var CrazyCribbage = (() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined") return require.apply(this, arguments);
    throw Error('Dynamic require of "' + x + '" is not supported');
  });
  var __commonJS = (cb, mod) => function __require2() {
    try {
      return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    } catch (e) {
      throw mod = 0, e;
    }
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // game-configs.js
  var require_game_configs = __commonJS({
    "game-configs.js"(exports, module) {
      (function(root, factory) {
        var exp = factory();
        if (typeof module === "object" && module.exports) {
          module.exports = exp;
        }
        if (typeof root !== "undefined") {
          root.GAME_CONFIGS = exp;
        }
        if (typeof window !== "undefined") {
          window.GAME_CONFIGS = exp;
        }
      })(typeof self !== "undefined" ? self : exports, function() {
        "use strict";
        const GAME_CONFIGS = {
          crazy: {
            id: "crazy",
            name: "Crazy Cribbage",
            title: "CRAZY CRIBBAGE",
            tagline: "THE WILD TWIST ON CLASSIC CRIBBAGE",
            startButtonText: "GO CRAZY",
            startAriaLabel: "Start Game",
            logo: {
              src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo_-_640_x_640.webp",
              alt: "Crazy Cribbage"
            },
            theme: {
              defaultTheme: "tournament",
              locked: false,
              storageKey: "crazyCribbage.theme"
            },
            storageKey: "crazyCribbage.settings.v1",
            recordKey: "crazyCribbage.records.v1",
            ageRestricted: false,
            allowCpu: true,
            allowGoalSelect: true,
            defaultGoal: "high",
            defaultTarget: 121,
            targets: [
              { value: 121, label: "Full Game (121)" },
              { value: 61, label: "Quick game (61)" },
              { value: 31, label: "Pegging Only (31)" }
            ],
            randomizer: {
              mode: "subset",
              buttonText: "Randomize Bonus Options",
              fullRandomText: null
            },
            subgroups: [
              { id: "general", title: "General Options" },
              { id: "cards", title: "Individual Cards" },
              { id: "poker", title: "Poker Hands" },
              { id: "pegging", title: "Pegging Options" },
              { id: "hands", title: "Hands & Cribs" }
            ],
            options: [
              // General Options
              { key: "jokers", chkId: "optJokers", subgroup: "general", type: "boolean", name: "Jokers", description: "2 wild cards per deck; represent any card in play, hands & crib", default: false },
              { key: "optCutBeforeDiscard", chkId: "optCutBeforeDiscard", subgroup: "general", type: "boolean", name: "Cut before Discard", description: "Pone cuts the starter card before players discard to the crib", default: false },
              { key: "opt31sFor5", chkId: "opt31sFor5", subgroup: "general", type: "boolean", name: "31's for 5", description: "Combinations summing to 31 count for 5 bonus points in play, hand & crib", default: false },
              { key: "opt19sFor2", chkId: "opt19sFor2", subgroup: "general", type: "boolean", name: "19's for 2", description: "Combinations summing to 19 count for 2 bonus points in play, hand & crib", default: false },
              { key: "optRoundAroundTheWorld", chkId: "optRoundAroundTheWorld", subgroup: "general", type: "boolean", name: "Round around the World", description: "Runs can wrap around Ace to King (e.g. K-A-2 or Q-K-A)", default: false },
              { key: "optAllRed", chkId: "optAllRed", subgroup: "general", type: "boolean", name: "All Red", description: "All-red cards in hand, crib, or pegging score 1 bonus point per card", default: false },
              { key: "optAllBlack", chkId: "optAllBlack", subgroup: "general", type: "boolean", name: "All Black", description: "All-black cards in hand, crib, or pegging score 1 bonus point per card", default: false },
              { key: "optAllOdd", chkId: "optAllOdd", subgroup: "general", type: "boolean", name: "All Odd", description: "All odd ranks (A, 3, 5, 7, 9, J, K) score 1 bonus point per card", default: false },
              { key: "optAllEven", chkId: "optAllEven", subgroup: "general", type: "boolean", name: "All Even", description: "All even ranks (2, 4, 6, 8, 10, Q) score 1 bonus point per card", default: false },
              { key: "optAllDifferentSuits", chkId: "optAllDifferentSuits", subgroup: "general", type: "boolean", name: "All Different Suits", description: "All cards having distinct suits score 1 bonus point per card", default: false },
              { key: "optFlushInPlay", chkId: "optFlushInPlay", subgroup: "general", type: "boolean", name: "Flush in Play", description: "3 or more consecutive cards of the same suit in pegging score 1 pt per card", default: false },
              { key: "optChutesAndLadders", chkId: "optChutesAndLadders", subgroup: "general", type: "boolean", name: "Chutes and Ladders", description: "If at any time all players are tied, everyone goes back to the start (hole 0)", default: false },
              // Individual Cards
              { key: "optKH", chkId: "optKH", subgroup: "cards", type: "boolean", name: "King of Hearts (Suicide King)", description: "Scores 5 bonus points when in hand or crib (does not count as starter)", default: false },
              { key: "optQS", chkId: "optQS", subgroup: "cards", type: "boolean", name: "Queen of Spades", description: "Scores 5 bonus points when in hand or crib (does not count as starter)", default: false },
              { key: "optAS", chkId: "optAS", subgroup: "cards", type: "boolean", name: "Ace of Spades", description: "Scores 5 bonus points when in hand or crib (does not count as starter)", default: false },
              { key: "optSpades", chkId: "optSpades", subgroup: "cards", type: "boolean", name: "Spades", description: "Hands & cribs with a Spade double; no Spade loses 29 pts (crib immune if dealer holds a Spade; min 0). Cutting a Spade doubles pegging & heels", default: false },
              { key: "optGuessStarter", chkId: "optGuessStarter", subgroup: "cards", type: "boolean", name: "Guess Starter", description: "Pone guesses the rank of the cut starter card before it is turned over. A correct guess scores 3 points", default: false },
              // Poker Hands
              { key: "optStraight", chkId: "optStraight", subgroup: "poker", type: "boolean", name: "Straight", description: "A run of 5 or more cards scores 10 bonus points", default: false },
              { key: "optFullHouse", chkId: "optFullHouse", subgroup: "poker", type: "boolean", name: "Full House", description: "Three of a kind plus a pair in hand or crib scores 10 bonus points", default: false },
              { key: "optStraightFlush", chkId: "optStraightFlush", subgroup: "poker", type: "boolean", name: "Straight Flush", description: "Five consecutive cards of the same suit score 20 bonus points", default: false },
              { key: "optRoyalFlush", chkId: "optRoyalFlush", subgroup: "poker", type: "boolean", name: "Royal Flush", description: "10-J-Q-K-A of the same suit scores 30 bonus points", default: false },
              // Pegging Options
              { key: "optMultipleRunsInPegging", chkId: "optMultipleRunsInPegging", subgroup: "pegging", type: "boolean", name: "Multiple Runs in Pegging", description: "Double runs, triple runs and quadruple runs can be scored during pegging", default: false },
              { key: "optPegThroughZones", chkId: "optPegThroughZones", subgroup: "pegging", type: "boolean", name: "Peg Through Zones", description: "Holes 31\u201340, 61\u201370, 91\u2013100 are peg-only zones; hand & crib points don't count", default: false, mutualGroup: "zones" },
              { key: "optLast5PegOut", chkId: "optLast5PegOut", subgroup: "pegging", type: "boolean", name: "Last 5 Peg Out", description: "Last 5 holes require pegging out; hand & crib points cannot cross finish", default: false, mutualGroup: "zones" },
              { key: "optBunkers", chkId: "optBunkers", subgroup: "pegging", type: "boolean", name: "Bunkers", description: "First & last 5 holes, plus 50\u201360 & 80\u201390; pegging points only", default: false, mutualGroup: "zones" },
              { key: "optStinkHole", chkId: "optStinkHole", subgroup: "pegging", type: "boolean", name: "Stink Hole", description: "At hole 120 (or 60 in quick game), you must score exactly 1 point to win", default: false, mutualGroup: "zones" },
              { key: "optProgressiveSteals", chkId: "optProgressiveSteals", subgroup: "pegging", type: "boolean", name: "Progressive Steals", description: "Pair opponent's card while pegging to steal it into your hand for counting", default: false },
              // Hands & Cribs
              { key: "optStolenCrib", chkId: "optStolenCrib", subgroup: "hands", type: "boolean", name: "Stolen Crib", description: "Pone guesses dealer's exact crib points to steal all of them (2 players only)", default: false, requiredPlayers: 2 },
              { key: "optZeroHand", chkId: "optZeroHand", subgroup: "hands", type: "boolean", name: "Zero Hand", description: "A 0-point hand inflicts \u221219 penalty points", default: false },
              { key: "optZeroCrib", chkId: "optZeroCrib", subgroup: "hands", type: "boolean", name: "Zero Crib", description: "A 0-point crib inflicts \u221219 penalty points to dealer", default: false },
              { key: "optRockCrib", chkId: "optRockCrib", subgroup: "hands", type: "boolean", name: "Rock the Crib", description: "All crib points subtract from dealer score instead of adding", default: false },
              { key: "optPickYourCrib", chkId: "optPickYourCrib", subgroup: "hands", type: "boolean", name: "Pick Your Crib", description: "Dealer discards normally, but steals card(s) from pone's hand for the crib", default: false },
              { key: "optSpeedoCribbage", chkId: "optSpeedoCribbage", subgroup: "hands", type: "boolean", name: "Speedo Cribbage", description: "Pone discards to dealer's hand; dealer discards 4 (or 6 in super) to crib (2 players only)", default: false, requiredPlayers: 2 },
              { key: "optShotgunCribbage", chkId: "optShotgunCribbage", subgroup: "hands", type: "boolean", name: "Shotgun Cribbage", description: "Dealer forfeits all points scored in the crib", default: false },
              { key: "optTwistedCribbage", chkId: "optTwistedCribbage", subgroup: "hands", type: "boolean", name: "Twisted Cribbage", description: "Dealer combines 8 cards to make best two 4-card hands. Flushes require all 5 cards matching (2 players only)", default: false, requiredPlayers: 2 },
              { key: "optFivesCribbage", chkId: "optFivesCribbage", subgroup: "hands", type: "boolean", name: "Five's Cribbage", description: "Players must discard any 5s in hand directly to the crib", default: false },
              { key: "optSevensAndEightsCribbage", chkId: "optSevensAndEightsCribbage", subgroup: "hands", type: "boolean", name: "Sevens and Eights Cribbage", description: "Players must discard any 7s and 8s in hand directly to the crib", default: false },
              { key: "optDrawCribbage", chkId: "optDrawCribbage", subgroup: "hands", type: "boolean", name: "Draw Cribbage", description: "Draw 0\u20135 cards after deal, discard 2 to crib, then discard & draw 0\u20133 cards (2 players only)", default: false, requiredPlayers: 2 },
              { key: "opt7CardCribbage", chkId: "opt7CardCribbage", subgroup: "hands", type: "boolean", name: "7 Card Cribbage", description: "7 cards dealt, 1 dealt to crib, both players discard 2 to crib (2 players only)", default: false, requiredPlayers: 2 },
              { key: "optProgressiveCut", chkId: "optProgressiveCut", subgroup: "hands", type: "boolean", name: "Progressive cut", description: "Cut 1 card for first 2 hands, 2 for next 2, etc. Game ends when >121 with equal cribs (2 players only)", default: false, requiredPlayers: 2 },
              { key: "optCanadianDoubles", chkId: "optCanadianDoubles", subgroup: "hands", type: "boolean", name: "Canadian Doubles", description: "4-player partnership: dealer and pone get 10 cards, keep 4, pass 4 to partner, discard 2 to crib (forces 4 players partnership)", default: false, requiredPlayers: 4, requiredGameMode: "partnership", requiredPlayerMode: "4_part" }
            ]
          },
          clash: {
            id: "clash",
            name: "Cribbage Clash",
            title: "CRIBBAGE CLASH",
            tagline: "TACTICAL BOARD BATTLE CRIBBAGE",
            startButtonText: "BEGIN BATTLE",
            startAriaLabel: "Begin Battle",
            logo: {
              src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-round-online-game-640x640.webp",
              alt: "Cribbage Clash"
            },
            theme: {
              defaultTheme: "rustic",
              locked: true,
              storageKey: "cribbageClash.theme"
            },
            storageKey: "cribbageClash.settings.v1",
            recordKey: "cribbageClash.records.v1",
            ageRestricted: false,
            allowCpu: true,
            allowGoalSelect: false,
            defaultGoal: "high",
            defaultTarget: 481,
            targets: [
              { value: 241, label: "241 - Short" },
              { value: 361, label: "361 - Medium" },
              { value: 481, label: "481 - Long" }
            ],
            randomizer: {
              mode: "clashTactical",
              buttonText: "Randomize",
              fullRandomText: "Full Random",
              description: "Randomize options, counts, non-overlapping placements & signs"
            },
            subgroups: [
              { id: "clash", title: "Cribbage Clash" }
            ],
            options: [
              {
                key: "noPassingLanes",
                chkId: "optNoPassingLanes",
                countId: "optNoPassingLaneCount",
                prefix: "optNoPassingLane",
                subgroup: "clash",
                type: "trackItem",
                name: "No Passing Lanes",
                description: "single-file bottlenecks where players cannot pass",
                badgePrefix: "Lane",
                maxCount: 4,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 5,
                headerDesc: "5 holes in length \xB7 bottlenecks into middle row",
                holes: { min: 10, max: 100, step: 5, defaults: [20, 50, 80, 100], suffix: "Start" }
              },
              {
                key: "jump",
                chkId: "optJump",
                countId: "optJumpCount",
                prefix: "optJump",
                subgroup: "clash",
                type: "trackItem",
                name: "Jump",
                description: "Vault players forward (10 holes) or backward (20 holes)",
                badgePrefix: "Jump",
                maxCount: 8,
                defaultCount: 2,
                lengthType: "jumpDynamic",
                // 1 if forward, 3 if backward
                headerDesc: "Forward jumps are 1 hole \xB7 Backward jumps are 3 holes \xB7 landing triggers a leap",
                hasDestination: true,
                holes: { min: 5, max: 115, step: 5, defaults: [15, 65, 5, 115, 25, 75, 45, 95], suffix: "Start" },
                destHoles: { min: 5, max: 120, step: 5, defaults: [35, 50, 45, 70, 55, 60, 80, 85], suffix: "Dest" }
              },
              {
                key: "jail",
                chkId: "optJail",
                countId: "optJailCount",
                prefix: "optJail",
                subgroup: "clash",
                type: "trackItem",
                name: "Jail",
                description: "Traps players until doubles or a jack is cut",
                badgePrefix: "Jail",
                maxCount: 4,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 1,
                headerDesc: "1 peg long \xB7 10 to 110 \xB7 Must cut a Jack or roll doubles to exit",
                holes: { min: 10, max: 110, step: 5, defaults: [25, 75, 45, 95], suffix: "Hole" }
              },
              {
                key: "bar",
                chkId: "optBar",
                countId: "optBarCount",
                prefix: "optBar",
                subgroup: "clash",
                type: "trackItem",
                name: "The Bar",
                description: "Social lounge with 1-turn pause or beverage challenge",
                badgePrefix: "Bar",
                maxCount: 4,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 1,
                headerDesc: "1 peg long \xB7 10 to 110 \xB7 Social lounge with 1-turn pause or beverage challenge",
                holes: { min: 10, max: 110, step: 5, defaults: [40, 85, 60, 105], suffix: "Hole" }
              },
              {
                key: "timeout",
                chkId: "optTimeout",
                countId: "optTimeoutCount",
                prefix: "optTimeout",
                subgroup: "clash",
                type: "trackItem",
                name: "Timeout",
                description: "Penalty box benching players for 1 turn",
                badgePrefix: "Timeout",
                maxCount: 4,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 1,
                headerDesc: "1 peg long \xB7 10 to 110 \xB7 Penalty box benching players for 1 turn",
                holes: { min: 10, max: 110, step: 5, defaults: [30, 90, 50, 110], suffix: "Hole" }
              },
              {
                key: "detour",
                chkId: "optDetour",
                countId: "optDetourCount",
                prefix: "optDetour",
                subgroup: "clash",
                type: "trackItem",
                name: "Detour",
                description: "1-hole traps divert players into an 8-hole scenic loop returning to same hole",
                badgePrefix: "Detour",
                maxCount: 4,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 1,
                headerDesc: "1 peg long \xB7 10 to 110 \xB7 8-hole off-track detour loop returning to same hole",
                holes: { min: 10, max: 110, step: 5, defaults: [10, 60, 35, 80], suffix: "Hole" }
              },
              {
                key: "roundAbout",
                chkId: "optRoundAbout",
                countId: "optRoundAboutCount",
                prefix: "optRoundAbout",
                subgroup: "clash",
                type: "trackItem",
                name: "Round About",
                description: "1-hole triggers divert players into a 7-peg rotary loop returning 1 hole ahead",
                badgePrefix: "Round About",
                maxCount: 4,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 1,
                headerDesc: "1 peg long \xB7 10 to 110 \xB7 7-peg off-track rotary loop returning 1 hole ahead",
                holes: { min: 10, max: 110, step: 5, defaults: [35, 70, 55, 90], suffix: "Hole" }
              },
              {
                key: "signs",
                chkId: "optSigns",
                countId: "optSignsCount",
                prefix: "optSigns",
                subgroup: "clash",
                type: "trackItem",
                name: "Signs",
                description: "3-peg (2 signs) or 5-peg (4 signs) blocks with interactive sign selection and replenishing pools",
                badgePrefix: "Sign Block",
                maxCount: 8,
                defaultCount: 2,
                lengthType: "signsSize",
                // 3 if size=2, 5 if size=4
                headerDesc: "3 pegs (2 signs) or 5 pegs (4 signs) \xB7 10 to 110 \xB7 Replenishes when empty",
                hasSignsSlots: true,
                holes: { min: 10, max: 110, step: 5, defaults: [45, 55, 95, 105, 30, 65, 85, 115], suffix: "Hole" }
              },
              {
                key: "stopSign",
                chkId: "optStopSign",
                countId: "optStopSignCount",
                prefix: "optStopSign",
                subgroup: "clash",
                type: "trackItem",
                name: "Stop Sign",
                description: "1-hole traps where counting stops immediately",
                badgePrefix: "Stop Sign",
                maxCount: 8,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 1,
                headerDesc: "1 peg long \xB7 5 to 475 \xB7 When reached, counting stops immediately (pegging, hand, or crib)",
                holes: { min: 5, max: 115, step: 5, defaults: [20, 35, 50, 65, 80, 95, 105, 115], suffix: "Hole" }
              },
              {
                key: "dice",
                chkId: "optDice",
                countId: "optDiceCount",
                prefix: "optDice",
                subgroup: "clash",
                type: "trackItem",
                name: "Dice",
                description: "Interactive 3-die challenge spaces triggering a Roll The Dice roll (\xB15 to \xB130 points)",
                badgePrefix: "Dice",
                color: "#a855f7",
                maxCount: 4,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 1,
                headerDesc: "1 peg long \xB7 10 to 475 \xB7 Triggers an animated 3-die roll for points and target player",
                holes: { min: 10, max: 110, step: 5, defaults: [50, 85, 200, 320], suffix: "Hole" }
              },
              {
                key: "wheel",
                chkId: "optWheel",
                countId: "optWheelCount",
                prefix: "optWheel",
                subgroup: "clash",
                type: "trackItem",
                name: "Spinning Wheel",
                icon: "\u{1F3A1}",
                description: "Carnival prize wheel spaces triggering an animated Spin-The-Wheel spin for exciting rewards or penalties",
                badgePrefix: "Spinning Wheel",
                color: "#ec4899",
                maxCount: 4,
                defaultCount: 2,
                lengthType: "fixed",
                fixedLength: 1,
                headerDesc: "1 peg long \xB7 10 to 475 \xB7 Triggers an animated wheel spin for points, jumps, or penalties",
                holes: { min: 10, max: 110, step: 5, defaults: [65, 160, 260, 385], suffix: "Hole" }
              },
              {
                key: "skunkMarkers",
                chkId: "optSkunkMarkers",
                prefix: "optSkunkMarker",
                subgroup: "clash",
                type: "skunkSpecial",
                name: "Skunk Markers",
                description: "Display interactive 75% and 50% Skunk Markers directly on the game board"
              }
            ]
          },
          pints: {
            id: "pints",
            name: "Pints and Pegs",
            title: "PINTS AND PEGS",
            tagline: "THE DRINKING CRIBBAGE PUB EXPERIENCE",
            startButtonText: "PLAY PINTS",
            startAriaLabel: "Play Pints",
            logo: {
              src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-pints-and-pegs_640x640_f004d2b4-49df-4181-a6d2-11c7f9212645.webp",
              alt: "Pints and Pegs"
            },
            theme: {
              defaultTheme: "tournament",
              locked: false,
              storageKey: "crazyCribbage.theme"
            },
            storageKey: "pintsAndPegs.settings.v1",
            recordKey: "pintsAndPegs.records.v1",
            ageRestricted: true,
            allowCpu: false,
            ageGateMessage: "This version contains drinking themes and pub games intended solely for individuals of legal drinking age. You must be at least 21 years old to enter and play.",
            allowGoalSelect: true,
            defaultGoal: "high",
            defaultTarget: 121,
            targets: [
              { value: 121, label: "Full Game (121)" },
              { value: 61, label: "Quick game (61)" },
              { value: 31, label: "Pegging Only (31)" }
            ],
            randomizer: {
              mode: "trackDistribution",
              totalBoardSpaces: 24,
              step: 5,
              minHole: 5,
              maxHole: 120,
              buttonText: "Randomize",
              fullRandomText: "Full Random",
              description: "Randomize drink spaces, counts & non-overlapping placements"
            },
            subgroups: [
              { id: "pints", title: "Pints and Pegs" }
            ],
            options: [
              {
                key: "youDrink",
                chkId: "optYouDrink",
                countId: "optYouDrinkCount",
                pegsId: "optYouDrinkPegs",
                prefix: "optYouDrink",
                subgroup: "pints",
                type: "trackItem",
                name: "You Drink",
                description: "Take a drink when you land on this space",
                actionText: "Landing here requires the player to take a drink",
                icon: "\u{1F37A}",
                color: "#f59e0b",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                holes: { min: 5, max: 120, step: 5, defaults: [15, 45, 75, 105], suffix: "Hole" }
              },
              {
                key: "guysDrink",
                chkId: "optGuysDrink",
                countId: "optGuysDrinkCount",
                pegsId: "optGuysDrinkPegs",
                prefix: "optGuysDrink",
                subgroup: "pints",
                type: "trackItem",
                name: "Guys Drink",
                description: "All male players take a drink",
                actionText: "Landing here requires all guys to take a drink",
                icon: "\u{1F37B}",
                color: "#3b82f6",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                holes: { min: 5, max: 120, step: 5, defaults: [25, 55, 85, 115], suffix: "Hole" }
              },
              {
                key: "galsDrink",
                chkId: "optGalsDrink",
                countId: "optGalsDrinkCount",
                pegsId: "optGalsDrinkPegs",
                prefix: "optGalsDrink",
                subgroup: "pints",
                type: "trackItem",
                name: "Gals Drink",
                description: "All female players take a drink",
                actionText: "Landing here requires all gals to take a drink",
                icon: "\u{1F377}",
                color: "#ec4899",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                holes: { min: 5, max: 120, step: 5, defaults: [35, 65, 95, 110], suffix: "Hole" }
              },
              {
                key: "leftDrink",
                chkId: "optLeftDrink",
                countId: "optLeftDrinkCount",
                pegsId: "optLeftDrinkPegs",
                prefix: "optLeftDrink",
                subgroup: "pints",
                type: "trackItem",
                name: "Player to the left Drinks",
                description: "Person to your left takes a drink",
                actionText: "Landing here requires the player to your left to take a drink",
                icon: "\u{1F448}",
                color: "#8b5cf6",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                holes: { min: 5, max: 120, step: 5, defaults: [10, 40, 70, 100], suffix: "Hole" }
              },
              {
                key: "rightDrink",
                chkId: "optRightDrink",
                countId: "optRightDrinkCount",
                pegsId: "optRightDrinkPegs",
                prefix: "optRightDrink",
                subgroup: "pints",
                type: "trackItem",
                name: "Player to the right Drinks",
                description: "Person to your right takes a drink",
                actionText: "Landing here requires the player to your right to take a drink",
                icon: "\u{1F449}",
                color: "#06b6d4",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                holes: { min: 5, max: 120, step: 5, defaults: [20, 50, 80, 120], suffix: "Hole" }
              },
              {
                key: "everyoneDrink",
                chkId: "optEveryoneDrink",
                countId: "optEveryoneDrinkCount",
                pegsId: "optEveryoneDrinkPegs",
                prefix: "optEveryoneDrink",
                subgroup: "pints",
                type: "trackItem",
                name: "Everyone Drinks",
                description: "Social! Every player at the table takes a drink",
                actionText: "Landing here requires everyone playing to take a drink",
                icon: "\u{1F942}",
                color: "#10b981",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                holes: { min: 5, max: 120, step: 5, defaults: [30, 60, 90, 5], suffix: "Hole" }
              },
              {
                key: "everyoneButYouDrink",
                chkId: "optEveryoneButYouDrink",
                countId: "optEveryoneButYouDrinkCount",
                pegsId: "optEveryoneButYouDrinkPegs",
                prefix: "optEveryoneButYouDrink",
                subgroup: "pints",
                type: "trackItem",
                name: "Everyone but you Drinks",
                description: "Everyone except the pegging player takes a drink",
                actionText: "Landing here requires everyone except you to take a drink",
                icon: "\u{1F389}",
                color: "#f97316",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                holes: { min: 5, max: 120, step: 5, defaults: [20, 50, 80, 110], suffix: "Hole" }
              },
              {
                key: "pickWhoDrinks",
                chkId: "optPickWhoDrinks",
                countId: "optPickWhoDrinksCount",
                pegsId: "optPickWhoDrinksPegs",
                prefix: "optPickWhoDrinks",
                subgroup: "pints",
                type: "trackItem",
                name: "You pick who drinks",
                description: "Choose any single opponent or player to take a drink",
                actionText: "Landing here allows you to choose who takes a drink",
                icon: "\u{1F3AF}",
                color: "#a855f7",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                holes: { min: 5, max: 120, step: 5, defaults: [25, 55, 85, 115], suffix: "Hole" }
              }
            ]
          },
          adult: {
            id: "adult",
            name: "Skunked and Stripped",
            title: "SKUNKED AND STRIPPED",
            tagline: "STRIP CRIBBAGE & MATURE CHALLENGES",
            startButtonText: "GET STRIPPED",
            startAriaLabel: "Get Stripped",
            logo: {
              src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-skunked-and-stripped_-_640_x_640.webp?v=1791397387",
              alt: "Skunked and Stripped"
            },
            theme: {
              defaultTheme: "passion",
              locked: false,
              storageKey: "skunkedAndStripped.theme"
            },
            storageKey: "skunkedAndStripped.settings.v1",
            recordKey: "skunkedAndStripped.records.v1",
            ageRestricted: true,
            allowCpu: false,
            ageGateMessage: "This version contains mature adult themes and erotic challenges intended solely for adults. You must be at least 21 years old to enter and play.",
            allowGoalSelect: true,
            defaultGoal: "high",
            defaultTarget: 121,
            targets: [
              { value: 121, label: "Full Game (121)" },
              { value: 61, label: "Quick game (61)" },
              { value: 31, label: "Pegging Only (31)" }
            ],
            randomizer: {
              mode: "trackDistribution",
              totalBoardSpaces: 24,
              step: 5,
              minHole: 5,
              maxHole: 120,
              buttonText: "Randomize",
              fullRandomText: "Full Random",
              description: "Randomize adult spaces, counts & non-overlapping placements"
            },
            subgroups: [
              { id: "strip", title: "Strip Themed Options" },
              { id: "adultChallenges", title: "Adult Challenges (Timed)" }
            ],
            options: [
              // Group 1: Strip Themed (2 spaces default)
              {
                key: "loseClothing",
                chkId: "optLoseClothing",
                countId: "optLoseClothingCount",
                pegsId: "optLoseClothingPegs",
                prefix: "optLoseClothing",
                subgroup: "strip",
                type: "trackItem",
                name: "You Lose Clothing",
                description: "You lose an article of clothing",
                actionText: "Player loses an article of clothing",
                group: "strip",
                icon: "\u{1F459}",
                color: "#f43f5e",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                timed: false,
                holes: { min: 5, max: 120, step: 5, defaults: [10, 70, 10, 70], suffix: "Hole" }
              },
              {
                key: "gainClothing",
                chkId: "optGainClothing",
                countId: "optGainClothingCount",
                pegsId: "optGainClothingPegs",
                prefix: "optGainClothing",
                subgroup: "strip",
                type: "trackItem",
                name: "You Gain Clothing",
                description: "You gain an article of clothing",
                actionText: "Player gains an article of clothing back",
                group: "strip",
                icon: "\u{1F9E5}",
                color: "#10b981",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                timed: false,
                holes: { min: 5, max: 120, step: 5, defaults: [20, 80, 20, 80], suffix: "Hole" }
              },
              {
                key: "pickWhoLosesClothing",
                chkId: "optPickWhoLosesClothing",
                countId: "optPickWhoLosesClothingCount",
                pegsId: "optPickWhoLosesClothingPegs",
                prefix: "optPickWhoLosesClothing",
                subgroup: "strip",
                type: "trackItem",
                name: "Pick Who Strips",
                description: "You pick who loses an article of clothing",
                actionText: "Player picks who loses an article of clothing",
                group: "strip",
                icon: "\u{1F3AF}",
                color: "#ec4899",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                timed: false,
                holes: { min: 5, max: 120, step: 5, defaults: [30, 90, 30, 90], suffix: "Hole" }
              },
              {
                key: "rightLosesClothing",
                chkId: "optRightLosesClothing",
                countId: "optRightLosesClothingCount",
                pegsId: "optRightLosesClothingPegs",
                prefix: "optRightLosesClothing",
                subgroup: "strip",
                type: "trackItem",
                name: "Right Neighbor Strips",
                description: "Person to the right loses an article of clothing",
                actionText: "Person to right loses an article of clothing",
                group: "strip",
                icon: "\u{1F449}",
                color: "#3b82f6",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                timed: false,
                holes: { min: 5, max: 120, step: 5, defaults: [40, 100, 40, 100], suffix: "Hole" }
              },
              {
                key: "leftLosesClothing",
                chkId: "optLeftLosesClothing",
                countId: "optLeftLosesClothingCount",
                pegsId: "optLeftLosesClothingPegs",
                prefix: "optLeftLosesClothing",
                subgroup: "strip",
                type: "trackItem",
                name: "Left Neighbor Strips",
                description: "Person to the left loses an article of clothing",
                actionText: "Person to left loses an article of clothing",
                group: "strip",
                icon: "\u{1F448}",
                color: "#8b5cf6",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                timed: false,
                holes: { min: 5, max: 120, step: 5, defaults: [50, 110, 50, 110], suffix: "Hole" }
              },
              {
                key: "removeClothingChoice",
                chkId: "optRemoveClothingChoice",
                countId: "optRemoveClothingChoiceCount",
                pegsId: "optRemoveClothingChoicePegs",
                prefix: "optRemoveClothingChoice",
                subgroup: "strip",
                type: "trackItem",
                name: "Remove Clothing Choice",
                description: "Remove an article of clothing off person of choice",
                actionText: "Remove an article of clothing off person of your choice",
                group: "strip",
                icon: "\u2702\uFE0F",
                color: "#e11d48",
                maxCount: 4,
                defaultCount: 2,
                defaultPegs: 1,
                timed: false,
                holes: { min: 5, max: 120, step: 5, defaults: [60, 120, 60, 120], suffix: "Hole" }
              },
              // Group 2: Adult Themed Timed Challenges (1 space default)
              {
                key: "touchBreast",
                chkId: "optTouchBreast",
                countId: "optTouchBreastCount",
                pegsId: "optTouchBreastPegs",
                prefix: "optTouchBreast",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Touch Breast",
                description: "Touch breast (60s timer)",
                actionText: "Touch breast",
                group: "adult",
                icon: "\u{1F48B}",
                color: "#f43f5e",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [5, 45, 75, 105], suffix: "Hole" }
              },
              {
                key: "lickBreast",
                chkId: "optLickBreast",
                countId: "optLickBreastCount",
                pegsId: "optLickBreastPegs",
                prefix: "optLickBreast",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Lick Breast",
                description: "Lick breast (60s timer)",
                actionText: "Lick breast",
                group: "adult",
                icon: "\u{1F445}",
                color: "#ec4899",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [15, 50, 80, 110], suffix: "Hole" }
              },
              {
                key: "suckBreast",
                chkId: "optSuckBreast",
                countId: "optSuckBreastCount",
                pegsId: "optSuckBreastPegs",
                prefix: "optSuckBreast",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Suck Breast",
                description: "Suck breast (60s timer)",
                actionText: "Suck breast",
                group: "adult",
                icon: "\u{1F444}",
                color: "#d946ef",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [25, 55, 85, 115], suffix: "Hole" }
              },
              {
                key: "touchGenitals",
                chkId: "optTouchGenitals",
                countId: "optTouchGenitalsCount",
                pegsId: "optTouchGenitalsPegs",
                prefix: "optTouchGenitals",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Touch Genitals",
                description: "Touch genitals (60s timer)",
                actionText: "Touch genitals",
                group: "adult",
                icon: "\u2728",
                color: "#a855f7",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [35, 40, 70, 100], suffix: "Hole" }
              },
              {
                key: "lickGenitals",
                chkId: "optLickGenitals",
                countId: "optLickGenitalsCount",
                pegsId: "optLickGenitalsPegs",
                prefix: "optLickGenitals",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Lick Genitals",
                description: "Lick genitals (60s timer)",
                actionText: "Lick genitals",
                group: "adult",
                icon: "\u{1F445}",
                color: "#f43f5e",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [45, 60, 90, 120], suffix: "Hole" }
              },
              {
                key: "suckGenitals",
                chkId: "optSuckGenitals",
                countId: "optSuckGenitalsCount",
                pegsId: "optSuckGenitalsPegs",
                prefix: "optSuckGenitals",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Suck Genitals",
                description: "Suck genitals (60s timer)",
                actionText: "Suck genitals",
                group: "adult",
                icon: "\u{1F444}",
                color: "#ec4899",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [55, 65, 95, 115], suffix: "Hole" }
              },
              {
                key: "fingerGenitals",
                chkId: "optFingerGenitals",
                countId: "optFingerGenitalsCount",
                pegsId: "optFingerGenitalsPegs",
                prefix: "optFingerGenitals",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Finger Genitals",
                description: "Finger genitals (60s timer)",
                actionText: "Finger genitals",
                group: "adult",
                icon: "\u{1F449}",
                color: "#f59e0b",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [65, 45, 75, 105], suffix: "Hole" }
              },
              {
                key: "genitalIntercourse",
                chkId: "optGenitalIntercourse",
                countId: "optGenitalIntercourseCount",
                pegsId: "optGenitalIntercoursePegs",
                prefix: "optGenitalIntercourse",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Genital Intercourse",
                description: "Genital intercourse (60s timer)",
                actionText: "Genital intercourse",
                group: "adult",
                icon: "\u{1F525}",
                color: "#ef4444",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [75, 55, 85, 115], suffix: "Hole" }
              },
              {
                key: "touchAnus",
                chkId: "optTouchAnus",
                countId: "optTouchAnusCount",
                pegsId: "optTouchAnusPegs",
                prefix: "optTouchAnus",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Touch Anus",
                description: "Touch anus (60s timer)",
                actionText: "Touch anus",
                group: "adult",
                icon: "\u{1F351}",
                color: "#8b5cf6",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [85, 50, 80, 110], suffix: "Hole" }
              },
              {
                key: "lickAnus",
                chkId: "optLickAnus",
                countId: "optLickAnusCount",
                pegsId: "optLickAnusPegs",
                prefix: "optLickAnus",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Lick Anus",
                description: "Lick anus (60s timer)",
                actionText: "Lick anus",
                group: "adult",
                icon: "\u{1F445}",
                color: "#ec4899",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [95, 55, 85, 115], suffix: "Hole" }
              },
              {
                key: "fingerAnus",
                chkId: "optFingerAnus",
                countId: "optFingerAnusCount",
                pegsId: "optFingerAnusPegs",
                prefix: "optFingerAnus",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Finger Anus",
                description: "Finger anus (60s timer)",
                actionText: "Finger anus",
                group: "adult",
                icon: "\u{1F449}",
                color: "#f59e0b",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [105, 60, 90, 120], suffix: "Hole" }
              },
              {
                key: "analIntercourse",
                chkId: "optAnalIntercourse",
                countId: "optAnalIntercourseCount",
                pegsId: "optAnalIntercoursePegs",
                prefix: "optAnalIntercourse",
                subgroup: "adultChallenges",
                type: "trackItem",
                name: "Anal Intercourse",
                description: "Anal intercourse (60s timer)",
                actionText: "Anal intercourse",
                group: "adult",
                icon: "\u{1F525}",
                color: "#ef4444",
                maxCount: 4,
                defaultCount: 1,
                defaultPegs: 1,
                timed: true,
                holes: { min: 5, max: 120, step: 5, defaults: [115, 65, 95, 115], suffix: "Hole" }
              }
            ]
          }
        };
        GAME_CONFIGS.getGame = function(brand) {
          return GAME_CONFIGS[brand] || GAME_CONFIGS.crazy;
        };
        GAME_CONFIGS.getOption = function(brand, optKey) {
          const g = GAME_CONFIGS.getGame(brand);
          return g && g.options ? g.options.find((o) => o.key === optKey || optKey === "spinningWheel" && o.key === "wheel" || optKey === "wheel" && o.key === "spinningWheel") : null;
        };
        return GAME_CONFIGS;
      });
    }
  });

  // game-options-engine.js
  var require_game_options_engine = __commonJS({
    "game-options-engine.js"(exports, module) {
      (function(root, factory) {
        var configs = typeof root !== "undefined" && root.GAME_CONFIGS || typeof window !== "undefined" && window.GAME_CONFIGS;
        if (!configs && typeof __require === "function") {
          try {
            configs = require_game_configs();
          } catch (e) {
          }
        }
        var exp = factory(configs);
        if (typeof module === "object" && module.exports) {
          module.exports = exp;
        }
        if (typeof root !== "undefined") {
          root.GameOptionsEngine = exp;
        }
        if (typeof window !== "undefined") {
          window.GameOptionsEngine = exp;
        }
      })(typeof self !== "undefined" ? self : exports, function(GAME_CONFIGS) {
        "use strict";
        let _suppressSave = false;
        let _isEnforcingOverlap = false;
        function resolveConfigs() {
          if (!GAME_CONFIGS || typeof GAME_CONFIGS.getGame !== "function") {
            GAME_CONFIGS = (typeof window !== "undefined" ? window.GAME_CONFIGS : null) || (typeof globalThis !== "undefined" ? globalThis.GAME_CONFIGS : null) || (typeof self !== "undefined" ? self.GAME_CONFIGS : null);
          }
          return GAME_CONFIGS;
        }
        const SIGN_SLOT_OPTIONS = [
          { value: "Plus 5", text: "Plus 5 (+5 pts)" },
          { value: "Plus 10", text: "Plus 10 (+10 pts)" },
          { value: "Minus 5", text: "Minus 5 (\u22125 pts)" },
          { value: "Minus 10", text: "Minus 10 (\u221210 pts)" },
          { value: "Undo", text: "Undo (Revert Last Score)" },
          { value: "Go To Jail", text: "Go To Jail" },
          { value: "Go To The Bar", text: "Go To The Bar" },
          { value: "Go To Timeout", text: "Go To Timeout" },
          { value: "Score Plus x2", text: "Score Plus x2 (2x Last Score)" },
          { value: "Score Plus x3", text: "Score Plus x3 (3x Last Score)" },
          { value: "Score Minus x2", text: "Score Minus x2 (\u22122x Last Score)" },
          { value: "Score Minus x3", text: "Score Minus x3 (\u22123x Last Score)" },
          { value: "Roll The Dice", text: "Roll The Dice (3 Dice)" },
          { value: "Spin The Wheel", text: "Spin The Wheel (8 Slots)" }
        ];
        function getAppBrand2() {
          if (typeof window !== "undefined") {
            if (window.currentBrand) return window.currentBrand;
            if (window.currentLogoBrand) return window.currentLogoBrand;
            if (typeof window.detectBrand === "function") {
              try {
                return window.detectBrand();
              } catch (e) {
              }
            }
          }
          return "crazy";
        }
        function getStreetOrTurnName2(h, targetVal) {
          targetVal = Number(targetVal || typeof settings !== "undefined" && settings && settings.target || 121);
          const isClashTarget2 = [241, 361, 481].includes(targetVal);
          if (isClashTarget2) {
            if (h <= 0) return "Start";
            if (h >= targetVal) return "Finish";
            const row = Math.floor((h - 1) / 60);
            const pos = (h - 1) % 60;
            if (pos < 55) return `Street ${row + 1}`;
            return `Turn ${row + 1}`;
          }
          if (h > 70) return "Street 3";
          if (h > 65) return "Turn 2";
          if (h > 35) return "Street 2";
          if (h > 30) return "Turn 1";
          return "Street 1";
        }
        function buildBrandSettingsUI(brand, containerEl) {
          const configs = resolveConfigs();
          const config = configs ? configs.getGame(brand) : null;
          if (!config || !containerEl) return;
          let html2 = "";
          if (brand === "clash") {
            html2 += `<div class="clash-presets-panel">
        <div class="clash-presets-header">
          <span class="clash-presets-title">\u{1F3C1} Track Layout Presets:</span>
          <button type="button" class="btn-sandbox-launcher" data-action="open-sandbox" data-brand="clash" title="Open visual interactive track hazard sandbox">
            \u{1F6E0}\uFE0F Track Sandbox
          </button>
        </div>
        <div class="clash-presets-pill-row" id="clashPresetsPillRow">
          <button type="button" class="clash-preset-pill active" data-brand="clash" data-preset="standard">\u{1F3DB}\uFE0F Classic</button>
          <button type="button" class="clash-preset-pill" data-brand="clash" data-preset="gauntlet">\u2694\uFE0F The Gauntlet</button>
          <button type="button" class="clash-preset-pill" data-brand="clash" data-preset="speedway">\u{1F680} Speedway</button>
          <button type="button" class="clash-preset-pill" data-brand="clash" data-preset="bottleneck">\u{1F6D1} Bottleneck</button>
          <button type="button" class="clash-preset-pill clash-preset-custom-pill" data-brand="clash" data-preset="custom" title="View & load custom track layouts">\u{1F4C1} Custom</button>
        </div>
      </div>`;
          }
          if (brand === "pints") {
            html2 += `<div class="clash-presets-panel pints-presets-panel">
        <div class="clash-presets-header">
          <span class="clash-presets-title">\u{1F37B} Drinking Board Presets:</span>
          <button type="button" class="btn-sandbox-launcher btn-pints-sandbox-launcher" data-action="open-sandbox" data-brand="pints" title="Open visual interactive drinking board sandbox">
            \u{1F6E0}\uFE0F Drinking Sandbox
          </button>
        </div>
        <div class="clash-presets-pill-row pints-presets-pill-row" id="pintsPresetsPillRow">
          <button type="button" class="clash-preset-pill active" data-brand="pints" data-preset="standard">\u{1F37B} Pub Crawl</button>
          <button type="button" class="clash-preset-pill" data-brand="pints" data-preset="powerHour">\u26A1 Power Hour</button>
          <button type="button" class="clash-preset-pill" data-brand="pints" data-preset="socialHour">\u{1F942} Social Hour</button>
          <button type="button" class="clash-preset-pill" data-brand="pints" data-preset="battleOfSexes">\u{1F94A} Battle of Sexes</button>
          <button type="button" class="clash-preset-pill clash-preset-custom-pill" data-brand="pints" data-preset="custom" title="View & load custom drinking layouts">\u{1F4C1} Custom</button>
        </div>
      </div>`;
          }
          if (brand === "adult") {
            html2 += `<div class="clash-presets-panel adult-presets-panel">
        <div class="clash-presets-header">
          <span class="clash-presets-title">\u{1F48B} Strip & Dare Presets:</span>
          <button type="button" class="btn-sandbox-launcher btn-adult-sandbox-launcher" data-action="open-sandbox" data-brand="adult" title="Open visual interactive adult strip & dare sandbox">
            \u{1F6E0}\uFE0F Adult Sandbox
          </button>
        </div>
        <div class="clash-presets-pill-row adult-presets-pill-row" id="adultPresetsPillRow">
          <button type="button" class="clash-preset-pill active" data-brand="adult" data-preset="standard">\u{1F457} Warm-Up Strip</button>
          <button type="button" class="clash-preset-pill" data-brand="adult" data-preset="highHeat">\u{1F525} High Heat</button>
          <button type="button" class="clash-preset-pill" data-brand="adult" data-preset="sensualGauntlet">\u23F3 Sensual Gauntlet</button>
          <button type="button" class="clash-preset-pill clash-preset-custom-pill" data-brand="adult" data-preset="custom" title="View & load custom strip layouts">\u{1F4C1} Custom</button>
        </div>
      </div>`;
          }
          if (config.randomizer) {
            const rand = config.randomizer;
            const randBtnId = `btnRandomize_${brand}`;
            const fullBtnId = `btnFullRandom_${brand}`;
            html2 += `<div class="clash-randomize-bar">
        <div class="clash-randomize-btn-row">
          <button type="button" id="${randBtnId}" class="clash-randomize-btn" data-brand="${brand}" data-action="randomize">
            <span class="clash-rand-dice">\u{1F3B2}</span> ${rand.buttonText || "Randomize"}
          </button>`;
            if (rand.fullRandomText) {
              html2 += `<button type="button" id="${fullBtnId}" class="clash-randomize-btn clash-full-random-btn" data-brand="${brand}" data-action="full-randomize">
            <span class="clash-rand-dice">\u26A1</span> ${rand.fullRandomText}
          </button>`;
            }
            html2 += `</div>`;
            if (rand.description) {
              html2 += `<div class="clash-randomize-desc">${rand.description}</div>`;
            }
            html2 += `</div>`;
          }
          const subgroups = config.subgroups || [{ id: "default", title: config.name }];
          const showToolbar = subgroups.length > 1;
          if (showToolbar) {
            html2 += `<div class="chk-subgroups-toolbar">
        <span class="chk-subgroups-toolbar-label">Variant Categories</span>
        <div class="chk-subgroups-toolbar-actions">
          <button type="button" class="btn-subgroup-action" data-action="expand-all-subgroups" title="Expand all variant sections">
            Expand All
          </button>
          <button type="button" class="btn-subgroup-action" data-action="collapse-all-subgroups" title="Collapse all variant sections">
            Collapse All
          </button>
        </div>
      </div>`;
          }
          const collapsedSet = getCollapsedSubgroups(brand);
          subgroups.forEach((subgroup) => {
            const groupOptions = config.options.filter((o) => (o.subgroup || "default") === subgroup.id);
            if (!groupOptions.length) return;
            const isCollapsed = collapsedSet.has(subgroup.id);
            const iconMap = {
              general: "\u{1F0CF}",
              cards: "\u{1F451}",
              poker: "\u2660\uFE0F",
              pegging: "\u{1F4CD}",
              hands: "\u270B",
              track: "\u{1F3C1}",
              strips: "\u{1F457}",
              dares: "\u{1F525}",
              drinking: "\u{1F37A}"
            };
            const icon = iconMap[subgroup.id] || "\u2728";
            html2 += `<div class="chk-subgroup-section${isCollapsed ? " is-collapsed" : ""}" data-subgroup="${subgroup.id}">`;
            if (subgroup.title) {
              html2 += `<button type="button" class="chk-subgroup-header" aria-expanded="${isCollapsed ? "false" : "true"}" aria-controls="subgroup-content-${subgroup.id}" data-action="toggle-subgroup" data-subgroup="${subgroup.id}" title="Click to ${isCollapsed ? "expand" : "collapse"} ${subgroup.title}">
          <span class="chk-subgroup-chevron" aria-hidden="true">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </span>
          <span class="chk-subgroup-icon" aria-hidden="true">${icon}</span>
          <span class="chk-subgroup-title">${subgroup.title}</span>
          <span class="chk-subgroup-count" title="${groupOptions.length} total options in this section">${groupOptions.length}</span>
          <span class="chk-subgroup-active-badge hidden" data-subgroup-badge="${subgroup.id}">0 active</span>
        </button>`;
            }
            html2 += `<div class="chk-subgroup-content" id="subgroup-content-${subgroup.id}">`;
            groupOptions.forEach((opt) => {
              if (opt.type === "boolean") {
                html2 += renderBooleanOptionMarkup(brand, opt);
              } else if (opt.type === "trackItem") {
                html2 += renderTrackItemMarkup(brand, opt);
              } else if (opt.type === "skunkSpecial") {
                html2 += renderSkunkMarkersMarkup();
              }
            });
            html2 += `</div></div>`;
          });
          containerEl.innerHTML = html2;
          populateBrandHoleDropdowns(brand);
          bindBrandContainerEvents(brand, containerEl);
          updateSubgroupActiveBadges(brand, containerEl);
        }
        function populateBrandHoleDropdowns(brand, targetVal) {
          const config = GAME_CONFIGS.getGame(brand);
          if (!config) return;
          targetVal = Number(targetVal || typeof settings !== "undefined" && settings && settings.target || config.defaultTarget || 121);
          const isClashTarget2 = [241, 361, 481].includes(targetVal);
          config.options.filter((o) => o.type === "trackItem").forEach((opt) => {
            const min = opt.holes && opt.holes.min || 5;
            let max = opt.holes && opt.holes.max || 120;
            if (brand === "clash" && isClashTarget2) {
              if (opt.key === "noPassingLanes") max = targetVal - 11;
              else if (opt.key === "jump") max = targetVal - 11;
              else if (opt.key === "stopSign") max = targetVal - 6;
              else max = targetVal - 11;
            }
            const step = opt.holes && opt.holes.step || 5;
            const suffix = opt.holes && opt.holes.suffix || "Hole";
            for (let i = 1; i <= opt.maxCount; i++) {
              const selId = `${opt.prefix}${i}${suffix}`;
              const sel = document.getElementById(selId);
              if (sel) {
                let optsHtml = "";
                for (let h = min; h <= max; h += step) {
                  let label = `Hole ${h}`;
                  if (opt.key === "noPassingLanes") label = `Hole ${h} (${h}\u2013${h + 4})`;
                  optsHtml += `<option value="${h}">${label}</option>`;
                }
                sel.innerHTML = optsHtml;
                const defaultHole2 = opt.holes && opt.holes.defaults && opt.holes.defaults[i - 1] || i * 15;
                sel.value = String(defaultHole2);
              }
              if (opt.hasDestination) {
                const dSelId = `${opt.prefix}${i}${opt.destHoles && opt.destHoles.suffix || "Dest"}`;
                const dSel = document.getElementById(dSelId);
                if (dSel) {
                  let dOptsHtml = "";
                  const dMax = brand === "clash" && isClashTarget2 ? targetVal - 1 : 120;
                  for (let dh = 5; dh <= dMax; dh += 5) {
                    dOptsHtml += `<option value="${dh}">Hole ${dh}</option>`;
                  }
                  dSel.innerHTML = dOptsHtml;
                  const defaultDest = opt.destHoles && opt.destHoles.defaults && opt.destHoles.defaults[i - 1] || defaultHole + 20;
                  dSel.value = String(defaultDest);
                }
              }
            }
          });
          if (brand === "clash") {
            const maxMarker = isClashTarget2 ? targetVal - 1 : 120;
            ["optSkunkMarkerHole", "optDoubleSkunkMarkerHole"].forEach((id) => {
              const sel = document.getElementById(id);
              if (sel) {
                let mHtml = "";
                for (let h = 5; h <= maxMarker; h += 5) mHtml += `<option value="${h}">Hole ${h}</option>`;
                sel.innerHTML = mHtml;
              }
            });
            const skunkDefs = typeof getSkunkDefaults === "function" ? getSkunkDefaults(targetVal) : { skunkHole: 360, doubleSkunkHole: 240 };
            const s1 = document.getElementById("optSkunkMarkerHole");
            const s2 = document.getElementById("optDoubleSkunkMarkerHole");
            if (s1) s1.value = String(skunkDefs.skunkHole);
            if (s2) s2.value = String(skunkDefs.doubleSkunkHole);
          }
        }
        function renderBooleanOptionMarkup(brand, opt) {
          const name = opt.name || "";
          let desc = opt.description || "";
          const badges = [];
          const ptsMatch = desc.match(/\b([−-]?\d+)\s*(?:bonus\s*)?points?\b/i);
          if (ptsMatch) {
            const pts = ptsMatch[1].replace("-", "\u2212");
            const ptsNum = parseInt(pts.replace("\u2212", "-"), 10);
            badges.push(`<span class="chk-badge points">${ptsNum > 0 ? `+${ptsNum}` : pts} pts</span>`);
          } else if (/1 (?:bonus )?point per card|1 pt per card/i.test(desc)) {
            badges.push(`<span class="chk-badge points">+1 pt / card</span>`);
          }
          if (/2 players only/i.test(desc)) {
            badges.push(`<span class="chk-badge tag">2P Only</span>`);
            desc = desc.replace(/\s*\(?2 players only\)?/i, "").trim();
          }
          if (/forces 4 players partnership/i.test(desc) || /4 players only/i.test(desc)) {
            badges.push(`<span class="chk-badge tag">4P Partnership</span>`);
            desc = desc.replace(/\s*\(?(?:forces 4 players partnership|4 players only)\)?/i, "").trim();
          }
          if (/pegging only/i.test(desc)) {
            badges.push(`<span class="chk-badge tag">Pegging Only</span>`);
            desc = desc.replace(/\s*\(?pegging only\)?/i, "").trim();
          }
          if (desc) {
            desc = desc.charAt(0).toUpperCase() + desc.slice(1);
            desc = desc.replace(/^[-—\s]+/, "").replace(/[-—\s]+$/, "");
          }
          const badgesHtml = badges.length ? `<div class="chk-badges">${badges.join("")}</div>` : "";
          return `<label class="chk ${opt.mutualGroup ? "chk-indented" : ""}" for="${opt.chkId}">
      <input type="checkbox" id="${opt.chkId}" data-opt-key="${opt.key}" data-brand="${brand}">
      <div class="chk-content">
        <div class="chk-title-row">
          <span class="chk-title">${name}</span>
          ${badgesHtml}
        </div>
        ${desc ? `<div class="chk-desc">${desc}</div>` : ""}
      </div>
    </label>`;
        }
        function renderTrackItemMarkup(brand, opt) {
          const configId = `${opt.key}Config`;
          const iconSpan = opt.icon ? `<span style="margin-right:4px;">${opt.icon}</span>` : "";
          const titleColor = opt.color ? `style="color: ${opt.color};"` : "";
          let out = `<label class="chk" for="${opt.chkId}">
      <input type="checkbox" id="${opt.chkId}" data-opt-key="${opt.key}" data-brand="${brand}" data-field-type="toggle">
      <div class="chk-content">
        <div class="chk-title-row">
          <span class="chk-title" ${titleColor}>${iconSpan}${opt.name}</span>
        </div>
        <div class="chk-desc">${opt.description}</div>
      </div>
    </label>
    <div id="${configId}" class="${opt.key}-config no-passing-config pints-config adult-config ${brand === "clash" ? "" : "pints-config"}" style="display: none;" data-config-key="${opt.key}">
      <div class="npl-header">
        <span class="npl-title" ${titleColor}>${iconSpan}${opt.name} Setup</span>
        <span class="npl-sub" id="${opt.key}Sub">${opt.headerDesc || (opt.actionText ? "1 peg \xB7 " + opt.actionText : "")}</span>
      </div>`;
          out += `<div class="npl-row">
      <label for="${opt.countId}">Active ${opt.badgePrefix || "Spaces"}:</label>
      <select id="${opt.countId}" data-opt-key="${opt.key}" data-brand="${brand}" data-field-type="count">`;
          for (let c = 1; c <= opt.maxCount; c++) {
            const selected = c === (opt.defaultCount || 2) ? " selected" : "";
            const unit = c === 1 ? opt.badgePrefix || "Space" : opt.badgePrefix ? opt.badgePrefix + "s" : "Spaces";
            out += `<option value="${c}"${selected}>${c} ${unit}</option>`;
          }
          out += `</select></div>`;
          if (opt.pegsId) {
            out += `<div class="npl-row" style="margin-top: 6px;">
        <label for="${opt.pegsId}">Number of Pegs:</label>
        <select id="${opt.pegsId}" data-opt-key="${opt.key}" data-brand="${brand}" data-field-type="pegs">`;
            for (let p = 1; p <= 5; p++) {
              const selected = p === (opt.defaultPegs || 1) ? " selected" : "";
              out += `<option value="${p}"${selected}>${p} Peg${p > 1 ? "s" : ""}</option>`;
            }
            out += `</select></div>`;
          }
          out += `<div class="npl-lanes-list">`;
          for (let i = 1; i <= opt.maxCount; i++) {
            const isVisible = i <= (opt.defaultCount || 2);
            const rowId = `${opt.key}Row${i}`;
            const badgeId = `${opt.key}Badge${i}`;
            const suffix = opt.holes && opt.holes.suffix || "Hole";
            const holeSelId = `${opt.prefix}${i}${suffix}`;
            const labelText = `${opt.badgePrefix || opt.name} ${i}`;
            const defaultHole2 = opt.holes && opt.holes.defaults && opt.holes.defaults[i - 1] || i * 15;
            let badgeStyle = "";
            if (opt.color) {
              badgeStyle = `style="background: ${hexToRgba(opt.color, 0.2)}; color: ${opt.color}; border: 1px solid ${hexToRgba(opt.color, 0.4)};"`;
            }
            if (opt.key === "jump") {
              const destSelId = `${opt.prefix}${i}${opt.destHoles && opt.destHoles.suffix || "Dest"}`;
              const defaultDest = opt.destHoles && opt.destHoles.defaults && opt.destHoles.defaults[i - 1] || defaultHole2 + 20;
              out += `<div class="jump-item-row" id="${rowId}" style="${isVisible ? "" : "display: none;"}">
          <div class="jump-row-top">
            <span class="jump-label">${labelText}</span>
            <span class="jump-badge jump-badge-forward" id="${badgeId}">Forward \u2794</span>
          </div>
          <div class="jump-controls-grid">
            <div class="jump-field">
              <label for="${holeSelId}">Trigger Zone:</label>
              <select id="${holeSelId}" class="jump-select" data-opt-key="${opt.key}" data-index="${i}" data-field-type="hole"></select>
            </div>
            <div class="jump-field">
              <label for="${destSelId}">Jump To:</label>
              <select id="${destSelId}" class="jump-select" data-opt-key="${opt.key}" data-index="${i}" data-field-type="jumpDest"></select>
            </div>
          </div>
        </div>`;
            } else if (opt.key === "signs") {
              const sizeSelId = `${opt.prefix}${i}Size`;
              const slotsWrapId = `signs${i}SlotsWrap`;
              out += `<div class="signs-item-row" id="${rowId}" style="${isVisible ? "" : "display: none;"}">
          <div class="signs-row-top">
            <span class="signs-label">${labelText}</span>
            <span class="signs-badge" id="${badgeId}">Holes ${defaultHole2}\u2013${defaultHole2 + 2} \xB7 2 Signs</span>
          </div>
          <div class="signs-controls-grid">
            <div class="signs-field">
              <label for="${holeSelId}">Start Hole:</label>
              <select id="${holeSelId}" class="signs-select" data-opt-key="${opt.key}" data-index="${i}" data-field-type="hole"></select>
            </div>
            <div class="signs-field">
              <label for="${sizeSelId}">Block Size:</label>
              <select id="${sizeSelId}" class="signs-select" data-opt-key="${opt.key}" data-index="${i}" data-field-type="signsSize">
                <option value="2"${i % 2 === 1 ? " selected" : ""}>3 Pegs (2 Signs)</option>
                <option value="4"${i % 2 === 0 ? " selected" : ""}>5 Pegs (4 Signs)</option>
              </select>
            </div>
          </div>
          <div class="signs-slots-grid" id="${slotsWrapId}">
            ${renderSignsSlots(i)}
          </div>
        </div>`;
            } else {
              out += `<div class="${opt.key}-item-row jail-item-row" id="${rowId}" style="${isVisible ? "" : "display: none;"}">
          <div class="${opt.key}-row-top jail-row-top">
            <span class="${opt.key}-label jail-label">${labelText}</span>
            <span class="${opt.key}-badge jail-badge" id="${badgeId}" ${badgeStyle}>Hole ${defaultHole2}</span>
          </div>
          <div class="${opt.key}-controls-grid jail-controls-grid">
            <div class="${opt.key}-field jail-field">
              <label for="${holeSelId}">Hole:</label>
              <select id="${holeSelId}" class="${opt.key}-select jail-select" data-opt-key="${opt.key}" data-index="${i}" data-field-type="hole"></select>
            </div>
          </div>
        </div>`;
            }
          }
          out += `</div></div>`;
          return out;
        }
        function renderSignsSlots(blockIdx) {
          let slotsHtml = "";
          const defaultSigns = [
            ["Plus 5", "Roll The Dice", "Score Plus x2", "Minus 5"],
            ["Plus 10", "Minus 10", "Spin The Wheel", "Plus 5"],
            ["Plus 5", "Score Plus x3", "Go To Jail", "Go To The Bar"],
            ["Plus 5", "Minus 10", "Roll The Dice", "Go To Timeout"]
          ];
          const def = defaultSigns[blockIdx - 1] || defaultSigns[0];
          for (let s = 1; s <= 4; s++) {
            const slotSelId = `optSigns${blockIdx}Slot${s}`;
            const wrapId = `signs${blockIdx}Slot${s}Wrap`;
            const isSlotVisible = s <= 2;
            slotsHtml += `<div class="signs-slot-field" id="${wrapId}" style="${isSlotVisible ? "" : "display: none;"}">
        <label>Sign ${s}:</label>
        <select id="${slotSelId}" class="signs-select" data-opt-key="signs" data-index="${blockIdx}" data-slot="${s}" data-field-type="signSlot">`;
            SIGN_SLOT_OPTIONS.forEach((opt) => {
              const selected = opt.value === def[s - 1] ? " selected" : "";
              slotsHtml += `<option value="${opt.value}"${selected}>${opt.text}</option>`;
            });
            slotsHtml += `</select></div>`;
          }
          return slotsHtml;
        }
        function renderSkunkMarkersMarkup() {
          return `<label class="chk"><input type="checkbox" id="optSkunkMarkers" data-opt-key="skunkMarkers" data-field-type="toggle"> Skunk Markers \u2014 Display interactive 75% and 50% Skunk Markers directly on the game board</label>
    <div id="skunkMarkersConfig" class="stop-sign-config" style="display: none;">
      <div class="npl-header">
        <span class="npl-title stop-sign-title">\u{1F9A8} Skunk Markers Setup</span>
        <span class="npl-sub">Single-hole markers \xB7 75% Skunk and 50% Double Skunk</span>
      </div>
      <div class="npl-lanes-list">
        <div class="stop-sign-item-row" id="skunkMarkerRow">
          <div class="stop-sign-row-top">
            <span class="skunk-marker-label">\u{1F9A8} Skunk Marker (75% mark)</span>
            <span class="stop-sign-badge" id="skunkMarkerBadge">Hole 360</span>
          </div>
          <div class="stop-sign-controls-grid">
            <div class="stop-sign-field">
              <label for="optSkunkMarkerHole">Marker Hole:</label>
              <select id="optSkunkMarkerHole" class="stop-sign-select" data-opt-key="skunkMarkers" data-field-type="skunkSingle"></select>
            </div>
          </div>
        </div>
        <div class="stop-sign-item-row" id="doubleSkunkMarkerRow">
          <div class="stop-sign-row-top">
            <span class="skunk-marker-label">\u{1F9A8}\u{1F9A8} Double Skunk Marker (50% mark)</span>
            <span class="stop-sign-badge" id="doubleSkunkMarkerBadge">Hole 240</span>
          </div>
          <div class="stop-sign-controls-grid">
            <div class="stop-sign-field">
              <label for="optDoubleSkunkMarkerHole">Marker Hole:</label>
              <select id="optDoubleSkunkMarkerHole" class="stop-sign-select" data-opt-key="skunkMarkers" data-field-type="skunkDouble"></select>
            </div>
          </div>
        </div>
      </div>
    </div>`;
        }
        function hexToRgba(hex, alpha) {
          if (!hex || hex[0] !== "#") return hex;
          const r = parseInt(hex.slice(1, 3), 16) || 0;
          const g = parseInt(hex.slice(3, 5), 16) || 0;
          const b = parseInt(hex.slice(5, 7), 16) || 0;
          return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        }
        function bindBrandContainerEvents(brand, containerEl) {
          containerEl.addEventListener("click", function(e) {
            const presetBtn = e.target.closest("button.clash-preset-pill");
            if (presetBtn) {
              const btnBrand = presetBtn.getAttribute("data-brand") || brand;
              const presetKey = presetBtn.getAttribute("data-preset");
              if (presetKey === "custom") {
                if (typeof window.ClashSandboxModal !== "undefined" && typeof window.ClashSandboxModal.open === "function") {
                  window.ClashSandboxModal.open({ brand: btnBrand, openDrawer: true });
                }
                return;
              }
              if (btnBrand === "pints") {
                if (typeof window.PintsPresets !== "undefined" && typeof window.PintsPresets.applyPreset === "function") {
                  window.PintsPresets.applyPreset(presetKey);
                  containerEl.querySelectorAll("#pintsPresetsPillRow .clash-preset-pill").forEach((b) => b.classList.toggle("active", b === presetBtn));
                  if (typeof window.showToast === "function") {
                    const names = { standard: "Pub Crawl", powerHour: "Power Hour", socialHour: "Social Hour", battleOfSexes: "Battle of the Sexes" };
                    window.showToast(`\u{1F37B} Applied drinking preset: ${names[presetKey] || presetKey}`);
                  }
                }
                return;
              }
              if (btnBrand === "adult") {
                if (typeof window.AdultPresets !== "undefined" && typeof window.AdultPresets.applyPreset === "function") {
                  window.AdultPresets.applyPreset(presetKey);
                  containerEl.querySelectorAll("#adultPresetsPillRow .clash-preset-pill").forEach((b) => b.classList.toggle("active", b === presetBtn));
                  if (typeof window.showToast === "function") {
                    const names = { standard: "Warm-Up Strip", highHeat: "High Heat", sensualGauntlet: "Sensual Gauntlet" };
                    window.showToast(`\u{1F48B} Applied strip & dare preset: ${names[presetKey] || presetKey}`);
                  }
                }
                return;
              }
              if (presetKey && typeof window.applyClashPreset === "function") {
                window.applyClashPreset(presetKey);
                containerEl.querySelectorAll("#clashPresetsPillRow .clash-preset-pill").forEach((b) => b.classList.toggle("active", b === presetBtn));
                if (typeof window.showToast === "function") {
                  const names = { standard: "Classic Clash", gauntlet: "The Gauntlet", speedway: "Speedway", bottleneck: "Cutthroat Bottleneck" };
                  window.showToast(`\u{1F3C1} Applied layout preset: ${names[presetKey] || presetKey}`);
                }
              }
              return;
            }
            const sandboxBtn = e.target.closest('button.btn-sandbox-launcher, button[data-action="open-sandbox"]');
            if (sandboxBtn) {
              const btnBrand = sandboxBtn.getAttribute("data-brand") || brand;
              if (btnBrand === "clash" && typeof window.openClashSandbox === "function") {
                window.openClashSandbox();
              } else if (btnBrand === "pints" && typeof window.openPintsSandbox === "function") {
                window.openPintsSandbox();
              } else if (btnBrand === "adult" && typeof window.openAdultSandbox === "function") {
                window.openAdultSandbox();
              } else if (typeof window.ClashSandboxModal !== "undefined" && typeof window.ClashSandboxModal.open === "function") {
                window.ClashSandboxModal.open({ brand: btnBrand });
              }
              return;
            }
            const headerBtn = e.target.closest('button[data-action="toggle-subgroup"]');
            if (headerBtn) {
              const subgroupId = headerBtn.getAttribute("data-subgroup");
              const section = headerBtn.closest(".chk-subgroup-section");
              if (section) {
                const isNowCollapsed = section.classList.toggle("is-collapsed");
                headerBtn.setAttribute("aria-expanded", isNowCollapsed ? "false" : "true");
                const title = headerBtn.querySelector(".chk-subgroup-title")?.textContent || "section";
                headerBtn.setAttribute("title", `Click to ${isNowCollapsed ? "expand" : "collapse"} ${title}`);
                const collapsedSet = getCollapsedSubgroups(brand);
                if (isNowCollapsed) {
                  collapsedSet.add(subgroupId);
                } else {
                  collapsedSet.delete(subgroupId);
                }
                saveCollapsedSubgroups(brand, collapsedSet);
              }
              return;
            }
            const expandAllBtn = e.target.closest('button[data-action="expand-all-subgroups"]');
            if (expandAllBtn) {
              setAllSubgroupsExpanded(brand, true);
              return;
            }
            const collapseAllBtn = e.target.closest('button[data-action="collapse-all-subgroups"]');
            if (collapseAllBtn) {
              setAllSubgroupsExpanded(brand, false);
              return;
            }
            const btn = e.target.closest("button[data-action]");
            if (!btn) return;
            const action = btn.getAttribute("data-action");
            if (action === "randomize") {
              randomizeBrandOptions(brand, false);
              updateSubgroupActiveBadges(brand, containerEl);
            } else if (action === "full-randomize") {
              randomizeBrandOptions(brand, true);
              updateSubgroupActiveBadges(brand, containerEl);
            }
          });
          const checkAllBonusesEl = document.getElementById("checkAllBonuses");
          if (checkAllBonusesEl && !checkAllBonusesEl._hasSubgroupBadgeListener) {
            checkAllBonusesEl._hasSubgroupBadgeListener = true;
            const updateBadges = () => {
              setTimeout(() => updateSubgroupActiveBadges(brand, containerEl), 0);
            };
            checkAllBonusesEl.addEventListener("click", updateBadges);
            checkAllBonusesEl.addEventListener("change", updateBadges);
          }
          containerEl.addEventListener("change", function(e) {
            const target = e.target;
            const optKey = target.getAttribute("data-opt-key");
            const fieldType = target.getAttribute("data-field-type");
            if (!optKey) return;
            handleFieldChange(brand, optKey, fieldType, target);
            updateSubgroupActiveBadges(brand, containerEl);
          });
        }
        function handleFieldChange(brand, optKey, fieldType, target) {
          const config = GAME_CONFIGS.getGame(brand);
          const opt = GAME_CONFIGS.getOption(brand, optKey);
          if (fieldType === "toggle") {
            const panel = document.getElementById(`${optKey}Config`);
            if (panel) {
              panel.style.display = target.checked ? "block" : "none";
            }
            if (opt && opt.type === "trackItem") {
              updateTrackItemRows(optKey);
              enforceBrandNoOverlap(brand);
            }
          } else if (fieldType === "count") {
            updateTrackItemRows(optKey);
            enforceBrandNoOverlap(brand);
          } else if (fieldType === "pegs") {
            updatePegsLabel(optKey, target.value);
            enforceBrandNoOverlap(brand);
          } else if (fieldType === "hole" || fieldType === "jumpDest") {
            enforceBrandNoOverlap(brand, target.id);
            updateBadge(brand, optKey, target.getAttribute("data-index"));
          } else if (fieldType === "signsSize") {
            const idx = target.getAttribute("data-index");
            const sz = parseInt(target.value, 10);
            const slot3 = document.getElementById(`signs${idx}Slot3Wrap`);
            const slot4 = document.getElementById(`signs${idx}Slot4Wrap`);
            if (slot3) slot3.style.display = sz === 4 ? "flex" : "none";
            if (slot4) slot4.style.display = sz === 4 ? "flex" : "none";
            enforceBrandNoOverlap(brand);
            updateBadge(brand, optKey, idx);
          }
          if (opt && opt.mutualGroup && target.checked) {
            config.options.filter((o) => o.mutualGroup === opt.mutualGroup && o.key !== opt.key).forEach((other) => {
              const otherEl = document.getElementById(other.chkId);
              if (otherEl) otherEl.checked = false;
            });
          }
          if (!_suppressSave) {
            if (typeof window !== "undefined" && typeof window.saveSettingsStore === "function" && typeof window.readFormSettings === "function") {
              window.saveSettingsStore(window.readFormSettings());
            } else {
              saveBrandSettings(brand, readBrandSettings(brand));
            }
          }
        }
        function updateTrackItemRows(optKey) {
          const countEl = document.getElementById(`opt${capitalize(optKey)}Count`);
          const count = countEl ? parseInt(countEl.value, 10) : 2;
          for (let i = 1; i <= 8; i++) {
            const row = document.getElementById(`${optKey}Row${i}`);
            if (row) row.style.display = i <= count ? "flex" : "none";
          }
        }
        function updatePegsLabel(optKey, pegsVal) {
          const sub = document.getElementById(`${optKey}Sub`);
          const opt = GAME_CONFIGS.getOption(getAppBrand2(), optKey);
          if (!sub || !opt) return;
          const p = parseInt(pegsVal, 10) || 1;
          const baseAction = opt.actionText || opt.description || "";
          sub.textContent = `${p === 1 ? "1 peg" : p + " pegs"} \xB7 ${baseAction}`;
        }
        function updateBadge(brand, optKey, idx) {
          const opt = GAME_CONFIGS.getOption(brand, optKey);
          if (!opt) return;
          const badge = document.getElementById(`${optKey}Badge${idx}`);
          if (!badge) return;
          const suffix = opt.holes && opt.holes.suffix || "Hole";
          const holeEl = document.getElementById(`${opt.prefix}${idx}${suffix}`);
          const h = holeEl ? parseInt(holeEl.value, 10) : 0;
          if (isNaN(h) || h <= 0) return;
          const targetVal = typeof settings !== "undefined" && settings && settings.target || 121;
          const street = getStreetOrTurnName2(h, targetVal);
          if (optKey === "jump") {
            const destEl = document.getElementById(`${opt.prefix}${idx}${opt.destHoles && opt.destHoles.suffix || "Dest"}`);
            const d = destEl ? parseInt(destEl.value, 10) : 0;
            const isFwd = !isNaN(d) && d > h;
            badge.className = "jump-badge " + (isFwd ? "jump-badge-forward" : "jump-badge-backward");
            badge.textContent = isFwd ? "Forward (1 hole) \u2794" : "Backward (3 holes) \u2B05";
            const row = document.getElementById(`jumpRow${idx}`);
            if (row) row.classList.toggle("backward", !isFwd);
          } else if (optKey === "signs") {
            const sizeEl = document.getElementById(`${opt.prefix}${idx}Size`);
            const sz = sizeEl ? parseInt(sizeEl.value, 10) : 2;
            const len = sz === 4 ? 5 : 3;
            badge.textContent = `${street} (Holes ${h}\u2013${h + len - 1} \xB7 ${sz} Signs)`;
          } else {
            const pegsEl = document.getElementById(opt.pegsId);
            const pegs = pegsEl ? parseInt(pegsEl.value, 10) : opt.fixedLength || 1;
            if (pegs > 1) {
              badge.textContent = `${street} \xB7 Holes ${h}\u2013${h + pegs - 1} (${pegs} Pegs)`;
            } else {
              badge.textContent = `${street} (Hole ${h})`;
            }
          }
        }
        function readBrandSettings(brand) {
          const config = GAME_CONFIGS.getGame(brand);
          const data = {};
          config.options.forEach((opt) => {
            const chk = document.getElementById(opt.chkId);
            if (opt.type === "boolean") {
              data[opt.key] = chk ? chk.checked : false;
              data[opt.chkId] = chk ? chk.checked : false;
            } else if (opt.type === "trackItem") {
              data[opt.chkId] = chk ? chk.checked : false;
              const countEl = document.getElementById(opt.countId);
              if (countEl) {
                data[`${opt.key}Count`] = parseInt(countEl.value, 10) || opt.defaultCount;
              }
              if (opt.pegsId) {
                const pegsEl = document.getElementById(opt.pegsId);
                if (pegsEl) {
                  data[`${opt.key}Pegs`] = parseInt(pegsEl.value, 10) || 1;
                }
              }
              const holes = [];
              const suffix = opt.holes && opt.holes.suffix || "Hole";
              for (let i = 1; i <= opt.maxCount; i++) {
                const hEl = document.getElementById(`${opt.prefix}${i}${suffix}`);
                const fallback = opt.holes && opt.holes.defaults && opt.holes.defaults[i - 1] || i * 15;
                const val = hEl ? parseInt(hEl.value, 10) || fallback : fallback;
                holes.push(val);
                data[`${opt.prefix}${i}${suffix}`] = val;
              }
              data[`${opt.key}Holes`] = holes;
              data[`${opt.key}Starts`] = holes;
              if (opt.key === "wheel") {
                data.spinningWheelCount = data.wheelCount;
                data.spinningWheelHoles = holes;
                data.spinningWheelStarts = holes;
                data.optSpinningWheel = data.optWheel;
              }
              if (opt.key === "noPassingLanes") {
                data.noPassingLaneCount = data.noPassingLanesCount;
                data.noPassingLaneStarts = holes;
                data.noPassingLaneHoles = holes;
              }
              if (opt.hasDestination) {
                const dests = [];
                const dSuffix = opt.destHoles && opt.destHoles.suffix || "Dest";
                for (let i = 1; i <= opt.maxCount; i++) {
                  const dEl = document.getElementById(`${opt.prefix}${i}${dSuffix}`);
                  const fallback = opt.destHoles && opt.destHoles.defaults && opt.destHoles.defaults[i - 1] || holes[i - 1] + 20;
                  dests.push(dEl ? parseInt(dEl.value, 10) || fallback : fallback);
                }
                data[`${opt.key}Dests`] = dests;
              }
              if (opt.hasSignsSlots) {
                const blocks = [];
                for (let i = 1; i <= opt.maxCount; i++) {
                  const sizeEl = document.getElementById(`${opt.prefix}${i}Size`);
                  const sz = sizeEl ? parseInt(sizeEl.value, 10) : 2;
                  const signs = [];
                  for (let s = 1; s <= sz; s++) {
                    const sEl = document.getElementById(`optSigns${i}Slot${s}`);
                    if (sEl && sEl.value) signs.push(sEl.value);
                  }
                  blocks.push({ id: i, start: holes[i - 1], size: sz, signs });
                }
                data.signsBlocks = blocks;
              }
            } else if (opt.type === "skunkSpecial") {
              data[opt.chkId] = chk ? chk.checked : false;
              data.optSkunkMarkers = chk ? chk.checked : false;
              const skunkHoleEl = document.getElementById("optSkunkMarkerHole");
              const dblSkunkHoleEl = document.getElementById("optDoubleSkunkMarkerHole");
              if (skunkHoleEl) data.skunkMarkerHole = parseInt(skunkHoleEl.value, 10);
              if (dblSkunkHoleEl) data.doubleSkunkMarkerHole = parseInt(dblSkunkHoleEl.value, 10);
            }
          });
          return data;
        }
        function applyBrandSettings(brand, saved) {
          if (!saved) return;
          const config = GAME_CONFIGS.getGame(brand);
          _suppressSave = true;
          try {
            config.options.forEach((opt) => {
              const chk = document.getElementById(opt.chkId);
              if (opt.type === "boolean") {
                if (chk && saved[opt.key] !== void 0) chk.checked = Boolean(saved[opt.key]);
                else if (chk && saved[opt.chkId] !== void 0) chk.checked = Boolean(saved[opt.chkId]);
              } else if (opt.type === "skunkSpecial") {
                const isEnabled = saved.optSkunkMarkers !== void 0 ? Boolean(saved.optSkunkMarkers) : saved[opt.chkId] !== void 0 ? Boolean(saved[opt.chkId]) : false;
                if (chk) chk.checked = isEnabled;
                const panel = document.getElementById("skunkMarkersConfig");
                if (panel) panel.style.display = isEnabled ? "block" : "none";
                const skunkHoleEl = document.getElementById("optSkunkMarkerHole");
                if (skunkHoleEl && saved.skunkMarkerHole != null) skunkHoleEl.value = String(saved.skunkMarkerHole);
                const dblSkunkHoleEl = document.getElementById("optDoubleSkunkMarkerHole");
                if (dblSkunkHoleEl && saved.doubleSkunkMarkerHole != null) dblSkunkHoleEl.value = String(saved.doubleSkunkMarkerHole);
                const badge1 = document.getElementById("skunkMarkerBadge");
                if (badge1 && saved.skunkMarkerHole != null) badge1.textContent = `Hole ${saved.skunkMarkerHole}`;
                const badge2 = document.getElementById("doubleSkunkMarkerBadge");
                if (badge2 && saved.doubleSkunkMarkerHole != null) badge2.textContent = `Hole ${saved.doubleSkunkMarkerHole}`;
              } else if (opt.type === "trackItem") {
                const isEnabled = saved[opt.chkId] !== void 0 ? Boolean(saved[opt.chkId]) : saved[opt.key] !== void 0 ? Boolean(saved[opt.key]) : opt.key === "wheel" && saved.optSpinningWheel !== void 0 ? Boolean(saved.optSpinningWheel) : false;
                if (chk) chk.checked = isEnabled;
                const panel = document.getElementById(`${opt.key}Config`);
                if (panel) panel.style.display = isEnabled ? "block" : "none";
                const count = saved[`${opt.key}Count`] || (opt.key === "wheel" ? saved.optWheelCount || saved.spinningWheelCount || saved.optSpinningWheelCount : null) || (opt.key === "noPassingLanes" ? saved.noPassingLaneCount : null) || opt.defaultCount || 2;
                const countEl = document.getElementById(opt.countId);
                if (countEl) countEl.value = String(count);
                if (opt.pegsId) {
                  const pegs = saved[`${opt.key}Pegs`] || opt.defaultPegs || 1;
                  const pegsEl = document.getElementById(opt.pegsId);
                  if (pegsEl) pegsEl.value = String(pegs);
                  updatePegsLabel(opt.key, pegs);
                }
                const holes = saved[`${opt.key}Holes`] || saved[`${opt.key}Starts`] || (opt.key === "wheel" ? saved.spinningWheelHoles || saved.spinningWheelStarts || [saved.optWheel1Hole, saved.optWheel2Hole, saved.optWheel3Hole, saved.optWheel4Hole].filter(Boolean) : null) || (opt.key === "noPassingLanes" ? saved.noPassingLaneHoles || saved.noPassingLaneStarts : null) || opt.holes && opt.holes.defaults || [];
                const suffix = opt.holes && opt.holes.suffix || "Hole";
                for (let i = 1; i <= opt.maxCount; i++) {
                  const hEl = document.getElementById(`${opt.prefix}${i}${suffix}`);
                  if (hEl && holes[i - 1] != null) {
                    hEl.value = String(holes[i - 1]);
                    hEl.dataset.customized = "true";
                  }
                }
                if (opt.hasDestination) {
                  const dests = saved[`${opt.key}Dests`] || opt.destHoles && opt.destHoles.defaults || [];
                  const dSuffix = opt.destHoles && opt.destHoles.suffix || "Dest";
                  for (let i = 1; i <= opt.maxCount; i++) {
                    const dEl = document.getElementById(`${opt.prefix}${i}${dSuffix}`);
                    if (dEl && dests[i - 1] != null) {
                      dEl.value = String(dests[i - 1]);
                      dEl.dataset.customized = "true";
                    }
                  }
                }
                if (opt.hasSignsSlots && Array.isArray(saved.signsBlocks)) {
                  saved.signsBlocks.forEach((block, idx) => {
                    const i = idx + 1;
                    const sizeEl = document.getElementById(`optSigns${i}Size`);
                    if (sizeEl && block.size) sizeEl.value = String(block.size);
                    const slot3 = document.getElementById(`signs${i}Slot3Wrap`);
                    const slot4 = document.getElementById(`signs${i}Slot4Wrap`);
                    if (slot3) slot3.style.display = block.size === 4 ? "flex" : "none";
                    if (slot4) slot4.style.display = block.size === 4 ? "flex" : "none";
                    if (Array.isArray(block.signs)) {
                      block.signs.forEach((sgn, sIdx) => {
                        const sEl = document.getElementById(`optSigns${i}Slot${sIdx + 1}`);
                        if (sEl) sEl.value = sgn;
                      });
                    }
                  });
                }
                updateTrackItemRows(opt.key);
                for (let i = 1; i <= opt.maxCount; i++) {
                  updateBadge(brand, opt.key, i);
                }
              }
            });
            enforceBrandNoOverlap(brand);
            updateSubgroupActiveBadges(brand, document.getElementById("brand-game-options"));
          } finally {
            _suppressSave = false;
          }
        }
        function getAppStorage() {
          return typeof window !== "undefined" && window.appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
        }
        function saveBrandSettings(brand, data) {
          if (_suppressSave) return;
          const config = GAME_CONFIGS.getGame(brand);
          try {
            const s = getAppStorage();
            if (s) {
              let existing = {};
              try {
                const raw = s.getItem(config.storageKey);
                if (raw) existing = JSON.parse(raw);
              } catch (_) {
              }
              const merged = Object.assign({}, existing, data);
              s.setItem(config.storageKey, JSON.stringify(merged));
            }
          } catch (e) {
          }
        }
        function loadBrandSettings(brand) {
          const config = GAME_CONFIGS.getGame(brand);
          try {
            const s = getAppStorage();
            const raw = s ? s.getItem(config.storageKey) : null;
            if (raw) return JSON.parse(raw);
          } catch (e) {
          }
          return null;
        }
        const COLLAPSED_STORAGE_KEY_PREFIX = "cc_collapsed_subgroups_";
        function getCollapsedSubgroups(brand) {
          const set = /* @__PURE__ */ new Set();
          try {
            const s = getAppStorage();
            if (s) {
              const raw = s.getItem(COLLAPSED_STORAGE_KEY_PREFIX + brand);
              if (raw) {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                  parsed.forEach((id) => set.add(id));
                }
              }
            }
          } catch (_) {
          }
          return set;
        }
        function saveCollapsedSubgroups(brand, set) {
          try {
            const s = getAppStorage();
            if (s) {
              s.setItem(COLLAPSED_STORAGE_KEY_PREFIX + brand, JSON.stringify(Array.from(set)));
            }
          } catch (_) {
          }
        }
        function updateSubgroupActiveBadges(brand, containerEl) {
          if (!containerEl && typeof document !== "undefined") {
            containerEl = document.getElementById("brand-game-options");
          }
          if (!containerEl || typeof containerEl.querySelectorAll !== "function") return;
          const sections = containerEl.querySelectorAll(".chk-subgroup-section");
          sections.forEach((section) => {
            const subgroupId = section.getAttribute("data-subgroup");
            const badge = section.querySelector(`[data-subgroup-badge="${subgroupId}"]`);
            if (!badge) return;
            const content = section.querySelector(".chk-subgroup-content");
            if (!content) return;
            const checkedCount = Array.from(content.querySelectorAll('input[type="checkbox"]')).filter((c) => c.checked).length;
            if (checkedCount > 0) {
              badge.textContent = `${checkedCount} active`;
              badge.classList.remove("hidden");
            } else {
              badge.textContent = "0 active";
              badge.classList.add("hidden");
            }
          });
        }
        function toggleSubgroup(brand, subgroupId, forceExpand = null) {
          if (typeof document === "undefined") return;
          const section = document.querySelector(`.chk-subgroup-section[data-subgroup="${subgroupId}"]`);
          if (!section) return;
          const headerBtn = section.querySelector('button[data-action="toggle-subgroup"]');
          const willBeCollapsed = forceExpand !== null ? !forceExpand : !section.classList.contains("is-collapsed");
          section.classList.toggle("is-collapsed", willBeCollapsed);
          if (headerBtn) {
            headerBtn.setAttribute("aria-expanded", willBeCollapsed ? "false" : "true");
            const title = headerBtn.querySelector?.(".chk-subgroup-title")?.textContent || "section";
            headerBtn.setAttribute("title", `Click to ${willBeCollapsed ? "expand" : "collapse"} ${title}`);
          }
          const collapsedSet = getCollapsedSubgroups(brand);
          if (willBeCollapsed) {
            collapsedSet.add(subgroupId);
          } else {
            collapsedSet.delete(subgroupId);
          }
          saveCollapsedSubgroups(brand, collapsedSet);
        }
        function setAllSubgroupsExpanded(brand, expanded = true) {
          if (typeof document === "undefined") return;
          const container = document.getElementById("brand-game-options");
          if (!container || typeof container.querySelectorAll !== "function") return;
          const sections = container.querySelectorAll(".chk-subgroup-section");
          const allIds = /* @__PURE__ */ new Set();
          sections.forEach((section) => {
            section.classList.toggle("is-collapsed", !expanded);
            const id = section.getAttribute("data-subgroup");
            if (id && !expanded) allIds.add(id);
            const h = section.querySelector('button[data-action="toggle-subgroup"]');
            if (h) {
              h.setAttribute("aria-expanded", expanded ? "true" : "false");
              const title = h.querySelector?.(".chk-subgroup-title")?.textContent || "section";
              h.setAttribute("title", `Click to ${expanded ? "collapse" : "expand"} ${title}`);
            }
          });
          saveCollapsedSubgroups(brand, allIds);
        }
        function getBrandActiveTrackItems(brand) {
          const config = GAME_CONFIGS.getGame(brand);
          const active2 = [];
          config.options.filter((o) => o.type === "trackItem").forEach((def) => {
            const chk = document.getElementById(def.chkId);
            if (!chk || !chk.checked) return;
            const countEl = document.getElementById(def.countId);
            const count = countEl ? Math.min(def.maxCount, Math.max(1, parseInt(countEl.value, 10) || 1)) : 1;
            const suffix = def.holes && def.holes.suffix || "Hole";
            for (let i = 1; i <= count; i++) {
              const selId = `${def.prefix}${i}${suffix}`;
              const sel = document.getElementById(selId);
              if (!sel) continue;
              const start = parseInt(sel.value, 10);
              if (isNaN(start) || start <= 0) continue;
              let length = 1;
              if (def.fixedLength) length = def.fixedLength;
              else if (def.pegsId) {
                const pEl = document.getElementById(def.pegsId);
                length = pEl ? parseInt(pEl.value, 10) || 1 : 1;
              } else if (def.lengthType === "jumpDynamic") {
                const dEl = document.getElementById(`${def.prefix}${i}Dest`);
                const dVal = dEl ? parseInt(dEl.value, 10) : 0;
                length = !isNaN(dVal) && dVal > start ? 1 : 3;
              } else if (def.lengthType === "signsSize") {
                const szEl = document.getElementById(`${def.prefix}${i}Size`);
                length = szEl && parseInt(szEl.value, 10) === 4 ? 5 : 3;
              }
              active2.push({
                brand,
                key: def.key,
                index: i,
                id: `${def.key}_${i}`,
                name: `${def.name} ${i}`,
                selectId: selId,
                start,
                length,
                end: start + length - 1,
                def
              });
            }
          });
          return active2;
        }
        function enforceBrandNoOverlap(brand, triggeringSelectId) {
          if (_isEnforcingOverlap) return;
          _isEnforcingOverlap = true;
          try {
            const active2 = getBrandActiveTrackItems(brand);
            const occupied = /* @__PURE__ */ new Map();
            active2.forEach((item) => {
              for (let h = item.start; h <= item.end; h++) {
                if (occupied.has(h)) {
                  const freeStart = findFreeSlot(item.start, item.length, occupied, 5, 120, 5);
                  item.start = freeStart;
                  item.end = freeStart + item.length - 1;
                  const sel = document.getElementById(item.selectId);
                  if (sel) sel.value = String(freeStart);
                  break;
                }
              }
              for (let h = item.start; h <= item.end; h++) {
                occupied.set(h, item);
              }
            });
          } finally {
            _isEnforcingOverlap = false;
          }
        }
        function findFreeSlot(desired, len, occupiedMap, minHole, maxHole, step) {
          function isFree(s) {
            for (let h = s; h < s + len; h++) {
              if (occupiedMap.has(h)) return false;
            }
            return true;
          }
          if (isFree(desired)) return desired;
          for (let delta = step; delta <= maxHole; delta += step) {
            if (desired + delta <= maxHole && isFree(desired + delta)) return desired + delta;
            if (desired - delta >= minHole && isFree(desired - delta)) return desired - delta;
          }
          for (let h = minHole; h <= maxHole; h += step) {
            if (isFree(h)) return h;
          }
          return desired;
        }
        function randomizeBrandOptions(brand, isFull = false) {
          const config = GAME_CONFIGS.getGame(brand);
          if (!config || !config.randomizer) return;
          if (config.randomizer.mode === "subset") {
            const container = document.getElementById("brand-game-options") || document.querySelector(".bonuses");
            if (!container) return;
            const chks = Array.from(container.querySelectorAll('input[type="checkbox"]'));
            chks.forEach((c) => c.checked = false);
            const count = Math.floor(Math.random() * 4) + 3;
            const shuffled = chks.slice().sort(() => 0.5 - Math.random());
            shuffled.slice(0, count).forEach((c) => c.checked = true);
            const cdChk = document.getElementById("optCanadianDoubles");
            if (cdChk && cdChk.checked) {
              const pCountEl = document.getElementById("optPlayerCount");
              if (pCountEl) {
                pCountEl.value = "4_part";
                pCountEl.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }
            saveBrandSettings(brand, readBrandSettings(brand));
            updateSubgroupActiveBadges(brand, container);
          } else if (config.randomizer.mode === "trackDistribution") {
            const trackOptions = config.options.filter((o) => o.type === "trackItem");
            trackOptions.forEach((opt) => {
              const chk = document.getElementById(opt.chkId);
              if (chk) chk.checked = true;
              const panel = document.getElementById(`${opt.key}Config`);
              if (panel) panel.style.display = "block";
            });
            const totalSpaces = config.randomizer.totalBoardSpaces || 24;
            const numOpts = trackOptions.length;
            const counts = new Array(numOpts).fill(1);
            let remaining = totalSpaces - numOpts;
            while (remaining > 0) {
              const candidates = [];
              for (let i = 0; i < numOpts; i++) {
                if (counts[i] < (trackOptions[i].maxCount || 4)) candidates.push(i);
              }
              if (!candidates.length) break;
              const chosen = candidates[Math.floor(Math.random() * candidates.length)];
              counts[chosen]++;
              remaining--;
            }
            const availableHoles = [];
            for (let h = config.randomizer.minHole || 5; h <= (config.randomizer.maxHole || 120); h += config.randomizer.step || 5) {
              availableHoles.push(h);
            }
            for (let i = availableHoles.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [availableHoles[i], availableHoles[j]] = [availableHoles[j], availableHoles[i]];
            }
            let holeIdx = 0;
            trackOptions.forEach((opt, idx) => {
              const count = counts[idx];
              const countSel = document.getElementById(opt.countId);
              if (countSel) countSel.value = String(count);
              if (opt.pegsId && isFull) {
                const pegsSel = document.getElementById(opt.pegsId);
                if (pegsSel) pegsSel.value = String(Math.floor(Math.random() * 5) + 1);
              }
              const suffix = opt.holes && opt.holes.suffix || "Hole";
              for (let s = 1; s <= count; s++) {
                const sel = document.getElementById(`${opt.prefix}${s}${suffix}`);
                if (sel && holeIdx < availableHoles.length) {
                  sel.value = String(availableHoles[holeIdx++]);
                  sel.dataset.customized = "true";
                }
              }
              updateTrackItemRows(opt.key);
              for (let s = 1; s <= opt.maxCount; s++) {
                updateBadge(brand, opt.key, s);
              }
            });
            enforceBrandNoOverlap(brand);
            saveBrandSettings(brand, readBrandSettings(brand));
          } else if (config.randomizer.mode === "clashTactical") {
            if (typeof window.randomizeCribbageClashOptions === "function") {
              window.randomizeCribbageClashOptions(isFull);
            }
          }
        }
        function capitalize(str) {
          if (!str) return "";
          return str.charAt(0).toUpperCase() + str.slice(1);
        }
        function isCpuAllowed(brand) {
          const config = GAME_CONFIGS.getGame(brand);
          return config ? config.allowCpu !== false : true;
        }
        return {
          buildBrandSettingsUI,
          populateBrandHoleDropdowns,
          readBrandSettings,
          applyBrandSettings,
          saveBrandSettings,
          loadBrandSettings,
          getBrandActiveTrackItems,
          enforceBrandNoOverlap,
          randomizeBrandOptions,
          updateTrackItemRows,
          updateBadge,
          isCpuAllowed,
          updateSubgroupActiveBadges,
          toggleSubgroup,
          setAllSubgroupsExpanded,
          getCollapsedSubgroups,
          saveCollapsedSubgroups
        };
      });
    }
  });

  // src/index.js
  var index_exports = {};
  __export(index_exports, {
    ADULT_CUSTOM_LAYOUTS_KEY: () => ADULT_CUSTOM_LAYOUTS_KEY,
    ADULT_OPTIONS_DEFS: () => ADULT_OPTIONS_DEFS,
    ADULT_OPTIONS_LIST: () => ADULT_OPTIONS_LIST,
    ADULT_PRESETS_121: () => ADULT_PRESETS_121,
    ADULT_PRESET_KEYS: () => ADULT_PRESET_KEYS,
    ALLOWED_BOARD_TARGETS: () => ALLOWED_BOARD_TARGETS,
    AUTO_RECORD_KEY: () => AUTO_RECORD_KEY,
    AchievementManager: () => AchievementManager,
    AdultManager: () => AdultManager,
    AdultPresets: () => AdultPresets,
    AdultSettings: () => AdultSettings,
    AudioManager: () => AudioManager,
    AvatarManager: () => AvatarManager,
    BADGE_DEFINITIONS: () => BADGE_DEFINITIONS,
    BANTER_ITEMS: () => BANTER_ITEMS,
    BOARD_CFG: () => BOARD_CFG,
    BOARD_CFG_481: () => BOARD_CFG_481,
    BOARD_FINISHES: () => BOARD_FINISHES,
    BRAND_ALLOWED_TYPES: () => BRAND_ALLOWED_TYPES,
    BRAND_GAME_TITLES: () => BRAND_GAME_TITLES,
    BRAND_ITEM_PALETTES: () => BRAND_ITEM_PALETTES,
    BarAnimationOverlay: () => BarAnimationOverlay,
    Board3DCatalog: () => Board3DCatalog,
    BoardRenderer: () => BoardRenderer,
    BoardRenderer3D: () => BoardRenderer3D,
    BoardSelectorModal: () => BoardSelectorModal2,
    CARD_BACKS: () => CARD_BACKS,
    CHECK_IDS: () => CHECK_IDS,
    CLASH_CUSTOM_LAYOUTS_KEY: () => CLASH_CUSTOM_LAYOUTS_KEY,
    CLASH_DEFAULTS_241: () => CLASH_DEFAULTS_2412,
    CLASH_DEFAULTS_361: () => CLASH_DEFAULTS_3612,
    CLASH_DEFAULTS_481: () => CLASH_DEFAULTS_4812,
    CLASH_OBSTACLE_TYPES: () => CLASH_OBSTACLE_TYPES,
    CLASH_PRESETS_481: () => CLASH_PRESETS_481,
    CLASH_PRESET_KEYS: () => CLASH_PRESET_KEYS,
    CLASH_SIGN_DEFS: () => CLASH_SIGN_DEFS,
    CLASH_WHEEL_SLOTS: () => CLASH_WHEEL_SLOTS,
    CRAZY_OPTIONS_DEFS: () => CRAZY_OPTIONS_DEFS,
    CameraManager: () => CameraManager2,
    CanadianDoublesModal: () => CanadianDoublesModal,
    CannonAnimationOverlay: () => CannonAnimationOverlay,
    Card: () => Card2,
    CardAssassinOverlay: () => CardAssassinOverlay,
    CardEngine3D: () => CardEngine3D,
    CardMesh3D: () => CardMesh3D,
    CelebrationFX: () => CelebrationFX,
    ChatManager: () => ChatManager,
    ClashManager: () => ClashManager,
    ClashMiniGames: () => ClashMiniGames,
    ClashPlacementModal: () => ClashPlacementModal,
    ClashPresets: () => ClashPresets,
    ClashSandboxModal: () => ClashSandboxModal,
    ClashSettings: () => ClashSettings,
    CoachController: () => CoachController,
    CoachPostMortem: () => CoachPostMortem,
    CountingTrainer: () => CountingTrainer,
    CrazyCribbageApp: () => CrazyCribbageApp,
    CrazyManager: () => CrazyManager,
    CrazySettings: () => CrazySettings,
    CribbageAI: () => CribbageAI,
    CribbageScorer: () => CribbageScorer2,
    DEFAULT_3D_BOARDS: () => DEFAULT_3D_BOARDS,
    DEFAULT_AVATARS: () => DEFAULT_AVATARS,
    DEFAULT_SETTINGS: () => DEFAULT_SETTINGS,
    DROPDOWN_DESCRIPTIONS: () => DROPDOWN_DESCRIPTIONS,
    DailyPuzzleManager: () => DailyPuzzleManager,
    Deck: () => Deck2,
    DiscardTrainer: () => DiscardTrainer,
    DropdownHelpManager: () => DropdownHelpManager,
    GAME_BRANDS: () => GAME_BRANDS,
    GameEngine: () => GameEngine2,
    GameReplayManager: () => GameReplayManager,
    GameState: () => GameState,
    Hand: () => Hand,
    HandOfGloryCard: () => HandOfGloryCard,
    HandScoreTracker: () => HandScoreTracker,
    IndexedDBStorage: () => IndexedDBStorage,
    JailAnimationOverlay: () => JailAnimationOverlay,
    LayoutSanitizer: () => LayoutSanitizer,
    LobbyController: () => LobbyController,
    MAX_CUSTOM_LAYOUTS: () => MAX_CUSTOM_LAYOUTS,
    MAX_ITEMS_PER_LAYOUT: () => MAX_ITEMS_PER_LAYOUT,
    MAX_LAYOUT_JSON_LENGTH: () => MAX_LAYOUT_JSON_LENGTH,
    MAX_NAME_LENGTH: () => MAX_NAME_LENGTH,
    ModalManager: () => ModalManager2,
    NetworkManager: () => NetworkManager2,
    ObstacleGeometry: () => ObstacleGeometry,
    PEGGING_CATEGORIES: () => PEGGING_CATEGORIES,
    PEGGING_SCENARIOS: () => PEGGING_SCENARIOS,
    PEG_SKINS: () => PEG_SKINS,
    PINTS_CUSTOM_LAYOUTS_KEY: () => PINTS_CUSTOM_LAYOUTS_KEY,
    PINTS_DRINKING_DEFS: () => PINTS_DRINKING_DEFS,
    PINTS_OPTIONS_DEFS: () => PINTS_OPTIONS_DEFS,
    PINTS_PRESETS_121: () => PINTS_PRESETS_121,
    PINTS_PRESET_KEYS: () => PINTS_PRESET_KEYS,
    PRESET_AVATARS: () => PRESET_AVATARS,
    PegTracker: () => PegTracker,
    PeggingTrainer: () => PeggingTrainer,
    PintsManager: () => PintsManager,
    PintsPresets: () => PintsPresets,
    PintsSettings: () => PintsSettings,
    Player: () => Player,
    PlayerAvatar3D: () => PlayerAvatar3D,
    Profile: () => Profile,
    RANKS: () => RANKS,
    RANK_NAME: () => RANK_NAME,
    REACTION_ITEMS: () => REACTION_ITEMS,
    REPLAY_STORAGE_KEY: () => REPLAY_STORAGE_KEY,
    ROOM_CODE_CHARS: () => ROOM_CODE_CHARS,
    ReactionManager: () => ReactionManager,
    ReplayModal: () => ReplayModal,
    Room3DLoadingOverlay: () => Room3DLoadingOverlay2,
    RoomCatalog3D: () => RoomCatalog3D,
    Roster: () => Roster,
    SEAT_COLORS: () => SEAT_COLORS,
    SERIES_MODES: () => SERIES_MODES,
    SIGN_DEFS: () => SIGN_DEFS,
    SIGN_PRIORITY: () => SIGN_PRIORITY,
    STORAGE_KEY_AVATAR: () => STORAGE_KEY_AVATAR,
    STORAGE_KEY_CUSTOM_3D_BOARDS: () => STORAGE_KEY_CUSTOM_3D_BOARDS,
    STORAGE_KEY_DAILY_PUZZLE: () => STORAGE_KEY_DAILY_PUZZLE,
    STORAGE_KEY_DISCARD_TRAINER: () => STORAGE_KEY_DISCARD_TRAINER,
    STORAGE_KEY_NAME: () => STORAGE_KEY_NAME,
    STORAGE_KEY_PEGGING_TRAINER: () => STORAGE_KEY_PEGGING_TRAINER,
    STORAGE_KEY_PROFILE: () => STORAGE_KEY_PROFILE,
    SUITS: () => SUITS,
    SUIT_NAME: () => SUIT_NAME,
    SUIT_SYM: () => SUIT_SYM,
    SYSTEM_TYPE_METADATA: () => SYSTEM_TYPE_METADATA,
    Sanitizer: () => Sanitizer,
    ScenicRouteAnimationOverlay: () => ScenicRouteAnimationOverlay,
    SeatManager3D: () => SeatManager3D,
    SeriesTracker: () => SeriesTracker,
    SettingsManager: () => SettingsManager,
    ShowModal: () => ShowModal,
    SpeedTrapAnimationOverlay: () => SpeedTrapAnimationOverlay,
    THEMES: () => THEMES,
    TOURNAMENT_FORMATS: () => TOURNAMENT_FORMATS,
    TOURNAMENT_SERIES_MODES: () => TOURNAMENT_SERIES_MODES,
    TYPE_ALIASES: () => TYPE_ALIASES,
    TableRenderer: () => TableRenderer,
    TournamentManager: () => TournamentManager,
    TournamentModal: () => TournamentModal,
    TraditionalCard: () => TraditionalCard,
    UIController: () => UIController,
    VAL: () => VAL2,
    WHEEL_SLOTS: () => WHEEL_SLOTS,
    appStorage: () => appStorage,
    areVariantPlayerRequirementsCompatible: () => areVariantPlayerRequirementsCompatible,
    buildClashItemMetadata: () => buildClashItemMetadata,
    combinations: () => combinations,
    getActiveTracks: () => getActiveTracks,
    getClashBoardCfg: () => getClashBoardCfg,
    getClashDefaults: () => getClashDefaults2,
    getDOMPurify: () => getDOMPurify,
    getJumpTriggerLength: () => getJumpTriggerLength,
    getSkunkDefaults: () => getSkunkDefaults2,
    getTrackOffset: () => getTrackOffset,
    getTrackXY: () => getTrackXY,
    getVariantRequiredPlayers: () => getVariantRequiredPlayers,
    initSanitizer: () => initSanitizer,
    installInnerHtmlHook: () => installInnerHtmlHook,
    installUserInputHook: () => installUserInputHook,
    isConsecutiveRun: () => isConsecutiveRun,
    isInBunker: () => isInBunker,
    isInLast5PegOut: () => isInLast5PegOut,
    isInNoPassingLane: () => isInNoPassingLane,
    isInPegThroughZone: () => isInPegThroughZone,
    isInStinkHole: () => isInStinkHole,
    isPlayerCountAllowedForVariant: () => isPlayerCountAllowedForVariant,
    isSpadeCard: () => isSpadeCard,
    sanitizeHtml: () => sanitizeHtml,
    sanitizeUserInput: () => sanitizeUserInput,
    skunkResult: () => skunkResult,
    streetName: () => streetName
  });

  // src/scoring/ScoringConstants.js
  var RANKS = Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]);
  var RANK_NAME = Object.freeze({
    1: "A",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    10: "10",
    11: "J",
    12: "Q",
    13: "K"
  });
  var SUITS = Object.freeze(["S", "H", "D", "C"]);
  var SUIT_SYM = Object.freeze({
    S: "\u2660",
    H: "\u2665",
    D: "\u2666",
    C: "\u2663"
  });
  var SUIT_NAME = Object.freeze({
    S: "Spades",
    H: "Hearts",
    D: "Diamonds",
    C: "Clubs"
  });
  var VAL2 = (r) => r >= 10 ? 10 : r <= 0 ? 0 : r;

  // src/models/Card.js
  var Card2 = class _Card {
    constructor(data = {}, suit = null) {
      if (typeof data === "number" || typeof data === "string" && !isNaN(Number(data)) && data !== "") {
        data = { r: Number(data), s: suit || "S" };
      }
      this.id = String(data.id || (data.r && data.s ? `${data.r}${data.s}` : ""));
      this.r = Number(data.r || 0);
      this.s = String(data.s || "S").toUpperCase();
      this.wild = Boolean(data.wild);
      this.playAs = data.playAs ? { r: Number(data.playAs.r), s: String(data.playAs.s).toUpperCase() } : null;
      this.masked = Boolean(data.masked);
      this.pegBadge = data.pegBadge ? String(data.pegBadge) : null;
      this.pegBadgeBonus = Boolean(data.pegBadgeBonus);
    }
    get rank() {
      return this.playAs && this.playAs.r ? this.playAs.r : this.r;
    }
    get rawRank() {
      return this.r;
    }
    get suit() {
      return this.playAs && this.playAs.s ? this.playAs.s : this.s;
    }
    get rawSuit() {
      return this.s;
    }
    get val() {
      return VAL2(this.rank);
    }
    get isWild() {
      return this.wild;
    }
    get isAssignedWild() {
      return this.wild && Boolean(this.playAs);
    }
    get isRed() {
      const s = this.suit;
      return s === "H" || s === "D";
    }
    get isBlack() {
      const s = this.suit;
      return s === "S" || s === "C";
    }
    get suitSymbol() {
      return SUIT_SYM[this.suit] || "";
    }
    get rankName() {
      return RANK_NAME[this.rank] || (this.wild ? "\u2605" : "?");
    }
    get label() {
      if (this.wild && !this.playAs) return "Joker";
      return (RANK_NAME[this.rank] || "?") + (SUIT_SYM[this.suit] || "");
    }
    fits(currentCount = 0) {
      if (this.wild && !this.playAs) return currentCount <= 30;
      return currentCount + this.val <= 31;
    }
    assignWild(r, s) {
      this.playAs = { r: Number(r), s: String(s || this.s).toUpperCase() };
      return this;
    }
    resetWild() {
      this.playAs = null;
      return this;
    }
    clone() {
      return new _Card({
        id: this.id,
        r: this.r,
        s: this.s,
        wild: this.wild,
        playAs: this.playAs ? { ...this.playAs } : null,
        masked: this.masked,
        pegBadge: this.pegBadge,
        pegBadgeBonus: this.pegBadgeBonus
      });
    }
    toPlain() {
      return {
        id: this.id,
        r: this.r,
        s: this.s,
        wild: this.wild,
        playAs: this.playAs ? { ...this.playAs } : null,
        masked: this.masked,
        pegBadge: this.pegBadge,
        pegBadgeBonus: this.pegBadgeBonus
      };
    }
    static from(obj) {
      if (!obj) return null;
      if (obj instanceof _Card) return obj;
      return new _Card(obj);
    }
  };

  // src/models/Deck.js
  var Deck2 = class _Deck {
    constructor(options = {}) {
      this.deckCount = Number(options.decks || 1);
      this.includeJokers = Boolean(options.jokers);
      this.cards = [];
      this.reset();
    }
    reset() {
      this.cards = [];
      for (let pack = 0; pack < this.deckCount; pack++) {
        for (const su of SUITS) {
          for (const r of RANKS) {
            this.cards.push(new Card2({
              r,
              s: su,
              id: `${r}${su}#${pack}`
            }));
          }
        }
        if (this.includeJokers) {
          this.cards.push(new Card2({ r: 0, s: "J", id: `W${pack}a`, wild: true }));
          this.cards.push(new Card2({ r: 0, s: "J", id: `W${pack}b`, wild: true }));
        }
      }
      return this;
    }
    shuffle() {
      _Deck.shuffleArray(this.cards);
      return this;
    }
    draw(count = 1) {
      if (count <= 1) return this.cards.pop() || null;
      const drawn = [];
      for (let i = 0; i < count; i++) {
        const c = this.cards.pop();
        if (c) drawn.push(c);
      }
      return drawn;
    }
    deal(count = 1) {
      return this.draw(count);
    }
    cut(index) {
      if (!this.cards.length) return null;
      const idx = Math.max(0, Math.min(this.cards.length - 1, index != null ? index : Math.floor(this.cards.length / 2)));
      return this.cards[idx];
    }
    pop() {
      return this.cards.pop();
    }
    splice(start, deleteCount, ...items) {
      return this.cards.splice(start, deleteCount, ...items);
    }
    get remaining() {
      return this.cards.length;
    }
    get length() {
      return this.cards.length;
    }
    toPlain() {
      return this.cards.map((c) => c.toPlain());
    }
    static shuffleArray(a) {
      if (!Array.isArray(a)) return a;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    }
    static makeDeck(nDecks = 1, jokers = false) {
      const d = new _Deck({ decks: nDecks, jokers });
      return d.cards;
    }
  };

  // src/models/Hand.js
  var Hand = class _Hand {
    constructor(cards = []) {
      this.cards = [];
      if (Array.isArray(cards)) {
        this.add(cards);
      }
    }
    get length() {
      return this.cards.length;
    }
    get isEmpty() {
      return this.cards.length === 0;
    }
    add(cardOrCards) {
      if (!cardOrCards) return this;
      if (Array.isArray(cardOrCards)) {
        for (const item of cardOrCards) {
          if (item) this.cards.push(Card2.from(item));
        }
      } else {
        this.cards.push(Card2.from(cardOrCards));
      }
      return this;
    }
    remove(cardId) {
      const idx = this.cards.findIndex((c) => c.id === cardId);
      if (idx >= 0) {
        return this.cards.splice(idx, 1)[0];
      }
      return null;
    }
    findById(cardId) {
      return this.cards.find((c) => c.id === cardId) || null;
    }
    sort() {
      this.cards.sort((a, b) => a.r - b.r || SUITS.indexOf(a.s) - SUITS.indexOf(b.s));
      return this;
    }
    getPlayableCards(currentCount = 0) {
      return this.cards.filter((c) => c.fits(currentCount));
    }
    hasPlayableCard(currentCount = 0) {
      return this.cards.some((c) => c.fits(currentCount));
    }
    totalNominalValue() {
      return this.cards.reduce((sum, c) => sum + c.val, 0);
    }
    clear() {
      this.cards = [];
      return this;
    }
    clone() {
      return new _Hand(this.cards.map((c) => c.clone()));
    }
    [Symbol.iterator]() {
      return this.cards[Symbol.iterator]();
    }
    forEach(fn) {
      return this.cards.forEach(fn);
    }
    map(fn) {
      return this.cards.map(fn);
    }
    filter(fn) {
      return this.cards.filter(fn);
    }
    some(fn) {
      return this.cards.some(fn);
    }
    every(fn) {
      return this.cards.every(fn);
    }
    find(fn) {
      return this.cards.find(fn);
    }
    findIndex(fn) {
      return this.cards.findIndex(fn);
    }
    slice(start, end) {
      return this.cards.slice(start, end);
    }
    pop() {
      return this.cards.pop();
    }
    splice(start, deleteCount, ...items) {
      return this.cards.splice(start, deleteCount, ...items);
    }
    toPlain() {
      return this.cards.map((c) => c.toPlain());
    }
    static sort(cards = []) {
      return cards.slice().sort((a, b) => {
        const ar = a && (a.r !== void 0 ? a.r : a.rank) || 0;
        const br = b && (b.r !== void 0 ? b.r : b.rank) || 0;
        const as = a && (a.s || a.suit) || "S";
        const bs = b && (b.s || b.suit) || "S";
        return ar - br || SUITS.indexOf(as) - SUITS.indexOf(bs);
      });
    }
  };

  // src/models/Player.js
  var SEAT_COLORS = Object.freeze({
    p1: "#d4a017",
    p2: "#ef4444",
    p3: "#10b981",
    p4: "#3b82f6",
    p5: "#a855f7",
    p6: "#ec4899",
    p7: "#f97316",
    p8: "#06b6d4",
    you: "#d4a017",
    cpu: "#ef4444",
    team1: "#d4a017",
    team2: "#ef4444",
    team3: "#10b981",
    team4: "#3b82f6"
  });
  var Player = class {
    constructor(data = {}) {
      Object.assign(this, data);
      this.id = String(data.id || "p1");
      this.name = String(data.name || this.id.toUpperCase());
      this.type = data.type === "cpu" ? "cpu" : "human";
      this.personality = data.personality || "shark";
      this.team = data.team || null;
      this.color = data.color || SEAT_COLORS[this.id] || "#d4a017";
      this.score = Number(data.score || 0);
      this.prevScore = Number(data.prevScore || 0);
      this.hand = data.hand instanceof Hand ? data.hand : new Hand(data.hand);
      this.kept = data.kept instanceof Hand ? data.kept : new Hand(data.kept);
      this.cutCard = data.cutCard || null;
    }
    get isCpu() {
      return this.type === "cpu";
    }
    get isHuman() {
      return this.type === "human";
    }
    resetForNewRound() {
      this.hand.clear();
      this.kept.clear();
      this.cutCard = null;
    }
    addScore(points) {
      this.prevScore = this.score;
      this.score += points;
      return this.score;
    }
    toPlain() {
      return {
        id: this.id,
        name: this.name,
        type: this.type,
        personality: this.personality,
        team: this.team,
        color: this.color,
        score: this.score,
        prevScore: this.prevScore,
        hand: this.hand.toPlain(),
        kept: this.kept.toPlain(),
        cutCard: this.cutCard
      };
    }
  };

  // src/models/Roster.js
  var Roster = class _Roster {
    constructor(options = {}) {
      this.playerCount = Number(options.playerCount || 2);
      this.gameMode = options.gameMode || "solo";
      this.players = /* @__PURE__ */ new Map();
      this.init(options);
    }
    static normalizeSeat(seatId) {
      if (!seatId) return "p1";
      if (typeof seatId === "object") {
        return seatId.id && typeof seatId.id === "string" && !seatId.id.includes("[object") ? seatId.id : "p1";
      }
      if (seatId === "you") return "p1";
      if (seatId === "cpu") return "p2";
      const str = String(seatId);
      return str.includes("[object") ? "p1" : str;
    }
    init(options = {}) {
      this.players.clear();
      const count = this.playerCount;
      const isHvH2 = options.isHvH || false;
      const isOnline2 = options.isOnline || false;
      if (Array.isArray(options.seats) && options.seats.length > 0) {
        for (const s of options.seats.slice(0, count)) {
          if (!s) continue;
          const sId = _Roster.normalizeSeat(s.id);
          const player = s instanceof Player ? s : new Player({
            ...s,
            id: sId,
            team: s.team || this.getTeamForSeat(sId, count, this.gameMode),
            color: s.color || SEAT_COLORS[sId]
          });
          this.players.set(sId, player);
        }
        return;
      }
      for (let i = 1; i <= count; i++) {
        const sId = `p${i}`;
        let defaultName = `Player ${i}`;
        let type = "human";
        if (i === 1) {
          defaultName = isHvH2 ? "Player 1" : "You";
        } else if (i === 2) {
          defaultName = isHvH2 ? "Player 2" : isOnline2 ? "Opponent" : "Computer";
          type = isHvH2 || isOnline2 ? "human" : "cpu";
        }
        this.players.set(sId, new Player({
          id: sId,
          name: options.names && options.names[sId] || defaultName,
          type: options.types && options.types[sId] || type,
          team: this.getTeamForSeat(sId, count, this.gameMode),
          color: SEAT_COLORS[sId]
        }));
      }
    }
    static fromSeats(seats, options = {}) {
      const count = options && options.playerCount || (Array.isArray(seats) ? seats.length : 2);
      return new _Roster({ ...options, playerCount: count, seats });
    }
    getPlayer(seatId) {
      const sId = _Roster.normalizeSeat(seatId);
      return this.players.get(sId) || null;
    }
    getActiveSeatIds() {
      return Array.from(this.players.keys());
    }
    getActivePlayers() {
      return Array.from(this.players.values());
    }
    getNextSeat(fromSeatId) {
      const ids = this.getActiveSeatIds();
      if (!ids.length) return "p1";
      const current = _Roster.normalizeSeat(fromSeatId);
      const idx = ids.indexOf(current);
      if (idx < 0) return ids[0];
      return ids[(idx + 1) % ids.length];
    }
    isPartnership() {
      return ["pairs", "trios", "quads"].includes(this.gameMode) || this.playerCount >= 4;
    }
    getTeamForSeat(seatId, count = this.playerCount, mode = this.gameMode) {
      const sId = _Roster.normalizeSeat(seatId);
      if (!["pairs", "trios", "quads"].includes(mode) && count === 2) {
        return sId;
      }
      if (count === 3) {
        return sId === "p1" ? "team1" : "team2";
      }
      if (count === 4) {
        return sId === "p1" || sId === "p3" ? "team1" : "team2";
      }
      if (count === 5) {
        if (sId === "p1") return "team1";
        if (sId === "p2" || sId === "p4") return "team2";
        return "team3";
      }
      if (count === 6) {
        if (sId === "p1" || sId === "p4") return "team1";
        if (sId === "p2" || sId === "p5") return "team2";
        return "team3";
      }
      if (count === 8) {
        if (sId === "p1" || sId === "p5") return "team1";
        if (sId === "p2" || sId === "p6") return "team2";
        if (sId === "p3" || sId === "p7") return "team3";
        return "team4";
      }
      return sId;
    }
    getSeatName(seatId) {
      if (!seatId) return "Player";
      if (seatId === "crib") return "The Crib";
      const sId = _Roster.normalizeSeat(seatId);
      const p = this.players.get(sId);
      return p && p.name || sId.toUpperCase();
    }
    getPlayerDisplayName(who) {
      if (!who) return "Player";
      if (who === "team1") {
        if (this.playerCount === 4) return "Team 1 (P1 & P3)";
        if (this.playerCount === 6) return "Team 1 (P1 & P4)";
        if (this.playerCount === 8) return "Team 1 (P1 & P5)";
        return "Team 1";
      }
      if (who === "team2") {
        if (this.playerCount === 3) return `Pair (${this.getSeatName("p2")} & ${this.getSeatName("p3")})`;
        if (this.playerCount === 4) return "Team 2 (P2 & P4)";
        if (this.playerCount === 6) return "Team 2 (P2 & P5)";
        if (this.playerCount === 8) return "Team 2 (P2 & P6)";
        return "Team 2";
      }
      if (who === "team3") {
        if (this.playerCount === 6) return "Team 3 (P3 & P6)";
        if (this.playerCount === 8) return "Team 3 (P3 & P7)";
        return "Team 3";
      }
      if (who === "team4") {
        return "Team 4 (P4 & P8)";
      }
      return this.getSeatName(who);
    }
    static seatName(seatId, context = {}) {
      if (!seatId) return "Player";
      if (typeof seatId === "object" && !seatId.id) return "Player";
      if (seatId === "crib") return "The Crib";
      const sId = _Roster.normalizeSeat(seatId);
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const getSeat2 = context.getSeat || (typeof window !== "undefined" && window.getSeat ? window.getSeat : _Roster.getSeat);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const isHvH2 = context.isHvH || (typeof window !== "undefined" ? window.isHvH : () => false);
      const s = getSeat2(sId, context);
      if (isOnline2()) {
        if (sId === mySeat3()) {
          return s && s.name && s.name !== "You" && s.name !== "Guest" ? `${s.name} (You)` : "You";
        }
        return s && s.name ? s.name : "Opponent";
      }
      if (!settings3 || (parseInt(settings3.playerCount, 10) || 2) === 2) {
        if (sId === "p1") return s && s.name && s.name !== "You" ? s.name : isHvH2() ? "Player 1" : "You";
        if (sId === "p2") return s && s.name && s.name !== "Player 2" && s.name !== "cpu" && s.name !== "Computer" ? s.name : isHvH2() ? "Player 2" : s && s.name || "Computer";
      }
      return s && s.name || (typeof sId === "string" ? sId.toUpperCase() : "Player");
    }
    static pName(who, context = {}) {
      if (!who) return "Player";
      const seatName3 = context.seatName || (typeof window !== "undefined" && typeof window.seatName === "function" ? window.seatName : _Roster.seatName);
      const isSoloVsPairs2 = context.isSoloVsPairs || (typeof window !== "undefined" ? window.isSoloVsPairs : () => false);
      const is3Player1vs22 = context.is3Player1vs2 || (typeof window !== "undefined" ? window.is3Player1vs2 : () => false);
      const is5Player1vs42 = context.is5Player1vs4 || (typeof window !== "undefined" ? window.is5Player1vs4 : () => false);
      const is7Player1vs62 = context.is7Player1vs6 || (typeof window !== "undefined" ? window.is7Player1vs6 : () => false);
      const getPlayerCount2 = context.getPlayerCount || (typeof window !== "undefined" ? window.getPlayerCount : () => 2);
      if (who === "team1") {
        if (isSoloVsPairs2()) return `${seatName3("p1", context)} (Solo)`;
        const count = getPlayerCount2();
        if (count === 4) return "Team 1 (P1 & P3)";
        if (count === 6) return "Team 1 (P1 & P4)";
        if (count === 8) return "Team 1 (P1 & P5)";
        return "Team 1";
      }
      if (who === "team2") {
        if (is3Player1vs22()) return `Pair (${seatName3("p2", context)} & ${seatName3("p3", context)})`;
        if (is5Player1vs42()) return `Pair 1 (${seatName3("p2", context)} & ${seatName3("p4", context)})`;
        if (is7Player1vs62()) return `Pair 1 (${seatName3("p2", context)} & ${seatName3("p5", context)})`;
        const count = getPlayerCount2();
        if (count === 4) return "Team 2 (P2 & P4)";
        if (count === 6) return "Team 2 (P2 & P5)";
        if (count === 8) return "Team 2 (P2 & P6)";
        return "Team 2";
      }
      if (who === "team3") {
        if (is5Player1vs42()) return `Pair 2 (${seatName3("p3", context)} & ${seatName3("p5", context)})`;
        if (is7Player1vs62()) return `Pair 2 (${seatName3("p3", context)} & ${seatName3("p6", context)})`;
        const count = getPlayerCount2();
        if (count === 6) return "Team 3 (P3 & P6)";
        if (count === 8) return "Team 3 (P3 & P7)";
        return "Team 3";
      }
      if (who === "team4") {
        if (is7Player1vs62()) return `Pair 3 (${seatName3("p4", context)} & ${seatName3("p7", context)})`;
        return "Team 4 (P4 & P8)";
      }
      return seatName3(who, context);
    }
    static getSeatTeam(seatId, context = {}) {
      const sId = _Roster.normalizeSeat(seatId);
      const is3Player1vs22 = context.is3Player1vs2 || (typeof window !== "undefined" ? window.is3Player1vs2 : () => false);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (is3Player1vs22()) {
        return sId === "p1" ? "team1" : "team2";
      }
      const count = settings3 && settings3.playerCount || 2;
      if (count === 5 && settings3 && settings3.gameMode === "shifting") {
        if (sId === "p1") return "team1";
        if (sId === "p2" || sId === "p4") return "team2";
        if (sId === "p3" || sId === "p5") return "team3";
      }
      if (count === 7 && settings3 && settings3.gameMode === "shifting") {
        if (sId === "p1") return "team1";
        if (sId === "p2" || sId === "p5") return "team2";
        if (sId === "p3" || sId === "p6") return "team3";
        if (sId === "p4" || sId === "p7") return "team4";
      }
      if (count === 4) {
        if (sId === "p1" || sId === "p3") return "team1";
        if (sId === "p2" || sId === "p4") return "team2";
      } else if (count === 6) {
        if (sId === "p1" || sId === "p4") return "team1";
        if (sId === "p2" || sId === "p5") return "team2";
        if (sId === "p3" || sId === "p6") return "team3";
      } else if (count === 8) {
        if (sId === "p1" || sId === "p5") return "team1";
        if (sId === "p2" || sId === "p6") return "team2";
        if (sId === "p3" || sId === "p7") return "team3";
        if (sId === "p4" || sId === "p8") return "team4";
      }
      return sId === "p1" || sId === "p3" || sId === "p5" || sId === "p7" ? "team1" : "team2";
    }
    static getSeat(seatId, context = {}) {
      let sId = _Roster.normalizeSeat(seatId);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3 && Array.isArray(settings3.seats)) {
        const found = settings3.seats.find((s) => s && s.id === sId);
        if (found && found.name) return found;
      }
      const getRoster2 = context.getRoster || (typeof window !== "undefined" ? window.getRoster : null);
      const r = typeof getRoster2 === "function" ? getRoster2() : null;
      if (r && typeof r.getPlayer === "function") {
        const p = r.getPlayer(sId);
        if (p) return p;
      }
      return (settings3 && settings3.seats || []).find((s) => s && s.id === sId) || { id: sId, name: sId, type: "cpu" };
    }
    static prevSeat(seatId, activeSeats = null) {
      const sId = _Roster.normalizeSeat(seatId);
      const active2 = activeSeats || (typeof window !== "undefined" && typeof window.getActiveSeatIds === "function" ? window.getActiveSeatIds() : ["p1", "p2"]);
      const idx = active2.indexOf(sId);
      if (idx < 0) return active2[0] || "p1";
      return active2[(idx - 1 + active2.length) % active2.length];
    }
    static seatColor(seatId) {
      if (seatId === "p1" || seatId === "you" || seatId === "team1") return "#d4a017";
      if (seatId === "p2" || seatId === "cpu" || seatId === "team2") return "#ef4444";
      if (seatId === "p3") return "#10b981";
      if (seatId === "p4") return "#3b82f6";
      if (seatId === "p5") return "#a855f7";
      if (seatId === "p6") return "#f97316";
      if (seatId === "p7" || seatId === "team3") return "#06b6d4";
      if (seatId === "p8" || seatId === "team4") return "#ec4899";
      return "#d4a017";
    }
    static getShiftingRoles(context = {}) {
      const isShiftingPartnership2 = context.isShiftingPartnership || (typeof window !== "undefined" ? window.isShiftingPartnership : () => false);
      if (!isShiftingPartnership2()) return null;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => []);
      const active2 = getActiveSeatIds2();
      const d = state3 && state3.dealer ? state3.dealer : active2[0];
      const dIdx = active2.indexOf(d);
      const others = [];
      for (let i = 1; i < active2.length; i++) {
        others.push(active2[(dIdx + i) % active2.length]);
      }
      const half = others.length / 2;
      const pairs = [];
      for (let i = 0; i < half; i++) {
        pairs.push([others[i], others[i + half]]);
      }
      return { lone: d, pairs };
    }
    static getShiftingPartner(seatId, context = {}) {
      const getShiftingRoles2 = context.getShiftingRoles || _Roster.getShiftingRoles;
      const roles = getShiftingRoles2(context);
      if (!roles) return null;
      let sId = _Roster.normalizeSeat(seatId);
      if (sId === roles.lone) return null;
      for (const pair of roles.pairs) {
        if (pair[0] === sId) return pair[1];
        if (pair[1] === sId) return pair[0];
      }
      return null;
    }
    static isTwoHuman(context = {}) {
      const isHvH2 = context.isHvH || (typeof window !== "undefined" && window.isHvH ? window.isHvH : () => false);
      const isOnline2 = context.isOnline || (typeof window !== "undefined" && window.isOnline ? window.isOnline : () => false);
      return isHvH2() || isOnline2();
    }
    static isSoloVsPairs(settings3 = typeof window !== "undefined" ? window.settings : null) {
      if (!settings3) return false;
      const pCount = parseInt(settings3.playerCount, 10) || 2;
      return settings3.gameMode === "shifting" && (pCount === 3 || pCount === 5 || pCount === 7);
    }
    static is3Player1vs2(settings3 = typeof window !== "undefined" ? window.settings : null) {
      if (!settings3) return false;
      const pCount = parseInt(settings3.playerCount, 10) || 2;
      return pCount === 3 && (settings3.gameMode === "shifting" || settings3.gameMode === "1vs2");
    }
    static is5Player1vs4(settings3 = typeof window !== "undefined" ? window.settings : null) {
      if (!settings3) return false;
      const pCount = parseInt(settings3.playerCount, 10) || 2;
      return pCount === 5 && settings3.gameMode === "shifting";
    }
    static is7Player1vs6(settings3 = typeof window !== "undefined" ? window.settings : null) {
      if (!settings3) return false;
      const pCount = parseInt(settings3.playerCount, 10) || 2;
      return pCount === 7 && settings3.gameMode === "shifting";
    }
    static isFixedTeams(settings3 = typeof window !== "undefined" ? window.settings : null) {
      if (!settings3) return false;
      const pCount = parseInt(settings3.playerCount, 10) || 2;
      return _Roster.isSoloVsPairs(settings3) || Boolean(settings3.optCanadianDoubles && pCount === 4) || pCount === 4 && settings3.gameMode === "partnership" || pCount === 6 && settings3.gameMode === "teams" || pCount === 8 && settings3.gameMode === "teams";
    }
    static isPartnership(settings3 = typeof window !== "undefined" ? window.settings : null) {
      return _Roster.isFixedTeams(settings3);
    }
    static isShiftingPartnership(settings3 = typeof window !== "undefined" ? window.settings : null) {
      return false;
    }
    static mySeat(context = {}) {
      const isOnline2 = context.isOnline || (typeof window !== "undefined" && window.isOnline ? window.isOnline : () => false);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (isOnline2()) {
        return net2 && net2.mySeatId || (settings3 && settings3.netRole === "guest" ? "p2" : "p1");
      }
      return "p1";
    }
    static getPlayerCount(settings3 = typeof window !== "undefined" ? window.settings : null) {
      return settings3 && settings3.playerCount || 2;
    }
    static getActiveSeats(settings3 = typeof window !== "undefined" ? window.settings : null) {
      const count = _Roster.getPlayerCount(settings3);
      if (settings3 && Array.isArray(settings3.seats)) {
        return settings3.seats.slice(0, count);
      }
      if (settings3 && settings3.seats && typeof settings3.seats === "object") {
        return Object.values(settings3.seats).slice(0, count);
      }
      return [];
    }
    static getActiveSeatIds(context = {}) {
      const r = (typeof context.getRoster === "function" ? context.getRoster() : null) || (typeof window !== "undefined" && typeof window.getRoster === "function" ? window.getRoster() : null);
      if (r && typeof r.getActiveSeatIds === "function") {
        return r.getActiveSeatIds();
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      return _Roster.getActiveSeats(settings3).map((s) => s.id);
    }
    static isSeatCpu(seatId, context = {}) {
      if (!seatId || typeof seatId !== "string") return false;
      let sId = _Roster.normalizeSeat(seatId);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3 && Array.isArray(settings3.seats)) {
        const s2 = settings3.seats.find((x) => x && x.id === sId);
        if (s2 && s2.type) return s2.type === "cpu";
      } else if (settings3 && settings3.seats && typeof settings3.seats === "object") {
        const s2 = settings3.seats[sId];
        if (s2 && s2.type) return s2.type === "cpu";
      }
      const isTwoHuman2 = context.isTwoHuman || (typeof window !== "undefined" && window.isTwoHuman ? window.isTwoHuman : () => false);
      if (!settings3 || (parseInt(settings3.playerCount, 10) || 2) === 2) {
        return !isTwoHuman2() && sId === "p2";
      }
      const getSeat2 = context.getSeat || (typeof window !== "undefined" && window.getSeat ? window.getSeat : _Roster.getSeat);
      const s = getSeat2(sId, context);
      return s ? s.type === "cpu" : false;
    }
    static isSeatHuman(seatId, context = {}) {
      if (!seatId || typeof seatId !== "string") return false;
      return !_Roster.isSeatCpu(seatId, context);
    }
    static scoreKey(who, context = {}) {
      const isFixedTeams2 = context.isFixedTeams || _Roster.isFixedTeams;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (isFixedTeams2(settings3)) {
        const getSeatTeam2 = context.getSeatTeam || (typeof window !== "undefined" && window.getSeatTeam ? window.getSeatTeam : _Roster.getSeatTeam);
        return getSeatTeam2(who, context);
      }
      if (who === "you") return "p1";
      if (who === "cpu") return "p2";
      return who;
    }
    static getRoster(context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const count = _Roster.getPlayerCount(settings3);
      const mode = settings3 && settings3.gameMode || "solo";
      const win = typeof window !== "undefined" ? window : {};
      if (!win._currentRoster || win._currentRoster.playerCount !== count || win._currentRoster.gameMode !== mode) {
        const isHvHMode = typeof context.isHvH === "function" ? context.isHvH() : typeof win.isHvH === "function" ? win.isHvH() : false;
        const isOnlineMode = typeof context.isOnline === "function" ? context.isOnline() : typeof win.isOnline === "function" ? win.isOnline() : false;
        const seats = settings3 && settings3.seats || [];
        win._currentRoster = new _Roster({
          playerCount: count,
          gameMode: mode,
          isHvH: isHvHMode,
          isOnline: isOnlineMode,
          seats
        });
      }
      return win._currentRoster;
    }
  };

  // src/scoring/CribbageScorer.js
  function combinations(arr, k) {
    const out = [];
    const rec = (start, path) => {
      if (path.length === k) {
        out.push(path.slice());
        return;
      }
      for (let i = start; i < arr.length; i++) {
        path.push(arr[i]);
        rec(i + 1, path);
        path.pop();
      }
    };
    rec(0, []);
    return out;
  }
  function isConsecutiveRun(rs, allowWrap = false) {
    const n = rs.length;
    if (n < 3) return false;
    const set = new Set(rs);
    if (set.size !== n) return false;
    if (!allowWrap) {
      const sorted = rs.slice().sort((a, b) => a - b);
      for (let i = 1; i < sorted.length; i++) {
        if (sorted[i] !== sorted[i - 1] + 1) return false;
      }
      return true;
    }
    for (const start of set) {
      const prev = start === 1 ? 13 : start - 1;
      if (!set.has(prev)) {
        let ok = true;
        let curr = start;
        for (let step = 1; step < n; step++) {
          curr = curr === 13 ? 1 : curr + 1;
          if (!set.has(curr)) {
            ok = false;
            break;
          }
        }
        if (ok) return true;
      }
    }
    return false;
  }
  function cardRank(c) {
    return c && c.playAs && c.playAs.r || (c ? c.r !== void 0 ? c.r : c.rank !== void 0 ? c.rank : 0 : 0);
  }
  function cardSuit(c) {
    return c && c.playAs && c.playAs.s || (c ? c.s !== void 0 ? c.s : c.suit !== void 0 ? c.suit : "S" : "S");
  }
  function isSpadeCard(c) {
    if (!c) return false;
    const raw = c.playAs && c.playAs.s || c.s || c.suit || "";
    const s = String(raw).trim().toLowerCase();
    return s === "s" || s.startsWith("spade") || s === "\u2660";
  }
  function isCardWild(c, isCrib = false) {
    if (!c || !c.wild && !c.isWild) return false;
    if (isCrib) return true;
    return !c.playAs;
  }
  var CribbageScorer2 = class _CribbageScorer {
    /**
     * Evaluates if a slice of played cards forms a valid single or multiple run.
     * @param {Array<Object>} slice
     * @param {boolean} [allowWrap=false]
     * @param {boolean} [allowMultiple=false]
     * @returns {Object|null}
     */
    static evaluateRunSlice(slice, allowWrap = false, allowMultiple = false) {
      if (!slice || slice.length < 3) return null;
      const rs = slice.map((c) => cardRank(c));
      const byRank = {};
      for (const r of rs) {
        if (r === 0 || r === void 0) return null;
        byRank[r] = (byRank[r] || 0) + 1;
      }
      const uniqueRanks = Object.keys(byRank).map(Number);
      const seqLen = uniqueRanks.length;
      if (seqLen < 3) return null;
      let prod = 1;
      for (const r of uniqueRanks) {
        prod *= byRank[r];
      }
      if (prod > 1 && !allowMultiple) {
        return null;
      }
      if (!isConsecutiveRun(uniqueRanks, allowWrap)) {
        return null;
      }
      let why = "run of " + seqLen;
      if (prod === 2) why = "double run of " + seqLen;
      else if (prod === 3) why = "triple run of " + seqLen;
      else if (prod === 4) why = "quadruple run of " + seqLen;
      else if (prod > 4) why = prod + "x run of " + seqLen;
      return {
        len: slice.length,
        seqLen,
        prod,
        points: seqLen * prod,
        why
      };
    }
    /**
     * Score pegging points for the latest card played on a pile.
     */
    static scorePegging(pile, options = {}) {
      if (!pile || !pile.length) return [];
      const pts = [];
      const count = pile.reduce((s, c) => s + VAL2(cardRank(c)), 0);
      if (count === 15) pts.push({ n: 2, why: "fifteen" });
      if (count === 19 && options.opt19sFor2) pts.push({ n: 2, why: "nineteen" });
      if (count === 31) pts.push({ n: options.opt31sFor5 ? 5 : 2, why: "thirty-one" });
      const lastR = cardRank(pile[pile.length - 1]);
      let same = 0;
      for (let i = pile.length - 1; i >= 0; i--) {
        if (cardRank(pile[i]) === lastR) same++;
        else break;
      }
      if (same >= 2) {
        const n = same * (same - 1);
        const why = same === 2 ? "pair" : same === 3 ? "pair royal" : same === 4 ? "double pair royal" : same + " of a kind";
        pts.push({ n, why });
      }
      let bestRun = null;
      const allowWrap = Boolean(options.optRoundAroundTheWorld);
      const allowMultiple = Boolean(options.optMultipleRunsInPegging || options.optMultipleRuns);
      for (let len = pile.length; len >= 3; len--) {
        const slice = pile.slice(pile.length - len);
        const res = _CribbageScorer.evaluateRunSlice(slice, allowWrap, allowMultiple);
        if (res) {
          if (!bestRun || res.points > bestRun.points || res.points === bestRun.points && res.len > bestRun.len) {
            bestRun = res;
          }
        }
      }
      if (bestRun) {
        pts.push({ n: bestRun.points, why: bestRun.why });
      }
      if (options.optFlushInPlay && pile.length >= 3) {
        const lastSuit = cardSuit(pile[pile.length - 1]);
        let flushCount = 0;
        for (let i = pile.length - 1; i >= 0; i--) {
          if (cardSuit(pile[i]) === lastSuit) {
            flushCount++;
          } else {
            break;
          }
        }
        if (flushCount >= 3) {
          pts.push({ n: flushCount, why: "flush of " + flushCount });
        }
      }
      return pts;
    }
    /**
     * Score hand or crib (exact core calculation with no wild variables).
     */
    static scoreHandCore(cards, starter, isCrib = false, options = {}) {
      const starterList = Array.isArray(starter) ? starter.filter(Boolean) : starter ? [starter] : [];
      const all = starterList.length ? cards.concat(starterList) : cards.slice();
      const detail = {
        fifteens: 0,
        nineteens: 0,
        thirtyOnes: 0,
        pairs: 0,
        runs: 0,
        flush: 0,
        nobs: 0,
        total: 0,
        notes: [],
        lines: []
      };
      const n = all.length;
      for (let mask = 1; mask < 1 << n; mask++) {
        let sum = 0;
        const combo = [];
        for (let i = 0; i < n; i++) {
          if (mask & 1 << i) {
            sum += VAL2(cardRank(all[i]));
            combo.push(all[i]);
          }
        }
        if (sum === 15) {
          detail.fifteens += 2;
          detail.lines.push({ n: 2, why: "Fifteen", cards: combo });
        }
        if (options.opt19sFor2 && sum === 19) {
          detail.nineteens = (detail.nineteens || 0) + 2;
          detail.lines.push({ n: 2, why: "Nineteen", cards: combo, isBonus: true });
        }
        if (options.opt31sFor5 && sum === 31) {
          detail.thirtyOnes = (detail.thirtyOnes || 0) + 5;
          detail.lines.push({ n: 5, why: "Thirty-one", cards: combo, isBonus: true });
        }
      }
      if (detail.fifteens) detail.notes.push(`${detail.fifteens / 2} fifteen${detail.fifteens > 2 ? "s" : ""} (${detail.fifteens})`);
      if (detail.nineteens) {
        const cnt = detail.nineteens / 2;
        detail.notes.push(`${cnt} nineteen${cnt > 1 ? "s" : ""} (${detail.nineteens})`);
      }
      if (detail.thirtyOnes) {
        const cnt = detail.thirtyOnes / 5;
        detail.notes.push(`${cnt} thirty-one${cnt > 1 ? "s" : ""} (${detail.thirtyOnes})`);
      }
      const byRank = {};
      for (const c of all) {
        const r = cardRank(c);
        byRank[r] = (byRank[r] || []).concat([c]);
      }
      for (const r in byRank) {
        const group = byRank[r];
        const k = group.length;
        if (k >= 2) {
          const pts = k * (k - 1);
          detail.pairs += pts;
          const label = k === 2 ? "Pair" : k === 3 ? "Pair royal" : k === 4 ? "Double pair royal" : k + " of a kind";
          const pairCombos = combinations(group, 2);
          if (pairCombos.length) {
            for (const pair of pairCombos) {
              detail.lines.push({ n: 2, why: k === 2 ? "Pair" : label, cards: pair });
            }
          } else {
            detail.lines.push({ n: pts, why: label, cards: group });
          }
        }
      }
      if (detail.pairs) detail.notes.push(`pairs (${detail.pairs})`);
      const ranksPresent = Object.keys(byRank).map(Number).sort((a, b) => a - b);
      const runSequences = [];
      if (options.optRoundAroundTheWorld) {
        const rankSet = new Set(ranksPresent);
        for (const r of ranksPresent) {
          const prev = r === 1 ? 13 : r - 1;
          if (!rankSet.has(prev)) {
            const seq = [r];
            let curr = r;
            while (seq.length < 13) {
              const next = curr === 13 ? 1 : curr + 1;
              if (!rankSet.has(next)) break;
              seq.push(next);
              curr = next;
            }
            if (seq.length >= 3) runSequences.push(seq);
          }
        }
      } else {
        let i = 0;
        while (i < ranksPresent.length) {
          let j = i;
          while (j + 1 < ranksPresent.length && ranksPresent[j + 1] === ranksPresent[j] + 1) j++;
          const len = j - i + 1;
          if (len >= 3) {
            const seq = [];
            for (let t = i; t <= j; t++) seq.push(ranksPresent[t]);
            runSequences.push(seq);
          }
          i = j + 1;
        }
      }
      for (const seq of runSequences) {
        const len = seq.length;
        let prod = 1;
        for (const r of seq) prod *= byRank[r].length;
        detail.runs += len * prod;
        const groups = seq.map((r) => byRank[r]);
        const runCombos = [];
        const walk = (gi, acc) => {
          if (gi === groups.length) {
            runCombos.push(acc.slice());
            return;
          }
          for (const card of groups[gi]) {
            acc.push(card);
            walk(gi + 1, acc);
            acc.pop();
          }
        };
        walk(0, []);
        if (runCombos.length) {
          for (const rc of runCombos) detail.lines.push({ n: len, why: "Run of " + len, cards: rc });
        } else {
          const runCards = [];
          for (const r of seq) runCards.push(...byRank[r]);
          detail.lines.push({ n: len * prod, why: "Run of " + len, cards: runCards });
        }
      }
      if (detail.runs) detail.notes.push(`runs (${detail.runs})`);
      if (cards.length) {
        const suitCounts = {};
        for (const c of cards) {
          const su = cardSuit(c);
          suitCounts[su] = (suitCounts[su] || 0) + 1;
        }
        const handSuits = Object.entries(suitCounts).sort((a, b) => b[1] - a[1]);
        const topSuit = handSuits[0];
        if (topSuit && topSuit[1] === cards.length && cards.length >= 4) {
          const matchingStarters = starterList.filter((s) => cardSuit(s) === topSuit[0]);
          if (isCrib || options.optFiveCardFlushOnly) {
            if (matchingStarters.length === starterList.length && starterList.length > 0) {
              detail.flush = cards.length + matchingStarters.length;
            }
          } else {
            detail.flush = cards.length + matchingStarters.length;
          }
          if (detail.flush) {
            detail.notes.push(`flush (${detail.flush})`);
            const flushCards = cards.filter((c) => cardSuit(c) === topSuit[0]).concat(matchingStarters);
            detail.lines.push({ n: detail.flush, why: "Flush", cards: flushCards });
          }
        }
      }
      if (starterList.length) {
        for (const st of starterList) {
          const jack = cards.find((c) => cardRank(c) === 11 && cardSuit(c) === cardSuit(st));
          if (jack) {
            detail.nobs += 1;
            detail.lines.push({ n: 1, why: "Nobs", cards: [jack, st] });
          }
        }
      }
      if (detail.nobs) {
        detail.notes.push(`nobs (${detail.nobs})`);
      }
      const isRed = (c) => cardSuit(c) === "H" || cardSuit(c) === "D";
      const isBlack = (c) => cardSuit(c) === "S" || cardSuit(c) === "C";
      const nAll = all.length;
      if (options.optAllRed && all.every((c) => isRed(c))) {
        detail.allRed = nAll;
        detail.notes.push(`all red (${nAll})`);
        detail.lines.push({ n: nAll, why: "All red", cards: all.slice(), isBonus: true });
      }
      if (options.optAllBlack && all.every((c) => isBlack(c))) {
        detail.allBlack = nAll;
        detail.notes.push(`all black (${nAll})`);
        detail.lines.push({ n: nAll, why: "All black", cards: all.slice(), isBonus: true });
      }
      if (options.optAllOdd && all.every((c) => cardRank(c) % 2 === 1)) {
        detail.allOdd = nAll;
        detail.notes.push(`all odd (${nAll})`);
        detail.lines.push({ n: nAll, why: "All odd", cards: all.slice(), isBonus: true });
      }
      if (options.optAllEven && all.every((c) => cardRank(c) % 2 === 0)) {
        detail.allEven = nAll;
        detail.notes.push(`all even (${nAll})`);
        detail.lines.push({ n: nAll, why: "All even", cards: all.slice(), isBonus: true });
      }
      if (options.optAllDifferentSuits) {
        let hasClub = false, hasDiamond = false, hasHeart = false, hasSpade = false;
        cards.forEach((c) => {
          const su = cardSuit(c);
          if (su === "C") hasClub = true;
          if (su === "D") hasDiamond = true;
          if (su === "H") hasHeart = true;
          if (su === "S") hasSpade = true;
        });
        if (cards.length === 4 && hasClub && hasDiamond && hasHeart && hasSpade) {
          detail.allDifferentSuits = 4;
          detail.notes.push("all diff suits (4)");
          const diffCards = ["C", "D", "H", "S"].map((s) => cards.find((c) => cardSuit(c) === s)).filter(Boolean);
          detail.lines.push({ n: 4, why: "All different suits", cards: diffCards, isBonus: true });
        }
      }
      const isFlush5 = (cs) => cs.length === 5 && cs.every((c) => cardSuit(c) === cardSuit(cs[0]));
      const isStraight5 = (cs) => {
        if (cs.length !== 5) return false;
        const rs = cs.map((c) => cardRank(c)).sort((a, b) => a - b);
        if (new Set(rs).size !== 5) return false;
        if (rs[4] - rs[0] === 4) return true;
        if (rs[0] === 1 && rs[1] === 10 && rs[2] === 11 && rs[3] === 12 && rs[4] === 13) return true;
        if (options.optRoundAroundTheWorld) {
          return isConsecutiveRun(rs, true);
        }
        return false;
      };
      const isRoyal5 = (cs) => {
        if (!isFlush5(cs)) return false;
        const set = new Set(cs.map((c) => cardRank(c)));
        return [1, 10, 11, 12, 13].every((r) => set.has(r));
      };
      const isFullHouse5 = (cs) => {
        if (!cs || cs.length < 5) return false;
        const by = {};
        for (const c of cs) {
          const r = cardRank(c);
          by[r] = (by[r] || 0) + 1;
        }
        const counts = Object.values(by).sort((a, b) => b - a);
        return counts[0] >= 3 && counts[1] >= 2;
      };
      const fives = nAll >= 5 ? combinations(all, 5) : [];
      if (options.optKH) {
        const khCard = cards.find((c) => cardRank(c) === 13 && cardSuit(c) === "H");
        if (khCard) {
          detail.kh = 5;
          detail.notes.push("suicide king (5)");
          detail.lines.push({ n: 5, why: "Suicide king", cards: [khCard], isBonus: true });
        }
      }
      if (options.optQS) {
        const qsCard = cards.find((c) => cardRank(c) === 12 && cardSuit(c) === "S");
        if (qsCard) {
          detail.qs = 5;
          detail.notes.push("queen of spades (5)");
          detail.lines.push({ n: 5, why: "Queen of spades", cards: [qsCard], isBonus: true });
        }
      }
      if (options.optAS) {
        const asCard = cards.find((c) => cardRank(c) === 1 && cardSuit(c) === "S");
        if (asCard) {
          detail.as = 5;
          detail.notes.push("ace of spades (5)");
          detail.lines.push({ n: 5, why: "Ace of spades", cards: [asCard], isBonus: true });
        }
      }
      let scoredPokerRun = false;
      if (options.optRoyalFlush) {
        const rf5 = fives.find(isRoyal5);
        if (rf5) {
          scoredPokerRun = true;
          detail.royalFlush = 30;
          detail.notes.push("royal flush (30)");
          detail.lines.push({ n: 30, why: "Royal flush", cards: rf5, isBonus: true });
        }
      }
      if (!scoredPokerRun && options.optStraightFlush) {
        const sf5 = fives.find((cs) => isFlush5(cs) && isStraight5(cs));
        if (sf5) {
          scoredPokerRun = true;
          detail.straightFlush = 20;
          detail.notes.push("straight flush (20)");
          detail.lines.push({ n: 20, why: "Straight flush", cards: sf5, isBonus: true });
        }
      }
      if (!scoredPokerRun && options.optStraight) {
        const st5 = fives.find(isStraight5);
        if (st5) {
          scoredPokerRun = true;
          detail.straight = 10;
          detail.notes.push("straight (10)");
          detail.lines.push({ n: 10, why: "Straight", cards: st5, isBonus: true });
        }
      }
      if (options.optFullHouse) {
        const fh5 = fives.find(isFullHouse5);
        if (fh5) {
          detail.fullHouse = 10;
          detail.notes.push("full house (10)");
          detail.lines.push({ n: 10, why: "Full house", cards: fh5, isBonus: true });
        }
      }
      detail.total = detail.fifteens + (detail.nineteens || 0) + (detail.thirtyOnes || 0) + detail.pairs + detail.runs + detail.flush + detail.nobs + (detail.allRed || 0) + (detail.allBlack || 0) + (detail.allOdd || 0) + (detail.allEven || 0) + (detail.allDifferentSuits || 0) + (detail.kh || 0) + (detail.qs || 0) + (detail.as || 0) + (detail.straight || 0) + (detail.fullHouse || 0) + (detail.straightFlush || 0) + (detail.royalFlush || 0);
      if (options.optSpades) {
        const spadeCut = starterList.some(isSpadeCard);
        const hasSpade = cards.some(isSpadeCard);
        if (hasSpade) {
          const rawPts = detail.total;
          if (rawPts > 0) {
            detail.spadesDouble = rawPts;
            detail.total = rawPts * 2;
            const noteText = spadeCut ? `spades cut & in ${isCrib ? "crib" : "hand"} (double points: +${rawPts})` : `spades in ${isCrib ? "crib" : "hand"} (double points: +${rawPts})`;
            detail.notes.push(noteText);
            const highlightCards = cards.filter(isSpadeCard).concat(starterList.filter(isSpadeCard));
            detail.lines.push({ n: rawPts, why: `Spades in ${isCrib ? "crib" : "hand"} double points`, cards: highlightCards, isBonus: true });
          }
        } else {
          let dealerHasSpade = false;
          if (isCrib) {
            if (options.dealerHasSpade !== void 0) {
              dealerHasSpade = Boolean(options.dealerHasSpade);
            } else if (Array.isArray(options.dealerHand)) {
              dealerHasSpade = options.dealerHand.some(isSpadeCard);
            } else {
              const st = options.state || (typeof window !== "undefined" ? window.state : null);
              if (st) {
                const d = st.dealer;
                const dCards = st.seatKept && st.seatKept[d] || st.lastShow && st.lastShow.dealer && st.lastShow.dealer.cards || (d === "p1" || d === "you" ? st.youHand : st.cpuHand);
                if (Array.isArray(dCards)) {
                  dealerHasSpade = dCards.some(isSpadeCard);
                }
              }
            }
          }
          if (isCrib && dealerHasSpade) {
            detail.notes.push("spade in dealer hand (no crib penalty)");
          } else {
            detail.total = -29;
            detail.spadesPenalty = -29;
            detail.notes = [`no spade in ${isCrib ? "crib" : "hand"} (-29)`];
            detail.lines = [{ n: -29, why: `No Spade in ${isCrib ? "crib" : "hand"} penalty`, cards: cards.slice(), isBonus: true }];
            detail.fifteens = 0;
            detail.nineteens = 0;
            detail.thirtyOnes = 0;
            detail.pairs = 0;
            detail.runs = 0;
            detail.flush = 0;
            detail.nobs = 0;
            detail.allRed = 0;
            detail.allBlack = 0;
            detail.allOdd = 0;
            detail.allEven = 0;
            detail.allDifferentSuits = 0;
            detail.kh = 0;
            detail.qs = 0;
            detail.as = 0;
            detail.fullHouse = 0;
            detail.straightFlush = 0;
            detail.royalFlush = 0;
            detail.straight = 0;
          }
        }
      }
      if (options.optZeroHand && !isCrib && detail.total === 0) {
        detail.zeroHand = -19;
        detail.notes.push("zero hand (-19)");
        detail.lines.push({ n: -19, why: "Zero hand penalty", cards: all.slice(), isBonus: true });
        detail.total += -19;
      }
      if (options.optZeroCrib && isCrib && detail.total === 0) {
        if (!options.optRockCrib) {
          detail.zeroCrib = -19;
          detail.notes.push("zero crib (-19)");
          detail.lines.push({ n: -19, why: "Zero crib penalty", cards: all.slice(), isBonus: true });
          detail.total += -19;
        } else {
          detail.zeroCrib = 19;
          detail.notes.push("rock crib bonus (19)");
          detail.lines.push({ n: 19, why: "Rock crib bonus", cards: all.slice(), isBonus: true });
          detail.total += 19;
        }
      }
      return detail;
    }
    /**
     * Score hand with automatic resolution of wild cards (Jokers) to maximize (or minimize if lowball) points.
     */
    static scoreHand(cards = [], starter = null, isCrib = false, options = {}, precise = true) {
      const allCards = cards.slice();
      const wilds = allCards.filter((c) => isCardWild(c, isCrib));
      const starterList = Array.isArray(starter) ? starter.filter(Boolean) : starter ? [starter] : [];
      for (const st of starterList) {
        if (isCardWild(st, false)) wilds.push(st);
      }
      if (!wilds.length) {
        return _CribbageScorer.scoreHandCore(allCards, starter, isCrib, options);
      }
      const lowball = options.goal === "low";
      let best = null;
      const suitList = precise === false || wilds.length >= 3 ? [(allCards.find((c) => !isCardWild(c, isCrib)) || { s: "S" }).s] : SUITS.slice();
      const rec = (wildIdx, wildAssignments) => {
        if (wildIdx === wilds.length) {
          const mappedCards = allCards.map((c) => {
            const w = wildAssignments.find((a) => a.card.id === c.id);
            return w ? { ...c, r: w.r, s: w.s, playAs: { r: w.r, s: w.s } } : c;
          });
          const mappedStarter = Array.isArray(starter) ? starter.map((st) => {
            if (isCardWild(st, false)) {
              const w = wildAssignments.find((a) => a.card.id === st.id);
              return w ? { ...st, r: w.r, s: w.s, playAs: { r: w.r, s: w.s } } : st;
            }
            return st;
          }) : starter && isCardWild(starter, false) ? (() => {
            const w = wildAssignments.find((a) => a.card.id === starter.id);
            return w ? { ...starter, r: w.r, s: w.s, playAs: { r: w.r, s: w.s } } : starter;
          })() : starter;
          const res = _CribbageScorer.scoreHandCore(mappedCards, mappedStarter, isCrib, options);
          if (!best) {
            best = res;
          } else if (lowball ? res.total < best.total : res.total > best.total) {
            best = res;
          }
          return;
        }
        const targetWild = wilds[wildIdx];
        for (let r = 1; r <= 13; r++) {
          for (const s of suitList) {
            wildAssignments.push({ card: targetWild, r, s });
            rec(wildIdx + 1, wildAssignments);
            wildAssignments.pop();
          }
        }
      };
      rec(0, []);
      if (best && wilds.length) {
        best.notes = (best.notes || []).concat(["wild"]);
      }
      return best || _CribbageScorer.scoreHandCore(allCards, starter, isCrib, options);
    }
    static pegTotal(pile, settings3 = {}) {
      return _CribbageScorer.scorePegging(pile, settings3).reduce((s, p) => s + p.n, 0);
    }
    static scoreHeels(starter) {
      if (!starter) return 0;
      const starterList = Array.isArray(starter) ? starter.filter(Boolean) : [starter];
      let heels = 0;
      for (const st of starterList) {
        const r = st.rank !== void 0 ? st.rank : st.r || 0;
        if (r === 11) heels += 2;
      }
      return heels;
    }
    static pegPotential(cards = []) {
      let v = 0;
      let fives = 0, tens = 0, lows = 0;
      for (const c of cards) {
        const isW = c && (c.isWild || c.wild);
        const r = c && (c.rank !== void 0 ? c.rank : c.r) || 0;
        if (isW || r === 5) fives++;
        else if (r >= 10) tens++;
        else if (r <= 4) lows++;
      }
      v += fives * 0.85;
      v += Math.min(fives, tens) * 0.25;
      v += Math.min(lows, 3) * 0.12;
      return v;
    }
    /**
     * Finds the optimal partition of 8 cards into two 4-card hands maximizing total points.
     * Both hands are evaluated with the 5-card flush rule (flush only if cut card matches suit).
     * @param {Array} cards8 - Exactly 8 cards combining dealer kept cards and crib cards
     * @param {Object|Array} starter - Starter cut card(s)
     * @param {Object} [options] - Game scoring options
     * @returns {{ hand1: Array, hand2: Array, score1: Object, score2: Object, total: number }}
     */
    static findOptimalTwistedSplit(cards8, starter, options = {}) {
      if (!Array.isArray(cards8) || cards8.length !== 8) {
        const mid = Math.floor((cards8 ? cards8.length : 0) / 2);
        const h1 = cards8 ? cards8.slice(0, mid) : [];
        const h2 = cards8 ? cards8.slice(mid) : [];
        const scoreOpts2 = { ...options, optFiveCardFlushOnly: true };
        const s1 = _CribbageScorer.scoreHand(h1, starter, true, scoreOpts2);
        const s2 = _CribbageScorer.scoreHand(h2, starter, true, { ...scoreOpts2, dealerHand: h1 });
        return { hand1: h1, hand2: h2, score1: s1, score2: s2, total: s1.total + s2.total };
      }
      const scoreOpts = { ...options, optFiveCardFlushOnly: true };
      const lowball = options.goal === "low";
      let best = null;
      for (let i = 1; i <= 5; i++) {
        for (let j = i + 1; j <= 6; j++) {
          for (let k = j + 1; k <= 7; k++) {
            const hand1 = [cards8[0], cards8[i], cards8[j], cards8[k]];
            const hand2 = [];
            for (let m = 1; m <= 7; m++) {
              if (m !== i && m !== j && m !== k) {
                hand2.push(cards8[m]);
              }
            }
            const s1 = _CribbageScorer.scoreHand(hand1, starter, true, scoreOpts);
            const s2 = _CribbageScorer.scoreHand(hand2, starter, true, { ...scoreOpts, dealerHand: hand1 });
            const total = s1.total + s2.total;
            if (!best) {
              best = { hand1, hand2, score1: s1, score2: s2, total };
            } else {
              const isBetter = lowball ? total < best.total : total > best.total;
              if (isBetter) {
                best = { hand1, hand2, score1: s1, score2: s2, total };
              } else if (total === best.total) {
                const maxCurr = Math.max(s1.total, s2.total);
                const maxBest = Math.max(best.score1.total, best.score2.total);
                if (lowball ? maxCurr < maxBest : maxCurr > maxBest) {
                  best = { hand1, hand2, score1: s1, score2: s2, total };
                }
              }
            }
          }
        }
      }
      if (best) {
        const swap = lowball ? best.score2.total < best.score1.total : best.score2.total > best.score1.total;
        if (swap) {
          best = {
            hand1: best.hand2,
            hand2: best.hand1,
            score1: best.score2,
            score2: best.score1,
            total: best.total
          };
        }
        best.hand1 = best.hand1.slice().sort((a, b) => cardRank(a) - cardRank(b));
        best.hand2 = best.hand2.slice().sort((a, b) => cardRank(a) - cardRank(b));
      }
      return best;
    }
  };

  // src/board/BoardGeometry.js
  var BoardGeometry_exports = {};
  __export(BoardGeometry_exports, {
    BOARD_CFG: () => BOARD_CFG,
    BOARD_CFG_481: () => BOARD_CFG_481,
    getActiveTracks: () => getActiveTracks,
    getClashBoardCfg: () => getClashBoardCfg,
    getTrackOffset: () => getTrackOffset,
    getTrackXY: () => getTrackXY,
    isInBunker: () => isInBunker,
    isInLast5PegOut: () => isInLast5PegOut,
    isInNoPassingLane: () => isInNoPassingLane,
    isInPegThroughZone: () => isInPegThroughZone,
    isInStinkHole: () => isInStinkHole,
    skunkResult: () => skunkResult,
    streetName: () => streetName
  });
  var BOARD_CFG = Object.freeze({
    viewW: 820,
    viewH: 216,
    st1Y: 54,
    // First street (0 to 30) -> Left to Right
    st2Y: 108,
    // Second street (31 to 60) -> Right to Left
    st3Y: 162,
    // Third street (61 to 120) -> Left to Right
    trackOffset: {
      p1: -15,
      p2: -10,
      p3: -5,
      p4: 0,
      p5: 5,
      p6: 10,
      p7: 15,
      p8: 20,
      you: -6,
      cpu: 6,
      team1: -6,
      team2: 6,
      team3: 0,
      team4: 6
    },
    xStart: 85,
    xEnd: 715
  });
  var BOARD_CFG_481 = Object.freeze({
    viewW: 820,
    viewH: 438,
    stY: [42, 86, 130, 174, 218, 262, 306, 350],
    finishY: 394,
    xStart: 75,
    xEnd: 745
  });
  function getClashBoardCfg(target = 481) {
    const t = Number(target) || 481;
    const numRows = t === 241 ? 4 : t === 361 ? 6 : 8;
    const stY = [42, 86, 130, 174, 218, 262, 306, 350].slice(0, numRows);
    const finishY = stY[numRows - 1] + 44;
    const viewH = finishY + 44;
    return {
      numRows,
      viewW: 820,
      viewH,
      stY,
      finishY,
      xStart: 75,
      xEnd: 745
    };
  }
  function getTrackOffset(who, playerCount = 2, isFixedTeams2 = false, getSeatTeamFn = null) {
    let sId = who;
    if (sId === "you") sId = "p1";
    if (sId === "cpu") sId = "p2";
    const isTeamId = typeof sId === "string" && sId.startsWith("team");
    if (isFixedTeams2 || isTeamId) {
      const team = isTeamId ? sId : typeof getSeatTeamFn === "function" ? getSeatTeamFn(sId) : sId === "p2" || sId === "p4" ? "team2" : "team1";
      if (playerCount === 6 || playerCount === 5) {
        const offsets6 = { team1: -8, team2: 0, team3: 8 };
        return offsets6[team] !== void 0 ? offsets6[team] : 0;
      } else if (playerCount === 8 || playerCount === 7) {
        const offsets8 = { team1: -9, team2: -3, team3: 3, team4: 9 };
        return offsets8[team] !== void 0 ? offsets8[team] : 0;
      }
      return team === "team1" ? -6 : 6;
    }
    if (playerCount === 2) {
      return sId === "p1" ? -6 : 6;
    } else if (playerCount === 3) {
      const offsets3 = { p1: -8, p2: 0, p3: 8 };
      return offsets3[sId] !== void 0 ? offsets3[sId] : 0;
    } else if (playerCount === 4) {
      const offsets4 = { p1: -9, p2: -3, p3: 3, p4: 9, team1: -6, team2: 6 };
      return offsets4[sId] !== void 0 ? offsets4[sId] : sId === "team1" ? -6 : sId === "team2" ? 6 : 0;
    } else if (playerCount === 5) {
      const offsets5 = { p1: -12, p2: -6, p3: 0, p4: 6, p5: 12, team1: -8, team2: 0, team3: 8 };
      return offsets5[sId] !== void 0 ? offsets5[sId] : 0;
    } else if (playerCount === 7) {
      const offsets7 = { p1: -15, p2: -10, p3: -5, p4: 0, p5: 5, p6: 10, p7: 15 };
      return offsets7[sId] !== void 0 ? offsets7[sId] : 0;
    }
    const offsetsDefault = { p1: -9, p2: -3, p3: 3, p4: 9, team1: -6, team2: 6 };
    return offsetsDefault[sId] !== void 0 ? offsetsDefault[sId] : 0;
  }
  function getTrackXY(holeNum, who = "p1", target = 121, options = {}) {
    let resolvedTarget = 121;
    let opts = options || {};
    if (typeof target === "object" && target !== null) {
      opts = Object.assign({}, target, options);
      resolvedTarget = Number(target.target) || 121;
    } else {
      resolvedTarget = Number(target) || 0;
      if (!resolvedTarget || resolvedTarget === 121) {
        if (typeof opts === "object" && opts !== null && opts.target) {
          resolvedTarget = Number(opts.target);
        } else if (typeof window !== "undefined" && window.settings && window.settings.target) {
          resolvedTarget = Number(window.settings.target);
        }
      }
      if (!resolvedTarget) resolvedTarget = 121;
    }
    if (holeNum > 120 && ![241, 361, 481].includes(resolvedTarget)) {
      if (holeNum <= 241) resolvedTarget = 241;
      else if (holeNum <= 361) resolvedTarget = 361;
      else resolvedTarget = 481;
    }
    const playerCount = Number(opts.playerCount) || 2;
    const isFixedTeams2 = Boolean(
      opts.isFixedTeams || opts.optCanadianDoubles || opts.gameMode === "partnership" || opts.gameMode === "teams" || opts.gameMode === "1vs2" || typeof opts.isFixedTeams === "function" && opts.isFixedTeams()
    );
    let offY = getTrackOffset(who, playerCount, isFixedTeams2, opts.getSeatTeam);
    if (opts.optNoPassingLanes && isInNoPassingLane(holeNum)) {
      offY = 0;
    }
    const isClashTarget2 = [241, 361, 481].includes(resolvedTarget);
    if (isClashTarget2) {
      const clashCfg = getClashBoardCfg(resolvedTarget);
      if (holeNum <= 0) {
        return { x: clashCfg.xStart - 35, y: clashCfg.stY[0] + offY };
      }
      if (holeNum >= resolvedTarget) {
        return { x: clashCfg.xStart + 32, y: clashCfg.finishY + offY };
      }
      const row = Math.floor((holeNum - 1) / 60);
      const pos = (holeNum - 1) % 60;
      if (pos < 55) {
        const frac = pos / 54;
        if (row % 2 === 0) {
          return {
            x: clashCfg.xStart + frac * (clashCfg.xEnd - clashCfg.xStart),
            y: clashCfg.stY[row] + offY
          };
        } else {
          return {
            x: clashCfg.xEnd - frac * (clashCfg.xEnd - clashCfg.xStart),
            y: clashCfg.stY[row] - offY
          };
        }
      } else {
        const k = pos - 54;
        const step = (k - 0.5) / 5;
        if (row % 2 === 0) {
          const nextY = clashCfg.stY[row + 1];
          const baseR = (nextY - clashCfg.stY[row]) / 2;
          const r = baseR - offY;
          const cy = (clashCfg.stY[row] + nextY) / 2;
          const angle = -Math.PI / 2 + step * Math.PI;
          return {
            x: clashCfg.xEnd + Math.cos(angle) * (r + 8),
            y: cy + Math.sin(angle) * r
          };
        } else {
          const nextY = row === clashCfg.numRows - 1 ? clashCfg.finishY : clashCfg.stY[row + 1];
          const baseR = (nextY - clashCfg.stY[row]) / 2;
          const r = baseR + offY;
          const cy = (clashCfg.stY[row] + nextY) / 2;
          const angle = -Math.PI / 2 - step * Math.PI;
          return {
            x: clashCfg.xStart + Math.cos(angle) * (r + 8),
            y: cy + Math.sin(angle) * r
          };
        }
      }
    }
    const startX = BOARD_CFG.xStart;
    const endX = BOARD_CFG.xEnd;
    const t = Math.max(0, Math.min(121, holeNum));
    if (t === 0) {
      return { x: startX - 35, y: BOARD_CFG.st1Y + offY };
    }
    if (t <= 30) {
      const frac = (t - 1) / 29;
      return { x: startX + frac * (endX - startX), y: BOARD_CFG.st1Y + offY };
    }
    if (t <= 35) {
      const baseR = (BOARD_CFG.st2Y - BOARD_CFG.st1Y) / 2;
      const r = baseR - offY;
      const cy = (BOARD_CFG.st1Y + BOARD_CFG.st2Y) / 2;
      const step = (t - 30.5) / 5;
      const angle = -Math.PI / 2 + step * Math.PI;
      return {
        x: endX + Math.cos(angle) * (r + 10),
        y: cy + Math.sin(angle) * r
      };
    }
    if (t <= 65) {
      const frac = (t - 36) / 29;
      return { x: endX - frac * (endX - startX), y: BOARD_CFG.st2Y - offY };
    }
    if (t <= 70) {
      const baseR = (BOARD_CFG.st3Y - BOARD_CFG.st2Y) / 2;
      const r = baseR + offY;
      const cy = (BOARD_CFG.st2Y + BOARD_CFG.st3Y) / 2;
      const step = (t - 65.5) / 5;
      const angle = -Math.PI / 2 - step * Math.PI;
      return {
        x: startX + Math.cos(angle) * (r + 10),
        y: cy + Math.sin(angle) * r
      };
    }
    if (t <= 120) {
      const frac = (t - 71) / 49;
      return { x: startX + frac * (endX - startX), y: BOARD_CFG.st3Y + offY };
    }
    return { x: endX + 32, y: BOARD_CFG.st3Y + offY };
  }
  function isInPegThroughZone(hole) {
    return hole >= 31 && hole <= 40 || hole >= 61 && hole <= 70 || hole >= 91 && hole <= 100;
  }
  function isInLast5PegOut(hole, target = 121) {
    return hole >= target - 5 && hole < target;
  }
  function isInBunker(hole, target = 121) {
    if (hole >= 1 && hole <= 5) return true;
    if (hole >= target - 5 && hole < target) return true;
    if (target === 121 || [241, 361, 481].includes(target)) {
      if (hole >= 50 && hole <= 60) return true;
      if (hole >= 80 && hole <= 90) return true;
    }
    return false;
  }
  function isInStinkHole(hole, target = 121) {
    return hole === target - 1;
  }
  function isInNoPassingLane(hole, lanes = []) {
    if (Array.isArray(lanes) && lanes.length > 0) {
      return lanes.some((lane) => hole >= lane.start && hole <= lane.end);
    }
    return hole >= 31 && hole <= 40 || hole >= 61 && hole <= 70 || hole >= 91 && hole <= 100;
  }
  function streetName(score, target = 121) {
    const t = Number(target) || 121;
    if (score >= t) return "Home";
    if ([241, 361, 481].includes(t)) {
      const numRows = t === 241 ? 4 : t === 361 ? 6 : 8;
      const row = Math.min(numRows, Math.max(1, Math.floor((score - 1) / 60) + 1));
      const ordinals = ["", "First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth"];
      return `${ordinals[row] || "Street " + row} street`;
    }
    if (score >= 90) return "Home";
    if (score >= 60) return "Third street";
    if (score >= 30) return "Second street";
    return "First street";
  }
  function skunkResult(winner, youScore, cpuScore, options = {}) {
    const target = Number(options.target || 121);
    const goal = options.goal || "high";
    if (goal !== "high") return null;
    const loserScore = winner === "you" || winner === "p1" || winner === "team1" ? cpuScore : youScore;
    const youLost = winner !== "you" && winner !== "p1" && winner !== "team1";
    const who = youLost ? "You were" : "Computer was";
    if (options.optSkunkMarkers) {
      const dHole = options.doubleSkunkMarkerHole || (target === 481 ? 240 : target === 361 ? 180 : 120);
      const sHole = options.skunkMarkerHole || (target === 481 ? 360 : target === 361 ? 270 : 180);
      if (loserScore <= dHole) {
        return {
          kind: "double",
          label: "Double skunk",
          line: `${who} double-skunked (under ${dHole + 1}).`
        };
      }
      if (loserScore <= sHole) {
        return {
          kind: "skunk",
          label: "Skunk",
          line: `${who} skunked (under ${sHole + 1}).`
        };
      }
      return null;
    }
    if (target === 121) {
      if (loserScore < 61) {
        return {
          kind: "double",
          label: "Double skunk",
          line: `${who} double-skunked (under 61).`
        };
      }
      if (loserScore < 91) {
        return {
          kind: "skunk",
          label: "Skunk",
          line: `${who} skunked (under 91).`
        };
      }
    } else if (target === 61) {
      if (loserScore < 31) {
        return {
          kind: "skunk",
          label: "Skunk",
          line: `${who} skunked (under 31).`
        };
      }
    }
    return null;
  }
  function getActiveTracks(settings3 = {}, isFixedTeams2 = false) {
    const isFixed = Boolean(
      isFixedTeams2 || settings3.optCanadianDoubles || settings3.gameMode === "partnership" || settings3.gameMode === "teams" || settings3.gameMode === "1vs2" || typeof isFixedTeams2 === "function" && isFixedTeams2()
    );
    if (isFixed) {
      const count2 = Number(settings3.playerCount) || 4;
      if (count2 === 3) return ["team1", "team2"];
      if (count2 === 5 || count2 === 6) return ["team1", "team2", "team3"];
      if (count2 === 7 || count2 === 8) return ["team1", "team2", "team3", "team4"];
      return ["team1", "team2"];
    }
    const count = Number(settings3.playerCount) || 2;
    const tracks = [];
    for (let i = 1; i <= count; i++) {
      tracks.push("p" + i);
    }
    return tracks;
  }

  // src/board/ObstacleGeometry.js
  var CLASH_DEFAULTS_481 = Object.freeze({
    noPassingLaneStarts: [40, 175, 275, 415],
    jumpStarts: [25, 195, 295, 435, 75, 145, 245, 365],
    jumpDests: [60, 160, 335, 395, 110, 125, 280, 400],
    jailHoles: [110, 315],
    barHoles: [125, 375],
    timeoutHoles: [75, 255],
    detourHoles: [15, 235],
    roundAboutHoles: [145, 355],
    signsStarts: [90, 215, 450, 465],
    stopSignHoles: [35, 70, 105, 155, 205, 265, 345, 425],
    diceHoles: [50, 185, 285, 410],
    wheelHoles: [65, 160, 260, 385],
    optDetour1Hole: 15,
    optJump1Start: 25,
    optNoPassingLane1Start: 40,
    optJump1Dest: 60,
    optTimeout1Hole: 75,
    optSigns1Hole: 90,
    optJail1Hole: 110,
    optBar1Hole: 125,
    optRoundAbout1Hole: 145,
    optJump2Dest: 160,
    optNoPassingLane2Start: 175,
    optJump2Start: 195,
    optSigns2Hole: 215,
    optDetour2Hole: 235,
    optTimeout2Hole: 255,
    optNoPassingLane3Start: 275,
    optJump3Start: 295,
    optJail2Hole: 315,
    optJump3Dest: 335,
    optRoundAbout2Hole: 355,
    optBar2Hole: 375,
    optJump4Dest: 395,
    optNoPassingLane4Start: 415,
    optJump4Start: 435,
    optJump5Start: 75,
    optJump5Dest: 110,
    optJump6Start: 145,
    optJump6Dest: 125,
    optJump7Start: 245,
    optJump7Dest: 280,
    optJump8Start: 365,
    optJump8Dest: 400,
    optSigns3Hole: 450,
    optSigns4Hole: 465,
    optStopSign1Hole: 35,
    optStopSign2Hole: 70,
    optStopSign3Hole: 105,
    optStopSign4Hole: 155,
    optStopSign5Hole: 205,
    optStopSign6Hole: 265,
    optStopSign7Hole: 345,
    optStopSign8Hole: 425,
    optDice1Hole: 50,
    optDice2Hole: 185,
    optDice3Hole: 285,
    optDice4Hole: 410,
    optWheel1Hole: 65,
    optWheel2Hole: 160,
    optWheel3Hole: 260,
    optWheel4Hole: 385,
    optSkunkMarkerHole: 360,
    optDoubleSkunkMarkerHole: 240
  });
  var CLASH_DEFAULTS_241 = Object.freeze({
    noPassingLaneStarts: [40, 95, 150, 195],
    jumpStarts: [25, 115, 145, 205, 55, 85, 135, 185],
    jumpDests: [60, 80, 185, 170, 75, 65, 160, 210],
    jailHoles: [70, 175],
    barHoles: [85, 190],
    timeoutHoles: [45, 140],
    detourHoles: [15, 125],
    roundAboutHoles: [65, 165],
    signsStarts: [50, 105, 155, 215],
    stopSignHoles: [25, 50, 75, 100, 125, 150, 175, 200],
    diceHoles: [30, 60, 130, 180],
    wheelHoles: [40, 80, 150, 200],
    optDetour1Hole: 15,
    optJump1Start: 25,
    optNoPassingLane1Start: 40,
    optJump1Dest: 60,
    optTimeout1Hole: 45,
    optSigns1Hole: 50,
    optJail1Hole: 70,
    optBar1Hole: 85,
    optRoundAbout1Hole: 65,
    optJump2Dest: 80,
    optNoPassingLane2Start: 95,
    optJump2Start: 115,
    optSigns2Hole: 105,
    optDetour2Hole: 125,
    optTimeout2Hole: 140,
    optNoPassingLane3Start: 150,
    optJump3Start: 145,
    optJail2Hole: 175,
    optJump3Dest: 185,
    optRoundAbout2Hole: 165,
    optBar2Hole: 190,
    optJump4Dest: 170,
    optNoPassingLane4Start: 195,
    optJump4Start: 205,
    optJump5Start: 55,
    optJump5Dest: 75,
    optJump6Start: 85,
    optJump6Dest: 65,
    optJump7Start: 135,
    optJump7Dest: 160,
    optJump8Start: 185,
    optJump8Dest: 210,
    optSigns3Hole: 155,
    optSigns4Hole: 215,
    optStopSign1Hole: 25,
    optStopSign2Hole: 50,
    optStopSign3Hole: 75,
    optStopSign4Hole: 100,
    optStopSign5Hole: 125,
    optStopSign6Hole: 150,
    optStopSign7Hole: 175,
    optStopSign8Hole: 200,
    optDice1Hole: 30,
    optDice2Hole: 60,
    optDice3Hole: 130,
    optDice4Hole: 180,
    optWheel1Hole: 40,
    optWheel2Hole: 80,
    optWheel3Hole: 150,
    optWheel4Hole: 200,
    optSkunkMarkerHole: 180,
    optDoubleSkunkMarkerHole: 120
  });
  var CLASH_DEFAULTS_361 = Object.freeze({
    noPassingLaneStarts: [40, 135, 215, 315],
    jumpStarts: [25, 145, 225, 325, 65, 105, 185, 275],
    jumpDests: [60, 115, 260, 295, 85, 95, 210, 310],
    jailHoles: [90, 245],
    barHoles: [105, 285],
    timeoutHoles: [65, 195],
    detourHoles: [15, 175],
    roundAboutHoles: [115, 265],
    signsStarts: [70, 165, 255, 335],
    stopSignHoles: [30, 65, 105, 150, 195, 240, 285, 330],
    diceHoles: [50, 140, 230, 320],
    wheelHoles: [70, 160, 250, 330],
    optDetour1Hole: 15,
    optJump1Start: 25,
    optNoPassingLane1Start: 40,
    optJump1Dest: 60,
    optTimeout1Hole: 65,
    optSigns1Hole: 70,
    optJail1Hole: 90,
    optBar1Hole: 105,
    optRoundAbout1Hole: 115,
    optJump2Dest: 115,
    optNoPassingLane2Start: 135,
    optJump2Start: 145,
    optSigns2Hole: 165,
    optDetour2Hole: 175,
    optTimeout2Hole: 195,
    optNoPassingLane3Start: 215,
    optJump3Start: 225,
    optJail2Hole: 245,
    optJump3Dest: 260,
    optRoundAbout2Hole: 265,
    optBar2Hole: 285,
    optJump4Dest: 295,
    optNoPassingLane4Start: 315,
    optJump4Start: 325,
    optJump5Start: 65,
    optJump5Dest: 85,
    optJump6Start: 105,
    optJump6Dest: 95,
    optJump7Start: 185,
    optJump7Dest: 210,
    optJump8Start: 275,
    optJump8Dest: 310,
    optSigns3Hole: 255,
    optSigns4Hole: 335,
    optStopSign1Hole: 30,
    optStopSign2Hole: 65,
    optStopSign3Hole: 105,
    optStopSign4Hole: 150,
    optStopSign5Hole: 195,
    optStopSign6Hole: 240,
    optStopSign7Hole: 285,
    optStopSign8Hole: 330,
    optDice1Hole: 50,
    optDice2Hole: 140,
    optDice3Hole: 230,
    optDice4Hole: 320,
    optWheel1Hole: 70,
    optWheel2Hole: 160,
    optWheel3Hole: 250,
    optWheel4Hole: 330,
    optSkunkMarkerHole: 270,
    optDoubleSkunkMarkerHole: 180
  });
  function getClashDefaults(target) {
    const t = Number(target) || 481;
    if (t === 241) return CLASH_DEFAULTS_241;
    if (t === 361) return CLASH_DEFAULTS_361;
    return CLASH_DEFAULTS_481;
  }
  var ObstacleGeometry = class _ObstacleGeometry {
    /**
     * Returns active No Passing Lane configurations.
     */
    static getNoPassingLanes(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optNoPassingLanes || settings3?.optNoPassing || isClash && settings3?.optNoPassingLanes !== false && settings3?.optNoPassing !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultStarts = isClash ? getClashDefaults(clashTargetVal).noPassingLaneStarts : [20, 50, 80, 100];
      const defaultCount = isClash ? defaultStarts.length : 2;
      const count = Math.min(4, Math.max(1, parseInt(settings3?.noPassingLaneCount || settings3?.optNoPassingLaneCount || settings3?.noPassingLanesCount, 10) || defaultCount));
      let starts = settings3?.noPassingLaneStarts || settings3?.noPassingLaneHoles;
      if (!Array.isArray(starts) || !starts.length) {
        const flatStarts = [];
        for (let i = 1; i <= 4; i++) {
          const val = settings3?.[`optNoPassingLane${i}Start`] || settings3?.[`noPassingLane${i}Start`] || settings3?.[`optNoPassingLane${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatStarts.push(Number(val));
          }
        }
        starts = flatStarts.length ? flatStarts : defaultStarts;
      }
      const maxHole = isClash ? clashTargetVal - 11 : 100;
      const lanes = [];
      for (let i = 0; i < count; i++) {
        const s = parseInt(starts[i], 10);
        if (!isNaN(s) && s >= 10 && s <= maxHole) {
          lanes.push({ start: s, end: s + 4 });
        }
      }
      return lanes;
    }
    static isInNoPassingLane(score, lanesOrSettings = {}) {
      if (!score || score <= 0) return false;
      const lanes = Array.isArray(lanesOrSettings) ? lanesOrSettings : _ObstacleGeometry.getNoPassingLanes(lanesOrSettings);
      return lanes.some((lane) => score >= lane.start && score <= lane.end);
    }
    static getNoPassingLaneForHole(score, lanesOrSettings = {}) {
      const lanes = Array.isArray(lanesOrSettings) ? lanesOrSettings : _ObstacleGeometry.getNoPassingLanes(lanesOrSettings);
      return lanes.find((lane) => score >= lane.start && score <= lane.end) || null;
    }
    /**
     * Calculates the maximum permissible score taking into account opponent blockage in No Passing Lanes.
     */
    static getNoPassingLaneMaxScore(who, currentScore, targetScore, state3 = {}, settings3 = {}, activeTracks = []) {
      if (!settings3 || !settings3.optNoPassingLanes) {
        return { allowedScore: targetScore, blocked: false, blockingPlayer: null };
      }
      const key = who;
      let maxAllowed = targetScore;
      let blockingPlayer = null;
      const tracks = activeTracks && activeTracks.length ? activeTracks : Object.keys(state3 && state3.scores || {});
      for (const other of tracks) {
        if (other === key) continue;
        const otherScore = state3 && state3.scores && state3.scores[other] || 0;
        if (otherScore > currentScore && _ObstacleGeometry.isInNoPassingLane(otherScore, settings3)) {
          const cap = otherScore - 1;
          if (cap < maxAllowed) {
            maxAllowed = cap;
            blockingPlayer = other;
          }
        }
      }
      if (maxAllowed < targetScore) {
        let resolvedCap = maxAllowed;
        let collision = true;
        while (collision && resolvedCap > currentScore) {
          collision = false;
          for (const other of tracks) {
            if (other === key) continue;
            const oScore = state3 && state3.scores && state3.scores[other] || 0;
            if (oScore === resolvedCap && _ObstacleGeometry.isInNoPassingLane(oScore, settings3)) {
              resolvedCap--;
              collision = true;
              break;
            }
          }
        }
        const finalScore = Math.max(currentScore, resolvedCap);
        return {
          allowedScore: finalScore,
          blocked: true,
          blockingPlayer
        };
      }
      return { allowedScore: targetScore, blocked: false, blockingPlayer: null };
    }
    static getJumpConfigs(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optJump || settings3?.optJumps || isClash && settings3?.optJump !== false && settings3?.optJumps !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultStarts = isClash ? getClashDefaults(clashTargetVal).jumpStarts : [15, 65, 5, 115, 25, 75, 45, 95];
      const defaultDests = isClash ? getClashDefaults(clashTargetVal).jumpDests : [35, 50, 45, 70, 55, 60, 80, 85];
      const defaultCount = isClash ? defaultStarts.length : 1;
      const count = Math.min(8, Math.max(1, parseInt(settings3?.jumpCount || settings3?.optJumpCount, 10) || defaultCount));
      let starts = settings3?.jumpStarts;
      let dests = settings3?.jumpDests;
      if (!Array.isArray(starts) || !starts.length) {
        const flatStarts = [];
        const flatDests = [];
        for (let i = 1; i <= 8; i++) {
          const sVal = settings3?.[`optJump${i}Start`] || settings3?.[`jump${i}Start`];
          const dVal = settings3?.[`optJump${i}Dest`] || settings3?.[`jump${i}Dest`];
          if (typeof sVal === "number" || typeof sVal === "string" && sVal.trim() !== "") {
            flatStarts.push(Number(sVal));
            flatDests.push(Number(dVal) || Number(sVal) + 20);
          }
        }
        if (flatStarts.length) {
          starts = flatStarts;
          dests = flatDests;
        } else {
          starts = defaultStarts;
          dests = defaultDests;
        }
      }
      const jumps = [];
      for (let i = 0; i < count; i++) {
        const s = parseInt(starts[i], 10);
        const d = parseInt(dests?.[i], 10);
        if (!isNaN(s) && !isNaN(d)) {
          const isForward = d > s;
          jumps.push({
            id: i + 1,
            start: s,
            end: isForward ? s : s + 2,
            dest: d,
            isForward
          });
        }
      }
      return jumps;
    }
    static getJumpForHole(holeNum, jumpsOrSettings = {}) {
      const jumps = Array.isArray(jumpsOrSettings) ? jumpsOrSettings : _ObstacleGeometry.getJumpConfigs(jumpsOrSettings);
      return jumps.find((j) => holeNum >= j.start && holeNum <= j.end) || null;
    }
    static getJailConfigs(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optJail || settings3?.optJails || isClash && settings3?.optJail !== false && settings3?.optJails !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultHoles = isClash ? getClashDefaults(clashTargetVal).jailHoles : [25, 75];
      const defaultCount = isClash ? defaultHoles.length : 1;
      const count = Math.min(4, Math.max(1, parseInt(settings3?.jailCount || settings3?.optJailCount, 10) || defaultCount));
      let holes = settings3?.jailHoles;
      if (!Array.isArray(holes) || !holes.length) {
        const flatHoles = [];
        for (let i = 1; i <= 4; i++) {
          const val = settings3?.[`optJail${i}Hole`] || settings3?.[`jail${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatHoles.push(Number(val));
          }
        }
        holes = flatHoles.length ? flatHoles : defaultHoles;
      }
      const maxHole = isClash ? clashTargetVal - 11 : 110;
      const jails = [];
      for (let i = 0; i < count; i++) {
        const h = parseInt(holes[i], 10);
        if (!isNaN(h) && h >= 10 && h <= maxHole) {
          jails.push({ id: i + 1, hole: h });
        }
      }
      return jails;
    }
    static getJailForHole(holeNum, jailsOrSettings = {}) {
      const jails = Array.isArray(jailsOrSettings) ? jailsOrSettings : _ObstacleGeometry.getJailConfigs(jailsOrSettings);
      return jails.find((j) => j.hole === holeNum) || null;
    }
    static getHoldingStepXY(hole, step, who = "p1", settings3 = {}, getTrackXYFn = null) {
      const trackResolver = getTrackXYFn || getTrackXY;
      const pTrack = trackResolver(hole, who, settings3);
      let dX = 0;
      let dY = 0;
      if (settings3 && [241, 361, 481].includes(settings3.target)) {
        const row = Math.floor((hole - 1) / 60);
        const pos = (hole - 1) % 60;
        if (pos >= 55) {
          dX = row % 2 === 0 ? 28 : -28;
        } else {
          dY = row === 0 || row % 2 === 0 ? -28 : 28;
        }
      } else {
        const h = hole;
        if (h <= 30) dY = -34;
        else if (h <= 35) dX = 30;
        else if (h <= 65) dY = -34;
        else if (h <= 70) dX = -30;
        else dY = 34;
      }
      const cellX = pTrack.x + dX;
      const cellY = pTrack.y + dY;
      const clampedStep = Math.max(0, Math.min(4, step));
      const frac = clampedStep / 4;
      return {
        x: cellX + frac * (pTrack.x - cellX),
        y: cellY + frac * (pTrack.y - cellY)
      };
    }
    static getJailStepXY(jailHole, step, who = "p1", settings3 = {}, getTrackXYFn = null) {
      return _ObstacleGeometry.getHoldingStepXY(jailHole, step, who, settings3, getTrackXYFn);
    }
    static getBarConfigs(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optBar || settings3?.optBars || isClash && settings3?.optBar !== false && settings3?.optBars !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultHoles = isClash ? getClashDefaults(clashTargetVal).barHoles : [40, 85];
      const defaultCount = isClash ? defaultHoles.length : 1;
      const count = Math.min(4, Math.max(1, parseInt(settings3?.barCount || settings3?.optBarCount, 10) || defaultCount));
      let holes = settings3?.barHoles;
      if (!Array.isArray(holes) || !holes.length) {
        const flatHoles = [];
        for (let i = 1; i <= 4; i++) {
          const val = settings3?.[`optBar${i}Hole`] || settings3?.[`bar${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatHoles.push(Number(val));
          }
        }
        holes = flatHoles.length ? flatHoles : defaultHoles;
      }
      const maxHole = isClash ? clashTargetVal - 11 : 110;
      const bars = [];
      for (let i = 0; i < count; i++) {
        const h = parseInt(holes[i], 10);
        if (!isNaN(h) && h >= 10 && h <= maxHole) {
          bars.push({ id: i + 1, hole: h });
        }
      }
      return bars;
    }
    static getBarForHole(holeNum, barsOrSettings = {}) {
      const bars = Array.isArray(barsOrSettings) ? barsOrSettings : _ObstacleGeometry.getBarConfigs(barsOrSettings);
      return bars.find((b) => b.hole === holeNum) || null;
    }
    static getBarStepXY(barHole, step, who = "p1", settings3 = {}, getTrackXYFn = null) {
      return _ObstacleGeometry.getHoldingStepXY(barHole, step, who, settings3, getTrackXYFn);
    }
    static getTimeoutConfigs(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optTimeout || settings3?.optTimeouts || isClash && settings3?.optTimeout !== false && settings3?.optTimeouts !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultHoles = isClash ? getClashDefaults(clashTargetVal).timeoutHoles : [30, 90];
      const defaultCount = isClash ? defaultHoles.length : 1;
      const count = Math.min(4, Math.max(1, parseInt(settings3?.timeoutCount || settings3?.optTimeoutCount, 10) || defaultCount));
      let holes = settings3?.timeoutHoles;
      if (!Array.isArray(holes) || !holes.length) {
        const flatHoles = [];
        for (let i = 1; i <= 4; i++) {
          const val = settings3?.[`optTimeout${i}Hole`] || settings3?.[`timeout${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatHoles.push(Number(val));
          }
        }
        holes = flatHoles.length ? flatHoles : defaultHoles;
      }
      const maxHole = isClash ? clashTargetVal - 11 : 110;
      const timeouts = [];
      for (let i = 0; i < count; i++) {
        const h = parseInt(holes[i], 10);
        if (!isNaN(h) && h >= 10 && h <= maxHole) {
          timeouts.push({ id: i + 1, hole: h });
        }
      }
      return timeouts;
    }
    static getTimeoutForHole(holeNum, timeoutsOrSettings = {}) {
      const timeouts = Array.isArray(timeoutsOrSettings) ? timeoutsOrSettings : _ObstacleGeometry.getTimeoutConfigs(timeoutsOrSettings);
      return timeouts.find((t) => t.hole === holeNum) || null;
    }
    static getTimeoutStepXY(timeoutHole, step, who = "p1", settings3 = {}, getTrackXYFn = null) {
      return _ObstacleGeometry.getHoldingStepXY(timeoutHole, step, who, settings3, getTrackXYFn);
    }
    static getStopSignConfigs(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optStopSign || settings3?.optStopSigns || isClash && settings3?.optStopSign !== false && settings3?.optStopSigns !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultHoles = isClash ? getClashDefaults(clashTargetVal).stopSignHoles : [20, 35, 50, 65, 80, 95, 105, 115];
      const defaultCount = isClash ? defaultHoles.length : 2;
      const count = Math.min(8, Math.max(1, parseInt(settings3?.stopSignCount || settings3?.optStopSignCount, 10) || defaultCount));
      let holes = settings3?.stopSignHoles;
      if (!Array.isArray(holes) || !holes.length) {
        const flatHoles = [];
        for (let i = 1; i <= 8; i++) {
          const val = settings3?.[`optStopSign${i}Hole`] || settings3?.[`stopSign${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatHoles.push(Number(val));
          }
        }
        holes = flatHoles.length ? flatHoles : defaultHoles;
      }
      const maxHole = isClash ? clashTargetVal - 6 : 115;
      const stopSigns = [];
      for (let i = 0; i < count; i++) {
        const h = parseInt(holes[i], 10);
        if (!isNaN(h) && h >= 5 && h <= maxHole) {
          stopSigns.push({ id: i + 1, hole: h });
        }
      }
      return stopSigns;
    }
    static getStopSignForHole(holeNum, stopSignsOrSettings = {}) {
      const signs = Array.isArray(stopSignsOrSettings) ? stopSignsOrSettings : _ObstacleGeometry.getStopSignConfigs(stopSignsOrSettings);
      return signs.find((s) => s.hole === holeNum) || null;
    }
    static getDetourConfigs(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optDetour || settings3?.optDetours || isClash && settings3?.optDetour !== false && settings3?.optDetours !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultHoles = isClash ? getClashDefaults(clashTargetVal).detourHoles : [10, 60];
      const defaultCount = isClash ? defaultHoles.length : 1;
      const count = Math.min(4, Math.max(1, parseInt(settings3?.detourCount || settings3?.optDetourCount, 10) || defaultCount));
      let holes = settings3?.detourHoles;
      if (!Array.isArray(holes) || !holes.length) {
        const flatHoles = [];
        for (let i = 1; i <= 4; i++) {
          const val = settings3?.[`optDetour${i}Hole`] || settings3?.[`detour${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatHoles.push(Number(val));
          }
        }
        holes = flatHoles.length ? flatHoles : defaultHoles;
      }
      const maxHole = isClash ? clashTargetVal - 11 : 110;
      const detours = [];
      for (let i = 0; i < count; i++) {
        const h = parseInt(holes[i], 10);
        if (!isNaN(h) && h >= 10 && h <= maxHole) {
          detours.push({ id: i + 1, hole: h });
        }
      }
      return detours;
    }
    static getDetourForHole(holeNum, detoursOrSettings = {}) {
      const detours = Array.isArray(detoursOrSettings) ? detoursOrSettings : _ObstacleGeometry.getDetourConfigs(detoursOrSettings);
      return detours.find((d) => d.hole === holeNum) || null;
    }
    static catmullRomPath(pts) {
      if (!pts || pts.length < 2) return "";
      let d = `M ${pts[0].x} ${pts[0].y}`;
      for (let i = 0; i < pts.length - 1; i++) {
        const p0 = i > 0 ? pts[i - 1] : pts[i];
        const p1 = pts[i];
        const p2 = pts[i + 1];
        const p3 = i < pts.length - 2 ? pts[i + 2] : p2;
        const cp1x = (p1.x + (p2.x - p0.x) / 6).toFixed(1);
        const cp1y = (p1.y + (p2.y - p0.y) / 6).toFixed(1);
        const cp2x = (p2.x - (p3.x - p1.x) / 6).toFixed(1);
        const cp2y = (p2.y - (p3.y - p1.y) / 6).toFixed(1);
        d += ` C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${p2.x} ${p2.y}`;
      }
      return d;
    }
    static computeLoopGeometry(holeNum, who = "p1", isRoundAbout = false, settings3 = {}, getTrackXYFn = null) {
      const trackResolver = getTrackXYFn || getTrackXY;
      const pEntry = trackResolver(holeNum, who, settings3);
      const pExit = trackResolver(holeNum + 1, who, settings3);
      const dx2 = pExit.x - pEntry.x;
      const dy2 = pExit.y - pEntry.y;
      const len = Math.hypot(dx2, dy2) || 12;
      const Tx = dx2 / len;
      const Ty = dy2 / len;
      let Nx = 0;
      let Ny = 0;
      if (settings3 && [241, 361, 481].includes(settings3.target)) {
        const row = Math.floor((holeNum - 1) / 60);
        const pos = (holeNum - 1) % 60;
        if (pos >= 55) {
          Nx = row % 2 === 0 ? 1 : -1;
          Ny = 0;
        } else {
          Nx = 0;
          Ny = row === 0 || row % 2 === 0 ? -1 : 1;
        }
      } else {
        const h = holeNum;
        if (h <= 30) {
          Nx = 0;
          Ny = -1;
        } else if (h <= 35) {
          Nx = 1;
          Ny = 0;
        } else if (h <= 65) {
          Nx = 0;
          Ny = isRoundAbout ? 1 : -1;
        } else if (h <= 70) {
          Nx = -1;
          Ny = 0;
        } else {
          Nx = 0;
          Ny = 1;
        }
      }
      const Mx = (pEntry.x + pExit.x) / 2;
      const My = (pEntry.y + pExit.y) / 2;
      const Rdist = isRoundAbout ? 20 : 9;
      const Rn = isRoundAbout ? 15 : 6.5;
      const Rt = isRoundAbout ? 16 : 7.5;
      const betaMax = isRoundAbout ? 2.5 : 2.4;
      const Cx = Mx + Nx * Rdist;
      const Cy = My + Ny * Rdist;
      return {
        pEntry,
        pExit,
        Mx,
        My,
        Tx,
        Ty,
        Nx,
        Ny,
        Cx,
        Cy,
        Rdist,
        Rn,
        Rt,
        betaMax
      };
    }
    static getDetourStepXY(detourHole, step, who = "p1", settings3 = {}, getTrackXYFn = null) {
      const geom = _ObstacleGeometry.computeLoopGeometry(detourHole, who, false, settings3, getTrackXYFn);
      if (step <= 0) return geom.pEntry;
      if (step >= 8) return geom.pExit;
      const f = Math.max(0, Math.min(8, step)) / 8;
      const beta = (f - 0.5) * 2 * geom.betaMax;
      const alongT = Math.sin(beta);
      const alongN = Math.cos(beta);
      return {
        x: geom.Cx + alongT * geom.Rt * geom.Tx + alongN * geom.Rn * geom.Nx,
        y: geom.Cy + alongT * geom.Rt * geom.Ty + alongN * geom.Rn * geom.Ny
      };
    }
    static getRoundAboutConfigs(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optRoundAbout || settings3?.optRoundAbouts || isClash && settings3?.optRoundAbout !== false && settings3?.optRoundAbouts !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultHoles = isClash ? getClashDefaults(clashTargetVal).roundAboutHoles : [35, 70];
      const defaultCount = isClash ? defaultHoles.length : 1;
      const count = Math.min(4, Math.max(1, parseInt(settings3?.roundAboutCount || settings3?.optRoundAboutCount, 10) || defaultCount));
      let holes = settings3?.roundAboutHoles;
      if (!Array.isArray(holes) || !holes.length) {
        const flatHoles = [];
        for (let i = 1; i <= 4; i++) {
          const val = settings3?.[`optRoundAbout${i}Hole`] || settings3?.[`roundAbout${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatHoles.push(Number(val));
          }
        }
        holes = flatHoles.length ? flatHoles : defaultHoles;
      }
      const maxHole = isClash ? clashTargetVal - 11 : 110;
      const roundabouts = [];
      for (let i = 0; i < count; i++) {
        const h = parseInt(holes[i], 10);
        if (!isNaN(h) && h >= 10 && h <= maxHole) {
          roundabouts.push({ id: i + 1, hole: h });
        }
      }
      return roundabouts;
    }
    static getRoundAboutForHole(holeNum, roundaboutsOrSettings = {}) {
      const roundabouts = Array.isArray(roundaboutsOrSettings) ? roundaboutsOrSettings : _ObstacleGeometry.getRoundAboutConfigs(roundaboutsOrSettings);
      return roundabouts.find((r) => r.hole === holeNum) || null;
    }
    static getRoundAboutStepXY(roundAboutHole, step, who = "p1", settings3 = {}, getTrackXYFn = null) {
      const geom = _ObstacleGeometry.computeLoopGeometry(roundAboutHole, who, true, settings3, getTrackXYFn);
      if (step <= 0) return geom.pEntry;
      if (step >= 8) return geom.pExit;
      const f = Math.max(0, Math.min(8, step)) / 8;
      const beta = (f - 0.5) * 2 * geom.betaMax;
      const alongT = Math.sin(beta);
      const alongN = Math.cos(beta);
      return {
        x: geom.Cx + alongT * geom.Rt * geom.Tx + alongN * geom.Rn * geom.Nx,
        y: geom.Cy + alongT * geom.Rt * geom.Ty + alongN * geom.Rn * geom.Ny
      };
    }
    static getSignConfigs(settings3 = {}) {
      if (settings3?.brand && settings3.brand !== "clash") return [];
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3?.target));
      const isClashBrand = settings3?.brand === "clash" || settings3?.boardId === "board-cribbage-clash" || settings3?.boardId === "board-cribbage-clash-square";
      const isClash = isClashTarget2 || isClashBrand;
      const isEnabled = Boolean(
        settings3?.optSigns || settings3?.optSign || isClash && settings3?.optSigns !== false && settings3?.optSign !== false
      );
      if (!isEnabled) return [];
      const clashTargetVal = Number(settings3?.target) || 481;
      const defaultStarts = isClash ? getClashDefaults(clashTargetVal).signsStarts || [90, 215, 450, 465] : [45, 55, 95, 105];
      const defaultBlocks = [
        { id: 1, start: defaultStarts[0] || 45, size: 2, signs: ["Plus 5", "Roll The Dice"] },
        { id: 2, start: defaultStarts[1] || 55, size: 4, signs: ["Spin The Wheel", "Plus 10", "Minus 5", "Score Plus x2"] },
        { id: 3, start: defaultStarts[2] || 95, size: 2, signs: ["Undo", "Score Plus x3"] },
        { id: 4, start: defaultStarts[3] || 105, size: 4, signs: ["Plus 5", "Minus 10", "Go To Jail", "Roll The Dice"] }
      ];
      const defaultCount = isClash ? defaultStarts.length : 4;
      const count = Math.min(8, Math.max(1, parseInt(settings3?.signsCount || settings3?.optSignsCount, 10) || defaultCount));
      let blocks = settings3?.signsBlocks;
      if (!Array.isArray(blocks) || !blocks.length) {
        const flatBlocks = [];
        for (let i = 1; i <= 8; i++) {
          const val = settings3?.[`optSigns${i}Hole`] || settings3?.[`signs${i}Hole`] || settings3?.[`optSigns${i}Start`] || settings3?.[`signs${i}Start`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatBlocks.push({
              id: i,
              start: Number(val),
              size: i % 2 === 0 ? 4 : 2,
              signs: i % 2 === 0 ? ["Spin The Wheel", "Plus 10", "Minus 5", "Score Plus x2"] : ["Plus 5", "Roll The Dice"]
            });
          }
        }
        blocks = flatBlocks.length ? flatBlocks : defaultBlocks;
      }
      const maxHole = isClash ? clashTargetVal - 11 : 110;
      const result = [];
      for (let i = 0; i < count; i++) {
        const b = blocks[i] || {};
        const s = parseInt(b.start, 10);
        const sz = parseInt(b.size, 10) === 4 ? 4 : 2;
        const pegLength = sz === 2 ? 3 : 5;
        if (!isNaN(s) && s >= 10 && s <= maxHole) {
          const fallbackSigns = sz === 2 ? ["Plus 5", "Roll The Dice"] : ["Spin The Wheel", "Plus 10", "Minus 5", "Score Plus x2"];
          const initialSigns = Array.isArray(b.signs) && b.signs.length ? b.signs.slice(0, sz) : fallbackSigns;
          result.push({
            id: i + 1,
            start: s,
            end: s + pegLength - 1,
            size: sz,
            pegLength,
            initialSigns
          });
        }
      }
      return result;
    }
    static getSignBlockForHole(h, blocksOrSettings = {}) {
      const blocks = Array.isArray(blocksOrSettings) ? blocksOrSettings : _ObstacleGeometry.getSignConfigs(blocksOrSettings);
      return blocks.find((b) => h >= b.start && h <= b.end) || null;
    }
    static getDiceConfigs(settings3 = {}) {
      if (!settings3 || !settings3.optDice || settings3.brand && settings3.brand !== "clash") return [];
      const count = Math.min(4, Math.max(1, parseInt(settings3.diceCount || settings3.optDiceCount, 10) || 1));
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3.target));
      const clashTargetVal = Number(settings3.target) || 481;
      const defaultHoles = isClashTarget2 ? getClashDefaults(clashTargetVal).diceHoles || [50, 185, 285, 410] : [20, 50, 80, 100];
      let holes = settings3.diceHoles;
      if (!Array.isArray(holes) || !holes.length) {
        const flatHoles = [];
        for (let i = 1; i <= 4; i++) {
          const val = settings3[`optDice${i}Hole`] || settings3[`dice${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatHoles.push(Number(val));
          }
        }
        holes = flatHoles.length ? flatHoles : defaultHoles;
      }
      const maxHole = isClashTarget2 ? clashTargetVal - 6 : 115;
      const dice = [];
      for (let i = 0; i < count; i++) {
        const h = parseInt(holes[i], 10);
        if (!isNaN(h) && h >= 5 && h <= maxHole) {
          dice.push({ id: i + 1, hole: h });
        }
      }
      return dice;
    }
    static getDiceForHole(holeNum, diceOrSettings = {}) {
      const dice = Array.isArray(diceOrSettings) ? diceOrSettings : _ObstacleGeometry.getDiceConfigs(diceOrSettings);
      return dice.find((d) => d.hole === holeNum) || null;
    }
    static getWheelConfigs(settings3 = {}) {
      if (!settings3 || !settings3.optWheel && !settings3.optSpinningWheel || settings3.brand && settings3.brand !== "clash") return [];
      const count = Math.min(4, Math.max(1, parseInt(settings3.wheelCount || settings3.optWheelCount || settings3.optSpinningWheelCount, 10) || 1));
      const isClashTarget2 = [241, 361, 481].includes(Number(settings3.target));
      const clashTargetVal = Number(settings3.target) || 481;
      const defaultHoles = isClashTarget2 ? getClashDefaults(clashTargetVal).wheelHoles || [65, 160, 260, 385] : [15, 45, 75, 105];
      let holes = settings3.wheelHoles;
      if (!Array.isArray(holes) || !holes.length) {
        const flatHoles = [];
        for (let i = 1; i <= 4; i++) {
          const val = settings3[`optWheel${i}Hole`] || settings3[`wheel${i}Hole`] || settings3[`optSpinningWheel${i}Hole`];
          if (typeof val === "number" || typeof val === "string" && val.trim() !== "") {
            flatHoles.push(Number(val));
          }
        }
        holes = flatHoles.length ? flatHoles : defaultHoles;
      }
      const maxHole = isClashTarget2 ? clashTargetVal - 6 : 115;
      const wheels = [];
      for (let i = 0; i < count; i++) {
        const h = parseInt(holes[i], 10);
        if (!isNaN(h) && h >= 5 && h <= maxHole) {
          wheels.push({ id: i + 1, hole: h });
        }
      }
      return wheels;
    }
    static getWheelForHole(holeNum, wheelsOrSettings = {}) {
      const wheels = Array.isArray(wheelsOrSettings) ? wheelsOrSettings : _ObstacleGeometry.getWheelConfigs(wheelsOrSettings);
      return wheels.find((w) => w.hole === holeNum) || null;
    }
  };

  // boards/default-boards.json
  var default_boards_default = [
    {
      id: "us-flag-250",
      name: "US Flag (250 Edition)",
      brand: "crazy,pints,adult",
      desc: "Sculpted American Flag cribbage board with engraved stripes and stars.",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/us-flag-250-thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/cd8a6a58625488d8/us-flag-250.glb",
      holeSpacing: 7.5,
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "maple",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 190.5,
            y: 10,
            z: 55.0003
          },
          {
            hole: 1,
            x: 172.5,
            y: 10,
            z: 55
          },
          {
            hole: 2,
            x: 165,
            y: 10,
            z: 55
          },
          {
            hole: 3,
            x: 152.5,
            y: 10,
            z: 55
          },
          {
            hole: 4,
            x: 152.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 5,
            x: 152.5,
            y: 10,
            z: 75
          },
          {
            hole: 6,
            x: 152.5,
            y: 10,
            z: 85
          },
          {
            hole: 7,
            x: 152.5,
            y: 10,
            z: 92.5
          },
          {
            hole: 8,
            x: 152.5,
            y: 10,
            z: 105
          },
          {
            hole: 9,
            x: 165,
            y: 10,
            z: 105
          },
          {
            hole: 10,
            x: 172.5,
            y: 10,
            z: 105
          },
          {
            hole: 11,
            x: 182.5,
            y: 10,
            z: 105
          },
          {
            hole: 12,
            x: 190,
            y: 10,
            z: 105
          },
          {
            hole: 13,
            x: 232.5,
            y: 10,
            z: 105
          },
          {
            hole: 14,
            x: 232.5,
            y: 10,
            z: 147.5
          },
          {
            hole: 15,
            x: 232.5,
            y: 10,
            z: 155
          },
          {
            hole: 16,
            x: 232.5,
            y: 10,
            z: 165
          },
          {
            hole: 17,
            x: 232.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 18,
            x: 232.5,
            y: 10,
            z: 215
          },
          {
            hole: 19,
            x: 190,
            y: 10,
            z: 215
          },
          {
            hole: 20,
            x: 182.5,
            y: 10,
            z: 215
          },
          {
            hole: 21,
            x: 173,
            y: 10,
            z: 215
          },
          {
            hole: 22,
            x: 165.25,
            y: 10,
            z: 215
          },
          {
            hole: 23,
            x: 157.5,
            y: 10,
            z: 215
          },
          {
            hole: 24,
            x: 149.75,
            y: 10,
            z: 215
          },
          {
            hole: 25,
            x: 142,
            y: 10,
            z: 215
          },
          {
            hole: 26,
            x: 133,
            y: 10,
            z: 215
          },
          {
            hole: 27,
            x: 125.25,
            y: 10,
            z: 215
          },
          {
            hole: 28,
            x: 117.5,
            y: 10,
            z: 215
          },
          {
            hole: 29,
            x: 109.75,
            y: 10,
            z: 215
          },
          {
            hole: 30,
            x: 102,
            y: 10,
            z: 215
          },
          {
            hole: 31,
            x: 93,
            y: 10,
            z: 215
          },
          {
            hole: 32,
            x: 85.25,
            y: 10,
            z: 215
          },
          {
            hole: 33,
            x: 77.5,
            y: 10,
            z: 215
          },
          {
            hole: 34,
            x: 69.75,
            y: 10,
            z: 215
          },
          {
            hole: 35,
            x: 62,
            y: 10,
            z: 215
          },
          {
            hole: 36,
            x: 53,
            y: 10,
            z: 215
          },
          {
            hole: 37,
            x: 45.25,
            y: 10,
            z: 215
          },
          {
            hole: 38,
            x: 37.5,
            y: 10,
            z: 215
          },
          {
            hole: 39,
            x: 29.75,
            y: 10,
            z: 215
          },
          {
            hole: 40,
            x: 22,
            y: 10,
            z: 215
          },
          {
            hole: 41,
            x: 12.5,
            y: 10,
            z: 215
          },
          {
            hole: 42,
            x: 5,
            y: 10,
            z: 215
          },
          {
            hole: 43,
            x: -37.5,
            y: 10,
            z: 215
          },
          {
            hole: 44,
            x: -37.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 45,
            x: -37.5,
            y: 10,
            z: 165
          },
          {
            hole: 46,
            x: -37.5,
            y: 10,
            z: 155
          },
          {
            hole: 47,
            x: -37.5,
            y: 10,
            z: 147.5
          },
          {
            hole: 48,
            x: -37.5,
            y: 10,
            z: 105
          },
          {
            hole: 49,
            x: 5,
            y: 10,
            z: 105
          },
          {
            hole: 50,
            x: 12.5,
            y: 10,
            z: 105
          },
          {
            hole: 51,
            x: 22.5,
            y: 10,
            z: 105
          },
          {
            hole: 52,
            x: 30,
            y: 10,
            z: 105
          },
          {
            hole: 53,
            x: 42.5,
            y: 10,
            z: 105
          },
          {
            hole: 54,
            x: 42.5,
            y: 10,
            z: 92.5
          },
          {
            hole: 55,
            x: 42.5,
            y: 10,
            z: 85
          },
          {
            hole: 56,
            x: 42.5,
            y: 10,
            z: 75
          },
          {
            hole: 57,
            x: 42.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 58,
            x: 42.5,
            y: 10,
            z: 55
          },
          {
            hole: 59,
            x: 30,
            y: 10,
            z: 55
          },
          {
            hole: 60,
            x: 22.5,
            y: 10,
            z: 55
          },
          {
            hole: 61,
            x: 13,
            y: 10,
            z: 55
          },
          {
            hole: 62,
            x: 5.25,
            y: 10,
            z: 55
          },
          {
            hole: 63,
            x: -2.5,
            y: 10,
            z: 55
          },
          {
            hole: 64,
            x: -10.25,
            y: 10,
            z: 55
          },
          {
            hole: 65,
            x: -18,
            y: 10,
            z: 55
          },
          {
            hole: 66,
            x: -27,
            y: 10,
            z: 55
          },
          {
            hole: 67,
            x: -34.75,
            y: 10,
            z: 55
          },
          {
            hole: 68,
            x: -42.5,
            y: 10,
            z: 55
          },
          {
            hole: 69,
            x: -50.25,
            y: 10,
            z: 55
          },
          {
            hole: 70,
            x: -58,
            y: 10,
            z: 55
          },
          {
            hole: 71,
            x: -67,
            y: 10,
            z: 55
          },
          {
            hole: 72,
            x: -74.75,
            y: 10,
            z: 55
          },
          {
            hole: 73,
            x: -82.5,
            y: 10,
            z: 55
          },
          {
            hole: 74,
            x: -90.25,
            y: 10,
            z: 55
          },
          {
            hole: 75,
            x: -98,
            y: 10,
            z: 55
          },
          {
            hole: 76,
            x: -107,
            y: 10,
            z: 55
          },
          {
            hole: 77,
            x: -114.75,
            y: 10,
            z: 55
          },
          {
            hole: 78,
            x: -122.5,
            y: 10,
            z: 55
          },
          {
            hole: 79,
            x: -130.25,
            y: 10,
            z: 55
          },
          {
            hole: 80,
            x: -138,
            y: 10,
            z: 55
          },
          {
            hole: 81,
            x: -147,
            y: 10,
            z: 55
          },
          {
            hole: 82,
            x: -154.75,
            y: 10,
            z: 55
          },
          {
            hole: 83,
            x: -162.5,
            y: 10,
            z: 55
          },
          {
            hole: 84,
            x: -170.25,
            y: 10,
            z: 55
          },
          {
            hole: 85,
            x: -178,
            y: 10,
            z: 55
          },
          {
            hole: 86,
            x: -187.5,
            y: 10,
            z: 55
          },
          {
            hole: 87,
            x: -195,
            y: 10,
            z: 55
          },
          {
            hole: 88,
            x: -207.5,
            y: 10,
            z: 55
          },
          {
            hole: 89,
            x: -207.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 90,
            x: -207.5,
            y: 10,
            z: 75
          },
          {
            hole: 91,
            x: -207.5,
            y: 10,
            z: 84.5
          },
          {
            hole: 92,
            x: -207.5,
            y: 10,
            z: 92.25
          },
          {
            hole: 93,
            x: -207.5,
            y: 10,
            z: 100
          },
          {
            hole: 94,
            x: -207.5,
            y: 10,
            z: 107.75
          },
          {
            hole: 95,
            x: -207.5,
            y: 10,
            z: 115.5
          },
          {
            hole: 96,
            x: -207.5,
            y: 10,
            z: 124.5
          },
          {
            hole: 97,
            x: -207.5,
            y: 10,
            z: 132.25
          },
          {
            hole: 98,
            x: -207.5,
            y: 10,
            z: 140
          },
          {
            hole: 99,
            x: -207.5,
            y: 10,
            z: 147.75
          },
          {
            hole: 100,
            x: -207.5,
            y: 10,
            z: 155.5
          },
          {
            hole: 101,
            x: -207.5,
            y: 10,
            z: 165
          },
          {
            hole: 102,
            x: -207.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 103,
            x: -207.5,
            y: 10,
            z: 185
          },
          {
            hole: 104,
            x: -195,
            y: 10,
            z: 185
          },
          {
            hole: 105,
            x: -187.5,
            y: 10,
            z: 185
          },
          {
            hole: 106,
            x: -178,
            y: 10,
            z: 185
          },
          {
            hole: 107,
            x: -170.25,
            y: 10,
            z: 185
          },
          {
            hole: 108,
            x: -162.5,
            y: 10,
            z: 185
          },
          {
            hole: 109,
            x: -154.75,
            y: 10,
            z: 185
          },
          {
            hole: 110,
            x: -147,
            y: 10,
            z: 185
          },
          {
            hole: 111,
            x: -137.5,
            y: 10,
            z: 185
          },
          {
            hole: 112,
            x: -130,
            y: 10,
            z: 185
          },
          {
            hole: 113,
            x: -117.5,
            y: 10,
            z: 185
          },
          {
            hole: 114,
            x: -117.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 115,
            x: -117.5,
            y: 10,
            z: 165
          },
          {
            hole: 116,
            x: -117.5,
            y: 10,
            z: 155.5
          },
          {
            hole: 117,
            x: -117.5,
            y: 10,
            z: 147.75
          },
          {
            hole: 118,
            x: -117.5,
            y: 10,
            z: 140
          },
          {
            hole: 119,
            x: -117.5,
            y: 10,
            z: 132.25
          },
          {
            hole: 120,
            x: -117.5,
            y: 10,
            z: 124.5
          },
          {
            hole: 121,
            x: -102.5,
            y: 10,
            z: 90
          }
        ],
        p2: [
          {
            hole: 0,
            x: 190.5,
            y: 10,
            z: 45.0003
          },
          {
            hole: 1,
            x: 172.5,
            y: 10,
            z: 45
          },
          {
            hole: 2,
            x: 165,
            y: 10,
            z: 45
          },
          {
            hole: 3,
            x: 142.5,
            y: 10,
            z: 45
          },
          {
            hole: 4,
            x: 142.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 5,
            x: 142.5,
            y: 10,
            z: 75
          },
          {
            hole: 6,
            x: 142.5,
            y: 10,
            z: 85
          },
          {
            hole: 7,
            x: 142.5,
            y: 10,
            z: 92.5
          },
          {
            hole: 8,
            x: 142.5,
            y: 10,
            z: 115
          },
          {
            hole: 9,
            x: 165,
            y: 10,
            z: 115
          },
          {
            hole: 10,
            x: 172.5,
            y: 10,
            z: 115
          },
          {
            hole: 11,
            x: 182.5,
            y: 10,
            z: 115
          },
          {
            hole: 12,
            x: 190,
            y: 10,
            z: 115
          },
          {
            hole: 13,
            x: 222.5,
            y: 10,
            z: 115
          },
          {
            hole: 14,
            x: 222.5,
            y: 10,
            z: 147.5
          },
          {
            hole: 15,
            x: 222.5,
            y: 10,
            z: 155
          },
          {
            hole: 16,
            x: 222.5,
            y: 10,
            z: 165
          },
          {
            hole: 17,
            x: 222.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 18,
            x: 222.5,
            y: 10,
            z: 205
          },
          {
            hole: 19,
            x: 190,
            y: 10,
            z: 205
          },
          {
            hole: 20,
            x: 182.5,
            y: 10,
            z: 205
          },
          {
            hole: 21,
            x: 173,
            y: 10,
            z: 205
          },
          {
            hole: 22,
            x: 165.25,
            y: 10,
            z: 205
          },
          {
            hole: 23,
            x: 157.5,
            y: 10,
            z: 205
          },
          {
            hole: 24,
            x: 149.75,
            y: 10,
            z: 205
          },
          {
            hole: 25,
            x: 142,
            y: 10,
            z: 205
          },
          {
            hole: 26,
            x: 133,
            y: 10,
            z: 205
          },
          {
            hole: 27,
            x: 125.25,
            y: 10,
            z: 205
          },
          {
            hole: 28,
            x: 117.5,
            y: 10,
            z: 205
          },
          {
            hole: 29,
            x: 109.75,
            y: 10,
            z: 205
          },
          {
            hole: 30,
            x: 102,
            y: 10,
            z: 205
          },
          {
            hole: 31,
            x: 93,
            y: 10,
            z: 205
          },
          {
            hole: 32,
            x: 85.25,
            y: 10,
            z: 205
          },
          {
            hole: 33,
            x: 77.5,
            y: 10,
            z: 205
          },
          {
            hole: 34,
            x: 69.75,
            y: 10,
            z: 205
          },
          {
            hole: 35,
            x: 62,
            y: 10,
            z: 205
          },
          {
            hole: 36,
            x: 53,
            y: 10,
            z: 205
          },
          {
            hole: 37,
            x: 45.25,
            y: 10,
            z: 205
          },
          {
            hole: 38,
            x: 37.5,
            y: 10,
            z: 205
          },
          {
            hole: 39,
            x: 29.75,
            y: 10,
            z: 205
          },
          {
            hole: 40,
            x: 22,
            y: 10,
            z: 205
          },
          {
            hole: 41,
            x: 12.5,
            y: 10,
            z: 205
          },
          {
            hole: 42,
            x: 5,
            y: 10,
            z: 205
          },
          {
            hole: 43,
            x: -27.5,
            y: 10,
            z: 205
          },
          {
            hole: 44,
            x: -27.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 45,
            x: -27.5,
            y: 10,
            z: 165
          },
          {
            hole: 46,
            x: -27.5,
            y: 10,
            z: 155
          },
          {
            hole: 47,
            x: -27.5,
            y: 10,
            z: 147.5
          },
          {
            hole: 48,
            x: -27.5,
            y: 10,
            z: 115
          },
          {
            hole: 49,
            x: 5,
            y: 10,
            z: 115
          },
          {
            hole: 50,
            x: 12.5,
            y: 10,
            z: 115
          },
          {
            hole: 51,
            x: 22.5,
            y: 10,
            z: 115
          },
          {
            hole: 52,
            x: 30,
            y: 10,
            z: 115
          },
          {
            hole: 53,
            x: 52.5,
            y: 10,
            z: 115
          },
          {
            hole: 54,
            x: 52.5,
            y: 10,
            z: 92.5
          },
          {
            hole: 55,
            x: 52.5,
            y: 10,
            z: 85
          },
          {
            hole: 56,
            x: 52.5,
            y: 10,
            z: 75
          },
          {
            hole: 57,
            x: 52.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 58,
            x: 52.5,
            y: 10,
            z: 45
          },
          {
            hole: 59,
            x: 30,
            y: 10,
            z: 45
          },
          {
            hole: 60,
            x: 22.5,
            y: 10,
            z: 45
          },
          {
            hole: 61,
            x: 13,
            y: 10,
            z: 45
          },
          {
            hole: 62,
            x: 5.25,
            y: 10,
            z: 45
          },
          {
            hole: 63,
            x: -2.5,
            y: 10,
            z: 45
          },
          {
            hole: 64,
            x: -10.25,
            y: 10,
            z: 45
          },
          {
            hole: 65,
            x: -18,
            y: 10,
            z: 45
          },
          {
            hole: 66,
            x: -27,
            y: 10,
            z: 45
          },
          {
            hole: 67,
            x: -34.75,
            y: 10,
            z: 45
          },
          {
            hole: 68,
            x: -42.5,
            y: 10,
            z: 45
          },
          {
            hole: 69,
            x: -50.25,
            y: 10,
            z: 45
          },
          {
            hole: 70,
            x: -58,
            y: 10,
            z: 45
          },
          {
            hole: 71,
            x: -67,
            y: 10,
            z: 45
          },
          {
            hole: 72,
            x: -74.75,
            y: 10,
            z: 45
          },
          {
            hole: 73,
            x: -82.5,
            y: 10,
            z: 45
          },
          {
            hole: 74,
            x: -90.25,
            y: 10,
            z: 45
          },
          {
            hole: 75,
            x: -98,
            y: 10,
            z: 45
          },
          {
            hole: 76,
            x: -107,
            y: 10,
            z: 45
          },
          {
            hole: 77,
            x: -114.75,
            y: 10,
            z: 45
          },
          {
            hole: 78,
            x: -122.5,
            y: 10,
            z: 45
          },
          {
            hole: 79,
            x: -130.25,
            y: 10,
            z: 45
          },
          {
            hole: 80,
            x: -138,
            y: 10,
            z: 45
          },
          {
            hole: 81,
            x: -147,
            y: 10,
            z: 45
          },
          {
            hole: 82,
            x: -154.75,
            y: 10,
            z: 45
          },
          {
            hole: 83,
            x: -162.5,
            y: 10,
            z: 45
          },
          {
            hole: 84,
            x: -170.25,
            y: 10,
            z: 45
          },
          {
            hole: 85,
            x: -178,
            y: 10,
            z: 45
          },
          {
            hole: 86,
            x: -187.5,
            y: 10,
            z: 45
          },
          {
            hole: 87,
            x: -195,
            y: 10,
            z: 45
          },
          {
            hole: 88,
            x: -217.5,
            y: 10,
            z: 45
          },
          {
            hole: 89,
            x: -217.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 90,
            x: -217.5,
            y: 10,
            z: 75
          },
          {
            hole: 91,
            x: -217.5,
            y: 10,
            z: 84.5
          },
          {
            hole: 92,
            x: -217.5,
            y: 10,
            z: 92.25
          },
          {
            hole: 93,
            x: -217.5,
            y: 10,
            z: 100
          },
          {
            hole: 94,
            x: -217.5,
            y: 10,
            z: 107.75
          },
          {
            hole: 95,
            x: -217.5,
            y: 10,
            z: 115.5
          },
          {
            hole: 96,
            x: -217.5,
            y: 10,
            z: 124.5
          },
          {
            hole: 97,
            x: -217.5,
            y: 10,
            z: 132.25
          },
          {
            hole: 98,
            x: -217.5,
            y: 10,
            z: 140
          },
          {
            hole: 99,
            x: -217.5,
            y: 10,
            z: 147.75
          },
          {
            hole: 100,
            x: -217.5,
            y: 10,
            z: 155.5
          },
          {
            hole: 101,
            x: -217.5,
            y: 10,
            z: 165
          },
          {
            hole: 102,
            x: -217.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 103,
            x: -217.5,
            y: 10,
            z: 195
          },
          {
            hole: 104,
            x: -195,
            y: 10,
            z: 195
          },
          {
            hole: 105,
            x: -187.5,
            y: 10,
            z: 195
          },
          {
            hole: 106,
            x: -178,
            y: 10,
            z: 195
          },
          {
            hole: 107,
            x: -170.25,
            y: 10,
            z: 195
          },
          {
            hole: 108,
            x: -162.5,
            y: 10,
            z: 195
          },
          {
            hole: 109,
            x: -154.75,
            y: 10,
            z: 195
          },
          {
            hole: 110,
            x: -147,
            y: 10,
            z: 195
          },
          {
            hole: 111,
            x: -137.5,
            y: 10,
            z: 195
          },
          {
            hole: 112,
            x: -130,
            y: 10,
            z: 195
          },
          {
            hole: 113,
            x: -107.5,
            y: 10,
            z: 195
          },
          {
            hole: 114,
            x: -107.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 115,
            x: -107.5,
            y: 10,
            z: 165
          },
          {
            hole: 116,
            x: -107.5,
            y: 10,
            z: 155.5
          },
          {
            hole: 117,
            x: -107.5,
            y: 10,
            z: 147.75
          },
          {
            hole: 118,
            x: -107.5,
            y: 10,
            z: 140
          },
          {
            hole: 119,
            x: -107.5,
            y: 10,
            z: 132.25
          },
          {
            hole: 120,
            x: -107.5,
            y: 10,
            z: 124.5
          },
          {
            hole: 121,
            x: -102.5,
            y: 10,
            z: 90
          }
        ],
        p3: [
          {
            hole: 0,
            x: 190.5,
            y: 10,
            z: 35.0003
          },
          {
            hole: 1,
            x: 172.5,
            y: 10,
            z: 35
          },
          {
            hole: 2,
            x: 165,
            y: 10,
            z: 35
          },
          {
            hole: 3,
            x: 132.5,
            y: 10,
            z: 35
          },
          {
            hole: 4,
            x: 132.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 5,
            x: 132.5,
            y: 10,
            z: 75
          },
          {
            hole: 6,
            x: 132.5,
            y: 10,
            z: 85
          },
          {
            hole: 7,
            x: 132.5,
            y: 10,
            z: 92.5
          },
          {
            hole: 8,
            x: 132.5,
            y: 10,
            z: 125
          },
          {
            hole: 9,
            x: 165,
            y: 10,
            z: 125
          },
          {
            hole: 10,
            x: 172.5,
            y: 10,
            z: 125
          },
          {
            hole: 11,
            x: 182.5,
            y: 10,
            z: 125
          },
          {
            hole: 12,
            x: 190,
            y: 10,
            z: 125
          },
          {
            hole: 13,
            x: 212.5,
            y: 10,
            z: 125
          },
          {
            hole: 14,
            x: 212.5,
            y: 10,
            z: 147.5
          },
          {
            hole: 15,
            x: 212.5,
            y: 10,
            z: 155
          },
          {
            hole: 16,
            x: 212.5,
            y: 10,
            z: 165
          },
          {
            hole: 17,
            x: 212.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 18,
            x: 212.5,
            y: 10,
            z: 195
          },
          {
            hole: 19,
            x: 190,
            y: 10,
            z: 195
          },
          {
            hole: 20,
            x: 182.5,
            y: 10,
            z: 195
          },
          {
            hole: 21,
            x: 173,
            y: 10,
            z: 195
          },
          {
            hole: 22,
            x: 165.25,
            y: 10,
            z: 195
          },
          {
            hole: 23,
            x: 157.5,
            y: 10,
            z: 195
          },
          {
            hole: 24,
            x: 149.75,
            y: 10,
            z: 195
          },
          {
            hole: 25,
            x: 142,
            y: 10,
            z: 195
          },
          {
            hole: 26,
            x: 133,
            y: 10,
            z: 195
          },
          {
            hole: 27,
            x: 125.25,
            y: 10,
            z: 195
          },
          {
            hole: 28,
            x: 117.5,
            y: 10,
            z: 195
          },
          {
            hole: 29,
            x: 109.75,
            y: 10,
            z: 195
          },
          {
            hole: 30,
            x: 102,
            y: 10,
            z: 195
          },
          {
            hole: 31,
            x: 93,
            y: 10,
            z: 195
          },
          {
            hole: 32,
            x: 85.25,
            y: 10,
            z: 195
          },
          {
            hole: 33,
            x: 77.5,
            y: 10,
            z: 195
          },
          {
            hole: 34,
            x: 69.75,
            y: 10,
            z: 195
          },
          {
            hole: 35,
            x: 62,
            y: 10,
            z: 195
          },
          {
            hole: 36,
            x: 53,
            y: 10,
            z: 195
          },
          {
            hole: 37,
            x: 45.25,
            y: 10,
            z: 195
          },
          {
            hole: 38,
            x: 37.5,
            y: 10,
            z: 195
          },
          {
            hole: 39,
            x: 29.75,
            y: 10,
            z: 195
          },
          {
            hole: 40,
            x: 22,
            y: 10,
            z: 195
          },
          {
            hole: 41,
            x: 12.5,
            y: 10,
            z: 195
          },
          {
            hole: 42,
            x: 5,
            y: 10,
            z: 195
          },
          {
            hole: 43,
            x: -17.5,
            y: 10,
            z: 195
          },
          {
            hole: 44,
            x: -17.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 45,
            x: -17.5,
            y: 10,
            z: 165
          },
          {
            hole: 46,
            x: -17.5,
            y: 10,
            z: 155
          },
          {
            hole: 47,
            x: -17.5,
            y: 10,
            z: 147.5
          },
          {
            hole: 48,
            x: -17.5,
            y: 10,
            z: 125
          },
          {
            hole: 49,
            x: 5,
            y: 10,
            z: 125
          },
          {
            hole: 50,
            x: 12.5,
            y: 10,
            z: 125
          },
          {
            hole: 51,
            x: 22.5,
            y: 10,
            z: 125
          },
          {
            hole: 52,
            x: 30,
            y: 10,
            z: 125
          },
          {
            hole: 53,
            x: 62.5,
            y: 10,
            z: 125
          },
          {
            hole: 54,
            x: 62.5,
            y: 10,
            z: 92.5
          },
          {
            hole: 55,
            x: 62.5,
            y: 10,
            z: 85
          },
          {
            hole: 56,
            x: 62.5,
            y: 10,
            z: 75
          },
          {
            hole: 57,
            x: 62.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 58,
            x: 62.5,
            y: 10,
            z: 35
          },
          {
            hole: 59,
            x: 30,
            y: 10,
            z: 35
          },
          {
            hole: 60,
            x: 22.5,
            y: 10,
            z: 35
          },
          {
            hole: 61,
            x: 13,
            y: 10,
            z: 35
          },
          {
            hole: 62,
            x: 5.25,
            y: 10,
            z: 35
          },
          {
            hole: 63,
            x: -2.5,
            y: 10,
            z: 35
          },
          {
            hole: 64,
            x: -10.25,
            y: 10,
            z: 35
          },
          {
            hole: 65,
            x: -18,
            y: 10,
            z: 35
          },
          {
            hole: 66,
            x: -27,
            y: 10,
            z: 35
          },
          {
            hole: 67,
            x: -34.75,
            y: 10,
            z: 35
          },
          {
            hole: 68,
            x: -42.5,
            y: 10,
            z: 35
          },
          {
            hole: 69,
            x: -50.25,
            y: 10,
            z: 35
          },
          {
            hole: 70,
            x: -58,
            y: 10,
            z: 35
          },
          {
            hole: 71,
            x: -67,
            y: 10,
            z: 35
          },
          {
            hole: 72,
            x: -74.75,
            y: 10,
            z: 35
          },
          {
            hole: 73,
            x: -82.5,
            y: 10,
            z: 35
          },
          {
            hole: 74,
            x: -90.25,
            y: 10,
            z: 35
          },
          {
            hole: 75,
            x: -98,
            y: 10,
            z: 35
          },
          {
            hole: 76,
            x: -107,
            y: 10,
            z: 35
          },
          {
            hole: 77,
            x: -114.75,
            y: 10,
            z: 35
          },
          {
            hole: 78,
            x: -122.5,
            y: 10,
            z: 35
          },
          {
            hole: 79,
            x: -130.25,
            y: 10,
            z: 35
          },
          {
            hole: 80,
            x: -138,
            y: 10,
            z: 35
          },
          {
            hole: 81,
            x: -147,
            y: 10,
            z: 35
          },
          {
            hole: 82,
            x: -154.75,
            y: 10,
            z: 35
          },
          {
            hole: 83,
            x: -162.5,
            y: 10,
            z: 35
          },
          {
            hole: 84,
            x: -170.25,
            y: 10,
            z: 35
          },
          {
            hole: 85,
            x: -178,
            y: 10,
            z: 35
          },
          {
            hole: 86,
            x: -187.5,
            y: 10,
            z: 35
          },
          {
            hole: 87,
            x: -195,
            y: 10,
            z: 35
          },
          {
            hole: 88,
            x: -227.5,
            y: 10,
            z: 35
          },
          {
            hole: 89,
            x: -227.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 90,
            x: -227.5,
            y: 10,
            z: 75
          },
          {
            hole: 91,
            x: -227.5,
            y: 10,
            z: 84.5
          },
          {
            hole: 92,
            x: -227.5,
            y: 10,
            z: 92.25
          },
          {
            hole: 93,
            x: -227.5,
            y: 10,
            z: 100
          },
          {
            hole: 94,
            x: -227.5,
            y: 10,
            z: 107.75
          },
          {
            hole: 95,
            x: -227.5,
            y: 10,
            z: 115.5
          },
          {
            hole: 96,
            x: -227.5,
            y: 10,
            z: 124.5
          },
          {
            hole: 97,
            x: -227.5,
            y: 10,
            z: 132.25
          },
          {
            hole: 98,
            x: -227.5,
            y: 10,
            z: 140
          },
          {
            hole: 99,
            x: -227.5,
            y: 10,
            z: 147.75
          },
          {
            hole: 100,
            x: -227.5,
            y: 10,
            z: 155.5
          },
          {
            hole: 101,
            x: -227.5,
            y: 10,
            z: 165
          },
          {
            hole: 102,
            x: -227.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 103,
            x: -227.5,
            y: 10,
            z: 205
          },
          {
            hole: 104,
            x: -195,
            y: 10,
            z: 205
          },
          {
            hole: 105,
            x: -187.5,
            y: 10,
            z: 205
          },
          {
            hole: 106,
            x: -178,
            y: 10,
            z: 205
          },
          {
            hole: 107,
            x: -170.25,
            y: 10,
            z: 205
          },
          {
            hole: 108,
            x: -162.5,
            y: 10,
            z: 205
          },
          {
            hole: 109,
            x: -154.75,
            y: 10,
            z: 205
          },
          {
            hole: 110,
            x: -147,
            y: 10,
            z: 205
          },
          {
            hole: 111,
            x: -137.5,
            y: 10,
            z: 205
          },
          {
            hole: 112,
            x: -130,
            y: 10,
            z: 205
          },
          {
            hole: 113,
            x: -97.5,
            y: 10,
            z: 205
          },
          {
            hole: 114,
            x: -97.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 115,
            x: -97.5,
            y: 10,
            z: 165
          },
          {
            hole: 116,
            x: -97.5,
            y: 10,
            z: 155.5
          },
          {
            hole: 117,
            x: -97.5,
            y: 10,
            z: 147.75
          },
          {
            hole: 118,
            x: -97.5,
            y: 10,
            z: 140
          },
          {
            hole: 119,
            x: -97.5,
            y: 10,
            z: 132.25
          },
          {
            hole: 120,
            x: -97.5,
            y: 10,
            z: 124.5
          },
          {
            hole: 121,
            x: -102.5,
            y: 10,
            z: 90
          }
        ],
        p4: [
          {
            hole: 0,
            x: 190.5,
            y: 10,
            z: 25.0003
          },
          {
            hole: 1,
            x: 172.5,
            y: 10,
            z: 25
          },
          {
            hole: 2,
            x: 165,
            y: 10,
            z: 25
          },
          {
            hole: 3,
            x: 122.5,
            y: 10,
            z: 25
          },
          {
            hole: 4,
            x: 122.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 5,
            x: 122.5,
            y: 10,
            z: 75
          },
          {
            hole: 6,
            x: 122.5,
            y: 10,
            z: 85
          },
          {
            hole: 7,
            x: 122.5,
            y: 10,
            z: 92.5
          },
          {
            hole: 8,
            x: 122.5,
            y: 10,
            z: 135
          },
          {
            hole: 9,
            x: 165,
            y: 10,
            z: 135
          },
          {
            hole: 10,
            x: 172.5,
            y: 10,
            z: 135
          },
          {
            hole: 11,
            x: 182.5,
            y: 10,
            z: 135
          },
          {
            hole: 12,
            x: 190,
            y: 10,
            z: 135
          },
          {
            hole: 13,
            x: 202.5,
            y: 10,
            z: 135
          },
          {
            hole: 14,
            x: 202.5,
            y: 10,
            z: 147.5
          },
          {
            hole: 15,
            x: 202.5,
            y: 10,
            z: 155
          },
          {
            hole: 16,
            x: 202.5,
            y: 10,
            z: 165
          },
          {
            hole: 17,
            x: 202.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 18,
            x: 202.5,
            y: 10,
            z: 185
          },
          {
            hole: 19,
            x: 190,
            y: 10,
            z: 185
          },
          {
            hole: 20,
            x: 182.5,
            y: 10,
            z: 185
          },
          {
            hole: 21,
            x: 173,
            y: 10,
            z: 185
          },
          {
            hole: 22,
            x: 165.25,
            y: 10,
            z: 185
          },
          {
            hole: 23,
            x: 157.5,
            y: 10,
            z: 185
          },
          {
            hole: 24,
            x: 149.75,
            y: 10,
            z: 185
          },
          {
            hole: 25,
            x: 142,
            y: 10,
            z: 185
          },
          {
            hole: 26,
            x: 133,
            y: 10,
            z: 185
          },
          {
            hole: 27,
            x: 125.25,
            y: 10,
            z: 185
          },
          {
            hole: 28,
            x: 117.5,
            y: 10,
            z: 185
          },
          {
            hole: 29,
            x: 109.75,
            y: 10,
            z: 185
          },
          {
            hole: 30,
            x: 102,
            y: 10,
            z: 185
          },
          {
            hole: 31,
            x: 93,
            y: 10,
            z: 185
          },
          {
            hole: 32,
            x: 85.25,
            y: 10,
            z: 185
          },
          {
            hole: 33,
            x: 77.5,
            y: 10,
            z: 185
          },
          {
            hole: 34,
            x: 69.75,
            y: 10,
            z: 185
          },
          {
            hole: 35,
            x: 62,
            y: 10,
            z: 185
          },
          {
            hole: 36,
            x: 53,
            y: 10,
            z: 185
          },
          {
            hole: 37,
            x: 45.25,
            y: 10,
            z: 185
          },
          {
            hole: 38,
            x: 37.5,
            y: 10,
            z: 185
          },
          {
            hole: 39,
            x: 29.75,
            y: 10,
            z: 185
          },
          {
            hole: 40,
            x: 22,
            y: 10,
            z: 185
          },
          {
            hole: 41,
            x: 12.5,
            y: 10,
            z: 185
          },
          {
            hole: 42,
            x: 5,
            y: 10,
            z: 185
          },
          {
            hole: 43,
            x: -7.5,
            y: 10,
            z: 185
          },
          {
            hole: 44,
            x: -7.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 45,
            x: -7.5,
            y: 10,
            z: 165
          },
          {
            hole: 46,
            x: -7.5,
            y: 10,
            z: 155
          },
          {
            hole: 47,
            x: -7.5,
            y: 10,
            z: 147.5
          },
          {
            hole: 48,
            x: -7.5,
            y: 10,
            z: 135
          },
          {
            hole: 49,
            x: 5,
            y: 10,
            z: 135
          },
          {
            hole: 50,
            x: 12.5,
            y: 10,
            z: 135
          },
          {
            hole: 51,
            x: 22.5,
            y: 10,
            z: 135
          },
          {
            hole: 52,
            x: 30,
            y: 10,
            z: 135
          },
          {
            hole: 53,
            x: 72.5,
            y: 10,
            z: 135
          },
          {
            hole: 54,
            x: 72.5,
            y: 10,
            z: 92.5
          },
          {
            hole: 55,
            x: 72.5,
            y: 10,
            z: 85
          },
          {
            hole: 56,
            x: 72.5,
            y: 10,
            z: 75
          },
          {
            hole: 57,
            x: 72.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 58,
            x: 72.5,
            y: 10,
            z: 25
          },
          {
            hole: 59,
            x: 30,
            y: 10,
            z: 25
          },
          {
            hole: 60,
            x: 22.5,
            y: 10,
            z: 25
          },
          {
            hole: 61,
            x: 13,
            y: 10,
            z: 25
          },
          {
            hole: 62,
            x: 5.25,
            y: 10,
            z: 25
          },
          {
            hole: 63,
            x: -2.5,
            y: 10,
            z: 25
          },
          {
            hole: 64,
            x: -10.25,
            y: 10,
            z: 25
          },
          {
            hole: 65,
            x: -18,
            y: 10,
            z: 25
          },
          {
            hole: 66,
            x: -27,
            y: 10,
            z: 25
          },
          {
            hole: 67,
            x: -34.75,
            y: 10,
            z: 25
          },
          {
            hole: 68,
            x: -42.5,
            y: 10,
            z: 25
          },
          {
            hole: 69,
            x: -50.25,
            y: 10,
            z: 25
          },
          {
            hole: 70,
            x: -58,
            y: 10,
            z: 25
          },
          {
            hole: 71,
            x: -67,
            y: 10,
            z: 25
          },
          {
            hole: 72,
            x: -74.75,
            y: 10,
            z: 25
          },
          {
            hole: 73,
            x: -82.5,
            y: 10,
            z: 25
          },
          {
            hole: 74,
            x: -90.25,
            y: 10,
            z: 25
          },
          {
            hole: 75,
            x: -98,
            y: 10,
            z: 25
          },
          {
            hole: 76,
            x: -107,
            y: 10,
            z: 25
          },
          {
            hole: 77,
            x: -114.75,
            y: 10,
            z: 25
          },
          {
            hole: 78,
            x: -122.5,
            y: 10,
            z: 25
          },
          {
            hole: 79,
            x: -130.25,
            y: 10,
            z: 25
          },
          {
            hole: 80,
            x: -138,
            y: 10,
            z: 25
          },
          {
            hole: 81,
            x: -147,
            y: 10,
            z: 25
          },
          {
            hole: 82,
            x: -154.75,
            y: 10,
            z: 25
          },
          {
            hole: 83,
            x: -162.5,
            y: 10,
            z: 25
          },
          {
            hole: 84,
            x: -170.25,
            y: 10,
            z: 25
          },
          {
            hole: 85,
            x: -178,
            y: 10,
            z: 25
          },
          {
            hole: 86,
            x: -187.5,
            y: 10,
            z: 25
          },
          {
            hole: 87,
            x: -195,
            y: 10,
            z: 25
          },
          {
            hole: 88,
            x: -237.5,
            y: 10,
            z: 25
          },
          {
            hole: 89,
            x: -237.5,
            y: 10,
            z: 67.5
          },
          {
            hole: 90,
            x: -237.5,
            y: 10,
            z: 75
          },
          {
            hole: 91,
            x: -237.5,
            y: 10,
            z: 84.5
          },
          {
            hole: 92,
            x: -237.5,
            y: 10,
            z: 92.25
          },
          {
            hole: 93,
            x: -237.5,
            y: 10,
            z: 100
          },
          {
            hole: 94,
            x: -237.5,
            y: 10,
            z: 107.75
          },
          {
            hole: 95,
            x: -237.5,
            y: 10,
            z: 115.5
          },
          {
            hole: 96,
            x: -237.5,
            y: 10,
            z: 124.5
          },
          {
            hole: 97,
            x: -237.5,
            y: 10,
            z: 132.25
          },
          {
            hole: 98,
            x: -237.5,
            y: 10,
            z: 140
          },
          {
            hole: 99,
            x: -237.5,
            y: 10,
            z: 147.75
          },
          {
            hole: 100,
            x: -237.5,
            y: 10,
            z: 155.5
          },
          {
            hole: 101,
            x: -237.5,
            y: 10,
            z: 165
          },
          {
            hole: 102,
            x: -237.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 103,
            x: -237.5,
            y: 10,
            z: 215
          },
          {
            hole: 104,
            x: -195,
            y: 10,
            z: 215
          },
          {
            hole: 105,
            x: -187.5,
            y: 10,
            z: 215
          },
          {
            hole: 106,
            x: -178,
            y: 10,
            z: 215
          },
          {
            hole: 107,
            x: -170.25,
            y: 10,
            z: 215
          },
          {
            hole: 108,
            x: -162.5,
            y: 10,
            z: 215
          },
          {
            hole: 109,
            x: -154.75,
            y: 10,
            z: 215
          },
          {
            hole: 110,
            x: -147,
            y: 10,
            z: 215
          },
          {
            hole: 111,
            x: -137.5,
            y: 10,
            z: 215
          },
          {
            hole: 112,
            x: -130,
            y: 10,
            z: 215
          },
          {
            hole: 113,
            x: -87.5,
            y: 10,
            z: 215
          },
          {
            hole: 114,
            x: -87.5,
            y: 10,
            z: 172.5
          },
          {
            hole: 115,
            x: -87.5,
            y: 10,
            z: 165
          },
          {
            hole: 116,
            x: -87.5,
            y: 10,
            z: 155.5
          },
          {
            hole: 117,
            x: -87.5,
            y: 10,
            z: 147.75
          },
          {
            hole: 118,
            x: -87.5,
            y: 10,
            z: 140
          },
          {
            hole: 119,
            x: -87.5,
            y: 10,
            z: 132.25
          },
          {
            hole: 120,
            x: -87.5,
            y: 10,
            z: 124.5
          },
          {
            hole: 121,
            x: -102.5,
            y: 10,
            z: 90
          }
        ]
      }
    },
    {
      id: "board-14",
      name: "Board 14",
      brand: "crazy,pints,adult",
      desc: "3D Cribbage Board.",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/14-dimensional-thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/47004d12546aac4e/14.glb",
      holeSpacing: 7.75,
      cameraDefaults: {
        fov: 44,
        alphaDeg: 20,
        betaDeg: 65,
        target: [
          15,
          44,
          -12
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: -1,
            x: 135,
            y: 15,
            z: 138.25
          },
          {
            hole: 0,
            x: 135,
            y: 15,
            z: 130.5
          },
          {
            hole: 1,
            x: 135,
            y: 25,
            z: 106.75
          },
          {
            hole: 2,
            x: 135,
            y: 25,
            z: 99
          },
          {
            hole: 3,
            x: 135,
            y: 25,
            z: 91.25
          },
          {
            hole: 4,
            x: 135,
            y: 25,
            z: 83.5
          },
          {
            hole: 5,
            x: 135,
            y: 25,
            z: 75.75
          },
          {
            hole: 6,
            x: 135,
            y: 35,
            z: 66.75
          },
          {
            hole: 7,
            x: 135,
            y: 35,
            z: 59
          },
          {
            hole: 8,
            x: 135,
            y: 35,
            z: 51.25
          },
          {
            hole: 9,
            x: 135,
            y: 35,
            z: 43.5
          },
          {
            hole: 10,
            x: 135,
            y: 35,
            z: 35.75
          },
          {
            hole: 11,
            x: 135,
            y: 45,
            z: 26.75
          },
          {
            hole: 12,
            x: 135,
            y: 45,
            z: 19
          },
          {
            hole: 13,
            x: 135,
            y: 45,
            z: 11.25
          },
          {
            hole: 14,
            x: 135,
            y: 45,
            z: 3.5
          },
          {
            hole: 15,
            x: 135,
            y: 45,
            z: -4.25
          },
          {
            hole: 16,
            x: 135,
            y: 55,
            z: -13.25
          },
          {
            hole: 17,
            x: 135,
            y: 55,
            z: -21
          },
          {
            hole: 18,
            x: 135,
            y: 55,
            z: -28.75
          },
          {
            hole: 19,
            x: 135,
            y: 55,
            z: -36.5
          },
          {
            hole: 20,
            x: 135,
            y: 55,
            z: -44.25
          },
          {
            hole: 21,
            x: 135,
            y: 65,
            z: -53.25
          },
          {
            hole: 22,
            x: 135,
            y: 65,
            z: -61
          },
          {
            hole: 23,
            x: 135,
            y: 65,
            z: -68.75
          },
          {
            hole: 24,
            x: 135,
            y: 65,
            z: -76.5
          },
          {
            hole: 25,
            x: 135,
            y: 65,
            z: -84.25
          },
          {
            hole: 26,
            x: 133.1259,
            y: 75,
            z: -101.735
          },
          {
            hole: 27,
            x: 127.6314,
            y: 75,
            z: -115
          },
          {
            hole: 28,
            x: 118.8909,
            y: 75,
            z: -126.3909
          },
          {
            hole: 29,
            x: 107.5,
            y: 75,
            z: -135.1314
          },
          {
            hole: 30,
            x: 94.235,
            y: 75,
            z: -140.6259
          },
          {
            hole: 31,
            x: 65.765,
            y: 75,
            z: -140.6259
          },
          {
            hole: 32,
            x: 52.5,
            y: 75,
            z: -135.1314
          },
          {
            hole: 33,
            x: 41.1091,
            y: 75,
            z: -126.3909
          },
          {
            hole: 34,
            x: 32.3686,
            y: 75,
            z: -115
          },
          {
            hole: 35,
            x: 26.8741,
            y: 75,
            z: -101.735
          },
          {
            hole: 36,
            x: 25,
            y: 85,
            z: -84.25
          },
          {
            hole: 37,
            x: 25,
            y: 85,
            z: -76.5
          },
          {
            hole: 38,
            x: 25,
            y: 85,
            z: -68.75
          },
          {
            hole: 39,
            x: 25,
            y: 85,
            z: -61
          },
          {
            hole: 40,
            x: 25,
            y: 85,
            z: -53.25
          },
          {
            hole: 41,
            x: 25,
            y: 95,
            z: -44.25
          },
          {
            hole: 42,
            x: 25,
            y: 95,
            z: -36.5
          },
          {
            hole: 43,
            x: 25,
            y: 95,
            z: -28.75
          },
          {
            hole: 44,
            x: 25,
            y: 95,
            z: -21
          },
          {
            hole: 45,
            x: 25,
            y: 95,
            z: -13.25
          },
          {
            hole: 46,
            x: 25,
            y: 105,
            z: -4.25
          },
          {
            hole: 47,
            x: 25,
            y: 105,
            z: 3.5
          },
          {
            hole: 48,
            x: 25,
            y: 105,
            z: 11.25
          },
          {
            hole: 49,
            x: 25,
            y: 105,
            z: 19
          },
          {
            hole: 50,
            x: 25,
            y: 105,
            z: 26.75
          },
          {
            hole: 51,
            x: 25,
            y: 115,
            z: 35.75
          },
          {
            hole: 52,
            x: 25,
            y: 115,
            z: 43.5
          },
          {
            hole: 53,
            x: 25,
            y: 115,
            z: 51.25
          },
          {
            hole: 54,
            x: 25,
            y: 115,
            z: 59
          },
          {
            hole: 55,
            x: 25,
            y: 115,
            z: 66.75
          },
          {
            hole: 56,
            x: 24.1481,
            y: 125,
            z: 77.7205
          },
          {
            hole: 57,
            x: 21.6506,
            y: 125,
            z: 83.75
          },
          {
            hole: 58,
            x: 17.6777,
            y: 125,
            z: 88.9277
          },
          {
            hole: 59,
            x: 12.5,
            y: 125,
            z: 92.9006
          },
          {
            hole: 60,
            x: 6.4705,
            y: 125,
            z: 95.3981
          },
          {
            hole: 61,
            x: -6.4705,
            y: 125,
            z: 95.3981
          },
          {
            hole: 62,
            x: -12.5,
            y: 125,
            z: 92.9006
          },
          {
            hole: 63,
            x: -17.6777,
            y: 125,
            z: 88.9277
          },
          {
            hole: 64,
            x: -21.6506,
            y: 125,
            z: 83.75
          },
          {
            hole: 65,
            x: -24.1481,
            y: 125,
            z: 77.7205
          },
          {
            hole: 66,
            x: -25,
            y: 115,
            z: 66.75
          },
          {
            hole: 67,
            x: -25,
            y: 115,
            z: 59
          },
          {
            hole: 68,
            x: -25,
            y: 115,
            z: 51.25
          },
          {
            hole: 69,
            x: -25,
            y: 115,
            z: 43.5
          },
          {
            hole: 70,
            x: -25,
            y: 115,
            z: 35.75
          },
          {
            hole: 71,
            x: -25,
            y: 105,
            z: 26.75
          },
          {
            hole: 72,
            x: -25,
            y: 105,
            z: 19
          },
          {
            hole: 73,
            x: -25,
            y: 105,
            z: 11.25
          },
          {
            hole: 74,
            x: -25,
            y: 105,
            z: 3.5
          },
          {
            hole: 75,
            x: -25,
            y: 105,
            z: -4.25
          },
          {
            hole: 76,
            x: -25,
            y: 95,
            z: -13.25
          },
          {
            hole: 77,
            x: -25,
            y: 95,
            z: -21
          },
          {
            hole: 78,
            x: -25,
            y: 95,
            z: -28.75
          },
          {
            hole: 79,
            x: -25,
            y: 95,
            z: -36.5
          },
          {
            hole: 80,
            x: -25,
            y: 95,
            z: -44.25
          },
          {
            hole: 81,
            x: -25,
            y: 85,
            z: -53.25
          },
          {
            hole: 82,
            x: -25,
            y: 85,
            z: -61
          },
          {
            hole: 83,
            x: -25,
            y: 85,
            z: -68.75
          },
          {
            hole: 84,
            x: -25,
            y: 85,
            z: -76.5
          },
          {
            hole: 85,
            x: -25,
            y: 85,
            z: -84.25
          },
          {
            hole: 86,
            x: -26.8741,
            y: 75,
            z: -101.735
          },
          {
            hole: 87,
            x: -32.3686,
            y: 75,
            z: -115
          },
          {
            hole: 88,
            x: -41.1091,
            y: 75,
            z: -126.3909
          },
          {
            hole: 89,
            x: -52.5,
            y: 75,
            z: -135.1314
          },
          {
            hole: 90,
            x: -65.765,
            y: 75,
            z: -140.6259
          },
          {
            hole: 91,
            x: -94.235,
            y: 75,
            z: -140.6259
          },
          {
            hole: 92,
            x: -107.5,
            y: 75,
            z: -135.1314
          },
          {
            hole: 93,
            x: -118.8909,
            y: 75,
            z: -126.3909
          },
          {
            hole: 94,
            x: -127.6314,
            y: 75,
            z: -115
          },
          {
            hole: 95,
            x: -133.1259,
            y: 75,
            z: -101.735
          },
          {
            hole: 96,
            x: -135,
            y: 65,
            z: -84.25
          },
          {
            hole: 97,
            x: -135,
            y: 65,
            z: -76.5
          },
          {
            hole: 98,
            x: -135,
            y: 65,
            z: -68.75
          },
          {
            hole: 99,
            x: -135,
            y: 65,
            z: -61
          },
          {
            hole: 100,
            x: -135,
            y: 65,
            z: -53.25
          },
          {
            hole: 101,
            x: -135,
            y: 55,
            z: -44.25
          },
          {
            hole: 102,
            x: -135,
            y: 55,
            z: -36.5
          },
          {
            hole: 103,
            x: -135,
            y: 55,
            z: -28.75
          },
          {
            hole: 104,
            x: -135,
            y: 55,
            z: -21
          },
          {
            hole: 105,
            x: -135,
            y: 55,
            z: -13.25
          },
          {
            hole: 106,
            x: -135,
            y: 45,
            z: -4.25
          },
          {
            hole: 107,
            x: -135,
            y: 45,
            z: 3.5
          },
          {
            hole: 108,
            x: -135,
            y: 45,
            z: 11.25
          },
          {
            hole: 109,
            x: -135,
            y: 45,
            z: 19
          },
          {
            hole: 110,
            x: -135,
            y: 45,
            z: 26.75
          },
          {
            hole: 111,
            x: -135,
            y: 35,
            z: 35.75
          },
          {
            hole: 112,
            x: -135,
            y: 35,
            z: 43.5
          },
          {
            hole: 113,
            x: -135,
            y: 35,
            z: 51.25
          },
          {
            hole: 114,
            x: -135,
            y: 35,
            z: 59
          },
          {
            hole: 115,
            x: -135,
            y: 35,
            z: 66.75
          },
          {
            hole: 116,
            x: -135,
            y: 25,
            z: 75.75
          },
          {
            hole: 117,
            x: -135,
            y: 25,
            z: 83.5
          },
          {
            hole: 118,
            x: -135,
            y: 25,
            z: 91.25
          },
          {
            hole: 119,
            x: -135,
            y: 25,
            z: 99
          },
          {
            hole: 120,
            x: -135,
            y: 25,
            z: 106.75
          },
          {
            hole: 121,
            x: -120,
            y: 15,
            z: 131.25
          }
        ],
        p2: [
          {
            hole: -1,
            x: 125,
            y: 15,
            z: 138.25
          },
          {
            hole: 0,
            x: 125,
            y: 15,
            z: 130.5
          },
          {
            hole: 1,
            x: 125,
            y: 25,
            z: 106.75
          },
          {
            hole: 2,
            x: 125,
            y: 25,
            z: 99
          },
          {
            hole: 3,
            x: 125,
            y: 25,
            z: 91.25
          },
          {
            hole: 4,
            x: 125,
            y: 25,
            z: 83.5
          },
          {
            hole: 5,
            x: 125,
            y: 25,
            z: 75.75
          },
          {
            hole: 6,
            x: 125,
            y: 35,
            z: 66.75
          },
          {
            hole: 7,
            x: 125,
            y: 35,
            z: 59
          },
          {
            hole: 8,
            x: 125,
            y: 35,
            z: 51.25
          },
          {
            hole: 9,
            x: 125,
            y: 35,
            z: 43.5
          },
          {
            hole: 10,
            x: 125,
            y: 35,
            z: 35.75
          },
          {
            hole: 11,
            x: 125,
            y: 45,
            z: 26.75
          },
          {
            hole: 12,
            x: 125,
            y: 45,
            z: 19
          },
          {
            hole: 13,
            x: 125,
            y: 45,
            z: 11.25
          },
          {
            hole: 14,
            x: 125,
            y: 45,
            z: 3.5
          },
          {
            hole: 15,
            x: 125,
            y: 45,
            z: -4.25
          },
          {
            hole: 16,
            x: 125,
            y: 55,
            z: -13.25
          },
          {
            hole: 17,
            x: 125,
            y: 55,
            z: -21
          },
          {
            hole: 18,
            x: 125,
            y: 55,
            z: -28.75
          },
          {
            hole: 19,
            x: 125,
            y: 55,
            z: -36.5
          },
          {
            hole: 20,
            x: 125,
            y: 55,
            z: -44.25
          },
          {
            hole: 21,
            x: 125,
            y: 65,
            z: -53.25
          },
          {
            hole: 22,
            x: 125,
            y: 65,
            z: -61
          },
          {
            hole: 23,
            x: 125,
            y: 65,
            z: -68.75
          },
          {
            hole: 24,
            x: 125,
            y: 65,
            z: -76.5
          },
          {
            hole: 25,
            x: 125,
            y: 65,
            z: -84.25
          },
          {
            hole: 26,
            x: 123.4667,
            y: 75,
            z: -99.1469
          },
          {
            hole: 27,
            x: 118.9711,
            y: 75,
            z: -110
          },
          {
            hole: 28,
            x: 111.8198,
            y: 75,
            z: -119.3198
          },
          {
            hole: 29,
            x: 102.5,
            y: 75,
            z: -126.4711
          },
          {
            hole: 30,
            x: 91.6469,
            y: 75,
            z: -130.9667
          },
          {
            hole: 31,
            x: 68.3531,
            y: 75,
            z: -130.9667
          },
          {
            hole: 32,
            x: 57.5,
            y: 75,
            z: -126.4711
          },
          {
            hole: 33,
            x: 48.1802,
            y: 75,
            z: -119.3198
          },
          {
            hole: 34,
            x: 41.0289,
            y: 75,
            z: -110
          },
          {
            hole: 35,
            x: 36.5333,
            y: 75,
            z: -99.1469
          },
          {
            hole: 36,
            x: 35,
            y: 85,
            z: -84.25
          },
          {
            hole: 37,
            x: 35,
            y: 85,
            z: -76.5
          },
          {
            hole: 38,
            x: 35,
            y: 85,
            z: -68.75
          },
          {
            hole: 39,
            x: 35,
            y: 85,
            z: -61
          },
          {
            hole: 40,
            x: 35,
            y: 85,
            z: -53.25
          },
          {
            hole: 41,
            x: 35,
            y: 95,
            z: -44.25
          },
          {
            hole: 42,
            x: 35,
            y: 95,
            z: -36.5
          },
          {
            hole: 43,
            x: 35,
            y: 95,
            z: -28.75
          },
          {
            hole: 44,
            x: 35,
            y: 95,
            z: -21
          },
          {
            hole: 45,
            x: 35,
            y: 95,
            z: -13.25
          },
          {
            hole: 46,
            x: 35,
            y: 105,
            z: -4.25
          },
          {
            hole: 47,
            x: 35,
            y: 105,
            z: 3.5
          },
          {
            hole: 48,
            x: 35,
            y: 105,
            z: 11.25
          },
          {
            hole: 49,
            x: 35,
            y: 105,
            z: 19
          },
          {
            hole: 50,
            x: 35,
            y: 105,
            z: 26.75
          },
          {
            hole: 51,
            x: 35,
            y: 115,
            z: 35.75
          },
          {
            hole: 52,
            x: 35,
            y: 115,
            z: 43.5
          },
          {
            hole: 53,
            x: 35,
            y: 115,
            z: 51.25
          },
          {
            hole: 54,
            x: 35,
            y: 115,
            z: 59
          },
          {
            hole: 55,
            x: 35,
            y: 115,
            z: 66.75
          },
          {
            hole: 56,
            x: 33.8074,
            y: 125,
            z: 80.3087
          },
          {
            hole: 57,
            x: 30.3109,
            y: 125,
            z: 88.75
          },
          {
            hole: 58,
            x: 24.7487,
            y: 125,
            z: 95.9987
          },
          {
            hole: 59,
            x: 17.5,
            y: 125,
            z: 101.5609
          },
          {
            hole: 60,
            x: 9.0587,
            y: 125,
            z: 105.0574
          },
          {
            hole: 61,
            x: -9.0587,
            y: 125,
            z: 105.0574
          },
          {
            hole: 62,
            x: -17.5,
            y: 125,
            z: 101.5609
          },
          {
            hole: 63,
            x: -24.7487,
            y: 125,
            z: 95.9987
          },
          {
            hole: 64,
            x: -30.3109,
            y: 125,
            z: 88.75
          },
          {
            hole: 65,
            x: -33.8074,
            y: 125,
            z: 80.3087
          },
          {
            hole: 66,
            x: -35,
            y: 115,
            z: 66.75
          },
          {
            hole: 67,
            x: -35,
            y: 115,
            z: 59
          },
          {
            hole: 68,
            x: -35,
            y: 115,
            z: 51.25
          },
          {
            hole: 69,
            x: -35,
            y: 115,
            z: 43.5
          },
          {
            hole: 70,
            x: -35,
            y: 115,
            z: 35.75
          },
          {
            hole: 71,
            x: -35,
            y: 105,
            z: 26.75
          },
          {
            hole: 72,
            x: -35,
            y: 105,
            z: 19
          },
          {
            hole: 73,
            x: -35,
            y: 105,
            z: 11.25
          },
          {
            hole: 74,
            x: -35,
            y: 105,
            z: 3.5
          },
          {
            hole: 75,
            x: -35,
            y: 105,
            z: -4.25
          },
          {
            hole: 76,
            x: -35,
            y: 95,
            z: -13.25
          },
          {
            hole: 77,
            x: -35,
            y: 95,
            z: -21
          },
          {
            hole: 78,
            x: -35,
            y: 95,
            z: -28.75
          },
          {
            hole: 79,
            x: -35,
            y: 95,
            z: -36.5
          },
          {
            hole: 80,
            x: -35,
            y: 95,
            z: -44.25
          },
          {
            hole: 81,
            x: -35,
            y: 85,
            z: -53.25
          },
          {
            hole: 82,
            x: -35,
            y: 85,
            z: -61
          },
          {
            hole: 83,
            x: -35,
            y: 85,
            z: -68.75
          },
          {
            hole: 84,
            x: -35,
            y: 85,
            z: -76.5
          },
          {
            hole: 85,
            x: -35,
            y: 85,
            z: -84.25
          },
          {
            hole: 86,
            x: -36.5333,
            y: 75,
            z: -99.1469
          },
          {
            hole: 87,
            x: -41.0289,
            y: 75,
            z: -110
          },
          {
            hole: 88,
            x: -48.1802,
            y: 75,
            z: -119.3198
          },
          {
            hole: 89,
            x: -57.5,
            y: 75,
            z: -126.4711
          },
          {
            hole: 90,
            x: -68.3531,
            y: 75,
            z: -130.9667
          },
          {
            hole: 91,
            x: -91.6469,
            y: 75,
            z: -130.9667
          },
          {
            hole: 92,
            x: -102.5,
            y: 75,
            z: -126.4711
          },
          {
            hole: 93,
            x: -111.8198,
            y: 75,
            z: -119.3198
          },
          {
            hole: 94,
            x: -118.9711,
            y: 75,
            z: -110
          },
          {
            hole: 95,
            x: -123.4667,
            y: 75,
            z: -99.1469
          },
          {
            hole: 96,
            x: -125,
            y: 65,
            z: -84.25
          },
          {
            hole: 97,
            x: -125,
            y: 65,
            z: -76.5
          },
          {
            hole: 98,
            x: -125,
            y: 65,
            z: -68.75
          },
          {
            hole: 99,
            x: -125,
            y: 65,
            z: -61
          },
          {
            hole: 100,
            x: -125,
            y: 65,
            z: -53.25
          },
          {
            hole: 101,
            x: -125,
            y: 55,
            z: -44.25
          },
          {
            hole: 102,
            x: -125,
            y: 55,
            z: -36.5
          },
          {
            hole: 103,
            x: -125,
            y: 55,
            z: -28.75
          },
          {
            hole: 104,
            x: -125,
            y: 55,
            z: -21
          },
          {
            hole: 105,
            x: -125,
            y: 55,
            z: -13.25
          },
          {
            hole: 106,
            x: -125,
            y: 45,
            z: -4.25
          },
          {
            hole: 107,
            x: -125,
            y: 45,
            z: 3.5
          },
          {
            hole: 108,
            x: -125,
            y: 45,
            z: 11.25
          },
          {
            hole: 109,
            x: -125,
            y: 45,
            z: 19
          },
          {
            hole: 110,
            x: -125,
            y: 45,
            z: 26.75
          },
          {
            hole: 111,
            x: -125,
            y: 35,
            z: 35.75
          },
          {
            hole: 112,
            x: -125,
            y: 35,
            z: 43.5
          },
          {
            hole: 113,
            x: -125,
            y: 35,
            z: 51.25
          },
          {
            hole: 114,
            x: -125,
            y: 35,
            z: 59
          },
          {
            hole: 115,
            x: -125,
            y: 35,
            z: 66.75
          },
          {
            hole: 116,
            x: -125,
            y: 25,
            z: 75.75
          },
          {
            hole: 117,
            x: -125,
            y: 25,
            z: 83.5
          },
          {
            hole: 118,
            x: -125,
            y: 25,
            z: 91.25
          },
          {
            hole: 119,
            x: -125,
            y: 25,
            z: 99
          },
          {
            hole: 120,
            x: -125,
            y: 25,
            z: 106.75
          },
          {
            hole: 121,
            x: -120,
            y: 15,
            z: 131.25
          }
        ],
        p3: [
          {
            hole: -1,
            x: 115,
            y: 15,
            z: 138.25
          },
          {
            hole: 0,
            x: 115,
            y: 15,
            z: 130.5
          },
          {
            hole: 1,
            x: 115,
            y: 25,
            z: 106.75
          },
          {
            hole: 2,
            x: 115,
            y: 25,
            z: 99
          },
          {
            hole: 3,
            x: 115,
            y: 25,
            z: 91.25
          },
          {
            hole: 4,
            x: 115,
            y: 25,
            z: 83.5
          },
          {
            hole: 5,
            x: 115,
            y: 25,
            z: 75.75
          },
          {
            hole: 6,
            x: 115,
            y: 35,
            z: 66.75
          },
          {
            hole: 7,
            x: 115,
            y: 35,
            z: 59
          },
          {
            hole: 8,
            x: 115,
            y: 35,
            z: 51.25
          },
          {
            hole: 9,
            x: 115,
            y: 35,
            z: 43.5
          },
          {
            hole: 10,
            x: 115,
            y: 35,
            z: 35.75
          },
          {
            hole: 11,
            x: 115,
            y: 45,
            z: 26.75
          },
          {
            hole: 12,
            x: 115,
            y: 45,
            z: 19
          },
          {
            hole: 13,
            x: 115,
            y: 45,
            z: 11.25
          },
          {
            hole: 14,
            x: 115,
            y: 45,
            z: 3.5
          },
          {
            hole: 15,
            x: 115,
            y: 45,
            z: -4.25
          },
          {
            hole: 16,
            x: 115,
            y: 55,
            z: -13.25
          },
          {
            hole: 17,
            x: 115,
            y: 55,
            z: -21
          },
          {
            hole: 18,
            x: 115,
            y: 55,
            z: -28.75
          },
          {
            hole: 19,
            x: 115,
            y: 55,
            z: -36.5
          },
          {
            hole: 20,
            x: 115,
            y: 55,
            z: -44.25
          },
          {
            hole: 21,
            x: 115,
            y: 65,
            z: -53.25
          },
          {
            hole: 22,
            x: 115,
            y: 65,
            z: -61
          },
          {
            hole: 23,
            x: 115,
            y: 65,
            z: -68.75
          },
          {
            hole: 24,
            x: 115,
            y: 65,
            z: -76.5
          },
          {
            hole: 25,
            x: 115,
            y: 65,
            z: -84.25
          },
          {
            hole: 26,
            x: 113.8074,
            y: 75,
            z: -96.5587
          },
          {
            hole: 27,
            x: 110.3109,
            y: 75,
            z: -105
          },
          {
            hole: 28,
            x: 104.7487,
            y: 75,
            z: -112.2487
          },
          {
            hole: 29,
            x: 97.5,
            y: 75,
            z: -117.8109
          },
          {
            hole: 30,
            x: 89.0587,
            y: 75,
            z: -121.3074
          },
          {
            hole: 31,
            x: 70.9413,
            y: 75,
            z: -121.3074
          },
          {
            hole: 32,
            x: 62.5,
            y: 75,
            z: -117.8109
          },
          {
            hole: 33,
            x: 55.2513,
            y: 75,
            z: -112.2487
          },
          {
            hole: 34,
            x: 49.6891,
            y: 75,
            z: -105
          },
          {
            hole: 35,
            x: 46.1926,
            y: 75,
            z: -96.5587
          },
          {
            hole: 36,
            x: 45,
            y: 85,
            z: -84.25
          },
          {
            hole: 37,
            x: 45,
            y: 85,
            z: -76.5
          },
          {
            hole: 38,
            x: 45,
            y: 85,
            z: -68.75
          },
          {
            hole: 39,
            x: 45,
            y: 85,
            z: -61
          },
          {
            hole: 40,
            x: 45,
            y: 85,
            z: -53.25
          },
          {
            hole: 41,
            x: 45,
            y: 95,
            z: -44.25
          },
          {
            hole: 42,
            x: 45,
            y: 95,
            z: -36.5
          },
          {
            hole: 43,
            x: 45,
            y: 95,
            z: -28.75
          },
          {
            hole: 44,
            x: 45,
            y: 95,
            z: -21
          },
          {
            hole: 45,
            x: 45,
            y: 95,
            z: -13.25
          },
          {
            hole: 46,
            x: 45,
            y: 105,
            z: -4.25
          },
          {
            hole: 47,
            x: 45,
            y: 105,
            z: 3.5
          },
          {
            hole: 48,
            x: 45,
            y: 105,
            z: 11.25
          },
          {
            hole: 49,
            x: 45,
            y: 105,
            z: 19
          },
          {
            hole: 50,
            x: 45,
            y: 105,
            z: 26.75
          },
          {
            hole: 51,
            x: 45,
            y: 115,
            z: 35.75
          },
          {
            hole: 52,
            x: 45,
            y: 115,
            z: 43.5
          },
          {
            hole: 53,
            x: 45,
            y: 115,
            z: 51.25
          },
          {
            hole: 54,
            x: 45,
            y: 115,
            z: 59
          },
          {
            hole: 55,
            x: 45,
            y: 115,
            z: 66.75
          },
          {
            hole: 56,
            x: 43.4667,
            y: 125,
            z: 82.8969
          },
          {
            hole: 57,
            x: 38.9711,
            y: 125,
            z: 93.75
          },
          {
            hole: 58,
            x: 31.8198,
            y: 125,
            z: 103.0698
          },
          {
            hole: 59,
            x: 22.5,
            y: 125,
            z: 110.2211
          },
          {
            hole: 60,
            x: 11.6469,
            y: 125,
            z: 114.7167
          },
          {
            hole: 61,
            x: -11.6469,
            y: 125,
            z: 114.7167
          },
          {
            hole: 62,
            x: -22.5,
            y: 125,
            z: 110.2211
          },
          {
            hole: 63,
            x: -31.8198,
            y: 125,
            z: 103.0698
          },
          {
            hole: 64,
            x: -38.9711,
            y: 125,
            z: 93.75
          },
          {
            hole: 65,
            x: -43.4667,
            y: 125,
            z: 82.8969
          },
          {
            hole: 66,
            x: -45,
            y: 115,
            z: 66.75
          },
          {
            hole: 67,
            x: -45,
            y: 115,
            z: 59
          },
          {
            hole: 68,
            x: -45,
            y: 115,
            z: 51.25
          },
          {
            hole: 69,
            x: -45,
            y: 115,
            z: 43.5
          },
          {
            hole: 70,
            x: -45,
            y: 115,
            z: 35.75
          },
          {
            hole: 71,
            x: -45,
            y: 105,
            z: 26.75
          },
          {
            hole: 72,
            x: -45,
            y: 105,
            z: 19
          },
          {
            hole: 73,
            x: -45,
            y: 105,
            z: 11.25
          },
          {
            hole: 74,
            x: -45,
            y: 105,
            z: 3.5
          },
          {
            hole: 75,
            x: -45,
            y: 105,
            z: -4.25
          },
          {
            hole: 76,
            x: -45,
            y: 95,
            z: -13.25
          },
          {
            hole: 77,
            x: -45,
            y: 95,
            z: -21
          },
          {
            hole: 78,
            x: -45,
            y: 95,
            z: -28.75
          },
          {
            hole: 79,
            x: -45,
            y: 95,
            z: -36.5
          },
          {
            hole: 80,
            x: -45,
            y: 95,
            z: -44.25
          },
          {
            hole: 81,
            x: -45,
            y: 85,
            z: -53.25
          },
          {
            hole: 82,
            x: -45,
            y: 85,
            z: -61
          },
          {
            hole: 83,
            x: -45,
            y: 85,
            z: -68.75
          },
          {
            hole: 84,
            x: -45,
            y: 85,
            z: -76.5
          },
          {
            hole: 85,
            x: -45,
            y: 85,
            z: -84.25
          },
          {
            hole: 86,
            x: -46.1926,
            y: 75,
            z: -96.5587
          },
          {
            hole: 87,
            x: -49.6891,
            y: 75,
            z: -105
          },
          {
            hole: 88,
            x: -55.2513,
            y: 75,
            z: -112.2487
          },
          {
            hole: 89,
            x: -62.5,
            y: 75,
            z: -117.8109
          },
          {
            hole: 90,
            x: -70.9413,
            y: 75,
            z: -121.3074
          },
          {
            hole: 91,
            x: -89.0587,
            y: 75,
            z: -121.3074
          },
          {
            hole: 92,
            x: -97.5,
            y: 75,
            z: -117.8109
          },
          {
            hole: 93,
            x: -104.7487,
            y: 75,
            z: -112.2487
          },
          {
            hole: 94,
            x: -110.3109,
            y: 75,
            z: -105
          },
          {
            hole: 95,
            x: -113.8074,
            y: 75,
            z: -96.5587
          },
          {
            hole: 96,
            x: -115,
            y: 65,
            z: -84.25
          },
          {
            hole: 97,
            x: -115,
            y: 65,
            z: -76.5
          },
          {
            hole: 98,
            x: -115,
            y: 65,
            z: -68.75
          },
          {
            hole: 99,
            x: -115,
            y: 65,
            z: -61
          },
          {
            hole: 100,
            x: -115,
            y: 65,
            z: -53.25
          },
          {
            hole: 101,
            x: -115,
            y: 55,
            z: -44.25
          },
          {
            hole: 102,
            x: -115,
            y: 55,
            z: -36.5
          },
          {
            hole: 103,
            x: -115,
            y: 55,
            z: -28.75
          },
          {
            hole: 104,
            x: -115,
            y: 55,
            z: -21
          },
          {
            hole: 105,
            x: -115,
            y: 55,
            z: -13.25
          },
          {
            hole: 106,
            x: -115,
            y: 45,
            z: -4.25
          },
          {
            hole: 107,
            x: -115,
            y: 45,
            z: 3.5
          },
          {
            hole: 108,
            x: -115,
            y: 45,
            z: 11.25
          },
          {
            hole: 109,
            x: -115,
            y: 45,
            z: 19
          },
          {
            hole: 110,
            x: -115,
            y: 45,
            z: 26.75
          },
          {
            hole: 111,
            x: -115,
            y: 35,
            z: 35.75
          },
          {
            hole: 112,
            x: -115,
            y: 35,
            z: 43.5
          },
          {
            hole: 113,
            x: -115,
            y: 35,
            z: 51.25
          },
          {
            hole: 114,
            x: -115,
            y: 35,
            z: 59
          },
          {
            hole: 115,
            x: -115,
            y: 35,
            z: 66.75
          },
          {
            hole: 116,
            x: -115,
            y: 25,
            z: 75.75
          },
          {
            hole: 117,
            x: -115,
            y: 25,
            z: 83.5
          },
          {
            hole: 118,
            x: -115,
            y: 25,
            z: 91.25
          },
          {
            hole: 119,
            x: -115,
            y: 25,
            z: 99
          },
          {
            hole: 120,
            x: -115,
            y: 25,
            z: 106.75
          },
          {
            hole: 121,
            x: -120,
            y: 15,
            z: 131.25
          }
        ],
        p4: [
          {
            hole: -1,
            x: 105,
            y: 15,
            z: 138.25
          },
          {
            hole: 0,
            x: 105,
            y: 15,
            z: 130.5
          },
          {
            hole: 1,
            x: 105,
            y: 25,
            z: 106.75
          },
          {
            hole: 2,
            x: 105,
            y: 25,
            z: 99
          },
          {
            hole: 3,
            x: 105,
            y: 25,
            z: 91.25
          },
          {
            hole: 4,
            x: 105,
            y: 25,
            z: 83.5
          },
          {
            hole: 5,
            x: 105,
            y: 25,
            z: 75.75
          },
          {
            hole: 6,
            x: 105,
            y: 35,
            z: 66.75
          },
          {
            hole: 7,
            x: 105,
            y: 35,
            z: 59
          },
          {
            hole: 8,
            x: 105,
            y: 35,
            z: 51.25
          },
          {
            hole: 9,
            x: 105,
            y: 35,
            z: 43.5
          },
          {
            hole: 10,
            x: 105,
            y: 35,
            z: 35.75
          },
          {
            hole: 11,
            x: 105,
            y: 45,
            z: 26.75
          },
          {
            hole: 12,
            x: 105,
            y: 45,
            z: 19
          },
          {
            hole: 13,
            x: 105,
            y: 45,
            z: 11.25
          },
          {
            hole: 14,
            x: 105,
            y: 45,
            z: 3.5
          },
          {
            hole: 15,
            x: 105,
            y: 45,
            z: -4.25
          },
          {
            hole: 16,
            x: 105,
            y: 55,
            z: -13.25
          },
          {
            hole: 17,
            x: 105,
            y: 55,
            z: -21
          },
          {
            hole: 18,
            x: 105,
            y: 55,
            z: -28.75
          },
          {
            hole: 19,
            x: 105,
            y: 55,
            z: -36.5
          },
          {
            hole: 20,
            x: 105,
            y: 55,
            z: -44.25
          },
          {
            hole: 21,
            x: 105,
            y: 65,
            z: -53.25
          },
          {
            hole: 22,
            x: 105,
            y: 65,
            z: -61
          },
          {
            hole: 23,
            x: 105,
            y: 65,
            z: -68.75
          },
          {
            hole: 24,
            x: 105,
            y: 65,
            z: -76.5
          },
          {
            hole: 25,
            x: 105,
            y: 65,
            z: -84.25
          },
          {
            hole: 26,
            x: 104.1481,
            y: 75,
            z: -93.9705
          },
          {
            hole: 27,
            x: 101.6506,
            y: 75,
            z: -100
          },
          {
            hole: 28,
            x: 97.6777,
            y: 75,
            z: -105.1777
          },
          {
            hole: 29,
            x: 92.5,
            y: 75,
            z: -109.1506
          },
          {
            hole: 30,
            x: 86.4705,
            y: 75,
            z: -111.6481
          },
          {
            hole: 31,
            x: 73.5295,
            y: 75,
            z: -111.6481
          },
          {
            hole: 32,
            x: 67.5,
            y: 75,
            z: -109.1506
          },
          {
            hole: 33,
            x: 62.3223,
            y: 75,
            z: -105.1777
          },
          {
            hole: 34,
            x: 58.3494,
            y: 75,
            z: -100
          },
          {
            hole: 35,
            x: 55.8519,
            y: 75,
            z: -93.9705
          },
          {
            hole: 36,
            x: 55,
            y: 85,
            z: -84.25
          },
          {
            hole: 37,
            x: 55,
            y: 85,
            z: -76.5
          },
          {
            hole: 38,
            x: 55,
            y: 85,
            z: -68.75
          },
          {
            hole: 39,
            x: 55,
            y: 85,
            z: -61
          },
          {
            hole: 40,
            x: 55,
            y: 85,
            z: -53.25
          },
          {
            hole: 41,
            x: 55,
            y: 95,
            z: -44.25
          },
          {
            hole: 42,
            x: 55,
            y: 95,
            z: -36.5
          },
          {
            hole: 43,
            x: 55,
            y: 95,
            z: -28.75
          },
          {
            hole: 44,
            x: 55,
            y: 95,
            z: -21
          },
          {
            hole: 45,
            x: 55,
            y: 95,
            z: -13.25
          },
          {
            hole: 46,
            x: 55,
            y: 105,
            z: -4.25
          },
          {
            hole: 47,
            x: 55,
            y: 105,
            z: 3.5
          },
          {
            hole: 48,
            x: 55,
            y: 105,
            z: 11.25
          },
          {
            hole: 49,
            x: 55,
            y: 105,
            z: 19
          },
          {
            hole: 50,
            x: 55,
            y: 105,
            z: 26.75
          },
          {
            hole: 51,
            x: 55,
            y: 115,
            z: 35.75
          },
          {
            hole: 52,
            x: 55,
            y: 115,
            z: 43.5
          },
          {
            hole: 53,
            x: 55,
            y: 115,
            z: 51.25
          },
          {
            hole: 54,
            x: 55,
            y: 115,
            z: 59
          },
          {
            hole: 55,
            x: 55,
            y: 115,
            z: 66.75
          },
          {
            hole: 56,
            x: 53.1259,
            y: 125,
            z: 85.485
          },
          {
            hole: 57,
            x: 47.6314,
            y: 125,
            z: 98.75
          },
          {
            hole: 58,
            x: 38.8909,
            y: 125,
            z: 110.1409
          },
          {
            hole: 59,
            x: 27.5,
            y: 125,
            z: 118.8814
          },
          {
            hole: 60,
            x: 14.235,
            y: 125,
            z: 124.3759
          },
          {
            hole: 61,
            x: -14.235,
            y: 125,
            z: 124.3759
          },
          {
            hole: 62,
            x: -27.5,
            y: 125,
            z: 118.8814
          },
          {
            hole: 63,
            x: -38.8909,
            y: 125,
            z: 110.1409
          },
          {
            hole: 64,
            x: -47.6314,
            y: 125,
            z: 98.75
          },
          {
            hole: 65,
            x: -53.1259,
            y: 125,
            z: 85.485
          },
          {
            hole: 66,
            x: -55,
            y: 115,
            z: 66.75
          },
          {
            hole: 67,
            x: -55,
            y: 115,
            z: 59
          },
          {
            hole: 68,
            x: -55,
            y: 115,
            z: 51.25
          },
          {
            hole: 69,
            x: -55,
            y: 115,
            z: 43.5
          },
          {
            hole: 70,
            x: -55,
            y: 115,
            z: 35.75
          },
          {
            hole: 71,
            x: -55,
            y: 105,
            z: 26.75
          },
          {
            hole: 72,
            x: -55,
            y: 105,
            z: 19
          },
          {
            hole: 73,
            x: -55,
            y: 105,
            z: 11.25
          },
          {
            hole: 74,
            x: -55,
            y: 105,
            z: 3.5
          },
          {
            hole: 75,
            x: -55,
            y: 105,
            z: -4.25
          },
          {
            hole: 76,
            x: -55,
            y: 95,
            z: -13.25
          },
          {
            hole: 77,
            x: -55,
            y: 95,
            z: -21
          },
          {
            hole: 78,
            x: -55,
            y: 95,
            z: -28.75
          },
          {
            hole: 79,
            x: -55,
            y: 95,
            z: -36.5
          },
          {
            hole: 80,
            x: -55,
            y: 95,
            z: -44.25
          },
          {
            hole: 81,
            x: -55,
            y: 85,
            z: -53.25
          },
          {
            hole: 82,
            x: -55,
            y: 85,
            z: -61
          },
          {
            hole: 83,
            x: -55,
            y: 85,
            z: -68.75
          },
          {
            hole: 84,
            x: -55,
            y: 85,
            z: -76.5
          },
          {
            hole: 85,
            x: -55,
            y: 85,
            z: -84.25
          },
          {
            hole: 86,
            x: -55.8519,
            y: 75,
            z: -93.9705
          },
          {
            hole: 87,
            x: -58.3494,
            y: 75,
            z: -100
          },
          {
            hole: 88,
            x: -62.3223,
            y: 75,
            z: -105.1777
          },
          {
            hole: 89,
            x: -67.5,
            y: 75,
            z: -109.1506
          },
          {
            hole: 90,
            x: -73.5295,
            y: 75,
            z: -111.6481
          },
          {
            hole: 91,
            x: -86.4705,
            y: 75,
            z: -111.6481
          },
          {
            hole: 92,
            x: -92.5,
            y: 75,
            z: -109.1506
          },
          {
            hole: 93,
            x: -97.6777,
            y: 75,
            z: -105.1777
          },
          {
            hole: 94,
            x: -101.6506,
            y: 75,
            z: -100
          },
          {
            hole: 95,
            x: -104.1481,
            y: 75,
            z: -93.9705
          },
          {
            hole: 96,
            x: -105,
            y: 65,
            z: -84.25
          },
          {
            hole: 97,
            x: -105,
            y: 65,
            z: -76.5
          },
          {
            hole: 98,
            x: -105,
            y: 65,
            z: -68.75
          },
          {
            hole: 99,
            x: -105,
            y: 65,
            z: -61
          },
          {
            hole: 100,
            x: -105,
            y: 65,
            z: -53.25
          },
          {
            hole: 101,
            x: -105,
            y: 55,
            z: -44.25
          },
          {
            hole: 102,
            x: -105,
            y: 55,
            z: -36.5
          },
          {
            hole: 103,
            x: -105,
            y: 55,
            z: -28.75
          },
          {
            hole: 104,
            x: -105,
            y: 55,
            z: -21
          },
          {
            hole: 105,
            x: -105,
            y: 55,
            z: -13.25
          },
          {
            hole: 106,
            x: -105,
            y: 45,
            z: -4.25
          },
          {
            hole: 107,
            x: -105,
            y: 45,
            z: 3.5
          },
          {
            hole: 108,
            x: -105,
            y: 45,
            z: 11.25
          },
          {
            hole: 109,
            x: -105,
            y: 45,
            z: 19
          },
          {
            hole: 110,
            x: -105,
            y: 45,
            z: 26.75
          },
          {
            hole: 111,
            x: -105,
            y: 35,
            z: 35.75
          },
          {
            hole: 112,
            x: -105,
            y: 35,
            z: 43.5
          },
          {
            hole: 113,
            x: -105,
            y: 35,
            z: 51.25
          },
          {
            hole: 114,
            x: -105,
            y: 35,
            z: 59
          },
          {
            hole: 115,
            x: -105,
            y: 35,
            z: 66.75
          },
          {
            hole: 116,
            x: -105,
            y: 25,
            z: 75.75
          },
          {
            hole: 117,
            x: -105,
            y: 25,
            z: 83.5
          },
          {
            hole: 118,
            x: -105,
            y: 25,
            z: 91.25
          },
          {
            hole: 119,
            x: -105,
            y: 25,
            z: 99
          },
          {
            hole: 120,
            x: -105,
            y: 25,
            z: 106.75
          },
          {
            hole: 121,
            x: -120,
            y: 15,
            z: 131.25
          }
        ]
      }
    },
    {
      id: "board-standard",
      name: "Standard",
      brand: "crazy,pints,adult",
      desc: "Standard 3D cribbage board.",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/standard-thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/24aee48aaf03fae0/standard.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 75,
            y: 5,
            z: 187
          },
          {
            hole: 1,
            x: 75,
            y: 5,
            z: 155.5
          },
          {
            hole: 2,
            x: 75,
            y: 5,
            z: 147.75
          },
          {
            hole: 3,
            x: 75,
            y: 5,
            z: 140
          },
          {
            hole: 4,
            x: 75,
            y: 5,
            z: 132.25
          },
          {
            hole: 5,
            x: 75,
            y: 5,
            z: 124.5
          },
          {
            hole: 6,
            x: 75,
            y: 5,
            z: 115.5
          },
          {
            hole: 7,
            x: 75,
            y: 5,
            z: 107.75
          },
          {
            hole: 8,
            x: 75,
            y: 5,
            z: 100
          },
          {
            hole: 9,
            x: 75,
            y: 5,
            z: 92.25
          },
          {
            hole: 10,
            x: 75,
            y: 5,
            z: 84.5
          },
          {
            hole: 11,
            x: 75,
            y: 5,
            z: 75.5
          },
          {
            hole: 12,
            x: 75,
            y: 5,
            z: 67.75
          },
          {
            hole: 13,
            x: 75,
            y: 5,
            z: 60
          },
          {
            hole: 14,
            x: 75,
            y: 5,
            z: 52.25
          },
          {
            hole: 15,
            x: 75,
            y: 5,
            z: 44.5
          },
          {
            hole: 16,
            x: 75,
            y: 5,
            z: 35.5
          },
          {
            hole: 17,
            x: 75,
            y: 5,
            z: 27.75
          },
          {
            hole: 18,
            x: 75,
            y: 5,
            z: 20
          },
          {
            hole: 19,
            x: 75,
            y: 5,
            z: 12.25
          },
          {
            hole: 20,
            x: 75,
            y: 5,
            z: 4.5
          },
          {
            hole: 21,
            x: 75,
            y: 5,
            z: -4.5
          },
          {
            hole: 22,
            x: 75,
            y: 5,
            z: -12.25
          },
          {
            hole: 23,
            x: 75,
            y: 5,
            z: -20
          },
          {
            hole: 24,
            x: 75,
            y: 5,
            z: -27.75
          },
          {
            hole: 25,
            x: 75,
            y: 5,
            z: -35.5
          },
          {
            hole: 26,
            x: 75,
            y: 5,
            z: -44.5
          },
          {
            hole: 27,
            x: 75,
            y: 5,
            z: -52.25
          },
          {
            hole: 28,
            x: 75,
            y: 5,
            z: -60
          },
          {
            hole: 29,
            x: 75,
            y: 5,
            z: -67.75
          },
          {
            hole: 30,
            x: 75,
            y: 5,
            z: -75.5
          },
          {
            hole: 31,
            x: 75,
            y: 5,
            z: -84.5
          },
          {
            hole: 32,
            x: 75,
            y: 5,
            z: -92.25
          },
          {
            hole: 33,
            x: 75,
            y: 5,
            z: -100
          },
          {
            hole: 34,
            x: 75,
            y: 5,
            z: -107.75
          },
          {
            hole: 35,
            x: 75,
            y: 5,
            z: -115.5
          },
          {
            hole: 36,
            x: 71.763,
            y: 5,
            z: -144.5878
          },
          {
            hole: 37,
            x: 62.2724,
            y: 5,
            z: -167.5
          },
          {
            hole: 38,
            x: 47.1751,
            y: 5,
            z: -187.1751
          },
          {
            hole: 39,
            x: 27.5,
            y: 5,
            z: -202.2724
          },
          {
            hole: 40,
            x: 4.5878,
            y: 5,
            z: -211.763
          },
          {
            hole: 41,
            x: -44.5878,
            y: 5,
            z: -211.763
          },
          {
            hole: 42,
            x: -67.5,
            y: 5,
            z: -202.2724
          },
          {
            hole: 43,
            x: -87.1751,
            y: 5,
            z: -187.1751
          },
          {
            hole: 44,
            x: -102.2724,
            y: 5,
            z: -167.5
          },
          {
            hole: 45,
            x: -111.763,
            y: 5,
            z: -144.5878
          },
          {
            hole: 46,
            x: -115,
            y: 5,
            z: -115.5
          },
          {
            hole: 47,
            x: -115,
            y: 5,
            z: -107.75
          },
          {
            hole: 48,
            x: -115,
            y: 5,
            z: -100
          },
          {
            hole: 49,
            x: -115,
            y: 5,
            z: -92.25
          },
          {
            hole: 50,
            x: -115,
            y: 5,
            z: -84.5
          },
          {
            hole: 51,
            x: -115,
            y: 5,
            z: -75.5
          },
          {
            hole: 52,
            x: -115,
            y: 5,
            z: -67.75
          },
          {
            hole: 53,
            x: -115,
            y: 5,
            z: -60
          },
          {
            hole: 54,
            x: -115,
            y: 5,
            z: -52.25
          },
          {
            hole: 55,
            x: -115,
            y: 5,
            z: -44.5
          },
          {
            hole: 56,
            x: -115,
            y: 5,
            z: -35.5
          },
          {
            hole: 57,
            x: -115,
            y: 5,
            z: -27.75
          },
          {
            hole: 58,
            x: -115,
            y: 5,
            z: -20
          },
          {
            hole: 59,
            x: -115,
            y: 5,
            z: -12.25
          },
          {
            hole: 60,
            x: -115,
            y: 5,
            z: -4.5
          },
          {
            hole: 61,
            x: -115,
            y: 5,
            z: 4.5
          },
          {
            hole: 62,
            x: -115,
            y: 5,
            z: 12.25
          },
          {
            hole: 63,
            x: -115,
            y: 5,
            z: 20
          },
          {
            hole: 64,
            x: -115,
            y: 5,
            z: 27.75
          },
          {
            hole: 65,
            x: -115,
            y: 5,
            z: 35.5
          },
          {
            hole: 66,
            x: -115,
            y: 5,
            z: 44.5
          },
          {
            hole: 67,
            x: -115,
            y: 5,
            z: 52.25
          },
          {
            hole: 68,
            x: -115,
            y: 5,
            z: 60
          },
          {
            hole: 69,
            x: -115,
            y: 5,
            z: 67.75
          },
          {
            hole: 70,
            x: -115,
            y: 5,
            z: 75.5
          },
          {
            hole: 71,
            x: -115,
            y: 5,
            z: 84.5
          },
          {
            hole: 72,
            x: -115,
            y: 5,
            z: 92.25
          },
          {
            hole: 73,
            x: -115,
            y: 5,
            z: 100
          },
          {
            hole: 74,
            x: -115,
            y: 5,
            z: 107.75
          },
          {
            hole: 75,
            x: -115,
            y: 5,
            z: 115.5
          },
          {
            hole: 76,
            x: -115,
            y: 5,
            z: 124.5
          },
          {
            hole: 77,
            x: -115,
            y: 5,
            z: 132.25
          },
          {
            hole: 78,
            x: -115,
            y: 5,
            z: 140
          },
          {
            hole: 79,
            x: -115,
            y: 5,
            z: 147.75
          },
          {
            hole: 80,
            x: -115,
            y: 5,
            z: 155.5
          },
          {
            hole: 81,
            x: -107.6314,
            y: 5,
            z: 187.5
          },
          {
            hole: 82,
            x: -87.5,
            y: 5,
            z: 207.6314
          },
          {
            hole: 83,
            x: -60,
            y: 5,
            z: 215
          },
          {
            hole: 84,
            x: -32.5,
            y: 5,
            z: 207.6314
          },
          {
            hole: 85,
            x: -12.3686,
            y: 5,
            z: 187.5
          },
          {
            hole: 86,
            x: -5,
            y: 5,
            z: 155.5
          },
          {
            hole: 87,
            x: -5,
            y: 5,
            z: 147.75
          },
          {
            hole: 88,
            x: -5,
            y: 5,
            z: 140
          },
          {
            hole: 89,
            x: -5,
            y: 5,
            z: 132.25
          },
          {
            hole: 90,
            x: -5,
            y: 5,
            z: 124.5
          },
          {
            hole: 91,
            x: -5,
            y: 5,
            z: 115.5
          },
          {
            hole: 92,
            x: -5,
            y: 5,
            z: 107.75
          },
          {
            hole: 93,
            x: -5,
            y: 5,
            z: 100
          },
          {
            hole: 94,
            x: -5,
            y: 5,
            z: 92.25
          },
          {
            hole: 95,
            x: -5,
            y: 5,
            z: 84.5
          },
          {
            hole: 96,
            x: -5,
            y: 5,
            z: 75.5
          },
          {
            hole: 97,
            x: -5,
            y: 5,
            z: 67.75
          },
          {
            hole: 98,
            x: -5,
            y: 5,
            z: 60
          },
          {
            hole: 99,
            x: -5,
            y: 5,
            z: 52.25
          },
          {
            hole: 100,
            x: -5,
            y: 5,
            z: 44.5
          },
          {
            hole: 101,
            x: -5,
            y: 5,
            z: 35.5
          },
          {
            hole: 102,
            x: -5,
            y: 5,
            z: 27.75
          },
          {
            hole: 103,
            x: -5,
            y: 5,
            z: 20
          },
          {
            hole: 104,
            x: -5,
            y: 5,
            z: 12.25
          },
          {
            hole: 105,
            x: -5,
            y: 5,
            z: 4.5
          },
          {
            hole: 106,
            x: -5,
            y: 5,
            z: -4.5
          },
          {
            hole: 107,
            x: -5,
            y: 5,
            z: -12.25
          },
          {
            hole: 108,
            x: -5,
            y: 5,
            z: -20
          },
          {
            hole: 109,
            x: -5,
            y: 5,
            z: -27.75
          },
          {
            hole: 110,
            x: -5,
            y: 5,
            z: -35.5
          },
          {
            hole: 111,
            x: -5,
            y: 5,
            z: -44.5
          },
          {
            hole: 112,
            x: -5,
            y: 5,
            z: -52.25
          },
          {
            hole: 113,
            x: -5,
            y: 5,
            z: -60
          },
          {
            hole: 114,
            x: -5,
            y: 5,
            z: -67.75
          },
          {
            hole: 115,
            x: -5,
            y: 5,
            z: -75.5
          },
          {
            hole: 116,
            x: -5,
            y: 5,
            z: -84.5
          },
          {
            hole: 117,
            x: -5,
            y: 5,
            z: -92.25
          },
          {
            hole: 118,
            x: -5,
            y: 5,
            z: -100
          },
          {
            hole: 119,
            x: -5,
            y: 5,
            z: -107.75
          },
          {
            hole: 120,
            x: -5,
            y: 5,
            z: -115.5
          },
          {
            hole: 121,
            x: -20,
            y: 5,
            z: -140
          }
        ],
        p2: [
          {
            hole: 0,
            x: 65,
            y: 5,
            z: 187
          },
          {
            hole: 1,
            x: 65,
            y: 5,
            z: 155.5
          },
          {
            hole: 2,
            x: 65,
            y: 5,
            z: 147.75
          },
          {
            hole: 3,
            x: 65,
            y: 5,
            z: 140
          },
          {
            hole: 4,
            x: 65,
            y: 5,
            z: 132.25
          },
          {
            hole: 5,
            x: 65,
            y: 5,
            z: 124.5
          },
          {
            hole: 6,
            x: 65,
            y: 5,
            z: 115.5
          },
          {
            hole: 7,
            x: 65,
            y: 5,
            z: 107.75
          },
          {
            hole: 8,
            x: 65,
            y: 5,
            z: 100
          },
          {
            hole: 9,
            x: 65,
            y: 5,
            z: 92.25
          },
          {
            hole: 10,
            x: 65,
            y: 5,
            z: 84.5
          },
          {
            hole: 11,
            x: 65,
            y: 5,
            z: 75.5
          },
          {
            hole: 12,
            x: 65,
            y: 5,
            z: 67.75
          },
          {
            hole: 13,
            x: 65,
            y: 5,
            z: 60
          },
          {
            hole: 14,
            x: 65,
            y: 5,
            z: 52.25
          },
          {
            hole: 15,
            x: 65,
            y: 5,
            z: 44.5
          },
          {
            hole: 16,
            x: 65,
            y: 5,
            z: 35.5
          },
          {
            hole: 17,
            x: 65,
            y: 5,
            z: 27.75
          },
          {
            hole: 18,
            x: 65,
            y: 5,
            z: 20
          },
          {
            hole: 19,
            x: 65,
            y: 5,
            z: 12.25
          },
          {
            hole: 20,
            x: 65,
            y: 5,
            z: 4.5
          },
          {
            hole: 21,
            x: 65,
            y: 5,
            z: -4.5
          },
          {
            hole: 22,
            x: 65,
            y: 5,
            z: -12.25
          },
          {
            hole: 23,
            x: 65,
            y: 5,
            z: -20
          },
          {
            hole: 24,
            x: 65,
            y: 5,
            z: -27.75
          },
          {
            hole: 25,
            x: 65,
            y: 5,
            z: -35.5
          },
          {
            hole: 26,
            x: 65,
            y: 5,
            z: -44.5
          },
          {
            hole: 27,
            x: 65,
            y: 5,
            z: -52.25
          },
          {
            hole: 28,
            x: 65,
            y: 5,
            z: -60
          },
          {
            hole: 29,
            x: 65,
            y: 5,
            z: -67.75
          },
          {
            hole: 30,
            x: 65,
            y: 5,
            z: -75.5
          },
          {
            hole: 31,
            x: 65,
            y: 5,
            z: -84.5
          },
          {
            hole: 32,
            x: 65,
            y: 5,
            z: -92.25
          },
          {
            hole: 33,
            x: 65,
            y: 5,
            z: -100
          },
          {
            hole: 34,
            x: 65,
            y: 5,
            z: -107.75
          },
          {
            hole: 35,
            x: 65,
            y: 5,
            z: -115.5
          },
          {
            hole: 36,
            x: 62.1037,
            y: 5,
            z: -141.9996
          },
          {
            hole: 37,
            x: 53.6122,
            y: 5,
            z: -162.5
          },
          {
            hole: 38,
            x: 40.1041,
            y: 5,
            z: -180.1041
          },
          {
            hole: 39,
            x: 22.5,
            y: 5,
            z: -193.6122
          },
          {
            hole: 40,
            x: 1.9996,
            y: 5,
            z: -202.1037
          },
          {
            hole: 41,
            x: -41.9996,
            y: 5,
            z: -202.1037
          },
          {
            hole: 42,
            x: -62.5,
            y: 5,
            z: -193.6122
          },
          {
            hole: 43,
            x: -80.1041,
            y: 5,
            z: -180.1041
          },
          {
            hole: 44,
            x: -93.6122,
            y: 5,
            z: -162.5
          },
          {
            hole: 45,
            x: -102.1037,
            y: 5,
            z: -141.9996
          },
          {
            hole: 46,
            x: -105,
            y: 5,
            z: -115.5
          },
          {
            hole: 47,
            x: -105,
            y: 5,
            z: -107.75
          },
          {
            hole: 48,
            x: -105,
            y: 5,
            z: -100
          },
          {
            hole: 49,
            x: -105,
            y: 5,
            z: -92.25
          },
          {
            hole: 50,
            x: -105,
            y: 5,
            z: -84.5
          },
          {
            hole: 51,
            x: -105,
            y: 5,
            z: -75.5
          },
          {
            hole: 52,
            x: -105,
            y: 5,
            z: -67.75
          },
          {
            hole: 53,
            x: -105,
            y: 5,
            z: -60
          },
          {
            hole: 54,
            x: -105,
            y: 5,
            z: -52.25
          },
          {
            hole: 55,
            x: -105,
            y: 5,
            z: -44.5
          },
          {
            hole: 56,
            x: -105,
            y: 5,
            z: -35.5
          },
          {
            hole: 57,
            x: -105,
            y: 5,
            z: -27.75
          },
          {
            hole: 58,
            x: -105,
            y: 5,
            z: -20
          },
          {
            hole: 59,
            x: -105,
            y: 5,
            z: -12.25
          },
          {
            hole: 60,
            x: -105,
            y: 5,
            z: -4.5
          },
          {
            hole: 61,
            x: -105,
            y: 5,
            z: 4.5
          },
          {
            hole: 62,
            x: -105,
            y: 5,
            z: 12.25
          },
          {
            hole: 63,
            x: -105,
            y: 5,
            z: 20
          },
          {
            hole: 64,
            x: -105,
            y: 5,
            z: 27.75
          },
          {
            hole: 65,
            x: -105,
            y: 5,
            z: 35.5
          },
          {
            hole: 66,
            x: -105,
            y: 5,
            z: 44.5
          },
          {
            hole: 67,
            x: -105,
            y: 5,
            z: 52.25
          },
          {
            hole: 68,
            x: -105,
            y: 5,
            z: 60
          },
          {
            hole: 69,
            x: -105,
            y: 5,
            z: 67.75
          },
          {
            hole: 70,
            x: -105,
            y: 5,
            z: 75.5
          },
          {
            hole: 71,
            x: -105,
            y: 5,
            z: 84.5
          },
          {
            hole: 72,
            x: -105,
            y: 5,
            z: 92.25
          },
          {
            hole: 73,
            x: -105,
            y: 5,
            z: 100
          },
          {
            hole: 74,
            x: -105,
            y: 5,
            z: 107.75
          },
          {
            hole: 75,
            x: -105,
            y: 5,
            z: 115.5
          },
          {
            hole: 76,
            x: -105,
            y: 5,
            z: 124.5
          },
          {
            hole: 77,
            x: -105,
            y: 5,
            z: 132.25
          },
          {
            hole: 78,
            x: -105,
            y: 5,
            z: 140
          },
          {
            hole: 79,
            x: -105,
            y: 5,
            z: 147.75
          },
          {
            hole: 80,
            x: -105,
            y: 5,
            z: 155.5
          },
          {
            hole: 81,
            x: -98.9711,
            y: 5,
            z: 182.5
          },
          {
            hole: 82,
            x: -82.5,
            y: 5,
            z: 198.9711
          },
          {
            hole: 83,
            x: -60,
            y: 5,
            z: 205
          },
          {
            hole: 84,
            x: -37.5,
            y: 5,
            z: 198.9711
          },
          {
            hole: 85,
            x: -21.0289,
            y: 5,
            z: 182.5
          },
          {
            hole: 86,
            x: -15,
            y: 5,
            z: 155.5
          },
          {
            hole: 87,
            x: -15,
            y: 5,
            z: 147.75
          },
          {
            hole: 88,
            x: -15,
            y: 5,
            z: 140
          },
          {
            hole: 89,
            x: -15,
            y: 5,
            z: 132.25
          },
          {
            hole: 90,
            x: -15,
            y: 5,
            z: 124.5
          },
          {
            hole: 91,
            x: -15,
            y: 5,
            z: 115.5
          },
          {
            hole: 92,
            x: -15,
            y: 5,
            z: 107.75
          },
          {
            hole: 93,
            x: -15,
            y: 5,
            z: 100
          },
          {
            hole: 94,
            x: -15,
            y: 5,
            z: 92.25
          },
          {
            hole: 95,
            x: -15,
            y: 5,
            z: 84.5
          },
          {
            hole: 96,
            x: -15,
            y: 5,
            z: 75.5
          },
          {
            hole: 97,
            x: -15,
            y: 5,
            z: 67.75
          },
          {
            hole: 98,
            x: -15,
            y: 5,
            z: 60
          },
          {
            hole: 99,
            x: -15,
            y: 5,
            z: 52.25
          },
          {
            hole: 100,
            x: -15,
            y: 5,
            z: 44.5
          },
          {
            hole: 101,
            x: -15,
            y: 5,
            z: 35.5
          },
          {
            hole: 102,
            x: -15,
            y: 5,
            z: 27.75
          },
          {
            hole: 103,
            x: -15,
            y: 5,
            z: 20
          },
          {
            hole: 104,
            x: -15,
            y: 5,
            z: 12.25
          },
          {
            hole: 105,
            x: -15,
            y: 5,
            z: 4.5
          },
          {
            hole: 106,
            x: -15,
            y: 5,
            z: -4.5
          },
          {
            hole: 107,
            x: -15,
            y: 5,
            z: -12.25
          },
          {
            hole: 108,
            x: -15,
            y: 5,
            z: -20
          },
          {
            hole: 109,
            x: -15,
            y: 5,
            z: -27.75
          },
          {
            hole: 110,
            x: -15,
            y: 5,
            z: -35.5
          },
          {
            hole: 111,
            x: -15,
            y: 5,
            z: -44.5
          },
          {
            hole: 112,
            x: -15,
            y: 5,
            z: -52.25
          },
          {
            hole: 113,
            x: -15,
            y: 5,
            z: -60
          },
          {
            hole: 114,
            x: -15,
            y: 5,
            z: -67.75
          },
          {
            hole: 115,
            x: -15,
            y: 5,
            z: -75.5
          },
          {
            hole: 116,
            x: -15,
            y: 5,
            z: -84.5
          },
          {
            hole: 117,
            x: -15,
            y: 5,
            z: -92.25
          },
          {
            hole: 118,
            x: -15,
            y: 5,
            z: -100
          },
          {
            hole: 119,
            x: -15,
            y: 5,
            z: -107.75
          },
          {
            hole: 120,
            x: -15,
            y: 5,
            z: -115.5
          },
          {
            hole: 121,
            x: -20,
            y: 5,
            z: -140
          }
        ],
        p3: [
          {
            hole: 0,
            x: 55,
            y: 5,
            z: 187
          },
          {
            hole: 1,
            x: 55,
            y: 5,
            z: 155.5
          },
          {
            hole: 2,
            x: 55,
            y: 5,
            z: 147.75
          },
          {
            hole: 3,
            x: 55,
            y: 5,
            z: 140
          },
          {
            hole: 4,
            x: 55,
            y: 5,
            z: 132.25
          },
          {
            hole: 5,
            x: 55,
            y: 5,
            z: 124.5
          },
          {
            hole: 6,
            x: 55,
            y: 5,
            z: 115.5
          },
          {
            hole: 7,
            x: 55,
            y: 5,
            z: 107.75
          },
          {
            hole: 8,
            x: 55,
            y: 5,
            z: 100
          },
          {
            hole: 9,
            x: 55,
            y: 5,
            z: 92.25
          },
          {
            hole: 10,
            x: 55,
            y: 5,
            z: 84.5
          },
          {
            hole: 11,
            x: 55,
            y: 5,
            z: 75.5
          },
          {
            hole: 12,
            x: 55,
            y: 5,
            z: 67.75
          },
          {
            hole: 13,
            x: 55,
            y: 5,
            z: 60
          },
          {
            hole: 14,
            x: 55,
            y: 5,
            z: 52.25
          },
          {
            hole: 15,
            x: 55,
            y: 5,
            z: 44.5
          },
          {
            hole: 16,
            x: 55,
            y: 5,
            z: 35.5
          },
          {
            hole: 17,
            x: 55,
            y: 5,
            z: 27.75
          },
          {
            hole: 18,
            x: 55,
            y: 5,
            z: 20
          },
          {
            hole: 19,
            x: 55,
            y: 5,
            z: 12.25
          },
          {
            hole: 20,
            x: 55,
            y: 5,
            z: 4.5
          },
          {
            hole: 21,
            x: 55,
            y: 5,
            z: -4.5
          },
          {
            hole: 22,
            x: 55,
            y: 5,
            z: -12.25
          },
          {
            hole: 23,
            x: 55,
            y: 5,
            z: -20
          },
          {
            hole: 24,
            x: 55,
            y: 5,
            z: -27.75
          },
          {
            hole: 25,
            x: 55,
            y: 5,
            z: -35.5
          },
          {
            hole: 26,
            x: 55,
            y: 5,
            z: -44.5
          },
          {
            hole: 27,
            x: 55,
            y: 5,
            z: -52.25
          },
          {
            hole: 28,
            x: 55,
            y: 5,
            z: -60
          },
          {
            hole: 29,
            x: 55,
            y: 5,
            z: -67.75
          },
          {
            hole: 30,
            x: 55,
            y: 5,
            z: -75.5
          },
          {
            hole: 31,
            x: 55,
            y: 5,
            z: -84.5
          },
          {
            hole: 32,
            x: 55,
            y: 5,
            z: -92.25
          },
          {
            hole: 33,
            x: 55,
            y: 5,
            z: -100
          },
          {
            hole: 34,
            x: 55,
            y: 5,
            z: -107.75
          },
          {
            hole: 35,
            x: 55,
            y: 5,
            z: -115.5
          },
          {
            hole: 36,
            x: 52.4444,
            y: 5,
            z: -139.4114
          },
          {
            hole: 37,
            x: 44.9519,
            y: 5,
            z: -157.5
          },
          {
            hole: 38,
            x: 33.033,
            y: 5,
            z: -173.033
          },
          {
            hole: 39,
            x: 17.5,
            y: 5,
            z: -184.9519
          },
          {
            hole: 40,
            x: -0.5886,
            y: 5,
            z: -192.4444
          },
          {
            hole: 41,
            x: -39.4114,
            y: 5,
            z: -192.4444
          },
          {
            hole: 42,
            x: -57.5,
            y: 5,
            z: -184.9519
          },
          {
            hole: 43,
            x: -73.033,
            y: 5,
            z: -173.033
          },
          {
            hole: 44,
            x: -84.9519,
            y: 5,
            z: -157.5
          },
          {
            hole: 45,
            x: -92.4444,
            y: 5,
            z: -139.4114
          },
          {
            hole: 46,
            x: -95,
            y: 5,
            z: -115.5
          },
          {
            hole: 47,
            x: -95,
            y: 5,
            z: -107.75
          },
          {
            hole: 48,
            x: -95,
            y: 5,
            z: -100
          },
          {
            hole: 49,
            x: -95,
            y: 5,
            z: -92.25
          },
          {
            hole: 50,
            x: -95,
            y: 5,
            z: -84.5
          },
          {
            hole: 51,
            x: -95,
            y: 5,
            z: -75.5
          },
          {
            hole: 52,
            x: -95,
            y: 5,
            z: -67.75
          },
          {
            hole: 53,
            x: -95,
            y: 5,
            z: -60
          },
          {
            hole: 54,
            x: -95,
            y: 5,
            z: -52.25
          },
          {
            hole: 55,
            x: -95,
            y: 5,
            z: -44.5
          },
          {
            hole: 56,
            x: -95,
            y: 5,
            z: -35.5
          },
          {
            hole: 57,
            x: -95,
            y: 5,
            z: -27.75
          },
          {
            hole: 58,
            x: -95,
            y: 5,
            z: -20
          },
          {
            hole: 59,
            x: -95,
            y: 5,
            z: -12.25
          },
          {
            hole: 60,
            x: -95,
            y: 5,
            z: -4.5
          },
          {
            hole: 61,
            x: -95,
            y: 5,
            z: 4.5
          },
          {
            hole: 62,
            x: -95,
            y: 5,
            z: 12.25
          },
          {
            hole: 63,
            x: -95,
            y: 5,
            z: 20
          },
          {
            hole: 64,
            x: -95,
            y: 5,
            z: 27.75
          },
          {
            hole: 65,
            x: -95,
            y: 5,
            z: 35.5
          },
          {
            hole: 66,
            x: -95,
            y: 5,
            z: 44.5
          },
          {
            hole: 67,
            x: -95,
            y: 5,
            z: 52.25
          },
          {
            hole: 68,
            x: -95,
            y: 5,
            z: 60
          },
          {
            hole: 69,
            x: -95,
            y: 5,
            z: 67.75
          },
          {
            hole: 70,
            x: -95,
            y: 5,
            z: 75.5
          },
          {
            hole: 71,
            x: -95,
            y: 5,
            z: 84.5
          },
          {
            hole: 72,
            x: -95,
            y: 5,
            z: 92.25
          },
          {
            hole: 73,
            x: -95,
            y: 5,
            z: 100
          },
          {
            hole: 74,
            x: -95,
            y: 5,
            z: 107.75
          },
          {
            hole: 75,
            x: -95,
            y: 5,
            z: 115.5
          },
          {
            hole: 76,
            x: -95,
            y: 5,
            z: 124.5
          },
          {
            hole: 77,
            x: -95,
            y: 5,
            z: 132.25
          },
          {
            hole: 78,
            x: -95,
            y: 5,
            z: 140
          },
          {
            hole: 79,
            x: -95,
            y: 5,
            z: 147.75
          },
          {
            hole: 80,
            x: -95,
            y: 5,
            z: 155.5
          },
          {
            hole: 81,
            x: -90.3109,
            y: 5,
            z: 177.5
          },
          {
            hole: 82,
            x: -77.5,
            y: 5,
            z: 190.3109
          },
          {
            hole: 83,
            x: -60,
            y: 5,
            z: 195
          },
          {
            hole: 84,
            x: -42.5,
            y: 5,
            z: 190.3109
          },
          {
            hole: 85,
            x: -29.6891,
            y: 5,
            z: 177.5
          },
          {
            hole: 86,
            x: -25,
            y: 5,
            z: 155.5
          },
          {
            hole: 87,
            x: -25,
            y: 5,
            z: 147.75
          },
          {
            hole: 88,
            x: -25,
            y: 5,
            z: 140
          },
          {
            hole: 89,
            x: -25,
            y: 5,
            z: 132.25
          },
          {
            hole: 90,
            x: -25,
            y: 5,
            z: 124.5
          },
          {
            hole: 91,
            x: -25,
            y: 5,
            z: 115.5
          },
          {
            hole: 92,
            x: -25,
            y: 5,
            z: 107.75
          },
          {
            hole: 93,
            x: -25,
            y: 5,
            z: 100
          },
          {
            hole: 94,
            x: -25,
            y: 5,
            z: 92.25
          },
          {
            hole: 95,
            x: -25,
            y: 5,
            z: 84.5
          },
          {
            hole: 96,
            x: -25,
            y: 5,
            z: 75.5
          },
          {
            hole: 97,
            x: -25,
            y: 5,
            z: 67.75
          },
          {
            hole: 98,
            x: -25,
            y: 5,
            z: 60
          },
          {
            hole: 99,
            x: -25,
            y: 5,
            z: 52.25
          },
          {
            hole: 100,
            x: -25,
            y: 5,
            z: 44.5
          },
          {
            hole: 101,
            x: -25,
            y: 5,
            z: 35.5
          },
          {
            hole: 102,
            x: -25,
            y: 5,
            z: 27.75
          },
          {
            hole: 103,
            x: -25,
            y: 5,
            z: 20
          },
          {
            hole: 104,
            x: -25,
            y: 5,
            z: 12.25
          },
          {
            hole: 105,
            x: -25,
            y: 5,
            z: 4.5
          },
          {
            hole: 106,
            x: -25,
            y: 5,
            z: -4.5
          },
          {
            hole: 107,
            x: -25,
            y: 5,
            z: -12.25
          },
          {
            hole: 108,
            x: -25,
            y: 5,
            z: -20
          },
          {
            hole: 109,
            x: -25,
            y: 5,
            z: -27.75
          },
          {
            hole: 110,
            x: -25,
            y: 5,
            z: -35.5
          },
          {
            hole: 111,
            x: -25,
            y: 5,
            z: -44.5
          },
          {
            hole: 112,
            x: -25,
            y: 5,
            z: -52.25
          },
          {
            hole: 113,
            x: -25,
            y: 5,
            z: -60
          },
          {
            hole: 114,
            x: -25,
            y: 5,
            z: -67.75
          },
          {
            hole: 115,
            x: -25,
            y: 5,
            z: -75.5
          },
          {
            hole: 116,
            x: -25,
            y: 5,
            z: -84.5
          },
          {
            hole: 117,
            x: -25,
            y: 5,
            z: -92.25
          },
          {
            hole: 118,
            x: -25,
            y: 5,
            z: -100
          },
          {
            hole: 119,
            x: -25,
            y: 5,
            z: -107.75
          },
          {
            hole: 120,
            x: -25,
            y: 5,
            z: -115.5
          },
          {
            hole: 121,
            x: -20,
            y: 5,
            z: -140
          }
        ],
        p4: [
          {
            hole: 0,
            x: 45,
            y: 5,
            z: 187
          },
          {
            hole: 1,
            x: 45,
            y: 5,
            z: 155.5
          },
          {
            hole: 2,
            x: 45,
            y: 5,
            z: 147.75
          },
          {
            hole: 3,
            x: 45,
            y: 5,
            z: 140
          },
          {
            hole: 4,
            x: 45,
            y: 5,
            z: 132.25
          },
          {
            hole: 5,
            x: 45,
            y: 5,
            z: 124.5
          },
          {
            hole: 6,
            x: 45,
            y: 5,
            z: 115.5
          },
          {
            hole: 7,
            x: 45,
            y: 5,
            z: 107.75
          },
          {
            hole: 8,
            x: 45,
            y: 5,
            z: 100
          },
          {
            hole: 9,
            x: 45,
            y: 5,
            z: 92.25
          },
          {
            hole: 10,
            x: 45,
            y: 5,
            z: 84.5
          },
          {
            hole: 11,
            x: 45,
            y: 5,
            z: 75.5
          },
          {
            hole: 12,
            x: 45,
            y: 5,
            z: 67.75
          },
          {
            hole: 13,
            x: 45,
            y: 5,
            z: 60
          },
          {
            hole: 14,
            x: 45,
            y: 5,
            z: 52.25
          },
          {
            hole: 15,
            x: 45,
            y: 5,
            z: 44.5
          },
          {
            hole: 16,
            x: 45,
            y: 5,
            z: 35.5
          },
          {
            hole: 17,
            x: 45,
            y: 5,
            z: 27.75
          },
          {
            hole: 18,
            x: 45,
            y: 5,
            z: 20
          },
          {
            hole: 19,
            x: 45,
            y: 5,
            z: 12.25
          },
          {
            hole: 20,
            x: 45,
            y: 5,
            z: 4.5
          },
          {
            hole: 21,
            x: 45,
            y: 5,
            z: -4.5
          },
          {
            hole: 22,
            x: 45,
            y: 5,
            z: -12.25
          },
          {
            hole: 23,
            x: 45,
            y: 5,
            z: -20
          },
          {
            hole: 24,
            x: 45,
            y: 5,
            z: -27.75
          },
          {
            hole: 25,
            x: 45,
            y: 5,
            z: -35.5
          },
          {
            hole: 26,
            x: 45,
            y: 5,
            z: -44.5
          },
          {
            hole: 27,
            x: 45,
            y: 5,
            z: -52.25
          },
          {
            hole: 28,
            x: 45,
            y: 5,
            z: -60
          },
          {
            hole: 29,
            x: 45,
            y: 5,
            z: -67.75
          },
          {
            hole: 30,
            x: 45,
            y: 5,
            z: -75.5
          },
          {
            hole: 31,
            x: 45,
            y: 5,
            z: -84.5
          },
          {
            hole: 32,
            x: 45,
            y: 5,
            z: -92.25
          },
          {
            hole: 33,
            x: 45,
            y: 5,
            z: -100
          },
          {
            hole: 34,
            x: 45,
            y: 5,
            z: -107.75
          },
          {
            hole: 35,
            x: 45,
            y: 5,
            z: -115.5
          },
          {
            hole: 36,
            x: 42.7852,
            y: 5,
            z: -136.8232
          },
          {
            hole: 37,
            x: 36.2917,
            y: 5,
            z: -152.5
          },
          {
            hole: 38,
            x: 25.9619,
            y: 5,
            z: -165.9619
          },
          {
            hole: 39,
            x: 12.5,
            y: 5,
            z: -176.2917
          },
          {
            hole: 40,
            x: -3.1768,
            y: 5,
            z: -182.7852
          },
          {
            hole: 41,
            x: -36.8232,
            y: 5,
            z: -182.7852
          },
          {
            hole: 42,
            x: -52.5,
            y: 5,
            z: -176.2917
          },
          {
            hole: 43,
            x: -65.9619,
            y: 5,
            z: -165.9619
          },
          {
            hole: 44,
            x: -76.2917,
            y: 5,
            z: -152.5
          },
          {
            hole: 45,
            x: -82.7852,
            y: 5,
            z: -136.8232
          },
          {
            hole: 46,
            x: -85,
            y: 5,
            z: -115.5
          },
          {
            hole: 47,
            x: -85,
            y: 5,
            z: -107.75
          },
          {
            hole: 48,
            x: -85,
            y: 5,
            z: -100
          },
          {
            hole: 49,
            x: -85,
            y: 5,
            z: -92.25
          },
          {
            hole: 50,
            x: -85,
            y: 5,
            z: -84.5
          },
          {
            hole: 51,
            x: -85,
            y: 5,
            z: -75.5
          },
          {
            hole: 52,
            x: -85,
            y: 5,
            z: -67.75
          },
          {
            hole: 53,
            x: -85,
            y: 5,
            z: -60
          },
          {
            hole: 54,
            x: -85,
            y: 5,
            z: -52.25
          },
          {
            hole: 55,
            x: -85,
            y: 5,
            z: -44.5
          },
          {
            hole: 56,
            x: -85,
            y: 5,
            z: -35.5
          },
          {
            hole: 57,
            x: -85,
            y: 5,
            z: -27.75
          },
          {
            hole: 58,
            x: -85,
            y: 5,
            z: -20
          },
          {
            hole: 59,
            x: -85,
            y: 5,
            z: -12.25
          },
          {
            hole: 60,
            x: -85,
            y: 5,
            z: -4.5
          },
          {
            hole: 61,
            x: -85,
            y: 5,
            z: 4.5
          },
          {
            hole: 62,
            x: -85,
            y: 5,
            z: 12.25
          },
          {
            hole: 63,
            x: -85,
            y: 5,
            z: 20
          },
          {
            hole: 64,
            x: -85,
            y: 5,
            z: 27.75
          },
          {
            hole: 65,
            x: -85,
            y: 5,
            z: 35.5
          },
          {
            hole: 66,
            x: -85,
            y: 5,
            z: 44.5
          },
          {
            hole: 67,
            x: -85,
            y: 5,
            z: 52.25
          },
          {
            hole: 68,
            x: -85,
            y: 5,
            z: 60
          },
          {
            hole: 69,
            x: -85,
            y: 5,
            z: 67.75
          },
          {
            hole: 70,
            x: -85,
            y: 5,
            z: 75.5
          },
          {
            hole: 71,
            x: -85,
            y: 5,
            z: 84.5
          },
          {
            hole: 72,
            x: -85,
            y: 5,
            z: 92.25
          },
          {
            hole: 73,
            x: -85,
            y: 5,
            z: 100
          },
          {
            hole: 74,
            x: -85,
            y: 5,
            z: 107.75
          },
          {
            hole: 75,
            x: -85,
            y: 5,
            z: 115.5
          },
          {
            hole: 76,
            x: -85,
            y: 5,
            z: 124.5
          },
          {
            hole: 77,
            x: -85,
            y: 5,
            z: 132.25
          },
          {
            hole: 78,
            x: -85,
            y: 5,
            z: 140
          },
          {
            hole: 79,
            x: -85,
            y: 5,
            z: 147.75
          },
          {
            hole: 80,
            x: -85,
            y: 5,
            z: 155.5
          },
          {
            hole: 81,
            x: -81.6506,
            y: 5,
            z: 172.5
          },
          {
            hole: 82,
            x: -72.5,
            y: 5,
            z: 181.6506
          },
          {
            hole: 83,
            x: -60,
            y: 5,
            z: 185
          },
          {
            hole: 84,
            x: -47.5,
            y: 5,
            z: 181.6506
          },
          {
            hole: 85,
            x: -38.3494,
            y: 5,
            z: 172.5
          },
          {
            hole: 86,
            x: -35,
            y: 5,
            z: 155.5
          },
          {
            hole: 87,
            x: -35,
            y: 5,
            z: 147.75
          },
          {
            hole: 88,
            x: -35,
            y: 5,
            z: 140
          },
          {
            hole: 89,
            x: -35,
            y: 5,
            z: 132.25
          },
          {
            hole: 90,
            x: -35,
            y: 5,
            z: 124.5
          },
          {
            hole: 91,
            x: -35,
            y: 5,
            z: 115.5
          },
          {
            hole: 92,
            x: -35,
            y: 5,
            z: 107.75
          },
          {
            hole: 93,
            x: -35,
            y: 5,
            z: 100
          },
          {
            hole: 94,
            x: -35,
            y: 5,
            z: 92.25
          },
          {
            hole: 95,
            x: -35,
            y: 5,
            z: 84.5
          },
          {
            hole: 96,
            x: -35,
            y: 5,
            z: 75.5
          },
          {
            hole: 97,
            x: -35,
            y: 5,
            z: 67.75
          },
          {
            hole: 98,
            x: -35,
            y: 5,
            z: 60
          },
          {
            hole: 99,
            x: -35,
            y: 5,
            z: 52.25
          },
          {
            hole: 100,
            x: -35,
            y: 5,
            z: 44.5
          },
          {
            hole: 101,
            x: -35,
            y: 5,
            z: 35.5
          },
          {
            hole: 102,
            x: -35,
            y: 5,
            z: 27.75
          },
          {
            hole: 103,
            x: -35,
            y: 5,
            z: 20
          },
          {
            hole: 104,
            x: -35,
            y: 5,
            z: 12.25
          },
          {
            hole: 105,
            x: -35,
            y: 5,
            z: 4.5
          },
          {
            hole: 106,
            x: -35,
            y: 5,
            z: -4.5
          },
          {
            hole: 107,
            x: -35,
            y: 5,
            z: -12.25
          },
          {
            hole: 108,
            x: -35,
            y: 5,
            z: -20
          },
          {
            hole: 109,
            x: -35,
            y: 5,
            z: -27.75
          },
          {
            hole: 110,
            x: -35,
            y: 5,
            z: -35.5
          },
          {
            hole: 111,
            x: -35,
            y: 5,
            z: -44.5
          },
          {
            hole: 112,
            x: -35,
            y: 5,
            z: -52.25
          },
          {
            hole: 113,
            x: -35,
            y: 5,
            z: -60
          },
          {
            hole: 114,
            x: -35,
            y: 5,
            z: -67.75
          },
          {
            hole: 115,
            x: -35,
            y: 5,
            z: -75.5
          },
          {
            hole: 116,
            x: -35,
            y: 5,
            z: -84.5
          },
          {
            hole: 117,
            x: -35,
            y: 5,
            z: -92.25
          },
          {
            hole: 118,
            x: -35,
            y: 5,
            z: -100
          },
          {
            hole: 119,
            x: -35,
            y: 5,
            z: -107.75
          },
          {
            hole: 120,
            x: -35,
            y: 5,
            z: -115.5
          },
          {
            hole: 121,
            x: -20,
            y: 5,
            z: -140
          }
        ]
      }
    },
    {
      id: "board-dimensional-tracks",
      name: "Dimensional Tracks",
      brand: "crazy,pints,adult",
      desc: "Dimensional Tracks 3D cribbage board.",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/dimensional-tracks-thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/9b27f0e46bfcdc6e/dimensional-tracks.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: -47,
            y: 5,
            z: -105
          },
          {
            hole: 1,
            x: -64.5,
            y: 5,
            z: -105
          },
          {
            hole: 2,
            x: -72.25,
            y: 5,
            z: -105
          },
          {
            hole: 3,
            x: -80,
            y: 5,
            z: -105
          },
          {
            hole: 4,
            x: -87.75,
            y: 5,
            z: -105
          },
          {
            hole: 5,
            x: -95.5,
            y: 5,
            z: -105
          },
          {
            hole: 6,
            x: -106.4705,
            y: 15,
            z: -104.1481
          },
          {
            hole: 7,
            x: -112.5,
            y: 15,
            z: -101.6506
          },
          {
            hole: 8,
            x: -117.6777,
            y: 15,
            z: -97.6777
          },
          {
            hole: 9,
            x: -121.6506,
            y: 15,
            z: -92.5
          },
          {
            hole: 10,
            x: -124.1481,
            y: 15,
            z: -86.4705
          },
          {
            hole: 11,
            x: -124.1481,
            y: 25,
            z: -73.5295
          },
          {
            hole: 12,
            x: -121.6506,
            y: 25,
            z: -67.5
          },
          {
            hole: 13,
            x: -117.6777,
            y: 25,
            z: -62.3223
          },
          {
            hole: 14,
            x: -112.5,
            y: 25,
            z: -58.3494
          },
          {
            hole: 15,
            x: -106.4705,
            y: 25,
            z: -55.8519
          },
          {
            hole: 16,
            x: -95.5,
            y: 35,
            z: -55
          },
          {
            hole: 17,
            x: -87.75,
            y: 35,
            z: -55
          },
          {
            hole: 18,
            x: -80,
            y: 35,
            z: -55
          },
          {
            hole: 19,
            x: -72.25,
            y: 35,
            z: -55
          },
          {
            hole: 20,
            x: -64.5,
            y: 35,
            z: -55
          },
          {
            hole: 21,
            x: -45.765,
            y: 45,
            z: -53.1259
          },
          {
            hole: 22,
            x: -32.5,
            y: 45,
            z: -47.6314
          },
          {
            hole: 23,
            x: -21.1091,
            y: 45,
            z: -38.8909
          },
          {
            hole: 24,
            x: -12.3686,
            y: 45,
            z: -27.5
          },
          {
            hole: 25,
            x: -6.8741,
            y: 45,
            z: -14.235
          },
          {
            hole: 26,
            x: -6.8741,
            y: 45,
            z: 14.235
          },
          {
            hole: 27,
            x: -12.3686,
            y: 45,
            z: 27.5
          },
          {
            hole: 28,
            x: -21.1091,
            y: 45,
            z: 38.8909
          },
          {
            hole: 29,
            x: -32.5,
            y: 45,
            z: 47.6314
          },
          {
            hole: 30,
            x: -45.765,
            y: 45,
            z: 53.1259
          },
          {
            hole: 31,
            x: -64.5,
            y: 35,
            z: 55
          },
          {
            hole: 32,
            x: -72.25,
            y: 35,
            z: 55
          },
          {
            hole: 33,
            x: -80,
            y: 35,
            z: 55
          },
          {
            hole: 34,
            x: -87.75,
            y: 35,
            z: 55
          },
          {
            hole: 35,
            x: -95.5,
            y: 35,
            z: 55
          },
          {
            hole: 36,
            x: -106.4705,
            y: 25,
            z: 55.8519
          },
          {
            hole: 37,
            x: -112.5,
            y: 25,
            z: 58.3494
          },
          {
            hole: 38,
            x: -117.6777,
            y: 25,
            z: 62.3223
          },
          {
            hole: 39,
            x: -121.6506,
            y: 25,
            z: 67.5
          },
          {
            hole: 40,
            x: -124.1481,
            y: 25,
            z: 73.5295
          },
          {
            hole: 41,
            x: -124.1481,
            y: 15,
            z: 86.4705
          },
          {
            hole: 42,
            x: -121.6506,
            y: 15,
            z: 92.5
          },
          {
            hole: 43,
            x: -117.6777,
            y: 15,
            z: 97.6777
          },
          {
            hole: 44,
            x: -112.5,
            y: 15,
            z: 101.6506
          },
          {
            hole: 45,
            x: -106.4705,
            y: 15,
            z: 104.1481
          },
          {
            hole: 46,
            x: -95.5,
            y: 5,
            z: 105
          },
          {
            hole: 47,
            x: -87.75,
            y: 5,
            z: 105
          },
          {
            hole: 48,
            x: -80,
            y: 5,
            z: 105
          },
          {
            hole: 49,
            x: -72.25,
            y: 5,
            z: 105
          },
          {
            hole: 50,
            x: -64.5,
            y: 5,
            z: 105
          },
          {
            hole: 51,
            x: -55.5,
            y: 5,
            z: 105
          },
          {
            hole: 52,
            x: -47.75,
            y: 5,
            z: 105
          },
          {
            hole: 53,
            x: -40,
            y: 5,
            z: 105
          },
          {
            hole: 54,
            x: -32.25,
            y: 5,
            z: 105
          },
          {
            hole: 55,
            x: -24.5,
            y: 5,
            z: 105
          },
          {
            hole: 56,
            x: -15.5,
            y: 5,
            z: 105
          },
          {
            hole: 57,
            x: -7.75,
            y: 5,
            z: 105
          },
          {
            hole: 58,
            x: 0,
            y: 5,
            z: 105
          },
          {
            hole: 59,
            x: 7.75,
            y: 5,
            z: 105
          },
          {
            hole: 60,
            x: 15.5,
            y: 5,
            z: 105
          },
          {
            hole: 61,
            x: 24.5,
            y: 5,
            z: 105
          },
          {
            hole: 62,
            x: 32.25,
            y: 5,
            z: 105
          },
          {
            hole: 63,
            x: 40,
            y: 5,
            z: 105
          },
          {
            hole: 64,
            x: 47.75,
            y: 5,
            z: 105
          },
          {
            hole: 65,
            x: 55.5,
            y: 5,
            z: 105
          },
          {
            hole: 66,
            x: 64.5,
            y: 5,
            z: 105
          },
          {
            hole: 67,
            x: 72.25,
            y: 5,
            z: 105
          },
          {
            hole: 68,
            x: 80,
            y: 5,
            z: 105
          },
          {
            hole: 69,
            x: 87.75,
            y: 5,
            z: 105
          },
          {
            hole: 70,
            x: 95.5,
            y: 5,
            z: 105
          },
          {
            hole: 71,
            x: 106.4705,
            y: 15,
            z: 104.1481
          },
          {
            hole: 72,
            x: 112.5,
            y: 15,
            z: 101.6506
          },
          {
            hole: 73,
            x: 117.6777,
            y: 15,
            z: 97.6777
          },
          {
            hole: 74,
            x: 121.6506,
            y: 15,
            z: 92.5
          },
          {
            hole: 75,
            x: 124.1481,
            y: 15,
            z: 86.4705
          },
          {
            hole: 76,
            x: 124.1481,
            y: 25,
            z: 73.5295
          },
          {
            hole: 77,
            x: 121.6506,
            y: 25,
            z: 67.5
          },
          {
            hole: 78,
            x: 117.6777,
            y: 25,
            z: 62.3223
          },
          {
            hole: 79,
            x: 112.5,
            y: 25,
            z: 58.3494
          },
          {
            hole: 80,
            x: 106.4705,
            y: 25,
            z: 55.8519
          },
          {
            hole: 81,
            x: 95.5,
            y: 35,
            z: 55
          },
          {
            hole: 82,
            x: 87.75,
            y: 35,
            z: 55
          },
          {
            hole: 83,
            x: 80,
            y: 35,
            z: 55
          },
          {
            hole: 84,
            x: 72.25,
            y: 35,
            z: 55
          },
          {
            hole: 85,
            x: 64.5,
            y: 35,
            z: 55
          },
          {
            hole: 86,
            x: 45.765,
            y: 45,
            z: 53.1259
          },
          {
            hole: 87,
            x: 32.5,
            y: 45,
            z: 47.6314
          },
          {
            hole: 88,
            x: 21.1091,
            y: 45,
            z: 38.8909
          },
          {
            hole: 89,
            x: 12.3686,
            y: 45,
            z: 27.5
          },
          {
            hole: 90,
            x: 6.8741,
            y: 45,
            z: 14.235
          },
          {
            hole: 91,
            x: 6.8741,
            y: 45,
            z: -14.235
          },
          {
            hole: 92,
            x: 12.3686,
            y: 45,
            z: -27.5
          },
          {
            hole: 93,
            x: 21.1091,
            y: 45,
            z: -38.8909
          },
          {
            hole: 94,
            x: 32.5,
            y: 45,
            z: -47.6314
          },
          {
            hole: 95,
            x: 45.765,
            y: 45,
            z: -53.1259
          },
          {
            hole: 96,
            x: 64.5,
            y: 35,
            z: -55
          },
          {
            hole: 97,
            x: 72.25,
            y: 35,
            z: -55
          },
          {
            hole: 98,
            x: 80,
            y: 35,
            z: -55
          },
          {
            hole: 99,
            x: 87.75,
            y: 35,
            z: -55
          },
          {
            hole: 100,
            x: 95.5,
            y: 35,
            z: -55
          },
          {
            hole: 101,
            x: 106.4705,
            y: 25,
            z: -55.8519
          },
          {
            hole: 102,
            x: 112.5,
            y: 25,
            z: -58.3494
          },
          {
            hole: 103,
            x: 117.6777,
            y: 25,
            z: -62.3223
          },
          {
            hole: 104,
            x: 121.6506,
            y: 25,
            z: -67.5
          },
          {
            hole: 105,
            x: 124.1481,
            y: 25,
            z: -73.5295
          },
          {
            hole: 106,
            x: 124.1481,
            y: 15,
            z: -86.4705
          },
          {
            hole: 107,
            x: 121.6506,
            y: 15,
            z: -92.5
          },
          {
            hole: 108,
            x: 117.6777,
            y: 15,
            z: -97.6777
          },
          {
            hole: 109,
            x: 112.5,
            y: 15,
            z: -101.6506
          },
          {
            hole: 110,
            x: 106.4705,
            y: 15,
            z: -104.1481
          },
          {
            hole: 111,
            x: 95.5,
            y: 5,
            z: -105
          },
          {
            hole: 112,
            x: 87.75,
            y: 5,
            z: -105
          },
          {
            hole: 113,
            x: 80,
            y: 5,
            z: -105
          },
          {
            hole: 114,
            x: 72.25,
            y: 5,
            z: -105
          },
          {
            hole: 115,
            x: 64.5,
            y: 5,
            z: -105
          },
          {
            hole: 116,
            x: 55.5,
            y: 5,
            z: -105
          },
          {
            hole: 117,
            x: 47.75,
            y: 5,
            z: -105
          },
          {
            hole: 118,
            x: 40,
            y: 5,
            z: -105
          },
          {
            hole: 119,
            x: 32.25,
            y: 5,
            z: -105
          },
          {
            hole: 120,
            x: 24.5,
            y: 5,
            z: -105
          },
          {
            hole: 121,
            x: 0,
            y: 5,
            z: -120
          }
        ],
        p2: [
          {
            hole: 0,
            x: -47,
            y: 5,
            z: -115
          },
          {
            hole: 1,
            x: -64.5,
            y: 5,
            z: -115
          },
          {
            hole: 2,
            x: -72.25,
            y: 5,
            z: -115
          },
          {
            hole: 3,
            x: -80,
            y: 5,
            z: -115
          },
          {
            hole: 4,
            x: -87.75,
            y: 5,
            z: -115
          },
          {
            hole: 5,
            x: -95.5,
            y: 5,
            z: -115
          },
          {
            hole: 6,
            x: -109.0587,
            y: 15,
            z: -113.8074
          },
          {
            hole: 7,
            x: -117.5,
            y: 15,
            z: -110.3109
          },
          {
            hole: 8,
            x: -124.7487,
            y: 15,
            z: -104.7487
          },
          {
            hole: 9,
            x: -130.3109,
            y: 15,
            z: -97.5
          },
          {
            hole: 10,
            x: -133.8074,
            y: 15,
            z: -89.0587
          },
          {
            hole: 11,
            x: -133.8074,
            y: 25,
            z: -70.9413
          },
          {
            hole: 12,
            x: -130.3109,
            y: 25,
            z: -62.5
          },
          {
            hole: 13,
            x: -124.7487,
            y: 25,
            z: -55.2513
          },
          {
            hole: 14,
            x: -117.5,
            y: 25,
            z: -49.6891
          },
          {
            hole: 15,
            x: -109.0587,
            y: 25,
            z: -46.1926
          },
          {
            hole: 16,
            x: -95.5,
            y: 35,
            z: -45
          },
          {
            hole: 17,
            x: -87.75,
            y: 35,
            z: -45
          },
          {
            hole: 18,
            x: -80,
            y: 35,
            z: -45
          },
          {
            hole: 19,
            x: -72.25,
            y: 35,
            z: -45
          },
          {
            hole: 20,
            x: -64.5,
            y: 35,
            z: -45
          },
          {
            hole: 21,
            x: -48.3531,
            y: 45,
            z: -43.4667
          },
          {
            hole: 22,
            x: -37.5,
            y: 45,
            z: -38.9711
          },
          {
            hole: 23,
            x: -28.1802,
            y: 45,
            z: -31.8198
          },
          {
            hole: 24,
            x: -21.0289,
            y: 45,
            z: -22.5
          },
          {
            hole: 25,
            x: -16.5333,
            y: 45,
            z: -11.6469
          },
          {
            hole: 26,
            x: -16.5333,
            y: 45,
            z: 11.6469
          },
          {
            hole: 27,
            x: -21.0289,
            y: 45,
            z: 22.5
          },
          {
            hole: 28,
            x: -28.1802,
            y: 45,
            z: 31.8198
          },
          {
            hole: 29,
            x: -37.5,
            y: 45,
            z: 38.9711
          },
          {
            hole: 30,
            x: -48.3531,
            y: 45,
            z: 43.4667
          },
          {
            hole: 31,
            x: -64.5,
            y: 35,
            z: 45
          },
          {
            hole: 32,
            x: -72.25,
            y: 35,
            z: 45
          },
          {
            hole: 33,
            x: -80,
            y: 35,
            z: 45
          },
          {
            hole: 34,
            x: -87.75,
            y: 35,
            z: 45
          },
          {
            hole: 35,
            x: -95.5,
            y: 35,
            z: 45
          },
          {
            hole: 36,
            x: -109.0587,
            y: 25,
            z: 46.1926
          },
          {
            hole: 37,
            x: -117.5,
            y: 25,
            z: 49.6891
          },
          {
            hole: 38,
            x: -124.7487,
            y: 25,
            z: 55.2513
          },
          {
            hole: 39,
            x: -130.3109,
            y: 25,
            z: 62.5
          },
          {
            hole: 40,
            x: -133.8074,
            y: 25,
            z: 70.9413
          },
          {
            hole: 41,
            x: -133.8074,
            y: 15,
            z: 89.0587
          },
          {
            hole: 42,
            x: -130.3109,
            y: 15,
            z: 97.5
          },
          {
            hole: 43,
            x: -124.7487,
            y: 15,
            z: 104.7487
          },
          {
            hole: 44,
            x: -117.5,
            y: 15,
            z: 110.3109
          },
          {
            hole: 45,
            x: -109.0587,
            y: 15,
            z: 113.8074
          },
          {
            hole: 46,
            x: -95.5,
            y: 5,
            z: 115
          },
          {
            hole: 47,
            x: -87.75,
            y: 5,
            z: 115
          },
          {
            hole: 48,
            x: -80,
            y: 5,
            z: 115
          },
          {
            hole: 49,
            x: -72.25,
            y: 5,
            z: 115
          },
          {
            hole: 50,
            x: -64.5,
            y: 5,
            z: 115
          },
          {
            hole: 51,
            x: -55.5,
            y: 5,
            z: 115
          },
          {
            hole: 52,
            x: -47.75,
            y: 5,
            z: 115
          },
          {
            hole: 53,
            x: -40,
            y: 5,
            z: 115
          },
          {
            hole: 54,
            x: -32.25,
            y: 5,
            z: 115
          },
          {
            hole: 55,
            x: -24.5,
            y: 5,
            z: 115
          },
          {
            hole: 56,
            x: -15.5,
            y: 5,
            z: 115
          },
          {
            hole: 57,
            x: -7.75,
            y: 5,
            z: 115
          },
          {
            hole: 58,
            x: 0,
            y: 5,
            z: 115
          },
          {
            hole: 59,
            x: 7.75,
            y: 5,
            z: 115
          },
          {
            hole: 60,
            x: 15.5,
            y: 5,
            z: 115
          },
          {
            hole: 61,
            x: 24.5,
            y: 5,
            z: 115
          },
          {
            hole: 62,
            x: 32.25,
            y: 5,
            z: 115
          },
          {
            hole: 63,
            x: 40,
            y: 5,
            z: 115
          },
          {
            hole: 64,
            x: 47.75,
            y: 5,
            z: 115
          },
          {
            hole: 65,
            x: 55.5,
            y: 5,
            z: 115
          },
          {
            hole: 66,
            x: 64.5,
            y: 5,
            z: 115
          },
          {
            hole: 67,
            x: 72.25,
            y: 5,
            z: 115
          },
          {
            hole: 68,
            x: 80,
            y: 5,
            z: 115
          },
          {
            hole: 69,
            x: 87.75,
            y: 5,
            z: 115
          },
          {
            hole: 70,
            x: 95.5,
            y: 5,
            z: 115
          },
          {
            hole: 71,
            x: 109.0587,
            y: 15,
            z: 113.8074
          },
          {
            hole: 72,
            x: 117.5,
            y: 15,
            z: 110.3109
          },
          {
            hole: 73,
            x: 124.7487,
            y: 15,
            z: 104.7487
          },
          {
            hole: 74,
            x: 130.3109,
            y: 15,
            z: 97.5
          },
          {
            hole: 75,
            x: 133.8074,
            y: 15,
            z: 89.0587
          },
          {
            hole: 76,
            x: 133.8074,
            y: 25,
            z: 70.9413
          },
          {
            hole: 77,
            x: 130.3109,
            y: 25,
            z: 62.5
          },
          {
            hole: 78,
            x: 124.7487,
            y: 25,
            z: 55.2513
          },
          {
            hole: 79,
            x: 117.5,
            y: 25,
            z: 49.6891
          },
          {
            hole: 80,
            x: 109.0587,
            y: 25,
            z: 46.1926
          },
          {
            hole: 81,
            x: 95.5,
            y: 35,
            z: 45
          },
          {
            hole: 82,
            x: 87.75,
            y: 35,
            z: 45
          },
          {
            hole: 83,
            x: 80,
            y: 35,
            z: 45
          },
          {
            hole: 84,
            x: 72.25,
            y: 35,
            z: 45
          },
          {
            hole: 85,
            x: 64.5,
            y: 35,
            z: 45
          },
          {
            hole: 86,
            x: 48.3531,
            y: 45,
            z: 43.4667
          },
          {
            hole: 87,
            x: 37.5,
            y: 45,
            z: 38.9711
          },
          {
            hole: 88,
            x: 28.1802,
            y: 45,
            z: 31.8198
          },
          {
            hole: 89,
            x: 21.0289,
            y: 45,
            z: 22.5
          },
          {
            hole: 90,
            x: 16.5333,
            y: 45,
            z: 11.6469
          },
          {
            hole: 91,
            x: 16.5333,
            y: 45,
            z: -11.6469
          },
          {
            hole: 92,
            x: 21.0289,
            y: 45,
            z: -22.5
          },
          {
            hole: 93,
            x: 28.1802,
            y: 45,
            z: -31.8198
          },
          {
            hole: 94,
            x: 37.5,
            y: 45,
            z: -38.9711
          },
          {
            hole: 95,
            x: 48.3531,
            y: 45,
            z: -43.4667
          },
          {
            hole: 96,
            x: 64.5,
            y: 35,
            z: -45
          },
          {
            hole: 97,
            x: 72.25,
            y: 35,
            z: -45
          },
          {
            hole: 98,
            x: 80,
            y: 35,
            z: -45
          },
          {
            hole: 99,
            x: 87.75,
            y: 35,
            z: -45
          },
          {
            hole: 100,
            x: 95.5,
            y: 35,
            z: -45
          },
          {
            hole: 101,
            x: 109.0587,
            y: 25,
            z: -46.1926
          },
          {
            hole: 102,
            x: 117.5,
            y: 25,
            z: -49.6891
          },
          {
            hole: 103,
            x: 124.7487,
            y: 25,
            z: -55.2513
          },
          {
            hole: 104,
            x: 130.3109,
            y: 25,
            z: -62.5
          },
          {
            hole: 105,
            x: 133.8074,
            y: 25,
            z: -70.9413
          },
          {
            hole: 106,
            x: 133.8074,
            y: 15,
            z: -89.0587
          },
          {
            hole: 107,
            x: 130.3109,
            y: 15,
            z: -97.5
          },
          {
            hole: 108,
            x: 124.7487,
            y: 15,
            z: -104.7487
          },
          {
            hole: 109,
            x: 117.5,
            y: 15,
            z: -110.3109
          },
          {
            hole: 110,
            x: 109.0587,
            y: 15,
            z: -113.8074
          },
          {
            hole: 111,
            x: 95.5,
            y: 5,
            z: -115
          },
          {
            hole: 112,
            x: 87.75,
            y: 5,
            z: -115
          },
          {
            hole: 113,
            x: 80,
            y: 5,
            z: -115
          },
          {
            hole: 114,
            x: 72.25,
            y: 5,
            z: -115
          },
          {
            hole: 115,
            x: 64.5,
            y: 5,
            z: -115
          },
          {
            hole: 116,
            x: 55.5,
            y: 5,
            z: -115
          },
          {
            hole: 117,
            x: 47.75,
            y: 5,
            z: -115
          },
          {
            hole: 118,
            x: 40,
            y: 5,
            z: -115
          },
          {
            hole: 119,
            x: 32.25,
            y: 5,
            z: -115
          },
          {
            hole: 120,
            x: 24.5,
            y: 5,
            z: -115
          },
          {
            hole: 121,
            x: 0,
            y: 5,
            z: -120
          }
        ],
        p3: [
          {
            hole: 0,
            x: -47,
            y: 5,
            z: -125
          },
          {
            hole: 1,
            x: -64.5,
            y: 5,
            z: -125
          },
          {
            hole: 2,
            x: -72.25,
            y: 5,
            z: -125
          },
          {
            hole: 3,
            x: -80,
            y: 5,
            z: -125
          },
          {
            hole: 4,
            x: -87.75,
            y: 5,
            z: -125
          },
          {
            hole: 5,
            x: -95.5,
            y: 5,
            z: -125
          },
          {
            hole: 6,
            x: -111.6469,
            y: 15,
            z: -123.4667
          },
          {
            hole: 7,
            x: -122.5,
            y: 15,
            z: -118.9711
          },
          {
            hole: 8,
            x: -131.8198,
            y: 15,
            z: -111.8198
          },
          {
            hole: 9,
            x: -138.9711,
            y: 15,
            z: -102.5
          },
          {
            hole: 10,
            x: -143.4667,
            y: 15,
            z: -91.6469
          },
          {
            hole: 11,
            x: -143.4667,
            y: 25,
            z: -68.3531
          },
          {
            hole: 12,
            x: -138.9711,
            y: 25,
            z: -57.5
          },
          {
            hole: 13,
            x: -131.8198,
            y: 25,
            z: -48.1802
          },
          {
            hole: 14,
            x: -122.5,
            y: 25,
            z: -41.0289
          },
          {
            hole: 15,
            x: -111.6469,
            y: 25,
            z: -36.5333
          },
          {
            hole: 16,
            x: -95.5,
            y: 35,
            z: -35
          },
          {
            hole: 17,
            x: -87.75,
            y: 35,
            z: -35
          },
          {
            hole: 18,
            x: -80,
            y: 35,
            z: -35
          },
          {
            hole: 19,
            x: -72.25,
            y: 35,
            z: -35
          },
          {
            hole: 20,
            x: -64.5,
            y: 35,
            z: -35
          },
          {
            hole: 21,
            x: -50.9413,
            y: 45,
            z: -33.8074
          },
          {
            hole: 22,
            x: -42.5,
            y: 45,
            z: -30.3109
          },
          {
            hole: 23,
            x: -35.2513,
            y: 45,
            z: -24.7487
          },
          {
            hole: 24,
            x: -29.6891,
            y: 45,
            z: -17.5
          },
          {
            hole: 25,
            x: -26.1926,
            y: 45,
            z: -9.0587
          },
          {
            hole: 26,
            x: -26.1926,
            y: 45,
            z: 9.0587
          },
          {
            hole: 27,
            x: -29.6891,
            y: 45,
            z: 17.5
          },
          {
            hole: 28,
            x: -35.2513,
            y: 45,
            z: 24.7487
          },
          {
            hole: 29,
            x: -42.5,
            y: 45,
            z: 30.3109
          },
          {
            hole: 30,
            x: -50.9413,
            y: 45,
            z: 33.8074
          },
          {
            hole: 31,
            x: -64.5,
            y: 35,
            z: 35
          },
          {
            hole: 32,
            x: -72.25,
            y: 35,
            z: 35
          },
          {
            hole: 33,
            x: -80,
            y: 35,
            z: 35
          },
          {
            hole: 34,
            x: -87.75,
            y: 35,
            z: 35
          },
          {
            hole: 35,
            x: -95.5,
            y: 35,
            z: 35
          },
          {
            hole: 36,
            x: -111.6469,
            y: 25,
            z: 36.5333
          },
          {
            hole: 37,
            x: -122.5,
            y: 25,
            z: 41.0289
          },
          {
            hole: 38,
            x: -131.8198,
            y: 25,
            z: 48.1802
          },
          {
            hole: 39,
            x: -138.9711,
            y: 25,
            z: 57.5
          },
          {
            hole: 40,
            x: -143.4667,
            y: 25,
            z: 68.3531
          },
          {
            hole: 41,
            x: -143.4667,
            y: 15,
            z: 91.6469
          },
          {
            hole: 42,
            x: -138.9711,
            y: 15,
            z: 102.5
          },
          {
            hole: 43,
            x: -131.8198,
            y: 15,
            z: 111.8198
          },
          {
            hole: 44,
            x: -122.5,
            y: 15,
            z: 118.9711
          },
          {
            hole: 45,
            x: -111.6469,
            y: 15,
            z: 123.4667
          },
          {
            hole: 46,
            x: -95.5,
            y: 5,
            z: 125
          },
          {
            hole: 47,
            x: -87.75,
            y: 5,
            z: 125
          },
          {
            hole: 48,
            x: -80,
            y: 5,
            z: 125
          },
          {
            hole: 49,
            x: -72.25,
            y: 5,
            z: 125
          },
          {
            hole: 50,
            x: -64.5,
            y: 5,
            z: 125
          },
          {
            hole: 51,
            x: -55.5,
            y: 5,
            z: 125
          },
          {
            hole: 52,
            x: -47.75,
            y: 5,
            z: 125
          },
          {
            hole: 53,
            x: -40,
            y: 5,
            z: 125
          },
          {
            hole: 54,
            x: -32.25,
            y: 5,
            z: 125
          },
          {
            hole: 55,
            x: -24.5,
            y: 5,
            z: 125
          },
          {
            hole: 56,
            x: -15.5,
            y: 5,
            z: 125
          },
          {
            hole: 57,
            x: -7.75,
            y: 5,
            z: 125
          },
          {
            hole: 58,
            x: 0,
            y: 5,
            z: 125
          },
          {
            hole: 59,
            x: 7.75,
            y: 5,
            z: 125
          },
          {
            hole: 60,
            x: 15.5,
            y: 5,
            z: 125
          },
          {
            hole: 61,
            x: 24.5,
            y: 5,
            z: 125
          },
          {
            hole: 62,
            x: 32.25,
            y: 5,
            z: 125
          },
          {
            hole: 63,
            x: 40,
            y: 5,
            z: 125
          },
          {
            hole: 64,
            x: 47.75,
            y: 5,
            z: 125
          },
          {
            hole: 65,
            x: 55.5,
            y: 5,
            z: 125
          },
          {
            hole: 66,
            x: 64.5,
            y: 5,
            z: 125
          },
          {
            hole: 67,
            x: 72.25,
            y: 5,
            z: 125
          },
          {
            hole: 68,
            x: 80,
            y: 5,
            z: 125
          },
          {
            hole: 69,
            x: 87.75,
            y: 5,
            z: 125
          },
          {
            hole: 70,
            x: 95.5,
            y: 5,
            z: 125
          },
          {
            hole: 71,
            x: 111.6469,
            y: 15,
            z: 123.4667
          },
          {
            hole: 72,
            x: 122.5,
            y: 15,
            z: 118.9711
          },
          {
            hole: 73,
            x: 131.8198,
            y: 15,
            z: 111.8198
          },
          {
            hole: 74,
            x: 138.9711,
            y: 15,
            z: 102.5
          },
          {
            hole: 75,
            x: 143.4667,
            y: 15,
            z: 91.6469
          },
          {
            hole: 76,
            x: 143.4667,
            y: 25,
            z: 68.3531
          },
          {
            hole: 77,
            x: 138.9711,
            y: 25,
            z: 57.5
          },
          {
            hole: 78,
            x: 131.8198,
            y: 25,
            z: 48.1802
          },
          {
            hole: 79,
            x: 122.5,
            y: 25,
            z: 41.0289
          },
          {
            hole: 80,
            x: 111.6469,
            y: 25,
            z: 36.5333
          },
          {
            hole: 81,
            x: 95.5,
            y: 35,
            z: 35
          },
          {
            hole: 82,
            x: 87.75,
            y: 35,
            z: 35
          },
          {
            hole: 83,
            x: 80,
            y: 35,
            z: 35
          },
          {
            hole: 84,
            x: 72.25,
            y: 35,
            z: 35
          },
          {
            hole: 85,
            x: 64.5,
            y: 35,
            z: 35
          },
          {
            hole: 86,
            x: 50.9413,
            y: 45,
            z: 33.8074
          },
          {
            hole: 87,
            x: 42.5,
            y: 45,
            z: 30.3109
          },
          {
            hole: 88,
            x: 35.2513,
            y: 45,
            z: 24.7487
          },
          {
            hole: 89,
            x: 29.6891,
            y: 45,
            z: 17.5
          },
          {
            hole: 90,
            x: 26.1926,
            y: 45,
            z: 9.0587
          },
          {
            hole: 91,
            x: 26.1926,
            y: 45,
            z: -9.0587
          },
          {
            hole: 92,
            x: 29.6891,
            y: 45,
            z: -17.5
          },
          {
            hole: 93,
            x: 35.2513,
            y: 45,
            z: -24.7487
          },
          {
            hole: 94,
            x: 42.5,
            y: 45,
            z: -30.3109
          },
          {
            hole: 95,
            x: 50.9413,
            y: 45,
            z: -33.8074
          },
          {
            hole: 96,
            x: 64.5,
            y: 35,
            z: -35
          },
          {
            hole: 97,
            x: 72.25,
            y: 35,
            z: -35
          },
          {
            hole: 98,
            x: 80,
            y: 35,
            z: -35
          },
          {
            hole: 99,
            x: 87.75,
            y: 35,
            z: -35
          },
          {
            hole: 100,
            x: 95.5,
            y: 35,
            z: -35
          },
          {
            hole: 101,
            x: 111.6469,
            y: 25,
            z: -36.5333
          },
          {
            hole: 102,
            x: 122.5,
            y: 25,
            z: -41.0289
          },
          {
            hole: 103,
            x: 131.8198,
            y: 25,
            z: -48.1802
          },
          {
            hole: 104,
            x: 138.9711,
            y: 25,
            z: -57.5
          },
          {
            hole: 105,
            x: 143.4667,
            y: 25,
            z: -68.3531
          },
          {
            hole: 106,
            x: 143.4667,
            y: 15,
            z: -91.6469
          },
          {
            hole: 107,
            x: 138.9711,
            y: 15,
            z: -102.5
          },
          {
            hole: 108,
            x: 131.8198,
            y: 15,
            z: -111.8198
          },
          {
            hole: 109,
            x: 122.5,
            y: 15,
            z: -118.9711
          },
          {
            hole: 110,
            x: 111.6469,
            y: 15,
            z: -123.4667
          },
          {
            hole: 111,
            x: 95.5,
            y: 5,
            z: -125
          },
          {
            hole: 112,
            x: 87.75,
            y: 5,
            z: -125
          },
          {
            hole: 113,
            x: 80,
            y: 5,
            z: -125
          },
          {
            hole: 114,
            x: 72.25,
            y: 5,
            z: -125
          },
          {
            hole: 115,
            x: 64.5,
            y: 5,
            z: -125
          },
          {
            hole: 116,
            x: 55.5,
            y: 5,
            z: -125
          },
          {
            hole: 117,
            x: 47.75,
            y: 5,
            z: -125
          },
          {
            hole: 118,
            x: 40,
            y: 5,
            z: -125
          },
          {
            hole: 119,
            x: 32.25,
            y: 5,
            z: -125
          },
          {
            hole: 120,
            x: 24.5,
            y: 5,
            z: -125
          },
          {
            hole: 121,
            x: 0,
            y: 5,
            z: -120
          }
        ],
        p4: [
          {
            hole: 0,
            x: -47,
            y: 5,
            z: -135
          },
          {
            hole: 1,
            x: -64.5,
            y: 5,
            z: -135
          },
          {
            hole: 2,
            x: -72.25,
            y: 5,
            z: -135
          },
          {
            hole: 3,
            x: -80,
            y: 5,
            z: -135
          },
          {
            hole: 4,
            x: -87.75,
            y: 5,
            z: -135
          },
          {
            hole: 5,
            x: -95.5,
            y: 5,
            z: -135
          },
          {
            hole: 6,
            x: -114.235,
            y: 15,
            z: -133.1259
          },
          {
            hole: 7,
            x: -127.5,
            y: 15,
            z: -127.6314
          },
          {
            hole: 8,
            x: -138.8909,
            y: 15,
            z: -118.8909
          },
          {
            hole: 9,
            x: -147.6314,
            y: 15,
            z: -107.5
          },
          {
            hole: 10,
            x: -153.1259,
            y: 15,
            z: -94.235
          },
          {
            hole: 11,
            x: -153.1259,
            y: 25,
            z: -65.765
          },
          {
            hole: 12,
            x: -147.6314,
            y: 25,
            z: -52.5
          },
          {
            hole: 13,
            x: -138.8909,
            y: 25,
            z: -41.1091
          },
          {
            hole: 14,
            x: -127.5,
            y: 25,
            z: -32.3686
          },
          {
            hole: 15,
            x: -114.235,
            y: 25,
            z: -26.8741
          },
          {
            hole: 16,
            x: -95.5,
            y: 35,
            z: -25
          },
          {
            hole: 17,
            x: -87.75,
            y: 35,
            z: -25
          },
          {
            hole: 18,
            x: -80,
            y: 35,
            z: -25
          },
          {
            hole: 19,
            x: -72.25,
            y: 35,
            z: -25
          },
          {
            hole: 20,
            x: -64.5,
            y: 35,
            z: -25
          },
          {
            hole: 21,
            x: -53.5295,
            y: 45,
            z: -24.1481
          },
          {
            hole: 22,
            x: -47.5,
            y: 45,
            z: -21.6506
          },
          {
            hole: 23,
            x: -42.3223,
            y: 45,
            z: -17.6777
          },
          {
            hole: 24,
            x: -38.3494,
            y: 45,
            z: -12.5
          },
          {
            hole: 25,
            x: -35.8519,
            y: 45,
            z: -6.4705
          },
          {
            hole: 26,
            x: -35.8519,
            y: 45,
            z: 6.4705
          },
          {
            hole: 27,
            x: -38.3494,
            y: 45,
            z: 12.5
          },
          {
            hole: 28,
            x: -42.3223,
            y: 45,
            z: 17.6777
          },
          {
            hole: 29,
            x: -47.5,
            y: 45,
            z: 21.6506
          },
          {
            hole: 30,
            x: -53.5295,
            y: 45,
            z: 24.1481
          },
          {
            hole: 31,
            x: -64.5,
            y: 35,
            z: 25
          },
          {
            hole: 32,
            x: -72.25,
            y: 35,
            z: 25
          },
          {
            hole: 33,
            x: -80,
            y: 35,
            z: 25
          },
          {
            hole: 34,
            x: -87.75,
            y: 35,
            z: 25
          },
          {
            hole: 35,
            x: -95.5,
            y: 35,
            z: 25
          },
          {
            hole: 36,
            x: -114.235,
            y: 25,
            z: 26.8741
          },
          {
            hole: 37,
            x: -127.5,
            y: 25,
            z: 32.3686
          },
          {
            hole: 38,
            x: -138.8909,
            y: 25,
            z: 41.1091
          },
          {
            hole: 39,
            x: -147.6314,
            y: 25,
            z: 52.5
          },
          {
            hole: 40,
            x: -153.1259,
            y: 25,
            z: 65.765
          },
          {
            hole: 41,
            x: -153.1259,
            y: 15,
            z: 94.235
          },
          {
            hole: 42,
            x: -147.6314,
            y: 15,
            z: 107.5
          },
          {
            hole: 43,
            x: -138.8909,
            y: 15,
            z: 118.8909
          },
          {
            hole: 44,
            x: -127.5,
            y: 15,
            z: 127.6314
          },
          {
            hole: 45,
            x: -114.235,
            y: 15,
            z: 133.1259
          },
          {
            hole: 46,
            x: -95.5,
            y: 5,
            z: 135
          },
          {
            hole: 47,
            x: -87.75,
            y: 5,
            z: 135
          },
          {
            hole: 48,
            x: -80,
            y: 5,
            z: 135
          },
          {
            hole: 49,
            x: -72.25,
            y: 5,
            z: 135
          },
          {
            hole: 50,
            x: -64.5,
            y: 5,
            z: 135
          },
          {
            hole: 51,
            x: -55.5,
            y: 5,
            z: 135
          },
          {
            hole: 52,
            x: -47.75,
            y: 5,
            z: 135
          },
          {
            hole: 53,
            x: -40,
            y: 5,
            z: 135
          },
          {
            hole: 54,
            x: -32.25,
            y: 5,
            z: 135
          },
          {
            hole: 55,
            x: -24.5,
            y: 5,
            z: 135
          },
          {
            hole: 56,
            x: -15.5,
            y: 5,
            z: 135
          },
          {
            hole: 57,
            x: -7.75,
            y: 5,
            z: 135
          },
          {
            hole: 58,
            x: 0,
            y: 5,
            z: 135
          },
          {
            hole: 59,
            x: 7.75,
            y: 5,
            z: 135
          },
          {
            hole: 60,
            x: 15.5,
            y: 5,
            z: 135
          },
          {
            hole: 61,
            x: 24.5,
            y: 5,
            z: 135
          },
          {
            hole: 62,
            x: 32.25,
            y: 5,
            z: 135
          },
          {
            hole: 63,
            x: 40,
            y: 5,
            z: 135
          },
          {
            hole: 64,
            x: 47.75,
            y: 5,
            z: 135
          },
          {
            hole: 65,
            x: 55.5,
            y: 5,
            z: 135
          },
          {
            hole: 66,
            x: 64.5,
            y: 5,
            z: 135
          },
          {
            hole: 67,
            x: 72.25,
            y: 5,
            z: 135
          },
          {
            hole: 68,
            x: 80,
            y: 5,
            z: 135
          },
          {
            hole: 69,
            x: 87.75,
            y: 5,
            z: 135
          },
          {
            hole: 70,
            x: 95.5,
            y: 5,
            z: 135
          },
          {
            hole: 71,
            x: 114.235,
            y: 15,
            z: 133.1259
          },
          {
            hole: 72,
            x: 127.5,
            y: 15,
            z: 127.6314
          },
          {
            hole: 73,
            x: 138.8909,
            y: 15,
            z: 118.8909
          },
          {
            hole: 74,
            x: 147.6314,
            y: 15,
            z: 107.5
          },
          {
            hole: 75,
            x: 153.1259,
            y: 15,
            z: 94.235
          },
          {
            hole: 76,
            x: 153.1259,
            y: 25,
            z: 65.765
          },
          {
            hole: 77,
            x: 147.6314,
            y: 25,
            z: 52.5
          },
          {
            hole: 78,
            x: 138.8909,
            y: 25,
            z: 41.1091
          },
          {
            hole: 79,
            x: 127.5,
            y: 25,
            z: 32.3686
          },
          {
            hole: 80,
            x: 114.235,
            y: 25,
            z: 26.8741
          },
          {
            hole: 81,
            x: 95.5,
            y: 35,
            z: 25
          },
          {
            hole: 82,
            x: 87.75,
            y: 35,
            z: 25
          },
          {
            hole: 83,
            x: 80,
            y: 35,
            z: 25
          },
          {
            hole: 84,
            x: 72.25,
            y: 35,
            z: 25
          },
          {
            hole: 85,
            x: 64.5,
            y: 35,
            z: 25
          },
          {
            hole: 86,
            x: 53.5295,
            y: 45,
            z: 24.1481
          },
          {
            hole: 87,
            x: 47.5,
            y: 45,
            z: 21.6506
          },
          {
            hole: 88,
            x: 42.3223,
            y: 45,
            z: 17.6777
          },
          {
            hole: 89,
            x: 38.3494,
            y: 45,
            z: 12.5
          },
          {
            hole: 90,
            x: 35.8519,
            y: 45,
            z: 6.4705
          },
          {
            hole: 91,
            x: 35.8519,
            y: 45,
            z: -6.4705
          },
          {
            hole: 92,
            x: 38.3494,
            y: 45,
            z: -12.5
          },
          {
            hole: 93,
            x: 42.3223,
            y: 45,
            z: -17.6777
          },
          {
            hole: 94,
            x: 47.5,
            y: 45,
            z: -21.6506
          },
          {
            hole: 95,
            x: 53.5295,
            y: 45,
            z: -24.1481
          },
          {
            hole: 96,
            x: 64.5,
            y: 35,
            z: -25
          },
          {
            hole: 97,
            x: 72.25,
            y: 35,
            z: -25
          },
          {
            hole: 98,
            x: 80,
            y: 35,
            z: -25
          },
          {
            hole: 99,
            x: 87.75,
            y: 35,
            z: -25
          },
          {
            hole: 100,
            x: 95.5,
            y: 35,
            z: -25
          },
          {
            hole: 101,
            x: 114.235,
            y: 25,
            z: -26.8741
          },
          {
            hole: 102,
            x: 127.5,
            y: 25,
            z: -32.3686
          },
          {
            hole: 103,
            x: 138.8909,
            y: 25,
            z: -41.1091
          },
          {
            hole: 104,
            x: 147.6314,
            y: 25,
            z: -52.5
          },
          {
            hole: 105,
            x: 153.1259,
            y: 25,
            z: -65.765
          },
          {
            hole: 106,
            x: 153.1259,
            y: 15,
            z: -94.235
          },
          {
            hole: 107,
            x: 147.6314,
            y: 15,
            z: -107.5
          },
          {
            hole: 108,
            x: 138.8909,
            y: 15,
            z: -118.8909
          },
          {
            hole: 109,
            x: 127.5,
            y: 15,
            z: -127.6314
          },
          {
            hole: 110,
            x: 114.235,
            y: 15,
            z: -133.1259
          },
          {
            hole: 111,
            x: 95.5,
            y: 5,
            z: -135
          },
          {
            hole: 112,
            x: 87.75,
            y: 5,
            z: -135
          },
          {
            hole: 113,
            x: 80,
            y: 5,
            z: -135
          },
          {
            hole: 114,
            x: 72.25,
            y: 5,
            z: -135
          },
          {
            hole: 115,
            x: 64.5,
            y: 5,
            z: -135
          },
          {
            hole: 116,
            x: 55.5,
            y: 5,
            z: -135
          },
          {
            hole: 117,
            x: 47.75,
            y: 5,
            z: -135
          },
          {
            hole: 118,
            x: 40,
            y: 5,
            z: -135
          },
          {
            hole: 119,
            x: 32.25,
            y: 5,
            z: -135
          },
          {
            hole: 120,
            x: 24.5,
            y: 5,
            z: -135
          },
          {
            hole: 121,
            x: 0,
            y: 5,
            z: -120
          }
        ]
      }
    },
    {
      id: "board-cancer-ribbon",
      name: "Cancer Ribbon",
      brand: "crazy,pints,adult",
      desc: "Cancer Ribbon 3D cribbage board.",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/cancer-ribbon-thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/ddf105366127887f/cancer-ribbon-3d.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 127,
            y: 15,
            z: 63.8283
          },
          {
            hole: 1,
            x: 135.5,
            y: 15,
            z: -55.4951
          },
          {
            hole: 2,
            x: 127.75,
            y: 15,
            z: -55.4951
          },
          {
            hole: 3,
            x: 120,
            y: 15,
            z: -55.4951
          },
          {
            hole: 4,
            x: 112.25,
            y: 15,
            z: -55.4951
          },
          {
            hole: 5,
            x: 104.5,
            y: 15,
            z: -55.4951
          },
          {
            hole: 6,
            x: 175.5,
            y: 15,
            z: -55.4951
          },
          {
            hole: 7,
            x: 167.75,
            y: 15,
            z: -55.4951
          },
          {
            hole: 8,
            x: 160,
            y: 15,
            z: -55.4951
          },
          {
            hole: 9,
            x: 152.25,
            y: 15,
            z: -55.4951
          },
          {
            hole: 10,
            x: 144.5,
            y: 15,
            z: -55.4951
          },
          {
            hole: 11,
            x: 215.5,
            y: 15,
            z: -55.4951
          },
          {
            hole: 12,
            x: 207.75,
            y: 15,
            z: -55.4951
          },
          {
            hole: 13,
            x: 200,
            y: 15,
            z: -55.4951
          },
          {
            hole: 14,
            x: 192.25,
            y: 15,
            z: -55.4951
          },
          {
            hole: 15,
            x: 184.5,
            y: 15,
            z: -55.4951
          },
          {
            hole: 16,
            x: 225,
            y: 15,
            z: -55.7513
          },
          {
            hole: 17,
            x: 232.5,
            y: 15,
            z: -55.7513
          },
          {
            hole: 18,
            x: 264.7487,
            y: 15,
            z: -45.5001
          },
          {
            hole: 19,
            x: 275,
            y: 15,
            z: -13.2513
          },
          {
            hole: 20,
            x: 275,
            y: 15,
            z: -5.7513
          },
          {
            hole: 21,
            x: 275,
            y: 15,
            z: 43.8283
          },
          {
            hole: 22,
            x: 275,
            y: 15,
            z: 51.3283
          },
          {
            hole: 23,
            x: 264.7487,
            y: 15,
            z: 83.577
          },
          {
            hole: 24,
            x: 232.5,
            y: 15,
            z: 93.8283
          },
          {
            hole: 25,
            x: 225,
            y: 15,
            z: 93.8283
          },
          {
            hole: 26,
            x: 175.5,
            y: 15,
            z: 63.8283
          },
          {
            hole: 27,
            x: 167.75,
            y: 15,
            z: 63.8283
          },
          {
            hole: 28,
            x: 160,
            y: 15,
            z: 63.8283
          },
          {
            hole: 29,
            x: 152.25,
            y: 15,
            z: 63.8283
          },
          {
            hole: 30,
            x: 144.5,
            y: 15,
            z: 63.8283
          },
          {
            hole: 31,
            x: 215.5,
            y: 15,
            z: 63.8283
          },
          {
            hole: 32,
            x: 207.75,
            y: 15,
            z: 63.8283
          },
          {
            hole: 33,
            x: 200,
            y: 15,
            z: 63.8283
          },
          {
            hole: 34,
            x: 192.25,
            y: 15,
            z: 63.8283
          },
          {
            hole: 35,
            x: 184.5,
            y: 15,
            z: 63.8283
          },
          {
            hole: 36,
            x: 95,
            y: 15,
            z: 174.3282
          },
          {
            hole: 37,
            x: 95,
            y: 15,
            z: 166.5782
          },
          {
            hole: 38,
            x: 95,
            y: 15,
            z: 158.8282
          },
          {
            hole: 39,
            x: 95,
            y: 15,
            z: 151.0782
          },
          {
            hole: 40,
            x: 95,
            y: 15,
            z: 143.3282
          },
          {
            hole: 41,
            x: 95,
            y: 15,
            z: 214.3282
          },
          {
            hole: 42,
            x: 95,
            y: 15,
            z: 206.5782
          },
          {
            hole: 43,
            x: 95,
            y: 15,
            z: 198.8282
          },
          {
            hole: 44,
            x: 95,
            y: 15,
            z: 191.0782
          },
          {
            hole: 45,
            x: 95,
            y: 15,
            z: 183.3282
          },
          {
            hole: 46,
            x: 95,
            y: 15,
            z: 223.8282
          },
          {
            hole: 47,
            x: 95,
            y: 15,
            z: 231.3282
          },
          {
            hole: 48,
            x: 84.7487,
            y: 15,
            z: 263.577
          },
          {
            hole: 49,
            x: 52.5,
            y: 15,
            z: 273.8282
          },
          {
            hole: 50,
            x: 45,
            y: 15,
            z: 273.8282
          },
          {
            hole: 51,
            x: -5,
            y: 15,
            z: 273.8282
          },
          {
            hole: 52,
            x: -12.5,
            y: 15,
            z: 273.8282
          },
          {
            hole: 53,
            x: -44.7488,
            y: 15,
            z: 263.577
          },
          {
            hole: 54,
            x: -55,
            y: 15,
            z: 231.3282
          },
          {
            hole: 55,
            x: -55,
            y: 15,
            z: 223.8282
          },
          {
            hole: 56,
            x: -25.014,
            y: 15,
            z: 214.3282
          },
          {
            hole: 57,
            x: -25.014,
            y: 15,
            z: 206.5782
          },
          {
            hole: 58,
            x: -25.014,
            y: 15,
            z: 198.8282
          },
          {
            hole: 59,
            x: -25.014,
            y: 15,
            z: 191.0782
          },
          {
            hole: 60,
            x: -25.014,
            y: 15,
            z: 183.3282
          },
          {
            hole: 61,
            x: -25.014,
            y: 15,
            z: 174.3282
          },
          {
            hole: 62,
            x: -25.014,
            y: 15,
            z: 166.5782
          },
          {
            hole: 63,
            x: -25.014,
            y: 15,
            z: 158.8282
          },
          {
            hole: 64,
            x: -25.014,
            y: 15,
            z: 151.0782
          },
          {
            hole: 65,
            x: -25.014,
            y: 15,
            z: 143.3282
          },
          {
            hole: 66,
            x: -25.014,
            y: 15,
            z: 134.7536
          },
          {
            hole: 67,
            x: -25.014,
            y: 15,
            z: 127.0036
          },
          {
            hole: 68,
            x: -25.014,
            y: 15,
            z: 119.2536
          },
          {
            hole: 69,
            x: -25.014,
            y: 15,
            z: 111.5036
          },
          {
            hole: 70,
            x: -25.014,
            y: 15,
            z: 103.7536
          },
          {
            hole: 71,
            x: -70.1375,
            y: 15,
            z: 93.9168
          },
          {
            hole: 72,
            x: -80.2316,
            y: 15,
            z: 92.9226
          },
          {
            hole: 73,
            x: -90.239,
            y: 15,
            z: 91.2704
          },
          {
            hole: 74,
            x: -100.117,
            y: 15,
            z: 88.9672
          },
          {
            hole: 75,
            x: -109.8232,
            y: 15,
            z: 86.0229
          },
          {
            hole: 76,
            x: -128.5548,
            y: 15,
            z: 78.264
          },
          {
            hole: 77,
            x: -137.5,
            y: 15,
            z: 73.4826
          },
          {
            hole: 78,
            x: -146.1134,
            y: 15,
            z: 68.1265
          },
          {
            hole: 79,
            x: -154.358,
            y: 15,
            z: 62.2185
          },
          {
            hole: 80,
            x: -162.1986,
            y: 15,
            z: 55.7839
          },
          {
            hole: 81,
            x: -176.5352,
            y: 15,
            z: 41.4473
          },
          {
            hole: 82,
            x: -182.9698,
            y: 15,
            z: 33.6067
          },
          {
            hole: 83,
            x: -188.8778,
            y: 15,
            z: 25.3621
          },
          {
            hole: 84,
            x: -194.234,
            y: 15,
            z: 16.7487
          },
          {
            hole: 85,
            x: -199.0153,
            y: 15,
            z: 7.8034
          },
          {
            hole: 86,
            x: -206.7742,
            y: 15,
            z: -10.9282
          },
          {
            hole: 87,
            x: -209.7185,
            y: 15,
            z: -20.6344
          },
          {
            hole: 88,
            x: -212.0218,
            y: 15,
            z: -30.5123
          },
          {
            hole: 89,
            x: -213.674,
            y: 15,
            z: -40.5198
          },
          {
            hole: 90,
            x: -214.6682,
            y: 15,
            z: -50.6138
          },
          {
            hole: 91,
            x: -214.6682,
            y: 15,
            z: -70.8888
          },
          {
            hole: 92,
            x: -213.674,
            y: 15,
            z: -80.9829
          },
          {
            hole: 93,
            x: -212.0218,
            y: 15,
            z: -90.9903
          },
          {
            hole: 94,
            x: -209.7185,
            y: 15,
            z: -100.8683
          },
          {
            hole: 95,
            x: -206.7742,
            y: 15,
            z: -110.5744
          },
          {
            hole: 96,
            x: -199.0153,
            y: 15,
            z: -129.3061
          },
          {
            hole: 97,
            x: -194.234,
            y: 15,
            z: -138.2513
          },
          {
            hole: 98,
            x: -188.8778,
            y: 15,
            z: -146.8647
          },
          {
            hole: 99,
            x: -182.9698,
            y: 15,
            z: -155.1093
          },
          {
            hole: 100,
            x: -176.5352,
            y: 15,
            z: -162.9499
          },
          {
            hole: 101,
            x: -162.1986,
            y: 15,
            z: -177.2865
          },
          {
            hole: 102,
            x: -154.3581,
            y: 15,
            z: -183.7211
          },
          {
            hole: 103,
            x: -146.1134,
            y: 15,
            z: -189.6291
          },
          {
            hole: 104,
            x: -137.5,
            y: 15,
            z: -194.9852
          },
          {
            hole: 105,
            x: -128.5548,
            y: 15,
            z: -199.7666
          },
          {
            hole: 106,
            x: -109.8231,
            y: 15,
            z: -207.5255
          },
          {
            hole: 107,
            x: -100.117,
            y: 15,
            z: -210.4698
          },
          {
            hole: 108,
            x: -90.239,
            y: 15,
            z: -212.773
          },
          {
            hole: 109,
            x: -80.2316,
            y: 15,
            z: -214.4253
          },
          {
            hole: 110,
            x: -70.1375,
            y: 15,
            z: -215.4194
          },
          {
            hole: 111,
            x: -49.8626,
            y: 15,
            z: -215.4194
          },
          {
            hole: 112,
            x: -39.7685,
            y: 15,
            z: -214.4253
          },
          {
            hole: 113,
            x: -29.761,
            y: 15,
            z: -212.773
          },
          {
            hole: 114,
            x: -19.8831,
            y: 15,
            z: -210.4698
          },
          {
            hole: 115,
            x: -10.1769,
            y: 15,
            z: -207.5255
          },
          {
            hole: 116,
            x: 8.5547,
            y: 15,
            z: -199.7666
          },
          {
            hole: 117,
            x: 17.5,
            y: 15,
            z: -194.9852
          },
          {
            hole: 118,
            x: 26.1134,
            y: 15,
            z: -189.6291
          },
          {
            hole: 119,
            x: 34.358,
            y: 15,
            z: -183.7211
          },
          {
            hole: 120,
            x: 42.1986,
            y: 15,
            z: -177.2865
          },
          {
            hole: 121,
            x: 56.5351,
            y: 15,
            z: -162.9499
          },
          {
            hole: 122,
            x: 62.9697,
            y: 15,
            z: -155.1093
          },
          {
            hole: 123,
            x: 68.8777,
            y: 15,
            z: -146.8647
          },
          {
            hole: 124,
            x: 74.2339,
            y: 15,
            z: -138.2513
          },
          {
            hole: 125,
            x: 79.0152,
            y: 15,
            z: -129.3061
          },
          {
            hole: 126,
            x: 86.7741,
            y: 15,
            z: -110.5744
          },
          {
            hole: 127,
            x: 89.7185,
            y: 15,
            z: -100.8683
          },
          {
            hole: 128,
            x: 92.0217,
            y: 15,
            z: -90.9903
          },
          {
            hole: 129,
            x: 93.6739,
            y: 15,
            z: -80.9829
          },
          {
            hole: 130,
            x: 94.6681,
            y: 15,
            z: -70.8888
          },
          {
            hole: 121,
            x: 80,
            y: 15,
            z: 118.8283
          }
        ],
        p2: [
          {
            hole: 0,
            x: 127,
            y: 15,
            z: 73.8283
          },
          {
            hole: 1,
            x: 135.5,
            y: 15,
            z: -45.4951
          },
          {
            hole: 2,
            x: 127.75,
            y: 15,
            z: -45.4951
          },
          {
            hole: 3,
            x: 120,
            y: 15,
            z: -45.4951
          },
          {
            hole: 4,
            x: 112.25,
            y: 15,
            z: -45.4951
          },
          {
            hole: 5,
            x: 104.5,
            y: 15,
            z: -45.4951
          },
          {
            hole: 6,
            x: 175.5,
            y: 15,
            z: -45.4951
          },
          {
            hole: 7,
            x: 167.75,
            y: 15,
            z: -45.4951
          },
          {
            hole: 8,
            x: 160,
            y: 15,
            z: -45.4951
          },
          {
            hole: 9,
            x: 152.25,
            y: 15,
            z: -45.4951
          },
          {
            hole: 10,
            x: 144.5,
            y: 15,
            z: -45.4951
          },
          {
            hole: 11,
            x: 215.5,
            y: 15,
            z: -45.4951
          },
          {
            hole: 12,
            x: 207.75,
            y: 15,
            z: -45.4951
          },
          {
            hole: 13,
            x: 200,
            y: 15,
            z: -45.4951
          },
          {
            hole: 14,
            x: 192.25,
            y: 15,
            z: -45.4951
          },
          {
            hole: 15,
            x: 184.5,
            y: 15,
            z: -45.4951
          },
          {
            hole: 16,
            x: 225,
            y: 15,
            z: -45.7513
          },
          {
            hole: 17,
            x: 232.5,
            y: 15,
            z: -45.7513
          },
          {
            hole: 18,
            x: 257.6776,
            y: 15,
            z: -38.429
          },
          {
            hole: 19,
            x: 265,
            y: 15,
            z: -13.2513
          },
          {
            hole: 20,
            x: 265,
            y: 15,
            z: -5.7513
          },
          {
            hole: 21,
            x: 265,
            y: 15,
            z: 43.8283
          },
          {
            hole: 22,
            x: 265,
            y: 15,
            z: 51.3283
          },
          {
            hole: 23,
            x: 257.6776,
            y: 15,
            z: 76.5059
          },
          {
            hole: 24,
            x: 232.5,
            y: 15,
            z: 83.8283
          },
          {
            hole: 25,
            x: 225,
            y: 15,
            z: 83.8283
          },
          {
            hole: 26,
            x: 175.5,
            y: 15,
            z: 73.8283
          },
          {
            hole: 27,
            x: 167.75,
            y: 15,
            z: 73.8283
          },
          {
            hole: 28,
            x: 160,
            y: 15,
            z: 73.8283
          },
          {
            hole: 29,
            x: 152.25,
            y: 15,
            z: 73.8283
          },
          {
            hole: 30,
            x: 144.5,
            y: 15,
            z: 73.8283
          },
          {
            hole: 31,
            x: 215.5,
            y: 15,
            z: 73.8283
          },
          {
            hole: 32,
            x: 207.75,
            y: 15,
            z: 73.8283
          },
          {
            hole: 33,
            x: 200,
            y: 15,
            z: 73.8283
          },
          {
            hole: 34,
            x: 192.25,
            y: 15,
            z: 73.8283
          },
          {
            hole: 35,
            x: 184.5,
            y: 15,
            z: 73.8283
          },
          {
            hole: 36,
            x: 85,
            y: 15,
            z: 174.3282
          },
          {
            hole: 37,
            x: 85,
            y: 15,
            z: 166.5782
          },
          {
            hole: 38,
            x: 85,
            y: 15,
            z: 158.8282
          },
          {
            hole: 39,
            x: 85,
            y: 15,
            z: 151.0782
          },
          {
            hole: 40,
            x: 85,
            y: 15,
            z: 143.3282
          },
          {
            hole: 41,
            x: 85,
            y: 15,
            z: 214.3282
          },
          {
            hole: 42,
            x: 85,
            y: 15,
            z: 206.5782
          },
          {
            hole: 43,
            x: 85,
            y: 15,
            z: 198.8282
          },
          {
            hole: 44,
            x: 85,
            y: 15,
            z: 191.0782
          },
          {
            hole: 45,
            x: 85,
            y: 15,
            z: 183.3282
          },
          {
            hole: 46,
            x: 85,
            y: 15,
            z: 223.8282
          },
          {
            hole: 47,
            x: 85,
            y: 15,
            z: 231.3282
          },
          {
            hole: 48,
            x: 77.6776,
            y: 15,
            z: 256.5059
          },
          {
            hole: 49,
            x: 52.5,
            y: 15,
            z: 263.8282
          },
          {
            hole: 50,
            x: 45,
            y: 15,
            z: 263.8282
          },
          {
            hole: 51,
            x: -5,
            y: 15,
            z: 263.8282
          },
          {
            hole: 52,
            x: -12.5,
            y: 15,
            z: 263.8282
          },
          {
            hole: 53,
            x: -37.6777,
            y: 15,
            z: 256.5059
          },
          {
            hole: 54,
            x: -45,
            y: 15,
            z: 231.3282
          },
          {
            hole: 55,
            x: -45,
            y: 15,
            z: 223.8282
          },
          {
            hole: 56,
            x: -35.014,
            y: 15,
            z: 214.3282
          },
          {
            hole: 57,
            x: -35.014,
            y: 15,
            z: 206.5782
          },
          {
            hole: 58,
            x: -35.014,
            y: 15,
            z: 198.8282
          },
          {
            hole: 59,
            x: -35.014,
            y: 15,
            z: 191.0782
          },
          {
            hole: 60,
            x: -35.014,
            y: 15,
            z: 183.3282
          },
          {
            hole: 61,
            x: -35.014,
            y: 15,
            z: 174.3282
          },
          {
            hole: 62,
            x: -35.014,
            y: 15,
            z: 166.5782
          },
          {
            hole: 63,
            x: -35.014,
            y: 15,
            z: 158.8282
          },
          {
            hole: 64,
            x: -35.014,
            y: 15,
            z: 151.0782
          },
          {
            hole: 65,
            x: -35.014,
            y: 15,
            z: 143.3282
          },
          {
            hole: 66,
            x: -35.014,
            y: 15,
            z: 134.7536
          },
          {
            hole: 67,
            x: -35.014,
            y: 15,
            z: 127.0036
          },
          {
            hole: 68,
            x: -35.014,
            y: 15,
            z: 119.2536
          },
          {
            hole: 69,
            x: -35.014,
            y: 15,
            z: 111.5036
          },
          {
            hole: 70,
            x: -35.014,
            y: 15,
            z: 103.7536
          },
          {
            hole: 71,
            x: -69.4835,
            y: 15,
            z: 83.9382
          },
          {
            hole: 72,
            x: -78.9263,
            y: 15,
            z: 83.0082
          },
          {
            hole: 73,
            x: -88.2881,
            y: 15,
            z: 81.4626
          },
          {
            hole: 74,
            x: -97.5288,
            y: 15,
            z: 79.3079
          },
          {
            hole: 75,
            x: -106.6088,
            y: 15,
            z: 76.5536
          },
          {
            hole: 76,
            x: -124.1319,
            y: 15,
            z: 69.2952
          },
          {
            hole: 77,
            x: -132.5,
            y: 15,
            z: 64.8224
          },
          {
            hole: 78,
            x: -140.5577,
            y: 15,
            z: 59.8118
          },
          {
            hole: 79,
            x: -148.2704,
            y: 15,
            z: 54.2849
          },
          {
            hole: 80,
            x: -155.6052,
            y: 15,
            z: 48.2655
          },
          {
            hole: 81,
            x: -169.0168,
            y: 15,
            z: 34.8538
          },
          {
            hole: 82,
            x: -175.0363,
            y: 15,
            z: 27.5191
          },
          {
            hole: 83,
            x: -180.5631,
            y: 15,
            z: 19.8064
          },
          {
            hole: 84,
            x: -185.5737,
            y: 15,
            z: 11.7487
          },
          {
            hole: 85,
            x: -190.0466,
            y: 15,
            z: 3.3805
          },
          {
            hole: 86,
            x: -197.3049,
            y: 15,
            z: -14.1426
          },
          {
            hole: 87,
            x: -200.0593,
            y: 15,
            z: -23.2226
          },
          {
            hole: 88,
            x: -202.2139,
            y: 15,
            z: -32.4632
          },
          {
            hole: 89,
            x: -203.7595,
            y: 15,
            z: -41.825
          },
          {
            hole: 90,
            x: -204.6896,
            y: 15,
            z: -51.2679
          },
          {
            hole: 91,
            x: -204.6896,
            y: 15,
            z: -70.2348
          },
          {
            hole: 92,
            x: -203.7595,
            y: 15,
            z: -79.6776
          },
          {
            hole: 93,
            x: -202.2139,
            y: 15,
            z: -89.0394
          },
          {
            hole: 94,
            x: -200.0593,
            y: 15,
            z: -98.2801
          },
          {
            hole: 95,
            x: -197.3049,
            y: 15,
            z: -107.36
          },
          {
            hole: 96,
            x: -190.0466,
            y: 15,
            z: -124.8832
          },
          {
            hole: 97,
            x: -185.5737,
            y: 15,
            z: -133.2513
          },
          {
            hole: 98,
            x: -180.5631,
            y: 15,
            z: -141.309
          },
          {
            hole: 99,
            x: -175.0363,
            y: 15,
            z: -149.0217
          },
          {
            hole: 100,
            x: -169.0168,
            y: 15,
            z: -156.3565
          },
          {
            hole: 101,
            x: -155.6052,
            y: 15,
            z: -169.7681
          },
          {
            hole: 102,
            x: -148.2704,
            y: 15,
            z: -175.7875
          },
          {
            hole: 103,
            x: -140.5577,
            y: 15,
            z: -181.3144
          },
          {
            hole: 104,
            x: -132.5,
            y: 15,
            z: -186.325
          },
          {
            hole: 105,
            x: -124.1319,
            y: 15,
            z: -190.7979
          },
          {
            hole: 106,
            x: -106.6088,
            y: 15,
            z: -198.0562
          },
          {
            hole: 107,
            x: -97.5288,
            y: 15,
            z: -200.8106
          },
          {
            hole: 108,
            x: -88.2881,
            y: 15,
            z: -202.9652
          },
          {
            hole: 109,
            x: -78.9263,
            y: 15,
            z: -204.5108
          },
          {
            hole: 110,
            x: -69.4835,
            y: 15,
            z: -205.4408
          },
          {
            hole: 111,
            x: -50.5166,
            y: 15,
            z: -205.4409
          },
          {
            hole: 112,
            x: -41.0737,
            y: 15,
            z: -204.5108
          },
          {
            hole: 113,
            x: -31.7119,
            y: 15,
            z: -202.9652
          },
          {
            hole: 114,
            x: -22.4713,
            y: 15,
            z: -200.8106
          },
          {
            hole: 115,
            x: -13.3913,
            y: 15,
            z: -198.0562
          },
          {
            hole: 116,
            x: 4.1318,
            y: 15,
            z: -190.7979
          },
          {
            hole: 117,
            x: 12.5,
            y: 15,
            z: -186.325
          },
          {
            hole: 118,
            x: 20.5577,
            y: 15,
            z: -181.3144
          },
          {
            hole: 119,
            x: 28.2704,
            y: 15,
            z: -175.7875
          },
          {
            hole: 120,
            x: 35.6051,
            y: 15,
            z: -169.7681
          },
          {
            hole: 121,
            x: 49.0167,
            y: 15,
            z: -156.3565
          },
          {
            hole: 122,
            x: 55.0362,
            y: 15,
            z: -149.0217
          },
          {
            hole: 123,
            x: 60.5631,
            y: 15,
            z: -141.309
          },
          {
            hole: 124,
            x: 65.5736,
            y: 15,
            z: -133.2513
          },
          {
            hole: 125,
            x: 70.0465,
            y: 15,
            z: -124.8832
          },
          {
            hole: 126,
            x: 77.3048,
            y: 15,
            z: -107.36
          },
          {
            hole: 127,
            x: 80.0592,
            y: 15,
            z: -98.2801
          },
          {
            hole: 128,
            x: 82.2138,
            y: 15,
            z: -89.0394
          },
          {
            hole: 129,
            x: 83.7595,
            y: 15,
            z: -79.6776
          },
          {
            hole: 130,
            x: 84.6895,
            y: 15,
            z: -70.2348
          },
          {
            hole: 121,
            x: 80,
            y: 15,
            z: 118.8283
          }
        ],
        p3: [
          {
            hole: 0,
            x: 127,
            y: 15,
            z: 83.8283
          },
          {
            hole: 1,
            x: 135.5,
            y: 15,
            z: -35.4951
          },
          {
            hole: 2,
            x: 127.75,
            y: 15,
            z: -35.4951
          },
          {
            hole: 3,
            x: 120,
            y: 15,
            z: -35.4951
          },
          {
            hole: 4,
            x: 112.25,
            y: 15,
            z: -35.4951
          },
          {
            hole: 5,
            x: 104.5,
            y: 15,
            z: -35.4951
          },
          {
            hole: 6,
            x: 175.5,
            y: 15,
            z: -35.4951
          },
          {
            hole: 7,
            x: 167.75,
            y: 15,
            z: -35.4951
          },
          {
            hole: 8,
            x: 160,
            y: 15,
            z: -35.4951
          },
          {
            hole: 9,
            x: 152.25,
            y: 15,
            z: -35.4951
          },
          {
            hole: 10,
            x: 144.5,
            y: 15,
            z: -35.4951
          },
          {
            hole: 11,
            x: 215.5,
            y: 15,
            z: -35.4951
          },
          {
            hole: 12,
            x: 207.75,
            y: 15,
            z: -35.4951
          },
          {
            hole: 13,
            x: 200,
            y: 15,
            z: -35.4951
          },
          {
            hole: 14,
            x: 192.25,
            y: 15,
            z: -35.4951
          },
          {
            hole: 15,
            x: 184.5,
            y: 15,
            z: -35.4951
          },
          {
            hole: 16,
            x: 225,
            y: 15,
            z: -35.7513
          },
          {
            hole: 17,
            x: 232.5,
            y: 15,
            z: -35.7513
          },
          {
            hole: 18,
            x: 250.6066,
            y: 15,
            z: -31.3579
          },
          {
            hole: 19,
            x: 255,
            y: 15,
            z: -13.2513
          },
          {
            hole: 20,
            x: 255,
            y: 15,
            z: -5.7513
          },
          {
            hole: 21,
            x: 255,
            y: 15,
            z: 43.8283
          },
          {
            hole: 22,
            x: 255,
            y: 15,
            z: 51.3283
          },
          {
            hole: 23,
            x: 250.6066,
            y: 15,
            z: 69.4349
          },
          {
            hole: 24,
            x: 232.5,
            y: 15,
            z: 73.8283
          },
          {
            hole: 25,
            x: 225,
            y: 15,
            z: 73.8283
          },
          {
            hole: 26,
            x: 175.5,
            y: 15,
            z: 83.8283
          },
          {
            hole: 27,
            x: 167.75,
            y: 15,
            z: 83.8283
          },
          {
            hole: 28,
            x: 160,
            y: 15,
            z: 83.8283
          },
          {
            hole: 29,
            x: 152.25,
            y: 15,
            z: 83.8283
          },
          {
            hole: 30,
            x: 144.5,
            y: 15,
            z: 83.8283
          },
          {
            hole: 31,
            x: 215.5,
            y: 15,
            z: 83.8283
          },
          {
            hole: 32,
            x: 207.75,
            y: 15,
            z: 83.8283
          },
          {
            hole: 33,
            x: 200,
            y: 15,
            z: 83.8283
          },
          {
            hole: 34,
            x: 192.25,
            y: 15,
            z: 83.8283
          },
          {
            hole: 35,
            x: 184.5,
            y: 15,
            z: 83.8283
          },
          {
            hole: 36,
            x: 75,
            y: 15,
            z: 174.3282
          },
          {
            hole: 37,
            x: 75,
            y: 15,
            z: 166.5782
          },
          {
            hole: 38,
            x: 75,
            y: 15,
            z: 158.8282
          },
          {
            hole: 39,
            x: 75,
            y: 15,
            z: 151.0782
          },
          {
            hole: 40,
            x: 75,
            y: 15,
            z: 143.3282
          },
          {
            hole: 41,
            x: 75,
            y: 15,
            z: 214.3282
          },
          {
            hole: 42,
            x: 75,
            y: 15,
            z: 206.5782
          },
          {
            hole: 43,
            x: 75,
            y: 15,
            z: 198.8282
          },
          {
            hole: 44,
            x: 75,
            y: 15,
            z: 191.0782
          },
          {
            hole: 45,
            x: 75,
            y: 15,
            z: 183.3282
          },
          {
            hole: 46,
            x: 75,
            y: 15,
            z: 223.8282
          },
          {
            hole: 47,
            x: 75,
            y: 15,
            z: 231.3282
          },
          {
            hole: 48,
            x: 70.6066,
            y: 15,
            z: 249.4348
          },
          {
            hole: 49,
            x: 52.5,
            y: 15,
            z: 253.8282
          },
          {
            hole: 50,
            x: 45,
            y: 15,
            z: 253.8282
          },
          {
            hole: 51,
            x: -5,
            y: 15,
            z: 253.8282
          },
          {
            hole: 52,
            x: -12.5,
            y: 15,
            z: 253.8282
          },
          {
            hole: 53,
            x: -30.6066,
            y: 15,
            z: 249.4348
          },
          {
            hole: 54,
            x: -35,
            y: 15,
            z: 231.3282
          },
          {
            hole: 55,
            x: -35,
            y: 15,
            z: 223.8282
          },
          {
            hole: 56,
            x: -45.014,
            y: 15,
            z: 214.3282
          },
          {
            hole: 57,
            x: -45.014,
            y: 15,
            z: 206.5782
          },
          {
            hole: 58,
            x: -45.014,
            y: 15,
            z: 198.8282
          },
          {
            hole: 59,
            x: -45.014,
            y: 15,
            z: 191.0782
          },
          {
            hole: 60,
            x: -45.014,
            y: 15,
            z: 183.3282
          },
          {
            hole: 61,
            x: -45.014,
            y: 15,
            z: 174.3282
          },
          {
            hole: 62,
            x: -45.014,
            y: 15,
            z: 166.5782
          },
          {
            hole: 63,
            x: -45.014,
            y: 15,
            z: 158.8282
          },
          {
            hole: 64,
            x: -45.014,
            y: 15,
            z: 151.0782
          },
          {
            hole: 65,
            x: -45.014,
            y: 15,
            z: 143.3282
          },
          {
            hole: 66,
            x: -45.014,
            y: 15,
            z: 134.7536
          },
          {
            hole: 67,
            x: -45.014,
            y: 15,
            z: 127.0036
          },
          {
            hole: 68,
            x: -45.014,
            y: 15,
            z: 119.2536
          },
          {
            hole: 69,
            x: -45.014,
            y: 15,
            z: 111.5036
          },
          {
            hole: 70,
            x: -45.014,
            y: 15,
            z: 103.7536
          },
          {
            hole: 71,
            x: -68.8295,
            y: 15,
            z: 73.9596
          },
          {
            hole: 72,
            x: -77.6211,
            y: 15,
            z: 73.0937
          },
          {
            hole: 73,
            x: -86.3372,
            y: 15,
            z: 71.6547
          },
          {
            hole: 74,
            x: -94.9406,
            y: 15,
            z: 69.6487
          },
          {
            hole: 75,
            x: -103.3944,
            y: 15,
            z: 67.0843
          },
          {
            hole: 76,
            x: -119.709,
            y: 15,
            z: 60.3265
          },
          {
            hole: 77,
            x: -127.5,
            y: 15,
            z: 56.1621
          },
          {
            hole: 78,
            x: -135.002,
            y: 15,
            z: 51.4971
          },
          {
            hole: 79,
            x: -142.1828,
            y: 15,
            z: 46.3514
          },
          {
            hole: 80,
            x: -149.0117,
            y: 15,
            z: 40.7471
          },
          {
            hole: 81,
            x: -161.4984,
            y: 15,
            z: 28.2604
          },
          {
            hole: 82,
            x: -167.1027,
            y: 15,
            z: 21.4315
          },
          {
            hole: 83,
            x: -172.2484,
            y: 15,
            z: 14.2507
          },
          {
            hole: 84,
            x: -176.9135,
            y: 15,
            z: 6.7487
          },
          {
            hole: 85,
            x: -181.0779,
            y: 15,
            z: -1.0423
          },
          {
            hole: 86,
            x: -187.8356,
            y: 15,
            z: -17.357
          },
          {
            hole: 87,
            x: -190.4,
            y: 15,
            z: -25.8107
          },
          {
            hole: 88,
            x: -192.406,
            y: 15,
            z: -34.4141
          },
          {
            hole: 89,
            x: -193.8451,
            y: 15,
            z: -43.1303
          },
          {
            hole: 90,
            x: -194.711,
            y: 15,
            z: -51.9219
          },
          {
            hole: 91,
            x: -194.711,
            y: 15,
            z: -69.5807
          },
          {
            hole: 92,
            x: -193.8451,
            y: 15,
            z: -78.3723
          },
          {
            hole: 93,
            x: -192.4061,
            y: 15,
            z: -87.0885
          },
          {
            hole: 94,
            x: -190.4,
            y: 15,
            z: -95.6919
          },
          {
            hole: 95,
            x: -187.8356,
            y: 15,
            z: -104.1456
          },
          {
            hole: 96,
            x: -181.0779,
            y: 15,
            z: -120.4603
          },
          {
            hole: 97,
            x: -176.9135,
            y: 15,
            z: -128.2513
          },
          {
            hole: 98,
            x: -172.2484,
            y: 15,
            z: -135.7533
          },
          {
            hole: 99,
            x: -167.1027,
            y: 15,
            z: -142.9341
          },
          {
            hole: 100,
            x: -161.4984,
            y: 15,
            z: -149.763
          },
          {
            hole: 101,
            x: -149.0117,
            y: 15,
            z: -162.2497
          },
          {
            hole: 102,
            x: -142.1828,
            y: 15,
            z: -167.854
          },
          {
            hole: 103,
            x: -135.002,
            y: 15,
            z: -172.9997
          },
          {
            hole: 104,
            x: -127.5,
            y: 15,
            z: -177.6647
          },
          {
            hole: 105,
            x: -119.709,
            y: 15,
            z: -181.8291
          },
          {
            hole: 106,
            x: -103.3944,
            y: 15,
            z: -188.5869
          },
          {
            hole: 107,
            x: -94.9406,
            y: 15,
            z: -191.1513
          },
          {
            hole: 108,
            x: -86.3372,
            y: 15,
            z: -193.1573
          },
          {
            hole: 109,
            x: -77.6211,
            y: 15,
            z: -194.5964
          },
          {
            hole: 110,
            x: -68.8295,
            y: 15,
            z: -195.4623
          },
          {
            hole: 111,
            x: -51.1706,
            y: 15,
            z: -195.4623
          },
          {
            hole: 112,
            x: -42.379,
            y: 15,
            z: -194.5964
          },
          {
            hole: 113,
            x: -33.6628,
            y: 15,
            z: -193.1573
          },
          {
            hole: 114,
            x: -25.0595,
            y: 15,
            z: -191.1513
          },
          {
            hole: 115,
            x: -16.6057,
            y: 15,
            z: -188.5869
          },
          {
            hole: 116,
            x: -0.2911,
            y: 15,
            z: -181.8291
          },
          {
            hole: 117,
            x: 7.5,
            y: 15,
            z: -177.6647
          },
          {
            hole: 118,
            x: 15.0019,
            y: 15,
            z: -172.9997
          },
          {
            hole: 119,
            x: 22.1828,
            y: 15,
            z: -167.854
          },
          {
            hole: 120,
            x: 29.0117,
            y: 15,
            z: -162.2497
          },
          {
            hole: 121,
            x: 41.4983,
            y: 15,
            z: -149.763
          },
          {
            hole: 122,
            x: 47.1027,
            y: 15,
            z: -142.9341
          },
          {
            hole: 123,
            x: 52.2484,
            y: 15,
            z: -135.7533
          },
          {
            hole: 124,
            x: 56.9134,
            y: 15,
            z: -128.2513
          },
          {
            hole: 125,
            x: 61.0778,
            y: 15,
            z: -120.4603
          },
          {
            hole: 126,
            x: 67.8355,
            y: 15,
            z: -104.1456
          },
          {
            hole: 127,
            x: 70.3999,
            y: 15,
            z: -95.6919
          },
          {
            hole: 128,
            x: 72.406,
            y: 15,
            z: -87.0885
          },
          {
            hole: 129,
            x: 73.845,
            y: 15,
            z: -78.3723
          },
          {
            hole: 130,
            x: 74.7109,
            y: 15,
            z: -69.5807
          },
          {
            hole: 121,
            x: 80,
            y: 15,
            z: 118.8283
          }
        ],
        p4: [
          {
            hole: 0,
            x: 127,
            y: 15,
            z: 93.8283
          },
          {
            hole: 1,
            x: 135.5,
            y: 15,
            z: -25.4951
          },
          {
            hole: 2,
            x: 127.75,
            y: 15,
            z: -25.4951
          },
          {
            hole: 3,
            x: 120,
            y: 15,
            z: -25.4951
          },
          {
            hole: 4,
            x: 112.25,
            y: 15,
            z: -25.4951
          },
          {
            hole: 5,
            x: 104.5,
            y: 15,
            z: -25.4951
          },
          {
            hole: 6,
            x: 175.5,
            y: 15,
            z: -25.4951
          },
          {
            hole: 7,
            x: 167.75,
            y: 15,
            z: -25.4951
          },
          {
            hole: 8,
            x: 160,
            y: 15,
            z: -25.4951
          },
          {
            hole: 9,
            x: 152.25,
            y: 15,
            z: -25.4951
          },
          {
            hole: 10,
            x: 144.5,
            y: 15,
            z: -25.4951
          },
          {
            hole: 11,
            x: 215.5,
            y: 15,
            z: -25.4951
          },
          {
            hole: 12,
            x: 207.75,
            y: 15,
            z: -25.4951
          },
          {
            hole: 13,
            x: 200,
            y: 15,
            z: -25.4951
          },
          {
            hole: 14,
            x: 192.25,
            y: 15,
            z: -25.4951
          },
          {
            hole: 15,
            x: 184.5,
            y: 15,
            z: -25.4951
          },
          {
            hole: 16,
            x: 225,
            y: 15,
            z: -25.7513
          },
          {
            hole: 17,
            x: 232.5,
            y: 15,
            z: -25.7513
          },
          {
            hole: 18,
            x: 243.5355,
            y: 15,
            z: -24.2869
          },
          {
            hole: 19,
            x: 245,
            y: 15,
            z: -13.2513
          },
          {
            hole: 20,
            x: 245,
            y: 15,
            z: -5.7513
          },
          {
            hole: 21,
            x: 245,
            y: 15,
            z: 43.8283
          },
          {
            hole: 22,
            x: 245,
            y: 15,
            z: 51.3283
          },
          {
            hole: 23,
            x: 243.5355,
            y: 15,
            z: 62.3638
          },
          {
            hole: 24,
            x: 232.5,
            y: 15,
            z: 63.8283
          },
          {
            hole: 25,
            x: 225,
            y: 15,
            z: 63.8283
          },
          {
            hole: 26,
            x: 175.5,
            y: 15,
            z: 93.8283
          },
          {
            hole: 27,
            x: 167.75,
            y: 15,
            z: 93.8283
          },
          {
            hole: 28,
            x: 160,
            y: 15,
            z: 93.8283
          },
          {
            hole: 29,
            x: 152.25,
            y: 15,
            z: 93.8283
          },
          {
            hole: 30,
            x: 144.5,
            y: 15,
            z: 93.8283
          },
          {
            hole: 31,
            x: 215.5,
            y: 15,
            z: 93.8283
          },
          {
            hole: 32,
            x: 207.75,
            y: 15,
            z: 93.8283
          },
          {
            hole: 33,
            x: 200,
            y: 15,
            z: 93.8283
          },
          {
            hole: 34,
            x: 192.25,
            y: 15,
            z: 93.8283
          },
          {
            hole: 35,
            x: 184.5,
            y: 15,
            z: 93.8283
          },
          {
            hole: 36,
            x: 65,
            y: 15,
            z: 174.3282
          },
          {
            hole: 37,
            x: 65,
            y: 15,
            z: 166.5782
          },
          {
            hole: 38,
            x: 65,
            y: 15,
            z: 158.8282
          },
          {
            hole: 39,
            x: 65,
            y: 15,
            z: 151.0782
          },
          {
            hole: 40,
            x: 65,
            y: 15,
            z: 143.3282
          },
          {
            hole: 41,
            x: 65,
            y: 15,
            z: 214.3282
          },
          {
            hole: 42,
            x: 65,
            y: 15,
            z: 206.5782
          },
          {
            hole: 43,
            x: 65,
            y: 15,
            z: 198.8282
          },
          {
            hole: 44,
            x: 65,
            y: 15,
            z: 191.0782
          },
          {
            hole: 45,
            x: 65,
            y: 15,
            z: 183.3282
          },
          {
            hole: 46,
            x: 65,
            y: 15,
            z: 223.8282
          },
          {
            hole: 47,
            x: 65,
            y: 15,
            z: 231.3282
          },
          {
            hole: 48,
            x: 63.5355,
            y: 15,
            z: 242.3638
          },
          {
            hole: 49,
            x: 52.5,
            y: 15,
            z: 243.8282
          },
          {
            hole: 50,
            x: 45,
            y: 15,
            z: 243.8282
          },
          {
            hole: 51,
            x: -5,
            y: 15,
            z: 243.8282
          },
          {
            hole: 52,
            x: -12.5,
            y: 15,
            z: 243.8282
          },
          {
            hole: 53,
            x: -23.5356,
            y: 15,
            z: 242.3638
          },
          {
            hole: 54,
            x: -25,
            y: 15,
            z: 231.3282
          },
          {
            hole: 55,
            x: -25,
            y: 15,
            z: 223.8282
          },
          {
            hole: 56,
            x: -55.014,
            y: 15,
            z: 214.3282
          },
          {
            hole: 57,
            x: -55.014,
            y: 15,
            z: 206.5782
          },
          {
            hole: 58,
            x: -55.014,
            y: 15,
            z: 198.8282
          },
          {
            hole: 59,
            x: -55.014,
            y: 15,
            z: 191.0782
          },
          {
            hole: 60,
            x: -55.014,
            y: 15,
            z: 183.3282
          },
          {
            hole: 61,
            x: -55.014,
            y: 15,
            z: 174.3282
          },
          {
            hole: 62,
            x: -55.014,
            y: 15,
            z: 166.5782
          },
          {
            hole: 63,
            x: -55.014,
            y: 15,
            z: 158.8282
          },
          {
            hole: 64,
            x: -55.014,
            y: 15,
            z: 151.0782
          },
          {
            hole: 65,
            x: -55.014,
            y: 15,
            z: 143.3282
          },
          {
            hole: 66,
            x: -55.014,
            y: 15,
            z: 134.7536
          },
          {
            hole: 67,
            x: -55.014,
            y: 15,
            z: 127.0036
          },
          {
            hole: 68,
            x: -55.014,
            y: 15,
            z: 119.2536
          },
          {
            hole: 69,
            x: -55.014,
            y: 15,
            z: 111.5036
          },
          {
            hole: 70,
            x: -55.014,
            y: 15,
            z: 103.7536
          },
          {
            hole: 71,
            x: -68.1754,
            y: 15,
            z: 63.9811
          },
          {
            hole: 72,
            x: -76.3158,
            y: 15,
            z: 63.1793
          },
          {
            hole: 73,
            x: -84.3863,
            y: 15,
            z: 61.8468
          },
          {
            hole: 74,
            x: -92.3524,
            y: 15,
            z: 59.9894
          },
          {
            hole: 75,
            x: -100.18,
            y: 15,
            z: 57.615
          },
          {
            hole: 76,
            x: -115.2861,
            y: 15,
            z: 51.3578
          },
          {
            hole: 77,
            x: -122.5,
            y: 15,
            z: 47.5019
          },
          {
            hole: 78,
            x: -129.4463,
            y: 15,
            z: 43.1824
          },
          {
            hole: 79,
            x: -136.0952,
            y: 15,
            z: 38.4179
          },
          {
            hole: 80,
            x: -142.4183,
            y: 15,
            z: 33.2287
          },
          {
            hole: 81,
            x: -153.98,
            y: 15,
            z: 21.6669
          },
          {
            hole: 82,
            x: -159.1692,
            y: 15,
            z: 15.3439
          },
          {
            hole: 83,
            x: -163.9337,
            y: 15,
            z: 8.695
          },
          {
            hole: 84,
            x: -168.2532,
            y: 15,
            z: 1.7487
          },
          {
            hole: 85,
            x: -172.1091,
            y: 15,
            z: -5.4652
          },
          {
            hole: 86,
            x: -178.3663,
            y: 15,
            z: -20.5714
          },
          {
            hole: 87,
            x: -180.7408,
            y: 15,
            z: -28.3989
          },
          {
            hole: 88,
            x: -182.5982,
            y: 15,
            z: -36.365
          },
          {
            hole: 89,
            x: -183.9306,
            y: 15,
            z: -44.4355
          },
          {
            hole: 90,
            x: -184.7324,
            y: 15,
            z: -52.5759
          },
          {
            hole: 91,
            x: -184.7324,
            y: 15,
            z: -68.9267
          },
          {
            hole: 92,
            x: -183.9306,
            y: 15,
            z: -77.0671
          },
          {
            hole: 93,
            x: -182.5982,
            y: 15,
            z: -85.1376
          },
          {
            hole: 94,
            x: -180.7408,
            y: 15,
            z: -93.1037
          },
          {
            hole: 95,
            x: -178.3663,
            y: 15,
            z: -100.9312
          },
          {
            hole: 96,
            x: -172.1091,
            y: 15,
            z: -116.0374
          },
          {
            hole: 97,
            x: -168.2532,
            y: 15,
            z: -123.2513
          },
          {
            hole: 98,
            x: -163.9337,
            y: 15,
            z: -130.1976
          },
          {
            hole: 99,
            x: -159.1692,
            y: 15,
            z: -136.8465
          },
          {
            hole: 100,
            x: -153.98,
            y: 15,
            z: -143.1695
          },
          {
            hole: 101,
            x: -142.4183,
            y: 15,
            z: -154.7313
          },
          {
            hole: 102,
            x: -136.0952,
            y: 15,
            z: -159.9205
          },
          {
            hole: 103,
            x: -129.4463,
            y: 15,
            z: -164.685
          },
          {
            hole: 104,
            x: -122.5,
            y: 15,
            z: -169.0045
          },
          {
            hole: 105,
            x: -115.2861,
            y: 15,
            z: -172.8604
          },
          {
            hole: 106,
            x: -100.18,
            y: 15,
            z: -179.1176
          },
          {
            hole: 107,
            x: -92.3524,
            y: 15,
            z: -181.492
          },
          {
            hole: 108,
            x: -84.3863,
            y: 15,
            z: -183.3495
          },
          {
            hole: 109,
            x: -76.3158,
            y: 15,
            z: -184.6819
          },
          {
            hole: 110,
            x: -68.1754,
            y: 15,
            z: -185.4837
          },
          {
            hole: 111,
            x: -51.8246,
            y: 15,
            z: -185.4837
          },
          {
            hole: 112,
            x: -43.6843,
            y: 15,
            z: -184.6819
          },
          {
            hole: 113,
            x: -35.6137,
            y: 15,
            z: -183.3495
          },
          {
            hole: 114,
            x: -27.6477,
            y: 15,
            z: -181.492
          },
          {
            hole: 115,
            x: -19.8201,
            y: 15,
            z: -179.1176
          },
          {
            hole: 116,
            x: -4.7139,
            y: 15,
            z: -172.8604
          },
          {
            hole: 117,
            x: 2.5,
            y: 15,
            z: -169.0045
          },
          {
            hole: 118,
            x: 9.4462,
            y: 15,
            z: -164.685
          },
          {
            hole: 119,
            x: 16.0951,
            y: 15,
            z: -159.9205
          },
          {
            hole: 120,
            x: 22.4182,
            y: 15,
            z: -154.7313
          },
          {
            hole: 121,
            x: 33.9799,
            y: 15,
            z: -143.1695
          },
          {
            hole: 122,
            x: 39.1691,
            y: 15,
            z: -136.8465
          },
          {
            hole: 123,
            x: 43.9337,
            y: 15,
            z: -130.1976
          },
          {
            hole: 124,
            x: 48.2531,
            y: 15,
            z: -123.2513
          },
          {
            hole: 125,
            x: 52.1091,
            y: 15,
            z: -116.0374
          },
          {
            hole: 126,
            x: 58.3662,
            y: 15,
            z: -100.9312
          },
          {
            hole: 127,
            x: 60.7407,
            y: 15,
            z: -93.1037
          },
          {
            hole: 128,
            x: 62.5981,
            y: 15,
            z: -85.1376
          },
          {
            hole: 129,
            x: 63.9306,
            y: 15,
            z: -77.0671
          },
          {
            hole: 130,
            x: 64.7323,
            y: 15,
            z: -68.9267
          },
          {
            hole: 121,
            x: 80,
            y: 15,
            z: 118.8283
          }
        ]
      }
    },
    {
      id: "board-cribbage-clash",
      name: "Cribbage Clash",
      brand: "clash",
      desc: "Cribbage Clash 3D cribbage board (13.7 MB)",
      target: 481,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/image_2026-09-28_120348350.png",
      modelUrl: "https://cdn.shopify.com/3d/models/5a81785101a7f569/cribbage-clash-no-bgimage.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 13,
            y: 5,
            z: 175
          },
          {
            hole: 1,
            x: 44.5,
            y: 5,
            z: 175
          },
          {
            hole: 2,
            x: 52.25,
            y: 5,
            z: 175
          },
          {
            hole: 3,
            x: 60,
            y: 5,
            z: 175
          },
          {
            hole: 4,
            x: 67.75,
            y: 5,
            z: 175
          },
          {
            hole: 5,
            x: 75.5,
            y: 5,
            z: 175
          },
          {
            hole: 6,
            x: 84.5,
            y: 5,
            z: 175
          },
          {
            hole: 7,
            x: 92.25,
            y: 5,
            z: 175
          },
          {
            hole: 8,
            x: 100,
            y: 5,
            z: 175
          },
          {
            hole: 9,
            x: 107.75,
            y: 5,
            z: 175
          },
          {
            hole: 10,
            x: 115.5,
            y: 5,
            z: 175
          },
          {
            hole: 11,
            x: 124.5,
            y: 5,
            z: 175
          },
          {
            hole: 12,
            x: 132.25,
            y: 5,
            z: 175
          },
          {
            hole: 13,
            x: 140,
            y: 5,
            z: 175
          },
          {
            hole: 14,
            x: 147.75,
            y: 5,
            z: 175
          },
          {
            hole: 15,
            x: 155.5,
            y: 5,
            z: 175
          },
          {
            hole: 16,
            x: 164.5,
            y: 5,
            z: 175
          },
          {
            hole: 17,
            x: 172.25,
            y: 5,
            z: 175
          },
          {
            hole: 18,
            x: 180,
            y: 5,
            z: 175
          },
          {
            hole: 19,
            x: 187.75,
            y: 5,
            z: 175
          },
          {
            hole: 20,
            x: 195.5,
            y: 5,
            z: 175
          },
          {
            hole: 21,
            x: 204.5,
            y: 5,
            z: 175
          },
          {
            hole: 22,
            x: 212.25,
            y: 5,
            z: 175
          },
          {
            hole: 23,
            x: 220,
            y: 5,
            z: 175
          },
          {
            hole: 24,
            x: 227.75,
            y: 5,
            z: 175
          },
          {
            hole: 25,
            x: 235.5,
            y: 5,
            z: 175
          },
          {
            hole: 26,
            x: 254.235,
            y: 5,
            z: 173.1259
          },
          {
            hole: 27,
            x: 267.5,
            y: 5,
            z: 167.6314
          },
          {
            hole: 28,
            x: 278.8909,
            y: 5,
            z: 158.8909
          },
          {
            hole: 29,
            x: 287.6314,
            y: 5,
            z: 147.5
          },
          {
            hole: 30,
            x: 293.1259,
            y: 5,
            z: 134.235
          },
          {
            hole: 31,
            x: 295,
            y: 5,
            z: 115.5
          },
          {
            hole: 32,
            x: 295,
            y: 5,
            z: 107.75
          },
          {
            hole: 33,
            x: 295,
            y: 5,
            z: 100
          },
          {
            hole: 34,
            x: 295,
            y: 5,
            z: 92.25
          },
          {
            hole: 35,
            x: 295,
            y: 5,
            z: 84.5
          },
          {
            hole: 36,
            x: 295,
            y: 5,
            z: 75.5
          },
          {
            hole: 37,
            x: 295,
            y: 5,
            z: 67.75
          },
          {
            hole: 38,
            x: 295,
            y: 5,
            z: 60
          },
          {
            hole: 39,
            x: 295,
            y: 5,
            z: 52.25
          },
          {
            hole: 40,
            x: 295,
            y: 5,
            z: 44.5
          },
          {
            hole: 41,
            x: 295,
            y: 5,
            z: 35.5
          },
          {
            hole: 42,
            x: 295,
            y: 5,
            z: 27.75
          },
          {
            hole: 43,
            x: 295,
            y: 5,
            z: 20
          },
          {
            hole: 44,
            x: 295,
            y: 5,
            z: 12.25
          },
          {
            hole: 45,
            x: 295,
            y: 5,
            z: 4.5
          },
          {
            hole: 46,
            x: 295,
            y: 5,
            z: -4.5
          },
          {
            hole: 47,
            x: 295,
            y: 5,
            z: -12.25
          },
          {
            hole: 48,
            x: 295,
            y: 5,
            z: -20
          },
          {
            hole: 49,
            x: 295,
            y: 5,
            z: -27.75
          },
          {
            hole: 50,
            x: 295,
            y: 5,
            z: -35.5
          },
          {
            hole: 51,
            x: 295,
            y: 5,
            z: -44.5
          },
          {
            hole: 52,
            x: 295,
            y: 5,
            z: -52.25
          },
          {
            hole: 53,
            x: 295,
            y: 5,
            z: -60
          },
          {
            hole: 54,
            x: 295,
            y: 5,
            z: -67.75
          },
          {
            hole: 55,
            x: 295,
            y: 5,
            z: -75.5
          },
          {
            hole: 56,
            x: 295,
            y: 5,
            z: -84.5
          },
          {
            hole: 57,
            x: 295,
            y: 5,
            z: -92.25
          },
          {
            hole: 58,
            x: 295,
            y: 5,
            z: -100
          },
          {
            hole: 59,
            x: 295,
            y: 5,
            z: -107.75
          },
          {
            hole: 60,
            x: 295,
            y: 5,
            z: -115.5
          },
          {
            hole: 61,
            x: 295,
            y: 5,
            z: -124.5
          },
          {
            hole: 62,
            x: 295,
            y: 5,
            z: -132.25
          },
          {
            hole: 63,
            x: 295,
            y: 5,
            z: -140
          },
          {
            hole: 64,
            x: 295,
            y: 5,
            z: -147.75
          },
          {
            hole: 65,
            x: 295,
            y: 5,
            z: -155.5
          },
          {
            hole: 66,
            x: 295,
            y: 5,
            z: -164.5
          },
          {
            hole: 67,
            x: 295,
            y: 5,
            z: -172.25
          },
          {
            hole: 68,
            x: 295,
            y: 5,
            z: -180
          },
          {
            hole: 69,
            x: 295,
            y: 5,
            z: -187.75
          },
          {
            hole: 70,
            x: 295,
            y: 5,
            z: -195.5
          },
          {
            hole: 71,
            x: 295,
            y: 5,
            z: -204.5
          },
          {
            hole: 72,
            x: 295,
            y: 5,
            z: -212.25
          },
          {
            hole: 73,
            x: 295,
            y: 5,
            z: -220
          },
          {
            hole: 74,
            x: 295,
            y: 5,
            z: -227.75
          },
          {
            hole: 75,
            x: 295,
            y: 5,
            z: -235.5
          },
          {
            hole: 76,
            x: 295,
            y: 5,
            z: -244.5
          },
          {
            hole: 77,
            x: 295,
            y: 5,
            z: -252.25
          },
          {
            hole: 78,
            x: 295,
            y: 5,
            z: -260
          },
          {
            hole: 79,
            x: 295,
            y: 5,
            z: -267.75
          },
          {
            hole: 80,
            x: 295,
            y: 5,
            z: -275.5
          },
          {
            hole: 81,
            x: 293.1259,
            y: 5,
            z: -294.235
          },
          {
            hole: 82,
            x: 287.6314,
            y: 5,
            z: -307.5
          },
          {
            hole: 83,
            x: 278.8909,
            y: 5,
            z: -318.8909
          },
          {
            hole: 84,
            x: 267.5,
            y: 5,
            z: -327.6314
          },
          {
            hole: 85,
            x: 254.235,
            y: 5,
            z: -333.1259
          },
          {
            hole: 86,
            x: 225.765,
            y: 5,
            z: -333.1259
          },
          {
            hole: 87,
            x: 212.5,
            y: 5,
            z: -327.6314
          },
          {
            hole: 88,
            x: 201.1091,
            y: 5,
            z: -318.8909
          },
          {
            hole: 89,
            x: 192.3686,
            y: 5,
            z: -307.5
          },
          {
            hole: 90,
            x: 186.8741,
            y: 5,
            z: -294.235
          },
          {
            hole: 91,
            x: 185,
            y: 5,
            z: -275.5
          },
          {
            hole: 92,
            x: 185,
            y: 5,
            z: -267.75
          },
          {
            hole: 93,
            x: 185,
            y: 5,
            z: -260
          },
          {
            hole: 94,
            x: 185,
            y: 5,
            z: -252.25
          },
          {
            hole: 95,
            x: 185,
            y: 5,
            z: -244.5
          },
          {
            hole: 96,
            x: 185,
            y: 5,
            z: -235.5
          },
          {
            hole: 97,
            x: 185,
            y: 5,
            z: -227.75
          },
          {
            hole: 98,
            x: 185,
            y: 5,
            z: -220
          },
          {
            hole: 99,
            x: 185,
            y: 5,
            z: -212.25
          },
          {
            hole: 100,
            x: 185,
            y: 5,
            z: -204.5
          },
          {
            hole: 101,
            x: 185,
            y: 5,
            z: -195.5
          },
          {
            hole: 102,
            x: 185,
            y: 5,
            z: -187.75
          },
          {
            hole: 103,
            x: 185,
            y: 5,
            z: -180
          },
          {
            hole: 104,
            x: 185,
            y: 5,
            z: -172.25
          },
          {
            hole: 105,
            x: 185,
            y: 5,
            z: -164.5
          },
          {
            hole: 106,
            x: 185,
            y: 5,
            z: -155.5
          },
          {
            hole: 107,
            x: 185,
            y: 5,
            z: -147.75
          },
          {
            hole: 108,
            x: 185,
            y: 5,
            z: -140
          },
          {
            hole: 109,
            x: 185,
            y: 5,
            z: -132.25
          },
          {
            hole: 110,
            x: 185,
            y: 5,
            z: -124.5
          },
          {
            hole: 111,
            x: 185,
            y: 5,
            z: -115.5
          },
          {
            hole: 112,
            x: 185,
            y: 5,
            z: -107.75
          },
          {
            hole: 113,
            x: 185,
            y: 5,
            z: -100
          },
          {
            hole: 114,
            x: 185,
            y: 5,
            z: -92.25
          },
          {
            hole: 115,
            x: 185,
            y: 5,
            z: -84.5
          },
          {
            hole: 116,
            x: 185,
            y: 5,
            z: -75.5
          },
          {
            hole: 117,
            x: 185,
            y: 5,
            z: -67.75
          },
          {
            hole: 118,
            x: 185,
            y: 5,
            z: -60
          },
          {
            hole: 119,
            x: 185,
            y: 5,
            z: -52.25
          },
          {
            hole: 120,
            x: 185,
            y: 5,
            z: -44.5
          },
          {
            hole: 121,
            x: 185,
            y: 5,
            z: -35.5
          },
          {
            hole: 122,
            x: 185,
            y: 5,
            z: -27.75
          },
          {
            hole: 123,
            x: 185,
            y: 5,
            z: -20
          },
          {
            hole: 124,
            x: 185,
            y: 5,
            z: -12.25
          },
          {
            hole: 125,
            x: 185,
            y: 5,
            z: -4.5
          },
          {
            hole: 126,
            x: 185,
            y: 5,
            z: 4.5
          },
          {
            hole: 127,
            x: 185,
            y: 5,
            z: 12.25
          },
          {
            hole: 128,
            x: 185,
            y: 5,
            z: 20
          },
          {
            hole: 129,
            x: 185,
            y: 5,
            z: 27.75
          },
          {
            hole: 130,
            x: 185,
            y: 5,
            z: 35.5
          },
          {
            hole: 131,
            x: 184.1481,
            y: 5,
            z: 46.4705
          },
          {
            hole: 132,
            x: 181.6506,
            y: 5,
            z: 52.5
          },
          {
            hole: 133,
            x: 177.6777,
            y: 5,
            z: 57.6777
          },
          {
            hole: 134,
            x: 172.5,
            y: 5,
            z: 61.6506
          },
          {
            hole: 135,
            x: 166.4705,
            y: 5,
            z: 64.1481
          },
          {
            hole: 136,
            x: 153.5295,
            y: 5,
            z: 64.1481
          },
          {
            hole: 137,
            x: 147.5,
            y: 5,
            z: 61.6506
          },
          {
            hole: 138,
            x: 142.3223,
            y: 5,
            z: 57.6777
          },
          {
            hole: 139,
            x: 138.3494,
            y: 5,
            z: 52.5
          },
          {
            hole: 140,
            x: 135.8519,
            y: 5,
            z: 46.4705
          },
          {
            hole: 141,
            x: 135,
            y: 5,
            z: 35.5
          },
          {
            hole: 142,
            x: 135,
            y: 5,
            z: 27.75
          },
          {
            hole: 143,
            x: 135,
            y: 5,
            z: 20
          },
          {
            hole: 144,
            x: 135,
            y: 5,
            z: 12.25
          },
          {
            hole: 145,
            x: 135,
            y: 5,
            z: 4.5
          },
          {
            hole: 146,
            x: 135,
            y: 5,
            z: -4.5
          },
          {
            hole: 147,
            x: 135,
            y: 5,
            z: -12.25
          },
          {
            hole: 148,
            x: 135,
            y: 5,
            z: -20
          },
          {
            hole: 149,
            x: 135,
            y: 5,
            z: -27.75
          },
          {
            hole: 150,
            x: 135,
            y: 5,
            z: -35.5
          },
          {
            hole: 151,
            x: 135,
            y: 5,
            z: -44.5
          },
          {
            hole: 152,
            x: 135,
            y: 5,
            z: -52.25
          },
          {
            hole: 153,
            x: 135,
            y: 5,
            z: -60
          },
          {
            hole: 154,
            x: 135,
            y: 5,
            z: -67.75
          },
          {
            hole: 155,
            x: 135,
            y: 5,
            z: -75.5
          },
          {
            hole: 156,
            x: 135,
            y: 5,
            z: -84.5
          },
          {
            hole: 157,
            x: 135,
            y: 5,
            z: -92.25
          },
          {
            hole: 158,
            x: 135,
            y: 5,
            z: -100
          },
          {
            hole: 159,
            x: 135,
            y: 5,
            z: -107.75
          },
          {
            hole: 160,
            x: 135,
            y: 5,
            z: -115.5
          },
          {
            hole: 161,
            x: 135,
            y: 5,
            z: -124.5
          },
          {
            hole: 162,
            x: 135,
            y: 5,
            z: -132.25
          },
          {
            hole: 163,
            x: 135,
            y: 5,
            z: -140
          },
          {
            hole: 164,
            x: 135,
            y: 5,
            z: -147.75
          },
          {
            hole: 165,
            x: 135,
            y: 5,
            z: -155.5
          },
          {
            hole: 166,
            x: 135,
            y: 5,
            z: -164.5
          },
          {
            hole: 167,
            x: 135,
            y: 5,
            z: -172.25
          },
          {
            hole: 168,
            x: 135,
            y: 5,
            z: -180
          },
          {
            hole: 169,
            x: 135,
            y: 5,
            z: -187.75
          },
          {
            hole: 170,
            x: 135,
            y: 5,
            z: -195.5
          },
          {
            hole: 171,
            x: 135,
            y: 5,
            z: -204.5
          },
          {
            hole: 172,
            x: 135,
            y: 5,
            z: -212.25
          },
          {
            hole: 173,
            x: 135,
            y: 5,
            z: -220
          },
          {
            hole: 174,
            x: 135,
            y: 5,
            z: -227.75
          },
          {
            hole: 175,
            x: 135,
            y: 5,
            z: -235.5
          },
          {
            hole: 176,
            x: 135,
            y: 5,
            z: -244.5
          },
          {
            hole: 177,
            x: 135,
            y: 5,
            z: -252.25
          },
          {
            hole: 178,
            x: 135,
            y: 5,
            z: -260
          },
          {
            hole: 179,
            x: 135,
            y: 5,
            z: -267.75
          },
          {
            hole: 180,
            x: 135,
            y: 5,
            z: -275.5
          },
          {
            hole: 181,
            x: 133.1259,
            y: 5,
            z: -294.235
          },
          {
            hole: 182,
            x: 127.6314,
            y: 5,
            z: -307.5
          },
          {
            hole: 183,
            x: 118.8909,
            y: 5,
            z: -318.8909
          },
          {
            hole: 184,
            x: 107.5,
            y: 5,
            z: -327.6314
          },
          {
            hole: 185,
            x: 94.235,
            y: 5,
            z: -333.1259
          },
          {
            hole: 186,
            x: 65.765,
            y: 5,
            z: -333.1259
          },
          {
            hole: 187,
            x: 52.5,
            y: 5,
            z: -327.6314
          },
          {
            hole: 188,
            x: 41.1091,
            y: 5,
            z: -318.8909
          },
          {
            hole: 189,
            x: 32.3686,
            y: 5,
            z: -307.5
          },
          {
            hole: 190,
            x: 26.8741,
            y: 5,
            z: -294.235
          },
          {
            hole: 191,
            x: 25,
            y: 5,
            z: -275.5
          },
          {
            hole: 192,
            x: 25,
            y: 5,
            z: -267.75
          },
          {
            hole: 193,
            x: 25,
            y: 5,
            z: -260
          },
          {
            hole: 194,
            x: 25,
            y: 5,
            z: -252.25
          },
          {
            hole: 195,
            x: 25,
            y: 5,
            z: -244.5
          },
          {
            hole: 196,
            x: 25,
            y: 5,
            z: -235.5
          },
          {
            hole: 197,
            x: 25,
            y: 5,
            z: -227.75
          },
          {
            hole: 198,
            x: 25,
            y: 5,
            z: -220
          },
          {
            hole: 199,
            x: 25,
            y: 5,
            z: -212.25
          },
          {
            hole: 200,
            x: 25,
            y: 5,
            z: -204.5
          },
          {
            hole: 201,
            x: 25,
            y: 5,
            z: -195.5
          },
          {
            hole: 202,
            x: 25,
            y: 5,
            z: -187.75
          },
          {
            hole: 203,
            x: 25,
            y: 5,
            z: -180
          },
          {
            hole: 204,
            x: 25,
            y: 5,
            z: -172.25
          },
          {
            hole: 205,
            x: 25,
            y: 5,
            z: -164.5
          },
          {
            hole: 206,
            x: 25,
            y: 5,
            z: -155.5
          },
          {
            hole: 207,
            x: 25,
            y: 5,
            z: -147.75
          },
          {
            hole: 208,
            x: 25,
            y: 5,
            z: -140
          },
          {
            hole: 209,
            x: 25,
            y: 5,
            z: -132.25
          },
          {
            hole: 210,
            x: 25,
            y: 5,
            z: -124.5
          },
          {
            hole: 211,
            x: 25,
            y: 5,
            z: -115.5
          },
          {
            hole: 212,
            x: 25,
            y: 5,
            z: -107.75
          },
          {
            hole: 213,
            x: 25,
            y: 5,
            z: -100
          },
          {
            hole: 214,
            x: 25,
            y: 5,
            z: -92.25
          },
          {
            hole: 215,
            x: 25,
            y: 5,
            z: -84.5
          },
          {
            hole: 216,
            x: 25,
            y: 5,
            z: -75.5
          },
          {
            hole: 217,
            x: 25,
            y: 5,
            z: -67.75
          },
          {
            hole: 218,
            x: 25,
            y: 5,
            z: -60
          },
          {
            hole: 219,
            x: 25,
            y: 5,
            z: -52.25
          },
          {
            hole: 220,
            x: 25,
            y: 5,
            z: -44.5
          },
          {
            hole: 221,
            x: 25,
            y: 5,
            z: -35.5
          },
          {
            hole: 222,
            x: 25,
            y: 5,
            z: -27.75
          },
          {
            hole: 223,
            x: 25,
            y: 5,
            z: -20
          },
          {
            hole: 224,
            x: 25,
            y: 5,
            z: -12.25
          },
          {
            hole: 225,
            x: 25,
            y: 5,
            z: -4.5
          },
          {
            hole: 226,
            x: 25,
            y: 5,
            z: 4.5
          },
          {
            hole: 227,
            x: 25,
            y: 5,
            z: 12.25
          },
          {
            hole: 228,
            x: 25,
            y: 5,
            z: 20
          },
          {
            hole: 229,
            x: 25,
            y: 5,
            z: 27.75
          },
          {
            hole: 230,
            x: 25,
            y: 5,
            z: 35.5
          },
          {
            hole: 231,
            x: 25,
            y: 5,
            z: 44.5
          },
          {
            hole: 232,
            x: 25,
            y: 5,
            z: 52.25
          },
          {
            hole: 233,
            x: 25,
            y: 5,
            z: 60
          },
          {
            hole: 234,
            x: 25,
            y: 5,
            z: 67.75
          },
          {
            hole: 235,
            x: 25,
            y: 5,
            z: 75.5
          },
          {
            hole: 236,
            x: 24.1481,
            y: 5,
            z: 86.4705
          },
          {
            hole: 237,
            x: 21.6506,
            y: 5,
            z: 92.5
          },
          {
            hole: 238,
            x: 17.6777,
            y: 5,
            z: 97.6777
          },
          {
            hole: 239,
            x: 12.5,
            y: 5,
            z: 101.6506
          },
          {
            hole: 240,
            x: 6.4705,
            y: 5,
            z: 104.1481
          },
          {
            hole: 241,
            x: -6.4705,
            y: 5,
            z: 104.1481
          },
          {
            hole: 242,
            x: -12.5,
            y: 5,
            z: 101.6506
          },
          {
            hole: 243,
            x: -17.6777,
            y: 5,
            z: 97.6777
          },
          {
            hole: 244,
            x: -21.6506,
            y: 5,
            z: 92.5
          },
          {
            hole: 245,
            x: -24.1481,
            y: 5,
            z: 86.4705
          },
          {
            hole: 246,
            x: -25,
            y: 5,
            z: 75.5
          },
          {
            hole: 247,
            x: -25,
            y: 5,
            z: 67.75
          },
          {
            hole: 248,
            x: -25,
            y: 5,
            z: 60
          },
          {
            hole: 249,
            x: -25,
            y: 5,
            z: 52.25
          },
          {
            hole: 250,
            x: -25,
            y: 5,
            z: 44.5
          },
          {
            hole: 251,
            x: -25,
            y: 5,
            z: 35.5
          },
          {
            hole: 252,
            x: -25,
            y: 5,
            z: 27.75
          },
          {
            hole: 253,
            x: -25,
            y: 5,
            z: 20
          },
          {
            hole: 254,
            x: -25,
            y: 5,
            z: 12.25
          },
          {
            hole: 255,
            x: -25,
            y: 5,
            z: 4.5
          },
          {
            hole: 256,
            x: -25,
            y: 5,
            z: -4.5
          },
          {
            hole: 257,
            x: -25,
            y: 5,
            z: -12.25
          },
          {
            hole: 258,
            x: -25,
            y: 5,
            z: -20
          },
          {
            hole: 259,
            x: -25,
            y: 5,
            z: -27.75
          },
          {
            hole: 260,
            x: -25,
            y: 5,
            z: -35.5
          },
          {
            hole: 261,
            x: -25,
            y: 5,
            z: -44.5
          },
          {
            hole: 262,
            x: -25,
            y: 5,
            z: -52.25
          },
          {
            hole: 263,
            x: -25,
            y: 5,
            z: -60
          },
          {
            hole: 264,
            x: -25,
            y: 5,
            z: -67.75
          },
          {
            hole: 265,
            x: -25,
            y: 5,
            z: -75.5
          },
          {
            hole: 266,
            x: -25,
            y: 5,
            z: -84.5
          },
          {
            hole: 267,
            x: -25,
            y: 5,
            z: -92.25
          },
          {
            hole: 268,
            x: -25,
            y: 5,
            z: -100
          },
          {
            hole: 269,
            x: -25,
            y: 5,
            z: -107.75
          },
          {
            hole: 270,
            x: -25,
            y: 5,
            z: -115.5
          },
          {
            hole: 271,
            x: -25,
            y: 5,
            z: -124.5
          },
          {
            hole: 272,
            x: -25,
            y: 5,
            z: -132.25
          },
          {
            hole: 273,
            x: -25,
            y: 5,
            z: -140
          },
          {
            hole: 274,
            x: -25,
            y: 5,
            z: -147.75
          },
          {
            hole: 275,
            x: -25,
            y: 5,
            z: -155.5
          },
          {
            hole: 276,
            x: -25,
            y: 5,
            z: -164.5
          },
          {
            hole: 277,
            x: -25,
            y: 5,
            z: -172.25
          },
          {
            hole: 278,
            x: -25,
            y: 5,
            z: -180
          },
          {
            hole: 279,
            x: -25,
            y: 5,
            z: -187.75
          },
          {
            hole: 280,
            x: -25,
            y: 5,
            z: -195.5
          },
          {
            hole: 281,
            x: -25,
            y: 5,
            z: -204.5
          },
          {
            hole: 282,
            x: -25,
            y: 5,
            z: -212.25
          },
          {
            hole: 283,
            x: -25,
            y: 5,
            z: -220
          },
          {
            hole: 284,
            x: -25,
            y: 5,
            z: -227.75
          },
          {
            hole: 285,
            x: -25,
            y: 5,
            z: -235.5
          },
          {
            hole: 286,
            x: -25,
            y: 5,
            z: -244.5
          },
          {
            hole: 287,
            x: -25,
            y: 5,
            z: -252.25
          },
          {
            hole: 288,
            x: -25,
            y: 5,
            z: -260
          },
          {
            hole: 289,
            x: -25,
            y: 5,
            z: -267.75
          },
          {
            hole: 290,
            x: -25,
            y: 5,
            z: -275.5
          },
          {
            hole: 291,
            x: -26.8741,
            y: 5,
            z: -294.235
          },
          {
            hole: 292,
            x: -32.3686,
            y: 5,
            z: -307.5
          },
          {
            hole: 293,
            x: -41.1091,
            y: 5,
            z: -318.8909
          },
          {
            hole: 294,
            x: -52.5,
            y: 5,
            z: -327.6314
          },
          {
            hole: 295,
            x: -65.765,
            y: 5,
            z: -333.1259
          },
          {
            hole: 296,
            x: -94.235,
            y: 5,
            z: -333.1259
          },
          {
            hole: 297,
            x: -107.5,
            y: 5,
            z: -327.6314
          },
          {
            hole: 298,
            x: -118.8909,
            y: 5,
            z: -318.8909
          },
          {
            hole: 299,
            x: -127.6314,
            y: 5,
            z: -307.5
          },
          {
            hole: 300,
            x: -133.1259,
            y: 5,
            z: -294.235
          },
          {
            hole: 301,
            x: -135,
            y: 5,
            z: -275.5
          },
          {
            hole: 302,
            x: -135,
            y: 5,
            z: -267.75
          },
          {
            hole: 303,
            x: -135,
            y: 5,
            z: -260
          },
          {
            hole: 304,
            x: -135,
            y: 5,
            z: -252.25
          },
          {
            hole: 305,
            x: -135,
            y: 5,
            z: -244.5
          },
          {
            hole: 306,
            x: -135,
            y: 5,
            z: -235.5
          },
          {
            hole: 307,
            x: -135,
            y: 5,
            z: -227.75
          },
          {
            hole: 308,
            x: -135,
            y: 5,
            z: -220
          },
          {
            hole: 309,
            x: -135,
            y: 5,
            z: -212.25
          },
          {
            hole: 310,
            x: -135,
            y: 5,
            z: -204.5
          },
          {
            hole: 311,
            x: -135,
            y: 5,
            z: -195.5
          },
          {
            hole: 312,
            x: -135,
            y: 5,
            z: -187.75
          },
          {
            hole: 313,
            x: -135,
            y: 5,
            z: -180
          },
          {
            hole: 314,
            x: -135,
            y: 5,
            z: -172.25
          },
          {
            hole: 315,
            x: -135,
            y: 5,
            z: -164.5
          },
          {
            hole: 316,
            x: -135,
            y: 5,
            z: -155.5
          },
          {
            hole: 317,
            x: -135,
            y: 5,
            z: -147.75
          },
          {
            hole: 318,
            x: -135,
            y: 5,
            z: -140
          },
          {
            hole: 319,
            x: -135,
            y: 5,
            z: -132.25
          },
          {
            hole: 320,
            x: -135,
            y: 5,
            z: -124.5
          },
          {
            hole: 321,
            x: -135,
            y: 5,
            z: -115.5
          },
          {
            hole: 322,
            x: -135,
            y: 5,
            z: -107.75
          },
          {
            hole: 323,
            x: -135,
            y: 5,
            z: -100
          },
          {
            hole: 324,
            x: -135,
            y: 5,
            z: -92.25
          },
          {
            hole: 325,
            x: -135,
            y: 5,
            z: -84.5
          },
          {
            hole: 326,
            x: -135,
            y: 5,
            z: -75.5
          },
          {
            hole: 327,
            x: -135,
            y: 5,
            z: -67.75
          },
          {
            hole: 328,
            x: -135,
            y: 5,
            z: -60
          },
          {
            hole: 329,
            x: -135,
            y: 5,
            z: -52.25
          },
          {
            hole: 330,
            x: -135,
            y: 5,
            z: -44.5
          },
          {
            hole: 331,
            x: -135,
            y: 5,
            z: -35.5
          },
          {
            hole: 332,
            x: -135,
            y: 5,
            z: -27.75
          },
          {
            hole: 333,
            x: -135,
            y: 5,
            z: -20
          },
          {
            hole: 334,
            x: -135,
            y: 5,
            z: -12.25
          },
          {
            hole: 335,
            x: -135,
            y: 5,
            z: -4.5
          },
          {
            hole: 336,
            x: -135,
            y: 5,
            z: 4.5
          },
          {
            hole: 337,
            x: -135,
            y: 5,
            z: 12.25
          },
          {
            hole: 338,
            x: -135,
            y: 5,
            z: 20
          },
          {
            hole: 339,
            x: -135,
            y: 5,
            z: 27.75
          },
          {
            hole: 340,
            x: -135,
            y: 5,
            z: 35.5
          },
          {
            hole: 341,
            x: -135.8519,
            y: 5,
            z: 46.4705
          },
          {
            hole: 342,
            x: -138.3494,
            y: 5,
            z: 52.5
          },
          {
            hole: 343,
            x: -142.3223,
            y: 5,
            z: 57.6777
          },
          {
            hole: 344,
            x: -147.5,
            y: 5,
            z: 61.6506
          },
          {
            hole: 345,
            x: -153.5295,
            y: 5,
            z: 64.1481
          },
          {
            hole: 346,
            x: -166.4705,
            y: 5,
            z: 64.1481
          },
          {
            hole: 347,
            x: -172.5,
            y: 5,
            z: 61.6506
          },
          {
            hole: 348,
            x: -177.6777,
            y: 5,
            z: 57.6777
          },
          {
            hole: 349,
            x: -181.6506,
            y: 5,
            z: 52.5
          },
          {
            hole: 350,
            x: -184.1481,
            y: 5,
            z: 46.4705
          },
          {
            hole: 351,
            x: -185,
            y: 5,
            z: 35.5
          },
          {
            hole: 352,
            x: -185,
            y: 5,
            z: 27.75
          },
          {
            hole: 353,
            x: -185,
            y: 5,
            z: 20
          },
          {
            hole: 354,
            x: -185,
            y: 5,
            z: 12.25
          },
          {
            hole: 355,
            x: -185,
            y: 5,
            z: 4.5
          },
          {
            hole: 356,
            x: -185,
            y: 5,
            z: -4.5
          },
          {
            hole: 357,
            x: -185,
            y: 5,
            z: -12.25
          },
          {
            hole: 358,
            x: -185,
            y: 5,
            z: -20
          },
          {
            hole: 359,
            x: -185,
            y: 5,
            z: -27.75
          },
          {
            hole: 360,
            x: -185,
            y: 5,
            z: -35.5
          },
          {
            hole: 361,
            x: -185,
            y: 5,
            z: -44.5
          },
          {
            hole: 362,
            x: -185,
            y: 5,
            z: -52.25
          },
          {
            hole: 363,
            x: -185,
            y: 5,
            z: -60
          },
          {
            hole: 364,
            x: -185,
            y: 5,
            z: -67.75
          },
          {
            hole: 365,
            x: -185,
            y: 5,
            z: -75.5
          },
          {
            hole: 366,
            x: -185,
            y: 5,
            z: -84.5
          },
          {
            hole: 367,
            x: -185,
            y: 5,
            z: -92.25
          },
          {
            hole: 368,
            x: -185,
            y: 5,
            z: -100
          },
          {
            hole: 369,
            x: -185,
            y: 5,
            z: -107.75
          },
          {
            hole: 370,
            x: -185,
            y: 5,
            z: -115.5
          },
          {
            hole: 371,
            x: -185,
            y: 5,
            z: -124.5
          },
          {
            hole: 372,
            x: -185,
            y: 5,
            z: -132.25
          },
          {
            hole: 373,
            x: -185,
            y: 5,
            z: -140
          },
          {
            hole: 374,
            x: -185,
            y: 5,
            z: -147.75
          },
          {
            hole: 375,
            x: -185,
            y: 5,
            z: -155.5
          },
          {
            hole: 376,
            x: -185,
            y: 5,
            z: -164.5
          },
          {
            hole: 377,
            x: -185,
            y: 5,
            z: -172.25
          },
          {
            hole: 378,
            x: -185,
            y: 5,
            z: -180
          },
          {
            hole: 379,
            x: -185,
            y: 5,
            z: -187.75
          },
          {
            hole: 380,
            x: -185,
            y: 5,
            z: -195.5
          },
          {
            hole: 381,
            x: -185,
            y: 5,
            z: -204.5
          },
          {
            hole: 382,
            x: -185,
            y: 5,
            z: -212.25
          },
          {
            hole: 383,
            x: -185,
            y: 5,
            z: -220
          },
          {
            hole: 384,
            x: -185,
            y: 5,
            z: -227.75
          },
          {
            hole: 385,
            x: -185,
            y: 5,
            z: -235.5
          },
          {
            hole: 386,
            x: -185,
            y: 5,
            z: -244.5
          },
          {
            hole: 387,
            x: -185,
            y: 5,
            z: -252.25
          },
          {
            hole: 388,
            x: -185,
            y: 5,
            z: -260
          },
          {
            hole: 389,
            x: -185,
            y: 5,
            z: -267.75
          },
          {
            hole: 390,
            x: -185,
            y: 5,
            z: -275.5
          },
          {
            hole: 391,
            x: -186.8741,
            y: 5,
            z: -294.235
          },
          {
            hole: 392,
            x: -192.3686,
            y: 5,
            z: -307.5
          },
          {
            hole: 393,
            x: -201.1091,
            y: 5,
            z: -318.8909
          },
          {
            hole: 394,
            x: -212.5,
            y: 5,
            z: -327.6314
          },
          {
            hole: 395,
            x: -225.765,
            y: 5,
            z: -333.1259
          },
          {
            hole: 396,
            x: -254.235,
            y: 5,
            z: -333.1259
          },
          {
            hole: 397,
            x: -267.5,
            y: 5,
            z: -327.6314
          },
          {
            hole: 398,
            x: -278.8909,
            y: 5,
            z: -318.8909
          },
          {
            hole: 399,
            x: -287.6314,
            y: 5,
            z: -307.5
          },
          {
            hole: 400,
            x: -293.1259,
            y: 5,
            z: -294.235
          },
          {
            hole: 401,
            x: -295,
            y: 5,
            z: -275.5
          },
          {
            hole: 402,
            x: -295,
            y: 5,
            z: -267.75
          },
          {
            hole: 403,
            x: -295,
            y: 5,
            z: -260
          },
          {
            hole: 404,
            x: -295,
            y: 5,
            z: -252.25
          },
          {
            hole: 405,
            x: -295,
            y: 5,
            z: -244.5
          },
          {
            hole: 406,
            x: -295,
            y: 5,
            z: -235.5
          },
          {
            hole: 407,
            x: -295,
            y: 5,
            z: -227.75
          },
          {
            hole: 408,
            x: -295,
            y: 5,
            z: -220
          },
          {
            hole: 409,
            x: -295,
            y: 5,
            z: -212.25
          },
          {
            hole: 410,
            x: -295,
            y: 5,
            z: -204.5
          },
          {
            hole: 411,
            x: -295,
            y: 5,
            z: -195.5
          },
          {
            hole: 412,
            x: -295,
            y: 5,
            z: -187.75
          },
          {
            hole: 413,
            x: -295,
            y: 5,
            z: -180
          },
          {
            hole: 414,
            x: -295,
            y: 5,
            z: -172.25
          },
          {
            hole: 415,
            x: -295,
            y: 5,
            z: -164.5
          },
          {
            hole: 416,
            x: -295,
            y: 5,
            z: -155.5
          },
          {
            hole: 417,
            x: -295,
            y: 5,
            z: -147.75
          },
          {
            hole: 418,
            x: -295,
            y: 5,
            z: -140
          },
          {
            hole: 419,
            x: -295,
            y: 5,
            z: -132.25
          },
          {
            hole: 420,
            x: -295,
            y: 5,
            z: -124.5
          },
          {
            hole: 421,
            x: -295,
            y: 5,
            z: -115.5
          },
          {
            hole: 422,
            x: -295,
            y: 5,
            z: -107.75
          },
          {
            hole: 423,
            x: -295,
            y: 5,
            z: -100
          },
          {
            hole: 424,
            x: -295,
            y: 5,
            z: -92.25
          },
          {
            hole: 425,
            x: -295,
            y: 5,
            z: -84.5
          },
          {
            hole: 426,
            x: -295,
            y: 5,
            z: -75.5
          },
          {
            hole: 427,
            x: -295,
            y: 5,
            z: -67.75
          },
          {
            hole: 428,
            x: -295,
            y: 5,
            z: -60
          },
          {
            hole: 429,
            x: -295,
            y: 5,
            z: -52.25
          },
          {
            hole: 430,
            x: -295,
            y: 5,
            z: -44.5
          },
          {
            hole: 431,
            x: -295,
            y: 5,
            z: -35.5
          },
          {
            hole: 432,
            x: -295,
            y: 5,
            z: -27.75
          },
          {
            hole: 433,
            x: -295,
            y: 5,
            z: -20
          },
          {
            hole: 434,
            x: -295,
            y: 5,
            z: -12.25
          },
          {
            hole: 435,
            x: -295,
            y: 5,
            z: -4.5
          },
          {
            hole: 436,
            x: -295,
            y: 5,
            z: 4.5
          },
          {
            hole: 437,
            x: -295,
            y: 5,
            z: 12.25
          },
          {
            hole: 438,
            x: -295,
            y: 5,
            z: 20
          },
          {
            hole: 439,
            x: -295,
            y: 5,
            z: 27.75
          },
          {
            hole: 440,
            x: -295,
            y: 5,
            z: 35.5
          },
          {
            hole: 441,
            x: -295,
            y: 5,
            z: 44.5
          },
          {
            hole: 442,
            x: -295,
            y: 5,
            z: 52.25
          },
          {
            hole: 443,
            x: -295,
            y: 5,
            z: 60
          },
          {
            hole: 444,
            x: -295,
            y: 5,
            z: 67.75
          },
          {
            hole: 445,
            x: -295,
            y: 5,
            z: 75.5
          },
          {
            hole: 446,
            x: -295,
            y: 5,
            z: 84.5
          },
          {
            hole: 447,
            x: -295,
            y: 5,
            z: 92.25
          },
          {
            hole: 448,
            x: -295,
            y: 5,
            z: 100
          },
          {
            hole: 449,
            x: -295,
            y: 5,
            z: 107.75
          },
          {
            hole: 450,
            x: -295,
            y: 5,
            z: 115.5
          },
          {
            hole: 451,
            x: -293.1259,
            y: 5,
            z: 134.235
          },
          {
            hole: 452,
            x: -287.6314,
            y: 5,
            z: 147.5
          },
          {
            hole: 453,
            x: -278.8909,
            y: 5,
            z: 158.8909
          },
          {
            hole: 454,
            x: -267.5,
            y: 5,
            z: 167.6314
          },
          {
            hole: 455,
            x: -254.235,
            y: 5,
            z: 173.1259
          },
          {
            hole: 456,
            x: -235.5,
            y: 5,
            z: 175
          },
          {
            hole: 457,
            x: -227.75,
            y: 5,
            z: 175
          },
          {
            hole: 458,
            x: -220,
            y: 5,
            z: 175
          },
          {
            hole: 459,
            x: -212.25,
            y: 5,
            z: 175
          },
          {
            hole: 460,
            x: -204.5,
            y: 5,
            z: 175
          },
          {
            hole: 461,
            x: -195.5,
            y: 5,
            z: 175
          },
          {
            hole: 462,
            x: -187.75,
            y: 5,
            z: 175
          },
          {
            hole: 463,
            x: -180,
            y: 5,
            z: 175
          },
          {
            hole: 464,
            x: -172.25,
            y: 5,
            z: 175
          },
          {
            hole: 465,
            x: -164.5,
            y: 5,
            z: 175
          },
          {
            hole: 466,
            x: -155.5,
            y: 5,
            z: 175
          },
          {
            hole: 467,
            x: -147.75,
            y: 5,
            z: 175
          },
          {
            hole: 468,
            x: -140,
            y: 5,
            z: 175
          },
          {
            hole: 469,
            x: -132.25,
            y: 5,
            z: 175
          },
          {
            hole: 470,
            x: -124.5,
            y: 5,
            z: 175
          },
          {
            hole: 471,
            x: -115.5,
            y: 5,
            z: 175
          },
          {
            hole: 472,
            x: -107.75,
            y: 5,
            z: 175
          },
          {
            hole: 473,
            x: -100,
            y: 5,
            z: 175
          },
          {
            hole: 474,
            x: -92.25,
            y: 5,
            z: 175
          },
          {
            hole: 475,
            x: -84.5,
            y: 5,
            z: 175
          },
          {
            hole: 476,
            x: -75.5,
            y: 5,
            z: 175
          },
          {
            hole: 477,
            x: -67.75,
            y: 5,
            z: 175
          },
          {
            hole: 478,
            x: -60,
            y: 5,
            z: 175
          },
          {
            hole: 479,
            x: -52.25,
            y: 5,
            z: 175
          },
          {
            hole: 480,
            x: -44.5,
            y: 5,
            z: 175
          },
          {
            hole: 481,
            x: -20,
            y: 5,
            z: 160
          }
        ],
        p2: [
          {
            hole: 0,
            x: 13,
            y: 5,
            z: 165
          },
          {
            hole: 1,
            x: 44.5,
            y: 5,
            z: 165
          },
          {
            hole: 2,
            x: 52.25,
            y: 5,
            z: 165
          },
          {
            hole: 3,
            x: 60,
            y: 5,
            z: 165
          },
          {
            hole: 4,
            x: 67.75,
            y: 5,
            z: 165
          },
          {
            hole: 5,
            x: 75.5,
            y: 5,
            z: 165
          },
          {
            hole: 6,
            x: 84.5,
            y: 5,
            z: 165
          },
          {
            hole: 7,
            x: 92.25,
            y: 5,
            z: 165
          },
          {
            hole: 8,
            x: 100,
            y: 5,
            z: 165
          },
          {
            hole: 9,
            x: 107.75,
            y: 5,
            z: 165
          },
          {
            hole: 10,
            x: 115.5,
            y: 5,
            z: 165
          },
          {
            hole: 11,
            x: 124.5,
            y: 5,
            z: 165
          },
          {
            hole: 12,
            x: 132.25,
            y: 5,
            z: 165
          },
          {
            hole: 13,
            x: 140,
            y: 5,
            z: 165
          },
          {
            hole: 14,
            x: 147.75,
            y: 5,
            z: 165
          },
          {
            hole: 15,
            x: 155.5,
            y: 5,
            z: 165
          },
          {
            hole: 16,
            x: 164.5,
            y: 5,
            z: 165
          },
          {
            hole: 17,
            x: 172.25,
            y: 5,
            z: 165
          },
          {
            hole: 18,
            x: 180,
            y: 5,
            z: 165
          },
          {
            hole: 19,
            x: 187.75,
            y: 5,
            z: 165
          },
          {
            hole: 20,
            x: 195.5,
            y: 5,
            z: 165
          },
          {
            hole: 21,
            x: 204.5,
            y: 5,
            z: 165
          },
          {
            hole: 22,
            x: 212.25,
            y: 5,
            z: 165
          },
          {
            hole: 23,
            x: 220,
            y: 5,
            z: 165
          },
          {
            hole: 24,
            x: 227.75,
            y: 5,
            z: 165
          },
          {
            hole: 25,
            x: 235.5,
            y: 5,
            z: 165
          },
          {
            hole: 26,
            x: 251.6469,
            y: 5,
            z: 163.4667
          },
          {
            hole: 27,
            x: 262.5,
            y: 5,
            z: 158.9711
          },
          {
            hole: 28,
            x: 271.8198,
            y: 5,
            z: 151.8198
          },
          {
            hole: 29,
            x: 278.9711,
            y: 5,
            z: 142.5
          },
          {
            hole: 30,
            x: 283.4667,
            y: 5,
            z: 131.6469
          },
          {
            hole: 31,
            x: 285,
            y: 5,
            z: 115.5
          },
          {
            hole: 32,
            x: 285,
            y: 5,
            z: 107.75
          },
          {
            hole: 33,
            x: 285,
            y: 5,
            z: 100
          },
          {
            hole: 34,
            x: 285,
            y: 5,
            z: 92.25
          },
          {
            hole: 35,
            x: 285,
            y: 5,
            z: 84.5
          },
          {
            hole: 36,
            x: 285,
            y: 5,
            z: 75.5
          },
          {
            hole: 37,
            x: 285,
            y: 5,
            z: 67.75
          },
          {
            hole: 38,
            x: 285,
            y: 5,
            z: 60
          },
          {
            hole: 39,
            x: 285,
            y: 5,
            z: 52.25
          },
          {
            hole: 40,
            x: 285,
            y: 5,
            z: 44.5
          },
          {
            hole: 41,
            x: 285,
            y: 5,
            z: 35.5
          },
          {
            hole: 42,
            x: 285,
            y: 5,
            z: 27.75
          },
          {
            hole: 43,
            x: 285,
            y: 5,
            z: 20
          },
          {
            hole: 44,
            x: 285,
            y: 5,
            z: 12.25
          },
          {
            hole: 45,
            x: 285,
            y: 5,
            z: 4.5
          },
          {
            hole: 46,
            x: 285,
            y: 5,
            z: -4.5
          },
          {
            hole: 47,
            x: 285,
            y: 5,
            z: -12.25
          },
          {
            hole: 48,
            x: 285,
            y: 5,
            z: -20
          },
          {
            hole: 49,
            x: 285,
            y: 5,
            z: -27.75
          },
          {
            hole: 50,
            x: 285,
            y: 5,
            z: -35.5
          },
          {
            hole: 51,
            x: 285,
            y: 5,
            z: -44.5
          },
          {
            hole: 52,
            x: 285,
            y: 5,
            z: -52.25
          },
          {
            hole: 53,
            x: 285,
            y: 5,
            z: -60
          },
          {
            hole: 54,
            x: 285,
            y: 5,
            z: -67.75
          },
          {
            hole: 55,
            x: 285,
            y: 5,
            z: -75.5
          },
          {
            hole: 56,
            x: 285,
            y: 5,
            z: -84.5
          },
          {
            hole: 57,
            x: 285,
            y: 5,
            z: -92.25
          },
          {
            hole: 58,
            x: 285,
            y: 5,
            z: -100
          },
          {
            hole: 59,
            x: 285,
            y: 5,
            z: -107.75
          },
          {
            hole: 60,
            x: 285,
            y: 5,
            z: -115.5
          },
          {
            hole: 61,
            x: 285,
            y: 5,
            z: -124.5
          },
          {
            hole: 62,
            x: 285,
            y: 5,
            z: -132.25
          },
          {
            hole: 63,
            x: 285,
            y: 5,
            z: -140
          },
          {
            hole: 64,
            x: 285,
            y: 5,
            z: -147.75
          },
          {
            hole: 65,
            x: 285,
            y: 5,
            z: -155.5
          },
          {
            hole: 66,
            x: 285,
            y: 5,
            z: -164.5
          },
          {
            hole: 67,
            x: 285,
            y: 5,
            z: -172.25
          },
          {
            hole: 68,
            x: 285,
            y: 5,
            z: -180
          },
          {
            hole: 69,
            x: 285,
            y: 5,
            z: -187.75
          },
          {
            hole: 70,
            x: 285,
            y: 5,
            z: -195.5
          },
          {
            hole: 71,
            x: 285,
            y: 5,
            z: -204.5
          },
          {
            hole: 72,
            x: 285,
            y: 5,
            z: -212.25
          },
          {
            hole: 73,
            x: 285,
            y: 5,
            z: -220
          },
          {
            hole: 74,
            x: 285,
            y: 5,
            z: -227.75
          },
          {
            hole: 75,
            x: 285,
            y: 5,
            z: -235.5
          },
          {
            hole: 76,
            x: 285,
            y: 5,
            z: -244.5
          },
          {
            hole: 77,
            x: 285,
            y: 5,
            z: -252.25
          },
          {
            hole: 78,
            x: 285,
            y: 5,
            z: -260
          },
          {
            hole: 79,
            x: 285,
            y: 5,
            z: -267.75
          },
          {
            hole: 80,
            x: 285,
            y: 5,
            z: -275.5
          },
          {
            hole: 81,
            x: 283.4667,
            y: 5,
            z: -291.6469
          },
          {
            hole: 82,
            x: 278.9711,
            y: 5,
            z: -302.5
          },
          {
            hole: 83,
            x: 271.8198,
            y: 5,
            z: -311.8198
          },
          {
            hole: 84,
            x: 262.5,
            y: 5,
            z: -318.9711
          },
          {
            hole: 85,
            x: 251.6469,
            y: 5,
            z: -323.4667
          },
          {
            hole: 86,
            x: 228.3531,
            y: 5,
            z: -323.4667
          },
          {
            hole: 87,
            x: 217.5,
            y: 5,
            z: -318.9711
          },
          {
            hole: 88,
            x: 208.1802,
            y: 5,
            z: -311.8198
          },
          {
            hole: 89,
            x: 201.0289,
            y: 5,
            z: -302.5
          },
          {
            hole: 90,
            x: 196.5333,
            y: 5,
            z: -291.6469
          },
          {
            hole: 91,
            x: 195,
            y: 5,
            z: -275.5
          },
          {
            hole: 92,
            x: 195,
            y: 5,
            z: -267.75
          },
          {
            hole: 93,
            x: 195,
            y: 5,
            z: -260
          },
          {
            hole: 94,
            x: 195,
            y: 5,
            z: -252.25
          },
          {
            hole: 95,
            x: 195,
            y: 5,
            z: -244.5
          },
          {
            hole: 96,
            x: 195,
            y: 5,
            z: -235.5
          },
          {
            hole: 97,
            x: 195,
            y: 5,
            z: -227.75
          },
          {
            hole: 98,
            x: 195,
            y: 5,
            z: -220
          },
          {
            hole: 99,
            x: 195,
            y: 5,
            z: -212.25
          },
          {
            hole: 100,
            x: 195,
            y: 5,
            z: -204.5
          },
          {
            hole: 101,
            x: 195,
            y: 5,
            z: -195.5
          },
          {
            hole: 102,
            x: 195,
            y: 5,
            z: -187.75
          },
          {
            hole: 103,
            x: 195,
            y: 5,
            z: -180
          },
          {
            hole: 104,
            x: 195,
            y: 5,
            z: -172.25
          },
          {
            hole: 105,
            x: 195,
            y: 5,
            z: -164.5
          },
          {
            hole: 106,
            x: 195,
            y: 5,
            z: -155.5
          },
          {
            hole: 107,
            x: 195,
            y: 5,
            z: -147.75
          },
          {
            hole: 108,
            x: 195,
            y: 5,
            z: -140
          },
          {
            hole: 109,
            x: 195,
            y: 5,
            z: -132.25
          },
          {
            hole: 110,
            x: 195,
            y: 5,
            z: -124.5
          },
          {
            hole: 111,
            x: 195,
            y: 5,
            z: -115.5
          },
          {
            hole: 112,
            x: 195,
            y: 5,
            z: -107.75
          },
          {
            hole: 113,
            x: 195,
            y: 5,
            z: -100
          },
          {
            hole: 114,
            x: 195,
            y: 5,
            z: -92.25
          },
          {
            hole: 115,
            x: 195,
            y: 5,
            z: -84.5
          },
          {
            hole: 116,
            x: 195,
            y: 5,
            z: -75.5
          },
          {
            hole: 117,
            x: 195,
            y: 5,
            z: -67.75
          },
          {
            hole: 118,
            x: 195,
            y: 5,
            z: -60
          },
          {
            hole: 119,
            x: 195,
            y: 5,
            z: -52.25
          },
          {
            hole: 120,
            x: 195,
            y: 5,
            z: -44.5
          },
          {
            hole: 121,
            x: 195,
            y: 5,
            z: -35.5
          },
          {
            hole: 122,
            x: 195,
            y: 5,
            z: -27.75
          },
          {
            hole: 123,
            x: 195,
            y: 5,
            z: -20
          },
          {
            hole: 124,
            x: 195,
            y: 5,
            z: -12.25
          },
          {
            hole: 125,
            x: 195,
            y: 5,
            z: -4.5
          },
          {
            hole: 126,
            x: 195,
            y: 5,
            z: 4.5
          },
          {
            hole: 127,
            x: 195,
            y: 5,
            z: 12.25
          },
          {
            hole: 128,
            x: 195,
            y: 5,
            z: 20
          },
          {
            hole: 129,
            x: 195,
            y: 5,
            z: 27.75
          },
          {
            hole: 130,
            x: 195,
            y: 5,
            z: 35.5
          },
          {
            hole: 131,
            x: 193.8074,
            y: 5,
            z: 49.0587
          },
          {
            hole: 132,
            x: 190.3109,
            y: 5,
            z: 57.5
          },
          {
            hole: 133,
            x: 184.7487,
            y: 5,
            z: 64.7487
          },
          {
            hole: 134,
            x: 177.5,
            y: 5,
            z: 70.3109
          },
          {
            hole: 135,
            x: 169.0587,
            y: 5,
            z: 73.8074
          },
          {
            hole: 136,
            x: 150.9413,
            y: 5,
            z: 73.8074
          },
          {
            hole: 137,
            x: 142.5,
            y: 5,
            z: 70.3109
          },
          {
            hole: 138,
            x: 135.2513,
            y: 5,
            z: 64.7487
          },
          {
            hole: 139,
            x: 129.6891,
            y: 5,
            z: 57.5
          },
          {
            hole: 140,
            x: 126.1926,
            y: 5,
            z: 49.0587
          },
          {
            hole: 141,
            x: 125,
            y: 5,
            z: 35.5
          },
          {
            hole: 142,
            x: 125,
            y: 5,
            z: 27.75
          },
          {
            hole: 143,
            x: 125,
            y: 5,
            z: 20
          },
          {
            hole: 144,
            x: 125,
            y: 5,
            z: 12.25
          },
          {
            hole: 145,
            x: 125,
            y: 5,
            z: 4.5
          },
          {
            hole: 146,
            x: 125,
            y: 5,
            z: -4.5
          },
          {
            hole: 147,
            x: 125,
            y: 5,
            z: -12.25
          },
          {
            hole: 148,
            x: 125,
            y: 5,
            z: -20
          },
          {
            hole: 149,
            x: 125,
            y: 5,
            z: -27.75
          },
          {
            hole: 150,
            x: 125,
            y: 5,
            z: -35.5
          },
          {
            hole: 151,
            x: 125,
            y: 5,
            z: -44.5
          },
          {
            hole: 152,
            x: 125,
            y: 5,
            z: -52.25
          },
          {
            hole: 153,
            x: 125,
            y: 5,
            z: -60
          },
          {
            hole: 154,
            x: 125,
            y: 5,
            z: -67.75
          },
          {
            hole: 155,
            x: 125,
            y: 5,
            z: -75.5
          },
          {
            hole: 156,
            x: 125,
            y: 5,
            z: -84.5
          },
          {
            hole: 157,
            x: 125,
            y: 5,
            z: -92.25
          },
          {
            hole: 158,
            x: 125,
            y: 5,
            z: -100
          },
          {
            hole: 159,
            x: 125,
            y: 5,
            z: -107.75
          },
          {
            hole: 160,
            x: 125,
            y: 5,
            z: -115.5
          },
          {
            hole: 161,
            x: 125,
            y: 5,
            z: -124.5
          },
          {
            hole: 162,
            x: 125,
            y: 5,
            z: -132.25
          },
          {
            hole: 163,
            x: 125,
            y: 5,
            z: -140
          },
          {
            hole: 164,
            x: 125,
            y: 5,
            z: -147.75
          },
          {
            hole: 165,
            x: 125,
            y: 5,
            z: -155.5
          },
          {
            hole: 166,
            x: 125,
            y: 5,
            z: -164.5
          },
          {
            hole: 167,
            x: 125,
            y: 5,
            z: -172.25
          },
          {
            hole: 168,
            x: 125,
            y: 5,
            z: -180
          },
          {
            hole: 169,
            x: 125,
            y: 5,
            z: -187.75
          },
          {
            hole: 170,
            x: 125,
            y: 5,
            z: -195.5
          },
          {
            hole: 171,
            x: 125,
            y: 5,
            z: -204.5
          },
          {
            hole: 172,
            x: 125,
            y: 5,
            z: -212.25
          },
          {
            hole: 173,
            x: 125,
            y: 5,
            z: -220
          },
          {
            hole: 174,
            x: 125,
            y: 5,
            z: -227.75
          },
          {
            hole: 175,
            x: 125,
            y: 5,
            z: -235.5
          },
          {
            hole: 176,
            x: 125,
            y: 5,
            z: -244.5
          },
          {
            hole: 177,
            x: 125,
            y: 5,
            z: -252.25
          },
          {
            hole: 178,
            x: 125,
            y: 5,
            z: -260
          },
          {
            hole: 179,
            x: 125,
            y: 5,
            z: -267.75
          },
          {
            hole: 180,
            x: 125,
            y: 5,
            z: -275.5
          },
          {
            hole: 181,
            x: 123.4667,
            y: 5,
            z: -291.6469
          },
          {
            hole: 182,
            x: 118.9711,
            y: 5,
            z: -302.5
          },
          {
            hole: 183,
            x: 111.8198,
            y: 5,
            z: -311.8198
          },
          {
            hole: 184,
            x: 102.5,
            y: 5,
            z: -318.9711
          },
          {
            hole: 185,
            x: 91.6469,
            y: 5,
            z: -323.4667
          },
          {
            hole: 186,
            x: 68.3531,
            y: 5,
            z: -323.4667
          },
          {
            hole: 187,
            x: 57.5,
            y: 5,
            z: -318.9711
          },
          {
            hole: 188,
            x: 48.1802,
            y: 5,
            z: -311.8198
          },
          {
            hole: 189,
            x: 41.0289,
            y: 5,
            z: -302.5
          },
          {
            hole: 190,
            x: 36.5333,
            y: 5,
            z: -291.6469
          },
          {
            hole: 191,
            x: 35,
            y: 5,
            z: -275.5
          },
          {
            hole: 192,
            x: 35,
            y: 5,
            z: -267.75
          },
          {
            hole: 193,
            x: 35,
            y: 5,
            z: -260
          },
          {
            hole: 194,
            x: 35,
            y: 5,
            z: -252.25
          },
          {
            hole: 195,
            x: 35,
            y: 5,
            z: -244.5
          },
          {
            hole: 196,
            x: 35,
            y: 5,
            z: -235.5
          },
          {
            hole: 197,
            x: 35,
            y: 5,
            z: -227.75
          },
          {
            hole: 198,
            x: 35,
            y: 5,
            z: -220
          },
          {
            hole: 199,
            x: 35,
            y: 5,
            z: -212.25
          },
          {
            hole: 200,
            x: 35,
            y: 5,
            z: -204.5
          },
          {
            hole: 201,
            x: 35,
            y: 5,
            z: -195.5
          },
          {
            hole: 202,
            x: 35,
            y: 5,
            z: -187.75
          },
          {
            hole: 203,
            x: 35,
            y: 5,
            z: -180
          },
          {
            hole: 204,
            x: 35,
            y: 5,
            z: -172.25
          },
          {
            hole: 205,
            x: 35,
            y: 5,
            z: -164.5
          },
          {
            hole: 206,
            x: 35,
            y: 5,
            z: -155.5
          },
          {
            hole: 207,
            x: 35,
            y: 5,
            z: -147.75
          },
          {
            hole: 208,
            x: 35,
            y: 5,
            z: -140
          },
          {
            hole: 209,
            x: 35,
            y: 5,
            z: -132.25
          },
          {
            hole: 210,
            x: 35,
            y: 5,
            z: -124.5
          },
          {
            hole: 211,
            x: 35,
            y: 5,
            z: -115.5
          },
          {
            hole: 212,
            x: 35,
            y: 5,
            z: -107.75
          },
          {
            hole: 213,
            x: 35,
            y: 5,
            z: -100
          },
          {
            hole: 214,
            x: 35,
            y: 5,
            z: -92.25
          },
          {
            hole: 215,
            x: 35,
            y: 5,
            z: -84.5
          },
          {
            hole: 216,
            x: 35,
            y: 5,
            z: -75.5
          },
          {
            hole: 217,
            x: 35,
            y: 5,
            z: -67.75
          },
          {
            hole: 218,
            x: 35,
            y: 5,
            z: -60
          },
          {
            hole: 219,
            x: 35,
            y: 5,
            z: -52.25
          },
          {
            hole: 220,
            x: 35,
            y: 5,
            z: -44.5
          },
          {
            hole: 221,
            x: 35,
            y: 5,
            z: -35.5
          },
          {
            hole: 222,
            x: 35,
            y: 5,
            z: -27.75
          },
          {
            hole: 223,
            x: 35,
            y: 5,
            z: -20
          },
          {
            hole: 224,
            x: 35,
            y: 5,
            z: -12.25
          },
          {
            hole: 225,
            x: 35,
            y: 5,
            z: -4.5
          },
          {
            hole: 226,
            x: 35,
            y: 5,
            z: 4.5
          },
          {
            hole: 227,
            x: 35,
            y: 5,
            z: 12.25
          },
          {
            hole: 228,
            x: 35,
            y: 5,
            z: 20
          },
          {
            hole: 229,
            x: 35,
            y: 5,
            z: 27.75
          },
          {
            hole: 230,
            x: 35,
            y: 5,
            z: 35.5
          },
          {
            hole: 231,
            x: 35,
            y: 5,
            z: 44.5
          },
          {
            hole: 232,
            x: 35,
            y: 5,
            z: 52.25
          },
          {
            hole: 233,
            x: 35,
            y: 5,
            z: 60
          },
          {
            hole: 234,
            x: 35,
            y: 5,
            z: 67.75
          },
          {
            hole: 235,
            x: 35,
            y: 5,
            z: 75.5
          },
          {
            hole: 236,
            x: 33.8074,
            y: 5,
            z: 89.0587
          },
          {
            hole: 237,
            x: 30.3109,
            y: 5,
            z: 97.5
          },
          {
            hole: 238,
            x: 24.7487,
            y: 5,
            z: 104.7487
          },
          {
            hole: 239,
            x: 17.5,
            y: 5,
            z: 110.3109
          },
          {
            hole: 240,
            x: 9.0587,
            y: 5,
            z: 113.8074
          },
          {
            hole: 241,
            x: -9.0587,
            y: 5,
            z: 113.8074
          },
          {
            hole: 242,
            x: -17.5,
            y: 5,
            z: 110.3109
          },
          {
            hole: 243,
            x: -24.7487,
            y: 5,
            z: 104.7487
          },
          {
            hole: 244,
            x: -30.3109,
            y: 5,
            z: 97.5
          },
          {
            hole: 245,
            x: -33.8074,
            y: 5,
            z: 89.0587
          },
          {
            hole: 246,
            x: -35,
            y: 5,
            z: 75.5
          },
          {
            hole: 247,
            x: -35,
            y: 5,
            z: 67.75
          },
          {
            hole: 248,
            x: -35,
            y: 5,
            z: 60
          },
          {
            hole: 249,
            x: -35,
            y: 5,
            z: 52.25
          },
          {
            hole: 250,
            x: -35,
            y: 5,
            z: 44.5
          },
          {
            hole: 251,
            x: -35,
            y: 5,
            z: 35.5
          },
          {
            hole: 252,
            x: -35,
            y: 5,
            z: 27.75
          },
          {
            hole: 253,
            x: -35,
            y: 5,
            z: 20
          },
          {
            hole: 254,
            x: -35,
            y: 5,
            z: 12.25
          },
          {
            hole: 255,
            x: -35,
            y: 5,
            z: 4.5
          },
          {
            hole: 256,
            x: -35,
            y: 5,
            z: -4.5
          },
          {
            hole: 257,
            x: -35,
            y: 5,
            z: -12.25
          },
          {
            hole: 258,
            x: -35,
            y: 5,
            z: -20
          },
          {
            hole: 259,
            x: -35,
            y: 5,
            z: -27.75
          },
          {
            hole: 260,
            x: -35,
            y: 5,
            z: -35.5
          },
          {
            hole: 261,
            x: -35,
            y: 5,
            z: -44.5
          },
          {
            hole: 262,
            x: -35,
            y: 5,
            z: -52.25
          },
          {
            hole: 263,
            x: -35,
            y: 5,
            z: -60
          },
          {
            hole: 264,
            x: -35,
            y: 5,
            z: -67.75
          },
          {
            hole: 265,
            x: -35,
            y: 5,
            z: -75.5
          },
          {
            hole: 266,
            x: -35,
            y: 5,
            z: -84.5
          },
          {
            hole: 267,
            x: -35,
            y: 5,
            z: -92.25
          },
          {
            hole: 268,
            x: -35,
            y: 5,
            z: -100
          },
          {
            hole: 269,
            x: -35,
            y: 5,
            z: -107.75
          },
          {
            hole: 270,
            x: -35,
            y: 5,
            z: -115.5
          },
          {
            hole: 271,
            x: -35,
            y: 5,
            z: -124.5
          },
          {
            hole: 272,
            x: -35,
            y: 5,
            z: -132.25
          },
          {
            hole: 273,
            x: -35,
            y: 5,
            z: -140
          },
          {
            hole: 274,
            x: -35,
            y: 5,
            z: -147.75
          },
          {
            hole: 275,
            x: -35,
            y: 5,
            z: -155.5
          },
          {
            hole: 276,
            x: -35,
            y: 5,
            z: -164.5
          },
          {
            hole: 277,
            x: -35,
            y: 5,
            z: -172.25
          },
          {
            hole: 278,
            x: -35,
            y: 5,
            z: -180
          },
          {
            hole: 279,
            x: -35,
            y: 5,
            z: -187.75
          },
          {
            hole: 280,
            x: -35,
            y: 5,
            z: -195.5
          },
          {
            hole: 281,
            x: -35,
            y: 5,
            z: -204.5
          },
          {
            hole: 282,
            x: -35,
            y: 5,
            z: -212.25
          },
          {
            hole: 283,
            x: -35,
            y: 5,
            z: -220
          },
          {
            hole: 284,
            x: -35,
            y: 5,
            z: -227.75
          },
          {
            hole: 285,
            x: -35,
            y: 5,
            z: -235.5
          },
          {
            hole: 286,
            x: -35,
            y: 5,
            z: -244.5
          },
          {
            hole: 287,
            x: -35,
            y: 5,
            z: -252.25
          },
          {
            hole: 288,
            x: -35,
            y: 5,
            z: -260
          },
          {
            hole: 289,
            x: -35,
            y: 5,
            z: -267.75
          },
          {
            hole: 290,
            x: -35,
            y: 5,
            z: -275.5
          },
          {
            hole: 291,
            x: -36.5333,
            y: 5,
            z: -291.6469
          },
          {
            hole: 292,
            x: -41.0289,
            y: 5,
            z: -302.5
          },
          {
            hole: 293,
            x: -48.1802,
            y: 5,
            z: -311.8198
          },
          {
            hole: 294,
            x: -57.5,
            y: 5,
            z: -318.9711
          },
          {
            hole: 295,
            x: -68.3531,
            y: 5,
            z: -323.4667
          },
          {
            hole: 296,
            x: -91.6469,
            y: 5,
            z: -323.4667
          },
          {
            hole: 297,
            x: -102.5,
            y: 5,
            z: -318.9711
          },
          {
            hole: 298,
            x: -111.8198,
            y: 5,
            z: -311.8198
          },
          {
            hole: 299,
            x: -118.9711,
            y: 5,
            z: -302.5
          },
          {
            hole: 300,
            x: -123.4667,
            y: 5,
            z: -291.6469
          },
          {
            hole: 301,
            x: -125,
            y: 5,
            z: -275.5
          },
          {
            hole: 302,
            x: -125,
            y: 5,
            z: -267.75
          },
          {
            hole: 303,
            x: -125,
            y: 5,
            z: -260
          },
          {
            hole: 304,
            x: -125,
            y: 5,
            z: -252.25
          },
          {
            hole: 305,
            x: -125,
            y: 5,
            z: -244.5
          },
          {
            hole: 306,
            x: -125,
            y: 5,
            z: -235.5
          },
          {
            hole: 307,
            x: -125,
            y: 5,
            z: -227.75
          },
          {
            hole: 308,
            x: -125,
            y: 5,
            z: -220
          },
          {
            hole: 309,
            x: -125,
            y: 5,
            z: -212.25
          },
          {
            hole: 310,
            x: -125,
            y: 5,
            z: -204.5
          },
          {
            hole: 311,
            x: -125,
            y: 5,
            z: -195.5
          },
          {
            hole: 312,
            x: -125,
            y: 5,
            z: -187.75
          },
          {
            hole: 313,
            x: -125,
            y: 5,
            z: -180
          },
          {
            hole: 314,
            x: -125,
            y: 5,
            z: -172.25
          },
          {
            hole: 315,
            x: -125,
            y: 5,
            z: -164.5
          },
          {
            hole: 316,
            x: -125,
            y: 5,
            z: -155.5
          },
          {
            hole: 317,
            x: -125,
            y: 5,
            z: -147.75
          },
          {
            hole: 318,
            x: -125,
            y: 5,
            z: -140
          },
          {
            hole: 319,
            x: -125,
            y: 5,
            z: -132.25
          },
          {
            hole: 320,
            x: -125,
            y: 5,
            z: -124.5
          },
          {
            hole: 321,
            x: -125,
            y: 5,
            z: -115.5
          },
          {
            hole: 322,
            x: -125,
            y: 5,
            z: -107.75
          },
          {
            hole: 323,
            x: -125,
            y: 5,
            z: -100
          },
          {
            hole: 324,
            x: -125,
            y: 5,
            z: -92.25
          },
          {
            hole: 325,
            x: -125,
            y: 5,
            z: -84.5
          },
          {
            hole: 326,
            x: -125,
            y: 5,
            z: -75.5
          },
          {
            hole: 327,
            x: -125,
            y: 5,
            z: -67.75
          },
          {
            hole: 328,
            x: -125,
            y: 5,
            z: -60
          },
          {
            hole: 329,
            x: -125,
            y: 5,
            z: -52.25
          },
          {
            hole: 330,
            x: -125,
            y: 5,
            z: -44.5
          },
          {
            hole: 331,
            x: -125,
            y: 5,
            z: -35.5
          },
          {
            hole: 332,
            x: -125,
            y: 5,
            z: -27.75
          },
          {
            hole: 333,
            x: -125,
            y: 5,
            z: -20
          },
          {
            hole: 334,
            x: -125,
            y: 5,
            z: -12.25
          },
          {
            hole: 335,
            x: -125,
            y: 5,
            z: -4.5
          },
          {
            hole: 336,
            x: -125,
            y: 5,
            z: 4.5
          },
          {
            hole: 337,
            x: -125,
            y: 5,
            z: 12.25
          },
          {
            hole: 338,
            x: -125,
            y: 5,
            z: 20
          },
          {
            hole: 339,
            x: -125,
            y: 5,
            z: 27.75
          },
          {
            hole: 340,
            x: -125,
            y: 5,
            z: 35.5
          },
          {
            hole: 341,
            x: -126.1926,
            y: 5,
            z: 49.0587
          },
          {
            hole: 342,
            x: -129.6891,
            y: 5,
            z: 57.5
          },
          {
            hole: 343,
            x: -135.2513,
            y: 5,
            z: 64.7487
          },
          {
            hole: 344,
            x: -142.5,
            y: 5,
            z: 70.3109
          },
          {
            hole: 345,
            x: -150.9413,
            y: 5,
            z: 73.8074
          },
          {
            hole: 346,
            x: -169.0587,
            y: 5,
            z: 73.8074
          },
          {
            hole: 347,
            x: -177.5,
            y: 5,
            z: 70.3109
          },
          {
            hole: 348,
            x: -184.7487,
            y: 5,
            z: 64.7487
          },
          {
            hole: 349,
            x: -190.3109,
            y: 5,
            z: 57.5
          },
          {
            hole: 350,
            x: -193.8074,
            y: 5,
            z: 49.0587
          },
          {
            hole: 351,
            x: -195,
            y: 5,
            z: 35.5
          },
          {
            hole: 352,
            x: -195,
            y: 5,
            z: 27.75
          },
          {
            hole: 353,
            x: -195,
            y: 5,
            z: 20
          },
          {
            hole: 354,
            x: -195,
            y: 5,
            z: 12.25
          },
          {
            hole: 355,
            x: -195,
            y: 5,
            z: 4.5
          },
          {
            hole: 356,
            x: -195,
            y: 5,
            z: -4.5
          },
          {
            hole: 357,
            x: -195,
            y: 5,
            z: -12.25
          },
          {
            hole: 358,
            x: -195,
            y: 5,
            z: -20
          },
          {
            hole: 359,
            x: -195,
            y: 5,
            z: -27.75
          },
          {
            hole: 360,
            x: -195,
            y: 5,
            z: -35.5
          },
          {
            hole: 361,
            x: -195,
            y: 5,
            z: -44.5
          },
          {
            hole: 362,
            x: -195,
            y: 5,
            z: -52.25
          },
          {
            hole: 363,
            x: -195,
            y: 5,
            z: -60
          },
          {
            hole: 364,
            x: -195,
            y: 5,
            z: -67.75
          },
          {
            hole: 365,
            x: -195,
            y: 5,
            z: -75.5
          },
          {
            hole: 366,
            x: -195,
            y: 5,
            z: -84.5
          },
          {
            hole: 367,
            x: -195,
            y: 5,
            z: -92.25
          },
          {
            hole: 368,
            x: -195,
            y: 5,
            z: -100
          },
          {
            hole: 369,
            x: -195,
            y: 5,
            z: -107.75
          },
          {
            hole: 370,
            x: -195,
            y: 5,
            z: -115.5
          },
          {
            hole: 371,
            x: -195,
            y: 5,
            z: -124.5
          },
          {
            hole: 372,
            x: -195,
            y: 5,
            z: -132.25
          },
          {
            hole: 373,
            x: -195,
            y: 5,
            z: -140
          },
          {
            hole: 374,
            x: -195,
            y: 5,
            z: -147.75
          },
          {
            hole: 375,
            x: -195,
            y: 5,
            z: -155.5
          },
          {
            hole: 376,
            x: -195,
            y: 5,
            z: -164.5
          },
          {
            hole: 377,
            x: -195,
            y: 5,
            z: -172.25
          },
          {
            hole: 378,
            x: -195,
            y: 5,
            z: -180
          },
          {
            hole: 379,
            x: -195,
            y: 5,
            z: -187.75
          },
          {
            hole: 380,
            x: -195,
            y: 5,
            z: -195.5
          },
          {
            hole: 381,
            x: -195,
            y: 5,
            z: -204.5
          },
          {
            hole: 382,
            x: -195,
            y: 5,
            z: -212.25
          },
          {
            hole: 383,
            x: -195,
            y: 5,
            z: -220
          },
          {
            hole: 384,
            x: -195,
            y: 5,
            z: -227.75
          },
          {
            hole: 385,
            x: -195,
            y: 5,
            z: -235.5
          },
          {
            hole: 386,
            x: -195,
            y: 5,
            z: -244.5
          },
          {
            hole: 387,
            x: -195,
            y: 5,
            z: -252.25
          },
          {
            hole: 388,
            x: -195,
            y: 5,
            z: -260
          },
          {
            hole: 389,
            x: -195,
            y: 5,
            z: -267.75
          },
          {
            hole: 390,
            x: -195,
            y: 5,
            z: -275.5
          },
          {
            hole: 391,
            x: -196.5333,
            y: 5,
            z: -291.6469
          },
          {
            hole: 392,
            x: -201.0289,
            y: 5,
            z: -302.5
          },
          {
            hole: 393,
            x: -208.1802,
            y: 5,
            z: -311.8198
          },
          {
            hole: 394,
            x: -217.5,
            y: 5,
            z: -318.9711
          },
          {
            hole: 395,
            x: -228.3531,
            y: 5,
            z: -323.4667
          },
          {
            hole: 396,
            x: -251.6469,
            y: 5,
            z: -323.4667
          },
          {
            hole: 397,
            x: -262.5,
            y: 5,
            z: -318.9711
          },
          {
            hole: 398,
            x: -271.8198,
            y: 5,
            z: -311.8198
          },
          {
            hole: 399,
            x: -278.9711,
            y: 5,
            z: -302.5
          },
          {
            hole: 400,
            x: -283.4667,
            y: 5,
            z: -291.6469
          },
          {
            hole: 401,
            x: -285,
            y: 5,
            z: -275.5
          },
          {
            hole: 402,
            x: -285,
            y: 5,
            z: -267.75
          },
          {
            hole: 403,
            x: -285,
            y: 5,
            z: -260
          },
          {
            hole: 404,
            x: -285,
            y: 5,
            z: -252.25
          },
          {
            hole: 405,
            x: -285,
            y: 5,
            z: -244.5
          },
          {
            hole: 406,
            x: -285,
            y: 5,
            z: -235.5
          },
          {
            hole: 407,
            x: -285,
            y: 5,
            z: -227.75
          },
          {
            hole: 408,
            x: -285,
            y: 5,
            z: -220
          },
          {
            hole: 409,
            x: -285,
            y: 5,
            z: -212.25
          },
          {
            hole: 410,
            x: -285,
            y: 5,
            z: -204.5
          },
          {
            hole: 411,
            x: -285,
            y: 5,
            z: -195.5
          },
          {
            hole: 412,
            x: -285,
            y: 5,
            z: -187.75
          },
          {
            hole: 413,
            x: -285,
            y: 5,
            z: -180
          },
          {
            hole: 414,
            x: -285,
            y: 5,
            z: -172.25
          },
          {
            hole: 415,
            x: -285,
            y: 5,
            z: -164.5
          },
          {
            hole: 416,
            x: -285,
            y: 5,
            z: -155.5
          },
          {
            hole: 417,
            x: -285,
            y: 5,
            z: -147.75
          },
          {
            hole: 418,
            x: -285,
            y: 5,
            z: -140
          },
          {
            hole: 419,
            x: -285,
            y: 5,
            z: -132.25
          },
          {
            hole: 420,
            x: -285,
            y: 5,
            z: -124.5
          },
          {
            hole: 421,
            x: -285,
            y: 5,
            z: -115.5
          },
          {
            hole: 422,
            x: -285,
            y: 5,
            z: -107.75
          },
          {
            hole: 423,
            x: -285,
            y: 5,
            z: -100
          },
          {
            hole: 424,
            x: -285,
            y: 5,
            z: -92.25
          },
          {
            hole: 425,
            x: -285,
            y: 5,
            z: -84.5
          },
          {
            hole: 426,
            x: -285,
            y: 5,
            z: -75.5
          },
          {
            hole: 427,
            x: -285,
            y: 5,
            z: -67.75
          },
          {
            hole: 428,
            x: -285,
            y: 5,
            z: -60
          },
          {
            hole: 429,
            x: -285,
            y: 5,
            z: -52.25
          },
          {
            hole: 430,
            x: -285,
            y: 5,
            z: -44.5
          },
          {
            hole: 431,
            x: -285,
            y: 5,
            z: -35.5
          },
          {
            hole: 432,
            x: -285,
            y: 5,
            z: -27.75
          },
          {
            hole: 433,
            x: -285,
            y: 5,
            z: -20
          },
          {
            hole: 434,
            x: -285,
            y: 5,
            z: -12.25
          },
          {
            hole: 435,
            x: -285,
            y: 5,
            z: -4.5
          },
          {
            hole: 436,
            x: -285,
            y: 5,
            z: 4.5
          },
          {
            hole: 437,
            x: -285,
            y: 5,
            z: 12.25
          },
          {
            hole: 438,
            x: -285,
            y: 5,
            z: 20
          },
          {
            hole: 439,
            x: -285,
            y: 5,
            z: 27.75
          },
          {
            hole: 440,
            x: -285,
            y: 5,
            z: 35.5
          },
          {
            hole: 441,
            x: -285,
            y: 5,
            z: 44.5
          },
          {
            hole: 442,
            x: -285,
            y: 5,
            z: 52.25
          },
          {
            hole: 443,
            x: -285,
            y: 5,
            z: 60
          },
          {
            hole: 444,
            x: -285,
            y: 5,
            z: 67.75
          },
          {
            hole: 445,
            x: -285,
            y: 5,
            z: 75.5
          },
          {
            hole: 446,
            x: -285,
            y: 5,
            z: 84.5
          },
          {
            hole: 447,
            x: -285,
            y: 5,
            z: 92.25
          },
          {
            hole: 448,
            x: -285,
            y: 5,
            z: 100
          },
          {
            hole: 449,
            x: -285,
            y: 5,
            z: 107.75
          },
          {
            hole: 450,
            x: -285,
            y: 5,
            z: 115.5
          },
          {
            hole: 451,
            x: -283.4667,
            y: 5,
            z: 131.6469
          },
          {
            hole: 452,
            x: -278.9711,
            y: 5,
            z: 142.5
          },
          {
            hole: 453,
            x: -271.8198,
            y: 5,
            z: 151.8198
          },
          {
            hole: 454,
            x: -262.5,
            y: 5,
            z: 158.9711
          },
          {
            hole: 455,
            x: -251.6469,
            y: 5,
            z: 163.4667
          },
          {
            hole: 456,
            x: -235.5,
            y: 5,
            z: 165
          },
          {
            hole: 457,
            x: -227.75,
            y: 5,
            z: 165
          },
          {
            hole: 458,
            x: -220,
            y: 5,
            z: 165
          },
          {
            hole: 459,
            x: -212.25,
            y: 5,
            z: 165
          },
          {
            hole: 460,
            x: -204.5,
            y: 5,
            z: 165
          },
          {
            hole: 461,
            x: -195.5,
            y: 5,
            z: 165
          },
          {
            hole: 462,
            x: -187.75,
            y: 5,
            z: 165
          },
          {
            hole: 463,
            x: -180,
            y: 5,
            z: 165
          },
          {
            hole: 464,
            x: -172.25,
            y: 5,
            z: 165
          },
          {
            hole: 465,
            x: -164.5,
            y: 5,
            z: 165
          },
          {
            hole: 466,
            x: -155.5,
            y: 5,
            z: 165
          },
          {
            hole: 467,
            x: -147.75,
            y: 5,
            z: 165
          },
          {
            hole: 468,
            x: -140,
            y: 5,
            z: 165
          },
          {
            hole: 469,
            x: -132.25,
            y: 5,
            z: 165
          },
          {
            hole: 470,
            x: -124.5,
            y: 5,
            z: 165
          },
          {
            hole: 471,
            x: -115.5,
            y: 5,
            z: 165
          },
          {
            hole: 472,
            x: -107.75,
            y: 5,
            z: 165
          },
          {
            hole: 473,
            x: -100,
            y: 5,
            z: 165
          },
          {
            hole: 474,
            x: -92.25,
            y: 5,
            z: 165
          },
          {
            hole: 475,
            x: -84.5,
            y: 5,
            z: 165
          },
          {
            hole: 476,
            x: -75.5,
            y: 5,
            z: 165
          },
          {
            hole: 477,
            x: -67.75,
            y: 5,
            z: 165
          },
          {
            hole: 478,
            x: -60,
            y: 5,
            z: 165
          },
          {
            hole: 479,
            x: -52.25,
            y: 5,
            z: 165
          },
          {
            hole: 480,
            x: -44.5,
            y: 5,
            z: 165
          },
          {
            hole: 481,
            x: -20,
            y: 5,
            z: 160
          }
        ],
        p3: [
          {
            hole: 0,
            x: 13,
            y: 5,
            z: 155
          },
          {
            hole: 1,
            x: 44.5,
            y: 5,
            z: 155
          },
          {
            hole: 2,
            x: 52.25,
            y: 5,
            z: 155
          },
          {
            hole: 3,
            x: 60,
            y: 5,
            z: 155
          },
          {
            hole: 4,
            x: 67.75,
            y: 5,
            z: 155
          },
          {
            hole: 5,
            x: 75.5,
            y: 5,
            z: 155
          },
          {
            hole: 6,
            x: 84.5,
            y: 5,
            z: 155
          },
          {
            hole: 7,
            x: 92.25,
            y: 5,
            z: 155
          },
          {
            hole: 8,
            x: 100,
            y: 5,
            z: 155
          },
          {
            hole: 9,
            x: 107.75,
            y: 5,
            z: 155
          },
          {
            hole: 10,
            x: 115.5,
            y: 5,
            z: 155
          },
          {
            hole: 11,
            x: 124.5,
            y: 5,
            z: 155
          },
          {
            hole: 12,
            x: 132.25,
            y: 5,
            z: 155
          },
          {
            hole: 13,
            x: 140,
            y: 5,
            z: 155
          },
          {
            hole: 14,
            x: 147.75,
            y: 5,
            z: 155
          },
          {
            hole: 15,
            x: 155.5,
            y: 5,
            z: 155
          },
          {
            hole: 16,
            x: 164.5,
            y: 5,
            z: 155
          },
          {
            hole: 17,
            x: 172.25,
            y: 5,
            z: 155
          },
          {
            hole: 18,
            x: 180,
            y: 5,
            z: 155
          },
          {
            hole: 19,
            x: 187.75,
            y: 5,
            z: 155
          },
          {
            hole: 20,
            x: 195.5,
            y: 5,
            z: 155
          },
          {
            hole: 21,
            x: 204.5,
            y: 5,
            z: 155
          },
          {
            hole: 22,
            x: 212.25,
            y: 5,
            z: 155
          },
          {
            hole: 23,
            x: 220,
            y: 5,
            z: 155
          },
          {
            hole: 24,
            x: 227.75,
            y: 5,
            z: 155
          },
          {
            hole: 25,
            x: 235.5,
            y: 5,
            z: 155
          },
          {
            hole: 26,
            x: 249.0587,
            y: 5,
            z: 153.8074
          },
          {
            hole: 27,
            x: 257.5,
            y: 5,
            z: 150.3109
          },
          {
            hole: 28,
            x: 264.7487,
            y: 5,
            z: 144.7487
          },
          {
            hole: 29,
            x: 270.3109,
            y: 5,
            z: 137.5
          },
          {
            hole: 30,
            x: 273.8074,
            y: 5,
            z: 129.0587
          },
          {
            hole: 31,
            x: 275,
            y: 5,
            z: 115.5
          },
          {
            hole: 32,
            x: 275,
            y: 5,
            z: 107.75
          },
          {
            hole: 33,
            x: 275,
            y: 5,
            z: 100
          },
          {
            hole: 34,
            x: 275,
            y: 5,
            z: 92.25
          },
          {
            hole: 35,
            x: 275,
            y: 5,
            z: 84.5
          },
          {
            hole: 36,
            x: 275,
            y: 5,
            z: 75.5
          },
          {
            hole: 37,
            x: 275,
            y: 5,
            z: 67.75
          },
          {
            hole: 38,
            x: 275,
            y: 5,
            z: 60
          },
          {
            hole: 39,
            x: 275,
            y: 5,
            z: 52.25
          },
          {
            hole: 40,
            x: 275,
            y: 5,
            z: 44.5
          },
          {
            hole: 41,
            x: 275,
            y: 5,
            z: 35.5
          },
          {
            hole: 42,
            x: 275,
            y: 5,
            z: 27.75
          },
          {
            hole: 43,
            x: 275,
            y: 5,
            z: 20
          },
          {
            hole: 44,
            x: 275,
            y: 5,
            z: 12.25
          },
          {
            hole: 45,
            x: 275,
            y: 5,
            z: 4.5
          },
          {
            hole: 46,
            x: 275,
            y: 5,
            z: -4.5
          },
          {
            hole: 47,
            x: 275,
            y: 5,
            z: -12.25
          },
          {
            hole: 48,
            x: 275,
            y: 5,
            z: -20
          },
          {
            hole: 49,
            x: 275,
            y: 5,
            z: -27.75
          },
          {
            hole: 50,
            x: 275,
            y: 5,
            z: -35.5
          },
          {
            hole: 51,
            x: 275,
            y: 5,
            z: -44.5
          },
          {
            hole: 52,
            x: 275,
            y: 5,
            z: -52.25
          },
          {
            hole: 53,
            x: 275,
            y: 5,
            z: -60
          },
          {
            hole: 54,
            x: 275,
            y: 5,
            z: -67.75
          },
          {
            hole: 55,
            x: 275,
            y: 5,
            z: -75.5
          },
          {
            hole: 56,
            x: 275,
            y: 5,
            z: -84.5
          },
          {
            hole: 57,
            x: 275,
            y: 5,
            z: -92.25
          },
          {
            hole: 58,
            x: 275,
            y: 5,
            z: -100
          },
          {
            hole: 59,
            x: 275,
            y: 5,
            z: -107.75
          },
          {
            hole: 60,
            x: 275,
            y: 5,
            z: -115.5
          },
          {
            hole: 61,
            x: 275,
            y: 5,
            z: -124.5
          },
          {
            hole: 62,
            x: 275,
            y: 5,
            z: -132.25
          },
          {
            hole: 63,
            x: 275,
            y: 5,
            z: -140
          },
          {
            hole: 64,
            x: 275,
            y: 5,
            z: -147.75
          },
          {
            hole: 65,
            x: 275,
            y: 5,
            z: -155.5
          },
          {
            hole: 66,
            x: 275,
            y: 5,
            z: -164.5
          },
          {
            hole: 67,
            x: 275,
            y: 5,
            z: -172.25
          },
          {
            hole: 68,
            x: 275,
            y: 5,
            z: -180
          },
          {
            hole: 69,
            x: 275,
            y: 5,
            z: -187.75
          },
          {
            hole: 70,
            x: 275,
            y: 5,
            z: -195.5
          },
          {
            hole: 71,
            x: 275,
            y: 5,
            z: -204.5
          },
          {
            hole: 72,
            x: 275,
            y: 5,
            z: -212.25
          },
          {
            hole: 73,
            x: 275,
            y: 5,
            z: -220
          },
          {
            hole: 74,
            x: 275,
            y: 5,
            z: -227.75
          },
          {
            hole: 75,
            x: 275,
            y: 5,
            z: -235.5
          },
          {
            hole: 76,
            x: 275,
            y: 5,
            z: -244.5
          },
          {
            hole: 77,
            x: 275,
            y: 5,
            z: -252.25
          },
          {
            hole: 78,
            x: 275,
            y: 5,
            z: -260
          },
          {
            hole: 79,
            x: 275,
            y: 5,
            z: -267.75
          },
          {
            hole: 80,
            x: 275,
            y: 5,
            z: -275.5
          },
          {
            hole: 81,
            x: 273.8074,
            y: 5,
            z: -289.0587
          },
          {
            hole: 82,
            x: 270.3109,
            y: 5,
            z: -297.5
          },
          {
            hole: 83,
            x: 264.7487,
            y: 5,
            z: -304.7487
          },
          {
            hole: 84,
            x: 257.5,
            y: 5,
            z: -310.3109
          },
          {
            hole: 85,
            x: 249.0587,
            y: 5,
            z: -313.8074
          },
          {
            hole: 86,
            x: 230.9413,
            y: 5,
            z: -313.8074
          },
          {
            hole: 87,
            x: 222.5,
            y: 5,
            z: -310.3109
          },
          {
            hole: 88,
            x: 215.2513,
            y: 5,
            z: -304.7487
          },
          {
            hole: 89,
            x: 209.6891,
            y: 5,
            z: -297.5
          },
          {
            hole: 90,
            x: 206.1926,
            y: 5,
            z: -289.0587
          },
          {
            hole: 91,
            x: 205,
            y: 5,
            z: -275.5
          },
          {
            hole: 92,
            x: 205,
            y: 5,
            z: -267.75
          },
          {
            hole: 93,
            x: 205,
            y: 5,
            z: -260
          },
          {
            hole: 94,
            x: 205,
            y: 5,
            z: -252.25
          },
          {
            hole: 95,
            x: 205,
            y: 5,
            z: -244.5
          },
          {
            hole: 96,
            x: 205,
            y: 5,
            z: -235.5
          },
          {
            hole: 97,
            x: 205,
            y: 5,
            z: -227.75
          },
          {
            hole: 98,
            x: 205,
            y: 5,
            z: -220
          },
          {
            hole: 99,
            x: 205,
            y: 5,
            z: -212.25
          },
          {
            hole: 100,
            x: 205,
            y: 5,
            z: -204.5
          },
          {
            hole: 101,
            x: 205,
            y: 5,
            z: -195.5
          },
          {
            hole: 102,
            x: 205,
            y: 5,
            z: -187.75
          },
          {
            hole: 103,
            x: 205,
            y: 5,
            z: -180
          },
          {
            hole: 104,
            x: 205,
            y: 5,
            z: -172.25
          },
          {
            hole: 105,
            x: 205,
            y: 5,
            z: -164.5
          },
          {
            hole: 106,
            x: 205,
            y: 5,
            z: -155.5
          },
          {
            hole: 107,
            x: 205,
            y: 5,
            z: -147.75
          },
          {
            hole: 108,
            x: 205,
            y: 5,
            z: -140
          },
          {
            hole: 109,
            x: 205,
            y: 5,
            z: -132.25
          },
          {
            hole: 110,
            x: 205,
            y: 5,
            z: -124.5
          },
          {
            hole: 111,
            x: 205,
            y: 5,
            z: -115.5
          },
          {
            hole: 112,
            x: 205,
            y: 5,
            z: -107.75
          },
          {
            hole: 113,
            x: 205,
            y: 5,
            z: -100
          },
          {
            hole: 114,
            x: 205,
            y: 5,
            z: -92.25
          },
          {
            hole: 115,
            x: 205,
            y: 5,
            z: -84.5
          },
          {
            hole: 116,
            x: 205,
            y: 5,
            z: -75.5
          },
          {
            hole: 117,
            x: 205,
            y: 5,
            z: -67.75
          },
          {
            hole: 118,
            x: 205,
            y: 5,
            z: -60
          },
          {
            hole: 119,
            x: 205,
            y: 5,
            z: -52.25
          },
          {
            hole: 120,
            x: 205,
            y: 5,
            z: -44.5
          },
          {
            hole: 121,
            x: 205,
            y: 5,
            z: -35.5
          },
          {
            hole: 122,
            x: 205,
            y: 5,
            z: -27.75
          },
          {
            hole: 123,
            x: 205,
            y: 5,
            z: -20
          },
          {
            hole: 124,
            x: 205,
            y: 5,
            z: -12.25
          },
          {
            hole: 125,
            x: 205,
            y: 5,
            z: -4.5
          },
          {
            hole: 126,
            x: 205,
            y: 5,
            z: 4.5
          },
          {
            hole: 127,
            x: 205,
            y: 5,
            z: 12.25
          },
          {
            hole: 128,
            x: 205,
            y: 5,
            z: 20
          },
          {
            hole: 129,
            x: 205,
            y: 5,
            z: 27.75
          },
          {
            hole: 130,
            x: 205,
            y: 5,
            z: 35.5
          },
          {
            hole: 131,
            x: 203.4667,
            y: 5,
            z: 51.6469
          },
          {
            hole: 132,
            x: 198.9711,
            y: 5,
            z: 62.5
          },
          {
            hole: 133,
            x: 191.8198,
            y: 5,
            z: 71.8198
          },
          {
            hole: 134,
            x: 182.5,
            y: 5,
            z: 78.9711
          },
          {
            hole: 135,
            x: 171.6469,
            y: 5,
            z: 83.4667
          },
          {
            hole: 136,
            x: 148.3531,
            y: 5,
            z: 83.4667
          },
          {
            hole: 137,
            x: 137.5,
            y: 5,
            z: 78.9711
          },
          {
            hole: 138,
            x: 128.1802,
            y: 5,
            z: 71.8198
          },
          {
            hole: 139,
            x: 121.0289,
            y: 5,
            z: 62.5
          },
          {
            hole: 140,
            x: 116.5333,
            y: 5,
            z: 51.6469
          },
          {
            hole: 141,
            x: 115,
            y: 5,
            z: 35.5
          },
          {
            hole: 142,
            x: 115,
            y: 5,
            z: 27.75
          },
          {
            hole: 143,
            x: 115,
            y: 5,
            z: 20
          },
          {
            hole: 144,
            x: 115,
            y: 5,
            z: 12.25
          },
          {
            hole: 145,
            x: 115,
            y: 5,
            z: 4.5
          },
          {
            hole: 146,
            x: 115,
            y: 5,
            z: -4.5
          },
          {
            hole: 147,
            x: 115,
            y: 5,
            z: -12.25
          },
          {
            hole: 148,
            x: 115,
            y: 5,
            z: -20
          },
          {
            hole: 149,
            x: 115,
            y: 5,
            z: -27.75
          },
          {
            hole: 150,
            x: 115,
            y: 5,
            z: -35.5
          },
          {
            hole: 151,
            x: 115,
            y: 5,
            z: -44.5
          },
          {
            hole: 152,
            x: 115,
            y: 5,
            z: -52.25
          },
          {
            hole: 153,
            x: 115,
            y: 5,
            z: -60
          },
          {
            hole: 154,
            x: 115,
            y: 5,
            z: -67.75
          },
          {
            hole: 155,
            x: 115,
            y: 5,
            z: -75.5
          },
          {
            hole: 156,
            x: 115,
            y: 5,
            z: -84.5
          },
          {
            hole: 157,
            x: 115,
            y: 5,
            z: -92.25
          },
          {
            hole: 158,
            x: 115,
            y: 5,
            z: -100
          },
          {
            hole: 159,
            x: 115,
            y: 5,
            z: -107.75
          },
          {
            hole: 160,
            x: 115,
            y: 5,
            z: -115.5
          },
          {
            hole: 161,
            x: 115,
            y: 5,
            z: -124.5
          },
          {
            hole: 162,
            x: 115,
            y: 5,
            z: -132.25
          },
          {
            hole: 163,
            x: 115,
            y: 5,
            z: -140
          },
          {
            hole: 164,
            x: 115,
            y: 5,
            z: -147.75
          },
          {
            hole: 165,
            x: 115,
            y: 5,
            z: -155.5
          },
          {
            hole: 166,
            x: 115,
            y: 5,
            z: -164.5
          },
          {
            hole: 167,
            x: 115,
            y: 5,
            z: -172.25
          },
          {
            hole: 168,
            x: 115,
            y: 5,
            z: -180
          },
          {
            hole: 169,
            x: 115,
            y: 5,
            z: -187.75
          },
          {
            hole: 170,
            x: 115,
            y: 5,
            z: -195.5
          },
          {
            hole: 171,
            x: 115,
            y: 5,
            z: -204.5
          },
          {
            hole: 172,
            x: 115,
            y: 5,
            z: -212.25
          },
          {
            hole: 173,
            x: 115,
            y: 5,
            z: -220
          },
          {
            hole: 174,
            x: 115,
            y: 5,
            z: -227.75
          },
          {
            hole: 175,
            x: 115,
            y: 5,
            z: -235.5
          },
          {
            hole: 176,
            x: 115,
            y: 5,
            z: -244.5
          },
          {
            hole: 177,
            x: 115,
            y: 5,
            z: -252.25
          },
          {
            hole: 178,
            x: 115,
            y: 5,
            z: -260
          },
          {
            hole: 179,
            x: 115,
            y: 5,
            z: -267.75
          },
          {
            hole: 180,
            x: 115,
            y: 5,
            z: -275.5
          },
          {
            hole: 181,
            x: 113.8074,
            y: 5,
            z: -289.0587
          },
          {
            hole: 182,
            x: 110.3109,
            y: 5,
            z: -297.5
          },
          {
            hole: 183,
            x: 104.7487,
            y: 5,
            z: -304.7487
          },
          {
            hole: 184,
            x: 97.5,
            y: 5,
            z: -310.3109
          },
          {
            hole: 185,
            x: 89.0587,
            y: 5,
            z: -313.8074
          },
          {
            hole: 186,
            x: 70.9413,
            y: 5,
            z: -313.8074
          },
          {
            hole: 187,
            x: 62.5,
            y: 5,
            z: -310.3109
          },
          {
            hole: 188,
            x: 55.2513,
            y: 5,
            z: -304.7487
          },
          {
            hole: 189,
            x: 49.6891,
            y: 5,
            z: -297.5
          },
          {
            hole: 190,
            x: 46.1926,
            y: 5,
            z: -289.0587
          },
          {
            hole: 191,
            x: 45,
            y: 5,
            z: -275.5
          },
          {
            hole: 192,
            x: 45,
            y: 5,
            z: -267.75
          },
          {
            hole: 193,
            x: 45,
            y: 5,
            z: -260
          },
          {
            hole: 194,
            x: 45,
            y: 5,
            z: -252.25
          },
          {
            hole: 195,
            x: 45,
            y: 5,
            z: -244.5
          },
          {
            hole: 196,
            x: 45,
            y: 5,
            z: -235.5
          },
          {
            hole: 197,
            x: 45,
            y: 5,
            z: -227.75
          },
          {
            hole: 198,
            x: 45,
            y: 5,
            z: -220
          },
          {
            hole: 199,
            x: 45,
            y: 5,
            z: -212.25
          },
          {
            hole: 200,
            x: 45,
            y: 5,
            z: -204.5
          },
          {
            hole: 201,
            x: 45,
            y: 5,
            z: -195.5
          },
          {
            hole: 202,
            x: 45,
            y: 5,
            z: -187.75
          },
          {
            hole: 203,
            x: 45,
            y: 5,
            z: -180
          },
          {
            hole: 204,
            x: 45,
            y: 5,
            z: -172.25
          },
          {
            hole: 205,
            x: 45,
            y: 5,
            z: -164.5
          },
          {
            hole: 206,
            x: 45,
            y: 5,
            z: -155.5
          },
          {
            hole: 207,
            x: 45,
            y: 5,
            z: -147.75
          },
          {
            hole: 208,
            x: 45,
            y: 5,
            z: -140
          },
          {
            hole: 209,
            x: 45,
            y: 5,
            z: -132.25
          },
          {
            hole: 210,
            x: 45,
            y: 5,
            z: -124.5
          },
          {
            hole: 211,
            x: 45,
            y: 5,
            z: -115.5
          },
          {
            hole: 212,
            x: 45,
            y: 5,
            z: -107.75
          },
          {
            hole: 213,
            x: 45,
            y: 5,
            z: -100
          },
          {
            hole: 214,
            x: 45,
            y: 5,
            z: -92.25
          },
          {
            hole: 215,
            x: 45,
            y: 5,
            z: -84.5
          },
          {
            hole: 216,
            x: 45,
            y: 5,
            z: -75.5
          },
          {
            hole: 217,
            x: 45,
            y: 5,
            z: -67.75
          },
          {
            hole: 218,
            x: 45,
            y: 5,
            z: -60
          },
          {
            hole: 219,
            x: 45,
            y: 5,
            z: -52.25
          },
          {
            hole: 220,
            x: 45,
            y: 5,
            z: -44.5
          },
          {
            hole: 221,
            x: 45,
            y: 5,
            z: -35.5
          },
          {
            hole: 222,
            x: 45,
            y: 5,
            z: -27.75
          },
          {
            hole: 223,
            x: 45,
            y: 5,
            z: -20
          },
          {
            hole: 224,
            x: 45,
            y: 5,
            z: -12.25
          },
          {
            hole: 225,
            x: 45,
            y: 5,
            z: -4.5
          },
          {
            hole: 226,
            x: 45,
            y: 5,
            z: 4.5
          },
          {
            hole: 227,
            x: 45,
            y: 5,
            z: 12.25
          },
          {
            hole: 228,
            x: 45,
            y: 5,
            z: 20
          },
          {
            hole: 229,
            x: 45,
            y: 5,
            z: 27.75
          },
          {
            hole: 230,
            x: 45,
            y: 5,
            z: 35.5
          },
          {
            hole: 231,
            x: 45,
            y: 5,
            z: 44.5
          },
          {
            hole: 232,
            x: 45,
            y: 5,
            z: 52.25
          },
          {
            hole: 233,
            x: 45,
            y: 5,
            z: 60
          },
          {
            hole: 234,
            x: 45,
            y: 5,
            z: 67.75
          },
          {
            hole: 235,
            x: 45,
            y: 5,
            z: 75.5
          },
          {
            hole: 236,
            x: 43.4667,
            y: 5,
            z: 91.6469
          },
          {
            hole: 237,
            x: 38.9711,
            y: 5,
            z: 102.5
          },
          {
            hole: 238,
            x: 31.8198,
            y: 5,
            z: 111.8198
          },
          {
            hole: 239,
            x: 22.5,
            y: 5,
            z: 118.9711
          },
          {
            hole: 240,
            x: 11.6469,
            y: 5,
            z: 123.4667
          },
          {
            hole: 241,
            x: -11.6469,
            y: 5,
            z: 123.4667
          },
          {
            hole: 242,
            x: -22.5,
            y: 5,
            z: 118.9711
          },
          {
            hole: 243,
            x: -31.8198,
            y: 5,
            z: 111.8198
          },
          {
            hole: 244,
            x: -38.9711,
            y: 5,
            z: 102.5
          },
          {
            hole: 245,
            x: -43.4667,
            y: 5,
            z: 91.6469
          },
          {
            hole: 246,
            x: -45,
            y: 5,
            z: 75.5
          },
          {
            hole: 247,
            x: -45,
            y: 5,
            z: 67.75
          },
          {
            hole: 248,
            x: -45,
            y: 5,
            z: 60
          },
          {
            hole: 249,
            x: -45,
            y: 5,
            z: 52.25
          },
          {
            hole: 250,
            x: -45,
            y: 5,
            z: 44.5
          },
          {
            hole: 251,
            x: -45,
            y: 5,
            z: 35.5
          },
          {
            hole: 252,
            x: -45,
            y: 5,
            z: 27.75
          },
          {
            hole: 253,
            x: -45,
            y: 5,
            z: 20
          },
          {
            hole: 254,
            x: -45,
            y: 5,
            z: 12.25
          },
          {
            hole: 255,
            x: -45,
            y: 5,
            z: 4.5
          },
          {
            hole: 256,
            x: -45,
            y: 5,
            z: -4.5
          },
          {
            hole: 257,
            x: -45,
            y: 5,
            z: -12.25
          },
          {
            hole: 258,
            x: -45,
            y: 5,
            z: -20
          },
          {
            hole: 259,
            x: -45,
            y: 5,
            z: -27.75
          },
          {
            hole: 260,
            x: -45,
            y: 5,
            z: -35.5
          },
          {
            hole: 261,
            x: -45,
            y: 5,
            z: -44.5
          },
          {
            hole: 262,
            x: -45,
            y: 5,
            z: -52.25
          },
          {
            hole: 263,
            x: -45,
            y: 5,
            z: -60
          },
          {
            hole: 264,
            x: -45,
            y: 5,
            z: -67.75
          },
          {
            hole: 265,
            x: -45,
            y: 5,
            z: -75.5
          },
          {
            hole: 266,
            x: -45,
            y: 5,
            z: -84.5
          },
          {
            hole: 267,
            x: -45,
            y: 5,
            z: -92.25
          },
          {
            hole: 268,
            x: -45,
            y: 5,
            z: -100
          },
          {
            hole: 269,
            x: -45,
            y: 5,
            z: -107.75
          },
          {
            hole: 270,
            x: -45,
            y: 5,
            z: -115.5
          },
          {
            hole: 271,
            x: -45,
            y: 5,
            z: -124.5
          },
          {
            hole: 272,
            x: -45,
            y: 5,
            z: -132.25
          },
          {
            hole: 273,
            x: -45,
            y: 5,
            z: -140
          },
          {
            hole: 274,
            x: -45,
            y: 5,
            z: -147.75
          },
          {
            hole: 275,
            x: -45,
            y: 5,
            z: -155.5
          },
          {
            hole: 276,
            x: -45,
            y: 5,
            z: -164.5
          },
          {
            hole: 277,
            x: -45,
            y: 5,
            z: -172.25
          },
          {
            hole: 278,
            x: -45,
            y: 5,
            z: -180
          },
          {
            hole: 279,
            x: -45,
            y: 5,
            z: -187.75
          },
          {
            hole: 280,
            x: -45,
            y: 5,
            z: -195.5
          },
          {
            hole: 281,
            x: -45,
            y: 5,
            z: -204.5
          },
          {
            hole: 282,
            x: -45,
            y: 5,
            z: -212.25
          },
          {
            hole: 283,
            x: -45,
            y: 5,
            z: -220
          },
          {
            hole: 284,
            x: -45,
            y: 5,
            z: -227.75
          },
          {
            hole: 285,
            x: -45,
            y: 5,
            z: -235.5
          },
          {
            hole: 286,
            x: -45,
            y: 5,
            z: -244.5
          },
          {
            hole: 287,
            x: -45,
            y: 5,
            z: -252.25
          },
          {
            hole: 288,
            x: -45,
            y: 5,
            z: -260
          },
          {
            hole: 289,
            x: -45,
            y: 5,
            z: -267.75
          },
          {
            hole: 290,
            x: -45,
            y: 5,
            z: -275.5
          },
          {
            hole: 291,
            x: -46.1926,
            y: 5,
            z: -289.0587
          },
          {
            hole: 292,
            x: -49.6891,
            y: 5,
            z: -297.5
          },
          {
            hole: 293,
            x: -55.2513,
            y: 5,
            z: -304.7487
          },
          {
            hole: 294,
            x: -62.5,
            y: 5,
            z: -310.3109
          },
          {
            hole: 295,
            x: -70.9413,
            y: 5,
            z: -313.8074
          },
          {
            hole: 296,
            x: -89.0587,
            y: 5,
            z: -313.8074
          },
          {
            hole: 297,
            x: -97.5,
            y: 5,
            z: -310.3109
          },
          {
            hole: 298,
            x: -104.7487,
            y: 5,
            z: -304.7487
          },
          {
            hole: 299,
            x: -110.3109,
            y: 5,
            z: -297.5
          },
          {
            hole: 300,
            x: -113.8074,
            y: 5,
            z: -289.0587
          },
          {
            hole: 301,
            x: -115,
            y: 5,
            z: -275.5
          },
          {
            hole: 302,
            x: -115,
            y: 5,
            z: -267.75
          },
          {
            hole: 303,
            x: -115,
            y: 5,
            z: -260
          },
          {
            hole: 304,
            x: -115,
            y: 5,
            z: -252.25
          },
          {
            hole: 305,
            x: -115,
            y: 5,
            z: -244.5
          },
          {
            hole: 306,
            x: -115,
            y: 5,
            z: -235.5
          },
          {
            hole: 307,
            x: -115,
            y: 5,
            z: -227.75
          },
          {
            hole: 308,
            x: -115,
            y: 5,
            z: -220
          },
          {
            hole: 309,
            x: -115,
            y: 5,
            z: -212.25
          },
          {
            hole: 310,
            x: -115,
            y: 5,
            z: -204.5
          },
          {
            hole: 311,
            x: -115,
            y: 5,
            z: -195.5
          },
          {
            hole: 312,
            x: -115,
            y: 5,
            z: -187.75
          },
          {
            hole: 313,
            x: -115,
            y: 5,
            z: -180
          },
          {
            hole: 314,
            x: -115,
            y: 5,
            z: -172.25
          },
          {
            hole: 315,
            x: -115,
            y: 5,
            z: -164.5
          },
          {
            hole: 316,
            x: -115,
            y: 5,
            z: -155.5
          },
          {
            hole: 317,
            x: -115,
            y: 5,
            z: -147.75
          },
          {
            hole: 318,
            x: -115,
            y: 5,
            z: -140
          },
          {
            hole: 319,
            x: -115,
            y: 5,
            z: -132.25
          },
          {
            hole: 320,
            x: -115,
            y: 5,
            z: -124.5
          },
          {
            hole: 321,
            x: -115,
            y: 5,
            z: -115.5
          },
          {
            hole: 322,
            x: -115,
            y: 5,
            z: -107.75
          },
          {
            hole: 323,
            x: -115,
            y: 5,
            z: -100
          },
          {
            hole: 324,
            x: -115,
            y: 5,
            z: -92.25
          },
          {
            hole: 325,
            x: -115,
            y: 5,
            z: -84.5
          },
          {
            hole: 326,
            x: -115,
            y: 5,
            z: -75.5
          },
          {
            hole: 327,
            x: -115,
            y: 5,
            z: -67.75
          },
          {
            hole: 328,
            x: -115,
            y: 5,
            z: -60
          },
          {
            hole: 329,
            x: -115,
            y: 5,
            z: -52.25
          },
          {
            hole: 330,
            x: -115,
            y: 5,
            z: -44.5
          },
          {
            hole: 331,
            x: -115,
            y: 5,
            z: -35.5
          },
          {
            hole: 332,
            x: -115,
            y: 5,
            z: -27.75
          },
          {
            hole: 333,
            x: -115,
            y: 5,
            z: -20
          },
          {
            hole: 334,
            x: -115,
            y: 5,
            z: -12.25
          },
          {
            hole: 335,
            x: -115,
            y: 5,
            z: -4.5
          },
          {
            hole: 336,
            x: -115,
            y: 5,
            z: 4.5
          },
          {
            hole: 337,
            x: -115,
            y: 5,
            z: 12.25
          },
          {
            hole: 338,
            x: -115,
            y: 5,
            z: 20
          },
          {
            hole: 339,
            x: -115,
            y: 5,
            z: 27.75
          },
          {
            hole: 340,
            x: -115,
            y: 5,
            z: 35.5
          },
          {
            hole: 341,
            x: -116.5333,
            y: 5,
            z: 51.6469
          },
          {
            hole: 342,
            x: -121.0289,
            y: 5,
            z: 62.5
          },
          {
            hole: 343,
            x: -128.1802,
            y: 5,
            z: 71.8198
          },
          {
            hole: 344,
            x: -137.5,
            y: 5,
            z: 78.9711
          },
          {
            hole: 345,
            x: -148.3531,
            y: 5,
            z: 83.4667
          },
          {
            hole: 346,
            x: -171.6469,
            y: 5,
            z: 83.4667
          },
          {
            hole: 347,
            x: -182.5,
            y: 5,
            z: 78.9711
          },
          {
            hole: 348,
            x: -191.8198,
            y: 5,
            z: 71.8198
          },
          {
            hole: 349,
            x: -198.9711,
            y: 5,
            z: 62.5
          },
          {
            hole: 350,
            x: -203.4667,
            y: 5,
            z: 51.6469
          },
          {
            hole: 351,
            x: -205,
            y: 5,
            z: 35.5
          },
          {
            hole: 352,
            x: -205,
            y: 5,
            z: 27.75
          },
          {
            hole: 353,
            x: -205,
            y: 5,
            z: 20
          },
          {
            hole: 354,
            x: -205,
            y: 5,
            z: 12.25
          },
          {
            hole: 355,
            x: -205,
            y: 5,
            z: 4.5
          },
          {
            hole: 356,
            x: -205,
            y: 5,
            z: -4.5
          },
          {
            hole: 357,
            x: -205,
            y: 5,
            z: -12.25
          },
          {
            hole: 358,
            x: -205,
            y: 5,
            z: -20
          },
          {
            hole: 359,
            x: -205,
            y: 5,
            z: -27.75
          },
          {
            hole: 360,
            x: -205,
            y: 5,
            z: -35.5
          },
          {
            hole: 361,
            x: -205,
            y: 5,
            z: -44.5
          },
          {
            hole: 362,
            x: -205,
            y: 5,
            z: -52.25
          },
          {
            hole: 363,
            x: -205,
            y: 5,
            z: -60
          },
          {
            hole: 364,
            x: -205,
            y: 5,
            z: -67.75
          },
          {
            hole: 365,
            x: -205,
            y: 5,
            z: -75.5
          },
          {
            hole: 366,
            x: -205,
            y: 5,
            z: -84.5
          },
          {
            hole: 367,
            x: -205,
            y: 5,
            z: -92.25
          },
          {
            hole: 368,
            x: -205,
            y: 5,
            z: -100
          },
          {
            hole: 369,
            x: -205,
            y: 5,
            z: -107.75
          },
          {
            hole: 370,
            x: -205,
            y: 5,
            z: -115.5
          },
          {
            hole: 371,
            x: -205,
            y: 5,
            z: -124.5
          },
          {
            hole: 372,
            x: -205,
            y: 5,
            z: -132.25
          },
          {
            hole: 373,
            x: -205,
            y: 5,
            z: -140
          },
          {
            hole: 374,
            x: -205,
            y: 5,
            z: -147.75
          },
          {
            hole: 375,
            x: -205,
            y: 5,
            z: -155.5
          },
          {
            hole: 376,
            x: -205,
            y: 5,
            z: -164.5
          },
          {
            hole: 377,
            x: -205,
            y: 5,
            z: -172.25
          },
          {
            hole: 378,
            x: -205,
            y: 5,
            z: -180
          },
          {
            hole: 379,
            x: -205,
            y: 5,
            z: -187.75
          },
          {
            hole: 380,
            x: -205,
            y: 5,
            z: -195.5
          },
          {
            hole: 381,
            x: -205,
            y: 5,
            z: -204.5
          },
          {
            hole: 382,
            x: -205,
            y: 5,
            z: -212.25
          },
          {
            hole: 383,
            x: -205,
            y: 5,
            z: -220
          },
          {
            hole: 384,
            x: -205,
            y: 5,
            z: -227.75
          },
          {
            hole: 385,
            x: -205,
            y: 5,
            z: -235.5
          },
          {
            hole: 386,
            x: -205,
            y: 5,
            z: -244.5
          },
          {
            hole: 387,
            x: -205,
            y: 5,
            z: -252.25
          },
          {
            hole: 388,
            x: -205,
            y: 5,
            z: -260
          },
          {
            hole: 389,
            x: -205,
            y: 5,
            z: -267.75
          },
          {
            hole: 390,
            x: -205,
            y: 5,
            z: -275.5
          },
          {
            hole: 391,
            x: -206.1926,
            y: 5,
            z: -289.0587
          },
          {
            hole: 392,
            x: -209.6891,
            y: 5,
            z: -297.5
          },
          {
            hole: 393,
            x: -215.2513,
            y: 5,
            z: -304.7487
          },
          {
            hole: 394,
            x: -222.5,
            y: 5,
            z: -310.3109
          },
          {
            hole: 395,
            x: -230.9413,
            y: 5,
            z: -313.8074
          },
          {
            hole: 396,
            x: -249.0587,
            y: 5,
            z: -313.8074
          },
          {
            hole: 397,
            x: -257.5,
            y: 5,
            z: -310.3109
          },
          {
            hole: 398,
            x: -264.7487,
            y: 5,
            z: -304.7487
          },
          {
            hole: 399,
            x: -270.3109,
            y: 5,
            z: -297.5
          },
          {
            hole: 400,
            x: -273.8074,
            y: 5,
            z: -289.0587
          },
          {
            hole: 401,
            x: -275,
            y: 5,
            z: -275.5
          },
          {
            hole: 402,
            x: -275,
            y: 5,
            z: -267.75
          },
          {
            hole: 403,
            x: -275,
            y: 5,
            z: -260
          },
          {
            hole: 404,
            x: -275,
            y: 5,
            z: -252.25
          },
          {
            hole: 405,
            x: -275,
            y: 5,
            z: -244.5
          },
          {
            hole: 406,
            x: -275,
            y: 5,
            z: -235.5
          },
          {
            hole: 407,
            x: -275,
            y: 5,
            z: -227.75
          },
          {
            hole: 408,
            x: -275,
            y: 5,
            z: -220
          },
          {
            hole: 409,
            x: -275,
            y: 5,
            z: -212.25
          },
          {
            hole: 410,
            x: -275,
            y: 5,
            z: -204.5
          },
          {
            hole: 411,
            x: -275,
            y: 5,
            z: -195.5
          },
          {
            hole: 412,
            x: -275,
            y: 5,
            z: -187.75
          },
          {
            hole: 413,
            x: -275,
            y: 5,
            z: -180
          },
          {
            hole: 414,
            x: -275,
            y: 5,
            z: -172.25
          },
          {
            hole: 415,
            x: -275,
            y: 5,
            z: -164.5
          },
          {
            hole: 416,
            x: -275,
            y: 5,
            z: -155.5
          },
          {
            hole: 417,
            x: -275,
            y: 5,
            z: -147.75
          },
          {
            hole: 418,
            x: -275,
            y: 5,
            z: -140
          },
          {
            hole: 419,
            x: -275,
            y: 5,
            z: -132.25
          },
          {
            hole: 420,
            x: -275,
            y: 5,
            z: -124.5
          },
          {
            hole: 421,
            x: -275,
            y: 5,
            z: -115.5
          },
          {
            hole: 422,
            x: -275,
            y: 5,
            z: -107.75
          },
          {
            hole: 423,
            x: -275,
            y: 5,
            z: -100
          },
          {
            hole: 424,
            x: -275,
            y: 5,
            z: -92.25
          },
          {
            hole: 425,
            x: -275,
            y: 5,
            z: -84.5
          },
          {
            hole: 426,
            x: -275,
            y: 5,
            z: -75.5
          },
          {
            hole: 427,
            x: -275,
            y: 5,
            z: -67.75
          },
          {
            hole: 428,
            x: -275,
            y: 5,
            z: -60
          },
          {
            hole: 429,
            x: -275,
            y: 5,
            z: -52.25
          },
          {
            hole: 430,
            x: -275,
            y: 5,
            z: -44.5
          },
          {
            hole: 431,
            x: -275,
            y: 5,
            z: -35.5
          },
          {
            hole: 432,
            x: -275,
            y: 5,
            z: -27.75
          },
          {
            hole: 433,
            x: -275,
            y: 5,
            z: -20
          },
          {
            hole: 434,
            x: -275,
            y: 5,
            z: -12.25
          },
          {
            hole: 435,
            x: -275,
            y: 5,
            z: -4.5
          },
          {
            hole: 436,
            x: -275,
            y: 5,
            z: 4.5
          },
          {
            hole: 437,
            x: -275,
            y: 5,
            z: 12.25
          },
          {
            hole: 438,
            x: -275,
            y: 5,
            z: 20
          },
          {
            hole: 439,
            x: -275,
            y: 5,
            z: 27.75
          },
          {
            hole: 440,
            x: -275,
            y: 5,
            z: 35.5
          },
          {
            hole: 441,
            x: -275,
            y: 5,
            z: 44.5
          },
          {
            hole: 442,
            x: -275,
            y: 5,
            z: 52.25
          },
          {
            hole: 443,
            x: -275,
            y: 5,
            z: 60
          },
          {
            hole: 444,
            x: -275,
            y: 5,
            z: 67.75
          },
          {
            hole: 445,
            x: -275,
            y: 5,
            z: 75.5
          },
          {
            hole: 446,
            x: -275,
            y: 5,
            z: 84.5
          },
          {
            hole: 447,
            x: -275,
            y: 5,
            z: 92.25
          },
          {
            hole: 448,
            x: -275,
            y: 5,
            z: 100
          },
          {
            hole: 449,
            x: -275,
            y: 5,
            z: 107.75
          },
          {
            hole: 450,
            x: -275,
            y: 5,
            z: 115.5
          },
          {
            hole: 451,
            x: -273.8074,
            y: 5,
            z: 129.0587
          },
          {
            hole: 452,
            x: -270.3109,
            y: 5,
            z: 137.5
          },
          {
            hole: 453,
            x: -264.7487,
            y: 5,
            z: 144.7487
          },
          {
            hole: 454,
            x: -257.5,
            y: 5,
            z: 150.3109
          },
          {
            hole: 455,
            x: -249.0587,
            y: 5,
            z: 153.8074
          },
          {
            hole: 456,
            x: -235.5,
            y: 5,
            z: 155
          },
          {
            hole: 457,
            x: -227.75,
            y: 5,
            z: 155
          },
          {
            hole: 458,
            x: -220,
            y: 5,
            z: 155
          },
          {
            hole: 459,
            x: -212.25,
            y: 5,
            z: 155
          },
          {
            hole: 460,
            x: -204.5,
            y: 5,
            z: 155
          },
          {
            hole: 461,
            x: -195.5,
            y: 5,
            z: 155
          },
          {
            hole: 462,
            x: -187.75,
            y: 5,
            z: 155
          },
          {
            hole: 463,
            x: -180,
            y: 5,
            z: 155
          },
          {
            hole: 464,
            x: -172.25,
            y: 5,
            z: 155
          },
          {
            hole: 465,
            x: -164.5,
            y: 5,
            z: 155
          },
          {
            hole: 466,
            x: -155.5,
            y: 5,
            z: 155
          },
          {
            hole: 467,
            x: -147.75,
            y: 5,
            z: 155
          },
          {
            hole: 468,
            x: -140,
            y: 5,
            z: 155
          },
          {
            hole: 469,
            x: -132.25,
            y: 5,
            z: 155
          },
          {
            hole: 470,
            x: -124.5,
            y: 5,
            z: 155
          },
          {
            hole: 471,
            x: -115.5,
            y: 5,
            z: 155
          },
          {
            hole: 472,
            x: -107.75,
            y: 5,
            z: 155
          },
          {
            hole: 473,
            x: -100,
            y: 5,
            z: 155
          },
          {
            hole: 474,
            x: -92.25,
            y: 5,
            z: 155
          },
          {
            hole: 475,
            x: -84.5,
            y: 5,
            z: 155
          },
          {
            hole: 476,
            x: -75.5,
            y: 5,
            z: 155
          },
          {
            hole: 477,
            x: -67.75,
            y: 5,
            z: 155
          },
          {
            hole: 478,
            x: -60,
            y: 5,
            z: 155
          },
          {
            hole: 479,
            x: -52.25,
            y: 5,
            z: 155
          },
          {
            hole: 480,
            x: -44.5,
            y: 5,
            z: 155
          },
          {
            hole: 481,
            x: -20,
            y: 5,
            z: 160
          }
        ],
        p4: [
          {
            hole: 0,
            x: 13,
            y: 5,
            z: 145
          },
          {
            hole: 1,
            x: 44.5,
            y: 5,
            z: 145
          },
          {
            hole: 2,
            x: 52.25,
            y: 5,
            z: 145
          },
          {
            hole: 3,
            x: 60,
            y: 5,
            z: 145
          },
          {
            hole: 4,
            x: 67.75,
            y: 5,
            z: 145
          },
          {
            hole: 5,
            x: 75.5,
            y: 5,
            z: 145
          },
          {
            hole: 6,
            x: 84.5,
            y: 5,
            z: 145
          },
          {
            hole: 7,
            x: 92.25,
            y: 5,
            z: 145
          },
          {
            hole: 8,
            x: 100,
            y: 5,
            z: 145
          },
          {
            hole: 9,
            x: 107.75,
            y: 5,
            z: 145
          },
          {
            hole: 10,
            x: 115.5,
            y: 5,
            z: 145
          },
          {
            hole: 11,
            x: 124.5,
            y: 5,
            z: 145
          },
          {
            hole: 12,
            x: 132.25,
            y: 5,
            z: 145
          },
          {
            hole: 13,
            x: 140,
            y: 5,
            z: 145
          },
          {
            hole: 14,
            x: 147.75,
            y: 5,
            z: 145
          },
          {
            hole: 15,
            x: 155.5,
            y: 5,
            z: 145
          },
          {
            hole: 16,
            x: 164.5,
            y: 5,
            z: 145
          },
          {
            hole: 17,
            x: 172.25,
            y: 5,
            z: 145
          },
          {
            hole: 18,
            x: 180,
            y: 5,
            z: 145
          },
          {
            hole: 19,
            x: 187.75,
            y: 5,
            z: 145
          },
          {
            hole: 20,
            x: 195.5,
            y: 5,
            z: 145
          },
          {
            hole: 21,
            x: 204.5,
            y: 5,
            z: 145
          },
          {
            hole: 22,
            x: 212.25,
            y: 5,
            z: 145
          },
          {
            hole: 23,
            x: 220,
            y: 5,
            z: 145
          },
          {
            hole: 24,
            x: 227.75,
            y: 5,
            z: 145
          },
          {
            hole: 25,
            x: 235.5,
            y: 5,
            z: 145
          },
          {
            hole: 26,
            x: 246.4705,
            y: 5,
            z: 144.1481
          },
          {
            hole: 27,
            x: 252.5,
            y: 5,
            z: 141.6506
          },
          {
            hole: 28,
            x: 257.6777,
            y: 5,
            z: 137.6777
          },
          {
            hole: 29,
            x: 261.6506,
            y: 5,
            z: 132.5
          },
          {
            hole: 30,
            x: 264.1481,
            y: 5,
            z: 126.4705
          },
          {
            hole: 31,
            x: 265,
            y: 5,
            z: 115.5
          },
          {
            hole: 32,
            x: 265,
            y: 5,
            z: 107.75
          },
          {
            hole: 33,
            x: 265,
            y: 5,
            z: 100
          },
          {
            hole: 34,
            x: 265,
            y: 5,
            z: 92.25
          },
          {
            hole: 35,
            x: 265,
            y: 5,
            z: 84.5
          },
          {
            hole: 36,
            x: 265,
            y: 5,
            z: 75.5
          },
          {
            hole: 37,
            x: 265,
            y: 5,
            z: 67.75
          },
          {
            hole: 38,
            x: 265,
            y: 5,
            z: 60
          },
          {
            hole: 39,
            x: 265,
            y: 5,
            z: 52.25
          },
          {
            hole: 40,
            x: 265,
            y: 5,
            z: 44.5
          },
          {
            hole: 41,
            x: 265,
            y: 5,
            z: 35.5
          },
          {
            hole: 42,
            x: 265,
            y: 5,
            z: 27.75
          },
          {
            hole: 43,
            x: 265,
            y: 5,
            z: 20
          },
          {
            hole: 44,
            x: 265,
            y: 5,
            z: 12.25
          },
          {
            hole: 45,
            x: 265,
            y: 5,
            z: 4.5
          },
          {
            hole: 46,
            x: 265,
            y: 5,
            z: -4.5
          },
          {
            hole: 47,
            x: 265,
            y: 5,
            z: -12.25
          },
          {
            hole: 48,
            x: 265,
            y: 5,
            z: -20
          },
          {
            hole: 49,
            x: 265,
            y: 5,
            z: -27.75
          },
          {
            hole: 50,
            x: 265,
            y: 5,
            z: -35.5
          },
          {
            hole: 51,
            x: 265,
            y: 5,
            z: -44.5
          },
          {
            hole: 52,
            x: 265,
            y: 5,
            z: -52.25
          },
          {
            hole: 53,
            x: 265,
            y: 5,
            z: -60
          },
          {
            hole: 54,
            x: 265,
            y: 5,
            z: -67.75
          },
          {
            hole: 55,
            x: 265,
            y: 5,
            z: -75.5
          },
          {
            hole: 56,
            x: 265,
            y: 5,
            z: -84.5
          },
          {
            hole: 57,
            x: 265,
            y: 5,
            z: -92.25
          },
          {
            hole: 58,
            x: 265,
            y: 5,
            z: -100
          },
          {
            hole: 59,
            x: 265,
            y: 5,
            z: -107.75
          },
          {
            hole: 60,
            x: 265,
            y: 5,
            z: -115.5
          },
          {
            hole: 61,
            x: 265,
            y: 5,
            z: -124.5
          },
          {
            hole: 62,
            x: 265,
            y: 5,
            z: -132.25
          },
          {
            hole: 63,
            x: 265,
            y: 5,
            z: -140
          },
          {
            hole: 64,
            x: 265,
            y: 5,
            z: -147.75
          },
          {
            hole: 65,
            x: 265,
            y: 5,
            z: -155.5
          },
          {
            hole: 66,
            x: 265,
            y: 5,
            z: -164.5
          },
          {
            hole: 67,
            x: 265,
            y: 5,
            z: -172.25
          },
          {
            hole: 68,
            x: 265,
            y: 5,
            z: -180
          },
          {
            hole: 69,
            x: 265,
            y: 5,
            z: -187.75
          },
          {
            hole: 70,
            x: 265,
            y: 5,
            z: -195.5
          },
          {
            hole: 71,
            x: 265,
            y: 5,
            z: -204.5
          },
          {
            hole: 72,
            x: 265,
            y: 5,
            z: -212.25
          },
          {
            hole: 73,
            x: 265,
            y: 5,
            z: -220
          },
          {
            hole: 74,
            x: 265,
            y: 5,
            z: -227.75
          },
          {
            hole: 75,
            x: 265,
            y: 5,
            z: -235.5
          },
          {
            hole: 76,
            x: 265,
            y: 5,
            z: -244.5
          },
          {
            hole: 77,
            x: 265,
            y: 5,
            z: -252.25
          },
          {
            hole: 78,
            x: 265,
            y: 5,
            z: -260
          },
          {
            hole: 79,
            x: 265,
            y: 5,
            z: -267.75
          },
          {
            hole: 80,
            x: 265,
            y: 5,
            z: -275.5
          },
          {
            hole: 81,
            x: 264.1481,
            y: 5,
            z: -286.4705
          },
          {
            hole: 82,
            x: 261.6506,
            y: 5,
            z: -292.5
          },
          {
            hole: 83,
            x: 257.6777,
            y: 5,
            z: -297.6777
          },
          {
            hole: 84,
            x: 252.5,
            y: 5,
            z: -301.6506
          },
          {
            hole: 85,
            x: 246.4705,
            y: 5,
            z: -304.1481
          },
          {
            hole: 86,
            x: 233.5295,
            y: 5,
            z: -304.1481
          },
          {
            hole: 87,
            x: 227.5,
            y: 5,
            z: -301.6506
          },
          {
            hole: 88,
            x: 222.3223,
            y: 5,
            z: -297.6777
          },
          {
            hole: 89,
            x: 218.3494,
            y: 5,
            z: -292.5
          },
          {
            hole: 90,
            x: 215.8519,
            y: 5,
            z: -286.4705
          },
          {
            hole: 91,
            x: 215,
            y: 5,
            z: -275.5
          },
          {
            hole: 92,
            x: 215,
            y: 5,
            z: -267.75
          },
          {
            hole: 93,
            x: 215,
            y: 5,
            z: -260
          },
          {
            hole: 94,
            x: 215,
            y: 5,
            z: -252.25
          },
          {
            hole: 95,
            x: 215,
            y: 5,
            z: -244.5
          },
          {
            hole: 96,
            x: 215,
            y: 5,
            z: -235.5
          },
          {
            hole: 97,
            x: 215,
            y: 5,
            z: -227.75
          },
          {
            hole: 98,
            x: 215,
            y: 5,
            z: -220
          },
          {
            hole: 99,
            x: 215,
            y: 5,
            z: -212.25
          },
          {
            hole: 100,
            x: 215,
            y: 5,
            z: -204.5
          },
          {
            hole: 101,
            x: 215,
            y: 5,
            z: -195.5
          },
          {
            hole: 102,
            x: 215,
            y: 5,
            z: -187.75
          },
          {
            hole: 103,
            x: 215,
            y: 5,
            z: -180
          },
          {
            hole: 104,
            x: 215,
            y: 5,
            z: -172.25
          },
          {
            hole: 105,
            x: 215,
            y: 5,
            z: -164.5
          },
          {
            hole: 106,
            x: 215,
            y: 5,
            z: -155.5
          },
          {
            hole: 107,
            x: 215,
            y: 5,
            z: -147.75
          },
          {
            hole: 108,
            x: 215,
            y: 5,
            z: -140
          },
          {
            hole: 109,
            x: 215,
            y: 5,
            z: -132.25
          },
          {
            hole: 110,
            x: 215,
            y: 5,
            z: -124.5
          },
          {
            hole: 111,
            x: 215,
            y: 5,
            z: -115.5
          },
          {
            hole: 112,
            x: 215,
            y: 5,
            z: -107.75
          },
          {
            hole: 113,
            x: 215,
            y: 5,
            z: -100
          },
          {
            hole: 114,
            x: 215,
            y: 5,
            z: -92.25
          },
          {
            hole: 115,
            x: 215,
            y: 5,
            z: -84.5
          },
          {
            hole: 116,
            x: 215,
            y: 5,
            z: -75.5
          },
          {
            hole: 117,
            x: 215,
            y: 5,
            z: -67.75
          },
          {
            hole: 118,
            x: 215,
            y: 5,
            z: -60
          },
          {
            hole: 119,
            x: 215,
            y: 5,
            z: -52.25
          },
          {
            hole: 120,
            x: 215,
            y: 5,
            z: -44.5
          },
          {
            hole: 121,
            x: 215,
            y: 5,
            z: -35.5
          },
          {
            hole: 122,
            x: 215,
            y: 5,
            z: -27.75
          },
          {
            hole: 123,
            x: 215,
            y: 5,
            z: -20
          },
          {
            hole: 124,
            x: 215,
            y: 5,
            z: -12.25
          },
          {
            hole: 125,
            x: 215,
            y: 5,
            z: -4.5
          },
          {
            hole: 126,
            x: 215,
            y: 5,
            z: 4.5
          },
          {
            hole: 127,
            x: 215,
            y: 5,
            z: 12.25
          },
          {
            hole: 128,
            x: 215,
            y: 5,
            z: 20
          },
          {
            hole: 129,
            x: 215,
            y: 5,
            z: 27.75
          },
          {
            hole: 130,
            x: 215,
            y: 5,
            z: 35.5
          },
          {
            hole: 131,
            x: 213.1259,
            y: 5,
            z: 54.235
          },
          {
            hole: 132,
            x: 207.6314,
            y: 5,
            z: 67.5
          },
          {
            hole: 133,
            x: 198.8909,
            y: 5,
            z: 78.8909
          },
          {
            hole: 134,
            x: 187.5,
            y: 5,
            z: 87.6314
          },
          {
            hole: 135,
            x: 174.235,
            y: 5,
            z: 93.1259
          },
          {
            hole: 136,
            x: 145.765,
            y: 5,
            z: 93.1259
          },
          {
            hole: 137,
            x: 132.5,
            y: 5,
            z: 87.6314
          },
          {
            hole: 138,
            x: 121.1091,
            y: 5,
            z: 78.8909
          },
          {
            hole: 139,
            x: 112.3686,
            y: 5,
            z: 67.5
          },
          {
            hole: 140,
            x: 106.8741,
            y: 5,
            z: 54.235
          },
          {
            hole: 141,
            x: 105,
            y: 5,
            z: 35.5
          },
          {
            hole: 142,
            x: 105,
            y: 5,
            z: 27.75
          },
          {
            hole: 143,
            x: 105,
            y: 5,
            z: 20
          },
          {
            hole: 144,
            x: 105,
            y: 5,
            z: 12.25
          },
          {
            hole: 145,
            x: 105,
            y: 5,
            z: 4.5
          },
          {
            hole: 146,
            x: 105,
            y: 5,
            z: -4.5
          },
          {
            hole: 147,
            x: 105,
            y: 5,
            z: -12.25
          },
          {
            hole: 148,
            x: 105,
            y: 5,
            z: -20
          },
          {
            hole: 149,
            x: 105,
            y: 5,
            z: -27.75
          },
          {
            hole: 150,
            x: 105,
            y: 5,
            z: -35.5
          },
          {
            hole: 151,
            x: 105,
            y: 5,
            z: -44.5
          },
          {
            hole: 152,
            x: 105,
            y: 5,
            z: -52.25
          },
          {
            hole: 153,
            x: 105,
            y: 5,
            z: -60
          },
          {
            hole: 154,
            x: 105,
            y: 5,
            z: -67.75
          },
          {
            hole: 155,
            x: 105,
            y: 5,
            z: -75.5
          },
          {
            hole: 156,
            x: 105,
            y: 5,
            z: -84.5
          },
          {
            hole: 157,
            x: 105,
            y: 5,
            z: -92.25
          },
          {
            hole: 158,
            x: 105,
            y: 5,
            z: -100
          },
          {
            hole: 159,
            x: 105,
            y: 5,
            z: -107.75
          },
          {
            hole: 160,
            x: 105,
            y: 5,
            z: -115.5
          },
          {
            hole: 161,
            x: 105,
            y: 5,
            z: -124.5
          },
          {
            hole: 162,
            x: 105,
            y: 5,
            z: -132.25
          },
          {
            hole: 163,
            x: 105,
            y: 5,
            z: -140
          },
          {
            hole: 164,
            x: 105,
            y: 5,
            z: -147.75
          },
          {
            hole: 165,
            x: 105,
            y: 5,
            z: -155.5
          },
          {
            hole: 166,
            x: 105,
            y: 5,
            z: -164.5
          },
          {
            hole: 167,
            x: 105,
            y: 5,
            z: -172.25
          },
          {
            hole: 168,
            x: 105,
            y: 5,
            z: -180
          },
          {
            hole: 169,
            x: 105,
            y: 5,
            z: -187.75
          },
          {
            hole: 170,
            x: 105,
            y: 5,
            z: -195.5
          },
          {
            hole: 171,
            x: 105,
            y: 5,
            z: -204.5
          },
          {
            hole: 172,
            x: 105,
            y: 5,
            z: -212.25
          },
          {
            hole: 173,
            x: 105,
            y: 5,
            z: -220
          },
          {
            hole: 174,
            x: 105,
            y: 5,
            z: -227.75
          },
          {
            hole: 175,
            x: 105,
            y: 5,
            z: -235.5
          },
          {
            hole: 176,
            x: 105,
            y: 5,
            z: -244.5
          },
          {
            hole: 177,
            x: 105,
            y: 5,
            z: -252.25
          },
          {
            hole: 178,
            x: 105,
            y: 5,
            z: -260
          },
          {
            hole: 179,
            x: 105,
            y: 5,
            z: -267.75
          },
          {
            hole: 180,
            x: 105,
            y: 5,
            z: -275.5
          },
          {
            hole: 181,
            x: 104.1481,
            y: 5,
            z: -286.4705
          },
          {
            hole: 182,
            x: 101.6506,
            y: 5,
            z: -292.5
          },
          {
            hole: 183,
            x: 97.6777,
            y: 5,
            z: -297.6777
          },
          {
            hole: 184,
            x: 92.5,
            y: 5,
            z: -301.6506
          },
          {
            hole: 185,
            x: 86.4705,
            y: 5,
            z: -304.1481
          },
          {
            hole: 186,
            x: 73.5295,
            y: 5,
            z: -304.1481
          },
          {
            hole: 187,
            x: 67.5,
            y: 5,
            z: -301.6506
          },
          {
            hole: 188,
            x: 62.3223,
            y: 5,
            z: -297.6777
          },
          {
            hole: 189,
            x: 58.3494,
            y: 5,
            z: -292.5
          },
          {
            hole: 190,
            x: 55.8519,
            y: 5,
            z: -286.4705
          },
          {
            hole: 191,
            x: 55,
            y: 5,
            z: -275.5
          },
          {
            hole: 192,
            x: 55,
            y: 5,
            z: -267.75
          },
          {
            hole: 193,
            x: 55,
            y: 5,
            z: -260
          },
          {
            hole: 194,
            x: 55,
            y: 5,
            z: -252.25
          },
          {
            hole: 195,
            x: 55,
            y: 5,
            z: -244.5
          },
          {
            hole: 196,
            x: 55,
            y: 5,
            z: -235.5
          },
          {
            hole: 197,
            x: 55,
            y: 5,
            z: -227.75
          },
          {
            hole: 198,
            x: 55,
            y: 5,
            z: -220
          },
          {
            hole: 199,
            x: 55,
            y: 5,
            z: -212.25
          },
          {
            hole: 200,
            x: 55,
            y: 5,
            z: -204.5
          },
          {
            hole: 201,
            x: 55,
            y: 5,
            z: -195.5
          },
          {
            hole: 202,
            x: 55,
            y: 5,
            z: -187.75
          },
          {
            hole: 203,
            x: 55,
            y: 5,
            z: -180
          },
          {
            hole: 204,
            x: 55,
            y: 5,
            z: -172.25
          },
          {
            hole: 205,
            x: 55,
            y: 5,
            z: -164.5
          },
          {
            hole: 206,
            x: 55,
            y: 5,
            z: -155.5
          },
          {
            hole: 207,
            x: 55,
            y: 5,
            z: -147.75
          },
          {
            hole: 208,
            x: 55,
            y: 5,
            z: -140
          },
          {
            hole: 209,
            x: 55,
            y: 5,
            z: -132.25
          },
          {
            hole: 210,
            x: 55,
            y: 5,
            z: -124.5
          },
          {
            hole: 211,
            x: 55,
            y: 5,
            z: -115.5
          },
          {
            hole: 212,
            x: 55,
            y: 5,
            z: -107.75
          },
          {
            hole: 213,
            x: 55,
            y: 5,
            z: -100
          },
          {
            hole: 214,
            x: 55,
            y: 5,
            z: -92.25
          },
          {
            hole: 215,
            x: 55,
            y: 5,
            z: -84.5
          },
          {
            hole: 216,
            x: 55,
            y: 5,
            z: -75.5
          },
          {
            hole: 217,
            x: 55,
            y: 5,
            z: -67.75
          },
          {
            hole: 218,
            x: 55,
            y: 5,
            z: -60
          },
          {
            hole: 219,
            x: 55,
            y: 5,
            z: -52.25
          },
          {
            hole: 220,
            x: 55,
            y: 5,
            z: -44.5
          },
          {
            hole: 221,
            x: 55,
            y: 5,
            z: -35.5
          },
          {
            hole: 222,
            x: 55,
            y: 5,
            z: -27.75
          },
          {
            hole: 223,
            x: 55,
            y: 5,
            z: -20
          },
          {
            hole: 224,
            x: 55,
            y: 5,
            z: -12.25
          },
          {
            hole: 225,
            x: 55,
            y: 5,
            z: -4.5
          },
          {
            hole: 226,
            x: 55,
            y: 5,
            z: 4.5
          },
          {
            hole: 227,
            x: 55,
            y: 5,
            z: 12.25
          },
          {
            hole: 228,
            x: 55,
            y: 5,
            z: 20
          },
          {
            hole: 229,
            x: 55,
            y: 5,
            z: 27.75
          },
          {
            hole: 230,
            x: 55,
            y: 5,
            z: 35.5
          },
          {
            hole: 231,
            x: 55,
            y: 5,
            z: 44.5
          },
          {
            hole: 232,
            x: 55,
            y: 5,
            z: 52.25
          },
          {
            hole: 233,
            x: 55,
            y: 5,
            z: 60
          },
          {
            hole: 234,
            x: 55,
            y: 5,
            z: 67.75
          },
          {
            hole: 235,
            x: 55,
            y: 5,
            z: 75.5
          },
          {
            hole: 236,
            x: 53.1259,
            y: 5,
            z: 94.235
          },
          {
            hole: 237,
            x: 47.6314,
            y: 5,
            z: 107.5
          },
          {
            hole: 238,
            x: 38.8909,
            y: 5,
            z: 118.8909
          },
          {
            hole: 239,
            x: 27.5,
            y: 5,
            z: 127.6314
          },
          {
            hole: 240,
            x: 14.235,
            y: 5,
            z: 133.1259
          },
          {
            hole: 241,
            x: -14.235,
            y: 5,
            z: 133.1259
          },
          {
            hole: 242,
            x: -27.5,
            y: 5,
            z: 127.6314
          },
          {
            hole: 243,
            x: -38.8909,
            y: 5,
            z: 118.8909
          },
          {
            hole: 244,
            x: -47.6314,
            y: 5,
            z: 107.5
          },
          {
            hole: 245,
            x: -53.1259,
            y: 5,
            z: 94.235
          },
          {
            hole: 246,
            x: -55,
            y: 5,
            z: 75.5
          },
          {
            hole: 247,
            x: -55,
            y: 5,
            z: 67.75
          },
          {
            hole: 248,
            x: -55,
            y: 5,
            z: 60
          },
          {
            hole: 249,
            x: -55,
            y: 5,
            z: 52.25
          },
          {
            hole: 250,
            x: -55,
            y: 5,
            z: 44.5
          },
          {
            hole: 251,
            x: -55,
            y: 5,
            z: 35.5
          },
          {
            hole: 252,
            x: -55,
            y: 5,
            z: 27.75
          },
          {
            hole: 253,
            x: -55,
            y: 5,
            z: 20
          },
          {
            hole: 254,
            x: -55,
            y: 5,
            z: 12.25
          },
          {
            hole: 255,
            x: -55,
            y: 5,
            z: 4.5
          },
          {
            hole: 256,
            x: -55,
            y: 5,
            z: -4.5
          },
          {
            hole: 257,
            x: -55,
            y: 5,
            z: -12.25
          },
          {
            hole: 258,
            x: -55,
            y: 5,
            z: -20
          },
          {
            hole: 259,
            x: -55,
            y: 5,
            z: -27.75
          },
          {
            hole: 260,
            x: -55,
            y: 5,
            z: -35.5
          },
          {
            hole: 261,
            x: -55,
            y: 5,
            z: -44.5
          },
          {
            hole: 262,
            x: -55,
            y: 5,
            z: -52.25
          },
          {
            hole: 263,
            x: -55,
            y: 5,
            z: -60
          },
          {
            hole: 264,
            x: -55,
            y: 5,
            z: -67.75
          },
          {
            hole: 265,
            x: -55,
            y: 5,
            z: -75.5
          },
          {
            hole: 266,
            x: -55,
            y: 5,
            z: -84.5
          },
          {
            hole: 267,
            x: -55,
            y: 5,
            z: -92.25
          },
          {
            hole: 268,
            x: -55,
            y: 5,
            z: -100
          },
          {
            hole: 269,
            x: -55,
            y: 5,
            z: -107.75
          },
          {
            hole: 270,
            x: -55,
            y: 5,
            z: -115.5
          },
          {
            hole: 271,
            x: -55,
            y: 5,
            z: -124.5
          },
          {
            hole: 272,
            x: -55,
            y: 5,
            z: -132.25
          },
          {
            hole: 273,
            x: -55,
            y: 5,
            z: -140
          },
          {
            hole: 274,
            x: -55,
            y: 5,
            z: -147.75
          },
          {
            hole: 275,
            x: -55,
            y: 5,
            z: -155.5
          },
          {
            hole: 276,
            x: -55,
            y: 5,
            z: -164.5
          },
          {
            hole: 277,
            x: -55,
            y: 5,
            z: -172.25
          },
          {
            hole: 278,
            x: -55,
            y: 5,
            z: -180
          },
          {
            hole: 279,
            x: -55,
            y: 5,
            z: -187.75
          },
          {
            hole: 280,
            x: -55,
            y: 5,
            z: -195.5
          },
          {
            hole: 281,
            x: -55,
            y: 5,
            z: -204.5
          },
          {
            hole: 282,
            x: -55,
            y: 5,
            z: -212.25
          },
          {
            hole: 283,
            x: -55,
            y: 5,
            z: -220
          },
          {
            hole: 284,
            x: -55,
            y: 5,
            z: -227.75
          },
          {
            hole: 285,
            x: -55,
            y: 5,
            z: -235.5
          },
          {
            hole: 286,
            x: -55,
            y: 5,
            z: -244.5
          },
          {
            hole: 287,
            x: -55,
            y: 5,
            z: -252.25
          },
          {
            hole: 288,
            x: -55,
            y: 5,
            z: -260
          },
          {
            hole: 289,
            x: -55,
            y: 5,
            z: -267.75
          },
          {
            hole: 290,
            x: -55,
            y: 5,
            z: -275.5
          },
          {
            hole: 291,
            x: -55.8519,
            y: 5,
            z: -286.4705
          },
          {
            hole: 292,
            x: -58.3494,
            y: 5,
            z: -292.5
          },
          {
            hole: 293,
            x: -62.3223,
            y: 5,
            z: -297.6777
          },
          {
            hole: 294,
            x: -67.5,
            y: 5,
            z: -301.6506
          },
          {
            hole: 295,
            x: -73.5295,
            y: 5,
            z: -304.1481
          },
          {
            hole: 296,
            x: -86.4705,
            y: 5,
            z: -304.1481
          },
          {
            hole: 297,
            x: -92.5,
            y: 5,
            z: -301.6506
          },
          {
            hole: 298,
            x: -97.6777,
            y: 5,
            z: -297.6777
          },
          {
            hole: 299,
            x: -101.6506,
            y: 5,
            z: -292.5
          },
          {
            hole: 300,
            x: -104.1481,
            y: 5,
            z: -286.4705
          },
          {
            hole: 301,
            x: -105,
            y: 5,
            z: -275.5
          },
          {
            hole: 302,
            x: -105,
            y: 5,
            z: -267.75
          },
          {
            hole: 303,
            x: -105,
            y: 5,
            z: -260
          },
          {
            hole: 304,
            x: -105,
            y: 5,
            z: -252.25
          },
          {
            hole: 305,
            x: -105,
            y: 5,
            z: -244.5
          },
          {
            hole: 306,
            x: -105,
            y: 5,
            z: -235.5
          },
          {
            hole: 307,
            x: -105,
            y: 5,
            z: -227.75
          },
          {
            hole: 308,
            x: -105,
            y: 5,
            z: -220
          },
          {
            hole: 309,
            x: -105,
            y: 5,
            z: -212.25
          },
          {
            hole: 310,
            x: -105,
            y: 5,
            z: -204.5
          },
          {
            hole: 311,
            x: -105,
            y: 5,
            z: -195.5
          },
          {
            hole: 312,
            x: -105,
            y: 5,
            z: -187.75
          },
          {
            hole: 313,
            x: -105,
            y: 5,
            z: -180
          },
          {
            hole: 314,
            x: -105,
            y: 5,
            z: -172.25
          },
          {
            hole: 315,
            x: -105,
            y: 5,
            z: -164.5
          },
          {
            hole: 316,
            x: -105,
            y: 5,
            z: -155.5
          },
          {
            hole: 317,
            x: -105,
            y: 5,
            z: -147.75
          },
          {
            hole: 318,
            x: -105,
            y: 5,
            z: -140
          },
          {
            hole: 319,
            x: -105,
            y: 5,
            z: -132.25
          },
          {
            hole: 320,
            x: -105,
            y: 5,
            z: -124.5
          },
          {
            hole: 321,
            x: -105,
            y: 5,
            z: -115.5
          },
          {
            hole: 322,
            x: -105,
            y: 5,
            z: -107.75
          },
          {
            hole: 323,
            x: -105,
            y: 5,
            z: -100
          },
          {
            hole: 324,
            x: -105,
            y: 5,
            z: -92.25
          },
          {
            hole: 325,
            x: -105,
            y: 5,
            z: -84.5
          },
          {
            hole: 326,
            x: -105,
            y: 5,
            z: -75.5
          },
          {
            hole: 327,
            x: -105,
            y: 5,
            z: -67.75
          },
          {
            hole: 328,
            x: -105,
            y: 5,
            z: -60
          },
          {
            hole: 329,
            x: -105,
            y: 5,
            z: -52.25
          },
          {
            hole: 330,
            x: -105,
            y: 5,
            z: -44.5
          },
          {
            hole: 331,
            x: -105,
            y: 5,
            z: -35.5
          },
          {
            hole: 332,
            x: -105,
            y: 5,
            z: -27.75
          },
          {
            hole: 333,
            x: -105,
            y: 5,
            z: -20
          },
          {
            hole: 334,
            x: -105,
            y: 5,
            z: -12.25
          },
          {
            hole: 335,
            x: -105,
            y: 5,
            z: -4.5
          },
          {
            hole: 336,
            x: -105,
            y: 5,
            z: 4.5
          },
          {
            hole: 337,
            x: -105,
            y: 5,
            z: 12.25
          },
          {
            hole: 338,
            x: -105,
            y: 5,
            z: 20
          },
          {
            hole: 339,
            x: -105,
            y: 5,
            z: 27.75
          },
          {
            hole: 340,
            x: -105,
            y: 5,
            z: 35.5
          },
          {
            hole: 341,
            x: -106.8741,
            y: 5,
            z: 54.235
          },
          {
            hole: 342,
            x: -112.3686,
            y: 5,
            z: 67.5
          },
          {
            hole: 343,
            x: -121.1091,
            y: 5,
            z: 78.8909
          },
          {
            hole: 344,
            x: -132.5,
            y: 5,
            z: 87.6314
          },
          {
            hole: 345,
            x: -145.765,
            y: 5,
            z: 93.1259
          },
          {
            hole: 346,
            x: -174.235,
            y: 5,
            z: 93.1259
          },
          {
            hole: 347,
            x: -187.5,
            y: 5,
            z: 87.6314
          },
          {
            hole: 348,
            x: -198.8909,
            y: 5,
            z: 78.8909
          },
          {
            hole: 349,
            x: -207.6314,
            y: 5,
            z: 67.5
          },
          {
            hole: 350,
            x: -213.1259,
            y: 5,
            z: 54.235
          },
          {
            hole: 351,
            x: -215,
            y: 5,
            z: 35.5
          },
          {
            hole: 352,
            x: -215,
            y: 5,
            z: 27.75
          },
          {
            hole: 353,
            x: -215,
            y: 5,
            z: 20
          },
          {
            hole: 354,
            x: -215,
            y: 5,
            z: 12.25
          },
          {
            hole: 355,
            x: -215,
            y: 5,
            z: 4.5
          },
          {
            hole: 356,
            x: -215,
            y: 5,
            z: -4.5
          },
          {
            hole: 357,
            x: -215,
            y: 5,
            z: -12.25
          },
          {
            hole: 358,
            x: -215,
            y: 5,
            z: -20
          },
          {
            hole: 359,
            x: -215,
            y: 5,
            z: -27.75
          },
          {
            hole: 360,
            x: -215,
            y: 5,
            z: -35.5
          },
          {
            hole: 361,
            x: -215,
            y: 5,
            z: -44.5
          },
          {
            hole: 362,
            x: -215,
            y: 5,
            z: -52.25
          },
          {
            hole: 363,
            x: -215,
            y: 5,
            z: -60
          },
          {
            hole: 364,
            x: -215,
            y: 5,
            z: -67.75
          },
          {
            hole: 365,
            x: -215,
            y: 5,
            z: -75.5
          },
          {
            hole: 366,
            x: -215,
            y: 5,
            z: -84.5
          },
          {
            hole: 367,
            x: -215,
            y: 5,
            z: -92.25
          },
          {
            hole: 368,
            x: -215,
            y: 5,
            z: -100
          },
          {
            hole: 369,
            x: -215,
            y: 5,
            z: -107.75
          },
          {
            hole: 370,
            x: -215,
            y: 5,
            z: -115.5
          },
          {
            hole: 371,
            x: -215,
            y: 5,
            z: -124.5
          },
          {
            hole: 372,
            x: -215,
            y: 5,
            z: -132.25
          },
          {
            hole: 373,
            x: -215,
            y: 5,
            z: -140
          },
          {
            hole: 374,
            x: -215,
            y: 5,
            z: -147.75
          },
          {
            hole: 375,
            x: -215,
            y: 5,
            z: -155.5
          },
          {
            hole: 376,
            x: -215,
            y: 5,
            z: -164.5
          },
          {
            hole: 377,
            x: -215,
            y: 5,
            z: -172.25
          },
          {
            hole: 378,
            x: -215,
            y: 5,
            z: -180
          },
          {
            hole: 379,
            x: -215,
            y: 5,
            z: -187.75
          },
          {
            hole: 380,
            x: -215,
            y: 5,
            z: -195.5
          },
          {
            hole: 381,
            x: -215,
            y: 5,
            z: -204.5
          },
          {
            hole: 382,
            x: -215,
            y: 5,
            z: -212.25
          },
          {
            hole: 383,
            x: -215,
            y: 5,
            z: -220
          },
          {
            hole: 384,
            x: -215,
            y: 5,
            z: -227.75
          },
          {
            hole: 385,
            x: -215,
            y: 5,
            z: -235.5
          },
          {
            hole: 386,
            x: -215,
            y: 5,
            z: -244.5
          },
          {
            hole: 387,
            x: -215,
            y: 5,
            z: -252.25
          },
          {
            hole: 388,
            x: -215,
            y: 5,
            z: -260
          },
          {
            hole: 389,
            x: -215,
            y: 5,
            z: -267.75
          },
          {
            hole: 390,
            x: -215,
            y: 5,
            z: -275.5
          },
          {
            hole: 391,
            x: -215.8519,
            y: 5,
            z: -286.4705
          },
          {
            hole: 392,
            x: -218.3494,
            y: 5,
            z: -292.5
          },
          {
            hole: 393,
            x: -222.3223,
            y: 5,
            z: -297.6777
          },
          {
            hole: 394,
            x: -227.5,
            y: 5,
            z: -301.6506
          },
          {
            hole: 395,
            x: -233.5295,
            y: 5,
            z: -304.1481
          },
          {
            hole: 396,
            x: -246.4705,
            y: 5,
            z: -304.1481
          },
          {
            hole: 397,
            x: -252.5,
            y: 5,
            z: -301.6506
          },
          {
            hole: 398,
            x: -257.6777,
            y: 5,
            z: -297.6777
          },
          {
            hole: 399,
            x: -261.6506,
            y: 5,
            z: -292.5
          },
          {
            hole: 400,
            x: -264.1481,
            y: 5,
            z: -286.4705
          },
          {
            hole: 401,
            x: -265,
            y: 5,
            z: -275.5
          },
          {
            hole: 402,
            x: -265,
            y: 5,
            z: -267.75
          },
          {
            hole: 403,
            x: -265,
            y: 5,
            z: -260
          },
          {
            hole: 404,
            x: -265,
            y: 5,
            z: -252.25
          },
          {
            hole: 405,
            x: -265,
            y: 5,
            z: -244.5
          },
          {
            hole: 406,
            x: -265,
            y: 5,
            z: -235.5
          },
          {
            hole: 407,
            x: -265,
            y: 5,
            z: -227.75
          },
          {
            hole: 408,
            x: -265,
            y: 5,
            z: -220
          },
          {
            hole: 409,
            x: -265,
            y: 5,
            z: -212.25
          },
          {
            hole: 410,
            x: -265,
            y: 5,
            z: -204.5
          },
          {
            hole: 411,
            x: -265,
            y: 5,
            z: -195.5
          },
          {
            hole: 412,
            x: -265,
            y: 5,
            z: -187.75
          },
          {
            hole: 413,
            x: -265,
            y: 5,
            z: -180
          },
          {
            hole: 414,
            x: -265,
            y: 5,
            z: -172.25
          },
          {
            hole: 415,
            x: -265,
            y: 5,
            z: -164.5
          },
          {
            hole: 416,
            x: -265,
            y: 5,
            z: -155.5
          },
          {
            hole: 417,
            x: -265,
            y: 5,
            z: -147.75
          },
          {
            hole: 418,
            x: -265,
            y: 5,
            z: -140
          },
          {
            hole: 419,
            x: -265,
            y: 5,
            z: -132.25
          },
          {
            hole: 420,
            x: -265,
            y: 5,
            z: -124.5
          },
          {
            hole: 421,
            x: -265,
            y: 5,
            z: -115.5
          },
          {
            hole: 422,
            x: -265,
            y: 5,
            z: -107.75
          },
          {
            hole: 423,
            x: -265,
            y: 5,
            z: -100
          },
          {
            hole: 424,
            x: -265,
            y: 5,
            z: -92.25
          },
          {
            hole: 425,
            x: -265,
            y: 5,
            z: -84.5
          },
          {
            hole: 426,
            x: -265,
            y: 5,
            z: -75.5
          },
          {
            hole: 427,
            x: -265,
            y: 5,
            z: -67.75
          },
          {
            hole: 428,
            x: -265,
            y: 5,
            z: -60
          },
          {
            hole: 429,
            x: -265,
            y: 5,
            z: -52.25
          },
          {
            hole: 430,
            x: -265,
            y: 5,
            z: -44.5
          },
          {
            hole: 431,
            x: -265,
            y: 5,
            z: -35.5
          },
          {
            hole: 432,
            x: -265,
            y: 5,
            z: -27.75
          },
          {
            hole: 433,
            x: -265,
            y: 5,
            z: -20
          },
          {
            hole: 434,
            x: -265,
            y: 5,
            z: -12.25
          },
          {
            hole: 435,
            x: -265,
            y: 5,
            z: -4.5
          },
          {
            hole: 436,
            x: -265,
            y: 5,
            z: 4.5
          },
          {
            hole: 437,
            x: -265,
            y: 5,
            z: 12.25
          },
          {
            hole: 438,
            x: -265,
            y: 5,
            z: 20
          },
          {
            hole: 439,
            x: -265,
            y: 5,
            z: 27.75
          },
          {
            hole: 440,
            x: -265,
            y: 5,
            z: 35.5
          },
          {
            hole: 441,
            x: -265,
            y: 5,
            z: 44.5
          },
          {
            hole: 442,
            x: -265,
            y: 5,
            z: 52.25
          },
          {
            hole: 443,
            x: -265,
            y: 5,
            z: 60
          },
          {
            hole: 444,
            x: -265,
            y: 5,
            z: 67.75
          },
          {
            hole: 445,
            x: -265,
            y: 5,
            z: 75.5
          },
          {
            hole: 446,
            x: -265,
            y: 5,
            z: 84.5
          },
          {
            hole: 447,
            x: -265,
            y: 5,
            z: 92.25
          },
          {
            hole: 448,
            x: -265,
            y: 5,
            z: 100
          },
          {
            hole: 449,
            x: -265,
            y: 5,
            z: 107.75
          },
          {
            hole: 450,
            x: -265,
            y: 5,
            z: 115.5
          },
          {
            hole: 451,
            x: -264.1481,
            y: 5,
            z: 126.4705
          },
          {
            hole: 452,
            x: -261.6506,
            y: 5,
            z: 132.5
          },
          {
            hole: 453,
            x: -257.6777,
            y: 5,
            z: 137.6777
          },
          {
            hole: 454,
            x: -252.5,
            y: 5,
            z: 141.6506
          },
          {
            hole: 455,
            x: -246.4705,
            y: 5,
            z: 144.1481
          },
          {
            hole: 456,
            x: -235.5,
            y: 5,
            z: 145
          },
          {
            hole: 457,
            x: -227.75,
            y: 5,
            z: 145
          },
          {
            hole: 458,
            x: -220,
            y: 5,
            z: 145
          },
          {
            hole: 459,
            x: -212.25,
            y: 5,
            z: 145
          },
          {
            hole: 460,
            x: -204.5,
            y: 5,
            z: 145
          },
          {
            hole: 461,
            x: -195.5,
            y: 5,
            z: 145
          },
          {
            hole: 462,
            x: -187.75,
            y: 5,
            z: 145
          },
          {
            hole: 463,
            x: -180,
            y: 5,
            z: 145
          },
          {
            hole: 464,
            x: -172.25,
            y: 5,
            z: 145
          },
          {
            hole: 465,
            x: -164.5,
            y: 5,
            z: 145
          },
          {
            hole: 466,
            x: -155.5,
            y: 5,
            z: 145
          },
          {
            hole: 467,
            x: -147.75,
            y: 5,
            z: 145
          },
          {
            hole: 468,
            x: -140,
            y: 5,
            z: 145
          },
          {
            hole: 469,
            x: -132.25,
            y: 5,
            z: 145
          },
          {
            hole: 470,
            x: -124.5,
            y: 5,
            z: 145
          },
          {
            hole: 471,
            x: -115.5,
            y: 5,
            z: 145
          },
          {
            hole: 472,
            x: -107.75,
            y: 5,
            z: 145
          },
          {
            hole: 473,
            x: -100,
            y: 5,
            z: 145
          },
          {
            hole: 474,
            x: -92.25,
            y: 5,
            z: 145
          },
          {
            hole: 475,
            x: -84.5,
            y: 5,
            z: 145
          },
          {
            hole: 476,
            x: -75.5,
            y: 5,
            z: 145
          },
          {
            hole: 477,
            x: -67.75,
            y: 5,
            z: 145
          },
          {
            hole: 478,
            x: -60,
            y: 5,
            z: 145
          },
          {
            hole: 479,
            x: -52.25,
            y: 5,
            z: 145
          },
          {
            hole: 480,
            x: -44.5,
            y: 5,
            z: 145
          },
          {
            hole: 481,
            x: -20,
            y: 5,
            z: 160
          }
        ]
      }
    },
    {
      id: "board-spiral",
      name: "3D Spiral",
      brand: "crazy,pints,adult",
      desc: "3D Spiral cribbage board.",
      target: 121,
      trackCount: 2,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/spiral-thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/469cce6d4b1eeaac/spiral-board.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 35.7626,
            y: 5,
            z: 153.7339
          },
          {
            hole: 1,
            x: -44.9424,
            y: 5,
            z: 156.6635
          },
          {
            hole: 2,
            x: -94.9874,
            y: 5,
            z: 135.9342
          },
          {
            hole: 3,
            x: -137.9621,
            y: 5,
            z: 102.9585
          },
          {
            hole: 4,
            x: -170.9377,
            y: 5,
            z: 59.9839
          },
          {
            hole: 5,
            x: -191.667,
            y: 5,
            z: 9.9388
          },
          {
            hole: 6,
            x: -191.9226,
            y: 5,
            z: -95.5299
          },
          {
            hole: 7,
            x: -171.9425,
            y: 5,
            z: -143.7661
          },
          {
            hole: 8,
            x: -140.1588,
            y: 5,
            z: -185.1875
          },
          {
            hole: 9,
            x: -98.7374,
            y: 5,
            z: -216.9712
          },
          {
            hole: 10,
            x: -50.5013,
            y: 5,
            z: -236.9513
          },
          {
            hole: 11,
            x: 51.0852,
            y: 5,
            z: -237.2068
          },
          {
            hole: 12,
            x: 97.5126,
            y: 5,
            z: -217.976
          },
          {
            hole: 13,
            x: 137.3806,
            y: 5,
            z: -187.3842
          },
          {
            hole: 14,
            x: 167.9724,
            y: 5,
            z: -147.5161
          },
          {
            hole: 15,
            x: 187.2033,
            y: 5,
            z: -101.0888
          },
          {
            hole: 16,
            x: 187.4588,
            y: 5,
            z: -3.3846
          },
          {
            hole: 17,
            x: 168.9773,
            y: 5,
            z: 41.2339
          },
          {
            hole: 18,
            x: 139.5773,
            y: 5,
            z: 79.5486
          },
          {
            hole: 19,
            x: 101.2626,
            y: 5,
            z: 108.9486
          },
          {
            hole: 20,
            x: 56.6441,
            y: 5,
            z: 127.4302
          },
          {
            hole: 21,
            x: -37.1778,
            y: 15,
            z: 127.6857
          },
          {
            hole: 22,
            x: -79.9874,
            y: 15,
            z: 109.9534
          },
          {
            hole: 23,
            x: -116.7489,
            y: 15,
            z: 81.7453
          },
          {
            hole: 24,
            x: -144.9569,
            y: 15,
            z: 44.9839
          },
          {
            hole: 25,
            x: -162.6893,
            y: 15,
            z: 2.1743
          },
          {
            hole: 26,
            x: -162.9448,
            y: 15,
            z: -87.7654
          },
          {
            hole: 27,
            x: -145.9617,
            y: 15,
            z: -128.7661
          },
          {
            hole: 28,
            x: -118.9456,
            y: 15,
            z: -163.9743
          },
          {
            hole: 29,
            x: -83.7374,
            y: 15,
            z: -190.9904
          },
          {
            hole: 30,
            x: -42.7367,
            y: 15,
            z: -207.9735
          },
          {
            hole: 31,
            x: 43.3207,
            y: 15,
            z: -208.2291
          },
          {
            hole: 32,
            x: 82.5126,
            y: 15,
            z: -191.9952
          },
          {
            hole: 33,
            x: 116.1674,
            y: 15,
            z: -166.171
          },
          {
            hole: 34,
            x: 141.9917,
            y: 15,
            z: -132.5161
          },
          {
            hole: 35,
            x: 158.2255,
            y: 15,
            z: -93.3242
          },
          {
            hole: 36,
            x: 158.4811,
            y: 15,
            z: -11.1492
          },
          {
            hole: 37,
            x: 142.9965,
            y: 15,
            z: 26.2339
          },
          {
            hole: 38,
            x: 118.3641,
            y: 15,
            z: 58.3354
          },
          {
            hole: 39,
            x: 86.2626,
            y: 15,
            z: 82.9678
          },
          {
            hole: 40,
            x: 48.8795,
            y: 15,
            z: 98.4524
          },
          {
            hole: 41,
            x: -29.4132,
            y: 25,
            z: 98.7079
          },
          {
            hole: 42,
            x: -64.9874,
            y: 25,
            z: 83.9726
          },
          {
            hole: 43,
            x: -95.5357,
            y: 25,
            z: 60.5321
          },
          {
            hole: 44,
            x: -118.9762,
            y: 25,
            z: 29.9839
          },
          {
            hole: 45,
            x: -133.7115,
            y: 25,
            z: -5.5903
          },
          {
            hole: 46,
            x: -133.967,
            y: 25,
            z: -80.0008
          },
          {
            hole: 47,
            x: -119.981,
            y: 25,
            z: -113.7661
          },
          {
            hole: 48,
            x: -97.7324,
            y: 25,
            z: -142.7611
          },
          {
            hole: 49,
            x: -68.7374,
            y: 25,
            z: -165.0097
          },
          {
            hole: 50,
            x: -34.9721,
            y: 25,
            z: -178.9957
          },
          {
            hole: 51,
            x: 35.5561,
            y: 25,
            z: -179.2513
          },
          {
            hole: 52,
            x: 67.5126,
            y: 25,
            z: -166.0145
          },
          {
            hole: 53,
            x: 94.9542,
            y: 25,
            z: -144.9578
          },
          {
            hole: 54,
            x: 116.0109,
            y: 25,
            z: -117.5161
          },
          {
            hole: 55,
            x: 129.2477,
            y: 25,
            z: -85.5596
          },
          {
            hole: 56,
            x: 129.5033,
            y: 25,
            z: -18.9137
          },
          {
            hole: 57,
            x: 117.0157,
            y: 25,
            z: 11.2339
          },
          {
            hole: 58,
            x: 97.1509,
            y: 25,
            z: 37.1222
          },
          {
            hole: 59,
            x: 71.2626,
            y: 25,
            z: 56.9871
          },
          {
            hole: 60,
            x: 41.1149,
            y: 25,
            z: 69.4746
          },
          {
            hole: 61,
            x: -21.6487,
            y: 35,
            z: 69.7302
          },
          {
            hole: 62,
            x: -49.9874,
            y: 35,
            z: 57.9919
          },
          {
            hole: 63,
            x: -74.3225,
            y: 35,
            z: 39.3189
          },
          {
            hole: 64,
            x: -92.9954,
            y: 35,
            z: 14.9839
          },
          {
            hole: 65,
            x: -104.7337,
            y: 35,
            z: -13.3549
          },
          {
            hole: 66,
            x: -104.9893,
            y: 35,
            z: -72.2362
          },
          {
            hole: 67,
            x: -94.0002,
            y: 35,
            z: -98.7661
          },
          {
            hole: 68,
            x: -76.5192,
            y: 35,
            z: -121.5479
          },
          {
            hole: 69,
            x: -53.7374,
            y: 35,
            z: -139.0289
          },
          {
            hole: 70,
            x: -27.2075,
            y: 35,
            z: -150.018
          },
          {
            hole: 71,
            x: 27.7915,
            y: 35,
            z: -150.2735
          },
          {
            hole: 72,
            x: 52.5126,
            y: 35,
            z: -140.0337
          },
          {
            hole: 73,
            x: 73.741,
            y: 35,
            z: -123.7446
          },
          {
            hole: 74,
            x: 90.0302,
            y: 35,
            z: -102.5161
          },
          {
            hole: 75,
            x: 100.27,
            y: 35,
            z: -77.7951
          },
          {
            hole: 76,
            x: 100.5255,
            y: 35,
            z: -26.6783
          },
          {
            hole: 77,
            x: 91.035,
            y: 35,
            z: -3.7661
          },
          {
            hole: 78,
            x: 75.9377,
            y: 35,
            z: 15.909
          },
          {
            hole: 79,
            x: 56.2626,
            y: 35,
            z: 31.0063
          },
          {
            hole: 80,
            x: 33.3504,
            y: 35,
            z: 40.4968
          },
          {
            hole: 81,
            x: -13.8841,
            y: 45,
            z: 40.7524
          },
          {
            hole: 82,
            x: -34.9874,
            y: 45,
            z: 32.0111
          },
          {
            hole: 83,
            x: -53.1093,
            y: 45,
            z: 18.1057
          },
          {
            hole: 84,
            x: -67.0147,
            y: 45,
            z: -0.0161
          },
          {
            hole: 85,
            x: -75.7559,
            y: 45,
            z: -21.1194
          },
          {
            hole: 86,
            x: -76.0115,
            y: 45,
            z: -64.4716
          },
          {
            hole: 87,
            x: -68.0195,
            y: 45,
            z: -83.7661
          },
          {
            hole: 88,
            x: -55.306,
            y: 45,
            z: -100.3347
          },
          {
            hole: 89,
            x: -38.7374,
            y: 45,
            z: -113.0481
          },
          {
            hole: 90,
            x: -19.443,
            y: 45,
            z: -121.0402
          },
          {
            hole: 91,
            x: 20.0269,
            y: 45,
            z: -121.2957
          },
          {
            hole: 92,
            x: 37.5126,
            y: 45,
            z: -114.053
          },
          {
            hole: 93,
            x: 52.5278,
            y: 45,
            z: -102.5314
          },
          {
            hole: 94,
            x: 64.0494,
            y: 45,
            z: -87.5161
          },
          {
            hole: 95,
            x: 71.2922,
            y: 45,
            z: -70.0305
          },
          {
            hole: 96,
            x: 71.5477,
            y: 45,
            z: -34.4429
          },
          {
            hole: 97,
            x: 65.0542,
            y: 45,
            z: -18.7661
          },
          {
            hole: 98,
            x: 54.7245,
            y: 45,
            z: -5.3042
          },
          {
            hole: 99,
            x: 41.2626,
            y: 45,
            z: 5.0255
          },
          {
            hole: 100,
            x: 25.5858,
            y: 45,
            z: 11.5191
          },
          {
            hole: 101,
            x: -6.1195,
            y: 55,
            z: 11.7746
          },
          {
            hole: 102,
            x: -19.9874,
            y: 55,
            z: 6.0303
          },
          {
            hole: 103,
            x: -31.8961,
            y: 55,
            z: -3.1075
          },
          {
            hole: 104,
            x: -41.0339,
            y: 55,
            z: -15.0161
          },
          {
            hole: 105,
            x: -46.7782,
            y: 55,
            z: -28.884
          },
          {
            hole: 106,
            x: -47.0337,
            y: 55,
            z: -56.7071
          },
          {
            hole: 107,
            x: -42.0387,
            y: 55,
            z: -68.7661
          },
          {
            hole: 108,
            x: -34.0928,
            y: 55,
            z: -79.1215
          },
          {
            hole: 109,
            x: -23.7374,
            y: 55,
            z: -87.0674
          },
          {
            hole: 110,
            x: -11.6784,
            y: 55,
            z: -92.0624
          },
          {
            hole: 111,
            x: 12.2624,
            y: 55,
            z: -92.318
          },
          {
            hole: 112,
            x: 22.5126,
            y: 55,
            z: -88.0722
          },
          {
            hole: 113,
            x: 31.3146,
            y: 55,
            z: -81.3182
          },
          {
            hole: 114,
            x: 38.0686,
            y: 55,
            z: -72.5161
          },
          {
            hole: 115,
            x: 42.3144,
            y: 55,
            z: -62.2659
          },
          {
            hole: 116,
            x: 42.57,
            y: 55,
            z: -42.2074
          },
          {
            hole: 117,
            x: 39.0734,
            y: 55,
            z: -33.7661
          },
          {
            hole: 118,
            x: 33.5113,
            y: 55,
            z: -26.5174
          },
          {
            hole: 119,
            x: 26.2626,
            y: 55,
            z: -20.9552
          },
          {
            hole: 120,
            x: 17.8212,
            y: 55,
            z: -17.4587
          },
          {
            hole: 121,
            x: 0.0126,
            y: 55,
            z: -21.2661
          }
        ],
        p2: [
          {
            hole: 0,
            x: 35.7626,
            y: 5,
            z: 163.7339
          },
          {
            hole: 1,
            x: -42.3542,
            y: 5,
            z: 147.0042
          },
          {
            hole: 2,
            x: -89.9874,
            y: 5,
            z: 127.2739
          },
          {
            hole: 3,
            x: -130.891,
            y: 5,
            z: 95.8875
          },
          {
            hole: 4,
            x: -162.2774,
            y: 5,
            z: 54.9839
          },
          {
            hole: 5,
            x: -182.0078,
            y: 5,
            z: 7.3506
          },
          {
            hole: 6,
            x: -182.2633,
            y: 5,
            z: -92.9417
          },
          {
            hole: 7,
            x: -163.2823,
            y: 5,
            z: -138.7661
          },
          {
            hole: 8,
            x: -133.0877,
            y: 5,
            z: -178.1164
          },
          {
            hole: 9,
            x: -93.7374,
            y: 5,
            z: -208.3109
          },
          {
            hole: 10,
            x: -47.9131,
            y: 5,
            z: -227.292
          },
          {
            hole: 11,
            x: 48.497,
            y: 5,
            z: -227.5476
          },
          {
            hole: 12,
            x: 92.5126,
            y: 5,
            z: -209.3157
          },
          {
            hole: 13,
            x: 130.3095,
            y: 5,
            z: -180.3131
          },
          {
            hole: 14,
            x: 159.3122,
            y: 5,
            z: -142.5161
          },
          {
            hole: 15,
            x: 177.544,
            y: 5,
            z: -98.5006
          },
          {
            hole: 16,
            x: 177.7996,
            y: 5,
            z: -5.9728
          },
          {
            hole: 17,
            x: 160.317,
            y: 5,
            z: 36.2339
          },
          {
            hole: 18,
            x: 132.5062,
            y: 5,
            z: 72.4776
          },
          {
            hole: 19,
            x: 96.2626,
            y: 5,
            z: 100.2883
          },
          {
            hole: 20,
            x: 54.0559,
            y: 5,
            z: 117.7709
          },
          {
            hole: 21,
            x: -34.5896,
            y: 15,
            z: 118.0265
          },
          {
            hole: 22,
            x: -74.9874,
            y: 15,
            z: 101.2931
          },
          {
            hole: 23,
            x: -109.6778,
            y: 15,
            z: 74.6743
          },
          {
            hole: 24,
            x: -136.2967,
            y: 15,
            z: 39.9839
          },
          {
            hole: 25,
            x: -153.03,
            y: 15,
            z: -0.4139
          },
          {
            hole: 26,
            x: -153.2856,
            y: 15,
            z: -85.1772
          },
          {
            hole: 27,
            x: -137.3015,
            y: 15,
            z: -123.7661
          },
          {
            hole: 28,
            x: -111.8745,
            y: 15,
            z: -156.9032
          },
          {
            hole: 29,
            x: -78.7374,
            y: 15,
            z: -182.3302
          },
          {
            hole: 30,
            x: -40.1485,
            y: 15,
            z: -198.3142
          },
          {
            hole: 31,
            x: 40.7325,
            y: 15,
            z: -198.5698
          },
          {
            hole: 32,
            x: 77.5126,
            y: 15,
            z: -183.335
          },
          {
            hole: 33,
            x: 109.0963,
            y: 15,
            z: -159.0999
          },
          {
            hole: 34,
            x: 133.3314,
            y: 15,
            z: -127.5161
          },
          {
            hole: 35,
            x: 148.5662,
            y: 15,
            z: -90.736
          },
          {
            hole: 36,
            x: 148.8218,
            y: 15,
            z: -13.7374
          },
          {
            hole: 37,
            x: 134.3362,
            y: 15,
            z: 21.2339
          },
          {
            hole: 38,
            x: 111.293,
            y: 15,
            z: 51.2644
          },
          {
            hole: 39,
            x: 81.2626,
            y: 15,
            z: 74.3076
          },
          {
            hole: 40,
            x: 46.2913,
            y: 15,
            z: 88.7931
          },
          {
            hole: 41,
            x: -26.825,
            y: 25,
            z: 89.0487
          },
          {
            hole: 42,
            x: -59.9874,
            y: 25,
            z: 75.3124
          },
          {
            hole: 43,
            x: -88.4646,
            y: 25,
            z: 53.4611
          },
          {
            hole: 44,
            x: -110.3159,
            y: 25,
            z: 24.9839
          },
          {
            hole: 45,
            x: -124.0522,
            y: 25,
            z: -8.1785
          },
          {
            hole: 46,
            x: -124.3078,
            y: 25,
            z: -77.4126
          },
          {
            hole: 47,
            x: -111.3207,
            y: 25,
            z: -108.7661
          },
          {
            hole: 48,
            x: -90.6613,
            y: 25,
            z: -135.69
          },
          {
            hole: 49,
            x: -63.7374,
            y: 25,
            z: -156.3494
          },
          {
            hole: 50,
            x: -32.3839,
            y: 25,
            z: -169.3365
          },
          {
            hole: 51,
            x: 32.9679,
            y: 25,
            z: -169.592
          },
          {
            hole: 52,
            x: 62.5126,
            y: 25,
            z: -157.3542
          },
          {
            hole: 53,
            x: 87.8831,
            y: 25,
            z: -137.8867
          },
          {
            hole: 54,
            x: 107.3507,
            y: 25,
            z: -112.5161
          },
          {
            hole: 55,
            x: 119.5885,
            y: 25,
            z: -82.9714
          },
          {
            hole: 56,
            x: 119.844,
            y: 25,
            z: -21.5019
          },
          {
            hole: 57,
            x: 108.3555,
            y: 25,
            z: 6.2339
          },
          {
            hole: 58,
            x: 90.0798,
            y: 25,
            z: 30.0512
          },
          {
            hole: 59,
            x: 66.2626,
            y: 25,
            z: 48.3268
          },
          {
            hole: 60,
            x: 38.5267,
            y: 25,
            z: 59.8154
          },
          {
            hole: 61,
            x: -19.0605,
            y: 35,
            z: 60.0709
          },
          {
            hole: 62,
            x: -44.9874,
            y: 35,
            z: 49.3316
          },
          {
            hole: 63,
            x: -67.2514,
            y: 35,
            z: 32.2479
          },
          {
            hole: 64,
            x: -84.3352,
            y: 35,
            z: 9.9839
          },
          {
            hole: 65,
            x: -95.0745,
            y: 35,
            z: -15.9431
          },
          {
            hole: 66,
            x: -95.33,
            y: 35,
            z: -69.648
          },
          {
            hole: 67,
            x: -85.34,
            y: 35,
            z: -93.7661
          },
          {
            hole: 68,
            x: -69.4481,
            y: 35,
            z: -114.4768
          },
          {
            hole: 69,
            x: -48.7374,
            y: 35,
            z: -130.3687
          },
          {
            hole: 70,
            x: -24.6193,
            y: 35,
            z: -140.3587
          },
          {
            hole: 71,
            x: 25.2033,
            y: 35,
            z: -140.6143
          },
          {
            hole: 72,
            x: 47.5126,
            y: 35,
            z: -131.3735
          },
          {
            hole: 73,
            x: 66.6699,
            y: 35,
            z: -116.6735
          },
          {
            hole: 74,
            x: 81.3699,
            y: 35,
            z: -97.5161
          },
          {
            hole: 75,
            x: 90.6107,
            y: 35,
            z: -75.2069
          },
          {
            hole: 76,
            x: 90.8663,
            y: 35,
            z: -29.2665
          },
          {
            hole: 77,
            x: 82.3747,
            y: 35,
            z: -8.7661
          },
          {
            hole: 78,
            x: 68.8666,
            y: 35,
            z: 8.838
          },
          {
            hole: 79,
            x: 51.2626,
            y: 35,
            z: 22.346
          },
          {
            hole: 80,
            x: 30.7622,
            y: 35,
            z: 30.8376
          },
          {
            hole: 81,
            x: -11.2959,
            y: 45,
            z: 31.0931
          },
          {
            hole: 82,
            x: -29.9874,
            y: 45,
            z: 23.3509
          },
          {
            hole: 83,
            x: -46.0382,
            y: 45,
            z: 11.0347
          },
          {
            hole: 84,
            x: -58.3544,
            y: 45,
            z: -5.0161
          },
          {
            hole: 85,
            x: -66.0967,
            y: 45,
            z: -23.7076
          },
          {
            hole: 86,
            x: -66.3522,
            y: 45,
            z: -61.8834
          },
          {
            hole: 87,
            x: -59.3592,
            y: 45,
            z: -78.7661
          },
          {
            hole: 88,
            x: -48.2349,
            y: 45,
            z: -93.2636
          },
          {
            hole: 89,
            x: -33.7374,
            y: 45,
            z: -104.3879
          },
          {
            hole: 90,
            x: -16.8548,
            y: 45,
            z: -111.3809
          },
          {
            hole: 91,
            x: 17.4387,
            y: 45,
            z: -111.6365
          },
          {
            hole: 92,
            x: 32.5126,
            y: 45,
            z: -105.3927
          },
          {
            hole: 93,
            x: 45.4567,
            y: 45,
            z: -95.4603
          },
          {
            hole: 94,
            x: 55.3891,
            y: 45,
            z: -82.5161
          },
          {
            hole: 95,
            x: 61.6329,
            y: 45,
            z: -67.4423
          },
          {
            hole: 96,
            x: 61.8885,
            y: 45,
            z: -37.0311
          },
          {
            hole: 97,
            x: 56.394,
            y: 45,
            z: -23.7661
          },
          {
            hole: 98,
            x: 47.6534,
            y: 45,
            z: -12.3752
          },
          {
            hole: 99,
            x: 36.2626,
            y: 45,
            z: -3.6347
          },
          {
            hole: 100,
            x: 22.9976,
            y: 45,
            z: 1.8598
          },
          {
            hole: 101,
            x: -3.5313,
            y: 55,
            z: 2.1154
          },
          {
            hole: 102,
            x: -14.9874,
            y: 55,
            z: -2.6299
          },
          {
            hole: 103,
            x: -24.825,
            y: 55,
            z: -10.1785
          },
          {
            hole: 104,
            x: -32.3736,
            y: 55,
            z: -20.0161
          },
          {
            hole: 105,
            x: -37.1189,
            y: 55,
            z: -31.4722
          },
          {
            hole: 106,
            x: -37.3745,
            y: 55,
            z: -54.1189
          },
          {
            hole: 107,
            x: -33.3785,
            y: 55,
            z: -63.7661
          },
          {
            hole: 108,
            x: -27.0217,
            y: 55,
            z: -72.0504
          },
          {
            hole: 109,
            x: -18.7374,
            y: 55,
            z: -78.4071
          },
          {
            hole: 110,
            x: -9.0902,
            y: 55,
            z: -82.4031
          },
          {
            hole: 111,
            x: 9.6742,
            y: 55,
            z: -82.6587
          },
          {
            hole: 112,
            x: 17.5126,
            y: 55,
            z: -79.4119
          },
          {
            hole: 113,
            x: 24.2435,
            y: 55,
            z: -74.2471
          },
          {
            hole: 114,
            x: 29.4084,
            y: 55,
            z: -67.5161
          },
          {
            hole: 115,
            x: 32.6551,
            y: 55,
            z: -59.6777
          },
          {
            hole: 116,
            x: 32.9107,
            y: 55,
            z: -44.7956
          },
          {
            hole: 117,
            x: 30.4132,
            y: 55,
            z: -38.7661
          },
          {
            hole: 118,
            x: 26.4402,
            y: 55,
            z: -33.5884
          },
          {
            hole: 119,
            x: 21.2626,
            y: 55,
            z: -29.6155
          },
          {
            hole: 120,
            x: 15.233,
            y: 55,
            z: -27.118
          },
          {
            hole: 121,
            x: 0.0126,
            y: 55,
            z: -21.2661
          }
        ]
      }
    },
    {
      id: "board-cribbage-clash-square",
      name: "Cribbage Clash Square",
      brand: "clash",
      desc: "Cribbage Clash Square 3D cribbage board (12.3 MB)",
      target: 481,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/cribbage-clash-square-thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/e78fceef8feb21ab/Cribbage_Clash_-_Square_-_stepped_-_height.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: -205,
            y: 10,
            z: -93
          },
          {
            hole: 1,
            x: -235,
            y: 20,
            z: -75.5
          },
          {
            hole: 2,
            x: -235,
            y: 20,
            z: -67.75
          },
          {
            hole: 3,
            x: -235,
            y: 20,
            z: -60
          },
          {
            hole: 4,
            x: -235,
            y: 20,
            z: -52.25
          },
          {
            hole: 5,
            x: -235,
            y: 20,
            z: -44.5
          },
          {
            hole: 6,
            x: -235,
            y: 20,
            z: -35.5
          },
          {
            hole: 7,
            x: -235,
            y: 20,
            z: -27.75
          },
          {
            hole: 8,
            x: -235,
            y: 20,
            z: -20
          },
          {
            hole: 9,
            x: -235,
            y: 20,
            z: -12.25
          },
          {
            hole: 10,
            x: -235,
            y: 20,
            z: -4.5
          },
          {
            hole: 11,
            x: -235,
            y: 20,
            z: 4.5
          },
          {
            hole: 12,
            x: -235,
            y: 20,
            z: 12.25
          },
          {
            hole: 13,
            x: -235,
            y: 20,
            z: 20
          },
          {
            hole: 14,
            x: -235,
            y: 20,
            z: 27.75
          },
          {
            hole: 15,
            x: -235,
            y: 20,
            z: 35.5
          },
          {
            hole: 16,
            x: -235,
            y: 20,
            z: 44.5
          },
          {
            hole: 17,
            x: -235,
            y: 20,
            z: 52.25
          },
          {
            hole: 18,
            x: -235,
            y: 20,
            z: 60
          },
          {
            hole: 19,
            x: -235,
            y: 20,
            z: 67.75
          },
          {
            hole: 20,
            x: -235,
            y: 20,
            z: 75.5
          },
          {
            hole: 21,
            x: -235,
            y: 20,
            z: 84.5
          },
          {
            hole: 22,
            x: -235,
            y: 20,
            z: 92.25
          },
          {
            hole: 23,
            x: -235,
            y: 20,
            z: 100
          },
          {
            hole: 24,
            x: -235,
            y: 20,
            z: 107.75
          },
          {
            hole: 25,
            x: -235,
            y: 20,
            z: 115.5
          },
          {
            hole: 26,
            x: -235,
            y: 20,
            z: 124.5
          },
          {
            hole: 27,
            x: -235,
            y: 20,
            z: 132.25
          },
          {
            hole: 28,
            x: -235,
            y: 20,
            z: 140
          },
          {
            hole: 29,
            x: -235,
            y: 20,
            z: 147.75
          },
          {
            hole: 30,
            x: -235,
            y: 20,
            z: 155.5
          },
          {
            hole: 31,
            x: -235,
            y: 20,
            z: 164.5
          },
          {
            hole: 32,
            x: -235,
            y: 20,
            z: 172.25
          },
          {
            hole: 33,
            x: -235,
            y: 20,
            z: 180
          },
          {
            hole: 34,
            x: -235,
            y: 20,
            z: 187.75
          },
          {
            hole: 35,
            x: -235,
            y: 20,
            z: 195.5
          },
          {
            hole: 36,
            x: -235,
            y: 20,
            z: 204.9999
          },
          {
            hole: 37,
            x: -235,
            y: 20,
            z: 212.4999
          },
          {
            hole: 38,
            x: -235,
            y: 20,
            z: 254.9999
          },
          {
            hole: 39,
            x: -192.5,
            y: 20,
            z: 254.9999
          },
          {
            hole: 40,
            x: -185,
            y: 20,
            z: 254.9999
          },
          {
            hole: 41,
            x: -175.5,
            y: 30,
            z: 255
          },
          {
            hole: 42,
            x: -167.75,
            y: 30,
            z: 255
          },
          {
            hole: 43,
            x: -160,
            y: 30,
            z: 255
          },
          {
            hole: 44,
            x: -152.25,
            y: 30,
            z: 255
          },
          {
            hole: 45,
            x: -144.5,
            y: 30,
            z: 255
          },
          {
            hole: 46,
            x: -135.5,
            y: 30,
            z: 255
          },
          {
            hole: 47,
            x: -127.75,
            y: 30,
            z: 255
          },
          {
            hole: 48,
            x: -120,
            y: 30,
            z: 255
          },
          {
            hole: 49,
            x: -112.25,
            y: 30,
            z: 255
          },
          {
            hole: 50,
            x: -104.5,
            y: 30,
            z: 255
          },
          {
            hole: 51,
            x: -95.5,
            y: 30,
            z: 255
          },
          {
            hole: 52,
            x: -87.75,
            y: 30,
            z: 255
          },
          {
            hole: 53,
            x: -80,
            y: 30,
            z: 255
          },
          {
            hole: 54,
            x: -72.25,
            y: 30,
            z: 255
          },
          {
            hole: 55,
            x: -64.5,
            y: 30,
            z: 255
          },
          {
            hole: 56,
            x: -55.5,
            y: 30,
            z: 255
          },
          {
            hole: 57,
            x: -47.75,
            y: 30,
            z: 255
          },
          {
            hole: 58,
            x: -40,
            y: 30,
            z: 255
          },
          {
            hole: 59,
            x: -32.25,
            y: 30,
            z: 255
          },
          {
            hole: 60,
            x: -24.5,
            y: 30,
            z: 255
          },
          {
            hole: 61,
            x: -15.5,
            y: 30,
            z: 255
          },
          {
            hole: 62,
            x: -7.75,
            y: 30,
            z: 255
          },
          {
            hole: 63,
            x: 0,
            y: 30,
            z: 255
          },
          {
            hole: 64,
            x: 7.75,
            y: 30,
            z: 255
          },
          {
            hole: 65,
            x: 15.5,
            y: 30,
            z: 255
          },
          {
            hole: 66,
            x: 24.5,
            y: 30,
            z: 255
          },
          {
            hole: 67,
            x: 32.25,
            y: 30,
            z: 255
          },
          {
            hole: 68,
            x: 40,
            y: 30,
            z: 255
          },
          {
            hole: 69,
            x: 47.75,
            y: 30,
            z: 255
          },
          {
            hole: 70,
            x: 55.5,
            y: 30,
            z: 255
          },
          {
            hole: 71,
            x: 64.5,
            y: 30,
            z: 255
          },
          {
            hole: 72,
            x: 72.25,
            y: 30,
            z: 255
          },
          {
            hole: 73,
            x: 80,
            y: 30,
            z: 255
          },
          {
            hole: 74,
            x: 87.75,
            y: 30,
            z: 255
          },
          {
            hole: 75,
            x: 95.5,
            y: 30,
            z: 255
          },
          {
            hole: 76,
            x: 104.5,
            y: 30,
            z: 255
          },
          {
            hole: 77,
            x: 112.25,
            y: 30,
            z: 255
          },
          {
            hole: 78,
            x: 120,
            y: 30,
            z: 255
          },
          {
            hole: 79,
            x: 127.75,
            y: 30,
            z: 255
          },
          {
            hole: 80,
            x: 135.5,
            y: 30,
            z: 255
          },
          {
            hole: 81,
            x: 144.5,
            y: 30,
            z: 255
          },
          {
            hole: 82,
            x: 152.25,
            y: 30,
            z: 255
          },
          {
            hole: 83,
            x: 160,
            y: 30,
            z: 255
          },
          {
            hole: 84,
            x: 167.75,
            y: 30,
            z: 255
          },
          {
            hole: 85,
            x: 175.5,
            y: 30,
            z: 255
          },
          {
            hole: 86,
            x: 184.5,
            y: 30,
            z: 255
          },
          {
            hole: 87,
            x: 192.25,
            y: 30,
            z: 255
          },
          {
            hole: 88,
            x: 200,
            y: 30,
            z: 255
          },
          {
            hole: 89,
            x: 207.75,
            y: 30,
            z: 255
          },
          {
            hole: 90,
            x: 215.5,
            y: 30,
            z: 255
          },
          {
            hole: 91,
            x: 224.5,
            y: 30,
            z: 255
          },
          {
            hole: 92,
            x: 232.25,
            y: 30,
            z: 255
          },
          {
            hole: 93,
            x: 240,
            y: 30,
            z: 255
          },
          {
            hole: 94,
            x: 247.75,
            y: 30,
            z: 255
          },
          {
            hole: 95,
            x: 255.5,
            y: 30,
            z: 255
          },
          {
            hole: 96,
            x: 264.5,
            y: 30,
            z: 255
          },
          {
            hole: 97,
            x: 272.25,
            y: 30,
            z: 255
          },
          {
            hole: 98,
            x: 280,
            y: 30,
            z: 255
          },
          {
            hole: 99,
            x: 287.75,
            y: 30,
            z: 255
          },
          {
            hole: 100,
            x: 295.5,
            y: 30,
            z: 255
          },
          {
            hole: 101,
            x: 305,
            y: 30,
            z: 255
          },
          {
            hole: 102,
            x: 312.5,
            y: 30,
            z: 255
          },
          {
            hole: 103,
            x: 355,
            y: 30,
            z: 255
          },
          {
            hole: 104,
            x: 355,
            y: 30,
            z: 212.5
          },
          {
            hole: 105,
            x: 355,
            y: 30,
            z: 205
          },
          {
            hole: 106,
            x: 355,
            y: 40,
            z: 195.5
          },
          {
            hole: 107,
            x: 355,
            y: 40,
            z: 187.75
          },
          {
            hole: 108,
            x: 355,
            y: 40,
            z: 180
          },
          {
            hole: 109,
            x: 355,
            y: 40,
            z: 172.25
          },
          {
            hole: 110,
            x: 355,
            y: 40,
            z: 164.5
          },
          {
            hole: 111,
            x: 355,
            y: 40,
            z: 155.5
          },
          {
            hole: 112,
            x: 355,
            y: 40,
            z: 147.75
          },
          {
            hole: 113,
            x: 355,
            y: 40,
            z: 140
          },
          {
            hole: 114,
            x: 355,
            y: 40,
            z: 132.25
          },
          {
            hole: 115,
            x: 355,
            y: 40,
            z: 124.5
          },
          {
            hole: 116,
            x: 355,
            y: 40,
            z: 115.5
          },
          {
            hole: 117,
            x: 355,
            y: 40,
            z: 107.75
          },
          {
            hole: 118,
            x: 355,
            y: 40,
            z: 100
          },
          {
            hole: 119,
            x: 355,
            y: 40,
            z: 92.25
          },
          {
            hole: 120,
            x: 355,
            y: 40,
            z: 84.5
          },
          {
            hole: 121,
            x: 355,
            y: 40,
            z: 75.5
          },
          {
            hole: 122,
            x: 355,
            y: 40,
            z: 67.75
          },
          {
            hole: 123,
            x: 355,
            y: 40,
            z: 60
          },
          {
            hole: 124,
            x: 355,
            y: 40,
            z: 52.25
          },
          {
            hole: 125,
            x: 355,
            y: 40,
            z: 44.5
          },
          {
            hole: 126,
            x: 355,
            y: 40,
            z: 35.5
          },
          {
            hole: 127,
            x: 355,
            y: 40,
            z: 27.75
          },
          {
            hole: 128,
            x: 355,
            y: 40,
            z: 20
          },
          {
            hole: 129,
            x: 355,
            y: 40,
            z: 12.25
          },
          {
            hole: 130,
            x: 355,
            y: 40,
            z: 4.5
          },
          {
            hole: 131,
            x: 355,
            y: 40,
            z: -4.5
          },
          {
            hole: 132,
            x: 355,
            y: 40,
            z: -12.25
          },
          {
            hole: 133,
            x: 355,
            y: 40,
            z: -20
          },
          {
            hole: 134,
            x: 355,
            y: 40,
            z: -27.75
          },
          {
            hole: 135,
            x: 355,
            y: 40,
            z: -35.5
          },
          {
            hole: 136,
            x: 355,
            y: 40,
            z: -44.5
          },
          {
            hole: 137,
            x: 355,
            y: 40,
            z: -52.25
          },
          {
            hole: 138,
            x: 355,
            y: 40,
            z: -60
          },
          {
            hole: 139,
            x: 355,
            y: 40,
            z: -67.75
          },
          {
            hole: 140,
            x: 355,
            y: 40,
            z: -75.5
          },
          {
            hole: 141,
            x: 355,
            y: 40,
            z: -84.5
          },
          {
            hole: 142,
            x: 355,
            y: 40,
            z: -92.25
          },
          {
            hole: 143,
            x: 355,
            y: 40,
            z: -100
          },
          {
            hole: 144,
            x: 355,
            y: 40,
            z: -107.75
          },
          {
            hole: 145,
            x: 355,
            y: 40,
            z: -115.5
          },
          {
            hole: 146,
            x: 355,
            y: 40,
            z: -124.5
          },
          {
            hole: 147,
            x: 355,
            y: 40,
            z: -132.25
          },
          {
            hole: 148,
            x: 355,
            y: 40,
            z: -140
          },
          {
            hole: 149,
            x: 355,
            y: 40,
            z: -147.75
          },
          {
            hole: 150,
            x: 355,
            y: 40,
            z: -155.5
          },
          {
            hole: 151,
            x: 355,
            y: 40,
            z: -164.5
          },
          {
            hole: 152,
            x: 355,
            y: 40,
            z: -172.25
          },
          {
            hole: 153,
            x: 355,
            y: 40,
            z: -180
          },
          {
            hole: 154,
            x: 355,
            y: 40,
            z: -187.75
          },
          {
            hole: 155,
            x: 355,
            y: 40,
            z: -195.5
          },
          {
            hole: 156,
            x: 355,
            y: 40,
            z: -204.5
          },
          {
            hole: 157,
            x: 355,
            y: 40,
            z: -212.25
          },
          {
            hole: 158,
            x: 355,
            y: 40,
            z: -220
          },
          {
            hole: 159,
            x: 355,
            y: 40,
            z: -227.75
          },
          {
            hole: 160,
            x: 355,
            y: 40,
            z: -235.5
          },
          {
            hole: 161,
            x: 355,
            y: 40,
            z: -245
          },
          {
            hole: 162,
            x: 355,
            y: 40,
            z: -262.5
          },
          {
            hole: 163,
            x: 355,
            y: 40,
            z: -315
          },
          {
            hole: 164,
            x: 302.5,
            y: 40,
            z: -315
          },
          {
            hole: 165,
            x: 285,
            y: 40,
            z: -315
          },
          {
            hole: 166,
            x: 275.5,
            y: 50,
            z: -315
          },
          {
            hole: 167,
            x: 267.75,
            y: 50,
            z: -315
          },
          {
            hole: 168,
            x: 260,
            y: 50,
            z: -315
          },
          {
            hole: 169,
            x: 252.25,
            y: 50,
            z: -315
          },
          {
            hole: 170,
            x: 244.5,
            y: 50,
            z: -315
          },
          {
            hole: 171,
            x: 235.5,
            y: 50,
            z: -315
          },
          {
            hole: 172,
            x: 227.75,
            y: 50,
            z: -315
          },
          {
            hole: 173,
            x: 220,
            y: 50,
            z: -315
          },
          {
            hole: 174,
            x: 212.25,
            y: 50,
            z: -315
          },
          {
            hole: 175,
            x: 204.5,
            y: 50,
            z: -315
          },
          {
            hole: 176,
            x: 195.5,
            y: 50,
            z: -315
          },
          {
            hole: 177,
            x: 187.75,
            y: 50,
            z: -315
          },
          {
            hole: 178,
            x: 180,
            y: 50,
            z: -315
          },
          {
            hole: 179,
            x: 172.25,
            y: 50,
            z: -315
          },
          {
            hole: 180,
            x: 164.5,
            y: 50,
            z: -315
          },
          {
            hole: 181,
            x: 155.5,
            y: 50,
            z: -315
          },
          {
            hole: 182,
            x: 147.75,
            y: 50,
            z: -315
          },
          {
            hole: 183,
            x: 140,
            y: 50,
            z: -315
          },
          {
            hole: 184,
            x: 132.25,
            y: 50,
            z: -315
          },
          {
            hole: 185,
            x: 124.5,
            y: 50,
            z: -315
          },
          {
            hole: 186,
            x: 115.5,
            y: 50,
            z: -315
          },
          {
            hole: 187,
            x: 107.75,
            y: 50,
            z: -315
          },
          {
            hole: 188,
            x: 100,
            y: 50,
            z: -315
          },
          {
            hole: 189,
            x: 92.25,
            y: 50,
            z: -315
          },
          {
            hole: 190,
            x: 84.5,
            y: 50,
            z: -315
          },
          {
            hole: 191,
            x: 75.5,
            y: 50,
            z: -315
          },
          {
            hole: 192,
            x: 67.75,
            y: 50,
            z: -315
          },
          {
            hole: 193,
            x: 60,
            y: 50,
            z: -315
          },
          {
            hole: 194,
            x: 52.25,
            y: 50,
            z: -315
          },
          {
            hole: 195,
            x: 44.5,
            y: 50,
            z: -315
          },
          {
            hole: 196,
            x: 35.5,
            y: 50,
            z: -315
          },
          {
            hole: 197,
            x: 27.75,
            y: 50,
            z: -315
          },
          {
            hole: 198,
            x: 20,
            y: 50,
            z: -315
          },
          {
            hole: 199,
            x: 12.25,
            y: 50,
            z: -315
          },
          {
            hole: 200,
            x: 4.5,
            y: 50,
            z: -315
          },
          {
            hole: 201,
            x: -4.5,
            y: 50,
            z: -315
          },
          {
            hole: 202,
            x: -12.25,
            y: 50,
            z: -315
          },
          {
            hole: 203,
            x: -20,
            y: 50,
            z: -315
          },
          {
            hole: 204,
            x: -27.75,
            y: 50,
            z: -315
          },
          {
            hole: 205,
            x: -35.5,
            y: 50,
            z: -315
          },
          {
            hole: 206,
            x: -44.5,
            y: 50,
            z: -315
          },
          {
            hole: 207,
            x: -52.25,
            y: 50,
            z: -315
          },
          {
            hole: 208,
            x: -60,
            y: 50,
            z: -315
          },
          {
            hole: 209,
            x: -67.75,
            y: 50,
            z: -315
          },
          {
            hole: 210,
            x: -75.5,
            y: 50,
            z: -315
          },
          {
            hole: 211,
            x: -85,
            y: 50,
            z: -315
          },
          {
            hole: 212,
            x: -102.5,
            y: 50,
            z: -315
          },
          {
            hole: 213,
            x: -155,
            y: 50,
            z: -315
          },
          {
            hole: 214,
            x: -155,
            y: 50,
            z: -262.5
          },
          {
            hole: 215,
            x: -155,
            y: 50,
            z: -245
          },
          {
            hole: 216,
            x: -155,
            y: 60,
            z: -235.5
          },
          {
            hole: 217,
            x: -155,
            y: 60,
            z: -227.75
          },
          {
            hole: 218,
            x: -155,
            y: 60,
            z: -220
          },
          {
            hole: 219,
            x: -155,
            y: 60,
            z: -212.25
          },
          {
            hole: 220,
            x: -155,
            y: 60,
            z: -204.5
          },
          {
            hole: 221,
            x: -155,
            y: 60,
            z: -195.5
          },
          {
            hole: 222,
            x: -155,
            y: 60,
            z: -187.75
          },
          {
            hole: 223,
            x: -155,
            y: 60,
            z: -180
          },
          {
            hole: 224,
            x: -155,
            y: 60,
            z: -172.25
          },
          {
            hole: 225,
            x: -155,
            y: 60,
            z: -164.5
          },
          {
            hole: 226,
            x: -155,
            y: 60,
            z: -155.5
          },
          {
            hole: 227,
            x: -155,
            y: 60,
            z: -147.75
          },
          {
            hole: 228,
            x: -155,
            y: 60,
            z: -140
          },
          {
            hole: 229,
            x: -155,
            y: 60,
            z: -132.25
          },
          {
            hole: 230,
            x: -155,
            y: 60,
            z: -124.5
          },
          {
            hole: 231,
            x: -155,
            y: 60,
            z: -115.5
          },
          {
            hole: 232,
            x: -155,
            y: 60,
            z: -107.75
          },
          {
            hole: 233,
            x: -155,
            y: 60,
            z: -100
          },
          {
            hole: 234,
            x: -155,
            y: 60,
            z: -92.25
          },
          {
            hole: 235,
            x: -155,
            y: 60,
            z: -84.5
          },
          {
            hole: 236,
            x: -155,
            y: 60,
            z: -75.5
          },
          {
            hole: 237,
            x: -155,
            y: 60,
            z: -67.75
          },
          {
            hole: 238,
            x: -155,
            y: 60,
            z: -60
          },
          {
            hole: 239,
            x: -155,
            y: 60,
            z: -52.25
          },
          {
            hole: 240,
            x: -155,
            y: 60,
            z: -44.5
          },
          {
            hole: 241,
            x: -155,
            y: 60,
            z: -35.5
          },
          {
            hole: 242,
            x: -155,
            y: 60,
            z: -27.75
          },
          {
            hole: 243,
            x: -155,
            y: 60,
            z: -20
          },
          {
            hole: 244,
            x: -155,
            y: 60,
            z: -12.25
          },
          {
            hole: 245,
            x: -155,
            y: 60,
            z: -4.5
          },
          {
            hole: 246,
            x: -155,
            y: 60,
            z: 4.5
          },
          {
            hole: 247,
            x: -155,
            y: 60,
            z: 12.25
          },
          {
            hole: 248,
            x: -155,
            y: 60,
            z: 20
          },
          {
            hole: 249,
            x: -155,
            y: 60,
            z: 27.75
          },
          {
            hole: 250,
            x: -155,
            y: 60,
            z: 35.5
          },
          {
            hole: 251,
            x: -155,
            y: 60,
            z: 44.5
          },
          {
            hole: 252,
            x: -155,
            y: 60,
            z: 52.25
          },
          {
            hole: 253,
            x: -155,
            y: 60,
            z: 60
          },
          {
            hole: 254,
            x: -155,
            y: 60,
            z: 67.75
          },
          {
            hole: 255,
            x: -155,
            y: 60,
            z: 75.5
          },
          {
            hole: 256,
            x: -155,
            y: 60,
            z: 84.5
          },
          {
            hole: 257,
            x: -155,
            y: 60,
            z: 92.25
          },
          {
            hole: 258,
            x: -155,
            y: 60,
            z: 100
          },
          {
            hole: 259,
            x: -155,
            y: 60,
            z: 107.75
          },
          {
            hole: 260,
            x: -155,
            y: 60,
            z: 115.5
          },
          {
            hole: 261,
            x: -155,
            y: 60,
            z: 125
          },
          {
            hole: 262,
            x: -155,
            y: 60,
            z: 132.5
          },
          {
            hole: 263,
            x: -155,
            y: 60,
            z: 175
          },
          {
            hole: 264,
            x: -112.5,
            y: 60,
            z: 175
          },
          {
            hole: 265,
            x: -105,
            y: 60,
            z: 175
          },
          {
            hole: 266,
            x: -95.5,
            y: 70,
            z: 175
          },
          {
            hole: 267,
            x: -87.75,
            y: 70,
            z: 175
          },
          {
            hole: 268,
            x: -80,
            y: 70,
            z: 175
          },
          {
            hole: 269,
            x: -72.25,
            y: 70,
            z: 175
          },
          {
            hole: 270,
            x: -64.5,
            y: 70,
            z: 175
          },
          {
            hole: 271,
            x: -55.5,
            y: 70,
            z: 175
          },
          {
            hole: 272,
            x: -47.75,
            y: 70,
            z: 175
          },
          {
            hole: 273,
            x: -40,
            y: 70,
            z: 175
          },
          {
            hole: 274,
            x: -32.25,
            y: 70,
            z: 175
          },
          {
            hole: 275,
            x: -24.5,
            y: 70,
            z: 175
          },
          {
            hole: 276,
            x: -15.5,
            y: 70,
            z: 175
          },
          {
            hole: 277,
            x: -7.75,
            y: 70,
            z: 175
          },
          {
            hole: 278,
            x: 0,
            y: 70,
            z: 175
          },
          {
            hole: 279,
            x: 7.75,
            y: 70,
            z: 175
          },
          {
            hole: 280,
            x: 15.5,
            y: 70,
            z: 175
          },
          {
            hole: 281,
            x: 24.5,
            y: 70,
            z: 175
          },
          {
            hole: 282,
            x: 32.25,
            y: 70,
            z: 175
          },
          {
            hole: 283,
            x: 40,
            y: 70,
            z: 175
          },
          {
            hole: 284,
            x: 47.75,
            y: 70,
            z: 175
          },
          {
            hole: 285,
            x: 55.5,
            y: 70,
            z: 175
          },
          {
            hole: 286,
            x: 64.5,
            y: 70,
            z: 175
          },
          {
            hole: 287,
            x: 72.25,
            y: 70,
            z: 175
          },
          {
            hole: 288,
            x: 80,
            y: 70,
            z: 175
          },
          {
            hole: 289,
            x: 87.75,
            y: 70,
            z: 175
          },
          {
            hole: 290,
            x: 95.5,
            y: 70,
            z: 175
          },
          {
            hole: 291,
            x: 104.5,
            y: 70,
            z: 175
          },
          {
            hole: 292,
            x: 112.25,
            y: 70,
            z: 175
          },
          {
            hole: 293,
            x: 120,
            y: 70,
            z: 175
          },
          {
            hole: 294,
            x: 127.75,
            y: 70,
            z: 175
          },
          {
            hole: 295,
            x: 135.5,
            y: 70,
            z: 175
          },
          {
            hole: 296,
            x: 144.5,
            y: 70,
            z: 175
          },
          {
            hole: 297,
            x: 152.25,
            y: 70,
            z: 175
          },
          {
            hole: 298,
            x: 160,
            y: 70,
            z: 175
          },
          {
            hole: 299,
            x: 167.75,
            y: 70,
            z: 175
          },
          {
            hole: 300,
            x: 175.5,
            y: 70,
            z: 175
          },
          {
            hole: 301,
            x: 184.5,
            y: 70,
            z: 175
          },
          {
            hole: 302,
            x: 192.25,
            y: 70,
            z: 175
          },
          {
            hole: 303,
            x: 200,
            y: 70,
            z: 175
          },
          {
            hole: 304,
            x: 207.75,
            y: 70,
            z: 175
          },
          {
            hole: 305,
            x: 215.5,
            y: 70,
            z: 175
          },
          {
            hole: 306,
            x: 225,
            y: 70,
            z: 175
          },
          {
            hole: 307,
            x: 232.5,
            y: 70,
            z: 175
          },
          {
            hole: 308,
            x: 275,
            y: 70,
            z: 175
          },
          {
            hole: 309,
            x: 275,
            y: 70,
            z: 132.5
          },
          {
            hole: 310,
            x: 275,
            y: 70,
            z: 125
          },
          {
            hole: 311,
            x: 275,
            y: 80,
            z: 115.5
          },
          {
            hole: 312,
            x: 275,
            y: 80,
            z: 107.75
          },
          {
            hole: 313,
            x: 275,
            y: 80,
            z: 100
          },
          {
            hole: 314,
            x: 275,
            y: 80,
            z: 92.25
          },
          {
            hole: 315,
            x: 275,
            y: 80,
            z: 84.5
          },
          {
            hole: 316,
            x: 275,
            y: 80,
            z: 75.5
          },
          {
            hole: 317,
            x: 275,
            y: 80,
            z: 67.75
          },
          {
            hole: 318,
            x: 275,
            y: 80,
            z: 60
          },
          {
            hole: 319,
            x: 275,
            y: 80,
            z: 52.25
          },
          {
            hole: 320,
            x: 275,
            y: 80,
            z: 44.5
          },
          {
            hole: 321,
            x: 275,
            y: 80,
            z: 35.5
          },
          {
            hole: 322,
            x: 275,
            y: 80,
            z: 27.75
          },
          {
            hole: 323,
            x: 275,
            y: 80,
            z: 20
          },
          {
            hole: 324,
            x: 275,
            y: 80,
            z: 12.25
          },
          {
            hole: 325,
            x: 275,
            y: 80,
            z: 4.5
          },
          {
            hole: 326,
            x: 275,
            y: 80,
            z: -4.5
          },
          {
            hole: 327,
            x: 275,
            y: 80,
            z: -12.25
          },
          {
            hole: 328,
            x: 275,
            y: 80,
            z: -20
          },
          {
            hole: 329,
            x: 275,
            y: 80,
            z: -27.75
          },
          {
            hole: 330,
            x: 275,
            y: 80,
            z: -35.5
          },
          {
            hole: 331,
            x: 275,
            y: 80,
            z: -44.5
          },
          {
            hole: 332,
            x: 275,
            y: 80,
            z: -52.25
          },
          {
            hole: 333,
            x: 275,
            y: 80,
            z: -60
          },
          {
            hole: 334,
            x: 275,
            y: 80,
            z: -67.75
          },
          {
            hole: 335,
            x: 275,
            y: 80,
            z: -75.5
          },
          {
            hole: 336,
            x: 275,
            y: 80,
            z: -84.5
          },
          {
            hole: 337,
            x: 275,
            y: 80,
            z: -92.25
          },
          {
            hole: 338,
            x: 275,
            y: 80,
            z: -100
          },
          {
            hole: 339,
            x: 275,
            y: 80,
            z: -107.75
          },
          {
            hole: 340,
            x: 275,
            y: 80,
            z: -115.5
          },
          {
            hole: 341,
            x: 275,
            y: 80,
            z: -124.5
          },
          {
            hole: 342,
            x: 275,
            y: 80,
            z: -132.25
          },
          {
            hole: 343,
            x: 275,
            y: 80,
            z: -140
          },
          {
            hole: 344,
            x: 275,
            y: 80,
            z: -147.75
          },
          {
            hole: 345,
            x: 275,
            y: 80,
            z: -155.5
          },
          {
            hole: 346,
            x: 275,
            y: 80,
            z: -165
          },
          {
            hole: 347,
            x: 275,
            y: 80,
            z: -182.5
          },
          {
            hole: 348,
            x: 275,
            y: 80,
            z: -235
          },
          {
            hole: 349,
            x: 222.5,
            y: 80,
            z: -235
          },
          {
            hole: 350,
            x: 205,
            y: 80,
            z: -235
          },
          {
            hole: 351,
            x: 195.5,
            y: 90,
            z: -235
          },
          {
            hole: 352,
            x: 187.75,
            y: 90,
            z: -235
          },
          {
            hole: 353,
            x: 180,
            y: 90,
            z: -235
          },
          {
            hole: 354,
            x: 172.25,
            y: 90,
            z: -235
          },
          {
            hole: 355,
            x: 164.5,
            y: 90,
            z: -235
          },
          {
            hole: 356,
            x: 155.5,
            y: 90,
            z: -235
          },
          {
            hole: 357,
            x: 147.75,
            y: 90,
            z: -235
          },
          {
            hole: 358,
            x: 140,
            y: 90,
            z: -235
          },
          {
            hole: 359,
            x: 132.25,
            y: 90,
            z: -235
          },
          {
            hole: 360,
            x: 124.5,
            y: 90,
            z: -235
          },
          {
            hole: 361,
            x: 115.5,
            y: 90,
            z: -235
          },
          {
            hole: 362,
            x: 107.75,
            y: 90,
            z: -235
          },
          {
            hole: 363,
            x: 100,
            y: 90,
            z: -235
          },
          {
            hole: 364,
            x: 92.25,
            y: 90,
            z: -235
          },
          {
            hole: 365,
            x: 84.5,
            y: 90,
            z: -235
          },
          {
            hole: 366,
            x: 75.5,
            y: 90,
            z: -235
          },
          {
            hole: 367,
            x: 67.75,
            y: 90,
            z: -235
          },
          {
            hole: 368,
            x: 60,
            y: 90,
            z: -235
          },
          {
            hole: 369,
            x: 52.25,
            y: 90,
            z: -235
          },
          {
            hole: 370,
            x: 44.5,
            y: 90,
            z: -235
          },
          {
            hole: 371,
            x: 35.5,
            y: 90,
            z: -235
          },
          {
            hole: 372,
            x: 27.75,
            y: 90,
            z: -235
          },
          {
            hole: 373,
            x: 20,
            y: 90,
            z: -235
          },
          {
            hole: 374,
            x: 12.25,
            y: 90,
            z: -235
          },
          {
            hole: 375,
            x: 4.5,
            y: 90,
            z: -235
          },
          {
            hole: 376,
            x: -5,
            y: 90,
            z: -235
          },
          {
            hole: 377,
            x: -22.5,
            y: 90,
            z: -235
          },
          {
            hole: 378,
            x: -75,
            y: 90,
            z: -235
          },
          {
            hole: 379,
            x: -75,
            y: 90,
            z: -182.5
          },
          {
            hole: 380,
            x: -75,
            y: 90,
            z: -165
          },
          {
            hole: 381,
            x: -75,
            y: 100,
            z: -155.5
          },
          {
            hole: 382,
            x: -75,
            y: 100,
            z: -147.75
          },
          {
            hole: 383,
            x: -75,
            y: 100,
            z: -140
          },
          {
            hole: 384,
            x: -75,
            y: 100,
            z: -132.25
          },
          {
            hole: 385,
            x: -75,
            y: 100,
            z: -124.5
          },
          {
            hole: 386,
            x: -75,
            y: 100,
            z: -115.5
          },
          {
            hole: 387,
            x: -75,
            y: 100,
            z: -107.75
          },
          {
            hole: 388,
            x: -75,
            y: 100,
            z: -100
          },
          {
            hole: 389,
            x: -75,
            y: 100,
            z: -92.25
          },
          {
            hole: 390,
            x: -75,
            y: 100,
            z: -84.5
          },
          {
            hole: 391,
            x: -75,
            y: 100,
            z: -75.5
          },
          {
            hole: 392,
            x: -75,
            y: 100,
            z: -67.75
          },
          {
            hole: 393,
            x: -75,
            y: 100,
            z: -60
          },
          {
            hole: 394,
            x: -75,
            y: 100,
            z: -52.25
          },
          {
            hole: 395,
            x: -75,
            y: 100,
            z: -44.5
          },
          {
            hole: 396,
            x: -75,
            y: 100,
            z: -35.5
          },
          {
            hole: 397,
            x: -75,
            y: 100,
            z: -27.75
          },
          {
            hole: 398,
            x: -75,
            y: 100,
            z: -20
          },
          {
            hole: 399,
            x: -75,
            y: 100,
            z: -12.25
          },
          {
            hole: 400,
            x: -75,
            y: 100,
            z: -4.5
          },
          {
            hole: 401,
            x: -75,
            y: 100,
            z: 4.5
          },
          {
            hole: 402,
            x: -75,
            y: 100,
            z: 12.25
          },
          {
            hole: 403,
            x: -75,
            y: 100,
            z: 20
          },
          {
            hole: 404,
            x: -75,
            y: 100,
            z: 27.75
          },
          {
            hole: 405,
            x: -75,
            y: 100,
            z: 35.5
          },
          {
            hole: 406,
            x: -75,
            y: 100,
            z: 45
          },
          {
            hole: 407,
            x: -75,
            y: 100,
            z: 52.5
          },
          {
            hole: 408,
            x: -75,
            y: 100,
            z: 95
          },
          {
            hole: 409,
            x: -32.5,
            y: 100,
            z: 95
          },
          {
            hole: 410,
            x: -25,
            y: 100,
            z: 95
          },
          {
            hole: 411,
            x: -15.5,
            y: 110,
            z: 95
          },
          {
            hole: 412,
            x: -7.75,
            y: 110,
            z: 95
          },
          {
            hole: 413,
            x: 0,
            y: 110,
            z: 95
          },
          {
            hole: 414,
            x: 7.75,
            y: 110,
            z: 95
          },
          {
            hole: 415,
            x: 15.5,
            y: 110,
            z: 95
          },
          {
            hole: 416,
            x: 24.5,
            y: 110,
            z: 95
          },
          {
            hole: 417,
            x: 32.25,
            y: 110,
            z: 95
          },
          {
            hole: 418,
            x: 40,
            y: 110,
            z: 95
          },
          {
            hole: 419,
            x: 47.75,
            y: 110,
            z: 95
          },
          {
            hole: 420,
            x: 55.5,
            y: 110,
            z: 95
          },
          {
            hole: 421,
            x: 64.5,
            y: 110,
            z: 95
          },
          {
            hole: 422,
            x: 72.25,
            y: 110,
            z: 95
          },
          {
            hole: 423,
            x: 80,
            y: 110,
            z: 95
          },
          {
            hole: 424,
            x: 87.75,
            y: 110,
            z: 95
          },
          {
            hole: 425,
            x: 95.5,
            y: 110,
            z: 95
          },
          {
            hole: 426,
            x: 104.5,
            y: 110,
            z: 95
          },
          {
            hole: 427,
            x: 112.25,
            y: 110,
            z: 95
          },
          {
            hole: 428,
            x: 120,
            y: 110,
            z: 95
          },
          {
            hole: 429,
            x: 127.75,
            y: 110,
            z: 95
          },
          {
            hole: 430,
            x: 135.5,
            y: 110,
            z: 95
          },
          {
            hole: 431,
            x: 145,
            y: 110,
            z: 95
          },
          {
            hole: 432,
            x: 152.5,
            y: 110,
            z: 95
          },
          {
            hole: 433,
            x: 195,
            y: 110,
            z: 95
          },
          {
            hole: 434,
            x: 195,
            y: 110,
            z: 52.5
          },
          {
            hole: 435,
            x: 195,
            y: 110,
            z: 45
          },
          {
            hole: 436,
            x: 195,
            y: 120,
            z: 35.5
          },
          {
            hole: 437,
            x: 195,
            y: 120,
            z: 27.75
          },
          {
            hole: 438,
            x: 195,
            y: 120,
            z: 20
          },
          {
            hole: 439,
            x: 195,
            y: 120,
            z: 12.25
          },
          {
            hole: 440,
            x: 195,
            y: 120,
            z: 4.5
          },
          {
            hole: 441,
            x: 195,
            y: 120,
            z: -4.5
          },
          {
            hole: 442,
            x: 195,
            y: 120,
            z: -12.25
          },
          {
            hole: 443,
            x: 195,
            y: 120,
            z: -20
          },
          {
            hole: 444,
            x: 195,
            y: 120,
            z: -27.75
          },
          {
            hole: 445,
            x: 195,
            y: 120,
            z: -35.5
          },
          {
            hole: 446,
            x: 195,
            y: 120,
            z: -44.5
          },
          {
            hole: 447,
            x: 195,
            y: 120,
            z: -52.25
          },
          {
            hole: 448,
            x: 195,
            y: 120,
            z: -60
          },
          {
            hole: 449,
            x: 195,
            y: 120,
            z: -67.75
          },
          {
            hole: 450,
            x: 195,
            y: 120,
            z: -75.5
          },
          {
            hole: 451,
            x: 195,
            y: 120,
            z: -85
          },
          {
            hole: 452,
            x: 195,
            y: 120,
            z: -102.5
          },
          {
            hole: 453,
            x: 195,
            y: 120,
            z: -155
          },
          {
            hole: 454,
            x: 142.5,
            y: 120,
            z: -155
          },
          {
            hole: 455,
            x: 125,
            y: 120,
            z: -155
          },
          {
            hole: 456,
            x: 115.5,
            y: 130,
            z: -155
          },
          {
            hole: 457,
            x: 107.75,
            y: 130,
            z: -155
          },
          {
            hole: 458,
            x: 100,
            y: 130,
            z: -155
          },
          {
            hole: 459,
            x: 92.25,
            y: 130,
            z: -155
          },
          {
            hole: 460,
            x: 84.5,
            y: 130,
            z: -155
          },
          {
            hole: 461,
            x: 75,
            y: 130,
            z: -155
          },
          {
            hole: 462,
            x: 57.5,
            y: 130,
            z: -155
          },
          {
            hole: 463,
            x: 5,
            y: 130,
            z: -155
          },
          {
            hole: 464,
            x: 5,
            y: 130,
            z: -102.5
          },
          {
            hole: 465,
            x: 5,
            y: 130,
            z: -85
          },
          {
            hole: 466,
            x: 5,
            y: 140,
            z: -75.5
          },
          {
            hole: 467,
            x: 5,
            y: 140,
            z: -67.75
          },
          {
            hole: 468,
            x: 5,
            y: 140,
            z: -60
          },
          {
            hole: 469,
            x: 5,
            y: 140,
            z: -52.25
          },
          {
            hole: 470,
            x: 5,
            y: 140,
            z: -44.5
          },
          {
            hole: 471,
            x: 5,
            y: 140,
            z: -35
          },
          {
            hole: 472,
            x: 5,
            y: 140,
            z: -27.5
          },
          {
            hole: 473,
            x: 5,
            y: 140,
            z: 15
          },
          {
            hole: 474,
            x: 47.5,
            y: 140,
            z: 15
          },
          {
            hole: 475,
            x: 55,
            y: 140,
            z: 15
          },
          {
            hole: 476,
            x: 65,
            y: 150,
            z: 15
          },
          {
            hole: 477,
            x: 72.5,
            y: 150,
            z: 15
          },
          {
            hole: 478,
            x: 115,
            y: 150,
            z: 15
          },
          {
            hole: 479,
            x: 115,
            y: 150,
            z: -27.5
          },
          {
            hole: 480,
            x: 115,
            y: 150,
            z: -35
          },
          {
            hole: 121,
            x: 100,
            y: 160,
            z: -60
          }
        ],
        p2: [
          {
            hole: 0,
            x: -215,
            y: 10,
            z: -93
          },
          {
            hole: 1,
            x: -225,
            y: 20,
            z: -75.5
          },
          {
            hole: 2,
            x: -225,
            y: 20,
            z: -67.75
          },
          {
            hole: 3,
            x: -225,
            y: 20,
            z: -60
          },
          {
            hole: 4,
            x: -225,
            y: 20,
            z: -52.25
          },
          {
            hole: 5,
            x: -225,
            y: 20,
            z: -44.5
          },
          {
            hole: 6,
            x: -225,
            y: 20,
            z: -35.5
          },
          {
            hole: 7,
            x: -225,
            y: 20,
            z: -27.75
          },
          {
            hole: 8,
            x: -225,
            y: 20,
            z: -20
          },
          {
            hole: 9,
            x: -225,
            y: 20,
            z: -12.25
          },
          {
            hole: 10,
            x: -225,
            y: 20,
            z: -4.5
          },
          {
            hole: 11,
            x: -225,
            y: 20,
            z: 4.5
          },
          {
            hole: 12,
            x: -225,
            y: 20,
            z: 12.25
          },
          {
            hole: 13,
            x: -225,
            y: 20,
            z: 20
          },
          {
            hole: 14,
            x: -225,
            y: 20,
            z: 27.75
          },
          {
            hole: 15,
            x: -225,
            y: 20,
            z: 35.5
          },
          {
            hole: 16,
            x: -225,
            y: 20,
            z: 44.5
          },
          {
            hole: 17,
            x: -225,
            y: 20,
            z: 52.25
          },
          {
            hole: 18,
            x: -225,
            y: 20,
            z: 60
          },
          {
            hole: 19,
            x: -225,
            y: 20,
            z: 67.75
          },
          {
            hole: 20,
            x: -225,
            y: 20,
            z: 75.5
          },
          {
            hole: 21,
            x: -225,
            y: 20,
            z: 84.5
          },
          {
            hole: 22,
            x: -225,
            y: 20,
            z: 92.25
          },
          {
            hole: 23,
            x: -225,
            y: 20,
            z: 100
          },
          {
            hole: 24,
            x: -225,
            y: 20,
            z: 107.75
          },
          {
            hole: 25,
            x: -225,
            y: 20,
            z: 115.5
          },
          {
            hole: 26,
            x: -225,
            y: 20,
            z: 124.5
          },
          {
            hole: 27,
            x: -225,
            y: 20,
            z: 132.25
          },
          {
            hole: 28,
            x: -225,
            y: 20,
            z: 140
          },
          {
            hole: 29,
            x: -225,
            y: 20,
            z: 147.75
          },
          {
            hole: 30,
            x: -225,
            y: 20,
            z: 155.5
          },
          {
            hole: 31,
            x: -225,
            y: 20,
            z: 164.5
          },
          {
            hole: 32,
            x: -225,
            y: 20,
            z: 172.25
          },
          {
            hole: 33,
            x: -225,
            y: 20,
            z: 180
          },
          {
            hole: 34,
            x: -225,
            y: 20,
            z: 187.75
          },
          {
            hole: 35,
            x: -225,
            y: 20,
            z: 195.5
          },
          {
            hole: 36,
            x: -225,
            y: 20,
            z: 204.9999
          },
          {
            hole: 37,
            x: -225,
            y: 20,
            z: 212.4999
          },
          {
            hole: 38,
            x: -225,
            y: 20,
            z: 244.9999
          },
          {
            hole: 39,
            x: -192.5,
            y: 20,
            z: 244.9999
          },
          {
            hole: 40,
            x: -185,
            y: 20,
            z: 244.9999
          },
          {
            hole: 41,
            x: -175.5,
            y: 30,
            z: 245
          },
          {
            hole: 42,
            x: -167.75,
            y: 30,
            z: 245
          },
          {
            hole: 43,
            x: -160,
            y: 30,
            z: 245
          },
          {
            hole: 44,
            x: -152.25,
            y: 30,
            z: 245
          },
          {
            hole: 45,
            x: -144.5,
            y: 30,
            z: 245
          },
          {
            hole: 46,
            x: -135.5,
            y: 30,
            z: 245
          },
          {
            hole: 47,
            x: -127.75,
            y: 30,
            z: 245
          },
          {
            hole: 48,
            x: -120,
            y: 30,
            z: 245
          },
          {
            hole: 49,
            x: -112.25,
            y: 30,
            z: 245
          },
          {
            hole: 50,
            x: -104.5,
            y: 30,
            z: 245
          },
          {
            hole: 51,
            x: -95.5,
            y: 30,
            z: 245
          },
          {
            hole: 52,
            x: -87.75,
            y: 30,
            z: 245
          },
          {
            hole: 53,
            x: -80,
            y: 30,
            z: 245
          },
          {
            hole: 54,
            x: -72.25,
            y: 30,
            z: 245
          },
          {
            hole: 55,
            x: -64.5,
            y: 30,
            z: 245
          },
          {
            hole: 56,
            x: -55.5,
            y: 30,
            z: 245
          },
          {
            hole: 57,
            x: -47.75,
            y: 30,
            z: 245
          },
          {
            hole: 58,
            x: -40,
            y: 30,
            z: 245
          },
          {
            hole: 59,
            x: -32.25,
            y: 30,
            z: 245
          },
          {
            hole: 60,
            x: -24.5,
            y: 30,
            z: 245
          },
          {
            hole: 61,
            x: -15.5,
            y: 30,
            z: 245
          },
          {
            hole: 62,
            x: -7.75,
            y: 30,
            z: 245
          },
          {
            hole: 63,
            x: 0,
            y: 30,
            z: 245
          },
          {
            hole: 64,
            x: 7.75,
            y: 30,
            z: 245
          },
          {
            hole: 65,
            x: 15.5,
            y: 30,
            z: 245
          },
          {
            hole: 66,
            x: 24.5,
            y: 30,
            z: 245
          },
          {
            hole: 67,
            x: 32.25,
            y: 30,
            z: 245
          },
          {
            hole: 68,
            x: 40,
            y: 30,
            z: 245
          },
          {
            hole: 69,
            x: 47.75,
            y: 30,
            z: 245
          },
          {
            hole: 70,
            x: 55.5,
            y: 30,
            z: 245
          },
          {
            hole: 71,
            x: 64.5,
            y: 30,
            z: 245
          },
          {
            hole: 72,
            x: 72.25,
            y: 30,
            z: 245
          },
          {
            hole: 73,
            x: 80,
            y: 30,
            z: 245
          },
          {
            hole: 74,
            x: 87.75,
            y: 30,
            z: 245
          },
          {
            hole: 75,
            x: 95.5,
            y: 30,
            z: 245
          },
          {
            hole: 76,
            x: 104.5,
            y: 30,
            z: 245
          },
          {
            hole: 77,
            x: 112.25,
            y: 30,
            z: 245
          },
          {
            hole: 78,
            x: 120,
            y: 30,
            z: 245
          },
          {
            hole: 79,
            x: 127.75,
            y: 30,
            z: 245
          },
          {
            hole: 80,
            x: 135.5,
            y: 30,
            z: 245
          },
          {
            hole: 81,
            x: 144.5,
            y: 30,
            z: 245
          },
          {
            hole: 82,
            x: 152.25,
            y: 30,
            z: 245
          },
          {
            hole: 83,
            x: 160,
            y: 30,
            z: 245
          },
          {
            hole: 84,
            x: 167.75,
            y: 30,
            z: 245
          },
          {
            hole: 85,
            x: 175.5,
            y: 30,
            z: 245
          },
          {
            hole: 86,
            x: 184.5,
            y: 30,
            z: 245
          },
          {
            hole: 87,
            x: 192.25,
            y: 30,
            z: 245
          },
          {
            hole: 88,
            x: 200,
            y: 30,
            z: 245
          },
          {
            hole: 89,
            x: 207.75,
            y: 30,
            z: 245
          },
          {
            hole: 90,
            x: 215.5,
            y: 30,
            z: 245
          },
          {
            hole: 91,
            x: 224.5,
            y: 30,
            z: 245
          },
          {
            hole: 92,
            x: 232.25,
            y: 30,
            z: 245
          },
          {
            hole: 93,
            x: 240,
            y: 30,
            z: 245
          },
          {
            hole: 94,
            x: 247.75,
            y: 30,
            z: 245
          },
          {
            hole: 95,
            x: 255.5,
            y: 30,
            z: 245
          },
          {
            hole: 96,
            x: 264.5,
            y: 30,
            z: 245
          },
          {
            hole: 97,
            x: 272.25,
            y: 30,
            z: 245
          },
          {
            hole: 98,
            x: 280,
            y: 30,
            z: 245
          },
          {
            hole: 99,
            x: 287.75,
            y: 30,
            z: 245
          },
          {
            hole: 100,
            x: 295.5,
            y: 30,
            z: 245
          },
          {
            hole: 101,
            x: 305,
            y: 30,
            z: 245
          },
          {
            hole: 102,
            x: 312.5,
            y: 30,
            z: 245
          },
          {
            hole: 103,
            x: 345,
            y: 30,
            z: 245
          },
          {
            hole: 104,
            x: 345,
            y: 30,
            z: 212.5
          },
          {
            hole: 105,
            x: 345,
            y: 30,
            z: 205
          },
          {
            hole: 106,
            x: 345,
            y: 40,
            z: 195.5
          },
          {
            hole: 107,
            x: 345,
            y: 40,
            z: 187.75
          },
          {
            hole: 108,
            x: 345,
            y: 40,
            z: 180
          },
          {
            hole: 109,
            x: 345,
            y: 40,
            z: 172.25
          },
          {
            hole: 110,
            x: 345,
            y: 40,
            z: 164.5
          },
          {
            hole: 111,
            x: 345,
            y: 40,
            z: 155.5
          },
          {
            hole: 112,
            x: 345,
            y: 40,
            z: 147.75
          },
          {
            hole: 113,
            x: 345,
            y: 40,
            z: 140
          },
          {
            hole: 114,
            x: 345,
            y: 40,
            z: 132.25
          },
          {
            hole: 115,
            x: 345,
            y: 40,
            z: 124.5
          },
          {
            hole: 116,
            x: 345,
            y: 40,
            z: 115.5
          },
          {
            hole: 117,
            x: 345,
            y: 40,
            z: 107.75
          },
          {
            hole: 118,
            x: 345,
            y: 40,
            z: 100
          },
          {
            hole: 119,
            x: 345,
            y: 40,
            z: 92.25
          },
          {
            hole: 120,
            x: 345,
            y: 40,
            z: 84.5
          },
          {
            hole: 121,
            x: 345,
            y: 40,
            z: 75.5
          },
          {
            hole: 122,
            x: 345,
            y: 40,
            z: 67.75
          },
          {
            hole: 123,
            x: 345,
            y: 40,
            z: 60
          },
          {
            hole: 124,
            x: 345,
            y: 40,
            z: 52.25
          },
          {
            hole: 125,
            x: 345,
            y: 40,
            z: 44.5
          },
          {
            hole: 126,
            x: 345,
            y: 40,
            z: 35.5
          },
          {
            hole: 127,
            x: 345,
            y: 40,
            z: 27.75
          },
          {
            hole: 128,
            x: 345,
            y: 40,
            z: 20
          },
          {
            hole: 129,
            x: 345,
            y: 40,
            z: 12.25
          },
          {
            hole: 130,
            x: 345,
            y: 40,
            z: 4.5
          },
          {
            hole: 131,
            x: 345,
            y: 40,
            z: -4.5
          },
          {
            hole: 132,
            x: 345,
            y: 40,
            z: -12.25
          },
          {
            hole: 133,
            x: 345,
            y: 40,
            z: -20
          },
          {
            hole: 134,
            x: 345,
            y: 40,
            z: -27.75
          },
          {
            hole: 135,
            x: 345,
            y: 40,
            z: -35.5
          },
          {
            hole: 136,
            x: 345,
            y: 40,
            z: -44.5
          },
          {
            hole: 137,
            x: 345,
            y: 40,
            z: -52.25
          },
          {
            hole: 138,
            x: 345,
            y: 40,
            z: -60
          },
          {
            hole: 139,
            x: 345,
            y: 40,
            z: -67.75
          },
          {
            hole: 140,
            x: 345,
            y: 40,
            z: -75.5
          },
          {
            hole: 141,
            x: 345,
            y: 40,
            z: -84.5
          },
          {
            hole: 142,
            x: 345,
            y: 40,
            z: -92.25
          },
          {
            hole: 143,
            x: 345,
            y: 40,
            z: -100
          },
          {
            hole: 144,
            x: 345,
            y: 40,
            z: -107.75
          },
          {
            hole: 145,
            x: 345,
            y: 40,
            z: -115.5
          },
          {
            hole: 146,
            x: 345,
            y: 40,
            z: -124.5
          },
          {
            hole: 147,
            x: 345,
            y: 40,
            z: -132.25
          },
          {
            hole: 148,
            x: 345,
            y: 40,
            z: -140
          },
          {
            hole: 149,
            x: 345,
            y: 40,
            z: -147.75
          },
          {
            hole: 150,
            x: 345,
            y: 40,
            z: -155.5
          },
          {
            hole: 151,
            x: 345,
            y: 40,
            z: -164.5
          },
          {
            hole: 152,
            x: 345,
            y: 40,
            z: -172.25
          },
          {
            hole: 153,
            x: 345,
            y: 40,
            z: -180
          },
          {
            hole: 154,
            x: 345,
            y: 40,
            z: -187.75
          },
          {
            hole: 155,
            x: 345,
            y: 40,
            z: -195.5
          },
          {
            hole: 156,
            x: 345,
            y: 40,
            z: -204.5
          },
          {
            hole: 157,
            x: 345,
            y: 40,
            z: -212.25
          },
          {
            hole: 158,
            x: 345,
            y: 40,
            z: -220
          },
          {
            hole: 159,
            x: 345,
            y: 40,
            z: -227.75
          },
          {
            hole: 160,
            x: 345,
            y: 40,
            z: -235.5
          },
          {
            hole: 161,
            x: 345,
            y: 40,
            z: -245
          },
          {
            hole: 162,
            x: 345,
            y: 40,
            z: -262.5
          },
          {
            hole: 163,
            x: 345,
            y: 40,
            z: -305
          },
          {
            hole: 164,
            x: 302.5,
            y: 40,
            z: -305
          },
          {
            hole: 165,
            x: 285,
            y: 40,
            z: -305
          },
          {
            hole: 166,
            x: 275.5,
            y: 50,
            z: -305
          },
          {
            hole: 167,
            x: 267.75,
            y: 50,
            z: -305
          },
          {
            hole: 168,
            x: 260,
            y: 50,
            z: -305
          },
          {
            hole: 169,
            x: 252.25,
            y: 50,
            z: -305
          },
          {
            hole: 170,
            x: 244.5,
            y: 50,
            z: -305
          },
          {
            hole: 171,
            x: 235.5,
            y: 50,
            z: -305
          },
          {
            hole: 172,
            x: 227.75,
            y: 50,
            z: -305
          },
          {
            hole: 173,
            x: 220,
            y: 50,
            z: -305
          },
          {
            hole: 174,
            x: 212.25,
            y: 50,
            z: -305
          },
          {
            hole: 175,
            x: 204.5,
            y: 50,
            z: -305
          },
          {
            hole: 176,
            x: 195.5,
            y: 50,
            z: -305
          },
          {
            hole: 177,
            x: 187.75,
            y: 50,
            z: -305
          },
          {
            hole: 178,
            x: 180,
            y: 50,
            z: -305
          },
          {
            hole: 179,
            x: 172.25,
            y: 50,
            z: -305
          },
          {
            hole: 180,
            x: 164.5,
            y: 50,
            z: -305
          },
          {
            hole: 181,
            x: 155.5,
            y: 50,
            z: -305
          },
          {
            hole: 182,
            x: 147.75,
            y: 50,
            z: -305
          },
          {
            hole: 183,
            x: 140,
            y: 50,
            z: -305
          },
          {
            hole: 184,
            x: 132.25,
            y: 50,
            z: -305
          },
          {
            hole: 185,
            x: 124.5,
            y: 50,
            z: -305
          },
          {
            hole: 186,
            x: 115.5,
            y: 50,
            z: -305
          },
          {
            hole: 187,
            x: 107.75,
            y: 50,
            z: -305
          },
          {
            hole: 188,
            x: 100,
            y: 50,
            z: -305
          },
          {
            hole: 189,
            x: 92.25,
            y: 50,
            z: -305
          },
          {
            hole: 190,
            x: 84.5,
            y: 50,
            z: -305
          },
          {
            hole: 191,
            x: 75.5,
            y: 50,
            z: -305
          },
          {
            hole: 192,
            x: 67.75,
            y: 50,
            z: -305
          },
          {
            hole: 193,
            x: 60,
            y: 50,
            z: -305
          },
          {
            hole: 194,
            x: 52.25,
            y: 50,
            z: -305
          },
          {
            hole: 195,
            x: 44.5,
            y: 50,
            z: -305
          },
          {
            hole: 196,
            x: 35.5,
            y: 50,
            z: -305
          },
          {
            hole: 197,
            x: 27.75,
            y: 50,
            z: -305
          },
          {
            hole: 198,
            x: 20,
            y: 50,
            z: -305
          },
          {
            hole: 199,
            x: 12.25,
            y: 50,
            z: -305
          },
          {
            hole: 200,
            x: 4.5,
            y: 50,
            z: -305
          },
          {
            hole: 201,
            x: -4.5,
            y: 50,
            z: -305
          },
          {
            hole: 202,
            x: -12.25,
            y: 50,
            z: -305
          },
          {
            hole: 203,
            x: -20,
            y: 50,
            z: -305
          },
          {
            hole: 204,
            x: -27.75,
            y: 50,
            z: -305
          },
          {
            hole: 205,
            x: -35.5,
            y: 50,
            z: -305
          },
          {
            hole: 206,
            x: -44.5,
            y: 50,
            z: -305
          },
          {
            hole: 207,
            x: -52.25,
            y: 50,
            z: -305
          },
          {
            hole: 208,
            x: -60,
            y: 50,
            z: -305
          },
          {
            hole: 209,
            x: -67.75,
            y: 50,
            z: -305
          },
          {
            hole: 210,
            x: -75.5,
            y: 50,
            z: -305
          },
          {
            hole: 211,
            x: -85,
            y: 50,
            z: -305
          },
          {
            hole: 212,
            x: -102.5,
            y: 50,
            z: -305
          },
          {
            hole: 213,
            x: -145,
            y: 50,
            z: -305
          },
          {
            hole: 214,
            x: -145,
            y: 50,
            z: -262.5
          },
          {
            hole: 215,
            x: -145,
            y: 50,
            z: -245
          },
          {
            hole: 216,
            x: -145,
            y: 60,
            z: -235.5
          },
          {
            hole: 217,
            x: -145,
            y: 60,
            z: -227.75
          },
          {
            hole: 218,
            x: -145,
            y: 60,
            z: -220
          },
          {
            hole: 219,
            x: -145,
            y: 60,
            z: -212.25
          },
          {
            hole: 220,
            x: -145,
            y: 60,
            z: -204.5
          },
          {
            hole: 221,
            x: -145,
            y: 60,
            z: -195.5
          },
          {
            hole: 222,
            x: -145,
            y: 60,
            z: -187.75
          },
          {
            hole: 223,
            x: -145,
            y: 60,
            z: -180
          },
          {
            hole: 224,
            x: -145,
            y: 60,
            z: -172.25
          },
          {
            hole: 225,
            x: -145,
            y: 60,
            z: -164.5
          },
          {
            hole: 226,
            x: -145,
            y: 60,
            z: -155.5
          },
          {
            hole: 227,
            x: -145,
            y: 60,
            z: -147.75
          },
          {
            hole: 228,
            x: -145,
            y: 60,
            z: -140
          },
          {
            hole: 229,
            x: -145,
            y: 60,
            z: -132.25
          },
          {
            hole: 230,
            x: -145,
            y: 60,
            z: -124.5
          },
          {
            hole: 231,
            x: -145,
            y: 60,
            z: -115.5
          },
          {
            hole: 232,
            x: -145,
            y: 60,
            z: -107.75
          },
          {
            hole: 233,
            x: -145,
            y: 60,
            z: -100
          },
          {
            hole: 234,
            x: -145,
            y: 60,
            z: -92.25
          },
          {
            hole: 235,
            x: -145,
            y: 60,
            z: -84.5
          },
          {
            hole: 236,
            x: -145,
            y: 60,
            z: -75.5
          },
          {
            hole: 237,
            x: -145,
            y: 60,
            z: -67.75
          },
          {
            hole: 238,
            x: -145,
            y: 60,
            z: -60
          },
          {
            hole: 239,
            x: -145,
            y: 60,
            z: -52.25
          },
          {
            hole: 240,
            x: -145,
            y: 60,
            z: -44.5
          },
          {
            hole: 241,
            x: -145,
            y: 60,
            z: -35.5
          },
          {
            hole: 242,
            x: -145,
            y: 60,
            z: -27.75
          },
          {
            hole: 243,
            x: -145,
            y: 60,
            z: -20
          },
          {
            hole: 244,
            x: -145,
            y: 60,
            z: -12.25
          },
          {
            hole: 245,
            x: -145,
            y: 60,
            z: -4.5
          },
          {
            hole: 246,
            x: -145,
            y: 60,
            z: 4.5
          },
          {
            hole: 247,
            x: -145,
            y: 60,
            z: 12.25
          },
          {
            hole: 248,
            x: -145,
            y: 60,
            z: 20
          },
          {
            hole: 249,
            x: -145,
            y: 60,
            z: 27.75
          },
          {
            hole: 250,
            x: -145,
            y: 60,
            z: 35.5
          },
          {
            hole: 251,
            x: -145,
            y: 60,
            z: 44.5
          },
          {
            hole: 252,
            x: -145,
            y: 60,
            z: 52.25
          },
          {
            hole: 253,
            x: -145,
            y: 60,
            z: 60
          },
          {
            hole: 254,
            x: -145,
            y: 60,
            z: 67.75
          },
          {
            hole: 255,
            x: -145,
            y: 60,
            z: 75.5
          },
          {
            hole: 256,
            x: -145,
            y: 60,
            z: 84.5
          },
          {
            hole: 257,
            x: -145,
            y: 60,
            z: 92.25
          },
          {
            hole: 258,
            x: -145,
            y: 60,
            z: 100
          },
          {
            hole: 259,
            x: -145,
            y: 60,
            z: 107.75
          },
          {
            hole: 260,
            x: -145,
            y: 60,
            z: 115.5
          },
          {
            hole: 261,
            x: -145,
            y: 60,
            z: 125
          },
          {
            hole: 262,
            x: -145,
            y: 60,
            z: 132.5
          },
          {
            hole: 263,
            x: -145,
            y: 60,
            z: 165
          },
          {
            hole: 264,
            x: -112.5,
            y: 60,
            z: 165
          },
          {
            hole: 265,
            x: -105,
            y: 60,
            z: 165
          },
          {
            hole: 266,
            x: -95.5,
            y: 70,
            z: 165
          },
          {
            hole: 267,
            x: -87.75,
            y: 70,
            z: 165
          },
          {
            hole: 268,
            x: -80,
            y: 70,
            z: 165
          },
          {
            hole: 269,
            x: -72.25,
            y: 70,
            z: 165
          },
          {
            hole: 270,
            x: -64.5,
            y: 70,
            z: 165
          },
          {
            hole: 271,
            x: -55.5,
            y: 70,
            z: 165
          },
          {
            hole: 272,
            x: -47.75,
            y: 70,
            z: 165
          },
          {
            hole: 273,
            x: -40,
            y: 70,
            z: 165
          },
          {
            hole: 274,
            x: -32.25,
            y: 70,
            z: 165
          },
          {
            hole: 275,
            x: -24.5,
            y: 70,
            z: 165
          },
          {
            hole: 276,
            x: -15.5,
            y: 70,
            z: 165
          },
          {
            hole: 277,
            x: -7.75,
            y: 70,
            z: 165
          },
          {
            hole: 278,
            x: 0,
            y: 70,
            z: 165
          },
          {
            hole: 279,
            x: 7.75,
            y: 70,
            z: 165
          },
          {
            hole: 280,
            x: 15.5,
            y: 70,
            z: 165
          },
          {
            hole: 281,
            x: 24.5,
            y: 70,
            z: 165
          },
          {
            hole: 282,
            x: 32.25,
            y: 70,
            z: 165
          },
          {
            hole: 283,
            x: 40,
            y: 70,
            z: 165
          },
          {
            hole: 284,
            x: 47.75,
            y: 70,
            z: 165
          },
          {
            hole: 285,
            x: 55.5,
            y: 70,
            z: 165
          },
          {
            hole: 286,
            x: 64.5,
            y: 70,
            z: 165
          },
          {
            hole: 287,
            x: 72.25,
            y: 70,
            z: 165
          },
          {
            hole: 288,
            x: 80,
            y: 70,
            z: 165
          },
          {
            hole: 289,
            x: 87.75,
            y: 70,
            z: 165
          },
          {
            hole: 290,
            x: 95.5,
            y: 70,
            z: 165
          },
          {
            hole: 291,
            x: 104.5,
            y: 70,
            z: 165
          },
          {
            hole: 292,
            x: 112.25,
            y: 70,
            z: 165
          },
          {
            hole: 293,
            x: 120,
            y: 70,
            z: 165
          },
          {
            hole: 294,
            x: 127.75,
            y: 70,
            z: 165
          },
          {
            hole: 295,
            x: 135.5,
            y: 70,
            z: 165
          },
          {
            hole: 296,
            x: 144.5,
            y: 70,
            z: 165
          },
          {
            hole: 297,
            x: 152.25,
            y: 70,
            z: 165
          },
          {
            hole: 298,
            x: 160,
            y: 70,
            z: 165
          },
          {
            hole: 299,
            x: 167.75,
            y: 70,
            z: 165
          },
          {
            hole: 300,
            x: 175.5,
            y: 70,
            z: 165
          },
          {
            hole: 301,
            x: 184.5,
            y: 70,
            z: 165
          },
          {
            hole: 302,
            x: 192.25,
            y: 70,
            z: 165
          },
          {
            hole: 303,
            x: 200,
            y: 70,
            z: 165
          },
          {
            hole: 304,
            x: 207.75,
            y: 70,
            z: 165
          },
          {
            hole: 305,
            x: 215.5,
            y: 70,
            z: 165
          },
          {
            hole: 306,
            x: 225,
            y: 70,
            z: 165
          },
          {
            hole: 307,
            x: 232.5,
            y: 70,
            z: 165
          },
          {
            hole: 308,
            x: 265,
            y: 70,
            z: 165
          },
          {
            hole: 309,
            x: 265,
            y: 70,
            z: 132.5
          },
          {
            hole: 310,
            x: 265,
            y: 70,
            z: 125
          },
          {
            hole: 311,
            x: 265,
            y: 80,
            z: 115.5
          },
          {
            hole: 312,
            x: 265,
            y: 80,
            z: 107.75
          },
          {
            hole: 313,
            x: 265,
            y: 80,
            z: 100
          },
          {
            hole: 314,
            x: 265,
            y: 80,
            z: 92.25
          },
          {
            hole: 315,
            x: 265,
            y: 80,
            z: 84.5
          },
          {
            hole: 316,
            x: 265,
            y: 80,
            z: 75.5
          },
          {
            hole: 317,
            x: 265,
            y: 80,
            z: 67.75
          },
          {
            hole: 318,
            x: 265,
            y: 80,
            z: 60
          },
          {
            hole: 319,
            x: 265,
            y: 80,
            z: 52.25
          },
          {
            hole: 320,
            x: 265,
            y: 80,
            z: 44.5
          },
          {
            hole: 321,
            x: 265,
            y: 80,
            z: 35.5
          },
          {
            hole: 322,
            x: 265,
            y: 80,
            z: 27.75
          },
          {
            hole: 323,
            x: 265,
            y: 80,
            z: 20
          },
          {
            hole: 324,
            x: 265,
            y: 80,
            z: 12.25
          },
          {
            hole: 325,
            x: 265,
            y: 80,
            z: 4.5
          },
          {
            hole: 326,
            x: 265,
            y: 80,
            z: -4.5
          },
          {
            hole: 327,
            x: 265,
            y: 80,
            z: -12.25
          },
          {
            hole: 328,
            x: 265,
            y: 80,
            z: -20
          },
          {
            hole: 329,
            x: 265,
            y: 80,
            z: -27.75
          },
          {
            hole: 330,
            x: 265,
            y: 80,
            z: -35.5
          },
          {
            hole: 331,
            x: 265,
            y: 80,
            z: -44.5
          },
          {
            hole: 332,
            x: 265,
            y: 80,
            z: -52.25
          },
          {
            hole: 333,
            x: 265,
            y: 80,
            z: -60
          },
          {
            hole: 334,
            x: 265,
            y: 80,
            z: -67.75
          },
          {
            hole: 335,
            x: 265,
            y: 80,
            z: -75.5
          },
          {
            hole: 336,
            x: 265,
            y: 80,
            z: -84.5
          },
          {
            hole: 337,
            x: 265,
            y: 80,
            z: -92.25
          },
          {
            hole: 338,
            x: 265,
            y: 80,
            z: -100
          },
          {
            hole: 339,
            x: 265,
            y: 80,
            z: -107.75
          },
          {
            hole: 340,
            x: 265,
            y: 80,
            z: -115.5
          },
          {
            hole: 341,
            x: 265,
            y: 80,
            z: -124.5
          },
          {
            hole: 342,
            x: 265,
            y: 80,
            z: -132.25
          },
          {
            hole: 343,
            x: 265,
            y: 80,
            z: -140
          },
          {
            hole: 344,
            x: 265,
            y: 80,
            z: -147.75
          },
          {
            hole: 345,
            x: 265,
            y: 80,
            z: -155.5
          },
          {
            hole: 346,
            x: 265,
            y: 80,
            z: -165
          },
          {
            hole: 347,
            x: 265,
            y: 80,
            z: -182.5
          },
          {
            hole: 348,
            x: 265,
            y: 80,
            z: -225
          },
          {
            hole: 349,
            x: 222.5,
            y: 80,
            z: -225
          },
          {
            hole: 350,
            x: 205,
            y: 80,
            z: -225
          },
          {
            hole: 351,
            x: 195.5,
            y: 90,
            z: -225
          },
          {
            hole: 352,
            x: 187.75,
            y: 90,
            z: -225
          },
          {
            hole: 353,
            x: 180,
            y: 90,
            z: -225
          },
          {
            hole: 354,
            x: 172.25,
            y: 90,
            z: -225
          },
          {
            hole: 355,
            x: 164.5,
            y: 90,
            z: -225
          },
          {
            hole: 356,
            x: 155.5,
            y: 90,
            z: -225
          },
          {
            hole: 357,
            x: 147.75,
            y: 90,
            z: -225
          },
          {
            hole: 358,
            x: 140,
            y: 90,
            z: -225
          },
          {
            hole: 359,
            x: 132.25,
            y: 90,
            z: -225
          },
          {
            hole: 360,
            x: 124.5,
            y: 90,
            z: -225
          },
          {
            hole: 361,
            x: 115.5,
            y: 90,
            z: -225
          },
          {
            hole: 362,
            x: 107.75,
            y: 90,
            z: -225
          },
          {
            hole: 363,
            x: 100,
            y: 90,
            z: -225
          },
          {
            hole: 364,
            x: 92.25,
            y: 90,
            z: -225
          },
          {
            hole: 365,
            x: 84.5,
            y: 90,
            z: -225
          },
          {
            hole: 366,
            x: 75.5,
            y: 90,
            z: -225
          },
          {
            hole: 367,
            x: 67.75,
            y: 90,
            z: -225
          },
          {
            hole: 368,
            x: 60,
            y: 90,
            z: -225
          },
          {
            hole: 369,
            x: 52.25,
            y: 90,
            z: -225
          },
          {
            hole: 370,
            x: 44.5,
            y: 90,
            z: -225
          },
          {
            hole: 371,
            x: 35.5,
            y: 90,
            z: -225
          },
          {
            hole: 372,
            x: 27.75,
            y: 90,
            z: -225
          },
          {
            hole: 373,
            x: 20,
            y: 90,
            z: -225
          },
          {
            hole: 374,
            x: 12.25,
            y: 90,
            z: -225
          },
          {
            hole: 375,
            x: 4.5,
            y: 90,
            z: -225
          },
          {
            hole: 376,
            x: -5,
            y: 90,
            z: -225
          },
          {
            hole: 377,
            x: -22.5,
            y: 90,
            z: -225
          },
          {
            hole: 378,
            x: -65,
            y: 90,
            z: -225
          },
          {
            hole: 379,
            x: -65,
            y: 90,
            z: -182.5
          },
          {
            hole: 380,
            x: -65,
            y: 90,
            z: -165
          },
          {
            hole: 381,
            x: -65,
            y: 100,
            z: -155.5
          },
          {
            hole: 382,
            x: -65,
            y: 100,
            z: -147.75
          },
          {
            hole: 383,
            x: -65,
            y: 100,
            z: -140
          },
          {
            hole: 384,
            x: -65,
            y: 100,
            z: -132.25
          },
          {
            hole: 385,
            x: -65,
            y: 100,
            z: -124.5
          },
          {
            hole: 386,
            x: -65,
            y: 100,
            z: -115.5
          },
          {
            hole: 387,
            x: -65,
            y: 100,
            z: -107.75
          },
          {
            hole: 388,
            x: -65,
            y: 100,
            z: -100
          },
          {
            hole: 389,
            x: -65,
            y: 100,
            z: -92.25
          },
          {
            hole: 390,
            x: -65,
            y: 100,
            z: -84.5
          },
          {
            hole: 391,
            x: -65,
            y: 100,
            z: -75.5
          },
          {
            hole: 392,
            x: -65,
            y: 100,
            z: -67.75
          },
          {
            hole: 393,
            x: -65,
            y: 100,
            z: -60
          },
          {
            hole: 394,
            x: -65,
            y: 100,
            z: -52.25
          },
          {
            hole: 395,
            x: -65,
            y: 100,
            z: -44.5
          },
          {
            hole: 396,
            x: -65,
            y: 100,
            z: -35.5
          },
          {
            hole: 397,
            x: -65,
            y: 100,
            z: -27.75
          },
          {
            hole: 398,
            x: -65,
            y: 100,
            z: -20
          },
          {
            hole: 399,
            x: -65,
            y: 100,
            z: -12.25
          },
          {
            hole: 400,
            x: -65,
            y: 100,
            z: -4.5
          },
          {
            hole: 401,
            x: -65,
            y: 100,
            z: 4.5
          },
          {
            hole: 402,
            x: -65,
            y: 100,
            z: 12.25
          },
          {
            hole: 403,
            x: -65,
            y: 100,
            z: 20
          },
          {
            hole: 404,
            x: -65,
            y: 100,
            z: 27.75
          },
          {
            hole: 405,
            x: -65,
            y: 100,
            z: 35.5
          },
          {
            hole: 406,
            x: -65,
            y: 100,
            z: 45
          },
          {
            hole: 407,
            x: -65,
            y: 100,
            z: 52.5
          },
          {
            hole: 408,
            x: -65,
            y: 100,
            z: 85
          },
          {
            hole: 409,
            x: -32.5,
            y: 100,
            z: 85
          },
          {
            hole: 410,
            x: -25,
            y: 100,
            z: 85
          },
          {
            hole: 411,
            x: -15.5,
            y: 110,
            z: 85
          },
          {
            hole: 412,
            x: -7.75,
            y: 110,
            z: 85
          },
          {
            hole: 413,
            x: 0,
            y: 110,
            z: 85
          },
          {
            hole: 414,
            x: 7.75,
            y: 110,
            z: 85
          },
          {
            hole: 415,
            x: 15.5,
            y: 110,
            z: 85
          },
          {
            hole: 416,
            x: 24.5,
            y: 110,
            z: 85
          },
          {
            hole: 417,
            x: 32.25,
            y: 110,
            z: 85
          },
          {
            hole: 418,
            x: 40,
            y: 110,
            z: 85
          },
          {
            hole: 419,
            x: 47.75,
            y: 110,
            z: 85
          },
          {
            hole: 420,
            x: 55.5,
            y: 110,
            z: 85
          },
          {
            hole: 421,
            x: 64.5,
            y: 110,
            z: 85
          },
          {
            hole: 422,
            x: 72.25,
            y: 110,
            z: 85
          },
          {
            hole: 423,
            x: 80,
            y: 110,
            z: 85
          },
          {
            hole: 424,
            x: 87.75,
            y: 110,
            z: 85
          },
          {
            hole: 425,
            x: 95.5,
            y: 110,
            z: 85
          },
          {
            hole: 426,
            x: 104.5,
            y: 110,
            z: 85
          },
          {
            hole: 427,
            x: 112.25,
            y: 110,
            z: 85
          },
          {
            hole: 428,
            x: 120,
            y: 110,
            z: 85
          },
          {
            hole: 429,
            x: 127.75,
            y: 110,
            z: 85
          },
          {
            hole: 430,
            x: 135.5,
            y: 110,
            z: 85
          },
          {
            hole: 431,
            x: 145,
            y: 110,
            z: 85
          },
          {
            hole: 432,
            x: 152.5,
            y: 110,
            z: 85
          },
          {
            hole: 433,
            x: 185,
            y: 110,
            z: 85
          },
          {
            hole: 434,
            x: 185,
            y: 110,
            z: 52.5
          },
          {
            hole: 435,
            x: 185,
            y: 110,
            z: 45
          },
          {
            hole: 436,
            x: 185,
            y: 120,
            z: 35.5
          },
          {
            hole: 437,
            x: 185,
            y: 120,
            z: 27.75
          },
          {
            hole: 438,
            x: 185,
            y: 120,
            z: 20
          },
          {
            hole: 439,
            x: 185,
            y: 120,
            z: 12.25
          },
          {
            hole: 440,
            x: 185,
            y: 120,
            z: 4.5
          },
          {
            hole: 441,
            x: 185,
            y: 120,
            z: -4.5
          },
          {
            hole: 442,
            x: 185,
            y: 120,
            z: -12.25
          },
          {
            hole: 443,
            x: 185,
            y: 120,
            z: -20
          },
          {
            hole: 444,
            x: 185,
            y: 120,
            z: -27.75
          },
          {
            hole: 445,
            x: 185,
            y: 120,
            z: -35.5
          },
          {
            hole: 446,
            x: 185,
            y: 120,
            z: -44.5
          },
          {
            hole: 447,
            x: 185,
            y: 120,
            z: -52.25
          },
          {
            hole: 448,
            x: 185,
            y: 120,
            z: -60
          },
          {
            hole: 449,
            x: 185,
            y: 120,
            z: -67.75
          },
          {
            hole: 450,
            x: 185,
            y: 120,
            z: -75.5
          },
          {
            hole: 451,
            x: 185,
            y: 120,
            z: -85
          },
          {
            hole: 452,
            x: 185,
            y: 120,
            z: -102.5
          },
          {
            hole: 453,
            x: 185,
            y: 120,
            z: -145
          },
          {
            hole: 454,
            x: 142.5,
            y: 120,
            z: -145
          },
          {
            hole: 455,
            x: 125,
            y: 120,
            z: -145
          },
          {
            hole: 456,
            x: 115.5,
            y: 130,
            z: -145
          },
          {
            hole: 457,
            x: 107.75,
            y: 130,
            z: -145
          },
          {
            hole: 458,
            x: 100,
            y: 130,
            z: -145
          },
          {
            hole: 459,
            x: 92.25,
            y: 130,
            z: -145
          },
          {
            hole: 460,
            x: 84.5,
            y: 130,
            z: -145
          },
          {
            hole: 461,
            x: 75,
            y: 130,
            z: -145
          },
          {
            hole: 462,
            x: 57.5,
            y: 130,
            z: -145
          },
          {
            hole: 463,
            x: 15,
            y: 130,
            z: -145
          },
          {
            hole: 464,
            x: 15,
            y: 130,
            z: -102.5
          },
          {
            hole: 465,
            x: 15,
            y: 130,
            z: -85
          },
          {
            hole: 466,
            x: 15,
            y: 140,
            z: -75.5
          },
          {
            hole: 467,
            x: 15,
            y: 140,
            z: -67.75
          },
          {
            hole: 468,
            x: 15,
            y: 140,
            z: -60
          },
          {
            hole: 469,
            x: 15,
            y: 140,
            z: -52.25
          },
          {
            hole: 470,
            x: 15,
            y: 140,
            z: -44.5
          },
          {
            hole: 471,
            x: 15,
            y: 140,
            z: -35
          },
          {
            hole: 472,
            x: 15,
            y: 140,
            z: -27.5
          },
          {
            hole: 473,
            x: 15,
            y: 140,
            z: 5
          },
          {
            hole: 474,
            x: 47.5,
            y: 140,
            z: 5
          },
          {
            hole: 475,
            x: 55,
            y: 140,
            z: 5
          },
          {
            hole: 476,
            x: 65,
            y: 150,
            z: 5
          },
          {
            hole: 477,
            x: 72.5,
            y: 150,
            z: 5
          },
          {
            hole: 478,
            x: 105,
            y: 150,
            z: 5
          },
          {
            hole: 479,
            x: 105,
            y: 150,
            z: -27.5
          },
          {
            hole: 480,
            x: 105,
            y: 150,
            z: -35
          },
          {
            hole: 121,
            x: 100,
            y: 160,
            z: -60
          }
        ],
        p3: [
          {
            hole: 0,
            x: -225,
            y: 10,
            z: -93
          },
          {
            hole: 1,
            x: -215,
            y: 20,
            z: -75.5
          },
          {
            hole: 2,
            x: -215,
            y: 20,
            z: -67.75
          },
          {
            hole: 3,
            x: -215,
            y: 20,
            z: -60
          },
          {
            hole: 4,
            x: -215,
            y: 20,
            z: -52.25
          },
          {
            hole: 5,
            x: -215,
            y: 20,
            z: -44.5
          },
          {
            hole: 6,
            x: -215,
            y: 20,
            z: -35.5
          },
          {
            hole: 7,
            x: -215,
            y: 20,
            z: -27.75
          },
          {
            hole: 8,
            x: -215,
            y: 20,
            z: -20
          },
          {
            hole: 9,
            x: -215,
            y: 20,
            z: -12.25
          },
          {
            hole: 10,
            x: -215,
            y: 20,
            z: -4.5
          },
          {
            hole: 11,
            x: -215,
            y: 20,
            z: 4.5
          },
          {
            hole: 12,
            x: -215,
            y: 20,
            z: 12.25
          },
          {
            hole: 13,
            x: -215,
            y: 20,
            z: 20
          },
          {
            hole: 14,
            x: -215,
            y: 20,
            z: 27.75
          },
          {
            hole: 15,
            x: -215,
            y: 20,
            z: 35.5
          },
          {
            hole: 16,
            x: -215,
            y: 20,
            z: 44.5
          },
          {
            hole: 17,
            x: -215,
            y: 20,
            z: 52.25
          },
          {
            hole: 18,
            x: -215,
            y: 20,
            z: 60
          },
          {
            hole: 19,
            x: -215,
            y: 20,
            z: 67.75
          },
          {
            hole: 20,
            x: -215,
            y: 20,
            z: 75.5
          },
          {
            hole: 21,
            x: -215,
            y: 20,
            z: 84.5
          },
          {
            hole: 22,
            x: -215,
            y: 20,
            z: 92.25
          },
          {
            hole: 23,
            x: -215,
            y: 20,
            z: 100
          },
          {
            hole: 24,
            x: -215,
            y: 20,
            z: 107.75
          },
          {
            hole: 25,
            x: -215,
            y: 20,
            z: 115.5
          },
          {
            hole: 26,
            x: -215,
            y: 20,
            z: 124.5
          },
          {
            hole: 27,
            x: -215,
            y: 20,
            z: 132.25
          },
          {
            hole: 28,
            x: -215,
            y: 20,
            z: 140
          },
          {
            hole: 29,
            x: -215,
            y: 20,
            z: 147.75
          },
          {
            hole: 30,
            x: -215,
            y: 20,
            z: 155.5
          },
          {
            hole: 31,
            x: -215,
            y: 20,
            z: 164.5
          },
          {
            hole: 32,
            x: -215,
            y: 20,
            z: 172.25
          },
          {
            hole: 33,
            x: -215,
            y: 20,
            z: 180
          },
          {
            hole: 34,
            x: -215,
            y: 20,
            z: 187.75
          },
          {
            hole: 35,
            x: -215,
            y: 20,
            z: 195.5
          },
          {
            hole: 36,
            x: -215,
            y: 20,
            z: 204.9999
          },
          {
            hole: 37,
            x: -215,
            y: 20,
            z: 212.4999
          },
          {
            hole: 38,
            x: -215,
            y: 20,
            z: 234.9999
          },
          {
            hole: 39,
            x: -192.5,
            y: 20,
            z: 234.9999
          },
          {
            hole: 40,
            x: -185,
            y: 20,
            z: 234.9999
          },
          {
            hole: 41,
            x: -175.5,
            y: 30,
            z: 235
          },
          {
            hole: 42,
            x: -167.75,
            y: 30,
            z: 235
          },
          {
            hole: 43,
            x: -160,
            y: 30,
            z: 235
          },
          {
            hole: 44,
            x: -152.25,
            y: 30,
            z: 235
          },
          {
            hole: 45,
            x: -144.5,
            y: 30,
            z: 235
          },
          {
            hole: 46,
            x: -135.5,
            y: 30,
            z: 235
          },
          {
            hole: 47,
            x: -127.75,
            y: 30,
            z: 235
          },
          {
            hole: 48,
            x: -120,
            y: 30,
            z: 235
          },
          {
            hole: 49,
            x: -112.25,
            y: 30,
            z: 235
          },
          {
            hole: 50,
            x: -104.5,
            y: 30,
            z: 235
          },
          {
            hole: 51,
            x: -95.5,
            y: 30,
            z: 235
          },
          {
            hole: 52,
            x: -87.75,
            y: 30,
            z: 235
          },
          {
            hole: 53,
            x: -80,
            y: 30,
            z: 235
          },
          {
            hole: 54,
            x: -72.25,
            y: 30,
            z: 235
          },
          {
            hole: 55,
            x: -64.5,
            y: 30,
            z: 235
          },
          {
            hole: 56,
            x: -55.5,
            y: 30,
            z: 235
          },
          {
            hole: 57,
            x: -47.75,
            y: 30,
            z: 235
          },
          {
            hole: 58,
            x: -40,
            y: 30,
            z: 235
          },
          {
            hole: 59,
            x: -32.25,
            y: 30,
            z: 235
          },
          {
            hole: 60,
            x: -24.5,
            y: 30,
            z: 235
          },
          {
            hole: 61,
            x: -15.5,
            y: 30,
            z: 235
          },
          {
            hole: 62,
            x: -7.75,
            y: 30,
            z: 235
          },
          {
            hole: 63,
            x: 0,
            y: 30,
            z: 235
          },
          {
            hole: 64,
            x: 7.75,
            y: 30,
            z: 235
          },
          {
            hole: 65,
            x: 15.5,
            y: 30,
            z: 235
          },
          {
            hole: 66,
            x: 24.5,
            y: 30,
            z: 235
          },
          {
            hole: 67,
            x: 32.25,
            y: 30,
            z: 235
          },
          {
            hole: 68,
            x: 40,
            y: 30,
            z: 235
          },
          {
            hole: 69,
            x: 47.75,
            y: 30,
            z: 235
          },
          {
            hole: 70,
            x: 55.5,
            y: 30,
            z: 235
          },
          {
            hole: 71,
            x: 64.5,
            y: 30,
            z: 235
          },
          {
            hole: 72,
            x: 72.25,
            y: 30,
            z: 235
          },
          {
            hole: 73,
            x: 80,
            y: 30,
            z: 235
          },
          {
            hole: 74,
            x: 87.75,
            y: 30,
            z: 235
          },
          {
            hole: 75,
            x: 95.5,
            y: 30,
            z: 235
          },
          {
            hole: 76,
            x: 104.5,
            y: 30,
            z: 235
          },
          {
            hole: 77,
            x: 112.25,
            y: 30,
            z: 235
          },
          {
            hole: 78,
            x: 120,
            y: 30,
            z: 235
          },
          {
            hole: 79,
            x: 127.75,
            y: 30,
            z: 235
          },
          {
            hole: 80,
            x: 135.5,
            y: 30,
            z: 235
          },
          {
            hole: 81,
            x: 144.5,
            y: 30,
            z: 235
          },
          {
            hole: 82,
            x: 152.25,
            y: 30,
            z: 235
          },
          {
            hole: 83,
            x: 160,
            y: 30,
            z: 235
          },
          {
            hole: 84,
            x: 167.75,
            y: 30,
            z: 235
          },
          {
            hole: 85,
            x: 175.5,
            y: 30,
            z: 235
          },
          {
            hole: 86,
            x: 184.5,
            y: 30,
            z: 235
          },
          {
            hole: 87,
            x: 192.25,
            y: 30,
            z: 235
          },
          {
            hole: 88,
            x: 200,
            y: 30,
            z: 235
          },
          {
            hole: 89,
            x: 207.75,
            y: 30,
            z: 235
          },
          {
            hole: 90,
            x: 215.5,
            y: 30,
            z: 235
          },
          {
            hole: 91,
            x: 224.5,
            y: 30,
            z: 235
          },
          {
            hole: 92,
            x: 232.25,
            y: 30,
            z: 235
          },
          {
            hole: 93,
            x: 240,
            y: 30,
            z: 235
          },
          {
            hole: 94,
            x: 247.75,
            y: 30,
            z: 235
          },
          {
            hole: 95,
            x: 255.5,
            y: 30,
            z: 235
          },
          {
            hole: 96,
            x: 264.5,
            y: 30,
            z: 235
          },
          {
            hole: 97,
            x: 272.25,
            y: 30,
            z: 235
          },
          {
            hole: 98,
            x: 280,
            y: 30,
            z: 235
          },
          {
            hole: 99,
            x: 287.75,
            y: 30,
            z: 235
          },
          {
            hole: 100,
            x: 295.5,
            y: 30,
            z: 235
          },
          {
            hole: 101,
            x: 305,
            y: 30,
            z: 235
          },
          {
            hole: 102,
            x: 312.5,
            y: 30,
            z: 235
          },
          {
            hole: 103,
            x: 335,
            y: 30,
            z: 235
          },
          {
            hole: 104,
            x: 335,
            y: 30,
            z: 212.5
          },
          {
            hole: 105,
            x: 335,
            y: 30,
            z: 205
          },
          {
            hole: 106,
            x: 335,
            y: 40,
            z: 195.5
          },
          {
            hole: 107,
            x: 335,
            y: 40,
            z: 187.75
          },
          {
            hole: 108,
            x: 335,
            y: 40,
            z: 180
          },
          {
            hole: 109,
            x: 335,
            y: 40,
            z: 172.25
          },
          {
            hole: 110,
            x: 335,
            y: 40,
            z: 164.5
          },
          {
            hole: 111,
            x: 335,
            y: 40,
            z: 155.5
          },
          {
            hole: 112,
            x: 335,
            y: 40,
            z: 147.75
          },
          {
            hole: 113,
            x: 335,
            y: 40,
            z: 140
          },
          {
            hole: 114,
            x: 335,
            y: 40,
            z: 132.25
          },
          {
            hole: 115,
            x: 335,
            y: 40,
            z: 124.5
          },
          {
            hole: 116,
            x: 335,
            y: 40,
            z: 115.5
          },
          {
            hole: 117,
            x: 335,
            y: 40,
            z: 107.75
          },
          {
            hole: 118,
            x: 335,
            y: 40,
            z: 100
          },
          {
            hole: 119,
            x: 335,
            y: 40,
            z: 92.25
          },
          {
            hole: 120,
            x: 335,
            y: 40,
            z: 84.5
          },
          {
            hole: 121,
            x: 335,
            y: 40,
            z: 75.5
          },
          {
            hole: 122,
            x: 335,
            y: 40,
            z: 67.75
          },
          {
            hole: 123,
            x: 335,
            y: 40,
            z: 60
          },
          {
            hole: 124,
            x: 335,
            y: 40,
            z: 52.25
          },
          {
            hole: 125,
            x: 335,
            y: 40,
            z: 44.5
          },
          {
            hole: 126,
            x: 335,
            y: 40,
            z: 35.5
          },
          {
            hole: 127,
            x: 335,
            y: 40,
            z: 27.75
          },
          {
            hole: 128,
            x: 335,
            y: 40,
            z: 20
          },
          {
            hole: 129,
            x: 335,
            y: 40,
            z: 12.25
          },
          {
            hole: 130,
            x: 335,
            y: 40,
            z: 4.5
          },
          {
            hole: 131,
            x: 335,
            y: 40,
            z: -4.5
          },
          {
            hole: 132,
            x: 335,
            y: 40,
            z: -12.25
          },
          {
            hole: 133,
            x: 335,
            y: 40,
            z: -20
          },
          {
            hole: 134,
            x: 335,
            y: 40,
            z: -27.75
          },
          {
            hole: 135,
            x: 335,
            y: 40,
            z: -35.5
          },
          {
            hole: 136,
            x: 335,
            y: 40,
            z: -44.5
          },
          {
            hole: 137,
            x: 335,
            y: 40,
            z: -52.25
          },
          {
            hole: 138,
            x: 335,
            y: 40,
            z: -60
          },
          {
            hole: 139,
            x: 335,
            y: 40,
            z: -67.75
          },
          {
            hole: 140,
            x: 335,
            y: 40,
            z: -75.5
          },
          {
            hole: 141,
            x: 335,
            y: 40,
            z: -84.5
          },
          {
            hole: 142,
            x: 335,
            y: 40,
            z: -92.25
          },
          {
            hole: 143,
            x: 335,
            y: 40,
            z: -100
          },
          {
            hole: 144,
            x: 335,
            y: 40,
            z: -107.75
          },
          {
            hole: 145,
            x: 335,
            y: 40,
            z: -115.5
          },
          {
            hole: 146,
            x: 335,
            y: 40,
            z: -124.5
          },
          {
            hole: 147,
            x: 335,
            y: 40,
            z: -132.25
          },
          {
            hole: 148,
            x: 335,
            y: 40,
            z: -140
          },
          {
            hole: 149,
            x: 335,
            y: 40,
            z: -147.75
          },
          {
            hole: 150,
            x: 335,
            y: 40,
            z: -155.5
          },
          {
            hole: 151,
            x: 335,
            y: 40,
            z: -164.5
          },
          {
            hole: 152,
            x: 335,
            y: 40,
            z: -172.25
          },
          {
            hole: 153,
            x: 335,
            y: 40,
            z: -180
          },
          {
            hole: 154,
            x: 335,
            y: 40,
            z: -187.75
          },
          {
            hole: 155,
            x: 335,
            y: 40,
            z: -195.5
          },
          {
            hole: 156,
            x: 335,
            y: 40,
            z: -204.5
          },
          {
            hole: 157,
            x: 335,
            y: 40,
            z: -212.25
          },
          {
            hole: 158,
            x: 335,
            y: 40,
            z: -220
          },
          {
            hole: 159,
            x: 335,
            y: 40,
            z: -227.75
          },
          {
            hole: 160,
            x: 335,
            y: 40,
            z: -235.5
          },
          {
            hole: 161,
            x: 335,
            y: 40,
            z: -245
          },
          {
            hole: 162,
            x: 335,
            y: 40,
            z: -262.5
          },
          {
            hole: 163,
            x: 335,
            y: 40,
            z: -295
          },
          {
            hole: 164,
            x: 302.5,
            y: 40,
            z: -295
          },
          {
            hole: 165,
            x: 285,
            y: 40,
            z: -295
          },
          {
            hole: 166,
            x: 275.5,
            y: 50,
            z: -295
          },
          {
            hole: 167,
            x: 267.75,
            y: 50,
            z: -295
          },
          {
            hole: 168,
            x: 260,
            y: 50,
            z: -295
          },
          {
            hole: 169,
            x: 252.25,
            y: 50,
            z: -295
          },
          {
            hole: 170,
            x: 244.5,
            y: 50,
            z: -295
          },
          {
            hole: 171,
            x: 235.5,
            y: 50,
            z: -295
          },
          {
            hole: 172,
            x: 227.75,
            y: 50,
            z: -295
          },
          {
            hole: 173,
            x: 220,
            y: 50,
            z: -295
          },
          {
            hole: 174,
            x: 212.25,
            y: 50,
            z: -295
          },
          {
            hole: 175,
            x: 204.5,
            y: 50,
            z: -295
          },
          {
            hole: 176,
            x: 195.5,
            y: 50,
            z: -295
          },
          {
            hole: 177,
            x: 187.75,
            y: 50,
            z: -295
          },
          {
            hole: 178,
            x: 180,
            y: 50,
            z: -295
          },
          {
            hole: 179,
            x: 172.25,
            y: 50,
            z: -295
          },
          {
            hole: 180,
            x: 164.5,
            y: 50,
            z: -295
          },
          {
            hole: 181,
            x: 155.5,
            y: 50,
            z: -295
          },
          {
            hole: 182,
            x: 147.75,
            y: 50,
            z: -295
          },
          {
            hole: 183,
            x: 140,
            y: 50,
            z: -295
          },
          {
            hole: 184,
            x: 132.25,
            y: 50,
            z: -295
          },
          {
            hole: 185,
            x: 124.5,
            y: 50,
            z: -295
          },
          {
            hole: 186,
            x: 115.5,
            y: 50,
            z: -295
          },
          {
            hole: 187,
            x: 107.75,
            y: 50,
            z: -295
          },
          {
            hole: 188,
            x: 100,
            y: 50,
            z: -295
          },
          {
            hole: 189,
            x: 92.25,
            y: 50,
            z: -295
          },
          {
            hole: 190,
            x: 84.5,
            y: 50,
            z: -295
          },
          {
            hole: 191,
            x: 75.5,
            y: 50,
            z: -295
          },
          {
            hole: 192,
            x: 67.75,
            y: 50,
            z: -295
          },
          {
            hole: 193,
            x: 60,
            y: 50,
            z: -295
          },
          {
            hole: 194,
            x: 52.25,
            y: 50,
            z: -295
          },
          {
            hole: 195,
            x: 44.5,
            y: 50,
            z: -295
          },
          {
            hole: 196,
            x: 35.5,
            y: 50,
            z: -295
          },
          {
            hole: 197,
            x: 27.75,
            y: 50,
            z: -295
          },
          {
            hole: 198,
            x: 20,
            y: 50,
            z: -295
          },
          {
            hole: 199,
            x: 12.25,
            y: 50,
            z: -295
          },
          {
            hole: 200,
            x: 4.5,
            y: 50,
            z: -295
          },
          {
            hole: 201,
            x: -4.5,
            y: 50,
            z: -295
          },
          {
            hole: 202,
            x: -12.25,
            y: 50,
            z: -295
          },
          {
            hole: 203,
            x: -20,
            y: 50,
            z: -295
          },
          {
            hole: 204,
            x: -27.75,
            y: 50,
            z: -295
          },
          {
            hole: 205,
            x: -35.5,
            y: 50,
            z: -295
          },
          {
            hole: 206,
            x: -44.5,
            y: 50,
            z: -295
          },
          {
            hole: 207,
            x: -52.25,
            y: 50,
            z: -295
          },
          {
            hole: 208,
            x: -60,
            y: 50,
            z: -295
          },
          {
            hole: 209,
            x: -67.75,
            y: 50,
            z: -295
          },
          {
            hole: 210,
            x: -75.5,
            y: 50,
            z: -295
          },
          {
            hole: 211,
            x: -85,
            y: 50,
            z: -295
          },
          {
            hole: 212,
            x: -102.5,
            y: 50,
            z: -295
          },
          {
            hole: 213,
            x: -135,
            y: 50,
            z: -295
          },
          {
            hole: 214,
            x: -135,
            y: 50,
            z: -262.5
          },
          {
            hole: 215,
            x: -135,
            y: 50,
            z: -245
          },
          {
            hole: 216,
            x: -135,
            y: 60,
            z: -235.5
          },
          {
            hole: 217,
            x: -135,
            y: 60,
            z: -227.75
          },
          {
            hole: 218,
            x: -135,
            y: 60,
            z: -220
          },
          {
            hole: 219,
            x: -135,
            y: 60,
            z: -212.25
          },
          {
            hole: 220,
            x: -135,
            y: 60,
            z: -204.5
          },
          {
            hole: 221,
            x: -135,
            y: 60,
            z: -195.5
          },
          {
            hole: 222,
            x: -135,
            y: 60,
            z: -187.75
          },
          {
            hole: 223,
            x: -135,
            y: 60,
            z: -180
          },
          {
            hole: 224,
            x: -135,
            y: 60,
            z: -172.25
          },
          {
            hole: 225,
            x: -135,
            y: 60,
            z: -164.5
          },
          {
            hole: 226,
            x: -135,
            y: 60,
            z: -155.5
          },
          {
            hole: 227,
            x: -135,
            y: 60,
            z: -147.75
          },
          {
            hole: 228,
            x: -135,
            y: 60,
            z: -140
          },
          {
            hole: 229,
            x: -135,
            y: 60,
            z: -132.25
          },
          {
            hole: 230,
            x: -135,
            y: 60,
            z: -124.5
          },
          {
            hole: 231,
            x: -135,
            y: 60,
            z: -115.5
          },
          {
            hole: 232,
            x: -135,
            y: 60,
            z: -107.75
          },
          {
            hole: 233,
            x: -135,
            y: 60,
            z: -100
          },
          {
            hole: 234,
            x: -135,
            y: 60,
            z: -92.25
          },
          {
            hole: 235,
            x: -135,
            y: 60,
            z: -84.5
          },
          {
            hole: 236,
            x: -135,
            y: 60,
            z: -75.5
          },
          {
            hole: 237,
            x: -135,
            y: 60,
            z: -67.75
          },
          {
            hole: 238,
            x: -135,
            y: 60,
            z: -60
          },
          {
            hole: 239,
            x: -135,
            y: 60,
            z: -52.25
          },
          {
            hole: 240,
            x: -135,
            y: 60,
            z: -44.5
          },
          {
            hole: 241,
            x: -135,
            y: 60,
            z: -35.5
          },
          {
            hole: 242,
            x: -135,
            y: 60,
            z: -27.75
          },
          {
            hole: 243,
            x: -135,
            y: 60,
            z: -20
          },
          {
            hole: 244,
            x: -135,
            y: 60,
            z: -12.25
          },
          {
            hole: 245,
            x: -135,
            y: 60,
            z: -4.5
          },
          {
            hole: 246,
            x: -135,
            y: 60,
            z: 4.5
          },
          {
            hole: 247,
            x: -135,
            y: 60,
            z: 12.25
          },
          {
            hole: 248,
            x: -135,
            y: 60,
            z: 20
          },
          {
            hole: 249,
            x: -135,
            y: 60,
            z: 27.75
          },
          {
            hole: 250,
            x: -135,
            y: 60,
            z: 35.5
          },
          {
            hole: 251,
            x: -135,
            y: 60,
            z: 44.5
          },
          {
            hole: 252,
            x: -135,
            y: 60,
            z: 52.25
          },
          {
            hole: 253,
            x: -135,
            y: 60,
            z: 60
          },
          {
            hole: 254,
            x: -135,
            y: 60,
            z: 67.75
          },
          {
            hole: 255,
            x: -135,
            y: 60,
            z: 75.5
          },
          {
            hole: 256,
            x: -135,
            y: 60,
            z: 84.5
          },
          {
            hole: 257,
            x: -135,
            y: 60,
            z: 92.25
          },
          {
            hole: 258,
            x: -135,
            y: 60,
            z: 100
          },
          {
            hole: 259,
            x: -135,
            y: 60,
            z: 107.75
          },
          {
            hole: 260,
            x: -135,
            y: 60,
            z: 115.5
          },
          {
            hole: 261,
            x: -135,
            y: 60,
            z: 125
          },
          {
            hole: 262,
            x: -135,
            y: 60,
            z: 132.5
          },
          {
            hole: 263,
            x: -135,
            y: 60,
            z: 155
          },
          {
            hole: 264,
            x: -112.5,
            y: 60,
            z: 155
          },
          {
            hole: 265,
            x: -105,
            y: 60,
            z: 155
          },
          {
            hole: 266,
            x: -95.5,
            y: 70,
            z: 155
          },
          {
            hole: 267,
            x: -87.75,
            y: 70,
            z: 155
          },
          {
            hole: 268,
            x: -80,
            y: 70,
            z: 155
          },
          {
            hole: 269,
            x: -72.25,
            y: 70,
            z: 155
          },
          {
            hole: 270,
            x: -64.5,
            y: 70,
            z: 155
          },
          {
            hole: 271,
            x: -55.5,
            y: 70,
            z: 155
          },
          {
            hole: 272,
            x: -47.75,
            y: 70,
            z: 155
          },
          {
            hole: 273,
            x: -40,
            y: 70,
            z: 155
          },
          {
            hole: 274,
            x: -32.25,
            y: 70,
            z: 155
          },
          {
            hole: 275,
            x: -24.5,
            y: 70,
            z: 155
          },
          {
            hole: 276,
            x: -15.5,
            y: 70,
            z: 155
          },
          {
            hole: 277,
            x: -7.75,
            y: 70,
            z: 155
          },
          {
            hole: 278,
            x: 0,
            y: 70,
            z: 155
          },
          {
            hole: 279,
            x: 7.75,
            y: 70,
            z: 155
          },
          {
            hole: 280,
            x: 15.5,
            y: 70,
            z: 155
          },
          {
            hole: 281,
            x: 24.5,
            y: 70,
            z: 155
          },
          {
            hole: 282,
            x: 32.25,
            y: 70,
            z: 155
          },
          {
            hole: 283,
            x: 40,
            y: 70,
            z: 155
          },
          {
            hole: 284,
            x: 47.75,
            y: 70,
            z: 155
          },
          {
            hole: 285,
            x: 55.5,
            y: 70,
            z: 155
          },
          {
            hole: 286,
            x: 64.5,
            y: 70,
            z: 155
          },
          {
            hole: 287,
            x: 72.25,
            y: 70,
            z: 155
          },
          {
            hole: 288,
            x: 80,
            y: 70,
            z: 155
          },
          {
            hole: 289,
            x: 87.75,
            y: 70,
            z: 155
          },
          {
            hole: 290,
            x: 95.5,
            y: 70,
            z: 155
          },
          {
            hole: 291,
            x: 104.5,
            y: 70,
            z: 155
          },
          {
            hole: 292,
            x: 112.25,
            y: 70,
            z: 155
          },
          {
            hole: 293,
            x: 120,
            y: 70,
            z: 155
          },
          {
            hole: 294,
            x: 127.75,
            y: 70,
            z: 155
          },
          {
            hole: 295,
            x: 135.5,
            y: 70,
            z: 155
          },
          {
            hole: 296,
            x: 144.5,
            y: 70,
            z: 155
          },
          {
            hole: 297,
            x: 152.25,
            y: 70,
            z: 155
          },
          {
            hole: 298,
            x: 160,
            y: 70,
            z: 155
          },
          {
            hole: 299,
            x: 167.75,
            y: 70,
            z: 155
          },
          {
            hole: 300,
            x: 175.5,
            y: 70,
            z: 155
          },
          {
            hole: 301,
            x: 184.5,
            y: 70,
            z: 155
          },
          {
            hole: 302,
            x: 192.25,
            y: 70,
            z: 155
          },
          {
            hole: 303,
            x: 200,
            y: 70,
            z: 155
          },
          {
            hole: 304,
            x: 207.75,
            y: 70,
            z: 155
          },
          {
            hole: 305,
            x: 215.5,
            y: 70,
            z: 155
          },
          {
            hole: 306,
            x: 225,
            y: 70,
            z: 155
          },
          {
            hole: 307,
            x: 232.5,
            y: 70,
            z: 155
          },
          {
            hole: 308,
            x: 255,
            y: 70,
            z: 155
          },
          {
            hole: 309,
            x: 255,
            y: 70,
            z: 132.5
          },
          {
            hole: 310,
            x: 255,
            y: 70,
            z: 125
          },
          {
            hole: 311,
            x: 255,
            y: 80,
            z: 115.5
          },
          {
            hole: 312,
            x: 255,
            y: 80,
            z: 107.75
          },
          {
            hole: 313,
            x: 255,
            y: 80,
            z: 100
          },
          {
            hole: 314,
            x: 255,
            y: 80,
            z: 92.25
          },
          {
            hole: 315,
            x: 255,
            y: 80,
            z: 84.5
          },
          {
            hole: 316,
            x: 255,
            y: 80,
            z: 75.5
          },
          {
            hole: 317,
            x: 255,
            y: 80,
            z: 67.75
          },
          {
            hole: 318,
            x: 255,
            y: 80,
            z: 60
          },
          {
            hole: 319,
            x: 255,
            y: 80,
            z: 52.25
          },
          {
            hole: 320,
            x: 255,
            y: 80,
            z: 44.5
          },
          {
            hole: 321,
            x: 255,
            y: 80,
            z: 35.5
          },
          {
            hole: 322,
            x: 255,
            y: 80,
            z: 27.75
          },
          {
            hole: 323,
            x: 255,
            y: 80,
            z: 20
          },
          {
            hole: 324,
            x: 255,
            y: 80,
            z: 12.25
          },
          {
            hole: 325,
            x: 255,
            y: 80,
            z: 4.5
          },
          {
            hole: 326,
            x: 255,
            y: 80,
            z: -4.5
          },
          {
            hole: 327,
            x: 255,
            y: 80,
            z: -12.25
          },
          {
            hole: 328,
            x: 255,
            y: 80,
            z: -20
          },
          {
            hole: 329,
            x: 255,
            y: 80,
            z: -27.75
          },
          {
            hole: 330,
            x: 255,
            y: 80,
            z: -35.5
          },
          {
            hole: 331,
            x: 255,
            y: 80,
            z: -44.5
          },
          {
            hole: 332,
            x: 255,
            y: 80,
            z: -52.25
          },
          {
            hole: 333,
            x: 255,
            y: 80,
            z: -60
          },
          {
            hole: 334,
            x: 255,
            y: 80,
            z: -67.75
          },
          {
            hole: 335,
            x: 255,
            y: 80,
            z: -75.5
          },
          {
            hole: 336,
            x: 255,
            y: 80,
            z: -84.5
          },
          {
            hole: 337,
            x: 255,
            y: 80,
            z: -92.25
          },
          {
            hole: 338,
            x: 255,
            y: 80,
            z: -100
          },
          {
            hole: 339,
            x: 255,
            y: 80,
            z: -107.75
          },
          {
            hole: 340,
            x: 255,
            y: 80,
            z: -115.5
          },
          {
            hole: 341,
            x: 255,
            y: 80,
            z: -124.5
          },
          {
            hole: 342,
            x: 255,
            y: 80,
            z: -132.25
          },
          {
            hole: 343,
            x: 255,
            y: 80,
            z: -140
          },
          {
            hole: 344,
            x: 255,
            y: 80,
            z: -147.75
          },
          {
            hole: 345,
            x: 255,
            y: 80,
            z: -155.5
          },
          {
            hole: 346,
            x: 255,
            y: 80,
            z: -165
          },
          {
            hole: 347,
            x: 255,
            y: 80,
            z: -182.5
          },
          {
            hole: 348,
            x: 255,
            y: 80,
            z: -215
          },
          {
            hole: 349,
            x: 222.5,
            y: 80,
            z: -215
          },
          {
            hole: 350,
            x: 205,
            y: 80,
            z: -215
          },
          {
            hole: 351,
            x: 195.5,
            y: 90,
            z: -215
          },
          {
            hole: 352,
            x: 187.75,
            y: 90,
            z: -215
          },
          {
            hole: 353,
            x: 180,
            y: 90,
            z: -215
          },
          {
            hole: 354,
            x: 172.25,
            y: 90,
            z: -215
          },
          {
            hole: 355,
            x: 164.5,
            y: 90,
            z: -215
          },
          {
            hole: 356,
            x: 155.5,
            y: 90,
            z: -215
          },
          {
            hole: 357,
            x: 147.75,
            y: 90,
            z: -215
          },
          {
            hole: 358,
            x: 140,
            y: 90,
            z: -215
          },
          {
            hole: 359,
            x: 132.25,
            y: 90,
            z: -215
          },
          {
            hole: 360,
            x: 124.5,
            y: 90,
            z: -215
          },
          {
            hole: 361,
            x: 115.5,
            y: 90,
            z: -215
          },
          {
            hole: 362,
            x: 107.75,
            y: 90,
            z: -215
          },
          {
            hole: 363,
            x: 100,
            y: 90,
            z: -215
          },
          {
            hole: 364,
            x: 92.25,
            y: 90,
            z: -215
          },
          {
            hole: 365,
            x: 84.5,
            y: 90,
            z: -215
          },
          {
            hole: 366,
            x: 75.5,
            y: 90,
            z: -215
          },
          {
            hole: 367,
            x: 67.75,
            y: 90,
            z: -215
          },
          {
            hole: 368,
            x: 60,
            y: 90,
            z: -215
          },
          {
            hole: 369,
            x: 52.25,
            y: 90,
            z: -215
          },
          {
            hole: 370,
            x: 44.5,
            y: 90,
            z: -215
          },
          {
            hole: 371,
            x: 35.5,
            y: 90,
            z: -215
          },
          {
            hole: 372,
            x: 27.75,
            y: 90,
            z: -215
          },
          {
            hole: 373,
            x: 20,
            y: 90,
            z: -215
          },
          {
            hole: 374,
            x: 12.25,
            y: 90,
            z: -215
          },
          {
            hole: 375,
            x: 4.5,
            y: 90,
            z: -215
          },
          {
            hole: 376,
            x: -5,
            y: 90,
            z: -215
          },
          {
            hole: 377,
            x: -22.5,
            y: 90,
            z: -215
          },
          {
            hole: 378,
            x: -55,
            y: 90,
            z: -215
          },
          {
            hole: 379,
            x: -55,
            y: 90,
            z: -182.5
          },
          {
            hole: 380,
            x: -55,
            y: 90,
            z: -165
          },
          {
            hole: 381,
            x: -55,
            y: 100,
            z: -155.5
          },
          {
            hole: 382,
            x: -55,
            y: 100,
            z: -147.75
          },
          {
            hole: 383,
            x: -55,
            y: 100,
            z: -140
          },
          {
            hole: 384,
            x: -55,
            y: 100,
            z: -132.25
          },
          {
            hole: 385,
            x: -55,
            y: 100,
            z: -124.5
          },
          {
            hole: 386,
            x: -55,
            y: 100,
            z: -115.5
          },
          {
            hole: 387,
            x: -55,
            y: 100,
            z: -107.75
          },
          {
            hole: 388,
            x: -55,
            y: 100,
            z: -100
          },
          {
            hole: 389,
            x: -55,
            y: 100,
            z: -92.25
          },
          {
            hole: 390,
            x: -55,
            y: 100,
            z: -84.5
          },
          {
            hole: 391,
            x: -55,
            y: 100,
            z: -75.5
          },
          {
            hole: 392,
            x: -55,
            y: 100,
            z: -67.75
          },
          {
            hole: 393,
            x: -55,
            y: 100,
            z: -60
          },
          {
            hole: 394,
            x: -55,
            y: 100,
            z: -52.25
          },
          {
            hole: 395,
            x: -55,
            y: 100,
            z: -44.5
          },
          {
            hole: 396,
            x: -55,
            y: 100,
            z: -35.5
          },
          {
            hole: 397,
            x: -55,
            y: 100,
            z: -27.75
          },
          {
            hole: 398,
            x: -55,
            y: 100,
            z: -20
          },
          {
            hole: 399,
            x: -55,
            y: 100,
            z: -12.25
          },
          {
            hole: 400,
            x: -55,
            y: 100,
            z: -4.5
          },
          {
            hole: 401,
            x: -55,
            y: 100,
            z: 4.5
          },
          {
            hole: 402,
            x: -55,
            y: 100,
            z: 12.25
          },
          {
            hole: 403,
            x: -55,
            y: 100,
            z: 20
          },
          {
            hole: 404,
            x: -55,
            y: 100,
            z: 27.75
          },
          {
            hole: 405,
            x: -55,
            y: 100,
            z: 35.5
          },
          {
            hole: 406,
            x: -55,
            y: 100,
            z: 45
          },
          {
            hole: 407,
            x: -55,
            y: 100,
            z: 52.5
          },
          {
            hole: 408,
            x: -55,
            y: 100,
            z: 75
          },
          {
            hole: 409,
            x: -32.5,
            y: 100,
            z: 75
          },
          {
            hole: 410,
            x: -25,
            y: 100,
            z: 75
          },
          {
            hole: 411,
            x: -15.5,
            y: 110,
            z: 75
          },
          {
            hole: 412,
            x: -7.75,
            y: 110,
            z: 75
          },
          {
            hole: 413,
            x: 0,
            y: 110,
            z: 75
          },
          {
            hole: 414,
            x: 7.75,
            y: 110,
            z: 75
          },
          {
            hole: 415,
            x: 15.5,
            y: 110,
            z: 75
          },
          {
            hole: 416,
            x: 24.5,
            y: 110,
            z: 75
          },
          {
            hole: 417,
            x: 32.25,
            y: 110,
            z: 75
          },
          {
            hole: 418,
            x: 40,
            y: 110,
            z: 75
          },
          {
            hole: 419,
            x: 47.75,
            y: 110,
            z: 75
          },
          {
            hole: 420,
            x: 55.5,
            y: 110,
            z: 75
          },
          {
            hole: 421,
            x: 64.5,
            y: 110,
            z: 75
          },
          {
            hole: 422,
            x: 72.25,
            y: 110,
            z: 75
          },
          {
            hole: 423,
            x: 80,
            y: 110,
            z: 75
          },
          {
            hole: 424,
            x: 87.75,
            y: 110,
            z: 75
          },
          {
            hole: 425,
            x: 95.5,
            y: 110,
            z: 75
          },
          {
            hole: 426,
            x: 104.5,
            y: 110,
            z: 75
          },
          {
            hole: 427,
            x: 112.25,
            y: 110,
            z: 75
          },
          {
            hole: 428,
            x: 120,
            y: 110,
            z: 75
          },
          {
            hole: 429,
            x: 127.75,
            y: 110,
            z: 75
          },
          {
            hole: 430,
            x: 135.5,
            y: 110,
            z: 75
          },
          {
            hole: 431,
            x: 145,
            y: 110,
            z: 75
          },
          {
            hole: 432,
            x: 152.5,
            y: 110,
            z: 75
          },
          {
            hole: 433,
            x: 175,
            y: 110,
            z: 75
          },
          {
            hole: 434,
            x: 175,
            y: 110,
            z: 52.5
          },
          {
            hole: 435,
            x: 175,
            y: 110,
            z: 45
          },
          {
            hole: 436,
            x: 175,
            y: 120,
            z: 35.5
          },
          {
            hole: 437,
            x: 175,
            y: 120,
            z: 27.75
          },
          {
            hole: 438,
            x: 175,
            y: 120,
            z: 20
          },
          {
            hole: 439,
            x: 175,
            y: 120,
            z: 12.25
          },
          {
            hole: 440,
            x: 175,
            y: 120,
            z: 4.5
          },
          {
            hole: 441,
            x: 175,
            y: 120,
            z: -4.5
          },
          {
            hole: 442,
            x: 175,
            y: 120,
            z: -12.25
          },
          {
            hole: 443,
            x: 175,
            y: 120,
            z: -20
          },
          {
            hole: 444,
            x: 175,
            y: 120,
            z: -27.75
          },
          {
            hole: 445,
            x: 175,
            y: 120,
            z: -35.5
          },
          {
            hole: 446,
            x: 175,
            y: 120,
            z: -44.5
          },
          {
            hole: 447,
            x: 175,
            y: 120,
            z: -52.25
          },
          {
            hole: 448,
            x: 175,
            y: 120,
            z: -60
          },
          {
            hole: 449,
            x: 175,
            y: 120,
            z: -67.75
          },
          {
            hole: 450,
            x: 175,
            y: 120,
            z: -75.5
          },
          {
            hole: 451,
            x: 175,
            y: 120,
            z: -85
          },
          {
            hole: 452,
            x: 175,
            y: 120,
            z: -102.5
          },
          {
            hole: 453,
            x: 175,
            y: 120,
            z: -135
          },
          {
            hole: 454,
            x: 142.5,
            y: 120,
            z: -135
          },
          {
            hole: 455,
            x: 125,
            y: 120,
            z: -135
          },
          {
            hole: 456,
            x: 115.5,
            y: 130,
            z: -135
          },
          {
            hole: 457,
            x: 107.75,
            y: 130,
            z: -135
          },
          {
            hole: 458,
            x: 100,
            y: 130,
            z: -135
          },
          {
            hole: 459,
            x: 92.25,
            y: 130,
            z: -135
          },
          {
            hole: 460,
            x: 84.5,
            y: 130,
            z: -135
          },
          {
            hole: 461,
            x: 75,
            y: 130,
            z: -135
          },
          {
            hole: 462,
            x: 57.5,
            y: 130,
            z: -135
          },
          {
            hole: 463,
            x: 25,
            y: 130,
            z: -135
          },
          {
            hole: 464,
            x: 25,
            y: 130,
            z: -102.5
          },
          {
            hole: 465,
            x: 25,
            y: 130,
            z: -85
          },
          {
            hole: 466,
            x: 25,
            y: 140,
            z: -75.5
          },
          {
            hole: 467,
            x: 25,
            y: 140,
            z: -67.75
          },
          {
            hole: 468,
            x: 25,
            y: 140,
            z: -60
          },
          {
            hole: 469,
            x: 25,
            y: 140,
            z: -52.25
          },
          {
            hole: 470,
            x: 25,
            y: 140,
            z: -44.5
          },
          {
            hole: 471,
            x: 25,
            y: 140,
            z: -35
          },
          {
            hole: 472,
            x: 25,
            y: 140,
            z: -27.5
          },
          {
            hole: 473,
            x: 25,
            y: 140,
            z: -5
          },
          {
            hole: 474,
            x: 47.5,
            y: 140,
            z: -5
          },
          {
            hole: 475,
            x: 55,
            y: 140,
            z: -5
          },
          {
            hole: 476,
            x: 65,
            y: 150,
            z: -5
          },
          {
            hole: 477,
            x: 72.5,
            y: 150,
            z: -5
          },
          {
            hole: 478,
            x: 95,
            y: 150,
            z: -5
          },
          {
            hole: 479,
            x: 95,
            y: 150,
            z: -27.5
          },
          {
            hole: 480,
            x: 95,
            y: 150,
            z: -35
          },
          {
            hole: 121,
            x: 100,
            y: 160,
            z: -60
          }
        ],
        p4: [
          {
            hole: 0,
            x: -235,
            y: 10,
            z: -93
          },
          {
            hole: 1,
            x: -205,
            y: 20,
            z: -75.5
          },
          {
            hole: 2,
            x: -205,
            y: 20,
            z: -67.75
          },
          {
            hole: 3,
            x: -205,
            y: 20,
            z: -60
          },
          {
            hole: 4,
            x: -205,
            y: 20,
            z: -52.25
          },
          {
            hole: 5,
            x: -205,
            y: 20,
            z: -44.5
          },
          {
            hole: 6,
            x: -205,
            y: 20,
            z: -35.5
          },
          {
            hole: 7,
            x: -205,
            y: 20,
            z: -27.75
          },
          {
            hole: 8,
            x: -205,
            y: 20,
            z: -20
          },
          {
            hole: 9,
            x: -205,
            y: 20,
            z: -12.25
          },
          {
            hole: 10,
            x: -205,
            y: 20,
            z: -4.5
          },
          {
            hole: 11,
            x: -205,
            y: 20,
            z: 4.5
          },
          {
            hole: 12,
            x: -205,
            y: 20,
            z: 12.25
          },
          {
            hole: 13,
            x: -205,
            y: 20,
            z: 20
          },
          {
            hole: 14,
            x: -205,
            y: 20,
            z: 27.75
          },
          {
            hole: 15,
            x: -205,
            y: 20,
            z: 35.5
          },
          {
            hole: 16,
            x: -205,
            y: 20,
            z: 44.5
          },
          {
            hole: 17,
            x: -205,
            y: 20,
            z: 52.25
          },
          {
            hole: 18,
            x: -205,
            y: 20,
            z: 60
          },
          {
            hole: 19,
            x: -205,
            y: 20,
            z: 67.75
          },
          {
            hole: 20,
            x: -205,
            y: 20,
            z: 75.5
          },
          {
            hole: 21,
            x: -205,
            y: 20,
            z: 84.5
          },
          {
            hole: 22,
            x: -205,
            y: 20,
            z: 92.25
          },
          {
            hole: 23,
            x: -205,
            y: 20,
            z: 100
          },
          {
            hole: 24,
            x: -205,
            y: 20,
            z: 107.75
          },
          {
            hole: 25,
            x: -205,
            y: 20,
            z: 115.5
          },
          {
            hole: 26,
            x: -205,
            y: 20,
            z: 124.5
          },
          {
            hole: 27,
            x: -205,
            y: 20,
            z: 132.25
          },
          {
            hole: 28,
            x: -205,
            y: 20,
            z: 140
          },
          {
            hole: 29,
            x: -205,
            y: 20,
            z: 147.75
          },
          {
            hole: 30,
            x: -205,
            y: 20,
            z: 155.5
          },
          {
            hole: 31,
            x: -205,
            y: 20,
            z: 164.5
          },
          {
            hole: 32,
            x: -205,
            y: 20,
            z: 172.25
          },
          {
            hole: 33,
            x: -205,
            y: 20,
            z: 180
          },
          {
            hole: 34,
            x: -205,
            y: 20,
            z: 187.75
          },
          {
            hole: 35,
            x: -205,
            y: 20,
            z: 195.5
          },
          {
            hole: 36,
            x: -205,
            y: 20,
            z: 204.9999
          },
          {
            hole: 37,
            x: -205,
            y: 20,
            z: 212.4999
          },
          {
            hole: 38,
            x: -205,
            y: 20,
            z: 224.9999
          },
          {
            hole: 39,
            x: -192.5,
            y: 20,
            z: 224.9999
          },
          {
            hole: 40,
            x: -185,
            y: 20,
            z: 224.9999
          },
          {
            hole: 41,
            x: -175.5,
            y: 30,
            z: 225
          },
          {
            hole: 42,
            x: -167.75,
            y: 30,
            z: 225
          },
          {
            hole: 43,
            x: -160,
            y: 30,
            z: 225
          },
          {
            hole: 44,
            x: -152.25,
            y: 30,
            z: 225
          },
          {
            hole: 45,
            x: -144.5,
            y: 30,
            z: 225
          },
          {
            hole: 46,
            x: -135.5,
            y: 30,
            z: 225
          },
          {
            hole: 47,
            x: -127.75,
            y: 30,
            z: 225
          },
          {
            hole: 48,
            x: -120,
            y: 30,
            z: 225
          },
          {
            hole: 49,
            x: -112.25,
            y: 30,
            z: 225
          },
          {
            hole: 50,
            x: -104.5,
            y: 30,
            z: 225
          },
          {
            hole: 51,
            x: -95.5,
            y: 30,
            z: 225
          },
          {
            hole: 52,
            x: -87.75,
            y: 30,
            z: 225
          },
          {
            hole: 53,
            x: -80,
            y: 30,
            z: 225
          },
          {
            hole: 54,
            x: -72.25,
            y: 30,
            z: 225
          },
          {
            hole: 55,
            x: -64.5,
            y: 30,
            z: 225
          },
          {
            hole: 56,
            x: -55.5,
            y: 30,
            z: 225
          },
          {
            hole: 57,
            x: -47.75,
            y: 30,
            z: 225
          },
          {
            hole: 58,
            x: -40,
            y: 30,
            z: 225
          },
          {
            hole: 59,
            x: -32.25,
            y: 30,
            z: 225
          },
          {
            hole: 60,
            x: -24.5,
            y: 30,
            z: 225
          },
          {
            hole: 61,
            x: -15.5,
            y: 30,
            z: 225
          },
          {
            hole: 62,
            x: -7.75,
            y: 30,
            z: 225
          },
          {
            hole: 63,
            x: 0,
            y: 30,
            z: 225
          },
          {
            hole: 64,
            x: 7.75,
            y: 30,
            z: 225
          },
          {
            hole: 65,
            x: 15.5,
            y: 30,
            z: 225
          },
          {
            hole: 66,
            x: 24.5,
            y: 30,
            z: 225
          },
          {
            hole: 67,
            x: 32.25,
            y: 30,
            z: 225
          },
          {
            hole: 68,
            x: 40,
            y: 30,
            z: 225
          },
          {
            hole: 69,
            x: 47.75,
            y: 30,
            z: 225
          },
          {
            hole: 70,
            x: 55.5,
            y: 30,
            z: 225
          },
          {
            hole: 71,
            x: 64.5,
            y: 30,
            z: 225
          },
          {
            hole: 72,
            x: 72.25,
            y: 30,
            z: 225
          },
          {
            hole: 73,
            x: 80,
            y: 30,
            z: 225
          },
          {
            hole: 74,
            x: 87.75,
            y: 30,
            z: 225
          },
          {
            hole: 75,
            x: 95.5,
            y: 30,
            z: 225
          },
          {
            hole: 76,
            x: 104.5,
            y: 30,
            z: 225
          },
          {
            hole: 77,
            x: 112.25,
            y: 30,
            z: 225
          },
          {
            hole: 78,
            x: 120,
            y: 30,
            z: 225
          },
          {
            hole: 79,
            x: 127.75,
            y: 30,
            z: 225
          },
          {
            hole: 80,
            x: 135.5,
            y: 30,
            z: 225
          },
          {
            hole: 81,
            x: 144.5,
            y: 30,
            z: 225
          },
          {
            hole: 82,
            x: 152.25,
            y: 30,
            z: 225
          },
          {
            hole: 83,
            x: 160,
            y: 30,
            z: 225
          },
          {
            hole: 84,
            x: 167.75,
            y: 30,
            z: 225
          },
          {
            hole: 85,
            x: 175.5,
            y: 30,
            z: 225
          },
          {
            hole: 86,
            x: 184.5,
            y: 30,
            z: 225
          },
          {
            hole: 87,
            x: 192.25,
            y: 30,
            z: 225
          },
          {
            hole: 88,
            x: 200,
            y: 30,
            z: 225
          },
          {
            hole: 89,
            x: 207.75,
            y: 30,
            z: 225
          },
          {
            hole: 90,
            x: 215.5,
            y: 30,
            z: 225
          },
          {
            hole: 91,
            x: 224.5,
            y: 30,
            z: 225
          },
          {
            hole: 92,
            x: 232.25,
            y: 30,
            z: 225
          },
          {
            hole: 93,
            x: 240,
            y: 30,
            z: 225
          },
          {
            hole: 94,
            x: 247.75,
            y: 30,
            z: 225
          },
          {
            hole: 95,
            x: 255.5,
            y: 30,
            z: 225
          },
          {
            hole: 96,
            x: 264.5,
            y: 30,
            z: 225
          },
          {
            hole: 97,
            x: 272.25,
            y: 30,
            z: 225
          },
          {
            hole: 98,
            x: 280,
            y: 30,
            z: 225
          },
          {
            hole: 99,
            x: 287.75,
            y: 30,
            z: 225
          },
          {
            hole: 100,
            x: 295.5,
            y: 30,
            z: 225
          },
          {
            hole: 101,
            x: 305,
            y: 30,
            z: 225
          },
          {
            hole: 102,
            x: 312.5,
            y: 30,
            z: 225
          },
          {
            hole: 103,
            x: 325,
            y: 30,
            z: 225
          },
          {
            hole: 104,
            x: 325,
            y: 30,
            z: 212.5
          },
          {
            hole: 105,
            x: 325,
            y: 30,
            z: 205
          },
          {
            hole: 106,
            x: 325,
            y: 40,
            z: 195.5
          },
          {
            hole: 107,
            x: 325,
            y: 40,
            z: 187.75
          },
          {
            hole: 108,
            x: 325,
            y: 40,
            z: 180
          },
          {
            hole: 109,
            x: 325,
            y: 40,
            z: 172.25
          },
          {
            hole: 110,
            x: 325,
            y: 40,
            z: 164.5
          },
          {
            hole: 111,
            x: 325,
            y: 40,
            z: 155.5
          },
          {
            hole: 112,
            x: 325,
            y: 40,
            z: 147.75
          },
          {
            hole: 113,
            x: 325,
            y: 40,
            z: 140
          },
          {
            hole: 114,
            x: 325,
            y: 40,
            z: 132.25
          },
          {
            hole: 115,
            x: 325,
            y: 40,
            z: 124.5
          },
          {
            hole: 116,
            x: 325,
            y: 40,
            z: 115.5
          },
          {
            hole: 117,
            x: 325,
            y: 40,
            z: 107.75
          },
          {
            hole: 118,
            x: 325,
            y: 40,
            z: 100
          },
          {
            hole: 119,
            x: 325,
            y: 40,
            z: 92.25
          },
          {
            hole: 120,
            x: 325,
            y: 40,
            z: 84.5
          },
          {
            hole: 121,
            x: 325,
            y: 40,
            z: 75.5
          },
          {
            hole: 122,
            x: 325,
            y: 40,
            z: 67.75
          },
          {
            hole: 123,
            x: 325,
            y: 40,
            z: 60
          },
          {
            hole: 124,
            x: 325,
            y: 40,
            z: 52.25
          },
          {
            hole: 125,
            x: 325,
            y: 40,
            z: 44.5
          },
          {
            hole: 126,
            x: 325,
            y: 40,
            z: 35.5
          },
          {
            hole: 127,
            x: 325,
            y: 40,
            z: 27.75
          },
          {
            hole: 128,
            x: 325,
            y: 40,
            z: 20
          },
          {
            hole: 129,
            x: 325,
            y: 40,
            z: 12.25
          },
          {
            hole: 130,
            x: 325,
            y: 40,
            z: 4.5
          },
          {
            hole: 131,
            x: 325,
            y: 40,
            z: -4.5
          },
          {
            hole: 132,
            x: 325,
            y: 40,
            z: -12.25
          },
          {
            hole: 133,
            x: 325,
            y: 40,
            z: -20
          },
          {
            hole: 134,
            x: 325,
            y: 40,
            z: -27.75
          },
          {
            hole: 135,
            x: 325,
            y: 40,
            z: -35.5
          },
          {
            hole: 136,
            x: 325,
            y: 40,
            z: -44.5
          },
          {
            hole: 137,
            x: 325,
            y: 40,
            z: -52.25
          },
          {
            hole: 138,
            x: 325,
            y: 40,
            z: -60
          },
          {
            hole: 139,
            x: 325,
            y: 40,
            z: -67.75
          },
          {
            hole: 140,
            x: 325,
            y: 40,
            z: -75.5
          },
          {
            hole: 141,
            x: 325,
            y: 40,
            z: -84.5
          },
          {
            hole: 142,
            x: 325,
            y: 40,
            z: -92.25
          },
          {
            hole: 143,
            x: 325,
            y: 40,
            z: -100
          },
          {
            hole: 144,
            x: 325,
            y: 40,
            z: -107.75
          },
          {
            hole: 145,
            x: 325,
            y: 40,
            z: -115.5
          },
          {
            hole: 146,
            x: 325,
            y: 40,
            z: -124.5
          },
          {
            hole: 147,
            x: 325,
            y: 40,
            z: -132.25
          },
          {
            hole: 148,
            x: 325,
            y: 40,
            z: -140
          },
          {
            hole: 149,
            x: 325,
            y: 40,
            z: -147.75
          },
          {
            hole: 150,
            x: 325,
            y: 40,
            z: -155.5
          },
          {
            hole: 151,
            x: 325,
            y: 40,
            z: -164.5
          },
          {
            hole: 152,
            x: 325,
            y: 40,
            z: -172.25
          },
          {
            hole: 153,
            x: 325,
            y: 40,
            z: -180
          },
          {
            hole: 154,
            x: 325,
            y: 40,
            z: -187.75
          },
          {
            hole: 155,
            x: 325,
            y: 40,
            z: -195.5
          },
          {
            hole: 156,
            x: 325,
            y: 40,
            z: -204.5
          },
          {
            hole: 157,
            x: 325,
            y: 40,
            z: -212.25
          },
          {
            hole: 158,
            x: 325,
            y: 40,
            z: -220
          },
          {
            hole: 159,
            x: 325,
            y: 40,
            z: -227.75
          },
          {
            hole: 160,
            x: 325,
            y: 40,
            z: -235.5
          },
          {
            hole: 161,
            x: 325,
            y: 40,
            z: -245
          },
          {
            hole: 162,
            x: 325,
            y: 40,
            z: -262.5
          },
          {
            hole: 163,
            x: 325,
            y: 40,
            z: -285
          },
          {
            hole: 164,
            x: 302.5,
            y: 40,
            z: -285
          },
          {
            hole: 165,
            x: 285,
            y: 40,
            z: -285
          },
          {
            hole: 166,
            x: 275.5,
            y: 50,
            z: -285
          },
          {
            hole: 167,
            x: 267.75,
            y: 50,
            z: -285
          },
          {
            hole: 168,
            x: 260,
            y: 50,
            z: -285
          },
          {
            hole: 169,
            x: 252.25,
            y: 50,
            z: -285
          },
          {
            hole: 170,
            x: 244.5,
            y: 50,
            z: -285
          },
          {
            hole: 171,
            x: 235.5,
            y: 50,
            z: -285
          },
          {
            hole: 172,
            x: 227.75,
            y: 50,
            z: -285
          },
          {
            hole: 173,
            x: 220,
            y: 50,
            z: -285
          },
          {
            hole: 174,
            x: 212.25,
            y: 50,
            z: -285
          },
          {
            hole: 175,
            x: 204.5,
            y: 50,
            z: -285
          },
          {
            hole: 176,
            x: 195.5,
            y: 50,
            z: -285
          },
          {
            hole: 177,
            x: 187.75,
            y: 50,
            z: -285
          },
          {
            hole: 178,
            x: 180,
            y: 50,
            z: -285
          },
          {
            hole: 179,
            x: 172.25,
            y: 50,
            z: -285
          },
          {
            hole: 180,
            x: 164.5,
            y: 50,
            z: -285
          },
          {
            hole: 181,
            x: 155.5,
            y: 50,
            z: -285
          },
          {
            hole: 182,
            x: 147.75,
            y: 50,
            z: -285
          },
          {
            hole: 183,
            x: 140,
            y: 50,
            z: -285
          },
          {
            hole: 184,
            x: 132.25,
            y: 50,
            z: -285
          },
          {
            hole: 185,
            x: 124.5,
            y: 50,
            z: -285
          },
          {
            hole: 186,
            x: 115.5,
            y: 50,
            z: -285
          },
          {
            hole: 187,
            x: 107.75,
            y: 50,
            z: -285
          },
          {
            hole: 188,
            x: 100,
            y: 50,
            z: -285
          },
          {
            hole: 189,
            x: 92.25,
            y: 50,
            z: -285
          },
          {
            hole: 190,
            x: 84.5,
            y: 50,
            z: -285
          },
          {
            hole: 191,
            x: 75.5,
            y: 50,
            z: -285
          },
          {
            hole: 192,
            x: 67.75,
            y: 50,
            z: -285
          },
          {
            hole: 193,
            x: 60,
            y: 50,
            z: -285
          },
          {
            hole: 194,
            x: 52.25,
            y: 50,
            z: -285
          },
          {
            hole: 195,
            x: 44.5,
            y: 50,
            z: -285
          },
          {
            hole: 196,
            x: 35.5,
            y: 50,
            z: -285
          },
          {
            hole: 197,
            x: 27.75,
            y: 50,
            z: -285
          },
          {
            hole: 198,
            x: 20,
            y: 50,
            z: -285
          },
          {
            hole: 199,
            x: 12.25,
            y: 50,
            z: -285
          },
          {
            hole: 200,
            x: 4.5,
            y: 50,
            z: -285
          },
          {
            hole: 201,
            x: -4.5,
            y: 50,
            z: -285
          },
          {
            hole: 202,
            x: -12.25,
            y: 50,
            z: -285
          },
          {
            hole: 203,
            x: -20,
            y: 50,
            z: -285
          },
          {
            hole: 204,
            x: -27.75,
            y: 50,
            z: -285
          },
          {
            hole: 205,
            x: -35.5,
            y: 50,
            z: -285
          },
          {
            hole: 206,
            x: -44.5,
            y: 50,
            z: -285
          },
          {
            hole: 207,
            x: -52.25,
            y: 50,
            z: -285
          },
          {
            hole: 208,
            x: -60,
            y: 50,
            z: -285
          },
          {
            hole: 209,
            x: -67.75,
            y: 50,
            z: -285
          },
          {
            hole: 210,
            x: -75.5,
            y: 50,
            z: -285
          },
          {
            hole: 211,
            x: -85,
            y: 50,
            z: -285
          },
          {
            hole: 212,
            x: -102.5,
            y: 50,
            z: -285
          },
          {
            hole: 213,
            x: -125,
            y: 50,
            z: -285
          },
          {
            hole: 214,
            x: -125,
            y: 50,
            z: -262.5
          },
          {
            hole: 215,
            x: -125,
            y: 50,
            z: -245
          },
          {
            hole: 216,
            x: -125,
            y: 60,
            z: -235.5
          },
          {
            hole: 217,
            x: -125,
            y: 60,
            z: -227.75
          },
          {
            hole: 218,
            x: -125,
            y: 60,
            z: -220
          },
          {
            hole: 219,
            x: -125,
            y: 60,
            z: -212.25
          },
          {
            hole: 220,
            x: -125,
            y: 60,
            z: -204.5
          },
          {
            hole: 221,
            x: -125,
            y: 60,
            z: -195.5
          },
          {
            hole: 222,
            x: -125,
            y: 60,
            z: -187.75
          },
          {
            hole: 223,
            x: -125,
            y: 60,
            z: -180
          },
          {
            hole: 224,
            x: -125,
            y: 60,
            z: -172.25
          },
          {
            hole: 225,
            x: -125,
            y: 60,
            z: -164.5
          },
          {
            hole: 226,
            x: -125,
            y: 60,
            z: -155.5
          },
          {
            hole: 227,
            x: -125,
            y: 60,
            z: -147.75
          },
          {
            hole: 228,
            x: -125,
            y: 60,
            z: -140
          },
          {
            hole: 229,
            x: -125,
            y: 60,
            z: -132.25
          },
          {
            hole: 230,
            x: -125,
            y: 60,
            z: -124.5
          },
          {
            hole: 231,
            x: -125,
            y: 60,
            z: -115.5
          },
          {
            hole: 232,
            x: -125,
            y: 60,
            z: -107.75
          },
          {
            hole: 233,
            x: -125,
            y: 60,
            z: -100
          },
          {
            hole: 234,
            x: -125,
            y: 60,
            z: -92.25
          },
          {
            hole: 235,
            x: -125,
            y: 60,
            z: -84.5
          },
          {
            hole: 236,
            x: -125,
            y: 60,
            z: -75.5
          },
          {
            hole: 237,
            x: -125,
            y: 60,
            z: -67.75
          },
          {
            hole: 238,
            x: -125,
            y: 60,
            z: -60
          },
          {
            hole: 239,
            x: -125,
            y: 60,
            z: -52.25
          },
          {
            hole: 240,
            x: -125,
            y: 60,
            z: -44.5
          },
          {
            hole: 241,
            x: -125,
            y: 60,
            z: -35.5
          },
          {
            hole: 242,
            x: -125,
            y: 60,
            z: -27.75
          },
          {
            hole: 243,
            x: -125,
            y: 60,
            z: -20
          },
          {
            hole: 244,
            x: -125,
            y: 60,
            z: -12.25
          },
          {
            hole: 245,
            x: -125,
            y: 60,
            z: -4.5
          },
          {
            hole: 246,
            x: -125,
            y: 60,
            z: 4.5
          },
          {
            hole: 247,
            x: -125,
            y: 60,
            z: 12.25
          },
          {
            hole: 248,
            x: -125,
            y: 60,
            z: 20
          },
          {
            hole: 249,
            x: -125,
            y: 60,
            z: 27.75
          },
          {
            hole: 250,
            x: -125,
            y: 60,
            z: 35.5
          },
          {
            hole: 251,
            x: -125,
            y: 60,
            z: 44.5
          },
          {
            hole: 252,
            x: -125,
            y: 60,
            z: 52.25
          },
          {
            hole: 253,
            x: -125,
            y: 60,
            z: 60
          },
          {
            hole: 254,
            x: -125,
            y: 60,
            z: 67.75
          },
          {
            hole: 255,
            x: -125,
            y: 60,
            z: 75.5
          },
          {
            hole: 256,
            x: -125,
            y: 60,
            z: 84.5
          },
          {
            hole: 257,
            x: -125,
            y: 60,
            z: 92.25
          },
          {
            hole: 258,
            x: -125,
            y: 60,
            z: 100
          },
          {
            hole: 259,
            x: -125,
            y: 60,
            z: 107.75
          },
          {
            hole: 260,
            x: -125,
            y: 60,
            z: 115.5
          },
          {
            hole: 261,
            x: -125,
            y: 60,
            z: 125
          },
          {
            hole: 262,
            x: -125,
            y: 60,
            z: 132.5
          },
          {
            hole: 263,
            x: -125,
            y: 60,
            z: 145
          },
          {
            hole: 264,
            x: -112.5,
            y: 60,
            z: 145
          },
          {
            hole: 265,
            x: -105,
            y: 60,
            z: 145
          },
          {
            hole: 266,
            x: -95.5,
            y: 70,
            z: 145
          },
          {
            hole: 267,
            x: -87.75,
            y: 70,
            z: 145
          },
          {
            hole: 268,
            x: -80,
            y: 70,
            z: 145
          },
          {
            hole: 269,
            x: -72.25,
            y: 70,
            z: 145
          },
          {
            hole: 270,
            x: -64.5,
            y: 70,
            z: 145
          },
          {
            hole: 271,
            x: -55.5,
            y: 70,
            z: 145
          },
          {
            hole: 272,
            x: -47.75,
            y: 70,
            z: 145
          },
          {
            hole: 273,
            x: -40,
            y: 70,
            z: 145
          },
          {
            hole: 274,
            x: -32.25,
            y: 70,
            z: 145
          },
          {
            hole: 275,
            x: -24.5,
            y: 70,
            z: 145
          },
          {
            hole: 276,
            x: -15.5,
            y: 70,
            z: 145
          },
          {
            hole: 277,
            x: -7.75,
            y: 70,
            z: 145
          },
          {
            hole: 278,
            x: 0,
            y: 70,
            z: 145
          },
          {
            hole: 279,
            x: 7.75,
            y: 70,
            z: 145
          },
          {
            hole: 280,
            x: 15.5,
            y: 70,
            z: 145
          },
          {
            hole: 281,
            x: 24.5,
            y: 70,
            z: 145
          },
          {
            hole: 282,
            x: 32.25,
            y: 70,
            z: 145
          },
          {
            hole: 283,
            x: 40,
            y: 70,
            z: 145
          },
          {
            hole: 284,
            x: 47.75,
            y: 70,
            z: 145
          },
          {
            hole: 285,
            x: 55.5,
            y: 70,
            z: 145
          },
          {
            hole: 286,
            x: 64.5,
            y: 70,
            z: 145
          },
          {
            hole: 287,
            x: 72.25,
            y: 70,
            z: 145
          },
          {
            hole: 288,
            x: 80,
            y: 70,
            z: 145
          },
          {
            hole: 289,
            x: 87.75,
            y: 70,
            z: 145
          },
          {
            hole: 290,
            x: 95.5,
            y: 70,
            z: 145
          },
          {
            hole: 291,
            x: 104.5,
            y: 70,
            z: 145
          },
          {
            hole: 292,
            x: 112.25,
            y: 70,
            z: 145
          },
          {
            hole: 293,
            x: 120,
            y: 70,
            z: 145
          },
          {
            hole: 294,
            x: 127.75,
            y: 70,
            z: 145
          },
          {
            hole: 295,
            x: 135.5,
            y: 70,
            z: 145
          },
          {
            hole: 296,
            x: 144.5,
            y: 70,
            z: 145
          },
          {
            hole: 297,
            x: 152.25,
            y: 70,
            z: 145
          },
          {
            hole: 298,
            x: 160,
            y: 70,
            z: 145
          },
          {
            hole: 299,
            x: 167.75,
            y: 70,
            z: 145
          },
          {
            hole: 300,
            x: 175.5,
            y: 70,
            z: 145
          },
          {
            hole: 301,
            x: 184.5,
            y: 70,
            z: 145
          },
          {
            hole: 302,
            x: 192.25,
            y: 70,
            z: 145
          },
          {
            hole: 303,
            x: 200,
            y: 70,
            z: 145
          },
          {
            hole: 304,
            x: 207.75,
            y: 70,
            z: 145
          },
          {
            hole: 305,
            x: 215.5,
            y: 70,
            z: 145
          },
          {
            hole: 306,
            x: 225,
            y: 70,
            z: 145
          },
          {
            hole: 307,
            x: 232.5,
            y: 70,
            z: 145
          },
          {
            hole: 308,
            x: 245,
            y: 70,
            z: 145
          },
          {
            hole: 309,
            x: 245,
            y: 70,
            z: 132.5
          },
          {
            hole: 310,
            x: 245,
            y: 70,
            z: 125
          },
          {
            hole: 311,
            x: 245,
            y: 80,
            z: 115.5
          },
          {
            hole: 312,
            x: 245,
            y: 80,
            z: 107.75
          },
          {
            hole: 313,
            x: 245,
            y: 80,
            z: 100
          },
          {
            hole: 314,
            x: 245,
            y: 80,
            z: 92.25
          },
          {
            hole: 315,
            x: 245,
            y: 80,
            z: 84.5
          },
          {
            hole: 316,
            x: 245,
            y: 80,
            z: 75.5
          },
          {
            hole: 317,
            x: 245,
            y: 80,
            z: 67.75
          },
          {
            hole: 318,
            x: 245,
            y: 80,
            z: 60
          },
          {
            hole: 319,
            x: 245,
            y: 80,
            z: 52.25
          },
          {
            hole: 320,
            x: 245,
            y: 80,
            z: 44.5
          },
          {
            hole: 321,
            x: 245,
            y: 80,
            z: 35.5
          },
          {
            hole: 322,
            x: 245,
            y: 80,
            z: 27.75
          },
          {
            hole: 323,
            x: 245,
            y: 80,
            z: 20
          },
          {
            hole: 324,
            x: 245,
            y: 80,
            z: 12.25
          },
          {
            hole: 325,
            x: 245,
            y: 80,
            z: 4.5
          },
          {
            hole: 326,
            x: 245,
            y: 80,
            z: -4.5
          },
          {
            hole: 327,
            x: 245,
            y: 80,
            z: -12.25
          },
          {
            hole: 328,
            x: 245,
            y: 80,
            z: -20
          },
          {
            hole: 329,
            x: 245,
            y: 80,
            z: -27.75
          },
          {
            hole: 330,
            x: 245,
            y: 80,
            z: -35.5
          },
          {
            hole: 331,
            x: 245,
            y: 80,
            z: -44.5
          },
          {
            hole: 332,
            x: 245,
            y: 80,
            z: -52.25
          },
          {
            hole: 333,
            x: 245,
            y: 80,
            z: -60
          },
          {
            hole: 334,
            x: 245,
            y: 80,
            z: -67.75
          },
          {
            hole: 335,
            x: 245,
            y: 80,
            z: -75.5
          },
          {
            hole: 336,
            x: 245,
            y: 80,
            z: -84.5
          },
          {
            hole: 337,
            x: 245,
            y: 80,
            z: -92.25
          },
          {
            hole: 338,
            x: 245,
            y: 80,
            z: -100
          },
          {
            hole: 339,
            x: 245,
            y: 80,
            z: -107.75
          },
          {
            hole: 340,
            x: 245,
            y: 80,
            z: -115.5
          },
          {
            hole: 341,
            x: 245,
            y: 80,
            z: -124.5
          },
          {
            hole: 342,
            x: 245,
            y: 80,
            z: -132.25
          },
          {
            hole: 343,
            x: 245,
            y: 80,
            z: -140
          },
          {
            hole: 344,
            x: 245,
            y: 80,
            z: -147.75
          },
          {
            hole: 345,
            x: 245,
            y: 80,
            z: -155.5
          },
          {
            hole: 346,
            x: 245,
            y: 80,
            z: -165
          },
          {
            hole: 347,
            x: 245,
            y: 80,
            z: -182.5
          },
          {
            hole: 348,
            x: 245,
            y: 80,
            z: -205
          },
          {
            hole: 349,
            x: 222.5,
            y: 80,
            z: -205
          },
          {
            hole: 350,
            x: 205,
            y: 80,
            z: -205
          },
          {
            hole: 351,
            x: 195.5,
            y: 90,
            z: -205
          },
          {
            hole: 352,
            x: 187.75,
            y: 90,
            z: -205
          },
          {
            hole: 353,
            x: 180,
            y: 90,
            z: -205
          },
          {
            hole: 354,
            x: 172.25,
            y: 90,
            z: -205
          },
          {
            hole: 355,
            x: 164.5,
            y: 90,
            z: -205
          },
          {
            hole: 356,
            x: 155.5,
            y: 90,
            z: -205
          },
          {
            hole: 357,
            x: 147.75,
            y: 90,
            z: -205
          },
          {
            hole: 358,
            x: 140,
            y: 90,
            z: -205
          },
          {
            hole: 359,
            x: 132.25,
            y: 90,
            z: -205
          },
          {
            hole: 360,
            x: 124.5,
            y: 90,
            z: -205
          },
          {
            hole: 361,
            x: 115.5,
            y: 90,
            z: -205
          },
          {
            hole: 362,
            x: 107.75,
            y: 90,
            z: -205
          },
          {
            hole: 363,
            x: 100,
            y: 90,
            z: -205
          },
          {
            hole: 364,
            x: 92.25,
            y: 90,
            z: -205
          },
          {
            hole: 365,
            x: 84.5,
            y: 90,
            z: -205
          },
          {
            hole: 366,
            x: 75.5,
            y: 90,
            z: -205
          },
          {
            hole: 367,
            x: 67.75,
            y: 90,
            z: -205
          },
          {
            hole: 368,
            x: 60,
            y: 90,
            z: -205
          },
          {
            hole: 369,
            x: 52.25,
            y: 90,
            z: -205
          },
          {
            hole: 370,
            x: 44.5,
            y: 90,
            z: -205
          },
          {
            hole: 371,
            x: 35.5,
            y: 90,
            z: -205
          },
          {
            hole: 372,
            x: 27.75,
            y: 90,
            z: -205
          },
          {
            hole: 373,
            x: 20,
            y: 90,
            z: -205
          },
          {
            hole: 374,
            x: 12.25,
            y: 90,
            z: -205
          },
          {
            hole: 375,
            x: 4.5,
            y: 90,
            z: -205
          },
          {
            hole: 376,
            x: -5,
            y: 90,
            z: -205
          },
          {
            hole: 377,
            x: -22.5,
            y: 90,
            z: -205
          },
          {
            hole: 378,
            x: -45,
            y: 90,
            z: -205
          },
          {
            hole: 379,
            x: -45,
            y: 90,
            z: -182.5
          },
          {
            hole: 380,
            x: -45,
            y: 90,
            z: -165
          },
          {
            hole: 381,
            x: -45,
            y: 100,
            z: -155.5
          },
          {
            hole: 382,
            x: -45,
            y: 100,
            z: -147.75
          },
          {
            hole: 383,
            x: -45,
            y: 100,
            z: -140
          },
          {
            hole: 384,
            x: -45,
            y: 100,
            z: -132.25
          },
          {
            hole: 385,
            x: -45,
            y: 100,
            z: -124.5
          },
          {
            hole: 386,
            x: -45,
            y: 100,
            z: -115.5
          },
          {
            hole: 387,
            x: -45,
            y: 100,
            z: -107.75
          },
          {
            hole: 388,
            x: -45,
            y: 100,
            z: -100
          },
          {
            hole: 389,
            x: -45,
            y: 100,
            z: -92.25
          },
          {
            hole: 390,
            x: -45,
            y: 100,
            z: -84.5
          },
          {
            hole: 391,
            x: -45,
            y: 100,
            z: -75.5
          },
          {
            hole: 392,
            x: -45,
            y: 100,
            z: -67.75
          },
          {
            hole: 393,
            x: -45,
            y: 100,
            z: -60
          },
          {
            hole: 394,
            x: -45,
            y: 100,
            z: -52.25
          },
          {
            hole: 395,
            x: -45,
            y: 100,
            z: -44.5
          },
          {
            hole: 396,
            x: -45,
            y: 100,
            z: -35.5
          },
          {
            hole: 397,
            x: -45,
            y: 100,
            z: -27.75
          },
          {
            hole: 398,
            x: -45,
            y: 100,
            z: -20
          },
          {
            hole: 399,
            x: -45,
            y: 100,
            z: -12.25
          },
          {
            hole: 400,
            x: -45,
            y: 100,
            z: -4.5
          },
          {
            hole: 401,
            x: -45,
            y: 100,
            z: 4.5
          },
          {
            hole: 402,
            x: -45,
            y: 100,
            z: 12.25
          },
          {
            hole: 403,
            x: -45,
            y: 100,
            z: 20
          },
          {
            hole: 404,
            x: -45,
            y: 100,
            z: 27.75
          },
          {
            hole: 405,
            x: -45,
            y: 100,
            z: 35.5
          },
          {
            hole: 406,
            x: -45,
            y: 100,
            z: 45
          },
          {
            hole: 407,
            x: -45,
            y: 100,
            z: 52.5
          },
          {
            hole: 408,
            x: -45,
            y: 100,
            z: 65
          },
          {
            hole: 409,
            x: -32.5,
            y: 100,
            z: 65
          },
          {
            hole: 410,
            x: -25,
            y: 100,
            z: 65
          },
          {
            hole: 411,
            x: -15.5,
            y: 110,
            z: 65
          },
          {
            hole: 412,
            x: -7.75,
            y: 110,
            z: 65
          },
          {
            hole: 413,
            x: 0,
            y: 110,
            z: 65
          },
          {
            hole: 414,
            x: 7.75,
            y: 110,
            z: 65
          },
          {
            hole: 415,
            x: 15.5,
            y: 110,
            z: 65
          },
          {
            hole: 416,
            x: 24.5,
            y: 110,
            z: 65
          },
          {
            hole: 417,
            x: 32.25,
            y: 110,
            z: 65
          },
          {
            hole: 418,
            x: 40,
            y: 110,
            z: 65
          },
          {
            hole: 419,
            x: 47.75,
            y: 110,
            z: 65
          },
          {
            hole: 420,
            x: 55.5,
            y: 110,
            z: 65
          },
          {
            hole: 421,
            x: 64.5,
            y: 110,
            z: 65
          },
          {
            hole: 422,
            x: 72.25,
            y: 110,
            z: 65
          },
          {
            hole: 423,
            x: 80,
            y: 110,
            z: 65
          },
          {
            hole: 424,
            x: 87.75,
            y: 110,
            z: 65
          },
          {
            hole: 425,
            x: 95.5,
            y: 110,
            z: 65
          },
          {
            hole: 426,
            x: 104.5,
            y: 110,
            z: 65
          },
          {
            hole: 427,
            x: 112.25,
            y: 110,
            z: 65
          },
          {
            hole: 428,
            x: 120,
            y: 110,
            z: 65
          },
          {
            hole: 429,
            x: 127.75,
            y: 110,
            z: 65
          },
          {
            hole: 430,
            x: 135.5,
            y: 110,
            z: 65
          },
          {
            hole: 431,
            x: 145,
            y: 110,
            z: 65
          },
          {
            hole: 432,
            x: 152.5,
            y: 110,
            z: 65
          },
          {
            hole: 433,
            x: 165,
            y: 110,
            z: 65
          },
          {
            hole: 434,
            x: 165,
            y: 110,
            z: 52.5
          },
          {
            hole: 435,
            x: 165,
            y: 110,
            z: 45
          },
          {
            hole: 436,
            x: 165,
            y: 120,
            z: 35.5
          },
          {
            hole: 437,
            x: 165,
            y: 120,
            z: 27.75
          },
          {
            hole: 438,
            x: 165,
            y: 120,
            z: 20
          },
          {
            hole: 439,
            x: 165,
            y: 120,
            z: 12.25
          },
          {
            hole: 440,
            x: 165,
            y: 120,
            z: 4.5
          },
          {
            hole: 441,
            x: 165,
            y: 120,
            z: -4.5
          },
          {
            hole: 442,
            x: 165,
            y: 120,
            z: -12.25
          },
          {
            hole: 443,
            x: 165,
            y: 120,
            z: -20
          },
          {
            hole: 444,
            x: 165,
            y: 120,
            z: -27.75
          },
          {
            hole: 445,
            x: 165,
            y: 120,
            z: -35.5
          },
          {
            hole: 446,
            x: 165,
            y: 120,
            z: -44.5
          },
          {
            hole: 447,
            x: 165,
            y: 120,
            z: -52.25
          },
          {
            hole: 448,
            x: 165,
            y: 120,
            z: -60
          },
          {
            hole: 449,
            x: 165,
            y: 120,
            z: -67.75
          },
          {
            hole: 450,
            x: 165,
            y: 120,
            z: -75.5
          },
          {
            hole: 451,
            x: 165,
            y: 120,
            z: -85
          },
          {
            hole: 452,
            x: 165,
            y: 120,
            z: -102.5
          },
          {
            hole: 453,
            x: 165,
            y: 120,
            z: -125
          },
          {
            hole: 454,
            x: 142.5,
            y: 120,
            z: -125
          },
          {
            hole: 455,
            x: 125,
            y: 120,
            z: -125
          },
          {
            hole: 456,
            x: 115.5,
            y: 130,
            z: -125
          },
          {
            hole: 457,
            x: 107.75,
            y: 130,
            z: -125
          },
          {
            hole: 458,
            x: 100,
            y: 130,
            z: -125
          },
          {
            hole: 459,
            x: 92.25,
            y: 130,
            z: -125
          },
          {
            hole: 460,
            x: 84.5,
            y: 130,
            z: -125
          },
          {
            hole: 461,
            x: 75,
            y: 130,
            z: -125
          },
          {
            hole: 462,
            x: 57.5,
            y: 130,
            z: -125
          },
          {
            hole: 463,
            x: 35,
            y: 130,
            z: -125
          },
          {
            hole: 464,
            x: 35,
            y: 130,
            z: -102.5
          },
          {
            hole: 465,
            x: 35,
            y: 130,
            z: -85
          },
          {
            hole: 466,
            x: 35,
            y: 140,
            z: -75.5
          },
          {
            hole: 467,
            x: 35,
            y: 140,
            z: -67.75
          },
          {
            hole: 468,
            x: 35,
            y: 140,
            z: -60
          },
          {
            hole: 469,
            x: 35,
            y: 140,
            z: -52.25
          },
          {
            hole: 470,
            x: 35,
            y: 140,
            z: -44.5
          },
          {
            hole: 471,
            x: 35,
            y: 140,
            z: -35
          },
          {
            hole: 472,
            x: 35,
            y: 140,
            z: -27.5
          },
          {
            hole: 473,
            x: 35,
            y: 140,
            z: -15
          },
          {
            hole: 474,
            x: 47.5,
            y: 140,
            z: -15
          },
          {
            hole: 475,
            x: 55,
            y: 140,
            z: -15
          },
          {
            hole: 476,
            x: 65,
            y: 150,
            z: -15
          },
          {
            hole: 477,
            x: 72.5,
            y: 150,
            z: -15
          },
          {
            hole: 478,
            x: 85,
            y: 150,
            z: -15
          },
          {
            hole: 479,
            x: 85,
            y: 150,
            z: -27.5
          },
          {
            hole: 480,
            x: 85,
            y: 150,
            z: -35
          },
          {
            hole: 121,
            x: 100,
            y: 160,
            z: -60
          }
        ]
      }
    },
    {
      id: "board-cribbage-clash-spiral",
      name: "Cribbage Clash Spiral",
      brand: "clash",
      desc: "Cribbage Clash Spiral 3D cribbage board (20.3 MB)",
      target: 481,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/spiral_-_no_gap_-_height_-_colored_-_thumbnail.png?v=",
      modelUrl: "https://cdn.shopify.com/3d/models/2a5c3782f2524344/cibbage_clash_-_spiral_-_no_gap_-_height_-_colored.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: -229.4967,
            y: 10,
            z: 122.5
          },
          {
            hole: 1,
            x: 53.1259,
            y: 230,
            z: 14.235
          },
          {
            hole: 2,
            x: 47.6314,
            y: 230,
            z: 27.5
          },
          {
            hole: 3,
            x: 38.8909,
            y: 230,
            z: 38.8909
          },
          {
            hole: 4,
            x: 27.5,
            y: 230,
            z: 47.6314
          },
          {
            hole: 5,
            x: 14.235,
            y: 230,
            z: 53.1259
          },
          {
            hole: 6,
            x: -16.8232,
            y: 220,
            z: 52.7852
          },
          {
            hole: 7,
            x: -32.5,
            y: 220,
            z: 46.2917
          },
          {
            hole: 8,
            x: -45.9619,
            y: 220,
            z: 35.9619
          },
          {
            hole: 9,
            x: -56.2917,
            y: 220,
            z: 22.5
          },
          {
            hole: 10,
            x: -62.7852,
            y: 220,
            z: 6.8232
          },
          {
            hole: 11,
            x: -62.4444,
            y: 210,
            z: -29.4114
          },
          {
            hole: 12,
            x: -54.9519,
            y: 210,
            z: -47.5
          },
          {
            hole: 13,
            x: -43.033,
            y: 210,
            z: -63.033
          },
          {
            hole: 14,
            x: -27.5,
            y: 210,
            z: -74.9519
          },
          {
            hole: 15,
            x: -9.4114,
            y: 210,
            z: -82.4444
          },
          {
            hole: 16,
            x: 31.9996,
            y: 200,
            z: -82.1037
          },
          {
            hole: 17,
            x: 52.5,
            y: 200,
            z: -73.6122
          },
          {
            hole: 18,
            x: 70.1041,
            y: 200,
            z: -60.1041
          },
          {
            hole: 19,
            x: 83.6122,
            y: 200,
            z: -42.5
          },
          {
            hole: 20,
            x: 92.1037,
            y: 200,
            z: -21.9996
          },
          {
            hole: 21,
            x: 94.1873,
            y: 190,
            z: 12.4
          },
          {
            hole: 22,
            x: 91.763,
            y: 190,
            z: 24.5878
          },
          {
            hole: 23,
            x: 87.7686,
            y: 190,
            z: 36.3549
          },
          {
            hole: 24,
            x: 82.2724,
            y: 190,
            z: 47.5
          },
          {
            hole: 25,
            x: 75.3686,
            y: 190,
            z: 57.8323
          },
          {
            hole: 26,
            x: 57.8323,
            y: 190,
            z: 75.3685
          },
          {
            hole: 27,
            x: 47.5,
            y: 190,
            z: 82.2724
          },
          {
            hole: 28,
            x: 36.3549,
            y: 190,
            z: 87.7685
          },
          {
            hole: 29,
            x: 24.5878,
            y: 190,
            z: 91.7629
          },
          {
            hole: 30,
            x: 12.4,
            y: 190,
            z: 94.1872
          },
          {
            hole: 31,
            x: -13.7053,
            y: 180,
            z: 94.1017
          },
          {
            hole: 32,
            x: -27.176,
            y: 180,
            z: 91.4222
          },
          {
            hole: 33,
            x: -40.1818,
            y: 180,
            z: 87.0073
          },
          {
            hole: 34,
            x: -52.5,
            y: 180,
            z: 80.9327
          },
          {
            hole: 35,
            x: -63.92,
            y: 180,
            z: 73.3021
          },
          {
            hole: 36,
            x: -83.3021,
            y: 180,
            z: 53.9199
          },
          {
            hole: 37,
            x: -90.9327,
            y: 180,
            z: 42.5
          },
          {
            hole: 38,
            x: -97.0073,
            y: 180,
            z: 30.1818
          },
          {
            hole: 39,
            x: -101.4222,
            y: 180,
            z: 17.176
          },
          {
            hole: 40,
            x: -104.1017,
            y: 180,
            z: 3.7053
          },
          {
            hole: 41,
            x: -104.0162,
            y: 170,
            z: -25.0105
          },
          {
            hole: 42,
            x: -101.0815,
            y: 170,
            z: -39.7642
          },
          {
            hole: 43,
            x: -96.2461,
            y: 170,
            z: -54.0086
          },
          {
            hole: 44,
            x: -89.5929,
            y: 170,
            z: -67.5
          },
          {
            hole: 45,
            x: -81.2356,
            y: 170,
            z: -80.0076
          },
          {
            hole: 46,
            x: -60.0076,
            y: 170,
            z: -101.2356
          },
          {
            hole: 47,
            x: -47.5,
            y: 170,
            z: -109.5929
          },
          {
            hole: 48,
            x: -34.0086,
            y: 170,
            z: -116.2461
          },
          {
            hole: 49,
            x: -19.7642,
            y: 170,
            z: -121.0815
          },
          {
            hole: 50,
            x: -5.0105,
            y: 170,
            z: -124.0162
          },
          {
            hole: 51,
            x: 26.3158,
            y: 160,
            z: -123.9306
          },
          {
            hole: 52,
            x: 42.3524,
            y: 160,
            z: -120.7407
          },
          {
            hole: 53,
            x: 57.8354,
            y: 160,
            z: -115.4849
          },
          {
            hole: 54,
            x: 72.5,
            y: 160,
            z: -108.2532
          },
          {
            hole: 55,
            x: 86.0952,
            y: 160,
            z: -99.1692
          },
          {
            hole: 56,
            x: 109.1692,
            y: 160,
            z: -76.0952
          },
          {
            hole: 57,
            x: 118.2532,
            y: 160,
            z: -62.5
          },
          {
            hole: 58,
            x: 125.4849,
            y: 160,
            z: -47.8354
          },
          {
            hole: 59,
            x: 130.7407,
            y: 160,
            z: -32.3524
          },
          {
            hole: 60,
            x: 133.9306,
            y: 160,
            z: -16.3158
          },
          {
            hole: 61,
            x: 134.7109,
            y: 150,
            z: 8.8294
          },
          {
            hole: 62,
            x: 133.845,
            y: 150,
            z: 17.621
          },
          {
            hole: 63,
            x: 132.406,
            y: 150,
            z: 26.3372
          },
          {
            hole: 64,
            x: 130.4,
            y: 150,
            z: 34.9406
          },
          {
            hole: 65,
            x: 127.8356,
            y: 150,
            z: 43.3943
          },
          {
            hole: 66,
            x: 121.0778,
            y: 150,
            z: 59.709
          },
          {
            hole: 67,
            x: 116.9134,
            y: 150,
            z: 67.5
          },
          {
            hole: 68,
            x: 112.2484,
            y: 150,
            z: 75.002
          },
          {
            hole: 69,
            x: 107.1027,
            y: 150,
            z: 82.1828
          },
          {
            hole: 70,
            x: 101.4984,
            y: 150,
            z: 89.0117
          },
          {
            hole: 71,
            x: 89.0117,
            y: 150,
            z: 101.4984
          },
          {
            hole: 72,
            x: 82.1828,
            y: 150,
            z: 107.1027
          },
          {
            hole: 73,
            x: 75.002,
            y: 150,
            z: 112.2484
          },
          {
            hole: 74,
            x: 67.5,
            y: 150,
            z: 116.9134
          },
          {
            hole: 75,
            x: 59.709,
            y: 150,
            z: 121.0778
          },
          {
            hole: 76,
            x: 43.3943,
            y: 150,
            z: 127.8356
          },
          {
            hole: 77,
            x: 34.9406,
            y: 150,
            z: 130.4
          },
          {
            hole: 78,
            x: 26.3372,
            y: 150,
            z: 132.406
          },
          {
            hole: 79,
            x: 17.621,
            y: 150,
            z: 133.845
          },
          {
            hole: 80,
            x: 8.8294,
            y: 150,
            z: 134.7109
          },
          {
            hole: 81,
            x: -9.4835,
            y: 140,
            z: 134.6895
          },
          {
            hole: 82,
            x: -18.9263,
            y: 140,
            z: 133.7595
          },
          {
            hole: 83,
            x: -28.2881,
            y: 140,
            z: 132.2139
          },
          {
            hole: 84,
            x: -37.5288,
            y: 140,
            z: 130.0592
          },
          {
            hole: 85,
            x: -46.6087,
            y: 140,
            z: 127.3049
          },
          {
            hole: 86,
            x: -64.1318,
            y: 140,
            z: 120.0465
          },
          {
            hole: 87,
            x: -72.5,
            y: 140,
            z: 115.5737
          },
          {
            hole: 88,
            x: -80.5577,
            y: 140,
            z: 110.5631
          },
          {
            hole: 89,
            x: -88.2704,
            y: 140,
            z: 105.0362
          },
          {
            hole: 90,
            x: -95.6051,
            y: 140,
            z: 99.0168
          },
          {
            hole: 91,
            x: -109.0168,
            y: 140,
            z: 85.6051
          },
          {
            hole: 92,
            x: -115.0362,
            y: 140,
            z: 78.2704
          },
          {
            hole: 93,
            x: -120.5631,
            y: 140,
            z: 70.5577
          },
          {
            hole: 94,
            x: -125.5737,
            y: 140,
            z: 62.5
          },
          {
            hole: 95,
            x: -130.0466,
            y: 140,
            z: 54.1319
          },
          {
            hole: 96,
            x: -137.3049,
            y: 140,
            z: 36.6087
          },
          {
            hole: 97,
            x: -140.0592,
            y: 140,
            z: 27.5288
          },
          {
            hole: 98,
            x: -142.2139,
            y: 140,
            z: 18.2881
          },
          {
            hole: 99,
            x: -143.7595,
            y: 140,
            z: 8.9263
          },
          {
            hole: 100,
            x: -144.6895,
            y: 140,
            z: -0.5165
          },
          {
            hole: 101,
            x: -144.6681,
            y: 130,
            z: -20.1375
          },
          {
            hole: 102,
            x: -143.6739,
            y: 130,
            z: -30.2316
          },
          {
            hole: 103,
            x: -142.0217,
            y: 130,
            z: -40.239
          },
          {
            hole: 104,
            x: -139.7185,
            y: 130,
            z: -50.117
          },
          {
            hole: 105,
            x: -136.7742,
            y: 130,
            z: -59.8231
          },
          {
            hole: 106,
            x: -129.0153,
            y: 130,
            z: -78.5547
          },
          {
            hole: 107,
            x: -124.2339,
            y: 130,
            z: -87.5
          },
          {
            hole: 108,
            x: -118.8778,
            y: 130,
            z: -96.1134
          },
          {
            hole: 109,
            x: -112.9698,
            y: 130,
            z: -104.358
          },
          {
            hole: 110,
            x: -106.5352,
            y: 130,
            z: -112.1986
          },
          {
            hole: 111,
            x: -92.1986,
            y: 130,
            z: -126.5352
          },
          {
            hole: 112,
            x: -84.358,
            y: 130,
            z: -132.9698
          },
          {
            hole: 113,
            x: -76.1134,
            y: 130,
            z: -138.8778
          },
          {
            hole: 114,
            x: -67.5,
            y: 130,
            z: -144.2339
          },
          {
            hole: 115,
            x: -58.5547,
            y: 130,
            z: -149.0153
          },
          {
            hole: 116,
            x: -39.8231,
            y: 130,
            z: -156.7742
          },
          {
            hole: 117,
            x: -30.1169,
            y: 130,
            z: -159.7185
          },
          {
            hole: 118,
            x: -20.239,
            y: 130,
            z: -162.0217
          },
          {
            hole: 119,
            x: -10.2315,
            y: 130,
            z: -163.6739
          },
          {
            hole: 120,
            x: -0.1375,
            y: 130,
            z: -164.6681
          },
          {
            hole: 121,
            x: 20.7915,
            y: 120,
            z: -164.6467
          },
          {
            hole: 122,
            x: 31.5368,
            y: 120,
            z: -163.5884
          },
          {
            hole: 123,
            x: 42.1899,
            y: 120,
            z: -161.8296
          },
          {
            hole: 124,
            x: 52.7051,
            y: 120,
            z: -159.3778
          },
          {
            hole: 125,
            x: 63.0375,
            y: 120,
            z: -156.2435
          },
          {
            hole: 126,
            x: 82.9776,
            y: 120,
            z: -147.984
          },
          {
            hole: 127,
            x: 92.5,
            y: 120,
            z: -142.8942
          },
          {
            hole: 128,
            x: 101.6691,
            y: 120,
            z: -137.1925
          },
          {
            hole: 129,
            x: 110.4456,
            y: 120,
            z: -130.9033
          },
          {
            hole: 130,
            x: 118.7921,
            y: 120,
            z: -124.0536
          },
          {
            hole: 131,
            x: 134.0536,
            y: 120,
            z: -108.7921
          },
          {
            hole: 132,
            x: 140.9033,
            y: 120,
            z: -100.4456
          },
          {
            hole: 133,
            x: 147.1925,
            y: 120,
            z: -91.6691
          },
          {
            hole: 134,
            x: 152.8942,
            y: 120,
            z: -82.5
          },
          {
            hole: 135,
            x: 157.984,
            y: 120,
            z: -72.9776
          },
          {
            hole: 136,
            x: 166.2435,
            y: 120,
            z: -53.0375
          },
          {
            hole: 137,
            x: 169.3778,
            y: 120,
            z: -42.7051
          },
          {
            hole: 138,
            x: 171.8296,
            y: 120,
            z: -32.1899
          },
          {
            hole: 139,
            x: 173.5884,
            y: 120,
            z: -21.5368
          },
          {
            hole: 140,
            x: 174.6467,
            y: 120,
            z: -10.7915
          },
          {
            hole: 141,
            x: 174.8334,
            y: 110,
            z: 7.6334
          },
          {
            hole: 142,
            x: 174.3341,
            y: 110,
            z: 15.2523
          },
          {
            hole: 143,
            x: 173.5029,
            y: 110,
            z: 22.8421
          },
          {
            hole: 144,
            x: 172.3414,
            y: 110,
            z: 30.3884
          },
          {
            hole: 145,
            x: 170.8518,
            y: 110,
            z: 37.8769
          },
          {
            hole: 146,
            x: 166.9005,
            y: 110,
            z: 52.6235
          },
          {
            hole: 147,
            x: 164.4462,
            y: 110,
            z: 59.8535
          },
          {
            hole: 148,
            x: 161.6789,
            y: 110,
            z: 66.9696
          },
          {
            hole: 149,
            x: 158.6039,
            y: 110,
            z: 73.9582
          },
          {
            hole: 150,
            x: 155.2269,
            y: 110,
            z: 80.806
          },
          {
            hole: 151,
            x: 147.5935,
            y: 110,
            z: 94.0274
          },
          {
            hole: 152,
            x: 143.3516,
            y: 110,
            z: 100.3759
          },
          {
            hole: 153,
            x: 138.8368,
            y: 110,
            z: 106.5333
          },
          {
            hole: 154,
            x: 134.0578,
            y: 110,
            z: 112.4878
          },
          {
            hole: 155,
            x: 129.0235,
            y: 110,
            z: 118.2283
          },
          {
            hole: 156,
            x: 118.2283,
            y: 110,
            z: 129.0235
          },
          {
            hole: 157,
            x: 112.4878,
            y: 110,
            z: 134.0578
          },
          {
            hole: 158,
            x: 106.5333,
            y: 110,
            z: 138.8368
          },
          {
            hole: 159,
            x: 100.3759,
            y: 110,
            z: 143.3516
          },
          {
            hole: 160,
            x: 94.0274,
            y: 110,
            z: 147.5935
          },
          {
            hole: 161,
            x: 80.806,
            y: 110,
            z: 155.2269
          },
          {
            hole: 162,
            x: 73.9582,
            y: 110,
            z: 158.6039
          },
          {
            hole: 163,
            x: 66.9696,
            y: 110,
            z: 161.6789
          },
          {
            hole: 164,
            x: 59.8535,
            y: 110,
            z: 164.4462
          },
          {
            hole: 165,
            x: 52.6235,
            y: 110,
            z: 166.9005
          },
          {
            hole: 166,
            x: 37.8769,
            y: 110,
            z: 170.8518
          },
          {
            hole: 167,
            x: 30.3884,
            y: 110,
            z: 172.3414
          },
          {
            hole: 168,
            x: 22.8421,
            y: 110,
            z: 173.5028
          },
          {
            hole: 169,
            x: 15.2523,
            y: 110,
            z: 174.3341
          },
          {
            hole: 170,
            x: 7.6334,
            y: 110,
            z: 174.8334
          },
          {
            hole: 171,
            x: -8.0696,
            y: 100,
            z: 174.8239
          },
          {
            hole: 172,
            x: -16.1238,
            y: 100,
            z: 174.296
          },
          {
            hole: 173,
            x: -24.1473,
            y: 100,
            z: 173.4173
          },
          {
            hole: 174,
            x: -32.1249,
            y: 100,
            z: 172.1894
          },
          {
            hole: 175,
            x: -40.0413,
            y: 100,
            z: 170.6148
          },
          {
            hole: 176,
            x: -55.6306,
            y: 100,
            z: 166.4376
          },
          {
            hole: 177,
            x: -63.2737,
            y: 100,
            z: 163.8431
          },
          {
            hole: 178,
            x: -70.7964,
            y: 100,
            z: 160.9177
          },
          {
            hole: 179,
            x: -78.1844,
            y: 100,
            z: 157.6669
          },
          {
            hole: 180,
            x: -85.4235,
            y: 100,
            z: 154.097
          },
          {
            hole: 181,
            x: -99.4004,
            y: 100,
            z: 146.0274
          },
          {
            hole: 182,
            x: -106.1116,
            y: 100,
            z: 141.5431
          },
          {
            hole: 183,
            x: -112.6209,
            y: 100,
            z: 136.7704
          },
          {
            hole: 184,
            x: -118.9157,
            y: 100,
            z: 131.7182
          },
          {
            hole: 185,
            x: -124.9842,
            y: 100,
            z: 126.3963
          },
          {
            hole: 186,
            x: -136.3963,
            y: 100,
            z: 114.9842
          },
          {
            hole: 187,
            x: -141.7182,
            y: 100,
            z: 108.9157
          },
          {
            hole: 188,
            x: -146.7704,
            y: 100,
            z: 102.6209
          },
          {
            hole: 189,
            x: -151.5431,
            y: 100,
            z: 96.1116
          },
          {
            hole: 190,
            x: -156.0274,
            y: 100,
            z: 89.4004
          },
          {
            hole: 191,
            x: -164.097,
            y: 100,
            z: 75.4235
          },
          {
            hole: 192,
            x: -167.6669,
            y: 100,
            z: 68.1844
          },
          {
            hole: 193,
            x: -170.9177,
            y: 100,
            z: 60.7964
          },
          {
            hole: 194,
            x: -173.8431,
            y: 100,
            z: 53.2737
          },
          {
            hole: 195,
            x: -176.4376,
            y: 100,
            z: 45.6306
          },
          {
            hole: 196,
            x: -180.6148,
            y: 100,
            z: 30.0413
          },
          {
            hole: 197,
            x: -182.1894,
            y: 100,
            z: 22.1249
          },
          {
            hole: 198,
            x: -183.4173,
            y: 100,
            z: 14.1473
          },
          {
            hole: 199,
            x: -184.296,
            y: 100,
            z: 6.1238
          },
          {
            hole: 200,
            x: -184.8239,
            y: 100,
            z: -1.9304
          },
          {
            hole: 201,
            x: -184.8144,
            y: 90,
            z: -18.5058
          },
          {
            hole: 202,
            x: -184.258,
            y: 90,
            z: -26.9954
          },
          {
            hole: 203,
            x: -183.3318,
            y: 90,
            z: -35.4526
          },
          {
            hole: 204,
            x: -182.0375,
            y: 90,
            z: -43.8614
          },
          {
            hole: 205,
            x: -180.3777,
            y: 90,
            z: -52.2057
          },
          {
            hole: 206,
            x: -175.9748,
            y: 90,
            z: -68.6376
          },
          {
            hole: 207,
            x: -173.2401,
            y: 90,
            z: -76.6939
          },
          {
            hole: 208,
            x: -170.1565,
            y: 90,
            z: -84.6233
          },
          {
            hole: 209,
            x: -166.73,
            y: 90,
            z: -92.4106
          },
          {
            hole: 210,
            x: -162.9671,
            y: 90,
            z: -100.041
          },
          {
            hole: 211,
            x: -154.4613,
            y: 90,
            z: -114.7734
          },
          {
            hole: 212,
            x: -149.7347,
            y: 90,
            z: -121.8474
          },
          {
            hole: 213,
            x: -144.7039,
            y: 90,
            z: -128.7085
          },
          {
            hole: 214,
            x: -139.3787,
            y: 90,
            z: -135.3436
          },
          {
            hole: 215,
            x: -133.7691,
            y: 90,
            z: -141.7401
          },
          {
            hole: 216,
            x: -121.7401,
            y: 90,
            z: -153.7691
          },
          {
            hole: 217,
            x: -115.3436,
            y: 90,
            z: -159.3787
          },
          {
            hole: 218,
            x: -108.7085,
            y: 90,
            z: -164.7039
          },
          {
            hole: 219,
            x: -101.8474,
            y: 90,
            z: -169.7346
          },
          {
            hole: 220,
            x: -94.7734,
            y: 90,
            z: -174.4613
          },
          {
            hole: 221,
            x: -80.041,
            y: 90,
            z: -182.9671
          },
          {
            hole: 222,
            x: -72.4105,
            y: 90,
            z: -186.73
          },
          {
            hole: 223,
            x: -64.6233,
            y: 90,
            z: -190.1565
          },
          {
            hole: 224,
            x: -56.6939,
            y: 90,
            z: -193.2401
          },
          {
            hole: 225,
            x: -48.6376,
            y: 90,
            z: -195.9748
          },
          {
            hole: 226,
            x: -32.2057,
            y: 90,
            z: -200.3777
          },
          {
            hole: 227,
            x: -23.8614,
            y: 90,
            z: -202.0375
          },
          {
            hole: 228,
            x: -15.4526,
            y: 90,
            z: -203.3317
          },
          {
            hole: 229,
            x: -6.9954,
            y: 90,
            z: -204.2579
          },
          {
            hole: 230,
            x: 1.4942,
            y: 90,
            z: -204.8144
          },
          {
            hole: 231,
            x: 18.942,
            y: 80,
            z: -204.8049
          },
          {
            hole: 232,
            x: 27.8669,
            y: 80,
            z: -204.2199
          },
          {
            hole: 233,
            x: 36.7579,
            y: 80,
            z: -203.2462
          },
          {
            hole: 234,
            x: 45.5979,
            y: 80,
            z: -201.8856
          },
          {
            hole: 235,
            x: 54.3701,
            y: 80,
            z: -200.1407
          },
          {
            hole: 236,
            x: 71.6447,
            y: 80,
            z: -195.512
          },
          {
            hole: 237,
            x: 80.1141,
            y: 80,
            z: -192.637
          },
          {
            hole: 238,
            x: 88.4501,
            y: 80,
            z: -189.3953
          },
          {
            hole: 239,
            x: 96.6367,
            y: 80,
            z: -185.7931
          },
          {
            hole: 240,
            x: 104.6585,
            y: 80,
            z: -181.8372
          },
          {
            hole: 241,
            x: 120.1464,
            y: 80,
            z: -172.8952
          },
          {
            hole: 242,
            x: 127.5832,
            y: 80,
            z: -167.9262
          },
          {
            hole: 243,
            x: 134.7961,
            y: 80,
            z: -162.6374
          },
          {
            hole: 244,
            x: 141.7715,
            y: 80,
            z: -157.0391
          },
          {
            hole: 245,
            x: 148.496,
            y: 80,
            z: -151.1418
          },
          {
            hole: 246,
            x: 161.1419,
            y: 80,
            z: -138.496
          },
          {
            hole: 247,
            x: 167.0391,
            y: 80,
            z: -131.7714
          },
          {
            hole: 248,
            x: 172.6374,
            y: 80,
            z: -124.7961
          },
          {
            hole: 249,
            x: 177.9262,
            y: 80,
            z: -117.5832
          },
          {
            hole: 250,
            x: 182.8952,
            y: 80,
            z: -110.1464
          },
          {
            hole: 251,
            x: 191.8372,
            y: 80,
            z: -94.6585
          },
          {
            hole: 252,
            x: 195.7931,
            y: 80,
            z: -86.6367
          },
          {
            hole: 253,
            x: 199.3953,
            y: 80,
            z: -78.4501
          },
          {
            hole: 254,
            x: 202.637,
            y: 80,
            z: -70.1141
          },
          {
            hole: 255,
            x: 205.512,
            y: 80,
            z: -61.6447
          },
          {
            hole: 256,
            x: 210.1407,
            y: 80,
            z: -44.3701
          },
          {
            hole: 257,
            x: 211.8856,
            y: 80,
            z: -35.5979
          },
          {
            hole: 258,
            x: 213.2462,
            y: 80,
            z: -26.7578
          },
          {
            hole: 259,
            x: 214.2199,
            y: 80,
            z: -17.8669
          },
          {
            hole: 260,
            x: 214.8049,
            y: 80,
            z: -8.942
          },
          {
            hole: 261,
            x: 214.8849,
            y: 70,
            z: 7.0346
          },
          {
            hole: 262,
            x: 214.5397,
            y: 70,
            z: 14.0617
          },
          {
            hole: 263,
            x: 213.9647,
            y: 70,
            z: 21.0737
          },
          {
            hole: 264,
            x: 213.1606,
            y: 70,
            z: 28.0631
          },
          {
            hole: 265,
            x: 212.1283,
            y: 70,
            z: 35.0225
          },
          {
            hole: 266,
            x: 209.3835,
            y: 70,
            z: 48.8214
          },
          {
            hole: 267,
            x: 207.674,
            y: 70,
            z: 55.6461
          },
          {
            hole: 268,
            x: 205.7422,
            y: 70,
            z: 62.4112
          },
          {
            hole: 269,
            x: 203.59,
            y: 70,
            z: 69.1095
          },
          {
            hole: 270,
            x: 201.2198,
            y: 70,
            z: 75.7338
          },
          {
            hole: 271,
            x: 195.8357,
            y: 70,
            z: 88.732
          },
          {
            hole: 272,
            x: 192.8276,
            y: 70,
            z: 95.0921
          },
          {
            hole: 273,
            x: 189.6131,
            y: 70,
            z: 101.3503
          },
          {
            hole: 274,
            x: 186.1955,
            y: 70,
            z: 107.5
          },
          {
            hole: 275,
            x: 182.5785,
            y: 70,
            z: 113.5346
          },
          {
            hole: 276,
            x: 174.762,
            y: 70,
            z: 125.2327
          },
          {
            hole: 277,
            x: 170.571,
            y: 70,
            z: 130.8837
          },
          {
            hole: 278,
            x: 166.1972,
            y: 70,
            z: 136.3946
          },
          {
            hole: 279,
            x: 161.6456,
            y: 70,
            z: 141.7594
          },
          {
            hole: 280,
            x: 156.9208,
            y: 70,
            z: 146.9723
          },
          {
            hole: 281,
            x: 146.9723,
            y: 70,
            z: 156.9208
          },
          {
            hole: 282,
            x: 141.7593,
            y: 70,
            z: 161.6456
          },
          {
            hole: 283,
            x: 136.3946,
            y: 70,
            z: 166.1972
          },
          {
            hole: 284,
            x: 130.8837,
            y: 70,
            z: 170.571
          },
          {
            hole: 285,
            x: 125.2327,
            y: 70,
            z: 174.762
          },
          {
            hole: 286,
            x: 113.5346,
            y: 70,
            z: 182.5785
          },
          {
            hole: 287,
            x: 107.5,
            y: 70,
            z: 186.1955
          },
          {
            hole: 288,
            x: 101.3503,
            y: 70,
            z: 189.6131
          },
          {
            hole: 289,
            x: 95.0921,
            y: 70,
            z: 192.8276
          },
          {
            hole: 290,
            x: 88.732,
            y: 70,
            z: 195.8357
          },
          {
            hole: 291,
            x: 75.7338,
            y: 70,
            z: 201.2198
          },
          {
            hole: 292,
            x: 69.1095,
            y: 70,
            z: 203.59
          },
          {
            hole: 293,
            x: 62.4112,
            y: 70,
            z: 205.7422
          },
          {
            hole: 294,
            x: 55.6461,
            y: 70,
            z: 207.674
          },
          {
            hole: 295,
            x: 48.8214,
            y: 70,
            z: 209.3835
          },
          {
            hole: 296,
            x: 35.0226,
            y: 70,
            z: 212.1283
          },
          {
            hole: 297,
            x: 28.0632,
            y: 70,
            z: 213.1606
          },
          {
            hole: 298,
            x: 21.0737,
            y: 70,
            z: 213.9647
          },
          {
            hole: 299,
            x: 14.0617,
            y: 70,
            z: 214.5397
          },
          {
            hole: 300,
            x: 7.0346,
            y: 70,
            z: 214.8849
          },
          {
            hole: 301,
            x: -7.3618,
            y: 60,
            z: 214.8795
          },
          {
            hole: 302,
            x: -14.7157,
            y: 60,
            z: 214.5183
          },
          {
            hole: 303,
            x: -22.0539,
            y: 60,
            z: 213.9166
          },
          {
            hole: 304,
            x: -29.3684,
            y: 60,
            z: 213.0751
          },
          {
            hole: 305,
            x: -36.6515,
            y: 60,
            z: 211.9947
          },
          {
            hole: 306,
            x: -51.0922,
            y: 60,
            z: 209.1223
          },
          {
            hole: 307,
            x: -58.2343,
            y: 60,
            z: 207.3333
          },
          {
            hole: 308,
            x: -65.3141,
            y: 60,
            z: 205.3116
          },
          {
            hole: 309,
            x: -72.3239,
            y: 60,
            z: 203.0593
          },
          {
            hole: 310,
            x: -79.2563,
            y: 60,
            z: 200.5788
          },
          {
            hole: 311,
            x: -92.8591,
            y: 60,
            z: 194.9444
          },
          {
            hole: 312,
            x: -99.515,
            y: 60,
            z: 191.7964
          },
          {
            hole: 313,
            x: -106.0643,
            y: 60,
            z: 188.4323
          },
          {
            hole: 314,
            x: -112.5,
            y: 60,
            z: 184.8557
          },
          {
            hole: 315,
            x: -118.8153,
            y: 60,
            z: 181.0705
          },
          {
            hole: 316,
            x: -131.0575,
            y: 60,
            z: 172.8905
          },
          {
            hole: 317,
            x: -136.9713,
            y: 60,
            z: 168.5045
          },
          {
            hole: 318,
            x: -142.7385,
            y: 60,
            z: 163.9273
          },
          {
            hole: 319,
            x: -148.3528,
            y: 60,
            z: 159.164
          },
          {
            hole: 320,
            x: -153.8083,
            y: 60,
            z: 154.2194
          },
          {
            hole: 321,
            x: -164.2194,
            y: 60,
            z: 143.8083
          },
          {
            hole: 322,
            x: -169.164,
            y: 60,
            z: 138.3528
          },
          {
            hole: 323,
            x: -173.9273,
            y: 60,
            z: 132.7385
          },
          {
            hole: 324,
            x: -178.5045,
            y: 60,
            z: 126.9713
          },
          {
            hole: 325,
            x: -182.8905,
            y: 60,
            z: 121.0575
          },
          {
            hole: 326,
            x: -191.0705,
            y: 60,
            z: 108.8153
          },
          {
            hole: 327,
            x: -194.8557,
            y: 60,
            z: 102.5
          },
          {
            hole: 328,
            x: -198.4323,
            y: 60,
            z: 96.0643
          },
          {
            hole: 329,
            x: -201.7964,
            y: 60,
            z: 89.515
          },
          {
            hole: 330,
            x: -204.9444,
            y: 60,
            z: 82.8591
          },
          {
            hole: 331,
            x: -210.5788,
            y: 60,
            z: 69.2563
          },
          {
            hole: 332,
            x: -213.0593,
            y: 60,
            z: 62.3239
          },
          {
            hole: 333,
            x: -215.3116,
            y: 60,
            z: 55.3141
          },
          {
            hole: 334,
            x: -217.3333,
            y: 60,
            z: 48.2343
          },
          {
            hole: 335,
            x: -219.1223,
            y: 60,
            z: 41.0922
          },
          {
            hole: 336,
            x: -221.9947,
            y: 60,
            z: 26.6515
          },
          {
            hole: 337,
            x: -223.0751,
            y: 60,
            z: 19.3684
          },
          {
            hole: 338,
            x: -223.9166,
            y: 60,
            z: 12.0539
          },
          {
            hole: 339,
            x: -224.5183,
            y: 60,
            z: 4.7157
          },
          {
            hole: 340,
            x: -224.8795,
            y: 60,
            z: -2.6382
          },
          {
            hole: 341,
            x: -224.8742,
            y: 50,
            z: -17.689
          },
          {
            hole: 342,
            x: -224.4968,
            y: 50,
            z: -25.3697
          },
          {
            hole: 343,
            x: -223.8684,
            y: 50,
            z: -33.034
          },
          {
            hole: 344,
            x: -222.9895,
            y: 50,
            z: -40.6737
          },
          {
            hole: 345,
            x: -221.8612,
            y: 50,
            z: -48.2804
          },
          {
            hole: 346,
            x: -218.8611,
            y: 50,
            z: -63.3629
          },
          {
            hole: 347,
            x: -216.9926,
            y: 50,
            z: -70.8225
          },
          {
            hole: 348,
            x: -214.881,
            y: 50,
            z: -78.2169
          },
          {
            hole: 349,
            x: -212.5286,
            y: 50,
            z: -85.5383
          },
          {
            hole: 350,
            x: -209.9379,
            y: 50,
            z: -92.7788
          },
          {
            hole: 351,
            x: -204.053,
            y: 50,
            z: -106.9862
          },
          {
            hole: 352,
            x: -200.7651,
            y: 50,
            z: -113.9378
          },
          {
            hole: 353,
            x: -197.2515,
            y: 50,
            z: -120.7782
          },
          {
            hole: 354,
            x: -193.516,
            y: 50,
            z: -127.5
          },
          {
            hole: 355,
            x: -189.5625,
            y: 50,
            z: -134.0959
          },
          {
            hole: 356,
            x: -181.019,
            y: 50,
            z: -146.8823
          },
          {
            hole: 357,
            x: -176.438,
            y: 50,
            z: -153.0589
          },
          {
            hole: 358,
            x: -171.6575,
            y: 50,
            z: -159.0824
          },
          {
            hole: 359,
            x: -166.6824,
            y: 50,
            z: -164.9463
          },
          {
            hole: 360,
            x: -161.5181,
            y: 50,
            z: -170.6442
          },
          {
            hole: 361,
            x: -150.6442,
            y: 50,
            z: -181.5181
          },
          {
            hole: 362,
            x: -144.9463,
            y: 50,
            z: -186.6824
          },
          {
            hole: 363,
            x: -139.0824,
            y: 50,
            z: -191.6575
          },
          {
            hole: 364,
            x: -133.0589,
            y: 50,
            z: -196.438
          },
          {
            hole: 365,
            x: -126.8823,
            y: 50,
            z: -201.019
          },
          {
            hole: 366,
            x: -114.0959,
            y: 50,
            z: -209.5625
          },
          {
            hole: 367,
            x: -107.5,
            y: 50,
            z: -213.516
          },
          {
            hole: 368,
            x: -100.7782,
            y: 50,
            z: -217.2515
          },
          {
            hole: 369,
            x: -93.9378,
            y: 50,
            z: -220.7651
          },
          {
            hole: 370,
            x: -86.9862,
            y: 50,
            z: -224.053
          },
          {
            hole: 371,
            x: -72.7787,
            y: 50,
            z: -229.9379
          },
          {
            hole: 372,
            x: -65.5383,
            y: 50,
            z: -232.5286
          },
          {
            hole: 373,
            x: -58.2169,
            y: 50,
            z: -234.881
          },
          {
            hole: 374,
            x: -50.8225,
            y: 50,
            z: -236.9926
          },
          {
            hole: 375,
            x: -43.3629,
            y: 50,
            z: -238.8611
          },
          {
            hole: 376,
            x: -28.2804,
            y: 50,
            z: -241.8612
          },
          {
            hole: 377,
            x: -20.6737,
            y: 50,
            z: -242.9895
          },
          {
            hole: 378,
            x: -13.034,
            y: 50,
            z: -243.8684
          },
          {
            hole: 379,
            x: -5.3697,
            y: 50,
            z: -244.4968
          },
          {
            hole: 380,
            x: 2.311,
            y: 50,
            z: -244.8742
          },
          {
            hole: 381,
            x: 18.0162,
            y: 40,
            z: -244.8688
          },
          {
            hole: 382,
            x: 26.0238,
            y: 40,
            z: -244.4755
          },
          {
            hole: 383,
            x: 34.0142,
            y: 40,
            z: -243.8203
          },
          {
            hole: 384,
            x: 41.9789,
            y: 40,
            z: -242.904
          },
          {
            hole: 385,
            x: 49.9094,
            y: 40,
            z: -241.7276
          },
          {
            hole: 386,
            x: 65.6337,
            y: 40,
            z: -238.5999
          },
          {
            hole: 387,
            x: 73.4107,
            y: 40,
            z: -236.6518
          },
          {
            hole: 388,
            x: 81.1198,
            y: 40,
            z: -234.4504
          },
          {
            hole: 389,
            x: 88.7527,
            y: 40,
            z: -231.9979
          },
          {
            hole: 390,
            x: 96.3013,
            y: 40,
            z: -229.297
          },
          {
            hole: 391,
            x: 111.1132,
            y: 40,
            z: -223.1616
          },
          {
            hole: 392,
            x: 118.3607,
            y: 40,
            z: -219.7338
          },
          {
            hole: 393,
            x: 125.4922,
            y: 40,
            z: -216.0707
          },
          {
            hole: 394,
            x: 132.5,
            y: 40,
            z: -212.1762
          },
          {
            hole: 395,
            x: 139.3766,
            y: 40,
            z: -208.0545
          },
          {
            hole: 396,
            x: 152.707,
            y: 40,
            z: -199.1474
          },
          {
            hole: 397,
            x: 159.1466,
            y: 40,
            z: -194.3716
          },
          {
            hole: 398,
            x: 165.4264,
            y: 40,
            z: -189.3876
          },
          {
            hole: 399,
            x: 171.5397,
            y: 40,
            z: -184.2008
          },
          {
            hole: 400,
            x: 177.4801,
            y: 40,
            z: -178.8167
          },
          {
            hole: 401,
            x: 188.8167,
            y: 40,
            z: -167.4801
          },
          {
            hole: 402,
            x: 194.2007,
            y: 40,
            z: -161.5397
          },
          {
            hole: 403,
            x: 199.3876,
            y: 40,
            z: -155.4264
          },
          {
            hole: 404,
            x: 204.3716,
            y: 40,
            z: -149.1466
          },
          {
            hole: 405,
            x: 209.1474,
            y: 40,
            z: -142.707
          },
          {
            hole: 406,
            x: 218.0545,
            y: 40,
            z: -129.3766
          },
          {
            hole: 407,
            x: 222.1762,
            y: 40,
            z: -122.5
          },
          {
            hole: 408,
            x: 226.0707,
            y: 40,
            z: -115.4922
          },
          {
            hole: 409,
            x: 229.7338,
            y: 40,
            z: -108.3607
          },
          {
            hole: 410,
            x: 233.1616,
            y: 40,
            z: -101.1132
          },
          {
            hole: 411,
            x: 239.2969,
            y: 40,
            z: -86.3013
          },
          {
            hole: 412,
            x: 241.9979,
            y: 40,
            z: -78.7527
          },
          {
            hole: 413,
            x: 244.4504,
            y: 40,
            z: -71.1198
          },
          {
            hole: 414,
            x: 246.6518,
            y: 40,
            z: -63.4107
          },
          {
            hole: 415,
            x: 248.5999,
            y: 40,
            z: -55.6337
          },
          {
            hole: 416,
            x: 251.7276,
            y: 40,
            z: -39.9094
          },
          {
            hole: 417,
            x: 252.904,
            y: 40,
            z: -31.9789
          },
          {
            hole: 418,
            x: 253.8203,
            y: 40,
            z: -24.0142
          },
          {
            hole: 419,
            x: 254.4754,
            y: 40,
            z: -16.0238
          },
          {
            hole: 420,
            x: 254.8688,
            y: 40,
            z: -8.0162
          },
          {
            hole: 421,
            x: 254.8635,
            y: 30,
            z: 8.3434
          },
          {
            hole: 422,
            x: 254.454,
            y: 30,
            z: 16.6778
          },
          {
            hole: 423,
            x: 253.7721,
            y: 30,
            z: 24.9944
          },
          {
            hole: 424,
            x: 252.8184,
            y: 30,
            z: 33.2842
          },
          {
            hole: 425,
            x: 251.594,
            y: 30,
            z: 41.5383
          },
          {
            hole: 426,
            x: 248.3386,
            y: 30,
            z: 57.9044
          },
          {
            hole: 427,
            x: 246.3111,
            y: 30,
            z: 65.9989
          },
          {
            hole: 428,
            x: 244.0198,
            y: 30,
            z: 74.0226
          },
          {
            hole: 429,
            x: 241.4672,
            y: 30,
            z: 81.9671
          },
          {
            hole: 430,
            x: 238.656,
            y: 30,
            z: 89.8238
          },
          {
            hole: 431,
            x: 232.2703,
            y: 30,
            z: 105.2403
          },
          {
            hole: 432,
            x: 228.7025,
            y: 30,
            z: 112.7836
          },
          {
            hole: 433,
            x: 224.8899,
            y: 30,
            z: 120.2062
          },
          {
            hole: 434,
            x: 220.8365,
            y: 30,
            z: 127.5
          },
          {
            hole: 435,
            x: 216.5465,
            y: 30,
            z: 134.6573
          },
          {
            hole: 436,
            x: 207.2759,
            y: 30,
            z: 148.5318
          },
          {
            hole: 437,
            x: 202.3051,
            y: 30,
            z: 155.2342
          },
          {
            hole: 438,
            x: 197.1177,
            y: 30,
            z: 161.7703
          },
          {
            hole: 439,
            x: 191.7191,
            y: 30,
            z: 168.1332
          },
          {
            hole: 440,
            x: 186.1153,
            y: 30,
            z: 174.316
          },
          {
            hole: 441,
            x: 174.316,
            y: 30,
            z: 186.1153
          },
          {
            hole: 442,
            x: 168.1332,
            y: 30,
            z: 191.7191
          },
          {
            hole: 443,
            x: 161.7703,
            y: 30,
            z: 197.1177
          },
          {
            hole: 444,
            x: 155.2342,
            y: 30,
            z: 202.3051
          },
          {
            hole: 445,
            x: 148.5318,
            y: 30,
            z: 207.2759
          },
          {
            hole: 446,
            x: 134.6573,
            y: 30,
            z: 216.5466
          },
          {
            hole: 447,
            x: 127.5,
            y: 30,
            z: 220.8365
          },
          {
            hole: 448,
            x: 120.2062,
            y: 30,
            z: 224.8899
          },
          {
            hole: 449,
            x: 112.7836,
            y: 30,
            z: 228.7025
          },
          {
            hole: 450,
            x: 105.2403,
            y: 30,
            z: 232.2703
          },
          {
            hole: 451,
            x: 89.8238,
            y: 30,
            z: 238.656
          },
          {
            hole: 452,
            x: 81.9671,
            y: 30,
            z: 241.4672
          },
          {
            hole: 453,
            x: 74.0226,
            y: 30,
            z: 244.0198
          },
          {
            hole: 454,
            x: 65.9989,
            y: 30,
            z: 246.3111
          },
          {
            hole: 455,
            x: 57.9045,
            y: 30,
            z: 248.3386
          },
          {
            hole: 456,
            x: 41.5384,
            y: 30,
            z: 251.594
          },
          {
            hole: 457,
            x: 33.2842,
            y: 30,
            z: 252.8184
          },
          {
            hole: 458,
            x: 24.9944,
            y: 30,
            z: 253.7721
          },
          {
            hole: 459,
            x: 16.6778,
            y: 30,
            z: 254.454
          },
          {
            hole: 460,
            x: 8.3434,
            y: 30,
            z: 254.8635
          },
          {
            hole: 461,
            x: -8.6706,
            y: 20,
            z: 254.8581
          },
          {
            hole: 462,
            x: -17.3318,
            y: 20,
            z: 254.4326
          },
          {
            hole: 463,
            x: -25.9745,
            y: 20,
            z: 253.724
          },
          {
            hole: 464,
            x: -34.5894,
            y: 20,
            z: 252.7329
          },
          {
            hole: 465,
            x: -43.1673,
            y: 20,
            z: 251.4605
          },
          {
            hole: 466,
            x: -60.1752,
            y: 20,
            z: 248.0774
          },
          {
            hole: 467,
            x: -68.5871,
            y: 20,
            z: 245.9703
          },
          {
            hole: 468,
            x: -76.9254,
            y: 20,
            z: 243.5892
          },
          {
            hole: 469,
            x: -85.1815,
            y: 20,
            z: 240.9365
          },
          {
            hole: 470,
            x: -93.3463,
            y: 20,
            z: 238.0151
          },
          {
            hole: 471,
            x: -109.3674,
            y: 20,
            z: 231.3789
          },
          {
            hole: 472,
            x: -117.2065,
            y: 20,
            z: 227.6713
          },
          {
            hole: 473,
            x: -124.9201,
            y: 20,
            z: 223.7091
          },
          {
            hole: 474,
            x: -132.5,
            y: 20,
            z: 219.4967
          },
          {
            hole: 475,
            x: -139.938,
            y: 20,
            z: 215.0386
          },
          {
            hole: 476,
            x: -154.3566,
            y: 20,
            z: 205.4044
          },
          {
            hole: 477,
            x: -161.3218,
            y: 20,
            z: 200.2386
          },
          {
            hole: 478,
            x: -168.1142,
            y: 20,
            z: 194.8478
          },
          {
            hole: 479,
            x: -174.7266,
            y: 20,
            z: 189.2375
          },
          {
            hole: 480,
            x: -181.152,
            y: 20,
            z: 183.414
          },
          {
            hole: 481,
            x: 40,
            y: 240,
            z: -6.25
          }
        ],
        p2: [
          {
            hole: 0,
            x: -220.8365,
            y: 10,
            z: 117.5
          },
          {
            hole: 1,
            x: 43.4667,
            y: 230,
            z: 11.6469
          },
          {
            hole: 2,
            x: 38.9711,
            y: 230,
            z: 22.5
          },
          {
            hole: 3,
            x: 31.8198,
            y: 230,
            z: 31.8198
          },
          {
            hole: 4,
            x: 22.5,
            y: 230,
            z: 38.9711
          },
          {
            hole: 5,
            x: 11.6469,
            y: 230,
            z: 43.4667
          },
          {
            hole: 6,
            x: -14.235,
            y: 220,
            z: 43.1259
          },
          {
            hole: 7,
            x: -27.5,
            y: 220,
            z: 37.6314
          },
          {
            hole: 8,
            x: -38.8909,
            y: 220,
            z: 28.8909
          },
          {
            hole: 9,
            x: -47.6314,
            y: 220,
            z: 17.5
          },
          {
            hole: 10,
            x: -53.1259,
            y: 220,
            z: 4.235
          },
          {
            hole: 11,
            x: -52.7852,
            y: 210,
            z: -26.8232
          },
          {
            hole: 12,
            x: -46.2917,
            y: 210,
            z: -42.5
          },
          {
            hole: 13,
            x: -35.9619,
            y: 210,
            z: -55.9619
          },
          {
            hole: 14,
            x: -22.5,
            y: 210,
            z: -66.2917
          },
          {
            hole: 15,
            x: -6.8232,
            y: 210,
            z: -72.7852
          },
          {
            hole: 16,
            x: 29.4114,
            y: 200,
            z: -72.4444
          },
          {
            hole: 17,
            x: 47.5,
            y: 200,
            z: -64.9519
          },
          {
            hole: 18,
            x: 63.033,
            y: 200,
            z: -53.033
          },
          {
            hole: 19,
            x: 74.9519,
            y: 200,
            z: -37.5
          },
          {
            hole: 20,
            x: 82.4444,
            y: 200,
            z: -19.4114
          },
          {
            hole: 21,
            x: 84.2728,
            y: 190,
            z: 11.0947
          },
          {
            hole: 22,
            x: 82.1037,
            y: 190,
            z: 21.9996
          },
          {
            hole: 23,
            x: 78.5298,
            y: 190,
            z: 32.5281
          },
          {
            hole: 24,
            x: 73.6122,
            y: 190,
            z: 42.5
          },
          {
            hole: 25,
            x: 67.435,
            y: 190,
            z: 51.7447
          },
          {
            hole: 26,
            x: 51.7447,
            y: 190,
            z: 67.435
          },
          {
            hole: 27,
            x: 42.5,
            y: 190,
            z: 73.6121
          },
          {
            hole: 28,
            x: 32.5281,
            y: 190,
            z: 78.5297
          },
          {
            hole: 29,
            x: 21.9996,
            y: 190,
            z: 82.1037
          },
          {
            hole: 30,
            x: 11.0947,
            y: 190,
            z: 84.2728
          },
          {
            hole: 31,
            x: -12.4,
            y: 180,
            z: 84.1873
          },
          {
            hole: 32,
            x: -24.5878,
            y: 180,
            z: 81.7629
          },
          {
            hole: 33,
            x: -36.3549,
            y: 180,
            z: 77.7686
          },
          {
            hole: 34,
            x: -47.5,
            y: 180,
            z: 72.2724
          },
          {
            hole: 35,
            x: -57.8323,
            y: 180,
            z: 65.3686
          },
          {
            hole: 36,
            x: -75.3686,
            y: 180,
            z: 47.8323
          },
          {
            hole: 37,
            x: -82.2724,
            y: 180,
            z: 37.5
          },
          {
            hole: 38,
            x: -87.7685,
            y: 180,
            z: 26.3549
          },
          {
            hole: 39,
            x: -91.7629,
            y: 180,
            z: 14.5878
          },
          {
            hole: 40,
            x: -94.1873,
            y: 180,
            z: 2.4
          },
          {
            hole: 41,
            x: -94.1017,
            y: 170,
            z: -23.7053
          },
          {
            hole: 42,
            x: -91.4222,
            y: 170,
            z: -37.176
          },
          {
            hole: 43,
            x: -87.0073,
            y: 170,
            z: -50.1818
          },
          {
            hole: 44,
            x: -80.9327,
            y: 170,
            z: -62.5
          },
          {
            hole: 45,
            x: -73.3021,
            y: 170,
            z: -73.92
          },
          {
            hole: 46,
            x: -53.9199,
            y: 170,
            z: -93.3021
          },
          {
            hole: 47,
            x: -42.5,
            y: 170,
            z: -100.9327
          },
          {
            hole: 48,
            x: -30.1818,
            y: 170,
            z: -107.0073
          },
          {
            hole: 49,
            x: -17.176,
            y: 170,
            z: -111.4222
          },
          {
            hole: 50,
            x: -3.7053,
            y: 170,
            z: -114.1017
          },
          {
            hole: 51,
            x: 25.0105,
            y: 160,
            z: -114.0162
          },
          {
            hole: 52,
            x: 39.7642,
            y: 160,
            z: -111.0815
          },
          {
            hole: 53,
            x: 54.0086,
            y: 160,
            z: -106.2461
          },
          {
            hole: 54,
            x: 67.5,
            y: 160,
            z: -99.5929
          },
          {
            hole: 55,
            x: 80.0076,
            y: 160,
            z: -91.2356
          },
          {
            hole: 56,
            x: 101.2356,
            y: 160,
            z: -70.0076
          },
          {
            hole: 57,
            x: 109.5929,
            y: 160,
            z: -57.5
          },
          {
            hole: 58,
            x: 116.2461,
            y: 160,
            z: -44.0086
          },
          {
            hole: 59,
            x: 121.0815,
            y: 160,
            z: -29.7642
          },
          {
            hole: 60,
            x: 124.0161,
            y: 160,
            z: -15.0105
          },
          {
            hole: 61,
            x: 124.7324,
            y: 150,
            z: 8.1754
          },
          {
            hole: 62,
            x: 123.9306,
            y: 150,
            z: 16.3158
          },
          {
            hole: 63,
            x: 122.5981,
            y: 150,
            z: 24.3863
          },
          {
            hole: 64,
            x: 120.7407,
            y: 150,
            z: 32.3524
          },
          {
            hole: 65,
            x: 118.3663,
            y: 150,
            z: 40.1799
          },
          {
            hole: 66,
            x: 112.1091,
            y: 150,
            z: 55.2861
          },
          {
            hole: 67,
            x: 108.2532,
            y: 150,
            z: 62.5
          },
          {
            hole: 68,
            x: 103.9337,
            y: 150,
            z: 69.4463
          },
          {
            hole: 69,
            x: 99.1692,
            y: 150,
            z: 76.0952
          },
          {
            hole: 70,
            x: 93.98,
            y: 150,
            z: 82.4182
          },
          {
            hole: 71,
            x: 82.4182,
            y: 150,
            z: 93.98
          },
          {
            hole: 72,
            x: 76.0952,
            y: 150,
            z: 99.1692
          },
          {
            hole: 73,
            x: 69.4463,
            y: 150,
            z: 103.9337
          },
          {
            hole: 74,
            x: 62.5,
            y: 150,
            z: 108.2532
          },
          {
            hole: 75,
            x: 55.2861,
            y: 150,
            z: 112.1091
          },
          {
            hole: 76,
            x: 40.1799,
            y: 150,
            z: 118.3663
          },
          {
            hole: 77,
            x: 32.3524,
            y: 150,
            z: 120.7407
          },
          {
            hole: 78,
            x: 24.3863,
            y: 150,
            z: 122.5982
          },
          {
            hole: 79,
            x: 16.3158,
            y: 150,
            z: 123.9306
          },
          {
            hole: 80,
            x: 8.1754,
            y: 150,
            z: 124.7324
          },
          {
            hole: 81,
            x: -8.8294,
            y: 140,
            z: 124.711
          },
          {
            hole: 82,
            x: -17.621,
            y: 140,
            z: 123.8451
          },
          {
            hole: 83,
            x: -26.3372,
            y: 140,
            z: 122.406
          },
          {
            hole: 84,
            x: -34.9406,
            y: 140,
            z: 120.4
          },
          {
            hole: 85,
            x: -43.3943,
            y: 140,
            z: 117.8356
          },
          {
            hole: 86,
            x: -59.709,
            y: 140,
            z: 111.0778
          },
          {
            hole: 87,
            x: -67.5,
            y: 140,
            z: 106.9134
          },
          {
            hole: 88,
            x: -75.002,
            y: 140,
            z: 102.2484
          },
          {
            hole: 89,
            x: -82.1828,
            y: 140,
            z: 97.1027
          },
          {
            hole: 90,
            x: -89.0117,
            y: 140,
            z: 91.4984
          },
          {
            hole: 91,
            x: -101.4984,
            y: 140,
            z: 79.0117
          },
          {
            hole: 92,
            x: -107.1027,
            y: 140,
            z: 72.1828
          },
          {
            hole: 93,
            x: -112.2484,
            y: 140,
            z: 65.002
          },
          {
            hole: 94,
            x: -116.9134,
            y: 140,
            z: 57.5
          },
          {
            hole: 95,
            x: -121.0778,
            y: 140,
            z: 49.709
          },
          {
            hole: 96,
            x: -127.8356,
            y: 140,
            z: 33.3943
          },
          {
            hole: 97,
            x: -130.4,
            y: 140,
            z: 24.9406
          },
          {
            hole: 98,
            x: -132.406,
            y: 140,
            z: 16.3372
          },
          {
            hole: 99,
            x: -133.8451,
            y: 140,
            z: 7.621
          },
          {
            hole: 100,
            x: -134.711,
            y: 140,
            z: -1.1706
          },
          {
            hole: 101,
            x: -134.6895,
            y: 130,
            z: -19.4835
          },
          {
            hole: 102,
            x: -133.7595,
            y: 130,
            z: -28.9263
          },
          {
            hole: 103,
            x: -132.2139,
            y: 130,
            z: -38.2881
          },
          {
            hole: 104,
            x: -130.0592,
            y: 130,
            z: -47.5288
          },
          {
            hole: 105,
            x: -127.3049,
            y: 130,
            z: -56.6087
          },
          {
            hole: 106,
            x: -120.0465,
            y: 130,
            z: -74.1319
          },
          {
            hole: 107,
            x: -115.5737,
            y: 130,
            z: -82.5
          },
          {
            hole: 108,
            x: -110.5631,
            y: 130,
            z: -90.5577
          },
          {
            hole: 109,
            x: -105.0362,
            y: 130,
            z: -98.2704
          },
          {
            hole: 110,
            x: -99.0168,
            y: 130,
            z: -105.6051
          },
          {
            hole: 111,
            x: -85.6051,
            y: 130,
            z: -119.0168
          },
          {
            hole: 112,
            x: -78.2704,
            y: 130,
            z: -125.0362
          },
          {
            hole: 113,
            x: -70.5577,
            y: 130,
            z: -130.5631
          },
          {
            hole: 114,
            x: -62.5,
            y: 130,
            z: -135.5737
          },
          {
            hole: 115,
            x: -54.1318,
            y: 130,
            z: -140.0465
          },
          {
            hole: 116,
            x: -36.6087,
            y: 130,
            z: -147.3049
          },
          {
            hole: 117,
            x: -27.5287,
            y: 130,
            z: -150.0592
          },
          {
            hole: 118,
            x: -18.2881,
            y: 130,
            z: -152.2139
          },
          {
            hole: 119,
            x: -8.9263,
            y: 130,
            z: -153.7595
          },
          {
            hole: 120,
            x: 0.5166,
            y: 130,
            z: -154.6895
          },
          {
            hole: 121,
            x: 20.1375,
            y: 120,
            z: -154.6681
          },
          {
            hole: 122,
            x: 30.2316,
            y: 120,
            z: -153.674
          },
          {
            hole: 123,
            x: 40.239,
            y: 120,
            z: -152.0217
          },
          {
            hole: 124,
            x: 50.117,
            y: 120,
            z: -149.7185
          },
          {
            hole: 125,
            x: 59.8231,
            y: 120,
            z: -146.7742
          },
          {
            hole: 126,
            x: 78.5548,
            y: 120,
            z: -139.0153
          },
          {
            hole: 127,
            x: 87.5,
            y: 120,
            z: -134.2339
          },
          {
            hole: 128,
            x: 96.1134,
            y: 120,
            z: -128.8778
          },
          {
            hole: 129,
            x: 104.358,
            y: 120,
            z: -122.9698
          },
          {
            hole: 130,
            x: 112.1986,
            y: 120,
            z: -116.5352
          },
          {
            hole: 131,
            x: 126.5352,
            y: 120,
            z: -102.1986
          },
          {
            hole: 132,
            x: 132.9698,
            y: 120,
            z: -94.358
          },
          {
            hole: 133,
            x: 138.8778,
            y: 120,
            z: -86.1134
          },
          {
            hole: 134,
            x: 144.2339,
            y: 120,
            z: -77.5
          },
          {
            hole: 135,
            x: 149.0153,
            y: 120,
            z: -68.5547
          },
          {
            hole: 136,
            x: 156.7742,
            y: 120,
            z: -49.8231
          },
          {
            hole: 137,
            x: 159.7185,
            y: 120,
            z: -40.117
          },
          {
            hole: 138,
            x: 162.0217,
            y: 120,
            z: -30.239
          },
          {
            hole: 139,
            x: 163.6739,
            y: 120,
            z: -20.2316
          },
          {
            hole: 140,
            x: 164.6681,
            y: 120,
            z: -10.1375
          },
          {
            hole: 141,
            x: 164.843,
            y: 110,
            z: 7.1972
          },
          {
            hole: 142,
            x: 164.3721,
            y: 110,
            z: 14.3807
          },
          {
            hole: 143,
            x: 163.5884,
            y: 110,
            z: 21.5368
          },
          {
            hole: 144,
            x: 162.4933,
            y: 110,
            z: 28.6519
          },
          {
            hole: 145,
            x: 161.0888,
            y: 110,
            z: 35.7125
          },
          {
            hole: 146,
            x: 157.3633,
            y: 110,
            z: 49.6165
          },
          {
            hole: 147,
            x: 155.0493,
            y: 110,
            z: 56.4333
          },
          {
            hole: 148,
            x: 152.4401,
            y: 110,
            z: 63.1428
          },
          {
            hole: 149,
            x: 149.5408,
            y: 110,
            z: 69.732
          },
          {
            hole: 150,
            x: 146.3568,
            y: 110,
            z: 76.1885
          },
          {
            hole: 151,
            x: 139.1596,
            y: 110,
            z: 88.6544
          },
          {
            hole: 152,
            x: 135.1601,
            y: 110,
            z: 94.6401
          },
          {
            hole: 153,
            x: 130.9033,
            y: 110,
            z: 100.4456
          },
          {
            hole: 154,
            x: 126.3973,
            y: 110,
            z: 106.06
          },
          {
            hole: 155,
            x: 121.6508,
            y: 110,
            z: 111.4724
          },
          {
            hole: 156,
            x: 111.4724,
            y: 110,
            z: 121.6508
          },
          {
            hole: 157,
            x: 106.06,
            y: 110,
            z: 126.3973
          },
          {
            hole: 158,
            x: 100.4456,
            y: 110,
            z: 130.9033
          },
          {
            hole: 159,
            x: 94.6401,
            y: 110,
            z: 135.1601
          },
          {
            hole: 160,
            x: 88.6544,
            y: 110,
            z: 139.1596
          },
          {
            hole: 161,
            x: 76.1885,
            y: 110,
            z: 146.3568
          },
          {
            hole: 162,
            x: 69.732,
            y: 110,
            z: 149.5408
          },
          {
            hole: 163,
            x: 63.1428,
            y: 110,
            z: 152.4401
          },
          {
            hole: 164,
            x: 56.4333,
            y: 110,
            z: 155.0493
          },
          {
            hole: 165,
            x: 49.6165,
            y: 110,
            z: 157.3633
          },
          {
            hole: 166,
            x: 35.7125,
            y: 110,
            z: 161.0888
          },
          {
            hole: 167,
            x: 28.652,
            y: 110,
            z: 162.4933
          },
          {
            hole: 168,
            x: 21.5368,
            y: 110,
            z: 163.5884
          },
          {
            hole: 169,
            x: 14.3807,
            y: 110,
            z: 164.3721
          },
          {
            hole: 170,
            x: 7.1972,
            y: 110,
            z: 164.843
          },
          {
            hole: 171,
            x: -7.6334,
            y: 100,
            z: 164.8334
          },
          {
            hole: 172,
            x: -15.2523,
            y: 100,
            z: 164.3341
          },
          {
            hole: 173,
            x: -22.8421,
            y: 100,
            z: 163.5029
          },
          {
            hole: 174,
            x: -30.3884,
            y: 100,
            z: 162.3414
          },
          {
            hole: 175,
            x: -37.8769,
            y: 100,
            z: 160.8518
          },
          {
            hole: 176,
            x: -52.6235,
            y: 100,
            z: 156.9005
          },
          {
            hole: 177,
            x: -59.8535,
            y: 100,
            z: 154.4462
          },
          {
            hole: 178,
            x: -66.9696,
            y: 100,
            z: 151.6789
          },
          {
            hole: 179,
            x: -73.9582,
            y: 100,
            z: 148.6039
          },
          {
            hole: 180,
            x: -80.806,
            y: 100,
            z: 145.2269
          },
          {
            hole: 181,
            x: -94.0274,
            y: 100,
            z: 137.5935
          },
          {
            hole: 182,
            x: -100.3759,
            y: 100,
            z: 133.3516
          },
          {
            hole: 183,
            x: -106.5332,
            y: 100,
            z: 128.8368
          },
          {
            hole: 184,
            x: -112.4878,
            y: 100,
            z: 124.0578
          },
          {
            hole: 185,
            x: -118.2283,
            y: 100,
            z: 119.0235
          },
          {
            hole: 186,
            x: -129.0235,
            y: 100,
            z: 108.2283
          },
          {
            hole: 187,
            x: -134.0578,
            y: 100,
            z: 102.4878
          },
          {
            hole: 188,
            x: -138.8368,
            y: 100,
            z: 96.5332
          },
          {
            hole: 189,
            x: -143.3516,
            y: 100,
            z: 90.3759
          },
          {
            hole: 190,
            x: -147.5935,
            y: 100,
            z: 84.0274
          },
          {
            hole: 191,
            x: -155.2269,
            y: 100,
            z: 70.806
          },
          {
            hole: 192,
            x: -158.6039,
            y: 100,
            z: 63.9582
          },
          {
            hole: 193,
            x: -161.6789,
            y: 100,
            z: 56.9696
          },
          {
            hole: 194,
            x: -164.4462,
            y: 100,
            z: 49.8535
          },
          {
            hole: 195,
            x: -166.9005,
            y: 100,
            z: 42.6235
          },
          {
            hole: 196,
            x: -170.8518,
            y: 100,
            z: 27.8769
          },
          {
            hole: 197,
            x: -172.3414,
            y: 100,
            z: 20.3884
          },
          {
            hole: 198,
            x: -173.5028,
            y: 100,
            z: 12.8421
          },
          {
            hole: 199,
            x: -174.3341,
            y: 100,
            z: 5.2522
          },
          {
            hole: 200,
            x: -174.8334,
            y: 100,
            z: -2.3666
          },
          {
            hole: 201,
            x: -174.8239,
            y: 90,
            z: -18.0696
          },
          {
            hole: 202,
            x: -174.296,
            y: 90,
            z: -26.1238
          },
          {
            hole: 203,
            x: -173.4173,
            y: 90,
            z: -34.1473
          },
          {
            hole: 204,
            x: -172.1894,
            y: 90,
            z: -42.1249
          },
          {
            hole: 205,
            x: -170.6148,
            y: 90,
            z: -50.0413
          },
          {
            hole: 206,
            x: -166.4376,
            y: 90,
            z: -65.6306
          },
          {
            hole: 207,
            x: -163.8431,
            y: 90,
            z: -73.2737
          },
          {
            hole: 208,
            x: -160.9177,
            y: 90,
            z: -80.7964
          },
          {
            hole: 209,
            x: -157.667,
            y: 90,
            z: -88.1844
          },
          {
            hole: 210,
            x: -154.097,
            y: 90,
            z: -95.4235
          },
          {
            hole: 211,
            x: -146.0274,
            y: 90,
            z: -109.4004
          },
          {
            hole: 212,
            x: -141.5431,
            y: 90,
            z: -116.1116
          },
          {
            hole: 213,
            x: -136.7704,
            y: 90,
            z: -122.6209
          },
          {
            hole: 214,
            x: -131.7182,
            y: 90,
            z: -128.9157
          },
          {
            hole: 215,
            x: -126.3963,
            y: 90,
            z: -134.9842
          },
          {
            hole: 216,
            x: -114.9842,
            y: 90,
            z: -146.3963
          },
          {
            hole: 217,
            x: -108.9157,
            y: 90,
            z: -151.7182
          },
          {
            hole: 218,
            x: -102.6209,
            y: 90,
            z: -156.7704
          },
          {
            hole: 219,
            x: -96.1117,
            y: 90,
            z: -161.5431
          },
          {
            hole: 220,
            x: -89.4004,
            y: 90,
            z: -166.0274
          },
          {
            hole: 221,
            x: -75.4235,
            y: 90,
            z: -174.097
          },
          {
            hole: 222,
            x: -68.1844,
            y: 90,
            z: -177.6669
          },
          {
            hole: 223,
            x: -60.7964,
            y: 90,
            z: -180.9177
          },
          {
            hole: 224,
            x: -53.2737,
            y: 90,
            z: -183.8431
          },
          {
            hole: 225,
            x: -45.6306,
            y: 90,
            z: -186.4376
          },
          {
            hole: 226,
            x: -30.0413,
            y: 90,
            z: -190.6147
          },
          {
            hole: 227,
            x: -22.1249,
            y: 90,
            z: -192.1894
          },
          {
            hole: 228,
            x: -14.1474,
            y: 90,
            z: -193.4173
          },
          {
            hole: 229,
            x: -6.1238,
            y: 90,
            z: -194.296
          },
          {
            hole: 230,
            x: 1.9304,
            y: 90,
            z: -194.8239
          },
          {
            hole: 231,
            x: 18.5058,
            y: 80,
            z: -194.8144
          },
          {
            hole: 232,
            x: 26.9954,
            y: 80,
            z: -194.258
          },
          {
            hole: 233,
            x: 35.4526,
            y: 80,
            z: -193.3317
          },
          {
            hole: 234,
            x: 43.8614,
            y: 80,
            z: -192.0375
          },
          {
            hole: 235,
            x: 52.2057,
            y: 80,
            z: -190.3777
          },
          {
            hole: 236,
            x: 68.6376,
            y: 80,
            z: -185.9748
          },
          {
            hole: 237,
            x: 76.6939,
            y: 80,
            z: -183.24
          },
          {
            hole: 238,
            x: 84.6233,
            y: 80,
            z: -180.1565
          },
          {
            hole: 239,
            x: 92.4106,
            y: 80,
            z: -176.73
          },
          {
            hole: 240,
            x: 100.041,
            y: 80,
            z: -172.9671
          },
          {
            hole: 241,
            x: 114.7734,
            y: 80,
            z: -164.4613
          },
          {
            hole: 242,
            x: 121.8474,
            y: 80,
            z: -159.7346
          },
          {
            hole: 243,
            x: 128.7085,
            y: 80,
            z: -154.7039
          },
          {
            hole: 244,
            x: 135.3436,
            y: 80,
            z: -149.3786
          },
          {
            hole: 245,
            x: 141.7401,
            y: 80,
            z: -143.7691
          },
          {
            hole: 246,
            x: 153.7691,
            y: 80,
            z: -131.7401
          },
          {
            hole: 247,
            x: 159.3787,
            y: 80,
            z: -125.3436
          },
          {
            hole: 248,
            x: 164.7039,
            y: 80,
            z: -118.7085
          },
          {
            hole: 249,
            x: 169.7346,
            y: 80,
            z: -111.8474
          },
          {
            hole: 250,
            x: 174.4613,
            y: 80,
            z: -104.7734
          },
          {
            hole: 251,
            x: 182.9671,
            y: 80,
            z: -90.041
          },
          {
            hole: 252,
            x: 186.73,
            y: 80,
            z: -82.4105
          },
          {
            hole: 253,
            x: 190.1565,
            y: 80,
            z: -74.6233
          },
          {
            hole: 254,
            x: 193.2401,
            y: 80,
            z: -66.6939
          },
          {
            hole: 255,
            x: 195.9748,
            y: 80,
            z: -58.6376
          },
          {
            hole: 256,
            x: 200.3777,
            y: 80,
            z: -42.2057
          },
          {
            hole: 257,
            x: 202.0375,
            y: 80,
            z: -33.8614
          },
          {
            hole: 258,
            x: 203.3317,
            y: 80,
            z: -25.4526
          },
          {
            hole: 259,
            x: 204.258,
            y: 80,
            z: -16.9953
          },
          {
            hole: 260,
            x: 204.8144,
            y: 80,
            z: -8.5058
          },
          {
            hole: 261,
            x: 204.8902,
            y: 70,
            z: 6.7074
          },
          {
            hole: 262,
            x: 204.5611,
            y: 70,
            z: 13.4076
          },
          {
            hole: 263,
            x: 204.0129,
            y: 70,
            z: 20.0935
          },
          {
            hole: 264,
            x: 203.2462,
            y: 70,
            z: 26.7579
          },
          {
            hole: 265,
            x: 202.2619,
            y: 70,
            z: 33.3936
          },
          {
            hole: 266,
            x: 199.6448,
            y: 70,
            z: 46.5506
          },
          {
            hole: 267,
            x: 198.0148,
            y: 70,
            z: 53.0579
          },
          {
            hole: 268,
            x: 196.1728,
            y: 70,
            z: 59.5084
          },
          {
            hole: 269,
            x: 194.1207,
            y: 70,
            z: 65.8951
          },
          {
            hole: 270,
            x: 191.8607,
            y: 70,
            z: 72.2113
          },
          {
            hole: 271,
            x: 186.7271,
            y: 70,
            z: 84.6049
          },
          {
            hole: 272,
            x: 183.8589,
            y: 70,
            z: 90.6692
          },
          {
            hole: 273,
            x: 180.7939,
            y: 70,
            z: 96.6363
          },
          {
            hole: 274,
            x: 177.5352,
            y: 70,
            z: 102.5
          },
          {
            hole: 275,
            x: 174.0864,
            y: 70,
            z: 108.2539
          },
          {
            hole: 276,
            x: 166.6336,
            y: 70,
            z: 119.4079
          },
          {
            hole: 277,
            x: 162.6374,
            y: 70,
            z: 124.7961
          },
          {
            hole: 278,
            x: 158.4671,
            y: 70,
            z: 130.0506
          },
          {
            hole: 279,
            x: 154.1272,
            y: 70,
            z: 135.1659
          },
          {
            hole: 280,
            x: 149.6221,
            y: 70,
            z: 140.1364
          },
          {
            hole: 281,
            x: 140.1364,
            y: 70,
            z: 149.6221
          },
          {
            hole: 282,
            x: 135.1659,
            y: 70,
            z: 154.1272
          },
          {
            hole: 283,
            x: 130.0506,
            y: 70,
            z: 158.4671
          },
          {
            hole: 284,
            x: 124.7961,
            y: 70,
            z: 162.6374
          },
          {
            hole: 285,
            x: 119.4079,
            y: 70,
            z: 166.6336
          },
          {
            hole: 286,
            x: 108.2539,
            y: 70,
            z: 174.0864
          },
          {
            hole: 287,
            x: 102.5,
            y: 70,
            z: 177.5352
          },
          {
            hole: 288,
            x: 96.6363,
            y: 70,
            z: 180.7939
          },
          {
            hole: 289,
            x: 90.6692,
            y: 70,
            z: 183.8589
          },
          {
            hole: 290,
            x: 84.6049,
            y: 70,
            z: 186.7271
          },
          {
            hole: 291,
            x: 72.2113,
            y: 70,
            z: 191.8607
          },
          {
            hole: 292,
            x: 65.8951,
            y: 70,
            z: 194.1207
          },
          {
            hole: 293,
            x: 59.5084,
            y: 70,
            z: 196.1728
          },
          {
            hole: 294,
            x: 53.0579,
            y: 70,
            z: 198.0148
          },
          {
            hole: 295,
            x: 46.5506,
            y: 70,
            z: 199.6448
          },
          {
            hole: 296,
            x: 33.3936,
            y: 70,
            z: 202.2619
          },
          {
            hole: 297,
            x: 26.7579,
            y: 70,
            z: 203.2462
          },
          {
            hole: 298,
            x: 20.0935,
            y: 70,
            z: 204.0129
          },
          {
            hole: 299,
            x: 13.4077,
            y: 70,
            z: 204.5611
          },
          {
            hole: 300,
            x: 6.7074,
            y: 70,
            z: 204.8902
          },
          {
            hole: 301,
            x: -7.0346,
            y: 60,
            z: 204.8849
          },
          {
            hole: 302,
            x: -14.0617,
            y: 60,
            z: 204.5397
          },
          {
            hole: 303,
            x: -21.0737,
            y: 60,
            z: 203.9647
          },
          {
            hole: 304,
            x: -28.0631,
            y: 60,
            z: 203.1606
          },
          {
            hole: 305,
            x: -35.0225,
            y: 60,
            z: 202.1283
          },
          {
            hole: 306,
            x: -48.8214,
            y: 60,
            z: 199.3835
          },
          {
            hole: 307,
            x: -55.6461,
            y: 60,
            z: 197.674
          },
          {
            hole: 308,
            x: -62.4112,
            y: 60,
            z: 195.7422
          },
          {
            hole: 309,
            x: -69.1095,
            y: 60,
            z: 193.59
          },
          {
            hole: 310,
            x: -75.7338,
            y: 60,
            z: 191.2198
          },
          {
            hole: 311,
            x: -88.732,
            y: 60,
            z: 185.8357
          },
          {
            hole: 312,
            x: -95.0921,
            y: 60,
            z: 182.8276
          },
          {
            hole: 313,
            x: -101.3503,
            y: 60,
            z: 179.6131
          },
          {
            hole: 314,
            x: -107.5,
            y: 60,
            z: 176.1955
          },
          {
            hole: 315,
            x: -113.5346,
            y: 60,
            z: 172.5785
          },
          {
            hole: 316,
            x: -125.2327,
            y: 60,
            z: 164.762
          },
          {
            hole: 317,
            x: -130.8837,
            y: 60,
            z: 160.571
          },
          {
            hole: 318,
            x: -136.3946,
            y: 60,
            z: 156.1972
          },
          {
            hole: 319,
            x: -141.7594,
            y: 60,
            z: 151.6456
          },
          {
            hole: 320,
            x: -146.9723,
            y: 60,
            z: 146.9208
          },
          {
            hole: 321,
            x: -156.9208,
            y: 60,
            z: 136.9723
          },
          {
            hole: 322,
            x: -161.6456,
            y: 60,
            z: 131.7593
          },
          {
            hole: 323,
            x: -166.1972,
            y: 60,
            z: 126.3946
          },
          {
            hole: 324,
            x: -170.571,
            y: 60,
            z: 120.8837
          },
          {
            hole: 325,
            x: -174.762,
            y: 60,
            z: 115.2327
          },
          {
            hole: 326,
            x: -182.5785,
            y: 60,
            z: 103.5346
          },
          {
            hole: 327,
            x: -186.1955,
            y: 60,
            z: 97.5
          },
          {
            hole: 328,
            x: -189.6131,
            y: 60,
            z: 91.3503
          },
          {
            hole: 329,
            x: -192.8276,
            y: 60,
            z: 85.0921
          },
          {
            hole: 330,
            x: -195.8357,
            y: 60,
            z: 78.732
          },
          {
            hole: 331,
            x: -201.2198,
            y: 60,
            z: 65.7338
          },
          {
            hole: 332,
            x: -203.59,
            y: 60,
            z: 59.1095
          },
          {
            hole: 333,
            x: -205.7422,
            y: 60,
            z: 52.4112
          },
          {
            hole: 334,
            x: -207.674,
            y: 60,
            z: 45.6461
          },
          {
            hole: 335,
            x: -209.3835,
            y: 60,
            z: 38.8214
          },
          {
            hole: 336,
            x: -212.1283,
            y: 60,
            z: 25.0225
          },
          {
            hole: 337,
            x: -213.1606,
            y: 60,
            z: 18.0631
          },
          {
            hole: 338,
            x: -213.9647,
            y: 60,
            z: 11.0737
          },
          {
            hole: 339,
            x: -214.5397,
            y: 60,
            z: 4.0617
          },
          {
            hole: 340,
            x: -214.8849,
            y: 60,
            z: -2.9654
          },
          {
            hole: 341,
            x: -214.8795,
            y: 50,
            z: -17.3618
          },
          {
            hole: 342,
            x: -214.5183,
            y: 50,
            z: -24.7157
          },
          {
            hole: 343,
            x: -213.9166,
            y: 50,
            z: -32.0539
          },
          {
            hole: 344,
            x: -213.0751,
            y: 50,
            z: -39.3684
          },
          {
            hole: 345,
            x: -211.9947,
            y: 50,
            z: -46.6515
          },
          {
            hole: 346,
            x: -209.1223,
            y: 50,
            z: -61.0922
          },
          {
            hole: 347,
            x: -207.3333,
            y: 50,
            z: -68.2343
          },
          {
            hole: 348,
            x: -205.3116,
            y: 50,
            z: -75.3141
          },
          {
            hole: 349,
            x: -203.0593,
            y: 50,
            z: -82.3239
          },
          {
            hole: 350,
            x: -200.5788,
            y: 50,
            z: -89.2563
          },
          {
            hole: 351,
            x: -194.9444,
            y: 50,
            z: -102.8591
          },
          {
            hole: 352,
            x: -191.7964,
            y: 50,
            z: -109.515
          },
          {
            hole: 353,
            x: -188.4323,
            y: 50,
            z: -116.0643
          },
          {
            hole: 354,
            x: -184.8557,
            y: 50,
            z: -122.5
          },
          {
            hole: 355,
            x: -181.0705,
            y: 50,
            z: -128.8153
          },
          {
            hole: 356,
            x: -172.8905,
            y: 50,
            z: -141.0575
          },
          {
            hole: 357,
            x: -168.5045,
            y: 50,
            z: -146.9713
          },
          {
            hole: 358,
            x: -163.9273,
            y: 50,
            z: -152.7385
          },
          {
            hole: 359,
            x: -159.164,
            y: 50,
            z: -158.3528
          },
          {
            hole: 360,
            x: -154.2194,
            y: 50,
            z: -163.8083
          },
          {
            hole: 361,
            x: -143.8083,
            y: 50,
            z: -174.2194
          },
          {
            hole: 362,
            x: -138.3528,
            y: 50,
            z: -179.164
          },
          {
            hole: 363,
            x: -132.7385,
            y: 50,
            z: -183.9273
          },
          {
            hole: 364,
            x: -126.9713,
            y: 50,
            z: -188.5045
          },
          {
            hole: 365,
            x: -121.0575,
            y: 50,
            z: -192.8905
          },
          {
            hole: 366,
            x: -108.8153,
            y: 50,
            z: -201.0705
          },
          {
            hole: 367,
            x: -102.5,
            y: 50,
            z: -204.8557
          },
          {
            hole: 368,
            x: -96.0643,
            y: 50,
            z: -208.4323
          },
          {
            hole: 369,
            x: -89.515,
            y: 50,
            z: -211.7964
          },
          {
            hole: 370,
            x: -82.8591,
            y: 50,
            z: -214.9444
          },
          {
            hole: 371,
            x: -69.2562,
            y: 50,
            z: -220.5788
          },
          {
            hole: 372,
            x: -62.3239,
            y: 50,
            z: -223.0593
          },
          {
            hole: 373,
            x: -55.314,
            y: 50,
            z: -225.3116
          },
          {
            hole: 374,
            x: -48.2343,
            y: 50,
            z: -227.3333
          },
          {
            hole: 375,
            x: -41.0921,
            y: 50,
            z: -229.1223
          },
          {
            hole: 376,
            x: -26.6515,
            y: 50,
            z: -231.9947
          },
          {
            hole: 377,
            x: -19.3684,
            y: 50,
            z: -233.0751
          },
          {
            hole: 378,
            x: -12.0539,
            y: 50,
            z: -233.9165
          },
          {
            hole: 379,
            x: -4.7157,
            y: 50,
            z: -234.5182
          },
          {
            hole: 380,
            x: 2.6382,
            y: 50,
            z: -234.8795
          },
          {
            hole: 381,
            x: 17.689,
            y: 40,
            z: -234.8742
          },
          {
            hole: 382,
            x: 25.3697,
            y: 40,
            z: -234.4969
          },
          {
            hole: 383,
            x: 33.034,
            y: 40,
            z: -233.8684
          },
          {
            hole: 384,
            x: 40.6737,
            y: 40,
            z: -232.9896
          },
          {
            hole: 385,
            x: 48.2804,
            y: 40,
            z: -231.8612
          },
          {
            hole: 386,
            x: 63.363,
            y: 40,
            z: -228.8611
          },
          {
            hole: 387,
            x: 70.8225,
            y: 40,
            z: -226.9926
          },
          {
            hole: 388,
            x: 78.2169,
            y: 40,
            z: -224.881
          },
          {
            hole: 389,
            x: 85.5383,
            y: 40,
            z: -222.5286
          },
          {
            hole: 390,
            x: 92.7788,
            y: 40,
            z: -219.9379
          },
          {
            hole: 391,
            x: 106.9862,
            y: 40,
            z: -214.053
          },
          {
            hole: 392,
            x: 113.9379,
            y: 40,
            z: -210.7651
          },
          {
            hole: 393,
            x: 120.7782,
            y: 40,
            z: -207.2515
          },
          {
            hole: 394,
            x: 127.5,
            y: 40,
            z: -203.516
          },
          {
            hole: 395,
            x: 134.096,
            y: 40,
            z: -199.5625
          },
          {
            hole: 396,
            x: 146.8823,
            y: 40,
            z: -191.019
          },
          {
            hole: 397,
            x: 153.0589,
            y: 40,
            z: -186.438
          },
          {
            hole: 398,
            x: 159.0824,
            y: 40,
            z: -181.6575
          },
          {
            hole: 399,
            x: 164.9463,
            y: 40,
            z: -176.6824
          },
          {
            hole: 400,
            x: 170.6442,
            y: 40,
            z: -171.5181
          },
          {
            hole: 401,
            x: 181.5181,
            y: 40,
            z: -160.6442
          },
          {
            hole: 402,
            x: 186.6824,
            y: 40,
            z: -154.9463
          },
          {
            hole: 403,
            x: 191.6575,
            y: 40,
            z: -149.0824
          },
          {
            hole: 404,
            x: 196.438,
            y: 40,
            z: -143.0589
          },
          {
            hole: 405,
            x: 201.019,
            y: 40,
            z: -136.8823
          },
          {
            hole: 406,
            x: 209.5625,
            y: 40,
            z: -124.096
          },
          {
            hole: 407,
            x: 213.516,
            y: 40,
            z: -117.5
          },
          {
            hole: 408,
            x: 217.2515,
            y: 40,
            z: -110.7783
          },
          {
            hole: 409,
            x: 220.7651,
            y: 40,
            z: -103.9379
          },
          {
            hole: 410,
            x: 224.053,
            y: 40,
            z: -96.9862
          },
          {
            hole: 411,
            x: 229.9379,
            y: 40,
            z: -82.7788
          },
          {
            hole: 412,
            x: 232.5286,
            y: 40,
            z: -75.5383
          },
          {
            hole: 413,
            x: 234.881,
            y: 40,
            z: -68.2169
          },
          {
            hole: 414,
            x: 236.9926,
            y: 40,
            z: -60.8225
          },
          {
            hole: 415,
            x: 238.8611,
            y: 40,
            z: -53.3629
          },
          {
            hole: 416,
            x: 241.8612,
            y: 40,
            z: -38.2804
          },
          {
            hole: 417,
            x: 242.9895,
            y: 40,
            z: -30.6737
          },
          {
            hole: 418,
            x: 243.8684,
            y: 40,
            z: -23.034
          },
          {
            hole: 419,
            x: 244.4968,
            y: 40,
            z: -15.3697
          },
          {
            hole: 420,
            x: 244.8742,
            y: 40,
            z: -7.689
          },
          {
            hole: 421,
            x: 244.8688,
            y: 30,
            z: 8.0162
          },
          {
            hole: 422,
            x: 244.4754,
            y: 30,
            z: 16.0238
          },
          {
            hole: 423,
            x: 243.8203,
            y: 30,
            z: 24.0142
          },
          {
            hole: 424,
            x: 242.904,
            y: 30,
            z: 31.9789
          },
          {
            hole: 425,
            x: 241.7276,
            y: 30,
            z: 39.9094
          },
          {
            hole: 426,
            x: 238.5999,
            y: 30,
            z: 55.6337
          },
          {
            hole: 427,
            x: 236.6518,
            y: 30,
            z: 63.4107
          },
          {
            hole: 428,
            x: 234.4504,
            y: 30,
            z: 71.1197
          },
          {
            hole: 429,
            x: 231.9979,
            y: 30,
            z: 78.7527
          },
          {
            hole: 430,
            x: 229.2969,
            y: 30,
            z: 86.3013
          },
          {
            hole: 431,
            x: 223.1616,
            y: 30,
            z: 101.1132
          },
          {
            hole: 432,
            x: 219.7338,
            y: 30,
            z: 108.3607
          },
          {
            hole: 433,
            x: 216.0707,
            y: 30,
            z: 115.4922
          },
          {
            hole: 434,
            x: 212.1762,
            y: 30,
            z: 122.5
          },
          {
            hole: 435,
            x: 208.0545,
            y: 30,
            z: 129.3766
          },
          {
            hole: 436,
            x: 199.1474,
            y: 30,
            z: 142.707
          },
          {
            hole: 437,
            x: 194.3716,
            y: 30,
            z: 149.1466
          },
          {
            hole: 438,
            x: 189.3876,
            y: 30,
            z: 155.4264
          },
          {
            hole: 439,
            x: 184.2007,
            y: 30,
            z: 161.5397
          },
          {
            hole: 440,
            x: 178.8167,
            y: 30,
            z: 167.4801
          },
          {
            hole: 441,
            x: 167.4801,
            y: 30,
            z: 178.8167
          },
          {
            hole: 442,
            x: 161.5397,
            y: 30,
            z: 184.2008
          },
          {
            hole: 443,
            x: 155.4264,
            y: 30,
            z: 189.3876
          },
          {
            hole: 444,
            x: 149.1465,
            y: 30,
            z: 194.3716
          },
          {
            hole: 445,
            x: 142.707,
            y: 30,
            z: 199.1474
          },
          {
            hole: 446,
            x: 129.3766,
            y: 30,
            z: 208.0545
          },
          {
            hole: 447,
            x: 122.5,
            y: 30,
            z: 212.1762
          },
          {
            hole: 448,
            x: 115.4922,
            y: 30,
            z: 216.0707
          },
          {
            hole: 449,
            x: 108.3607,
            y: 30,
            z: 219.7338
          },
          {
            hole: 450,
            x: 101.1132,
            y: 30,
            z: 223.1616
          },
          {
            hole: 451,
            x: 86.3013,
            y: 30,
            z: 229.2969
          },
          {
            hole: 452,
            x: 78.7527,
            y: 30,
            z: 231.9979
          },
          {
            hole: 453,
            x: 71.1198,
            y: 30,
            z: 234.4504
          },
          {
            hole: 454,
            x: 63.4107,
            y: 30,
            z: 236.6518
          },
          {
            hole: 455,
            x: 55.6337,
            y: 30,
            z: 238.5999
          },
          {
            hole: 456,
            x: 39.9094,
            y: 30,
            z: 241.7276
          },
          {
            hole: 457,
            x: 31.979,
            y: 30,
            z: 242.904
          },
          {
            hole: 458,
            x: 24.0142,
            y: 30,
            z: 243.8203
          },
          {
            hole: 459,
            x: 16.0238,
            y: 30,
            z: 244.4754
          },
          {
            hole: 460,
            x: 8.0162,
            y: 30,
            z: 244.8688
          },
          {
            hole: 461,
            x: -8.3434,
            y: 20,
            z: 244.8635
          },
          {
            hole: 462,
            x: -16.6778,
            y: 20,
            z: 244.454
          },
          {
            hole: 463,
            x: -24.9944,
            y: 20,
            z: 243.7721
          },
          {
            hole: 464,
            x: -33.2842,
            y: 20,
            z: 242.8184
          },
          {
            hole: 465,
            x: -41.5383,
            y: 20,
            z: 241.594
          },
          {
            hole: 466,
            x: -57.9045,
            y: 20,
            z: 238.3386
          },
          {
            hole: 467,
            x: -65.9989,
            y: 20,
            z: 236.3111
          },
          {
            hole: 468,
            x: -74.0226,
            y: 20,
            z: 234.0198
          },
          {
            hole: 469,
            x: -81.9671,
            y: 20,
            z: 231.4672
          },
          {
            hole: 470,
            x: -89.8238,
            y: 20,
            z: 228.656
          },
          {
            hole: 471,
            x: -105.2403,
            y: 20,
            z: 222.2703
          },
          {
            hole: 472,
            x: -112.7836,
            y: 20,
            z: 218.7025
          },
          {
            hole: 473,
            x: -120.2062,
            y: 20,
            z: 214.8899
          },
          {
            hole: 474,
            x: -127.5,
            y: 20,
            z: 210.8365
          },
          {
            hole: 475,
            x: -134.6573,
            y: 20,
            z: 206.5465
          },
          {
            hole: 476,
            x: -148.5318,
            y: 20,
            z: 197.2759
          },
          {
            hole: 477,
            x: -155.2342,
            y: 20,
            z: 192.3051
          },
          {
            hole: 478,
            x: -161.7703,
            y: 20,
            z: 187.1177
          },
          {
            hole: 479,
            x: -168.1332,
            y: 20,
            z: 181.7191
          },
          {
            hole: 480,
            x: -174.316,
            y: 20,
            z: 176.1153
          },
          {
            hole: 481,
            x: 40,
            y: 240,
            z: -6.25
          }
        ],
        p3: [
          {
            hole: 0,
            x: -212.1762,
            y: 10,
            z: 112.5
          },
          {
            hole: 1,
            x: 33.8074,
            y: 230,
            z: 9.0587
          },
          {
            hole: 2,
            x: 30.3109,
            y: 230,
            z: 17.5
          },
          {
            hole: 3,
            x: 24.7487,
            y: 230,
            z: 24.7487
          },
          {
            hole: 4,
            x: 17.5,
            y: 230,
            z: 30.3109
          },
          {
            hole: 5,
            x: 9.0587,
            y: 230,
            z: 33.8074
          },
          {
            hole: 6,
            x: -11.6469,
            y: 220,
            z: 33.4667
          },
          {
            hole: 7,
            x: -22.5,
            y: 220,
            z: 28.9711
          },
          {
            hole: 8,
            x: -31.8198,
            y: 220,
            z: 21.8198
          },
          {
            hole: 9,
            x: -38.9711,
            y: 220,
            z: 12.5
          },
          {
            hole: 10,
            x: -43.4667,
            y: 220,
            z: 1.6469
          },
          {
            hole: 11,
            x: -43.1259,
            y: 210,
            z: -24.235
          },
          {
            hole: 12,
            x: -37.6314,
            y: 210,
            z: -37.5
          },
          {
            hole: 13,
            x: -28.8909,
            y: 210,
            z: -48.8909
          },
          {
            hole: 14,
            x: -17.5,
            y: 210,
            z: -57.6314
          },
          {
            hole: 15,
            x: -4.235,
            y: 210,
            z: -63.1259
          },
          {
            hole: 16,
            x: 26.8232,
            y: 200,
            z: -62.7852
          },
          {
            hole: 17,
            x: 42.5,
            y: 200,
            z: -56.2917
          },
          {
            hole: 18,
            x: 55.9619,
            y: 200,
            z: -45.9619
          },
          {
            hole: 19,
            x: 66.2917,
            y: 200,
            z: -32.5
          },
          {
            hole: 20,
            x: 72.7852,
            y: 200,
            z: -16.8232
          },
          {
            hole: 21,
            x: 74.3584,
            y: 190,
            z: 9.7895
          },
          {
            hole: 22,
            x: 72.4444,
            y: 190,
            z: 19.4114
          },
          {
            hole: 23,
            x: 69.291,
            y: 190,
            z: 28.7013
          },
          {
            hole: 24,
            x: 64.9519,
            y: 190,
            z: 37.5
          },
          {
            hole: 25,
            x: 59.5015,
            y: 190,
            z: 45.6571
          },
          {
            hole: 26,
            x: 45.6571,
            y: 190,
            z: 59.5015
          },
          {
            hole: 27,
            x: 37.5,
            y: 190,
            z: 64.9519
          },
          {
            hole: 28,
            x: 28.7013,
            y: 190,
            z: 69.2909
          },
          {
            hole: 29,
            x: 19.4114,
            y: 190,
            z: 72.4444
          },
          {
            hole: 30,
            x: 9.7895,
            y: 190,
            z: 74.3583
          },
          {
            hole: 31,
            x: -11.0947,
            y: 180,
            z: 74.2728
          },
          {
            hole: 32,
            x: -21.9996,
            y: 180,
            z: 72.1037
          },
          {
            hole: 33,
            x: -32.5281,
            y: 180,
            z: 68.5298
          },
          {
            hole: 34,
            x: -42.5,
            y: 180,
            z: 63.6122
          },
          {
            hole: 35,
            x: -51.7447,
            y: 180,
            z: 57.435
          },
          {
            hole: 36,
            x: -67.435,
            y: 180,
            z: 41.7447
          },
          {
            hole: 37,
            x: -73.6122,
            y: 180,
            z: 32.5
          },
          {
            hole: 38,
            x: -78.5298,
            y: 180,
            z: 22.5281
          },
          {
            hole: 39,
            x: -82.1037,
            y: 180,
            z: 11.9996
          },
          {
            hole: 40,
            x: -84.2728,
            y: 180,
            z: 1.0947
          },
          {
            hole: 41,
            x: -84.1873,
            y: 170,
            z: -22.4
          },
          {
            hole: 42,
            x: -81.763,
            y: 170,
            z: -34.5878
          },
          {
            hole: 43,
            x: -77.7686,
            y: 170,
            z: -46.3549
          },
          {
            hole: 44,
            x: -72.2724,
            y: 170,
            z: -57.5
          },
          {
            hole: 45,
            x: -65.3686,
            y: 170,
            z: -67.8323
          },
          {
            hole: 46,
            x: -47.8323,
            y: 170,
            z: -85.3686
          },
          {
            hole: 47,
            x: -37.5,
            y: 170,
            z: -92.2724
          },
          {
            hole: 48,
            x: -26.3549,
            y: 170,
            z: -97.7686
          },
          {
            hole: 49,
            x: -14.5878,
            y: 170,
            z: -101.763
          },
          {
            hole: 50,
            x: -2.4,
            y: 170,
            z: -104.1873
          },
          {
            hole: 51,
            x: 23.7053,
            y: 160,
            z: -104.1017
          },
          {
            hole: 52,
            x: 37.176,
            y: 160,
            z: -101.4222
          },
          {
            hole: 53,
            x: 50.1818,
            y: 160,
            z: -97.0074
          },
          {
            hole: 54,
            x: 62.5,
            y: 160,
            z: -90.9327
          },
          {
            hole: 55,
            x: 73.92,
            y: 160,
            z: -83.3021
          },
          {
            hole: 56,
            x: 93.3021,
            y: 160,
            z: -63.9199
          },
          {
            hole: 57,
            x: 100.9327,
            y: 160,
            z: -52.5
          },
          {
            hole: 58,
            x: 107.0073,
            y: 160,
            z: -40.1818
          },
          {
            hole: 59,
            x: 111.4222,
            y: 160,
            z: -27.176
          },
          {
            hole: 60,
            x: 114.1017,
            y: 160,
            z: -13.7053
          },
          {
            hole: 61,
            x: 114.7538,
            y: 150,
            z: 7.5214
          },
          {
            hole: 62,
            x: 114.0161,
            y: 150,
            z: 15.0105
          },
          {
            hole: 63,
            x: 112.7903,
            y: 150,
            z: 22.4354
          },
          {
            hole: 64,
            x: 111.0815,
            y: 150,
            z: 29.7642
          },
          {
            hole: 65,
            x: 108.897,
            y: 150,
            z: 36.9655
          },
          {
            hole: 66,
            x: 103.1404,
            y: 150,
            z: 50.8632
          },
          {
            hole: 67,
            x: 99.5929,
            y: 150,
            z: 57.5
          },
          {
            hole: 68,
            x: 95.619,
            y: 150,
            z: 63.8906
          },
          {
            hole: 69,
            x: 91.2356,
            y: 150,
            z: 70.0076
          },
          {
            hole: 70,
            x: 86.4616,
            y: 150,
            z: 75.8248
          },
          {
            hole: 71,
            x: 75.8248,
            y: 150,
            z: 86.4616
          },
          {
            hole: 72,
            x: 70.0076,
            y: 150,
            z: 91.2356
          },
          {
            hole: 73,
            x: 63.8906,
            y: 150,
            z: 95.619
          },
          {
            hole: 74,
            x: 57.5,
            y: 150,
            z: 99.5929
          },
          {
            hole: 75,
            x: 50.8632,
            y: 150,
            z: 103.1404
          },
          {
            hole: 76,
            x: 36.9655,
            y: 150,
            z: 108.897
          },
          {
            hole: 77,
            x: 29.7642,
            y: 150,
            z: 111.0815
          },
          {
            hole: 78,
            x: 22.4354,
            y: 150,
            z: 112.7903
          },
          {
            hole: 79,
            x: 15.0105,
            y: 150,
            z: 114.0162
          },
          {
            hole: 80,
            x: 7.5214,
            y: 150,
            z: 114.7538
          },
          {
            hole: 81,
            x: -8.1754,
            y: 140,
            z: 114.7324
          },
          {
            hole: 82,
            x: -16.3158,
            y: 140,
            z: 113.9306
          },
          {
            hole: 83,
            x: -24.3863,
            y: 140,
            z: 112.5982
          },
          {
            hole: 84,
            x: -32.3524,
            y: 140,
            z: 110.7407
          },
          {
            hole: 85,
            x: -40.1799,
            y: 140,
            z: 108.3663
          },
          {
            hole: 86,
            x: -55.2861,
            y: 140,
            z: 102.1091
          },
          {
            hole: 87,
            x: -62.5,
            y: 140,
            z: 98.2532
          },
          {
            hole: 88,
            x: -69.4463,
            y: 140,
            z: 93.9337
          },
          {
            hole: 89,
            x: -76.0952,
            y: 140,
            z: 89.1692
          },
          {
            hole: 90,
            x: -82.4182,
            y: 140,
            z: 83.98
          },
          {
            hole: 91,
            x: -93.98,
            y: 140,
            z: 72.4182
          },
          {
            hole: 92,
            x: -99.1692,
            y: 140,
            z: 66.0952
          },
          {
            hole: 93,
            x: -103.9337,
            y: 140,
            z: 59.4463
          },
          {
            hole: 94,
            x: -108.2532,
            y: 140,
            z: 52.5
          },
          {
            hole: 95,
            x: -112.1091,
            y: 140,
            z: 45.2861
          },
          {
            hole: 96,
            x: -118.3663,
            y: 140,
            z: 30.1799
          },
          {
            hole: 97,
            x: -120.7407,
            y: 140,
            z: 22.3524
          },
          {
            hole: 98,
            x: -122.5982,
            y: 140,
            z: 14.3863
          },
          {
            hole: 99,
            x: -123.9306,
            y: 140,
            z: 6.3158
          },
          {
            hole: 100,
            x: -124.7324,
            y: 140,
            z: -1.8246
          },
          {
            hole: 101,
            x: -124.7109,
            y: 130,
            z: -18.8294
          },
          {
            hole: 102,
            x: -123.845,
            y: 130,
            z: -27.621
          },
          {
            hole: 103,
            x: -122.406,
            y: 130,
            z: -36.3372
          },
          {
            hole: 104,
            x: -120.4,
            y: 130,
            z: -44.9406
          },
          {
            hole: 105,
            x: -117.8356,
            y: 130,
            z: -53.3943
          },
          {
            hole: 106,
            x: -111.0778,
            y: 130,
            z: -69.709
          },
          {
            hole: 107,
            x: -106.9134,
            y: 130,
            z: -77.5
          },
          {
            hole: 108,
            x: -102.2484,
            y: 130,
            z: -85.002
          },
          {
            hole: 109,
            x: -97.1027,
            y: 130,
            z: -92.1828
          },
          {
            hole: 110,
            x: -91.4984,
            y: 130,
            z: -99.0117
          },
          {
            hole: 111,
            x: -79.0117,
            y: 130,
            z: -111.4984
          },
          {
            hole: 112,
            x: -72.1828,
            y: 130,
            z: -117.1027
          },
          {
            hole: 113,
            x: -65.002,
            y: 130,
            z: -122.2484
          },
          {
            hole: 114,
            x: -57.5,
            y: 130,
            z: -126.9134
          },
          {
            hole: 115,
            x: -49.709,
            y: 130,
            z: -131.0778
          },
          {
            hole: 116,
            x: -33.3943,
            y: 130,
            z: -137.8356
          },
          {
            hole: 117,
            x: -24.9405,
            y: 130,
            z: -140.4
          },
          {
            hole: 118,
            x: -16.3372,
            y: 130,
            z: -142.406
          },
          {
            hole: 119,
            x: -7.621,
            y: 130,
            z: -143.845
          },
          {
            hole: 120,
            x: 1.1706,
            y: 130,
            z: -144.7109
          },
          {
            hole: 121,
            x: 19.4835,
            y: 120,
            z: -144.6895
          },
          {
            hole: 122,
            x: 28.9263,
            y: 120,
            z: -143.7595
          },
          {
            hole: 123,
            x: 38.2881,
            y: 120,
            z: -142.2139
          },
          {
            hole: 124,
            x: 47.5288,
            y: 120,
            z: -140.0592
          },
          {
            hole: 125,
            x: 56.6087,
            y: 120,
            z: -137.3049
          },
          {
            hole: 126,
            x: 74.1319,
            y: 120,
            z: -130.0465
          },
          {
            hole: 127,
            x: 82.5,
            y: 120,
            z: -125.5737
          },
          {
            hole: 128,
            x: 90.5577,
            y: 120,
            z: -120.5631
          },
          {
            hole: 129,
            x: 98.2704,
            y: 120,
            z: -115.0362
          },
          {
            hole: 130,
            x: 105.6051,
            y: 120,
            z: -109.0168
          },
          {
            hole: 131,
            x: 119.0168,
            y: 120,
            z: -95.6051
          },
          {
            hole: 132,
            x: 125.0362,
            y: 120,
            z: -88.2704
          },
          {
            hole: 133,
            x: 130.5631,
            y: 120,
            z: -80.5577
          },
          {
            hole: 134,
            x: 135.5737,
            y: 120,
            z: -72.5
          },
          {
            hole: 135,
            x: 140.0465,
            y: 120,
            z: -64.1319
          },
          {
            hole: 136,
            x: 147.3049,
            y: 120,
            z: -46.6087
          },
          {
            hole: 137,
            x: 150.0592,
            y: 120,
            z: -37.5288
          },
          {
            hole: 138,
            x: 152.2139,
            y: 120,
            z: -28.2881
          },
          {
            hole: 139,
            x: 153.7595,
            y: 120,
            z: -18.9263
          },
          {
            hole: 140,
            x: 154.6895,
            y: 120,
            z: -9.4835
          },
          {
            hole: 141,
            x: 154.8525,
            y: 110,
            z: 6.761
          },
          {
            hole: 142,
            x: 154.4102,
            y: 110,
            z: 13.5091
          },
          {
            hole: 143,
            x: 153.674,
            y: 110,
            z: 20.2316
          },
          {
            hole: 144,
            x: 152.6452,
            y: 110,
            z: 26.9155
          },
          {
            hole: 145,
            x: 151.3259,
            y: 110,
            z: 33.5481
          },
          {
            hole: 146,
            x: 147.8261,
            y: 110,
            z: 46.6094
          },
          {
            hole: 147,
            x: 145.6524,
            y: 110,
            z: 53.0131
          },
          {
            hole: 148,
            x: 143.2013,
            y: 110,
            z: 59.3159
          },
          {
            hole: 149,
            x: 140.4777,
            y: 110,
            z: 65.5058
          },
          {
            hole: 150,
            x: 137.4867,
            y: 110,
            z: 71.571
          },
          {
            hole: 151,
            x: 130.7257,
            y: 110,
            z: 83.2814
          },
          {
            hole: 152,
            x: 126.9686,
            y: 110,
            z: 88.9043
          },
          {
            hole: 153,
            x: 122.9698,
            y: 110,
            z: 94.358
          },
          {
            hole: 154,
            x: 118.7369,
            y: 110,
            z: 99.6321
          },
          {
            hole: 155,
            x: 114.278,
            y: 110,
            z: 104.7165
          },
          {
            hole: 156,
            x: 104.7165,
            y: 110,
            z: 114.278
          },
          {
            hole: 157,
            x: 99.6321,
            y: 110,
            z: 118.7369
          },
          {
            hole: 158,
            x: 94.358,
            y: 110,
            z: 122.9698
          },
          {
            hole: 159,
            x: 88.9044,
            y: 110,
            z: 126.9686
          },
          {
            hole: 160,
            x: 83.2814,
            y: 110,
            z: 130.7257
          },
          {
            hole: 161,
            x: 71.571,
            y: 110,
            z: 137.4867
          },
          {
            hole: 162,
            x: 65.5058,
            y: 110,
            z: 140.4777
          },
          {
            hole: 163,
            x: 59.3159,
            y: 110,
            z: 143.2013
          },
          {
            hole: 164,
            x: 53.0131,
            y: 110,
            z: 145.6524
          },
          {
            hole: 165,
            x: 46.6094,
            y: 110,
            z: 147.8261
          },
          {
            hole: 166,
            x: 33.5482,
            y: 110,
            z: 151.3259
          },
          {
            hole: 167,
            x: 26.9155,
            y: 110,
            z: 152.6452
          },
          {
            hole: 168,
            x: 20.2316,
            y: 110,
            z: 153.674
          },
          {
            hole: 169,
            x: 13.5092,
            y: 110,
            z: 154.4102
          },
          {
            hole: 170,
            x: 6.761,
            y: 110,
            z: 154.8525
          },
          {
            hole: 171,
            x: -7.1972,
            y: 100,
            z: 154.843
          },
          {
            hole: 172,
            x: -14.3807,
            y: 100,
            z: 154.3721
          },
          {
            hole: 173,
            x: -21.5368,
            y: 100,
            z: 153.5884
          },
          {
            hole: 174,
            x: -28.6519,
            y: 100,
            z: 152.4933
          },
          {
            hole: 175,
            x: -35.7125,
            y: 100,
            z: 151.0888
          },
          {
            hole: 176,
            x: -49.6165,
            y: 100,
            z: 147.3633
          },
          {
            hole: 177,
            x: -56.4333,
            y: 100,
            z: 145.0493
          },
          {
            hole: 178,
            x: -63.1428,
            y: 100,
            z: 142.4401
          },
          {
            hole: 179,
            x: -69.732,
            y: 100,
            z: 139.5408
          },
          {
            hole: 180,
            x: -76.1885,
            y: 100,
            z: 136.3568
          },
          {
            hole: 181,
            x: -88.6544,
            y: 100,
            z: 129.1596
          },
          {
            hole: 182,
            x: -94.6401,
            y: 100,
            z: 125.1601
          },
          {
            hole: 183,
            x: -100.4456,
            y: 100,
            z: 120.9033
          },
          {
            hole: 184,
            x: -106.06,
            y: 100,
            z: 116.3973
          },
          {
            hole: 185,
            x: -111.4724,
            y: 100,
            z: 111.6508
          },
          {
            hole: 186,
            x: -121.6508,
            y: 100,
            z: 101.4724
          },
          {
            hole: 187,
            x: -126.3973,
            y: 100,
            z: 96.06
          },
          {
            hole: 188,
            x: -130.9033,
            y: 100,
            z: 90.4456
          },
          {
            hole: 189,
            x: -135.1601,
            y: 100,
            z: 84.6401
          },
          {
            hole: 190,
            x: -139.1596,
            y: 100,
            z: 78.6544
          },
          {
            hole: 191,
            x: -146.3568,
            y: 100,
            z: 66.1885
          },
          {
            hole: 192,
            x: -149.5408,
            y: 100,
            z: 59.732
          },
          {
            hole: 193,
            x: -152.4401,
            y: 100,
            z: 53.1428
          },
          {
            hole: 194,
            x: -155.0493,
            y: 100,
            z: 46.4333
          },
          {
            hole: 195,
            x: -157.3633,
            y: 100,
            z: 39.6165
          },
          {
            hole: 196,
            x: -161.0888,
            y: 100,
            z: 25.7125
          },
          {
            hole: 197,
            x: -162.4933,
            y: 100,
            z: 18.6519
          },
          {
            hole: 198,
            x: -163.5884,
            y: 100,
            z: 11.5368
          },
          {
            hole: 199,
            x: -164.3721,
            y: 100,
            z: 4.3807
          },
          {
            hole: 200,
            x: -164.843,
            y: 100,
            z: -2.8028
          },
          {
            hole: 201,
            x: -164.8335,
            y: 90,
            z: -17.6334
          },
          {
            hole: 202,
            x: -164.3341,
            y: 90,
            z: -25.2523
          },
          {
            hole: 203,
            x: -163.5029,
            y: 90,
            z: -32.8421
          },
          {
            hole: 204,
            x: -162.3414,
            y: 90,
            z: -40.3884
          },
          {
            hole: 205,
            x: -160.8518,
            y: 90,
            z: -47.8769
          },
          {
            hole: 206,
            x: -156.9005,
            y: 90,
            z: -62.6235
          },
          {
            hole: 207,
            x: -154.4462,
            y: 90,
            z: -69.8535
          },
          {
            hole: 208,
            x: -151.6789,
            y: 90,
            z: -76.9696
          },
          {
            hole: 209,
            x: -148.6039,
            y: 90,
            z: -83.9582
          },
          {
            hole: 210,
            x: -145.2269,
            y: 90,
            z: -90.806
          },
          {
            hole: 211,
            x: -137.5935,
            y: 90,
            z: -104.0274
          },
          {
            hole: 212,
            x: -133.3516,
            y: 90,
            z: -110.3759
          },
          {
            hole: 213,
            x: -128.8368,
            y: 90,
            z: -116.5332
          },
          {
            hole: 214,
            x: -124.0578,
            y: 90,
            z: -122.4878
          },
          {
            hole: 215,
            x: -119.0235,
            y: 90,
            z: -128.2283
          },
          {
            hole: 216,
            x: -108.2283,
            y: 90,
            z: -139.0235
          },
          {
            hole: 217,
            x: -102.4879,
            y: 90,
            z: -144.0578
          },
          {
            hole: 218,
            x: -96.5333,
            y: 90,
            z: -148.8368
          },
          {
            hole: 219,
            x: -90.3759,
            y: 90,
            z: -153.3516
          },
          {
            hole: 220,
            x: -84.0275,
            y: 90,
            z: -157.5935
          },
          {
            hole: 221,
            x: -70.806,
            y: 90,
            z: -165.2269
          },
          {
            hole: 222,
            x: -63.9582,
            y: 90,
            z: -168.6039
          },
          {
            hole: 223,
            x: -56.9696,
            y: 90,
            z: -171.6789
          },
          {
            hole: 224,
            x: -49.8535,
            y: 90,
            z: -174.4462
          },
          {
            hole: 225,
            x: -42.6235,
            y: 90,
            z: -176.9005
          },
          {
            hole: 226,
            x: -27.8769,
            y: 90,
            z: -180.8518
          },
          {
            hole: 227,
            x: -20.3884,
            y: 90,
            z: -182.3413
          },
          {
            hole: 228,
            x: -12.8421,
            y: 90,
            z: -183.5028
          },
          {
            hole: 229,
            x: -5.2523,
            y: 90,
            z: -184.3341
          },
          {
            hole: 230,
            x: 2.3666,
            y: 90,
            z: -184.8334
          },
          {
            hole: 231,
            x: 18.0696,
            y: 80,
            z: -184.8239
          },
          {
            hole: 232,
            x: 26.1238,
            y: 80,
            z: -184.296
          },
          {
            hole: 233,
            x: 34.1473,
            y: 80,
            z: -183.4173
          },
          {
            hole: 234,
            x: 42.1249,
            y: 80,
            z: -182.1894
          },
          {
            hole: 235,
            x: 50.0413,
            y: 80,
            z: -180.6147
          },
          {
            hole: 236,
            x: 65.6306,
            y: 80,
            z: -176.4376
          },
          {
            hole: 237,
            x: 73.2737,
            y: 80,
            z: -173.8431
          },
          {
            hole: 238,
            x: 80.7964,
            y: 80,
            z: -170.9177
          },
          {
            hole: 239,
            x: 88.1844,
            y: 80,
            z: -167.6669
          },
          {
            hole: 240,
            x: 95.4235,
            y: 80,
            z: -164.097
          },
          {
            hole: 241,
            x: 109.4004,
            y: 80,
            z: -156.0274
          },
          {
            hole: 242,
            x: 116.1116,
            y: 80,
            z: -151.5431
          },
          {
            hole: 243,
            x: 122.6209,
            y: 80,
            z: -146.7703
          },
          {
            hole: 244,
            x: 128.9157,
            y: 80,
            z: -141.7182
          },
          {
            hole: 245,
            x: 134.9842,
            y: 80,
            z: -136.3963
          },
          {
            hole: 246,
            x: 146.3963,
            y: 80,
            z: -124.9842
          },
          {
            hole: 247,
            x: 151.7182,
            y: 80,
            z: -118.9157
          },
          {
            hole: 248,
            x: 156.7704,
            y: 80,
            z: -112.6208
          },
          {
            hole: 249,
            x: 161.5431,
            y: 80,
            z: -106.1116
          },
          {
            hole: 250,
            x: 166.0274,
            y: 80,
            z: -99.4004
          },
          {
            hole: 251,
            x: 174.097,
            y: 80,
            z: -85.4235
          },
          {
            hole: 252,
            x: 177.6669,
            y: 80,
            z: -78.1844
          },
          {
            hole: 253,
            x: 180.9177,
            y: 80,
            z: -70.7964
          },
          {
            hole: 254,
            x: 183.8431,
            y: 80,
            z: -63.2737
          },
          {
            hole: 255,
            x: 186.4376,
            y: 80,
            z: -55.6306
          },
          {
            hole: 256,
            x: 190.6148,
            y: 80,
            z: -40.0413
          },
          {
            hole: 257,
            x: 192.1894,
            y: 80,
            z: -32.1249
          },
          {
            hole: 258,
            x: 193.4173,
            y: 80,
            z: -24.1473
          },
          {
            hole: 259,
            x: 194.296,
            y: 80,
            z: -16.1238
          },
          {
            hole: 260,
            x: 194.8239,
            y: 80,
            z: -8.0696
          },
          {
            hole: 261,
            x: 194.8956,
            y: 70,
            z: 6.3802
          },
          {
            hole: 262,
            x: 194.5825,
            y: 70,
            z: 12.7536
          },
          {
            hole: 263,
            x: 194.061,
            y: 70,
            z: 19.1133
          },
          {
            hole: 264,
            x: 193.3317,
            y: 70,
            z: 25.4526
          },
          {
            hole: 265,
            x: 192.3954,
            y: 70,
            z: 31.7646
          },
          {
            hole: 266,
            x: 189.906,
            y: 70,
            z: 44.2799
          },
          {
            hole: 267,
            x: 188.3555,
            y: 70,
            z: 50.4697
          },
          {
            hole: 268,
            x: 186.6034,
            y: 70,
            z: 56.6055
          },
          {
            hole: 269,
            x: 184.6514,
            y: 70,
            z: 62.6807
          },
          {
            hole: 270,
            x: 182.5016,
            y: 70,
            z: 68.6888
          },
          {
            hole: 271,
            x: 177.6184,
            y: 70,
            z: 80.4779
          },
          {
            hole: 272,
            x: 174.8902,
            y: 70,
            z: 86.2463
          },
          {
            hole: 273,
            x: 171.9746,
            y: 70,
            z: 91.9224
          },
          {
            hole: 274,
            x: 168.8749,
            y: 70,
            z: 97.5
          },
          {
            hole: 275,
            x: 165.5944,
            y: 70,
            z: 102.9732
          },
          {
            hole: 276,
            x: 158.5051,
            y: 70,
            z: 113.5832
          },
          {
            hole: 277,
            x: 154.7039,
            y: 70,
            z: 118.7085
          },
          {
            hole: 278,
            x: 150.737,
            y: 70,
            z: 123.7067
          },
          {
            hole: 279,
            x: 146.6088,
            y: 70,
            z: 128.5724
          },
          {
            hole: 280,
            x: 142.3235,
            y: 70,
            z: 133.3005
          },
          {
            hole: 281,
            x: 133.3005,
            y: 70,
            z: 142.3235
          },
          {
            hole: 282,
            x: 128.5724,
            y: 70,
            z: 146.6088
          },
          {
            hole: 283,
            x: 123.7067,
            y: 70,
            z: 150.737
          },
          {
            hole: 284,
            x: 118.7085,
            y: 70,
            z: 154.7039
          },
          {
            hole: 285,
            x: 113.5831,
            y: 70,
            z: 158.5051
          },
          {
            hole: 286,
            x: 102.9732,
            y: 70,
            z: 165.5944
          },
          {
            hole: 287,
            x: 97.5,
            y: 70,
            z: 168.875
          },
          {
            hole: 288,
            x: 91.9224,
            y: 70,
            z: 171.9746
          },
          {
            hole: 289,
            x: 86.2463,
            y: 70,
            z: 174.8902
          },
          {
            hole: 290,
            x: 80.4779,
            y: 70,
            z: 177.6184
          },
          {
            hole: 291,
            x: 68.6888,
            y: 70,
            z: 182.5017
          },
          {
            hole: 292,
            x: 62.6807,
            y: 70,
            z: 184.6514
          },
          {
            hole: 293,
            x: 56.6055,
            y: 70,
            z: 186.6034
          },
          {
            hole: 294,
            x: 50.4697,
            y: 70,
            z: 188.3555
          },
          {
            hole: 295,
            x: 44.2799,
            y: 70,
            z: 189.906
          },
          {
            hole: 296,
            x: 31.7646,
            y: 70,
            z: 192.3954
          },
          {
            hole: 297,
            x: 25.4526,
            y: 70,
            z: 193.3317
          },
          {
            hole: 298,
            x: 19.1134,
            y: 70,
            z: 194.061
          },
          {
            hole: 299,
            x: 12.7536,
            y: 70,
            z: 194.5825
          },
          {
            hole: 300,
            x: 6.3802,
            y: 70,
            z: 194.8956
          },
          {
            hole: 301,
            x: -6.7074,
            y: 60,
            z: 194.8902
          },
          {
            hole: 302,
            x: -13.4076,
            y: 60,
            z: 194.5611
          },
          {
            hole: 303,
            x: -20.0935,
            y: 60,
            z: 194.0129
          },
          {
            hole: 304,
            x: -26.7579,
            y: 60,
            z: 193.2462
          },
          {
            hole: 305,
            x: -33.3936,
            y: 60,
            z: 192.2619
          },
          {
            hole: 306,
            x: -46.5506,
            y: 60,
            z: 189.6448
          },
          {
            hole: 307,
            x: -53.0579,
            y: 60,
            z: 188.0148
          },
          {
            hole: 308,
            x: -59.5084,
            y: 60,
            z: 186.1728
          },
          {
            hole: 309,
            x: -65.8951,
            y: 60,
            z: 184.1207
          },
          {
            hole: 310,
            x: -72.2113,
            y: 60,
            z: 181.8607
          },
          {
            hole: 311,
            x: -84.6049,
            y: 60,
            z: 176.7271
          },
          {
            hole: 312,
            x: -90.6692,
            y: 60,
            z: 173.8589
          },
          {
            hole: 313,
            x: -96.6363,
            y: 60,
            z: 170.7939
          },
          {
            hole: 314,
            x: -102.5,
            y: 60,
            z: 167.5352
          },
          {
            hole: 315,
            x: -108.2539,
            y: 60,
            z: 164.0864
          },
          {
            hole: 316,
            x: -119.4079,
            y: 60,
            z: 156.6336
          },
          {
            hole: 317,
            x: -124.7961,
            y: 60,
            z: 152.6374
          },
          {
            hole: 318,
            x: -130.0506,
            y: 60,
            z: 148.4671
          },
          {
            hole: 319,
            x: -135.1659,
            y: 60,
            z: 144.1272
          },
          {
            hole: 320,
            x: -140.1364,
            y: 60,
            z: 139.6221
          },
          {
            hole: 321,
            x: -149.6221,
            y: 60,
            z: 130.1364
          },
          {
            hole: 322,
            x: -154.1272,
            y: 60,
            z: 125.1659
          },
          {
            hole: 323,
            x: -158.4671,
            y: 60,
            z: 120.0506
          },
          {
            hole: 324,
            x: -162.6374,
            y: 60,
            z: 114.7961
          },
          {
            hole: 325,
            x: -166.6336,
            y: 60,
            z: 109.4079
          },
          {
            hole: 326,
            x: -174.0864,
            y: 60,
            z: 98.2539
          },
          {
            hole: 327,
            x: -177.5352,
            y: 60,
            z: 92.5
          },
          {
            hole: 328,
            x: -180.7939,
            y: 60,
            z: 86.6363
          },
          {
            hole: 329,
            x: -183.8589,
            y: 60,
            z: 80.6692
          },
          {
            hole: 330,
            x: -186.7271,
            y: 60,
            z: 74.6049
          },
          {
            hole: 331,
            x: -191.8607,
            y: 60,
            z: 62.2113
          },
          {
            hole: 332,
            x: -194.1207,
            y: 60,
            z: 55.8951
          },
          {
            hole: 333,
            x: -196.1728,
            y: 60,
            z: 49.5084
          },
          {
            hole: 334,
            x: -198.0148,
            y: 60,
            z: 43.0579
          },
          {
            hole: 335,
            x: -199.6448,
            y: 60,
            z: 36.5506
          },
          {
            hole: 336,
            x: -202.2619,
            y: 60,
            z: 23.3936
          },
          {
            hole: 337,
            x: -203.2462,
            y: 60,
            z: 16.7579
          },
          {
            hole: 338,
            x: -204.0129,
            y: 60,
            z: 10.0935
          },
          {
            hole: 339,
            x: -204.5611,
            y: 60,
            z: 3.4077
          },
          {
            hole: 340,
            x: -204.8902,
            y: 60,
            z: -3.2926
          },
          {
            hole: 341,
            x: -204.8849,
            y: 50,
            z: -17.0346
          },
          {
            hole: 342,
            x: -204.5397,
            y: 50,
            z: -24.0617
          },
          {
            hole: 343,
            x: -203.9647,
            y: 50,
            z: -31.0737
          },
          {
            hole: 344,
            x: -203.1606,
            y: 50,
            z: -38.0631
          },
          {
            hole: 345,
            x: -202.1283,
            y: 50,
            z: -45.0225
          },
          {
            hole: 346,
            x: -199.3835,
            y: 50,
            z: -58.8214
          },
          {
            hole: 347,
            x: -197.674,
            y: 50,
            z: -65.6461
          },
          {
            hole: 348,
            x: -195.7422,
            y: 50,
            z: -72.4112
          },
          {
            hole: 349,
            x: -193.59,
            y: 50,
            z: -79.1095
          },
          {
            hole: 350,
            x: -191.2198,
            y: 50,
            z: -85.7338
          },
          {
            hole: 351,
            x: -185.8357,
            y: 50,
            z: -98.732
          },
          {
            hole: 352,
            x: -182.8276,
            y: 50,
            z: -105.0921
          },
          {
            hole: 353,
            x: -179.6131,
            y: 50,
            z: -111.3503
          },
          {
            hole: 354,
            x: -176.1955,
            y: 50,
            z: -117.5
          },
          {
            hole: 355,
            x: -172.5785,
            y: 50,
            z: -123.5346
          },
          {
            hole: 356,
            x: -164.762,
            y: 50,
            z: -135.2327
          },
          {
            hole: 357,
            x: -160.571,
            y: 50,
            z: -140.8837
          },
          {
            hole: 358,
            x: -156.1972,
            y: 50,
            z: -146.3946
          },
          {
            hole: 359,
            x: -151.6456,
            y: 50,
            z: -151.7594
          },
          {
            hole: 360,
            x: -146.9208,
            y: 50,
            z: -156.9723
          },
          {
            hole: 361,
            x: -136.9723,
            y: 50,
            z: -166.9208
          },
          {
            hole: 362,
            x: -131.7593,
            y: 50,
            z: -171.6456
          },
          {
            hole: 363,
            x: -126.3946,
            y: 50,
            z: -176.1972
          },
          {
            hole: 364,
            x: -120.8837,
            y: 50,
            z: -180.571
          },
          {
            hole: 365,
            x: -115.2327,
            y: 50,
            z: -184.762
          },
          {
            hole: 366,
            x: -103.5346,
            y: 50,
            z: -192.5785
          },
          {
            hole: 367,
            x: -97.5,
            y: 50,
            z: -196.1955
          },
          {
            hole: 368,
            x: -91.3503,
            y: 50,
            z: -199.6131
          },
          {
            hole: 369,
            x: -85.0921,
            y: 50,
            z: -202.8276
          },
          {
            hole: 370,
            x: -78.732,
            y: 50,
            z: -205.8357
          },
          {
            hole: 371,
            x: -65.7337,
            y: 50,
            z: -211.2198
          },
          {
            hole: 372,
            x: -59.1095,
            y: 50,
            z: -213.59
          },
          {
            hole: 373,
            x: -52.4112,
            y: 50,
            z: -215.7422
          },
          {
            hole: 374,
            x: -45.6461,
            y: 50,
            z: -217.674
          },
          {
            hole: 375,
            x: -38.8214,
            y: 50,
            z: -219.3835
          },
          {
            hole: 376,
            x: -25.0225,
            y: 50,
            z: -222.1283
          },
          {
            hole: 377,
            x: -18.0631,
            y: 50,
            z: -223.1606
          },
          {
            hole: 378,
            x: -11.0737,
            y: 50,
            z: -223.9647
          },
          {
            hole: 379,
            x: -4.0617,
            y: 50,
            z: -224.5396
          },
          {
            hole: 380,
            x: 2.9654,
            y: 50,
            z: -224.8849
          },
          {
            hole: 381,
            x: 17.3618,
            y: 40,
            z: -224.8795
          },
          {
            hole: 382,
            x: 24.7157,
            y: 40,
            z: -224.5183
          },
          {
            hole: 383,
            x: 32.0539,
            y: 40,
            z: -223.9166
          },
          {
            hole: 384,
            x: 39.3684,
            y: 40,
            z: -223.0751
          },
          {
            hole: 385,
            x: 46.6515,
            y: 40,
            z: -221.9948
          },
          {
            hole: 386,
            x: 61.0922,
            y: 40,
            z: -219.1223
          },
          {
            hole: 387,
            x: 68.2343,
            y: 40,
            z: -217.3333
          },
          {
            hole: 388,
            x: 75.3141,
            y: 40,
            z: -215.3116
          },
          {
            hole: 389,
            x: 82.3239,
            y: 40,
            z: -213.0593
          },
          {
            hole: 390,
            x: 89.2563,
            y: 40,
            z: -210.5788
          },
          {
            hole: 391,
            x: 102.8591,
            y: 40,
            z: -204.9444
          },
          {
            hole: 392,
            x: 109.515,
            y: 40,
            z: -201.7964
          },
          {
            hole: 393,
            x: 116.0643,
            y: 40,
            z: -198.4323
          },
          {
            hole: 394,
            x: 122.5,
            y: 40,
            z: -194.8557
          },
          {
            hole: 395,
            x: 128.8153,
            y: 40,
            z: -191.0705
          },
          {
            hole: 396,
            x: 141.0575,
            y: 40,
            z: -182.8905
          },
          {
            hole: 397,
            x: 146.9713,
            y: 40,
            z: -178.5045
          },
          {
            hole: 398,
            x: 152.7385,
            y: 40,
            z: -173.9274
          },
          {
            hole: 399,
            x: 158.3528,
            y: 40,
            z: -169.164
          },
          {
            hole: 400,
            x: 163.8083,
            y: 40,
            z: -164.2194
          },
          {
            hole: 401,
            x: 174.2194,
            y: 40,
            z: -153.8083
          },
          {
            hole: 402,
            x: 179.164,
            y: 40,
            z: -148.3528
          },
          {
            hole: 403,
            x: 183.9273,
            y: 40,
            z: -142.7385
          },
          {
            hole: 404,
            x: 188.5045,
            y: 40,
            z: -136.9713
          },
          {
            hole: 405,
            x: 192.8905,
            y: 40,
            z: -131.0575
          },
          {
            hole: 406,
            x: 201.0705,
            y: 40,
            z: -118.8153
          },
          {
            hole: 407,
            x: 204.8557,
            y: 40,
            z: -112.5
          },
          {
            hole: 408,
            x: 208.4323,
            y: 40,
            z: -106.0643
          },
          {
            hole: 409,
            x: 211.7964,
            y: 40,
            z: -99.515
          },
          {
            hole: 410,
            x: 214.9444,
            y: 40,
            z: -92.8591
          },
          {
            hole: 411,
            x: 220.5788,
            y: 40,
            z: -79.2563
          },
          {
            hole: 412,
            x: 223.0593,
            y: 40,
            z: -72.3239
          },
          {
            hole: 413,
            x: 225.3116,
            y: 40,
            z: -65.3141
          },
          {
            hole: 414,
            x: 227.3333,
            y: 40,
            z: -58.2343
          },
          {
            hole: 415,
            x: 229.1223,
            y: 40,
            z: -51.0922
          },
          {
            hole: 416,
            x: 231.9947,
            y: 40,
            z: -36.6515
          },
          {
            hole: 417,
            x: 233.0751,
            y: 40,
            z: -29.3684
          },
          {
            hole: 418,
            x: 233.9166,
            y: 40,
            z: -22.0539
          },
          {
            hole: 419,
            x: 234.5183,
            y: 40,
            z: -14.7157
          },
          {
            hole: 420,
            x: 234.8795,
            y: 40,
            z: -7.3618
          },
          {
            hole: 421,
            x: 234.8742,
            y: 30,
            z: 7.689
          },
          {
            hole: 422,
            x: 234.4968,
            y: 30,
            z: 15.3697
          },
          {
            hole: 423,
            x: 233.8684,
            y: 30,
            z: 23.034
          },
          {
            hole: 424,
            x: 232.9895,
            y: 30,
            z: 30.6737
          },
          {
            hole: 425,
            x: 231.8612,
            y: 30,
            z: 38.2804
          },
          {
            hole: 426,
            x: 228.8611,
            y: 30,
            z: 53.3629
          },
          {
            hole: 427,
            x: 226.9926,
            y: 30,
            z: 60.8225
          },
          {
            hole: 428,
            x: 224.881,
            y: 30,
            z: 68.2169
          },
          {
            hole: 429,
            x: 222.5286,
            y: 30,
            z: 75.5383
          },
          {
            hole: 430,
            x: 219.9379,
            y: 30,
            z: 82.7788
          },
          {
            hole: 431,
            x: 214.053,
            y: 30,
            z: 96.9862
          },
          {
            hole: 432,
            x: 210.7651,
            y: 30,
            z: 103.9378
          },
          {
            hole: 433,
            x: 207.2515,
            y: 30,
            z: 110.7782
          },
          {
            hole: 434,
            x: 203.516,
            y: 30,
            z: 117.5
          },
          {
            hole: 435,
            x: 199.5625,
            y: 30,
            z: 124.0959
          },
          {
            hole: 436,
            x: 191.019,
            y: 30,
            z: 136.8823
          },
          {
            hole: 437,
            x: 186.438,
            y: 30,
            z: 143.0589
          },
          {
            hole: 438,
            x: 181.6575,
            y: 30,
            z: 149.0824
          },
          {
            hole: 439,
            x: 176.6824,
            y: 30,
            z: 154.9463
          },
          {
            hole: 440,
            x: 171.5181,
            y: 30,
            z: 160.6442
          },
          {
            hole: 441,
            x: 160.6442,
            y: 30,
            z: 171.5181
          },
          {
            hole: 442,
            x: 154.9463,
            y: 30,
            z: 176.6824
          },
          {
            hole: 443,
            x: 149.0824,
            y: 30,
            z: 181.6575
          },
          {
            hole: 444,
            x: 143.0589,
            y: 30,
            z: 186.438
          },
          {
            hole: 445,
            x: 136.8823,
            y: 30,
            z: 191.019
          },
          {
            hole: 446,
            x: 124.0959,
            y: 30,
            z: 199.5625
          },
          {
            hole: 447,
            x: 117.5,
            y: 30,
            z: 203.516
          },
          {
            hole: 448,
            x: 110.7782,
            y: 30,
            z: 207.2515
          },
          {
            hole: 449,
            x: 103.9378,
            y: 30,
            z: 210.7651
          },
          {
            hole: 450,
            x: 96.9862,
            y: 30,
            z: 214.053
          },
          {
            hole: 451,
            x: 82.7788,
            y: 30,
            z: 219.9379
          },
          {
            hole: 452,
            x: 75.5383,
            y: 30,
            z: 222.5286
          },
          {
            hole: 453,
            x: 68.2169,
            y: 30,
            z: 224.881
          },
          {
            hole: 454,
            x: 60.8225,
            y: 30,
            z: 226.9926
          },
          {
            hole: 455,
            x: 53.3629,
            y: 30,
            z: 228.8611
          },
          {
            hole: 456,
            x: 38.2805,
            y: 30,
            z: 231.8612
          },
          {
            hole: 457,
            x: 30.6737,
            y: 30,
            z: 232.9895
          },
          {
            hole: 458,
            x: 23.0341,
            y: 30,
            z: 233.8684
          },
          {
            hole: 459,
            x: 15.3698,
            y: 30,
            z: 234.4968
          },
          {
            hole: 460,
            x: 7.689,
            y: 30,
            z: 234.8742
          },
          {
            hole: 461,
            x: -8.0162,
            y: 20,
            z: 234.8688
          },
          {
            hole: 462,
            x: -16.0238,
            y: 20,
            z: 234.4754
          },
          {
            hole: 463,
            x: -24.0142,
            y: 20,
            z: 233.8203
          },
          {
            hole: 464,
            x: -31.9789,
            y: 20,
            z: 232.904
          },
          {
            hole: 465,
            x: -39.9094,
            y: 20,
            z: 231.7276
          },
          {
            hole: 466,
            x: -55.6337,
            y: 20,
            z: 228.5999
          },
          {
            hole: 467,
            x: -63.4107,
            y: 20,
            z: 226.6518
          },
          {
            hole: 468,
            x: -71.1198,
            y: 20,
            z: 224.4504
          },
          {
            hole: 469,
            x: -78.7527,
            y: 20,
            z: 221.9979
          },
          {
            hole: 470,
            x: -86.3013,
            y: 20,
            z: 219.2969
          },
          {
            hole: 471,
            x: -101.1132,
            y: 20,
            z: 213.1616
          },
          {
            hole: 472,
            x: -108.3607,
            y: 20,
            z: 209.7338
          },
          {
            hole: 473,
            x: -115.4922,
            y: 20,
            z: 206.0707
          },
          {
            hole: 474,
            x: -122.5,
            y: 20,
            z: 202.1762
          },
          {
            hole: 475,
            x: -129.3766,
            y: 20,
            z: 198.0545
          },
          {
            hole: 476,
            x: -142.707,
            y: 20,
            z: 189.1474
          },
          {
            hole: 477,
            x: -149.1466,
            y: 20,
            z: 184.3716
          },
          {
            hole: 478,
            x: -155.4264,
            y: 20,
            z: 179.3876
          },
          {
            hole: 479,
            x: -161.5397,
            y: 20,
            z: 174.2007
          },
          {
            hole: 480,
            x: -167.4801,
            y: 20,
            z: 168.8167
          },
          {
            hole: 481,
            x: 40,
            y: 240,
            z: -6.25
          }
        ],
        p4: [
          {
            hole: 0,
            x: -203.516,
            y: 10,
            z: 107.5
          },
          {
            hole: 1,
            x: 24.1481,
            y: 230,
            z: 6.4705
          },
          {
            hole: 2,
            x: 21.6506,
            y: 230,
            z: 12.5
          },
          {
            hole: 3,
            x: 17.6777,
            y: 230,
            z: 17.6777
          },
          {
            hole: 4,
            x: 12.5,
            y: 230,
            z: 21.6506
          },
          {
            hole: 5,
            x: 6.4705,
            y: 230,
            z: 24.1481
          },
          {
            hole: 6,
            x: -9.0587,
            y: 220,
            z: 23.8074
          },
          {
            hole: 7,
            x: -17.5,
            y: 220,
            z: 20.3109
          },
          {
            hole: 8,
            x: -24.7487,
            y: 220,
            z: 14.7487
          },
          {
            hole: 9,
            x: -30.3109,
            y: 220,
            z: 7.5
          },
          {
            hole: 10,
            x: -33.8074,
            y: 220,
            z: -0.9413
          },
          {
            hole: 11,
            x: -33.4667,
            y: 210,
            z: -21.6469
          },
          {
            hole: 12,
            x: -28.9711,
            y: 210,
            z: -32.5
          },
          {
            hole: 13,
            x: -21.8198,
            y: 210,
            z: -41.8198
          },
          {
            hole: 14,
            x: -12.5,
            y: 210,
            z: -48.9711
          },
          {
            hole: 15,
            x: -1.6469,
            y: 210,
            z: -53.4667
          },
          {
            hole: 16,
            x: 24.235,
            y: 200,
            z: -53.1259
          },
          {
            hole: 17,
            x: 37.5,
            y: 200,
            z: -47.6314
          },
          {
            hole: 18,
            x: 48.8909,
            y: 200,
            z: -38.8909
          },
          {
            hole: 19,
            x: 57.6314,
            y: 200,
            z: -27.5
          },
          {
            hole: 20,
            x: 63.1259,
            y: 200,
            z: -14.235
          },
          {
            hole: 21,
            x: 64.4439,
            y: 190,
            z: 8.4842
          },
          {
            hole: 22,
            x: 62.7852,
            y: 190,
            z: 16.8232
          },
          {
            hole: 23,
            x: 60.0522,
            y: 190,
            z: 24.8744
          },
          {
            hole: 24,
            x: 56.2917,
            y: 190,
            z: 32.5
          },
          {
            hole: 25,
            x: 51.568,
            y: 190,
            z: 39.5695
          },
          {
            hole: 26,
            x: 39.5695,
            y: 190,
            z: 51.568
          },
          {
            hole: 27,
            x: 32.5,
            y: 190,
            z: 56.2916
          },
          {
            hole: 28,
            x: 24.8744,
            y: 190,
            z: 60.0522
          },
          {
            hole: 29,
            x: 16.8232,
            y: 190,
            z: 62.7852
          },
          {
            hole: 30,
            x: 8.4842,
            y: 190,
            z: 64.4439
          },
          {
            hole: 31,
            x: -9.7895,
            y: 180,
            z: 64.3584
          },
          {
            hole: 32,
            x: -19.4114,
            y: 180,
            z: 62.4444
          },
          {
            hole: 33,
            x: -28.7013,
            y: 180,
            z: 59.291
          },
          {
            hole: 34,
            x: -37.5,
            y: 180,
            z: 54.9519
          },
          {
            hole: 35,
            x: -45.6571,
            y: 180,
            z: 49.5015
          },
          {
            hole: 36,
            x: -59.5015,
            y: 180,
            z: 35.6571
          },
          {
            hole: 37,
            x: -64.9519,
            y: 180,
            z: 27.5
          },
          {
            hole: 38,
            x: -69.291,
            y: 180,
            z: 18.7013
          },
          {
            hole: 39,
            x: -72.4444,
            y: 180,
            z: 9.4114
          },
          {
            hole: 40,
            x: -74.3584,
            y: 180,
            z: -0.2105
          },
          {
            hole: 41,
            x: -74.2728,
            y: 170,
            z: -21.0947
          },
          {
            hole: 42,
            x: -72.1037,
            y: 170,
            z: -31.9996
          },
          {
            hole: 43,
            x: -68.5298,
            y: 170,
            z: -42.5281
          },
          {
            hole: 44,
            x: -63.6122,
            y: 170,
            z: -52.5
          },
          {
            hole: 45,
            x: -57.435,
            y: 170,
            z: -61.7447
          },
          {
            hole: 46,
            x: -41.7447,
            y: 170,
            z: -77.435
          },
          {
            hole: 47,
            x: -32.5,
            y: 170,
            z: -83.6122
          },
          {
            hole: 48,
            x: -22.5281,
            y: 170,
            z: -88.5298
          },
          {
            hole: 49,
            x: -11.9996,
            y: 170,
            z: -92.1037
          },
          {
            hole: 50,
            x: -1.0947,
            y: 170,
            z: -94.2728
          },
          {
            hole: 51,
            x: 22.4,
            y: 160,
            z: -94.1873
          },
          {
            hole: 52,
            x: 34.5878,
            y: 160,
            z: -91.763
          },
          {
            hole: 53,
            x: 46.3549,
            y: 160,
            z: -87.7686
          },
          {
            hole: 54,
            x: 57.5,
            y: 160,
            z: -82.2724
          },
          {
            hole: 55,
            x: 67.8323,
            y: 160,
            z: -75.3686
          },
          {
            hole: 56,
            x: 85.3686,
            y: 160,
            z: -57.8323
          },
          {
            hole: 57,
            x: 92.2724,
            y: 160,
            z: -47.5
          },
          {
            hole: 58,
            x: 97.7685,
            y: 160,
            z: -36.3549
          },
          {
            hole: 59,
            x: 101.7629,
            y: 160,
            z: -24.5878
          },
          {
            hole: 60,
            x: 104.1873,
            y: 160,
            z: -12.4
          },
          {
            hole: 61,
            x: 104.7752,
            y: 150,
            z: 6.8673
          },
          {
            hole: 62,
            x: 104.1017,
            y: 150,
            z: 13.7052
          },
          {
            hole: 63,
            x: 102.9824,
            y: 150,
            z: 20.4845
          },
          {
            hole: 64,
            x: 101.4222,
            y: 150,
            z: 27.176
          },
          {
            hole: 65,
            x: 99.4277,
            y: 150,
            z: 33.7511
          },
          {
            hole: 66,
            x: 94.1716,
            y: 150,
            z: 46.4403
          },
          {
            hole: 67,
            x: 90.9327,
            y: 150,
            z: 52.5
          },
          {
            hole: 68,
            x: 87.3043,
            y: 150,
            z: 58.3349
          },
          {
            hole: 69,
            x: 83.3021,
            y: 150,
            z: 63.9199
          },
          {
            hole: 70,
            x: 78.9432,
            y: 150,
            z: 69.2313
          },
          {
            hole: 71,
            x: 69.2313,
            y: 150,
            z: 78.9432
          },
          {
            hole: 72,
            x: 63.9199,
            y: 150,
            z: 83.3021
          },
          {
            hole: 73,
            x: 58.3349,
            y: 150,
            z: 87.3043
          },
          {
            hole: 74,
            x: 52.5,
            y: 150,
            z: 90.9327
          },
          {
            hole: 75,
            x: 46.4403,
            y: 150,
            z: 94.1716
          },
          {
            hole: 76,
            x: 33.7511,
            y: 150,
            z: 99.4277
          },
          {
            hole: 77,
            x: 27.176,
            y: 150,
            z: 101.4222
          },
          {
            hole: 78,
            x: 20.4845,
            y: 150,
            z: 102.9824
          },
          {
            hole: 79,
            x: 13.7053,
            y: 150,
            z: 104.1017
          },
          {
            hole: 80,
            x: 6.8673,
            y: 150,
            z: 104.7752
          },
          {
            hole: 81,
            x: -7.5214,
            y: 140,
            z: 104.7538
          },
          {
            hole: 82,
            x: -15.0105,
            y: 140,
            z: 104.0162
          },
          {
            hole: 83,
            x: -22.4354,
            y: 140,
            z: 102.7903
          },
          {
            hole: 84,
            x: -29.7642,
            y: 140,
            z: 101.0815
          },
          {
            hole: 85,
            x: -36.9655,
            y: 140,
            z: 98.897
          },
          {
            hole: 86,
            x: -50.8632,
            y: 140,
            z: 93.1404
          },
          {
            hole: 87,
            x: -57.5,
            y: 140,
            z: 89.5929
          },
          {
            hole: 88,
            x: -63.8906,
            y: 140,
            z: 85.619
          },
          {
            hole: 89,
            x: -70.0076,
            y: 140,
            z: 81.2356
          },
          {
            hole: 90,
            x: -75.8248,
            y: 140,
            z: 76.4616
          },
          {
            hole: 91,
            x: -86.4616,
            y: 140,
            z: 65.8248
          },
          {
            hole: 92,
            x: -91.2356,
            y: 140,
            z: 60.0076
          },
          {
            hole: 93,
            x: -95.619,
            y: 140,
            z: 53.8906
          },
          {
            hole: 94,
            x: -99.5929,
            y: 140,
            z: 47.5
          },
          {
            hole: 95,
            x: -103.1404,
            y: 140,
            z: 40.8632
          },
          {
            hole: 96,
            x: -108.897,
            y: 140,
            z: 26.9655
          },
          {
            hole: 97,
            x: -111.0815,
            y: 140,
            z: 19.7642
          },
          {
            hole: 98,
            x: -112.7903,
            y: 140,
            z: 12.4354
          },
          {
            hole: 99,
            x: -114.0162,
            y: 140,
            z: 5.0105
          },
          {
            hole: 100,
            x: -114.7538,
            y: 140,
            z: -2.4786
          },
          {
            hole: 101,
            x: -114.7324,
            y: 130,
            z: -18.1754
          },
          {
            hole: 102,
            x: -113.9306,
            y: 130,
            z: -26.3158
          },
          {
            hole: 103,
            x: -112.5981,
            y: 130,
            z: -34.3863
          },
          {
            hole: 104,
            x: -110.7407,
            y: 130,
            z: -42.3524
          },
          {
            hole: 105,
            x: -108.3663,
            y: 130,
            z: -50.1799
          },
          {
            hole: 106,
            x: -102.1091,
            y: 130,
            z: -65.2861
          },
          {
            hole: 107,
            x: -98.2532,
            y: 130,
            z: -72.5
          },
          {
            hole: 108,
            x: -93.9337,
            y: 130,
            z: -79.4463
          },
          {
            hole: 109,
            x: -89.1692,
            y: 130,
            z: -86.0952
          },
          {
            hole: 110,
            x: -83.98,
            y: 130,
            z: -92.4182
          },
          {
            hole: 111,
            x: -72.4182,
            y: 130,
            z: -103.98
          },
          {
            hole: 112,
            x: -66.0952,
            y: 130,
            z: -109.1692
          },
          {
            hole: 113,
            x: -59.4463,
            y: 130,
            z: -113.9337
          },
          {
            hole: 114,
            x: -52.5,
            y: 130,
            z: -118.2532
          },
          {
            hole: 115,
            x: -45.2861,
            y: 130,
            z: -122.1091
          },
          {
            hole: 116,
            x: -30.1799,
            y: 130,
            z: -128.3663
          },
          {
            hole: 117,
            x: -22.3524,
            y: 130,
            z: -130.7407
          },
          {
            hole: 118,
            x: -14.3863,
            y: 130,
            z: -132.5982
          },
          {
            hole: 119,
            x: -6.3158,
            y: 130,
            z: -133.9306
          },
          {
            hole: 120,
            x: 1.8246,
            y: 130,
            z: -134.7324
          },
          {
            hole: 121,
            x: 18.8294,
            y: 120,
            z: -134.711
          },
          {
            hole: 122,
            x: 27.621,
            y: 120,
            z: -133.8451
          },
          {
            hole: 123,
            x: 36.3372,
            y: 120,
            z: -132.406
          },
          {
            hole: 124,
            x: 44.9406,
            y: 120,
            z: -130.4
          },
          {
            hole: 125,
            x: 53.3943,
            y: 120,
            z: -127.8356
          },
          {
            hole: 126,
            x: 69.709,
            y: 120,
            z: -121.0778
          },
          {
            hole: 127,
            x: 77.5,
            y: 120,
            z: -116.9134
          },
          {
            hole: 128,
            x: 85.002,
            y: 120,
            z: -112.2484
          },
          {
            hole: 129,
            x: 92.1828,
            y: 120,
            z: -107.1027
          },
          {
            hole: 130,
            x: 99.0117,
            y: 120,
            z: -101.4984
          },
          {
            hole: 131,
            x: 111.4984,
            y: 120,
            z: -89.0117
          },
          {
            hole: 132,
            x: 117.1027,
            y: 120,
            z: -82.1828
          },
          {
            hole: 133,
            x: 122.2484,
            y: 120,
            z: -75.002
          },
          {
            hole: 134,
            x: 126.9134,
            y: 120,
            z: -67.5
          },
          {
            hole: 135,
            x: 131.0778,
            y: 120,
            z: -59.709
          },
          {
            hole: 136,
            x: 137.8356,
            y: 120,
            z: -43.3943
          },
          {
            hole: 137,
            x: 140.4,
            y: 120,
            z: -34.9406
          },
          {
            hole: 138,
            x: 142.406,
            y: 120,
            z: -26.3372
          },
          {
            hole: 139,
            x: 143.8451,
            y: 120,
            z: -17.621
          },
          {
            hole: 140,
            x: 144.711,
            y: 120,
            z: -8.8294
          },
          {
            hole: 141,
            x: 144.862,
            y: 110,
            z: 6.3248
          },
          {
            hole: 142,
            x: 144.4482,
            y: 110,
            z: 12.6376
          },
          {
            hole: 143,
            x: 143.7595,
            y: 110,
            z: 18.9263
          },
          {
            hole: 144,
            x: 142.7971,
            y: 110,
            z: 25.179
          },
          {
            hole: 145,
            x: 141.5629,
            y: 110,
            z: 31.3837
          },
          {
            hole: 146,
            x: 138.289,
            y: 110,
            z: 43.6023
          },
          {
            hole: 147,
            x: 136.2554,
            y: 110,
            z: 49.5929
          },
          {
            hole: 148,
            x: 133.9625,
            y: 110,
            z: 55.4891
          },
          {
            hole: 149,
            x: 131.4146,
            y: 110,
            z: 61.2796
          },
          {
            hole: 150,
            x: 128.6166,
            y: 110,
            z: 66.9535
          },
          {
            hole: 151,
            x: 122.2918,
            y: 110,
            z: 77.9084
          },
          {
            hole: 152,
            x: 118.777,
            y: 110,
            z: 83.1686
          },
          {
            hole: 153,
            x: 115.0362,
            y: 110,
            z: 88.2704
          },
          {
            hole: 154,
            x: 111.0764,
            y: 110,
            z: 93.2042
          },
          {
            hole: 155,
            x: 106.9052,
            y: 110,
            z: 97.9606
          },
          {
            hole: 156,
            x: 97.9606,
            y: 110,
            z: 106.9052
          },
          {
            hole: 157,
            x: 93.2042,
            y: 110,
            z: 111.0764
          },
          {
            hole: 158,
            x: 88.2704,
            y: 110,
            z: 115.0362
          },
          {
            hole: 159,
            x: 83.1686,
            y: 110,
            z: 118.777
          },
          {
            hole: 160,
            x: 77.9084,
            y: 110,
            z: 122.2918
          },
          {
            hole: 161,
            x: 66.9536,
            y: 110,
            z: 128.6166
          },
          {
            hole: 162,
            x: 61.2797,
            y: 110,
            z: 131.4146
          },
          {
            hole: 163,
            x: 55.4891,
            y: 110,
            z: 133.9625
          },
          {
            hole: 164,
            x: 49.5929,
            y: 110,
            z: 136.2554
          },
          {
            hole: 165,
            x: 43.6023,
            y: 110,
            z: 138.289
          },
          {
            hole: 166,
            x: 31.3838,
            y: 110,
            z: 141.5629
          },
          {
            hole: 167,
            x: 25.179,
            y: 110,
            z: 142.7971
          },
          {
            hole: 168,
            x: 18.9263,
            y: 110,
            z: 143.7595
          },
          {
            hole: 169,
            x: 12.6376,
            y: 110,
            z: 144.4482
          },
          {
            hole: 170,
            x: 6.3248,
            y: 110,
            z: 144.862
          },
          {
            hole: 171,
            x: -6.761,
            y: 100,
            z: 144.8525
          },
          {
            hole: 172,
            x: -13.5091,
            y: 100,
            z: 144.4102
          },
          {
            hole: 173,
            x: -20.2316,
            y: 100,
            z: 143.674
          },
          {
            hole: 174,
            x: -26.9155,
            y: 100,
            z: 142.6452
          },
          {
            hole: 175,
            x: -33.5481,
            y: 100,
            z: 141.3259
          },
          {
            hole: 176,
            x: -46.6094,
            y: 100,
            z: 137.8261
          },
          {
            hole: 177,
            x: -53.0131,
            y: 100,
            z: 135.6524
          },
          {
            hole: 178,
            x: -59.3159,
            y: 100,
            z: 133.2013
          },
          {
            hole: 179,
            x: -65.5058,
            y: 100,
            z: 130.4777
          },
          {
            hole: 180,
            x: -71.571,
            y: 100,
            z: 127.4867
          },
          {
            hole: 181,
            x: -83.2814,
            y: 100,
            z: 120.7257
          },
          {
            hole: 182,
            x: -88.9043,
            y: 100,
            z: 116.9686
          },
          {
            hole: 183,
            x: -94.358,
            y: 100,
            z: 112.9698
          },
          {
            hole: 184,
            x: -99.6321,
            y: 100,
            z: 108.7369
          },
          {
            hole: 185,
            x: -104.7165,
            y: 100,
            z: 104.278
          },
          {
            hole: 186,
            x: -114.278,
            y: 100,
            z: 94.7165
          },
          {
            hole: 187,
            x: -118.7369,
            y: 100,
            z: 89.6321
          },
          {
            hole: 188,
            x: -122.9698,
            y: 100,
            z: 84.358
          },
          {
            hole: 189,
            x: -126.9686,
            y: 100,
            z: 78.9043
          },
          {
            hole: 190,
            x: -130.7257,
            y: 100,
            z: 73.2814
          },
          {
            hole: 191,
            x: -137.4867,
            y: 100,
            z: 61.571
          },
          {
            hole: 192,
            x: -140.4777,
            y: 100,
            z: 55.5058
          },
          {
            hole: 193,
            x: -143.2013,
            y: 100,
            z: 49.3159
          },
          {
            hole: 194,
            x: -145.6524,
            y: 100,
            z: 43.0131
          },
          {
            hole: 195,
            x: -147.8261,
            y: 100,
            z: 36.6094
          },
          {
            hole: 196,
            x: -151.3259,
            y: 100,
            z: 23.5481
          },
          {
            hole: 197,
            x: -152.6452,
            y: 100,
            z: 16.9155
          },
          {
            hole: 198,
            x: -153.674,
            y: 100,
            z: 10.2316
          },
          {
            hole: 199,
            x: -154.4102,
            y: 100,
            z: 3.5091
          },
          {
            hole: 200,
            x: -154.8525,
            y: 100,
            z: -3.239
          },
          {
            hole: 201,
            x: -154.843,
            y: 90,
            z: -17.1972
          },
          {
            hole: 202,
            x: -154.3721,
            y: 90,
            z: -24.3807
          },
          {
            hole: 203,
            x: -153.5884,
            y: 90,
            z: -31.5368
          },
          {
            hole: 204,
            x: -152.4933,
            y: 90,
            z: -38.6519
          },
          {
            hole: 205,
            x: -151.0889,
            y: 90,
            z: -45.7125
          },
          {
            hole: 206,
            x: -147.3633,
            y: 90,
            z: -59.6165
          },
          {
            hole: 207,
            x: -145.0493,
            y: 90,
            z: -66.4333
          },
          {
            hole: 208,
            x: -142.4401,
            y: 90,
            z: -73.1428
          },
          {
            hole: 209,
            x: -139.5408,
            y: 90,
            z: -79.732
          },
          {
            hole: 210,
            x: -136.3568,
            y: 90,
            z: -86.1885
          },
          {
            hole: 211,
            x: -129.1596,
            y: 90,
            z: -98.6544
          },
          {
            hole: 212,
            x: -125.1601,
            y: 90,
            z: -104.6401
          },
          {
            hole: 213,
            x: -120.9033,
            y: 90,
            z: -110.4456
          },
          {
            hole: 214,
            x: -116.3973,
            y: 90,
            z: -116.06
          },
          {
            hole: 215,
            x: -111.6508,
            y: 90,
            z: -121.4724
          },
          {
            hole: 216,
            x: -101.4724,
            y: 90,
            z: -131.6508
          },
          {
            hole: 217,
            x: -96.06,
            y: 90,
            z: -136.3973
          },
          {
            hole: 218,
            x: -90.4457,
            y: 90,
            z: -140.9033
          },
          {
            hole: 219,
            x: -84.6401,
            y: 90,
            z: -145.1601
          },
          {
            hole: 220,
            x: -78.6545,
            y: 90,
            z: -149.1596
          },
          {
            hole: 221,
            x: -66.1885,
            y: 90,
            z: -156.3568
          },
          {
            hole: 222,
            x: -59.732,
            y: 90,
            z: -159.5408
          },
          {
            hole: 223,
            x: -53.1428,
            y: 90,
            z: -162.4401
          },
          {
            hole: 224,
            x: -46.4333,
            y: 90,
            z: -165.0493
          },
          {
            hole: 225,
            x: -39.6164,
            y: 90,
            z: -167.3633
          },
          {
            hole: 226,
            x: -25.7125,
            y: 90,
            z: -171.0888
          },
          {
            hole: 227,
            x: -18.652,
            y: 90,
            z: -172.4933
          },
          {
            hole: 228,
            x: -11.5368,
            y: 90,
            z: -173.5884
          },
          {
            hole: 229,
            x: -4.3807,
            y: 90,
            z: -174.3721
          },
          {
            hole: 230,
            x: 2.8028,
            y: 90,
            z: -174.8429
          },
          {
            hole: 231,
            x: 17.6334,
            y: 80,
            z: -174.8334
          },
          {
            hole: 232,
            x: 25.2523,
            y: 80,
            z: -174.3341
          },
          {
            hole: 233,
            x: 32.8421,
            y: 80,
            z: -173.5028
          },
          {
            hole: 234,
            x: 40.3884,
            y: 80,
            z: -172.3413
          },
          {
            hole: 235,
            x: 47.8769,
            y: 80,
            z: -170.8518
          },
          {
            hole: 236,
            x: 62.6235,
            y: 80,
            z: -166.9004
          },
          {
            hole: 237,
            x: 69.8535,
            y: 80,
            z: -164.4462
          },
          {
            hole: 238,
            x: 76.9696,
            y: 80,
            z: -161.6789
          },
          {
            hole: 239,
            x: 83.9582,
            y: 80,
            z: -158.6038
          },
          {
            hole: 240,
            x: 90.806,
            y: 80,
            z: -155.2269
          },
          {
            hole: 241,
            x: 104.0274,
            y: 80,
            z: -147.5935
          },
          {
            hole: 242,
            x: 110.3759,
            y: 80,
            z: -143.3516
          },
          {
            hole: 243,
            x: 116.5332,
            y: 80,
            z: -138.8368
          },
          {
            hole: 244,
            x: 122.4878,
            y: 80,
            z: -134.0578
          },
          {
            hole: 245,
            x: 128.2283,
            y: 80,
            z: -129.0235
          },
          {
            hole: 246,
            x: 139.0235,
            y: 80,
            z: -118.2283
          },
          {
            hole: 247,
            x: 144.0578,
            y: 80,
            z: -112.4878
          },
          {
            hole: 248,
            x: 148.8368,
            y: 80,
            z: -106.5332
          },
          {
            hole: 249,
            x: 153.3516,
            y: 80,
            z: -100.3759
          },
          {
            hole: 250,
            x: 157.5935,
            y: 80,
            z: -94.0274
          },
          {
            hole: 251,
            x: 165.2269,
            y: 80,
            z: -80.806
          },
          {
            hole: 252,
            x: 168.6039,
            y: 80,
            z: -73.9582
          },
          {
            hole: 253,
            x: 171.6789,
            y: 80,
            z: -66.9696
          },
          {
            hole: 254,
            x: 174.4462,
            y: 80,
            z: -59.8535
          },
          {
            hole: 255,
            x: 176.9005,
            y: 80,
            z: -52.6235
          },
          {
            hole: 256,
            x: 180.8518,
            y: 80,
            z: -37.8769
          },
          {
            hole: 257,
            x: 182.3414,
            y: 80,
            z: -30.3884
          },
          {
            hole: 258,
            x: 183.5028,
            y: 80,
            z: -22.8421
          },
          {
            hole: 259,
            x: 184.3341,
            y: 80,
            z: -15.2522
          },
          {
            hole: 260,
            x: 184.8334,
            y: 80,
            z: -7.6334
          },
          {
            hole: 261,
            x: 184.9009,
            y: 70,
            z: 6.053
          },
          {
            hole: 262,
            x: 184.6039,
            y: 70,
            z: 12.0996
          },
          {
            hole: 263,
            x: 184.1092,
            y: 70,
            z: 18.1332
          },
          {
            hole: 264,
            x: 183.4173,
            y: 70,
            z: 24.1473
          },
          {
            hole: 265,
            x: 182.529,
            y: 70,
            z: 30.1357
          },
          {
            hole: 266,
            x: 180.1672,
            y: 70,
            z: 42.0091
          },
          {
            hole: 267,
            x: 178.6963,
            y: 70,
            z: 47.8815
          },
          {
            hole: 268,
            x: 177.034,
            y: 70,
            z: 53.7027
          },
          {
            hole: 269,
            x: 175.1821,
            y: 70,
            z: 59.4663
          },
          {
            hole: 270,
            x: 173.1426,
            y: 70,
            z: 65.1663
          },
          {
            hole: 271,
            x: 168.5098,
            y: 70,
            z: 76.3508
          },
          {
            hole: 272,
            x: 165.9215,
            y: 70,
            z: 81.8234
          },
          {
            hole: 273,
            x: 163.1554,
            y: 70,
            z: 87.2084
          },
          {
            hole: 274,
            x: 160.2147,
            y: 70,
            z: 92.5
          },
          {
            hole: 275,
            x: 157.1024,
            y: 70,
            z: 97.6926
          },
          {
            hole: 276,
            x: 150.3766,
            y: 70,
            z: 107.7584
          },
          {
            hole: 277,
            x: 146.7704,
            y: 70,
            z: 112.6209
          },
          {
            hole: 278,
            x: 143.0069,
            y: 70,
            z: 117.3628
          },
          {
            hole: 279,
            x: 139.0904,
            y: 70,
            z: 121.979
          },
          {
            hole: 280,
            x: 135.0249,
            y: 70,
            z: 126.4646
          },
          {
            hole: 281,
            x: 126.4646,
            y: 70,
            z: 135.0249
          },
          {
            hole: 282,
            x: 121.979,
            y: 70,
            z: 139.0904
          },
          {
            hole: 283,
            x: 117.3628,
            y: 70,
            z: 143.0069
          },
          {
            hole: 284,
            x: 112.6209,
            y: 70,
            z: 146.7704
          },
          {
            hole: 285,
            x: 107.7584,
            y: 70,
            z: 150.3766
          },
          {
            hole: 286,
            x: 97.6926,
            y: 70,
            z: 157.1024
          },
          {
            hole: 287,
            x: 92.5,
            y: 70,
            z: 160.2147
          },
          {
            hole: 288,
            x: 87.2084,
            y: 70,
            z: 163.1554
          },
          {
            hole: 289,
            x: 81.8234,
            y: 70,
            z: 165.9215
          },
          {
            hole: 290,
            x: 76.3508,
            y: 70,
            z: 168.5098
          },
          {
            hole: 291,
            x: 65.1663,
            y: 70,
            z: 173.1426
          },
          {
            hole: 292,
            x: 59.4663,
            y: 70,
            z: 175.1821
          },
          {
            hole: 293,
            x: 53.7027,
            y: 70,
            z: 177.034
          },
          {
            hole: 294,
            x: 47.8815,
            y: 70,
            z: 178.6963
          },
          {
            hole: 295,
            x: 42.0091,
            y: 70,
            z: 180.1672
          },
          {
            hole: 296,
            x: 30.1357,
            y: 70,
            z: 182.529
          },
          {
            hole: 297,
            x: 24.1474,
            y: 70,
            z: 183.4173
          },
          {
            hole: 298,
            x: 18.1332,
            y: 70,
            z: 184.1092
          },
          {
            hole: 299,
            x: 12.0996,
            y: 70,
            z: 184.6039
          },
          {
            hole: 300,
            x: 6.0531,
            y: 70,
            z: 184.9009
          },
          {
            hole: 301,
            x: -6.3802,
            y: 60,
            z: 184.8956
          },
          {
            hole: 302,
            x: -12.7536,
            y: 60,
            z: 184.5825
          },
          {
            hole: 303,
            x: -19.1133,
            y: 60,
            z: 184.061
          },
          {
            hole: 304,
            x: -25.4526,
            y: 60,
            z: 183.3317
          },
          {
            hole: 305,
            x: -31.7646,
            y: 60,
            z: 182.3954
          },
          {
            hole: 306,
            x: -44.2799,
            y: 60,
            z: 179.906
          },
          {
            hole: 307,
            x: -50.4697,
            y: 60,
            z: 178.3555
          },
          {
            hole: 308,
            x: -56.6055,
            y: 60,
            z: 176.6034
          },
          {
            hole: 309,
            x: -62.6807,
            y: 60,
            z: 174.6514
          },
          {
            hole: 310,
            x: -68.6888,
            y: 60,
            z: 172.5016
          },
          {
            hole: 311,
            x: -80.4779,
            y: 60,
            z: 167.6184
          },
          {
            hole: 312,
            x: -86.2463,
            y: 60,
            z: 164.8902
          },
          {
            hole: 313,
            x: -91.9224,
            y: 60,
            z: 161.9746
          },
          {
            hole: 314,
            x: -97.5,
            y: 60,
            z: 158.8749
          },
          {
            hole: 315,
            x: -102.9732,
            y: 60,
            z: 155.5944
          },
          {
            hole: 316,
            x: -113.5832,
            y: 60,
            z: 148.5051
          },
          {
            hole: 317,
            x: -118.7085,
            y: 60,
            z: 144.7039
          },
          {
            hole: 318,
            x: -123.7067,
            y: 60,
            z: 140.737
          },
          {
            hole: 319,
            x: -128.5724,
            y: 60,
            z: 136.6088
          },
          {
            hole: 320,
            x: -133.3005,
            y: 60,
            z: 132.3235
          },
          {
            hole: 321,
            x: -142.3235,
            y: 60,
            z: 123.3005
          },
          {
            hole: 322,
            x: -146.6088,
            y: 60,
            z: 118.5724
          },
          {
            hole: 323,
            x: -150.737,
            y: 60,
            z: 113.7067
          },
          {
            hole: 324,
            x: -154.7039,
            y: 60,
            z: 108.7085
          },
          {
            hole: 325,
            x: -158.5051,
            y: 60,
            z: 103.5831
          },
          {
            hole: 326,
            x: -165.5944,
            y: 60,
            z: 92.9732
          },
          {
            hole: 327,
            x: -168.875,
            y: 60,
            z: 87.5
          },
          {
            hole: 328,
            x: -171.9746,
            y: 60,
            z: 81.9224
          },
          {
            hole: 329,
            x: -174.8902,
            y: 60,
            z: 76.2463
          },
          {
            hole: 330,
            x: -177.6184,
            y: 60,
            z: 70.4779
          },
          {
            hole: 331,
            x: -182.5017,
            y: 60,
            z: 58.6888
          },
          {
            hole: 332,
            x: -184.6514,
            y: 60,
            z: 52.6807
          },
          {
            hole: 333,
            x: -186.6034,
            y: 60,
            z: 46.6055
          },
          {
            hole: 334,
            x: -188.3555,
            y: 60,
            z: 40.4697
          },
          {
            hole: 335,
            x: -189.906,
            y: 60,
            z: 34.2799
          },
          {
            hole: 336,
            x: -192.3954,
            y: 60,
            z: 21.7646
          },
          {
            hole: 337,
            x: -193.3317,
            y: 60,
            z: 15.4526
          },
          {
            hole: 338,
            x: -194.061,
            y: 60,
            z: 9.1134
          },
          {
            hole: 339,
            x: -194.5825,
            y: 60,
            z: 2.7536
          },
          {
            hole: 340,
            x: -194.8956,
            y: 60,
            z: -3.6198
          },
          {
            hole: 341,
            x: -194.8902,
            y: 50,
            z: -16.7074
          },
          {
            hole: 342,
            x: -194.5611,
            y: 50,
            z: -23.4076
          },
          {
            hole: 343,
            x: -194.0129,
            y: 50,
            z: -30.0935
          },
          {
            hole: 344,
            x: -193.2462,
            y: 50,
            z: -36.7579
          },
          {
            hole: 345,
            x: -192.2619,
            y: 50,
            z: -43.3936
          },
          {
            hole: 346,
            x: -189.6448,
            y: 50,
            z: -56.5506
          },
          {
            hole: 347,
            x: -188.0148,
            y: 50,
            z: -63.0579
          },
          {
            hole: 348,
            x: -186.1728,
            y: 50,
            z: -69.5084
          },
          {
            hole: 349,
            x: -184.1207,
            y: 50,
            z: -75.8951
          },
          {
            hole: 350,
            x: -181.8607,
            y: 50,
            z: -82.2113
          },
          {
            hole: 351,
            x: -176.7271,
            y: 50,
            z: -94.6049
          },
          {
            hole: 352,
            x: -173.8589,
            y: 50,
            z: -100.6692
          },
          {
            hole: 353,
            x: -170.7939,
            y: 50,
            z: -106.6363
          },
          {
            hole: 354,
            x: -167.5352,
            y: 50,
            z: -112.5
          },
          {
            hole: 355,
            x: -164.0864,
            y: 50,
            z: -118.2539
          },
          {
            hole: 356,
            x: -156.6336,
            y: 50,
            z: -129.4079
          },
          {
            hole: 357,
            x: -152.6374,
            y: 50,
            z: -134.7961
          },
          {
            hole: 358,
            x: -148.4671,
            y: 50,
            z: -140.0506
          },
          {
            hole: 359,
            x: -144.1272,
            y: 50,
            z: -145.1659
          },
          {
            hole: 360,
            x: -139.6221,
            y: 50,
            z: -150.1364
          },
          {
            hole: 361,
            x: -130.1364,
            y: 50,
            z: -159.6221
          },
          {
            hole: 362,
            x: -125.1659,
            y: 50,
            z: -164.1272
          },
          {
            hole: 363,
            x: -120.0506,
            y: 50,
            z: -168.4671
          },
          {
            hole: 364,
            x: -114.7961,
            y: 50,
            z: -172.6374
          },
          {
            hole: 365,
            x: -109.4079,
            y: 50,
            z: -176.6336
          },
          {
            hole: 366,
            x: -98.2539,
            y: 50,
            z: -184.0864
          },
          {
            hole: 367,
            x: -92.5,
            y: 50,
            z: -187.5352
          },
          {
            hole: 368,
            x: -86.6363,
            y: 50,
            z: -190.7939
          },
          {
            hole: 369,
            x: -80.6692,
            y: 50,
            z: -193.8589
          },
          {
            hole: 370,
            x: -74.6049,
            y: 50,
            z: -196.7271
          },
          {
            hole: 371,
            x: -62.2112,
            y: 50,
            z: -201.8607
          },
          {
            hole: 372,
            x: -55.8951,
            y: 50,
            z: -204.1207
          },
          {
            hole: 373,
            x: -49.5083,
            y: 50,
            z: -206.1728
          },
          {
            hole: 374,
            x: -43.0579,
            y: 50,
            z: -208.0148
          },
          {
            hole: 375,
            x: -36.5506,
            y: 50,
            z: -209.6448
          },
          {
            hole: 376,
            x: -23.3936,
            y: 50,
            z: -212.2619
          },
          {
            hole: 377,
            x: -16.7579,
            y: 50,
            z: -213.2462
          },
          {
            hole: 378,
            x: -10.0935,
            y: 50,
            z: -214.0128
          },
          {
            hole: 379,
            x: -3.4077,
            y: 50,
            z: -214.5611
          },
          {
            hole: 380,
            x: 3.2926,
            y: 50,
            z: -214.8902
          },
          {
            hole: 381,
            x: 17.0346,
            y: 40,
            z: -214.8849
          },
          {
            hole: 382,
            x: 24.0617,
            y: 40,
            z: -214.5397
          },
          {
            hole: 383,
            x: 31.0737,
            y: 40,
            z: -213.9647
          },
          {
            hole: 384,
            x: 38.0631,
            y: 40,
            z: -213.1607
          },
          {
            hole: 385,
            x: 45.0225,
            y: 40,
            z: -212.1283
          },
          {
            hole: 386,
            x: 58.8214,
            y: 40,
            z: -209.3836
          },
          {
            hole: 387,
            x: 65.6461,
            y: 40,
            z: -207.6741
          },
          {
            hole: 388,
            x: 72.4112,
            y: 40,
            z: -205.7422
          },
          {
            hole: 389,
            x: 79.1095,
            y: 40,
            z: -203.59
          },
          {
            hole: 390,
            x: 85.7338,
            y: 40,
            z: -201.2198
          },
          {
            hole: 391,
            x: 98.732,
            y: 40,
            z: -195.8357
          },
          {
            hole: 392,
            x: 105.0921,
            y: 40,
            z: -192.8276
          },
          {
            hole: 393,
            x: 111.3503,
            y: 40,
            z: -189.6131
          },
          {
            hole: 394,
            x: 117.5,
            y: 40,
            z: -186.1955
          },
          {
            hole: 395,
            x: 123.5346,
            y: 40,
            z: -182.5785
          },
          {
            hole: 396,
            x: 135.2327,
            y: 40,
            z: -174.762
          },
          {
            hole: 397,
            x: 140.8837,
            y: 40,
            z: -170.571
          },
          {
            hole: 398,
            x: 146.3946,
            y: 40,
            z: -166.1973
          },
          {
            hole: 399,
            x: 151.7594,
            y: 40,
            z: -161.6456
          },
          {
            hole: 400,
            x: 156.9723,
            y: 40,
            z: -156.9208
          },
          {
            hole: 401,
            x: 166.9208,
            y: 40,
            z: -146.9724
          },
          {
            hole: 402,
            x: 171.6456,
            y: 40,
            z: -141.7594
          },
          {
            hole: 403,
            x: 176.1972,
            y: 40,
            z: -136.3946
          },
          {
            hole: 404,
            x: 180.571,
            y: 40,
            z: -130.8837
          },
          {
            hole: 405,
            x: 184.762,
            y: 40,
            z: -125.2327
          },
          {
            hole: 406,
            x: 192.5785,
            y: 40,
            z: -113.5346
          },
          {
            hole: 407,
            x: 196.1955,
            y: 40,
            z: -107.5
          },
          {
            hole: 408,
            x: 199.6131,
            y: 40,
            z: -101.3503
          },
          {
            hole: 409,
            x: 202.8276,
            y: 40,
            z: -95.0921
          },
          {
            hole: 410,
            x: 205.8357,
            y: 40,
            z: -88.732
          },
          {
            hole: 411,
            x: 211.2198,
            y: 40,
            z: -75.7338
          },
          {
            hole: 412,
            x: 213.59,
            y: 40,
            z: -69.1095
          },
          {
            hole: 413,
            x: 215.7422,
            y: 40,
            z: -62.4112
          },
          {
            hole: 414,
            x: 217.674,
            y: 40,
            z: -55.6461
          },
          {
            hole: 415,
            x: 219.3835,
            y: 40,
            z: -48.8214
          },
          {
            hole: 416,
            x: 222.1283,
            y: 40,
            z: -35.0225
          },
          {
            hole: 417,
            x: 223.1606,
            y: 40,
            z: -28.0631
          },
          {
            hole: 418,
            x: 223.9647,
            y: 40,
            z: -21.0737
          },
          {
            hole: 419,
            x: 224.5397,
            y: 40,
            z: -14.0617
          },
          {
            hole: 420,
            x: 224.8849,
            y: 40,
            z: -7.0346
          },
          {
            hole: 421,
            x: 224.8795,
            y: 30,
            z: 7.3618
          },
          {
            hole: 422,
            x: 224.5183,
            y: 30,
            z: 14.7157
          },
          {
            hole: 423,
            x: 223.9166,
            y: 30,
            z: 22.0539
          },
          {
            hole: 424,
            x: 223.0751,
            y: 30,
            z: 29.3684
          },
          {
            hole: 425,
            x: 221.9947,
            y: 30,
            z: 36.6515
          },
          {
            hole: 426,
            x: 219.1223,
            y: 30,
            z: 51.0922
          },
          {
            hole: 427,
            x: 217.3333,
            y: 30,
            z: 58.2343
          },
          {
            hole: 428,
            x: 215.3116,
            y: 30,
            z: 65.3141
          },
          {
            hole: 429,
            x: 213.0593,
            y: 30,
            z: 72.3239
          },
          {
            hole: 430,
            x: 210.5788,
            y: 30,
            z: 79.2563
          },
          {
            hole: 431,
            x: 204.9444,
            y: 30,
            z: 92.8591
          },
          {
            hole: 432,
            x: 201.7964,
            y: 30,
            z: 99.515
          },
          {
            hole: 433,
            x: 198.4323,
            y: 30,
            z: 106.0643
          },
          {
            hole: 434,
            x: 194.8557,
            y: 30,
            z: 112.5
          },
          {
            hole: 435,
            x: 191.0705,
            y: 30,
            z: 118.8153
          },
          {
            hole: 436,
            x: 182.8905,
            y: 30,
            z: 131.0575
          },
          {
            hole: 437,
            x: 178.5045,
            y: 30,
            z: 136.9713
          },
          {
            hole: 438,
            x: 173.9273,
            y: 30,
            z: 142.7385
          },
          {
            hole: 439,
            x: 169.164,
            y: 30,
            z: 148.3528
          },
          {
            hole: 440,
            x: 164.2194,
            y: 30,
            z: 153.8083
          },
          {
            hole: 441,
            x: 153.8083,
            y: 30,
            z: 164.2194
          },
          {
            hole: 442,
            x: 148.3528,
            y: 30,
            z: 169.164
          },
          {
            hole: 443,
            x: 142.7385,
            y: 30,
            z: 173.9273
          },
          {
            hole: 444,
            x: 136.9713,
            y: 30,
            z: 178.5045
          },
          {
            hole: 445,
            x: 131.0575,
            y: 30,
            z: 182.8905
          },
          {
            hole: 446,
            x: 118.8153,
            y: 30,
            z: 191.0705
          },
          {
            hole: 447,
            x: 112.5,
            y: 30,
            z: 194.8557
          },
          {
            hole: 448,
            x: 106.0643,
            y: 30,
            z: 198.4323
          },
          {
            hole: 449,
            x: 99.515,
            y: 30,
            z: 201.7964
          },
          {
            hole: 450,
            x: 92.8591,
            y: 30,
            z: 204.9444
          },
          {
            hole: 451,
            x: 79.2563,
            y: 30,
            z: 210.5788
          },
          {
            hole: 452,
            x: 72.3239,
            y: 30,
            z: 213.0593
          },
          {
            hole: 453,
            x: 65.3141,
            y: 30,
            z: 215.3116
          },
          {
            hole: 454,
            x: 58.2343,
            y: 30,
            z: 217.3333
          },
          {
            hole: 455,
            x: 51.0922,
            y: 30,
            z: 219.1223
          },
          {
            hole: 456,
            x: 36.6515,
            y: 30,
            z: 221.9947
          },
          {
            hole: 457,
            x: 29.3684,
            y: 30,
            z: 223.0751
          },
          {
            hole: 458,
            x: 22.0539,
            y: 30,
            z: 223.9166
          },
          {
            hole: 459,
            x: 14.7157,
            y: 30,
            z: 224.5183
          },
          {
            hole: 460,
            x: 7.3618,
            y: 30,
            z: 224.8795
          },
          {
            hole: 461,
            x: -7.689,
            y: 20,
            z: 224.8742
          },
          {
            hole: 462,
            x: -15.3697,
            y: 20,
            z: 224.4968
          },
          {
            hole: 463,
            x: -23.034,
            y: 20,
            z: 223.8684
          },
          {
            hole: 464,
            x: -30.6737,
            y: 20,
            z: 222.9895
          },
          {
            hole: 465,
            x: -38.2804,
            y: 20,
            z: 221.8612
          },
          {
            hole: 466,
            x: -53.3629,
            y: 20,
            z: 218.8611
          },
          {
            hole: 467,
            x: -60.8225,
            y: 20,
            z: 216.9926
          },
          {
            hole: 468,
            x: -68.2169,
            y: 20,
            z: 214.881
          },
          {
            hole: 469,
            x: -75.5383,
            y: 20,
            z: 212.5286
          },
          {
            hole: 470,
            x: -82.7788,
            y: 20,
            z: 209.9379
          },
          {
            hole: 471,
            x: -96.9862,
            y: 20,
            z: 204.053
          },
          {
            hole: 472,
            x: -103.9378,
            y: 20,
            z: 200.7651
          },
          {
            hole: 473,
            x: -110.7782,
            y: 20,
            z: 197.2515
          },
          {
            hole: 474,
            x: -117.5,
            y: 20,
            z: 193.516
          },
          {
            hole: 475,
            x: -124.0959,
            y: 20,
            z: 189.5625
          },
          {
            hole: 476,
            x: -136.8823,
            y: 20,
            z: 181.019
          },
          {
            hole: 477,
            x: -143.0589,
            y: 20,
            z: 176.438
          },
          {
            hole: 478,
            x: -149.0824,
            y: 20,
            z: 171.6575
          },
          {
            hole: 479,
            x: -154.9463,
            y: 20,
            z: 166.6824
          },
          {
            hole: 480,
            x: -160.6442,
            y: 20,
            z: 161.5181
          },
          {
            hole: 481,
            x: 40,
            y: 240,
            z: -6.25
          }
        ]
      }
    },
    {
      id: "board-fidget-spinner-cribbage",
      name: "Fidget Spinner",
      brand: "crazy,pints,adult",
      desc: "Fidget Spinner Cribbage 3D cribbage board (45.5 MB)",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/fidget_spinner_-_sunken_-_3d_-_thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/5730422d65587cc2/fidget_spinner_-_sunken_-_3d.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: -8.2905,
            y: 30,
            z: -223.8537
          },
          {
            hole: -1,
            x: -16.5073,
            y: 30,
            z: -222.7719
          },
          {
            hole: 1,
            x: -32.5025,
            y: 40,
            z: -218.4857
          },
          {
            hole: 2,
            x: -40.1593,
            y: 40,
            z: -215.3141
          },
          {
            hole: 3,
            x: -47.5106,
            y: 40,
            z: -211.4873
          },
          {
            hole: 4,
            x: -54.5004,
            y: 40,
            z: -207.0343
          },
          {
            hole: 5,
            x: -61.0754,
            y: 40,
            z: -201.9891
          },
          {
            hole: 6,
            x: -75.3792,
            y: 40,
            z: -187.1234
          },
          {
            hole: 7,
            x: -82.2831,
            y: 40,
            z: -176.7911
          },
          {
            hole: 8,
            x: -87.7792,
            y: 40,
            z: -165.646
          },
          {
            hole: 9,
            x: -91.7736,
            y: 40,
            z: -153.8789
          },
          {
            hole: 10,
            x: -94.1979,
            y: 40,
            z: -141.6911
          },
          {
            hole: 11,
            x: -96.3886,
            y: 40,
            z: -121.5158
          },
          {
            hole: 12,
            x: -98.0473,
            y: 40,
            z: -113.1767
          },
          {
            hole: 13,
            x: -100.7803,
            y: 40,
            z: -105.1255
          },
          {
            hole: 14,
            x: -104.5408,
            y: 40,
            z: -97.5
          },
          {
            hole: 15,
            x: -109.2645,
            y: 40,
            z: -90.4305
          },
          {
            hole: 16,
            x: -120.4305,
            y: 40,
            z: -78.432
          },
          {
            hole: 17,
            x: -127.5,
            y: 40,
            z: -73.7084
          },
          {
            hole: 18,
            x: -135.1255,
            y: 40,
            z: -69.9478
          },
          {
            hole: 19,
            x: -143.1767,
            y: 40,
            z: -67.2148
          },
          {
            hole: 20,
            x: -151.5157,
            y: 40,
            z: -65.5561
          },
          {
            hole: 21,
            x: -172.7561,
            y: 50,
            z: -64.1873
          },
          {
            hole: 22,
            x: -184.9439,
            y: 50,
            z: -61.763
          },
          {
            hole: 23,
            x: -196.711,
            y: 50,
            z: -57.7686
          },
          {
            hole: 24,
            x: -207.8561,
            y: 50,
            z: -52.2725
          },
          {
            hole: 25,
            x: -218.1884,
            y: 50,
            z: -45.3686
          },
          {
            hole: 26,
            x: -235.7248,
            y: 50,
            z: -27.8324
          },
          {
            hole: 27,
            x: -242.6286,
            y: 50,
            z: -17.5
          },
          {
            hole: 28,
            x: -248.1248,
            y: 50,
            z: -6.355
          },
          {
            hole: 29,
            x: -252.1192,
            y: 50,
            z: 5.4122
          },
          {
            hole: 30,
            x: -254.5435,
            y: 50,
            z: 17.6
          },
          {
            hole: 31,
            x: -254.1872,
            y: 50,
            z: 42.4
          },
          {
            hole: 32,
            x: -251.7629,
            y: 50,
            z: 54.5878
          },
          {
            hole: 33,
            x: -247.7685,
            y: 50,
            z: 66.3549
          },
          {
            hole: 34,
            x: -242.2724,
            y: 50,
            z: 77.5
          },
          {
            hole: 35,
            x: -235.3685,
            y: 50,
            z: 87.8323
          },
          {
            hole: 36,
            x: -217.8323,
            y: 50,
            z: 105.3685
          },
          {
            hole: 37,
            x: -207.5,
            y: 50,
            z: 112.2724
          },
          {
            hole: 38,
            x: -196.3549,
            y: 50,
            z: 117.7685
          },
          {
            hole: 39,
            x: -184.5878,
            y: 50,
            z: 121.7629
          },
          {
            hole: 40,
            x: -172.4,
            y: 50,
            z: 124.1872
          },
          {
            hole: 41,
            x: -147.6,
            y: 50,
            z: 124.1872
          },
          {
            hole: 42,
            x: -135.4122,
            y: 50,
            z: 121.7629
          },
          {
            hole: 43,
            x: -123.6451,
            y: 50,
            z: 117.7685
          },
          {
            hole: 44,
            x: -112.5,
            y: 50,
            z: 112.2724
          },
          {
            hole: 45,
            x: -102.1677,
            y: 50,
            z: 105.3685
          },
          {
            hole: 46,
            x: -84.6314,
            y: 50,
            z: 87.8323
          },
          {
            hole: 47,
            x: -77.7276,
            y: 50,
            z: 77.5
          },
          {
            hole: 48,
            x: -72.2314,
            y: 50,
            z: 66.3549
          },
          {
            hole: 49,
            x: -68.2371,
            y: 50,
            z: 54.5878
          },
          {
            hole: 50,
            x: -65.8127,
            y: 50,
            z: 42.4
          },
          {
            hole: 51,
            x: -64.4546,
            y: 60,
            z: 22.2247
          },
          {
            hole: 52,
            x: -62.7959,
            y: 60,
            z: 13.8856
          },
          {
            hole: 53,
            x: -60.0628,
            y: 60,
            z: 5.8344
          },
          {
            hole: 54,
            x: -56.3023,
            y: 60,
            z: -1.7911
          },
          {
            hole: 55,
            x: -51.5786,
            y: 60,
            z: -8.8606
          },
          {
            hole: 56,
            x: -39.5802,
            y: 60,
            z: -20.8591
          },
          {
            hole: 57,
            x: -32.5107,
            y: 60,
            z: -25.5828
          },
          {
            hole: 58,
            x: -24.8851,
            y: 60,
            z: -29.3433
          },
          {
            hole: 59,
            x: -16.8339,
            y: 60,
            z: -32.0763
          },
          {
            hole: 60,
            x: -8.4949,
            y: 60,
            z: -33.7351
          },
          {
            hole: 61,
            x: 8.4735,
            y: 60,
            z: -33.735
          },
          {
            hole: 62,
            x: 16.8126,
            y: 60,
            z: -32.0763
          },
          {
            hole: 63,
            x: 24.8637,
            y: 60,
            z: -29.3433
          },
          {
            hole: 64,
            x: 32.4893,
            y: 60,
            z: -25.5828
          },
          {
            hole: 65,
            x: 39.5588,
            y: 60,
            z: -20.8591
          },
          {
            hole: 66,
            x: 75.3579,
            y: 60,
            z: -27.1235
          },
          {
            hole: 67,
            x: 82.2617,
            y: 60,
            z: -16.7911
          },
          {
            hole: 68,
            x: 87.7579,
            y: 60,
            z: -5.6461
          },
          {
            hole: 69,
            x: 91.7523,
            y: 60,
            z: 6.1211
          },
          {
            hole: 70,
            x: 94.1766,
            y: 60,
            z: 18.3089
          },
          {
            hole: 71,
            x: 65.8128,
            y: 50,
            z: 42.4
          },
          {
            hole: 72,
            x: 68.2371,
            y: 50,
            z: 54.5878
          },
          {
            hole: 73,
            x: 72.2315,
            y: 50,
            z: 66.3549
          },
          {
            hole: 74,
            x: 77.7276,
            y: 50,
            z: 77.5
          },
          {
            hole: 75,
            x: 84.6314,
            y: 50,
            z: 87.8323
          },
          {
            hole: 76,
            x: 102.1677,
            y: 50,
            z: 105.3686
          },
          {
            hole: 77,
            x: 112.5,
            y: 50,
            z: 112.2724
          },
          {
            hole: 78,
            x: 123.6451,
            y: 50,
            z: 117.7685
          },
          {
            hole: 79,
            x: 135.4122,
            y: 50,
            z: 121.7629
          },
          {
            hole: 80,
            x: 147.6,
            y: 50,
            z: 124.1872
          },
          {
            hole: 81,
            x: 172.4,
            y: 50,
            z: 124.1873
          },
          {
            hole: 82,
            x: 184.5878,
            y: 50,
            z: 121.7629
          },
          {
            hole: 83,
            x: 196.355,
            y: 50,
            z: 117.7685
          },
          {
            hole: 84,
            x: 207.5,
            y: 50,
            z: 112.2724
          },
          {
            hole: 85,
            x: 217.8324,
            y: 50,
            z: 105.3686
          },
          {
            hole: 86,
            x: 235.3686,
            y: 50,
            z: 87.8323
          },
          {
            hole: 87,
            x: 242.2724,
            y: 50,
            z: 77.5
          },
          {
            hole: 88,
            x: 247.7686,
            y: 50,
            z: 66.3549
          },
          {
            hole: 89,
            x: 251.763,
            y: 50,
            z: 54.5878
          },
          {
            hole: 90,
            x: 254.1873,
            y: 50,
            z: 42.4
          },
          {
            hole: 91,
            x: 254.1872,
            y: 50,
            z: 18.3089
          },
          {
            hole: 92,
            x: 251.7629,
            y: 50,
            z: 6.1211
          },
          {
            hole: 93,
            x: 247.7685,
            y: 50,
            z: -5.646
          },
          {
            hole: 94,
            x: 242.2724,
            y: 50,
            z: -16.7911
          },
          {
            hole: 95,
            x: 235.3685,
            y: 50,
            z: -27.1234
          },
          {
            hole: 96,
            x: 217.8323,
            y: 50,
            z: -44.6597
          },
          {
            hole: 97,
            x: 207.5,
            y: 50,
            z: -51.5635
          },
          {
            hole: 98,
            x: 196.3549,
            y: 50,
            z: -57.0597
          },
          {
            hole: 99,
            x: 184.5878,
            y: 50,
            z: -61.0541
          },
          {
            hole: 100,
            x: 172.4,
            y: 50,
            z: -63.4784
          },
          {
            hole: 101,
            x: 151.5158,
            y: 40,
            z: -65.5561
          },
          {
            hole: 102,
            x: 143.1768,
            y: 40,
            z: -67.2149
          },
          {
            hole: 103,
            x: 135.1256,
            y: 40,
            z: -69.9479
          },
          {
            hole: 104,
            x: 127.5,
            y: 40,
            z: -73.7084
          },
          {
            hole: 105,
            x: 120.4305,
            y: 40,
            z: -78.4321
          },
          {
            hole: 106,
            x: 108.432,
            y: 40,
            z: -90.4305
          },
          {
            hole: 107,
            x: 103.7083,
            y: 40,
            z: -97.5
          },
          {
            hole: 108,
            x: 99.9478,
            y: 40,
            z: -105.1256
          },
          {
            hole: 109,
            x: 97.2148,
            y: 40,
            z: -113.1768
          },
          {
            hole: 110,
            x: 95.5561,
            y: 40,
            z: -121.5158
          },
          {
            hole: 111,
            x: 93.344,
            y: 40,
            z: -142.3999
          },
          {
            hole: 112,
            x: 90.9197,
            y: 40,
            z: -154.5877
          },
          {
            hole: 113,
            x: 86.9253,
            y: 40,
            z: -166.3548
          },
          {
            hole: 114,
            x: 81.4292,
            y: 40,
            z: -177.4999
          },
          {
            hole: 115,
            x: 74.5253,
            y: 40,
            z: -187.8322
          },
          {
            hole: 116,
            x: 61.0541,
            y: 40,
            z: -201.9892
          },
          {
            hole: 117,
            x: 54.4791,
            y: 40,
            z: -207.0344
          },
          {
            hole: 118,
            x: 47.4893,
            y: 40,
            z: -211.4874
          },
          {
            hole: 119,
            x: 40.1381,
            y: 40,
            z: -215.3142
          },
          {
            hole: 120,
            x: 32.4812,
            y: 40,
            z: -218.4858
          },
          {
            hole: 121,
            x: 8.2691,
            y: 30,
            z: -223.8537
          }
        ],
        p2: [
          {
            hole: 0,
            x: -7.419,
            y: 20,
            z: -213.8917
          },
          {
            hole: -1,
            x: -14.7708,
            y: 20,
            z: -212.9239
          },
          {
            hole: 1,
            x: -29.0823,
            y: 30,
            z: -209.0888
          },
          {
            hole: 2,
            x: -35.9332,
            y: 30,
            z: -206.2511
          },
          {
            hole: 3,
            x: -42.5106,
            y: 30,
            z: -202.8271
          },
          {
            hole: 4,
            x: -48.7646,
            y: 30,
            z: -198.8428
          },
          {
            hole: 5,
            x: -54.6476,
            y: 30,
            z: -194.3287
          },
          {
            hole: 6,
            x: -67.4457,
            y: 30,
            z: -181.0358
          },
          {
            hole: 7,
            x: -73.6228,
            y: 30,
            z: -171.7911
          },
          {
            hole: 8,
            x: -78.5404,
            y: 30,
            z: -161.8192
          },
          {
            hole: 9,
            x: -82.1143,
            y: 30,
            z: -151.2907
          },
          {
            hole: 10,
            x: -84.2835,
            y: 30,
            z: -140.3858
          },
          {
            hole: 11,
            x: -86.4741,
            y: 30,
            z: -120.2105
          },
          {
            hole: 12,
            x: -88.3881,
            y: 30,
            z: -110.5885
          },
          {
            hole: 13,
            x: -91.5415,
            y: 30,
            z: -101.2987
          },
          {
            hole: 14,
            x: -95.8806,
            y: 30,
            z: -92.5
          },
          {
            hole: 15,
            x: -101.331,
            y: 30,
            z: -84.3429
          },
          {
            hole: 16,
            x: -114.3428,
            y: 30,
            z: -70.4985
          },
          {
            hole: 17,
            x: -122.5,
            y: 30,
            z: -65.0481
          },
          {
            hole: 18,
            x: -131.2987,
            y: 30,
            z: -60.709
          },
          {
            hole: 19,
            x: -140.5885,
            y: 30,
            z: -57.5556
          },
          {
            hole: 20,
            x: -150.2105,
            y: 30,
            z: -55.6416
          },
          {
            hole: 21,
            x: -171.4508,
            y: 40,
            z: -54.2729
          },
          {
            hole: 22,
            x: -182.3557,
            y: 40,
            z: -52.1038
          },
          {
            hole: 23,
            x: -192.8842,
            y: 40,
            z: -48.5298
          },
          {
            hole: 24,
            x: -202.8561,
            y: 40,
            z: -43.6122
          },
          {
            hole: 25,
            x: -212.1008,
            y: 40,
            z: -37.4351
          },
          {
            hole: 26,
            x: -227.7912,
            y: 40,
            z: -21.7447
          },
          {
            hole: 27,
            x: -233.9684,
            y: 40,
            z: -12.5
          },
          {
            hole: 28,
            x: -238.886,
            y: 40,
            z: -2.5281
          },
          {
            hole: 29,
            x: -242.4599,
            y: 40,
            z: 8.0004
          },
          {
            hole: 30,
            x: -244.629,
            y: 40,
            z: 18.9052
          },
          {
            hole: 31,
            x: -244.2728,
            y: 40,
            z: 41.0947
          },
          {
            hole: 32,
            x: -242.1037,
            y: 40,
            z: 51.9996
          },
          {
            hole: 33,
            x: -238.5297,
            y: 40,
            z: 62.5281
          },
          {
            hole: 34,
            x: -233.6121,
            y: 40,
            z: 72.5
          },
          {
            hole: 35,
            x: -227.435,
            y: 40,
            z: 81.7447
          },
          {
            hole: 36,
            x: -211.7447,
            y: 40,
            z: 97.435
          },
          {
            hole: 37,
            x: -202.5,
            y: 40,
            z: 103.6121
          },
          {
            hole: 38,
            x: -192.5281,
            y: 40,
            z: 108.5297
          },
          {
            hole: 39,
            x: -181.9996,
            y: 40,
            z: 112.1037
          },
          {
            hole: 40,
            x: -171.0947,
            y: 40,
            z: 114.2728
          },
          {
            hole: 41,
            x: -148.9053,
            y: 40,
            z: 114.2728
          },
          {
            hole: 42,
            x: -138.0004,
            y: 40,
            z: 112.1037
          },
          {
            hole: 43,
            x: -127.4719,
            y: 40,
            z: 108.5297
          },
          {
            hole: 44,
            x: -117.5,
            y: 40,
            z: 103.6121
          },
          {
            hole: 45,
            x: -108.2553,
            y: 40,
            z: 97.435
          },
          {
            hole: 46,
            x: -92.565,
            y: 40,
            z: 81.7447
          },
          {
            hole: 47,
            x: -86.3878,
            y: 40,
            z: 72.5
          },
          {
            hole: 48,
            x: -81.4702,
            y: 40,
            z: 62.5281
          },
          {
            hole: 49,
            x: -77.8963,
            y: 40,
            z: 51.9996
          },
          {
            hole: 50,
            x: -75.7272,
            y: 40,
            z: 41.0947
          },
          {
            hole: 51,
            x: -74.369,
            y: 50,
            z: 20.9194
          },
          {
            hole: 52,
            x: -72.4551,
            y: 50,
            z: 11.2974
          },
          {
            hole: 53,
            x: -69.3016,
            y: 50,
            z: 2.0076
          },
          {
            hole: 54,
            x: -64.9626,
            y: 50,
            z: -6.7911
          },
          {
            hole: 55,
            x: -59.5122,
            y: 50,
            z: -14.9482
          },
          {
            hole: 56,
            x: -45.6678,
            y: 50,
            z: -28.7926
          },
          {
            hole: 57,
            x: -37.5107,
            y: 50,
            z: -34.243
          },
          {
            hole: 58,
            x: -28.7119,
            y: 50,
            z: -38.5821
          },
          {
            hole: 59,
            x: -19.4221,
            y: 50,
            z: -41.7356
          },
          {
            hole: 60,
            x: -9.8001,
            y: 50,
            z: -43.6495
          },
          {
            hole: 61,
            x: 9.7788,
            y: 50,
            z: -43.6495
          },
          {
            hole: 62,
            x: 19.4007,
            y: 50,
            z: -41.7356
          },
          {
            hole: 63,
            x: 28.6906,
            y: 50,
            z: -38.5821
          },
          {
            hole: 64,
            x: 37.4893,
            y: 50,
            z: -34.243
          },
          {
            hole: 65,
            x: 45.6464,
            y: 50,
            z: -28.7926
          },
          {
            hole: 66,
            x: 67.4243,
            y: 50,
            z: -21.0359
          },
          {
            hole: 67,
            x: 73.6015,
            y: 50,
            z: -11.7911
          },
          {
            hole: 68,
            x: 78.5191,
            y: 50,
            z: -1.8192
          },
          {
            hole: 69,
            x: 82.093,
            y: 50,
            z: 8.7092
          },
          {
            hole: 70,
            x: 84.2621,
            y: 50,
            z: 19.6141
          },
          {
            hole: 71,
            x: 75.7272,
            y: 40,
            z: 41.0947
          },
          {
            hole: 72,
            x: 77.8963,
            y: 40,
            z: 51.9996
          },
          {
            hole: 73,
            x: 81.4703,
            y: 40,
            z: 62.5281
          },
          {
            hole: 74,
            x: 86.3879,
            y: 40,
            z: 72.5
          },
          {
            hole: 75,
            x: 92.565,
            y: 40,
            z: 81.7447
          },
          {
            hole: 76,
            x: 108.2553,
            y: 40,
            z: 97.435
          },
          {
            hole: 77,
            x: 117.5,
            y: 40,
            z: 103.6121
          },
          {
            hole: 78,
            x: 127.4719,
            y: 40,
            z: 108.5297
          },
          {
            hole: 79,
            x: 138.0004,
            y: 40,
            z: 112.1037
          },
          {
            hole: 80,
            x: 148.9053,
            y: 40,
            z: 114.2728
          },
          {
            hole: 81,
            x: 171.0948,
            y: 40,
            z: 114.2728
          },
          {
            hole: 82,
            x: 181.9996,
            y: 40,
            z: 112.1037
          },
          {
            hole: 83,
            x: 192.5281,
            y: 40,
            z: 108.5298
          },
          {
            hole: 84,
            x: 202.5,
            y: 40,
            z: 103.6122
          },
          {
            hole: 85,
            x: 211.7447,
            y: 40,
            z: 97.435
          },
          {
            hole: 86,
            x: 227.4351,
            y: 40,
            z: 81.7447
          },
          {
            hole: 87,
            x: 233.6122,
            y: 40,
            z: 72.5
          },
          {
            hole: 88,
            x: 238.5298,
            y: 40,
            z: 62.5281
          },
          {
            hole: 89,
            x: 242.1037,
            y: 40,
            z: 51.9996
          },
          {
            hole: 90,
            x: 244.2728,
            y: 40,
            z: 41.0947
          },
          {
            hole: 91,
            x: 244.2728,
            y: 40,
            z: 19.6142
          },
          {
            hole: 92,
            x: 242.1037,
            y: 40,
            z: 8.7093
          },
          {
            hole: 93,
            x: 238.5297,
            y: 40,
            z: -1.8192
          },
          {
            hole: 94,
            x: 233.6121,
            y: 40,
            z: -11.7911
          },
          {
            hole: 95,
            x: 227.435,
            y: 40,
            z: -21.0358
          },
          {
            hole: 96,
            x: 211.7447,
            y: 40,
            z: -36.7261
          },
          {
            hole: 97,
            x: 202.5,
            y: 40,
            z: -42.9033
          },
          {
            hole: 98,
            x: 192.5281,
            y: 40,
            z: -47.8209
          },
          {
            hole: 99,
            x: 181.9996,
            y: 40,
            z: -51.3948
          },
          {
            hole: 100,
            x: 171.0947,
            y: 40,
            z: -53.5639
          },
          {
            hole: 101,
            x: 150.2105,
            y: 30,
            z: -55.6417
          },
          {
            hole: 102,
            x: 140.5886,
            y: 30,
            z: -57.5556
          },
          {
            hole: 103,
            x: 131.2987,
            y: 30,
            z: -60.7091
          },
          {
            hole: 104,
            x: 122.5,
            y: 30,
            z: -65.0481
          },
          {
            hole: 105,
            x: 114.3429,
            y: 30,
            z: -70.4985
          },
          {
            hole: 106,
            x: 100.4985,
            y: 30,
            z: -84.3429
          },
          {
            hole: 107,
            x: 95.0481,
            y: 30,
            z: -92.5
          },
          {
            hole: 108,
            x: 90.709,
            y: 30,
            z: -101.2988
          },
          {
            hole: 109,
            x: 87.5556,
            y: 30,
            z: -110.5886
          },
          {
            hole: 110,
            x: 85.6416,
            y: 30,
            z: -120.2106
          },
          {
            hole: 111,
            x: 83.4296,
            y: 30,
            z: -141.0946
          },
          {
            hole: 112,
            x: 81.2605,
            y: 30,
            z: -151.9995
          },
          {
            hole: 113,
            x: 77.6865,
            y: 30,
            z: -162.528
          },
          {
            hole: 114,
            x: 72.7689,
            y: 30,
            z: -172.4999
          },
          {
            hole: 115,
            x: 66.5918,
            y: 30,
            z: -181.7446
          },
          {
            hole: 116,
            x: 54.6263,
            y: 30,
            z: -194.3288
          },
          {
            hole: 117,
            x: 48.7433,
            y: 30,
            z: -198.8429
          },
          {
            hole: 118,
            x: 42.4893,
            y: 30,
            z: -202.8272
          },
          {
            hole: 119,
            x: 35.9119,
            y: 30,
            z: -206.2512
          },
          {
            hole: 120,
            x: 29.061,
            y: 30,
            z: -209.0889
          },
          {
            hole: 121,
            x: 7.3975,
            y: 20,
            z: -213.8917
          }
        ],
        p3: [
          {
            hole: 0,
            x: -6.5474,
            y: 20,
            z: -203.9298
          },
          {
            hole: -1,
            x: -13.0344,
            y: 20,
            z: -203.0758
          },
          {
            hole: 1,
            x: -25.6621,
            y: 30,
            z: -199.6918
          },
          {
            hole: 2,
            x: -31.707,
            y: 30,
            z: -197.188
          },
          {
            hole: 3,
            x: -37.5106,
            y: 30,
            z: -194.1668
          },
          {
            hole: 4,
            x: -43.0288,
            y: 30,
            z: -190.6513
          },
          {
            hole: 5,
            x: -48.2197,
            y: 30,
            z: -186.6682
          },
          {
            hole: 6,
            x: -59.5122,
            y: 30,
            z: -174.9482
          },
          {
            hole: 7,
            x: -64.9626,
            y: 30,
            z: -166.7911
          },
          {
            hole: 8,
            x: -69.3016,
            y: 30,
            z: -157.9924
          },
          {
            hole: 9,
            x: -72.4551,
            y: 30,
            z: -148.7025
          },
          {
            hole: 10,
            x: -74.369,
            y: 30,
            z: -139.0806
          },
          {
            hole: 11,
            x: -76.5597,
            y: 30,
            z: -118.9052
          },
          {
            hole: 12,
            x: -78.7288,
            y: 30,
            z: -108.0004
          },
          {
            hole: 13,
            x: -82.3027,
            y: 30,
            z: -97.4719
          },
          {
            hole: 14,
            x: -87.2203,
            y: 30,
            z: -87.5
          },
          {
            hole: 15,
            x: -93.3975,
            y: 30,
            z: -78.2553
          },
          {
            hole: 16,
            x: -108.2552,
            y: 30,
            z: -62.565
          },
          {
            hole: 17,
            x: -117.5,
            y: 30,
            z: -56.3879
          },
          {
            hole: 18,
            x: -127.4719,
            y: 30,
            z: -51.4703
          },
          {
            hole: 19,
            x: -138.0003,
            y: 30,
            z: -47.8963
          },
          {
            hole: 20,
            x: -148.9052,
            y: 30,
            z: -45.7272
          },
          {
            hole: 21,
            x: -170.1456,
            y: 40,
            z: -44.3584
          },
          {
            hole: 22,
            x: -179.7675,
            y: 40,
            z: -42.4445
          },
          {
            hole: 23,
            x: -189.0574,
            y: 40,
            z: -39.291
          },
          {
            hole: 24,
            x: -197.8561,
            y: 40,
            z: -34.952
          },
          {
            hole: 25,
            x: -206.0132,
            y: 40,
            z: -29.5016
          },
          {
            hole: 26,
            x: -219.8577,
            y: 40,
            z: -15.6571
          },
          {
            hole: 27,
            x: -225.3081,
            y: 40,
            z: -7.5
          },
          {
            hole: 28,
            x: -229.6472,
            y: 40,
            z: 1.2987
          },
          {
            hole: 29,
            x: -232.8006,
            y: 40,
            z: 10.5885
          },
          {
            hole: 30,
            x: -234.7146,
            y: 40,
            z: 20.2105
          },
          {
            hole: 31,
            x: -234.3583,
            y: 40,
            z: 39.7895
          },
          {
            hole: 32,
            x: -232.4444,
            y: 40,
            z: 49.4114
          },
          {
            hole: 33,
            x: -229.2909,
            y: 40,
            z: 58.7013
          },
          {
            hole: 34,
            x: -224.9519,
            y: 40,
            z: 67.5
          },
          {
            hole: 35,
            x: -219.5015,
            y: 40,
            z: 75.6571
          },
          {
            hole: 36,
            x: -205.6571,
            y: 40,
            z: 89.5015
          },
          {
            hole: 37,
            x: -197.5,
            y: 40,
            z: 94.9519
          },
          {
            hole: 38,
            x: -188.7012,
            y: 40,
            z: 99.2909
          },
          {
            hole: 39,
            x: -179.4114,
            y: 40,
            z: 102.4444
          },
          {
            hole: 40,
            x: -169.7894,
            y: 40,
            z: 104.3583
          },
          {
            hole: 41,
            x: -150.2105,
            y: 40,
            z: 104.3583
          },
          {
            hole: 42,
            x: -140.5886,
            y: 40,
            z: 102.4444
          },
          {
            hole: 43,
            x: -131.2987,
            y: 40,
            z: 99.2909
          },
          {
            hole: 44,
            x: -122.5,
            y: 40,
            z: 94.9519
          },
          {
            hole: 45,
            x: -114.3429,
            y: 40,
            z: 89.5015
          },
          {
            hole: 46,
            x: -100.4985,
            y: 40,
            z: 75.6571
          },
          {
            hole: 47,
            x: -95.0481,
            y: 40,
            z: 67.5
          },
          {
            hole: 48,
            x: -90.709,
            y: 40,
            z: 58.7012
          },
          {
            hole: 49,
            x: -87.5556,
            y: 40,
            z: 49.4114
          },
          {
            hole: 50,
            x: -85.6416,
            y: 40,
            z: 39.7895
          },
          {
            hole: 51,
            x: -84.2835,
            y: 50,
            z: 19.6141
          },
          {
            hole: 52,
            x: -82.1144,
            y: 50,
            z: 8.7092
          },
          {
            hole: 53,
            x: -78.5404,
            y: 50,
            z: -1.8192
          },
          {
            hole: 54,
            x: -73.6228,
            y: 50,
            z: -11.7911
          },
          {
            hole: 55,
            x: -67.4457,
            y: 50,
            z: -21.0359
          },
          {
            hole: 56,
            x: -51.7554,
            y: 50,
            z: -36.7262
          },
          {
            hole: 57,
            x: -42.5107,
            y: 50,
            z: -42.9033
          },
          {
            hole: 58,
            x: -32.5388,
            y: 50,
            z: -47.8209
          },
          {
            hole: 59,
            x: -22.0103,
            y: 50,
            z: -51.3948
          },
          {
            hole: 60,
            x: -11.1054,
            y: 50,
            z: -53.564
          },
          {
            hole: 61,
            x: 11.084,
            y: 50,
            z: -53.5639
          },
          {
            hole: 62,
            x: 21.9889,
            y: 50,
            z: -51.3948
          },
          {
            hole: 63,
            x: 32.5174,
            y: 50,
            z: -47.8209
          },
          {
            hole: 64,
            x: 42.4893,
            y: 50,
            z: -42.9033
          },
          {
            hole: 65,
            x: 51.734,
            y: 50,
            z: -36.7262
          },
          {
            hole: 66,
            x: 59.4908,
            y: 50,
            z: -14.9482
          },
          {
            hole: 67,
            x: 64.9412,
            y: 50,
            z: -6.7911
          },
          {
            hole: 68,
            x: 69.2803,
            y: 50,
            z: 2.0076
          },
          {
            hole: 69,
            x: 72.4337,
            y: 50,
            z: 11.2974
          },
          {
            hole: 70,
            x: 74.3477,
            y: 50,
            z: 20.9194
          },
          {
            hole: 71,
            x: 85.6416,
            y: 40,
            z: 39.7894
          },
          {
            hole: 72,
            x: 87.5556,
            y: 40,
            z: 49.4114
          },
          {
            hole: 73,
            x: 90.709,
            y: 40,
            z: 58.7012
          },
          {
            hole: 74,
            x: 95.0481,
            y: 40,
            z: 67.5
          },
          {
            hole: 75,
            x: 100.4985,
            y: 40,
            z: 75.6571
          },
          {
            hole: 76,
            x: 114.3429,
            y: 40,
            z: 89.5015
          },
          {
            hole: 77,
            x: 122.5,
            y: 40,
            z: 94.9519
          },
          {
            hole: 78,
            x: 131.2987,
            y: 40,
            z: 99.2909
          },
          {
            hole: 79,
            x: 140.5886,
            y: 40,
            z: 102.4444
          },
          {
            hole: 80,
            x: 150.2105,
            y: 40,
            z: 104.3583
          },
          {
            hole: 81,
            x: 169.7895,
            y: 40,
            z: 104.3584
          },
          {
            hole: 82,
            x: 179.4115,
            y: 40,
            z: 102.4444
          },
          {
            hole: 83,
            x: 188.7013,
            y: 40,
            z: 99.291
          },
          {
            hole: 84,
            x: 197.5,
            y: 40,
            z: 94.9519
          },
          {
            hole: 85,
            x: 205.6571,
            y: 40,
            z: 89.5015
          },
          {
            hole: 86,
            x: 219.5015,
            y: 40,
            z: 75.6571
          },
          {
            hole: 87,
            x: 224.9519,
            y: 40,
            z: 67.5
          },
          {
            hole: 88,
            x: 229.291,
            y: 40,
            z: 58.7012
          },
          {
            hole: 89,
            x: 232.4445,
            y: 40,
            z: 49.4114
          },
          {
            hole: 90,
            x: 234.3584,
            y: 40,
            z: 39.7894
          },
          {
            hole: 91,
            x: 234.3583,
            y: 40,
            z: 20.9194
          },
          {
            hole: 92,
            x: 232.4444,
            y: 40,
            z: 11.2975
          },
          {
            hole: 93,
            x: 229.2909,
            y: 40,
            z: 2.0077
          },
          {
            hole: 94,
            x: 224.9519,
            y: 40,
            z: -6.7911
          },
          {
            hole: 95,
            x: 219.5015,
            y: 40,
            z: -14.9482
          },
          {
            hole: 96,
            x: 205.6571,
            y: 40,
            z: -28.7926
          },
          {
            hole: 97,
            x: 197.5,
            y: 40,
            z: -34.243
          },
          {
            hole: 98,
            x: 188.7013,
            y: 40,
            z: -38.5821
          },
          {
            hole: 99,
            x: 179.4114,
            y: 40,
            z: -41.7355
          },
          {
            hole: 100,
            x: 169.7895,
            y: 40,
            z: -43.6495
          },
          {
            hole: 101,
            x: 148.9053,
            y: 30,
            z: -45.7272
          },
          {
            hole: 102,
            x: 138.0004,
            y: 30,
            z: -47.8964
          },
          {
            hole: 103,
            x: 127.4719,
            y: 30,
            z: -51.4703
          },
          {
            hole: 104,
            x: 117.5,
            y: 30,
            z: -56.3879
          },
          {
            hole: 105,
            x: 108.2553,
            y: 30,
            z: -62.565
          },
          {
            hole: 106,
            x: 92.565,
            y: 30,
            z: -78.2553
          },
          {
            hole: 107,
            x: 86.3878,
            y: 30,
            z: -87.5
          },
          {
            hole: 108,
            x: 81.4702,
            y: 30,
            z: -97.4719
          },
          {
            hole: 109,
            x: 77.8963,
            y: 30,
            z: -108.0004
          },
          {
            hole: 110,
            x: 75.7272,
            y: 30,
            z: -118.9053
          },
          {
            hole: 111,
            x: 73.5151,
            y: 30,
            z: -139.7894
          },
          {
            hole: 112,
            x: 71.6012,
            y: 30,
            z: -149.4113
          },
          {
            hole: 113,
            x: 68.4477,
            y: 30,
            z: -158.7012
          },
          {
            hole: 114,
            x: 64.1087,
            y: 30,
            z: -167.4999
          },
          {
            hole: 115,
            x: 58.6583,
            y: 30,
            z: -175.657
          },
          {
            hole: 116,
            x: 48.1984,
            y: 30,
            z: -186.6683
          },
          {
            hole: 117,
            x: 43.0076,
            y: 30,
            z: -190.6514
          },
          {
            hole: 118,
            x: 37.4893,
            y: 30,
            z: -194.1669
          },
          {
            hole: 119,
            x: 31.6857,
            y: 30,
            z: -197.1881
          },
          {
            hole: 120,
            x: 25.6408,
            y: 30,
            z: -199.6919
          },
          {
            hole: 121,
            x: 6.5259,
            y: 20,
            z: -203.9298
          }
        ],
        p4: [
          {
            hole: 0,
            x: -5.6759,
            y: 30,
            z: -193.9679
          },
          {
            hole: -1,
            x: -11.2979,
            y: 30,
            z: -193.2277
          },
          {
            hole: 1,
            x: -22.2419,
            y: 40,
            z: -190.2949
          },
          {
            hole: 2,
            x: -27.4808,
            y: 40,
            z: -188.1249
          },
          {
            hole: 3,
            x: -32.5106,
            y: 40,
            z: -185.5066
          },
          {
            hole: 4,
            x: -37.2931,
            y: 40,
            z: -182.4598
          },
          {
            hole: 5,
            x: -41.7918,
            y: 40,
            z: -179.0078
          },
          {
            hole: 6,
            x: -51.5786,
            y: 40,
            z: -168.8606
          },
          {
            hole: 7,
            x: -56.3023,
            y: 40,
            z: -161.7911
          },
          {
            hole: 8,
            x: -60.0628,
            y: 40,
            z: -154.1655
          },
          {
            hole: 9,
            x: -62.7958,
            y: 40,
            z: -146.1143
          },
          {
            hole: 10,
            x: -64.4546,
            y: 40,
            z: -137.7753
          },
          {
            hole: 11,
            x: -66.6452,
            y: 40,
            z: -117.6
          },
          {
            hole: 12,
            x: -69.0695,
            y: 40,
            z: -105.4122
          },
          {
            hole: 13,
            x: -73.0639,
            y: 40,
            z: -93.645
          },
          {
            hole: 14,
            x: -78.5601,
            y: 40,
            z: -82.5
          },
          {
            hole: 15,
            x: -85.4639,
            y: 40,
            z: -72.1676
          },
          {
            hole: 16,
            x: -102.1676,
            y: 40,
            z: -54.6314
          },
          {
            hole: 17,
            x: -112.5,
            y: 40,
            z: -47.7276
          },
          {
            hole: 18,
            x: -123.645,
            y: 40,
            z: -42.2315
          },
          {
            hole: 19,
            x: -135.4121,
            y: 40,
            z: -38.2371
          },
          {
            hole: 20,
            x: -147.6,
            y: 40,
            z: -35.8128
          },
          {
            hole: 21,
            x: -168.8403,
            y: 50,
            z: -34.444
          },
          {
            hole: 22,
            x: -177.1793,
            y: 50,
            z: -32.7853
          },
          {
            hole: 23,
            x: -185.2305,
            y: 50,
            z: -30.0523
          },
          {
            hole: 24,
            x: -192.8561,
            y: 50,
            z: -26.2917
          },
          {
            hole: 25,
            x: -199.9256,
            y: 50,
            z: -21.5681
          },
          {
            hole: 26,
            x: -211.9242,
            y: 50,
            z: -9.5695
          },
          {
            hole: 27,
            x: -216.6479,
            y: 50,
            z: -2.5
          },
          {
            hole: 28,
            x: -220.4084,
            y: 50,
            z: 5.1256
          },
          {
            hole: 29,
            x: -223.1414,
            y: 50,
            z: 13.1767
          },
          {
            hole: 30,
            x: -224.8001,
            y: 50,
            z: 21.5158
          },
          {
            hole: 31,
            x: -224.4439,
            y: 50,
            z: 38.4842
          },
          {
            hole: 32,
            x: -222.7851,
            y: 50,
            z: 46.8233
          },
          {
            hole: 33,
            x: -220.0521,
            y: 50,
            z: 54.8744
          },
          {
            hole: 34,
            x: -216.2916,
            y: 50,
            z: 62.5
          },
          {
            hole: 35,
            x: -211.5679,
            y: 50,
            z: 69.5695
          },
          {
            hole: 36,
            x: -199.5695,
            y: 50,
            z: 81.5679
          },
          {
            hole: 37,
            x: -192.5,
            y: 50,
            z: 86.2916
          },
          {
            hole: 38,
            x: -184.8744,
            y: 50,
            z: 90.0521
          },
          {
            hole: 39,
            x: -176.8232,
            y: 50,
            z: 92.7852
          },
          {
            hole: 40,
            x: -168.4842,
            y: 50,
            z: 94.4439
          },
          {
            hole: 41,
            x: -151.5158,
            y: 50,
            z: 94.4439
          },
          {
            hole: 42,
            x: -143.1768,
            y: 50,
            z: 92.7851
          },
          {
            hole: 43,
            x: -135.1256,
            y: 50,
            z: 90.0521
          },
          {
            hole: 44,
            x: -127.5,
            y: 50,
            z: 86.2916
          },
          {
            hole: 45,
            x: -120.4305,
            y: 50,
            z: 81.5679
          },
          {
            hole: 46,
            x: -108.432,
            y: 50,
            z: 69.5695
          },
          {
            hole: 47,
            x: -103.7084,
            y: 50,
            z: 62.5
          },
          {
            hole: 48,
            x: -99.9478,
            y: 50,
            z: 54.8744
          },
          {
            hole: 49,
            x: -97.2148,
            y: 50,
            z: 46.8232
          },
          {
            hole: 50,
            x: -95.5561,
            y: 50,
            z: 38.4842
          },
          {
            hole: 51,
            x: -94.1979,
            y: 60,
            z: 18.3089
          },
          {
            hole: 52,
            x: -91.7736,
            y: 60,
            z: 6.1211
          },
          {
            hole: 53,
            x: -87.7792,
            y: 60,
            z: -5.6461
          },
          {
            hole: 54,
            x: -82.2831,
            y: 60,
            z: -16.7911
          },
          {
            hole: 55,
            x: -75.3792,
            y: 60,
            z: -27.1235
          },
          {
            hole: 56,
            x: -57.843,
            y: 60,
            z: -44.6597
          },
          {
            hole: 57,
            x: -47.5107,
            y: 60,
            z: -51.5636
          },
          {
            hole: 58,
            x: -36.3656,
            y: 60,
            z: -57.0597
          },
          {
            hole: 59,
            x: -24.5985,
            y: 60,
            z: -61.0541
          },
          {
            hole: 60,
            x: -12.4107,
            y: 60,
            z: -63.4784
          },
          {
            hole: 61,
            x: 12.3893,
            y: 60,
            z: -63.4784
          },
          {
            hole: 62,
            x: 24.5771,
            y: 60,
            z: -61.0541
          },
          {
            hole: 63,
            x: 36.3442,
            y: 60,
            z: -57.0597
          },
          {
            hole: 64,
            x: 47.4893,
            y: 60,
            z: -51.5635
          },
          {
            hole: 65,
            x: 57.8216,
            y: 60,
            z: -44.6597
          },
          {
            hole: 66,
            x: 51.5573,
            y: 60,
            z: -8.8606
          },
          {
            hole: 67,
            x: 56.281,
            y: 60,
            z: -1.7911
          },
          {
            hole: 68,
            x: 60.0415,
            y: 60,
            z: 5.8344
          },
          {
            hole: 69,
            x: 62.7745,
            y: 60,
            z: 13.8856
          },
          {
            hole: 70,
            x: 64.4332,
            y: 60,
            z: 22.2247
          },
          {
            hole: 71,
            x: 95.5561,
            y: 50,
            z: 38.4842
          },
          {
            hole: 72,
            x: 97.2148,
            y: 50,
            z: 46.8232
          },
          {
            hole: 73,
            x: 99.9478,
            y: 50,
            z: 54.8744
          },
          {
            hole: 74,
            x: 103.7084,
            y: 50,
            z: 62.5
          },
          {
            hole: 75,
            x: 108.432,
            y: 50,
            z: 69.5695
          },
          {
            hole: 76,
            x: 120.4305,
            y: 50,
            z: 81.568
          },
          {
            hole: 77,
            x: 127.5,
            y: 50,
            z: 86.2916
          },
          {
            hole: 78,
            x: 135.1256,
            y: 50,
            z: 90.0522
          },
          {
            hole: 79,
            x: 143.1768,
            y: 50,
            z: 92.7852
          },
          {
            hole: 80,
            x: 151.5158,
            y: 50,
            z: 94.4439
          },
          {
            hole: 81,
            x: 168.4842,
            y: 50,
            z: 94.4439
          },
          {
            hole: 82,
            x: 176.8233,
            y: 50,
            z: 92.7852
          },
          {
            hole: 83,
            x: 184.8745,
            y: 50,
            z: 90.0522
          },
          {
            hole: 84,
            x: 192.5,
            y: 50,
            z: 86.2916
          },
          {
            hole: 85,
            x: 199.5695,
            y: 50,
            z: 81.568
          },
          {
            hole: 86,
            x: 211.568,
            y: 50,
            z: 69.5695
          },
          {
            hole: 87,
            x: 216.2917,
            y: 50,
            z: 62.5
          },
          {
            hole: 88,
            x: 220.0522,
            y: 50,
            z: 54.8744
          },
          {
            hole: 89,
            x: 222.7852,
            y: 50,
            z: 46.8232
          },
          {
            hole: 90,
            x: 224.4439,
            y: 50,
            z: 38.4842
          },
          {
            hole: 91,
            x: 224.4439,
            y: 50,
            z: 22.2247
          },
          {
            hole: 92,
            x: 222.7852,
            y: 50,
            z: 13.8857
          },
          {
            hole: 93,
            x: 220.0521,
            y: 50,
            z: 5.8345
          },
          {
            hole: 94,
            x: 216.2916,
            y: 50,
            z: -1.7911
          },
          {
            hole: 95,
            x: 211.5679,
            y: 50,
            z: -8.8606
          },
          {
            hole: 96,
            x: 199.5695,
            y: 50,
            z: -20.8591
          },
          {
            hole: 97,
            x: 192.5,
            y: 50,
            z: -25.5828
          },
          {
            hole: 98,
            x: 184.8744,
            y: 50,
            z: -29.3433
          },
          {
            hole: 99,
            x: 176.8232,
            y: 50,
            z: -32.0763
          },
          {
            hole: 100,
            x: 168.4842,
            y: 50,
            z: -33.735
          },
          {
            hole: 101,
            x: 147.6,
            y: 40,
            z: -35.8128
          },
          {
            hole: 102,
            x: 135.4122,
            y: 40,
            z: -38.2371
          },
          {
            hole: 103,
            x: 123.6451,
            y: 40,
            z: -42.2315
          },
          {
            hole: 104,
            x: 112.5,
            y: 40,
            z: -47.7276
          },
          {
            hole: 105,
            x: 102.1677,
            y: 40,
            z: -54.6315
          },
          {
            hole: 106,
            x: 84.6314,
            y: 40,
            z: -72.1677
          },
          {
            hole: 107,
            x: 77.7276,
            y: 40,
            z: -82.5
          },
          {
            hole: 108,
            x: 72.2314,
            y: 40,
            z: -93.6451
          },
          {
            hole: 109,
            x: 68.237,
            y: 40,
            z: -105.4122
          },
          {
            hole: 110,
            x: 65.8127,
            y: 40,
            z: -117.6
          },
          {
            hole: 111,
            x: 63.6007,
            y: 40,
            z: -138.4841
          },
          {
            hole: 112,
            x: 61.942,
            y: 40,
            z: -146.8232
          },
          {
            hole: 113,
            x: 59.209,
            y: 40,
            z: -154.8743
          },
          {
            hole: 114,
            x: 55.4484,
            y: 40,
            z: -162.4999
          },
          {
            hole: 115,
            x: 50.7248,
            y: 40,
            z: -169.5694
          },
          {
            hole: 116,
            x: 41.7705,
            y: 40,
            z: -179.0079
          },
          {
            hole: 117,
            x: 37.2718,
            y: 40,
            z: -182.4599
          },
          {
            hole: 118,
            x: 32.4893,
            y: 40,
            z: -185.5067
          },
          {
            hole: 119,
            x: 27.4595,
            y: 40,
            z: -188.125
          },
          {
            hole: 120,
            x: 22.2206,
            y: 40,
            z: -190.295
          },
          {
            hole: 121,
            x: 5.6544,
            y: 30,
            z: -193.9679
          }
        ]
      }
    },
    {
      id: "board-baseball-stadium",
      name: "Baseball Stadium",
      brand: "crazy,pints,adult",
      desc: "Baseball Stadium Cribbage 3D cribbage board (6.2 MB)",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/crazy-baseball-stadium-thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/97bec5b478d23010/crazy-baseball-stadium.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: -190.6568,
            y: 50,
            z: 169.4436
          },
          {
            hole: 1,
            x: -125,
            y: 40,
            z: 115.5
          },
          {
            hole: 2,
            x: -125,
            y: 40,
            z: 107.75
          },
          {
            hole: 3,
            x: -125,
            y: 40,
            z: 100
          },
          {
            hole: 4,
            x: -125,
            y: 40,
            z: 92.25
          },
          {
            hole: 5,
            x: -125,
            y: 40,
            z: 84.5
          },
          {
            hole: 6,
            x: -125,
            y: 40,
            z: 75.5
          },
          {
            hole: 7,
            x: -125,
            y: 40,
            z: 67.75
          },
          {
            hole: 8,
            x: -125,
            y: 40,
            z: 60
          },
          {
            hole: 9,
            x: -125,
            y: 40,
            z: 52.25
          },
          {
            hole: 10,
            x: -125,
            y: 40,
            z: 44.5
          },
          {
            hole: 11,
            x: -125,
            y: 40,
            z: 35.5
          },
          {
            hole: 12,
            x: -125,
            y: 40,
            z: 27.75
          },
          {
            hole: 13,
            x: -125,
            y: 40,
            z: 20
          },
          {
            hole: 14,
            x: -125,
            y: 40,
            z: 12.25
          },
          {
            hole: 15,
            x: -125,
            y: 40,
            z: 4.5
          },
          {
            hole: 16,
            x: -125,
            y: 40,
            z: -4.5
          },
          {
            hole: 17,
            x: -125,
            y: 40,
            z: -12.25
          },
          {
            hole: 18,
            x: -125,
            y: 40,
            z: -20
          },
          {
            hole: 19,
            x: -125,
            y: 40,
            z: -27.75
          },
          {
            hole: 20,
            x: -125,
            y: 40,
            z: -35.5
          },
          {
            hole: 21,
            x: -125,
            y: 40,
            z: -44.5
          },
          {
            hole: 22,
            x: -125,
            y: 40,
            z: -52.25
          },
          {
            hole: 23,
            x: -125,
            y: 40,
            z: -60
          },
          {
            hole: 24,
            x: -125,
            y: 40,
            z: -67.75
          },
          {
            hole: 25,
            x: -125,
            y: 40,
            z: -75.5
          },
          {
            hole: 26,
            x: -125,
            y: 40,
            z: -84.5
          },
          {
            hole: 27,
            x: -125,
            y: 40,
            z: -92.25
          },
          {
            hole: 28,
            x: -125,
            y: 40,
            z: -100
          },
          {
            hole: 29,
            x: -125,
            y: 40,
            z: -107.75
          },
          {
            hole: 30,
            x: -125,
            y: 40,
            z: -115.5
          },
          {
            hole: 31,
            x: -115.5,
            y: 40,
            z: -155
          },
          {
            hole: 32,
            x: -107.75,
            y: 40,
            z: -155
          },
          {
            hole: 33,
            x: -100,
            y: 40,
            z: -155
          },
          {
            hole: 34,
            x: -92.25,
            y: 40,
            z: -155
          },
          {
            hole: 35,
            x: -84.5,
            y: 40,
            z: -155
          },
          {
            hole: 36,
            x: -75.5,
            y: 40,
            z: -155
          },
          {
            hole: 37,
            x: -67.75,
            y: 40,
            z: -155
          },
          {
            hole: 38,
            x: -60,
            y: 40,
            z: -155
          },
          {
            hole: 39,
            x: -52.25,
            y: 40,
            z: -155
          },
          {
            hole: 40,
            x: -44.5,
            y: 40,
            z: -155
          },
          {
            hole: 41,
            x: -35.5,
            y: 40,
            z: -155
          },
          {
            hole: 42,
            x: -27.75,
            y: 40,
            z: -155
          },
          {
            hole: 43,
            x: -20,
            y: 40,
            z: -155
          },
          {
            hole: 44,
            x: -12.25,
            y: 40,
            z: -155
          },
          {
            hole: 45,
            x: -4.5,
            y: 40,
            z: -155
          },
          {
            hole: 46,
            x: 4.5,
            y: 40,
            z: -155
          },
          {
            hole: 47,
            x: 12.25,
            y: 40,
            z: -155
          },
          {
            hole: 48,
            x: 20,
            y: 40,
            z: -155
          },
          {
            hole: 49,
            x: 27.75,
            y: 40,
            z: -155
          },
          {
            hole: 50,
            x: 35.5,
            y: 40,
            z: -155
          },
          {
            hole: 51,
            x: 44.5,
            y: 40,
            z: -155
          },
          {
            hole: 52,
            x: 52.25,
            y: 40,
            z: -155
          },
          {
            hole: 53,
            x: 60,
            y: 40,
            z: -155
          },
          {
            hole: 54,
            x: 67.75,
            y: 40,
            z: -155
          },
          {
            hole: 55,
            x: 75.5,
            y: 40,
            z: -155
          },
          {
            hole: 56,
            x: 84.5,
            y: 40,
            z: -155
          },
          {
            hole: 57,
            x: 92.25,
            y: 40,
            z: -155
          },
          {
            hole: 58,
            x: 100,
            y: 40,
            z: -155
          },
          {
            hole: 59,
            x: 107.75,
            y: 40,
            z: -155
          },
          {
            hole: 60,
            x: 115.5,
            y: 40,
            z: -155
          },
          {
            hole: 61,
            x: 155,
            y: 40,
            z: -115.5
          },
          {
            hole: 62,
            x: 155,
            y: 40,
            z: -107.75
          },
          {
            hole: 63,
            x: 155,
            y: 40,
            z: -100
          },
          {
            hole: 64,
            x: 155,
            y: 40,
            z: -92.25
          },
          {
            hole: 65,
            x: 155,
            y: 40,
            z: -84.5
          },
          {
            hole: 66,
            x: 155,
            y: 40,
            z: -75.5
          },
          {
            hole: 67,
            x: 155,
            y: 40,
            z: -67.75
          },
          {
            hole: 68,
            x: 155,
            y: 40,
            z: -60
          },
          {
            hole: 69,
            x: 155,
            y: 40,
            z: -52.25
          },
          {
            hole: 70,
            x: 155,
            y: 40,
            z: -44.5
          },
          {
            hole: 71,
            x: 155,
            y: 40,
            z: -35.5
          },
          {
            hole: 72,
            x: 155,
            y: 40,
            z: -27.75
          },
          {
            hole: 73,
            x: 155,
            y: 40,
            z: -20
          },
          {
            hole: 74,
            x: 155,
            y: 40,
            z: -12.25
          },
          {
            hole: 75,
            x: 155,
            y: 40,
            z: -4.5
          },
          {
            hole: 76,
            x: 155,
            y: 40,
            z: 4.5
          },
          {
            hole: 77,
            x: 155,
            y: 40,
            z: 12.25
          },
          {
            hole: 78,
            x: 155,
            y: 40,
            z: 20
          },
          {
            hole: 79,
            x: 155,
            y: 40,
            z: 27.75
          },
          {
            hole: 80,
            x: 155,
            y: 40,
            z: 35.5
          },
          {
            hole: 81,
            x: 155,
            y: 40,
            z: 44.5
          },
          {
            hole: 82,
            x: 155,
            y: 40,
            z: 52.25
          },
          {
            hole: 83,
            x: 155,
            y: 40,
            z: 60
          },
          {
            hole: 84,
            x: 155,
            y: 40,
            z: 67.75
          },
          {
            hole: 85,
            x: 155,
            y: 40,
            z: 75.5
          },
          {
            hole: 86,
            x: 155,
            y: 40,
            z: 84.5
          },
          {
            hole: 87,
            x: 155,
            y: 40,
            z: 92.25
          },
          {
            hole: 88,
            x: 155,
            y: 40,
            z: 100
          },
          {
            hole: 89,
            x: 155,
            y: 40,
            z: 107.75
          },
          {
            hole: 90,
            x: 155,
            y: 40,
            z: 115.5
          },
          {
            hole: 91,
            x: 115.5,
            y: 40,
            z: 125
          },
          {
            hole: 92,
            x: 107.75,
            y: 40,
            z: 125
          },
          {
            hole: 93,
            x: 100,
            y: 40,
            z: 125
          },
          {
            hole: 94,
            x: 92.25,
            y: 40,
            z: 125
          },
          {
            hole: 95,
            x: 84.5,
            y: 40,
            z: 125
          },
          {
            hole: 96,
            x: 75.5,
            y: 40,
            z: 125
          },
          {
            hole: 97,
            x: 67.75,
            y: 40,
            z: 125
          },
          {
            hole: 98,
            x: 60,
            y: 40,
            z: 125
          },
          {
            hole: 99,
            x: 52.25,
            y: 40,
            z: 125
          },
          {
            hole: 100,
            x: 44.5,
            y: 40,
            z: 125
          },
          {
            hole: 101,
            x: 35.5,
            y: 40,
            z: 125
          },
          {
            hole: 102,
            x: 27.75,
            y: 40,
            z: 125
          },
          {
            hole: 103,
            x: 20,
            y: 40,
            z: 125
          },
          {
            hole: 104,
            x: 12.25,
            y: 40,
            z: 125
          },
          {
            hole: 105,
            x: 4.5,
            y: 40,
            z: 125
          },
          {
            hole: 106,
            x: -4.5,
            y: 40,
            z: 125
          },
          {
            hole: 107,
            x: -12.25,
            y: 40,
            z: 125
          },
          {
            hole: 108,
            x: -20,
            y: 40,
            z: 125
          },
          {
            hole: 109,
            x: -27.75,
            y: 40,
            z: 125
          },
          {
            hole: 110,
            x: -35.5,
            y: 40,
            z: 125
          },
          {
            hole: 111,
            x: -44.5,
            y: 40,
            z: 125
          },
          {
            hole: 112,
            x: -52.25,
            y: 40,
            z: 125
          },
          {
            hole: 113,
            x: -60,
            y: 40,
            z: 125
          },
          {
            hole: 114,
            x: -67.75,
            y: 40,
            z: 125
          },
          {
            hole: 115,
            x: -75.5,
            y: 40,
            z: 125
          },
          {
            hole: 116,
            x: -84.5,
            y: 40,
            z: 125
          },
          {
            hole: 117,
            x: -92.25,
            y: 40,
            z: 125
          },
          {
            hole: 118,
            x: -100,
            y: 40,
            z: 125
          },
          {
            hole: 119,
            x: -107.75,
            y: 40,
            z: 125
          },
          {
            hole: 120,
            x: -115.5,
            y: 40,
            z: 125
          }
        ],
        p2: [
          {
            hole: 0,
            x: -183.5858,
            y: 50,
            z: 176.5147
          },
          {
            hole: 1,
            x: -135,
            y: 40,
            z: 115.5
          },
          {
            hole: 2,
            x: -135,
            y: 40,
            z: 107.75
          },
          {
            hole: 3,
            x: -135,
            y: 40,
            z: 100
          },
          {
            hole: 4,
            x: -135,
            y: 40,
            z: 92.25
          },
          {
            hole: 5,
            x: -135,
            y: 40,
            z: 84.5
          },
          {
            hole: 6,
            x: -135,
            y: 40,
            z: 75.5
          },
          {
            hole: 7,
            x: -135,
            y: 40,
            z: 67.75
          },
          {
            hole: 8,
            x: -135,
            y: 40,
            z: 60
          },
          {
            hole: 9,
            x: -135,
            y: 40,
            z: 52.25
          },
          {
            hole: 10,
            x: -135,
            y: 40,
            z: 44.5
          },
          {
            hole: 11,
            x: -135,
            y: 40,
            z: 35.5
          },
          {
            hole: 12,
            x: -135,
            y: 40,
            z: 27.75
          },
          {
            hole: 13,
            x: -135,
            y: 40,
            z: 20
          },
          {
            hole: 14,
            x: -135,
            y: 40,
            z: 12.25
          },
          {
            hole: 15,
            x: -135,
            y: 40,
            z: 4.5
          },
          {
            hole: 16,
            x: -135,
            y: 40,
            z: -4.5
          },
          {
            hole: 17,
            x: -135,
            y: 40,
            z: -12.25
          },
          {
            hole: 18,
            x: -135,
            y: 40,
            z: -20
          },
          {
            hole: 19,
            x: -135,
            y: 40,
            z: -27.75
          },
          {
            hole: 20,
            x: -135,
            y: 40,
            z: -35.5
          },
          {
            hole: 21,
            x: -135,
            y: 40,
            z: -44.5
          },
          {
            hole: 22,
            x: -135,
            y: 40,
            z: -52.25
          },
          {
            hole: 23,
            x: -135,
            y: 40,
            z: -60
          },
          {
            hole: 24,
            x: -135,
            y: 40,
            z: -67.75
          },
          {
            hole: 25,
            x: -135,
            y: 40,
            z: -75.5
          },
          {
            hole: 26,
            x: -135,
            y: 40,
            z: -84.5
          },
          {
            hole: 27,
            x: -135,
            y: 40,
            z: -92.25
          },
          {
            hole: 28,
            x: -135,
            y: 40,
            z: -100
          },
          {
            hole: 29,
            x: -135,
            y: 40,
            z: -107.75
          },
          {
            hole: 30,
            x: -135,
            y: 40,
            z: -115.5
          },
          {
            hole: 31,
            x: -115.5,
            y: 40,
            z: -145
          },
          {
            hole: 32,
            x: -107.75,
            y: 40,
            z: -145
          },
          {
            hole: 33,
            x: -100,
            y: 40,
            z: -145
          },
          {
            hole: 34,
            x: -92.25,
            y: 40,
            z: -145
          },
          {
            hole: 35,
            x: -84.5,
            y: 40,
            z: -145
          },
          {
            hole: 36,
            x: -75.5,
            y: 40,
            z: -145
          },
          {
            hole: 37,
            x: -67.75,
            y: 40,
            z: -145
          },
          {
            hole: 38,
            x: -60,
            y: 40,
            z: -145
          },
          {
            hole: 39,
            x: -52.25,
            y: 40,
            z: -145
          },
          {
            hole: 40,
            x: -44.5,
            y: 40,
            z: -145
          },
          {
            hole: 41,
            x: -35.5,
            y: 40,
            z: -145
          },
          {
            hole: 42,
            x: -27.75,
            y: 40,
            z: -145
          },
          {
            hole: 43,
            x: -20,
            y: 40,
            z: -145
          },
          {
            hole: 44,
            x: -12.25,
            y: 40,
            z: -145
          },
          {
            hole: 45,
            x: -4.5,
            y: 40,
            z: -145
          },
          {
            hole: 46,
            x: 4.5,
            y: 40,
            z: -145
          },
          {
            hole: 47,
            x: 12.25,
            y: 40,
            z: -145
          },
          {
            hole: 48,
            x: 20,
            y: 40,
            z: -145
          },
          {
            hole: 49,
            x: 27.75,
            y: 40,
            z: -145
          },
          {
            hole: 50,
            x: 35.5,
            y: 40,
            z: -145
          },
          {
            hole: 51,
            x: 44.5,
            y: 40,
            z: -145
          },
          {
            hole: 52,
            x: 52.25,
            y: 40,
            z: -145
          },
          {
            hole: 53,
            x: 60,
            y: 40,
            z: -145
          },
          {
            hole: 54,
            x: 67.75,
            y: 40,
            z: -145
          },
          {
            hole: 55,
            x: 75.5,
            y: 40,
            z: -145
          },
          {
            hole: 56,
            x: 84.5,
            y: 40,
            z: -145
          },
          {
            hole: 57,
            x: 92.25,
            y: 40,
            z: -145
          },
          {
            hole: 58,
            x: 100,
            y: 40,
            z: -145
          },
          {
            hole: 59,
            x: 107.75,
            y: 40,
            z: -145
          },
          {
            hole: 60,
            x: 115.5,
            y: 40,
            z: -145
          },
          {
            hole: 61,
            x: 145,
            y: 40,
            z: -115.5
          },
          {
            hole: 62,
            x: 145,
            y: 40,
            z: -107.75
          },
          {
            hole: 63,
            x: 145,
            y: 40,
            z: -100
          },
          {
            hole: 64,
            x: 145,
            y: 40,
            z: -92.25
          },
          {
            hole: 65,
            x: 145,
            y: 40,
            z: -84.5
          },
          {
            hole: 66,
            x: 145,
            y: 40,
            z: -75.5
          },
          {
            hole: 67,
            x: 145,
            y: 40,
            z: -67.75
          },
          {
            hole: 68,
            x: 145,
            y: 40,
            z: -60
          },
          {
            hole: 69,
            x: 145,
            y: 40,
            z: -52.25
          },
          {
            hole: 70,
            x: 145,
            y: 40,
            z: -44.5
          },
          {
            hole: 71,
            x: 145,
            y: 40,
            z: -35.5
          },
          {
            hole: 72,
            x: 145,
            y: 40,
            z: -27.75
          },
          {
            hole: 73,
            x: 145,
            y: 40,
            z: -20
          },
          {
            hole: 74,
            x: 145,
            y: 40,
            z: -12.25
          },
          {
            hole: 75,
            x: 145,
            y: 40,
            z: -4.5
          },
          {
            hole: 76,
            x: 145,
            y: 40,
            z: 4.5
          },
          {
            hole: 77,
            x: 145,
            y: 40,
            z: 12.25
          },
          {
            hole: 78,
            x: 145,
            y: 40,
            z: 20
          },
          {
            hole: 79,
            x: 145,
            y: 40,
            z: 27.75
          },
          {
            hole: 80,
            x: 145,
            y: 40,
            z: 35.5
          },
          {
            hole: 81,
            x: 145,
            y: 40,
            z: 44.5
          },
          {
            hole: 82,
            x: 145,
            y: 40,
            z: 52.25
          },
          {
            hole: 83,
            x: 145,
            y: 40,
            z: 60
          },
          {
            hole: 84,
            x: 145,
            y: 40,
            z: 67.75
          },
          {
            hole: 85,
            x: 145,
            y: 40,
            z: 75.5
          },
          {
            hole: 86,
            x: 145,
            y: 40,
            z: 84.5
          },
          {
            hole: 87,
            x: 145,
            y: 40,
            z: 92.25
          },
          {
            hole: 88,
            x: 145,
            y: 40,
            z: 100
          },
          {
            hole: 89,
            x: 145,
            y: 40,
            z: 107.75
          },
          {
            hole: 90,
            x: 145,
            y: 40,
            z: 115.5
          },
          {
            hole: 91,
            x: 115.5,
            y: 40,
            z: 135
          },
          {
            hole: 92,
            x: 107.75,
            y: 40,
            z: 135
          },
          {
            hole: 93,
            x: 100,
            y: 40,
            z: 135
          },
          {
            hole: 94,
            x: 92.25,
            y: 40,
            z: 135
          },
          {
            hole: 95,
            x: 84.5,
            y: 40,
            z: 135
          },
          {
            hole: 96,
            x: 75.5,
            y: 40,
            z: 135
          },
          {
            hole: 97,
            x: 67.75,
            y: 40,
            z: 135
          },
          {
            hole: 98,
            x: 60,
            y: 40,
            z: 135
          },
          {
            hole: 99,
            x: 52.25,
            y: 40,
            z: 135
          },
          {
            hole: 100,
            x: 44.5,
            y: 40,
            z: 135
          },
          {
            hole: 101,
            x: 35.5,
            y: 40,
            z: 135
          },
          {
            hole: 102,
            x: 27.75,
            y: 40,
            z: 135
          },
          {
            hole: 103,
            x: 20,
            y: 40,
            z: 135
          },
          {
            hole: 104,
            x: 12.25,
            y: 40,
            z: 135
          },
          {
            hole: 105,
            x: 4.5,
            y: 40,
            z: 135
          },
          {
            hole: 106,
            x: -4.5,
            y: 40,
            z: 135
          },
          {
            hole: 107,
            x: -12.25,
            y: 40,
            z: 135
          },
          {
            hole: 108,
            x: -20,
            y: 40,
            z: 135
          },
          {
            hole: 109,
            x: -27.75,
            y: 40,
            z: 135
          },
          {
            hole: 110,
            x: -35.5,
            y: 40,
            z: 135
          },
          {
            hole: 111,
            x: -44.5,
            y: 40,
            z: 135
          },
          {
            hole: 112,
            x: -52.25,
            y: 40,
            z: 135
          },
          {
            hole: 113,
            x: -60,
            y: 40,
            z: 135
          },
          {
            hole: 114,
            x: -67.75,
            y: 40,
            z: 135
          },
          {
            hole: 115,
            x: -75.5,
            y: 40,
            z: 135
          },
          {
            hole: 116,
            x: -84.5,
            y: 40,
            z: 135
          },
          {
            hole: 117,
            x: -92.25,
            y: 40,
            z: 135
          },
          {
            hole: 118,
            x: -100,
            y: 40,
            z: 135
          },
          {
            hole: 119,
            x: -107.75,
            y: 40,
            z: 135
          },
          {
            hole: 120,
            x: -115.5,
            y: 40,
            z: 135
          }
        ],
        p3: [
          {
            hole: 0,
            x: -176.5147,
            y: 50,
            z: 183.5858
          },
          {
            hole: 1,
            x: -145,
            y: 40,
            z: 115.5
          },
          {
            hole: 2,
            x: -145,
            y: 40,
            z: 107.75
          },
          {
            hole: 3,
            x: -145,
            y: 40,
            z: 100
          },
          {
            hole: 4,
            x: -145,
            y: 40,
            z: 92.25
          },
          {
            hole: 5,
            x: -145,
            y: 40,
            z: 84.5
          },
          {
            hole: 6,
            x: -145,
            y: 40,
            z: 75.5
          },
          {
            hole: 7,
            x: -145,
            y: 40,
            z: 67.75
          },
          {
            hole: 8,
            x: -145,
            y: 40,
            z: 60
          },
          {
            hole: 9,
            x: -145,
            y: 40,
            z: 52.25
          },
          {
            hole: 10,
            x: -145,
            y: 40,
            z: 44.5
          },
          {
            hole: 11,
            x: -145,
            y: 40,
            z: 35.5
          },
          {
            hole: 12,
            x: -145,
            y: 40,
            z: 27.75
          },
          {
            hole: 13,
            x: -145,
            y: 40,
            z: 20
          },
          {
            hole: 14,
            x: -145,
            y: 40,
            z: 12.25
          },
          {
            hole: 15,
            x: -145,
            y: 40,
            z: 4.5
          },
          {
            hole: 16,
            x: -145,
            y: 40,
            z: -4.5
          },
          {
            hole: 17,
            x: -145,
            y: 40,
            z: -12.25
          },
          {
            hole: 18,
            x: -145,
            y: 40,
            z: -20
          },
          {
            hole: 19,
            x: -145,
            y: 40,
            z: -27.75
          },
          {
            hole: 20,
            x: -145,
            y: 40,
            z: -35.5
          },
          {
            hole: 21,
            x: -145,
            y: 40,
            z: -44.5
          },
          {
            hole: 22,
            x: -145,
            y: 40,
            z: -52.25
          },
          {
            hole: 23,
            x: -145,
            y: 40,
            z: -60
          },
          {
            hole: 24,
            x: -145,
            y: 40,
            z: -67.75
          },
          {
            hole: 25,
            x: -145,
            y: 40,
            z: -75.5
          },
          {
            hole: 26,
            x: -145,
            y: 40,
            z: -84.5
          },
          {
            hole: 27,
            x: -145,
            y: 40,
            z: -92.25
          },
          {
            hole: 28,
            x: -145,
            y: 40,
            z: -100
          },
          {
            hole: 29,
            x: -145,
            y: 40,
            z: -107.75
          },
          {
            hole: 30,
            x: -145,
            y: 40,
            z: -115.5
          },
          {
            hole: 31,
            x: -115.5,
            y: 40,
            z: -135
          },
          {
            hole: 32,
            x: -107.75,
            y: 40,
            z: -135
          },
          {
            hole: 33,
            x: -100,
            y: 40,
            z: -135
          },
          {
            hole: 34,
            x: -92.25,
            y: 40,
            z: -135
          },
          {
            hole: 35,
            x: -84.5,
            y: 40,
            z: -135
          },
          {
            hole: 36,
            x: -75.5,
            y: 40,
            z: -135
          },
          {
            hole: 37,
            x: -67.75,
            y: 40,
            z: -135
          },
          {
            hole: 38,
            x: -60,
            y: 40,
            z: -135
          },
          {
            hole: 39,
            x: -52.25,
            y: 40,
            z: -135
          },
          {
            hole: 40,
            x: -44.5,
            y: 40,
            z: -135
          },
          {
            hole: 41,
            x: -35.5,
            y: 40,
            z: -135
          },
          {
            hole: 42,
            x: -27.75,
            y: 40,
            z: -135
          },
          {
            hole: 43,
            x: -20,
            y: 40,
            z: -135
          },
          {
            hole: 44,
            x: -12.25,
            y: 40,
            z: -135
          },
          {
            hole: 45,
            x: -4.5,
            y: 40,
            z: -135
          },
          {
            hole: 46,
            x: 4.5,
            y: 40,
            z: -135
          },
          {
            hole: 47,
            x: 12.25,
            y: 40,
            z: -135
          },
          {
            hole: 48,
            x: 20,
            y: 40,
            z: -135
          },
          {
            hole: 49,
            x: 27.75,
            y: 40,
            z: -135
          },
          {
            hole: 50,
            x: 35.5,
            y: 40,
            z: -135
          },
          {
            hole: 51,
            x: 44.5,
            y: 40,
            z: -135
          },
          {
            hole: 52,
            x: 52.25,
            y: 40,
            z: -135
          },
          {
            hole: 53,
            x: 60,
            y: 40,
            z: -135
          },
          {
            hole: 54,
            x: 67.75,
            y: 40,
            z: -135
          },
          {
            hole: 55,
            x: 75.5,
            y: 40,
            z: -135
          },
          {
            hole: 56,
            x: 84.5,
            y: 40,
            z: -135
          },
          {
            hole: 57,
            x: 92.25,
            y: 40,
            z: -135
          },
          {
            hole: 58,
            x: 100,
            y: 40,
            z: -135
          },
          {
            hole: 59,
            x: 107.75,
            y: 40,
            z: -135
          },
          {
            hole: 60,
            x: 115.5,
            y: 40,
            z: -135
          },
          {
            hole: 61,
            x: 135,
            y: 40,
            z: -115.5
          },
          {
            hole: 62,
            x: 135,
            y: 40,
            z: -107.75
          },
          {
            hole: 63,
            x: 135,
            y: 40,
            z: -100
          },
          {
            hole: 64,
            x: 135,
            y: 40,
            z: -92.25
          },
          {
            hole: 65,
            x: 135,
            y: 40,
            z: -84.5
          },
          {
            hole: 66,
            x: 135,
            y: 40,
            z: -75.5
          },
          {
            hole: 67,
            x: 135,
            y: 40,
            z: -67.75
          },
          {
            hole: 68,
            x: 135,
            y: 40,
            z: -60
          },
          {
            hole: 69,
            x: 135,
            y: 40,
            z: -52.25
          },
          {
            hole: 70,
            x: 135,
            y: 40,
            z: -44.5
          },
          {
            hole: 71,
            x: 135,
            y: 40,
            z: -35.5
          },
          {
            hole: 72,
            x: 135,
            y: 40,
            z: -27.75
          },
          {
            hole: 73,
            x: 135,
            y: 40,
            z: -20
          },
          {
            hole: 74,
            x: 135,
            y: 40,
            z: -12.25
          },
          {
            hole: 75,
            x: 135,
            y: 40,
            z: -4.5
          },
          {
            hole: 76,
            x: 135,
            y: 40,
            z: 4.5
          },
          {
            hole: 77,
            x: 135,
            y: 40,
            z: 12.25
          },
          {
            hole: 78,
            x: 135,
            y: 40,
            z: 20
          },
          {
            hole: 79,
            x: 135,
            y: 40,
            z: 27.75
          },
          {
            hole: 80,
            x: 135,
            y: 40,
            z: 35.5
          },
          {
            hole: 81,
            x: 135,
            y: 40,
            z: 44.5
          },
          {
            hole: 82,
            x: 135,
            y: 40,
            z: 52.25
          },
          {
            hole: 83,
            x: 135,
            y: 40,
            z: 60
          },
          {
            hole: 84,
            x: 135,
            y: 40,
            z: 67.75
          },
          {
            hole: 85,
            x: 135,
            y: 40,
            z: 75.5
          },
          {
            hole: 86,
            x: 135,
            y: 40,
            z: 84.5
          },
          {
            hole: 87,
            x: 135,
            y: 40,
            z: 92.25
          },
          {
            hole: 88,
            x: 135,
            y: 40,
            z: 100
          },
          {
            hole: 89,
            x: 135,
            y: 40,
            z: 107.75
          },
          {
            hole: 90,
            x: 135,
            y: 40,
            z: 115.5
          },
          {
            hole: 91,
            x: 115.5,
            y: 40,
            z: 145
          },
          {
            hole: 92,
            x: 107.75,
            y: 40,
            z: 145
          },
          {
            hole: 93,
            x: 100,
            y: 40,
            z: 145
          },
          {
            hole: 94,
            x: 92.25,
            y: 40,
            z: 145
          },
          {
            hole: 95,
            x: 84.5,
            y: 40,
            z: 145
          },
          {
            hole: 96,
            x: 75.5,
            y: 40,
            z: 145
          },
          {
            hole: 97,
            x: 67.75,
            y: 40,
            z: 145
          },
          {
            hole: 98,
            x: 60,
            y: 40,
            z: 145
          },
          {
            hole: 99,
            x: 52.25,
            y: 40,
            z: 145
          },
          {
            hole: 100,
            x: 44.5,
            y: 40,
            z: 145
          },
          {
            hole: 101,
            x: 35.5,
            y: 40,
            z: 145
          },
          {
            hole: 102,
            x: 27.75,
            y: 40,
            z: 145
          },
          {
            hole: 103,
            x: 20,
            y: 40,
            z: 145
          },
          {
            hole: 104,
            x: 12.25,
            y: 40,
            z: 145
          },
          {
            hole: 105,
            x: 4.5,
            y: 40,
            z: 145
          },
          {
            hole: 106,
            x: -4.5,
            y: 40,
            z: 145
          },
          {
            hole: 107,
            x: -12.25,
            y: 40,
            z: 145
          },
          {
            hole: 108,
            x: -20,
            y: 40,
            z: 145
          },
          {
            hole: 109,
            x: -27.75,
            y: 40,
            z: 145
          },
          {
            hole: 110,
            x: -35.5,
            y: 40,
            z: 145
          },
          {
            hole: 111,
            x: -44.5,
            y: 40,
            z: 145
          },
          {
            hole: 112,
            x: -52.25,
            y: 40,
            z: 145
          },
          {
            hole: 113,
            x: -60,
            y: 40,
            z: 145
          },
          {
            hole: 114,
            x: -67.75,
            y: 40,
            z: 145
          },
          {
            hole: 115,
            x: -75.5,
            y: 40,
            z: 145
          },
          {
            hole: 116,
            x: -84.5,
            y: 40,
            z: 145
          },
          {
            hole: 117,
            x: -92.25,
            y: 40,
            z: 145
          },
          {
            hole: 118,
            x: -100,
            y: 40,
            z: 145
          },
          {
            hole: 119,
            x: -107.75,
            y: 40,
            z: 145
          },
          {
            hole: 120,
            x: -115.5,
            y: 40,
            z: 145
          }
        ],
        p4: [
          {
            hole: 0,
            x: -169.4436,
            y: 50,
            z: 190.6568
          },
          {
            hole: 1,
            x: -155,
            y: 40,
            z: 115.5
          },
          {
            hole: 2,
            x: -155,
            y: 40,
            z: 107.75
          },
          {
            hole: 3,
            x: -155,
            y: 40,
            z: 100
          },
          {
            hole: 4,
            x: -155,
            y: 40,
            z: 92.25
          },
          {
            hole: 5,
            x: -155,
            y: 40,
            z: 84.5
          },
          {
            hole: 6,
            x: -155,
            y: 40,
            z: 75.5
          },
          {
            hole: 7,
            x: -155,
            y: 40,
            z: 67.75
          },
          {
            hole: 8,
            x: -155,
            y: 40,
            z: 60
          },
          {
            hole: 9,
            x: -155,
            y: 40,
            z: 52.25
          },
          {
            hole: 10,
            x: -155,
            y: 40,
            z: 44.5
          },
          {
            hole: 11,
            x: -155,
            y: 40,
            z: 35.5
          },
          {
            hole: 12,
            x: -155,
            y: 40,
            z: 27.75
          },
          {
            hole: 13,
            x: -155,
            y: 40,
            z: 20
          },
          {
            hole: 14,
            x: -155,
            y: 40,
            z: 12.25
          },
          {
            hole: 15,
            x: -155,
            y: 40,
            z: 4.5
          },
          {
            hole: 16,
            x: -155,
            y: 40,
            z: -4.5
          },
          {
            hole: 17,
            x: -155,
            y: 40,
            z: -12.25
          },
          {
            hole: 18,
            x: -155,
            y: 40,
            z: -20
          },
          {
            hole: 19,
            x: -155,
            y: 40,
            z: -27.75
          },
          {
            hole: 20,
            x: -155,
            y: 40,
            z: -35.5
          },
          {
            hole: 21,
            x: -155,
            y: 40,
            z: -44.5
          },
          {
            hole: 22,
            x: -155,
            y: 40,
            z: -52.25
          },
          {
            hole: 23,
            x: -155,
            y: 40,
            z: -60
          },
          {
            hole: 24,
            x: -155,
            y: 40,
            z: -67.75
          },
          {
            hole: 25,
            x: -155,
            y: 40,
            z: -75.5
          },
          {
            hole: 26,
            x: -155,
            y: 40,
            z: -84.5
          },
          {
            hole: 27,
            x: -155,
            y: 40,
            z: -92.25
          },
          {
            hole: 28,
            x: -155,
            y: 40,
            z: -100
          },
          {
            hole: 29,
            x: -155,
            y: 40,
            z: -107.75
          },
          {
            hole: 30,
            x: -155,
            y: 40,
            z: -115.5
          },
          {
            hole: 31,
            x: -115.5,
            y: 40,
            z: -125
          },
          {
            hole: 32,
            x: -107.75,
            y: 40,
            z: -125
          },
          {
            hole: 33,
            x: -100,
            y: 40,
            z: -125
          },
          {
            hole: 34,
            x: -92.25,
            y: 40,
            z: -125
          },
          {
            hole: 35,
            x: -84.5,
            y: 40,
            z: -125
          },
          {
            hole: 36,
            x: -75.5,
            y: 40,
            z: -125
          },
          {
            hole: 37,
            x: -67.75,
            y: 40,
            z: -125
          },
          {
            hole: 38,
            x: -60,
            y: 40,
            z: -125
          },
          {
            hole: 39,
            x: -52.25,
            y: 40,
            z: -125
          },
          {
            hole: 40,
            x: -44.5,
            y: 40,
            z: -125
          },
          {
            hole: 41,
            x: -35.5,
            y: 40,
            z: -125
          },
          {
            hole: 42,
            x: -27.75,
            y: 40,
            z: -125
          },
          {
            hole: 43,
            x: -20,
            y: 40,
            z: -125
          },
          {
            hole: 44,
            x: -12.25,
            y: 40,
            z: -125
          },
          {
            hole: 45,
            x: -4.5,
            y: 40,
            z: -125
          },
          {
            hole: 46,
            x: 4.5,
            y: 40,
            z: -125
          },
          {
            hole: 47,
            x: 12.25,
            y: 40,
            z: -125
          },
          {
            hole: 48,
            x: 20,
            y: 40,
            z: -125
          },
          {
            hole: 49,
            x: 27.75,
            y: 40,
            z: -125
          },
          {
            hole: 50,
            x: 35.5,
            y: 40,
            z: -125
          },
          {
            hole: 51,
            x: 44.5,
            y: 40,
            z: -125
          },
          {
            hole: 52,
            x: 52.25,
            y: 40,
            z: -125
          },
          {
            hole: 53,
            x: 60,
            y: 40,
            z: -125
          },
          {
            hole: 54,
            x: 67.75,
            y: 40,
            z: -125
          },
          {
            hole: 55,
            x: 75.5,
            y: 40,
            z: -125
          },
          {
            hole: 56,
            x: 84.5,
            y: 40,
            z: -125
          },
          {
            hole: 57,
            x: 92.25,
            y: 40,
            z: -125
          },
          {
            hole: 58,
            x: 100,
            y: 40,
            z: -125
          },
          {
            hole: 59,
            x: 107.75,
            y: 40,
            z: -125
          },
          {
            hole: 60,
            x: 115.5,
            y: 40,
            z: -125
          },
          {
            hole: 61,
            x: 125,
            y: 40,
            z: -115.5
          },
          {
            hole: 62,
            x: 125,
            y: 40,
            z: -107.75
          },
          {
            hole: 63,
            x: 125,
            y: 40,
            z: -100
          },
          {
            hole: 64,
            x: 125,
            y: 40,
            z: -92.25
          },
          {
            hole: 65,
            x: 125,
            y: 40,
            z: -84.5
          },
          {
            hole: 66,
            x: 125,
            y: 40,
            z: -75.5
          },
          {
            hole: 67,
            x: 125,
            y: 40,
            z: -67.75
          },
          {
            hole: 68,
            x: 125,
            y: 40,
            z: -60
          },
          {
            hole: 69,
            x: 125,
            y: 40,
            z: -52.25
          },
          {
            hole: 70,
            x: 125,
            y: 40,
            z: -44.5
          },
          {
            hole: 71,
            x: 125,
            y: 40,
            z: -35.5
          },
          {
            hole: 72,
            x: 125,
            y: 40,
            z: -27.75
          },
          {
            hole: 73,
            x: 125,
            y: 40,
            z: -20
          },
          {
            hole: 74,
            x: 125,
            y: 40,
            z: -12.25
          },
          {
            hole: 75,
            x: 125,
            y: 40,
            z: -4.5
          },
          {
            hole: 76,
            x: 125,
            y: 40,
            z: 4.5
          },
          {
            hole: 77,
            x: 125,
            y: 40,
            z: 12.25
          },
          {
            hole: 78,
            x: 125,
            y: 40,
            z: 20
          },
          {
            hole: 79,
            x: 125,
            y: 40,
            z: 27.75
          },
          {
            hole: 80,
            x: 125,
            y: 40,
            z: 35.5
          },
          {
            hole: 81,
            x: 125,
            y: 40,
            z: 44.5
          },
          {
            hole: 82,
            x: 125,
            y: 40,
            z: 52.25
          },
          {
            hole: 83,
            x: 125,
            y: 40,
            z: 60
          },
          {
            hole: 84,
            x: 125,
            y: 40,
            z: 67.75
          },
          {
            hole: 85,
            x: 125,
            y: 40,
            z: 75.5
          },
          {
            hole: 86,
            x: 125,
            y: 40,
            z: 84.5
          },
          {
            hole: 87,
            x: 125,
            y: 40,
            z: 92.25
          },
          {
            hole: 88,
            x: 125,
            y: 40,
            z: 100
          },
          {
            hole: 89,
            x: 125,
            y: 40,
            z: 107.75
          },
          {
            hole: 90,
            x: 125,
            y: 40,
            z: 115.5
          },
          {
            hole: 91,
            x: 115.5,
            y: 40,
            z: 155
          },
          {
            hole: 92,
            x: 107.75,
            y: 40,
            z: 155
          },
          {
            hole: 93,
            x: 100,
            y: 40,
            z: 155
          },
          {
            hole: 94,
            x: 92.25,
            y: 40,
            z: 155
          },
          {
            hole: 95,
            x: 84.5,
            y: 40,
            z: 155
          },
          {
            hole: 96,
            x: 75.5,
            y: 40,
            z: 155
          },
          {
            hole: 97,
            x: 67.75,
            y: 40,
            z: 155
          },
          {
            hole: 98,
            x: 60,
            y: 40,
            z: 155
          },
          {
            hole: 99,
            x: 52.25,
            y: 40,
            z: 155
          },
          {
            hole: 100,
            x: 44.5,
            y: 40,
            z: 155
          },
          {
            hole: 101,
            x: 35.5,
            y: 40,
            z: 155
          },
          {
            hole: 102,
            x: 27.75,
            y: 40,
            z: 155
          },
          {
            hole: 103,
            x: 20,
            y: 40,
            z: 155
          },
          {
            hole: 104,
            x: 12.25,
            y: 40,
            z: 155
          },
          {
            hole: 105,
            x: 4.5,
            y: 40,
            z: 155
          },
          {
            hole: 106,
            x: -4.5,
            y: 40,
            z: 155
          },
          {
            hole: 107,
            x: -12.25,
            y: 40,
            z: 155
          },
          {
            hole: 108,
            x: -20,
            y: 40,
            z: 155
          },
          {
            hole: 109,
            x: -27.75,
            y: 40,
            z: 155
          },
          {
            hole: 110,
            x: -35.5,
            y: 40,
            z: 155
          },
          {
            hole: 111,
            x: -44.5,
            y: 40,
            z: 155
          },
          {
            hole: 112,
            x: -52.25,
            y: 40,
            z: 155
          },
          {
            hole: 113,
            x: -60,
            y: 40,
            z: 155
          },
          {
            hole: 114,
            x: -67.75,
            y: 40,
            z: 155
          },
          {
            hole: 115,
            x: -75.5,
            y: 40,
            z: 155
          },
          {
            hole: 116,
            x: -84.5,
            y: 40,
            z: 155
          },
          {
            hole: 117,
            x: -92.25,
            y: 40,
            z: 155
          },
          {
            hole: 118,
            x: -100,
            y: 40,
            z: 155
          },
          {
            hole: 119,
            x: -107.75,
            y: 40,
            z: 155
          },
          {
            hole: 120,
            x: -115.5,
            y: 40,
            z: 155
          }
        ]
      }
    },
    {
      id: "board-football-stadium",
      name: "Football Stadium",
      brand: "crazy,pints,adult",
      desc: "Football Stadium Cribbage 3D cribbage board (9.4 MB)",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/Stadium_-_Football_-_Crazy_-_Thumbnail.png",
      modelUrl: "https://cdn.shopify.com/3d/models/9fe4175dafce835a/Stadium_-_Football_-_Crazy.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 7,
            y: 20,
            z: 85
          },
          {
            hole: 1,
            x: 24.5,
            y: 50,
            z: 115
          },
          {
            hole: 2,
            x: 32.25,
            y: 50,
            z: 115
          },
          {
            hole: 3,
            x: 40,
            y: 50,
            z: 115
          },
          {
            hole: 4,
            x: 47.75,
            y: 50,
            z: 115
          },
          {
            hole: 5,
            x: 55.5,
            y: 50,
            z: 115
          },
          {
            hole: 6,
            x: 64.5,
            y: 50,
            z: 115
          },
          {
            hole: 7,
            x: 72.25,
            y: 50,
            z: 115
          },
          {
            hole: 8,
            x: 80,
            y: 50,
            z: 115
          },
          {
            hole: 9,
            x: 87.75,
            y: 50,
            z: 115
          },
          {
            hole: 10,
            x: 95.5,
            y: 50,
            z: 115
          },
          {
            hole: 11,
            x: 107.5214,
            y: 50,
            z: 114.7538
          },
          {
            hole: 12,
            x: 115.0105,
            y: 50,
            z: 114.0162
          },
          {
            hole: 13,
            x: 122.4354,
            y: 50,
            z: 112.7903
          },
          {
            hole: 14,
            x: 129.7642,
            y: 50,
            z: 111.0815
          },
          {
            hole: 15,
            x: 136.9655,
            y: 50,
            z: 108.897
          },
          {
            hole: 16,
            x: 150.8632,
            y: 50,
            z: 103.1404
          },
          {
            hole: 17,
            x: 157.5,
            y: 50,
            z: 99.5929
          },
          {
            hole: 18,
            x: 163.8906,
            y: 50,
            z: 95.619
          },
          {
            hole: 19,
            x: 170.0076,
            y: 50,
            z: 91.2356
          },
          {
            hole: 20,
            x: 175.8248,
            y: 50,
            z: 86.4616
          },
          {
            hole: 21,
            x: 186.4616,
            y: 50,
            z: 75.8248
          },
          {
            hole: 22,
            x: 191.2356,
            y: 50,
            z: 70.0076
          },
          {
            hole: 23,
            x: 195.619,
            y: 50,
            z: 63.8906
          },
          {
            hole: 24,
            x: 199.5929,
            y: 50,
            z: 57.5
          },
          {
            hole: 25,
            x: 203.1404,
            y: 50,
            z: 50.8632
          },
          {
            hole: 26,
            x: 208.897,
            y: 50,
            z: 36.9655
          },
          {
            hole: 27,
            x: 211.0815,
            y: 50,
            z: 29.7642
          },
          {
            hole: 28,
            x: 212.7903,
            y: 50,
            z: 22.4354
          },
          {
            hole: 29,
            x: 214.0162,
            y: 50,
            z: 15.0105
          },
          {
            hole: 30,
            x: 214.7538,
            y: 50,
            z: 7.5214
          },
          {
            hole: 31,
            x: 214.7537,
            y: 50,
            z: -7.5213
          },
          {
            hole: 32,
            x: 214.0161,
            y: 50,
            z: -15.0105
          },
          {
            hole: 33,
            x: 212.7903,
            y: 50,
            z: -22.4354
          },
          {
            hole: 34,
            x: 211.0814,
            y: 50,
            z: -29.7642
          },
          {
            hole: 35,
            x: 208.8969,
            y: 50,
            z: -36.9655
          },
          {
            hole: 36,
            x: 203.1403,
            y: 50,
            z: -50.8632
          },
          {
            hole: 37,
            x: 199.5929,
            y: 50,
            z: -57.5
          },
          {
            hole: 38,
            x: 195.619,
            y: 50,
            z: -63.8906
          },
          {
            hole: 39,
            x: 191.2356,
            y: 50,
            z: -70.0076
          },
          {
            hole: 40,
            x: 186.4615,
            y: 50,
            z: -75.8248
          },
          {
            hole: 41,
            x: 175.8248,
            y: 50,
            z: -86.4616
          },
          {
            hole: 42,
            x: 170.0076,
            y: 50,
            z: -91.2357
          },
          {
            hole: 43,
            x: 163.8906,
            y: 50,
            z: -95.619
          },
          {
            hole: 44,
            x: 157.5,
            y: 50,
            z: -99.5929
          },
          {
            hole: 45,
            x: 150.8632,
            y: 50,
            z: -103.1404
          },
          {
            hole: 46,
            x: 136.9655,
            y: 50,
            z: -108.897
          },
          {
            hole: 47,
            x: 129.7642,
            y: 50,
            z: -111.0815
          },
          {
            hole: 48,
            x: 122.4354,
            y: 50,
            z: -112.7903
          },
          {
            hole: 49,
            x: 115.0105,
            y: 50,
            z: -114.0162
          },
          {
            hole: 50,
            x: 107.5214,
            y: 50,
            z: -114.7538
          },
          {
            hole: 51,
            x: 95.5,
            y: 50,
            z: -115
          },
          {
            hole: 52,
            x: 87.75,
            y: 50,
            z: -115
          },
          {
            hole: 53,
            x: 80,
            y: 50,
            z: -115
          },
          {
            hole: 54,
            x: 72.25,
            y: 50,
            z: -115
          },
          {
            hole: 55,
            x: 64.5,
            y: 50,
            z: -115
          },
          {
            hole: 56,
            x: 55.5,
            y: 50,
            z: -115
          },
          {
            hole: 57,
            x: 47.75,
            y: 50,
            z: -115
          },
          {
            hole: 58,
            x: 40,
            y: 50,
            z: -115
          },
          {
            hole: 59,
            x: 32.25,
            y: 50,
            z: -115
          },
          {
            hole: 60,
            x: 24.5,
            y: 50,
            z: -115
          },
          {
            hole: 61,
            x: 15.5,
            y: 50,
            z: -115
          },
          {
            hole: 62,
            x: 7.75,
            y: 50,
            z: -115
          },
          {
            hole: 63,
            x: 0,
            y: 50,
            z: -115
          },
          {
            hole: 64,
            x: -7.75,
            y: 50,
            z: -115
          },
          {
            hole: 65,
            x: -15.5,
            y: 50,
            z: -115
          },
          {
            hole: 66,
            x: -24.5,
            y: 50,
            z: -115
          },
          {
            hole: 67,
            x: -32.25,
            y: 50,
            z: -115
          },
          {
            hole: 68,
            x: -40,
            y: 50,
            z: -115
          },
          {
            hole: 69,
            x: -47.75,
            y: 50,
            z: -115
          },
          {
            hole: 70,
            x: -55.5,
            y: 50,
            z: -115
          },
          {
            hole: 71,
            x: -64.4999,
            y: 50,
            z: -114.9999
          },
          {
            hole: 72,
            x: -72.2499,
            y: 50,
            z: -114.9999
          },
          {
            hole: 73,
            x: -79.9999,
            y: 50,
            z: -114.9999
          },
          {
            hole: 74,
            x: -87.7499,
            y: 50,
            z: -115
          },
          {
            hole: 75,
            x: -95.4999,
            y: 50,
            z: -115
          },
          {
            hole: 76,
            x: -107.5213,
            y: 50,
            z: -114.7538
          },
          {
            hole: 77,
            x: -115.0105,
            y: 50,
            z: -114.0162
          },
          {
            hole: 78,
            x: -122.4354,
            y: 50,
            z: -112.7903
          },
          {
            hole: 79,
            x: -129.7642,
            y: 50,
            z: -111.0815
          },
          {
            hole: 80,
            x: -136.9655,
            y: 50,
            z: -108.897
          },
          {
            hole: 81,
            x: -150.8631,
            y: 50,
            z: -103.1403
          },
          {
            hole: 82,
            x: -157.4999,
            y: 50,
            z: -99.5929
          },
          {
            hole: 83,
            x: -163.8905,
            y: 50,
            z: -95.619
          },
          {
            hole: 84,
            x: -170.0075,
            y: 50,
            z: -91.2356
          },
          {
            hole: 85,
            x: -175.8247,
            y: 50,
            z: -86.4616
          },
          {
            hole: 86,
            x: -186.4616,
            y: 50,
            z: -75.8248
          },
          {
            hole: 87,
            x: -191.2356,
            y: 50,
            z: -70.0076
          },
          {
            hole: 88,
            x: -195.619,
            y: 50,
            z: -63.8906
          },
          {
            hole: 89,
            x: -199.5929,
            y: 50,
            z: -57.5
          },
          {
            hole: 90,
            x: -203.1404,
            y: 50,
            z: -50.8632
          },
          {
            hole: 91,
            x: -208.897,
            y: 50,
            z: -36.9655
          },
          {
            hole: 92,
            x: -211.0815,
            y: 50,
            z: -29.7642
          },
          {
            hole: 93,
            x: -212.7903,
            y: 50,
            z: -22.4354
          },
          {
            hole: 94,
            x: -214.0162,
            y: 50,
            z: -15.0105
          },
          {
            hole: 95,
            x: -214.7538,
            y: 50,
            z: -7.5214
          },
          {
            hole: 96,
            x: -214.7538,
            y: 50,
            z: 7.5214
          },
          {
            hole: 97,
            x: -214.0162,
            y: 50,
            z: 15.0105
          },
          {
            hole: 98,
            x: -212.7903,
            y: 50,
            z: 22.4354
          },
          {
            hole: 99,
            x: -211.0815,
            y: 50,
            z: 29.7642
          },
          {
            hole: 100,
            x: -208.897,
            y: 50,
            z: 36.9655
          },
          {
            hole: 101,
            x: -203.1403,
            y: 50,
            z: 50.8632
          },
          {
            hole: 102,
            x: -199.5929,
            y: 50,
            z: 57.5
          },
          {
            hole: 103,
            x: -195.619,
            y: 50,
            z: 63.8906
          },
          {
            hole: 104,
            x: -191.2356,
            y: 50,
            z: 70.0076
          },
          {
            hole: 105,
            x: -186.4616,
            y: 50,
            z: 75.8248
          },
          {
            hole: 106,
            x: -175.8248,
            y: 50,
            z: 86.4615
          },
          {
            hole: 107,
            x: -170.0076,
            y: 50,
            z: 91.2356
          },
          {
            hole: 108,
            x: -163.8906,
            y: 50,
            z: 95.619
          },
          {
            hole: 109,
            x: -157.5,
            y: 50,
            z: 99.5929
          },
          {
            hole: 110,
            x: -150.8632,
            y: 50,
            z: 103.1403
          },
          {
            hole: 111,
            x: -136.9655,
            y: 50,
            z: 108.897
          },
          {
            hole: 112,
            x: -129.7642,
            y: 50,
            z: 111.0815
          },
          {
            hole: 113,
            x: -122.4354,
            y: 50,
            z: 112.7903
          },
          {
            hole: 114,
            x: -115.0105,
            y: 50,
            z: 114.0162
          },
          {
            hole: 115,
            x: -107.5214,
            y: 50,
            z: 114.7538
          },
          {
            hole: 116,
            x: -95.5,
            y: 50,
            z: 115
          },
          {
            hole: 117,
            x: -87.75,
            y: 50,
            z: 115
          },
          {
            hole: 118,
            x: -80,
            y: 50,
            z: 115
          },
          {
            hole: 119,
            x: -72.25,
            y: 50,
            z: 115
          },
          {
            hole: 120,
            x: -64.5,
            y: 50,
            z: 115
          },
          {
            hole: 121,
            x: -40,
            y: 20,
            z: 100
          }
        ],
        p2: [
          {
            hole: 0,
            x: 7,
            y: 30,
            z: 95
          },
          {
            hole: 1,
            x: 24.5,
            y: 40,
            z: 105
          },
          {
            hole: 2,
            x: 32.25,
            y: 40,
            z: 105
          },
          {
            hole: 3,
            x: 40,
            y: 40,
            z: 105
          },
          {
            hole: 4,
            x: 47.75,
            y: 40,
            z: 105
          },
          {
            hole: 5,
            x: 55.5,
            y: 40,
            z: 105
          },
          {
            hole: 6,
            x: 64.5,
            y: 40,
            z: 105
          },
          {
            hole: 7,
            x: 72.25,
            y: 40,
            z: 105
          },
          {
            hole: 8,
            x: 80,
            y: 40,
            z: 105
          },
          {
            hole: 9,
            x: 87.75,
            y: 40,
            z: 105
          },
          {
            hole: 10,
            x: 95.5,
            y: 40,
            z: 105
          },
          {
            hole: 11,
            x: 106.8673,
            y: 40,
            z: 104.7752
          },
          {
            hole: 12,
            x: 113.7052,
            y: 40,
            z: 104.1017
          },
          {
            hole: 13,
            x: 120.4845,
            y: 40,
            z: 102.9825
          },
          {
            hole: 14,
            x: 127.176,
            y: 40,
            z: 101.4222
          },
          {
            hole: 15,
            x: 133.7511,
            y: 40,
            z: 99.4277
          },
          {
            hole: 16,
            x: 146.4403,
            y: 40,
            z: 94.1716
          },
          {
            hole: 17,
            x: 152.5,
            y: 40,
            z: 90.9327
          },
          {
            hole: 18,
            x: 158.3349,
            y: 40,
            z: 87.3043
          },
          {
            hole: 19,
            x: 163.9199,
            y: 40,
            z: 83.3021
          },
          {
            hole: 20,
            x: 169.2313,
            y: 40,
            z: 78.9432
          },
          {
            hole: 21,
            x: 178.9432,
            y: 40,
            z: 69.2313
          },
          {
            hole: 22,
            x: 183.3021,
            y: 40,
            z: 63.92
          },
          {
            hole: 23,
            x: 187.3043,
            y: 40,
            z: 58.3349
          },
          {
            hole: 24,
            x: 190.9327,
            y: 40,
            z: 52.5
          },
          {
            hole: 25,
            x: 194.1716,
            y: 40,
            z: 46.4403
          },
          {
            hole: 26,
            x: 199.4277,
            y: 40,
            z: 33.7511
          },
          {
            hole: 27,
            x: 201.4222,
            y: 40,
            z: 27.176
          },
          {
            hole: 28,
            x: 202.9824,
            y: 40,
            z: 20.4845
          },
          {
            hole: 29,
            x: 204.1017,
            y: 40,
            z: 13.7052
          },
          {
            hole: 30,
            x: 204.7752,
            y: 40,
            z: 6.8673
          },
          {
            hole: 31,
            x: 204.7752,
            y: 40,
            z: -6.8673
          },
          {
            hole: 32,
            x: 204.1017,
            y: 40,
            z: -13.7052
          },
          {
            hole: 33,
            x: 202.9824,
            y: 40,
            z: -20.4845
          },
          {
            hole: 34,
            x: 201.4222,
            y: 40,
            z: -27.176
          },
          {
            hole: 35,
            x: 199.4276,
            y: 40,
            z: -33.7511
          },
          {
            hole: 36,
            x: 194.1716,
            y: 40,
            z: -46.4403
          },
          {
            hole: 37,
            x: 190.9326,
            y: 40,
            z: -52.5
          },
          {
            hole: 38,
            x: 187.3043,
            y: 40,
            z: -58.3349
          },
          {
            hole: 39,
            x: 183.3021,
            y: 40,
            z: -63.92
          },
          {
            hole: 40,
            x: 178.9431,
            y: 40,
            z: -69.2313
          },
          {
            hole: 41,
            x: 169.2313,
            y: 40,
            z: -78.9432
          },
          {
            hole: 42,
            x: 163.92,
            y: 40,
            z: -83.3021
          },
          {
            hole: 43,
            x: 158.3349,
            y: 40,
            z: -87.3043
          },
          {
            hole: 44,
            x: 152.5,
            y: 40,
            z: -90.9327
          },
          {
            hole: 45,
            x: 146.4403,
            y: 40,
            z: -94.1717
          },
          {
            hole: 46,
            x: 133.7511,
            y: 40,
            z: -99.4277
          },
          {
            hole: 47,
            x: 127.176,
            y: 40,
            z: -101.4222
          },
          {
            hole: 48,
            x: 120.4845,
            y: 40,
            z: -102.9825
          },
          {
            hole: 49,
            x: 113.7053,
            y: 40,
            z: -104.1017
          },
          {
            hole: 50,
            x: 106.8673,
            y: 40,
            z: -104.7752
          },
          {
            hole: 51,
            x: 95.5,
            y: 40,
            z: -105
          },
          {
            hole: 52,
            x: 87.75,
            y: 40,
            z: -105
          },
          {
            hole: 53,
            x: 80,
            y: 40,
            z: -105
          },
          {
            hole: 54,
            x: 72.25,
            y: 40,
            z: -105
          },
          {
            hole: 55,
            x: 64.5,
            y: 40,
            z: -105
          },
          {
            hole: 56,
            x: 55.5,
            y: 40,
            z: -105
          },
          {
            hole: 57,
            x: 47.75,
            y: 40,
            z: -105
          },
          {
            hole: 58,
            x: 40,
            y: 40,
            z: -105
          },
          {
            hole: 59,
            x: 32.25,
            y: 40,
            z: -105
          },
          {
            hole: 60,
            x: 24.5,
            y: 40,
            z: -105
          },
          {
            hole: 61,
            x: 15.5,
            y: 40,
            z: -105
          },
          {
            hole: 62,
            x: 7.75,
            y: 40,
            z: -105
          },
          {
            hole: 63,
            x: 0,
            y: 40,
            z: -105
          },
          {
            hole: 64,
            x: -7.75,
            y: 40,
            z: -105
          },
          {
            hole: 65,
            x: -15.5,
            y: 40,
            z: -105
          },
          {
            hole: 66,
            x: -24.5,
            y: 40,
            z: -105
          },
          {
            hole: 67,
            x: -32.25,
            y: 40,
            z: -105
          },
          {
            hole: 68,
            x: -40,
            y: 40,
            z: -105
          },
          {
            hole: 69,
            x: -47.75,
            y: 40,
            z: -105
          },
          {
            hole: 70,
            x: -55.5,
            y: 40,
            z: -105
          },
          {
            hole: 71,
            x: -64.4999,
            y: 40,
            z: -105
          },
          {
            hole: 72,
            x: -72.2499,
            y: 40,
            z: -105
          },
          {
            hole: 73,
            x: -79.9999,
            y: 40,
            z: -105
          },
          {
            hole: 74,
            x: -87.7499,
            y: 40,
            z: -105
          },
          {
            hole: 75,
            x: -95.4999,
            y: 40,
            z: -105
          },
          {
            hole: 76,
            x: -106.8673,
            y: 40,
            z: -104.7752
          },
          {
            hole: 77,
            x: -113.7052,
            y: 40,
            z: -104.1017
          },
          {
            hole: 78,
            x: -120.4845,
            y: 40,
            z: -102.9825
          },
          {
            hole: 79,
            x: -127.176,
            y: 40,
            z: -101.4222
          },
          {
            hole: 80,
            x: -133.7511,
            y: 40,
            z: -99.4277
          },
          {
            hole: 81,
            x: -146.4403,
            y: 40,
            z: -94.1716
          },
          {
            hole: 82,
            x: -152.4999,
            y: 40,
            z: -90.9326
          },
          {
            hole: 83,
            x: -158.3348,
            y: 40,
            z: -87.3043
          },
          {
            hole: 84,
            x: -163.9199,
            y: 40,
            z: -83.3021
          },
          {
            hole: 85,
            x: -169.2313,
            y: 40,
            z: -78.9432
          },
          {
            hole: 86,
            x: -178.9432,
            y: 40,
            z: -69.2313
          },
          {
            hole: 87,
            x: -183.3021,
            y: 40,
            z: -63.92
          },
          {
            hole: 88,
            x: -187.3043,
            y: 40,
            z: -58.3349
          },
          {
            hole: 89,
            x: -190.9327,
            y: 40,
            z: -52.5
          },
          {
            hole: 90,
            x: -194.1717,
            y: 40,
            z: -46.4403
          },
          {
            hole: 91,
            x: -199.4277,
            y: 40,
            z: -33.7511
          },
          {
            hole: 92,
            x: -201.4222,
            y: 40,
            z: -27.176
          },
          {
            hole: 93,
            x: -202.9825,
            y: 40,
            z: -20.4845
          },
          {
            hole: 94,
            x: -204.1017,
            y: 40,
            z: -13.7053
          },
          {
            hole: 95,
            x: -204.7752,
            y: 40,
            z: -6.8673
          },
          {
            hole: 96,
            x: -204.7752,
            y: 40,
            z: 6.8673
          },
          {
            hole: 97,
            x: -204.1017,
            y: 40,
            z: 13.7052
          },
          {
            hole: 98,
            x: -202.9825,
            y: 40,
            z: 20.4845
          },
          {
            hole: 99,
            x: -201.4222,
            y: 40,
            z: 27.176
          },
          {
            hole: 100,
            x: -199.4277,
            y: 40,
            z: 33.7511
          },
          {
            hole: 101,
            x: -194.1716,
            y: 40,
            z: 46.4403
          },
          {
            hole: 102,
            x: -190.9326,
            y: 40,
            z: 52.5
          },
          {
            hole: 103,
            x: -187.3043,
            y: 40,
            z: 58.3349
          },
          {
            hole: 104,
            x: -183.3021,
            y: 40,
            z: 63.9199
          },
          {
            hole: 105,
            x: -178.9432,
            y: 40,
            z: 69.2313
          },
          {
            hole: 106,
            x: -169.2313,
            y: 40,
            z: 78.9431
          },
          {
            hole: 107,
            x: -163.92,
            y: 40,
            z: 83.3021
          },
          {
            hole: 108,
            x: -158.3349,
            y: 40,
            z: 87.3043
          },
          {
            hole: 109,
            x: -152.5,
            y: 40,
            z: 90.9326
          },
          {
            hole: 110,
            x: -146.4403,
            y: 40,
            z: 94.1716
          },
          {
            hole: 111,
            x: -133.7512,
            y: 40,
            z: 99.4277
          },
          {
            hole: 112,
            x: -127.176,
            y: 40,
            z: 101.4222
          },
          {
            hole: 113,
            x: -120.4845,
            y: 40,
            z: 102.9825
          },
          {
            hole: 114,
            x: -113.7053,
            y: 40,
            z: 104.1017
          },
          {
            hole: 115,
            x: -106.8673,
            y: 40,
            z: 104.7752
          },
          {
            hole: 116,
            x: -95.5,
            y: 40,
            z: 105
          },
          {
            hole: 117,
            x: -87.75,
            y: 40,
            z: 105
          },
          {
            hole: 118,
            x: -80,
            y: 40,
            z: 105
          },
          {
            hole: 119,
            x: -72.25,
            y: 40,
            z: 105
          },
          {
            hole: 120,
            x: -64.5,
            y: 40,
            z: 105
          },
          {
            hole: 121,
            x: -40,
            y: 30,
            z: 100
          }
        ],
        p3: [
          {
            hole: 0,
            x: 7,
            y: 40,
            z: 105
          },
          {
            hole: 1,
            x: 24.5,
            y: 30,
            z: 95
          },
          {
            hole: 2,
            x: 32.25,
            y: 30,
            z: 95
          },
          {
            hole: 3,
            x: 40,
            y: 30,
            z: 95
          },
          {
            hole: 4,
            x: 47.75,
            y: 30,
            z: 95
          },
          {
            hole: 5,
            x: 55.5,
            y: 30,
            z: 95
          },
          {
            hole: 6,
            x: 64.5,
            y: 30,
            z: 95
          },
          {
            hole: 7,
            x: 72.25,
            y: 30,
            z: 95
          },
          {
            hole: 8,
            x: 80,
            y: 30,
            z: 95
          },
          {
            hole: 9,
            x: 87.75,
            y: 30,
            z: 95
          },
          {
            hole: 10,
            x: 95.5,
            y: 30,
            z: 95
          },
          {
            hole: 11,
            x: 106.2133,
            y: 30,
            z: 94.7966
          },
          {
            hole: 12,
            x: 112.4,
            y: 30,
            z: 94.1873
          },
          {
            hole: 13,
            x: 118.5336,
            y: 30,
            z: 93.1746
          },
          {
            hole: 14,
            x: 124.5878,
            y: 30,
            z: 91.763
          },
          {
            hole: 15,
            x: 130.5367,
            y: 30,
            z: 89.9584
          },
          {
            hole: 16,
            x: 142.0174,
            y: 30,
            z: 85.2029
          },
          {
            hole: 17,
            x: 147.5,
            y: 30,
            z: 82.2724
          },
          {
            hole: 18,
            x: 152.7792,
            y: 30,
            z: 78.9896
          },
          {
            hole: 19,
            x: 157.8323,
            y: 30,
            z: 75.3686
          },
          {
            hole: 20,
            x: 162.6378,
            y: 30,
            z: 71.4248
          },
          {
            hole: 21,
            x: 171.4248,
            y: 30,
            z: 62.6379
          },
          {
            hole: 22,
            x: 175.3686,
            y: 30,
            z: 57.8323
          },
          {
            hole: 23,
            x: 178.9896,
            y: 30,
            z: 52.7792
          },
          {
            hole: 24,
            x: 182.2724,
            y: 30,
            z: 47.5
          },
          {
            hole: 25,
            x: 185.2029,
            y: 30,
            z: 42.0174
          },
          {
            hole: 26,
            x: 189.9584,
            y: 30,
            z: 30.5367
          },
          {
            hole: 27,
            x: 191.7629,
            y: 30,
            z: 24.5878
          },
          {
            hole: 28,
            x: 193.1746,
            y: 30,
            z: 18.5336
          },
          {
            hole: 29,
            x: 194.1873,
            y: 30,
            z: 12.4
          },
          {
            hole: 30,
            x: 194.7966,
            y: 30,
            z: 6.2133
          },
          {
            hole: 31,
            x: 194.7966,
            y: 30,
            z: -6.2133
          },
          {
            hole: 32,
            x: 194.1872,
            y: 30,
            z: -12.4
          },
          {
            hole: 33,
            x: 193.1746,
            y: 30,
            z: -18.5336
          },
          {
            hole: 34,
            x: 191.7629,
            y: 30,
            z: -24.5878
          },
          {
            hole: 35,
            x: 189.9583,
            y: 30,
            z: -30.5367
          },
          {
            hole: 36,
            x: 185.2029,
            y: 30,
            z: -42.0174
          },
          {
            hole: 37,
            x: 182.2724,
            y: 30,
            z: -47.5
          },
          {
            hole: 38,
            x: 178.9896,
            y: 30,
            z: -52.7792
          },
          {
            hole: 39,
            x: 175.3685,
            y: 30,
            z: -57.8324
          },
          {
            hole: 40,
            x: 171.4247,
            y: 30,
            z: -62.6379
          },
          {
            hole: 41,
            x: 162.6379,
            y: 30,
            z: -71.4248
          },
          {
            hole: 42,
            x: 157.8323,
            y: 30,
            z: -75.3686
          },
          {
            hole: 43,
            x: 152.7792,
            y: 30,
            z: -78.9896
          },
          {
            hole: 44,
            x: 147.5,
            y: 30,
            z: -82.2724
          },
          {
            hole: 45,
            x: 142.0174,
            y: 30,
            z: -85.2029
          },
          {
            hole: 46,
            x: 130.5367,
            y: 30,
            z: -89.9584
          },
          {
            hole: 47,
            x: 124.5878,
            y: 30,
            z: -91.763
          },
          {
            hole: 48,
            x: 118.5336,
            y: 30,
            z: -93.1746
          },
          {
            hole: 49,
            x: 112.4,
            y: 30,
            z: -94.1873
          },
          {
            hole: 50,
            x: 106.2133,
            y: 30,
            z: -94.7966
          },
          {
            hole: 51,
            x: 95.5,
            y: 30,
            z: -95
          },
          {
            hole: 52,
            x: 87.75,
            y: 30,
            z: -95
          },
          {
            hole: 53,
            x: 80,
            y: 30,
            z: -95
          },
          {
            hole: 54,
            x: 72.25,
            y: 30,
            z: -95
          },
          {
            hole: 55,
            x: 64.5,
            y: 30,
            z: -95
          },
          {
            hole: 56,
            x: 55.5,
            y: 30,
            z: -95
          },
          {
            hole: 57,
            x: 47.75,
            y: 30,
            z: -95
          },
          {
            hole: 58,
            x: 40,
            y: 30,
            z: -95
          },
          {
            hole: 59,
            x: 32.25,
            y: 30,
            z: -95
          },
          {
            hole: 60,
            x: 24.5,
            y: 30,
            z: -95
          },
          {
            hole: 61,
            x: 15.5,
            y: 30,
            z: -95
          },
          {
            hole: 62,
            x: 7.75,
            y: 30,
            z: -95
          },
          {
            hole: 63,
            x: 0,
            y: 30,
            z: -95
          },
          {
            hole: 64,
            x: -7.75,
            y: 30,
            z: -95
          },
          {
            hole: 65,
            x: -15.5,
            y: 30,
            z: -95
          },
          {
            hole: 66,
            x: -24.5,
            y: 30,
            z: -95
          },
          {
            hole: 67,
            x: -32.25,
            y: 30,
            z: -95
          },
          {
            hole: 68,
            x: -40,
            y: 30,
            z: -95
          },
          {
            hole: 69,
            x: -47.75,
            y: 30,
            z: -95
          },
          {
            hole: 70,
            x: -55.5,
            y: 30,
            z: -95
          },
          {
            hole: 71,
            x: -64.4999,
            y: 30,
            z: -95
          },
          {
            hole: 72,
            x: -72.2499,
            y: 30,
            z: -95
          },
          {
            hole: 73,
            x: -79.9999,
            y: 30,
            z: -95
          },
          {
            hole: 74,
            x: -87.7499,
            y: 30,
            z: -95
          },
          {
            hole: 75,
            x: -95.4999,
            y: 30,
            z: -95
          },
          {
            hole: 76,
            x: -106.2133,
            y: 30,
            z: -94.7966
          },
          {
            hole: 77,
            x: -112.4,
            y: 30,
            z: -94.1873
          },
          {
            hole: 78,
            x: -118.5336,
            y: 30,
            z: -93.1746
          },
          {
            hole: 79,
            x: -124.5878,
            y: 30,
            z: -91.763
          },
          {
            hole: 80,
            x: -130.5367,
            y: 30,
            z: -89.9584
          },
          {
            hole: 81,
            x: -142.0174,
            y: 30,
            z: -85.2029
          },
          {
            hole: 82,
            x: -147.4999,
            y: 30,
            z: -82.2724
          },
          {
            hole: 83,
            x: -152.7791,
            y: 30,
            z: -78.9896
          },
          {
            hole: 84,
            x: -157.8323,
            y: 30,
            z: -75.3685
          },
          {
            hole: 85,
            x: -162.6378,
            y: 30,
            z: -71.4248
          },
          {
            hole: 86,
            x: -171.4248,
            y: 30,
            z: -62.6379
          },
          {
            hole: 87,
            x: -175.3686,
            y: 30,
            z: -57.8324
          },
          {
            hole: 88,
            x: -178.9896,
            y: 30,
            z: -52.7792
          },
          {
            hole: 89,
            x: -182.2724,
            y: 30,
            z: -47.5
          },
          {
            hole: 90,
            x: -185.2029,
            y: 30,
            z: -42.0174
          },
          {
            hole: 91,
            x: -189.9584,
            y: 30,
            z: -30.5368
          },
          {
            hole: 92,
            x: -191.763,
            y: 30,
            z: -24.5878
          },
          {
            hole: 93,
            x: -193.1746,
            y: 30,
            z: -18.5336
          },
          {
            hole: 94,
            x: -194.1873,
            y: 30,
            z: -12.4
          },
          {
            hole: 95,
            x: -194.7966,
            y: 30,
            z: -6.2133
          },
          {
            hole: 96,
            x: -194.7966,
            y: 30,
            z: 6.2133
          },
          {
            hole: 97,
            x: -194.1873,
            y: 30,
            z: 12.4
          },
          {
            hole: 98,
            x: -193.1746,
            y: 30,
            z: 18.5336
          },
          {
            hole: 99,
            x: -191.763,
            y: 30,
            z: 24.5878
          },
          {
            hole: 100,
            x: -189.9584,
            y: 30,
            z: 30.5367
          },
          {
            hole: 101,
            x: -185.2029,
            y: 30,
            z: 42.0174
          },
          {
            hole: 102,
            x: -182.2724,
            y: 30,
            z: 47.5
          },
          {
            hole: 103,
            x: -178.9896,
            y: 30,
            z: 52.7792
          },
          {
            hole: 104,
            x: -175.3685,
            y: 30,
            z: 57.8323
          },
          {
            hole: 105,
            x: -171.4248,
            y: 30,
            z: 62.6378
          },
          {
            hole: 106,
            x: -162.6379,
            y: 30,
            z: 71.4247
          },
          {
            hole: 107,
            x: -157.8323,
            y: 30,
            z: 75.3685
          },
          {
            hole: 108,
            x: -152.7792,
            y: 30,
            z: 78.9896
          },
          {
            hole: 109,
            x: -147.5,
            y: 30,
            z: 82.2724
          },
          {
            hole: 110,
            x: -142.0174,
            y: 30,
            z: 85.2029
          },
          {
            hole: 111,
            x: -130.5368,
            y: 30,
            z: 89.9584
          },
          {
            hole: 112,
            x: -124.5878,
            y: 30,
            z: 91.763
          },
          {
            hole: 113,
            x: -118.5336,
            y: 30,
            z: 93.1746
          },
          {
            hole: 114,
            x: -112.4,
            y: 30,
            z: 94.1873
          },
          {
            hole: 115,
            x: -106.2133,
            y: 30,
            z: 94.7966
          },
          {
            hole: 116,
            x: -95.5,
            y: 30,
            z: 95
          },
          {
            hole: 117,
            x: -87.75,
            y: 30,
            z: 95
          },
          {
            hole: 118,
            x: -80,
            y: 30,
            z: 95
          },
          {
            hole: 119,
            x: -72.25,
            y: 30,
            z: 95
          },
          {
            hole: 120,
            x: -64.5,
            y: 30,
            z: 95
          },
          {
            hole: 121,
            x: -40,
            y: 40,
            z: 100
          }
        ],
        p4: [
          {
            hole: 0,
            x: 7,
            y: 50,
            z: 115
          },
          {
            hole: 1,
            x: 24.5,
            y: 20,
            z: 85
          },
          {
            hole: 2,
            x: 32.25,
            y: 20,
            z: 85
          },
          {
            hole: 3,
            x: 40,
            y: 20,
            z: 85
          },
          {
            hole: 4,
            x: 47.75,
            y: 20,
            z: 85
          },
          {
            hole: 5,
            x: 55.5,
            y: 20,
            z: 85
          },
          {
            hole: 6,
            x: 64.5,
            y: 20,
            z: 85
          },
          {
            hole: 7,
            x: 72.25,
            y: 20,
            z: 85
          },
          {
            hole: 8,
            x: 80,
            y: 20,
            z: 85
          },
          {
            hole: 9,
            x: 87.75,
            y: 20,
            z: 85
          },
          {
            hole: 10,
            x: 95.5,
            y: 20,
            z: 85
          },
          {
            hole: 11,
            x: 105.5593,
            y: 20,
            z: 84.818
          },
          {
            hole: 12,
            x: 111.0947,
            y: 20,
            z: 84.2728
          },
          {
            hole: 13,
            x: 116.5827,
            y: 20,
            z: 83.3668
          },
          {
            hole: 14,
            x: 121.9996,
            y: 20,
            z: 82.1037
          },
          {
            hole: 15,
            x: 127.3224,
            y: 20,
            z: 80.4891
          },
          {
            hole: 16,
            x: 137.5945,
            y: 20,
            z: 76.2342
          },
          {
            hole: 17,
            x: 142.5,
            y: 20,
            z: 73.6122
          },
          {
            hole: 18,
            x: 147.2235,
            y: 20,
            z: 70.6749
          },
          {
            hole: 19,
            x: 151.7447,
            y: 20,
            z: 67.435
          },
          {
            hole: 20,
            x: 156.0444,
            y: 20,
            z: 63.9064
          },
          {
            hole: 21,
            x: 163.9064,
            y: 20,
            z: 56.0444
          },
          {
            hole: 22,
            x: 167.435,
            y: 20,
            z: 51.7447
          },
          {
            hole: 23,
            x: 170.6749,
            y: 20,
            z: 47.2235
          },
          {
            hole: 24,
            x: 173.6122,
            y: 20,
            z: 42.5
          },
          {
            hole: 25,
            x: 176.2342,
            y: 20,
            z: 37.5945
          },
          {
            hole: 26,
            x: 180.4891,
            y: 20,
            z: 27.3223
          },
          {
            hole: 27,
            x: 182.1037,
            y: 20,
            z: 21.9996
          },
          {
            hole: 28,
            x: 183.3667,
            y: 20,
            z: 16.5827
          },
          {
            hole: 29,
            x: 184.2728,
            y: 20,
            z: 11.0947
          },
          {
            hole: 30,
            x: 184.818,
            y: 20,
            z: 5.5593
          },
          {
            hole: 31,
            x: 184.818,
            y: 20,
            z: -5.5593
          },
          {
            hole: 32,
            x: 184.2728,
            y: 20,
            z: -11.0947
          },
          {
            hole: 33,
            x: 183.3667,
            y: 20,
            z: -16.5827
          },
          {
            hole: 34,
            x: 182.1037,
            y: 20,
            z: -21.9996
          },
          {
            hole: 35,
            x: 180.489,
            y: 20,
            z: -27.3223
          },
          {
            hole: 36,
            x: 176.2341,
            y: 20,
            z: -37.5946
          },
          {
            hole: 37,
            x: 173.6121,
            y: 20,
            z: -42.5
          },
          {
            hole: 38,
            x: 170.6749,
            y: 20,
            z: -47.2235
          },
          {
            hole: 39,
            x: 167.435,
            y: 20,
            z: -51.7447
          },
          {
            hole: 40,
            x: 163.9063,
            y: 20,
            z: -56.0444
          },
          {
            hole: 41,
            x: 156.0444,
            y: 20,
            z: -63.9064
          },
          {
            hole: 42,
            x: 151.7447,
            y: 20,
            z: -67.4351
          },
          {
            hole: 43,
            x: 147.2235,
            y: 20,
            z: -70.6749
          },
          {
            hole: 44,
            x: 142.5,
            y: 20,
            z: -73.6122
          },
          {
            hole: 45,
            x: 137.5945,
            y: 20,
            z: -76.2342
          },
          {
            hole: 46,
            x: 127.3224,
            y: 20,
            z: -80.4891
          },
          {
            hole: 47,
            x: 121.9996,
            y: 20,
            z: -82.1037
          },
          {
            hole: 48,
            x: 116.5827,
            y: 20,
            z: -83.3668
          },
          {
            hole: 49,
            x: 111.0947,
            y: 20,
            z: -84.2728
          },
          {
            hole: 50,
            x: 105.5593,
            y: 20,
            z: -84.818
          },
          {
            hole: 51,
            x: 95.5,
            y: 20,
            z: -85
          },
          {
            hole: 52,
            x: 87.75,
            y: 20,
            z: -85
          },
          {
            hole: 53,
            x: 80,
            y: 20,
            z: -85
          },
          {
            hole: 54,
            x: 72.25,
            y: 20,
            z: -85
          },
          {
            hole: 55,
            x: 64.5,
            y: 20,
            z: -85
          },
          {
            hole: 56,
            x: 55.5,
            y: 20,
            z: -85
          },
          {
            hole: 57,
            x: 47.75,
            y: 20,
            z: -85
          },
          {
            hole: 58,
            x: 40,
            y: 20,
            z: -85
          },
          {
            hole: 59,
            x: 32.25,
            y: 20,
            z: -85
          },
          {
            hole: 60,
            x: 24.5,
            y: 20,
            z: -85
          },
          {
            hole: 61,
            x: 15.5,
            y: 20,
            z: -85
          },
          {
            hole: 62,
            x: 7.75,
            y: 20,
            z: -85
          },
          {
            hole: 63,
            x: 0,
            y: 20,
            z: -85
          },
          {
            hole: 64,
            x: -7.75,
            y: 20,
            z: -85
          },
          {
            hole: 65,
            x: -15.5,
            y: 20,
            z: -85
          },
          {
            hole: 66,
            x: -24.5,
            y: 20,
            z: -85
          },
          {
            hole: 67,
            x: -32.25,
            y: 20,
            z: -85
          },
          {
            hole: 68,
            x: -40,
            y: 20,
            z: -85
          },
          {
            hole: 69,
            x: -47.75,
            y: 20,
            z: -85
          },
          {
            hole: 70,
            x: -55.5,
            y: 20,
            z: -85
          },
          {
            hole: 71,
            x: -64.4999,
            y: 20,
            z: -85
          },
          {
            hole: 72,
            x: -72.2499,
            y: 20,
            z: -85
          },
          {
            hole: 73,
            x: -79.9999,
            y: 20,
            z: -85
          },
          {
            hole: 74,
            x: -87.7499,
            y: 20,
            z: -85
          },
          {
            hole: 75,
            x: -95.4999,
            y: 20,
            z: -85
          },
          {
            hole: 76,
            x: -105.5593,
            y: 20,
            z: -84.818
          },
          {
            hole: 77,
            x: -111.0947,
            y: 20,
            z: -84.2728
          },
          {
            hole: 78,
            x: -116.5827,
            y: 20,
            z: -83.3668
          },
          {
            hole: 79,
            x: -121.9996,
            y: 20,
            z: -82.1037
          },
          {
            hole: 80,
            x: -127.3223,
            y: 20,
            z: -80.4891
          },
          {
            hole: 81,
            x: -137.5945,
            y: 20,
            z: -76.2342
          },
          {
            hole: 82,
            x: -142.4999,
            y: 20,
            z: -73.6121
          },
          {
            hole: 83,
            x: -147.2234,
            y: 20,
            z: -70.6749
          },
          {
            hole: 84,
            x: -151.7447,
            y: 20,
            z: -67.435
          },
          {
            hole: 85,
            x: -156.0443,
            y: 20,
            z: -63.9064
          },
          {
            hole: 86,
            x: -163.9064,
            y: 20,
            z: -56.0444
          },
          {
            hole: 87,
            x: -167.435,
            y: 20,
            z: -51.7447
          },
          {
            hole: 88,
            x: -170.6749,
            y: 20,
            z: -47.2235
          },
          {
            hole: 89,
            x: -173.6122,
            y: 20,
            z: -42.5
          },
          {
            hole: 90,
            x: -176.2342,
            y: 20,
            z: -37.5946
          },
          {
            hole: 91,
            x: -180.4891,
            y: 20,
            z: -27.3224
          },
          {
            hole: 92,
            x: -182.1037,
            y: 20,
            z: -21.9996
          },
          {
            hole: 93,
            x: -183.3667,
            y: 20,
            z: -16.5827
          },
          {
            hole: 94,
            x: -184.2728,
            y: 20,
            z: -11.0947
          },
          {
            hole: 95,
            x: -184.818,
            y: 20,
            z: -5.5593
          },
          {
            hole: 96,
            x: -184.818,
            y: 20,
            z: 5.5593
          },
          {
            hole: 97,
            x: -184.2728,
            y: 20,
            z: 11.0947
          },
          {
            hole: 98,
            x: -183.3668,
            y: 20,
            z: 16.5827
          },
          {
            hole: 99,
            x: -182.1037,
            y: 20,
            z: 21.9996
          },
          {
            hole: 100,
            x: -180.4891,
            y: 20,
            z: 27.3223
          },
          {
            hole: 101,
            x: -176.2342,
            y: 20,
            z: 37.5945
          },
          {
            hole: 102,
            x: -173.6121,
            y: 20,
            z: 42.5
          },
          {
            hole: 103,
            x: -170.6749,
            y: 20,
            z: 47.2235
          },
          {
            hole: 104,
            x: -167.435,
            y: 20,
            z: 51.7447
          },
          {
            hole: 105,
            x: -163.9064,
            y: 20,
            z: 56.0444
          },
          {
            hole: 106,
            x: -156.0444,
            y: 20,
            z: 63.9063
          },
          {
            hole: 107,
            x: -151.7447,
            y: 20,
            z: 67.435
          },
          {
            hole: 108,
            x: -147.2235,
            y: 20,
            z: 70.6749
          },
          {
            hole: 109,
            x: -142.5,
            y: 20,
            z: 73.6121
          },
          {
            hole: 110,
            x: -137.5945,
            y: 20,
            z: 76.2341
          },
          {
            hole: 111,
            x: -127.3224,
            y: 20,
            z: 80.4891
          },
          {
            hole: 112,
            x: -121.9996,
            y: 20,
            z: 82.1037
          },
          {
            hole: 113,
            x: -116.5827,
            y: 20,
            z: 83.3667
          },
          {
            hole: 114,
            x: -111.0947,
            y: 20,
            z: 84.2728
          },
          {
            hole: 115,
            x: -105.5593,
            y: 20,
            z: 84.818
          },
          {
            hole: 116,
            x: -95.5,
            y: 20,
            z: 85
          },
          {
            hole: 117,
            x: -87.75,
            y: 20,
            z: 85
          },
          {
            hole: 118,
            x: -80,
            y: 20,
            z: 85
          },
          {
            hole: 119,
            x: -72.25,
            y: 20,
            z: 85
          },
          {
            hole: 120,
            x: -64.5,
            y: 20,
            z: 85
          },
          {
            hole: 121,
            x: -40,
            y: 50,
            z: 100
          }
        ]
      }
    },
    {
      id: "board-hockey-rink",
      name: "Hockey Rink",
      brand: "crazy,pints,adult",
      desc: "Hockey Rink Cribbage 3D cribbage board (8.8 MB)",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/hockey_rink_thumbnail.png?v=1792022321",
      modelUrl: "https://cdn.shopify.com/3d/models/35db708682e15a0f/hockey_rink.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 29.5,
            y: 30,
            z: 82.3246
          },
          {
            hole: 1,
            x: 47,
            y: 60,
            z: 112.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 5,
            x: 78,
            y: 60,
            z: 112.5
          },
          {
            hole: 6,
            x: 90.0213,
            y: 60,
            z: 112.2538
          },
          {
            hole: 7,
            x: 97.5105,
            y: 60,
            z: 111.5162
          },
          {
            hole: 8,
            x: 104.9354,
            y: 60,
            z: 110.2903
          },
          {
            hole: 9,
            x: 112.2642,
            y: 60,
            z: 108.5815
          },
          {
            hole: 10,
            x: 119.4655,
            y: 60,
            z: 106.397
          },
          {
            hole: 11,
            x: 133.3631,
            y: 60,
            z: 100.6404
          },
          {
            hole: 12,
            x: 139.9999,
            y: 60,
            z: 97.0929
          },
          {
            hole: 13,
            x: 146.3905,
            y: 60,
            z: 93.119
          },
          {
            hole: 14,
            x: 152.5075,
            y: 60,
            z: 88.7356
          },
          {
            hole: 15,
            x: 158.3247,
            y: 60,
            z: 83.9616
          },
          {
            hole: 16,
            x: 168.9614,
            y: 60,
            z: 73.3247
          },
          {
            hole: 17,
            x: 173.7355,
            y: 60,
            z: 67.5075
          },
          {
            hole: 18,
            x: 178.1189,
            y: 60,
            z: 61.3905
          },
          {
            hole: 19,
            x: 182.0928,
            y: 60,
            z: 55
          },
          {
            hole: 20,
            x: 185.6402,
            y: 60,
            z: 48.3632
          },
          {
            hole: 21,
            x: 191.397,
            y: 60,
            z: 34.4655
          },
          {
            hole: 22,
            x: 193.5815,
            y: 60,
            z: 27.2642
          },
          {
            hole: 23,
            x: 195.2903,
            y: 60,
            z: 19.9354
          },
          {
            hole: 24,
            x: 196.5162,
            y: 60,
            z: 12.5105
          },
          {
            hole: 25,
            x: 197.2538,
            y: 60,
            z: 5.0214
          },
          {
            hole: 26,
            x: 197.2538,
            y: 60,
            z: -10.0214
          },
          {
            hole: 27,
            x: 196.5162,
            y: 60,
            z: -17.5105
          },
          {
            hole: 28,
            x: 195.2903,
            y: 60,
            z: -24.9354
          },
          {
            hole: 29,
            x: 193.5815,
            y: 60,
            z: -32.2642
          },
          {
            hole: 30,
            x: 191.397,
            y: 60,
            z: -39.4655
          },
          {
            hole: 31,
            x: 185.6403,
            y: 60,
            z: -53.3632
          },
          {
            hole: 32,
            x: 182.0929,
            y: 60,
            z: -60
          },
          {
            hole: 33,
            x: 178.119,
            y: 60,
            z: -66.3906
          },
          {
            hole: 34,
            x: 173.7356,
            y: 60,
            z: -72.5076
          },
          {
            hole: 35,
            x: 168.9615,
            y: 60,
            z: -78.3248
          },
          {
            hole: 36,
            x: 158.3247,
            y: 60,
            z: -88.9616
          },
          {
            hole: 37,
            x: 152.5075,
            y: 60,
            z: -93.7356
          },
          {
            hole: 38,
            x: 146.3905,
            y: 60,
            z: -98.119
          },
          {
            hole: 39,
            x: 140,
            y: 60,
            z: -102.0929
          },
          {
            hole: 40,
            x: 133.3632,
            y: 60,
            z: -105.6404
          },
          {
            hole: 41,
            x: 119.4655,
            y: 60,
            z: -111.397
          },
          {
            hole: 42,
            x: 112.2642,
            y: 60,
            z: -113.5815
          },
          {
            hole: 43,
            x: 104.9354,
            y: 60,
            z: -115.2903
          },
          {
            hole: 44,
            x: 97.5105,
            y: 60,
            z: -116.5162
          },
          {
            hole: 45,
            x: 90.0214,
            y: 60,
            z: -117.2538
          },
          {
            hole: 46,
            x: 78,
            y: 60,
            z: -117.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 50,
            x: 47,
            y: 60,
            z: -117.5
          },
          {
            hole: 51,
            x: 38,
            y: 60,
            z: -117.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 55,
            x: 7,
            y: 60,
            z: -117.5
          },
          {
            hole: 56,
            x: -2,
            y: 60,
            z: -117.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 60,
            x: -33,
            y: 60,
            z: -117.5
          },
          {
            hole: 61,
            x: -42,
            y: 60,
            z: -117.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 65,
            x: -73,
            y: 60,
            z: -117.5
          },
          {
            hole: 66,
            x: -82,
            y: 60,
            z: -117.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 70,
            x: -113,
            y: 60,
            z: -117.5
          },
          {
            hole: 71,
            x: -125.0214,
            y: 60,
            z: -117.2538
          },
          {
            hole: 72,
            x: -132.5105,
            y: 60,
            z: -116.5161
          },
          {
            hole: 73,
            x: -139.9354,
            y: 60,
            z: -115.2903
          },
          {
            hole: 74,
            x: -147.2642,
            y: 60,
            z: -113.5815
          },
          {
            hole: 75,
            x: -154.4655,
            y: 60,
            z: -111.3969
          },
          {
            hole: 76,
            x: -168.3632,
            y: 60,
            z: -105.6403
          },
          {
            hole: 77,
            x: -175,
            y: 60,
            z: -102.0929
          },
          {
            hole: 78,
            x: -181.3906,
            y: 60,
            z: -98.119
          },
          {
            hole: 79,
            x: -187.5075,
            y: 60,
            z: -93.7356
          },
          {
            hole: 80,
            x: -193.3247,
            y: 60,
            z: -88.9616
          },
          {
            hole: 81,
            x: -203.9616,
            y: 60,
            z: -78.3248
          },
          {
            hole: 82,
            x: -208.7356,
            y: 60,
            z: -72.5076
          },
          {
            hole: 83,
            x: -213.119,
            y: 60,
            z: -66.3906
          },
          {
            hole: 84,
            x: -217.0929,
            y: 60,
            z: -60
          },
          {
            hole: 85,
            x: -220.6404,
            y: 60,
            z: -53.3632
          },
          {
            hole: 86,
            x: -226.397,
            y: 60,
            z: -39.4655
          },
          {
            hole: 87,
            x: -228.5815,
            y: 60,
            z: -32.2642
          },
          {
            hole: 88,
            x: -230.2903,
            y: 60,
            z: -24.9354
          },
          {
            hole: 89,
            x: -231.5162,
            y: 60,
            z: -17.5105
          },
          {
            hole: 90,
            x: -232.2538,
            y: 60,
            z: -10.0214
          },
          {
            hole: 91,
            x: -232.2538,
            y: 60,
            z: 5.0214
          },
          {
            hole: 92,
            x: -231.5162,
            y: 60,
            z: 12.5105
          },
          {
            hole: 93,
            x: -230.2903,
            y: 60,
            z: 19.9354
          },
          {
            hole: 94,
            x: -228.5815,
            y: 60,
            z: 27.2642
          },
          {
            hole: 95,
            x: -226.397,
            y: 60,
            z: 34.4655
          },
          {
            hole: 96,
            x: -220.6404,
            y: 60,
            z: 48.3633
          },
          {
            hole: 97,
            x: -217.0929,
            y: 60,
            z: 55.0001
          },
          {
            hole: 98,
            x: -213.119,
            y: 60,
            z: 61.3906
          },
          {
            hole: 99,
            x: -208.7356,
            y: 60,
            z: 67.5076
          },
          {
            hole: 100,
            x: -203.9616,
            y: 60,
            z: 73.3248
          },
          {
            hole: 101,
            x: -193.3248,
            y: 60,
            z: 83.9616
          },
          {
            hole: 102,
            x: -187.5076,
            y: 60,
            z: 88.7357
          },
          {
            hole: 103,
            x: -181.3906,
            y: 60,
            z: 93.119
          },
          {
            hole: 104,
            x: -175,
            y: 60,
            z: 97.0929
          },
          {
            hole: 105,
            x: -168.3632,
            y: 60,
            z: 100.6404
          },
          {
            hole: 106,
            x: -154.4655,
            y: 60,
            z: 106.397
          },
          {
            hole: 107,
            x: -147.2642,
            y: 60,
            z: 108.5815
          },
          {
            hole: 108,
            x: -139.9354,
            y: 60,
            z: 110.2903
          },
          {
            hole: 109,
            x: -132.5105,
            y: 60,
            z: 111.5162
          },
          {
            hole: 110,
            x: -125.0214,
            y: 60,
            z: 112.2538
          },
          {
            hole: 111,
            x: -113,
            y: 60,
            z: 112.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 115,
            x: -82,
            y: 60,
            z: 112.5
          },
          {
            hole: 116,
            x: -73,
            y: 60,
            z: 112.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 120,
            x: -42,
            y: 60,
            z: 112.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 60,
            z: 112.5
          }
        ],
        p2: [
          {
            hole: 0,
            x: 29.5,
            y: 40,
            z: 92.3246
          },
          {
            hole: 1,
            x: 47,
            y: 50,
            z: 102.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 5,
            x: 78,
            y: 50,
            z: 102.5
          },
          {
            hole: 6,
            x: 89.3673,
            y: 50,
            z: 102.2752
          },
          {
            hole: 7,
            x: 96.2052,
            y: 50,
            z: 101.6017
          },
          {
            hole: 8,
            x: 102.9845,
            y: 50,
            z: 100.4825
          },
          {
            hole: 9,
            x: 109.676,
            y: 50,
            z: 98.9222
          },
          {
            hole: 10,
            x: 116.2511,
            y: 50,
            z: 96.9277
          },
          {
            hole: 11,
            x: 128.9403,
            y: 50,
            z: 91.6716
          },
          {
            hole: 12,
            x: 134.9999,
            y: 50,
            z: 88.4327
          },
          {
            hole: 13,
            x: 140.8348,
            y: 50,
            z: 84.8043
          },
          {
            hole: 14,
            x: 146.4199,
            y: 50,
            z: 80.8021
          },
          {
            hole: 15,
            x: 151.7313,
            y: 50,
            z: 76.4432
          },
          {
            hole: 16,
            x: 161.443,
            y: 50,
            z: 66.7313
          },
          {
            hole: 17,
            x: 165.802,
            y: 50,
            z: 61.4199
          },
          {
            hole: 18,
            x: 169.8042,
            y: 50,
            z: 55.8348
          },
          {
            hole: 19,
            x: 173.4325,
            y: 50,
            z: 50
          },
          {
            hole: 20,
            x: 176.6715,
            y: 50,
            z: 43.9403
          },
          {
            hole: 21,
            x: 181.9277,
            y: 50,
            z: 31.2512
          },
          {
            hole: 22,
            x: 183.9222,
            y: 50,
            z: 24.676
          },
          {
            hole: 23,
            x: 185.4825,
            y: 50,
            z: 17.9845
          },
          {
            hole: 24,
            x: 186.6017,
            y: 50,
            z: 11.2053
          },
          {
            hole: 25,
            x: 187.2752,
            y: 50,
            z: 4.3673
          },
          {
            hole: 26,
            x: 187.2752,
            y: 50,
            z: -9.3673
          },
          {
            hole: 27,
            x: 186.6017,
            y: 50,
            z: -16.2052
          },
          {
            hole: 28,
            x: 185.4825,
            y: 50,
            z: -22.9845
          },
          {
            hole: 29,
            x: 183.9222,
            y: 50,
            z: -29.676
          },
          {
            hole: 30,
            x: 181.9277,
            y: 50,
            z: -36.2511
          },
          {
            hole: 31,
            x: 176.6716,
            y: 50,
            z: -48.9403
          },
          {
            hole: 32,
            x: 173.4326,
            y: 50,
            z: -55
          },
          {
            hole: 33,
            x: 169.8043,
            y: 50,
            z: -60.8349
          },
          {
            hole: 34,
            x: 165.8021,
            y: 50,
            z: -66.4199
          },
          {
            hole: 35,
            x: 161.4431,
            y: 50,
            z: -71.7313
          },
          {
            hole: 36,
            x: 151.7313,
            y: 50,
            z: -81.4432
          },
          {
            hole: 37,
            x: 146.4199,
            y: 50,
            z: -85.8021
          },
          {
            hole: 38,
            x: 140.8348,
            y: 50,
            z: -89.8043
          },
          {
            hole: 39,
            x: 135,
            y: 50,
            z: -93.4327
          },
          {
            hole: 40,
            x: 128.9403,
            y: 50,
            z: -96.6716
          },
          {
            hole: 41,
            x: 116.2511,
            y: 50,
            z: -101.9277
          },
          {
            hole: 42,
            x: 109.676,
            y: 50,
            z: -103.9222
          },
          {
            hole: 43,
            x: 102.9845,
            y: 50,
            z: -105.4825
          },
          {
            hole: 44,
            x: 96.2053,
            y: 50,
            z: -106.6017
          },
          {
            hole: 45,
            x: 89.3673,
            y: 50,
            z: -107.2752
          },
          {
            hole: 46,
            x: 78,
            y: 50,
            z: -107.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 50,
            x: 47,
            y: 50,
            z: -107.5
          },
          {
            hole: 51,
            x: 38,
            y: 50,
            z: -107.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 55,
            x: 7,
            y: 50,
            z: -107.5
          },
          {
            hole: 56,
            x: -2,
            y: 50,
            z: -107.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 60,
            x: -33,
            y: 50,
            z: -107.5
          },
          {
            hole: 61,
            x: -42,
            y: 50,
            z: -107.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 65,
            x: -73,
            y: 50,
            z: -107.5
          },
          {
            hole: 66,
            x: -82,
            y: 50,
            z: -107.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 70,
            x: -113,
            y: 50,
            z: -107.5
          },
          {
            hole: 71,
            x: -124.3673,
            y: 50,
            z: -107.2752
          },
          {
            hole: 72,
            x: -131.2052,
            y: 50,
            z: -106.6017
          },
          {
            hole: 73,
            x: -137.9845,
            y: 50,
            z: -105.4824
          },
          {
            hole: 74,
            x: -144.676,
            y: 50,
            z: -103.9222
          },
          {
            hole: 75,
            x: -151.2511,
            y: 50,
            z: -101.9276
          },
          {
            hole: 76,
            x: -163.9403,
            y: 50,
            z: -96.6716
          },
          {
            hole: 77,
            x: -170,
            y: 50,
            z: -93.4326
          },
          {
            hole: 78,
            x: -175.8349,
            y: 50,
            z: -89.8043
          },
          {
            hole: 79,
            x: -181.4199,
            y: 50,
            z: -85.8021
          },
          {
            hole: 80,
            x: -186.7313,
            y: 50,
            z: -81.4432
          },
          {
            hole: 81,
            x: -196.4432,
            y: 50,
            z: -71.7313
          },
          {
            hole: 82,
            x: -200.8021,
            y: 50,
            z: -66.42
          },
          {
            hole: 83,
            x: -204.8043,
            y: 50,
            z: -60.8349
          },
          {
            hole: 84,
            x: -208.4327,
            y: 50,
            z: -55
          },
          {
            hole: 85,
            x: -211.6716,
            y: 50,
            z: -48.9403
          },
          {
            hole: 86,
            x: -216.9277,
            y: 50,
            z: -36.2511
          },
          {
            hole: 87,
            x: -218.9222,
            y: 50,
            z: -29.676
          },
          {
            hole: 88,
            x: -220.4825,
            y: 50,
            z: -22.9845
          },
          {
            hole: 89,
            x: -221.6017,
            y: 50,
            z: -16.2053
          },
          {
            hole: 90,
            x: -222.2752,
            y: 50,
            z: -9.3673
          },
          {
            hole: 91,
            x: -222.2752,
            y: 50,
            z: 4.3673
          },
          {
            hole: 92,
            x: -221.6017,
            y: 50,
            z: 11.2053
          },
          {
            hole: 93,
            x: -220.4825,
            y: 50,
            z: 17.9845
          },
          {
            hole: 94,
            x: -218.9222,
            y: 50,
            z: 24.676
          },
          {
            hole: 95,
            x: -216.9277,
            y: 50,
            z: 31.2512
          },
          {
            hole: 96,
            x: -211.6716,
            y: 50,
            z: 43.9404
          },
          {
            hole: 97,
            x: -208.4327,
            y: 50,
            z: 50.0001
          },
          {
            hole: 98,
            x: -204.8043,
            y: 50,
            z: 55.8349
          },
          {
            hole: 99,
            x: -200.8021,
            y: 50,
            z: 61.42
          },
          {
            hole: 100,
            x: -196.4432,
            y: 50,
            z: 66.7314
          },
          {
            hole: 101,
            x: -186.7313,
            y: 50,
            z: 76.4432
          },
          {
            hole: 102,
            x: -181.4199,
            y: 50,
            z: 80.8021
          },
          {
            hole: 103,
            x: -175.8349,
            y: 50,
            z: 84.8043
          },
          {
            hole: 104,
            x: -170,
            y: 50,
            z: 88.4327
          },
          {
            hole: 105,
            x: -163.9403,
            y: 50,
            z: 91.6717
          },
          {
            hole: 106,
            x: -151.2511,
            y: 50,
            z: 96.9277
          },
          {
            hole: 107,
            x: -144.676,
            y: 50,
            z: 98.9222
          },
          {
            hole: 108,
            x: -137.9845,
            y: 50,
            z: 100.4825
          },
          {
            hole: 109,
            x: -131.2053,
            y: 50,
            z: 101.6017
          },
          {
            hole: 110,
            x: -124.3673,
            y: 50,
            z: 102.2752
          },
          {
            hole: 111,
            x: -113,
            y: 50,
            z: 102.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 115,
            x: -82,
            y: 50,
            z: 102.5
          },
          {
            hole: 116,
            x: -73,
            y: 50,
            z: 102.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 120,
            x: -42,
            y: 50,
            z: 102.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 50,
            z: 102.5
          }
        ],
        p3: [
          {
            hole: 0,
            x: 29.5,
            y: 50,
            z: 102.3246
          },
          {
            hole: 1,
            x: 47,
            y: 40,
            z: 92.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 5,
            x: 78,
            y: 40,
            z: 92.5
          },
          {
            hole: 6,
            x: 88.7133,
            y: 40,
            z: 92.2966
          },
          {
            hole: 7,
            x: 94.9,
            y: 40,
            z: 91.6873
          },
          {
            hole: 8,
            x: 101.0336,
            y: 40,
            z: 90.6746
          },
          {
            hole: 9,
            x: 107.0878,
            y: 40,
            z: 89.263
          },
          {
            hole: 10,
            x: 113.0367,
            y: 40,
            z: 87.4584
          },
          {
            hole: 11,
            x: 124.5174,
            y: 40,
            z: 82.7029
          },
          {
            hole: 12,
            x: 129.9999,
            y: 40,
            z: 79.7724
          },
          {
            hole: 13,
            x: 135.2791,
            y: 40,
            z: 76.4896
          },
          {
            hole: 14,
            x: 140.3323,
            y: 40,
            z: 72.8686
          },
          {
            hole: 15,
            x: 145.1378,
            y: 40,
            z: 68.9248
          },
          {
            hole: 16,
            x: 153.9246,
            y: 40,
            z: 60.1378
          },
          {
            hole: 17,
            x: 157.8684,
            y: 40,
            z: 55.3323
          },
          {
            hole: 18,
            x: 161.4895,
            y: 40,
            z: 50.2791
          },
          {
            hole: 19,
            x: 164.7723,
            y: 40,
            z: 45
          },
          {
            hole: 20,
            x: 167.7028,
            y: 40,
            z: 39.5174
          },
          {
            hole: 21,
            x: 172.4584,
            y: 40,
            z: 28.0368
          },
          {
            hole: 22,
            x: 174.263,
            y: 40,
            z: 22.0878
          },
          {
            hole: 23,
            x: 175.6746,
            y: 40,
            z: 16.0336
          },
          {
            hole: 24,
            x: 176.6873,
            y: 40,
            z: 9.9
          },
          {
            hole: 25,
            x: 177.2966,
            y: 40,
            z: 3.7133
          },
          {
            hole: 26,
            x: 177.2966,
            y: 40,
            z: -8.7133
          },
          {
            hole: 27,
            x: 176.6873,
            y: 40,
            z: -14.9
          },
          {
            hole: 28,
            x: 175.6746,
            y: 40,
            z: -21.0336
          },
          {
            hole: 29,
            x: 174.263,
            y: 40,
            z: -27.0878
          },
          {
            hole: 30,
            x: 172.4584,
            y: 40,
            z: -33.0367
          },
          {
            hole: 31,
            x: 167.7029,
            y: 40,
            z: -44.5174
          },
          {
            hole: 32,
            x: 164.7724,
            y: 40,
            z: -50
          },
          {
            hole: 33,
            x: 161.4896,
            y: 40,
            z: -55.2792
          },
          {
            hole: 34,
            x: 157.8685,
            y: 40,
            z: -60.3323
          },
          {
            hole: 35,
            x: 153.9247,
            y: 40,
            z: -65.1378
          },
          {
            hole: 36,
            x: 145.1378,
            y: 40,
            z: -73.9248
          },
          {
            hole: 37,
            x: 140.3323,
            y: 40,
            z: -77.8686
          },
          {
            hole: 38,
            x: 135.2791,
            y: 40,
            z: -81.4896
          },
          {
            hole: 39,
            x: 130,
            y: 40,
            z: -84.7724
          },
          {
            hole: 40,
            x: 124.5174,
            y: 40,
            z: -87.7029
          },
          {
            hole: 41,
            x: 113.0367,
            y: 40,
            z: -92.4584
          },
          {
            hole: 42,
            x: 107.0878,
            y: 40,
            z: -94.263
          },
          {
            hole: 43,
            x: 101.0336,
            y: 40,
            z: -95.6746
          },
          {
            hole: 44,
            x: 94.9,
            y: 40,
            z: -96.6873
          },
          {
            hole: 45,
            x: 88.7133,
            y: 40,
            z: -97.2966
          },
          {
            hole: 46,
            x: 78,
            y: 40,
            z: -97.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 50,
            x: 47,
            y: 40,
            z: -97.5
          },
          {
            hole: 51,
            x: 38,
            y: 40,
            z: -97.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 55,
            x: 7,
            y: 40,
            z: -97.5
          },
          {
            hole: 56,
            x: -2,
            y: 40,
            z: -97.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 60,
            x: -33,
            y: 40,
            z: -97.5
          },
          {
            hole: 61,
            x: -42,
            y: 40,
            z: -97.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 65,
            x: -73,
            y: 40,
            z: -97.5
          },
          {
            hole: 66,
            x: -82,
            y: 40,
            z: -97.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 70,
            x: -113,
            y: 40,
            z: -97.5
          },
          {
            hole: 71,
            x: -123.7133,
            y: 40,
            z: -97.2966
          },
          {
            hole: 72,
            x: -129.9,
            y: 40,
            z: -96.6872
          },
          {
            hole: 73,
            x: -136.0336,
            y: 40,
            z: -95.6746
          },
          {
            hole: 74,
            x: -142.0878,
            y: 40,
            z: -94.2629
          },
          {
            hole: 75,
            x: -148.0367,
            y: 40,
            z: -92.4583
          },
          {
            hole: 76,
            x: -159.5174,
            y: 40,
            z: -87.7029
          },
          {
            hole: 77,
            x: -165,
            y: 40,
            z: -84.7724
          },
          {
            hole: 78,
            x: -170.2792,
            y: 40,
            z: -81.4896
          },
          {
            hole: 79,
            x: -175.3323,
            y: 40,
            z: -77.8685
          },
          {
            hole: 80,
            x: -180.1378,
            y: 40,
            z: -73.9248
          },
          {
            hole: 81,
            x: -188.9248,
            y: 40,
            z: -65.1379
          },
          {
            hole: 82,
            x: -192.8686,
            y: 40,
            z: -60.3323
          },
          {
            hole: 83,
            x: -196.4896,
            y: 40,
            z: -55.2792
          },
          {
            hole: 84,
            x: -199.7724,
            y: 40,
            z: -50
          },
          {
            hole: 85,
            x: -202.7029,
            y: 40,
            z: -44.5174
          },
          {
            hole: 86,
            x: -207.4584,
            y: 40,
            z: -33.0367
          },
          {
            hole: 87,
            x: -209.263,
            y: 40,
            z: -27.0878
          },
          {
            hole: 88,
            x: -210.6746,
            y: 40,
            z: -21.0336
          },
          {
            hole: 89,
            x: -211.6873,
            y: 40,
            z: -14.9
          },
          {
            hole: 90,
            x: -212.2966,
            y: 40,
            z: -8.7133
          },
          {
            hole: 91,
            x: -212.2966,
            y: 40,
            z: 3.7133
          },
          {
            hole: 92,
            x: -211.6873,
            y: 40,
            z: 9.9
          },
          {
            hole: 93,
            x: -210.6746,
            y: 40,
            z: 16.0336
          },
          {
            hole: 94,
            x: -209.263,
            y: 40,
            z: 22.0878
          },
          {
            hole: 95,
            x: -207.4584,
            y: 40,
            z: 28.0368
          },
          {
            hole: 96,
            x: -202.7029,
            y: 40,
            z: 39.5175
          },
          {
            hole: 97,
            x: -199.7724,
            y: 40,
            z: 45.0001
          },
          {
            hole: 98,
            x: -196.4896,
            y: 40,
            z: 50.2792
          },
          {
            hole: 99,
            x: -192.8686,
            y: 40,
            z: 55.3324
          },
          {
            hole: 100,
            x: -188.9248,
            y: 40,
            z: 60.1379
          },
          {
            hole: 101,
            x: -180.1378,
            y: 40,
            z: 68.9248
          },
          {
            hole: 102,
            x: -175.3323,
            y: 40,
            z: 72.8686
          },
          {
            hole: 103,
            x: -170.2792,
            y: 40,
            z: 76.4896
          },
          {
            hole: 104,
            x: -165,
            y: 40,
            z: 79.7724
          },
          {
            hole: 105,
            x: -159.5174,
            y: 40,
            z: 82.7029
          },
          {
            hole: 106,
            x: -148.0367,
            y: 40,
            z: 87.4584
          },
          {
            hole: 107,
            x: -142.0878,
            y: 40,
            z: 89.263
          },
          {
            hole: 108,
            x: -136.0336,
            y: 40,
            z: 90.6746
          },
          {
            hole: 109,
            x: -129.9,
            y: 40,
            z: 91.6873
          },
          {
            hole: 110,
            x: -123.7133,
            y: 40,
            z: 92.2966
          },
          {
            hole: 111,
            x: -113,
            y: 40,
            z: 92.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 115,
            x: -82,
            y: 40,
            z: 92.5
          },
          {
            hole: 116,
            x: -73,
            y: 40,
            z: 92.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 120,
            x: -42,
            y: 40,
            z: 92.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 40,
            z: 92.5
          }
        ],
        p4: [
          {
            hole: 0,
            x: 29.5,
            y: 60,
            z: 112.3246
          },
          {
            hole: 1,
            x: 47,
            y: 30,
            z: 82.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 5,
            x: 78,
            y: 30,
            z: 82.5
          },
          {
            hole: 6,
            x: 88.0592,
            y: 30,
            z: 82.318
          },
          {
            hole: 7,
            x: 93.5947,
            y: 30,
            z: 81.7728
          },
          {
            hole: 8,
            x: 99.0827,
            y: 30,
            z: 80.8668
          },
          {
            hole: 9,
            x: 104.4996,
            y: 30,
            z: 79.6037
          },
          {
            hole: 10,
            x: 109.8223,
            y: 30,
            z: 77.9891
          },
          {
            hole: 11,
            x: 120.0945,
            y: 30,
            z: 73.7342
          },
          {
            hole: 12,
            x: 124.9999,
            y: 30,
            z: 71.1121
          },
          {
            hole: 13,
            x: 129.7234,
            y: 30,
            z: 68.1749
          },
          {
            hole: 14,
            x: 134.2447,
            y: 30,
            z: 64.935
          },
          {
            hole: 15,
            x: 138.5443,
            y: 30,
            z: 61.4064
          },
          {
            hole: 16,
            x: 146.4063,
            y: 30,
            z: 53.5444
          },
          {
            hole: 17,
            x: 149.9349,
            y: 30,
            z: 49.2447
          },
          {
            hole: 18,
            x: 153.1748,
            y: 30,
            z: 44.7234
          },
          {
            hole: 19,
            x: 156.112,
            y: 30,
            z: 40
          },
          {
            hole: 20,
            x: 158.7341,
            y: 30,
            z: 35.0945
          },
          {
            hole: 21,
            x: 162.9891,
            y: 30,
            z: 24.8224
          },
          {
            hole: 22,
            x: 164.6037,
            y: 30,
            z: 19.4996
          },
          {
            hole: 23,
            x: 165.8668,
            y: 30,
            z: 14.0827
          },
          {
            hole: 24,
            x: 166.7728,
            y: 30,
            z: 8.5947
          },
          {
            hole: 25,
            x: 167.318,
            y: 30,
            z: 3.0593
          },
          {
            hole: 26,
            x: 167.318,
            y: 30,
            z: -8.0593
          },
          {
            hole: 27,
            x: 166.7728,
            y: 30,
            z: -13.5947
          },
          {
            hole: 28,
            x: 165.8668,
            y: 30,
            z: -19.0827
          },
          {
            hole: 29,
            x: 164.6037,
            y: 30,
            z: -24.4996
          },
          {
            hole: 30,
            x: 162.9891,
            y: 30,
            z: -29.8224
          },
          {
            hole: 31,
            x: 158.7341,
            y: 30,
            z: -40.0945
          },
          {
            hole: 32,
            x: 156.1121,
            y: 30,
            z: -45
          },
          {
            hole: 33,
            x: 153.1749,
            y: 30,
            z: -49.7235
          },
          {
            hole: 34,
            x: 149.935,
            y: 30,
            z: -54.2447
          },
          {
            hole: 35,
            x: 146.4063,
            y: 30,
            z: -58.5444
          },
          {
            hole: 36,
            x: 138.5444,
            y: 30,
            z: -66.4064
          },
          {
            hole: 37,
            x: 134.2447,
            y: 30,
            z: -69.935
          },
          {
            hole: 38,
            x: 129.7234,
            y: 30,
            z: -73.1749
          },
          {
            hole: 39,
            x: 125,
            y: 30,
            z: -76.1122
          },
          {
            hole: 40,
            x: 120.0945,
            y: 30,
            z: -78.7342
          },
          {
            hole: 41,
            x: 109.8224,
            y: 30,
            z: -82.9891
          },
          {
            hole: 42,
            x: 104.4996,
            y: 30,
            z: -84.6037
          },
          {
            hole: 43,
            x: 99.0827,
            y: 30,
            z: -85.8667
          },
          {
            hole: 44,
            x: 93.5947,
            y: 30,
            z: -86.7728
          },
          {
            hole: 45,
            x: 88.0593,
            y: 30,
            z: -87.318
          },
          {
            hole: 46,
            x: 78,
            y: 30,
            z: -87.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 50,
            x: 47,
            y: 30,
            z: -87.5
          },
          {
            hole: 51,
            x: 38,
            y: 30,
            z: -87.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 55,
            x: 7,
            y: 30,
            z: -87.5
          },
          {
            hole: 56,
            x: -2,
            y: 30,
            z: -87.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 60,
            x: -33,
            y: 30,
            z: -87.5
          },
          {
            hole: 61,
            x: -42,
            y: 30,
            z: -87.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 65,
            x: -73,
            y: 30,
            z: -87.5
          },
          {
            hole: 66,
            x: -82,
            y: 30,
            z: -87.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 70,
            x: -113,
            y: 30,
            z: -87.5
          },
          {
            hole: 71,
            x: -123.0593,
            y: 30,
            z: -87.318
          },
          {
            hole: 72,
            x: -128.5947,
            y: 30,
            z: -86.7728
          },
          {
            hole: 73,
            x: -134.0827,
            y: 30,
            z: -85.8667
          },
          {
            hole: 74,
            x: -139.4996,
            y: 30,
            z: -84.6037
          },
          {
            hole: 75,
            x: -144.8223,
            y: 30,
            z: -82.989
          },
          {
            hole: 76,
            x: -155.0945,
            y: 30,
            z: -78.7342
          },
          {
            hole: 77,
            x: -160,
            y: 30,
            z: -76.1121
          },
          {
            hole: 78,
            x: -164.7234,
            y: 30,
            z: -73.1749
          },
          {
            hole: 79,
            x: -169.2447,
            y: 30,
            z: -69.935
          },
          {
            hole: 80,
            x: -173.5444,
            y: 30,
            z: -66.4064
          },
          {
            hole: 81,
            x: -181.4064,
            y: 30,
            z: -58.5444
          },
          {
            hole: 82,
            x: -184.935,
            y: 30,
            z: -54.2447
          },
          {
            hole: 83,
            x: -188.1749,
            y: 30,
            z: -49.7235
          },
          {
            hole: 84,
            x: -191.1122,
            y: 30,
            z: -45
          },
          {
            hole: 85,
            x: -193.7342,
            y: 30,
            z: -40.0945
          },
          {
            hole: 86,
            x: -197.9891,
            y: 30,
            z: -29.8224
          },
          {
            hole: 87,
            x: -199.6037,
            y: 30,
            z: -24.4996
          },
          {
            hole: 88,
            x: -200.8668,
            y: 30,
            z: -19.0827
          },
          {
            hole: 89,
            x: -201.7728,
            y: 30,
            z: -13.5947
          },
          {
            hole: 90,
            x: -202.318,
            y: 30,
            z: -8.0593
          },
          {
            hole: 91,
            x: -202.318,
            y: 30,
            z: 3.0593
          },
          {
            hole: 92,
            x: -201.7728,
            y: 30,
            z: 8.5947
          },
          {
            hole: 93,
            x: -200.8668,
            y: 30,
            z: 14.0827
          },
          {
            hole: 94,
            x: -199.6037,
            y: 30,
            z: 19.4996
          },
          {
            hole: 95,
            x: -197.9891,
            y: 30,
            z: 24.8224
          },
          {
            hole: 96,
            x: -193.7342,
            y: 30,
            z: 35.0946
          },
          {
            hole: 97,
            x: -191.1122,
            y: 30,
            z: 40.0001
          },
          {
            hole: 98,
            x: -188.1749,
            y: 30,
            z: 44.7235
          },
          {
            hole: 99,
            x: -184.935,
            y: 30,
            z: 49.2448
          },
          {
            hole: 100,
            x: -181.4064,
            y: 30,
            z: 53.5444
          },
          {
            hole: 101,
            x: -173.5444,
            y: 30,
            z: 61.4064
          },
          {
            hole: 102,
            x: -169.2447,
            y: 30,
            z: 64.9351
          },
          {
            hole: 103,
            x: -164.7235,
            y: 30,
            z: 68.1749
          },
          {
            hole: 104,
            x: -160,
            y: 30,
            z: 71.1122
          },
          {
            hole: 105,
            x: -155.0945,
            y: 30,
            z: 73.7342
          },
          {
            hole: 106,
            x: -144.8224,
            y: 30,
            z: 77.9891
          },
          {
            hole: 107,
            x: -139.4996,
            y: 30,
            z: 79.6037
          },
          {
            hole: 108,
            x: -134.0827,
            y: 30,
            z: 80.8667
          },
          {
            hole: 109,
            x: -128.5947,
            y: 30,
            z: 81.7728
          },
          {
            hole: 110,
            x: -123.0593,
            y: 30,
            z: 82.318
          },
          {
            hole: 111,
            x: -113,
            y: 30,
            z: 82.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 115,
            x: -82,
            y: 30,
            z: 82.5
          },
          {
            hole: 116,
            x: -73,
            y: 30,
            z: 82.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 120,
            x: -42,
            y: 30,
            z: 82.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 30,
            z: 82.5
          }
        ]
      }
    },
    {
      id: "board-soccer-field",
      name: "Soccer Field",
      brand: "crazy,pints,adult",
      desc: "Soccer Field Cribbage 3D cribbage board (8.8 MB)",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/soccer-field-crazy-thumbnail.png?v=1792021029",
      modelUrl: "https://cdn.shopify.com/3d/models/ec653d35f4b4eac7/soccer_field.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 29.5,
            y: 30,
            z: 82.3246
          },
          {
            hole: 1,
            x: 47,
            y: 60,
            z: 112.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 5,
            x: 78,
            y: 60,
            z: 112.5
          },
          {
            hole: 6,
            x: 90.0213,
            y: 60,
            z: 112.2538
          },
          {
            hole: 7,
            x: 97.5105,
            y: 60,
            z: 111.5162
          },
          {
            hole: 8,
            x: 104.9354,
            y: 60,
            z: 110.2903
          },
          {
            hole: 9,
            x: 112.2642,
            y: 60,
            z: 108.5815
          },
          {
            hole: 10,
            x: 119.4655,
            y: 60,
            z: 106.397
          },
          {
            hole: 11,
            x: 133.3631,
            y: 60,
            z: 100.6404
          },
          {
            hole: 12,
            x: 139.9999,
            y: 60,
            z: 97.0929
          },
          {
            hole: 13,
            x: 146.3905,
            y: 60,
            z: 93.119
          },
          {
            hole: 14,
            x: 152.5075,
            y: 60,
            z: 88.7356
          },
          {
            hole: 15,
            x: 158.3247,
            y: 60,
            z: 83.9616
          },
          {
            hole: 16,
            x: 168.9614,
            y: 60,
            z: 73.3247
          },
          {
            hole: 17,
            x: 173.7355,
            y: 60,
            z: 67.5075
          },
          {
            hole: 18,
            x: 178.1189,
            y: 60,
            z: 61.3905
          },
          {
            hole: 19,
            x: 182.0928,
            y: 60,
            z: 55
          },
          {
            hole: 20,
            x: 185.6402,
            y: 60,
            z: 48.3632
          },
          {
            hole: 21,
            x: 191.397,
            y: 60,
            z: 34.4655
          },
          {
            hole: 22,
            x: 193.5815,
            y: 60,
            z: 27.2642
          },
          {
            hole: 23,
            x: 195.2903,
            y: 60,
            z: 19.9354
          },
          {
            hole: 24,
            x: 196.5162,
            y: 60,
            z: 12.5105
          },
          {
            hole: 25,
            x: 197.2538,
            y: 60,
            z: 5.0214
          },
          {
            hole: 26,
            x: 197.2538,
            y: 60,
            z: -10.0214
          },
          {
            hole: 27,
            x: 196.5162,
            y: 60,
            z: -17.5105
          },
          {
            hole: 28,
            x: 195.2903,
            y: 60,
            z: -24.9354
          },
          {
            hole: 29,
            x: 193.5815,
            y: 60,
            z: -32.2642
          },
          {
            hole: 30,
            x: 191.397,
            y: 60,
            z: -39.4655
          },
          {
            hole: 31,
            x: 185.6403,
            y: 60,
            z: -53.3632
          },
          {
            hole: 32,
            x: 182.0929,
            y: 60,
            z: -60
          },
          {
            hole: 33,
            x: 178.119,
            y: 60,
            z: -66.3906
          },
          {
            hole: 34,
            x: 173.7356,
            y: 60,
            z: -72.5076
          },
          {
            hole: 35,
            x: 168.9615,
            y: 60,
            z: -78.3248
          },
          {
            hole: 36,
            x: 158.3247,
            y: 60,
            z: -88.9616
          },
          {
            hole: 37,
            x: 152.5075,
            y: 60,
            z: -93.7356
          },
          {
            hole: 38,
            x: 146.3905,
            y: 60,
            z: -98.119
          },
          {
            hole: 39,
            x: 140,
            y: 60,
            z: -102.0929
          },
          {
            hole: 40,
            x: 133.3632,
            y: 60,
            z: -105.6404
          },
          {
            hole: 41,
            x: 119.4655,
            y: 60,
            z: -111.397
          },
          {
            hole: 42,
            x: 112.2642,
            y: 60,
            z: -113.5815
          },
          {
            hole: 43,
            x: 104.9354,
            y: 60,
            z: -115.2903
          },
          {
            hole: 44,
            x: 97.5105,
            y: 60,
            z: -116.5162
          },
          {
            hole: 45,
            x: 90.0214,
            y: 60,
            z: -117.2538
          },
          {
            hole: 46,
            x: 78,
            y: 60,
            z: -117.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 50,
            x: 47,
            y: 60,
            z: -117.5
          },
          {
            hole: 51,
            x: 38,
            y: 60,
            z: -117.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 55,
            x: 7,
            y: 60,
            z: -117.5
          },
          {
            hole: 56,
            x: -2,
            y: 60,
            z: -117.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 60,
            x: -33,
            y: 60,
            z: -117.5
          },
          {
            hole: 61,
            x: -42,
            y: 60,
            z: -117.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 65,
            x: -73,
            y: 60,
            z: -117.5
          },
          {
            hole: 66,
            x: -82,
            y: 60,
            z: -117.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 70,
            x: -113,
            y: 60,
            z: -117.5
          },
          {
            hole: 71,
            x: -125.0214,
            y: 60,
            z: -117.2538
          },
          {
            hole: 72,
            x: -132.5105,
            y: 60,
            z: -116.5161
          },
          {
            hole: 73,
            x: -139.9354,
            y: 60,
            z: -115.2903
          },
          {
            hole: 74,
            x: -147.2642,
            y: 60,
            z: -113.5815
          },
          {
            hole: 75,
            x: -154.4655,
            y: 60,
            z: -111.3969
          },
          {
            hole: 76,
            x: -168.3632,
            y: 60,
            z: -105.6403
          },
          {
            hole: 77,
            x: -175,
            y: 60,
            z: -102.0929
          },
          {
            hole: 78,
            x: -181.3906,
            y: 60,
            z: -98.119
          },
          {
            hole: 79,
            x: -187.5075,
            y: 60,
            z: -93.7356
          },
          {
            hole: 80,
            x: -193.3247,
            y: 60,
            z: -88.9616
          },
          {
            hole: 81,
            x: -203.9616,
            y: 60,
            z: -78.3248
          },
          {
            hole: 82,
            x: -208.7356,
            y: 60,
            z: -72.5076
          },
          {
            hole: 83,
            x: -213.119,
            y: 60,
            z: -66.3906
          },
          {
            hole: 84,
            x: -217.0929,
            y: 60,
            z: -60
          },
          {
            hole: 85,
            x: -220.6404,
            y: 60,
            z: -53.3632
          },
          {
            hole: 86,
            x: -226.397,
            y: 60,
            z: -39.4655
          },
          {
            hole: 87,
            x: -228.5815,
            y: 60,
            z: -32.2642
          },
          {
            hole: 88,
            x: -230.2903,
            y: 60,
            z: -24.9354
          },
          {
            hole: 89,
            x: -231.5162,
            y: 60,
            z: -17.5105
          },
          {
            hole: 90,
            x: -232.2538,
            y: 60,
            z: -10.0214
          },
          {
            hole: 91,
            x: -232.2538,
            y: 60,
            z: 5.0214
          },
          {
            hole: 92,
            x: -231.5162,
            y: 60,
            z: 12.5105
          },
          {
            hole: 93,
            x: -230.2903,
            y: 60,
            z: 19.9354
          },
          {
            hole: 94,
            x: -228.5815,
            y: 60,
            z: 27.2642
          },
          {
            hole: 95,
            x: -226.397,
            y: 60,
            z: 34.4655
          },
          {
            hole: 96,
            x: -220.6404,
            y: 60,
            z: 48.3633
          },
          {
            hole: 97,
            x: -217.0929,
            y: 60,
            z: 55.0001
          },
          {
            hole: 98,
            x: -213.119,
            y: 60,
            z: 61.3906
          },
          {
            hole: 99,
            x: -208.7356,
            y: 60,
            z: 67.5076
          },
          {
            hole: 100,
            x: -203.9616,
            y: 60,
            z: 73.3248
          },
          {
            hole: 101,
            x: -193.3248,
            y: 60,
            z: 83.9616
          },
          {
            hole: 102,
            x: -187.5076,
            y: 60,
            z: 88.7357
          },
          {
            hole: 103,
            x: -181.3906,
            y: 60,
            z: 93.119
          },
          {
            hole: 104,
            x: -175,
            y: 60,
            z: 97.0929
          },
          {
            hole: 105,
            x: -168.3632,
            y: 60,
            z: 100.6404
          },
          {
            hole: 106,
            x: -154.4655,
            y: 60,
            z: 106.397
          },
          {
            hole: 107,
            x: -147.2642,
            y: 60,
            z: 108.5815
          },
          {
            hole: 108,
            x: -139.9354,
            y: 60,
            z: 110.2903
          },
          {
            hole: 109,
            x: -132.5105,
            y: 60,
            z: 111.5162
          },
          {
            hole: 110,
            x: -125.0214,
            y: 60,
            z: 112.2538
          },
          {
            hole: 111,
            x: -113,
            y: 60,
            z: 112.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 115,
            x: -82,
            y: 60,
            z: 112.5
          },
          {
            hole: 116,
            x: -73,
            y: 60,
            z: 112.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 120,
            x: -42,
            y: 60,
            z: 112.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 60,
            z: 112.5
          }
        ],
        p2: [
          {
            hole: 0,
            x: 29.5,
            y: 40,
            z: 92.3246
          },
          {
            hole: 1,
            x: 47,
            y: 50,
            z: 102.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 5,
            x: 78,
            y: 50,
            z: 102.5
          },
          {
            hole: 6,
            x: 89.3673,
            y: 50,
            z: 102.2752
          },
          {
            hole: 7,
            x: 96.2052,
            y: 50,
            z: 101.6017
          },
          {
            hole: 8,
            x: 102.9845,
            y: 50,
            z: 100.4825
          },
          {
            hole: 9,
            x: 109.676,
            y: 50,
            z: 98.9222
          },
          {
            hole: 10,
            x: 116.2511,
            y: 50,
            z: 96.9277
          },
          {
            hole: 11,
            x: 128.9403,
            y: 50,
            z: 91.6716
          },
          {
            hole: 12,
            x: 134.9999,
            y: 50,
            z: 88.4327
          },
          {
            hole: 13,
            x: 140.8348,
            y: 50,
            z: 84.8043
          },
          {
            hole: 14,
            x: 146.4199,
            y: 50,
            z: 80.8021
          },
          {
            hole: 15,
            x: 151.7313,
            y: 50,
            z: 76.4432
          },
          {
            hole: 16,
            x: 161.443,
            y: 50,
            z: 66.7313
          },
          {
            hole: 17,
            x: 165.802,
            y: 50,
            z: 61.4199
          },
          {
            hole: 18,
            x: 169.8042,
            y: 50,
            z: 55.8348
          },
          {
            hole: 19,
            x: 173.4325,
            y: 50,
            z: 50
          },
          {
            hole: 20,
            x: 176.6715,
            y: 50,
            z: 43.9403
          },
          {
            hole: 21,
            x: 181.9277,
            y: 50,
            z: 31.2512
          },
          {
            hole: 22,
            x: 183.9222,
            y: 50,
            z: 24.676
          },
          {
            hole: 23,
            x: 185.4825,
            y: 50,
            z: 17.9845
          },
          {
            hole: 24,
            x: 186.6017,
            y: 50,
            z: 11.2053
          },
          {
            hole: 25,
            x: 187.2752,
            y: 50,
            z: 4.3673
          },
          {
            hole: 26,
            x: 187.2752,
            y: 50,
            z: -9.3673
          },
          {
            hole: 27,
            x: 186.6017,
            y: 50,
            z: -16.2052
          },
          {
            hole: 28,
            x: 185.4825,
            y: 50,
            z: -22.9845
          },
          {
            hole: 29,
            x: 183.9222,
            y: 50,
            z: -29.676
          },
          {
            hole: 30,
            x: 181.9277,
            y: 50,
            z: -36.2511
          },
          {
            hole: 31,
            x: 176.6716,
            y: 50,
            z: -48.9403
          },
          {
            hole: 32,
            x: 173.4326,
            y: 50,
            z: -55
          },
          {
            hole: 33,
            x: 169.8043,
            y: 50,
            z: -60.8349
          },
          {
            hole: 34,
            x: 165.8021,
            y: 50,
            z: -66.4199
          },
          {
            hole: 35,
            x: 161.4431,
            y: 50,
            z: -71.7313
          },
          {
            hole: 36,
            x: 151.7313,
            y: 50,
            z: -81.4432
          },
          {
            hole: 37,
            x: 146.4199,
            y: 50,
            z: -85.8021
          },
          {
            hole: 38,
            x: 140.8348,
            y: 50,
            z: -89.8043
          },
          {
            hole: 39,
            x: 135,
            y: 50,
            z: -93.4327
          },
          {
            hole: 40,
            x: 128.9403,
            y: 50,
            z: -96.6716
          },
          {
            hole: 41,
            x: 116.2511,
            y: 50,
            z: -101.9277
          },
          {
            hole: 42,
            x: 109.676,
            y: 50,
            z: -103.9222
          },
          {
            hole: 43,
            x: 102.9845,
            y: 50,
            z: -105.4825
          },
          {
            hole: 44,
            x: 96.2053,
            y: 50,
            z: -106.6017
          },
          {
            hole: 45,
            x: 89.3673,
            y: 50,
            z: -107.2752
          },
          {
            hole: 46,
            x: 78,
            y: 50,
            z: -107.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 50,
            x: 47,
            y: 50,
            z: -107.5
          },
          {
            hole: 51,
            x: 38,
            y: 50,
            z: -107.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 55,
            x: 7,
            y: 50,
            z: -107.5
          },
          {
            hole: 56,
            x: -2,
            y: 50,
            z: -107.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 60,
            x: -33,
            y: 50,
            z: -107.5
          },
          {
            hole: 61,
            x: -42,
            y: 50,
            z: -107.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 65,
            x: -73,
            y: 50,
            z: -107.5
          },
          {
            hole: 66,
            x: -82,
            y: 50,
            z: -107.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 70,
            x: -113,
            y: 50,
            z: -107.5
          },
          {
            hole: 71,
            x: -124.3673,
            y: 50,
            z: -107.2752
          },
          {
            hole: 72,
            x: -131.2052,
            y: 50,
            z: -106.6017
          },
          {
            hole: 73,
            x: -137.9845,
            y: 50,
            z: -105.4824
          },
          {
            hole: 74,
            x: -144.676,
            y: 50,
            z: -103.9222
          },
          {
            hole: 75,
            x: -151.2511,
            y: 50,
            z: -101.9276
          },
          {
            hole: 76,
            x: -163.9403,
            y: 50,
            z: -96.6716
          },
          {
            hole: 77,
            x: -170,
            y: 50,
            z: -93.4326
          },
          {
            hole: 78,
            x: -175.8349,
            y: 50,
            z: -89.8043
          },
          {
            hole: 79,
            x: -181.4199,
            y: 50,
            z: -85.8021
          },
          {
            hole: 80,
            x: -186.7313,
            y: 50,
            z: -81.4432
          },
          {
            hole: 81,
            x: -196.4432,
            y: 50,
            z: -71.7313
          },
          {
            hole: 82,
            x: -200.8021,
            y: 50,
            z: -66.42
          },
          {
            hole: 83,
            x: -204.8043,
            y: 50,
            z: -60.8349
          },
          {
            hole: 84,
            x: -208.4327,
            y: 50,
            z: -55
          },
          {
            hole: 85,
            x: -211.6716,
            y: 50,
            z: -48.9403
          },
          {
            hole: 86,
            x: -216.9277,
            y: 50,
            z: -36.2511
          },
          {
            hole: 87,
            x: -218.9222,
            y: 50,
            z: -29.676
          },
          {
            hole: 88,
            x: -220.4825,
            y: 50,
            z: -22.9845
          },
          {
            hole: 89,
            x: -221.6017,
            y: 50,
            z: -16.2053
          },
          {
            hole: 90,
            x: -222.2752,
            y: 50,
            z: -9.3673
          },
          {
            hole: 91,
            x: -222.2752,
            y: 50,
            z: 4.3673
          },
          {
            hole: 92,
            x: -221.6017,
            y: 50,
            z: 11.2053
          },
          {
            hole: 93,
            x: -220.4825,
            y: 50,
            z: 17.9845
          },
          {
            hole: 94,
            x: -218.9222,
            y: 50,
            z: 24.676
          },
          {
            hole: 95,
            x: -216.9277,
            y: 50,
            z: 31.2512
          },
          {
            hole: 96,
            x: -211.6716,
            y: 50,
            z: 43.9404
          },
          {
            hole: 97,
            x: -208.4327,
            y: 50,
            z: 50.0001
          },
          {
            hole: 98,
            x: -204.8043,
            y: 50,
            z: 55.8349
          },
          {
            hole: 99,
            x: -200.8021,
            y: 50,
            z: 61.42
          },
          {
            hole: 100,
            x: -196.4432,
            y: 50,
            z: 66.7314
          },
          {
            hole: 101,
            x: -186.7313,
            y: 50,
            z: 76.4432
          },
          {
            hole: 102,
            x: -181.4199,
            y: 50,
            z: 80.8021
          },
          {
            hole: 103,
            x: -175.8349,
            y: 50,
            z: 84.8043
          },
          {
            hole: 104,
            x: -170,
            y: 50,
            z: 88.4327
          },
          {
            hole: 105,
            x: -163.9403,
            y: 50,
            z: 91.6717
          },
          {
            hole: 106,
            x: -151.2511,
            y: 50,
            z: 96.9277
          },
          {
            hole: 107,
            x: -144.676,
            y: 50,
            z: 98.9222
          },
          {
            hole: 108,
            x: -137.9845,
            y: 50,
            z: 100.4825
          },
          {
            hole: 109,
            x: -131.2053,
            y: 50,
            z: 101.6017
          },
          {
            hole: 110,
            x: -124.3673,
            y: 50,
            z: 102.2752
          },
          {
            hole: 111,
            x: -113,
            y: 50,
            z: 102.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 115,
            x: -82,
            y: 50,
            z: 102.5
          },
          {
            hole: 116,
            x: -73,
            y: 50,
            z: 102.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 120,
            x: -42,
            y: 50,
            z: 102.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 50,
            z: 102.5
          }
        ],
        p3: [
          {
            hole: 0,
            x: 29.5,
            y: 50,
            z: 102.3246
          },
          {
            hole: 1,
            x: 47,
            y: 40,
            z: 92.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 5,
            x: 78,
            y: 40,
            z: 92.5
          },
          {
            hole: 6,
            x: 88.7133,
            y: 40,
            z: 92.2966
          },
          {
            hole: 7,
            x: 94.9,
            y: 40,
            z: 91.6873
          },
          {
            hole: 8,
            x: 101.0336,
            y: 40,
            z: 90.6746
          },
          {
            hole: 9,
            x: 107.0878,
            y: 40,
            z: 89.263
          },
          {
            hole: 10,
            x: 113.0367,
            y: 40,
            z: 87.4584
          },
          {
            hole: 11,
            x: 124.5174,
            y: 40,
            z: 82.7029
          },
          {
            hole: 12,
            x: 129.9999,
            y: 40,
            z: 79.7724
          },
          {
            hole: 13,
            x: 135.2791,
            y: 40,
            z: 76.4896
          },
          {
            hole: 14,
            x: 140.3323,
            y: 40,
            z: 72.8686
          },
          {
            hole: 15,
            x: 145.1378,
            y: 40,
            z: 68.9248
          },
          {
            hole: 16,
            x: 153.9246,
            y: 40,
            z: 60.1378
          },
          {
            hole: 17,
            x: 157.8684,
            y: 40,
            z: 55.3323
          },
          {
            hole: 18,
            x: 161.4895,
            y: 40,
            z: 50.2791
          },
          {
            hole: 19,
            x: 164.7723,
            y: 40,
            z: 45
          },
          {
            hole: 20,
            x: 167.7028,
            y: 40,
            z: 39.5174
          },
          {
            hole: 21,
            x: 172.4584,
            y: 40,
            z: 28.0368
          },
          {
            hole: 22,
            x: 174.263,
            y: 40,
            z: 22.0878
          },
          {
            hole: 23,
            x: 175.6746,
            y: 40,
            z: 16.0336
          },
          {
            hole: 24,
            x: 176.6873,
            y: 40,
            z: 9.9
          },
          {
            hole: 25,
            x: 177.2966,
            y: 40,
            z: 3.7133
          },
          {
            hole: 26,
            x: 177.2966,
            y: 40,
            z: -8.7133
          },
          {
            hole: 27,
            x: 176.6873,
            y: 40,
            z: -14.9
          },
          {
            hole: 28,
            x: 175.6746,
            y: 40,
            z: -21.0336
          },
          {
            hole: 29,
            x: 174.263,
            y: 40,
            z: -27.0878
          },
          {
            hole: 30,
            x: 172.4584,
            y: 40,
            z: -33.0367
          },
          {
            hole: 31,
            x: 167.7029,
            y: 40,
            z: -44.5174
          },
          {
            hole: 32,
            x: 164.7724,
            y: 40,
            z: -50
          },
          {
            hole: 33,
            x: 161.4896,
            y: 40,
            z: -55.2792
          },
          {
            hole: 34,
            x: 157.8685,
            y: 40,
            z: -60.3323
          },
          {
            hole: 35,
            x: 153.9247,
            y: 40,
            z: -65.1378
          },
          {
            hole: 36,
            x: 145.1378,
            y: 40,
            z: -73.9248
          },
          {
            hole: 37,
            x: 140.3323,
            y: 40,
            z: -77.8686
          },
          {
            hole: 38,
            x: 135.2791,
            y: 40,
            z: -81.4896
          },
          {
            hole: 39,
            x: 130,
            y: 40,
            z: -84.7724
          },
          {
            hole: 40,
            x: 124.5174,
            y: 40,
            z: -87.7029
          },
          {
            hole: 41,
            x: 113.0367,
            y: 40,
            z: -92.4584
          },
          {
            hole: 42,
            x: 107.0878,
            y: 40,
            z: -94.263
          },
          {
            hole: 43,
            x: 101.0336,
            y: 40,
            z: -95.6746
          },
          {
            hole: 44,
            x: 94.9,
            y: 40,
            z: -96.6873
          },
          {
            hole: 45,
            x: 88.7133,
            y: 40,
            z: -97.2966
          },
          {
            hole: 46,
            x: 78,
            y: 40,
            z: -97.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 50,
            x: 47,
            y: 40,
            z: -97.5
          },
          {
            hole: 51,
            x: 38,
            y: 40,
            z: -97.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 55,
            x: 7,
            y: 40,
            z: -97.5
          },
          {
            hole: 56,
            x: -2,
            y: 40,
            z: -97.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 60,
            x: -33,
            y: 40,
            z: -97.5
          },
          {
            hole: 61,
            x: -42,
            y: 40,
            z: -97.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 65,
            x: -73,
            y: 40,
            z: -97.5
          },
          {
            hole: 66,
            x: -82,
            y: 40,
            z: -97.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 70,
            x: -113,
            y: 40,
            z: -97.5
          },
          {
            hole: 71,
            x: -123.7133,
            y: 40,
            z: -97.2966
          },
          {
            hole: 72,
            x: -129.9,
            y: 40,
            z: -96.6872
          },
          {
            hole: 73,
            x: -136.0336,
            y: 40,
            z: -95.6746
          },
          {
            hole: 74,
            x: -142.0878,
            y: 40,
            z: -94.2629
          },
          {
            hole: 75,
            x: -148.0367,
            y: 40,
            z: -92.4583
          },
          {
            hole: 76,
            x: -159.5174,
            y: 40,
            z: -87.7029
          },
          {
            hole: 77,
            x: -165,
            y: 40,
            z: -84.7724
          },
          {
            hole: 78,
            x: -170.2792,
            y: 40,
            z: -81.4896
          },
          {
            hole: 79,
            x: -175.3323,
            y: 40,
            z: -77.8685
          },
          {
            hole: 80,
            x: -180.1378,
            y: 40,
            z: -73.9248
          },
          {
            hole: 81,
            x: -188.9248,
            y: 40,
            z: -65.1379
          },
          {
            hole: 82,
            x: -192.8686,
            y: 40,
            z: -60.3323
          },
          {
            hole: 83,
            x: -196.4896,
            y: 40,
            z: -55.2792
          },
          {
            hole: 84,
            x: -199.7724,
            y: 40,
            z: -50
          },
          {
            hole: 85,
            x: -202.7029,
            y: 40,
            z: -44.5174
          },
          {
            hole: 86,
            x: -207.4584,
            y: 40,
            z: -33.0367
          },
          {
            hole: 87,
            x: -209.263,
            y: 40,
            z: -27.0878
          },
          {
            hole: 88,
            x: -210.6746,
            y: 40,
            z: -21.0336
          },
          {
            hole: 89,
            x: -211.6873,
            y: 40,
            z: -14.9
          },
          {
            hole: 90,
            x: -212.2966,
            y: 40,
            z: -8.7133
          },
          {
            hole: 91,
            x: -212.2966,
            y: 40,
            z: 3.7133
          },
          {
            hole: 92,
            x: -211.6873,
            y: 40,
            z: 9.9
          },
          {
            hole: 93,
            x: -210.6746,
            y: 40,
            z: 16.0336
          },
          {
            hole: 94,
            x: -209.263,
            y: 40,
            z: 22.0878
          },
          {
            hole: 95,
            x: -207.4584,
            y: 40,
            z: 28.0368
          },
          {
            hole: 96,
            x: -202.7029,
            y: 40,
            z: 39.5175
          },
          {
            hole: 97,
            x: -199.7724,
            y: 40,
            z: 45.0001
          },
          {
            hole: 98,
            x: -196.4896,
            y: 40,
            z: 50.2792
          },
          {
            hole: 99,
            x: -192.8686,
            y: 40,
            z: 55.3324
          },
          {
            hole: 100,
            x: -188.9248,
            y: 40,
            z: 60.1379
          },
          {
            hole: 101,
            x: -180.1378,
            y: 40,
            z: 68.9248
          },
          {
            hole: 102,
            x: -175.3323,
            y: 40,
            z: 72.8686
          },
          {
            hole: 103,
            x: -170.2792,
            y: 40,
            z: 76.4896
          },
          {
            hole: 104,
            x: -165,
            y: 40,
            z: 79.7724
          },
          {
            hole: 105,
            x: -159.5174,
            y: 40,
            z: 82.7029
          },
          {
            hole: 106,
            x: -148.0367,
            y: 40,
            z: 87.4584
          },
          {
            hole: 107,
            x: -142.0878,
            y: 40,
            z: 89.263
          },
          {
            hole: 108,
            x: -136.0336,
            y: 40,
            z: 90.6746
          },
          {
            hole: 109,
            x: -129.9,
            y: 40,
            z: 91.6873
          },
          {
            hole: 110,
            x: -123.7133,
            y: 40,
            z: 92.2966
          },
          {
            hole: 111,
            x: -113,
            y: 40,
            z: 92.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 115,
            x: -82,
            y: 40,
            z: 92.5
          },
          {
            hole: 116,
            x: -73,
            y: 40,
            z: 92.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 120,
            x: -42,
            y: 40,
            z: 92.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 40,
            z: 92.5
          }
        ],
        p4: [
          {
            hole: 0,
            x: 29.5,
            y: 60,
            z: 112.3246
          },
          {
            hole: 1,
            x: 47,
            y: 30,
            z: 82.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 5,
            x: 78,
            y: 30,
            z: 82.5
          },
          {
            hole: 6,
            x: 88.0592,
            y: 30,
            z: 82.318
          },
          {
            hole: 7,
            x: 93.5947,
            y: 30,
            z: 81.7728
          },
          {
            hole: 8,
            x: 99.0827,
            y: 30,
            z: 80.8668
          },
          {
            hole: 9,
            x: 104.4996,
            y: 30,
            z: 79.6037
          },
          {
            hole: 10,
            x: 109.8223,
            y: 30,
            z: 77.9891
          },
          {
            hole: 11,
            x: 120.0945,
            y: 30,
            z: 73.7342
          },
          {
            hole: 12,
            x: 124.9999,
            y: 30,
            z: 71.1121
          },
          {
            hole: 13,
            x: 129.7234,
            y: 30,
            z: 68.1749
          },
          {
            hole: 14,
            x: 134.2447,
            y: 30,
            z: 64.935
          },
          {
            hole: 15,
            x: 138.5443,
            y: 30,
            z: 61.4064
          },
          {
            hole: 16,
            x: 146.4063,
            y: 30,
            z: 53.5444
          },
          {
            hole: 17,
            x: 149.9349,
            y: 30,
            z: 49.2447
          },
          {
            hole: 18,
            x: 153.1748,
            y: 30,
            z: 44.7234
          },
          {
            hole: 19,
            x: 156.112,
            y: 30,
            z: 40
          },
          {
            hole: 20,
            x: 158.7341,
            y: 30,
            z: 35.0945
          },
          {
            hole: 21,
            x: 162.9891,
            y: 30,
            z: 24.8224
          },
          {
            hole: 22,
            x: 164.6037,
            y: 30,
            z: 19.4996
          },
          {
            hole: 23,
            x: 165.8668,
            y: 30,
            z: 14.0827
          },
          {
            hole: 24,
            x: 166.7728,
            y: 30,
            z: 8.5947
          },
          {
            hole: 25,
            x: 167.318,
            y: 30,
            z: 3.0593
          },
          {
            hole: 26,
            x: 167.318,
            y: 30,
            z: -8.0593
          },
          {
            hole: 27,
            x: 166.7728,
            y: 30,
            z: -13.5947
          },
          {
            hole: 28,
            x: 165.8668,
            y: 30,
            z: -19.0827
          },
          {
            hole: 29,
            x: 164.6037,
            y: 30,
            z: -24.4996
          },
          {
            hole: 30,
            x: 162.9891,
            y: 30,
            z: -29.8224
          },
          {
            hole: 31,
            x: 158.7341,
            y: 30,
            z: -40.0945
          },
          {
            hole: 32,
            x: 156.1121,
            y: 30,
            z: -45
          },
          {
            hole: 33,
            x: 153.1749,
            y: 30,
            z: -49.7235
          },
          {
            hole: 34,
            x: 149.935,
            y: 30,
            z: -54.2447
          },
          {
            hole: 35,
            x: 146.4063,
            y: 30,
            z: -58.5444
          },
          {
            hole: 36,
            x: 138.5444,
            y: 30,
            z: -66.4064
          },
          {
            hole: 37,
            x: 134.2447,
            y: 30,
            z: -69.935
          },
          {
            hole: 38,
            x: 129.7234,
            y: 30,
            z: -73.1749
          },
          {
            hole: 39,
            x: 125,
            y: 30,
            z: -76.1122
          },
          {
            hole: 40,
            x: 120.0945,
            y: 30,
            z: -78.7342
          },
          {
            hole: 41,
            x: 109.8224,
            y: 30,
            z: -82.9891
          },
          {
            hole: 42,
            x: 104.4996,
            y: 30,
            z: -84.6037
          },
          {
            hole: 43,
            x: 99.0827,
            y: 30,
            z: -85.8667
          },
          {
            hole: 44,
            x: 93.5947,
            y: 30,
            z: -86.7728
          },
          {
            hole: 45,
            x: 88.0593,
            y: 30,
            z: -87.318
          },
          {
            hole: 46,
            x: 78,
            y: 30,
            z: -87.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 50,
            x: 47,
            y: 30,
            z: -87.5
          },
          {
            hole: 51,
            x: 38,
            y: 30,
            z: -87.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 55,
            x: 7,
            y: 30,
            z: -87.5
          },
          {
            hole: 56,
            x: -2,
            y: 30,
            z: -87.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 60,
            x: -33,
            y: 30,
            z: -87.5
          },
          {
            hole: 61,
            x: -42,
            y: 30,
            z: -87.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 65,
            x: -73,
            y: 30,
            z: -87.5
          },
          {
            hole: 66,
            x: -82,
            y: 30,
            z: -87.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 70,
            x: -113,
            y: 30,
            z: -87.5
          },
          {
            hole: 71,
            x: -123.0593,
            y: 30,
            z: -87.318
          },
          {
            hole: 72,
            x: -128.5947,
            y: 30,
            z: -86.7728
          },
          {
            hole: 73,
            x: -134.0827,
            y: 30,
            z: -85.8667
          },
          {
            hole: 74,
            x: -139.4996,
            y: 30,
            z: -84.6037
          },
          {
            hole: 75,
            x: -144.8223,
            y: 30,
            z: -82.989
          },
          {
            hole: 76,
            x: -155.0945,
            y: 30,
            z: -78.7342
          },
          {
            hole: 77,
            x: -160,
            y: 30,
            z: -76.1121
          },
          {
            hole: 78,
            x: -164.7234,
            y: 30,
            z: -73.1749
          },
          {
            hole: 79,
            x: -169.2447,
            y: 30,
            z: -69.935
          },
          {
            hole: 80,
            x: -173.5444,
            y: 30,
            z: -66.4064
          },
          {
            hole: 81,
            x: -181.4064,
            y: 30,
            z: -58.5444
          },
          {
            hole: 82,
            x: -184.935,
            y: 30,
            z: -54.2447
          },
          {
            hole: 83,
            x: -188.1749,
            y: 30,
            z: -49.7235
          },
          {
            hole: 84,
            x: -191.1122,
            y: 30,
            z: -45
          },
          {
            hole: 85,
            x: -193.7342,
            y: 30,
            z: -40.0945
          },
          {
            hole: 86,
            x: -197.9891,
            y: 30,
            z: -29.8224
          },
          {
            hole: 87,
            x: -199.6037,
            y: 30,
            z: -24.4996
          },
          {
            hole: 88,
            x: -200.8668,
            y: 30,
            z: -19.0827
          },
          {
            hole: 89,
            x: -201.7728,
            y: 30,
            z: -13.5947
          },
          {
            hole: 90,
            x: -202.318,
            y: 30,
            z: -8.0593
          },
          {
            hole: 91,
            x: -202.318,
            y: 30,
            z: 3.0593
          },
          {
            hole: 92,
            x: -201.7728,
            y: 30,
            z: 8.5947
          },
          {
            hole: 93,
            x: -200.8668,
            y: 30,
            z: 14.0827
          },
          {
            hole: 94,
            x: -199.6037,
            y: 30,
            z: 19.4996
          },
          {
            hole: 95,
            x: -197.9891,
            y: 30,
            z: 24.8224
          },
          {
            hole: 96,
            x: -193.7342,
            y: 30,
            z: 35.0946
          },
          {
            hole: 97,
            x: -191.1122,
            y: 30,
            z: 40.0001
          },
          {
            hole: 98,
            x: -188.1749,
            y: 30,
            z: 44.7235
          },
          {
            hole: 99,
            x: -184.935,
            y: 30,
            z: 49.2448
          },
          {
            hole: 100,
            x: -181.4064,
            y: 30,
            z: 53.5444
          },
          {
            hole: 101,
            x: -173.5444,
            y: 30,
            z: 61.4064
          },
          {
            hole: 102,
            x: -169.2447,
            y: 30,
            z: 64.9351
          },
          {
            hole: 103,
            x: -164.7235,
            y: 30,
            z: 68.1749
          },
          {
            hole: 104,
            x: -160,
            y: 30,
            z: 71.1122
          },
          {
            hole: 105,
            x: -155.0945,
            y: 30,
            z: 73.7342
          },
          {
            hole: 106,
            x: -144.8224,
            y: 30,
            z: 77.9891
          },
          {
            hole: 107,
            x: -139.4996,
            y: 30,
            z: 79.6037
          },
          {
            hole: 108,
            x: -134.0827,
            y: 30,
            z: 80.8667
          },
          {
            hole: 109,
            x: -128.5947,
            y: 30,
            z: 81.7728
          },
          {
            hole: 110,
            x: -123.0593,
            y: 30,
            z: 82.318
          },
          {
            hole: 111,
            x: -113,
            y: 30,
            z: 82.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 115,
            x: -82,
            y: 30,
            z: 82.5
          },
          {
            hole: 116,
            x: -73,
            y: 30,
            z: 82.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 120,
            x: -42,
            y: 30,
            z: 82.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 30,
            z: 82.5
          }
        ]
      }
    },
    {
      id: "board-basketball-court",
      name: "Basketball Court",
      brand: "crazy,pints,adult",
      desc: "basketball Court Cribbage 3D cribbage board (8.8 MB)",
      target: 121,
      trackCount: 4,
      thumbnailUrl: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/basketball-court-crazy-thumbnail.png?v=1792021029",
      modelUrl: "https://cdn.shopify.com/3d/models/44fb8729ec0418de/basketball-court-crazy.glb",
      cameraDefaults: {
        fov: 44,
        position: [
          0,
          48,
          38
        ],
        target: [
          0,
          0,
          0
        ],
        minDistance: 15,
        maxDistance: 95
      },
      lightingPreset: "studio",
      woodFinish: "walnut",
      coordinatesData: {
        p1: [
          {
            hole: 0,
            x: 29.5,
            y: 30,
            z: 82.3246
          },
          {
            hole: 1,
            x: 47,
            y: 60,
            z: 112.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 5,
            x: 78,
            y: 60,
            z: 112.5
          },
          {
            hole: 6,
            x: 90.0213,
            y: 60,
            z: 112.2538
          },
          {
            hole: 7,
            x: 97.5105,
            y: 60,
            z: 111.5162
          },
          {
            hole: 8,
            x: 104.9354,
            y: 60,
            z: 110.2903
          },
          {
            hole: 9,
            x: 112.2642,
            y: 60,
            z: 108.5815
          },
          {
            hole: 10,
            x: 119.4655,
            y: 60,
            z: 106.397
          },
          {
            hole: 11,
            x: 133.3631,
            y: 60,
            z: 100.6404
          },
          {
            hole: 12,
            x: 139.9999,
            y: 60,
            z: 97.0929
          },
          {
            hole: 13,
            x: 146.3905,
            y: 60,
            z: 93.119
          },
          {
            hole: 14,
            x: 152.5075,
            y: 60,
            z: 88.7356
          },
          {
            hole: 15,
            x: 158.3247,
            y: 60,
            z: 83.9616
          },
          {
            hole: 16,
            x: 168.9614,
            y: 60,
            z: 73.3247
          },
          {
            hole: 17,
            x: 173.7355,
            y: 60,
            z: 67.5075
          },
          {
            hole: 18,
            x: 178.1189,
            y: 60,
            z: 61.3905
          },
          {
            hole: 19,
            x: 182.0928,
            y: 60,
            z: 55
          },
          {
            hole: 20,
            x: 185.6402,
            y: 60,
            z: 48.3632
          },
          {
            hole: 21,
            x: 191.397,
            y: 60,
            z: 34.4655
          },
          {
            hole: 22,
            x: 193.5815,
            y: 60,
            z: 27.2642
          },
          {
            hole: 23,
            x: 195.2903,
            y: 60,
            z: 19.9354
          },
          {
            hole: 24,
            x: 196.5162,
            y: 60,
            z: 12.5105
          },
          {
            hole: 25,
            x: 197.2538,
            y: 60,
            z: 5.0214
          },
          {
            hole: 26,
            x: 197.2538,
            y: 60,
            z: -10.0214
          },
          {
            hole: 27,
            x: 196.5162,
            y: 60,
            z: -17.5105
          },
          {
            hole: 28,
            x: 195.2903,
            y: 60,
            z: -24.9354
          },
          {
            hole: 29,
            x: 193.5815,
            y: 60,
            z: -32.2642
          },
          {
            hole: 30,
            x: 191.397,
            y: 60,
            z: -39.4655
          },
          {
            hole: 31,
            x: 185.6403,
            y: 60,
            z: -53.3632
          },
          {
            hole: 32,
            x: 182.0929,
            y: 60,
            z: -60
          },
          {
            hole: 33,
            x: 178.119,
            y: 60,
            z: -66.3906
          },
          {
            hole: 34,
            x: 173.7356,
            y: 60,
            z: -72.5076
          },
          {
            hole: 35,
            x: 168.9615,
            y: 60,
            z: -78.3248
          },
          {
            hole: 36,
            x: 158.3247,
            y: 60,
            z: -88.9616
          },
          {
            hole: 37,
            x: 152.5075,
            y: 60,
            z: -93.7356
          },
          {
            hole: 38,
            x: 146.3905,
            y: 60,
            z: -98.119
          },
          {
            hole: 39,
            x: 140,
            y: 60,
            z: -102.0929
          },
          {
            hole: 40,
            x: 133.3632,
            y: 60,
            z: -105.6404
          },
          {
            hole: 41,
            x: 119.4655,
            y: 60,
            z: -111.397
          },
          {
            hole: 42,
            x: 112.2642,
            y: 60,
            z: -113.5815
          },
          {
            hole: 43,
            x: 104.9354,
            y: 60,
            z: -115.2903
          },
          {
            hole: 44,
            x: 97.5105,
            y: 60,
            z: -116.5162
          },
          {
            hole: 45,
            x: 90.0214,
            y: 60,
            z: -117.2538
          },
          {
            hole: 46,
            x: 78,
            y: 60,
            z: -117.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 50,
            x: 47,
            y: 60,
            z: -117.5
          },
          {
            hole: 51,
            x: 38,
            y: 60,
            z: -117.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 55,
            x: 7,
            y: 60,
            z: -117.5
          },
          {
            hole: 56,
            x: -2,
            y: 60,
            z: -117.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 60,
            x: -33,
            y: 60,
            z: -117.5
          },
          {
            hole: 61,
            x: -42,
            y: 60,
            z: -117.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 65,
            x: -73,
            y: 60,
            z: -117.5
          },
          {
            hole: 66,
            x: -82,
            y: 60,
            z: -117.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 60,
            z: -117.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 60,
            z: -117.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 60,
            z: -117.5
          },
          {
            hole: 70,
            x: -113,
            y: 60,
            z: -117.5
          },
          {
            hole: 71,
            x: -125.0214,
            y: 60,
            z: -117.2538
          },
          {
            hole: 72,
            x: -132.5105,
            y: 60,
            z: -116.5161
          },
          {
            hole: 73,
            x: -139.9354,
            y: 60,
            z: -115.2903
          },
          {
            hole: 74,
            x: -147.2642,
            y: 60,
            z: -113.5815
          },
          {
            hole: 75,
            x: -154.4655,
            y: 60,
            z: -111.3969
          },
          {
            hole: 76,
            x: -168.3632,
            y: 60,
            z: -105.6403
          },
          {
            hole: 77,
            x: -175,
            y: 60,
            z: -102.0929
          },
          {
            hole: 78,
            x: -181.3906,
            y: 60,
            z: -98.119
          },
          {
            hole: 79,
            x: -187.5075,
            y: 60,
            z: -93.7356
          },
          {
            hole: 80,
            x: -193.3247,
            y: 60,
            z: -88.9616
          },
          {
            hole: 81,
            x: -203.9616,
            y: 60,
            z: -78.3248
          },
          {
            hole: 82,
            x: -208.7356,
            y: 60,
            z: -72.5076
          },
          {
            hole: 83,
            x: -213.119,
            y: 60,
            z: -66.3906
          },
          {
            hole: 84,
            x: -217.0929,
            y: 60,
            z: -60
          },
          {
            hole: 85,
            x: -220.6404,
            y: 60,
            z: -53.3632
          },
          {
            hole: 86,
            x: -226.397,
            y: 60,
            z: -39.4655
          },
          {
            hole: 87,
            x: -228.5815,
            y: 60,
            z: -32.2642
          },
          {
            hole: 88,
            x: -230.2903,
            y: 60,
            z: -24.9354
          },
          {
            hole: 89,
            x: -231.5162,
            y: 60,
            z: -17.5105
          },
          {
            hole: 90,
            x: -232.2538,
            y: 60,
            z: -10.0214
          },
          {
            hole: 91,
            x: -232.2538,
            y: 60,
            z: 5.0214
          },
          {
            hole: 92,
            x: -231.5162,
            y: 60,
            z: 12.5105
          },
          {
            hole: 93,
            x: -230.2903,
            y: 60,
            z: 19.9354
          },
          {
            hole: 94,
            x: -228.5815,
            y: 60,
            z: 27.2642
          },
          {
            hole: 95,
            x: -226.397,
            y: 60,
            z: 34.4655
          },
          {
            hole: 96,
            x: -220.6404,
            y: 60,
            z: 48.3633
          },
          {
            hole: 97,
            x: -217.0929,
            y: 60,
            z: 55.0001
          },
          {
            hole: 98,
            x: -213.119,
            y: 60,
            z: 61.3906
          },
          {
            hole: 99,
            x: -208.7356,
            y: 60,
            z: 67.5076
          },
          {
            hole: 100,
            x: -203.9616,
            y: 60,
            z: 73.3248
          },
          {
            hole: 101,
            x: -193.3248,
            y: 60,
            z: 83.9616
          },
          {
            hole: 102,
            x: -187.5076,
            y: 60,
            z: 88.7357
          },
          {
            hole: 103,
            x: -181.3906,
            y: 60,
            z: 93.119
          },
          {
            hole: 104,
            x: -175,
            y: 60,
            z: 97.0929
          },
          {
            hole: 105,
            x: -168.3632,
            y: 60,
            z: 100.6404
          },
          {
            hole: 106,
            x: -154.4655,
            y: 60,
            z: 106.397
          },
          {
            hole: 107,
            x: -147.2642,
            y: 60,
            z: 108.5815
          },
          {
            hole: 108,
            x: -139.9354,
            y: 60,
            z: 110.2903
          },
          {
            hole: 109,
            x: -132.5105,
            y: 60,
            z: 111.5162
          },
          {
            hole: 110,
            x: -125.0214,
            y: 60,
            z: 112.2538
          },
          {
            hole: 111,
            x: -113,
            y: 60,
            z: 112.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 115,
            x: -82,
            y: 60,
            z: 112.5
          },
          {
            hole: 116,
            x: -73,
            y: 60,
            z: 112.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 60,
            z: 112.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 60,
            z: 112.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 60,
            z: 112.5
          },
          {
            hole: 120,
            x: -42,
            y: 60,
            z: 112.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 60,
            z: 112.5
          }
        ],
        p2: [
          {
            hole: 0,
            x: 29.5,
            y: 40,
            z: 92.3246
          },
          {
            hole: 1,
            x: 47,
            y: 50,
            z: 102.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 5,
            x: 78,
            y: 50,
            z: 102.5
          },
          {
            hole: 6,
            x: 89.3673,
            y: 50,
            z: 102.2752
          },
          {
            hole: 7,
            x: 96.2052,
            y: 50,
            z: 101.6017
          },
          {
            hole: 8,
            x: 102.9845,
            y: 50,
            z: 100.4825
          },
          {
            hole: 9,
            x: 109.676,
            y: 50,
            z: 98.9222
          },
          {
            hole: 10,
            x: 116.2511,
            y: 50,
            z: 96.9277
          },
          {
            hole: 11,
            x: 128.9403,
            y: 50,
            z: 91.6716
          },
          {
            hole: 12,
            x: 134.9999,
            y: 50,
            z: 88.4327
          },
          {
            hole: 13,
            x: 140.8348,
            y: 50,
            z: 84.8043
          },
          {
            hole: 14,
            x: 146.4199,
            y: 50,
            z: 80.8021
          },
          {
            hole: 15,
            x: 151.7313,
            y: 50,
            z: 76.4432
          },
          {
            hole: 16,
            x: 161.443,
            y: 50,
            z: 66.7313
          },
          {
            hole: 17,
            x: 165.802,
            y: 50,
            z: 61.4199
          },
          {
            hole: 18,
            x: 169.8042,
            y: 50,
            z: 55.8348
          },
          {
            hole: 19,
            x: 173.4325,
            y: 50,
            z: 50
          },
          {
            hole: 20,
            x: 176.6715,
            y: 50,
            z: 43.9403
          },
          {
            hole: 21,
            x: 181.9277,
            y: 50,
            z: 31.2512
          },
          {
            hole: 22,
            x: 183.9222,
            y: 50,
            z: 24.676
          },
          {
            hole: 23,
            x: 185.4825,
            y: 50,
            z: 17.9845
          },
          {
            hole: 24,
            x: 186.6017,
            y: 50,
            z: 11.2053
          },
          {
            hole: 25,
            x: 187.2752,
            y: 50,
            z: 4.3673
          },
          {
            hole: 26,
            x: 187.2752,
            y: 50,
            z: -9.3673
          },
          {
            hole: 27,
            x: 186.6017,
            y: 50,
            z: -16.2052
          },
          {
            hole: 28,
            x: 185.4825,
            y: 50,
            z: -22.9845
          },
          {
            hole: 29,
            x: 183.9222,
            y: 50,
            z: -29.676
          },
          {
            hole: 30,
            x: 181.9277,
            y: 50,
            z: -36.2511
          },
          {
            hole: 31,
            x: 176.6716,
            y: 50,
            z: -48.9403
          },
          {
            hole: 32,
            x: 173.4326,
            y: 50,
            z: -55
          },
          {
            hole: 33,
            x: 169.8043,
            y: 50,
            z: -60.8349
          },
          {
            hole: 34,
            x: 165.8021,
            y: 50,
            z: -66.4199
          },
          {
            hole: 35,
            x: 161.4431,
            y: 50,
            z: -71.7313
          },
          {
            hole: 36,
            x: 151.7313,
            y: 50,
            z: -81.4432
          },
          {
            hole: 37,
            x: 146.4199,
            y: 50,
            z: -85.8021
          },
          {
            hole: 38,
            x: 140.8348,
            y: 50,
            z: -89.8043
          },
          {
            hole: 39,
            x: 135,
            y: 50,
            z: -93.4327
          },
          {
            hole: 40,
            x: 128.9403,
            y: 50,
            z: -96.6716
          },
          {
            hole: 41,
            x: 116.2511,
            y: 50,
            z: -101.9277
          },
          {
            hole: 42,
            x: 109.676,
            y: 50,
            z: -103.9222
          },
          {
            hole: 43,
            x: 102.9845,
            y: 50,
            z: -105.4825
          },
          {
            hole: 44,
            x: 96.2053,
            y: 50,
            z: -106.6017
          },
          {
            hole: 45,
            x: 89.3673,
            y: 50,
            z: -107.2752
          },
          {
            hole: 46,
            x: 78,
            y: 50,
            z: -107.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 50,
            x: 47,
            y: 50,
            z: -107.5
          },
          {
            hole: 51,
            x: 38,
            y: 50,
            z: -107.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 55,
            x: 7,
            y: 50,
            z: -107.5
          },
          {
            hole: 56,
            x: -2,
            y: 50,
            z: -107.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 60,
            x: -33,
            y: 50,
            z: -107.5
          },
          {
            hole: 61,
            x: -42,
            y: 50,
            z: -107.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 65,
            x: -73,
            y: 50,
            z: -107.5
          },
          {
            hole: 66,
            x: -82,
            y: 50,
            z: -107.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 50,
            z: -107.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 50,
            z: -107.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 50,
            z: -107.5
          },
          {
            hole: 70,
            x: -113,
            y: 50,
            z: -107.5
          },
          {
            hole: 71,
            x: -124.3673,
            y: 50,
            z: -107.2752
          },
          {
            hole: 72,
            x: -131.2052,
            y: 50,
            z: -106.6017
          },
          {
            hole: 73,
            x: -137.9845,
            y: 50,
            z: -105.4824
          },
          {
            hole: 74,
            x: -144.676,
            y: 50,
            z: -103.9222
          },
          {
            hole: 75,
            x: -151.2511,
            y: 50,
            z: -101.9276
          },
          {
            hole: 76,
            x: -163.9403,
            y: 50,
            z: -96.6716
          },
          {
            hole: 77,
            x: -170,
            y: 50,
            z: -93.4326
          },
          {
            hole: 78,
            x: -175.8349,
            y: 50,
            z: -89.8043
          },
          {
            hole: 79,
            x: -181.4199,
            y: 50,
            z: -85.8021
          },
          {
            hole: 80,
            x: -186.7313,
            y: 50,
            z: -81.4432
          },
          {
            hole: 81,
            x: -196.4432,
            y: 50,
            z: -71.7313
          },
          {
            hole: 82,
            x: -200.8021,
            y: 50,
            z: -66.42
          },
          {
            hole: 83,
            x: -204.8043,
            y: 50,
            z: -60.8349
          },
          {
            hole: 84,
            x: -208.4327,
            y: 50,
            z: -55
          },
          {
            hole: 85,
            x: -211.6716,
            y: 50,
            z: -48.9403
          },
          {
            hole: 86,
            x: -216.9277,
            y: 50,
            z: -36.2511
          },
          {
            hole: 87,
            x: -218.9222,
            y: 50,
            z: -29.676
          },
          {
            hole: 88,
            x: -220.4825,
            y: 50,
            z: -22.9845
          },
          {
            hole: 89,
            x: -221.6017,
            y: 50,
            z: -16.2053
          },
          {
            hole: 90,
            x: -222.2752,
            y: 50,
            z: -9.3673
          },
          {
            hole: 91,
            x: -222.2752,
            y: 50,
            z: 4.3673
          },
          {
            hole: 92,
            x: -221.6017,
            y: 50,
            z: 11.2053
          },
          {
            hole: 93,
            x: -220.4825,
            y: 50,
            z: 17.9845
          },
          {
            hole: 94,
            x: -218.9222,
            y: 50,
            z: 24.676
          },
          {
            hole: 95,
            x: -216.9277,
            y: 50,
            z: 31.2512
          },
          {
            hole: 96,
            x: -211.6716,
            y: 50,
            z: 43.9404
          },
          {
            hole: 97,
            x: -208.4327,
            y: 50,
            z: 50.0001
          },
          {
            hole: 98,
            x: -204.8043,
            y: 50,
            z: 55.8349
          },
          {
            hole: 99,
            x: -200.8021,
            y: 50,
            z: 61.42
          },
          {
            hole: 100,
            x: -196.4432,
            y: 50,
            z: 66.7314
          },
          {
            hole: 101,
            x: -186.7313,
            y: 50,
            z: 76.4432
          },
          {
            hole: 102,
            x: -181.4199,
            y: 50,
            z: 80.8021
          },
          {
            hole: 103,
            x: -175.8349,
            y: 50,
            z: 84.8043
          },
          {
            hole: 104,
            x: -170,
            y: 50,
            z: 88.4327
          },
          {
            hole: 105,
            x: -163.9403,
            y: 50,
            z: 91.6717
          },
          {
            hole: 106,
            x: -151.2511,
            y: 50,
            z: 96.9277
          },
          {
            hole: 107,
            x: -144.676,
            y: 50,
            z: 98.9222
          },
          {
            hole: 108,
            x: -137.9845,
            y: 50,
            z: 100.4825
          },
          {
            hole: 109,
            x: -131.2053,
            y: 50,
            z: 101.6017
          },
          {
            hole: 110,
            x: -124.3673,
            y: 50,
            z: 102.2752
          },
          {
            hole: 111,
            x: -113,
            y: 50,
            z: 102.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 115,
            x: -82,
            y: 50,
            z: 102.5
          },
          {
            hole: 116,
            x: -73,
            y: 50,
            z: 102.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 50,
            z: 102.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 50,
            z: 102.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 50,
            z: 102.5
          },
          {
            hole: 120,
            x: -42,
            y: 50,
            z: 102.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 50,
            z: 102.5
          }
        ],
        p3: [
          {
            hole: 0,
            x: 29.5,
            y: 50,
            z: 102.3246
          },
          {
            hole: 1,
            x: 47,
            y: 40,
            z: 92.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 5,
            x: 78,
            y: 40,
            z: 92.5
          },
          {
            hole: 6,
            x: 88.7133,
            y: 40,
            z: 92.2966
          },
          {
            hole: 7,
            x: 94.9,
            y: 40,
            z: 91.6873
          },
          {
            hole: 8,
            x: 101.0336,
            y: 40,
            z: 90.6746
          },
          {
            hole: 9,
            x: 107.0878,
            y: 40,
            z: 89.263
          },
          {
            hole: 10,
            x: 113.0367,
            y: 40,
            z: 87.4584
          },
          {
            hole: 11,
            x: 124.5174,
            y: 40,
            z: 82.7029
          },
          {
            hole: 12,
            x: 129.9999,
            y: 40,
            z: 79.7724
          },
          {
            hole: 13,
            x: 135.2791,
            y: 40,
            z: 76.4896
          },
          {
            hole: 14,
            x: 140.3323,
            y: 40,
            z: 72.8686
          },
          {
            hole: 15,
            x: 145.1378,
            y: 40,
            z: 68.9248
          },
          {
            hole: 16,
            x: 153.9246,
            y: 40,
            z: 60.1378
          },
          {
            hole: 17,
            x: 157.8684,
            y: 40,
            z: 55.3323
          },
          {
            hole: 18,
            x: 161.4895,
            y: 40,
            z: 50.2791
          },
          {
            hole: 19,
            x: 164.7723,
            y: 40,
            z: 45
          },
          {
            hole: 20,
            x: 167.7028,
            y: 40,
            z: 39.5174
          },
          {
            hole: 21,
            x: 172.4584,
            y: 40,
            z: 28.0368
          },
          {
            hole: 22,
            x: 174.263,
            y: 40,
            z: 22.0878
          },
          {
            hole: 23,
            x: 175.6746,
            y: 40,
            z: 16.0336
          },
          {
            hole: 24,
            x: 176.6873,
            y: 40,
            z: 9.9
          },
          {
            hole: 25,
            x: 177.2966,
            y: 40,
            z: 3.7133
          },
          {
            hole: 26,
            x: 177.2966,
            y: 40,
            z: -8.7133
          },
          {
            hole: 27,
            x: 176.6873,
            y: 40,
            z: -14.9
          },
          {
            hole: 28,
            x: 175.6746,
            y: 40,
            z: -21.0336
          },
          {
            hole: 29,
            x: 174.263,
            y: 40,
            z: -27.0878
          },
          {
            hole: 30,
            x: 172.4584,
            y: 40,
            z: -33.0367
          },
          {
            hole: 31,
            x: 167.7029,
            y: 40,
            z: -44.5174
          },
          {
            hole: 32,
            x: 164.7724,
            y: 40,
            z: -50
          },
          {
            hole: 33,
            x: 161.4896,
            y: 40,
            z: -55.2792
          },
          {
            hole: 34,
            x: 157.8685,
            y: 40,
            z: -60.3323
          },
          {
            hole: 35,
            x: 153.9247,
            y: 40,
            z: -65.1378
          },
          {
            hole: 36,
            x: 145.1378,
            y: 40,
            z: -73.9248
          },
          {
            hole: 37,
            x: 140.3323,
            y: 40,
            z: -77.8686
          },
          {
            hole: 38,
            x: 135.2791,
            y: 40,
            z: -81.4896
          },
          {
            hole: 39,
            x: 130,
            y: 40,
            z: -84.7724
          },
          {
            hole: 40,
            x: 124.5174,
            y: 40,
            z: -87.7029
          },
          {
            hole: 41,
            x: 113.0367,
            y: 40,
            z: -92.4584
          },
          {
            hole: 42,
            x: 107.0878,
            y: 40,
            z: -94.263
          },
          {
            hole: 43,
            x: 101.0336,
            y: 40,
            z: -95.6746
          },
          {
            hole: 44,
            x: 94.9,
            y: 40,
            z: -96.6873
          },
          {
            hole: 45,
            x: 88.7133,
            y: 40,
            z: -97.2966
          },
          {
            hole: 46,
            x: 78,
            y: 40,
            z: -97.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 50,
            x: 47,
            y: 40,
            z: -97.5
          },
          {
            hole: 51,
            x: 38,
            y: 40,
            z: -97.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 55,
            x: 7,
            y: 40,
            z: -97.5
          },
          {
            hole: 56,
            x: -2,
            y: 40,
            z: -97.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 60,
            x: -33,
            y: 40,
            z: -97.5
          },
          {
            hole: 61,
            x: -42,
            y: 40,
            z: -97.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 65,
            x: -73,
            y: 40,
            z: -97.5
          },
          {
            hole: 66,
            x: -82,
            y: 40,
            z: -97.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 40,
            z: -97.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 40,
            z: -97.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 40,
            z: -97.5
          },
          {
            hole: 70,
            x: -113,
            y: 40,
            z: -97.5
          },
          {
            hole: 71,
            x: -123.7133,
            y: 40,
            z: -97.2966
          },
          {
            hole: 72,
            x: -129.9,
            y: 40,
            z: -96.6872
          },
          {
            hole: 73,
            x: -136.0336,
            y: 40,
            z: -95.6746
          },
          {
            hole: 74,
            x: -142.0878,
            y: 40,
            z: -94.2629
          },
          {
            hole: 75,
            x: -148.0367,
            y: 40,
            z: -92.4583
          },
          {
            hole: 76,
            x: -159.5174,
            y: 40,
            z: -87.7029
          },
          {
            hole: 77,
            x: -165,
            y: 40,
            z: -84.7724
          },
          {
            hole: 78,
            x: -170.2792,
            y: 40,
            z: -81.4896
          },
          {
            hole: 79,
            x: -175.3323,
            y: 40,
            z: -77.8685
          },
          {
            hole: 80,
            x: -180.1378,
            y: 40,
            z: -73.9248
          },
          {
            hole: 81,
            x: -188.9248,
            y: 40,
            z: -65.1379
          },
          {
            hole: 82,
            x: -192.8686,
            y: 40,
            z: -60.3323
          },
          {
            hole: 83,
            x: -196.4896,
            y: 40,
            z: -55.2792
          },
          {
            hole: 84,
            x: -199.7724,
            y: 40,
            z: -50
          },
          {
            hole: 85,
            x: -202.7029,
            y: 40,
            z: -44.5174
          },
          {
            hole: 86,
            x: -207.4584,
            y: 40,
            z: -33.0367
          },
          {
            hole: 87,
            x: -209.263,
            y: 40,
            z: -27.0878
          },
          {
            hole: 88,
            x: -210.6746,
            y: 40,
            z: -21.0336
          },
          {
            hole: 89,
            x: -211.6873,
            y: 40,
            z: -14.9
          },
          {
            hole: 90,
            x: -212.2966,
            y: 40,
            z: -8.7133
          },
          {
            hole: 91,
            x: -212.2966,
            y: 40,
            z: 3.7133
          },
          {
            hole: 92,
            x: -211.6873,
            y: 40,
            z: 9.9
          },
          {
            hole: 93,
            x: -210.6746,
            y: 40,
            z: 16.0336
          },
          {
            hole: 94,
            x: -209.263,
            y: 40,
            z: 22.0878
          },
          {
            hole: 95,
            x: -207.4584,
            y: 40,
            z: 28.0368
          },
          {
            hole: 96,
            x: -202.7029,
            y: 40,
            z: 39.5175
          },
          {
            hole: 97,
            x: -199.7724,
            y: 40,
            z: 45.0001
          },
          {
            hole: 98,
            x: -196.4896,
            y: 40,
            z: 50.2792
          },
          {
            hole: 99,
            x: -192.8686,
            y: 40,
            z: 55.3324
          },
          {
            hole: 100,
            x: -188.9248,
            y: 40,
            z: 60.1379
          },
          {
            hole: 101,
            x: -180.1378,
            y: 40,
            z: 68.9248
          },
          {
            hole: 102,
            x: -175.3323,
            y: 40,
            z: 72.8686
          },
          {
            hole: 103,
            x: -170.2792,
            y: 40,
            z: 76.4896
          },
          {
            hole: 104,
            x: -165,
            y: 40,
            z: 79.7724
          },
          {
            hole: 105,
            x: -159.5174,
            y: 40,
            z: 82.7029
          },
          {
            hole: 106,
            x: -148.0367,
            y: 40,
            z: 87.4584
          },
          {
            hole: 107,
            x: -142.0878,
            y: 40,
            z: 89.263
          },
          {
            hole: 108,
            x: -136.0336,
            y: 40,
            z: 90.6746
          },
          {
            hole: 109,
            x: -129.9,
            y: 40,
            z: 91.6873
          },
          {
            hole: 110,
            x: -123.7133,
            y: 40,
            z: 92.2966
          },
          {
            hole: 111,
            x: -113,
            y: 40,
            z: 92.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 115,
            x: -82,
            y: 40,
            z: 92.5
          },
          {
            hole: 116,
            x: -73,
            y: 40,
            z: 92.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 40,
            z: 92.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 40,
            z: 92.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 40,
            z: 92.5
          },
          {
            hole: 120,
            x: -42,
            y: 40,
            z: 92.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 40,
            z: 92.5
          }
        ],
        p4: [
          {
            hole: 0,
            x: 29.5,
            y: 60,
            z: 112.3246
          },
          {
            hole: 1,
            x: 47,
            y: 30,
            z: 82.5
          },
          {
            hole: 2,
            x: 54.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 3,
            x: 62.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 4,
            x: 70.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 5,
            x: 78,
            y: 30,
            z: 82.5
          },
          {
            hole: 6,
            x: 88.0592,
            y: 30,
            z: 82.318
          },
          {
            hole: 7,
            x: 93.5947,
            y: 30,
            z: 81.7728
          },
          {
            hole: 8,
            x: 99.0827,
            y: 30,
            z: 80.8668
          },
          {
            hole: 9,
            x: 104.4996,
            y: 30,
            z: 79.6037
          },
          {
            hole: 10,
            x: 109.8223,
            y: 30,
            z: 77.9891
          },
          {
            hole: 11,
            x: 120.0945,
            y: 30,
            z: 73.7342
          },
          {
            hole: 12,
            x: 124.9999,
            y: 30,
            z: 71.1121
          },
          {
            hole: 13,
            x: 129.7234,
            y: 30,
            z: 68.1749
          },
          {
            hole: 14,
            x: 134.2447,
            y: 30,
            z: 64.935
          },
          {
            hole: 15,
            x: 138.5443,
            y: 30,
            z: 61.4064
          },
          {
            hole: 16,
            x: 146.4063,
            y: 30,
            z: 53.5444
          },
          {
            hole: 17,
            x: 149.9349,
            y: 30,
            z: 49.2447
          },
          {
            hole: 18,
            x: 153.1748,
            y: 30,
            z: 44.7234
          },
          {
            hole: 19,
            x: 156.112,
            y: 30,
            z: 40
          },
          {
            hole: 20,
            x: 158.7341,
            y: 30,
            z: 35.0945
          },
          {
            hole: 21,
            x: 162.9891,
            y: 30,
            z: 24.8224
          },
          {
            hole: 22,
            x: 164.6037,
            y: 30,
            z: 19.4996
          },
          {
            hole: 23,
            x: 165.8668,
            y: 30,
            z: 14.0827
          },
          {
            hole: 24,
            x: 166.7728,
            y: 30,
            z: 8.5947
          },
          {
            hole: 25,
            x: 167.318,
            y: 30,
            z: 3.0593
          },
          {
            hole: 26,
            x: 167.318,
            y: 30,
            z: -8.0593
          },
          {
            hole: 27,
            x: 166.7728,
            y: 30,
            z: -13.5947
          },
          {
            hole: 28,
            x: 165.8668,
            y: 30,
            z: -19.0827
          },
          {
            hole: 29,
            x: 164.6037,
            y: 30,
            z: -24.4996
          },
          {
            hole: 30,
            x: 162.9891,
            y: 30,
            z: -29.8224
          },
          {
            hole: 31,
            x: 158.7341,
            y: 30,
            z: -40.0945
          },
          {
            hole: 32,
            x: 156.1121,
            y: 30,
            z: -45
          },
          {
            hole: 33,
            x: 153.1749,
            y: 30,
            z: -49.7235
          },
          {
            hole: 34,
            x: 149.935,
            y: 30,
            z: -54.2447
          },
          {
            hole: 35,
            x: 146.4063,
            y: 30,
            z: -58.5444
          },
          {
            hole: 36,
            x: 138.5444,
            y: 30,
            z: -66.4064
          },
          {
            hole: 37,
            x: 134.2447,
            y: 30,
            z: -69.935
          },
          {
            hole: 38,
            x: 129.7234,
            y: 30,
            z: -73.1749
          },
          {
            hole: 39,
            x: 125,
            y: 30,
            z: -76.1122
          },
          {
            hole: 40,
            x: 120.0945,
            y: 30,
            z: -78.7342
          },
          {
            hole: 41,
            x: 109.8224,
            y: 30,
            z: -82.9891
          },
          {
            hole: 42,
            x: 104.4996,
            y: 30,
            z: -84.6037
          },
          {
            hole: 43,
            x: 99.0827,
            y: 30,
            z: -85.8667
          },
          {
            hole: 44,
            x: 93.5947,
            y: 30,
            z: -86.7728
          },
          {
            hole: 45,
            x: 88.0593,
            y: 30,
            z: -87.318
          },
          {
            hole: 46,
            x: 78,
            y: 30,
            z: -87.5
          },
          {
            hole: 47,
            x: 70.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 48,
            x: 62.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 49,
            x: 54.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 50,
            x: 47,
            y: 30,
            z: -87.5
          },
          {
            hole: 51,
            x: 38,
            y: 30,
            z: -87.5
          },
          {
            hole: 52,
            x: 30.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 53,
            x: 22.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 54,
            x: 14.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 55,
            x: 7,
            y: 30,
            z: -87.5
          },
          {
            hole: 56,
            x: -2,
            y: 30,
            z: -87.5
          },
          {
            hole: 57,
            x: -9.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 58,
            x: -17.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 59,
            x: -25.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 60,
            x: -33,
            y: 30,
            z: -87.5
          },
          {
            hole: 61,
            x: -42,
            y: 30,
            z: -87.5
          },
          {
            hole: 62,
            x: -49.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 63,
            x: -57.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 64,
            x: -65.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 65,
            x: -73,
            y: 30,
            z: -87.5
          },
          {
            hole: 66,
            x: -82,
            y: 30,
            z: -87.5
          },
          {
            hole: 67,
            x: -89.75,
            y: 30,
            z: -87.5
          },
          {
            hole: 68,
            x: -97.5,
            y: 30,
            z: -87.5
          },
          {
            hole: 69,
            x: -105.25,
            y: 30,
            z: -87.5
          },
          {
            hole: 70,
            x: -113,
            y: 30,
            z: -87.5
          },
          {
            hole: 71,
            x: -123.0593,
            y: 30,
            z: -87.318
          },
          {
            hole: 72,
            x: -128.5947,
            y: 30,
            z: -86.7728
          },
          {
            hole: 73,
            x: -134.0827,
            y: 30,
            z: -85.8667
          },
          {
            hole: 74,
            x: -139.4996,
            y: 30,
            z: -84.6037
          },
          {
            hole: 75,
            x: -144.8223,
            y: 30,
            z: -82.989
          },
          {
            hole: 76,
            x: -155.0945,
            y: 30,
            z: -78.7342
          },
          {
            hole: 77,
            x: -160,
            y: 30,
            z: -76.1121
          },
          {
            hole: 78,
            x: -164.7234,
            y: 30,
            z: -73.1749
          },
          {
            hole: 79,
            x: -169.2447,
            y: 30,
            z: -69.935
          },
          {
            hole: 80,
            x: -173.5444,
            y: 30,
            z: -66.4064
          },
          {
            hole: 81,
            x: -181.4064,
            y: 30,
            z: -58.5444
          },
          {
            hole: 82,
            x: -184.935,
            y: 30,
            z: -54.2447
          },
          {
            hole: 83,
            x: -188.1749,
            y: 30,
            z: -49.7235
          },
          {
            hole: 84,
            x: -191.1122,
            y: 30,
            z: -45
          },
          {
            hole: 85,
            x: -193.7342,
            y: 30,
            z: -40.0945
          },
          {
            hole: 86,
            x: -197.9891,
            y: 30,
            z: -29.8224
          },
          {
            hole: 87,
            x: -199.6037,
            y: 30,
            z: -24.4996
          },
          {
            hole: 88,
            x: -200.8668,
            y: 30,
            z: -19.0827
          },
          {
            hole: 89,
            x: -201.7728,
            y: 30,
            z: -13.5947
          },
          {
            hole: 90,
            x: -202.318,
            y: 30,
            z: -8.0593
          },
          {
            hole: 91,
            x: -202.318,
            y: 30,
            z: 3.0593
          },
          {
            hole: 92,
            x: -201.7728,
            y: 30,
            z: 8.5947
          },
          {
            hole: 93,
            x: -200.8668,
            y: 30,
            z: 14.0827
          },
          {
            hole: 94,
            x: -199.6037,
            y: 30,
            z: 19.4996
          },
          {
            hole: 95,
            x: -197.9891,
            y: 30,
            z: 24.8224
          },
          {
            hole: 96,
            x: -193.7342,
            y: 30,
            z: 35.0946
          },
          {
            hole: 97,
            x: -191.1122,
            y: 30,
            z: 40.0001
          },
          {
            hole: 98,
            x: -188.1749,
            y: 30,
            z: 44.7235
          },
          {
            hole: 99,
            x: -184.935,
            y: 30,
            z: 49.2448
          },
          {
            hole: 100,
            x: -181.4064,
            y: 30,
            z: 53.5444
          },
          {
            hole: 101,
            x: -173.5444,
            y: 30,
            z: 61.4064
          },
          {
            hole: 102,
            x: -169.2447,
            y: 30,
            z: 64.9351
          },
          {
            hole: 103,
            x: -164.7235,
            y: 30,
            z: 68.1749
          },
          {
            hole: 104,
            x: -160,
            y: 30,
            z: 71.1122
          },
          {
            hole: 105,
            x: -155.0945,
            y: 30,
            z: 73.7342
          },
          {
            hole: 106,
            x: -144.8224,
            y: 30,
            z: 77.9891
          },
          {
            hole: 107,
            x: -139.4996,
            y: 30,
            z: 79.6037
          },
          {
            hole: 108,
            x: -134.0827,
            y: 30,
            z: 80.8667
          },
          {
            hole: 109,
            x: -128.5947,
            y: 30,
            z: 81.7728
          },
          {
            hole: 110,
            x: -123.0593,
            y: 30,
            z: 82.318
          },
          {
            hole: 111,
            x: -113,
            y: 30,
            z: 82.5
          },
          {
            hole: 112,
            x: -105.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 113,
            x: -97.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 114,
            x: -89.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 115,
            x: -82,
            y: 30,
            z: 82.5
          },
          {
            hole: 116,
            x: -73,
            y: 30,
            z: 82.5
          },
          {
            hole: 117,
            x: -65.25,
            y: 30,
            z: 82.5
          },
          {
            hole: 118,
            x: -57.5,
            y: 30,
            z: 82.5
          },
          {
            hole: 119,
            x: -49.75,
            y: 30,
            z: 82.5
          },
          {
            hole: 120,
            x: -42,
            y: 30,
            z: 82.5
          },
          {
            hole: 121,
            x: -17.5,
            y: 30,
            z: 82.5
          }
        ]
      }
    }
  ];

  // src/board/Board3DCatalog.js
  var DEFAULT_3D_BOARDS = Array.isArray(default_boards_default) ? default_boards_default.map((b) => Object.assign({}, b)) : [];
  var Board3DCatalog = class _Board3DCatalog {
    static CUSTOM_STORAGE_KEY = "cc_custom_3d_boards";
    static DEFAULT_JSON_PATH = "boards/default-boards.json";
    static _fallbackBoards = DEFAULT_3D_BOARDS.map((b) => Object.assign({}, b));
    static _boards = new Map(DEFAULT_3D_BOARDS.map((b) => [b.id, Object.assign({}, b)]));
    static _customBoards = /* @__PURE__ */ new Map();
    static _customLoaded = false;
    static _jsonLoaded = false;
    static _jsonLoadPromise = null;
    static _jsonSource = null;
    /**
     * Returns whether default boards have been loaded from an external JSON source.
     * @returns {boolean}
     */
    static get jsonLoaded() {
      return this._jsonLoaded;
    }
    /**
     * Returns the source URL/path of the loaded JSON boards, or null if using built-in defaults.
     * @returns {string|null}
     */
    static get jsonSource() {
      return this._jsonSource;
    }
    /**
     * Returns the list of currently registered default 3D boards.
     * @returns {Array<Object>}
     */
    static get defaultBoards() {
      return Array.from(this._boards.values());
    }
    /**
     * Loads default 3D boards from an external JSON file, URL, raw JSON string, or object.
     * Updates Board3DCatalog._boards and DEFAULT_3D_BOARDS without requiring bundle recompilation.
     *
     * @param {string|Array|Object|File|Blob} [source=null] - JSON URL, file path, board array, object, or File instance.
     * @param {Object} [options={}]
     * @param {boolean} [options.replace=true] - If true, replaces default boards; if false, merges by ID.
     * @param {boolean} [options.syncDropdown=true] - If true, syncs the DOM #opt3DBoard dropdown after load.
     * @param {boolean} [options.notify=true] - If true, dispatches 'board3d:boards-loaded' event on document.
     * @returns {Promise<{ success: boolean, count: number, boards: Array<Object>, source: string|null, error?: string }>}
     */
    static async loadDefaultBoards(source = null, options = {}) {
      const replace = options.replace !== false;
      const syncDropdown = options.syncDropdown !== false;
      const notify = options.notify !== false;
      let rawData = null;
      let resolvedSource = null;
      try {
        if (Array.isArray(source)) {
          rawData = source;
          resolvedSource = "direct-array";
        } else if (source && typeof source === "object" && !(typeof Blob !== "undefined" && source instanceof Blob)) {
          rawData = source.boards || source.defaultBoards || source.list || source;
          resolvedSource = "direct-object";
        } else if (typeof Blob !== "undefined" && source instanceof Blob) {
          const text2 = await source.text();
          rawData = JSON.parse(text2);
          resolvedSource = source.name || "file-upload";
        } else if (typeof source === "string" && (source.trim().startsWith("[") || source.trim().startsWith("{"))) {
          rawData = JSON.parse(source.trim());
          resolvedSource = "raw-json-string";
        } else {
          const candidates = [];
          if (source && typeof source === "string") {
            candidates.push(source);
          } else {
            if (typeof window !== "undefined" && window.BOARDS_JSON_URL) {
              candidates.push(window.BOARDS_JSON_URL);
            }
            if (typeof window !== "undefined" && window.DEFAULT_3D_BOARDS_URL) {
              candidates.push(window.DEFAULT_3D_BOARDS_URL);
            }
            if (typeof document !== "undefined") {
              const meta = document.querySelector('meta[name="boards-json"], meta[name="boards-config"]');
              if (meta?.content) candidates.push(meta.content);
            }
            candidates.push(this.DEFAULT_JSON_PATH);
            candidates.push("boards/boards-config.json");
            candidates.push("./boards/default-boards.json");
            candidates.push("./boards/boards-config.json");
            candidates.push("/boards/default-boards.json");
            candidates.push("/boards/boards-config.json");
          }
          let fetchErr = null;
          for (const candidate of candidates) {
            try {
              if (typeof fetch === "function") {
                const isHttp = typeof window !== "undefined" && window.location?.protocol !== "file:" || typeof candidate === "string" && (candidate.startsWith("http://") || candidate.startsWith("https://") || candidate.startsWith("/"));
                const fetchUrl = isHttp ? `${candidate}${candidate.includes("?") ? "&" : "?"}t=${Date.now()}` : candidate;
                const res = await fetch(fetchUrl, { cache: "no-cache" });
                if (res.ok) {
                  rawData = await res.json();
                  resolvedSource = candidate;
                  break;
                } else {
                  fetchErr = new Error(`HTTP ${res.status} ${res.statusText} from ${candidate}`);
                }
              } else if (typeof process !== "undefined" && process.versions?.node) {
                try {
                  const fs = await import("fs/promises");
                  const path = await import("path");
                  const filePath = path.resolve(process.cwd(), candidate);
                  const content = await fs.readFile(filePath, "utf8");
                  rawData = JSON.parse(content);
                  resolvedSource = candidate;
                  break;
                } catch (nodeErr) {
                  fetchErr = nodeErr;
                }
              }
            } catch (e) {
              fetchErr = e;
            }
          }
          if (!rawData && typeof process !== "undefined" && process.versions?.node) {
            for (const candidate of candidates) {
              try {
                const fs = await import("fs/promises");
                const path = await import("path");
                const filePath = path.resolve(process.cwd(), candidate);
                const content = await fs.readFile(filePath, "utf8");
                rawData = JSON.parse(content);
                resolvedSource = candidate;
                break;
              } catch (_) {
              }
            }
          }
          if (!rawData) {
            throw fetchErr || new Error("Could not resolve or load boards JSON from candidate paths");
          }
        }
        let boardsList = rawData;
        if (!Array.isArray(boardsList) && boardsList && typeof boardsList === "object") {
          boardsList = boardsList.boards || boardsList.defaultBoards || boardsList.list || Object.values(boardsList);
        }
        if (!Array.isArray(boardsList) || boardsList.length === 0) {
          throw new Error("Loaded JSON does not contain a valid non-empty array of board configurations");
        }
        const cleanBoards = [];
        for (const item of boardsList) {
          if (!item || typeof item !== "object") continue;
          const validRes = this.validateBoardConfig(item);
          if (!validRes.valid) {
            console.warn(`[Board3DCatalog] Skipping invalid board "${item?.id || "unknown"}":`, validRes.error);
            continue;
          }
          const clean = {
            id: String(item.id).trim(),
            name: String(item.name).trim(),
            brand: item.brand || "crazy,pints,adult",
            desc: String(item.desc || "").trim(),
            target: Number(item.target) || 121,
            trackCount: Number(item.trackCount) || 3,
            thumbnailUrl: String(item.thumbnailUrl || "").trim(),
            modelUrl: String(item.modelUrl || "").trim(),
            holeSpacing: typeof item.holeSpacing === "number" ? item.holeSpacing : 7.5,
            cameraDefaults: Object.assign({
              fov: 44,
              position: [0, 48, 38],
              target: [0, 0, 0],
              minDistance: 15,
              maxDistance: 95
            }, item.cameraDefaults || {}),
            lightingPreset: item.lightingPreset || "studio",
            woodFinish: item.woodFinish || "maple",
            coordinatesData: item.coordinatesData !== void 0 ? item.coordinatesData : item.holeData || null,
            holeData: item.coordinatesData !== void 0 ? item.coordinatesData : item.holeData || null,
            isCustom: Boolean(item.isCustom)
          };
          cleanBoards.push(clean);
        }
        if (cleanBoards.length === 0) {
          throw new Error("No valid board configurations could be parsed from the JSON source");
        }
        if (replace) {
          this._boards.clear();
        }
        for (const b of cleanBoards) {
          this._boards.set(b.id, b);
        }
        if (Array.isArray(DEFAULT_3D_BOARDS)) {
          DEFAULT_3D_BOARDS.length = 0;
          DEFAULT_3D_BOARDS.push(...cleanBoards);
        }
        if (typeof window !== "undefined") {
          window.DEFAULT_3D_BOARDS = DEFAULT_3D_BOARDS;
        }
        this._jsonLoaded = true;
        this._jsonSource = resolvedSource;
        if (syncDropdown) {
          this.syncDropdownOptions();
        }
        if (notify && typeof document !== "undefined") {
          try {
            document.dispatchEvent(new CustomEvent("board3d:boards-loaded", {
              detail: {
                boards: this.getBoards(),
                defaultBoards: cleanBoards,
                source: resolvedSource,
                count: cleanBoards.length
              }
            }));
          } catch (_) {
          }
        }
        console.info(`[Board3DCatalog] Successfully loaded ${cleanBoards.length} boards from JSON (${resolvedSource}) without rebuilding!`);
        return {
          success: true,
          count: cleanBoards.length,
          boards: cleanBoards,
          source: resolvedSource
        };
      } catch (err) {
        console.warn("[Board3DCatalog] Failed to load boards from JSON, falling back to embedded defaults:", err?.message || err);
        return {
          success: false,
          error: err?.message || String(err),
          boards: Array.from(this._boards.values()),
          source: null
        };
      }
    }
    /**
     * Convenience alias for loadDefaultBoards.
     * @param {string|Array|Object|File|Blob} [source=null]
     * @param {Object} [options={}]
     * @returns {Promise<{ success: boolean, count: number, boards: Array<Object>, source: string|null, error?: string }>}
     */
    static async loadFromJson(source = null, options = {}) {
      return this.loadDefaultBoards(source, options);
    }
    /**
     * Automatically initiates loading default boards from the JSON config file.
     * Deduplicates concurrent calls.
     * @returns {Promise<{ success: boolean, boards: Array<Object> }>}
     */
    static autoLoad() {
      if (this._jsonLoaded) {
        return Promise.resolve({
          success: true,
          count: this._boards.size,
          boards: Array.from(this._boards.values()),
          source: this._jsonSource
        });
      }
      if (this._jsonLoadPromise) {
        return this._jsonLoadPromise;
      }
      this._jsonLoadPromise = this.loadDefaultBoards().finally(() => {
        this._jsonLoadPromise = null;
      });
      return this._jsonLoadPromise;
    }
    /**
     * Synchronously registers or sets a list of default boards (e.g. from an inlined JSON object).
     * @param {Array<Object>} boardsList
     * @param {Object} [options={}]
     * @returns {{ success: boolean, count: number }}
     */
    static setDefaultBoards(boardsList, options = {}) {
      if (!Array.isArray(boardsList)) {
        return { success: false, error: "Boards list must be an array" };
      }
      const replace = options.replace !== false;
      if (replace) this._boards.clear();
      for (const item of boardsList) {
        if (item && item.id) {
          this._boards.set(item.id, Object.assign({}, item, { isCustom: false }));
        }
      }
      if (Array.isArray(DEFAULT_3D_BOARDS)) {
        DEFAULT_3D_BOARDS.length = 0;
        DEFAULT_3D_BOARDS.push(...this._boards.values());
      }
      this._jsonLoaded = true;
      this._jsonSource = options.source || "in-memory";
      if (options.syncDropdown !== false) {
        this.syncDropdownOptions();
      }
      return { success: true, count: this._boards.size };
    }
    /**
     * Restores default boards back to the built-in fallback set.
     */
    static resetDefaultBoards() {
      this._boards.clear();
      for (const b of this._fallbackBoards) {
        this._boards.set(b.id, Object.assign({}, b));
      }
      if (Array.isArray(DEFAULT_3D_BOARDS)) {
        DEFAULT_3D_BOARDS.length = 0;
        DEFAULT_3D_BOARDS.push(...this._boards.values());
      }
      this._jsonLoaded = false;
      this._jsonSource = null;
      this.syncDropdownOptions();
    }
    static getStorage() {
      return typeof window !== "undefined" && (window.localStorage || window.appStorage) || (typeof localStorage !== "undefined" ? localStorage : null);
    }
    /**
     * Loads custom 3D boards from localStorage/appStorage into memory.
     * @returns {Array<Object>}
     */
    static loadCustomBoards() {
      this._customBoards.clear();
      const s = this.getStorage();
      if (s) {
        try {
          const raw = s.getItem(_Board3DCatalog.CUSTOM_STORAGE_KEY);
          if (raw) {
            const list = JSON.parse(raw);
            if (Array.isArray(list)) {
              for (const item of list) {
                if (item && item.id) {
                  delete item.coordinatesUrl;
                  this._customBoards.set(item.id, Object.assign({}, item, { isCustom: true }));
                }
              }
            }
          }
        } catch (err) {
          console.warn("[Board3DCatalog] Error loading custom boards from storage:", err);
        }
      }
      if (typeof window !== "undefined" && window.Profile && typeof window.Profile.getInstance === "function") {
        try {
          const profBoards = window.Profile.getInstance().getCustom3DBoards(s);
          if (profBoards?.list && Array.isArray(profBoards.list)) {
            for (const item of profBoards.list) {
              if (item && item.id && !this._customBoards.has(item.id)) {
                this._customBoards.set(item.id, Object.assign({}, item, { isCustom: true }));
              }
            }
          }
        } catch (_) {
        }
      }
      this._customLoaded = true;
      return Array.from(this._customBoards.values());
    }
    /**
     * Persists all custom 3D boards to localStorage/appStorage.
     */
    static saveCustomBoards() {
      const s = this.getStorage();
      if (!s) return;
      try {
        const list = Array.from(this._customBoards.values());
        s.setItem(_Board3DCatalog.CUSTOM_STORAGE_KEY, JSON.stringify(list));
      } catch (err) {
        console.warn("[Board3DCatalog] Error saving custom boards to storage:", err);
      }
    }
    /**
     * Resets custom boards cache, forcing reload on next access.
     */
    static resetCustomBoards() {
      this._customBoards.clear();
      this._customLoaded = false;
    }
    /**
     * Ensures custom boards have been loaded from storage at least once.
     * @private
     */
    static _ensureCustomLoaded() {
      if (!this._customLoaded) {
        this.loadCustomBoards();
      }
    }
    /**
     * Retrieves all registered 3D boards, optionally filtered by brand.
     * @param {string} [brand='all']
     * @returns {Array<Object>}
     */
    static getBoards(brand = "all") {
      this._ensureCustomLoaded();
      const all = [
        ...Array.from(this._boards.values()),
        ...Array.from(this._customBoards.values())
      ];
      if (!brand || brand === "all") return all;
      return all.filter((b) => {
        if (!b.brand || b.brand === "all") return true;
        const brands = String(b.brand).split(",").map((s) => s.trim());
        return brands.includes(brand);
      });
    }
    /**
     * Retrieves a specific 3D board definition by ID.
     * @param {string} id
     * @returns {Object|null}
     */
    static getBoardById(id) {
      if (!id) return null;
      this._ensureCustomLoaded();
      return this._customBoards.get(id) || this._boards.get(id) || null;
    }
    /**
     * Retrieves custom 3D boards, optionally filtered by brand.
     * @param {string} [brand='all']
     * @returns {Array<Object>}
     */
    static getCustomBoards(brand = "all") {
      this._ensureCustomLoaded();
      const list = Array.from(this._customBoards.values());
      if (!brand || brand === "all") return list;
      return list.filter((b) => {
        if (!b.brand || b.brand === "all") return true;
        const brands = String(b.brand).split(",").map((s) => s.trim());
        return brands.includes(brand);
      });
    }
    /**
     * Checks if a board is a custom user-registered board.
     * @param {string} id
     * @returns {boolean}
     */
    static isCustomBoard(id) {
      if (!id) return false;
      this._ensureCustomLoaded();
      return this._customBoards.has(id);
    }
    /**
     * Registers a new 3D cribbage board with model URL and hole coordinate data.
     * @param {Object} boardConfig
     * @returns {{ success: boolean, board?: Object, error?: string }}
     */
    static registerBoard(boardConfig) {
      this._ensureCustomLoaded();
      const validation = this.validateBoardConfig(boardConfig);
      if (!validation.valid) {
        return { success: false, error: validation.error };
      }
      const clean = {
        id: String(boardConfig.id).trim(),
        name: String(boardConfig.name).trim(),
        brand: boardConfig.brand || "all",
        desc: String(boardConfig.desc || "").trim(),
        target: Number(boardConfig.target) || 121,
        trackCount: Number(boardConfig.trackCount) || 3,
        thumbnailUrl: String(boardConfig.thumbnailUrl || "").trim(),
        modelUrl: String(boardConfig.modelUrl || "").trim(),
        coordinatesData: boardConfig.coordinatesData !== void 0 ? boardConfig.coordinatesData : boardConfig.holeData || null,
        holeData: boardConfig.coordinatesData !== void 0 ? boardConfig.coordinatesData : boardConfig.holeData || null,
        cameraDefaults: Object.assign({
          fov: 44,
          position: [0, 48, 38],
          target: [0, 0, 0],
          minDistance: 15,
          maxDistance: 95
        }, boardConfig.cameraDefaults || {}),
        lightingPreset: boardConfig.lightingPreset || "studio",
        woodFinish: boardConfig.woodFinish || "maple",
        isCustom: true
      };
      this._customBoards.set(clean.id, clean);
      this.saveCustomBoards();
      this.syncDropdownOptions();
      try {
        if (typeof window !== "undefined" && window.Profile && typeof window.Profile.getInstance === "function") {
          window.Profile.getInstance().saveCustom3DBoard(clean, clean.brand);
        }
      } catch (_) {
      }
      return { success: true, board: clean };
    }
    /**
     * Alias for registerBoard.
     * @param {Object} boardConfig
     * @returns {{ success: boolean, board?: Object, error?: string }}
     */
    static addCustomBoard(boardConfig) {
      return this.registerBoard(boardConfig);
    }
    /**
     * Updates an existing custom 3D board definition.
     * @param {string} id
     * @param {Object} updates
     * @returns {{ success: boolean, board?: Object, error?: string }}
     */
    static updateCustomBoard(id, updates = {}) {
      this._ensureCustomLoaded();
      if (!id || !this._customBoards.has(id)) {
        return { success: false, error: "Custom board not found or cannot edit default boards." };
      }
      const existing = this._customBoards.get(id);
      if (updates.name !== void 0) {
        if (typeof updates.name !== "string" || updates.name.trim().length === 0) {
          return { success: false, error: "Board name is required and cannot be empty." };
        }
      }
      if (updates.holeData !== void 0 && updates.holeData !== null) {
        const holeVal = this.validateHoleCoordinates(updates.holeData);
        if (!holeVal.valid) {
          return { success: false, error: holeVal.error || "Invalid hole coordinate dataset structure." };
        }
      }
      const updated = {
        ...existing,
        name: updates.name !== void 0 ? String(updates.name).trim() : existing.name,
        brand: updates.brand !== void 0 ? updates.brand : existing.brand || "all",
        desc: updates.desc !== void 0 ? String(updates.desc).trim() : existing.desc,
        thumbnailUrl: updates.thumbnailUrl !== void 0 ? String(updates.thumbnailUrl).trim() : existing.thumbnailUrl || "",
        modelUrl: updates.modelUrl !== void 0 ? String(updates.modelUrl).trim() : existing.modelUrl,
        coordinatesData: updates.coordinatesData !== void 0 ? updates.coordinatesData : updates.holeData !== void 0 ? updates.holeData : existing.coordinatesData,
        holeData: updates.coordinatesData !== void 0 ? updates.coordinatesData : updates.holeData !== void 0 ? updates.holeData : existing.holeData,
        trackCount: updates.trackCount !== void 0 ? Number(updates.trackCount) || existing.trackCount : existing.trackCount,
        target: updates.target !== void 0 ? Number(updates.target) || existing.target : existing.target,
        woodFinish: updates.woodFinish !== void 0 ? updates.woodFinish : existing.woodFinish,
        lightingPreset: updates.lightingPreset !== void 0 ? updates.lightingPreset : existing.lightingPreset,
        cameraDefaults: updates.cameraDefaults !== void 0 ? { ...existing.cameraDefaults, ...updates.cameraDefaults } : existing.cameraDefaults,
        isCustom: true
      };
      delete updated.coordinatesUrl;
      this._customBoards.set(id, updated);
      this.saveCustomBoards();
      this.syncDropdownOptions();
      try {
        if (typeof window !== "undefined" && window.Profile && typeof window.Profile.getInstance === "function") {
          window.Profile.getInstance().saveCustom3DBoard(updated, updated.brand);
        }
      } catch (_) {
      }
      return { success: true, board: updated };
    }
    /**
     * Renames an existing custom 3D board.
     * @param {string} id
     * @param {string} newName
     * @returns {{ success: boolean, board?: Object, error?: string }}
     */
    static renameCustomBoard(id, newName) {
      if (!newName || typeof newName !== "string" || !newName.trim()) {
        return { success: false, error: "Board name cannot be empty." };
      }
      return this.updateCustomBoard(id, { name: newName.trim() });
    }
    /**
     * Deletes a custom 3D board by ID.
     * @param {string} id
     * @returns {{ success: boolean, error?: string }}
     */
    static deleteCustomBoard(id) {
      this._ensureCustomLoaded();
      if (!id || !this._customBoards.has(id)) {
        return { success: false, error: "Cannot delete: custom board not found or is a built-in default board." };
      }
      this._customBoards.delete(id);
      this.saveCustomBoards();
      this.syncDropdownOptions();
      try {
        if (typeof window !== "undefined" && window.Profile && typeof window.Profile.getInstance === "function") {
          window.Profile.getInstance().deleteCustom3DBoard(id);
        }
      } catch (_) {
      }
      return { success: true };
    }
    /**
     * Synchronizes the DOM #opt3DBoard <select> element with default and custom boards filtered by brand.
     * If only 1 board is available for the current game, that option will automatically be selected.
     * @param {HTMLSelectElement} [selectEl]
     * @param {string} [selectedId]
     * @param {string} [brand]
     */
    static syncDropdownOptions(selectEl = null, selectedId = null, brand = null) {
      if (typeof document === "undefined") return;
      const targetEls = selectEl ? [selectEl] : [document.getElementById("opt3DBoard"), document.getElementById("inGameOpt3DBoard")].filter(Boolean);
      if (targetEls.length === 0) return;
      this._ensureCustomLoaded();
      const resolvedBrand = brand || (typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : typeof window !== "undefined" && window.currentBrand ? window.currentBrand : typeof window !== "undefined" && typeof window.detectBrand === "function" ? window.detectBrand() : "crazy");
      const isBrandAllowed = (b) => {
        if (!b.brand || b.brand === "all") return true;
        const brands = String(b.brand).split(",").map((s) => s.trim());
        return brands.includes(resolvedBrand);
      };
      let allowedDefaults = Array.from(this._boards.values()).filter(isBrandAllowed);
      let allowedCustom = Array.from(this._customBoards.values()).filter(isBrandAllowed);
      if (allowedDefaults.length === 0 && allowedCustom.length === 0) {
        allowedDefaults = Array.from(this._boards.values());
        allowedCustom = Array.from(this._customBoards.values());
      }
      const allAllowed = [...allowedDefaults, ...allowedCustom];
      let targetId = null;
      if (allAllowed.length === 1) {
        targetId = allAllowed[0].id;
      } else {
        const currentVal = selectedId || typeof window !== "undefined" && window.settings?.selected3DBoardId || targetEls[0] && targetEls[0].value || (resolvedBrand === "clash" ? "board-cribbage-clash" : "board-14");
        if (allAllowed.some((b) => b.id === currentVal)) {
          targetId = currentVal;
        } else {
          targetId = (allAllowed.find((b) => b.id === "board-14") || allAllowed[0]).id;
        }
      }
      for (const el of targetEls) {
        el.innerHTML = "";
        if (allowedCustom.length === 0) {
          for (const b of allowedDefaults) {
            const opt = document.createElement("option");
            opt.value = b.id;
            opt.textContent = b.name;
            if (b.id === targetId) opt.selected = true;
            el.appendChild(opt);
          }
        } else {
          if (allowedDefaults.length > 0) {
            const defGroup = document.createElement("optgroup");
            defGroup.label = "Default 3D Boards";
            for (const b of allowedDefaults) {
              const opt = document.createElement("option");
              opt.value = b.id;
              opt.textContent = b.name;
              if (b.id === targetId) opt.selected = true;
              defGroup.appendChild(opt);
            }
            el.appendChild(defGroup);
          }
          const customGroup = document.createElement("optgroup");
          customGroup.label = "Custom 3D Boards";
          for (const b of allowedCustom) {
            const opt = document.createElement("option");
            opt.value = b.id;
            opt.textContent = `${b.name} (Custom)`;
            if (b.id === targetId) opt.selected = true;
            customGroup.appendChild(opt);
          }
          el.appendChild(customGroup);
        }
        if (targetId) {
          el.value = targetId;
        }
      }
      if (targetId && typeof window !== "undefined" && window.settings) {
        window.settings.selected3DBoardId = targetId;
      }
    }
    /**
     * Validates a board definition schema.
     * @param {Object} cfg
     * @returns {{ valid: boolean, error?: string }}
     */
    static validateBoardConfig(cfg) {
      if (!cfg || typeof cfg !== "object") {
        return { valid: false, error: "Board configuration must be an object" };
      }
      if (!cfg.id || typeof cfg.id !== "string" || cfg.id.trim().length === 0) {
        return { valid: false, error: "Board ID is required and must be a non-empty string" };
      }
      if (!cfg.name || typeof cfg.name !== "string" || cfg.name.trim().length === 0) {
        return { valid: false, error: "Board name is required" };
      }
      if (cfg.modelUrl && typeof cfg.modelUrl !== "string") {
        return { valid: false, error: "modelUrl must be a valid URL string" };
      }
      const coordsData = cfg.coordinatesData !== void 0 ? cfg.coordinatesData : cfg.holeData;
      if (coordsData && !this.validateHoleCoordinates(coordsData).valid) {
        return { valid: false, error: "Invalid hole coordinate dataset structure" };
      }
      return { valid: true };
    }
    /**
     * Validates hole coordinate JSON dataset structure.
     * Accepts `{ tracks: { p1: [ {hole, x, y, z} ] } }`, root `{ p1: [ {hole, x, y, z} ] }`, and flat array format.
     * @param {Object|Array} data
     * @returns {{ valid: boolean, error?: string }}
     */
    static validateHoleCoordinates(data) {
      if (!data || typeof data !== "object") {
        return { valid: false, error: "Hole coordinates must be an object or array" };
      }
      let tracks = null;
      if (Array.isArray(data)) {
        tracks = { p1: data };
      } else if (data.tracks && typeof data.tracks === "object") {
        tracks = data.tracks;
      } else if (typeof data === "object") {
        const hasArrays = Object.values(data).some((v) => Array.isArray(v));
        if (hasArrays) {
          tracks = data;
        } else {
          return { valid: false, error: "Coordinate data missing tracks map" };
        }
      } else {
        return { valid: false, error: "Coordinate data missing tracks map" };
      }
      for (const trackKey of Object.keys(tracks)) {
        const list = tracks[trackKey];
        if (!Array.isArray(list)) {
          return { valid: false, error: `Track ${trackKey} must be an array of hole coordinates` };
        }
        for (let i = 0; i < list.length; i++) {
          const pt = list[i];
          if (!pt || typeof pt !== "object") {
            return { valid: false, error: `Invalid point at index ${i} in track ${trackKey}` };
          }
          const px = typeof pt.x === "number" ? pt.x : typeof pt[" x"] === "number" ? pt[" x"] : Number(pt.x ?? pt[" x"]);
          const py = typeof pt.y === "number" ? pt.y : typeof pt[" y"] === "number" ? pt[" y"] : Number(pt.y ?? pt[" y"]);
          const pz = typeof pt.z === "number" ? pt.z : typeof pt[" z"] === "number" ? pt[" z"] : Number(pt.z ?? pt[" z"]);
          if (typeof px !== "number" || isNaN(px) || typeof py !== "number" || isNaN(py) || typeof pz !== "number" || isNaN(pz)) {
            return { valid: false, error: `Point at hole ${pt.hole ?? i} must have valid numeric x, y, z` };
          }
        }
      }
      return { valid: true };
    }
    /**
     * Builds a fast (who, hole) -> { x, y, z } lookup map from coordinate data.
     * If a dataset only contains key landmark holes, smoothly interpolates intermediate holes.
     * @param {Object|Array} holeData
     * @returns {Function} (who, hole) => { x, y, z }
     */
    static createHoleLookup(holeData, scale = 1) {
      if (!holeData) return null;
      let tracks = {};
      if (Array.isArray(holeData)) {
        tracks = { p1: holeData };
      } else if (holeData.tracks && typeof holeData.tracks === "object") {
        tracks = holeData.tracks;
      } else if (typeof holeData === "object") {
        tracks = holeData;
      }
      const map = /* @__PURE__ */ new Map();
      const sortedHolesPerTrack = /* @__PURE__ */ new Map();
      for (const who of Object.keys(tracks)) {
        const list = tracks[who];
        if (Array.isArray(list)) {
          const sorted = [];
          for (const pt of list) {
            const h = Number(pt.hole !== void 0 ? pt.hole : pt.h !== void 0 ? pt.h : pt.index);
            if (!isNaN(h)) {
              const px = pt.x !== void 0 ? pt.x : pt[" x"];
              const py = pt.y !== void 0 ? pt.y : pt[" y"];
              const pz = pt.z !== void 0 ? pt.z : pt[" z"];
              const entry = {
                hole: h,
                x: Number(px) * scale,
                y: Number(py) * scale,
                z: Number(pz) * scale,
                normal: Array.isArray(pt.normal) ? pt.normal : [0, 1, 0]
              };
              map.set(`${who}_${h}`, entry);
              sorted.push(entry);
            }
          }
          sorted.sort((a, b) => a.hole - b.hole);
          sortedHolesPerTrack.set(who, sorted);
        }
      }
      const lookupFn = (who, holeNum) => {
        let resolvedWho = who;
        if (who === "you" || who === "player1" || who === "team1") resolvedWho = "p1";
        else if (who === "cpu" || who === "player2" || who === "team2") resolvedWho = "p2";
        else if (who === "player3" || who === "team3") resolvedWho = "p3";
        else if (who === "player4" || who === "team4") resolvedWho = "p4";
        const key = `${resolvedWho}_${holeNum}`;
        if (map.has(key)) return map.get(key);
        const p1Key = `p1_${holeNum}`;
        if (map.has(p1Key)) return map.get(p1Key);
        const trackList = sortedHolesPerTrack.get(resolvedWho) || sortedHolesPerTrack.get("p1");
        if (trackList && trackList.length > 0) {
          if (holeNum <= trackList[0].hole) return trackList[0];
          if (holeNum >= trackList[trackList.length - 1].hole) return trackList[trackList.length - 1];
          for (let i = 0; i < trackList.length - 1; i++) {
            const a = trackList[i];
            const b = trackList[i + 1];
            if (holeNum >= a.hole && holeNum <= b.hole) {
              const span = b.hole - a.hole;
              const t = span === 0 ? 0 : (holeNum - a.hole) / span;
              return {
                hole: holeNum,
                x: a.x + (b.x - a.x) * t,
                y: a.y + (b.y - a.y) * t,
                z: a.z + (b.z - a.z) * t,
                normal: a.normal
              };
            }
          }
        }
        return null;
      };
      lookupFn.has = (who, holeNum) => {
        let resolvedWho = who;
        if (who === "you" || who === "player1" || who === "team1") resolvedWho = "p1";
        else if (who === "cpu" || who === "player2" || who === "team2") resolvedWho = "p2";
        else if (who === "player3" || who === "team3") resolvedWho = "p3";
        else if (who === "player4" || who === "team4") resolvedWho = "p4";
        return map.has(`${resolvedWho}_${holeNum}`) || map.has(`p1_${holeNum}`);
      };
      return lookupFn;
    }
  };

  // src/storage/IndexedDBStorage.js
  var IndexedDBStorage = class {
    /**
     * @param {Object} [options={}]
     * @param {string} [options.dbName='crazy_cribbage_db']
     * @param {string} [options.storeName='app_storage']
     * @param {number} [options.version=1]
     * @param {boolean} [options.migrateLocalStorage=true]
     */
    constructor(options = {}) {
      this.dbName = options.dbName || "crazy_cribbage_db";
      this.storeName = options.storeName || "app_storage";
      this.version = options.version || 1;
      this.migrateLocalStorage = options.migrateLocalStorage !== false;
      this._cache = /* @__PURE__ */ new Map();
      this._prepopulateFromLocalStorage();
      this._db = null;
      this._isReady = false;
      this.ready = this.init();
    }
    /**
     * Checks whether a storage key is associated with Crazy Cribbage apps and settings.
     * @private
     * @param {string} key
     * @returns {boolean}
     */
    _isRelevantKey(key) {
      if (!key || typeof key !== "string") return false;
      return key.startsWith("crazy") || key.startsWith("cc_") || key.startsWith("cribbage") || key.startsWith("pints") || key.startsWith("skunk") || key.startsWith("camera_wrap_w");
    }
    /**
     * Synchronously reads existing localStorage keys into the cache.
     * @private
     */
    _prepopulateFromLocalStorage() {
      if (!this.migrateLocalStorage || typeof window === "undefined" || typeof window.localStorage === "undefined") return;
      try {
        for (let i = 0; i < window.localStorage.length; i++) {
          const key = window.localStorage.key(i);
          if (this._isRelevantKey(key)) {
            this._cache.set(key, String(window.localStorage.getItem(key)));
          }
        }
      } catch (e) {
        console.warn("[IndexedDBStorage] LocalStorage pre-read warning:", e);
      }
    }
    /**
     * Initializes the IndexedDB database connection, sets up object stores,
     * loads existing records into the in-memory cache, and migrates legacy localStorage.
     * @returns {Promise<IndexedDBStorage>}
     */
    async init() {
      if (typeof window === "undefined") {
        this._isReady = true;
        return this;
      }
      this._prepopulateFromLocalStorage();
      const idb = typeof indexedDB !== "undefined" ? indexedDB : window.indexedDB || null;
      if (!idb) {
        console.warn("[IndexedDBStorage] IndexedDB not supported; using in-memory cache.");
        this._isReady = true;
        return this;
      }
      return new Promise((resolve) => {
        try {
          const req = idb.open(this.dbName, this.version);
          req.onupgradeneeded = (e) => {
            const db = e.target.result;
            if (!db.objectStoreNames.contains(this.storeName)) {
              db.createObjectStore(this.storeName);
            }
          };
          req.onsuccess = async (e) => {
            this._db = e.target.result;
            try {
              await this._warmCacheFromDb();
              if (this.migrateLocalStorage) {
                await this._performLocalStorageMigration();
              }
            } catch (err) {
              console.warn("[IndexedDBStorage] Cache warm/migration warning:", err);
            }
            this._isReady = true;
            resolve(this);
          };
          req.onerror = (e) => {
            console.warn("[IndexedDBStorage] Failed to open IndexedDB:", e.target.error);
            this._isReady = true;
            resolve(this);
          };
        } catch (err) {
          console.warn("[IndexedDBStorage] Unexpected init exception:", err);
          this._isReady = true;
          resolve(this);
        }
      });
    }
    /**
     * Reads all key-value entries from IndexedDB into the synchronous cache.
     * @private
     * @returns {Promise<void>}
     */
    _warmCacheFromDb() {
      return new Promise((resolve, reject) => {
        if (!this._db) return resolve();
        try {
          const tx = this._db.transaction(this.storeName, "readonly");
          const store = tx.objectStore(this.storeName);
          if (typeof store.openCursor === "function") {
            const cursorReq = store.openCursor();
            cursorReq.onsuccess = (e) => {
              const cursor = e.target.result;
              if (cursor) {
                const k = String(cursor.key);
                const v = String(cursor.value);
                this._cache.set(k, v);
                if (typeof window !== "undefined" && window.localStorage) {
                  try {
                    window.localStorage.setItem(k, v);
                  } catch (_) {
                  }
                }
                cursor.continue();
              } else {
                resolve();
              }
            };
            cursorReq.onerror = (e) => reject(e.target.error);
          } else if (typeof store.getAllKeys === "function") {
            const keysReq = store.getAllKeys();
            keysReq.onsuccess = () => {
              const keys = keysReq.result || [];
              const valsReq = store.getAll();
              valsReq.onsuccess = () => {
                const vals = valsReq.result || [];
                for (let i = 0; i < keys.length; i++) {
                  const k = String(keys[i]);
                  const v = String(vals[i]);
                  this._cache.set(k, v);
                  if (typeof window !== "undefined" && window.localStorage) {
                    try {
                      window.localStorage.setItem(k, v);
                    } catch (_) {
                    }
                  }
                }
                resolve();
              };
              valsReq.onerror = (e) => reject(e.target.error);
            };
            keysReq.onerror = (e) => reject(e.target.error);
          } else {
            resolve();
          }
        } catch (err) {
          reject(err);
        }
      });
    }
    /**
     * Copies relevant legacy localStorage items into IndexedDB and in-memory cache.
     * @private
     * @returns {Promise<void>}
     */
    async _performLocalStorageMigration() {
      if (typeof window === "undefined" || typeof window.localStorage === "undefined") return;
      try {
        const keysToMigrate = [];
        for (let i = 0; i < window.localStorage.length; i++) {
          const key = window.localStorage.key(i);
          if (this._isRelevantKey(key)) {
            keysToMigrate.push(key);
          }
        }
        for (const k of keysToMigrate) {
          const val = window.localStorage.getItem(k);
          if (val !== null && !this._cache.has(k)) {
            this._cache.set(k, String(val));
            await this._writeToDb(k, String(val));
          }
        }
      } catch (e) {
        console.warn("[IndexedDBStorage] LocalStorage migration error:", e);
      }
    }
    /**
     * Persists a key-value record to IndexedDB.
     * @private
     * @param {string} key
     * @param {string} val
     * @returns {Promise<void>}
     */
    _writeToDb(key, val) {
      return new Promise((resolve) => {
        if (!this._db) return resolve();
        try {
          const tx = this._db.transaction(this.storeName, "readwrite");
          const store = tx.objectStore(this.storeName);
          const req = store.put(String(val), String(key));
          req.onsuccess = () => resolve();
          req.onerror = () => resolve();
        } catch (err) {
          resolve();
        }
      });
    }
    /**
     * Deletes a key from IndexedDB.
     * @private
     * @param {string} key
     * @returns {Promise<void>}
     */
    _deleteFromDb(key) {
      return new Promise((resolve) => {
        if (!this._db) return resolve();
        try {
          const tx = this._db.transaction(this.storeName, "readwrite");
          const store = tx.objectStore(this.storeName);
          const req = store.delete(String(key));
          req.onsuccess = () => resolve();
          req.onerror = () => resolve();
        } catch (err) {
          resolve();
        }
      });
    }
    /**
     * Clears all records from IndexedDB.
     * @private
     * @returns {Promise<void>}
     */
    _clearDb() {
      return new Promise((resolve) => {
        if (!this._db) return resolve();
        try {
          const tx = this._db.transaction(this.storeName, "readwrite");
          const store = tx.objectStore(this.storeName);
          const req = store.clear();
          req.onsuccess = () => resolve();
          req.onerror = () => resolve();
        } catch (err) {
          resolve();
        }
      });
    }
    // ==========================================
    // Synchronous Web Storage API Compatibility
    // ==========================================
    /**
     * Returns current value associated with the given key, or null if key does not exist.
     * @param {string} key
     * @returns {string|null}
     */
    getItem(key) {
      const k = String(key);
      if (this._cache.has(k)) {
        return this._cache.get(k);
      }
      if (typeof window !== "undefined" && window.localStorage) {
        try {
          const val = window.localStorage.getItem(k);
          if (val !== null) {
            const sVal = String(val);
            this._cache.set(k, sVal);
            return sVal;
          }
        } catch (e) {
        }
      }
      return null;
    }
    /**
     * Sets the value of the pair identified by key to value, creating a new key/value pair if none existed.
     * Synchronously updates in-memory cache, mirrors to localStorage, and asynchronously writes to IndexedDB.
     * @param {string} key
     * @param {string|number|boolean} value
     */
    setItem(key, value) {
      const k = String(key);
      const v = String(value);
      this._cache.set(k, v);
      if (typeof window !== "undefined" && window.localStorage) {
        try {
          window.localStorage.setItem(k, v);
        } catch (e) {
        }
      }
      this._writeToDb(k, v).catch(() => {
      });
    }
    /**
     * Removes the key/value pair with the given key.
     * Synchronously removes from in-memory cache and localStorage, and asynchronously deletes from IndexedDB.
     * @param {string} key
     */
    removeItem(key) {
      const k = String(key);
      this._cache.delete(k);
      if (typeof window !== "undefined" && window.localStorage) {
        try {
          window.localStorage.removeItem(k);
        } catch (e) {
        }
      }
      this._deleteFromDb(k).catch(() => {
      });
    }
    /**
     * Removes all key/value pairs.
     * Synchronously clears in-memory cache and localStorage, and asynchronously clears IndexedDB.
     */
    clear() {
      if (typeof window !== "undefined" && window.localStorage) {
        try {
          for (const k of Array.from(this._cache.keys())) {
            window.localStorage.removeItem(k);
          }
        } catch (e) {
        }
      }
      this._cache.clear();
      this._clearDb().catch(() => {
      });
    }
    /**
     * Returns the name of the nth key in the list, or null if n is greater than or equal to the number of key/value pairs.
     * @param {number} index
     * @returns {string|null}
     */
    key(index) {
      const keys = Array.from(this._cache.keys());
      return index >= 0 && index < keys.length ? keys[index] : null;
    }
    /**
     * Number of data items stored.
     * @returns {number}
     */
    get length() {
      return this._cache.size;
    }
    // ==========================================
    // Asynchronous Promise-Based API
    // ==========================================
    /**
     * Asynchronously retrieves a value, awaiting DB readiness if still initializing.
     * @param {string} key
     * @returns {Promise<string|null>}
     */
    async getAsync(key) {
      if (!this._isReady) await this.ready;
      return this.getItem(key);
    }
    /**
     * Asynchronously sets a key-value pair and waits for IndexedDB commit.
     * @param {string} key
     * @param {string|number|boolean} value
     * @returns {Promise<void>}
     */
    async setAsync(key, value) {
      if (!this._isReady) await this.ready;
      const k = String(key);
      const v = String(value);
      this._cache.set(k, v);
      if (typeof window !== "undefined" && window.localStorage) {
        try {
          window.localStorage.setItem(k, v);
        } catch (e) {
        }
      }
      await this._writeToDb(k, v);
    }
    /**
     * Asynchronously deletes a key and waits for IndexedDB commit.
     * @param {string} key
     * @returns {Promise<void>}
     */
    async deleteAsync(key) {
      if (!this._isReady) await this.ready;
      const k = String(key);
      this._cache.delete(k);
      if (typeof window !== "undefined" && window.localStorage) {
        try {
          window.localStorage.removeItem(k);
        } catch (e) {
        }
      }
      await this._deleteFromDb(k);
    }
    /**
     * Asynchronously clears all stored items and waits for IndexedDB commit.
     * @returns {Promise<void>}
     */
    async clearAsync() {
      if (!this._isReady) await this.ready;
      if (typeof window !== "undefined" && window.localStorage) {
        try {
          for (const k of Array.from(this._cache.keys())) {
            window.localStorage.removeItem(k);
          }
        } catch (e) {
        }
      }
      this._cache.clear();
      await this._clearDb();
    }
    /**
     * Returns an array of all keys currently stored.
     * @returns {Promise<Array<string>>}
     */
    async keysAsync() {
      if (!this._isReady) await this.ready;
      return Array.from(this._cache.keys());
    }
    /**
     * Returns a dictionary object containing all key-value entries.
     * @returns {Promise<Object<string, string>>}
     */
    async getAllAsync() {
      if (!this._isReady) await this.ready;
      const res = {};
      for (const [k, v] of this._cache.entries()) {
        res[k] = v;
      }
      return res;
    }
  };
  var appStorage = new IndexedDBStorage();
  if (typeof window !== "undefined") {
    window.IndexedDBStorage = IndexedDBStorage;
    window.appStorage = appStorage;
  }

  // src/ui/AvatarManager.js
  function getStorage() {
    if (typeof window !== "undefined" && window.appStorage) return window.appStorage;
    if (appStorage) return appStorage;
    if (typeof localStorage !== "undefined") return localStorage;
    return null;
  }
  var PRESET_AVATARS = [
    {
      id: "joker",
      name: "Wild Joker",
      title: "Court Jester & Chaos Pegger",
      badgeColor: "#a855f7",
      bgColor: "linear-gradient(135deg, #3b0764, #7e22ce)",
      category: "Court",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="jkGlow" cx="50%" cy="45%" r="50%">
          <stop offset="0%" stop-color="#9333ea" stop-opacity="0.8"/>
          <stop offset="100%" stop-color="#3b0764" stop-opacity="1"/>
        </radialGradient>
        <linearGradient id="jkGold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#fde047"/>
          <stop offset="100%" stop-color="#ca8a04"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#jkGlow)" stroke="#facc15" stroke-width="2.5"/>
      <!-- Jester Collar / Ruffle -->
      <polygon points="50,70 40,88 50,82 60,88" fill="url(#jkGold)"/>
      <polygon points="32,72 22,85 35,80" fill="#ec4899"/>
      <polygon points="68,72 78,85 65,80" fill="#ec4899"/>
      <circle cx="22" cy="85" r="2.5" fill="#facc15"/>
      <circle cx="50" cy="82" r="3" fill="#facc15"/>
      <circle cx="78" cy="85" r="2.5" fill="#facc15"/>
      <!-- Face Mask Base -->
      <path d="M30 46 C30 36, 70 36, 70 46 C70 66, 30 66, 30 46 Z" fill="#fef08a" stroke="#ca8a04" stroke-width="1.5"/>
      <!-- Jester Hat Left Horn -->
      <path d="M34 40 C24 30, 14 36, 12 48 C18 46, 26 44, 34 42" fill="#ec4899"/>
      <circle cx="12" cy="48" r="4" fill="url(#jkGold)"/>
      <!-- Jester Hat Center Horn -->
      <path d="M42 36 C50 18, 50 16, 50 12 C52 18, 56 26, 58 36" fill="url(#jkGold)"/>
      <circle cx="50" cy="12" r="4" fill="#f43f5e"/>
      <!-- Jester Hat Right Horn -->
      <path d="M66 40 C76 30, 86 36, 88 48 C82 46, 74 44, 66 42" fill="#8b5cf6"/>
      <circle cx="88" cy="48" r="4" fill="url(#jkGold)"/>
      <!-- Hat Band -->
      <path d="M32 40 Q50 34 68 40 Q50 44 32 40 Z" fill="#ca8a04"/>
      <!-- Eyes & Smile -->
      <path d="M38 48 Q44 42 46 48" stroke="#1e1b4b" stroke-width="2" fill="none" stroke-linecap="round"/>
      <path d="M54 48 Q56 42 62 48" stroke="#1e1b4b" stroke-width="2" fill="none" stroke-linecap="round"/>
      <!-- Cheek Diamond Marks -->
      <polygon points="41,53 44,57 41,61 38,57" fill="#ec4899"/>
      <polygon points="59,53 62,57 59,61 56,57" fill="#ec4899"/>
      <!-- Mischievous Grin -->
      <path d="M38 58 Q50 70 62 58 Q50 64 38 58 Z" fill="#b91c1c"/>
      <path d="M42 59 Q50 63 58 59" stroke="#ffffff" stroke-width="1.5" fill="none"/>
    </svg>`
    },
    {
      id: "king",
      name: "King of Cribbage",
      title: "Monarch of the Board",
      badgeColor: "#eab308",
      bgColor: "linear-gradient(135deg, #7f1d1d, #b91c1c)",
      category: "Court",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="kgGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#991b1b"/>
          <stop offset="100%" stop-color="#450a0a"/>
        </radialGradient>
        <linearGradient id="kgGold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#fef08a"/>
          <stop offset="50%" stop-color="#eab308"/>
          <stop offset="100%" stop-color="#a16207"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#kgGlow)" stroke="#facc15" stroke-width="2.5"/>
      <!-- Robe Collar -->
      <path d="M22 88 Q50 78 78 88 L84 96 L16 96 Z" fill="#f8fafc" stroke="#e2e8f0" stroke-width="1.5"/>
      <circle cx="28" cy="90" r="2" fill="#0f172a"/>
      <circle cx="50" cy="86" r="2.5" fill="#0f172a"/>
      <circle cx="72" cy="90" r="2" fill="#0f172a"/>
      <!-- King Beard -->
      <path d="M30 56 Q50 90 70 56 Q50 76 30 56 Z" fill="#fef08a" stroke="#ca8a04" stroke-width="1.5"/>
      <!-- King Face -->
      <ellipse cx="50" cy="52" rx="18" ry="16" fill="#fed7aa"/>
      <!-- Eyes & Brows -->
      <path d="M36 46 Q43 44 46 48" stroke="#78350f" stroke-width="2" fill="none"/>
      <path d="M54 48 Q57 44 64 46" stroke="#78350f" stroke-width="2" fill="none"/>
      <circle cx="42" cy="50" r="2" fill="#451a03"/>
      <circle cx="58" cy="50" r="2" fill="#451a03"/>
      <!-- Royal Mustache -->
      <path d="M34 58 Q42 54 50 58 Q58 54 66 58 Q58 64 50 60 Q42 64 34 58 Z" fill="#ca8a04"/>
      <!-- Crown Base -->
      <path d="M26 38 L30 18 L42 28 L50 14 L58 28 L70 18 L74 38 Z" fill="url(#kgGold)" stroke="#78350f" stroke-width="1.5"/>
      <rect x="25" y="36" width="50" height="6" rx="2" fill="url(#kgGold)" stroke="#78350f" stroke-width="1"/>
      <!-- Crown Jewels -->
      <circle cx="50" cy="18" r="3" fill="#ef4444"/>
      <circle cx="32" cy="22" r="2.5" fill="#3b82f6"/>
      <circle cx="68" cy="22" r="2.5" fill="#10b981"/>
      <circle cx="50" cy="39" r="2.5" fill="#ef4444"/>
      <circle cx="37" cy="39" r="2" fill="#3b82f6"/>
      <circle cx="63" cy="39" r="2" fill="#10b981"/>
    </svg>`
    },
    {
      id: "queen",
      name: "Queen of Skunks",
      title: "Sovereign of Double Runs",
      badgeColor: "#10b981",
      bgColor: "linear-gradient(135deg, #064e3b, #047857)",
      category: "Court",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="qnGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#047857"/>
          <stop offset="100%" stop-color="#022c22"/>
        </radialGradient>
        <linearGradient id="qnGold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#fef08a"/>
          <stop offset="100%" stop-color="#d97706"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#qnGlow)" stroke="#34d399" stroke-width="2.5"/>
      <!-- Hair Curls -->
      <path d="M22 48 Q20 72 32 82 Q38 68 32 52 Z" fill="#78350f"/>
      <path d="M78 48 Q80 72 68 82 Q62 68 68 52 Z" fill="#78350f"/>
      <!-- Neck & Shoulders -->
      <path d="M34 76 Q50 72 66 76 L76 96 L24 96 Z" fill="#047857" stroke="#10b981" stroke-width="1.5"/>
      <path d="M38 78 Q50 88 62 78" stroke="url(#qnGold)" stroke-width="2.5" fill="none"/>
      <!-- Queen Face -->
      <ellipse cx="50" cy="54" rx="17" ry="19" fill="#fde68a"/>
      <!-- Elegant Eyes & Lashes -->
      <path d="M37 50 Q43 46 47 51" stroke="#047857" stroke-width="2" fill="none"/>
      <path d="M53 51 Q57 46 63 50" stroke="#047857" stroke-width="2" fill="none"/>
      <line x1="35" y1="48" x2="38" y2="50" stroke="#047857" stroke-width="1.5"/>
      <line x1="65" y1="48" x2="62" y2="50" stroke="#047857" stroke-width="1.5"/>
      <!-- Ruby Lips -->
      <path d="M44 64 Q50 67 56 64 Q50 69 44 64 Z" fill="#e11d48"/>
      <!-- Tiara Crown -->
      <path d="M30 40 L34 22 L42 30 L50 16 L58 30 L66 22 L70 40 Z" fill="url(#qnGold)" stroke="#b45309" stroke-width="1.5"/>
      <circle cx="50" cy="20" r="3" fill="#10b981" stroke="#fef08a" stroke-width="1"/>
      <circle cx="36" cy="26" r="2.5" fill="#f43f5e"/>
      <circle cx="64" cy="26" r="2.5" fill="#f43f5e"/>
      <!-- Skunk Streak Accent Ribbon -->
      <path d="M47 38 L50 44 L53 38 Z" fill="#ffffff"/>
    </svg>`
    },
    {
      id: "jack",
      name: "His Nob Jack",
      title: "One for His Nob",
      badgeColor: "#3b82f6",
      bgColor: "linear-gradient(135deg, #1e3a8a, #2563eb)",
      category: "Court",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="jkGlow2" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#1d4ed8"/>
          <stop offset="100%" stop-color="#0f172a"/>
        </radialGradient>
        <linearGradient id="jkFeather" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#f43f5e"/>
          <stop offset="100%" stop-color="#fbbf24"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#jkGlow2)" stroke="#60a5fa" stroke-width="2.5"/>
      <!-- Renaissance Tunic -->
      <path d="M26 84 L38 72 L62 72 L74 84 L80 96 L20 96 Z" fill="#1d4ed8" stroke="#93c5fd" stroke-width="1.5"/>
      <polygon points="50,72 44,88 56,88" fill="#fbbf24"/>
      <!-- Face -->
      <ellipse cx="50" cy="56" rx="17" ry="18" fill="#fed7aa"/>
      <circle cx="43" cy="54" r="2.5" fill="#1e3a8a"/>
      <circle cx="57" cy="54" r="2.5" fill="#1e3a8a"/>
      <!-- Smirk -->
      <path d="M43 66 Q52 70 58 64" stroke="#78350f" stroke-width="2" fill="none" stroke-linecap="round"/>
      <!-- Renaissance Beret Cap -->
      <path d="M24 44 Q50 28 76 44 Q50 38 24 44 Z" fill="#2563eb" stroke="#1d4ed8" stroke-width="1.5"/>
      <ellipse cx="50" cy="40" rx="28" ry="10" fill="#1e40af"/>
      <!-- Feather Plume (His Nob) -->
      <path d="M68 38 Q82 18 64 8 Q74 24 64 36" fill="url(#jkFeather)" stroke="#f59e0b" stroke-width="1"/>
      <!-- Peg Brooch -->
      <circle cx="66" cy="38" r="4.5" fill="#fbbf24" stroke="#78350f" stroke-width="1"/>
      <rect x="64.5" y="35" width="3" height="6" rx="1" fill="#dc2626"/>
    </svg>`
    },
    {
      id: "shark",
      name: "The Peg Shark",
      title: "Relentless Board Hunter",
      badgeColor: "#06b6d4",
      bgColor: "linear-gradient(135deg, #083344, #0e7490)",
      category: "Wildlife",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="shkGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#0891b2"/>
          <stop offset="100%" stop-color="#082f49"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#shkGlow)" stroke="#22d3ee" stroke-width="2.5"/>
      <!-- Ocean Waves Backing -->
      <path d="M12 72 Q30 64 50 72 Q70 80 88 72 L88 96 L12 96 Z" fill="#0369a1" opacity="0.6"/>
      <!-- Dorsal Fin Behind -->
      <path d="M48 14 Q52 24 62 30 L44 32 Z" fill="#0f766e"/>
      <!-- Shark Head Silhouette -->
      <path d="M22 66 C22 36, 46 26, 78 38 C74 54, 66 70, 48 76 C32 78, 22 72, 22 66 Z" fill="#64748b" stroke="#cbd5e1" stroke-width="1.5"/>
      <!-- Belly Accent -->
      <path d="M30 68 C34 56, 52 58, 68 54 C58 68, 44 74, 30 68 Z" fill="#f1f5f9"/>
      <!-- Shark Eye (Menacing) -->
      <circle cx="64" cy="42" r="4.5" fill="#0f172a"/>
      <circle cx="65.5" cy="41" r="1.5" fill="#facc15"/>
      <!-- Sharp Teeth Grin -->
      <path d="M42 60 Q56 62 70 52" stroke="#0f172a" stroke-width="2" fill="none"/>
      <polygon points="48,60 50,56 52,60" fill="#ffffff"/>
      <polygon points="54,59 56,55 58,59" fill="#ffffff"/>
      <polygon points="60,57 62,53 64,57" fill="#ffffff"/>
      <!-- Golden Peg in Jaws -->
      <path d="M34 52 L56 64" stroke="#facc15" stroke-width="4.5" stroke-linecap="round"/>
      <circle cx="34" cy="52" r="3.5" fill="#eab308"/>
    </svg>`
    },
    {
      id: "turtler",
      name: "Patient Turtler",
      title: "Slow, Steady & Unskunkable",
      badgeColor: "#22c55e",
      bgColor: "linear-gradient(135deg, #14532d, #15803d)",
      category: "Wildlife",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="trtGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#16a34a"/>
          <stop offset="100%" stop-color="#052e16"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#trtGlow)" stroke="#4ade80" stroke-width="2.5"/>
      <!-- Turtle Shell (Cribbage Board Track Motif) -->
      <ellipse cx="50" cy="54" rx="34" ry="28" fill="#713f12" stroke="#ca8a04" stroke-width="2"/>
      <!-- Shell Track Lines -->
      <ellipse cx="50" cy="54" rx="26" ry="20" fill="#854d0e" stroke="#eab308" stroke-width="1.5" stroke-dasharray="3,3"/>
      <ellipse cx="50" cy="54" rx="16" ry="12" fill="#a16207" stroke="#fde047" stroke-width="1.5"/>
      <!-- Pegs sticking out of Shell -->
      <circle cx="44" cy="48" r="3" fill="#ef4444" stroke="#fef08a" stroke-width="1"/>
      <circle cx="56" cy="48" r="3" fill="#3b82f6" stroke="#fef08a" stroke-width="1"/>
      <circle cx="50" cy="58" r="3" fill="#22c55e" stroke="#fef08a" stroke-width="1"/>
      <!-- Turtle Head -->
      <ellipse cx="50" cy="24" rx="14" ry="12" fill="#4ade80" stroke="#166534" stroke-width="1.5"/>
      <!-- Wise Big Eyes -->
      <circle cx="44" cy="22" r="3.5" fill="#ffffff"/>
      <circle cx="44" cy="22" r="2" fill="#14532d"/>
      <circle cx="56" cy="22" r="3.5" fill="#ffffff"/>
      <circle cx="56" cy="22" r="2" fill="#14532d"/>
      <!-- Gentle Smile -->
      <path d="M46 28 Q50 32 54 28" stroke="#14532d" stroke-width="1.5" fill="none" stroke-linecap="round"/>
      <!-- Little Flippers -->
      <ellipse cx="18" cy="44" rx="7" ry="5" fill="#4ade80" transform="rotate(-25 18 44)"/>
      <ellipse cx="82" cy="44" rx="7" ry="5" fill="#4ade80" transform="rotate(25 82 44)"/>
    </svg>`
    },
    {
      id: "gambler",
      name: "High Roller",
      title: "Double-Run Risk Taker",
      badgeColor: "#f43f5e",
      bgColor: "linear-gradient(135deg, #4c0519, #881337)",
      category: "Vegas & Pub",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="gmbGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#be123c"/>
          <stop offset="100%" stop-color="#4c0519"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#gmbGlow)" stroke="#fb7185" stroke-width="2.5"/>
      <!-- Silk Top Hat -->
      <path d="M28 48 L32 16 L68 16 L72 48 Z" fill="#0f172a" stroke="#334155" stroke-width="1.5"/>
      <ellipse cx="50" cy="16" rx="18" ry="4" fill="#1e293b"/>
      <!-- Crimson Ribbon Band -->
      <path d="M29 42 L30 48 L70 48 L71 42 Z" fill="#e11d48"/>
      <!-- Wide Brim -->
      <ellipse cx="50" cy="50" rx="36" ry="8" fill="#0f172a" stroke="#334155" stroke-width="1.5"/>
      <!-- Playing Card tucked into Ribbon -->
      <g transform="translate(56, 26) rotate(15)">
        <rect x="0" y="0" width="14" height="20" rx="2" fill="#ffffff" stroke="#94a3b8" stroke-width="0.75"/>
        <text x="3" y="7" font-size="6" font-weight="bold" fill="#dc2626" font-family="sans-serif">A</text>
        <polygon points="7,9 10,14 7,19 4,14" fill="#dc2626"/>
      </g>
      <!-- Pair of Red Dice below -->
      <g transform="translate(26, 62) rotate(-8)">
        <rect x="0" y="0" width="22" height="22" rx="4" fill="#e11d48" stroke="#ffffff" stroke-width="1.5"/>
        <circle cx="5" cy="5" r="2" fill="#ffffff"/>
        <circle cx="17" cy="5" r="2" fill="#ffffff"/>
        <circle cx="11" cy="11" r="2" fill="#ffffff"/>
        <circle cx="5" cy="17" r="2" fill="#ffffff"/>
        <circle cx="17" cy="17" r="2" fill="#ffffff"/>
      </g>
      <g transform="translate(54, 64) rotate(12)">
        <rect x="0" y="0" width="20" height="20" rx="4" fill="#e11d48" stroke="#ffffff" stroke-width="1.5"/>
        <circle cx="5" cy="5" r="2" fill="#ffffff"/>
        <circle cx="15" cy="5" r="2" fill="#ffffff"/>
        <circle cx="5" cy="10" r="2" fill="#ffffff"/>
        <circle cx="15" cy="10" r="2" fill="#ffffff"/>
        <circle cx="5" cy="15" r="2" fill="#ffffff"/>
        <circle cx="15" cy="15" r="2" fill="#ffffff"/>
      </g>
    </svg>`
    },
    {
      id: "ace_spades",
      name: "Ace of Spades",
      title: "The Legendary Death Card",
      badgeColor: "#fbbf24",
      bgColor: "linear-gradient(135deg, #18181b, #27272a)",
      category: "Legendary",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="aceGlow" cx="50%" cy="45%" r="50%">
          <stop offset="0%" stop-color="#3f3f46"/>
          <stop offset="100%" stop-color="#09090b"/>
        </radialGradient>
        <linearGradient id="aceGold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#fef08a"/>
          <stop offset="50%" stop-color="#eab308"/>
          <stop offset="100%" stop-color="#a16207"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#aceGlow)" stroke="url(#aceGold)" stroke-width="2.5"/>
      <!-- Ornate Laurel Wreath -->
      <path d="M22 66 C14 42, 28 22, 50 18 C72 22, 86 42, 78 66" stroke="#ca8a04" stroke-width="2" fill="none" stroke-dasharray="4,3"/>
      <!-- Large Filigree Ace of Spades -->
      <path d="M50 24 C44 38, 22 48, 22 64 C22 74, 34 80, 44 74 C47 72, 48 70, 48 70 L46 84 L54 84 L52 70 C52 70, 53 72, 56 74 C66 80, 78 74, 78 64 C78 48, 56 38, 50 24 Z" fill="url(#aceGold)" stroke="#78350f" stroke-width="1.5"/>
      <!-- Center Emblem Inner Cutout -->
      <path d="M50 36 C46 46, 32 54, 32 63 C32 69, 40 71, 46 67 C48 65, 49 63, 50 62 C51 63, 52 65, 54 67 C60 71, 68 69, 68 63 C68 54, 54 46, 50 36 Z" fill="#09090b"/>
      <circle cx="50" cy="54" r="4" fill="url(#aceGold)"/>
    </svg>`
    },
    {
      id: "pint_master",
      name: "Pub Master Dave",
      title: "The Alehouse Skunker",
      badgeColor: "#f59e0b",
      bgColor: "linear-gradient(135deg, #451a03, #78350f)",
      category: "Vegas & Pub",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="pntGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#b45309"/>
          <stop offset="100%" stop-color="#451a03"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#pntGlow)" stroke="#f59e0b" stroke-width="2.5"/>
      <!-- Crossed Cribbage Pegs behind Pint -->
      <line x1="20" y1="20" x2="80" y2="80" stroke="#fde047" stroke-width="3.5" stroke-linecap="round"/>
      <line x1="80" y1="20" x2="20" y2="80" stroke="#fde047" stroke-width="3.5" stroke-linecap="round"/>
      <!-- Pint Tankard Body -->
      <rect x="34" y="36" width="32" height="44" rx="4" fill="#d97706" stroke="#fbbf24" stroke-width="2"/>
      <!-- Amber Ale Contents -->
      <rect x="36" y="42" width="28" height="36" rx="2" fill="#b45309"/>
      <!-- Frosted Tankard Ribs -->
      <line x1="43" y1="44" x2="43" y2="76" stroke="#f59e0b" stroke-width="1.5" opacity="0.6"/>
      <line x1="50" y1="44" x2="50" y2="76" stroke="#f59e0b" stroke-width="1.5" opacity="0.6"/>
      <line x1="57" y1="44" x2="57" y2="76" stroke="#f59e0b" stroke-width="1.5" opacity="0.6"/>
      <!-- Tankard Handle -->
      <path d="M66 44 Q80 44 80 58 Q80 72 66 72" stroke="#fbbf24" stroke-width="4.5" fill="none" stroke-linecap="round"/>
      <!-- Foaming Beer Head (Puffy Bubbles) -->
      <circle cx="34" cy="36" r="6" fill="#fef08a"/>
      <circle cx="42" cy="32" r="7" fill="#ffffff"/>
      <circle cx="50" cy="30" r="8" fill="#ffffff"/>
      <circle cx="58" cy="32" r="7" fill="#ffffff"/>
      <circle cx="66" cy="36" r="6" fill="#fef08a"/>
      <!-- Dripping Foam -->
      <path d="M40 38 Q42 46 44 40" fill="#ffffff"/>
      <path d="M52 38 Q54 48 56 40" fill="#ffffff"/>
    </svg>`
    },
    {
      id: "steampunk",
      name: "Clockwork Pegger",
      title: "Precision Brass & Cog Mechanist",
      badgeColor: "#d97706",
      bgColor: "linear-gradient(135deg, #292524, #44403c)",
      category: "Legendary",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="spkGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#78716c"/>
          <stop offset="100%" stop-color="#1c1917"/>
        </radialGradient>
        <linearGradient id="spkBrass" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#fde047"/>
          <stop offset="100%" stop-color="#b45309"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#spkGlow)" stroke="url(#spkBrass)" stroke-width="2.5"/>
      <!-- Large Brass Gear (Left) -->
      <g transform="translate(30, 62)">
        <circle cx="0" cy="0" r="14" fill="url(#spkBrass)" stroke="#78350f" stroke-width="1.5"/>
        <circle cx="0" cy="0" r="6" fill="#1c1917"/>
        <!-- Gear Cogs -->
        <rect x="-2" y="-18" width="4" height="6" fill="url(#spkBrass)"/>
        <rect x="-2" y="12" width="4" height="6" fill="url(#spkBrass)"/>
        <rect x="-18" y="-2" width="6" height="4" fill="url(#spkBrass)"/>
        <rect x="12" y="-2" width="6" height="4" fill="url(#spkBrass)"/>
      </g>
      <!-- Medium Brass Gear (Right) -->
      <g transform="translate(68, 64)">
        <circle cx="0" cy="0" r="11" fill="url(#spkBrass)" stroke="#78350f" stroke-width="1.5"/>
        <circle cx="0" cy="0" r="4" fill="#1c1917"/>
        <rect x="-1.5" y="-14" width="3" height="4" fill="url(#spkBrass)"/>
        <rect x="-1.5" y="10" width="3" height="4" fill="url(#spkBrass)"/>
        <rect x="-14" y="-1.5" width="4" height="3" fill="url(#spkBrass)"/>
        <rect x="10" y="-1.5" width="4" height="3" fill="url(#spkBrass)"/>
      </g>
      <!-- Steampunk Goggles -->
      <rect x="22" y="34" width="56" height="6" rx="2" fill="#78350f"/>
      <!-- Left Lens -->
      <circle cx="36" cy="37" r="14" fill="#ca8a04" stroke="url(#spkBrass)" stroke-width="3"/>
      <circle cx="36" cy="37" r="10" fill="#06b6d4" opacity="0.85"/>
      <circle cx="34" cy="35" r="3" fill="#ffffff" opacity="0.6"/>
      <!-- Right Lens -->
      <circle cx="64" cy="37" r="14" fill="#ca8a04" stroke="url(#spkBrass)" stroke-width="3"/>
      <circle cx="64" cy="37" r="10" fill="#06b6d4" opacity="0.85"/>
      <circle cx="62" cy="35" r="3" fill="#ffffff" opacity="0.6"/>
      <!-- Center Bridge -->
      <rect x="46" y="34" width="8" height="6" fill="url(#spkBrass)"/>
      <!-- Steam Pressure Gauge Needle -->
      <line x1="36" y1="37" x2="41" y2="33" stroke="#ef4444" stroke-width="1.5"/>
    </svg>`
    },
    {
      id: "clash_helm",
      name: "Board Gladiator",
      title: "Champion of Cribbage Clash",
      badgeColor: "#eab308",
      bgColor: "linear-gradient(135deg, #713f12, #a16207)",
      category: "Vegas & Pub",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="clshGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#b45309"/>
          <stop offset="100%" stop-color="#451a03"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#clshGlow)" stroke="#facc15" stroke-width="2.5"/>
      <!-- Red Feather Crest Plume -->
      <path d="M46 10 Q50 6 54 10 L54 36 L46 36 Z" fill="#dc2626"/>
      <path d="M38 16 Q50 8 62 16 L54 36 L46 36 Z" fill="#ef4444"/>
      <!-- Golden Spartan / Gladiator Helmet Dome -->
      <path d="M26 44 C26 26, 74 26, 74 44 L74 62 L64 62 L64 52 L36 52 L36 62 L26 62 Z" fill="#eab308" stroke="#78350f" stroke-width="1.5"/>
      <!-- Cheek Guards -->
      <path d="M28 58 L36 78 L44 64 L36 58 Z" fill="#ca8a04" stroke="#78350f" stroke-width="1"/>
      <path d="M72 58 L64 78 L56 64 L64 58 Z" fill="#ca8a04" stroke="#78350f" stroke-width="1"/>
      <!-- Nose Guard & Eye Slits -->
      <rect x="47" y="44" width="6" height="24" fill="#a16207"/>
      <!-- Dark Eye Cavity -->
      <rect x="36" y="46" width="11" height="6" rx="1" fill="#1e1b4b"/>
      <rect x="53" y="46" width="11" height="6" rx="1" fill="#1e1b4b"/>
      <!-- Glowing Gladiator Eyes -->
      <circle cx="41" cy="49" r="1.5" fill="#fef08a"/>
      <circle cx="59" cy="49" r="1.5" fill="#fef08a"/>
    </svg>`
    },
    {
      id: "velvet_fox",
      name: "Sly Fox",
      title: "The Mastermind Pegger",
      badgeColor: "#f97316",
      bgColor: "linear-gradient(135deg, #7c2d12, #c2410c)",
      category: "Wildlife",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="foxGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#ea580c"/>
          <stop offset="100%" stop-color="#431407"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#foxGlow)" stroke="#fb923c" stroke-width="2.5"/>
      <!-- Fox Ears Outer -->
      <polygon points="24,42 32,14 46,36" fill="#ea580c" stroke="#9a3412" stroke-width="1.5"/>
      <polygon points="76,42 68,14 54,36" fill="#ea580c" stroke="#9a3412" stroke-width="1.5"/>
      <!-- Fox Ears Inner (Fluffy) -->
      <polygon points="28,38 34,20 42,34" fill="#fed7aa"/>
      <polygon points="72,38 66,20 58,34" fill="#fed7aa"/>
      <!-- Fox Face Main (Orange Fur) -->
      <path d="M22 46 C22 36, 78 36, 78 46 C78 64, 50 82, 50 82 C50 82, 22 64, 22 46 Z" fill="#ea580c"/>
      <!-- White Cheeks & Snout -->
      <path d="M22 46 C34 58, 44 72, 50 82 C56 72, 66 58, 78 46 C74 58, 62 68, 50 78 C38 68, 26 58, 22 46 Z" fill="#ffffff"/>
      <!-- Mischievous Eyes (Left Eye Winking) -->
      <path d="M34 50 Q40 44 44 50" stroke="#431407" stroke-width="2.5" fill="none" stroke-linecap="round"/>
      <circle cx="60" cy="48" r="3" fill="#431407"/>
      <circle cx="61" cy="47" r="1" fill="#ffffff"/>
      <!-- Black Nose -->
      <polygon points="47,78 53,78 50,82" fill="#18181b"/>
      <!-- Whiskers -->
      <line x1="26" y1="62" x2="16" y2="60" stroke="#fdba74" stroke-width="1.5"/>
      <line x1="26" y1="66" x2="16" y2="68" stroke="#fdba74" stroke-width="1.5"/>
      <line x1="74" y1="62" x2="84" y2="60" stroke="#fdba74" stroke-width="1.5"/>
      <line x1="74" y1="66" x2="84" y2="68" stroke="#fdba74" stroke-width="1.5"/>
    </svg>`
    },
    {
      id: "card_assassin",
      name: "Card Assassin",
      title: "Silent Crib Striker",
      badgeColor: "#8b5cf6",
      bgColor: "linear-gradient(135deg, #09090b, #18181b)",
      category: "Legendary",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="asnGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#4c1d95"/>
          <stop offset="100%" stop-color="#09090b"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#asnGlow)" stroke="#a78bfa" stroke-width="2.5"/>
      <!-- Crossed Razor Card Blades in Background -->
      <g transform="translate(50, 48) rotate(45)">
        <rect x="-14" y="-22" width="28" height="44" rx="2" fill="#3b82f6" stroke="#93c5fd" stroke-width="1.5" opacity="0.7"/>
      </g>
      <g transform="translate(50, 48) rotate(-45)">
        <rect x="-14" y="-22" width="28" height="44" rx="2" fill="#ef4444" stroke="#fca5a5" stroke-width="1.5" opacity="0.7"/>
      </g>
      <!-- Assassin Cowl / Hood -->
      <path d="M50 14 C30 18, 20 44, 20 72 L32 86 L50 78 L68 86 L80 72 C80 44, 70 18, 50 14 Z" fill="#18181b" stroke="#6d28d9" stroke-width="2"/>
      <!-- Shadowy Face Hollow -->
      <path d="M50 26 C36 32, 32 50, 32 66 L50 72 L68 66 C68 50, 64 32, 50 26 Z" fill="#09090b"/>
      <!-- Glowing Lethal Eyes -->
      <ellipse cx="42" cy="50" rx="4" ry="2" fill="#a855f7"/>
      <ellipse cx="58" cy="50" rx="4" ry="2" fill="#a855f7"/>
      <circle cx="42" cy="50" r="1.5" fill="#f5d0fe"/>
      <circle cx="58" cy="50" r="1.5" fill="#f5d0fe"/>
      <!-- Face Mask Wrap -->
      <path d="M34 58 Q50 64 66 58 L50 72 Z" fill="#2e1065"/>
    </svg>`
    },
    {
      id: "cannon_commander",
      name: "Captain 31",
      title: "High Seas 31 Blaster",
      badgeColor: "#e11d48",
      bgColor: "linear-gradient(135deg, #1e293b, #0f172a)",
      category: "Legendary",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="cptGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#334155"/>
          <stop offset="100%" stop-color="#020617"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#cptGlow)" stroke="#f43f5e" stroke-width="2.5"/>
      <!-- Pirate Bicorne Hat -->
      <path d="M12 44 Q50 18 88 44 Q50 36 12 44 Z" fill="#0f172a" stroke="#ca8a04" stroke-width="2"/>
      <ellipse cx="50" cy="36" rx="20" ry="12" fill="#1e293b"/>
      <!-- Skull with Crossed Pegs Insignia -->
      <circle cx="50" cy="32" r="5" fill="#f8fafc"/>
      <line x1="42" y1="38" x2="58" y2="26" stroke="#fde047" stroke-width="2" stroke-linecap="round"/>
      <line x1="58" y1="38" x2="42" y2="26" stroke="#fde047" stroke-width="2" stroke-linecap="round"/>
      <!-- Face with Eyepatch -->
      <ellipse cx="50" cy="56" rx="16" ry="17" fill="#fed7aa"/>
      <circle cx="42" cy="52" r="2.5" fill="#020617"/>
      <!-- Leather Eyepatch -->
      <path d="M36 48 L64 54" stroke="#020617" stroke-width="2"/>
      <circle cx="58" cy="52" r="4.5" fill="#020617"/>
      <!-- Pirate Beard -->
      <path d="M34 60 Q50 82 66 60 Q50 72 34 60 Z" fill="#1e293b"/>
      <!-- Smoking Brass Cannon below -->
      <g transform="translate(50, 82)">
        <rect x="-16" y="-6" width="32" height="12" rx="3" fill="#ca8a04" stroke="#78350f" stroke-width="1.5"/>
        <circle cx="16" cy="0" r="4" fill="#020617"/>
      </g>
    </svg>`
    },
    {
      id: "lightning_29",
      name: "The 29 Club",
      title: "The Holy Grail of Cribbage",
      badgeColor: "#38bdf8",
      bgColor: "linear-gradient(135deg, #0369a1, #0284c7)",
      category: "Legendary",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="ltnGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#38bdf8"/>
          <stop offset="100%" stop-color="#0c4a6e"/>
        </radialGradient>
        <linearGradient id="ltnBolt" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#fef08a"/>
          <stop offset="50%" stop-color="#facc15"/>
          <stop offset="100%" stop-color="#ea580c"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#ltnGlow)" stroke="#7dd3fc" stroke-width="2.5"/>
      <!-- Electric Heraldic Shield -->
      <path d="M26 24 L74 24 L74 54 C74 72, 50 86, 50 86 C50 86, 26 72, 26 54 Z" fill="#0f172a" stroke="#38bdf8" stroke-width="2"/>
      <!-- Glowing 29 Text -->
      <text x="50" y="58" font-size="28" font-weight="900" text-anchor="middle" fill="#38bdf8" font-family="'Impact', 'Arial Black', sans-serif" letter-spacing="1">29</text>
      <!-- Electric Crackling Lightning Bolt across shield -->
      <polygon points="56,12 36,46 48,46 42,78 66,38 52,38" fill="url(#ltnBolt)" stroke="#ffffff" stroke-width="1"/>
    </svg>`
    },
    {
      id: "lucky_clover",
      name: "Emerald Clover",
      title: "Blessed by the Cut",
      badgeColor: "#10b981",
      bgColor: "linear-gradient(135deg, #064e3b, #047857)",
      category: "Legendary",
      svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="clvGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#10b981"/>
          <stop offset="100%" stop-color="#022c22"/>
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#clvGlow)" stroke="#6ee7b7" stroke-width="2.5"/>
      <!-- Golden Horseshoe Backdrop -->
      <path d="M30 70 C24 48, 24 30, 40 22 C56 16, 70 24, 72 40 C74 54, 68 70, 68 70" stroke="#facc15" stroke-width="6" fill="none" stroke-linecap="round"/>
      <!-- Four-Leaf Clover Leaves -->
      <circle cx="40" cy="40" r="13" fill="#22c55e" stroke="#15803d" stroke-width="1.5"/>
      <circle cx="60" cy="40" r="13" fill="#22c55e" stroke="#15803d" stroke-width="1.5"/>
      <circle cx="40" cy="60" r="13" fill="#22c55e" stroke="#15803d" stroke-width="1.5"/>
      <circle cx="60" cy="60" r="13" fill="#22c55e" stroke="#15803d" stroke-width="1.5"/>
      <!-- Clover Center Heart Lines -->
      <circle cx="50" cy="50" r="6" fill="#16a34a"/>
      <!-- Clover Stem -->
      <path d="M50 54 Q48 76 38 88" stroke="#15803d" stroke-width="3" fill="none" stroke-linecap="round"/>
      <!-- Dewdrop Sparkle -->
      <circle cx="37" cy="37" r="2.5" fill="#ffffff" opacity="0.8"/>
    </svg>`
    }
  ];
  var AvatarManager = class _AvatarManager {
    static STORAGE_KEY = "cc_player_avatar";
    static DEFAULT_AVATAR_ID = "joker";
    static CUSTOM_AVATAR_ID = "custom";
    static STORAGE_KEY_CUSTOM = "cc_custom_avatar_data";
    static STORAGE_KEY_CUSTOM_NAME = "cc_custom_avatar_name";
    static _activeModal = null;
    static _remoteAvatars = /* @__PURE__ */ new Map();
    static _inMemoryCustomData = null;
    static _inMemoryCustomName = null;
    /**
     * Retrieves full list of available preset avatars.
     * @returns {Array<Object>}
     */
    static getAvatars() {
      return PRESET_AVATARS;
    }
    /**
     * Finds avatar by unique ID. Supports custom uploaded photo, remote peers, and vector presets.
     * @param {string} id
     * @returns {Object}
     */
    static getAvatarById(id, storage = null) {
      if (!id) return PRESET_AVATARS[0];
      const cleanId = String(id).toLowerCase().trim();
      if (cleanId === "custom") {
        const data = _AvatarManager.getCustomAvatarData(storage);
        if (data) {
          return {
            id: "custom",
            name: _AvatarManager.getCustomAvatarName(storage) || "My Photo",
            title: "Custom Cribbage Persona",
            badgeColor: "#f59e0b",
            bgColor: "linear-gradient(135deg, #1e1b4b, #312e81)",
            category: "Custom",
            isCustom: true,
            dataUrl: data,
            svg: _AvatarManager.generateCustomAvatarSvg(data)
          };
        }
        return PRESET_AVATARS[0];
      }
      if (cleanId.startsWith("custom_")) {
        if (_AvatarManager._remoteAvatars && _AvatarManager._remoteAvatars.has(cleanId)) {
          return _AvatarManager._remoteAvatars.get(cleanId);
        }
        const localData = _AvatarManager.getCustomAvatarData(storage);
        return {
          id: cleanId,
          name: "Remote Player",
          title: "Remote Cribbage Persona",
          badgeColor: "#f59e0b",
          bgColor: "linear-gradient(135deg, #1e1b4b, #312e81)",
          category: "Custom",
          isCustom: true,
          dataUrl: localData || null,
          svg: _AvatarManager.generateCustomAvatarSvg(localData || null)
        };
      }
      const found = PRESET_AVATARS.find((a) => a.id === cleanId);
      return found || PRESET_AVATARS[0];
    }
    /**
     * Retrieves the custom photo Data URL from storage.
     * @param {Object} [storage=null]
     * @returns {string|null}
     */
    static getCustomAvatarData(storage = null) {
      if (_AvatarManager._inMemoryCustomData) return _AvatarManager._inMemoryCustomData;
      const s = storage || getStorage();
      if (!s) return null;
      try {
        const val = s.getItem(_AvatarManager.STORAGE_KEY_CUSTOM);
        if (val && typeof val === "string") return val;
      } catch (_) {
      }
      if (typeof localStorage !== "undefined" && s !== localStorage) {
        try {
          const val = localStorage.getItem(_AvatarManager.STORAGE_KEY_CUSTOM);
          if (val && typeof val === "string") return val;
        } catch (_) {
        }
      }
      return null;
    }
    /**
     * Retrieves the custom persona label/name from storage.
     * @param {Object} [storage=null]
     * @returns {string}
     */
    static getCustomAvatarName(storage = null) {
      if (_AvatarManager._inMemoryCustomName) return _AvatarManager._inMemoryCustomName;
      const s = storage || getStorage();
      if (!s) return "My Photo";
      try {
        const val = s.getItem(_AvatarManager.STORAGE_KEY_CUSTOM_NAME);
        if (val && typeof val === "string" && val.trim()) return val.trim();
      } catch (_) {
      }
      if (typeof localStorage !== "undefined" && s !== localStorage) {
        try {
          const val = localStorage.getItem(_AvatarManager.STORAGE_KEY_CUSTOM_NAME);
          if (val && typeof val === "string" && val.trim()) return val.trim();
        } catch (_) {
        }
      }
      return "My Photo";
    }
    /**
     * Saves a custom photo Data URL and sets it as the active avatar.
     * @param {string} dataUrl
     * @param {string} [name='My Photo']
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static setCustomAvatar(dataUrl, name = "My Photo", storage = null) {
      if (!dataUrl) return null;
      _AvatarManager._inMemoryCustomData = dataUrl;
      _AvatarManager._inMemoryCustomName = name;
      const s = storage || getStorage();
      if (s) {
        try {
          s.setItem(_AvatarManager.STORAGE_KEY_CUSTOM, dataUrl);
          s.setItem(_AvatarManager.STORAGE_KEY_CUSTOM_NAME, name);
        } catch (e) {
          console.warn("[AvatarManager] Custom avatar storage write warning:", e);
        }
      }
      if (typeof localStorage !== "undefined" && s !== localStorage) {
        try {
          localStorage.setItem(_AvatarManager.STORAGE_KEY_CUSTOM, dataUrl);
          localStorage.setItem(_AvatarManager.STORAGE_KEY_CUSTOM_NAME, name);
        } catch (_) {
        }
      }
      _AvatarManager._medallionCache?.clear();
      _AvatarManager._bodyWrapCache?.clear();
      _AvatarManager._canvasCache?.clear();
      _AvatarManager.setSelectedAvatarId("custom", storage);
      return _AvatarManager.getAvatarById("custom");
    }
    /**
     * Clears custom photo from storage and reverts to default avatar.
     * @param {Object} [storage=null]
     */
    static clearCustomAvatar(storage = null) {
      _AvatarManager._inMemoryCustomData = null;
      _AvatarManager._inMemoryCustomName = null;
      const s = storage || getStorage();
      if (s) {
        try {
          s.removeItem(_AvatarManager.STORAGE_KEY_CUSTOM);
          s.removeItem(_AvatarManager.STORAGE_KEY_CUSTOM_NAME);
        } catch (_) {
        }
      }
      if (typeof localStorage !== "undefined") {
        try {
          localStorage.removeItem(_AvatarManager.STORAGE_KEY_CUSTOM);
          localStorage.removeItem(_AvatarManager.STORAGE_KEY_CUSTOM_NAME);
        } catch (_) {
        }
      }
      _AvatarManager._medallionCache?.clear();
      _AvatarManager._bodyWrapCache?.clear();
      _AvatarManager._canvasCache?.clear();
      if (_AvatarManager.getSelectedAvatarId(storage) === "custom") {
        _AvatarManager.setSelectedAvatarId(_AvatarManager.DEFAULT_AVATAR_ID, storage);
      } else {
        _AvatarManager.syncAvatarUI(storage);
      }
    }
    /**
     * Registers a remote player's custom avatar photo for multiplayer sync.
     * @param {string} seatId - e.g. 'p2', 'p3'
     * @param {string} dataUrl - Compressed photo data URL
     * @param {string} [name=null]
     * @returns {Object}
     */
    static registerRemoteCustomAvatar(seatId, dataUrl, name = null) {
      if (!seatId || !dataUrl) return null;
      const cleanSeat = String(seatId).toLowerCase().trim();
      const key = cleanSeat.startsWith("custom_") ? cleanSeat : "custom_" + cleanSeat;
      const remoteObj = {
        id: key,
        name: name || `Player ${cleanSeat.replace(/\D/g, "") || ""}`,
        title: "Remote Cribbage Persona",
        badgeColor: "#f59e0b",
        bgColor: "linear-gradient(135deg, #1e1b4b, #312e81)",
        category: "Remote",
        isCustom: true,
        dataUrl,
        svg: _AvatarManager.generateCustomAvatarSvg(dataUrl)
      };
      _AvatarManager._remoteAvatars.set(key, remoteObj);
      _AvatarManager._medallionCache?.delete(`${key}_256`);
      _AvatarManager._bodyWrapCache?.delete(`${key}_512x256`);
      _AvatarManager.updateBoardPegPattern(cleanSeat, key);
      if (typeof window !== "undefined" && window._currentRenderer3D?.updatePegAvatars) {
        window._currentRenderer3D.updatePegAvatars();
      }
      return remoteObj;
    }
    /**
     * Generates clean SVG markup with embedded image and circular clip path for custom photos.
     * @param {string|null} dataUrl
     * @returns {string}
     */
    static generateCustomAvatarSvg(dataUrl) {
      if (!dataUrl) {
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="48" fill="#1e293b" stroke="#f59e0b" stroke-width="2.5"/>
        <circle cx="50" cy="40" r="16" fill="#94a3b8"/>
        <path d="M26 80 C26 62, 74 62, 74 80 Z" fill="#94a3b8"/>
      </svg>`;
      }
      const safeHref = String(dataUrl).replace(/"/g, "&quot;");
      return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <clipPath id="customClip_avatar">
          <circle cx="50" cy="50" r="46"/>
        </clipPath>
      </defs>
      <circle cx="50" cy="50" r="48" fill="#0f172a" stroke="#f59e0b" stroke-width="2.5"/>
      <image href="${safeHref}" xlink:href="${safeHref}" x="4" y="4" width="92" height="92" preserveAspectRatio="xMidYMid slice" clip-path="url(#customClip_avatar)"/>
      <circle cx="50" cy="50" r="46" fill="none" stroke="rgba(245, 158, 11, 0.45)" stroke-width="1.5"/>
    </svg>`;
    }
    /**
     * Processes, center-crops, and downscales an uploaded image file.
     * Disabled: custom avatar uploads are no longer supported.
     * @throws {Error}
     */
    static async processUploadedImage() {
      throw new Error("Custom avatar uploads are disabled");
    }
    /**
     * Retrieves the current user's selected avatar ID from storage.
     * @param {Object} [storage=null]
     * @returns {string}
     */
    static getSelectedAvatarId(storage = null) {
      const s = storage || getStorage();
      if (!s) return _AvatarManager.DEFAULT_AVATAR_ID;
      try {
        const val = s.getItem(_AvatarManager.STORAGE_KEY);
        if (val && typeof val === "string") {
          const trimmed = val.trim().toLowerCase();
          if (trimmed === "custom" || PRESET_AVATARS.some((a) => a.id === trimmed)) {
            return trimmed;
          }
        }
      } catch (e) {
        console.warn("[AvatarManager] Storage read warning:", e);
      }
      return _AvatarManager.DEFAULT_AVATAR_ID;
    }
    /**
     * Persists selected avatar ID into storage and dispatches UI synchronization.
     * Also broadcasts avatar updates across active WebRTC multiplayer connections.
     * @param {string} id
     * @param {Object} [storage=null]
     * @returns {string}
     */
    static setSelectedAvatarId(id, storage = null) {
      const valid = _AvatarManager.getAvatarById(id).id;
      const s = storage || getStorage();
      if (s) {
        try {
          s.setItem(_AvatarManager.STORAGE_KEY, valid);
        } catch (e) {
          console.warn("[AvatarManager] Storage write warning:", e);
        }
      }
      if (typeof localStorage !== "undefined" && s !== localStorage) {
        try {
          localStorage.setItem(_AvatarManager.STORAGE_KEY, valid);
        } catch (e) {
        }
      }
      _AvatarManager.syncAvatarUI(storage);
      _AvatarManager.updateBoardPegPattern("p1", valid);
      _AvatarManager.updateBoardPegPattern("you", valid);
      _AvatarManager.updateBoardPegPattern("team1", valid);
      if (typeof window !== "undefined" && window._currentRenderer3D?.updatePegAvatars) {
        window._currentRenderer3D.updatePegAvatars();
      }
      if (typeof window !== "undefined") {
        const net2 = window.net;
        const isOnline2 = typeof window.isOnline === "function" ? window.isOnline() : Boolean(net2?.ready && net2?.peer);
        if (isOnline2) {
          const mySeatId = typeof window.mySeat === "function" ? window.mySeat() : net2?.mySeatId || "p1";
          const customData = valid === "custom" ? _AvatarManager.getCustomAvatarData(storage) : null;
          const updateMsg = {
            type: "avatar_update",
            seatId: mySeatId,
            avatarId: valid,
            customAvatarData: customData
          };
          if (typeof window.netSend === "function") {
            window.netSend(updateMsg);
          } else if (typeof window.NetworkManager !== "undefined" && typeof window.NetworkManager.netSend === "function") {
            window.NetworkManager.netSend(updateMsg);
          }
        }
        window.dispatchEvent(new CustomEvent("avatar-changed", { detail: { avatarId: valid } }));
      }
      return valid;
    }
    /**
     * Updates an active SVG board's peg pattern definition in real-time.
     * @param {string} who
     * @param {string} avatarId
     */
    static updateBoardPegPattern(who, avatarId) {
      if (typeof document === "undefined") return;
      const patId = `pegAvatarPattern_${who}`;
      const patternEl = document.getElementById(patId);
      const avatar = _AvatarManager.getAvatarById(avatarId);
      const innerContent = avatar.svg.replace(/^<svg[^>]*>/, "").replace(/<\/svg>$/, "");
      if (patternEl) {
        patternEl.innerHTML = innerContent;
      }
    }
    /**
     * Returns full object for selected avatar.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static getSelectedAvatar(storage = null) {
      return _AvatarManager.getAvatarById(_AvatarManager.getSelectedAvatarId(storage));
    }
    /**
     * Renders raw scalable SVG markup for an avatar.
     * @param {string} id
     * @param {Object} [options={}]
     * @returns {string}
     */
    static renderAvatarSvg(id, options = {}) {
      const avatar = _AvatarManager.getAvatarById(id);
      const size = options.size || 32;
      const className = options.className || "avatar-svg";
      let raw = avatar.svg;
      if (size) {
        raw = raw.replace("<svg ", `<svg width="${size}" height="${size}" class="${className}" style="display:block;border-radius:50%;" `);
      }
      return raw;
    }
    /**
     * Renders an avatar badge component (container + SVG + glow ring).
     * @param {string} id
     * @param {Object} [options={}]
     * @returns {string}
     */
    static renderAvatarBadge(id, options = {}) {
      const avatar = _AvatarManager.getAvatarById(id);
      const size = options.size || 32;
      const showRing = options.showRing !== false;
      const ringColor = options.ringColor || avatar.badgeColor || "#f0c64a";
      const borderStyle = showRing ? `border: 2px solid ${ringColor}; box-shadow: 0 0 10px ${ringColor}44;` : "";
      const className = options.className || "cc-avatar-badge";
      return `
      <div class="${className}" data-avatar-id="${avatar.id}" title="${avatar.name} \u2014 ${avatar.title}" style="display:inline-flex;align-items:center;justify-content:center;width:${size}px;height:${size}px;border-radius:50%;background:${avatar.bgColor};${borderStyle}overflow:hidden;flex-shrink:0;vertical-align:middle;">
        ${_AvatarManager.renderAvatarSvg(avatar.id, { size: size - (showRing ? 4 : 0) })}
      </div>
    `.trim();
    }
    /**
     * Synchronizes all avatar preview elements across the DOM.
     */
    static syncAvatarUI(storage = null) {
      if (typeof document === "undefined") return;
      const avatar = _AvatarManager.getSelectedAvatar(storage);
      const lobbyPreviewEl = document.getElementById("playerAvatarPreview");
      if (lobbyPreviewEl) {
        lobbyPreviewEl.innerHTML = _AvatarManager.renderAvatarBadge(avatar.id, { size: 38, showRing: true });
      }
      const scoreChipAvatar = document.getElementById("scoreChipAvatarYou");
      if (scoreChipAvatar) {
        scoreChipAvatar.innerHTML = _AvatarManager.renderAvatarBadge(avatar.id, { size: 22, showRing: false });
      }
      const youZoneAvatar = document.getElementById("youZoneAvatar");
      if (youZoneAvatar) {
        youZoneAvatar.innerHTML = _AvatarManager.renderAvatarBadge(avatar.id, { size: 24, showRing: true });
      }
      const rosterRows = document.querySelectorAll(".net-roster-row.you .net-roster-avatar");
      rosterRows.forEach((el) => {
        el.innerHTML = _AvatarManager.renderAvatarBadge(avatar.id, { size: 26, showRing: true });
      });
      _AvatarManager.updateBoardPegPattern("p1", avatar.id);
      _AvatarManager.updateBoardPegPattern("you", avatar.id);
      _AvatarManager.updateBoardPegPattern("team1", avatar.id);
      if (typeof window !== "undefined" && window._currentRenderer3D?.updatePegAvatars) {
        window._currentRenderer3D.updatePegAvatars();
      }
    }
    /**
     * Opens the interactive Avatar Selection Modal.
     * @param {Object} [options={}]
     */
    static openAvatarModal(options = {}) {
      if (typeof document === "undefined") return;
      let overlay = document.getElementById("avatarModalOverlay");
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = "avatarModalOverlay";
        overlay.className = "avatar-modal-overlay";
        overlay.setAttribute("role", "dialog");
        overlay.setAttribute("aria-modal", "true");
        overlay.setAttribute("aria-labelledby", "avatarModalTitle");
        document.body.appendChild(overlay);
      }
      const fsElem = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
      const b3dElem = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
      const activeModalOverlay = document.getElementById("overlay");
      const modalParent = activeModalOverlay && activeModalOverlay.parentElement && activeModalOverlay.parentElement !== document.body ? activeModalOverlay.parentElement : null;
      const b3dContainer = document.getElementById("board3DContainer");
      const is3DFullscreen = Boolean(
        fsElem || b3dElem || b3dContainer && (b3dContainer.classList?.contains?.("is-fullscreen") || typeof document !== "undefined" && document.body?.classList?.contains?.("is-3d-fullscreen"))
      );
      const targetParent = fsElem || b3dElem || modalParent || (is3DFullscreen ? b3dContainer : null);
      if (targetParent && overlay.parentElement !== targetParent) {
        targetParent.appendChild(overlay);
      } else if (!targetParent && overlay.parentElement !== document.body && document.body) {
        document.body.appendChild(overlay);
      }
      overlay.style.zIndex = "20000000";
      if (!window._avatarEscapeBound && typeof window !== "undefined" && typeof window.addEventListener === "function") {
        window._avatarEscapeBound = true;
        window.addEventListener("keydown", (e) => {
          if (e.key === "Escape") {
            const el = document.getElementById("avatarModalOverlay");
            if (el && el.style.display !== "none") {
              _AvatarManager.closeAvatarModal();
            }
          }
        });
      }
      const currentId = _AvatarManager.getSelectedAvatarId();
      let tempSelectedId = currentId === "custom" || !PRESET_AVATARS.some((a) => a.id === currentId) ? _AvatarManager.DEFAULT_AVATAR_ID : currentId;
      const render2 = () => {
        const selected = _AvatarManager.getAvatarById(tempSelectedId);
        const playerNameEl = document.getElementById("optPlayerName");
        const playerName = playerNameEl && playerNameEl.value.trim() || "Player";
        overlay.innerHTML = `
        <div class="avatar-modal-card">
          <div class="avatar-modal-header">
            <div class="avatar-modal-title-group">
              <span class="avatar-modal-title-icon">\u{1F3AD}</span>
              <div>
                <h2 id="avatarModalTitle" class="avatar-modal-title">Choose Your Avatar</h2>
                <div class="avatar-modal-subtitle">Select your cribbage persona for pegs, boards, and scorecards</div>
              </div>
            </div>
            <button type="button" class="avatar-modal-close-btn" id="btnAvatarModalClose" aria-label="Close modal">\u2715</button>
          </div>

          <!-- Live Spotlight Preview Bar with 3D Turntable -->
          <div class="avatar-spotlight-bar" id="avatarSpotlightBar" style="background:${selected.bgColor};border:1.5px solid ${selected.badgeColor};">
            <div class="avatar-spotlight-badge" id="avatarSpotlightBadge">
              ${_AvatarManager.renderAvatarBadge(selected.id, { size: 68, showRing: true, ringColor: "#facc15" })}
            </div>
            <div class="avatar-spotlight-info">
              <div class="avatar-spotlight-player">Playing as <strong>${playerName}</strong></div>
              <div class="avatar-spotlight-name" id="avatarSpotlightName" style="color:#ffffff;">${selected.name}</div>
              <div class="avatar-spotlight-tag" id="avatarSpotlightTag" style="color:#fde047;">${selected.title}</div>
            </div>
            <div class="avatar-spotlight-3d">
              <div class="turntable-header">
                <span class="turntable-icon">\u{1F3B2}</span>
                <span>3D Peg</span>
              </div>
              <canvas id="avatar3DTurntableCanvas" class="avatar-3d-canvas" width="100" height="100" title="Interactive 3D Peg - Drag to spin"></canvas>
              <div class="turntable-hint">Drag to rotate 360\xB0</div>
            </div>
          </div>

          <!-- Avatar Grid -->
          <div class="avatar-modal-body">
            <div class="avatar-grid" id="avatarGrid">
              ${PRESET_AVATARS.map((a) => {
          const isSelected = a.id === tempSelectedId;
          return `
                  <div class="avatar-card ${isSelected ? "active" : ""}" data-avatar-id="${a.id}" tabindex="0" role="button" aria-pressed="${isSelected}">
                    <div class="avatar-card-badge-wrap" style="background:${a.bgColor};">
                      ${_AvatarManager.renderAvatarSvg(a.id, { size: 54 })}
                      ${isSelected ? `<span class="avatar-card-check">\u2713</span>` : ""}
                    </div>
                    <div class="avatar-card-name">${a.name}</div>
                    <div class="avatar-card-title">${a.title}</div>
                  </div>
                `;
        }).join("")}
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="avatar-modal-footer">
            <button type="button" class="btn-ghost avatar-modal-btn" id="btnAvatarCancel">Cancel</button>
            <button type="button" class="btn-gold avatar-modal-btn" id="btnAvatarConfirm">Confirm Avatar</button>
          </div>
        </div>
      `;
        overlay.onclick = (e) => {
          if (e.target === overlay) _AvatarManager.closeAvatarModal();
        };
        const closeBtn = document.getElementById("btnAvatarModalClose");
        if (closeBtn) closeBtn.onclick = () => _AvatarManager.closeAvatarModal();
        const cancelBtn = document.getElementById("btnAvatarCancel");
        if (cancelBtn) cancelBtn.onclick = () => _AvatarManager.closeAvatarModal();
        const confirmBtn = document.getElementById("btnAvatarConfirm");
        if (confirmBtn) {
          confirmBtn.onclick = () => {
            _AvatarManager.setSelectedAvatarId(tempSelectedId);
            _AvatarManager.closeAvatarModal();
            if (typeof options.onSelect === "function") {
              options.onSelect(tempSelectedId);
            }
          };
        }
        const cards = overlay.querySelectorAll(".avatar-card");
        const updateSelection = (id) => {
          tempSelectedId = id;
          const item = _AvatarManager.getAvatarById(id);
          const bar = document.getElementById("avatarSpotlightBar");
          if (bar) {
            bar.style.background = item.bgColor;
            bar.style.borderColor = item.badgeColor;
          }
          const badge = document.getElementById("avatarSpotlightBadge");
          if (badge) {
            badge.innerHTML = _AvatarManager.renderAvatarBadge(item.id, { size: 68, showRing: true, ringColor: "#facc15" });
          }
          const nameEl = document.getElementById("avatarSpotlightName");
          if (nameEl) nameEl.textContent = item.name;
          const tagEl = document.getElementById("avatarSpotlightTag");
          if (tagEl) tagEl.textContent = item.title;
          cards.forEach((c) => {
            const isAct = c.getAttribute("data-avatar-id") === id;
            c.classList.toggle("active", isAct);
            c.setAttribute("aria-pressed", isAct ? "true" : "false");
            let check = c.querySelector(".avatar-card-check");
            if (isAct && !check) {
              const wrap = c.querySelector(".avatar-card-badge-wrap");
              if (wrap) wrap.insertAdjacentHTML("beforeend", `<span class="avatar-card-check">\u2713</span>`);
            } else if (!isAct && check) {
              check.remove();
            }
          });
          if (_AvatarManager._turntable?.updateAvatar) {
            _AvatarManager._turntable.updateAvatar(id);
          }
        };
        cards.forEach((card) => {
          const id = card.getAttribute("data-avatar-id");
          if (id) {
            card.onclick = () => updateSelection(id);
            card.onkeydown = (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                updateSelection(id);
              }
            };
          }
        });
        const ttCanvas = document.getElementById("avatar3DTurntableCanvas");
        if (ttCanvas) {
          _AvatarManager.initTurntable(ttCanvas, tempSelectedId);
        }
      };
      render2();
      overlay.style.display = "flex";
      overlay.style.zIndex = "20000000";
      _AvatarManager._activeModal = overlay;
    }
    /**
     * Closes the active Avatar Selection Modal and cleans up 3D turntable.
     */
    static closeAvatarModal() {
      if (typeof document === "undefined") return;
      _AvatarManager.destroyTurntable();
      const overlay = document.getElementById("avatarModalOverlay");
      if (overlay) {
        overlay.style.display = "none";
        const fsElem = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
        const b3dElem = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
        if (overlay.parentElement !== document.body && !fsElem && !b3dElem && document.body) {
          document.body.appendChild(overlay);
        }
      }
      _AvatarManager._activeModal = null;
    }
    /**
     * Phase 2: Creates SVG <pattern> definition for wrapping cribbage pegs on 2D SVG boards.
     * @param {string} id
     * @param {string} patternId
     * @returns {string}
     */
    static getAvatarPatternSvg(id, patternId = "pegAvatarPattern") {
      const avatar = _AvatarManager.getAvatarById(id);
      const innerContent = avatar.svg.replace(/^<svg[^>]*>/, "").replace(/<\/svg>$/, "");
      return `
      <pattern id="${patternId}" patternUnits="objectBoundingBox" width="1" height="1" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice">
        ${innerContent}
      </pattern>
    `.trim();
    }
    /**
     * Phase 3 & 4: Creates an HTMLCanvasElement rendering the avatar SVG or custom photo for Babylon.js DynamicTexture wrapping.
     * @param {string} id
     * @param {number} [width=128]
     * @param {number} [height=128]
     * @returns {Promise<HTMLCanvasElement|null>}
     */
    static async createAvatarCanvas(id, width = 128, height = 128) {
      if (typeof document === "undefined") return null;
      const avatar = _AvatarManager.getAvatarById(id);
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (!ctx) return canvas;
      if (avatar.dataUrl) {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            ctx.clearRect(0, 0, width, height);
            ctx.save();
            ctx.beginPath();
            ctx.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, Math.PI * 2);
            ctx.clip();
            ctx.drawImage(img, 0, 0, width, height);
            ctx.restore();
            resolve(canvas);
          };
          img.onerror = () => resolve(canvas);
          img.src = avatar.dataUrl;
        });
      }
      return new Promise((resolve) => {
        const img = new Image();
        const svgBlob = new Blob([avatar.svg], { type: "image/svg+xml;charset=utf-8" });
        const url = URL.createObjectURL(svgBlob);
        img.onload = () => {
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);
          URL.revokeObjectURL(url);
          resolve(canvas);
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(canvas);
        };
        img.src = url;
      });
    }
    /**
     * Phase 3: Generates a 256x256 circular coin medallion texture with milled metallic rim,
     * cameo relief portrait, and specular dome highlight for the top of 3D cribbage pegs.
     * @param {string} id - Avatar preset ID
     * @param {number} [size=256] - Medallion diameter in pixels
     * @returns {Promise<HTMLCanvasElement|null>}
     */
    static async createAvatarMedallionCanvas(id, size = 256) {
      if (typeof document === "undefined") return null;
      _AvatarManager._medallionCache = _AvatarManager._medallionCache || /* @__PURE__ */ new Map();
      const cacheKey = `${id}_${size}`;
      if (_AvatarManager._medallionCache.has(cacheKey)) {
        return _AvatarManager._medallionCache.get(cacheKey);
      }
      const avatar = _AvatarManager.getAvatarById(id);
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext("2d");
      if (!ctx) return canvas;
      const cx = size / 2;
      const cy = size / 2;
      const rOuter = size * 0.48;
      const gradRim = ctx.createLinearGradient(0, 0, size, size);
      gradRim.addColorStop(0, "#fef08a");
      gradRim.addColorStop(0.35, "#ca8a04");
      gradRim.addColorStop(0.7, "#eab308");
      gradRim.addColorStop(1, "#854d0e");
      ctx.beginPath();
      ctx.arc(cx, cy, rOuter, 0, Math.PI * 2);
      ctx.fillStyle = gradRim;
      ctx.fill();
      const notches = 48;
      ctx.strokeStyle = "rgba(69, 26, 3, 0.55)";
      ctx.lineWidth = 1.6;
      for (let i = 0; i < notches; i++) {
        const angle = i * Math.PI * 2 / notches;
        const x1 = cx + Math.cos(angle) * (rOuter - 5);
        const y1 = cy + Math.sin(angle) * (rOuter - 5);
        const x2 = cx + Math.cos(angle) * rOuter;
        const y2 = cy + Math.sin(angle) * rOuter;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(cx, cy, rOuter - 6, 0, Math.PI * 2);
      ctx.strokeStyle = "#fef08a";
      ctx.lineWidth = 2.2;
      ctx.stroke();
      const rInner = rOuter - 10;
      const gradBg = ctx.createRadialGradient(cx, cy * 0.85, 4, cx, cy, rInner);
      gradBg.addColorStop(0, avatar.badgeColor || "#a855f7");
      gradBg.addColorStop(0.85, "#0f172a");
      gradBg.addColorStop(1, "#020617");
      ctx.beginPath();
      ctx.arc(cx, cy, rInner, 0, Math.PI * 2);
      ctx.fillStyle = gradBg;
      ctx.fill();
      const avatarCanvas = await _AvatarManager.createAvatarCanvas(id, Math.round(rInner * 1.85), Math.round(rInner * 1.85));
      if (avatarCanvas) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(cx, cy, rInner - 1, 0, Math.PI * 2);
        ctx.clip();
        ctx.drawImage(avatarCanvas, cx - rInner * 0.925, cy - rInner * 0.925, rInner * 1.85, rInner * 1.85);
        ctx.restore();
      }
      const gradGloss = ctx.createRadialGradient(cx, cy * 0.6, 2, cx, cy * 0.6, rInner * 0.9);
      gradGloss.addColorStop(0, "rgba(255, 255, 255, 0.45)");
      gradGloss.addColorStop(0.45, "rgba(255, 255, 255, 0.08)");
      gradGloss.addColorStop(1, "rgba(255, 255, 255, 0)");
      ctx.beginPath();
      ctx.arc(cx, cy, rInner, 0, Math.PI * 2);
      ctx.fillStyle = gradGloss;
      ctx.fill();
      ctx.beginPath();
      ctx.arc(cx, cy, rOuter, 0, Math.PI * 2);
      ctx.strokeStyle = "rgba(0, 0, 0, 0.4)";
      ctx.lineWidth = 1;
      ctx.stroke();
      _AvatarManager._medallionCache.set(cacheKey, canvas);
      return canvas;
    }
    /**
     * Phase 3: Generates a 512x256 cylindrical wrap texture featuring dual portrait cameos (front & back),
     * gold filigree collars, and card suit trims for the body of 3D cribbage pegs.
     * @param {string} id - Avatar preset ID
     * @param {number} [width=512]
     * @param {number} [height=256]
     * @returns {Promise<HTMLCanvasElement|null>}
     */
    static async createAvatarBodyWrapCanvas(id, width = 512, height = 256) {
      if (typeof document === "undefined") return null;
      _AvatarManager._bodyWrapCache = _AvatarManager._bodyWrapCache || /* @__PURE__ */ new Map();
      const cacheKey = `${id}_${width}x${height}`;
      if (_AvatarManager._bodyWrapCache.has(cacheKey)) {
        return _AvatarManager._bodyWrapCache.get(cacheKey);
      }
      const avatar = _AvatarManager.getAvatarById(id);
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (!ctx) return canvas;
      const bgGrad = ctx.createLinearGradient(0, 0, 0, height);
      bgGrad.addColorStop(0, "#0f172a");
      bgGrad.addColorStop(0.2, avatar.badgeColor || "#6366f1");
      bgGrad.addColorStop(0.5, "#1e1b4b");
      bgGrad.addColorStop(0.85, "#090d16");
      bgGrad.addColorStop(1, "#020617");
      ctx.fillStyle = bgGrad;
      ctx.fillRect(0, 0, width, height);
      const trimH = 26;
      const topGrad = ctx.createLinearGradient(0, 0, 0, trimH);
      topGrad.addColorStop(0, "#fef08a");
      topGrad.addColorStop(0.5, "#ca8a04");
      topGrad.addColorStop(1, "#78350f");
      ctx.fillStyle = topGrad;
      ctx.fillRect(0, 0, width, trimH);
      ctx.fillStyle = "#fde047";
      ctx.fillRect(0, trimH - 2, width, 2);
      const botGrad = ctx.createLinearGradient(0, height - trimH - 4, 0, height);
      botGrad.addColorStop(0, "#78350f");
      botGrad.addColorStop(0.5, "#ca8a04");
      botGrad.addColorStop(1, "#fef08a");
      ctx.fillStyle = botGrad;
      ctx.fillRect(0, height - trimH - 4, width, trimH + 4);
      ctx.fillStyle = "#fde047";
      ctx.fillRect(0, height - trimH - 4, width, 2);
      ctx.fillStyle = "#fef08a";
      for (let x = 8; x < width; x += 16) {
        ctx.beginPath();
        ctx.arc(x, trimH / 2, 2, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();
        ctx.arc(x, height - trimH / 2 - 2, 2, 0, Math.PI * 2);
        ctx.fill();
      }
      const cameoR = Math.round((height - trimH * 2) * 0.35);
      const avatarCanvas = await _AvatarManager.createAvatarCanvas(id, cameoR * 2, cameoR * 2);
      const centers = [width * 0.25, width * 0.75];
      const cy = height * 0.51;
      centers.forEach((cx) => {
        ctx.beginPath();
        ctx.arc(cx, cy, cameoR + 5, 0, Math.PI * 2);
        ctx.fillStyle = "#ca8a04";
        ctx.fill();
        ctx.lineWidth = 2.5;
        ctx.strokeStyle = "#fef08a";
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(cx, cy, cameoR, 0, Math.PI * 2);
        ctx.fillStyle = "#0f172a";
        ctx.fill();
        if (avatarCanvas) {
          ctx.save();
          ctx.beginPath();
          ctx.arc(cx, cy, cameoR, 0, Math.PI * 2);
          ctx.clip();
          ctx.drawImage(avatarCanvas, cx - cameoR, cy - cameoR, cameoR * 2, cameoR * 2);
          ctx.restore();
        }
        const g = ctx.createLinearGradient(cx - cameoR, cy - cameoR, cx + cameoR, cy + cameoR);
        g.addColorStop(0, "rgba(255, 255, 255, 0.4)");
        g.addColorStop(0.4, "rgba(255, 255, 255, 0.05)");
        g.addColorStop(1, "rgba(255, 255, 255, 0)");
        ctx.beginPath();
        ctx.arc(cx, cy, cameoR, 0, Math.PI * 2);
        ctx.fillStyle = g;
        ctx.fill();
        ctx.font = "bold 12px sans-serif";
        ctx.textAlign = "center";
        ctx.fillStyle = "#000000";
        ctx.fillText(avatar.name, cx + 1, cy + cameoR + 15);
        ctx.fillStyle = "#fde047";
        ctx.fillText(avatar.name, cx, cy + cameoR + 14);
      });
      ctx.font = "16px serif";
      ctx.textAlign = "center";
      ctx.fillStyle = "rgba(250, 204, 21, 0.65)";
      [width * 0.02, width * 0.5, width * 0.98].forEach((x) => {
        ctx.fillText("\u2666", x, cy - 20);
        ctx.fillText("\u2660", x, cy + 20);
      });
      _AvatarManager._bodyWrapCache.set(cacheKey, canvas);
      return canvas;
    }
    /**
     * Phase 3: Initializes interactive 3D Babylon.js Turntable inside the Avatar Modal spotlight bar.
     * Provides 360° auto-spin, pointer drag rotation, and live persona switching.
     * @param {HTMLCanvasElement} canvas
     * @param {string} avatarId
     * @returns {Promise<Object|null>}
     */
    static async initTurntable(canvas, avatarId) {
      if (!canvas || typeof window === "undefined") return null;
      _AvatarManager.destroyTurntable();
      let BABYLON = window.BABYLON;
      if (!BABYLON || !BABYLON.Engine) {
        if (typeof window.BoardRenderer3D !== "undefined" && typeof window.BoardRenderer3D.prototype?.loadBabylon === "function") {
          try {
            BABYLON = await window.BoardRenderer3D.prototype.loadBabylon.call({});
          } catch (_) {
          }
        }
        if (!BABYLON || !BABYLON.Engine) {
          try {
            await new Promise((res, rej) => {
              const s = document.createElement("script");
              s.src = "dist/babylon.min.js";
              s.onload = () => res();
              s.onerror = (e) => rej(e);
              document.head.appendChild(s);
            });
            BABYLON = window.BABYLON;
          } catch (_) {
          }
        }
      }
      if (!BABYLON || !BABYLON.Engine) return null;
      try {
        const engine = new BABYLON.Engine(canvas, true, { preserveDrawingBuffer: true, stencil: true, alpha: true });
        const scene = new BABYLON.Scene(engine);
        scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
        const camera = new BABYLON.ArcRotateCamera("ttCam", -Math.PI / 2, Math.PI / 2.8, 5.4, new BABYLON.Vector3(0, 0.95, 0), scene);
        camera.lowerRadiusLimit = 3.5;
        camera.upperRadiusLimit = 8;
        camera.wheelPrecision = 40;
        camera.attachControl(canvas, true);
        const hemi = new BABYLON.HemisphericLight("ttHemi", new BABYLON.Vector3(0, 1, 0), scene);
        hemi.intensity = 0.95;
        const dir = new BABYLON.DirectionalLight("ttDir", new BABYLON.Vector3(-1, 2, -1), scene);
        dir.intensity = 1.05;
        const point = new BABYLON.PointLight("ttPt", new BABYLON.Vector3(2, 2, 2), scene);
        point.intensity = 0.55;
        const pegRoot = new BABYLON.TransformNode("ttPegRoot", scene);
        const shank = BABYLON.MeshBuilder.CreateCylinder("ttShank", {
          height: 0.5,
          diameterTop: 0.52,
          diameterBottom: 0.44,
          tessellation: 24
        }, scene);
        shank.position.y = -0.25;
        shank.parent = pegRoot;
        const body = BABYLON.MeshBuilder.CreateCylinder("ttBody", {
          height: 1.8,
          diameterTop: 0.68,
          diameterBottom: 0.82,
          tessellation: 32
        }, scene);
        body.position.y = 0.9;
        body.parent = pegRoot;
        const cap = BABYLON.MeshBuilder.CreateSphere("ttCap", {
          diameter: 0.92,
          segments: 20
        }, scene);
        cap.position.y = 1.8;
        cap.parent = pegRoot;
        const medallion = BABYLON.MeshBuilder.CreateCylinder("ttMedallion", {
          height: 0.12,
          diameter: 0.94,
          tessellation: 32
        }, scene);
        medallion.position.y = 2.22;
        medallion.parent = pegRoot;
        const matGold = new BABYLON.PBRMaterial("ttMatGold", scene);
        matGold.albedoColor = new BABYLON.Color3(0.92, 0.74, 0.2);
        matGold.metallic = 0.92;
        matGold.roughness = 0.18;
        if (matGold.clearCoat) {
          matGold.clearCoat.isEnabled = true;
          matGold.clearCoat.intensity = 0.6;
        }
        shank.material = matGold;
        cap.material = matGold;
        const matBody = new BABYLON.PBRMaterial("ttMatBody", scene);
        matBody.metallic = 0.25;
        matBody.roughness = 0.35;
        body.material = matBody;
        const matMedallion = new BABYLON.PBRMaterial("ttMatMedallion", scene);
        matMedallion.metallic = 0.45;
        matMedallion.roughness = 0.22;
        medallion.material = matMedallion;
        let currentDynBody = null;
        let currentDynMed = null;
        const updateTextures = async (currId) => {
          try {
            const [bodyCanvas, medCanvas] = await Promise.all([
              _AvatarManager.createAvatarBodyWrapCanvas(currId),
              _AvatarManager.createAvatarMedallionCanvas(currId)
            ]);
            if (scene.isDisposed) return;
            if (bodyCanvas) {
              if (currentDynBody) currentDynBody.dispose();
              currentDynBody = new BABYLON.DynamicTexture(`ttDynBody_${currId}`, { width: bodyCanvas.width, height: bodyCanvas.height }, scene, true);
              const bctx = currentDynBody.getContext();
              bctx.drawImage(bodyCanvas, 0, 0);
              currentDynBody.update();
              matBody.albedoTexture = currentDynBody;
            }
            if (medCanvas) {
              if (currentDynMed) currentDynMed.dispose();
              currentDynMed = new BABYLON.DynamicTexture(`ttDynMed_${currId}`, { width: medCanvas.width, height: medCanvas.height }, scene, true);
              const mctx = currentDynMed.getContext();
              mctx.drawImage(medCanvas, 0, 0);
              currentDynMed.update();
              matMedallion.albedoTexture = currentDynMed;
            }
          } catch (e) {
            console.warn("[AvatarManager] Turntable texture update error:", e);
          }
        };
        await updateTextures(avatarId);
        let isDragging = false;
        const onDown = () => {
          isDragging = true;
        };
        const onUp = () => {
          isDragging = false;
        };
        canvas.addEventListener("pointerdown", onDown);
        window.addEventListener("pointerup", onUp);
        const renderCallback = () => {
          if (!scene.isDisposed) {
            if (!isDragging) {
              pegRoot.rotation.y += 0.016;
            }
            scene.render();
          }
        };
        engine.runRenderLoop(renderCallback);
        const onResize = () => engine.resize();
        window.addEventListener("resize", onResize);
        const turntableObj = {
          engine,
          scene,
          pegRoot,
          updateAvatar: (newId) => updateTextures(newId),
          destroy: () => {
            canvas.removeEventListener("pointerdown", onDown);
            window.removeEventListener("pointerup", onUp);
            window.removeEventListener("resize", onResize);
            if (currentDynBody) currentDynBody.dispose();
            if (currentDynMed) currentDynMed.dispose();
            scene.dispose();
            engine.dispose();
          }
        };
        _AvatarManager._turntable = turntableObj;
        return turntableObj;
      } catch (err) {
        console.warn("[AvatarManager] Could not initialize 3D turntable:", err);
        return null;
      }
    }
    /**
     * Destroys active 3D turntable instance and frees WebGL resources.
     */
    static destroyTurntable() {
      if (_AvatarManager._turntable) {
        try {
          _AvatarManager._turntable.destroy();
        } catch (_) {
        }
        _AvatarManager._turntable = null;
      }
    }
  };
  if (typeof window !== "undefined") {
    window.AvatarManager = AvatarManager;
    window.openAvatarModal = (options) => AvatarManager.openAvatarModal(options);
    window.closeAvatarModal = () => AvatarManager.closeAvatarModal();
  }

  // src/board/RoomCatalog3D.js
  var RoomCatalog3D = class {
    /**
     * Theme configuration dictionary.
     */
    static ROOM_THEMES = {
      pub: {
        id: "pub",
        name: "The Old Pub & Tavern",
        description: "Oak plank tavern floor, aged brick and wood paneling, brass pendant, and tavern chairs",
        wallColor: "#2b1b11",
        brickColor: "#5c2a1a",
        floorColor: "#1e130a",
        tableFinish: "oak",
        tableStyle: "trestle",
        chairStyle: "pub",
        ceilingStyle: "beams",
        ambientColor: { r: 0.95, g: 0.75, b: 0.45 },
        lightColor: { r: 1, g: 0.82, b: 0.55 },
        lightIntensity: 1.25,
        hasFireplace: true,
        hasCoasters: true
      },
      vegas: {
        id: "vegas",
        name: "Vegas High Roller Suite",
        description: "Polished checkered marble, gold moldings, nighttime skyline view, baize card table",
        wallColor: "#121820",
        brickColor: "#0a1018",
        floorColor: "#0d131a",
        tableFinish: "baize",
        tableStyle: "pedestal",
        chairStyle: "swivel",
        ceilingStyle: "coffered",
        ambientColor: { r: 0.65, g: 0.75, b: 0.95 },
        lightColor: { r: 0.98, g: 0.95, b: 0.88 },
        lightIntensity: 1.35,
        hasSkyline: true,
        hasChips: true
      },
      cabin: {
        id: "cabin",
        name: "Cozy Mountain Lodge",
        description: "Knotty pine timber logs, stone hearth, snow-capped window, rustic live-edge slab table",
        wallColor: "#3d2514",
        brickColor: "#4a3220",
        floorColor: "#2b190c",
        tableFinish: "slab",
        tableStyle: "rustic",
        chairStyle: "timber",
        ceilingStyle: "trusses",
        ambientColor: { r: 0.98, g: 0.72, b: 0.4 },
        lightColor: { r: 1, g: 0.78, b: 0.48 },
        lightIntensity: 1.2,
        hasFireplace: true,
        hasSnowWindow: true
      },
      velvet: {
        id: "velvet",
        name: "Velvet Speakeasy Lounge",
        description: "Chevron parquet floor, emerald & burgundy tufted velvet walls, art-deco walnut table",
        wallColor: "#14251e",
        brickColor: "#2d121c",
        floorColor: "#1c150e",
        tableFinish: "walnut",
        tableStyle: "artdeco",
        chairStyle: "velvet",
        ceilingStyle: "tin",
        ambientColor: { r: 0.92, g: 0.68, b: 0.48 },
        lightColor: { r: 1, g: 0.85, b: 0.6 },
        lightIntensity: 1.15,
        hasArtDecoTrim: true
      },
      thunderdome: {
        id: "thunderdome",
        name: "The Thunderdome / Industrial",
        description: "Diamond-plate steel flooring, hazard lines, riveted iron walls, exposed copper fixtures",
        wallColor: "#1a1d22",
        brickColor: "#111418",
        floorColor: "#15181e",
        tableFinish: "steel",
        tableStyle: "industrial",
        chairStyle: "bucket",
        ceilingStyle: "trusses",
        ambientColor: { r: 0.55, g: 0.75, b: 0.95 },
        lightColor: { r: 0.95, g: 0.8, b: 0.5 },
        lightIntensity: 1.3,
        hasHazardStripes: true,
        hasNeonTrim: true
      },
      studio: {
        id: "studio",
        name: "Nordic Minimalist Studio",
        description: "Bleached ash hardwood floor, acoustic oak slat walls, modern round table and shell chairs",
        wallColor: "#2c2e33",
        brickColor: "#222428",
        floorColor: "#3a342c",
        tableFinish: "ash",
        tableStyle: "scandinavian",
        chairStyle: "shell",
        ceilingStyle: "skylight",
        ambientColor: { r: 0.92, g: 0.94, b: 0.98 },
        lightColor: { r: 1, g: 0.98, b: 0.92 },
        lightIntensity: 1.4,
        hasWoodSlats: true
      },
      none: {
        id: "none",
        name: "Minimalist Studio Backdrop",
        description: "Clean studio floor with subtle vignette lighting",
        wallColor: "#181a1f",
        brickColor: "#121418",
        floorColor: "#181a1f",
        tableFinish: "matte",
        tableStyle: "pedestal",
        chairStyle: "shell",
        ceilingStyle: "flat",
        ambientColor: { r: 0.7, g: 0.7, b: 0.75 },
        lightColor: { r: 1, g: 1, b: 1 },
        lightIntensity: 1
      }
    };
    /**
     * Retrieves all available room theme options.
     * @returns {Array<Object>}
     */
    static getThemes() {
      return Object.values(this.ROOM_THEMES);
    }
    /**
     * Retrieves a theme configuration by ID, falling back safely to 'pub'.
     * @param {string} themeId
     * @returns {Object}
     */
    static getThemeById(themeId) {
      if (!themeId || themeId === "auto") return this.ROOM_THEMES.pub;
      const tid = String(themeId).toLowerCase();
      if (tid === "raceway") return this.ROOM_THEMES.thunderdome;
      if (tid === "lounge") return this.ROOM_THEMES.velvet;
      return this.ROOM_THEMES[tid] || this.ROOM_THEMES.pub;
    }
    /**
     * Builds the complete 3D Room, Floor, Walls, Table, Chairs, and Lighting.
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {string} themeId
     * @param {Object} [options={}]
     * @returns {Object} { rootNode, tableMesh, chairMeshes, lights, theme, dims }
     */
    static buildRoom(scene, BABYLON, themeId, options = {}) {
      if (!scene || !BABYLON) return null;
      const theme2 = this.getThemeById(themeId);
      const bounds = options.bounds || { min: { y: -0.8 }, size: { x: 120, z: 80 } };
      const baseBoardX = bounds.size?.x || 120;
      const baseBoardZ = bounds.size?.z || 80;
      const tableW = Math.max(88, Math.round(baseBoardX + 54));
      const tableD = Math.max(72, Math.round(baseBoardZ + 48));
      const tableH = 3.6;
      const boardBottomY = bounds.min?.y != null ? bounds.min.y : -0.8;
      const tableSurfaceY = boardBottomY - 0.08;
      const floorY = tableSurfaceY - 110;
      const roomW = Math.max(760, Math.round(tableW * 4.8));
      const roomD = Math.max(720, Math.round(tableD * 4.8));
      const roomH = 560;
      const ceilingY = floorY + roomH;
      const seatW = Math.min(84, Math.round(tableW * 0.52));
      const seatD = Math.min(70, Math.round(tableD * 0.52));
      const seatH = 10;
      const seatElev = 66;
      const backH = 52;
      const dims = { tableW, tableD, tableH, tableSurfaceY, floorY, roomW, roomD, roomH, ceilingY, seatW, seatD, seatH, seatElev, backH };
      const rootNode = new BABYLON.TransformNode(`room3DRoot_${theme2.id}`, scene);
      const lights = [];
      const chairMeshes = [];
      if (theme2.id !== "none") {
        this.buildRoomShell(scene, BABYLON, rootNode, theme2, dims);
      } else {
        this.buildMinimalFloor(scene, BABYLON, rootNode, dims);
      }
      const tableMesh = this.buildTable(scene, BABYLON, rootNode, theme2, dims);
      const seatCount = options.seatCount || (Array.isArray(options.activeTracks) ? options.activeTracks.length : 2);
      const chairs = this.buildChairs(scene, BABYLON, rootNode, theme2, dims, Math.max(2, Math.min(8, seatCount)));
      chairMeshes.push(...chairs);
      const roomLights = this.buildLighting(scene, BABYLON, rootNode, theme2, dims, bounds);
      lights.push(...roomLights);
      const props = theme2.id !== "none" ? this.buildProps(scene, BABYLON, rootNode, theme2, dims) : [];
      const chairRoots = chairs.map((c) => c.parent).filter(Boolean);
      return {
        rootNode,
        tableMesh,
        chairMeshes,
        chairRoots,
        lights,
        props,
        theme: theme2,
        dims
      };
    }
    /**
     * Builds the room shell: Floor plane, Back Wall, Side Walls, and Ceiling with procedural PBR materials.
     */
    static buildRoomShell(scene, BABYLON, rootNode, theme2, dims) {
      const { roomW, roomD, floorY, ceilingY, roomH } = dims;
      const floor = BABYLON.MeshBuilder.CreateGround("room3DFloor", { width: roomW, height: roomD }, scene);
      floor.position.set(0, floorY, 0);
      floor.parent = rootNode;
      floor.receiveShadows = true;
      floor.isPickable = false;
      floor.checkCollisions = true;
      const floorMat = new BABYLON.PBRMaterial(`matRoomFloor_${theme2.id}`, scene);
      floorMat.roughness = theme2.id === "vegas" ? 0.18 : theme2.id === "pub" ? 0.42 : 0.35;
      floorMat.metallic = theme2.id === "thunderdome" ? 0.65 : 0.05;
      if (BABYLON.DynamicTexture) {
        const floorTex = new BABYLON.DynamicTexture(`texRoomFloor_${theme2.id}`, { width: 1024, height: 1024 }, scene, true);
        const ctx = floorTex.getContext();
        this.drawFloorTexture(ctx, theme2);
        floorTex.update();
        floorTex.uScale = 4;
        floorTex.vScale = 4;
        floorMat.albedoTexture = floorTex;
      } else {
        floorMat.albedoColor = new BABYLON.Color3(0.12, 0.08, 0.05);
      }
      floor.material = floorMat;
      const doubleSide = BABYLON.Mesh && BABYLON.Mesh.DOUBLESIDE != null ? BABYLON.Mesh.DOUBLESIDE : 2;
      const backWall = BABYLON.MeshBuilder.CreatePlane("room3DBackWall", { width: roomW, height: roomH, sideOrientation: doubleSide }, scene);
      backWall.position.set(0, floorY + roomH / 2, roomD / 2);
      backWall.parent = rootNode;
      backWall.receiveShadows = true;
      backWall.isPickable = false;
      backWall.checkCollisions = true;
      const wallMat = new BABYLON.PBRMaterial(`matRoomWall_${theme2.id}`, scene);
      wallMat.roughness = 0.65;
      wallMat.metallic = 0.02;
      wallMat.backFaceCulling = false;
      wallMat.twoSidedLighting = true;
      if (BABYLON.DynamicTexture) {
        const wallTex = new BABYLON.DynamicTexture(`texRoomWall_${theme2.id}`, { width: 1024, height: 512 }, scene, true);
        const ctx = wallTex.getContext();
        this.drawWallTexture(ctx, theme2);
        wallTex.update();
        wallTex.uScale = 2;
        wallTex.vScale = 4;
        wallMat.albedoTexture = wallTex;
      } else {
        wallMat.albedoColor = new BABYLON.Color3(0.18, 0.14, 0.12);
      }
      backWall.material = wallMat;
      const leftWall = BABYLON.MeshBuilder.CreatePlane("room3DLeftWall", { width: roomD, height: roomH, sideOrientation: doubleSide }, scene);
      leftWall.rotation.y = Math.PI / 2;
      leftWall.position.set(-roomW / 2, floorY + roomH / 2, 0);
      leftWall.parent = rootNode;
      leftWall.receiveShadows = true;
      leftWall.isPickable = false;
      leftWall.checkCollisions = true;
      leftWall.material = wallMat;
      const rightWall = BABYLON.MeshBuilder.CreatePlane("room3DRightWall", { width: roomD, height: roomH, sideOrientation: doubleSide }, scene);
      rightWall.rotation.y = -Math.PI / 2;
      rightWall.position.set(roomW / 2, floorY + roomH / 2, 0);
      rightWall.parent = rootNode;
      rightWall.receiveShadows = true;
      rightWall.isPickable = false;
      rightWall.checkCollisions = true;
      rightWall.material = wallMat;
      const frontWall = BABYLON.MeshBuilder.CreatePlane("room3DFrontWall", { width: roomW, height: roomH, sideOrientation: doubleSide }, scene);
      frontWall.rotation.y = Math.PI;
      frontWall.position.set(0, floorY + roomH / 2, -roomD / 2);
      frontWall.parent = rootNode;
      frontWall.receiveShadows = true;
      frontWall.isPickable = false;
      frontWall.checkCollisions = true;
      frontWall.material = wallMat;
      const baseboardH = 6;
      const baseboardD = 1.6;
      const baseboardMat = new BABYLON.PBRMaterial(`matBaseboard_${theme2.id}`, scene);
      baseboardMat.albedoColor = new BABYLON.Color3(0.14, 0.09, 0.06);
      baseboardMat.roughness = 0.35;
      const backBaseboard = BABYLON.MeshBuilder.CreateBox("baseboardBack", { width: roomW, height: baseboardH, depth: baseboardD }, scene);
      backBaseboard.position.set(0, floorY + baseboardH / 2, roomD / 2 - baseboardD / 2);
      backBaseboard.parent = rootNode;
      backBaseboard.material = baseboardMat;
      const frontBaseboard = BABYLON.MeshBuilder.CreateBox("baseboardFront", { width: roomW, height: baseboardH, depth: baseboardD }, scene);
      frontBaseboard.position.set(0, floorY + baseboardH / 2, -roomD / 2 + baseboardD / 2);
      frontBaseboard.parent = rootNode;
      frontBaseboard.material = baseboardMat;
      const leftBaseboard = BABYLON.MeshBuilder.CreateBox("baseboardLeft", { width: baseboardD, height: baseboardH, depth: roomD }, scene);
      leftBaseboard.position.set(-roomW / 2 + baseboardD / 2, floorY + baseboardH / 2, 0);
      leftBaseboard.parent = rootNode;
      leftBaseboard.material = baseboardMat;
      const rightBaseboard = BABYLON.MeshBuilder.CreateBox("baseboardRight", { width: baseboardD, height: baseboardH, depth: roomD }, scene);
      rightBaseboard.position.set(roomW / 2 - baseboardD / 2, floorY + baseboardH / 2, 0);
      rightBaseboard.parent = rootNode;
      rightBaseboard.material = baseboardMat;
      this.buildWindow(scene, BABYLON, rootNode, theme2, 0, floorY + 220, roomD / 2 - 1.2, 0, "north");
      this.buildWindow(scene, BABYLON, rootNode, theme2, 0, floorY + 220, -roomD / 2 + 1.2, Math.PI, "south");
      this.buildDoor(scene, BABYLON, rootNode, theme2, -roomW / 2 + 1.2, floorY, 0, Math.PI / 2);
      const ceiling = BABYLON.MeshBuilder.CreatePlane("room3DCeiling", { width: roomW, height: roomD, sideOrientation: doubleSide }, scene);
      ceiling.rotation.x = Math.PI / 2;
      ceiling.position.set(0, ceilingY, 0);
      ceiling.parent = rootNode;
      ceiling.isPickable = false;
      ceiling.checkCollisions = true;
      const ceilingMat = new BABYLON.PBRMaterial(`matRoomCeiling_${theme2.id}`, scene);
      ceilingMat.albedoColor = new BABYLON.Color3(0.08, 0.06, 0.05);
      ceilingMat.roughness = 0.8;
      ceilingMat.backFaceCulling = false;
      ceiling.material = ceilingMat;
      if (theme2.ceilingStyle === "beams" || theme2.ceilingStyle === "trusses") {
        const beamMat = new BABYLON.PBRMaterial(`matBeams_${theme2.id}`, scene);
        beamMat.albedoColor = new BABYLON.Color3(0.15, 0.09, 0.05);
        beamMat.roughness = 0.5;
        for (let z = -roomD / 2 + 60; z <= roomD / 2 - 60; z += 100) {
          const beam = BABYLON.MeshBuilder.CreateBox(`ceilingBeam_${z}`, { width: roomW, height: 6, depth: 10 }, scene);
          beam.position.set(0, ceilingY - 3, z);
          beam.parent = rootNode;
          beam.isPickable = false;
          beam.material = beamMat;
        }
      }
    }
    /**
     * Minimalist fallback floor for 'none' theme.
     */
    static buildMinimalFloor(scene, BABYLON, rootNode, dims) {
      const floor = BABYLON.MeshBuilder.CreateGround("room3DFloorMin", { width: dims.roomW, height: dims.roomD }, scene);
      floor.position.set(0, dims.floorY, 0);
      floor.parent = rootNode;
      floor.receiveShadows = true;
      floor.checkCollisions = true;
      const floorMat = new BABYLON.PBRMaterial("matRoomFloorMin", scene);
      floorMat.albedoColor = new BABYLON.Color3(0.1, 0.11, 0.14);
      floorMat.roughness = 0.6;
      floor.material = floorMat;
      const doubleSide = BABYLON.Mesh && BABYLON.Mesh.DOUBLESIDE != null ? BABYLON.Mesh.DOUBLESIDE : 2;
      const { roomW, roomD, floorY, roomH, ceilingY } = dims;
      const createBarrier = (name, width, height, posX, posY, posZ, rotY = 0, rotX = 0) => {
        const barrier = BABYLON.MeshBuilder.CreatePlane(name, { width, height, sideOrientation: doubleSide }, scene);
        barrier.position.set(posX, posY, posZ);
        if (rotY) barrier.rotation.y = rotY;
        if (rotX) barrier.rotation.x = rotX;
        barrier.parent = rootNode;
        barrier.isVisible = false;
        barrier.isPickable = false;
        barrier.checkCollisions = true;
        return barrier;
      };
      createBarrier("boundaryNorth", roomW, roomH, 0, floorY + roomH / 2, roomD / 2, 0);
      createBarrier("boundarySouth", roomW, roomH, 0, floorY + roomH / 2, -roomD / 2, Math.PI);
      createBarrier("boundaryWest", roomD, roomH, -roomW / 2, floorY + roomH / 2, 0, Math.PI / 2);
      createBarrier("boundaryEast", roomD, roomH, roomW / 2, floorY + roomH / 2, 0, -Math.PI / 2);
      createBarrier("boundaryCeiling", roomW, roomD, 0, ceilingY, 0, 0, Math.PI / 2);
    }
    /**
     * Builds the realistic 3D Table including tabletop, apron, and 4 sturdy legs reaching the floor.
     */
    static buildTable(scene, BABYLON, rootNode, theme2, dims) {
      const { tableW, tableD, tableH, tableSurfaceY, floorY } = dims;
      const tableCenterY = tableSurfaceY - tableH / 2;
      const legHeight = Math.max(10, tableCenterY - tableH / 2 - floorY);
      const isRoundTheme = theme2.tableStyle === "artdeco" || theme2.tableStyle === "scandinavian";
      let tabletop;
      if (isRoundTheme) {
        const radius = Math.max(tableW, tableD) * 0.55;
        tabletop = BABYLON.MeshBuilder.CreateCylinder("board3DTableTop", {
          diameter: radius * 2,
          height: tableH,
          tessellation: 48
        }, scene);
      } else {
        tabletop = BABYLON.MeshBuilder.CreateBox("board3DTableTop", {
          width: tableW,
          height: tableH,
          depth: tableD
        }, scene);
      }
      tabletop.position.set(0, tableCenterY, 0);
      tabletop.parent = rootNode;
      tabletop.receiveShadows = true;
      tabletop.checkCollisions = true;
      const tableMat = new BABYLON.PBRMaterial(`matTablePBR_${theme2.id}`, scene);
      tableMat.roughness = theme2.tableFinish === "baize" ? 0.75 : 0.38;
      tableMat.metallic = theme2.tableFinish === "steel" ? 0.7 : 0.04;
      if (BABYLON.DynamicTexture) {
        const tableTex = new BABYLON.DynamicTexture(`texTablePBR_${theme2.id}`, { width: 1024, height: 1024 }, scene, true);
        const ctx = tableTex.getContext();
        this.drawTableTexture(ctx, theme2, tableW, tableD);
        tableTex.update();
        tableMat.albedoTexture = tableTex;
      } else {
        tableMat.albedoColor = new BABYLON.Color3(0.25, 0.16, 0.1);
      }
      tabletop.material = tableMat;
      const legMat = new BABYLON.PBRMaterial(`matTableLegs_${theme2.id}`, scene);
      if (theme2.tableFinish === "steel") {
        legMat.albedoColor = new BABYLON.Color3(0.2, 0.22, 0.25);
        legMat.metallic = 0.8;
        legMat.roughness = 0.3;
      } else if (theme2.tableStyle === "pedestal") {
        legMat.albedoColor = new BABYLON.Color3(0.18, 0.12, 0.08);
        legMat.roughness = 0.35;
      } else {
        legMat.albedoColor = new BABYLON.Color3(0.16, 0.1, 0.06);
        legMat.roughness = 0.45;
      }
      if (theme2.tableStyle === "pedestal") {
        const pedestal = BABYLON.MeshBuilder.CreateCylinder("tablePedestal", {
          diameterTop: 20,
          diameterBottom: 32,
          height: legHeight,
          tessellation: 32
        }, scene);
        pedestal.position.set(0, floorY + legHeight / 2, 0);
        pedestal.parent = rootNode;
        pedestal.material = legMat;
        const basePlate = BABYLON.MeshBuilder.CreateCylinder("tableBasePlate", {
          diameter: Math.min(tableW, tableD) * 0.55,
          height: 2.4,
          tessellation: 32
        }, scene);
        basePlate.position.set(0, floorY + 1.2, 0);
        basePlate.parent = rootNode;
        basePlate.material = legMat;
      } else {
        const legThick = theme2.tableStyle === "industrial" ? 7.2 : 6;
        const legX = tableW / 2 - legThick - 2;
        const legZ = tableD / 2 - legThick - 2;
        const legPositions = [
          [-legX, legZ],
          [legX, legZ],
          [-legX, -legZ],
          [legX, -legZ]
        ];
        legPositions.forEach(([lx, lz], idx) => {
          const leg = BABYLON.MeshBuilder.CreateBox(`tableLeg_${idx}`, {
            width: legThick,
            height: legHeight,
            depth: legThick
          }, scene);
          leg.position.set(lx, floorY + legHeight / 2, lz);
          leg.parent = rootNode;
          leg.material = legMat;
          leg.receiveShadows = true;
        });
        const apronH = 4;
        const apronFront = BABYLON.MeshBuilder.CreateBox("tableApronFront", {
          width: tableW - 8,
          height: apronH,
          depth: 2
        }, scene);
        apronFront.position.set(0, tableCenterY - tableH / 2 - apronH / 2, legZ);
        apronFront.parent = rootNode;
        apronFront.material = legMat;
        const apronBack = apronFront.clone("tableApronBack");
        apronBack.position.z = -legZ;
        apronBack.parent = rootNode;
      }
      return tabletop;
    }
    /**
     * Builds 3D Chairs arranged radially around the table, facing inward.
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {BABYLON.TransformNode} rootNode
     * @param {Object} theme
     * @param {Object} dims
     * @param {number} count - Player seat count (2 to 8)
     * @returns {Array<BABYLON.Mesh>}
     */
    static buildChairs(scene, BABYLON, rootNode, theme2, dims, count = 2) {
      const { tableW, tableD, floorY } = dims;
      const chairs = [];
      const seatMat = new BABYLON.PBRMaterial(`matChairSeat_${theme2.id}`, scene);
      const frameMat = new BABYLON.PBRMaterial(`matChairFrame_${theme2.id}`, scene);
      if (theme2.chairStyle === "swivel" || theme2.chairStyle === "bucket") {
        seatMat.albedoColor = new BABYLON.Color3(0.12, 0.12, 0.14);
        seatMat.roughness = 0.35;
        frameMat.albedoColor = new BABYLON.Color3(0.85, 0.72, 0.35);
        frameMat.metallic = 0.9;
        frameMat.roughness = 0.25;
      } else if (theme2.chairStyle === "velvet") {
        seatMat.albedoColor = new BABYLON.Color3(0.08, 0.32, 0.22);
        seatMat.roughness = 0.75;
        frameMat.albedoColor = new BABYLON.Color3(0.82, 0.7, 0.3);
        frameMat.metallic = 0.92;
        frameMat.roughness = 0.2;
      } else {
        seatMat.albedoColor = new BABYLON.Color3(0.24, 0.15, 0.09);
        seatMat.roughness = 0.45;
        frameMat.albedoColor = new BABYLON.Color3(0.18, 0.11, 0.07);
        frameMat.roughness = 0.5;
      }
      const seatW = dims.seatW ?? 96;
      const seatD = dims.seatD ?? 80;
      const seatH = dims.seatH ?? 12;
      const seatElev = dims.seatElev ?? 72;
      const chairCenterY = floorY + seatElev;
      const backH = dims.backH ?? 58;
      const backD = 10;
      const radiusX = tableW / 2 + seatD / 2 - 12;
      const radiusZ = tableD / 2 + seatD / 2 - 12;
      const angles = [];
      if (count === 2) {
        angles.push(0, Math.PI);
      } else if (count === 3) {
        angles.push(0, 4 * Math.PI / 3, 2 * Math.PI / 3);
      } else if (count === 4) {
        angles.push(0, 3 * Math.PI / 2, Math.PI, Math.PI / 2);
      } else {
        for (let i = 0; i < count; i++) {
          angles.push((2 * Math.PI - i * 2 * Math.PI / count) % (2 * Math.PI));
        }
      }
      angles.forEach((angle, idx) => {
        const chairRoot = new BABYLON.TransformNode(`chair_${idx}`, scene);
        chairRoot.parent = rootNode;
        const posX = Math.sin(angle) * radiusX;
        const posZ = -Math.cos(angle) * radiusZ;
        chairRoot.position.set(posX, 0, posZ);
        chairRoot.rotation.y = angle;
        const cushion = BABYLON.MeshBuilder.CreateBox(`chairSeat_${idx}`, {
          width: seatW,
          height: seatH,
          depth: seatD
        }, scene);
        cushion.position.set(0, chairCenterY, 0);
        cushion.parent = chairRoot;
        cushion.material = seatMat;
        cushion.receiveShadows = true;
        chairs.push(cushion);
        const backrest = BABYLON.MeshBuilder.CreateBox(`chairBack_${idx}`, {
          width: seatW,
          height: backH,
          depth: backD
        }, scene);
        backrest.position.set(0, chairCenterY + backH / 2 + seatH / 2, -seatD / 2 + backD / 2);
        backrest.parent = chairRoot;
        backrest.material = seatMat;
        backrest.receiveShadows = true;
        const armW = 8;
        const armH = 18;
        const armD = seatD * 0.82;
        const armY = chairCenterY + seatH / 2 + armH / 2;
        const armXOffset = seatW / 2 - armW / 2;
        [-armXOffset, armXOffset].forEach((ax, aIdx) => {
          const arm = BABYLON.MeshBuilder.CreateBox(`chairArm_${idx}_${aIdx}`, {
            width: armW,
            height: armH,
            depth: armD
          }, scene);
          arm.position.set(ax, armY, 0);
          arm.parent = chairRoot;
          arm.material = seatMat;
          arm.receiveShadows = true;
        });
        const legThick = 8;
        const legH = seatElev - seatH / 2;
        const cLegX = seatW / 2 - legThick - 1.5;
        const cLegZ = seatD / 2 - legThick - 1.5;
        const legCoords = [
          [-cLegX, cLegZ],
          [cLegX, cLegZ],
          [-cLegX, -cLegZ],
          [cLegX, -cLegZ]
        ];
        legCoords.forEach(([lx, lz], lIdx) => {
          const cLeg = BABYLON.MeshBuilder.CreateBox(`chairLeg_${idx}_${lIdx}`, {
            width: legThick,
            height: legH,
            depth: legThick
          }, scene);
          cLeg.position.set(lx, floorY + legH / 2, lz);
          cLeg.parent = chairRoot;
          cLeg.material = frameMat;
        });
      });
      return chairs;
    }
    /**
     * Builds realistic overhead pendant/chandelier lighting and warm ambient fills.
     */
    static buildLighting(scene, BABYLON, rootNode, theme2, dims, bounds = {}) {
      const { tableSurfaceY, ceilingY, roomH } = dims;
      const lights = [];
      const boardHeight = bounds && bounds.size && bounds.size.y ? bounds.size.y : 15;
      const fixtureY = Math.max(tableSurfaceY + 75, tableSurfaceY + boardHeight + 35);
      const cordH = Math.max(10, ceilingY - fixtureY);
      const cord = BABYLON.MeshBuilder.CreateCylinder("lightCord", {
        diameter: 0.8,
        height: cordH,
        tessellation: 12
      }, scene);
      cord.position.set(0, ceilingY - cordH / 2, 0);
      cord.parent = rootNode;
      const shade = BABYLON.MeshBuilder.CreateCylinder("lightShade", {
        diameterTop: 6,
        diameterBottom: 22,
        height: 9,
        tessellation: 24
      }, scene);
      shade.position.set(0, fixtureY, 0);
      shade.parent = rootNode;
      const fixtureMat = new BABYLON.PBRMaterial("matFixture", scene);
      fixtureMat.albedoColor = new BABYLON.Color3(0.22, 0.18, 0.12);
      fixtureMat.metallic = 0.85;
      fixtureMat.roughness = 0.3;
      cord.material = fixtureMat;
      shade.material = fixtureMat;
      const bulb = BABYLON.MeshBuilder.CreateSphere("lightBulb", { diameter: 4.5 }, scene);
      bulb.position.set(0, fixtureY - 2.5, 0);
      bulb.parent = rootNode;
      const bulbMat = new BABYLON.PBRMaterial("matBulb", scene);
      bulbMat.emissiveColor = new BABYLON.Color3(theme2.lightColor.r, theme2.lightColor.g, theme2.lightColor.b);
      bulbMat.emissiveIntensity = 2;
      bulb.material = bulbMat;
      const spot = new BABYLON.SpotLight(
        "roomTableSpot",
        new BABYLON.Vector3(0, fixtureY - 3, 0),
        new BABYLON.Vector3(0, -1, 0),
        Math.PI / 2.2,
        // Angle
        2,
        // Exponent / falloff
        scene
      );
      spot.diffuse = new BABYLON.Color3(theme2.lightColor.r, theme2.lightColor.g, theme2.lightColor.b);
      spot.intensity = theme2.lightIntensity * 2.8;
      spot.range = Math.max(600, roomH);
      spot.parent = rootNode;
      lights.push(spot);
      const fillPoint = new BABYLON.PointLight(
        "roomAmbientFill",
        new BABYLON.Vector3(0, tableSurfaceY + 28, 0),
        scene
      );
      fillPoint.diffuse = new BABYLON.Color3(theme2.ambientColor.r, theme2.ambientColor.g, theme2.ambientColor.b);
      fillPoint.intensity = theme2.lightIntensity * 0.9;
      fillPoint.range = Math.max(850, roomH * 1.5);
      fillPoint.parent = rootNode;
      lights.push(fillPoint);
      return lights;
    }
    /**
     * Procedural texture generator for room flooring.
     */
    static drawFloorTexture(ctx, theme2) {
      if (theme2.id === "vegas") {
        for (let x = 0; x < 1024; x += 128) {
          for (let y = 0; y < 1024; y += 128) {
            const isEven = (Math.floor(x / 128) + Math.floor(y / 128)) % 2 === 0;
            ctx.fillStyle = isEven ? "#0a1610" : "#14221a";
            ctx.fillRect(x, y, 128, 128);
            ctx.strokeStyle = "#22382c";
            ctx.lineWidth = 2;
            ctx.strokeRect(x, y, 128, 128);
          }
        }
      } else if (theme2.id === "velvet") {
        ctx.fillStyle = "#1e140c";
        ctx.fillRect(0, 0, 1024, 1024);
        for (let y = 0; y < 1024; y += 64) {
          ctx.strokeStyle = "#2d1f14";
          ctx.lineWidth = 3;
          ctx.beginPath();
          for (let x = 0; x <= 1024; x += 128) {
            ctx.lineTo(x, y);
            ctx.lineTo(x + 64, y + 32);
          }
          ctx.stroke();
        }
      } else if (theme2.id === "thunderdome") {
        ctx.fillStyle = "#181c22";
        ctx.fillRect(0, 0, 1024, 1024);
        ctx.strokeStyle = "#2c333d";
        ctx.lineWidth = 3;
        for (let x = 0; x < 1024; x += 32) {
          for (let y = 0; y < 1024; y += 32) {
            ctx.beginPath();
            ctx.moveTo(x + 4, y + 4);
            ctx.lineTo(x + 16, y + 16);
            ctx.stroke();
          }
        }
      } else {
        const baseCol = theme2.id === "studio" ? "#3e3830" : theme2.id === "cabin" ? "#2e1c0f" : "#22150c";
        const stripeCol = theme2.id === "studio" ? "#363028" : theme2.id === "cabin" ? "#24150a" : "#1c1008";
        ctx.fillStyle = baseCol;
        ctx.fillRect(0, 0, 1024, 1024);
        for (let y = 0; y < 1024; y += 128) {
          ctx.fillStyle = Math.floor(y / 128) % 2 === 0 ? baseCol : stripeCol;
          ctx.fillRect(0, y, 1024, 126);
          ctx.fillStyle = "#0f0804";
          ctx.fillRect(0, y + 126, 1024, 2);
          ctx.strokeStyle = "rgba(255, 255, 255, 0.035)";
          ctx.lineWidth = 1;
          for (let i = 0; i < 4; i++) {
            ctx.beginPath();
            ctx.moveTo(0, y + 20 + i * 26);
            ctx.bezierCurveTo(340, y + 25 + i * 26, 680, y + 15 + i * 26, 1024, y + 22 + i * 26);
            ctx.stroke();
          }
        }
      }
    }
    /**
     * Procedural texture generator for room walls.
     */
    static drawWallTexture(ctx, theme2) {
      ctx.fillStyle = theme2.wallColor || "#22150c";
      ctx.fillRect(0, 0, 1024, 512);
      if (theme2.id === "pub" || theme2.hasFireplace) {
        ctx.fillStyle = "#1c0f08";
        ctx.fillRect(0, 256, 1024, 256);
        ctx.strokeStyle = "#2d1a0e";
        ctx.lineWidth = 4;
        for (let x = 0; x < 1024; x += 128) {
          ctx.strokeRect(x + 10, 266, 108, 236);
        }
        ctx.fillStyle = "#421a10";
        ctx.fillRect(0, 0, 1024, 256);
        ctx.strokeStyle = "#2b1008";
        ctx.lineWidth = 2;
        for (let y = 0; y < 256; y += 24) {
          ctx.beginPath();
          ctx.moveTo(0, y);
          ctx.lineTo(1024, y);
          ctx.stroke();
          const offset = Math.floor(y / 24) % 2 * 32;
          for (let x = offset; x < 1024; x += 64) {
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x, y + 24);
            ctx.stroke();
          }
        }
      } else if (theme2.id === "vegas") {
        ctx.fillStyle = "#0e141a";
        ctx.fillRect(0, 0, 1024, 512);
        ctx.strokeStyle = "#c9a44b";
        ctx.lineWidth = 2;
        for (let x = 64; x < 1024; x += 128) {
          ctx.strokeRect(x, 40, 96, 432);
        }
      } else if (theme2.id === "velvet") {
        ctx.fillStyle = "#0f241a";
        ctx.fillRect(0, 0, 1024, 512);
        ctx.strokeStyle = "#183829";
        ctx.lineWidth = 2;
        for (let x = 0; x < 1024; x += 64) {
          for (let y = 0; y < 512; y += 64) {
            ctx.beginPath();
            ctx.moveTo(x + 32, y);
            ctx.lineTo(x + 64, y + 32);
            ctx.lineTo(x + 32, y + 64);
            ctx.lineTo(x, y + 32);
            ctx.closePath();
            ctx.stroke();
          }
        }
      } else if (theme2.id === "thunderdome") {
        ctx.fillStyle = "#16191f";
        ctx.fillRect(0, 0, 1024, 512);
        ctx.strokeStyle = "#252b34";
        ctx.lineWidth = 3;
        for (let x = 0; x < 1024; x += 256) {
          ctx.strokeRect(x + 6, 6, 244, 500);
        }
      } else {
        ctx.fillStyle = "#2c2e33";
        ctx.fillRect(0, 0, 1024, 512);
        ctx.fillStyle = "#6e563b";
        for (let x = 0; x < 1024; x += 24) {
          ctx.fillRect(x, 0, 14, 512);
        }
      }
    }
    /**
     * Procedural texture generator for table surface.
     */
    static drawTableTexture(ctx, theme2, tableW, tableD) {
      if (theme2.tableFinish === "baize") {
        ctx.fillStyle = "#083818";
        ctx.fillRect(0, 0, 1024, 1024);
        ctx.fillStyle = "#0e0e12";
        ctx.fillRect(0, 0, 1024, 64);
        ctx.fillRect(0, 960, 1024, 64);
        ctx.fillRect(0, 0, 64, 1024);
        ctx.fillRect(960, 0, 64, 1024);
        ctx.strokeStyle = "#d4af37";
        ctx.lineWidth = 3;
        ctx.strokeRect(66, 66, 892, 892);
      } else if (theme2.tableFinish === "steel") {
        ctx.fillStyle = "#22262e";
        ctx.fillRect(0, 0, 1024, 1024);
        ctx.fillStyle = "#d97706";
        ctx.fillRect(0, 0, 1024, 48);
        ctx.fillRect(0, 976, 1024, 48);
        ctx.fillStyle = "#111827";
        for (let x = 0; x < 1024; x += 64) {
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x + 32, 48);
          ctx.lineTo(x + 16, 48);
          ctx.lineTo(x - 16, 0);
          ctx.fill();
          ctx.beginPath();
          ctx.moveTo(x, 976);
          ctx.lineTo(x + 32, 1024);
          ctx.lineTo(x + 16, 1024);
          ctx.lineTo(x - 16, 976);
          ctx.fill();
        }
      } else {
        const woodBase = theme2.tableFinish === "ash" ? "#443c32" : theme2.tableFinish === "walnut" ? "#26170d" : "#28170c";
        ctx.fillStyle = woodBase;
        ctx.fillRect(0, 0, 1024, 1024);
        for (let y = 0; y < 1024; y += 128) {
          ctx.fillStyle = Math.floor(y / 128) % 2 === 0 ? "rgba(0,0,0,0.12)" : "rgba(255,255,255,0.03)";
          ctx.fillRect(0, y, 1024, 126);
          ctx.fillStyle = "rgba(0,0,0,0.3)";
          ctx.fillRect(0, y + 126, 1024, 2);
        }
        if (theme2.hasCoasters) {
          ctx.fillStyle = "#f4ead4";
          ctx.beginPath();
          ctx.arc(180, 200, 70, 0, Math.PI * 2);
          ctx.fill();
          ctx.strokeStyle = "#b45309";
          ctx.lineWidth = 4;
          ctx.stroke();
          ctx.fillStyle = "#b45309";
          ctx.font = "bold 20px sans-serif";
          ctx.textAlign = "center";
          ctx.fillText("CRIBBAGE", 180, 195);
          ctx.fillText("ALE", 180, 218);
          ctx.fillStyle = "#f4ead4";
          ctx.beginPath();
          ctx.arc(840, 820, 70, 0, Math.PI * 2);
          ctx.fill();
          ctx.stroke();
          ctx.fillText("PINTS", 840, 815);
          ctx.fillText("& PEGS", 840, 838);
        }
      }
    }
    /**
     * Builds an architectural window featuring molded frame casing, sill, muntin grid,
     * glass pane, and scenic dynamic backdrop view.
     */
    static buildWindow(scene, BABYLON, rootNode, theme2, posX, posY, posZ, rotY = 0, nameSuffix = "0") {
      const winW = 160;
      const winH = 200;
      const frameDepth = 4.8;
      const winRoot = new BABYLON.TransformNode(`windowRoot_${nameSuffix}`, scene);
      winRoot.position.set(posX, posY, posZ);
      winRoot.rotation.y = rotY;
      winRoot.parent = rootNode;
      const frameMat = new BABYLON.PBRMaterial(`matWinFrame_${nameSuffix}_${theme2.id}`, scene);
      frameMat.albedoColor = new BABYLON.Color3(0.18, 0.12, 0.08);
      frameMat.roughness = 0.4;
      frameMat.metallic = theme2.id === "vegas" ? 0.6 : 0.05;
      const casingThick = 6;
      const topCasing = BABYLON.MeshBuilder.CreateBox(`winTop_${nameSuffix}`, { width: winW + casingThick * 2, height: casingThick, depth: frameDepth }, scene);
      topCasing.position.set(0, winH / 2 + casingThick / 2, 0);
      topCasing.parent = winRoot;
      topCasing.material = frameMat;
      const sill = BABYLON.MeshBuilder.CreateBox(`winSill_${nameSuffix}`, { width: winW + casingThick * 2 + 8, height: casingThick + 2, depth: frameDepth + 4 }, scene);
      sill.position.set(0, -winH / 2 - (casingThick + 2) / 2, 1.8);
      sill.parent = winRoot;
      sill.material = frameMat;
      const leftCasing = BABYLON.MeshBuilder.CreateBox(`winLeft_${nameSuffix}`, { width: casingThick, height: winH, depth: frameDepth }, scene);
      leftCasing.position.set(-winW / 2 - casingThick / 2, 0, 0);
      leftCasing.parent = winRoot;
      leftCasing.material = frameMat;
      const rightCasing = BABYLON.MeshBuilder.CreateBox(`winRight_${nameSuffix}`, { width: casingThick, height: winH, depth: frameDepth }, scene);
      rightCasing.position.set(winW / 2 + casingThick / 2, 0, 0);
      rightCasing.parent = winRoot;
      rightCasing.material = frameMat;
      const barThick = 3.6;
      const horizBar = BABYLON.MeshBuilder.CreateBox(`winMuntinH_${nameSuffix}`, { width: winW, height: barThick, depth: frameDepth * 0.7 }, scene);
      horizBar.position.set(0, 0, 0);
      horizBar.parent = winRoot;
      horizBar.material = frameMat;
      const vertBar = BABYLON.MeshBuilder.CreateBox(`winMuntinV_${nameSuffix}`, { width: barThick, height: winH, depth: frameDepth * 0.7 }, scene);
      vertBar.position.set(0, 0, 0);
      vertBar.parent = winRoot;
      vertBar.material = frameMat;
      const doubleSide = BABYLON.Mesh && BABYLON.Mesh.DOUBLESIDE != null ? BABYLON.Mesh.DOUBLESIDE : 2;
      const scenery = BABYLON.MeshBuilder.CreatePlane(`winScenery_${nameSuffix}`, { width: winW, height: winH, sideOrientation: doubleSide }, scene);
      scenery.position.set(0, 0, -0.6);
      scenery.parent = winRoot;
      const sceneryMat = new BABYLON.PBRMaterial(`matWinScenery_${nameSuffix}_${theme2.id}`, scene);
      sceneryMat.roughness = 0.2;
      sceneryMat.backFaceCulling = false;
      if (BABYLON.DynamicTexture) {
        const sceneTex = new BABYLON.DynamicTexture(`texWinScenery_${nameSuffix}_${theme2.id}`, { width: 512, height: 512 }, scene, true);
        const sCtx = sceneTex.getContext();
        this.drawWindowScenery(sCtx, theme2);
        sceneTex.update();
        sceneryMat.albedoTexture = sceneTex;
        sceneryMat.emissiveTexture = sceneTex;
        sceneryMat.emissiveColor = new BABYLON.Color3(0.65, 0.65, 0.65);
      } else {
        sceneryMat.emissiveColor = new BABYLON.Color3(0.12, 0.18, 0.32);
      }
      scenery.material = sceneryMat;
      const glass = BABYLON.MeshBuilder.CreatePlane(`winGlass_${nameSuffix}`, { width: winW, height: winH, sideOrientation: doubleSide }, scene);
      glass.position.set(0, 0, 0.4);
      glass.parent = winRoot;
      const glassMat = new BABYLON.PBRMaterial(`matWinGlass_${nameSuffix}`, scene);
      glassMat.alpha = 0.35;
      glassMat.roughness = 0.08;
      glassMat.metallic = 0.2;
      glassMat.backFaceCulling = false;
      glassMat.albedoColor = new BABYLON.Color3(0.85, 0.92, 0.98);
      glass.material = glassMat;
      return winRoot;
    }
    /**
     * Builds an architectural entrance door with casing architrave, molded panels,
     * threshold, and polished brass handle.
     */
    static buildDoor(scene, BABYLON, rootNode, theme2, posX, floorY, posZ, rotY = 0) {
      const doorW = 120;
      const doorH = 340;
      const frameDepth = 5;
      const casingThick = 6.5;
      const doorRoot = new BABYLON.TransformNode("doorRoot_0", scene);
      doorRoot.position.set(posX, floorY, posZ);
      doorRoot.rotation.y = rotY;
      doorRoot.parent = rootNode;
      const casingMat = new BABYLON.PBRMaterial(`matDoorCasing_${theme2.id}`, scene);
      casingMat.albedoColor = new BABYLON.Color3(0.14, 0.09, 0.06);
      casingMat.roughness = 0.4;
      const leafMat = new BABYLON.PBRMaterial(`matDoorLeaf_${theme2.id}`, scene);
      leafMat.albedoColor = theme2.id === "vegas" ? new BABYLON.Color3(0.1, 0.1, 0.12) : new BABYLON.Color3(0.22, 0.14, 0.08);
      leafMat.roughness = 0.35;
      leafMat.metallic = theme2.id === "thunderdome" ? 0.7 : 0.04;
      const topCasing = BABYLON.MeshBuilder.CreateBox("doorTopCasing", { width: doorW + casingThick * 2, height: casingThick, depth: frameDepth }, scene);
      topCasing.position.set(0, doorH + casingThick / 2, 0);
      topCasing.parent = doorRoot;
      topCasing.material = casingMat;
      const leftCasing = BABYLON.MeshBuilder.CreateBox("doorLeftCasing", { width: casingThick, height: doorH, depth: frameDepth }, scene);
      leftCasing.position.set(-doorW / 2 - casingThick / 2, doorH / 2, 0);
      leftCasing.parent = doorRoot;
      leftCasing.material = casingMat;
      const rightCasing = BABYLON.MeshBuilder.CreateBox("doorRightCasing", { width: casingThick, height: doorH, depth: frameDepth }, scene);
      rightCasing.position.set(doorW / 2 + casingThick / 2, doorH / 2, 0);
      rightCasing.parent = doorRoot;
      rightCasing.material = casingMat;
      const threshold = BABYLON.MeshBuilder.CreateBox("doorThreshold", { width: doorW + casingThick * 2, height: 2.2, depth: frameDepth + 2.4 }, scene);
      threshold.position.set(0, 1.1, 1.2);
      threshold.parent = doorRoot;
      threshold.material = casingMat;
      const leaf = BABYLON.MeshBuilder.CreateBox("doorLeaf", { width: doorW, height: doorH, depth: 3.6 }, scene);
      leaf.position.set(0, doorH / 2, 0);
      leaf.parent = doorRoot;
      leaf.material = leafMat;
      leaf.receiveShadows = true;
      const panelMat = new BABYLON.PBRMaterial(`matDoorPanel_${theme2.id}`, scene);
      panelMat.albedoColor = theme2.id === "vegas" ? new BABYLON.Color3(0.06, 0.06, 0.08) : new BABYLON.Color3(0.16, 0.1, 0.06);
      panelMat.roughness = 0.5;
      const upperPanel = BABYLON.MeshBuilder.CreateBox("doorPanelUpper", { width: doorW * 0.72, height: doorH * 0.4, depth: 1 }, scene);
      upperPanel.position.set(0, doorH * 0.7, 2);
      upperPanel.parent = doorRoot;
      upperPanel.material = panelMat;
      const lowerPanel = BABYLON.MeshBuilder.CreateBox("doorPanelLower", { width: doorW * 0.72, height: doorH * 0.32, depth: 1 }, scene);
      lowerPanel.position.set(0, doorH * 0.28, 2);
      lowerPanel.parent = doorRoot;
      lowerPanel.material = panelMat;
      const handleMat = new BABYLON.PBRMaterial("matDoorHandle", scene);
      handleMat.albedoColor = new BABYLON.Color3(0.88, 0.74, 0.35);
      handleMat.metallic = 0.95;
      handleMat.roughness = 0.18;
      const knobEscutcheon = BABYLON.MeshBuilder.CreateCylinder("doorEscutcheon", { diameter: 7.2, height: 0.8, tessellation: 20 }, scene);
      knobEscutcheon.rotation.x = Math.PI / 2;
      knobEscutcheon.position.set(doorW / 2 - 14, doorH * 0.48, 2);
      knobEscutcheon.parent = doorRoot;
      knobEscutcheon.material = handleMat;
      const knob = BABYLON.MeshBuilder.CreateSphere("doorKnob", { diameter: 5.6 }, scene);
      knob.position.set(doorW / 2 - 14, doorH * 0.48, 4.8);
      knob.parent = doorRoot;
      knob.material = handleMat;
      return doorRoot;
    }
    /**
     * Procedural texture generator for scenic outdoor view behind window panes.
     */
    static drawWindowScenery(ctx, theme2) {
      if (!ctx) return;
      const w = 512;
      const h = 512;
      if (theme2.id === "vegas") {
        const skyGrad = ctx.createLinearGradient(0, 0, 0, h);
        skyGrad.addColorStop(0, "#100624");
        skyGrad.addColorStop(0.65, "#2e0f48");
        skyGrad.addColorStop(1, "#66164d");
        ctx.fillStyle = skyGrad;
        ctx.fillRect(0, 0, w, h);
        ctx.fillStyle = "#ffffff";
        for (let i = 0; i < 40; i++) {
          const sx = i * 97 % w;
          const sy = i * 61 % (h * 0.5);
          ctx.fillRect(sx, sy, 2, 2);
        }
        const bldgs = [
          [30, 260, 60, 252, "#0c051a", "#ff007f"],
          [100, 200, 75, 312, "#150826", "#00f0ff"],
          [185, 230, 80, 282, "#0c051a", "#ffd700"],
          [275, 170, 90, 342, "#180a2c", "#ff00aa"],
          [375, 220, 65, 292, "#0c051a", "#00ff88"],
          [450, 250, 55, 262, "#140722", "#ff5500"]
        ];
        bldgs.forEach(([bx, by, bw, bh, col, neon]) => {
          ctx.fillStyle = col;
          ctx.fillRect(bx, by, bw, bh);
          ctx.fillStyle = neon;
          ctx.fillRect(bx + 4, by, bw - 8, 3);
          for (let wy = by + 12; wy < by + bh - 10; wy += 14) {
            for (let wx = bx + 8; wx < bx + bw - 8; wx += 12) {
              ctx.fillStyle = Math.sin(wx * wy) > 0.1 ? neon : "rgba(255, 255, 200, 0.4)";
              ctx.fillRect(wx, wy, 4, 6);
            }
          }
        });
      } else if (theme2.id === "cabin") {
        const skyGrad = ctx.createLinearGradient(0, 0, 0, h);
        skyGrad.addColorStop(0, "#040b18");
        skyGrad.addColorStop(0.7, "#0b1d38");
        skyGrad.addColorStop(1, "#1e3355");
        ctx.fillStyle = skyGrad;
        ctx.fillRect(0, 0, w, h);
        ctx.fillStyle = "#fffae0";
        ctx.beginPath();
        ctx.arc(380, 90, 32, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = "#040b18";
        ctx.beginPath();
        ctx.arc(370, 85, 28, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = "#101c2e";
        ctx.beginPath();
        ctx.moveTo(0, 340);
        ctx.lineTo(140, 240);
        ctx.lineTo(260, 310);
        ctx.lineTo(390, 220);
        ctx.lineTo(512, 330);
        ctx.lineTo(512, 512);
        ctx.lineTo(0, 512);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = "#c8daf0";
        ctx.beginPath();
        ctx.moveTo(140, 240);
        ctx.lineTo(120, 270);
        ctx.lineTo(160, 270);
        ctx.closePath();
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(390, 220);
        ctx.lineTo(365, 260);
        ctx.lineTo(415, 260);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = "#050a12";
        for (let px = 10; px < w; px += 45) {
          const py = 330 + px % 40;
          ctx.beginPath();
          ctx.moveTo(px, py);
          ctx.lineTo(px - 22, py + 160);
          ctx.lineTo(px + 22, py + 160);
          ctx.closePath();
          ctx.fill();
        }
      } else if (theme2.id === "pub") {
        const skyGrad = ctx.createLinearGradient(0, 0, 0, h);
        skyGrad.addColorStop(0, "#0c121e");
        skyGrad.addColorStop(0.7, "#1b2432");
        skyGrad.addColorStop(1, "#2c3325");
        ctx.fillStyle = skyGrad;
        ctx.fillRect(0, 0, w, h);
        ctx.fillStyle = "#12161c";
        ctx.fillRect(20, 180, 150, 332);
        ctx.fillRect(180, 220, 170, 292);
        ctx.fillRect(360, 160, 140, 352);
        ctx.fillStyle = "#0a0d12";
        ctx.fillRect(60, 155, 24, 25);
        ctx.fillRect(410, 135, 24, 25);
        const lanternGlow = ctx.createRadialGradient(260, 380, 10, 260, 380, 130);
        lanternGlow.addColorStop(0, "rgba(255, 195, 77, 0.85)");
        lanternGlow.addColorStop(0.5, "rgba(255, 140, 0, 0.35)");
        lanternGlow.addColorStop(1, "rgba(0, 0, 0, 0)");
        ctx.fillStyle = lanternGlow;
        ctx.fillRect(130, 250, 260, 260);
        ctx.fillStyle = "#05070a";
        ctx.fillRect(256, 330, 8, 182);
        ctx.beginPath();
        ctx.arc(260, 330, 14, 0, Math.PI * 2);
        ctx.fill();
      } else {
        const skyGrad = ctx.createLinearGradient(0, 0, 0, h);
        skyGrad.addColorStop(0, "#0d1020");
        skyGrad.addColorStop(0.6, "#18243c");
        skyGrad.addColorStop(1, "#2b3b5c");
        ctx.fillStyle = skyGrad;
        ctx.fillRect(0, 0, w, h);
        ctx.fillStyle = "#090d18";
        for (let i = 0; i < 8; i++) {
          const bx = i * 65;
          const bw = 55;
          const bh = 180 + i * 47 % 150;
          ctx.fillRect(bx, h - bh, bw, bh);
          ctx.fillStyle = "rgba(255, 230, 150, 0.45)";
          for (let wy = h - bh + 15; wy < h - 20; wy += 20) {
            for (let wx = bx + 8; wx < bx + bw - 8; wx += 14) {
              ctx.fillRect(wx, wy, 5, 8);
            }
          }
          ctx.fillStyle = "#090d18";
        }
      }
    }
    /**
     * Dispatches theme-specific 3D decorative room and tabletop prop generation.
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {BABYLON.TransformNode} rootNode
     * @param {Object} theme
     * @param {Object} dims
     * @returns {Array<BABYLON.Mesh|BABYLON.TransformNode|BABYLON.Light>}
     */
    static buildProps(scene, BABYLON, rootNode, theme2, dims) {
      if (!scene || !BABYLON || !theme2 || theme2.id === "none") return [];
      switch (theme2.id) {
        case "pub":
          return this.buildPubProps(scene, BABYLON, rootNode, dims);
        case "vegas":
          return this.buildVegasProps(scene, BABYLON, rootNode, dims);
        case "cabin":
          return this.buildCabinProps(scene, BABYLON, rootNode, dims);
        case "velvet":
          return this.buildVelvetProps(scene, BABYLON, rootNode, dims);
        case "thunderdome":
          return this.buildThunderdomeProps(scene, BABYLON, rootNode, dims);
        case "studio":
          return this.buildStudioProps(scene, BABYLON, rootNode, dims);
        default:
          return [];
      }
    }
    /**
     * Builds Old English Pub thematic props: brick fireplace with glowing embers,
     * frosted pint tankards with foam heads on wooden coasters, and tavern wall sconces.
     */
    static buildPubProps(scene, BABYLON, rootNode, dims) {
      const props = [];
      const { tableW, tableD, tableSurfaceY, floorY, roomW, roomD } = dims;
      const fireplaceRoot = new BABYLON.TransformNode("pubFireplaceRoot", scene);
      fireplaceRoot.position.set(-roomW * 0.28, floorY, roomD / 2 - 14);
      fireplaceRoot.parent = rootNode;
      props.push(fireplaceRoot);
      const brickMat = new BABYLON.PBRMaterial("matPubFireplaceBrick", scene);
      brickMat.albedoColor = new BABYLON.Color3(0.36, 0.16, 0.1);
      brickMat.roughness = 0.85;
      const mantelMat = new BABYLON.PBRMaterial("matPubFireplaceMantel", scene);
      mantelMat.albedoColor = new BABYLON.Color3(0.18, 0.11, 0.06);
      mantelMat.roughness = 0.45;
      const hearth = BABYLON.MeshBuilder.CreateBox("pubFireHearth", { width: 70, height: 6, depth: 32 }, scene);
      hearth.position.set(0, 3, 0);
      hearth.parent = fireplaceRoot;
      hearth.material = brickMat;
      hearth.isPickable = false;
      props.push(hearth);
      [-24, 24].forEach((jx, idx) => {
        const col = BABYLON.MeshBuilder.CreateBox(`pubFireCol_${idx}`, { width: 14, height: 90, depth: 22 }, scene);
        col.position.set(jx, 48, 0);
        col.parent = fireplaceRoot;
        col.material = brickMat;
        col.isPickable = false;
        props.push(col);
      });
      const lintel = BABYLON.MeshBuilder.CreateBox("pubFireLintel", { width: 62, height: 16, depth: 22 }, scene);
      lintel.position.set(0, 85, 0);
      lintel.parent = fireplaceRoot;
      lintel.material = brickMat;
      lintel.isPickable = false;
      props.push(lintel);
      const mantel = BABYLON.MeshBuilder.CreateBox("pubFireMantel", { width: 84, height: 8, depth: 28 }, scene);
      mantel.position.set(0, 97, 2);
      mantel.parent = fireplaceRoot;
      mantel.material = mantelMat;
      mantel.isPickable = false;
      props.push(mantel);
      const fireboxMat = new BABYLON.PBRMaterial("matPubFirebox", scene);
      fireboxMat.albedoColor = new BABYLON.Color3(0.05, 0.04, 0.04);
      fireboxMat.roughness = 0.95;
      const firebox = BABYLON.MeshBuilder.CreateBox("pubFirebox", { width: 34, height: 64, depth: 16 }, scene);
      firebox.position.set(0, 35, -2);
      firebox.parent = fireplaceRoot;
      firebox.material = fireboxMat;
      firebox.isPickable = false;
      props.push(firebox);
      const fireMat = new BABYLON.PBRMaterial("matPubFireEmbers", scene);
      fireMat.emissiveColor = new BABYLON.Color3(1, 0.52, 0.12);
      fireMat.emissiveIntensity = 2.4;
      fireMat.backFaceCulling = false;
      const doubleSide = BABYLON.Mesh && BABYLON.Mesh.DOUBLESIDE != null ? BABYLON.Mesh.DOUBLESIDE : 2;
      const embers = BABYLON.MeshBuilder.CreatePlane("pubFireEmbers", { width: 26, height: 26, sideOrientation: doubleSide }, scene);
      embers.position.set(0, 18, 5);
      embers.parent = fireplaceRoot;
      embers.material = fireMat;
      embers.isPickable = false;
      props.push(embers);
      const fireLight = new BABYLON.PointLight("pubFireLight", new BABYLON.Vector3(0, 22, 10), scene);
      fireLight.diffuse = new BABYLON.Color3(1, 0.55, 0.15);
      fireLight.intensity = 1.35;
      fireLight.range = 190;
      fireLight.parent = fireplaceRoot;
      props.push(fireLight);
      const coasterMat = new BABYLON.PBRMaterial("matPubCoaster", scene);
      coasterMat.albedoColor = new BABYLON.Color3(0.72, 0.58, 0.42);
      coasterMat.roughness = 0.6;
      const tankardMat = new BABYLON.PBRMaterial("matPubGlassTankard", scene);
      tankardMat.albedoColor = new BABYLON.Color3(0.85, 0.55, 0.15);
      tankardMat.alpha = 0.82;
      tankardMat.roughness = 0.2;
      tankardMat.metallic = 0.1;
      const foamMat = new BABYLON.PBRMaterial("matPubFoamHead", scene);
      foamMat.albedoColor = new BABYLON.Color3(0.96, 0.94, 0.88);
      foamMat.roughness = 0.7;
      const mugCoords = [
        [-tableW * 0.38, -tableD * 0.35],
        [tableW * 0.38, tableD * 0.35]
      ];
      mugCoords.forEach(([mx, mz], idx) => {
        const mugRoot = new BABYLON.TransformNode(`pubMugRoot_${idx}`, scene);
        mugRoot.position.set(mx, tableSurfaceY, mz);
        mugRoot.parent = rootNode;
        props.push(mugRoot);
        const coaster = BABYLON.MeshBuilder.CreateCylinder(`pubCoaster_${idx}`, { diameter: 10, height: 0.6, tessellation: 24 }, scene);
        coaster.position.set(0, 0.3, 0);
        coaster.parent = mugRoot;
        coaster.material = coasterMat;
        coaster.isPickable = false;
        props.push(coaster);
        const body = BABYLON.MeshBuilder.CreateCylinder(`pubTankard_${idx}`, { diameterTop: 5.2, diameterBottom: 4.6, height: 10, tessellation: 20 }, scene);
        body.position.set(0, 5.6, 0);
        body.parent = mugRoot;
        body.material = tankardMat;
        body.isPickable = false;
        props.push(body);
        const foam = BABYLON.MeshBuilder.CreateCylinder(`pubFoam_${idx}`, { diameter: 5.3, height: 2.2, tessellation: 20 }, scene);
        foam.position.set(0, 10.6, 0);
        foam.parent = mugRoot;
        foam.material = foamMat;
        foam.isPickable = false;
        props.push(foam);
        const handle = BABYLON.MeshBuilder.CreateBox(`pubHandle_${idx}`, { width: 1.2, height: 5.8, depth: 3.2 }, scene);
        handle.position.set(3, 5.8, 0);
        handle.parent = mugRoot;
        handle.material = tankardMat;
        handle.isPickable = false;
        props.push(handle);
      });
      const sconceMat = new BABYLON.PBRMaterial("matPubSconce", scene);
      sconceMat.albedoColor = new BABYLON.Color3(0.24, 0.18, 0.12);
      sconceMat.metallic = 0.8;
      sconceMat.roughness = 0.3;
      const bulbMat = new BABYLON.PBRMaterial("matPubSconceBulb", scene);
      bulbMat.emissiveColor = new BABYLON.Color3(1, 0.78, 0.38);
      bulbMat.emissiveIntensity = 2;
      [-roomW / 2 + 3].forEach((sx, idx) => {
        const sconceRoot = new BABYLON.TransformNode(`pubSconceRoot_${idx}`, scene);
        sconceRoot.position.set(sx, floorY + 200, -roomD * 0.15);
        sconceRoot.parent = rootNode;
        props.push(sconceRoot);
        const bracket = BABYLON.MeshBuilder.CreateBox(`pubSconceBracket_${idx}`, { width: 2.4, height: 14, depth: 8 }, scene);
        bracket.parent = sconceRoot;
        bracket.material = sconceMat;
        bracket.isPickable = false;
        props.push(bracket);
        const shade = BABYLON.MeshBuilder.CreateCylinder(`pubSconceShade_${idx}`, { diameterTop: 6, diameterBottom: 4, height: 8, tessellation: 16 }, scene);
        shade.position.set(4, 5, 0);
        shade.parent = sconceRoot;
        shade.material = bulbMat;
        shade.isPickable = false;
        props.push(shade);
      });
      return props;
    }
    /**
     * Builds Vegas High Roller Suite thematic props: stacked clay casino chips,
     * crystal decanter & whiskey tumbler, and luxury gold crown moldings.
     */
    static buildVegasProps(scene, BABYLON, rootNode, dims) {
      const props = [];
      const { tableW, tableD, tableSurfaceY, floorY, roomW, roomD } = dims;
      const chipRoot = new BABYLON.TransformNode("vegasChipsRoot", scene);
      chipRoot.position.set(-tableW * 0.38, tableSurfaceY, -tableD * 0.34);
      chipRoot.parent = rootNode;
      props.push(chipRoot);
      const redChipMat = new BABYLON.PBRMaterial("matVegasRedChip", scene);
      redChipMat.albedoColor = new BABYLON.Color3(0.78, 0.1, 0.12);
      redChipMat.roughness = 0.35;
      const blueChipMat = new BABYLON.PBRMaterial("matVegasBlueChip", scene);
      blueChipMat.albedoColor = new BABYLON.Color3(0.12, 0.28, 0.75);
      blueChipMat.roughness = 0.35;
      const goldChipMat = new BABYLON.PBRMaterial("matVegasGoldChip", scene);
      goldChipMat.albedoColor = new BABYLON.Color3(0.92, 0.76, 0.22);
      goldChipMat.metallic = 0.75;
      goldChipMat.roughness = 0.25;
      const blackChipMat = new BABYLON.PBRMaterial("matVegasBlackChip", scene);
      blackChipMat.albedoColor = new BABYLON.Color3(0.12, 0.12, 0.14);
      blackChipMat.roughness = 0.4;
      const chipConfigs = [
        { name: "stackRed", mat: redChipMat, h: 7.2, x: 0, z: 0 },
        { name: "stackBlue", mat: blueChipMat, h: 9.6, x: 5.5, z: 1.5 },
        { name: "stackGold", mat: goldChipMat, h: 6, x: -3.5, z: 4.5 },
        { name: "stackBlack", mat: blackChipMat, h: 8.4, x: 2.5, z: 6 }
      ];
      chipConfigs.forEach((c) => {
        const stack = BABYLON.MeshBuilder.CreateCylinder(`vegas_${c.name}`, { diameter: 4.8, height: c.h, tessellation: 24 }, scene);
        stack.position.set(c.x, c.h / 2, c.z);
        stack.parent = chipRoot;
        stack.material = c.mat;
        stack.isPickable = false;
        props.push(stack);
      });
      const drinkRoot = new BABYLON.TransformNode("vegasDrinkRoot", scene);
      drinkRoot.position.set(tableW * 0.38, tableSurfaceY, tableD * 0.34);
      drinkRoot.parent = rootNode;
      props.push(drinkRoot);
      const crystalMat = new BABYLON.PBRMaterial("matVegasCrystal", scene);
      crystalMat.albedoColor = new BABYLON.Color3(0.92, 0.95, 1);
      crystalMat.alpha = 0.45;
      crystalMat.roughness = 0.08;
      crystalMat.metallic = 0.15;
      const whiskeyMat = new BABYLON.PBRMaterial("matVegasWhiskey", scene);
      whiskeyMat.albedoColor = new BABYLON.Color3(0.88, 0.52, 0.1);
      whiskeyMat.alpha = 0.85;
      whiskeyMat.roughness = 0.2;
      const decanter = BABYLON.MeshBuilder.CreateCylinder("vegasDecanterBody", { diameterTop: 4, diameterBottom: 7, height: 12, tessellation: 20 }, scene);
      decanter.position.set(0, 6, 0);
      decanter.parent = drinkRoot;
      decanter.material = crystalMat;
      decanter.isPickable = false;
      props.push(decanter);
      const liquor = BABYLON.MeshBuilder.CreateCylinder("vegasLiquor", { diameter: 5.8, height: 6, tessellation: 18 }, scene);
      liquor.position.set(0, 3.4, 0);
      liquor.parent = drinkRoot;
      liquor.material = whiskeyMat;
      liquor.isPickable = false;
      props.push(liquor);
      const stopper = BABYLON.MeshBuilder.CreateSphere("vegasStopper", { diameter: 4.2 }, scene);
      stopper.position.set(0, 13.5, 0);
      stopper.parent = drinkRoot;
      stopper.material = crystalMat;
      stopper.isPickable = false;
      props.push(stopper);
      const tumbler = BABYLON.MeshBuilder.CreateCylinder("vegasTumbler", { diameter: 4.6, height: 5.5, tessellation: 20 }, scene);
      tumbler.position.set(7.5, 2.75, 2);
      tumbler.parent = drinkRoot;
      tumbler.material = crystalMat;
      tumbler.isPickable = false;
      props.push(tumbler);
      const goldMat = new BABYLON.PBRMaterial("matVegasGoldTrim", scene);
      goldMat.albedoColor = new BABYLON.Color3(0.9, 0.76, 0.28);
      goldMat.metallic = 0.92;
      goldMat.roughness = 0.22;
      const goldTrim = BABYLON.MeshBuilder.CreateBox("vegasGoldTrimNorth", { width: roomW * 0.9, height: 2.2, depth: 1.8 }, scene);
      goldTrim.position.set(0, floorY + 340, roomD / 2 - 2);
      goldTrim.parent = rootNode;
      goldTrim.material = goldMat;
      goldTrim.isPickable = false;
      props.push(goldTrim);
      return props;
    }
    /**
     * Builds Mountain Lodge thematic props: stone hearth fireplace,
     * steaming stoneware coffee mugs on wood-slice coasters.
     */
    static buildCabinProps(scene, BABYLON, rootNode, dims) {
      const props = [];
      const { tableW, tableD, tableSurfaceY, floorY, roomW, roomD } = dims;
      const hearthRoot = new BABYLON.TransformNode("cabinHearthRoot", scene);
      hearthRoot.position.set(roomW * 0.28, floorY, roomD / 2 - 14);
      hearthRoot.parent = rootNode;
      props.push(hearthRoot);
      const stoneMat = new BABYLON.PBRMaterial("matCabinStone", scene);
      stoneMat.albedoColor = new BABYLON.Color3(0.32, 0.29, 0.26);
      stoneMat.roughness = 0.9;
      const pineMat = new BABYLON.PBRMaterial("matCabinPineLog", scene);
      pineMat.albedoColor = new BABYLON.Color3(0.24, 0.15, 0.08);
      pineMat.roughness = 0.65;
      const hearthBase = BABYLON.MeshBuilder.CreateBox("cabinHearthBase", { width: 76, height: 6, depth: 34 }, scene);
      hearthBase.position.set(0, 3, 0);
      hearthBase.parent = hearthRoot;
      hearthBase.material = stoneMat;
      hearthBase.isPickable = false;
      props.push(hearthBase);
      [-26, 26].forEach((px, idx) => {
        const p = BABYLON.MeshBuilder.CreateBox(`cabinStonePillar_${idx}`, { width: 16, height: 96, depth: 24 }, scene);
        p.position.set(px, 51, 0);
        p.parent = hearthRoot;
        p.material = stoneMat;
        p.isPickable = false;
        props.push(p);
      });
      const timberMantel = BABYLON.MeshBuilder.CreateBox("cabinTimberMantel", { width: 92, height: 12, depth: 30 }, scene);
      timberMantel.position.set(0, 103, 2);
      timberMantel.parent = hearthRoot;
      timberMantel.material = pineMat;
      timberMantel.isPickable = false;
      props.push(timberMantel);
      const fireMat = new BABYLON.PBRMaterial("matCabinFire", scene);
      fireMat.emissiveColor = new BABYLON.Color3(1, 0.58, 0.14);
      fireMat.emissiveIntensity = 2.5;
      fireMat.backFaceCulling = false;
      const doubleSide = BABYLON.Mesh && BABYLON.Mesh.DOUBLESIDE != null ? BABYLON.Mesh.DOUBLESIDE : 2;
      const embers = BABYLON.MeshBuilder.CreatePlane("cabinEmbers", { width: 30, height: 30, sideOrientation: doubleSide }, scene);
      embers.position.set(0, 20, 6);
      embers.parent = hearthRoot;
      embers.material = fireMat;
      embers.isPickable = false;
      props.push(embers);
      const fireLight = new BABYLON.PointLight("cabinFireLight", new BABYLON.Vector3(0, 26, 12), scene);
      fireLight.diffuse = new BABYLON.Color3(1, 0.6, 0.18);
      fireLight.intensity = 1.4;
      fireLight.range = 195;
      fireLight.parent = hearthRoot;
      props.push(fireLight);
      const mugMat = new BABYLON.PBRMaterial("matCabinMug", scene);
      mugMat.albedoColor = new BABYLON.Color3(0.28, 0.22, 0.18);
      mugMat.roughness = 0.55;
      const coffeeMat = new BABYLON.PBRMaterial("matCabinCoffee", scene);
      coffeeMat.albedoColor = new BABYLON.Color3(0.1, 0.06, 0.04);
      coffeeMat.roughness = 0.3;
      const birchMat = new BABYLON.PBRMaterial("matCabinBirchCoaster", scene);
      birchMat.albedoColor = new BABYLON.Color3(0.55, 0.42, 0.28);
      birchMat.roughness = 0.7;
      const mugCoords = [
        [-tableW * 0.38, tableD * 0.34],
        [tableW * 0.38, -tableD * 0.34]
      ];
      mugCoords.forEach(([mx, mz], idx) => {
        const mugRoot = new BABYLON.TransformNode(`cabinMugRoot_${idx}`, scene);
        mugRoot.position.set(mx, tableSurfaceY, mz);
        mugRoot.parent = rootNode;
        props.push(mugRoot);
        const coaster = BABYLON.MeshBuilder.CreateCylinder(`cabinCoaster_${idx}`, { diameter: 9.6, height: 0.7, tessellation: 20 }, scene);
        coaster.position.set(0, 0.35, 0);
        coaster.parent = mugRoot;
        coaster.material = birchMat;
        coaster.isPickable = false;
        props.push(coaster);
        const mug = BABYLON.MeshBuilder.CreateCylinder(`cabinMug_${idx}`, { diameter: 5.4, height: 7.5, tessellation: 20 }, scene);
        mug.position.set(0, 4.2, 0);
        mug.parent = mugRoot;
        mug.material = mugMat;
        mug.isPickable = false;
        props.push(mug);
        const coffee = BABYLON.MeshBuilder.CreateCylinder(`cabinCoffee_${idx}`, { diameter: 4.8, height: 0.5, tessellation: 18 }, scene);
        coffee.position.set(0, 7.5, 0);
        coffee.parent = mugRoot;
        coffee.material = coffeeMat;
        coffee.isPickable = false;
        props.push(coffee);
        const handle = BABYLON.MeshBuilder.CreateBox(`cabinHandle_${idx}`, { width: 1.2, height: 4.8, depth: 2.8 }, scene);
        handle.position.set(3, 4.4, 0);
        handle.parent = mugRoot;
        handle.material = mugMat;
        handle.isPickable = false;
        props.push(handle);
      });
      return props;
    }
    /**
     * Builds Velvet Speakeasy Lounge thematic props: art-deco cocktail glass,
     * emerald brass banker table lamp.
     */
    static buildVelvetProps(scene, BABYLON, rootNode, dims) {
      const props = [];
      const { tableW, tableD, tableSurfaceY } = dims;
      const cocktailRoot = new BABYLON.TransformNode("velvetCocktailRoot", scene);
      cocktailRoot.position.set(-tableW * 0.38, tableSurfaceY, -tableD * 0.34);
      cocktailRoot.parent = rootNode;
      props.push(cocktailRoot);
      const glassMat = new BABYLON.PBRMaterial("matVelvetGlass", scene);
      glassMat.albedoColor = new BABYLON.Color3(0.9, 0.95, 0.98);
      glassMat.alpha = 0.5;
      glassMat.roughness = 0.1;
      const oliveMat = new BABYLON.PBRMaterial("matVelvetOlive", scene);
      oliveMat.albedoColor = new BABYLON.Color3(0.35, 0.45, 0.15);
      oliveMat.roughness = 0.4;
      const gBase = BABYLON.MeshBuilder.CreateCylinder("velvetGlassBase", { diameter: 5, height: 0.4, tessellation: 20 }, scene);
      gBase.position.set(0, 0.2, 0);
      gBase.parent = cocktailRoot;
      gBase.material = glassMat;
      gBase.isPickable = false;
      props.push(gBase);
      const gStem = BABYLON.MeshBuilder.CreateCylinder("velvetGlassStem", { diameter: 0.7, height: 5.5, tessellation: 14 }, scene);
      gStem.position.set(0, 3.1, 0);
      gStem.parent = cocktailRoot;
      gStem.material = glassMat;
      gStem.isPickable = false;
      props.push(gStem);
      const gCup = BABYLON.MeshBuilder.CreateCylinder("velvetGlassCup", { diameterTop: 6.8, diameterBottom: 1.2, height: 4.2, tessellation: 20 }, scene);
      gCup.position.set(0, 7.8, 0);
      gCup.parent = cocktailRoot;
      gCup.material = glassMat;
      gCup.isPickable = false;
      props.push(gCup);
      const olive = BABYLON.MeshBuilder.CreateSphere("velvetOlive", { diameter: 2 }, scene);
      olive.position.set(0.6, 7.2, 0);
      olive.parent = cocktailRoot;
      olive.material = oliveMat;
      olive.isPickable = false;
      props.push(olive);
      const lampRoot = new BABYLON.TransformNode("velvetLampRoot", scene);
      lampRoot.position.set(tableW * 0.38, tableSurfaceY, tableD * 0.34);
      lampRoot.parent = rootNode;
      props.push(lampRoot);
      const brassMat = new BABYLON.PBRMaterial("matVelvetBrass", scene);
      brassMat.albedoColor = new BABYLON.Color3(0.88, 0.74, 0.28);
      brassMat.metallic = 0.95;
      brassMat.roughness = 0.2;
      const shadeMat = new BABYLON.PBRMaterial("matVelvetLampShade", scene);
      shadeMat.albedoColor = new BABYLON.Color3(0.08, 0.48, 0.28);
      shadeMat.emissiveColor = new BABYLON.Color3(0.05, 0.25, 0.14);
      shadeMat.emissiveIntensity = 1.2;
      shadeMat.roughness = 0.25;
      const lBase = BABYLON.MeshBuilder.CreateCylinder("velvetLampBase", { diameter: 7, height: 1.2, tessellation: 24 }, scene);
      lBase.position.set(0, 0.6, 0);
      lBase.parent = lampRoot;
      lBase.material = brassMat;
      lBase.isPickable = false;
      props.push(lBase);
      const lNeck = BABYLON.MeshBuilder.CreateCylinder("velvetLampNeck", { diameter: 1.2, height: 12, tessellation: 16 }, scene);
      lNeck.position.set(0, 6.8, 0);
      lNeck.parent = lampRoot;
      lNeck.material = brassMat;
      lNeck.isPickable = false;
      props.push(lNeck);
      const lShade = BABYLON.MeshBuilder.CreateBox("velvetLampShade", { width: 8.8, height: 4.2, depth: 5.6 }, scene);
      lShade.position.set(0, 13.5, 0);
      lShade.parent = lampRoot;
      lShade.material = shadeMat;
      lShade.isPickable = false;
      props.push(lShade);
      const lampLight = new BABYLON.PointLight("velvetLampLight", new BABYLON.Vector3(0, 12, 0), scene);
      lampLight.diffuse = new BABYLON.Color3(1, 0.88, 0.62);
      lampLight.intensity = 0.85;
      lampLight.range = 85;
      lampLight.parent = lampRoot;
      props.push(lampLight);
      return props;
    }
    /**
     * Builds Thunderdome / Industrial thematic props: exposed glowing neon strips along wall/ceiling corners,
     * heavy steel fuel canister on table corner, and ventilation exhaust duct.
     */
    static buildThunderdomeProps(scene, BABYLON, rootNode, dims) {
      const props = [];
      const { tableW, tableD, tableSurfaceY, ceilingY, roomW, roomD } = dims;
      const cyanNeonMat = new BABYLON.PBRMaterial("matThunderNeonCyan", scene);
      cyanNeonMat.emissiveColor = new BABYLON.Color3(0, 0.95, 1);
      cyanNeonMat.emissiveIntensity = 3;
      const orangeNeonMat = new BABYLON.PBRMaterial("matThunderNeonOrange", scene);
      orangeNeonMat.emissiveColor = new BABYLON.Color3(1, 0.45, 0);
      orangeNeonMat.emissiveIntensity = 3;
      const neonNorth = BABYLON.MeshBuilder.CreateCylinder("thunderNeonNorth", { diameter: 3.2, height: roomW * 0.85, tessellation: 16 }, scene);
      neonNorth.rotation.z = Math.PI / 2;
      neonNorth.position.set(0, ceilingY - 18, roomD / 2 - 10);
      neonNorth.parent = rootNode;
      neonNorth.material = cyanNeonMat;
      neonNorth.isPickable = false;
      props.push(neonNorth);
      const neonWest = BABYLON.MeshBuilder.CreateCylinder("thunderNeonWest", { diameter: 3.2, height: roomD * 0.85, tessellation: 16 }, scene);
      neonWest.rotation.x = Math.PI / 2;
      neonWest.position.set(-roomW / 2 + 10, ceilingY - 18, 0);
      neonWest.parent = rootNode;
      neonWest.material = orangeNeonMat;
      neonWest.isPickable = false;
      props.push(neonWest);
      const canisterRoot = new BABYLON.TransformNode("thunderCanisterRoot", scene);
      canisterRoot.position.set(tableW * 0.38, tableSurfaceY, -tableD * 0.34);
      canisterRoot.parent = rootNode;
      props.push(canisterRoot);
      const steelMat = new BABYLON.PBRMaterial("matThunderSteel", scene);
      steelMat.albedoColor = new BABYLON.Color3(0.25, 0.28, 0.32);
      steelMat.metallic = 0.95;
      steelMat.roughness = 0.25;
      const bronzeMat = new BABYLON.PBRMaterial("matThunderBronze", scene);
      bronzeMat.albedoColor = new BABYLON.Color3(0.72, 0.52, 0.24);
      bronzeMat.metallic = 0.85;
      bronzeMat.roughness = 0.3;
      const canBody = BABYLON.MeshBuilder.CreateCylinder("thunderCanBody", { diameter: 5.6, height: 9.5, tessellation: 20 }, scene);
      canBody.position.set(0, 4.75, 0);
      canBody.parent = canisterRoot;
      canBody.material = steelMat;
      canBody.isPickable = false;
      props.push(canBody);
      const canCap = BABYLON.MeshBuilder.CreateCylinder("thunderCanCap", { diameter: 2.4, height: 2.2, tessellation: 16 }, scene);
      canCap.position.set(0, 10.2, 0);
      canCap.parent = canisterRoot;
      canCap.material = bronzeMat;
      canCap.isPickable = false;
      props.push(canCap);
      const ventMat = new BABYLON.PBRMaterial("matThunderVent", scene);
      ventMat.albedoColor = new BABYLON.Color3(0.18, 0.2, 0.22);
      ventMat.metallic = 0.8;
      ventMat.roughness = 0.4;
      const vent = BABYLON.MeshBuilder.CreateBox("thunderVentGrate", { width: 36, height: 36, depth: 6 }, scene);
      vent.position.set(roomW * 0.28, ceilingY - 90, roomD / 2 - 3);
      vent.parent = rootNode;
      vent.material = ventMat;
      vent.isPickable = false;
      props.push(vent);
      return props;
    }
    /**
     * Builds Nordic Minimalist Studio thematic props: potted succulent plant,
     * modern stone coaster and ceramic cup, and diffuse daylight skylight fixture.
     */
    static buildStudioProps(scene, BABYLON, rootNode, dims) {
      const props = [];
      const { tableW, tableD, tableSurfaceY, ceilingY } = dims;
      const plantRoot = new BABYLON.TransformNode("studioPlantRoot", scene);
      plantRoot.position.set(tableW * 0.38, tableSurfaceY, tableD * 0.34);
      plantRoot.parent = rootNode;
      props.push(plantRoot);
      const potMat = new BABYLON.PBRMaterial("matStudioPot", scene);
      potMat.albedoColor = new BABYLON.Color3(0.92, 0.9, 0.86);
      potMat.roughness = 0.65;
      const soilMat = new BABYLON.PBRMaterial("matStudioSoil", scene);
      soilMat.albedoColor = new BABYLON.Color3(0.16, 0.12, 0.08);
      soilMat.roughness = 0.9;
      const leafMat = new BABYLON.PBRMaterial("matStudioSucculent", scene);
      leafMat.albedoColor = new BABYLON.Color3(0.35, 0.65, 0.42);
      leafMat.roughness = 0.45;
      const pot = BABYLON.MeshBuilder.CreateCylinder("studioPlanterPot", { diameter: 6.2, height: 6.5, tessellation: 24 }, scene);
      pot.position.set(0, 3.25, 0);
      pot.parent = plantRoot;
      pot.material = potMat;
      pot.isPickable = false;
      props.push(pot);
      const soil = BABYLON.MeshBuilder.CreateCylinder("studioSoil", { diameter: 5.6, height: 0.6, tessellation: 20 }, scene);
      soil.position.set(0, 6.2, 0);
      soil.parent = plantRoot;
      soil.material = soilMat;
      soil.isPickable = false;
      props.push(soil);
      const rosettePositions = [
        [0, 7.4, 0, 1.8],
        [-1.4, 7, -1.2, 1.4],
        [1.4, 7, -1.2, 1.4],
        [0, 7, 1.5, 1.4]
      ];
      rosettePositions.forEach(([rx, ry, rz, rRad], idx) => {
        const leaf = BABYLON.MeshBuilder.CreateSphere(`studioLeaf_${idx}`, { diameter: rRad * 2 }, scene);
        leaf.position.set(rx, ry, rz);
        leaf.parent = plantRoot;
        leaf.material = leafMat;
        leaf.isPickable = false;
        props.push(leaf);
      });
      const cupRoot = new BABYLON.TransformNode("studioCupRoot", scene);
      cupRoot.position.set(-tableW * 0.38, tableSurfaceY, -tableD * 0.34);
      cupRoot.parent = rootNode;
      props.push(cupRoot);
      const stoneMat = new BABYLON.PBRMaterial("matStudioStoneCoaster", scene);
      stoneMat.albedoColor = new BABYLON.Color3(0.48, 0.48, 0.5);
      stoneMat.roughness = 0.7;
      const coaster = BABYLON.MeshBuilder.CreateCylinder("studioCoaster", { diameter: 8.5, height: 0.5, tessellation: 24 }, scene);
      coaster.position.set(0, 0.25, 0);
      coaster.parent = cupRoot;
      coaster.material = stoneMat;
      coaster.isPickable = false;
      props.push(coaster);
      const cup = BABYLON.MeshBuilder.CreateCylinder("studioCup", { diameter: 4.8, height: 6.8, tessellation: 20 }, scene);
      cup.position.set(0, 3.8, 0);
      cup.parent = cupRoot;
      cup.material = potMat;
      cup.isPickable = false;
      props.push(cup);
      const skyMat = new BABYLON.PBRMaterial("matStudioSkylight", scene);
      skyMat.emissiveColor = new BABYLON.Color3(0.95, 0.98, 1);
      skyMat.emissiveIntensity = 1.6;
      const skylight = BABYLON.MeshBuilder.CreateBox("studioSkylightFixture", { width: 90, height: 2.4, depth: 70 }, scene);
      skylight.position.set(0, ceilingY - 12, 0);
      skylight.parent = rootNode;
      skylight.material = skyMat;
      skylight.isPickable = false;
      props.push(skylight);
      return props;
    }
    /**
     * Cleans up and disposes all room nodes, meshes, textures, materials, and lights.
     * @param {Object} roomData
     */
    static disposeRoom(roomData) {
      if (!roomData) return;
      try {
        if (roomData.props && Array.isArray(roomData.props)) {
          roomData.props.forEach((p) => {
            try {
              if (p && typeof p.dispose === "function") {
                p.dispose(false, true);
              }
            } catch (_) {
            }
          });
        }
        if (roomData.lights && Array.isArray(roomData.lights)) {
          roomData.lights.forEach((l) => {
            try {
              l.dispose();
            } catch (_) {
            }
          });
        }
        if (roomData.rootNode) {
          try {
            roomData.rootNode.dispose(false, true);
          } catch (_) {
          }
        }
      } catch (e) {
        console.warn("[RoomCatalog3D] Error disposing room resources:", e);
      }
    }
  };

  // src/board/CardMesh3D.js
  var CardMesh3D = class _CardMesh3D {
    /**
     * Static texture cache for shared card faces and backs across identical cards.
     * @type {Map<string, BABYLON.DynamicTexture>}
     */
    static textureCache = /* @__PURE__ */ new Map();
    /**
     * Standard poker playing card dimensions in Babylon world units.
     */
    static CARD_WIDTH = 11;
    static CARD_HEIGHT = 15.4;
    static CARD_THICKNESS = 0.12;
    /**
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {Object} cardData - { r: '5', s: 'H', id: '5H_0', ... }
     * @param {Object} [options={}]
     */
    constructor(scene, BABYLON, cardData, options = {}) {
      this.scene = scene;
      this.BABYLON = BABYLON;
      this.card = cardData || { r: "A", s: "S", id: "AS_0" };
      this.options = options;
      this.width = options.width || _CardMesh3D.CARD_WIDTH;
      this.height = options.height || _CardMesh3D.CARD_HEIGHT;
      this.thickness = options.thickness || _CardMesh3D.CARD_THICKNESS;
      this.backStyle = options.backStyle || "classic-blue";
      this.owner = options.owner || "p1";
      this.isLocal = options.isLocal != null ? Boolean(options.isLocal) : this.owner === "p1";
      this.faceUp = options.faceUp != null ? Boolean(options.faceUp) : this.isLocal;
      this.isSelected = false;
      this.isHovered = false;
      this.isInteractive = options.interactive !== false;
      this.isDeck = Boolean(options.isDeck);
      this.isCutFan = Boolean(options.isCutFan);
      this.cutIndex = options.cutIndex != null ? options.cutIndex : null;
      this._baseY = 0;
      this._hoverElev = 2.4;
      this._selectElev = 4.8;
      this._animating = false;
      this._animObserver = null;
      this.onClick = options.onClick || null;
      this.onHover = options.onHover || null;
      this.buildMesh();
    }
    /**
     * Returns underlying card data object.
     * @type {Object}
     */
    get cardData() {
      return this.card;
    }
    /**
     * Unique identifier for the card used in reconciliation and object reuse.
     * @type {string}
     */
    get cardId() {
      return this.card?.id || `${this.card?.rankName || this.card?.r || this.card?.rank || "A"}${this.card?.suit || this.card?.s || "S"}`;
    }
    /**
     * Whether the card face is legitimately visible/revealed to the player.
     * If false, front face texture is replaced with card back to prevent peeking when the 3D room is rotated.
     * @type {boolean}
     */
    get isFaceRevealed() {
      return Boolean(this.faceUp && (this.isLocal || this.options.faceUp === true || this.options.revealed === true));
    }
    /**
     * Normalizes rank and suit strings from any engine format.
     * @param {Object} c
     * @returns {{ rank: string, suit: string, isRed: boolean, cid: string }}
     */
    static normalizeCard(c) {
      if (!c) return { rank: "A", suit: "S", isRed: false, cid: "AS" };
      const isWild2 = Boolean(c.wild || c.isWild || c.r === 0 || c.rank === 0);
      if (isWild2 && !c.playAs) {
        return { rank: "\u2605", suit: "J", isRed: false, cid: c.id || "JOKER" };
      }
      let rank = String(c.rankName || (c.playAs ? c.playAs.r : c.r) || c.rank || "A").toUpperCase();
      if (rank === "1") rank = "A";
      if (rank === "11") rank = "J";
      if (rank === "12") rank = "Q";
      if (rank === "13") rank = "K";
      let suit = String((c.playAs ? c.playAs.s : c.suit) || c.s || "S").toUpperCase().charAt(0);
      if (!["S", "H", "D", "C"].includes(suit)) {
        if (suit === "\u2660") suit = "S";
        else if (suit === "\u2665") suit = "H";
        else if (suit === "\u2666") suit = "D";
        else if (suit === "\u2663") suit = "C";
        else suit = "S";
      }
      const isRed = suit === "H" || suit === "D";
      const cid = c.id || `${rank}${suit}`;
      return { rank, suit, isRed, cid };
    }
    /**
     * Builds the composite 3D playing card mesh:
     * Front face plane, Back face plane, and white cardstock core with edge thickness.
     */
    buildMesh() {
      const { scene, BABYLON } = this;
      const cid = this.card.id || `${this.card.r || "A"}${this.card.s || "S"}`;
      this.rootNode = new BABYLON.TransformNode(`card3D_${cid}`, scene);
      const doubleSide = BABYLON.Mesh && BABYLON.Mesh.DOUBLESIDE != null ? BABYLON.Mesh.DOUBLESIDE : 2;
      this.frontMesh = BABYLON.MeshBuilder.CreatePlane(`cardFront_${cid}`, {
        width: this.width,
        height: this.height,
        sideOrientation: doubleSide
      }, scene);
      this.frontMesh.position.set(0, 0, -this.thickness / 2 - 5e-3);
      this.frontMesh.rotation.set(0, 0, 0);
      this.frontMesh.parent = this.rootNode;
      this.frontMesh.isPickable = this.isInteractive;
      this.frontMesh.receiveShadows = true;
      this.frontMat = new BABYLON.PBRMaterial(`matCardFront_${cid}`, scene);
      this.frontMat.roughness = 0.38;
      this.frontMat.metallic = 0.02;
      this.frontMat.backFaceCulling = false;
      this.frontMat.transparencyMode = 0;
      this.frontMat.alpha = 1;
      this.updateCardTextures();
      this.frontMesh.material = this.frontMat;
      this.backMesh = BABYLON.MeshBuilder.CreatePlane(`cardBack_${cid}`, {
        width: this.width,
        height: this.height,
        sideOrientation: doubleSide
      }, scene);
      this.backMesh.position.set(0, 0, this.thickness / 2 + 5e-3);
      this.backMesh.rotation.set(0, Math.PI, 0);
      this.backMesh.parent = this.rootNode;
      this.backMesh.isPickable = this.isInteractive;
      this.backMesh.receiveShadows = true;
      this.backMat = new BABYLON.PBRMaterial(`matCardBack_${cid}_${this.backStyle}`, scene);
      this.backMat.roughness = 0.32;
      this.backMat.metallic = 0.05;
      this.backMat.backFaceCulling = false;
      this.backMat.transparencyMode = 0;
      this.backMat.alpha = 1;
      const backTex = _CardMesh3D.getCardBackTexture(scene, BABYLON, this.backStyle);
      if (backTex) {
        backTex.hasAlpha = false;
        this.backMat.albedoTexture = backTex;
      } else {
        this.backMat.albedoColor = new BABYLON.Color3(0.12, 0.22, 0.55);
      }
      this.backMesh.material = this.backMat;
      this.coreMesh = BABYLON.MeshBuilder.CreateBox(`cardCore_${cid}`, {
        width: this.width - 0.05,
        height: this.height - 0.05,
        depth: this.thickness
      }, scene);
      this.coreMesh.position.set(0, 0, 0);
      this.coreMesh.parent = this.rootNode;
      this.coreMesh.isPickable = false;
      this.coreMat = new BABYLON.PBRMaterial(`matCardCore_${cid}`, scene);
      this.coreMat.albedoColor = new BABYLON.Color3(0.96, 0.96, 0.94);
      this.coreMat.roughness = 0.6;
      this.coreMesh.material = this.coreMat;
      this.highlightMesh = BABYLON.MeshBuilder.CreatePlane(`cardHighlight_${cid}`, {
        width: this.width + 0.8,
        height: this.height + 0.8,
        sideOrientation: doubleSide
      }, scene);
      this.highlightMesh.position.set(0, 0, -this.thickness / 2 - 0.012);
      this.highlightMesh.parent = this.rootNode;
      this.highlightMesh.isPickable = false;
      this.highlightMesh.isVisible = false;
      this.highlightMat = new BABYLON.PBRMaterial(`matCardHighlight_${cid}`, scene);
      this.highlightMat.emissiveColor = new BABYLON.Color3(1, 0.85, 0.2);
      this.highlightMat.alpha = 0.65;
      this.highlightMesh.material = this.highlightMat;
      this.frontMesh.metadata = { cardMesh: this, card: this.card, isDeck: this.isDeck, isCutFan: this.isCutFan, cutIndex: this.cutIndex };
      this.backMesh.metadata = { cardMesh: this, card: this.card, isDeck: this.isDeck, isCutFan: this.isCutFan, cutIndex: this.cutIndex };
      if (!this.faceUp) {
        this.rootNode.rotation.y = Math.PI;
      }
    }
    /**
     * Clears the static texture cache.
     */
    static clearTextureCache() {
      _CardMesh3D.textureCache.forEach((tex) => {
        try {
          if (tex && !tex.isDisposed && typeof tex.dispose === "function") tex.dispose();
        } catch (_) {
        }
      });
      _CardMesh3D.textureCache.clear();
    }
    /**
     * Retrieves or generates a high-DPI procedural DynamicTexture for a card face.
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {Object} card
     * @returns {BABYLON.DynamicTexture|null}
     */
    static getCardFaceTexture(scene, BABYLON, card) {
      if (!BABYLON || !BABYLON.DynamicTexture) return null;
      const { rank, suit, cid } = _CardMesh3D.normalizeCard(card);
      const isCut = Boolean(card && card.isCut);
      const cacheKey = `face_${rank}_${suit}_${isCut ? "cut" : "std"}`;
      if (_CardMesh3D.textureCache.has(cacheKey)) {
        const cached = _CardMesh3D.textureCache.get(cacheKey);
        if (cached && (typeof cached.getScene !== "function" || cached.getScene() === scene) && !cached.isDisposed) {
          return cached;
        }
        _CardMesh3D.textureCache.delete(cacheKey);
      }
      const tex = new BABYLON.DynamicTexture(`texFace_${cacheKey}`, { width: 512, height: 716 }, scene, false);
      tex.hasAlpha = false;
      const ctx = tex.getContext ? tex.getContext() : null;
      if (ctx) {
        _CardMesh3D.drawCardFace(ctx, rank, suit, card.isCut);
        if (typeof tex.update === "function") tex.update();
      }
      _CardMesh3D.textureCache.set(cacheKey, tex);
      return tex;
    }
    /**
     * Retrieves or generates a high-DPI procedural DynamicTexture for a card back.
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {string} [backStyle='classic-blue']
     * @returns {BABYLON.DynamicTexture|null}
     */
    static getCardBackTexture(scene, BABYLON, backStyle = "classic-blue") {
      if (!BABYLON || !BABYLON.DynamicTexture) return null;
      const cacheKey = `back_${backStyle}`;
      if (_CardMesh3D.textureCache.has(cacheKey)) {
        const cached = _CardMesh3D.textureCache.get(cacheKey);
        if (cached && (typeof cached.getScene !== "function" || cached.getScene() === scene) && !cached.isDisposed) {
          return cached;
        }
        _CardMesh3D.textureCache.delete(cacheKey);
      }
      const tex = new BABYLON.DynamicTexture(`texBack_${cacheKey}`, { width: 512, height: 716 }, scene, false);
      tex.hasAlpha = false;
      const ctx = tex.getContext ? tex.getContext() : null;
      if (ctx) {
        _CardMesh3D.drawCardBack(ctx, backStyle);
        if (typeof tex.update === "function") tex.update();
      }
      _CardMesh3D.textureCache.set(cacheKey, tex);
      return tex;
    }
    /**
     * Draws a crisp, high-DPI authentic playing card face onto an HTML Canvas 2D context.
     * @param {CanvasRenderingContext2D} ctx
     * @param {string} rank - 'A', '2'..'10', 'J', 'Q', 'K', '★'
     * @param {string} suit - 'S', 'H', 'D', 'C', 'J'
     * @param {boolean} [isCut=false]
     */
    static drawCardFace(ctx, rank, suit, isCut = false) {
      if (!ctx) return;
      const w = 512;
      const h = 716;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = isCut ? "#eab308" : "#cbd5e1";
      ctx.lineWidth = isCut ? 8 : 4;
      ctx.beginPath();
      if (typeof ctx.roundRect === "function") {
        ctx.roundRect(8, 8, w - 16, h - 16, 20);
      } else {
        ctx.rect(8, 8, w - 16, h - 16);
      }
      ctx.stroke();
      const suitSymbolMap = { S: "\u2660", H: "\u2665", D: "\u2666", C: "\u2663", J: "\u2605" };
      const suitSymbol = suitSymbolMap[suit] || "\u2660";
      const isRed = suit === "H" || suit === "D";
      const primaryColor = isRed ? "#dc2626" : "#0f172a";
      const drawCornerIndex = (x, y, angle = 0) => {
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillStyle = primaryColor;
        ctx.textAlign = "center";
        ctx.font = 'bold 54px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillText(rank, 0, 0);
        ctx.font = '42px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillText(suitSymbol, 0, 42);
        ctx.restore();
      };
      drawCornerIndex(52, 68, 0);
      drawCornerIndex(w - 52, h - 68, Math.PI);
      if (rank === "\u2605") {
        ctx.save();
        ctx.fillStyle = "#ca8a04";
        ctx.font = 'bold 120px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("\u2605", w / 2, h / 2 - 20);
        ctx.font = 'bold 44px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillStyle = "#9333ea";
        ctx.fillText("WILD JOKER", w / 2, h / 2 + 80);
        ctx.restore();
      } else if (["J", "Q", "K"].includes(rank)) {
        _CardMesh3D.drawCourtCardCenter(ctx, rank, suit, suitSymbol, primaryColor, w, h);
      } else {
        _CardMesh3D.drawPipCardCenter(ctx, rank, suitSymbol, primaryColor, w, h);
      }
      if (isCut) {
        ctx.save();
        ctx.fillStyle = "#ca8a04";
        ctx.font = 'bold 20px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.fillText("STARTER CUT", w / 2, h - 28);
        ctx.restore();
      }
    }
    /**
     * Draws traditional pip configurations (Ace through 10).
     */
    static drawPipCardCenter(ctx, rank, suitSymbol, color, w, h) {
      ctx.save();
      ctx.fillStyle = color;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      const cx = w / 2;
      const cy = h / 2;
      if (rank === "A") {
        ctx.font = '160px "Segoe UI", Roboto, sans-serif';
        ctx.fillText(suitSymbol, cx, cy);
        if (suitSymbol === "\u2660") {
          ctx.strokeStyle = "#0f172a";
          ctx.lineWidth = 3;
          ctx.beginPath();
          ctx.arc(cx, cy, 100, 0, Math.PI * 2);
          ctx.stroke();
        }
      } else {
        ctx.font = '72px "Segoe UI", Roboto, sans-serif';
        const pipCoords = _CardMesh3D.getPipCoordinates(rank, w, h);
        pipCoords.forEach(([px, py, flip]) => {
          ctx.save();
          ctx.translate(px, py);
          if (flip) ctx.rotate(Math.PI);
          ctx.fillText(suitSymbol, 0, 0);
          ctx.restore();
        });
      }
      ctx.restore();
    }
    /**
     * Calculates normalized coordinate positions for 2 through 10 card pips.
     */
    static getPipCoordinates(rank, w, h) {
      const lx = w * 0.33;
      const rx = w * 0.67;
      const cx = w * 0.5;
      const ty = h * 0.22;
      const tmy = h * 0.36;
      const my = h * 0.5;
      const bmy = h * 0.64;
      const by = h * 0.78;
      switch (rank) {
        case "2":
          return [[cx, ty, false], [cx, by, true]];
        case "3":
          return [[cx, ty, false], [cx, my, false], [cx, by, true]];
        case "4":
          return [[lx, ty, false], [rx, ty, false], [lx, by, true], [rx, by, true]];
        case "5":
          return [[lx, ty, false], [rx, ty, false], [cx, my, false], [lx, by, true], [rx, by, true]];
        case "6":
          return [[lx, ty, false], [rx, ty, false], [lx, my, false], [rx, my, false], [lx, by, true], [rx, by, true]];
        case "7":
          return [[lx, ty, false], [rx, ty, false], [cx, tmy, false], [lx, my, false], [rx, my, false], [lx, by, true], [rx, by, true]];
        case "8":
          return [[lx, ty, false], [rx, ty, false], [cx, tmy, false], [lx, my, false], [rx, my, false], [cx, bmy, true], [lx, by, true], [rx, by, true]];
        case "9":
          return [[lx, ty, false], [rx, ty, false], [lx, tmy, false], [rx, tmy, false], [cx, my, false], [lx, bmy, true], [rx, bmy, true], [lx, by, true], [rx, by, true]];
        case "10":
          return [[lx, ty, false], [rx, ty, false], [cx, tmy - 15, false], [lx, tmy + 15, false], [rx, tmy + 15, false], [lx, bmy - 15, true], [rx, bmy - 15, true], [cx, bmy + 15, true], [lx, by, true], [rx, by, true]];
        default:
          return [[cx, my, false]];
      }
    }
    /**
     * Draws authentic two-way royal portrait emblem for Jack, Queen, and King.
     */
    static drawCourtCardCenter(ctx, rank, suit, suitSymbol, color, w, h) {
      ctx.save();
      const frameW = 280;
      const frameH = 440;
      const fx = (w - frameW) / 2;
      const fy = (h - frameH) / 2;
      ctx.strokeStyle = "#d4af37";
      ctx.lineWidth = 4;
      ctx.strokeRect(fx, fy, frameW, frameH);
      ctx.strokeStyle = "#f59e0b";
      ctx.lineWidth = 1.5;
      ctx.strokeRect(fx + 6, fy + 6, frameW - 12, frameH - 12);
      ctx.fillStyle = "#fafaf9";
      ctx.fillRect(fx + 8, fy + 8, frameW - 16, frameH - 16);
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, 70, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = "#ffffff";
      ctx.font = '76px "Segoe UI", Roboto, sans-serif';
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(suitSymbol, w / 2, h / 2);
      ctx.fillStyle = "#d4af37";
      ctx.font = 'bold 36px "Segoe UI", Roboto, sans-serif';
      ctx.fillText(rank === "K" ? "\u2654 KING" : rank === "Q" ? "\u2655 QUEEN" : "\u2657 JACK", w / 2, fy + 42);
      ctx.fillText(rank === "K" ? "\u2654 KING" : rank === "Q" ? "\u2655 QUEEN" : "\u2657 JACK", w / 2, fy + frameH - 36);
      ctx.restore();
    }
    /**
     * Generates procedural pattern artwork for the back of the card.
     * @param {CanvasRenderingContext2D} ctx
     * @param {string} backStyle
     */
    static drawCardBack(ctx, backStyle = "classic-blue") {
      if (!ctx) return;
      const w = 512;
      const h = 716;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, w, h);
      const margin = 26;
      const innerW = w - margin * 2;
      const innerH = h - margin * 2;
      ctx.save();
      ctx.beginPath();
      ctx.roundRect ? ctx.roundRect(margin, margin, innerW, innerH, 16) : ctx.rect(margin, margin, innerW, innerH);
      ctx.clip();
      if (backStyle === "classic-red" || backStyle === "vegas-crimson") {
        ctx.fillStyle = "#991b1b";
        ctx.fillRect(margin, margin, innerW, innerH);
        ctx.strokeStyle = "#b91c1c";
        ctx.lineWidth = 2;
        for (let x = -w; x < w * 2; x += 16) {
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x + h, h);
          ctx.stroke();
          ctx.beginPath();
          ctx.moveTo(x, h);
          ctx.lineTo(x + h, 0);
          ctx.stroke();
        }
        ctx.fillStyle = "#ffffff";
        ctx.beginPath();
        ctx.arc(w / 2, h / 2, 54, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = "#991b1b";
        ctx.beginPath();
        ctx.arc(w / 2, h / 2, 44, 0, Math.PI * 2);
        ctx.fill();
      } else if (backStyle === "royal-gold" || backStyle === "obsidian-carbon") {
        ctx.fillStyle = "#0f172a";
        ctx.fillRect(margin, margin, innerW, innerH);
        ctx.strokeStyle = "#d4af37";
        ctx.lineWidth = 1.5;
        for (let x = margin; x < w - margin; x += 24) {
          ctx.beginPath();
          ctx.arc(x, h / 2, 80, 0, Math.PI);
          ctx.stroke();
        }
        ctx.strokeStyle = "#f59e0b";
        ctx.lineWidth = 3;
        ctx.strokeRect(margin + 12, margin + 12, innerW - 24, innerH - 24);
      } else if (backStyle === "emerald-diamond") {
        ctx.fillStyle = "#065f46";
        ctx.fillRect(margin, margin, innerW, innerH);
        ctx.strokeStyle = "#047857";
        ctx.lineWidth = 2.5;
        for (let x = -w; x < w * 2; x += 28) {
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x + h, h);
          ctx.stroke();
          ctx.beginPath();
          ctx.moveTo(x, h);
          ctx.lineTo(x + h, 0);
          ctx.stroke();
        }
      } else {
        ctx.fillStyle = "#1e3a8a";
        ctx.fillRect(margin, margin, innerW, innerH);
        ctx.strokeStyle = "#2563eb";
        ctx.lineWidth = 2;
        for (let x = -w; x < w * 2; x += 18) {
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x + h, h);
          ctx.stroke();
          ctx.beginPath();
          ctx.moveTo(x, h);
          ctx.lineTo(x + h, 0);
          ctx.stroke();
        }
        ctx.fillStyle = "#ffffff";
        ctx.beginPath();
        ctx.arc(w / 2, h / 2, 60, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = "#1e3a8a";
        ctx.beginPath();
        ctx.arc(w / 2, h / 2, 48, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = "#ffffff";
        ctx.font = 'bold 24px "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("\u2660 \u2665", w / 2, h / 2 - 8);
        ctx.fillText("\u2666 \u2663", w / 2, h / 2 + 14);
      }
      ctx.restore();
      ctx.strokeStyle = "#ffffff";
      ctx.lineWidth = 3;
      ctx.strokeRect(margin + 8, margin + 8, innerW - 16, innerH - 16);
    }
    /**
     * Sets card hover state with smooth vertical lift.
     * @param {boolean} hovered
     */
    setHover(hovered) {
      if (this.isHovered === hovered || this._animating) return;
      this.isHovered = hovered;
      this.updateElevation();
    }
    /**
     * Sets card selection state (elevates further with golden highlight).
     * @param {boolean} selected
     */
    setSelected(selected) {
      this.isSelected = selected;
      if (this.highlightMesh) {
        this.highlightMesh.isVisible = selected;
      }
      this.updateElevation();
    }
    /**
     * Recomputes vertical elevation based on base height, hover, and selection.
     */
    updateElevation() {
      let targetY = this._baseY;
      if (this.isSelected) {
        targetY += this._selectElev;
      } else if (this.isHovered) {
        targetY += this.isDeck ? 1.4 : this._hoverElev;
      }
      if (this.rootNode && this.rootNode.position) {
        this.rootNode.position.y = targetY;
      }
    }
    /**
     * Animates card translation and rotation towards target coordinates.
     * @param {BABYLON.Vector3} targetPos
     * @param {BABYLON.Vector3} targetRot
     * @param {number} [duration=260]
     * @param {Function} [onComplete]
     */
    animateTo(targetPos, targetRot, duration = 260, onComplete = null) {
      if (!this.rootNode) return;
      if (this._animObserver && this.scene) {
        this.scene.onBeforeRenderObservable.remove(this._animObserver);
        this._animObserver = null;
      }
      this._animating = true;
      const startPos = this.rootNode.position && typeof this.rootNode.position.clone === "function" ? this.rootNode.position.clone() : { x: this.rootNode.position?.x || 0, y: this.rootNode.position?.y || 0, z: this.rootNode.position?.z || 0 };
      const startRot = this.rootNode.rotation && typeof this.rootNode.rotation.clone === "function" ? this.rootNode.rotation.clone() : { x: this.rootNode.rotation?.x || 0, y: this.rootNode.rotation?.y || 0, z: this.rootNode.rotation?.z || 0 };
      const startTime = performance.now();
      const observer = this.scene.onBeforeRenderObservable.add(() => {
        const elapsed = performance.now() - startTime;
        const t = Math.min(1, elapsed / duration);
        const ease = 1 - Math.pow(1 - t, 3);
        if (this.BABYLON.Vector3 && typeof this.BABYLON.Vector3.Lerp === "function") {
          this.rootNode.position = this.BABYLON.Vector3.Lerp(startPos, targetPos, ease);
          this.rootNode.rotation = this.BABYLON.Vector3.Lerp(startRot, targetRot, ease);
        } else {
          if (this.rootNode.position) {
            this.rootNode.position.x = startPos.x + (targetPos.x - startPos.x) * ease;
            this.rootNode.position.y = startPos.y + (targetPos.y - startPos.y) * ease;
            this.rootNode.position.z = startPos.z + (targetPos.z - startPos.z) * ease;
          }
          if (this.rootNode.rotation) {
            this.rootNode.rotation.x = startRot.x + (targetRot.x - startRot.x) * ease;
            this.rootNode.rotation.y = startRot.y + (targetRot.y - startRot.y) * ease;
            this.rootNode.rotation.z = startRot.z + (targetRot.z - startRot.z) * ease;
          }
        }
        if (t >= 1) {
          if (this.scene && this._animObserver === observer) {
            this.scene.onBeforeRenderObservable.remove(observer);
            this._animObserver = null;
          }
          this._animating = false;
          if (this.rootNode.position) {
            this._baseY = this.rootNode.position.y;
          }
          if (typeof onComplete === "function") onComplete();
        }
      });
      this._animObserver = observer;
    }
    /**
     * Sets card face-up state and updates textures so card face is only visible when revealed.
     * @param {boolean} faceUp
     */
    setFaceUp(faceUp) {
      if (faceUp && (this._wasTurnedDown || this.card?.faceDown)) {
        this.faceUp = false;
        this.options.faceUp = false;
        this.updateCardTextures();
        return;
      }
      this.faceUp = Boolean(faceUp);
      this.options.faceUp = this.faceUp;
      this.updateCardTextures();
    }
    /**
     * Sets card revealed state (e.g. at showdown).
     * @param {boolean} revealed
     */
    setRevealed(revealed) {
      this.options.revealed = Boolean(revealed);
      this.updateCardTextures();
    }
    /**
     * Updates card properties, textures, and metadata in place without mesh recreation.
     * @param {Object} cardData
     * @param {Object} [options={}]
     */
    updateCard(cardData, options = {}) {
      this.card = cardData || this.card;
      if (options.width != null) this.width = options.width;
      if (options.height != null) this.height = options.height;
      if (options.backStyle != null && options.backStyle !== this.backStyle) {
        this.backStyle = options.backStyle;
      }
      if (options.owner != null) this.owner = options.owner;
      if (options.isLocal != null) this.isLocal = Boolean(options.isLocal);
      if (this._wasTurnedDown || this.card?.faceDown) {
        this.faceUp = false;
        this.options.faceUp = false;
      } else if (options.faceUp != null) {
        this.faceUp = Boolean(options.faceUp);
        this.options.faceUp = this.faceUp;
      }
      if (options.revealed != null) this.options.revealed = Boolean(options.revealed);
      if (options.interactive != null) {
        this.isInteractive = Boolean(options.interactive);
        if (this.frontMesh) this.frontMesh.isPickable = this.isInteractive;
        if (this.backMesh) this.backMesh.isPickable = this.isInteractive;
        if (!this.isInteractive && this.isHovered) {
          this.setHover(false);
        }
      }
      if (options.cutIndex != null) this.cutIndex = options.cutIndex;
      if (options.isDeck != null) this.isDeck = Boolean(options.isDeck);
      if (options.isCutFan != null) this.isCutFan = Boolean(options.isCutFan);
      if (options.onClick != null) this.onClick = options.onClick;
      if (options.onHover != null) this.onHover = options.onHover;
      if (this.frontMesh?.metadata) {
        this.frontMesh.metadata.card = this.card;
        this.frontMesh.metadata.cardMesh = this;
        this.frontMesh.metadata.isDeck = this.isDeck;
        this.frontMesh.metadata.isCutFan = this.isCutFan;
        this.frontMesh.metadata.cutIndex = this.cutIndex;
      }
      if (this.backMesh?.metadata) {
        this.backMesh.metadata.card = this.card;
        this.backMesh.metadata.cardMesh = this;
        this.backMesh.metadata.isDeck = this.isDeck;
        this.backMesh.metadata.isCutFan = this.isCutFan;
        this.backMesh.metadata.cutIndex = this.cutIndex;
      }
      this.updateCardTextures();
    }
    /**
     * Sets the 3D position and rotation of the card, with optional smooth animation.
     * @param {number} posX
     * @param {number} posY
     * @param {number} posZ
     * @param {number} rotPitch
     * @param {number} rotYaw
     * @param {number} rotRoll
     * @param {boolean} [smooth=false]
     * @param {number} [duration=200]
     * @param {Function} [onComplete]
     */
    setTransform(posX, posY, posZ, rotPitch, rotYaw, rotRoll, smooth = false, duration = 200, onComplete = null) {
      if (!this.rootNode) return;
      this._baseY = posY;
      const targetY = posY + (this.isSelected ? this._selectElev : this.isHovered ? this.isDeck ? 1.4 : this._hoverElev : 0);
      if (smooth && !this._animating) {
        const curPos = this.rootNode.position;
        const dist2 = Math.hypot(curPos.x - posX, curPos.y - targetY, curPos.z - posZ);
        if (dist2 > 0.05) {
          const targetPos = new this.BABYLON.Vector3(posX, targetY, posZ);
          const targetRot = new this.BABYLON.Vector3(rotPitch, rotYaw, rotRoll);
          this.animateTo(targetPos, targetRot, duration, onComplete);
          return;
        }
      }
      if (!this._animating) {
        this.rootNode.position.set(posX, targetY, posZ);
        this.rootNode.rotation.set(rotPitch, rotYaw, rotRoll);
        if (typeof onComplete === "function") onComplete();
      }
    }
    /**
     * Updates card front texture based on whether the face is legitimately revealed.
     * Unrevealed cards (e.g. opponents' hands or face-down deck/crib) display card back on both sides,
     * completely preventing players from seeing card faces when the 3D room is rotated.
     */
    updateCardTextures() {
      if (!this.frontMat || !this.scene || !this.BABYLON) return;
      if (this.isFaceRevealed) {
        const frontTex = _CardMesh3D.getCardFaceTexture(this.scene, this.BABYLON, this.card);
        if (frontTex) {
          frontTex.hasAlpha = false;
          this.frontMat.albedoTexture = frontTex;
          if (this.frontMat.albedoColor) {
            this.frontMat.albedoColor = new this.BABYLON.Color3(1, 1, 1);
          }
        } else {
          this.frontMat.albedoColor = new this.BABYLON.Color3(0.98, 0.98, 0.98);
        }
      } else {
        const backTex = _CardMesh3D.getCardBackTexture(this.scene, this.BABYLON, this.backStyle);
        if (backTex) {
          backTex.hasAlpha = false;
          this.frontMat.albedoTexture = backTex;
          if (this.frontMat.albedoColor) {
            this.frontMat.albedoColor = new this.BABYLON.Color3(1, 1, 1);
          }
        } else {
          this.frontMat.albedoColor = new this.BABYLON.Color3(0.12, 0.22, 0.55);
        }
      }
    }
    /**
     * Flips card smoothly face-up or face-down.
     * @param {boolean} faceUp
     * @param {number} [duration=240]
     * @param {Function} [onComplete]
     */
    flip(faceUp, duration = 240, onComplete = null) {
      if (faceUp && (this._wasTurnedDown || this.card?.faceDown)) {
        this.faceUp = false;
        this.options.faceUp = false;
        this.updateCardTextures();
        return;
      }
      this.faceUp = Boolean(faceUp);
      this.options.faceUp = this.faceUp;
      this.updateCardTextures();
      const targetRotY = faceUp ? 0 : Math.PI;
      const curRot = this.rootNode.rotation && typeof this.rootNode.rotation.clone === "function" ? this.rootNode.rotation.clone() : { x: this.rootNode.rotation?.x || 0, y: this.rootNode.rotation?.y || 0, z: this.rootNode.rotation?.z || 0 };
      const targetRot = new this.BABYLON.Vector3(curRot.x, targetRotY, curRot.z);
      this.animateTo(this.rootNode.position.clone(), targetRot, duration, onComplete);
    }
    /**
     * Disposes all meshes, textures, materials, and observables cleanly.
     */
    dispose() {
      try {
        if (this._animObserver && this.scene) {
          this.scene.onBeforeRenderObservable.remove(this._animObserver);
          this._animObserver = null;
        }
        if (this.frontMesh) {
          if (this.frontMesh.metadata) this.frontMesh.metadata = null;
          this.frontMesh.dispose();
        }
        if (this.backMesh) {
          if (this.backMesh.metadata) this.backMesh.metadata = null;
          this.backMesh.dispose();
        }
        if (this.coreMesh) this.coreMesh.dispose();
        if (this.highlightMesh) this.highlightMesh.dispose();
        if (this.frontMat) this.frontMat.dispose();
        if (this.backMat) this.backMat.dispose();
        if (this.coreMat) this.coreMat.dispose();
        if (this.highlightMat) this.highlightMat.dispose();
        if (this.rootNode) this.rootNode.dispose(false, true);
      } catch (_) {
      }
    }
  };
  var CardEngine3D = class {
    /**
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {Object} options - { tableSurfaceY, tableW, tableD, settings }
     */
    constructor(scene, BABYLON, options = {}) {
      this.scene = scene;
      this.BABYLON = BABYLON;
      this.options = options;
      this.tableSurfaceY = options.tableSurfaceY != null ? options.tableSurfaceY : -0.88;
      this.tableW = options.tableW || 140;
      this.tableD = options.tableD || 100;
      this.boardBounds = options.boardBounds || null;
      this.chairRoots = options.chairRoots || [];
      this.seatManager = options.seatManager || null;
      this.backStyle = options.settings?.cardBack || options.backStyle || "classic-blue";
      this.playerHands = /* @__PURE__ */ new Map();
      this.playPile = [];
      this.starterDeck = [];
      this.starterCard = null;
      this.starterCards = [];
      this.cribCards = [];
      this.cutDeckFan = [];
      this.cutPrompt = null;
      this.isCuttable = false;
      this.onCutPromptClick = null;
      this.pointerObserver = null;
      this.hoveredCard = null;
      this.onCardClick = options.onCardClick || null;
      this.onCardHover = options.onCardHover || null;
      this.setupPointerInteractions();
    }
    /**
     * Returns primary starter card mesh for backward compatibility.
     * @returns {CardMesh3D|null}
     */
    get starterCardMesh() {
      return this.starterCard || this.starterCards && this.starterCards[0] || null;
    }
    /**
     * Sets up 3D pointer raycast picking for hover elevation and card selection.
     */
    setupPointerInteractions() {
      if (!this.scene || !this.BABYLON) return;
      let moveRafPending = false;
      let lastPointerX = 0;
      let lastPointerY = 0;
      const cardRaycastPredicate = (mesh) => {
        return Boolean(mesh && mesh.isPickable && (mesh.metadata?.cardMesh || mesh.metadata?.isCutPrompt));
      };
      const processPointerHover = (px, py) => {
        const pick = this.scene.pick(px, py, cardRaycastPredicate);
        const meta = pick?.pickedMesh?.metadata;
        const cardMesh = meta?.cardMesh;
        const isCutPrompt = Boolean(meta?.isCutPrompt);
        if (cardMesh && cardMesh.isInteractive) {
          if (this.hoveredCard !== cardMesh) {
            if (this.hoveredCard) this.hoveredCard.setHover(false);
            this.hoveredCard = cardMesh;
            this.hoveredCard.setHover(true);
            if (typeof this.onCardHover === "function") this.onCardHover(cardMesh.card, true);
          }
          if (typeof document !== "undefined") {
            const canvas = this.scene?.getEngine?.()?.getRenderingCanvas?.();
            if (canvas) canvas.style.cursor = "pointer";
          }
        } else if (isCutPrompt) {
          if (typeof document !== "undefined") {
            const canvas = this.scene?.getEngine?.()?.getRenderingCanvas?.();
            if (canvas) canvas.style.cursor = "pointer";
          }
        } else {
          if (this.hoveredCard) {
            this.hoveredCard.setHover(false);
            if (typeof this.onCardHover === "function") this.onCardHover(this.hoveredCard.card, false);
            this.hoveredCard = null;
          }
          if (typeof document !== "undefined") {
            const canvas = this.scene?.getEngine?.()?.getRenderingCanvas?.();
            if (canvas) canvas.style.cursor = "default";
          }
        }
      };
      this.pointerObserver = this.scene.onPointerObservable.add((pointerInfo) => {
        const type = pointerInfo.type;
        if (type === this.BABYLON.PointerEventTypes.POINTERMOVE) {
          lastPointerX = this.scene.pointerX;
          lastPointerY = this.scene.pointerY;
          if (!moveRafPending) {
            moveRafPending = true;
            const scheduleRaf = typeof requestAnimationFrame === "function" ? requestAnimationFrame : (cb) => setTimeout(cb, 16);
            scheduleRaf(() => {
              moveRafPending = false;
              if (this.scene && !this.scene.isDisposed) {
                processPointerHover(lastPointerX, lastPointerY);
              }
            });
          }
        }
        if (type === this.BABYLON.PointerEventTypes.POINTERPICK) {
          const pick = this.scene.pick(this.scene.pointerX, this.scene.pointerY, cardRaycastPredicate);
          const meta = pick?.pickedMesh?.metadata;
          const cardMesh = meta?.cardMesh;
          if (cardMesh && cardMesh.isInteractive) {
            if (typeof cardMesh.onClick === "function") {
              cardMesh.onClick(cardMesh.card, cardMesh);
            } else {
              cardMesh.setSelected(!cardMesh.isSelected);
              if (typeof this.onCardClick === "function") {
                this.onCardClick(cardMesh.card, cardMesh);
              }
            }
          } else if (meta?.isCutPrompt) {
            if (typeof meta.onClick === "function") {
              meta.onClick();
            } else if (typeof this.onCutPromptClick === "function") {
              this.onCutPromptClick();
            }
          }
        }
      });
    }
    /**
     * Resolves the anchor position and rotation for a player's hand fan in 3D space.
     * Accurately anchors each player's hand on the table surface directly in front of their chair,
     * properly oriented and spaced.
     * @param {string} seat - 'p1', 'p2', etc.
     * @param {boolean} isLocal
     * @returns {{ posX: number, posY: number, posZ: number, angle: number, pitch: number, yaw: number, cardWidth: number, cardHeight: number }}
     */
    getSeatHandAnchor(seat, isLocal) {
      const tableW = this.tableW || 120;
      const tableD = this.tableD || 100;
      const edgeOffset = 13.5;
      let seatIdx = 0;
      if (seat && seat.startsWith("p")) {
        const parsed = parseInt(seat.slice(1), 10);
        if (!isNaN(parsed) && parsed >= 1) seatIdx = parsed - 1;
      }
      let chairRoot = null;
      if (this.chairRoots && this.chairRoots[seatIdx]) {
        chairRoot = this.chairRoots[seatIdx];
      } else if (this.seatManager?.seats?.get(seat)?.chairRoot) {
        chairRoot = this.seatManager.seats.get(seat).chairRoot;
      }
      let angle = 0;
      if (chairRoot && chairRoot.rotation && typeof chairRoot.rotation.y === "number") {
        angle = chairRoot.rotation.y;
      } else {
        if (seatIdx === 0) angle = 0;
        else if (seatIdx === 1) angle = Math.PI;
        else if (seatIdx === 2) angle = 1.5 * Math.PI;
        else if (seatIdx === 3) angle = 0.5 * Math.PI;
      }
      const cardWidth = isLocal ? 14.5 : 13;
      const cardHeight = isLocal ? 20.3 : 18.2;
      const pitch = isLocal ? 0.42 : -0.42;
      const halfH = cardHeight / 2;
      const bottomOffset = halfH * Math.cos(Math.abs(pitch));
      const tableClearance = isLocal ? 1.4 : 0.8;
      const posY = this.tableSurfaceY + bottomOffset + tableClearance;
      const posX = Math.sin(angle) * (tableW / 2 - edgeOffset);
      const posZ = -Math.cos(angle) * (tableD / 2 - edgeOffset);
      return {
        posX,
        posY,
        posZ,
        angle,
        pitch,
        yaw: angle,
        cardWidth,
        cardHeight
      };
    }
    /**
     * Arranges cards into an ergonomic hand fan in front of a player's seat.
     * @param {string} seat - 'p1', 'p2', etc.
     * @param {Array<Object>} cards
     * @param {Object} [options={}]
     * @returns {Array<CardMesh3D>}
     */
    renderHandFan(seat, cards = [], options = {}) {
      if (!cards || !cards.length) {
        this.clearHand(seat);
        return [];
      }
      const isLocal = options.isLocal != null ? Boolean(options.isLocal) : seat === "p1";
      const count = cards.length;
      const anchor = this.getSeatHandAnchor(seat, isLocal);
      const cardWidth = options.width || anchor.cardWidth;
      const cardHeight = options.height || anchor.cardHeight;
      const maxFanAngle = Math.min(0.28, count * 0.055);
      const cardSpacing = isLocal ? Math.min(8, 42 / Math.max(1, count)) : Math.min(6.5, 34 / Math.max(1, count));
      const cosA = Math.cos(anchor.angle);
      const sinA = Math.sin(anchor.angle);
      const isCardFaceUp = isLocal || options.faceUp === true;
      const isCardInteractive = options.interactive !== void 0 ? Boolean(options.interactive) : isLocal;
      const isOppRevealed = !isLocal && options.faceUp === true;
      const pitch = isOppRevealed ? Math.PI / 2 : anchor.pitch;
      const yaw = isOppRevealed ? 0 : anchor.yaw;
      const existingMeshes = this.playerHands.get(seat) || [];
      const existingById = /* @__PURE__ */ new Map();
      existingMeshes.forEach((m) => {
        if (m && m.rootNode && !m.rootNode.isDisposed) {
          existingById.set(m.cardId, m);
        }
      });
      const newHandMeshes = [];
      const usedMeshSet = /* @__PURE__ */ new Set();
      cards.forEach((c, idx) => {
        const normIdx = count > 1 ? idx / (count - 1) - 0.5 : 0;
        const fanAngle = normIdx * maxFanAngle;
        const spread = normIdx * (count * cardSpacing);
        const arcInward = Math.abs(normIdx) * 1.8;
        const posX = anchor.posX + cosA * spread - sinA * arcInward;
        const posZ = anchor.posZ + sinA * spread + cosA * arcInward;
        const posY = anchor.posY + idx * 0.16;
        const cId = c?.id || `${c?.rankName || c?.r || c?.rank || "A"}${c?.suit || c?.s || "S"}`;
        let cardMesh = existingById.get(cId);
        if (cardMesh && !usedMeshSet.has(cardMesh)) {
          usedMeshSet.add(cardMesh);
          cardMesh.updateCard(c, {
            width: cardWidth,
            height: cardHeight,
            faceUp: isCardFaceUp,
            backStyle: this.backStyle,
            owner: seat,
            isLocal,
            interactive: isCardInteractive,
            revealed: isOppRevealed
          });
          cardMesh.setTransform(posX, posY, posZ, pitch, yaw, -fanAngle, false);
        } else {
          cardMesh = new CardMesh3D(this.scene, this.BABYLON, c, {
            width: cardWidth,
            height: cardHeight,
            faceUp: isCardFaceUp,
            backStyle: this.backStyle,
            owner: seat,
            isLocal,
            interactive: isCardInteractive,
            revealed: isOppRevealed
          });
          cardMesh.rootNode.position.set(posX, posY, posZ);
          cardMesh.rootNode.rotation.set(pitch, yaw, -fanAngle);
          cardMesh._baseY = posY;
          usedMeshSet.add(cardMesh);
        }
        newHandMeshes.push(cardMesh);
      });
      existingMeshes.forEach((m) => {
        if (!usedMeshSet.has(m)) {
          try {
            m.dispose();
          } catch (_) {
          }
        }
      });
      this.playerHands.set(seat, newHandMeshes);
      return newHandMeshes;
    }
    /**
     * Renders all played pegging cards face up on the table directly in front of the player.
     * Spreads all played cards from left to right in chronological order between the player's
     * hand fan and the central board, completely clear of the board and face-up.
     * Reuses existing played card meshes to prevent allocation stalls during rapid pegging.
     * @param {Array<Object>} playedCards - Array of played cards or { who, card } entries
     * @param {Object} [options={}]
     */
    renderPlayPile(playedCards = [], options = {}) {
      if (!playedCards || !playedCards.length) {
        this.clearPlayPile();
        return;
      }
      const localSeat = options.localSeat || this.localSeat || "p1";
      const turnSeat = options.turnSeat || options.activeSeat || options.seat || localSeat;
      const isLocal = turnSeat === localSeat || turnSeat === "p1";
      const anchor = this.getSeatHandAnchor(turnSeat, isLocal);
      const count = playedCards.length;
      this.playPileTurnSeat = turnSeat;
      const cardW = 13.5;
      const cardH = 18.9;
      const sinA = Math.sin(anchor.angle);
      const cosA = Math.cos(anchor.angle);
      const centerDist = Math.hypot(anchor.posX, anchor.posZ);
      const inwardDist = Math.max(30, Math.min(42, centerDist * 0.42));
      const inwardX = -sinA * inwardDist;
      const inwardZ = cosA * inwardDist;
      const tanX = cosA;
      const tanZ = sinA;
      const cardSpacing = Math.min(5.2, 45 / Math.max(1, count));
      const existingById = /* @__PURE__ */ new Map();
      this.playPile.forEach((m) => {
        if (m && m.rootNode && !m.rootNode.isDisposed) {
          existingById.set(m.cardId, m);
        }
      });
      const newPlayPile = [];
      const usedMeshSet = /* @__PURE__ */ new Set();
      playedCards.forEach((item, idx) => {
        const cardData = item?.card || item;
        const who = item?.who || item?.owner || "p1";
        const spreadOffset = (idx - (count - 1) * 0.5) * cardSpacing;
        const posX = anchor.posX + inwardX + tanX * spreadOffset;
        const posZ = anchor.posZ + inwardZ + tanZ * spreadOffset;
        const posY = this.tableSurfaceY + 0.12 + idx * 0.06;
        const subtleRot = (idx * 17 % 5 - 2) * (Math.PI / 180);
        const targetRotYaw = anchor.yaw + subtleRot;
        const cId = cardData?.id || `${cardData?.rankName || cardData?.r || cardData?.rank || "A"}${cardData?.suit || cardData?.s || "S"}`;
        let cardMesh = existingById.get(cId);
        const wasFlippedDown = Boolean(
          cardData?.faceDown || item?.faceDown || cardMesh && cardMesh._wasTurnedDown || existingById.get(cId) && existingById.get(cId)._wasTurnedDown
        );
        const isFaceUp = wasFlippedDown ? false : options.faceUp !== void 0 ? Boolean(options.faceUp) : item?.faceUp !== void 0 ? Boolean(item.faceUp) : true;
        const rotY = isFaceUp ? 0 : Math.PI;
        if (cardMesh && !usedMeshSet.has(cardMesh)) {
          usedMeshSet.add(cardMesh);
          if (wasFlippedDown) {
            cardMesh._wasTurnedDown = true;
            if (cardMesh.faceUp && typeof cardMesh.flip === "function") {
              cardMesh.flip(false, 260);
            } else {
              cardMesh.setFaceUp(false);
            }
          } else if (cardMesh.faceUp !== isFaceUp && typeof cardMesh.flip === "function") {
            cardMesh.flip(isFaceUp, 260);
          } else {
            cardMesh.updateCard(cardData, {
              width: cardW,
              height: cardH,
              faceUp: isFaceUp,
              backStyle: this.backStyle,
              interactive: false,
              owner: who
            });
          }
          cardMesh.setTransform(posX, posY, posZ, Math.PI / 2, rotY, targetRotYaw, false);
        } else {
          cardMesh = new CardMesh3D(this.scene, this.BABYLON, cardData, {
            width: cardW,
            height: cardH,
            faceUp: isFaceUp,
            backStyle: this.backStyle,
            interactive: false,
            owner: who
          });
          if (wasFlippedDown) cardMesh._wasTurnedDown = true;
          cardMesh.rootNode.position.set(posX, posY, posZ);
          cardMesh.rootNode.rotation.set(Math.PI / 2, rotY, targetRotYaw);
          cardMesh._baseY = posY;
          usedMeshSet.add(cardMesh);
        }
        newPlayPile.push(cardMesh);
      });
      this.playPile.forEach((m) => {
        if (!usedMeshSet.has(m)) {
          try {
            m.dispose();
          } catch (_) {
          }
        }
      });
      this.playPile = newPlayPile;
    }
    /**
     * Renders the 3D cut starter card and deck stack on the table.
     * Placed to the right of the human player, clear of the central board.
     * Supports interactive deck cutting when isCuttable is true.
     * @param {Object} starterCardData
     * @param {Object} [options={}]
     */
    renderStarterDeck(starterCardData = null, options = {}) {
      const boardLeft = this.boardBounds?.min?.x != null ? this.boardBounds.min.x : -14;
      const boardBottom = this.boardBounds?.min?.z != null ? this.boardBounds.min.z : -8;
      const minTableLeft = -this.tableW / 2 + 8;
      const playerNearZ = -this.tableD / 2 + 10;
      const deckX = Math.min(boardLeft - 9, Math.max(minTableLeft + 16, -32));
      const deckZ = Math.min(-24, Math.max(playerNearZ, boardBottom - 16));
      const deckCardW = 13.5;
      const deckCardH = 18.9;
      const deckStackCount = 8;
      const isCuttable = Boolean(options.isCuttable);
      this.isCuttable = isCuttable;
      this.onCutStarter = options.onCut || null;
      const canReuseStack = Array.isArray(this.starterDeck) && this.starterDeck.length === deckStackCount && this.starterDeck.every((c) => c && c.rootNode && !c.rootNode.isDisposed);
      if (canReuseStack) {
        for (let i = 0; i < deckStackCount; i++) {
          const posY = this.tableSurfaceY + 0.12 + i * 0.22;
          const stackCard = this.starterDeck[i];
          stackCard.updateCard({ r: "A", s: "S" }, {
            width: deckCardW,
            height: deckCardH,
            faceUp: false,
            backStyle: this.backStyle,
            interactive: isCuttable,
            isDeck: true,
            owner: "deck",
            onClick: () => {
              if (isCuttable && typeof options.onCut === "function") {
                options.onCut();
              }
            }
          });
          stackCard.setTransform(deckX, posY, deckZ, -Math.PI / 2, 0, 0, false);
        }
      } else {
        if (Array.isArray(this.starterDeck)) {
          this.starterDeck.forEach((c) => {
            try {
              c.dispose();
            } catch (_) {
            }
          });
        }
        this.starterDeck = [];
        for (let i = 0; i < deckStackCount; i++) {
          const posY = this.tableSurfaceY + 0.12 + i * 0.22;
          const stackCard = new CardMesh3D(this.scene, this.BABYLON, { r: "A", s: "S" }, {
            width: deckCardW,
            height: deckCardH,
            faceUp: false,
            backStyle: this.backStyle,
            interactive: isCuttable,
            isDeck: true,
            owner: "deck",
            onClick: () => {
              if (isCuttable && typeof options.onCut === "function") {
                options.onCut();
              }
            }
          });
          stackCard.rootNode.position.set(deckX, posY, deckZ);
          stackCard.rootNode.rotation.set(-Math.PI / 2, 0, 0);
          stackCard._baseY = posY;
          this.starterDeck.push(stackCard);
        }
      }
      const starterList = Array.isArray(starterCardData) ? starterCardData.filter(Boolean) : Array.isArray(options.starters) && options.starters.length ? options.starters.filter(Boolean) : starterCardData ? [starterCardData] : [];
      const existingCutById = /* @__PURE__ */ new Map();
      (this.starterCards || []).forEach((m) => {
        if (m && m.rootNode && !m.rootNode.isDisposed) {
          existingCutById.set(m.cardId, m);
        }
      });
      const newStarterCards = [];
      const usedCutSet = /* @__PURE__ */ new Set();
      if (starterList.length > 0) {
        const count = starterList.length;
        const isRevealed = options.starterFace !== false;
        const cutBaseY = this.tableSurfaceY + 0.12 + deckStackCount * 0.22 + 0.08;
        const spacingX = count > 1 ? Math.min(8.5, 26 / Math.max(1, count - 1)) : 0;
        starterList.forEach((cardData, idx) => {
          const offsetIdx = count > 1 ? idx - (count - 1) / 2 : 0;
          const posX = count > 1 ? deckX + offsetIdx * spacingX : deckX;
          const posY = cutBaseY + idx * 0.05;
          const posZ = count > 1 ? deckZ - Math.abs(offsetIdx) * 0.4 : deckZ;
          const rotY = count > 1 ? offsetIdx * -0.06 : 0;
          const rotX = isRevealed ? Math.PI / 2 : -Math.PI / 2;
          const cId = cardData?.id || `${cardData?.rankName || cardData?.r || cardData?.rank || "A"}${cardData?.suit || cardData?.s || "S"}`;
          let cutCard = existingCutById.get(cId);
          if (cutCard && !usedCutSet.has(cutCard)) {
            usedCutSet.add(cutCard);
            cutCard.updateCard({ ...cardData, isCut: true }, {
              width: deckCardW,
              height: deckCardH,
              faceUp: isRevealed,
              backStyle: this.backStyle,
              interactive: false,
              isCutStarter: true,
              cutIndex: idx
            });
            cutCard.setTransform(posX, posY, posZ, rotX, rotY, 0, false);
          } else {
            cutCard = new CardMesh3D(this.scene, this.BABYLON, { ...cardData, isCut: true }, {
              width: deckCardW,
              height: deckCardH,
              faceUp: isRevealed,
              backStyle: this.backStyle,
              interactive: false,
              isCutStarter: true,
              cutIndex: idx
            });
            cutCard.rootNode.position.set(posX, posY, posZ);
            cutCard.rootNode.rotation.set(rotX, rotY, 0);
            cutCard._baseY = posY;
            usedCutSet.add(cutCard);
            if (!isRevealed) {
              setTimeout(() => {
                if (cutCard && cutCard.rootNode && !cutCard.rootNode.isDisposed) {
                  cutCard.setFaceUp(true);
                  const rotUp = new this.BABYLON.Vector3(Math.PI / 2, rotY, 0);
                  cutCard.animateTo(cutCard.rootNode.position.clone(), rotUp, 260 + idx * 90);
                }
              }, 280);
            }
          }
          newStarterCards.push(cutCard);
        });
      }
      (this.starterCards || []).forEach((m) => {
        if (!usedCutSet.has(m)) {
          try {
            m.dispose();
          } catch (_) {
          }
        }
      });
      this.starterCards = newStarterCards;
      this.starterCard = this.starterCards[0] || null;
      if (isCuttable && starterList.length === 0) {
        const promptText = options.cutCount && options.cutCount > 1 ? `\u2702\uFE0F Cut ${options.cutCount} Cards` : "\u2702\uFE0F Cut Deck";
        if (!this.cutPrompt || !this.cutPrompt.mesh || this.cutPrompt.mesh.isDisposed) {
          this.createCutPrompt(deckX, this.tableSurfaceY + 7.5, deckZ, options.onCut, promptText);
        } else {
          if (this.cutPrompt.mesh.metadata) {
            this.cutPrompt.mesh.metadata.onClick = options.onCut;
          }
        }
      } else {
        this.clearCutPrompt();
      }
    }
    /**
     * Creates a floating 3D billboard cut prompt badge above the starter deck.
     * @param {number} x
     * @param {number} y
     * @param {number} z
     * @param {Function} [onCut]
     * @param {string} [promptText='✂️ Cut Deck']
     */
    createCutPrompt(x, y, z, onCut = null, promptText = "\u2702\uFE0F Cut Deck") {
      this.clearCutPrompt();
      if (!this.scene || !this.BABYLON || !this.BABYLON.MeshBuilder) return;
      try {
        const promptNode = new this.BABYLON.TransformNode("cutDeckPromptNode", this.scene);
        promptNode.position.set(x, y, z);
        const planeWidth = Math.max(18, promptText.length * 1.35 + 2);
        const plane = this.BABYLON.MeshBuilder.CreatePlane("cutDeckPromptMesh", {
          width: planeWidth,
          height: 5.5,
          sideOrientation: this.BABYLON.Mesh.DOUBLESIDE || 2
        }, this.scene);
        plane.parent = promptNode;
        plane.billboardMode = this.BABYLON.Mesh.BILLBOARDMODE_ALL || 7;
        plane.isPickable = true;
        let tex = null;
        if (this.BABYLON.DynamicTexture) {
          const texW = 512;
          const texH = 128;
          tex = new this.BABYLON.DynamicTexture("texCutDeckPrompt", { width: texW, height: texH }, this.scene, true);
          tex.hasAlpha = true;
          const ctx = tex.getContext ? tex.getContext() : null;
          if (ctx) {
            ctx.clearRect(0, 0, texW, texH);
            ctx.fillStyle = "#0f172a";
            ctx.beginPath();
            if (typeof ctx.roundRect === "function") ctx.roundRect(10, 10, texW - 20, texH - 20, 54);
            else ctx.rect(10, 10, texW - 20, texH - 20);
            ctx.fill();
            ctx.strokeStyle = "#f59e0b";
            ctx.lineWidth = 8;
            ctx.stroke();
            ctx.fillStyle = "#ffffff";
            ctx.font = 'bold 44px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(promptText, texW / 2, texH / 2);
            if (typeof tex.update === "function") tex.update();
          }
        }
        let mat = null;
        if (this.BABYLON.PBRMaterial) {
          mat = new this.BABYLON.PBRMaterial("matCutDeckPrompt", this.scene);
          if (tex) {
            mat.albedoTexture = tex;
            mat.useAlphaFromAlbedoTexture = true;
          }
          mat.unlit = true;
          mat.roughness = 0.3;
          mat.backFaceCulling = false;
          plane.material = mat;
        } else if (this.BABYLON.StandardMaterial) {
          mat = new this.BABYLON.StandardMaterial("matCutDeckPrompt", this.scene);
          if (tex) {
            mat.diffuseTexture = tex;
            mat.emissiveTexture = tex;
            mat.opacityTexture = tex;
          }
          mat.disableLighting = true;
          mat.backFaceCulling = false;
          plane.material = mat;
        }
        plane.metadata = {
          isCutPrompt: true,
          onClick: onCut
        };
        const startY = y;
        const startTime = performance.now();
        let bobObserver = null;
        if (this.scene.onBeforeRenderObservable && typeof this.scene.onBeforeRenderObservable.add === "function") {
          bobObserver = this.scene.onBeforeRenderObservable.add(() => {
            if (!promptNode || !promptNode.position) return;
            const elapsed = (performance.now() - startTime) / 1e3;
            promptNode.position.y = startY + Math.sin(elapsed * 4.2) * 0.45;
          });
        }
        this.cutPrompt = {
          node: promptNode,
          mesh: plane,
          mat,
          tex,
          observer: bobObserver
        };
      } catch (_) {
      }
    }
    /**
     * Cleans up the floating 3D cut prompt badge.
     */
    clearCutPrompt() {
      if (this.cutPrompt) {
        if (this.cutPrompt.observer && this.scene?.onBeforeRenderObservable) {
          this.scene.onBeforeRenderObservable.remove(this.cutPrompt.observer);
        }
        if (this.cutPrompt.mesh && typeof this.cutPrompt.mesh.dispose === "function") this.cutPrompt.mesh.dispose();
        if (this.cutPrompt.mat && typeof this.cutPrompt.mat.dispose === "function") this.cutPrompt.mat.dispose();
        if (this.cutPrompt.tex && typeof this.cutPrompt.tex.dispose === "function") this.cutPrompt.tex.dispose();
        if (this.cutPrompt.node && typeof this.cutPrompt.node.dispose === "function") this.cutPrompt.node.dispose();
        this.cutPrompt = null;
      }
    }
    /**
     * Animates cutting the 3D deck: separates top cut packet, slides laterally, and reassembles.
     * @param {Function} [onComplete]
     */
    animateDeckCut(onComplete = null) {
      if (!this.starterDeck || this.starterDeck.length < 4) {
        if (typeof onComplete === "function") onComplete();
        return;
      }
      const cutPacket = this.starterDeck.slice(4);
      const lateralShift = 7;
      const liftY = 3.6;
      cutPacket.forEach((cardMesh, idx) => {
        const curPos = cardMesh.rootNode.position && typeof cardMesh.rootNode.position.clone === "function" ? cardMesh.rootNode.position.clone() : { x: cardMesh.rootNode.position?.x || 0, y: cardMesh.rootNode.position?.y || 0, z: cardMesh.rootNode.position?.z || 0 };
        const curRot = cardMesh.rootNode.rotation && typeof cardMesh.rootNode.rotation.clone === "function" ? cardMesh.rootNode.rotation.clone() : { x: cardMesh.rootNode.rotation?.x || 0, y: cardMesh.rootNode.rotation?.y || 0, z: cardMesh.rootNode.rotation?.z || 0 };
        const targetUp = new this.BABYLON.Vector3(curPos.x + lateralShift, curPos.y + liftY, curPos.z + 1.2);
        cardMesh.animateTo(targetUp, curRot, 220, () => {
          const targetDown = new this.BABYLON.Vector3(curPos.x + lateralShift, this.tableSurfaceY + 0.12 + idx * 0.22, curPos.z + 1.2);
          cardMesh.animateTo(targetDown, curRot, 180, () => {
            setTimeout(() => {
              const targetFinal = new this.BABYLON.Vector3(curPos.x, curPos.y, curPos.z);
              cardMesh.animateTo(targetFinal, curRot, 240, () => {
                if (idx === cutPacket.length - 1 && typeof onComplete === "function") {
                  onComplete();
                }
              });
            }, 350);
          });
        });
      });
    }
    /**
     * Renders the initial deal cut fan across the table for game start cut-for-deal.
     * @param {Array<Object>} cutDeck
     * @param {Object} cutPicks
     * @param {Object} [options={}]
     */
    renderCutDeckFan(cutDeck = [], cutPicks = {}, options = {}) {
      if (!cutDeck || !cutDeck.length) {
        this.clearCutDeckFan();
        return;
      }
      const count = cutDeck.length;
      const isMyCut = Boolean(options.isMyCut);
      const boardRight = this.boardBounds?.max?.x != null ? this.boardBounds.max.x : 28;
      const boardBottom = this.boardBounds?.min?.z != null ? this.boardBounds.min.z : -15;
      const maxTableRight = this.tableW / 2 - 8;
      const playerNearZ = -this.tableD / 2 + 12;
      let startX, endX, spanX, fanZ;
      if (isMyCut) {
        spanX = Math.min(36, Math.max(22, count * 1.4));
        startX = -spanX / 2;
        endX = spanX / 2;
        fanZ = Math.min(-24, Math.max(playerNearZ + 8, boardBottom - 18));
        const midIdx = Math.floor(count / 2);
        this.createCutPrompt(0, this.tableSurfaceY + 7.5, fanZ - 5.5, () => {
          if (typeof options.onPickCut === "function") {
            options.onPickCut(midIdx);
          }
        }, "\u2702\uFE0F Cut the Deck");
      } else {
        this.clearCutPrompt();
        startX = Math.max(28, Math.min(maxTableRight - 28, boardRight + 6));
        endX = Math.min(maxTableRight, startX + 30);
        spanX = endX - startX;
        fanZ = Math.min(-34, Math.max(playerNearZ, boardBottom - 16));
      }
      const existingById = /* @__PURE__ */ new Map();
      (this.cutDeckFan || []).forEach((m) => {
        if (m && m.rootNode && !m.rootNode.isDisposed) {
          existingById.set(m.cardId, m);
        }
      });
      const newCutDeckFan = [];
      const usedMeshSet = /* @__PURE__ */ new Set();
      cutDeck.forEach((card, idx) => {
        const pickedEntry = Object.entries(cutPicks).find(([_, p]) => p && p.id === card.id);
        const isPicked = Boolean(pickedEntry);
        const pickedSeat = pickedEntry ? pickedEntry[0] : null;
        const norm = count > 1 ? idx / (count - 1) : 0.5;
        const posX = startX + norm * spanX;
        const posY = this.tableSurfaceY + 0.12 + idx * 0.015;
        const posZ = fanZ + Math.sin(norm * Math.PI) * 2.8;
        let targetX, targetY, targetZ, targetRotPitch, targetRotYaw, targetRotRoll;
        if (isPicked && pickedSeat) {
          const isLocal = pickedSeat === "p1";
          const anchor = this.getSeatHandAnchor(pickedSeat, isLocal);
          const sinA = Math.sin(anchor.angle);
          const cosA = Math.cos(anchor.angle);
          const inwardDist = 12;
          targetX = anchor.posX - sinA * inwardDist;
          targetY = this.tableSurfaceY + 0.35;
          targetZ = anchor.posZ + cosA * inwardDist;
          targetRotPitch = Math.PI / 2;
          targetRotYaw = 0;
          targetRotRoll = anchor.yaw;
        } else {
          targetX = posX;
          targetY = posY;
          targetZ = posZ;
          targetRotPitch = -Math.PI / 2;
          targetRotYaw = 0;
          targetRotRoll = (norm - 0.5) * 0.35;
        }
        const cId = card?.id || `${card?.rankName || card?.r || card?.rank || "A"}${card?.suit || card?.s || "S"}`;
        let cardMesh = existingById.get(cId);
        const cardOpts = {
          faceUp: isPicked,
          backStyle: this.backStyle,
          interactive: !isPicked && isMyCut,
          isCutFan: true,
          cutIndex: idx,
          onClick: () => {
            if (!isPicked && isMyCut && typeof options.onPickCut === "function") {
              options.onPickCut(idx);
            }
          }
        };
        if (cardMesh && !usedMeshSet.has(cardMesh)) {
          usedMeshSet.add(cardMesh);
          cardMesh.updateCard(card, cardOpts);
          cardMesh.setTransform(targetX, targetY, targetZ, targetRotPitch, targetRotYaw, targetRotRoll, true, 380);
        } else {
          cardMesh = new CardMesh3D(this.scene, this.BABYLON, card, cardOpts);
          cardMesh.rootNode.position.set(targetX, targetY, targetZ);
          cardMesh.rootNode.rotation.set(targetRotPitch, targetRotYaw, targetRotRoll);
          cardMesh._baseY = targetY;
          usedMeshSet.add(cardMesh);
        }
        newCutDeckFan.push(cardMesh);
      });
      (this.cutDeckFan || []).forEach((m) => {
        if (!usedMeshSet.has(m)) {
          try {
            m.dispose();
          } catch (_) {
          }
        }
      });
      this.cutDeckFan = newCutDeckFan;
    }
    /**
     * Clears the initial deal cut fan.
     */
    clearCutDeckFan() {
      this.clearCutPrompt();
      if (this.cutDeckFan) {
        this.cutDeckFan.forEach((c) => c.dispose());
        this.cutDeckFan = [];
      }
    }
    /**
     * Renders the 4-card crib stack in the crib zone.
     * Placed to the left of the human player, clear of the central board.
     * @param {Array<Object>} cribCards
     * @param {boolean} [isRevealed=false]
     */
    renderCrib(cribCards = [], isRevealed = false) {
      if (!cribCards || !cribCards.length) {
        this.clearCrib();
        return;
      }
      const boardLeft = this.boardBounds?.min?.x != null ? this.boardBounds.min.x : -14;
      const boardBottom = this.boardBounds?.min?.z != null ? this.boardBounds.min.z : -8;
      const minTableLeft = -this.tableW / 2 + 8;
      const playerNearZ = -this.tableD / 2 + 10;
      const deckX = Math.min(boardLeft - 9, Math.max(minTableLeft + 16, -32));
      const deckZ = Math.min(-24, Math.max(playerNearZ, boardBottom - 16));
      const cribX = Math.min(deckX - 16, Math.max(minTableLeft + 2, deckX - 18));
      const cribZ = deckZ;
      const cardW = 13.5;
      const cardH = 18.9;
      const existingById = /* @__PURE__ */ new Map();
      (this.cribCards || []).forEach((m) => {
        if (m && m.rootNode && !m.rootNode.isDisposed) {
          existingById.set(m.cardId, m);
        }
      });
      const newCribCards = [];
      const usedMeshSet = /* @__PURE__ */ new Set();
      cribCards.forEach((c, idx) => {
        const posY = this.tableSurfaceY + 0.12 + idx * 0.22;
        const rotZ = isRevealed ? idx * 0.12 - 0.18 : idx * 0.04;
        const posX = cribX + (isRevealed ? (idx - 1.5) * 5 : 0);
        const rotPitch = isRevealed ? Math.PI / 2 : -Math.PI / 2;
        const cId = c?.id || `${c?.rankName || c?.r || c?.rank || "A"}${c?.suit || c?.s || "S"}`;
        let cardMesh = existingById.get(cId);
        const cardOpts = {
          width: cardW,
          height: cardH,
          faceUp: isRevealed,
          backStyle: this.backStyle,
          interactive: false,
          isLocal: false,
          owner: "crib"
        };
        if (cardMesh && !usedMeshSet.has(cardMesh)) {
          usedMeshSet.add(cardMesh);
          cardMesh.updateCard(c, cardOpts);
          cardMesh.setTransform(posX, posY, cribZ, rotPitch, 0, rotZ, false);
        } else {
          cardMesh = new CardMesh3D(this.scene, this.BABYLON, c, cardOpts);
          cardMesh.rootNode.position.set(posX, posY, cribZ);
          cardMesh.rootNode.rotation.set(rotPitch, 0, rotZ);
          cardMesh._baseY = posY;
          usedMeshSet.add(cardMesh);
        }
        newCribCards.push(cardMesh);
      });
      (this.cribCards || []).forEach((m) => {
        if (!usedMeshSet.has(m)) {
          try {
            m.dispose();
          } catch (_) {
          }
        }
      });
      this.cribCards = newCribCards;
    }
    /**
     * Clears cards for a specific hand.
     */
    clearHand(seat) {
      const hand = this.playerHands.get(seat);
      if (hand) {
        hand.forEach((c) => c.dispose());
        this.playerHands.delete(seat);
      }
    }
    /**
     * Turns all cards currently in the play pile face down out of the way.
     */
    turnPlayPileFaceDown() {
      if (!this.playPile || !this.playPile.length) return;
      this.playPile.forEach((m) => {
        if (m && m.rootNode && !m.rootNode.isDisposed) {
          m._wasTurnedDown = true;
          if (m.card) m.card.faceDown = true;
          if (m.options) m.options.faceUp = false;
          if (typeof m.flip === "function" && m.faceUp) {
            m.flip(false, 280);
          } else if (typeof m.setFaceUp === "function") {
            m.setFaceUp(false);
          }
        }
      });
    }
    /**
     * Animates face-down played cards sweeping out of the way before clearing.
     */
    sweepPlayPile() {
      if (!this.playPile || !this.playPile.length) return;
      this.playPile.forEach((m) => {
        if (m && m.rootNode && !m.rootNode.isDisposed && this.BABYLON) {
          const curPos = m.rootNode.position.clone ? m.rootNode.position.clone() : { x: m.rootNode.position.x, y: m.rootNode.position.y, z: m.rootNode.position.z };
          const targetPos = new this.BABYLON.Vector3(curPos.x + 20, (curPos.y || 0) - 0.2, (curPos.z || 0) + (curPos.z >= 0 ? 12 : -12));
          const curRot = m.rootNode.rotation.clone ? m.rootNode.rotation.clone() : { x: m.rootNode.rotation.x, y: m.rootNode.rotation.y, z: m.rootNode.rotation.z };
          const targetRot = new this.BABYLON.Vector3(curRot.x, curRot.y, (curRot.z || 0) + 0.25);
          if (typeof m.animateTo === "function") {
            m.animateTo(targetPos, targetRot, 480);
          }
        }
      });
    }
    /**
     * Clears the play pile.
     */
    clearPlayPile() {
      this.playPile.forEach((c) => c.dispose());
      this.playPile = [];
    }
    /**
     * Clears the starter deck, cut prompt, and cut card(s).
     */
    clearStarterDeck() {
      this.clearCutPrompt();
      this.starterDeck.forEach((c) => c.dispose());
      this.starterDeck = [];
      if (this.starterCards && this.starterCards.length) {
        this.starterCards.forEach((c) => c && typeof c.dispose === "function" && c.dispose());
        this.starterCards = [];
      }
      if (this.starterCard) {
        this.starterCard.dispose();
        this.starterCard = null;
      }
    }
    /**
     * Clears the crib stack.
     */
    clearCrib() {
      this.cribCards.forEach((c) => c.dispose());
      this.cribCards = [];
    }
    /**
     * Clears all cards in the entire 3D scene.
     */
    clearAll() {
      this.playerHands.forEach((hand) => hand.forEach((c) => c.dispose()));
      this.playerHands.clear();
      this.clearPlayPile();
      this.clearStarterDeck();
      this.clearCutDeckFan();
      this.clearCrib();
    }
    /**
     * Disposes the card engine and pointer listeners.
     */
    dispose() {
      this.clearAll();
      this.clearCutPrompt();
      if (this.pointerObserver && this.scene) {
        this.scene.onPointerObservable.remove(this.pointerObserver);
        this.pointerObserver = null;
      }
      CardMesh3D.clearTextureCache();
    }
  };

  // src/board/SeatManager3D.js
  var PlayerAvatar3D = class {
    /**
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {string} seat - 'p1', 'p2', etc.
     * @param {Object} playerData - { name, avatarId, color, score, isTurn }
     * @param {Object} options - { chairRoot, seatIndex, dims }
     */
    constructor(scene, BABYLON, seat, playerData = {}, options = {}) {
      this.scene = scene;
      this.BABYLON = BABYLON;
      this.seat = seat || "p1";
      this.seatIndex = options.seatIndex ?? 0;
      this.chairRoot = options.chairRoot || null;
      this.dims = options.dims || {};
      this.playerData = {
        id: seat,
        name: playerData.name || (seat === "p1" ? "You" : `Player ${this.seatIndex + 1}`),
        avatarId: playerData.avatarId || playerData.avatar || (seat === "p1" ? "joker" : "king"),
        color: playerData.color || (seat === "p1" ? "#3b82f6" : "#ef4444"),
        score: Number(playerData.score || 0),
        isTurn: Boolean(playerData.isTurn),
        isDealer: Boolean(playerData.isDealer)
      };
      const isComputer = Boolean(
        options.isComputer !== void 0 ? options.isComputer : playerData.isComputer || playerData.isCpu || playerData.type === "computer" || playerData.type === "cpu" || this.seat !== "p1"
      );
      this.isComputer = isComputer;
      this.isTransparent = Boolean(options.isTransparent !== void 0 ? options.isTransparent : this.isComputer);
      this.transparencyAlpha = options.transparencyAlpha ?? (this.isTransparent ? 0.6 : 1);
      this.wrapAvatarOnHead = Boolean(options.wrapAvatarOnHead !== void 0 ? options.wrapAvatarOnHead : this.isComputer);
      this.rootNode = null;
      this.torsoMesh = null;
      this.headMesh = null;
      this.collarMesh = null;
      this.armMeshes = [];
      this.faceCameoMesh = null;
      this.turnHaloMesh = null;
      this.nameplateMesh = null;
      this.nameplateTexture = null;
      this.reactionBubbleMesh = null;
      this.reactionTexture = null;
      this.reactionMaterial = null;
      this.faceCameoTexture = null;
      this.headWrapTexture = null;
      this.visible = options.visible !== false;
      this.materials = [];
      this.textures = [];
      this.idleObserver = null;
      this._reactionTimeout = null;
      this.buildAvatar();
      if (!this.visible) {
        this.setVisible(false);
      }
    }
    /**
     * Builds the complete stylized 3D seated figure, face cameo or head wrap, turn halo, and floating HUD plaque.
     */
    buildAvatar() {
      const { scene, BABYLON } = this;
      const seat = this.seat;
      const avatarInfo = AvatarManager?.getAvatarById?.(this.playerData.avatarId) || PRESET_AVATARS[0] || {};
      const badgeColorHex = avatarInfo.badgeColor || this.playerData.color || "#3b82f6";
      const badgeColor = this.hexToColor3(badgeColorHex);
      this.rootNode = new BABYLON.TransformNode(`avatarRoot_${seat}`, scene);
      if (this.chairRoot) {
        this.rootNode.parent = this.chairRoot;
      }
      const floorY = this.dims.floorY ?? -110;
      const seatElev = this.dims.seatElev ?? 72;
      const seatH = this.dims.seatH ?? 12;
      const seatSurfaceY = floorY + seatElev + seatH / 2;
      this.rootNode.position.set(0, seatSurfaceY, -14);
      const doubleSide = BABYLON.Mesh && BABYLON.Mesh.DOUBLESIDE != null ? BABYLON.Mesh.DOUBLESIDE : 2;
      this.torsoMesh = BABYLON.MeshBuilder.CreateBox(`torso_${seat}`, {
        width: 64,
        height: 56,
        depth: 32
      }, scene);
      this.torsoMesh.position.set(0, 28, 0);
      this.torsoMesh.parent = this.rootNode;
      this.torsoMesh.receiveShadows = true;
      const torsoMat = new BABYLON.PBRMaterial(`matTorso_${seat}`, scene);
      torsoMat.albedoColor = badgeColor;
      torsoMat.roughness = 0.65;
      torsoMat.metallic = 0.05;
      if (this.isTransparent) {
        torsoMat.alpha = Math.min(this.transparencyAlpha, 0.55);
        if (BABYLON.PBRMaterial?.PBRMATERIAL_ALPHABLEND != null) {
          torsoMat.transparencyMode = BABYLON.PBRMaterial.PBRMATERIAL_ALPHABLEND;
        }
        torsoMat.backFaceCulling = true;
        this.torsoMesh.visibility = Math.min(this.transparencyAlpha, 0.6);
      }
      this.torsoMesh.material = torsoMat;
      this.materials.push(torsoMat);
      const collarMesh = BABYLON.MeshBuilder.CreateCylinder(`collar_${seat}`, {
        diameter: 24,
        height: 6,
        tessellation: 18
      }, scene);
      collarMesh.position.set(0, 58, 0);
      collarMesh.parent = this.rootNode;
      this.collarMesh = collarMesh;
      const collarMat = new BABYLON.PBRMaterial(`matCollar_${seat}`, scene);
      collarMat.albedoColor = new BABYLON.Color3(0.92, 0.78, 0.32);
      collarMat.metallic = 0.88;
      collarMat.roughness = 0.25;
      if (this.isTransparent) {
        collarMat.alpha = Math.min(this.transparencyAlpha + 0.1, 0.7);
        if (BABYLON.PBRMaterial?.PBRMATERIAL_ALPHABLEND != null) {
          collarMat.transparencyMode = BABYLON.PBRMaterial.PBRMATERIAL_ALPHABLEND;
        }
        collarMesh.visibility = Math.min(this.transparencyAlpha + 0.1, 0.7);
      }
      collarMesh.material = collarMat;
      this.materials.push(collarMat);
      this.headMesh = BABYLON.MeshBuilder.CreateSphere(`head_${seat}`, {
        diameter: 36,
        segments: 20
      }, scene);
      this.headMesh.position.set(0, 78, 0);
      this.headMesh.parent = this.rootNode;
      if (this.headMesh.rotation) {
        this.headMesh.rotation.y = Math.PI / 2;
      }
      const headMat = new BABYLON.PBRMaterial(`matHead_${seat}`, scene);
      headMat.albedoColor = new BABYLON.Color3(0.93, 0.85, 0.78);
      headMat.roughness = 0.38;
      headMat.metallic = 0.05;
      if (this.isTransparent) {
        headMat.alpha = this.transparencyAlpha;
        if (BABYLON.PBRMaterial?.PBRMATERIAL_ALPHABLEND != null) {
          headMat.transparencyMode = BABYLON.PBRMaterial.PBRMATERIAL_ALPHABLEND;
        }
        headMat.backFaceCulling = false;
        this.headMesh.visibility = this.transparencyAlpha;
      }
      this.headMesh.material = headMat;
      this.materials.push(headMat);
      this.faceCameoMesh = BABYLON.MeshBuilder.CreatePlane(`faceCameo_${seat}`, {
        width: 28,
        height: 28,
        sideOrientation: doubleSide
      }, scene);
      this.faceCameoMesh.position.set(0, 78, 18.2);
      this.faceCameoMesh.parent = this.rootNode;
      if (this.faceCameoMesh.rotation) {
        this.faceCameoMesh.rotation.y = Math.PI;
      }
      const faceMat = new BABYLON.PBRMaterial(`matFaceCameo_${seat}`, scene);
      faceMat.roughness = 0.3;
      faceMat.metallic = 0.05;
      faceMat.backFaceCulling = false;
      this.faceCameoMesh.material = faceMat;
      this.materials.push(faceMat);
      if (this.wrapAvatarOnHead) {
        this.faceCameoMesh.isVisible = false;
        this.applyHeadWrapTexture(headMat, avatarInfo);
      } else {
        this.applyAvatarFaceTexture(faceMat, avatarInfo);
      }
      this.armMeshes = [];
      [-36, 36].forEach((ax, aIdx) => {
        const arm = BABYLON.MeshBuilder.CreateBox(`arm_${seat}_${aIdx}`, {
          width: 10,
          height: 32,
          depth: 30
        }, scene);
        arm.position.set(ax, 24, 6);
        arm.parent = this.rootNode;
        arm.material = torsoMat;
        arm.receiveShadows = true;
        if (this.isTransparent) {
          arm.visibility = Math.min(this.transparencyAlpha, 0.6);
        }
        this.armMeshes.push(arm);
        const hand = BABYLON.MeshBuilder.CreateBox(`hand_${seat}_${aIdx}`, {
          width: 9,
          height: 9,
          depth: 16
        }, scene);
        hand.position.set(ax, 9, 24);
        hand.parent = this.rootNode;
        hand.material = headMat;
        if (this.isTransparent) {
          hand.visibility = Math.min(this.transparencyAlpha, 0.6);
        }
        this.armMeshes.push(hand);
      });
      const haloMesh = BABYLON.MeshBuilder.CreateTorus ? BABYLON.MeshBuilder.CreateTorus(`turnHalo_${seat}`, { diameter: 40, thickness: 3.4, tessellation: 24 }, scene) : BABYLON.MeshBuilder.CreateCylinder(`turnHalo_${seat}`, { diameter: 40, height: 3.4, tessellation: 24 }, scene);
      haloMesh.position.set(0, 101, 0);
      haloMesh.parent = this.rootNode;
      haloMesh.isVisible = this.playerData.isTurn;
      const haloMat = new BABYLON.PBRMaterial(`matHalo_${seat}`, scene);
      haloMat.albedoColor = new BABYLON.Color3(1, 0.85, 0.2);
      haloMat.emissiveColor = new BABYLON.Color3(1, 0.78, 0.15);
      haloMat.metallic = 0.9;
      haloMat.roughness = 0.2;
      haloMesh.material = haloMat;
      this.turnHaloMesh = haloMesh;
      this.materials.push(haloMat);
      this.nameplateMesh = BABYLON.MeshBuilder.CreatePlane(`nameplate_${seat}`, {
        width: 68,
        height: 24,
        sideOrientation: doubleSide
      }, scene);
      this.nameplateMesh.position.set(0, 120, 0);
      this.nameplateMesh.parent = this.rootNode;
      this.nameplateMesh.billboardMode = BABYLON.Mesh && BABYLON.Mesh.BILLBOARDMODE_ALL != null ? BABYLON.Mesh.BILLBOARDMODE_ALL : 7;
      const nameplateMat = new BABYLON.PBRMaterial(`matNameplate_${seat}`, scene);
      nameplateMat.roughness = 0.35;
      nameplateMat.metallic = 0.05;
      nameplateMat.backFaceCulling = false;
      this.nameplateMesh.material = nameplateMat;
      this.materials.push(nameplateMat);
      this.updateNameplateTexture(nameplateMat);
      this.reactionBubbleMesh = BABYLON.MeshBuilder.CreatePlane(`reactionBubble_${seat}`, {
        width: 36,
        height: 36,
        sideOrientation: doubleSide
      }, scene);
      this.reactionBubbleMesh.position.set(0, 142, 0);
      this.reactionBubbleMesh.parent = this.rootNode;
      this.reactionBubbleMesh.isVisible = false;
      this.reactionBubbleMesh.billboardMode = BABYLON.Mesh && BABYLON.Mesh.BILLBOARDMODE_ALL != null ? BABYLON.Mesh.BILLBOARDMODE_ALL : 7;
      this.startIdleAnimation();
    }
    /**
     * Applies the avatar face texture or draws a stylized circular cameo.
     * @param {BABYLON.PBRMaterial} faceMat
     * @param {Object} avatarInfo
     */
    async applyAvatarFaceTexture(faceMat, avatarInfo) {
      const { scene, BABYLON } = this;
      if (!BABYLON || !BABYLON.DynamicTexture) return;
      try {
        let tex = this.faceCameoTexture;
        if (!tex || typeof tex.isDisposed === "function" && tex.isDisposed()) {
          tex = new BABYLON.DynamicTexture(`texFaceCameo_${this.seat}`, { width: 256, height: 256 }, scene, false);
          this.faceCameoTexture = tex;
          this.textures.push(tex);
        }
        const ctx = tex.getContext();
        if (!ctx) return;
        const w = 256;
        const h = 256;
        const r = 120;
        ctx.clearRect(0, 0, w, h);
        ctx.save();
        ctx.beginPath();
        ctx.arc(w / 2, h / 2, r, 0, Math.PI * 2);
        ctx.clip();
        let drawn = false;
        if (typeof AvatarManager?.createAvatarCanvas === "function") {
          const c = await AvatarManager.createAvatarCanvas(this.playerData.avatarId, 256, 256);
          if (c && ctx.drawImage) {
            ctx.drawImage(c, 0, 0, w, h);
            drawn = true;
          }
        }
        if (!drawn) {
          ctx.fillStyle = avatarInfo.badgeColor || this.playerData.color || "#3b82f6";
          ctx.fillRect(0, 0, w, h);
          ctx.fillStyle = "#ffffff";
          ctx.font = 'bold 110px "Segoe UI", Roboto, sans-serif';
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          const initial = (this.playerData.name || this.seat).charAt(0).toUpperCase();
          ctx.fillText(initial, w / 2, h / 2 + 8);
        }
        ctx.restore();
        ctx.strokeStyle = "#f59e0b";
        ctx.lineWidth = 10;
        ctx.beginPath();
        ctx.arc(w / 2, h / 2, r - 5, 0, Math.PI * 2);
        ctx.stroke();
        tex.update();
        if (faceMat.albedoTexture && faceMat.albedoTexture !== tex) {
          try {
            faceMat.albedoTexture.dispose();
          } catch (_) {
          }
        }
        faceMat.albedoTexture = tex;
      } catch (_) {
      }
    }
    /**
     * Generates a 360-degree panoramic spherical head texture wrapping the avatar portrait
     * across the front of the head with stylized hair/crown and side/back trims.
     * @param {BABYLON.PBRMaterial} headMat
     * @param {Object} avatarInfo
     */
    async applyHeadWrapTexture(headMat, avatarInfo = {}) {
      const { scene, BABYLON } = this;
      if (!BABYLON || !BABYLON.DynamicTexture) return;
      try {
        const w = 512;
        const h = 256;
        let tex = this.headWrapTexture;
        if (!tex || typeof tex.isDisposed === "function" && tex.isDisposed()) {
          tex = new BABYLON.DynamicTexture(`texHeadWrap_${this.seat}`, { width: w, height: h }, scene, false);
          tex.vScale = -1;
          tex.vOffset = 1;
          this.headWrapTexture = tex;
          this.textures.push(tex);
        }
        const ctx = tex.getContext();
        if (!ctx) return;
        const badgeColorHex = avatarInfo.badgeColor || this.playerData.color || "#3b82f6";
        ctx.clearRect(0, 0, w, h);
        const bgGrad = ctx.createLinearGradient(0, 0, 0, h);
        if (this.isTransparent) {
          bgGrad.addColorStop(0, "rgba(15, 23, 42, 0.7)");
          bgGrad.addColorStop(0.3, this.hexToRgba(badgeColorHex, 0.65));
          bgGrad.addColorStop(0.55, "rgba(248, 250, 252, 0.75)");
          bgGrad.addColorStop(0.85, this.hexToRgba(badgeColorHex, 0.65));
          bgGrad.addColorStop(1, "rgba(15, 23, 42, 0.7)");
        } else {
          bgGrad.addColorStop(0, "#0f172a");
          bgGrad.addColorStop(0.3, badgeColorHex);
          bgGrad.addColorStop(0.55, "#f8fafc");
          bgGrad.addColorStop(0.85, badgeColorHex);
          bgGrad.addColorStop(1, "#0f172a");
        }
        ctx.fillStyle = bgGrad;
        ctx.fillRect(0, 0, w, h);
        ctx.save();
        ctx.fillStyle = this.isTransparent ? "rgba(255, 255, 255, 0.3)" : "rgba(255, 255, 255, 0.4)";
        ctx.font = "bold 24px serif";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("\u2660", w * 0.15, h * 0.5);
        ctx.fillText("\u2666", w * 0.25, h * 0.5);
        ctx.fillText("\u2663", w * 0.75, h * 0.5);
        ctx.fillText("\u2665", w * 0.85, h * 0.5);
        ctx.fillText("\u{1F451}", w * 0.05, h * 0.32);
        ctx.fillText("\u{1F451}", w * 0.95, h * 0.32);
        ctx.restore();
        ctx.strokeStyle = "#f59e0b";
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.moveTo(0, h * 0.22);
        ctx.lineTo(w, h * 0.22);
        ctx.stroke();
        const faceSize = Math.round(h * 0.72);
        const fx = Math.round((w - faceSize) / 2);
        const fy = Math.round((h - faceSize) / 2);
        let drawn = false;
        if (typeof AvatarManager?.createAvatarCanvas === "function") {
          const c = await AvatarManager.createAvatarCanvas(this.playerData.avatarId, faceSize, faceSize);
          if (c && ctx.drawImage) {
            ctx.save();
            const glowGrad = ctx.createRadialGradient(w / 2, h / 2, faceSize * 0.2, w / 2, h / 2, faceSize * 0.55);
            glowGrad.addColorStop(0, this.hexToRgba(badgeColorHex, 0.5));
            glowGrad.addColorStop(1, "rgba(0, 0, 0, 0)");
            ctx.fillStyle = glowGrad;
            ctx.fillRect(fx - 10, fy - 10, faceSize + 20, faceSize + 20);
            ctx.drawImage(c, fx, fy, faceSize, faceSize);
            ctx.restore();
            drawn = true;
          }
        }
        if (!drawn) {
          ctx.save();
          ctx.beginPath();
          ctx.arc(w / 2, h / 2, faceSize / 2, 0, Math.PI * 2);
          ctx.fillStyle = badgeColorHex;
          ctx.fill();
          ctx.strokeStyle = "#f59e0b";
          ctx.lineWidth = 4;
          ctx.stroke();
          ctx.fillStyle = "#ffffff";
          ctx.font = 'bold 72px "Segoe UI", Roboto, sans-serif';
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          const initial = (this.playerData.name || this.seat).charAt(0).toUpperCase();
          ctx.fillText(initial, w / 2, h / 2 + 4);
          ctx.restore();
        }
        tex.update();
        if (headMat.albedoTexture && headMat.albedoTexture !== tex) {
          try {
            headMat.albedoTexture.dispose();
          } catch (_) {
          }
        }
        headMat.albedoTexture = tex;
        if (headMat.useAlphaFromAlbedoTexture !== void 0) {
          headMat.useAlphaFromAlbedoTexture = true;
        }
      } catch (_) {
      }
    }
    /**
     * Helper: converts hex color string and alpha to CSS rgba string.
     * @param {string} hex
     * @param {number} alpha
     * @returns {string}
     */
    hexToRgba(hex, alpha = 1) {
      if (!hex || typeof hex !== "string") return `rgba(59, 130, 246, ${alpha})`;
      const clean = hex.replace("#", "");
      const num = parseInt(clean, 16);
      if (isNaN(num)) return `rgba(59, 130, 246, ${alpha})`;
      const r = num >> 16 & 255;
      const g = num >> 8 & 255;
      const b = num & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    /**
     * Updates transparency for computer player avatar figure.
     * @param {boolean} isTransparent
     * @param {number} [alpha=0.6]
     */
    setTransparent(isTransparent, alpha = 0.6) {
      this.isTransparent = Boolean(isTransparent);
      this.transparencyAlpha = this.isTransparent ? alpha : 1;
      const blendMode = this.BABYLON?.PBRMaterial?.PBRMATERIAL_ALPHABLEND != null ? this.BABYLON.PBRMaterial.PBRMATERIAL_ALPHABLEND : 2;
      const applyTrans = (mesh, mat, a) => {
        if (mesh) mesh.visibility = this.isTransparent ? a : 1;
        if (mat) {
          mat.alpha = this.isTransparent ? a : 1;
          if (mat.transparencyMode !== void 0) {
            mat.transparencyMode = this.isTransparent ? blendMode : 0;
          }
        }
      };
      applyTrans(this.torsoMesh, this.torsoMesh?.material, Math.min(this.transparencyAlpha, 0.55));
      applyTrans(this.collarMesh, this.collarMesh?.material, Math.min(this.transparencyAlpha + 0.1, 0.7));
      applyTrans(this.headMesh, this.headMesh?.material, this.transparencyAlpha);
      if (this.armMeshes) {
        this.armMeshes.forEach((m) => {
          if (m) m.visibility = this.isTransparent ? Math.min(this.transparencyAlpha, 0.6) : 1;
        });
      }
    }
    /**
     * Toggles avatar wrapping on head sphere vs flat floating cameo.
     * @param {boolean} wrap
     */
    setWrapAvatarOnHead(wrap) {
      this.wrapAvatarOnHead = Boolean(wrap);
      if (this.faceCameoMesh) {
        this.faceCameoMesh.isVisible = !this.wrapAvatarOnHead && this.visible;
      }
      const avatarInfo = AvatarManager?.getAvatarById?.(this.playerData.avatarId) || {};
      if (this.wrapAvatarOnHead) {
        if (this.headMesh?.material) {
          this.applyHeadWrapTexture(this.headMesh.material, avatarInfo);
        }
      } else {
        if (this.faceCameoMesh?.material) {
          this.applyAvatarFaceTexture(this.faceCameoMesh.material, avatarInfo);
        }
      }
    }
    /**
     * Generates or refreshes the floating HUD nameplate texture with name, score, and turn glow.
     * @param {BABYLON.PBRMaterial} mat
     */
    updateNameplateTexture(mat) {
      const { scene, BABYLON } = this;
      if (!BABYLON || !BABYLON.DynamicTexture) return;
      try {
        let tex = this.nameplateTexture;
        if (!tex || typeof tex.isDisposed === "function" && tex.isDisposed()) {
          tex = new BABYLON.DynamicTexture(`texNameplate_${this.seat}`, { width: 512, height: 180 }, scene, false);
          this.nameplateTexture = tex;
          this.textures.push(tex);
        }
        const ctx = tex.getContext();
        if (!ctx) return;
        const w = 512;
        const h = 180;
        const isTurn = Boolean(this.playerData.isTurn);
        const isDealer = Boolean(this.playerData.isDealer);
        ctx.clearRect(0, 0, w, h);
        ctx.fillStyle = isTurn ? "rgba(15, 23, 42, 0.94)" : "rgba(15, 23, 42, 0.82)";
        ctx.beginPath();
        if (ctx.roundRect) {
          ctx.roundRect(10, 10, w - 20, h - 20, 24);
        } else {
          ctx.rect(10, 10, w - 20, h - 20);
        }
        ctx.fill();
        ctx.strokeStyle = isTurn ? "#f59e0b" : isDealer ? "rgba(245, 158, 11, 0.75)" : "#334155";
        ctx.lineWidth = isTurn ? 8 : isDealer ? 5 : 4;
        ctx.stroke();
        ctx.fillStyle = "#ffffff";
        ctx.font = 'bold 44px "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        const displayName = this.playerData.name || this.seat;
        ctx.fillText(displayName.slice(0, 13), 36, h / 2 - 20);
        const scoreText = `${this.playerData.score || 0} pts`;
        ctx.fillStyle = isTurn ? "#f59e0b" : "#3b82f6";
        ctx.beginPath();
        if (ctx.roundRect) {
          ctx.roundRect(36, h / 2 + 18, 136, 42, 14);
        } else {
          ctx.rect(36, h / 2 + 18, 136, 42);
        }
        ctx.fill();
        ctx.fillStyle = isTurn ? "#000000" : "#ffffff";
        ctx.font = 'bold 28px "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.fillText(scoreText, 104, h / 2 + 40);
        if (isDealer) {
          const dealerX = isTurn ? w - 184 : w - 170;
          const dealerY = isTurn ? h / 2 - 46 : h / 2 - 22;
          const dealerW = isTurn ? 148 : 144;
          const dealerH = isTurn ? 40 : 44;
          const grad = ctx.createLinearGradient(dealerX, dealerY, dealerX + dealerW, dealerY + dealerH);
          grad.addColorStop(0, "#f59e0b");
          grad.addColorStop(1, "#b45309");
          ctx.fillStyle = grad;
          ctx.beginPath();
          if (ctx.roundRect) {
            ctx.roundRect(dealerX, dealerY, dealerW, dealerH, 14);
          } else {
            ctx.rect(dealerX, dealerY, dealerW, dealerH);
          }
          ctx.fill();
          ctx.strokeStyle = "#fef08a";
          ctx.lineWidth = 2;
          ctx.stroke();
          ctx.fillStyle = "#0f172a";
          ctx.font = 'bold 24px "Segoe UI", Roboto, sans-serif';
          ctx.textAlign = "center";
          ctx.fillText("\u2605 DEALER", dealerX + dealerW / 2, dealerY + dealerH / 2 + 2);
        }
        if (isTurn) {
          const turnX = isDealer ? w - 184 : w - 170;
          const turnY = isDealer ? h / 2 + 10 : h / 2 - 20;
          const turnW = isDealer ? 148 : 130;
          const turnH = isDealer ? 40 : 44;
          ctx.fillStyle = "#10b981";
          ctx.beginPath();
          if (ctx.roundRect) {
            ctx.roundRect(turnX, turnY, turnW, turnH, 14);
          } else {
            ctx.rect(turnX, turnY, turnW, turnH);
          }
          ctx.fill();
          ctx.fillStyle = "#ffffff";
          ctx.font = 'bold 24px "Segoe UI", Roboto, sans-serif';
          ctx.textAlign = "center";
          ctx.fillText("TURN", turnX + turnW / 2, turnY + turnH / 2 + 2);
        }
        tex.update();
        if (mat.albedoTexture !== tex) {
          mat.albedoTexture = tex;
        }
      } catch (_) {
      }
    }
    /**
     * Updates player data (name, avatar, score, turn, dealer) and refreshes visual indicators.
     * @param {Object} data
     */
    update(data = {}) {
      let changed = false;
      if (data.name !== void 0 && data.name !== this.playerData.name) {
        this.playerData.name = data.name;
        changed = true;
      }
      if (data.score !== void 0 && Number(data.score) !== this.playerData.score) {
        this.playerData.score = Number(data.score);
        changed = true;
      }
      if (data.isTurn !== void 0 && Boolean(data.isTurn) !== this.playerData.isTurn) {
        this.playerData.isTurn = Boolean(data.isTurn);
        if (this.turnHaloMesh) {
          this.turnHaloMesh.isVisible = this.playerData.isTurn;
        }
        changed = true;
      }
      if (data.isDealer !== void 0 && Boolean(data.isDealer) !== this.playerData.isDealer) {
        this.playerData.isDealer = Boolean(data.isDealer);
        changed = true;
      }
      if (data.avatarId !== void 0 && data.avatarId !== this.playerData.avatarId) {
        this.playerData.avatarId = data.avatarId;
        const avatarInfo = AvatarManager?.getAvatarById?.(this.playerData.avatarId) || {};
        if (this.wrapAvatarOnHead) {
          const headMat = this.headMesh?.material;
          if (headMat) this.applyHeadWrapTexture(headMat, avatarInfo);
        } else {
          const faceMat = this.faceCameoMesh?.material;
          if (faceMat) this.applyAvatarFaceTexture(faceMat, avatarInfo);
        }
        changed = true;
      }
      if (changed && this.nameplateMesh?.material) {
        this.updateNameplateTexture(this.nameplateMesh.material);
      }
    }
    /**
     * Sets or clears the active turn state.
     * @param {boolean} isTurn
     */
    setTurn(isTurn) {
      const nextVal = Boolean(isTurn);
      if (this.playerData.isTurn === nextVal) return;
      this.playerData.isTurn = nextVal;
      if (this.turnHaloMesh) {
        this.turnHaloMesh.isVisible = this.playerData.isTurn;
      }
      if (this.nameplateMesh?.material) {
        this.updateNameplateTexture(this.nameplateMesh.material);
      }
    }
    /**
     * Sets or clears the dealer state on this seated avatar.
     * @param {boolean} isDealer
     */
    setDealer(isDealer) {
      const nextVal = Boolean(isDealer);
      if (this.playerData.isDealer === nextVal) return;
      this.playerData.isDealer = nextVal;
      if (this.nameplateMesh?.material) {
        this.updateNameplateTexture(this.nameplateMesh.material);
      }
    }
    /**
     * Updates the displayed score.
     * @param {number} score
     */
    setScore(score) {
      const nextVal = Number(score);
      if (this.playerData.score === nextVal) return;
      this.playerData.score = nextVal;
      if (this.nameplateMesh?.material) {
        this.updateNameplateTexture(this.nameplateMesh.material);
      }
    }
    /**
     * Shows a floating emoji reaction speech bubble over the player avatar.
     * @param {string} emoji
     * @param {number} [duration=3200]
     */
    showReaction(emoji = "\u{1F60E}", duration = 3200) {
      if (!this.reactionBubbleMesh) return;
      if (this._reactionTimeout) {
        clearTimeout(this._reactionTimeout);
        this._reactionTimeout = null;
      }
      const { scene, BABYLON } = this;
      if (BABYLON?.DynamicTexture) {
        let tex = this.reactionTexture;
        if (!tex || typeof tex.isDisposed === "function" && tex.isDisposed()) {
          tex = new BABYLON.DynamicTexture(`texReaction_${this.seat}`, { width: 160, height: 160 }, scene, false);
          this.reactionTexture = tex;
          this.textures.push(tex);
        }
        const ctx = tex.getContext();
        if (ctx) {
          ctx.clearRect(0, 0, 160, 160);
          ctx.fillStyle = "#ffffff";
          ctx.beginPath();
          ctx.arc(80, 80, 70, 0, Math.PI * 2);
          ctx.fill();
          ctx.strokeStyle = "#3b82f6";
          ctx.lineWidth = 6;
          ctx.stroke();
          ctx.font = '72px "Segoe UI Emoji", "Apple Color Emoji", sans-serif';
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(emoji, 80, 84);
          tex.update();
          let mat = this.reactionMaterial;
          if (!mat || typeof mat.isDisposed === "function" && mat.isDisposed()) {
            mat = new BABYLON.PBRMaterial(`matReaction_${this.seat}`, scene);
            mat.roughness = 0.2;
            this.reactionMaterial = mat;
            this.materials.push(mat);
          }
          mat.albedoTexture = tex;
          this.reactionBubbleMesh.material = mat;
        }
      }
      this.reactionBubbleMesh.isVisible = true;
      this._reactionTimeout = setTimeout(() => {
        if (this.reactionBubbleMesh) {
          this.reactionBubbleMesh.isVisible = false;
        }
      }, duration);
    }
    /**
     * Initiates gentle breathing idle animation cycle.
     */
    startIdleAnimation() {
      if (!this.scene?.onBeforeRenderObservable || !this.torsoMesh) return;
      if (this.idleObserver) {
        this.scene.onBeforeRenderObservable.remove(this.idleObserver);
        this.idleObserver = null;
      }
      const baseTorsoY = this.torsoMesh.position.y;
      const baseHeadY = this.headMesh ? this.headMesh.position.y : 76;
      const phaseOffset = this.seatIndex * 1.25;
      this.idleObserver = this.scene.onBeforeRenderObservable.add(() => {
        const t = performance.now() * 2e-3 + phaseOffset;
        const breathe = Math.sin(t) * 0.45;
        if (this.torsoMesh) this.torsoMesh.position.y = baseTorsoY + breathe;
        if (this.headMesh) this.headMesh.position.y = baseHeadY + breathe * 1.1;
        if (this.faceCameoMesh) this.faceCameoMesh.position.y = baseHeadY + breathe * 1.1;
        if (this.playerData.isTurn && this.turnHaloMesh) {
          const pulse = 1 + Math.sin(t * 3) * 0.08;
          this.turnHaloMesh.scaling.set(pulse, 1, pulse);
        }
      });
    }
    /**
     * Helper: converts hex color string to Babylon Color3.
     * @param {string} hex
     * @returns {BABYLON.Color3}
     */
    hexToColor3(hex) {
      const BABYLON = this.BABYLON;
      if (!hex || typeof hex !== "string") return new BABYLON.Color3(0.2, 0.4, 0.8);
      const clean = hex.replace("#", "");
      const num = parseInt(clean, 16);
      if (isNaN(num)) return new BABYLON.Color3(0.2, 0.4, 0.8);
      const r = (num >> 16 & 255) / 255;
      const g = (num >> 8 & 255) / 255;
      const b = (num & 255) / 255;
      return new BABYLON.Color3(r, g, b);
    }
    /**
     * Sets avatar visibility (used to hide the human player so hand cards are fully visible).
     * @param {boolean} visible
     */
    setVisible(visible) {
      this.visible = Boolean(visible);
      if (this.rootNode && typeof this.rootNode.setEnabled === "function") {
        this.rootNode.setEnabled(this.visible);
      }
      if (this.torsoMesh) this.torsoMesh.isVisible = this.visible;
      if (this.headMesh) this.headMesh.isVisible = this.visible;
      if (this.collarMesh) this.collarMesh.isVisible = this.visible;
      if (this.faceCameoMesh) this.faceCameoMesh.isVisible = this.visible && !this.wrapAvatarOnHead;
      if (this.nameplateMesh) this.nameplateMesh.isVisible = this.visible;
      if (this.turnHaloMesh) this.turnHaloMesh.isVisible = this.visible && Boolean(this.playerData.isTurn);
      if (this.armMeshes) this.armMeshes.forEach((m) => {
        if (m) m.isVisible = this.visible;
      });
    }
    /**
     * Disposes all meshes, textures, materials, and observers for this player avatar.
     */
    dispose() {
      if (this._reactionTimeout) {
        clearTimeout(this._reactionTimeout);
        this._reactionTimeout = null;
      }
      if (this.idleObserver && this.scene?.onBeforeRenderObservable) {
        this.scene.onBeforeRenderObservable.remove(this.idleObserver);
        this.idleObserver = null;
      }
      this.nameplateTexture = null;
      this.faceCameoTexture = null;
      this.headWrapTexture = null;
      this.reactionTexture = null;
      this.reactionMaterial = null;
      this.textures.forEach((t) => {
        try {
          t.dispose();
        } catch (_) {
        }
      });
      this.textures = [];
      this.materials.forEach((m) => {
        try {
          m.dispose();
        } catch (_) {
        }
      });
      this.materials = [];
      if (this.collarMesh) {
        try {
          this.collarMesh.dispose();
        } catch (_) {
        }
        this.collarMesh = null;
      }
      if (this.armMeshes) {
        this.armMeshes.forEach((m) => {
          try {
            m.dispose();
          } catch (_) {
          }
        });
        this.armMeshes = [];
      }
      if (this.rootNode) {
        try {
          this.rootNode.dispose(false, true);
        } catch (_) {
        }
        this.rootNode = null;
      }
    }
  };
  var SeatManager3D = class {
    /**
     * @param {BABYLON.Scene} scene
     * @param {Object} BABYLON
     * @param {Object} options - { dims, seatCount, chairs }
     */
    constructor(scene, BABYLON, options = {}) {
      this.scene = scene;
      this.BABYLON = BABYLON;
      this.options = options;
      this.dims = options.dims || {};
      this.seats = /* @__PURE__ */ new Map();
      this.chairRoots = options.chairRoots || [];
    }
    /**
     * Sets up 3D seated player avatars according to active roster / seat count.
     * Computer player avatars (p2, p3, etc.) are rendered semi-transparent with wrapped head textures.
     * @param {Array<Object>} players - Array of player info { id, name, avatarId, score, isTurn }
     * @param {number} [count=2]
     * @param {Array<BABYLON.TransformNode>} [chairRoots=[]]
     * @returns {Map<string, PlayerAvatar3D>}
     */
    setupSeats(players = [], count = 2, chairRoots = []) {
      this.clearAll();
      const actualRoots = chairRoots && chairRoots.length > 0 ? chairRoots : this.chairRoots;
      const seatCount = Math.max(2, Math.min(8, count || players.length || 2));
      for (let i = 0; i < seatCount; i++) {
        const seat = `p${i + 1}`;
        const playerData = players.find((p) => p.id === seat) || players[i] || {
          id: seat,
          name: i === 0 ? "You" : `Player ${i + 1}`,
          avatarId: i === 0 ? "joker" : i === 1 ? "king" : "shark",
          score: 0,
          isTurn: i === 0
        };
        const chairRoot = actualRoots[i] || null;
        const isLocal = seat === "p1";
        const showFigure = this.options.showLocalPlayer === true || !isLocal;
        const isComputer = !isLocal || Boolean(playerData.isComputer || playerData.isCpu || playerData.type === "computer" || playerData.type === "cpu");
        const avatar = new PlayerAvatar3D(this.scene, this.BABYLON, seat, playerData, {
          chairRoot,
          seatIndex: i,
          dims: this.dims,
          visible: showFigure,
          isComputer,
          isTransparent: isComputer,
          wrapAvatarOnHead: isComputer
        });
        this.seats.set(seat, avatar);
      }
      return this.seats;
    }
    /**
     * Normalizes seat identifier across alias forms (you/cpu/player1/team1 -> p1, etc.).
     * @param {string} seat
     * @returns {string}
     */
    normalizeSeatId(seat) {
      if (!seat) return "";
      if (seat === "you" || seat === "player1" || seat === "team1") return "p1";
      if (seat === "cpu" || seat === "player2" || seat === "team2") return "p2";
      if (seat === "player3" || seat === "team3") return "p3";
      if (seat === "player4" || seat === "team4") return "p4";
      return seat;
    }
    /**
     * Retrieves the PlayerAvatar3D instance for a given seat.
     * @param {string} seat - 'p1', 'p2', 'you', 'cpu', etc.
     * @returns {PlayerAvatar3D|null}
     */
    getSeat(seat) {
      const key = this.normalizeSeatId(seat);
      return this.seats.get(key) || this.seats.get(seat) || null;
    }
    /**
     * Updates an individual seated player's data (name, score, avatar, turn).
     * @param {string} seat
     * @param {Object} data
     */
    updatePlayer(seat, data = {}) {
      const avatar = this.getSeat(seat);
      if (avatar) avatar.update(data);
    }
    /**
     * Resolves the numeric score for a specific seat from a scores object,
     * accounting for raw IDs (p1-p8), aliases (you/cpu), teams (team1-team4),
     * and partnership mirroring in 4-player cribbage.
     * @param {string} seat - 'p1', 'p2', 'p3', 'p4', etc.
     * @param {Object} scores - Map of scores
     * @returns {number}
     */
    resolveSeatScore(seat, scores = {}) {
      if (!scores || typeof scores !== "object") return 0;
      const norm = this.normalizeSeatId(seat);
      if (scores[seat] !== void 0) return Number(scores[seat]) || 0;
      if (scores[norm] !== void 0) return Number(scores[norm]) || 0;
      if (norm === "p1") {
        if (scores.you !== void 0) return Number(scores.you) || 0;
        if (scores.player1 !== void 0) return Number(scores.player1) || 0;
        if (scores.team1 !== void 0) return Number(scores.team1) || 0;
      } else if (norm === "p2") {
        if (scores.cpu !== void 0) return Number(scores.cpu) || 0;
        if (scores.player2 !== void 0) return Number(scores.player2) || 0;
        if (scores.team2 !== void 0) return Number(scores.team2) || 0;
      } else if (norm === "p3") {
        if (scores.player3 !== void 0) return Number(scores.player3) || 0;
        if (scores.team3 !== void 0) return Number(scores.team3) || 0;
      } else if (norm === "p4") {
        if (scores.player4 !== void 0) return Number(scores.player4) || 0;
        if (scores.team4 !== void 0) return Number(scores.team4) || 0;
      }
      let team = null;
      if (typeof window !== "undefined" && typeof window.getSeatTeam === "function") {
        try {
          team = window.getSeatTeam(norm);
        } catch (_) {
        }
      }
      if (!team) {
        const totalSeats = this.seats && this.seats.size || 4;
        if (totalSeats === 4) {
          if (norm === "p1" || norm === "p3") team = "team1";
          else if (norm === "p2" || norm === "p4") team = "team2";
        }
      }
      if (team && scores[team] !== void 0) {
        return Number(scores[team]) || 0;
      }
      if (norm === "p3") {
        if (scores.team1 !== void 0) return Number(scores.team1) || 0;
        if (scores.p1 !== void 0) return Number(scores.p1) || 0;
        if (scores.you !== void 0) return Number(scores.you) || 0;
      } else if (norm === "p4") {
        if (scores.team2 !== void 0) return Number(scores.team2) || 0;
        if (scores.p2 !== void 0) return Number(scores.p2) || 0;
        if (scores.cpu !== void 0) return Number(scores.cpu) || 0;
      } else if (norm === "p1") {
        if (scores.team1 !== void 0) return Number(scores.team1) || 0;
        if (scores.p3 !== void 0) return Number(scores.p3) || 0;
      } else if (norm === "p2") {
        if (scores.team2 !== void 0) return Number(scores.team2) || 0;
        if (scores.p4 !== void 0) return Number(scores.p4) || 0;
      }
      if (typeof window !== "undefined" && window.state && window.state.scores && window.state.scores !== scores) {
        return this.resolveSeatScore(seat, window.state.scores);
      }
      return 0;
    }
    /**
     * Updates live scores across all seated players.
     * @param {Object} scores - { p1: 12, p2: 18, ... } or { team1: 24, team2: 18 }
     */
    updateScores(scores = {}) {
      if (!scores || typeof scores !== "object") return;
      this.seats.forEach((avatar, seatId) => {
        if (avatar) {
          const sc = this.resolveSeatScore(seatId, scores);
          avatar.setScore(sc);
        }
      });
      for (const [seat, score] of Object.entries(scores)) {
        const avatar = this.getSeat(seat);
        if (avatar && avatar.playerData.score !== Number(score)) {
          avatar.setScore(Number(score) || 0);
        }
      }
    }
    /**
     * Sets the active turn on a player seat, illuminating their halo and updating status plaques.
     * @param {string} activeSeat
     */
    setActiveTurn(activeSeat) {
      const targetSeat = this.normalizeSeatId(activeSeat);
      this.seats.forEach((avatar, seat) => {
        avatar.setTurn(seat === targetSeat || seat === activeSeat);
      });
    }
    /**
     * Sets the active dealer across all player seats, updating nameplate status badges.
     * @param {string} dealerSeat - 'p1', 'p2', 'you', 'cpu', etc.
     */
    setDealer(dealerSeat) {
      const targetSeat = this.normalizeSeatId(dealerSeat);
      this.seats.forEach((avatar, seat) => {
        avatar.setDealer(seat === targetSeat || seat === dealerSeat);
      });
    }
    /**
     * Displays an emoji reaction above the specified player's seat.
     * @param {string} seat
     * @param {string} emoji
     */
    showReaction(seat, emoji) {
      const avatar = this.getSeat(seat);
      if (avatar) avatar.showReaction(emoji);
    }
    /**
     * Updates transparency across all computer player avatars.
     * @param {boolean} isTransparent
     * @param {number} [alpha=0.6]
     */
    setComputerAvatarsTransparent(isTransparent, alpha = 0.6) {
      this.seats.forEach((avatar) => {
        if (avatar.isComputer) {
          avatar.setTransparent(isTransparent, alpha);
        }
      });
    }
    /**
     * Updates head wrap on all computer player avatars.
     * @param {boolean} wrap
     */
    setComputerAvatarsWrapOnHead(wrap) {
      this.seats.forEach((avatar) => {
        if (avatar.isComputer) {
          avatar.setWrapAvatarOnHead(wrap);
        }
      });
    }
    /**
     * Cleans up and disposes all seated avatars.
     */
    clearAll() {
      this.seats.forEach((avatar) => avatar.dispose());
      this.seats.clear();
    }
    /**
     * Toggles visibility of the local player avatar figure.
     * @param {boolean} visible
     */
    setLocalPlayerVisible(visible) {
      this.options.showLocalPlayer = Boolean(visible);
      const p1Avatar = this.getSeat("p1");
      if (p1Avatar) {
        p1Avatar.setVisible(this.options.showLocalPlayer);
      }
    }
    /**
     * Disposes the SeatManager3D.
     */
    dispose() {
      this.clearAll();
    }
  };

  // src/board/BoardRenderer3D.js
  var BoardRenderer3D = class _BoardRenderer3D {
    /**
     * @param {HTMLElement} container - DOM element to mount the Babylon.js canvas into.
     * @param {Object} options
     */
    constructor(container, options = {}) {
      this.container = container;
      this.options = options;
      this.boardConfig = options.boardConfig || Board3DCatalog.getBoardById("board-14") || Board3DCatalog.getBoards()[0];
      this.activeTracks = options.activeTracks || ["p1", "p2"];
      this.settings = options.settings || {};
      this.targetHoles = Number(this.settings.target) || 121;
      this.viewBoxW = Number(options.boardViewW) || 820;
      this.viewBoxH = Number(options.boardViewH) || 216;
      this.canvas = null;
      this.engine = null;
      this.scene = null;
      this.camera = null;
      this.boardMeshes = [];
      this.boardRoot = null;
      this.isDraggingBoard = false;
      this.pegMeshes = /* @__PURE__ */ new Map();
      this.pegState = {};
      this.holeLookup = null;
      this.animatingPegs = [];
      this.isDestroyed = false;
      this.BABYLON = null;
      this._avatarMaterials = /* @__PURE__ */ new Map();
      this._avatarTextures = /* @__PURE__ */ new Map();
      this.clashObstaclesRoot = null;
      this.glowLayer = null;
      this._obstacleMaterials = null;
      this.pintsObjectsRoot = null;
      this._pintsMaterials = null;
      this.adultObjectsRoot = null;
      this._adultMaterials = null;
      this.zoneHighlightsRoot = null;
      this._zoneMaterials = null;
      this._lastZoneHighlightKey = null;
      this.boardBounds = null;
      this.boardScale = 0.5;
      let savedScale = 1;
      try {
        if (typeof localStorage !== "undefined") {
          const s = parseFloat(localStorage.getItem("cc_board_3d_scale"));
          if (!isNaN(s) && s >= 0.2 && s <= 2.5) {
            savedScale = s;
          }
        }
      } catch (_) {
      }
      this.boardScaleMultiplier = savedScale;
      this.dirLight = null;
      this.fillLight = null;
      this.hemiLight = null;
      this.shadowGenerator = null;
      this.ssaoPipeline = null;
      this.activePreset = "overview";
      this.isPanMode = false;
      this.presetsToolbar = null;
      this._currentCameraAnim = null;
      this.resizeObserver = null;
      this._resizeRaf = null;
      this._userHasAdjustedCamera = false;
      this.roomData = null;
      this.tableMesh = null;
      this._tableTexture = null;
      this.cardEngine = null;
      this.seatManager = null;
      this.hud3DOverlay = null;
      this.dealerButtonMesh = null;
      this.dealerSeat = null;
      this._dealerButtonMat = null;
      this._dealerButtonTex = null;
      this._dealerButtonAnim = null;
      this._tableMaterial = null;
      this.tableEnvironment = this.settings?.tableEnvironment || "auto";
      this.pegStyle = this.settings?.pegStyle || "classic";
      this._activeTrailParticles = [];
      this._isActionCamActive = false;
      this._savedActionCamState = null;
      this._actionCamTimer = null;
      this.actionCamOverlay = null;
      this._onFullscreenChange = null;
      this._onGlobalKeydown = null;
      this._fullscreenListenersBound = false;
      let savedBrightness = 100;
      try {
        if (typeof localStorage !== "undefined") {
          const stored = parseInt(localStorage.getItem("cc_board_3d_brightness"), 10);
          if (!isNaN(stored) && stored >= 30 && stored <= 220) {
            savedBrightness = stored;
          }
          const storedEnv = localStorage.getItem("cc_board_3d_table_env");
          if (storedEnv) this.tableEnvironment = storedEnv;
          const storedPegStyle = localStorage.getItem("cc_board_3d_peg_style");
          if (storedPegStyle) this.pegStyle = storedPegStyle;
        }
      } catch (_) {
      }
      this.brightnessPercent = savedBrightness;
      this.init();
    }
    /**
     * Emits loading progress updates to options.onProgress if registered.
     * @param {string} statusText
     * @param {number} percent
     */
    notifyProgress(statusText, percent) {
      if (typeof this.options.onProgress === "function") {
        try {
          this.options.onProgress(statusText, percent);
        } catch (_) {
        }
      }
    }
    /**
     * Asynchronously loads Babylon.js and initializes the 3D scene.
     */
    async init() {
      try {
        this.notifyProgress("Loading 3D WebGL engine\u2026", 0.2);
        this.BABYLON = await this.loadBabylon();
        if (!this.BABYLON || this.isDestroyed) return;
        this.notifyProgress("Configuring camera & dynamic lighting\u2026", 0.35);
        this.setupEngineAndScene();
        this.setupCamera();
        this.setupLighting();
        this.notifyProgress("Loading 3D cribbage board model\u2026", 0.52);
        await this.loadBoardModel();
        this.notifyProgress("Constructing 3D room, table & surroundings\u2026", 0.72);
        this.setupPostProcessing();
        this.setupTableEnvironment();
        this.fitBoardToViewBox(true);
        this.notifyProgress("Setting up pegs, tracks & 3D cards\u2026", 0.88);
        await this.setupHoleLookup();
        this.setupPegs();
        this.setupClashObstacles();
        this.setupPintsObjects();
        this.setupAdultObjects();
        this.setupZoneHighlights();
        this.setupCameraPresetsUI();
        this.setupTopLeftLogoUI();
        this.syncFromGameState();
        this.startRenderLoop();
        this.notifyProgress("3D Room ready to play!", 1);
        if (typeof this.options.onReady === "function") {
          this.options.onReady(this);
        }
      } catch (err) {
        console.error("[BoardRenderer3D] Babylon.js initialization failed, falling back to 2D:", err);
        if (typeof this.options.onError === "function") {
          this.options.onError(err);
        }
      }
    }
    /**
     * Checks whether the GLTF/GLB loader plugin is registered in Babylon.js.
     * @returns {boolean}
     */
    static hasGlbLoader() {
      return Boolean(
        typeof window !== "undefined" && window.BABYLON && window.BABYLON.Engine && (window.BABYLON.GLTFFileLoader || window.BABYLON.SceneLoader && typeof window.BABYLON.SceneLoader.IsPluginForExtensionAvailable === "function" && window.BABYLON.SceneLoader.IsPluginForExtensionAvailable(".glb"))
      );
    }
    /**
     * Helper to sequentially attempt loading a script from a list of candidate URLs.
     * @param {string[]} urls - Array of candidate URLs in order of preference.
     * @param {string} dataAttr - Dataset attribute for script tag identification.
     * @returns {Promise<void>}
     */
    static _loadScriptWithFallbacks(urls, dataAttr) {
      return new Promise((resolve, reject) => {
        let index = 0;
        const tryNext = () => {
          if (index >= urls.length) {
            return reject(new Error(`Failed to load script from all candidate URLs for [${dataAttr}]: ${urls.join(", ")}`));
          }
          const url = urls[index++];
          const prevScript = document.querySelector(`script[${dataAttr}]`);
          if (prevScript) {
            prevScript.remove();
          }
          const script = document.createElement("script");
          script.setAttribute(dataAttr, "loading");
          script.crossOrigin = "anonymous";
          script.async = false;
          script.src = url;
          script.onload = () => {
            script.setAttribute(dataAttr, "loaded");
            resolve();
          };
          script.onerror = () => {
            script.remove();
            tryNext();
          };
          document.head.appendChild(script);
        };
        tryNext();
      });
    }
    /**
     * Dynamic loader for Babylon.js core and GLTF loaders.
     * Pinned version 9.28.0 loaded directly from reliable CDN on production/Shopify,
     * guaranteeing that both Babylon core and the GLTF/GLB loader plugin are loaded and ready.
     */
    async loadBabylon() {
      if (_BoardRenderer3D.hasGlbLoader()) {
        return window.BABYLON;
      }
      if (_BoardRenderer3D._babylonPromise) {
        return _BoardRenderer3D._babylonPromise;
      }
      _BoardRenderer3D._babylonPromise = new Promise(async (resolve, reject) => {
        if (typeof document === "undefined") return reject(new Error("No DOM environment"));
        if (_BoardRenderer3D.hasGlbLoader()) return resolve(window.BABYLON);
        const isLocal = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.protocol === "file:");
        const customCore = typeof window !== "undefined" && window.BABYLON_CORE_URL ? [window.BABYLON_CORE_URL] : [];
        const customLoader = typeof window !== "undefined" && window.BABYLON_LOADER_URL ? [window.BABYLON_LOADER_URL] : [];
        const coreUrls = [
          ...customCore,
          ...isLocal ? ["dist/babylon.min.js"] : [],
          "https://unpkg.com/babylonjs@9.28.0/babylon.js",
          "https://cdn.babylonjs.com/babylon.js"
        ];
        const loaderUrls = [
          ...customLoader,
          ...isLocal ? ["dist/babylonjs.loaders.min.js"] : [],
          "https://unpkg.com/babylonjs-loaders@9.28.0/babylonjs.loaders.min.js",
          "https://cdn.babylonjs.com/loaders/babylonjs.loaders.min.js"
        ];
        try {
          if (!window.BABYLON || !window.BABYLON.Engine) {
            await _BoardRenderer3D._loadScriptWithFallbacks(coreUrls, "data-babylon-engine");
          }
          if (!_BoardRenderer3D.hasGlbLoader()) {
            await _BoardRenderer3D._loadScriptWithFallbacks(loaderUrls, "data-babylon-loader");
          }
          if (_BoardRenderer3D.hasGlbLoader()) {
            resolve(window.BABYLON);
          } else {
            _BoardRenderer3D._babylonPromise = null;
            reject(new Error("Babylon.js GLTF/GLB loader plugin was not found after loading scripts."));
          }
        } catch (err) {
          _BoardRenderer3D._babylonPromise = null;
          reject(err);
        }
      });
      return _BoardRenderer3D._babylonPromise;
    }
    /**
     * Sets up hole coordinate resolver using the Babylon.js coordinate system.
     */
    async setupHoleLookup() {
      const scale = this.boardScale || 0.5;
      const directCoords = this.boardConfig?.coordinatesData || this.boardConfig?.holeData;
      if (directCoords) {
        let parsed = directCoords;
        if (typeof parsed === "string") {
          try {
            parsed = JSON.parse(parsed);
          } catch (e) {
            try {
              parsed = JSON.parse(parsed.replace(/,(\s*[\]}])/g, "$1"));
            } catch (_) {
            }
          }
        }
        if (parsed && typeof parsed === "object") {
          this.boardConfig.holeData = parsed;
          if (this.hasDistinctCoordinates(parsed)) {
            this.holeLookup = Board3DCatalog.createHoleLookup(parsed, scale);
            return;
          }
        }
      }
      this.holeLookup = (who, hole) => {
        const p2d = getTrackXY(hole, who, this.targetHoles, this.settings);
        if (!p2d) return null;
        if (this.boardBounds && this.boardConfig?.modelUrl) {
          const b = this.boardBounds;
          const normX = Math.max(0, Math.min(1, (p2d.x - 40) / 740));
          const normZ = Math.max(0, Math.min(1, (p2d.y - 30) / 156));
          const x3d2 = b.min.x + normX * b.size.x;
          const z3d2 = b.max.z - normZ * b.size.z;
          const y3d2 = b.max.y + 0.2 * scale;
          return { x: x3d2, y: y3d2, z: z3d2, normal: [0, 1, 0] };
        }
        const x3d = (p2d.x - 410) / 410 * 30 * scale;
        const z3d = (108 - p2d.y) / 108 * 8.5 * scale;
        const y3d = 0.8 * scale;
        return { x: x3d, y: y3d, z: z3d, normal: [0, 1, 0] };
      };
    }
    /**
     * Helper to verify if coordinate data has real distinct hole positions.
     */
    hasDistinctCoordinates(data) {
      if (!data) return false;
      const pts = Array.isArray(data) ? data : data.tracks ? Object.values(data.tracks)[0] : Object.values(data)[0];
      if (!Array.isArray(pts) || pts.length < 5) return false;
      let minX = Infinity, maxX = -Infinity, minZ = Infinity, maxZ = -Infinity;
      for (const p of pts) {
        const px = typeof p?.x === "number" ? p.x : typeof p?.[" x"] === "number" ? p[" x"] : Number(p?.x ?? p?.[" x"]);
        const pz = typeof p?.z === "number" ? p.z : typeof p?.[" z"] === "number" ? p[" z"] : Number(p?.z ?? p?.[" z"]);
        if (!isNaN(px)) {
          minX = Math.min(minX, px);
          maxX = Math.max(maxX, px);
        }
        if (!isNaN(pz)) {
          minZ = Math.min(minZ, pz);
          maxZ = Math.max(maxZ, pz);
        }
      }
      return maxX - minX > 2 || maxZ - minZ > 2;
    }
    /**
     * Creates the canvas, Babylon Engine, Scene, and sets up responsive observers.
     */
    setupEngineAndScene() {
      const BABYLON = this.BABYLON;
      const existingCanvases = this.container.querySelectorAll("canvas");
      existingCanvases.forEach((c) => c.remove());
      this.canvas = document.createElement("canvas");
      this.canvas.style.width = "100%";
      this.canvas.style.height = "100%";
      this.canvas.style.display = "block";
      this.canvas.style.outline = "none";
      this.canvas.style.touchAction = "none";
      const activeOverlay = this.container.querySelector(".room3d-loading-overlay");
      if (activeOverlay) {
        this.container.insertBefore(this.canvas, activeOverlay);
      } else {
        this.container.appendChild(this.canvas);
      }
      this.engine = new BABYLON.Engine(this.canvas, true, {
        preserveDrawingBuffer: true,
        stencil: true,
        antialias: true,
        adaptToDeviceRatio: true
      });
      this.scene = new BABYLON.Scene(this.engine);
      this.scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
      this.boardRoot = new BABYLON.TransformNode("boardRoot", this.scene);
      if (this.boardScaleMultiplier && this.boardScaleMultiplier !== 1) {
        this.boardRoot.scaling.set(this.boardScaleMultiplier, this.boardScaleMultiplier, this.boardScaleMultiplier);
      }
      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver((entries2) => {
          if (this.isDestroyed || !this.engine) return;
          for (const entry of entries2) {
            if (entry.contentRect.width > 0 && entry.contentRect.height > 0) {
              if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
              this._resizeRaf = requestAnimationFrame(() => {
                if (!this.isDestroyed && this.engine) {
                  this.handleResize();
                }
              });
              break;
            }
          }
        });
        this.resizeObserver.observe(this.container);
      }
      this.resizeHandler = () => {
        if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
        this._resizeRaf = requestAnimationFrame(() => {
          if (!this.isDestroyed && this.engine) {
            this.handleResize();
          }
        });
      };
      window.addEventListener("resize", this.resizeHandler);
    }
    /**
     * Configures Babylon ArcRotateCamera with orbit, zoom, and pan controls.
     */
    setupCamera() {
      const BABYLON = this.BABYLON;
      const camDef = this.boardConfig?.cameraDefaults || {};
      const target = new BABYLON.Vector3(camDef.target?.[0] || 0, camDef.target?.[1] || 0, camDef.target?.[2] || 0);
      const defaultAlpha = camDef.alpha !== void 0 ? Number(camDef.alpha) : camDef.alphaDeg !== void 0 ? Number(camDef.alphaDeg) * Math.PI / 180 : -Math.PI / 2;
      const defaultBeta = camDef.beta !== void 0 ? Number(camDef.beta) : camDef.betaDeg !== void 0 ? Number(camDef.betaDeg) * Math.PI / 180 : Math.PI / 5.2;
      this.camera = new BABYLON.ArcRotateCamera(
        "boardCamera",
        defaultAlpha,
        // Alpha: horizontal orbit angle (yaw)
        defaultBeta,
        // Beta: elevated vantage point showing all tracks and tiers (pitch)
        55,
        // Will be auto-computed by fitBoardToViewBox
        target,
        this.scene
      );
      this.camera.fov = camDef.fov ? camDef.fov * Math.PI / 180 : 0.8;
      this.camera.fovMode = BABYLON.Camera.FOVMODE_VERTICAL_FIXED;
      this.camera.attachControl(this.canvas, true);
      this.camera.wheelDeltaPercentage = 0.035;
      this.camera.pinchDeltaPercentage = 0;
      this.camera.useNaturalPinchZoom = true;
      this.camera.pinchPrecision = 40;
      this.camera.wheelPrecision = 12;
      this.camera.inertia = 0.88;
      this.camera.panningSensibility = 25;
      this.camera.panningInertia = 0.85;
      this.camera.angularSensibilityX = 1e3;
      this.camera.angularSensibilityY = 1e3;
      this.camera.upperBetaLimit = Math.PI / 2.05;
      if (this.camera.inputs?.attached?.pointers) {
        this.camera.inputs.attached.pointers.useNaturalPinchZoom = true;
        this.camera.inputs.attached.pointers.pinchDeltaPercentage = 0;
        this.camera.inputs.attached.pointers.pinchPrecision = 40;
        this.camera.inputs.attached.pointers.panningSensibility = 25;
      }
      this.scene.collisionsEnabled = true;
      this.camera.checkCollisions = true;
      this.camera.collisionRadius = new BABYLON.Vector3(3, 3, 3);
      this.camera.onCollide = (collidedMesh) => {
        this.camera.inertialAlphaOffset = 0;
        this.camera.inertialBetaOffset = 0;
        this.camera.inertialRadiusOffset = 0;
        this.camera.inertialPanningX = 0;
        this.camera.inertialPanningY = 0;
        if (typeof this.camera.rebuildAnglesAndRadius === "function") {
          this.camera.rebuildAnglesAndRadius();
        }
      };
      this.scene.onBeforeRenderObservable.add(() => {
        if (this.camera && this.roomData?.dims) {
          const { roomW, roomD, floorY, ceilingY, tableSurfaceY } = this.roomData.dims;
          const marginX = roomW * 0.44;
          const marginZ = roomD * 0.44;
          const minY = tableSurfaceY != null ? tableSurfaceY - 10 : floorY + 15;
          if (this.camera.target) {
            if (this.camera.target.x > marginX) this.camera.target.x = marginX;
            if (this.camera.target.x < -marginX) this.camera.target.x = -marginX;
            if (this.camera.target.z > marginZ) this.camera.target.z = marginZ;
            if (this.camera.target.z < -marginZ) this.camera.target.z = -marginZ;
            if (this.camera.target.y < minY) this.camera.target.y = minY;
            if (this.camera.target.y > ceilingY - 25) this.camera.target.y = ceilingY - 25;
          }
          if (this.camera.position) {
            const camMarginX = roomW * 0.46;
            const camMarginZ = roomD * 0.46;
            const camMinY = floorY + 8;
            const camMaxY = ceilingY - 12;
            let clamped = false;
            let px = this.camera.position.x;
            let py = this.camera.position.y;
            let pz = this.camera.position.z;
            if (px > camMarginX) {
              px = camMarginX;
              clamped = true;
            } else if (px < -camMarginX) {
              px = -camMarginX;
              clamped = true;
            }
            if (pz > camMarginZ) {
              pz = camMarginZ;
              clamped = true;
            } else if (pz < -camMarginZ) {
              pz = -camMarginZ;
              clamped = true;
            }
            if (py < camMinY) {
              py = camMinY;
              clamped = true;
            } else if (py > camMaxY) {
              py = camMaxY;
              clamped = true;
            }
            if (clamped) {
              this.camera.position.set(px, py, pz);
              this.camera.inertialAlphaOffset = 0;
              this.camera.inertialBetaOffset = 0;
              this.camera.inertialRadiusOffset = 0;
              this.camera.inertialPanningX = 0;
              this.camera.inertialPanningY = 0;
              if (typeof this.camera.rebuildAnglesAndRadius === "function") {
                this.camera.rebuildAnglesAndRadius();
              }
            }
          }
        }
      });
      this.canvas.addEventListener("wheel", (e) => {
        if (e.ctrlKey || e.altKey) {
          const pick = this.scene ? this.scene.pick(this.scene.pointerX, this.scene.pointerY) : null;
          if (pick && pick.hit && this.isBoardMesh(pick.pickedMesh)) {
            e.preventDefault();
            e.stopPropagation();
            const delta = e.deltaY < 0 ? 0.05 : -0.05;
            this.scaleBoard(delta, false);
            return;
          }
        }
        this._userHasAdjustedCamera = true;
        this.activePreset = null;
        this.updatePresetButtonsUI(null);
      }, { passive: false });
      const activePointers = /* @__PURE__ */ new Map();
      let isDraggingBoard = false;
      let isTwoFingerRotating = false;
      let twoFingerStart = null;
      let cameraOrbitDetached = false;
      let boardDragPlane = null;
      let boardDragStart = null;
      let pointerStart = null;
      const detachCameraOrbit = () => {
        if (!cameraOrbitDetached) {
          cameraOrbitDetached = true;
          if (this.camera) {
            if (typeof this.camera.detachControl === "function") {
              this.camera.detachControl();
            }
            if (this.camera.inputs?.attached?.pointers) {
              try {
                this.camera.inputs.attached.pointers.detachControl();
              } catch (_) {
              }
            }
            if (typeof this.camera._reset === "function") {
              this.camera._reset();
            }
            this.camera.inertialAlphaOffset = 0;
            this.camera.inertialBetaOffset = 0;
            this.camera.inertialRadiusOffset = 0;
            this.camera.inertialPanningX = 0;
            this.camera.inertialPanningY = 0;
          }
        }
      };
      const attachCameraOrbit = () => {
        if (cameraOrbitDetached && !this.isPanMode && !isTwoFingerRotating) {
          cameraOrbitDetached = false;
          if (this.camera) {
            if (typeof this.camera.attachControl === "function") {
              this.camera.attachControl(this.canvas, true);
            } else if (this.camera.inputs?.attached?.pointers) {
              try {
                this.camera.inputs.attached.pointers.attachControl(this.canvas, true);
              } catch (_) {
              }
            }
            if (this.camera.inputs?.attached?.pointers) {
              this.camera.inputs.attached.pointers.useNaturalPinchZoom = true;
              this.camera.inputs.attached.pointers.pinchDeltaPercentage = 0;
              this.camera.inputs.attached.pointers.pinchPrecision = 40;
              this.camera.inputs.attached.pointers.panningSensibility = 25;
            }
          }
        }
      };
      const endTwoFingerRotate = () => {
        isTwoFingerRotating = false;
        twoFingerStart = null;
        if (activePointers.size === 0 && !isDraggingBoard) {
          attachCameraOrbit();
        }
      };
      const endBoardDrag = (e) => {
        if (isDraggingBoard) {
          if (e && typeof e.pointerId === "number") {
            try {
              this.canvas.releasePointerCapture(e.pointerId);
            } catch (_) {
            }
          }
          isDraggingBoard = false;
          this.isDraggingBoard = false;
          boardDragStart = null;
          boardDragPlane = null;
          if (activePointers.size === 0 && !isTwoFingerRotating) {
            attachCameraOrbit();
          }
        }
        if (this.canvas) {
          this.canvas.classList.remove("is-pan-grabbing");
          this.canvas.style.cursor = "default";
        }
      };
      this.canvas.addEventListener("pointerdown", (e) => {
        activePointers.set(e.pointerId, { x: e.clientX, y: e.clientY, type: e.pointerType });
        pointerStart = { x: e.clientX, y: e.clientY };
        const rect = this.canvas.getBoundingClientRect();
        const px = e.clientX - rect.left;
        const py = e.clientY - rect.top;
        const pick = this.scene ? this.scene.pick(px, py) : null;
        let hitBoard = Boolean(pick && pick.hit && this.isBoardMesh(pick.pickedMesh));
        if (!hitBoard && this.scene) {
          const boardPick = this.scene.pick(px, py, (m) => this.isBoardMesh(m));
          if (boardPick && boardPick.hit) {
            hitBoard = true;
          }
        }
        if (activePointers.size === 2) {
          if (isDraggingBoard || hitBoard || this.isPanMode) {
            const pts = Array.from(activePointers.values());
            const p1 = pts[0];
            const p2 = pts[1];
            const initialAngle = Math.atan2(p2.y - p1.y, p2.x - p1.x);
            const initialDist = Math.hypot(p2.x - p1.x, p2.y - p1.y);
            twoFingerStart = {
              initialAngle,
              lastAngle: initialAngle,
              initialDist,
              startRotY: this.boardRoot ? this.boardRoot.rotation.y || 0 : 0,
              accumulatedAngleDelta: 0,
              isConfirmedRotation: false,
              cameraAlpha: this.camera ? this.camera.alpha : null,
              cameraBeta: this.camera ? this.camera.beta : null
            };
            detachCameraOrbit();
            return;
          }
          if (isDraggingBoard) {
            endBoardDrag(e);
          }
          endTwoFingerRotate();
          attachCameraOrbit();
          return;
        }
        if (activePointers.size > 2) {
          if (isDraggingBoard) endBoardDrag(e);
          endTwoFingerRotate();
          attachCameraOrbit();
          return;
        }
        if (e.button === 0 || e.pointerType === "touch" || e.pointerType === "pen") {
          if (this.isPanMode || hitBoard) {
            isDraggingBoard = true;
            this.isDraggingBoard = true;
            this._userHasAdjustedCamera = true;
            this.activePreset = null;
            this.updatePresetButtonsUI(null);
            detachCameraOrbit();
            const surfaceY = this.roomData?.dims?.tableSurfaceY != null ? this.roomData.dims.tableSurfaceY : this.boardRoot?.position.y || 0;
            boardDragPlane = this.BABYLON.Plane.FromPositionAndNormal(
              new this.BABYLON.Vector3(0, surfaceY, 0),
              new this.BABYLON.Vector3(0, 1, 0)
            );
            const ray = this.scene.createPickingRay(
              px,
              py,
              this.BABYLON.Matrix.Identity(),
              this.camera
            );
            const dist2 = ray ? ray.intersectsPlane(boardDragPlane) : null;
            const initialHit = dist2 !== null && isFinite(dist2) ? ray.origin.add(ray.direction.scale(dist2)) : new this.BABYLON.Vector3(0, 0, 0);
            boardDragStart = {
              pointerId: e.pointerId,
              screenX: e.clientX,
              screenY: e.clientY,
              hit: initialHit,
              startPos: this.boardRoot ? this.boardRoot.position.clone() : new this.BABYLON.Vector3(0, 0, 0),
              startRotY: this.boardRoot ? this.boardRoot.rotation.y : 0,
              startScale: this.boardScaleMultiplier || 1,
              cameraAlpha: this.camera ? this.camera.alpha : null,
              cameraBeta: this.camera ? this.camera.beta : null,
              isRotating: Boolean(e.shiftKey),
              isScaling: Boolean(e.ctrlKey || e.metaKey)
            };
            this.canvas.classList.add("is-pan-grabbing");
            try {
              this.canvas.setPointerCapture(e.pointerId);
            } catch (_) {
            }
          }
        }
      });
      this.canvas.addEventListener("pointermove", (e) => {
        if (activePointers.has(e.pointerId)) {
          activePointers.set(e.pointerId, { x: e.clientX, y: e.clientY, type: e.pointerType });
        }
        if (activePointers.size === 2) {
          if (twoFingerStart && this.boardRoot) {
            const pts = Array.from(activePointers.values());
            const p1 = pts[0];
            const p2 = pts[1];
            const currentAngle = Math.atan2(p2.y - p1.y, p2.x - p1.x);
            const currentDist = Math.hypot(p2.x - p1.x, p2.y - p1.y);
            let deltaAngle = currentAngle - twoFingerStart.lastAngle;
            while (deltaAngle < -Math.PI) deltaAngle += Math.PI * 2;
            while (deltaAngle > Math.PI) deltaAngle -= Math.PI * 2;
            twoFingerStart.accumulatedAngleDelta += Math.abs(deltaAngle);
            if (!twoFingerStart.isConfirmedRotation) {
              const distChange = Math.abs(currentDist - twoFingerStart.initialDist);
              if (twoFingerStart.accumulatedAngleDelta > 0.04) {
                twoFingerStart.isConfirmedRotation = true;
                isTwoFingerRotating = true;
                if (isDraggingBoard) {
                  isDraggingBoard = false;
                  this.isDraggingBoard = false;
                }
              } else if (distChange > 32 && twoFingerStart.accumulatedAngleDelta < 0.02) {
                endTwoFingerRotate();
                if (isDraggingBoard) endBoardDrag(e);
                attachCameraOrbit();
                return;
              }
            }
            if (twoFingerStart.isConfirmedRotation || isTwoFingerRotating) {
              if (e.cancelable) e.preventDefault();
              detachCameraOrbit();
              if (this.camera && typeof twoFingerStart.cameraAlpha === "number") {
                this.camera.alpha = twoFingerStart.cameraAlpha;
                this.camera.beta = twoFingerStart.cameraBeta;
                this.camera.inertialAlphaOffset = 0;
                this.camera.inertialBetaOffset = 0;
                this.camera.inertialRadiusOffset = 0;
                this.camera.inertialPanningX = 0;
                this.camera.inertialPanningY = 0;
              }
              this.setBoardRotation((this.boardRoot.rotation.y || 0) + deltaAngle, false);
              twoFingerStart.lastAngle = currentAngle;
              this._userHasAdjustedCamera = true;
              this.activePreset = null;
              this.updatePresetButtonsUI(null);
              return;
            }
          } else {
            if (isDraggingBoard) {
              endBoardDrag(e);
            }
            return;
          }
        }
        if (activePointers.size > 2) {
          if (isDraggingBoard) endBoardDrag(e);
          endTwoFingerRotate();
          return;
        }
        if (isDraggingBoard && boardDragStart && boardDragStart.pointerId === e.pointerId && this.boardRoot && boardDragPlane) {
          if (e.cancelable) {
            e.preventDefault();
          }
          if (this.camera && typeof boardDragStart.cameraAlpha === "number") {
            this.camera.alpha = boardDragStart.cameraAlpha;
            this.camera.beta = boardDragStart.cameraBeta;
            this.camera.inertialAlphaOffset = 0;
            this.camera.inertialBetaOffset = 0;
            this.camera.inertialRadiusOffset = 0;
            this.camera.inertialPanningX = 0;
            this.camera.inertialPanningY = 0;
          }
          const dx2 = e.clientX - boardDragStart.screenX;
          const dy2 = e.clientY - boardDragStart.screenY;
          if (Math.abs(dx2) > 3 || Math.abs(dy2) > 3) {
            this._userHasAdjustedCamera = true;
            this.activePreset = null;
            this.updatePresetButtonsUI(null);
          }
          if (boardDragStart.isScaling || e.ctrlKey || e.metaKey) {
            const scaleDelta = (boardDragStart.screenY - e.clientY + (e.clientX - boardDragStart.screenX)) * 5e-3;
            this.setBoardScale(boardDragStart.startScale + scaleDelta, false);
            this.canvas.style.cursor = "nwse-resize";
          } else if (boardDragStart.isRotating || e.shiftKey) {
            const rotSpeed = 0.015;
            this.setBoardRotation(boardDragStart.startRotY + dx2 * rotSpeed);
            this.canvas.style.cursor = "ew-resize";
          } else {
            const rect = this.canvas.getBoundingClientRect();
            const px = e.clientX - rect.left;
            const py = e.clientY - rect.top;
            const ray = this.scene.createPickingRay(
              px,
              py,
              this.BABYLON.Matrix.Identity(),
              this.camera
            );
            const dist2 = ray ? ray.intersectsPlane(boardDragPlane) : null;
            if (dist2 !== null && isFinite(dist2)) {
              const currentHit = ray.origin.add(ray.direction.scale(dist2));
              const deltaX = currentHit.x - boardDragStart.hit.x;
              const deltaZ = currentHit.z - boardDragStart.hit.z;
              this.setBoardPosition(
                boardDragStart.startPos.x + deltaX,
                boardDragStart.startPos.z + deltaZ,
                false
              );
            }
            this.canvas.style.cursor = "grabbing";
          }
        } else if (!isDraggingBoard && this.scene && this.canvas) {
          if (!this._hoverRaf) {
            const ctrl = Boolean(e.ctrlKey || e.metaKey);
            const shift = Boolean(e.shiftKey);
            this._hoverRaf = requestAnimationFrame(() => {
              this._hoverRaf = null;
              if (this.isDestroyed || !this.scene || !this.canvas || isDraggingBoard) return;
              const pick = this.scene.pick(this.scene.pointerX, this.scene.pointerY, (m) => {
                return m && (m.metadata?.obstacle || this.isBoardMesh(m));
              });
              if (pick && pick.hit) {
                if (pick.pickedMesh?.metadata?.obstacle) {
                  this.canvas.style.cursor = "pointer";
                } else if (this.isBoardMesh(pick.pickedMesh)) {
                  if (ctrl) {
                    this.canvas.style.cursor = "nwse-resize";
                  } else if (shift) {
                    this.canvas.style.cursor = "ew-resize";
                  } else {
                    this.canvas.style.cursor = "grab";
                  }
                } else if (this.isPanMode) {
                  this.canvas.style.cursor = "grab";
                } else {
                  this.canvas.style.cursor = "default";
                }
              } else if (this.isPanMode) {
                this.canvas.style.cursor = "grab";
              } else {
                this.canvas.style.cursor = "default";
              }
            });
          }
        }
      });
      this.canvas.addEventListener("pointerup", (e) => {
        activePointers.delete(e.pointerId);
        if (activePointers.size < 2) {
          endTwoFingerRotate();
        }
        if (isDraggingBoard && boardDragStart && boardDragStart.pointerId === e.pointerId) {
          endBoardDrag(e);
        }
        if (activePointers.size === 0 && !isDraggingBoard && !isTwoFingerRotating) {
          attachCameraOrbit();
        }
        if (pointerStart) {
          const dx2 = Math.abs(e.clientX - pointerStart.x);
          const dy2 = Math.abs(e.clientY - pointerStart.y);
          if (dx2 > 6 || dy2 > 6) {
            this._userHasAdjustedCamera = true;
            this.activePreset = null;
            this.updatePresetButtonsUI(null);
          } else if (activePointers.size === 0) {
            this._handleBoard3DClick(e);
          }
          pointerStart = null;
        }
      });
      this.canvas.addEventListener("pointercancel", (e) => {
        activePointers.delete(e.pointerId);
        endTwoFingerRotate();
        endBoardDrag(e);
        if (activePointers.size === 0 && !isDraggingBoard && !isTwoFingerRotating) {
          attachCameraOrbit();
        }
        pointerStart = null;
      });
      this.canvas.addEventListener("lostpointercapture", (e) => {
        activePointers.delete(e.pointerId);
        if (activePointers.size < 2) {
          endTwoFingerRotate();
        }
        if (isDraggingBoard && boardDragStart && boardDragStart.pointerId === e.pointerId) {
          endBoardDrag(e);
        }
      });
      this.canvas.addEventListener("pointerleave", (e) => {
        if (!isDraggingBoard && this.canvas) {
          this.canvas.classList.remove("is-pan-grabbing");
        }
      });
      this.canvas.addEventListener("dblclick", (e) => {
        const pick = this.scene ? this.scene.pick(this.scene.pointerX, this.scene.pointerY) : null;
        if (pick && pick.hit && this.isBoardMesh(pick.pickedMesh)) {
          if (e.ctrlKey) {
            this.resetBoardScale(true);
          } else if (e.shiftKey) {
            this.resetBoardTransform(true);
          } else {
            this.resetBoardPosition(true);
          }
        } else {
          this._userHasAdjustedCamera = false;
          this.setCameraPreset("overview");
        }
      });
      this.canvas.setAttribute("tabindex", "0");
      this.canvas.addEventListener("keydown", (e) => {
        if (e.key === "+" || e.key === "=") {
          if (e.ctrlKey) {
            e.preventDefault();
            this.scaleBoard(0.1, true);
          } else {
            e.preventDefault();
            this.zoomIn();
          }
        } else if (e.key === "-" || e.key === "_") {
          if (e.ctrlKey) {
            e.preventDefault();
            this.scaleBoard(-0.1, true);
          } else {
            e.preventDefault();
            this.zoomOut();
          }
        } else if (e.key === "[" || e.key === "{") {
          e.preventDefault();
          this.scaleBoard(-0.1, true);
        } else if (e.key === "]" || e.key === "}") {
          e.preventDefault();
          this.scaleBoard(0.1, true);
        } else if (e.key === "0") {
          e.preventDefault();
          if (e.ctrlKey) {
            this.resetBoardScale(true);
          } else {
            this.setCameraPreset("overview");
          }
        } else if (e.key === "r" || e.key === "R") {
          e.preventDefault();
          if (e.shiftKey) {
            this.resetBoardTransform(true);
          } else {
            this.resetBoardPosition(true);
          }
        } else if (e.key === "p" || e.key === "P" || e.key === "m" || e.key === "M") {
          e.preventDefault();
          this.togglePanMode();
        } else if (e.key === "ArrowLeft") {
          e.preventDefault();
          if (e.shiftKey) this.rotateBoard(-Math.PI / 16);
          else this.moveBoard(-5, 0);
        } else if (e.key === "ArrowRight") {
          e.preventDefault();
          if (e.shiftKey) this.rotateBoard(Math.PI / 16);
          else this.moveBoard(5, 0);
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          this.moveBoard(0, -5);
        } else if (e.key === "ArrowDown") {
          e.preventDefault();
          this.moveBoard(0, 5);
        } else if (e.key === "f" || e.key === "F") {
          e.preventDefault();
          this.toggleFullScreen();
        } else if (e.key === "Escape" && this.isFullScreen()) {
          e.preventDefault();
          this.exitFullScreen();
        }
      });
    }
    /**
     * Sets up bright, radiant Babylon lighting:
     * - High-intensity ambient hemisphere bounce illuminating all angles and recesses
     * - Brilliant overhead table light casting clean, soft contact shadows into hole recesses
     * - Vibrant opposing rim/fill light highlighting wood grain and metallic peg bevels
     */
    setupLighting() {
      const BABYLON = this.BABYLON;
      const isPub = this.boardConfig?.lightingPreset === "warm_pub";
      this.hemiLight = new BABYLON.HemisphericLight(
        "hemiLight",
        new BABYLON.Vector3(0, 1, 0),
        this.scene
      );
      this.hemiLight.intensity = isPub ? 2.1 : 1.95;
      this.hemiLight.diffuse = isPub ? new BABYLON.Color3(1, 0.96, 0.9) : new BABYLON.Color3(1, 1, 1);
      this.hemiLight.groundColor = isPub ? new BABYLON.Color3(0.7, 0.62, 0.52) : new BABYLON.Color3(0.68, 0.68, 0.7);
      this.dirLight = new BABYLON.DirectionalLight(
        "dirLight",
        new BABYLON.Vector3(-0.75, -2.2, -0.65).normalize(),
        this.scene
      );
      this.dirLight.position = new BABYLON.Vector3(30, 80, 35);
      this.dirLight.intensity = isPub ? 3.6 : 3.4;
      this.dirLight.diffuse = isPub ? new BABYLON.Color3(1, 0.98, 0.92) : new BABYLON.Color3(1, 1, 1);
      this.dirLight.specular = new BABYLON.Color3(1, 1, 1);
      this.fillLight = new BABYLON.DirectionalLight(
        "fillLight",
        new BABYLON.Vector3(0.85, -1.3, 0.8).normalize(),
        this.scene
      );
      this.fillLight.position = new BABYLON.Vector3(-30, 60, -25);
      this.fillLight.intensity = isPub ? 2 : 1.85;
      this.fillLight.diffuse = isPub ? new BABYLON.Color3(1, 0.92, 0.82) : new BABYLON.Color3(0.95, 0.97, 1);
      this.fillLight.specular = new BABYLON.Color3(0.85, 0.85, 0.9);
      this.shadowGenerator = new BABYLON.ShadowGenerator(2048, this.dirLight);
      if (BABYLON.ShadowGenerator.FILTER_PCF !== void 0) {
        this.shadowGenerator.filter = BABYLON.ShadowGenerator.FILTER_PCF;
        this.shadowGenerator.filteringQuality = BABYLON.ShadowGenerator.QUALITY_HIGH;
      } else {
        this.shadowGenerator.useBlurExponentialShadowMap = true;
        this.shadowGenerator.blurKernel = 16;
      }
      this.shadowGenerator.bias = 5e-4;
      this.shadowGenerator.normalBias = 12e-4;
      this.shadowGenerator.darkness = 0.3;
      this.shadowGenerator.transparencyShadow = true;
      this.setBrightness(this.brightnessPercent, false);
    }
    /**
     * Adjusts 3D board lighting brightness dynamically and persists preference.
     * @param {number} percent - Brightness percentage (40 to 180, default 100)
     * @param {boolean} [save=true] - Whether to save to localStorage
     */
    setBrightness(percent, save = true) {
      const val = Math.max(30, Math.min(220, Number(percent) || 100));
      this.brightnessPercent = val;
      if (save && typeof localStorage !== "undefined") {
        try {
          localStorage.setItem("cc_board_3d_brightness", String(Math.round(val)));
        } catch (_) {
        }
      }
      if (!this.scene) return;
      const mult = val / 100;
      const isPub = this.boardConfig?.lightingPreset === "warm_pub";
      const baseHemi = isPub ? 1.45 : 1.3;
      const baseDir = isPub ? 2.6 : 2.4;
      const baseFill = isPub ? 1.2 : 1;
      const baseExposure = 1.15;
      if (this.hemiLight) {
        this.hemiLight.intensity = baseHemi * mult;
      }
      if (this.dirLight) {
        this.dirLight.intensity = baseDir * mult;
      }
      if (this.fillLight) {
        this.fillLight.intensity = baseFill * mult;
      }
      if (this.scene.imageProcessingConfiguration) {
        this.scene.imageProcessingConfiguration.exposure = baseExposure * Math.pow(mult, 0.4);
      }
      if (this.presetsToolbar) {
        const slider = this.presetsToolbar.querySelector(".slider-3d-brightness");
        const label = this.presetsToolbar.querySelector(".val-3d-brightness");
        if (slider && Number(slider.value) !== val) {
          slider.value = String(Math.round(val));
        }
        if (label) {
          label.textContent = `${Math.round(val)}%`;
        }
      }
    }
    /**
     * Post-processing configuration.
     */
    setupPostProcessing() {
      if (this.scene && this.scene.imageProcessingConfiguration) {
        this.scene.imageProcessingConfiguration.exposure = 1.35;
        this.scene.imageProcessingConfiguration.contrast = 1.1;
      }
    }
    /**
     * Resolves the active table environment setting.
     * If 'auto', detects current brand mood (Pints -> Pub, Clash -> Raceway, Adult -> Lounge, Crazy -> Vegas).
     * @returns {'pub'|'vegas'|'raceway'|'lounge'|'studio'}
     */
    getTableEnvironment() {
      let env = this.tableEnvironment || this.settings?.tableEnvironment || "auto";
      if (env === "auto") {
        const brand = this.options.brand || this.settings?.brand || (typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : "crazy");
        if (brand === "pints") return "pub";
        if (brand === "clash") return "raceway";
        if (brand === "adult") return "lounge";
        return "vegas";
      }
      if (env === "thunderdome") return "raceway";
      if (env === "velvet") return "lounge";
      return env;
    }
    /**
     * Sets and applies the active 3D table environment in real-time.
     * @param {string} envId - 'auto' | 'pub' | 'vegas' | 'raceway' | 'lounge' | 'studio'
     */
    setTableEnvironment(envId) {
      if (!envId) return;
      this.tableEnvironment = envId;
      if (this.settings) this.settings.tableEnvironment = envId;
      if (typeof localStorage !== "undefined") {
        try {
          localStorage.setItem("cc_board_3d_table_env", envId);
        } catch (_) {
        }
      }
      const domSel = typeof document !== "undefined" ? document.getElementById("optTableEnvironment") : null;
      if (domSel && domSel.value !== envId) {
        domSel.value = envId;
      }
      this.setupTableEnvironment();
      this.updateTableEnvironmentToolbarUI();
    }
    /**
     * Synchronizes active table environment state with DOM selector or toolbar if present.
     */
    updateTableEnvironmentToolbarUI() {
      const domSel = typeof document !== "undefined" ? document.getElementById("optTableEnvironment") : null;
      if (domSel && this.tableEnvironment && domSel.value !== this.tableEnvironment) {
        domSel.value = this.tableEnvironment;
      }
    }
    /**
     * Constructs or updates the large 3D grounded table slab underneath the board
     * with custom themed PBR surfaces, coasters, card baize, raceway asphalt, or wood grain.
     */
    setupTableEnvironment() {
      if (!this.scene || !this.BABYLON || this.isDestroyed) return;
      this.clearTableEnvironment();
      const BABYLON = this.BABYLON;
      const envId = this.getTableEnvironment();
      const bounds = this.boardBounds || this.getBoardBounds();
      const activeTracks = this.activeTracks || ["p1", "p2"];
      this.roomData = RoomCatalog3D.buildRoom(this.scene, BABYLON, envId, {
        bounds,
        activeTracks,
        seatCount: activeTracks.length,
        settings: this.settings
      });
      if (this.roomData && this.roomData.tableMesh) {
        this.tableMesh = this.roomData.tableMesh;
      }
      this.applyEnvironmentAtmosphere(envId);
      if (this.camera && this.roomData?.dims) {
        const { roomW, roomD } = this.roomData.dims;
        const roomLimit = Math.min(roomW, roomD) * 0.46;
        if (!this.camera.upperRadiusLimit || this.camera.upperRadiusLimit < roomLimit) {
          this.camera.upperRadiusLimit = roomLimit;
        }
        if (this.camera.upperRadiusLimit && this.camera.radius > this.camera.upperRadiusLimit) {
          this.camera.radius = this.camera.upperRadiusLimit;
        }
      }
      try {
        const dims = this.roomData?.dims || {};
        const tableSurfaceY = dims.tableSurfaceY ?? (bounds?.min?.y != null ? bounds.min.y - 0.08 : -0.88);
        const tableW = dims.tableW ?? 140;
        const tableD = dims.tableD ?? 100;
        this.cardEngine = new CardEngine3D(this.scene, BABYLON, {
          tableSurfaceY,
          tableW,
          tableD,
          boardBounds: bounds,
          chairRoots: this.roomData?.chairRoots || [],
          backStyle: this.options.cardBack || this.settings?.cardBack || "classic-blue",
          onCardClick: (card, cardMesh) => this.handle3DCardClick(card, cardMesh),
          onCardHover: (card, isHovered) => this.handle3DCardHover(card, isHovered)
        });
      } catch (e) {
        console.warn("[BoardRenderer3D] Could not initialize CardEngine3D:", e);
      }
      try {
        this.seatManager = new SeatManager3D(this.scene, BABYLON, {
          dims: this.roomData?.dims,
          chairRoots: this.roomData?.chairRoots || []
        });
        const initialPlayers = this.getInitialSeatedPlayers();
        this.seatManager.setupSeats(initialPlayers, activeTracks.length, this.roomData?.chairRoots);
        const curScores = (typeof window !== "undefined" ? window.state?.scores : null) || this.lastSyncedState?.scores;
        if (curScores) {
          this.seatManager.updateScores(curScores);
        }
        if (this.cardEngine) {
          this.cardEngine.seatManager = this.seatManager;
          this.cardEngine.chairRoots = this.roomData?.chairRoots || [];
        }
      } catch (e) {
        console.warn("[BoardRenderer3D] Could not initialize SeatManager3D:", e);
      }
    }
    /**
     * Resolves initial player avatars, display names, and scores for active seats.
     * @returns {Array<Object>}
     */
    getInitialSeatedPlayers() {
      const activeTracks = this.activeTracks || ["p1", "p2"];
      const players = [];
      for (let i = 0; i < activeTracks.length; i++) {
        const seat = activeTracks[i] || `p${i + 1}`;
        const avatarId = this.options.avatarMap?.[seat] || (seat === "p1" ? this.settings?.avatar || "joker" : seat === "p2" ? "king" : "shark");
        const name = this.options.playerNames?.[seat] || (seat === "p1" ? this.settings?.playerName || "You" : seat === "p2" ? "Computer" : `Player ${i + 1}`);
        const score = this.pegState?.[seat]?.front || 0;
        players.push({
          id: seat,
          name,
          avatarId,
          score,
          isTurn: i === 0
        });
      }
      return players;
    }
    /**
     * Updates player data on a 3D seated avatar.
     * @param {string} seat - 'p1', 'p2', etc.
     * @param {Object} data
     */
    updateSeatPlayer(seat, data) {
      if (this.seatManager) this.seatManager.updatePlayer(seat, data);
    }
    /**
     * Sets the active player's turn halo and status badge.
     * @param {string} seat - 'p1', 'p2', etc.
     */
    setActiveTurn(seat) {
      if (this.seatManager) this.seatManager.setActiveTurn(seat);
    }
    /**
     * Updates scores displayed on 3D floating nameplates.
     * @param {Object} scores - { p1: 12, p2: 18, ... }
     */
    updateSeatScores(scores) {
      if (this.seatManager) this.seatManager.updateScores(scores);
    }
    /**
     * Shows an emoji reaction bubble above a seated player's avatar.
     * @param {string} seat
     * @param {string} emoji
     */
    showSeatReaction(seat, emoji) {
      if (this.seatManager) this.seatManager.showReaction(seat, emoji);
    }
    /**
     * Toggles visibility of the local human player 3D avatar figure.
     * @param {boolean} visible
     */
    setLocalPlayerVisible(visible) {
      if (this.seatManager) this.seatManager.setLocalPlayerVisible(visible);
    }
    /**
     * Sets transparency across all computer player avatars in the 3D scene.
     * @param {boolean} isTransparent
     * @param {number} [alpha=0.6]
     */
    setComputerAvatarsTransparent(isTransparent, alpha = 0.6) {
      if (this.seatManager) this.seatManager.setComputerAvatarsTransparent(isTransparent, alpha);
    }
    /**
     * Toggles avatar wrapping on head sphere across all computer player avatars.
     * @param {boolean} wrap
     */
    setComputerAvatarsWrapOnHead(wrap) {
      if (this.seatManager) this.seatManager.setComputerAvatarsWrapOnHead(wrap);
    }
    /**
     * Renders a player's hand fan in 3D in front of their seat.
     * @param {string} seat - 'p1', 'p2', etc.
     * @param {Array<Object>} cards
     * @param {Object} [options={}]
     * @returns {Array<CardMesh3D>}
     */
    renderPlayerHand(seat, cards, options = {}) {
      if (this.cardEngine) return this.cardEngine.renderHandFan(seat, cards, options);
      return [];
    }
    /**
     * Renders played cards in the central pegging pile on the table.
     * @param {Array<Object>} cards
     */
    renderPlayPile(cards, options = {}) {
      if (!this.cardEngine) return;
      const state3 = (typeof window !== "undefined" ? window.state : null) || {};
      const me = this.mySeat || "p1";
      const isPlayPhase = state3.phase === "play" || state3.phase === "pegging";
      const normalizeSeat = (s) => {
        if (!s) return "";
        if (this.seatManager && typeof this.seatManager.normalizeSeatId === "function") {
          return this.seatManager.normalizeSeatId(s);
        }
        if (s === "you" || s === "player1" || s === "team1") return "p1";
        if (s === "cpu" || s === "player2" || s === "team2") return "p2";
        if (s === "player3" || s === "team3") return "p3";
        if (s === "player4" || s === "team4") return "p4";
        return s;
      };
      const activeSeat = isPlayPhase && state3.turn ? normalizeSeat(state3.turn) : options.turnSeat || me;
      return this.cardEngine.renderPlayPile(cards, {
        localSeat: me,
        turnSeat: activeSeat || me,
        faceUp: options.faceUp !== void 0 ? options.faceUp : !state3.pileFaceDown,
        ...options
      });
    }
    /**
     * Renders the starter deck and cut starter card on the table.
     * @param {Object} starterCard
     * @param {Object} [options={}]
     */
    renderStarterDeck(starterCard, options = {}) {
      if (this.cardEngine) return this.cardEngine.renderStarterDeck(starterCard, options);
    }
    /**
     * Performs cutting the starter deck in the 3D room.
     * Plays the 3D cut animation, snap audio, and invokes the game engine cut logic.
     * @param {Object} [context={}]
     */
    do3DCutStarter(context = {}) {
      if (this._isCuttingStarter) return;
      this._isCuttingStarter = true;
      if (this.cardEngine && typeof this.cardEngine.animateDeckCut === "function") {
        try {
          this.cardEngine.animateDeckCut();
        } catch (_) {
        }
      }
      try {
        const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
        if (sfx3 && typeof sfx3.snap === "function") sfx3.snap();
      } catch (_) {
      }
      const domCut = typeof document !== "undefined" ? document.getElementById("btnCutStarter") || document.getElementById("dealDeck") : null;
      if (domCut && typeof domCut.click === "function" && domCut.offsetParent !== null) {
        domCut.click();
      } else if (typeof window !== "undefined" && typeof window.poneDoCutStarter === "function") {
        window.poneDoCutStarter(context);
      } else {
        const poneCut = context.poneDoCutStarter || (typeof window !== "undefined" ? window.CrazyCribbage?.GameEngine?.poneDoCutStarter : null);
        if (typeof poneCut === "function") poneCut(context);
      }
      setTimeout(() => {
        this._isCuttingStarter = false;
      }, 1200);
    }
    /**
     * Performs picking a card from the cut fan for initial deal in the 3D room.
     * @param {number} index
     * @param {Object} [context={}]
     */
    do3DPickCut(index, context = {}) {
      const isOnline2 = typeof context.isOnline === "function" ? context.isOnline : typeof window !== "undefined" && typeof window.isOnline === "function" ? window.isOnline : () => false;
      const mySeat3 = typeof context.mySeat === "function" ? context.mySeat : typeof window !== "undefined" && typeof window.mySeat === "function" ? window.mySeat : () => "p1";
      const curState = (typeof window !== "undefined" ? window.state : null) || this.lastSyncedState;
      const curTurn = curState?.cutTurn || "p1";
      const seat = isOnline2() ? mySeat3() : curTurn;
      const pickCut2 = context.pickCut || (typeof window !== "undefined" ? window.pickCut || window.CrazyCribbage?.GameEngine?.pickCut : null);
      if (typeof pickCut2 === "function") {
        pickCut2(index, seat, context);
      }
    }
    /**
     * Renders the crib cards in the crib zone.
     * @param {Array<Object>} cards
     * @param {boolean} [isRevealed=false]
     */
    renderCrib(cards, isRevealed = false) {
      if (this.cardEngine) return this.cardEngine.renderCrib(cards, isRevealed);
    }
    /**
     * Synchronizes all 3D cards in the scene based on game state.
     * @param {Object} cardState - { hands, playPile, starter, starterOptions, crib, cribRevealed, revealAll }
     */
    syncCards(cardState = {}) {
      if (!this.cardEngine) return;
      if (this.boardBounds && !this.cardEngine.boardBounds) {
        this.cardEngine.boardBounds = this.boardBounds;
      }
      if (cardState.hands) {
        for (const [seat, cards] of Object.entries(cardState.hands)) {
          this.cardEngine.renderHandFan(seat, cards, { faceUp: seat === "p1" || cardState.revealAll, isLocal: seat === "p1" });
        }
      }
      if (cardState.playPile) {
        this.cardEngine.renderPlayPile(cardState.playPile);
      }
      if (cardState.starters !== void 0 || cardState.starter !== void 0) {
        const starters = cardState.starters && cardState.starters.length ? cardState.starters : cardState.starter ? [cardState.starter] : [];
        this.cardEngine.renderStarterDeck(starters.length ? starters : null, cardState.starterOptions || {});
      }
      if (cardState.crib) {
        this.cardEngine.renderCrib(cardState.crib, cardState.cribRevealed);
      }
    }
    /**
     * Handles user interaction when clicking a 3D playing card in their hand or on the table.
     * Routes the action into deck cutting, discard picking, pegging card play, or custom callbacks.
     * @param {Object} card
     * @param {Object} cardMesh
     */
    handle3DCardClick(card, cardMesh) {
      if (cardMesh && (cardMesh.isDeck || cardMesh.owner === "deck" || cardMesh.isCutPrompt)) {
        const curState = (typeof window !== "undefined" ? window.state : null) || this.lastSyncedState;
        if (curState && curState.phase === "cut") {
          const cutDeck = curState.cutDeck || [];
          const midIdx = Math.floor(cutDeck.length / 2);
          this.do3DPickCut(midIdx);
          return;
        }
        this.do3DCutStarter();
        return;
      }
      if (cardMesh && (cardMesh.isCutFan || cardMesh.cutIndex != null)) {
        this.do3DPickCut(cardMesh.cutIndex);
        return;
      }
      if (typeof this.options.onCardClick === "function") {
        this.options.onCardClick(card, cardMesh);
        return;
      }
      if (typeof window === "undefined") return;
      const state3 = window.state;
      const me = typeof window.mySeat === "function" ? window.mySeat() : "p1";
      if (!state3 || !card) return;
      const isDrawPhase = state3.phase === "draw-1" || state3.phase === "draw-2" || state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2";
      if (state3.phase === "discard" || state3.phase === "discard-p2" || isDrawPhase) {
        if (typeof window.onYouCard === "function") {
          window.onYouCard(card);
        }
      } else if (state3.phase === "play" || state3.phase === "pegging") {
        if (state3.frozen || state3.paused || state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || !state3.turn) return;
        const cardOwner = cardMesh?.owner || card?.owner;
        const isOnline2 = typeof this.options.isOnline === "function" ? this.options.isOnline : typeof window !== "undefined" && typeof window.isOnline === "function" ? window.isOnline : () => false;
        const isSeatHuman2 = typeof this.options.isSeatHuman === "function" ? this.options.isSeatHuman : typeof window !== "undefined" && typeof window.isSeatHuman === "function" ? window.isSeatHuman : (s) => s ? s === me : false;
        const isMyTurn = state3.turn === me || !isOnline2() && (state3.turn === "p1" || state3.turn === "you");
        if (isMyTurn) {
          if (cardOwner && cardOwner !== me && cardOwner !== "p1" && cardOwner !== "you") return;
          if (typeof window.onYouCard === "function") {
            window.onYouCard(card);
          }
        } else if (!isOnline2() && isSeatHuman2(state3.turn)) {
          if (cardOwner && cardOwner !== state3.turn) return;
          if (state3.turn === "p2" && typeof window.onCpuCard === "function") {
            window.onCpuCard(card);
          } else if (typeof window.playCard === "function") {
            window.playCard(state3.turn, card);
          }
        }
      } else if (state3.phase === "assign" || state3.phase === "assign-p2") {
        if (state3.assignTarget === "starter") {
          const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
          const unassignedWild = starters.find((c) => Boolean(c && c.wild) && !c.playAs);
          if (unassignedWild && typeof window.openWildPick === "function") {
            window.openWildPick(unassignedWild, "starter");
          }
        } else {
          if (state3.phase === "assign-p2" && typeof window.onCpuCard === "function") {
            window.onCpuCard(card);
          } else if (typeof window.onYouCard === "function") {
            window.onYouCard(card);
          }
        }
      } else if (state3.phase === "pick-crib" && typeof window.onPickCribCard === "function") {
        const pickSeat = cardMesh?.owner || state3.currentPickPone || "p2";
        window.onPickCribCard(pickSeat, card);
      }
    }
    /**
     * Handles hovering over 3D playing cards (e.g. coach preview during discard).
     * @param {Object} card
     * @param {boolean} isHovered
     */
    handle3DCardHover(card, isHovered) {
      if (typeof this.options.onCardHover === "function") {
        this.options.onCardHover(card, isHovered);
        return;
      }
      if (typeof window === "undefined") return;
      const state3 = window.state;
      const settings3 = window.settings;
      if (settings3?.coach === "on" && state3?.phase === "discard" && typeof window.updateCoachDisplay === "function") {
        if (isHovered && card) {
          const me = typeof window.mySeat === "function" ? window.mySeat() : "p1";
          const getHand = typeof window.getSeatHand === "function" ? window.getSeatHand : () => [];
          let sim = getHand(me).filter((x) => state3.selected?.includes(x.id));
          if (!state3.selected?.includes(card.id)) {
            sim = sim.concat([card]).slice(0, 2);
          }
          if (sim.length === 2) {
            window.updateCoachDisplay(sim);
          }
        } else {
          window.updateCoachDisplay();
        }
      }
    }
    /**
     * Mounts the floating in-game action HUD overlay on top of the 3D canvas.
     */
    create3DHUD() {
      if (typeof document === "undefined" || !this.container || this.hud3DOverlay) return;
      const hud = document.createElement("div");
      hud.className = "board-3d-hud-wrap";
      hud.setAttribute("aria-label", "3D In-Game Tabletop HUD");
      const dealerPill = document.createElement("div");
      dealerPill.className = "hud-3d-dealer";
      dealerPill.style.display = "none";
      hud.appendChild(dealerPill);
      const scorePill = document.createElement("div");
      scorePill.className = "hud-3d-player-score";
      scorePill.style.display = "none";
      hud.appendChild(scorePill);
      const countPill = document.createElement("div");
      countPill.className = "hud-3d-count";
      countPill.style.display = "none";
      hud.appendChild(countPill);
      const playPromptPill = document.createElement("div");
      playPromptPill.className = "hud-3d-play-prompt";
      playPromptPill.style.display = "none";
      hud.appendChild(playPromptPill);
      const cutBtn = document.createElement("button");
      cutBtn.type = "button";
      cutBtn.className = "btn-3d-hud-action btn-3d-hud-cut";
      cutBtn.textContent = "\u{1F3AF} Cut Starter Card";
      cutBtn.style.display = "none";
      cutBtn.addEventListener("click", () => {
        const curState = (typeof window !== "undefined" ? window.state : null) || this.lastSyncedState;
        if (curState && curState.phase === "cut") {
          const cutDeck = curState.cutDeck || [];
          const midIdx = Math.floor(cutDeck.length / 2);
          this.do3DPickCut(midIdx);
          return;
        }
        this.do3DCutStarter();
      });
      hud.appendChild(cutBtn);
      const discardBtn = document.createElement("button");
      discardBtn.type = "button";
      discardBtn.className = "btn-3d-hud-action btn-3d-hud-discard";
      discardBtn.textContent = "Discard Selected";
      discardBtn.style.display = "none";
      discardBtn.addEventListener("click", () => {
        const curState = typeof window !== "undefined" ? window.state : null;
        if (curState && curState.phase === "pick-crib") {
          if (typeof window !== "undefined" && typeof window.confirmPickCrib === "function") {
            window.confirmPickCrib();
            return;
          }
        }
        if (curState && (curState.phase === "draw-1" || curState.phase === "draw-2" || curState.phase === "draw-1-p2" || curState.phase === "draw-2-p2")) {
          if (typeof window !== "undefined" && typeof window.confirmDraw === "function") {
            window.confirmDraw();
            return;
          }
        }
        const domDiscard = document.getElementById("btnDiscard");
        if (domDiscard && typeof domDiscard.click === "function") {
          domDiscard.click();
        } else if (typeof window !== "undefined" && typeof window.confirmDiscard === "function") {
          window.confirmDiscard();
        }
      });
      hud.appendChild(discardBtn);
      const nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = "btn-3d-hud-action btn-3d-hud-next";
      nextBtn.textContent = "Continue \u25B6";
      nextBtn.style.display = "none";
      nextBtn.addEventListener("click", () => {
        const domNext = document.getElementById("btnNext");
        if (domNext) domNext.click();
      });
      hud.appendChild(nextBtn);
      const showCountPill = document.createElement("div");
      showCountPill.className = "hud-3d-show-count";
      showCountPill.style.display = "none";
      hud.appendChild(showCountPill);
      const nextHandBtn = document.createElement("button");
      nextHandBtn.type = "button";
      nextHandBtn.className = "btn-3d-hud-action btn-3d-hud-next-hand";
      nextHandBtn.textContent = "Next Hand \u25B6";
      nextHandBtn.style.display = "none";
      nextHandBtn.addEventListener("click", () => {
        const domNextHand = document.getElementById("btnNextHand");
        if (domNextHand && typeof domNextHand.click === "function") {
          domNextHand.click();
        } else {
          const curState = (typeof window !== "undefined" ? window.state : null) || state;
          if (curState) {
            curState.showModal = null;
            curState.chutesAndLaddersTriggered = false;
            curState.chutesAndLaddersTiedScore = null;
          }
          if (typeof window !== "undefined") {
            if (typeof window.hideModal === "function") window.hideModal();
            if (typeof window.nextSeat === "function" && curState) curState.dealer = window.nextSeat(curState.dealer);
            if (curState) curState.revealCrib = false;
            if (typeof window.newHand === "function") window.newHand();
            if (typeof window.netPush === "function") window.netPush({ modal: "hide" });
          }
        }
      });
      hud.appendChild(nextHandBtn);
      this.container.appendChild(hud);
      this.hud3DOverlay = hud;
    }
    /**
     * Updates state-driven visibility and labels of the floating 3D HUD controls.
     * @param {Object} state
     * @param {Object} context
     */
    update3DHUD(state3 = {}, context = {}) {
      if (typeof document === "undefined" || !this.container) return;
      if (!this.hud3DOverlay) {
        this.create3DHUD();
      }
      if (!this.hud3DOverlay) return;
      const me = context.me || (typeof window !== "undefined" && typeof window.mySeat === "function" ? window.mySeat() : "p1");
      const isPlayPhase = state3.phase === "play" || state3.phase === "pegging";
      const isCutStarter = state3.phase === "cut-starter";
      const isDiscard = state3.phase === "discard" || state3.phase === "discard-p2";
      const dealerEl = this.hud3DOverlay.querySelector(".hud-3d-dealer");
      if (dealerEl) {
        if (state3.dealer) {
          dealerEl.style.display = "inline-flex";
          const isMeDeal = state3.dealer === me || state3.dealer === "you" || state3.dealer === "p1";
          const pName2 = context.pName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : (s) => s === "p1" ? "You" : s === "p2" ? "Opponent" : String(s).toUpperCase());
          const dealerLabel = isMeDeal ? "You (Your Crib)" : `${pName2(state3.dealer)} (Crib)`;
          dealerEl.innerHTML = `<span class="hud-3d-dealer-star" aria-hidden="true">\u2605</span> <span>Dealer: ${dealerLabel}</span>`;
          dealerEl.classList.toggle("is-me", isMeDeal);
          dealerEl.title = isMeDeal ? "You are the dealer. You count your hand and the crib at the end of the round." : `${pName2(state3.dealer)} is the dealer and counts the crib.`;
        } else {
          dealerEl.style.display = "none";
        }
      }
      const countEl = this.hud3DOverlay.querySelector(".hud-3d-count");
      if (countEl) {
        if (isPlayPhase) {
          countEl.style.display = "inline-flex";
          const curCount = state3.count != null ? state3.count : 0;
          countEl.textContent = `Count: ${curCount} / 31`;
          countEl.classList.toggle("is-fifteen", curCount === 15);
          countEl.classList.toggle("is-thirtyone", curCount === 31);
        } else {
          countEl.style.display = "none";
        }
      }
      const scoreEl = this.hud3DOverlay.querySelector(".hud-3d-player-score");
      if (scoreEl) {
        const activeSeat = isPlayPhase ? state3.passingTo || state3.turn || me || "p1" : me || "p1";
        const isMyTurn = activeSeat === me || activeSeat === "p1" || activeSeat === "you";
        const seatNameFn = typeof context.seatName === "function" ? context.seatName : typeof window !== "undefined" && typeof window.seatName === "function" ? window.seatName : (s) => s === "p1" ? "You" : s === "p2" ? "Player 2" : String(s).toUpperCase();
        const currentName = isMyTurn ? "You" : seatNameFn(activeSeat);
        const currentScore = this.seatManager ? this.seatManager.resolveSeatScore(activeSeat, state3.scores) : this.getTrackScore(state3.scores, activeSeat) || 0;
        const targetLimit = Number(this.targetHoles) || typeof window !== "undefined" && window.settings && Number(window.settings.target) || 121;
        scoreEl.style.display = "inline-flex";
        scoreEl.innerHTML = `<span class="hud-3d-score-icon" aria-hidden="true">\u{1F3C6}</span> <span><strong>${currentName}:</strong> ${currentScore} / ${targetLimit} pts</span>`;
        scoreEl.title = `${currentName}'s score: ${currentScore} pts (Goal: ${targetLimit})`;
      }
      const playPromptEl = this.hud3DOverlay.querySelector(".hud-3d-play-prompt");
      if (playPromptEl) {
        const activeTurn = state3.passingTo || state3.turn;
        const isSeatHuman2 = typeof context.isSeatHuman === "function" ? context.isSeatHuman : typeof window !== "undefined" && typeof window.isSeatHuman === "function" ? window.isSeatHuman : () => true;
        const isOnline2 = typeof context.isOnline === "function" ? context.isOnline : typeof window !== "undefined" && typeof window.isOnline === "function" ? window.isOnline : () => false;
        const seatName3 = typeof context.seatName === "function" ? context.seatName : typeof window !== "undefined" && typeof window.seatName === "function" ? window.seatName : (s) => s === "p1" ? "You" : s === "p2" ? "Opponent" : String(s).toUpperCase();
        const isHumanTurn = isPlayPhase && !state3.frozen && (isOnline2() ? activeTurn === me : isSeatHuman2(activeTurn));
        if (isHumanTurn) {
          playPromptEl.style.display = "inline-flex";
          const isMyTurn = activeTurn === me || !isOnline2() && (activeTurn === "p1" || activeTurn === "you");
          const turnScore = this.seatManager ? this.seatManager.resolveSeatScore(activeTurn, state3.scores) : this.getTrackScore(state3.scores, activeTurn) || 0;
          const label = isMyTurn ? `Your Turn: Play a Card (${turnScore} pts)` : `${seatName3(activeTurn)}: Play a Card (${turnScore} pts)`;
          playPromptEl.innerHTML = `<span class="hud-3d-prompt-icon" aria-hidden="true">\u{1F3B4}</span> <span><strong>${label}</strong></span>`;
        } else {
          playPromptEl.style.display = "none";
        }
      }
      const showCountEl = this.hud3DOverlay.querySelector(".hud-3d-show-count");
      const isShowPhase = state3.phase === "show" || state3.phase === "show-crib";
      if (showCountEl) {
        if (isShowPhase && state3.showAct && state3.showAct !== "done") {
          showCountEl.style.display = "inline-flex";
          const isCrib = state3.showAct === "crib";
          const pName2 = context.pName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : (s) => s === "p1" ? "You" : s === "p2" ? "Opponent" : String(s).toUpperCase());
          const pack = state3.lastShow && state3.lastShow[state3.showAct] || null;
          const icon = isCrib ? "\u{1F9FA}" : "\u{1F3B4}";
          const actTitle = pack?.title || (isCrib ? "The Crib" : `${pName2(state3.showAct)} Hand`);
          const total = pack?.score?.total != null ? pack.score.total : state3.showRun || 0;
          const line = state3.showMeter?.line || "";
          showCountEl.innerHTML = `<span class="hud-3d-show-icon">${icon}</span> <span><strong>${actTitle}:</strong> ${total} pts${line ? ` (${line})` : ""}</span>`;
        } else {
          showCountEl.style.display = "none";
        }
      }
      const cutBtn = this.hud3DOverlay.querySelector(".btn-3d-hud-cut");
      if (cutBtn) {
        const isDealCut = state3.phase === "cut";
        const isSeatHuman2 = typeof context.isSeatHuman === "function" ? context.isSeatHuman : typeof window !== "undefined" && typeof window.isSeatHuman === "function" ? window.isSeatHuman : () => true;
        const isOnline2 = typeof context.isOnline === "function" ? context.isOnline : typeof window !== "undefined" && typeof window.isOnline === "function" ? window.isOnline : () => false;
        if (isDealCut) {
          const isPassingDevice = !isOnline2() && Boolean(state3.passingTo);
          const curTurn = state3.cutTurn || "p1";
          const isMyDealCut = !isPassingDevice && (isOnline2() ? (!state3.cutPicks || !state3.cutPicks[me]) && state3.cutTurn === me : isSeatHuman2(curTurn) && (!state3.cutPicks || !state3.cutPicks[curTurn]));
          cutBtn.style.display = isMyDealCut ? "inline-flex" : "none";
          cutBtn.textContent = "\u2702\uFE0F Cut the Deck";
        } else {
          const pone = state3.cutTurn && isCutStarter ? state3.cutTurn : state3.dealer === "p1" ? "p2" : "p1";
          const isMyCut = isCutStarter && (pone === me || !isOnline2() && isSeatHuman2(pone) || pone === "p1");
          cutBtn.style.display = isMyCut ? "inline-flex" : "none";
          const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || this.settings || {};
          const isProgCut = Boolean(settings3 && settings3.optProgressiveCut && (settings3.playerCount || 2) === 2);
          const cutCount = isProgCut ? Math.max(1, Math.floor((state3.handsCompleted || 0) / 2) + 1) : 1;
          cutBtn.textContent = cutCount > 1 ? `\u{1F3AF} Cut ${cutCount} Starter Cards` : "\u{1F3AF} Cut Starter Card";
        }
      }
      const discardBtn = this.hud3DOverlay.querySelector(".btn-3d-hud-discard");
      if (discardBtn) {
        const selLen = state3.selected?.length || 0;
        const isDrawPhase = state3.phase === "draw-1" || state3.phase === "draw-2" || state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2";
        if (state3.phase === "pick-crib") {
          const pickN = state3.pickN || 2;
          const canConfirmPick = selLen === pickN;
          discardBtn.style.display = canConfirmPick ? "inline-flex" : "none";
          if (canConfirmPick) {
            discardBtn.textContent = `Take (${pickN}) to your crib`;
          }
        } else if (isDrawPhase) {
          discardBtn.style.display = "inline-flex";
          if (selLen === 0) {
            discardBtn.textContent = "Keep Hand (Draw 0)";
          } else {
            discardBtn.textContent = `Discard & Draw (${selLen})`;
          }
        } else {
          const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || this.settings || {};
          const count = Number(context.count || settings3 && settings3.playerCount || (typeof window !== "undefined" && typeof window.getPlayerCount === "function" ? window.getPlayerCount(settings3) : 2)) || 2;
          const isCanadianDoubles = Boolean(settings3 && settings3.optCanadianDoubles && count === 4);
          const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
          let requiredDiscardN = isCanadianDoubles ? 2 : count >= 3 ? 1 : is7Card ? 2 : settings3 && settings3.deal === "super" ? 3 : 2;
          if (settings3 && (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
            const curSeat = state3.currentHumanDiscard || me;
            requiredDiscardN = curSeat === state3.dealer ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
          }
          const canDiscard = isDiscard && selLen === requiredDiscardN;
          discardBtn.style.display = canDiscard ? "inline-flex" : "none";
          if (canDiscard) {
            if (settings3 && (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
              const curSeat = state3.currentHumanDiscard || me;
              const target = curSeat === state3.dealer ? "Crib" : "Dealer's Hand";
              discardBtn.textContent = `Discard (${selLen}) to ${target}`;
            } else {
              discardBtn.textContent = requiredDiscardN === 1 ? "Discard Selected" : `Discard Selected (${selLen})`;
            }
          }
        }
      }
      const nextBtn = this.hud3DOverlay.querySelector(".btn-3d-hud-next");
      if (nextBtn) {
        const showNext = state3.phase === "await";
        nextBtn.style.display = showNext ? "inline-flex" : "none";
      }
      const nextHandBtn = this.hud3DOverlay.querySelector(".btn-3d-hud-next-hand");
      if (nextHandBtn) {
        const isShowOver = state3.showAct === "done" || Boolean(state3.showModal && state3.showModal.open) || state3.phase === "show" && Boolean(document.getElementById("btnNextHand"));
        const isMatchOver = Boolean(state3.over);
        nextHandBtn.style.display = isShowOver && !isMatchOver ? "inline-flex" : "none";
      }
    }
    /**
     * Synchronizes 3D cards, seating avatars, active turns, scores, and HUD directly from GameState.
     * @param {Object} context
     */
    syncFromGameState(context = {}) {
      if (this.isDestroyed || !this.scene) return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null) || {};
      const settings3 = typeof this.getResolvedSettings === "function" ? this.getResolvedSettings(context.settings) : context.settings || (typeof window !== "undefined" ? window.settings : null) || this.settings || {};
      const target = Number(settings3.target || this.targetHoles || 121) || 121;
      const key = `${Boolean(settings3.optPegThroughZones)}_${Boolean(settings3.optLast5PegOut)}_${Boolean(settings3.optBunkers)}_${Boolean(settings3.optStinkHole)}_${target}`;
      if (this._lastZoneHighlightKey !== key || !this.zoneHighlightsRoot) {
        if (typeof this.updateZoneHighlights === "function") this.updateZoneHighlights(settings3);
      }
      const me = context.me || (typeof window !== "undefined" && typeof window.mySeat === "function" ? window.mySeat() : "p1");
      const oppSeats = context.oppSeats || (this.activeTracks || ["p1", "p2"]).filter((s) => s !== me);
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" && typeof window.getSeatHand === "function" ? window.getSeatHand : () => []);
      const getSeatKept2 = context.getSeatKept || (typeof window !== "undefined" && typeof window.getSeatKept === "function" ? window.getSeatKept : () => []);
      const sortCards2 = context.sortCards || (typeof window !== "undefined" && typeof window.sortCards === "function" ? window.sortCards : (c) => c);
      const showHands = Boolean(state3.phase === "show" || state3.phase === "show-crib" || state3.over);
      if (this.cardEngine) {
        if (this.boardBounds && !this.cardEngine.boardBounds) {
          this.cardEngine.boardBounds = this.boardBounds;
        }
        const myKept = getSeatKept2(me);
        const myHandCards = showHands && myKept && myKept.length ? myKept : getSeatHand2(me);
        const myHand = sortCards2(myHandCards || []);
        const isPlayPhase = state3.phase === "play" || state3.phase === "pegging";
        const isDrawPhase = state3.phase === "draw-1" || state3.phase === "draw-2" || state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2";
        const isDiscardPhase = state3.phase === "discard" || state3.phase === "discard-p2";
        const isAssignPhase = state3.phase === "assign" || state3.phase === "assign-p2";
        const isOnlineFn = typeof context.isOnline === "function" ? context.isOnline : typeof window !== "undefined" && typeof window.isOnline === "function" ? window.isOnline : () => false;
        const isOnlineGame = isOnlineFn();
        let isLocalHandInteractive = false;
        if (state3.frozen || state3.paused || state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || state3.over) {
          isLocalHandInteractive = false;
        } else if (isDiscardPhase) {
          const hasDiscarded = Boolean(state3.seatDiscards && state3.seatDiscards[me]);
          isLocalHandInteractive = !hasDiscarded;
        } else if (isDrawPhase || isAssignPhase) {
          isLocalHandInteractive = true;
        } else if (isPlayPhase) {
          const isMyTurn = Boolean(state3.turn && (state3.turn === me || !isOnlineGame && (state3.turn === "p1" || state3.turn === "you")));
          isLocalHandInteractive = isMyTurn;
        }
        const p1Meshes = this.cardEngine.renderHandFan(me, myHand, {
          faceUp: true,
          interactive: isLocalHandInteractive,
          isLocal: true
        });
        if (p1Meshes) {
          p1Meshes.forEach((mesh) => {
            const isSel = Array.isArray(state3.selected) && state3.selected.includes(mesh.card?.id) || Array.isArray(state3.highlightIds) && state3.highlightIds.includes(mesh.card?.id);
            if (mesh.isSelected !== isSel) {
              mesh.setSelected(isSel);
            }
          });
        }
        oppSeats.forEach((oppSeat) => {
          const oppKept = getSeatKept2(oppSeat);
          const oppHand = showHands && oppKept && oppKept.length ? oppKept : getSeatHand2(oppSeat);
          const isThisOppShowing = state3.phase === "show" && (state3.showAct === oppSeat || state3.showAct === "done" || state3.showAct === "crib" || state3.over);
          const isPickingThisOpp = state3.phase === "pick-crib" && state3.currentPickPone === oppSeat;
          const oppMeshes = this.cardEngine.renderHandFan(oppSeat, oppHand || [], {
            faceUp: showHands && (isThisOppShowing || state3.over),
            interactive: isPickingThisOpp,
            isLocal: false
          });
          if (oppMeshes) {
            oppMeshes.forEach((mesh) => {
              const isHigh = Boolean(Array.isArray(state3.highlightIds) && state3.highlightIds.includes(mesh.card?.id));
              const isSel = Boolean(isPickingThisOpp && Array.isArray(state3.selected) && state3.selected.includes(mesh.card?.id));
              const active2 = isHigh || isSel;
              if (mesh.isSelected !== active2) {
                mesh.setSelected(active2);
              }
            });
          }
        });
        const normalizeSeat = (s) => {
          if (!s) return "";
          if (this.seatManager && typeof this.seatManager.normalizeSeatId === "function") {
            return this.seatManager.normalizeSeatId(s);
          }
          if (s === "you" || s === "player1" || s === "team1") return "p1";
          if (s === "cpu" || s === "player2" || s === "team2") return "p2";
          if (s === "player3" || s === "team3") return "p3";
          if (s === "player4" || s === "team4") return "p4";
          return s;
        };
        const activeSeat = isPlayPhase && state3.turn ? normalizeSeat(state3.turn) : me;
        const playPileCards = state3.pile && state3.pile.length ? state3.pile : state3.played && state3.played.length && (state3.phase !== "play" || state3.turn || !state3.frozen) ? state3.played : state3.pile || [];
        this.cardEngine.renderPlayPile(playPileCards, {
          localSeat: me,
          turnSeat: activeSeat || me,
          faceUp: !state3.pileFaceDown
        });
        const isCutStarter = state3.phase === "cut-starter";
        const pone = state3.cutTurn && isCutStarter ? state3.cutTurn : state3.dealer === "p1" ? "p2" : "p1";
        const isSeatHuman2 = typeof context.isSeatHuman === "function" ? context.isSeatHuman : typeof window !== "undefined" && typeof window.isSeatHuman === "function" ? window.isSeatHuman : () => true;
        const isOnline2 = typeof context.isOnline === "function" ? context.isOnline : typeof window !== "undefined" && typeof window.isOnline === "function" ? window.isOnline : () => false;
        const isMyCut = isCutStarter && (pone === me || !isOnline2() && isSeatHuman2(pone));
        const settings4 = context.settings || (typeof window !== "undefined" ? window.settings : null) || this.settings || {};
        const isProgCut = Boolean(settings4 && settings4.optProgressiveCut && (settings4.playerCount || 2) === 2);
        const cutCount = isProgCut ? Math.max(1, Math.floor((state3.handsCompleted || 0) / 2) + 1) : 1;
        const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
        this.cardEngine.renderStarterDeck(starters.length ? starters : null, {
          isCuttable: isMyCut,
          cutCount,
          phase: state3.phase,
          cutTurn: pone,
          starters,
          starterFace: state3.starterFace !== false,
          onCut: () => this.do3DCutStarter(context)
        });
        const starterMeshes = this.cardEngine.starterCards && this.cardEngine.starterCards.length ? this.cardEngine.starterCards : this.cardEngine.starterCardMesh ? [this.cardEngine.starterCardMesh] : [];
        starterMeshes.forEach((mesh) => {
          if (mesh && mesh.cardData) {
            const isStarterHigh = Boolean(Array.isArray(state3.highlightIds) && mesh.cardData.id && state3.highlightIds.includes(mesh.cardData.id));
            if (mesh.isSelected !== isStarterHigh) {
              mesh.setSelected(isStarterHigh);
            }
          }
        });
        if ((state3.phase === "cut" || state3.phase === "cut-reveal") && Array.isArray(state3.cutDeck)) {
          const isPassingDevice = !isOnline2() && Boolean(state3.passingTo);
          const curTurn = state3.cutTurn || "p1";
          const isMyDealCut = !isPassingDevice && (isOnline2() ? (!state3.cutPicks || !state3.cutPicks[me]) && state3.cutTurn === me : isSeatHuman2(curTurn) && (!state3.cutPicks || !state3.cutPicks[curTurn]));
          this.cardEngine.renderCutDeckFan(state3.cutDeck, state3.cutPicks || {}, {
            isMyCut: isMyDealCut,
            cutTurn: curTurn,
            phase: state3.phase,
            onPickCut: (index) => this.do3DPickCut(index, context)
          });
        } else if (typeof this.cardEngine.clearCutDeckFan === "function") {
          this.cardEngine.clearCutDeckFan();
        }
        const isCribRevealed = Boolean(
          state3.phase === "show-crib" || state3.phase === "show" && (state3.turn === "crib" || state3.showAct === "crib" || state3.revealCrib || state3.showAct === "done") || state3.over
        );
        const cribMeshes = this.cardEngine.renderCrib(state3.crib || [], isCribRevealed);
        if (cribMeshes && Array.isArray(state3.highlightIds) && state3.highlightIds.length > 0) {
          cribMeshes.forEach((mesh) => {
            const isHigh = state3.highlightIds.includes(mesh.card?.id);
            if (mesh.isSelected !== isHigh) {
              mesh.setSelected(isHigh);
            }
          });
        }
      }
      if (state3.dealer && typeof this.setDealer === "function") {
        this.setDealer(state3.dealer, true);
      }
      if (this.seatManager) {
        if (state3.turn) {
          this.seatManager.setActiveTurn(state3.turn);
        }
        if (state3.scores) {
          this.seatManager.updateScores(state3.scores);
        }
      }
      if (state3 && state3.scores && typeof this.updatePegs === "function") {
        const tracks = Array.isArray(this.activeTracks) ? this.activeTracks : ["p1", "p2"];
        let outOfSync = false;
        for (const who of tracks) {
          const targetLimit = Number(this.targetHoles) || 121;
          const sc = Math.min(targetLimit, typeof this.getTrackScore === "function" ? this.getTrackScore(state3.scores, who) : state3.scores[who] || 0);
          const cur = this.pegState && this.pegState[who] ? this.pegState[who].front : 0;
          if (sc !== cur) {
            outOfSync = true;
            break;
          }
        }
        if (outOfSync) {
          this.updatePegs(state3.scores, state3.prev || {}, false, state3.lastScoringEvent || null);
        }
      }
      this.update3DHUD(state3, context);
    }
    /**
     * Generates a high-definition PBR material for the chosen table environment
     * featuring procedural pub coasters, casino felt baize, or raceway tire markings.
     * @param {string} envId
     * @param {number} width
     * @param {number} depth
     * @returns {BABYLON.PBRMaterial}
     */
    createTableEnvironmentMaterial(envId, width, depth) {
      const BABYLON = this.BABYLON;
      const mat = new BABYLON.PBRMaterial(`matTableEnv_${envId}`, this.scene);
      if (!BABYLON.DynamicTexture) {
        mat.albedoColor = new BABYLON.Color3(0.18, 0.12, 0.08);
        mat.roughness = 0.5;
        return mat;
      }
      const dynTex = new BABYLON.DynamicTexture(`texTableEnv_${envId}`, { width: 1024, height: 1024 }, this.scene, true);
      this._tableTexture = dynTex;
      const ctx = dynTex.getContext();
      if (envId === "pub") {
        mat.roughness = 0.45;
        mat.metallic = 0.04;
        ctx.fillStyle = "#22150c";
        ctx.fillRect(0, 0, 1024, 1024);
        for (let y = 0; y < 1024; y += 128) {
          ctx.fillStyle = Math.floor(y / 128) % 2 === 0 ? "#281a10" : "#1c1109";
          ctx.fillRect(0, y, 1024, 126);
          ctx.fillStyle = "#0f0804";
          ctx.fillRect(0, y + 126, 1024, 2);
          ctx.strokeStyle = "rgba(255, 255, 255, 0.03)";
          ctx.lineWidth = 1;
          for (let i = 0; i < 4; i++) {
            ctx.beginPath();
            ctx.moveTo(0, y + 20 + i * 26);
            ctx.bezierCurveTo(340, y + 25 + i * 26, 680, y + 15 + i * 26, 1024, y + 22 + i * 26);
            ctx.stroke();
          }
        }
        const cx1 = 200, cy1 = 220, r1 = 110;
        ctx.beginPath();
        ctx.arc(cx1, cy1, r1, 0, Math.PI * 2);
        ctx.fillStyle = "#103822";
        ctx.fill();
        ctx.strokeStyle = "#d4af37";
        ctx.lineWidth = 8;
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(cx1, cy1, r1 - 12, 0, Math.PI * 2);
        ctx.strokeStyle = "rgba(212, 175, 55, 0.4)";
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.fillStyle = "#ffd700";
        ctx.font = 'bold 20px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("PINTS & PEGS", cx1, cy1 - 18);
        ctx.font = '14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillStyle = "#e2e8f0";
        ctx.fillText("EST. CRAZY CRIBBAGE", cx1, cy1 + 10);
        ctx.fillText("\u{1F37A} TAVERN PUB \u{1F37A}", cx1, cy1 + 32);
        const cx2 = 824, cy2 = 804, r2 = 100;
        ctx.beginPath();
        ctx.arc(cx2, cy2, r2, 0, Math.PI * 2);
        ctx.fillStyle = "#9c7348";
        ctx.fill();
        ctx.strokeStyle = "#5a3d1e";
        ctx.lineWidth = 5;
        ctx.stroke();
        ctx.fillStyle = "#3a2512";
        ctx.font = 'bold 18px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillText("CRAFT BREWED", cx2, cy2 - 14);
        ctx.font = '13px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillText("121 PEGS \u2022 31 TO THE GO", cx2, cy2 + 12);
        const drawRing = (rx, ry, rad) => {
          ctx.beginPath();
          ctx.arc(rx, ry, rad, 0, Math.PI * 2);
          ctx.strokeStyle = "rgba(255, 255, 255, 0.14)";
          ctx.lineWidth = 4;
          ctx.stroke();
          ctx.beginPath();
          ctx.arc(rx, ry, rad - 2, 0, Math.PI * 2);
          ctx.strokeStyle = "rgba(0, 0, 0, 0.35)";
          ctx.lineWidth = 2;
          ctx.stroke();
        };
        drawRing(280, 800, 65);
        drawRing(760, 240, 72);
      } else if (envId === "vegas") {
        mat.roughness = 0.65;
        mat.metallic = 0.12;
        ctx.fillStyle = "#261108";
        ctx.fillRect(0, 0, 1024, 1024);
        const inset = 64;
        ctx.fillStyle = "#0a3d24";
        ctx.fillRect(inset, inset, 1024 - inset * 2, 1024 - inset * 2);
        ctx.strokeStyle = "#d4af37";
        ctx.lineWidth = 6;
        ctx.strokeRect(inset, inset, 1024 - inset * 2, 1024 - inset * 2);
        ctx.strokeStyle = "rgba(212, 175, 55, 0.35)";
        ctx.lineWidth = 2;
        ctx.strokeRect(inset + 10, inset + 10, 1024 - (inset + 10) * 2, 1024 - (inset + 10) * 2);
        ctx.strokeStyle = "rgba(255, 255, 255, 0.035)";
        ctx.lineWidth = 1.5;
        const step = 80;
        for (let x = -1024; x < 2048; x += step) {
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x + 1024, 1024);
          ctx.stroke();
          ctx.beginPath();
          ctx.moveTo(x, 1024);
          ctx.lineTo(x + 1024, 0);
          ctx.stroke();
        }
        ctx.fillStyle = "#ffd700";
        ctx.font = "bold 36px serif";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("\u2660   \u2665   \u2666   \u2663", 512, 110);
        ctx.fillText("\u2660   \u2665   \u2666   \u2663", 512, 914);
        ctx.font = 'bold 22px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillStyle = "#fef08a";
        ctx.fillText("CRAZY CRIBBAGE \u2022 HIGH ROLLER VIP SUITE", 512, 150);
        ctx.fillText("CRAZY CRIBBAGE \u2022 HIGH ROLLER VIP SUITE", 512, 874);
      } else if (envId === "raceway") {
        mat.roughness = 0.8;
        mat.metallic = 0.04;
        ctx.fillStyle = "#16191d";
        ctx.fillRect(0, 0, 1024, 1024);
        ctx.fillStyle = "rgba(255, 255, 255, 0.04)";
        for (let i = 0; i < 300; i++) {
          const sx = i * 37 % 1024;
          const sy = i * 83 % 1024;
          ctx.fillRect(sx, sy, 3, 2);
        }
        const stripeW = 32;
        const drawHazardBar = (x, y, w, h) => {
          ctx.save();
          ctx.beginPath();
          ctx.rect(x, y, w, h);
          ctx.clip();
          ctx.fillStyle = "#ffd600";
          ctx.fillRect(x, y, w, h);
          ctx.fillStyle = "#0f172a";
          for (let i = -h; i < w + h; i += stripeW * 2) {
            ctx.beginPath();
            ctx.moveTo(x + i, y);
            ctx.lineTo(x + i + stripeW, y);
            ctx.lineTo(x + i + stripeW - h, y + h);
            ctx.lineTo(x + i - h, y + h);
            ctx.closePath();
            ctx.fill();
          }
          ctx.restore();
        };
        drawHazardBar(0, 0, 1024, 32);
        drawHazardBar(0, 992, 1024, 32);
        const checkSize = 24;
        for (let cy = 120; cy < 904; cy += checkSize) {
          for (let col = 0; col < 2; col++) {
            const isBlack = (Math.floor(cy / checkSize) + col) % 2 === 0;
            ctx.fillStyle = isBlack ? "#000000" : "#ffffff";
            ctx.fillRect(40 + col * checkSize, cy, checkSize, checkSize);
            ctx.fillRect(936 + col * checkSize, cy, checkSize, checkSize);
          }
        }
        ctx.strokeStyle = "rgba(0, 0, 0, 0.65)";
        ctx.lineWidth = 14;
        ctx.beginPath();
        ctx.moveTo(140, 320);
        ctx.bezierCurveTo(380, 260, 680, 360, 880, 290);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(160, 350);
        ctx.bezierCurveTo(400, 290, 700, 390, 900, 320);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(120, 720);
        ctx.bezierCurveTo(340, 780, 660, 690, 890, 760);
        ctx.stroke();
        ctx.fillStyle = "#f8fafc";
        ctx.font = '900 36px "Arial Black", -apple-system, sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("\u{1F3C1} CLASH 481 MOTOR SPEEDWAY \u{1F3C1}", 512, 180);
        ctx.fillStyle = "#ef4444";
        ctx.font = "bold 20px -apple-system, BlinkMacSystemFont, sans-serif";
        ctx.fillText("HAZARDS \u2022 JUMPS \u2022 STOP SIGNS \u2022 SPEED TRAPS", 512, 840);
      } else if (envId === "lounge") {
        mat.roughness = 0.5;
        mat.metallic = 0.22;
        ctx.fillStyle = "#09090b";
        ctx.fillRect(0, 0, 1024, 1024);
        ctx.fillStyle = "#4c0519";
        ctx.fillRect(72, 72, 880, 880);
        ctx.strokeStyle = "#fb7185";
        ctx.lineWidth = 6;
        ctx.strokeRect(72, 72, 880, 880);
        ctx.strokeStyle = "rgba(251, 113, 133, 0.35)";
        ctx.lineWidth = 2;
        ctx.strokeRect(84, 84, 856, 856);
        ctx.fillStyle = "#f43f5e";
        ctx.font = "bold 26px -apple-system, BlinkMacSystemFont, sans-serif";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("\u{1F339} SKUNKED & STRIPPED LOUNGE \u{1F339}", 512, 140);
        ctx.font = "16px -apple-system, BlinkMacSystemFont, sans-serif";
        ctx.fillStyle = "#fda4af";
        ctx.fillText("ADULT PARTY \u2022 DARE YOU TO SKUNK", 512, 884);
      } else {
        mat.roughness = 0.38;
        mat.metallic = 0.02;
        ctx.fillStyle = "#d2b48c";
        ctx.fillRect(0, 0, 1024, 1024);
        for (let y = 0; y < 1024; y += 96) {
          ctx.fillStyle = Math.floor(y / 96) % 2 === 0 ? "#deb887" : "#d2b48c";
          ctx.fillRect(0, y, 1024, 94);
          ctx.fillStyle = "rgba(139, 69, 19, 0.2)";
          ctx.fillRect(0, y + 94, 1024, 2);
        }
        ctx.strokeStyle = "rgba(139, 69, 19, 0.08)";
        ctx.lineWidth = 1;
        for (let y = 0; y < 1024; y += 24) {
          ctx.beginPath();
          ctx.moveTo(0, y);
          ctx.bezierCurveTo(340, y + 8, 680, y - 8, 1024, y);
          ctx.stroke();
        }
      }
      dynTex.update();
      mat.albedoTexture = dynTex;
      return mat;
    }
    /**
     * Adjusts scene atmospheric light color temperatures and clear color
     * to match the chosen environment's mood.
     * @param {string} envId
     */
    applyEnvironmentAtmosphere(envId) {
      if (!this.BABYLON || !this.scene) return;
      const BABYLON = this.BABYLON;
      const theme2 = RoomCatalog3D.getThemeById(envId);
      if (theme2 && theme2.ambientColor && BABYLON.Color3) {
        try {
          this.scene.ambientColor = new BABYLON.Color3(
            theme2.ambientColor.r * 0.4,
            theme2.ambientColor.g * 0.4,
            theme2.ambientColor.b * 0.4
          );
        } catch (_) {
        }
      }
      if (theme2 && BABYLON.Color4) {
        try {
          if (theme2.id === "none") {
            this.scene.clearColor = new BABYLON.Color4(0.09, 0.1, 0.12, 1);
          } else if (theme2.id === "vegas") {
            this.scene.clearColor = new BABYLON.Color4(0.05, 0.07, 0.1, 1);
          } else if (theme2.id === "pub" || theme2.id === "cabin") {
            this.scene.clearColor = new BABYLON.Color4(0.08, 0.05, 0.03, 1);
          } else {
            this.scene.clearColor = new BABYLON.Color4(0.07, 0.08, 0.1, 1);
          }
        } catch (_) {
        }
      }
      const tid = theme2 ? theme2.id : envId;
      if (tid === "pub") {
        if (this.hemiLight) {
          this.hemiLight.diffuse = new BABYLON.Color3(1, 0.88, 0.72);
          this.hemiLight.groundColor = new BABYLON.Color3(0.55, 0.4, 0.28);
        }
        if (this.dirLight) {
          this.dirLight.diffuse = new BABYLON.Color3(1, 0.94, 0.82);
        }
      } else if (tid === "vegas") {
        if (this.hemiLight) {
          this.hemiLight.diffuse = new BABYLON.Color3(0.92, 1, 0.95);
          this.hemiLight.groundColor = new BABYLON.Color3(0.35, 0.5, 0.42);
        }
        if (this.fillLight) {
          this.fillLight.diffuse = new BABYLON.Color3(0.98, 0.88, 1);
        }
      } else if (tid === "thunderdome" || tid === "raceway") {
        if (this.hemiLight) {
          this.hemiLight.diffuse = new BABYLON.Color3(0.9, 0.96, 1);
          this.hemiLight.groundColor = new BABYLON.Color3(0.4, 0.45, 0.52);
        }
        if (this.dirLight) {
          this.dirLight.diffuse = new BABYLON.Color3(1, 1, 1);
        }
      } else if (tid === "velvet" || tid === "lounge") {
        if (this.hemiLight) {
          this.hemiLight.diffuse = new BABYLON.Color3(0.95, 0.82, 0.92);
          this.hemiLight.groundColor = new BABYLON.Color3(0.45, 0.25, 0.35);
        }
        if (this.fillLight) {
          this.fillLight.diffuse = new BABYLON.Color3(0.9, 0.65, 0.85);
        }
      } else {
        if (this.hemiLight) {
          this.hemiLight.diffuse = new BABYLON.Color3(1, 1, 1);
          this.hemiLight.groundColor = new BABYLON.Color3(0.68, 0.68, 0.7);
        }
      }
    }
    /**
     * Cleans up 3D table mesh, texture, and materials.
     */
    clearTableEnvironment() {
      if (this.seatManager) {
        try {
          this.seatManager.dispose();
        } catch (_) {
        }
        this.seatManager = null;
      }
      if (this.cardEngine) {
        try {
          this.cardEngine.dispose();
        } catch (_) {
        }
        this.cardEngine = null;
      }
      if (this.hud3DOverlay) {
        try {
          this.hud3DOverlay.remove();
        } catch (_) {
        }
        this.hud3DOverlay = null;
      }
      if (this.roomData) {
        RoomCatalog3D.disposeRoom(this.roomData);
        this.roomData = null;
      }
      if (this.tableMesh) {
        try {
          this.tableMesh.dispose(false, true);
        } catch (_) {
        }
        this.tableMesh = null;
      }
      if (this._tableTexture) {
        try {
          this._tableTexture.dispose();
        } catch (_) {
        }
        this._tableTexture = null;
      }
      if (this._tableMaterial) {
        try {
          this._tableMaterial.dispose();
        } catch (_) {
        }
        this._tableMaterial = null;
      }
      this.clearDealerButton();
    }
    /**
     * Loads custom GLB model or generates a procedural 3D board in Babylon.js.
     */
    async loadBoardModel() {
      const BABYLON = this.BABYLON;
      if (this.boardConfig?.modelUrl) {
        try {
          if (!_BoardRenderer3D.hasGlbLoader()) {
            await this.loadBabylon();
          }
          const fullUrl = this.boardConfig.modelUrl;
          const lastSlash = fullUrl.lastIndexOf("/");
          const rootUrl = lastSlash !== -1 ? fullUrl.substring(0, lastSlash + 1) : "";
          const fileName = lastSlash !== -1 ? fullUrl.substring(lastSlash + 1) : fullUrl;
          const ext = fullUrl.toLowerCase().includes(".glb") ? ".glb" : fullUrl.toLowerCase().includes(".gltf") ? ".gltf" : void 0;
          const result = await BABYLON.SceneLoader.ImportMeshAsync("", rootUrl, fileName, this.scene, null, ext);
          this.boardMeshes = result.meshes || [];
          this.boardScale = 0.5;
          if (!this.boardRoot || this.boardRoot.isDisposed) {
            this.boardRoot = new BABYLON.TransformNode("boardRoot", this.scene);
          }
          if (this.boardScaleMultiplier && this.boardScaleMultiplier !== 1) {
            this.boardRoot.scaling.set(this.boardScaleMultiplier, this.boardScaleMultiplier, this.boardScaleMultiplier);
          }
          const rootNode = this.boardMeshes[0]?.name === "__root__" ? this.boardMeshes[0] : null;
          if (rootNode) {
            if (this.boardRoot) rootNode.parent = this.boardRoot;
            rootNode.scaling.scaleInPlace(this.boardScale);
          } else {
            this.boardMeshes.forEach((m) => {
              if (!m.parent) {
                if (this.boardRoot) m.parent = this.boardRoot;
                m.scaling.scaleInPlace(this.boardScale);
              }
            });
          }
          this.boardMeshes.forEach((m) => {
            m.receiveShadows = true;
            if (this.shadowGenerator && m.name !== "__root__") {
              this.shadowGenerator.addShadowCaster(m);
            }
            if (m.material) {
              if (m.material.roughness !== void 0 && m.material.roughness > 0.45) {
                m.material.roughness = 0.4;
              }
              if (m.material.metallic !== void 0 && m.material.metallic > 0.08) {
                m.material.metallic = 0.04;
              }
            }
          });
          return;
        } catch (err) {
          console.warn("[BoardRenderer3D] Custom GLB failed to load in Babylon, falling back to procedural board:", err);
        }
      }
      if (!this.boardRoot || this.boardRoot.isDisposed) {
        this.boardRoot = new BABYLON.TransformNode("boardRoot", this.scene);
      }
      if (this.boardScaleMultiplier && this.boardScaleMultiplier !== 1) {
        this.boardRoot.scaling.set(this.boardScaleMultiplier, this.boardScaleMultiplier, this.boardScaleMultiplier);
      }
      this.boardScale = 0.5;
      const board = BABYLON.MeshBuilder.CreateBox("proceduralBoard", {
        width: 65 * this.boardScale,
        height: 1.6 * this.boardScale,
        depth: 21 * this.boardScale
      }, this.scene);
      board.position.y = 0;
      board.receiveShadows = true;
      if (this.shadowGenerator) this.shadowGenerator.addShadowCaster(board);
      if (this.boardRoot) board.parent = this.boardRoot;
      const mat = new BABYLON.PBRMaterial("woodMat", this.scene);
      mat.albedoColor = this.getBabylonWoodColor();
      mat.roughness = 0.4;
      mat.metallic = 0.05;
      board.material = mat;
      const rim = BABYLON.MeshBuilder.CreateBox("brassRim", {
        width: 65.6 * this.boardScale,
        height: 0.3 * this.boardScale,
        depth: 21.6 * this.boardScale
      }, this.scene);
      rim.position.y = -0.65 * this.boardScale;
      if (this.boardRoot) rim.parent = this.boardRoot;
      const rimMat = new BABYLON.PBRMaterial("rimMat", this.scene);
      rimMat.albedoColor = new BABYLON.Color3(0.85, 0.65, 0.1);
      rimMat.metallic = 0.9;
      rimMat.roughness = 0.25;
      rim.material = rimMat;
      this.boardMeshes = [board, rim];
    }
    /**
     * Computes the world bounding box encompassing all board meshes.
     * @returns {{ min: BABYLON.Vector3, max: BABYLON.Vector3, center: BABYLON.Vector3, size: BABYLON.Vector3 } | null}
     */
    getBoardBounds() {
      if (!this.boardMeshes || this.boardMeshes.length === 0) return null;
      const BABYLON = this.BABYLON;
      let min = new BABYLON.Vector3(Infinity, Infinity, Infinity);
      let max = new BABYLON.Vector3(-Infinity, -Infinity, -Infinity);
      let count = 0;
      for (const mesh of this.boardMeshes) {
        if (!mesh || mesh.name === "__root__") continue;
        mesh.computeWorldMatrix(true);
        const bInfo = mesh.getBoundingInfo ? mesh.getBoundingInfo() : null;
        if (bInfo && bInfo.boundingBox) {
          min = BABYLON.Vector3.Minimize(min, bInfo.boundingBox.minimumWorld);
          max = BABYLON.Vector3.Maximize(max, bInfo.boundingBox.maximumWorld);
          count++;
        }
      }
      if (count === 0) {
        for (const mesh of this.boardMeshes) {
          if (!mesh) continue;
          mesh.computeWorldMatrix(true);
          const bInfo = mesh.getBoundingInfo ? mesh.getBoundingInfo() : null;
          if (bInfo && bInfo.boundingBox) {
            min = BABYLON.Vector3.Minimize(min, bInfo.boundingBox.minimumWorld);
            max = BABYLON.Vector3.Maximize(max, bInfo.boundingBox.maximumWorld);
            count++;
          }
        }
      }
      if (count === 0 || !isFinite(min.x) || !isFinite(max.x)) {
        return null;
      }
      const center = min.add(max).scale(0.5);
      const size = max.subtract(min);
      return { min, max, center, size };
    }
    /**
     * Adapts the cribbage board container's aspect ratio to match the natural
     * physical proportions of the active 3D model.
     * @param {Object} bounds - Bounding box { size, center }
     */
    updateContainerAspectRatio(bounds) {
      if (!this.container || !bounds) return;
      if (this.container.style.height && this.container.style.height !== "auto") {
        return;
      }
      const beta = this.camera ? this.camera.beta : Math.PI / 5.2;
      const horizSpan = Math.max(1, bounds.size.x);
      const vertSpan = Math.abs(bounds.size.z * Math.cos(beta)) + Math.abs(bounds.size.y * Math.sin(beta));
      const modelAspect = horizSpan / Math.max(0.1, vertSpan);
      const targetAspect = Math.max(1.25, Math.min(3.8, modelAspect * 1.15));
      const aspectStr = `${targetAspect.toFixed(3)} / 1`;
      if (this.container.style.aspectRatio !== aspectStr) {
        this.container.style.aspectRatio = aspectStr;
      }
    }
    /**
     * Automatically calculates camera framing distance and target so the 3D model
     * fits comfortably into the cribbage board view box, adjusting dynamically on resize.
     * @param {boolean} [force=false] - If true, recalculates even if user manually panned/zoomed.
     */
    fitBoardToViewBox(force = false) {
      if (!this.camera || !this.engine || !this.scene || this.isDestroyed) return;
      if (this._userHasAdjustedCamera && !force) return;
      const bounds = this.getBoardBounds();
      if (!bounds) return;
      this.boardBounds = bounds;
      if (this.cardEngine) {
        this.cardEngine.boardBounds = bounds;
      }
      this.updateContainerAspectRatio(bounds);
      this.camera.setTarget(bounds.center);
      const canvas = this.canvas || this.engine.getRenderingCanvas();
      const width = canvas && canvas.clientWidth > 0 ? canvas.clientWidth : this.viewBoxW;
      const height = canvas && canvas.clientHeight > 0 ? canvas.clientHeight : this.viewBoxH;
      if (width <= 0 || height <= 0) return;
      const aspect = width / height;
      const fov = this.camera.fov || 0.8;
      const halfVFOV = fov / 2;
      const halfHFOV = Math.atan(Math.tan(halfVFOV) * aspect);
      const beta = this.camera.beta !== void 0 ? this.camera.beta : Math.PI / 4;
      const alpha = this.camera.alpha !== void 0 ? this.camera.alpha : -Math.PI / 2;
      const hasRoom = Boolean(this.roomData || this.tableMesh || this.cardEngine);
      const dims = this.roomData?.dims;
      const tableW = dims?.tableW ?? (this.cardEngine?.tableW || 120);
      const tableD = dims?.tableD ?? (this.cardEngine?.tableD || 100);
      let spanTargetX = bounds.size.x;
      let spanTargetZ = bounds.size.z;
      const isMobile = aspect < 0.9 || typeof window !== "undefined" && (window.innerWidth <= 768 || window.matchMedia?.("(max-width: 768px)")?.matches);
      if (hasRoom && tableW && tableD) {
        const spanFactor = isMobile ? 1.25 : 1;
        spanTargetX = Math.max(bounds.size.x, tableW * spanFactor);
        spanTargetZ = Math.max(bounds.size.z, tableD * spanFactor);
      }
      const sizeX = Math.max(1, spanTargetX);
      const sizeY = Math.max(0.1, bounds.size.y);
      const sizeZ = Math.max(1, spanTargetZ);
      const horizSpan = Math.abs(sizeX * Math.sin(alpha)) + Math.abs(sizeZ * Math.cos(alpha));
      const depthSpan = Math.abs(sizeZ * Math.sin(alpha)) + Math.abs(sizeX * Math.cos(alpha));
      const vertSpan = Math.abs(depthSpan * Math.cos(beta)) + Math.abs(sizeY * Math.sin(beta));
      const distH = horizSpan / 2 / Math.tan(halfHFOV);
      const distV = vertSpan / 2 / Math.tan(halfVFOV);
      const padding = hasRoom ? isMobile ? 1.38 : 1.25 : 1.18;
      const fitRadius = Math.max(distH, distV) * padding;
      this.camera.radius = fitRadius;
      this.fitRadius = fitRadius;
      this.camera.lowerRadiusLimit = fitRadius * 0.15;
      let maxRadius = fitRadius * 4.5;
      if (this.roomData?.dims) {
        const { roomW, roomD } = this.roomData.dims;
        maxRadius = Math.min(maxRadius, Math.min(roomW, roomD) * 0.46);
      }
      this.camera.upperRadiusLimit = Math.max(fitRadius * 1.5, maxRadius);
      this.camera.minZ = Math.max(0.1, fitRadius * 5e-3);
      this.camera.maxZ = Math.max(1e4, fitRadius * 20);
      this.camera.panningSensibility = 25;
      if (this.dirLight) {
        const maxDim = Math.max(sizeX, sizeY, sizeZ);
        this.dirLight.position = bounds.center.add(new this.BABYLON.Vector3(maxDim * 0.35, maxDim * 1.2, maxDim * 0.5));
      }
      if (this.fillLight) {
        const maxDim = Math.max(sizeX, sizeY, sizeZ);
        this.fillLight.position = bounds.center.add(new this.BABYLON.Vector3(-maxDim * 0.4, maxDim * 0.9, -maxDim * 0.4));
      }
    }
    /**
     * Handles resizing of the view box or window.
     */
    handleResize() {
      if (!this.engine || !this.scene || !this.camera || this.isDestroyed) return;
      this.engine.resize();
      this.fitBoardToViewBox(false);
    }
    /**
     * Instantiates front and rear 3D pegs for each active track.
     */
    setupPegs() {
      for (const who of this.activeTracks) {
        const hasMinusOne = this.hasHole(who, -1);
        const initialRearHole = hasMinusOne ? -1 : 0;
        this.pegState[who] = { front: 0, rear: initialRearHole };
        for (const role of ["rear", "front"]) {
          const pegMesh = this.createPegMesh(who, role);
          if (this.boardRoot) {
            pegMesh.parent = this.boardRoot;
          }
          this.pegMeshes.set(`${who}_${role}`, pegMesh);
          const holeToUse = role === "rear" ? initialRearHole : 0;
          const pt = this.getHoleCoords(who, holeToUse);
          if (pt) {
            pegMesh.position.set(pt.x, pt.y, pt.z);
          }
        }
      }
    }
    /**
     * Checks whether Cribbage Clash or hazard obstacle rules are active.
     * @returns {boolean}
     */
    isClashMode() {
      const brand = this.options.brand || this.settings?.brand || typeof window !== "undefined" && (window.CRAZY_BRAND || typeof window.getAppBrand === "function" && window.getAppBrand());
      if (brand && brand !== "clash") return false;
      const isClashTarget2 = [241, 361, 481].includes(Number(this.settings?.target)) || [241, 361, 481].includes(Number(this.targetHoles));
      const isClashBoard = this.boardConfig?.brand === "clash" || this.boardConfig?.id === "board-cribbage-clash" || this.boardConfig?.id === "board-cribbage-clash-square";
      const hasClashSettings = Boolean(
        this.settings && (this.settings.optStopSign || this.settings.optJump || this.settings.optJail || this.settings.optBar || this.settings.optTimeout || this.settings.optDetour || this.settings.optRoundAbout || this.settings.optNoPassingLanes || this.settings.optNoPassing || this.settings.optSigns)
      );
      const hasObstacleConfigs = Boolean(
        this.options.obstacleConfigs && (this.options.obstacleConfigs.stopSigns && this.options.obstacleConfigs.stopSigns.length || this.options.obstacleConfigs.jumps && this.options.obstacleConfigs.jumps.length || this.options.obstacleConfigs.jails && this.options.obstacleConfigs.jails.length || this.options.obstacleConfigs.bars && this.options.obstacleConfigs.bars.length || this.options.obstacleConfigs.timeouts && this.options.obstacleConfigs.timeouts.length || this.options.obstacleConfigs.detours && this.options.obstacleConfigs.detours.length || this.options.obstacleConfigs.roundabouts && this.options.obstacleConfigs.roundabouts.length || this.options.obstacleConfigs.noPassingLanes && this.options.obstacleConfigs.noPassingLanes.length || this.options.obstacleConfigs.signs && this.options.obstacleConfigs.signs.length)
      );
      return brand === "clash" || isClashTarget2 || isClashBoard || hasClashSettings || hasObstacleConfigs;
    }
    /**
     * Resolves active game settings from options, instance state, window, and DOM checkboxes.
     * Prevents empty sync contexts from clearing active zone variant highlights.
     * @param {Object} [extraSettings=null]
     * @returns {Object}
     */
    getResolvedSettings(extraSettings = null) {
      const domSettings = {};
      if (typeof document !== "undefined") {
        ["optPegThroughZones", "optLast5PegOut", "optBunkers", "optStinkHole"].forEach((id) => {
          const el = document.getElementById(id);
          if (el && el.checked) domSettings[id] = true;
        });
      }
      const resolved = Object.assign(
        {},
        this.options?.settings || {},
        this.settings || {},
        typeof window !== "undefined" && window.settings ? window.settings : {},
        domSettings
      );
      if (extraSettings && typeof extraSettings === "object" && Object.keys(extraSettings).length > 0) {
        ["optPegThroughZones", "optLast5PegOut", "optBunkers", "optStinkHole", "target"].forEach((k) => {
          if (extraSettings[k] !== void 0) resolved[k] = extraSettings[k];
        });
      }
      return resolved;
    }
    /**
     * Checks whether any zone pegging variants requiring red glow hole highlights are active.
     * @param {Object} [settings=null]
     * @returns {boolean}
     */
    isZoneHighlightActive(settings3 = null) {
      const s = this.getResolvedSettings(settings3);
      return Boolean(
        s.optPegThroughZones || s.optLast5PegOut || s.optBunkers || s.optStinkHole
      );
    }
    /**
     * Returns a Set of hole indices that should be highlighted with a red glow.
     * @param {Object} [settings=null]
     * @returns {Set<number>}
     */
    getHighlightedZoneHoles(settings3 = null) {
      const holes = /* @__PURE__ */ new Set();
      const s = this.getResolvedSettings(settings3);
      const target = Number(s.target || this.targetHoles || 121) || 121;
      for (let h = 1; h < target; h++) {
        if (s.optPegThroughZones && isInPegThroughZone(h)) {
          holes.add(h);
        } else if (s.optLast5PegOut && isInLast5PegOut(h, target)) {
          holes.add(h);
        } else if (s.optBunkers && isInBunker(h, target)) {
          holes.add(h);
        } else if (s.optStinkHole && isInStinkHole(h, target)) {
          holes.add(h);
        }
      }
      return holes;
    }
    /**
     * Generates or retrieves cached PBR materials for 3D red glow zone hole highlights.
     * Configured as pure ruby red (#d50000 / #ff1100) with zero blue and high roughness
     * so ambient spotlights never cast white specular sheen (which makes it look pink).
     * @private
     */
    _getZoneHighlightMaterials() {
      if (this._zoneMaterials) return this._zoneMaterials;
      const BABYLON = this.BABYLON;
      if (!BABYLON) return null;
      const MatClass = BABYLON.PBRMaterial || BABYLON.StandardMaterial;
      if (!MatClass) return null;
      const redGlow = new MatClass("mat3D_ZoneRedGlow", this.scene);
      const col = BABYLON.Color3 && typeof BABYLON.Color3.FromHexString === "function" ? BABYLON.Color3.FromHexString("#ff0000") : null;
      const em = BABYLON.Color3 && typeof BABYLON.Color3.FromHexString === "function" ? BABYLON.Color3.FromHexString("#ff0000") : null;
      if (redGlow.albedoColor !== void 0) redGlow.albedoColor = col;
      else if (redGlow.diffuseColor !== void 0) redGlow.diffuseColor = col;
      if (redGlow.emissiveColor !== void 0 && em) redGlow.emissiveColor = em;
      redGlow.metallic = 0;
      redGlow.roughness = 0.75;
      redGlow.backFaceCulling = false;
      redGlow.alpha = 1;
      this._zoneMaterials = { redGlow };
      return this._zoneMaterials;
    }
    /**
     * Sets up 3D red soft gradient glow highlights at the top of active zone pegging holes
     * (Peg Through Zones, Last 5 Peg Out, Bunkers, or Stink Hole).
     * Stands vertically around the hole socket with a feathered alpha gradient.
     */
    setupZoneHighlights() {
      if (!this.scene || !this.BABYLON || this.isDestroyed) return;
      const settings3 = this.getResolvedSettings();
      const target = Number(settings3.target || this.targetHoles || 121) || 121;
      this.targetHoles = target;
      const key = `${Boolean(settings3.optPegThroughZones)}_${Boolean(settings3.optLast5PegOut)}_${Boolean(settings3.optBunkers)}_${Boolean(settings3.optStinkHole)}_${target}`;
      if (!this.isZoneHighlightActive(settings3)) {
        this.clearZoneHighlights();
        this._lastZoneHighlightKey = key;
        return;
      }
      if (this._lastZoneHighlightKey === key && this.zoneHighlightsRoot) {
        return;
      }
      this.clearZoneHighlights();
      this._lastZoneHighlightKey = key;
      const BABYLON = this.BABYLON;
      this.zoneHighlightsRoot = new BABYLON.TransformNode("zoneHighlightsRoot", this.scene);
      if (this.boardRoot) {
        this.zoneHighlightsRoot.parent = this.boardRoot;
      }
      const hasExplicitCoords = Boolean(this.boardConfig?.coordinatesData || this.boardConfig?.holeData);
      this.zoneHighlightsRoot.position.y = hasExplicitCoords ? 0 : 5;
      if (!this.glowLayer && BABYLON.GlowLayer) {
        try {
          this.glowLayer = new BABYLON.GlowLayer("boardObstaclesGlow", this.scene, {
            mainTextureRatio: 0.5,
            blurKernelSize: 16
          });
        } catch (_) {
        }
      }
      if (this.glowLayer) {
        this.glowLayer.intensity = Math.max(this.glowLayer.intensity || 0, 0.65);
        if (!this.glowLayer._hasZoneGlowSelector) {
          this.glowLayer._hasZoneGlowSelector = true;
          const prevSelector = this.glowLayer.customEmissiveColorSelector;
          this.glowLayer.customEmissiveColorSelector = (mesh, subMesh, material, result) => {
            if (mesh && mesh.metadata && mesh.metadata.isZoneHighlight) {
              result.set(1, 0, 0, 1);
            } else if (typeof prevSelector === "function") {
              prevSelector(mesh, subMesh, material, result);
            } else if (material && material.emissiveColor) {
              result.set(material.emissiveColor.r, material.emissiveColor.g, material.emissiveColor.b, 1);
            } else {
              result.set(0, 0, 0, 0);
            }
          };
        }
      }
      const dims = this.getPegDimensions("front");
      const spacing = dims.spacing || 7.75;
      const holeRadius = dims.radiusBottom || spacing * 0.2 || 1.1;
      const collarDiam = Math.min(spacing * 0.58, Math.max(holeRadius * 2.3, 3.2));
      const ringThickness = Math.max(0.38, holeRadius * 0.32);
      const mats = this._getZoneHighlightMaterials();
      if (!mats) return;
      const highlightedHoles = this.getHighlightedZoneHoles(settings3);
      const tracksToMark = Array.isArray(this.activeTracks) && this.activeTracks.length > 0 ? this.activeTracks : ["p1", "p2"];
      highlightedHoles.forEach((h) => {
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, h);
          if (!pt) return;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const torusCenterY = surfaceY + 2.55;
          let ring = null;
          if (typeof BABYLON.MeshBuilder.CreateTorus === "function") {
            ring = BABYLON.MeshBuilder.CreateTorus(`zoneHoleRing_${who}_${h}`, {
              diameter: collarDiam,
              thickness: ringThickness,
              tessellation: 32
            }, this.scene);
          } else {
            ring = BABYLON.MeshBuilder.CreateCylinder(`zoneHoleRing_${who}_${h}`, {
              diameter: collarDiam,
              height: ringThickness,
              tessellation: 24
            }, this.scene);
          }
          ring.position.set(pt.x, torusCenterY, pt.z);
          ring.material = mats.redGlow;
          ring.parent = this.zoneHighlightsRoot;
          ring.metadata = { isZoneHighlight: true, hole: h, who };
        });
      });
    }
    /**
     * Clears and disposes all 3D red glow zone hole highlight meshes.
     */
    clearZoneHighlights() {
      if (this.zoneHighlightsRoot) {
        try {
          this.zoneHighlightsRoot.dispose(false, true);
        } catch (_) {
        }
        this.zoneHighlightsRoot = null;
      }
      this._lastZoneHighlightKey = null;
    }
    /**
     * Dynamically updates 3D zone highlight placements when game settings or variants change.
     * @param {Object} [settings=null]
     */
    updateZoneHighlights(settings3 = null) {
      if (settings3 && typeof settings3 === "object" && Object.keys(settings3).length > 0) {
        this.settings = Object.assign(this.settings || {}, settings3);
      }
      this.setupZoneHighlights();
    }
    /**
     * Sets up 3D visual markers, socket highlights, and leap trajectories
     * for active Cribbage Clash obstacles on the 3D board model.
     */
    setupClashObstacles() {
      if (!this.scene || !this.BABYLON || this.isDestroyed) return;
      if (!this.isClashMode()) {
        this.clearClashObstacles();
        return;
      }
      this.clearClashObstacles();
      const BABYLON = this.BABYLON;
      this.clashObstaclesRoot = new BABYLON.TransformNode("clashObstaclesRoot", this.scene);
      if (this.boardRoot) {
        this.clashObstaclesRoot.parent = this.boardRoot;
      }
      const hasExplicitCoords = Boolean(this.boardConfig?.coordinatesData || this.boardConfig?.holeData);
      this.clashObstaclesRoot.position.y = hasExplicitCoords ? 0 : 5;
      if (!this.glowLayer && BABYLON.GlowLayer) {
        try {
          this.glowLayer = new BABYLON.GlowLayer("boardObstaclesGlow", this.scene, {
            mainTextureRatio: 0.5,
            blurKernelSize: 16
          });
          this.glowLayer.intensity = 0.55;
        } catch (_) {
        }
      }
      const dims = this.getPegDimensions("front");
      const spacing = dims.spacing || 7.75;
      const markerRadius = spacing * 0.38;
      const padHeight = 0.22;
      const materials = this._getClashObstacleMaterials();
      this._render3DStopSigns(spacing, markerRadius, padHeight, materials);
      this._render3DJumps(spacing, markerRadius, padHeight, materials);
      this._render3DJails(spacing, markerRadius, padHeight, materials);
      this._render3DBars(spacing, markerRadius, padHeight, materials);
      this._render3DTimeouts(spacing, markerRadius, padHeight, materials);
      this._render3DDetours(spacing, markerRadius, padHeight, materials);
      this._render3DRoundAbouts(spacing, markerRadius, padHeight, materials);
      this._render3DNoPassingLanes(spacing, materials);
      this._render3DSignBlocks(spacing, markerRadius, padHeight, materials);
      this._render3DDice(spacing, markerRadius, padHeight, materials);
      this._render3DSpinningWheels(spacing, markerRadius, padHeight, materials);
      this._render3DSkunkMarkers(spacing, markerRadius, padHeight, materials);
    }
    /**
     * Clears and disposes all 3D clash obstacle meshes.
     */
    clearClashObstacles() {
      if (this.clashObstaclesRoot) {
        try {
          this.clashObstaclesRoot.dispose(false, true);
        } catch (_) {
        }
        this.clashObstaclesRoot = null;
      }
      if (this._diceSharedTexture) {
        try {
          this._diceSharedTexture.dispose();
        } catch (_) {
        }
        this._diceSharedTexture = null;
      }
      if (this._wheelSharedTexture) {
        try {
          this._wheelSharedTexture.dispose();
        } catch (_) {
        }
        this._wheelSharedTexture = null;
      }
      if (this._skunkSharedTexture) {
        try {
          this._skunkSharedTexture.dispose();
        } catch (_) {
        }
        this._skunkSharedTexture = null;
      }
      if (this._wheelRenderObservers && Array.isArray(this._wheelRenderObservers)) {
        this._wheelRenderObservers.forEach((obs) => {
          try {
            this.scene.onBeforeRenderObservable.remove(obs);
          } catch (_) {
          }
        });
        this._wheelRenderObservers = null;
      }
    }
    /**
     * Dynamically updates 3D clash obstacle placements when game settings or presets change.
     * @param {Object} [settings=null]
     */
    updateClashObstacles(settings3 = null) {
      if (settings3) {
        this.settings = Object.assign(this.settings || {}, settings3);
      }
      this.setupClashObstacles();
    }
    /**
     * Checks whether Pints & Pegs drinking spaces are active on this board.
     * @returns {boolean}
     */
    isPintsMode() {
      const brand = this.options.brand || this.settings?.brand || typeof window !== "undefined" && (window.CRAZY_BRAND || typeof window.getAppBrand === "function" && window.getAppBrand());
      if (brand && brand !== "pints") return false;
      if (brand === "pints") return true;
      const hasDrinkingSettings = Boolean(
        this.settings && (this.settings.optYouDrink || this.settings.optGuysDrink || this.settings.optGalsDrink || this.settings.optLeftDrink || this.settings.optRightDrink || this.settings.optEveryoneDrink || this.settings.optEveryoneButYouDrink || this.settings.optPickWhoDrinks)
      );
      const hasPintsConfigs = Boolean(
        this.options.pintsConfigs && this.options.pintsConfigs.length > 0
      );
      return hasDrinkingSettings || hasPintsConfigs;
    }
    /**
     * Sets up 3D visual markers, socket coaster pads, and upright beverages
     * for active Pints & Pegs drinking spaces on the 3D board model.
     */
    setupPintsObjects() {
      if (!this.scene || !this.BABYLON || this.isDestroyed) return;
      if (!this.isPintsMode()) {
        this.clearPintsObjects();
        return;
      }
      this.clearPintsObjects();
      const BABYLON = this.BABYLON;
      this.pintsObjectsRoot = new BABYLON.TransformNode("pintsObjectsRoot", this.scene);
      if (this.boardRoot) {
        this.pintsObjectsRoot.parent = this.boardRoot;
      }
      const hasExplicitCoords = Boolean(this.boardConfig?.coordinatesData || this.boardConfig?.holeData);
      this.pintsObjectsRoot.position.y = hasExplicitCoords ? 0 : 5;
      if (!this.glowLayer && BABYLON.GlowLayer) {
        try {
          this.glowLayer = new BABYLON.GlowLayer("boardObstaclesGlow", this.scene, {
            mainTextureRatio: 0.5,
            blurKernelSize: 16
          });
          this.glowLayer.intensity = 0.55;
        } catch (_) {
        }
      }
      const dims = this.getPegDimensions("front");
      const spacing = dims.spacing || 7.75;
      const markerRadius = spacing * 0.38;
      const padHeight = 0.22;
      const materials = this._getPintsMaterials();
      this._render3DPintsCoastersAndBeverages(spacing, markerRadius, padHeight, materials);
    }
    /**
     * Clears and disposes all 3D pints drinking meshes.
     */
    clearPintsObjects() {
      if (this.pintsObjectsRoot) {
        try {
          this.pintsObjectsRoot.dispose(false, true);
        } catch (_) {
        }
        this.pintsObjectsRoot = null;
      }
    }
    /**
     * Dynamically updates 3D pints drinking space placements when game settings or presets change.
     * @param {Object} [settings=null]
     */
    updatePintsObjects(settings3 = null) {
      if (settings3) {
        this.settings = Object.assign(this.settings || {}, settings3);
      }
      this.setupPintsObjects();
    }
    /**
     * Generates or retrieves cached PBR materials for 3D Pints drinking markers and beverages.
     * @private
     */
    _getPintsMaterials() {
      const BABYLON = this.BABYLON;
      if (this._pintsMaterials) return this._pintsMaterials;
      const createMat = (name, colHex, emHex, emissiveScale = 0.65, metallic = 0.15, roughness = 0.3) => {
        const mat = new BABYLON.PBRMaterial(name, this.scene);
        const col = BABYLON.Color3.FromHexString(colHex);
        const em = BABYLON.Color3.FromHexString(emHex);
        mat.albedoColor = col;
        mat.emissiveColor = em.scale(emissiveScale);
        mat.metallic = metallic;
        mat.roughness = roughness;
        return mat;
      };
      const mats = {
        // Coasters & trim
        coasterWood: createMat("matPints_CoasterWood", "#3e2723", "#27180d", 0.2, 0.05, 0.6),
        coasterSlate: createMat("matPints_CoasterSlate", "#1e293b", "#0f172a", 0.2, 0.2, 0.5),
        coasterMarble: createMat("matPints_CoasterMarble", "#f8fafc", "#e2e8f0", 0.25, 0.1, 0.2),
        coasterGold: createMat("matPints_CoasterGold", "#f59e0b", "#d97706", 0.7, 0.85, 0.2),
        coasterSilver: createMat("matPints_CoasterSilver", "#cbd5e1", "#94a3b8", 0.4, 0.85, 0.25),
        // Beverage Liquids & Accents
        beerAmber: createMat("matPints_BeerAmber", "#f59e0b", "#d97706", 0.75, 0.1, 0.35),
        beerDarkAle: createMat("matPints_BeerDarkAle", "#78350f", "#451a03", 0.6, 0.1, 0.4),
        beerFoam: createMat("matPints_BeerFoam", "#ffffff", "#fef3c7", 0.85, 0, 0.7),
        wineRuby: createMat("matPints_WineRuby", "#991b1b", "#7f1d1d", 0.8, 0.1, 0.2),
        cocktailViolet: createMat("matPints_CocktailViolet", "#7c3aed", "#6d28d9", 0.75, 0.1, 0.25),
        cocktailOrange: createMat("matPints_CocktailOrange", "#ea580c", "#c2410c", 0.8, 0.1, 0.25),
        champagneGold: createMat("matPints_ChampagneGold", "#fef08a", "#facc15", 0.85, 0.15, 0.2),
        iceBucketSteel: createMat("matPints_IceBucketSteel", "#e2e8f0", "#94a3b8", 0.35, 0.9, 0.15),
        shakerSteel: createMat("matPints_ShakerSteel", "#f1f5f9", "#cbd5e1", 0.4, 0.92, 0.12),
        bottleGreen: createMat("matPints_BottleGreen", "#14532d", "#052e16", 0.6, 0.2, 0.3),
        bottleFoilGold: createMat("matPints_BottleFoilGold", "#fbbf24", "#f59e0b", 0.85, 0.8, 0.25),
        corkWood: createMat("matPints_CorkWood", "#b45309", "#92400e", 0.2, 0.02, 0.85),
        limeGarnish: createMat("matPints_LimeGarnish", "#84cc16", "#65a30d", 0.7, 0.05, 0.4),
        orangeGarnish: createMat("matPints_OrangeGarnish", "#f97316", "#ea580c", 0.8, 0.05, 0.4),
        strawCyan: createMat("matPints_StrawCyan", "#06b6d4", "#0891b2", 0.85, 0.1, 0.3),
        strawMagenta: createMat("matPints_StrawMagenta", "#ec4899", "#db2777", 0.85, 0.1, 0.3),
        targetRed: createMat("matPints_TargetRed", "#e11d48", "#be123c", 0.9, 0.1, 0.3),
        targetWhite: createMat("matPints_TargetWhite", "#ffffff", "#f1f5f9", 0.6, 0.1, 0.3),
        // Glass & Ice
        glass: (() => {
          const m = new BABYLON.PBRMaterial("matPints_Glass", this.scene);
          m.albedoColor = new BABYLON.Color3(0.88, 0.95, 1);
          m.alpha = 0.42;
          m.metallic = 0.08;
          m.roughness = 0.12;
          return m;
        })(),
        iceCube: (() => {
          const m = new BABYLON.PBRMaterial("matPints_IceCube", this.scene);
          m.albedoColor = new BABYLON.Color3(0.92, 0.97, 1);
          m.alpha = 0.55;
          m.metallic = 0.05;
          m.roughness = 0.08;
          return m;
        })(),
        // Themed Track Socket Pads
        padYouDrink: createMat("matPints_PadYouDrink", "#f59e0b", "#d97706", 0.85),
        padGuysDrink: createMat("matPints_PadGuysDrink", "#6366f1", "#4f46e5", 0.85),
        padGalsDrink: createMat("matPints_PadGalsDrink", "#ec4899", "#db2777", 0.85),
        padLeftDrink: createMat("matPints_PadLeftDrink", "#3b82f6", "#2563eb", 0.85),
        padRightDrink: createMat("matPints_PadRightDrink", "#06b6d4", "#0891b2", 0.85),
        padEveryoneDrink: createMat("matPints_PadEveryoneDrink", "#10b981", "#059669", 0.85),
        padEveryoneButYouDrink: createMat("matPints_PadEveryoneButYouDrink", "#8b5cf6", "#7c3aed", 0.85),
        padPickWhoDrinks: createMat("matPints_PadPickWhoDrinks", "#e11d48", "#be123c", 0.85),
        padRim: createMat("matPints_PadRim", "#ffffff", "#e2e8f0", 0.5, 0.5, 0.25)
      };
      this._pintsMaterials = mats;
      return mats;
    }
    /**
     * Retrieves active Pints drinking space configurations from settings or presets.
     * @returns {Array<Object>}
     */
    getActivePintsConfigs() {
      const settings3 = this.settings || {};
      const brand = this.options.brand || settings3?.brand || typeof window !== "undefined" && (window.CRAZY_BRAND || typeof window.getAppBrand === "function" && window.getAppBrand());
      const isPints = brand === "pints";
      if (Array.isArray(this.options.pintsConfigs) && this.options.pintsConfigs.length > 0) {
        return this.options.pintsConfigs;
      }
      const drinkingTypes = [
        { key: "youDrink", name: "You Drink", icon: "\u{1F37A}", defHoles: [15, 45, 75, 105] },
        { key: "guysDrink", name: "Guys Drink", icon: "\u{1F37B}", defHoles: [25, 55, 85, 115] },
        { key: "galsDrink", name: "Gals Drink", icon: "\u{1F377}", defHoles: [35, 65, 95, 105] },
        { key: "leftDrink", name: "Left Drinks", icon: "\u{1F448}", defHoles: [20, 50, 80, 110] },
        { key: "rightDrink", name: "Right Drinks", icon: "\u{1F449}", defHoles: [40, 70, 100, 120] },
        { key: "everyoneDrink", name: "Everyone Drinks", icon: "\u{1F942}", defHoles: [30, 60, 90, 120] },
        { key: "everyoneButYouDrink", name: "Everyone But You", icon: "\u{1F389}", defHoles: [10, 50, 90, 110] },
        { key: "pickWhoDrinks", name: "Pick Who Drinks", icon: "\u{1F3AF}", defHoles: [25, 55, 85, 115] }
      ];
      const configs = [];
      drinkingTypes.forEach((dt) => {
        const chkKey = `opt${dt.key.charAt(0).toUpperCase() + dt.key.slice(1)}`;
        const isChecked = Boolean(settings3[chkKey] || settings3[dt.key] || isPints && (settings3[`${dt.key}Holes`] || settings3[`${chkKey}1Hole`]));
        if (!isChecked) return;
        const arr = settings3[`${dt.key}Holes`] || [];
        const rawCnt = settings3[`${chkKey}Count`] || settings3[`${dt.key}Count`] || arr.length || 2;
        const count = Math.min(4, Math.max(1, parseInt(rawCnt, 10) || 1));
        const rawPegs = settings3[`${chkKey}Pegs`] || settings3[`${dt.key}Pegs`] || 1;
        const pegs = Math.min(5, Math.max(1, parseInt(rawPegs, 10) || 1));
        for (let i = 1; i <= count; i++) {
          const h = settings3[`${chkKey}${i}Hole`] || arr[i - 1] || dt.defHoles[i - 1] || 15;
          if (h && h > 0 && h <= this.targetHoles) {
            configs.push({
              id: `${dt.key}_${i}`,
              type: dt.key,
              name: `${dt.name} ${i}`,
              icon: dt.icon,
              index: i,
              hole: parseInt(h, 10),
              pegs: parseInt(pegs, 10)
            });
          }
        }
      });
      return configs;
    }
    /**
     * Checks whether Skunked and Stripped (Adult Brand) options are active on this board.
     * @returns {boolean}
     */
    isAdultMode() {
      const brand = this.options.brand || this.settings?.brand || typeof window !== "undefined" && (window.CRAZY_BRAND || typeof window.getAppBrand === "function" && window.getAppBrand());
      if (brand && brand !== "adult") return false;
      if (brand === "adult") return true;
      const hasAdultSettings = Boolean(
        this.settings && (this.settings.optLoseClothing || this.settings.optGainClothing || this.settings.optPickWhoLosesClothing || this.settings.optRightLosesClothing || this.settings.optLeftLosesClothing || this.settings.optRemoveClothingChoice || this.settings.optTouchBreast || this.settings.optLickBreast || this.settings.optSuckBreast || this.settings.optTouchGenitals || this.settings.optLickGenitals || this.settings.optSuckGenitals || this.settings.optFingerGenitals || this.settings.optGenitalIntercourse || this.settings.optTouchAnus || this.settings.optLickAnus || this.settings.optFingerAnus || this.settings.optAnalIntercourse)
      );
      const hasAdultConfigs = Boolean(
        this.options.adultConfigs && this.options.adultConfigs.length > 0
      );
      return hasAdultSettings || hasAdultConfigs;
    }
    /**
     * Sets up 3D visual markers, socket coaster pads, and sensual sculptures
     * for active Skunked & Stripped (Adult) options on the 3D board model.
     */
    setupAdultObjects() {
      if (!this.scene || !this.BABYLON || this.isDestroyed) return;
      if (!this.isAdultMode()) {
        this.clearAdultObjects();
        return;
      }
      this.clearAdultObjects();
      const BABYLON = this.BABYLON;
      this.adultObjectsRoot = new BABYLON.TransformNode("adultObjectsRoot", this.scene);
      if (this.boardRoot) {
        this.adultObjectsRoot.parent = this.boardRoot;
      }
      const hasExplicitCoords = Boolean(this.boardConfig?.coordinatesData || this.boardConfig?.holeData);
      this.adultObjectsRoot.position.y = hasExplicitCoords ? 0 : 5;
      if (!this.glowLayer && BABYLON.GlowLayer) {
        try {
          this.glowLayer = new BABYLON.GlowLayer("boardObstaclesGlow", this.scene, {
            mainTextureRatio: 0.5,
            blurKernelSize: 16
          });
          this.glowLayer.intensity = 0.55;
        } catch (_) {
        }
      }
      const dims = this.getPegDimensions("front");
      const spacing = dims.spacing || 7.75;
      const markerRadius = spacing * 0.38;
      const padHeight = 0.22;
      const materials = this._getAdultMaterials();
      this._render3DAdultCoastersAndObjects(spacing, markerRadius, padHeight, materials);
    }
    /**
     * Clears and disposes all 3D adult challenge meshes.
     */
    clearAdultObjects() {
      if (this.adultObjectsRoot) {
        try {
          this.adultObjectsRoot.dispose(false, true);
        } catch (_) {
        }
        this.adultObjectsRoot = null;
      }
    }
    /**
     * Dynamically updates 3D adult challenge placements when game settings or presets change.
     * @param {Object} [settings=null]
     */
    updateAdultObjects(settings3 = null) {
      if (settings3) {
        this.settings = Object.assign(this.settings || {}, settings3);
      }
      this.setupAdultObjects();
    }
    /**
     * Generates or retrieves cached PBR materials for 3D Adult markers and sculptures.
     * @private
     */
    _getAdultMaterials() {
      const BABYLON = this.BABYLON;
      if (this._adultMaterials) return this._adultMaterials;
      const createMat = (name, colHex, emHex, emissiveScale = 0.65, metallic = 0.15, roughness = 0.3) => {
        const mat = new BABYLON.PBRMaterial(name, this.scene);
        const col = BABYLON.Color3.FromHexString(colHex);
        const em = BABYLON.Color3.FromHexString(emHex);
        mat.albedoColor = col;
        mat.emissiveColor = em.scale(emissiveScale);
        mat.metallic = metallic;
        mat.roughness = roughness;
        return mat;
      };
      const mats = {
        // Pedestals, plinths & luxury materials
        pedestalObsidian: createMat("matAdult_PedestalObsidian", "#0f172a", "#020617", 0.15, 0.25, 0.35),
        pedestalRoseGold: createMat("matAdult_PedestalRoseGold", "#f43f5e", "#e11d48", 0.7, 0.85, 0.2),
        pedestalGold: createMat("matAdult_PedestalGold", "#f59e0b", "#d97706", 0.75, 0.9, 0.18),
        pedestalSilver: createMat("matAdult_PedestalSilver", "#e2e8f0", "#cbd5e1", 0.45, 0.92, 0.15),
        pedestalWood: createMat("matAdult_PedestalWood", "#451a03", "#27180d", 0.2, 0.05, 0.5),
        velvetRed: createMat("matAdult_VelvetRed", "#991b1b", "#7f1d1d", 0.45, 0.05, 0.85),
        velvetPurple: createMat("matAdult_VelvetPurple", "#6b21a8", "#581c87", 0.45, 0.05, 0.85),
        velvetPink: createMat("matAdult_VelvetPink", "#f43f5e", "#e11d48", 0.5, 0.05, 0.85),
        silkPink: createMat("matAdult_SilkPink", "#fb7185", "#f43f5e", 0.75, 0.1, 0.3),
        satinEmerald: createMat("matAdult_SatinEmerald", "#10b981", "#059669", 0.75, 0.1, 0.3),
        sculptureGold: createMat("matAdult_SculptureGold", "#fbbf24", "#f59e0b", 0.8, 0.9, 0.2),
        lipsRuby: createMat("matAdult_LipsRuby", "#e11d48", "#be123c", 0.9, 0.15, 0.18),
        peachBlush: createMat("matAdult_PeachBlush", "#fb923c", "#f97316", 0.65, 0.05, 0.5),
        strawberryRed: createMat("matAdult_StrawberryRed", "#dc2626", "#b91c1c", 0.75, 0.1, 0.25),
        leafGreen: createMat("matAdult_LeafGreen", "#16a34a", "#15803d", 0.4, 0.05, 0.45),
        candleWax: createMat("matAdult_CandleWax", "#fef08a", "#fde047", 0.6, 0.05, 0.5),
        candleFlame: createMat("matAdult_CandleFlame", "#ffedd5", "#f97316", 1.2, 0, 0.1),
        ribbonScarlet: createMat("matAdult_RibbonScarlet", "#e11d48", "#be123c", 0.85, 0.1, 0.3),
        sandGold: createMat("matAdult_SandGold", "#fbbf24", "#f59e0b", 0.85, 0.2, 0.4),
        // Glass for hourglass & votives
        glass: (() => {
          const m = new BABYLON.PBRMaterial("matAdult_Glass", this.scene);
          m.albedoColor = new BABYLON.Color3(0.9, 0.96, 1);
          m.alpha = 0.38;
          m.metallic = 0.08;
          m.roughness = 0.12;
          return m;
        })(),
        // Themed Track Socket Pads
        padLoseClothing: createMat("matAdult_PadLoseClothing", "#f43f5e", "#e11d48", 0.85),
        padGainClothing: createMat("matAdult_PadGainClothing", "#10b981", "#059669", 0.85),
        padPickWhoLosesClothing: createMat("matAdult_PadPickWhoLosesClothing", "#ec4899", "#db2777", 0.85),
        padRightLosesClothing: createMat("matAdult_PadRightLosesClothing", "#3b82f6", "#2563eb", 0.85),
        padLeftLosesClothing: createMat("matAdult_PadLeftLosesClothing", "#8b5cf6", "#7c3aed", 0.85),
        padRemoveClothingChoice: createMat("matAdult_PadRemoveClothingChoice", "#e11d48", "#be123c", 0.85),
        padTouchBreast: createMat("matAdult_PadTouchBreast", "#f43f5e", "#e11d48", 0.85),
        padLickBreast: createMat("matAdult_PadLickBreast", "#ec4899", "#db2777", 0.85),
        padSuckBreast: createMat("matAdult_PadSuckBreast", "#d946ef", "#c026d3", 0.85),
        padTouchGenitals: createMat("matAdult_PadTouchGenitals", "#a855f7", "#9333ea", 0.85),
        padLickGenitals: createMat("matAdult_PadLickGenitals", "#f43f5e", "#e11d48", 0.85),
        padSuckGenitals: createMat("matAdult_PadSuckGenitals", "#ec4899", "#db2777", 0.85),
        padFingerGenitals: createMat("matAdult_PadFingerGenitals", "#f59e0b", "#d97706", 0.85),
        padGenitalIntercourse: createMat("matAdult_PadGenitalIntercourse", "#ef4444", "#dc2626", 0.9),
        padTouchAnus: createMat("matAdult_PadTouchAnus", "#8b5cf6", "#7c3aed", 0.85),
        padLickAnus: createMat("matAdult_PadLickAnus", "#ec4899", "#db2777", 0.85),
        padFingerAnus: createMat("matAdult_PadFingerAnus", "#f59e0b", "#d97706", 0.85),
        padAnalIntercourse: createMat("matAdult_PadAnalIntercourse", "#ef4444", "#dc2626", 0.9),
        padRim: createMat("matAdult_PadRim", "#ffffff", "#e2e8f0", 0.5, 0.5, 0.25)
      };
      this._adultMaterials = mats;
      return mats;
    }
    /**
     * Retrieves active Skunked & Stripped (Adult) configurations from settings or presets.
     * @returns {Array<Object>}
     */
    getActiveAdultConfigs() {
      const settings3 = this.settings || {};
      const brand = this.options.brand || settings3?.brand || typeof window !== "undefined" && (window.CRAZY_BRAND || typeof window.getAppBrand === "function" && window.getAppBrand());
      const isAdult = brand === "adult";
      if (Array.isArray(this.options.adultConfigs) && this.options.adultConfigs.length > 0) {
        return this.options.adultConfigs;
      }
      const adultTypes = [
        { key: "loseClothing", name: "You Lose Clothing", icon: "\u{1F459}", color: "#f43f5e", defHoles: [10, 70, 10, 70] },
        { key: "gainClothing", name: "You Gain Clothing", icon: "\u{1F9E5}", color: "#10b981", defHoles: [20, 80, 20, 80] },
        { key: "pickWhoLosesClothing", name: "Pick Who Strips", icon: "\u{1F3AF}", color: "#ec4899", defHoles: [30, 90, 30, 90] },
        { key: "rightLosesClothing", name: "Right Neighbor Strips", icon: "\u{1F449}", color: "#3b82f6", defHoles: [40, 100, 40, 100] },
        { key: "leftLosesClothing", name: "Left Neighbor Strips", icon: "\u{1F448}", color: "#8b5cf6", defHoles: [50, 110, 50, 110] },
        { key: "removeClothingChoice", name: "Remove Clothing Choice", icon: "\u2702\uFE0F", color: "#e11d48", defHoles: [60, 120, 60, 120] },
        { key: "touchBreast", name: "Touch Breast", icon: "\u{1F48B}", color: "#f43f5e", defHoles: [5, 45, 75, 105], timed: true },
        { key: "lickBreast", name: "Lick Breast", icon: "\u{1F445}", color: "#ec4899", defHoles: [15, 50, 80, 110], timed: true },
        { key: "suckBreast", name: "Suck Breast", icon: "\u{1F444}", color: "#d946ef", defHoles: [25, 55, 85, 115], timed: true },
        { key: "touchGenitals", name: "Touch Genitals", icon: "\u2728", color: "#a855f7", defHoles: [35, 40, 70, 100], timed: true },
        { key: "lickGenitals", name: "Lick Genitals", icon: "\u{1F445}", color: "#f43f5e", defHoles: [45, 60, 90, 120], timed: true },
        { key: "suckGenitals", name: "Suck Genitals", icon: "\u{1F444}", color: "#ec4899", defHoles: [55, 65, 95, 115], timed: true },
        { key: "fingerGenitals", name: "Finger Genitals", icon: "\u{1F449}", color: "#f59e0b", defHoles: [65, 45, 75, 105], timed: true },
        { key: "genitalIntercourse", name: "Genital Intercourse", icon: "\u{1F525}", color: "#ef4444", defHoles: [75, 55, 85, 115], timed: true },
        { key: "touchAnus", name: "Touch Anus", icon: "\u{1F351}", color: "#8b5cf6", defHoles: [85, 50, 80, 110], timed: true },
        { key: "lickAnus", name: "Lick Anus", icon: "\u{1F445}", color: "#ec4899", defHoles: [95, 55, 85, 115], timed: true },
        { key: "fingerAnus", name: "Finger Anus", icon: "\u{1F449}", color: "#f59e0b", defHoles: [105, 60, 90, 120], timed: true },
        { key: "analIntercourse", name: "Anal Intercourse", icon: "\u{1F525}", color: "#ef4444", defHoles: [115, 65, 95, 115], timed: true }
      ];
      const configs = [];
      adultTypes.forEach((at) => {
        const chkKey = `opt${at.key.charAt(0).toUpperCase() + at.key.slice(1)}`;
        const isChecked = Boolean(settings3[chkKey] || settings3[at.key] || isAdult && (settings3[`${at.key}Holes`] || settings3[`${chkKey}1Hole`]));
        if (!isChecked) return;
        const arr = settings3[`${at.key}Holes`] || [];
        const rawCnt = settings3[`${chkKey}Count`] || settings3[`${at.key}Count`] || arr.length || 2;
        const count = Math.min(4, Math.max(1, parseInt(rawCnt, 10) || 1));
        const rawPegs = settings3[`${chkKey}Pegs`] || settings3[`${at.key}Pegs`] || 1;
        const pegs = Math.min(5, Math.max(1, parseInt(rawPegs, 10) || 1));
        for (let i = 1; i <= count; i++) {
          const h = settings3[`${chkKey}${i}Hole`] || arr[i - 1] || at.defHoles[i - 1] || 15;
          if (h && h > 0 && h <= this.targetHoles) {
            configs.push({
              id: `${at.key}_${i}`,
              type: at.key,
              name: `${at.name} ${i}`,
              icon: at.icon,
              color: at.color,
              index: i,
              hole: parseInt(h, 10),
              pegs: parseInt(pegs, 10),
              timed: Boolean(at.timed)
            });
          }
        }
      });
      return configs;
    }
    /**
     * Generates or retrieves cached PBR materials for 3D clash obstacle markers.
     * @private
     */
    _getClashObstacleMaterials() {
      const BABYLON = this.BABYLON;
      if (this._obstacleMaterials) return this._obstacleMaterials;
      const createMat = (name, colHex, emHex, emissiveScale = 0.65) => {
        const mat = new BABYLON.PBRMaterial(name, this.scene);
        const col = BABYLON.Color3.FromHexString(colHex);
        const em = BABYLON.Color3.FromHexString(emHex);
        mat.albedoColor = col;
        mat.emissiveColor = em.scale(emissiveScale);
        mat.metallic = 0.15;
        mat.roughness = 0.3;
        return mat;
      };
      const mats = {
        stopSign: createMat("mat3D_StopSign", "#d32f2f", "#ff1744", 0.95),
        stopSignInner: createMat("mat3D_StopSignInner", "#ffffff", "#ffffff", 0.5),
        stopSignPole: createMat("mat3D_StopSignPole", "#b0bec5", "#eceff1", 0.35),
        jumpFwdLaunch: createMat("mat3D_JumpFwdLaunch", "#00e676", "#00ff80", 0.9),
        jumpFwdDest: createMat("mat3D_JumpFwdDest", "#00b0ff", "#00e5ff", 0.85),
        jumpBwdLaunch: createMat("mat3D_JumpBwdLaunch", "#ff3d00", "#ff1744", 0.9),
        jumpBwdDest: createMat("mat3D_JumpBwdDest", "#b71c1c", "#d50000", 0.85),
        jumpArcFwd: createMat("mat3D_JumpArcFwd", "#00e676", "#00ff88", 1),
        jumpArcBwd: createMat("mat3D_JumpArcBwd", "#ff1744", "#ff5252", 1),
        jail: createMat("mat3D_Jail", "#8e24aa", "#ba68c8", 0.85),
        bar: createMat("mat3D_Bar", "#ffb300", "#ffd54f", 0.85),
        timeout: createMat("mat3D_Timeout", "#fb8c00", "#ffa726", 0.85),
        detour: createMat("mat3D_Detour", "#ffd600", "#ffea00", 0.85),
        roundabout: createMat("mat3D_RoundAbout", "#00bcd4", "#26c6da", 0.85),
        noPassing: createMat("mat3D_NoPassing", "#0091ea", "#00b0ff", 0.95),
        noPassingBarrier: createMat("mat3D_NoPassingBarrier", "#00e5ff", "#80d8ff", 0.95),
        noPassingCone: createMat("mat3D_NoPassingCone", "#0d47a1", "#2979ff", 0.9),
        signs: createMat("mat3D_Signs", "#d81b60", "#f06292", 0.85),
        accentWhite: createMat("mat3D_AccentWhite", "#ffffff", "#e0e0e0", 0.4),
        glass: (() => {
          const m = new BABYLON.PBRMaterial("mat3D_Glass", this.scene);
          m.albedoColor = new BABYLON.Color3(0.85, 0.93, 1);
          m.alpha = 0.42;
          m.metallic = 0.08;
          m.roughness = 0.12;
          return m;
        })(),
        beerLiquid: createMat("mat3D_BeerLiquid", "#f59e0b", "#d97706", 0.5),
        beerFoam: createMat("mat3D_BeerFoam", "#fffdf5", "#fff9c4", 0.25),
        wineLiquid: createMat("mat3D_WineLiquid", "#881337", "#9f1239", 0.4),
        shotSpirit: createMat("mat3D_ShotSpirit", "#eab308", "#ca8a04", 0.5),
        barCoaster: createMat("mat3D_BarCoaster", "#3e2723", "#5d4037", 0.25),
        metalCage: (() => {
          const m = new BABYLON.PBRMaterial("mat3D_MetalCage", this.scene);
          m.albedoColor = BABYLON.Color3.FromHexString("#37474f");
          m.emissiveColor = BABYLON.Color3.FromHexString("#263238").scale(0.35);
          m.metallic = 0.88;
          m.roughness = 0.28;
          return m;
        })(),
        metalBars: (() => {
          const m = new BABYLON.PBRMaterial("mat3D_MetalBars", this.scene);
          m.albedoColor = BABYLON.Color3.FromHexString("#78909c");
          m.emissiveColor = BABYLON.Color3.FromHexString("#546e7a").scale(0.3);
          m.metallic = 0.92;
          m.roughness = 0.18;
          return m;
        })(),
        cageLock: (() => {
          const m = new BABYLON.PBRMaterial("mat3D_CageLock", this.scene);
          m.albedoColor = BABYLON.Color3.FromHexString("#fbc02d");
          m.emissiveColor = BABYLON.Color3.FromHexString("#f57f17").scale(0.5);
          m.metallic = 0.85;
          m.roughness = 0.25;
          return m;
        })(),
        dunceWood: createMat("mat3D_DunceWood", "#5d4037", "#3e2723", 0.25),
        dunceCap: createMat("mat3D_DunceCap", "#fffdf5", "#ffffff", 0.2),
        dunceRed: createMat("mat3D_DunceRed", "#d32f2f", "#f44336", 0.5),
        timeoutPlatform: createMat("mat3D_TimeoutPlatform", "#4e342e", "#3e2723", 0.2),
        asphaltRoad: (() => {
          const m = createMat("mat3D_AsphaltRoad", "#242424", "#171717", 0.1);
          m.roughness = 0.88;
          m.metallic = 0.05;
          return m;
        })(),
        concreteCurb: (() => {
          const m = createMat("mat3D_ConcreteCurb", "#eceff1", "#cfd8dc", 0.2);
          m.roughness = 0.55;
          m.metallic = 0.08;
          return m;
        })(),
        grassLawn: (() => {
          const m = createMat("mat3D_GrassLawn", "#2e7d32", "#1b5e20", 0.25);
          m.roughness = 0.85;
          m.metallic = 0.02;
          return m;
        })(),
        roadLineWhite: createMat("mat3D_RoadLineWhite", "#ffffff", "#e0e0e0", 0.5),
        roadSignBlue: createMat("mat3D_RoadSignBlue", "#0277bd", "#0288d1", 0.65),
        chevronYellow: createMat("mat3D_ChevronYellow", "#fbc02d", "#f57f17", 0.7),
        carWheels: createMat("mat3D_CarWheels", "#1c1c1c", "#000000", 0.1),
        headlights: createMat("mat3D_Headlights", "#fffde7", "#ffeb3b", 0.95),
        detourOrange: createMat("mat3D_DetourOrange", "#ff6d00", "#ff9100", 0.85),
        detourBarricade: createMat("mat3D_DetourBarricade", "#ff3d00", "#ff6e40", 0.85),
        highwayGreen: (() => {
          const m = createMat("mat3D_HighwayGreen", "#00703c", "#008751", 0.65);
          m.roughness = 0.35;
          m.metallic = 0.12;
          return m;
        })(),
        highwayGreenBorder: createMat("mat3D_HighwayGreenBorder", "#ffffff", "#e0e0e0", 0.7),
        dicePad: createMat("mat3D_DicePad", "#7c3aed", "#9333ea", 0.85),
        dicePadRing: createMat("mat3D_DicePadRing", "#c084fc", "#e9d5ff", 0.5),
        diceFelt: (() => {
          const m = createMat("mat3D_DiceFelt", "#064e3b", "#047857", 0.15);
          m.roughness = 0.92;
          m.metallic = 0.02;
          return m;
        })(),
        diceTrayRim: createMat("mat3D_DiceTrayRim", "#3e2723", "#27180d", 0.25),
        diceTrayBase: createMat("mat3D_DiceTrayBase", "#27180d", "#1a0b03", 0.2),
        diceGoldTrim: createMat("mat3D_DiceGoldTrim", "#f59e0b", "#d97706", 0.6),
        wheelPad: createMat("mat3D_WheelPad", "#db2777", "#ec4899", 0.85),
        wheelPadRing: createMat("mat3D_WheelPadRing", "#f472b6", "#fbcfe8", 0.5),
        wheelStand: (() => {
          const m = createMat("mat3D_WheelStand", "#1e293b", "#0f172a", 0.15);
          m.metallic = 0.85;
          m.roughness = 0.35;
          return m;
        })(),
        wheelRim: (() => {
          const m = createMat("mat3D_WheelRim", "#f59e0b", "#d97706", 0.6);
          m.metallic = 0.9;
          m.roughness = 0.2;
          return m;
        })(),
        wheelHub: (() => {
          const m = createMat("mat3D_WheelHub", "#fbbf24", "#f59e0b", 0.8);
          m.metallic = 0.95;
          m.roughness = 0.15;
          return m;
        })(),
        wheelPointer: createMat("mat3D_WheelPointer", "#ef4444", "#dc2626", 0.9)
      };
      this._obstacleMaterials = mats;
      return mats;
    }
    /**
     * Renders 3D Octagonal Stop Sign markers and roadside signposts directly at stop sign holes.
     * @private
     */
    _render3DStopSigns(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.stopSigns) && this.options.obstacleConfigs.stopSigns.length > 0;
      const active2 = hasConfigs || Boolean(
        settings3?.optStopSign || settings3?.optStopSigns || isClash && settings3?.optStopSign !== false && settings3?.optStopSigns !== false
      );
      if (!active2) return;
      const stopSigns = hasConfigs ? this.options.obstacleConfigs.stopSigns : ObstacleGeometry.getStopSignConfigs(Object.assign({}, settings3, { optStopSign: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(stopSigns) || !stopSigns.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      stopSigns.forEach((s) => {
        if (s.hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, s.hole);
          if (!pt) return;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const oct = BABYLON.MeshBuilder.CreateCylinder(`stopSign_${who}_${s.hole}`, {
            diameter: radius * 2.6,
            height: padHeight * 2.2,
            tessellation: 8
          }, this.scene);
          oct.position.set(pt.x, surfaceY + padHeight * 2.2 / 2 + 0.08, pt.z);
          oct.material = mats.stopSign;
          oct.parent = this.clashObstaclesRoot;
          oct.metadata = { obstacle: "stop-sign", hole: s.hole, who };
          const innerOct = BABYLON.MeshBuilder.CreateCylinder(`stopSignInner_${who}_${s.hole}`, {
            diameter: radius * 2,
            height: padHeight * 2.2 + 0.06,
            tessellation: 8
          }, this.scene);
          innerOct.position.set(pt.x, surfaceY + (padHeight * 2.2 + 0.06) / 2 + 0.08, pt.z);
          innerOct.material = mats.stopSignInner;
          innerOct.parent = this.clashObstaclesRoot;
          innerOct.metadata = { obstacle: "stop-sign", hole: s.hole, who };
          const centerOct = BABYLON.MeshBuilder.CreateCylinder(`stopSignCenter_${who}_${s.hole}`, {
            diameter: radius * 1.5,
            height: padHeight * 2.2 + 0.12,
            tessellation: 8
          }, this.scene);
          centerOct.position.set(pt.x, surfaceY + (padHeight * 2.2 + 0.12) / 2 + 0.08, pt.z);
          centerOct.material = mats.stopSign;
          centerOct.parent = this.clashObstaclesRoot;
          centerOct.metadata = { obstacle: "stop-sign", hole: s.hole, who };
        });
        const p0 = this.getHoleCoords(refTrack, s.hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, s.hole + 1));
        if (p0) {
          let nx = 0;
          let nz = 1;
          if (p1) {
            const dx2 = p1.x - p0.x;
            const dz = p1.z - p0.z;
            const len = Math.hypot(dx2, dz) || 1;
            nx = -dz / len;
            nz = dx2 / len;
          }
          const postDist = spacing * 1.65;
          const postX = p0.x + nx * postDist;
          const postZ = p0.z + nz * postDist;
          const postY = (p0 && p0.y !== void 0 ? p0.y : 0.8) + 0.1;
          const poleHeight = 16.8;
          const poleDiameter = 1.35;
          const pole = BABYLON.MeshBuilder.CreateCylinder(`stopSignPole_${s.hole}`, {
            diameter: poleDiameter,
            height: poleHeight,
            tessellation: 20
          }, this.scene);
          pole.position.set(postX, postY + poleHeight / 2, postZ);
          pole.material = mats.stopSignPole || mats.accentWhite;
          pole.parent = this.clashObstaclesRoot;
          pole.metadata = { obstacle: "stop-sign", hole: s.hole, who: refTrack };
          const signDiameter = Math.max(10.5, spacing * 1.68);
          const signDepth = 1.25;
          const signHead = BABYLON.MeshBuilder.CreateCylinder(`stopSignHead_${s.hole}`, {
            diameter: signDiameter,
            height: signDepth,
            tessellation: 8
          }, this.scene);
          signHead.bakeTransformIntoVertices(BABYLON.Matrix.RotationY(Math.PI / 8));
          signHead.position.set(postX, postY + poleHeight - 0.2, postZ);
          signHead.rotation.x = -Math.PI / 3.4;
          signHead.rotation.y = Math.PI;
          signHead.material = mats.stopSign;
          signHead.parent = this.clashObstaclesRoot;
          signHead.metadata = { obstacle: "stop-sign", hole: s.hole, who: refTrack };
          const signBorder = BABYLON.MeshBuilder.CreateCylinder(`stopSignBorder_${s.hole}`, {
            diameter: signDiameter * 0.85,
            height: signDepth + 0.12,
            tessellation: 8
          }, this.scene);
          signBorder.bakeTransformIntoVertices(BABYLON.Matrix.RotationY(Math.PI / 8));
          signBorder.position.set(postX, postY + poleHeight - 0.2, postZ);
          signBorder.rotation.x = signHead.rotation.x;
          signBorder.rotation.y = signHead.rotation.y;
          signBorder.material = mats.stopSignInner;
          signBorder.parent = this.clashObstaclesRoot;
          signBorder.metadata = { obstacle: "stop-sign", hole: s.hole, who: refTrack };
          const signFace = BABYLON.MeshBuilder.CreateCylinder(`stopSignFace_${s.hole}`, {
            diameter: signDiameter * 0.72,
            height: signDepth + 0.24,
            tessellation: 8
          }, this.scene);
          signFace.bakeTransformIntoVertices(BABYLON.Matrix.RotationY(Math.PI / 8));
          signFace.position.set(postX, postY + poleHeight - 0.2, postZ);
          signFace.rotation.x = signHead.rotation.x;
          signFace.rotation.y = signHead.rotation.y;
          signFace.material = mats.stopSign;
          signFace.parent = this.clashObstaclesRoot;
          signFace.metadata = { obstacle: "stop-sign", hole: s.hole, who: refTrack };
          try {
            const dynTex = new BABYLON.DynamicTexture(`stopSignTex_${s.hole}`, { width: 512, height: 512 }, this.scene, true);
            const ctx = dynTex.getContext();
            ctx.fillStyle = "#d32f2f";
            ctx.fillRect(0, 0, 512, 512);
            ctx.strokeStyle = "#ffffff";
            ctx.lineWidth = 28;
            ctx.beginPath();
            const cx = 256;
            const cy = 256;
            const rOct = 224;
            for (let i = 0; i < 8; i++) {
              const ang = i * Math.PI / 4 + Math.PI / 8;
              const px = cx + rOct * Math.cos(ang);
              const py = cy + rOct * Math.sin(ang);
              if (i === 0) ctx.moveTo(px, py);
              else ctx.lineTo(px, py);
            }
            ctx.closePath();
            ctx.stroke();
            ctx.fillStyle = "#ffffff";
            ctx.font = '900 136px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText("STOP", 256, 260);
            dynTex.update();
            const labelDisc = BABYLON.MeshBuilder.CreateCylinder(`stopSignLabel_${s.hole}`, {
              diameter: signDiameter * 0.7,
              height: signDepth + 0.32,
              tessellation: 32
            }, this.scene);
            labelDisc.position.set(postX, postY + poleHeight - 0.2, postZ);
            labelDisc.rotation.x = signHead.rotation.x;
            labelDisc.rotation.y = signHead.rotation.y;
            const textMat = new BABYLON.PBRMaterial(`matStopSignText_${s.hole}`, this.scene);
            textMat.albedoTexture = dynTex;
            textMat.emissiveTexture = dynTex;
            textMat.emissiveColor = new BABYLON.Color3(0.9, 0.9, 0.9);
            textMat.roughness = 0.25;
            labelDisc.material = textMat;
            labelDisc.parent = this.clashObstaclesRoot;
            labelDisc.metadata = { obstacle: "stop-sign", hole: s.hole, who: refTrack };
          } catch (_) {
          }
        }
      });
    }
    /**
     * Renders 3D Jump launch pads, destination pads, and parabolic trajectory leaping arcs.
     * @private
     */
    _render3DJumps(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.jumps) && this.options.obstacleConfigs.jumps.length > 0;
      const active2 = hasConfigs || Boolean(settings3?.optJump || isClash && settings3?.optJump !== false);
      if (!active2) return;
      const jumps = hasConfigs ? this.options.obstacleConfigs.jumps : ObstacleGeometry.getJumpConfigs(Object.assign({}, settings3, { optJump: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(jumps) || !jumps.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      jumps.forEach((j) => {
        if (j.start > this.targetHoles && j.dest > this.targetHoles) return;
        const isFwd = Boolean(j.isForward);
        const sHole = Math.min(this.targetHoles, isFwd ? j.start : j.start + 1);
        const dHole = Math.min(this.targetHoles, j.dest);
        const endHole = Math.min(this.targetHoles, j.end !== void 0 ? j.end : isFwd ? j.start : j.start + 2);
        const triggerHoles = [];
        for (let h = j.start; h <= endHole; h++) {
          if (h <= this.targetHoles) {
            triggerHoles.push(h);
          }
        }
        if (triggerHoles.length === 0) {
          triggerHoles.push(sHole);
        }
        tracksToMark.forEach((who) => {
          triggerHoles.forEach((h) => {
            const pStart = this.getHoleCoords(who, h);
            if (pStart) {
              const surfaceY = pStart && pStart.y !== void 0 ? pStart.y : 0.8;
              const launchPad = BABYLON.MeshBuilder.CreateCylinder(`jumpStart_${who}_${j.id}_${h}`, {
                diameter: radius * 2,
                height: padHeight,
                tessellation: 24
              }, this.scene);
              launchPad.position.set(pStart.x, surfaceY + padHeight / 2 + 0.08, pStart.z);
              launchPad.material = isFwd ? mats.jumpFwdLaunch : mats.jumpBwdLaunch;
              launchPad.parent = this.clashObstaclesRoot;
              launchPad.metadata = {
                obstacle: "jump-arrow",
                jumpId: j.id,
                start: j.start,
                end: endHole,
                dest: j.dest,
                forward: String(isFwd),
                hole: h
              };
              if (!isFwd) {
                const hazardRing = BABYLON.MeshBuilder.CreateTorus(`jumpHazardRing_${who}_${j.id}_${h}`, {
                  diameter: radius * 2,
                  thickness: 0.22,
                  tessellation: 24
                }, this.scene);
                hazardRing.position.set(pStart.x, surfaceY + padHeight + 0.08, pStart.z);
                hazardRing.rotation.x = Math.PI / 2;
                hazardRing.material = mats.jumpArcBwd || mats.jumpBwdLaunch;
                hazardRing.parent = this.clashObstaclesRoot;
                hazardRing.metadata = launchPad.metadata;
              }
            }
          });
          const pDest = this.getHoleCoords(who, dHole);
          if (pDest) {
            const surfaceY = pDest && pDest.y !== void 0 ? pDest.y : 0.8;
            const destPad = BABYLON.MeshBuilder.CreateCylinder(`jumpDest_${who}_${j.id}`, {
              diameter: radius * 2,
              height: padHeight,
              tessellation: 24
            }, this.scene);
            destPad.position.set(pDest.x, surfaceY + padHeight / 2 + 0.08, pDest.z);
            destPad.material = isFwd ? mats.jumpFwdDest : mats.jumpBwdDest;
            destPad.parent = this.clashObstaclesRoot;
            destPad.metadata = {
              obstacle: "jump-arrow",
              jumpId: j.id,
              start: j.start,
              end: endHole,
              dest: j.dest,
              forward: String(isFwd),
              hole: dHole
            };
          }
        });
        const arcStart = this.getHoleCoords(refTrack, sHole);
        const arcEnd = this.getHoleCoords(refTrack, dHole);
        if (arcStart && arcEnd) {
          const startY = arcStart && typeof arcStart.y === "number" ? arcStart.y : 0.8;
          const endY = arcEnd && typeof arcEnd.y === "number" ? arcEnd.y : 0.8;
          const dx2 = arcEnd.x - arcStart.x;
          const dz = arcEnd.z - arcStart.z;
          const dist2 = Math.hypot(dx2, dz);
          if (dist2 >= 4) {
            const steps = 32;
            const vertDelta = Math.abs(endY - startY);
            const apexClearance = Math.max(6, Math.min(26, dist2 * 0.35));
            const curveHeight = vertDelta / 2 + apexClearance;
            const path = [];
            for (let s = 0; s <= steps; s++) {
              const t = s / steps;
              const x = arcStart.x + dx2 * t;
              const z = arcStart.z + dz * t;
              const baseY = startY + (endY - startY) * t;
              const arcY = 4 * curveHeight * t * (1 - t);
              path.push(new BABYLON.Vector3(x, baseY + arcY + 0.2, z));
            }
            const tube = BABYLON.MeshBuilder.CreateTube(`jumpTube_${j.id}`, {
              path,
              radius: 0.42,
              tessellation: 12
            }, this.scene);
            tube.material = isFwd ? mats.jumpArcFwd : mats.jumpArcBwd;
            tube.parent = this.clashObstaclesRoot;
            tube.metadata = {
              obstacle: "jump-arrow",
              jumpId: j.id,
              start: j.start,
              end: j.end,
              dest: j.dest,
              forward: String(isFwd)
            };
            const coneHeight = 1.8;
            const cone = BABYLON.MeshBuilder.CreateCylinder(`jumpCone_${j.id}`, {
              diameterTop: 0,
              diameterBottom: 1.4,
              height: coneHeight,
              tessellation: 16
            }, this.scene);
            const lastPt = path[path.length - 1];
            const prevPt = path[path.length - 2];
            const dir = lastPt.subtract(prevPt).normalize();
            cone.position.set(
              arcEnd.x - dir.x * (coneHeight * 0.45),
              endY + padHeight + 0.08 - dir.y * (coneHeight * 0.45),
              arcEnd.z - dir.z * (coneHeight * 0.45)
            );
            if (BABYLON.Quaternion && typeof BABYLON.Quaternion.FromUnitVectorsToRef === "function") {
              cone.rotationQuaternion = BABYLON.Quaternion.FromUnitVectorsToRef(
                new BABYLON.Vector3(0, 1, 0),
                dir,
                new BABYLON.Quaternion()
              );
            } else {
              const pitch = Math.acos(Math.max(-1, Math.min(1, dir.y)));
              const yaw = Math.atan2(dir.x, dir.z);
              cone.rotation.set(pitch, yaw, 0);
            }
            cone.material = isFwd ? mats.jumpFwdDest : mats.jumpBwdDest;
            cone.parent = this.clashObstaclesRoot;
            cone.metadata = tube.metadata;
          }
        }
      });
    }
    /**
     * Helper to render holding areas (Jails, Bars, Timeouts) with trigger pads and holding step studs.
     * @private
     */
    _render3DHoldingArea(items, type, mat, mats, spacing, radius, padHeight) {
      const BABYLON = this.BABYLON;
      if (!Array.isArray(items) || !items.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      items.forEach((item) => {
        const hole = item.hole;
        if (hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, hole);
          if (!pt) return;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const disc = BABYLON.MeshBuilder.CreateCylinder(`${type}Trigger_${who}_${hole}`, {
            diameter: radius * 2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          disc.position.set(pt.x, surfaceY + padHeight / 2 + 0.08, pt.z);
          disc.material = mat;
          disc.parent = this.clashObstaclesRoot;
          disc.metadata = { obstacle: `${type}-cell`, hole, who };
        });
        const p0 = this.getHoleCoords(refTrack, hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, hole + 1));
        if (p0 && p1) {
          const dx2 = p1.x - p0.x;
          const dz = p1.z - p0.z;
          const len = Math.hypot(dx2, dz) || 1;
          const nx = -dz / len;
          const nz = dx2 / len;
          for (let s = 1; s <= 3; s++) {
            const stepDist = radius * 1.8 + s * spacing * 0.85;
            const stepX = p0.x + nx * stepDist;
            const stepZ = p0.z + nz * stepDist;
            const stepY = (p0 && p0.y !== void 0 ? p0.y : 0.8) + padHeight / 2 + 0.08;
            const stud = BABYLON.MeshBuilder.CreateCylinder(`${type}Step_${hole}_${s}`, {
              diameter: radius * 1.2,
              height: padHeight * 0.85,
              tessellation: 16
            }, this.scene);
            stud.position.set(stepX, stepY, stepZ);
            stud.material = mat;
            stud.parent = this.clashObstaclesRoot;
            stud.metadata = { obstacle: `${type}-step`, hole, step: s };
          }
        }
      });
    }
    /**
     * Renders 3D Jail cells with an authentic 3D metal prison cage standing beside the track
     * instead of the 3 dots.
     * @private
     */
    _render3DJails(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.jails) && this.options.obstacleConfigs.jails.length > 0;
      const active2 = hasConfigs || Boolean(settings3?.optJail || isClash && settings3?.optJail !== false);
      if (!active2) return;
      const jails = hasConfigs ? this.options.obstacleConfigs.jails : ObstacleGeometry.getJailConfigs(Object.assign({}, settings3, { optJail: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(jails) || !jails.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      jails.forEach((item) => {
        const hole = item.hole;
        if (hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, hole);
          if (!pt) return;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const disc = BABYLON.MeshBuilder.CreateCylinder(`jailTrigger_${who}_${hole}`, {
            diameter: radius * 2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          disc.position.set(pt.x, surfaceY + padHeight / 2 + 0.08, pt.z);
          disc.material = mats.jail;
          disc.parent = this.clashObstaclesRoot;
          disc.metadata = { obstacle: "jail-cell", hole, who };
          const shackle = BABYLON.MeshBuilder.CreateCylinder(`jailTriggerRing_${who}_${hole}`, {
            diameter: radius * 2.22,
            height: padHeight * 0.75,
            tessellation: 24
          }, this.scene);
          shackle.position.set(pt.x, surfaceY + padHeight * 0.75 / 2 + 0.06, pt.z);
          shackle.material = mats.metalCage || mats.jail;
          shackle.parent = this.clashObstaclesRoot;
          shackle.metadata = { obstacle: "jail-cell", hole, who };
        });
        const p0 = this.getHoleCoords(refTrack, hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, hole + 1));
        if (p0 && p1) {
          const dx2 = p1.x - p0.x;
          const dz = p1.z - p0.z;
          const len = Math.hypot(dx2, dz) || 1;
          const nx = -dz / len;
          const nz = dx2 / len;
          const surfaceY = p0 && p0.y !== void 0 ? p0.y : 0.8;
          const cageDist = radius * 1.8 + spacing * 2.1;
          const cageX = p0.x + nx * cageDist;
          const cageZ = p0.z + nz * cageDist;
          const cageNode = new BABYLON.TransformNode(`jailCageNode_${hole}`, this.scene);
          cageNode.position.set(cageX, surfaceY, cageZ);
          cageNode.rotation.y = Math.atan2(-nx, -nz);
          cageNode.parent = this.clashObstaclesRoot;
          const cageMeta = { obstacle: "jail-cell", hole, who: refTrack };
          const matCage = mats.metalCage || mats.jail;
          const matBars = mats.metalBars || mats.jail;
          const matLock = mats.cageLock || mats.jail;
          const floor = BABYLON.MeshBuilder.CreateBox(`jailCage_${hole}_floor`, {
            width: 14,
            depth: 14,
            height: 0.6
          }, this.scene);
          floor.position.set(0, 0.3, 0);
          floor.material = matCage;
          floor.parent = cageNode;
          floor.metadata = cageMeta;
          const postRadius = 0.55;
          const postHeight = 14;
          const postOffsets = [
            [-5.8, -5.8],
            [5.8, -5.8],
            [-5.8, 5.8],
            [5.8, 5.8]
          ];
          postOffsets.forEach(([px, pz], pIdx) => {
            const post = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_post_${pIdx}`, {
              diameter: postRadius * 2,
              height: postHeight,
              tessellation: 16
            }, this.scene);
            post.position.set(px, 0.6 + postHeight / 2, pz);
            post.material = matCage;
            post.parent = cageNode;
            post.metadata = cageMeta;
          });
          const curbWidth = 12.8;
          const curbHeight = 0.8;
          const curbThick = 0.8;
          const curbBeams = [
            { x: 0, z: -5.8, w: curbWidth, d: curbThick },
            // back
            { x: -5.8, z: 0, w: curbThick, d: curbWidth },
            // left
            { x: 5.8, z: 0, w: curbThick, d: curbWidth },
            // right
            { x: 0, z: 5.8, w: curbWidth, d: curbThick }
            // front
          ];
          curbBeams.forEach((cb, bIdx) => {
            const curb = BABYLON.MeshBuilder.CreateBox(`jailCage_${hole}_curb_${bIdx}`, {
              width: cb.w,
              depth: cb.d,
              height: curbHeight
            }, this.scene);
            curb.position.set(cb.x, 0.6 + curbHeight / 2, cb.z);
            curb.material = matCage;
            curb.parent = cageNode;
            curb.metadata = cageMeta;
          });
          curbBeams.forEach((tb, bIdx) => {
            const topBeam = BABYLON.MeshBuilder.CreateBox(`jailCage_${hole}_topBeam_${bIdx}`, {
              width: tb.w,
              depth: tb.d,
              height: curbHeight
            }, this.scene);
            topBeam.position.set(tb.x, 0.6 + postHeight - curbHeight / 2, tb.z);
            topBeam.material = matCage;
            topBeam.parent = cageNode;
            topBeam.metadata = cageMeta;
          });
          const barHeight = 13;
          const barDiameter = 0.46;
          const barOffsets = [-4.2, -2.1, 0, 2.1, 4.2];
          barOffsets.forEach((bx, bIdx) => {
            const bar = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_barB_${bIdx}`, {
              diameter: barDiameter,
              height: barHeight,
              tessellation: 14
            }, this.scene);
            bar.position.set(bx, 0.6 + barHeight / 2, -5.8);
            bar.material = matBars;
            bar.parent = cageNode;
            bar.metadata = cageMeta;
          });
          barOffsets.forEach((bz, bIdx) => {
            const bar = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_barL_${bIdx}`, {
              diameter: barDiameter,
              height: barHeight,
              tessellation: 14
            }, this.scene);
            bar.position.set(-5.8, 0.6 + barHeight / 2, bz);
            bar.material = matBars;
            bar.parent = cageNode;
            bar.metadata = cageMeta;
          });
          barOffsets.forEach((bz, bIdx) => {
            const bar = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_barR_${bIdx}`, {
              diameter: barDiameter,
              height: barHeight,
              tessellation: 14
            }, this.scene);
            bar.position.set(5.8, 0.6 + barHeight / 2, bz);
            bar.material = matBars;
            bar.parent = cageNode;
            bar.metadata = cageMeta;
          });
          [-4.2, 4.2].forEach((bx, bIdx) => {
            const bar = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_barF_${bIdx}`, {
              diameter: barDiameter,
              height: barHeight,
              tessellation: 14
            }, this.scene);
            bar.position.set(bx, 0.6 + barHeight / 2, 5.8);
            bar.material = matBars;
            bar.parent = cageNode;
            bar.metadata = cageMeta;
          });
          [-2.6, 2.6].forEach((dx3, dIdx) => {
            const dPost = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_doorPost_${dIdx}`, {
              diameter: 0.7,
              height: barHeight,
              tessellation: 16
            }, this.scene);
            dPost.position.set(dx3, 0.6 + barHeight / 2, 5.8);
            dPost.material = matCage;
            dPost.parent = cageNode;
            dPost.metadata = cageMeta;
          });
          [-1.3, 0, 1.3].forEach((dx3, dIdx) => {
            const dBar = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_doorBar_${dIdx}`, {
              diameter: barDiameter,
              height: barHeight,
              tessellation: 14
            }, this.scene);
            dBar.position.set(dx3, 0.6 + barHeight / 2, 5.8);
            dBar.material = matBars;
            dBar.parent = cageNode;
            dBar.metadata = cageMeta;
          });
          const doorBrace = BABYLON.MeshBuilder.CreateBox(`jailCage_${hole}_doorBrace`, {
            width: 5.2,
            depth: 0.7,
            height: 0.7
          }, this.scene);
          doorBrace.position.set(0, 0.6 + barHeight / 2, 5.8);
          doorBrace.material = matCage;
          doorBrace.parent = cageNode;
          doorBrace.metadata = cageMeta;
          const lockBody = BABYLON.MeshBuilder.CreateBox(`jailCage_${hole}_lockBody`, {
            width: 1.4,
            height: 1.6,
            depth: 0.8
          }, this.scene);
          lockBody.position.set(2.4, 0.6 + barHeight / 2, 6.4);
          lockBody.material = matLock;
          lockBody.parent = cageNode;
          lockBody.metadata = cageMeta;
          const lockShackle = BABYLON.MeshBuilder.CreateTorus(`jailCage_${hole}_lockShackle`, {
            diameter: 1.1,
            thickness: 0.28,
            tessellation: 16
          }, this.scene);
          lockShackle.position.set(2.4, 0.6 + barHeight / 2 + 1.1, 6.4);
          lockShackle.rotation.x = Math.PI / 2;
          lockShackle.material = matBars;
          lockShackle.parent = cageNode;
          lockShackle.metadata = cageMeta;
          barOffsets.forEach((rx, rIdx) => {
            const roofBar = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_roofBar_${rIdx}`, {
              diameter: 0.42,
              height: 12,
              tessellation: 12
            }, this.scene);
            roofBar.rotation.x = Math.PI / 2;
            roofBar.position.set(rx, 0.6 + postHeight + 0.1, 0);
            roofBar.material = matBars;
            roofBar.parent = cageNode;
            roofBar.metadata = cageMeta;
          });
          const roofCross = BABYLON.MeshBuilder.CreateCylinder(`jailCage_${hole}_roofCross`, {
            diameter: 0.48,
            height: 12,
            tessellation: 12
          }, this.scene);
          roofCross.rotation.z = Math.PI / 2;
          roofCross.position.set(0, 0.6 + postHeight + 0.35, 0);
          roofCross.material = matCage;
          roofCross.parent = cageNode;
          roofCross.metadata = cageMeta;
          const beacon = BABYLON.MeshBuilder.CreateSphere(`jailCage_${hole}_beacon`, {
            diameter: 1.5,
            segments: 16
          }, this.scene);
          beacon.position.set(0, 0.6 + postHeight + 1.2, 0);
          beacon.material = mats.jail;
          beacon.parent = cageNode;
          beacon.metadata = cageMeta;
          const stepPositions = [
            { s: 1, x: -3.4, z: 0 },
            { s: 2, x: 0, z: 0 },
            { s: 3, x: 3.4, z: 0 }
          ];
          stepPositions.forEach((st) => {
            const stepPad = BABYLON.MeshBuilder.CreateCylinder(`jailStep_${hole}_${st.s}`, {
              diameter: 2.2,
              height: 0.28,
              tessellation: 20
            }, this.scene);
            stepPad.position.set(st.x, 0.6 + 0.14, st.z);
            stepPad.material = mats.jail;
            stepPad.parent = cageNode;
            stepPad.metadata = { obstacle: "jail-step", hole, step: st.s };
            const stepRing = BABYLON.MeshBuilder.CreateCylinder(`jailStep_${hole}_${st.s}_ring`, {
              diameter: 2.6,
              height: 0.16,
              tessellation: 20
            }, this.scene);
            stepRing.position.set(st.x, 0.6 + 0.08, st.z);
            stepRing.material = matCage;
            stepRing.parent = cageNode;
            stepRing.metadata = { obstacle: "jail-step", hole, step: st.s };
          });
        }
      });
    }
    /**
     * Renders 3D Bar lounges with custom 3D beverages:
     * - Step 1: A glass of beer (mug with golden beer, white foam cap, and curved handle)
     * - Step 2: A glass of wine (stemmed wine glass with rich red wine)
     * - Step 3: A shot glass (heavy base tapered glass with golden spirit)
     * @private
     */
    _render3DBars(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.bars) && this.options.obstacleConfigs.bars.length > 0;
      const active2 = hasConfigs || Boolean(settings3?.optBar || isClash && settings3?.optBar !== false);
      if (!active2) return;
      const bars = hasConfigs ? this.options.obstacleConfigs.bars : ObstacleGeometry.getBarConfigs(Object.assign({}, settings3, { optBar: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(bars) || !bars.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      bars.forEach((item) => {
        const hole = item.hole;
        if (hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, hole);
          if (!pt) return;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const disc = BABYLON.MeshBuilder.CreateCylinder(`barTrigger_${who}_${hole}`, {
            diameter: radius * 2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          disc.position.set(pt.x, surfaceY + padHeight / 2 + 0.08, pt.z);
          disc.material = mats.bar;
          disc.parent = this.clashObstaclesRoot;
          disc.metadata = { obstacle: "bar-cell", hole, who };
          const coasterRim = BABYLON.MeshBuilder.CreateCylinder(`barTriggerRim_${who}_${hole}`, {
            diameter: radius * 2.22,
            height: padHeight * 0.75,
            tessellation: 24
          }, this.scene);
          coasterRim.position.set(pt.x, surfaceY + padHeight * 0.75 / 2 + 0.06, pt.z);
          coasterRim.material = mats.barCoaster || mats.bar;
          coasterRim.parent = this.clashObstaclesRoot;
          coasterRim.metadata = { obstacle: "bar-cell", hole, who };
        });
        const p0 = this.getHoleCoords(refTrack, hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, hole + 1));
        if (p0 && p1) {
          const dx2 = p1.x - p0.x;
          const dz = p1.z - p0.z;
          const len = Math.hypot(dx2, dz) || 1;
          const nx = -dz / len;
          const nz = dx2 / len;
          const surfaceY = p0 && p0.y !== void 0 ? p0.y : 0.8;
          const baseOffset = radius * 1.8 + 4;
          const stepSpacing = Math.max(13.5, spacing * 1.6);
          for (let s = 1; s <= 3; s++) {
            const stepDist = baseOffset + s * stepSpacing;
            const stepX = p0.x + nx * stepDist;
            const stepZ = p0.z + nz * stepDist;
            const stepMeta = { obstacle: "bar-step", hole, step: s };
            if (s === 1) {
              const coaster = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_1_coaster`, {
                diameter: 11.2,
                height: 0.48,
                tessellation: 24
              }, this.scene);
              coaster.position.set(stepX, surfaceY + 0.24, stepZ);
              coaster.material = mats.barCoaster || mats.bar;
              coaster.parent = this.clashObstaclesRoot;
              coaster.metadata = stepMeta;
              const mugGlass = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_1`, {
                diameter: 9.2,
                height: 14.4,
                tessellation: 24
              }, this.scene);
              mugGlass.position.set(stepX, surfaceY + 0.48 + 7.2, stepZ);
              mugGlass.material = mats.glass || mats.bar;
              mugGlass.parent = this.clashObstaclesRoot;
              mugGlass.metadata = stepMeta;
              const beerLiquid = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_1_liquid`, {
                diameter: 7.8,
                height: 12.4,
                tessellation: 24
              }, this.scene);
              beerLiquid.position.set(stepX, surfaceY + 1.1 + 6.2, stepZ);
              beerLiquid.material = mats.beerLiquid || mats.bar;
              beerLiquid.parent = this.clashObstaclesRoot;
              beerLiquid.metadata = stepMeta;
              const beerFoam = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_1_foam`, {
                diameter: 8.4,
                height: 3,
                tessellation: 24
              }, this.scene);
              beerFoam.position.set(stepX, surfaceY + 13.8, stepZ);
              beerFoam.material = mats.beerFoam || mats.accentWhite;
              beerFoam.parent = this.clashObstaclesRoot;
              beerFoam.metadata = stepMeta;
              const foamCap = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_1_foamcap`, {
                diameter: 9,
                height: 1.2,
                tessellation: 24
              }, this.scene);
              foamCap.position.set(stepX, surfaceY + 15.3, stepZ);
              foamCap.material = mats.beerFoam || mats.accentWhite;
              foamCap.parent = this.clashObstaclesRoot;
              foamCap.metadata = stepMeta;
              try {
                const handleCurve = [];
                const handleAngle = Math.atan2(nz, nx);
                const cosA = Math.cos(handleAngle);
                const sinA = Math.sin(handleAngle);
                for (let a = -Math.PI / 2; a <= Math.PI / 2; a += Math.PI / 6) {
                  const rOut = 4.6 + 2.5 * Math.cos(a);
                  const hOut = 7.8 + 4.4 * Math.sin(a);
                  handleCurve.push(new BABYLON.Vector3(
                    stepX + cosA * rOut,
                    surfaceY + hOut,
                    stepZ + sinA * rOut
                  ));
                }
                const handle = BABYLON.MeshBuilder.CreateTube(`barStep_${hole}_1_handle`, {
                  path: handleCurve,
                  radius: 0.72,
                  tessellation: 12
                }, this.scene);
                handle.material = mats.glass || mats.bar;
                handle.parent = this.clashObstaclesRoot;
                handle.metadata = stepMeta;
              } catch (_) {
              }
            } else if (s === 2) {
              const coaster = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_2_coaster`, {
                diameter: 10.4,
                height: 0.48,
                tessellation: 24
              }, this.scene);
              coaster.position.set(stepX, surfaceY + 0.24, stepZ);
              coaster.material = mats.barCoaster || mats.bar;
              coaster.parent = this.clashObstaclesRoot;
              coaster.metadata = stepMeta;
              const wineBase = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_2`, {
                diameter: 8.4,
                height: 0.72,
                tessellation: 24
              }, this.scene);
              wineBase.position.set(stepX, surfaceY + 0.48 + 0.36, stepZ);
              wineBase.material = mats.glass || mats.bar;
              wineBase.parent = this.clashObstaclesRoot;
              wineBase.metadata = stepMeta;
              const wineStem = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_2_stem`, {
                diameter: 1.28,
                height: 9.2,
                tessellation: 18
              }, this.scene);
              wineStem.position.set(stepX, surfaceY + 1.2 + 4.6, stepZ);
              wineStem.material = mats.glass || mats.bar;
              wineStem.parent = this.clashObstaclesRoot;
              wineStem.metadata = stepMeta;
              const bowlLower = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_2_bowl_lower`, {
                diameterBottom: 2,
                diameterTop: 9.2,
                height: 6,
                tessellation: 24
              }, this.scene);
              bowlLower.position.set(stepX, surfaceY + 10.4 + 3, stepZ);
              bowlLower.material = mats.glass || mats.bar;
              bowlLower.parent = this.clashObstaclesRoot;
              bowlLower.metadata = stepMeta;
              const bowlUpper = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_2_bowl_upper`, {
                diameterBottom: 9.2,
                diameterTop: 7.4,
                height: 5.2,
                tessellation: 24
              }, this.scene);
              bowlUpper.position.set(stepX, surfaceY + 16.4 + 2.6, stepZ);
              bowlUpper.material = mats.glass || mats.bar;
              bowlUpper.parent = this.clashObstaclesRoot;
              bowlUpper.metadata = stepMeta;
              const wineLiquid = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_2_liquid`, {
                diameterBottom: 4.8,
                diameterTop: 8,
                height: 5.6,
                tessellation: 24
              }, this.scene);
              wineLiquid.position.set(stepX, surfaceY + 14.2, stepZ);
              wineLiquid.material = mats.wineLiquid || mats.bar;
              wineLiquid.parent = this.clashObstaclesRoot;
              wineLiquid.metadata = stepMeta;
            } else if (s === 3) {
              const coaster = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_3_coaster`, {
                diameter: 9.6,
                height: 0.48,
                tessellation: 24
              }, this.scene);
              coaster.position.set(stepX, surfaceY + 0.24, stepZ);
              coaster.material = mats.barCoaster || mats.bar;
              coaster.parent = this.clashObstaclesRoot;
              coaster.metadata = stepMeta;
              const shotBase = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_3`, {
                diameter: 6.8,
                height: 3.2,
                tessellation: 24
              }, this.scene);
              shotBase.position.set(stepX, surfaceY + 0.48 + 1.6, stepZ);
              shotBase.material = mats.glass || mats.bar;
              shotBase.parent = this.clashObstaclesRoot;
              shotBase.metadata = stepMeta;
              const shotGlass = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_3_glass`, {
                diameterBottom: 6.8,
                diameterTop: 9.2,
                height: 8.4,
                tessellation: 24
              }, this.scene);
              shotGlass.position.set(stepX, surfaceY + 3.68 + 4.2, stepZ);
              shotGlass.material = mats.glass || mats.bar;
              shotGlass.parent = this.clashObstaclesRoot;
              shotGlass.metadata = stepMeta;
              const shotSpirit = BABYLON.MeshBuilder.CreateCylinder(`barStep_${hole}_3_spirit`, {
                diameterBottom: 5.2,
                diameterTop: 7.4,
                height: 6.4,
                tessellation: 24
              }, this.scene);
              shotSpirit.position.set(stepX, surfaceY + 3.68 + 3.2, stepZ);
              shotSpirit.material = mats.shotSpirit || mats.bar;
              shotSpirit.parent = this.clashObstaclesRoot;
              shotSpirit.metadata = stepMeta;
            }
          }
        }
      });
    }
    /**
     * Renders 3D Timeout penalty boxes with a 3D Dunce Stool, Dunce Cap, and Blackboard
     * standing beside the track instead of the 3 dots.
     * @private
     */
    _render3DTimeouts(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.timeouts) && this.options.obstacleConfigs.timeouts.length > 0;
      const active2 = hasConfigs || Boolean(settings3?.optTimeout || isClash && settings3?.optTimeout !== false);
      if (!active2) return;
      const timeouts = hasConfigs ? this.options.obstacleConfigs.timeouts : ObstacleGeometry.getTimeoutConfigs(Object.assign({}, settings3, { optTimeout: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(timeouts) || !timeouts.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      timeouts.forEach((item) => {
        const hole = item.hole;
        if (hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, hole);
          if (!pt) return;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const disc = BABYLON.MeshBuilder.CreateCylinder(`timeoutTrigger_${who}_${hole}`, {
            diameter: radius * 2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          disc.position.set(pt.x, surfaceY + padHeight / 2 + 0.08, pt.z);
          disc.material = mats.timeout;
          disc.parent = this.clashObstaclesRoot;
          disc.metadata = { obstacle: "timeout-cell", hole, who };
          const outerRing = BABYLON.MeshBuilder.CreateCylinder(`timeoutTriggerRing_${who}_${hole}`, {
            diameter: radius * 2.22,
            height: padHeight * 0.75,
            tessellation: 24
          }, this.scene);
          outerRing.position.set(pt.x, surfaceY + padHeight * 0.75 / 2 + 0.06, pt.z);
          outerRing.material = mats.dunceWood || mats.timeout;
          outerRing.parent = this.clashObstaclesRoot;
          outerRing.metadata = { obstacle: "timeout-cell", hole, who };
        });
        const p0 = this.getHoleCoords(refTrack, hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, hole + 1));
        if (p0 && p1) {
          const dx2 = p1.x - p0.x;
          const dz = p1.z - p0.z;
          const len = Math.hypot(dx2, dz) || 1;
          const nx = -dz / len;
          const nz = dx2 / len;
          const surfaceY = p0 && p0.y !== void 0 ? p0.y : 0.8;
          const cornerDist = radius * 1.8 + spacing * 2.1;
          const cornerX = p0.x + nx * cornerDist;
          const cornerZ = p0.z + nz * cornerDist;
          const timeoutNode = new BABYLON.TransformNode(`timeoutNode_${hole}`, this.scene);
          timeoutNode.position.set(cornerX, surfaceY, cornerZ);
          timeoutNode.rotation.y = Math.atan2(-nx, -nz);
          timeoutNode.parent = this.clashObstaclesRoot;
          const timeoutMeta = { obstacle: "timeout-box", hole, who: refTrack };
          const matWood = mats.dunceWood || mats.timeout;
          const platform = BABYLON.MeshBuilder.CreateBox(`timeoutPlatform_${hole}`, {
            width: 14,
            depth: 14,
            height: 0.5
          }, this.scene);
          platform.position.set(0, 0.25, 0);
          platform.material = mats.timeoutPlatform || mats.dunceWood || mats.timeout;
          platform.parent = timeoutNode;
          platform.metadata = timeoutMeta;
          const trim = BABYLON.MeshBuilder.CreateBox(`timeoutTrim_${hole}`, {
            width: 14.4,
            depth: 14.4,
            height: 0.2
          }, this.scene);
          trim.position.set(0, 0.1, 0);
          trim.material = matWood;
          trim.parent = timeoutNode;
          trim.metadata = timeoutMeta;
          const stoolSeat = BABYLON.MeshBuilder.CreateCylinder(`timeoutStoolSeat_${hole}`, {
            diameter: 4.8,
            height: 0.8,
            tessellation: 24
          }, this.scene);
          stoolSeat.position.set(0, 7, 0);
          stoolSeat.material = matWood;
          stoolSeat.parent = timeoutNode;
          stoolSeat.metadata = timeoutMeta;
          const cushion = BABYLON.MeshBuilder.CreateCylinder(`timeoutStoolCushion_${hole}`, {
            diameter: 4.2,
            height: 0.35,
            tessellation: 24
          }, this.scene);
          cushion.position.set(0, 7.45, 0);
          cushion.material = mats.timeout;
          cushion.parent = timeoutNode;
          cushion.metadata = timeoutMeta;
          for (let i = 0; i < 3; i++) {
            const ang = i * 2 * Math.PI / 3 + Math.PI / 6;
            const topX = 1.4 * Math.cos(ang);
            const topZ = 1.4 * Math.sin(ang);
            const botX = 2.4 * Math.cos(ang);
            const botZ = 2.4 * Math.sin(ang);
            const legPath = [
              new BABYLON.Vector3(botX, 0.5, botZ),
              new BABYLON.Vector3((topX + botX) / 2, 3.8, (topZ + botZ) / 2),
              new BABYLON.Vector3(topX, 6.7, topZ)
            ];
            try {
              const leg = BABYLON.MeshBuilder.CreateTube(`timeoutStoolLeg_${hole}_${i}`, {
                path: legPath,
                radius: 0.32,
                tessellation: 12
              }, this.scene);
              leg.material = matWood;
              leg.parent = timeoutNode;
              leg.metadata = timeoutMeta;
            } catch (_) {
            }
          }
          for (let i = 0; i < 3; i++) {
            const nextI = (i + 1) % 3;
            const a1 = i * 2 * Math.PI / 3 + Math.PI / 6;
            const a2 = nextI * 2 * Math.PI / 3 + Math.PI / 6;
            const midR = 1.9;
            const pA = new BABYLON.Vector3(midR * Math.cos(a1), 3.6, midR * Math.sin(a1));
            const pB = new BABYLON.Vector3(midR * Math.cos(a2), 3.6, midR * Math.sin(a2));
            try {
              const rung = BABYLON.MeshBuilder.CreateTube(`timeoutStoolRung_${hole}_${i}`, {
                path: [pA, pB],
                radius: 0.2,
                tessellation: 10
              }, this.scene);
              rung.material = matWood;
              rung.parent = timeoutNode;
              rung.metadata = timeoutMeta;
            } catch (_) {
            }
          }
          const dunceCone = BABYLON.MeshBuilder.CreateCylinder(`timeoutDunceCone_${hole}`, {
            diameterTop: 0.1,
            diameterBottom: 3.8,
            height: 6.8,
            tessellation: 24
          }, this.scene);
          dunceCone.position.set(0, 7.55 + 3.4, 0);
          dunceCone.material = mats.dunceCap || mats.accentWhite;
          dunceCone.parent = timeoutNode;
          dunceCone.metadata = timeoutMeta;
          const dunceBand = BABYLON.MeshBuilder.CreateCylinder(`timeoutDunceBand_${hole}`, {
            diameter: 3.88,
            height: 0.6,
            tessellation: 24
          }, this.scene);
          dunceBand.position.set(0, 7.55 + 0.35, 0);
          dunceBand.material = mats.dunceRed || mats.timeout;
          dunceBand.parent = timeoutNode;
          dunceBand.metadata = timeoutMeta;
          const dunceD = BABYLON.MeshBuilder.CreateCylinder(`timeoutDunceEmblem_${hole}`, {
            diameter: 1.2,
            height: 0.35,
            tessellation: 16
          }, this.scene);
          dunceD.rotation.x = Math.PI / 7;
          dunceD.position.set(0, 10.2, 1.45);
          dunceD.material = mats.dunceRed || mats.timeout;
          dunceD.parent = timeoutNode;
          dunceD.metadata = timeoutMeta;
          let boardMat = matWood;
          try {
            const chalkTex = new BABYLON.DynamicTexture(`chalkboardTex_${hole}`, { width: 512, height: 256 }, this.scene);
            const ctx = chalkTex.getContext();
            if (ctx) {
              ctx.fillStyle = "#1e2d24";
              ctx.fillRect(0, 0, 512, 256);
              ctx.strokeStyle = "#37474f";
              ctx.lineWidth = 6;
              ctx.strokeRect(10, 10, 492, 236);
              ctx.fillStyle = "#ffb74d";
              ctx.font = "bold 36px monospace";
              ctx.textAlign = "center";
              ctx.fillText("\u23F3 TIMEOUT CORNER \u23F3", 256, 52);
              ctx.fillStyle = "#ffffff";
              ctx.font = "bold 28px sans-serif";
              ctx.fillText("I WILL NOT OVER-PEG", 256, 108);
              ctx.fillStyle = "#ff9800";
              ctx.font = "bold 52px monospace";
              ctx.fillText("| | |", 256, 178);
              ctx.fillStyle = "#cfd8dc";
              ctx.font = "22px sans-serif";
              ctx.fillText("3 TURNS IN THE CORNER", 256, 224);
              chalkTex.update();
              const chalkMat = new BABYLON.PBRMaterial(`matChalk_${hole}`, this.scene);
              chalkMat.albedoTexture = chalkTex;
              chalkMat.roughness = 0.8;
              boardMat = chalkMat;
            }
          } catch (_) {
          }
          const boardFrame = BABYLON.MeshBuilder.CreateBox(`timeoutBoardFrame_${hole}`, {
            width: 11.2,
            height: 7.2,
            depth: 0.5
          }, this.scene);
          boardFrame.position.set(0, 9.6, -5.2);
          boardFrame.material = matWood;
          boardFrame.parent = timeoutNode;
          boardFrame.metadata = timeoutMeta;
          const boardPlate = BABYLON.MeshBuilder.CreateBox(`timeoutBoardPlate_${hole}`, {
            width: 10.2,
            height: 6.2,
            depth: 0.55
          }, this.scene);
          boardPlate.position.set(0, 9.6, -5.2);
          boardPlate.material = boardMat;
          boardPlate.parent = timeoutNode;
          boardPlate.metadata = timeoutMeta;
          [-4.4, 4.4].forEach((ex, eIdx) => {
            const leg = BABYLON.MeshBuilder.CreateCylinder(`timeoutEaselLeg_${hole}_${eIdx}`, {
              diameter: 0.65,
              height: 13.5,
              tessellation: 14
            }, this.scene);
            leg.position.set(ex, 0.5 + 13.5 / 2, -5.4);
            leg.material = matWood;
            leg.parent = timeoutNode;
            leg.metadata = timeoutMeta;
          });
          const chalkTray = BABYLON.MeshBuilder.CreateBox(`timeoutChalkTray_${hole}`, {
            width: 9.6,
            depth: 0.8,
            height: 0.3
          }, this.scene);
          chalkTray.position.set(0, 6, -4.8);
          chalkTray.material = matWood;
          chalkTray.parent = timeoutNode;
          chalkTray.metadata = timeoutMeta;
          const stepPositions = [
            { s: 1, x: -4.2, z: 3.4 },
            { s: 2, x: 0, z: 4.6 },
            { s: 3, x: 4.2, z: 3.4 }
          ];
          stepPositions.forEach((st) => {
            const stepBlock = BABYLON.MeshBuilder.CreateCylinder(`timeoutStep_${hole}_${st.s}`, {
              diameter: 2.6,
              height: 0.6,
              tessellation: 20
            }, this.scene);
            stepBlock.position.set(st.x, 0.5 + 0.3, st.z);
            stepBlock.material = matWood;
            stepBlock.parent = timeoutNode;
            stepBlock.metadata = { obstacle: "timeout-step", hole, step: st.s };
            const stepPad = BABYLON.MeshBuilder.CreateCylinder(`timeoutStep_${hole}_${st.s}_pad`, {
              diameter: 2.1,
              height: 0.66,
              tessellation: 20
            }, this.scene);
            stepPad.position.set(st.x, 0.5 + 0.33, st.z);
            stepPad.material = mats.timeout;
            stepPad.parent = timeoutNode;
            stepPad.metadata = { obstacle: "timeout-step", hole, step: st.s };
          });
        }
      });
    }
    /**
     * Renders 3D Detour bypass as an authentic 3D paved road complete with asphalt road bed,
     * concrete curb shoulders, dashed yellow centerline, orange construction barricades,
     * roadside "DETOUR ➔" diamond signs, and embedded road navigation step markers.
     * @private
     */
    _render3DDetours(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.detours) && this.options.obstacleConfigs.detours.length > 0;
      const active2 = hasConfigs || Boolean(settings3?.optDetour || isClash && settings3?.optDetour !== false);
      if (!active2) return;
      const detours = hasConfigs ? this.options.obstacleConfigs.detours : ObstacleGeometry.getDetourConfigs(Object.assign({}, settings3, { optDetour: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(detours) || !detours.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      const bounds = (typeof this.getBoardBounds === "function" ? this.getBoardBounds() : null) || this.boardBounds;
      const isClashTarget2 = this.isClashMode() || this.boardConfig?.brand === "clash" || this.boardConfig?.id === "board-cribbage-clash" || this.boardConfig?.id === "board-cribbage-clash-square";
      detours.forEach((d) => {
        if (d.hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, d.hole);
          if (!pt) return;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const pad = BABYLON.MeshBuilder.CreateCylinder(`detourTrigger_${who}_${d.hole}`, {
            diameter: radius * 2.2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          pad.position.set(pt.x, surfaceY + padHeight / 2 + 0.08, pt.z);
          pad.material = mats.asphaltRoad || mats.detour;
          pad.parent = this.clashObstaclesRoot;
          pad.metadata = { obstacle: "detour-box", hole: d.hole, who };
          const ring = BABYLON.MeshBuilder.CreateTorus(`detourTriggerRing_${who}_${d.hole}`, {
            diameter: radius * 1.8,
            thickness: 0.26,
            tessellation: 24
          }, this.scene);
          ring.position.set(pt.x, surfaceY + padHeight + 0.08, pt.z);
          ring.rotation.x = Math.PI / 2;
          ring.material = mats.chevronYellow || mats.detour;
          ring.parent = this.clashObstaclesRoot;
          ring.metadata = { obstacle: "detour-box", hole: d.hole, who };
        });
        const pStart = this.getHoleCoords(refTrack, d.hole);
        const pRejoin = this.getHoleCoords(refTrack, Math.min(this.targetHoles, d.hole + 1));
        if (pStart && pRejoin) {
          const dx2 = pRejoin.x - pStart.x;
          const dz = pRejoin.z - pStart.z;
          const trackLen = Math.hypot(dx2, dz) || 2.5;
          const Tx = dx2 / trackLen;
          const Tz = dz / trackLen;
          let nx = -Tz;
          let nz = Tx;
          const surfaceY = pStart && pStart.y !== void 0 ? pStart.y : 0.8;
          const pMidX = (pStart.x + pRejoin.x) / 2;
          const pMidZ = (pStart.z + pRejoin.z) / 2;
          if (bounds && bounds.min && bounds.max) {
            const bCenterX = (bounds.min.x + bounds.max.x) / 2;
            const bCenterZ = (bounds.min.z + bounds.max.z) / 2;
            const dPos = Math.hypot(pMidX + nx * 10 - bCenterX, pMidZ + nz * 10 - bCenterZ);
            const dNeg = Math.hypot(pMidX - nx * 10 - bCenterX, pMidZ - nz * 10 - bCenterZ);
            if (dPos < dNeg) {
              nx = -nx;
              nz = -nz;
            }
          }
          const detourMeta = { obstacle: "detour-box", hole: d.hole, who: refTrack };
          const Rdist = Math.max(7, spacing * 2.25);
          const Rn = Math.max(6, spacing * 1.9);
          const Rt = Math.max(5.25, spacing * 1.7);
          const betaMax = 2.38;
          const roadWidth = Math.max(3, radius * 1.8);
          const numSegments = 60;
          const centerPoints = [];
          const tangents = [];
          const leftEdgePoints = [];
          const rightEdgePoints = [];
          for (let i = 0; i <= numSegments; i++) {
            const t = i / numSegments;
            const beta = (t - 0.5) * 2 * betaMax;
            const alongT = Math.sin(beta);
            const alongN = Math.cos(beta);
            const blend = Math.pow(Math.sin(t * Math.PI), 0.7);
            const neckT = (t - 0.5) * trackLen;
            const posT = neckT * (1 - blend) + alongT * Rt * blend;
            const cos0 = Math.cos(betaMax);
            const normN = (alongN - cos0) / (1 - cos0);
            const posN = normN * (Rdist + Rn - 1);
            const midX = pStart.x + Tx * (trackLen / 2 + posT) + nx * posN;
            const midZ = pStart.z + Tz * (trackLen / 2 + posT) + nz * posN;
            const midY = surfaceY + 0.16;
            centerPoints.push(new BABYLON.Vector3(midX, midY, midZ));
          }
          for (let i = 0; i <= numSegments; i++) {
            let tanX, tanZ;
            if (i === 0) {
              tanX = centerPoints[1].x - centerPoints[0].x;
              tanZ = centerPoints[1].z - centerPoints[0].z;
            } else if (i === numSegments) {
              tanX = centerPoints[numSegments].x - centerPoints[numSegments - 1].x;
              tanZ = centerPoints[numSegments].z - centerPoints[numSegments - 1].z;
            } else {
              tanX = centerPoints[i + 1].x - centerPoints[i - 1].x;
              tanZ = centerPoints[i + 1].z - centerPoints[i - 1].z;
            }
            const tLen = Math.hypot(tanX, tanZ) || 1;
            tanX /= tLen;
            tanZ /= tLen;
            tangents.push({ x: tanX, z: tanZ, heading: Math.atan2(tanX, tanZ) });
            const normX = -tanZ;
            const normZ = tanX;
            leftEdgePoints.push(new BABYLON.Vector3(
              centerPoints[i].x + normX * (roadWidth / 2),
              centerPoints[i].y,
              centerPoints[i].z + normZ * (roadWidth / 2)
            ));
            rightEdgePoints.push(new BABYLON.Vector3(
              centerPoints[i].x - normX * (roadWidth / 2),
              centerPoints[i].y,
              centerPoints[i].z - normZ * (roadWidth / 2)
            ));
          }
          const arcLens = [0];
          let totalCurveLen = 0;
          for (let i = 1; i <= numSegments; i++) {
            totalCurveLen += BABYLON.Vector3.Distance(centerPoints[i], centerPoints[i - 1]);
            arcLens.push(totalCurveLen);
          }
          try {
            const roadBed = BABYLON.MeshBuilder.CreateRibbon(`detourRoadBed_${d.hole}`, {
              pathArray: [leftEdgePoints, rightEdgePoints],
              sideOrientation: BABYLON.Mesh.DOUBLESIDE
            }, this.scene);
            roadBed.material = mats.asphaltRoad || mats.detour;
            roadBed.parent = this.clashObstaclesRoot;
            roadBed.metadata = detourMeta;
          } catch (_) {
          }
          try {
            const curbLeft = BABYLON.MeshBuilder.CreateTube(`detourCurbLeft_${d.hole}`, {
              path: leftEdgePoints.map((p) => new BABYLON.Vector3(p.x, p.y + 0.1, p.z)),
              radius: 0.18,
              tessellation: 12
            }, this.scene);
            curbLeft.material = mats.concreteCurb || mats.accentWhite;
            curbLeft.parent = this.clashObstaclesRoot;
            curbLeft.metadata = detourMeta;
            const curbRight = BABYLON.MeshBuilder.CreateTube(`detourCurbRight_${d.hole}`, {
              path: rightEdgePoints.map((p) => new BABYLON.Vector3(p.x, p.y + 0.1, p.z)),
              radius: 0.18,
              tessellation: 12
            }, this.scene);
            curbRight.material = mats.concreteCurb || mats.accentWhite;
            curbRight.parent = this.clashObstaclesRoot;
            curbRight.metadata = detourMeta;
          } catch (_) {
          }
          const islandCenterX = pStart.x + Tx * (trackLen / 2) + nx * (Rdist * 0.96);
          const islandCenterZ = pStart.z + Tz * (trackLen / 2) + nz * (Rdist * 0.96);
          const islandCenterY = surfaceY + 0.18;
          const islandRadius = Rt * 0.62;
          try {
            const lawnMesh = new BABYLON.Mesh(`detourLawn_${d.hole}`, this.scene);
            const boundary = [...rightEdgePoints];
            const numBaseSegments = 8;
            const pEndBoundary = rightEdgePoints[numSegments];
            const pStartBoundary = rightEdgePoints[0];
            for (let b = 1; b < numBaseSegments; b++) {
              const frac = b / numBaseSegments;
              boundary.push(new BABYLON.Vector3(
                pEndBoundary.x + (pStartBoundary.x - pEndBoundary.x) * frac,
                surfaceY + 0.16,
                pEndBoundary.z + (pStartBoundary.z - pEndBoundary.z) * frac
              ));
            }
            const positions = [islandCenterX, islandCenterY, islandCenterZ];
            const uvs = [0.5, 0.5];
            const normals = [0, 1, 0];
            let minX = islandCenterX, maxX = islandCenterX, minZ = islandCenterZ, maxZ = islandCenterZ;
            for (const p of boundary) {
              minX = Math.min(minX, p.x);
              maxX = Math.max(maxX, p.x);
              minZ = Math.min(minZ, p.z);
              maxZ = Math.max(maxZ, p.z);
            }
            const rangeX = maxX - minX || 1;
            const rangeZ = maxZ - minZ || 1;
            for (const p of boundary) {
              positions.push(p.x, surfaceY + 0.16, p.z);
              uvs.push((p.x - minX) / rangeX, (p.z - minZ) / rangeZ);
              normals.push(0, 1, 0);
            }
            const indices = [];
            const N = boundary.length;
            for (let i = 0; i < N; i++) {
              const next = (i + 1) % N;
              indices.push(0, next + 1, i + 1);
            }
            const vertexData = new BABYLON.VertexData();
            vertexData.positions = positions;
            vertexData.indices = indices;
            vertexData.normals = normals;
            vertexData.uvs = uvs;
            vertexData.applyToMesh(lawnMesh);
            lawnMesh.material = mats.grassLawn || mats.p1;
            lawnMesh.parent = this.clashObstaclesRoot;
            lawnMesh.metadata = detourMeta;
            const island = BABYLON.MeshBuilder.CreateCylinder(`detourIsland_${d.hole}`, {
              diameter: islandRadius * 2,
              height: 0.18,
              tessellation: 32
            }, this.scene);
            island.position.set(islandCenterX, surfaceY + 0.19, islandCenterZ);
            island.material = mats.grassLawn || mats.p1;
            island.parent = this.clashObstaclesRoot;
            island.metadata = detourMeta;
            const islandCurb = BABYLON.MeshBuilder.CreateTorus(`detourIslandCurb_${d.hole}`, {
              diameter: islandRadius * 2,
              thickness: 0.16,
              tessellation: 32
            }, this.scene);
            islandCurb.position.set(islandCenterX, surfaceY + 0.22, islandCenterZ);
            islandCurb.rotation.x = Math.PI / 2;
            islandCurb.material = mats.concreteCurb || mats.accentWhite;
            islandCurb.parent = this.clashObstaclesRoot;
            islandCurb.metadata = detourMeta;
            const scenicPost = BABYLON.MeshBuilder.CreateCylinder(`detourScenicPost_${d.hole}`, {
              diameter: 0.24,
              height: 2.4,
              tessellation: 12
            }, this.scene);
            scenicPost.position.set(islandCenterX, surfaceY + 1.2, islandCenterZ);
            scenicPost.material = mats.dunceWood || mats.asphaltRoad;
            scenicPost.parent = this.clashObstaclesRoot;
            scenicPost.metadata = detourMeta;
            const scenicBoard = BABYLON.MeshBuilder.CreateBox(`detourScenicBoard_${d.hole}`, {
              width: 2.2,
              height: 1,
              depth: 0.18
            }, this.scene);
            scenicBoard.position.set(islandCenterX, surfaceY + 2, islandCenterZ);
            scenicBoard.rotation.y = Math.atan2(nx, nz);
            scenicBoard.material = mats.dunceWood || mats.detourOrange;
            scenicBoard.parent = this.clashObstaclesRoot;
            scenicBoard.metadata = detourMeta;
          } catch (_) {
          }
          const dashInterval = 2;
          for (let targetArc = 1.6; targetArc < totalCurveLen - 1.6; targetArc += dashInterval) {
            let idx = 0;
            while (idx < numSegments && arcLens[idx + 1] < targetArc) idx++;
            const frac = (targetArc - arcLens[idx]) / (arcLens[idx + 1] - arcLens[idx]);
            const dX = centerPoints[idx].x + frac * (centerPoints[idx + 1].x - centerPoints[idx].x);
            const dZ = centerPoints[idx].z + frac * (centerPoints[idx + 1].z - centerPoints[idx].z);
            const dHeading = tangents[idx].heading;
            const dash = BABYLON.MeshBuilder.CreateBox(`detourDash_${d.hole}_${Math.round(targetArc * 10)}`, {
              width: 0.24,
              depth: 0.9,
              height: 0.05
            }, this.scene);
            dash.position.set(dX, surfaceY + 0.19, dZ);
            dash.rotation.y = dHeading;
            dash.material = mats.chevronYellow || mats.detour;
            dash.parent = this.clashObstaclesRoot;
            dash.metadata = detourMeta;
          }
          const signX = pStart.x + Tx * -1 + nx * 1.6;
          const signZ = pStart.z + Tz * -1 + nz * 1.6;
          const signPost = BABYLON.MeshBuilder.CreateCylinder(`detourSignPost_${d.hole}`, {
            diameter: 0.24,
            height: 5.4,
            tessellation: 12
          }, this.scene);
          signPost.position.set(signX, surfaceY + 2.7, signZ);
          signPost.material = mats.stopSignPole || mats.accentWhite;
          signPost.parent = this.clashObstaclesRoot;
          signPost.metadata = detourMeta;
          const signDiamond = BABYLON.MeshBuilder.CreateBox(`detourSignDiamond_${d.hole}`, {
            width: 2.2,
            height: 2.2,
            depth: 0.18
          }, this.scene);
          signDiamond.position.set(signX, surfaceY + 4.8, signZ);
          signDiamond.rotation.z = Math.PI / 4;
          signDiamond.rotation.y = Math.atan2(Tx, Tz) + Math.PI / 2;
          signDiamond.material = mats.detourOrange || mats.detour;
          signDiamond.parent = this.clashObstaclesRoot;
          signDiamond.metadata = detourMeta;
          const signArrow = BABYLON.MeshBuilder.CreateBox(`detourSignArrow_${d.hole}`, {
            width: 1.2,
            height: 0.32,
            depth: 0.22
          }, this.scene);
          signArrow.position.set(signX, surfaceY + 4.8, signZ);
          signArrow.rotation.y = Math.atan2(Tx, Tz) + Math.PI / 2;
          signArrow.material = mats.asphaltRoad || mats.carWheels;
          signArrow.parent = this.clashObstaclesRoot;
          signArrow.metadata = detourMeta;
          const barX = pMidX;
          const barZ = pMidZ;
          const barHeading = Math.atan2(Tx, Tz);
          const barricadeBoard = BABYLON.MeshBuilder.CreateBox(`detourBarricade_${d.hole}`, {
            width: Math.max(3.2, trackLen * 1.1),
            height: 0.7,
            depth: 0.18
          }, this.scene);
          barricadeBoard.position.set(barX, surfaceY + 1.6, barZ);
          barricadeBoard.rotation.y = barHeading;
          barricadeBoard.material = mats.detourBarricade || mats.detourOrange || mats.detour;
          barricadeBoard.parent = this.clashObstaclesRoot;
          barricadeBoard.metadata = detourMeta;
          [-1.3, 1.3].forEach((legOff, lIdx) => {
            const leg = BABYLON.MeshBuilder.CreateCylinder(`detourBarricadeLeg_${d.hole}_${lIdx}`, {
              diameter: 0.22,
              height: 2.4,
              tessellation: 10
            }, this.scene);
            leg.position.set(barX + Math.cos(barHeading) * legOff, surfaceY + 1.2, barZ - Math.sin(barHeading) * legOff);
            leg.material = mats.accentWhite;
            leg.parent = this.clashObstaclesRoot;
            leg.metadata = detourMeta;
          });
          const beacon = BABYLON.MeshBuilder.CreateCylinder(`detourBeacon_${d.hole}`, {
            diameter: 0.6,
            height: 0.5,
            tessellation: 14
          }, this.scene);
          beacon.position.set(barX, surfaceY + 2.2, barZ);
          beacon.material = mats.chevronYellow || mats.detour;
          beacon.parent = this.clashObstaclesRoot;
          beacon.metadata = detourMeta;
          [-0.5, 0.8].forEach((cOff, cIdx) => {
            const cX = pStart.x + Tx * (cOff - 0.8) + nx * (2 + cIdx * 1.4);
            const cZ = pStart.z + Tz * (cOff - 0.8) + nz * (2 + cIdx * 1.4);
            const coneBase = BABYLON.MeshBuilder.CreateBox(`detourConeBase_${d.hole}_${cIdx}`, {
              width: 0.75,
              depth: 0.75,
              height: 0.1
            }, this.scene);
            coneBase.position.set(cX, surfaceY + 0.1, cZ);
            coneBase.material = mats.detourOrange || mats.detour;
            coneBase.parent = this.clashObstaclesRoot;
            coneBase.metadata = detourMeta;
            const coneBody = BABYLON.MeshBuilder.CreateCylinder(`detourCone_${d.hole}_${cIdx}`, {
              diameterTop: 0.14,
              diameterBottom: 0.6,
              height: 1,
              tessellation: 16
            }, this.scene);
            coneBody.position.set(cX, surfaceY + 0.58, cZ);
            coneBody.material = mats.detourOrange || mats.detour;
            coneBody.parent = this.clashObstaclesRoot;
            coneBody.metadata = detourMeta;
            const coneCollar = BABYLON.MeshBuilder.CreateCylinder(`detourConeCollar_${d.hole}_${cIdx}`, {
              diameterTop: 0.28,
              diameterBottom: 0.4,
              height: 0.22,
              tessellation: 16
            }, this.scene);
            coneCollar.position.set(cX, surfaceY + 0.62, cZ);
            coneCollar.material = mats.accentWhite;
            coneCollar.parent = this.clashObstaclesRoot;
            coneCollar.metadata = detourMeta;
          });
          for (let s = 1; s <= 7; s++) {
            const targetArc = s / 8 * totalCurveLen;
            let idx = 0;
            while (idx < numSegments && arcLens[idx + 1] < targetArc) idx++;
            const frac = (targetArc - arcLens[idx]) / (arcLens[idx + 1] - arcLens[idx]);
            const stepX = centerPoints[idx].x + frac * (centerPoints[idx + 1].x - centerPoints[idx].x);
            const stepZ = centerPoints[idx].z + frac * (centerPoints[idx + 1].z - centerPoints[idx].z);
            const stepHeading = tangents[idx].heading;
            const stepMeta = { obstacle: "detour-step", hole: d.hole, step: s };
            const stepPad = BABYLON.MeshBuilder.CreateCylinder(`detourStep_${d.hole}_${s}`, {
              diameter: Math.max(1.8, radius * 1.6),
              height: padHeight * 0.8,
              tessellation: 20
            }, this.scene);
            stepPad.position.set(stepX, surfaceY + 0.18, stepZ);
            stepPad.material = mats.detour;
            stepPad.parent = this.clashObstaclesRoot;
            stepPad.metadata = stepMeta;
            const stepRing = BABYLON.MeshBuilder.CreateTorus(`detourStep_${d.hole}_${s}_ring`, {
              diameter: Math.max(1.9, radius * 1.8),
              thickness: 0.14,
              tessellation: 20
            }, this.scene);
            stepRing.position.set(stepX, surfaceY + 0.21, stepZ);
            stepRing.rotation.x = Math.PI / 2;
            stepRing.material = mats.chevronYellow || mats.detour;
            stepRing.parent = this.clashObstaclesRoot;
            stepRing.metadata = stepMeta;
            const arrowHead = BABYLON.MeshBuilder.CreateCylinder(`detourStep_${d.hole}_${s}_arrow`, {
              diameter: 0.8,
              height: 0.05,
              tessellation: 3
            }, this.scene);
            arrowHead.position.set(stepX, surfaceY + 0.22, stepZ);
            arrowHead.rotation.x = Math.PI / 2;
            arrowHead.rotation.y = stepHeading + Math.PI / 6;
            arrowHead.material = mats.roadLineWhite || mats.accentWhite;
            arrowHead.parent = this.clashObstaclesRoot;
            arrowHead.metadata = stepMeta;
          }
        }
      });
    }
    /**
     * Renders 3D Round About rotary rings and 8-hole circle loops.
     * @private
     */
    /**
     * Renders 3D Round About as an authentic road traffic roundabout with circular asphalt roadway,
     * outer concrete curb, dashed lane markings, raised green central island with chevron signs and
     * stone fountain/monument, roadside traffic signs, and 8 navigating miniature sports cars.
     * @private
     */
    _render3DRoundAbouts(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.roundabouts) && this.options.obstacleConfigs.roundabouts.length > 0;
      const active2 = hasConfigs || Boolean(settings3?.optRoundAbout || isClash && settings3?.optRoundAbout !== false);
      if (!active2) return;
      const roundabouts = hasConfigs ? this.options.obstacleConfigs.roundabouts : ObstacleGeometry.getRoundAboutConfigs(Object.assign({}, settings3, { optRoundAbout: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(roundabouts) || !roundabouts.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      const carPaints = [
        "#e53935",
        // red racer
        "#1e88e5",
        // electric blue
        "#fbc02d",
        // sports yellow
        "#fb8c00",
        // orange speedster
        "#43a047",
        // emerald green
        "#8e24aa",
        // deep purple
        "#f5f5f5",
        // silver metallic
        "#00e5ff"
        // cyan turbo
      ];
      roundabouts.forEach((r) => {
        if (r.hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, r.hole);
          if (!pt) return;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const pad = BABYLON.MeshBuilder.CreateCylinder(`roundaboutTrigger_${who}_${r.hole}`, {
            diameter: radius * 2.2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          pad.position.set(pt.x, surfaceY + padHeight / 2 + 0.08, pt.z);
          pad.material = mats.asphaltRoad || mats.roundabout;
          pad.parent = this.clashObstaclesRoot;
          pad.metadata = { obstacle: "roundabout-box", hole: r.hole, who };
          const ring = BABYLON.MeshBuilder.CreateTorus(`roundaboutTriggerRing_${who}_${r.hole}`, {
            diameter: radius * 1.6,
            thickness: 0.28,
            tessellation: 24
          }, this.scene);
          ring.position.set(pt.x, surfaceY + padHeight + 0.08, pt.z);
          ring.rotation.x = Math.PI / 2;
          ring.material = mats.asphaltRoad || mats.roundabout;
          ring.parent = this.clashObstaclesRoot;
          ring.metadata = { obstacle: "roundabout-box", hole: r.hole, who };
        });
        const p0 = this.getHoleCoords(refTrack, r.hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, r.hole + 1));
        if (p0 && p1) {
          const dx2 = p1.x - p0.x;
          const dz = p1.z - p0.z;
          const len = Math.hypot(dx2, dz) || 1;
          const nx = -dz / len;
          const nz = dx2 / len;
          const surfaceY = p0 && p0.y !== void 0 ? p0.y : 0.8;
          const rotaryRadius = Math.max(13, spacing * 1.65);
          const laneWidth = 7;
          const roadOuterRadius = rotaryRadius + laneWidth / 2;
          const islandRadius = rotaryRadius - laneWidth / 2;
          const distFromTrack = roadOuterRadius + 4.5;
          const cx = p0.x + nx * distFromTrack;
          const cz = p0.z + nz * distFromTrack;
          const roundaboutNode = new BABYLON.TransformNode(`roundaboutNode_${r.hole}`, this.scene);
          roundaboutNode.position.set(cx, surfaceY, cz);
          roundaboutNode.parent = this.clashObstaclesRoot;
          const roundaboutMeta = { obstacle: "roundabout-box", hole: r.hole, who: refTrack };
          const islandMeta = { obstacle: "roundabout-island", hole: r.hole, who: refTrack };
          const outerCurb = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_outerCurb`, {
            diameter: (roadOuterRadius + 0.6) * 2,
            height: 0.44,
            tessellation: 48
          }, this.scene);
          outerCurb.position.set(0, 0.22, 0);
          outerCurb.material = mats.asphaltRoad || mats.roundabout;
          outerCurb.parent = roundaboutNode;
          outerCurb.metadata = roundaboutMeta;
          const roadBed = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_roadBed`, {
            diameter: roadOuterRadius * 2,
            height: 0.45,
            tessellation: 48
          }, this.scene);
          roadBed.position.set(0, 0.225, 0);
          roadBed.material = mats.asphaltRoad || mats.roundabout;
          roadBed.parent = roundaboutNode;
          roadBed.metadata = roundaboutMeta;
          const outerStripe = BABYLON.MeshBuilder.CreateTorus(`roundabout_${r.hole}_outerStripe`, {
            diameter: (roadOuterRadius - 0.2) * 2,
            thickness: 0.22,
            tessellation: 44
          }, this.scene);
          outerStripe.position.set(0, 0.46, 0);
          outerStripe.rotation.x = Math.PI / 2;
          outerStripe.material = mats.asphaltRoad || mats.roundabout;
          outerStripe.parent = roundaboutNode;
          outerStripe.metadata = roundaboutMeta;
          const dashCount = 16;
          for (let d = 0; d < dashCount; d++) {
            const dashAngle = d / dashCount * 2 * Math.PI;
            const dX = rotaryRadius * Math.cos(dashAngle);
            const dZ = rotaryRadius * Math.sin(dashAngle);
            const dash = BABYLON.MeshBuilder.CreateBox(`roundabout_${r.hole}_dash_${d}`, {
              width: 0.34,
              depth: 1.8,
              height: 0.05
            }, this.scene);
            dash.position.set(dX, 0.465, dZ);
            dash.rotation.y = -dashAngle + Math.PI / 2;
            dash.material = mats.chevronYellow || mats.asphaltRoad;
            dash.parent = roundaboutNode;
            dash.metadata = roundaboutMeta;
          }
          const islandCurb = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_islandCurb`, {
            diameter: islandRadius * 2,
            height: 0.65,
            tessellation: 40
          }, this.scene);
          islandCurb.position.set(0, 0.325, 0);
          islandCurb.material = mats.asphaltRoad || mats.roundabout;
          islandCurb.parent = roundaboutNode;
          islandCurb.metadata = islandMeta;
          const lawn = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_lawn`, {
            diameter: (islandRadius - 0.4) * 2,
            height: 0.8,
            tessellation: 40
          }, this.scene);
          lawn.position.set(0, 0.4, 0);
          lawn.material = mats.grassLawn || mats.roundabout;
          lawn.parent = roundaboutNode;
          lawn.metadata = islandMeta;
          const plinth = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_plinth`, {
            diameter: 5.2,
            height: 1.2,
            tessellation: 24
          }, this.scene);
          plinth.position.set(0, 0.8 + 0.6, 0);
          plinth.material = mats.asphaltRoad || mats.roundabout;
          plinth.parent = roundaboutNode;
          plinth.metadata = islandMeta;
          const pedestal = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_pedestal`, {
            diameter: 3.2,
            height: 2.2,
            tessellation: 20
          }, this.scene);
          pedestal.position.set(0, 2 + 1.1, 0);
          pedestal.material = mats.asphaltRoad || mats.roundabout;
          pedestal.parent = roundaboutNode;
          pedestal.metadata = islandMeta;
          const finial = BABYLON.MeshBuilder.CreateSphere(`roundabout_${r.hole}_finial`, {
            diameter: 2.2,
            segments: 16
          }, this.scene);
          finial.position.set(0, 4.3 + 1.1, 0);
          finial.material = mats.roundabout;
          finial.parent = roundaboutNode;
          finial.metadata = islandMeta;
          const chevronRadius = islandRadius * 0.72;
          for (let q = 0; q < 4; q++) {
            const qAng = q * (Math.PI / 2) + Math.PI / 4;
            const qX = chevronRadius * Math.cos(qAng);
            const qZ = chevronRadius * Math.sin(qAng);
            const signBoard = BABYLON.MeshBuilder.CreateBox(`roundabout_${r.hole}_chevronSign_${q}`, {
              width: 3.4,
              height: 1.5,
              depth: 0.25
            }, this.scene);
            signBoard.position.set(qX, 2, qZ);
            signBoard.rotation.y = -qAng + Math.PI / 2;
            signBoard.material = mats.chevronYellow || mats.roundabout;
            signBoard.parent = roundaboutNode;
            signBoard.metadata = islandMeta;
            [-1.2, 1.2].forEach((postOffset, pI) => {
              const tangentNormX = -Math.sin(qAng);
              const tangentNormZ = Math.cos(qAng);
              const pX = qX + tangentNormX * postOffset;
              const pZ = qZ + tangentNormZ * postOffset;
              const post = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_chevronPost_${q}_${pI}`, {
                diameter: 0.2,
                height: 2.2,
                tessellation: 10
              }, this.scene);
              post.position.set(pX, 1.1, pZ);
              post.material = mats.asphaltRoad || mats.stopSignPole;
              post.parent = roundaboutNode;
              post.metadata = islandMeta;
            });
          }
          const entryAngle = Math.atan2(p0.z - cz, p0.x - cx);
          const signX = (roadOuterRadius + 2.5) * Math.cos(entryAngle + 0.3);
          const signZ = (roadOuterRadius + 2.5) * Math.sin(entryAngle + 0.3);
          const signPole = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_signPole`, {
            diameter: 0.35,
            height: 8.5,
            tessellation: 14
          }, this.scene);
          signPole.position.set(signX, 4.25, signZ);
          signPole.material = mats.asphaltRoad || mats.stopSignPole;
          signPole.parent = roundaboutNode;
          signPole.metadata = roundaboutMeta;
          const blueSign = BABYLON.MeshBuilder.CreateCylinder(`roundabout_${r.hole}_blueSign`, {
            diameter: 3.4,
            height: 0.25,
            tessellation: 24
          }, this.scene);
          blueSign.position.set(signX, 8.2, signZ);
          blueSign.rotation.x = Math.PI / 2;
          blueSign.rotation.y = entryAngle + Math.PI;
          blueSign.material = mats.roadSignBlue || mats.roundabout;
          blueSign.parent = roundaboutNode;
          blueSign.metadata = roundaboutMeta;
          const signSymbol = BABYLON.MeshBuilder.CreateTorus(`roundabout_${r.hole}_signSymbol`, {
            diameter: 2.1,
            thickness: 0.24,
            tessellation: 20
          }, this.scene);
          signSymbol.position.set(signX, 8.2, signZ - 0.15);
          signSymbol.rotation.x = Math.PI / 2;
          signSymbol.rotation.y = entryAngle + Math.PI;
          signSymbol.material = mats.asphaltRoad || mats.roundabout;
          signSymbol.parent = roundaboutNode;
          signSymbol.metadata = roundaboutMeta;
          for (let s = 1; s <= 8; s++) {
            const angle = s / 8 * Math.PI * 2;
            const stepX = rotaryRadius * Math.cos(angle);
            const stepZ = rotaryRadius * Math.sin(angle);
            const stepHeading = -angle + Math.PI / 2;
            const stepMeta = { obstacle: "roundabout-step", hole: r.hole, step: s };
            const stepPad = BABYLON.MeshBuilder.CreateCylinder(`roundaboutStep_${r.hole}_${s}`, {
              diameter: 2.8,
              height: 0.22,
              tessellation: 24
            }, this.scene);
            stepPad.position.set(stepX, 0.4, stepZ);
            stepPad.material = mats.roundabout;
            stepPad.parent = roundaboutNode;
            stepPad.metadata = stepMeta;
            const stepRing = BABYLON.MeshBuilder.CreateTorus(`roundaboutStep_${r.hole}_${s}_ring`, {
              diameter: 2.9,
              thickness: 0.16,
              tessellation: 20
            }, this.scene);
            stepRing.position.set(stepX, 0.44, stepZ);
            stepRing.rotation.x = Math.PI / 2;
            stepRing.material = mats.roundabout;
            stepRing.parent = roundaboutNode;
            stepRing.metadata = stepMeta;
            const carColor = carPaints[(s - 1) % carPaints.length];
            const carMat = new BABYLON.PBRMaterial(`matCar_${r.hole}_${s}`, this.scene);
            carMat.albedoColor = BABYLON.Color3.FromHexString(carColor);
            carMat.emissiveColor = BABYLON.Color3.FromHexString(carColor).scale(0.35);
            carMat.metallic = 0.8;
            carMat.roughness = 0.25;
            const carBody = BABYLON.MeshBuilder.CreateBox(`roundaboutCar_${r.hole}_${s}`, {
              width: 1.6,
              depth: 3.4,
              height: 0.7
            }, this.scene);
            carBody.position.set(stepX, 0.85, stepZ);
            carBody.rotation.y = stepHeading;
            carBody.material = carMat;
            carBody.parent = roundaboutNode;
            carBody.metadata = stepMeta;
            const carCabin = BABYLON.MeshBuilder.CreateBox(`roundaboutCabin_${r.hole}_${s}`, {
              width: 1.3,
              depth: 1.6,
              height: 0.6
            }, this.scene);
            carCabin.position.set(0, 0.6, -0.2);
            carCabin.material = mats.carWheels || mats.asphaltRoad;
            carCabin.parent = carBody;
            carCabin.metadata = stepMeta;
            const carSpoiler = BABYLON.MeshBuilder.CreateBox(`roundaboutSpoiler_${r.hole}_${s}`, {
              width: 1.5,
              depth: 0.35,
              height: 0.35
            }, this.scene);
            carSpoiler.position.set(0, 0.45, -1.5);
            carSpoiler.material = carMat;
            carSpoiler.parent = carBody;
            carSpoiler.metadata = stepMeta;
            [-0.55, 0.55].forEach((hx, hI) => {
              const hl = BABYLON.MeshBuilder.CreateSphere(`roundaboutLight_${r.hole}_${s}_${hI}`, {
                diameter: 0.38,
                segments: 10
              }, this.scene);
              hl.position.set(hx, 0, 1.72);
              hl.material = mats.headlights || mats.accentWhite;
              hl.parent = carBody;
              hl.metadata = stepMeta;
            });
          }
        }
      });
    }
    /**
     * Renders 3D No Passing Lane caution pads, continuous barrier guide rails, and entry/exit warning pylons.
     * @private
     */
    _render3DNoPassingLanes(spacing, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.noPassingLanes) && this.options.obstacleConfigs.noPassingLanes.length > 0;
      const active2 = hasConfigs || Boolean(
        settings3?.optNoPassingLanes || settings3?.optNoPassing || isClash && settings3?.optNoPassingLanes !== false && settings3?.optNoPassing !== false
      );
      if (!active2) return;
      const lanes = hasConfigs ? this.options.obstacleConfigs.noPassingLanes : ObstacleGeometry.getNoPassingLanes(Object.assign({}, settings3, { optNoPassingLanes: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(lanes) || !lanes.length) return;
      const singleTrack = this.activeTracks[0] || "p1";
      const padHeight = 0.35;
      const dims = this.getPegDimensions("front");
      const markerRadius = (dims.spacing || spacing || 7.75) * 0.4;
      lanes.forEach((lane, idx) => {
        const lanePoints = [];
        for (let h = lane.start; h <= Math.min(this.targetHoles, lane.end); h++) {
          const pt = this.getHoleCoords(singleTrack, h);
          if (!pt) continue;
          const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
          const padY = surfaceY + padHeight / 2 + 0.05;
          lanePoints.push(new BABYLON.Vector3(pt.x, padY, pt.z));
          const pad = BABYLON.MeshBuilder.CreateCylinder(`noPassingPad_${singleTrack}_${h}`, {
            diameter: markerRadius * 2.2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          pad.position.set(pt.x, padY, pt.z);
          pad.material = mats.noPassing;
          pad.parent = this.clashObstaclesRoot;
          pad.metadata = { obstacle: "no-passing", laneIndex: idx + 1, start: lane.start, end: lane.end, hole: h, who: singleTrack };
        }
        if (lanePoints.length >= 2) {
          try {
            const railPath = lanePoints.map((p) => new BABYLON.Vector3(p.x, p.y + padHeight / 2 + 0.22, p.z));
            const barrierRail = BABYLON.MeshBuilder.CreateTube(`noPassingRail_${singleTrack}_${lane.start}`, {
              path: railPath,
              radius: 0.36,
              tessellation: 16
            }, this.scene);
            barrierRail.material = mats.noPassingBarrier || mats.noPassing;
            barrierRail.parent = this.clashObstaclesRoot;
            barrierRail.metadata = { obstacle: "no-passing", laneIndex: idx + 1, start: lane.start, end: lane.end, hole: lane.start, who: singleTrack };
          } catch (_) {
          }
        }
        [lane.start, lane.end].forEach((coneHole, cIdx) => {
          const pCone = this.getHoleCoords(singleTrack, coneHole);
          if (pCone) {
            const surfaceY = pCone && pCone.y !== void 0 ? pCone.y : 0.8;
            const pylonHeight = 3.6;
            const cone = BABYLON.MeshBuilder.CreateCylinder(`noPassingPylon_${idx}_${cIdx}`, {
              diameterTop: 0.45,
              diameterBottom: 1.8,
              height: pylonHeight,
              tessellation: 20
            }, this.scene);
            cone.position.set(pCone.x, surfaceY + pylonHeight / 2 + 0.05, pCone.z);
            cone.material = mats.noPassingCone || mats.noPassing;
            cone.parent = this.clashObstaclesRoot;
            cone.metadata = { obstacle: "no-passing", laneIndex: idx + 1, start: lane.start, end: lane.end, hole: coneHole, who: singleTrack };
          }
        });
      });
    }
    /**
     * Renders 3D Sign Block runway socket highlights.
     * @private
     */
    _render3DSignBlocks(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.signs) && this.options.obstacleConfigs.signs.length > 0;
      const active2 = hasConfigs || Boolean(settings3?.optSigns || settings3?.optSign || isClash && settings3?.optSigns !== false && settings3?.optSign !== false);
      if (!active2) return;
      const blocks = hasConfigs ? this.options.obstacleConfigs.signs : ObstacleGeometry.getSignConfigs(Object.assign({}, settings3, { optSigns: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(blocks) || !blocks.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const bounds = (typeof this.getBoardBounds === "function" ? this.getBoardBounds() : null) || this.boardBounds;
      const isClashTarget2 = isClash || this.boardConfig?.brand === "clash" || this.boardConfig?.id === "board-cribbage-clash" || this.boardConfig?.id === "board-cribbage-clash-square";
      blocks.forEach((b) => {
        tracksToMark.forEach((who) => {
          for (let h = b.start; h <= Math.min(this.targetHoles, b.end); h++) {
            const pt = this.getHoleCoords(who, h);
            if (!pt) continue;
            const surfaceY = pt && pt.y !== void 0 ? pt.y : 0.8;
            const pad = BABYLON.MeshBuilder.CreateCylinder(`signHole_${who}_${h}`, {
              diameter: radius * 2.2,
              height: padHeight,
              tessellation: 24
            }, this.scene);
            pad.position.set(pt.x, surfaceY + padHeight / 2 + 0.08, pt.z);
            pad.material = mats.highwayGreen || mats.signs;
            pad.parent = this.clashObstaclesRoot;
            pad.metadata = { obstacle: "sign-block", blockId: b.id, start: b.start, end: b.end, hole: h, who };
            const ring = BABYLON.MeshBuilder.CreateTorus(`signHoleRing_${who}_${h}`, {
              diameter: radius * 1.7,
              thickness: 0.22,
              tessellation: 24
            }, this.scene);
            ring.position.set(pt.x, surfaceY + padHeight + 0.08, pt.z);
            ring.rotation.x = Math.PI / 2;
            ring.material = mats.highwayGreenBorder || mats.accentWhite;
            ring.parent = this.clashObstaclesRoot;
            ring.metadata = { obstacle: "sign-block", blockId: b.id, start: b.start, end: b.end, hole: h, who };
          }
        });
        const refTrack = tracksToMark[0] || "p1";
        const initialSigns = Array.isArray(b.initialSigns) && b.initialSigns.length ? b.initialSigns : ["Plus 5", "Roll The Dice"];
        const signCount = Math.max(2, initialSigns.length);
        const effectiveEnd = Math.min(this.targetHoles, b.end);
        const signW = Math.max(7.4, spacing * 2.2);
        const signH = Math.max(4.6, spacing * 1.4);
        const signR = 0.8;
        const poleHeight = Math.max(12, spacing * 3.6);
        const poleDiameter = 0.42;
        const roundedRectShape = [];
        const segs = 6;
        for (let i = 0; i <= segs; i++) {
          const a = i / segs * Math.PI / 2;
          roundedRectShape.push(new BABYLON.Vector3(signW / 2 - signR + Math.cos(a) * signR, signH / 2 - signR + Math.sin(a) * signR, 0));
        }
        for (let i = 0; i <= segs; i++) {
          const a = Math.PI / 2 + i / segs * Math.PI / 2;
          roundedRectShape.push(new BABYLON.Vector3(-signW / 2 + signR + Math.cos(a) * signR, signH / 2 - signR + Math.sin(a) * signR, 0));
        }
        for (let i = 0; i <= segs; i++) {
          const a = Math.PI + i / segs * Math.PI / 2;
          roundedRectShape.push(new BABYLON.Vector3(-signW / 2 + signR + Math.cos(a) * signR, -signH / 2 + signR + Math.sin(a) * signR, 0));
        }
        for (let i = 0; i <= segs; i++) {
          const a = 3 * Math.PI / 2 + i / segs * Math.PI / 2;
          roundedRectShape.push(new BABYLON.Vector3(signW / 2 - signR + Math.cos(a) * signR, -signH / 2 + signR + Math.sin(a) * signR, 0));
        }
        roundedRectShape.push(roundedRectShape[0]);
        for (let sIdx = 0; sIdx < signCount; sIdx++) {
          const frac = signCount === 1 ? 0.5 : sIdx / (signCount - 1);
          const signHole = Math.round(b.start + frac * (effectiveEnd - b.start));
          const signName = initialSigns[sIdx] || "BONUS SIGN";
          const p0 = this.getHoleCoords(refTrack, signHole);
          const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, signHole + 1));
          if (!p0) continue;
          let nx = 0, nz = 1, dx2 = 1, dz = 0;
          if (p1) {
            dx2 = p1.x - p0.x;
            dz = p1.z - p0.z;
            const len = Math.hypot(dx2, dz) || 1;
            dx2 /= len;
            dz /= len;
            nx = -dz;
            nz = dx2;
          }
          if (bounds && bounds.min && bounds.max) {
            const bCenterX = (bounds.min.x + bounds.max.x) / 2;
            const bCenterZ = (bounds.min.z + bounds.max.z) / 2;
            const dPos = Math.hypot(p0.x + nx * 10 - bCenterX, p0.z + nz * 10 - bCenterZ);
            const dNeg = Math.hypot(p0.x - nx * 10 - bCenterX, p0.z - nz * 10 - bCenterZ);
            if (dPos < dNeg) {
              nx = -nx;
              nz = -nz;
            }
          }
          const staggerDist = spacing * (1.75 + sIdx % 2 * 0.25);
          const postX = p0.x + nx * staggerDist;
          const postZ = p0.z + nz * staggerDist;
          const postY = (p0 && p0.y !== void 0 ? p0.y : 0.8) + 0.1;
          const signMeta = { obstacle: "sign-block", blockId: b.id, signName, hole: signHole, start: b.start, end: effectiveEnd, who: refTrack };
          [-signW * 0.3, signW * 0.3].forEach((postOff, pI) => {
            const pSideX = postX + dx2 * postOff;
            const pSideZ = postZ + dz * postOff;
            const post = BABYLON.MeshBuilder.CreateCylinder(`signBlockPost_${b.id}_${sIdx}_${pI}`, {
              diameter: poleDiameter,
              height: poleHeight,
              tessellation: 16
            }, this.scene);
            post.position.set(pSideX, postY + poleHeight / 2, pSideZ);
            post.material = mats.stopSignPole || mats.accentWhite;
            post.parent = this.clashObstaclesRoot;
            post.metadata = signMeta;
          });
          const crossBeam = BABYLON.MeshBuilder.CreateBox(`signBlockBeam_${b.id}_${sIdx}`, {
            width: signW * 0.85,
            height: 0.35,
            depth: 0.35
          }, this.scene);
          crossBeam.position.set(postX, postY + poleHeight - 0.4, postZ);
          crossBeam.rotation.y = Math.atan2(dx2, dz);
          crossBeam.material = mats.stopSignPole || mats.accentWhite;
          crossBeam.parent = this.clashObstaclesRoot;
          crossBeam.metadata = signMeta;
          try {
            const extrudePath = [new BABYLON.Vector3(0, 0, -0.16), new BABYLON.Vector3(0, 0, 0.16)];
            const signBody = BABYLON.MeshBuilder.ExtrudeShape(`signBlockHead_${b.id}_${sIdx}`, {
              shape: roundedRectShape,
              path: extrudePath,
              cap: BABYLON.Mesh.CAP_ALL
            }, this.scene);
            signBody.position.set(postX, postY + poleHeight, postZ);
            signBody.rotation.x = -Math.PI / 3.4;
            signBody.rotation.y = Math.atan2(dx2, dz) + Math.PI / 2;
            signBody.material = mats.highwayGreen || mats.signs;
            signBody.parent = this.clashObstaclesRoot;
            signBody.metadata = signMeta;
            const dynTex = new BABYLON.DynamicTexture(`signBlockTex_${b.id}_${sIdx}`, { width: 512, height: 320 }, this.scene, true);
            dynTex.hasAlpha = true;
            const ctx = dynTex.getContext();
            ctx.clearRect(0, 0, 512, 320);
            const drawRoundRect = (x, y, w, h, r) => {
              ctx.beginPath();
              ctx.moveTo(x + r, y);
              ctx.lineTo(x + w - r, y);
              ctx.arcTo(x + w, y, x + w, y + r, r);
              ctx.lineTo(x + w, y + h - r);
              ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
              ctx.lineTo(x + r, y + h);
              ctx.arcTo(x, y + h, x, y + h - r, r);
              ctx.lineTo(x, y + r);
              ctx.arcTo(x, y, x + r, y, r);
              ctx.closePath();
            };
            drawRoundRect(8, 8, 496, 304, 36);
            ctx.fillStyle = "#00703c";
            ctx.fill();
            drawRoundRect(22, 22, 468, 276, 26);
            ctx.strokeStyle = "#ffffff";
            ctx.lineWidth = 10;
            ctx.stroke();
            ctx.fillStyle = "#ffffff";
            ctx.font = '700 30px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
            ctx.textAlign = "center";
            ctx.textBaseline = "top";
            ctx.fillText(`EXIT ${signHole} \u2022 CLASH EXPWY`, 256, 36);
            ctx.strokeStyle = "rgba(255, 255, 255, 0.7)";
            ctx.lineWidth = 3;
            ctx.beginPath();
            ctx.moveTo(45, 74);
            ctx.lineTo(467, 74);
            ctx.stroke();
            ctx.fillStyle = "#ffffff";
            const cleanSignName = String(signName || "SIGN BLOCK").toUpperCase();
            if (cleanSignName.length > 14) {
              ctx.font = '900 44px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
            } else if (cleanSignName.length > 9) {
              ctx.font = '900 52px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
            } else {
              ctx.font = '900 62px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
            }
            ctx.textBaseline = "middle";
            ctx.fillText(cleanSignName, 256, 150);
            ctx.fillStyle = "#ffd600";
            ctx.font = '700 28px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
            ctx.fillText("\u2794  BONUS SIGN  \u2794", 256, 240);
            dynTex.update();
            const facePlane = BABYLON.MeshBuilder.CreatePlane(`signBlockFace_${b.id}_${sIdx}`, {
              width: signW * 0.98,
              height: signH * 0.98
            }, this.scene);
            facePlane.position.set(0, 0, 0.18);
            facePlane.parent = signBody;
            const faceMat = new BABYLON.PBRMaterial(`matSignFace_${b.id}_${sIdx}`, this.scene);
            faceMat.albedoTexture = dynTex;
            faceMat.emissiveTexture = dynTex;
            faceMat.emissiveColor = new BABYLON.Color3(0.85, 0.85, 0.85);
            faceMat.roughness = 0.3;
            faceMat.metallic = 0.1;
            facePlane.material = faceMat;
            facePlane.metadata = signMeta;
          } catch (_) {
          }
        }
      });
    }
    /**
     * Renders 3D physical dice clusters (3 dice in a felt casino tray) and track sockets for Dice challenge spaces.
     * @private
     */
    _render3DDice(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.dice) && this.options.obstacleConfigs.dice.length > 0;
      const active2 = hasConfigs || Boolean(settings3?.optDice || isClash && settings3?.optDice !== false && [241, 361, 481].includes(Number(settings3?.target)));
      if (!active2) return;
      const diceList = hasConfigs ? this.options.obstacleConfigs.dice : ObstacleGeometry.getDiceConfigs(Object.assign({}, settings3, { optDice: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(diceList) || !diceList.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      let diceTex = this._diceSharedTexture;
      if (!diceTex && BABYLON.DynamicTexture) {
        try {
          diceTex = new BABYLON.DynamicTexture("diceSharedTex", { width: 1536, height: 256 }, this.scene, false);
          const ctx = diceTex.getContext();
          if (ctx) {
            const pipR = 21;
            const pipRedR = 34;
            const drawDieFace = (fIdx) => {
              const ox = fIdx * 256;
              ctx.fillStyle = "#f8fafc";
              ctx.fillRect(ox, 0, 256, 256);
              ctx.strokeStyle = "#cbd5e1";
              ctx.lineWidth = 10;
              ctx.strokeRect(ox + 5, 5, 246, 246);
              const grad = ctx.createRadialGradient(ox + 128, 128, 10, ox + 128, 128, 140);
              grad.addColorStop(0, "rgba(255, 255, 255, 0.95)");
              grad.addColorStop(1, "rgba(226, 232, 240, 0.4)");
              ctx.fillStyle = grad;
              ctx.fillRect(ox + 8, 8, 240, 240);
            };
            const drawPip = (ox, cx, cy, isRed = false) => {
              const r = isRed ? pipRedR : pipR;
              ctx.beginPath();
              ctx.arc(ox + cx, cy + 2, r, 0, Math.PI * 2);
              ctx.fillStyle = isRed ? "#7f1d1d" : "#0f172a";
              ctx.fill();
              ctx.beginPath();
              ctx.arc(ox + cx, cy, r, 0, Math.PI * 2);
              ctx.fillStyle = isRed ? "#dc2626" : "#1e293b";
              ctx.fill();
              ctx.beginPath();
              ctx.arc(ox + cx - r * 0.32, cy - r * 0.32, r * 0.28, 0, Math.PI * 2);
              ctx.fillStyle = isRed ? "rgba(254, 202, 202, 0.8)" : "rgba(255, 255, 255, 0.55)";
              ctx.fill();
            };
            for (let f = 0; f < 6; f++) {
              drawDieFace(f);
              const ox = f * 256;
              if (f === 0) {
                drawPip(ox, 128, 128, true);
              } else if (f === 1) {
                [68, 188].forEach((x) => {
                  [64, 128, 192].forEach((y) => drawPip(ox, x, y));
                });
              } else if (f === 2) {
                drawPip(ox, 72, 72);
                drawPip(ox, 184, 184);
              } else if (f === 3) {
                drawPip(ox, 72, 72);
                drawPip(ox, 184, 72);
                drawPip(ox, 128, 128);
                drawPip(ox, 72, 184);
                drawPip(ox, 184, 184);
              } else if (f === 4) {
                drawPip(ox, 72, 72);
                drawPip(ox, 128, 128);
                drawPip(ox, 184, 184);
              } else if (f === 5) {
                drawPip(ox, 72, 72);
                drawPip(ox, 184, 72);
                drawPip(ox, 72, 184);
                drawPip(ox, 184, 184);
              }
            }
            diceTex.update();
            this._diceSharedTexture = diceTex;
          }
        } catch (_) {
        }
      }
      const diceMat = new BABYLON.PBRMaterial("mat3D_DiePhysical", this.scene);
      if (diceTex) {
        diceMat.albedoTexture = diceTex;
        diceMat.emissiveTexture = diceTex;
        diceMat.emissiveColor = new BABYLON.Color3(0.12, 0.12, 0.12);
      } else {
        diceMat.albedoColor = new BABYLON.Color3(0.96, 0.96, 0.94);
      }
      diceMat.roughness = 0.22;
      diceMat.metallic = 0.04;
      const faceUV = [
        new BABYLON.Vector4(0 / 6, 0, 1 / 6, 1),
        new BABYLON.Vector4(1 / 6, 0, 2 / 6, 1),
        new BABYLON.Vector4(2 / 6, 0, 3 / 6, 1),
        new BABYLON.Vector4(3 / 6, 0, 4 / 6, 1),
        new BABYLON.Vector4(4 / 6, 0, 5 / 6, 1),
        new BABYLON.Vector4(5 / 6, 0, 6 / 6, 1)
      ];
      diceList.forEach((item) => {
        const hole = item.hole;
        if (hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, hole);
          if (!pt) return;
          const surfaceY2 = pt && pt.y !== void 0 ? pt.y : 0.8;
          const pad = BABYLON.MeshBuilder.CreateCylinder(`diceTrigger_${who}_${hole}`, {
            diameter: radius * 2.2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          pad.position.set(pt.x, surfaceY2 + padHeight / 2 + 0.08, pt.z);
          pad.material = mats.dicePad || mats.timeout;
          pad.parent = this.clashObstaclesRoot;
          pad.metadata = { obstacle: "dice-box", hole, who };
          const outerRing = BABYLON.MeshBuilder.CreateCylinder(`diceTriggerRing_${who}_${hole}`, {
            diameter: radius * 2.45,
            height: padHeight * 0.7,
            tessellation: 24
          }, this.scene);
          outerRing.position.set(pt.x, surfaceY2 + padHeight * 0.7 / 2 + 0.06, pt.z);
          outerRing.material = mats.dicePadRing || mats.diceGoldTrim || mats.accentWhite;
          outerRing.parent = this.clashObstaclesRoot;
          outerRing.metadata = { obstacle: "dice-box", hole, who };
        });
        const refTrack = tracksToMark[0] || "p1";
        const p0 = this.getHoleCoords(refTrack, hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, hole + 1));
        if (!p0 || !p1) return;
        const dx2 = p1.x - p0.x;
        const dz = p1.z - p0.z;
        const len = Math.hypot(dx2, dz) || 1;
        const nx = -dz / len;
        const nz = dx2 / len;
        const surfaceY = p0 && p0.y !== void 0 ? p0.y : 0.8;
        const trayDist = radius * 1.8 + spacing * 2.3;
        const trayX = p0.x + nx * trayDist;
        const trayZ = p0.z + nz * trayDist;
        const diceNode = new BABYLON.TransformNode(`diceNode_${hole}`, this.scene);
        diceNode.position.set(trayX, surfaceY, trayZ);
        diceNode.rotation.y = Math.atan2(-nx, -nz);
        diceNode.parent = this.clashObstaclesRoot;
        const diceMeta = { obstacle: "dice-box", hole, who: refTrack };
        const trayDiam = Math.max(14, spacing * 3.4);
        const trayBase = BABYLON.MeshBuilder.CreateCylinder(`diceTrayBase_${hole}`, {
          diameter: trayDiam,
          height: 0.6,
          tessellation: 28
        }, this.scene);
        trayBase.position.set(0, 0.3, 0);
        trayBase.material = mats.diceTrayBase || mats.dunceWood;
        trayBase.parent = diceNode;
        trayBase.metadata = diceMeta;
        const felt = BABYLON.MeshBuilder.CreateCylinder(`diceFelt_${hole}`, {
          diameter: trayDiam * 0.9,
          height: 0.65,
          tessellation: 28
        }, this.scene);
        felt.position.set(0, 0.32, 0);
        felt.material = mats.diceFelt || mats.grassLawn;
        felt.parent = diceNode;
        felt.metadata = diceMeta;
        const rim = BABYLON.MeshBuilder.CreateTorus(`diceTrayRim_${hole}`, {
          diameter: trayDiam * 0.95,
          thickness: 0.7,
          tessellation: 28
        }, this.scene);
        rim.position.set(0, 0.75, 0);
        rim.material = mats.diceTrayRim || mats.dunceWood;
        rim.parent = diceNode;
        rim.metadata = diceMeta;
        const goldTrim = BABYLON.MeshBuilder.CreateTorus(`diceGoldTrim_${hole}`, {
          diameter: trayDiam * 0.88,
          thickness: 0.2,
          tessellation: 28
        }, this.scene);
        goldTrim.position.set(0, 0.7, 0);
        goldTrim.material = mats.diceGoldTrim || mats.cageLock;
        goldTrim.parent = diceNode;
        goldTrim.metadata = diceMeta;
        const dieSize = Math.max(3.2, spacing * 0.82);
        const die1 = BABYLON.MeshBuilder.CreateBox(`die1_${hole}`, { size: dieSize, faceUV }, this.scene);
        die1.position.set(-dieSize * 0.74, 0.62 + dieSize / 2, -dieSize * 0.43);
        die1.rotation.set(0, 0.35, 0);
        die1.material = diceMat;
        die1.parent = diceNode;
        die1.metadata = diceMeta;
        const die2 = BABYLON.MeshBuilder.CreateBox(`die2_${hole}`, { size: dieSize, faceUV }, this.scene);
        die2.position.set(dieSize * 0.74, 0.62 + dieSize / 2, -dieSize * 0.43);
        die2.rotation.set(-Math.PI / 2, 0, -0.4);
        die2.material = diceMat;
        die2.parent = diceNode;
        die2.metadata = diceMeta;
        const die3 = BABYLON.MeshBuilder.CreateBox(`die3_${hole}`, { size: dieSize, faceUV }, this.scene);
        die3.position.set(0, 0.62 + dieSize / 2, dieSize * 0.76);
        die3.rotation.set(Math.PI / 2, 0, 0.6);
        die3.material = diceMat;
        die3.parent = diceNode;
        die3.metadata = diceMeta;
      });
    }
    /**
     * Renders physical 3D Spinning Wheels (pedestal stand, prize wheel disc with dynamic texture,
     * center hub, pointer flipper, and track socket pad) beside the track for Clash mode.
     * @private
     */
    _render3DSpinningWheels(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const hasConfigs = Array.isArray(this.options.obstacleConfigs?.wheels) && this.options.obstacleConfigs.wheels.length > 0;
      const active2 = hasConfigs || Boolean(
        settings3?.optWheel || settings3?.optSpinningWheel || isClash && settings3?.optWheel !== false && settings3?.optSpinningWheel !== false && [241, 361, 481].includes(Number(settings3?.target))
      );
      if (!active2) return;
      const wheelsList = hasConfigs ? this.options.obstacleConfigs.wheels : ObstacleGeometry.getWheelConfigs(Object.assign({}, settings3, { optWheel: true, target: this.targetHoles || settings3?.target || 481 }));
      if (!Array.isArray(wheelsList) || !wheelsList.length) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      let wheelTex = this._wheelSharedTexture;
      if (!wheelTex && BABYLON.DynamicTexture) {
        try {
          wheelTex = new BABYLON.DynamicTexture("wheelSharedTex", { width: 512, height: 512 }, this.scene, false);
          const ctx = wheelTex.getContext();
          if (ctx) {
            const cx = 256;
            const cy = 256;
            const outerR = 246;
            const numSlices = 8;
            const sliceAngle = Math.PI * 2 / numSlices;
            const colors = [
              "#10b981",
              "#ef4444",
              "#06b6d4",
              "#f97316",
              "#6366f1",
              "#a855f7",
              "#eab308",
              "#ec4899"
            ];
            const sliceLabels = ["+10", "TRAP", "PEGS", "+15", "ROLL", "FREE", "+20", "SPIN"];
            for (let i = 0; i < numSlices; i++) {
              const startA = i * sliceAngle;
              const endA = startA + sliceAngle;
              ctx.beginPath();
              ctx.moveTo(cx, cy);
              ctx.arc(cx, cy, outerR, startA, endA);
              ctx.closePath();
              ctx.fillStyle = colors[i % colors.length];
              ctx.fill();
              ctx.strokeStyle = "#f59e0b";
              ctx.lineWidth = 5;
              ctx.stroke();
              ctx.save();
              ctx.translate(cx, cy);
              ctx.rotate(startA + sliceAngle / 2);
              ctx.textAlign = "right";
              ctx.fillStyle = "#ffffff";
              ctx.font = "bold 26px sans-serif";
              ctx.shadowColor = "rgba(0,0,0,0.8)";
              ctx.shadowBlur = 6;
              ctx.fillText(sliceLabels[i], outerR - 26, 9);
              ctx.restore();
            }
            ctx.beginPath();
            ctx.arc(cx, cy, outerR, 0, Math.PI * 2);
            ctx.strokeStyle = "#f59e0b";
            ctx.lineWidth = 14;
            ctx.stroke();
            for (let p = 0; p < numSlices * 2; p++) {
              const pinAngle = p * Math.PI / numSlices;
              const px = cx + (outerR - 7) * Math.cos(pinAngle);
              const py = cy + (outerR - 7) * Math.sin(pinAngle);
              ctx.beginPath();
              ctx.arc(px, py, 5, 0, Math.PI * 2);
              ctx.fillStyle = "#ffffff";
              ctx.fill();
              ctx.strokeStyle = "#d97706";
              ctx.lineWidth = 2;
              ctx.stroke();
            }
            ctx.beginPath();
            ctx.arc(cx, cy, 52, 0, Math.PI * 2);
            ctx.fillStyle = "#1e1b4b";
            ctx.fill();
            ctx.strokeStyle = "#fbbf24";
            ctx.lineWidth = 6;
            ctx.stroke();
            ctx.fillStyle = "#fbbf24";
            ctx.font = "bold 36px sans-serif";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText("\u2605", cx, cy);
            wheelTex.update();
            this._wheelSharedTexture = wheelTex;
          }
        } catch (_) {
        }
      }
      const wheelFaceMat = new BABYLON.PBRMaterial("mat3D_WheelFace", this.scene);
      if (wheelTex) {
        wheelFaceMat.albedoTexture = wheelTex;
        wheelFaceMat.emissiveTexture = wheelTex;
        wheelFaceMat.emissiveColor = new BABYLON.Color3(0.22, 0.22, 0.22);
      } else {
        wheelFaceMat.albedoColor = new BABYLON.Color3(0.92, 0.3, 0.6);
      }
      wheelFaceMat.roughness = 0.28;
      wheelFaceMat.metallic = 0.12;
      if (!this._wheelRenderObservers) {
        this._wheelRenderObservers = [];
      }
      wheelsList.forEach((item) => {
        const hole = item.hole;
        if (hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          const pt = this.getHoleCoords(who, hole);
          if (!pt) return;
          const surfaceY2 = pt && pt.y !== void 0 ? pt.y : 0.8;
          const pad = BABYLON.MeshBuilder.CreateCylinder(`wheelTrigger_${who}_${hole}`, {
            diameter: radius * 2.2,
            height: padHeight,
            tessellation: 24
          }, this.scene);
          pad.position.set(pt.x, surfaceY2 + padHeight / 2 + 0.08, pt.z);
          pad.material = mats.wheelPad || mats.timeout;
          pad.parent = this.clashObstaclesRoot;
          pad.metadata = { obstacle: "wheel-box", hole, who };
          const outerRing = BABYLON.MeshBuilder.CreateCylinder(`wheelTriggerRing_${who}_${hole}`, {
            diameter: radius * 2.45,
            height: padHeight * 0.7,
            tessellation: 24
          }, this.scene);
          outerRing.position.set(pt.x, surfaceY2 + padHeight * 0.7 / 2 + 0.06, pt.z);
          outerRing.material = mats.wheelPadRing || mats.wheelRim || mats.accentWhite;
          outerRing.parent = this.clashObstaclesRoot;
          outerRing.metadata = { obstacle: "wheel-box", hole, who };
        });
        const refTrack = tracksToMark[0] || "p1";
        const p0 = this.getHoleCoords(refTrack, hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, hole + 1));
        if (!p0 || !p1) return;
        const dx2 = p1.x - p0.x;
        const dz = p1.z - p0.z;
        const len = Math.hypot(dx2, dz) || 1;
        const nx = -dz / len;
        const nz = dx2 / len;
        const surfaceY = p0 && p0.y !== void 0 ? p0.y : 0.8;
        const wheelDist = radius * 1.8 + spacing * 2.4;
        const wheelX = p0.x + nx * wheelDist;
        const wheelZ = p0.z + nz * wheelDist;
        const wheelRootNode = new BABYLON.TransformNode(`wheelRootNode_${hole}`, this.scene);
        wheelRootNode.position.set(wheelX, surfaceY, wheelZ);
        wheelRootNode.rotation.y = Math.atan2(-nx, -nz);
        wheelRootNode.parent = this.clashObstaclesRoot;
        const wheelMeta = { obstacle: "wheel-box", hole, who: refTrack };
        const baseDiam = Math.max(10, spacing * 2.2);
        const basePlate = BABYLON.MeshBuilder.CreateCylinder(`wheelBasePlate_${hole}`, {
          diameter: baseDiam,
          height: 0.5,
          tessellation: 28
        }, this.scene);
        basePlate.position.set(0, 0.25, 0);
        basePlate.material = mats.wheelStand || mats.dunceWood;
        basePlate.parent = wheelRootNode;
        basePlate.metadata = wheelMeta;
        const baseRing = BABYLON.MeshBuilder.CreateTorus(`wheelBaseRing_${hole}`, {
          diameter: baseDiam * 0.94,
          thickness: 0.25,
          tessellation: 28
        }, this.scene);
        baseRing.position.set(0, 0.48, 0);
        baseRing.material = mats.wheelRim || mats.cageLock;
        baseRing.parent = wheelRootNode;
        baseRing.metadata = wheelMeta;
        const hubHeight = Math.max(12.5, spacing * 3.2);
        const legRadius = 0.4;
        [-baseDiam * 0.32, baseDiam * 0.32].forEach((lx, lIdx) => {
          const pBottom = new BABYLON.Vector3(lx, 0.5, 0);
          const pTop = new BABYLON.Vector3(0, hubHeight, 0);
          try {
            const leg = BABYLON.MeshBuilder.CreateTube(`wheelLeg_${hole}_${lIdx}`, {
              path: [pBottom, pTop],
              radius: legRadius,
              tessellation: 12
            }, this.scene);
            leg.material = mats.wheelStand;
            leg.parent = wheelRootNode;
            leg.metadata = wheelMeta;
          } catch (_) {
          }
        });
        try {
          const pRear = new BABYLON.Vector3(0, 0.5, -baseDiam * 0.38);
          const pTop = new BABYLON.Vector3(0, hubHeight, 0);
          const rearStrut = BABYLON.MeshBuilder.CreateTube(`wheelRearStrut_${hole}`, {
            path: [pRear, pTop],
            radius: legRadius * 0.85,
            tessellation: 12
          }, this.scene);
          rearStrut.material = mats.wheelStand;
          rearStrut.parent = wheelRootNode;
          rearStrut.metadata = wheelMeta;
        } catch (_) {
        }
        const crossbar = BABYLON.MeshBuilder.CreateCylinder(`wheelCrossbar_${hole}`, {
          diameter: legRadius * 1.5,
          height: baseDiam * 0.45,
          tessellation: 12
        }, this.scene);
        crossbar.position.set(0, hubHeight * 0.45, 0);
        crossbar.rotation.z = Math.PI / 2;
        crossbar.material = mats.wheelRim;
        crossbar.parent = wheelRootNode;
        crossbar.metadata = wheelMeta;
        const wheelDiameter = Math.max(13, spacing * 3.1);
        const wheelDiscThickness = 0.55;
        const wheelRotNode = new BABYLON.TransformNode(`wheelRotNode_${hole}`, this.scene);
        wheelRotNode.position.set(0, hubHeight, 0.4);
        wheelRotNode.parent = wheelRootNode;
        const wheelDisc = BABYLON.MeshBuilder.CreateCylinder(`wheelDisc_${hole}`, {
          diameter: wheelDiameter,
          height: wheelDiscThickness,
          tessellation: 48
        }, this.scene);
        wheelDisc.rotation.x = Math.PI / 2;
        wheelDisc.material = wheelFaceMat;
        wheelDisc.parent = wheelRotNode;
        wheelDisc.metadata = wheelMeta;
        const wheelRimTorus = BABYLON.MeshBuilder.CreateTorus(`wheelRimTorus_${hole}`, {
          diameter: wheelDiameter,
          thickness: 0.5,
          tessellation: 48
        }, this.scene);
        wheelRimTorus.rotation.x = Math.PI / 2;
        wheelRimTorus.material = mats.wheelRim;
        wheelRimTorus.parent = wheelRotNode;
        wheelRimTorus.metadata = wheelMeta;
        const hubCap = BABYLON.MeshBuilder.CreateSphere(`wheelHubCap_${hole}`, {
          diameter: wheelDiameter * 0.22,
          segments: 16
        }, this.scene);
        hubCap.position.set(0, 0, wheelDiscThickness / 2 + 0.1);
        hubCap.scaling.set(1, 1, 0.45);
        hubCap.material = mats.wheelHub;
        hubCap.parent = wheelRotNode;
        hubCap.metadata = wheelMeta;
        const pointer = BABYLON.MeshBuilder.CreateCylinder(`wheelPointer_${hole}`, {
          diameterTop: 0.1,
          diameterBottom: 1.1,
          height: 1.8,
          tessellation: 16
        }, this.scene);
        pointer.position.set(0, hubHeight + wheelDiameter / 2 - 0.2, 0.7);
        pointer.rotation.x = Math.PI;
        pointer.material = mats.wheelPointer;
        pointer.parent = wheelRootNode;
        pointer.metadata = wheelMeta;
        const spinSpeed = 8e-3 + Math.random() * 4e-3;
        const animObserver = this.scene.onBeforeRenderObservable.add(() => {
          if (wheelRotNode && !wheelRotNode.isDisposed()) {
            wheelRotNode.rotation.z += spinSpeed;
          }
        });
        this._wheelRenderObservers.push(animObserver);
      });
    }
    /**
     * Renders 3D Skunk and Double Skunk Milestone Markers:
     * - Threshold line across the track holes
     * - 1 skunk on each side of the track for Single Skunk Marker
     * - 2 skunks on each side of the track for Double Skunk Marker
     * @private
     */
    _render3DSkunkMarkers(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const settings3 = this.settings;
      const isClash = this.isClashMode();
      const active2 = Boolean(
        settings3?.optSkunkMarkers || isClash && settings3?.optSkunkMarkers !== false && [241, 361, 481].includes(Number(settings3?.target))
      );
      if (!active2) return;
      const targetHoles = this.targetHoles || settings3?.target || 481;
      const skunkHole = settings3?.skunkMarkerHole || Math.round(targetHoles * 0.75);
      const doubleSkunkHole = settings3?.doubleSkunkMarkerHole || Math.round(targetHoles * 0.5);
      const markers = [
        {
          hole: skunkHole,
          isDouble: false,
          label: "SKUNK",
          title: "Skunk Line",
          color: "#38bdf8",
          numSkunksPerSide: 1
        },
        {
          hole: doubleSkunkHole,
          isDouble: true,
          label: "DBL SKUNK",
          title: "Double Skunk Line",
          color: "#f59e0b",
          numSkunksPerSide: 2
        }
      ];
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      let skunkTex = this._skunkSharedTexture;
      if (!skunkTex && BABYLON.DynamicTexture) {
        try {
          skunkTex = new BABYLON.DynamicTexture("skunkSharedTex", { width: 512, height: 512 }, this.scene, false);
          const ctx = skunkTex.getContext();
          if (ctx) {
            ctx.clearRect(0, 0, 512, 512);
            ctx.beginPath();
            ctx.arc(256, 256, 238, 0, Math.PI * 2);
            ctx.fillStyle = "#090d16";
            ctx.fill();
            ctx.lineWidth = 18;
            ctx.strokeStyle = "#e2e8f0";
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(256, 256, 214, 0, Math.PI * 2);
            ctx.lineWidth = 7;
            ctx.strokeStyle = "#f59e0b";
            ctx.stroke();
            ctx.font = '280px "Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", sans-serif';
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText("\u{1F9A8}", 256, 260);
            skunkTex.update();
            this._skunkSharedTexture = skunkTex;
          }
        } catch (_) {
        }
      }
      const skunkMat = new BABYLON.PBRMaterial("mat3D_SkunkToken", this.scene);
      if (skunkTex) {
        skunkMat.albedoTexture = skunkTex;
        skunkMat.emissiveTexture = skunkTex;
        skunkMat.emissiveColor = new BABYLON.Color3(0.35, 0.35, 0.35);
      } else {
        skunkMat.albedoColor = new BABYLON.Color3(0.12, 0.12, 0.12);
      }
      skunkMat.roughness = 0.25;
      skunkMat.metallic = 0.35;
      markers.forEach((m) => {
        const hole = m.hole;
        if (!hole || hole <= 0 || hole > targetHoles) return;
        const pFirst = this.getHoleCoords(tracksToMark[0], hole);
        const pLast = this.getHoleCoords(tracksToMark[tracksToMark.length - 1], hole);
        if (!pFirst) return;
        const pNext = this.getHoleCoords(tracksToMark[0], Math.min(targetHoles, hole + 1));
        const pPrev = this.getHoleCoords(tracksToMark[0], Math.max(1, hole - 1));
        const tdx = (pNext ? pNext.x : pFirst.x) - (pPrev ? pPrev.x : pFirst.x);
        const tdz = (pNext ? pNext.z : pFirst.z) - (pPrev ? pPrev.z : pFirst.z);
        const tLen = Math.hypot(tdx, tdz) || 1;
        const tx = tdx / tLen;
        const tz = tdz / tLen;
        let cx, cz;
        if (pLast && (pLast.x !== pFirst.x || pLast.z !== pFirst.z)) {
          const dx2 = pLast.x - pFirst.x;
          const dz = pLast.z - pFirst.z;
          const cLen = Math.hypot(dx2, dz) || 1;
          cx = dx2 / cLen;
          cz = dz / cLen;
        } else {
          cx = -tz;
          cz = tx;
        }
        const surfaceY = pFirst && pFirst.y !== void 0 ? pFirst.y : 0.8;
        const ext = spacing * 0.75;
        const lastPt = pLast || pFirst;
        const lineP1 = new BABYLON.Vector3(pFirst.x - cx * ext, surfaceY + 0.12, pFirst.z - cz * ext);
        const lineP2 = new BABYLON.Vector3(lastPt.x + cx * ext, surfaceY + 0.12, lastPt.z + cz * ext);
        try {
          const threshLine = BABYLON.MeshBuilder.CreateDashedLines(`skunkThresh_${hole}`, {
            points: [lineP1, lineP2],
            dashSize: 1.5,
            gapSize: 0.8
          }, this.scene);
          threshLine.color = BABYLON.Color3.FromHexString(m.color);
          threshLine.parent = this.clashObstaclesRoot;
          threshLine.metadata = { obstacle: "skunk-marker", hole, isDouble: m.isDouble };
        } catch (_) {
        }
        const tokenRadius = Math.max(3, spacing * 0.76);
        const tokenHeight = 0.55;
        const sideDist = ext + tokenRadius + spacing * 0.4;
        const sides = [
          { x: pFirst.x - cx * sideDist, z: pFirst.z - cz * sideDist, normSign: -1 },
          { x: lastPt.x + cx * sideDist, z: lastPt.z + cz * sideDist, normSign: 1 }
        ];
        sides.forEach((sidePt, sIdx) => {
          const sideNode = new BABYLON.TransformNode(`skunkSideNode_${hole}_${sIdx}`, this.scene);
          sideNode.position.set(sidePt.x, surfaceY, sidePt.z);
          sideNode.parent = this.clashObstaclesRoot;
          const offsets = m.numSkunksPerSide === 1 ? [0] : [-tokenRadius * 1.15, tokenRadius * 1.15];
          offsets.forEach((off, oIdx) => {
            const tokenX = tx * off;
            const tokenZ = tz * off;
            const baseCyl = BABYLON.MeshBuilder.CreateCylinder(`skunkBase_${hole}_${sIdx}_${oIdx}`, {
              diameter: tokenRadius * 2.2,
              height: tokenHeight,
              tessellation: 24
            }, this.scene);
            baseCyl.position.set(tokenX, tokenHeight / 2, tokenZ);
            baseCyl.material = mats.diceTrayBase || mats.dunceWood;
            baseCyl.parent = sideNode;
            baseCyl.metadata = { obstacle: "skunk-marker", hole, isDouble: m.isDouble };
            const accentRing = BABYLON.MeshBuilder.CreateTorus(`skunkRing_${hole}_${sIdx}_${oIdx}`, {
              diameter: tokenRadius * 2.1,
              thickness: 0.28,
              tessellation: 24
            }, this.scene);
            accentRing.position.set(tokenX, tokenHeight, tokenZ);
            accentRing.material = m.isDouble ? mats.diceGoldTrim || mats.cageLock : mats.accentWhite || mats.dicePadRing;
            accentRing.parent = sideNode;
            accentRing.metadata = { obstacle: "skunk-marker", hole, isDouble: m.isDouble };
            const tokenCyl = BABYLON.MeshBuilder.CreateCylinder(`skunkCoin_${hole}_${sIdx}_${oIdx}`, {
              diameter: tokenRadius * 2,
              height: tokenHeight * 0.4,
              tessellation: 24
            }, this.scene);
            tokenCyl.position.set(tokenX, tokenHeight + 0.05, tokenZ);
            tokenCyl.rotation.y = Math.atan2(cx * sidePt.normSign, cz * sidePt.normSign);
            tokenCyl.material = skunkMat;
            tokenCyl.parent = sideNode;
            tokenCyl.metadata = { obstacle: "skunk-marker", hole, isDouble: m.isDouble };
          });
        });
      });
    }
    /**
     * Renders 3D themed coaster socket pads and upright beverages for active Pints & Pegs drinking spaces.
     * @private
     */
    _render3DPintsCoastersAndBeverages(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const configs = this.getActivePintsConfigs();
      if (!Array.isArray(configs) || configs.length === 0) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      configs.forEach((cfg) => {
        if (cfg.hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          for (let offset = 0; offset < cfg.pegs; offset++) {
            const currentHole = cfg.hole + offset;
            if (currentHole > this.targetHoles) break;
            const pt = this.getHoleCoords(who, currentHole);
            if (!pt) continue;
            const surfaceY2 = pt && pt.y !== void 0 ? pt.y : 0.8;
            const padDiam = radius * 2.3;
            const padH = padHeight * 1.8;
            const padMat = mats[`pad${cfg.type.charAt(0).toUpperCase() + cfg.type.slice(1)}`] || mats.padYouDrink;
            const meta = { obstacle: "pints-space", type: cfg.type, hole: currentHole, who };
            const padMesh = BABYLON.MeshBuilder.CreateCylinder(`pintsPad_${who}_${currentHole}_${cfg.type}`, {
              diameter: padDiam,
              height: padH,
              tessellation: 24
            }, this.scene);
            padMesh.position.set(pt.x, surfaceY2 + padH / 2 + 0.05, pt.z);
            padMesh.material = padMat;
            padMesh.parent = this.pintsObjectsRoot;
            padMesh.metadata = meta;
            const rimMesh = BABYLON.MeshBuilder.CreateCylinder(`pintsPadRim_${who}_${currentHole}_${cfg.type}`, {
              diameter: padDiam * 0.84,
              height: padH + 0.06,
              tessellation: 24
            }, this.scene);
            rimMesh.position.set(pt.x, surfaceY2 + (padH + 0.06) / 2 + 0.05, pt.z);
            rimMesh.material = mats.padRim;
            rimMesh.parent = this.pintsObjectsRoot;
            rimMesh.metadata = meta;
            const coreMesh = BABYLON.MeshBuilder.CreateCylinder(`pintsPadCore_${who}_${currentHole}_${cfg.type}`, {
              diameter: padDiam * 0.58,
              height: padH + 0.12,
              tessellation: 24
            }, this.scene);
            coreMesh.position.set(pt.x, surfaceY2 + (padH + 0.12) / 2 + 0.05, pt.z);
            coreMesh.material = padMat;
            coreMesh.parent = this.pintsObjectsRoot;
            coreMesh.metadata = meta;
          }
        });
        const p0 = this.getHoleCoords(refTrack, cfg.hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, cfg.hole + 1));
        if (!p0) return;
        let nx = 0;
        let nz = 1;
        if (p1 && (p1.x !== p0.x || p1.z !== p0.z)) {
          const dx2 = p1.x - p0.x;
          const dz = p1.z - p0.z;
          const len = Math.hypot(dx2, dz) || 1;
          nx = -dz / len;
          nz = dx2 / len;
        }
        const itemDist = spacing * 1.75;
        const itemX = p0.x + nx * itemDist;
        const itemZ = p0.z + nz * itemDist;
        const surfaceY = p0 && p0.y !== void 0 ? p0.y : 0.8;
        const bevNode = new BABYLON.TransformNode(`pintsBevNode_${cfg.id}`, this.scene);
        bevNode.position.set(itemX, surfaceY, itemZ);
        bevNode.rotation.y = Math.atan2(-nx, -nz);
        bevNode.parent = this.pintsObjectsRoot;
        const bevMeta = { obstacle: "pints-drink", type: cfg.type, hole: cfg.hole, who: refTrack, id: cfg.id };
        switch (cfg.type) {
          case "youDrink":
            this._build3DBeerMug(bevNode, mats, bevMeta);
            break;
          case "guysDrink":
            this._build3DGuysDrink(bevNode, mats, bevMeta);
            break;
          case "galsDrink":
            this._build3DGalsDrink(bevNode, mats, bevMeta);
            break;
          case "leftDrink":
            this._build3DLeftDrink(bevNode, mats, bevMeta);
            break;
          case "rightDrink":
            this._build3DRightDrink(bevNode, mats, bevMeta);
            break;
          case "everyoneDrink":
            this._build3DEveryoneDrink(bevNode, mats, bevMeta);
            break;
          case "everyoneButYouDrink":
            this._build3DEveryoneButYouDrink(bevNode, mats, bevMeta);
            break;
          case "pickWhoDrinks":
            this._build3DShakerAndShot(bevNode, mats, bevMeta);
            break;
          default:
            this._build3DBeerMug(bevNode, mats, bevMeta);
            break;
        }
      });
    }
    /**
     * 1. You Drink: 3D Frosted Beer Mug with Golden Lager & Foam Crown
     * @private
     */
    _build3DBeerMug(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const coaster = BABYLON.MeshBuilder.CreateCylinder(`bevCoaster_${meta.id}`, {
        diameter: 11,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      coaster.position.set(0, 0.25, 0);
      coaster.material = mats.coasterWood;
      coaster.parent = parent;
      coaster.metadata = meta;
      const coasterRim = BABYLON.MeshBuilder.CreateTorus(`bevCoasterRim_${meta.id}`, {
        diameter: 10.8,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      coasterRim.position.set(0, 0.48, 0);
      coasterRim.material = mats.coasterGold;
      coasterRim.parent = parent;
      coasterRim.metadata = meta;
      const mugGlass = BABYLON.MeshBuilder.CreateCylinder(`bevGlass_${meta.id}`, {
        diameter: 8.8,
        height: 13,
        tessellation: 24
      }, this.scene);
      mugGlass.position.set(0, 0.5 + 6.5, 0);
      mugGlass.material = mats.glass;
      mugGlass.parent = parent;
      mugGlass.metadata = meta;
      const liquid = BABYLON.MeshBuilder.CreateCylinder(`bevLiquid_${meta.id}`, {
        diameter: 7.4,
        height: 11.2,
        tessellation: 24
      }, this.scene);
      liquid.position.set(0, 1 + 5.6, 0);
      liquid.material = mats.beerAmber;
      liquid.parent = parent;
      liquid.metadata = meta;
      const foam = BABYLON.MeshBuilder.CreateCylinder(`bevFoam_${meta.id}`, {
        diameter: 8,
        height: 2.6,
        tessellation: 24
      }, this.scene);
      foam.position.set(0, 12.5, 0);
      foam.material = mats.beerFoam;
      foam.parent = parent;
      foam.metadata = meta;
      const foamCap = BABYLON.MeshBuilder.CreateCylinder(`bevFoamCap_${meta.id}`, {
        diameter: 8.6,
        height: 1.2,
        tessellation: 24
      }, this.scene);
      foamCap.position.set(0, 13.8, 0);
      foamCap.material = mats.beerFoam;
      foamCap.parent = parent;
      foamCap.metadata = meta;
      try {
        const handlePath = [];
        for (let a = -Math.PI / 2; a <= Math.PI / 2; a += Math.PI / 8) {
          handlePath.push(new BABYLON.Vector3(
            4.4 + 2.2 * Math.cos(a),
            7 + 3.8 * Math.sin(a),
            0
          ));
        }
        const handle = BABYLON.MeshBuilder.CreateTube(`bevHandle_${meta.id}`, {
          path: handlePath,
          radius: 0.65,
          tessellation: 12
        }, this.scene);
        handle.material = mats.glass;
        handle.parent = parent;
        handle.metadata = meta;
      } catch (_) {
      }
    }
    /**
     * 2. Guys Drink: 3D British Nonic Pint Glass with signature bulge band & dark ale
     * @private
     */
    _build3DGuysDrink(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const coaster = BABYLON.MeshBuilder.CreateCylinder(`bevCoaster_${meta.id}`, {
        diameter: 10.6,
        height: 0.48,
        tessellation: 28
      }, this.scene);
      coaster.position.set(0, 0.24, 0);
      coaster.material = mats.coasterSlate;
      coaster.parent = parent;
      coaster.metadata = meta;
      const coasterRim = BABYLON.MeshBuilder.CreateTorus(`bevCoasterRim_${meta.id}`, {
        diameter: 10.4,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      coasterRim.position.set(0, 0.46, 0);
      coasterRim.material = mats.padGuysDrink;
      coasterRim.parent = parent;
      coasterRim.metadata = meta;
      const nonicLower = BABYLON.MeshBuilder.CreateCylinder(`bevNonicLower_${meta.id}`, {
        diameterBottom: 6.2,
        diameterTop: 8.2,
        height: 8,
        tessellation: 24
      }, this.scene);
      nonicLower.position.set(0, 0.48 + 4, 0);
      nonicLower.material = mats.glass;
      nonicLower.parent = parent;
      nonicLower.metadata = meta;
      const nonicBulge = BABYLON.MeshBuilder.CreateCylinder(`bevNonicBulge_${meta.id}`, {
        diameterBottom: 8.2,
        diameterTop: 9.4,
        height: 2.8,
        tessellation: 24
      }, this.scene);
      nonicBulge.position.set(0, 8.48 + 1.4, 0);
      nonicBulge.material = mats.glass;
      nonicBulge.parent = parent;
      nonicBulge.metadata = meta;
      const nonicUpper = BABYLON.MeshBuilder.CreateCylinder(`bevNonicUpper_${meta.id}`, {
        diameterBottom: 9.4,
        diameterTop: 8.6,
        height: 3.2,
        tessellation: 24
      }, this.scene);
      nonicUpper.position.set(0, 11.28 + 1.6, 0);
      nonicUpper.material = mats.glass;
      nonicUpper.parent = parent;
      nonicUpper.metadata = meta;
      const liquid = BABYLON.MeshBuilder.CreateCylinder(`bevLiquid_${meta.id}`, {
        diameterBottom: 5.4,
        diameterTop: 7.8,
        height: 11,
        tessellation: 24
      }, this.scene);
      liquid.position.set(0, 1 + 5.5, 0);
      liquid.material = mats.beerDarkAle;
      liquid.parent = parent;
      liquid.metadata = meta;
      const foam = BABYLON.MeshBuilder.CreateCylinder(`bevFoam_${meta.id}`, {
        diameter: 8.4,
        height: 1.8,
        tessellation: 24
      }, this.scene);
      foam.position.set(0, 13.4, 0);
      foam.material = mats.beerFoam;
      foam.parent = parent;
      foam.metadata = meta;
    }
    /**
     * 3. Gals Drink: 3D Stemmed Wine Glass with circular foot, slender stem & ruby wine
     * @private
     */
    _build3DGalsDrink(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const coaster = BABYLON.MeshBuilder.CreateCylinder(`bevCoaster_${meta.id}`, {
        diameter: 10.2,
        height: 0.45,
        tessellation: 28
      }, this.scene);
      coaster.position.set(0, 0.225, 0);
      coaster.material = mats.coasterWood;
      coaster.parent = parent;
      coaster.metadata = meta;
      const coasterRim = BABYLON.MeshBuilder.CreateTorus(`bevCoasterRim_${meta.id}`, {
        diameter: 10,
        thickness: 0.22,
        tessellation: 28
      }, this.scene);
      coasterRim.position.set(0, 0.42, 0);
      coasterRim.material = mats.padGalsDrink;
      coasterRim.parent = parent;
      coasterRim.metadata = meta;
      const foot = BABYLON.MeshBuilder.CreateCylinder(`bevWineFoot_${meta.id}`, {
        diameter: 8,
        height: 0.65,
        tessellation: 24
      }, this.scene);
      foot.position.set(0, 0.45 + 0.325, 0);
      foot.material = mats.glass;
      foot.parent = parent;
      foot.metadata = meta;
      const stem = BABYLON.MeshBuilder.CreateCylinder(`bevWineStem_${meta.id}`, {
        diameter: 1.15,
        height: 8.5,
        tessellation: 18
      }, this.scene);
      stem.position.set(0, 1.1 + 4.25, 0);
      stem.material = mats.glass;
      stem.parent = parent;
      stem.metadata = meta;
      const bowlLower = BABYLON.MeshBuilder.CreateCylinder(`bevWineBowlLower_${meta.id}`, {
        diameterBottom: 1.8,
        diameterTop: 8.6,
        height: 5.5,
        tessellation: 24
      }, this.scene);
      bowlLower.position.set(0, 9.6 + 2.75, 0);
      bowlLower.material = mats.glass;
      bowlLower.parent = parent;
      bowlLower.metadata = meta;
      const bowlUpper = BABYLON.MeshBuilder.CreateCylinder(`bevWineBowlUpper_${meta.id}`, {
        diameterBottom: 8.6,
        diameterTop: 7,
        height: 4.8,
        tessellation: 24
      }, this.scene);
      bowlUpper.position.set(0, 15.1 + 2.4, 0);
      bowlUpper.material = mats.glass;
      bowlUpper.parent = parent;
      bowlUpper.metadata = meta;
      const liquid = BABYLON.MeshBuilder.CreateCylinder(`bevLiquid_${meta.id}`, {
        diameterBottom: 4.2,
        diameterTop: 7.6,
        height: 4.8,
        tessellation: 24
      }, this.scene);
      liquid.position.set(0, 13.2, 0);
      liquid.material = mats.wineRuby;
      liquid.parent = parent;
      liquid.metadata = meta;
    }
    /**
     * 4. Left Drink: 3D Frosted Highball with Violet Cocktail, Ice & Lime Wheel pointing Left
     * @private
     */
    _build3DLeftDrink(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const coaster = BABYLON.MeshBuilder.CreateCylinder(`bevCoaster_${meta.id}`, {
        diameter: 10.4,
        height: 0.48,
        tessellation: 28
      }, this.scene);
      coaster.position.set(0, 0.24, 0);
      coaster.material = mats.coasterMarble;
      coaster.parent = parent;
      coaster.metadata = meta;
      const coasterRim = BABYLON.MeshBuilder.CreateTorus(`bevCoasterRim_${meta.id}`, {
        diameter: 10.2,
        thickness: 0.24,
        tessellation: 28
      }, this.scene);
      coasterRim.position.set(0, 0.46, 0);
      coasterRim.material = mats.padLeftDrink;
      coasterRim.parent = parent;
      coasterRim.metadata = meta;
      const glassBase = BABYLON.MeshBuilder.CreateCylinder(`bevGlassBase_${meta.id}`, {
        diameter: 7.4,
        height: 2.2,
        tessellation: 24
      }, this.scene);
      glassBase.position.set(0, 0.48 + 1.1, 0);
      glassBase.material = mats.glass;
      glassBase.parent = parent;
      glassBase.metadata = meta;
      const glassBody = BABYLON.MeshBuilder.CreateCylinder(`bevGlass_${meta.id}`, {
        diameter: 7.6,
        height: 13,
        tessellation: 24
      }, this.scene);
      glassBody.position.set(0, 2.68 + 6.5, 0);
      glassBody.material = mats.glass;
      glassBody.parent = parent;
      glassBody.metadata = meta;
      const liquid = BABYLON.MeshBuilder.CreateCylinder(`bevLiquid_${meta.id}`, {
        diameter: 6.6,
        height: 10.5,
        tessellation: 24
      }, this.scene);
      liquid.position.set(0, 2.68 + 5.25, 0);
      liquid.material = mats.cocktailViolet;
      liquid.parent = parent;
      liquid.metadata = meta;
      const ice1 = BABYLON.MeshBuilder.CreateBox(`bevIce1_${meta.id}`, { size: 2 }, this.scene);
      ice1.position.set(-0.8, 7.5, 0.4);
      ice1.rotation.set(0.3, 0.4, 0.2);
      ice1.material = mats.iceCube;
      ice1.parent = parent;
      ice1.metadata = meta;
      const ice2 = BABYLON.MeshBuilder.CreateBox(`bevIce2_${meta.id}`, { size: 1.9 }, this.scene);
      ice2.position.set(0.7, 10.5, -0.3);
      ice2.rotation.set(-0.2, 0.5, -0.3);
      ice2.material = mats.iceCube;
      ice2.parent = parent;
      ice2.metadata = meta;
      const lime = BABYLON.MeshBuilder.CreateCylinder(`bevLime_${meta.id}`, {
        diameter: 4,
        height: 0.4,
        tessellation: 24
      }, this.scene);
      lime.position.set(-3.6, 15.5, 0);
      lime.rotation.z = -0.45;
      lime.material = mats.limeGarnish;
      lime.parent = parent;
      lime.metadata = meta;
      const straw = BABYLON.MeshBuilder.CreateCylinder(`bevStraw_${meta.id}`, {
        diameter: 0.42,
        height: 16,
        tessellation: 12
      }, this.scene);
      straw.position.set(-1.4, 9.8, 0);
      straw.rotation.z = 0.3;
      straw.material = mats.strawCyan;
      straw.parent = parent;
      straw.metadata = meta;
    }
    /**
     * 5. Right Drink: 3D Frosted Highball with Orange Cocktail, Ice & Orange Slice pointing Right
     * @private
     */
    _build3DRightDrink(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const coaster = BABYLON.MeshBuilder.CreateCylinder(`bevCoaster_${meta.id}`, {
        diameter: 10.4,
        height: 0.48,
        tessellation: 28
      }, this.scene);
      coaster.position.set(0, 0.24, 0);
      coaster.material = mats.coasterMarble;
      coaster.parent = parent;
      coaster.metadata = meta;
      const coasterRim = BABYLON.MeshBuilder.CreateTorus(`bevCoasterRim_${meta.id}`, {
        diameter: 10.2,
        thickness: 0.24,
        tessellation: 28
      }, this.scene);
      coasterRim.position.set(0, 0.46, 0);
      coasterRim.material = mats.padRightDrink;
      coasterRim.parent = parent;
      coasterRim.metadata = meta;
      const glassBase = BABYLON.MeshBuilder.CreateCylinder(`bevGlassBase_${meta.id}`, {
        diameter: 7.4,
        height: 2.2,
        tessellation: 24
      }, this.scene);
      glassBase.position.set(0, 0.48 + 1.1, 0);
      glassBase.material = mats.glass;
      glassBase.parent = parent;
      glassBase.metadata = meta;
      const glassBody = BABYLON.MeshBuilder.CreateCylinder(`bevGlass_${meta.id}`, {
        diameter: 7.6,
        height: 13,
        tessellation: 24
      }, this.scene);
      glassBody.position.set(0, 2.68 + 6.5, 0);
      glassBody.material = mats.glass;
      glassBody.parent = parent;
      glassBody.metadata = meta;
      const liquid = BABYLON.MeshBuilder.CreateCylinder(`bevLiquid_${meta.id}`, {
        diameter: 6.6,
        height: 10.5,
        tessellation: 24
      }, this.scene);
      liquid.position.set(0, 2.68 + 5.25, 0);
      liquid.material = mats.cocktailOrange;
      liquid.parent = parent;
      liquid.metadata = meta;
      const ice1 = BABYLON.MeshBuilder.CreateBox(`bevIce1_${meta.id}`, { size: 2 }, this.scene);
      ice1.position.set(0.8, 7.5, 0.4);
      ice1.rotation.set(-0.3, 0.4, -0.2);
      ice1.material = mats.iceCube;
      ice1.parent = parent;
      ice1.metadata = meta;
      const ice2 = BABYLON.MeshBuilder.CreateBox(`bevIce2_${meta.id}`, { size: 1.9 }, this.scene);
      ice2.position.set(-0.7, 10.5, -0.3);
      ice2.rotation.set(0.2, 0.5, 0.3);
      ice2.material = mats.iceCube;
      ice2.parent = parent;
      ice2.metadata = meta;
      const orange = BABYLON.MeshBuilder.CreateCylinder(`bevOrange_${meta.id}`, {
        diameter: 4.4,
        height: 0.45,
        tessellation: 24
      }, this.scene);
      orange.position.set(3.6, 15.5, 0);
      orange.rotation.z = 0.45;
      orange.material = mats.orangeGarnish;
      orange.parent = parent;
      orange.metadata = meta;
      const straw = BABYLON.MeshBuilder.CreateCylinder(`bevStraw_${meta.id}`, {
        diameter: 0.42,
        height: 16,
        tessellation: 12
      }, this.scene);
      straw.position.set(1.4, 9.8, 0);
      straw.rotation.z = -0.3;
      straw.material = mats.strawMagenta;
      straw.parent = parent;
      straw.metadata = meta;
    }
    /**
     * 6. Everyone Drinks: 3D Toasting Clinking Champagne Flutes with bubbly golden champagne
     * @private
     */
    _build3DEveryoneDrink(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const coaster = BABYLON.MeshBuilder.CreateCylinder(`bevCoaster_${meta.id}`, {
        diameter: 14,
        height: 0.48,
        tessellation: 28
      }, this.scene);
      coaster.position.set(0, 0.24, 0);
      coaster.material = mats.coasterSlate;
      coaster.parent = parent;
      coaster.metadata = meta;
      const coasterRim = BABYLON.MeshBuilder.CreateTorus(`bevCoasterRim_${meta.id}`, {
        diameter: 13.8,
        thickness: 0.26,
        tessellation: 28
      }, this.scene);
      coasterRim.position.set(0, 0.46, 0);
      coasterRim.material = mats.padEveryoneDrink;
      coasterRim.parent = parent;
      coasterRim.metadata = meta;
      const buildFlute = (sideName, posX, rotZ) => {
        const fluteNode = new BABYLON.TransformNode(`fluteNode_${sideName}_${meta.id}`, this.scene);
        fluteNode.position.set(posX, 0.48, 0);
        fluteNode.rotation.z = rotZ;
        fluteNode.parent = parent;
        const foot = BABYLON.MeshBuilder.CreateCylinder(`fluteFoot_${sideName}_${meta.id}`, {
          diameter: 5.2,
          height: 0.45,
          tessellation: 24
        }, this.scene);
        foot.position.set(0, 0.225, 0);
        foot.material = mats.glass;
        foot.parent = fluteNode;
        foot.metadata = meta;
        const stem = BABYLON.MeshBuilder.CreateCylinder(`fluteStem_${sideName}_${meta.id}`, {
          diameter: 0.85,
          height: 7.5,
          tessellation: 18
        }, this.scene);
        stem.position.set(0, 0.45 + 3.75, 0);
        stem.material = mats.glass;
        stem.parent = fluteNode;
        stem.metadata = meta;
        const bowl = BABYLON.MeshBuilder.CreateCylinder(`fluteBowl_${sideName}_${meta.id}`, {
          diameterBottom: 1.4,
          diameterTop: 4.4,
          height: 8.5,
          tessellation: 24
        }, this.scene);
        bowl.position.set(0, 4.2 + 4.25, 0);
        bowl.material = mats.glass;
        bowl.parent = fluteNode;
        bowl.metadata = meta;
        const liquid = BABYLON.MeshBuilder.CreateCylinder(`fluteLiquid_${sideName}_${meta.id}`, {
          diameterBottom: 1.2,
          diameterTop: 3.8,
          height: 6.5,
          tessellation: 24
        }, this.scene);
        liquid.position.set(0, 4.5 + 3.25, 0);
        liquid.material = mats.champagneGold;
        liquid.parent = fluteNode;
        liquid.metadata = meta;
      };
      buildFlute("left", -2.8, -0.14);
      buildFlute("right", 2.8, 0.14);
      const spark = BABYLON.MeshBuilder.CreateSphere(`clinkSpark_${meta.id}`, {
        diameter: 1.1,
        segments: 12
      }, this.scene);
      spark.position.set(0, 16.2, 0);
      spark.material = mats.coasterGold;
      spark.parent = parent;
      spark.metadata = meta;
    }
    /**
     * 7. Everyone But You: 3D Champagne Bottle in Chilled Stainless Steel Ice Bucket
     * @private
     */
    _build3DEveryoneButYouDrink(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const coaster = BABYLON.MeshBuilder.CreateCylinder(`bevCoaster_${meta.id}`, {
        diameter: 13,
        height: 0.48,
        tessellation: 28
      }, this.scene);
      coaster.position.set(0, 0.24, 0);
      coaster.material = mats.padEveryoneButYouDrink;
      coaster.parent = parent;
      coaster.metadata = meta;
      const coasterRim = BABYLON.MeshBuilder.CreateTorus(`bevCoasterRim_${meta.id}`, {
        diameter: 12.8,
        thickness: 0.26,
        tessellation: 28
      }, this.scene);
      coasterRim.position.set(0, 0.46, 0);
      coasterRim.material = mats.coasterSilver;
      coasterRim.parent = parent;
      coasterRim.metadata = meta;
      const bucket = BABYLON.MeshBuilder.CreateCylinder(`iceBucket_${meta.id}`, {
        diameterBottom: 9,
        diameterTop: 11.6,
        height: 8.5,
        tessellation: 28
      }, this.scene);
      bucket.position.set(0, 0.48 + 4.25, 0);
      bucket.material = mats.iceBucketSteel;
      bucket.parent = parent;
      bucket.metadata = meta;
      const bucketRim = BABYLON.MeshBuilder.CreateTorus(`iceBucketRim_${meta.id}`, {
        diameter: 11.6,
        thickness: 0.45,
        tessellation: 28
      }, this.scene);
      bucketRim.position.set(0, 0.48 + 8.5, 0);
      bucketRim.material = mats.iceBucketSteel;
      bucketRim.parent = parent;
      bucketRim.metadata = meta;
      [-5.8, 5.8].forEach((hx, hIdx) => {
        const handle = BABYLON.MeshBuilder.CreateTorus(`bucketHandle_${meta.id}_${hIdx}`, {
          diameter: 2,
          thickness: 0.35,
          tessellation: 18
        }, this.scene);
        handle.position.set(hx, 6.8, 0);
        handle.rotation.z = Math.PI / 2;
        handle.material = mats.iceBucketSteel;
        handle.parent = parent;
        handle.metadata = meta;
      });
      const iceMound = BABYLON.MeshBuilder.CreateCylinder(`bucketIce_${meta.id}`, {
        diameter: 10.8,
        height: 1.2,
        tessellation: 24
      }, this.scene);
      iceMound.position.set(0, 8.2, 0);
      iceMound.material = mats.iceCube;
      iceMound.parent = parent;
      iceMound.metadata = meta;
      [
        { x: -2.6, y: 9, z: 2.2, r: 0.3 },
        { x: 2.4, y: 9.1, z: 2, r: -0.4 },
        { x: -1.8, y: 8.9, z: -2.4, r: 0.5 }
      ].forEach((cub, cIdx) => {
        const cube = BABYLON.MeshBuilder.CreateBox(`bucketCube_${meta.id}_${cIdx}`, { size: 1.8 }, this.scene);
        cube.position.set(cub.x, cub.y, cub.z);
        cube.rotation.set(cub.r, cub.r * 1.5, cub.r * 0.7);
        cube.material = mats.iceCube;
        cube.parent = parent;
        cube.metadata = meta;
      });
      const bottleNode = new BABYLON.TransformNode(`champagneBottle_${meta.id}`, this.scene);
      bottleNode.position.set(0.4, 5, 0);
      bottleNode.rotation.z = 0.14;
      bottleNode.parent = parent;
      const bottleBody = BABYLON.MeshBuilder.CreateCylinder(`bottleBody_${meta.id}`, {
        diameter: 4.8,
        height: 7.2,
        tessellation: 24
      }, this.scene);
      bottleBody.position.set(0, 3.6, 0);
      bottleBody.material = mats.bottleGreen;
      bottleBody.parent = bottleNode;
      bottleBody.metadata = meta;
      const bottleShoulder = BABYLON.MeshBuilder.CreateCylinder(`bottleShoulder_${meta.id}`, {
        diameterBottom: 4.8,
        diameterTop: 2,
        height: 3.2,
        tessellation: 24
      }, this.scene);
      bottleShoulder.position.set(0, 7.2 + 1.6, 0);
      bottleShoulder.material = mats.bottleGreen;
      bottleShoulder.parent = bottleNode;
      bottleShoulder.metadata = meta;
      const bottleNeck = BABYLON.MeshBuilder.CreateCylinder(`bottleNeck_${meta.id}`, {
        diameter: 1.9,
        height: 3.8,
        tessellation: 24
      }, this.scene);
      bottleNeck.position.set(0, 10.4 + 1.9, 0);
      bottleNeck.material = mats.bottleFoilGold;
      bottleNeck.parent = bottleNode;
      bottleNeck.metadata = meta;
      const bottleCork = BABYLON.MeshBuilder.CreateCylinder(`bottleCork_${meta.id}`, {
        diameter: 2.2,
        height: 1.6,
        tessellation: 24
      }, this.scene);
      bottleCork.position.set(0, 14.2 + 0.8, 0);
      bottleCork.material = mats.corkWood;
      bottleCork.parent = bottleNode;
      bottleCork.metadata = meta;
    }
    /**
     * 8. Pick Who Drinks: 3D Cocktail Shaker, Shot Glass & Bullseye Target Coaster
     * @private
     */
    _build3DShakerAndShot(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const targetBase = BABYLON.MeshBuilder.CreateCylinder(`targetBase_${meta.id}`, {
        diameter: 13,
        height: 0.48,
        tessellation: 28
      }, this.scene);
      targetBase.position.set(0, 0.24, 0);
      targetBase.material = mats.targetRed;
      targetBase.parent = parent;
      targetBase.metadata = meta;
      const targetWhite = BABYLON.MeshBuilder.CreateCylinder(`targetWhite_${meta.id}`, {
        diameter: 10,
        height: 0.54,
        tessellation: 28
      }, this.scene);
      targetWhite.position.set(0, 0.27, 0);
      targetWhite.material = mats.targetWhite;
      targetWhite.parent = parent;
      targetWhite.metadata = meta;
      const targetRed = BABYLON.MeshBuilder.CreateCylinder(`targetRed_${meta.id}`, {
        diameter: 7,
        height: 0.6,
        tessellation: 28
      }, this.scene);
      targetRed.position.set(0, 0.3, 0);
      targetRed.material = mats.targetRed;
      targetRed.parent = parent;
      targetRed.metadata = meta;
      const targetBullseye = BABYLON.MeshBuilder.CreateCylinder(`targetBullseye_${meta.id}`, {
        diameter: 3.8,
        height: 0.66,
        tessellation: 28
      }, this.scene);
      targetBullseye.position.set(0, 0.33, 0);
      targetBullseye.material = mats.coasterGold;
      targetBullseye.parent = parent;
      targetBullseye.metadata = meta;
      const shakerTumbler = BABYLON.MeshBuilder.CreateCylinder(`shakerTumbler_${meta.id}`, {
        diameterBottom: 4.8,
        diameterTop: 6.2,
        height: 8,
        tessellation: 24
      }, this.scene);
      shakerTumbler.position.set(-2.6, 0.48 + 4, 0.5);
      shakerTumbler.material = mats.shakerSteel;
      shakerTumbler.parent = parent;
      shakerTumbler.metadata = meta;
      const shakerStrainer = BABYLON.MeshBuilder.CreateCylinder(`shakerStrainer_${meta.id}`, {
        diameterBottom: 6.2,
        diameterTop: 3.4,
        height: 3.6,
        tessellation: 24
      }, this.scene);
      shakerStrainer.position.set(-2.6, 8.48 + 1.8, 0.5);
      shakerStrainer.material = mats.shakerSteel;
      shakerStrainer.parent = parent;
      shakerStrainer.metadata = meta;
      const shakerCap = BABYLON.MeshBuilder.CreateCylinder(`shakerCap_${meta.id}`, {
        diameter: 3.2,
        height: 2.6,
        tessellation: 24
      }, this.scene);
      shakerCap.position.set(-2.6, 12.08 + 1.3, 0.5);
      shakerCap.material = mats.shakerSteel;
      shakerCap.parent = parent;
      shakerCap.metadata = meta;
      const shotBase = BABYLON.MeshBuilder.CreateCylinder(`shotBase_${meta.id}`, {
        diameter: 4.2,
        height: 1.6,
        tessellation: 24
      }, this.scene);
      shotBase.position.set(3.2, 0.48 + 0.8, -0.5);
      shotBase.material = mats.glass;
      shotBase.parent = parent;
      shotBase.metadata = meta;
      const shotGlass = BABYLON.MeshBuilder.CreateCylinder(`shotGlass_${meta.id}`, {
        diameterBottom: 4.2,
        diameterTop: 5.4,
        height: 4.8,
        tessellation: 24
      }, this.scene);
      shotGlass.position.set(3.2, 2.08 + 2.4, -0.5);
      shotGlass.material = mats.glass;
      shotGlass.parent = parent;
      shotGlass.metadata = meta;
      const shotLiquid = BABYLON.MeshBuilder.CreateCylinder(`shotLiquid_${meta.id}`, {
        diameterBottom: 3.6,
        diameterTop: 4.8,
        height: 3.6,
        tessellation: 24
      }, this.scene);
      shotLiquid.position.set(3.2, 2.08 + 1.8, -0.5);
      shotLiquid.material = mats.beerAmber;
      shotLiquid.parent = parent;
      shotLiquid.metadata = meta;
    }
    /**
     * Renders 3D themed coaster socket pads and romantic sculptures for active Skunked & Stripped (Adult) spaces.
     * @private
     */
    _render3DAdultCoastersAndObjects(spacing, radius, padHeight, mats) {
      const BABYLON = this.BABYLON;
      const configs = this.getActiveAdultConfigs();
      if (!Array.isArray(configs) || configs.length === 0) return;
      const tracksToMark = this.activeTracks.length > 0 ? this.activeTracks : ["p1"];
      const refTrack = tracksToMark[0] || "p1";
      configs.forEach((cfg) => {
        if (cfg.hole > this.targetHoles) return;
        tracksToMark.forEach((who) => {
          for (let offset = 0; offset < cfg.pegs; offset++) {
            const currentHole = cfg.hole + offset;
            if (currentHole > this.targetHoles) break;
            const pt = this.getHoleCoords(who, currentHole);
            if (!pt) continue;
            const surfaceY2 = pt && pt.y !== void 0 ? pt.y : 0.8;
            const padDiam = radius * 2.3;
            const padH = padHeight * 1.8;
            const padMat = mats[`pad${cfg.type.charAt(0).toUpperCase() + cfg.type.slice(1)}`] || mats.padLoseClothing;
            const meta = { obstacle: "adult-space", type: cfg.type, hole: currentHole, who, timed: cfg.timed };
            const padMesh = BABYLON.MeshBuilder.CreateCylinder(`adultPad_${who}_${currentHole}_${cfg.type}`, {
              diameter: padDiam,
              height: padH,
              tessellation: 24
            }, this.scene);
            padMesh.position.set(pt.x, surfaceY2 + padH / 2 + 0.05, pt.z);
            padMesh.material = padMat;
            padMesh.parent = this.adultObjectsRoot;
            padMesh.metadata = meta;
            const rimMesh = BABYLON.MeshBuilder.CreateCylinder(`adultPadRim_${who}_${currentHole}_${cfg.type}`, {
              diameter: padDiam * 0.84,
              height: padH + 0.06,
              tessellation: 24
            }, this.scene);
            rimMesh.position.set(pt.x, surfaceY2 + (padH + 0.06) / 2 + 0.05, pt.z);
            rimMesh.material = mats.padRim;
            rimMesh.parent = this.adultObjectsRoot;
            rimMesh.metadata = meta;
            const coreMesh = BABYLON.MeshBuilder.CreateCylinder(`adultPadCore_${who}_${currentHole}_${cfg.type}`, {
              diameter: padDiam * 0.58,
              height: padH + 0.12,
              tessellation: 24
            }, this.scene);
            coreMesh.position.set(pt.x, surfaceY2 + (padH + 0.12) / 2 + 0.05, pt.z);
            coreMesh.material = padMat;
            coreMesh.parent = this.adultObjectsRoot;
            coreMesh.metadata = meta;
          }
        });
        const p0 = this.getHoleCoords(refTrack, cfg.hole);
        const p1 = this.getHoleCoords(refTrack, Math.min(this.targetHoles, cfg.hole + 1));
        if (!p0) return;
        let nx = 0;
        let nz = 1;
        if (p1 && (p1.x !== p0.x || p1.z !== p0.z)) {
          const dx2 = p1.x - p0.x;
          const dz = p1.z - p0.z;
          const len = Math.hypot(dx2, dz) || 1;
          nx = -dz / len;
          nz = dx2 / len;
        }
        const itemDist = spacing * 1.75;
        const itemX = p0.x + nx * itemDist;
        const itemZ = p0.z + nz * itemDist;
        const surfaceY = p0 && p0.y !== void 0 ? p0.y : 0.8;
        const objNode = new BABYLON.TransformNode(`adultObjNode_${cfg.id}`, this.scene);
        objNode.position.set(itemX, surfaceY, itemZ);
        objNode.rotation.y = Math.atan2(-nx, -nz);
        objNode.parent = this.adultObjectsRoot;
        const objMeta = { obstacle: "adult-dare", type: cfg.type, hole: cfg.hole, who: refTrack, id: cfg.id, timed: cfg.timed };
        switch (cfg.type) {
          case "loseClothing":
            this._build3DLingerieMannequin(objNode, mats, objMeta);
            break;
          case "gainClothing":
            this._build3DCoatValet(objNode, mats, objMeta);
            break;
          case "pickWhoLosesClothing":
            this._build3DCupidTarget(objNode, mats, objMeta);
            break;
          case "rightLosesClothing":
            this._build3DPointingHandRight(objNode, mats, objMeta);
            break;
          case "leftLosesClothing":
            this._build3DPointingHandLeft(objNode, mats, objMeta);
            break;
          case "removeClothingChoice":
            this._build3DTailorShears(objNode, mats, objMeta);
            break;
          case "touchBreast":
            this._build3DLipsAndHourglass(objNode, mats, objMeta);
            break;
          case "lickBreast":
          case "lickGenitals":
          case "lickAnus":
            this._build3DLollipopAndHourglass(objNode, mats, objMeta);
            break;
          case "suckBreast":
          case "suckGenitals":
            this._build3DStrawberryAndHourglass(objNode, mats, objMeta);
            break;
          case "touchGenitals":
            this._build3DMagicWandAndHourglass(objNode, mats, objMeta);
            break;
          case "fingerGenitals":
          case "fingerAnus":
            this._build3DScentedCandleAndHand(objNode, mats, objMeta);
            break;
          case "genitalIntercourse":
          case "analIntercourse":
            this._build3DPassionateFlames(objNode, mats, objMeta);
            break;
          case "touchAnus":
            this._build3DVelvetPeach(objNode, mats, objMeta);
            break;
          default:
            this._build3DLingerieMannequin(objNode, mats, objMeta);
            break;
        }
      });
    }
    /**
     * Helper: 3D Challenge Timer Hourglass with glass bulbs, sand & golden pillars
     * @private
     */
    _build3DHourglass(parent, mats, meta, posX = 2.8, posZ = 0.2) {
      const BABYLON = this.BABYLON;
      const hgNode = new BABYLON.TransformNode(`hourglassNode_${meta.id}`, this.scene);
      hgNode.position.set(posX, 0, posZ);
      hgNode.parent = parent;
      const baseDisc = BABYLON.MeshBuilder.CreateCylinder(`hgBase_${meta.id}`, {
        diameter: 3.8,
        height: 0.5,
        tessellation: 20
      }, this.scene);
      baseDisc.position.set(0, 0.48 + 0.25, 0);
      baseDisc.material = mats.sculptureGold;
      baseDisc.parent = hgNode;
      baseDisc.metadata = meta;
      const topDisc = BABYLON.MeshBuilder.CreateCylinder(`hgTop_${meta.id}`, {
        diameter: 3.8,
        height: 0.5,
        tessellation: 20
      }, this.scene);
      topDisc.position.set(0, 0.48 + 7.8, 0);
      topDisc.material = mats.sculptureGold;
      topDisc.parent = hgNode;
      topDisc.metadata = meta;
      for (let p = 0; p < 3; p++) {
        const a = p * 2 * Math.PI / 3;
        const px = 1.4 * Math.cos(a);
        const pz = 1.4 * Math.sin(a);
        const pillar = BABYLON.MeshBuilder.CreateCylinder(`hgPillar_${meta.id}_${p}`, {
          diameter: 0.35,
          height: 7.2,
          tessellation: 12
        }, this.scene);
        pillar.position.set(px, 0.48 + 4, pz);
        pillar.material = mats.sculptureGold;
        pillar.parent = hgNode;
        pillar.metadata = meta;
      }
      const glassLower = BABYLON.MeshBuilder.CreateCylinder(`hgGlassLower_${meta.id}`, {
        diameterBottom: 3,
        diameterTop: 0.6,
        height: 3.4,
        tessellation: 20
      }, this.scene);
      glassLower.position.set(0, 0.48 + 0.5 + 1.7, 0);
      glassLower.material = mats.glass;
      glassLower.parent = hgNode;
      glassLower.metadata = meta;
      const glassUpper = BABYLON.MeshBuilder.CreateCylinder(`hgGlassUpper_${meta.id}`, {
        diameterBottom: 0.6,
        diameterTop: 3,
        height: 3.4,
        tessellation: 20
      }, this.scene);
      glassUpper.position.set(0, 0.48 + 0.5 + 5.1, 0);
      glassUpper.material = mats.glass;
      glassUpper.parent = hgNode;
      glassUpper.metadata = meta;
      const sandLower = BABYLON.MeshBuilder.CreateCylinder(`hgSandLower_${meta.id}`, {
        diameterBottom: 2.6,
        diameterTop: 0.3,
        height: 1.8,
        tessellation: 20
      }, this.scene);
      sandLower.position.set(0, 0.48 + 0.5 + 0.9, 0);
      sandLower.material = mats.sandGold;
      sandLower.parent = hgNode;
      sandLower.metadata = meta;
      const sandUpper = BABYLON.MeshBuilder.CreateCylinder(`hgSandUpper_${meta.id}`, {
        diameterBottom: 0.4,
        diameterTop: 2.4,
        height: 1.4,
        tessellation: 20
      }, this.scene);
      sandUpper.position.set(0, 0.48 + 0.5 + 5.9, 0);
      sandUpper.material = mats.sandGold;
      sandUpper.parent = hgNode;
      sandUpper.metadata = meta;
    }
    /**
     * 1. You Lose Clothing: 3D Sculpted Lingerie Corset Mannequin on Rose-Gold Plinth
     * @private
     */
    _build3DLingerieMannequin(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`adultPlinth_${meta.id}`, {
        diameter: 11.2,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`adultPlinthRim_${meta.id}`, {
        diameter: 11,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.pedestalRoseGold;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const rod = BABYLON.MeshBuilder.CreateCylinder(`mannequinRod_${meta.id}`, {
        diameter: 0.8,
        height: 5.5,
        tessellation: 16
      }, this.scene);
      rod.position.set(0, 0.5 + 2.75, 0);
      rod.material = mats.sculptureGold;
      rod.parent = parent;
      rod.metadata = meta;
      const hips = BABYLON.MeshBuilder.CreateCylinder(`mannequinHips_${meta.id}`, {
        diameterBottom: 5.6,
        diameterTop: 4.2,
        height: 3.8,
        tessellation: 24
      }, this.scene);
      hips.position.set(0, 5, 0);
      hips.material = mats.pedestalSilver;
      hips.parent = parent;
      hips.metadata = meta;
      const bust = BABYLON.MeshBuilder.CreateCylinder(`mannequinBust_${meta.id}`, {
        diameterBottom: 4.2,
        diameterTop: 6,
        height: 4.2,
        tessellation: 24
      }, this.scene);
      bust.position.set(0, 8.8, 0);
      bust.material = mats.pedestalSilver;
      bust.parent = parent;
      bust.metadata = meta;
      const neck = BABYLON.MeshBuilder.CreateCylinder(`mannequinNeck_${meta.id}`, {
        diameter: 1.8,
        height: 1.8,
        tessellation: 16
      }, this.scene);
      neck.position.set(0, 11.6, 0);
      neck.material = mats.pedestalSilver;
      neck.parent = parent;
      neck.metadata = meta;
      const finial = BABYLON.MeshBuilder.CreateSphere(`mannequinFinial_${meta.id}`, {
        diameter: 2.2,
        segments: 16
      }, this.scene);
      finial.position.set(0, 13, 0);
      finial.material = mats.sculptureGold;
      finial.parent = parent;
      finial.metadata = meta;
      const lowerWrap = BABYLON.MeshBuilder.CreateTorus(`lingerieWrap_${meta.id}`, {
        diameter: 5.4,
        thickness: 0.45,
        tessellation: 24
      }, this.scene);
      lowerWrap.position.set(0, 4.4, 0);
      lowerWrap.material = mats.silkPink;
      lowerWrap.parent = parent;
      lowerWrap.metadata = meta;
      [-1.4, 1.4].forEach((cx, cIdx) => {
        const cup = BABYLON.MeshBuilder.CreateSphere(`lingerieCup_${meta.id}_${cIdx}`, {
          diameter: 2.7,
          segments: 16
        }, this.scene);
        cup.position.set(cx, 9.2, 1.6);
        cup.material = mats.silkPink;
        cup.parent = parent;
        cup.metadata = meta;
      });
    }
    /**
     * 2. You Gain Clothing: Tailored Emerald Velvet Jacket on Mahogany Valet Stand
     * @private
     */
    _build3DCoatValet(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`valetPlinth_${meta.id}`, {
        diameter: 11.2,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalWood;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`valetPlinthRim_${meta.id}`, {
        diameter: 11,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.satinEmerald;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const rod = BABYLON.MeshBuilder.CreateCylinder(`valetRod_${meta.id}`, {
        diameter: 0.85,
        height: 12,
        tessellation: 16
      }, this.scene);
      rod.position.set(0, 0.5 + 6, 0);
      rod.material = mats.sculptureGold;
      rod.parent = parent;
      rod.metadata = meta;
      const hanger = BABYLON.MeshBuilder.CreateBox(`valetHanger_${meta.id}`, {
        width: 8.5,
        height: 0.65,
        depth: 1.2
      }, this.scene);
      hanger.position.set(0, 12.2, 0);
      hanger.material = mats.pedestalWood;
      hanger.parent = parent;
      hanger.metadata = meta;
      const coat = BABYLON.MeshBuilder.CreateBox(`valetCoat_${meta.id}`, {
        width: 7.2,
        height: 8,
        depth: 3.8
      }, this.scene);
      coat.position.set(0, 8, 0);
      coat.material = mats.satinEmerald;
      coat.parent = parent;
      coat.metadata = meta;
      for (let b = 0; b < 3; b++) {
        const btn = BABYLON.MeshBuilder.CreateCylinder(`coatBtn_${meta.id}_${b}`, {
          diameter: 0.6,
          height: 0.35,
          tessellation: 12
        }, this.scene);
        btn.position.set(0, 9.5 - b * 1.5, 2);
        btn.rotation.x = Math.PI / 2;
        btn.material = mats.sculptureGold;
        btn.parent = parent;
        btn.metadata = meta;
      }
    }
    /**
     * 3. Pick Who Strips: 3D Archery Dartboard Target with Cupid's Golden Heart Arrow
     * @private
     */
    _build3DCupidTarget(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`targetPlinth_${meta.id}`, {
        diameter: 11.2,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`targetPlinthRim_${meta.id}`, {
        diameter: 11,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.padPickWhoLosesClothing;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const board = BABYLON.MeshBuilder.CreateCylinder(`targetDisc_${meta.id}`, {
        diameter: 10.4,
        height: 0.6,
        tessellation: 28
      }, this.scene);
      board.position.set(0, 7, 0);
      board.rotation.x = Math.PI / 2;
      board.material = mats.velvetPink;
      board.parent = parent;
      board.metadata = meta;
      const ringWhite = BABYLON.MeshBuilder.CreateCylinder(`targetRingWhite_${meta.id}`, {
        diameter: 7.6,
        height: 0.7,
        tessellation: 28
      }, this.scene);
      ringWhite.position.set(0, 7, 0.05);
      ringWhite.rotation.x = Math.PI / 2;
      ringWhite.material = mats.padRim;
      ringWhite.parent = parent;
      ringWhite.metadata = meta;
      const ringPink = BABYLON.MeshBuilder.CreateCylinder(`targetRingPink_${meta.id}`, {
        diameter: 4.8,
        height: 0.8,
        tessellation: 28
      }, this.scene);
      ringPink.position.set(0, 7, 0.1);
      ringPink.rotation.x = Math.PI / 2;
      ringPink.material = mats.padPickWhoLosesClothing;
      ringPink.parent = parent;
      ringPink.metadata = meta;
      const bullseye = BABYLON.MeshBuilder.CreateCylinder(`targetBullseye_${meta.id}`, {
        diameter: 2.2,
        height: 0.9,
        tessellation: 24
      }, this.scene);
      bullseye.position.set(0, 7, 0.15);
      bullseye.rotation.x = Math.PI / 2;
      bullseye.material = mats.sculptureGold;
      bullseye.parent = parent;
      bullseye.metadata = meta;
      const shaft = BABYLON.MeshBuilder.CreateCylinder(`arrowShaft_${meta.id}`, {
        diameter: 0.38,
        height: 6.5,
        tessellation: 12
      }, this.scene);
      shaft.position.set(0, 7, 3.5);
      shaft.rotation.x = Math.PI / 2;
      shaft.material = mats.sculptureGold;
      shaft.parent = parent;
      shaft.metadata = meta;
      const heartHead = BABYLON.MeshBuilder.CreateSphere(`arrowHeart_${meta.id}`, {
        diameter: 1.4,
        segments: 12
      }, this.scene);
      heartHead.position.set(0, 7, 0.5);
      heartHead.material = mats.lipsRuby;
      heartHead.parent = parent;
      heartHead.metadata = meta;
      const fletch = BABYLON.MeshBuilder.CreateBox(`arrowFletch_${meta.id}`, {
        width: 1.5,
        height: 1.5,
        depth: 0.3
      }, this.scene);
      fletch.position.set(0, 7, 6.4);
      fletch.material = mats.sculptureGold;
      fletch.parent = parent;
      fletch.metadata = meta;
    }
    /**
     * 4. Right Neighbor Strips: Sculpted Golden Hand with Sapphire Ring pointing Right
     * @private
     */
    _build3DPointingHandRight(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`handPlinth_${meta.id}`, {
        diameter: 11,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`handPlinthRim_${meta.id}`, {
        diameter: 10.8,
        thickness: 0.24,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.padRightLosesClothing;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const wrist = BABYLON.MeshBuilder.CreateSphere(`wrist_${meta.id}`, {
        diameter: 3.2,
        segments: 16
      }, this.scene);
      wrist.position.set(-1.8, 2.2, 0);
      wrist.material = mats.pedestalSilver;
      wrist.parent = parent;
      wrist.metadata = meta;
      const palm = BABYLON.MeshBuilder.CreateBox(`palm_${meta.id}`, {
        width: 3.4,
        height: 2.2,
        depth: 2.8
      }, this.scene);
      palm.position.set(-0.8, 3.8, 0);
      palm.material = mats.sculptureGold;
      palm.parent = parent;
      palm.metadata = meta;
      const finger = BABYLON.MeshBuilder.CreateCylinder(`finger_${meta.id}`, {
        diameter: 1,
        height: 5.5,
        tessellation: 16
      }, this.scene);
      finger.position.set(2.2, 4.4, 0.6);
      finger.rotation.z = -Math.PI / 2;
      finger.material = mats.sculptureGold;
      finger.parent = parent;
      finger.metadata = meta;
      const curled = BABYLON.MeshBuilder.CreateBox(`curled_${meta.id}`, {
        width: 2.4,
        height: 2,
        depth: 1.8
      }, this.scene);
      curled.position.set(0.2, 3.2, -0.4);
      curled.material = mats.sculptureGold;
      curled.parent = parent;
      curled.metadata = meta;
      const ring = BABYLON.MeshBuilder.CreateTorus(`ring_${meta.id}`, {
        diameter: 1.4,
        thickness: 0.35,
        tessellation: 16
      }, this.scene);
      ring.position.set(1.5, 4.4, 0.6);
      ring.rotation.y = Math.PI / 2;
      ring.material = mats.padRightLosesClothing;
      ring.parent = parent;
      ring.metadata = meta;
    }
    /**
     * 5. Left Neighbor Strips: Sculpted Golden Hand with Amethyst Ring pointing Left
     * @private
     */
    _build3DPointingHandLeft(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`handPlinth_${meta.id}`, {
        diameter: 11,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`handPlinthRim_${meta.id}`, {
        diameter: 10.8,
        thickness: 0.24,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.padLeftLosesClothing;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const wrist = BABYLON.MeshBuilder.CreateSphere(`wrist_${meta.id}`, {
        diameter: 3.2,
        segments: 16
      }, this.scene);
      wrist.position.set(1.8, 2.2, 0);
      wrist.material = mats.pedestalSilver;
      wrist.parent = parent;
      wrist.metadata = meta;
      const palm = BABYLON.MeshBuilder.CreateBox(`palm_${meta.id}`, {
        width: 3.4,
        height: 2.2,
        depth: 2.8
      }, this.scene);
      palm.position.set(0.8, 3.8, 0);
      palm.material = mats.sculptureGold;
      palm.parent = parent;
      palm.metadata = meta;
      const finger = BABYLON.MeshBuilder.CreateCylinder(`finger_${meta.id}`, {
        diameter: 1,
        height: 5.5,
        tessellation: 16
      }, this.scene);
      finger.position.set(-2.2, 4.4, 0.6);
      finger.rotation.z = Math.PI / 2;
      finger.material = mats.sculptureGold;
      finger.parent = parent;
      finger.metadata = meta;
      const curled = BABYLON.MeshBuilder.CreateBox(`curled_${meta.id}`, {
        width: 2.4,
        height: 2,
        depth: 1.8
      }, this.scene);
      curled.position.set(-0.2, 3.2, -0.4);
      curled.material = mats.sculptureGold;
      curled.parent = parent;
      curled.metadata = meta;
      const ring = BABYLON.MeshBuilder.CreateTorus(`ring_${meta.id}`, {
        diameter: 1.4,
        thickness: 0.35,
        tessellation: 16
      }, this.scene);
      ring.position.set(-1.5, 4.4, 0.6);
      ring.rotation.y = Math.PI / 2;
      ring.material = mats.padLeftLosesClothing;
      ring.parent = parent;
      ring.metadata = meta;
    }
    /**
     * 6. Remove Clothing Choice: Golden Tailor's Shears Cutting Scarlet Silk Ribbon
     * @private
     */
    _build3DTailorShears(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`shearsPlinth_${meta.id}`, {
        diameter: 11,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`shearsPlinthRim_${meta.id}`, {
        diameter: 10.8,
        thickness: 0.24,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.ribbonScarlet;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const pivot = BABYLON.MeshBuilder.CreateCylinder(`shearsPivot_${meta.id}`, {
        diameter: 1.2,
        height: 0.8,
        tessellation: 16
      }, this.scene);
      pivot.position.set(0, 4.5, 0);
      pivot.rotation.x = Math.PI / 2;
      pivot.material = mats.sculptureGold;
      pivot.parent = parent;
      pivot.metadata = meta;
      const bladeLeft = BABYLON.MeshBuilder.CreateBox(`shearsBladeL_${meta.id}`, {
        width: 0.8,
        height: 8.5,
        depth: 0.3
      }, this.scene);
      bladeLeft.position.set(-1.6, 8.2, 0);
      bladeLeft.rotation.z = -0.32;
      bladeLeft.material = mats.pedestalSilver;
      bladeLeft.parent = parent;
      bladeLeft.metadata = meta;
      const bladeRight = BABYLON.MeshBuilder.CreateBox(`shearsBladeR_${meta.id}`, {
        width: 0.8,
        height: 8.5,
        depth: 0.3
      }, this.scene);
      bladeRight.position.set(1.6, 8.2, 0);
      bladeRight.rotation.z = 0.32;
      bladeRight.material = mats.pedestalSilver;
      bladeRight.parent = parent;
      bladeRight.metadata = meta;
      const loopL = BABYLON.MeshBuilder.CreateTorus(`shearsLoopL_${meta.id}`, {
        diameter: 3,
        thickness: 0.5,
        tessellation: 20
      }, this.scene);
      loopL.position.set(-1.8, 2, 0);
      loopL.rotation.z = 0.2;
      loopL.material = mats.sculptureGold;
      loopL.parent = parent;
      loopL.metadata = meta;
      const loopR = BABYLON.MeshBuilder.CreateTorus(`shearsLoopR_${meta.id}`, {
        diameter: 3,
        thickness: 0.5,
        tessellation: 20
      }, this.scene);
      loopR.position.set(1.8, 2, 0);
      loopR.rotation.z = -0.2;
      loopR.material = mats.sculptureGold;
      loopR.parent = parent;
      loopR.metadata = meta;
      const ribbon = BABYLON.MeshBuilder.CreateBox(`shearsRibbon_${meta.id}`, {
        width: 7,
        height: 0.8,
        depth: 1.4
      }, this.scene);
      ribbon.position.set(0, 5.8, 0.4);
      ribbon.rotation.y = 0.15;
      ribbon.material = mats.ribbonScarlet;
      ribbon.parent = parent;
      ribbon.metadata = meta;
    }
    /**
     * 7. Touch Breast / Kiss Dares: Sculpted Glossy Ruby Lips with 3D Challenge Hourglass
     * @private
     */
    _build3DLipsAndHourglass(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`lipsPlinth_${meta.id}`, {
        diameter: 12,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`lipsPlinthRim_${meta.id}`, {
        diameter: 11.8,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.pedestalRoseGold;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const stand = BABYLON.MeshBuilder.CreateCylinder(`lipsStand_${meta.id}`, {
        diameter: 0.65,
        height: 4.8,
        tessellation: 16
      }, this.scene);
      stand.position.set(-2.4, 0.5 + 2.4, 0);
      stand.material = mats.sculptureGold;
      stand.parent = parent;
      stand.metadata = meta;
      const upperLipL = BABYLON.MeshBuilder.CreateSphere(`lipUpperL_${meta.id}`, {
        diameter: 2.2,
        segments: 16
      }, this.scene);
      upperLipL.position.set(-3.2, 6.2, 0.1);
      upperLipL.material = mats.lipsRuby;
      upperLipL.parent = parent;
      upperLipL.metadata = meta;
      const upperLipR = BABYLON.MeshBuilder.CreateSphere(`lipUpperR_${meta.id}`, {
        diameter: 2.2,
        segments: 16
      }, this.scene);
      upperLipR.position.set(-1.6, 6.2, 0.1);
      upperLipR.material = mats.lipsRuby;
      upperLipR.parent = parent;
      upperLipR.metadata = meta;
      const lowerLip = BABYLON.MeshBuilder.CreateCylinder(`lipLower_${meta.id}`, {
        diameterBottom: 2.4,
        diameterTop: 3.4,
        height: 1.4,
        tessellation: 20
      }, this.scene);
      lowerLip.position.set(-2.4, 5, 0.2);
      lowerLip.rotation.z = Math.PI / 2;
      lowerLip.material = mats.lipsRuby;
      lowerLip.parent = parent;
      lowerLip.metadata = meta;
      this._build3DHourglass(parent, mats, meta, 2.8, 0.2);
    }
    /**
     * 8. Lick Dares: Sculpted Spiral Lollipop with Ribbon & 3D Challenge Hourglass
     * @private
     */
    _build3DLollipopAndHourglass(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`popPlinth_${meta.id}`, {
        diameter: 12,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`popPlinthRim_${meta.id}`, {
        diameter: 11.8,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.velvetPink;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const stick = BABYLON.MeshBuilder.CreateCylinder(`popStick_${meta.id}`, {
        diameter: 0.55,
        height: 6.8,
        tessellation: 16
      }, this.scene);
      stick.position.set(-2.4, 0.5 + 3.4, 0);
      stick.material = mats.pedestalSilver;
      stick.parent = parent;
      stick.metadata = meta;
      const popDisc = BABYLON.MeshBuilder.CreateCylinder(`popDisc_${meta.id}`, {
        diameter: 5.6,
        height: 1.2,
        tessellation: 28
      }, this.scene);
      popDisc.position.set(-2.4, 8.2, 0);
      popDisc.rotation.x = Math.PI / 2;
      popDisc.material = mats.lipsRuby;
      popDisc.parent = parent;
      popDisc.metadata = meta;
      const popSwirl = BABYLON.MeshBuilder.CreateTorus(`popSwirl_${meta.id}`, {
        diameter: 4,
        thickness: 0.45,
        tessellation: 24
      }, this.scene);
      popSwirl.position.set(-2.4, 8.2, 0.2);
      popSwirl.rotation.x = Math.PI / 2;
      popSwirl.material = mats.silkPink;
      popSwirl.parent = parent;
      popSwirl.metadata = meta;
      this._build3DHourglass(parent, mats, meta, 2.8, 0.2);
    }
    /**
     * 9. Suck Dares: Chocolate-Dipped Strawberry with 3D Challenge Hourglass
     * @private
     */
    _build3DStrawberryAndHourglass(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`strawbPlinth_${meta.id}`, {
        diameter: 12,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`strawbPlinthRim_${meta.id}`, {
        diameter: 11.8,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.pedestalGold;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const dip = BABYLON.MeshBuilder.CreateCylinder(`chocoDip_${meta.id}`, {
        diameterBottom: 1.2,
        diameterTop: 3.8,
        height: 2.6,
        tessellation: 24
      }, this.scene);
      dip.position.set(-2.4, 0.5 + 1.3, 0);
      dip.material = mats.pedestalWood;
      dip.parent = parent;
      dip.metadata = meta;
      const berryBody = BABYLON.MeshBuilder.CreateCylinder(`berryBody_${meta.id}`, {
        diameterBottom: 3.6,
        diameterTop: 4.8,
        height: 2.8,
        tessellation: 24
      }, this.scene);
      berryBody.position.set(-2.4, 0.5 + 2.6 + 1.4, 0);
      berryBody.material = mats.strawberryRed;
      berryBody.parent = parent;
      berryBody.metadata = meta;
      const berryDome = BABYLON.MeshBuilder.CreateSphere(`berryDome_${meta.id}`, {
        diameter: 4.8,
        segments: 16
      }, this.scene);
      berryDome.position.set(-2.4, 0.5 + 5, 0);
      berryDome.material = mats.strawberryRed;
      berryDome.parent = parent;
      berryDome.metadata = meta;
      const stem = BABYLON.MeshBuilder.CreateCylinder(`berryStem_${meta.id}`, {
        diameter: 0.45,
        height: 1.6,
        tessellation: 12
      }, this.scene);
      stem.position.set(-2.4, 0.5 + 7.4, 0);
      stem.material = mats.leafGreen;
      stem.parent = parent;
      stem.metadata = meta;
      this._build3DHourglass(parent, mats, meta, 2.8, 0.2);
    }
    /**
     * 10. Touch Genitals: Golden Star Scepter Crystal Wand with 3D Challenge Hourglass
     * @private
     */
    _build3DMagicWandAndHourglass(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`wandPlinth_${meta.id}`, {
        diameter: 12,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.velvetPurple;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`wandPlinthRim_${meta.id}`, {
        diameter: 11.8,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.pedestalGold;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const staff = BABYLON.MeshBuilder.CreateCylinder(`wandStaff_${meta.id}`, {
        diameter: 0.7,
        height: 10,
        tessellation: 16
      }, this.scene);
      staff.position.set(-2.4, 0.5 + 5, 0);
      staff.material = mats.sculptureGold;
      staff.parent = parent;
      staff.metadata = meta;
      const star = BABYLON.MeshBuilder.CreateSphere(`wandStar_${meta.id}`, {
        diameter: 2.6,
        segments: 8
      }, this.scene);
      star.position.set(-2.4, 11.4, 0);
      star.material = mats.padTouchGenitals;
      star.parent = parent;
      star.metadata = meta;
      const orbit = BABYLON.MeshBuilder.CreateTorus(`wandOrbit_${meta.id}`, {
        diameter: 3.6,
        thickness: 0.28,
        tessellation: 20
      }, this.scene);
      orbit.position.set(-2.4, 11.4, 0);
      orbit.rotation.x = 0.5;
      orbit.material = mats.sculptureGold;
      orbit.parent = parent;
      orbit.metadata = meta;
      this._build3DHourglass(parent, mats, meta, 2.8, 0.2);
    }
    /**
     * 11. Finger Dares: Scented Candle Votive & Golden Touch Hand with 3D Challenge Hourglass
     * @private
     */
    _build3DScentedCandleAndHand(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`candlePlinth_${meta.id}`, {
        diameter: 12,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`candlePlinthRim_${meta.id}`, {
        diameter: 11.8,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.pedestalGold;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const votive = BABYLON.MeshBuilder.CreateCylinder(`votiveGlass_${meta.id}`, {
        diameter: 4.4,
        height: 5.2,
        tessellation: 20
      }, this.scene);
      votive.position.set(-0.8, 0.48 + 2.6, -0.6);
      votive.material = mats.glass;
      votive.parent = parent;
      votive.metadata = meta;
      const wax = BABYLON.MeshBuilder.CreateCylinder(`votiveWax_${meta.id}`, {
        diameter: 3.8,
        height: 4.2,
        tessellation: 20
      }, this.scene);
      wax.position.set(-0.8, 0.48 + 2.1, -0.6);
      wax.material = mats.candleWax;
      wax.parent = parent;
      wax.metadata = meta;
      const flame = BABYLON.MeshBuilder.CreateSphere(`votiveFlame_${meta.id}`, {
        diameter: 1.2,
        segments: 12
      }, this.scene);
      flame.position.set(-0.8, 0.48 + 4.9, -0.6);
      flame.material = mats.candleFlame;
      flame.parent = parent;
      flame.metadata = meta;
      const hand = BABYLON.MeshBuilder.CreateBox(`touchHand_${meta.id}`, {
        width: 3,
        height: 1.6,
        depth: 2.2
      }, this.scene);
      hand.position.set(-2, 3.6, 1.4);
      hand.material = mats.sculptureGold;
      hand.parent = parent;
      hand.metadata = meta;
      this._build3DHourglass(parent, mats, meta, 2.9, 0.5);
    }
    /**
     * 12. Intercourse / High Heat Dares: Intertwined Golden Love Rings & Passion Flames
     * @private
     */
    _build3DPassionateFlames(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`flamePlinth_${meta.id}`, {
        diameter: 12,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.pedestalObsidian;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`flamePlinthRim_${meta.id}`, {
        diameter: 11.8,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.ribbonScarlet;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const ring1 = BABYLON.MeshBuilder.CreateTorus(`loveRing1_${meta.id}`, {
        diameter: 4.2,
        thickness: 0.48,
        tessellation: 24
      }, this.scene);
      ring1.position.set(-1.2, 3, 0);
      ring1.rotation.y = 0.35;
      ring1.material = mats.sculptureGold;
      ring1.parent = parent;
      ring1.metadata = meta;
      const ring2 = BABYLON.MeshBuilder.CreateTorus(`loveRing2_${meta.id}`, {
        diameter: 4.2,
        thickness: 0.48,
        tessellation: 24
      }, this.scene);
      ring2.position.set(1.2, 3, 0);
      ring2.rotation.y = -0.35;
      ring2.material = mats.sculptureGold;
      ring2.parent = parent;
      ring2.metadata = meta;
      const flameCore = BABYLON.MeshBuilder.CreateCylinder(`flameCore_${meta.id}`, {
        diameterBottom: 2.6,
        diameterTop: 0.2,
        height: 8.5,
        tessellation: 16
      }, this.scene);
      flameCore.position.set(0, 8, 0);
      flameCore.material = mats.candleFlame;
      flameCore.parent = parent;
      flameCore.metadata = meta;
      const flameOuter = BABYLON.MeshBuilder.CreateCylinder(`flameOuter_${meta.id}`, {
        diameterBottom: 3.4,
        diameterTop: 0.3,
        height: 6.2,
        tessellation: 16
      }, this.scene);
      flameOuter.position.set(0, 6.8, 0);
      flameOuter.material = mats.sandGold;
      flameOuter.parent = parent;
      flameOuter.metadata = meta;
      this._build3DHourglass(parent, mats, meta, 3.2, 0.8);
    }
    /**
     * 13. Anus Dares: Sculpted Blush Velvet Peach on Satin Cushion with 3D Challenge Hourglass
     * @private
     */
    _build3DVelvetPeach(parent, mats, meta) {
      const BABYLON = this.BABYLON;
      const plinth = BABYLON.MeshBuilder.CreateCylinder(`peachPlinth_${meta.id}`, {
        diameter: 12,
        height: 0.5,
        tessellation: 28
      }, this.scene);
      plinth.position.set(0, 0.25, 0);
      plinth.material = mats.velvetPurple;
      plinth.parent = parent;
      plinth.metadata = meta;
      const plinthRim = BABYLON.MeshBuilder.CreateTorus(`peachPlinthRim_${meta.id}`, {
        diameter: 11.8,
        thickness: 0.25,
        tessellation: 28
      }, this.scene);
      plinthRim.position.set(0, 0.48, 0);
      plinthRim.material = mats.pedestalSilver;
      plinthRim.parent = parent;
      plinthRim.metadata = meta;
      const cushion = BABYLON.MeshBuilder.CreateCylinder(`peachCushion_${meta.id}`, {
        diameter: 6.8,
        height: 1.4,
        tessellation: 24
      }, this.scene);
      cushion.position.set(-1.8, 0.48 + 0.7, 0);
      cushion.material = mats.velvetPink;
      cushion.parent = parent;
      cushion.metadata = meta;
      const cheekL = BABYLON.MeshBuilder.CreateSphere(`cheekL_${meta.id}`, {
        diameter: 3.4,
        segments: 16
      }, this.scene);
      cheekL.position.set(-2.5, 3.4, 0);
      cheekL.material = mats.peachBlush;
      cheekL.parent = parent;
      cheekL.metadata = meta;
      const cheekR = BABYLON.MeshBuilder.CreateSphere(`cheekR_${meta.id}`, {
        diameter: 3.4,
        segments: 16
      }, this.scene);
      cheekR.position.set(-1.1, 3.4, 0);
      cheekR.material = mats.peachBlush;
      cheekR.parent = parent;
      cheekR.metadata = meta;
      const stem = BABYLON.MeshBuilder.CreateCylinder(`peachStem_${meta.id}`, {
        diameter: 0.35,
        height: 1.8,
        tessellation: 12
      }, this.scene);
      stem.position.set(-1.8, 5.2, 0);
      stem.material = mats.leafGreen;
      stem.parent = parent;
      stem.metadata = meta;
      this._build3DHourglass(parent, mats, meta, 2.9, 0.4);
    }
    /**
     * Handles user clicks on 3D obstacle markers to display interactive fancy tooltips.
     * @private
     */
    _handleBoard3DClick(e) {
      if (!this.scene) return;
      const pick = this.scene.pick(this.scene.pointerX, this.scene.pointerY, (m) => Boolean(m.metadata && m.metadata.obstacle));
      if (pick && pick.hit && pick.pickedMesh && pick.pickedMesh.metadata) {
        const meta = pick.pickedMesh.metadata;
        const fakeEl = {
          id: pick.pickedMesh.name || "",
          dataset: { ...meta, hole: String(meta.hole || "") },
          closest: (selector) => {
            if (typeof selector !== "string") return null;
            if (selector.includes("data-obstacle") && meta.obstacle) {
              return fakeEl;
            }
            if (selector.includes("data-hole") && meta.hole !== void 0) {
              return fakeEl;
            }
            if (selector.includes("peg") && meta.pegWho) {
              return fakeEl;
            }
            return null;
          }
        };
        const boardRenderer = typeof window !== "undefined" && window.CrazyCribbage?.BoardRenderer ? window.CrazyCribbage.BoardRenderer : null;
        if (boardRenderer) {
          const liveCtx = typeof window.getBoardTooltipContext === "function" ? window.getBoardTooltipContext() : boardRenderer.getBoardTooltipContext ? boardRenderer.getBoardTooltipContext({ settings: this.settings }) : { settings: this.settings };
          const data = boardRenderer.getBoardTooltipData(fakeEl, liveCtx);
          if (data && typeof boardRenderer.showFancyTooltip === "function") {
            boardRenderer.showFancyTooltip(data, e.clientX, e.clientY);
          }
        }
      }
    }
    /**
     * Calculates proportional peg dimensions derived from the board's hole spacing
     * to guarantee the peg shank snugly fills the hole aperture.
     * @param {string} [role='front']
     * @returns {{ spacing: number, radiusBottom: number, radiusTop: number, height: number, capDiameter: number, shankDepth: number }}
     */
    getPegDimensions(role = "front") {
      const isFront = role === "front";
      let spacing = 0;
      if (typeof this.boardConfig?.holeSpacing === "number" && this.boardConfig.holeSpacing > 0) {
        spacing = this.boardConfig.holeSpacing;
      }
      if (!spacing && typeof this.holeLookup === "function") {
        const distances = [];
        const track = this.activeTracks[0] || "p1";
        const sampleLimit = Math.min(35, this.targetHoles || 120);
        for (let h = 1; h < sampleLimit; h++) {
          const p0 = this.getHoleCoords(track, h);
          const p1 = this.getHoleCoords(track, h + 1);
          if (p0 && p1) {
            const dist2 = Math.hypot(p1.x - p0.x, p1.z - p0.z);
            if (dist2 > 0.1 && dist2 < 40) {
              distances.push(dist2);
            }
          }
        }
        if (distances.length > 0) {
          const bins = /* @__PURE__ */ new Map();
          for (const d of distances) {
            const key = Math.round(d * 2) / 2;
            bins.set(key, (bins.get(key) || 0) + 1);
          }
          let maxCount = 0;
          let bestBin = null;
          for (const [bin, count] of bins.entries()) {
            if (count > maxCount) {
              maxCount = count;
              bestBin = bin;
            }
          }
          if (bestBin !== null) {
            const inBin = distances.filter((d) => Math.abs(d - bestBin) <= 0.6);
            spacing = inBin.reduce((sum, v) => sum + v, 0) / inBin.length;
          } else {
            distances.sort((a, b) => a - b);
            spacing = distances[Math.floor(distances.length / 2)];
          }
        }
      }
      if (!spacing && this.boardBounds) {
        spacing = Math.max(3, this.boardBounds.size.x / 36);
      }
      if (!spacing) spacing = 7.75;
      const scale = typeof this.boardConfig?.pegScale === "number" && this.boardConfig.pegScale > 0 ? this.boardConfig.pegScale : 1;
      const radiusBottom = spacing * 0.2 * scale;
      const radiusTop = spacing * 0.24 * scale;
      const height = spacing * (isFront ? 1.75 : 1.45) * scale;
      const capDiameter = radiusTop * 2.15;
      const shankDepth = spacing * 0.24 * scale;
      return { spacing, radiusBottom, radiusTop, height, capDiameter, shankDepth };
    }
    /**
     * Creates an authentic 3D tapered metallic peg mesh in Babylon.js that fills the hole.
     */
    /**
     * Creates an authentic 3D tapered metallic peg mesh in Babylon.js that fills the hole,
     * wrapped with custom avatar body and medallion textures when avatar mode is active.
     */
    createPegMesh(who, role) {
      const BABYLON = this.BABYLON;
      const isFront = role === "front";
      const dims = this.getPegDimensions(role);
      const { radiusBottom, radiusTop, height, capDiameter, shankDepth } = dims;
      const shank = BABYLON.MeshBuilder.CreateCylinder(`pegShank_${who}_${role}`, {
        height: shankDepth,
        diameterTop: radiusBottom * 2,
        diameterBottom: radiusBottom * 1.85,
        tessellation: 24
      }, this.scene);
      shank.position.y = -shankDepth / 2;
      const body = BABYLON.MeshBuilder.CreateCylinder(`pegBody_${who}_${role}`, {
        height,
        diameterTop: radiusTop * 2,
        diameterBottom: radiusBottom * 2,
        tessellation: 24
      }, this.scene);
      body.position.y = height / 2;
      const baseMetallicMat = this.createPegMaterial(who, role);
      const isWrapping = this.isAvatarWrappingActive(who);
      shank.material = baseMetallicMat;
      body.material = isWrapping ? this.getOrCreateAvatarBodyWrapMaterial(who, role) : baseMetallicMat;
      const pegStyle = this.settings && this.settings.pegStyle || this.pegStyle || "classic";
      const headMeshes = this.createPegHeadMeshes(pegStyle, who, role, dims, baseMetallicMat);
      let peg = null;
      if (typeof BABYLON.Mesh?.MergeMeshes === "function") {
        peg = BABYLON.Mesh.MergeMeshes([shank, body, ...headMeshes], true, true, void 0, false, true);
      }
      if (!peg) {
        peg = shank;
      }
      peg.name = `peg_${who}_${role}`;
      peg.receiveShadows = true;
      if (this.shadowGenerator) this.shadowGenerator.addShadowCaster(peg);
      if (!isWrapping && pegStyle === "classic") {
        peg.material = baseMetallicMat;
      }
      return peg;
    }
    /**
     * Retrieves active peg style.
     * @returns {'classic'|'crown'|'skull'|'beermug'|'rivet'|'crystal'}
     */
    getPegStyle() {
      return this.settings && this.settings.pegStyle || this.pegStyle || "classic";
    }
    /**
     * Updates peg head style in real-time and recreates peg meshes across all active tracks.
     * @param {string} style - 'classic' | 'crown' | 'skull' | 'beermug' | 'rivet' | 'crystal'
     */
    setPegStyle(style) {
      if (!style) return;
      this.pegStyle = style;
      if (this.settings) this.settings.pegStyle = style;
      if (typeof localStorage !== "undefined") {
        try {
          localStorage.setItem("cc_board_3d_peg_style", style);
        } catch (_) {
        }
      }
      const domSel = typeof document !== "undefined" ? document.getElementById("optPegStyle") : null;
      if (domSel && domSel.value !== style) {
        domSel.value = style;
      }
      this.pegMeshes.forEach((mesh) => {
        try {
          mesh.dispose(false, true);
        } catch (_) {
        }
      });
      this.pegMeshes.clear();
      for (const who of this.activeTracks) {
        const st = this.pegState[who] || { front: 0, rear: 0 };
        for (const role of ["rear", "front"]) {
          const pegMesh = this.createPegMesh(who, role);
          if (this.boardRoot) {
            pegMesh.parent = this.boardRoot;
          }
          this.pegMeshes.set(`${who}_${role}`, pegMesh);
          const hole = role === "front" ? st.front : st.rear;
          const pt = this.getHoleCoords(who, hole);
          if (pt) pegMesh.position.set(pt.x, pt.y, pt.z);
        }
      }
      this.updatePegStyleToolbarUI();
    }
    /**
     * Synchronizes active peg style state with DOM selector or toolbar if present.
     */
    updatePegStyleToolbarUI() {
      const domSel = typeof document !== "undefined" ? document.getElementById("optPegStyle") : null;
      if (domSel && this.pegStyle && domSel.value !== this.pegStyle) {
        domSel.value = this.pegStyle;
      }
    }
    /**
     * Constructs custom 3D sculpted peg heads (Royal Crown, Pirate Skull, Beer Mug, Rivet, Neon Crystal, Classic).
     * @param {string} style
     * @param {string} who
     * @param {string} role
     * @param {Object} dims
     * @param {BABYLON.PBRMaterial} baseMetallicMat
     * @returns {BABYLON.Mesh[]} Array of submeshes to merge into the peg
     */
    createPegHeadMeshes(style, who, role, dims, baseMetallicMat) {
      const BABYLON = this.BABYLON;
      const { capDiameter, height } = dims;
      const isWrapping = this.isAvatarWrappingActive(who);
      if (style === "crown") {
        const crownBaseH = capDiameter * 0.28;
        const crownBase = BABYLON.MeshBuilder.CreateCylinder(`pegHeadBase_${who}_${role}`, {
          height: crownBaseH,
          diameterTop: capDiameter * 1.15,
          diameterBottom: capDiameter * 0.95,
          tessellation: 24
        }, this.scene);
        crownBase.position.y = height + crownBaseH / 2;
        crownBase.material = baseMetallicMat;
        const crownParts = [crownBase];
        const peakCount = 5;
        const peakR = capDiameter * 0.52;
        for (let i = 0; i < peakCount; i++) {
          const angle = i * 2 * Math.PI / peakCount;
          const px = Math.cos(angle) * peakR;
          const pz = Math.sin(angle) * peakR;
          const peak = BABYLON.MeshBuilder.CreateCylinder(`pegPeak_${who}_${role}_${i}`, {
            height: capDiameter * 0.55,
            diameterTop: 0.1,
            diameterBottom: capDiameter * 0.28,
            tessellation: 12
          }, this.scene);
          peak.position.set(px, height + crownBaseH + capDiameter * 0.24, pz);
          if (!peak.rotation && BABYLON.Vector3) peak.rotation = new BABYLON.Vector3(0, 0, 0);
          if (peak.rotation) {
            peak.rotation.z = -Math.cos(angle) * 0.15;
            peak.rotation.x = Math.sin(angle) * 0.15;
          }
          peak.material = baseMetallicMat;
          crownParts.push(peak);
          const gem = BABYLON.MeshBuilder.CreateSphere(`pegGem_${who}_${role}_${i}`, {
            diameter: capDiameter * 0.2,
            segments: 10
          }, this.scene);
          gem.position.set(px * 1.05, height + crownBaseH + capDiameter * 0.52, pz * 1.05);
          const gemMat = new BABYLON.PBRMaterial(`matGem_${who}_${role}_${i}`, this.scene);
          const isRed = i % 2 === 0;
          gemMat.albedoColor = isRed ? new BABYLON.Color3(0.9, 0.1, 0.2) : new BABYLON.Color3(0.1, 0.8, 0.9);
          gemMat.emissiveColor = gemMat.albedoColor.scale(0.5);
          gemMat.metallic = 0.4;
          gemMat.roughness = 0.15;
          gem.material = gemMat;
          crownParts.push(gem);
        }
        const dome = BABYLON.MeshBuilder.CreateSphere(`pegCrownDome_${who}_${role}`, {
          diameter: capDiameter * 0.85,
          segments: 16
        }, this.scene);
        dome.position.y = height + crownBaseH * 0.7;
        const domeMat = new BABYLON.PBRMaterial(`matCrownDome_${who}_${role}`, this.scene);
        domeMat.albedoColor = new BABYLON.Color3(0.6, 0.08, 0.12);
        domeMat.roughness = 0.7;
        dome.material = domeMat;
        crownParts.push(dome);
        return crownParts;
      }
      if (style === "skull") {
        const cranium = BABYLON.MeshBuilder.CreateSphere(`pegSkullDome_${who}_${role}`, {
          diameter: capDiameter * 1.05,
          segments: 16
        }, this.scene);
        cranium.position.set(0, height + capDiameter * 0.55, 0);
        cranium.scaling.set(1, 1.15, 1.05);
        const jaw = BABYLON.MeshBuilder.CreateBox(`pegSkullJaw_${who}_${role}`, {
          width: capDiameter * 0.62,
          height: capDiameter * 0.38,
          depth: capDiameter * 0.58
        }, this.scene);
        jaw.position.set(0, height + capDiameter * 0.2, capDiameter * 0.12);
        const skullMat = new BABYLON.PBRMaterial(`matSkull_${who}_${role}`, this.scene);
        skullMat.albedoColor = new BABYLON.Color3(0.92, 0.9, 0.85);
        skullMat.roughness = 0.45;
        skullMat.metallic = 0.25;
        cranium.material = skullMat;
        jaw.material = skullMat;
        const eyeL = BABYLON.MeshBuilder.CreateSphere(`pegEyeL_${who}_${role}`, { diameter: capDiameter * 0.26, segments: 8 }, this.scene);
        eyeL.position.set(-capDiameter * 0.24, height + capDiameter * 0.52, capDiameter * 0.48);
        const eyeR = BABYLON.MeshBuilder.CreateSphere(`pegEyeR_${who}_${role}`, { diameter: capDiameter * 0.26, segments: 8 }, this.scene);
        eyeR.position.set(capDiameter * 0.24, height + capDiameter * 0.52, capDiameter * 0.48);
        const socketMat = new BABYLON.PBRMaterial(`matEyeSocket_${who}_${role}`, this.scene);
        socketMat.albedoColor = new BABYLON.Color3(0.05, 0.05, 0.06);
        socketMat.roughness = 0.9;
        eyeL.material = socketMat;
        eyeR.material = socketMat;
        return [cranium, jaw, eyeL, eyeR];
      }
      if (style === "beermug") {
        const mugH = capDiameter * 1.1;
        const mugGlass = BABYLON.MeshBuilder.CreateCylinder(`pegMugGlass_${who}_${role}`, {
          height: mugH,
          diameter: capDiameter * 0.95,
          tessellation: 20
        }, this.scene);
        mugGlass.position.y = height + mugH / 2;
        const glassMat = new BABYLON.PBRMaterial(`matMugGlass_${who}_${role}`, this.scene);
        glassMat.albedoColor = new BABYLON.Color3(0.9, 0.95, 1);
        glassMat.alpha = 0.45;
        glassMat.roughness = 0.12;
        glassMat.metallic = 0.05;
        mugGlass.material = glassMat;
        const beerLiquid = BABYLON.MeshBuilder.CreateCylinder(`pegBeerLiq_${who}_${role}`, {
          height: mugH * 0.78,
          diameter: capDiameter * 0.82,
          tessellation: 18
        }, this.scene);
        beerLiquid.position.y = height + mugH * 0.78 / 2 + 0.1;
        const beerMat = new BABYLON.PBRMaterial(`matBeerLiq_${who}_${role}`, this.scene);
        beerMat.albedoColor = new BABYLON.Color3(0.95, 0.65, 0.12);
        beerMat.emissiveColor = new BABYLON.Color3(0.4, 0.25, 0.02);
        beerMat.roughness = 0.2;
        beerLiquid.material = beerMat;
        const foam = BABYLON.MeshBuilder.CreateCylinder(`pegMugFoam_${who}_${role}`, {
          height: capDiameter * 0.26,
          diameter: capDiameter * 0.92,
          tessellation: 18
        }, this.scene);
        foam.position.y = height + mugH * 0.88;
        const foamMat = new BABYLON.PBRMaterial(`matFoam_${who}_${role}`, this.scene);
        foamMat.albedoColor = new BABYLON.Color3(0.98, 0.98, 0.95);
        foamMat.roughness = 0.85;
        foam.material = foamMat;
        const handle = BABYLON.MeshBuilder.CreateTorus(`pegMugHandle_${who}_${role}`, {
          diameter: capDiameter * 0.55,
          thickness: capDiameter * 0.14,
          tessellation: 16
        }, this.scene);
        handle.position.set(capDiameter * 0.52, height + mugH * 0.52, 0);
        if (!handle.rotation && BABYLON.Vector3) handle.rotation = new BABYLON.Vector3(0, 0, 0);
        if (handle.rotation) handle.rotation.z = Math.PI / 2;
        handle.material = glassMat;
        return [mugGlass, beerLiquid, foam, handle];
      }
      if (style === "rivet") {
        const boltH = capDiameter * 0.55;
        const hexBolt = BABYLON.MeshBuilder.CreateCylinder(`pegHexBolt_${who}_${role}`, {
          height: boltH,
          diameter: capDiameter * 1.18,
          tessellation: 6
        }, this.scene);
        hexBolt.position.y = height + boltH / 2;
        const boltDome = BABYLON.MeshBuilder.CreateCylinder(`pegBoltDome_${who}_${role}`, {
          height: boltH * 0.35,
          diameterTop: capDiameter * 0.85,
          diameterBottom: capDiameter * 1.15,
          tessellation: 20
        }, this.scene);
        boltDome.position.y = height + boltH + boltH * 0.35 / 2;
        const socketHole = BABYLON.MeshBuilder.CreateCylinder(`pegBoltSocket_${who}_${role}`, {
          height: 0.15,
          diameter: capDiameter * 0.44,
          tessellation: 6
        }, this.scene);
        socketHole.position.y = height + boltH + boltH * 0.35;
        const socketMat = new BABYLON.PBRMaterial(`matBoltSocket_${who}_${role}`, this.scene);
        socketMat.albedoColor = new BABYLON.Color3(0.08, 0.08, 0.1);
        socketHole.material = socketMat;
        hexBolt.material = baseMetallicMat;
        boltDome.material = baseMetallicMat;
        return [hexBolt, boltDome, socketHole];
      }
      if (style === "crystal") {
        const crystalH = capDiameter * 1.15;
        const topCone = BABYLON.MeshBuilder.CreateCylinder(`pegCrystTop_${who}_${role}`, {
          height: crystalH * 0.58,
          diameterTop: 0.1,
          diameterBottom: capDiameter * 1.08,
          tessellation: 8
        }, this.scene);
        topCone.position.y = height + crystalH * 0.58 / 2 + crystalH * 0.42;
        const botCone = BABYLON.MeshBuilder.CreateCylinder(`pegCrystBot_${who}_${role}`, {
          height: crystalH * 0.42,
          diameterTop: capDiameter * 1.08,
          diameterBottom: capDiameter * 0.55,
          tessellation: 8
        }, this.scene);
        botCone.position.y = height + crystalH * 0.42 / 2;
        const crystalMat = new BABYLON.PBRMaterial(`matCrystal_${who}_${role}`, this.scene);
        const isP1 = who === "p1" || who === "you" || who === "team1";
        const crystalCol = isP1 ? new BABYLON.Color3(0, 0.95, 0.9) : new BABYLON.Color3(1, 0.15, 0.55);
        crystalMat.albedoColor = crystalCol;
        crystalMat.emissiveColor = crystalCol.scale(0.55);
        crystalMat.metallic = 0.15;
        crystalMat.roughness = 0.12;
        crystalMat.alpha = 0.88;
        topCone.material = crystalMat;
        botCone.material = crystalMat;
        return [topCone, botCone];
      }
      const cap = BABYLON.MeshBuilder.CreateSphere(`pegCap_${who}_${role}`, {
        diameter: capDiameter,
        segments: 20
      }, this.scene);
      cap.position.y = height;
      const medallionH = capDiameter * 0.16;
      const medallion = BABYLON.MeshBuilder.CreateCylinder(`pegMedallion_${who}_${role}`, {
        height: medallionH,
        diameter: capDiameter * 1.04,
        tessellation: 28
      }, this.scene);
      medallion.position.y = height + capDiameter * 0.44;
      if (isWrapping) {
        cap.material = baseMetallicMat;
        medallion.material = this.getOrCreateAvatarMedallionMaterial(who, role);
      } else {
        cap.material = baseMetallicMat;
        medallion.material = baseMetallicMat;
      }
      return [cap, medallion];
    }
    /**
     * Checks whether custom avatar wrapping should be used on pegs instead of metallic skin override.
     * @param {string} who - Track identifier (p1, p2, etc.)
     * @returns {boolean}
     */
    isAvatarWrappingActive(who) {
      const skin = this.settings?.pegSkin;
      if (skin && skin !== "brass" && skin !== "classic" && skin !== "avatar" && skin !== "default") {
        return false;
      }
      return true;
    }
    /**
     * Resolves the avatar preset ID for a specific track.
     * @param {string} who - Track identifier (p1, p2, team1, etc.)
     * @returns {string}
     */
    getTrackAvatarId(who) {
      if (typeof window !== "undefined" && window.BoardRenderer?.getTrackAvatarId) {
        return window.BoardRenderer.getTrackAvatarId(who, this.settings);
      }
      const isP1 = who === "p1" || who === "you" || who === "team1";
      if (isP1) {
        const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
        return avMgr ? avMgr.getSelectedAvatarId() : "joker";
      }
      if (this.settings?.seats && Array.isArray(this.settings.seats)) {
        const s = this.settings.seats.find((x) => x && (x.id === who || who === "cpu" && x.id === "p2"));
        if (s && s.avatar) {
          if (s.avatar === "custom" && !isP1) {
            return "custom_" + s.id;
          }
          return s.avatar;
        }
      }
      if (who === "p2" || who === "cpu" || who === "team2") {
        const isVsHuman = Boolean(this.settings?.vsHuman || this.settings?.isHvH || this.settings?.opp === "human");
        if (isVsHuman) return "queen";
        const rawProf = this.settings?.optAiProfile || "shark";
        const avatarMap = {
          master: "king",
          maverick: "steampunk",
          regular: "velvet_fox",
          casual: "pint_master",
          rookie: "jack",
          gambler: "gambler",
          turtler: "turtler",
          shark: "shark"
        };
        if (avatarMap[rawProf]) return avatarMap[rawProf];
        const aiProfile = typeof window !== "undefined" && window.CribbageAI?.normalizeProfile ? window.CribbageAI.normalizeProfile(rawProf) : rawProf;
        return avatarMap[aiProfile] || "shark";
      }
      const multiplayerAvatars = {
        p3: "pint_master",
        p4: "steampunk",
        p5: "clash_helm",
        p6: "velvet_fox",
        p7: "cannon_commander",
        p8: "lightning_29",
        team3: "pint_master",
        team4: "steampunk"
      };
      return multiplayerAvatars[who] || "jack";
    }
    /**
     * Retrieves or creates a PBRMaterial textured with the avatar cylindrical body wrap.
     * @param {string} who
     * @param {string} role
     * @returns {BABYLON.PBRMaterial}
     */
    getOrCreateAvatarBodyWrapMaterial(who, role) {
      const key = `matPegBodyWrap_${who}_${role}`;
      if (this._avatarMaterials && this._avatarMaterials.has(key)) {
        return this._avatarMaterials.get(key);
      }
      const BABYLON = this.BABYLON;
      const mat = new BABYLON.PBRMaterial(key, this.scene);
      mat.metallic = 0.25;
      mat.roughness = 0.35;
      const avatarId = this.getTrackAvatarId(who);
      AvatarManager.createAvatarBodyWrapCanvas(avatarId, 512, 256).then((canvas) => {
        if (!canvas || this.isDestroyed || !this.scene || this.scene.isDisposed) return;
        const texKey = `texPegBody_${who}_${role}`;
        let dynTex = this._avatarTextures?.get(texKey);
        if (!dynTex || dynTex.isDisposed) {
          dynTex = new BABYLON.DynamicTexture(texKey, { width: canvas.width, height: canvas.height }, this.scene, true);
          if (this._avatarTextures) this._avatarTextures.set(texKey, dynTex);
        }
        const ctx = dynTex.getContext();
        ctx.drawImage(canvas, 0, 0);
        dynTex.update();
        mat.albedoTexture = dynTex;
      }).catch((err) => {
        console.warn("[BoardRenderer3D] Avatar body wrap texture error:", err);
      });
      if (this._avatarMaterials) this._avatarMaterials.set(key, mat);
      return mat;
    }
    /**
     * Retrieves or creates a PBRMaterial textured with the avatar coin medallion disc.
     * @param {string} who
     * @param {string} role
     * @returns {BABYLON.PBRMaterial}
     */
    getOrCreateAvatarMedallionMaterial(who, role) {
      const key = `matPegMedallion_${who}_${role}`;
      if (this._avatarMaterials && this._avatarMaterials.has(key)) {
        return this._avatarMaterials.get(key);
      }
      const BABYLON = this.BABYLON;
      const mat = new BABYLON.PBRMaterial(key, this.scene);
      mat.metallic = 0.45;
      mat.roughness = 0.22;
      const avatarId = this.getTrackAvatarId(who);
      AvatarManager.createAvatarMedallionCanvas(avatarId, 256).then((canvas) => {
        if (!canvas || this.isDestroyed || !this.scene || this.scene.isDisposed) return;
        const texKey = `texPegMed_${who}_${role}`;
        let dynTex = this._avatarTextures?.get(texKey);
        if (!dynTex || dynTex.isDisposed) {
          dynTex = new BABYLON.DynamicTexture(texKey, { width: canvas.width, height: canvas.height }, this.scene, true);
          if (this._avatarTextures) this._avatarTextures.set(texKey, dynTex);
        }
        const ctx = dynTex.getContext();
        ctx.drawImage(canvas, 0, 0);
        dynTex.update();
        mat.albedoTexture = dynTex;
      }).catch((err) => {
        console.warn("[BoardRenderer3D] Avatar medallion texture error:", err);
      });
      if (this._avatarMaterials) this._avatarMaterials.set(key, mat);
      return mat;
    }
    /**
     * Synchronizes 3D peg avatar textures in real-time when the player swaps their persona.
     */
    async updatePegAvatars() {
      if (this.isDestroyed || !this.scene || this.scene.isDisposed) return;
      for (const who of this.activeTracks) {
        if (!this.isAvatarWrappingActive(who)) continue;
        const avatarId = this.getTrackAvatarId(who);
        const [bodyCanvas, medCanvas] = await Promise.all([
          AvatarManager.createAvatarBodyWrapCanvas(avatarId, 512, 256),
          AvatarManager.createAvatarMedallionCanvas(avatarId, 256)
        ]);
        if (this.isDestroyed || !this.scene || this.scene.isDisposed) return;
        for (const role of ["front", "rear"]) {
          const bodyTexKey = `texPegBody_${who}_${role}`;
          let dynBody = this._avatarTextures?.get(bodyTexKey);
          if (dynBody && !dynBody.isDisposed && bodyCanvas) {
            const ctx = dynBody.getContext();
            ctx.clearRect(0, 0, bodyCanvas.width, bodyCanvas.height);
            ctx.drawImage(bodyCanvas, 0, 0);
            dynBody.update();
          }
          const medTexKey = `texPegMed_${who}_${role}`;
          let dynMed = this._avatarTextures?.get(medTexKey);
          if (dynMed && !dynMed.isDisposed && medCanvas) {
            const ctx = dynMed.getContext();
            ctx.clearRect(0, 0, medCanvas.width, medCanvas.height);
            ctx.drawImage(medCanvas, 0, 0);
            dynMed.update();
          }
        }
      }
    }
    /**
     * PBR Material generator for metallic peg finishes.
     */
    createPegMaterial(who, role) {
      const BABYLON = this.BABYLON;
      const skin = this.settings.pegSkin || "brass";
      const isP1 = who === "p1" || who === "team1" || who === "you";
      const isTeam2 = who === "p2" || who === "team2" || who === "cpu";
      const isTeam3 = who === "p3" || who === "team3" || who === "p5";
      const isTeam4 = who === "p4" || who === "team4" || who === "p6" || who === "p7" || who === "p8";
      const mat = new BABYLON.PBRMaterial(`matPeg_${who}_${skin}_${role}`, this.scene);
      if (isP1) {
        if (skin === "silver") {
          mat.albedoColor = new BABYLON.Color3(0.9, 0.92, 0.95);
          mat.metallic = 0.92;
          mat.roughness = 0.2;
        } else if (skin === "walnut") {
          mat.albedoColor = new BABYLON.Color3(0.4, 0.25, 0.14);
          mat.metallic = 0.05;
          mat.roughness = 0.55;
        } else if (skin === "cherry") {
          mat.albedoColor = new BABYLON.Color3(0.55, 0.12, 0.14);
          mat.metallic = 0.15;
          mat.roughness = 0.45;
        } else if (skin === "glow") {
          const glowCol = new BABYLON.Color3(0, 0.9, 1);
          mat.albedoColor = glowCol;
          mat.emissiveColor = glowCol.scale(0.45);
          mat.metallic = 0.2;
          mat.roughness = 0.2;
        } else {
          mat.albedoColor = new BABYLON.Color3(0.92, 0.72, 0.18);
          mat.metallic = 0.9;
          mat.roughness = 0.2;
        }
      } else if (isTeam2) {
        if (skin === "silver") {
          mat.albedoColor = new BABYLON.Color3(0.95, 0.35, 0.35);
          mat.metallic = 0.92;
          mat.roughness = 0.2;
        } else if (skin === "walnut") {
          mat.albedoColor = new BABYLON.Color3(0.18, 0.1, 0.05);
          mat.metallic = 0.05;
          mat.roughness = 0.55;
        } else if (skin === "cherry") {
          mat.albedoColor = new BABYLON.Color3(0.42, 0.1, 0.12);
          mat.metallic = 0.15;
          mat.roughness = 0.45;
        } else if (skin === "glow") {
          const glowCol = new BABYLON.Color3(1, 0.1, 0.4);
          mat.albedoColor = glowCol;
          mat.emissiveColor = glowCol.scale(0.45);
          mat.metallic = 0.2;
          mat.roughness = 0.2;
        } else {
          mat.albedoColor = new BABYLON.Color3(0.85, 0.2, 0.2);
          mat.metallic = 0.9;
          mat.roughness = 0.2;
        }
      } else if (isTeam3) {
        mat.albedoColor = new BABYLON.Color3(0.15, 0.65, 0.95);
        mat.metallic = 0.88;
        mat.roughness = 0.22;
      } else if (isTeam4) {
        mat.albedoColor = new BABYLON.Color3(0.72, 0.25, 0.92);
        mat.metallic = 0.88;
        mat.roughness = 0.22;
      } else {
        mat.albedoColor = new BABYLON.Color3(0.85, 0.2, 0.2);
        mat.metallic = 0.9;
        mat.roughness = 0.2;
      }
      if (mat.clearCoat) {
        mat.clearCoat.isEnabled = true;
        mat.clearCoat.intensity = skin === "walnut" && isP1 ? 0.3 : 0.7;
        mat.clearCoat.roughness = 0.12;
      }
      return mat;
    }
    /**
     * Retrieves 3D coordinates for a specific hole and player.
     */
    getHoleCoords(who, holeNum) {
      if (typeof this.holeLookup === "function") {
        const pt = this.holeLookup(who, holeNum);
        if (pt) return pt;
      }
      return { x: 0, y: 0.8, z: 0 };
    }
    /**
     * Checks whether a specific hole number is explicitly defined for a track in coordinate data.
     * @param {string} who - Track identifier (p1, p2, team1, etc.)
     * @param {number} holeNum - Hole index (e.g. -1 for secondary starting peg)
     * @returns {boolean}
     */
    hasHole(who, holeNum) {
      if (typeof this.holeLookup?.has === "function") {
        return this.holeLookup.has(who, holeNum);
      }
      const data = this.boardConfig?.coordinatesData || this.boardConfig?.holeData;
      if (data) {
        let resolvedWho = who;
        if (who === "you" || who === "player1" || who === "team1") resolvedWho = "p1";
        else if (who === "cpu" || who === "player2" || who === "team2") resolvedWho = "p2";
        else if (who === "player3" || who === "team3") resolvedWho = "p3";
        else if (who === "player4" || who === "team4") resolvedWho = "p4";
        if (Array.isArray(data)) {
          return data.some((pt) => {
            const track = pt.track || pt.who || "p1";
            const h = parseInt(pt.hole !== void 0 ? pt.hole : pt.index, 10);
            return (track === resolvedWho || track === "p1") && h === holeNum;
          });
        } else if (typeof data === "object") {
          const tracks = data.tracks || data;
          const trackPts = tracks[resolvedWho] || tracks["p1"];
          if (Array.isArray(trackPts)) {
            return trackPts.some((pt) => {
              const h = parseInt(pt.hole !== void 0 ? pt.hole : pt.index, 10);
              return h === holeNum;
            });
          }
        }
      }
      return false;
    }
    /**
     * Resolves the numeric score for a track from a score object,
     * accounting for alternate track identifiers (p1/you/team1, p2/cpu/team2, etc.).
     * @param {Object} scoresObj
     * @param {string} track
     * @returns {number}
     */
    getTrackScore(scoresObj, track) {
      if (!scoresObj) return 0;
      if (scoresObj[track] !== void 0) return Number(scoresObj[track]) || 0;
      let norm = track;
      if (track === "you" || track === "player1" || track === "team1") norm = "p1";
      else if (track === "cpu" || track === "player2" || track === "team2") norm = "p2";
      else if (track === "player3" || track === "team3") norm = "p3";
      else if (track === "player4" || track === "team4") norm = "p4";
      if (scoresObj[norm] !== void 0) return Number(scoresObj[norm]) || 0;
      if (norm === "p1") {
        if (scoresObj.you !== void 0) return Number(scoresObj.you) || 0;
        if (scoresObj.player1 !== void 0) return Number(scoresObj.player1) || 0;
        if (scoresObj.team1 !== void 0) return Number(scoresObj.team1) || 0;
      } else if (norm === "p2") {
        if (scoresObj.cpu !== void 0) return Number(scoresObj.cpu) || 0;
        if (scoresObj.player2 !== void 0) return Number(scoresObj.player2) || 0;
        if (scoresObj.team2 !== void 0) return Number(scoresObj.team2) || 0;
      } else if (norm === "p3") {
        if (scoresObj.player3 !== void 0) return Number(scoresObj.player3) || 0;
        if (scoresObj.team3 !== void 0) return Number(scoresObj.team3) || 0;
        if (scoresObj.team1 !== void 0) return Number(scoresObj.team1) || 0;
        if (scoresObj.p1 !== void 0) return Number(scoresObj.p1) || 0;
        if (scoresObj.you !== void 0) return Number(scoresObj.you) || 0;
      } else if (norm === "p4") {
        if (scoresObj.player4 !== void 0) return Number(scoresObj.player4) || 0;
        if (scoresObj.team4 !== void 0) return Number(scoresObj.team4) || 0;
        if (scoresObj.team2 !== void 0) return Number(scoresObj.team2) || 0;
        if (scoresObj.p2 !== void 0) return Number(scoresObj.p2) || 0;
        if (scoresObj.cpu !== void 0) return Number(scoresObj.cpu) || 0;
      }
      return 0;
    }
    /**
     * Synchronizes 3D peg positions with game score updates.
     * Animates a leaping parabolic arc for the moving front peg.
     */
    updatePegs(scores = {}, prevScores = {}, animate = true, scoringEvent = null) {
      if (this.seatManager && scores) {
        this.seatManager.updateScores(scores);
      }
      for (const who of this.activeTracks) {
        const hasMinusOne = this.hasHole(who, -1);
        const defaultRear = hasMinusOne ? -1 : 0;
        const frontScore = Math.min(this.targetHoles, this.getTrackScore(scores, who));
        const rawRearScore = Math.min(this.targetHoles, this.getTrackScore(prevScores, who));
        const rearScore = frontScore === 0 && hasMinusOne ? -1 : rawRearScore;
        const oldState = this.pegState[who] || { front: 0, rear: defaultRear };
        if (frontScore !== oldState.front) {
          const pegMesh = this.pegMeshes.get(`${who}_front`);
          const startPt = this.getHoleCoords(who, oldState.front);
          const endPt = this.getHoleCoords(who, frontScore);
          if (pegMesh && startPt && endPt) {
            const delta = Math.abs(frontScore - oldState.front);
            const is15 = delta === 2 && scoringEvent && /fifteen/i.test(scoringEvent.why || "");
            const is31 = scoringEvent && /thirty|31/i.test(scoringEvent.why || "");
            const isSpecial = delta >= 6 || is15 || is31;
            const scoringInfo = { is15, is31, isSpecial, delta, who };
            if (animate && frontScore !== oldState.front) {
              this.animatePegLeap(pegMesh, startPt, endPt, 450, scoringInfo);
            } else {
              pegMesh.position.set(endPt.x, endPt.y, endPt.z);
            }
          }
        }
        if (rearScore !== oldState.rear) {
          const pegMesh = this.pegMeshes.get(`${who}_rear`);
          const endPt = this.getHoleCoords(who, rearScore);
          if (pegMesh && endPt) {
            pegMesh.position.set(endPt.x, endPt.y, endPt.z);
          }
        }
        this.pegState[who] = { front: frontScore, rear: rearScore };
      }
      if (this.activePreset === "closeup") {
        this.setCameraPreset("closeup", true);
      }
    }
    /**
     * Animates a smooth 3D parabolic leap in Babylon coordinate space
     * emitting luminous particle trail sparks and hole socket landing ripples.
     */
    animatePegLeap(mesh, startPt, endPt, durationMs = 450, scoringInfo = null) {
      const startTime = performance.now();
      const dims = this.getPegDimensions("front");
      const horizDist = Math.hypot(endPt.x - startPt.x, endPt.z - startPt.z);
      const vertDelta = Math.abs((endPt && endPt.y || 0) - (startPt && startPt.y || 0));
      const baseApex = Math.max(dims.height * 0.9, Math.min(dims.height * 2.2, horizDist * 0.45));
      const leapHeight = vertDelta / 2 + baseApex;
      const trackColor = this.getTrackAccentColor(mesh?.name || "");
      const isSpecial = Boolean(scoringInfo?.isSpecial);
      let lastSparkTime = 0;
      const anim = {
        update: (now) => {
          const elapsed = now - startTime;
          const t = Math.min(1, elapsed / durationMs);
          const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          const x = startPt.x + (endPt.x - startPt.x) * ease;
          const z = startPt.z + (endPt.z - startPt.z) * ease;
          const arcY = leapHeight * 4 * t * (1 - t);
          const y = startPt.y + (endPt.y - startPt.y) * ease + arcY;
          mesh.position.set(x, y, z);
          if (elapsed - lastSparkTime > 32 && t < 0.95) {
            lastSparkTime = elapsed;
            this.emitLeapSpark(x, y + dims.height * 0.45, z, trackColor, isSpecial);
          }
          if (t >= 1) {
            this.emitLandingImpact(endPt, trackColor, isSpecial);
            return false;
          }
          return true;
        }
      };
      this.animatingPegs.push(anim);
    }
    /**
     * Emits a floating radiant spark quad during peg flight.
     */
    emitLeapSpark(x, y, z, color, isSpecial = false) {
      if (!this.scene || !this.BABYLON || !this.BABYLON.MeshBuilder || this.isDestroyed) return;
      try {
        const BABYLON = this.BABYLON;
        const size = isSpecial ? 0.85 : 0.55;
        const spark = BABYLON.MeshBuilder.CreatePlane(`spark_${Math.random()}`, { size }, this.scene);
        spark.position.set(x + (Math.random() - 0.5) * 0.3, y + (Math.random() - 0.5) * 0.3, z + (Math.random() - 0.5) * 0.3);
        spark.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        spark.isPickable = false;
        if (this.boardRoot) spark.parent = this.boardRoot;
        if (!this._sparkMaterials) this._sparkMaterials = /* @__PURE__ */ new Map();
        const colorKey = color && typeof color.toHexString === "function" ? color.toHexString() : `${color?.r}_${color?.g}_${color?.b}`;
        let mat = this._sparkMaterials.get(colorKey);
        if (!mat || mat.isDisposed) {
          mat = new BABYLON.PBRMaterial(`matSpark_${colorKey}`, this.scene);
          mat.albedoColor = color;
          mat.emissiveColor = color && typeof color.scale === "function" ? color.scale(1.2) : color;
          mat.roughness = 0.1;
          this._sparkMaterials.set(colorKey, mat);
        }
        spark.material = mat;
        const startNow = performance.now();
        const lifeMs = isSpecial ? 360 : 260;
        this.animatingPegs.push({
          update: (now) => {
            const el = now - startNow;
            const prog = Math.min(1, el / lifeMs);
            spark.scaling.setAll(Math.max(0.01, 1 - prog));
            spark.position.y += 0.04 * (1 - prog);
            if (prog >= 1) {
              try {
                spark.dispose(false, false);
              } catch (_) {
              }
              return false;
            }
            return true;
          }
        });
      } catch (_) {
      }
    }
    /**
     * Spawns an expanding surface ring ripple and outward spark spray when a peg lands.
     */
    emitLandingImpact(endPt, color, isSpecial = false) {
      if (!this.scene || !this.BABYLON || !this.BABYLON.MeshBuilder || this.isDestroyed) return;
      try {
        const BABYLON = this.BABYLON;
        const baseR = isSpecial ? 1.6 : 1.1;
        const ring = BABYLON.MeshBuilder.CreateDisc(`landingRing_${Math.random()}`, {
          radius: baseR,
          tessellation: 20
        }, this.scene);
        const surfaceY = endPt && endPt.y !== void 0 ? endPt.y : 0.8;
        ring.position.set(endPt.x, surfaceY + 0.06, endPt.z);
        ring.rotation.x = Math.PI / 2;
        ring.isPickable = false;
        if (this.boardRoot) ring.parent = this.boardRoot;
        if (!this._ringMaterials) this._ringMaterials = /* @__PURE__ */ new Map();
        const colorKey = color && typeof color.toHexString === "function" ? color.toHexString() : `${color?.r}_${color?.g}_${color?.b}`;
        let mat = this._ringMaterials.get(colorKey);
        if (!mat || mat.isDisposed) {
          mat = new BABYLON.PBRMaterial(`matRing_${colorKey}`, this.scene);
          mat.albedoColor = color;
          mat.emissiveColor = color && typeof color.scale === "function" ? color.scale(1.4) : color;
          mat.alpha = 0.85;
          this._ringMaterials.set(colorKey, mat);
        }
        ring.material = mat;
        const startNow = performance.now();
        const lifeMs = isSpecial ? 480 : 340;
        this.animatingPegs.push({
          update: (now) => {
            const el = now - startNow;
            const prog = Math.min(1, el / lifeMs);
            const scale = 1 + prog * (isSpecial ? 2.2 : 1.6);
            ring.scaling.set(scale, scale, scale);
            mat.alpha = Math.max(0, 0.85 * (1 - prog));
            if (prog >= 1) {
              try {
                ring.dispose(false, false);
              } catch (_) {
              }
              return false;
            }
            return true;
          }
        });
        if (isSpecial) {
          for (let i = 0; i < 6; i++) {
            const angle = i * Math.PI * 2 / 6;
            const dist2 = 1.2 + Math.random() * 0.8;
            this.emitLeapSpark(endPt.x + Math.cos(angle) * dist2, surfaceY + 0.6 + Math.random() * 0.8, endPt.z + Math.sin(angle) * dist2, color, false);
          }
        }
      } catch (_) {
      }
    }
    /**
     * Resolves the primary track accent color for particle sparks and rings.
     */
    getTrackAccentColor(meshName = "") {
      const BABYLON = this.BABYLON;
      if (!BABYLON || !BABYLON.Color3) {
        return { r: 1, g: 0.84, b: 0, scale: (x) => ({ r: x, g: 0.84 * x, b: 0 }) };
      }
      const n = String(meshName || "").toLowerCase();
      if (n.includes("p1") || n.includes("team1") || n.includes("you")) {
        return new BABYLON.Color3(1, 0.84, 0.1);
      }
      if (n.includes("p2") || n.includes("team2") || n.includes("cpu")) {
        return new BABYLON.Color3(0.95, 0.22, 0.22);
      }
      if (n.includes("p3") || n.includes("team3")) {
        return new BABYLON.Color3(0.15, 0.72, 1);
      }
      if (n.includes("p4") || n.includes("team4")) {
        return new BABYLON.Color3(0.78, 0.25, 0.95);
      }
      return new BABYLON.Color3(1, 0.85, 0.2);
    }
    /**
     * Triggers an automated dynamic cinematic slow-motion orbit around the target peg or hole
     * on major gameplay achievements (24+ point hands, 4-of-a-kind pegging, winning peg 121/481).
     * @param {Object} event
     * @param {'big_hand'|'four_of_a_kind'|'winning_peg'} [event.type]
     * @param {number} [event.score]
     * @param {string} [event.who]
     * @param {number} [event.hole]
     */
    triggerActionCam(event = {}) {
      const opt = this.settings?.optActionCam;
      if (opt !== "yes") return;
      if (this._isActionCamActive || !this.camera || this.isDestroyed || !this.scene) return;
      this._isActionCamActive = true;
      this._savedActionCamState = {
        target: this.camera.target.clone(),
        alpha: this.camera.alpha,
        beta: this.camera.beta,
        radius: this.camera.radius
      };
      const type = event.type || "big_hand";
      const who = event.who || "p1";
      let targetPt = null;
      let title = "ACTION REPLAY";
      if (type === "winning_peg") {
        const hole = event.hole || this.targetHoles || 121;
        targetPt = this.getHoleCoords(who, hole);
        title = `WINNING PEG \u2022 HOLE ${hole}!`;
      } else if (type === "four_of_a_kind") {
        const st = this.pegState[who] || { front: 0 };
        targetPt = this.getHoleCoords(who, st.front);
        title = "4-OF-A-KIND PEGGING \u2022 12 PTS!";
      } else {
        const score = event.score || 24;
        const st = this.pegState[who] || { front: 0 };
        targetPt = this.getHoleCoords(who, st.front);
        title = `${score}+ POINT MONSTER HAND!`;
      }
      if (!targetPt) {
        targetPt = { x: 0, y: 1, z: 0 };
      }
      this.showActionCamOverlay(title);
      const heroTarget = new this.BABYLON.Vector3(targetPt.x, targetPt.y + 1.2, targetPt.z);
      const heroRadius = Math.max(16, (this.fitRadius || 55) * 0.28);
      const heroBeta = Math.PI / 4.6;
      const heroAlpha = this.camera.alpha + 0.75;
      this.animateCameraTo({
        target: heroTarget,
        alpha: heroAlpha,
        beta: heroBeta,
        radius: heroRadius,
        durationMs: 2500
      });
      const sparkColor = this.getTrackAccentColor(who);
      this.emitLandingImpact(targetPt, sparkColor, true);
      if (this._actionCamTimer) clearTimeout(this._actionCamTimer);
      this._actionCamTimer = setTimeout(() => {
        this.cancelActionCam();
      }, 2800);
    }
    /**
     * Cancels the active Action Cam sequence and smoothly returns to the player's vantage point.
     */
    cancelActionCam() {
      if (!this._isActionCamActive) return;
      this._isActionCamActive = false;
      if (this._actionCamTimer) {
        clearTimeout(this._actionCamTimer);
        this._actionCamTimer = null;
      }
      this.hideActionCamOverlay();
      if (this._savedActionCamState && this.camera && !this.isDestroyed) {
        this.animateCameraTo({
          target: this._savedActionCamState.target,
          alpha: this._savedActionCamState.alpha,
          beta: this._savedActionCamState.beta,
          radius: this._savedActionCamState.radius,
          durationMs: 650
        });
        this._savedActionCamState = null;
      }
    }
    showActionCamOverlay(title) {
      if (!this.container || typeof document === "undefined") return;
      let overlay = this.container.querySelector(".action-cam-overlay");
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.className = "action-cam-overlay";
        this.container.appendChild(overlay);
      }
      overlay.innerHTML = `
      <div class="action-cam-badge">
        <span class="action-cam-rec">\u25CF REC</span>
        <span class="action-cam-label">ACTION CAM</span>
        <span class="action-cam-sep">|</span>
        <span class="action-cam-title">${title}</span>
      </div>
    `;
      overlay.classList.add("is-visible");
      this.actionCamOverlay = overlay;
    }
    hideActionCamOverlay() {
      if (this.actionCamOverlay) {
        this.actionCamOverlay.classList.remove("is-visible");
        setTimeout(() => {
          if (this.actionCamOverlay && !this._isActionCamActive) {
            try {
              this.actionCamOverlay.remove();
            } catch (_) {
            }
            this.actionCamOverlay = null;
          }
        }, 350);
      }
    }
    /**
     * Smoothly animates the camera to a target configuration.
     * @param {Object} options
     */
    animateCameraTo({ target, alpha, beta, radius, durationMs = 460 }) {
      if (!this.camera || this.isDestroyed) return;
      const startTarget = this.camera.target.clone();
      const endTarget = target ? target.clone() : startTarget;
      const startAlpha = this.camera.alpha;
      let endAlpha = alpha !== void 0 ? alpha : startAlpha;
      let deltaAlpha = (endAlpha - startAlpha) % (2 * Math.PI);
      if (deltaAlpha > Math.PI) deltaAlpha -= 2 * Math.PI;
      if (deltaAlpha < -Math.PI) deltaAlpha += 2 * Math.PI;
      endAlpha = startAlpha + deltaAlpha;
      const startBeta = this.camera.beta;
      const endBeta = beta !== void 0 ? beta : startBeta;
      const startRadius = this.camera.radius;
      const endRadius = radius !== void 0 ? radius : startRadius;
      const startTime = performance.now();
      const anim = {
        update: (now) => {
          const elapsed = now - startTime;
          const t = Math.min(1, elapsed / durationMs);
          const ease = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          this.camera.target.x = startTarget.x + (endTarget.x - startTarget.x) * ease;
          this.camera.target.y = startTarget.y + (endTarget.y - startTarget.y) * ease;
          this.camera.target.z = startTarget.z + (endTarget.z - startTarget.z) * ease;
          this.camera.alpha = startAlpha + (endAlpha - startAlpha) * ease;
          this.camera.beta = startBeta + (endBeta - startBeta) * ease;
          this.camera.radius = startRadius + (endRadius - startRadius) * ease;
          return t < 1;
        }
      };
      if (this._currentCameraAnim) {
        this.animatingPegs = this.animatingPegs.filter((a) => a !== this._currentCameraAnim);
      }
      this._currentCameraAnim = anim;
      this.animatingPegs.push(anim);
    }
    /**
     * Zooms camera in towards the 3D board.
     * @param {number} [stepPercent=25] Percentage to zoom in
     */
    zoomIn(stepPercent = 25) {
      if (!this.camera || this.isDestroyed) return;
      this._userHasAdjustedCamera = true;
      this.activePreset = null;
      this.updatePresetButtonsUI(null);
      const minRadius = this.camera.lowerRadiusLimit || (this.fitRadius ? this.fitRadius * 0.15 : 5);
      const factor = Math.max(0.1, 1 - stepPercent / 100);
      const targetRadius = Math.max(minRadius, this.camera.radius * factor);
      this.animateCameraTo({
        radius: targetRadius,
        durationMs: 220
      });
    }
    /**
     * Zooms camera out away from the 3D board.
     * @param {number} [stepPercent=25] Percentage to zoom out
     */
    zoomOut(stepPercent = 25) {
      if (!this.camera || this.isDestroyed) return;
      this._userHasAdjustedCamera = true;
      this.activePreset = null;
      this.updatePresetButtonsUI(null);
      const maxRadius = this.camera.upperRadiusLimit || (this.fitRadius ? this.fitRadius * 4.5 : 500);
      const factor = 1 + stepPercent / 100;
      const targetRadius = Math.min(maxRadius, this.camera.radius * factor);
      this.animateCameraTo({
        radius: targetRadius,
        durationMs: 220
      });
    }
    /**
     * Toggles Pan mode on/off. In Pan mode, primary pointer drag pans the board instead of orbiting.
     * @param {boolean} [enable] Explicit state, or toggles if omitted
     * @returns {boolean} New pan mode state
     */
    setPanMode(enable) {
      this.isPanMode = enable !== void 0 ? !!enable : !this.isPanMode;
      const ptr = this.camera?.inputs?.attached?.pointers;
      if (ptr) {
        if (this.isPanMode) {
          ptr.detachControl();
        } else {
          ptr.attachControl(this.canvas, true);
        }
      }
      if (this.canvas) {
        if (this.isPanMode) {
          this.canvas.classList.add("is-pan-mode");
        } else {
          this.canvas.classList.remove("is-pan-mode", "is-pan-grabbing");
        }
      }
      this.updatePanButtonUI();
      return this.isPanMode;
    }
    /**
     * Toggles Pan mode on/off.
     * @returns {boolean}
     */
    togglePanMode() {
      return this.setPanMode();
    }
    /**
     * Updates visual active state for the Pan Mode button in the toolbar.
     */
    updatePanButtonUI() {
      if (!this.presetsToolbar) return;
      const btn = this.presetsToolbar.querySelector('[data-action="panMode"]');
      if (btn) {
        if (this.isPanMode) {
          btn.classList.add("is-active");
          btn.setAttribute("aria-pressed", "true");
        } else {
          btn.classList.remove("is-active");
          btn.setAttribute("aria-pressed", "false");
        }
      }
    }
    /**
     * Pans the 3D board relative to current camera screen orientation.
     * @param {number} deltaX Screen horizontal offset (positive = right, negative = left)
     * @param {number} deltaY Screen vertical offset (positive = up, negative = down)
     * @param {number} [durationMs=180] Animation duration in ms (0 for instant)
     */
    pan(deltaX, deltaY, durationMs = 180) {
      if (this.boardRoot) {
        this.moveBoard(deltaX * 0.25, -deltaY * 0.25, durationMs > 0);
        return;
      }
      if (!this.camera || this.isDestroyed) return;
      this._userHasAdjustedCamera = true;
      this.activePreset = null;
      this.updatePresetButtonsUI(null);
      const invView = this.camera.getViewMatrix().clone().invert();
      const right = new this.BABYLON.Vector3(invView.m[0], invView.m[1], invView.m[2]).normalize();
      const up = new this.BABYLON.Vector3(invView.m[4], invView.m[5], invView.m[6]).normalize();
      const offset = right.scale(deltaX).add(up.scale(deltaY));
      const newTarget = this.camera.target.add(offset);
      if (durationMs > 0) {
        this.animateCameraTo({
          target: newTarget,
          durationMs
        });
      } else {
        this.camera.target.copyFrom(newTarget);
      }
    }
    /**
     * Directional pan helper: moves board left.
     * @param {number} [step]
     */
    panLeft(step) {
      const s = typeof step === "number" ? step : this.fitRadius ? this.fitRadius * 0.12 : 20;
      this.pan(-s, 0);
    }
    /**
     * Directional pan helper: moves board right.
     * @param {number} [step]
     */
    panRight(step) {
      const s = typeof step === "number" ? step : this.fitRadius ? this.fitRadius * 0.12 : 20;
      this.pan(s, 0);
    }
    /**
     * Directional pan helper: moves board up.
     * @param {number} [step]
     */
    panUp(step) {
      const s = typeof step === "number" ? step : this.fitRadius ? this.fitRadius * 0.12 : 20;
      this.pan(0, s);
    }
    /**
     * Directional pan helper: moves board down.
     * @param {number} [step]
     */
    panDown(step) {
      const s = typeof step === "number" ? step : this.fitRadius ? this.fitRadius * 0.12 : 20;
      this.pan(0, -s);
    }
    /**
     * Resets pan offset back to board center.
     * @param {number} [durationMs=260]
     */
    resetPan(durationMs = 260) {
      if (this.boardRoot) {
        this.resetBoardPosition(durationMs > 0);
      }
      const bounds = this.boardBounds || this.getBoardBounds();
      const center = bounds ? bounds.center : new this.BABYLON.Vector3(0, 0, 0);
      this.animateCameraTo({
        target: center,
        durationMs
      });
    }
    /**
     * Checks whether a picked mesh belongs to the cribbage board, its pegs, or its obstacles.
     * @param {BABYLON.AbstractMesh} mesh
     * @returns {boolean}
     */
    isBoardMesh(mesh) {
      if (!mesh) return false;
      if (this.boardRoot && mesh === this.boardRoot) return true;
      if (this.boardMeshes && this.boardMeshes.includes(mesh)) return true;
      let curr = mesh;
      while (curr) {
        if (this.boardRoot && curr === this.boardRoot) return true;
        if (curr.name) {
          if (curr.name === "board3DTableTop" || curr.name.startsWith("table") || curr.name.startsWith("chair") || curr.name.startsWith("card_") || curr.name.startsWith("avatarRoot_") || curr.name.startsWith("room3D")) {
            return false;
          }
        }
        curr = curr.parent;
      }
      return false;
    }
    /**
     * Sets the position of the cribbage board on the tabletop in the 3D room.
     * Clamps the position to prevent the board from falling off the table edges.
     * @param {number} x - Horizontal offset on the tabletop (left/right)
     * @param {number} z - Depth offset on the tabletop (forward/backward)
     * @param {boolean} [animate=false] - Whether to smoothly animate the translation
     */
    setBoardPosition(x, z, animate = false) {
      if (!this.boardRoot || this.isDestroyed) return;
      const dims = this.roomData?.dims;
      const tableW = dims?.tableW ?? (this.cardEngine?.tableW || 120);
      const tableD = dims?.tableD ?? (this.cardEngine?.tableD || 100);
      const bounds = this.getBoardBounds();
      const halfBoardW = bounds ? bounds.size.x / 2 : 24;
      const halfBoardD = bounds ? bounds.size.z / 2 : 14;
      const maxX = Math.max(12, tableW / 2 - halfBoardW - 3);
      const maxZ = Math.max(10, tableD / 2 - halfBoardD - 3);
      const clampedX = Math.max(-maxX, Math.min(maxX, x));
      const clampedZ = Math.max(-maxZ, Math.min(maxZ, z));
      if (animate && this.scene?.onBeforeRenderObservable) {
        const startX = this.boardRoot.position.x;
        const startZ = this.boardRoot.position.z;
        const startTime = performance.now();
        const dur = 220;
        const observer = this.scene.onBeforeRenderObservable.add(() => {
          const elapsed = performance.now() - startTime;
          const t = Math.min(1, elapsed / dur);
          const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          if (this.boardRoot) {
            this.boardRoot.position.x = startX + (clampedX - startX) * ease;
            this.boardRoot.position.z = startZ + (clampedZ - startZ) * ease;
          }
          if (t >= 1) {
            this.scene.onBeforeRenderObservable.remove(observer);
            this.boardBounds = this.getBoardBounds();
            if (this.cardEngine) {
              this.cardEngine.boardBounds = this.boardBounds;
            }
          }
        });
      } else {
        this.boardRoot.position.x = clampedX;
        this.boardRoot.position.z = clampedZ;
        this.boardBounds = this.getBoardBounds();
        if (this.cardEngine) {
          this.cardEngine.boardBounds = this.boardBounds;
        }
      }
    }
    /**
     * Moves the cribbage board relative to its current tabletop position.
     * @param {number} deltaX
     * @param {number} deltaZ
     * @param {boolean} [animate=true]
     */
    moveBoard(deltaX, deltaZ, animate = true) {
      if (!this.boardRoot) return;
      const targetX = this.boardRoot.position.x + deltaX;
      const targetZ = this.boardRoot.position.z + deltaZ;
      this.setBoardPosition(targetX, targetZ, animate);
    }
    /**
     * Rotates the cribbage board on the tabletop around its vertical Y axis.
     * @param {number} deltaRad - Angle in radians
     * @param {boolean} [animate=false]
     */
    rotateBoard(deltaRad, animate = false) {
      if (!this.boardRoot) return;
      this.setBoardRotation((this.boardRoot.rotation.y || 0) + deltaRad, animate);
    }
    /**
     * Sets the absolute Y rotation of the cribbage board.
     * @param {number} rad
     * @param {boolean} [animate=false]
     */
    setBoardRotation(rad, animate = false) {
      if (!this.boardRoot) return;
      if (this._boardRotObserver && this.scene?.onBeforeRenderObservable) {
        try {
          this.scene.onBeforeRenderObservable.remove(this._boardRotObserver);
        } catch (_) {
        }
        this._boardRotObserver = null;
      }
      if (animate && this.scene?.onBeforeRenderObservable) {
        const startRot = this.boardRoot.rotation.y || 0;
        const targetRot = rad;
        const startTime = performance.now();
        const dur = 180;
        const observer = this.scene.onBeforeRenderObservable.add(() => {
          const elapsed = performance.now() - startTime;
          const t = Math.min(1, elapsed / dur);
          const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          if (this.boardRoot) {
            this.boardRoot.rotation.y = startRot + (targetRot - startRot) * ease;
          }
          if (t >= 1) {
            if (this.scene?.onBeforeRenderObservable) {
              this.scene.onBeforeRenderObservable.remove(observer);
            }
            if (this._boardRotObserver === observer) {
              this._boardRotObserver = null;
            }
            if (this.boardRoot) {
              this.boardRoot.rotation.y = targetRot;
            }
            this.boardBounds = this.getBoardBounds();
            if (this.cardEngine) {
              this.cardEngine.boardBounds = this.boardBounds;
            }
          }
        });
        this._boardRotObserver = observer;
      } else {
        this.boardRoot.rotation.y = rad;
        this.boardBounds = this.getBoardBounds();
        if (this.cardEngine) {
          this.cardEngine.boardBounds = this.boardBounds;
        }
      }
    }
    /**
     * Resets the cribbage board to the center of the table (0, 0, 0) with 0 rotation.
     * @param {boolean} [animate=true]
     */
    resetBoardPosition(animate = true) {
      if (!this.boardRoot || this.isDestroyed) return;
      if (this._boardRotObserver && this.scene?.onBeforeRenderObservable) {
        try {
          this.scene.onBeforeRenderObservable.remove(this._boardRotObserver);
        } catch (_) {
        }
        this._boardRotObserver = null;
      }
      if (animate && this.scene?.onBeforeRenderObservable) {
        const startX = this.boardRoot.position.x;
        const startZ = this.boardRoot.position.z;
        const startRot = this.boardRoot.rotation.y;
        const startTime = performance.now();
        const dur = 260;
        const observer = this.scene.onBeforeRenderObservable.add(() => {
          const elapsed = performance.now() - startTime;
          const t = Math.min(1, elapsed / dur);
          const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          if (this.boardRoot) {
            this.boardRoot.position.x = startX * (1 - ease);
            this.boardRoot.position.z = startZ * (1 - ease);
            this.boardRoot.rotation.y = startRot * (1 - ease);
          }
          if (t >= 1) {
            this.scene.onBeforeRenderObservable.remove(observer);
            if (this.boardRoot) {
              this.boardRoot.position.set(0, 0, 0);
              this.boardRoot.rotation.y = 0;
            }
            this.boardBounds = this.getBoardBounds();
            if (this.cardEngine) {
              this.cardEngine.boardBounds = this.boardBounds;
            }
          }
        });
      } else {
        this.boardRoot.position.set(0, 0, 0);
        this.boardRoot.rotation.y = 0;
        this.boardBounds = this.getBoardBounds();
        if (this.cardEngine) {
          this.cardEngine.boardBounds = this.boardBounds;
        }
      }
    }
    /**
     * Retrieves the current position and orientation of the cribbage board.
     * @returns {{ x: number, y: number, z: number, rotationY: number }}
     */
    getBoardPosition() {
      if (!this.boardRoot) {
        return { x: 0, y: 0, z: 0, rotationY: 0, scale: this.boardScaleMultiplier || 1 };
      }
      return {
        x: Number(this.boardRoot.position.x.toFixed(2)),
        y: Number(this.boardRoot.position.y.toFixed(2)),
        z: Number(this.boardRoot.position.z.toFixed(2)),
        rotationY: Number(this.boardRoot.rotation.y.toFixed(3)),
        scale: Number((this.boardScaleMultiplier || 1).toFixed(2))
      };
    }
    /**
     * Sets the scale multiplier of the cribbage board in the 3D room.
     * Clamps between 0.20 (20% size) and 2.5 (250% size).
     * @param {number} scaleMultiplier
     * @param {boolean} [animate=false]
     */
    setBoardScale(scaleMultiplier, animate = false) {
      if (!this.boardRoot || this.isDestroyed) return;
      const clamped = Math.max(0.2, Math.min(2.5, Number(scaleMultiplier) || 1));
      if (animate && this.scene?.onBeforeRenderObservable) {
        const startScale = this.boardRoot.scaling.x || 1;
        const startTime = performance.now();
        const dur = 200;
        const observer = this.scene.onBeforeRenderObservable.add(() => {
          const elapsed = performance.now() - startTime;
          const t = Math.min(1, elapsed / dur);
          const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          const curr = startScale + (clamped - startScale) * ease;
          if (this.boardRoot) {
            this.boardRoot.scaling.set(curr, curr, curr);
          }
          if (t >= 1) {
            this.scene.onBeforeRenderObservable.remove(observer);
            this.boardScaleMultiplier = clamped;
            this.boardBounds = this.getBoardBounds();
            if (this.cardEngine) {
              this.cardEngine.boardBounds = this.boardBounds;
            }
            this.setBoardPosition(this.boardRoot.position.x, this.boardRoot.position.z, false);
            this.updateScaleToolbarUI();
          }
        });
      } else {
        this.boardRoot.scaling.set(clamped, clamped, clamped);
        this.boardScaleMultiplier = clamped;
        this.boardBounds = this.getBoardBounds();
        if (this.cardEngine) {
          this.cardEngine.boardBounds = this.boardBounds;
        }
        this.setBoardPosition(this.boardRoot.position.x, this.boardRoot.position.z, false);
        this.updateScaleToolbarUI();
      }
      try {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem("cc_board_3d_scale", clamped.toFixed(2));
        }
      } catch (_) {
      }
    }
    /**
     * Adjusts the cribbage board scale relative to its current size.
     * @param {number} deltaMultiplier
     * @param {boolean} [animate=true]
     */
    scaleBoard(deltaMultiplier, animate = true) {
      if (!this.boardRoot) return;
      this.setBoardScale((this.boardScaleMultiplier || 1) + deltaMultiplier, animate);
    }
    /**
     * Resets the cribbage board scale to standard 100% size (1.0).
     * @param {boolean} [animate=true]
     */
    resetBoardScale(animate = true) {
      this.setBoardScale(1, animate);
    }
    /**
     * Resets position, rotation, and size of the cribbage board to default tabletop state.
     * @param {boolean} [animate=true]
     */
    resetBoardTransform(animate = true) {
      this.resetBoardPosition(animate);
      this.resetBoardScale(animate);
    }
    /**
     * Retrieves the current scale multiplier of the cribbage board.
     * @returns {number}
     */
    getBoardScale() {
      return this.boardScaleMultiplier || 1;
    }
    /**
     * Synchronizes board scale controls in the toolbar if present.
     */
    updateScaleToolbarUI() {
      if (!this.presetsToolbar) return;
      const slider = this.presetsToolbar.querySelector(".slider-3d-scale");
      if (slider) {
        slider.value = String(Math.round((this.boardScaleMultiplier || 1) * 100));
      }
      const label = this.presetsToolbar.querySelector(".val-3d-scale");
      if (label) {
        label.textContent = `${Math.round((this.boardScaleMultiplier || 1) * 100)}%`;
      }
    }
    /**
     * Instantiates the 3D physical tabletop dealer button token with embossed brass/gold medallion.
     */
    createDealerButton3D() {
      if (!this.scene || !this.BABYLON || this.isDestroyed || this.dealerButtonMesh) return;
      const BABYLON = this.BABYLON;
      const button = BABYLON.MeshBuilder.CreateCylinder("dealerButton3D", {
        diameter: 7.6,
        height: 1.35,
        tessellation: 48
      }, this.scene);
      button.receiveShadows = true;
      if (this.shadowGenerator) {
        this.shadowGenerator.addShadowCaster(button);
      }
      const tex = new BABYLON.DynamicTexture("texDealerButton", { width: 512, height: 512 }, this.scene, true);
      const ctx = tex.getContext();
      if (ctx) {
        const w = 512;
        const h = 512;
        const cx = w / 2;
        const cy = h / 2;
        const bgGrad = ctx.createRadialGradient(cx, cy, 30, cx, cy, 250);
        bgGrad.addColorStop(0, "#fef9c3");
        bgGrad.addColorStop(0.65, "#fde047");
        bgGrad.addColorStop(0.9, "#f59e0b");
        bgGrad.addColorStop(1, "#92400e");
        ctx.fillStyle = bgGrad;
        ctx.beginPath();
        ctx.arc(cx, cy, 252, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = "#78350f";
        ctx.lineWidth = 14;
        ctx.beginPath();
        ctx.arc(cx, cy, 240, 0, Math.PI * 2);
        ctx.stroke();
        ctx.strokeStyle = "#fef08a";
        ctx.lineWidth = 6;
        ctx.beginPath();
        ctx.arc(cx, cy, 222, 0, Math.PI * 2);
        ctx.stroke();
        ctx.strokeStyle = "rgba(120, 53, 15, 0.45)";
        ctx.lineWidth = 4;
        ctx.beginPath();
        ctx.arc(cx, cy, 185, 0, Math.PI * 2);
        ctx.stroke();
        ctx.fillStyle = "#78350f";
        ctx.font = 'bold 36px "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("\u2605   \u2605   \u2605", cx, 88);
        ctx.fillText("\u2605   \u2605   \u2605", cx, h - 88);
        ctx.fillStyle = "#78350f";
        ctx.font = '900 84px "Segoe UI", Roboto, sans-serif';
        ctx.fillText("DEALER", cx, cy - 6);
        ctx.font = 'bold 32px "Segoe UI", Roboto, sans-serif';
        ctx.fillText("CRIBBAGE", cx, cy + 62);
        tex.update();
      }
      const mat = new BABYLON.PBRMaterial("matDealerButton", this.scene);
      mat.albedoTexture = tex;
      mat.metallic = 0.55;
      mat.roughness = 0.28;
      if (mat.clearCoat) {
        mat.clearCoat.isEnabled = true;
        mat.clearCoat.intensity = 0.8;
        mat.clearCoat.roughness = 0.15;
      }
      button.material = mat;
      button.isPickable = true;
      button.metadata = { dealerButton: true };
      this.dealerButtonMesh = button;
      this._dealerButtonMat = mat;
      this._dealerButtonTex = tex;
      const initialDealer = this.dealerSeat || "p1";
      const coords = this.getDealerButtonCoords(initialDealer);
      button.position.set(coords.x, coords.y, coords.z);
      button.rotation.y = coords.angle || 0;
    }
    /**
     * Computes tabletop surface coordinates for placing the 3D dealer button in front of a specific seat.
     * @param {string} seat - 'p1', 'p2', 'you', 'cpu', etc.
     * @returns {{ x: number, y: number, z: number, angle: number }}
     */
    getDealerButtonCoords(seat) {
      const normSeat = this.seatManager ? this.seatManager.normalizeSeatId(seat) : seat;
      let seatIdx = 0;
      if (normSeat && normSeat.startsWith("p")) {
        const parsed = parseInt(normSeat.slice(1), 10);
        if (!isNaN(parsed) && parsed >= 1) seatIdx = parsed - 1;
      }
      let angle = 0;
      const chairRoots = this.roomData?.chairRoots || this.seatManager?.chairRoots || [];
      if (chairRoots[seatIdx]?.rotation && typeof chairRoots[seatIdx].rotation.y === "number") {
        angle = chairRoots[seatIdx].rotation.y;
      } else {
        if (seatIdx === 0) angle = 0;
        else if (seatIdx === 1) angle = Math.PI;
        else if (seatIdx === 2) angle = 1.5 * Math.PI;
        else if (seatIdx === 3) angle = 0.5 * Math.PI;
      }
      const tableW = this.roomData?.dims?.tableW ?? (this.cardEngine?.tableW || 120);
      const tableD = this.roomData?.dims?.tableD ?? (this.cardEngine?.tableD || 100);
      const edgeOffset = 18;
      const posX = Math.sin(angle + 0.26) * (tableW / 2 - edgeOffset);
      const posZ = -Math.cos(angle + 0.26) * (tableD / 2 - edgeOffset);
      const surfaceY = this.roomData?.dims?.tableSurfaceY != null ? this.roomData.dims.tableSurfaceY : this.cardEngine?.tableSurfaceY ?? -0.88;
      const posY = surfaceY + 0.72;
      return { x: posX, y: posY, z: posZ, angle };
    }
    /**
     * Sets the active dealer in the 3D room, updating:
     * 1. The physical 3D tabletop dealer button with smooth gliding animation
     * 2. The seated player avatar 3D floating nameplate HUD badge
     * 3. The 3D in-game action HUD status pill
     * @param {string} dealerSeat - 'p1', 'p2', 'you', 'cpu', etc.
     * @param {boolean} [animate=true]
     */
    setDealer(dealerSeat, animate = true) {
      if (!dealerSeat) return;
      const prev = this.dealerSeat;
      const norm = this.seatManager ? this.seatManager.normalizeSeatId(dealerSeat) : dealerSeat;
      this.dealerSeat = norm;
      if (this.seatManager) {
        this.seatManager.setDealer(norm);
      }
      if (!this.dealerButtonMesh && (this.roomData || this.tableMesh || this.cardEngine) && typeof this.createDealerButton3D === "function") {
        this.createDealerButton3D();
      }
      if (this.dealerButtonMesh) {
        const coords = this.getDealerButtonCoords(norm);
        if (animate && prev && prev !== norm && this.scene?.onBeforeRenderObservable) {
          if (this._dealerButtonAnim) {
            this.scene.onBeforeRenderObservable.remove(this._dealerButtonAnim);
            this._dealerButtonAnim = null;
          }
          const startX = this.dealerButtonMesh.position.x;
          const startY = this.dealerButtonMesh.position.y;
          const startZ = this.dealerButtonMesh.position.z;
          const startAngle = this.dealerButtonMesh.rotation.y;
          const startTime = performance.now();
          const dur = 420;
          const obs = this.scene.onBeforeRenderObservable.add(() => {
            const elapsed = performance.now() - startTime;
            const t = Math.min(1, elapsed / dur);
            const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            if (this.dealerButtonMesh) {
              const x = startX + (coords.x - startX) * ease;
              const z = startZ + (coords.z - startZ) * ease;
              const hop = Math.sin(t * Math.PI) * 2.2;
              this.dealerButtonMesh.position.set(x, coords.y + hop, z);
              this.dealerButtonMesh.rotation.y = startAngle + (coords.angle - startAngle) * ease + t * Math.PI * 0.5;
            }
            if (t >= 1) {
              this.scene.onBeforeRenderObservable.remove(obs);
              if (this._dealerButtonAnim === obs) this._dealerButtonAnim = null;
              if (this.dealerButtonMesh) {
                this.dealerButtonMesh.position.set(coords.x, coords.y, coords.z);
                this.dealerButtonMesh.rotation.y = coords.angle || 0;
              }
            }
          });
          this._dealerButtonAnim = obs;
        } else {
          this.dealerButtonMesh.position.set(coords.x, coords.y, coords.z);
          this.dealerButtonMesh.rotation.y = coords.angle || 0;
        }
      }
    }
    /**
     * Retrieves the current dealer seat identifier.
     * @returns {string|null}
     */
    getDealer() {
      return this.dealerSeat;
    }
    /**
     * Cleans up and disposes the 3D dealer button mesh and textures.
     */
    clearDealerButton() {
      if (this._dealerButtonAnim && this.scene?.onBeforeRenderObservable) {
        try {
          this.scene.onBeforeRenderObservable.remove(this._dealerButtonAnim);
        } catch (_) {
        }
        this._dealerButtonAnim = null;
      }
      if (this._dealerButtonTex) {
        try {
          this._dealerButtonTex.dispose();
        } catch (_) {
        }
        this._dealerButtonTex = null;
      }
      if (this._dealerButtonMat) {
        try {
          this._dealerButtonMat.dispose();
        } catch (_) {
        }
        this._dealerButtonMat = null;
      }
      if (this.dealerButtonMesh) {
        try {
          this.dealerButtonMesh.dispose(false, true);
        } catch (_) {
        }
        this.dealerButtonMesh = null;
      }
    }
    /**
     * Camera Presets:
     * - 'overview': Full board overview with optimal framing
     * - 'closeup': Leading Peg Close-up focusing dynamically on current frontrunner
     * - 'finish': Homestretch and Finish Line view
     */
    setCameraPreset(presetName, isAutoFollow = false) {
      if (!this.camera) return;
      const bounds = this.getBoardBounds();
      const camDef = this.boardConfig?.cameraDefaults || {};
      if (presetName === "overview" || presetName === "perspective") {
        this.activePreset = "overview";
        this.updatePresetButtonsUI("overview");
        this._userHasAdjustedCamera = false;
        const defaultAlpha = camDef.alpha !== void 0 ? Number(camDef.alpha) : camDef.alphaDeg !== void 0 ? Number(camDef.alphaDeg) * Math.PI / 180 : -Math.PI / 2;
        const defaultBeta = camDef.beta !== void 0 ? Number(camDef.beta) : camDef.betaDeg !== void 0 ? Number(camDef.betaDeg) * Math.PI / 180 : Math.PI / 5.2;
        const center = bounds ? bounds.center : new this.BABYLON.Vector3(0, 0, 0);
        let fitRadius = 55;
        if (bounds) {
          const canvas = this.canvas || this.engine.getRenderingCanvas();
          const width = canvas && canvas.clientWidth > 0 ? canvas.clientWidth : this.viewBoxW;
          const height = canvas && canvas.clientHeight > 0 ? canvas.clientHeight : this.viewBoxH;
          if (width > 0 && height > 0) {
            const aspect = width / height;
            const fov = this.camera.fov || 0.8;
            const halfVFOV = fov / 2;
            const halfHFOV = Math.atan(Math.tan(halfVFOV) * aspect);
            const beta = defaultBeta;
            const alpha = defaultAlpha;
            const hasRoom = Boolean(this.roomData || this.tableMesh || this.cardEngine);
            const dims = this.roomData?.dims;
            const tableW = dims?.tableW ?? (this.cardEngine?.tableW || 120);
            const tableD = dims?.tableD ?? (this.cardEngine?.tableD || 100);
            let spanTargetX = bounds.size.x;
            let spanTargetZ = bounds.size.z;
            if (hasRoom && tableW && tableD) {
              spanTargetX = Math.max(bounds.size.x, tableW * 0.9);
              spanTargetZ = Math.max(bounds.size.z, tableD * 0.9);
            }
            const sizeX = Math.max(1, spanTargetX);
            const sizeY = Math.max(0.1, bounds.size.y);
            const sizeZ = Math.max(1, spanTargetZ);
            const horizSpan = Math.abs(sizeX * Math.sin(alpha)) + Math.abs(sizeZ * Math.cos(alpha));
            const depthSpan = Math.abs(sizeZ * Math.sin(alpha)) + Math.abs(sizeX * Math.cos(alpha));
            const vertSpan = Math.abs(depthSpan * Math.cos(beta)) + Math.abs(sizeY * Math.sin(beta));
            const distH = horizSpan / 2 / Math.tan(halfHFOV);
            const distV = vertSpan / 2 / Math.tan(halfVFOV);
            const padding = hasRoom ? 1.25 : 1.18;
            fitRadius = Math.max(distH, distV) * padding;
          }
        }
        this.animateCameraTo({
          target: center,
          alpha: defaultAlpha,
          beta: defaultBeta,
          radius: fitRadius,
          durationMs: 460
        });
      } else if (presetName === "top") {
        this.activePreset = "top";
        this.updatePresetButtonsUI(null);
        this._userHasAdjustedCamera = false;
        const center = bounds ? bounds.center : new this.BABYLON.Vector3(0, 0, 0);
        this.animateCameraTo({
          target: center,
          alpha: -Math.PI / 2,
          beta: 0.05,
          radius: this.camera.radius || 55,
          durationMs: 460
        });
      } else if (presetName === "closeup" || presetName === "follow") {
        this.activePreset = "closeup";
        this.updatePresetButtonsUI("closeup");
        this._userHasAdjustedCamera = false;
        let leaderTrack = this.activeTracks[0] || "p1";
        let maxScore = -1;
        for (const who of this.activeTracks) {
          const score = this.pegState[who] && this.pegState[who].front || 0;
          if (score > maxScore) {
            maxScore = score;
            leaderTrack = who;
          }
        }
        const leaderHole = Math.max(0, maxScore);
        const pt = this.getHoleCoords(leaderTrack, leaderHole);
        if (pt) {
          const maxDim = bounds ? Math.max(bounds.size.x, bounds.size.z) : 100;
          const targetRadius = Math.max(16, maxDim * 0.16);
          this.animateCameraTo({
            target: new this.BABYLON.Vector3(pt.x, pt.y + 1.2, pt.z),
            alpha: -Math.PI / 2.18,
            beta: Math.PI / 4.4,
            radius: targetRadius,
            durationMs: isAutoFollow ? 380 : 460
          });
        }
      } else if (presetName === "finish") {
        this.activePreset = "finish";
        this.updatePresetButtonsUI("finish");
        this._userHasAdjustedCamera = false;
        const finishHole = this.targetHoles || 121;
        let pt = this.getHoleCoords("p1", finishHole);
        if (!pt || pt.x === 0 && pt.z === 0) {
          pt = this.getHoleCoords("p1", finishHole - 1);
        }
        if (pt) {
          const maxDim = bounds ? Math.max(bounds.size.x, bounds.size.z) : 100;
          const targetRadius = Math.max(18, maxDim * 0.19);
          this.animateCameraTo({
            target: new this.BABYLON.Vector3(pt.x, pt.y + 1.2, pt.z),
            alpha: -Math.PI / 1.72,
            beta: Math.PI / 4.5,
            radius: targetRadius,
            durationMs: 460
          });
        }
      }
    }
    /**
     * Sets up the interactive game logo badge in the top-left corner of the 3D room container.
     * Clicking this logo invokes the quit match modal ('Return to Main Menu?'), consistent with
     * the 2D game header logo behavior, whether in windowed or fullscreen 3D mode.
     */
    setupTopLeftLogoUI() {
      if (!this.container) return;
      const existing = this.container.querySelector(".board-3d-logo-btn");
      if (existing) existing.remove();
      const LOGO_CONFIG = {
        crazy: {
          src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo_-_640_x_640.webp",
          alt: "Crazy Cribbage",
          title: "Crazy Cribbage"
        },
        clash: {
          src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-round-online-game-640x640.webp",
          alt: "Cribbage Clash",
          title: "Cribbage Clash"
        },
        pints: {
          src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-pints-and-pegs_640x640_f004d2b4-49df-4181-a6d2-11c7f9212645.webp",
          alt: "Pints and Pegs",
          title: "Pints & Pegs"
        },
        adult: {
          src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-skunked-and-stripped_-_640_x_640.webp?v=1791397387",
          alt: "Skunked and Stripped",
          title: "Skunked & Stripped"
        }
      };
      const getBrand = () => {
        if (typeof window !== "undefined") {
          if (typeof window.getAppBrand === "function") {
            const b = window.getAppBrand();
            if (b) return b;
          }
          if (window.currentLogoBrand) return window.currentLogoBrand;
          if (window.currentBrand) return window.currentBrand;
          if (window.settings && window.settings.brand) return window.settings.brand;
        }
        return "crazy";
      };
      const brand = getBrand();
      const config = LOGO_CONFIG[brand] || LOGO_CONFIG.crazy;
      const logoBtn = document.createElement("button");
      logoBtn.type = "button";
      logoBtn.className = "board-3d-logo-btn";
      logoBtn.setAttribute("aria-label", `Return to Main Menu (${config.title})`);
      logoBtn.setAttribute("title", "Return to Main Menu");
      const img = document.createElement("img");
      img.className = "board-3d-logo-img";
      img.src = config.src;
      img.alt = config.alt;
      img.width = 38;
      img.height = 38;
      img.decoding = "async";
      const text2 = document.createElement("span");
      text2.className = "board-3d-logo-text";
      text2.textContent = config.title;
      logoBtn.appendChild(img);
      logoBtn.appendChild(text2);
      logoBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (typeof window !== "undefined") {
          if (typeof window.returnToMenu === "function") {
            window.returnToMenu();
          } else if (window.crazyCribbageApp && typeof window.crazyCribbageApp.returnToMenu === "function") {
            window.crazyCribbageApp.returnToMenu();
          } else if (window.CrazyCribbage && window.CrazyCribbage.ModalManager && typeof window.CrazyCribbage.ModalManager.returnToMenu === "function") {
            window.CrazyCribbage.ModalManager.returnToMenu();
          }
        }
      });
      this.container.appendChild(logoBtn);
      this.logoBtn = logoBtn;
    }
    /**
     * Builds the interactive Camera Presets & Lighting Brightness toolbar overlay.
     */
    setupCameraPresetsUI() {
      if (!this.container) return;
      const existing = this.container.querySelector(".board-3d-cam-toolbar");
      if (existing) existing.remove();
      const toolbar = document.createElement("div");
      toolbar.className = "board-3d-cam-toolbar";
      toolbar.setAttribute("role", "toolbar");
      toolbar.setAttribute("aria-label", "3D Camera Presets and Lighting Controls");
      const camGroup = document.createElement("div");
      camGroup.className = "board-3d-cam-group";
      const presets = [
        {
          id: "overview",
          label: "Overview",
          title: "Full Board Overview",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/></svg>'
        }
        /*
        ,
        {
          id: 'closeup',
          label: 'Leading Peg',
          title: 'Leading Peg Close-up',
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><circle cx="11" cy="11" r="2.5" fill="currentColor"/></svg>'
        },
        {
          id: 'finish',
          label: 'Finish Line',
          title: 'Homestretch & Finish Line',
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>'
        }
        */
      ];
      presets.forEach(({ id, label: label2, title, icon }) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = `btn-3d-preset${id === (this.activePreset || "overview") ? " is-active" : ""}`;
        btn.setAttribute("data-preset", id);
        btn.setAttribute("title", title);
        btn.setAttribute("aria-label", title);
        btn.setAttribute("aria-pressed", id === (this.activePreset || "overview") ? "true" : "false");
        btn.innerHTML = `${icon}<span>${label2}</span>`;
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          this.setCameraPreset(id);
        });
        camGroup.appendChild(btn);
      });
      toolbar.appendChild(camGroup);
      const sepZoom = document.createElement("div");
      sepZoom.className = "board-3d-toolbar-sep";
      sepZoom.setAttribute("aria-hidden", "true");
      toolbar.appendChild(sepZoom);
      const navGroup = document.createElement("div");
      navGroup.className = "board-3d-zoom-group board-3d-cam-group";
      const navBtns = [
        {
          id: "panMode",
          //label: 'Move',
          label: "",
          title: "Move Board Mode (drag board across table, P or M)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="12" y1="2" x2="12" y2="22"/></svg>',
          action: () => this.togglePanMode(),
          isActive: () => !!this.isPanMode
        },
        {
          id: "centerBoard",
          //label: 'Center',
          label: "",
          title: "Center Board on Table (R)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/></svg>',
          action: () => this.resetBoardPosition(true)
        },
        {
          id: "rotateLeft",
          label: "",
          title: "Rotate Board Counter-Clockwise \u21BA (Shift+\u2190, Hold to spin)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><polyline points="3 3 3 8 8 8"/></svg>',
          action: () => this.rotateBoard(-Math.PI / 12, true),
          onHold: () => this.rotateBoard(-0.035, false)
        },
        {
          id: "rotateRight",
          label: "",
          title: "Rotate Board Clockwise \u21BB (Shift+\u2192, Hold to spin)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.85.99 6.57 2.6L21 8"/><polyline points="21 3 21 8 16 8"/></svg>',
          action: () => this.rotateBoard(Math.PI / 12, true),
          onHold: () => this.rotateBoard(0.035, false)
        },
        {
          id: "scaleDown",
          //label: '- Size',
          label: "",
          title: "Decrease Board Size ([ or Ctrl+Drag down)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="8" y1="12" x2="16" y2="12"/></svg>',
          action: () => this.scaleBoard(-0.05, true)
        },
        {
          id: "scaleUp",
          //label: '+ Size',
          label: "",
          title: "Increase Board Size (] or Ctrl+Drag up)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>',
          action: () => this.scaleBoard(0.05, true)
        },
        {
          id: "zoomIn",
          //label: 'In',
          label: "",
          title: "Zoom In (+)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>',
          action: () => this.zoomIn()
        },
        {
          id: "zoomOut",
          //label: 'Out',
          label: "",
          title: "Zoom Out (-)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>',
          action: () => this.zoomOut()
        },
        {
          id: "fullScreen",
          label: "",
          title: "Toggle Full Screen (F)",
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" class="icon-fs-expand"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" class="icon-fs-contract" style="display:none;"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/></svg>',
          action: () => this.toggleFullScreen(),
          isActive: () => this.isFullScreen()
        }
        /*
        {
          id: 'actionCam',
          label: 'Action Cam',
          title: 'Cinematic Action Cam Replay Orbit',
          icon: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>',
          action: () => this.triggerActionCam({ type: 'big_hand', score: 29 })
        }
        */
      ];
      navBtns.forEach(({ id, label: label2, title, icon, action, isActive, onHold }) => {
        const btn = document.createElement("button");
        btn.type = "button";
        const activeClass = isActive && isActive() ? " is-active" : "";
        btn.className = `btn-3d-preset btn-3d-nav btn-3d-${id}${activeClass}`;
        btn.setAttribute("data-action", id);
        btn.setAttribute("title", title);
        btn.setAttribute("aria-label", title);
        btn.setAttribute("aria-pressed", isActive && isActive() ? "true" : "false");
        btn.innerHTML = `${icon}<span>${label2}</span>`;
        if (onHold) {
          let holdTimer = null;
          let holdInterval = null;
          let didHold = false;
          const stopHold = () => {
            if (holdTimer) {
              clearTimeout(holdTimer);
              holdTimer = null;
            }
            if (holdInterval) {
              clearInterval(holdInterval);
              holdInterval = null;
            }
          };
          btn.addEventListener("pointerdown", (e) => {
            e.stopPropagation();
            didHold = false;
            stopHold();
            holdTimer = setTimeout(() => {
              didHold = true;
              holdInterval = setInterval(() => {
                onHold();
              }, 30);
            }, 260);
          });
          btn.addEventListener("pointerup", (e) => {
            stopHold();
            if (!didHold) {
              e.stopPropagation();
              action();
            }
          });
          btn.addEventListener("pointerleave", stopHold);
          btn.addEventListener("pointercancel", stopHold);
          btn.addEventListener("contextmenu", (e) => e.preventDefault());
        } else {
          btn.addEventListener("click", (e) => {
            e.stopPropagation();
            action();
          });
        }
        navGroup.appendChild(btn);
      });
      toolbar.appendChild(navGroup);
      const sep = document.createElement("div");
      sep.className = "board-3d-toolbar-sep";
      sep.setAttribute("aria-hidden", "true");
      toolbar.appendChild(sep);
      const brightWrap = document.createElement("div");
      brightWrap.className = "board-3d-brightness-wrap";
      brightWrap.setAttribute("title", "Adjust 3D Board Lighting Brightness (Double-click to reset to 100%)");
      const brightIconBtn = document.createElement("button");
      brightIconBtn.type = "button";
      brightIconBtn.className = "btn-3d-brightness-icon";
      brightIconBtn.setAttribute("title", "Reset brightness to 100%");
      brightIconBtn.setAttribute("aria-label", "Reset lighting brightness to 100%");
      brightIconBtn.innerHTML = `
      <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="4.5"/>
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
      </svg>
    `;
      brightIconBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.setBrightness(100);
      });
      brightWrap.appendChild(brightIconBtn);
      const slider = document.createElement("input");
      slider.type = "range";
      slider.className = "slider-3d-brightness";
      slider.min = "40";
      slider.max = "180";
      slider.step = "5";
      slider.value = String(Math.round(this.brightnessPercent || 100));
      slider.setAttribute("aria-label", "3D Lighting Brightness Slider");
      slider.addEventListener("input", (e) => {
        this.setBrightness(Number(e.target.value));
      });
      slider.addEventListener("dblclick", (e) => {
        e.stopPropagation();
        this.setBrightness(100);
      });
      brightWrap.appendChild(slider);
      const label = document.createElement("span");
      label.className = "val-3d-brightness";
      label.textContent = `${Math.round(this.brightnessPercent || 100)}%`;
      brightWrap.appendChild(label);
      toolbar.appendChild(brightWrap);
      const sepScale = document.createElement("div");
      sepScale.className = "board-3d-toolbar-sep";
      sepScale.setAttribute("aria-hidden", "true");
      toolbar.appendChild(sepScale);
      const scaleWrap = document.createElement("div");
      scaleWrap.className = "board-3d-scale-wrap";
      scaleWrap.setAttribute("title", "Adjust 3D Cribbage Board Size (Ctrl+Drag or [ / ] keys, Double-click to reset to 100%)");
      const scaleIconBtn = document.createElement("button");
      scaleIconBtn.type = "button";
      scaleIconBtn.className = "btn-3d-scale-icon";
      scaleIconBtn.setAttribute("title", "Reset board size to 100%");
      scaleIconBtn.setAttribute("aria-label", "Reset board size to 100%");
      scaleIconBtn.innerHTML = `
      <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
      </svg>
    `;
      scaleIconBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.resetBoardScale(true);
      });
      scaleWrap.appendChild(scaleIconBtn);
      const scaleSlider = document.createElement("input");
      scaleSlider.type = "range";
      scaleSlider.className = "slider-3d-scale";
      scaleSlider.min = "20";
      scaleSlider.max = "200";
      scaleSlider.step = "5";
      scaleSlider.value = String(Math.round((this.boardScaleMultiplier || 1) * 100));
      scaleSlider.setAttribute("aria-label", "3D Board Size Slider");
      scaleSlider.addEventListener("input", (e) => {
        this.setBoardScale(Number(e.target.value) / 100, false);
      });
      scaleSlider.addEventListener("dblclick", (e) => {
        e.stopPropagation();
        this.resetBoardScale(true);
      });
      scaleWrap.appendChild(scaleSlider);
      const scaleLabel = document.createElement("span");
      scaleLabel.className = "val-3d-scale";
      scaleLabel.title = "Click to reset board size to 100%";
      scaleLabel.textContent = `${Math.round((this.boardScaleMultiplier || 1) * 100)}%`;
      scaleLabel.addEventListener("click", (e) => {
        e.stopPropagation();
        this.resetBoardScale(true);
      });
      scaleWrap.appendChild(scaleLabel);
      toolbar.appendChild(scaleWrap);
      this.container.appendChild(toolbar);
      this.presetsToolbar = toolbar;
      if (!this._fullscreenListenersBound && typeof document !== "undefined") {
        this._fullscreenListenersBound = true;
        this._onFullscreenChange = () => {
          const isFS = this.isFullScreen();
          if (!isFS) {
            this._applyCssFullScreen(false);
          }
          this.updateFullScreenUI(isFS);
          this.handleResize();
          if (this.fitBoardToViewBox) {
            this.fitBoardToViewBox(false);
          }
        };
        document.addEventListener("fullscreenchange", this._onFullscreenChange);
        document.addEventListener("webkitfullscreenchange", this._onFullscreenChange);
        this._onGlobalKeydown = (e) => {
          if (this.isDestroyed || !this.container) return;
          const target = e.target;
          const isInput = target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable);
          if (isInput) return;
          if ((e.key === "f" || e.key === "F") && !e.ctrlKey && !e.altKey && !e.metaKey) {
            const is3DActive = window.settings?.boardViewMode === "3d" || window.settings?.boardViewMode === "room3d" || window.settings?.boardViewMode === "room3d-fullscreen" || this.isFullScreen();
            if (is3DActive) {
              e.preventDefault();
              this.toggleFullScreen();
            }
          } else if (e.key === "Escape" && this.isFullScreen()) {
            e.preventDefault();
            this.exitFullScreen();
          }
        };
        window.addEventListener("keydown", this._onGlobalKeydown);
      }
    }
    /**
     * Updates visual active states on the preset toolbar buttons.
     */
    updatePresetButtonsUI(activeId) {
      if (!this.presetsToolbar) return;
      const btns = this.presetsToolbar.querySelectorAll(".btn-3d-preset");
      btns.forEach((btn) => {
        const presetAttr = btn.getAttribute("data-preset");
        if (!presetAttr) return;
        const isMatch = activeId && presetAttr === activeId;
        if (isMatch) {
          btn.classList.add("is-active");
          btn.setAttribute("aria-pressed", "true");
        } else {
          btn.classList.remove("is-active");
          btn.setAttribute("aria-pressed", "false");
        }
      });
      this.updateFullScreenUI();
    }
    /**
     * Starts the Babylon.js render loop.
     */
    startRenderLoop() {
      this.engine.runRenderLoop(() => {
        if (this.isDestroyed || !this.scene) return;
        const now = performance.now();
        if (this.animatingPegs.length > 0) {
          this.animatingPegs = this.animatingPegs.filter((a) => a.update(now));
        }
        this.scene.render();
      });
    }
    getBabylonWoodColor() {
      const BABYLON = this.BABYLON;
      const finish = this.settings.boardFinish || this.boardConfig?.woodFinish || "maple";
      if (finish === "walnut") return new BABYLON.Color3(0.24, 0.15, 0.08);
      if (finish === "cherry") return new BABYLON.Color3(0.42, 0.14, 0.09);
      if (finish === "obsidian") return new BABYLON.Color3(0.09, 0.09, 0.1);
      if (finish === "driftwood") return new BABYLON.Color3(0.47, 0.44, 0.42);
      return new BABYLON.Color3(0.85, 0.64, 0.38);
    }
    /**
     * Cleans up Babylon Engine, Scene, and Event Listeners.
     */
    destroy() {
      this.isDestroyed = true;
      this.clearTableEnvironment();
      this.cancelActionCam();
      if (this.actionCamOverlay) {
        try {
          this.actionCamOverlay.remove();
        } catch (_) {
        }
        this.actionCamOverlay = null;
      }
      this.clearClashObstacles();
      this.clearPintsObjects();
      this.clearAdultObjects();
      this.clearZoneHighlights();
      if (this._zoneMaterials) {
        for (const k of Object.keys(this._zoneMaterials)) {
          try {
            this._zoneMaterials[k].dispose();
          } catch (_) {
          }
        }
        this._zoneMaterials = null;
      }
      if (this.boardRoot) {
        try {
          this.boardRoot.dispose(false, true);
        } catch (_) {
        }
        this.boardRoot = null;
      }
      if (this._obstacleMaterials) {
        for (const k of Object.keys(this._obstacleMaterials)) {
          try {
            this._obstacleMaterials[k].dispose();
          } catch (_) {
          }
        }
        this._obstacleMaterials = null;
      }
      if (this._pintsMaterials) {
        for (const k of Object.keys(this._pintsMaterials)) {
          try {
            this._pintsMaterials[k].dispose();
          } catch (_) {
          }
        }
        this._pintsMaterials = null;
      }
      if (this._adultMaterials) {
        for (const k of Object.keys(this._adultMaterials)) {
          try {
            this._adultMaterials[k].dispose();
          } catch (_) {
          }
        }
        this._adultMaterials = null;
      }
      if (this._sparkMaterials) {
        for (const mat of this._sparkMaterials.values()) {
          try {
            mat.dispose();
          } catch (_) {
          }
        }
        this._sparkMaterials.clear();
        this._sparkMaterials = null;
      }
      if (this._ringMaterials) {
        for (const mat of this._ringMaterials.values()) {
          try {
            mat.dispose();
          } catch (_) {
          }
        }
        this._ringMaterials.clear();
        this._ringMaterials = null;
      }
      this.animatingPegs = [];
      if (this.glowLayer) {
        try {
          this.glowLayer.dispose();
        } catch (_) {
        }
        this.glowLayer = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      if (this._resizeRaf) {
        cancelAnimationFrame(this._resizeRaf);
        this._resizeRaf = null;
      }
      if (this._hoverRaf) {
        cancelAnimationFrame(this._hoverRaf);
        this._hoverRaf = null;
      }
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
      }
      if (this._onFullscreenChange) {
        document.removeEventListener("fullscreenchange", this._onFullscreenChange);
        document.removeEventListener("webkitfullscreenchange", this._onFullscreenChange);
        this._onFullscreenChange = null;
      }
      if (this._onGlobalKeydown) {
        window.removeEventListener("keydown", this._onGlobalKeydown);
        this._onGlobalKeydown = null;
      }
      this._fullscreenListenersBound = false;
      this._applyCssFullScreen(false);
      if (this._avatarTextures) {
        for (const tex of this._avatarTextures.values()) {
          try {
            tex.dispose();
          } catch (_) {
          }
        }
        this._avatarTextures.clear();
      }
      if (this._avatarMaterials) {
        for (const mat of this._avatarMaterials.values()) {
          try {
            mat.dispose();
          } catch (_) {
          }
        }
        this._avatarMaterials.clear();
      }
      if (this.engine && typeof this.engine.stopRenderLoop === "function") {
        this.engine.stopRenderLoop();
      }
      if (this.scene && typeof this.scene.dispose === "function") {
        this.scene.dispose();
      }
      if (this.engine) {
        this.engine.dispose();
      }
      if (this.canvas) {
        try {
          if (typeof this.canvas.remove === "function") {
            this.canvas.remove();
          } else if (this.canvas.parentNode) {
            this.canvas.parentNode.removeChild(this.canvas);
          }
        } catch (_) {
        }
      }
      if (this.container && this.container.classList && this.container.classList.contains("board-3d-container")) {
        try {
          if (typeof this.container.remove === "function") {
            this.container.remove();
          } else if (this.container.parentNode) {
            this.container.parentNode.removeChild(this.container);
          }
        } catch (_) {
        }
      }
      const resizeHandle = typeof document !== "undefined" ? document.getElementById("board3DResizeHandle") : null;
      if (resizeHandle) {
        try {
          if (typeof resizeHandle.remove === "function") {
            resizeHandle.remove();
          } else if (resizeHandle.parentNode) {
            resizeHandle.parentNode.removeChild(resizeHandle);
          }
        } catch (_) {
        }
      }
      if (this.presetsToolbar) {
        try {
          if (typeof this.presetsToolbar.remove === "function") {
            this.presetsToolbar.remove();
          } else if (this.presetsToolbar.parentNode) {
            this.presetsToolbar.parentNode.removeChild(this.presetsToolbar);
          }
        } catch (_) {
        }
        this.presetsToolbar = null;
      }
      if (this.ssaoPipeline) {
        try {
          this.ssaoPipeline.dispose();
        } catch (_) {
        }
        this.ssaoPipeline = null;
      }
      if (this.fillLight) {
        try {
          this.fillLight.dispose();
        } catch (_) {
        }
        this.fillLight = null;
      }
      this.scene = null;
      this.engine = null;
      this.camera = null;
      this.canvas = null;
    }
    /**
     * Retrieves the current camera angles, distance, and target of the 3D board.
     * Prints a formatted summary and ready-to-paste cameraDefaults code snippet to the console.
     * @returns {{ boardId: string, boardName: string, alphaDeg: number, betaDeg: number, alpha: number, beta: number, radius: number, fov: number, target: number[], snippet: string } | null}
     */
    getCameraAngles() {
      if (!this.camera) {
        console.warn("[BoardRenderer3D] Camera is not initialized.");
        return null;
      }
      const alphaRad = Number(this.camera.alpha.toFixed(4));
      const betaRad = Number(this.camera.beta.toFixed(4));
      const rawAlphaDeg = this.camera.alpha * 180 / Math.PI;
      let alphaDeg = (rawAlphaDeg % 360 + 540) % 360 - 180;
      alphaDeg = Number(alphaDeg.toFixed(2));
      const betaDeg = Number((this.camera.beta * 180 / Math.PI).toFixed(2));
      const radius = Number((this.camera.radius || 0).toFixed(2));
      const fov = Number(((this.camera.fov || 0.8) * 180 / Math.PI).toFixed(1));
      const targetPos = this.camera.target ? [
        Number(this.camera.target.x.toFixed(2)),
        Number(this.camera.target.y.toFixed(2)),
        Number(this.camera.target.z.toFixed(2))
      ] : [0, 0, 0];
      const boardId = this.boardConfig?.id || "current-board";
      const boardName = this.boardConfig?.name || "Current 3D Board";
      const camDef = this.boardConfig?.cameraDefaults || {};
      const snippet = `cameraDefaults: {
  fov: ${fov},
  alphaDeg: ${alphaDeg},
  betaDeg: ${betaDeg},
  target: [${targetPos.join(", ")}],
  minDistance: ${camDef.minDistance !== void 0 ? camDef.minDistance : 15},
  maxDistance: ${camDef.maxDistance !== void 0 ? camDef.maxDistance : 95}
}`;
      const info = {
        boardId,
        boardName,
        alphaDeg,
        betaDeg,
        alpha: alphaRad,
        beta: betaRad,
        radius,
        fov,
        target: targetPos,
        snippet
      };
      if (typeof console !== "undefined" && console.log) {
        console.log(
          `%c\u{1F3B2} 3D Board Camera Angles [${boardName} (${boardId})]%c
  \u2022 alphaDeg: %c${alphaDeg}\xB0%c (horizontal orbit / yaw)
  \u2022 betaDeg:  %c${betaDeg}\xB0%c (vertical pitch / tilt)
  \u2022 alpha:    ${alphaRad} rad
  \u2022 beta:     ${betaRad} rad
  \u2022 radius:   ${radius}
  \u2022 fov:      ${fov}\xB0
  \u2022 target:   [${targetPos.join(", ")}]

%c\u{1F4CB} Copy & Paste into cameraDefaults in Board3DCatalog.js:%c
${snippet}`,
          "color: #00d26a; font-weight: bold; font-size: 13px;",
          "color: inherit;",
          "color: #00e5ff; font-weight: bold;",
          "color: inherit;",
          "color: #ffaa00; font-weight: bold;",
          "color: inherit;",
          "color: #b388ff; font-weight: bold;",
          "color: #00e676; font-family: monospace;"
        );
      }
      return info;
    }
    /**
     * Alias for getCameraAngles().
     */
    getBoardAngles() {
      return this.getCameraAngles();
    }
    /**
     * Alias for getCameraAngles().
     */
    getAngles() {
      return this.getCameraAngles();
    }
    /**
     * Static helper to retrieve angles from the active 3D renderer instance.
     */
    static getCameraAngles() {
      if (typeof window !== "undefined" && window._currentRenderer3D?.getCameraAngles) {
        return window._currentRenderer3D.getCameraAngles();
      }
      console.warn("[BoardRenderer3D] No active 3D board found. Ensure 3D board view is selected.");
      return null;
    }
    /**
     * Static alias for getCameraAngles().
     */
    static getBoardAngles() {
      return _BoardRenderer3D.getCameraAngles();
    }
    /**
     * Checks whether the 3D room/board container is currently full screen.
     * @returns {boolean}
     */
    isFullScreen() {
      if (typeof document === "undefined") return false;
      const fsEl = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
      if (fsEl && (fsEl === this.container || this.container?.contains(fsEl))) {
        return true;
      }
      return Boolean(this.container && this.container.classList.contains("is-fullscreen"));
    }
    /**
     * Applies or removes CSS-level fullscreen fallback styling on the 3D container.
     * @param {boolean} enable
     */
    _applyCssFullScreen(enable) {
      if (!this.container) return;
      if (enable) {
        const gameEl = typeof document !== "undefined" ? document.getElementById("game") : null;
        const menuVariants = typeof document !== "undefined" ? document.getElementById("menuVariants") : null;
        if (gameEl && gameEl.classList.contains("hidden") || menuVariants && !menuVariants.classList.contains("hidden")) {
          return;
        }
        this.container.classList.add("is-fullscreen");
        if (typeof document !== "undefined" && document.body) {
          document.body.classList.add("is-3d-fullscreen");
        }
      } else {
        this.container.classList.remove("is-fullscreen");
        if (typeof document !== "undefined" && document.body) {
          document.body.classList.remove("is-3d-fullscreen");
        }
      }
    }
    /**
     * Requests fullscreen mode for the 3D room/board container.
     * Uses HTML5 Fullscreen API with automatic fallback to CSS full-window mode.
     * @returns {Promise<void>}
     */
    async enterFullScreen() {
      if (typeof document === "undefined" || !this.container) return;
      if (this.isFullScreen()) return;
      const gameEl = document.getElementById("game");
      if (gameEl && gameEl.classList.contains("hidden")) {
        return;
      }
      const menuVariants = document.getElementById("menuVariants");
      if (menuVariants && !menuVariants.classList.contains("hidden")) {
        return;
      }
      let usedHtml5Fs = false;
      try {
        if (this.container.requestFullscreen) {
          await this.container.requestFullscreen();
          usedHtml5Fs = true;
        } else if (this.container.webkitRequestFullscreen) {
          await this.container.webkitRequestFullscreen();
          usedHtml5Fs = true;
        } else if (this.container.mozRequestFullScreen) {
          await this.container.mozRequestFullScreen();
          usedHtml5Fs = true;
        } else if (this.container.msRequestFullscreen) {
          await this.container.msRequestFullscreen();
          usedHtml5Fs = true;
        } else {
          this._applyCssFullScreen(true);
        }
      } catch (err) {
        console.warn("[BoardRenderer3D] HTML5 requestFullscreen unavailable or denied, falling back to CSS fullscreen:", err);
        this._applyCssFullScreen(true);
      }
      if (!usedHtml5Fs && !this.isFullScreen()) {
        this._applyCssFullScreen(true);
      }
      this.updateFullScreenUI(true);
      this.handleResize();
      if (this.fitBoardToViewBox) {
        setTimeout(() => {
          if (!this.isDestroyed) {
            this.handleResize();
            this.fitBoardToViewBox(false);
          }
        }, 60);
      }
    }
    /**
     * Exits fullscreen mode and restores normal container bounds.
     * @returns {Promise<void>}
     */
    async exitFullScreen() {
      if (typeof document === "undefined") return;
      if (!this.isFullScreen()) return;
      try {
        const fsEl = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
        if (fsEl && (document.exitFullscreen || document.webkitExitFullscreen)) {
          if (document.exitFullscreen) {
            await document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            await document.webkitExitFullscreen();
          }
        }
      } catch (err) {
        console.warn("[BoardRenderer3D] exitFullscreen error:", err);
      }
      this._applyCssFullScreen(false);
      try {
        const overlay = document.getElementById("overlay");
        if (overlay && overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }
      } catch (_) {
      }
      this.updateFullScreenUI(false);
      this.handleResize();
      if (this.fitBoardToViewBox) {
        setTimeout(() => {
          if (!this.isDestroyed) {
            this.handleResize();
            this.fitBoardToViewBox(false);
          }
        }, 60);
      }
    }
    /**
     * Toggles between fullscreen and standard room view.
     * @returns {Promise<void>}
     */
    toggleFullScreen() {
      if (this.isFullScreen()) {
        return this.exitFullScreen();
      } else {
        return this.enterFullScreen();
      }
    }
    /**
     * Synchronizes visual states of fullscreen buttons across toolbar and in-game UI.
     * @param {boolean} [isFS]
     */
    updateFullScreenUI(isFS = this.isFullScreen()) {
      if (typeof document === "undefined") return;
      if (this.presetsToolbar) {
        const btn = this.presetsToolbar.querySelector(".btn-3d-fullScreen");
        if (btn) {
          btn.classList.toggle("is-active", !!isFS);
          btn.setAttribute("aria-pressed", isFS ? "true" : "false");
          btn.title = isFS ? "Exit Full Screen (Esc or F)" : "Toggle Full Screen (F)";
          const iconExpand = btn.querySelector(".icon-fs-expand");
          const iconContract = btn.querySelector(".icon-fs-contract");
          if (iconExpand) iconExpand.style.display = isFS ? "none" : "block";
          if (iconContract) iconContract.style.display = isFS ? "block" : "none";
        }
      }
      const inGameBtn = document.getElementById("btnFullscreen3D");
      const inGameIcon = document.getElementById("btnFullscreen3DIcon");
      if (inGameBtn) {
        inGameBtn.classList.toggle("active", !!isFS);
        inGameBtn.setAttribute("aria-pressed", isFS ? "true" : "false");
        inGameBtn.title = isFS ? "Exit 3D Full Screen (Esc or F)" : "Toggle 3D Full Screen (F)";
        if (inGameIcon) inGameIcon.textContent = isFS ? "\u{1F5D7}" : "\u26F6";
      }
    }
    static isFullScreen() {
      if (typeof window !== "undefined" && window._currentRenderer3D?.isFullScreen) {
        return window._currentRenderer3D.isFullScreen();
      }
      return false;
    }
    static toggleFullScreen() {
      if (typeof window !== "undefined" && window._currentRenderer3D?.toggleFullScreen) {
        return window._currentRenderer3D.toggleFullScreen();
      }
    }
  };
  if (typeof window !== "undefined") {
    window.getBoardAngles = () => BoardRenderer3D.getBoardAngles();
    window.getCameraAngles = () => BoardRenderer3D.getCameraAngles();
    window.toggle3DRoomFullScreen = () => BoardRenderer3D.toggleFullScreen();
    window.is3DRoomFullScreen = () => BoardRenderer3D.isFullScreen();
  }

  // src/ui/Room3DLoadingOverlay.js
  var activeRoom3DLoaderInstance = null;
  var Room3DLoadingOverlay2 = class _Room3DLoadingOverlay {
    /**
     * Displays the 3D Room Loader with a slowly rotating random card.
     *
     * @param {HTMLElement} [container] - Container element (default: #board3DContainer or #boardTracks)
     * @param {Object} [options]
     * @param {Object} [options.settings] - Active game settings
     * @param {Object} [options.card] - Explicit card to display (optional)
     * @param {Array<Object>} [options.deck] - Source deck to choose random card from (optional)
     * @param {string} [options.theme] - Active room theme id
     * @param {string} [options.cardBack] - Active card back style id
     * @param {number} [options.minDuration] - Minimum display milliseconds before hiding (default 1350ms)
     * @param {Function} [options.onComplete] - Callback fired when loader finishes and dismisses
     * @returns {Room3DLoadingOverlay}
     */
    static show(container = null, options = {}) {
      if (typeof document === "undefined") {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (activeRoom3DLoaderInstance) {
        activeRoom3DLoaderInstance.close(false);
      }
      const instance = new _Room3DLoadingOverlay(container, options);
      activeRoom3DLoaderInstance = instance;
      instance.mount();
      return instance;
    }
    /**
     * Returns the current active instance if any.
     * @returns {Room3DLoadingOverlay|null}
     */
    static getActive() {
      return activeRoom3DLoaderInstance;
    }
    /**
     * Notifies the active loader that the 3D renderer is ready.
     * @param {Object} [renderer3D]
     */
    static markRendererReady(renderer3D = null) {
      if (activeRoom3DLoaderInstance) {
        activeRoom3DLoaderInstance.markRendererReady(renderer3D);
      }
    }
    /**
     * Updates progress on the active loader.
     * @param {string} text
     * @param {number} percent
     */
    static updateProgress(text2, percent) {
      if (activeRoom3DLoaderInstance) {
        activeRoom3DLoaderInstance.updateProgress(text2, percent);
      }
    }
    /**
     * Immediately closes the active loader without animations (e.g. on error).
     */
    static hideImmediate() {
      if (activeRoom3DLoaderInstance) {
        activeRoom3DLoaderInstance.close(false);
      }
    }
    /**
     * Smoothly finishes and dismisses the active loader.
     * @param {Function} [callback]
     */
    static finish(callback = null) {
      if (activeRoom3DLoaderInstance) {
        activeRoom3DLoaderInstance.finish(callback);
      } else if (typeof callback === "function") {
        callback();
      }
    }
    constructor(container = null, options = {}) {
      this.container = container;
      this.options = options;
      this.settings = options.settings || (typeof window !== "undefined" ? window.settings : {}) || {};
      this.minDuration = options.minDuration != null ? options.minDuration : 1600;
      this.onComplete = options.onComplete || (() => {
      });
      this.card = options.card || _Room3DLoadingOverlay.pickRandomCard(options.deck || (typeof window !== "undefined" ? window.FULL_DECK : null));
      this.cardBack = options.cardBack || this.settings.cardBack || "classic-blue";
      this.themeId = options.theme || this.settings.roomTheme || this.settings.tableEnvironment || "pub";
      this.startTime = Date.now();
      this.overlayEl = null;
      this.progressFillEl = null;
      this.statusTextEl = null;
      this.currentProgress = 0.15;
      this.isClosing = false;
      this.rendererIsReady = false;
      this._safetyTimeout = null;
      this._tipInterval = null;
    }
    /**
     * Resolves a random card from the provided deck or standard 52-card distribution.
     * @param {Array<Object>} [deck]
     * @returns {Object} Normalized card data
     */
    static pickRandomCard(deck = null) {
      if (Array.isArray(deck) && deck.length > 0) {
        const idx = Math.floor(Math.random() * deck.length);
        return _Room3DLoadingOverlay.normalizeCard(deck[idx]);
      }
      const ranks = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];
      const suits = ["S", "H", "D", "C"];
      const r = ranks[Math.floor(Math.random() * ranks.length)];
      const s = suits[Math.floor(Math.random() * suits.length)];
      return _Room3DLoadingOverlay.normalizeCard({ r, s, id: `${r}${s}` });
    }
    /**
     * Normalizes rank, suit, symbol, color and friendly labels for a card.
     * @param {Object} rawCard
     * @returns {Object}
     */
    static normalizeCard(rawCard) {
      if (!rawCard) {
        return {
          r: "A",
          s: "S",
          rank: "A",
          suit: "S",
          rankName: "Ace",
          suitName: "Spades",
          suitSymbol: "\u2660",
          isRed: false,
          isWild: false,
          fullName: "Ace of Spades \u2660",
          id: "AS"
        };
      }
      const isWild2 = Boolean(rawCard.wild || rawCard.isWild || rawCard.r === 0 || rawCard.rank === 0);
      if (isWild2 && !rawCard.playAs) {
        return {
          r: "JOKER",
          s: "J",
          rank: "\u2605",
          suit: "J",
          rankName: "Joker",
          suitName: "Wild",
          suitSymbol: "\u2605",
          isRed: false,
          isWild: true,
          fullName: "Wild Joker \u2605",
          id: rawCard.id || "JOKER"
        };
      }
      let rank = String((rawCard.playAs ? rawCard.playAs.r : rawCard.r) || rawCard.rank || "A").toUpperCase();
      if (rank === "1") rank = "A";
      if (rank === "11") rank = "J";
      if (rank === "12") rank = "Q";
      if (rank === "13") rank = "K";
      let suit = String((rawCard.playAs ? rawCard.playAs.s : rawCard.s) || rawCard.suit || "S").toUpperCase().charAt(0);
      if (!["S", "H", "D", "C"].includes(suit)) {
        if (suit === "\u2660") suit = "S";
        else if (suit === "\u2665") suit = "H";
        else if (suit === "\u2666") suit = "D";
        else if (suit === "\u2663") suit = "C";
        else suit = "S";
      }
      const suitSymbols = { S: "\u2660", H: "\u2665", D: "\u2666", C: "\u2663" };
      const suitNames = { S: "Spades", H: "Hearts", D: "Diamonds", C: "Clubs" };
      const rankNames = {
        A: "Ace",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        J: "Jack",
        Q: "Queen",
        K: "King"
      };
      const isRed = suit === "H" || suit === "D";
      const rankName = rankNames[rank] || rank;
      const suitName = suitNames[suit] || suit;
      const suitSymbol = suitSymbols[suit] || suit;
      return {
        r: rank,
        s: suit,
        rank,
        suit,
        rankName,
        suitName,
        suitSymbol,
        isRed,
        isWild: false,
        fullName: `${rankName} of ${suitName} ${suitSymbol}`,
        id: rawCard.id || `${rank}${suit}`
      };
    }
    /**
     * Resolves user-friendly themed titles for the room environment header.
     * @param {string} themeId
     * @returns {string}
     */
    static getThemeTitle(themeId) {
      const titles = {
        pub: "The English Pub & Fireplace Hearth",
        vegas: "The High-Roller Penthouse Suite",
        cabin: "The Alpine Mountain Lodge",
        velvet: "The Velvet Underground Speakeasy",
        industrial: "The Industrial Loft & Warehouse",
        nordic: "The Minimalist Nordic Studio",
        none: "Custom Themed Cribbage Table"
      };
      return titles[themeId] || titles.pub;
    }
    /**
     * Mounts the loader overlay DOM element into the target container.
     */
    mount() {
      if (typeof document === "undefined") return;
      let target = this.container;
      if (!target) {
        target = document.getElementById("board3DContainer") || document.getElementById("boardTracks") || document.getElementById("cribBoard") || document.getElementById("game");
      }
      if (!target) return;
      const oldOverlays = target.querySelectorAll(".room3d-loading-overlay");
      oldOverlays.forEach((el) => el.remove());
      const isGlobal = Boolean(this.options.isGlobal || target === document.body || target?.id === "game");
      const overlay = document.createElement("div");
      overlay.className = `room3d-loading-overlay theme-${this.themeId}${isGlobal ? " is-global-overlay" : ""}`;
      overlay.id = "room3dLoadingOverlay";
      overlay.setAttribute("role", "status");
      overlay.setAttribute("aria-live", "polite");
      overlay.setAttribute("aria-label", "Loading 3D Room and Tabletop");
      const is3DOnly = Boolean(this.options.is3DOnly);
      const themeTitle = is3DOnly ? "Interactive 3D Cribbage Board" : _Room3DLoadingOverlay.getThemeTitle(this.themeId);
      const badgeText = is3DOnly ? "3D CRIBBAGE BOARD" : "3D ROOM ENVIRONMENT";
      const mainTitle = is3DOnly ? "Loading 3D Cribbage Board" : "Entering 3D Cribbage Room";
      const card = this.card;
      overlay.innerHTML = `
      <div class="room3d-loader-backdrop-glow"></div>

      <!-- Header Section -->
      <div class="room3d-loader-header">
        <div class="room3d-loader-badge">
          <span class="room3d-loader-badge-dot"></span>
          <span>${badgeText}</span>
        </div>
        <h2 class="room3d-loader-title">${mainTitle}</h2>
        <div class="room3d-loader-subtitle" id="room3dLoaderTheme">${themeTitle}</div>
      </div>

      <!-- 3D Rotating Card Section -->
      <div class="room3d-card-viewport">
        <div class="room3d-card-scene">
          <div class="room3d-card-3d" id="room3dSpinningCard">
            <!-- Front Face -->
            <div class="room3d-card-face room3d-card-front ${card.isRed ? "is-red" : "is-black"}">
              <div class="room3d-card-corner top-left">
                <span class="room3d-card-rank">${card.rank}</span>
                <span class="room3d-card-suit">${card.suitSymbol}</span>
              </div>
              <div class="room3d-card-center">
                ${this.renderCardCenterMarkup(card)}
              </div>
              <div class="room3d-card-corner bottom-right">
                <span class="room3d-card-rank">${card.rank}</span>
                <span class="room3d-card-suit">${card.suitSymbol}</span>
              </div>
              <div class="room3d-card-gloss"></div>
            </div>

            <!-- Back Face -->
            <div class="room3d-card-face room3d-card-back back-${this.cardBack}">
              <div class="room3d-card-back-pattern"></div>
              <div class="room3d-card-back-frame">
                <div class="room3d-card-back-crest">
                  <span class="room3d-crest-sym">\u2726</span>
                  <span class="room3d-crest-label">CRAZY CRIBBAGE</span>
                </div>
              </div>
              <div class="room3d-card-gloss"></div>
            </div>

            <!-- 3D Card Edge Thickness Layers -->
            <div class="room3d-card-edge edge-left"></div>
            <div class="room3d-card-edge edge-right"></div>
            <div class="room3d-card-edge edge-top"></div>
            <div class="room3d-card-edge edge-bottom"></div>
          </div>
          <!-- Ground Breathing Shadow -->
          <div class="room3d-card-shadow"></div>
        </div>
      </div>

      <!-- Card Identity Pill -->
      <div class="room3d-card-draw-pill">
        <span class="room3d-card-draw-icon">\u{1F3B4}</span>
        <span class="room3d-card-draw-label">Random Draw:</span>
        <strong class="room3d-card-draw-name ${card.isRed ? "is-red" : ""}">${card.fullName}</strong>
      </div>

      <!-- Footer / Loading Progress Section -->
      <div class="room3d-loader-footer">
        <div class="room3d-loader-status-wrap">
          <span class="room3d-loader-spinner-icon" aria-hidden="true">\u23F3</span>
          <span class="room3d-loader-status" id="room3dLoaderStatus">Initializing 3D graphics &amp; lighting\u2026</span>
        </div>
        <div class="room3d-loader-progress-bar">
          <div class="room3d-loader-progress-fill" id="room3dLoaderProgressFill" style="width: 15%;"></div>
          <div class="room3d-loader-progress-glow"></div>
        </div>
        <div class="room3d-loader-tip" id="room3dLoaderTip">
          <span class="room3d-tip-icon">\u{1F4A1}</span>
          <span class="room3d-tip-text" id="room3dLoaderTipText">Drag anywhere on the 3D tabletop to orbit the camera view.</span>
        </div>
      </div>
    `;
      target.appendChild(overlay);
      this.overlayEl = overlay;
      this.progressFillEl = overlay.querySelector("#room3dLoaderProgressFill");
      this.statusTextEl = overlay.querySelector("#room3dLoaderStatus");
      this.startAmbientTipRotation();
      this._safetyTimeout = setTimeout(() => {
        if (!this.isClosing) {
          this.finish();
        }
      }, 12e3);
    }
    /**
     * Generates SVG/HTML art for court cards, aces, jokers, and pip distributions.
     * @param {Object} card
     * @returns {string}
     */
    renderCardCenterMarkup(card) {
      if (card.isWild) {
        return `
        <div class="room3d-art-court joker">
          <div class="court-icon">\u{1F3AD}</div>
          <div class="court-title">JOKER</div>
          <div class="court-stars">\u2605 \u2605 \u2605</div>
        </div>
      `;
      }
      if (card.rank === "K") {
        return `
        <div class="room3d-art-court king">
          <div class="court-crown">\u{1F451}</div>
          <div class="court-figure">\u265A</div>
          <div class="court-title">KING</div>
          <div class="court-suit-sym">${card.suitSymbol}</div>
        </div>
      `;
      }
      if (card.rank === "Q") {
        return `
        <div class="room3d-art-court queen">
          <div class="court-crown">\u2655</div>
          <div class="court-figure">\u265B</div>
          <div class="court-title">QUEEN</div>
          <div class="court-suit-sym">${card.suitSymbol}</div>
        </div>
      `;
      }
      if (card.rank === "J") {
        return `
        <div class="room3d-art-court jack">
          <div class="court-crown">\u{1F6E1}\uFE0F</div>
          <div class="court-figure">\u265E</div>
          <div class="court-title">JACK</div>
          <div class="court-suit-sym">${card.suitSymbol}</div>
        </div>
      `;
      }
      if (card.rank === "A") {
        return `
        <div class="room3d-art-ace">
          <div class="ace-large-suit">${card.suitSymbol}</div>
          <div class="ace-flourish">\u2726 ACE \u2726</div>
        </div>
      `;
      }
      const count = parseInt(card.rank, 10) || 5;
      let pipsHtml = "";
      for (let i = 0; i < count; i++) {
        pipsHtml += `<span class="room3d-pip-item">${card.suitSymbol}</span>`;
      }
      return `
      <div class="room3d-art-pips pips-${count}">
        ${pipsHtml}
      </div>
    `;
    }
    /**
     * Cycles ambient cribbage tips smoothly while the room loads.
     */
    startAmbientTipRotation() {
      const tips = [
        "Drag anywhere on the 3D tabletop to orbit the camera view.",
        "Use the mouse scroll wheel or pinch to zoom in on your cards or pegs.",
        "Double-click the 3D board resize handle to reset the board height.",
        "Lowest cut card earns the first deal \u2014 Ace is lowest in Cribbage!",
        "Watch your opponents in radial seats for real-time play gestures."
      ];
      let tipIdx = 0;
      this._tipInterval = setInterval(() => {
        if (this.isClosing || !this.overlayEl) return;
        const el = this.overlayEl.querySelector("#room3dLoaderTipText");
        if (el) {
          tipIdx = (tipIdx + 1) % tips.length;
          el.style.opacity = "0";
          setTimeout(() => {
            if (el) {
              el.textContent = tips[tipIdx];
              el.style.opacity = "1";
            }
          }, 200);
        }
      }, 2800);
    }
    /**
     * Updates loading progress percentage and text.
     * @param {string} text
     * @param {number} percent - 0.0 to 1.0
     */
    updateProgress(text2, percent) {
      if (this.isClosing) return;
      this.currentProgress = Math.max(this.currentProgress, Math.min(1, percent));
      if (this.statusTextEl && text2) {
        this.statusTextEl.textContent = text2;
      }
      if (this.progressFillEl) {
        this.progressFillEl.style.width = `${Math.round(this.currentProgress * 100)}%`;
      }
    }
    /**
     * Marks the 3D renderer as ready. Waits for Babylon ready & minDuration before dismissing.
     * @param {Object} [renderer3D]
     */
    markRendererReady(renderer3D = null) {
      this.rendererIsReady = true;
      this.updateProgress("Finalizing 3D tabletop environment\u2026", 0.95);
      const onReadyCheck = () => {
        const elapsed = Date.now() - this.startTime;
        const remainingTime = Math.max(0, this.minDuration - elapsed);
        setTimeout(() => {
          this.finish();
        }, remainingTime);
      };
      if (renderer3D && renderer3D.scene && typeof renderer3D.scene.executeWhenReady === "function") {
        renderer3D.scene.executeWhenReady(() => {
          if (typeof requestAnimationFrame === "function") {
            requestAnimationFrame(onReadyCheck);
          } else {
            onReadyCheck();
          }
        });
      } else {
        onReadyCheck();
      }
    }
    /**
     * Completes the loading sequence with an elegant exit animation.
     * @param {Function} [callback]
     */
    finish(callback = null) {
      if (this.isClosing) return;
      this.isClosing = true;
      if (this._safetyTimeout) {
        clearTimeout(this._safetyTimeout);
        this._safetyTimeout = null;
      }
      if (this._tipInterval) {
        clearInterval(this._tipInterval);
        this._tipInterval = null;
      }
      this.updateProgress("Room Ready \u2014 Let\u2019s Play!", 1);
      setTimeout(() => {
        if (this.overlayEl) {
          this.overlayEl.classList.add("room3d-loader-hiding");
        }
        setTimeout(() => {
          this.close(true);
          if (typeof callback === "function") callback();
        }, 420);
      }, 240);
    }
    /**
     * Closes and cleans up the overlay from DOM.
     * @param {boolean} triggerComplete - whether to fire onComplete callback
     */
    close(triggerComplete = true) {
      if (this._safetyTimeout) {
        clearTimeout(this._safetyTimeout);
        this._safetyTimeout = null;
      }
      if (this._tipInterval) {
        clearInterval(this._tipInterval);
        this._tipInterval = null;
      }
      if (this.overlayEl) {
        try {
          if (typeof this.overlayEl.remove === "function") {
            this.overlayEl.remove();
          } else if (this.overlayEl.parentNode) {
            this.overlayEl.parentNode.removeChild(this.overlayEl);
          }
        } catch (_) {
        }
        this.overlayEl = null;
      }
      if (activeRoom3DLoaderInstance === this) {
        activeRoom3DLoaderInstance = null;
      }
      if (triggerComplete && typeof this.onComplete === "function") {
        try {
          this.onComplete();
        } catch (_) {
        }
      }
    }
  };

  // src/board/BoardRenderer.js
  var BoardRenderer = class _BoardRenderer {
    /**
     * Computes the cache key string for board redraw invalidation.
     * @param {Object} settings
     * @param {Array<string>} activeTracks
     * @param {string} brand
     * @returns {string}
     */
    static getBoardSignature(settings3 = {}, activeTracks = [], brand = "") {
      const tracks = (Array.isArray(activeTracks) ? activeTracks : []).join(",");
      let t = settings3.target || 121;
      if (brand === "clash" && ![241, 361, 481].includes(t)) {
        t = 481;
      }
      const obs = [
        settings3.optNoPassingLanes,
        settings3.optJump,
        settings3.optJail,
        settings3.optBar,
        settings3.optTimeout,
        settings3.optDetour,
        settings3.optRoundAbout,
        settings3.optSigns,
        settings3.optStopSign,
        settings3.optSkunkMarkers,
        settings3.optYouDrink,
        settings3.optGuysDrink,
        settings3.optGalsDrink,
        settings3.optLeftDrink,
        settings3.optRightDrink,
        settings3.optEveryoneDrink,
        settings3.optEveryoneButYouDrink,
        settings3.optPickWhoDrinks
      ].map(Boolean).join("");
      const finish = settings3.boardFinish || "maple";
      const skin = settings3.pegSkin || "brass";
      const viewMode = settings3.boardViewMode || "2d";
      const board3D = settings3.selected3DBoardId || "";
      return `${brand}|${t}|${tracks}|${obs}|${finish}|${skin}|${viewMode}|${board3D}`;
    }
    /**
     * Updates top scoreboard chips for active tracks.
     * @param {Document} doc
     * @param {Array<string>} tracks
     * @param {Function} pName
     * @param {Object} settings
     */
    static updateScoreChips(doc, tracks = [], pName2 = ((w) => w), settings3 = {}) {
      if (!doc) return;
      const topEl = doc.getElementById("boardTopChips");
      if (!topEl) return;
      const is2P = settings3 && settings3.playerCount === 2;
      const currentChips = topEl.querySelectorAll(".score-chip");
      const chipIds = Array.from(currentChips).map((c) => c.id);
      const expectedIds = tracks.map((k) => `chip-${k}`);
      const needsRebuild = currentChips.length !== tracks.length || chipIds.some((id, idx) => id !== expectedIds[idx]);
      const isSeatHuman2 = (w) => {
        if (typeof window !== "undefined" && typeof window.isSeatHuman === "function") {
          return window.isSeatHuman(w);
        }
        if (settings3 && settings3.seats) {
          const s = settings3.seats.find((x) => x && x.id === w);
          if (s) return s.type === "human";
        }
        return w === "p1" || Boolean(settings3 && settings3.isHvH);
      };
      const isSeatOnline3 = (w) => {
        if (typeof window !== "undefined" && typeof window.isSeatOnline === "function") {
          return window.isSeatOnline(w);
        }
        if (settings3 && settings3.seats) {
          const s = settings3.seats.find((x) => x && x.id === w);
          if (s && s.online !== void 0) return Boolean(s.online);
        }
        return true;
      };
      const isMultiHuman3 = () => {
        if (typeof window !== "undefined" && typeof window.isMultiHuman === "function") {
          return window.isMultiHuman();
        }
        if (settings3 && settings3.seats) {
          return settings3.seats.filter((s) => s && s.type === "human").length >= 2;
        }
        return Boolean(settings3 && (settings3.opp === "online" || settings3.isHvH));
      };
      const multiHuman = isMultiHuman3();
      const getIndicatorHtml = (k) => {
        if (!multiHuman || !isSeatHuman2(k)) return "";
        const online = isSeatOnline3(k);
        return `<span class="online-indicator ${online ? "online" : "offline"}" title="${online ? "Online" : "Offline"}"></span>`;
      };
      if (needsRebuild) {
        const chipsHtml = tracks.map((key) => {
          const label = pName2(key);
          const cls = key === "p1" && is2P ? "you" : key === "p2" && is2P ? "cpu" : key;
          const youCpuId = key === "p1" && is2P ? "you" : key === "p2" && is2P ? "cpu" : key;
          const ind = getIndicatorHtml(key);
          const isYou = key === "p1" || key === "you";
          let avatarBadgeHtml = "";
          if (isYou) {
            const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
            if (avMgr && typeof avMgr.getSelectedAvatarId === "function") {
              avatarBadgeHtml = `<span class="score-chip-avatar" id="scoreChipAvatarYou">${avMgr.renderAvatarBadge(avMgr.getSelectedAvatarId(), { size: 20, showRing: false })}</span>`;
            }
          }
          return `<span class="score-chip ${cls}" id="chip-${key}">${avatarBadgeHtml}<span id="${youCpuId}Label">${ind}${label}</span> <span id="${youCpuId}Score">0</span></span>`;
        }).join("");
        const nonChipEls = Array.from(topEl.children).filter((el) => !el.classList.contains("score-chip"));
        topEl.querySelectorAll(".score-chip").forEach((el) => el.remove());
        const temp = doc.createElement("div");
        temp.innerHTML = chipsHtml;
        while (temp.firstChild) {
          if (nonChipEls[0]) {
            topEl.insertBefore(temp.firstChild, nonChipEls[0]);
          } else {
            topEl.appendChild(temp.firstChild);
          }
        }
      } else {
        tracks.forEach((key) => {
          const youCpuId = key === "p1" && is2P ? "you" : key === "p2" && is2P ? "cpu" : key;
          const lbl = doc.getElementById(`${youCpuId}Label`);
          if (lbl) {
            const ind = getIndicatorHtml(key);
            lbl.innerHTML = `${ind}${pName2(key)}`;
          }
          const isYou = key === "p1" || key === "you";
          if (isYou) {
            const avEl = doc.getElementById("scoreChipAvatarYou");
            if (avEl) {
              const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
              if (avMgr && typeof avMgr.getSelectedAvatarId === "function") {
                avEl.innerHTML = avMgr.renderAvatarBadge(avMgr.getSelectedAvatarId(), { size: 20, showRing: false });
              }
            }
          }
        });
      }
    }
    /**
     * Resolves tooltip data for an element hovered on the cribbage board.
     * @param {Element} target
     * @param {Object} context
     * @returns {Object|null}
     */
    static getBoardTooltipData(target, context = {}) {
      if (!target) return null;
      const {
        state: state3,
        settings: settings3,
        pegState: pegState2,
        brand,
        getStreetOrTurnName: getStreetOrTurnName2,
        getSignConfigs: getSignConfigs2,
        getStopSignConfigs: getStopSignConfigs2,
        getJailConfigs: getJailConfigs2,
        getBarConfigs: getBarConfigs2,
        getTimeoutConfigs: getTimeoutConfigs2,
        getJumpConfigs: getJumpConfigs2,
        getDetourConfigs: getDetourConfigs2,
        getRoundAboutConfigs: getRoundAboutConfigs2,
        getNoPassingLanes: getNoPassingLanes2
      } = context;
      const pegEl = target.closest ? target.closest("[data-peg-who], .peg-group") : null;
      if (pegEl && (pegEl.dataset?.pegWho || pegEl.id && (pegEl.id.includes("p1") || pegEl.id.includes("p2")))) {
        const who = pegEl.dataset?.pegWho || (pegEl.id && pegEl.id.includes("p1") ? "p1" : "p2");
        const role = pegEl.dataset?.pegRole || (pegEl.id && pegEl.id.includes("front") ? "front" : "rear");
        const isFront = role === "front";
        const youCpu = who === "p1" ? "you" : "cpu";
        const name = who === "p1" ? state3?.names?.p1 || "Player" : state3?.names?.p2 || (settings3?.vsHuman ? "Opponent" : "Computer");
        const score = state3?.scores && (state3.scores[who] !== void 0 ? state3.scores[who] : state3.scores[youCpu]) || 0;
        const hole = pegState2 && pegState2[who] && pegState2[who][role] !== void 0 ? pegState2[who][role] : role === "front" ? score : state3?.prev && (state3.prev[who] !== void 0 ? state3.prev[who] : state3.prev[youCpu]) || 0;
        const targetH = settings3?.target || 121;
        const avId = _BoardRenderer.getTrackAvatarId(who, settings3);
        const av = AvatarManager.getAvatarById(avId);
        const avBadge = AvatarManager.renderAvatarBadge(av.id, { size: 22, showRing: true });
        return {
          icon: avBadge,
          title: `${isFront ? "Leading Peg" : "Trailing Peg"} \xB7 ${name}`,
          badge: `Hole ${hole}`,
          badgeClass: "peg",
          body: `${name} (${av.name}) ${isFront ? "front leading scoring peg" : "rear follow peg"}. Currently resting at Hole ${hole}.${who === "p1" ? " (Click peg to change persona)" : ""}`,
          detail: `Current Score: ${score} pts`,
          extra: hole >= targetH ? "\u2605 In Finish Cup" : `${Math.max(0, targetH - hole)} pts to win`
        };
      }
      const obstacleEl = target.closest("[data-obstacle]");
      if (obstacleEl) {
        const obs = obstacleEl.dataset.obstacle;
        const hole = parseInt(obstacleEl.dataset.hole || "0", 10);
        const step = obstacleEl.dataset.step ? parseInt(obstacleEl.dataset.step, 10) : null;
        const street = typeof getStreetOrTurnName2 === "function" ? getStreetOrTurnName2(hole) : "";
        if (obs === "detour-step") {
          return {
            icon: "\u26A0\uFE0F",
            title: `Detour Bypass \xB7 Step ${step} of 7`,
            badge: "DETOUR",
            badgeClass: "bypass",
            body: `Intermediate peg hole ${step} along the 7-hole detour bypass. Pegs advance step-by-step through here before re-entering the main track at Hole ${hole + 1}.`,
            detail: `Rejoins Track at Hole ${hole + 1}`,
            extra: "+7 Extra Holes"
          };
        }
        if (obs === "detour-box") {
          return {
            icon: "\u26A0\uFE0F",
            title: `Detour Loop Bypass (Hole ${hole})`,
            badge: "DETOUR",
            badgeClass: "bypass",
            body: `A 7-hole bypass loop triggered by landing on Hole ${hole}. Bypasses the main track and rejoins at Hole ${hole + 1}.`,
            detail: `Rejoins Track at Hole ${hole + 1}`,
            extra: "7-Hole Bypass Loop"
          };
        }
        if (obs === "roundabout-step") {
          return {
            icon: "\u{1F504}",
            title: `Round About Rotary \xB7 Hole ${step} of 7`,
            badge: "ROTARY",
            badgeClass: "rotary",
            body: `Rotary loop hole ${step} of 7. Pegs navigate around this scenic traffic circle before emerging back onto the track at Hole ${hole + 1}.`,
            detail: `Rejoins Track at Hole ${hole + 1}`,
            extra: "+7 Rotary Steps"
          };
        }
        if (obs === "roundabout-box") {
          return {
            icon: "\u{1F504}",
            title: `Round About Rotary (Hole ${hole})`,
            badge: "ROTARY",
            badgeClass: "rotary",
            body: `A 7-hole traffic rotary roundabout triggered by landing on Hole ${hole}. Takes your peg on a 7-step loop before rejoining at Hole ${hole + 1}.`,
            detail: `Rejoins Track at Hole ${hole + 1}`,
            extra: "7 Rotary Holes"
          };
        }
        if (obs === "roundabout-island") {
          return {
            icon: "\u{1F504}",
            title: `Rotary Island (Hole ${hole})`,
            badge: "ROTARY",
            badgeClass: "rotary",
            body: `Central rotary roundabout island. Pegs circle around this island between Hole ${hole} and Hole ${hole + 1}.`,
            detail: `Rotary at Hole ${hole}`,
            extra: street
          };
        }
        if (obs === "jail-step") {
          return {
            icon: "\u26D3\uFE0F",
            title: `Jail Escape \xB7 Step ${step} of 3`,
            badge: "JAIL",
            badgeClass: "trap",
            body: `Jail escape step ${step} of 3. Advance 1 step per missed turn to break out and return to track Hole ${hole}.`,
            detail: "Miss 3 Turns to Escape",
            extra: street
          };
        }
        if (obs === "jail-cell") {
          return {
            icon: "\u26D3\uFE0F",
            title: `County Jail Cell (Hole ${hole})`,
            badge: "JAIL TRAP",
            badgeClass: "trap",
            body: `Landing on Hole ${hole} locks your peg behind iron bars! You must miss 3 consecutive turns before escaping back to the track.`,
            detail: "Loss of 3 Turns",
            extra: street
          };
        }
        if (obs === "bar-step") {
          const stepNum = Number(step);
          const drinkNames = { 1: "Glass of Beer \u{1F37A}", 2: "Glass of Wine \u{1F377}", 3: "Shot Glass \u{1F943}" };
          const drinkName = drinkNames[stepNum] || `Drink ${step}`;
          const drinkIcons = { 1: "\u{1F37A}", 2: "\u{1F377}", 3: "\u{1F943}" };
          return {
            icon: drinkIcons[stepNum] || "\u{1F378}",
            title: `The Bar Lounge \xB7 ${drinkName} (Step ${step} of 3)`,
            badge: "THE BAR",
            badgeClass: "trap",
            body: `Lounge refreshment: enjoying a ${drinkName.toLowerCase()} (step ${step} of 3) before returning to the track at Hole ${hole}.`,
            detail: "Miss 3 Turns",
            extra: street
          };
        }
        if (obs === "bar-box" || obs === "bar-cell") {
          return {
            icon: "\u{1F37B}",
            title: `The Bar Lounge (Hole ${hole})`,
            badge: "LOUNGE TRAP",
            badgeClass: "trap",
            body: `Landing on Hole ${hole} sends your peg into The Bar for refreshments! Miss 3 turns while enjoying beer, wine, and shots.`,
            detail: "Loss of 3 Turns",
            extra: street
          };
        }
        if (obs === "timeout-step") {
          return {
            icon: "\u{1FA91}",
            title: `Timeout Corner \xB7 Penalty Stool (Step ${step} of 3)`,
            badge: "TIMEOUT",
            badgeClass: "trap",
            body: `Sitting on the penalty stool with the dunce cap: step ${step} of 3 before returning to the track at Hole ${hole}.`,
            detail: "Miss 3 Turns",
            extra: street
          };
        }
        if (obs === "timeout-box" || obs === "timeout-cell") {
          return {
            icon: "\u{1FA91}",
            title: `Timeout Corner (Hole ${hole})`,
            badge: "TIMEOUT TRAP",
            badgeClass: "trap",
            body: `Landing on Hole ${hole} sends your peg to the Timeout Corner! Sit on the penalty stool with the dunce cap for 3 turns.`,
            detail: "Loss of 3 Turns",
            extra: street
          };
        }
        if (obs === "jump-arrow") {
          const jId = obstacleEl.dataset.jumpId;
          const s = parseInt(obstacleEl.dataset.start, 10);
          const e = parseInt(obstacleEl.dataset.end, 10);
          const d = parseInt(obstacleEl.dataset.dest, 10);
          const isFwd = obstacleEl.dataset.forward === "true" || d > s;
          const isSingle = s === e;
          const spanStr = isSingle ? `Hole ${s}` : `Holes ${s}\u2013${e}`;
          return {
            icon: isFwd ? "\u{1F680}" : "\u21A9\uFE0F",
            title: `Jump ${jId}: ${spanStr} \u2794 Hole ${d}`,
            badge: isFwd ? `Jump +${d - s}` : `Jump -${s - d}`,
            badgeClass: isFwd ? "jump-fwd" : "jump-bwd",
            body: isFwd ? `Rocket leap! Landing on Hole ${s} instantly teleports your peg forward to Hole ${d}!` : `Hazardous pitfall! Landing on Holes ${s}\u2013${e} (3 peg holes) throws your peg backward to Hole ${d}.`,
            detail: `Trigger: ${spanStr} \u2794 Dest: ${d}`,
            extra: isFwd ? "\u26A1 Forward Boost (1 hole)" : "\u26A0\uFE0F Backward Hazard (3 holes)"
          };
        }
        if (obs === "sign-billboard") {
          const signId = parseInt(obstacleEl.dataset.signId || "1", 10);
          const signs = typeof getSignConfigs2 === "function" ? getSignConfigs2() : [];
          const signCfg = signs.find((s2) => s2.id === signId);
          const remCount = state3 && state3.signsState && state3.signsState[signId] ? state3.signsState[signId].length : signCfg ? signCfg.initialSigns.length : 0;
          const totalCount = signCfg ? signCfg.initialSigns.length : 0;
          const s = obstacleEl.dataset.start || (signCfg ? signCfg.start : "");
          const e = obstacleEl.dataset.end || (signCfg ? signCfg.end : "");
          return {
            icon: "\u{1FAA7}",
            title: `Road Sign Block ${signId}`,
            badge: `${remCount}/${totalCount} Signs`,
            badgeClass: "amber",
            body: `Interactive Road Signs zone spanning Holes ${s}\u2013${e}. Passing or landing here triggers road signs with points and effects! Click billboard to view.`,
            detail: `Active Holes ${s}\u2013${e}`,
            extra: "\u{1FAA7} Click to Inspect"
          };
        }
        if (obs === "stop-sign") {
          const hole2 = obstacleEl.dataset.hole || "";
          return {
            icon: "\u{1F6D1}",
            title: `Stop Sign (Hole ${hole2})`,
            badge: "STOP SIGN",
            badgeClass: "trap",
            body: `1-hole obstacle! When reached during counting (pegging, hand, or crib), counting stops immediately at this hole.`,
            detail: "Counting Stops Immediately",
            extra: "\u{1F6D1} Full Stop"
          };
        }
        if (obs === "no-passing") {
          const s = obstacleEl.dataset.start || "";
          const e = obstacleEl.dataset.end || "";
          const h = obstacleEl.dataset.hole || "";
          return {
            icon: "\u{1F6AB}",
            title: `No-Passing Single Lane (Holes ${s}\u2013${e})`,
            badge: "NO PASSING",
            badgeClass: "trap",
            body: `Narrow single-file track spanning Holes ${s}\u2013${e}. Pegs cannot jump or pass other pegs in this bottleneck lane!`,
            detail: `Bottleneck Zone: Holes ${s}\u2013${e}`,
            extra: street || (h ? `Hole ${h}` : "\u{1F6AB} Single File")
          };
        }
        if (obs === "sign-block") {
          const blockId = obstacleEl.dataset.blockId || "";
          const s = obstacleEl.dataset.start || "";
          const e = obstacleEl.dataset.end || "";
          return {
            icon: "\u{1FAA7}",
            title: `Road Sign Block ${blockId} (Holes ${s}\u2013${e})`,
            badge: "SIGN ZONE",
            badgeClass: "amber",
            body: `Interactive road signs zone covering Holes ${s}\u2013${e}. Pegs landing here or passing through reveal road signs with bonuses and penalties!`,
            detail: `Active Billboard Block ${blockId}`,
            extra: street || "\u{1FAA7} Road Signs"
          };
        }
        if (obs === "skunk-marker") {
          const sDefs = _BoardRenderer.getSkunkDefaults(settings3 && settings3.target || 481);
          const isDouble = hole === (settings3 && settings3.doubleSkunkMarkerHole || sDefs.doubleSkunkHole);
          return {
            icon: "\u{1F9A8}",
            title: isDouble ? `Double Skunk Line \xB7 Hole ${hole}` : `Skunk Line \xB7 Hole ${hole}`,
            badge: isDouble ? "DBL SKUNK" : "SKUNK",
            badgeClass: isDouble ? "trap" : "amber",
            body: isDouble ? `Critical margin! Players failing to reach Hole ${hole} when the winner finishes suffer a double skunk defeat (counts as 3 losses).` : `Single skunk threshold! Crossing Hole ${hole} before the winner crosses the finish cup saves you from being skunked (counts as 2 losses).`,
            detail: `Threshold at Hole ${hole}`,
            extra: isDouble ? "\u{1F9A8} 3-Point Loss Penalty" : "\u{1F9A8} 2-Point Loss Penalty"
          };
        }
        if (obs === "pints-space" || obs === "pints-drink") {
          const type = obstacleEl.dataset.type || "";
          const hole2 = obstacleEl.dataset.hole || "";
          const drinkingNames = {
            youDrink: { name: "You Drink", icon: "\u{1F37A}", desc: "Take a drink! Landing on this space requires the player to take a drink." },
            guysDrink: { name: "Guys Drink", icon: "\u{1F37B}", desc: "Guys Drink! All male players take a drink when someone lands here." },
            galsDrink: { name: "Gals Drink", icon: "\u{1F377}", desc: "Gals Drink! All female players take a drink when someone lands here." },
            leftDrink: { name: "Left Drinks", icon: "\u{1F448}", desc: "Player to your left takes a drink when you land on this space." },
            rightDrink: { name: "Right Drinks", icon: "\u{1F449}", desc: "Player to your right takes a drink when you land on this space." },
            everyoneDrink: { name: "Everyone Drinks", icon: "\u{1F942}", desc: "Social! Every player at the table takes a drink." },
            everyoneButYouDrink: { name: "Everyone But You", icon: "\u{1F389}", desc: "Celebration! Everyone except the pegging player takes a drink." },
            pickWhoDrinks: { name: "Pick Who Drinks", icon: "\u{1F3AF}", desc: "Target! Choose any player at the table to take a drink." }
          };
          const item = drinkingNames[type] || { name: "Drinking Space", icon: "\u{1F37A}", desc: "Take a drink!" };
          return {
            icon: item.icon,
            title: `${item.name} (Hole ${hole2})`,
            badge: "PINTS & PEGS",
            badgeClass: "amber",
            body: item.desc,
            detail: `Drinking Space at Hole ${hole2}`,
            extra: street || "\u{1F37B} Pints & Pegs"
          };
        }
        if (obs === "adult-space" || obs === "adult-dare") {
          const type = obstacleEl.dataset.type || "";
          const hole2 = obstacleEl.dataset.hole || "";
          const timed = obstacleEl.dataset.timed === "true" || obstacleEl.dataset.timed === true;
          const adultDefs = {
            loseClothing: { name: "You Lose Clothing", icon: "\u{1F459}", desc: "Player loses an article of clothing!" },
            gainClothing: { name: "You Gain Clothing", icon: "\u{1F9E5}", desc: "Player gains an article of clothing back!" },
            pickWhoLosesClothing: { name: "Pick Who Strips", icon: "\u{1F3AF}", desc: "Player picks who loses an article of clothing!" },
            rightLosesClothing: { name: "Right Neighbor Strips", icon: "\u{1F449}", desc: "Person to right loses an article of clothing!" },
            leftLosesClothing: { name: "Left Neighbor Strips", icon: "\u{1F448}", desc: "Person to left loses an article of clothing!" },
            removeClothingChoice: { name: "Remove Clothing Choice", icon: "\u2702\uFE0F", desc: "Remove an article of clothing off person of your choice!" },
            touchBreast: { name: "Touch Breast", icon: "\u{1F48B}", desc: "Timed adult dare: Touch breast!" },
            lickBreast: { name: "Lick Breast", icon: "\u{1F445}", desc: "Timed adult dare: Lick breast!" },
            suckBreast: { name: "Suck Breast", icon: "\u{1F444}", desc: "Timed adult dare: Suck breast!" },
            touchGenitals: { name: "Touch Genitals", icon: "\u2728", desc: "Timed adult dare: Touch genitals!" },
            lickGenitals: { name: "Lick Genitals", icon: "\u{1F445}", desc: "Timed adult dare: Lick genitals!" },
            suckGenitals: { name: "Suck Genitals", icon: "\u{1F444}", desc: "Timed adult dare: Suck genitals!" },
            fingerGenitals: { name: "Finger Genitals", icon: "\u{1F449}", desc: "Timed adult dare: Finger genitals!" },
            genitalIntercourse: { name: "Genital Intercourse", icon: "\u{1F525}", desc: "Timed adult dare: Genital intercourse!" },
            touchAnus: { name: "Touch Anus", icon: "\u{1F351}", desc: "Timed adult dare: Touch anus!" },
            lickAnus: { name: "Lick Anus", icon: "\u{1F445}", desc: "Timed adult dare: Lick anus!" },
            fingerAnus: { name: "Finger Anus", icon: "\u{1F449}", desc: "Timed adult dare: Finger anus!" },
            analIntercourse: { name: "Anal Intercourse", icon: "\u{1F525}", desc: "Timed adult dare: Anal intercourse!" }
          };
          const item = adultDefs[type] || { name: "Adult Challenge", icon: "\u{1F48B}", desc: "Adult challenge space!" };
          return {
            icon: item.icon,
            title: `${item.name} (Hole ${hole2})`,
            badge: timed ? "TIMED DARE" : "STRIP SPACE",
            badgeClass: timed ? "trap" : "amber",
            body: item.desc,
            detail: `${timed ? "Timed Dare" : "Strip Space"} at Hole ${hole2}`,
            extra: street || (timed ? "\u23F3 Timed Challenge" : "\u{1F48B} Skunked & Stripped")
          };
        }
      }
      const holeEl = target.closest("[data-hole]");
      if (holeEl) {
        const h = parseInt(holeEl.dataset.hole, 10);
        const targetHoles = settings3 && settings3.target || 121;
        const isGameHole = h === targetHoles;
        const street = typeof getStreetOrTurnName2 === "function" ? getStreetOrTurnName2(h) : "";
        if (h === 0) {
          return {
            icon: "\u{1F3C1}",
            title: "Starting Line \xB7 Hole 0",
            badge: "START",
            badgeClass: "",
            body: "The opening gate where pegs stage before cards are dealt and pegging begins.",
            detail: `${targetHoles} holes to win`,
            extra: "Preshow"
          };
        }
        if (isGameHole) {
          return {
            icon: "\u{1F3C6}",
            title: `Game Hole ${h} \xB7 Finish Cup`,
            badge: "VICTORY",
            badgeClass: "milestone",
            body: "The championship cup! Peg into or beyond this hole to win the cribbage match.",
            detail: `Target: ${targetHoles} Points`,
            extra: "\u{1F3C1} Finish Line"
          };
        }
        const isStopSign = settings3 && settings3.optStopSign && typeof getStopSignConfigs2 === "function" && getStopSignConfigs2().some((s) => s.hole === h);
        if (isStopSign) {
          return {
            icon: "\u{1F6D1}",
            title: `Stop Sign (Hole ${h})`,
            badge: "STOP SIGN",
            badgeClass: "trap",
            body: "1-hole obstacle! When reached during counting, counting stops immediately at this hole.",
            detail: "Counting Stops Immediately",
            extra: street
          };
        }
        const isJail = settings3 && settings3.optJail && typeof getJailConfigs2 === "function" && getJailConfigs2().some((j) => j.hole === h);
        if (isJail) {
          return {
            icon: "\u26D3\uFE0F",
            title: `Jail Trap (Hole ${h})`,
            badge: "JAIL TRAP",
            badgeClass: "trap",
            body: "Danger! Landing directly on this hole sends your peg behind iron bars for 3 turns.",
            detail: "Miss 3 Turns",
            extra: street
          };
        }
        const isBar = settings3 && settings3.optBar && typeof getBarConfigs2 === "function" && getBarConfigs2().some((b) => b.hole === h);
        if (isBar) {
          return {
            icon: "\u{1F378}",
            title: `The Bar Trap (Hole ${h})`,
            badge: "BAR TRAP",
            badgeClass: "trap",
            body: "Danger! Landing directly on this hole pulls your peg into the bar lounge for 3 turns.",
            detail: "Miss 3 Turns",
            extra: street
          };
        }
        const isTimeout = settings3 && settings3.optTimeout && typeof getTimeoutConfigs2 === "function" && getTimeoutConfigs2().some((t) => t.hole === h);
        if (isTimeout) {
          return {
            icon: "\u23F3",
            title: `Timeout Corner (Hole ${h})`,
            badge: "TIMEOUT TRAP",
            badgeClass: "trap",
            body: "Danger! Landing directly on this hole sends your peg to the timeout corner for 3 turns.",
            detail: "Miss 3 Turns",
            extra: street
          };
        }
        if (settings3 && settings3.optJump) {
          const jumps = typeof getJumpConfigs2 === "function" ? getJumpConfigs2() : ObstacleGeometry?.getJumpConfigs ? ObstacleGeometry.getJumpConfigs(settings3) : [];
          if (Array.isArray(jumps)) {
            const jumpTrigger = jumps.find((j) => j.isForward ? j.start === h : h >= j.start && h <= j.end);
            if (jumpTrigger) {
              const isFwd = jumpTrigger.isForward;
              return {
                icon: isFwd ? "\u{1F680}" : "\u21A9\uFE0F",
                title: `Jump ${jumpTrigger.id} Trigger \xB7 Hole ${h}`,
                badge: isFwd ? `Jump +${jumpTrigger.dest - jumpTrigger.start}` : `Pitfall -${jumpTrigger.start - jumpTrigger.dest}`,
                badgeClass: isFwd ? "jump-fwd" : "jump-bwd",
                body: isFwd ? `Rocket leap trigger! Landing on Hole ${h} immediately teleports your peg forward to Hole ${jumpTrigger.dest}!` : `Hazardous pitfall trigger! Landing on Hole ${h} throws your peg backward to Hole ${jumpTrigger.dest}.`,
                detail: `Teleports to Hole ${jumpTrigger.dest}`,
                extra: street
              };
            }
            const jumpDest = jumps.find((j) => j.dest === h);
            if (jumpDest) {
              return {
                icon: "\u{1F3AF}",
                title: `Jump ${jumpDest.id} Landing Pad \xB7 Hole ${h}`,
                badge: "JUMP DEST",
                badgeClass: "milestone",
                body: `Safe landing destination for Jump ${jumpDest.id} (originating from Hole ${jumpDest.start}).`,
                detail: `Destination from Hole ${jumpDest.start}`,
                extra: street
              };
            }
          }
        }
        if (settings3 && settings3.optDetour) {
          const detours = typeof getDetourConfigs2 === "function" ? getDetourConfigs2() : ObstacleGeometry?.getDetourConfigs ? ObstacleGeometry.getDetourConfigs(settings3) : [];
          const detour = Array.isArray(detours) ? detours.find((d) => d.hole === h) : null;
          if (detour) {
            return {
              icon: "\u26A0\uFE0F",
              title: `Detour Loop Trigger (Hole ${h})`,
              badge: "DETOUR",
              badgeClass: "bypass",
              body: `Detour branch point! Landing on Hole ${h} diverts your peg through a 7-hole bypass loop before re-entering at Hole ${h + 1}.`,
              detail: `Rejoins Track at Hole ${h + 1}`,
              extra: street
            };
          }
        }
        if (settings3 && settings3.optRoundAbout) {
          const roundabouts = typeof getRoundAboutConfigs2 === "function" ? getRoundAboutConfigs2() : ObstacleGeometry?.getRoundAboutConfigs ? ObstacleGeometry.getRoundAboutConfigs(settings3) : [];
          const rAbout = Array.isArray(roundabouts) ? roundabouts.find((r) => r.hole === h) : null;
          if (rAbout) {
            return {
              icon: "\u{1F504}",
              title: `Round About Rotary Trigger (Hole ${h})`,
              badge: "ROTARY",
              badgeClass: "rotary",
              body: `Rotary circle trigger! Landing on Hole ${h} sends your peg circling a 7-hole traffic rotary before rejoining at Hole ${h + 1}.`,
              detail: `Rejoins Track at Hole ${h + 1}`,
              extra: street
            };
          }
        }
        if (settings3 && settings3.optDice) {
          const diceConfigs = typeof getDiceConfigs === "function" ? getDiceConfigs() : ObstacleGeometry?.getDiceConfigs ? ObstacleGeometry.getDiceConfigs(settings3) : [];
          const dieHit = Array.isArray(diceConfigs) ? diceConfigs.find((d) => d.hole === h) : null;
          if (dieHit) {
            return {
              icon: "\u{1F3B2}",
              title: `Dice Space (Hole ${h})`,
              badge: "DICE",
              badgeClass: "rotary",
              body: `3-Die Challenge! Landing on Hole ${h} immediately rolls 3 dice for Direction (\xB1), Points (5..30), and Target Player!`,
              detail: `Roll The Dice at Hole ${h}`,
              extra: street
            };
          }
        }
        if (settings3 && (settings3.optWheel || settings3.optSpinningWheel)) {
          const wheelConfigs = typeof getWheelConfigs === "function" ? getWheelConfigs() : ObstacleGeometry?.getWheelConfigs ? ObstacleGeometry.getWheelConfigs(settings3) : [];
          const wheelHit = Array.isArray(wheelConfigs) ? wheelConfigs.find((w) => w.hole === h) : null;
          if (wheelHit) {
            return {
              icon: "\u{1F3A1}",
              title: `Spinning Wheel Space (Hole ${h})`,
              badge: "WHEEL",
              badgeClass: "rotary",
              body: `Spinning Wheel Prize Space! Landing on Hole ${h} spins the prize wheel for bonus points and game effects!`,
              detail: `Spin The Wheel at Hole ${h}`,
              extra: street
            };
          }
        }
        if (settings3 && settings3.optSign) {
          const signs = typeof getSignConfigs2 === "function" ? getSignConfigs2() : ObstacleGeometry?.getSignConfigs ? ObstacleGeometry.getSignConfigs(settings3) : [];
          const signZone = Array.isArray(signs) ? signs.find((s) => h >= s.start && h <= s.end) : null;
          if (signZone) {
            return {
              icon: "\u{1FAA7}",
              title: `Road Sign Block ${signZone.id} (Hole ${h})`,
              badge: "SIGN ZONE",
              badgeClass: "amber",
              body: `Interactive road signs zone covering Holes ${signZone.start}\u2013${signZone.end}. Pegs landing here or passing through reveal road signs with bonuses and penalties!`,
              detail: `Active Billboard Block ${signZone.id}`,
              extra: street
            };
          }
        }
        if (settings3 && settings3.optSkunkMarkers) {
          const sDefs = _BoardRenderer.getSkunkDefaults(targetHoles);
          const skHole = settings3.skunkMarkerHole || sDefs.skunkHole;
          const dblSkHole = settings3.doubleSkunkMarkerHole || sDefs.doubleSkunkHole;
          if (h === dblSkHole) {
            return {
              icon: "\u{1F9A8}",
              title: `Double Skunk Line \xB7 Hole ${h}`,
              badge: "DBL SKUNK",
              badgeClass: "trap",
              body: `Critical threshold! Opponents trailing behind this line when the winner finishes suffer a double skunk defeat (3 losses).`,
              detail: `Double Skunk at Hole ${h}`,
              extra: street
            };
          }
          if (h === skHole) {
            return {
              icon: "\u{1F9A8}",
              title: `Skunk Line \xB7 Hole ${h}`,
              badge: "SKUNK LINE",
              badgeClass: "amber",
              body: `Single skunk boundary! Players must cross Hole ${h} before the opponent finishes to avoid being skunked (2 losses).`,
              detail: `Skunk at Hole ${h}`,
              extra: street
            };
          }
        }
        if (settings3 && (settings3.optStopSign || settings3.optStopSigns || isClashTarget || brand === "clash")) {
          const stopSigns = typeof getStopSignConfigs2 === "function" ? getStopSignConfigs2() : ObstacleGeometry?.getStopSignConfigs ? ObstacleGeometry.getStopSignConfigs(settings3) : [];
          const stopSign = Array.isArray(stopSigns) ? stopSigns.find((s) => s.hole === h) : null;
          if (stopSign) {
            return {
              icon: "\u{1F6D1}",
              title: `Stop Sign \xB7 Hole ${h}`,
              badge: "STOP SIGN",
              badgeClass: "trap",
              body: `Mandatory halt! Any peg passing or landing on Hole ${h} must stop immediately, burning any remaining count points.`,
              detail: `Mandatory Stop at Hole ${h}`,
              extra: street
            };
          }
        }
        if (settings3 && (settings3.optNoPassingLanes || settings3.optNoPassing || isClashTarget || brand === "clash")) {
          const npLanes = typeof getNoPassingLanes2 === "function" ? getNoPassingLanes2() : ObstacleGeometry?.getNoPassingLanes ? ObstacleGeometry.getNoPassingLanes(settings3) : [];
          const np = Array.isArray(npLanes) ? npLanes.find((l) => h >= l.start && h <= l.end) : null;
          if (np) {
            return {
              icon: "\u{1F6AB}",
              title: `No-Passing Single Lane (Hole ${h})`,
              badge: "NO PASSING",
              badgeClass: "trap",
              body: `Narrow single-file track spanning Holes ${np.start}\u2013${np.end}. Pegs cannot pass other pegs in this lane!`,
              detail: `Lanes ${np.start}\u2013${np.end}`,
              extra: street
            };
          }
        }
        const isMilestone = h > 0 && h % 5 === 0;
        return {
          icon: isMilestone ? "\u{1F4CD}" : "\u26AA",
          title: `Track Hole ${h}`,
          badge: isMilestone ? `Hole ${h}` : "",
          badgeClass: isMilestone ? "milestone" : "",
          body: `Standard board hole along the ${street || "track"}. Pegs advance through here during gameplay.`,
          detail: `${Math.max(0, targetHoles - h)} holes to finish`,
          extra: street
        };
      }
      return null;
    }
    /**
     * Hides the active fancy tooltip immediately.
     */
    static hideFancyTooltip() {
      if (typeof document === "undefined") return;
      const tip = document.getElementById("boardFancyTooltip");
      if (!tip) return;
      tip.classList.remove("is-visible");
      tip.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        if (!tip.classList.contains("is-visible")) {
          tip.style.display = "none";
        }
      }, 120);
    }
    /**
     * Displays the fancy interactive tooltip card at given viewport coordinates.
     * @param {Object} data
     * @param {number} clientX
     * @param {number} clientY
     */
    static showFancyTooltip(data, clientX, clientY) {
      if (typeof document === "undefined" || !data) return;
      const tip = document.getElementById("boardFancyTooltip");
      if (!tip) return;
      tip.innerHTML = `
      <div class="bft-header">
        <span class="bft-icon">${data.icon || "\u{1F518}"}</span>
        <div class="bft-title-wrap">
          <span class="bft-title">${data.title}</span>
        </div>
        ${data.badge ? `<span class="bft-badge ${data.badgeClass || ""}">${data.badge}</span>` : ""}
      </div>
      ${data.body ? `<div class="bft-body">${data.body}</div>` : ""}
      ${data.detail || data.extra ? `
        <div class="bft-footer">
          <span class="bft-detail">${data.detail || ""}</span>
          <span class="bft-extra">${data.extra || ""}</span>
        </div>
      ` : ""}
    `;
      tip.style.display = "block";
      tip.setAttribute("aria-hidden", "false");
      _BoardRenderer.positionFancyTooltip(clientX, clientY);
      if (typeof requestAnimationFrame !== "undefined") {
        requestAnimationFrame(() => {
          tip.classList.add("is-visible");
        });
      } else {
        tip.classList.add("is-visible");
      }
    }
    /**
     * Positions the fancy tooltip card within viewport bounds.
     * @param {number} clientX
     * @param {number} clientY
     */
    static positionFancyTooltip(clientX, clientY) {
      if (typeof document === "undefined") return;
      const tip = document.getElementById("boardFancyTooltip");
      if (!tip || tip.style.display === "none") return;
      const pad = 14;
      const tipW = tip.offsetWidth || 230;
      const tipH = tip.offsetHeight || 80;
      let x = clientX + pad;
      let y = clientY + pad;
      const winW = typeof window !== "undefined" ? window.innerWidth : 1e3;
      const winH = typeof window !== "undefined" ? window.innerHeight : 800;
      if (x + tipW > winW - 12) x = clientX - tipW - pad;
      if (x < 10) x = 10;
      if (y + tipH > winH - 12) y = clientY - tipH - pad;
      if (y < 10) y = 10;
      tip.style.left = `${x}px`;
      tip.style.top = `${y}px`;
    }
    /**
     * Initializes fancy interactive tooltips on the board.
     */
    static initBoardFancyTooltips(containerOrContext = null, maybeContext = {}) {
      if (typeof document === "undefined") return;
      let container = null;
      let context = {};
      if (containerOrContext && (containerOrContext.nodeType || typeof containerOrContext.addEventListener === "function")) {
        container = containerOrContext;
        context = maybeContext || {};
      } else if (containerOrContext && typeof containerOrContext === "object") {
        context = containerOrContext;
        container = null;
      } else {
        context = maybeContext || {};
      }
      const cribBoard = container || document.getElementById("cribBoard");
      if (!cribBoard || cribBoard._fancyTooltipsInited) return;
      cribBoard._fancyTooltipsInited = true;
      let _boardTooltipTimer = null;
      let _boardTooltipRaf = null;
      let _currentTooltipTarget = null;
      const showFancyTooltip = (data, clientX, clientY) => {
        _currentTooltipTarget = _currentTooltipTarget || document.body;
        _BoardRenderer.showFancyTooltip(data, clientX, clientY);
      };
      const positionFancyTooltip = (clientX, clientY) => {
        _BoardRenderer.positionFancyTooltip(clientX, clientY);
      };
      const hideFancyTooltip2 = () => {
        const tip = document.getElementById("boardFancyTooltip");
        if (!tip) return;
        _currentTooltipTarget = null;
        if (_boardTooltipRaf) {
          cancelAnimationFrame(_boardTooltipRaf);
          _boardTooltipRaf = null;
        }
        tip.classList.remove("is-visible");
        tip.setAttribute("aria-hidden", "true");
        if (_boardTooltipTimer) clearTimeout(_boardTooltipTimer);
        _boardTooltipTimer = setTimeout(() => {
          if (!tip.classList.contains("is-visible")) {
            tip.style.display = "none";
          }
        }, 120);
      };
      const resolveContext = () => {
        const liveCtx = typeof window !== "undefined" && typeof window.getBoardTooltipContext === "function" ? window.getBoardTooltipContext() : _BoardRenderer.getBoardTooltipContext(context);
        return { ...context, ...liveCtx };
      };
      cribBoard.addEventListener("pointerover", (e) => {
        const data = _BoardRenderer.getBoardTooltipData(e.target, resolveContext());
        if (data) {
          _currentTooltipTarget = e.target;
          showFancyTooltip(data, e.clientX, e.clientY);
        } else if (_currentTooltipTarget && !cribBoard.contains(e.target)) {
          hideFancyTooltip2();
        }
      });
      cribBoard.addEventListener("pointermove", (e) => {
        const tip = document.getElementById("boardFancyTooltip");
        if (!tip || tip.style.display === "none") {
          const data = _BoardRenderer.getBoardTooltipData(e.target, resolveContext());
          if (data) {
            _currentTooltipTarget = e.target;
            showFancyTooltip(data, e.clientX, e.clientY);
          }
          return;
        }
        const matchingEl = e.target.closest("[data-hole], [data-obstacle], [data-peg-who], .peg-group");
        if (matchingEl && matchingEl !== _currentTooltipTarget) {
          const data = _BoardRenderer.getBoardTooltipData(e.target, resolveContext());
          if (data) {
            _currentTooltipTarget = matchingEl;
            showFancyTooltip(data, e.clientX, e.clientY);
          }
        }
        positionFancyTooltip(e.clientX, e.clientY);
      });
      cribBoard.addEventListener("pointerout", (e) => {
        if (!e.relatedTarget || !cribBoard.contains(e.relatedTarget)) {
          hideFancyTooltip2();
        }
      });
      cribBoard.addEventListener("pointerdown", hideFancyTooltip2);
      if (typeof window !== "undefined") {
        window.addEventListener("scroll", hideFancyTooltip2, { passive: true });
      }
    }
    /**
     * Constructs the interactive collapsible accordion legend.
     */
    static createLegend(context = {}) {
      if (typeof document === "undefined") return null;
      const { brand = "crazy", settings: settings3 = {}, adultOptions = [], obstacleConfigs = {} } = context;
      const container = document.createElement("div");
      container.className = "clash-legend-container";
      container.id = "clashLegendContainer";
      const isCollapsed = typeof window !== "undefined" && window._clashLegendCollapsed !== void 0 ? Boolean(window._clashLegendCollapsed) : true;
      const isPintsMode = brand === "pints";
      const isAdultMode = brand === "adult";
      let blocks = [];
      if (isAdultMode && Array.isArray(adultOptions) && adultOptions.length > 0) {
        blocks = adultOptions.map((opt) => {
          const active2 = Boolean(settings3 && settings3[opt.chkId]);
          const count = settings3 && settings3[opt.key + "Count"] || 2;
          const pegs = settings3 && settings3[opt.key + "Pegs"] || 1;
          const pegStr = pegs > 1 ? ` (${pegs} Pegs)` : "";
          const timedDesc = opt.timed ? " Landing triggers an interactive timer (15\u2013120s) and alarm!" : "";
          return {
            id: opt.key,
            title: `${opt.name}${pegStr}`,
            icon: opt.icon,
            badgeColor: opt.color,
            badgeBg: `${opt.color}2e`,
            active: active2,
            count,
            desc: `${opt.actionText}.${timedDesc}`,
            selector: `#serpentineBoard [data-adult-key="${opt.key}"]`
          };
        });
      } else if (isPintsMode) {
        const pintsDefs = [
          { id: "youDrink", name: "You Drink", chkId: "optYouDrink", icon: "\u{1F37A}", color: "#f59e0b", desc: "Take a drink! Landing on this space requires the player to take a drink." },
          { id: "guysDrink", name: "Guys Drink", chkId: "optGuysDrink", icon: "\u{1F37B}", color: "#06b6d4", desc: "Gentlemen drink! Landing on this space requires all guys playing to take a drink." },
          { id: "galsDrink", name: "Gals Drink", chkId: "optGalsDrink", icon: "\u{1F377}", color: "#ec4899", desc: "Ladies drink! Landing on this space requires all gals playing to take a drink." },
          { id: "leftDrink", name: "Left Drinks", chkId: "optLeftDrink", icon: "\u{1F448}", color: "#8b5cf6", desc: "Player to the left drinks! Landing on this space requires the player to your left to drink." },
          { id: "rightDrink", name: "Right Drinks", chkId: "optRightDrink", icon: "\u{1F449}", color: "#3b82f6", desc: "Player to the right drinks! Landing on this space requires the player to your right to drink." },
          { id: "everyoneDrink", name: "Everyone Drinks", chkId: "optEveryoneDrink", icon: "\u{1F942}", color: "#10b981", desc: "Everyone drinks! Landing on this space requires all players to take a drink." },
          { id: "everyoneButYouDrink", name: "Everyone But You", chkId: "optEveryoneButYouDrink", icon: "\u{1F389}", color: "#f97316", desc: "Everyone else drinks! Landing on this space requires all players except you to drink." },
          { id: "pickWhoDrinks", name: "Pick Who Drinks", chkId: "optPickWhoDrinks", icon: "\u{1F3AF}", color: "#e11d48", desc: "Pick who drinks! Landing on this space allows you to choose any player to take a drink." }
        ];
        blocks = pintsDefs.map((dt) => {
          const active2 = Boolean(settings3 && settings3[dt.chkId]);
          const count = settings3 && settings3[dt.id + "Count"] || 2;
          const pegs = settings3 && settings3[dt.id + "Pegs"] || 1;
          const pegStr = pegs > 1 ? ` (${pegs} Pegs)` : "";
          return {
            id: dt.id,
            title: `${dt.name}${pegStr}`,
            icon: dt.icon,
            badgeColor: dt.color,
            badgeBg: `${dt.color}2e`,
            active: active2,
            count,
            desc: dt.desc,
            selector: `#serpentineBoard .hole-${dt.id.replace(/([A-Z])/g, "-$1").toLowerCase()}`
          };
        });
      } else {
        const npLanes = obstacleConfigs.noPassingLanes || [];
        const jumps = obstacleConfigs.jumps || [];
        const jails = obstacleConfigs.jails || [];
        const bars = obstacleConfigs.bars || [];
        const timeouts = obstacleConfigs.timeouts || [];
        const detours = obstacleConfigs.detours || [];
        const roundabouts = obstacleConfigs.roundabouts || [];
        const signs = obstacleConfigs.signs || [];
        const stopSigns = obstacleConfigs.stopSigns || [];
        const dice = obstacleConfigs.dice || [];
        blocks = [
          {
            id: "noPassing",
            title: "No Passing Lane",
            icon: "\u{1F6AB}",
            badgeColor: "#00e5ff",
            badgeBg: "rgba(0, 229, 255, 0.15)",
            active: Boolean(settings3 && settings3.optNoPassingLanes),
            count: npLanes.length || 4,
            desc: "Single-file bottleneck zone. Opponent pegs cannot pass while inside this lane \u2014 must wait behind.",
            selector: "#serpentineBoard .hole-no-passing-lane, #serpentineBoard .no-passing-lane-bg"
          },
          {
            id: "jump",
            title: "Jump",
            icon: "\u2197",
            badgeColor: "#22c55e",
            badgeBg: "rgba(34, 197, 94, 0.18)",
            active: Boolean(settings3 && settings3.optJump),
            count: jumps.length || 8,
            desc: "Instant leap! Forward jumps are 1 hole; backward jumps span 3 holes. Green arrows propel forward; Red arrows drop backward.",
            selector: "#serpentineBoard #jumpsLayer"
          },
          {
            id: "jail",
            title: "Jail Cell",
            icon: "\u26D3\uFE0F",
            badgeColor: "#f59e0b",
            badgeBg: "rgba(245, 158, 11, 0.18)",
            active: Boolean(settings3 && settings3.optJail),
            count: jails.length || 2,
            desc: "Prison trap! Lock behind bars and miss 3 turns (1 step per missed turn) before escaping.",
            selector: "#serpentineBoard #jailsLayer"
          },
          {
            id: "bar",
            title: "The Bar",
            icon: "\u{1F378}",
            badgeColor: "#fb923c",
            badgeBg: "rgba(251, 146, 60, 0.18)",
            active: Boolean(settings3 && settings3.optBar),
            count: bars.length || 2,
            desc: "Lounge trap! Stopped for drinks \u2014 miss 3 turns (1 step per missed turn) before returning.",
            selector: "#serpentineBoard #barsLayer"
          },
          {
            id: "timeout",
            title: "Timeout Corner",
            icon: "\u23F3",
            badgeColor: "#c084fc",
            badgeBg: "rgba(192, 132, 252, 0.18)",
            active: Boolean(settings3 && settings3.optTimeout),
            count: timeouts.length || 2,
            desc: "Penalty corner! Sent to cool off \u2014 miss 3 turns (1 step per missed turn) before release.",
            selector: "#serpentineBoard #timeoutsLayer"
          },
          {
            id: "detour",
            title: "Detour Loop",
            icon: "\u{1F504}",
            badgeColor: "#fbbf24",
            badgeBg: "rgba(251, 191, 36, 0.18)",
            active: Boolean(settings3 && settings3.optDetour),
            count: detours.length || 2,
            desc: "Forced diversion! Peg must travel an extra 7-hole road loop before rejoining the track.",
            selector: "#serpentineBoard #detoursLayer"
          },
          {
            id: "roundabout",
            title: "Roundabout",
            icon: "\u{1F500}",
            badgeColor: "#00e5ff",
            badgeBg: "rgba(0, 229, 255, 0.18)",
            active: Boolean(settings3 && settings3.optRoundAbout),
            count: roundabouts.length || 2,
            desc: "Traffic circle! Navigate 7 rotary holes around the roundabout before continuing along track.",
            selector: "#serpentineBoard #roundAboutsLayer"
          },
          {
            id: "signs",
            title: "Road Signs",
            icon: "\u{1FAA7}",
            badgeColor: "#34d399",
            badgeBg: "rgba(52, 211, 153, 0.18)",
            active: Boolean(settings3 && settings3.optSigns),
            count: signs.length || 4,
            desc: "Billboard zone! Landing here draws random action cards with point bonuses or penalties.",
            selector: "#serpentineBoard #signsLayer"
          },
          {
            id: "stopsign",
            title: "Stop Sign",
            icon: "\u{1F6D1}",
            badgeColor: "#ef4444",
            badgeBg: "rgba(239, 68, 68, 0.18)",
            active: Boolean(settings3 && settings3.optStopSign),
            count: stopSigns.length || 2,
            desc: "1-hole trap! When reached, counting stops immediately (pegging, hand, or crib).",
            selector: "#serpentineBoard #stopSignsLayer, #serpentineBoard .hole-stop-sign"
          },
          {
            id: "dice",
            title: "Dice",
            icon: "\u{1F3B2}",
            badgeColor: "#a855f7",
            badgeBg: "rgba(168, 85, 247, 0.18)",
            active: Boolean(settings3 && settings3.optDice),
            count: dice.length || 4,
            desc: "3-Die challenge space! Landing here rolls 3 dice for direction (\xB1), point values (5..30), and target player.",
            selector: "#serpentineBoard #diceLayer, #serpentineBoard .hole-dice-trigger"
          },
          {
            id: "wheel",
            title: "Spinning Wheel",
            icon: "\u{1F3A1}",
            badgeColor: "#ec4899",
            badgeBg: "rgba(236, 72, 153, 0.18)",
            active: Boolean(settings3 && (settings3.optWheel || settings3.optSpinningWheel)),
            count: (obstacleConfigs.wheels || []).length || 4,
            desc: "Spinning Wheel challenge space! Landing here spins the prize wheel for bonus points and effects.",
            selector: "#serpentineBoard #wheelsLayer, #serpentineBoard .hole-wheel-trigger"
          },
          {
            id: "skunkMarkers",
            title: "Skunk Markers",
            icon: "\u{1F9A8}",
            badgeColor: "#94a3b8",
            badgeBg: "rgba(148, 163, 184, 0.18)",
            active: Boolean(settings3 && settings3.optSkunkMarkers),
            count: 2,
            desc: "Milestone markers measuring victory margins. Skunk at 75% of route; Double Skunk at 50% of route.",
            selector: "#serpentineBoard #skunkMarkersLayer"
          }
        ];
      }
      const legendTitle = isAdultMode ? "Skunked and Stripped Action Legend" : isPintsMode ? "Pints and Pegs Rules Legend" : "Crazy Cribbage Obstacles Legend";
      const legendIcon = isAdultMode ? "\u{1F525}" : isPintsMode ? "\u{1F37A}" : "\u{1F3B2}";
      container.innerHTML = `
      <div class="clash-legend-header">
        <div class="clash-legend-title">
          <span class="clash-legend-icon">${legendIcon}</span>
          <span>${legendTitle}</span>
          <span class="clash-legend-hint">(hover to highlight)</span>
        </div>
        <button type="button" class="clash-legend-toggle-btn" id="btnToggleClashLegend" aria-expanded="${!isCollapsed}" title="Toggle Legend View">
          <span id="clashLegendToggleIcon">${isCollapsed ? "\uFF0B" : "\u2212"}</span>
          <span id="clashLegendToggleText">${isCollapsed ? "Show" : "Hide"}</span>
        </button>
      </div>
      <div class="clash-legend-grid ${isCollapsed ? "collapsed" : ""}" id="clashLegendGrid">
        ${blocks.map((b) => `
          <div class="clash-legend-card ${b.active ? "active-block" : "inactive-block"}" data-block-id="${b.id}" data-selector="${b.selector}" title="${b.title} (${b.active ? "Active on board" : "Disabled"})">
            <div class="clash-legend-card-header">
              <span class="clash-legend-badge" style="background:${b.badgeBg}; color:${b.badgeColor}; border: 1px solid ${b.badgeColor}40;">
                ${b.icon} ${b.title}
              </span>
              <span class="clash-legend-status ${b.active ? "status-active" : "status-off"}">
                ${b.active ? `${b.count} On Board` : "Off"}
              </span>
            </div>
            <div class="clash-legend-card-body">
              ${b.desc}
            </div>
          </div>
        `).join("")}
      </div>
    `;
      const toggleBtn = container.querySelector("#btnToggleClashLegend");
      const grid = container.querySelector("#clashLegendGrid");
      const toggleIcon = container.querySelector("#clashLegendToggleIcon");
      const toggleText = container.querySelector("#clashLegendToggleText");
      if (toggleBtn && grid) {
        toggleBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          const nowCollapsed = !grid.classList.contains("collapsed");
          if (typeof window !== "undefined") window._clashLegendCollapsed = nowCollapsed;
          grid.classList.toggle("collapsed", nowCollapsed);
          toggleBtn.setAttribute("aria-expanded", String(!nowCollapsed));
          if (toggleIcon) toggleIcon.textContent = nowCollapsed ? "\uFF0B" : "\u2212";
          if (toggleText) toggleText.textContent = nowCollapsed ? "Show" : "Hide";
        });
      }
      const cards = container.querySelectorAll(".clash-legend-card");
      cards.forEach((card) => {
        const sel = card.getAttribute("data-selector");
        if (!sel) return;
        const setHighlight = (enable) => {
          try {
            const els = document.querySelectorAll(sel);
            els.forEach((el) => {
              if (enable) el.classList.add("legend-highlight-pulse");
              else el.classList.remove("legend-highlight-pulse");
            });
          } catch (err) {
          }
        };
        card.addEventListener("mouseenter", () => setHighlight(true));
        card.addEventListener("mouseleave", () => setHighlight(false));
        card.addEventListener("click", () => {
          setHighlight(true);
          setTimeout(() => setHighlight(false), 2e3);
        });
      });
      return container;
    }
    /**
     * Helper to map seat ID to peg gradient ID, respecting custom peg skins for Player 1.
     * @param {string} who
     * @param {Object} [settings={}]
     * @returns {string}
     */
    static getPegGradId(who, settings3 = {}) {
      const isP1 = who === "p1" || who === "you" || who === "team1";
      if (isP1 && settings3 && settings3.pegSkin && settings3.pegSkin !== "brass" && settings3.pegSkin !== "classic" && settings3.pegSkin !== "avatar") {
        return `pegSkin_${settings3.pegSkin}`;
      }
      if (isP1) return "pegP1Grad";
      if (who === "p2" || who === "cpu" || who === "team2") return "pegP2Grad";
      if (who === "p3") return "pegP3Grad";
      if (who === "p4") return "pegP4Grad";
      if (who === "p5") return "pegP5Grad";
      if (who === "p6") return "pegP6Grad";
      if (who === "p7" || who === "team3") return "pegP7Grad";
      if (who === "p8" || who === "team4") return "pegP8Grad";
      return "pegP1Grad";
    }
    /**
     * Helper to resolve the assigned avatar persona ID for a given track/seat.
     * @param {string} who
     * @param {Object} [settings={}]
     * @returns {string}
     */
    static getTrackAvatarId(who, settings3 = {}) {
      const isP1 = who === "p1" || who === "you" || who === "team1";
      if (isP1) {
        const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
        return avMgr ? avMgr.getSelectedAvatarId() : "joker";
      }
      if (settings3 && Array.isArray(settings3.seats)) {
        const s = settings3.seats.find((x) => x && (x.id === who || who === "cpu" && x.id === "p2"));
        if (s && s.avatar) {
          if (s.avatar === "custom" && !isP1) {
            return "custom_" + s.id;
          }
          return s.avatar;
        }
      }
      if (who === "p2" || who === "cpu" || who === "team2") {
        const isVsHuman = Boolean(settings3 && (settings3.vsHuman || settings3.isHvH || settings3.opp === "human"));
        if (isVsHuman) return "queen";
        const rawProf = settings3 && settings3.optAiProfile || "shark";
        const avatarMap = {
          master: "king",
          maverick: "steampunk",
          regular: "velvet_fox",
          casual: "pint_master",
          rookie: "jack",
          gambler: "gambler",
          turtler: "turtler",
          shark: "shark"
        };
        if (avatarMap[rawProf]) return avatarMap[rawProf];
        const aiProfile = typeof window !== "undefined" && window.CribbageAI?.normalizeProfile ? window.CribbageAI.normalizeProfile(rawProf) : rawProf;
        return avatarMap[aiProfile] || "shark";
      }
      const multiplayerAvatars = {
        p3: "pint_master",
        p4: "steampunk",
        p5: "clash_helm",
        p6: "velvet_fox",
        p7: "cannon_commander",
        p8: "lightning_29",
        team3: "pint_master",
        team4: "steampunk"
      };
      return multiplayerAvatars[who] || "jack";
    }
    /**
     * Resolves track accent color for rims and halo badges.
     * @param {string} who
     * @returns {string}
     */
    static getTrackColor(who) {
      const colors = {
        p1: "#d4a017",
        you: "#d4a017",
        team1: "#d4a017",
        p2: "#ef4444",
        cpu: "#ef4444",
        team2: "#ef4444",
        p3: "#10b981",
        p4: "#3b82f6",
        p5: "#a855f7",
        p6: "#ec4899",
        p7: "#f97316",
        team3: "#10b981",
        p8: "#06b6d4",
        team4: "#3b82f6"
      };
      return colors[who] || "#d4a017";
    }
    /**
     * Generates SVG inner markup for a 2D cribbage peg.
     * Implements Phase 2: custom avatar medallion fill, high-contrast track rim,
     * glossy 3D dome reflection for front pegs, and dimmed indicator for rear follow pegs.
     * @param {string} who
     * @param {string} role ('front' | 'rear')
     * @param {Object} [settings={}]
     * @returns {string}
     */
    static buildPegSvgContent(who, role, settings3 = {}) {
      const isFront = role === "front";
      const isP1 = who === "p1" || who === "you" || who === "team1";
      const trackColor = _BoardRenderer.getTrackColor(who);
      const skin = settings3 && settings3.pegSkin;
      const hasCustomMetallicSkin = isP1 && skin && skin !== "brass" && skin !== "classic" && skin !== "avatar";
      if (hasCustomMetallicSkin) {
        const gradId = `pegSkin_${skin}`;
        return `
        <circle cx="0" cy="0" r="${isFront ? "5.2" : "4.4"}"
                fill="url(#${gradId})"
                stroke="#1a1208" stroke-width="0.8"
                opacity="${isFront ? "1" : "0.85"}"
                data-peg-who="${who}" data-peg-role="${role}" />
        <circle cx="-1.2" cy="-1.4" r="1.4" fill="#ffffff" opacity="0.6"
                data-peg-who="${who}" data-peg-role="${role}" />
      `;
      }
      const patId = `pegAvatarPattern_${who}`;
      const outerR = isFront ? "5.8" : "4.6";
      const innerR = isFront ? "5.2" : "4.0";
      const strokeW = isFront ? "1.2" : "1.0";
      const opacity = isFront ? "1.0" : "0.85";
      return `
      <!-- Bezel halo / track color rim -->
      <circle cx="0" cy="0" r="${outerR}"
              fill="#1a1208" stroke="${trackColor}" stroke-width="${strokeW}"
              opacity="${opacity}"
              data-peg-who="${who}" data-peg-role="${role}" />
      <!-- Avatar medallion fill -->
      <circle cx="0" cy="0" r="${innerR}"
              fill="url(#${patId})"
              opacity="${opacity}"
              data-peg-who="${who}" data-peg-role="${role}" />
      ${!isFront ? `
        <!-- Trailing follow peg subtle dim overlay -->
        <circle cx="0" cy="0" r="${innerR}" fill="#000000" opacity="0.18" pointer-events="none" />
        <circle cx="-1.0" cy="-1.0" r="1.1" fill="#ffffff" opacity="0.4" pointer-events="none" />
      ` : `
        <!-- Leading scoring peg 3D glossy reflection -->
        <ellipse cx="-1.4" cy="-1.6" rx="2.1" ry="1.2" fill="#ffffff" opacity="0.45"
                 transform="rotate(-25 -1.4 -1.6)" pointer-events="none" />
      `}
    `;
    }
    /**
     * Returns gradient colors and border styling for the selected woodwork finish.
     * @param {string} [finishKey='maple']
     * @returns {Object}
     */
    static getBoardFinishConfig(finishKey = "maple") {
      const finishes = {
        maple: {
          stops: [
            { offset: "0%", color: "#eed5ad" },
            { offset: "45%", color: "#e2c191" },
            { offset: "80%", color: "#d4af7a" },
            { offset: "100%", color: "#c69e67" }
          ],
          stroke: "#6b3a12",
          innerStroke: "rgba(255, 240, 215, 0.45)"
        },
        walnut: {
          stops: [
            { offset: "0%", color: "#5a3d28" },
            { offset: "45%", color: "#442b1a" },
            { offset: "80%", color: "#2f1a0e" },
            { offset: "100%", color: "#1f1008" }
          ],
          stroke: "#150904",
          innerStroke: "rgba(225, 185, 150, 0.3)"
        },
        cherry: {
          stops: [
            { offset: "0%", color: "#8c3523" },
            { offset: "45%", color: "#6e2315" },
            { offset: "80%", color: "#4a1309" },
            { offset: "100%", color: "#2d0804" }
          ],
          stroke: "#240603",
          innerStroke: "rgba(255, 200, 190, 0.35)"
        },
        obsidian: {
          stops: [
            { offset: "0%", color: "#2a2632" },
            { offset: "45%", color: "#181520" },
            { offset: "80%", color: "#100e16" },
            { offset: "100%", color: "#09070c" }
          ],
          stroke: "#d4af37",
          innerStroke: "rgba(234, 179, 8, 0.4)"
        },
        driftwood: {
          stops: [
            { offset: "0%", color: "#cbd5e1" },
            { offset: "45%", color: "#94a3b8" },
            { offset: "80%", color: "#64748b" },
            { offset: "100%", color: "#475569" }
          ],
          stroke: "#334155",
          innerStroke: "rgba(241, 245, 249, 0.5)"
        }
      };
      return finishes[finishKey] || finishes.maple;
    }
    /**
     * Helper to get skunk default hole numbers.
     */
    static getSkunkDefaults(target = 121) {
      const t = Number(target) || 121;
      if (t === 481) return { skunkHole: 360, doubleSkunkHole: 240 };
      if (t === 361) return { skunkHole: 270, doubleSkunkHole: 180 };
      if (t === 241) return { skunkHole: 180, doubleSkunkHole: 120 };
      return { skunkHole: 90, doubleSkunkHole: 60 };
    }
    /**
     * Constructs the full SVG cribbage board with obstacle overlays, milestone markers,
     * player pegs, and interactive legend.
     * @param {Object} options
     * @returns {Element|null}
     */
    static buildBoard(options = {}) {
      if (typeof document === "undefined") return null;
      const {
        root = document.getElementById("boardTracks"),
        settings: settings3 = {},
        state: state3 = {},
        pegState: pegState2 = {},
        brand = "crazy",
        activeTracks = ["p1", "p2"],
        getTrackXYFn = null,
        getTrackXY: optGetTrackXY = null,
        obstacleConfigs = {},
        obstacleStepHelpers = {},
        pintsConfigs = [],
        adultConfigs = [],
        createLegendFn = null,
        onAfterRender = null
      } = options;
      if (!root) return null;
      const signature = _BoardRenderer.getBoardSignature(settings3, activeTracks, brand);
      if (typeof window !== "undefined") {
        window._currentBoardSignature = signature;
      }
      root.innerHTML = "";
      const isClashBrand = brand === "clash";
      const isClashTarget2 = isClashBrand && (!settings3?.target || [241, 361, 481].includes(Number(settings3.target)));
      const clashTarget = [241, 361, 481].includes(Number(settings3?.target)) ? Number(settings3.target) : 481;
      const curCfg = isClashTarget2 ? getClashBoardCfg(clashTarget) : BOARD_CFG;
      const boardViewW = curCfg.viewW;
      const boardViewH = curCfg.viewH;
      const cribBoard = (root && root.closest ? root.closest(".board") : null) || (typeof document !== "undefined" ? document.getElementById("cribBoard") : null);
      const splitContainer = typeof document !== "undefined" ? document.querySelector(".table.split") : null;
      if (settings3 && settings3.boardViewMode === "none") {
        if (cribBoard) {
          cribBoard.classList.remove("is-3d-board", "is-3d-room-mode");
          cribBoard.classList.add("is-no-board");
        }
        if (splitContainer) {
          splitContainer.classList.remove("is-3d-room-mode");
        }
        if (root) {
          root.innerHTML = "";
          root.style.display = "none";
        }
        if (typeof window !== "undefined" && window._currentRenderer3D) {
          window._currentRenderer3D.destroy();
          window._currentRenderer3D = null;
        }
        const staleResizeHandle2 = typeof document !== "undefined" ? document.getElementById("board3DResizeHandle") : null;
        if (staleResizeHandle2) {
          try {
            if (typeof staleResizeHandle2.remove === "function") {
              staleResizeHandle2.remove();
            } else if (staleResizeHandle2.parentNode) {
              staleResizeHandle2.parentNode.removeChild(staleResizeHandle2);
            }
          } catch (_) {
          }
        }
        if (typeof onAfterRender === "function") {
          onAfterRender();
        }
        return null;
      }
      if (cribBoard) {
        cribBoard.classList.remove("is-no-board");
      }
      if (root) {
        const isMin = cribBoard && cribBoard.classList.contains("is-minimized");
        root.style.display = isMin ? "none" : "";
      }
      const is3DMode = Boolean(settings3 && (settings3.boardViewMode === "3d" || settings3.boardViewMode === "room3d" || settings3.boardViewMode === "room3d-fullscreen"));
      const isRoom3D = Boolean(settings3 && (settings3.boardViewMode === "room3d" || settings3.boardViewMode === "room3d-fullscreen"));
      if (splitContainer) {
        splitContainer.classList.toggle("is-3d-room-mode", isRoom3D);
      }
      if (is3DMode) {
        if (cribBoard) {
          cribBoard.classList.add("is-3d-board");
          cribBoard.classList.toggle("is-3d-room-mode", isRoom3D);
        }
        const allowedBoards = Board3DCatalog.getBoards(brand);
        const isAllowed = allowedBoards.some((b) => b.id === settings3.selected3DBoardId);
        const boardConfig = isAllowed && Board3DCatalog.getBoardById(settings3.selected3DBoardId) || allowedBoards[0] || Board3DCatalog.getBoardById(settings3.selected3DBoardId);
        if (boardConfig && boardConfig.id && settings3) {
          settings3.selected3DBoardId = boardConfig.id;
        }
        if (typeof window !== "undefined" && window._currentRenderer3D) {
          window._currentRenderer3D.destroy();
          window._currentRenderer3D = null;
        }
        const oldResizeHandle = typeof document !== "undefined" ? document.getElementById("board3DResizeHandle") : null;
        if (oldResizeHandle) {
          try {
            if (typeof oldResizeHandle.remove === "function") {
              oldResizeHandle.remove();
            } else if (oldResizeHandle.parentNode) {
              oldResizeHandle.parentNode.removeChild(oldResizeHandle);
            }
          } catch (_) {
          }
        }
        let savedHeight = null;
        try {
          if (typeof localStorage !== "undefined") {
            savedHeight = parseInt(localStorage.getItem("cc_board_3d_height"), 10);
          }
        } catch (_) {
        }
        const hasValidSavedHeight = Boolean(savedHeight && !isNaN(savedHeight) && savedHeight >= 140 && savedHeight <= 1600);
        const wrap2 = document.createElement("div");
        wrap2.className = "board-container board-3d-container is-resizable";
        wrap2.id = "board3DContainer";
        const defaultRoom3DHeight = "height: clamp(540px, 75vh, 920px); min-height: 520px; aspect-ratio: auto;";
        const heightStyle = isRoom3D ? hasValidSavedHeight ? `height: ${savedHeight}px; min-height: 480px; aspect-ratio: auto;` : defaultRoom3DHeight : hasValidSavedHeight ? `height: ${savedHeight}px; aspect-ratio: auto;` : `aspect-ratio: ${boardViewW} / ${boardViewH};`;
        wrap2.style.cssText = `width: 100%; ${heightStyle} min-height: 140px; max-height: 85vh; position: relative; overflow: hidden; border-radius: 12px;`;
        root.appendChild(wrap2);
        let roomLoader = null;
        if (is3DMode && !options.skipLoader) {
          try {
            const loaderCls = typeof Room3DLoadingOverlay2 !== "undefined" ? Room3DLoadingOverlay2 : typeof window !== "undefined" ? window.Room3DLoadingOverlay : null;
            if (loaderCls && typeof loaderCls.show === "function") {
              const activeLoader = loaderCls.getActive();
              roomLoader = activeLoader || loaderCls.show(wrap2, {
                settings: settings3,
                is3DOnly: !isRoom3D,
                cardBack: settings3?.cardBack,
                theme: settings3?.roomTheme || settings3?.tableEnvironment,
                deck: typeof window !== "undefined" ? window.FULL_DECK : null
              });
            }
          } catch (err) {
            console.warn("[BoardRenderer] Could not mount Room3DLoadingOverlay:", err);
          }
        }
        const resizeHandle = document.createElement("div");
        resizeHandle.className = "board-3d-resize-handle";
        resizeHandle.id = "board3DResizeHandle";
        resizeHandle.setAttribute("role", "separator");
        resizeHandle.setAttribute("aria-orientation", "horizontal");
        resizeHandle.setAttribute("tabindex", "0");
        resizeHandle.setAttribute("title", "Drag to resize 3D board vertically (Double-click to reset height)");
        resizeHandle.innerHTML = `
        <div class="board-3d-resize-grip" aria-hidden="true"></div>
        <div class="board-3d-resize-label"><span>\u21C5 3D Board Height</span></div>
        <div class="board-3d-resize-grip" aria-hidden="true"></div>
      `;
        root.appendChild(resizeHandle);
        let r3d = null;
        let isDragging = false;
        let startY = 0;
        let startH = 0;
        const updateHeight = (newH) => {
          const maxH = typeof window !== "undefined" ? Math.round(window.innerHeight * 0.85) : 800;
          const clampedH = Math.round(Math.max(140, Math.min(maxH, newH)));
          wrap2.style.height = `${clampedH}px`;
          wrap2.style.aspectRatio = "auto";
          try {
            if (typeof localStorage !== "undefined") {
              localStorage.setItem("cc_board_3d_height", String(clampedH));
            }
          } catch (_) {
          }
          if (r3d && r3d.engine) {
            r3d.engine.resize();
          }
          return clampedH;
        };
        const onPointerMove = (e) => {
          if (!isDragging) return;
          if (e.cancelable) e.preventDefault();
          const clientY = e.touches && e.touches[0] ? e.touches[0].clientY : e.clientY;
          const deltaY = clientY - startY;
          updateHeight(startH + deltaY);
        };
        const onPointerUp = () => {
          if (!isDragging) return;
          isDragging = false;
          resizeHandle.classList.remove("dragging");
          if (typeof document !== "undefined") {
            document.body.classList.remove("is-board-3d-resizing");
          }
          window.removeEventListener("pointermove", onPointerMove);
          window.removeEventListener("pointerup", onPointerUp);
          window.removeEventListener("touchmove", onPointerMove);
          window.removeEventListener("touchend", onPointerUp);
          if (r3d && r3d.handleResize) {
            r3d.handleResize();
          }
        };
        const onPointerDown = (e) => {
          if (e.button !== void 0 && e.button !== 0) return;
          isDragging = true;
          startY = e.touches && e.touches[0] ? e.touches[0].clientY : e.clientY;
          startH = wrap2.getBoundingClientRect().height;
          resizeHandle.classList.add("dragging");
          if (typeof document !== "undefined") {
            document.body.classList.add("is-board-3d-resizing");
          }
          window.addEventListener("pointermove", onPointerMove, { passive: false });
          window.addEventListener("pointerup", onPointerUp);
          window.addEventListener("touchmove", onPointerMove, { passive: false });
          window.addEventListener("touchend", onPointerUp);
        };
        const resetHeight = () => {
          try {
            if (typeof localStorage !== "undefined") {
              localStorage.removeItem("cc_board_3d_height");
            }
          } catch (_) {
          }
          wrap2.style.height = "";
          wrap2.style.aspectRatio = `${boardViewW} / ${boardViewH}`;
          if (r3d) {
            if (r3d.fitBoardToViewBox) {
              r3d.fitBoardToViewBox(true);
            }
            if (r3d.handleResize) {
              r3d.handleResize();
            }
          }
        };
        resizeHandle.addEventListener("pointerdown", onPointerDown);
        resizeHandle.addEventListener("dblclick", resetHeight);
        resizeHandle.addEventListener("keydown", (e) => {
          if (e.key === "ArrowUp") {
            e.preventDefault();
            const curH = wrap2.getBoundingClientRect().height;
            updateHeight(curH - 25);
          } else if (e.key === "ArrowDown") {
            e.preventDefault();
            const curH = wrap2.getBoundingClientRect().height;
            updateHeight(curH + 25);
          } else if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            resetHeight();
          }
        });
        wrap2.addEventListener("mouseup", () => {
          const curH = wrap2.getBoundingClientRect().height;
          if (curH && curH >= 140) {
            try {
              if (typeof localStorage !== "undefined") {
                localStorage.setItem("cc_board_3d_height", String(Math.round(curH)));
              }
            } catch (_) {
            }
          }
        });
        r3d = new BoardRenderer3D(wrap2, {
          boardConfig,
          activeTracks,
          settings: settings3,
          boardViewW,
          boardViewH,
          brand,
          obstacleConfigs,
          getTrackXYFn,
          onProgress: (statusText, percent) => {
            const loaderCls = typeof Room3DLoadingOverlay2 !== "undefined" ? Room3DLoadingOverlay2 : typeof window !== "undefined" ? window.Room3DLoadingOverlay : null;
            if (loaderCls && typeof loaderCls.updateProgress === "function") {
              loaderCls.updateProgress(statusText, percent);
            } else if (roomLoader && typeof roomLoader.updateProgress === "function") {
              roomLoader.updateProgress(statusText, percent);
            }
          },
          onReady: (inst) => {
            const loaderCls = typeof Room3DLoadingOverlay2 !== "undefined" ? Room3DLoadingOverlay2 : typeof window !== "undefined" ? window.Room3DLoadingOverlay : null;
            if (loaderCls && typeof loaderCls.markRendererReady === "function") {
              loaderCls.markRendererReady(inst);
            } else if (roomLoader && typeof roomLoader.markRendererReady === "function") {
              roomLoader.markRendererReady(inst);
            }
            if (typeof window !== "undefined") window._currentRenderer3D = inst;
            inst.updatePegs(state3?.scores || {}, state3?.prev || {}, false);
            if (typeof inst.syncFromGameState === "function") {
              inst.syncFromGameState({ state: state3, settings: settings3 });
            }
            if (typeof window !== "undefined" && window.crazyCribbageApp && typeof window.crazyCribbageApp.updateBoardViewToggleBtn === "function") {
              window.crazyCribbageApp.updateBoardViewToggleBtn();
            }
            if (typeof window !== "undefined" && window.crazyCribbageApp && typeof window.crazyCribbageApp.syncInGameBoardSelector === "function") {
              window.crazyCribbageApp.syncInGameBoardSelector();
            }
            if (typeof onAfterRender === "function") onAfterRender();
            if (settings3 && settings3.boardViewMode === "room3d-fullscreen") {
              try {
                const gameEl = typeof document !== "undefined" ? document.getElementById("game") : null;
                const menuVariants = typeof document !== "undefined" ? document.getElementById("menuVariants") : null;
                const isGameActive = Boolean(gameEl && !gameEl.classList.contains("hidden"));
                const isVariantsOpen = Boolean(menuVariants && !menuVariants.classList.contains("hidden"));
                if (isGameActive && !isVariantsOpen && typeof inst.enterFullScreen === "function") {
                  inst.enterFullScreen();
                }
              } catch (fsErr) {
                console.warn("[BoardRenderer] Error entering fullscreen onReady:", fsErr);
              }
            }
          },
          onError: (err) => {
            const loaderCls = typeof Room3DLoadingOverlay2 !== "undefined" ? Room3DLoadingOverlay2 : typeof window !== "undefined" ? window.Room3DLoadingOverlay : null;
            if (loaderCls && typeof loaderCls.hideImmediate === "function") {
              loaderCls.hideImmediate();
            } else if (roomLoader && typeof roomLoader.close === "function") {
              roomLoader.close(false);
            }
            console.error("[BoardRenderer3D] Babylon failed to initialize, falling back to 2D:", err);
            if (cribBoard) cribBoard.classList.remove("is-3d-board");
            settings3.boardViewMode = "2d";
            const el = typeof document !== "undefined" ? document.getElementById("optBoardView") : null;
            if (el) el.value = "2d";
            const elModal = typeof document !== "undefined" ? document.getElementById("optBoardViewModal") : null;
            if (elModal) elModal.value = "2d";
            if (typeof window !== "undefined" && window.crazyCribbageApp && typeof window.crazyCribbageApp.updateBoardViewToggleBtn === "function") {
              window.crazyCribbageApp.updateBoardViewToggleBtn();
            }
            _BoardRenderer.buildBoard(options);
          }
        });
        return wrap2;
      }
      if (cribBoard) cribBoard.classList.remove("is-3d-board", "is-3d-room-mode");
      if (splitContainer) splitContainer.classList.remove("is-3d-room-mode");
      if (typeof window !== "undefined" && window._currentRenderer3D) {
        window._currentRenderer3D.destroy();
        window._currentRenderer3D = null;
      }
      const staleResizeHandle = typeof document !== "undefined" ? document.getElementById("board3DResizeHandle") : null;
      if (staleResizeHandle) {
        try {
          if (typeof staleResizeHandle.remove === "function") {
            staleResizeHandle.remove();
          } else if (staleResizeHandle.parentNode) {
            staleResizeHandle.parentNode.removeChild(staleResizeHandle);
          }
        } catch (_) {
        }
      }
      const wrap = document.createElement("div");
      wrap.className = "board-container";
      const bgX = 15;
      const bgY = isClashTarget2 ? 12 : 14;
      const bgW = boardViewW - 30;
      const bgH = boardViewH - (isClashTarget2 ? 24 : 28);
      const bgRx = isClashTarget2 ? 16 : 14;
      const svg2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg2.id = "serpentineBoard";
      svg2.setAttribute("viewBox", `0 0 ${boardViewW} ${boardViewH}`);
      const finishCfg = _BoardRenderer.getBoardFinishConfig(settings3?.boardFinish || "maple");
      const boardWoodStops = finishCfg.stops.map((s) => `<stop offset="${s.offset}" stop-color="${s.color}" />`).join("\n          ");
      const allPegTracks = Array.from(/* @__PURE__ */ new Set([...Array.isArray(activeTracks) ? activeTracks : [], "p1", "you", "p2", "cpu"]));
      const pegPatternsDefs = allPegTracks.map((w) => {
        const avId = _BoardRenderer.getTrackAvatarId(w, settings3);
        return AvatarManager.getAvatarPatternSvg(avId, `pegAvatarPattern_${w}`);
      }).join("\n        ");
      svg2.innerHTML = `
      <defs>
        <radialGradient id="holeGrad" cx="35%" cy="35%" r="70%">
          <stop offset="0%" stop-color="#020101" />
          <stop offset="60%" stop-color="#120803" />
          <stop offset="100%" stop-color="#241005" />
        </radialGradient>
        <linearGradient id="boardWoodGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          ${boardWoodStops}
        </linearGradient>
        <linearGradient id="pegP1Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#ffffff" />
          <stop offset="35%" stop-color="#f3d7a0" />
          <stop offset="85%" stop-color="#d4a017" />
          <stop offset="100%" stop-color="#7a5500" />
        </linearGradient>
        <linearGradient id="pegP2Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fff0ea" />
          <stop offset="35%" stop-color="#f87171" />
          <stop offset="85%" stop-color="#dc2626" />
          <stop offset="100%" stop-color="#7f1d1d" />
        </linearGradient>
        <linearGradient id="pegP3Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#ecfdf5" />
          <stop offset="35%" stop-color="#34d399" />
          <stop offset="85%" stop-color="#059669" />
          <stop offset="100%" stop-color="#064e3b" />
        </linearGradient>
        <linearGradient id="pegP4Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#eff6ff" />
          <stop offset="35%" stop-color="#60a5fa" />
          <stop offset="85%" stop-color="#2563eb" />
          <stop offset="100%" stop-color="#1e3a8a" />
        </linearGradient>
        <linearGradient id="pegP5Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#f5d0fe" />
          <stop offset="35%" stop-color="#c084fc" />
          <stop offset="85%" stop-color="#a855f7" />
          <stop offset="100%" stop-color="#581c87" />
        </linearGradient>
        <linearGradient id="pegP6Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#ffedd5" />
          <stop offset="35%" stop-color="#fb923c" />
          <stop offset="85%" stop-color="#ea580c" />
          <stop offset="100%" stop-color="#7c2d12" />
        </linearGradient>
        <linearGradient id="pegP7Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#cffafe" />
          <stop offset="35%" stop-color="#22d3ee" />
          <stop offset="85%" stop-color="#0891b2" />
          <stop offset="100%" stop-color="#164e63" />
        </linearGradient>
        <linearGradient id="pegP8Grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fce7f3" />
          <stop offset="35%" stop-color="#f472b6" />
          <stop offset="85%" stop-color="#db2777" />
          <stop offset="100%" stop-color="#831843" />
        </linearGradient>
        <!-- Custom Peg Skins -->
        <linearGradient id="pegSkin_brass" href="#pegP1Grad" />
        <linearGradient id="pegSkin_silver" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#ffffff" />
          <stop offset="35%" stop-color="#e2e8f0" />
          <stop offset="85%" stop-color="#94a3b8" />
          <stop offset="100%" stop-color="#334155" />
        </linearGradient>
        <linearGradient id="pegSkin_cherry" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fed7aa" />
          <stop offset="35%" stop-color="#f87171" />
          <stop offset="85%" stop-color="#b91c1c" />
          <stop offset="100%" stop-color="#450a0a" />
        </linearGradient>
        <linearGradient id="pegSkin_walnut" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#e7dfd5" />
          <stop offset="35%" stop-color="#a88b73" />
          <stop offset="85%" stop-color="#5c4028" />
          <stop offset="100%" stop-color="#27180d" />
        </linearGradient>
        <linearGradient id="pegSkin_glow" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#ecfeff" />
          <stop offset="35%" stop-color="#38bdf8" />
          <stop offset="85%" stop-color="#0284c7" />
          <stop offset="100%" stop-color="#0369a1" />
        </linearGradient>
        <linearGradient id="pegYouGrad" href="#pegP1Grad" />
        <linearGradient id="pegCpuGrad" href="#pegP2Grad" />
        <linearGradient id="pegTeam1Grad" href="#pegP1Grad" />
        <linearGradient id="pegTeam2Grad" href="#pegP2Grad" />
        <linearGradient id="pegTeam3Grad" href="#pegP7Grad" />
        <linearGradient id="pegTeam4Grad" href="#pegP8Grad" />
        <filter id="pegShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="2.5" stdDeviation="1.8" flood-color="#000" flood-opacity="0.65" />
        </filter>
        <marker id="jumpArrowGreen" viewBox="0 0 10 10" refX="6" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill="#22c55e" />
        </marker>
        <marker id="jumpArrowRed" viewBox="0 0 10 10" refX="6" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill="#ef4444" />
        </marker>
        <!-- Phase 2: Avatar Medallion Peg Patterns -->
        ${pegPatternsDefs}
      </defs>
      <rect x="${bgX}" y="${bgY}" width="${bgW}" height="${bgH}" rx="${bgRx}"
            fill="url(#boardWoodGrad)" stroke="${finishCfg.stroke}" stroke-width="3" />
      <rect x="${bgX + 3}" y="${bgY + 3}" width="${bgW - 6}" height="${bgH - 6}" rx="${bgRx - 2}"
            fill="none" stroke="${finishCfg.innerStroke}" stroke-width="1.2" />
      <g id="jumpsLayer"></g>
      <g id="jailsLayer"></g>
      <g id="barsLayer"></g>
      <g id="timeoutsLayer"></g>
      <g id="detoursLayer"></g>
      <g id="roundAboutsLayer"></g>
      <g id="signsLayer"></g>
      <g id="stopSignsLayer"></g>
      <g id="diceLayer"></g>
      <g id="wheelsLayer"></g>
      <g id="trackHoles"></g>
      <g id="skunkMarkersLayer"></g>
      <g id="pegsLayer"></g>
    `;
      root.appendChild(wrap);
      wrap.appendChild(svg2);
      const jumpsGroup = svg2.querySelector("#jumpsLayer");
      const jailsGroup = svg2.querySelector("#jailsLayer");
      const barsGroup = svg2.querySelector("#barsLayer");
      const timeoutsGroup = svg2.querySelector("#timeoutsLayer");
      const detoursGroup = svg2.querySelector("#detoursLayer");
      const roundAboutsGroup = svg2.querySelector("#roundAboutsLayer");
      const signsGroup = svg2.querySelector("#signsLayer");
      const stopSignsGroup = svg2.querySelector("#stopSignsLayer");
      const diceGroup = svg2.querySelector("#diceLayer");
      const wheelsGroup = svg2.querySelector("#wheelsLayer");
      const skunkMarkersGroup = svg2.querySelector("#skunkMarkersLayer");
      const holesGroup = svg2.querySelector("#trackHoles");
      const targetHoles = isClashTarget2 ? clashTarget : settings3.target === 61 ? 61 : settings3.target === 31 ? 31 : 121;
      const actualTrackXYFn = getTrackXYFn || optGetTrackXY;
      const getTrackXY3 = (h, who) => typeof actualTrackXYFn === "function" ? actualTrackXYFn(h, who, targetHoles) : getTrackXY(h, who, targetHoles, settings3);
      const refTrack = activeTracks[0] || "p1";
      const isClashObstaclesActive = brand === "clash";
      const jumps = isClashObstaclesActive ? obstacleConfigs.jumps || ObstacleGeometry.getJumpConfigs(settings3) : [];
      if (isClashObstaclesActive && settings3.optJump && jumpsGroup && Array.isArray(jumps)) {
        jumps.forEach((j) => {
          if (j.start > targetHoles && j.dest > targetHoles) return;
          const sHole = Math.min(targetHoles, j.isForward ? j.start : j.start + 1);
          const dHole = Math.min(targetHoles, j.dest);
          const pStart = getTrackXY3(sHole, refTrack);
          const pEnd = getTrackXY3(dHole, refTrack);
          const dx2 = pEnd.x - pStart.x;
          const dy2 = pEnd.y - pStart.y;
          const dist2 = Math.hypot(dx2, dy2);
          if (dist2 < 4) return;
          const mx = (pStart.x + pEnd.x) / 2;
          const my = (pStart.y + pEnd.y) / 2;
          const nx = -dy2 / dist2;
          const ny = dx2 / dist2;
          let arcSign = -1;
          if (Math.abs(dy2) < 15) {
            arcSign = my > (isClashTarget2 ? curCfg.viewH / 2 : BOARD_CFG.st2Y) ? 1 : -1;
          } else {
            arcSign = j.isForward ? -1 : 1;
          }
          const curveHeight = Math.max(16, Math.min(45, dist2 * 0.25)) * arcSign;
          const cx = mx + nx * curveHeight;
          const cy = my + ny * curveHeight;
          const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
          path.setAttribute("d", `M ${pStart.x} ${pStart.y} Q ${cx} ${cy} ${pEnd.x} ${pEnd.y}`);
          path.classList.add(j.isForward ? "jump-arrow-forward" : "jump-arrow-backward");
          path.setAttribute("marker-end", j.isForward ? "url(#jumpArrowGreen)" : "url(#jumpArrowRed)");
          path.setAttribute("pointer-events", "stroke");
          path.dataset.obstacle = "jump-arrow";
          path.dataset.jumpId = String(j.id);
          path.dataset.start = String(j.start);
          path.dataset.end = String(j.end);
          path.dataset.dest = String(j.dest);
          path.dataset.forward = String(j.isForward);
          jumpsGroup.appendChild(path);
        });
      }
      const jails = isClashObstaclesActive ? obstacleConfigs.jails || ObstacleGeometry.getJailConfigs(settings3) : [];
      const getJailStepXY2 = obstacleStepHelpers.getJailStepXY || ((h, s, w) => ObstacleGeometry.getJailStepXY(h, s, w, settings3, getTrackXY3));
      if (isClashObstaclesActive && settings3.optJail && jailsGroup && Array.isArray(jails)) {
        jails.forEach((j) => {
          if (j.hole > targetHoles) return;
          const pTrack = getTrackXY3(j.hole, refTrack);
          const cellPos = getJailStepXY2(j.hole, 0, refTrack);
          const pathLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
          pathLine.setAttribute("x1", cellPos.x);
          pathLine.setAttribute("y1", cellPos.y);
          pathLine.setAttribute("x2", pTrack.x);
          pathLine.setAttribute("y2", pTrack.y);
          pathLine.classList.add("jail-path-line");
          pathLine.dataset.obstacle = "jail-cell";
          pathLine.dataset.hole = String(j.hole);
          jailsGroup.appendChild(pathLine);
          for (let s = 1; s <= 3; s++) {
            const stepPos = getJailStepXY2(j.hole, s, refTrack);
            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("cx", stepPos.x);
            circle.setAttribute("cy", stepPos.y);
            circle.setAttribute("r", "2");
            circle.classList.add("hole-jail-path");
            circle.dataset.obstacle = "jail-step";
            circle.dataset.hole = String(j.hole);
            circle.dataset.step = String(s);
            jailsGroup.appendChild(circle);
          }
          const boxW = 22;
          const boxH = 22;
          const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
          rect.setAttribute("x", cellPos.x - boxW / 2);
          rect.setAttribute("y", cellPos.y - boxH / 2);
          rect.setAttribute("width", boxW);
          rect.setAttribute("height", boxH);
          rect.setAttribute("rx", "4");
          rect.classList.add("jail-cell-box");
          rect.dataset.obstacle = "jail-cell";
          rect.dataset.hole = String(j.hole);
          jailsGroup.appendChild(rect);
          [-5, 0, 5].forEach((dx2) => {
            const bar = document.createElementNS("http://www.w3.org/2000/svg", "line");
            bar.setAttribute("x1", cellPos.x + dx2);
            bar.setAttribute("y1", cellPos.y - boxH / 2 + 2.5);
            bar.setAttribute("x2", cellPos.x + dx2);
            bar.setAttribute("y2", cellPos.y + boxH / 2 - 2.5);
            bar.classList.add("jail-cell-bar");
            bar.style.pointerEvents = "none";
            jailsGroup.appendChild(bar);
          });
          const cellHole = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          cellHole.setAttribute("cx", cellPos.x);
          cellHole.setAttribute("cy", cellPos.y);
          cellHole.setAttribute("r", "3.6");
          cellHole.classList.add("hole-jail-cell");
          cellHole.dataset.obstacle = "jail-cell";
          cellHole.dataset.hole = String(j.hole);
          jailsGroup.appendChild(cellHole);
        });
      }
      const bars = isClashObstaclesActive ? obstacleConfigs.bars || ObstacleGeometry.getBarConfigs(settings3) : [];
      const getBarStepXY2 = obstacleStepHelpers.getBarStepXY || ((h, s, w) => ObstacleGeometry.getBarStepXY(h, s, w, settings3, getTrackXY3));
      if (isClashObstaclesActive && settings3.optBar && barsGroup && Array.isArray(bars)) {
        bars.forEach((b) => {
          if (b.hole > targetHoles) return;
          const pTrack = getTrackXY3(b.hole, refTrack);
          const barPos = getBarStepXY2(b.hole, 0, refTrack);
          const pathLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
          pathLine.setAttribute("x1", barPos.x);
          pathLine.setAttribute("y1", barPos.y);
          pathLine.setAttribute("x2", pTrack.x);
          pathLine.setAttribute("y2", pTrack.y);
          pathLine.classList.add("bar-path-line");
          pathLine.dataset.obstacle = "bar-box";
          pathLine.dataset.hole = String(b.hole);
          barsGroup.appendChild(pathLine);
          for (let s = 1; s <= 3; s++) {
            const stepPos = getBarStepXY2(b.hole, s, refTrack);
            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("cx", stepPos.x);
            circle.setAttribute("cy", stepPos.y);
            circle.setAttribute("r", "2");
            circle.classList.add("hole-bar-path");
            circle.dataset.obstacle = "bar-step";
            circle.dataset.hole = String(b.hole);
            circle.dataset.step = String(s);
            barsGroup.appendChild(circle);
          }
          const boxW = 24;
          const boxH = 22;
          const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
          rect.setAttribute("x", barPos.x - boxW / 2);
          rect.setAttribute("y", barPos.y - boxH / 2);
          rect.setAttribute("width", boxW);
          rect.setAttribute("height", boxH);
          rect.setAttribute("rx", "5");
          rect.classList.add("bar-lounge-box");
          rect.dataset.obstacle = "bar-box";
          rect.dataset.hole = String(b.hole);
          barsGroup.appendChild(rect);
          const counter = document.createElementNS("http://www.w3.org/2000/svg", "line");
          counter.setAttribute("x1", barPos.x - boxW / 2 + 3);
          counter.setAttribute("y1", barPos.y - boxH / 2 + 4);
          counter.setAttribute("x2", barPos.x + boxW / 2 - 3);
          counter.setAttribute("y2", barPos.y - boxH / 2 + 4);
          counter.classList.add("bar-counter-line");
          counter.style.pointerEvents = "none";
          barsGroup.appendChild(counter);
          const drinkIcon = document.createElementNS("http://www.w3.org/2000/svg", "path");
          const ix = barPos.x + 5;
          const iy = barPos.y - 1;
          drinkIcon.setAttribute("d", `M ${ix - 3.5} ${iy - 4} L ${ix + 3.5} ${iy - 4} L ${ix} ${iy} Z M ${ix} ${iy} L ${ix} ${iy + 4} M ${ix - 2.5} ${iy + 4} L ${ix + 2.5} ${iy + 4}`);
          drinkIcon.classList.add("bar-icon");
          drinkIcon.style.pointerEvents = "none";
          barsGroup.appendChild(drinkIcon);
          const barHole = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          barHole.setAttribute("cx", barPos.x - 4);
          barHole.setAttribute("cy", barPos.y + 1);
          barHole.setAttribute("r", "3.4");
          barHole.classList.add("hole-bar-lounge");
          barHole.dataset.obstacle = "bar-box";
          barHole.dataset.hole = String(b.hole);
          barsGroup.appendChild(barHole);
        });
      }
      const timeouts = isClashObstaclesActive ? obstacleConfigs.timeouts || ObstacleGeometry.getTimeoutConfigs(settings3) : [];
      const getTimeoutStepXY2 = obstacleStepHelpers.getTimeoutStepXY || ((h, s, w) => ObstacleGeometry.getTimeoutStepXY(h, s, w, settings3, getTrackXY3));
      if (isClashObstaclesActive && settings3.optTimeout && timeoutsGroup && Array.isArray(timeouts)) {
        timeouts.forEach((t) => {
          if (t.hole > targetHoles) return;
          const pTrack = getTrackXY3(t.hole, refTrack);
          const timeoutPos = getTimeoutStepXY2(t.hole, 0, refTrack);
          const pathLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
          pathLine.setAttribute("x1", timeoutPos.x);
          pathLine.setAttribute("y1", timeoutPos.y);
          pathLine.setAttribute("x2", pTrack.x);
          pathLine.setAttribute("y2", pTrack.y);
          pathLine.classList.add("timeout-path-line");
          pathLine.dataset.obstacle = "timeout-box";
          pathLine.dataset.hole = String(t.hole);
          timeoutsGroup.appendChild(pathLine);
          for (let s = 1; s <= 3; s++) {
            const stepPos = getTimeoutStepXY2(t.hole, s, refTrack);
            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("cx", stepPos.x);
            circle.setAttribute("cy", stepPos.y);
            circle.setAttribute("r", "2");
            circle.classList.add("hole-timeout-path");
            circle.dataset.obstacle = "timeout-step";
            circle.dataset.hole = String(t.hole);
            circle.dataset.step = String(s);
            timeoutsGroup.appendChild(circle);
          }
          const boxW = 24;
          const boxH = 22;
          const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
          rect.setAttribute("x", timeoutPos.x - boxW / 2);
          rect.setAttribute("y", timeoutPos.y - boxH / 2);
          rect.setAttribute("width", boxW);
          rect.setAttribute("height", boxH);
          rect.setAttribute("rx", "5");
          rect.classList.add("timeout-corner-box");
          rect.dataset.obstacle = "timeout-box";
          rect.dataset.hole = String(t.hole);
          timeoutsGroup.appendChild(rect);
          const seat = document.createElementNS("http://www.w3.org/2000/svg", "line");
          seat.setAttribute("x1", timeoutPos.x - boxW / 2 + 3);
          seat.setAttribute("y1", timeoutPos.y - boxH / 2 + 4);
          seat.setAttribute("x2", timeoutPos.x + boxW / 2 - 3);
          seat.setAttribute("y2", timeoutPos.y - boxH / 2 + 4);
          seat.classList.add("timeout-seat-line");
          seat.style.pointerEvents = "none";
          timeoutsGroup.appendChild(seat);
          const icon = document.createElementNS("http://www.w3.org/2000/svg", "path");
          const ix = timeoutPos.x + 5;
          const iy = timeoutPos.y - 1;
          icon.setAttribute("d", `M ${ix - 3} ${iy - 4} L ${ix + 3} ${iy - 4} L ${ix} ${iy} L ${ix - 3} ${iy + 4} L ${ix + 3} ${iy + 4} M ${ix - 3} ${iy + 4} L ${ix} ${iy} L ${ix + 3} ${iy - 4}`);
          icon.classList.add("timeout-icon");
          icon.style.pointerEvents = "none";
          timeoutsGroup.appendChild(icon);
          const cornerHole = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          cornerHole.setAttribute("cx", timeoutPos.x - 4);
          cornerHole.setAttribute("cy", timeoutPos.y + 1);
          cornerHole.setAttribute("r", "3.4");
          cornerHole.classList.add("hole-timeout-corner");
          cornerHole.dataset.obstacle = "timeout-box";
          cornerHole.dataset.hole = String(t.hole);
          timeoutsGroup.appendChild(cornerHole);
        });
      }
      const detours = isClashObstaclesActive ? obstacleConfigs.detours || ObstacleGeometry.getDetourConfigs(settings3) : [];
      const computeLoopGeometry2 = obstacleStepHelpers.computeLoopGeometry || ((h, w, r) => ObstacleGeometry.computeLoopGeometry(h, w, r, settings3, getTrackXY3));
      const getDetourStepXY2 = obstacleStepHelpers.getDetourStepXY || ((h, s, w) => ObstacleGeometry.getDetourStepXY(h, s, w, settings3, getTrackXY3));
      const catmullRomPath2 = obstacleStepHelpers.catmullRomPath || ((pts) => ObstacleGeometry.catmullRomPath(pts));
      if (isClashObstaclesActive && settings3.optDetour && detoursGroup && Array.isArray(detours)) {
        detours.forEach((d) => {
          if (d.hole > targetHoles) return;
          const geom = computeLoopGeometry2(d.hole, refTrack, false);
          const points = [geom.pEntry];
          for (let s = 1; s <= 7; s++) {
            points.push(getDetourStepXY2(d.hole, s, refTrack));
          }
          points.push(geom.pExit);
          const pathD = catmullRomPath2(points);
          const roadBg = document.createElementNS("http://www.w3.org/2000/svg", "path");
          roadBg.setAttribute("d", pathD);
          roadBg.classList.add("detour-road-bg");
          roadBg.dataset.obstacle = "detour-box";
          roadBg.dataset.hole = String(d.hole);
          detoursGroup.appendChild(roadBg);
          const roadStripe = document.createElementNS("http://www.w3.org/2000/svg", "path");
          roadStripe.setAttribute("d", pathD);
          roadStripe.classList.add("detour-road-path");
          roadStripe.style.pointerEvents = "none";
          detoursGroup.appendChild(roadStripe);
          const apexPos = points[4];
          const badgeOffX = geom.Nx !== 0 ? geom.Nx > 0 ? 8 : -30 : -11;
          const badgeOffY = geom.Ny !== 0 ? geom.Ny > 0 ? 8 : -16 : -5;
          const detourBox = document.createElementNS("http://www.w3.org/2000/svg", "rect");
          detourBox.setAttribute("x", apexPos.x + badgeOffX);
          detourBox.setAttribute("y", apexPos.y + badgeOffY);
          detourBox.setAttribute("width", 22);
          detourBox.setAttribute("height", 9);
          detourBox.setAttribute("rx", "3");
          detourBox.classList.add("detour-loop-box");
          detourBox.dataset.obstacle = "detour-box";
          detourBox.dataset.hole = String(d.hole);
          detoursGroup.appendChild(detourBox);
          const detourText = document.createElementNS("http://www.w3.org/2000/svg", "text");
          detourText.setAttribute("x", apexPos.x + badgeOffX + 11);
          detourText.setAttribute("y", apexPos.y + badgeOffY + 6.8);
          detourText.setAttribute("text-anchor", "middle");
          detourText.setAttribute("fill", "#f59e0b");
          detourText.setAttribute("font-size", "5px");
          detourText.setAttribute("font-weight", "800");
          detourText.setAttribute("letter-spacing", "0.5px");
          detourText.textContent = "DETOUR";
          detourText.style.pointerEvents = "none";
          detoursGroup.appendChild(detourText);
          for (let s = 1; s <= 7; s++) {
            const pt = points[s];
            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("cx", pt.x);
            circle.setAttribute("cy", pt.y);
            circle.setAttribute("r", "3.0");
            circle.classList.add("hole-detour-loop");
            circle.dataset.obstacle = "detour-step";
            circle.dataset.hole = String(d.hole);
            circle.dataset.step = String(s);
            detoursGroup.appendChild(circle);
          }
        });
      }
      const roundabouts = isClashObstaclesActive ? obstacleConfigs.roundabouts || ObstacleGeometry.getRoundAboutConfigs(settings3) : [];
      const getRoundAboutStepXY2 = obstacleStepHelpers.getRoundAboutStepXY || ((h, s, w) => ObstacleGeometry.getRoundAboutStepXY(h, s, w, settings3, getTrackXY3));
      if (isClashObstaclesActive && settings3.optRoundAbout && roundAboutsGroup && Array.isArray(roundabouts)) {
        roundabouts.forEach((r) => {
          if (r.hole > targetHoles) return;
          const geom = computeLoopGeometry2(r.hole, refTrack, true);
          const points = [geom.pEntry];
          for (let s = 1; s <= 7; s++) {
            points.push(getRoundAboutStepXY2(r.hole, s, refTrack));
          }
          points.push(geom.pExit);
          const pathD = catmullRomPath2(points);
          const roadBg = document.createElementNS("http://www.w3.org/2000/svg", "path");
          roadBg.setAttribute("d", pathD);
          roadBg.classList.add("roundabout-road-bg");
          roadBg.dataset.obstacle = "roundabout-box";
          roadBg.dataset.hole = String(r.hole);
          roundAboutsGroup.appendChild(roadBg);
          const roadStripe = document.createElementNS("http://www.w3.org/2000/svg", "path");
          roadStripe.setAttribute("d", pathD);
          roadStripe.classList.add("roundabout-road-path");
          roadStripe.style.pointerEvents = "none";
          roundAboutsGroup.appendChild(roadStripe);
          const island = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          island.setAttribute("cx", geom.Cx);
          island.setAttribute("cy", geom.Cy);
          island.setAttribute("r", "7.5");
          island.classList.add("roundabout-island");
          island.dataset.obstacle = "roundabout-island";
          island.dataset.hole = String(r.hole);
          roundAboutsGroup.appendChild(island);
          const islandInner = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          islandInner.setAttribute("cx", geom.Cx);
          islandInner.setAttribute("cy", geom.Cy);
          islandInner.setAttribute("r", "5.5");
          islandInner.classList.add("roundabout-island-inner");
          islandInner.style.pointerEvents = "none";
          roundAboutsGroup.appendChild(islandInner);
          const islandIcon = document.createElementNS("http://www.w3.org/2000/svg", "text");
          islandIcon.setAttribute("x", geom.Cx);
          islandIcon.setAttribute("y", geom.Cy + 0.5);
          islandIcon.setAttribute("text-anchor", "middle");
          islandIcon.setAttribute("dominant-baseline", "central");
          islandIcon.setAttribute("font-size", "7px");
          islandIcon.textContent = "\u{1F504}";
          islandIcon.style.pointerEvents = "none";
          roundAboutsGroup.appendChild(islandIcon);
          const apexPos = points[4];
          const badgeOffX = geom.Nx !== 0 ? geom.Nx > 0 ? 8 : -30 : -11;
          const badgeOffY = geom.Ny !== 0 ? geom.Ny > 0 ? 8 : -16 : -5;
          const rBox = document.createElementNS("http://www.w3.org/2000/svg", "rect");
          rBox.setAttribute("x", apexPos.x + badgeOffX);
          rBox.setAttribute("y", apexPos.y + badgeOffY);
          rBox.setAttribute("width", 22);
          rBox.setAttribute("height", 9);
          rBox.setAttribute("rx", "3");
          rBox.classList.add("roundabout-loop-box");
          rBox.dataset.obstacle = "roundabout-box";
          rBox.dataset.hole = String(r.hole);
          roundAboutsGroup.appendChild(rBox);
          const rText = document.createElementNS("http://www.w3.org/2000/svg", "text");
          rText.setAttribute("x", apexPos.x + badgeOffX + 11);
          rText.setAttribute("y", apexPos.y + badgeOffY + 6.8);
          rText.setAttribute("text-anchor", "middle");
          rText.setAttribute("fill", "#00e5ff");
          rText.setAttribute("font-size", "5px");
          rText.setAttribute("font-weight", "800");
          rText.setAttribute("letter-spacing", "0.5px");
          rText.textContent = "ROTARY";
          rText.style.pointerEvents = "none";
          roundAboutsGroup.appendChild(rText);
          for (let s = 1; s <= 7; s++) {
            const pt = points[s];
            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("cx", pt.x);
            circle.setAttribute("cy", pt.y);
            circle.setAttribute("r", "3.0");
            circle.classList.add("hole-roundabout-loop");
            circle.dataset.obstacle = "roundabout-step";
            circle.dataset.hole = String(r.hole);
            circle.dataset.step = String(s);
            roundAboutsGroup.appendChild(circle);
          }
        });
      }
      const signs = isClashObstaclesActive ? obstacleConfigs.signs || ObstacleGeometry.getSignConfigs(settings3) : [];
      if (isClashObstaclesActive && settings3.optSigns && signsGroup && Array.isArray(signs)) {
        signs.forEach((b) => {
          if (b.start > targetHoles) return;
          const effectiveEnd = Math.min(targetHoles, b.end);
          const pStart = getTrackXY3(b.start, refTrack);
          let bracketD = `M ${pStart.x} ${pStart.y}`;
          for (let h = b.start + 1; h <= effectiveEnd; h++) {
            const pt = getTrackXY3(h, refTrack);
            bracketD += ` L ${pt.x} ${pt.y}`;
          }
          const bracket = document.createElementNS("http://www.w3.org/2000/svg", "path");
          bracket.setAttribute("d", bracketD);
          bracket.classList.add("signs-bracket");
          signsGroup.appendChild(bracket);
          const bracketLine = document.createElementNS("http://www.w3.org/2000/svg", "path");
          bracketLine.setAttribute("d", bracketD);
          bracketLine.classList.add("signs-bracket-line");
          signsGroup.appendChild(bracketLine);
          const midHole = Math.round((b.start + effectiveEnd) / 2);
          const midPos = getTrackXY3(midHole, refTrack);
          const offsetSign = midPos.y > (isClashTarget2 ? curCfg.viewH / 2 : BOARD_CFG.st2Y) ? 1 : -1;
          const bbY = midPos.y + offsetSign * 16;
          const bbW = 56;
          const bbH = 14;
          const bbRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
          bbRect.setAttribute("x", midPos.x - bbW / 2);
          bbRect.setAttribute("y", bbY - bbH / 2);
          bbRect.setAttribute("width", bbW);
          bbRect.setAttribute("height", bbH);
          bbRect.setAttribute("rx", "3");
          bbRect.classList.add("signs-billboard");
          bbRect.setAttribute("id", `signsBillboard${b.id}`);
          bbRect.setAttribute("onclick", `if (window.onSignBillboardClick) window.onSignBillboardClick(${b.id})`);
          bbRect.dataset.obstacle = "sign-billboard";
          bbRect.dataset.signId = String(b.id);
          bbRect.dataset.start = String(b.start);
          bbRect.dataset.end = String(effectiveEnd);
          signsGroup.appendChild(bbRect);
          const remCount = state3 && state3.signsState && state3.signsState[b.id] ? state3.signsState[b.id].length : b.initialSigns.length;
          const bbText = document.createElementNS("http://www.w3.org/2000/svg", "text");
          bbText.setAttribute("x", midPos.x);
          bbText.setAttribute("y", bbY);
          bbText.setAttribute("id", `signsText${b.id}`);
          bbText.classList.add("signs-billboard-text");
          bbText.textContent = `\u{1FAA7} Signs: ${remCount}/${b.initialSigns.length}`;
          signsGroup.appendChild(bbText);
        });
      }
      const stopSigns = isClashObstaclesActive ? obstacleConfigs.stopSigns || ObstacleGeometry.getStopSignConfigs(settings3) : [];
      const isStopSignActive = isClashObstaclesActive && Boolean(settings3.optStopSign || settings3.optStopSigns || isClashTarget2 && settings3.optStopSign !== false && settings3.optStopSigns !== false);
      if (isClashObstaclesActive && isStopSignActive && stopSignsGroup && Array.isArray(stopSigns)) {
        stopSigns.forEach((s) => {
          if (s.hole > targetHoles) return;
          const pt = getTrackXY3(s.hole, refTrack);
          const isTopTrack = pt.y < (isClashTarget2 ? curCfg.viewH / 2 : BOARD_CFG.st2Y);
          const signY = pt.y + (isTopTrack ? -36 : 36);
          const signX = pt.x;
          const pole = document.createElementNS("http://www.w3.org/2000/svg", "line");
          pole.setAttribute("x1", pt.x);
          pole.setAttribute("y1", pt.y);
          pole.setAttribute("x2", signX);
          pole.setAttribute("y2", signY);
          pole.setAttribute("stroke", "#94a3b8");
          pole.setAttribute("stroke-width", "3.2");
          pole.style.pointerEvents = "none";
          stopSignsGroup.appendChild(pole);
          const r = 28;
          const points = [];
          for (let i = 0; i < 8; i++) {
            const angle = i * Math.PI / 4 + Math.PI / 8;
            points.push(`${(signX + r * Math.cos(angle)).toFixed(1)},${(signY + r * Math.sin(angle)).toFixed(1)}`);
          }
          const oct = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
          oct.setAttribute("points", points.join(" "));
          oct.classList.add("board-stop-sign");
          oct.dataset.obstacle = "stop-sign";
          oct.dataset.hole = String(s.hole);
          stopSignsGroup.appendChild(oct);
          const txt = document.createElementNS("http://www.w3.org/2000/svg", "text");
          txt.setAttribute("x", signX);
          txt.setAttribute("y", signY + 1.8);
          txt.setAttribute("text-anchor", "middle");
          txt.setAttribute("dominant-baseline", "central");
          txt.setAttribute("fill", "#ffffff");
          txt.setAttribute("font-size", "15px");
          txt.setAttribute("font-weight", "900");
          txt.setAttribute("letter-spacing", "1.2px");
          txt.style.pointerEvents = "none";
          txt.textContent = "STOP";
          stopSignsGroup.appendChild(txt);
        });
      }
      const diceList = isClashObstaclesActive ? obstacleConfigs.dice || ObstacleGeometry.getDiceConfigs(settings3) : [];
      if (isClashObstaclesActive && settings3.optDice && diceGroup && Array.isArray(diceList)) {
        diceList.forEach((d) => {
          if (d.hole > targetHoles) return;
          const pt = getTrackXY3(d.hole, refTrack);
          const isTopTrack = pt.y < (isClashTarget2 ? curCfg.viewH / 2 : BOARD_CFG.st2Y);
          const diceY = pt.y + (isTopTrack ? -16 : 16);
          const diceX = pt.x;
          const diceMarker = document.createElementNS("http://www.w3.org/2000/svg", "text");
          diceMarker.setAttribute("x", diceX);
          diceMarker.setAttribute("y", diceY);
          diceMarker.setAttribute("text-anchor", "middle");
          diceMarker.setAttribute("dominant-baseline", "central");
          diceMarker.setAttribute("font-size", "14px");
          diceMarker.setAttribute("filter", "url(#pegShadow)");
          diceMarker.classList.add("dice-board-marker");
          diceMarker.dataset.obstacle = "dice-box";
          diceMarker.dataset.hole = String(d.hole);
          diceMarker.style.cursor = "pointer";
          diceMarker.textContent = "\u{1F3B2}";
          diceGroup.appendChild(diceMarker);
        });
      }
      const wheelList = isClashObstaclesActive ? obstacleConfigs.wheels || ObstacleGeometry.getWheelConfigs(settings3) : [];
      if (isClashObstaclesActive && (settings3.optWheel || settings3.optSpinningWheel) && wheelsGroup && Array.isArray(wheelList)) {
        wheelList.forEach((w) => {
          if (w.hole > targetHoles) return;
          const pt = getTrackXY3(w.hole, refTrack);
          const isTopTrack = pt.y < (isClashTarget2 ? curCfg.viewH / 2 : BOARD_CFG.st2Y);
          const wheelY = pt.y + (isTopTrack ? -16 : 16);
          const wheelX = pt.x;
          const wheelMarker = document.createElementNS("http://www.w3.org/2000/svg", "text");
          wheelMarker.setAttribute("x", wheelX);
          wheelMarker.setAttribute("y", wheelY);
          wheelMarker.setAttribute("text-anchor", "middle");
          wheelMarker.setAttribute("dominant-baseline", "central");
          wheelMarker.setAttribute("font-size", "14px");
          wheelMarker.setAttribute("filter", "url(#pegShadow)");
          wheelMarker.classList.add("wheel-board-marker");
          wheelMarker.dataset.obstacle = "wheel-box";
          wheelMarker.dataset.hole = String(w.hole);
          wheelMarker.style.cursor = "pointer";
          wheelMarker.textContent = "\u{1F3A1}";
          wheelsGroup.appendChild(wheelMarker);
        });
      }
      if (settings3.optSkunkMarkers && skunkMarkersGroup) {
        const sDefs = _BoardRenderer.getSkunkDefaults(settings3.target || 481);
        const markers = [
          {
            hole: settings3.skunkMarkerHole || sDefs.skunkHole,
            label: "SKUNK",
            icon: "\u{1F9A8}",
            dashColor: "#38bdf8",
            borderColor: "#38bdf8",
            bgColor: "#090d16",
            textColor: "#ffffff",
            title: "Skunk Line"
          },
          {
            hole: settings3.doubleSkunkMarkerHole || sDefs.doubleSkunkHole,
            label: "DBL SKUNK",
            icon: "\u{1F9A8}",
            dashColor: "#f59e0b",
            borderColor: "#f59e0b",
            bgColor: "#090d16",
            textColor: "#ffffff",
            title: "Double Skunk Line"
          }
        ];
        markers.forEach((m) => {
          if (m.hole <= 0 || m.hole > targetHoles) return;
          const ptFirst = getTrackXY3(m.hole, activeTracks[0]);
          const ptLast = getTrackXY3(m.hole, activeTracks[activeTracks.length - 1]);
          const nextH = Math.min(targetHoles, m.hole + 1);
          const prevH = Math.max(1, m.hole - 1);
          const pNext = getTrackXY3(nextH, activeTracks[0]);
          const pPrev = getTrackXY3(prevH, activeTracks[0]);
          const tdx = pNext.x - pPrev.x;
          const tdy = pNext.y - pPrev.y;
          const tLen = Math.hypot(tdx, tdy) || 1;
          const tx = tdx / tLen;
          const ty = tdy / tLen;
          let nx, ny;
          if (dist > 0.1) {
            nx = dx / dist;
            ny = dy / dist;
          } else {
            nx = -ty;
            ny = tx;
          }
          const ext = 7;
          const x1 = ptFirst.x - nx * ext;
          const y1 = ptFirst.y - ny * ext;
          const x2 = ptLast.x + nx * ext;
          const y2 = ptLast.y + ny * ext;
          const shadowLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
          shadowLine.setAttribute("x1", x1);
          shadowLine.setAttribute("y1", y1);
          shadowLine.setAttribute("x2", x2);
          shadowLine.setAttribute("y2", y2);
          shadowLine.setAttribute("stroke", "#000000");
          shadowLine.setAttribute("stroke-width", "4");
          shadowLine.setAttribute("stroke-linecap", "round");
          shadowLine.setAttribute("opacity", "0.75");
          shadowLine.style.pointerEvents = "none";
          skunkMarkersGroup.appendChild(shadowLine);
          const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
          line.setAttribute("x1", x1);
          line.setAttribute("y1", y1);
          line.setAttribute("x2", x2);
          line.setAttribute("y2", y2);
          line.setAttribute("stroke", m.dashColor);
          line.setAttribute("stroke-width", "2.5");
          line.setAttribute("stroke-linecap", "round");
          line.setAttribute("stroke-dasharray", "4,2");
          line.setAttribute("opacity", "1");
          line.style.pointerEvents = "none";
          skunkMarkersGroup.appendChild(line);
          const isDouble = m.label === "DBL SKUNK";
          const sideOffset = ext + (isDouble ? 20 : 18);
          const sides = [
            { x: ptFirst.x - nx * sideOffset, y: ptFirst.y - ny * sideOffset },
            { x: ptLast.x + nx * sideOffset, y: ptLast.y + ny * sideOffset }
          ];
          sides.forEach((sidePt) => {
            const sideGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
            sideGroup.classList.add("skunk-board-marker");
            sideGroup.dataset.obstacle = "skunk-marker";
            sideGroup.dataset.hole = String(m.hole);
            sideGroup.style.cursor = "pointer";
            const tip = document.createElementNS("http://www.w3.org/2000/svg", "title");
            tip.textContent = `${m.title} (Hole ${m.hole})`;
            sideGroup.appendChild(tip);
            if (!isDouble) {
              const bgCircle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
              bgCircle.setAttribute("cx", sidePt.x);
              bgCircle.setAttribute("cy", sidePt.y);
              bgCircle.setAttribute("r", "15");
              bgCircle.setAttribute("fill", m.bgColor);
              bgCircle.setAttribute("stroke", m.borderColor);
              bgCircle.setAttribute("stroke-width", "2.0");
              bgCircle.setAttribute("filter", "url(#pegShadow)");
              sideGroup.appendChild(bgCircle);
              const txt = document.createElementNS("http://www.w3.org/2000/svg", "text");
              txt.setAttribute("x", sidePt.x);
              txt.setAttribute("y", sidePt.y + 1.2);
              txt.setAttribute("text-anchor", "middle");
              txt.setAttribute("dominant-baseline", "central");
              txt.setAttribute("font-size", "19px");
              txt.style.pointerEvents = "none";
              txt.textContent = "\u{1F9A8}";
              sideGroup.appendChild(txt);
            } else {
              const pillAngle = Math.atan2(ty, tx) * 180 / Math.PI;
              const pillWrap = document.createElementNS("http://www.w3.org/2000/svg", "g");
              pillWrap.setAttribute("transform", `translate(${sidePt.x}, ${sidePt.y}) rotate(${pillAngle})`);
              const pillRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
              pillRect.setAttribute("x", "-26");
              pillRect.setAttribute("y", "-15");
              pillRect.setAttribute("width", "52");
              pillRect.setAttribute("height", "30");
              pillRect.setAttribute("rx", "15");
              pillRect.setAttribute("fill", m.bgColor);
              pillRect.setAttribute("stroke", m.borderColor);
              pillRect.setAttribute("stroke-width", "2.0");
              pillRect.setAttribute("filter", "url(#pegShadow)");
              pillWrap.appendChild(pillRect);
              const txt1 = document.createElementNS("http://www.w3.org/2000/svg", "text");
              txt1.setAttribute("x", "-11");
              txt1.setAttribute("y", "1.0");
              txt1.setAttribute("text-anchor", "middle");
              txt1.setAttribute("dominant-baseline", "central");
              txt1.setAttribute("font-size", "18px");
              txt1.style.pointerEvents = "none";
              txt1.textContent = "\u{1F9A8}";
              pillWrap.appendChild(txt1);
              const txt2 = document.createElementNS("http://www.w3.org/2000/svg", "text");
              txt2.setAttribute("x", "11");
              txt2.setAttribute("y", "1.0");
              txt2.setAttribute("text-anchor", "middle");
              txt2.setAttribute("dominant-baseline", "central");
              txt2.setAttribute("font-size", "18px");
              txt2.style.pointerEvents = "none";
              txt2.textContent = "\u{1F9A8}";
              pillWrap.appendChild(txt2);
              sideGroup.appendChild(pillWrap);
            }
            skunkMarkersGroup.appendChild(sideGroup);
          });
        });
      }
      const noPassingLanes = obstacleConfigs.noPassingLanes || ObstacleGeometry.getNoPassingLanes(settings3);
      const isInNoPassingLane3 = (h) => noPassingLanes.some((l) => h >= l.start && h <= l.end);
      const isInPegThroughZone3 = (h) => h >= 31 && h <= 40 || h >= 61 && h <= 70 || h >= 91 && h <= 100;
      const isInLast5PegOut3 = (h) => h >= targetHoles - 5 && h < targetHoles;
      const isInBunker3 = (h) => h >= 1 && h <= 5 || h >= targetHoles - 5 && h < targetHoles || [121, 241, 361, 481].includes(targetHoles) && (h >= 50 && h <= 60 || h >= 80 && h <= 90);
      for (const who of activeTracks) {
        for (let h = 0; h <= targetHoles; h++) {
          const inNoPassing = isClashObstaclesActive && settings3.optNoPassingLanes && isInNoPassingLane3(h);
          if (inNoPassing && who !== activeTracks[0]) continue;
          const pos = getTrackXY3(h, who);
          const isMilestone = h > 0 && h % 5 === 0;
          const isGameHole = h === targetHoles;
          const jump = isClashObstaclesActive && settings3.optJump && jumps.find((j) => j.start === h);
          const isJumpDest = isClashObstaclesActive && settings3.optJump && jumps.some((j) => j.dest === h);
          const isJailTrap = isClashObstaclesActive && settings3.optJail && jails.some((j) => j.hole === h);
          const isBarTrap = isClashObstaclesActive && settings3.optBar && bars.some((b) => b.hole === h);
          const isTimeoutTrap = isClashObstaclesActive && settings3.optTimeout && timeouts.some((t) => t.hole === h);
          const isDetourTrap = isClashObstaclesActive && settings3.optDetour && detours.some((d) => d.hole === h);
          const isRoundAboutTrap = isClashObstaclesActive && settings3.optRoundAbout && roundabouts.some((r) => r.hole === h);
          const signBlock = isClashObstaclesActive && settings3.optSigns && signs.find((b) => h >= b.start && h <= b.end);
          const isStopSignTrap = isClashObstaclesActive && settings3.optStopSign && stopSigns.some((s) => s.hole === h);
          const isDiceTrap = isClashObstaclesActive && settings3.optDice && Array.isArray(diceList) && diceList.some((d) => d.hole === h);
          const isWheelTrap = isClashObstaclesActive && (settings3.optWheel || settings3.optSpinningWheel) && Array.isArray(wheelList) && wheelList.some((w) => w.hole === h);
          const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          circle.setAttribute("cx", pos.x);
          circle.setAttribute("cy", pos.y);
          circle.setAttribute("r", isGameHole ? "4.8" : inNoPassing ? isMilestone ? "3.0" : "2.4" : isMilestone ? "2.8" : "2");
          circle.setAttribute("fill", isGameHole ? "#f0c64a" : "url(#holeGrad)");
          circle.setAttribute("stroke", isGameHole ? "#4a2c04" : isMilestone ? "#3a1b07" : "#1a0b03");
          circle.setAttribute("stroke-width", isMilestone || isGameHole ? "1.2" : "0.8");
          circle.dataset.hole = String(h);
          circle.dataset.who = who;
          if (isClashObstaclesActive) {
            if (inNoPassing && !isGameHole) {
              circle.classList.add("hole-no-passing-lane");
            } else if (isStopSignTrap && !isGameHole) {
              circle.classList.add("hole-stop-sign");
            } else if (isDiceTrap && !isGameHole) {
              circle.classList.add("hole-dice-trigger");
            } else if (isWheelTrap && !isGameHole) {
              circle.classList.add("hole-wheel-trigger");
            } else if (isJailTrap && !isGameHole) {
              circle.classList.add("hole-jail-trigger");
            } else if (isBarTrap && !isGameHole) {
              circle.classList.add("hole-bar-trigger");
            } else if (isTimeoutTrap && !isGameHole) {
              circle.classList.add("hole-timeout-trigger");
            } else if (isDetourTrap && !isGameHole) {
              circle.classList.add("hole-detour-trigger");
            } else if (isRoundAboutTrap && !isGameHole) {
              circle.classList.add("hole-roundabout-trigger");
            } else if (signBlock && !isGameHole) {
              circle.classList.add("hole-sign-block");
            } else if (jump && !isGameHole) {
              circle.classList.add(jump.isForward ? "hole-jump-trigger-forward" : "hole-jump-trigger-backward");
            } else if (isJumpDest && !isGameHole) {
              circle.classList.add("hole-jump-dest");
            }
          } else if (brand === "crazy") {
            if (settings3.optPegThroughZones && isInPegThroughZone3(h) && !isGameHole) {
              circle.classList.add("hole-peg-zone");
            } else if (settings3.optLast5PegOut && isInLast5PegOut3(h) && !isGameHole) {
              circle.classList.add("hole-last5-zone");
            } else if (settings3.optBunkers && isInBunker3(h) && !isGameHole) {
              circle.classList.add("hole-bunker-zone");
            }
          }
          if (brand === "pints" && !isGameHole) {
            const pintsKeys = ["youDrink", "guysDrink", "galsDrink", "leftDrink", "rightDrink", "everyoneDrink", "everyoneButYouDrink", "pickWhoDrinks"];
            for (const pk of pintsKeys) {
              const chk = settings3[`opt${pk.charAt(0).toUpperCase() + pk.slice(1)}`];
              if (chk) {
                const count = settings3[`${pk}Count`] || settings3[`opt${pk.charAt(0).toUpperCase() + pk.slice(1)}Count`] || 2;
                let isMatch = false;
                for (let ci = 1; ci <= count; ci++) {
                  const hVal = settings3[`opt${pk.charAt(0).toUpperCase() + pk.slice(1)}${ci}Hole`] || settings3[`${pk}Holes`] && settings3[`${pk}Holes`][ci - 1];
                  if (hVal === h) {
                    isMatch = true;
                    break;
                  }
                }
                if (isMatch) {
                  circle.classList.add(`hole-${pk.replace(/([A-Z])/g, "-$1").toLowerCase()}`);
                  break;
                }
              }
            }
          } else if (brand === "adult" && !isGameHole) {
            const adultKeys = ["loseClothing", "gainClothing", "pickWhoLosesClothing", "rightLosesClothing", "leftLosesClothing", "removeClothingChoice", "touchBreast", "lickBreast", "suckBreast", "touchGenitals", "lickGenitals", "suckGenitals", "fingerGenitals"];
            for (const ak of adultKeys) {
              const chk = settings3[`opt${ak.charAt(0).toUpperCase() + ak.slice(1)}`];
              if (chk) {
                const count = settings3[`${ak}Count`] || settings3[`opt${ak.charAt(0).toUpperCase() + ak.slice(1)}Count`] || 2;
                let isMatch = false;
                for (let ci = 1; ci <= count; ci++) {
                  const hVal = settings3[`opt${ak.charAt(0).toUpperCase() + ak.slice(1)}${ci}Hole`] || settings3[`${ak}Holes`] && settings3[`${ak}Holes`][ci - 1];
                  if (hVal === h) {
                    isMatch = true;
                    break;
                  }
                }
                if (isMatch) {
                  circle.classList.add("hole-strip-action");
                  circle.classList.add(`hole-${ak.replace(/([A-Z])/g, "-$1").toLowerCase()}`);
                  circle.setAttribute("data-adult-key", ak);
                  break;
                }
              }
            }
          }
          holesGroup.appendChild(circle);
          const isTurn = isClashTarget2 ? h > 0 && h < targetHoles && (h - 1) % 60 >= 55 : h >= 31 && h <= 35 || h >= 66 && h <= 70;
          if (who === activeTracks[0] && activeTracks.length > 1 && isMilestone && !isTurn && h < targetHoles && !inNoPassing) {
            const pt1 = getTrackXY3(h, activeTracks[0]);
            const pt4 = getTrackXY3(h, activeTracks[activeTracks.length - 1]);
            const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
            line.setAttribute("x1", pt1.x);
            line.setAttribute("y1", pt1.y + (pt1.y < pt4.y ? 2.6 : -2.6));
            line.setAttribute("x2", pt4.x);
            line.setAttribute("y2", pt4.y + (pt1.y < pt4.y ? -2.6 : 2.6));
            line.setAttribute("stroke", "#6d421a");
            line.setAttribute("stroke-width", "1");
            line.setAttribute("stroke-opacity", "0.65");
            holesGroup.appendChild(line);
          }
        }
      }
      if (isClashTarget2) {
        const p0 = getTrackXY3(0, activeTracks[0]);
        const startTxt = document.createElementNS("http://www.w3.org/2000/svg", "text");
        startTxt.setAttribute("x", p0.x);
        startTxt.setAttribute("y", p0.y - 12);
        startTxt.setAttribute("fill", "#4a2c04");
        startTxt.setAttribute("font-size", "9");
        startTxt.setAttribute("font-weight", "800");
        startTxt.setAttribute("text-anchor", "middle");
        startTxt.setAttribute("letter-spacing", "0.05em");
        startTxt.textContent = "START";
        holesGroup.appendChild(startTxt);
        const pFinish = getTrackXY3(targetHoles, activeTracks[0]);
        const gameTxt = document.createElementNS("http://www.w3.org/2000/svg", "text");
        gameTxt.setAttribute("x", pFinish.x + 16);
        gameTxt.setAttribute("y", pFinish.y + 3.5);
        gameTxt.setAttribute("fill", "#4a2c04");
        gameTxt.setAttribute("font-size", "10");
        gameTxt.setAttribute("font-weight", "800");
        gameTxt.setAttribute("letter-spacing", "0.04em");
        gameTxt.textContent = `\u2605 ${targetHoles} GAME`;
        holesGroup.appendChild(gameTxt);
        for (let r = 0; r < curCfg.numRows; r++) {
          const isEven = r % 2 === 0;
          const stTxt = document.createElementNS("http://www.w3.org/2000/svg", "text");
          stTxt.setAttribute("x", isEven ? 32 : 788);
          stTxt.setAttribute("y", curCfg.stY[r] + 3.5);
          stTxt.setAttribute("fill", "#5c3814");
          stTxt.setAttribute("font-size", "8.5");
          stTxt.setAttribute("font-weight", "700");
          stTxt.setAttribute("opacity", "0.85");
          stTxt.setAttribute("text-anchor", "middle");
          stTxt.textContent = `ST ${r + 1}`;
          holesGroup.appendChild(stTxt);
        }
      }
      const pegsGroup = svg2.querySelector("#pegsLayer");
      activeTracks.forEach((who) => {
        ["rear", "front"].forEach((role) => {
          const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
          g.id = `peg-${who}-${role}`;
          g.className.baseVal = "peg-group";
          g.setAttribute("filter", "url(#pegShadow)");
          g.dataset.pegWho = who;
          g.dataset.pegRole = role;
          g.innerHTML = _BoardRenderer.buildPegSvgContent(who, role, settings3);
          if (who === "p1" || who === "you" || who === "team1") {
            g.style.cursor = "pointer";
            g.setAttribute("title", "Your Peg \u2014 Click to customize your avatar persona");
            g.addEventListener("click", (e) => {
              e.stopPropagation();
              const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
              if (avMgr && typeof avMgr.openAvatarModal === "function") {
                avMgr.openAvatarModal();
              }
            });
          }
          pegsGroup.appendChild(g);
        });
        if (!pegState2[who]) pegState2[who] = { front: 0, rear: 0 };
        pegState2[who].front = state3 && state3.scores && state3.scores[who] || 0;
        pegState2[who].rear = state3 && state3.prev && state3.prev[who] || 0;
      });
      const hasDrinking = settings3 && (settings3.optYouDrink || settings3.optGuysDrink || settings3.optGalsDrink || settings3.optLeftDrink || settings3.optRightDrink || settings3.optEveryoneDrink || settings3.optEveryoneButYouDrink || settings3.optPickWhoDrinks);
      if (isClashTarget2 || brand === "pints" || brand === "adult" || hasDrinking) {
        const legendEl = typeof createLegendFn === "function" ? createLegendFn() : _BoardRenderer.createLegend({ brand, settings: settings3, adultOptions: adultConfigs, obstacleConfigs });
        if (legendEl) wrap.appendChild(legendEl);
      }
      if (typeof onAfterRender === "function") {
        onAfterRender();
      }
      _BoardRenderer.updateBoardSizeButtons();
      return wrap;
    }
    /**
     * Synchronizes SVG front and rear peg markers with current player/team scores.
     * Handles smooth leap transitions and obstacle coordinates.
     * @param {boolean} [animate=true]
     * @param {Object} [context={}]
     */
    static renderScores(animate = true, context = {}) {
      if (typeof document === "undefined") return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const pegState2 = context.pegState || (typeof window !== "undefined" ? window.pegState : {});
      const getActiveTracks3 = context.getActiveTracks || (typeof window !== "undefined" ? window.getActiveTracks : (() => ["p1", "p2"]));
      const baseGetTrackXY = context.getTrackXY || typeof window !== "undefined" && window.getTrackXY || getTrackXY;
      const getTrackXY3 = (h, w) => typeof baseGetTrackXY === "function" ? baseGetTrackXY(h, w, t, settings3) : getTrackXY(h, w, t, settings3);
      const getJailStepXY2 = context.getJailStepXY || (typeof window !== "undefined" ? window.getJailStepXY : ObstacleGeometry.getJailStepXY);
      const getBarStepXY2 = context.getBarStepXY || (typeof window !== "undefined" ? window.getBarStepXY : ObstacleGeometry.getBarStepXY);
      const getTimeoutStepXY2 = context.getTimeoutStepXY || (typeof window !== "undefined" ? window.getTimeoutStepXY : ObstacleGeometry.getTimeoutStepXY);
      const getDetourStepXY2 = context.getDetourStepXY || (typeof window !== "undefined" ? window.getDetourStepXY : ObstacleGeometry.getDetourStepXY);
      const getRoundAboutStepXY2 = context.getRoundAboutStepXY || (typeof window !== "undefined" ? window.getRoundAboutStepXY : ObstacleGeometry.getRoundAboutStepXY);
      if (typeof context.updateScoreChips === "function") {
        context.updateScoreChips();
      } else if (typeof window !== "undefined" && typeof window.updateScoreChips === "function") {
        window.updateScoreChips();
      }
      try {
        const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
        if (avMgr && typeof avMgr.syncAvatarUI === "function") {
          avMgr.syncAvatarUI();
        }
      } catch (e) {
      }
      const t = settings3.target || 121;
      const activeTracks = getActiveTracks3();
      try {
        const boardSvg = document.getElementById("serpentineBoard");
        const defsEl = boardSvg ? boardSvg.querySelector("defs") : null;
        if (defsEl) {
          activeTracks.forEach((who) => {
            const patId = `pegAvatarPattern_${who}`;
            if (!defsEl.querySelector(`#${patId}`)) {
              const avId = _BoardRenderer.getTrackAvatarId(who, settings3);
              const rawSvg = AvatarManager.getAvatarPatternSvg(avId, patId);
              const parser = new DOMParser();
              const doc = parser.parseFromString(`<svg xmlns="http://www.w3.org/2000/svg">${rawSvg}</svg>`, "image/svg+xml");
              const patNode = doc.querySelector("pattern");
              if (patNode) {
                defsEl.appendChild(document.importNode(patNode, true));
              }
            }
          });
        }
      } catch (_) {
      }
      const r3d = typeof window !== "undefined" ? window._currentRenderer3D || window.boardRenderer3D : null;
      if (r3d && (!settings3 || settings3.boardViewMode !== "2d" && settings3.boardViewMode !== "none")) {
        r3d.updatePegs(state3?.scores || {}, state3?.prev || {}, animate, state3?.lastScoringEvent || null);
        if (typeof r3d.syncFromGameState === "function") {
          r3d.syncFromGameState({ state: state3, settings: settings3 });
        }
      }
      activeTracks.forEach((who) => {
        const is2P = settings3 && settings3.playerCount === 2;
        const scoreTargetId = who === "p1" && is2P ? "you" : who === "p2" && is2P ? "cpu" : who;
        const scoreEl = document.getElementById(`${scoreTargetId}Score`) || document.getElementById(`${who}Score`) || (who === "p1" ? document.getElementById("youScore") : who === "p2" ? document.getElementById("cpuScore") : null);
        const sc = state3 && state3.scores && (state3.scores[who] !== void 0 ? state3.scores[who] : state3.scores[scoreTargetId] !== void 0 ? state3.scores[scoreTargetId] : 0) || 0;
        if (scoreEl) scoreEl.textContent = sc;
        const currentScore = Math.min(t, sc);
        const prevSc = state3 && state3.prev && (state3.prev[who] !== void 0 ? state3.prev[who] : state3.prev[scoreTargetId] !== void 0 ? state3.prev[scoreTargetId] : 0) || 0;
        const prevScore = Math.min(t, prevSc);
        if (!pegState2[who]) pegState2[who] = { front: 0, rear: 0 };
        const fEl = document.getElementById(`peg-${who}-front`);
        const rEl = document.getElementById(`peg-${who}-rear`);
        if (!fEl || !rEl) return;
        const isJailed = settings3.optJail && state3 && state3.jailed && state3.jailed[who];
        const jailedStep = isJailed ? state3.jailed[who].step : -1;
        if (pegState2[who]._lastJailStep === void 0) pegState2[who]._lastJailStep = -1;
        const jailStepChanged = isJailed && pegState2[who]._lastJailStep !== jailedStep;
        const isAtBar = settings3.optBar && state3 && state3.atBar && state3.atBar[who];
        const barStep = isAtBar ? state3.atBar[who].step : -1;
        if (pegState2[who]._lastBarStep === void 0) pegState2[who]._lastBarStep = -1;
        const barStepChanged = isAtBar && pegState2[who]._lastBarStep !== barStep;
        const isInTimeout = settings3.optTimeout && state3 && state3.inTimeout && state3.inTimeout[who];
        const timeoutStep = isInTimeout ? state3.inTimeout[who].step : -1;
        if (pegState2[who]._lastTimeoutStep === void 0) pegState2[who]._lastTimeoutStep = -1;
        const timeoutStepChanged = isInTimeout && pegState2[who]._lastTimeoutStep !== timeoutStep;
        const isInDetour = settings3.optDetour && state3 && state3.inDetour && state3.inDetour[who];
        const detourProgress = isInDetour ? state3.inDetour[who].progress : -1;
        if (pegState2[who]._lastDetourProgress === void 0) pegState2[who]._lastDetourProgress = -1;
        const detourProgressChanged = isInDetour && pegState2[who]._lastDetourProgress !== detourProgress;
        const isInRoundAbout = settings3.optRoundAbout && state3 && state3.inRoundAbout && state3.inRoundAbout[who];
        const roundAboutProgress = isInRoundAbout ? state3.inRoundAbout[who].progress : -1;
        if (pegState2[who]._lastRoundAboutProgress === void 0) pegState2[who]._lastRoundAboutProgress = -1;
        const roundAboutProgressChanged = isInRoundAbout && pegState2[who]._lastRoundAboutProgress !== roundAboutProgress;
        const oldFront = pegState2[who].front;
        const isBackward = currentScore < oldFront && !isJailed && !isAtBar && !isInTimeout && !isInDetour && !isInRoundAbout;
        if (animate && (currentScore !== pegState2[who].front || jailStepChanged || barStepChanged || timeoutStepChanged || detourProgressChanged || roundAboutProgressChanged)) {
          if (pegState2[who]._rearTimer) {
            clearTimeout(pegState2[who]._rearTimer);
            pegState2[who]._rearTimer = null;
          }
          if (pegState2[who]._leapTimer) {
            clearTimeout(pegState2[who]._leapTimer);
            pegState2[who]._leapTimer = null;
          }
          if (pegState2[who]._rearLeapTimer) {
            clearTimeout(pegState2[who]._rearLeapTimer);
            pegState2[who]._rearLeapTimer = null;
          }
          if (pegState2[who]._hopTimers) {
            pegState2[who]._hopTimers.forEach((t2) => clearTimeout(t2));
            pegState2[who]._hopTimers = null;
          }
          fEl.classList.remove("peg-hopping");
          pegState2[who]._lastJailStep = jailedStep;
          pegState2[who]._lastBarStep = barStep;
          pegState2[who]._lastTimeoutStep = timeoutStep;
          pegState2[who]._lastDetourProgress = detourProgress;
          pegState2[who]._lastRoundAboutProgress = roundAboutProgress;
          if (isBackward) {
            pegState2[who].front = currentScore;
            const newRear = Math.max(0, currentScore - 1);
            pegState2[who].rear = newRear;
            if (state3 && state3.prev) {
              state3.prev[who] = newRear;
              if (who === "p1" || who === "team1") state3.prev.you = newRear;
              if (who === "p2" || who === "team2") state3.prev.cpu = newRear;
            }
            const newFrontPos = getTrackXY3(currentScore, who);
            const newRearPos = getTrackXY3(newRear, who);
            fEl.classList.add("leaping");
            fEl.setAttribute("transform", `translate(${newFrontPos.x}, ${newFrontPos.y})`);
            pegState2[who]._leapTimer = setTimeout(() => {
              fEl.classList.remove("leaping");
              pegState2[who]._leapTimer = null;
            }, 440);
            pegState2[who]._rearTimer = setTimeout(() => {
              rEl.classList.add("leaping");
              rEl.setAttribute("transform", `translate(${newRearPos.x}, ${newRearPos.y})`);
              pegState2[who]._rearLeapTimer = setTimeout(() => {
                rEl.classList.remove("leaping");
                pegState2[who]._rearLeapTimer = null;
              }, 440);
              pegState2[who]._rearTimer = null;
            }, 460);
          } else {
            const oldScore = oldFront;
            const scoreDelta = currentScore - oldScore;
            pegState2[who].rear = oldScore;
            pegState2[who].front = currentScore;
            let newFrontPos = getTrackXY3(pegState2[who].front, who);
            if (isJailed && typeof getJailStepXY2 === "function") {
              newFrontPos = getJailStepXY2(state3.jailed[who].jailHole, state3.jailed[who].step, who);
            } else if (isAtBar && typeof getBarStepXY2 === "function") {
              newFrontPos = getBarStepXY2(state3.atBar[who].barHole, state3.atBar[who].step, who);
            } else if (isInTimeout && typeof getTimeoutStepXY2 === "function") {
              newFrontPos = getTimeoutStepXY2(state3.inTimeout[who].timeoutHole, state3.inTimeout[who].step, who);
            } else if (isInDetour && typeof getDetourStepXY2 === "function") {
              newFrontPos = getDetourStepXY2(state3.inDetour[who].detourHole, state3.inDetour[who].progress, who);
            } else if (isInRoundAbout && typeof getRoundAboutStepXY2 === "function") {
              newFrontPos = getRoundAboutStepXY2(state3.inRoundAbout[who].roundAboutHole, state3.inRoundAbout[who].progress, who);
            }
            const newRearPos = getTrackXY3(pegState2[who].rear, who);
            rEl.setAttribute("transform", `translate(${newRearPos.x}, ${newRearPos.y})`);
            const isSpecialZone = isJailed || isAtBar || isInTimeout || isInDetour || isInRoundAbout;
            const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
            if (!isSpecialZone && scoreDelta >= 1 && scoreDelta <= 14) {
              fEl.classList.add("peg-hopping");
              pegState2[who]._hopTimers = [];
              const hopDelay = Math.max(45, Math.min(75, Math.floor(620 / scoreDelta)));
              for (let step = 1; step <= scoreDelta; step++) {
                const h = oldScore + step;
                const timer = setTimeout(() => {
                  const stepPos = getTrackXY3(h, who);
                  const isLast = step === scoreDelta;
                  fEl.setAttribute("transform", `translate(${stepPos.x}, ${stepPos.y})`);
                  if (sfx3 && typeof sfx3.thunk === "function") {
                    const pitchMod = 0.95 + step / scoreDelta * 0.15;
                    sfx3.thunk(pitchMod);
                  } else if (sfx3 && typeof sfx3.clack === "function") {
                    const pitchMod = 0.95 + step / scoreDelta * 0.15;
                    sfx3.clack(pitchMod);
                  }
                  if (isLast) {
                    fEl.classList.remove("peg-hopping");
                    pegState2[who]._hopTimers = null;
                  }
                }, (step - 1) * hopDelay);
                pegState2[who]._hopTimers.push(timer);
              }
            } else {
              fEl.classList.add("leaping");
              fEl.setAttribute("transform", `translate(${newFrontPos.x}, ${newFrontPos.y})`);
              const playPegSound = (pMod = 1) => {
                if (!sfx3) return;
                if (typeof sfx3.thunk === "function") sfx3.thunk(pMod);
                else if (typeof sfx3.clack === "function") sfx3.clack(pMod);
              };
              playPegSound(1);
              if (scoreDelta > 14) {
                setTimeout(() => playPegSound(1.06), 70);
                setTimeout(() => playPegSound(1.12), 140);
                setTimeout(() => playPegSound(1.18), 210);
              }
              pegState2[who]._leapTimer = setTimeout(() => {
                fEl.classList.remove("leaping");
                pegState2[who]._leapTimer = null;
              }, 450);
            }
          }
        } else {
          if (pegState2[who]._hopTimers) {
            pegState2[who]._hopTimers.forEach((t2) => clearTimeout(t2));
            pegState2[who]._hopTimers = null;
          }
          fEl.classList.remove("peg-hopping");
          fEl.classList.remove("leaping");
          let fPos = getTrackXY3(currentScore, who);
          if (isJailed && typeof getJailStepXY2 === "function") {
            fPos = getJailStepXY2(state3.jailed[who].jailHole, state3.jailed[who].step, who);
          } else if (isAtBar && typeof getBarStepXY2 === "function") {
            fPos = getBarStepXY2(state3.atBar[who].barHole, state3.atBar[who].step, who);
          } else if (isInTimeout && typeof getTimeoutStepXY2 === "function") {
            fPos = getTimeoutStepXY2(state3.inTimeout[who].timeoutHole, state3.inTimeout[who].step, who);
          } else if (isInDetour && typeof getDetourStepXY2 === "function") {
            fPos = getDetourStepXY2(state3.inDetour[who].detourHole, state3.inDetour[who].progress, who);
          } else if (isInRoundAbout && typeof getRoundAboutStepXY2 === "function") {
            fPos = getRoundAboutStepXY2(state3.inRoundAbout[who].roundAboutHole, state3.inRoundAbout[who].progress, who);
          }
          const safeRear = currentScore < prevScore ? Math.max(0, currentScore - 1) : prevScore;
          const rPos = getTrackXY3(safeRear, who);
          fEl.setAttribute("transform", `translate(${fPos.x}, ${fPos.y})`);
          rEl.setAttribute("transform", `translate(${rPos.x}, ${rPos.y})`);
          pegState2[who].front = currentScore;
          pegState2[who].rear = safeRear;
          pegState2[who]._lastJailStep = jailedStep;
          pegState2[who]._lastBarStep = barStep;
          pegState2[who]._lastTimeoutStep = timeoutStep;
          pegState2[who]._lastDetourProgress = detourProgress;
          pegState2[who]._lastRoundAboutProgress = roundAboutProgress;
        }
      });
      if (typeof context.updateCoachDisplay === "function") {
        context.updateCoachDisplay();
      } else if (typeof window !== "undefined" && typeof window.updateCoachDisplay === "function") {
        window.updateCoachDisplay();
      }
    }
    /**
     * Assembles runtime context dictionary required for board hover tooltips.
     * @param {Object} [deps]
     * @returns {Object}
     */
    static getBoardTooltipContext(deps = {}) {
      const win = typeof window !== "undefined" ? window : {};
      const state3 = deps.state || win.state || null;
      const settings3 = deps.settings || win.settings || null;
      const pegState2 = deps.pegState || win.pegState || null;
      const brandFn = deps.getAppBrand || win.getAppBrand;
      const brand = typeof brandFn === "function" ? brandFn() : deps.brand || win.CRAZY_BRAND || "crazy";
      const OG = ObstacleGeometry || win.CrazyCribbage?.ObstacleGeometry;
      return {
        state: state3,
        settings: settings3,
        pegState: pegState2,
        brand,
        getStreetOrTurnName: deps.getStreetOrTurnName || win.getStreetOrTurnName || ((h) => OG && OG.getStreetOrTurnName ? OG.getStreetOrTurnName(h) : ""),
        getSignConfigs: deps.getSignConfigs || win.getSignConfigs || (() => OG && OG.getSignConfigs ? OG.getSignConfigs(settings3) : []),
        getStopSignConfigs: deps.getStopSignConfigs || win.getStopSignConfigs || (() => OG && OG.getStopSignConfigs ? OG.getStopSignConfigs(settings3) : []),
        getJailConfigs: deps.getJailConfigs || win.getJailConfigs || (() => OG && OG.getJailConfigs ? OG.getJailConfigs(settings3) : []),
        getBarConfigs: deps.getBarConfigs || win.getBarConfigs || (() => OG && OG.getBarConfigs ? OG.getBarConfigs(settings3) : []),
        getTimeoutConfigs: deps.getTimeoutConfigs || win.getTimeoutConfigs || (() => OG && OG.getTimeoutConfigs ? OG.getTimeoutConfigs(settings3) : []),
        getJumpConfigs: deps.getJumpConfigs || win.getJumpConfigs || (() => OG && OG.getJumpConfigs ? OG.getJumpConfigs(settings3) : []),
        getDetourConfigs: deps.getDetourConfigs || win.getDetourConfigs || (() => OG && OG.getDetourConfigs ? OG.getDetourConfigs(settings3) : []),
        getRoundAboutConfigs: deps.getRoundAboutConfigs || win.getRoundAboutConfigs || (() => OG && OG.getRoundAboutConfigs ? OG.getRoundAboutConfigs(settings3) : []),
        getNoPassingLanes: deps.getNoPassingLanes || win.getNoPassingLanes || (() => OG && OG.getNoPassingLanes ? OG.getNoPassingLanes(settings3) : []),
        getDiceConfigs: deps.getDiceConfigs || win.getDiceConfigs || (() => OG && OG.getDiceConfigs ? OG.getDiceConfigs(settings3) : [])
      };
    }
    /**
     * Sets the board display state: 'normal', 'minimized', or 'maximized'.
     * @param {string} newState
     */
    static setBoardDisplayState(newState) {
      if (typeof document === "undefined") return;
      const cribBoard = document.getElementById("cribBoard");
      if (!cribBoard) return;
      const validStates = ["normal", "minimized", "maximized"];
      const state3 = validStates.includes(newState) ? newState : "normal";
      cribBoard.classList.toggle("is-minimized", state3 === "minimized");
      cribBoard.classList.toggle("is-maximized", state3 === "maximized");
      const tracks = document.getElementById("boardTracks");
      if (tracks) {
        tracks.style.display = state3 === "minimized" ? "none" : "";
      }
      const splitContainer = document.querySelector(".table.split");
      if (splitContainer) {
        splitContainer.classList.toggle("board-minimized", state3 === "minimized");
        splitContainer.classList.toggle("board-maximized", state3 === "maximized");
      }
      try {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem("cc_board_display_state", state3);
        }
      } catch (_) {
      }
      _BoardRenderer.updateBoardSizeButtons(state3);
      if (typeof window !== "undefined" && window._currentRenderer3D) {
        setTimeout(() => {
          if (window._currentRenderer3D?.handleResize) window._currentRenderer3D.handleResize();
          if (window._currentRenderer3D?.fitBoardToViewBox) window._currentRenderer3D.fitBoardToViewBox(true);
        }, 50);
        setTimeout(() => {
          if (window._currentRenderer3D?.handleResize) window._currentRenderer3D.handleResize();
          if (window._currentRenderer3D?.fitBoardToViewBox) window._currentRenderer3D.fitBoardToViewBox(true);
        }, 250);
      }
    }
    static getBoardDisplayState() {
      if (typeof document === "undefined") return "normal";
      const cribBoard = document.getElementById("cribBoard");
      if (!cribBoard) return "normal";
      if (cribBoard.classList.contains("is-minimized")) return "minimized";
      if (cribBoard.classList.contains("is-maximized")) return "maximized";
      return "normal";
    }
    static minimizeBoard() {
      _BoardRenderer.setBoardDisplayState("minimized");
    }
    static maximizeBoard() {
      _BoardRenderer.setBoardDisplayState("maximized");
    }
    static restoreBoard() {
      _BoardRenderer.setBoardDisplayState("normal");
    }
    static toggleBoardMinimize() {
      if (_BoardRenderer.getBoardDisplayState() === "minimized") {
        _BoardRenderer.restoreBoard();
      } else {
        _BoardRenderer.minimizeBoard();
      }
    }
    static toggleBoardMaximize() {
      if (_BoardRenderer.getBoardDisplayState() === "maximized") {
        _BoardRenderer.restoreBoard();
      } else {
        _BoardRenderer.maximizeBoard();
      }
    }
    static updateBoardSizeButtons(state3 = _BoardRenderer.getBoardDisplayState()) {
      if (typeof document === "undefined") return;
      const btnMin = document.getElementById("btnMinimizeBoard");
      const btnMax = document.getElementById("btnMaximizeBoard");
      const iconMin = document.getElementById("btnMinimizeIcon");
      const iconMax = document.getElementById("btnMaximizeIcon");
      if (btnMin) {
        const isMin = state3 === "minimized";
        btnMin.classList.toggle("active", isMin);
        btnMin.title = isMin ? "Restore Normal Board" : "Minimize Board (Collapse)";
        btnMin.setAttribute("aria-label", isMin ? "Restore Normal Board" : "Minimize Board (Collapse)");
        btnMin.setAttribute("aria-pressed", isMin ? "true" : "false");
        if (iconMin) iconMin.textContent = isMin ? "\u{1F5D7}" : "\u{1F5D5}";
      }
      if (btnMax) {
        const isMax = state3 === "maximized";
        btnMax.classList.toggle("active", isMax);
        btnMax.title = isMax ? "Restore Normal Board" : "Maximize Board (Full View)";
        btnMax.setAttribute("aria-label", isMax ? "Restore Normal Board" : "Maximize Board (Full View)");
        btnMax.setAttribute("aria-pressed", isMax ? "true" : "false");
        if (iconMax) iconMax.textContent = isMax ? "\u{1F5D7}" : "\u{1F5D6}";
      }
      const floatingRestore = document.getElementById("btnFloatingRestoreBoard");
      if (floatingRestore) {
        floatingRestore.style.display = state3 === "maximized" ? "inline-flex" : "none";
      }
    }
    static toggle3DRoomFullScreen() {
      if (typeof window !== "undefined" && window._currentRenderer3D?.toggleFullScreen) {
        return window._currentRenderer3D.toggleFullScreen();
      }
    }
    static is3DRoomFullScreen() {
      if (typeof window !== "undefined" && window._currentRenderer3D?.isFullScreen) {
        return window._currentRenderer3D.isFullScreen();
      }
      return false;
    }
  };

  // src/board/PegTracker.js
  var PegTracker = class {
    constructor() {
      this.positions = {};
      this.reset();
    }
    reset() {
      const seats = ["p1", "p2", "p3", "p4", "p5", "p6", "p7", "p8", "team1", "team2", "team3", "team4", "you", "cpu"];
      this.positions = {};
      for (const s of seats) {
        this.positions[s] = { front: 0, rear: 0 };
      }
    }
    getPosition(seatId) {
      if (!this.positions[seatId]) {
        this.positions[seatId] = { front: 0, rear: 0 };
      }
      return this.positions[seatId];
    }
    getFront(seatId) {
      return this.getPosition(seatId).front;
    }
    getRear(seatId) {
      return this.getPosition(seatId).rear;
    }
    advance(seatId, newScore) {
      const pos = this.getPosition(seatId);
      const prevFront = pos.front;
      const safeRear = newScore < prevFront ? Math.max(0, newScore - 1) : prevFront;
      pos.rear = safeRear;
      pos.front = newScore;
      return pos;
    }
    toPlain() {
      return JSON.parse(JSON.stringify(this.positions));
    }
  };

  // src/game/GameState.js
  var GameState = class _GameState {
    constructor(data = {}) {
      Object.assign(this, data);
      this.phase = data.phase || "cut";
      this.dealer = data.dealer || "p1";
      this.turn = data.turn || "p2";
      this.count = Number(data.count || 0);
      this.pile = Array.isArray(data.pile) ? [...data.pile] : [];
      this.played = Array.isArray(data.played) ? [...data.played] : [];
      this.scores = data.scores ? { ...data.scores } : {};
      this.prev = data.prev ? { ...data.prev } : {};
      this.handPeg = data.handPeg ? { ...data.handPeg } : {};
      this.seatHands = data.seatHands ? { ...data.seatHands } : {};
      this.seatDiscards = data.seatDiscards ? { ...data.seatDiscards } : {};
      this.starter = data.starter || null;
      this.crib = Array.isArray(data.crib) ? [...data.crib] : [];
      this.selected = Array.isArray(data.selected) ? [...data.selected] : [];
      this.lastPlayed = data.lastPlayed || null;
      this.paused = Boolean(data.paused);
      this.pausedForSign = Boolean(data.pausedForSign);
      this.pausedForAdultTimer = Boolean(data.pausedForAdultTimer);
      this.pausedForAdultStrip = Boolean(data.pausedForAdultStrip);
      this.pausedForPintsBonus = Boolean(data.pausedForPintsBonus);
      this.passingTo = data.passingTo || null;
      this.frozen = Boolean(data.frozen);
      this.over = Boolean(data.over);
    }
    isPaused() {
      return Boolean(
        this.paused || this.pausedForAdultTimer || this.pausedForAdultStrip || this.pausedForSign || this.pausedForPintsBonus
      );
    }
    resetRound() {
      this.count = 0;
      this.pile = [];
      this.played = [];
      this.crib = [];
      this.selected = [];
      this.starter = null;
      this.lastPlayed = null;
      this.passingTo = null;
      this.frozen = false;
    }
    toPlain() {
      return JSON.parse(JSON.stringify(this));
    }
    static from(obj) {
      if (!obj) return null;
      if (obj instanceof _GameState) return obj;
      return new _GameState(obj);
    }
    static getSeatHand(arg1, arg2 = null) {
      let seatId = typeof arg1 === "string" ? arg1 : typeof arg2 === "string" ? arg2 : null;
      let state3 = arg1 && typeof arg1 === "object" ? arg1 : arg2 && typeof arg2 === "object" ? arg2 : typeof window !== "undefined" ? window.state : null;
      if (!seatId || !state3) return [];
      let sId = seatId;
      if (sId === "you") sId = "p1";
      if (sId === "cpu") sId = "p2";
      if (state3.seatHands && state3.seatHands[sId]) return state3.seatHands[sId];
      if (state3.hands && state3.hands[sId]) return state3.hands[sId];
      if (sId === "p1") return state3.youHand || state3.hands && state3.hands.p1 || [];
      if (sId === "p2") return state3.cpuHand || state3.hands && state3.hands.p2 || [];
      return [];
    }
    static setSeatHand(arg1, arg2, arg3 = null) {
      let state3, seatId, cards;
      if (typeof arg1 === "string") {
        seatId = arg1;
        cards = arg2;
        state3 = arg3 || (typeof window !== "undefined" ? window.state : null);
      } else {
        state3 = arg1;
        seatId = arg2;
        cards = arg3;
      }
      if (!seatId || typeof seatId !== "string" || !state3) return;
      let sId = seatId;
      if (sId === "you") sId = "p1";
      if (sId === "cpu") sId = "p2";
      if (!state3.seatHands) state3.seatHands = {};
      state3.seatHands[sId] = cards;
      if (!state3.hands) state3.hands = {};
      state3.hands[sId] = cards;
      if (sId === "p1") state3.youHand = cards;
      if (sId === "p2") state3.cpuHand = cards;
    }
    static getSeatKept(arg1, arg2 = null) {
      let seatId = typeof arg1 === "string" ? arg1 : typeof arg2 === "string" ? arg2 : null;
      let state3 = arg1 && typeof arg1 === "object" ? arg1 : arg2 && typeof arg2 === "object" ? arg2 : typeof window !== "undefined" ? window.state : null;
      if (!seatId || !state3) return [];
      let sId = seatId;
      if (sId === "you") sId = "p1";
      if (sId === "cpu") sId = "p2";
      if (state3.seatKept && state3.seatKept[sId]) return state3.seatKept[sId];
      if (state3.kept && state3.kept[sId]) return state3.kept[sId];
      if (sId === "p1") return state3.youKept || state3.kept && state3.kept.p1 || [];
      if (sId === "p2") return state3.cpuKept || state3.kept && state3.kept.p2 || [];
      return [];
    }
    static setSeatKept(arg1, arg2, arg3 = null) {
      let state3, seatId, cards;
      if (typeof arg1 === "string") {
        seatId = arg1;
        cards = arg2;
        state3 = arg3 || (typeof window !== "undefined" ? window.state : null);
      } else {
        state3 = arg1;
        seatId = arg2;
        cards = arg3;
      }
      if (!seatId || typeof seatId !== "string" || !state3) return;
      let sId = seatId;
      if (sId === "you") sId = "p1";
      if (sId === "cpu") sId = "p2";
      if (!state3.seatKept) state3.seatKept = {};
      state3.seatKept[sId] = cards;
      if (!state3.kept) state3.kept = {};
      state3.kept[sId] = cards;
      if (sId === "p1") state3.youKept = cards;
      if (sId === "p2") state3.cpuKept = cards;
    }
    getSeatHand(seatId) {
      return _GameState.getSeatHand(seatId, this);
    }
    setSeatHand(seatId, cards) {
      return _GameState.setSeatHand(seatId, cards, this);
    }
    getSeatKept(seatId) {
      return _GameState.getSeatKept(seatId, this);
    }
    setSeatKept(seatId, cards) {
      return _GameState.setSeatKept(seatId, cards, this);
    }
  };

  // src/ai/CribbageAI.js
  var CribbageAI = class _CribbageAI {
    /**
     * Normalizes profile or friendly level string into an AI profile key.
     * @param {string} [prof='shark']
     * @returns {string}
     */
    static normalizeProfile(prof) {
      if (!prof) return "shark";
      const p = String(prof).trim().toLowerCase();
      if (p === "expert") return "shark";
      if (p === "advanced") return "turtler";
      if (p === "intermediate") return "gambler";
      if (p === "beginner") return "rookie";
      return p;
    }
    /**
     * Calculates the exact expected show score across all possible unseen starter cards.
     * @param {Card[]} keep Cards kept in hand
     * @param {Set<string>|Array<string>} [deadIds] Card IDs already known/accounted for
     * @param {boolean} [isCrib=false] Whether this is a crib calculation
     * @param {Card[]} [deck] Deck pool to sample from (defaults to standard 52-card deck)
     * @returns {number} Average score
     */
    static expectedShowExact(keep, deadIds, isCrib = false, deck = null) {
      const pool = deck || Deck2.makeDeck(1, false);
      const deadSet = deadIds instanceof Set ? deadIds : new Set(deadIds || []);
      let tot = 0, n = 0;
      for (const s of pool) {
        if (keep.some((c) => c.id === s.id)) continue;
        if (deadSet.has(s.id)) continue;
        const scored = CribbageScorer2.scoreHand(keep, s, isCrib, { verbose: false });
        tot += scored && typeof scored.total === "number" ? scored.total : 0;
        n++;
      }
      return n ? tot / n : 0;
    }
    /**
     * Fast discard heuristic with personality modifiers.
     * @param {Card[]} hand Player's dealt hand
     * @param {boolean} isDealer Whether player is dealer
     * @param {boolean} [lowball=false] Lowball mode flag
     * @param {number} [discardN=2] Number of cards to discard
     * @param {boolean} [toDeck=false] Discarding to deck rather than crib
     * @param {Object} [options={}] Additional context (profile, starter, etc.)
     * @returns {Card[]} Best discard combination
     */
    static chooseDiscardFast(hand, isDealer, lowball = false, discardN = 2, toDeck = false, options = {}) {
      if (!hand || hand.length <= discardN) return (hand || []).slice(0, discardN);
      const rawProf = options.profile || options.aiProfile || "shark";
      const profile = _CribbageAI.normalizeProfile(rawProf);
      const starter = options.starter || null;
      let best = null;
      let bestScore = lowball ? Infinity : -Infinity;
      const combos = combinations(hand, discardN);
      const isFivesCribbage = Boolean(options.optFivesCribbage || options.settings && options.settings.optFivesCribbage);
      const isSevensAndEightsCribbage = Boolean(options.optSevensAndEightsCribbage || options.settings && options.settings.optSevensAndEightsCribbage);
      let validCombos = combos;
      if (isFivesCribbage && !toDeck) {
        const fivesInHand = hand.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5);
        const reqFives = Math.min(fivesInHand.length, discardN);
        if (reqFives > 0) {
          const filtered = combos.filter((disc) => disc.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5).length >= reqFives);
          if (filtered.length > 0) validCombos = filtered;
        }
      } else if (isSevensAndEightsCribbage && !toDeck) {
        const sevensAndEightsInHand = hand.filter((c) => {
          const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
          return r === 7 || r === 8;
        });
        const reqCount = Math.min(sevensAndEightsInHand.length, discardN);
        if (reqCount > 0) {
          const filtered = combos.filter((disc) => disc.filter((c) => {
            const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
            return r === 7 || r === 8;
          }).length >= reqCount);
          if (filtered.length > 0) validCombos = filtered;
        }
      }
      for (const disc of validCombos) {
        const ids = new Set(disc.map((c) => c.id));
        const keep = hand.filter((c) => !ids.has(c.id));
        const scored = CribbageScorer2.scoreHand(keep, starter, false, { verbose: false });
        let val = scored ? scored.total : 0;
        if (isNaN(val)) val = 0;
        if (toDeck) {
          val += keep.filter((c) => (c.rank !== void 0 ? c.rank : c.r) === 5).length * 1;
        } else if (profile === "gambler") {
          val += keep.filter((c) => (c.rank !== void 0 ? c.rank : c.r) === 5).length * 2.2;
          const suitCounts = {};
          keep.forEach((c) => {
            const s = c.suit || c.s;
            suitCounts[s] = (suitCounts[s] || 0) + 1;
          });
          const vals = Object.values(suitCounts);
          if (vals.length && Math.max(...vals) >= 3) val += 1.8;
        } else if (profile === "regular") {
          val += keep.filter((c) => (c.rank !== void 0 ? c.rank : c.r) === 5).length * 1;
          const cribBareScored = CribbageScorer2.scoreHand(disc, null, true, { verbose: false });
          const cribBare = cribBareScored ? cribBareScored.total : 0;
          if (isDealer) val += cribBare * 0.35;
          else val -= cribBare * 0.5;
        } else if (profile === "turtler") {
          const cribBareScored = CribbageScorer2.scoreHand(disc, null, true, { verbose: false });
          const cribBare = cribBareScored ? cribBareScored.total : 0;
          if (isDealer) val += cribBare * 0.3;
          else val -= cribBare * 1.4;
        } else if (profile === "maverick") {
          val += keep.filter((c) => (c.rank !== void 0 ? c.rank : c.r) === 5).length * 1.6;
          val += CribbageScorer2.pegPotential(keep) * 0.4;
          const cribBareScored = CribbageScorer2.scoreHand(disc, null, true, { verbose: false });
          const cribBare = cribBareScored ? cribBareScored.total : 0;
          if (isDealer) val += cribBare * 0.45;
          else val -= cribBare * 0.5;
        } else if (profile === "rookie" || profile === "casual") {
          const cribBareScored = CribbageScorer2.scoreHand(disc, null, true, { verbose: false });
          const cribBare = cribBareScored ? cribBareScored.total : 0;
          if (isDealer) val += cribBare * 0.2;
          else val -= cribBare * 0.15;
        } else if (profile === "master") {
          val += keep.filter((c) => (c.rank !== void 0 ? c.rank : c.r) === 5).length * 1.25;
          const firstSuit = keep[0] ? keep[0].suit || keep[0].s : null;
          const suitSame = keep.length && keep.every((c) => (c.suit || c.s) === firstSuit);
          if (suitSame && keep.length >= 4) val += 0.9;
          const cribBareScored = CribbageScorer2.scoreHand(disc, null, true, { verbose: false });
          const cribBare = cribBareScored ? cribBareScored.total : 0;
          if (isDealer) val += cribBare * 0.45;
          else val -= cribBare * 0.45;
        } else {
          val += keep.filter((c) => (c.rank !== void 0 ? c.rank : c.r) === 5).length * 1.15;
          const firstSuit = keep[0] ? keep[0].suit || keep[0].s : null;
          const suitSame = keep.length && keep.every((c) => (c.suit || c.s) === firstSuit);
          if (suitSame && keep.length >= 4) val += 0.8;
          const cribBareScored = CribbageScorer2.scoreHand(disc, null, true, { verbose: false });
          const cribBare = cribBareScored ? cribBareScored.total : 0;
          if (isDealer) val += cribBare * 0.4;
          else val -= cribBare * 0.3;
        }
        if (lowball) val = -val;
        if (lowball ? val < bestScore : val > bestScore) {
          bestScore = val;
          best = disc;
        }
      }
      return best || validCombos[0] || combos[0] || hand.slice(0, discardN);
    }
    /**
     * Computer discard with tactical personality biases and Monte Carlo simulation.
     */
    static chooseDiscard(hand, isDealer, lowball = false, discardN = 2, toDeck = false, options = {}) {
      if (!hand || hand.length <= discardN) return (hand || []).slice(0, discardN);
      const rawProf = options.profile || options.aiProfile || "shark";
      const profile = _CribbageAI.normalizeProfile(rawProf);
      const combos = combinations(hand, discardN);
      const isFivesCribbage = Boolean(options.optFivesCribbage || options.settings && options.settings.optFivesCribbage);
      const isSevensAndEightsCribbage = Boolean(options.optSevensAndEightsCribbage || options.settings && options.settings.optSevensAndEightsCribbage);
      let validCombos = combos;
      if (isFivesCribbage && !toDeck) {
        const fivesInHand = hand.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5);
        const reqFives = Math.min(fivesInHand.length, discardN);
        if (reqFives > 0) {
          const filtered = combos.filter((disc) => disc.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5).length >= reqFives);
          if (filtered.length > 0) validCombos = filtered;
        }
      } else if (isSevensAndEightsCribbage && !toDeck) {
        const sevensAndEightsInHand = hand.filter((c) => {
          const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
          return r === 7 || r === 8;
        });
        const reqCount = Math.min(sevensAndEightsInHand.length, discardN);
        if (reqCount > 0) {
          const filtered = combos.filter((disc) => disc.filter((c) => {
            const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
            return r === 7 || r === 8;
          }).length >= reqCount);
          if (filtered.length > 0) validCombos = filtered;
        }
      }
      const dead = new Set(hand.map((c) => c.id));
      const pool = (options.deck || Deck2.makeDeck(options.decks || 1, false)).filter((c) => !dead.has(c.id));
      const dealN = hand.length;
      const samples = validCombos.length > 30 ? 36 : 64;
      const worlds = [];
      const knownStarter = options.starter || options.state && options.state.starter || null;
      for (let t = 0; t < samples; t++) {
        const shuffled = Deck2.shuffleArray(pool.slice());
        const oppHand = shuffled.slice(0, dealN);
        const starter = knownStarter || shuffled[dealN];
        const oppDisc = _CribbageAI.chooseDiscardFast(oppHand, !isDealer, lowball, discardN, toDeck, { ...options, profile }) || oppHand.slice(0, discardN);
        const oids = new Set(oppDisc.map((c) => c.id));
        const oppKeep = oppHand.filter((c) => !oids.has(c.id));
        worlds.push({ starter, oppDisc, oppKeep });
      }
      const inBlockedZone = Boolean(options.inBlockedZone);
      const ranked = [];
      for (const disc of validCombos) {
        const ids = new Set(disc.map((c) => c.id));
        const keep = hand.filter((c) => !ids.has(c.id));
        const rawHandEV = knownStarter ? CribbageScorer2.scoreHand(keep, knownStarter, false, { verbose: false }).total : _CribbageAI.expectedShowExact(keep, dead, false, pool);
        const handEV = inBlockedZone ? 0 : rawHandEV;
        let cribSum = 0, pegSum = 0;
        for (const w of worlds) {
          const fullCrib = disc.concat(w.oppDisc);
          cribSum += CribbageScorer2.scoreHand(fullCrib, w.starter, true, { verbose: false }).total;
          const r = _CribbageAI.rolloutPeg(keep.slice(), w.oppKeep.slice(), [], 0, !isDealer, false, options.settings);
          pegSum += r.myPts - r.oppPts;
        }
        const cribEV = toDeck || inBlockedZone && isDealer ? 0 : cribSum / worlds.length;
        const pegEV = pegSum / worlds.length * (inBlockedZone ? 2.5 : 1);
        let val;
        if (toDeck || options.optShotgunCribbage || options.settings && options.settings.optShotgunCribbage) {
          val = handEV + pegEV * 0.2 + CribbageScorer2.pegPotential(keep) * 0.2;
        } else if (options.target === 31) {
          val = pegEV + CribbageScorer2.pegPotential(keep) * 0.2;
        } else {
          if (profile === "gambler") {
            val = handEV + (isDealer ? cribEV * 0.8 : 0) + pegEV * 0.3;
          } else if (profile === "regular") {
            val = handEV + (isDealer ? cribEV * 0.75 : -cribEV * 0.75) + pegEV * 0.2;
          } else if (profile === "turtler") {
            const cribFactor = isDealer ? 0.7 : 1.6;
            val = handEV + (isDealer ? cribEV * cribFactor : -cribEV * cribFactor) + pegEV * 0.25;
          } else if (profile === "maverick") {
            val = handEV + (isDealer ? cribEV * 0.9 : -cribEV * 0.6) + pegEV * 0.5 + CribbageScorer2.pegPotential(keep) * 0.3;
          } else if (profile === "rookie" || profile === "casual") {
            val = handEV + (isDealer ? cribEV * 0.35 : -cribEV * 0.2);
          } else if (profile === "master") {
            val = options.optRockCrib ? isDealer ? handEV - cribEV * 1.05 : handEV + cribEV * 1.05 : isDealer ? handEV + cribEV * 1.05 : handEV - cribEV * 1.05;
            val += pegEV * 1.1 + CribbageScorer2.pegPotential(keep) * 0.25;
          } else {
            val = options.optRockCrib ? isDealer ? handEV - cribEV : handEV + cribEV : isDealer ? handEV + cribEV : handEV - cribEV;
            val += pegEV + CribbageScorer2.pegPotential(keep) * 0.2;
          }
        }
        const raw = val;
        if (lowball) val = -val;
        ranked.push({ disc, keep, handEV, cribEV, pegEV, val, raw });
      }
      ranked.sort((a, b) => b.val - a.val);
      if ((profile === "rookie" || profile === "casual") && ranked.length > 1 && Math.random() < 0.15) {
        if (Math.abs(ranked[0].val - ranked[1].val) <= 1.5) {
          return ranked[1].disc;
        }
      }
      return ranked[0] && ranked[0].disc || validCombos[0] || combos[0] || hand.slice(0, discardN);
    }
    /**
     * Fast legal play selector for pegging simulations.
     */
    static fastPlayCard(hand, pile = [], count = 0, settings3 = {}) {
      let best = null, bestV = -Infinity;
      const opts = [];
      for (const c of hand) {
        const isW = c && (c.isWild || c.wild);
        const r = c && (c.rank !== void 0 ? c.rank : c.r) || 0;
        if (isW) {
          for (const rank of RANKS) {
            if (count + VAL2(rank) <= 31) {
              const assigned = Card2.from ? Card2.from(c).clone().assignWild(rank, "S") : { ...c, r: rank, playAs: { r: rank, s: "S" } };
              opts.push(assigned);
            }
          }
        } else if (count + VAL2(r) <= 31) {
          opts.push(c);
        }
      }
      for (const c of opts) {
        const r = c && (c.rank !== void 0 ? c.rank : c.r) || 0;
        const pts = CribbageScorer2.pegTotal(pile.concat([c]), settings3);
        const nc = count + VAL2(r);
        let v = pts * 3;
        if (nc === 31) v += settings3 && settings3.opt31sFor5 ? 5 : 2;
        if (nc === 21) v -= 2;
        if (nc === 5 || nc === 10 || nc === 26) v -= 1;
        if (r === 5 && pts === 0) v -= 1;
        if (v > bestV || v === bestV && best && VAL2(r) < VAL2(best.rank !== void 0 ? best.rank : best.r)) {
          bestV = v;
          best = c;
        }
      }
      return best;
    }
    /**
     * Simulates pegging playout between two hands to estimate net peg points.
     */
    static rolloutPeg(myHand, oppHand, pile = [], count = 0, myTurn = true, lastWasMe = false, settings3 = {}) {
      myHand = myHand.slice();
      oppHand = oppHand.slice();
      pile = pile.slice();
      let myPts = 0, oppPts = 0;
      let guard = 48;
      while (guard-- && (myHand.length || oppHand.length)) {
        const meCan = myHand.some((c) => c.fits ? c.fits(count) : count + VAL2(c.rank !== void 0 ? c.rank : c.r) <= 31);
        const oppCan = oppHand.some((c) => c.fits ? c.fits(count) : count + VAL2(c.rank !== void 0 ? c.rank : c.r) <= 31);
        if (myTurn && meCan) {
          const c = _CribbageAI.fastPlayCard(myHand, pile, count, settings3);
          if (!c) break;
          pile.push(c);
          count += VAL2(c.rank !== void 0 ? c.rank : c.r);
          const idx = myHand.findIndex((x) => x.id === c.id);
          if (idx >= 0) myHand.splice(idx, 1);
          myPts += CribbageScorer2.pegTotal(pile, settings3);
          lastWasMe = true;
          myTurn = false;
          continue;
        }
        if (!myTurn && oppCan) {
          const c = _CribbageAI.fastPlayCard(oppHand, pile, count, settings3);
          if (!c) break;
          pile.push(c);
          count += VAL2(c.rank !== void 0 ? c.rank : c.r);
          const idx = oppHand.findIndex((x) => x.id === c.id);
          if (idx >= 0) oppHand.splice(idx, 1);
          oppPts += CribbageScorer2.pegTotal(pile, settings3);
          lastWasMe = false;
          myTurn = true;
          continue;
        }
        if (myTurn && !meCan && oppCan) {
          myTurn = false;
          continue;
        }
        if (!myTurn && !oppCan && meCan) {
          myTurn = true;
          continue;
        }
        if (count !== 31) {
          if (lastWasMe) myPts += 1;
          else oppPts += 1;
        }
        if (!myHand.length && !oppHand.length) break;
        pile = [];
        count = 0;
        myTurn = !lastWasMe;
        if (myTurn && !myHand.length) myTurn = false;
        if (!myTurn && !oppHand.length) myTurn = true;
      }
      return { myPts, oppPts };
    }
    /**
     * Bonus weighting when nearing match target.
     */
    static raceBonus(whoPts, add, lowball = false, target = 121, oppScore = 0) {
      const mine = (whoPts || 0) + add;
      const opp = oppScore || 0;
      if (!lowball) {
        if (mine >= target && opp < target) return 80;
        if (mine >= target && opp >= target && mine >= opp) return 40;
        if (target - mine <= 4 && add > 0) return 3;
      } else {
        if (mine >= target && (whoPts || 0) < target) return -80;
      }
      return 0;
    }
    /**
     * Chooses optimal card to play during pegging phase.
     */
    static choosePlay(hand, pile = [], count = 0, oppCanPlay = true, lowball = false, options = {}) {
      const rawProf = options.profile || options.aiProfile || "shark";
      const profile = _CribbageAI.normalizeProfile(rawProf);
      const settings3 = options.settings || {};
      const legal = [];
      for (const c of hand) {
        const isW = c && (c.isWild || c.wild);
        const r = c && (c.rank !== void 0 ? c.rank : c.r) || 0;
        if (isW) {
          for (const rank of RANKS) {
            if (count + VAL2(rank) <= 31) {
              legal.push(Card2.from ? Card2.from(c).clone().assignWild(rank, "S") : { ...c, r: rank, playAs: { r: rank, s: "S" } });
            }
          }
        } else if (count + VAL2(r) <= 31) {
          legal.push(c);
        }
      }
      if (!legal.length) return null;
      const usedIds = new Set(options.knownIds || []);
      const fullDeck = options.deck || Deck2.makeDeck(options.decks || 1, false);
      const unseen = fullDeck.filter((c) => !usedIds.has(c.id));
      const oppN = options.oppHandCount || 4;
      const samples = Math.min(50, Math.max(24, 6 * legal.length));
      const oppWorlds = [];
      for (let t = 0; t < samples; t++) {
        oppWorlds.push(Deck2.shuffleArray(unseen.slice()).slice(0, oppN));
      }
      const myScore = options.myScore || 0;
      const oppScore = options.oppScore || 0;
      const target = options.target || 121;
      const ranked = [];
      for (const c of legal) {
        const r = c && (c.rank !== void 0 ? c.rank : c.r) || 0;
        const newPile = pile.concat([c]);
        const myPts = CribbageScorer2.pegTotal(newPile, settings3);
        const newCount = count + VAL2(r);
        const newHand2 = hand.filter((x) => x.id !== c.id);
        let net2 = 0;
        for (let t = 0; t < samples; t++) {
          const sim = _CribbageAI.rolloutPeg(newHand2, oppWorlds[t], newPile, newCount, false, true, settings3);
          net2 += myPts + sim.myPts - sim.oppPts;
        }
        let v = net2 / samples;
        v += _CribbageAI.raceBonus(myScore, myPts, lowball, target, oppScore);
        if (profile === "gambler") {
          if (myPts >= 2) v += 2.5;
          if (pile.length === 0 && (r === 5 || VAL2(r) === 10)) v += 0.8;
        } else if (profile === "regular") {
          if (myPts >= 2) v += 1.5;
          if (pile.length === 0 && r === 5) v -= 1.5;
        } else if (profile === "turtler") {
          if (newCount === 15 || newCount === 21 || newCount === 26) v -= 3;
          if (pile.length === 0 && r === 5) v -= 4;
          if (newCount === 31) v += settings3 && settings3.opt31sFor5 ? 6.5 : 3.5;
        } else if (profile === "maverick") {
          if (myPts >= 2) v += 2.2;
          if (newCount === 31) v += 3.8;
          if (pile.length === 0 && (r === 4 || r === 6)) v += 0.8;
        } else if (profile === "rookie" || profile === "casual") {
          if (myPts >= 2) v += 3;
          if (newCount === 31) v += 2;
        } else if (profile === "master") {
          if (r === 5 && myPts === 0 && newHand2.length) v -= 0.6;
          if (newCount === 21 && myPts === 0) v -= 0.8;
          if (newCount === 31) v += settings3 && settings3.opt31sFor5 ? 5.5 : 3;
        } else {
          if (r === 5 && myPts === 0 && newHand2.length) v -= 0.35;
          if (newCount === 21 && myPts === 0) v -= 0.5;
        }
        const raw = v;
        if (lowball) v = -v;
        ranked.push({ card: c, v, raw, now: myPts });
      }
      ranked.sort((a, b) => b.v - a.v);
      return ranked[0] ? ranked[0].card : null;
    }
    /**
     * Analyzes keep EV for Coach Mode.
     */
    static analyzeKeepEV(keep, deadIds, starter = null, deck = null) {
      if (starter) {
        const pts = CribbageScorer2.scoreHand(keep, starter, false, { verbose: false }).total;
        return { min: pts, max: pts, avg: pts };
      }
      const pool = deck || Deck2.makeDeck(1, false);
      const deadSet = deadIds instanceof Set ? deadIds : new Set(deadIds || []);
      let minPts = Infinity;
      let maxPts = -Infinity;
      let totalPts = 0;
      let count = 0;
      for (const s of pool) {
        if (deadSet.has(s.id)) continue;
        if (keep.some((c) => c.id === s.id)) continue;
        const pts = CribbageScorer2.scoreHand(keep, s, false, { verbose: false }).total;
        if (pts < minPts) minPts = pts;
        if (pts > maxPts) maxPts = pts;
        totalPts += pts;
        count++;
      }
      if (count === 0) return { min: 0, max: 0, avg: 0 };
      return {
        min: minPts,
        max: maxPts,
        avg: Number((totalPts / count).toFixed(1))
      };
    }
    /**
     * Monte Carlo guessing for Stolen Crib variant.
     */
    static guessStolenCrib(myDiscards = [], starter = null, myKept = [], deck = null) {
      if (!starter || myDiscards.length < 2) return 4;
      const knownIds = /* @__PURE__ */ new Set([starter.id, ...myDiscards.map((c) => c.id), ...myKept.map((c) => c.id)]);
      const pool = deck || Deck2.makeDeck(1, false);
      const unseen = pool.filter((c) => !knownIds.has(c.id));
      const freq = {};
      const samples = Math.min(36, Math.floor(unseen.length / 2));
      for (let i = 0; i < samples; i++) {
        const shuffled = Deck2.shuffleArray(unseen.slice());
        const oppC1 = shuffled[0];
        const oppC2 = shuffled[1];
        if (!oppC1 || !oppC2) continue;
        const hypCrib = [...myDiscards, oppC1, oppC2];
        const pts = CribbageScorer2.scoreHand(hypCrib, starter, true, { verbose: false }).total;
        freq[pts] = (freq[pts] || 0) + 1;
      }
      let bestScore = 4;
      let maxCount = -1;
      for (const [pts, count] of Object.entries(freq)) {
        if (count > maxCount) {
          maxCount = count;
          bestScore = parseInt(pts, 10);
        }
      }
      return bestScore;
    }
    /**
     * Blind/random card picker from opponent hand (e.g. for Pick Your Crib).
     */
    static pickBlindFromHand(hand, pickN = 1) {
      if (!hand || hand.length <= pickN) return (hand || []).slice();
      const shuffled = Deck2.shuffleArray(hand.slice());
      return shuffled.slice(0, pickN);
    }
    /**
     * Evaluates and assigns ranks/suits for unassigned jokers in CPU hand to optimize score.
     * @param {Array} hand
     * @param {Object} [context]
     */
    static cpuAssignWilds(hand, context = {}) {
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (c) => Boolean(c && c.wild));
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const scoreShow2 = context.scoreShow || (typeof window !== "undefined" ? window.scoreShow : () => ({ total: 0 }));
      const assignCard2 = context.assignCard || (typeof window !== "undefined" ? window.assignCard : (c, r, s) => ({ ...c, r, s, playAs: { r, s } }));
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const RANK_NAME3 = context.RANK_NAME || (typeof window !== "undefined" ? window.RANK_NAME : { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" });
      const SUIT_SYM3 = context.SUIT_SYM || (typeof window !== "undefined" ? window.SUIT_SYM : { S: "\u2660", H: "\u2665", C: "\u2663", D: "\u2666" });
      const RANKS3 = context.RANKS || (typeof window !== "undefined" ? window.RANKS : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]);
      const wilds = (hand || []).filter((c) => isWild2(c) && !c.playAs);
      if (!wilds.length) return;
      const fixed = hand.filter((c) => !isWild2(c) || c.playAs);
      const suitGuess = fixed[0] && fixed[0].s || "S";
      const trySet = (list) => {
        let best = null, bestV = settings3.goal === "low" ? Infinity : -Infinity;
        const rec = (i) => {
          if (i === list.length) {
            const v = scoreShow2(hand.map((c2) => c2.playAs ? assignCard2(c2, c2.r, c2.s) : c2), null, false, false).total;
            if (settings3.goal === "low" ? v < bestV : v > bestV) {
              bestV = v;
              best = list.map((c2) => ({ id: c2.id, r: c2.r, s: c2.s }));
            }
            return;
          }
          const c = list[i];
          for (const r of RANKS3) {
            c.r = r;
            c.s = suitGuess;
            c.playAs = { r, s: suitGuess };
            rec(i + 1);
          }
        };
        rec(0);
        if (best) {
          for (const a of best) {
            const c = hand.find((x) => x.id === a.id);
            if (c) {
              c.r = a.r;
              c.s = a.s;
              c.playAs = { r: a.r, s: a.s };
            }
          }
        }
      };
      trySet(wilds);
      for (const c of wilds) {
        if (!c.playAs) {
          c.r = 5;
          c.s = suitGuess;
          c.playAs = { r: 5, s: suitGuess };
        }
        log2("Computer sets joker to " + (RANK_NAME3[c.r] || c.r) + (SUIT_SYM3[c.s] || c.s));
      }
    }
    /**
     * Discovers card IDs already known/observed by CPU.
     * @param {Object} [state]
     * @returns {Set<string>}
     */
    static cpuKnownIds(state3 = null) {
      const s = state3 || (typeof window !== "undefined" ? window.state : null);
      const used = /* @__PURE__ */ new Set();
      const mark = (arr) => {
        if (arr) {
          for (const c of arr) if (c && c.id) used.add(c.id);
        }
      };
      mark(s && s.cpuHand);
      mark(s && s.pile);
      if (s && s.starter && s.starter.id) used.add(s.starter.id);
      if (s && s.cpuKept && s.cpuOrig) {
        const kept = new Set(s.cpuKept.map((c) => c.id));
        for (const c of s.cpuOrig) if (!kept.has(c.id)) used.add(c.id);
      }
      return used;
    }
    /**
     * Returns unseen cards from fullDeck excluding those known to CPU.
     * @param {Object} [state]
     * @param {Array} [fullDeck]
     * @returns {Array}
     */
    static unseenCards(state3 = null, fullDeck = null) {
      const deck = fullDeck || (typeof window !== "undefined" && window.FULL_DECK ? window.FULL_DECK : []);
      const used = _CribbageAI.cpuKnownIds(state3);
      return deck.filter((c) => !used.has(c.id));
    }
    /**
     * Randomly samples opponent hand from unseen cards.
     * @param {Array} unseen
     * @param {number} n
     * @param {Function} [shuffleFn]
     * @returns {Array}
     */
    static sampleOppHand(unseen, n, shuffleFn = null) {
      if (!unseen || n <= 0) return [];
      if (n >= unseen.length) return unseen.slice();
      const copy = unseen.slice();
      const shuf = shuffleFn || (typeof window !== "undefined" && window.shuffle ? window.shuffle : (arr) => {
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
      });
      shuf(copy);
      return copy.slice(0, n);
    }
    /**
     * In-place card removal helper.
     * @param {Array} hand
     * @param {Object} card
     */
    static removeCard(hand, card) {
      if (!hand || !card) return;
      const i = hand.findIndex((x) => x.id === card.id);
      if (i >= 0) hand.splice(i, 1);
    }
    /**
     * Finds the next player in rotational order who has a legal card that fits under 31.
     * @param {string} fromSeat
     * @param {number} count Current pegging count
     * @param {Array<string>} seats Active seat IDs in rotation order
     * @param {Object} hands Map of seatId -> Card[]
     * @returns {string|null} Seat ID of next player with a play, or null if all pass
     */
    static findNextPlayerWithPlay(fromSeat, count, seats = [], hands = {}) {
      if (!Array.isArray(seats) || seats.length === 0) return null;
      const startIndex = seats.indexOf(fromSeat);
      const n = seats.length;
      for (let i = 1; i <= n; i++) {
        const nextIndex = (startIndex + i) % n;
        const sId = seats[nextIndex];
        const hand = hands[sId] || [];
        const hasFit = hand.some((c) => Card2.from(c).fits(count));
        if (hasFit) return sId;
      }
      return null;
    }
    /**
     * Evaluates and selects 0 to 5 cards to discard & replace in Draw Cribbage Phase 1 (from 6 cards).
     * @param {Card[]} hand Player's 6-card hand
     * @param {boolean} isDealer Whether player is dealer
     * @param {boolean} [lowball=false]
     * @param {Object} [options={}]
     * @returns {Card[]} Array of cards to discard (empty array if standing pat)
     */
    static chooseDrawPhase1(hand = [], isDealer = false, lowball = false, options = {}) {
      if (!hand || hand.length <= 1) return [];
      const pool = (options.deck || Deck2.makeDeck(1, false)).filter((c) => !hand.some((h) => h.id === c.id));
      const eval6Hand = (sixCards) => {
        let best = lowball ? Infinity : -Infinity;
        const fours = combinations(sixCards, 4);
        for (const four of fours) {
          const sc = CribbageScorer2.scoreHand(four, null, false, { verbose: false });
          const val = sc ? sc.total : 0;
          if (lowball ? val < best : val > best) best = val;
        }
        return best;
      };
      let bestDiscard = [];
      let bestScore = eval6Hand(hand);
      for (let k = 1; k <= 5; k++) {
        const discCombos = combinations(hand, k);
        for (const disc of discCombos) {
          const discIds = new Set(disc.map((c) => c.id));
          const keep = hand.filter((c) => !discIds.has(c.id));
          const sampleCount = 6;
          let tot = 0;
          for (let s = 0; s < sampleCount; s++) {
            const drawn = [];
            const avail = pool.slice();
            for (let d = 0; d < k; d++) {
              const idx = Math.floor(Math.random() * avail.length);
              drawn.push(avail.splice(idx, 1)[0]);
            }
            tot += eval6Hand(keep.concat(drawn));
          }
          const avg = tot / sampleCount;
          if (lowball ? avg < bestScore : avg > bestScore) {
            bestScore = avg;
            bestDiscard = disc;
          }
        }
      }
      return bestDiscard;
    }
    /**
     * Evaluates and selects 0 to 3 cards to discard & replace in Draw Cribbage Phase 2 (from 4 cards).
     * @param {Card[]} hand Player's 4-card hand
     * @param {boolean} isDealer Whether player is dealer
     * @param {boolean} [lowball=false]
     * @param {Card} [starter=null]
     * @param {Object} [options={}]
     * @returns {Card[]} Array of cards to discard (empty array if standing pat)
     */
    static chooseDrawPhase2(hand = [], isDealer = false, lowball = false, starter = null, options = {}) {
      if (!hand || hand.length <= 1) return [];
      const pool = (options.deck || Deck2.makeDeck(1, false)).filter((c) => !hand.some((h) => h.id === c.id));
      const eval4Hand = (fourCards) => {
        const sc = CribbageScorer2.scoreHand(fourCards, starter, false, { verbose: false });
        return sc ? sc.total : 0;
      };
      let bestDiscard = [];
      let bestScore = eval4Hand(hand);
      for (let k = 1; k <= 3; k++) {
        const discCombos = combinations(hand, k);
        for (const disc of discCombos) {
          const discIds = new Set(disc.map((c) => c.id));
          const keep = hand.filter((c) => !discIds.has(c.id));
          const sampleCount = 12;
          let tot = 0;
          for (let s = 0; s < sampleCount; s++) {
            const drawn = [];
            const avail = pool.slice();
            for (let d = 0; d < k; d++) {
              const idx = Math.floor(Math.random() * avail.length);
              drawn.push(avail.splice(idx, 1)[0]);
            }
            tot += eval4Hand(keep.concat(drawn));
          }
          const avg = tot / sampleCount;
          if (lowball ? avg < bestScore : avg > bestScore) {
            bestScore = avg;
            bestDiscard = disc;
          }
        }
      }
      return bestDiscard;
    }
    /**
     * Canadian Doubles: Optimally partitions 10 cards into:
     * - 4 cards kept in hand
     * - 4 cards passed to partner
     * - 2 cards discarded to crib
     * @param {Card[]} cards - 10 dealt cards
     * @param {boolean} [isDealer=false] - whether player belongs to dealer team (crib scores for them)
     * @param {Object} [options={}] - game settings and options
     * @returns {{ keepHand: Card[], partnerHand: Card[], cribDiscards: Card[], score1: number, score2: number, cribScore: number, totalEV: number }}
     */
    static organizeCanadianDoubles(cards, isDealer = false, options = {}) {
      if (!cards || cards.length < 10) {
        const h = (cards || []).slice();
        return {
          keepHand: h.slice(0, 4),
          partnerHand: h.slice(4, 8),
          cribDiscards: h.slice(8, 10),
          score1: 0,
          score2: 0,
          cribScore: 0,
          totalEV: 0
        };
      }
      const starter = options.starter || null;
      const scoreOpts = { verbose: false, ...options.settings };
      const lowball = Boolean(options.settings && options.settings.goal === "low");
      const isFivesCribbage = Boolean(options.optFivesCribbage || options.settings && options.settings.optFivesCribbage);
      const isSevensAndEightsCribbage = Boolean(options.optSevensAndEightsCribbage || options.settings && options.settings.optSevensAndEightsCribbage);
      const cribCombos = combinations(cards, 2);
      let validCribCombos = cribCombos;
      if (isFivesCribbage) {
        const fivesInHand = cards.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5);
        const reqFives = Math.min(fivesInHand.length, 2);
        if (reqFives > 0) {
          const filtered = cribCombos.filter((disc) => disc.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5).length >= reqFives);
          if (filtered.length > 0) validCribCombos = filtered;
        }
      } else if (isSevensAndEightsCribbage) {
        const targetInHand = cards.filter((c) => {
          const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
          return r === 7 || r === 8;
        });
        const reqTarget = Math.min(targetInHand.length, 2);
        if (reqTarget > 0) {
          const filtered = cribCombos.filter((disc) => disc.filter((c) => {
            const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
            return r === 7 || r === 8;
          }).length >= reqTarget);
          if (filtered.length > 0) validCribCombos = filtered;
        }
      }
      let best = null;
      let bestVal = lowball ? Infinity : -Infinity;
      for (const crib of validCribCombos) {
        const cids = new Set(crib.map((c) => c.id));
        const rem = cards.filter((c) => !cids.has(c.id));
        const handCombos = combinations(rem, 4);
        const halfCount = handCombos.length / 2;
        const cribBare = CribbageScorer2.scoreHand(crib, starter, true, scoreOpts)?.total || 0;
        let cribHeuristic = cribBare * 0.75;
        const r1 = (crib[0].rank !== void 0 ? crib[0].rank : crib[0].r) || 0;
        const r2 = (crib[1].rank !== void 0 ? crib[1].rank : crib[1].r) || 0;
        const s1 = crib[0].suit || crib[0].s;
        const s2 = crib[1].suit || crib[1].s;
        if (r1 === 5 || r2 === 5) cribHeuristic += 1.5;
        if (VAL2(r1) + VAL2(r2) === 15) cribHeuristic += 2;
        if (r1 === r2) cribHeuristic += 2;
        if (Math.abs(r1 - r2) === 1) cribHeuristic += 1;
        if (s1 === s2) cribHeuristic += 0.5;
        for (let i = 0; i < halfCount; i++) {
          const h1 = handCombos[i];
          const h1ids = new Set(h1.map((c) => c.id));
          const h2 = rem.filter((c) => !h1ids.has(c.id));
          const sc1 = CribbageScorer2.scoreHand(h1, starter, false, scoreOpts)?.total || 0;
          const sc2 = CribbageScorer2.scoreHand(h2, starter, false, scoreOpts)?.total || 0;
          let evalVal = sc1 + sc2;
          if (isDealer) {
            evalVal += cribHeuristic;
          } else {
            evalVal -= cribHeuristic;
          }
          const isBetter = lowball ? evalVal < bestVal : evalVal > bestVal;
          if (isBetter || best === null) {
            bestVal = evalVal;
            const [keep, partner] = sc1 >= sc2 ? [h1, h2] : [h2, h1];
            const [kScore, pScore] = sc1 >= sc2 ? [sc1, sc2] : [sc2, sc1];
            best = {
              keepHand: keep,
              partnerHand: partner,
              cribDiscards: crib,
              score1: kScore,
              score2: pScore,
              cribScore: cribBare,
              totalEV: evalVal
            };
          }
        }
      }
      return best || {
        keepHand: cards.slice(0, 4),
        partnerHand: cards.slice(4, 8),
        cribDiscards: cards.slice(8, 10),
        score1: 0,
        score2: 0,
        cribScore: 0,
        totalEV: 0
      };
    }
  };

  // node_modules/dompurify/dist/purify.es.mjs
  function _OverloadYield(e, d) {
    this.v = e, this.k = d;
  }
  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }
  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e, n, i, u, a = [], f = true, o = false;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = false;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
      } catch (r2) {
        o = true, n = r2;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
  }
  function AsyncGenerator(e) {
    var t, n;
    function resume(t2, n2) {
      try {
        var r = e[t2](n2), o = r.value, u = o instanceof _OverloadYield;
        Promise.resolve(u ? o.v : o).then(function(n3) {
          if (u) {
            var i = "return" === t2 && o.k ? t2 : "next";
            if (!o.k || n3.done) return resume(i, n3);
            n3 = e[i](n3).value;
          }
          settle(!!r.done, n3);
        }, function(e2) {
          resume("throw", e2);
        });
      } catch (e2) {
        settle(2, e2);
      }
    }
    function settle(e2, r) {
      2 === e2 ? t.reject(r) : t.resolve({
        value: r,
        done: e2
      }), (t = t.next) ? resume(t.key, t.arg) : n = null;
    }
    this._invoke = function(e2, r) {
      return new Promise(function(o, u) {
        var i = {
          key: e2,
          arg: r,
          resolve: o,
          reject: u,
          next: null
        };
        n ? n = n.next = i : (t = n = i, resume(e2, r));
      });
    }, "function" != typeof e.return && (this.return = void 0);
  }
  AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
  }, AsyncGenerator.prototype.next = function(e) {
    return this._invoke("next", e);
  }, AsyncGenerator.prototype.throw = function(e) {
    return this._invoke("throw", e);
  }, AsyncGenerator.prototype.return = function(e) {
    return this._invoke("return", e);
  };
  var entries = Object.entries;
  var setPrototypeOf = Object.setPrototypeOf;
  var isFrozen = Object.isFrozen;
  var getPrototypeOf = Object.getPrototypeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze;
  var seal = Object.seal;
  var create = Object.create;
  var _ref = typeof Reflect !== "undefined" && Reflect;
  var apply = _ref.apply;
  var construct = _ref.construct;
  if (!freeze) freeze = function freeze2(x) {
    return x;
  };
  if (!seal) seal = function seal2(x) {
    return x;
  };
  if (!apply) apply = function apply2(func, thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) args[_key - 2] = arguments[_key];
    return func.apply(thisArg, args);
  };
  if (!construct) construct = function construct2(Func) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) args[_key2 - 1] = arguments[_key2];
    return new Func(...args);
  };
  var arrayForEach = unapply(Array.prototype.forEach);
  Array.prototype.indexOf;
  var arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var arraySlice = unapply(Array.prototype.slice);
  var arraySplice = unapply(Array.prototype.splice);
  var arrayIsArray = Array.isArray;
  var setCreate = unconstruct(Set);
  var setAdd = unapply(Set.prototype.add);
  var setHas = unapply(Set.prototype.has);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var numberToString = unapply(Number.prototype.toString);
  var booleanToString = unapply(Boolean.prototype.toString);
  var bigintToString = typeof BigInt === "undefined" ? null : unapply(BigInt.prototype.toString);
  var symbolToString = typeof Symbol === "undefined" ? null : unapply(Symbol.prototype.toString);
  var objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
  var objectToString = unapply(Object.prototype.toString);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function(thisArg) {
      if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) args[_key3 - 1] = arguments[_key3];
      return apply(func, thisArg, args);
    };
  }
  function unconstruct(Func) {
    return function() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
      return construct(Func, args);
    };
  }
  function addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
    if (setPrototypeOf) setPrototypeOf(set, null);
    if (!arrayIsArray(array)) return set;
    let l = array.length;
    while (l--) {
      let element = array[l];
      if (typeof element === "string") {
        const lcElement = transformCaseFunc(element);
        if (lcElement !== element) {
          if (!isFrozen(array)) array[l] = lcElement;
          element = lcElement;
        }
      }
      set[element] = true;
    }
    return set;
  }
  function cleanArray(array) {
    for (let index = 0; index < array.length; index++) if (!objectHasOwnProperty(array, index)) array[index] = null;
    return array;
  }
  function clone(object) {
    const newObject = create(null);
    for (const _ref2 of entries(object)) {
      var _ref3 = _slicedToArray(_ref2, 2);
      const property = _ref3[0];
      const value = _ref3[1];
      if (objectHasOwnProperty(object, property)) {
        if (arrayIsArray(value)) newObject[property] = cleanArray(value);
        else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
        else newObject[property] = value;
      }
    }
    return newObject;
  }
  function stringifyValue(value) {
    switch (typeof value) {
      case "string":
        return value;
      case "number":
        return numberToString(value);
      case "boolean":
        return booleanToString(value);
      case "bigint":
        return bigintToString ? bigintToString(value) : "0";
      case "symbol":
        return symbolToString ? symbolToString(value) : "Symbol()";
      case "undefined":
        return objectToString(value);
      case "function":
      case "object": {
        if (value === null) return objectToString(value);
        const valueAsRecord = value;
        const valueToString = lookupGetter(valueAsRecord, "toString");
        if (typeof valueToString === "function") {
          const stringified = valueToString(valueAsRecord);
          return typeof stringified === "string" ? stringified : objectToString(stringified);
        }
        return objectToString(value);
      }
      default:
        return objectToString(value);
    }
  }
  function lookupGetter(object, prop) {
    while (object !== null) {
      const desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) return unapply(desc.get);
        if (typeof desc.value === "function") return unapply(desc.value);
      }
      object = getPrototypeOf(object);
    }
    function fallbackValue() {
      return null;
    }
    return fallbackValue;
  }
  function lookupAccessor(object, prop) {
    while (object !== null) {
      const desc = getOwnPropertyDescriptor(object, prop);
      if (desc) return desc.get ? unapply(desc.get) : null;
      object = getPrototypeOf(object);
    }
    return null;
  }
  function isRegex(value) {
    try {
      regExpTest(value, "");
      return true;
    } catch (_unused) {
      return false;
    }
  }
  var html$1 = freeze([
    "a",
    "abbr",
    "acronym",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "decorator",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "element",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meter",
    "nav",
    "nobr",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr"
  ]);
  var svg$1 = freeze([
    "svg",
    "a",
    "altglyph",
    "altglyphdef",
    "altglyphitem",
    "animatecolor",
    "animatemotion",
    "animatetransform",
    "circle",
    "clippath",
    "defs",
    "desc",
    "ellipse",
    "enterkeyhint",
    "exportparts",
    "filter",
    "font",
    "g",
    "glyph",
    "glyphref",
    "hkern",
    "image",
    "inputmode",
    "line",
    "lineargradient",
    "marker",
    "mask",
    "metadata",
    "mpath",
    "part",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialgradient",
    "rect",
    "stop",
    "style",
    "switch",
    "symbol",
    "text",
    "textpath",
    "title",
    "tref",
    "tspan",
    "view",
    "vkern"
  ]);
  var svgFilters = freeze([
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence"
  ]);
  var svgDisallowed = freeze([
    "animate",
    "color-profile",
    "cursor",
    "discard",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignobject",
    "hatch",
    "hatchpath",
    "mesh",
    "meshgradient",
    "meshpatch",
    "meshrow",
    "missing-glyph",
    "script",
    "set",
    "solidcolor",
    "unknown",
    "use"
  ]);
  var mathMl$1 = freeze([
    "math",
    "menclose",
    "merror",
    "mfenced",
    "mfrac",
    "mglyph",
    "mi",
    "mlabeledtr",
    "mmultiscripts",
    "mn",
    "mo",
    "mover",
    "mpadded",
    "mphantom",
    "mroot",
    "mrow",
    "ms",
    "mspace",
    "msqrt",
    "mstyle",
    "msub",
    "msup",
    "msubsup",
    "mtable",
    "mtd",
    "mtext",
    "mtr",
    "munder",
    "munderover",
    "mprescripts"
  ]);
  var mathMlDisallowed = freeze([
    "maction",
    "maligngroup",
    "malignmark",
    "mlongdiv",
    "mscarries",
    "mscarry",
    "msgroup",
    "mstack",
    "msline",
    "msrow",
    "semantics",
    "annotation",
    "annotation-xml",
    "mprescripts",
    "none"
  ]);
  var text = freeze(["#text"]);
  var html = freeze([
    "accept",
    "action",
    "align",
    "alt",
    "autocapitalize",
    "autocomplete",
    "autopictureinpicture",
    "autoplay",
    "background",
    "bgcolor",
    "border",
    "capture",
    "cellpadding",
    "cellspacing",
    "checked",
    "cite",
    "class",
    "clear",
    "color",
    "cols",
    "colspan",
    "command",
    "commandfor",
    "controls",
    "controlslist",
    "coords",
    "crossorigin",
    "datetime",
    "decoding",
    "default",
    "dir",
    "disabled",
    "disablepictureinpicture",
    "disableremoteplayback",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "exportparts",
    "face",
    "for",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "id",
    "inert",
    "inputmode",
    "integrity",
    "ismap",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "loop",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "multiple",
    "muted",
    "name",
    "nonce",
    "noshade",
    "novalidate",
    "nowrap",
    "open",
    "optimum",
    "part",
    "pattern",
    "placeholder",
    "playsinline",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "pubdate",
    "radiogroup",
    "readonly",
    "rel",
    "required",
    "rev",
    "reversed",
    "role",
    "rows",
    "rowspan",
    "spellcheck",
    "scope",
    "selected",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "srclang",
    "start",
    "src",
    "srcset",
    "step",
    "style",
    "summary",
    "tabindex",
    "title",
    "translate",
    "type",
    "usemap",
    "valign",
    "value",
    "width",
    "wrap",
    "xmlns"
  ]);
  var svg = freeze([
    "accent-height",
    "accumulate",
    "additive",
    "alignment-baseline",
    "amplitude",
    "ascent",
    "attributename",
    "attributetype",
    "azimuth",
    "basefrequency",
    "baseline-shift",
    "begin",
    "bias",
    "by",
    "class",
    "clip",
    "clippathunits",
    "clip-path",
    "clip-rule",
    "color",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "cx",
    "cy",
    "d",
    "dx",
    "dy",
    "diffuseconstant",
    "direction",
    "display",
    "divisor",
    "dominant-baseline",
    "dur",
    "edgemode",
    "elevation",
    "end",
    "exponent",
    "fill",
    "fill-opacity",
    "fill-rule",
    "filter",
    "filterunits",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyph-name",
    "glyphref",
    "gradientunits",
    "gradienttransform",
    "height",
    "href",
    "id",
    "image-rendering",
    "in",
    "in2",
    "intercept",
    "k",
    "k1",
    "k2",
    "k3",
    "k4",
    "kerning",
    "keypoints",
    "keysplines",
    "keytimes",
    "lang",
    "lengthadjust",
    "letter-spacing",
    "kernelmatrix",
    "kernelunitlength",
    "lighting-color",
    "local",
    "marker-end",
    "marker-mid",
    "marker-start",
    "markerheight",
    "markerunits",
    "markerwidth",
    "maskcontentunits",
    "maskunits",
    "max",
    "mask",
    "mask-type",
    "media",
    "method",
    "mode",
    "min",
    "name",
    "numoctaves",
    "offset",
    "operator",
    "opacity",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "paint-order",
    "path",
    "pathlength",
    "patterncontentunits",
    "patterntransform",
    "patternunits",
    "pointer-events",
    "points",
    "preservealpha",
    "preserveaspectratio",
    "primitiveunits",
    "r",
    "rx",
    "ry",
    "radius",
    "refx",
    "refy",
    "repeatcount",
    "repeatdur",
    "restart",
    "result",
    "rotate",
    "scale",
    "seed",
    "shape-rendering",
    "slope",
    "specularconstant",
    "specularexponent",
    "spreadmethod",
    "startoffset",
    "stddeviation",
    "stitchtiles",
    "stop-color",
    "stop-opacity",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke",
    "stroke-width",
    "style",
    "surfacescale",
    "systemlanguage",
    "tabindex",
    "tablevalues",
    "targetx",
    "targety",
    "transform",
    "transform-origin",
    "text-anchor",
    "text-decoration",
    "text-orientation",
    "text-rendering",
    "textlength",
    "type",
    "u1",
    "u2",
    "unicode",
    "values",
    "vector-effect",
    "viewbox",
    "visibility",
    "version",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "width",
    "word-spacing",
    "wrap",
    "writing-mode",
    "xchannelselector",
    "ychannelselector",
    "x",
    "x1",
    "x2",
    "xmlns",
    "y",
    "y1",
    "y2",
    "z",
    "zoomandpan"
  ]);
  var mathMl = freeze([
    "accent",
    "accentunder",
    "align",
    "bevelled",
    "close",
    "columnalign",
    "columnlines",
    "columnspacing",
    "columnspan",
    "denomalign",
    "depth",
    "dir",
    "display",
    "displaystyle",
    "encoding",
    "fence",
    "frame",
    "height",
    "href",
    "id",
    "largeop",
    "length",
    "linethickness",
    "lquote",
    "lspace",
    "mathbackground",
    "mathcolor",
    "mathsize",
    "mathvariant",
    "maxsize",
    "minsize",
    "movablelimits",
    "notation",
    "numalign",
    "open",
    "rowalign",
    "rowlines",
    "rowspacing",
    "rowspan",
    "rspace",
    "rquote",
    "scriptlevel",
    "scriptminsize",
    "scriptsizemultiplier",
    "selection",
    "separator",
    "separators",
    "stretchy",
    "subscriptshift",
    "supscriptshift",
    "symmetric",
    "voffset",
    "width",
    "xmlns"
  ]);
  var xml = freeze([
    "xlink:href",
    "xml:id",
    "xlink:title",
    "xml:space",
    "xmlns:xlink"
  ]);
  var MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
  var ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
  var TMPLIT_EXPR = seal(/\${[\w\W]*/g);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
  var DOCTYPE_NAME = seal(/^html$/i);
  var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
  var ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
  var COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
  var FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
  var SELF_CLOSING_TAG = seal(/\/>/i);
  var NODE_TYPE = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    entityNode: 6,
    processingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12
  };
  var LITERAL_TEXT_ELEMENTS = freeze(addToSet({}, [
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]));
  var getGlobal = function getGlobal2() {
    return typeof window === "undefined" ? null : window;
  };
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy2(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
    let suffix = null;
    const ATTR_NAME = "data-tt-policy-suffix";
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = "dompurify" + (suffix ? "#" + suffix : "");
    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML(html2) {
          return html2;
        },
        createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      console.warn("TrustedTypes policy " + policyName + " could not be created.");
      return null;
    }
  };
  var _createHooksMap = function _createHooksMap2() {
    return {
      afterSanitizeAttributes: [],
      afterSanitizeElements: [],
      afterSanitizeShadowDOM: [],
      beforeSanitizeAttributes: [],
      beforeSanitizeElements: [],
      beforeSanitizeShadowDOM: [],
      uponSanitizeAttribute: [],
      uponSanitizeElement: [],
      uponSanitizeShadowNode: []
    };
  };
  var _resolveSetOption = function _resolveSetOption2(cfg, key, fallback, options) {
    return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone(options.base) : {}, cfg[key], options.transform) : fallback;
  };
  var _resolveObjectOption = function _resolveObjectOption2(cfg, key, makeFallback) {
    const value = objectHasOwnProperty(cfg, key) ? cfg[key] : void 0;
    return value && typeof value === "object" ? clone(value) : makeFallback();
  };
  function createDOMPurify() {
    let window2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
    const DOMPurify = (root) => createDOMPurify(root);
    DOMPurify.version = "3.4.17";
    DOMPurify.removed = [];
    if (!window2 || !window2.document || window2.document.nodeType !== NODE_TYPE.document || !window2.Element) {
      DOMPurify.isSupported = false;
      return DOMPurify;
    }
    let document2 = window2.document;
    const originalDocument = document2;
    const currentScript = originalDocument.currentScript;
    window2.DocumentFragment;
    const HTMLTemplateElement = window2.HTMLTemplateElement, Node = window2.Node, Element = window2.Element, NodeFilter = window2.NodeFilter;
    window2.NamedNodeMap === void 0 && (window2.NamedNodeMap || window2.MozNamedAttrMap);
    window2.HTMLFormElement;
    const DOMParser2 = window2.DOMParser, trustedTypes = window2.trustedTypes;
    const ElementPrototype = Element.prototype;
    const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
    const remove = lookupGetter(ElementPrototype, "remove");
    const removeAttributeNode = lookupGetter(ElementPrototype, "removeAttributeNode");
    const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
    const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
    const getParentNode = lookupGetter(ElementPrototype, "parentNode");
    const getShadowRoot = lookupGetter(ElementPrototype, "shadowRoot");
    const getAttributes = lookupGetter(ElementPrototype, "attributes");
    const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeType") : null;
    const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeName") : null;
    const getOwnerDocument = Node && Node.prototype ? lookupGetter(Node.prototype, "ownerDocument") : null;
    const _readNodeType = function _readNodeType2(node) {
      return getNodeType ? getNodeType(node) : node.nodeType;
    };
    const _readNodeName = function _readNodeName2(node) {
      return getNodeName ? getNodeName(node) : node.nodeName;
    };
    const getNamespaceURI = lookupAccessor(ElementPrototype, "namespaceURI");
    const _readNamespaceURI = function _readNamespaceURI2(element) {
      return getNamespaceURI ? getNamespaceURI(element) : element.namespaceURI;
    };
    if (typeof HTMLTemplateElement === "function") {
      const template = document2.createElement("template");
      if (template.content && template.content.ownerDocument) document2 = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = "";
    let defaultTrustedTypesPolicy;
    let defaultTrustedTypesPolicyResolved = false;
    let IN_TRUSTED_TYPES_POLICY = 0;
    const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy2() {
      if (IN_TRUSTED_TYPES_POLICY > 0) throw typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
    };
    const _createTrustedHTML = function _createTrustedHTML2(html2) {
      _assertNotInTrustedTypesPolicy();
      IN_TRUSTED_TYPES_POLICY++;
      try {
        return trustedTypesPolicy.createHTML(html2);
      } finally {
        IN_TRUSTED_TYPES_POLICY--;
      }
    };
    const _createTrustedScriptURL = function _createTrustedScriptURL2(scriptUrl) {
      _assertNotInTrustedTypesPolicy();
      IN_TRUSTED_TYPES_POLICY++;
      try {
        return trustedTypesPolicy.createScriptURL(scriptUrl);
      } finally {
        IN_TRUSTED_TYPES_POLICY--;
      }
    };
    const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy2() {
      if (!defaultTrustedTypesPolicyResolved) {
        defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
        defaultTrustedTypesPolicyResolved = true;
      }
      return defaultTrustedTypesPolicy;
    };
    const _document = document2, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
    const importNode = originalDocument.importNode;
    let hooks = _createHooksMap();
    DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
    const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
    let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = addToSet({}, [
      ...html$1,
      ...svg$1,
      ...svgFilters,
      ...mathMl$1,
      ...text
    ]);
    let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = addToSet({}, [
      ...html,
      ...svg,
      ...mathMl,
      ...xml
    ]);
    let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    let FORBID_TAGS = null;
    let FORBID_ATTR = null;
    const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
      tagCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      }
    }));
    let ALLOW_ARIA_ATTR = true;
    let ALLOW_DATA_ATTR = true;
    let ALLOW_UNKNOWN_PROTOCOLS = false;
    let ALLOW_SELF_CLOSE_IN_ATTR = true;
    let SAFE_FOR_TEMPLATES = false;
    let SAFE_FOR_XML = true;
    let WHOLE_DOCUMENT = false;
    let SET_CONFIG = false;
    let SET_CONFIG_ALLOWED_TAGS = null;
    let SET_CONFIG_ALLOWED_ATTR = null;
    let FORCE_BODY = false;
    let RETURN_DOM = false;
    let RETURN_DOM_FRAGMENT = false;
    let RETURN_TRUSTED_TYPE = false;
    let SANITIZE_DOM = true;
    let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
    let KEEP_CONTENT = true;
    let IN_PLACE = false;
    let IN_PLACE_VISITED = null;
    let USE_PROFILES = {};
    let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = addToSet({}, [
      "annotation-xml",
      "audio",
      "colgroup",
      "desc",
      "foreignobject",
      "head",
      "iframe",
      "math",
      "mi",
      "mn",
      "mo",
      "ms",
      "mtext",
      "noembed",
      "noframes",
      "noscript",
      "plaintext",
      "script",
      "selectedcontent",
      "style",
      "svg",
      "template",
      "thead",
      "title",
      "video",
      "xmp"
    ]);
    let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = addToSet({}, [
      "audio",
      "video",
      "img",
      "source",
      "image",
      "track"
    ]);
    let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
      "alt",
      "class",
      "for",
      "id",
      "label",
      "name",
      "pattern",
      "placeholder",
      "role",
      "summary",
      "title",
      "value",
      "style",
      "xmlns"
    ]);
    const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
    const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
      MATHML_NAMESPACE,
      SVG_NAMESPACE,
      HTML_NAMESPACE
    ], stringToString);
    const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze([
      "mi",
      "mo",
      "mn",
      "ms",
      "mtext"
    ]);
    let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
    const DEFAULT_HTML_INTEGRATION_POINTS = freeze(["annotation-xml"]);
    let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
    const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
      "title",
      "style",
      "font",
      "a",
      "script"
    ]);
    let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = ["application/xhtml+xml", "text/html"];
    const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
    let transformCaseFunc = null;
    let CONFIG = null;
    const formElement = document2.createElement("form");
    const isRegexOrFunction = function isRegexOrFunction2(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    const _parseConfig = function _parseConfig2() {
      let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (CONFIG && CONFIG === cfg) return;
      if (!cfg || typeof cfg !== "object") cfg = {};
      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
      transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
      ALLOWED_TAGS = _resolveSetOption(cfg, "ALLOWED_TAGS", DEFAULT_ALLOWED_TAGS, { transform: transformCaseFunc });
      ALLOWED_ATTR = _resolveSetOption(cfg, "ALLOWED_ATTR", DEFAULT_ALLOWED_ATTR, { transform: transformCaseFunc });
      ALLOWED_NAMESPACES = _resolveSetOption(cfg, "ALLOWED_NAMESPACES", DEFAULT_ALLOWED_NAMESPACES, { transform: stringToString });
      URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, "ADD_URI_SAFE_ATTR", DEFAULT_URI_SAFE_ATTRIBUTES, {
        transform: transformCaseFunc,
        base: DEFAULT_URI_SAFE_ATTRIBUTES
      });
      DATA_URI_TAGS = _resolveSetOption(cfg, "ADD_DATA_URI_TAGS", DEFAULT_DATA_URI_TAGS, {
        transform: transformCaseFunc,
        base: DEFAULT_DATA_URI_TAGS
      });
      FORBID_CONTENTS = _resolveSetOption(cfg, "FORBID_CONTENTS", DEFAULT_FORBID_CONTENTS, { transform: transformCaseFunc });
      FORBID_TAGS = _resolveSetOption(cfg, "FORBID_TAGS", clone({}), { transform: transformCaseFunc });
      FORBID_ATTR = _resolveSetOption(cfg, "FORBID_ATTR", clone({}), { transform: transformCaseFunc });
      USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === "object" ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
      SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
      RETURN_DOM = cfg.RETURN_DOM || false;
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
      FORCE_BODY = cfg.FORCE_BODY || false;
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
      IN_PLACE = cfg.IN_PLACE || false;
      IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI;
      NAMESPACE = typeof cfg.NAMESPACE === "string" ? cfg.NAMESPACE : HTML_NAMESPACE;
      MATHML_TEXT_INTEGRATION_POINTS = _resolveObjectOption(cfg, "MATHML_TEXT_INTEGRATION_POINTS", () => addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS));
      HTML_INTEGRATION_POINTS = _resolveObjectOption(cfg, "HTML_INTEGRATION_POINTS", () => addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS));
      const customElementHandling = _resolveObjectOption(cfg, "CUSTOM_ELEMENT_HANDLING", () => create(null));
      CUSTOM_ELEMENT_HANDLING = create(null);
      if (objectHasOwnProperty(customElementHandling, "tagNameCheck") && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck;
      if (objectHasOwnProperty(customElementHandling, "attributeNameCheck") && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck;
      if (objectHasOwnProperty(customElementHandling, "allowCustomizedBuiltInElements") && typeof customElementHandling.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements;
      seal(CUSTOM_ELEMENT_HANDLING);
      if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
      if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, text);
        ALLOWED_ATTR = create(null);
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }
        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      EXTRA_ELEMENT_HANDLING.tagCheck = null;
      EXTRA_ELEMENT_HANDLING.attributeCheck = null;
      if (objectHasOwnProperty(cfg, "ADD_TAGS")) {
        if (typeof cfg.ADD_TAGS === "function") EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
        else if (arrayIsArray(cfg.ADD_TAGS)) {
          if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
          addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
        }
      }
      if (objectHasOwnProperty(cfg, "ADD_ATTR")) {
        if (typeof cfg.ADD_ATTR === "function") EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
        else if (arrayIsArray(cfg.ADD_ATTR)) {
          if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
          addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
        }
      }
      if (objectHasOwnProperty(cfg, "ADD_FORBID_CONTENTS") && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
        addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
      }
      if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
      if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
        "html",
        "head",
        "body"
      ]);
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ["tbody"]);
        delete FORBID_TAGS.tbody;
      }
      if (cfg.TRUSTED_TYPES_POLICY) {
        if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        const previousTrustedTypesPolicy = trustedTypesPolicy;
        trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
        try {
          emptyHTML = _createTrustedHTML("");
        } catch (error) {
          trustedTypesPolicy = previousTrustedTypesPolicy;
          throw error;
        }
      } else if (cfg.TRUSTED_TYPES_POLICY === null) {
        trustedTypesPolicy = void 0;
        emptyHTML = "";
      } else {
        if (trustedTypesPolicy === void 0) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
        if (trustedTypesPolicy && typeof emptyHTML === "string") emptyHTML = _createTrustedHTML("");
      }
      if (freeze) freeze(cfg);
      CONFIG = cfg;
    };
    const ALL_SVG_TAGS = addToSet({}, [
      ...svg$1,
      ...svgFilters,
      ...svgDisallowed
    ]);
    const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
    const _checkSvgNamespace = function _checkSvgNamespace2(tagName, parent, parentTagName) {
      if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
      if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      return Boolean(ALL_SVG_TAGS[tagName]);
    };
    const _checkMathMlNamespace = function _checkMathMlNamespace2(tagName, parent, parentTagName) {
      if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
      if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
      return Boolean(ALL_MATHML_TAGS[tagName]);
    };
    const _checkHtmlNamespace = function _checkHtmlNamespace2(tagName, parent, parentTagName) {
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    };
    const _checkValidNamespace = function _checkValidNamespace2(element) {
      const elementNamespace = _readNamespaceURI(element);
      const tagName = stringToLowerCase(_readNodeName(element));
      const parentNode = getParentNode(element);
      let parent;
      let parentTagName;
      if (parentNode && _readNodeType(parentNode) === NODE_TYPE.element) {
        parent = { namespaceURI: _readNamespaceURI(parentNode) };
        parentTagName = stringToLowerCase(_readNodeName(parentNode));
      } else {
        parent = { namespaceURI: NAMESPACE };
        parentTagName = "template";
      }
      if (!ALLOWED_NAMESPACES[elementNamespace]) return false;
      if (elementNamespace === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
      if (elementNamespace === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
      if (elementNamespace === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
      if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[elementNamespace]) return true;
      return false;
    };
    const _forceRemove = function _forceRemove2(node) {
      arrayPush(DOMPurify.removed, { element: node });
      try {
        getParentNode(node).removeChild(node);
      } catch (_) {
        remove(node);
        if (!getParentNode(node)) throw typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
      }
    };
    const _stripAttributeNode = function _stripAttributeNode2(element, attribute, name) {
      try {
        removeAttributeNode(element, attribute);
      } catch (_) {
        try {
          element.removeAttribute(name);
        } catch (_2) {
        }
      }
    };
    const _neutralizeRoot = function _neutralizeRoot2(root) {
      _neutralizeSubtree(root);
      const childNodes = getChildNodes(root);
      if (childNodes) arrayForEach(arraySlice(childNodes), (child) => {
        try {
          remove(child);
        } catch (_) {
        }
      });
      const attributes = _readNodeType(root) === NODE_TYPE.element ? getAttributes(root) : null;
      if (attributes) for (let i = attributes.length - 1; i >= 0; --i) {
        const attribute = attributes[i];
        const name = attribute && attribute.name;
        if (typeof name === "string") _stripAttributeNode(root, attribute, name);
      }
    };
    const _removeAttribute = function _removeAttribute2(name, element, attr) {
      if (!attr) try {
        attr = element.getAttributeNode(name);
      } catch (_) {
        attr = null;
      }
      arrayPush(DOMPurify.removed, {
        attribute: attr || null,
        from: element
      });
      try {
        if (attr) removeAttributeNode(element, attr);
        else element.removeAttribute(name);
      } catch (_) {
        try {
          element.removeAttribute(name);
        } catch (_2) {
        }
      }
      if (name === "is") {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
          _forceRemove(element);
        } catch (_) {
        }
        else try {
          element.setAttribute(name, "");
        } catch (_) {
        }
      }
    };
    const _stripDisallowedAttributes = function _stripDisallowedAttributes2(element) {
      const attributes = getAttributes(element);
      if (!attributes) return;
      for (let i = attributes.length - 1; i >= 0; --i) {
        const attribute = attributes[i];
        const name = attribute && attribute.name;
        if (typeof name !== "string" || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
        _stripAttributeNode(element, attribute, name);
      }
    };
    const _walkTree = function _walkTree2(root, visit) {
      let intoShadow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      const stack = [root];
      while (stack.length > 0) {
        const node = stack.pop();
        if (visit(node) === false) continue;
        if (intoShadow && _readNodeType(node) === NODE_TYPE.element) {
          const shadowRoot = getShadowRoot(node);
          if (_isDocumentFragment(shadowRoot)) stack.push(shadowRoot);
        }
        const childNodes = getChildNodes(node);
        if (childNodes) for (let i = childNodes.length - 1; i >= 0; --i) stack.push(childNodes[i]);
      }
    };
    const _neutralizeSubtree = function _neutralizeSubtree2(root) {
      _walkTree(root, (node) => {
        if (_readNodeType(node) === NODE_TYPE.element) _stripDisallowedAttributes(node);
      });
    };
    const _collectLiveNodes = function _collectLiveNodes2(root) {
      const nodes = [];
      _walkTree(root, (node) => {
        nodes.push(node);
      }, true);
      return nodes;
    };
    const _neutralizeEscapedElements = function _neutralizeEscapedElements2(root, before) {
      const reachable = setCreate();
      arrayForEach(_collectLiveNodes(root), (node) => {
        if (_readNodeType(node) === NODE_TYPE.element) setAdd(reachable, node);
      });
      arrayForEach(before, (node) => {
        if (_readNodeType(node) === NODE_TYPE.element && !setHas(reachable, node)) _stripDisallowedAttributes(node);
      });
    };
    const _neutralizeDiscarded = function _neutralizeDiscarded2(root, before) {
      let rootRemoved = false;
      arrayForEach(DOMPurify.removed, (entry) => {
        if (entry.element) {
          rootRemoved = rootRemoved || entry.element === root;
          _neutralizeSubtree(entry.element);
        }
      });
      _neutralizeEscapedElements(root, before);
      return rootRemoved;
    };
    const MAX_UNVISITED_ROUNDS = 8;
    const _sanitizeUnvisitedNodes = function _sanitizeUnvisitedNodes2(root, before) {
      const visited = IN_PLACE_VISITED;
      let original = null;
      const getOriginal = () => {
        if (!original) {
          original = setCreate();
          arrayForEach(before, (beforeNode) => {
            setAdd(original, beforeNode);
          });
        }
        return original;
      };
      for (let round = 0; ; round++) {
        const live = _collectLiveNodes(root);
        const containers = [root];
        let pending = false;
        arrayForEach(live, (node) => {
          if (_readNodeType(node) === NODE_TYPE.documentFragment) arrayPush(containers, node);
          else if (!pending && !setHas(visited, node)) pending = setHas(getOriginal(), node);
        });
        if (!pending) return;
        if (round >= MAX_UNVISITED_ROUNDS) throw typeErrorCreate("the tree kept changing during in-place sanitization; refusing to return it");
        arrayForEach(containers, (container, index) => {
          _sanitizeUnvisitedIn(container, index > 0, root, getOriginal());
        });
      }
    };
    const _sanitizeUnvisitedIn = function _sanitizeUnvisitedIn2(container, inShadow, root, original) {
      const iterator = _createNodeIterator(container);
      let node;
      while (node = iterator.nextNode()) {
        if (!setHas(original, node) || setHas(IN_PLACE_VISITED, node)) continue;
        if (inShadow) _executeHooks(hooks.uponSanitizeShadowNode, node, null);
        _sanitizeElements(node, root);
        _sanitizeAttributes(node, root);
        if (_isDocumentFragment(node.content)) _sanitizeShadowDOM2(node.content);
      }
    };
    const _markVisited = function _markVisited2(node) {
      if (IN_PLACE_VISITED) setAdd(IN_PLACE_VISITED, node);
    };
    const _isPatchLinkageAttribute = function _isPatchLinkageAttribute2(lcName, lcTag) {
      if (!SAFE_FOR_XML) return false;
      if (lcName === "patchsrc") return true;
      return lcName === "for" && lcTag !== "label" && lcTag !== "output";
    };
    const _neutralizePatchLinkage = function _neutralizePatchLinkage2(root) {
      if (!SAFE_FOR_XML) return;
      _walkTree(root, (node) => {
        const nodeType = _readNodeType(node);
        if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
          try {
            remove(node);
          } catch (_) {
          }
          return false;
        }
        if (nodeType === NODE_TYPE.element) {
          const element = node;
          const lcTag = transformCaseFunc(_readNodeName(node));
          try {
            if (element.hasAttribute && element.hasAttribute("patchsrc")) element.removeAttribute("patchsrc");
            if (element.hasAttribute && element.hasAttribute("for") && _isPatchLinkageAttribute("for", lcTag)) element.removeAttribute("for");
          } catch (_) {
          }
        }
        return true;
      });
    };
    const _initDocument = function _initDocument2(dirty) {
      let doc = null;
      let leadingWhitespace = null;
      if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
      else {
        const matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }
      if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
      const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
      if (NAMESPACE === HTML_NAMESPACE) try {
        doc = new DOMParser2().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {
      }
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, "template", null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {
        }
      }
      const body = doc.body || doc.documentElement;
      if (dirty && leadingWhitespace) body.insertBefore(document2.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    const _createNodeIterator = function _createNodeIterator2(root) {
      const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
      return createNodeIterator.call(doc || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    const _stripTemplateExpressions = function _stripTemplateExpressions2(value) {
      value = stringReplace(value, MUSTACHE_EXPR$1, " ");
      value = stringReplace(value, ERB_EXPR$1, " ");
      value = stringReplace(value, TMPLIT_EXPR$1, " ");
      return value;
    };
    const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
      var _node$querySelectorAl;
      _scrubOwnCharacterData(node);
      const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, "template");
      if (templates) arrayForEach(templates, (tmpl) => {
        if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
      });
    };
    const _scrubOwnCharacterData = function _scrubOwnCharacterData2(node) {
      node.normalize();
      const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
      const walker = createNodeIterator.call(doc || node, node, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
      let currentNode = walker.nextNode();
      while (currentNode) {
        currentNode.data = _stripTemplateExpressions(currentNode.data);
        currentNode = walker.nextNode();
      }
    };
    const _isClobbered = function _isClobbered2(element) {
      const realTagName = getNodeName ? getNodeName(element) : null;
      if (typeof realTagName !== "string") return false;
      if (transformCaseFunc(realTagName) !== "form") return false;
      return typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || element.attributes !== getAttributes(element) || typeof element.removeAttribute !== "function" || typeof element.removeAttributeNode !== "function" || typeof element.getAttributeNode !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function" || element.nodeType !== getNodeType(element) || element.childNodes !== getChildNodes(element);
    };
    const _isDocumentFragment = function _isDocumentFragment2(value) {
      if (!getNodeType || typeof value !== "object" || value === null) return false;
      try {
        return getNodeType(value) === NODE_TYPE.documentFragment;
      } catch (_) {
        return false;
      }
    };
    const _isNode = function _isNode2(value) {
      if (!getNodeType || typeof value !== "object" || value === null) return false;
      try {
        return typeof getNodeType(value) === "number";
      } catch (_) {
        return false;
      }
    };
    function _executeHooks(hooks2, currentNode, data) {
      if (hooks2.length === 0) return;
      arrayForEach(hooks2, (hook) => {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    }
    const _isUnsafeNode = function _isUnsafeNode2(currentNode, tagName) {
      if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
      if (SAFE_FOR_XML && LITERAL_TEXT_ELEMENTS[tagName] && _readNodeType(currentNode) === NODE_TYPE.element && _readNamespaceURI(currentNode) === HTML_NAMESPACE && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === "string" && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent))) return true;
      if (currentNode.nodeType === NODE_TYPE.processingInstruction) return true;
      if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) return true;
      return false;
    };
    const _matchesNameCheck = function _matchesNameCheck2(check, name) {
      if (check instanceof RegExp) return regExpTest(check, name);
      if (check instanceof Function) {
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) args[_key - 2] = arguments[_key];
        return Boolean(check(name, ...args));
      }
      return false;
    };
    const _sanitizeDisallowedNode = function _sanitizeDisallowedNode2(currentNode, tagName, root) {
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && !FORBID_CONTENTS[stringToLowerCase(tagName)]) {
        const parentNode = getParentNode(currentNode);
        const childNodes = getChildNodes(currentNode);
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i = childCount - 1; i >= 0; --i) {
            const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
            parentNode.insertBefore(hoisted, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    };
    const _forkSharedAllowlist = function _forkSharedAllowlist2(hookList, set, defaultSet, setConfigSet) {
      if (hookList.length === 0) return set;
      return set === defaultSet || set === setConfigSet ? clone(set) : set;
    };
    const _handleHookDetachedNode = function _handleHookDetachedNode2(currentNode, root) {
      if (currentNode === root || getParentNode(currentNode) !== null) return false;
      if (IN_PLACE) _neutralizeSubtree(currentNode);
      return true;
    };
    const _sanitizeElements = function _sanitizeElements2(currentNode, root) {
      _markVisited(currentNode);
      _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
      if (_handleHookDetachedNode(currentNode, root)) return true;
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }
      const tagName = transformCaseFunc(_readNodeName(currentNode));
      ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
      _executeHooks(hooks.uponSanitizeElement, currentNode, {
        tagName,
        allowedTags: ALLOWED_TAGS
      });
      if (_handleHookDetachedNode(currentNode, root)) return true;
      if (_isUnsafeNode(currentNode, tagName)) {
        _forceRemove(currentNode);
        return true;
      }
      if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
        const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
        if (removed === false) {
          _executeHooks(hooks.afterSanitizeElements, currentNode, null);
          if (_handleHookDetachedNode(currentNode, root)) return true;
        }
        return removed;
      }
      if (_readNodeType(currentNode) === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }
      if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
        const content = _stripTemplateExpressions(currentNode.textContent);
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
          currentNode.textContent = content;
        }
      }
      _executeHooks(hooks.afterSanitizeElements, currentNode, null);
      return _handleHookDetachedNode(currentNode, root);
    };
    const _isValidAttribute = function _isValidAttribute2(lcTag, lcName, value) {
      if (FORBID_ATTR[lcName]) return false;
      if (_isPatchLinkageAttribute(lcName, lcTag)) return false;
      if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document2 || value in formElement)) return false;
      const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
      if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) return true;
      if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) return true;
      if (!nameIsPermitted) return _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) || lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value);
      if (URI_SAFE_ATTRIBUTES[lcName]) return true;
      if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
      if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) return true;
      if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
      return !value;
    };
    const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
      "annotation-xml",
      "color-profile",
      "font-face",
      "font-face-format",
      "font-face-name",
      "font-face-src",
      "font-face-uri",
      "missing-glyph"
    ]);
    const _isBasicCustomElement = function _isBasicCustomElement2(tagName) {
      return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
    };
    const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute2(lcTag, lcName, namespaceURI, value) {
      if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function" && !namespaceURI) switch (trustedTypes.getAttributeType(lcTag, lcName)) {
        case "TrustedHTML":
          return _createTrustedHTML(value);
        case "TrustedScriptURL":
          return _createTrustedScriptURL(value);
      }
      return value;
    };
    const _setAttributeValue = function _setAttributeValue2(currentNode, name, namespaceURI, value) {
      try {
        if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
        else currentNode.setAttribute(name, value);
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
          return false;
        }
        return true;
      } catch (_) {
        _removeAttribute(name, currentNode);
        return false;
      }
    };
    const _isUnsafeAttributeValue = function _isUnsafeAttributeValue2(name, value) {
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) return true;
      return stringToLowerCase(name) === "attributename" && stringMatch(value, "href") !== null;
    };
    const _sanitizeAttributes = function _sanitizeAttributes2(currentNode, root) {
      _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
      if (_handleHookDetachedNode(currentNode, root)) return;
      const attributes = currentNode.attributes;
      if (!attributes || _isClobbered(currentNode)) return;
      ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
      const hookEvent = {
        attrName: "",
        attrValue: "",
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR,
        forceKeepAttr: void 0
      };
      let l = attributes.length;
      const lcTag = transformCaseFunc(currentNode.nodeName);
      while (l--) {
        const attr = attributes[l];
        const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
        const lcName = transformCaseFunc(name);
        const initValue = attrValue;
        let value = name === "value" ? initValue : stringTrim(initValue);
        let recreatedNamedProp = false;
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = void 0;
        _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
        value = hookEvent.attrValue;
        if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name") && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
          _removeAttribute(name, currentNode, attr);
          value = SANITIZE_NAMED_PROPS_PREFIX + value;
          recreatedNamedProp = true;
        }
        if (_isUnsafeAttributeValue(name, value)) {
          _removeAttribute(name, currentNode, attr);
          continue;
        }
        if (hookEvent.forceKeepAttr) continue;
        if (!hookEvent.keepAttr) {
          _removeAttribute(name, currentNode, attr);
          continue;
        }
        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
          _removeAttribute(name, currentNode, attr);
          continue;
        }
        if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          _removeAttribute(name, currentNode, attr);
          continue;
        }
        value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
        if (value !== initValue) {
          if (_setAttributeValue(currentNode, name, namespaceURI, value) && recreatedNamedProp) arrayPop(DOMPurify.removed);
        }
      }
      _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
      _handleHookDetachedNode(currentNode, root);
    };
    const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
      let shadowNode = null;
      const shadowIterator = _createNodeIterator(fragment);
      _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
      while (shadowNode = shadowIterator.nextNode()) {
        _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
        _sanitizeElements(shadowNode, fragment);
        _sanitizeAttributes(shadowNode, fragment);
        if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
        if (_readNodeType(shadowNode) === NODE_TYPE.element) {
          const innerSr = getShadowRoot(shadowNode);
          if (_isDocumentFragment(innerSr)) {
            _sanitizeAttachedShadowRoots(innerSr);
            _sanitizeShadowDOM2(innerSr);
          }
        }
      }
      if (SAFE_FOR_TEMPLATES) _scrubOwnCharacterData(fragment);
      _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots2(root) {
      const stack = [{
        node: root,
        shadow: null
      }];
      while (stack.length > 0) {
        const item = stack.pop();
        if (item.shadow) {
          _sanitizeShadowDOM2(item.shadow);
          continue;
        }
        const node = item.node;
        const isElement = _readNodeType(node) === NODE_TYPE.element;
        const childNodes = getChildNodes(node);
        if (childNodes) for (let i = childNodes.length - 1; i >= 0; --i) stack.push({
          node: childNodes[i],
          shadow: null
        });
        if (isElement) {
          const rootName = getNodeName ? getNodeName(node) : null;
          if (typeof rootName === "string" && transformCaseFunc(rootName) === "template") {
            const content = node.content;
            if (_isDocumentFragment(content)) stack.push({
              node: content,
              shadow: null
            });
          }
        }
        if (isElement) {
          const sr = getShadowRoot(node);
          if (_isDocumentFragment(sr)) stack.push({
            node: null,
            shadow: sr
          }, {
            node: sr,
            shadow: null
          });
        }
      }
    };
    DOMPurify.sanitize = function(dirty) {
      let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      let body = null;
      let importedNode = null;
      let currentNode = null;
      let returnNode = null;
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) dirty = "<!-->";
      if (typeof dirty !== "string" && !_isNode(dirty)) {
        dirty = stringifyValue(dirty);
        if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
      }
      if (!DOMPurify.isSupported) return dirty;
      if (SET_CONFIG) {
        ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
        ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
      } else _parseConfig(cfg);
      if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = clone(ALLOWED_TAGS);
      if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = clone(ALLOWED_ATTR);
      DOMPurify.removed = [];
      const inPlace = IN_PLACE && typeof dirty !== "string" && _isNode(dirty);
      let inPlaceNodes = [];
      const outerVisited = IN_PLACE_VISITED;
      if (inPlace) {
        _neutralizePatchLinkage(dirty);
        const nn = _readNodeName(dirty);
        if (typeof nn === "string") {
          const tagName = transformCaseFunc(nn);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            _neutralizeRoot(dirty);
            throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
          }
        }
        if (_isClobbered(dirty)) {
          _neutralizeRoot(dirty);
          throw typeErrorCreate("root node is clobbered and cannot be sanitized in-place");
        }
        inPlaceNodes = _collectLiveNodes(dirty);
        IN_PLACE_VISITED = setCreate();
      } else if (_isNode(dirty)) {
        body = _initDocument("<!---->");
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") body = importedNode;
        else if (importedNode.nodeName === "HTML") body = importedNode;
        else body.appendChild(importedNode);
        _sanitizeAttachedShadowRoots(body);
      } else {
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
        body = _initDocument(dirty);
        if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
      }
      if (body && FORCE_BODY) _forceRemove(body.firstChild);
      const walkRoot = inPlace ? dirty : body;
      try {
        if (inPlace) _sanitizeAttachedShadowRoots(dirty);
        const nodeIterator = _createNodeIterator(walkRoot);
        while (currentNode = nodeIterator.nextNode()) {
          _sanitizeElements(currentNode, walkRoot);
          _sanitizeAttributes(currentNode, walkRoot);
          if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
        }
        if (inPlace) _sanitizeUnvisitedNodes(dirty, inPlaceNodes);
      } catch (error) {
        if (inPlace) {
          _neutralizeRoot(dirty);
          _neutralizeDiscarded(dirty, inPlaceNodes);
        }
        throw error;
      } finally {
        IN_PLACE_VISITED = outerVisited;
      }
      if (inPlace) {
        if (_neutralizeDiscarded(dirty, inPlaceNodes)) throw typeErrorCreate("a node selected for removal could not be safely returned; refusing to sanitize in place");
        if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
        return dirty;
      }
      if (RETURN_DOM) {
        if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);
          while (body.firstChild) returnNode.appendChild(body.firstChild);
        } else returnNode = body;
        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) returnNode = importNode.call(originalDocument, returnNode, true);
        return returnNode;
      }
      let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
      if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
      let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      _parseConfig(cfg);
      SET_CONFIG = true;
      SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
      SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
    };
    DOMPurify.clearConfig = function() {
      CONFIG = null;
      SET_CONFIG = false;
      SET_CONFIG_ALLOWED_TAGS = null;
      SET_CONFIG_ALLOWED_ATTR = null;
      trustedTypesPolicy = defaultTrustedTypesPolicy;
      emptyHTML = "";
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
      if (!CONFIG) _parseConfig({});
      const lcTag = transformCaseFunc(tag);
      const lcName = transformCaseFunc(attr);
      if (typeof value === "string" && (_isUnsafeAttributeValue(attr, value) || !ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value))) return false;
      return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
      if (typeof hookFunction !== "function") return;
      if (!objectHasOwnProperty(hooks, entryPoint)) return;
      arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
      if (!objectHasOwnProperty(hooks, entryPoint)) return;
      if (hookFunction !== void 0) {
        const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
        return index === -1 ? void 0 : arraySplice(hooks[entryPoint], index, 1)[0];
      }
      return arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
      if (!objectHasOwnProperty(hooks, entryPoint)) return;
      hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
      hooks = _createHooksMap();
    };
    return DOMPurify;
  }
  var purify_default = createDOMPurify();

  // src/utils/Sanitizer.js
  var DEFAULT_DOMPURIFY_CONFIG = Object.freeze({
    USE_PROFILES: { html: true, svg: true, svgFilters: true },
    ADD_ATTR: [
      "onclick",
      "oninput",
      "onchange",
      "onkeydown",
      "autofocus",
      "autocomplete",
      "data-opt-key",
      "data-brand",
      "data-field-type",
      "data-seat-id",
      "data-hole",
      "data-banter",
      "data-count",
      "data-theme",
      "data-customized",
      "data-tab",
      "playsinline",
      "fetchpriority",
      "aria-label",
      "aria-hidden",
      "aria-live",
      "aria-modal",
      "role",
      "tabindex"
    ],
    ADD_TAGS: [
      "circle",
      "svg",
      "path",
      "line",
      "rect",
      "defs",
      "clipPath",
      "g",
      "polygon",
      "text",
      "use",
      "style"
    ],
    ALLOW_DATA_ATTR: true
  });
  var USER_INPUT_DOMPURIFY_CONFIG = Object.freeze({
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true
  });
  function getDOMPurify() {
    if (typeof window !== "undefined" && window.DOMPurify && typeof window.DOMPurify.sanitize === "function") {
      return window.DOMPurify;
    }
    if (purify_default && typeof purify_default.sanitize === "function") {
      return purify_default;
    }
    if (typeof purify_default === "function") {
      const win = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" && globalThis.window ? globalThis.window : null;
      if (win) {
        try {
          const instance = purify_default(win);
          if (instance && typeof instance.sanitize === "function") {
            return instance;
          }
        } catch (_) {
        }
      }
    }
    return null;
  }
  function fallbackSanitize(str) {
    if (typeof str !== "string") return "";
    return str.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "").replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "").replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, "").replace(/\bon\w+\s*=\s*(?:'[^']*'|"[^"]*"|[^\s>]+)/gi, "").replace(/javascript\s*:/gi, "");
  }
  function sanitizeHtml(html2, contextNode = null, options = {}) {
    if (typeof html2 !== "string") return html2 === null || html2 === void 0 ? "" : String(html2);
    if (!html2.trim()) return "";
    const purify = getDOMPurify();
    if (!purify || typeof purify.sanitize !== "function") {
      return fallbackSanitize(html2);
    }
    const isSvg = contextNode && (typeof SVGElement !== "undefined" && contextNode instanceof SVGElement || contextNode.namespaceURI === "http://www.w3.org/2000/svg");
    const config = {
      ...DEFAULT_DOMPURIFY_CONFIG,
      ...options
    };
    if (isSvg) {
      config.NAMESPACE = "http://www.w3.org/2000/svg";
    }
    try {
      return purify.sanitize(html2, config);
    } catch (_) {
      return fallbackSanitize(html2);
    }
  }
  function sanitizeUserInput(input, options = {}) {
    if (input === null || input === void 0) return "";
    const str = String(input);
    if (!str) return "";
    const purify = getDOMPurify();
    let cleaned = "";
    if (purify && typeof purify.sanitize === "function") {
      try {
        cleaned = purify.sanitize(str, {
          ...USER_INPUT_DOMPURIFY_CONFIG,
          ...options
        });
      } catch (_) {
        cleaned = fallbackSanitize(str).replace(/<[^>]*>/g, "");
      }
    } else {
      cleaned = fallbackSanitize(str).replace(/<[^>]*>/g, "");
    }
    cleaned = cleaned.replace(/javascript\s*:/gi, "");
    return cleaned.trim();
  }
  function installInnerHtmlHook(win = typeof window !== "undefined" ? window : null) {
    if (!win || !win.Element || !win.Element.prototype) return false;
    const proto = win.Element.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(proto, "innerHTML") || win.HTMLElement && Object.getOwnPropertyDescriptor(win.HTMLElement.prototype, "innerHTML");
    if (!descriptor || !descriptor.set) return false;
    if (proto.__ccInnerHtmlHookInstalled) return true;
    const originalSet = descriptor.set;
    const originalGet = descriptor.get;
    Object.defineProperty(proto, "innerHTML", {
      get() {
        return originalGet.call(this);
      },
      set(val) {
        if (typeof val !== "string") {
          return originalSet.call(this, val === null || val === void 0 ? "" : String(val));
        }
        if (!val) {
          return originalSet.call(this, "");
        }
        const sanitized = sanitizeHtml(val, this);
        return originalSet.call(this, sanitized);
      },
      configurable: true,
      enumerable: true
    });
    proto.__ccInnerHtmlHookInstalled = true;
    if (win.ShadowRoot && win.ShadowRoot.prototype) {
      const srDesc = Object.getOwnPropertyDescriptor(win.ShadowRoot.prototype, "innerHTML");
      if (srDesc && srDesc.set && !win.ShadowRoot.prototype.__ccInnerHtmlHookInstalled) {
        const origSrSet = srDesc.set;
        const origSrGet = srDesc.get;
        Object.defineProperty(win.ShadowRoot.prototype, "innerHTML", {
          get() {
            return origSrGet.call(this);
          },
          set(val) {
            if (typeof val !== "string") {
              return origSrSet.call(this, val === null || val === void 0 ? "" : String(val));
            }
            if (!val) return origSrSet.call(this, "");
            const sanitized = sanitizeHtml(val, this);
            return origSrSet.call(this, sanitized);
          },
          configurable: true,
          enumerable: true
        });
        win.ShadowRoot.prototype.__ccInnerHtmlHookInstalled = true;
      }
    }
    return true;
  }
  function installUserInputHook(win = typeof window !== "undefined" ? window : null) {
    if (!win || !win.document) return false;
    if (win.__ccUserInputHookInstalled) return true;
    const doc = win.document;
    doc.addEventListener("input", (e) => {
      const t = e.target;
      if (!t || t.tagName !== "INPUT" && t.tagName !== "TEXTAREA") return;
      if (["checkbox", "radio", "file", "range", "button", "submit"].includes(t.type)) return;
      if (typeof t.value === "string" && (t.value.includes("<") || t.value.includes(">"))) {
        const sanitized = sanitizeUserInput(t.value);
        if (t.value !== sanitized) {
          t.value = sanitized;
        }
      }
    }, true);
    doc.addEventListener("change", (e) => {
      const t = e.target;
      if (!t || t.tagName !== "INPUT" && t.tagName !== "TEXTAREA") return;
      if (["checkbox", "radio", "file", "range", "button", "submit"].includes(t.type)) return;
      if (typeof t.value === "string") {
        const sanitized = sanitizeUserInput(t.value);
        if (t.value !== sanitized) {
          t.value = sanitized;
        }
      }
    }, true);
    doc.addEventListener("paste", (e) => {
      const t = e.target;
      if (!t || t.tagName !== "INPUT" && t.tagName !== "TEXTAREA") return;
      if (["checkbox", "radio", "file", "range", "button", "submit"].includes(t.type)) return;
      setTimeout(() => {
        if (typeof t.value === "string") {
          const sanitized = sanitizeUserInput(t.value);
          if (t.value !== sanitized) {
            t.value = sanitized;
          }
        }
      }, 0);
    }, true);
    if (typeof win.prompt === "function") {
      const originalPrompt = win.prompt;
      win.prompt = function(...args) {
        const res = originalPrompt.apply(this, args);
        if (typeof res === "string") {
          return sanitizeUserInput(res);
        }
        return res;
      };
    }
    win.__ccUserInputHookInstalled = true;
    return true;
  }
  function initSanitizer(win = typeof window !== "undefined" ? window : null) {
    if (!win) return;
    installInnerHtmlHook(win);
    installUserInputHook(win);
    const purify = getDOMPurify();
    if (purify && !win.DOMPurify) {
      win.DOMPurify = purify;
    }
    win.Sanitizer = Sanitizer;
    win.sanitizeHtml = sanitizeHtml;
    win.sanitizeUserInput = sanitizeUserInput;
  }
  var Sanitizer = {
    getDOMPurify,
    sanitizeHtml,
    sanitizeUserInput,
    installInnerHtmlHook,
    installUserInputHook,
    initSanitizer,
    DEFAULT_DOMPURIFY_CONFIG,
    USER_INPUT_DOMPURIFY_CONFIG
  };
  if (typeof window !== "undefined") {
    initSanitizer(window);
  }

  // src/profile/Profile.js
  function getStorage2(storage = null) {
    return storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
  }
  var STORAGE_KEY_PROFILE = "cc_player_profile";
  var STORAGE_KEY_NAME = "cc_player_name";
  var STORAGE_KEY_AVATAR = "cc_player_avatar";
  var STORAGE_KEY_DAILY_PUZZLE = "cc_daily_puzzle_stats";
  var STORAGE_KEY_DISCARD_TRAINER = "cc_discard_trainer_stats";
  var STORAGE_KEY_PEGGING_TRAINER = "cc_pegging_trainer_stats";
  var STORAGE_KEY_COUNTING_TRAINER = "cc_counting_trainer_stats";
  var STORAGE_KEY_CUSTOM_3D_BOARDS = "cc_custom_3d_boards";
  var GAME_BRANDS = Object.freeze([
    { id: "crazy", name: "Crazy Cribbage", shortName: "Crazy", icon: "\u{1F0CF}", color: "#facc15", badgeBg: "rgba(245, 158, 11, 0.2)", border: "rgba(245, 158, 11, 0.4)" },
    { id: "clash", name: "Cribbage Clash", shortName: "Clash", icon: "\u2694\uFE0F", color: "#38bdf8", badgeBg: "rgba(56, 189, 248, 0.2)", border: "rgba(56, 189, 248, 0.4)" },
    { id: "pints", name: "Pints & Pegs", shortName: "Pints", icon: "\u{1F37A}", color: "#10b981", badgeBg: "rgba(16, 185, 129, 0.2)", border: "rgba(16, 185, 129, 0.4)" },
    { id: "adult", name: "Skunked & Stripped", shortName: "Adult", icon: "\u{1F9A8}", color: "#ec4899", badgeBg: "rgba(244, 63, 94, 0.2)", border: "rgba(244, 63, 94, 0.4)" }
  ]);
  var Profile = class _Profile {
    static _instance = null;
    constructor(options = {}) {
      this.name = options.name || "Player";
      this.avatar = options.avatar || "joker";
      this.stats = {
        totalGamesPlayed: 0,
        wins: 0,
        losses: 0,
        currentStreak: 0,
        bestStreak: 0,
        skunkWins: 0,
        skunkLosses: 0,
        highestScore: 0,
        totalPoints: 0,
        lastPlayed: null,
        dailyPuzzle: {
          currentStreak: 0,
          bestStreak: 0,
          lastPlayedDate: "",
          history: {},
          totalPlayed: 0,
          perfectDiscards: 0,
          peggingWins: 0,
          ...options.stats?.dailyPuzzle || {}
        },
        discardTrainer: {
          handsPlayed: 0,
          optimalCount: 0,
          currentStreak: 0,
          bestStreak: 0,
          totalLossEV: 0,
          averageLossEV: 0,
          accuracyPct: 0,
          lastPlayedDate: "",
          ...options.stats?.discardTrainer || {}
        },
        peggingTrainer: {
          scenariosPlayed: 0,
          optimalCount: 0,
          currentStreak: 0,
          bestStreak: 0,
          totalLossEV: 0,
          averageLossEV: 0,
          accuracyPct: 0,
          lastPlayedDate: "",
          ...options.stats?.peggingTrainer || {}
        },
        countingTrainer: {
          handsPlayed: 0,
          handsCorrect: 0,
          handsWrong: 0,
          currentStreak: 0,
          bestStreak: 0,
          accuracyPct: 0,
          lastPlayedDate: "",
          ...options.stats?.countingTrainer || {}
        },
        ...options.stats || {}
      };
      this.history = Array.isArray(options.history) ? options.history : [];
      this.trophies = {
        unlocked: {},
        byBrand: {
          crazy: [],
          clash: [],
          pints: [],
          adult: []
        },
        ...options.trophies || {}
      };
      if (!this.trophies.byBrand) {
        this.trophies.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      }
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(this.trophies.byBrand[b.id])) {
          this.trophies.byBrand[b.id] = [];
        }
      }
      this.replays = {
        byBrand: {
          crazy: [],
          clash: [],
          pints: [],
          adult: []
        },
        list: [],
        ...options.replays || {}
      };
      if (!this.replays.byBrand) {
        this.replays.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      }
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(this.replays.byBrand[b.id])) {
          this.replays.byBrand[b.id] = [];
        }
      }
      if (!Array.isArray(this.replays.list)) {
        this.replays.list = [];
      }
      this.custom3DBoards = {
        byBrand: {
          crazy: [],
          clash: [],
          pints: [],
          adult: []
        },
        list: [],
        ...options.custom3DBoards || {}
      };
      if (!this.custom3DBoards.byBrand) {
        this.custom3DBoards = { crazy: [], clash: [], pints: [], adult: [] };
      }
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(this.custom3DBoards.byBrand[b.id])) {
          this.custom3DBoards.byBrand[b.id] = [];
        }
      }
      if (!Array.isArray(this.custom3DBoards.list)) {
        this.custom3DBoards.list = [];
      }
    }
    /**
     * Retrieves singleton Profile instance, auto-loading from storage.
     * @param {Object} [storage=null]
     * @returns {Profile}
     */
    static getInstance(storage = null) {
      if (!_Profile._instance) {
        _Profile._instance = _Profile.load(storage);
      }
      return _Profile._instance;
    }
    /**
     * Loads player profile data from storage.
     * @param {Object} [storage=null]
     * @returns {Profile}
     */
    static load(storage = null) {
      const s = getStorage2(storage);
      let savedName = "Player";
      let savedAvatar = "joker";
      let savedData = null;
      let savedDaily = null;
      let savedTrainer = null;
      let savedPeggingTrainer = null;
      if (s) {
        try {
          const rawName = s.getItem(STORAGE_KEY_NAME);
          if (rawName && typeof rawName === "string") savedName = rawName.trim();
          const rawAvatar = s.getItem(STORAGE_KEY_AVATAR);
          if (rawAvatar && typeof rawAvatar === "string") savedAvatar = rawAvatar.trim();
          const rawProfile = s.getItem(STORAGE_KEY_PROFILE);
          if (rawProfile && typeof rawProfile === "string") {
            savedData = JSON.parse(rawProfile);
          }
          const rawDaily = s.getItem(STORAGE_KEY_DAILY_PUZZLE);
          if (rawDaily && typeof rawDaily === "string") {
            try {
              savedDaily = JSON.parse(rawDaily);
            } catch (_) {
            }
          }
          const rawTrainer = s.getItem(STORAGE_KEY_DISCARD_TRAINER);
          if (rawTrainer && typeof rawTrainer === "string") {
            try {
              savedTrainer = JSON.parse(rawTrainer);
            } catch (_) {
            }
          }
          const rawPegTrainer = s.getItem(STORAGE_KEY_PEGGING_TRAINER);
          if (rawPegTrainer && typeof rawPegTrainer === "string") {
            try {
              savedPeggingTrainer = JSON.parse(rawPegTrainer);
            } catch (_) {
            }
          }
        } catch (err) {
          console.warn("[Profile] Failed to load profile from storage:", err);
        }
      }
      if (typeof document !== "undefined") {
        const optNameEl = document.getElementById("optPlayerName");
        if (optNameEl) {
          if (optNameEl.value && optNameEl.value.trim()) {
            savedName = optNameEl.value.trim();
          } else if (savedName) {
            optNameEl.value = savedName;
          }
        }
      }
      const mergedDaily = {
        currentStreak: 0,
        bestStreak: 0,
        lastPlayedDate: "",
        history: {},
        totalPlayed: 0,
        perfectDiscards: 0,
        peggingWins: 0,
        ...savedData?.stats?.dailyPuzzle || {},
        ...savedDaily || {}
      };
      const mergedTrainer = {
        handsPlayed: 0,
        optimalCount: 0,
        currentStreak: 0,
        bestStreak: 0,
        totalLossEV: 0,
        averageLossEV: 0,
        accuracyPct: 0,
        lastPlayedDate: "",
        ...savedData?.stats?.discardTrainer || {},
        ...savedTrainer || {}
      };
      if (mergedTrainer.handsPlayed > 0) {
        mergedTrainer.accuracyPct = Math.round(mergedTrainer.optimalCount / mergedTrainer.handsPlayed * 100);
        mergedTrainer.averageLossEV = Math.round(mergedTrainer.totalLossEV / mergedTrainer.handsPlayed * 100) / 100;
      }
      const mergedPeggingTrainer = {
        scenariosPlayed: 0,
        optimalCount: 0,
        currentStreak: 0,
        bestStreak: 0,
        totalLossEV: 0,
        averageLossEV: 0,
        accuracyPct: 0,
        lastPlayedDate: "",
        ...savedData?.stats?.peggingTrainer || {},
        ...savedPeggingTrainer || {}
      };
      if (mergedPeggingTrainer.scenariosPlayed > 0) {
        mergedPeggingTrainer.accuracyPct = Math.round(mergedPeggingTrainer.optimalCount / mergedPeggingTrainer.scenariosPlayed * 100);
        mergedPeggingTrainer.averageLossEV = Math.round(mergedPeggingTrainer.totalLossEV / mergedPeggingTrainer.scenariosPlayed * 100) / 100;
      }
      const finalStats = {
        ...savedData?.stats || {},
        dailyPuzzle: mergedDaily,
        discardTrainer: mergedTrainer,
        peggingTrainer: mergedPeggingTrainer
      };
      const savedTrophies = {
        unlocked: {},
        byBrand: { crazy: [], clash: [], pints: [], adult: [] },
        ...savedData?.trophies || {}
      };
      if (!savedTrophies.byBrand) {
        savedTrophies.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      }
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(savedTrophies.byBrand[b.id])) {
          savedTrophies.byBrand[b.id] = [];
        }
      }
      if (s) {
        try {
          const rawAch = s.getItem("crazyCribbage.achievements");
          if (rawAch) {
            const parsedAch = JSON.parse(rawAch);
            for (const [badgeId, badgeMeta] of Object.entries(parsedAch)) {
              const bDef = Array.isArray(BADGE_DEFINITIONS) ? BADGE_DEFINITIONS.find((b) => b.id === badgeId) : null;
              const brand = bDef?.brand || "crazy";
              if (!savedTrophies.unlocked[badgeId]) {
                savedTrophies.unlocked[badgeId] = {
                  unlockedAt: badgeMeta.unlockedAt || Date.now(),
                  brand
                };
              }
              if (!savedTrophies.byBrand[brand].includes(badgeId)) {
                savedTrophies.byBrand[brand].push(badgeId);
              }
            }
          }
        } catch (_) {
        }
      }
      const savedReplays = {
        byBrand: { crazy: [], clash: [], pints: [], adult: [] },
        list: [],
        ...savedData?.replays || {}
      };
      if (!savedReplays.byBrand) {
        savedReplays.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      }
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(savedReplays.byBrand[b.id])) {
          savedReplays.byBrand[b.id] = [];
        }
      }
      if (!Array.isArray(savedReplays.list)) {
        savedReplays.list = [];
      }
      if (s) {
        try {
          const rawRep = s.getItem("crazyCribbage.replays.v1");
          if (rawRep) {
            const parsedRep = JSON.parse(rawRep);
            if (Array.isArray(parsedRep)) {
              for (const r of parsedRep) {
                if (!r || !r.id) continue;
                const brand = r.brand || "crazy";
                if (!savedReplays.list.some((item) => item.id === r.id)) {
                  savedReplays.list.push(r);
                }
                if (!savedReplays.byBrand[brand]) {
                  savedReplays.byBrand[brand] = [];
                }
                if (!savedReplays.byBrand[brand].some((item) => item.id === r.id)) {
                  savedReplays.byBrand[brand].push(r);
                }
              }
            }
          }
        } catch (_) {
        }
      }
      savedReplays.list.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      for (const b of GAME_BRANDS) {
        savedReplays.byBrand[b.id].sort((a, b2) => (b2.timestamp || 0) - (a.timestamp || 0));
      }
      const savedCustomBoards = {
        byBrand: { crazy: [], clash: [], pints: [], adult: [] },
        list: [],
        ...savedData?.custom3DBoards || {}
      };
      if (!savedCustomBoards.byBrand) {
        savedCustomBoards.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      }
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(savedCustomBoards.byBrand[b.id])) {
          savedCustomBoards.byBrand[b.id] = [];
        }
      }
      if (!Array.isArray(savedCustomBoards.list)) {
        savedCustomBoards.list = [];
      }
      if (s) {
        try {
          const rawBoards = s.getItem(STORAGE_KEY_CUSTOM_3D_BOARDS);
          if (rawBoards) {
            const parsedBoards = JSON.parse(rawBoards);
            if (Array.isArray(parsedBoards)) {
              for (const b of parsedBoards) {
                if (!b || !b.id) continue;
                const brandVal = b.brand || "crazy";
                const existingIdx = savedCustomBoards.list.findIndex((x) => x.id === b.id);
                if (existingIdx >= 0) {
                  savedCustomBoards.list[existingIdx] = Object.assign({}, savedCustomBoards.list[existingIdx], b);
                } else {
                  savedCustomBoards.list.push(b);
                }
                const targetBrands = brandVal === "all" ? GAME_BRANDS.map((g) => g.id) : brandVal.split(",").map((str) => str.trim());
                for (const tb of targetBrands) {
                  if (savedCustomBoards.byBrand[tb] && !savedCustomBoards.byBrand[tb].some((x) => x.id === b.id)) {
                    savedCustomBoards.byBrand[tb].push(b);
                  }
                }
              }
            }
          }
        } catch (_) {
        }
      }
      return new _Profile({
        name: savedName,
        avatar: savedAvatar,
        stats: finalStats,
        trophies: savedTrophies,
        replays: savedReplays,
        custom3DBoards: savedCustomBoards,
        history: savedData?.history || []
      });
    }
    /**
     * Saves current profile data to storage.
     * @param {Object} [storage=null]
     */
    save(storage = null) {
      const s = getStorage2(storage);
      if (!s) return;
      try {
        if (this.name) s.setItem(STORAGE_KEY_NAME, this.name);
        if (this.avatar) s.setItem(STORAGE_KEY_AVATAR, this.avatar);
        if (this.stats?.dailyPuzzle) {
          try {
            s.setItem(STORAGE_KEY_DAILY_PUZZLE, JSON.stringify(this.stats.dailyPuzzle));
          } catch (_) {
          }
        }
        if (this.stats?.discardTrainer) {
          try {
            s.setItem(STORAGE_KEY_DISCARD_TRAINER, JSON.stringify(this.stats.discardTrainer));
          } catch (_) {
          }
        }
        if (this.stats?.peggingTrainer) {
          try {
            s.setItem(STORAGE_KEY_PEGGING_TRAINER, JSON.stringify(this.stats.peggingTrainer));
          } catch (_) {
          }
        }
        const payload = {
          name: this.name,
          avatar: this.avatar,
          stats: this.stats,
          trophies: this.trophies,
          replays: this.replays,
          custom3DBoards: this.custom3DBoards,
          history: this.history.slice(0, 100),
          // Cap history to 100 most recent
          updatedAt: Date.now()
        };
        s.setItem(STORAGE_KEY_PROFILE, JSON.stringify(payload));
        if (this.trophies?.unlocked) {
          try {
            s.setItem("crazyCribbage.achievements", JSON.stringify(this.trophies.unlocked));
          } catch (_) {
          }
        }
        if (this.replays?.list && Array.isArray(this.replays.list)) {
          try {
            s.setItem("crazyCribbage.replays.v1", JSON.stringify(this.replays.list.slice(0, 30)));
          } catch (_) {
          }
        }
        if (this.custom3DBoards?.list && Array.isArray(this.custom3DBoards.list)) {
          try {
            s.setItem(STORAGE_KEY_CUSTOM_3D_BOARDS, JSON.stringify(this.custom3DBoards.list));
          } catch (_) {
          }
        }
      } catch (err) {
        console.warn("[Profile] Failed to save profile to storage:", err);
      }
    }
    /**
     * Gets current player name.
     * @param {Object} [storage=null]
     * @returns {string}
     */
    getName(storage = null) {
      const s = getStorage2(storage);
      if (s) {
        try {
          const stored = s.getItem(STORAGE_KEY_NAME);
          if (stored && typeof stored === "string" && stored.trim()) {
            this.name = stored.trim();
            if (typeof document !== "undefined") {
              const el = document.getElementById("optPlayerName");
              if (el && (!el.value || !el.value.trim())) {
                el.value = this.name;
              }
            }
            return this.name;
          }
        } catch (_) {
        }
      }
      if (typeof document !== "undefined") {
        const el = document.getElementById("optPlayerName");
        if (el && el.value.trim()) {
          this.name = el.value.trim();
          return this.name;
        }
      }
      return this.name || "Player";
    }
    /**
     * Updates player name, syncs with storage and DOM, and triggers update events.
     * @param {string} newName
     * @param {Object} [storage=null]
     * @returns {string}
     */
    setName(newName, storage = null) {
      const sanitized = sanitizeUserInput(newName);
      const alphanumeric = sanitized.replace(/[^a-zA-Z0-9]/g, "").trim();
      this.name = alphanumeric ? alphanumeric.slice(0, 24) : "Player";
      const s = getStorage2(storage);
      if (s) {
        try {
          s.setItem(STORAGE_KEY_NAME, this.name);
        } catch (_) {
        }
      }
      if (typeof document !== "undefined") {
        const el = document.getElementById("optPlayerName");
        if (el && el.value !== this.name) {
          el.value = this.name;
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.name;
    }
    /**
     * Gets current avatar ID.
     * @param {Object} [storage=null]
     * @returns {string}
     */
    getAvatar(storage = null) {
      const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
      if (avMgr && typeof avMgr.getSelectedAvatarId === "function") {
        this.avatar = avMgr.getSelectedAvatarId(getStorage2(storage));
      }
      return this.avatar || "joker";
    }
    /**
     * Sets current player avatar ID.
     * @param {string} avatarId
     * @param {Object} [storage=null]
     * @returns {string}
     */
    setAvatar(avatarId, storage = null) {
      const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
      if (avMgr && typeof avMgr.setSelectedAvatarId === "function") {
        avMgr.setSelectedAvatarId(avatarId, getStorage2(storage));
      }
      this.avatar = avatarId;
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.avatar;
    }
    /**
     * Returns the full avatar definition object.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getAvatarObject(storage = null) {
      const avId = this.getAvatar(storage);
      const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
      return avMgr ? avMgr.getAvatarById(avId, getStorage2(storage)) : null;
    }
    /**
     * Returns career match statistics and win rate.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getStats(storage = null) {
      const total = this.stats.totalGamesPlayed || 0;
      const wins = this.stats.wins || 0;
      const losses = this.stats.losses || 0;
      const winRateNum = total > 0 ? wins / total * 100 : 0;
      const winRate = total > 0 ? `${winRateNum.toFixed(1)}%` : "0%";
      return {
        totalGamesPlayed: total,
        wins,
        losses,
        winRate,
        winRateNum: Math.round(winRateNum * 10) / 10,
        currentStreak: this.stats.currentStreak || 0,
        bestStreak: this.stats.bestStreak || 0,
        skunkWins: this.stats.skunkWins || 0,
        skunkLosses: this.stats.skunkLosses || 0,
        highestScore: this.stats.highestScore || 0,
        totalPoints: this.stats.totalPoints || 0,
        lastPlayed: this.stats.lastPlayed || null
      };
    }
    /**
     * Retrieves win/loss statistics and variant setups for all 4 games.
     * @param {Object} [storage=null]
     * @returns {Object} map of brandId -> brand record details
     */
    getGameRecords(storage = null) {
      const s = getStorage2(storage);
      const settingsMgr = typeof window !== "undefined" && window.CrazyCribbage?.SettingsManager || null;
      const records = {};
      for (const b of GAME_BRANDS) {
        let wins = 0;
        let losses = 0;
        let variants = [];
        if (settingsMgr && typeof settingsMgr.loadRecords === "function") {
          const vMap = settingsMgr.loadRecords(s, b.id);
          if (vMap && typeof vMap === "object") {
            variants = Object.keys(vMap).map((k) => ({
              key: k,
              label: vMap[k].label || k,
              wins: Number(vMap[k].wins) || 0,
              losses: Number(vMap[k].losses) || 0
            })).filter((r) => r.wins + r.losses > 0).sort((a, b2) => b2.wins + b2.losses - (a.wins + a.losses));
            wins = variants.reduce((sum, r) => sum + r.wins, 0);
            losses = variants.reduce((sum, r) => sum + r.losses, 0);
          }
        }
        const brandHistory = (this.history || []).filter((m) => (m.brand || "crazy") === b.id);
        const histWins = brandHistory.filter((m) => m.userWon).length;
        const histLosses = brandHistory.filter((m) => !m.userWon).length;
        if (this.stats?.byBrand?.[b.id]) {
          const sb = this.stats.byBrand[b.id];
          wins = Math.max(wins, Number(sb.wins) || 0);
          losses = Math.max(losses, Number(sb.losses) || 0);
        }
        wins = Math.max(wins, histWins);
        losses = Math.max(losses, histLosses);
        const total = wins + losses;
        const winRateNum = total > 0 ? wins / total * 100 : 0;
        const winRate = total > 0 ? `${winRateNum.toFixed(1)}%` : "0%";
        const brandTrophies = this.getTrophiesByBrand(b.id, storage);
        const brandReplays = this.getReplaysByBrand(b.id, storage);
        const brandCustomBoards = this.getCustom3DBoardsByBrand(b.id, storage);
        records[b.id] = {
          ...b,
          wins,
          losses,
          total,
          winRate,
          winRateNum: Math.round(winRateNum * 10) / 10,
          trophiesUnlocked: brandTrophies.unlockedCount,
          trophiesTotal: brandTrophies.totalCount,
          trophiesPct: brandTrophies.pct,
          replaysCount: Array.isArray(brandReplays) ? brandReplays.length : 0,
          customBoardsCount: Array.isArray(brandCustomBoards) ? brandCustomBoards.length : 0,
          variants,
          history: brandHistory
        };
      }
      return records;
    }
    /**
     * Computes career totals across all 4 games.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getOverallStats(storage = null) {
      const gameRecs = this.getGameRecords(storage);
      let totalWins = 0;
      let totalLosses = 0;
      for (const b of GAME_BRANDS) {
        totalWins += gameRecs[b.id].wins;
        totalLosses += gameRecs[b.id].losses;
      }
      const totalMatches = Math.max(this.stats.totalGamesPlayed || 0, totalWins + totalLosses);
      const winRateNum = totalMatches > 0 ? totalWins / totalMatches * 100 : 0;
      const winRate = totalMatches > 0 ? `${winRateNum.toFixed(1)}%` : "0%";
      const dailyPuzzle = this.getDailyPuzzleStats(storage);
      const discardTrainer = this.getDiscardTrainerStats(storage);
      const peggingTrainer = this.getPeggingTrainerStats(storage);
      const overallTrophies = this.getTrophiesByBrand("all", storage);
      const overallReplays = this.getReplaysByBrand("all", storage);
      const overallCustomBoards = this.getCustom3DBoardsByBrand("all", storage);
      return {
        totalGamesPlayed: totalMatches,
        wins: totalWins,
        losses: totalLosses,
        winRate,
        winRateNum: Math.round(winRateNum * 10) / 10,
        currentStreak: this.stats.currentStreak || 0,
        bestStreak: this.stats.bestStreak || 0,
        skunkWins: this.stats.skunkWins || 0,
        skunkLosses: this.stats.skunkLosses || 0,
        highestScore: this.stats.highestScore || 0,
        totalPoints: this.stats.totalPoints || 0,
        dailyPuzzle,
        discardTrainer,
        peggingTrainer,
        trophies: overallTrophies,
        trophiesUnlocked: overallTrophies.unlockedCount,
        trophiesTotal: overallTrophies.totalCount,
        trophiesPct: overallTrophies.pct,
        replaysTotal: Array.isArray(overallReplays) ? overallReplays.length : 0,
        customBoardsTotal: Array.isArray(overallCustomBoards) ? overallCustomBoards.length : 0
      };
    }
    /**
     * Retrieves player trophies, syncing with crazyCribbage.achievements storage.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getTrophies(storage = null) {
      const s = getStorage2(storage);
      if (!this.trophies) {
        this.trophies = { unlocked: {}, byBrand: { crazy: [], clash: [], pints: [], adult: [] } };
      }
      if (!this.trophies.unlocked) this.trophies.unlocked = {};
      if (!this.trophies.byBrand) this.trophies.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(this.trophies.byBrand[b.id])) {
          this.trophies.byBrand[b.id] = [];
        }
      }
      if (s) {
        try {
          const rawAch = s.getItem("crazyCribbage.achievements");
          if (rawAch) {
            const parsed = JSON.parse(rawAch);
            for (const [id, meta] of Object.entries(parsed)) {
              const bDef = Array.isArray(BADGE_DEFINITIONS) ? BADGE_DEFINITIONS.find((b) => b.id === id) : null;
              const brand = bDef?.brand || "crazy";
              if (!this.trophies.unlocked[id]) {
                this.trophies.unlocked[id] = { unlockedAt: meta.unlockedAt || Date.now(), brand };
              }
              if (!this.trophies.byBrand[brand].includes(id)) {
                this.trophies.byBrand[brand].push(id);
              }
            }
          }
        } catch (_) {
        }
      }
      return this.trophies;
    }
    /**
     * Retrieves trophies separated for a specific brand or all brands.
     * @param {string} [brand='all']
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getTrophiesByBrand(brand = "all", storage = null) {
      this.getTrophies(storage);
      const allDefs = Array.isArray(BADGE_DEFINITIONS) ? BADGE_DEFINITIONS : [];
      const targetBadges = !brand || brand === "all" ? allDefs : allDefs.filter((b) => (b.brand || "crazy") === brand);
      const unlocked = targetBadges.filter((b) => Boolean(this.trophies.unlocked[b.id])).map((b) => ({
        ...b,
        unlocked: true,
        unlockedAt: this.trophies.unlocked[b.id]?.unlockedAt || null
      }));
      const locked = targetBadges.filter((b) => !this.trophies.unlocked[b.id]).map((b) => ({
        ...b,
        unlocked: false,
        unlockedAt: null
      }));
      const totalCount = targetBadges.length;
      const unlockedCount = unlocked.length;
      const pct = totalCount > 0 ? Math.round(unlockedCount / totalCount * 100) : 0;
      return {
        brand: brand || "all",
        unlockedCount,
        totalCount,
        pct,
        unlocked,
        locked,
        all: [...unlocked, ...locked]
      };
    }
    /**
     * Records a newly unlocked trophy into player profile under the appropriate brand.
     * @param {string} badgeId
     * @param {string} [brand=null]
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    recordTrophy(badgeId, brand = null, storage = null) {
      if (!badgeId) return this.trophies;
      const bDef = Array.isArray(BADGE_DEFINITIONS) ? BADGE_DEFINITIONS.find((b) => b.id === badgeId) : null;
      const resolvedBrand = brand || bDef?.brand || "crazy";
      if (!this.trophies) {
        this.trophies = { unlocked: {}, byBrand: { crazy: [], clash: [], pints: [], adult: [] } };
      }
      if (!this.trophies.unlocked) this.trophies.unlocked = {};
      if (!this.trophies.byBrand) this.trophies.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      if (!Array.isArray(this.trophies.byBrand[resolvedBrand])) {
        this.trophies.byBrand[resolvedBrand] = [];
      }
      if (!this.trophies.unlocked[badgeId]) {
        this.trophies.unlocked[badgeId] = {
          unlockedAt: Date.now(),
          brand: resolvedBrand
        };
      }
      if (!this.trophies.byBrand[resolvedBrand].includes(badgeId)) {
        this.trophies.byBrand[resolvedBrand].push(badgeId);
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.trophies;
    }
    /**
     * Bulk synchronizes unlocked achievements map into profile trophies.
     * @param {Object} unlockedMap
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    syncTrophiesFromUnlocked(unlockedMap = {}, storage = null) {
      if (!unlockedMap || typeof unlockedMap !== "object") return this.trophies;
      if (!this.trophies) {
        this.trophies = { unlocked: {}, byBrand: { crazy: [], clash: [], pints: [], adult: [] } };
      }
      if (!this.trophies.unlocked) this.trophies.unlocked = {};
      if (!this.trophies.byBrand) this.trophies.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      let changed = false;
      for (const [id, meta] of Object.entries(unlockedMap)) {
        const bDef = Array.isArray(BADGE_DEFINITIONS) ? BADGE_DEFINITIONS.find((b) => b.id === id) : null;
        const brand = bDef?.brand || "crazy";
        if (!this.trophies.byBrand[brand]) this.trophies.byBrand[brand] = [];
        if (!this.trophies.unlocked[id]) {
          this.trophies.unlocked[id] = {
            unlockedAt: meta?.unlockedAt || Date.now(),
            brand
          };
          changed = true;
        }
        if (!this.trophies.byBrand[brand].includes(id)) {
          this.trophies.byBrand[brand].push(id);
          changed = true;
        }
      }
      if (changed) {
        this.save(storage);
        _Profile.notifyProfileUpdate();
      }
      return this.trophies;
    }
    /**
     * Resets trophies for a specific brand or all brands.
     * @param {Object} [storage=null]
     * @param {string} [brand=null]
     */
    clearTrophies(storage = null, brand = null) {
      const s = getStorage2(storage);
      if (!this.trophies) {
        this.trophies = { unlocked: {}, byBrand: { crazy: [], clash: [], pints: [], adult: [] } };
      }
      if (!brand || brand === "all") {
        this.trophies = {
          unlocked: {},
          byBrand: { crazy: [], clash: [], pints: [], adult: [] }
        };
        if (s) {
          try {
            s.setItem("crazyCribbage.achievements", JSON.stringify({}));
          } catch (_) {
          }
        }
      } else {
        const toRemove = this.trophies.byBrand[brand] || [];
        for (const id of toRemove) {
          delete this.trophies.unlocked[id];
        }
        this.trophies.byBrand[brand] = [];
        if (s) {
          try {
            s.setItem("crazyCribbage.achievements", JSON.stringify(this.trophies.unlocked));
          } catch (_) {
          }
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
    }
    /**
     * Retrieves player replays, syncing with crazyCribbage.replays.v1 storage.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getReplays(storage = null) {
      const s = getStorage2(storage);
      if (!this.replays) {
        this.replays = { byBrand: { crazy: [], clash: [], pints: [], adult: [] }, list: [] };
      }
      if (!this.replays.byBrand) {
        this.replays.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      }
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(this.replays.byBrand[b.id])) {
          this.replays.byBrand[b.id] = [];
        }
      }
      if (!Array.isArray(this.replays.list)) {
        this.replays.list = [];
      }
      if (s) {
        try {
          const raw = s.getItem("crazyCribbage.replays.v1");
          if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
              let changed = false;
              for (const r of parsed) {
                if (!r || !r.id) continue;
                const brand = r.brand || "crazy";
                if (!this.replays.list.some((item) => item.id === r.id)) {
                  this.replays.list.push(r);
                  changed = true;
                }
                if (!this.replays.byBrand[brand]) {
                  this.replays.byBrand[brand] = [];
                }
                if (!this.replays.byBrand[brand].some((item) => item.id === r.id)) {
                  this.replays.byBrand[brand].push(r);
                  changed = true;
                }
              }
              if (changed) {
                this.replays.list.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
                for (const b of GAME_BRANDS) {
                  this.replays.byBrand[b.id].sort((a, b2) => (b2.timestamp || 0) - (a.timestamp || 0));
                }
              }
            }
          }
        } catch (_) {
        }
      }
      return this.replays;
    }
    /**
     * Retrieves replays separated for a specific brand or all brands.
     * @param {string} [brand='all']
     * @param {Object} [storage=null]
     * @returns {Array<Object>}
     */
    getReplaysByBrand(brand = "all", storage = null) {
      this.getReplays(storage);
      if (!brand || brand === "all") {
        return [...this.replays.list].sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      }
      const list = this.replays.byBrand[brand] || [];
      return [...list].sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
    }
    /**
     * Records a match replay into player profile under the appropriate brand.
     * @param {Object} replay
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    recordReplay(replay, storage = null) {
      if (!replay || !replay.id) return this.replays;
      const brand = replay.brand || "crazy";
      if (!this.replays) {
        this.replays = { byBrand: { crazy: [], clash: [], pints: [], adult: [] }, list: [] };
      }
      if (!this.replays.byBrand) {
        this.replays.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      }
      if (!Array.isArray(this.replays.byBrand[brand])) {
        this.replays.byBrand[brand] = [];
      }
      if (!Array.isArray(this.replays.list)) {
        this.replays.list = [];
      }
      this.replays.list = this.replays.list.filter((r) => r.id !== replay.id);
      this.replays.byBrand[brand] = this.replays.byBrand[brand].filter((r) => r.id !== replay.id);
      this.replays.list.unshift(replay);
      this.replays.byBrand[brand].unshift(replay);
      this.replays.list = this.replays.list.slice(0, 30);
      this.replays.byBrand[brand] = this.replays.byBrand[brand].slice(0, 20);
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.replays;
    }
    /**
     * Deletes a replay by ID across all brand collections.
     * @param {string} id
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    deleteReplay(id, storage = null) {
      if (!id || !this.replays) return this.replays;
      this.replays.list = (this.replays.list || []).filter((r) => r.id !== id);
      for (const b of GAME_BRANDS) {
        if (Array.isArray(this.replays.byBrand[b.id])) {
          this.replays.byBrand[b.id] = this.replays.byBrand[b.id].filter((r) => r.id !== id);
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.replays;
    }
    /**
     * Clears saved replays for a specific brand or all brands.
     * @param {string} [brand='all']
     * @param {Object} [storage=null]
     */
    clearReplays(brand = "all", storage = null) {
      const s = getStorage2(storage);
      if (!this.replays) {
        this.replays = { byBrand: { crazy: [], clash: [], pints: [], adult: [] }, list: [] };
      }
      if (!brand || brand === "all") {
        this.replays = {
          byBrand: { crazy: [], clash: [], pints: [], adult: [] },
          list: []
        };
        if (s) {
          try {
            s.setItem("crazyCribbage.replays.v1", JSON.stringify([]));
          } catch (_) {
          }
        }
      } else {
        const removedIds = new Set((this.replays.byBrand[brand] || []).map((r) => r.id));
        this.replays.byBrand[brand] = [];
        this.replays.list = this.replays.list.filter((r) => !removedIds.has(r.id));
        if (s) {
          try {
            s.setItem("crazyCribbage.replays.v1", JSON.stringify(this.replays.list));
          } catch (_) {
          }
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
    }
    /**
     * Retrieves player's custom 3D boards, categorized by brand and overall list.
     * @param {Object} [storage=null]
     * @returns {{ byBrand: Object, list: Array<Object> }}
     */
    getCustom3DBoards(storage = null) {
      const s = getStorage2(storage);
      if (!this.custom3DBoards) {
        this.custom3DBoards = { byBrand: { crazy: [], clash: [], pints: [], adult: [] }, list: [] };
      }
      if (!this.custom3DBoards.byBrand) {
        this.custom3DBoards.byBrand = { crazy: [], clash: [], pints: [], adult: [] };
      }
      for (const b of GAME_BRANDS) {
        if (!Array.isArray(this.custom3DBoards.byBrand[b.id])) {
          this.custom3DBoards.byBrand[b.id] = [];
        }
      }
      if (!Array.isArray(this.custom3DBoards.list)) {
        this.custom3DBoards.list = [];
      }
      if (s) {
        try {
          const raw = s.getItem(STORAGE_KEY_CUSTOM_3D_BOARDS);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
              let changed = false;
              for (const b of parsed) {
                if (!b || !b.id) continue;
                const brandVal = b.brand || "crazy";
                if (!this.custom3DBoards.list.some((item) => item.id === b.id)) {
                  this.custom3DBoards.list.push(b);
                  changed = true;
                }
                const targetBrands = brandVal === "all" ? GAME_BRANDS.map((g) => g.id) : brandVal.split(",").map((str) => str.trim());
                for (const tb of targetBrands) {
                  if (this.custom3DBoards.byBrand[tb] && !this.custom3DBoards.byBrand[tb].some((item) => item.id === b.id)) {
                    this.custom3DBoards.byBrand[tb].push(b);
                    changed = true;
                  }
                }
              }
            }
          }
        } catch (_) {
        }
      }
      return this.custom3DBoards;
    }
    /**
     * Retrieves custom 3D boards separated for a specific brand or all brands.
     * @param {string} [brand='all']
     * @param {Object} [storage=null]
     * @returns {Array<Object>}
     */
    getCustom3DBoardsByBrand(brand = "all", storage = null) {
      this.getCustom3DBoards(storage);
      if (!brand || brand === "all") {
        return [...this.custom3DBoards.list];
      }
      const list = this.custom3DBoards.byBrand[brand] || [];
      return [...list];
    }
    /**
     * Records or updates a custom 3D board into user profile for the appropriate brand.
     * @param {Object} boardConfig
     * @param {string} [brand=null]
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    saveCustom3DBoard(boardConfig, brand = null, storage = null) {
      if (!boardConfig || !boardConfig.id) return null;
      const resolvedBrand = brand || boardConfig.brand || "crazy";
      this.getCustom3DBoards(storage);
      const clean = {
        ...boardConfig,
        id: String(boardConfig.id).trim(),
        name: String(boardConfig.name || "Custom Board").trim(),
        brand: resolvedBrand,
        isCustom: true,
        updatedAt: Date.now()
      };
      this.custom3DBoards.list = this.custom3DBoards.list.filter((b) => b.id !== clean.id);
      this.custom3DBoards.list.unshift(clean);
      const targetBrands = resolvedBrand === "all" ? GAME_BRANDS.map((g) => g.id) : resolvedBrand.split(",").map((s) => s.trim());
      for (const b of GAME_BRANDS) {
        if (this.custom3DBoards.byBrand[b.id]) {
          this.custom3DBoards.byBrand[b.id] = this.custom3DBoards.byBrand[b.id].filter((x) => x.id !== clean.id);
          if (targetBrands.includes(b.id)) {
            this.custom3DBoards.byBrand[b.id].unshift(clean);
          }
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return clean;
    }
    /**
     * Deletes a custom 3D board by ID across all brand collections.
     * @param {string} id
     * @param {Object} [storage=null]
     * @returns {boolean}
     */
    deleteCustom3DBoard(id, storage = null) {
      if (!id || !this.custom3DBoards) return false;
      this.custom3DBoards.list = (this.custom3DBoards.list || []).filter((b) => b.id !== id);
      for (const b of GAME_BRANDS) {
        if (Array.isArray(this.custom3DBoards.byBrand[b.id])) {
          this.custom3DBoards.byBrand[b.id] = this.custom3DBoards.byBrand[b.id].filter((x) => x.id !== id);
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return true;
    }
    /**
     * Clears saved custom 3D boards for a specific brand or all brands.
     * @param {string} [brand='all']
     * @param {Object} [storage=null]
     */
    clearCustom3DBoards(brand = "all", storage = null) {
      if (!this.custom3DBoards) {
        this.custom3DBoards = { byBrand: { crazy: [], clash: [], pints: [], adult: [] }, list: [] };
      }
      if (!brand || brand === "all") {
        this.custom3DBoards = {
          byBrand: { crazy: [], clash: [], pints: [], adult: [] },
          list: []
        };
      } else {
        const removedIds = new Set((this.custom3DBoards.byBrand[brand] || []).map((b) => b.id));
        this.custom3DBoards.byBrand[brand] = [];
        this.custom3DBoards.list = this.custom3DBoards.list.filter((b) => !removedIds.has(b.id));
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
    }
    /**
     * Opens the 3D boards gallery & custom loader modal.
     * @param {string} [brand=null]
     */
    static openBoard3DModal(brand = null) {
      if (typeof window !== "undefined") {
        const targetBrand = brand || "all";
        const opts = { brand: targetBrand, settings: window.settings };
        if (typeof window.showBoard3DModal === "function") {
          window.showBoard3DModal(opts);
        } else if (window.crazyCribbageApp && typeof window.crazyCribbageApp.showBoard3DModal === "function") {
          window.crazyCribbageApp.showBoard3DModal(opts);
        } else if (window.BoardSelectorModal && typeof window.BoardSelectorModal.show === "function") {
          window.BoardSelectorModal.show(opts);
        } else if (typeof BoardSelectorModal !== "undefined" && typeof BoardSelectorModal.show === "function") {
          BoardSelectorModal.show(opts);
        }
      }
    }
    /**
     * Retrieves user's Daily Puzzle streaks and statistics.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getDailyPuzzleStats(storage = null) {
      const s = getStorage2(storage);
      if (s) {
        try {
          const raw = s.getItem(STORAGE_KEY_DAILY_PUZZLE);
          if (raw) {
            const parsed = JSON.parse(raw);
            this.stats.dailyPuzzle = {
              ...this.stats.dailyPuzzle || {},
              ...parsed
            };
          }
        } catch (_) {
        }
      }
      const dp = this.stats.dailyPuzzle || {};
      return {
        currentStreak: Number(dp.currentStreak) || 0,
        bestStreak: Number(dp.bestStreak) || 0,
        lastPlayedDate: dp.lastPlayedDate || "",
        history: dp.history || {},
        totalPlayed: Number(dp.totalPlayed) || 0,
        perfectDiscards: Number(dp.perfectDiscards) || 0,
        peggingWins: Number(dp.peggingWins) || 0
      };
    }
    /**
     * Saves updated Daily Puzzle streaks and stats in the user profile.
     * @param {Object} dailyStats
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    setDailyPuzzleStats(dailyStats, storage = null) {
      if (!dailyStats || typeof dailyStats !== "object") return this.getDailyPuzzleStats(storage);
      this.stats.dailyPuzzle = {
        ...this.stats.dailyPuzzle || {},
        ...dailyStats
      };
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.stats.dailyPuzzle;
    }
    /**
     * Resets Daily Puzzle streak and stats.
     * @param {Object} [storage=null]
     */
    clearDailyPuzzleStats(storage = null) {
      this.stats.dailyPuzzle = {
        currentStreak: 0,
        bestStreak: 0,
        lastPlayedDate: "",
        history: {},
        totalPlayed: 0,
        perfectDiscards: 0,
        peggingWins: 0
      };
      const s = getStorage2(storage);
      if (s) {
        try {
          s.setItem(STORAGE_KEY_DAILY_PUZZLE, JSON.stringify(this.stats.dailyPuzzle));
        } catch (_) {
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
    }
    /**
     * Opens the Daily Puzzle modal.
     */
    static openDailyPuzzle() {
      if (typeof window !== "undefined") {
        if (typeof window.showDailyPuzzleModal === "function") {
          window.showDailyPuzzleModal();
        } else if (window.modalManager && typeof window.modalManager.showDailyPuzzleModal === "function") {
          window.modalManager.showDailyPuzzleModal();
        } else if (window.ModalManager && typeof window.ModalManager.showDailyPuzzleModal === "function") {
          window.ModalManager.showDailyPuzzleModal();
        }
      }
    }
    /**
     * Retrieves player's global Discard Trainer career statistics across all brands.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getDiscardTrainerStats(storage = null) {
      const s = getStorage2(storage);
      if (s) {
        try {
          const raw = s.getItem(STORAGE_KEY_DISCARD_TRAINER);
          if (raw) {
            const parsed = JSON.parse(raw);
            this.stats.discardTrainer = {
              ...this.stats.discardTrainer || {},
              ...parsed
            };
          }
        } catch (_) {
        }
      }
      const dt = this.stats.discardTrainer || {};
      const handsPlayed = Number(dt.handsPlayed) || 0;
      const optimalCount = Number(dt.optimalCount) || 0;
      const currentStreak = Number(dt.currentStreak) || 0;
      const bestStreak = Number(dt.bestStreak) || 0;
      const totalLossEV = Number(dt.totalLossEV) || 0;
      const accuracyPct = handsPlayed > 0 ? Math.round(optimalCount / handsPlayed * 100) : 0;
      const averageLossEV = handsPlayed > 0 ? Math.round(totalLossEV / handsPlayed * 100) / 100 : 0;
      return {
        handsPlayed,
        optimalCount,
        currentStreak,
        bestStreak,
        totalLossEV: Math.round(totalLossEV * 100) / 100,
        averageLossEV,
        accuracyPct,
        lastPlayedDate: dt.lastPlayedDate || ""
      };
    }
    /**
     * Records a Discard Trainer practice hand into global user profile.
     * Tracks career hands played, optimal discards, accuracy %, win/optimal streaks, and EV loss.
     * @param {Object} playData
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    recordDiscardTrainerPlay(playData = {}, storage = null) {
      if (!this.stats.discardTrainer) {
        this.stats.discardTrainer = {
          handsPlayed: 0,
          optimalCount: 0,
          currentStreak: 0,
          bestStreak: 0,
          totalLossEV: 0,
          averageLossEV: 0,
          accuracyPct: 0,
          lastPlayedDate: ""
        };
      }
      const dt = this.stats.discardTrainer;
      const isOptimal = Boolean(playData.isOptimal);
      const diff = Math.max(0, Number(playData.diff ?? playData.evDiff) || 0);
      const dateStr = playData.date || (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
      dt.handsPlayed = (Number(dt.handsPlayed) || 0) + 1;
      if (isOptimal) {
        dt.optimalCount = (Number(dt.optimalCount) || 0) + 1;
        dt.currentStreak = (Number(dt.currentStreak) || 0) + 1;
        dt.bestStreak = Math.max(Number(dt.bestStreak) || 0, dt.currentStreak);
      } else {
        dt.currentStreak = 0;
      }
      dt.totalLossEV = (Number(dt.totalLossEV) || 0) + diff;
      dt.accuracyPct = Math.round(dt.optimalCount / dt.handsPlayed * 100);
      dt.averageLossEV = Math.round(dt.totalLossEV / dt.handsPlayed * 100) / 100;
      dt.lastPlayedDate = dateStr;
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.getDiscardTrainerStats(storage);
    }
    /**
     * Sets or updates Discard Trainer stats directly in user profile.
     * @param {Object} stats
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    setDiscardTrainerStats(stats, storage = null) {
      if (!stats || typeof stats !== "object") return this.getDiscardTrainerStats(storage);
      this.stats.discardTrainer = {
        ...this.stats.discardTrainer || {},
        ...stats
      };
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.getDiscardTrainerStats(storage);
    }
    /**
     * Resets Discard Trainer statistics to zero across the profile.
     * @param {Object} [storage=null]
     */
    clearDiscardTrainerStats(storage = null) {
      this.stats.discardTrainer = {
        handsPlayed: 0,
        optimalCount: 0,
        currentStreak: 0,
        bestStreak: 0,
        totalLossEV: 0,
        averageLossEV: 0,
        accuracyPct: 0,
        lastPlayedDate: ""
      };
      const s = getStorage2(storage);
      if (s) {
        try {
          s.setItem(STORAGE_KEY_DISCARD_TRAINER, JSON.stringify(this.stats.discardTrainer));
        } catch (_) {
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
    }
    /**
     * Opens the Discard Trainer modal.
     * @param {Object} [context={}]
     */
    static openDiscardTrainer(context = {}) {
      if (typeof window !== "undefined") {
        if (typeof window.showDiscardTrainerModal === "function") {
          window.showDiscardTrainerModal(context);
        } else if (window.modalManager && typeof window.modalManager.showDiscardTrainerModal === "function") {
          window.modalManager.showDiscardTrainerModal(context);
        } else if (window.ModalManager && typeof window.ModalManager.showDiscardTrainerModal === "function") {
          window.ModalManager.showDiscardTrainerModal(context);
        }
      }
    }
    /**
     * Retrieves user Pegging Tactics Trainer career stats.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getPeggingTrainerStats(storage = null) {
      const s = getStorage2(storage);
      if (s && (!this.stats.peggingTrainer || !this.stats.peggingTrainer.scenariosPlayed)) {
        try {
          const raw = s.getItem(STORAGE_KEY_PEGGING_TRAINER);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === "object") {
              this.stats.peggingTrainer = { ...this.stats.peggingTrainer || {}, ...parsed };
            }
          }
        } catch (_) {
        }
      }
      const pt = this.stats.peggingTrainer || {};
      const scenariosPlayed = Number(pt.scenariosPlayed) || 0;
      const optimalCount = Number(pt.optimalCount) || 0;
      const currentStreak = Number(pt.currentStreak) || 0;
      const bestStreak = Number(pt.bestStreak) || 0;
      const totalLossEV = Number(pt.totalLossEV) || 0;
      const accuracyPct = scenariosPlayed > 0 ? Math.round(optimalCount / scenariosPlayed * 100) : 0;
      const averageLossEV = scenariosPlayed > 0 ? Math.round(totalLossEV / scenariosPlayed * 100) / 100 : 0;
      return {
        scenariosPlayed,
        optimalCount,
        currentStreak,
        bestStreak,
        totalLossEV: Math.round(totalLossEV * 100) / 100,
        averageLossEV,
        accuracyPct,
        lastPlayedDate: pt.lastPlayedDate || ""
      };
    }
    /**
     * Records a Pegging Trainer scenario play into global user profile.
     * @param {Object} playData
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    recordPeggingTrainerPlay(playData = {}, storage = null) {
      if (!this.stats.peggingTrainer) {
        this.stats.peggingTrainer = {
          scenariosPlayed: 0,
          optimalCount: 0,
          currentStreak: 0,
          bestStreak: 0,
          totalLossEV: 0,
          averageLossEV: 0,
          accuracyPct: 0,
          lastPlayedDate: ""
        };
      }
      const pt = this.stats.peggingTrainer;
      const isOptimal = Boolean(playData.isOptimal);
      const diff = Math.max(0, Number(playData.diff ?? playData.evDiff) || 0);
      const dateStr = playData.date || (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
      pt.scenariosPlayed = (Number(pt.scenariosPlayed) || 0) + 1;
      if (isOptimal) {
        pt.optimalCount = (Number(pt.optimalCount) || 0) + 1;
        pt.currentStreak = (Number(pt.currentStreak) || 0) + 1;
        pt.bestStreak = Math.max(Number(pt.bestStreak) || 0, pt.currentStreak);
      } else {
        pt.currentStreak = 0;
      }
      pt.totalLossEV = (Number(pt.totalLossEV) || 0) + diff;
      pt.accuracyPct = Math.round(pt.optimalCount / pt.scenariosPlayed * 100);
      pt.averageLossEV = Math.round(pt.totalLossEV / pt.scenariosPlayed * 100) / 100;
      pt.lastPlayedDate = dateStr;
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.getPeggingTrainerStats(storage);
    }
    /**
     * Sets or updates Pegging Trainer stats directly in user profile.
     * @param {Object} stats
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    setPeggingTrainerStats(stats, storage = null) {
      if (!stats || typeof stats !== "object") return this.getPeggingTrainerStats(storage);
      this.stats.peggingTrainer = {
        ...this.stats.peggingTrainer || {},
        ...stats
      };
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.getPeggingTrainerStats(storage);
    }
    /**
     * Resets Pegging Trainer statistics to zero across the profile.
     * @param {Object} [storage=null]
     */
    clearPeggingTrainerStats(storage = null) {
      this.stats.peggingTrainer = {
        scenariosPlayed: 0,
        optimalCount: 0,
        currentStreak: 0,
        bestStreak: 0,
        totalLossEV: 0,
        averageLossEV: 0,
        accuracyPct: 0,
        lastPlayedDate: ""
      };
      const s = getStorage2(storage);
      if (s) {
        try {
          s.setItem(STORAGE_KEY_PEGGING_TRAINER, JSON.stringify(this.stats.peggingTrainer));
        } catch (_) {
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
    }
    /**
     * Retrieves player's Counting Trainer statistics.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    getCountingTrainerStats(storage = null) {
      const s = getStorage2(storage);
      if (s) {
        try {
          const raw = s.getItem(STORAGE_KEY_COUNTING_TRAINER);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === "object") {
              this.stats.countingTrainer = { ...this.stats.countingTrainer || {}, ...parsed };
            }
          }
        } catch (_) {
        }
      }
      const ct = this.stats.countingTrainer || {};
      const handsPlayed = Number(ct.handsPlayed) || 0;
      const handsCorrect = Number(ct.handsCorrect) || 0;
      const handsWrong = Number(ct.handsWrong) || 0;
      const currentStreak = Number(ct.currentStreak) || 0;
      const bestStreak = Number(ct.bestStreak) || 0;
      const accuracyPct = handsPlayed > 0 ? Math.round(handsCorrect / handsPlayed * 100) : 0;
      return {
        handsPlayed,
        handsCorrect,
        handsWrong,
        currentStreak,
        bestStreak,
        accuracyPct,
        lastPlayedDate: ct.lastPlayedDate || ""
      };
    }
    /**
     * Records a Counting Trainer play into global user profile.
     * @param {Object} playData
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    recordCountingTrainerPlay(playData = {}, storage = null) {
      if (!this.stats.countingTrainer) {
        this.stats.countingTrainer = {
          handsPlayed: 0,
          handsCorrect: 0,
          handsWrong: 0,
          currentStreak: 0,
          bestStreak: 0,
          accuracyPct: 0,
          lastPlayedDate: ""
        };
      }
      const ct = this.stats.countingTrainer;
      const isCorrect = Boolean(playData.isCorrect);
      const dateStr = playData.date || (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
      ct.handsPlayed = (Number(ct.handsPlayed) || 0) + 1;
      if (isCorrect) {
        ct.handsCorrect = (Number(ct.handsCorrect) || 0) + 1;
        ct.currentStreak = (Number(ct.currentStreak) || 0) + 1;
        ct.bestStreak = Math.max(Number(ct.bestStreak) || 0, ct.currentStreak);
      } else {
        ct.handsWrong = (Number(ct.handsWrong) || 0) + 1;
        ct.currentStreak = 0;
      }
      ct.accuracyPct = Math.round(ct.handsCorrect / ct.handsPlayed * 100);
      ct.lastPlayedDate = dateStr;
      const s = getStorage2(storage);
      if (s) {
        try {
          s.setItem(STORAGE_KEY_COUNTING_TRAINER, JSON.stringify(ct));
        } catch (_) {
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.getCountingTrainerStats(storage);
    }
    /**
     * Resets Counting Trainer statistics.
     * @param {Object} [storage=null]
     */
    clearCountingTrainerStats(storage = null) {
      this.stats.countingTrainer = {
        handsPlayed: 0,
        handsCorrect: 0,
        handsWrong: 0,
        currentStreak: 0,
        bestStreak: 0,
        accuracyPct: 0,
        lastPlayedDate: ""
      };
      const s = getStorage2(storage);
      if (s) {
        try {
          s.removeItem(STORAGE_KEY_COUNTING_TRAINER);
        } catch (_) {
        }
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
    }
    /**
     * Opens the Counting Trainer modal.
     * @param {Object} [context={}]
     */
    static openCountingTrainer(context = {}) {
      if (typeof window !== "undefined") {
        if (typeof window.showCountingTrainerModal === "function") {
          window.showCountingTrainerModal(context);
        } else if (window.modalManager && typeof window.modalManager.showCountingTrainerModal === "function") {
          window.modalManager.showCountingTrainerModal(context);
        }
      }
    }
    /**
     * Opens the Pegging Tactics Trainer modal.
     * @param {Object} [context={}]
     */
    static openPeggingTrainer(context = {}) {
      if (typeof window !== "undefined") {
        if (typeof window.showPeggingTrainerModal === "function") {
          window.showPeggingTrainerModal(context);
        } else if (window.modalManager && typeof window.modalManager.showPeggingTrainerModal === "function") {
          window.modalManager.showPeggingTrainerModal(context);
        } else if (window.ModalManager && typeof window.ModalManager.showPeggingTrainerModal === "function") {
          window.ModalManager.showPeggingTrainerModal(context);
        }
      }
    }
    /**
     * Returns match history list, optionally filtered by brand.
     * @param {number} [limit=50]
     * @param {string} [brand=null]
     * @returns {Array<Object>}
     */
    getHistory(limit = 50, brand = null) {
      let list = this.history || [];
      if (brand && brand !== "all") {
        list = list.filter((m) => (m.brand || "crazy") === brand);
      }
      return list.slice(0, limit);
    }
    /**
     * Records a completed match into player records.
     * @param {Object} gameData
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    recordGame(gameData = {}, storage = null) {
      const winner = gameData.winner;
      const userScore = Number(gameData.userScore) || 0;
      const oppScore = Number(gameData.oppScore) || 0;
      const userWon = Boolean(
        winner === "you" || winner === "p1" || winner === "user" || winner === "team1" || winner === true || (gameData.userWon !== void 0 ? gameData.userWon : userScore > oppScore && oppScore > 0)
      );
      const skunk = Boolean(gameData.skunk || gameData.isSkunk);
      const brand = gameData.brand || (typeof window !== "undefined" && window.getAppBrand ? window.getAppBrand() : "crazy");
      this.stats.totalGamesPlayed = (this.stats.totalGamesPlayed || 0) + 1;
      if (userWon) {
        this.stats.wins = (this.stats.wins || 0) + 1;
        const curStreak = this.stats.currentStreak || 0;
        this.stats.currentStreak = curStreak > 0 ? curStreak + 1 : 1;
        this.stats.bestStreak = Math.max(this.stats.bestStreak || 0, this.stats.currentStreak);
        if (skunk) {
          this.stats.skunkWins = (this.stats.skunkWins || 0) + 1;
        }
      } else {
        this.stats.losses = (this.stats.losses || 0) + 1;
        const curStreak = this.stats.currentStreak || 0;
        this.stats.currentStreak = curStreak < 0 ? curStreak - 1 : -1;
        if (skunk) {
          this.stats.skunkLosses = (this.stats.skunkLosses || 0) + 1;
        }
      }
      if (userScore > 0) {
        this.stats.highestScore = Math.max(this.stats.highestScore || 0, userScore);
        this.stats.totalPoints = (this.stats.totalPoints || 0) + userScore;
      }
      this.stats.lastPlayed = Date.now();
      if (!this.stats.byBrand) {
        this.stats.byBrand = {};
      }
      if (!this.stats.byBrand[brand]) {
        this.stats.byBrand[brand] = { totalGamesPlayed: 0, wins: 0, losses: 0, highestScore: 0, skunkWins: 0, skunkLosses: 0 };
      }
      const bStats = this.stats.byBrand[brand];
      bStats.totalGamesPlayed = (bStats.totalGamesPlayed || 0) + 1;
      if (userWon) {
        bStats.wins = (bStats.wins || 0) + 1;
        if (skunk) bStats.skunkWins = (bStats.skunkWins || 0) + 1;
      } else {
        bStats.losses = (bStats.losses || 0) + 1;
        if (skunk) bStats.skunkLosses = (bStats.skunkLosses || 0) + 1;
      }
      if (userScore > 0) {
        bStats.highestScore = Math.max(bStats.highestScore || 0, userScore);
      }
      const matchEntry = {
        id: "match_" + Date.now() + "_" + Math.random().toString(36).slice(2, 6),
        timestamp: Date.now(),
        date: (/* @__PURE__ */ new Date()).toLocaleDateString(void 0, { month: "short", day: "numeric", year: "numeric" }),
        time: (/* @__PURE__ */ new Date()).toLocaleTimeString(void 0, { hour: "2-digit", minute: "2-digit" }),
        winner: userWon ? "you" : "opp",
        userWon,
        userScore,
        oppScore,
        opponentName: gameData.opponentName || "Opponent",
        variantKey: gameData.variantKey || "standard",
        variantLabel: gameData.variantLabel || "Standard Match",
        brand,
        skunk
      };
      this.history.unshift(matchEntry);
      if (this.history.length > 100) {
        this.history = this.history.slice(0, 100);
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
      return this.getStats();
    }
    /**
     * Resets game match records and statistics.
     * Can reset all 4 games or a specific game brand.
     * @param {Object} [storage=null]
     * @param {string} [brand=null]
     */
    clearRecords(storage = null, brand = null) {
      const s = getStorage2(storage);
      const settingsMgr = typeof window !== "undefined" && window.CrazyCribbage?.SettingsManager || null;
      if (brand === "daily" || brand === "dailyPuzzle") {
        this.clearDailyPuzzleStats(storage);
        return;
      }
      if (brand === "trainer" || brand === "discardTrainer") {
        this.clearDiscardTrainerStats(storage);
        return;
      }
      if (brand === "pegging" || brand === "peggingTrainer") {
        this.clearPeggingTrainerStats(storage);
        return;
      }
      if (brand === "boards" || brand === "custom3DBoards" || brand === "customBoards") {
        this.clearCustom3DBoards("all", storage);
        return;
      }
      if (brand && brand !== "all") {
        if (settingsMgr && typeof settingsMgr.saveRecords === "function") {
          settingsMgr.saveRecords({}, s, brand);
        }
        this.history = (this.history || []).filter((m) => (m.brand || "crazy") !== brand);
        if (this.stats?.byBrand?.[brand]) {
          delete this.stats.byBrand[brand];
        }
        const overall = this.getOverallStats(storage);
        this.stats.wins = overall.wins;
        this.stats.losses = overall.losses;
        this.stats.totalGamesPlayed = overall.totalGamesPlayed;
      } else {
        if (settingsMgr && typeof settingsMgr.saveRecords === "function") {
          for (const b of GAME_BRANDS) {
            settingsMgr.saveRecords({}, s, b.id);
          }
        }
        const preservedDaily = this.stats.dailyPuzzle || {
          currentStreak: 0,
          bestStreak: 0,
          lastPlayedDate: "",
          history: {},
          totalPlayed: 0,
          perfectDiscards: 0,
          peggingWins: 0
        };
        const preservedTrainer = this.stats.discardTrainer || {
          handsPlayed: 0,
          optimalCount: 0,
          currentStreak: 0,
          bestStreak: 0,
          totalLossEV: 0,
          averageLossEV: 0,
          accuracyPct: 0,
          lastPlayedDate: ""
        };
        const preservedPeggingTrainer = this.stats.peggingTrainer || {
          scenariosPlayed: 0,
          optimalCount: 0,
          currentStreak: 0,
          bestStreak: 0,
          totalLossEV: 0,
          averageLossEV: 0,
          accuracyPct: 0,
          lastPlayedDate: ""
        };
        this.stats = {
          totalGamesPlayed: 0,
          wins: 0,
          losses: 0,
          currentStreak: 0,
          bestStreak: 0,
          skunkWins: 0,
          skunkLosses: 0,
          highestScore: 0,
          totalPoints: 0,
          lastPlayed: null,
          byBrand: {},
          dailyPuzzle: preservedDaily,
          discardTrainer: preservedTrainer,
          peggingTrainer: preservedPeggingTrainer
        };
        this.history = [];
      }
      this.save(storage);
      _Profile.notifyProfileUpdate();
    }
    /**
     * Dispatches 'profile-updated' event to keep UI and menu dropdowns in sync.
     */
    static notifyProfileUpdate() {
      if (typeof window !== "undefined") {
        if (typeof window.dispatchEvent === "function" && typeof CustomEvent !== "undefined") {
          try {
            window.dispatchEvent(new CustomEvent("profile-updated"));
          } catch (_) {
          }
        }
        if (typeof window.updateProfileDropdownUI === "function") {
          window.updateProfileDropdownUI();
        }
      }
    }
    /**
     * Switches active filter tab in records modal.
     * @param {string} tabId
     */
    static switchRecordsTab(tabId) {
      _Profile._selectedRecordsTab = tabId;
      _Profile.showRecordsModal(_Profile._lastContext || {});
    }
    /**
     * Displays the enhanced Game Records Modal featuring Player Profile & 4 games win records.
     * @param {Object} [context={}]
     */
    static showRecordsModal(context = {}) {
      _Profile._lastContext = context;
      const profile = _Profile.getInstance(context.storage);
      const playerName = profile.getName(context.storage);
      const avId = profile.getAvatar(context.storage);
      const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
      const avBadgeHtml = avMgr && typeof avMgr.renderAvatarBadge === "function" ? avMgr.renderAvatarBadge(avId, { size: 52, showRing: true }) : '<span style="font-size:2rem;">\u{1F464}</span>';
      const avObj = avMgr ? avMgr.getAvatarById(avId, getStorage2(context.storage)) : null;
      const gameRecs = profile.getGameRecords(context.storage);
      const overallStats = profile.getOverallStats(context.storage);
      const activeTab = _Profile._selectedRecordsTab || "all";
      let streakText = "None";
      if (overallStats.currentStreak > 0) {
        streakText = `\u{1F525} ${overallStats.currentStreak} Win Streak`;
      } else if (overallStats.currentStreak < 0) {
        streakText = `\u2744\uFE0F ${Math.abs(overallStats.currentStreak)} Loss Streak`;
      }
      const history = profile.getHistory(25, activeTab);
      const historyRowsHtml = history.length ? history.map((m) => {
        const resultLabel = m.userWon ? "WIN" : "LOSS";
        const badgeColor = m.userWon ? "#10b981" : "#ef4444";
        const skunkBadge = m.skunk ? `<span style="background:#f43f5e;color:#fff;font-size:0.68rem;padding:2px 6px;border-radius:6px;font-weight:700;margin-left:6px;">SKUNK</span>` : "";
        const brandObj = GAME_BRANDS.find((b) => b.id === (m.brand || "crazy")) || GAME_BRANDS[0];
        return `
          <div style="display:flex;align-items:center;justify-content:space-between;padding:8px 10px;border-bottom:1px solid rgba(244,234,212,0.1);gap:10px;">
            <div style="flex:1;min-width:0;">
              <div style="font-weight:600;color:#f3f4f6;font-size:0.9rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                vs. ${m.opponentName} ${skunkBadge}
              </div>
              <div style="font-size:0.75rem;color:#9ca3af;display:flex;align-items:center;gap:6px;margin-top:2px;">
                <span>${m.date}</span> \xB7 
                <span style="color:${brandObj.color};font-weight:700;">${brandObj.icon} ${brandObj.shortName}</span> \xB7 
                <span>${m.variantLabel}</span>
              </div>
            </div>
            <div style="text-align:right;white-space:nowrap;">
              <div style="font-weight:700;color:#facc15;font-size:0.92rem;">
                ${m.userScore} \u2013 ${m.oppScore}
              </div>
              <span style="display:inline-block;padding:2px 6px;border-radius:4px;font-size:0.7rem;font-weight:800;background:${badgeColor};color:#fff;">
                ${resultLabel}
              </span>
            </div>
          </div>
        `;
      }).join("") : '<div style="color:#d7e8dc;font-style:italic;padding:12px 0;text-align:center;">No match history recorded yet.</div>';
      const displayBrands = activeTab === "all" ? GAME_BRANDS : GAME_BRANDS.filter((b) => b.id === activeTab);
      const gamesBreakdownHtml = displayBrands.map((b) => {
        const rec = gameRecs[b.id];
        return `
        <div class="game-brand-records-card" style="background:rgba(0,0,0,0.3);border:1.5px solid ${b.border};border-radius:10px;padding:10px 14px;margin-bottom:10px;text-align:left;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;border-bottom:1px solid rgba(244,234,212,0.1);padding-bottom:6px;flex-wrap:wrap;gap:8px;">
            <div style="display:flex;align-items:center;gap:8px;">
              <span style="font-size:1.3rem;">${b.icon}</span>
              <div>
                <div style="color:${b.color};font-size:0.98rem;font-weight:800;">${b.name}</div>
                <div style="font-size:0.72rem;color:#9ca3af;">Win Records &amp; Setups</div>
              </div>
            </div>
            <div style="text-align:right;white-space:nowrap;">
              <div style="font-size:1.05rem;font-weight:800;color:#facc15;">${rec.wins} Wins \u2013 ${rec.losses} Losses</div>
              <span style="display:inline-block;padding:2px 8px;border-radius:4px;font-size:0.72rem;font-weight:800;background:${rec.wins > 0 ? "#10b981" : "#4b5563"};color:#fff;">${rec.winRate} Win Rate</span>
            </div>
          </div>
          ${rec.variants.length ? `
            <div style="display:grid;grid-template-columns:repeat(auto-fit, minmax(200px, 1fr));gap:6px;margin-top:6px;">
              ${rec.variants.map((v) => `
                <div style="display:flex;justify-content:space-between;padding:4px 8px;background:rgba(255,255,255,0.03);border-radius:6px;font-size:0.83rem;border:1px solid rgba(244,234,212,0.06);">
                  <span style="color:#e5e7eb;">${v.label}</span>
                  <strong style="color:#facc15;">${v.wins}\u2013${v.losses}</strong>
                </div>
              `).join("")}
            </div>
          ` : `<div style="font-size:0.8rem;color:#9ca3af;font-style:italic;padding:4px 0;">No match setups recorded yet in ${b.name}.</div>`}
          <div style="display:flex;align-items:center;justify-content:space-between;margin-top:8px;padding-top:6px;border-top:1px solid rgba(244,234,212,0.08);flex-wrap:wrap;gap:6px;">
            <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
              <span style="font-size:0.76rem;color:#facc15;font-weight:700;">
                \u{1F3C6} ${rec.trophiesUnlocked} of ${rec.trophiesTotal} Trophies (${rec.trophiesPct}%)
              </span>
              <span style="font-size:0.76rem;color:${b.color};font-weight:700;">
                \u{1F3AC} ${rec.replaysCount} Saved Replays
              </span>
              <span style="font-size:0.76rem;color:#38bdf8;font-weight:700;">
                \u{1F3B2} ${rec.customBoardsCount} Custom 3D Boards
              </span>
            </div>
            <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;">
              <button type="button" data-action="view-trophies" data-brand="${b.id}" style="font-size:0.72rem;padding:3px 9px;border-radius:6px;border:1px solid ${b.color};background:${b.badgeBg};color:${b.color};cursor:pointer;font-weight:700;">
                \u{1F3C6} View ${b.shortName} Trophies
              </button>
              <button type="button" data-action="view-replays" data-brand="${b.id}" style="font-size:0.72rem;padding:3px 9px;border-radius:6px;border:1px solid ${b.color};background:${b.badgeBg};color:${b.color};cursor:pointer;font-weight:700;">
                \u{1F3AC} View ${b.shortName} Replays
              </button>
              <button type="button" data-action="open-3d-boards" data-brand="${b.id}" style="font-size:0.72rem;padding:3px 9px;border-radius:6px;border:1px solid #38bdf8;background:rgba(56, 189, 248, 0.2);color:#38bdf8;cursor:pointer;font-weight:700;">
                \u{1F3B2} ${b.shortName} 3D Boards
              </button>
            </div>
          </div>
        </div>
      `;
      }).join("");
      const modalHtml = `
      <div class="profile-records-modal-content">
        <!-- Player Header Banner -->
        <div style="background:linear-gradient(135deg, rgba(30, 27, 75, 0.9), rgba(15, 23, 42, 0.95));border:1.5px solid rgba(245,158,11,0.5);border-radius:12px;padding:14px;margin-bottom:14px;display:flex;align-items:center;gap:14px;">
          <div class="profile-header-avatar-wrap" style="position:relative;flex-shrink:0;">
            <button type="button" class="profile-avatar-trigger" id="btnProfileModalAvatar" data-action="open-avatar" title="Click to choose a different avatar persona" aria-label="Change Avatar">
              ${avBadgeHtml}
              <span class="profile-avatar-edit-chip" title="Change Avatar">\u{1F3AD}</span>
            </button>
          </div>
          <div style="flex:1;min-width:0;text-align:left;">
            <!-- Username row (view mode) -->
            <div id="profileHeaderNameRow" style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">
              <span id="profileHeaderNameDisplay" style="font-size:1.25rem;font-weight:800;color:#fff;">${playerName}</span>
              <button type="button" class="btn-profile-edit-name" id="btnEditProfileName" data-action="edit-name" title="Edit Username" aria-label="Edit Username">
                \u270F\uFE0F Edit
              </button>
              <span id="profilePersonaTag" style="font-size:0.75rem;padding:2px 8px;border-radius:10px;background:rgba(245,158,11,0.2);color:#f59e0b;border:1px solid rgba(245,158,11,0.4);font-weight:700;">
                ${avObj?.name || "Persona"}
              </span>
            </div>

            <!-- Username row (edit mode) -->
            <div id="profileHeaderNameEditRow" style="display:none;align-items:center;gap:6px;flex-wrap:wrap;margin:4px 0;">
              <input type="text" id="inputProfileInlineName" value="${playerName.replace(/"/g, "&quot;")}" maxlength="24" placeholder="Enter username" pattern="[a-zA-Z0-9]+" style="padding:4px 8px;border-radius:6px;border:1.5px solid #f59e0b;background:#0f172a;color:#fff;font-weight:700;font-size:0.95rem;outline:none;width:150px;max-width:100%;" />
              <button type="button" class="btn-gold" id="btnSaveInlineName" data-action="save-inline-name" style="padding:4px 10px;font-size:0.8rem;border-radius:6px;cursor:pointer;font-weight:700;">Save</button>
              <button type="button" class="btn-ghost" id="btnCancelInlineName" data-action="cancel-inline-name" style="padding:4px 8px;font-size:0.8rem;border-radius:6px;cursor:pointer;color:#9ca3af;">Cancel</button>
            </div>

            <div style="font-size:0.88rem;color:#facc15;font-weight:700;margin-top:4px;">
              ${overallStats.wins} Wins \xB7 ${overallStats.losses} Losses <span style="opacity:0.75;color:#e5e7eb;">(${overallStats.winRate} Win Rate)</span>
            </div>
            <div style="font-size:0.78rem;color:#9ca3af;margin-top:2px;">
              ${streakText} \xB7 Best Win Streak: ${overallStats.bestStreak}
            </div>
            <div style="font-size:0.76rem;color:#facc15;margin-top:3px;font-weight:700;display:flex;align-items:center;gap:8px;flex-wrap:wrap;">
              <span>\u{1F3C6} ${overallStats.trophiesUnlocked} of ${overallStats.trophiesTotal} Badges Unlocked (${overallStats.trophiesPct}%)</span>
              <button type="button" data-action="view-trophies" data-brand="all" style="font-size:0.7rem;padding:2px 8px;border-radius:5px;border:1px solid #facc15;background:rgba(250,204,21,0.2);color:#facc15;cursor:pointer;font-weight:700;">
                Trophy Room
              </button>
              <span>\xB7</span>
              <span style="color:#cbd5e1;">\u{1F3AC} ${overallStats.replaysTotal} Replays</span>
              <button type="button" data-action="view-replays" data-brand="all" style="font-size:0.7rem;padding:2px 8px;border-radius:5px;border:1px solid #38bdf8;background:rgba(56,189,248,0.2);color:#38bdf8;cursor:pointer;font-weight:700;">
                Replay Library
              </button>
              <span>\xB7</span>
              <span style="color:#38bdf8;">\u{1F3B2} ${overallStats.customBoardsTotal} Custom 3D Boards</span>
              <button type="button" data-action="open-3d-boards" data-brand="all" style="font-size:0.7rem;padding:2px 8px;border-radius:5px;border:1px solid #38bdf8;background:rgba(56,189,248,0.2);color:#38bdf8;cursor:pointer;font-weight:700;">
                3D Boards
              </button>
              <span>\xB7</span>
              <span style="color:#34d399;">\u{1F3AF} ${overallStats.discardTrainer.optimalCount}/${overallStats.discardTrainer.handsPlayed} Optimal (${overallStats.discardTrainer.accuracyPct}%)</span>
              <button type="button" data-action="open-trainer" style="font-size:0.7rem;padding:2px 8px;border-radius:5px;border:1px solid #10b981;background:rgba(16,185,129,0.2);color:#34d399;cursor:pointer;font-weight:700;">
                Discard Trainer
              </button>
            </div>
            <div style="margin-top:4px; display: none;">
              <span style="font-size:0.7rem;padding:2px 8px;border-radius:10px;background:rgba(56,189,248,0.15);color:#38bdf8;border:1px solid rgba(56,189,248,0.35);font-weight:600;">
                \u{1F310} Global Profile across all 4 games
              </span>
            </div>
          </div>
        </div>

        <!-- 4 Games Win Records Hub Cards (Separated by Game) -->
        <div class="games-record-grid" style="display:grid;grid-template-columns:repeat(4, 1fr);gap:8px;margin-bottom:12px;text-align:center;">
          ${GAME_BRANDS.map((b) => {
        const rec = gameRecs[b.id];
        const isSelected = activeTab === b.id;
        return `
              <div class="game-record-summary-card ${isSelected ? "active" : ""}" data-action="switch-tab" data-tab="${b.id}" title="Click to filter ${b.name}" style="background:${isSelected ? b.badgeBg : "rgba(0,0,0,0.3)"};border:1.5px solid ${isSelected ? b.color : "rgba(244,234,212,0.15)"};border-radius:10px;padding:8px 4px;cursor:pointer;transition:transform 0.15s ease, border-color 0.15s ease;">
                <div style="font-size:1.15rem;margin-bottom:2px;">${b.icon}</div>
                <div style="font-size:0.75rem;font-weight:700;color:${b.color};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${b.shortName}</div>
                <div style="font-size:1.1rem;font-weight:800;color:#fff;margin:2px 0;">${rec.wins}\u2013${rec.losses}</div>
                <div style="font-size:0.68rem;font-weight:700;color:${rec.wins > 0 ? "#10b981" : "#9ca3af"};">${rec.winRate}</div>
                <div style="font-size:0.67rem;font-weight:700;color:#facc15;margin-top:3px;background:rgba(250,204,21,0.12);padding:2px 4px;border-radius:4px;border:1px solid rgba(250,204,21,0.25);display:flex;justify-content:center;gap:6px;flex-wrap:wrap;">
                  <span>\u{1F3C6} ${rec.trophiesUnlocked}/${rec.trophiesTotal}</span>
                  <span style="color:${b.color};">\u{1F3AC} ${rec.replaysCount}</span>
                  <span style="color:#38bdf8;">\u{1F3B2} ${rec.customBoardsCount}</span>
                </div>
              </div>
            `;
      }).join("")}
        </div>

        <!-- Game & Mode Filter Dropdown (replaces overflowing horizontal scrollbar) -->
        <div class="profile-tabs-bar" id="profileFilterDropdownRow" style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:12px;background:rgba(0,0,0,0.28);border:1.5px solid rgba(245,158,11,0.35);border-radius:10px;padding:8px 12px;flex-wrap:wrap;">
          <div style="display:flex;align-items:center;gap:8px;">
            <span style="font-size:1.15rem;">\u{1F3AF}</span>
            <label for="selectProfileRecordsTab" style="font-size:0.84rem;font-weight:800;color:#facc15;text-transform:uppercase;letter-spacing:0.04em;">
              Filter Records &amp; Mode:
            </label>
          </div>
          <div style="flex:1;min-width:240px;position:relative;">
            <select id="selectProfileRecordsTab" class="profile-records-tab-select" aria-label="Filter profile records and stats by game or mode" style="width:100%;padding:8px 32px 8px 12px;border-radius:8px;border:1.5px solid #f59e0b;background:#0f172a;color:#facc15;font-weight:700;font-size:0.9rem;cursor:pointer;outline:none;appearance:none;-webkit-appearance:none;box-shadow:0 2px 8px rgba(0,0,0,0.4);">
              <option value="all" ${activeTab === "all" ? "selected" : ""}>\u{1F310} All 4 Games (${overallStats.wins} Wins \u2013 ${overallStats.losses} Losses)</option>
              ${GAME_BRANDS.map((b) => {
        const rec = gameRecs[b.id];
        return `<option value="${b.id}" ${activeTab === b.id ? "selected" : ""}>${b.icon} ${b.name} (${rec.wins}W \u2013 ${rec.losses}L)</option>`;
      }).join("")}
              <option value="boards" ${activeTab === "boards" ? "selected" : ""}>\u{1F3B2} 3D Boards (${overallStats.customBoardsTotal})</option>
              <option value="daily" ${activeTab === "daily" ? "selected" : ""}>\u{1F9E9} Daily Puzzle (${profile.getDailyPuzzleStats(context.storage).currentStreak > 0 ? `${profile.getDailyPuzzleStats(context.storage).currentStreak}\u{1F525} Day Streak` : `${profile.getDailyPuzzleStats(context.storage).totalPlayed} Played`})</option>
              <option value="trainer" ${activeTab === "trainer" ? "selected" : ""}>\u{1F3AF} Discard Trainer (${overallStats.discardTrainer.handsPlayed > 0 ? `${overallStats.discardTrainer.accuracyPct}% Optimal` : "0 Practiced"})</option>
            </select>
            <span style="position:absolute;right:12px;top:50%;transform:translateY(-50%);pointer-events:none;color:#f59e0b;font-size:0.75rem;">\u25BC</span>
          </div>
        </div>

        ${activeTab !== "daily" && activeTab !== "trainer" && activeTab !== "boards" ? `
          <!-- Game Records Breakdown Separated by 4 Games -->
          <div style="text-align:left;margin-bottom:12px;">
            <div style="font-size:0.8rem;text-transform:uppercase;letter-spacing:0.06em;color:#f59e0b;font-weight:700;margin-bottom:8px;">
              ${activeTab === "all" ? "Records Separated by Game" : `${GAME_BRANDS.find((b) => b.id === activeTab)?.name || "Game"} Setups`}
            </div>
            <div style="max-height:36vh;overflow-y:auto;padding-right:2px;">
              ${gamesBreakdownHtml}
            </div>
          </div>
        ` : ""}

        ${activeTab === "all" || activeTab === "daily" ? (() => {
        const dp = profile.getDailyPuzzleStats(context.storage);
        const todayKey = typeof window !== "undefined" && window.DailyPuzzleManager && typeof window.DailyPuzzleManager.getDailyDateKey === "function" ? window.DailyPuzzleManager.getDailyDateKey() : (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
        const isTodayDone = Boolean(dp.lastPlayedDate === todayKey && dp.history?.[todayKey]?.completed);
        return `
            <!-- Daily Puzzle Streaks & Statistics -->
            <div class="profile-daily-puzzle-card" style="background:rgba(0,0,0,0.3);border:1.5px solid rgba(245,158,11,0.45);border-radius:10px;padding:12px 14px;margin-bottom:12px;text-align:left;">
              <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;border-bottom:1px solid rgba(244,234,212,0.1);padding-bottom:6px;flex-wrap:wrap;gap:8px;">
                <div style="display:flex;align-items:center;gap:8px;">
                  <span style="font-size:1.35rem;">\u{1F9E9}</span>
                  <div>
                    <div style="color:#facc15;font-size:0.96rem;font-weight:800;">Daily Puzzle Streaks &amp; Stats</div>
                    <div style="font-size:0.72rem;color:#9ca3af;">Hand of the Day \xB7 Discard &amp; Pegging Challenges</div>
                  </div>
                </div>
                <button type="button" class="btn-daily-puzzle-link" id="btnProfileModalPlayDaily" data-action="open-daily" style="display:inline-flex;align-items:center;gap:6px;padding:5px 12px;border-radius:6px;font-size:0.78rem;font-weight:700;border:1px solid #f59e0b;background:rgba(245,158,11,0.22);color:#facc15;cursor:pointer;transition:transform 0.15s ease;">
                  ${isTodayDone ? "\u2705 Completed Today" : "\u25B6\uFE0F Play Today\u2019s Puzzle"}
                </button>
              </div>
              <div class="daily-puzzle-stats-grid" style="display:grid;grid-template-columns:repeat(4, 1fr);gap:6px;text-align:center;">
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;">
                  <div style="font-size:0.68rem;color:#9ca3af;font-weight:700;text-transform:uppercase;">Current Streak</div>
                  <div style="font-size:1.1rem;font-weight:800;color:#f59e0b;margin-top:2px;">
                    ${dp.currentStreak > 0 ? `\u{1F525} ${dp.currentStreak} Day${dp.currentStreak === 1 ? "" : "s"}` : "0 Days"}
                  </div>
                </div>
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;">
                  <div style="font-size:0.68rem;color:#9ca3af;font-weight:700;text-transform:uppercase;">Best Streak</div>
                  <div style="font-size:1.1rem;font-weight:800;color:#facc15;margin-top:2px;">
                    \u2B50 ${dp.bestStreak || 0} Day${dp.bestStreak === 1 ? "" : "s"}
                  </div>
                </div>
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;">
                  <div style="font-size:0.68rem;color:#9ca3af;font-weight:700;text-transform:uppercase;">Optimal Discards</div>
                  <div style="font-size:1.1rem;font-weight:800;color:#10b981;margin-top:2px;">
                    \u{1F3AF} ${dp.perfectDiscards || 0}
                  </div>
                </div>
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;">
                  <div style="font-size:0.68rem;color:#9ca3af;font-weight:700;text-transform:uppercase;">Pegging Won</div>
                  <div style="font-size:1.1rem;font-weight:800;color:#38bdf8;margin-top:2px;">
                    \u26A1 ${dp.peggingWins || 0}
                  </div>
                </div>
              </div>
              <div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px;font-size:0.75rem;color:#9ca3af;padding-top:4px;border-top:1px solid rgba(244,234,212,0.06);">
                <span>Total Puzzles Played: <strong style="color:#fff;">${dp.totalPlayed || 0}</strong></span>
                <span>Last Played: <strong style="color:#e5e7eb;">${dp.lastPlayedDate || "Never"}</strong></span>
              </div>
            </div>
          `;
      })() : ""}

        ${activeTab === "all" || activeTab === "trainer" ? (() => {
        const dt = profile.getDiscardTrainerStats(context.storage);
        return `
            <!-- Global Discard Trainer Career Statistics Across All Brands -->
            <div class="profile-discard-trainer-card" style="background:rgba(0,0,0,0.3);border:1.5px solid rgba(16,185,129,0.45);border-radius:10px;padding:12px 14px;margin-bottom:12px;text-align:left;">
              <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;border-bottom:1px solid rgba(244,234,212,0.1);padding-bottom:6px;flex-wrap:wrap;gap:8px;">
                <div style="display:flex;align-items:center;gap:8px;">
                  <span style="font-size:1.35rem;">\u{1F3AF}</span>
                  <div>
                    <div style="color:#34d399;font-size:0.96rem;font-weight:800;">Discard Trainer Career Stats</div>
                    <div style="font-size:0.72rem;color:#9ca3af;">Global Optimal Discards &amp; EV Accuracy across all 4 brands</div>
                  </div>
                </div>
                <button type="button" class="btn-trainer-play-link" id="btnProfileModalPracticeDiscards" data-action="open-trainer" style="display:inline-flex;align-items:center;gap:6px;padding:5px 12px;border-radius:6px;font-size:0.78rem;font-weight:700;border:1px solid #10b981;background:rgba(16,185,129,0.22);color:#34d399;cursor:pointer;transition:transform 0.15s ease;">
                  \u{1F3AF} Practice Discards
                </button>
              </div>
              <div class="discard-trainer-stats-grid" style="display:grid;grid-template-columns:repeat(4, 1fr);gap:6px;text-align:center;">
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;">
                  <div style="font-size:0.68rem;color:#9ca3af;font-weight:700;text-transform:uppercase;">Hands Practiced</div>
                  <div style="font-size:1.1rem;font-weight:800;color:#facc15;margin-top:2px;">
                    ${dt.handsPlayed || 0}
                  </div>
                </div>
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;">
                  <div style="font-size:0.68rem;color:#9ca3af;font-weight:700;text-transform:uppercase;">Optimal Accuracy</div>
                  <div style="font-size:1.1rem;font-weight:800;color:#10b981;margin-top:2px;">
                    ${dt.accuracyPct}% <span style="font-size:0.72rem;color:#9ca3af;">(${dt.optimalCount})</span>
                  </div>
                </div>
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;">
                  <div style="font-size:0.68rem;color:#9ca3af;font-weight:700;text-transform:uppercase;">Optimal Streak</div>
                  <div style="font-size:1.1rem;font-weight:800;color:#38bdf8;margin-top:2px;">
                    ${dt.currentStreak > 0 ? `\u{1F525} ${dt.currentStreak}` : "0"} <span style="font-size:0.72rem;color:#9ca3af;">(Best: ${dt.bestStreak})</span>
                  </div>
                </div>
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;">
                  <div style="font-size:0.68rem;color:#9ca3af;font-weight:700;text-transform:uppercase;">Avg EV Loss</div>
                  <div style="font-size:1.1rem;font-weight:800;color:${dt.averageLossEV === 0 ? "#10b981" : "#f87171"};margin-top:2px;">
                    -${dt.averageLossEV.toFixed(2)}
                  </div>
                </div>
              </div>
              <div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px;font-size:0.75rem;color:#9ca3af;padding-top:4px;border-top:1px solid rgba(244,234,212,0.06);">
                <span>Cumulative EV Loss: <strong style="color:#e5e7eb;">-${dt.totalLossEV.toFixed(2)}</strong></span>
                <span>Last Practiced: <strong style="color:#e5e7eb;">${dt.lastPlayedDate || "Never"}</strong></span>
              </div>
            </div>
          `;
      })() : ""}

        ${activeTab === "all" || activeTab === "boards" ? (() => {
        const boardsData = profile.getCustom3DBoards(context.storage);
        const totalCustom = boardsData?.list?.length || 0;
        return `
            <!-- Custom 3D Boards by Brand -->
            <div class="profile-custom-boards-card" style="background:rgba(0,0,0,0.3);border:1.5px solid rgba(56,189,248,0.45);border-radius:10px;padding:12px 14px;margin-bottom:12px;text-align:left;">
              <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;border-bottom:1px solid rgba(244,234,212,0.1);padding-bottom:6px;flex-wrap:wrap;gap:8px;">
                <div style="display:flex;align-items:center;gap:8px;">
                  <span style="font-size:1.35rem;">\u{1F3B2}</span>
                  <div>
                    <div style="color:#38bdf8;font-size:0.96rem;font-weight:800;">Custom 3D Boards Gallery</div>
                    <div style="font-size:0.72rem;color:#9ca3af;">User-configured 3D cribbage boards saved per brand in your profile</div>
                  </div>
                </div>
                <button type="button" class="btn-boards-3d-link" id="btnProfileModalOpen3DBoards" data-action="open-3d-boards" data-brand="all" style="display:inline-flex;align-items:center;gap:6px;padding:5px 12px;border-radius:6px;font-size:0.78rem;font-weight:700;border:1px solid #38bdf8;background:rgba(56,189,248,0.22);color:#38bdf8;cursor:pointer;transition:transform 0.15s ease;">
                  \u{1F3B2} Open 3D Boards Modal
                </button>
              </div>
              <div class="custom-boards-grid" style="display:grid;grid-template-columns:repeat(4, 1fr);gap:6px;text-align:center;">
                ${GAME_BRANDS.map((b) => {
          const bCount = (boardsData?.byBrand?.[b.id] || []).length;
          return `
                    <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(244,234,212,0.08);border-radius:8px;padding:6px 4px;cursor:pointer;" data-action="open-3d-boards" data-brand="${b.id}" title="View ${b.name} 3D boards">
                      <div style="font-size:0.68rem;color:${b.color};font-weight:700;text-transform:uppercase;">${b.shortName}</div>
                      <div style="font-size:1.1rem;font-weight:800;color:#fff;margin-top:2px;">
                        ${bCount} Board${bCount === 1 ? "" : "s"}
                      </div>
                    </div>
                  `;
        }).join("")}
              </div>
              <div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px;font-size:0.75rem;color:#9ca3af;padding-top:4px;border-top:1px solid rgba(244,234,212,0.06);">
                <span>Total Custom Boards: <strong style="color:#fff;">${totalCustom}</strong></span>
                <span style="color:#38bdf8;cursor:pointer;" data-action="open-3d-boards" data-brand="all">Manage &amp; Add Custom Boards \u2794</span>
              </div>
            </div>
          `;
      })() : ""}

        <!-- Recent Match History List -->
        <div style="text-align:left;">
          <div style="font-size:0.8rem;text-transform:uppercase;letter-spacing:0.06em;color:#f59e0b;font-weight:700;margin-bottom:6px;">
            ${activeTab === "all" ? "Recent Match History (All Games)" : activeTab === "daily" || activeTab === "trainer" || activeTab === "boards" ? "Match History" : `Recent ${GAME_BRANDS.find((b) => b.id === activeTab)?.shortName || ""} Matches`}
          </div>
          <div style="background:rgba(0,0,0,0.25);border:1px solid rgba(244,234,212,0.18);border-radius:8px;max-height:28vh;overflow-y:auto;">
            ${historyRowsHtml}
          </div>
        </div>

        <!-- Actions -->
        <div style="margin-top:16px;display:flex;justify-content:center;gap:10px;flex-wrap:wrap;">
          <button type="button" class="btn-gold" id="btnProfileModalChangeAvatarAction" data-action="open-avatar" style="cursor:pointer;display:inline-flex;align-items:center;gap:6px;padding:8px 14px;border-radius:8px;font-weight:700;">
            \u{1F3AD} Change Avatar
          </button>
          <button type="button" class="btn-gold" id="btnProfileModalEditNameAction" data-action="edit-name" style="cursor:pointer;display:inline-flex;align-items:center;gap:6px;padding:8px 14px;border-radius:8px;font-weight:700;">
            \u270F\uFE0F Edit Username
          </button>
          <button type="button" class="btn-danger" id="btnResetProfileStats" data-action="reset-stats" style="padding:8px 14px;border-radius:8px;font-weight:700;cursor:pointer;">
            Reset Statistics
          </button>
          <button type="button" class="btn-ghost modal-btn-close" id="btnCloseRecords" data-action="close" style="padding:8px 14px;border-radius:8px;font-weight:700;cursor:pointer;">
            Close
          </button>
        </div>
      </div>
    `;
      const showModalFn = context.showModal || (typeof window !== "undefined" && window.showModal ? window.showModal : null);
      if (typeof showModalFn === "function") {
        showModalFn(modalHtml, true);
        const root = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".profile-records-modal-content") || (typeof document.getElementById === "function" ? document.getElementById("overlay") : null) : null;
        if (root) _Profile.bindModalEvents(root);
      }
    }
    /**
     * Centralized event delegation binder for Profile records modal.
     * @param {HTMLElement} root
     */
    static bindModalEvents(root) {
      if (!root || typeof root.addEventListener !== "function") return;
      root.addEventListener("click", (e) => {
        const target = e.target.closest("[data-action]");
        if (!target) return;
        const action = target.dataset.action;
        switch (action) {
          case "view-trophies": {
            const brandId = target.dataset.brand || "all";
            if (typeof window !== "undefined") {
              if (window.showTrophyRoomModal) window.showTrophyRoomModal(brandId);
              else if (window.AchievementManager?.showTrophyRoomModal) window.AchievementManager.showTrophyRoomModal(brandId);
            }
            break;
          }
          case "view-replays": {
            const brandId = target.dataset.brand || "all";
            if (typeof window !== "undefined") {
              if (window.showReplaysModal) window.showReplaysModal(brandId);
              else if (window.ReplayModal?.openLibrary) window.ReplayModal.openLibrary(brandId);
            }
            break;
          }
          case "open-3d-boards": {
            const brandId = target.dataset.brand || "all";
            _Profile.openBoard3DModal(brandId);
            break;
          }
          case "open-avatar":
            _Profile.openAvatarSelector();
            break;
          case "edit-name":
            _Profile.startInlineNameEdit();
            break;
          case "save-inline-name":
            _Profile.saveInlineName();
            break;
          case "cancel-inline-name":
            _Profile.cancelInlineNameEdit();
            break;
          case "open-trainer":
            _Profile.openDiscardTrainer();
            break;
          case "open-daily":
            _Profile.openDailyPuzzle();
            break;
          case "switch-tab": {
            const tab = target.dataset.tab;
            if (tab) _Profile.switchRecordsTab(tab);
            break;
          }
          case "reset-stats":
            _Profile.resetStatsConfirm();
            break;
          case "close":
            if (typeof hideModal === "function") hideModal();
            else if (typeof window !== "undefined" && typeof window.hideModal === "function") window.hideModal();
            break;
        }
      });
      const sel = root.querySelector("#selectProfileRecordsTab");
      if (sel) {
        sel.addEventListener("change", () => {
          _Profile.switchRecordsTab(sel.value);
        });
      }
      const inlineInput = root.querySelector("#inputProfileInlineName");
      if (inlineInput) {
        inlineInput.addEventListener("input", () => {
          inlineInput.value = inlineInput.value.replace(/[^a-zA-Z0-9]/g, "");
        });
        inlineInput.addEventListener("keydown", (e) => {
          if (e.key === "Enter") _Profile.saveInlineName();
          if (e.key === "Escape") _Profile.cancelInlineNameEdit();
        });
      }
    }
    /**
     * Opens the avatar selection modal from the profile modal.
     */
    static openAvatarSelector() {
      const avMgr = typeof window !== "undefined" && window.AvatarManager || (typeof AvatarManager !== "undefined" ? AvatarManager : null) || typeof window !== "undefined" && window.CrazyCribbage && window.CrazyCribbage.AvatarManager;
      if (avMgr && typeof avMgr.openAvatarModal === "function") {
        avMgr.openAvatarModal({
          onSelect: (newAvatarId) => {
            const profile = _Profile.getInstance(_Profile._lastContext?.storage);
            profile.setAvatar(newAvatarId, _Profile._lastContext?.storage);
            if (typeof window !== "undefined" && typeof window.updateProfileDropdownUI === "function") {
              window.updateProfileDropdownUI();
            }
            _Profile.showRecordsModal(_Profile._lastContext || {});
          }
        });
      }
    }
    /**
     * Activates inline editing for username in the profile header banner.
     */
    static startInlineNameEdit() {
      if (typeof document === "undefined") return;
      const viewRow = document.getElementById("profileHeaderNameRow");
      const editRow = document.getElementById("profileHeaderNameEditRow");
      const input = document.getElementById("inputProfileInlineName");
      if (viewRow && editRow) {
        viewRow.style.display = "none";
        editRow.style.display = "flex";
        if (input) {
          input.focus();
          input.select();
          input.oninput = () => {
            input.value = input.value.replace(/[^a-zA-Z0-9]/g, "");
          };
          input.onkeydown = (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              _Profile.saveInlineName();
            } else if (e.key === "Escape") {
              e.preventDefault();
              _Profile.cancelInlineNameEdit();
            }
          };
        }
      }
    }
    /**
     * Cancels inline username editing and restores original name.
     */
    static cancelInlineNameEdit() {
      if (typeof document === "undefined") return;
      const viewRow = document.getElementById("profileHeaderNameRow");
      const editRow = document.getElementById("profileHeaderNameEditRow");
      const input = document.getElementById("inputProfileInlineName");
      const profile = _Profile.getInstance(_Profile._lastContext?.storage);
      if (input) {
        input.value = profile.getName(_Profile._lastContext?.storage);
      }
      if (viewRow && editRow) {
        editRow.style.display = "none";
        viewRow.style.display = "flex";
      }
    }
    /**
     * Saves new username from inline edit input, updates DOM & storage, and returns to view mode.
     */
    static saveInlineName() {
      if (typeof document === "undefined") return;
      const input = document.getElementById("inputProfileInlineName");
      if (!input) return;
      const sanitized = sanitizeUserInput(input.value);
      const newName = sanitized.replace(/[^a-zA-Z0-9]/g, "").trim() || "Player";
      const profile = _Profile.getInstance(_Profile._lastContext?.storage);
      profile.setName(newName, _Profile._lastContext?.storage);
      const nameDisplay = document.getElementById("profileHeaderNameDisplay");
      if (nameDisplay) nameDisplay.textContent = newName;
      if (typeof window !== "undefined" && typeof window.updateProfileDropdownUI === "function") {
        window.updateProfileDropdownUI();
      }
      const viewRow = document.getElementById("profileHeaderNameRow");
      const editRow = document.getElementById("profileHeaderNameEditRow");
      if (viewRow && editRow) {
        editRow.style.display = "none";
        viewRow.style.display = "flex";
      }
    }
    /**
     * Prompts user with confirmation before resetting statistics.
     * Supports resetting a specific game or all 4 games.
     * @param {string} [brand=null]
     */
    static resetStatsConfirm(brand = null) {
      const targetBrand = brand || _Profile._selectedRecordsTab || "all";
      const showConfirmModalFn = typeof window !== "undefined" && window.showConfirmModal ? window.showConfirmModal : null;
      const brandObj = GAME_BRANDS.find((b) => b.id === targetBrand);
      let title;
      let message;
      if (targetBrand === "daily" || targetBrand === "dailyPuzzle") {
        title = "Reset Daily Puzzle Statistics & Streaks?";
        message = "This will reset your Daily Puzzle current streak, best streak, optimal discards, and pegging results to zero. Player profile and game match records will remain intact.";
      } else if (targetBrand === "trainer" || targetBrand === "discardTrainer") {
        title = "Reset Discard Trainer Statistics?";
        message = "This will reset your Discard Trainer career hands played, optimal discards, streaks, and EV accuracy to zero across all brands. Player profile and game match records will remain intact.";
      } else if (targetBrand === "pegging" || targetBrand === "peggingTrainer") {
        title = "Reset Pegging Tactics Trainer Statistics?";
        message = "This will reset your Pegging Trainer career scenarios played, optimal moves, streaks, and accuracy to zero across all brands. Player profile and game match records will remain intact.";
      } else if (targetBrand === "all") {
        title = "Reset All Match Statistics Across All 4 Games?";
        message = "This will reset your match history, win rate, and streak records to zero across Crazy Cribbage, Cribbage Clash, Pints & Pegs, and Skunked & Stripped. Player name, avatar, Discard Trainer, and Daily Puzzle streaks will remain intact.";
      } else {
        title = `Reset All Statistics for ${brandObj?.name || targetBrand}?`;
        message = `This will reset your match history and win rate for ${brandObj?.name || targetBrand} to zero. Player name, avatar, Discard Trainer, and Daily Puzzle streaks will remain intact.`;
      }
      const onConfirm = () => {
        const profile = _Profile.getInstance(_Profile._lastContext?.storage);
        profile.clearRecords(_Profile._lastContext?.storage, targetBrand);
        _Profile.showRecordsModal(_Profile._lastContext || {});
      };
      if (typeof showConfirmModalFn === "function") {
        showConfirmModalFn({
          title,
          message,
          confirmLabel: "Yes, Reset",
          cancelLabel: "Cancel",
          onConfirm
        });
      } else {
        if (typeof window !== "undefined" && window.confirm && window.confirm(title)) {
          onConfirm();
        }
      }
    }
    /**
     * Opens interactive modal / prompt allowing the user to change their username.
     */
    static promptChangeUsername() {
      const profile = _Profile.getInstance();
      const currentName = profile.getName();
      const modalHtml = `
      <div style="text-align:left;max-width:400px;margin:0 auto;">
        <h2 style="margin-top:0;color:#f59e0b;font-size:1.3rem;">Change Username</h2>
        <p style="color:#d1d5db;font-size:0.88rem;margin-bottom:14px;">
          Choose your player name for solo matches, scoreboard chips, and online multiplayer rooms:
        </p>
        <div style="margin-bottom:16px;">
          <input type="text" id="inputProfileNewUsername" value="${currentName.replace(/"/g, "&quot;")}" maxlength="24" placeholder="Enter username" pattern="[a-zA-Z0-9]+" style="width:100%;box-sizing:border-box;padding:10px 14px;border-radius:8px;border:1.5px solid rgba(245,158,11,0.5);background:#0f172a;color:#fff;font-size:1rem;font-weight:600;outline:none;" />
        </div>
        <div style="display:flex;justify-content:flex-end;gap:10px;">
          <button type="button" class="btn-ghost" id="btnCancelNewUsername">Cancel</button>
          <button type="button" class="btn-gold" id="btnSaveNewUsername">Save Username</button>
        </div>
      </div>
    `;
      if (typeof window !== "undefined" && typeof window.showModal === "function") {
        window.showModal(modalHtml, false);
        setTimeout(() => {
          const inp = document.getElementById("inputProfileNewUsername");
          if (inp) {
            inp.focus();
            inp.select();
            inp.addEventListener("input", () => {
              inp.value = inp.value.replace(/[^a-zA-Z0-9]/g, "");
            });
            inp.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                _Profile.saveUsernameFromInput();
              }
            });
          }
          const btnSave = document.getElementById("btnSaveNewUsername");
          if (btnSave) {
            btnSave.addEventListener("click", () => _Profile.saveUsernameFromInput());
          }
          const btnCancel = document.getElementById("btnCancelNewUsername");
          if (btnCancel) {
            btnCancel.addEventListener("click", () => {
              if (typeof hideModal === "function") hideModal();
              else if (typeof window !== "undefined" && typeof window.hideModal === "function") window.hideModal();
            });
          }
        }, 50);
      }
    }
    /**
     * Saves new username from the modal input and closes modal.
     */
    static saveUsernameFromInput() {
      if (typeof document === "undefined") return;
      const inp = document.getElementById("inputProfileNewUsername");
      if (!inp) return;
      const sanitized = sanitizeUserInput(inp.value);
      const newName = sanitized.replace(/[^a-zA-Z0-9]/g, "").trim() || "Player";
      const profile = _Profile.getInstance(_Profile._lastContext?.storage);
      profile.setName(newName, _Profile._lastContext?.storage);
      if (typeof window !== "undefined") {
        if (typeof window.updateProfileDropdownUI === "function") {
          window.updateProfileDropdownUI();
        }
        if (_Profile._wasRecordsModalOpen) {
          _Profile.showRecordsModal(_Profile._lastContext || {});
          _Profile._wasRecordsModalOpen = false;
          return;
        }
        if (typeof window.hideModal === "function") {
          window.hideModal();
        }
      }
    }
  };
  if (typeof window !== "undefined") {
    window.Profile = Profile;
  }

  // src/achievements/AchievementManager.js
  var BADGE_DEFINITIONS = [
    // ==========================================
    // BRAND: Crazy Cribbage (Flagship / Classic / Jokers / Tournaments / Daily)
    // ==========================================
    // --- Category: Match Victories ---
    {
      id: "first_blood",
      name: "First Victory",
      desc: "Win your first full cribbage match against AI or human challenger.",
      icon: "\u{1F947}",
      rarity: "common",
      category: "victories",
      brand: "crazy",
      targetStat: "totalWins",
      targetVal: 1
    },
    {
      id: "victories_5",
      name: "High Roller",
      desc: "Win 5 full cribbage matches.",
      icon: "\u{1F396}\uFE0F",
      rarity: "common",
      category: "victories",
      brand: "crazy",
      targetStat: "totalWins",
      targetVal: 5
    },
    {
      id: "victories_10",
      name: "Card Shark",
      desc: "Win 10 full cribbage matches.",
      icon: "\u{1F988}",
      rarity: "rare",
      category: "victories",
      brand: "crazy",
      targetStat: "totalWins",
      targetVal: 10
    },
    {
      id: "victories_25",
      name: "Board Commander",
      desc: "Win 25 full cribbage matches.",
      icon: "\u2694\uFE0F",
      rarity: "rare",
      category: "victories",
      brand: "crazy",
      targetStat: "totalWins",
      targetVal: 25
    },
    {
      id: "victories_50",
      name: "Master of the Pegs",
      desc: "Win 50 full cribbage matches.",
      icon: "\u{1F6E1}\uFE0F",
      rarity: "epic",
      category: "victories",
      brand: "crazy",
      targetStat: "totalWins",
      targetVal: 50
    },
    {
      id: "victories_100",
      name: "Centurion",
      desc: "Win 100 full cribbage matches.",
      icon: "\u{1F451}",
      rarity: "legendary",
      category: "victories",
      brand: "crazy",
      targetStat: "totalWins",
      targetVal: 100
    },
    // --- Category: Single Hand Scores ---
    {
      id: "twenty_pointer",
      name: "Twenty Pointer",
      desc: "Score 20 or more points in a single hand.",
      icon: "\u270B",
      rarity: "common",
      category: "hands",
      brand: "crazy"
    },
    {
      id: "crazy_good",
      name: "Crazy Good",
      desc: "Score 30 or more points in a single hand.",
      icon: "\u{1F601}",
      rarity: "epic",
      category: "hands",
      brand: "crazy"
    },
    {
      id: "century_club",
      name: "Century Club",
      desc: "Score 35 or more points in a single Super Deal hand.",
      icon: "\u{1F3A9}",
      rarity: "rare",
      category: "hands",
      brand: "crazy"
    },
    {
      id: "crazy_amazing",
      name: "Crazy Amazing",
      desc: "Score 40 or more points in a single hand.",
      icon: "\u{1F601}",
      rarity: "epic",
      category: "hands",
      brand: "crazy"
    },
    {
      id: "crazy_awesome",
      name: "Crazy Awesome",
      desc: "Score 50 or more points in a single hand.",
      icon: "\u{1F601}",
      rarity: "epic",
      category: "hands",
      brand: "crazy"
    },
    {
      id: "crazy_legendary",
      name: "Crazy Legendary",
      desc: "Score 60 or more points in a single hand.",
      icon: "\u{1F31F}",
      rarity: "legendary",
      category: "hands",
      brand: "crazy"
    },
    {
      id: "crazy_godlike",
      name: "Crazy Godlike",
      desc: "Score 75 or more points in a single hand.",
      icon: "\u26A1",
      rarity: "legendary",
      category: "hands",
      brand: "crazy"
    },
    {
      id: "crazy_mythic",
      name: "Crazy Mythic",
      desc: "Score 100 or more points in a single explosive hand.",
      icon: "\u{1F30C}",
      rarity: "legendary",
      category: "hands",
      brand: "crazy"
    },
    {
      id: "holy_grail",
      name: "The Holy Grail",
      desc: "Score the legendary 29-point hand \u2014 highest score in standard cribbage.",
      icon: "\u{1F3C6}",
      rarity: "legendary",
      category: "hands",
      brand: "crazy"
    },
    // --- Category: Jokers & Special Rules ---
    {
      id: "super_joker",
      name: "Super Joker",
      desc: "Get 2 jokers in one hand.",
      icon: "\u{1F601}",
      rarity: "rare",
      category: "specials",
      brand: "crazy"
    },
    {
      id: "triple_joker",
      name: "Triple Joker",
      desc: "Get 3 jokers in a single hand (2-deck mode).",
      icon: "\u{1F0CF}",
      rarity: "legendary",
      category: "specials",
      brand: "crazy"
    },
    {
      id: "cutthroat_king",
      name: "Cutthroat King",
      desc: "Successfully call Muggins on an opponent and steal their forgotten points.",
      icon: "\u26A1",
      rarity: "rare",
      category: "specials",
      brand: "crazy",
      targetStat: "mugginsCalls",
      targetVal: 1
    },
    {
      id: "muggins_5",
      name: "Eagle Eyes",
      desc: "Call Muggins 5 times to catch opponents sleeping.",
      icon: "\u{1F985}",
      rarity: "rare",
      category: "specials",
      brand: "crazy",
      targetStat: "mugginsCalls",
      targetVal: 5
    },
    {
      id: "muggins_15",
      name: "Muggins Menace",
      desc: "Call Muggins 15 times.",
      icon: "\u{1F575}\uFE0F",
      rarity: "epic",
      category: "specials",
      brand: "crazy",
      targetStat: "mugginsCalls",
      targetVal: 15
    },
    {
      id: "muggins_30",
      name: "The Master Thief",
      desc: "Call Muggins 30 times.",
      icon: "\u{1F4B0}",
      rarity: "legendary",
      category: "specials",
      brand: "crazy",
      targetStat: "mugginsCalls",
      targetVal: 30
    },
    // --- Category: Tournament Wins ---
    {
      id: "tourney_first_win",
      name: "Table Champion",
      desc: "Win your first mini-tournament bracket championship.",
      icon: "\u{1F3C6}",
      rarity: "rare",
      category: "tournaments",
      brand: "crazy",
      targetStat: "tournamentWins",
      targetVal: 1
    },
    {
      id: "tourney_3_wins",
      name: "Bracket Dominator",
      desc: "Win 3 mini-tournament championships.",
      icon: "\u{1F947}",
      rarity: "epic",
      category: "tournaments",
      brand: "crazy",
      targetStat: "tournamentWins",
      targetVal: 3
    },
    {
      id: "tourney_5_wins",
      name: "Tournament Veteran",
      desc: "Win 5 mini-tournament championships.",
      icon: "\u{1F396}\uFE0F",
      rarity: "epic",
      category: "tournaments",
      brand: "crazy",
      targetStat: "tournamentWins",
      targetVal: 5
    },
    {
      id: "tourney_10_wins",
      name: "Grand Tournament Master",
      desc: "Win 10 mini-tournament championships.",
      icon: "\u{1F451}",
      rarity: "legendary",
      category: "tournaments",
      brand: "crazy",
      targetStat: "tournamentWins",
      targetVal: 10
    },
    {
      id: "tourney_25_wins",
      name: "Undisputed Table Legend",
      desc: "Win 25 mini-tournament championships.",
      icon: "\u{1F3DB}\uFE0F",
      rarity: "legendary",
      category: "tournaments",
      brand: "crazy",
      targetStat: "tournamentWins",
      targetVal: 25
    },
    {
      id: "tourney_double_elim",
      name: "Double Elimination King",
      desc: "Win a full Double Elimination tournament bracket.",
      icon: "\u{1F501}",
      rarity: "epic",
      category: "tournaments",
      brand: "crazy"
    },
    {
      id: "tourney_8_player",
      name: "Octo-Champion",
      desc: "Win an 8-player tournament bracket from start to finish.",
      icon: "\u{1F419}",
      rarity: "legendary",
      category: "tournaments",
      brand: "crazy"
    },
    // --- Category: Daily Discard Challenges ---
    {
      id: "daily_discard_first",
      name: "Daily Discard Apprentice",
      desc: "Find the optimal discard in your first Daily Discard puzzle.",
      icon: "\u{1F9E9}",
      rarity: "common",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyDiscardOptimal",
      targetVal: 1
    },
    {
      id: "daily_discard_5",
      name: "Daily Discard Specialist",
      desc: "Achieve 5 optimal Daily Discard puzzle solutions.",
      icon: "\u{1F4A1}",
      rarity: "rare",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyDiscardOptimal",
      targetVal: 5
    },
    {
      id: "daily_discard_10",
      name: "Daily Discard Expert",
      desc: "Achieve 10 optimal Daily Discard puzzle solutions.",
      icon: "\u{1F9E0}",
      rarity: "epic",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyDiscardOptimal",
      targetVal: 10
    },
    {
      id: "daily_discard_25",
      name: "Daily Discard Master",
      desc: "Achieve 25 optimal Daily Discard puzzle solutions.",
      icon: "\u{1F393}",
      rarity: "legendary",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyDiscardOptimal",
      targetVal: 25
    },
    {
      id: "daily_discard_50",
      name: "Daily Discard Oracle",
      desc: "Achieve 50 optimal Daily Discard puzzle solutions.",
      icon: "\u{1F52E}",
      rarity: "legendary",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyDiscardOptimal",
      targetVal: 50
    },
    {
      id: "daily_discard_streak_3",
      name: "Discard Streak (3 Days)",
      desc: "Solve the Daily Discard optimally 3 consecutive days in a row.",
      icon: "\u{1F525}",
      rarity: "rare",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyDiscardStreak",
      targetVal: 3
    },
    {
      id: "daily_discard_streak_7",
      name: "Discard Streak (7 Days)",
      desc: "Solve the Daily Discard optimally 7 consecutive days in a row.",
      icon: "\u26A1",
      rarity: "epic",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyDiscardStreak",
      targetVal: 7
    },
    // --- Category: Daily Pegging Challenges ---
    {
      id: "daily_pegging_first",
      name: "Daily Pegging Sharp",
      desc: "Find the winning card in your first Daily Pegging scenario.",
      icon: "\u{1F3AF}",
      rarity: "common",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyPeggingCorrect",
      targetVal: 1
    },
    {
      id: "daily_pegging_5",
      name: "Daily Pegging Tactician",
      desc: "Solve 5 Daily Pegging scenarios correctly.",
      icon: "\u{1F3F9}",
      rarity: "rare",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyPeggingCorrect",
      targetVal: 5
    },
    {
      id: "daily_pegging_10",
      name: "Daily Pegging Strategist",
      desc: "Solve 10 Daily Pegging scenarios correctly.",
      icon: "\u265F\uFE0F",
      rarity: "epic",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyPeggingCorrect",
      targetVal: 10
    },
    {
      id: "daily_pegging_25",
      name: "Daily Pegging Grandmaster",
      desc: "Solve 25 Daily Pegging scenarios correctly.",
      icon: "\u{1F3AA}",
      rarity: "legendary",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyPeggingCorrect",
      targetVal: 25
    },
    {
      id: "daily_pegging_50",
      name: "Daily Pegging Virtuoso",
      desc: "Solve 50 Daily Pegging scenarios correctly.",
      icon: "\u{1F320}",
      rarity: "legendary",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyPeggingCorrect",
      targetVal: 50
    },
    {
      id: "daily_pegging_streak_3",
      name: "Pegging Streak (3 Days)",
      desc: "Solve Daily Pegging correctly 3 consecutive days in a row.",
      icon: "\u{1F525}",
      rarity: "rare",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyPeggingStreak",
      targetVal: 3
    },
    {
      id: "daily_pegging_streak_7",
      name: "Pegging Streak (7 Days)",
      desc: "Solve Daily Pegging correctly 7 consecutive days in a row.",
      icon: "\u26A1",
      rarity: "epic",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyPeggingStreak",
      targetVal: 7
    },
    // --- Category: Daily Puzzle Streaks (Both Challenges) ---
    {
      id: "daily_streak_3",
      name: "Daily Devotee (3-Day Streak)",
      desc: "Complete both Daily Discard and Pegging challenges 3 days in a row.",
      icon: "\u{1F5D3}\uFE0F",
      rarity: "rare",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyStreak",
      targetVal: 3
    },
    {
      id: "daily_streak_7",
      name: "Daily Champion (7-Day Streak)",
      desc: "Complete both Daily challenges 7 days in a row.",
      icon: "\u{1F31F}",
      rarity: "epic",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyStreak",
      targetVal: 7
    },
    {
      id: "daily_streak_14",
      name: "Daily Legend (14-Day Streak)",
      desc: "Complete both Daily challenges 14 days in a row.",
      icon: "\u{1F3C5}",
      rarity: "legendary",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyStreak",
      targetVal: 14
    },
    {
      id: "daily_streak_30",
      name: "Daily Immortal (30-Day Streak)",
      desc: "Complete both Daily challenges 30 days in a row.",
      icon: "\u{1FA90}",
      rarity: "legendary",
      category: "daily",
      brand: "crazy",
      targetStat: "dailyStreak",
      targetVal: 30
    },
    // --- Category: Discard Trainer (EV Exploration) ---
    {
      id: "ev_master",
      name: "EV Master",
      desc: "Find the #1 statistically optimal crib discard in the Discard Trainer.",
      icon: "\u{1F3AF}",
      rarity: "common",
      category: "daily",
      brand: "crazy",
      targetStat: "trainerOptimalDiscards",
      targetVal: 1
    },
    {
      id: "ev_scholar",
      name: "Discard Scholar",
      desc: "Find 10 #1 optimal discards in the Discard Trainer.",
      icon: "\u{1F4DA}",
      rarity: "rare",
      category: "daily",
      brand: "crazy",
      targetStat: "trainerOptimalDiscards",
      targetVal: 10
    },
    {
      id: "ev_grandmaster",
      name: "Discard Grandmaster",
      desc: "Find 25 #1 optimal discards in the Discard Trainer.",
      icon: "\u{1F396}\uFE0F",
      rarity: "epic",
      category: "daily",
      brand: "crazy",
      targetStat: "trainerOptimalDiscards",
      targetVal: 25
    },
    {
      id: "ev_guru",
      name: "EV Oracle",
      desc: "Find 50 #1 optimal discards in the Discard Trainer.",
      icon: "\u{1F441}\uFE0F",
      rarity: "legendary",
      category: "daily",
      brand: "crazy",
      targetStat: "trainerOptimalDiscards",
      targetVal: 50
    },
    // ==========================================
    // BRAND: Cribbage Clash (481-Hole Marathon & Track Challenges)
    // ==========================================
    {
      id: "clash_conqueror",
      name: "Clash Conqueror",
      desc: "Emerge victorious on the epic 481-hole circular marathon track.",
      icon: "\u{1F300}",
      rarity: "common",
      category: "specials",
      brand: "clash",
      targetStat: "clashWins",
      targetVal: 1
    },
    {
      id: "clash_veteran",
      name: "Clash Veteran",
      desc: "Win 3 Cribbage Clash marathon matches.",
      icon: "\u{1F3CE}\uFE0F",
      rarity: "rare",
      category: "specials",
      brand: "clash",
      targetStat: "clashWins",
      targetVal: 3
    },
    {
      id: "clash_master",
      name: "Clash Master",
      desc: "Win 10 Cribbage Clash marathon matches.",
      icon: "\u{1F3C1}",
      rarity: "epic",
      category: "specials",
      brand: "clash",
      targetStat: "clashWins",
      targetVal: 10
    },
    {
      id: "clash_legend",
      name: "Clash Legend",
      desc: "Win 25 Cribbage Clash marathon matches.",
      icon: "\u26A1",
      rarity: "legendary",
      category: "specials",
      brand: "clash",
      targetStat: "clashWins",
      targetVal: 25
    },
    {
      id: "clash_speedster",
      name: "Speed Demon",
      desc: "Win 50 Cribbage Clash marathon matches.",
      icon: "\u{1F680}",
      rarity: "legendary",
      category: "specials",
      brand: "clash",
      targetStat: "clashWins",
      targetVal: 50
    },
    {
      id: "clash_ring_ruler",
      name: "Master of the Track",
      desc: "Win 100 Cribbage Clash marathon matches.",
      icon: "\u{1F451}",
      rarity: "legendary",
      category: "specials",
      brand: "clash",
      targetStat: "clashWins",
      targetVal: 100
    },
    // ==========================================
    // BRAND: Pints & Pegs (Pub Matches, Pints & Zero Drinks)
    // ==========================================
    {
      id: "pub_first_pint",
      name: "First Round",
      desc: "Win your first Pints & Pegs pub match.",
      icon: "\u{1F37A}",
      rarity: "common",
      category: "specials",
      brand: "pints",
      targetStat: "pintsWins",
      targetVal: 1
    },
    {
      id: "pub_legend",
      name: "Pub Legend",
      desc: "Finish a Pints & Pegs match with zero drink penalties taken.",
      icon: "\u{1F37B}",
      rarity: "rare",
      category: "specials",
      brand: "pints"
    },
    {
      id: "pub_regular",
      name: "Pub Regular",
      desc: "Win 5 Pints & Pegs pub matches.",
      icon: "\u{1F37A}",
      rarity: "rare",
      category: "specials",
      brand: "pints",
      targetStat: "pintsWins",
      targetVal: 5
    },
    {
      id: "pub_champion",
      name: "Pub Champion",
      desc: "Win 15 Pints & Pegs pub matches.",
      icon: "\u{1F3C6}",
      rarity: "epic",
      category: "specials",
      brand: "pints",
      targetStat: "pintsWins",
      targetVal: 15
    },
    {
      id: "pub_master",
      name: "Tavern Master",
      desc: "Win 25 Pints & Pegs pub matches.",
      icon: "\u{1F451}",
      rarity: "legendary",
      category: "specials",
      brand: "pints",
      targetStat: "pintsWins",
      targetVal: 25
    },
    {
      id: "pub_tavern_king",
      name: "King of the Tavern",
      desc: "Win 50 Pints & Pegs pub matches.",
      icon: "\u{1F3F0}",
      rarity: "legendary",
      category: "specials",
      brand: "pints",
      targetStat: "pintsWins",
      targetVal: 50
    },
    // ==========================================
    // BRAND: Skunked & Stripped (Skunks & High Stakes Matches)
    // ==========================================
    {
      id: "adult_first_strip",
      name: "Strip Showdown",
      desc: "Win your first Skunked & Stripped showdown match.",
      icon: "\u{1F48B}",
      rarity: "common",
      category: "victories",
      brand: "adult",
      targetStat: "adultWins",
      targetVal: 1
    },
    {
      id: "skunk_master",
      name: "Skunk Master",
      desc: "Defeat an opponent by 31 or more points.",
      icon: "\u{1F9A8}",
      rarity: "epic",
      category: "victories",
      brand: "adult",
      targetStat: "totalSkunks",
      targetVal: 1
    },
    {
      id: "double_skunk",
      name: "Double Skunk Destroyer",
      desc: "Defeat an opponent by 61 or more points (Double Skunk).",
      icon: "\u{1F9A8}",
      rarity: "epic",
      category: "victories",
      brand: "adult",
      targetStat: "totalDoubleSkunks",
      targetVal: 1
    },
    {
      id: "skunk_5",
      name: "Skunk Hunter",
      desc: "Skunk opponents 5 times.",
      icon: "\u{1F3AF}",
      rarity: "rare",
      category: "victories",
      brand: "adult",
      targetStat: "totalSkunks",
      targetVal: 5
    },
    {
      id: "skunk_10",
      name: "Skunk Overlord",
      desc: "Skunk opponents 10 times.",
      icon: "\u2620\uFE0F",
      rarity: "epic",
      category: "victories",
      brand: "adult",
      targetStat: "totalSkunks",
      targetVal: 10
    },
    {
      id: "skunk_25",
      name: "Reign of the Skunk",
      desc: "Skunk opponents 25 times.",
      icon: "\u{1F32A}\uFE0F",
      rarity: "legendary",
      category: "victories",
      brand: "adult",
      targetStat: "totalSkunks",
      targetVal: 25
    },
    {
      id: "adult_high_roller",
      name: "Daredevil",
      desc: "Win 10 Skunked & Stripped matches.",
      icon: "\u{1F525}",
      rarity: "epic",
      category: "victories",
      brand: "adult",
      targetStat: "adultWins",
      targetVal: 10
    },
    {
      id: "adult_bare_minimum",
      name: "Stripped Clean",
      desc: "Win 25 Skunked & Stripped matches.",
      icon: "\u2728",
      rarity: "legendary",
      category: "victories",
      brand: "adult",
      targetStat: "adultWins",
      targetVal: 25
    }
  ];
  var AchievementManager = class _AchievementManager {
    static STORAGE_KEY = "crazyCribbage.achievements";
    static STATS_KEY = "crazyCribbage.achievementStats";
    /**
     * Loads unlocked achievements map from storage.
     * @param {Object} [storage=null]
     * @returns {Object<string, { unlockedAt: number }>}
     */
    static loadUnlocked(storage = null) {
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) return {};
      try {
        const raw = s.getItem(_AchievementManager.STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        return {};
      }
    }
    /**
     * Persists unlocked achievements map to storage.
     * @param {Object} data
     * @param {Object} [storage=null]
     */
    /**
     * Persists unlocked achievements map to storage and syncs with user profile.
     * @param {Object} data
     * @param {Object} [storage=null]
     */
    static saveUnlocked(data, storage = null) {
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) return;
      try {
        s.setItem(_AchievementManager.STORAGE_KEY, JSON.stringify(data));
        const prof = typeof window !== "undefined" && window.Profile ? window.Profile.getInstance(storage) : null;
        if (prof && typeof prof.syncTrophiesFromUnlocked === "function") {
          prof.syncTrophiesFromUnlocked(data, storage);
        }
      } catch (e) {
      }
    }
    /**
     * Retrieves persistent achievement tracking statistics, automatically syncing
     * with DailyPuzzleManager stats, tournament history, match win records, and player profile.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static getStats(storage = null) {
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      const defaultStats = {
        totalWins: 0,
        totalSkunks: 0,
        totalDoubleSkunks: 0,
        clashWins: 0,
        pintsWins: 0,
        adultWins: 0,
        crazyWins: 0,
        tournamentWins: 0,
        dailyDiscardOptimal: 0,
        dailyDiscardStreak: 0,
        dailyPeggingCorrect: 0,
        dailyPeggingStreak: 0,
        dailyStreak: 0,
        trainerOptimalDiscards: 0,
        mugginsCalls: 0
      };
      if (!s) return defaultStats;
      try {
        const raw = s.getItem(_AchievementManager.STATS_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        const merged = { ...defaultStats, ...parsed };
        try {
          const dpRaw = s.getItem("cc_daily_puzzle_stats");
          if (dpRaw) {
            const dp = JSON.parse(dpRaw);
            if (dp.perfectDiscards > merged.dailyDiscardOptimal) merged.dailyDiscardOptimal = dp.perfectDiscards;
            if (dp.peggingWins > merged.dailyPeggingCorrect) merged.dailyPeggingCorrect = dp.peggingWins;
            if (dp.currentStreak > merged.dailyStreak) merged.dailyStreak = dp.currentStreak;
            if (dp.bestStreak > merged.dailyStreak) merged.dailyStreak = Math.max(merged.dailyStreak, dp.bestStreak);
          }
        } catch (e) {
        }
        try {
          const thRaw = s.getItem("crazyCribbage.tournamentHistory");
          if (thRaw) {
            const th = JSON.parse(thRaw);
            if (Array.isArray(th) && th.length > merged.tournamentWins) {
              merged.tournamentWins = Math.max(merged.tournamentWins, th.length);
            }
          }
        } catch (e) {
        }
        try {
          const prof = typeof window !== "undefined" && window.Profile ? window.Profile.getInstance(storage) : null;
          if (prof && prof.stats?.byBrand) {
            const pb = prof.stats.byBrand;
            if (pb.clash?.wins > merged.clashWins) merged.clashWins = pb.clash.wins;
            if (pb.pints?.wins > merged.pintsWins) merged.pintsWins = pb.pints.wins;
            if (pb.adult?.wins > merged.adultWins) merged.adultWins = pb.adult.wins;
            if (pb.crazy?.wins > merged.crazyWins) merged.crazyWins = pb.crazy.wins;
            if ((prof.stats.wins || 0) > merged.totalWins) merged.totalWins = prof.stats.wins;
            if ((prof.stats.skunkWins || 0) > merged.totalSkunks) merged.totalSkunks = prof.stats.skunkWins;
          }
        } catch (e) {
        }
        return merged;
      } catch (e) {
        return defaultStats;
      }
    }
    /**
     * Persists updated tracking statistics to storage.
     * @param {Object} stats
     * @param {Object} [storage=null]
     */
    static saveStats(stats, storage = null) {
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) return;
      try {
        s.setItem(_AchievementManager.STATS_KEY, JSON.stringify(stats));
      } catch (e) {
      }
    }
    /**
     * Increments a numeric statistic and evaluates any milestone badges.
     * @param {string} key
     * @param {number} [amount=1]
     * @param {Object} [options={}]
     * @returns {number} Updated stat value
     */
    static incrementStat(key, amount = 1, options = {}) {
      if (!key) return 0;
      const stats = _AchievementManager.getStats(options.storage);
      stats[key] = (stats[key] || 0) + amount;
      _AchievementManager.saveStats(stats, options.storage);
      _AchievementManager.checkMilestoneBadges(stats, options);
      return stats[key];
    }
    /**
     * Sets a numeric statistic (monotonic increase) and evaluates milestone badges.
     * @param {string} key
     * @param {number} val
     * @param {Object} [options={}]
     * @returns {number} Updated stat value
     */
    static setStat(key, val, options = {}) {
      if (!key) return 0;
      const stats = _AchievementManager.getStats(options.storage);
      stats[key] = Math.max(stats[key] || 0, Number(val) || 0);
      _AchievementManager.saveStats(stats, options.storage);
      _AchievementManager.checkMilestoneBadges(stats, options);
      return stats[key];
    }
    /**
     * Evaluates all milestone badges with targetStat against current stats.
     * @param {Object} [stats=null]
     * @param {Object} [options={}]
     */
    static checkMilestoneBadges(stats = null, options = {}) {
      const s = stats || _AchievementManager.getStats(options.storage);
      BADGE_DEFINITIONS.forEach((badge) => {
        if (badge.targetStat && badge.targetVal) {
          if ((s[badge.targetStat] || 0) >= badge.targetVal) {
            _AchievementManager.unlock(badge.id, options);
          }
        }
      });
    }
    /**
     * Records a tournament championship victory and awards tournament badges.
     * @param {Object} [tourneyState=null]
     * @param {Object} [options={}]
     */
    static recordTournamentWin(tourneyState = null, options = {}) {
      _AchievementManager.incrementStat("tournamentWins", 1, options);
      _AchievementManager.unlock("tourney_first_win", options);
      if (tourneyState) {
        if (tourneyState.format === "double") {
          _AchievementManager.unlock("tourney_double_elim", options);
        }
        if (tourneyState.playerCount === 8) {
          _AchievementManager.unlock("tourney_8_player", options);
        }
      }
    }
    /**
     * Computes consecutive optimal discard and correct pegging streaks from DailyPuzzleManager history.
     * @param {Object} dailyStats
     * @param {Object} [options={}]
     */
    static checkDailyStreaks(dailyStats, options = {}) {
      if (!dailyStats) return;
      if (dailyStats.currentStreak > 0) {
        _AchievementManager.setStat("dailyStreak", dailyStats.currentStreak, options);
      }
      if (dailyStats.perfectDiscards > 0) {
        _AchievementManager.setStat("dailyDiscardOptimal", dailyStats.perfectDiscards, options);
      }
      if (dailyStats.peggingWins > 0) {
        _AchievementManager.setStat("dailyPeggingCorrect", dailyStats.peggingWins, options);
      }
      const history = dailyStats.history;
      if (!history) return;
      let currentDiscardStreak = 0;
      let currentPeggingStreak = 0;
      const now = /* @__PURE__ */ new Date();
      for (let i = 0; i < 60; i++) {
        const d = new Date(now);
        d.setDate(d.getDate() - i);
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        const entry = history[key];
        if (entry && entry.discard && entry.discard.grade === "optimal") {
          currentDiscardStreak++;
        } else if (i === 0 && (!entry || !entry.discard)) {
          continue;
        } else {
          break;
        }
      }
      for (let i = 0; i < 60; i++) {
        const d = new Date(now);
        d.setDate(d.getDate() - i);
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        const entry = history[key];
        if (entry && entry.pegging && entry.pegging.isCorrect) {
          currentPeggingStreak++;
        } else if (i === 0 && (!entry || !entry.pegging)) {
          continue;
        } else {
          break;
        }
      }
      if (currentDiscardStreak > 0) {
        _AchievementManager.setStat("dailyDiscardStreak", currentDiscardStreak, options);
      }
      if (currentPeggingStreak > 0) {
        _AchievementManager.setStat("dailyPeggingStreak", currentPeggingStreak, options);
      }
    }
    /**
     * Checks if an achievement badge is already unlocked.
     * @param {string} id
     * @param {Object} [storage=null]
     * @returns {boolean}
     */
    static isUnlocked(id, storage = null) {
      const data = _AchievementManager.loadUnlocked(storage);
      return Boolean(data && data[id]);
    }
    /**
     * Unlocks an achievement badge, plays reward audio, syncs to user profile, and displays unlock toast.
     * @param {string} id
     * @param {Object} [options={}]
     * @returns {boolean} True if freshly unlocked, false if already achieved
     */
    static unlock(id, options = {}) {
      if (!id) return false;
      const badge = BADGE_DEFINITIONS.find((b) => b.id === id);
      if (!badge) return false;
      const storage = options.storage || null;
      const data = _AchievementManager.loadUnlocked(storage);
      if (data[id]) {
        return false;
      }
      data[id] = { unlockedAt: Date.now() };
      _AchievementManager.saveUnlocked(data, storage);
      try {
        const prof = typeof window !== "undefined" && window.Profile ? window.Profile.getInstance(storage) : null;
        if (prof && typeof prof.recordTrophy === "function") {
          prof.recordTrophy(id, badge.brand, storage);
        }
      } catch (_) {
      }
      const sfx3 = options.sfx || (typeof window !== "undefined" ? window.sfx : null);
      if (sfx3 && typeof sfx3.achievement === "function") {
        try {
          sfx3.achievement();
        } catch (e) {
        }
      }
      _AchievementManager.showUnlockToast(badge);
      return true;
    }
    /**
     * Displays animated unlock notification toast.
     * @param {Object} badge
     */
    static showUnlockToast(badge) {
      if (typeof document === "undefined") return;
      let toastContainer = document.getElementById("achievementToastContainer");
      if (!toastContainer) {
        toastContainer = document.createElement("div");
        toastContainer.id = "achievementToastContainer";
        toastContainer.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 100000;
        display: flex;
        flex-direction: column;
        gap: 10px;
        pointer-events: none;
      `;
        document.body.appendChild(toastContainer);
      }
      const toast = document.createElement("div");
      toast.className = "achievement-toast";
      toast.style.cssText = `
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 14px 20px;
      background: rgba(18, 14, 28, 0.94);
      border: 1.5px solid #eab308;
      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.6), 0 0 15px rgba(234, 179, 8, 0.35);
      border-radius: 12px;
      color: #f8fafc;
      font-family: inherit;
      max-width: 380px;
      backdrop-filter: blur(12px);
      transform: translateX(120%);
      opacity: 0;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.35s ease;
      pointer-events: auto;
    `;
      toast.innerHTML = `
      <div style="font-size: 2.2rem; filter: drop-shadow(0 2px 6px rgba(234, 179, 8, 0.5)); flex-shrink: 0;">
        ${badge.icon}
      </div>
      <div style="flex: 1; min-width: 0;">
        <div style="font-size: 0.72rem; font-weight: 800; letter-spacing: 0.1em; color: #facc15; text-transform: uppercase;">
          \u{1F3C6} Achievement Unlocked
        </div>
        <div style="font-size: 1.05rem; font-weight: 700; color: #ffffff; margin-top: 2px;">
          ${badge.name}
        </div>
        <div style="font-size: 0.8rem; color: #cbd5e1; margin-top: 2px; line-height: 1.3;">
          ${badge.desc}
        </div>
      </div>
    `;
      toastContainer.appendChild(toast);
      requestAnimationFrame(() => {
        toast.style.transform = "translateX(0)";
        toast.style.opacity = "1";
      });
      setTimeout(() => {
        toast.style.transform = "translateX(120%)";
        toast.style.opacity = "0";
        setTimeout(() => toast.remove(), 450);
      }, 4800);
    }
    /**
     * Returns list of all badges merged with their unlock metadata and numeric progress.
     * @param {Object} [storage=null]
     * @returns {Array<Object>}
     */
    static getAchievements(storage = null) {
      const unlocked = _AchievementManager.loadUnlocked(storage);
      const stats = _AchievementManager.getStats(storage);
      return BADGE_DEFINITIONS.map((badge) => {
        const isUn = Boolean(unlocked[badge.id]);
        const current = badge.targetStat ? stats[badge.targetStat] || 0 : null;
        const target = badge.targetVal || null;
        return {
          ...badge,
          unlocked: isUn,
          unlockedAt: unlocked[badge.id]?.unlockedAt || null,
          currentProgress: current,
          targetProgress: target
        };
      });
    }
    /**
     * Returns achievements list filtered by brand.
     * @param {string} [brand='all']
     * @param {Object} [storage=null]
     * @returns {Array<Object>}
     */
    static getBadgesByBrand(brand = "all", storage = null) {
      const list = _AchievementManager.getAchievements(storage);
      if (!brand || brand === "all") return list;
      return list.filter((b) => (b.brand || "crazy") === brand);
    }
    /**
     * Returns summary counts and badges grouped by each brand.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static getBrandSummary(storage = null) {
      const list = _AchievementManager.getAchievements(storage);
      const brands = typeof GAME_BRANDS !== "undefined" && Array.isArray(GAME_BRANDS) ? GAME_BRANDS : [
        { id: "crazy", name: "Crazy Cribbage", shortName: "Crazy", icon: "\u{1F0CF}", color: "#facc15" },
        { id: "clash", name: "Cribbage Clash", shortName: "Clash", icon: "\u2694\uFE0F", color: "#38bdf8" },
        { id: "pints", name: "Pints & Pegs", shortName: "Pints", icon: "\u{1F37A}", color: "#10b981" },
        { id: "adult", name: "Skunked & Stripped", shortName: "Adult", icon: "\u{1F9A8}", color: "#ec4899" }
      ];
      const summary = {
        overall: {
          total: list.length,
          unlocked: list.filter((b) => b.unlocked).length,
          pct: list.length > 0 ? Math.round(list.filter((b) => b.unlocked).length / list.length * 100) : 0
        }
      };
      for (const b of brands) {
        const bList = list.filter((item) => (item.brand || "crazy") === b.id);
        const bUnlocked = bList.filter((item) => item.unlocked).length;
        summary[b.id] = {
          ...b,
          badges: bList,
          total: bList.length,
          unlocked: bUnlocked,
          pct: bList.length > 0 ? Math.round(bUnlocked / bList.length * 100) : 0
        };
      }
      return summary;
    }
    /**
     * Opens the Trophy Room modal dialog with interactive brand tabs, brand sections, and progress tracking.
     * Displays the trophies for each brand clearly separated by brand.
     * @param {string} [defaultBrand='all']
     */
    static showTrophyRoomModal(defaultBrand = "all") {
      if (typeof document === "undefined") return;
      _AchievementManager.checkMilestoneBadges();
      const list = _AchievementManager.getAchievements();
      const unlockedCount = list.filter((b) => b.unlocked).length;
      const totalCount = list.length;
      const pct = Math.round(unlockedCount / totalCount * 100);
      const brands = typeof GAME_BRANDS !== "undefined" && Array.isArray(GAME_BRANDS) ? GAME_BRANDS : [
        { id: "crazy", name: "Crazy Cribbage", shortName: "Crazy", icon: "\u{1F0CF}", color: "#facc15", badgeBg: "rgba(245, 158, 11, 0.2)", border: "rgba(245, 158, 11, 0.4)" },
        { id: "clash", name: "Cribbage Clash", shortName: "Clash", icon: "\u2694\uFE0F", color: "#38bdf8", badgeBg: "rgba(56, 189, 248, 0.2)", border: "rgba(56, 189, 248, 0.4)" },
        { id: "pints", name: "Pints & Pegs", shortName: "Pints", icon: "\u{1F37A}", color: "#10b981", badgeBg: "rgba(16, 185, 129, 0.2)", border: "rgba(16, 185, 129, 0.4)" },
        { id: "adult", name: "Skunked & Stripped", shortName: "Adult", icon: "\u{1F9A8}", color: "#ec4899", badgeBg: "rgba(244, 63, 94, 0.2)", border: "rgba(244, 63, 94, 0.4)" }
      ];
      const brandStats = {};
      for (const b of brands) {
        const bList = list.filter((item) => (item.brand || "crazy") === b.id);
        const bUnlocked = bList.filter((item) => item.unlocked).length;
        brandStats[b.id] = {
          ...b,
          list: bList,
          total: bList.length,
          unlocked: bUnlocked,
          pct: bList.length > 0 ? Math.round(bUnlocked / bList.length * 100) : 0
        };
      }
      const modalId = "trophyRoomModal";
      let overlay = document.getElementById(modalId);
      if (overlay) overlay.remove();
      overlay = document.createElement("div");
      overlay.id = modalId;
      overlay.className = "modal-backdrop";
      overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.82);
      backdrop-filter: blur(8px);
      z-index: 20000000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
    `;
      const CATEGORIES = [
        { id: "all", label: `All Badges (${totalCount})` },
        { id: "tournaments", label: `\u{1F3C6} Tournaments (${list.filter((b) => b.category === "tournaments").length})` },
        { id: "daily", label: `\u{1F9E9} Daily Challenges (${list.filter((b) => b.category === "daily").length})` },
        { id: "victories", label: `\u{1F947} Victories & Skunks (${list.filter((b) => b.category === "victories").length})` },
        { id: "hands", label: `\u270B High Hands (${list.filter((b) => b.category === "hands").length})` },
        { id: "specials", label: `\u{1F0CF} Specials & Rules (${list.filter((b) => b.category === "specials").length})` }
      ];
      const rarityColors = {
        legendary: "border: 1.5px solid #f59e0b; background: rgba(245, 158, 11, 0.08);",
        epic: "border: 1.5px solid #a855f7; background: rgba(168, 85, 247, 0.08);",
        rare: "border: 1.5px solid #3b82f6; background: rgba(59, 130, 246, 0.08);",
        common: "border: 1.5px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.04);"
      };
      const lockedStyle = "border: 1.5px dashed rgba(255, 255, 255, 0.12); background: rgba(15, 12, 24, 0.4); opacity: 0.75;";
      const renderCard = (badge) => {
        const isUn = badge.unlocked;
        const bDef = brands.find((b) => b.id === (badge.brand || "crazy")) || brands[0];
        const dateStr = isUn && badge.unlockedAt ? new Date(badge.unlockedAt).toLocaleDateString(void 0, { month: "short", day: "numeric", year: "numeric" }) : null;
        const hasTarget = badge.targetProgress != null && badge.targetProgress > 0;
        const curProg = badge.currentProgress || 0;
        const tgtProg = badge.targetProgress || 1;
        const progPct = Math.min(100, Math.round(curProg / tgtProg * 100));
        return `
        <div class="trophy-badge-card" data-badge-id="${badge.id}" data-brand="${badge.brand || "crazy"}" data-category="${badge.category || "all"}" style="
          padding: 14px 16px;
          border-radius: 12px;
          display: flex;
          gap: 14px;
          align-items: flex-start;
          transition: all 0.2s ease;
          ${isUn ? rarityColors[badge.rarity] || rarityColors.common : lockedStyle}
        ">
          <div style="
            font-size: 2.2rem;
            line-height: 1;
            filter: ${isUn ? "drop-shadow(0 2px 8px rgba(234, 179, 8, 0.4))" : "grayscale(100%) opacity(35%)"};
            flex-shrink: 0;
          ">
            ${isUn ? badge.icon : "\u{1F512}"}
          </div>
          <div style="flex: 1; min-width: 0;">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap;">
              <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                <span style="font-size: 1.02rem; font-weight: 700; color: ${isUn ? "#ffffff" : "#94a3b8"};">
                  ${badge.name}
                </span>
                <span class="badge-brand-chip" style="
                  font-size: 0.68rem;
                  font-weight: 700;
                  padding: 2px 7px;
                  border-radius: 6px;
                  background: ${bDef.badgeBg};
                  color: ${bDef.color};
                  border: 1px solid ${bDef.border};
                ">
                  ${bDef.icon} ${bDef.shortName}
                </span>
              </div>
              <span style="
                font-size: 0.68rem;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 0.08em;
                padding: 2px 8px;
                border-radius: 6px;
                background: ${isUn ? "rgba(234, 179, 8, 0.2)" : "rgba(255, 255, 255, 0.08)"};
                color: ${isUn ? "#facc15" : "#64748b"};
                flex-shrink: 0;
              ">
                ${badge.rarity}
              </span>
            </div>
            <p style="font-size: 0.82rem; color: ${isUn ? "#cbd5e1" : "#64748b"}; margin: 4px 0 0; line-height: 1.35;">
              ${badge.desc}
            </p>

            ${!isUn && hasTarget ? `
              <div style="margin-top: 8px;">
                <div style="display: flex; justify-content: space-between; font-size: 0.72rem; color: #facc15; font-weight: 700; margin-bottom: 3px;">
                  <span>Progress</span>
                  <span>${curProg} / ${tgtProg} (${progPct}%)</span>
                </div>
                <div style="height: 4px; border-radius: 2px; background: rgba(255, 255, 255, 0.1); width: 100%; overflow: hidden;">
                  <div style="height: 100%; border-radius: 2px; width: ${progPct}%; background: linear-gradient(90deg, #f59e0b, #eab308); transition: width 0.3s ease;"></div>
                </div>
              </div>
            ` : ""}

            ${isUn && dateStr ? `
              <div style="font-size: 0.72rem; color: #94a3b8; margin-top: 6px; font-weight: 600;">
                \u2605 Unlocked ${dateStr}
              </div>
            ` : ""}
          </div>
        </div>
      `;
      };
      const brandSectionsHtml = brands.map((b) => {
        const bs = brandStats[b.id];
        const cardsHtml = bs.list.map(renderCard).join("");
        return `
        <div class="trophy-brand-section" data-brand-section="${b.id}" style="margin-bottom: 24px;">
          <!-- Brand Section Banner -->
          <div class="trophy-brand-banner" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 16px;
            background: ${b.badgeBg};
            border: 1.5px solid ${b.border};
            border-radius: 12px;
            margin-bottom: 12px;
            flex-wrap: wrap;
            gap: 10px;
          ">
            <div style="display: flex; align-items: center; gap: 10px;">
              <span style="font-size: 1.6rem;">${b.icon}</span>
              <div>
                <div style="font-size: 1.12rem; font-weight: 800; color: ${b.color};">${b.name} Trophies</div>
                <div style="font-size: 0.74rem; color: #cbd5e1;">${bs.total} Trophies Available</div>
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 10px;">
              <div style="text-align: right;">
                <div style="font-size: 0.9rem; font-weight: 800; color: #facc15;">
                  ${bs.unlocked} of ${bs.total} Unlocked
                </div>
                <div style="font-size: 0.72rem; color: #94a3b8;">${bs.pct}% Complete</div>
              </div>
              <div style="width: 76px; height: 7px; background: rgba(255, 255, 255, 0.12); border-radius: 4px; overflow: hidden;">
                <div style="width: ${bs.pct}%; height: 100%; background: ${b.color}; border-radius: 4px; transition: width 0.3s ease;"></div>
              </div>
            </div>
          </div>

          <!-- Cards List for this Brand -->
          <div class="trophy-brand-cards" style="display: flex; flex-direction: column; gap: 10px;">
            ${cardsHtml}
          </div>
        </div>
      `;
      }).join("");
      const brandTabsHtml = `
      <button type="button" class="trophy-brand-tab ${defaultBrand === "all" ? "active" : ""}" data-brand="all" style="
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 7px 16px;
        font-size: 0.84rem;
        font-weight: 700;
        border-radius: 20px;
        cursor: pointer;
        border: 1.5px solid ${defaultBrand === "all" ? "#facc15" : "rgba(255, 255, 255, 0.15)"};
        background: ${defaultBrand === "all" ? "rgba(234, 179, 8, 0.25)" : "rgba(255, 255, 255, 0.05)"};
        color: ${defaultBrand === "all" ? "#facc15" : "#cbd5e1"};
        white-space: nowrap;
        flex-shrink: 0;
        min-height: 34px;
        box-sizing: border-box;
        transition: all 0.15s ease;
      ">
        <span>\u{1F310} All Brands (${unlockedCount}/${totalCount})</span>
      </button>
      ${brands.map((b) => {
        const bs = brandStats[b.id];
        const isAct = defaultBrand === b.id;
        return `
          <button type="button" class="trophy-brand-tab ${isAct ? "active" : ""}" data-brand="${b.id}" style="
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 7px 16px;
            font-size: 0.84rem;
            font-weight: 700;
            border-radius: 20px;
            cursor: pointer;
            border: 1.5px solid ${isAct ? b.color : "rgba(255, 255, 255, 0.15)"};
            background: ${isAct ? b.badgeBg : "rgba(255, 255, 255, 0.05)"};
            color: ${isAct ? b.color : "#cbd5e1"};
            white-space: nowrap;
            flex-shrink: 0;
            min-height: 34px;
            box-sizing: border-box;
            transition: all 0.15s ease;
          ">
            <span>${b.icon} ${b.shortName} (${bs.unlocked}/${bs.total})</span>
          </button>
        `;
      }).join("")}
    `;
      const categoryTabsHtml = CATEGORIES.map((cat, idx) => `
      <button type="button" class="trophy-category-tab ${idx === 0 ? "active" : ""}" data-cat="${cat.id}" style="
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 5px 12px;
        font-size: 0.78rem;
        font-weight: 600;
        border-radius: 16px;
        cursor: pointer;
        border: 1px solid ${idx === 0 ? "#facc15" : "rgba(255, 255, 255, 0.12)"};
        background: ${idx === 0 ? "rgba(234, 179, 8, 0.18)" : "rgba(255, 255, 255, 0.03)"};
        color: ${idx === 0 ? "#facc15" : "#94a3b8"};
        white-space: nowrap;
        flex-shrink: 0;
        min-height: 28px;
        box-sizing: border-box;
        transition: all 0.15s ease;
      ">
        ${cat.label}
      </button>
    `).join("");
      overlay.innerHTML = `
      <div style="
        background: linear-gradient(145deg, #181424, #0f0c18);
        border: 1px solid rgba(212, 160, 23, 0.35);
        border-radius: 16px;
        max-width: 860px;
        width: 100%;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.85), 0 0 35px rgba(212, 160, 23, 0.18);
        color: #f8fafc;
        overflow: hidden;
      ">
        <!-- Header -->
        <div style="padding: 16px 24px; border-bottom: 1px solid rgba(255, 255, 255, 0.1); display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px; flex-shrink: 0;">
          <div>
            <h2 style="margin: 0; font-size: 1.4rem; font-weight: 800; color: #facc15; display: flex; align-items: center; gap: 8px;">
              \u{1F3C6} Trophy Room &amp; Hall of Fame
            </h2>
            <p style="margin: 4px 0 0; font-size: 0.85rem; color: #94a3b8;">
              ${unlockedCount} of ${totalCount} Badges Unlocked (${pct}%) \xB7 Separated by Game Brand
            </p>
          </div>
          <button id="btnCloseTrophyRoom" style="
            background: rgba(255, 255, 255, 0.08);
            border: 1px solid rgba(255, 255, 255, 0.15);
            color: #ffffff;
            font-size: 1.2rem;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          ">\u2715</button>
        </div>

        <!-- Progress bar -->
        <div style="height: 4px; background: rgba(255, 255, 255, 0.08); width: 100%; flex-shrink: 0;">
          <div style="height: 100%; width: ${pct}%; background: linear-gradient(90deg, #f59e0b, #eab308); transition: width 0.3s ease;"></div>
        </div>

        <style>
          .trophy-brand-tabs-row {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 8px 10px !important;
            padding: 12px 24px 8px !important;
            flex-shrink: 0 !important;
            min-height: 52px !important;
            box-sizing: border-box !important;
            background: rgba(0, 0, 0, 0.35) !important;
            align-items: center !important;
          }
          .trophy-category-tabs-row {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 6px 8px !important;
            padding: 6px 24px 10px !important;
            flex-shrink: 0 !important;
            box-sizing: border-box !important;
            background: rgba(0, 0, 0, 0.35) !important;
            border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
            align-items: center !important;
          }
          #trophyBadgesList::-webkit-scrollbar,
          .trophy-brand-tabs-row::-webkit-scrollbar {
            width: 10px;
            height: 8px;
          }
          #trophyBadgesList::-webkit-scrollbar-track,
          .trophy-brand-tabs-row::-webkit-scrollbar-track {
            background: rgba(0, 0, 0, 0.35);
            border-radius: 8px;
            margin: 4px;
            box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.6);
          }
          #trophyBadgesList::-webkit-scrollbar-thumb,
          .trophy-brand-tabs-row::-webkit-scrollbar-thumb {
            background: linear-gradient(180deg, #ffe680 0%, #f0c64a 50%, #c99718 100%);
            border-radius: 8px;
            border: 2px solid #1a1528;
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4), 0 2px 5px rgba(0, 0, 0, 0.5);
            transition: background 0.15s ease, box-shadow 0.15s ease;
          }
          #trophyBadgesList::-webkit-scrollbar-thumb:hover,
          .trophy-brand-tabs-row::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(180deg, #fff3a8 0%, #ffd700 50%, #e0aa1b 100%);
            box-shadow: 0 0 10px rgba(240, 198, 74, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.6);
          }
        </style>

        <!-- Brand Tabs Navigation (Separated by Brand) -->
        <div class="trophy-brand-tabs-row">
          ${brandTabsHtml}
        </div>

        <!-- Secondary Category Filter Tabs -->
        <div class="trophy-category-tabs-row">
          ${categoryTabsHtml}
        </div>

        <!-- Badges Grid/List (Grouped into Brand Sections) -->
        <div id="trophyBadgesList" class="trophy-badges-list" style="
          padding: 18px 24px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          flex: 1;
          scrollbar-width: thin;
          scrollbar-color: #f0c64a rgba(0, 0, 0, 0.35);
        ">
          ${brandSectionsHtml}
        </div>

        <!-- Footer -->
        <div style="padding: 14px 24px; border-top: 1px solid rgba(255, 255, 255, 0.1); display: flex; justify-content: flex-end; background: rgba(0, 0, 0, 0.25);">
          <button id="btnCloseTrophyRoomBottom" class="btn-gold" style="padding: 8px 24px; font-weight: 700; border-radius: 8px; cursor: pointer;">
            Close
          </button>
        </div>
      </div>
    `;
      document.body.appendChild(overlay);
      let activeBrandFilter = defaultBrand || "all";
      let activeCategoryFilter = "all";
      const brandTabs = overlay.querySelectorAll(".trophy-brand-tab");
      const categoryTabs = overlay.querySelectorAll(".trophy-category-tab");
      const brandSections = overlay.querySelectorAll(".trophy-brand-section");
      const badgeCards = overlay.querySelectorAll(".trophy-badge-card");
      const updateFilterVisibility = () => {
        brandSections.forEach((sec) => {
          const secBrand = sec.getAttribute("data-brand-section");
          const isBrandMatch = activeBrandFilter === "all" || secBrand === activeBrandFilter;
          if (isBrandMatch) {
            sec.style.display = "block";
          } else {
            sec.style.display = "none";
          }
        });
        badgeCards.forEach((card) => {
          const cardCat = card.getAttribute("data-category");
          const cardBrand = card.getAttribute("data-brand");
          const isBrandMatch = activeBrandFilter === "all" || cardBrand === activeBrandFilter;
          const isCatMatch = activeCategoryFilter === "all" || cardCat === activeCategoryFilter;
          if (isBrandMatch && isCatMatch) {
            card.style.display = "flex";
          } else {
            card.style.display = "none";
          }
        });
      };
      brandTabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const targetBrand = tab.getAttribute("data-brand");
          activeBrandFilter = targetBrand;
          brandTabs.forEach((t) => {
            t.style.border = "1.5px solid rgba(255, 255, 255, 0.15)";
            t.style.background = "rgba(255, 255, 255, 0.05)";
            t.style.color = "#cbd5e1";
            t.classList.remove("active");
          });
          const bDef = brands.find((b) => b.id === targetBrand);
          tab.style.border = `1.5px solid ${bDef ? bDef.color : "#facc15"}`;
          tab.style.background = bDef ? bDef.badgeBg : "rgba(234, 179, 8, 0.25)";
          tab.style.color = bDef ? bDef.color : "#facc15";
          tab.classList.add("active");
          updateFilterVisibility();
        });
      });
      categoryTabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          activeCategoryFilter = tab.getAttribute("data-cat");
          categoryTabs.forEach((t) => {
            t.style.border = "1px solid rgba(255, 255, 255, 0.12)";
            t.style.background = "rgba(255, 255, 255, 0.03)";
            t.style.color = "#94a3b8";
            t.classList.remove("active");
          });
          tab.style.border = "1px solid #facc15";
          tab.style.background = "rgba(234, 179, 8, 0.18)";
          tab.style.color = "#facc15";
          tab.classList.add("active");
          updateFilterVisibility();
        });
      });
      if (defaultBrand && defaultBrand !== "all") {
        updateFilterVisibility();
      }
      const closeFn = () => overlay.remove();
      const btnX = overlay.querySelector("#btnCloseTrophyRoom");
      const btnBottom = overlay.querySelector("#btnCloseTrophyRoomBottom");
      if (btnX) btnX.onclick = closeFn;
      if (btnBottom) btnBottom.onclick = closeFn;
      overlay.onclick = (e) => {
        if (e.target === overlay) closeFn();
      };
    }
  };

  // src/ui/CelebrationFX.js
  var CelebrationFX = class _CelebrationFX {
    /**
     * Triggers a screen radial vignette pulse flash.
     * @param {'gold'|'skunk'|'royal'|'legendary'} [type='gold']
     * @param {number} [duration=1200] Duration in milliseconds
     */
    static pulseScreen(type = "gold", duration = 1200) {
      if (typeof document === "undefined") return;
      let overlay = document.getElementById("celebrationPulseOverlay");
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = "celebrationPulseOverlay";
        overlay.style.cssText = `
        position: fixed;
        inset: 0;
        pointer-events: none;
        z-index: 9998;
        opacity: 0;
        transition: opacity 0.25s ease-out;
      `;
        document.body.appendChild(overlay);
      }
      let gradient = "radial-gradient(circle at center, rgba(255, 215, 0, 0.28) 0%, rgba(212, 160, 23, 0.45) 60%, rgba(122, 85, 0, 0.6) 100%)";
      if (type === "skunk") {
        gradient = "radial-gradient(circle at center, rgba(148, 163, 184, 0.25) 0%, rgba(71, 85, 105, 0.45) 60%, rgba(15, 23, 42, 0.75) 100%)";
      } else if (type === "royal" || type === "legendary") {
        gradient = "radial-gradient(circle at center, rgba(254, 240, 138, 0.35) 0%, rgba(234, 179, 8, 0.45) 45%, rgba(168, 85, 247, 0.4) 75%, rgba(88, 28, 135, 0.65) 100%)";
      }
      overlay.style.background = gradient;
      overlay.style.opacity = "1";
      setTimeout(() => {
        if (overlay) {
          overlay.style.transition = `opacity ${Math.max(0.3, (duration - 300) / 1e3)}s ease-out`;
          overlay.style.opacity = "0";
        }
      }, 280);
    }
    /**
     * Launches dynamic particle confetti cannons.
     * @param {Object} [options={}]
     * @param {number} [options.count=80] Number of confetti pieces
     * @param {Array<string>} [options.colors] Array of hex/rgb color strings
     * @param {number} [options.duration=3200] Lifespan in ms
     * @param {boolean} [options.sound=true] Whether to trigger audio pop
     * @param {AudioManager} [options.sfx] Optional AudioManager instance
     */
    static launchConfetti(options = {}) {
      if (typeof window === "undefined" || typeof document === "undefined") return;
      const count = options.count || 85;
      const colors = options.colors || [
        "#ffd700",
        // Metallic Gold
        "#f59e0b",
        // Amber
        "#ef4444",
        // Ruby Red
        "#3b82f6",
        // Sapphire Blue
        "#10b981",
        // Emerald Green
        "#ec4899",
        // Crimson Pink
        "#a855f7",
        // Regal Purple
        "#f8fafc"
        // Sterling Silver
      ];
      const duration = options.duration || 3400;
      if (options.sound !== false) {
        const sfx3 = options.sfx || window.sfx;
        if (sfx3 && typeof sfx3.confettiPop === "function") {
          sfx3.confettiPop();
        }
      }
      const canvas = document.createElement("canvas");
      canvas.id = "celebrationConfettiCanvas";
      canvas.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      pointer-events: none;
      z-index: 9999;
    `;
      document.body.appendChild(canvas);
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        canvas.remove();
        return;
      }
      const dpr = window.devicePixelRatio || 1;
      let width = canvas.width = window.innerWidth * dpr;
      let height = canvas.height = window.innerHeight * dpr;
      const particles = [];
      for (let i = 0; i < count; i++) {
        const fromLeft = i % 2 === 0;
        const startX = fromLeft ? width * 0.15 : width * 0.85;
        const startY = height * 0.85;
        const angle = fromLeft ? -Math.PI * 0.25 - Math.random() * 0.45 : -Math.PI * 0.75 + Math.random() * 0.45;
        const speed = (width * 0.012 + Math.random() * (width * 0.018)) * (0.8 + Math.random() * 0.5);
        particles.push({
          x: startX,
          y: startY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          w: (8 + Math.random() * 10) * dpr,
          h: (4 + Math.random() * 6) * dpr,
          color: colors[Math.floor(Math.random() * colors.length)],
          rotation: Math.random() * Math.PI * 2,
          rSpeed: Math.random() * 0.2 - 0.1,
          tilt: Math.random() * Math.PI,
          tSpeed: 0.08 + Math.random() * 0.12,
          gravity: 0.32 * dpr,
          drag: 0.982,
          opacity: 1
        });
      }
      let animId = null;
      const startTime = performance.now();
      function render2(now) {
        const elapsed = now - startTime;
        const progress = elapsed / duration;
        if (progress >= 1) {
          if (animId) cancelAnimationFrame(animId);
          canvas.remove();
          return;
        }
        ctx.clearRect(0, 0, width, height);
        particles.forEach((p) => {
          p.vx *= p.drag;
          p.vy = p.vy * p.drag + p.gravity;
          p.x += p.vx;
          p.y += p.vy;
          p.rotation += p.rSpeed;
          p.tilt += p.tSpeed;
          if (progress > 0.7) {
            p.opacity = Math.max(0, 1 - (progress - 0.7) / 0.3);
          }
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rotation);
          ctx.scale(1, Math.sin(p.tilt));
          ctx.globalAlpha = p.opacity;
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        });
        animId = requestAnimationFrame(render2);
      }
      animId = requestAnimationFrame(render2);
    }
    /**
     * Triggers grand celebration fanfare and FX on high-scoring events.
     * @param {number} score
     * @param {Object} [deps={}]
     */
    static triggerCelebration(score, deps = {}) {
      const sfx3 = deps.sfx || (typeof window !== "undefined" ? window.sfx : null);
      if (score === 29) {
        _CelebrationFX.pulseScreen("legendary", 2400);
        _CelebrationFX.launchConfetti({
          count: 140,
          colors: ["#ffd700", "#f59e0b", "#ef4444", "#3b82f6", "#10b981", "#ffffff", "#a855f7"],
          duration: 4200,
          sfx: sfx3
        });
        if (sfx3 && typeof sfx3.fanfare29 === "function") {
          sfx3.fanfare29();
        }
      } else if (score >= 20) {
        _CelebrationFX.pulseScreen("gold", 1600);
        _CelebrationFX.launchConfetti({
          count: 85,
          colors: ["#ffd700", "#f59e0b", "#ef4444", "#3b82f6", "#ffffff"],
          duration: 3200,
          sfx: sfx3
        });
        if (sfx3 && typeof sfx3.fanfare20 === "function") {
          sfx3.fanfare20();
        }
      }
    }
  };

  // src/series/SeriesTracker.js
  var SERIES_MODES = {
    NONE: "none",
    UNLIMITED: "unlimited",
    BO3: "bo3",
    BO5: "bo5",
    BO7: "bo7"
  };
  var SERIES_TARGET_WINS = {
    none: 1,
    unlimited: Infinity,
    bo3: 2,
    bo5: 3,
    bo7: 4
  };
  var SeriesTracker = class _SeriesTracker {
    static STORAGE_KEY = "crazyCribbage.seriesTracker";
    /**
     * Loads the current series tracking state from storage.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static getSeriesState(storage = null) {
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) {
        return _SeriesTracker.getDefaultState();
      }
      try {
        const raw = s.getItem(_SeriesTracker.STORAGE_KEY);
        if (raw) {
          const data = JSON.parse(raw);
          if (data && typeof data === "object") return data;
        }
      } catch (e) {
      }
      return _SeriesTracker.getDefaultState();
    }
    /**
     * Returns default initial state for a new series.
     * @param {string} [mode='bo3']
     * @returns {Object}
     */
    static getDefaultState(mode = "bo3") {
      return {
        mode,
        gamesPlayed: 0,
        wins: { p1: 0, p2: 0 },
        skunks: { p1: 0, p2: 0 },
        // skunks inflicted by seat
        doubleSkunks: { p1: 0, p2: 0 },
        history: [],
        lastDealer: null,
        champion: null
      };
    }
    /**
     * Saves series state to storage.
     * @param {Object} state
     * @param {Object} [storage=null]
     */
    static saveSeriesState(state3, storage = null) {
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) return;
      try {
        s.setItem(_SeriesTracker.STORAGE_KEY, JSON.stringify(state3));
      } catch (e) {
      }
    }
    /**
     * Sets the series format (e.g. 'bo3', 'bo5', 'unlimited') and resets counts if mode changed.
     * @param {string} mode
     */
    static setMode(mode) {
      const cur = _SeriesTracker.getSeriesState();
      if (cur.mode !== mode) {
        const fresh = _SeriesTracker.getDefaultState(mode);
        _SeriesTracker.saveSeriesState(fresh);
        _SeriesTracker.updateSeriesUi();
      }
    }
    /**
     * Records the completion of a game in the series.
     * @param {Object} gameResult
     * @param {string} gameResult.winner Winning seat ('p1', 'p2', 'you', 'cpu')
     * @param {string} [gameResult.winnerName]
     * @param {number} [gameResult.p1Score=0]
     * @param {number} [gameResult.p2Score=0]
     * @param {string} [gameResult.skunkKind] 'skunk' | 'double_skunk' | null
     * @param {string} [gameResult.openingDealer]
     * @returns {Object} Updated series state and status
     */
    static recordGame(gameResult = {}) {
      const state3 = _SeriesTracker.getSeriesState();
      state3.gamesPlayed = (state3.gamesPlayed || 0) + 1;
      let winKey = "p1";
      if (gameResult.winner === "p2" || gameResult.winner === "cpu") {
        winKey = "p2";
      } else if (gameResult.winner === "p1" || gameResult.winner === "you") {
        winKey = "p1";
      }
      state3.wins[winKey] = (state3.wins[winKey] || 0) + 1;
      if (gameResult.skunkKind === "skunk") {
        state3.skunks[winKey] = (state3.skunks[winKey] || 0) + 1;
      } else if (gameResult.skunkKind === "double_skunk") {
        state3.doubleSkunks[winKey] = (state3.doubleSkunks[winKey] || 0) + 1;
      }
      state3.lastDealer = gameResult.openingDealer || state3.lastDealer;
      state3.history.push({
        gameNumber: state3.gamesPlayed,
        winner: winKey,
        winnerName: gameResult.winnerName || winKey,
        p1Score: gameResult.p1Score || 0,
        p2Score: gameResult.p2Score || 0,
        skunkKind: gameResult.skunkKind || null,
        timestamp: Date.now()
      });
      const targetWins = SERIES_TARGET_WINS[state3.mode] || Infinity;
      if (state3.wins[winKey] >= targetWins) {
        state3.champion = winKey;
      }
      _SeriesTracker.saveSeriesState(state3);
      _SeriesTracker.updateSeriesUi();
      return {
        state: state3,
        isComplete: Boolean(state3.champion),
        champion: state3.champion
      };
    }
    /**
     * Resets the current series for a fresh start.
     * @param {string} [mode]
     */
    static resetSeries(mode) {
      const cur = _SeriesTracker.getSeriesState();
      const newMode = mode || cur.mode || "bo3";
      const fresh = _SeriesTracker.getDefaultState(newMode);
      _SeriesTracker.saveSeriesState(fresh);
      _SeriesTracker.updateSeriesUi();
      return fresh;
    }
    /**
     * Returns the next fair opening dealer for a rematch, alternating from previous game.
     * @param {string} [currentDealer]
     * @returns {string} 'p1' or 'p2'
     */
    static getNextOpeningDealer(currentDealer) {
      const state3 = _SeriesTracker.getSeriesState();
      const prev = currentDealer || state3.lastDealer || "p1";
      return prev === "p1" || prev === "you" ? "p2" : "p1";
    }
    /**
     * Builds series standing HTML summary for the end-of-game modal.
     * @param {Object} options
     * @returns {string}
     */
    static buildModalSummary(options = {}) {
      const state3 = _SeriesTracker.getSeriesState();
      const pCount = typeof window !== "undefined" && window.settings && window.settings.playerCount || 2;
      if (!state3 || state3.mode === "none" || pCount > 2) return "";
      const p1Name = options.p1Name || "You";
      const p2Name = options.p2Name || "Computer";
      const p1Wins = state3.wins.p1 || 0;
      const p2Wins = state3.wins.p2 || 0;
      const targetWins = SERIES_TARGET_WINS[state3.mode] || Infinity;
      const modeLabel = state3.mode === "bo3" ? "Best of 3" : state3.mode === "bo5" ? "Best of 5" : state3.mode === "bo7" ? "Best of 7" : "Series";
      const isChampion = Boolean(state3.champion);
      const champName = state3.champion === "p1" ? p1Name : p2Name;
      return `
      <div class="series-modal-card" style="margin: 14px 0; padding: 12px 16px; background: rgba(0,0,0,0.45); border: 1px solid rgba(240,198,74,0.35); border-radius: 10px; text-align: center;">
        <div style="font-size: 0.8rem; font-weight: 700; color: #f0c64a; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 6px;">
          \u2694\uFE0F ${modeLabel} Series Tracker
        </div>
        <div style="display: flex; justify-content: center; align-items: center; gap: 16px; margin: 8px 0;">
          <div style="text-align: right; flex: 1;">
            <div style="font-size: 0.95rem; font-weight: 700; color: ${p1Wins > p2Wins ? "#f0c64a" : "#f4ead4"};">${p1Name}</div>
            <div style="font-size: 1.6rem; font-weight: 900; color: #f0c64a; line-height: 1.1;">${p1Wins}</div>
          </div>
          <div style="font-size: 1.2rem; font-weight: 800; color: rgba(244,234,212,0.4);">-</div>
          <div style="text-align: left; flex: 1;">
            <div style="font-size: 0.95rem; font-weight: 700; color: ${p2Wins > p1Wins ? "#f0c64a" : "#f4ead4"};">${p2Name}</div>
            <div style="font-size: 1.6rem; font-weight: 900; color: #f0c64a; line-height: 1.1;">${p2Wins}</div>
          </div>
        </div>
        ${isChampion ? `
          <div style="margin-top: 8px; font-size: 0.95rem; font-weight: 800; color: #34d399; background: rgba(52,211,153,0.15); padding: 6px 12px; border-radius: 6px; border: 1px solid rgba(52,211,153,0.3);">
            \u{1F451} ${champName} wins the ${modeLabel} Series!
          </div>
        ` : `
          <div style="margin-top: 6px; font-size: 0.82rem; color: #d6d3d1;">
            Game ${state3.gamesPlayed} completed \xB7 First to ${targetWins} wins takes the match
          </div>
        `}
      </div>
    `;
    }
    /**
     * Updates or injects the series tracker HUD pill near the board / score chips.
     */
    static updateSeriesUi() {
      if (typeof document === "undefined") return;
      let pill = document.getElementById("seriesHudPill");
      if (!pill) {
        const topChips = document.getElementById("boardTopChips");
        if (!topChips) return;
        pill = document.createElement("div");
        pill.id = "seriesHudPill";
        pill.className = "series-hud-pill";
        pill.title = "Current match series standings";
        topChips.appendChild(pill);
      }
      const state3 = _SeriesTracker.getSeriesState();
      const pCount = typeof window !== "undefined" && window.settings && window.settings.playerCount || 2;
      if (state3.mode === "none" || pCount > 2) {
        pill.style.display = "none";
        return;
      }
      pill.style.display = "inline-flex";
      const modeLabel = state3.mode === "bo3" ? "Bo3" : state3.mode === "bo5" ? "Bo5" : state3.mode === "bo7" ? "Bo7" : "Match";
      pill.innerHTML = `
      <span class="series-pill-icon">\u2694\uFE0F</span>
      <span class="series-pill-mode">${modeLabel}</span>
      <span class="series-pill-score">${state3.wins.p1 || 0} - ${state3.wins.p2 || 0}</span>
    `;
    }
  };

  // src/series/TournamentManager.js
  var TOURNAMENT_FORMATS = {
    SINGLE_ELIM: "single",
    DOUBLE_ELIM: "double"
  };
  var TOURNAMENT_SERIES_MODES = {
    BO1: "bo1",
    BO3: "bo3",
    BO5: "bo5"
  };
  var TOURNAMENT_TARGET_WINS = {
    bo1: 1,
    bo3: 2,
    bo5: 3
  };
  var DEFAULT_AVATARS = ["\u{1F451}", "\u{1F0CF}", "\u{1F37A}", "\u26A1", "\u{1F3C6}", "\u{1F3AF}", "\u{1F525}", "\u{1F3B2}"];
  var PRESET_PLAYERS_8 = [
    { id: "p1", name: "Player 1 (You)", type: "human", cpuProfile: "shark", avatar: "\u{1F451}", seed: 1 },
    { id: "p2", name: "The Shark", type: "cpu", cpuProfile: "shark", avatar: "\u{1F988}", seed: 2 },
    { id: "p3", name: "The Gambler", type: "cpu", cpuProfile: "gambler", avatar: "\u{1F3B2}", seed: 3 },
    { id: "p4", name: "The Turtler", type: "cpu", cpuProfile: "turtler", avatar: "\u{1F422}", seed: 4 },
    { id: "p5", name: "Pub Master Dave", type: "human", cpuProfile: "gambler", avatar: "\u{1F37A}", seed: 5 },
    { id: "p6", name: "Lucky Sarah", type: "human", cpuProfile: "shark", avatar: "\u26A1", seed: 6 },
    { id: "p7", name: "Peggin Pete", type: "cpu", cpuProfile: "gambler", avatar: "\u{1F3AF}", seed: 7 },
    { id: "p8", name: "Cribbage Chris", type: "cpu", cpuProfile: "turtler", avatar: "\u{1F525}", seed: 8 }
  ];
  var TournamentManager = class _TournamentManager {
    static STORAGE_KEY = "crazyCribbage.tournamentState";
    static HISTORY_KEY = "crazyCribbage.tournamentHistory";
    static SETUP_SETTINGS_KEY = "crazyCribbage.tournamentSetupSettings";
    static _lastState = null;
    /**
     * Retrieves active tournament state from storage.
     * @param {Object} [storage=null]
     * @returns {Object|null}
     */
    static getTournamentState(storage = null) {
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) return _TournamentManager._lastState || null;
      try {
        const raw = s.getItem(_TournamentManager.STORAGE_KEY);
        if (raw) {
          const data = JSON.parse(raw);
          if (data && typeof data === "object") return data;
        }
      } catch (e) {
        console.warn("[TournamentManager] Failed to load state:", e);
      }
      return _TournamentManager._lastState || null;
    }
    /**
     * Saves tournament state to storage and updates UI if active.
     * @param {Object|null} state
     * @param {Object} [storage=null]
     */
    static saveTournamentState(state3, storage = null) {
      _TournamentManager._lastState = state3;
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) return;
      try {
        if (state3 === null) {
          s.removeItem(_TournamentManager.STORAGE_KEY);
        } else {
          s.setItem(_TournamentManager.STORAGE_KEY, JSON.stringify(state3));
        }
      } catch (e) {
        console.warn("[TournamentManager] Failed to save state:", e);
      }
    }
    /**
     * Retrieves remembered setup preferences (title, format, seriesMode, playerCount, roster).
     * @param {Object} [storage=null]
     * @returns {Object|null}
     */
    static getSavedSetupSettings(storage = null) {
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) return null;
      try {
        const raw = s.getItem(_TournamentManager.SETUP_SETTINGS_KEY);
        if (raw) {
          const data = JSON.parse(raw);
          if (data && typeof data === "object") return data;
        }
      } catch (e) {
        console.warn("[TournamentManager] Failed to load setup settings:", e);
      }
      return null;
    }
    /**
     * Saves tournament setup preferences for future mini-tournaments.
     * @param {Object} settings
     * @param {Object} [storage=null]
     */
    static saveSetupSettings(settings3, storage = null) {
      if (!settings3 || typeof settings3 !== "object") return;
      const s = storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (!s) return;
      try {
        s.setItem(_TournamentManager.SETUP_SETTINGS_KEY, JSON.stringify(settings3));
      } catch (e) {
        console.warn("[TournamentManager] Failed to save setup settings:", e);
      }
    }
    /**
     * Creates and initializes a new 4-8 player tournament.
     * @param {Object} options
     * @param {string} [options.title='Crazy Cribbage Table Championship']
     * @param {string} [options.format='single'] 'single' | 'double'
     * @param {string} [options.seriesMode='bo3'] 'bo1' | 'bo3' | 'bo5'
     * @param {number} [options.playerCount=4] 4 to 8
     * @param {Array<Object>} [options.players] Array of participant objects
     * @param {string} [options.brand='crazy']
     * @param {number} [options.targetPoints=121]
     * @returns {Object} Newly created tournament state
     */
    static createTournament(options = {}, storage = null) {
      const s = storage || options.storage || null;
      const playerCount = Math.max(4, Math.min(8, Number(options.playerCount) || 4));
      const format = options.format === TOURNAMENT_FORMATS.DOUBLE_ELIM ? TOURNAMENT_FORMATS.DOUBLE_ELIM : TOURNAMENT_FORMATS.SINGLE_ELIM;
      const seriesMode = options.seriesMode || TOURNAMENT_SERIES_MODES.BO3;
      const targetWins = TOURNAMENT_TARGET_WINS[seriesMode] || 2;
      const title = (options.title || "Table Championship").trim();
      const brand = options.brand || "crazy";
      const targetPoints = options.targetPoints || 121;
      let players = [];
      if (Array.isArray(options.players) && options.players.length >= playerCount) {
        players = options.players.slice(0, playerCount).map((p, idx) => ({
          id: p.id || `p${idx + 1}`,
          name: (p.name || `Player ${idx + 1}`).trim(),
          type: p.type || (idx === 0 ? "human" : "cpu"),
          cpuProfile: p.cpuProfile || "shark",
          avatar: p.avatar || DEFAULT_AVATARS[idx % DEFAULT_AVATARS.length],
          seed: Number(p.seed) || idx + 1,
          peerId: p.peerId || null
        }));
      } else {
        players = PRESET_PLAYERS_8.slice(0, playerCount).map((p, idx) => ({
          ...p,
          seed: idx + 1
        }));
      }
      players.sort((a, b) => a.seed - b.seed);
      const matches = format === TOURNAMENT_FORMATS.DOUBLE_ELIM ? _TournamentManager._buildDoubleElimBracket(players, targetWins) : _TournamentManager._buildSingleElimBracket(players, targetWins);
      const state3 = {
        id: "tourney_" + Date.now(),
        title,
        format,
        seriesMode,
        targetWins,
        playerCount,
        players,
        matches,
        activeMatchId: null,
        champion: null,
        podium: { first: null, second: null, third: null },
        createdAt: Date.now(),
        updatedAt: Date.now(),
        brand,
        targetPoints,
        isComplete: false
      };
      _TournamentManager._autoAdvanceByes(state3);
      _TournamentManager._updateMatchStatuses(state3);
      const firstReady = Object.values(state3.matches).find((m) => m.status === "ready");
      if (firstReady) {
        state3.activeMatchId = firstReady.id;
      }
      _TournamentManager.saveTournamentState(state3, s);
      return state3;
    }
    /**
     * Builds single elimination bracket tree.
     * Bracket size is 4 or 8.
     * For 5, 6, 7 players, slots are padded with BYE virtual players.
     * Standard seeding pairings:
     * 4-player: (1 vs 4), (2 vs 3) -> Finals
     * 8-player: (1 vs 8), (4 vs 5), (2 vs 7), (3 vs 6) -> Semis -> Finals
     */
    static _buildSingleElimBracket(players, targetWins) {
      const n = players.length;
      const bracketSize = n <= 4 ? 4 : 8;
      const matches = {};
      if (bracketSize === 4) {
        const p1 = players[0] || null;
        const p2 = players[1] || null;
        const p3 = players[2] || null;
        const p4 = players[3] || null;
        matches["m_semi_1"] = {
          id: "m_semi_1",
          bracket: "winners",
          round: 1,
          roundLabel: "Semifinals",
          player1Id: p1 ? p1.id : null,
          player2Id: p4 ? p4.id : null,
          wins: { [p1 ? p1.id : "p1"]: 0, [p4 ? p4.id : "p4"]: 0 },
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "ready",
          nextMatchId: "m_finals",
          nextMatchSlot: 1,
          loserNextMatchId: "m_bronze",
          loserNextMatchSlot: 1
        };
        matches["m_semi_2"] = {
          id: "m_semi_2",
          bracket: "winners",
          round: 1,
          roundLabel: "Semifinals",
          player1Id: p2 ? p2.id : null,
          player2Id: p3 ? p3.id : null,
          wins: { [p2 ? p2.id : "p2"]: 0, [p3 ? p3.id : "p3"]: 0 },
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "ready",
          nextMatchId: "m_finals",
          nextMatchSlot: 2,
          loserNextMatchId: "m_bronze",
          loserNextMatchSlot: 2
        };
        matches["m_bronze"] = {
          id: "m_bronze",
          bracket: "consolation",
          round: 2,
          roundLabel: "3rd Place Playoff",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: null
        };
        matches["m_finals"] = {
          id: "m_finals",
          bracket: "winners",
          round: 2,
          roundLabel: "Championship Finals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: null
        };
      } else {
        const seedPairings = [
          [1, 8],
          [4, 5],
          [2, 7],
          [3, 6]
        ];
        const getPlayerBySeed = (seedNum) => players.find((p) => p.seed === seedNum) || null;
        for (let i = 0; i < 4; i++) {
          const [s1, s2] = seedPairings[i];
          const pA = getPlayerBySeed(s1);
          const pB = getPlayerBySeed(s2);
          matches[`m_qf_${i + 1}`] = {
            id: `m_qf_${i + 1}`,
            bracket: "winners",
            round: 1,
            roundLabel: "Quarterfinals",
            player1Id: pA ? pA.id : null,
            player2Id: pB ? pB.id : null,
            wins: {
              [pA ? pA.id : "pA"]: 0,
              [pB ? pB.id : "pB"]: 0
            },
            games: [],
            targetWins,
            winnerId: null,
            loserId: null,
            status: pA && pB ? "ready" : pA && !pB ? "bye" : "pending",
            nextMatchId: i < 2 ? "m_semi_1" : "m_semi_2",
            nextMatchSlot: i % 2 + 1
          };
        }
        matches["m_semi_1"] = {
          id: "m_semi_1",
          bracket: "winners",
          round: 2,
          roundLabel: "Semifinals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_finals",
          nextMatchSlot: 1,
          loserNextMatchId: "m_bronze",
          loserNextMatchSlot: 1
        };
        matches["m_semi_2"] = {
          id: "m_semi_2",
          bracket: "winners",
          round: 2,
          roundLabel: "Semifinals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_finals",
          nextMatchSlot: 2,
          loserNextMatchId: "m_bronze",
          loserNextMatchSlot: 2
        };
        matches["m_bronze"] = {
          id: "m_bronze",
          bracket: "consolation",
          round: 3,
          roundLabel: "3rd Place Playoff",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: null
        };
        matches["m_finals"] = {
          id: "m_finals",
          bracket: "winners",
          round: 3,
          roundLabel: "Championship Finals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: null
        };
      }
      return matches;
    }
    /**
     * Builds double elimination bracket tree (4 or 8 players).
     * Includes Winners Bracket, Losers/Consolation Bracket, and Grand Finals.
     */
    static _buildDoubleElimBracket(players, targetWins) {
      const n = players.length;
      const matches = {};
      if (n <= 4) {
        const p1 = players[0] || null;
        const p2 = players[1] || null;
        const p3 = players[2] || null;
        const p4 = players[3] || null;
        matches["m_wb_r1_1"] = {
          id: "m_wb_r1_1",
          bracket: "winners",
          round: 1,
          roundLabel: "Winners Semis 1",
          player1Id: p1 ? p1.id : null,
          player2Id: p4 ? p4.id : null,
          wins: { [p1 ? p1.id : "p1"]: 0, [p4 ? p4.id : "p4"]: 0 },
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "ready",
          nextMatchId: "m_wb_finals",
          nextMatchSlot: 1,
          loserNextMatchId: "m_lb_r1",
          loserNextMatchSlot: 1
        };
        matches["m_wb_r1_2"] = {
          id: "m_wb_r1_2",
          bracket: "winners",
          round: 1,
          roundLabel: "Winners Semis 2",
          player1Id: p2 ? p2.id : null,
          player2Id: p3 ? p3.id : null,
          wins: { [p2 ? p2.id : "p2"]: 0, [p3 ? p3.id : "p3"]: 0 },
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "ready",
          nextMatchId: "m_wb_finals",
          nextMatchSlot: 2,
          loserNextMatchId: "m_lb_r1",
          loserNextMatchSlot: 2
        };
        matches["m_wb_finals"] = {
          id: "m_wb_finals",
          bracket: "winners",
          round: 2,
          roundLabel: "Winners Finals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_grand_finals",
          nextMatchSlot: 1,
          loserNextMatchId: "m_lb_finals",
          loserNextMatchSlot: 2
        };
        matches["m_lb_r1"] = {
          id: "m_lb_r1",
          bracket: "losers",
          round: 1,
          roundLabel: "Losers Round 1",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_lb_finals",
          nextMatchSlot: 1
        };
        matches["m_lb_finals"] = {
          id: "m_lb_finals",
          bracket: "losers",
          round: 2,
          roundLabel: "Losers Finals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_grand_finals",
          nextMatchSlot: 2
        };
        matches["m_grand_finals"] = {
          id: "m_grand_finals",
          bracket: "finals",
          round: 3,
          roundLabel: "Grand Championship Finals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: null
        };
      } else {
        const getPlayerBySeed = (seedNum) => players.find((p) => p.seed === seedNum) || null;
        const seedPairings = [
          [1, 8],
          [4, 5],
          [2, 7],
          [3, 6]
        ];
        for (let i = 0; i < 4; i++) {
          const [s1, s2] = seedPairings[i];
          const pA = getPlayerBySeed(s1);
          const pB = getPlayerBySeed(s2);
          matches[`m_wb_qf_${i + 1}`] = {
            id: `m_wb_qf_${i + 1}`,
            bracket: "winners",
            round: 1,
            roundLabel: "Winners Quarterfinals",
            player1Id: pA ? pA.id : null,
            player2Id: pB ? pB.id : null,
            wins: {},
            games: [],
            targetWins,
            winnerId: null,
            loserId: null,
            status: pA && pB ? "ready" : pA && !pB ? "bye" : "pending",
            nextMatchId: i < 2 ? "m_wb_semi_1" : "m_wb_semi_2",
            nextMatchSlot: i % 2 + 1,
            loserNextMatchId: i < 2 ? "m_lb_r1_1" : "m_lb_r1_2",
            loserNextMatchSlot: i % 2 + 1
          };
        }
        matches["m_wb_semi_1"] = {
          id: "m_wb_semi_1",
          bracket: "winners",
          round: 2,
          roundLabel: "Winners Semifinals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_wb_finals",
          nextMatchSlot: 1,
          loserNextMatchId: "m_lb_r2_1",
          loserNextMatchSlot: 2
        };
        matches["m_wb_semi_2"] = {
          id: "m_wb_semi_2",
          bracket: "winners",
          round: 2,
          roundLabel: "Winners Semifinals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_wb_finals",
          nextMatchSlot: 2,
          loserNextMatchId: "m_lb_r2_2",
          loserNextMatchSlot: 2
        };
        matches["m_wb_finals"] = {
          id: "m_wb_finals",
          bracket: "winners",
          round: 3,
          roundLabel: "Winners Finals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_grand_finals",
          nextMatchSlot: 1,
          loserNextMatchId: "m_lb_finals",
          loserNextMatchSlot: 2
        };
        matches["m_lb_r1_1"] = {
          id: "m_lb_r1_1",
          bracket: "losers",
          round: 1,
          roundLabel: "Losers Round 1",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_lb_r2_1",
          nextMatchSlot: 1
        };
        matches["m_lb_r1_2"] = {
          id: "m_lb_r1_2",
          bracket: "losers",
          round: 1,
          roundLabel: "Losers Round 1",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_lb_r2_2",
          nextMatchSlot: 1
        };
        matches["m_lb_r2_1"] = {
          id: "m_lb_r2_1",
          bracket: "losers",
          round: 2,
          roundLabel: "Losers Semis 1",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_lb_semi",
          nextMatchSlot: 1
        };
        matches["m_lb_r2_2"] = {
          id: "m_lb_r2_2",
          bracket: "losers",
          round: 2,
          roundLabel: "Losers Semis 2",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_lb_semi",
          nextMatchSlot: 2
        };
        matches["m_lb_semi"] = {
          id: "m_lb_semi",
          bracket: "losers",
          round: 3,
          roundLabel: "Losers Semifinals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_lb_finals",
          nextMatchSlot: 1
        };
        matches["m_lb_finals"] = {
          id: "m_lb_finals",
          bracket: "losers",
          round: 4,
          roundLabel: "Losers Finals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: "m_grand_finals",
          nextMatchSlot: 2
        };
        matches["m_grand_finals"] = {
          id: "m_grand_finals",
          bracket: "finals",
          round: 5,
          roundLabel: "Grand Championship Finals",
          player1Id: null,
          player2Id: null,
          wins: {},
          games: [],
          targetWins,
          winnerId: null,
          loserId: null,
          status: "pending",
          nextMatchId: null
        };
      }
      return matches;
    }
    /**
     * Advances matches with BYEs automatically.
     */
    static _autoAdvanceByes(state3) {
      if (!state3 || !state3.matches) return;
      let changed = false;
      for (const match of Object.values(state3.matches)) {
        if (match.status === "bye" && match.player1Id && !match.player2Id) {
          match.winnerId = match.player1Id;
          match.status = "completed";
          _TournamentManager._advanceWinner(state3, match);
          changed = true;
        }
      }
      if (changed) {
        _TournamentManager._updateMatchStatuses(state3);
      }
    }
    /**
     * Updates match statuses based on player presence.
     */
    static _updateMatchStatuses(state3) {
      if (!state3 || !state3.matches) return;
      for (const match of Object.values(state3.matches)) {
        if (match.status === "completed") continue;
        if (match.player1Id && match.player2Id) {
          match.status = match.games && match.games.length > 0 ? "in_progress" : "ready";
        } else if (match.player1Id && !match.player2Id && match.round === 1) {
          match.status = "bye";
        } else {
          match.status = "pending";
        }
      }
    }
    /**
     * Advances a match winner to their next tournament slot.
     */
    static _advanceWinner(state3, match) {
      if (!match.winnerId) return;
      if (match.nextMatchId && state3.matches[match.nextMatchId]) {
        const nextM = state3.matches[match.nextMatchId];
        if (match.nextMatchSlot === 1) {
          nextM.player1Id = match.winnerId;
        } else if (match.nextMatchSlot === 2) {
          nextM.player2Id = match.winnerId;
        } else {
          if (!nextM.player1Id) nextM.player1Id = match.winnerId;
          else if (!nextM.player2Id) nextM.player2Id = match.winnerId;
        }
      }
      if (match.loserId && match.loserNextMatchId && state3.matches[match.loserNextMatchId]) {
        const loserM = state3.matches[match.loserNextMatchId];
        if (match.loserNextMatchSlot === 1) {
          loserM.player1Id = match.loserId;
        } else if (match.loserNextMatchSlot === 2) {
          loserM.player2Id = match.loserId;
        } else {
          if (!loserM.player1Id) loserM.player1Id = match.loserId;
          else if (!loserM.player2Id) loserM.player2Id = match.loserId;
        }
      }
      _TournamentManager._checkChampionship(state3);
    }
    /**
     * Checks if tournament finals have completed and crowns champion.
     */
    static _checkChampionship(state3) {
      if (!state3 || !state3.matches) return;
      const finals = state3.matches["m_grand_finals"] || state3.matches["m_finals"];
      if (finals && finals.status === "completed" && finals.winnerId) {
        state3.champion = finals.winnerId;
        state3.isComplete = true;
        const secondPlace = finals.loserId || null;
        let thirdPlace = null;
        if (state3.matches["m_bronze"] && state3.matches["m_bronze"].status === "completed") {
          thirdPlace = state3.matches["m_bronze"].winnerId;
        } else if (state3.matches["m_lb_finals"] && state3.matches["m_lb_finals"].status === "completed") {
          thirdPlace = state3.matches["m_lb_finals"].loserId;
        }
        state3.podium = {
          first: state3.champion,
          second: secondPlace,
          third: thirdPlace
        };
        _TournamentManager._archiveTournament(state3);
        try {
          const champPlayer = _TournamentManager.getPlayer(state3, state3.champion);
          const isHumanChamp = champPlayer && (champPlayer.type === "human" || champPlayer.id === "p1");
          if (isHumanChamp) {
            if (typeof AchievementManager !== "undefined" && typeof AchievementManager.recordTournamentWin === "function") {
              AchievementManager.recordTournamentWin(state3);
            }
          }
        } catch (e) {
        }
      }
    }
    /**
     * Saves completed tournament to local history list.
     */
    static _archiveTournament(state3) {
      try {
        const s = typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
        if (!s) return;
        const historyRaw = s.getItem(_TournamentManager.HISTORY_KEY);
        let history = [];
        if (historyRaw) {
          try {
            history = JSON.parse(historyRaw) || [];
          } catch (e) {
          }
        }
        history.unshift({
          id: state3.id,
          title: state3.title,
          format: state3.format,
          playerCount: state3.playerCount,
          champion: state3.champion,
          championName: _TournamentManager.getPlayer(state3, state3.champion)?.name || "Champion",
          completedAt: Date.now()
        });
        if (history.length > 20) history = history.slice(0, 20);
        s.setItem(_TournamentManager.HISTORY_KEY, JSON.stringify(history));
      } catch (e) {
      }
    }
    /**
     * Returns participant object by ID.
     */
    static getPlayer(state3, playerId) {
      if (!state3 || !state3.players) return null;
      return state3.players.find((p) => p.id === playerId) || null;
    }
    /**
     * Returns current active tournament match.
     */
    static getActiveMatch(state3 = null) {
      const s = state3 || _TournamentManager.getTournamentState();
      if (!s || !s.matches || !s.activeMatchId) return null;
      return s.matches[s.activeMatchId] || null;
    }
    /**
     * Sets active match ID and saves state.
     */
    static setActiveMatch(matchId, storage = null) {
      const state3 = _TournamentManager.getTournamentState(storage);
      if (!state3 || !state3.matches || !state3.matches[matchId]) return null;
      state3.activeMatchId = matchId;
      state3.updatedAt = Date.now();
      _TournamentManager.saveTournamentState(state3, storage);
      return state3.matches[matchId];
    }
    /**
     * Records completed game result into the active tournament match.
     * Called by GameEngine.checkGameOver.
     * @param {Object} gameResult
     * @param {string} gameResult.winner Winning seat ('you'|'cpu'|'p1'|'p2')
     * @param {number} [gameResult.p1Score=0]
     * @param {number} [gameResult.p2Score=0]
     * @param {string} [gameResult.skunkKind]
     * @param {Object} [storage=null]
     * @returns {Object|null}
     */
    static recordGame(gameResult = {}, storage = null) {
      const state3 = _TournamentManager.getTournamentState(storage);
      if (!state3 || !state3.activeMatchId) return null;
      const match = state3.matches[state3.activeMatchId];
      if (!match || match.status === "completed") return null;
      const p1 = _TournamentManager.getPlayer(state3, match.player1Id);
      const p2 = _TournamentManager.getPlayer(state3, match.player2Id);
      if (!p1 || !p2) return null;
      let winningPlayerId = null;
      const w = gameResult.winner;
      if (match.seatMap) {
        const mappedKey = w === "you" ? "p1" : w === "cpu" ? "p2" : w;
        winningPlayerId = match.seatMap[mappedKey] || match.seatMap[w];
      }
      if (!winningPlayerId) {
        if (w === "p1" || w === "you") {
          winningPlayerId = p1.id;
        } else if (w === "p2" || w === "cpu") {
          winningPlayerId = p2.id;
        } else if (w === p1.id || w === p2.id) {
          winningPlayerId = w;
        } else {
          winningPlayerId = p1.id;
        }
      }
      match.wins = match.wins || {};
      match.wins[winningPlayerId] = (match.wins[winningPlayerId] || 0) + 1;
      match.games = match.games || [];
      match.games.push({
        gameNumber: match.games.length + 1,
        winnerId: winningPlayerId,
        p1Score: gameResult.p1Score || 0,
        p2Score: gameResult.p2Score || 0,
        skunkKind: gameResult.skunkKind || null,
        timestamp: Date.now()
      });
      const losingPlayerId = winningPlayerId === p1.id ? p2.id : p1.id;
      const targetWins = match.targetWins || state3.targetWins || 2;
      let matchFinished = false;
      if (match.wins[winningPlayerId] >= targetWins) {
        match.winnerId = winningPlayerId;
        match.loserId = losingPlayerId;
        match.status = "completed";
        matchFinished = true;
        _TournamentManager._advanceWinner(state3, match);
      } else {
        match.status = "in_progress";
      }
      if (matchFinished && !state3.isComplete) {
        _TournamentManager._updateMatchStatuses(state3);
        const nextReady = Object.values(state3.matches).find((m) => m.status === "ready" && m.id !== match.id);
        if (nextReady) {
          state3.activeMatchId = nextReady.id;
        }
      }
      state3.updatedAt = Date.now();
      _TournamentManager.saveTournamentState(state3, storage);
      return {
        state: state3,
        match,
        matchFinished,
        winner: _TournamentManager.getPlayer(state3, match.winnerId),
        isTournamentComplete: state3.isComplete,
        champion: state3.champion ? _TournamentManager.getPlayer(state3, state3.champion) : null
      };
    }
    /**
     * Manually sets or overrides a match winner (useful for physical pub boards where matches
     * are played on wooden boards and results are entered into the app bracket manager).
     * @param {string} matchId
     * @param {string} winnerId
     * @param {number} [winnerWins=1]
     * @param {number} [loserWins=0]
     * @param {Object} [storage=null]
     * @returns {Object|null}
     */
    static manualSetMatchWinner(matchId, winnerId, winnerWins = null, loserWins = 0, storage = null) {
      const state3 = _TournamentManager.getTournamentState(storage);
      if (!state3 || !state3.matches || !state3.matches[matchId]) return null;
      const match = state3.matches[matchId];
      if (!match.player1Id || !match.player2Id) return null;
      if (winnerId !== match.player1Id && winnerId !== match.player2Id) return null;
      const loserId = winnerId === match.player1Id ? match.player2Id : match.player1Id;
      const requiredWins = match.targetWins || state3.targetWins || 1;
      const wWins = winnerWins !== null ? winnerWins : requiredWins;
      match.wins = {
        [winnerId]: wWins,
        [loserId]: loserWins
      };
      match.winnerId = winnerId;
      match.loserId = loserId;
      match.status = "completed";
      match.games = match.games || [];
      match.games.push({
        gameNumber: match.games.length + 1,
        winnerId,
        p1Score: 121,
        p2Score: 90,
        manual: true,
        timestamp: Date.now()
      });
      _TournamentManager._advanceWinner(state3, match);
      _TournamentManager._updateMatchStatuses(state3);
      if (!state3.isComplete) {
        const nextReady = Object.values(state3.matches).find((m) => m.status === "ready" && m.id !== match.id);
        if (nextReady) state3.activeMatchId = nextReady.id;
      }
      state3.updatedAt = Date.now();
      _TournamentManager.saveTournamentState(state3, storage);
      return {
        state: state3,
        match,
        winner: _TournamentManager.getPlayer(state3, winnerId),
        isTournamentComplete: state3.isComplete
      };
    }
    /**
     * Simulates a match between two Computer players automatically.
     * @param {string} matchId
     * @param {Object} [storage=null]
     */
    static simulateCpuMatch(matchId, storage = null) {
      const state3 = _TournamentManager.getTournamentState(storage);
      if (!state3 || !state3.matches || !state3.matches[matchId]) return null;
      const match = state3.matches[matchId];
      const p1 = _TournamentManager.getPlayer(state3, match.player1Id);
      const p2 = _TournamentManager.getPlayer(state3, match.player2Id);
      if (!p1 || !p2) return null;
      const profileWeights = {
        shark: 1.15,
        gambler: 1,
        turtler: 0.95
      };
      const w1 = profileWeights[p1.cpuProfile] || 1;
      const w2 = profileWeights[p2.cpuProfile] || 1;
      const probP1 = w1 / (w1 + w2);
      const targetWins = match.targetWins || state3.targetWins || 2;
      let p1Wins = match.wins[p1.id] || 0;
      let p2Wins = match.wins[p2.id] || 0;
      while (p1Wins < targetWins && p2Wins < targetWins) {
        const p1WonGame = Math.random() < probP1;
        const gameWinnerId = p1WonGame ? p1.id : p2.id;
        if (p1WonGame) p1Wins++;
        else p2Wins++;
        const winningScore = state3.targetPoints || 121;
        const losingScore = Math.floor(Math.random() * 35) + (winningScore - 40);
        match.games.push({
          gameNumber: match.games.length + 1,
          winnerId: gameWinnerId,
          p1Score: p1WonGame ? winningScore : losingScore,
          p2Score: p1WonGame ? losingScore : winningScore,
          simulated: true,
          timestamp: Date.now()
        });
      }
      const winnerId = p1Wins >= targetWins ? p1.id : p2.id;
      return _TournamentManager.manualSetMatchWinner(matchId, winnerId, Math.max(p1Wins, p2Wins), Math.min(p1Wins, p2Wins), storage);
    }
    /**
     * Resets active tournament.
     */
    static resetTournament(storage = null) {
      _TournamentManager.saveTournamentState(null, storage);
    }
    /**
     * Generates a clean text / markdown recap of tournament standings for sharing
     * to group chats, Discord, or WhatsApp.
     * @param {Object} [state=null]
     * @returns {string}
     */
    static generateShareSummary(state3 = null) {
      const s = state3 || _TournamentManager.getTournamentState();
      if (!s) return "No active tournament found.";
      const champ = s.champion ? _TournamentManager.getPlayer(s, s.champion) : null;
      const firstP = s.podium?.first ? _TournamentManager.getPlayer(s, s.podium.first) : null;
      const secondP = s.podium?.second ? _TournamentManager.getPlayer(s, s.podium.second) : null;
      const thirdP = s.podium?.third ? _TournamentManager.getPlayer(s, s.podium.third) : null;
      const lines = [
        `\u{1F3C6} **${s.title.toUpperCase()}** \u{1F3C6}`,
        `Format: ${s.format === "double" ? "Double Elimination" : "Single Elimination"} (${s.playerCount} Players \xB7 ${s.seriesMode.toUpperCase()})`,
        `Date: ${new Date(s.createdAt).toLocaleDateString()}`,
        ""
      ];
      if (champ) {
        lines.push(`\u{1F451} **CHAMPION: ${champ.name}**`);
        if (secondP) lines.push(`\u{1F948} Runner-Up: ${secondP.name}`);
        if (thirdP) lines.push(`\u{1F949} 3rd Place: ${thirdP.name}`);
        lines.push("");
      }
      lines.push("\u{1F4CB} **Match Results:**");
      for (const match of Object.values(s.matches)) {
        const p1 = _TournamentManager.getPlayer(s, match.player1Id);
        const p2 = _TournamentManager.getPlayer(s, match.player2Id);
        const p1Name = p1 ? p1.name : match.status === "bye" ? "BYE" : "TBD";
        const p2Name = p2 ? p2.name : match.status === "bye" ? "BYE" : "TBD";
        const p1Wins = match.wins[match.player1Id] || 0;
        const p2Wins = match.wins[match.player2Id] || 0;
        let statusMarker = "\u23F3";
        if (match.status === "completed") statusMarker = "\u2714";
        else if (match.status === "in_progress") statusMarker = "\u25B6";
        else if (match.status === "bye") statusMarker = "\u26A1";
        lines.push(`${statusMarker} ${match.roundLabel}: ${p1Name} (${p1Wins}) vs ${p2Name} (${p2Wins})`);
      }
      lines.push("");
      lines.push("Played on Crazy Cribbage \xB7 100% Free Online Cribbage");
      return lines.join("\n");
    }
  };

  // src/ui/ReactionManager.js
  function escapeHtml(str) {
    if (!str) return "";
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }
  var REACTION_ITEMS = [
    { id: "skunked", emoji: "\u{1F9A8}", label: "Skunked", sfxMethod: "reactionSkunk" },
    { id: "cheers", emoji: "\u{1F37B}", label: "Cheers", sfxMethod: "reactionCheers" },
    { id: "noway", emoji: "\u{1F631}", label: "No Way!", sfxMethod: "reactionNoWay" },
    { id: "nice15", emoji: "\u{1F0CF}", label: "Nice 15", sfxMethod: "reactionNice15" },
    { id: "boom", emoji: "\u{1F4A5}", label: "Boom!", sfxMethod: "reactionBoom" }
  ];
  var BANTER_ITEMS = [
    {
      id: "fifteen24",
      emoji: "\u{1F522}",
      text: "Fifteen two, fifteen four, and the rest don't score!",
      short: "15-2, 15-4\u2026",
      sfxMethod: "banterFifteenTwo"
    },
    {
      id: "nob",
      emoji: "\u{1F3A9}",
      text: "One for his nob!",
      short: "His Nob!",
      sfxMethod: "banterNob"
    },
    {
      id: "go",
      emoji: "\u{1F3C3}",
      text: "Go!",
      short: "Go!",
      sfxMethod: "banterGo"
    },
    {
      id: "pair2",
      emoji: "\u270C\uFE0F",
      text: "Pair for two!",
      short: "Pair for 2!",
      sfxMethod: "banterPair"
    },
    {
      id: "thirtyone",
      emoji: "\u{1F451}",
      text: "Thirty-one for two!",
      short: "31 for 2!",
      sfxMethod: "banterThirtyOne"
    },
    {
      id: "heels",
      emoji: "\u{1F462}",
      text: "Two for his heels!",
      short: "His Heels!",
      sfxMethod: "banterHeels"
    }
  ];
  var ReactionManager = class _ReactionManager {
    static isWheelOpen = false;
    static activeTab = "emotes";
    // 'emotes' | 'banter'
    static _lastReactionTime = 0;
    /**
     * Returns definition for a reaction emoji by id.
     * @param {string} id
     * @returns {Object|null}
     */
    static getReaction(id) {
      return REACTION_ITEMS.find((r) => r.id === id) || null;
    }
    /**
     * Returns definition for a banter phrase by id.
     * @param {string} id
     * @returns {Object|null}
     */
    static getBanter(id) {
      return BANTER_ITEMS.find((b) => b.id === id) || null;
    }
    /**
     * Triggers an emoji reaction locally, plays acoustic SFX, spawns floating emoji on board,
     * and broadcasts to online peers if in a multiplayer room.
     * @param {string} reactionId
     * @param {Object} [options]
     */
    static triggerReaction(reactionId, options = {}) {
      const item = _ReactionManager.getReaction(reactionId);
      if (!item) return;
      const now = Date.now();
      if (now - _ReactionManager._lastReactionTime < 400) return;
      _ReactionManager._lastReactionTime = now;
      const sfx3 = options.sfx || (typeof window !== "undefined" ? window.sfx : null);
      if (sfx3 && typeof sfx3[item.sfxMethod] === "function") {
        sfx3[item.sfxMethod]();
      }
      const senderName = options.senderName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName("you") : "You");
      const fromSeat = options.fromSeat || "p1";
      _ReactionManager.displayFloatingReaction(item.emoji, item.label, {
        senderName,
        fromSeat,
        isLocal: true,
        isBanter: false
      });
      _ReactionManager.closeReactionWheel();
      const net2 = options.net || (typeof window !== "undefined" ? window.net : null);
      const netSend2 = options.netSend || (typeof window !== "undefined" ? window.netSend : null);
      if (net2 && net2.room && typeof netSend2 === "function") {
        netSend2({
          type: "reaction",
          id: item.id,
          emoji: item.emoji,
          label: item.label,
          senderName,
          fromSeat,
          isBanter: false
        });
      }
    }
    /**
     * Triggers a friendly cribbage table banter phrase locally, plays sound bite/speech,
     * spawns floating speech bubble on the table, and broadcasts to online peers.
     * @param {string} banterId
     * @param {Object} [options]
     */
    static triggerBanter(banterId, options = {}) {
      const item = _ReactionManager.getBanter(banterId);
      if (!item) return;
      const now = Date.now();
      if (now - _ReactionManager._lastReactionTime < 400) return;
      _ReactionManager._lastReactionTime = now;
      const sfx3 = options.sfx || (typeof window !== "undefined" ? window.sfx : null);
      if (sfx3) {
        if (typeof sfx3.playBanterSound === "function") {
          sfx3.playBanterSound(item.sfxMethod, item.text);
        } else if (typeof sfx3[item.sfxMethod] === "function") {
          sfx3[item.sfxMethod]();
        }
      }
      const senderName = options.senderName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName("you") : "You");
      const fromSeat = options.fromSeat || "p1";
      _ReactionManager.displayFloatingReaction(item.emoji, item.text, {
        senderName,
        fromSeat,
        isLocal: true,
        isBanter: true
      });
      _ReactionManager.closeReactionWheel();
      const net2 = options.net || (typeof window !== "undefined" ? window.net : null);
      const netSend2 = options.netSend || (typeof window !== "undefined" ? window.netSend : null);
      if (net2 && net2.room && typeof netSend2 === "function") {
        netSend2({
          type: "reaction",
          id: item.id,
          emoji: item.emoji,
          label: item.text,
          senderName,
          fromSeat,
          isBanter: true
        });
      }
      _ReactionManager.respondAiToBanter(item.id, { sfx: sfx3 });
    }
    /**
     * Handles incoming reaction or banter message from remote peer.
     * @param {Object} msg
     * @param {Object} [options]
     */
    static handleRemoteReaction(msg, options = {}) {
      if (!msg || !msg.emoji && !msg.label) return;
      const isBanter = Boolean(msg.isBanter);
      const item = isBanter ? _ReactionManager.getBanter(msg.id) : _ReactionManager.getReaction(msg.id);
      const sfx3 = options.sfx || (typeof window !== "undefined" ? window.sfx : null);
      if (sfx3) {
        if (isBanter && item && typeof sfx3.playBanterSound === "function") {
          sfx3.playBanterSound(item.sfxMethod, item.text);
        } else if (item && typeof sfx3[item.sfxMethod] === "function") {
          sfx3[item.sfxMethod]();
        }
      }
      const safeEmoji = item ? item.emoji : typeof msg.emoji === "string" ? msg.emoji.replace(/[<>"'&`/\\;]/g, "").trim().slice(0, 10) : "\u{1F4AC}";
      const safeLabel = item ? isBanter ? item.text : item.label : typeof msg.label === "string" ? msg.label.slice(0, 100) : "";
      const safeSender = typeof msg.senderName === "string" ? msg.senderName.replace(/[<>"'&`/\\;]/g, "").trim().slice(0, 24) || "Opponent" : "Opponent";
      _ReactionManager.displayFloatingReaction(safeEmoji, safeLabel, {
        senderName: safeSender,
        fromSeat: msg.fromSeat || "p2",
        isLocal: false,
        isBanter
      });
    }
    /**
     * Contextual reaction triggered by computer AI.
     * @param {string} trigger Event trigger type ('nice15', 'boom', 'skunk', 'cheers')
     * @param {Object} [options]
     */
    static triggerAiReaction(trigger, options = {}) {
      const item = _ReactionManager.getReaction(trigger);
      if (!item) return;
      const delay = options.delay != null ? options.delay : 400 + Math.random() * 500;
      setTimeout(() => {
        const sfx3 = options.sfx || (typeof window !== "undefined" ? window.sfx : null);
        if (sfx3 && typeof sfx3[item.sfxMethod] === "function") {
          sfx3[item.sfxMethod]();
        }
        const aiName = options.aiName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName("cpu") : "Computer");
        _ReactionManager.displayFloatingReaction(item.emoji, item.label, {
          senderName: aiName,
          fromSeat: "cpu",
          isLocal: false,
          isBanter: false
        });
      }, delay);
    }
    /**
     * AI contextual banter response to player table banter.
     * @param {string} playerBanterId
     * @param {Object} [options]
     */
    static respondAiToBanter(playerBanterId, options = {}) {
      const aiName = options.aiName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName("cpu") : "Computer");
      const delay = 650 + Math.random() * 700;
      let reply = null;
      let isReplyBanter = false;
      if (playerBanterId === "go") {
        reply = { emoji: "\u{1F440}", text: "Taking the point!" };
        isReplyBanter = true;
      } else if (playerBanterId === "fifteen24") {
        if (Math.random() > 0.45) {
          reply = _ReactionManager.getReaction("noway") || { emoji: "\u{1F631}", label: "No Way!" };
        } else {
          reply = { emoji: "\u{1F0CF}", text: "Count 'em up!" };
          isReplyBanter = true;
        }
      } else if (playerBanterId === "nob" || playerBanterId === "heels") {
        reply = Math.random() > 0.5 ? _ReactionManager.getReaction("cheers") : { emoji: "\u{1F3A9}", text: "Well cut!" };
        isReplyBanter = !reply.sfxMethod;
      } else if (playerBanterId === "pair2") {
        reply = { emoji: "\u2694\uFE0F", text: "Nice pair!" };
        isReplyBanter = true;
      }
      if (reply) {
        setTimeout(() => {
          const sfx3 = options.sfx || (typeof window !== "undefined" ? window.sfx : null);
          if (sfx3) {
            if (reply.sfxMethod && typeof sfx3[reply.sfxMethod] === "function") {
              sfx3[reply.sfxMethod]();
            } else if (typeof sfx3.thunk === "function") {
              sfx3.thunk(1.15);
            }
          }
          _ReactionManager.displayFloatingReaction(reply.emoji, reply.text || reply.label || "", {
            senderName: aiName,
            fromSeat: "cpu",
            isLocal: false,
            isBanter: isReplyBanter
          });
        }, delay);
      }
    }
    /**
     * Spawns an animated floating reaction or banter speech bubble that glides upward with organic bounce.
     * @param {string} emoji
     * @param {string} label
     * @param {Object} [options]
     */
    static displayFloatingReaction(emoji, label, options = {}) {
      if (typeof document === "undefined") return;
      const targetContainer = document.getElementById("cribBoard") || document.getElementById("game") || document.body;
      if (!targetContainer) return;
      const isBanter = Boolean(options.isBanter);
      const el = document.createElement("div");
      el.className = "floating-reaction" + (isBanter ? " is-banter" : "") + (options.isLocal ? " is-local" : " is-remote");
      const randomOffset = (Math.random() - 0.5) * 55;
      el.style.setProperty("--react-offset-x", `${randomOffset}px`);
      const senderHtml = options.senderName ? `<span class="react-sender">${escapeHtml(options.senderName)}</span>` : "";
      if (isBanter) {
        el.innerHTML = `
        <div class="react-content is-banter">
          <div class="banter-bubble">
            <span class="banter-bubble-emoji">${escapeHtml(emoji)}</span>
            <span class="banter-bubble-quote">\u201C${escapeHtml(label)}\u201D</span>
          </div>
          ${senderHtml}
        </div>
      `;
      } else {
        el.innerHTML = `
        <div class="react-content">
          <span class="react-emoji">${escapeHtml(emoji)}</span>
          ${label ? `<span class="react-bubble">${escapeHtml(label)}</span>` : ""}
          ${senderHtml}
        </div>
      `;
      }
      targetContainer.appendChild(el);
      const cleanup = () => {
        if (el.parentNode) el.parentNode.removeChild(el);
      };
      el.addEventListener("animationend", cleanup, { once: true });
      setTimeout(cleanup, 2800);
    }
    /**
     * Switches between 'emotes' and 'banter' tabs in the dock.
     * @param {string} tab 'emotes' | 'banter'
     */
    static switchTab(tab) {
      if (typeof document === "undefined") return;
      _ReactionManager.activeTab = tab;
      const btnEmotes = document.getElementById("btnReactionTabEmotes");
      const btnBanter = document.getElementById("btnReactionTabBanter");
      const panelEmotes = document.getElementById("reactionPanelEmotes");
      const panelBanter = document.getElementById("reactionPanelBanter");
      if (btnEmotes && btnBanter && panelEmotes && panelBanter) {
        if (tab === "banter") {
          btnEmotes.classList.remove("is-active");
          btnBanter.classList.add("is-active");
          panelEmotes.classList.add("hidden");
          panelBanter.classList.remove("hidden");
        } else {
          btnEmotes.classList.add("is-active");
          btnBanter.classList.remove("is-active");
          panelEmotes.classList.remove("hidden");
          panelBanter.classList.add("hidden");
        }
      }
    }
    /**
     * Toggles visibility of the in-game reaction wheel.
     */
    static toggleReactionWheel() {
      if (_ReactionManager.isWheelOpen) {
        _ReactionManager.closeReactionWheel();
      } else {
        _ReactionManager.openReactionWheel();
      }
    }
    /**
     * Opens the in-game reaction wheel.
     */
    static openReactionWheel() {
      if (typeof document === "undefined") return;
      const wheel = document.getElementById("reactionWheel");
      const trigger = document.getElementById("btnReactionTrigger");
      if (!wheel) return;
      wheel.classList.remove("hidden");
      wheel.classList.add("is-open");
      if (trigger) trigger.classList.add("is-active");
      _ReactionManager.isWheelOpen = true;
      const handleOutside = (e) => {
        if (!wheel.contains(e.target) && (!trigger || !trigger.contains(e.target))) {
          _ReactionManager.closeReactionWheel();
          document.removeEventListener("click", handleOutside);
        }
      };
      setTimeout(() => {
        document.addEventListener("click", handleOutside);
      }, 10);
    }
    /**
     * Closes the in-game reaction wheel.
     */
    static closeReactionWheel() {
      if (typeof document === "undefined") return;
      const wheel = document.getElementById("reactionWheel");
      const trigger = document.getElementById("btnReactionTrigger");
      if (wheel) {
        wheel.classList.remove("is-open");
        setTimeout(() => {
          if (!_ReactionManager.isWheelOpen && wheel) wheel.classList.add("hidden");
        }, 160);
      }
      if (trigger) trigger.classList.remove("is-active");
      _ReactionManager.isWheelOpen = false;
    }
    /**
     * Injects the reaction wheel and trigger button HTML markup into the play area if not already present.
     * @param {HTMLElement} [container]
     */
    static injectReactionUi(container) {
      if (typeof document === "undefined") return;
      if (document.getElementById("reactionDockWrap")) return;
      const parent = container || document.getElementById("tableRight") || document.getElementById("game");
      if (!parent) return;
      const dock = document.createElement("div");
      dock.id = "reactionDockWrap";
      dock.className = "reaction-dock-wrap";
      const emotesHtml = REACTION_ITEMS.map((item, idx) => `
      <button type="button" class="reaction-item-btn" data-reaction="${item.id}" title="${item.label} (${item.emoji})" style="--item-index: ${idx}">
        <span class="reaction-item-emoji">${item.emoji}</span>
        <span class="reaction-item-label">${item.label}</span>
      </button>
    `).join("");
      const banterHtml = BANTER_ITEMS.map((item, idx) => `
      <button type="button" class="banter-item-btn" data-banter="${item.id}" title="${escapeHtml(item.text)}" style="--item-index: ${idx}">
        <span class="banter-item-emoji">${item.emoji}</span>
        <span class="banter-item-short">${escapeHtml(item.short)}</span>
      </button>
    `).join("");
      dock.innerHTML = `
      <div id="reactionWheel" class="reaction-wheel hidden" role="toolbar" aria-label="Table Banter & Emojis">
        <div class="reaction-wheel-tabs">
          <button type="button" class="reaction-tab-btn is-active" id="btnReactionTabEmotes">\u{1F600} Emotes</button>
          <button type="button" class="reaction-tab-btn" id="btnReactionTabBanter">\u{1F4AC} Banter</button>
        </div>
        <div class="reaction-panel" id="reactionPanelEmotes">
          ${emotesHtml}
        </div>
        <div class="reaction-panel hidden" id="reactionPanelBanter">
          ${banterHtml}
        </div>
      </div>
      <button type="button" id="btnReactionTrigger" class="reaction-trigger-btn" aria-label="Send game reaction emoji or banter" title="Table Banter & Reactions (\u{1F4AC})">
        <span class="reaction-trigger-icon">\u{1F4AC}</span>
      </button>
    `;
      parent.appendChild(dock);
      const tabEmotes = dock.querySelector("#btnReactionTabEmotes");
      if (tabEmotes) {
        tabEmotes.addEventListener("click", (e) => {
          e.stopPropagation();
          _ReactionManager.switchTab("emotes");
        });
      }
      const tabBanter = dock.querySelector("#btnReactionTabBanter");
      if (tabBanter) {
        tabBanter.addEventListener("click", (e) => {
          e.stopPropagation();
          _ReactionManager.switchTab("banter");
        });
      }
      const trigger = dock.querySelector("#btnReactionTrigger");
      if (trigger) {
        trigger.addEventListener("click", (e) => {
          e.stopPropagation();
          _ReactionManager.toggleReactionWheel();
        });
      }
      const emoteBtns = dock.querySelectorAll(".reaction-item-btn");
      emoteBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          const rId = btn.dataset.reaction;
          _ReactionManager.triggerReaction(rId);
        });
      });
      const banterBtns = dock.querySelectorAll(".banter-item-btn");
      banterBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          const bId = btn.dataset.banter;
          _ReactionManager.triggerBanter(bId);
        });
      });
    }
  };

  // src/game/GameReplayManager.js
  var REPLAY_STORAGE_KEY = "crazyCribbage.replays.v1";
  var AUTO_RECORD_KEY = "crazyCribbage.autoRecord.v1";
  var MAX_SAVED_REPLAYS = 30;
  var _memoryFallbackStorage = {};
  function getStorage3() {
    if (typeof window !== "undefined" && window.appStorage) return window.appStorage;
    if (appStorage && typeof appStorage.getItem === "function") return appStorage;
    try {
      if (typeof localStorage !== "undefined" && typeof localStorage.getItem === "function") {
        localStorage.getItem("__storage_test__");
        return localStorage;
      }
    } catch (_) {
    }
    return {
      getItem: (key) => _memoryFallbackStorage[key] !== void 0 ? _memoryFallbackStorage[key] : null,
      setItem: (key, val) => {
        _memoryFallbackStorage[key] = String(val);
      },
      removeItem: (key) => {
        delete _memoryFallbackStorage[key];
      },
      clear: () => {
        _memoryFallbackStorage = {};
      }
    };
  }
  var GameReplayManager = class _GameReplayManager {
    static currentReplay = null;
    static lastRecordedReplay = null;
    static _activeRound = 1;
    static _activeHands = {};
    static _activeStarter = null;
    static _activeCrib = [];
    static _activePile = [];
    static _activeScores = { p1: 0, p2: 0 };
    static _activeCount = 0;
    /**
     * Checks whether automatic match recording is enabled.
     * @returns {boolean}
     */
    static isAutoRecordEnabled() {
      try {
        const storage = getStorage3();
        if (!storage) return true;
        const val = storage.getItem(AUTO_RECORD_KEY);
        return val === null || val === "true" || val === true;
      } catch (_) {
        return true;
      }
    }
    /**
     * Sets auto-record preference.
     * @param {boolean} enabled
     */
    static setAutoRecordEnabled(enabled) {
      try {
        const storage = getStorage3();
        if (storage) {
          storage.setItem(AUTO_RECORD_KEY, enabled ? "true" : "false");
        }
      } catch (_) {
      }
    }
    /**
     * Initializes and begins recording a new game session.
     * @param {Object} options
     */
    static startRecording({ settings: settings3 = {}, state: state3 = {}, brand = "crazy", pName: pName2 = null } = {}) {
      const timestamp = Date.now();
      const date = new Date(timestamp);
      const dateLabel = date.toLocaleDateString(void 0, {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit"
      });
      let p1Name = "You";
      let p2Name = "Computer";
      if (typeof pName2 === "function") {
        p1Name = pName2("p1") || "You";
        p2Name = pName2("p2") || "Computer";
      } else if (typeof pName2 === "string" && pName2.trim()) {
        p1Name = pName2.trim();
      } else if (state3 && state3.pName) {
        p1Name = state3.pName;
      }
      if (state3 && state3.cpuDifficulty) {
        const diffLabels = { turtler: "The Turtler", shark: "The Shark", gambler: "The High Roller" };
        p2Name = diffLabels[state3.cpuDifficulty] || "Computer";
      }
      if (state3 && state3.players && state3.players.p1 && state3.players.p1.name) p1Name = state3.players.p1.name;
      if (state3 && state3.players && state3.players.p2 && state3.players.p2.name) p2Name = state3.players.p2.name;
      const resolvedBrand = brand || (typeof window !== "undefined" ? window.getAppBrand ? window.getAppBrand() : window.currentBrand || "crazy" : "crazy");
      const brandNames = {
        crazy: "Crazy Cribbage",
        clash: "Cribbage Clash",
        pints: "Pints & Pegs",
        adult: "Skunked & Stripped"
      };
      let p1Avatar = "\u{1F920}";
      try {
        const prof = typeof window !== "undefined" && window.Profile ? window.Profile.getInstance() : Profile ? Profile.getInstance() : null;
        if (prof) {
          if (p1Name === "You" && prof.getName()) p1Name = prof.getName();
          const avObj = prof.getAvatarObject ? prof.getAvatarObject() : null;
          if (avObj && avObj.emoji) p1Avatar = avObj.emoji;
        }
      } catch (_) {
      }
      _GameReplayManager._activeRound = 1;
      _GameReplayManager._activeHands = {};
      _GameReplayManager._activeStarter = null;
      _GameReplayManager._activeCrib = [];
      _GameReplayManager._activePile = [];
      _GameReplayManager._activeScores = { p1: 0, p2: 0 };
      _GameReplayManager._activeCount = 0;
      _GameReplayManager.currentReplay = {
        version: "1.0.0",
        id: `replay_${timestamp}_${Math.random().toString(36).substring(2, 7)}`,
        timestamp,
        dateLabel,
        brand: resolvedBrand || "crazy",
        brandLabel: brandNames[resolvedBrand] || "Crazy Cribbage",
        target: Number(settings3.target) || 121,
        goal: settings3.goal || "high",
        board3DId: settings3.selected3DBoardId || "us-flag-250",
        boardViewMode: settings3.boardViewMode || "3d",
        players: {
          p1: { id: "p1", name: p1Name, avatar: p1Avatar, isHuman: true },
          p2: { id: "p2", name: p2Name, avatar: "\u{1F916}", isHuman: false }
        },
        winner: null,
        winnerName: null,
        finalScores: { p1: 0, p2: 0 },
        skunkKind: null,
        settings: { ...settings3 },
        events: []
      };
      _GameReplayManager.recordEvent("game_start", {
        narration: `Match started: ${p1Name} vs ${p2Name} (${brandNames[brand] || "Crazy Cribbage"}, First to ${settings3.target || 121} pts).`,
        dealer: state3.dealer || "p1",
        activePlayer: state3.dealer || "p1",
        scores: { p1: 0, p2: 0 }
      });
      return _GameReplayManager.currentReplay;
    }
    /**
     * Records a discrete match event into the current replay timeline.
     * @param {string} type - Event type identifier
     * @param {Object} data - Payload data
     */
    static recordEvent(type, data = {}) {
      if (!_GameReplayManager.currentReplay) return;
      const events = _GameReplayManager.currentReplay.events;
      const step = events.length;
      if (data.round) {
        _GameReplayManager._activeRound = data.round;
      }
      const round = data.round || _GameReplayManager._activeRound || 1;
      if (data.scores) {
        _GameReplayManager._activeScores = {
          p1: data.scores.p1 !== void 0 ? data.scores.p1 : data.scores.you || _GameReplayManager._activeScores.p1 || 0,
          p2: data.scores.p2 !== void 0 ? data.scores.p2 : data.scores.cpu || _GameReplayManager._activeScores.p2 || 0
        };
      }
      if (data.countAfter !== void 0) {
        _GameReplayManager._activeCount = data.countAfter;
      } else if (data.count !== void 0) {
        _GameReplayManager._activeCount = data.count;
      }
      if (data.hands) {
        _GameReplayManager._activeHands = JSON.parse(JSON.stringify(data.hands));
      }
      if (data.cards) {
        if (type === "show_hand" && data.who) {
          const whoKey = data.who === "you" || data.who === "p1" ? "p1" : "p2";
          _GameReplayManager._activeHands[whoKey] = [...data.cards];
        } else if (type === "show_crib") {
          _GameReplayManager._activeCrib = [...data.cards];
        }
      }
      if (data.starter) {
        _GameReplayManager._activeStarter = { ...data.starter };
      }
      if (data.crib) {
        _GameReplayManager._activeCrib = Array.isArray(data.crib) ? [...data.crib] : [];
      }
      if (data.pile) {
        _GameReplayManager._activePile = Array.isArray(data.pile) ? [...data.pile] : [];
      } else if (data.card && type === "peg_play") {
        _GameReplayManager._activePile.push({ ...data.card });
        if (data.who) {
          const whoKey = data.who === "you" || data.who === "p1" ? "p1" : "p2";
          if (Array.isArray(_GameReplayManager._activeHands[whoKey])) {
            const idx = _GameReplayManager._activeHands[whoKey].findIndex(
              (c) => c.id && data.card.id && c.id === data.card.id || (c.r === data.card.r || c.rank === data.card.rank) && (c.s === data.card.s || c.suit === data.card.suit)
            );
            if (idx !== -1) {
              _GameReplayManager._activeHands[whoKey].splice(idx, 1);
            }
          }
        }
      } else if (type === "discard" && data.who) {
        const whoKey = data.who === "you" || data.who === "p1" ? "p1" : "p2";
        const discardList = Array.isArray(data.discards) ? data.discards : Array.isArray(data.cards) ? data.cards : [];
        if (Array.isArray(_GameReplayManager._activeHands[whoKey])) {
          for (const dc of discardList) {
            const idx = _GameReplayManager._activeHands[whoKey].findIndex(
              (c) => c.id && dc.id && c.id === dc.id || (c.r === dc.r || c.rank === dc.rank) && (c.s === dc.s || c.suit === dc.suit)
            );
            if (idx !== -1) {
              _GameReplayManager._activeHands[whoKey].splice(idx, 1);
            }
          }
        }
      } else if (type === "round_start") {
        _GameReplayManager._activeRound = round;
        _GameReplayManager._activePile = [];
        _GameReplayManager._activeCount = 0;
        _GameReplayManager._activeCrib = [];
        _GameReplayManager._activeStarter = null;
        _GameReplayManager._activeHands = { p1: [], p2: [] };
      } else if (type === "peg_go" || type === "peg_reset" || type === "show_hand" || type === "show_crib") {
        _GameReplayManager._activePile = [];
        _GameReplayManager._activeCount = 0;
      }
      let narration = data.narration;
      if (!narration) {
        const p1 = _GameReplayManager.currentReplay?.players?.p1?.name || "You";
        const p2 = _GameReplayManager.currentReplay?.players?.p2?.name || "Computer";
        const whoName = data.who === "p1" || data.who === "you" ? p1 : p2;
        switch (type) {
          case "round_start":
            narration = `Round ${round} began. Dealer: ${whoName}.`;
            break;
          case "deal":
            narration = `Cards dealt for Round ${round}.`;
            break;
          case "discard":
            narration = `${whoName} discarded to the crib.`;
            break;
          case "starter_cut": {
            const c = data.starter;
            const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
            const cardStr = c ? `${c.r}${suitSyms[c.s] || c.s}` : "Starter Card";
            narration = `Starter cut: ${cardStr}${data.heels ? " (His Heels! +2 points for dealer)" : ""}.`;
            break;
          }
          case "peg_play": {
            const c = data.card;
            const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
            const cardStr = c ? `${c.r}${suitSyms[c.s] || c.s}` : "Card";
            narration = `${whoName} played ${cardStr} \u2014 Count: ${data.countAfter ?? data.count}${data.points ? ` (+${data.points} pts: ${data.reason || "score"})` : ""}.`;
            break;
          }
          case "peg_go":
            narration = data.reason === "31" ? `${whoName} reached 31 (+${data.points || 2} pts). Sequence cleared.` : `${whoName} scored Go (+${data.points || 1} pt). Sequence cleared.`;
            break;
          case "peg_reset":
            narration = `Count reset to 0 (${data.reason || "31 or Go reached"}). Sequence cleared.`;
            break;
          case "show_hand": {
            let comboText = "";
            if (Array.isArray(data.combos) && data.combos.length) {
              comboText = data.combos.map((c) => typeof c === "string" ? c : c.why ? `${c.why} (+${c.n})` : c.name || c.text || "").filter(Boolean).join(", ");
            }
            narration = `${whoName} scored ${data.points || 0} pts in hand${comboText ? ` (${comboText})` : ""}.`;
            break;
          }
          case "show_crib": {
            let comboText = "";
            if (Array.isArray(data.combos) && data.combos.length) {
              comboText = data.combos.map((c) => typeof c === "string" ? c : c.why ? `${c.why} (+${c.n})` : c.name || c.text || "").filter(Boolean).join(", ");
            }
            narration = `${whoName} scored ${data.points || 0} pts in crib${comboText ? ` (${comboText})` : ""}.`;
            break;
          }
          case "obstacle":
            narration = `Hazard triggered: ${whoName} landed on ${data.name || "Obstacle"} (${data.action || ""}).`;
            break;
          case "game_over":
            narration = `Game Over! ${data.winnerName || whoName} won with ${data.scores?.[data.winner] || data.finalScores?.[data.winner] || 121} points!`;
            break;
          default:
            narration = data.text || "Match event occurred.";
        }
      }
      const eventSnapshot = {
        step,
        round,
        type,
        narration,
        who: data.who || null,
        card: data.card ? { ...data.card } : null,
        starter: data.starter ? { ...data.starter } : _GameReplayManager._activeStarter ? { ..._GameReplayManager._activeStarter } : null,
        count: _GameReplayManager._activeCount,
        scores: { ..._GameReplayManager._activeScores },
        pile: [..._GameReplayManager._activePile],
        crib: [..._GameReplayManager._activeCrib],
        hands: JSON.parse(JSON.stringify(_GameReplayManager._activeHands)),
        cards: data.cards ? [...data.cards] : null,
        combos: Array.isArray(data.combos) ? [...data.combos] : null,
        points: data.points || 0,
        reason: data.reason || null,
        details: data.details || null
      };
      events.push(eventSnapshot);
      if (type === "peg_play" && (data.countAfter === 31 || data.count === 31)) {
        _GameReplayManager._activePile = [];
        _GameReplayManager._activeCount = 0;
      }
      if (type === "round_start") {
        _GameReplayManager._activeRound = round;
      }
    }
    /**
     * Finalizes the current match recording and persists it to storage.
     * @param {string} winner
     * @param {Object} finalScores
     * @param {string} [skunkKind]
     */
    static finishRecording(winner, finalScores = {}, skunkKind = null) {
      if (!_GameReplayManager.currentReplay) {
        return _GameReplayManager.lastRecordedReplay || null;
      }
      const rep = _GameReplayManager.currentReplay;
      if (!rep) return null;
      rep.winner = winner || "p1";
      const p1 = rep.players?.p1?.name || "You";
      const p2 = rep.players?.p2?.name || "Computer";
      rep.winnerName = winner === "p1" || winner === "you" ? p1 : p2;
      rep.finalScores = {
        p1: finalScores.p1 !== void 0 ? finalScores.p1 : finalScores.you || _GameReplayManager._activeScores.p1 || 0,
        p2: finalScores.p2 !== void 0 ? finalScores.p2 : finalScores.cpu || _GameReplayManager._activeScores.p2 || 0
      };
      rep.skunkKind = skunkKind || null;
      rep.totalRounds = _GameReplayManager._activeRound || 1;
      _GameReplayManager.recordEvent("game_over", {
        winner: rep.winner,
        winnerName: rep.winnerName,
        scores: rep.finalScores,
        skunkKind: rep.skunkKind,
        narration: `Game Over! ${rep.winnerName} won the match (${rep.finalScores.p1}\u2013${rep.finalScores.p2})!`
      });
      _GameReplayManager.lastRecordedReplay = rep;
      if (_GameReplayManager.isAutoRecordEnabled()) {
        _GameReplayManager.saveReplay(rep);
      }
      _GameReplayManager.currentReplay = null;
      return rep;
    }
    /**
     * Saves a replay object to persistent storage.
     * @param {Object} replay
     */
    static saveReplay(replay, storage = null) {
      if (!replay || !replay.id) return;
      if (!Array.isArray(replay.events) || replay.events.length <= 2) return;
      try {
        const s = storage || getStorage3();
        const list = _GameReplayManager.loadReplays(s);
        const filtered = list.filter((r) => r.id !== replay.id);
        filtered.unshift(replay);
        const trimmed = filtered.slice(0, MAX_SAVED_REPLAYS);
        const str = JSON.stringify(trimmed);
        if (s) {
          s.setItem(REPLAY_STORAGE_KEY, str);
        }
        if (typeof window !== "undefined" && window.localStorage && s !== window.localStorage) {
          try {
            window.localStorage.setItem(REPLAY_STORAGE_KEY, str);
          } catch (_) {
          }
        }
        try {
          const prof = typeof window !== "undefined" && window.Profile ? window.Profile.getInstance(s) : Profile ? Profile.getInstance(s) : null;
          if (prof && typeof prof.recordReplay === "function") {
            prof.recordReplay(replay, s);
          }
        } catch (_) {
        }
      } catch (err) {
        console.warn("[GameReplayManager] Failed to persist replay:", err);
      }
    }
    /**
     * Loads all saved replays from storage (newest first).
     * @param {Object} [storage=null]
     * @returns {Array<Object>}
     */
    static loadReplays(storage = null) {
      try {
        const s = storage || getStorage3();
        let raw = s ? s.getItem(REPLAY_STORAGE_KEY) : null;
        if (!raw && typeof window !== "undefined" && window.localStorage && s !== window.localStorage) {
          try {
            raw = window.localStorage.getItem(REPLAY_STORAGE_KEY);
          } catch (_) {
          }
        }
        let list = [];
        if (raw) {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) list = parsed;
        }
        try {
          const prof = typeof window !== "undefined" && window.Profile ? window.Profile.getInstance(s) : Profile ? Profile.getInstance(s) : null;
          if (prof && typeof prof.getReplays === "function") {
            const pReps = prof.getReplays(s);
            if (pReps && Array.isArray(pReps.list) && pReps.list.length > 0) {
              const map = /* @__PURE__ */ new Map();
              for (const r of list) {
                if (r && r.id) map.set(r.id, r);
              }
              for (const r of pReps.list) {
                if (r && r.id && !map.has(r.id)) map.set(r.id, r);
              }
              list = Array.from(map.values()).sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
            }
          }
        } catch (_) {
        }
        return list;
      } catch (err) {
        console.warn("[GameReplayManager] Error parsing saved replays:", err);
        return [];
      }
    }
    /**
     * Retrieves a single replay by its unique ID.
     * @param {string} id
     * @param {Object} [storage=null]
     * @returns {Object|null}
     */
    static getReplayById(id, storage = null) {
      if (!id) return null;
      const all = _GameReplayManager.loadReplays(storage);
      const found = all.find((r) => r.id === id);
      if (found) return found;
      if (_GameReplayManager.lastRecordedReplay && _GameReplayManager.lastRecordedReplay.id === id) {
        return _GameReplayManager.lastRecordedReplay;
      }
      return null;
    }
    /**
     * Retrieves saved replays separated by brand.
     * @param {string} [brand='all']
     * @param {Object} [storage=null]
     * @returns {Array<Object>}
     */
    static getReplaysByBrand(brand = "all", storage = null) {
      const all = _GameReplayManager.loadReplays(storage);
      if (!brand || brand === "all") return all;
      return all.filter((r) => (r.brand || "crazy") === brand);
    }
    /**
     * Retrieves summary counts of saved replays for each brand and overall.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static getBrandSummary(storage = null) {
      const all = _GameReplayManager.loadReplays(storage);
      return {
        all: all.length,
        crazy: all.filter((r) => (r.brand || "crazy") === "crazy").length,
        clash: all.filter((r) => (r.brand || "crazy") === "clash").length,
        pints: all.filter((r) => (r.brand || "crazy") === "pints").length,
        adult: all.filter((r) => (r.brand || "crazy") === "adult").length
      };
    }
    /**
     * Deletes a replay by ID.
     * @param {string} id
     * @param {Object} [storage=null]
     */
    static deleteReplay(id, storage = null) {
      if (!id) return;
      if (_GameReplayManager.lastRecordedReplay && _GameReplayManager.lastRecordedReplay.id === id) {
        _GameReplayManager.lastRecordedReplay = null;
      }
      try {
        const s = storage || getStorage3();
        const list = _GameReplayManager.loadReplays(s).filter((r) => r.id !== id);
        if (s) {
          s.setItem(REPLAY_STORAGE_KEY, JSON.stringify(list));
        }
        try {
          const prof = typeof window !== "undefined" && window.Profile ? window.Profile.getInstance(s) : Profile ? Profile.getInstance(s) : null;
          if (prof && typeof prof.deleteReplay === "function") {
            prof.deleteReplay(id, s);
          }
        } catch (_) {
        }
      } catch (err) {
      }
    }
    /**
     * Clears all saved replays.
     * @param {Object} [storage=null]
     */
    static clearAllReplays(storage = null) {
      try {
        const s = storage || getStorage3();
        if (s) s.removeItem(REPLAY_STORAGE_KEY);
        try {
          const prof = typeof window !== "undefined" && window.Profile ? window.Profile.getInstance(s) : Profile ? Profile.getInstance(s) : null;
          if (prof && typeof prof.clearReplays === "function") {
            prof.clearReplays("all", s);
          }
        } catch (_) {
        }
      } catch (_) {
      }
    }
    /**
     * Triggers a browser file download of the replay as a `.cribbage.json` file.
     * @param {Object|string} replayOrId
     */
    static exportReplayFile(replayOrId) {
      const replay = typeof replayOrId === "string" ? _GameReplayManager.getReplayById(replayOrId) : replayOrId;
      if (!replay) {
        console.warn("[GameReplayManager] No replay available to export.");
        return;
      }
      try {
        const json = JSON.stringify(replay, null, 2);
        const blob = new Blob([json], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const cleanDate = (replay.id || "game").replace(/[^a-zA-Z0-9_-]/g, "_");
        a.download = `crazy-cribbage-${cleanDate}.cribbage.json`;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }, 300);
      } catch (err) {
        console.error("[GameReplayManager] Export failed:", err);
      }
    }
    /**
     * Reads and parses a `.json` or `.cribbage.json` file uploaded by the user.
     * @param {File} file
     * @returns {Promise<Object>}
     */
    static importReplayFile(file) {
      return new Promise((resolve, reject) => {
        if (!file) return reject(new Error("No file provided."));
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const replay = JSON.parse(e.target.result);
            if (!replay || !Array.isArray(replay.events)) {
              throw new Error("Invalid replay format: missing events timeline.");
            }
            if (!replay.id) {
              replay.id = `replay_${Date.now()}_imported`;
            }
            _GameReplayManager.saveReplay(replay);
            resolve(replay);
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = () => reject(new Error("Failed to read file."));
        reader.readAsText(file);
      });
    }
    /**
     * Compresses a replay into a URL-safe Base64 string for link sharing.
     * @param {Object} replay
     * @returns {Promise<string>}
     */
    static async compressReplay(replay) {
      if (!replay) return "";
      const jsonStr = JSON.stringify(replay);
      if (typeof CompressionStream !== "undefined") {
        try {
          const stream = new Blob([jsonStr]).stream();
          const compressedStream = stream.pipeThrough(new CompressionStream("deflate-raw"));
          const response = new Response(compressedStream);
          const buffer = await response.arrayBuffer();
          let binary = "";
          const bytes = new Uint8Array(buffer);
          for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        } catch (_) {
        }
      }
      try {
        return btoa(unescape(encodeURIComponent(jsonStr))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
      } catch (_) {
        return encodeURIComponent(jsonStr);
      }
    }
    /**
     * Decompresses a URL parameter string back into a replay object.
     * @param {string} compressedStr
     * @returns {Promise<Object|null>}
     */
    static async decompressReplay(compressedStr) {
      if (!compressedStr) return null;
      let b64 = decodeURIComponent(compressedStr).replace(/-/g, "+").replace(/_/g, "/");
      while (b64.length % 4) b64 += "=";
      if (typeof DecompressionStream !== "undefined") {
        try {
          const binary = atob(b64);
          const bytes = new Uint8Array(binary.length);
          for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
          }
          const stream = new Blob([bytes]).stream();
          const decompressedStream = stream.pipeThrough(new DecompressionStream("deflate-raw"));
          const response = new Response(decompressedStream);
          const text2 = await response.text();
          return JSON.parse(text2);
        } catch (_) {
        }
      }
      try {
        const decoded = decodeURIComponent(escape(atob(b64)));
        return JSON.parse(decoded);
      } catch (_) {
        try {
          return JSON.parse(decodeURIComponent(compressedStr));
        } catch (_2) {
          return null;
        }
      }
    }
    /**
     * Generates a full shareable web URL for this replay.
     * @param {Object} replay
     * @returns {Promise<string>}
     */
    static async generateShareUrl(replay) {
      const compressed = await _GameReplayManager.compressReplay(replay);
      if (!compressed) return "";
      const base = typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "https://crazycribbage.com";
      return `${base}?replay=${compressed}`;
    }
    static _toastTimer = null;
    /**
     * Prominent floating toast notification rendered on top of all modals/overlays (z-index: 99999).
     * @param {string} msg
     * @param {number} [duration=3000]
     */
    static showToast(msg, duration = 3e3) {
      if (typeof document === "undefined") return;
      let toast = document.getElementById("replayToast");
      if (!toast) {
        toast = document.createElement("div");
        toast.id = "replayToast";
        toast.style.cssText = `
        position: fixed;
        bottom: 32px;
        left: 50%;
        transform: translateX(-50%) translateY(20px);
        background: #1e1505;
        border: 1.5px solid #f0c64a;
        color: #f0c64a;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        font-weight: 700;
        font-size: 0.95rem;
        padding: 10px 22px;
        border-radius: 24px;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.85);
        z-index: 99999;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.25s ease, transform 0.25s ease;
        text-align: center;
        max-width: 90vw;
      `;
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      requestAnimationFrame(() => {
        toast.style.opacity = "1";
        toast.style.transform = "translateX(-50%) translateY(0)";
      });
      clearTimeout(_GameReplayManager._toastTimer);
      _GameReplayManager._toastTimer = setTimeout(() => {
        if (toast) {
          toast.style.opacity = "0";
          toast.style.transform = "translateX(-50%) translateY(20px)";
        }
      }, duration);
    }
    /**
     * Convenience launcher: opens the replay of the game that just finished.
     */
    static playCurrentGameReplay() {
      const replay = _GameReplayManager.lastRecordedReplay || _GameReplayManager.loadReplays()[0];
      const repModal = typeof window !== "undefined" && window.ReplayModal || typeof globalThis !== "undefined" && globalThis.ReplayModal || typeof window !== "undefined" && window.CrazyCribbage?.ReplayModal;
      if (replay && repModal && typeof repModal.open === "function") {
        repModal.open(replay);
        return;
      }
      _GameReplayManager.showToast("No recorded game replay available yet.", 3e3);
    }
    /**
     * Convenience sharer: triggers sharing dialog for the game that just finished.
     */
    static shareCurrentGameReplay() {
      const replay = _GameReplayManager.lastRecordedReplay || _GameReplayManager.loadReplays()[0];
      const repModal = typeof window !== "undefined" && window.ReplayModal || typeof globalThis !== "undefined" && globalThis.ReplayModal || typeof window !== "undefined" && window.CrazyCribbage?.ReplayModal;
      if (replay && repModal && typeof repModal.openShareDialog === "function") {
        repModal.openShareDialog(replay);
        return;
      }
      _GameReplayManager.showToast("No recorded game replay available to share.", 3e3);
    }
  };

  // src/stats/HandScoreTracker.js
  var HandScoreTracker = class _HandScoreTracker {
    static hands = [];
    /**
     * Resets the tracked hands for a fresh match.
     */
    static reset() {
      _HandScoreTracker.hands = [];
    }
    /**
     * Returns a copy of the tracked hands.
     * @returns {Array}
     */
    static getHands() {
      return [..._HandScoreTracker.hands];
    }
    /**
     * Formats a card object into a compact mini-badge string.
     * @param {Object} card
     * @returns {string}
     */
    static formatMiniCard(card) {
      if (!card) return "\u2014";
      const r = card.r || card.rank || "";
      const s = card.s || card.suit || "";
      const isRed = s === "H" || s === "D";
      const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const sym = suitSyms[s] || s;
      const rankNames = { 1: "A", 11: "J", 12: "Q", 13: "K" };
      const rName = rankNames[r] || r;
      const textColor = isRed ? "#dc2626" : "#111111";
      return `<span class="sc-cut-card ${isRed ? "sc-red red" : "sc-black black"}" style="color:${textColor} !important; -webkit-text-fill-color:${textColor} !important; background:#ffffff !important;">${rName}${sym}</span>`;
    }
    /**
     * Records a completed hand from the show scoring phase.
     * @param {Object} state - Current GameState
     * @param {Object} settings - Active game settings
     * @param {Object} [options]
     * @returns {Object} The recorded hand record
     */
    static recordHand(state3, settings3 = {}, options = {}) {
      if (!state3) return null;
      const pName2 = options.pName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : ((s) => s === "you" ? "You" : s === "cpu" ? "Computer" : s));
      const isPart = options.isPartnership || (typeof window !== "undefined" && typeof window.isPartnership === "function" ? window.isPartnership() : false);
      const count = settings3.playerCount || 2;
      const handNum = _HandScoreTracker.hands.length + 1;
      const ls = state3.lastShow || {};
      const handRecord = {
        handNumber: handNum,
        dealer: state3.dealer,
        dealerName: pName2(state3.dealer),
        starter: state3.starter ? { ...state3.starter } : null,
        scores: {},
        isPartnership: isPart,
        endedMidPlay: false
      };
      if (count === 2 && !isPart) {
        const youPeg = state3.handPeg && (state3.handPeg.you ?? state3.handPeg.p1) || 0;
        const cpuPeg = state3.handPeg && (state3.handPeg.cpu ?? state3.handPeg.p2) || 0;
        const dealerIsYou = state3.dealer === "you" || state3.dealer === "p1";
        const poneKey = dealerIsYou ? "cpu" : "you";
        const dealerKey = dealerIsYou ? "you" : "cpu";
        const poneScore = ls.pone && ls.pone.score || { total: 0 };
        const dealScore = ls.dealer && ls.dealer.score || { total: 0 };
        const cribSigned = ls.crib ? ls.crib.signed ?? 0 : 0;
        const poneCounted = ls.pone && ls.pone.blockedByZone ? 0 : poneScore.total;
        const dealCounted = ls.dealer && ls.dealer.blockedByZone ? 0 : dealScore.total;
        const cribCounted = ls.crib && ls.crib.blockedByZone ? 0 : cribSigned;
        const cribRecipient = ls.crib && ls.crib.who || dealerKey;
        const youGotCrib = cribRecipient === "you" || cribRecipient === "p1";
        const youHand = poneKey === "you" ? poneCounted : dealCounted;
        const cpuHand = poneKey === "cpu" ? poneCounted : dealCounted;
        const youCrib = youGotCrib ? cribCounted : 0;
        const cpuCrib = !youGotCrib ? cribCounted : 0;
        const youRound = youPeg + youHand + youCrib;
        const cpuRound = cpuPeg + cpuHand + cpuCrib;
        const youTotal = state3.scores ? state3.scores.you ?? state3.scores.p1 ?? 0 : 0;
        const cpuTotal = state3.scores ? state3.scores.cpu ?? state3.scores.p2 ?? 0 : 0;
        handRecord.scores["p1"] = {
          id: "p1",
          name: pName2("you"),
          isDealer: dealerIsYou,
          pegged: youPeg,
          hand: youHand,
          crib: youCrib,
          hasCrib: youGotCrib,
          roundTotal: youRound,
          runningTotal: youTotal
        };
        handRecord.scores["p2"] = {
          id: "p2",
          name: pName2("cpu"),
          isDealer: !dealerIsYou,
          pegged: cpuPeg,
          hand: cpuHand,
          crib: cpuCrib,
          hasCrib: !youGotCrib,
          roundTotal: cpuRound,
          runningTotal: cpuTotal
        };
      } else if (isPart) {
        const t1Peg = state3.handPeg && state3.handPeg.team1 || 0;
        const t2Peg = state3.handPeg && state3.handPeg.team2 || 0;
        let t1Hand = 0, t2Hand = 0, t1Crib = 0, t2Crib = 0;
        const cribRecipient = ls.crib && ls.crib.who || state3.dealer;
        const cribCounted = ls.crib && ls.crib.blockedByZone ? 0 : ls.crib ? ls.crib.signed ?? 0 : 0;
        const isTeam1Crib = cribRecipient === "p1" || cribRecipient === "p3" || cribRecipient === "team1";
        if (isTeam1Crib) t1Crib = cribCounted;
        else t2Crib = cribCounted;
        const q = state3.showQueue || [];
        q.forEach((key) => {
          if (key === "crib") return;
          const pack = ls[key];
          if (!pack) return;
          const pts = pack.blockedByZone ? 0 : pack.score?.total || 0;
          const who = pack.who || key;
          if (who === "p1" || who === "p3" || who === "team1") {
            t1Hand += pts;
          } else {
            t2Hand += pts;
          }
        });
        const t1Round = t1Peg + t1Hand + t1Crib;
        const t2Round = t2Peg + t2Hand + t2Crib;
        handRecord.scores["team1"] = {
          id: "team1",
          name: pName2("team1") || "Team 1",
          isDealer: isTeam1Crib,
          pegged: t1Peg,
          hand: t1Hand,
          crib: t1Crib,
          hasCrib: isTeam1Crib,
          roundTotal: t1Round,
          runningTotal: state3.scores ? state3.scores.team1 || 0 : 0
        };
        handRecord.scores["team2"] = {
          id: "team2",
          name: pName2("team2") || "Team 2",
          isDealer: !isTeam1Crib,
          pegged: t2Peg,
          hand: t2Hand,
          crib: t2Crib,
          hasCrib: !isTeam1Crib,
          roundTotal: t2Round,
          runningTotal: state3.scores ? state3.scores.team2 || 0 : 0
        };
      } else {
        const activeSeats = typeof window !== "undefined" && typeof window.getActiveSeats === "function" ? window.getActiveSeats() : [{ id: "p1", name: "Seat 1" }, { id: "p2", name: "Seat 2" }, { id: "p3", name: "Seat 3" }];
        const cribRecipient = ls.crib && ls.crib.who || state3.dealer;
        const cribCounted = ls.crib && ls.crib.blockedByZone ? 0 : ls.crib ? ls.crib.signed ?? 0 : 0;
        activeSeats.forEach((s) => {
          const sId = s.id;
          const sPeg = state3.handPeg && state3.handPeg[sId] || 0;
          const pack = ls[sId];
          const sHand = pack ? pack.blockedByZone ? 0 : pack.score?.total || 0 : 0;
          const isCribSeat = cribRecipient === sId;
          const sCrib = isCribSeat ? cribCounted : 0;
          const sRound = sPeg + sHand + sCrib;
          const sTotal = state3.scores ? state3.scores[sId] || 0 : 0;
          handRecord.scores[sId] = {
            id: sId,
            name: s.name || pName2(sId),
            isDealer: state3.dealer === sId,
            pegged: sPeg,
            hand: sHand,
            crib: sCrib,
            hasCrib: isCribSeat,
            roundTotal: sRound,
            runningTotal: sTotal
          };
        });
      }
      state3.handRecorded = true;
      _HandScoreTracker.hands.push(handRecord);
      try {
        const repMgr = typeof window !== "undefined" && window.CrazyCribbage?.GameReplayManager || GameReplayManager || (typeof window !== "undefined" ? window.GameReplayManager : null);
        if (repMgr && repMgr.currentReplay) {
          if (ls.pone?._replayRecorded || ls.dealer?._replayRecorded || ls.crib?._replayRecorded) {
            return handRecord;
          }
          if (count === 2 && !isPart) {
            const dealerIsYou = state3.dealer === "you" || state3.dealer === "p1";
            const poneKey = dealerIsYou ? "cpu" : "you";
            const dealerKey = dealerIsYou ? "you" : "cpu";
            const poneScore = ls.pone && ls.pone.score || { total: 0 };
            const dealScore = ls.dealer && ls.dealer.score || { total: 0 };
            const cribSigned = ls.crib ? ls.crib.signed ?? 0 : 0;
            const poneCounted = ls.pone && ls.pone.blockedByZone ? 0 : poneScore.total;
            const dealCounted = ls.dealer && ls.dealer.blockedByZone ? 0 : dealScore.total;
            const cribCounted = ls.crib && ls.crib.blockedByZone ? 0 : cribSigned;
            const cribRecipient = ls.crib && ls.crib.who || dealerKey;
            const youGotCrib = cribRecipient === "you" || cribRecipient === "p1";
            const youEnd = state3.scores ? state3.scores.you ?? state3.scores.p1 ?? 0 : 0;
            const cpuEnd = state3.scores ? state3.scores.cpu ?? state3.scores.p2 ?? 0 : 0;
            const youHand = poneKey === "you" ? poneCounted : dealCounted;
            const cpuHand = poneKey === "cpu" ? poneCounted : dealCounted;
            const youCrib = youGotCrib ? cribCounted : 0;
            const cpuCrib = !youGotCrib ? cribCounted : 0;
            const youPreShow = youEnd - youHand - youCrib;
            const cpuPreShow = cpuEnd - cpuHand - cpuCrib;
            const p1AfterPone = poneKey === "you" ? youPreShow + poneCounted : youPreShow;
            const p2AfterPone = poneKey === "cpu" ? cpuPreShow + poneCounted : cpuPreShow;
            repMgr.recordEvent("show_hand", {
              round: handNum,
              who: poneKey === "you" ? "p1" : "p2",
              starter: state3.starter,
              cards: ls.pone?.cards || [],
              points: poneCounted,
              combos: ls.pone?.score?.lines || ls.pone?.score?.items || ls.pone?.score?.notes || [],
              scores: { p1: p1AfterPone, p2: p2AfterPone }
            });
            const p1AfterDeal = p1AfterPone + (dealerKey === "you" ? dealCounted : 0);
            const p2AfterDeal = p2AfterPone + (dealerKey === "cpu" ? dealCounted : 0);
            repMgr.recordEvent("show_hand", {
              round: handNum,
              who: dealerKey === "you" ? "p1" : "p2",
              starter: state3.starter,
              cards: ls.dealer?.cards || [],
              points: dealCounted,
              combos: ls.dealer?.score?.lines || ls.dealer?.score?.items || ls.dealer?.score?.notes || [],
              scores: { p1: p1AfterDeal, p2: p2AfterDeal }
            });
            if (cribCounted > 0 || state3.crib && state3.crib.length || ls.crib && ls.crib.cards) {
              const p1AfterCrib = p1AfterDeal + (youGotCrib ? cribCounted : 0);
              const p2AfterCrib = p2AfterDeal + (!youGotCrib ? cribCounted : 0);
              repMgr.recordEvent("show_crib", {
                round: handNum,
                who: youGotCrib ? "p1" : "p2",
                starter: state3.starter,
                cards: state3.crib || ls.crib?.cards || [],
                points: cribCounted,
                combos: ls.crib?.score?.lines || ls.crib?.score?.items || ls.crib?.score?.notes || [],
                scores: { p1: p1AfterCrib, p2: p2AfterCrib }
              });
            }
          } else {
            const q = state3.showQueue || Object.keys(ls);
            for (const key of q) {
              if (key === "crib") {
                const pack = ls.crib;
                const cribPts = pack ? pack.blockedByZone ? 0 : pack.signed ?? pack.score?.total ?? 0 : 0;
                repMgr.recordEvent("show_crib", {
                  round: handNum,
                  who: pack?.who || state3.dealer || "p1",
                  starter: state3.starter,
                  cards: pack?.cards || state3.crib || [],
                  points: cribPts,
                  combos: pack?.score?.lines || pack?.score?.items || pack?.score?.notes || [],
                  scores: state3.scores
                });
              } else if (ls[key]) {
                const pack = ls[key];
                const handPts = pack ? pack.blockedByZone ? 0 : pack.score?.total || 0 : 0;
                repMgr.recordEvent("show_hand", {
                  round: handNum,
                  who: pack.who || key,
                  starter: state3.starter,
                  cards: pack.cards || [],
                  points: handPts,
                  combos: pack.score?.lines || pack.score?.items || pack.score?.notes || [],
                  scores: state3.scores
                });
              }
            }
          }
        }
      } catch (_) {
      }
      return handRecord;
    }
    /**
     * If game ended during pegging (before show phase), records the final partial hand.
     * @param {Object} state
     * @param {Object} settings
     * @param {string} [winner]
     * @param {Object} [options]
     */
    static recordFinalPartialHand(state3, settings3 = {}, winner = null, options = {}) {
      if (!state3 || state3.handRecorded) return null;
      const pName2 = options.pName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : ((s) => s === "you" ? "You" : s === "cpu" ? "Computer" : s));
      const isPart = options.isPartnership || (typeof window !== "undefined" && typeof window.isPartnership === "function" ? window.isPartnership() : false);
      const count = settings3.playerCount || 2;
      const handNum = _HandScoreTracker.hands.length + 1;
      const handRecord = {
        handNumber: handNum,
        dealer: state3.dealer,
        dealerName: pName2(state3.dealer),
        starter: state3.starter ? { ...state3.starter } : null,
        scores: {},
        isPartnership: isPart,
        endedMidPlay: true
      };
      if (count === 2 && !isPart) {
        const youPeg = state3.handPeg && (state3.handPeg.you ?? state3.handPeg.p1) || 0;
        const cpuPeg = state3.handPeg && (state3.handPeg.cpu ?? state3.handPeg.p2) || 0;
        const dealerIsYou = state3.dealer === "you" || state3.dealer === "p1";
        handRecord.scores["p1"] = {
          id: "p1",
          name: pName2("you"),
          isDealer: dealerIsYou,
          pegged: youPeg,
          hand: 0,
          crib: 0,
          hasCrib: dealerIsYou,
          roundTotal: youPeg,
          runningTotal: state3.scores ? state3.scores.you ?? state3.scores.p1 ?? 0 : 0
        };
        handRecord.scores["p2"] = {
          id: "p2",
          name: pName2("cpu"),
          isDealer: !dealerIsYou,
          pegged: cpuPeg,
          hand: 0,
          crib: 0,
          hasCrib: !dealerIsYou,
          roundTotal: cpuPeg,
          runningTotal: state3.scores ? state3.scores.cpu ?? state3.scores.p2 ?? 0 : 0
        };
      } else if (isPart) {
        const t1Peg = state3.handPeg && state3.handPeg.team1 || 0;
        const t2Peg = state3.handPeg && state3.handPeg.team2 || 0;
        const isTeam1Dealer = state3.dealer === "p1" || state3.dealer === "p3" || state3.dealer === "team1";
        handRecord.scores["team1"] = {
          id: "team1",
          name: pName2("team1") || "Team 1",
          isDealer: isTeam1Dealer,
          pegged: t1Peg,
          hand: 0,
          crib: 0,
          hasCrib: isTeam1Dealer,
          roundTotal: t1Peg,
          runningTotal: state3.scores ? state3.scores.team1 || 0 : 0
        };
        handRecord.scores["team2"] = {
          id: "team2",
          name: pName2("team2") || "Team 2",
          isDealer: !isTeam1Dealer,
          pegged: t2Peg,
          hand: 0,
          crib: 0,
          hasCrib: !isTeam1Dealer,
          roundTotal: t2Peg,
          runningTotal: state3.scores ? state3.scores.team2 || 0 : 0
        };
      } else {
        const activeSeats = typeof window !== "undefined" && typeof window.getActiveSeats === "function" ? window.getActiveSeats() : [{ id: "p1", name: "Seat 1" }, { id: "p2", name: "Seat 2" }, { id: "p3", name: "Seat 3" }];
        activeSeats.forEach((s) => {
          const sId = s.id;
          const sPeg = state3.handPeg && state3.handPeg[sId] || 0;
          handRecord.scores[sId] = {
            id: sId,
            name: s.name || pName2(sId),
            isDealer: state3.dealer === sId,
            pegged: sPeg,
            hand: 0,
            crib: 0,
            hasCrib: state3.dealer === sId,
            roundTotal: sPeg,
            runningTotal: state3.scores ? state3.scores[sId] || 0 : 0
          };
        });
      }
      state3.handRecorded = true;
      _HandScoreTracker.hands.push(handRecord);
      return handRecord;
    }
    /**
     * Calculates overall aggregate statistics across all recorded hands.
     * @returns {Object}
     */
    static getStats() {
      const hands = _HandScoreTracker.hands;
      if (!hands.length) {
        return { totalHands: 0, participants: {} };
      }
      const participants = {};
      const firstHand = hands[0];
      Object.keys(firstHand.scores).forEach((key) => {
        participants[key] = {
          name: firstHand.scores[key].name,
          totalPegged: 0,
          totalHand: 0,
          totalCrib: 0,
          totalRound: 0,
          highestHand: 0,
          highestPeg: 0,
          finalScore: 0
        };
      });
      hands.forEach((h) => {
        Object.keys(h.scores).forEach((key) => {
          if (!participants[key]) {
            participants[key] = {
              name: h.scores[key].name,
              totalPegged: 0,
              totalHand: 0,
              totalCrib: 0,
              totalRound: 0,
              highestHand: 0,
              highestPeg: 0,
              finalScore: 0
            };
          }
          const s = h.scores[key];
          const p = participants[key];
          p.totalPegged += s.pegged || 0;
          p.totalHand += s.hand || 0;
          p.totalCrib += s.crib || 0;
          p.totalRound += s.roundTotal || 0;
          if ((s.hand || 0) > p.highestHand) p.highestHand = s.hand;
          if ((s.pegged || 0) > p.highestPeg) p.highestPeg = s.pegged;
          p.finalScore = s.runningTotal || 0;
        });
      });
      return {
        totalHands: hands.length,
        participants
      };
    }
    /**
     * Builds the complete scorecard table and summary modal HTML.
     * @param {Object} [context]
     * @returns {string} HTML string for modal display
     */
    static buildScorecardHtml(context = {}) {
      const hands = _HandScoreTracker.hands;
      const state3 = context.state || (typeof window !== "undefined" && window.state ? window.state : {});
      const settings3 = context.settings || (typeof window !== "undefined" && window.settings ? window.settings : {});
      const target = settings3.target || 121;
      const isGameOver = Boolean(state3 && state3.over);
      if (!hands.length) {
        return `
        <div class="scorecard-wrap">
          <div class="scorecard-header">
            <h2>\u{1F4CA} Game Scorecard &amp; Summary</h2>
            <p class="sc-subtitle">Target: ${target} pts \xB7 High Ball</p>
          </div>
          <div class="sc-empty-state">
            <div style="font-size:2.8rem;margin-bottom:8px;">\u{1F0CF}</div>
            <p style="font-weight:700;color:var(--gold,#f0c64a);margin-bottom:6px;">No Completed Hands Yet</p>
            <p style="color:#d7e8dc;font-size:0.92rem;line-height:1.5;">Scores and points will be tracked automatically hand-by-hand as pegging and hands are completed.</p>
          </div>
          <div class="sc-actions sc-actions-centered">
            <button type="button" class="btn-gold sc-btn sc-btn-back modal-btn-close" id="btnCloseScorecardEmpty">\u2715 Close Scorecard</button>
          </div>
        </div>
      `;
      }
      const stats = _HandScoreTracker.getStats();
      const pKeys = Object.keys(hands[0].scores);
      let bestHandText = "\u2014";
      let bestHandPts = -1;
      let bestHandPlayer = "";
      pKeys.forEach((k) => {
        const p = stats.participants[k];
        if (p && p.highestHand > bestHandPts) {
          bestHandPts = p.highestHand;
          bestHandPlayer = p.name;
        }
      });
      if (bestHandPts >= 0) {
        bestHandText = `${bestHandPts} pts <span class="sc-badge-sub">(${bestHandPlayer})</span>`;
      }
      const topPegPlayer = pKeys.reduce((best, k) => {
        const cur = stats.participants[k]?.totalPegged || 0;
        return cur > (best.pts || 0) ? { name: stats.participants[k]?.name, pts: cur } : best;
      }, { name: "", pts: -1 });
      const badgesHtml = `
      <div class="sc-badge-grid">
        <div class="sc-stat-pill">
          <span class="sc-stat-label">Hands Played</span>
          <span class="sc-stat-val">${stats.totalHands}</span>
        </div>
        <div class="sc-stat-pill ${bestHandPts >= 12 ? "clickable-stat-pill" : ""}" ${bestHandPts >= 12 ? `data-action="show-glory" style="cursor:pointer;" title="Click to view &amp; share Hand of Glory card"` : ""}>
          <span class="sc-stat-label">Top Hand ${bestHandPts >= 12 ? "\u{1F3C6}" : ""}</span>
          <span class="sc-stat-val gold">${bestHandText}</span>
        </div>
        <div class="sc-stat-pill">
          <span class="sc-stat-label">Peg Leader</span>
          <span class="sc-stat-val">${topPegPlayer.name} (${topPegPlayer.pts})</span>
        </div>
      </div>
    `;
      let playerColsHeader = "";
      let subHeaders = "";
      pKeys.forEach((k, idx) => {
        const p = stats.participants[k];
        const isP1 = idx === 0;
        let avatarHtml = "";
        if (isP1) {
          const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
          if (avMgr && typeof avMgr.getSelectedAvatarId === "function") {
            avatarHtml = `<span style="vertical-align:middle;margin-right:4px;">${avMgr.renderAvatarBadge(avMgr.getSelectedAvatarId(), { size: 18, showRing: false })}</span>`;
          }
        }
        playerColsHeader += `<th colspan="5" class="sc-th-player ${isP1 ? "sc-p1-col" : "sc-p2-col"}">${avatarHtml}${p ? p.name : k}</th>`;
        subHeaders += `
        <th class="sc-th-sub" title="Pegging Points">Peg</th>
        <th class="sc-th-sub" title="Hand Score">Hand</th>
        <th class="sc-th-sub" title="Crib Score">Crib</th>
        <th class="sc-th-sub sc-rnd" title="Round Total">Rnd</th>
        <th class="sc-th-sub sc-tot" title="Running Match Total">Total</th>
      `;
      });
      const rowsHtml = hands.map((h) => {
        const cutHtml = _HandScoreTracker.formatMiniCard(h.starter);
        let playerCells = "";
        pKeys.forEach((k, idx) => {
          const s = h.scores[k] || { pegged: 0, hand: 0, crib: 0, roundTotal: 0, runningTotal: 0, isDealer: false };
          const isDealer = s.isDealer;
          const dealerCrown = isDealer ? '<span class="sc-dealer-icon" title="Dealer">\u{1F451}</span>' : "";
          const cribDisplay = s.hasCrib ? `+${s.crib}` : '<span style="opacity:0.35;">\u2014</span>';
          const midPlayTag = h.endedMidPlay ? ' <span class="sc-midplay" title="Game ended during pegging">*</span>' : "";
          playerCells += `
          <td class="sc-num sc-peg">+${s.pegged}</td>
          <td class="sc-num sc-hand">${h.endedMidPlay ? "\u2014" : s.hand}</td>
          <td class="sc-num sc-crib">${cribDisplay}</td>
          <td class="sc-num sc-round"><strong>${s.roundTotal}</strong>${midPlayTag}</td>
          <td class="sc-num sc-running"><span class="sc-total-pill">${s.runningTotal}</span></td>
        `;
        });
        return `
        <tr>
          <td class="sc-hand-col">
            <span class="sc-hand-num">${h.handNumber}</span>
            <span class="sc-dealer-cell" title="Dealer: ${h.dealerName}">\u{1F451} ${h.dealerName}</span>
          </td>
          <td class="sc-cut-col">${cutHtml}</td>
          ${playerCells}
        </tr>
      `;
      }).join("");
      let footerCells = "";
      pKeys.forEach((k) => {
        const p = stats.participants[k] || { totalPegged: 0, totalHand: 0, totalCrib: 0, totalRound: 0, finalScore: 0 };
        footerCells += `
        <td class="sc-num sc-peg"><strong>${p.totalPegged}</strong></td>
        <td class="sc-num sc-hand"><strong>${p.totalHand}</strong></td>
        <td class="sc-num sc-crib"><strong>${p.totalCrib}</strong></td>
        <td class="sc-num sc-round"><strong>${p.totalRound}</strong></td>
        <td class="sc-num sc-running"><strong class="sc-final-pill">${p.finalScore}</strong></td>
      `;
      });
      const isTournament = Boolean(
        settings3 && settings3.isTournamentMatch || context && (context.isTournament || context.isTournamentMatch) || typeof window !== "undefined" && window.settings && window.settings.isTournamentMatch
      );
      const actionBtn = isGameOver && !isTournament ? `<button type="button" class="sc-btn sc-btn-rematch" id="btnScorecardRematch" data-action="rematch">\u{1F501} Rematch</button>` : isGameOver && isTournament ? `<button type="button" class="sc-btn sc-btn-tourney" id="btnScorecardTourney" data-action="tourney">\u{1F3C6} Tournament Bracket</button>` : "";
      const coachBtn = isGameOver ? `<button type="button" class="sc-btn sc-btn-coach" id="btnScorecardCoach" data-action="coach">\u{1F393} Coach's Post-Mortem</button>` : "";
      const backBtnText = isGameOver ? "\u{1F3C6} Back to Game Results" : "\u2715 Close Scorecard";
      return `
      <div class="scorecard-wrap">
        <div class="scorecard-header">
          <h2>\u{1F4CA} Game Scorecard &amp; Summary</h2>
          <p class="sc-subtitle">Target: ${target} pts \xB7 High Ball \xB7 ${hands.length} Hand${hands.length === 1 ? "" : "s"} Logged</p>
        </div>
        ${badgesHtml}
        <div class="sc-table-container">
          <table class="scorecard-table">
            <thead>
              <tr class="sc-top-header">
                <th rowspan="2" class="sc-th-hand">Hand</th>
                <th rowspan="2" class="sc-th-cut">Cut</th>
                ${playerColsHeader}
              </tr>
              <tr class="sc-sub-header">
                ${subHeaders}
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
            <tfoot>
              <tr class="sc-totals-row">
                <td colspan="2" class="sc-totals-label">TOTALS</td>
                ${footerCells}
              </tr>
            </tfoot>
          </table>
        </div>
        <div style="font-size:0.78rem;color:#d7e8dc;opacity:0.75;margin:8px 0 14px;text-align:center;">
          \u{1F451} = Dealer for the hand &nbsp;\xB7&nbsp; Running total tracks cumulative board score after each hand
        </div>
        <div class="sc-actions${!coachBtn && !actionBtn ? " sc-actions-centered" : ""}">
          ${coachBtn || actionBtn ? `
            <div class="sc-actions-tools">
              ${coachBtn}
              ${actionBtn}
            </div>
          ` : ""}
          <div class="sc-actions-main">
            <button type="button" class="btn-gold sc-btn sc-btn-back modal-btn-close" id="btnCloseScorecard" data-action="close">${backBtnText}</button>
          </div>
        </div>
      </div>
    `;
    }
    /**
     * Binds click event listeners for elements inside a scorecard container.
     * @param {Element|Document} [root=document]
     */
    static bindEvents(root = typeof document !== "undefined" ? document : null) {
      if (!root || typeof root.querySelector !== "function") return;
      const rematchBtn = root.querySelector('#btnScorecardRematch, [data-action="rematch"]');
      if (rematchBtn && !rematchBtn._boundScorecard) {
        rematchBtn._boundScorecard = true;
        rematchBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.playAgain === "function") {
            window.playAgain();
          }
        });
      }
      const tourneyBtn = root.querySelector('#btnScorecardTourney, [data-action="tourney"]');
      if (tourneyBtn && !tourneyBtn._boundScorecard) {
        tourneyBtn._boundScorecard = true;
        tourneyBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.hideModal === "function") window.hideModal();
          if (typeof window !== "undefined" && window.TournamentModal && typeof window.TournamentModal.open === "function") {
            window.TournamentModal.open();
          }
        });
      }
      const coachBtn = root.querySelector('#btnScorecardCoach, [data-action="coach"]');
      if (coachBtn && !coachBtn._boundScorecard) {
        coachBtn._boundScorecard = true;
        coachBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.showCoachPostMortemModal === "function") {
            window.showCoachPostMortemModal();
          } else if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showCoachPostMortemModal === "function") {
            window.modalManager.showCoachPostMortemModal();
          }
        });
      }
      const gloryPill = root.querySelector('.clickable-stat-pill, [data-action="show-glory"]');
      if (gloryPill && !gloryPill._boundScorecard) {
        gloryPill._boundScorecard = true;
        gloryPill.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.showHandOfGloryModal === "function") {
            window.showHandOfGloryModal("best");
          }
        });
      }
      const closeBtn = root.querySelector("#btnCloseScorecard");
      if (closeBtn && !closeBtn._boundScorecard) {
        closeBtn._boundScorecard = true;
        closeBtn.addEventListener("click", (e) => {
          if (e && e.stopPropagation) e.stopPropagation();
          if (typeof window !== "undefined" && typeof window.showGameWonModal === "function" && window.showGameWonModal()) {
            return;
          } else if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showGameWonModal === "function" && window.modalManager.showGameWonModal()) {
            return;
          } else if (typeof window !== "undefined" && typeof window.hideModal === "function") {
            window.hideModal();
          }
        });
      }
      const emptyCloseBtn = root.querySelector("#btnCloseScorecardEmpty");
      if (emptyCloseBtn && !emptyCloseBtn._boundScorecard) {
        emptyCloseBtn._boundScorecard = true;
        emptyCloseBtn.addEventListener("click", (e) => {
          if (e && e.stopPropagation) e.stopPropagation();
          if (typeof window !== "undefined" && typeof window.hideModal === "function") {
            window.hideModal();
          }
        });
      }
    }
  };

  // src/trainer/DiscardTrainer.js
  var BASE_CRIB_VALUES = {
    "5-5": 8.8,
    "2-3": 5.4,
    "7-8": 5.3,
    "4-5": 5.6,
    "5-6": 5.7,
    "3-3": 5,
    "4-4": 4.7,
    "6-6": 4.9,
    "7-7": 5.2,
    "8-8": 5,
    "9-9": 4.6,
    "10-10": 4.4,
    "J-J": 4.8,
    "Q-Q": 4.4,
    "K-K": 4.2,
    "A-A": 4.3,
    "A-4": 4.9,
    "2-4": 4.5,
    "6-9": 4.7,
    "7-9": 4.6,
    "8-9": 4.8,
    "J-5": 6.2,
    "Q-5": 5.9,
    "K-5": 5.8,
    "10-5": 5.9,
    "A-5": 5.6,
    "2-5": 5.5,
    "3-5": 5.7
  };
  var DiscardTrainer = class _DiscardTrainer {
    /**
     * Session state for continuous practice statistics.
     */
    static stats = {
      handsPlayed: 0,
      optimalCount: 0,
      totalLossEV: 0
    };
    /**
     * Resets session statistics, and optionally career statistics in profile.
     * @param {Object} [options={}]
     */
    static resetStats(options = {}) {
      _DiscardTrainer.stats = {
        handsPlayed: 0,
        optimalCount: 0,
        totalLossEV: 0
      };
      if (options && options.career) {
        try {
          Profile.getInstance(options.storage).clearDiscardTrainerStats(options.storage);
        } catch (_) {
        }
      }
    }
    /**
     * Retrieves current session stats and global career stats from Profile.
     * @param {Object} [storage=null]
     * @returns {{ session: Object, career: Object }}
     */
    static getStats(storage = null) {
      const session = {
        ..._DiscardTrainer.stats,
        accuracyPct: _DiscardTrainer.stats.handsPlayed > 0 ? Math.round(_DiscardTrainer.stats.optimalCount / _DiscardTrainer.stats.handsPlayed * 100) : 0
      };
      let career = null;
      try {
        career = Profile.getInstance(storage).getDiscardTrainerStats(storage);
      } catch (_) {
      }
      return { session, career };
    }
    /**
     * Retrieves player's global career stats across all brands.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static getCareerStats(storage = null) {
      try {
        return Profile.getInstance(storage).getDiscardTrainerStats(storage);
      } catch (_) {
        return null;
      }
    }
    /**
     * Deals 6 random cards from a fresh 52-card deck.
     * @returns {Card[]}
     */
    static dealRandomHand() {
      const deck = Deck2.makeDeck(1, false);
      const shuffled = Deck2.shuffleArray(deck);
      return shuffled.slice(0, 6);
    }
    /**
     * Parses string representation or validates array into 6 Card instances.
     * e.g. "5H, 5D, JC, QS, 7S, 8C" or ["5H", "5D", ...]
     * @param {string|Array} input
     * @returns {Card[]|null}
     */
    static parseHand(input) {
      if (Array.isArray(input)) {
        if (input.length === 6 && input.every((c) => c instanceof Card2 || c && (c.rank !== void 0 || c.r !== void 0) && (c.suit || c.s))) {
          return input.map((c) => c instanceof Card2 ? c : Card2.from(c));
        }
        return _DiscardTrainer.parseHand(input.join(" "));
      }
      if (typeof input !== "string") return null;
      const tokens = input.trim().toUpperCase().split(/[\s,;]+/);
      if (tokens.length !== 6) return null;
      const rankMap = { A: 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9, "10": 10, J: 11, Q: 12, K: 13 };
      const cards = [];
      const seen = /* @__PURE__ */ new Set();
      for (const t of tokens) {
        const match = t.match(/^([2-9]|10|[JQKA])([SHDC])$/);
        if (!match) return null;
        const rankToken = match[1];
        const suit = match[2];
        const r = rankMap[rankToken];
        const id = `${rankToken}${suit}`;
        if (seen.has(id)) return null;
        seen.add(id);
        cards.push(new Card2({ r, s: suit, id }));
      }
      return cards.length === 6 ? cards : null;
    }
    /**
     * Estimates Expected Crib Value of a 2-card discard pair.
     * @param {Card[]} disc The 2 cards tossed to the crib
     * @param {boolean} isDealer Whether it is the player's own crib
     * @returns {number} Expected points
     */
    static estimateCribEV(disc, isDealer = true) {
      if (!disc || !disc.length) return 4.5;
      if (disc.length === 3) {
        const pairs = combinations(disc, 2);
        let avg = 0;
        for (const p of pairs) {
          avg += _DiscardTrainer.estimateCribEV(p, isDealer);
        }
        return Number((avg / pairs.length * 1.5).toFixed(2));
      }
      if (disc.length !== 2) return 4.5;
      const r1 = disc[0].rankName || String(disc[0].rank);
      const r2 = disc[1].rankName || String(disc[1].rank);
      const key1 = `${r1}-${r2}`;
      const key2 = `${r2}-${r1}`;
      let val = BASE_CRIB_VALUES[key1] || BASE_CRIB_VALUES[key2];
      if (val === void 0) {
        const v1 = VAL2(disc[0].rank);
        const v2 = VAL2(disc[1].rank);
        const sum = v1 + v2;
        val = 3.6;
        if (sum === 15) val += 2;
        if (r1 === r2) val += 2;
        if (r1 === "5" || r2 === "5") val += 1.6;
        if (Math.abs(v1 - v2) === 1) val += 0.8;
        if (Math.abs(v1 - v2) === 2) val += 0.4;
        if (disc[0].suit === disc[1].suit) val += 0.25;
      }
      return Number(val.toFixed(2));
    }
    /**
     * Evaluates all 15 combinations of keeping 4 cards and discarding 2 cards.
     * @param {Card[]} hand 6 cards
     * @param {boolean} [isDealer=true]
     * @param {Card|null} [starter=null]
     * @returns {{ hand: Card[], isDealer: boolean, combos: Array, optimal: Object }}
     */
    static analyzeHand(hand, isDealer = true, starter = null) {
      if (!hand || hand.length !== 6 && hand.length !== 9) {
        throw new Error("DiscardTrainer requires 6 or 9 cards.");
      }
      const discCount = hand.length === 9 ? 3 : 2;
      const fullDeck = Deck2.makeDeck(1, false);
      const deadSet = new Set(hand.map((c) => c.id));
      const pool = fullDeck.filter((c) => !deadSet.has(c.id));
      const combos = combinations(hand, discCount);
      const results = [];
      for (let i = 0; i < combos.length; i++) {
        const disc = combos[i];
        const discIds = new Set(disc.map((c) => c.id));
        const keep = hand.filter((c) => !discIds.has(c.id));
        let handEV = 0;
        let handMin = Infinity;
        let handMax = -Infinity;
        if (starter) {
          const scored = CribbageScorer2.scoreHand(keep, starter, false, { verbose: false });
          handEV = scored ? scored.total : 0;
          handMin = handEV;
          handMax = handEV;
        } else {
          let sum = 0;
          for (const cutCard of pool) {
            const scoreObj = CribbageScorer2.scoreHand(keep, cutCard, false, { verbose: false });
            const total = scoreObj && typeof scoreObj.total === "number" ? scoreObj.total : 0;
            sum += total;
            if (total < handMin) handMin = total;
            if (total > handMax) handMax = total;
          }
          handEV = sum / pool.length;
        }
        if (handMin === Infinity) handMin = 0;
        if (handMax === -Infinity) handMax = 0;
        const cribEV = _DiscardTrainer.estimateCribEV(disc, isDealer);
        const netEV = isDealer ? handEV + cribEV : handEV - cribEV;
        results.push({
          id: disc.map((c) => c.id).sort().join("-"),
          disc,
          keep,
          handEV: Number(handEV.toFixed(2)),
          handMin,
          handMax,
          cribEV: Number(cribEV.toFixed(2)),
          netEV: Number(netEV.toFixed(2))
        });
      }
      results.sort((a, b) => b.netEV - a.netEV);
      results.forEach((item, index) => {
        item.rank = index + 1;
        item.evDiff = Number((results[0].netEV - item.netEV).toFixed(2));
      });
      return {
        hand,
        isDealer,
        starter,
        combos: results,
        optimal: results[0]
      };
    }
    /**
     * Compares the user's selected 2 discard cards against the optimal ranking.
     * @param {Object} analysisResult Result from analyzeHand()
     * @param {Card[]} userDiscards 2 chosen cards
     * @returns {Object} Evaluation details and strategic advice
     */
    static evaluateUserChoice(analysisResult, userDiscards, recordStats = true) {
      if (!analysisResult || !analysisResult.combos || !userDiscards || userDiscards.length !== 2 && userDiscards.length !== 3) {
        return null;
      }
      const userKey = userDiscards.map((c) => c.id).sort().join("-");
      const match = analysisResult.combos.find((c) => c.id === userKey);
      if (!match) return null;
      const diff = match.evDiff;
      const isOptimal = match.rank === 1;
      let grade = "optimal";
      let gradeLabel = "Optimal Choice! \u{1F3C6}";
      if (diff === 0) {
        grade = "optimal";
        gradeLabel = "Optimal Discard! \u{1F3C6}";
      } else if (diff <= 0.5) {
        grade = "great";
        gradeLabel = `Great Pick! \u{1F44D} (-${diff.toFixed(2)} EV)`;
      } else if (diff <= 1.25) {
        grade = "good";
        gradeLabel = `Good Play (-${diff.toFixed(2)} EV)`;
      } else {
        grade = "suboptimal";
        gradeLabel = `Sub-Optimal \u26A0\uFE0F (-${diff.toFixed(2)} EV)`;
      }
      let careerStats = null;
      if (recordStats) {
        _DiscardTrainer.stats.handsPlayed++;
        if (isOptimal) {
          _DiscardTrainer.stats.optimalCount++;
          const sfx3 = typeof window !== "undefined" ? window.sfx : null;
          AchievementManager.incrementStat("trainerOptimalDiscards", 1, { sfx: sfx3 });
          AchievementManager.unlock("ev_master", { sfx: sfx3 });
        }
        _DiscardTrainer.stats.totalLossEV += diff;
        try {
          const prof = Profile.getInstance();
          careerStats = prof.recordDiscardTrainerPlay({ isOptimal, diff });
        } catch (err) {
          console.warn("[DiscardTrainer] Failed to record stats in Profile:", err);
        }
      }
      const tips = _DiscardTrainer.generateStrategyTips(analysisResult, match);
      return {
        chosen: match,
        optimal: analysisResult.optimal,
        rank: match.rank,
        evDiff: diff,
        diff,
        grade,
        gradeLabel,
        tips,
        stats: {
          ..._DiscardTrainer.stats,
          accuracyPct: Math.round(_DiscardTrainer.stats.optimalCount / _DiscardTrainer.stats.handsPlayed * 100),
          career: careerStats || (function() {
            try {
              return Profile.getInstance().getDiscardTrainerStats();
            } catch (_) {
              return null;
            }
          })()
        }
      };
    }
    /**
     * Generates actionable tactical cribbage advice for the specific choice.
     * @param {Object} analysis
     * @param {Object} chosen
     * @returns {string[]}
     */
    static generateStrategyTips(analysis, chosen) {
      const tips = [];
      const isDealer = analysis.isDealer;
      const disc = chosen.disc;
      const optDisc = analysis.optimal.disc;
      const hasFive = disc.some((c) => c.rank === "5");
      const optHasFive = optDisc.some((c) => c.rank === "5");
      if (!isDealer && hasFive && !optHasFive) {
        tips.push("\u26A0\uFE0F Giving 5s to your opponent's crib is high risk. Opponents gain an average of 5.8+ points from 5s.");
      } else if (isDealer && !hasFive && optHasFive) {
        tips.push("\u{1F4A1} Fives in your own crib significantly boost potential 15s and pairs with dealer discard synergy.");
      }
      if (disc[0].rank === disc[1].rank) {
        if (isDealer) {
          tips.push("\u2728 Seeding a pair into your own crib guarantees at least 2 points plus strong run and 15 synergies.");
        } else {
          tips.push("\u26A0\uFE0F Throwing a pair to your opponent's crib gifts them 2 guaranteed points.");
        }
      }
      if (Math.abs(VAL2(disc[0].rank) + VAL2(disc[1].rank)) === 15) {
        if (isDealer) {
          tips.push("\u{1F3AF} Discarding a fifteen to your own crib locks in 2 guaranteed points.");
        } else {
          tips.push("\u{1F6AB} Never toss a 15 into your opponent's crib unless forced!");
        }
      }
      if (chosen.rank === 1) {
        tips.push("\u{1F31F} You maximized the mathematical combination of hand points and crib impact!");
      } else {
        tips.push(`\u{1F4CC} The optimal discard was ${optDisc.map((c) => `${c.rank}${c.suit}`).join(" ")}, offering ${analysis.optimal.netEV.toFixed(2)} Net EV vs your ${chosen.netEV.toFixed(2)} Net EV.`);
      }
      return tips;
    }
  };

  // src/trainer/PeggingTrainer.js
  var PEGGING_CATEGORIES = [
    { id: "all", name: "All Scenarios (Mixed Challenges)" },
    { id: "baiting_15s", name: "Baiting & Defending the 15" },
    { id: "sequence_defense", name: "Run Defense & Sequence Traps" },
    { id: "pair_dilemmas", name: "Pairing vs. Pair Royal Danger" },
    { id: "maneuver_31", name: "The 31-Point Maneuver" },
    { id: "go_traps", name: "Go Traps & Low Card Sweeps" },
    { id: "endgame", name: "Endgame Pegging (Race to 121)" }
  ];
  var PeggingTrainer = class _PeggingTrainer {
    /**
     * In-session statistics.
     */
    static stats = {
      scenariosPlayed: 0,
      optimalCount: 0,
      currentStreak: 0,
      bestStreak: 0,
      totalEVDiff: 0
    };
    /**
     * Resets session statistics.
     */
    static resetStats(options = {}) {
      _PeggingTrainer.stats = {
        scenariosPlayed: 0,
        optimalCount: 0,
        currentStreak: 0,
        bestStreak: 0,
        totalEVDiff: 0
      };
      if (options && options.career) {
        try {
          const prof = Profile.getInstance(options.storage);
          if (prof && typeof prof.clearPeggingTrainerStats === "function") {
            prof.clearPeggingTrainerStats(options.storage);
          }
        } catch (_) {
        }
      }
    }
    /**
     * Retrieves session and career stats.
     * @param {Object} [storage=null]
     */
    static getStats(storage = null) {
      const accuracyPct = _PeggingTrainer.stats.scenariosPlayed > 0 ? Math.round(_PeggingTrainer.stats.optimalCount / _PeggingTrainer.stats.scenariosPlayed * 100) : 0;
      let career = null;
      try {
        const prof = Profile.getInstance(storage);
        if (prof && typeof prof.getPeggingTrainerStats === "function") {
          career = prof.getPeggingTrainerStats(storage);
        }
      } catch (_) {
      }
      return {
        session: {
          ..._PeggingTrainer.stats,
          accuracyPct
        },
        career: career || {
          scenariosPlayed: 0,
          optimalCount: 0,
          accuracyPct: 0,
          currentStreak: 0,
          bestStreak: 0
        }
      };
    }
    /**
     * Curated scenario definitions illustrating foundational pegging tenets.
     */
    static CURATED_SCENARIOS = [
      {
        id: "bait_5_lead",
        category: "baiting_15s",
        title: "Opening Lead Dilemma \u2014 Never Lead a 5",
        description: "You are Pone and have the opening lead. You hold a 4, a 5, a 10, and a King. Which card do you lead?",
        pile: [],
        count: 0,
        hand: [
          new Card2({ r: 4, s: "D", id: "4D" }),
          new Card2({ r: 5, s: "S", id: "5S" }),
          new Card2({ r: 10, s: "C", id: "10C" }),
          new Card2({ r: 13, s: "H", id: "KH" })
        ],
        lesson: "Never lead a 5! Since over 30% of the entire deck consists of 10-value cards (10, J, Q, K), leading a 5 virtually guarantees your opponent scores 15-for-2 on their first response. Leading a 4 is the safest disciplined play, keeping the count under 15."
      },
      {
        id: "bait_10_lead_hold_pair",
        category: "baiting_15s",
        title: "Opponent Leads a 10 \u2014 Armed with Hidden Fives",
        description: "Your opponent leads a King (10-value). You hold two 5s in your hand. How do you play?",
        pile: [new Card2({ r: 13, s: "S", id: "KS" })],
        count: 10,
        hand: [
          new Card2({ r: 5, s: "D", id: "5D" }),
          new Card2({ r: 5, s: "C", id: "5C" }),
          new Card2({ r: 8, s: "H", id: "8H" }),
          new Card2({ r: 11, s: "S", id: "JS" })
        ],
        lesson: "Playing a 5 scores 15-for-2 (+2 pts) with complete security. Because you hold the backup 5 in hand, if your opponent pairs your 5 for 2 pts, you can immediately counter with Pair Royal for 6 pts (count 25)!"
      },
      {
        id: "seq_def_4_lead",
        category: "sequence_defense",
        title: "Opponent Leads a 4 \u2014 The 4-5-6 Ambush Trap",
        description: "Opponent leads a 4 (Count: 4). You hold a 5, an 8, and a King. Do you play the 5, or play disciplined defense?",
        pile: [new Card2({ r: 4, s: "C", id: "4C" })],
        count: 4,
        hand: [
          new Card2({ r: 5, s: "D", id: "5D" }),
          new Card2({ r: 8, s: "S", id: "8S" }),
          new Card2({ r: 13, s: "H", id: "KH" })
        ],
        lesson: "Never play a 5 on a 4 lead! Playing a 5 reaches count 9, inviting the opponent to drop a 6 for 15-for-2 PLUS a 3-card run (4-5-6 for 3 pts) = 5 devastating points! Playing an 8 (count 12) or King (count 14) safely defuses the trap."
      },
      {
        id: "seq_counter_run",
        category: "sequence_defense",
        title: "Opponent Triggers a 3-Card Run \u2014 The Coup de Gr\xE2ce",
        description: "Pile sequence is 6 - 7 - 8 (Count: 21). Opponent just scored 3 pts for the run. Can you counter?",
        pile: [
          new Card2({ r: 6, s: "H", id: "6H" }),
          new Card2({ r: 7, s: "S", id: "7S" }),
          new Card2({ r: 8, s: "D", id: "8D" })
        ],
        count: 21,
        hand: [
          new Card2({ r: 9, s: "C", id: "9C" }),
          new Card2({ r: 2, s: "D", id: "2D" }),
          new Card2({ r: 10, s: "S", id: "10S" })
        ],
        lesson: "Playing the 9 reaches count 30 and extends the sequence to a 4-card run (6-7-8-9) for 4 points! It also puts the count at 30, virtually assuring you a 1-point Go on the next card for 5 total points."
      },
      {
        id: "pair_danger_4",
        category: "pair_dilemmas",
        title: "Opponent Leads a 4 \u2014 The Pair Royal Ambush",
        description: "Opponent leads a 4. You hold a 4, a 7, an 8, and a Queen (no backup 4). Do you pair the 4?",
        pile: [new Card2({ r: 4, s: "S", id: "4S" })],
        count: 4,
        hand: [
          new Card2({ r: 4, s: "C", id: "4C" }),
          new Card2({ r: 7, s: "H", id: "7H" }),
          new Card2({ r: 8, s: "D", id: "8D" }),
          new Card2({ r: 12, s: "S", id: "QS" })
        ],
        lesson: "Pairing low cards like 3s, 4s, and 5s early in the hand without a backup in hand carries severe risk. If the opponent holds a third 4, they counter-strike with Pair Royal for 6 points at count 12. Playing Queen (count 14) is disciplined defense."
      },
      {
        id: "maneuver_31_exact",
        category: "maneuver_31",
        title: "Count is 21 \u2014 Seizing the Thirty-One",
        description: "Count is at 21 after intense pegging. You have an Ace, a 5, and a 10. How do you maneuver?",
        pile: [
          new Card2({ r: 10, s: "D", id: "10D" }),
          new Card2({ r: 8, s: "H", id: "8H" }),
          new Card2({ r: 3, s: "C", id: "3C" })
        ],
        count: 21,
        hand: [
          new Card2({ r: 1, s: "S", id: "AS" }),
          new Card2({ r: 5, s: "S", id: "5S" }),
          new Card2({ r: 10, s: "C", id: "10C" })
        ],
        lesson: "Playing the 10 hits exactly 31 for 2 points! Playing the 5 advances the count to 26, which gives the opponent an easy 31 if they hold a 5. Playing the Ace hits 22, yielding initiative."
      },
      {
        id: "go_trap_sweep",
        category: "go_traps",
        isGo: true,
        title: "Opponent Plays 2 to Count 28 and Calls GO \u2014 The Double-Dip",
        description: "Opponent plays a 2 to reach count 28 and calls GO! You hold a 2, an Ace, and an 8. In what order do you play them?",
        pile: [
          new Card2({ r: 10, s: "S", id: "10S" }),
          new Card2({ r: 9, s: "D", id: "9D" }),
          new Card2({ r: 7, s: "H", id: "7H" }),
          new Card2({ r: 2, s: "S", id: "2S" })
        ],
        count: 28,
        hand: [
          new Card2({ r: 2, s: "C", id: "2C" }),
          new Card2({ r: 1, s: "H", id: "AH" }),
          new Card2({ r: 8, s: "D", id: "8D" })
        ],
        lesson: "Order of play on a GO is crucial! By playing your 2 first (count 30), you pair the opponent's 2 for 2 points, and then immediately follow up with your Ace to hit 31 for 2 more points, capturing 4 total points! If you played the Ace first to count 29, it separates the 2s and destroys your pair, yielding only 2 points for 31."
      },
      {
        id: "go_trap_snag_31",
        category: "go_traps",
        isGo: true,
        title: "Opponent Calls Go at 28 \u2014 Snagging 31 vs Stranded Go",
        description: "Opponent is stuck at count 28 and calls GO! You hold an Ace, a 3, and a 9. Which card do you play?",
        pile: [
          new Card2({ r: 10, s: "S", id: "10S" }),
          new Card2({ r: 9, s: "D", id: "9D" }),
          new Card2({ r: 9, s: "H", id: "9H" })
        ],
        count: 28,
        hand: [
          new Card2({ r: 3, s: "C", id: "3C" }),
          new Card2({ r: 1, s: "H", id: "AH" }),
          new Card2({ r: 9, s: "S", id: "9S" })
        ],
        lesson: "When an opponent calls GO, always check if you can hit exactly 31! Playing the 3 seizes 31 for 2 points. If you play the Ace first to count 29, your 3 is immediately blocked (29 + 3 = 32 exceeds 31), forcing a 1-point Go and leaving thirty-one on the table."
      },
      {
        id: "endgame_119_pegout",
        category: "endgame",
        title: "Endgame: Score 119 vs 120 \u2014 Instant Peg-Out",
        description: "You are at hole 119 (2 pts needed to win). Opponent is at 120. Opponent leads a 3. What is your move?",
        pile: [new Card2({ r: 3, s: "H", id: "3H" })],
        count: 3,
        hand: [
          new Card2({ r: 3, s: "D", id: "3D" }),
          new Card2({ r: 6, s: "S", id: "6S" }),
          new Card2({ r: 9, s: "C", id: "9C" }),
          new Card2({ r: 13, s: "D", id: "KD" })
        ],
        lesson: "In the endgame when within pegging distance of 121, pairing for 2 points wins the entire match instantly! Pair Royal risk does not matter because the game terminates the millisecond your 121st hole is reached."
      }
    ];
    /**
     * Generates a scenario by category or procedural random deal.
     * @param {string} [categoryId='all']
     * @returns {Object}
     */
    static generateScenario(categoryId = "all") {
      let pool = _PeggingTrainer.CURATED_SCENARIOS;
      if (categoryId && categoryId !== "all") {
        const filtered = pool.filter((s) => s.category === categoryId);
        if (filtered.length) pool = filtered;
      }
      const template = pool[Math.floor(Math.random() * pool.length)];
      const scenario = {
        id: `${template.id}_${Date.now()}`,
        templateId: template.id,
        category: template.category,
        title: template.title,
        description: template.description,
        lesson: template.lesson,
        isGo: Boolean(template.isGo || template.category === "go_traps"),
        pile: template.pile.map((c) => new Card2({ r: c.rank, s: c.suit, id: c.id })),
        count: template.count,
        hand: template.hand.map((c) => new Card2({ r: c.rank, s: c.suit, id: c.id }))
      };
      scenario.analysis = _PeggingTrainer.analyzeScenario(scenario);
      return scenario;
    }
    /**
     * Evaluates all legal moves for the player in the scenario.
     * @param {Object} scenario
     * @returns {Object}
     */
    static analyzeScenario(scenario) {
      const { pile, count, hand } = scenario;
      const isGo = Boolean(scenario.isGo || scenario.category === "go_traps");
      const legalCards = hand.filter((c) => count + VAL2(c.rank) <= 31);
      const evaluatedMoves = legalCards.map((card) => {
        const v = VAL2(card.rank);
        const newCount = count + v;
        const testPile = [...pile, card];
        const rawPts = CribbageScorer2.scorePegging(testPile, scenario.options || {});
        const directPts = rawPts.reduce((s, p) => s + p.n, 0);
        let counterRisk = 0;
        let reasons = [];
        if (directPts > 0) {
          reasons.push(`Scores +${directPts} pts (${rawPts.map((p) => p.why).join(", ") || "31"})`);
        }
        if (!isGo) {
          if (newCount === 5) {
            counterRisk += 2;
            reasons.push("\u26A0\uFE0F Leaves count at 5; opponent holding any 10-value card scores 15-for-2");
          } else if (newCount > 5 && newCount < 15 && 15 - newCount <= 10) {
            const gap = 15 - newCount;
            if (gap === 5) {
              counterRisk += 1.6;
              reasons.push(`Leaves count at ${newCount}; vulnerable to an opponent 5 (15-for-2)`);
            } else if (gap >= 1 && gap <= 4) {
              counterRisk += 1.1;
            }
          }
          if (newCount === 21) {
            counterRisk += 2;
            reasons.push("\u26A0\uFE0F Leaves count at 21; any 10-value card from opponent hits 31-for-2");
          } else if (newCount >= 22 && newCount <= 30) {
            const gap = 31 - newCount;
            if (gap <= 5) {
              counterRisk += 1.4;
              reasons.push(`Leaves count at ${newCount}; vulnerable to opponent 31-for-2`);
            }
          }
          if (pile.length > 0) {
            const oppLast = pile[pile.length - 1];
            if (oppLast.rank === card.rank && VAL2(card.rank) <= 5 && pile.length === 1) {
              const hasBackup = hand.filter((c) => c.rank === card.rank).length >= 2;
              if (!hasBackup) {
                counterRisk += 3.2;
                reasons.push(`\u26A0\uFE0F Pairing a ${card.rankName || card.rank} without a backup in hand risks opponent counter-striking with Pair Royal for 6 pts`);
              }
            }
          }
          if (testPile.length === 2) {
            const r1 = testPile[0].rank;
            const r2 = card.rank;
            const ranks = [r1, r2].sort((a, b) => a - b);
            if (ranks[0] === 4 && ranks[1] === 5 || ranks[0] === 5 && ranks[1] === 6) {
              counterRisk += 3.2;
              const missing = ranks[0] === 4 ? 6 : 4;
              reasons.push(`\u26A0\uFE0F Walking into the 4-5-6 trap: opponent ${missing} scores 15-for-2 AND a 3-card run for 5 points!`);
            }
          }
          if (testPile.length >= 2) {
            const r1 = testPile[testPile.length - 2].rank;
            const r2 = card.rank;
            if (Math.abs(r1 - r2) === 1 && newCount <= 22) {
              counterRisk += 1.2;
              reasons.push("Leaves consecutive run open for opponent");
            }
          }
        }
        let stratBonus = 0;
        if (newCount === 31) stratBonus += 3.5;
        if (newCount === 15) stratBonus += 2.5;
        if (directPts >= 3) stratBonus += directPts * 1.2;
        const isEndgame = scenario.category === "endgame" || scenario.isEndgame;
        if (isEndgame && directPts >= 2) {
          stratBonus += 10;
          counterRisk = 0;
          reasons = reasons.filter((r) => !r.startsWith("\u26A0\uFE0F") && !r.includes("Leaves count"));
          reasons.unshift("\u{1F3C6} Pegs out! Captures match-winning points instantly (game ends immediately)");
        }
        if (isGo && newCount < 31) {
          const remaining = hand.filter((h) => h.id !== card.id);
          const followUps = remaining.filter((h) => newCount + VAL2(h.rank) <= 31);
          if (followUps.length > 0) {
            const hits31 = followUps.some((h) => newCount + VAL2(h.rank) === 31);
            if (hits31) {
              stratBonus += 2.5;
              reasons.push("Keeps count open to sweep 31 (+2 pts) with remaining card in hand");
            } else {
              stratBonus += 1;
              reasons.push("Allows playing an additional card under 31");
            }
          }
        }
        const netScore = Number((directPts + stratBonus - counterRisk).toFixed(2));
        return {
          card,
          id: card.id,
          newCount,
          directPts,
          counterRisk: Number(counterRisk.toFixed(2)),
          netScore,
          reasons
        };
      });
      evaluatedMoves.sort((a, b) => b.netScore - a.netScore);
      const optimal = evaluatedMoves[0] || null;
      evaluatedMoves.forEach((m, idx) => {
        m.rank = idx + 1;
        m.diff = optimal ? Number((optimal.netScore - m.netScore).toFixed(2)) : 0;
        if (m.diff === 0) {
          m.grade = "optimal";
          m.gradeLabel = "Optimal Choice! \u{1F3C6}";
        } else if (m.diff <= 1.2) {
          m.grade = "great";
          m.gradeLabel = "Safe Alternative \u{1F44D}";
        } else if (m.diff <= 2.8) {
          m.grade = "risky";
          m.gradeLabel = "Risky Play \u26A0\uFE0F";
        } else {
          m.grade = "blunder";
          m.gradeLabel = "Blunder / Trapped \u274C";
        }
      });
      return {
        legalMoves: evaluatedMoves,
        optimal,
        hasLegalMoves: evaluatedMoves.length > 0
      };
    }
    /**
     * Evaluates the player's selected card in the scenario and records stats.
     * @param {Object} scenario
     * @param {Card} chosenCard
     * @param {Object} [options]
     * @returns {Object}
     */
    static evaluateChoice(scenario, chosenCard, options = {}) {
      if (!scenario || !scenario.analysis || !chosenCard) return null;
      const match = scenario.analysis.legalMoves.find((m) => m.card.id === chosenCard.id);
      if (!match) return null;
      const isOptimal = match.rank === 1;
      const diff = match.diff;
      _PeggingTrainer.stats.scenariosPlayed++;
      if (isOptimal) {
        _PeggingTrainer.stats.optimalCount++;
        _PeggingTrainer.stats.currentStreak++;
        if (_PeggingTrainer.stats.currentStreak > _PeggingTrainer.stats.bestStreak) {
          _PeggingTrainer.stats.bestStreak = _PeggingTrainer.stats.currentStreak;
        }
        const sfx3 = typeof window !== "undefined" ? window.sfx : null;
        AchievementManager.incrementStat("peggingTrainerOptimalPlays", 1, { sfx: sfx3 });
      } else {
        _PeggingTrainer.stats.currentStreak = 0;
      }
      _PeggingTrainer.stats.totalEVDiff += diff;
      let career = null;
      try {
        const prof = Profile.getInstance(options.storage);
        if (prof && typeof prof.recordPeggingTrainerPlay === "function") {
          career = prof.recordPeggingTrainerPlay({ isOptimal, diff }, options.storage);
        }
      } catch (_) {
      }
      return {
        scenario,
        chosen: match,
        optimal: scenario.analysis.optimal,
        isOptimal,
        diff,
        grade: match.grade,
        gradeLabel: match.gradeLabel,
        lesson: scenario.lesson,
        stats: {
          ..._PeggingTrainer.stats,
          accuracyPct: Math.round(_PeggingTrainer.stats.optimalCount / _PeggingTrainer.stats.scenariosPlayed * 100),
          career
        }
      };
    }
  };

  // src/trainer/CountingTrainer.js
  var CountingTrainer = class _CountingTrainer {
    /**
     * In-memory session statistics.
     */
    static stats = {
      handsPlayed: 0,
      handsCorrect: 0,
      handsWrong: 0,
      currentStreak: 0,
      bestStreak: 0,
      accuracyPct: 0
    };
    /**
     * Resets in-session statistics and optionally career stats.
     * @param {Object} [options]
     */
    static resetStats(options = {}) {
      _CountingTrainer.stats = {
        handsPlayed: 0,
        handsCorrect: 0,
        handsWrong: 0,
        currentStreak: 0,
        bestStreak: 0,
        accuracyPct: 0
      };
      if (options && options.career) {
        try {
          const prof = Profile.getInstance(options.storage);
          if (prof && typeof prof.clearCountingTrainerStats === "function") {
            prof.clearCountingTrainerStats(options.storage);
          }
        } catch (_) {
        }
      }
    }
    /**
     * Returns current session and career statistics.
     * @param {Object} [storage=null]
     * @returns {{ session: Object, career: Object }}
     */
    static getStats(storage = null) {
      let career = {
        handsPlayed: 0,
        handsCorrect: 0,
        handsWrong: 0,
        currentStreak: 0,
        bestStreak: 0,
        accuracyPct: 0
      };
      try {
        const prof = Profile.getInstance(storage);
        if (prof && typeof prof.getCountingTrainerStats === "function") {
          career = prof.getCountingTrainerStats(storage);
        }
      } catch (_) {
      }
      return {
        session: {
          ..._CountingTrainer.stats,
          accuracyPct: _CountingTrainer.stats.handsPlayed > 0 ? Math.round(_CountingTrainer.stats.handsCorrect / _CountingTrainer.stats.handsPlayed * 100) : 0
        },
        career
      };
    }
    /**
     * Returns career stats from Profile or localStorage.
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static getCareerStats(storage = null) {
      return _CountingTrainer.getStats(storage).career;
    }
    /**
     * Sorts cards lowest to highest by rank (Ace=1 to King=13), then by suit.
     * @param {Card[]} [cards=[]]
     * @returns {Card[]}
     */
    static sortCards(cards = []) {
      if (Hand && typeof Hand.sort === "function") {
        return Hand.sort(cards);
      }
      return (cards || []).slice().sort((a, b) => {
        const ar = a && (a.rank !== void 0 ? a.rank : a.r !== void 0 ? a.r : 0) || 0;
        const br = b && (b.rank !== void 0 ? b.rank : b.r !== void 0 ? b.r : 0) || 0;
        const as = String(a && (a.suit || a.s || a.rawSuit) || "S").toUpperCase();
        const bs = String(b && (b.suit || b.s || b.rawSuit) || "S").toUpperCase();
        const suitsOrder = ["S", "H", "D", "C"];
        const aSuitIdx = suitsOrder.indexOf(as) !== -1 ? suitsOrder.indexOf(as) : 99;
        const bSuitIdx = suitsOrder.indexOf(bs) !== -1 ? suitsOrder.indexOf(bs) : 99;
        return ar - br || aSuitIdx - bSuitIdx;
      });
    }
    /**
     * Deals a random hand of 6 or 9 cards from a fresh 52-card deck, sorted lowest to highest.
     * @param {number} [mode=6] Hand size (6 for standard, 9 for super)
     * @returns {Card[]}
     */
    static dealRandomHand(mode = 6) {
      const handSize = mode === 9 ? 9 : 6;
      const deck = new Deck2();
      deck.shuffle();
      const dealt = deck.deal(handSize);
      return _CountingTrainer.sortCards(dealt);
    }
    /**
     * Cuts a random starter card from the remaining deck.
     * @param {Card[]} [excludedCards=[]] Cards already dealt/kept/discarded
     * @returns {Card}
     */
    static cutStarterCard(excludedCards = []) {
      const excludedIds = new Set(excludedCards.map((c) => c.id || `${c.r}${c.s}`));
      const deck = new Deck2();
      deck.shuffle();
      for (const card of deck.cards) {
        const id = card.id || `${card.r}${card.s}`;
        if (!excludedIds.has(id)) {
          return card;
        }
      }
      return deck.cards[0] || new Card2({ r: 5, s: "H" });
    }
    /**
     * Fully scores a kept hand and starter card using core Cribbage scoring rules.
     * @param {Card[]} cards Kept cards in hand (4 for 6-card deal, 6 for 9-card deal)
     * @param {Card} starter Starter cut card
     * @param {boolean} [isCrib=false] Whether counting as a crib
     * @param {Object} [options={}] Optional variant settings
     * @returns {Object} Structured score breakdown
     */
    static scoreCountedHand(cards, starter, isCrib = false, options = {}) {
      const rawCards = (cards || []).map((c) => c instanceof Card2 ? c : Card2.from(c));
      const rawStarter = starter instanceof Card2 ? starter : starter ? Card2.from(starter) : null;
      const scored = CribbageScorer2.scoreHandCore(rawCards, rawStarter, isCrib, options);
      return {
        fifteens: scored.fifteens || 0,
        pairs: scored.pairs || 0,
        runs: scored.runs || 0,
        flush: scored.flush || 0,
        nobs: scored.nobs || 0,
        straight: scored.straight || 0,
        fullHouse: scored.fullHouse || 0,
        straightFlush: scored.straightFlush || 0,
        royalFlush: scored.royalFlush || 0,
        total: scored.total || 0,
        notes: scored.notes || [],
        lines: scored.lines || []
      };
    }
    /**
     * Evaluates the player's entered points against the actual score breakdown.
     * @param {Object} actualBreakdown Return value from scoreCountedHand
     * @param {Object} userInputs User-entered values { fifteens, pairs, runs, flush, nobs, total }
     * @returns {Object} Evaluation with per-category pass/fail and actual values
     */
    static evaluateUserCount(actualBreakdown, userInputs = {}) {
      const userFifteens = Number(userInputs.fifteens) || 0;
      const userPairs = Number(userInputs.pairs) || 0;
      const userRuns = Number(userInputs.runs) || 0;
      const userFlush = Number(userInputs.flush) || 0;
      const userNobs = Number(userInputs.nobs) || 0;
      const actualFifteens = actualBreakdown.fifteens || 0;
      const actualPairs = actualBreakdown.pairs || 0;
      const actualRuns = actualBreakdown.runs || 0;
      const actualFlush = actualBreakdown.flush || 0;
      const actualNobs = actualBreakdown.nobs || 0;
      const actualTotal = actualBreakdown.total || 0;
      const computedUserTotal = userFifteens + userPairs + userRuns + userFlush + userNobs;
      const userTotal = userInputs.total !== void 0 ? Number(userInputs.total) || 0 : computedUserTotal;
      const res = {
        fifteens: {
          user: userFifteens,
          actual: actualFifteens,
          correct: userFifteens === actualFifteens
        },
        pairs: {
          user: userPairs,
          actual: actualPairs,
          correct: userPairs === actualPairs
        },
        runs: {
          user: userRuns,
          actual: actualRuns,
          correct: userRuns === actualRuns
        },
        flush: {
          user: userFlush,
          actual: actualFlush,
          correct: userFlush === actualFlush
        },
        nobs: {
          user: userNobs,
          actual: actualNobs,
          correct: userNobs === actualNobs
        },
        total: {
          user: userTotal,
          actual: actualTotal,
          correct: userTotal === actualTotal
        }
      };
      res.isAllCorrect = res.fifteens.correct && res.pairs.correct && res.runs.correct && res.flush.correct && res.nobs.correct && res.total.correct;
      return res;
    }
    /**
     * Analyzes dealt hand and evaluates the player's discard choices against EV table.
     * @param {Card[]} dealtHand Full dealt hand (6 or 9 cards)
     * @param {Card[]} userDiscards Cards the player discarded (2 or 3 cards)
     * @param {boolean} [isDealer=true]
     * @returns {{ analysis: Object, evaluation: Object, isCorrect: boolean }|null}
     */
    static analyzeDiscards(dealtHand, userDiscards, isDealer = true) {
      if (!dealtHand || dealtHand.length !== 6 && dealtHand.length !== 9) return null;
      const rawDealt = dealtHand.map((c) => c instanceof Card2 ? c : Card2.from(c));
      const rawDisc = (userDiscards || []).map((c) => c instanceof Card2 ? c : Card2.from(c));
      const analysis = DiscardTrainer.analyzeHand(rawDealt, isDealer);
      const evaluation = DiscardTrainer.evaluateUserChoice(analysis, rawDisc, false);
      return {
        analysis,
        evaluation,
        isCorrect: evaluation ? evaluation.isOptimal : false
      };
    }
    /**
     * Records a completed counting hand into session and profile career stats.
     * @param {Object} playData
     * @param {boolean} playData.isCorrect Whether all categories and total were 100% correct
     * @param {Object} [storage=null]
     * @returns {Object} Updated career statistics
     */
    static recordPlay(playData = {}, storage = null) {
      const isCorrect = Boolean(playData.isCorrect);
      _CountingTrainer.stats.handsPlayed++;
      if (isCorrect) {
        _CountingTrainer.stats.handsCorrect++;
        _CountingTrainer.stats.currentStreak++;
        _CountingTrainer.stats.bestStreak = Math.max(
          _CountingTrainer.stats.bestStreak,
          _CountingTrainer.stats.currentStreak
        );
      } else {
        _CountingTrainer.stats.handsWrong++;
        _CountingTrainer.stats.currentStreak = 0;
      }
      _CountingTrainer.stats.accuracyPct = Math.round(
        _CountingTrainer.stats.handsCorrect / _CountingTrainer.stats.handsPlayed * 100
      );
      let careerStats = null;
      try {
        const prof = Profile.getInstance(storage);
        if (prof && typeof prof.recordCountingTrainerPlay === "function") {
          careerStats = prof.recordCountingTrainerPlay({ isCorrect }, storage);
        }
      } catch (_) {
      }
      return careerStats || _CountingTrainer.stats;
    }
    /**
     * Parses custom card input string or array into Card instances.
     * Supports:
     * - 5 cards (4 hand cards + 1 cut card as the last card): "5H 5D 5S JC 5C" or "5H 5D 5S JC + 5C"
     * - 7 cards (6 hand cards + 1 cut card as the last card): "5H 5D 5S JC 7H 8D 5C" or "5H 5D 5S JC 7H 8D + 5C"
     * - Dealt hand fallback (6 or 9 cards): "5H 5D 5S JC 7H 8D"
     * @param {string|Array} input
     * @param {number} [mode=6]
     * @returns {{ cards: Card[], starter: Card|null, mode: number, isComplete: boolean }|null}
     */
    static parseCustomHand(input, mode = 6) {
      if (!input) return null;
      let text2 = "";
      if (Array.isArray(input)) {
        text2 = input.map((c) => c && (c.id || `${c.r || c.rank}${c.s || c.suit}`)).join(" ");
      } else {
        text2 = String(input);
      }
      let starterPart = null;
      let handPart = text2;
      if (text2.includes("+")) {
        const parts = text2.split("+");
        handPart = parts[0].trim();
        starterPart = parts.slice(1).join("+").trim();
      } else if (text2.includes("|")) {
        const parts = text2.split("|");
        handPart = parts[0].trim();
        starterPart = parts.slice(1).join("|").trim();
      }
      const rankMap = { A: 1, "1": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9, "10": 10, T: 10, J: 11, Q: 12, K: 13 };
      const suitMap = { S: "S", H: "H", D: "D", C: "C", "\u2660": "S", "\u2665": "H", "\u2666": "D", "\u2663": "C" };
      const parseToken = (t) => {
        const cleaned = String(t).trim().toUpperCase();
        const m = cleaned.match(/^([2-9]|10|[TJQKA])([SHDC♠♥♦♣])$/);
        if (!m) return null;
        const rank = rankMap[m[1]];
        const suit = suitMap[m[2]];
        const rName = RANK_NAME && RANK_NAME[rank] || (rank === 1 ? "A" : rank === 11 ? "J" : rank === 12 ? "Q" : rank === 13 ? "K" : String(rank));
        return new Card2({ r: rank, s: suit, id: `${rName}${suit}` });
      };
      const handTokens = handPart.split(/[\s,;]+/).filter(Boolean);
      const parsedHand = [];
      const seen = /* @__PURE__ */ new Set();
      for (const t of handTokens) {
        const card = parseToken(t);
        if (!card || seen.has(card.id)) return null;
        seen.add(card.id);
        parsedHand.push(card);
      }
      let parsedStarter = null;
      if (starterPart) {
        const starterTokens = starterPart.split(/[\s,;]+/).filter(Boolean);
        if (starterTokens.length > 0) {
          parsedStarter = parseToken(starterTokens[0]);
          if (!parsedStarter || seen.has(parsedStarter.id)) return null;
          seen.add(parsedStarter.id);
        }
      }
      if (parsedStarter) {
        if (parsedHand.length === 4) {
          return {
            cards: _CountingTrainer.sortCards(parsedHand),
            starter: parsedStarter,
            mode: 6,
            isComplete: true
          };
        }
        if (parsedHand.length === 6) {
          return {
            cards: _CountingTrainer.sortCards(parsedHand),
            starter: parsedStarter,
            mode: 9,
            isComplete: true
          };
        }
        return null;
      }
      if (parsedHand.length === 5) {
        return {
          cards: _CountingTrainer.sortCards(parsedHand.slice(0, 4)),
          starter: parsedHand[4],
          mode: 6,
          isComplete: true
        };
      }
      if (parsedHand.length === 7) {
        return {
          cards: _CountingTrainer.sortCards(parsedHand.slice(0, 6)),
          starter: parsedHand[6],
          mode: 9,
          isComplete: true
        };
      }
      if (parsedHand.length === 6 && !parsedStarter) {
        return {
          cards: _CountingTrainer.sortCards(parsedHand),
          starter: null,
          mode: 6,
          isComplete: false
        };
      }
      if (parsedHand.length === 9 && !parsedStarter) {
        return {
          cards: _CountingTrainer.sortCards(parsedHand),
          starter: null,
          mode: 9,
          isComplete: false
        };
      }
      return null;
    }
    /**
     * Encodes a counting challenge into a shareable URL query string.
     * @param {Card[]} cards Kept or dealt cards
     * @param {Card} starter Starter card
     * @param {number} [mode=6]
     * @returns {string} URL string
     */
    static encodeShareUrl(cards, starter, mode = 6) {
      const cardCodes = (cards || []).map((c) => {
        const r = c.rankName && c.rankName !== "?" ? c.rankName : c.rank === 1 ? "A" : c.rank === 11 ? "J" : c.rank === 12 ? "Q" : c.rank === 13 ? "K" : String(c.rank || c.r || "");
        const s = c.suit || c.s || "S";
        return `${r}${s}`;
      }).join(",");
      const starterCode = starter ? (() => {
        const r = starter.rankName && starter.rankName !== "?" ? starter.rankName : starter.rank === 1 ? "A" : starter.rank === 11 ? "J" : starter.rank === 12 ? "Q" : starter.rank === 13 ? "K" : String(starter.rank || starter.r || "");
        const s = starter.suit || starter.s || "S";
        return `${r}${s}`;
      })() : "";
      const params = new URLSearchParams({
        trainer: "counting",
        mode: String(mode),
        cards: cardCodes,
        starter: starterCode
      });
      let base = "https://crazycribbage.com";
      if (typeof window !== "undefined" && window.location) {
        if (window.location.href && !window.location.href.startsWith("about:")) {
          base = window.location.href.split("?")[0].split("#")[0];
        } else if (window.location.origin && window.location.origin !== "null") {
          base = window.location.origin + window.location.pathname;
        }
      }
      return `${base}?${params.toString()}`;
    }
    /**
     * Decodes query parameters from a URL or search string.
     * @param {string} [searchStr]
     * @returns {{ cards: Card[], starter: Card, mode: number }|null}
     */
    static decodeShareUrl(searchStr) {
      try {
        const search = searchStr || (typeof window !== "undefined" ? window.location.search : "");
        if (!search) return null;
        const params = new URLSearchParams(search);
        if (params.get("trainer") !== "counting" && params.get("tool") !== "counting" && params.get("mode") !== "counting") return null;
        const mode = params.get("mode") === "9" ? 9 : 6;
        const cardsParam = params.get("cards");
        const starterParam = params.get("starter");
        if (!cardsParam) return null;
        const rankMap = { A: 1, "1": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9, "10": 10, T: 10, J: 11, Q: 12, K: 13 };
        const parseToken = (t) => {
          const m = String(t).trim().toUpperCase().match(/^([2-9]|10|[TJQKA]|1)([SHDC])$/);
          if (!m) return null;
          const rank = rankMap[m[1]];
          const suit = m[2];
          const rName = RANK_NAME && RANK_NAME[rank] || (rank === 1 ? "A" : rank === 11 ? "J" : rank === 12 ? "Q" : rank === 13 ? "K" : String(rank));
          return new Card2({ r: rank, s: suit, id: `${rName}${suit}` });
        };
        const cards = cardsParam.split(",").map(parseToken).filter(Boolean);
        const starter = starterParam ? parseToken(starterParam) : null;
        if (!cards.length) return null;
        return {
          cards: _CountingTrainer.sortCards(cards),
          kept: starter ? _CountingTrainer.sortCards(cards) : null,
          hand: !starter ? _CountingTrainer.sortCards(cards) : null,
          starter,
          mode
        };
      } catch (_) {
        return null;
      }
    }
    /**
     * Generates a rich text challenge for social sharing or copying.
     * @param {Card[]} cards
     * @param {Card} starter
     * @param {number} [mode=6]
     * @returns {string}
     */
    static generateShareText(cards, starter, mode = 6) {
      const suitSym = { S: "\u2660", H: "\u2665", D: "\u2666", C: "\u2663" };
      const cardLabels = (cards || []).map((c) => {
        const r = c && c.rankName && c.rankName !== "?" ? c.rankName : c && c.rank === 1 ? "A" : c && c.rank === 11 ? "J" : c && c.rank === 12 ? "Q" : c && c.rank === 13 ? "K" : String(c && (c.rank || c.r) || "");
        const su = String(c && (c.suit || c.s) || "").toUpperCase();
        const s = SUIT_SYM && SUIT_SYM[su] || suitSym[su] || su;
        return `${r}${s}`;
      }).join(" ");
      let starterLabel = "None";
      if (starter) {
        const r = starter.rankName && starter.rankName !== "?" ? starter.rankName : starter.rank === 1 ? "A" : starter.rank === 11 ? "J" : starter.rank === 12 ? "Q" : starter.rank === 13 ? "K" : String(starter.rank || starter.r || "");
        const su = String(starter.suit || starter.s || "").toUpperCase();
        const s = SUIT_SYM && SUIT_SYM[su] || suitSym[su] || su;
        starterLabel = `${r}${s}`;
      }
      const shareUrl = _CountingTrainer.encodeShareUrl(cards, starter, mode);
      return `\u{1F9EE} Crazy Cribbage - Counting Challenge!
Mode: ${mode === 9 ? "9-Card Super Hand" : "Standard 6-Card Hand"}
Hand: ${cardLabels} | Starter: ${starterLabel}
Can you score this hand correctly without peeking?
Test yourself here: ${shareUrl}`;
    }
  };

  // src/coach/CoachPostMortem.js
  var CoachPostMortem = class _CoachPostMortem {
    /**
     * Analyzes match history and generates comprehensive post-mortem analytics.
     * @param {Object} context
     * @param {Object} [context.state]
     * @param {Object} [context.settings]
     * @returns {Object} Full post-mortem analytics report
     */
    static analyzeMatch(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : {}) || {};
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {}) || {};
      const replay = context.replay || GameReplayManager.currentReplay || GameReplayManager.lastRecordedReplay;
      const trackedHands = HandScoreTracker.getHands();
      const discardDecisions = _CoachPostMortem.extractDiscardDecisions(state3, replay);
      const discardAnalysis = _CoachPostMortem.evaluateDiscardEfficiency(discardDecisions);
      const peggingTurns = _CoachPostMortem.extractPeggingTurns(state3, replay);
      const peggingAnalysis = _CoachPostMortem.evaluatePeggingEfficiency(peggingTurns, state3);
      const luckAnalysis = _CoachPostMortem.evaluateLuckAndSynergy(state3, trackedHands, replay);
      const combinedSkill = Math.round(discardAnalysis.efficiencyPct * 0.55 + peggingAnalysis.efficiencyPct * 0.45);
      const gradeInfo = _CoachPostMortem.computeCoachGrade(combinedSkill, discardAnalysis, peggingAnalysis);
      return {
        matchDate: (/* @__PURE__ */ new Date()).toLocaleDateString(void 0, { month: "short", day: "numeric", year: "numeric" }),
        target: settings3.target || 121,
        goal: settings3.goal || "high",
        winner: state3.winner || state3.scores && (state3.scores.you > state3.scores.cpu ? "you" : "cpu") || "you",
        scores: state3.scores || { you: 0, cpu: 0 },
        combinedSkill,
        grade: gradeInfo.grade,
        gradeTitle: gradeInfo.title,
        summaryTakeaway: gradeInfo.takeaway,
        discard: discardAnalysis,
        pegging: peggingAnalysis,
        luck: luckAnalysis
      };
    }
    /**
     * Extracts player discards from match state history or replay events.
     */
    static extractDiscardDecisions(state3, replay) {
      if (state3.coachHistory && Array.isArray(state3.coachHistory.discards) && state3.coachHistory.discards.length > 0) {
        return state3.coachHistory.discards;
      }
      const decisions = [];
      if (replay && Array.isArray(replay.events)) {
        let currentRound = 1;
        let roundHands = {};
        let roundDealer = "p1";
        for (const ev of replay.events) {
          if (ev.round) currentRound = ev.round;
          if (ev.type === "game_start" && ev.dealer) roundDealer = ev.dealer;
          if (ev.type === "deal" && ev.hands) {
            roundHands = JSON.parse(JSON.stringify(ev.hands));
            if (ev.dealer) roundDealer = ev.dealer;
          }
          if (ev.type === "discard" && (ev.who === "p1" || ev.who === "you")) {
            const dealtHand = (roundHands["p1"] || roundHands["you"] || []).slice();
            const thrown = ev.discards || [];
            const kept = ev.kept || [];
            if (dealtHand.length >= 5) {
              decisions.push({
                round: currentRound,
                isDealer: roundDealer === "p1" || roundDealer === "you",
                hand: dealtHand,
                discards: thrown,
                kept
              });
            }
          }
        }
      }
      return decisions;
    }
    /**
     * Evaluates all discard decisions made during the match.
     */
    static evaluateDiscardEfficiency(discards) {
      if (!discards || discards.length === 0) {
        return {
          handsAnalyzed: 0,
          optimalCount: 0,
          totalLossEV: 0,
          averageLossEV: 0,
          efficiencyPct: 95,
          ratingLabel: "Standard Strategy",
          details: []
        };
      }
      let totalLossEV = 0;
      let optimalCount = 0;
      const details = [];
      for (let i = 0; i < discards.length; i++) {
        const d = discards[i];
        let hand = d.hand || [];
        const userThrown = d.discards || [];
        const isDealer = Boolean(d.isDealer);
        if (hand.length === 6) {
          try {
            const analysis = DiscardTrainer.analyzeHand(hand, isDealer);
            const userKey = userThrown.map((c) => c.id).sort().join("-");
            const match = analysis.combos.find((c) => c.id === userKey) || analysis.combos[0];
            const diff = match ? match.evDiff : 0;
            const isOptimal = match ? match.rank === 1 : true;
            if (isOptimal) optimalCount++;
            totalLossEV += diff;
            details.push({
              handNumber: d.round || i + 1,
              isDealer,
              hand,
              userDiscards: userThrown,
              userKept: d.kept || [],
              optimalDiscards: analysis.optimal.disc,
              optimalKept: analysis.optimal.keep,
              isOptimal,
              evDiff: diff,
              userNetEV: match ? match.netEV : analysis.optimal.netEV,
              optimalNetEV: analysis.optimal.netEV,
              userRank: match ? match.rank : 1,
              userKey,
              analysisCombos: analysis.combos,
              tips: DiscardTrainer.generateStrategyTips(analysis, match || analysis.optimal)
            });
          } catch (_) {
            optimalCount++;
            details.push({
              handNumber: d.round || i + 1,
              isDealer,
              hand,
              userDiscards: userThrown,
              isOptimal: true,
              evDiff: 0,
              tips: ["Standard discard pattern."]
            });
          }
        } else {
          optimalCount++;
          details.push({
            handNumber: d.round || i + 1,
            isDealer,
            hand,
            userDiscards: userThrown,
            isOptimal: true,
            evDiff: 0,
            tips: ["Variant hand play."]
          });
        }
      }
      const totalHands = discards.length;
      const avgLoss = totalHands > 0 ? Number((totalLossEV / totalHands).toFixed(2)) : 0;
      const efficiencyPct = Math.max(50, Math.min(100, Math.round(100 - avgLoss * 13.5)));
      let ratingLabel = "Optimal Strategy \u{1F3C6}";
      if (efficiencyPct >= 95) ratingLabel = "Grandmaster Accuracy \u{1F3C6}";
      else if (efficiencyPct >= 88) ratingLabel = "Excellent Discards \u{1F44D}";
      else if (efficiencyPct >= 80) ratingLabel = "Solid Fundamentals \u2714";
      else ratingLabel = "Room for Optimization \u26A0\uFE0F";
      return {
        handsAnalyzed: totalHands,
        optimalCount,
        totalLossEV: Number(totalLossEV.toFixed(2)),
        averageLossEV: avgLoss,
        efficiencyPct,
        ratingLabel,
        details
      };
    }
    /**
     * Extracts pegging turns from match state history or replay events.
     */
    static extractPeggingTurns(state3, replay) {
      if (state3.coachHistory && Array.isArray(state3.coachHistory.peggingTurns) && state3.coachHistory.peggingTurns.length > 0) {
        return state3.coachHistory.peggingTurns.filter((t) => t.who === "p1" || t.who === "you");
      }
      const turns = [];
      if (replay && Array.isArray(replay.events)) {
        for (const ev of replay.events) {
          if (ev.type === "peg_play" && (ev.who === "p1" || ev.who === "you")) {
            turns.push({
              round: ev.round || 1,
              cardPlayed: ev.card,
              pointsScored: ev.points || 0,
              maxPointsPossible: ev.points || 0,
              reason: ev.reason || "play"
            });
          }
        }
      }
      return turns;
    }
    /**
     * Evaluates pegging efficiency (points captured vs. points available).
     */
    static evaluatePeggingEfficiency(peggingTurns, state3) {
      let captured = 0;
      let available = 0;
      const highlights = [];
      for (const turn of peggingTurns) {
        const pts = turn.pointsScored || 0;
        captured += pts;
        const maxPts = turn.maxPointsPossible !== void 0 ? Math.max(pts, turn.maxPointsPossible) : pts;
        available += maxPts;
        if (pts >= 3 || turn.reason && /fifteen|pair|run|thirty/i.test(turn.reason)) {
          highlights.push({
            round: turn.round || 1,
            pts,
            reason: turn.reason || "Combo",
            card: turn.cardPlayed
          });
        }
      }
      if (captured === 0 && state3.scores) {
        const p1Score = state3.scores.you || state3.scores.p1 || 0;
        captured = Math.max(0, Math.min(28, Math.round(p1Score * 0.22)));
        available = Math.max(captured, captured + 4);
      }
      const efficiencyPct = available > 0 ? Math.max(45, Math.min(100, Math.round(captured / available * 100))) : 88;
      return {
        captured,
        available: Math.max(captured, available),
        efficiencyPct,
        turnsCount: peggingTurns.length,
        highlights: highlights.slice(0, 4)
      };
    }
    /**
     * Evaluates luck vs skill: net cut value and starter synergy across match rounds.
     */
    static evaluateLuckAndSynergy(state3, trackedHands, replay) {
      let totalCutSynergy = 0;
      let roundsCount = 0;
      const cutDetails = [];
      const hands = trackedHands.length > 0 ? trackedHands : (function() {
        const syn = [];
        if (replay && Array.isArray(replay.events)) {
          for (const ev of replay.events) {
            if (ev.type === "show_hand" && (ev.who === "you" || ev.who === "p1")) {
              syn.push({
                handNumber: ev.round || syn.length + 1,
                starter: ev.starter,
                scores: { p1: { hand: ev.score && ev.score.total || 8 } }
              });
            }
          }
        }
        return syn;
      })();
      for (let i = 0; i < hands.length; i++) {
        const h = hands[i];
        const p1 = h.scores && h.scores.p1 || { hand: 8 };
        const handScore = p1.hand || 0;
        const starter = h.starter || null;
        const baselineEV = 4.6;
        const synergy = Number((handScore - 8.2).toFixed(1));
        totalCutSynergy += synergy;
        roundsCount++;
        cutDetails.push({
          handNumber: h.handNumber || i + 1,
          starter,
          handScore,
          synergy
        });
      }
      const avgNetCut = roundsCount > 0 ? Number((totalCutSynergy / roundsCount).toFixed(1)) : 0;
      const luckRating = avgNetCut >= 2.5 ? "Favorable Cuts \u{1F340}" : avgNetCut >= -1 ? "Balanced Starter Cuts \u2696\uFE0F" : "Cold Deck Runs \u2744\uFE0F";
      const luckPct = Math.max(25, Math.min(75, Math.round(50 + avgNetCut * 4)));
      const skillPct = 100 - luckPct;
      return {
        totalCutSynergy: Number(totalCutSynergy.toFixed(1)),
        averageNetCut: avgNetCut,
        luckRating,
        luckPct,
        skillPct,
        cutDetails
      };
    }
    /**
     * Computes overall coach grade and actionable takeaways.
     */
    static computeCoachGrade(skillScore, discard, pegging) {
      let grade = "A";
      let title = "Master Strategist";
      let takeaway = "Outstanding match performance with disciplined discard efficiency and clinical pegging.";
      if (skillScore >= 94) {
        grade = "A+";
        title = "Grandmaster Execution";
        takeaway = "Nearly flawless match play! Your discards strictly adhered to game theory optimal EV, and you captured nearly every pegging point available.";
      } else if (skillScore >= 88) {
        grade = "A";
        title = "Tactical Master";
        takeaway = "Strong fundamental play! You consistently protected your hand potential while defending against opponent crib seeding.";
      } else if (skillScore >= 80) {
        grade = "B+";
        title = "Sharp Competitor";
        takeaway = "Solid overall strategy. A couple of minor discard EV concessions and pegging counter-attacks held you back from perfection.";
      } else if (skillScore >= 72) {
        grade = "B";
        title = "Developing Tactician";
        takeaway = "Good instincts, but you gave up valuable expected points on discards. Review the alternate discard recommendations below.";
      } else {
        grade = "C+";
        title = "Room for Polish";
        takeaway = "Focus on protecting your hand EV during the discard phase and avoiding premature leads of 5-value cards in pegging.";
      }
      return { grade, title, takeaway };
    }
    /**
     * Renders the complete Coach's Post-Mortem modal HTML.
     * @param {Object} analysis
     * @returns {string}
     */
    static buildPostMortemHtml(analysis) {
      _CoachPostMortem.lastReport = analysis;
      const {
        grade,
        gradeTitle,
        summaryTakeaway,
        combinedSkill,
        discard,
        pegging,
        luck
      } = analysis;
      const gradeColor = grade.startsWith("A") ? "#10b981" : grade.startsWith("B") ? "#f59e0b" : "#38bdf8";
      return `
      <div class="coach-post-mortem-modal" style="max-width: 720px; margin: 0 auto; text-align: left; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; color: #f4ead4;">
        <!-- Header Banner -->
        <div class="post-mortem-header" style="display: flex; align-items: center; justify-content: space-between; border-bottom: 2px solid rgba(240,198,74,0.3); padding-bottom: 14px; margin-bottom: 16px; flex-wrap: wrap; gap: 12px;">
          <div style="display: flex; align-items: center; gap: 14px;">
            <div class="grade-badge" style="width: 58px; height: 58px; border-radius: 14px; background: linear-gradient(135deg, rgba(16,185,129,0.2), rgba(6,182,212,0.2)); border: 2.5px solid ${gradeColor}; display: flex; align-items: center; justify-content: center; font-size: 2rem; font-weight: 900; color: ${gradeColor}; text-shadow: 0 0 12px ${gradeColor}80; box-shadow: 0 4px 16px rgba(0,0,0,0.4);">
              ${grade}
            </div>
            <div>
              <div style="font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.08em; color: #f0c64a; font-weight: 800;">\u{1F393} Coach's Match Post-Mortem</div>
              <div style="font-size: 1.35rem; font-weight: 800; color: #ffffff;">${gradeTitle} (${combinedSkill}% Accuracy)</div>
            </div>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <div style="font-size: 0.8rem; color: #9ca3af; text-align: right;">
              Match Performance Audit
            </div>
          </div>
        </div>

        <!-- Takeaway Callout -->
        <div style="background: rgba(240,198,74,0.08); border: 1.5px solid rgba(240,198,74,0.35); border-radius: 10px; padding: 12px 16px; margin-bottom: 18px; font-size: 0.92rem; line-height: 1.45;">
          <strong>\u{1F4A1} Coach's Verdict:</strong> ${summaryTakeaway}
        </div>

        <!-- Tri-Stat Analytics Grid -->
        <div class="post-mortem-stats-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 20px;">
          <!-- 1. Discard Efficiency -->
          <div class="pm-stat-card" style="background: rgba(0,0,0,0.35); border: 1.5px solid rgba(16,185,129,0.4); border-radius: 12px; padding: 14px; text-align: center;">
            <div style="font-size: 0.75rem; font-weight: 800; color: #34d399; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px;">\u{1F3AF} Discard Efficiency</div>
            <div style="font-size: 1.8rem; font-weight: 900; color: #34d399;">${discard.efficiencyPct}%</div>
            <div style="font-size: 0.82rem; color: #e2e8f0; font-weight: 700; margin-top: 2px;">${discard.optimalCount} of ${discard.handsAnalyzed} Optimal</div>
            <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 4px;">Avg EV Gap: -${discard.averageLossEV} pts</div>
          </div>

          <!-- 2. Pegging Efficiency -->
          <div class="pm-stat-card" style="background: rgba(0,0,0,0.35); border: 1.5px solid rgba(56,189,248,0.4); border-radius: 12px; padding: 14px; text-align: center;">
            <div style="font-size: 0.75rem; font-weight: 800; color: #38bdf8; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px;">\u2694\uFE0F Pegging Efficiency</div>
            <div style="font-size: 1.8rem; font-weight: 900; color: #38bdf8;">${pegging.efficiencyPct}%</div>
            <div style="font-size: 0.82rem; color: #e2e8f0; font-weight: 700; margin-top: 2px;">${pegging.captured} / ${pegging.available} Pts</div>
            <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 4px;">Captured vs. Available</div>
          </div>

          <!-- 3. Luck vs Skill Breakdown -->
          <div class="pm-stat-card" style="background: rgba(0,0,0,0.35); border: 1.5px solid rgba(245,158,11,0.4); border-radius: 12px; padding: 14px; text-align: center;">
            <div style="font-size: 0.75rem; font-weight: 800; color: #fbbf24; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px;">\u{1F340} Luck vs. Skill</div>
            <div style="font-size: 1.45rem; font-weight: 900; color: #fbbf24; margin-top: 4px;">${luck.skillPct}% Skill \xB7 ${luck.luckPct}% Luck</div>
            <div style="font-size: 0.82rem; color: #e2e8f0; font-weight: 700; margin-top: 2px;">${luck.luckRating}</div>
            <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 4px;">Net Cut: ${luck.averageNetCut >= 0 ? "+" : ""}${luck.averageNetCut} pts</div>
          </div>
        </div>

        <!-- Hand-by-Hand Discard Efficiency Breakdown -->
        <div class="pm-section" style="background: rgba(0,0,0,0.25); border: 1px solid rgba(244,234,212,0.15); border-radius: 12px; padding: 14px 16px; margin-bottom: 16px;">
          <div style="font-size: 0.95rem; font-weight: 800; color: #f0c64a; margin-bottom: 10px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 6px;">
            <span>\u{1F4CB} Hand-by-Hand Discard Breakdown</span>
            <span style="font-size: 0.75rem; color: #9ca3af; font-weight: normal;">Click any hand to inspect all 15 EV combinations &amp; alternate plays</span>
          </div>

          <div style="display: flex; flex-direction: column; gap: 8px;">
            ${discard.details.map((d, i) => {
        const userDiscardsHtml = (d.userDiscards || []).map((c) => _CoachPostMortem.formatCardMini(c)).join(" ");
        const optimalDiscardsHtml = (d.optimalDiscards || []).map((c) => _CoachPostMortem.formatCardMini(c)).join(" ");
        const hasCombos = Array.isArray(d.analysisCombos) && d.analysisCombos.length > 0;
        const userKey = d.userKey || (d.userDiscards || []).map((c) => c.id).sort().join("-");
        const tableRowsHtml = hasCombos ? d.analysisCombos.map((combo) => {
          const isUserPick = combo.id === userKey;
          const isOptimalPick = combo.rank === 1;
          let rowBg = "transparent";
          if (isUserPick && isOptimalPick) rowBg = "rgba(16, 185, 129, 0.22)";
          else if (isUserPick) rowBg = "rgba(240, 198, 74, 0.18)";
          else if (isOptimalPick) rowBg = "rgba(16, 185, 129, 0.14)";
          const discMiniHtml = combo.disc.map((c) => _CoachPostMortem.formatCardMini(c)).join(" ");
          const keepMiniHtml = combo.keep.map((c) => _CoachPostMortem.formatCardMini(c, true)).join(" ");
          return `
                  <tr style="background: ${rowBg}; border-bottom: 1px solid rgba(255,255,255,0.06); font-size: 0.8rem;">
                    <td style="padding: 5px 8px; font-weight: 800; color: ${isOptimalPick ? "#10b981" : isUserPick ? "#f0c64a" : "#a8a29e"}; text-align: center;">
                      ${combo.rank}${isOptimalPick ? " \u2605" : ""}${isUserPick ? " \u{1F448}" : ""}
                    </td>
                    <td style="padding: 5px 8px; white-space: nowrap;">${discMiniHtml}</td>
                    <td style="padding: 5px 8px; white-space: nowrap;">${keepMiniHtml}</td>
                    <td style="padding: 5px 8px; text-align: center; color: #e7e5e4;">
                      <span style="font-weight: 700;">${combo.handEV.toFixed(1)}</span>
                      <span style="font-size: 0.72rem; color: #9ca3af; margin-left: 3px;">(${combo.handMin}\u2013${combo.handMax})</span>
                    </td>
                    <td style="padding: 5px 8px; text-align: center; color: #cbd5e1;">${combo.cribEV > 0 ? "+" : ""}${combo.cribEV.toFixed(1)}</td>
                    <td style="padding: 5px 8px; text-align: center; font-weight: 800; color: ${isOptimalPick ? "#10b981" : "#f4ead4"};">
                      ${combo.netEV > 0 ? "+" : ""}${combo.netEV.toFixed(1)}
                    </td>
                    <td style="padding: 5px 8px; text-align: center; font-size: 0.76rem; font-weight: 700; color: ${combo.evDiff === 0 ? "#10b981" : "#f87171"};">
                      ${combo.evDiff === 0 ? "0.0" : `-${combo.evDiff.toFixed(1)}`}
                    </td>
                  </tr>
                `;
        }).join("") : "";
        return `
                <div class="coach-hand-item" style="background: rgba(255,255,255,0.03); border: 1.5px solid ${d.isOptimal ? "rgba(16,185,129,0.35)" : "rgba(239,68,68,0.4)"}; border-radius: 10px; overflow: hidden; transition: border-color 0.2s ease, background 0.2s ease;">
                  <!-- Clickable Row Header -->
                  <div class="coach-hand-row-header" data-coach-hand-toggle="${i}" style="padding: 10px 14px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px; cursor: pointer; user-select: none;" title="Click to toggle full 15-combination EV breakdown">
                    <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
                      <span style="font-size: 0.78rem; font-weight: 800; background: ${d.isDealer ? "#ca8a04" : "#334155"}; color: #ffffff; padding: 2px 7px; border-radius: 4px;">
                        Hand ${d.handNumber} \xB7 ${d.isDealer ? "CRIB" : "PONE"}
                      </span>
                      <span style="font-size: 0.86rem; color: #e2e8f0; display: inline-flex; align-items: center; gap: 4px;">
                        Tossed: ${userDiscardsHtml}
                      </span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
                      <span style="font-size: 0.82rem; font-weight: 700; color: ${d.isOptimal ? "#34d399" : "#f87171"}; display: inline-flex; align-items: center; gap: 4px;">
                        ${d.isOptimal ? "Optimal Pick \u{1F3C6}" : `Alternate: ${optimalDiscardsHtml} (-${Number(d.evDiff).toFixed(1)} EV)`}
                      </span>
                      <span id="coachHandToggleBtn_${i}" class="coach-hand-toggle-pill" style="font-size: 0.75rem; font-weight: 700; padding: 3px 9px; border-radius: 12px; background: rgba(240,198,74,0.15); border: 1px solid rgba(240,198,74,0.4); color: #f0c64a; display: inline-flex; align-items: center; gap: 4px;">
                        \u25BC View All EV Details
                      </span>
                    </div>
                  </div>

                  <!-- Collapsible EV Drawer -->
                  <div id="coachHandEv_${i}" class="coach-hand-ev-drawer" style="display: none; padding: 12px 14px 14px; border-top: 1px solid rgba(255,255,255,0.08); background: rgba(0,0,0,0.38);">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; flex-wrap: wrap; gap: 8px;">
                      <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                        <span style="font-size: 0.78rem; font-weight: 800; padding: 3px 8px; border-radius: 5px; background: ${d.isOptimal ? "#10b981" : "#f59e0b"}; color: #0f172a; letter-spacing: 0.03em;">
                          ${d.isOptimal ? "OPTIMAL DISCARD" : `YOUR PICK: RANK #${d.userRank || "?"} OF 15`}
                        </span>
                        ${d.hand && d.hand.length ? `
                          <span style="font-size: 0.8rem; color: #cbd5e1; display: inline-flex; align-items: center; gap: 3px;">
                            Dealt: ${d.hand.map((c) => _CoachPostMortem.formatCardMini(c)).join(" ")}
                          </span>
                        ` : ""}
                      </div>
                      ${d.hand && d.hand.length === 6 ? `
                        <button type="button" class="btn-ghost" data-coach-practice="${i}" style="padding: 4px 10px; font-size: 0.78rem; font-weight: 700; border-radius: 6px; border: 1.5px solid rgba(16,185,129,0.55); color: #34d399; background: rgba(16,185,129,0.15); cursor: pointer; transition: background 0.15s ease;">
                          \u{1F3AF} Practice in Discard Trainer
                        </button>
                      ` : ""}
                    </div>

                    ${d.tips && d.tips.length ? `
                      <div style="margin-bottom: 10px; padding: 8px 12px; background: rgba(240,198,74,0.08); border-left: 3px solid #f0c64a; border-radius: 4px; font-size: 0.8rem; color: #fef08a; line-height: 1.45;">
                        ${d.tips.map((t) => `<div>\u{1F4A1} ${t}</div>`).join("")}
                      </div>
                    ` : ""}

                    ${hasCombos ? `
                      <div style="max-height: 250px; overflow-y: auto; overflow-x: auto; border: 1px solid rgba(255,255,255,0.1); border-radius: 6px;">
                        <table style="width: 100%; border-collapse: collapse; text-align: left; font-family: inherit;">
                          <thead>
                            <tr style="background: rgba(0,0,0,0.65); border-bottom: 1px solid rgba(255,255,255,0.15); font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.05em; color: #a8a29e;">
                              <th style="padding: 6px 8px; text-align: center;">Rank</th>
                              <th style="padding: 6px 8px;">Discard (2)</th>
                              <th style="padding: 6px 8px;">Keep (4)</th>
                              <th style="padding: 6px 8px; text-align: center;">Hand EV (Min\u2013Max)</th>
                              <th style="padding: 6px 8px; text-align: center;">Crib EV</th>
                              <th style="padding: 6px 8px; text-align: center;">Net Score</th>
                              <th style="padding: 6px 8px; text-align: center;">Loss</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${tableRowsHtml}
                          </tbody>
                        </table>
                      </div>
                    ` : `
                      <div style="font-size: 0.82rem; color: #9ca3af; text-align: center; padding: 8px;">
                        Full 15-combination matrix available for standard 6-card deals.
                      </div>
                    `}
                  </div>
                </div>
              `;
      }).join("")}
          </div>
        </div>

        <!-- Action Buttons (Responsive Grid/Flex Layout) -->
        <div class="post-mortem-actions" style="display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; gap: 10px !important; justify-content: space-between !important; align-items: stretch !important; margin-top: 18px !important; width: 100% !important; box-sizing: border-box !important;">
          <button type="button" class="btn-ghost pm-btn pm-btn-discard" data-action="discard-trainer" style="flex: 1 1 200px !important; min-width: 170px !important; padding: 10px 12px !important; font-size: 0.88rem !important; font-weight: 700 !important; border-radius: 8px !important; border: 1.5px solid rgba(16,185,129,0.6) !important; color: #34d399 !important; background: rgba(16,185,129,0.15) !important; cursor: pointer !important; white-space: normal !important; word-break: normal !important; overflow: hidden !important; text-align: center !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; line-height: 1.25 !important; min-height: 44px !important;">
            \u{1F3AF} Practice Discard Trainer
          </button>
          <button type="button" class="btn-ghost pm-btn pm-btn-pegging" data-action="pegging-trainer" style="flex: 1 1 200px !important; min-width: 170px !important; padding: 10px 12px !important; font-size: 0.88rem !important; font-weight: 700 !important; border-radius: 8px !important; border: 1.5px solid rgba(56,189,248,0.6) !important; color: #38bdf8 !important; background: rgba(56,189,248,0.15) !important; cursor: pointer !important; white-space: normal !important; word-break: normal !important; overflow: hidden !important; text-align: center !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; line-height: 1.25 !important; min-height: 44px !important;">
            \u2694\uFE0F Practice Pegging Tactics
          </button>
          <button type="button" class="btn-gold pm-btn pm-btn-back modal-btn-close" id="btnClosePostMortem" data-action="close" style="flex: 1 1 200px !important; min-width: 170px !important; padding: 10px 12px !important; font-size: 0.88rem !important; font-weight: 800 !important; border-radius: 8px !important; background: linear-gradient(135deg,#f0c64a,#ca8a04) !important; color: #1a1208 !important; cursor: pointer !important; white-space: normal !important; word-break: normal !important; overflow: hidden !important; text-align: center !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; border: 1.5px solid rgba(240,198,74,0.9) !important; line-height: 1.25 !important; min-height: 44px !important;">
            \u{1F3C6} Back to Game Results
          </button>
        </div>
      </div>
    `;
    }
    /**
     * Formats a card into a styled miniature card HTML snippet.
     */
    static formatCardMini(c, isKeep = false) {
      if (!c) return "";
      const suit = c.suit || c.s || "";
      const isRed = suit === "H" || suit === "D";
      const color = isRed ? "#dc2626 !important" : "#111827 !important";
      const r = c.rankName || (c.rank === 1 ? "A" : c.rank === 11 ? "J" : c.rank === 12 ? "Q" : c.rank === 13 ? "K" : c.rank || c.r || "");
      const suitSymbols = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const sym = suitSymbols[suit] || suit;
      const pad = isKeep ? "1px 5px" : "2px 6px";
      const fsize = isKeep ? "0.78rem" : "0.82rem";
      return `<span class="trainer-mini-card ${isRed ? "card-red" : "card-black"}" style="display: inline-block; padding: ${pad}; border-radius: 4px; font-weight: 700; font-size: ${fsize}; background: #ffffff !important; color: ${color}; -webkit-text-fill-color: ${color}; border: 1px solid #cbd5e1; box-shadow: 0 1px 2px rgba(0,0,0,0.18); margin: 0 2px 0 0; vertical-align: middle;">${r}${sym}</span>`;
    }
    /**
     * Opens the Discard Trainer modal loaded with the specified match hand.
     */
    static practiceHand(index) {
      const detail = _CoachPostMortem.lastReport?.discard?.details?.[index];
      if (!detail || !detail.hand) return;
      const showTrainer = typeof window !== "undefined" && window.showDiscardTrainerModal ? window.showDiscardTrainerModal : typeof window !== "undefined" && window.modalManager && window.modalManager.showDiscardTrainerModal ? window.modalManager.showDiscardTrainerModal.bind(window.modalManager) : null;
      if (showTrainer) {
        showTrainer({ hand: detail.hand, isDealer: detail.isDealer });
      }
    }
    /**
     * Generates formatted clipboard and social share text for the post-mortem report.
     * @param {Object} [report]
     * @returns {string} Formatted text
     */
    static generateShareText(report = _CoachPostMortem.lastReport) {
      const r = report || _CoachPostMortem.lastReport || (typeof _CoachPostMortem.analyzeMatch === "function" ? _CoachPostMortem.analyzeMatch() : null) || {};
      const grade = r.grade || "A";
      const title = r.gradeTitle || "Match Performance";
      const acc = r.combinedSkill !== void 0 ? `${r.combinedSkill}%` : "85%";
      const you = r.scores?.you ?? 0;
      const cpu = r.scores?.cpu ?? 0;
      const target = r.target || 121;
      const result = r.winner === "you" || you >= target ? "Victory \u{1F3C6}" : "Defeat";
      const discEff = r.discard?.efficiencyPct !== void 0 ? `${r.discard.efficiencyPct}%` : "\u2014";
      const discOpt = r.discard?.optimalCount !== void 0 && r.discard?.handsAnalyzed !== void 0 ? `${r.discard.optimalCount}/${r.discard.handsAnalyzed} Optimal` : "";
      const avgLoss = r.discard?.averageLossEV !== void 0 && r.discard.averageLossEV > 0 ? `-${r.discard.averageLossEV} EV Gap` : "";
      const discSummary = [discEff, discOpt, avgLoss].filter(Boolean).join(" \xB7 ");
      const pegEff = r.pegging?.efficiencyPct !== void 0 ? `${r.pegging.efficiencyPct}%` : "\u2014";
      const pegPts = r.pegging?.captured !== void 0 && r.pegging?.available !== void 0 ? `${r.pegging.captured}/${r.pegging.available} Pts` : "";
      const pegSummary = [pegEff, pegPts].filter(Boolean).join(" \xB7 ");
      const luckSkill = r.luck?.skillPct !== void 0 && r.luck?.luckPct !== void 0 ? `${r.luck.skillPct}% Skill \xB7 ${r.luck.luckPct}% Luck (${r.luck.luckRating || "Even Cuts"})` : "";
      const verdict = r.summaryTakeaway ? `
\u{1F4A1} Verdict: ${r.summaryTakeaway}` : "";
      const url = _CoachPostMortem.generateShareUrl(r);
      return [
        `\u{1F393} Coach's Match Post-Mortem \u2014 Crazy Cribbage`,
        `Grade: ${grade} \xB7 ${title} (${acc} Accuracy) \xB7 ${result}`,
        `Score: You ${you} \u2013 ${cpu} Computer (Target: ${target})`,
        ``,
        `\u{1F3AF} Discard Efficiency: ${discSummary}`,
        `\u2694\uFE0F Pegging Efficiency: ${pegSummary}`,
        luckSkill ? `\u{1F340} Luck vs. Skill: ${luckSkill}` : "",
        verdict,
        ``,
        `Play Crazy Cribbage: ${url}`
      ].filter((line) => line !== null && line !== void 0).join("\n");
    }
    /**
     * Generates a direct web URL linking to Crazy Cribbage with post-mortem param.
     * @param {Object} [report]
     * @returns {string} URL string
     */
    static generateShareUrl(report = _CoachPostMortem.lastReport) {
      if (typeof window !== "undefined" && window.location) {
        const base = window.location.origin + window.location.pathname;
        return `${base}?tool=postmortem`;
      }
      return "https://crazycribbage.com/?tool=postmortem";
    }
    /**
     * Helper to display temporary toast message.
     * @param {string} msg
     */
    static showToast(msg) {
      if (typeof window !== "undefined") {
        if (typeof window.showToast === "function") {
          window.showToast(msg);
          return;
        }
        if (typeof window.showScoreToast === "function") {
          window.showScoreToast(msg, 2500);
          return;
        }
      }
      if (typeof document === "undefined") return;
      const existing = document.getElementById("coachPostMortemToast");
      if (existing) existing.remove();
      const toast = document.createElement("div");
      toast.id = "coachPostMortemToast";
      toast.textContent = msg;
      toast.style.cssText = "position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:rgba(22,16,8,0.96);border:1.5px solid #f0c64a;color:#f0c64a;padding:10px 18px;border-radius:999px;font-weight:700;font-size:0.86rem;z-index:99999;box-shadow:0 8px 24px rgba(0,0,0,0.6);";
      document.body.appendChild(toast);
      setTimeout(() => {
        toast.style.opacity = "0";
        toast.style.transition = "opacity 0.25s ease";
        setTimeout(() => toast.remove(), 260);
      }, 2400);
    }
    /**
     * Copies formatted text breakdown of the post-mortem to clipboard.
     * @param {Object} [report]
     * @returns {Promise<boolean>}
     */
    static async copyShareText(report = _CoachPostMortem.lastReport) {
      const text2 = _CoachPostMortem.generateShareText(report);
      try {
        if (typeof navigator !== "undefined" && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text2);
          _CoachPostMortem.showToast("\u{1F4CB} Coach's Post-Mortem copied to clipboard!");
          return true;
        }
      } catch (_) {
      }
      if (typeof document !== "undefined") {
        const ta = document.createElement("textarea");
        ta.value = text2;
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand("copy");
          ta.remove();
          _CoachPostMortem.showToast("\u{1F4CB} Coach's Post-Mortem copied to clipboard!");
          return true;
        } catch (_) {
          ta.remove();
        }
      }
      if (typeof window !== "undefined" && window.prompt) {
        window.prompt("Copy Coach's Post-Mortem:", text2);
        return true;
      }
      return false;
    }
    /**
     * Copies shareable web link to clipboard.
     * @param {Object} [report]
     * @returns {Promise<boolean>}
     */
    static async copyShareUrl(report = _CoachPostMortem.lastReport) {
      const url = _CoachPostMortem.generateShareUrl(report);
      try {
        if (typeof navigator !== "undefined" && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
          _CoachPostMortem.showToast("\u{1F517} Match link copied to clipboard!");
          return true;
        }
      } catch (_) {
      }
      if (typeof window !== "undefined" && window.prompt) {
        window.prompt("Copy match link:", url);
        return true;
      }
      return false;
    }
    /**
     * Triggers native Mobile/Desktop Web Share API if supported.
     * @param {Object} [report]
     */
    static async shareNative(report = _CoachPostMortem.lastReport) {
      const r = report || _CoachPostMortem.lastReport || (typeof _CoachPostMortem.analyzeMatch === "function" ? _CoachPostMortem.analyzeMatch() : null) || {};
      const title = `Coach's Match Post-Mortem (${r.grade || "A"} Grade \xB7 ${r.combinedSkill || 85}% Accuracy)`;
      const text2 = _CoachPostMortem.generateShareText(r);
      const url = _CoachPostMortem.generateShareUrl(r);
      if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
        try {
          await navigator.share({ title, text: text2, url });
          return true;
        } catch (err) {
          if (err.name === "AbortError") return false;
        }
      }
      return _CoachPostMortem.copyShareText(r);
    }
    /**
     * Downloads full JSON file of the post-mortem audit report.
     * @param {Object} [report]
     */
    static downloadReport(report = _CoachPostMortem.lastReport) {
      if (typeof document === "undefined") return;
      const r = report || _CoachPostMortem.lastReport || (typeof _CoachPostMortem.analyzeMatch === "function" ? _CoachPostMortem.analyzeMatch() : null) || {};
      const gradeSlug = (r.grade || "Audit").replace(/[^a-zA-Z0-9]/g, "");
      const filename = `coach-post-mortem-${gradeSlug}-${Date.now()}.json`;
      const jsonStr = JSON.stringify(r, null, 2);
      const blob = new Blob([jsonStr], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        a.remove();
        URL.revokeObjectURL(url);
      }, 100);
      _CoachPostMortem.showToast(`\u{1F4BE} Downloaded ${filename}`);
    }
    /**
     * Share Match Post-Mortem dialog removed.
     * @param {Object} [report]
     */
    static openShareDialog(report = _CoachPostMortem.lastReport) {
      if (typeof document !== "undefined") {
        const dialog = document.getElementById("coachPostMortemShareDialog");
        if (dialog) dialog.remove();
      }
      return null;
    }
    /**
     * Toggles EV drawer visibility for hand index.
     * @param {number} idx
     */
    static toggleCoachHandDetails(idx) {
      if (typeof document === "undefined") return;
      const el = document.getElementById(`coachHandEv_${idx}`);
      const pill = document.getElementById(`coachHandToggleBtn_${idx}`);
      if (el) {
        const isHidden = el.style.display === "none" || !el.style.display;
        el.style.display = isHidden ? "block" : "none";
        if (pill) {
          pill.innerHTML = isHidden ? "\u25B2 Hide All EV Details" : "\u25BC View All EV Details";
        }
      }
    }
    /**
     * Binds click events for coach post-mortem modal container.
     * @param {Element|Document} [root=document]
     */
    static bindEvents(root = typeof document !== "undefined" ? document : null) {
      if (!root || typeof root.addEventListener !== "function") return;
      if (root._boundCoachEvents) return;
      root._boundCoachEvents = true;
      root.addEventListener("click", (e) => {
        const target = e.target;
        if (!target) return;
        const practiceBtn = target.closest ? target.closest("[data-coach-practice]") : null;
        if (practiceBtn) {
          if (e.stopPropagation) e.stopPropagation();
          const idx = practiceBtn.getAttribute("data-coach-practice");
          if (idx != null) _CoachPostMortem.practiceHand(Number(idx));
          return;
        }
        const toggleHeader = target.closest ? target.closest("[data-coach-hand-toggle]") : null;
        if (toggleHeader) {
          const idx = toggleHeader.getAttribute("data-coach-hand-toggle");
          if (idx != null) _CoachPostMortem.toggleCoachHandDetails(Number(idx));
          return;
        }
        const actionBtn = target.closest ? target.closest("[data-action]") : null;
        if (actionBtn) {
          const action = actionBtn.getAttribute("data-action");
          if (action === "discard-trainer") {
            if (typeof window !== "undefined" && typeof window.showDiscardTrainerModal === "function") {
              window.showDiscardTrainerModal();
            } else if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showDiscardTrainerModal === "function") {
              window.modalManager.showDiscardTrainerModal();
            }
          } else if (action === "pegging-trainer") {
            if (typeof window !== "undefined" && typeof window.showPeggingTrainerModal === "function") {
              window.showPeggingTrainerModal();
            } else if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showPeggingTrainerModal === "function") {
              window.modalManager.showPeggingTrainerModal();
            }
          } else if (action === "close") {
            if (typeof window !== "undefined" && typeof window.showGameWonModal === "function" && window.showGameWonModal()) {
              return;
            } else if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showGameWonModal === "function" && window.modalManager.showGameWonModal()) {
              return;
            } else if (typeof window !== "undefined" && typeof window.hideModal === "function") {
              window.hideModal();
            }
          }
        }
      });
    }
  };
  if (typeof window !== "undefined") {
    window.toggleCoachHandDetails = (idx) => CoachPostMortem.toggleCoachHandDetails(idx);
    window.practiceCoachHand = (idx) => {
      CoachPostMortem.practiceHand(idx);
    };
    window.shareCoachPostMortem = (report) => {
      return CoachPostMortem.openShareDialog(report);
    };
  }

  // src/trainer/DailyPuzzleManager.js
  var ANCHOR_DATE = /* @__PURE__ */ new Date("2026-01-01T00:00:00Z");
  var PEGGING_SCENARIOS = [
    {
      id: "endgame_116_118",
      title: "The 31-Trap Squeeze",
      subtitle: "Endgame Match Point",
      description: "You are Pone at 116 points. Dealer has 118 points. Game target is 121. The count is at 21 after Dealer played a 10. Opponent holds exactly one card remaining (a 6\u2665). What card do you play to guarantee the win before Dealer can peg out?",
      playerScore: 116,
      opponentScore: 118,
      targetScore: 121,
      isDealer: false,
      // Player is Pone
      currentCount: 21,
      countHistory: [
        { card: "5H", label: "5\u2665", playedBy: "pone", value: 5, countAfter: 5 },
        { card: "6D", label: "6\u2666", playedBy: "dealer", value: 6, countAfter: 11 },
        { card: "KC", label: "K\u2663", playedBy: "dealer", value: 10, countAfter: 21 }
      ],
      playerHand: [
        { id: "4S", r: 4, s: "S" },
        { id: "5D", r: 5, s: "D" },
        { id: "7C", r: 7, s: "C" }
      ],
      opponentKnown: "6\u2665 (Dealer holds 6\u2665)",
      optimalCardId: "4S",
      solutions: {
        "4S": {
          correct: true,
          grade: "SOLVED",
          badge: "\u{1F3AF} MASTER MOVE",
          explanation: 'Brilliant! Playing the 4\u2660 brings the count to exactly 25. Dealer holds 6\u2665, so playing it would make 31 for 2 pts, BUT 25 + 6 = 31! Dealer cannot play anything else and you claim 31 for 2 pts or if Dealer plays 6\u2665, count is 31 for Dealer? Wait! If count is 25, 25+6 = 31! With count at 25, Dealer MUST play 6\u2665 for 31 for 2 pts (120). Then Dealer has NO cards left, the count resets to 0, and you play your 7\u2663 and 5\u2666 for 1 point "Go" and peg out to 121 for the win!'
        },
        "5D": {
          correct: false,
          grade: "MISTAKE",
          badge: "\u274C BLUNDER",
          explanation: 'Fatal trap! Playing 5\u2666 brings the count to 26. Dealer can no longer play their 6 (26 + 6 = 32 > 31) and says "Go". You score 1 pt for 31/Go (117). But on the fresh count from 0, Dealer leads their 6\u2665, you must play 7 (count 13) or 4 (count 10), and Dealer scores the final "Go" to reach 119 and secures dealer crib first!'
        },
        "7C": {
          correct: false,
          grade: "MISTAKE",
          badge: "\u274C BLUNDER",
          explanation: "Disaster! Playing 7\u2663 brings the count to 28. Neither player can play. You get 1 pt for Go (117). But on the fresh count, Dealer holds their 6\u2665 and controls tempo to win the game."
        }
      }
    },
    {
      id: "run_trap_24",
      title: "The Stepping Stone Run",
      subtitle: "Trap & Run Counter",
      description: 'You are Dealer at 117 points. Pone has 119 points. The count is 17. The play sequence so far is 8\u2660 then 9\u2666. Pone has just said "Go". What card do you drop to secure maximum consecutive pegging points?',
      playerScore: 117,
      opponentScore: 119,
      targetScore: 121,
      isDealer: true,
      currentCount: 17,
      countHistory: [
        { card: "8S", label: "8\u2660", playedBy: "pone", value: 8, countAfter: 8 },
        { card: "9D", label: "9\u2666", playedBy: "dealer", value: 9, countAfter: 17 }
      ],
      playerHand: [
        { id: "7H", r: 7, s: "H" },
        { id: "10C", r: 10, s: "C" },
        { id: "2S", r: 2, s: "S" }
      ],
      opponentKnown: 'Pone is out of legal plays (called "Go")',
      optimalCardId: "7H",
      solutions: {
        "7H": {
          correct: true,
          grade: "SOLVED",
          badge: "\u{1F31F} PERFECT RUN",
          explanation: "Masterful! Playing 7\u2665 brings the count to 24 (17 + 7) and completes the 3-card run 8-9-7 for 3 pegging points! Since Pone called Go, you can then also play your 2\u2660 to hit 26 and take the 1 pt Go for 4 total points, vaulting you straight from 117 to 121 for the instant win!"
        },
        "10C": {
          correct: false,
          grade: "SUBOPTIMAL",
          badge: "\u26A0\uFE0F MISSED WIN",
          explanation: "Playing 10\u2663 brings the count to 27 and scores 3 points for the run 8-9-10! However, with count at 27 you cannot also play your 2\u2660 (27+2=29), leaving you 1 point short of the 121 match target."
        },
        "2S": {
          correct: false,
          grade: "MISTAKE",
          badge: "\u274C BLUNDER",
          explanation: "Playing 2\u2660 brings the count to 19 without completing any run or sequence, scoring 0 points and failing to reach 121."
        }
      }
    },
    {
      id: "fifteen_lead_defense",
      title: "The Poison 5 Defense",
      subtitle: "Opening Play Strategy",
      description: "First hand of the match. You are Pone holding 5\u2660, 7\u2666, 8\u2663, K\u2665. You need to lead a card. Opponent is a sharp Shark AI. Which card is the statistically safest lead that minimizes opponent scoring opportunities?",
      playerScore: 0,
      opponentScore: 0,
      targetScore: 121,
      isDealer: false,
      currentCount: 0,
      countHistory: [],
      playerHand: [
        { id: "5S", r: 5, s: "S" },
        { id: "7D", r: 7, s: "D" },
        { id: "8C", r: 8, s: "C" },
        { id: "KH", r: 13, s: "H" }
      ],
      opponentKnown: "Dealer holds 4 unseen cards",
      optimalCardId: "7D",
      solutions: {
        "7D": {
          correct: true,
          grade: "SOLVED",
          badge: "\u{1F6E1}\uFE0F FLAWLESS DEFENSE",
          explanation: "Correct! Leading a 7 is mathematically standard defense. If opponent plays an 8 for 15-for-2, you can counter with your 8\u2663 or 7\u2666 to score a pair or run! Leading from a 7-8 connector retains strong offensive counters while avoiding 10-point immediate 15s."
        },
        "8C": {
          correct: false,
          grade: "SUBOPTIMAL",
          badge: "\u26A0\uFE0F RISKY PLAY",
          explanation: "Leading an 8 allows Dealer to play 7 for 15-2. While you can follow with 7\u2666, 7 is generally preferred as an opening lead over 8 because fewer cards hit exactly 15 off an 8 without setting up runs."
        },
        "5S": {
          correct: false,
          grade: "MISTAKE",
          badge: "\u274C GOLDEN RULE BROKEN",
          explanation: "Never lead a 5! With sixteen 10-value cards in a 52-card deck (nearly 1 in 3 cards), leading a 5 gives the dealer an easy 15-for-2 over 70% of the time."
        },
        "KH": {
          correct: false,
          grade: "MISTAKE",
          badge: "\u26A0\uFE0F SUBOPTIMAL",
          explanation: "Leading a King allows opponent to play a 5 for 15-for-2. Furthermore, leading face cards leaves you with fewer flexible responses on subsequent cards."
        }
      }
    },
    {
      id: "stinkhole_defense_120",
      title: "The Stink Hole Escape",
      subtitle: "Precision 1-Point Peg",
      description: "You are at 120 points (Stink Hole) as Dealer! Opponent is at 120. Game target is 121. The count is 29 after Opponent played a 9. What card do you play to score the single point needed to win the match right now?",
      playerScore: 120,
      opponentScore: 120,
      targetScore: 121,
      isDealer: true,
      currentCount: 29,
      countHistory: [
        { card: "10S", label: "10\u2660", playedBy: "pone", value: 10, countAfter: 10 },
        { card: "10D", label: "10\u2666", playedBy: "dealer", value: 10, countAfter: 20 },
        { card: "9C", label: "9\u2663", playedBy: "pone", value: 9, countAfter: 29 }
      ],
      playerHand: [
        { id: "2H", r: 2, s: "H" },
        { id: "AH", r: 1, s: "H" },
        { id: "6S", r: 6, s: "S" }
      ],
      opponentKnown: "Count is 29. Single point wins.",
      optimalCardId: "2H",
      solutions: {
        "2H": {
          correct: true,
          grade: "SOLVED",
          badge: "\u{1F3C6} 31 FOR THE WIN",
          explanation: "Perfection! 29 + 2 = exactly 31! Playing 2\u2665 hits 31 for 2 points, giving you the immediate winning peg from 120 to 121+ and ending the game on the spot!"
        },
        "AH": {
          correct: false,
          grade: "SUBOPTIMAL",
          badge: "\u26A0\uFE0F DANGEROUS MISS",
          explanation: "Playing A\u2665 brings the count to 30. If Opponent has an Ace remaining, they will play it for 31-for-2 and steal the match! Never leave count at 30 when you have the direct 31 play."
        },
        "6S": {
          correct: false,
          grade: "MISTAKE",
          badge: "\u274C ILLEGAL PLAY",
          explanation: "Playing 6\u2660 exceeds 31 (29 + 6 = 35) and is an illegal move."
        }
      }
    },
    {
      id: "pone_pair_counter",
      title: "The Bait and Trap",
      subtitle: "Tactical Pairing Trap",
      description: "You are Pone at 112 points, Dealer is at 114. You led 4\u2663. Dealer immediately paired your 4 with 4\u2666 (count 8, Dealer pegged 2). What do you play now?",
      playerScore: 112,
      opponentScore: 116,
      targetScore: 121,
      isDealer: false,
      currentCount: 8,
      countHistory: [
        { card: "4C", label: "4\u2663", playedBy: "pone", value: 4, countAfter: 4 },
        { card: "4D", label: "4\u2666", playedBy: "dealer", value: 4, countAfter: 8 }
      ],
      playerHand: [
        { id: "4S", r: 4, s: "S" },
        { id: "7H", r: 7, s: "H" },
        { id: "9C", r: 9, s: "C" }
      ],
      opponentKnown: "Dealer holds 3 unseen cards",
      optimalCardId: "4S",
      solutions: {
        "4S": {
          correct: true,
          grade: "SOLVED",
          badge: "\u26A1 TRIPLE 4 BOMB",
          explanation: "Boom! Playing your 4\u2660 makes three-of-a-kind (Pair Royal) for 6 pegging points! Count becomes 12. Dealer cannot 4-of-a-kind you because the fourth 4 is in the crib/deck. You vault 6 points ahead!"
        },
        "7H": {
          correct: false,
          grade: "SUBOPTIMAL",
          badge: "\u26A0\uFE0F MISSED 6 POINTS",
          explanation: "Playing 7\u2665 brings the count to 15 for 2 points, but forfeits the devastating 6-point Pair Royal with your 4\u2660."
        },
        "9C": {
          correct: false,
          grade: "MISTAKE",
          badge: "\u274C BLUNDER",
          explanation: "Playing 9\u2663 scores 0 points and wastes a huge scoring opportunity."
        }
      }
    }
  ];
  var DailyPuzzleManager = class _DailyPuzzleManager {
    /**
     * Generates a deterministic 32-bit integer hash from a date string (e.g. "2026-09-23").
     * @param {string} str
     * @returns {number}
     */
    static hashString(str) {
      let hash = 1779033703 ^ str.length;
      for (let i = 0; i < str.length; i++) {
        hash = Math.imul(hash ^ str.charCodeAt(i), 3432918353);
        hash = hash << 13 | hash >>> 19;
      }
      return hash >>> 0;
    }
    /**
     * Mulberry32 PRNG generator seeded with integer seed.
     * @param {number} a
     * @returns {function(): number} PRNG returning [0, 1)
     */
    static mulberry32(a) {
      return function() {
        let t = a += 1831565813;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
      };
    }
    /**
     * Gets calendar day key in YYYY-MM-DD format (local time).
     * @param {Date} [d=new Date()]
     * @returns {string}
     */
    static getDailyDateKey(d = /* @__PURE__ */ new Date()) {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    /**
     * Calculates Day # counter from anchor date.
     * @param {string} dateKey YYYY-MM-DD
     * @returns {number}
     */
    static getDayNumber(dateKey) {
      const target = /* @__PURE__ */ new Date(`${dateKey}T00:00:00Z`);
      const diffMs = target.getTime() - ANCHOR_DATE.getTime();
      const days = Math.floor(diffMs / (1e3 * 60 * 60 * 24)) + 1;
      return Math.max(1, days);
    }
    /**
     * Generates deterministic 6-card hand for the specified dateKey.
     * @param {string} [dateKey]
     * @returns {{ hand: Card[], isDealer: boolean, dayNumber: number, dateKey: string }}
     */
    static getDailyHand(dateKey = _DailyPuzzleManager.getDailyDateKey()) {
      const seed = _DailyPuzzleManager.hashString(`cribbage-daily-hand-${dateKey}`);
      const rng = _DailyPuzzleManager.mulberry32(seed);
      const deck = Deck2.makeDeck(1, false);
      for (let i = deck.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        const temp = deck[i];
        deck[i] = deck[j];
        deck[j] = temp;
      }
      const hand = deck.slice(0, 6);
      const dayNumber = _DailyPuzzleManager.getDayNumber(dateKey);
      const isDealer = dayNumber % 2 === 0;
      return { hand, isDealer, dayNumber, dateKey };
    }
    /**
     * Selects deterministic pegging puzzle scenario for the specified dateKey.
     * @param {string} [dateKey]
     * @returns {Object} Scenario definition with Card instances in playerHand
     */
    static getDailyPeggingScenario(dateKey = _DailyPuzzleManager.getDailyDateKey()) {
      const dayNumber = _DailyPuzzleManager.getDayNumber(dateKey);
      const index = (dayNumber - 1) % PEGGING_SCENARIOS.length;
      const baseScenario = PEGGING_SCENARIOS[index];
      const playerHand = baseScenario.playerHand.map((c) => new Card2({ r: c.r, s: c.s, id: c.id }));
      return {
        ...baseScenario,
        dayNumber,
        dateKey,
        playerHand
      };
    }
    /**
     * Evaluates player's chosen discards for the daily challenge.
     * @param {string[]} chosenCardIds Array of 2 card IDs e.g. ['5H', '6D']
     * @param {string} [dateKey]
     * @returns {Object} Evaluation report
     */
    static evaluateDailyDiscard(chosenCardIds, dateKey = _DailyPuzzleManager.getDailyDateKey()) {
      const { hand, isDealer, dayNumber } = _DailyPuzzleManager.getDailyHand(dateKey);
      const analysis = DiscardTrainer.analyzeHand(hand, isDealer);
      const chosenSet = new Set(chosenCardIds);
      const userCombos = analysis.combos.filter((c) => c.disc.every((card) => chosenSet.has(card.id)));
      if (!userCombos || userCombos.length === 0) {
        throw new Error("Selected cards do not form a valid 2-card discard from hand.");
      }
      const userCombo = userCombos[0];
      const optimalCombo = analysis.optimal;
      const diff = Number((optimalCombo.netEV - userCombo.netEV).toFixed(2));
      let grade = "optimal";
      let gradeLabel = "\u{1F31F} PERFECT OPTIMAL";
      if (diff > 0 && diff <= 0.5) {
        grade = "great";
        gradeLabel = "\u{1F7E2} EXCELLENT PLAY";
      } else if (diff > 0.5 && diff <= 1.5) {
        grade = "good";
        gradeLabel = "\u{1F7E1} GOOD CHOICE";
      } else if (diff > 1.5) {
        grade = "suboptimal";
        gradeLabel = "\u{1F534} SUBOPTIMAL";
      }
      return {
        dateKey,
        dayNumber,
        isDealer,
        userCombo,
        optimalCombo,
        diff,
        grade,
        gradeLabel,
        analysis
      };
    }
    /**
     * Evaluates player's pegging card selection for the daily pegging puzzle.
     * @param {string} chosenCardId e.g. '4S'
     * @param {string} [dateKey]
     * @returns {Object}
     */
    static evaluateDailyPegging(chosenCardId, dateKey = _DailyPuzzleManager.getDailyDateKey()) {
      const scenario = _DailyPuzzleManager.getDailyPeggingScenario(dateKey);
      const solution = scenario.solutions[chosenCardId];
      if (!solution) {
        throw new Error(`Invalid card selected for scenario: ${chosenCardId}`);
      }
      return {
        dateKey,
        dayNumber: scenario.dayNumber,
        chosenCardId,
        scenario,
        isCorrect: solution.correct,
        solution
      };
    }
    /**
     * Loads user's daily puzzle statistics and completion state from persistent storage.
     * @param {Object} [storage]
     * @returns {Object}
     */
    static loadStats(storage = typeof window !== "undefined" ? window.appStorage : null) {
      const defaultStats = {
        currentStreak: 0,
        bestStreak: 0,
        lastPlayedDate: "",
        history: {},
        // dateKey -> { discard: {...}, pegging: {...} }
        totalPlayed: 0,
        perfectDiscards: 0,
        peggingWins: 0
      };
      let loaded = null;
      if (storage) {
        try {
          const raw = storage.getItem("cc_daily_puzzle_stats");
          if (raw) loaded = JSON.parse(raw);
        } catch (e) {
        }
      }
      if (!loaded) {
        try {
          const profile = typeof window !== "undefined" && window.Profile && typeof window.Profile.getInstance === "function" ? window.Profile.getInstance(storage) : Profile ? Profile.getInstance(storage) : null;
          if (profile && typeof profile.getDailyPuzzleStats === "function") {
            const pStats = profile.getDailyPuzzleStats(storage);
            if (pStats && (pStats.totalPlayed > 0 || pStats.currentStreak > 0 || Object.keys(pStats.history || {}).length > 0)) {
              loaded = pStats;
            }
          }
        } catch (_) {
        }
      }
      if (!loaded && _DailyPuzzleManager._memoryStats) {
        loaded = _DailyPuzzleManager._memoryStats;
      }
      const merged = { ...defaultStats, ...loaded || {} };
      _DailyPuzzleManager._memoryStats = merged;
      return merged;
    }
    /**
     * Saves updated statistics to persistent storage and synchronizes into User Profile.
     * @param {Object} stats
     * @param {Object} [storage]
     */
    static saveStats(stats, storage = typeof window !== "undefined" ? window.appStorage : null) {
      _DailyPuzzleManager._memoryStats = { ...stats };
      if (storage) {
        try {
          storage.setItem("cc_daily_puzzle_stats", JSON.stringify(stats));
        } catch (e) {
          console.warn("[DailyPuzzleManager] Error saving stats:", e);
        }
      }
      try {
        const profile = typeof window !== "undefined" && window.Profile && typeof window.Profile.getInstance === "function" ? window.Profile.getInstance(storage) : Profile ? Profile.getInstance(storage) : null;
        if (profile && typeof profile.setDailyPuzzleStats === "function") {
          profile.setDailyPuzzleStats(stats, storage);
        }
      } catch (e) {
        console.warn("[DailyPuzzleManager] Error syncing stats to Profile:", e);
      }
    }
    /**
     * Resets daily puzzle statistics and streak history.
     * @param {Object} [storage]
     * @returns {Object} Reset default statistics
     */
    static resetStats(storage = typeof window !== "undefined" ? window.appStorage : null) {
      const defaultStats = {
        currentStreak: 0,
        bestStreak: 0,
        lastPlayedDate: "",
        history: {},
        totalPlayed: 0,
        perfectDiscards: 0,
        peggingWins: 0
      };
      _DailyPuzzleManager.saveStats(defaultStats, storage);
      try {
        const profile = typeof window !== "undefined" && window.Profile && typeof window.Profile.getInstance === "function" ? window.Profile.getInstance(storage) : Profile ? Profile.getInstance(storage) : null;
        if (profile && typeof profile.clearDailyPuzzleStats === "function") {
          profile.clearDailyPuzzleStats(storage);
        }
      } catch (_) {
      }
      return defaultStats;
    }
    /**
     * Records completion of either discard or pegging section.
     * Updates streaks if both daily challenges are finished for today.
     * @param {'discard'|'pegging'} section
     * @param {Object} result
     * @param {string} [dateKey]
     * @returns {Object} Updated stats
     */
    static recordCompletion(section, result, dateKey = _DailyPuzzleManager.getDailyDateKey(), options = {}) {
      const storage = options.storage || (typeof window !== "undefined" ? window.appStorage : null);
      const stats = _DailyPuzzleManager.loadStats(storage);
      if (!stats.history[dateKey]) {
        stats.history[dateKey] = {};
      }
      const todayEntry = stats.history[dateKey];
      todayEntry[section] = result;
      if (section === "discard" && result.grade === "optimal") {
        stats.perfectDiscards = (stats.perfectDiscards || 0) + 1;
        try {
          AchievementManager.incrementStat("dailyDiscardOptimal", 1, options);
        } catch (e) {
        }
      }
      if (section === "pegging" && result.isCorrect) {
        stats.peggingWins = (stats.peggingWins || 0) + 1;
        try {
          AchievementManager.incrementStat("dailyPeggingCorrect", 1, options);
        } catch (e) {
        }
      }
      if (todayEntry.discard && todayEntry.pegging && todayEntry.completed !== true) {
        todayEntry.completed = true;
        stats.totalPlayed = (stats.totalPlayed || 0) + 1;
        const lastDate = stats.lastPlayedDate;
        if (!lastDate) {
          stats.currentStreak = 1;
        } else {
          const yesterday = /* @__PURE__ */ new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          const yesterdayKey = _DailyPuzzleManager.getDailyDateKey(yesterday);
          if (lastDate === yesterdayKey) {
            stats.currentStreak = (stats.currentStreak || 0) + 1;
          } else if (lastDate === dateKey) {
          } else {
            stats.currentStreak = 1;
          }
        }
        stats.lastPlayedDate = dateKey;
        if (stats.currentStreak > (stats.bestStreak || 0)) {
          stats.bestStreak = stats.currentStreak;
        }
      }
      _DailyPuzzleManager.saveStats(stats, storage);
      try {
        AchievementManager.checkDailyStreaks(stats, options);
      } catch (e) {
      }
      return stats;
    }
    /**
     * Generates viral Wordle-style shareable text for clipboard.
     * @param {string} [dateKey]
     * @returns {string}
     */
    static generateShareText(dateKey = _DailyPuzzleManager.getDailyDateKey()) {
      const stats = _DailyPuzzleManager.loadStats();
      const dayNumber = _DailyPuzzleManager.getDayNumber(dateKey);
      const today = stats.history[dateKey] || {};
      let discardStr = "\u23F3 Not completed";
      if (today.discard) {
        const g = today.discard.grade;
        if (g === "optimal") discardStr = "\u{1F31F} PERFECT (0.00 loss)";
        else if (g === "great") discardStr = `\u{1F7E2} EXCELLENT (${today.discard.diff} loss)`;
        else if (g === "good") discardStr = `\u{1F7E1} GOOD (${today.discard.diff} loss)`;
        else discardStr = `\u{1F534} SUBOPTIMAL (${today.discard.diff} loss)`;
      }
      let peggingStr = "\u23F3 Not completed";
      if (today.pegging) {
        peggingStr = today.pegging.isCorrect ? "\u{1F3AF} SOLVED" : "\u274C FAILED";
      }
      const streak = stats.currentStreak || 1;
      return `Crazy Cribbage Daily #${dayNumber} \u{1F4C5}
\u{1F0CF} Discard: ${discardStr}
\u26A1 Pegging: ${peggingStr}
\u{1F525} Streak: ${streak} ${streak === 1 ? "Day" : "Days"}
Play Free: https://customcribboards.com/pages/crazy-cribbage`;
    }
    /**
     * Checks whether both daily puzzles have been completed for today.
     * @param {string} [dateKey]
     * @returns {boolean}
     */
    static isTodayCompleted(dateKey = _DailyPuzzleManager.getDailyDateKey()) {
      const stats = _DailyPuzzleManager.loadStats();
      const entry = stats.history[dateKey];
      return !!(entry && entry.completed);
    }
  };
  if (typeof window !== "undefined") {
    window.DailyPuzzleManager = DailyPuzzleManager;
  }

  // src/ui/TraditionalCard.js
  var TraditionalCard = class _TraditionalCard {
    /**
     * Normalizes any card representation into standard rank, suit, symbol, color, and flags.
     * @param {Object} c
     * @returns {{ rank: number, rankName: string, suit: string, suitSymbol: string, isRed: boolean, isJoker: boolean }}
     */
    static normalize(c) {
      if (!c) {
        return { rank: 1, rankName: "A", suit: "S", suitSymbol: "\u2660", isRed: false, isJoker: false };
      }
      const isJoker = Boolean(c.joker || c.isWild || c.wild || c.r === 0 || c.rank === 0) && !c.playAs;
      if (isJoker) {
        return { rank: 0, rankName: "\u2605", suit: "J", suitSymbol: "\u2605", isRed: false, isJoker: true };
      }
      let r = c.playAs ? c.playAs.r : c.rank !== void 0 ? c.rank : c.r !== void 0 ? c.r : 1;
      let rankNum = typeof r === "number" ? r : parseInt(r, 10);
      let rankName = String(c.rankName || RANK_NAME[r] || r || "A").toUpperCase();
      if (rankName === "1" || rankNum === 1) {
        rankName = "A";
        rankNum = 1;
      } else if (rankName === "11" || rankNum === 11) {
        rankName = "J";
        rankNum = 11;
      } else if (rankName === "12" || rankNum === 12) {
        rankName = "Q";
        rankNum = 12;
      } else if (rankName === "13" || rankNum === 13) {
        rankName = "K";
        rankNum = 13;
      } else if (isNaN(rankNum)) {
        if (rankName === "A") rankNum = 1;
        else if (rankName === "J") rankNum = 11;
        else if (rankName === "Q") rankNum = 12;
        else if (rankName === "K") rankNum = 13;
        else rankNum = parseInt(rankName, 10) || 5;
      }
      let s = String(c.playAs ? c.playAs.s : c.suit || c.s || "S").toUpperCase();
      let suit = "S";
      let suitSymbol = "\u2660";
      if (s === "H" || s.startsWith("HEART") || s === "\u2665") {
        suit = "H";
        suitSymbol = "\u2665";
      } else if (s === "D" || s.startsWith("DIAMOND") || s === "\u2666") {
        suit = "D";
        suitSymbol = "\u2666";
      } else if (s === "C" || s.startsWith("CLUB") || s === "\u2663") {
        suit = "C";
        suitSymbol = "\u2663";
      } else if (s === "S" || s.startsWith("SPADE") || s === "\u2660") {
        suit = "S";
        suitSymbol = "\u2660";
      } else if (SUIT_SYM[s]) {
        suit = s;
        suitSymbol = SUIT_SYM[s];
      }
      const isRed = cardOrSuitIsRed(c, suit);
      return { rank: rankNum, rankName, suit, suitSymbol, isRed, isJoker: false };
    }
    /**
     * Returns traditional grid layout matrix coordinates for spot cards (2 through 10).
     * Maps onto a 3-column, 5-row CSS grid.
     * @param {string} rankName
     * @returns {Array<{ col: number, row: number, inv: boolean }>}
     */
    static getPipLayout(rankName) {
      switch (rankName) {
        case "2":
          return [
            { col: 2, row: 1, inv: false },
            { col: 2, row: 5, inv: true }
          ];
        case "3":
          return [
            { col: 2, row: 1, inv: false },
            { col: 2, row: 3, inv: false },
            { col: 2, row: 5, inv: true }
          ];
        case "4":
          return [
            { col: 1, row: 1, inv: false },
            { col: 3, row: 1, inv: false },
            { col: 1, row: 5, inv: true },
            { col: 3, row: 5, inv: true }
          ];
        case "5":
          return [
            { col: 1, row: 1, inv: false },
            { col: 3, row: 1, inv: false },
            { col: 2, row: 3, inv: false },
            { col: 1, row: 5, inv: true },
            { col: 3, row: 5, inv: true }
          ];
        case "6":
          return [
            { col: 1, row: 1, inv: false },
            { col: 3, row: 1, inv: false },
            { col: 1, row: 3, inv: false },
            { col: 3, row: 3, inv: false },
            { col: 1, row: 5, inv: true },
            { col: 3, row: 5, inv: true }
          ];
        case "7":
          return [
            { col: 1, row: 1, inv: false },
            { col: 3, row: 1, inv: false },
            { col: 2, row: 2, inv: false },
            { col: 1, row: 3, inv: false },
            { col: 3, row: 3, inv: false },
            { col: 1, row: 5, inv: true },
            { col: 3, row: 5, inv: true }
          ];
        case "8":
          return [
            { col: 1, row: 1, inv: false },
            { col: 3, row: 1, inv: false },
            { col: 2, row: 2, inv: false },
            { col: 1, row: 3, inv: false },
            { col: 3, row: 3, inv: false },
            { col: 2, row: 4, inv: true },
            { col: 1, row: 5, inv: true },
            { col: 3, row: 5, inv: true }
          ];
        case "9":
          return [
            { col: 1, row: 1, inv: false },
            { col: 3, row: 1, inv: false },
            { col: 1, row: 2, inv: false },
            { col: 3, row: 2, inv: false },
            { col: 2, row: 3, inv: false },
            { col: 1, row: 4, inv: true },
            { col: 3, row: 4, inv: true },
            { col: 1, row: 5, inv: true },
            { col: 3, row: 5, inv: true }
          ];
        case "10":
          return [
            { col: 1, row: 1, inv: false },
            { col: 3, row: 1, inv: false },
            { col: 2, row: 2, inv: false },
            { col: 1, row: 2, inv: false },
            { col: 3, row: 2, inv: false },
            { col: 1, row: 4, inv: true },
            { col: 3, row: 4, inv: true },
            { col: 2, row: 4, inv: true },
            { col: 1, row: 5, inv: true },
            { col: 3, row: 5, inv: true }
          ];
        default:
          return [
            { col: 2, row: 3, inv: false }
          ];
      }
    }
    /**
     * Returns normalized canvas position offsets [xRatio, yRatio, isInverted]
     * for drawing pips on a 2D HTML5 canvas.
     * @param {string} rankName
     * @returns {Array<[number, number, boolean]>}
     */
    static getPipCanvasOffsets(rankName) {
      switch (rankName) {
        case "2":
          return [
            [0.5, 0.16, false],
            [0.5, 0.84, true]
          ];
        case "3":
          return [
            [0.5, 0.16, false],
            [0.5, 0.5, false],
            [0.5, 0.84, true]
          ];
        case "4":
          return [
            [0.26, 0.16, false],
            [0.74, 0.16, false],
            [0.26, 0.84, true],
            [0.74, 0.84, true]
          ];
        case "5":
          return [
            [0.26, 0.16, false],
            [0.74, 0.16, false],
            [0.5, 0.5, false],
            [0.26, 0.84, true],
            [0.74, 0.84, true]
          ];
        case "6":
          return [
            [0.26, 0.16, false],
            [0.74, 0.16, false],
            [0.26, 0.5, false],
            [0.74, 0.5, false],
            [0.26, 0.84, true],
            [0.74, 0.84, true]
          ];
        case "7":
          return [
            [0.26, 0.16, false],
            [0.74, 0.16, false],
            [0.5, 0.33, false],
            [0.26, 0.5, false],
            [0.74, 0.5, false],
            [0.26, 0.84, true],
            [0.74, 0.84, true]
          ];
        case "8":
          return [
            [0.26, 0.16, false],
            [0.74, 0.16, false],
            [0.5, 0.33, false],
            [0.26, 0.5, false],
            [0.74, 0.5, false],
            [0.5, 0.67, true],
            [0.26, 0.84, true],
            [0.74, 0.84, true]
          ];
        case "9":
          return [
            [0.26, 0.16, false],
            [0.74, 0.16, false],
            [0.26, 0.38, false],
            [0.74, 0.38, false],
            [0.5, 0.5, false],
            [0.26, 0.62, true],
            [0.74, 0.62, true],
            [0.26, 0.84, true],
            [0.74, 0.84, true]
          ];
        case "10":
          return [
            [0.26, 0.16, false],
            [0.74, 0.16, false],
            [0.5, 0.28, false],
            [0.26, 0.38, false],
            [0.74, 0.38, false],
            [0.26, 0.62, true],
            [0.74, 0.62, true],
            [0.5, 0.72, true],
            [0.26, 0.84, true],
            [0.74, 0.84, true]
          ];
        default:
          return [
            [0.5, 0.5, false]
          ];
      }
    }
    /**
     * Renders the authentic traditional playing card face HTML markup.
     * Generates corner indices, central pip grid for 2..10, Ace emblem, or Court card crest.
     * @param {Object} c - Card object or instance
     * @param {Object} [opts={}]
     * @returns {string} HTML markup string
     */
    static renderHtml(c, opts = {}) {
      const card = _TraditionalCard.normalize(c);
      const color = card.isJoker ? "#9333ea" : card.isRed ? "#dc2626" : "#111827";
      const isCut = Boolean(opts.isCut);
      if (card.isJoker) {
        return `
        <div class="trad-card trad-joker" style="color:${color};">
          ${isCut ? '<span class="trad-cut-badge">CUT</span>' : ""}
          <div class="trad-corner top-left">
            <span class="trad-rank">\u2605</span>
            <span class="trad-suit">\u2605</span>
          </div>
          <div class="trad-center-art">
            <div class="trad-art-joker">
              <div class="trad-joker-icon">\u{1F0CF}</div>
              <div class="trad-joker-title">JOKER</div>
            </div>
          </div>
          <div class="trad-corner bottom-right">
            <span class="trad-rank">\u2605</span>
            <span class="trad-suit">\u2605</span>
          </div>
        </div>
      `;
      }
      const { rankName, suitSymbol } = card;
      let centerArt = "";
      if (rankName === "A") {
        centerArt = `
        <div class="trad-art-ace">
          <span class="trad-ace-symbol">${suitSymbol}</span>
        </div>
      `;
      } else if (["K", "Q", "J"].includes(rankName)) {
        const courtTitle = rankName === "K" ? "KING" : rankName === "Q" ? "QUEEN" : "JACK";
        const courtCrown = rankName === "K" ? "\u{1F451}" : rankName === "Q" ? "\u2655" : "\u{1F6E1}\uFE0F";
        centerArt = `
        <div class="trad-art-court court-${rankName.toLowerCase()}">
          <div class="trad-court-crown">${courtCrown}</div>
          <div class="trad-court-title">${courtTitle}</div>
          <div class="trad-court-suit">${suitSymbol}</div>
        </div>
      `;
      } else {
        const pips = _TraditionalCard.getPipLayout(rankName);
        const pipsHtml = pips.map((p) => {
          const invClass = p.inv ? " is-inverted" : "";
          return `<span class="trad-pip col-${p.col} row-${p.row}${invClass}" style="grid-column:${p.col}; grid-row:${p.row};">${suitSymbol}</span>`;
        }).join("");
        centerArt = `
        <div class="trad-art-pips pips-${rankName}">
          ${pipsHtml}
        </div>
      `;
      }
      return `
      <div class="trad-card trad-${card.isRed ? "red" : "black"}" style="color:${color};">
        ${isCut ? '<span class="trad-cut-badge">CUT</span>' : ""}
        <div class="trad-corner top-left">
          <span class="trad-rank">${rankName}</span>
          <span class="trad-suit">${suitSymbol}</span>
        </div>
        <div class="trad-center-art">
          ${centerArt}
        </div>
        <div class="trad-corner bottom-right">
          <span class="trad-rank">${rankName}</span>
          <span class="trad-suit">${suitSymbol}</span>
        </div>
      </div>
    `;
    }
    /**
     * Draws an authentic traditional playing card onto a 2D Canvas context.
     * Used for social image generation, downloads, and clipboard copies.
     * @param {CanvasRenderingContext2D} ctx
     * @param {Object} c
     * @param {number} x
     * @param {number} y
     * @param {number} w
     * @param {number} h
     * @param {Object} [opts={}]
     */
    static drawToCanvas(ctx, c, x, y, w, h, opts = {}) {
      if (!ctx) return;
      const card = _TraditionalCard.normalize(c);
      const isCut = Boolean(opts.isCut || opts.isStarter);
      const color = card.isJoker ? "#9333ea" : card.isRed ? "#dc2626" : "#000000";
      ctx.save();
      ctx.shadowBlur = 0;
      ctx.shadowColor = "transparent";
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.fillStyle = "#ffffff";
      ctx.beginPath();
      if (typeof ctx.roundRect === "function") {
        ctx.roundRect(x, y, w, h, 8);
      } else {
        ctx.rect(x, y, w, h);
      }
      ctx.fill();
      ctx.strokeStyle = isCut ? "#f59e0b" : "rgba(0, 0, 0, 0.22)";
      ctx.lineWidth = isCut ? 3.5 : 1.5;
      ctx.stroke();
      if (isCut) {
        ctx.fillStyle = "#f59e0b";
        ctx.beginPath();
        const badgeW = Math.min(48, w - 24);
        if (typeof ctx.roundRect === "function") {
          ctx.roundRect(x + (w - badgeW) / 2, y - 9, badgeW, 18, 9);
        } else {
          ctx.rect(x + (w - badgeW) / 2, y - 9, badgeW, 18);
        }
        ctx.fill();
        ctx.fillStyle = "#1e1b18";
        ctx.font = '900 10px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("CUT", x + w / 2, y);
      }
      const cornerPadX = 8;
      const cornerTopY = 20;
      const cornerRankFont = '800 18px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      const cornerSuitFont = '16px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      ctx.fillStyle = color;
      ctx.textAlign = "left";
      ctx.textBaseline = "alphabetic";
      ctx.font = cornerRankFont;
      ctx.fillText(card.rankName, x + cornerPadX, y + cornerTopY);
      ctx.font = cornerSuitFont;
      ctx.fillText(card.suitSymbol, x + cornerPadX, y + cornerTopY + 16);
      if (typeof ctx.translate === "function" && typeof ctx.rotate === "function") {
        ctx.save();
        ctx.translate(x + w - cornerPadX, y + h - 8);
        ctx.rotate(Math.PI);
        ctx.fillStyle = color;
        ctx.textAlign = "left";
        ctx.textBaseline = "alphabetic";
        ctx.font = cornerRankFont;
        ctx.fillText(card.rankName, 0, 16);
        ctx.font = cornerSuitFont;
        ctx.fillText(card.suitSymbol, 0, 0);
        ctx.restore();
      } else {
        ctx.fillStyle = color;
        ctx.textAlign = "right";
        ctx.textBaseline = "alphabetic";
        ctx.font = cornerRankFont;
        ctx.fillText(card.rankName, x + w - cornerPadX, y + h - 24);
        ctx.font = cornerSuitFont;
        ctx.fillText(card.suitSymbol, x + w - cornerPadX, y + h - 8);
      }
      const cx = x + w / 2;
      const cy = y + h / 2;
      if (card.isJoker) {
        ctx.fillStyle = color;
        ctx.font = '40px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("\u{1F0CF}", cx, cy - 4);
        ctx.font = 'bold 12px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillText("JOKER", cx, cy + 28);
      } else if (card.rankName === "A") {
        ctx.fillStyle = color;
        ctx.font = `${Math.round(h * 0.42)}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(card.suitSymbol, cx, cy + 4);
      } else if (["K", "Q", "J"].includes(card.rankName)) {
        const courtW = w - 30;
        const courtH = h - 48;
        const courtX = x + 15;
        const courtY = y + 24;
        ctx.save();
        ctx.strokeStyle = "#d4af37";
        ctx.lineWidth = 1.8;
        ctx.strokeRect(courtX, courtY, courtW, courtH);
        ctx.fillStyle = "rgba(254, 249, 235, 0.45)";
        ctx.fillRect(courtX + 1, courtY + 1, courtW - 2, courtH - 2);
        const title = card.rankName === "K" ? "KING" : card.rankName === "Q" ? "QUEEN" : "JACK";
        const crown = card.rankName === "K" ? "\u{1F451}" : card.rankName === "Q" ? "\u2655" : "\u{1F6E1}\uFE0F";
        ctx.fillStyle = "#b45309";
        ctx.font = '16px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(crown, cx, courtY + 16);
        ctx.fillStyle = color;
        ctx.font = `${Math.round(h * 0.24)}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;
        ctx.fillText(card.suitSymbol, cx, cy + 2);
        ctx.fillStyle = "#78350f";
        ctx.font = 'bold 10px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.fillText(title, cx, courtY + courtH - 12);
        ctx.restore();
      } else {
        const innerX = x + 16;
        const innerY = y + 16;
        const innerW = w - 32;
        const innerH = h - 32;
        const pipOffsets = _TraditionalCard.getPipCanvasOffsets(card.rankName);
        const pipFontSize = Math.round(w * 0.22);
        ctx.font = `${pipFontSize}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;
        ctx.fillStyle = color;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        pipOffsets.forEach(([fx, fy, inv]) => {
          const px = innerX + innerW * fx;
          const py = innerY + innerH * fy;
          if (inv && typeof ctx.translate === "function" && typeof ctx.rotate === "function") {
            ctx.save();
            ctx.translate(px, py);
            ctx.rotate(Math.PI);
            ctx.fillText(card.suitSymbol, 0, 0);
            ctx.restore();
          } else {
            ctx.fillText(card.suitSymbol, px, py);
          }
        });
      }
      ctx.restore();
    }
  };
  function cardOrSuitIsRed(c, suit) {
    if (c && typeof c.isRed === "boolean") return c.isRed;
    return suit === "H" || suit === "D";
  }

  // src/ui/HandOfGloryCard.js
  var HandOfGloryCard = class _HandOfGloryCard {
    /**
     * Normalizes arbitrary brand strings to 'crazy', 'clash', 'pints', or 'adult'.
     * @param {string} brand
     * @returns {string}
     */
    static normalizeBrand(brand) {
      if (!brand) return "crazy";
      const s = String(brand).toLowerCase().trim();
      if (s === "clash" || s === "cribbage-clash" || s.includes("clash")) return "clash";
      if (s === "pints" || s === "pints-and-pegs" || s === "cribbage-pints" || s.includes("pints")) return "pints";
      if (s === "adult" || s === "stripped" || s === "skunked-and-stripped" || s.includes("stripped") || s.includes("adult") || s.includes("skunked")) return "adult";
      return "crazy";
    }
    /**
     * Resolves full branding metadata (titles, canonical URLs, display URLs, slugs) for a game brand.
     * @param {string} [brandKey='crazy']
     * @returns {{ id: string, name: string, brandTitle: string, slug: string, path: string, url: string, displayUrl: string }}
     */
    static getBrandInfo(brandKey = "crazy") {
      const brand = _HandOfGloryCard.normalizeBrand(brandKey);
      const map = {
        crazy: {
          id: "crazy",
          name: "Crazy Cribbage",
          brandTitle: "CRAZY CRIBBAGE",
          slug: "game-crazy-cribbage",
          path: "/pages/game-crazy-cribbage",
          url: "https://customcribboards.com/pages/game-crazy-cribbage",
          displayUrl: "customcribboards.com/pages/game-crazy-cribbage"
        },
        clash: {
          id: "clash",
          name: "Cribbage Clash",
          brandTitle: "CRIBBAGE CLASH",
          slug: "game-cribbage-clash",
          path: "/pages/game-cribbage-clash",
          url: "https://customcribboards.com/pages/game-cribbage-clash",
          displayUrl: "customcribboards.com/pages/game-cribbage-clash"
        },
        pints: {
          id: "pints",
          name: "Pints & Pegs",
          brandTitle: "PINTS AND PEGS",
          slug: "game-pints-and-pegs",
          path: "/pages/game-pints-and-pegs",
          url: "https://customcribboards.com/pages/game-pints-and-pegs",
          displayUrl: "customcribboards.com/pages/game-pints-and-pegs"
        },
        adult: {
          id: "adult",
          name: "Skunked & Stripped",
          brandTitle: "SKUNKED AND STRIPPED",
          slug: "game-skunked-and-stripped",
          path: "/pages/game-skunked-and-stripped",
          url: "https://customcribboards.com/pages/game-skunked-and-stripped",
          displayUrl: "customcribboards.com/pages/game-skunked-and-stripped"
        }
      };
      return map[brand] || map.crazy;
    }
    /**
     * Detects the active game brand from context, settings, global state, DOM attributes, or URL.
     * @param {Object} [context={}]
     * @returns {string}
     */
    static detectBrand(context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null) || {};
      if (context.brand) return _HandOfGloryCard.normalizeBrand(context.brand);
      if (context.currentBrand) return _HandOfGloryCard.normalizeBrand(context.currentBrand);
      if (context.hand && context.hand.brand) return _HandOfGloryCard.normalizeBrand(context.hand.brand);
      if (settings3.brand) return _HandOfGloryCard.normalizeBrand(settings3.brand);
      if (state3.brand) return _HandOfGloryCard.normalizeBrand(state3.brand);
      if (typeof window !== "undefined") {
        if (window.currentBrand) return _HandOfGloryCard.normalizeBrand(window.currentBrand);
        if (window.currentLogoBrand) return _HandOfGloryCard.normalizeBrand(window.currentLogoBrand);
        if (typeof window.detectBrand === "function") {
          try {
            const b = window.detectBrand();
            if (b) return _HandOfGloryCard.normalizeBrand(b);
          } catch (e) {
          }
        }
      }
      if (typeof document !== "undefined" && document.documentElement) {
        const b = document.documentElement.getAttribute("data-brand");
        if (b) return _HandOfGloryCard.normalizeBrand(b);
      }
      if (typeof window !== "undefined" && window.location) {
        try {
          const params = new URLSearchParams(window.location.search);
          const p = (params.get("brand") || params.get("game") || params.get("logo") || "").toLowerCase();
          if (p) return _HandOfGloryCard.normalizeBrand(p);
          const href = (window.location.href || "").toLowerCase();
          if (href.includes("game-cribbage-clash") || href.includes("cribbage-clash") || href.includes("clash")) return "clash";
          if (href.includes("game-pints-and-pegs") || href.includes("pints-and-pegs") || href.includes("pints")) return "pints";
          if (href.includes("game-skunked-and-stripped") || href.includes("skunked-and-stripped") || href.includes("adult") || href.includes("stripped")) return "adult";
          if (href.includes("game-crazy-cribbage") || href.includes("crazy-cribbage") || href.includes("crazy")) return "crazy";
        } catch (e) {
        }
      }
      return "crazy";
    }
    /**
     * Normalizes hand data from state, lastShow, or raw object.
     * @param {string|Object} keyOrData
     * @param {Object} [context={}]
     * @returns {Object|null}
     */
    static extractHandData(keyOrData, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null) || {};
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
      const pName2 = context.pName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : ((w) => w === "you" ? "You" : w === "cpu" ? "Computer" : w));
      let h = null;
      if (typeof keyOrData === "string") {
        const ls = state3.lastShow || {};
        h = ls[keyOrData] || null;
        if (!h) {
          for (const k of Object.keys(ls)) {
            if (ls[k] && (ls[k].who === keyOrData || ls[k].seat === keyOrData || ls[k].id === keyOrData)) {
              h = ls[k];
              break;
            }
          }
        }
        if (keyOrData === "best") {
          if (state3.bestMatchHand) {
            h = state3.bestMatchHand;
          } else if (typeof window !== "undefined" && window.state && window.state.bestMatchHand) {
            h = window.state.bestMatchHand;
          }
        }
      } else if (keyOrData && typeof keyOrData === "object") {
        h = keyOrData;
      }
      if (!h) {
        const ls = state3.lastShow || {};
        h = ls.pone || ls.dealer || ls.crib || ls.p1 || ls.p2 || (Object.values(ls)[0] || null);
      }
      if (!h) return null;
      const isCrib = !!(h.isCrib || typeof keyOrData === "string" && keyOrData === "crib");
      const cards = (h.cards || []).map((c) => ({
        r: c.r || c.rank || "",
        s: c.s || c.suit || "",
        joker: !!(c.joker || c.isJoker)
      }));
      const startersList = h.starters && h.starters.length ? h.starters : state3.starters && state3.starters.length ? state3.starters : [];
      const starter = h.starter ? {
        r: h.starter.r || h.starter.rank || "",
        s: h.starter.s || h.starter.suit || "",
        joker: !!(h.starter.joker || h.starter.isJoker)
      } : startersList.length ? {
        r: startersList[0].r || startersList[0].rank || "",
        s: startersList[0].s || startersList[0].suit || "",
        joker: !!(startersList[0].joker || startersList[0].isJoker)
      } : state3.starter ? {
        r: state3.starter.r || state3.starter.rank || "",
        s: state3.starter.s || state3.starter.suit || "",
        joker: !!(state3.starter.joker || state3.starter.isJoker)
      } : null;
      const scoreTotal = typeof h.signed === "number" ? h.signed : h.score && typeof h.score.total === "number" ? h.score.total : h.points || 0;
      let lines = h.score && h.score.lines || h.lines || [];
      let notes = h.score && h.score.notes || h.notes || [];
      if ((!lines || lines.length === 0) && cards.length > 0) {
        try {
          if (typeof CribbageScorer !== "undefined" && CribbageScorer.scoreHand) {
            const reScored = CribbageScorer.scoreHand(cards, starter, isCrib, settings3);
            if (reScored && reScored.lines && reScored.lines.length) {
              lines = reScored.lines;
              notes = reScored.notes || notes;
            }
          }
        } catch (e) {
        }
      }
      const ownerName = h.title || pName2(h.who || "you");
      const brand = _HandOfGloryCard.detectBrand({ ...context, keyOrData, hand: h, settings: settings3, state: state3 });
      const brandInfo = _HandOfGloryCard.getBrandInfo(brand);
      let titleTag = "HAND OF GLORY";
      if (scoreTotal === 29) titleTag = "THE HOLY GRAIL";
      else if (scoreTotal === 28) titleTag = "TWENTY-EIGHT";
      else if (scoreTotal >= 50) titleTag = "CRAZY CENTURY";
      else if (scoreTotal >= 30) titleTag = "MONSTER HAND";
      else if (scoreTotal < 20) titleTag = "HAND BREAKDOWN";
      return {
        brand: brandInfo.id,
        brandName: brandInfo.name,
        brandTitle: brandInfo.brandTitle,
        brandUrl: brandInfo.url,
        brandDisplayUrl: brandInfo.displayUrl,
        brandSlug: brandInfo.slug,
        score: scoreTotal,
        titleTag,
        ownerName,
        isCrib,
        cards,
        starter,
        lines,
        notes,
        date: (/* @__PURE__ */ new Date()).toLocaleDateString(void 0, { month: "short", day: "numeric", year: "numeric" })
      };
    }
    /**
     * Checks whether a scoring line represents a Crazy Cribbage bonus or specialty rule.
     * @param {Object} l
     * @returns {boolean}
     */
    static isBonusLine(l) {
      if (!l) return false;
      if (l.isBonus) return true;
      const w = String(l.why || "").toLowerCase();
      return /all diff|diff.*suit|different suit|all red|all black|all odd|all even|flush in play|suicide|queen of spades|ace of spades|full house|straight flush|straight|royal flush|nineteen|thirty-one|31 for 5|19 for 2|bonus|zero hand|zero crib|rock crib/i.test(w);
    }
    /**
     * Helper to format a card label string (e.g. 5♥, J♦, Joker).
     * @param {Object} c
     * @returns {string}
     */
    static formatCardText(c) {
      if (!c) return "";
      if (c.joker) return "\u2605 Joker";
      const r = c.r || "";
      const rankNames = { 1: "A", 11: "J", 12: "Q", 13: "K" };
      const rName = rankNames[r] || r;
      const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      return `${rName}${suitSyms[c.s] || c.s || ""}`;
    }
    /**
     * Builds the HTML preview for the Hand of Glory card inside the modal.
     * @param {Object} data
     * @returns {string}
     */
    static buildCardHtml(data) {
      const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
      const displayUrl = data?.brandDisplayUrl || brandInfo.displayUrl;
      const brandTitle = data?.brandTitle || brandInfo.brandTitle;
      const isRedSuit = (s) => {
        const str = String(s || "").toUpperCase();
        return str === "H" || str === "D" || str.startsWith("HEART") || str.startsWith("DIAMOND");
      };
      const getSuitSym = (s) => {
        const str = String(s || "").toUpperCase();
        if (str === "H" || str.startsWith("HEART")) return "\u2665";
        if (str === "D" || str.startsWith("DIAMOND")) return "\u2666";
        if (str === "S" || str.startsWith("SPADE")) return "\u2660";
        if (str === "C" || str.startsWith("CLUB")) return "\u2663";
        return str;
      };
      const rankNames = { 1: "A", 11: "J", 12: "Q", 13: "K" };
      const renderCard = (c, isCut = false) => {
        if (!c) return "";
        const red = isRedSuit(c.s);
        const colorClass = red ? "card-red" : "card-black";
        return `
        <div class="glory-card-box ${colorClass} ${isCut ? "glory-cut-card" : ""}" style="border: 2px solid ${isCut ? "#f59e0b" : "rgba(0,0,0,0.18)"}; background: #ffffff !important; position: relative;">
          ${TraditionalCard.renderHtml(c, { isCut })}
        </div>
      `;
      };
      const cardsHtml = data.cards.map((c) => renderCard(c, false)).join("");
      const starterHtml = data.starter ? renderCard(data.starter, true) : "";
      const linesHtml = (data.lines || []).map((l) => {
        const isBonus = _HandOfGloryCard.isBonusLine(l);
        const sign = l.n > 0 ? `+${l.n}` : `${l.n}`;
        const bonusClass = isBonus ? " glory-pill-bonus" : "";
        const bonusBadge = isBonus ? '<span class="glory-bonus-badge">\u2605 BONUS</span> ' : "";
        return `<span class="glory-pill${bonusClass}"><strong>${sign}</strong> ${bonusBadge}${l.why}</span>`;
      }).join("");
      return `
      <div class="glory-card-outer" id="gloryCardOuter">
        <div class="glory-card-inner">
          <div class="glory-card-header">
            <div class="glory-brand-badge">${brandTitle}</div>
            <div class="glory-hand-title">${data.ownerName} \xB7 ${data.isCrib ? "Crib" : "Hand"}</div>
          </div>

          <div class="glory-score-wrap">
            <div class="glory-score-value">${data.score}</div>
            <div class="glory-score-label">POINTS</div>
            <div class="glory-tag-badge">${data.titleTag}</div>
          </div>

          <div class="glory-cards-row">
            ${cardsHtml}
            ${starterHtml ? `<div class="glory-starter-divider"></div>${starterHtml}` : ""}
          </div>

          ${linesHtml ? `<div class="glory-pills-row">${linesHtml}</div>` : ""}

          <div class="glory-card-footer">
            <span class="glory-url">${displayUrl}</span>
            <span class="glory-date">${data.date}</span>
          </div>
        </div>
      </div>
    `;
    }
    /**
     * Renders the hand of glory card onto a crisp 1200x675 HTML5 Canvas for image generation.
     * @param {Object} data
     * @returns {HTMLCanvasElement}
     */
    static renderToCanvas(data) {
      const W = 1200;
      const H = 675;
      const canvas = document.createElement("canvas");
      canvas.width = W;
      canvas.height = H;
      const ctx = canvas.getContext("2d");
      if (!ctx) return canvas;
      const bgGrad = ctx.createRadialGradient(W / 2, H / 2, 80, W / 2, H / 2, 700);
      bgGrad.addColorStop(0, "#1c150c");
      bgGrad.addColorStop(0.55, "#120d07");
      bgGrad.addColorStop(1, "#080503");
      ctx.fillStyle = bgGrad;
      ctx.fillRect(0, 0, W, H);
      ctx.save();
      ctx.globalAlpha = 0.035;
      ctx.strokeStyle = "#ffffff";
      ctx.lineWidth = 1;
      for (let y = 0; y < H; y += 7) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.bezierCurveTo(W * 0.35, y + 4, W * 0.65, y - 4, W, y);
        ctx.stroke();
      }
      ctx.restore();
      ctx.save();
      ctx.strokeStyle = "#f0c64a";
      ctx.lineWidth = 4;
      ctx.strokeRect(28, 28, W - 56, H - 56);
      ctx.strokeStyle = "rgba(240, 198, 74, 0.4)";
      ctx.lineWidth = 1.5;
      ctx.strokeRect(36, 36, W - 72, H - 72);
      const drawDiamond = (cx, cy, s) => {
        ctx.fillStyle = "#f0c64a";
        ctx.beginPath();
        ctx.moveTo(cx, cy - s);
        ctx.lineTo(cx + s, cy);
        ctx.lineTo(cx, cy + s);
        ctx.lineTo(cx - s, cy);
        ctx.closePath();
        ctx.fill();
      };
      drawDiamond(36, 36, 6);
      drawDiamond(W - 36, 36, 6);
      drawDiamond(36, H - 36, 6);
      drawDiamond(W - 36, H - 36, 6);
      ctx.restore();
      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "top";
      ctx.font = '800 24px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      ctx.fillStyle = "#f0c64a";
      ctx.fillText(data.brandTitle.toUpperCase() + " \xB7 HAND OF GLORY", W / 2, 54);
      ctx.font = '600 20px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      ctx.fillStyle = "#d6d3d1";
      ctx.fillText(`${data.ownerName} \xB7 ${data.isCrib ? "Crib" : "Hand"}`, W / 2, 88);
      ctx.restore();
      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = '900 86px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      ctx.fillStyle = "#f0c64a";
      ctx.shadowColor = "rgba(240, 198, 74, 0.6)";
      ctx.shadowBlur = 18;
      ctx.fillText(String(data.score), W / 2, 168);
      ctx.shadowBlur = 0;
      ctx.shadowColor = "transparent";
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.font = '800 20px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      ctx.fillStyle = "#fbbf24";
      ctx.fillText("POINTS", W / 2, 222);
      const badgeText = `\u2605  ${data.titleTag}  \u2605`;
      ctx.font = '700 15px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      const tagW = ctx.measureText(badgeText).width + 36;
      ctx.fillStyle = "rgba(240, 198, 74, 0.15)";
      ctx.strokeStyle = "#f0c64a";
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.roundRect((W - tagW) / 2, 240, tagW, 28, 14);
      ctx.fill();
      ctx.stroke();
      ctx.fillStyle = "#fef08a";
      ctx.fillText(badgeText, W / 2, 254);
      ctx.restore();
      const allCards = [...data.cards];
      if (data.starter) allCards.push({ ...data.starter, isStarter: true });
      const totalCards = allCards.length;
      const cardW = 108;
      const cardH = 152;
      const gap = 16;
      const dividerGap = data.starter ? 28 : 0;
      const rowW = totalCards * cardW + (totalCards - 1) * gap + dividerGap;
      let startX = (W - rowW) / 2;
      const cardY = 300;
      const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const rankNames = { 1: "A", 11: "J", 12: "Q", 13: "K" };
      allCards.forEach((c) => {
        if (c.isStarter) startX += dividerGap;
        ctx.save();
        ctx.shadowColor = "rgba(0, 0, 0, 0.65)";
        ctx.shadowBlur = 14;
        ctx.shadowOffsetY = 6;
        ctx.fillStyle = "#ffffff";
        ctx.beginPath();
        ctx.roundRect(startX, cardY, cardW, cardH, 10);
        ctx.fill();
        ctx.shadowBlur = 0;
        ctx.shadowColor = "transparent";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        if (c.isStarter) {
          ctx.strokeStyle = "#f59e0b";
          ctx.lineWidth = 3.5;
        } else if (c.joker) {
          ctx.strokeStyle = "#9333ea";
          ctx.lineWidth = 2.5;
        } else {
          ctx.strokeStyle = "rgba(0, 0, 0, 0.2)";
          ctx.lineWidth = 1.5;
        }
        ctx.stroke();
        if (c.isStarter) {
          ctx.fillStyle = "#f59e0b";
          ctx.beginPath();
          ctx.roundRect(startX + 18, cardY - 11, cardW - 36, 20, 10);
          ctx.fill();
          ctx.fillStyle = "#1e1b18";
          ctx.font = '900 11px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText("CUT", startX + cardW / 2, cardY - 1);
        }
        ctx.shadowBlur = 0;
        ctx.shadowColor = "transparent";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        TraditionalCard.drawToCanvas(ctx, c, startX, cardY, cardW, cardH, { isStarter: c.isStarter, isCut: c.isStarter, joker: c.joker });
        ctx.restore();
        startX += cardW + gap;
      });
      const allLines = data.lines || [];
      if (allLines.length) {
        ctx.save();
        ctx.font = '600 13px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textBaseline = "middle";
        const chips = allLines.map((l) => {
          const isBonus = _HandOfGloryCard.isBonusLine(l);
          const prefix = l.n > 0 ? `+${l.n}` : `${l.n}`;
          const label = isBonus ? `\u2605 ${prefix} ${l.why}` : `${prefix} ${l.why}`;
          const textW = ctx.measureText(label).width;
          const boxW = textW + 22;
          return { label, boxW, isBonus };
        });
        const maxRowW = 1080;
        const rows = [];
        let currentRow = [];
        let currentRowW = 0;
        chips.forEach((chip) => {
          const addedW = currentRow.length === 0 ? chip.boxW : 8 + chip.boxW;
          if (currentRow.length > 0 && currentRowW + addedW > maxRowW) {
            rows.push({ items: currentRow, totalW: currentRowW });
            currentRow = [chip];
            currentRowW = chip.boxW;
          } else {
            currentRow.push(chip);
            currentRowW += addedW;
          }
        });
        if (currentRow.length) {
          rows.push({ items: currentRow, totalW: currentRowW });
        }
        const chipH = rows.length > 2 ? 24 : 26;
        const rowGap = 7;
        const totalBlockH = rows.length * chipH + (rows.length - 1) * rowGap;
        const blockStartY = 464 + Math.max(0, (126 - totalBlockH) / 2);
        rows.forEach((row, rIdx) => {
          let cx = (W - row.totalW) / 2;
          const cy = blockStartY + rIdx * (chipH + rowGap) + chipH / 2;
          row.items.forEach((chip) => {
            if (chip.isBonus) {
              ctx.fillStyle = "rgba(245, 158, 11, 0.22)";
              ctx.strokeStyle = "#f59e0b";
              ctx.lineWidth = 1.4;
            } else {
              ctx.fillStyle = "rgba(255, 255, 255, 0.08)";
              ctx.strokeStyle = "rgba(240, 198, 74, 0.38)";
              ctx.lineWidth = 1;
            }
            ctx.beginPath();
            ctx.roundRect(cx, cy - chipH / 2, chip.boxW, chipH, 5);
            ctx.fill();
            ctx.stroke();
            ctx.fillStyle = chip.isBonus ? "#fef08a" : "#f4ead4";
            ctx.textAlign = "left";
            ctx.fillText(chip.label, cx + 11, cy);
            cx += chip.boxW + 8;
          });
        });
        ctx.restore();
      }
      const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
      const brandTitle = data?.brandTitle || brandInfo.brandTitle;
      ctx.save();
      ctx.textAlign = "left";
      ctx.textBaseline = "bottom";
      ctx.font = '700 16px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      ctx.fillStyle = "#f0c64a";
      ctx.fillText(`${brandTitle} \xB7 CustomCribBoards.com`, 52, H - 48);
      ctx.font = '500 14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
      ctx.fillStyle = "rgba(214, 211, 209, 0.7)";
      ctx.fillText("Play 100% Free Online: Solo vs AI, Pass & Play, or Online Room Codes", 52, H - 28);
      ctx.textAlign = "right";
      ctx.fillText(data.date, W - 52, H - 38);
      ctx.restore();
      return canvas;
    }
    /**
     * Generates a PNG Blob from the rendered canvas.
     * @param {Object} data
     * @returns {Promise<Blob>}
     */
    static async getCardBlob(data) {
      const canvas = _HandOfGloryCard.renderToCanvas(data);
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (blob) resolve(blob);
          else reject(new Error("Canvas toBlob failed"));
        }, "image/png");
      });
    }
    /**
     * Triggers a download of the card PNG image.
     * @param {Object} data
     */
    static async downloadCardImage(data) {
      try {
        const blob = await _HandOfGloryCard.getCardBlob(data);
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
        const fileSlug = brandInfo.slug || "game-crazy-cribbage";
        const safeName = (data.titleTag || "hand-of-glory").toLowerCase().replace(/[^a-z0-9]+/g, "-");
        a.download = `${fileSlug}-${safeName}-${data.score}pts.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        _HandOfGloryCard.showToast("\u{1F4E5} Hand of Glory card downloaded!");
      } catch (err) {
        console.error("Download error:", err);
        _HandOfGloryCard.showToast("Failed to download image.");
      }
    }
    /**
     * Copies the card image directly to system clipboard as image/png.
     * @param {Object} data
     */
    static async copyCardImage(data) {
      try {
        if (typeof navigator === "undefined" || !navigator.clipboard || !navigator.clipboard.write) {
          throw new Error("Clipboard API not supported");
        }
        const blob = await _HandOfGloryCard.getCardBlob(data);
        await navigator.clipboard.write([
          new ClipboardItem({ "image/png": blob })
        ]);
        _HandOfGloryCard.showToast("\u{1F4CB} Image copied to clipboard!");
      } catch (err) {
        console.warn("Clipboard image write failed, copying text breakdown instead:", err);
        _HandOfGloryCard.copyBreakdownText(data);
      }
    }
    /**
     * Copies formatted text breakdown of the hand to clipboard.
     * @param {Object} data
     */
    static async copyBreakdownText(data) {
      const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
      const brandName = data?.brandName || brandInfo.name;
      const shareUrl = data?.brandUrl || brandInfo.url;
      const cardStrs = (data.cards || []).map(_HandOfGloryCard.formatCardText).join(" ");
      const cutStr = data.starter ? ` | Cut: ${_HandOfGloryCard.formatCardText(data.starter)}` : "";
      const linesStr = (data.lines || []).map((l) => {
        const isBonus = _HandOfGloryCard.isBonusLine(l);
        const sign = l.n > 0 ? `+${l.n}` : `${l.n}`;
        return `\u2022 ${sign} ${l.why}${isBonus ? " (\u2605 Bonus)" : ""}`;
      }).join("\n");
      const text2 = `\u{1F3C6} ${brandName} Hand of Glory: ${data.score} Points! (${data.titleTag})
Cards: [${cardStrs}${cutStr}]
` + (linesStr ? `${linesStr}
` : "") + `Play free: ${shareUrl}`;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text2);
          _HandOfGloryCard.showToast("\u{1F4CB} Hand summary copied to clipboard!");
        }
      } catch (e) {
        console.error(e);
      }
    }
    /**
     * Native Mobile Web Share API integration (files + text).
     * @param {Object} data
     */
    static async shareNative(data) {
      try {
        if (typeof navigator === "undefined" || !navigator.share) {
          _HandOfGloryCard.downloadCardImage(data);
          return;
        }
        const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
        const brandName = data?.brandName || brandInfo.name;
        const shareUrl = data?.brandUrl || brandInfo.url;
        const fileSlug = brandInfo.slug || "game-crazy-cribbage";
        const cardStrs = (data.cards || []).map(_HandOfGloryCard.formatCardText).join(" ");
        const cutStr = data.starter ? ` + ${_HandOfGloryCard.formatCardText(data.starter)} cut` : "";
        const text2 = `I just scored ${data.score} points (${data.titleTag}) in ${brandName}! [${cardStrs}${cutStr}]`;
        const url = shareUrl;
        try {
          const blob = await _HandOfGloryCard.getCardBlob(data);
          const file = new File([blob], `${fileSlug}-${data.score}pts.png`, { type: "image/png" });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({
              title: `${brandName}: ${data.score} pt Hand!`,
              text: text2,
              url,
              files: [file]
            });
            return;
          }
        } catch (fileErr) {
          console.warn("File sharing failed, attempting text share:", fileErr);
        }
        await navigator.share({
          title: `${brandName}: ${data.score} pt Hand!`,
          text: text2,
          url
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Native share failed:", err);
        }
      }
    }
    /**
     * Opens Reddit submission window targeting r/cribbage.
     * @param {Object} data
     */
    static shareToReddit(data) {
      const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
      const brandName = data?.brandName || brandInfo.name;
      const shareUrl = data?.brandUrl || brandInfo.url;
      const cardStrs = (data.cards || []).map(_HandOfGloryCard.formatCardText).join(" ");
      const cutStr = data.starter ? ` + ${_HandOfGloryCard.formatCardText(data.starter)} cut` : "";
      const title = `Scored ${data.score} points in ${brandName}! [${cardStrs}${cutStr}]`;
      const url = `https://www.reddit.com/r/cribbage/submit?title=${encodeURIComponent(title)}&url=${encodeURIComponent(shareUrl)}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    /**
     * Opens X / Twitter intent.
     * @param {Object} data
     */
    static shareToTwitter(data) {
      const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
      const brandName = data?.brandName || brandInfo.name;
      const shareUrl = data?.brandUrl || brandInfo.url;
      const cardStrs = (data.cards || []).map(_HandOfGloryCard.formatCardText).join(" ");
      const cutStr = data.starter ? ` + ${_HandOfGloryCard.formatCardText(data.starter)} cut` : "";
      const text2 = `Scored ${data.score} points in @CustomCribBoard ${brandName}! [${cardStrs}${cutStr}] \u{1F0CF}\u{1F525}`;
      const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text2)}&url=${encodeURIComponent(shareUrl)}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    /**
     * Opens Facebook share dialog.
     * @param {Object} data
     */
    static shareToFacebook(data) {
      const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
      const brandName = data?.brandName || brandInfo.name;
      const shareUrl = data?.brandUrl || brandInfo.url;
      const cardStrs = (data.cards || []).map(_HandOfGloryCard.formatCardText).join(" ");
      const cutStr = data.starter ? ` + ${_HandOfGloryCard.formatCardText(data.starter)} cut` : "";
      const quote = `Scored ${data.score} points in ${brandName}! [${cardStrs}${cutStr}]`;
      const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(quote)}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    /**
     * Opens Instagram directly and copies the card graphic to the clipboard for instant pasting.
     * @param {Object} data
     */
    static shareToInstagram(data) {
      window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
      _HandOfGloryCard.copyCardImage(data);
    }
    /**
     * Opens Threads submission intent with prefilled hand breakdown and link.
     * @param {Object} data
     */
    static shareToThreads(data) {
      const brandInfo = _HandOfGloryCard.getBrandInfo(data?.brand);
      const brandName = data?.brandName || brandInfo.name;
      const shareUrl = data?.brandUrl || brandInfo.url;
      const cardStrs = (data.cards || []).map(_HandOfGloryCard.formatCardText).join(" ");
      const cutStr = data.starter ? ` + ${_HandOfGloryCard.formatCardText(data.starter)} cut` : "";
      const text2 = `Scored ${data.score} points in @CustomCribBoard ${brandName}! [${cardStrs}${cutStr}] \u{1F0CF}\u{1F525}

${shareUrl}`;
      const url = `https://www.threads.net/intent/post?text=${encodeURIComponent(text2)}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    /**
     * Brief floating toast notification.
     * @param {string} msg
     */
    static showToast(msg) {
      if (typeof document === "undefined") return;
      let toast = document.getElementById("gloryToast");
      if (!toast) {
        toast = document.createElement("div");
        toast.id = "gloryToast";
        toast.className = "glory-toast";
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      toast.classList.add("visible");
      setTimeout(() => {
        if (toast) toast.classList.remove("visible");
      }, 2400);
    }
    /**
     * Displays the complete Hand of Glory Modal.
     * @param {string|Object} keyOrData
     * @param {Object} [context={}]
     */
    static showModal(keyOrData, context = {}) {
      if (typeof document === "undefined") return;
      const data = _HandOfGloryCard.extractHandData(keyOrData, context);
      if (!data) return;
      window._activeGloryCardData = data;
      const cardPreviewHtml = _HandOfGloryCard.buildCardHtml(data);
      const canNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";
      const modalHtml = `
      <div class="glory-modal-container">
        <div class="glory-modal-top">
          <div class="glory-modal-headline">\u{1F3C6} HAND OF GLORY</div>
          <button type="button" class="glory-btn-close" data-action="close" aria-label="Close" title="Close">\u2715</button>
        </div>

        ${cardPreviewHtml}

        <div class="glory-action-bar">
          <button type="button" class="btn-glory-action btn-glory-download" data-action="download" title="Download high-resolution image">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            <span>Download</span>
          </button>
          <button type="button" class="btn-glory-action btn-glory-copy" data-action="copy" title="Copy card graphic to clipboard">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
            <span>Copy Image</span>
          </button>
          ${canNativeShare ? `
          <button type="button" class="btn-glory-action btn-glory-native" data-action="native" title="Share with phone apps">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
            <span>Share</span>
          </button>` : ""}
          <button type="button" class="btn-glory-action btn-glory-reddit" data-action="reddit" title="Share to r/cribbage on Reddit">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="10"/><path fill="#fff" d="M12 4.5c.8 0 1.5.7 1.5 1.5 0 .2-.05.4-.13.58l2.06 1.03c.53-.4 1.2-.61 1.92-.61 1.74 0 3.15 1.41 3.15 3.15 0 .73-.24 1.4-.66 1.94.05.27.08.55.08.83 0 2.87-3.58 5.2-8 5.2s-8-2.33-8-5.2c0-.28.03-.56.08-.83-.42-.54-.66-1.21-.66-1.94 0-1.74 1.41-3.15 3.15-3.15.72 0 1.39.21 1.92.61l2.06-1.03c-.08-.18-.13-.38-.13-.58 0-.8.7-1.5 1.5-1.5zm-3 8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm6 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm-5.5 2.5c.67.67 1.5 1 2.5 1s1.83-.33 2.5-1"/></svg>
            <span>Reddit</span>
          </button>
          <button type="button" class="btn-glory-action btn-glory-x" data-action="x" title="Share to X">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            <span>X</span>
          </button>
          <button type="button" class="btn-glory-action btn-glory-facebook" data-action="facebook" title="Share to Facebook">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            <span>Facebook</span>
          </button>
          <button type="button" class="btn-glory-action btn-glory-instagram" data-action="instagram" title="Share to Instagram">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            <span>Instagram</span>
          </button>
          <button type="button" class="btn-glory-action btn-glory-threads" data-action="threads" title="Share to Threads">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.26 18.3 1.5 15.394 1.733 11.838c.418-6.384 4.887-11.393 10.63-11.82 5.093-.38 9.537 2.378 10.748 6.66.42 1.487.483 3.018.188 4.549a9.718 9.718 0 0 1-2.924 5.378 9.554 9.554 0 0 1-5.753 2.658c-1.326.175-2.618-.088-3.738-.76-.713-.427-1.305-1.01-1.748-1.713-.672.937-1.554 1.637-2.607 2.062a7.126 7.126 0 0 1-4.004.288c.324.636.745 1.209 1.259 1.706 1.488 1.439 3.518 2.213 6.033 2.302.267.01.536.015.805.015 2.535 0 5.074-.537 7.234-1.639.673-.343 1.49-.074 1.833.599.344.673.075 1.49-.598 1.833-2.502 1.277-5.441 1.9-8.384 1.9-.304 0-.608-.006-.911-.017zm2.463-7.797c.504-.08 1.004-.25 1.486-.508a6.992 6.992 0 0 0 2.457-2.42 6.842 6.842 0 0 0 .97-3.66c.162-.84.127-1.68-.104-2.497-.783-2.772-3.766-4.606-7.237-4.348-4.223.313-7.513 4.095-7.828 8.989-.174 2.698.396 4.887 1.696 6.505 1.349 1.68 3.398 2.545 6.091 2.57 2.052-.072 3.659-.724 4.793-1.841-.301-.482-.507-1.026-.6-1.603a4.57 4.57 0 0 1-.225-1.378c-.012-.435.032-.871.13-1.298a4.136 4.136 0 0 1 1.077-1.921 4.254 4.254 0 0 1 2.023-1.071c1.077-.247 2.146-.071 2.97.487-.315-1.815-.989-2.937-2.22-3.702-.997-.62-2.316-.957-3.818-.981a8.423 8.423 0 0 0-4.707 1.424 8.784 8.784 0 0 0-3.088 3.738 9.537 9.537 0 0 0-.649 4.316c.381 2.894 2.138 4.755 4.819 5.097 1.258.161 2.483-.075 3.541-.682.49-.281 1.115-.116 1.396.374.281.491.116 1.116-.374 1.397-1.42.815-3.064 1.132-4.754.915-3.67-.47-6.098-3.082-6.602-6.915a11.91 11.91 0 0 1 .812-5.394 11.002 11.002 0 0 1 3.864-4.678 10.685 10.685 0 0 1 5.952-1.794c1.94.032 3.684.475 5.044 1.323 1.959 1.218 3.012 3.09 3.125 5.767a1.144 1.144 0 0 1-.03.265c-.173 1.025-.568 2.012-1.173 2.936a7.272 7.272 0 0 1-2.072 2.046c-.958.583-2.036.883-3.116.868z"/></svg>
            <span>Threads</span>
          </button>
        </div>

        <div class="glory-modal-bottom-row">
          <button type="button" class="btn-ghost glory-btn-return" data-action="close">
            \u2190 Return to Game
          </button>
        </div>
      </div>
    `;
      let overlay = document.getElementById("gloryOverlay");
      let box = document.getElementById("gloryModalBox");
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = "gloryOverlay";
        overlay.className = "glory-overlay";
        overlay.setAttribute("role", "dialog");
        overlay.setAttribute("aria-modal", "true");
        overlay.setAttribute("aria-label", "Hand of Glory Card");
        box = document.createElement("div");
        box.id = "gloryModalBox";
        box.className = "glory-modal-box";
        overlay.appendChild(box);
        document.body.appendChild(overlay);
      }
      if (!overlay._hasGloryClickListener && typeof overlay.addEventListener === "function") {
        overlay._hasGloryClickListener = true;
        overlay.addEventListener("click", (e) => {
          if (e.target === overlay) {
            _HandOfGloryCard.closeModal();
            return;
          }
          const actionBtn = e.target && typeof e.target.closest === "function" ? e.target.closest("[data-action]") : null;
          if (!actionBtn) return;
          const action = actionBtn.dataset ? actionBtn.dataset.action : actionBtn.getAttribute("data-action");
          switch (action) {
            case "close":
              _HandOfGloryCard.closeModal();
              break;
            case "download":
              if (window._activeGloryCardData) _HandOfGloryCard.downloadCardImage(window._activeGloryCardData);
              break;
            case "copy":
              if (window._activeGloryCardData) _HandOfGloryCard.copyCardImage(window._activeGloryCardData);
              break;
            case "native":
              if (window._activeGloryCardData) _HandOfGloryCard.shareNative(window._activeGloryCardData);
              break;
            case "reddit":
              if (window._activeGloryCardData) _HandOfGloryCard.shareToReddit(window._activeGloryCardData);
              break;
            case "x":
              if (window._activeGloryCardData) _HandOfGloryCard.shareToTwitter(window._activeGloryCardData);
              break;
            case "facebook":
              if (window._activeGloryCardData) _HandOfGloryCard.shareToFacebook(window._activeGloryCardData);
              break;
            case "instagram":
              if (window._activeGloryCardData) _HandOfGloryCard.shareToInstagram(window._activeGloryCardData);
              break;
            case "threads":
              if (window._activeGloryCardData) _HandOfGloryCard.shareToThreads(window._activeGloryCardData);
              break;
          }
        });
      }
      if (!window._gloryKeyBound && typeof window !== "undefined" && typeof window.addEventListener === "function") {
        window._gloryKeyBound = true;
        window.addEventListener("keydown", (e) => {
          if (e.key === "Escape") {
            const el = document.getElementById("gloryOverlay");
            if (el && el.style.display !== "none") {
              _HandOfGloryCard.closeModal();
            }
          }
        });
      }
      if (box) {
        box.innerHTML = modalHtml;
      }
      const fsElem = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
      const b3dElem = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
      const activeModalOverlay = document.getElementById("overlay");
      const modalParent = activeModalOverlay && activeModalOverlay.parentElement && activeModalOverlay.parentElement !== document.body ? activeModalOverlay.parentElement : null;
      const b3dContainer = document.getElementById("board3DContainer");
      const is3DFullscreen = Boolean(
        fsElem || b3dElem || b3dContainer && (b3dContainer.classList?.contains?.("is-fullscreen") || typeof document !== "undefined" && document.body?.classList?.contains?.("is-3d-fullscreen"))
      );
      const targetParent = fsElem || b3dElem || modalParent || (is3DFullscreen ? b3dContainer : null);
      if (targetParent && overlay.parentElement !== targetParent) {
        targetParent.appendChild(overlay);
      }
      overlay.style.position = "fixed";
      overlay.style.inset = "0";
      overlay.style.zIndex = "20000000";
      overlay.style.pointerEvents = "auto";
      overlay.style.display = "flex";
    }
    /**
     * Closes the Hand of Glory modal without touching or disrupting the underlying game modal.
     */
    static closeModal() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("gloryOverlay");
      if (overlay) {
        overlay.style.display = "none";
        const fsElem = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
        const b3dElem = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
        if (overlay.parentElement !== document.body && !fsElem && !b3dElem && document.body) {
          document.body.appendChild(overlay);
        }
      }
      const nextBtn = document.getElementById("btnNextHand");
      if (nextBtn && !nextBtn.onclick) {
        nextBtn.onclick = () => {
          const state3 = typeof window !== "undefined" && window.state || {};
          state3.showModal = null;
          if (typeof window.hideModal === "function") window.hideModal();
          if (typeof window.nextSeat === "function") state3.dealer = window.nextSeat(state3.dealer);
          state3.revealCrib = false;
          if (typeof window.newHand === "function") window.newHand();
          if (typeof window.netPush === "function") window.netPush({ modal: "hide" });
        };
      }
    }
  };
  if (typeof window !== "undefined") {
    window.downloadActiveGloryCard = () => {
      if (window._activeGloryCardData) HandOfGloryCard.downloadCardImage(window._activeGloryCardData);
    };
    window.copyActiveGloryCard = () => {
      if (window._activeGloryCardData) HandOfGloryCard.copyCardImage(window._activeGloryCardData);
    };
    window.shareActiveGloryNative = () => {
      if (window._activeGloryCardData) HandOfGloryCard.shareNative(window._activeGloryCardData);
    };
    window.shareActiveGloryReddit = () => {
      if (window._activeGloryCardData) HandOfGloryCard.shareToReddit(window._activeGloryCardData);
    };
    window.shareActiveGloryTwitter = () => {
      if (window._activeGloryCardData) HandOfGloryCard.shareToTwitter(window._activeGloryCardData);
    };
    window.shareActiveGloryFacebook = () => {
      if (window._activeGloryCardData) HandOfGloryCard.shareToFacebook(window._activeGloryCardData);
    };
    window.shareActiveGloryInstagram = () => {
      if (window._activeGloryCardData) HandOfGloryCard.shareToInstagram(window._activeGloryCardData);
    };
    window.shareActiveGloryThreads = () => {
      if (window._activeGloryCardData) HandOfGloryCard.shareToThreads(window._activeGloryCardData);
    };
    window.showHandOfGloryModal = (keyOrData, context) => {
      HandOfGloryCard.showModal(keyOrData, context);
    };
    window.closeHandOfGloryModal = () => {
      HandOfGloryCard.closeModal();
    };
  }

  // src/ui/ModalManager.js
  function getStorage4() {
    return typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
  }
  var ModalManager2 = class _ModalManager {
    constructor(options = {}) {
      this.options = options;
      this.currentTheme = options.theme || "tournament";
    }
    setTheme(theme2) {
      this.currentTheme = theme2;
    }
    /**
     * Displays a modal dialog with HTML content.
     * @param {string|object} html - HTML string or configuration object
     * @param {boolean|object} closable - Whether the modal has a visible close button
     */
    showModal(html2, closable = false) {
      if (typeof document === "undefined") return;
      let shouldShowClose = false;
      let onCloseCallback = null;
      if (typeof closable === "boolean") {
        shouldShowClose = closable;
      } else if (typeof closable === "object" && closable !== null) {
        shouldShowClose = Boolean(
          closable.showClose ?? closable.closable ?? closable.closeButton ?? closable.showCloseButton ?? closable.close
        );
        if (typeof closable.onClose === "function") {
          onCloseCallback = closable.onClose;
        }
      } else if (typeof html2 === "boolean") {
        shouldShowClose = html2;
        html2 = "";
      } else if (typeof html2 === "object" && html2 !== null && !("nodeType" in html2)) {
        if ("showClose" in html2 || "closable" in html2 || "closeButton" in html2 || "showCloseButton" in html2) {
          shouldShowClose = Boolean(html2.showClose ?? html2.closable ?? html2.closeButton ?? html2.showCloseButton);
          html2 = html2.html || html2.content || "";
        }
        if (typeof html2.onClose === "function") {
          onCloseCallback = html2.onClose;
        }
      }
      this._activeModalOnClose = onCloseCallback;
      const modal = document.getElementById("modal");
      const overlay = document.getElementById("overlay");
      const modalBar = document.getElementById("modalBar");
      const modalClose = document.getElementById("modalClose");
      const activeTheme = this && this.currentTheme || typeof window !== "undefined" && window.theme || "tournament";
      if (modal) {
        modal.setAttribute("data-theme", activeTheme);
        modal.innerHTML = html2 != null ? html2 : "";
        const innerCloseBtns = modal.querySelectorAll('button[onclick*="hideModal"], button[onclick*="closeModal"], .modal-btn-close, [data-modal-close]');
        innerCloseBtns.forEach((btn) => {
          btn.onclick = (e) => {
            if (e && e.stopPropagation) e.stopPropagation();
            if (this && typeof this.hideModal === "function") {
              this.hideModal();
            } else if (typeof window !== "undefined" && typeof window.hideModal === "function") {
              window.hideModal();
            } else if (typeof _ModalManager !== "undefined" && typeof _ModalManager.hideModal === "function") {
              _ModalManager.hideModal();
            }
          };
        });
      }
      if (overlay) {
        const fsElem = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
        const b3dElem = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
        const targetParent = fsElem || b3dElem;
        if (targetParent && overlay.parentElement !== targetParent) {
          targetParent.appendChild(overlay);
        }
        overlay.setAttribute("data-theme", activeTheme);
        overlay.style.display = "flex";
        if (html2 && typeof html2 === "string" && (html2.includes("signs-modal-wrap") || html2.includes("muggins-count-box") || html2.includes("stolen-crib-box") || html2.includes("guess-starter-box") || html2.includes("show-counter-modal"))) {
          overlay.classList.add("signs-modal-center");
        } else {
          overlay.classList.remove("signs-modal-center");
        }
        if (html2 && typeof html2 === "string" && html2.includes("coach-post-mortem-modal")) {
          overlay.classList.add("has-coach-post-mortem");
          if (modal) modal.classList.add("coach-post-mortem-container");
        } else {
          overlay.classList.remove("has-coach-post-mortem");
          if (modal) modal.classList.remove("coach-post-mortem-container");
        }
        if (html2 && typeof html2 === "string" && html2.includes("dropdown-info-modal")) {
          overlay.classList.add("has-dropdown-info");
          overlay.style.zIndex = "2500";
        } else {
          overlay.classList.remove("has-dropdown-info");
          overlay.style.zIndex = "";
        }
        if (shouldShowClose) {
          overlay.classList.add("closable");
        } else {
          overlay.classList.remove("closable");
        }
        overlay.onclick = (e) => {
          if (e && e.target === overlay && overlay.classList.contains("closable")) {
            if (this && typeof this.hideModal === "function") {
              this.hideModal();
            } else if (typeof window !== "undefined" && typeof window.hideModal === "function") {
              window.hideModal();
            }
          }
        };
      }
      if (modalBar) {
        modalBar.style.display = shouldShowClose ? "flex" : "none";
      }
      if (modalClose) {
        modalClose.style.display = shouldShowClose ? "inline-flex" : "none";
      }
    }
    /**
     * Hides the active modal and overlay.
     * @param {object} state - Optional game state to clear passingTo
     */
    hideModal(state3 = null) {
      if (this._activeModalOnClose) {
        const onCloseCb = this._activeModalOnClose;
        this._activeModalOnClose = null;
        onCloseCb();
        return;
      }
      if (typeof document === "undefined") return;
      if (state3 && state3.passingTo) {
        state3.passingTo = null;
      } else if (typeof window !== "undefined" && window.state && window.state.passingTo) {
        window.state.passingTo = null;
      }
      const overlay = document.getElementById("overlay");
      if (overlay) {
        const fsElem = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
        const b3dElem = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
        if (overlay.parentElement !== document.body && !fsElem && !b3dElem) {
          document.body.appendChild(overlay);
        }
        overlay.style.display = "none";
        overlay.classList.remove("closable");
        overlay.classList.remove("signs-modal-center");
        overlay.classList.remove("has-coach-post-mortem");
        overlay.classList.remove("has-dropdown-info");
        overlay.style.zIndex = "";
        const gloryOverlay = document.getElementById("gloryOverlay");
        if (gloryOverlay) {
          gloryOverlay.style.display = "none";
          if (gloryOverlay.parentElement !== document.body && !fsElem && !b3dElem && document.body) {
            document.body.appendChild(gloryOverlay);
          }
        }
        const board3DModal = document.getElementById("board3DModal");
        if (board3DModal) {
          board3DModal.style.display = "none";
          if (board3DModal.parentElement !== document.body && !fsElem && !b3dElem && document.body) {
            document.body.appendChild(board3DModal);
          }
        }
        const avatarModalOverlay = document.getElementById("avatarModalOverlay");
        if (avatarModalOverlay) {
          avatarModalOverlay.style.display = "none";
          if (avatarModalOverlay.parentElement !== document.body && !fsElem && !b3dElem && document.body) {
            document.body.appendChild(avatarModalOverlay);
          }
        }
      }
      const modal = document.getElementById("modal");
      if (modal) {
        modal.classList.remove("coach-post-mortem-container");
      }
      const modalBar = document.getElementById("modalBar");
      if (modalBar) {
        modalBar.style.display = "none";
      }
      const modalClose = document.getElementById("modalClose");
      if (modalClose) {
        modalClose.style.display = "none";
      }
    }
    showOverlay(html2, closable = false) {
      return this.showModal(html2, closable);
    }
    hideOverlay() {
      return this.hideModal();
    }
    closeModal() {
      return this.hideModal();
    }
    closeOverlay() {
      return this.hideModal();
    }
    /**
     * Displays the dedicated Start Game Quick-Setup Modal.
     * @param {object} [context]
     */
    showStartGameModal(context = {}) {
      const getAppBrand2 = context && typeof context.getAppBrand === "function" ? context.getAppBrand : typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand : () => "crazy";
      const isAgeVerified2 = context.isAgeVerified || (typeof window !== "undefined" && window.isAgeVerified ? window.isAgeVerified : ((b) => b !== "pints" && b !== "adult"));
      const showAgeGateModal2 = context.showAgeGateModal || (typeof window !== "undefined" ? window.showAgeGateModal : () => {
      });
      const brand = getAppBrand2();
      if ((brand === "pints" || brand === "adult") && !isAgeVerified2(brand)) {
        showAgeGateModal2(brand);
        return;
      }
      const overlay = document.getElementById("startGameOverlay");
      if (!overlay) return;
      const fsElem = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
      if (fsElem && overlay.parentElement !== fsElem) {
        fsElem.appendChild(overlay);
      }
      const syncPlayerCountUi2 = context.syncPlayerCountUi || (typeof window !== "undefined" ? window.syncPlayerCountUi : null);
      if (typeof syncPlayerCountUi2 === "function") {
        syncPlayerCountUi2();
      }
      const titleEl = document.getElementById("startGameModalTitle");
      const badgeEl = document.getElementById("startGameModalBadge");
      const btnTextEl = document.getElementById("btnConfirmStartGameText");
      if (brand === "clash") {
        if (titleEl) titleEl.textContent = "Cribbage Clash";
        if (badgeEl) badgeEl.textContent = "\u2694\uFE0F BATTLE SETUP";
        if (btnTextEl) btnTextEl.textContent = "BEGIN BATTLE";
      } else if (brand === "pints") {
        if (titleEl) titleEl.textContent = "Pints & Pegs";
        if (badgeEl) badgeEl.textContent = "\u{1F37A} PUB SETUP";
        if (btnTextEl) btnTextEl.textContent = "PLAY PINTS";
      } else if (brand === "adult") {
        if (titleEl) titleEl.textContent = "Skunked & Stripped";
        if (badgeEl) badgeEl.textContent = "\u{1F525} INTIMATE SETUP";
        if (btnTextEl) btnTextEl.textContent = "PLAY SKUNKED";
      } else {
        if (titleEl) titleEl.textContent = "Crazy Cribbage";
        if (badgeEl) badgeEl.textContent = "\u{1F3AE} QUICK SETUP";
        if (btnTextEl) btnTextEl.textContent = "START GAME";
      }
      const optBoardViewModal = document.getElementById("optBoardViewModal");
      const optBoardView = document.getElementById("optBoardView");
      const curMode = window.settings && window.settings.boardViewMode && window.settings.boardViewMode !== "3d" && window.settings.boardViewMode !== "room3d" ? window.settings.boardViewMode : optBoardViewModal && optBoardViewModal.value || optBoardView && optBoardView.value || window.settings && window.settings.boardViewMode || "room3d-fullscreen";
      if (optBoardViewModal) {
        optBoardViewModal.value = curMode;
      }
      if (optBoardView) {
        optBoardView.value = curMode;
      }
      if (typeof window !== "undefined" && window.settings) {
        window.settings.boardViewMode = curMode;
      }
      overlay.style.display = "flex";
      overlay.setAttribute("data-brand", brand);
    }
    /**
     * Hides the Start Game Quick-Setup Modal.
     */
    hideStartGameModal() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("startGameOverlay");
      if (overlay) {
        if (overlay.parentElement !== document.body && !document.fullscreenElement) {
          document.body.appendChild(overlay);
        }
        overlay.style.display = "none";
      }
    }
    /**
     * Displays a stylized confirmation modal.
     * @param {object} opts
     */
    showConfirmModal(opts = {}) {
      const {
        title = "Start a New Game?",
        message = "Your current match progress will be lost. Are you sure you want to return to the main menu and start a new game?",
        confirmText = "Start New Game",
        cancelText = "Keep Playing",
        danger = false,
        icon = null,
        onConfirm = () => {
        },
        onCancel = () => {
        }
      } = opts;
      const defaultIcon = danger ? `<svg class="confirm-icon-svg" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        </svg>` : `<svg class="confirm-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9" stroke="var(--gold, #f0c64a)"/>
          <path d="M12 8v5" stroke="var(--gold, #f0c64a)"/>
          <circle cx="12" cy="16.5" r="1" fill="var(--gold, #f0c64a)" stroke="none"/>
          <path d="M21 3v6h-6" stroke="var(--gold, #f0c64a)"/>
        </svg>`;
      const confirmBtnClass = danger ? "btn-danger" : "btn-gold";
      const modalHtml = `
      <div class="fancy-confirm-modal" role="dialog" aria-labelledby="confirmModalTitle" aria-describedby="confirmModalMsg">
        <div class="confirm-icon-ring ${danger ? "danger" : ""}" aria-hidden="true">
          ${icon || defaultIcon}
        </div>
        <h2 class="confirm-title" id="confirmModalTitle">${title}</h2>
        <p class="confirm-message" id="confirmModalMsg">${message}</p>
        <div class="confirm-actions">
          <button type="button" class="${confirmBtnClass} confirm-btn-yes" id="btnFancyConfirmYes">${confirmText}</button>
          <button type="button" class="btn-ghost confirm-btn-no" id="btnFancyConfirmNo">${cancelText}</button>
        </div>
      </div>
    `;
      this.showModal(modalHtml, true);
      if (typeof document !== "undefined") {
        const btnYes = document.getElementById("btnFancyConfirmYes");
        const btnNo = document.getElementById("btnFancyConfirmNo");
        if (btnYes) {
          btnYes.onclick = () => {
            this.hideModal();
            onConfirm();
          };
        }
        if (btnNo) {
          btnNo.onclick = () => {
            this.hideModal();
            onCancel();
          };
        }
      }
    }
    /**
     * Returns to the main menu from an active or completed game.
     * @param {Object} [context]
     */
    static backToMenu(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : () => {
      });
      const showConfirmModal2 = context.showConfirmModal || (typeof window !== "undefined" ? window.showConfirmModal : () => {
      });
      const renderRecordBox2 = context.renderRecordBox || (typeof window !== "undefined" ? window.renderRecordBox : () => {
      });
      const navigate = () => {
        hideModal3();
        try {
          const camMgr = typeof window !== "undefined" && (window._ccCameraManager || window.CrazyCribbage && window.CrazyCribbage.CameraManager && window.CrazyCribbage.CameraManager.getInstance());
          if (camMgr && camMgr.isBroadcasting) {
            camMgr.stopBroadcast();
          }
          const chatMgr = typeof window !== "undefined" && (window._ccChatManager || window.CrazyCribbage && window.CrazyCribbage.ChatManager && window.CrazyCribbage.ChatManager.getInstance());
          if (chatMgr) {
            chatMgr.setChatVisibility(false);
            chatMgr.clearChat();
          }
        } catch (e) {
        }
        if (typeof document !== "undefined") {
          const game = document.getElementById("game");
          const menu = document.getElementById("menu");
          if (game) game.classList.add("hidden");
          if (menu) menu.classList.remove("hidden");
        }
        renderRecordBox2();
      };
      if (state3 && state3.over) {
        navigate();
        return;
      }
      showConfirmModal2({
        title: "Start a New Game?",
        message: "Your current match progress will be lost. Are you sure you want to return to the main menu and start a new game?",
        confirmText: "Start New Game",
        cancelText: "Keep Playing",
        onConfirm: navigate
      });
    }
    /**
     * Returns to the main menu via the brand logo button.
     * @param {Object} [context]
     */
    static returnToMenu(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : () => {
      });
      const showConfirmModal2 = context.showConfirmModal || (typeof window !== "undefined" ? window.showConfirmModal : () => {
      });
      const renderRecordBox2 = context.renderRecordBox || (typeof window !== "undefined" ? window.renderRecordBox : () => {
      });
      const navigate = () => {
        hideModal3();
        try {
          if (typeof window !== "undefined" && window._currentRenderer3D && typeof window._currentRenderer3D.exitFullScreen === "function") {
            window._currentRenderer3D.exitFullScreen();
          }
        } catch (e) {
        }
        if (typeof document !== "undefined") {
          try {
            if (document.body) document.body.classList.remove("is-3d-fullscreen");
            const b3d = document.getElementById("board3DContainer");
            if (b3d) b3d.classList.remove("is-fullscreen");
          } catch (e) {
          }
        }
        try {
          const camMgr = typeof window !== "undefined" && (window._ccCameraManager || window.CrazyCribbage && window.CrazyCribbage.CameraManager && window.CrazyCribbage.CameraManager.getInstance());
          if (camMgr && camMgr.isBroadcasting) {
            camMgr.stopBroadcast();
          }
          const chatMgr = typeof window !== "undefined" && (window._ccChatManager || window.CrazyCribbage && window.CrazyCribbage.ChatManager && window.CrazyCribbage.ChatManager.getInstance());
          if (chatMgr) {
            chatMgr.setChatVisibility(false);
            chatMgr.clearChat();
          }
        } catch (e) {
        }
        if (typeof document !== "undefined") {
          const game = document.getElementById("game");
          const menu = document.getElementById("menu");
          if (game) game.classList.add("hidden");
          if (menu) menu.classList.remove("hidden");
        }
        renderRecordBox2();
      };
      if (state3 && state3.over) {
        navigate();
        return;
      }
      showConfirmModal2({
        title: "Return to Main Menu?",
        message: "Your current match progress will be lost. Are you sure you want to return to the main menu and start a new game?",
        confirmText: "Return to Main Menu",
        cancelText: "Keep Playing",
        onConfirm: navigate
      });
    }
    backToMenu(context) {
      return _ModalManager.backToMenu(context);
    }
    returnToMenu(context) {
      return _ModalManager.returnToMenu(context);
    }
    /**
     * Displays the social and peer sharing modal.
     * @param {Object} [context]
     */
    showShareModal(context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null) || {};
      const getJoinUrl2 = context.getJoinUrl || (typeof window !== "undefined" ? window.getJoinUrl : null);
      const isOnlineHost = settings3.opp === "online" && net2.room;
      const shareTitle = "Crazy Cribbage";
      const shareText = isOnlineHost ? `Join my Crazy Cribbage online room! Room code: ${net2.room}` : "Play Crazy Cribbage \u2014 the wild twist on classic cribbage! 50+ point hands, jokers, and custom boards!";
      const shareUrl = isOnlineHost && typeof getJoinUrl2 === "function" ? getJoinUrl2(net2.room) : typeof window !== "undefined" && window.location ? window.location.href.split("#")[0] : "https://crazycribbage.com";
      const canNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";
      const encodedUrl = encodeURIComponent(shareUrl);
      const encodedText = encodeURIComponent(shareText);
      const encodedTitle = encodeURIComponent(shareTitle);
      const platforms = [
        {
          name: "X (Twitter)",
          color: "#000000",
          border: "rgba(255,255,255,0.25)",
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
          url: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`
        },
        {
          name: "Facebook",
          color: "#1877F2",
          border: "rgba(24,119,242,0.5)",
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>',
          url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
        },
        {
          name: "WhatsApp",
          color: "#25D366",
          border: "rgba(37,211,102,0.5)",
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12.031 2c-5.508 0-9.984 4.476-9.984 9.984 0 1.76.459 3.478 1.333 4.992L2 22.062l5.244-1.375c1.464.799 3.116 1.22 4.787 1.22h.005c5.508 0 9.984-4.476 9.984-9.984 0-2.668-1.039-5.176-2.925-7.062A9.92 9.92 0 0 0 12.031 2zm0 18.291h-.004a8.28 8.28 0 0 1-4.22-1.154l-.303-.18-3.136.822.837-3.056-.197-.314a8.26 8.26 0 0 1-1.267-4.425c0-4.57 3.719-8.289 8.29-8.289 2.215 0 4.297.863 5.863 2.43 1.566 1.566 2.428 3.649 2.427 5.864 0 4.571-3.719 8.29-8.29 8.29z"/></svg>',
          url: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`
        },
        {
          name: "Reddit",
          color: "#FF4500",
          border: "rgba(255,69,0,0.5)",
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="10"/><path fill="#fff" d="M12 4.5c.8 0 1.5.7 1.5 1.5 0 .2-.05.4-.13.58l2.06 1.03c.53-.4 1.2-.61 1.92-.61 1.74 0 3.15 1.41 3.15 3.15 0 .73-.24 1.4-.66 1.94.05.27.08.55.08.83 0 2.87-3.58 5.2-8 5.2s-8-2.33-8-5.2c0-.28.03-.56.08-.83-.42-.54-.66-1.21-.66-1.94 0-1.74 1.41-3.15 3.15-3.15.72 0 1.39.21 1.92.61l2.06-1.03c-.08-.18-.13-.38-.13-.58 0-.8.7-1.5 1.5-1.5zm-3 8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm6 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm-5.5 2.5c.67.67 1.5 1 2.5 1s1.83-.33 2.5-1"/></svg>',
          url: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`
        },
        {
          name: "LinkedIn",
          color: "#0A66C2",
          border: "rgba(10,102,194,0.5)",
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.46 10.9v8.37H9.2V10.9H6.46M7.83 6.45c-.9 0-1.63.73-1.63 1.63 0 .9.73 1.63 1.63 1.63.9 0 1.63-.73 1.63-1.63 0-.9-.73-1.63-1.63-1.63z"/></svg>',
          url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
        },
        {
          name: "Telegram",
          color: "#229ED9",
          border: "rgba(34,158,217,0.5)",
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 0 0-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/></svg>',
          url: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`
        },
        {
          name: "Email",
          color: "#374151",
          border: "rgba(255,255,255,0.25)",
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>',
          url: `mailto:?subject=${encodedTitle}&body=${encodedText}%0A%0A${encodedUrl}`
        }
      ];
      const gridHtml = platforms.map((p) => `
      <a href="${p.url}" target="_blank" rel="noopener noreferrer" class="social-share-btn" style="--btn-color:${p.color};--btn-border:${p.border};">
        <span class="social-share-icon">${p.icon}</span>
        <span class="social-share-name">${p.name}</span>
      </a>
    `).join("");
      const modalHtml = `
      <div class="share-modal-content">
        <h2>Share Crazy Cribbage</h2>
        <div style="color:#d7e8dc;font-size:0.9rem;margin:6px 0 16px;">
          ${isOnlineHost ? `Join my Crazy Cribbage online room! Room code: ${net2.room}` : "Share the fun with friends or challenge other Cribbage players!"}
        </div>
        
        <div class="share-copy-box">
          <input type="text" readonly value="${shareUrl}" id="shareLinkInput" class="share-link-input" />
          <button type="button" class="btn-gold" id="btnCopyShareLink">Copy Link</button>
        </div>

        <div class="social-share-grid">
          ${gridHtml}
        </div>

        ${canNativeShare ? `
          <div style="margin-top:14px;">
            <button type="button" class="btn-gold" id="btnNativeShare" style="width:100%;display:inline-flex;align-items:center;justify-content:center;gap:8px;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/></svg>
              <span>More Options (Device Share)</span>
            </button>
          </div>
        ` : ""}

        <div style="margin-top:18px;">
          <button type="button" class="btn-ghost modal-btn-close" id="btnCloseShare">Close</button>
        </div>
      </div>
    `;
      this.showModal(modalHtml, true);
      if (typeof document !== "undefined") {
        const input = document.getElementById("shareLinkInput") || document.getElementById("shareUrlInput");
        if (input) {
          input.focus();
          input.select();
        }
        const copyBtn = document.getElementById("btnCopyShareLink");
        if (copyBtn) {
          copyBtn.addEventListener("click", () => {
            if (typeof copyShareLink === "function") copyShareLink();
            else _ModalManager.copyShareLink();
          });
        }
        const nativeBtn = document.getElementById("btnNativeShare");
        if (nativeBtn) {
          nativeBtn.addEventListener("click", () => {
            if (typeof triggerNativeShare === "function") triggerNativeShare();
            else _ModalManager.triggerNativeShare();
          });
        }
      }
    }
    /**
     * Copies the share link to the user's clipboard and displays temporary confirmation text.
     */
    static copyShareLink() {
      if (typeof document === "undefined") return;
      const input = document.getElementById("shareLinkInput") || document.getElementById("shareUrlInput");
      const btn = document.getElementById("btnCopyShareLink") || document.getElementById("btnCopyShare");
      if (input) {
        if (typeof navigator !== "undefined" && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
          navigator.clipboard.writeText(input.value).then(() => {
            if (btn) {
              const orig = btn.textContent;
              btn.textContent = "Copied!";
              btn.style.filter = "brightness(1.2)";
              setTimeout(() => {
                if (btn) {
                  btn.textContent = orig;
                  btn.style.filter = "";
                }
              }, 2e3);
            }
          }).catch(() => {
            input.select();
            try {
              document.execCommand("copy");
              if (btn) {
                const orig = btn.textContent;
                btn.textContent = "Copied!";
                setTimeout(() => {
                  if (btn) btn.textContent = orig;
                }, 2e3);
              }
            } catch (e) {
            }
          });
        } else {
          input.select();
          try {
            document.execCommand("copy");
            if (btn) {
              const orig = btn.textContent;
              btn.textContent = "Copied!";
              setTimeout(() => {
                if (btn) btn.textContent = orig;
              }, 2e3);
            }
          } catch (e) {
          }
        }
      }
    }
    copyShareLink() {
      return _ModalManager.copyShareLink();
    }
    /**
     * Displays the Host & Join Online Game modal with 1-click shareable invite link generator.
     * @param {Object} context
     */
    showJoinModal(context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null) || {};
      const joinRoomFn = context.joinRoom || (typeof window !== "undefined" ? window.joinRoom : null);
      const hostRoomFn = context.hostRoom || (typeof window !== "undefined" ? window.hostRoom : null);
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const hideModalFn = () => this.hideModal();
      let savedName = "";
      const s = getStorage4();
      if (s) {
        try {
          savedName = s.getItem("cc_player_name") || "";
        } catch (e) {
        }
      }
      if (!savedName && typeof document !== "undefined") {
        const optNameEl = document.getElementById("optPlayerName");
        if (optNameEl && optNameEl.value) savedName = optNameEl.value.trim();
      }
      if (!savedName) savedName = "Player";
      const getJoinUrl2 = context.getJoinUrl || (typeof window !== "undefined" && typeof window.getJoinUrl === "function" ? window.getJoinUrl : typeof NetworkManager !== "undefined" ? NetworkManager.getJoinUrl : ((c) => `?room=${c}`));
      const generateCode = typeof NetworkManager !== "undefined" && typeof NetworkManager.generateRoomCode === "function" ? NetworkManager.generateRoomCode : (() => "CC" + Math.floor(1e3 + Math.random() * 9e3));
      let hostCode = net2 && net2.room || typeof document !== "undefined" && document.getElementById("optRoom") && document.getElementById("optRoom").value || generateCode();
      hostCode = hostCode.trim().toUpperCase();
      let hostInviteUrl = getJoinUrl2(hostCode);
      const modalHtml = `
      <div class="online-table-modal" style="max-width: 460px; margin: 0 auto; text-align: center;">
        <div style="display: flex; justify-content: center; gap: 8px; margin-bottom: 16px; border-bottom: 1px solid rgba(240, 198, 74, 0.2); padding-bottom: 10px;">
          <button type="button" id="tabHostBtn" class="online-modal-tab is-active" style="flex: 1; padding: 10px 14px; font-size: 0.95rem; font-weight: 800; border-radius: 8px; border: 1px solid #f0c64a; background: rgba(240, 198, 74, 0.18); color: #f0c64a; cursor: pointer;">
            \u{1F451} HOST TABLE
          </button>
          <button type="button" id="tabJoinBtn" class="online-modal-tab" style="flex: 1; padding: 10px 14px; font-size: 0.95rem; font-weight: 800; border-radius: 8px; border: 1px solid rgba(255,255,255,0.15); background: rgba(0,0,0,0.3); color: #d6d3d1; cursor: pointer;">
            \u{1F310} JOIN TABLE
          </button>
        </div>

        <!-- HOST VIEW -->
        <div id="hostViewSection">
          <h2 style="font-size: 1.35rem; font-weight: 800; color: #f0c64a; margin: 0 0 6px;">Host Online Table</h2>
          <p style="font-size: 0.88rem; color: #d6d3d1; margin: 0 0 16px; line-height: 1.4;">
            Share this 1-click link with a friend on phone or desktop. When they click, they connect automatically!
          </p>

          <div style="background: rgba(0,0,0,0.5); border: 1px solid rgba(240,198,74,0.35); border-radius: 10px; padding: 14px; margin-bottom: 16px; text-align: left;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span style="font-size: 0.78rem; font-weight: 700; color: #f0c64a; text-transform: uppercase; letter-spacing: 0.06em;">Room Code</span>
              <button type="button" id="btnRefreshHostCode" style="background: transparent; border: none; color: #f0c64a; font-size: 0.8rem; font-weight: 600; cursor: pointer;" title="Generate new code">\u{1F3B2} New Code</button>
            </div>
            <div id="hostCodeDisplay" style="font-family: monospace; font-size: 1.5rem; font-weight: 900; color: #f0c64a; letter-spacing: 0.16em; text-align: center; margin-bottom: 12px; padding: 6px; background: rgba(240,198,74,0.08); border-radius: 6px;">
              ${hostCode}
            </div>

            <label for="hostDirectInviteInput" style="display: block; font-size: 0.78rem; font-weight: 700; color: #d6d3d1; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px;">1-Click Invite Link</label>
            <div style="display: flex; gap: 8px;">
              <input id="hostDirectInviteInput" type="text" readonly value="${hostInviteUrl}"
                     style="flex: 1; box-sizing: border-box; padding: 10px 12px; font-size: 0.86rem; font-family: monospace; border-radius: 8px; border: 1px solid rgba(240, 198, 74, 0.4); background: #1a1208; color: #f4ead4; outline: none;" />
              <button type="button" class="btn-gold" id="btnCopyDirectInvite" style="padding: 10px 16px; font-size: 0.88rem; font-weight: 800; white-space: nowrap; display: inline-flex; align-items: center; gap: 6px;">
                <span>\u{1F4CB} Copy Link</span>
              </button>
            </div>
          </div>

          <div style="display: flex; gap: 10px;">
            <button type="button" class="btn-gold" id="btnHostStartTable" style="flex: 1; padding: 12px 18px; font-size: 1.05rem; font-weight: 800; letter-spacing: 0.03em;">
              \u{1F451} START HOSTING
            </button>
            <button type="button" class="btn-ghost modal-btn-close" style="padding: 12px 16px;">Cancel</button>
          </div>
        </div>

        <!-- JOIN VIEW -->
        <div id="joinViewSection" style="display: none;">
          <h2 style="font-size: 1.35rem; font-weight: 800; color: #f0c64a; margin: 0 0 6px;">Join Table</h2>
          <p style="font-size: 0.88rem; color: #d6d3d1; margin: 0 0 16px; line-height: 1.4;">
            Enter the room code or paste the invite link shared by the host:
          </p>

          <form id="joinModalForm" style="display: flex; flex-direction: column; gap: 14px; text-align: left; margin-bottom: 20px;">
            <div>
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                <label for="joinModalRoomCode" style="font-size: 0.8rem; font-weight: 700; color: #f0c64a; text-transform: uppercase; letter-spacing: 0.05em;">Room Code or Link</label>
                <button type="button" id="btnPasteFromClipboard" style="background: transparent; border: none; color: #f0c64a; font-size: 0.8rem; font-weight: 600; cursor: pointer;">\u{1F4CB} Paste</button>
              </div>
              <input id="joinModalRoomCode" type="text" maxlength="80" placeholder="e.g. CC4819 or paste link" autocomplete="off" autocapitalize="characters" spellcheck="false"
                     style="width: 100%; box-sizing: border-box; padding: 12px 14px; font-size: 1.15rem; font-family: monospace; font-weight: 800; letter-spacing: 0.1em; text-align: center; border-radius: 10px; border: 2px solid #f0c64a; background: #1a1208; color: #f0c64a; outline: none;" />
              <div id="joinModalError" style="display: none; color: #f87171; font-size: 0.82rem; font-weight: 600; margin-top: 6px; text-align: center;">Please enter a valid room code.</div>
            </div>

            <div>
              <label for="joinModalPlayerName" style="display: block; font-size: 0.8rem; font-weight: 700; color: #d6d3d1; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px;">Your Name</label>
              <input id="joinModalPlayerName" type="text" maxlength="16" placeholder="Your Name" value="${savedName.replace(/"/g, "&quot;")}" pattern="[a-zA-Z0-9]+"
                     style="width: 100%; box-sizing: border-box; padding: 10px 14px; font-size: 1rem; border-radius: 8px; border: 1px solid rgba(240, 198, 74, 0.4); background: rgba(0,0,0,0.5); color: #f4ead4; outline: none;" />
            </div>

            <div style="display: flex; gap: 10px; margin-top: 6px;">
              <button type="button" class="btn-gold" id="btnJoinModalSubmit" style="flex: 1; padding: 12px 20px; font-size: 1.05rem; font-weight: 800; letter-spacing: 0.04em; display: inline-flex; align-items: center; justify-content: center; gap: 8px;">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>
                <span>JOIN TABLE</span>
              </button>
              <button type="button" class="btn-ghost modal-btn-close" style="padding: 12px 18px;">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    `;
      this.showModal(modalHtml, true);
      if (typeof document !== "undefined") {
        const tabHostBtn = document.getElementById("tabHostBtn");
        const tabJoinBtn = document.getElementById("tabJoinBtn");
        const hostView = document.getElementById("hostViewSection");
        const joinView = document.getElementById("joinViewSection");
        const setTab = (isHost) => {
          if (tabHostBtn && tabJoinBtn && hostView && joinView) {
            if (isHost) {
              tabHostBtn.style.background = "rgba(240, 198, 74, 0.18)";
              tabHostBtn.style.color = "#f0c64a";
              tabHostBtn.style.borderColor = "#f0c64a";
              tabJoinBtn.style.background = "rgba(0,0,0,0.3)";
              tabJoinBtn.style.color = "#d6d3d1";
              tabJoinBtn.style.borderColor = "rgba(255,255,255,0.15)";
              hostView.style.display = "block";
              joinView.style.display = "none";
            } else {
              tabJoinBtn.style.background = "rgba(240, 198, 74, 0.18)";
              tabJoinBtn.style.color = "#f0c64a";
              tabJoinBtn.style.borderColor = "#f0c64a";
              tabHostBtn.style.background = "rgba(0,0,0,0.3)";
              tabHostBtn.style.color = "#d6d3d1";
              tabHostBtn.style.borderColor = "rgba(255,255,255,0.15)";
              hostView.style.display = "none";
              joinView.style.display = "block";
              const codeInput2 = document.getElementById("joinModalRoomCode");
              if (codeInput2) codeInput2.focus();
            }
          }
        };
        if (tabHostBtn) tabHostBtn.onclick = () => setTab(true);
        if (tabJoinBtn) tabJoinBtn.onclick = () => setTab(false);
        const copyBtn = document.getElementById("btnCopyDirectInvite");
        const inviteInp = document.getElementById("hostDirectInviteInput");
        if (copyBtn && inviteInp) {
          copyBtn.onclick = () => {
            const val = inviteInp.value;
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(val).then(() => {
                const orig = copyBtn.innerHTML;
                copyBtn.innerHTML = "<span>Copied! \u2713</span>";
                if (sfx3 && typeof sfx3.snap === "function") sfx3.snap();
                setTimeout(() => {
                  if (copyBtn) copyBtn.innerHTML = orig;
                }, 2200);
              }).catch(() => {
                inviteInp.select();
                document.execCommand("copy");
              });
            } else {
              inviteInp.select();
              try {
                document.execCommand("copy");
              } catch (e) {
              }
            }
          };
        }
        const refreshBtn = document.getElementById("btnRefreshHostCode");
        const codeDisplay = document.getElementById("hostCodeDisplay");
        if (refreshBtn && codeDisplay && inviteInp) {
          refreshBtn.onclick = () => {
            hostCode = generateCode();
            hostInviteUrl = getJoinUrl2(hostCode);
            codeDisplay.textContent = hostCode;
            inviteInp.value = hostInviteUrl;
            const optRoomEl = document.getElementById("optRoom");
            if (optRoomEl) optRoomEl.value = hostCode;
          };
        }
        const btnHostStart = document.getElementById("btnHostStartTable");
        if (btnHostStart) {
          btnHostStart.onclick = () => {
            const optRoomEl = document.getElementById("optRoom");
            if (optRoomEl) optRoomEl.value = hostCode;
            const optOppEl = document.getElementById("optOpp");
            if (optOppEl) {
              optOppEl.value = "online";
              optOppEl.dispatchEvent(new Event("change"));
            }
            if (settings3) {
              settings3.opp = "online";
              settings3.netRole = "host";
            }
            hideModalFn();
            if (typeof hostRoomFn === "function") {
              hostRoomFn();
            } else if (typeof window !== "undefined" && typeof window.hostRoom === "function") {
              window.hostRoom();
            }
          };
        }
        const codeInput = document.getElementById("joinModalRoomCode");
        const nameInput = document.getElementById("joinModalPlayerName");
        const submitBtn = document.getElementById("btnJoinModalSubmit");
        const errorDiv = document.getElementById("joinModalError");
        const parseCodeFromInput = (str) => {
          let val = sanitizeUserInput(str || "");
          const match = /[?&](?:room|join)=([a-zA-Z0-9_-]+)/i.exec(val);
          if (match && match[1]) {
            val = match[1];
          }
          return val.toUpperCase();
        };
        if (codeInput) {
          codeInput.addEventListener("input", () => {
            if (errorDiv) errorDiv.style.display = "none";
            codeInput.value = parseCodeFromInput(codeInput.value);
          });
          codeInput.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              if (submitBtn) submitBtn.click();
            }
          });
        }
        if (nameInput) {
          nameInput.addEventListener("input", () => {
            nameInput.value = sanitizeUserInput(nameInput.value).replace(/[^a-zA-Z0-9]/g, "");
          });
        }
        const joinForm = document.getElementById("joinModalForm");
        if (joinForm) {
          joinForm.addEventListener("submit", (e) => e.preventDefault());
        }
        const pasteBtn = document.getElementById("btnPasteFromClipboard");
        if (pasteBtn && codeInput) {
          pasteBtn.onclick = async () => {
            try {
              if (navigator.clipboard && navigator.clipboard.readText) {
                const text2 = await navigator.clipboard.readText();
                if (text2) {
                  codeInput.value = parseCodeFromInput(text2);
                  if (errorDiv) errorDiv.style.display = "none";
                }
              }
            } catch (e) {
            }
          };
        }
        if (submitBtn) {
          submitBtn.onclick = (e) => {
            if (e && e.preventDefault) e.preventDefault();
            const code = parseCodeFromInput(codeInput ? codeInput.value : "");
            if (!code) {
              if (errorDiv) {
                errorDiv.textContent = "Please enter a valid room code or link.";
                errorDiv.style.display = "block";
              }
              if (codeInput) codeInput.focus();
              return;
            }
            const rawEnteredName = nameInput ? nameInput.value : "";
            const enteredName = sanitizeUserInput(rawEnteredName).replace(/[^a-zA-Z0-9]/g, "").trim();
            if (enteredName) {
              try {
                const s2 = getStorage4();
                if (s2) s2.setItem("cc_player_name", enteredName);
              } catch (err) {
              }
            }
            const optNameEl = document.getElementById("optPlayerName");
            if (optNameEl && enteredName) optNameEl.value = enteredName;
            const optRoomEl = document.getElementById("optRoom");
            if (optRoomEl) optRoomEl.value = code;
            const optOppEl = document.getElementById("optOpp");
            if (optOppEl) {
              optOppEl.value = "online";
              optOppEl.dispatchEvent(new Event("change"));
            }
            if (settings3) {
              settings3.opp = "online";
              settings3.netRole = "guest";
            }
            hideModalFn();
            if (typeof joinRoomFn === "function") {
              joinRoomFn(code, { playerName: enteredName });
            } else if (typeof window !== "undefined" && typeof window.joinRoom === "function") {
              window.joinRoom(code, { playerName: enteredName });
            }
          };
        }
      }
    }
    /**
     * Displays the interactive Discard Trainer & Hand Analyzer modal.
     * @param {Object} [context]
     */
    showDiscardTrainerModal(context = {}) {
      if (typeof document === "undefined") return;
      let trainerHand = context.hand || DiscardTrainer.dealRandomHand();
      let isDealer = context.isDealer !== void 0 ? context.isDealer : true;
      let selectedIndices = /* @__PURE__ */ new Set();
      let analysisResult = null;
      let evalResult = null;
      const suitSymbols = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const renderTrainer = () => {
        analysisResult = DiscardTrainer.analyzeHand(trainerHand, isDealer);
        const isSelected = (idx) => selectedIndices.has(idx);
        const cardsHtml = trainerHand.map((c, idx) => {
          const isRed = c.suit === "H" || c.suit === "D";
          const sel = isSelected(idx);
          const textColor = isRed ? "#dc2626 !important" : "#111827 !important";
          return `
          <button type="button" class="trainer-card-btn ${sel ? "selected" : ""} ${isRed ? "card-red" : "card-black"}" data-idx="${idx}"
                  style="position: relative; width: 74px; height: 106px; box-sizing: border-box; background: #ffffff !important; border: ${sel ? "3px solid #eab308 !important" : "2px solid #cbd5e1 !important"}; border-radius: 8px; cursor: pointer; display: flex; flex-direction: column; justify-content: space-between; padding: 6px 7px; box-shadow: ${sel ? "0 0 0 2px #ca8a04, 0 8px 18px rgba(234,179,8,0.45) !important" : "0 4px 10px rgba(0,0,0,0.35), 0 1px 3px rgba(0,0,0,0.15) !important"}; transform: ${sel ? "translateY(-3px)" : "none"}; transition: all 0.15s ease;"
                  title="${c.rankName || c.rank}${c.suit} - Click to toggle discard">
            <div style="display: flex; align-items: baseline; justify-content: flex-start; gap: 2px; line-height: 1;">
              <span class="card-val" style="font-size: 1.25rem; font-weight: 900; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${c.rankName || c.rank}</span>
              <span class="card-val" style="font-size: 0.95rem; font-weight: 700; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${suitSymbols[c.suit] || c.suit}</span>
            </div>
            <div class="card-val" style="font-size: 2.1rem; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1; text-align: center; margin: 2px 0;">${suitSymbols[c.suit] || c.suit}</div>
            <span class="trainer-discard-badge" style="font-size: 0.6rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.03em; background: ${sel ? "#ca8a04 !important" : "transparent"}; color: ${sel ? "#ffffff !important" : "transparent"}; -webkit-text-fill-color: ${sel ? "#ffffff !important" : "transparent"}; border-radius: 4px; padding: 2px 0; line-height: 1.1; text-align: center; display: block; width: 100%; box-sizing: border-box; visibility: ${sel ? "visible" : "hidden"};">${sel ? "DISCARD" : "DISCARD"}</span>
          </button>
        `;
        }).join("");
        const career = DiscardTrainer.getCareerStats(context.storage) || {
          handsPlayed: 0,
          optimalCount: 0,
          currentStreak: 0,
          bestStreak: 0,
          averageLossEV: 0,
          accuracyPct: 0
        };
        let resultsHtml = "";
        if (evalResult) {
          const gradeBadgeColors = {
            optimal: "#10b981",
            great: "#06b6d4",
            good: "#f59e0b",
            suboptimal: "#ef4444"
          };
          const badgeColor = gradeBadgeColors[evalResult.grade] || "#f0c64a";
          const tableRowsHtml = analysisResult.combos.map((combo) => {
            const isUserPick = combo.id === evalResult.chosen.id;
            const isOptimalPick = combo.rank === 1;
            let rowBg = "transparent";
            if (isUserPick && isOptimalPick) rowBg = "rgba(16, 185, 129, 0.18)";
            else if (isUserPick) rowBg = "rgba(240, 198, 74, 0.15)";
            else if (isOptimalPick) rowBg = "rgba(16, 185, 129, 0.12)";
            const discMiniHtml = combo.disc.map((c) => {
              const red = c.suit === "H" || c.suit === "D";
              const color = red ? "#dc2626 !important" : "#111827 !important";
              return `<span class="trainer-mini-card ${red ? "card-red" : "card-black"}" style="display: inline-block; padding: 2px 6px; border-radius: 4px; font-weight: 800; font-size: 0.82rem; background: #ffffff !important; color: ${color}; -webkit-text-fill-color: ${color}; border: 1px solid #cbd5e1; box-shadow: 0 1px 3px rgba(0,0,0,0.2); margin-right: 4px;">${c.rankName || c.rank}${suitSymbols[c.suit] || c.suit}</span>`;
            }).join("");
            const keepMiniHtml = combo.keep.map((c) => {
              const red = c.suit === "H" || c.suit === "D";
              const color = red ? "#dc2626 !important" : "#111827 !important";
              return `<span class="trainer-mini-card ${red ? "card-red" : "card-black"}" style="display: inline-block; padding: 2px 5px; border-radius: 4px; font-weight: 700; font-size: 0.78rem; background: #ffffff !important; color: ${color}; -webkit-text-fill-color: ${color}; border: 1px solid #cbd5e1; box-shadow: 0 1px 2px rgba(0,0,0,0.15); margin-right: 3px;">${c.rankName || c.rank}${suitSymbols[c.suit] || c.suit}</span>`;
            }).join("");
            return `
            <tr style="background: ${rowBg}; border-bottom: 1px solid rgba(255,255,255,0.06); font-size: 0.82rem;">
              <td style="padding: 6px 8px; font-weight: 800; color: ${isOptimalPick ? "#10b981" : isUserPick ? "#f0c64a" : "#a8a29e"}; text-align: center;">
                ${combo.rank}${isOptimalPick ? " \u2605" : ""}${isUserPick ? " \u{1F448}" : ""}
              </td>
              <td style="padding: 6px 8px; white-space: nowrap;">${discMiniHtml}</td>
              <td style="padding: 6px 8px; white-space: nowrap;">${keepMiniHtml}</td>
              <td style="padding: 6px 8px; text-align: center; color: #e7e5e4;">
                <span style="font-weight: 700;">${combo.handEV.toFixed(1)}</span>
                <span style="font-size: 0.72rem; color: #78716c; margin-left: 4px;">(${combo.handMin}\u2013${combo.handMax})</span>
              </td>
              <td style="padding: 6px 8px; text-align: center; color: #a8a29e;">${combo.cribEV.toFixed(1)}</td>
              <td style="padding: 6px 8px; text-align: center; font-weight: 800; color: ${isOptimalPick ? "#10b981" : "#f4ead4"};">
                ${combo.netEV > 0 ? "+" : ""}${combo.netEV.toFixed(1)}
              </td>
              <td style="padding: 6px 8px; text-align: center; font-size: 0.76rem; color: ${combo.evDiff === 0 ? "#10b981" : "#f87171"};">
                ${combo.evDiff === 0 ? "0.0" : `-${combo.evDiff.toFixed(1)}`}
              </td>
            </tr>
          `;
          }).join("");
          resultsHtml = `
          <div style="margin-top: 16px; padding: 14px; background: rgba(0,0,0,0.35); border-radius: 10px; border: 1px solid rgba(255,255,255,0.12);">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; flex-wrap: wrap; gap: 8px;">
              <div>
                <span style="display: inline-block; padding: 4px 10px; border-radius: 6px; font-weight: 800; font-size: 0.88rem; background: ${badgeColor}; color: #000; letter-spacing: 0.04em;">
                  ${evalResult.gradeLabel}
                </span>
                <span style="font-size: 0.9rem; color: #e7e5e4; margin-left: 8px; font-weight: 600;">
                  Your Pick: Rank #${evalResult.rank} of 15
                </span>
              </div>
              <div style="display: flex; gap: 6px; align-items: center; flex-wrap: wrap;">
                <div style="font-size: 0.78rem; color: #a8a29e; background: rgba(0,0,0,0.4); padding: 4px 8px; border-radius: 6px;">
                  Session: ${evalResult.stats.optimalCount}/${evalResult.stats.handsPlayed} (${evalResult.stats.accuracyPct}%)
                </div>
                ${evalResult.stats.career ? `
                  <div style="font-size: 0.78rem; color: #34d399; background: rgba(16,185,129,0.15); border: 1px solid rgba(16,185,129,0.3); padding: 4px 8px; border-radius: 6px; font-weight: 700;">
                    \u{1F310} Career: ${evalResult.stats.career.optimalCount}/${evalResult.stats.career.handsPlayed} (${evalResult.stats.career.accuracyPct}%) \xB7 Streak: ${evalResult.stats.career.currentStreak > 0 ? `\u{1F525} ${evalResult.stats.career.currentStreak}` : "0"}
                  </div>
                ` : ""}
              </div>
            </div>

            ${evalResult.tips.length ? `
              <div style="margin-bottom: 12px; padding: 8px 12px; background: rgba(240,198,74,0.08); border-left: 3px solid #f0c64a; border-radius: 4px; font-size: 0.82rem; color: #fef08a; line-height: 1.45;">
                ${evalResult.tips.map((t) => `<div>${t}</div>`).join("")}
              </div>
            ` : ""}

            <div style="max-height: 240px; overflow-y: auto; border: 1px solid rgba(255,255,255,0.08); border-radius: 8px;">
              <table style="width: 100%; border-collapse: collapse; text-align: left; font-family: inherit;">
                <thead>
                  <tr style="background: rgba(0,0,0,0.6); border-bottom: 1px solid rgba(255,255,255,0.15); font-size: 0.74rem; text-transform: uppercase; letter-spacing: 0.05em; color: #a8a29e;">
                    <th style="padding: 6px 8px; text-align: center;">Rank</th>
                    <th style="padding: 6px 8px;">Discard (2)</th>
                    <th style="padding: 6px 8px;">Keep (4)</th>
                    <th style="padding: 6px 8px; text-align: center;">Hand EV (Min\u2013Max)</th>
                    <th style="padding: 6px 8px; text-align: center;">Crib EV</th>
                    <th style="padding: 6px 8px; text-align: center;">Net Score</th>
                    <th style="padding: 6px 8px; text-align: center;">Loss</th>
                  </tr>
                </thead>
                <tbody>
                  ${tableRowsHtml}
                </tbody>
              </table>
            </div>
          </div>
        `;
        }
        const modalHtml = `
        <div class="discard-trainer-wrap" style="max-width: 620px; width: 100%; margin: 0 auto; color: #f4ead4; font-family: inherit;">
          <div style="text-align: center; margin-bottom: 12px;">
            <div style="display: inline-flex; align-items: center; justify-content: center; width: 44px; height: 44px; border-radius: 50%; background: linear-gradient(135deg, #f0c64a, #d4a017); color: #1a1208; font-size: 1.6rem; margin-bottom: 6px;">\u{1F3AF}</div>
            <h2 style="margin: 0; font-size: 1.35rem; font-weight: 800; color: #f0c64a; letter-spacing: 0.04em;">CRIBBAGE DISCARD TRAINER</h2>
            <p style="margin: 4px 0 0; font-size: 0.82rem; color: #a8a29e;">Exact Hand Expected Value (EV) across all 46 cut cards &amp; crib impact.</p>
            <div style="margin-top: 6px; display: inline-flex; align-items: center; gap: 8px; padding: 3px 10px; border-radius: 12px; background: rgba(16,185,129,0.12); border: 1px solid rgba(16,185,129,0.3); font-size: 0.74rem; color: #34d399; font-weight: 700;">
              <span>\u{1F310} Global Career: ${career.optimalCount}/${career.handsPlayed} Optimal (${career.accuracyPct}%)</span>
              <span>\xB7</span>
              <span>Streak: ${career.currentStreak > 0 ? `\u{1F525} ${career.currentStreak}` : "0"}</span>
              <span>\xB7</span>
              <span>Avg Loss: -${career.averageLossEV.toFixed(2)} EV</span>
            </div>
          </div>

          <!-- Role Toggle -->
          <div style="display: flex; justify-content: center; gap: 8px; margin-bottom: 14px;">
            <button type="button" id="btnTrainerDealer" class="btn-ghost"
                    style="padding: 6px 14px; font-size: 0.82rem; font-weight: 700; border-radius: 20px; border: 1px solid ${isDealer ? "#f0c64a" : "rgba(255,255,255,0.18)"}; background: ${isDealer ? "rgba(240,198,74,0.2)" : "transparent"}; color: ${isDealer ? "#f0c64a" : "#a8a29e"}; cursor: pointer;">
              \u{1F451} Dealer (Your Crib)
            </button>
            <button type="button" id="btnTrainerPone" class="btn-ghost"
                    style="padding: 6px 14px; font-size: 0.82rem; font-weight: 700; border-radius: 20px; border: 1px solid ${!isDealer ? "#f0c64a" : "rgba(255,255,255,0.18)"}; background: ${!isDealer ? "rgba(240,198,74,0.2)" : "transparent"}; color: ${!isDealer ? "#f0c64a" : "#a8a29e"}; cursor: pointer;">
              \u{1F6E1}\uFE0F Pone (Opponent's Crib)
            </button>
          </div>

          <!-- Card Hand -->
          <div style="text-align: center; margin-bottom: 8px; font-size: 0.85rem; font-weight: 600; color: #d6d3d1;">
            Select 2 cards to toss to the crib (${selectedIndices.size}/2 selected):
          </div>
          <div id="trainerCardsRow" style="display: flex; justify-content: center; gap: 8px; flex-wrap: wrap; margin-bottom: 14px;">
            ${cardsHtml}
          </div>

          <!-- Action Buttons -->
          <div style="display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
            <button type="button" id="btnTrainerSubmit" class="btn-gold" ${selectedIndices.size !== 2 ? "disabled" : ""}
                    style="padding: 10px 18px; font-weight: 800; font-size: 0.92rem; border-radius: 8px; cursor: ${selectedIndices.size === 2 ? "pointer" : "not-allowed"}; opacity: ${selectedIndices.size === 2 ? "1" : "0.5"};">
              \u{1F4CA} Analyze &amp; Score Discard
            </button>
            <button type="button" id="btnTrainerDeal" class="btn-secondary" style="padding: 10px 14px; font-weight: 700; font-size: 0.88rem; border-radius: 8px; background: linear-gradient(135deg, #2a1b08, #3b2810); color: #f0c64a; border: 1.5px solid rgba(240, 198, 74, 0.6); cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.4);">
              \u{1F3B2} Deal New Hand
            </button>
            <button type="button" id="btnTrainerCustom" class="btn-ghost" style="padding: 10px 12px; font-size: 0.85rem; border-radius: 8px; background: rgba(255,255,255,0.08); color: #e7e5e4; border: 1.5px solid rgba(255,255,255,0.2); cursor: pointer;">
              \u270F\uFE0F Custom Hand
            </button>
            <button type="button" class="btn-ghost modal-btn-close" style="padding: 10px 14px; font-size: 0.85rem; border-radius: 8px; background: rgba(255,255,255,0.08); color: #d6d3d1; border: 1.5px solid rgba(255,255,255,0.2); cursor: pointer;">
              Close
            </button>
          </div>

          <!-- Output Container -->
          <div id="trainerOutputWrap">
            ${resultsHtml}
          </div>
        </div>
      `;
        this.showModal(modalHtml, true);
        bindTrainerEvents();
      };
      const bindTrainerEvents = () => {
        const cardBtns = document.querySelectorAll(".trainer-card-btn");
        cardBtns.forEach((btn) => {
          btn.onclick = () => {
            const idx = parseInt(btn.dataset.idx, 10);
            if (selectedIndices.has(idx)) {
              selectedIndices.delete(idx);
            } else {
              if (selectedIndices.size >= 2) {
                const first = selectedIndices.values().next().value;
                selectedIndices.delete(first);
              }
              selectedIndices.add(idx);
            }
            evalResult = null;
            renderTrainer();
          };
        });
        const btnDealer = document.getElementById("btnTrainerDealer");
        if (btnDealer) {
          btnDealer.onclick = () => {
            if (!isDealer) {
              isDealer = true;
              evalResult = null;
              renderTrainer();
            }
          };
        }
        const btnPone = document.getElementById("btnTrainerPone");
        if (btnPone) {
          btnPone.onclick = () => {
            if (isDealer) {
              isDealer = false;
              evalResult = null;
              renderTrainer();
            }
          };
        }
        const btnSubmit = document.getElementById("btnTrainerSubmit");
        if (btnSubmit) {
          btnSubmit.onclick = () => {
            if (selectedIndices.size !== 2) return;
            const userDiscards = Array.from(selectedIndices).map((i) => trainerHand[i]);
            evalResult = DiscardTrainer.evaluateUserChoice(analysisResult, userDiscards);
            renderTrainer();
          };
        }
        const btnDeal = document.getElementById("btnTrainerDeal");
        if (btnDeal) {
          btnDeal.onclick = () => {
            trainerHand = DiscardTrainer.dealRandomHand();
            selectedIndices.clear();
            evalResult = null;
            renderTrainer();
          };
        }
        const btnCustom = document.getElementById("btnTrainerCustom");
        if (btnCustom) {
          btnCustom.onclick = () => {
            const input = prompt("Enter 6 cards separated by spaces (e.g. 5H 5D JC QS 7S 8C):", trainerHand.map((c) => `${c.rankName || c.rank}${c.suit}`).join(" "));
            if (input) {
              const parsed = DiscardTrainer.parseHand(input);
              if (parsed) {
                trainerHand = parsed;
                selectedIndices.clear();
                evalResult = null;
                renderTrainer();
              } else {
                alert("Invalid cards entered! Please provide exactly 6 distinct cards like: 5H 5D JC QS 7S 8C");
              }
            }
          };
        }
      };
      renderTrainer();
    }
    /**
     * Displays the interactive Pegging Tactics Trainer modal.
     * Gives players tactical scenarios (baiting 15s, sequence defense, maneuvering to 31, etc.)
     * and provides instant feedback on optimal plays vs traps.
     * @param {Object} [context]
     */
    showPeggingTrainerModal(context = {}) {
      if (typeof document === "undefined") return;
      let activeCategory = context.category || "all";
      let currentScenario = context.scenario || PeggingTrainer.generateScenario(activeCategory);
      let evalResult = null;
      const suitSymbols = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const renderPeggingTrainer = () => {
        const statsObj = PeggingTrainer.getStats(context.storage);
        const session = statsObj.session;
        const career = statsObj.career;
        const categoryOptionsHtml = PEGGING_CATEGORIES.map((cat) => `
        <option value="${cat.id}" ${cat.id === activeCategory ? "selected" : ""}>
          ${cat.name}
        </option>
      `).join("");
        const pileCardsHtml = currentScenario.pile && currentScenario.pile.length ? currentScenario.pile.map((c) => {
          const isRed = c.suit === "H" || c.suit === "D";
          const textColor = isRed ? "#dc2626 !important" : "#111827 !important";
          return `
            <div class="pegging-mini-card ${isRed ? "card-red" : "card-black"}"
                 style="display: inline-flex; flex-direction: column; align-items: center; justify-content: center; width: 44px; height: 62px; background: #ffffff !important; border: 1.5px solid #cbd5e1; border-radius: 6px; box-shadow: 0 2px 6px rgba(0,0,0,0.3); padding: 2px;">
              <span style="font-size: 0.92rem; font-weight: 800; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${c.rankName || c.rank}</span>
              <span style="font-size: 1.15rem; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${suitSymbols[c.suit] || c.suit}</span>
            </div>
          `;
        }).join("") : '<span style="color:#94a3b8; font-style:italic;">Pile is empty (Lead card)</span>';
        const handCardsHtml = currentScenario.hand.map((c, idx) => {
          const isRed = c.suit === "H" || c.suit === "D";
          const textColor = isRed ? "#dc2626 !important" : "#111827 !important";
          const isLegal = currentScenario.count + VAL(c.rank) <= 31;
          const isChosen = evalResult && evalResult.chosen && evalResult.chosen.card.id === c.id;
          let borderStyle = isLegal ? "2px solid #cbd5e1 !important" : "2px dashed #64748b !important";
          let boxShadow = isLegal ? "0 4px 10px rgba(0,0,0,0.35)" : "none";
          if (isChosen) {
            borderStyle = evalResult.isOptimal ? "3px solid #10b981 !important" : "3px solid #f59e0b !important";
            boxShadow = evalResult.isOptimal ? "0 0 0 2px #10b981, 0 8px 18px rgba(16,185,129,0.45) !important" : "0 0 0 2px #f59e0b, 0 8px 18px rgba(245,158,11,0.45) !important";
          }
          return `
          <button type="button" class="pegging-hand-card-btn ${isLegal ? "" : "illegal-card"} ${isRed ? "card-red" : "card-black"}" data-card-id="${c.id}" ${!isLegal || evalResult ? "disabled" : ""}
                  style="position: relative; width: 72px; height: 104px; box-sizing: border-box; background: #ffffff !important; border: ${borderStyle}; border-radius: 8px; cursor: ${isLegal && !evalResult ? "pointer" : "default"}; opacity: ${isLegal ? "1" : "0.45"}; display: flex; flex-direction: column; justify-content: space-between; padding: 6px 7px; box-shadow: ${boxShadow}; transform: ${isChosen ? "translateY(-4px)" : "none"}; transition: all 0.15s ease;"
                  title="${c.rankName || c.rank}${c.suit} ${isLegal ? "(Click to play)" : "(Exceeds 31)"}">
            <div style="display: flex; align-items: baseline; justify-content: flex-start; gap: 2px; line-height: 1;">
              <span class="card-val" style="font-size: 1.22rem; font-weight: 900; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${c.rankName || c.rank}</span>
              <span class="card-val" style="font-size: 0.92rem; font-weight: 700; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${suitSymbols[c.suit] || c.suit}</span>
            </div>
            <div class="card-val" style="font-size: 2rem; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1; text-align: center; margin: 2px 0;">${suitSymbols[c.suit] || c.suit}</div>
            <span style="font-size: 0.6rem; font-weight: 800; text-transform: uppercase; background: ${isLegal ? "rgba(0,0,0,0.06)" : "rgba(239,68,68,0.1)"}; color: ${isLegal ? "#475569" : "#dc2626"}; border-radius: 4px; padding: 1px 0; text-align: center; display: block; width: 100%;">
              ${isChosen ? "PLAYED" : isLegal ? `+${VAL(c.rank)}` : "OVER 31"}
            </span>
          </button>
        `;
        }).join("");
        let resultSectionHtml = "";
        if (evalResult) {
          const gradeBadgeColors = {
            optimal: "#10b981",
            great: "#06b6d4",
            risky: "#f59e0b",
            blunder: "#ef4444"
          };
          const badgeColor = gradeBadgeColors[evalResult.grade] || "#f0c64a";
          const candidateRowsHtml = evalResult.scenario.analysis.legalMoves.map((m) => {
            const isUserPick = m.card.id === evalResult.chosen.card.id;
            const isOptimalPick = m.rank === 1;
            const isRed = m.card.suit === "H" || m.card.suit === "D";
            const cardTextColor = isRed ? "#dc2626 !important" : "#111827 !important";
            let rowBg = "transparent";
            if (isUserPick && isOptimalPick) rowBg = "rgba(16, 185, 129, 0.18)";
            else if (isUserPick) rowBg = "rgba(240, 198, 74, 0.15)";
            else if (isOptimalPick) rowBg = "rgba(16, 185, 129, 0.12)";
            return `
            <tr style="background: ${rowBg}; border-bottom: 1px solid rgba(255,255,255,0.06); font-size: 0.82rem;">
              <td style="padding: 6px 8px; font-weight: 800; color: ${isOptimalPick ? "#10b981" : isUserPick ? "#f0c64a" : "#a8a29e"}; text-align: center;">
                #${m.rank}${isOptimalPick ? " \u2605" : ""}${isUserPick ? " \u{1F448}" : ""}
              </td>
              <td style="padding: 6px 8px; white-space: nowrap;">
                <span style="display: inline-block; padding: 2px 6px; border-radius: 4px; font-weight: 800; font-size: 0.84rem; background: #ffffff !important; color: ${cardTextColor}; -webkit-text-fill-color: ${cardTextColor}; border: 1px solid #cbd5e1;">
                  ${m.card.rankName || m.card.rank}${suitSymbols[m.card.suit] || m.card.suit}
                </span>
              </td>
              <td style="padding: 6px 8px; text-align: center; font-weight: 700; color: #e2e8f0;">
                ${currentScenario.count + VAL(m.card.rank)}
              </td>
              <td style="padding: 6px 8px; text-align: center; font-weight: 800; color: ${m.directPts > 0 ? "#10b981" : "#a8a29e"};">
                ${m.directPts > 0 ? `+${m.directPts}` : "0"}
              </td>
              <td style="padding: 6px 8px; text-align: center; font-size: 0.78rem; color: ${m.diff === 0 ? "#10b981" : "#f87171"}; font-weight: 700;">
                ${m.diff === 0 ? "0.0 (Best)" : `-${m.diff.toFixed(1)}`}
              </td>
              <td style="padding: 6px 8px; font-size: 0.78rem; color: #cbd5e1;">
                ${m.reasons.length ? m.reasons.join(" \xB7 ") : "Safe tempo play"}
              </td>
            </tr>
          `;
          }).join("");
          resultSectionHtml = `
          <div style="margin-top: 16px; padding: 14px; background: rgba(0,0,0,0.38); border-radius: 10px; border: 1.5px solid ${badgeColor}; text-align: left;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; flex-wrap: wrap; gap: 8px;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <span style="display: inline-block; padding: 4px 12px; border-radius: 6px; font-weight: 800; font-size: 0.92rem; background: ${badgeColor}; color: #000; letter-spacing: 0.04em;">
                  ${evalResult.gradeLabel}
                </span>
                <span style="font-size: 0.95rem; color: #e7e5e4; font-weight: 700;">
                  Card: ${evalResult.chosen.card.rankName || evalResult.chosen.card.rank}${evalResult.chosen.card.suit}
                </span>
              </div>
              <div style="font-size: 0.78rem; color: #34d399; background: rgba(16,185,129,0.15); border: 1px solid rgba(16,185,129,0.3); padding: 4px 10px; border-radius: 6px; font-weight: 700;">
                Session: ${session.optimalCount}/${session.scenariosPlayed} (${session.accuracyPct}%) \xB7 Streak: ${session.currentStreak > 0 ? `\u{1F525} ${session.currentStreak}` : "0"}
              </div>
            </div>

            <!-- Master Lesson Explanation -->
            <div style="margin-bottom: 12px; padding: 10px 14px; background: rgba(240,198,74,0.1); border-left: 3.5px solid #f0c64a; border-radius: 4px; font-size: 0.85rem; color: #fef08a; line-height: 1.45;">
              <strong>\u{1F4A1} Tactical Lesson:</strong> ${evalResult.lesson}
            </div>

            <!-- All Move Options Comparison Table -->
            <div style="max-height: 200px; overflow-y: auto; border: 1px solid rgba(255,255,255,0.08); border-radius: 8px;">
              <table style="width: 100%; border-collapse: collapse; text-align: left; font-family: inherit;">
                <thead>
                  <tr style="background: rgba(0,0,0,0.6); border-bottom: 1px solid rgba(255,255,255,0.15); font-size: 0.74rem; text-transform: uppercase; letter-spacing: 0.05em; color: #a8a29e;">
                    <th style="padding: 6px 8px; text-align: center;">Rank</th>
                    <th style="padding: 6px 8px;">Card</th>
                    <th style="padding: 6px 8px; text-align: center;">Count</th>
                    <th style="padding: 6px 8px; text-align: center;">Points</th>
                    <th style="padding: 6px 8px; text-align: center;">Gap</th>
                    <th style="padding: 6px 8px;">Tactical Rationale</th>
                  </tr>
                </thead>
                <tbody>
                  ${candidateRowsHtml}
                </tbody>
              </table>
            </div>
          </div>
        `;
        }
        const modalHtml = `
        <div class="pegging-trainer-wrap" style="max-width: 660px; width: 100%; margin: 0 auto; color: #f4ead4; font-family: inherit;">
          <!-- Top Header -->
          <div style="text-align: center; margin-bottom: 12px;">
            <div style="display: inline-flex; align-items: center; justify-content: center; width: 44px; height: 44px; border-radius: 50%; background: linear-gradient(135deg, #38bdf8, #0284c7); color: #0f172a; font-size: 1.6rem; margin-bottom: 6px;">\u2694\uFE0F</div>
            <h2 style="margin: 0; font-size: 1.35rem; font-weight: 800; color: #38bdf8; letter-spacing: 0.04em;">PEGGING TACTICS TRAINER</h2>
            <p style="margin: 4px 0 0; font-size: 0.82rem; color: #94a3b8;">Master 15-baiting, sequence defense, pair traps, and safe maneuvers toward 31.</p>
            <div style="margin-top: 6px; display: inline-flex; align-items: center; gap: 8px; padding: 3px 12px; border-radius: 12px; background: rgba(56,189,248,0.12); border: 1px solid rgba(56,189,248,0.3); font-size: 0.75rem; color: #38bdf8; font-weight: 700;">
              <span>\u{1F310} Global Career: ${career.optimalCount}/${career.scenariosPlayed} Optimal (${career.accuracyPct}%)</span>
              <span>\xB7</span>
              <span>Streak: ${career.currentStreak > 0 ? `\u{1F525} ${career.currentStreak}` : "0"}</span>
            </div>
          </div>

          <!-- Category Selector & Navigation -->
          <div style="display: flex; justify-content: space-between; align-items: center; gap: 10px; margin-bottom: 12px; flex-wrap: wrap;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <label for="selPeggingCat" style="font-size: 0.8rem; font-weight: 700; color: #cbd5e1;">Topic:</label>
              <select id="selPeggingCat" style="background: rgba(15,23,42,0.9); color: #f8fafc; border: 1px solid rgba(56,189,248,0.5); padding: 5px 10px; border-radius: 6px; font-size: 0.82rem; font-weight: 600; outline: none; cursor: pointer;">
                ${categoryOptionsHtml}
              </select>
            </div>
            <button type="button" id="btnNextScenario" class="btn-ghost" style="padding: 6px 14px; font-size: 0.82rem; font-weight: 700; border-radius: 6px; border: 1px solid rgba(56,189,248,0.5); background: rgba(56,189,248,0.15); color: #38bdf8; cursor: pointer;">
              \u{1F3B2} Next Scenario
            </button>
          </div>

          <!-- Scenario Board Box -->
          <div style="background: rgba(0,0,0,0.35); border: 1.5px solid rgba(56,189,248,0.25); border-radius: 12px; padding: 14px 16px; margin-bottom: 14px; text-align: left;">
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 6px; flex-wrap: wrap; gap: 8px;">
              <span style="font-size: 1rem; font-weight: 800; color: #facc15;">${currentScenario.title}</span>
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="font-size: 0.75rem; text-transform: uppercase; font-weight: 800; padding: 2px 8px; border-radius: 4px; background: rgba(56,189,248,0.2); color: #38bdf8;">
                  Count: ${currentScenario.count} / 31
                </span>
              </div>
            </div>
            <p style="margin: 0 0 10px; font-size: 0.86rem; color: #e2e8f0; line-height: 1.4;">
              ${currentScenario.description}
            </p>

            <!-- Board Pile -->
            <div style="display: flex; align-items: center; gap: 12px; padding: 8px 12px; background: rgba(255,255,255,0.03); border-radius: 8px; border: 1px solid rgba(255,255,255,0.06);">
              <span style="font-size: 0.78rem; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Cards on Table:</span>
              <div style="display: flex; gap: 6px; align-items: center; flex-wrap: wrap;">
                ${pileCardsHtml}
              </div>
            </div>
          </div>

          <!-- Hand Choice Prompt -->
          <div style="text-align: center; margin-bottom: 10px; font-size: 0.88rem; font-weight: 700; color: #cbd5e1;">
            ${evalResult ? "Scenario Completed! Review breakdown below or pick Next Scenario." : "Choose a card from your hand to play:"}
          </div>
          <div id="peggingHandRow" style="display: flex; justify-content: center; gap: 8px; flex-wrap: wrap; margin-bottom: 14px;">
            ${handCardsHtml}
          </div>

          <!-- Results Section Container -->
          <div id="peggingResultsWrap">
            ${resultSectionHtml}
          </div>

          <!-- Footer Controls -->
          <div style="display: flex; gap: 8px; justify-content: center; margin-top: 16px; flex-wrap: wrap;">
            <button type="button" id="btnPeggingNextAction" class="btn-gold" style="padding: 9px 18px; font-weight: 800; font-size: 0.9rem; border-radius: 8px; cursor: pointer;">
              \u{1F3B2} Next Scenario
            </button>
            <button type="button" class="btn-ghost" id="btnGoToDiscardTrainer" style="padding: 9px 14px; font-size: 0.85rem; border-radius: 8px; border: 1px solid rgba(240,198,74,0.4); color: #f0c64a; cursor: pointer;">
              \u{1F3AF} Discard Trainer
            </button>
            <button type="button" class="btn-ghost modal-btn-close" style="padding: 9px 16px; font-size: 0.85rem; border-radius: 8px; border: 1.5px solid rgba(255,255,255,0.2); color: #d6d3d1; cursor: pointer;">
              Close
            </button>
          </div>
        </div>
      `;
        this.showModal(modalHtml, true);
        bindPeggingEvents();
      };
      const bindPeggingEvents = () => {
        const btnDiscard = document.getElementById("btnGoToDiscardTrainer");
        if (btnDiscard) {
          btnDiscard.addEventListener("click", () => {
            if (typeof showDiscardTrainerModal === "function") showDiscardTrainerModal();
            else if (typeof window !== "undefined" && typeof window.showDiscardTrainerModal === "function") window.showDiscardTrainerModal();
          });
        }
        const selCat = document.getElementById("selPeggingCat");
        if (selCat) {
          selCat.onchange = () => {
            activeCategory = selCat.value;
            currentScenario = PeggingTrainer.generateScenario(activeCategory);
            evalResult = null;
            renderPeggingTrainer();
          };
        }
        const btnNext = document.getElementById("btnNextScenario");
        const btnNextAction = document.getElementById("btnPeggingNextAction");
        const loadNext = () => {
          currentScenario = PeggingTrainer.generateScenario(activeCategory);
          evalResult = null;
          renderPeggingTrainer();
        };
        if (btnNext) btnNext.onclick = loadNext;
        if (btnNextAction) btnNextAction.onclick = loadNext;
        const cardBtns = document.querySelectorAll(".pegging-hand-card-btn:not([disabled])");
        cardBtns.forEach((btn) => {
          btn.onclick = () => {
            const cardId = btn.getAttribute("data-card-id");
            const chosenCard = currentScenario.hand.find((c) => c.id === cardId);
            if (chosenCard) {
              evalResult = PeggingTrainer.evaluateChoice(currentScenario, chosenCard, { storage: context.storage });
              renderPeggingTrainer();
            }
          };
        });
      };
      renderPeggingTrainer();
    }
    /**
     * Displays the Counting Trainer modal for practicing cribbage hand scoring.
     * Supports 6-card (discard 2, keep 4) and 9-card (discard 3, keep 6) modes,
     * random cut starter card, live total calculation, green checkmarks / red X's,
     * stats tracking with accuracy percentage, custom hand entry, sharing,
     * and expandable point-by-point details with card chips.
     * @param {Object} [context]
     */
    showCountingTrainerModal(context = {}) {
      if (typeof document === "undefined") return;
      if ((!context || !context.cards && !context.hand && !context.kept && !context.starter) && typeof window !== "undefined" && window.location && window.location.search) {
        try {
          const decoded = CountingTrainer.decodeShareUrl(window.location.search);
          if (decoded) {
            context = { ...context, ...decoded };
          }
        } catch (_) {
        }
      }
      const rankMap = { A: 1, "1": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9, "10": 10, T: 10, J: 11, Q: 12, K: 13 };
      const suitMap = { S: "S", H: "H", D: "D", C: "C", "\u2660": "S", "\u2665": "H", "\u2666": "D", "\u2663": "C" };
      const normalizeCardToken = (c) => {
        if (!c) return null;
        if (typeof c === "object" && (c.rank !== void 0 || c.r !== void 0) && (c.suit !== void 0 || c.s !== void 0)) {
          return c instanceof Card ? c : new Card(c);
        }
        if (typeof c === "string") {
          const m = c.trim().toUpperCase().match(/^([2-9]|10|[TJQKA]|1)([SHDC♠♥♦♣])$/);
          if (m) {
            const rank = rankMap[m[1]];
            const suit = suitMap[m[2]];
            return new Card({ r: rank, s: suit, id: `${m[1]}${suit}` });
          }
        }
        return null;
      };
      let mode = context.mode === 9 ? 9 : 6;
      let starterCard = normalizeCardToken(context.starter);
      let keptHand = null;
      let dealtHand = null;
      if (starterCard) {
        const rawCards = context.kept || context.cards || context.hand || null;
        if (Array.isArray(rawCards) && rawCards.length > 0) {
          keptHand = CountingTrainer.sortCards(rawCards.map(normalizeCardToken).filter(Boolean));
        }
      } else {
        const rawCards = context.hand || context.cards || null;
        if (Array.isArray(rawCards) && rawCards.length > 0) {
          dealtHand = CountingTrainer.sortCards(rawCards.map(normalizeCardToken).filter(Boolean));
        }
      }
      let phase = keptHand && starterCard ? "counting" : "discard";
      let selectedIndices = /* @__PURE__ */ new Set();
      let userInputs = { fifteens: 0, pairs: 0, runs: 0, flush: 0, nobs: 0 };
      let evalResult = null;
      let actualBreakdown = null;
      let showDetails = false;
      let showCustomForm = false;
      let customError = "";
      let toastMessage = "";
      let userDiscardedCards = null;
      let originalDealtHand = dealtHand ? dealtHand.slice() : null;
      let discardEvalResult = null;
      let showEvTable = false;
      let showSharePanel = false;
      let shareCopiedNotice = "";
      let currentShareText = "";
      let currentShareUrl = "";
      const copyTextToClipboard = async (str) => {
        if (!str) return false;
        let ok = false;
        if (typeof navigator !== "undefined" && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
          try {
            await navigator.clipboard.writeText(str);
            ok = true;
          } catch (_) {
          }
        }
        if (!ok && typeof document !== "undefined") {
          try {
            const ta = document.createElement("textarea");
            ta.value = str;
            ta.setAttribute("readonly", "");
            ta.style.position = "fixed";
            ta.style.top = "-9999px";
            ta.style.left = "-9999px";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            ok = Boolean(document.execCommand("copy"));
            document.body.removeChild(ta);
          } catch (_) {
          }
        }
        return ok;
      };
      const getRequiredDiscards = (m) => m === 9 ? 3 : 2;
      const startNewHand = (targetMode = mode) => {
        mode = targetMode;
        dealtHand = CountingTrainer.dealRandomHand(mode);
        originalDealtHand = dealtHand ? dealtHand.slice() : null;
        userDiscardedCards = null;
        discardEvalResult = null;
        showEvTable = false;
        showSharePanel = false;
        shareCopiedNotice = "";
        keptHand = null;
        starterCard = null;
        selectedIndices.clear();
        userInputs = { fifteens: 0, pairs: 0, runs: 0, flush: 0, nobs: 0 };
        evalResult = null;
        actualBreakdown = null;
        showDetails = false;
        showCustomForm = false;
        customError = "";
        phase = "discard";
        renderCountingTrainer();
      };
      if (!dealtHand && !keptHand) {
        dealtHand = CountingTrainer.dealRandomHand(mode);
      } else if (dealtHand && !keptHand && !starterCard) {
        phase = "discard";
      }
      if (phase === "counting" && keptHand && starterCard) {
        actualBreakdown = CountingTrainer.scoreCountedHand(keptHand, starterCard, false);
      }
      const suitSymbols = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const renderCountingTrainer = () => {
        const statsObj = CountingTrainer.getStats(context.storage);
        const session = statsObj.session;
        const career = statsObj.career;
        const requiredDiscards = getRequiredDiscards(mode);
        const currentLiveTotal = (Number(userInputs.fifteens) || 0) + (Number(userInputs.pairs) || 0) + (Number(userInputs.runs) || 0) + (Number(userInputs.flush) || 0) + (Number(userInputs.nobs) || 0);
        let cardsDisplayHtml = "";
        if (phase === "discard") {
          const discardCount = selectedIndices.size;
          const canCut = discardCount === requiredDiscards;
          const cardBtnsHtml = dealtHand.map((c, idx) => {
            const su = String(c && (c.suit || c.s || c.rawSuit) || "").toUpperCase();
            const isRed = su === "H" || su === "D" || su === "\u2665" || su === "\u2666";
            const isSelected = selectedIndices.has(idx);
            const textColor = isRed ? "#dc2626 !important" : "#111827 !important";
            const rVal = c ? c.rank !== void 0 ? c.rank : c.r !== void 0 ? c.r : 0 : 0;
            const rName = c && c.rankName || RANK_NAME && RANK_NAME[rVal] || (rVal === 1 ? "A" : rVal === 11 ? "J" : rVal === 12 ? "Q" : rVal === 13 ? "K" : String(rVal || ""));
            const sSym = suitSymbols && suitSymbols[su] || SUIT_SYM && SUIT_SYM[su] || (su === "H" ? "\u2665" : su === "D" ? "\u2666" : su === "S" ? "\u2660" : su === "C" ? "\u2663" : su);
            return `
            <button type="button" class="counting-card-btn ${isSelected ? "selected" : ""} ${isRed ? "card-red" : "card-black"}" data-idx="${idx}"
                    style="position: relative; width: 72px; height: 104px; box-sizing: border-box; background: #ffffff !important; border: ${isSelected ? "3px solid #ef4444 !important" : "2px solid #cbd5e1 !important"}; border-radius: 8px; cursor: pointer; display: flex; flex-direction: column; justify-content: space-between; padding: 6px 7px; box-shadow: ${isSelected ? "0 0 0 2px #dc2626, 0 8px 18px rgba(239,68,68,0.45) !important" : "0 4px 10px rgba(0,0,0,0.35) !important"}; transform: ${isSelected ? "translateY(-4px)" : "none"}; transition: all 0.15s ease;"
                    title="${rName}${sSym} - Click to toggle discard">
              <div style="display: flex; align-items: baseline; justify-content: flex-start; gap: 2px; line-height: 1;">
                <span class="card-val" style="font-size: 1.22rem; font-weight: 900; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${rName}</span>
                <span class="card-val" style="font-size: 0.92rem; font-weight: 700; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${sSym}</span>
              </div>
              <div class="card-val" style="font-size: 2rem; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1; text-align: center; margin: 2px 0;">${sSym}</div>
              <span style="font-size: 0.6rem; font-weight: 800; text-transform: uppercase; background: ${isSelected ? "#ef4444 !important" : "transparent"}; color: ${isSelected ? "#ffffff !important" : "transparent"}; -webkit-text-fill-color: ${isSelected ? "#ffffff !important" : "transparent"}; border-radius: 4px; padding: 1px 0; text-align: center; display: block; width: 100%;">
                ${isSelected ? "DISCARD" : "KEEP"}
              </span>
            </button>
          `;
          }).join("");
          cardsDisplayHtml = `
          <div style="background: rgba(0,0,0,0.25); border-radius: 12px; padding: 14px; margin-bottom: 16px; border: 1px solid rgba(255,255,255,0.08);">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; flex-wrap: wrap; gap: 8px;">
              <span style="font-size: 0.92rem; font-weight: 700; color: #f1f5f9;">
                \u{1F0CF} Dealt Hand (${dealtHand.length} cards) \u2014 Select <strong style="color: #f59e0b;">${requiredDiscards}</strong> cards to discard:
              </span>
              <span style="font-size: 0.82rem; font-weight: 800; padding: 3px 10px; border-radius: 12px; background: ${canCut ? "rgba(16,185,129,0.2)" : "rgba(239,68,68,0.2)"}; color: ${canCut ? "#34d399" : "#f87171"}; border: 1px solid ${canCut ? "rgba(16,185,129,0.4)" : "rgba(239,68,68,0.4)"};">
                ${discardCount} / ${requiredDiscards} Discarded
              </span>
            </div>
            <div style="display: flex; justify-content: center; gap: 8px; flex-wrap: wrap;">
              ${cardBtnsHtml}
            </div>
            <div style="margin-top: 14px; text-align: center;">
              <button type="button" id="btnCountingCutStarter" class="btn-primary" ${canCut ? "" : "disabled"}
                      style="padding: 10px 22px; font-weight: 800; font-size: 0.95rem; border-radius: 8px; background: ${canCut ? "linear-gradient(135deg, #10b981, #059669)" : "rgba(255,255,255,0.1)"}; color: ${canCut ? "#fff" : "#94a3b8"}; cursor: ${canCut ? "pointer" : "not-allowed"}; border: none; box-shadow: ${canCut ? "0 4px 12px rgba(16,185,129,0.4)" : "none"}; transition: all 0.2s ease;">
                \u2702\uFE0F Cut Starter & Count Hand
              </button>
            </div>
          </div>
        `;
        } else {
          const renderCardBox = (c, isCut = false) => {
            const su = String(c && (c.suit || c.s || c.rawSuit) || "").toUpperCase();
            const isRed = su === "H" || su === "D" || su === "\u2665" || su === "\u2666";
            const textColor = isRed ? "#dc2626 !important" : "#111827 !important";
            const rVal = c ? c.rank !== void 0 ? c.rank : c.r !== void 0 ? c.r : 0 : 0;
            const rName = c && c.rankName || RANK_NAME && RANK_NAME[rVal] || (rVal === 1 ? "A" : rVal === 11 ? "J" : rVal === 12 ? "Q" : rVal === 13 ? "K" : String(rVal || ""));
            const sSym = suitSymbols && suitSymbols[su] || SUIT_SYM && SUIT_SYM[su] || (su === "H" ? "\u2665" : su === "D" ? "\u2666" : su === "S" ? "\u2660" : su === "C" ? "\u2663" : su);
            const border = isCut ? "3px solid #f59e0b !important" : "2px solid #cbd5e1 !important";
            const shadow = isCut ? "0 0 16px rgba(245,158,11,0.6), 0 4px 12px rgba(0,0,0,0.4) !important" : "0 4px 10px rgba(0,0,0,0.35) !important";
            return `
            <div class="counting-display-card ${isRed ? "card-red" : "card-black"}"
                 style="position: relative; width: 72px; height: 104px; box-sizing: border-box; background: #ffffff !important; border: ${border}; border-radius: 8px; display: flex; flex-direction: column; justify-content: space-between; padding: 6px 7px; box-shadow: ${shadow};">
              <div style="display: flex; align-items: baseline; justify-content: flex-start; gap: 2px; line-height: 1;">
                <span class="card-val" style="font-size: 1.22rem; font-weight: 900; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${rName}</span>
                <span class="card-val" style="font-size: 0.92rem; font-weight: 700; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${sSym}</span>
              </div>
              <div class="card-val" style="font-size: 2rem; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1; text-align: center; margin: 2px 0;">${sSym}</div>
              <span class="counting-card-badge" style="font-size: 0.58rem; font-weight: 800; text-transform: uppercase; background: ${isCut ? "rgba(245,158,11,0.22)" : "rgba(0,0,0,0.06)"}; color: #000000 !important; -webkit-text-fill-color: #000000 !important; border-radius: 4px; padding: 2px 0; text-align: center; display: block; width: 100%; line-height: 1.1;">
                ${isCut ? "CUT CARD" : "KEPT"}
              </span>
            </div>
          `;
          };
          const keptCardsHtml = (keptHand || []).map((c) => renderCardBox(c, false)).join("");
          const starterCardHtml = starterCard ? renderCardBox(starterCard, true) : "";
          cardsDisplayHtml = `
          <div style="background: rgba(0,0,0,0.25); border-radius: 12px; padding: 14px; margin-bottom: 16px; border: 1px solid rgba(255,255,255,0.08);">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; flex-wrap: wrap; gap: 6px;">
              <span style="font-size: 0.88rem; font-weight: 800; color: #cbd5e1; text-transform: uppercase; letter-spacing: 0.05em;">
                Hand to Count (${(keptHand || []).length} Kept + Cut Starter)
              </span>
            </div>
            <div style="display: flex; align-items: center; justify-content: center; gap: 14px; flex-wrap: wrap;">
              <div style="display: flex; gap: 8px; flex-wrap: wrap; justify-content: center;">
                ${keptCardsHtml}
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                <span style="font-size: 0.72rem; font-weight: 800; color: #f59e0b; text-transform: uppercase; letter-spacing: 0.05em;">\u2702\uFE0F Starter</span>
                ${starterCardHtml}
              </div>
            </div>
          </div>
        `;
        }
        const renderCategoryRow = (id, label, icon, step = 2) => {
          const val = userInputs[id] !== void 0 ? userInputs[id] : 0;
          let badgeHtml = "";
          if (evalResult) {
            const res = evalResult[id];
            if (res && res.correct) {
              badgeHtml = `<span style="color: #10b981 !important; font-weight: 800; font-size: 1rem; display: inline-flex; align-items: center; gap: 4px;">\u2714 ${res.actual} pts</span>`;
            } else if (res) {
              badgeHtml = `<span style="color: #ef4444 !important; font-weight: 800; font-size: 0.85rem; display: inline-flex; align-items: center; gap: 4px;">\u2716 Entered ${res.user} (Actual: ${res.actual})</span>`;
            }
          }
          return `
          <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: rgba(0,0,0,0.2); border-radius: 8px; border: 1px solid rgba(255,255,255,0.05); gap: 10px; flex-wrap: wrap;">
            <div style="display: flex; align-items: center; gap: 8px; min-width: 110px;">
              <span style="font-size: 1.15rem;">${icon}</span>
              <span style="font-weight: 800; font-size: 0.95rem; color: #f1f5f9;">${label}</span>
            </div>
            <div style="display: flex; align-items: center; gap: 6px;">
              <button type="button" class="count-step-btn" data-cat="${id}" data-delta="-${step}" ${evalResult ? "disabled" : ""}
                      style="width: 32px; height: 32px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.2); background: rgba(255,255,255,0.1); color: #fff; font-weight: 800; font-size: 1.1rem; cursor: pointer; display: flex; align-items: center; justify-content: center; line-height: 1;">-</button>
              <input type="number" id="inputCat_${id}" class="count-input-field" data-cat="${id}" min="0" max="40" step="${step === 1 ? 1 : 2}" value="${val}" ${evalResult ? "disabled" : ""}
                     style="width: 58px; height: 32px; border-radius: 6px; border: 1.5px solid rgba(255,255,255,0.2); background: rgba(15,23,42,0.8); color: #f8fafc; font-weight: 800; font-size: 1.05rem; text-align: center; box-sizing: border-box;" />
              <button type="button" class="count-step-btn" data-cat="${id}" data-delta="${step}" ${evalResult ? "disabled" : ""}
                      style="width: 32px; height: 32px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.2); background: rgba(255,255,255,0.1); color: #fff; font-weight: 800; font-size: 1.1rem; cursor: pointer; display: flex; align-items: center; justify-content: center; line-height: 1;">+</button>
            </div>
            <div style="min-width: 140px; text-align: right;">
              ${badgeHtml}
            </div>
          </div>
        `;
        };
        let detailsHtml = "";
        if (showDetails && actualBreakdown) {
          if (!actualBreakdown.lines || !actualBreakdown.lines.length) {
            detailsHtml = `
            <div style="margin-top: 14px; padding: 12px; background: rgba(0,0,0,0.3); border-radius: 8px; border: 1px dashed rgba(255,255,255,0.15); text-align: center; color: #94a3b8; font-style: italic;">
              Zero points in this hand (19-hand).
            </div>
          `;
          } else {
            const detailRows = actualBreakdown.lines.map((ln) => {
              const cardsHtml = (ln.cards || []).map((c) => {
                const su = String(c && (c.suit || c.s || c.rawSuit) || "").toUpperCase();
                const isRed = su === "H" || su === "D" || su === "\u2665" || su === "\u2666";
                const col = isRed ? "#dc2626" : "#111827";
                const rVal = c ? c.rank !== void 0 ? c.rank : c.r !== void 0 ? c.r : 0 : 0;
                const rName = c && c.rankName || RANK_NAME && RANK_NAME[rVal] || (rVal === 1 ? "A" : rVal === 11 ? "J" : rVal === 12 ? "Q" : rVal === 13 ? "K" : String(rVal || ""));
                const sSym = suitSymbols && suitSymbols[su] || SUIT_SYM && SUIT_SYM[su] || (su === "H" ? "\u2665" : su === "D" ? "\u2666" : su === "S" ? "\u2660" : su === "C" ? "\u2663" : su);
                return `
                <span class="trainer-mini-card ${isRed ? "card-red" : "card-black"}"
                      style="display: inline-flex; align-items: center; justify-content: center; gap: 3px; padding: 2px 7px; background: #ffffff !important; color: ${col} !important; -webkit-text-fill-color: ${col} !important; border-radius: 5px; font-weight: 800; font-size: 0.88rem; border: 1.5px solid #cbd5e1; box-shadow: 0 1px 3px rgba(0,0,0,0.25); margin-right: 5px; vertical-align: middle;">
                  <span class="card-val card-rank" style="color: ${col} !important; -webkit-text-fill-color: ${col} !important; font-weight: 900; line-height: 1;">${rName}</span>
                  <span class="card-val card-suit" style="color: ${col} !important; -webkit-text-fill-color: ${col} !important; font-size: 1.05rem; line-height: 1;">${sSym}</span>
                </span>
              `;
              }).join("");
              return `
              <div style="display: flex; align-items: center; justify-content: space-between; padding: 8px 12px; background: rgba(255,255,255,0.04); border-radius: 6px; margin-bottom: 6px; flex-wrap: wrap; gap: 6px;">
                <div style="display: flex; align-items: center; gap: 6px;">
                  <span style="font-weight: 800; color: #f59e0b; font-size: 0.88rem;">+${ln.n} pts</span>
                  <span style="color: #f1f5f9; font-weight: 600; font-size: 0.86rem;">${ln.why}</span>
                </div>
                <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 4px;">${cardsHtml}</div>
              </div>
            `;
            }).join("");
            detailsHtml = `
            <div style="margin-top: 14px; padding: 14px; background: rgba(0,0,0,0.35); border-radius: 8px; border: 1px solid rgba(245,158,11,0.3);">
              <div style="font-size: 0.88rem; font-weight: 800; color: #f59e0b; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.04em;">
                \u{1F50D} Point-by-Point Score Breakdown (Total: ${actualBreakdown.total} pts)
              </div>
              ${detailRows}
            </div>
          `;
          }
        }
        let evTableHtml = "";
        if (showEvTable && discardEvalResult && discardEvalResult.analysis) {
          const { analysis, evaluation, isCorrect } = discardEvalResult;
          const totalCombos = analysis.combos.length;
          const reqDisc = getRequiredDiscards(mode);
          const renderMiniCards = (cardList) => {
            return (cardList || []).map((c) => {
              const su = String(c && (c.suit || c.s || c.rawSuit) || "").toUpperCase();
              const isRed = su === "H" || su === "D" || su === "\u2665" || su === "\u2666";
              const col = isRed ? "#dc2626" : "#111827";
              const rVal = c ? c.rank !== void 0 ? c.rank : c.r !== void 0 ? c.r : 0 : 0;
              const rName = c && c.rankName || RANK_NAME && RANK_NAME[rVal] || (rVal === 1 ? "A" : rVal === 11 ? "J" : rVal === 12 ? "Q" : rVal === 13 ? "K" : String(rVal || ""));
              const sSym = suitSymbols && suitSymbols[su] || SUIT_SYM && SUIT_SYM[su] || (su === "H" ? "\u2665" : su === "D" ? "\u2666" : su === "S" ? "\u2660" : su === "C" ? "\u2663" : su);
              return `
              <span class="trainer-mini-card ${isRed ? "card-red" : "card-black"}"
                    style="display: inline-flex; align-items: center; justify-content: center; gap: 3px; padding: 2px 7px; background: #ffffff !important; color: ${col} !important; -webkit-text-fill-color: ${col} !important; border-radius: 5px; font-weight: 800; font-size: 0.84rem; border: 1.5px solid #cbd5e1; box-shadow: 0 1px 3px rgba(0,0,0,0.25); margin-right: 4px; vertical-align: middle;">
                <span class="card-val card-rank" style="color: ${col} !important; -webkit-text-fill-color: ${col} !important; font-weight: 900; line-height: 1;">${rName}</span>
                <span class="card-val card-suit" style="color: ${col} !important; -webkit-text-fill-color: ${col} !important; font-size: 1rem; line-height: 1;">${sSym}</span>
              </span>
            `;
            }).join("");
          };
          const optimalMiniCards = renderMiniCards(evaluation.optimal.disc);
          const userMiniCards = renderMiniCards(evaluation.chosen.disc);
          const bannerHtml2 = isCorrect ? `
          <div style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; background: rgba(16,185,129,0.16); border: 1.5px solid rgba(16,185,129,0.45); border-radius: 8px; margin-bottom: 12px; flex-wrap: wrap; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 10px;">
              <span style="font-size: 1.6rem; line-height: 1;">\u{1F3C6}</span>
              <div>
                <div style="font-size: 1rem; font-weight: 900; color: #34d399; letter-spacing: 0.02em;">
                  Optimal Discard! You Discarded Correctly
                </div>
                <div style="font-size: 0.82rem; color: #d1fae5; margin-top: 2px;">
                  Your discard ${userMiniCards} achieved highest Net Expected Value (${evaluation.chosen.netEV > 0 ? "+" : ""}${evaluation.chosen.netEV.toFixed(1)} pts).
                </div>
              </div>
            </div>
            <span style="padding: 4px 12px; border-radius: 6px; background: #10b981; color: #000; font-weight: 900; font-size: 0.86rem; letter-spacing: 0.03em;">
              Rank #1 of ${totalCombos}
            </span>
          </div>
        ` : `
          <div style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; background: rgba(239,68,68,0.16); border: 1.5px solid rgba(239,68,68,0.45); border-radius: 8px; margin-bottom: 12px; flex-wrap: wrap; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 10px;">
              <span style="font-size: 1.6rem; line-height: 1;">\u26A0\uFE0F</span>
              <div>
                <div style="font-size: 1rem; font-weight: 900; color: #f87171; letter-spacing: 0.02em;">
                  Sub-Optimal Discard (-${Number(evaluation.evDiff ?? evaluation.diff ?? 0).toFixed(1)} EV Loss)
                </div>
                <div style="font-size: 0.82rem; color: #fee2e2; margin-top: 2px;">
                  You discarded: ${userMiniCards} (Rank #${evaluation.rank} of ${totalCombos}). Optimal discard was: ${optimalMiniCards} (${evaluation.optimal.netEV > 0 ? "+" : ""}${evaluation.optimal.netEV.toFixed(1)} Net EV).
                </div>
              </div>
            </div>
            <span style="padding: 4px 12px; border-radius: 6px; background: #ef4444; color: #fff; font-weight: 900; font-size: 0.86rem; letter-spacing: 0.03em;">
              Rank #${evaluation.rank} of ${totalCombos}
            </span>
          </div>
        `;
          const tableRowsHtml = analysis.combos.map((combo) => {
            const isUserPick = combo.id === evaluation.chosen.id;
            const isOptimalPick = combo.rank === 1;
            let rowBg = "transparent";
            if (isUserPick && isOptimalPick) rowBg = "rgba(16, 185, 129, 0.2)";
            else if (isUserPick) rowBg = "rgba(240, 198, 74, 0.18)";
            else if (isOptimalPick) rowBg = "rgba(16, 185, 129, 0.12)";
            const discMiniHtml = renderMiniCards(combo.disc);
            const keepMiniHtml = renderMiniCards(combo.keep);
            return `
            <tr style="background: ${rowBg}; border-bottom: 1px solid rgba(255,255,255,0.06); font-size: 0.82rem;">
              <td style="padding: 6px 8px; font-weight: 800; color: ${isOptimalPick ? "#10b981" : isUserPick ? "#f0c64a" : "#a8a29e"}; text-align: center;">
                ${combo.rank}${isOptimalPick ? " \u2605" : ""}${isUserPick ? " \u{1F448}" : ""}
              </td>
              <td style="padding: 6px 8px; white-space: nowrap;">${discMiniHtml}</td>
              <td style="padding: 6px 8px; white-space: nowrap;">${keepMiniHtml}</td>
              <td style="padding: 6px 8px; text-align: center; color: #e7e5e4;">
                <span style="font-weight: 700;">${combo.handEV.toFixed(1)}</span>
                <span style="font-size: 0.72rem; color: #78716c; margin-left: 4px;">(${combo.handMin}\u2013${combo.handMax})</span>
              </td>
              <td style="padding: 6px 8px; text-align: center; color: #a8a29e;">${combo.cribEV.toFixed(1)}</td>
              <td style="padding: 6px 8px; text-align: center; font-weight: 800; color: ${isOptimalPick ? "#10b981" : "#f4ead4"};">
                ${combo.netEV > 0 ? "+" : ""}${combo.netEV.toFixed(1)}
              </td>
              <td style="padding: 6px 8px; text-align: center; font-size: 0.76rem; color: ${combo.evDiff === 0 ? "#10b981" : "#f87171"};">
                ${combo.evDiff === 0 ? "0.0" : `-${combo.evDiff.toFixed(1)}`}
              </td>
            </tr>
          `;
          }).join("");
          evTableHtml = `
          <div style="margin-top: 14px; padding: 14px; background: rgba(0,0,0,0.38); border-radius: 10px; border: 1.5px solid rgba(245,158,11,0.35);">
            <div style="font-size: 0.88rem; font-weight: 800; color: #f59e0b; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.04em;">
              \u{1F4CA} Statistical Discard Expected Value (EV) Table (${totalCombos} Combinations)
            </div>
            ${bannerHtml2}
            ${evaluation.tips && evaluation.tips.length ? `
              <div style="margin-bottom: 12px; padding: 8px 12px; background: rgba(240,198,74,0.08); border-left: 3px solid #f0c64a; border-radius: 4px; font-size: 0.82rem; color: #fef08a; line-height: 1.45;">
                ${evaluation.tips.map((t) => `<div>${t}</div>`).join("")}
              </div>
            ` : ""}
            <div style="max-height: 250px; overflow-y: auto; border: 1px solid rgba(255,255,255,0.08); border-radius: 8px;">
              <table style="width: 100%; border-collapse: collapse; text-align: left; font-family: inherit;">
                <thead>
                  <tr style="background: rgba(0,0,0,0.6); border-bottom: 1px solid rgba(255,255,255,0.15); font-size: 0.74rem; text-transform: uppercase; letter-spacing: 0.05em; color: #a8a29e;">
                    <th style="padding: 6px 8px; text-align: center;">Rank</th>
                    <th style="padding: 6px 8px;">Discard (${reqDisc})</th>
                    <th style="padding: 6px 8px;">Keep (${mode - reqDisc})</th>
                    <th style="padding: 6px 8px; text-align: center;">Hand EV (Min\u2013Max)</th>
                    <th style="padding: 6px 8px; text-align: center;">Crib EV</th>
                    <th style="padding: 6px 8px; text-align: center;">Net Score</th>
                    <th style="padding: 6px 8px; text-align: center;">Loss</th>
                  </tr>
                </thead>
                <tbody>
                  ${tableRowsHtml}
                </tbody>
              </table>
            </div>
          </div>
        `;
        }
        let customFormHtml = "";
        if (showCustomForm) {
          customFormHtml = `
          <div style="margin-bottom: 16px; padding: 14px; background: rgba(15,23,42,0.85); border-radius: 10px; border: 1px solid rgba(56,189,248,0.4);">
            <div style="font-weight: 800; font-size: 0.92rem; color: #38bdf8; margin-bottom: 6px;">
              \u270F\uFE0F Enter Custom Hand to Count
            </div>
            <div style="font-size: 0.82rem; color: #cbd5e1; margin-bottom: 8px; line-height: 1.45;">
              Enter <strong>5 cards</strong> (4 hand cards + 1 cut card) or <strong>7 cards</strong> (6 hand cards + 1 cut card).<br/>
              The <strong>last card</strong> is always the starter cut card.<br/>
              <span style="color: #94a3b8; font-size: 0.78rem;">Examples: <code>5H 5D 5S JC 5C</code> or <code>5H 5D 5S JC 7H 8D 5C</code> (optional <code>+</code> before cut card also accepted)</span>
            </div>
            <div style="display: flex; gap: 8px; flex-wrap: wrap;">
              <input type="text" id="countingCustomHandInput" placeholder="e.g. 5H 5D 5S JC 5C"
                     style="flex: 1; min-width: 200px; padding: 8px 12px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.2); background: rgba(0,0,0,0.4); color: #fff; font-family: monospace; font-size: 0.95rem;" />
              <button type="button" id="btnCountingLoadCustom" class="btn-primary" style="padding: 8px 16px; font-weight: 800; font-size: 0.88rem; border-radius: 6px; background: #0284c7; color: #fff; border: none; cursor: pointer;">
                Count Hand
              </button>
              <button type="button" id="btnCountingCancelCustom" style="padding: 8px 12px; font-weight: 700; font-size: 0.85rem; border-radius: 6px; background: transparent; border: 1px solid rgba(255,255,255,0.2); color: #cbd5e1; cursor: pointer;">
                Cancel
              </button>
            </div>
            ${customError ? `<div style="color: #ef4444; font-size: 0.82rem; font-weight: 700; margin-top: 6px;">${customError}</div>` : ""}
          </div>
        `;
        }
        let bannerHtml = "";
        if (evalResult) {
          if (evalResult.isAllCorrect) {
            bannerHtml = `
            <div style="margin-bottom: 14px; padding: 12px 16px; border-radius: 8px; background: rgba(16,185,129,0.2); border: 1px solid rgba(16,185,129,0.5); display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;">
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="font-size: 1.4rem;">\u{1F389}</span>
                <span style="font-weight: 800; color: #34d399; font-size: 1rem;">Perfect Count! All categories correct (+${evalResult.total.actual} pts).</span>
              </div>
              <span style="font-size: 0.82rem; font-weight: 800; padding: 3px 8px; border-radius: 12px; background: #10b981; color: #000;">STREAK: ${career.currentStreak} \u{1F525}</span>
            </div>
          `;
          } else {
            bannerHtml = `
            <div style="margin-bottom: 14px; padding: 12px 16px; border-radius: 8px; background: rgba(239,68,68,0.2); border: 1px solid rgba(239,68,68,0.5); display: flex; align-items: center; gap: 8px;">
              <span style="font-size: 1.4rem;">\u274C</span>
              <span style="font-weight: 800; color: #f87171; font-size: 0.95rem;">Not quite! Review the red marks below. Actual Total: ${evalResult.total.actual} pts.</span>
            </div>
          `;
          }
        }
        let totalBadgeHtml = "";
        if (evalResult) {
          if (evalResult.total.correct) {
            totalBadgeHtml = `<span style="color: #10b981 !important; font-weight: 900; font-size: 1.15rem;">\u2714 ${evalResult.total.actual} pts</span>`;
          } else {
            totalBadgeHtml = `<span style="color: #ef4444 !important; font-weight: 900; font-size: 0.95rem;">\u2716 Entered ${evalResult.total.user} (Actual: ${evalResult.total.actual})</span>`;
          }
        }
        const totalRowHtml = `
        <div style="margin-top: 12px; padding: 12px 16px; background: rgba(15,23,42,0.6); border-radius: 8px; border: 2px solid ${evalResult ? evalResult.total.correct ? "#10b981" : "#ef4444" : "rgba(52,211,153,0.4)"}; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="font-size: 1.25rem;">\u{1F9EE}</span>
            <span style="font-weight: 900; font-size: 1.1rem; color: #f8fafc; letter-spacing: 0.03em;">TOTAL:</span>
            <span id="countingLiveTotalDisplay" style="font-weight: 900; font-size: 1.35rem; color: #34d399; margin-left: 4px;">${currentLiveTotal}</span>
            <span style="font-size: 0.85rem; color: #94a3b8; font-weight: 600;">pts</span>
          </div>
          <div>
            ${totalBadgeHtml}
          </div>
        </div>
      `;
        const toastHtml = toastMessage ? `
        <div style="margin-bottom: 12px; padding: 8px 14px; background: rgba(56,189,248,0.2); border: 1px solid rgba(56,189,248,0.5); border-radius: 6px; color: #38bdf8; font-weight: 700; font-size: 0.85rem; text-align: center;">
          ${toastMessage}
        </div>
      ` : "";
        const cardsToShare = phase === "counting" && keptHand ? keptHand : dealtHand || [];
        const starterToShare = phase === "counting" ? starterCard : null;
        currentShareText = cardsToShare && cardsToShare.length ? CountingTrainer.generateShareText(cardsToShare, starterToShare, mode) : "";
        currentShareUrl = cardsToShare && cardsToShare.length ? CountingTrainer.encodeShareUrl(cardsToShare, starterToShare, mode) : "";
        let sharePanelHtml = "";
        if (showSharePanel && currentShareText) {
          const canNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";
          sharePanelHtml = `
          <div id="countingSharePanel" style="margin-top: 14px; padding: 14px; background: rgba(15,23,42,0.92); border-radius: 10px; border: 1.5px solid rgba(56,189,248,0.45); box-shadow: 0 4px 14px rgba(0,0,0,0.4);">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
              <div style="font-weight: 800; font-size: 0.95rem; color: #38bdf8; display: flex; align-items: center; gap: 6px;">
                \u{1F517} Share Counting Challenge
              </div>
              <button type="button" id="btnCountingCloseShare" style="background: none; border: none; color: #94a3b8; font-size: 1.1rem; cursor: pointer; padding: 2px 6px;" title="Close share panel">\u2715</button>
            </div>

            <div style="font-size: 0.82rem; color: #cbd5e1; margin-bottom: 12px; line-height: 1.45;">
              Share this challenge link with friends or your cribbage club! Anyone opening the link will load this exact hand to count.
            </div>

            <div style="margin-bottom: 12px;">
              <label style="display: block; font-size: 0.74rem; font-weight: 700; color: #94a3b8; text-transform: uppercase; margin-bottom: 4px;">Challenge URL</label>
              <div style="display: flex; gap: 8px;">
                <input type="text" readonly id="countingShareUrlInput" value="${currentShareUrl}"
                       style="flex: 1; min-width: 0; padding: 8px 10px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.2); background: rgba(0,0,0,0.5); color: #38bdf8; font-family: monospace; font-size: 0.84rem;" />
                <button type="button" id="btnCountingCopyUrl" style="padding: 8px 14px; font-weight: 800; font-size: 0.82rem; border-radius: 6px; background: #0284c7; color: #fff; border: none; cursor: pointer; white-space: nowrap;">
                  \u{1F4CB} Copy Link
                </button>
              </div>
            </div>

            <div style="margin-bottom: 10px;">
              <label style="display: block; font-size: 0.74rem; font-weight: 700; color: #94a3b8; text-transform: uppercase; margin-bottom: 4px;">Formatted Challenge Message</label>
              <div style="display: flex; flex-direction: column; gap: 8px;">
                <textarea readonly id="countingShareTextInput" rows="4"
                          style="width: 100%; box-sizing: border-box; padding: 8px 10px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.2); background: rgba(0,0,0,0.5); color: #e2e8f0; font-size: 0.82rem; resize: none; font-family: inherit; line-height: 1.4;">${currentShareText}</textarea>
                <div style="display: flex; gap: 8px; justify-content: flex-end; flex-wrap: wrap;">
                  ${canNativeShare ? `
                    <button type="button" id="btnCountingNativeShare" style="padding: 8px 14px; font-weight: 800; font-size: 0.82rem; border-radius: 6px; background: rgba(56,189,248,0.2); border: 1px solid #38bdf8; color: #38bdf8; cursor: pointer;">
                      \u{1F4F1} Device Share...
                    </button>
                  ` : ""}
                  <button type="button" id="btnCountingCopyText" style="padding: 8px 14px; font-weight: 800; font-size: 0.82rem; border-radius: 6px; background: #0284c7; color: #fff; border: none; cursor: pointer; white-space: nowrap;">
                    \u{1F4CB} Copy Message
                  </button>
                </div>
              </div>
            </div>

            ${shareCopiedNotice ? `
              <div style="padding: 7px 12px; background: rgba(16,185,129,0.2); border: 1px solid rgba(16,185,129,0.5); border-radius: 6px; color: #34d399; font-weight: 700; font-size: 0.84rem; text-align: center; margin-top: 8px;">
                ${shareCopiedNotice}
              </div>
            ` : ""}
          </div>
        `;
        }
        const modalHtml = `
        <div class="counting-trainer-modal" style="max-width: 660px; width: 100%; box-sizing: border-box; font-family: inherit; color: #f8fafc;">
          <!-- Header -->
          <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1.5px solid rgba(255,255,255,0.1); padding-bottom: 12px; margin-bottom: 14px; flex-wrap: wrap; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 10px;">
              <span style="font-size: 1.6rem;">\u{1F9EE}</span>
              <div>
                <h2 style="margin: 0; font-size: 1.3rem; font-weight: 900; color: #34d399; letter-spacing: 0.03em; line-height: 1.2;">
                  COUNTING TRAINER
                </h2>
                <span style="font-size: 0.78rem; color: #94a3b8; font-weight: 600;">
                  Master hand scoring under pressure
                </span>
              </div>
            </div>
            <!-- Mode Switcher -->
            <div style="display: flex; gap: 4px; background: rgba(0,0,0,0.4); padding: 3px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.1);">
              <button type="button" id="btnCountingMode6" style="padding: 5px 12px; font-weight: 800; font-size: 0.78rem; border-radius: 6px; border: none; cursor: pointer; background: ${mode === 6 ? "#34d399" : "transparent"}; color: ${mode === 6 ? "#0f172a" : "#cbd5e1"};">
                6 Cards (Keep 4)
              </button>
              <button type="button" id="btnCountingMode9" style="padding: 5px 12px; font-weight: 800; font-size: 0.78rem; border-radius: 6px; border: none; cursor: pointer; background: ${mode === 9 ? "#34d399" : "transparent"}; color: ${mode === 9 ? "#0f172a" : "#cbd5e1"};">
                9 Cards (Keep 6)
              </button>
            </div>
          </div>

          <!-- Stats Bar -->
          <div style="display: flex; justify-content: space-between; align-items: center; background: rgba(0,0,0,0.35); border-radius: 8px; padding: 8px 14px; margin-bottom: 14px; border: 1px solid rgba(255,255,255,0.08); flex-wrap: wrap; gap: 8px;">
            <div style="display: flex; gap: 14px; align-items: center; flex-wrap: wrap; font-size: 0.82rem;">
              <span>Hands: <strong style="color: #fff;">${career.handsPlayed}</strong></span>
              <span>Correct: <strong style="color: #34d399;">${career.handsCorrect}</strong></span>
              <span>Wrong: <strong style="color: #f87171;">${career.handsWrong}</strong></span>
              <span>Accuracy: <strong style="color: #38bdf8;">${career.accuracyPct}%</strong></span>
              <span>Streak: <strong style="color: #f59e0b;">\u{1F525} ${career.currentStreak}</strong> (Best: ${career.bestStreak})</span>
            </div>
            <button type="button" id="btnCountingResetStats" style="background: none; border: none; color: #94a3b8; font-size: 0.74rem; cursor: pointer; text-decoration: underline;">
              Reset Stats
            </button>
          </div>

          ${toastHtml}
          ${customFormHtml}
          ${bannerHtml}
          ${cardsDisplayHtml}

          <!-- Counting Phase Form -->
          ${phase === "counting" ? `
            <div style="background: rgba(0,0,0,0.25); border-radius: 12px; padding: 14px; border: 1px solid rgba(255,255,255,0.08); margin-bottom: 14px;">
              <div style="font-size: 0.88rem; font-weight: 800; color: #cbd5e1; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.04em;">
                Enter Your Point Counts:
              </div>
              <div style="display: flex; flex-direction: column; gap: 8px;">
                ${renderCategoryRow("fifteens", "15's", "\u{1F3AF}", 2)}
                ${renderCategoryRow("pairs", "Pairs", "\u{1F465}", 2)}
                ${renderCategoryRow("runs", "Runs", "\u{1F3C3}", 1)}
                ${renderCategoryRow("flush", "Flush", "\u{1F30A}", 1)}
                ${renderCategoryRow("nobs", "Nobs", "\u{1F451}", 1)}
              </div>
              ${totalRowHtml}
            </div>

            <!-- Action Controls -->
            <div style="display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 12px;">
              <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                ${!evalResult ? `
                  <button type="button" id="btnCountingCheckScore" class="btn-primary"
                          style="padding: 10px 22px; font-weight: 800; font-size: 0.95rem; border-radius: 8px; background: linear-gradient(135deg, #10b981, #059669); color: #fff; border: none; cursor: pointer; box-shadow: 0 4px 12px rgba(16,185,129,0.4);">
                    \u{1F50D} Check Score
                  </button>
                ` : `
                  <button type="button" id="btnCountingNextHand" class="btn-primary"
                          style="padding: 10px 22px; font-weight: 800; font-size: 0.95rem; border-radius: 8px; background: linear-gradient(135deg, #3b82f6, #2563eb); color: #fff; border: none; cursor: pointer; box-shadow: 0 4px 12px rgba(59,130,246,0.4);">
                    \u27A1\uFE0F Next Hand
                  </button>
                `}
                <button type="button" id="btnCountingToggleDetails"
                        style="padding: 9px 14px; font-weight: 700; font-size: 0.86rem; border-radius: 8px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.18); color: #cbd5e1; cursor: pointer;">
                  ${showDetails ? "\u{1F648} Hide Point Details" : "\u{1F441}\uFE0F Show Point Details"}
                </button>
                ${discardEvalResult ? `
                  <button type="button" id="btnCountingToggleEvTable"
                          style="padding: 9px 14px; font-weight: 700; font-size: 0.86rem; border-radius: 8px; background: ${showEvTable ? "rgba(245,158,11,0.22)" : "rgba(255,255,255,0.08)"}; border: 1px solid ${showEvTable ? "#f59e0b" : "rgba(255,255,255,0.18)"}; color: ${showEvTable ? "#fbbf24" : "#cbd5e1"}; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;">
                    ${showEvTable ? "\u{1F4CA} Hide EV Table" : "\u{1F4CA} Show EV Table"}
                    <span style="font-size: 0.72rem; padding: 2px 7px; border-radius: 10px; font-weight: 900; background: ${discardEvalResult.isCorrect ? "#10b981" : "#ef4444"}; color: #fff;">
                      ${discardEvalResult.isCorrect ? "\u2714 Optimal" : `\u2716 Rank #${discardEvalResult.evaluation.rank}`}
                    </span>
                  </button>
                ` : ""}
              </div>

              <div style="display: flex; gap: 6px;">
                <button type="button" id="btnCountingShareHand" title="Share this hand challenge"
                        style="padding: 9px 13px; font-weight: 700; font-size: 0.84rem; border-radius: 8px; background: rgba(56,189,248,0.12); border: 1px solid rgba(56,189,248,0.35); color: #38bdf8; cursor: pointer; display: inline-flex; align-items: center; gap: 4px;">
                  \u{1F517} Share
                </button>
                <button type="button" id="btnCountingToggleCustom" title="Enter custom hand"
                        style="padding: 9px 13px; font-weight: 700; font-size: 0.84rem; border-radius: 8px; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.18); color: #cbd5e1; cursor: pointer;">
                  \u270F\uFE0F Custom Hand
                </button>
              </div>
            </div>
            ${detailsHtml}
            ${evTableHtml}
            ${sharePanelHtml}
          ` : `
            <!-- In Discard Phase, secondary options -->
            <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 10px; flex-wrap: wrap;">
              <button type="button" id="btnCountingShareHand" title="Share this hand challenge"
                      style="padding: 8px 14px; font-weight: 700; font-size: 0.84rem; border-radius: 8px; background: rgba(56,189,248,0.12); border: 1px solid rgba(56,189,248,0.35); color: #38bdf8; cursor: pointer; display: inline-flex; align-items: center; gap: 4px;">
                \u{1F517} Share
              </button>
              <button type="button" id="btnCountingNewDeal"
                      style="padding: 8px 14px; font-weight: 700; font-size: 0.84rem; border-radius: 8px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.18); color: #cbd5e1; cursor: pointer;">
                \u{1F3B2} Redeal
              </button>
              <button type="button" id="btnCountingToggleCustom"
                      style="padding: 8px 14px; font-weight: 700; font-size: 0.84rem; border-radius: 8px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.18); color: #cbd5e1; cursor: pointer;">
                \u270F\uFE0F Custom Hand
              </button>
            </div>
            ${sharePanelHtml}
          `}
        </div>
      `;
        this.showModal(modalHtml, true);
        bindCountingEvents();
      };
      const bindCountingEvents = () => {
        const modalEl = document.getElementById("modal") || document;
        const getEl = (id) => modalEl.querySelector("#" + id);
        const btnMode6 = getEl("btnCountingMode6");
        const btnMode9 = getEl("btnCountingMode9");
        if (btnMode6) btnMode6.onclick = () => {
          if (mode !== 6) startNewHand(6);
        };
        if (btnMode9) btnMode9.onclick = () => {
          if (mode !== 9) startNewHand(9);
        };
        const btnResetStats = getEl("btnCountingResetStats");
        if (btnResetStats) {
          btnResetStats.onclick = () => {
            if (confirm("Reset your Counting Trainer statistics?")) {
              CountingTrainer.resetStats({ career: true, storage: context.storage });
              renderCountingTrainer();
            }
          };
        }
        if (phase === "discard") {
          const requiredDiscards = getRequiredDiscards(mode);
          const cardBtns = modalEl.querySelectorAll(".counting-card-btn");
          cardBtns.forEach((btn) => {
            btn.onclick = () => {
              const idx = parseInt(btn.dataset.idx, 10);
              if (selectedIndices.has(idx)) {
                selectedIndices.delete(idx);
              } else {
                if (selectedIndices.size >= requiredDiscards) {
                  const first = selectedIndices.values().next().value;
                  selectedIndices.delete(first);
                }
                selectedIndices.add(idx);
              }
              renderCountingTrainer();
            };
          });
          const btnCut = getEl("btnCountingCutStarter");
          if (btnCut) {
            btnCut.onclick = () => {
              if (selectedIndices.size !== requiredDiscards) return;
              userDiscardedCards = CountingTrainer.sortCards(dealtHand.filter((_, idx) => selectedIndices.has(idx)));
              originalDealtHand = dealtHand.slice();
              keptHand = CountingTrainer.sortCards(dealtHand.filter((_, idx) => !selectedIndices.has(idx)));
              starterCard = CountingTrainer.cutStarterCard(dealtHand);
              phase = "counting";
              actualBreakdown = CountingTrainer.scoreCountedHand(keptHand, starterCard, false);
              evalResult = null;
              userInputs = { fifteens: 0, pairs: 0, runs: 0, flush: 0, nobs: 0 };
              showDetails = false;
              showEvTable = false;
              showSharePanel = false;
              shareCopiedNotice = "";
              if (originalDealtHand && userDiscardedCards) {
                discardEvalResult = CountingTrainer.analyzeDiscards(originalDealtHand, userDiscardedCards, true);
              }
              renderCountingTrainer();
            };
          }
          const btnNewDeal = getEl("btnCountingNewDeal");
          if (btnNewDeal) btnNewDeal.onclick = () => startNewHand(mode);
        }
        if (phase === "counting") {
          const updateLiveTotal = () => {
            const tot = (Number(userInputs.fifteens) || 0) + (Number(userInputs.pairs) || 0) + (Number(userInputs.runs) || 0) + (Number(userInputs.flush) || 0) + (Number(userInputs.nobs) || 0);
            const liveTotEl = getEl("countingLiveTotalDisplay");
            if (liveTotEl) liveTotEl.textContent = String(tot);
          };
          const stepBtns = modalEl.querySelectorAll(".count-step-btn");
          stepBtns.forEach((btn) => {
            btn.onclick = () => {
              const cat = btn.dataset.cat;
              const delta = parseInt(btn.dataset.delta, 10) || 0;
              const cur = Number(userInputs[cat]) || 0;
              const next = Math.max(0, cur + delta);
              userInputs[cat] = next;
              const inp = getEl(`inputCat_${cat}`);
              if (inp) inp.value = String(next);
              updateLiveTotal();
            };
          });
          const inputs = modalEl.querySelectorAll(".count-input-field");
          inputs.forEach((inp) => {
            inp.oninput = () => {
              const cat = inp.dataset.cat;
              const v = Math.max(0, parseInt(inp.value, 10) || 0);
              userInputs[cat] = v;
              updateLiveTotal();
            };
          });
          const btnCheck = getEl("btnCountingCheckScore");
          if (btnCheck) {
            btnCheck.onclick = () => {
              evalResult = CountingTrainer.evaluateUserCount(actualBreakdown, userInputs);
              CountingTrainer.recordPlay({ isCorrect: evalResult.isAllCorrect }, context.storage);
              renderCountingTrainer();
            };
          }
          const btnNext = getEl("btnCountingNextHand");
          if (btnNext) btnNext.onclick = () => startNewHand(mode);
          const btnDetails = getEl("btnCountingToggleDetails");
          if (btnDetails) {
            btnDetails.onclick = () => {
              showDetails = !showDetails;
              renderCountingTrainer();
            };
          }
          const btnToggleEv = getEl("btnCountingToggleEvTable");
          if (btnToggleEv) {
            btnToggleEv.onclick = () => {
              showEvTable = !showEvTable;
              renderCountingTrainer();
            };
          }
        }
        const btnShare = getEl("btnCountingShareHand");
        if (btnShare) {
          btnShare.onclick = async () => {
            showSharePanel = !showSharePanel;
            if (showSharePanel) {
              const ok = await copyTextToClipboard(currentShareText);
              shareCopiedNotice = ok ? "\u2714 Challenge copied to clipboard!" : "Challenge ready in Share Panel below.";
              toastMessage = ok ? "\u2714 Challenge copied to clipboard!" : "Challenge ready in Share Panel below.";
            } else {
              shareCopiedNotice = "";
              toastMessage = "";
            }
            renderCountingTrainer();
          };
        }
        const btnCloseShare = getEl("btnCountingCloseShare");
        if (btnCloseShare) {
          btnCloseShare.onclick = () => {
            showSharePanel = false;
            shareCopiedNotice = "";
            renderCountingTrainer();
          };
        }
        const btnCopyUrl = getEl("btnCountingCopyUrl");
        if (btnCopyUrl) {
          btnCopyUrl.onclick = async () => {
            const input = getEl("countingShareUrlInput");
            const val = input ? input.value : currentShareUrl;
            if (input) input.select();
            await copyTextToClipboard(val);
            btnCopyUrl.textContent = "\u2714 Copied!";
            setTimeout(() => {
              if (btnCopyUrl) btnCopyUrl.textContent = "\u{1F4CB} Copy Link";
            }, 2e3);
          };
        }
        const btnCopyText = getEl("btnCountingCopyText");
        if (btnCopyText) {
          btnCopyText.onclick = async () => {
            const ta = getEl("countingShareTextInput");
            const val = ta ? ta.value : currentShareText;
            if (ta) ta.select();
            await copyTextToClipboard(val);
            btnCopyText.textContent = "\u2714 Copied!";
            setTimeout(() => {
              if (btnCopyText) btnCopyText.textContent = "\u{1F4CB} Copy Message";
            }, 2e3);
          };
        }
        const btnNativeShare = getEl("btnCountingNativeShare");
        if (btnNativeShare) {
          btnNativeShare.onclick = () => {
            if (typeof navigator !== "undefined" && navigator.share) {
              navigator.share({
                title: "Crazy Cribbage Counting Challenge",
                text: currentShareText,
                url: currentShareUrl
              }).catch(() => {
              });
            }
          };
        }
        const btnToggleCust = getEl("btnCountingToggleCustom");
        if (btnToggleCust) {
          btnToggleCust.onclick = () => {
            showCustomForm = !showCustomForm;
            customError = "";
            renderCountingTrainer();
          };
        }
        const btnCancelCust = getEl("btnCountingCancelCustom");
        if (btnCancelCust) {
          btnCancelCust.onclick = () => {
            showCustomForm = false;
            customError = "";
            renderCountingTrainer();
          };
        }
        const btnLoadCust = getEl("btnCountingLoadCustom");
        if (btnLoadCust) {
          btnLoadCust.onclick = () => {
            const inp = getEl("countingCustomHandInput");
            const val = inp ? inp.value.trim() : "";
            const parsed = CountingTrainer.parseCustomHand(val, mode);
            if (!parsed || !parsed.isComplete) {
              customError = "Please enter 5 cards (4 in hand + 1 cut card) or 7 cards (6 in hand + 1 cut card). The last card will be the cut card. E.g. 5H 5D 5S JC 5C";
              renderCountingTrainer();
              return;
            }
            mode = parsed.mode;
            keptHand = parsed.cards;
            starterCard = parsed.starter;
            phase = "counting";
            actualBreakdown = CountingTrainer.scoreCountedHand(keptHand, starterCard, false);
            userDiscardedCards = null;
            originalDealtHand = null;
            discardEvalResult = null;
            showEvTable = false;
            showCustomForm = false;
            customError = "";
            evalResult = null;
            userInputs = { fifteens: 0, pairs: 0, runs: 0, flush: 0, nobs: 0 };
            showDetails = false;
            renderCountingTrainer();
          };
        }
      };
      renderCountingTrainer();
    }
    /**
     * Displays the End-of-Game "Coach's Post-Mortem" & Match Accuracy Rating modal.
     * @param {Object} [context]
     */
    showCoachPostMortemModal(context = {}) {
      const report = CoachPostMortem.analyzeMatch(context);
      const html2 = CoachPostMortem.buildPostMortemHtml(report);
      this.showModal(html2, {
        showClose: true,
        onClose: () => {
          if (typeof window !== "undefined" && typeof window.showGameWonModal === "function" && window.showGameWonModal()) {
            return;
          }
          if (typeof this.showGameWonModal === "function" && this.showGameWonModal()) {
            return;
          }
          this.hideModal();
        }
      });
      if (typeof CoachPostMortem !== "undefined" && typeof CoachPostMortem.bindEvents === "function" && typeof document !== "undefined") {
        const modalEl = document.getElementById("modal");
        CoachPostMortem.bindEvents(modalEl || document);
      }
    }
    /**
     * Displays the Coach's Match Post-Mortem Share Dialog.
     * @param {Object} [report]
     */
    showCoachPostMortemShareModal(report) {
      return CoachPostMortem.openShareDialog(report);
    }
    shareCoachPostMortem(report) {
      return CoachPostMortem.openShareDialog(report);
    }
    /**
     * Displays the Daily Puzzle ("Hand of the Day") modal.
     * Features:
     * 1. Daily Discard Challenge (Seeded 6-card hand, EV evaluation against optimal).
     * 2. Daily Pegging Scenario (Tactical endgame problem with count explanation).
     * 3. Streaks & Stats (Consecutive day counter, win %, Wordle-style share).
     */
    showDailyPuzzleModal(context = {}) {
      if (typeof document === "undefined") return;
      const dateKey = context.dateKey || DailyPuzzleManager.getDailyDateKey();
      const dayNumber = DailyPuzzleManager.getDayNumber(dateKey);
      const dateFormatted = (/* @__PURE__ */ new Date(`${dateKey}T12:00:00`)).toLocaleDateString(void 0, {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric"
      });
      const { hand: dailyHand, isDealer: dailyIsDealer } = DailyPuzzleManager.getDailyHand(dateKey);
      const peggingScenario = DailyPuzzleManager.getDailyPeggingScenario(dateKey);
      let stats = DailyPuzzleManager.loadStats();
      let todayHistory = stats.history[dateKey] || {};
      let activeTab = context.tab || (todayHistory.discard && !todayHistory.pegging ? "pegging" : "discard");
      let selectedDiscardIndices = /* @__PURE__ */ new Set();
      let discardEvalResult = todayHistory.discard || null;
      let selectedPeggingCardId = todayHistory.pegging ? todayHistory.pegging.chosenCardId : null;
      let peggingEvalResult = todayHistory.pegging || null;
      let copyToastMessage = "";
      const suitSymbols = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const render2 = () => {
        stats = DailyPuzzleManager.loadStats();
        todayHistory = stats.history[dateKey] || {};
        const tabsHtml = `
        <div class="daily-puzzle-tabs" style="display: flex; gap: 8px; justify-content: center; margin-bottom: 18px; border-bottom: 1px solid rgba(240,198,74,0.25); padding-bottom: 12px; flex-wrap: wrap;">
          <button type="button" id="tabBtnDiscard" class="daily-tab-btn ${activeTab === "discard" ? "active" : ""}"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 20px; font-weight: 800; font-size: 0.88rem; cursor: pointer; border: 1.5px solid ${activeTab === "discard" ? "#f0c64a" : "rgba(255,255,255,0.18)"}; background: ${activeTab === "discard" ? "rgba(240,198,74,0.2)" : "rgba(255,255,255,0.05)"}; color: ${activeTab === "discard" ? "#f0c64a" : "#d6d3d1"}; transition: all 0.15s ease;">
            <span>\u{1F0CF} Daily Discard</span>
            ${todayHistory.discard ? '<span style="color: #22c55e; font-size: 0.85rem;">\u2714</span>' : ""}
          </button>
          <button type="button" id="tabBtnPegging" class="daily-tab-btn ${activeTab === "pegging" ? "active" : ""}"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 20px; font-weight: 800; font-size: 0.88rem; cursor: pointer; border: 1.5px solid ${activeTab === "pegging" ? "#f0c64a" : "rgba(255,255,255,0.18)"}; background: ${activeTab === "pegging" ? "rgba(240,198,74,0.2)" : "rgba(255,255,255,0.05)"}; color: ${activeTab === "pegging" ? "#f0c64a" : "#d6d3d1"}; transition: all 0.15s ease;">
            <span>\u26A1 Daily Pegging</span>
            ${todayHistory.pegging ? todayHistory.pegging.isCorrect ? '<span style="color: #22c55e; font-size: 0.85rem;">\u2714</span>' : '<span style="color: #ef4444; font-size: 0.85rem;">\u274C</span>' : ""}
          </button>
          <button type="button" id="tabBtnStats" class="daily-tab-btn ${activeTab === "stats" ? "active" : ""}"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 20px; font-weight: 800; font-size: 0.88rem; cursor: pointer; border: 1.5px solid ${activeTab === "stats" ? "#f0c64a" : "rgba(255,255,255,0.18)"}; background: ${activeTab === "stats" ? "rgba(240,198,74,0.2)" : "rgba(255,255,255,0.05)"}; color: ${activeTab === "stats" ? "#f0c64a" : "#d6d3d1"}; transition: all 0.15s ease;">
            <span>\u{1F3C6} Streaks &amp; Stats</span>
            ${stats.currentStreak > 0 ? `<span style="background: rgba(240,198,74,0.25); color: #f0c64a; padding: 1px 6px; border-radius: 10px; font-size: 0.75rem;">${stats.currentStreak}\u{1F525}</span>` : ""}
          </button>
        </div>
      `;
        let tabContentHtml = "";
        if (activeTab === "discard") {
          const roleBadge = dailyIsDealer ? `<span style="background: rgba(240,198,74,0.18); color: #f0c64a; border: 1px solid rgba(240,198,74,0.4); padding: 4px 12px; border-radius: 14px; font-size: 0.82rem; font-weight: 700;">\u{1F451} DEALER (Your Crib)</span>` : `<span style="background: rgba(96,165,250,0.18); color: #93c5fd; border: 1px solid rgba(96,165,250,0.4); padding: 4px 12px; border-radius: 14px; font-size: 0.82rem; font-weight: 700;">\u{1F6E1}\uFE0F PONE (Opponent Crib)</span>`;
          const cardsHtml = dailyHand.map((c, idx) => {
            const isRed = c.suit === "H" || c.suit === "D";
            const sel = selectedDiscardIndices.has(idx) || discardEvalResult && discardEvalResult.userCombo && discardEvalResult.userCombo.disc.some((d) => d.id === c.id);
            const textColor = isRed ? "#dc2626 !important" : "#111827 !important";
            const isLocked = !!discardEvalResult;
            return `
            <button type="button" class="trainer-card-btn ${sel ? "selected" : ""} ${isRed ? "card-red" : "card-black"}" data-idx="${idx}"
                    style="position: relative; width: 72px; height: 104px; box-sizing: border-box; background: #ffffff !important; border: ${sel ? "3px solid #eab308 !important" : "2px solid #cbd5e1 !important"}; border-radius: 8px; cursor: ${isLocked ? "default" : "pointer"}; display: flex; flex-direction: column; justify-content: space-between; padding: 6px 7px; box-shadow: ${sel ? "0 0 0 2px #ca8a04, 0 8px 18px rgba(234,179,8,0.45) !important" : "0 4px 10px rgba(0,0,0,0.35), 0 1px 3px rgba(0,0,0,0.15) !important"}; transform: ${sel ? "translateY(-3px)" : "none"}; transition: all 0.15s ease;"
                    title="${c.rankName || c.rank}${c.suit}">
              <div style="display: flex; align-items: baseline; justify-content: flex-start; gap: 2px; line-height: 1;">
                <span class="card-val" style="font-size: 1.2rem; font-weight: 900; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${c.rankName || c.rank}</span>
                <span class="card-val" style="font-size: 0.9rem; font-weight: 700; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${suitSymbols[c.suit] || c.suit}</span>
              </div>
              <div class="card-val" style="font-size: 2rem; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1; text-align: center; margin: 2px 0;">${suitSymbols[c.suit] || c.suit}</div>
              <span class="trainer-discard-badge" style="font-size: 0.58rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.03em; background: ${sel ? "#ca8a04 !important" : "transparent"}; color: ${sel ? "#ffffff !important" : "transparent"}; -webkit-text-fill-color: ${sel ? "#ffffff !important" : "transparent"}; border-radius: 4px; padding: 2px 0; line-height: 1.1; text-align: center; display: block; width: 100%; box-sizing: border-box; visibility: ${sel ? "visible" : "hidden"};">DISCARD</span>
            </button>
          `;
          }).join("");
          let discardResultsHtml = "";
          if (discardEvalResult) {
            const analysis = DiscardTrainer.analyzeHand(dailyHand, dailyIsDealer);
            const gradeColors = { optimal: "#10b981", great: "#06b6d4", good: "#f59e0b", suboptimal: "#ef4444" };
            const badgeColor = gradeColors[discardEvalResult.grade] || "#f0c64a";
            const tableRows = analysis.combos.map((combo) => {
              const isUserPick = combo.id === discardEvalResult.userCombo.id;
              const isOptimal = combo.rank === 1;
              let bg = "transparent";
              if (isUserPick && isOptimal) bg = "rgba(16, 185, 129, 0.2)";
              else if (isUserPick) bg = "rgba(240, 198, 74, 0.15)";
              else if (isOptimal) bg = "rgba(16, 185, 129, 0.12)";
              const discMiniHtml = combo.disc.map((c) => {
                const red = c.suit === "H" || c.suit === "D";
                const color = red ? "#dc2626 !important" : "#111827 !important";
                return `<span class="trainer-mini-card ${red ? "card-red" : "card-black"}" style="display: inline-block; padding: 2px 6px; border-radius: 4px; font-weight: 800; font-size: 0.8rem; background: #ffffff !important; color: ${color}; -webkit-text-fill-color: ${color}; border: 1px solid #cbd5e1; box-shadow: 0 1px 3px rgba(0,0,0,0.2); margin-right: 3px;">${c.rankName || c.rank}${suitSymbols[c.suit] || c.suit}</span>`;
              }).join("");
              return `
              <tr style="background: ${bg}; border-bottom: 1px solid rgba(255,255,255,0.06);">
                <td style="padding: 7px 8px; font-weight: 700; color: ${isOptimal ? "#10b981" : isUserPick ? "#f0c64a" : "#a8a29e"};">#${combo.rank} ${isUserPick ? "\u{1F448} YOU" : ""}</td>
                <td style="padding: 7px 8px;">${discMiniHtml}</td>
                <td style="padding: 7px 8px; font-weight: 800; color: #f0c64a; text-align: right;">${combo.netEV.toFixed(2)}</td>
                <td style="padding: 7px 8px; color: #d6d3d1; text-align: right;">${combo.handEV.toFixed(2)} [${combo.handMin}\u2013${combo.handMax}]</td>
                <td style="padding: 7px 8px; color: #a8a29e; text-align: right;">${combo.cribEV.toFixed(2)}</td>
              </tr>
            `;
            }).join("");
            discardResultsHtml = `
            <div style="margin-top: 18px; padding: 14px; background: rgba(0,0,0,0.4); border-radius: 10px; border: 1.5px solid ${badgeColor}; text-align: center;">
              <div style="display: inline-block; padding: 5px 14px; border-radius: 20px; background: ${badgeColor}; color: #000; font-weight: 900; font-size: 0.95rem; margin-bottom: 8px;">
                ${discardEvalResult.gradeLabel}
              </div>
              <div style="font-size: 0.95rem; color: #f4ead4; margin-bottom: 12px;">
                Your EV: <strong style="color: #f0c64a;">${discardEvalResult.userCombo.netEV.toFixed(2)}</strong> \xB7 Optimal EV: <strong style="color: #10b981;">${discardEvalResult.optimalCombo.netEV.toFixed(2)}</strong> (Loss: <strong>${discardEvalResult.diff.toFixed(2)}</strong> pts)
              </div>
              <div style="overflow-x: auto; max-height: 220px; border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; margin-bottom: 14px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 0.8rem; text-align: left;">
                  <thead style="background: rgba(255,255,255,0.08); color: #f0c64a; position: sticky; top: 0; z-index: 2;">
                    <tr>
                      <th style="padding: 6px 8px;">Rank</th>
                      <th style="padding: 6px 8px;">Discards</th>
                      <th style="padding: 6px 8px; text-align: right;">Net EV</th>
                      <th style="padding: 6px 8px; text-align: right;">Hand [Min\u2013Max]</th>
                      <th style="padding: 6px 8px; text-align: right;">Crib</th>
                    </tr>
                  </thead>
                  <tbody>${tableRows}</tbody>
                </table>
              </div>
              <div style="display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
                ${!todayHistory.pegging ? `
                  <button type="button" id="btnNextToPegging" class="btn-gold" style="padding: 9px 16px; font-weight: 800; font-size: 0.88rem; border-radius: 8px; cursor: pointer;">
                    Next: Daily Pegging Scenario \u2794
                  </button>
                ` : ""}
                <button type="button" id="btnShareDiscardScore" class="btn-secondary" style="padding: 9px 14px; font-weight: 800; font-size: 0.88rem; border-radius: 8px; background: rgba(240,198,74,0.2); color: #f0c64a; border: 1px solid #f0c64a; cursor: pointer;">
                  \u{1F4CB} Share Daily Score
                </button>
              </div>
            </div>
          `;
          }
          tabContentHtml = `
          <div style="text-align: center; margin-bottom: 12px;">
            <div style="margin-bottom: 6px;">${roleBadge}</div>
            <p style="margin: 0; font-size: 0.86rem; color: #a8a29e;">
              ${discardEvalResult ? "Today\u2019s Hand Analyzed against all 46 unseen cut cards:" : "Select 2 cards to toss to the crib (" + selectedDiscardIndices.size + "/2 selected):"}
            </p>
          </div>
          <div style="display: flex; justify-content: center; gap: 8px; flex-wrap: wrap; margin-bottom: 14px;">
            ${cardsHtml}
          </div>
          ${!discardEvalResult ? `
            <div style="text-align: center;">
              <button type="button" id="btnSubmitDailyDiscard" class="btn-gold" ${selectedDiscardIndices.size !== 2 ? "disabled" : ""}
                      style="padding: 10px 22px; font-weight: 800; font-size: 0.95rem; border-radius: 8px; cursor: ${selectedDiscardIndices.size === 2 ? "pointer" : "not-allowed"}; opacity: ${selectedDiscardIndices.size === 2 ? "1" : "0.5"};">
                \u{1F31F} Submit Daily Discard
              </button>
            </div>
          ` : ""}
          ${discardResultsHtml}
        `;
        } else if (activeTab === "pegging") {
          const pHand = peggingScenario.playerHand;
          const countPills = peggingScenario.countHistory.map((item) => `
          <span style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 8px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.18); border-radius: 6px; font-size: 0.8rem; font-weight: 700; color: #f4ead4;">
            <span>${item.label}</span>
            <span style="font-size: 0.72rem; color: #f0c64a;">(${item.countAfter})</span>
          </span>
        `).join(" \u2794 ");
          const peggingCardsHtml = pHand.map((c) => {
            const isRed = c.suit === "H" || c.suit === "D";
            const sel = selectedPeggingCardId === c.id;
            const textColor = isRed ? "#dc2626 !important" : "#111827 !important";
            const isLocked = !!peggingEvalResult;
            let cardBorder = sel ? "3px solid #eab308 !important" : "2px solid #cbd5e1 !important";
            let cardShadow = sel ? "0 0 0 2px #ca8a04, 0 8px 18px rgba(234,179,8,0.45) !important" : "0 4px 10px rgba(0,0,0,0.35), 0 1px 3px rgba(0,0,0,0.15) !important";
            let cardTransform = sel ? "translateY(-3px)" : "none";
            let badgeText = "PLAY";
            let badgeBg = sel ? "#ca8a04 !important" : "transparent";
            let badgeColor = sel ? "#ffffff !important" : "transparent";
            let badgeVisible = sel;
            if (isLocked) {
              const isOptimal = c.id === peggingScenario.optimalCardId;
              const isChosen = c.id === selectedPeggingCardId;
              if (isOptimal) {
                cardBorder = "3px solid #10b981 !important";
                cardShadow = "0 0 0 2px #059669, 0 8px 18px rgba(16,185,129,0.5) !important";
                cardTransform = "translateY(-3px)";
                badgeText = "CORRECT \u2714";
                badgeBg = "#059669 !important";
                badgeColor = "#ffffff !important";
                badgeVisible = true;
              } else if (isChosen) {
                cardBorder = "3px solid #ef4444 !important";
                cardShadow = "0 0 0 2px #dc2626, 0 8px 18px rgba(239,68,68,0.45) !important";
                cardTransform = "translateY(-3px)";
                badgeText = "YOUR PLAY \u2715";
                badgeBg = "#dc2626 !important";
                badgeColor = "#ffffff !important";
                badgeVisible = true;
              } else {
                badgeVisible = false;
              }
            }
            return `
            <button type="button" class="daily-pegging-card-btn ${sel ? "selected" : ""} ${isRed ? "card-red" : "card-black"}" data-card-id="${c.id}"
                    style="position: relative; width: 72px; height: 104px; box-sizing: border-box; background: #ffffff !important; border: ${cardBorder}; border-radius: 8px; cursor: ${isLocked ? "default" : "pointer"}; display: flex; flex-direction: column; justify-content: space-between; padding: 6px 7px; box-shadow: ${cardShadow}; transform: ${cardTransform}; transition: all 0.15s ease;"
                    title="${c.rankName || c.rank}${c.suit}">
              <div style="display: flex; align-items: baseline; justify-content: flex-start; gap: 2px; line-height: 1;">
                <span class="card-val" style="font-size: 1.2rem; font-weight: 900; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${c.rankName || c.rank}</span>
                <span class="card-val" style="font-size: 0.9rem; font-weight: 700; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1;">${suitSymbols[c.suit] || c.suit}</span>
              </div>
              <div class="card-val" style="font-size: 2rem; color: ${textColor}; -webkit-text-fill-color: ${textColor}; line-height: 1; text-align: center; margin: 2px 0;">${suitSymbols[c.suit] || c.suit}</div>
              <span class="trainer-discard-badge" style="font-size: 0.58rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.03em; background: ${badgeBg}; color: ${badgeColor}; -webkit-text-fill-color: ${badgeColor}; border-radius: 4px; padding: 2px 0; line-height: 1.1; text-align: center; display: block; width: 100%; box-sizing: border-box; visibility: ${badgeVisible ? "visible" : "hidden"};">${badgeText}</span>
            </button>
          `;
          }).join("");
          let peggingOutcomeHtml = "";
          if (peggingEvalResult) {
            const sol = peggingEvalResult.solution;
            const isCorrect = peggingEvalResult.isCorrect;
            const optimalId = peggingScenario.optimalCardId;
            const optimalSol = peggingScenario.solutions[optimalId] || {};
            const optimalCardObj = pHand.find((c) => c.id === optimalId) || { id: optimalId, rank: "", suit: "" };
            const userCardObj = pHand.find((c) => c.id === selectedPeggingCardId) || { id: selectedPeggingCardId, rank: "", suit: "" };
            const optCardName = `${optimalCardObj.rankName || optimalCardObj.rank}${suitSymbols[optimalCardObj.suit] || optimalCardObj.suit}`;
            const userCardName = `${userCardObj.rankName || userCardObj.rank}${suitSymbols[userCardObj.suit] || userCardObj.suit}`;
            const optIsRed = optimalCardObj.suit === "H" || optimalCardObj.suit === "D";
            if (isCorrect) {
              peggingOutcomeHtml = `
              <div style="margin-top: 18px; padding: 14px; background: rgba(0,0,0,0.4); border-radius: 10px; border: 1.5px solid #10b981; text-align: center;">
                <div style="display: inline-block; padding: 5px 14px; border-radius: 20px; background: #10b981; color: #000; font-weight: 900; font-size: 0.95rem; margin-bottom: 8px;">
                  ${sol.badge}
                </div>
                <div style="font-size: 0.9rem; line-height: 1.55; color: #f4ead4; text-align: left; background: rgba(255,255,255,0.05); padding: 12px; border-radius: 8px; margin-bottom: 14px;">
                  ${sol.explanation}
                </div>
                <div style="display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
                  <button type="button" id="btnSharePeggingScore" class="btn-secondary" style="padding: 9px 14px; font-weight: 800; font-size: 0.88rem; border-radius: 8px; background: rgba(240,198,74,0.2); color: #f0c64a; border: 1px solid #f0c64a; cursor: pointer;">
                    \u{1F4CB} Share Daily Score
                  </button>
                </div>
              </div>
            `;
            } else {
              peggingOutcomeHtml = `
              <div style="margin-top: 18px; padding: 16px; background: rgba(0,0,0,0.45); border-radius: 10px; border: 1.5px solid #ef4444; text-align: left;">
                <div style="text-align: center; margin-bottom: 14px;">
                  <div style="display: inline-block; padding: 5px 16px; border-radius: 20px; background: #ef4444; color: #ffffff; font-weight: 900; font-size: 0.92rem; letter-spacing: 0.03em;">
                    \u274C INCORRECT PLAY \xB7 ${sol.badge}
                  </div>
                </div>

                <!-- Correct Card & Explanation (Prominent) -->
                <div style="background: rgba(16, 185, 129, 0.12); border: 1.5px solid #10b981; border-radius: 8px; padding: 12px 14px; margin-bottom: 12px;">
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap; margin-bottom: 8px; border-bottom: 1px solid rgba(16, 185, 129, 0.3); padding-bottom: 6px;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <span style="font-size: 1.15rem;">\u2714</span>
                      <span style="font-size: 0.85rem; font-weight: 800; color: #10b981; text-transform: uppercase; letter-spacing: 0.05em;">Correct Card to Play:</span>
                      <span style="display: inline-flex; align-items: center; justify-content: center; background: #ffffff; color: ${optIsRed ? "#dc2626 !important" : "#111827 !important"}; -webkit-text-fill-color: ${optIsRed ? "#dc2626" : "#111827"}; font-weight: 900; font-size: 0.95rem; padding: 2px 8px; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.3);">
                        ${optCardName}
                      </span>
                    </div>
                    ${optimalSol.badge ? `
                      <span style="background: rgba(16, 185, 129, 0.25); color: #6ee7b7; border: 1px solid rgba(16, 185, 129, 0.5); font-size: 0.72rem; font-weight: 800; padding: 2px 8px; border-radius: 10px;">
                        ${optimalSol.badge}
                      </span>
                    ` : ""}
                  </div>
                  <div style="color: #6ee7b7; font-size: 0.78rem; font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
                    Why ${optCardName} is the correct card:
                  </div>
                  <div style="color: #f4ead4; font-size: 0.88rem; line-height: 1.5;">
                    ${optimalSol.explanation || "This card maximizes points and secures the winning peg."}
                  </div>
                </div>

                <!-- Your Played Card Analysis -->
                <div style="background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.35); border-radius: 8px; padding: 12px 14px; margin-bottom: 14px;">
                  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
                    <span style="font-size: 1.05rem;">\u2715</span>
                    <span style="font-size: 0.82rem; font-weight: 800; color: #f87171; text-transform: uppercase; letter-spacing: 0.04em;">Why your play (${userCardName}) was suboptimal:</span>
                  </div>
                  <div style="color: #d6d3d1; font-size: 0.85rem; line-height: 1.48;">
                    ${sol.explanation}
                  </div>
                </div>

                <div style="display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
                  <button type="button" id="btnSharePeggingScore" class="btn-secondary" style="padding: 9px 14px; font-weight: 800; font-size: 0.88rem; border-radius: 8px; background: rgba(240,198,74,0.2); color: #f0c64a; border: 1px solid #f0c64a; cursor: pointer;">
                    \u{1F4CB} Share Daily Score
                  </button>
                </div>
              </div>
            `;
            }
          }
          tabContentHtml = `
          <div style="padding: 12px 14px; background: rgba(0,0,0,0.3); border-radius: 10px; border: 1px solid rgba(240,198,74,0.3); margin-bottom: 14px;">
            <div style="display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 6px; margin-bottom: 4px;">
              <h3 style="margin: 0; color: #f0c64a; font-size: 1.05rem;">${peggingScenario.title}</h3>
              <span style="font-size: 0.78rem; font-weight: 700; color: #fbbf24; text-transform: uppercase;">${peggingScenario.subtitle}</span>
            </div>
            <p style="margin: 0 0 10px; font-size: 0.88rem; color: #d6d3d1; line-height: 1.45;">
              ${peggingScenario.description}
            </p>
            <div style="display: flex; justify-content: space-between; background: rgba(0,0,0,0.4); padding: 8px 12px; border-radius: 8px; font-size: 0.84rem; font-weight: 700; color: #f4ead4; flex-wrap: wrap; gap: 8px;">
              <div>You: <strong style="color: #60a5fa;">${peggingScenario.playerScore}</strong> (${peggingScenario.isDealer ? "Dealer" : "Pone"})</div>
              <div>Opponent: <strong style="color: #f87171;">${peggingScenario.opponentScore}</strong></div>
              <div>Count: <strong style="color: #f0c64a; font-size: 1rem;">${peggingScenario.currentCount}</strong> / 31</div>
            </div>
            ${peggingScenario.countHistory.length > 0 ? `
              <div style="margin-top: 8px; font-size: 0.8rem; color: #a8a29e;">
                Sequence: ${countPills}
              </div>
            ` : ""}
          </div>

          <div style="text-align: center; margin-bottom: 8px; font-size: 0.85rem; font-weight: 600; color: #d6d3d1;">
            ${peggingEvalResult ? "Your Play &amp; Tactical Outcome:" : "Pick the winning card from your remaining hand:"}
          </div>
          <div style="display: flex; justify-content: center; gap: 8px; flex-wrap: wrap; margin-bottom: 14px;">
            ${peggingCardsHtml}
          </div>
          ${!peggingEvalResult ? `
            <div style="text-align: center;">
              <button type="button" id="btnSubmitDailyPegging" class="btn-gold" ${!selectedPeggingCardId ? "disabled" : ""}
                      style="padding: 10px 22px; font-weight: 800; font-size: 0.95rem; border-radius: 8px; cursor: ${selectedPeggingCardId ? "pointer" : "not-allowed"}; opacity: ${selectedPeggingCardId ? "1" : "0.5"};">
                \u26A1 Play Selected Card
              </button>
            </div>
          ` : ""}
          ${peggingOutcomeHtml}
        `;
        } else {
          const shareTextPreview = DailyPuzzleManager.generateShareText(dateKey);
          const perfectPct = stats.totalPlayed > 0 ? Math.round((stats.perfectDiscards || 0) / stats.totalPlayed * 100) : 0;
          const peggingPct = stats.totalPlayed > 0 ? Math.round((stats.peggingWins || 0) / stats.totalPlayed * 100) : 0;
          tabContentHtml = `
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(110px, 1fr)); gap: 10px; margin-bottom: 18px;">
            <div style="padding: 12px 8px; background: rgba(0,0,0,0.35); border-radius: 10px; border: 1px solid rgba(240,198,74,0.3); text-align: center;">
              <div style="font-size: 1.6rem; line-height: 1;">\u{1F525}</div>
              <div style="font-size: 1.4rem; font-weight: 900; color: #f0c64a; margin: 4px 0;">${stats.currentStreak || 0}</div>
              <div style="font-size: 0.72rem; color: #a8a29e; font-weight: 700; text-transform: uppercase;">Current Streak</div>
            </div>
            <div style="padding: 12px 8px; background: rgba(0,0,0,0.35); border-radius: 10px; border: 1px solid rgba(240,198,74,0.3); text-align: center;">
              <div style="font-size: 1.6rem; line-height: 1;">\u{1F3C6}</div>
              <div style="font-size: 1.4rem; font-weight: 900; color: #fbbf24; margin: 4px 0;">${stats.bestStreak || 0}</div>
              <div style="font-size: 0.72rem; color: #a8a29e; font-weight: 700; text-transform: uppercase;">Best Streak</div>
            </div>
            <div style="padding: 12px 8px; background: rgba(0,0,0,0.35); border-radius: 10px; border: 1px solid rgba(240,198,74,0.3); text-align: center;">
              <div style="font-size: 1.6rem; line-height: 1;">\u{1F4C5}</div>
              <div style="font-size: 1.4rem; font-weight: 900; color: #60a5fa; margin: 4px 0;">${stats.totalPlayed || 0}</div>
              <div style="font-size: 0.72rem; color: #a8a29e; font-weight: 700; text-transform: uppercase;">Days Played</div>
            </div>
            <div style="padding: 12px 8px; background: rgba(0,0,0,0.35); border-radius: 10px; border: 1px solid rgba(240,198,74,0.3); text-align: center;">
              <div style="font-size: 1.6rem; line-height: 1;">\u{1F31F}</div>
              <div style="font-size: 1.4rem; font-weight: 900; color: #10b981; margin: 4px 0;">${perfectPct}%</div>
              <div style="font-size: 0.72rem; color: #a8a29e; font-weight: 700; text-transform: uppercase;">Optimal Discard</div>
            </div>
            <div style="padding: 12px 8px; background: rgba(0,0,0,0.35); border-radius: 10px; border: 1px solid rgba(240,198,74,0.3); text-align: center;">
              <div style="font-size: 1.6rem; line-height: 1;">\u26A1</div>
              <div style="font-size: 1.4rem; font-weight: 900; color: #f59e0b; margin: 4px 0;">${peggingPct}%</div>
              <div style="font-size: 0.72rem; color: #a8a29e; font-weight: 700; text-transform: uppercase;">Pegging Win Rate</div>
            </div>
          </div>

          <div style="background: rgba(0,0,0,0.45); border-radius: 10px; border: 1px solid rgba(255,255,255,0.12); padding: 14px; margin-bottom: 16px;">
            <div style="font-size: 0.8rem; font-weight: 700; color: #f0c64a; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.05em;">
              Wordle-Style Share Card Preview
            </div>
            <pre style="margin: 0; font-family: monospace; font-size: 0.88rem; color: #f4ead4; background: rgba(0,0,0,0.3); padding: 10px; border-radius: 6px; white-space: pre-wrap; line-height: 1.45;">${shareTextPreview}</pre>
          </div>

          <div style="text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px;">
            <button type="button" id="btnCopyDailyShareText" class="btn-gold" style="padding: 11px 22px; font-weight: 800; font-size: 0.95rem; border-radius: 8px; cursor: pointer;">
              \u{1F4CB} Copy Share Card to Clipboard
            </button>
            ${copyToastMessage ? `<div style="margin-top: 4px; color: ${copyToastMessage.includes("reset") ? "#f87171" : "#22c55e"}; font-weight: 700; font-size: 0.88rem;">${copyToastMessage}</div>` : ""}
            <button type="button" id="btnResetDailyStats" class="btn-ghost" style="margin-top: 10px; padding: 7px 15px; font-size: 0.8rem; font-weight: 700; color: #ef4444; border: 1px solid rgba(239,68,68,0.35); border-radius: 6px; background: rgba(239,68,68,0.08); cursor: pointer; transition: all 0.15s ease;" title="Reset daily streaks and completion history">
              \u{1F5D1}\uFE0F Reset Streaks &amp; Stats
            </button>
          </div>
        `;
        }
        const modalHtml = `
        <div class="daily-puzzle-modal" style="max-width: 680px; width: 100%; box-sizing: border-box; text-align: left; padding: 4px 2px;">
          <!-- Header -->
          <div style="display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 1.5px solid rgba(240, 198, 74, 0.4); padding-bottom: 12px; margin-bottom: 14px;">
            <div>
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="font-size: 1.4rem;">\u{1F4C5}</span>
                <h2 style="margin: 0; font-size: 1.35rem; color: #f0c64a; font-weight: 800; letter-spacing: 0.03em;">DAILY PUZZLE</h2>
                <span style="background: rgba(240,198,74,0.2); color: #f0c64a; border: 1px solid rgba(240,198,74,0.4); font-size: 0.75rem; font-weight: 800; padding: 2px 7px; border-radius: 12px;">DAY #${dayNumber}</span>
              </div>
              <p style="margin: 4px 0 0; font-size: 0.82rem; color: #a8a29e;">${dateFormatted} \xB7 Fresh puzzle daily at midnight</p>
            </div>
            <button type="button" class="btn-ghost modal-btn-close" title="Close Daily Puzzle" style="padding: 6px 12px; font-size: 0.85rem; border-radius: 6px; background: rgba(255,255,255,0.08); color: #d6d3d1; border: 1px solid rgba(255,255,255,0.2); cursor: pointer;">
              \u2715 Close
            </button>
          </div>

          <!-- Tabs -->
          ${tabsHtml}

          <!-- Content -->
          <div class="daily-tab-content">
            ${tabContentHtml}
          </div>
        </div>
      `;
        this.showModal(modalHtml, true);
        bindEvents();
      };
      const bindEvents = () => {
        const tabDiscard = document.getElementById("tabBtnDiscard");
        const tabPegging = document.getElementById("tabBtnPegging");
        const tabStats = document.getElementById("tabBtnStats");
        if (tabDiscard) tabDiscard.onclick = () => {
          activeTab = "discard";
          copyToastMessage = "";
          render2();
        };
        if (tabPegging) tabPegging.onclick = () => {
          activeTab = "pegging";
          copyToastMessage = "";
          render2();
        };
        if (tabStats) tabStats.onclick = () => {
          activeTab = "stats";
          copyToastMessage = "";
          render2();
        };
        if (activeTab === "discard") {
          const cardBtns = document.querySelectorAll(".trainer-card-btn");
          cardBtns.forEach((btn) => {
            btn.onclick = () => {
              if (discardEvalResult) return;
              const idx = parseInt(btn.dataset.idx, 10);
              if (selectedDiscardIndices.has(idx)) {
                selectedDiscardIndices.delete(idx);
              } else {
                if (selectedDiscardIndices.size >= 2) {
                  const first = selectedDiscardIndices.values().next().value;
                  selectedDiscardIndices.delete(first);
                }
                selectedDiscardIndices.add(idx);
              }
              render2();
            };
          });
          const btnSubmitDiscard = document.getElementById("btnSubmitDailyDiscard");
          if (btnSubmitDiscard) {
            btnSubmitDiscard.onclick = () => {
              if (selectedDiscardIndices.size !== 2) return;
              const chosenCards = Array.from(selectedDiscardIndices).map((idx) => dailyHand[idx].id);
              discardEvalResult = DailyPuzzleManager.evaluateDailyDiscard(chosenCards, dateKey);
              const sfx3 = typeof window !== "undefined" ? window.sfx : null;
              DailyPuzzleManager.recordCompletion("discard", discardEvalResult, dateKey, { sfx: sfx3 });
              render2();
            };
          }
          const btnNextToPegging = document.getElementById("btnNextToPegging");
          if (btnNextToPegging) {
            btnNextToPegging.onclick = () => {
              activeTab = "pegging";
              render2();
            };
          }
          const btnShareDiscard = document.getElementById("btnShareDiscardScore");
          if (btnShareDiscard) {
            btnShareDiscard.onclick = () => {
              const text2 = DailyPuzzleManager.generateShareText(dateKey);
              if (typeof navigator !== "undefined" && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text2).then(() => {
                  alert("Daily Score copied to clipboard! \u{1F4CB}\n\n" + text2);
                }).catch(() => {
                  prompt("Copy your daily score:", text2);
                });
              } else {
                prompt("Copy your daily score:", text2);
              }
            };
          }
        }
        if (activeTab === "pegging") {
          const peggingBtns = document.querySelectorAll(".daily-pegging-card-btn");
          peggingBtns.forEach((btn) => {
            btn.onclick = () => {
              if (peggingEvalResult) return;
              selectedPeggingCardId = btn.dataset.cardId;
              render2();
            };
          });
          const btnSubmitPegging = document.getElementById("btnSubmitDailyPegging");
          if (btnSubmitPegging) {
            btnSubmitPegging.onclick = () => {
              if (!selectedPeggingCardId) return;
              peggingEvalResult = DailyPuzzleManager.evaluateDailyPegging(selectedPeggingCardId, dateKey);
              const sfx3 = typeof window !== "undefined" ? window.sfx : null;
              DailyPuzzleManager.recordCompletion("pegging", peggingEvalResult, dateKey, { sfx: sfx3 });
              render2();
            };
          }
          const btnSharePegging = document.getElementById("btnSharePeggingScore");
          if (btnSharePegging) {
            btnSharePegging.onclick = () => {
              const text2 = DailyPuzzleManager.generateShareText(dateKey);
              if (typeof navigator !== "undefined" && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text2).then(() => {
                  alert("Daily Score copied to clipboard! \u{1F4CB}\n\n" + text2);
                }).catch(() => {
                  prompt("Copy your daily score:", text2);
                });
              } else {
                prompt("Copy your daily score:", text2);
              }
            };
          }
        }
        if (activeTab === "stats") {
          const btnCopyShare = document.getElementById("btnCopyDailyShareText");
          if (btnCopyShare) {
            btnCopyShare.onclick = () => {
              const text2 = DailyPuzzleManager.generateShareText(dateKey);
              if (typeof navigator !== "undefined" && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text2).then(() => {
                  copyToastMessage = "Copied to clipboard! \u{1F4CB} Share with friends!";
                  render2();
                }).catch(() => {
                  prompt("Copy your daily share card:", text2);
                });
              } else {
                prompt("Copy your daily share card:", text2);
              }
            };
          }
          const btnResetStats = document.getElementById("btnResetDailyStats");
          if (btnResetStats) {
            btnResetStats.onclick = () => {
              const doReset = () => {
                DailyPuzzleManager.resetStats();
                stats = DailyPuzzleManager.loadStats();
                todayHistory = {};
                discardEvalResult = null;
                peggingEvalResult = null;
                selectedDiscardIndices.clear();
                selectedPeggingCardId = null;
                copyToastMessage = "Daily streaks and statistics have been reset.";
                render2();
              };
              const showConfirmFn = typeof window !== "undefined" && typeof window.showConfirmModal === "function" ? window.showConfirmModal : context && typeof context.showConfirmModal === "function" ? context.showConfirmModal : null;
              if (typeof showConfirmFn === "function") {
                showConfirmFn({
                  title: "Reset Daily Streaks & Stats?",
                  message: "Are you sure you want to reset your daily streaks, win counts, and puzzle history? This action cannot be undone.",
                  confirmText: "Reset Stats",
                  cancelText: "Cancel",
                  danger: true,
                  onConfirm: doReset
                });
              } else if (confirm("Are you sure you want to reset your daily streaks and statistics? This cannot be undone.")) {
                doReset();
              }
            };
          }
        }
      };
      render2();
    }
    static showDailyPuzzleModal(context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showDailyPuzzleModal === "function") {
        return window.modalManager.showDailyPuzzleModal(context);
      }
      const mm = new _ModalManager();
      return mm.showDailyPuzzleModal(context);
    }
    static triggerNativeShare(shareData = {}) {
      if (typeof navigator !== "undefined" && navigator.share) {
        const data = {
          title: shareData.title || "Crazy Cribbage",
          text: shareData.text || "Play Crazy Cribbage \u2014 the wild twist on classic cribbage! 50+ point hands, jokers, and custom boards!",
          url: shareData.url || (typeof window !== "undefined" && window.location ? window.location.href.split("#")[0] : "")
        };
        navigator.share(data).catch(() => {
        });
      }
    }
    triggerNativeShare(shareData) {
      return _ModalManager.triggerNativeShare(shareData);
    }
    /**
     * Displays the brand-specific intro/rules modal.
     */
    static showIntro(brand = null, options = {}) {
      if (typeof document === "undefined" && !options.showModal) return;
      const resolvedBrand = brand || (typeof window !== "undefined" && window.getAppBrand ? window.getAppBrand() : typeof window !== "undefined" && (window.currentBrand || window.currentLogoBrand) ? window.currentBrand || window.currentLogoBrand : "crazy");
      const isClash = resolvedBrand === "clash";
      const isAdult = resolvedBrand === "adult";
      const isPints = resolvedBrand === "pints";
      let copyEl;
      if (typeof document !== "undefined") {
        if (isAdult) {
          copyEl = document.getElementById("introCopyAdult") || document.getElementById("introCopy");
        } else if (isPints) {
          copyEl = document.getElementById("introCopyPints") || document.getElementById("introCopy");
        } else if (isClash) {
          copyEl = document.getElementById("introCopyClash") || document.getElementById("introCopy");
        } else {
          copyEl = document.getElementById("introCopy");
        }
      }
      const html2 = copyEl ? copyEl.innerHTML : options.content || "<p>Intro</p>";
      const showModalFn = options.showModal || (typeof window !== "undefined" && window.showModal ? window.showModal : null);
      if (typeof showModalFn === "function") {
        showModalFn(html2, true);
      }
    }
    showIntro(brand, options) {
      return _ModalManager.showIntro(brand, { ...options, showModal: this.showModal.bind(this) });
    }
    /**
     * Binds close buttons, escape key, and header menu shortcuts.
     */
    static setupCloseButtonEvents(handlers = {}) {
      if (typeof document === "undefined") return;
      const hideModalFn = handlers.hideModal || (typeof window !== "undefined" && window.hideModal ? window.hideModal : null);
      const showIntroFn = handlers.showIntro || (typeof window !== "undefined" && window.showIntro ? window.showIntro : null);
      const showRecordsModalFn = handlers.showRecordsModal || (typeof window !== "undefined" && window.showRecordsModal ? window.showRecordsModal : null);
      const toggleMenuSettingsFn = handlers.toggleMenuSettings || (typeof window !== "undefined" && window.toggleMenuSettings ? window.toggleMenuSettings : null);
      const showShareModalFn = handlers.showShareModal || (typeof window !== "undefined" && window.showShareModal ? window.showShareModal : null);
      const modalBar = document.getElementById("modalBar");
      const modalClose = document.getElementById("modalClose");
      if (modalBar && hideModalFn) {
        modalBar.onclick = (e) => {
          if (e && e.stopPropagation) e.stopPropagation();
          hideModalFn();
        };
      }
      if (modalClose && hideModalFn) {
        modalClose.onclick = (e) => {
          if (e && e.stopPropagation) e.stopPropagation();
          hideModalFn();
        };
      }
      document.addEventListener("click", (e) => {
        const closeBtn = e.target && e.target.closest && e.target.closest('button[onclick*="hideModal"], button[onclick*="closeModal"], .modal-btn-close, [data-modal-close]');
        if (closeBtn && hideModalFn) {
          if (e && e.stopPropagation) e.stopPropagation();
          hideModalFn();
        }
      });
    }
    /**
     * Displays the Age Gate modal for age-restricted game brands (pints / adult).
     * @param {string} [brand]
     * @param {Object} [context]
     */
    static showAgeGateModal(brand, context = {}) {
      if (typeof document === "undefined") return;
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "pints");
      brand = brand || getAppBrand2();
      const overlay = document.getElementById("ageGateOverlay");
      const modal = document.getElementById("ageGateModal");
      if (!overlay || !modal) return;
      const isPints = brand === "pints";
      const isAdult = brand === "adult";
      if (!isPints && !isAdult) {
        overlay.style.display = "none";
        return;
      }
      modal.classList.remove("age-gate-pints", "age-gate-adult");
      modal.classList.add(isPints ? "age-gate-pints" : "age-gate-adult");
      const iconEl = document.getElementById("ageGateIcon");
      const brandNameEl = document.getElementById("ageGateBrandName");
      const msgEl = document.getElementById("ageGateMessage");
      const confirmBtn = document.getElementById("btnAgeGateConfirm");
      if (iconEl) iconEl.textContent = isPints ? "\u{1F37B}" : "\u{1F51E}";
      if (brandNameEl) brandNameEl.textContent = isPints ? "Pints and Pegs" : "Skunked and Stripped";
      if (msgEl) {
        msgEl.textContent = isPints ? "This version contains drinking themes and pub games intended solely for individuals of legal drinking age. You must be at least 21 years old to enter and play." : "This version contains mature adult themes and erotic challenges intended solely for adults. You must be at least 21 years old to enter and play.";
      }
      if (confirmBtn) {
        confirmBtn.textContent = "\u2714 I Am 21 or Older \u2014 Enter";
      }
      overlay.style.display = "flex";
    }
    /**
     * Hides the Age Gate overlay.
     */
    static hideAgeGateModal() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("ageGateOverlay");
      if (overlay) overlay.style.display = "none";
    }
    /**
     * Confirms user is 21+, stores verification flag and dismisses modal.
     * @param {Object} [context]
     */
    static confirmAgeGate(context = {}) {
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "pints");
      const setAgeVerified2 = context.setAgeVerified || (typeof window !== "undefined" ? window.setAgeVerified : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const brand = getAppBrand2();
      setAgeVerified2(brand, true);
      if (typeof window !== "undefined" && window.appStorage) {
        try {
          window.appStorage.setItem("cc_age_verified_" + brand, "true");
        } catch (e) {
        }
      }
      _ModalManager.hideAgeGateModal();
      if (sfx3 && sfx3.snap) sfx3.snap();
    }
    /**
     * Safely navigates away to the default Crazy Cribbage brand if age verification declined.
     */
    static exitAgeGateToSafeBrand() {
      if (typeof window === "undefined") return;
      _ModalManager.hideAgeGateModal();
      if (typeof window.setLogoBrand === "function") {
        try {
          window.setLogoBrand("crazy");
        } catch (e) {
        }
      }
      const path = window.location && window.location.pathname || "";
      if (path.includes("pints") || path.includes("stripped") || path.includes("adult")) {
        window.location.href = "/pages/game-crazy-cribbage";
      } else if (window.location && window.location.search && (window.location.search.includes("pints") || window.location.search.includes("adult") || window.location.search.includes("stripped"))) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set("brand", "crazy");
          window.location.href = url.toString();
        } catch (e) {
          window.location.href = "?brand=crazy";
        }
      }
    }
    showAgeGateModal(brand, context) {
      return _ModalManager.showAgeGateModal(brand, context);
    }
    hideAgeGateModal() {
      return _ModalManager.hideAgeGateModal();
    }
    confirmAgeGate(context) {
      return _ModalManager.confirmAgeGate(context);
    }
    exitAgeGateToSafeBrand() {
      return _ModalManager.exitAgeGateToSafeBrand();
    }
    /**
     * Shows the Adult Mode timer challenge modal.
     * @param {Object} optionDef
     * @param {string} playerLabel
     * @param {number} holeNum
     * @param {Object} [context]
     */
    static showAdultTimerModal(optionDef, playerLabel, holeNum, context = {}) {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("adultTimerOverlay");
      if (!overlay) return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      if (state3) {
        state3.pausedForAdultTimer = true;
        state3.paused = true;
        log2(`\u23F1\uFE0F ADULT CHALLENGE: ${playerLabel || "Player"} landed on Hole ${holeNum} (${optionDef.name})! Game is paused until timer challenge is closed.`);
        setStatus2(`Landed on Hole ${holeNum} (${optionDef.name})! Game is paused.`);
      }
      const times = [15, 30, 45, 60, 90, 120];
      const chosenTime = times[Math.floor(Math.random() * times.length)];
      _ModalManager.adultTimerTotal = chosenTime;
      _ModalManager.adultTimerRemaining = chosenTime;
      if (_ModalManager.adultTimerInterval) {
        clearInterval(_ModalManager.adultTimerInterval);
        _ModalManager.adultTimerInterval = null;
      }
      const titleEl = document.getElementById("adultTimerTitle");
      const descEl = document.getElementById("adultTimerDesc");
      const playerEl = document.getElementById("adultTimerPlayer");
      const pickBadgeEl = document.getElementById("adultTimerPickBadge");
      const secEl = document.getElementById("adultTimerSeconds");
      const bannerEl = document.getElementById("adultTimerBanner");
      const startBtn = document.getElementById("btnAdultTimerStart");
      const closeBtn = document.getElementById("btnAdultTimerClose");
      const circle = document.getElementById("adultDialProgress");
      if (titleEl) titleEl.textContent = `${optionDef.icon || "\u{1F525}"} ${optionDef.name}`;
      if (descEl) descEl.textContent = `Action: ${optionDef.actionText || optionDef.name}`;
      if (playerEl) playerEl.textContent = `${playerLabel || "Player"} landed on Hole ${holeNum}!`;
      if (pickBadgeEl) pickBadgeEl.textContent = `\u23F1\uFE0F ${chosenTime} Seconds Challenge`;
      if (secEl) secEl.textContent = String(chosenTime);
      if (bannerEl) bannerEl.style.display = "none";
      if (closeBtn) closeBtn.textContent = "Close";
      if (startBtn) {
        startBtn.disabled = false;
        startBtn.textContent = "\u25B6 Start Timer";
        startBtn.style.display = "inline-flex";
      }
      if (circle) {
        const circum = 2 * Math.PI * 76;
        circle.style.strokeDasharray = `${circum}`;
        circle.style.strokeDashoffset = "0";
      }
      overlay.style.display = "flex";
      if (sfx3 && sfx3.snap) sfx3.snap();
    }
    /**
     * Starts the countdown timer for the Adult Challenge modal.
     * @param {Object} [context]
     */
    static startAdultTimer(context = {}) {
      if (typeof document === "undefined") return;
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      if (sfx3 && sfx3.ensure) {
        try {
          sfx3.ensure();
        } catch (e) {
        }
      }
      const startBtn = document.getElementById("btnAdultTimerStart");
      if (startBtn) {
        startBtn.disabled = true;
        startBtn.textContent = "\u23F3 Running...";
      }
      const secEl = document.getElementById("adultTimerSeconds");
      const bannerEl = document.getElementById("adultTimerBanner");
      const circle = document.getElementById("adultDialProgress");
      const circum = 2 * Math.PI * 76;
      if (_ModalManager.adultTimerInterval) clearInterval(_ModalManager.adultTimerInterval);
      _ModalManager.adultTimerInterval = setInterval(() => {
        _ModalManager.adultTimerRemaining--;
        if (secEl) secEl.textContent = String(Math.max(0, _ModalManager.adultTimerRemaining));
        if (circle && _ModalManager.adultTimerTotal > 0) {
          const progress = 1 - _ModalManager.adultTimerRemaining / _ModalManager.adultTimerTotal;
          circle.style.strokeDashoffset = `${progress * circum}`;
        }
        if (_ModalManager.adultTimerRemaining > 0 && sfx3 && sfx3.tone) {
          sfx3.tone(440, 0.04, "triangle", 0.03);
        }
        if (_ModalManager.adultTimerRemaining <= 0) {
          clearInterval(_ModalManager.adultTimerInterval);
          _ModalManager.adultTimerInterval = null;
          if (secEl) secEl.textContent = "0";
          if (circle) circle.style.strokeDashoffset = `${circum}`;
          if (bannerEl) bannerEl.style.display = "block";
          if (startBtn) startBtn.style.display = "none";
          const closeBtn = document.getElementById("btnAdultTimerClose");
          if (closeBtn) closeBtn.textContent = "Dismiss";
          if (sfx3 && typeof sfx3.alarm === "function") {
            sfx3.alarm(true);
          }
        }
      }, 1e3);
    }
    /**
     * Closes the Adult Challenge modal and resumes gameplay.
     * @param {Object} [context]
     */
    static closeAdultTimerModal(context = {}) {
      if (_ModalManager.adultTimerInterval) {
        clearInterval(_ModalManager.adultTimerInterval);
        _ModalManager.adultTimerInterval = null;
      }
      if (typeof document !== "undefined") {
        const overlay = document.getElementById("adultTimerOverlay");
        if (overlay) overlay.style.display = "none";
      }
      const resumeFn = context.resumeGameAfterAdultTimer || (typeof window !== "undefined" ? window.resumeGameAfterAdultTimer : _ModalManager.resumeGameAfterAdultTimer);
      resumeFn(context);
    }
    /**
     * Displays the Adult Mode strip challenge modal.
     * @param {Object} optionDef
     * @param {string} playerLabel
     * @param {number} holeNum
     * @param {Object} [context]
     */
    static showAdultStripModal(optionDef, playerLabel, holeNum, context = {}) {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("adultBonusOverlay");
      if (!overlay) return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      if (state3) {
        state3.pausedForAdultStrip = true;
        state3.paused = true;
        log2(`\u{1F459} STRIP BONUS: ${playerLabel || "Player"} landed on Hole ${holeNum} (${optionDef.name}) \u2014 ${optionDef.actionText}! Game is paused.`);
        setStatus2(`Landed on Hole ${holeNum} (${optionDef.name})! Game is paused.`);
      }
      const titleEl = document.getElementById("adultBonusTitle");
      const descEl = document.getElementById("adultBonusDesc");
      const playerEl = document.getElementById("adultBonusPlayer");
      const iconEl = document.getElementById("adultBonusIcon");
      const msgEl = document.getElementById("adultBonusMessage");
      if (iconEl) iconEl.textContent = optionDef.icon || "\u{1F459}";
      if (titleEl) titleEl.textContent = `${optionDef.icon ? optionDef.icon + " " : ""}${optionDef.name}`;
      if (playerEl) playerEl.textContent = `${playerLabel || "Player"} landed on Hole ${holeNum}!`;
      if (msgEl) msgEl.textContent = optionDef.actionText || optionDef.name;
      if (descEl) descEl.textContent = `Action: ${optionDef.actionText || optionDef.name}`;
      overlay.style.display = "flex";
      if (sfx3 && sfx3.snap) sfx3.snap();
    }
    /**
     * Closes the Adult Mode strip challenge modal and resumes gameplay.
     * @param {Object} [context]
     */
    static closeAdultStripModal(context = {}) {
      if (typeof document !== "undefined") {
        const overlay = document.getElementById("adultBonusOverlay");
        if (overlay) overlay.style.display = "none";
      }
      const resumeFn = context.resumeGameAfterAdultStrip || (typeof window !== "undefined" ? window.resumeGameAfterAdultStrip : _ModalManager.resumeGameAfterAdultStrip);
      resumeFn(context);
    }
    /**
     * Resumes game loop after strip modal dismissal.
     * @param {Object} [context]
     */
    static resumeGameAfterAdultStrip(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      state3.pausedForAdultStrip = false;
      if (!state3.pausedForSign && !state3.pausedForAdultTimer && !state3.pausedForPintsBonus) {
        state3.paused = false;
      }
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      if (typeof state3._resumeAfterAdultTimer === "function" && !state3.pausedForAdultTimer && !state3.pausedForPintsBonus) {
        const resumeFn = state3._resumeAfterAdultTimer;
        state3._resumeAfterAdultTimer = null;
        state3._resumeAfterSign = null;
        state3._resumeAfterPintsBonus = null;
        resumeFn();
      } else if (typeof state3._resumeAfterSign === "function" && !state3.pausedForSign && !state3.pausedForAdultTimer && !state3.pausedForPintsBonus) {
        const resumeFn = state3._resumeAfterSign;
        state3._resumeAfterAdultTimer = null;
        state3._resumeAfterSign = null;
        state3._resumeAfterPintsBonus = null;
        resumeFn();
      } else if (state3.phase === "play" && isSeatCpu2(state3.turn) && !state3.paused) {
        scheduleOppPlay2(state3.turn);
      } else if (state3.phase === "play" && !state3.paused) {
        render2();
      }
    }
    /**
     * Resumes game loop after timer challenge dismissal.
     * @param {Object} [context]
     */
    static resumeGameAfterAdultTimer(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      state3.pausedForAdultTimer = false;
      if (!state3.pausedForSign && !state3.pausedForAdultStrip && !state3.pausedForPintsBonus) {
        state3.paused = false;
      }
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      if (typeof state3._resumeAfterAdultTimer === "function" && !state3.pausedForAdultStrip && !state3.pausedForPintsBonus) {
        const resumeFn = state3._resumeAfterAdultTimer;
        state3._resumeAfterAdultTimer = null;
        state3._resumeAfterSign = null;
        state3._resumeAfterPintsBonus = null;
        resumeFn();
      } else if (typeof state3._resumeAfterSign === "function" && !state3.pausedForSign && !state3.pausedForAdultStrip && !state3.pausedForPintsBonus) {
        const resumeFn = state3._resumeAfterSign;
        state3._resumeAfterAdultTimer = null;
        state3._resumeAfterSign = null;
        state3._resumeAfterPintsBonus = null;
        resumeFn();
      } else if (state3.phase === "play" && isSeatCpu2(state3.turn) && !state3.paused) {
        scheduleOppPlay2(state3.turn);
      } else if (state3.phase === "play" && !state3.paused) {
        render2();
      }
    }
    showAdultTimerModal(optionDef, playerLabel, holeNum, context) {
      return _ModalManager.showAdultTimerModal(optionDef, playerLabel, holeNum, context);
    }
    startAdultTimer(context) {
      return _ModalManager.startAdultTimer(context);
    }
    closeAdultTimerModal(context) {
      return _ModalManager.closeAdultTimerModal(context);
    }
    showAdultStripModal(optionDef, playerLabel, holeNum, context) {
      return _ModalManager.showAdultStripModal(optionDef, playerLabel, holeNum, context);
    }
    closeAdultStripModal(context) {
      return _ModalManager.closeAdultStripModal(context);
    }
    resumeGameAfterAdultStrip(context) {
      return _ModalManager.resumeGameAfterAdultStrip(context);
    }
    resumeGameAfterAdultTimer(context) {
      return _ModalManager.resumeGameAfterAdultTimer(context);
    }
    /**
     * Prompts device handoff for local pass-and-play matches.
     * @param {string} who - Target seat ID
     * @param {Function} thenFn - Callback when recipient confirms ready
     * @param {Object} [context]
     */
    static passTo(who, thenFn, context = {}) {
      if (who === "you") who = "p1";
      if (who === "cpu") who = "p2";
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      if (isOnline2() || isSeatCpu2(who)) {
        if (thenFn) thenFn();
        return;
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const pCount = settings3 ? parseInt(settings3.playerCount, 10) || 2 : 2;
      const activeSeats = typeof context.getActiveSeatIds === "function" ? context.getActiveSeatIds() : Array.isArray(settings3?.seats) ? settings3.seats.slice(0, pCount).map((s) => s.id) : ["p1", "p2", "p3", "p4"].slice(0, pCount);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : null);
      const humanSeats = activeSeats.filter((sId) => {
        if (typeof isSeatHuman2 === "function") return isSeatHuman2(sId);
        if (typeof isSeatCpu2 === "function" && isSeatCpu2(sId)) return false;
        if (Array.isArray(settings3?.seats)) {
          const s = settings3.seats.find((seat) => seat.id === sId);
          if (s && s.type === "cpu") return false;
        } else if (settings3?.seats && typeof settings3.seats === "object") {
          const s = settings3.seats[sId];
          if (s && s.type === "cpu") return false;
        }
        return true;
      });
      if (humanSeats.length <= 1) {
        if (thenFn) thenFn();
        return;
      }
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "crazy");
      const appBrand = typeof getAppBrand2 === "function" ? getAppBrand2() : "crazy";
      const GameOptionsEngine2 = typeof window !== "undefined" && window.GameOptionsEngine ? window.GameOptionsEngine : null;
      const allowCpu = GameOptionsEngine2 && typeof GameOptionsEngine2.isCpuAllowed === "function" ? GameOptionsEngine2.isCpuAllowed(appBrand) : !["pints", "adult"].includes(appBrand);
      const isHvH2 = context.isHvH || (typeof window !== "undefined" ? window.isHvH : () => false);
      if (settings3 && pCount === 2 && !isHvH2() && allowCpu) {
        if (thenFn) thenFn();
        return;
      }
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      if (state3) {
        state3.passingTo = who;
        render2();
      }
      const showModal2 = context.showModal || (typeof window !== "undefined" && typeof window.showModal === "function" ? window.showModal : () => {
      });
      const hideModal3 = context.hideModal || (typeof window !== "undefined" && typeof window.hideModal === "function" ? window.hideModal : () => {
      });
      const seatColor2 = context.seatColor || (typeof window !== "undefined" ? window.seatColor : () => "#d4a017");
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      showModal2(
        `<h2>Pass This Device</h2>
       <p>Pass the device to <strong style="color:${seatColor2(who)}">${seatName3(who)}</strong>. Other players please look away.</p>
       <button class="btn-gold" id="btnSeat">Ready \u2014 ${seatName3(who)}</button>`
      );
      if (typeof document !== "undefined") {
        const b = document.getElementById("btnSeat");
        if (b) b.onclick = () => {
          if (state3) state3.passingTo = null;
          hideModal3();
          if (thenFn) thenFn();
        };
      }
    }
    /**
     * Closes wild card picker dialog.
     * @param {Object} [context]
     */
    static hideWildPick(context = {}) {
      if (typeof document === "undefined") return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const box = document.getElementById("wildPick");
      if (box) {
        box.classList.remove("on");
        box.innerHTML = "";
        const tableLeft = document.querySelector(".table-left");
        if (tableLeft && box.parentElement !== tableLeft) {
          const statusEl = document.getElementById("status");
          if (statusEl && statusEl.nextSibling) {
            tableLeft.insertBefore(box, statusEl.nextSibling);
          } else {
            tableLeft.appendChild(box);
          }
        }
      }
      const backdrop = document.getElementById("wildPickBackdrop");
      if (backdrop) {
        backdrop.classList.remove("on");
        if (typeof backdrop.remove === "function") backdrop.remove();
      }
      if (state3) {
        state3.pendingWild = null;
        state3.pendingSuit = null;
      }
    }
    /**
     * Applies consistent styling to wild card selection buttons.
     * @param {HTMLElement} b
     * @param {string} [ink='#1a1208']
     */
    static stylePickBtn(b, ink = "#1a1208") {
      if (!b || !b.style) return;
      b.style.setProperty("color", ink || "#1a1208", "important");
      b.style.setProperty("-webkit-text-fill-color", ink || "#1a1208", "important");
      b.style.setProperty("background", "#f4ead4", "important");
      b.style.setProperty("background-color", "#f4ead4", "important");
      b.style.setProperty("border", "2px solid #1a1208", "important");
      b.style.setProperty("color-scheme", "light", "important");
    }
    /**
     * Opens wild card picker dialog for choosing suit and rank.
     * @param {Object} c - Target card
     * @param {string} [kind='hand']
     * @param {Object} [context]
     */
    static openWildPick(c, kind = "hand", context = {}) {
      if (typeof document === "undefined") return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const box = document.getElementById("wildPick");
      if (!box) return;
      const backdrop = document.getElementById("wildPickBackdrop");
      if (backdrop) {
        backdrop.classList.remove("on");
        if (typeof backdrop.remove === "function") backdrop.remove();
      }
      const fsElem = document.fullscreenElement || document.webkitFullscreenElement;
      const b3d = document.getElementById("board3DContainer");
      if (b3d && (fsElem === b3d || b3d.classList.contains("is-fullscreen"))) {
        if (box.parentElement !== b3d) {
          b3d.appendChild(box);
        }
      }
      if (state3) {
        state3.pendingWild = c;
        state3.pendingSuit = null;
        state3.pendingKind = kind || "hand";
      }
      box.classList.add("on");
      _ModalManager.drawWildPick(context);
      setStatus2("Joker: pick a suit, then a rank. That card is locked in.");
    }
    /**
     * Draws interactive suit or rank buttons in wild card picker overlay.
     * @param {Object} [context]
     */
    static drawWildPick(context = {}) {
      if (typeof document === "undefined") return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const box = document.getElementById("wildPick");
      if (!box || !state3) return;
      box.innerHTML = "";
      const SUIT_SYM3 = context.SUIT_SYM || (typeof window !== "undefined" ? window.SUIT_SYM : { S: "\u2660", H: "\u2665", C: "\u2663", D: "\u2666" });
      const SUIT_NAME2 = { S: "Spades", H: "Hearts", C: "Clubs", D: "Diamonds" };
      const SUITS3 = context.SUITS || (typeof window !== "undefined" ? window.SUITS : ["S", "H", "C", "D"]);
      const RANKS3 = context.RANKS || (typeof window !== "undefined" ? window.RANKS : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]);
      const RANK_NAME3 = context.RANK_NAME || (typeof window !== "undefined" ? window.RANK_NAME : { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" });
      const confirmWildAs2 = context.confirmWildAs || (typeof window !== "undefined" ? window.confirmWildAs : () => {
      });
      const header = document.createElement("div");
      header.className = "wild-pick-header";
      header.innerHTML = `
      <div class="wild-pick-badge">\u{1F0CF} JOKER REPLACEMENT</div>
      <h3 class="wild-pick-title">${state3.pendingSuit ? "Choose Card Rank" : "Choose Card Suit"}</h3>
      <p class="wild-pick-subtitle">${state3.pendingSuit ? `Suit: <strong style="color: ${state3.pendingSuit === "H" || state3.pendingSuit === "D" ? "#ef4444" : "#f0c64a"};">${SUIT_SYM3[state3.pendingSuit]} ${SUIT_NAME2[state3.pendingSuit]}</strong> \u2014 pick any rank:` : "Select which suit your Joker will become:"}</p>
    `;
      box.appendChild(header);
      if (!state3.pendingSuit) {
        const suitRow = document.createElement("div");
        suitRow.className = "wild-pick-suit-grid";
        for (const su of SUITS3) {
          const b = document.createElement("button");
          b.type = "button";
          b.className = "wild-pick-suit-btn" + (su === "H" || su === "D" ? " is-red" : " is-black");
          b.innerHTML = `
          <span class="wild-suit-icon">${SUIT_SYM3[su]}</span>
          <span class="wild-suit-name">${SUIT_NAME2[su]}</span>
        `;
          const ink2 = su === "H" || su === "D" ? "#c0392b" : "#1a1208";
          _ModalManager.stylePickBtn(b, ink2);
          b.onclick = () => {
            state3.pendingSuit = su;
            _ModalManager.drawWildPick(context);
          };
          suitRow.appendChild(b);
        }
        box.appendChild(suitRow);
        return;
      }
      const backBtn = document.createElement("div");
      backBtn.setAttribute("role", "button");
      backBtn.setAttribute("tabindex", "0");
      backBtn.className = "wild-pick-back-btn";
      backBtn.innerHTML = "\u2190 Choose Different Suit";
      backBtn.onclick = () => {
        state3.pendingSuit = null;
        _ModalManager.drawWildPick(context);
      };
      backBtn.onkeydown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          state3.pendingSuit = null;
          _ModalManager.drawWildPick(context);
        }
      };
      box.appendChild(backBtn);
      const isRed = state3.pendingSuit === "H" || state3.pendingSuit === "D";
      const ink = isRed ? "#c0392b" : "#1a1208";
      const rankGrid = document.createElement("div");
      rankGrid.className = "wild-pick-rank-grid";
      for (const r of RANKS3) {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "wild-pick-rank-btn" + (isRed ? " is-red" : " is-black");
        b.innerHTML = `
        <span class="wild-rank-val">${RANK_NAME3[r]}</span>
        <span class="wild-rank-suit">${SUIT_SYM3[state3.pendingSuit]}</span>
      `;
        _ModalManager.stylePickBtn(b, ink);
        b.onclick = () => confirmWildAs2(r, state3.pendingSuit);
        rankGrid.appendChild(b);
      }
      box.appendChild(rankGrid);
    }
    passTo(who, thenFn, context) {
      return _ModalManager.passTo(who, thenFn, context);
    }
    hideWildPick(context) {
      return _ModalManager.hideWildPick(context);
    }
    stylePickBtn(b, ink) {
      return _ModalManager.stylePickBtn(b, ink);
    }
    openWildPick(c, kind, context) {
      return _ModalManager.openWildPick(c, kind, context);
    }
    drawWildPick(context) {
      return _ModalManager.drawWildPick(context);
    }
    setupCloseButtonEvents(handlers) {
      return _ModalManager.setupCloseButtonEvents({
        hideModal: this.hideModal.bind(this),
        showIntro: this.showIntro.bind(this),
        ...handlers
      });
    }
    static showModal(html2, closable = false) {
      if (typeof window !== "undefined" && window.modalManager) {
        return window.modalManager.showModal(html2, closable);
      }
      const mgr = new _ModalManager();
      return mgr.showModal(html2, closable);
    }
    static hideModal(state3 = null) {
      if (typeof window !== "undefined" && window.modalManager) {
        return window.modalManager.hideModal(state3);
      }
      const mgr = new _ModalManager();
      return mgr.hideModal(state3);
    }
    static showOverlay(html2, closable = false) {
      return _ModalManager.showModal(html2, closable);
    }
    static hideOverlay() {
      return _ModalManager.hideModal();
    }
    static closeModal() {
      return _ModalManager.hideModal();
    }
    static closeOverlay() {
      return _ModalManager.hideModal();
    }
    static showConfirmModal(opts = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showConfirmModal === "function") {
        return window.modalManager.showConfirmModal(opts);
      }
      const mgr = new _ModalManager();
      return mgr.showConfirmModal(opts);
    }
    static showDiscardTrainerModal(context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showDiscardTrainerModal === "function") {
        return window.modalManager.showDiscardTrainerModal(context);
      }
      const mgr = new _ModalManager();
      return mgr.showDiscardTrainerModal(context);
    }
    static showPeggingTrainerModal(context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showPeggingTrainerModal === "function") {
        return window.modalManager.showPeggingTrainerModal(context);
      }
      const mgr = new _ModalManager();
      return mgr.showPeggingTrainerModal(context);
    }
    static showCountingTrainerModal(context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showCountingTrainerModal === "function") {
        return window.modalManager.showCountingTrainerModal(context);
      }
      const mgr = new _ModalManager();
      return mgr.showCountingTrainerModal(context);
    }
    static showCoachPostMortemModal(context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showCoachPostMortemModal === "function") {
        return window.modalManager.showCoachPostMortemModal(context);
      }
      const mgr = new _ModalManager();
      return mgr.showCoachPostMortemModal(context);
    }
    static showCoachPostMortemShareModal(report) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showCoachPostMortemShareModal === "function") {
        return window.modalManager.showCoachPostMortemShareModal(report);
      }
      return CoachPostMortem.openShareDialog(report);
    }
    static shareCoachPostMortem(report) {
      return _ModalManager.showCoachPostMortemShareModal(report);
    }
    /**
     * Displays the game summary scorecard modal with hand-by-hand points and running totals.
     * @param {Object} [context]
     */
    showGameSummaryModal(context = {}) {
      const showModalFn = this.showModal.bind(this);
      const state3 = context.state || (typeof window !== "undefined" && window.state ? window.state : {});
      const settings3 = context.settings || (typeof window !== "undefined" && window.settings ? window.settings : {});
      const html2 = HandScoreTracker.buildScorecardHtml({ state: state3, settings: settings3, ...context });
      const isGameOver = Boolean(state3 && state3.over);
      showModalFn(html2, {
        showClose: true,
        onClose: () => {
          if (isGameOver) {
            if (typeof window !== "undefined" && typeof window.showGameWonModal === "function" && window.showGameWonModal()) {
              return;
            }
            if (typeof this.showGameWonModal === "function" && this.showGameWonModal()) {
              return;
            }
          }
          this.hideModal();
        }
      });
      if (typeof HandScoreTracker !== "undefined" && typeof HandScoreTracker.bindEvents === "function" && typeof document !== "undefined") {
        const modalEl = document.getElementById("modal");
        HandScoreTracker.bindEvents(modalEl || document);
      }
    }
    static showGameSummaryModal(context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showGameSummaryModal === "function") {
        return window.modalManager.showGameSummaryModal(context);
      }
      const mgr = new _ModalManager();
      return mgr.showGameSummaryModal(context);
    }
    showGameWonModal() {
      if (typeof GameEngine !== "undefined" && typeof GameEngine.showGameWonModal === "function") {
        return GameEngine.showGameWonModal();
      }
      if (typeof window !== "undefined" && window.GameEngine && typeof window.GameEngine.showGameWonModal === "function") {
        return window.GameEngine.showGameWonModal();
      }
      if (typeof window !== "undefined" && typeof window.showGameWonModal === "function") {
        return window.showGameWonModal();
      }
      return false;
    }
    static showGameWonModal() {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showGameWonModal === "function") {
        return window.modalManager.showGameWonModal();
      }
      const mgr = new _ModalManager();
      return mgr.showGameWonModal();
    }
    /**
     * Displays the Hand of Glory card modal for sharing big hands.
     * @param {string|Object} keyOrData
     * @param {Object} [context]
     */
    showHandOfGloryModal(keyOrData, context = {}) {
      return HandOfGloryCard.showModal(keyOrData, context);
    }
    static showHandOfGloryModal(keyOrData, context = {}) {
      return HandOfGloryCard.showModal(keyOrData, context);
    }
    closeHandOfGloryModal() {
      return HandOfGloryCard.closeModal();
    }
    static closeHandOfGloryModal() {
      return HandOfGloryCard.closeModal();
    }
    /**
     * Displays the confirmation modal when a human player disconnects.
     * @param {string} seatId
     * @param {string} seatName
     * @param {Function} onConfirm Callback if user chooses to replace with computer
     * @param {Function} [onWait] Callback if user chooses to wait
     * @param {Function} [onCancel] Callback if user chooses to cancel game
     * @param {Object} [context]
     */
    showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context = {}) {
      const showModalFn = this.showModal.bind(this);
      const hideModalFn = this.hideModal.bind(this);
      const name = seatName3 || (seatId ? seatId.toUpperCase() : "A player");
      const html2 = `
      <div class="offline-modal-wrap">
        <div class="offline-warning-icon">\u26A0\uFE0F</div>
        <h3 class="offline-modal-title">Player Went Offline</h3>
        <p class="offline-modal-desc">
          <strong>${name}</strong> has disconnected from the match.<br>
          Would you like to replace them with a computer player so the game can continue?
        </p>
        <div class="ai-replace-actions">
          <button type="button" class="btn-gold btn-ai-choice" id="btnReplaceYes">\u{1F916} Yes, Replace with Computer</button>
          <button type="button" class="btn-ghost btn-ai-choice" id="btnReplaceWait">\u23F3 Wait for Reconnection</button>
          <button type="button" class="btn-gold btn-ai-choice" id="btnReplaceCancel">\u2715 Cancel Game</button>
        </div>
      </div>
    `;
      showModalFn(html2, false);
      setTimeout(() => {
        if (typeof document === "undefined") return;
        const btnYes = document.getElementById("btnReplaceYes");
        const btnWait = document.getElementById("btnReplaceWait");
        const btnCancel = document.getElementById("btnReplaceCancel");
        if (btnYes) {
          btnYes.onclick = () => {
            hideModalFn();
            if (typeof onConfirm === "function") onConfirm(seatId, name);
          };
        }
        if (btnWait) {
          btnWait.onclick = () => {
            hideModalFn();
            if (typeof onWait === "function") onWait(seatId, name);
          };
        }
        if (btnCancel) {
          btnCancel.onclick = () => {
            hideModalFn();
            if (typeof onCancel === "function") {
              onCancel(seatId, name);
            } else if (typeof window !== "undefined" && typeof window.cancelGameAndReturnToMenu === "function") {
              window.cancelGameAndReturnToMenu();
            } else {
              try {
                const st = context.state || (typeof window !== "undefined" ? window.state : typeof globalThis !== "undefined" ? globalThis.state : null);
                if (st) st.over = true;
                const camMgr = typeof window !== "undefined" && (window._ccCameraManager || window.CrazyCribbage && window.CrazyCribbage.CameraManager && window.CrazyCribbage.CameraManager.getInstance());
                if (camMgr && camMgr.isBroadcasting) camMgr.stopBroadcast();
                const chatMgr = typeof window !== "undefined" && (window._ccChatManager || window.CrazyCribbage && window.CrazyCribbage.ChatManager && window.CrazyCribbage.ChatManager.getInstance());
                if (chatMgr) {
                  chatMgr.setChatVisibility(false);
                  chatMgr.clearChat();
                }
              } catch (e) {
              }
              if (typeof document !== "undefined") {
                const game = document.getElementById("game");
                const menu = document.getElementById("menu");
                if (game) game.classList.add("hidden");
                if (menu) menu.classList.remove("hidden");
                const waitBar = document.getElementById("reconnectWaitBar");
                if (waitBar) waitBar.remove();
              }
              if (typeof window !== "undefined" && typeof window.renderRecordBox === "function") {
                window.renderRecordBox();
              }
            }
          };
        }
      }, 10);
    }
    static showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showPlayerOfflineModal === "function") {
        return window.modalManager.showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context);
      }
      const mgr = new _ModalManager();
      return mgr.showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context);
    }
    /**
     * Displays the AI personality selection modal to pick which computer player replaces a disconnected human.
     * @param {string} seatId
     * @param {string} seatName
     * @param {Function} onSelectAi Callback receiving (profileKey, displayName)
     * @param {Object} [context]
     */
    showPickAiReplacementModal(seatId, seatName3, onSelectAi, context = {}) {
      const showModalFn = this.showModal.bind(this);
      const hideModalFn = this.hideModal.bind(this);
      const name = seatName3 || (seatId ? seatId.toUpperCase() : "Player");
      const aiProfiles = [
        {
          id: "shark",
          name: "The Shark",
          avatar: "\u{1F988}",
          level: "Expert",
          badge: "Expert \xB7 GTO / EV Optimal",
          desc: "Plays mathematically optimal cribbage. Analyzes discard EV permutations and pegging counts for maximum points."
        },
        {
          id: "master",
          name: "The Grandmaster",
          avatar: "\u{1F451}",
          level: "Expert",
          badge: "Expert \xB7 Tournament Precision",
          desc: "Seasoned tournament champion playing disciplined positional cribbage with deep board-position awareness."
        },
        {
          id: "turtler",
          name: "The Turtler",
          avatar: "\u{1F422}",
          level: "Advanced",
          badge: "Advanced \xB7 Defensive Strategy",
          desc: "Starves opponent cribs of synergy, refuses to give away 15s or 31s, and controls pegging count securely."
        },
        {
          id: "maverick",
          name: "The Maverick",
          avatar: "\u26A1",
          level: "Advanced",
          badge: "Advanced \xB7 Tactical Pressure",
          desc: "Assertive, high-tempo tactician who pushes pegging runs, sets trap cards, and keeps constant pressure on the board."
        },
        {
          id: "gambler",
          name: "The Gambler",
          avatar: "\u{1F3B2}",
          level: "Intermediate",
          badge: "Intermediate \xB7 Aggressive & Big Hands",
          desc: "Chases explosive hands, risk-heavy discards, and aggressive pairing during pegging to create high-scoring action."
        },
        {
          id: "regular",
          name: "The Regular",
          avatar: "\u2615",
          level: "Intermediate",
          badge: "Intermediate \xB7 Steady Fundamentals",
          desc: "Dependable cribbage player following time-tested counting principles, balanced crib discards, and safe leads."
        },
        {
          id: "rookie",
          name: "The Rookie",
          avatar: "\u{1F331}",
          level: "Beginner",
          badge: "Beginner \xB7 Friendly & Relaxed",
          desc: "Friendly, casual opponent focused on straightforward counting. Perfect for a relaxing, stress-free match."
        },
        {
          id: "casual",
          name: "The Casual",
          avatar: "\u{1F37A}",
          level: "Beginner",
          badge: "Beginner \xB7 Easygoing & Learning",
          desc: "Easygoing, social player who plays simple, natural card combinations without laying counter-traps or tracking crib odds."
        }
      ];
      let selectedProfile = "shark";
      const renderCardsHtml = () => {
        return aiProfiles.map((p) => `
        <div class="ai-card ${p.id === selectedProfile ? "selected" : ""}" data-ai-id="${p.id}" tabindex="0" role="button" aria-pressed="${p.id === selectedProfile}">
          <div class="ai-card-avatar">${p.avatar}</div>
          <div class="ai-card-name">${p.name}</div>
          <div class="ai-card-badge">${p.badge}</div>
          <div class="ai-card-desc">${p.desc}</div>
        </div>
      `).join("");
      };
      const html2 = `
      <div class="offline-modal-wrap">
        <h3 class="offline-modal-title">Choose Computer Player</h3>
        <p class="offline-modal-desc">
          Select which computer personality takes over for <strong>${name}</strong>:
        </p>
        <div class="ai-replace-options" id="aiReplaceCards">
          ${renderCardsHtml()}
        </div>
        <div class="ai-replace-actions">
          <button type="button" class="btn-gold btn-ai-choice" id="btnConfirmAiTakeover">Confirm AI Takeover</button>
          <button type="button" class="btn-ghost btn-ai-choice" id="btnCancelAiTakeover">Cancel</button>
        </div>
      </div>
    `;
      showModalFn(html2, true);
      setTimeout(() => {
        if (typeof document === "undefined") return;
        const container = document.getElementById("aiReplaceCards");
        if (container) {
          container.querySelectorAll(".ai-card").forEach((card) => {
            card.onclick = () => {
              const pId = card.getAttribute("data-ai-id");
              if (pId) {
                selectedProfile = pId;
                container.querySelectorAll(".ai-card").forEach((c) => {
                  const match = c.getAttribute("data-ai-id") === pId;
                  c.classList.toggle("selected", match);
                  c.setAttribute("aria-pressed", match ? "true" : "false");
                });
              }
            };
          });
        }
        const btnConfirm = document.getElementById("btnConfirmAiTakeover");
        const btnCancel = document.getElementById("btnCancelAiTakeover");
        if (btnConfirm) {
          btnConfirm.onclick = () => {
            hideModalFn();
            const chosen = aiProfiles.find((x) => x.id === selectedProfile) || aiProfiles[0];
            if (typeof onSelectAi === "function") {
              onSelectAi(chosen.id, chosen.name);
            }
          };
        }
        if (btnCancel) {
          btnCancel.onclick = () => {
            hideModalFn();
          };
        }
      }, 10);
    }
    static showPickAiReplacementModal(seatId, seatName3, onSelectAi, context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showPickAiReplacementModal === "function") {
        return window.modalManager.showPickAiReplacementModal(seatId, seatName3, onSelectAi, context);
      }
      const mgr = new _ModalManager();
      return mgr.showPickAiReplacementModal(seatId, seatName3, onSelectAi, context);
    }
    /**
     * Prompts the human pone to guess the rank of the starter card before it is revealed.
     * @param {string} poneSeat
     * @param {function} onGuess
     * @param {Object} [context]
     */
    static openGuessStarterPrompt(poneSeat, onGuess, context = {}) {
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const showModal2 = context.showModal || (typeof window !== "undefined" && window.modalManager && window.modalManager.showModal ? window.modalManager.showModal.bind(window.modalManager) : (html3, closable) => {
        _ModalManager.showModal(html3, closable);
      });
      const hideModal3 = context.hideModal || (typeof window !== "undefined" && window.modalManager && window.modalManager.hideModal ? window.modalManager.hideModal.bind(window.modalManager) : () => {
        _ModalManager.hideModal();
      });
      const pTitle = seatName3(poneSeat);
      const ranks = [
        { r: 1, name: "A" },
        { r: 2, name: "2" },
        { r: 3, name: "3" },
        { r: 4, name: "4" },
        { r: 5, name: "5" },
        { r: 6, name: "6" },
        { r: 7, name: "7" },
        { r: 8, name: "8" },
        { r: 9, name: "9" },
        { r: 10, name: "10" },
        { r: 11, name: "J" },
        { r: 12, name: "Q" },
        { r: 13, name: "K" }
      ];
      if (typeof window !== "undefined") {
        window.selectGuessStarter = (rank) => {
          hideModal3();
          if (typeof onGuess === "function") {
            onGuess(Number(rank));
          }
        };
      }
      const buttonsHtml = ranks.map((item) => `
      <button type="button" class="guess-starter-chip" data-rank="${item.r}" aria-label="Guess ${item.name}">
        ${item.name}
      </button>
    `).join("");
      const html2 = `
      <div class="guess-starter-box">
        <div class="guess-starter-badge">\u{1F3AF} Bonus: Guess Starter</div>
        <h2 style="margin: 4px 0 10px; font-size: 1.4rem; color: #fff;">Guess the Starter Card!</h2>
        <p style="margin: 0 0 6px; font-size: 1rem; color: #e2e8f0;">
          <strong>${pTitle}</strong>, guess the rank of the cut starter card before it is turned over.
        </p>
        <p style="margin: 0 0 16px; font-size: 0.88rem; color: #94a3b8;">
          Any suit matches! A correct guess scores <strong>+3 points</strong>.
        </p>
        <div class="guess-starter-grid">
          ${buttonsHtml}
        </div>
      </div>
    `;
      showModal2(html2, false);
      if (typeof document === "undefined") return;
      const chips = document.querySelectorAll(".guess-starter-chip");
      chips.forEach((btn) => {
        btn.addEventListener("click", () => {
          const rank = parseInt(btn.getAttribute("data-rank"), 10);
          hideModal3();
          if (typeof onGuess === "function") {
            onGuess(rank);
          }
        });
      });
    }
    openGuessStarterPrompt(poneSeat, onGuess, context) {
      return _ModalManager.openGuessStarterPrompt(poneSeat, onGuess, context);
    }
  };

  // src/variants/CanadianDoublesModal.js
  var CanadianDoublesModal = class {
    /**
     * Opens the interactive Canadian Doubles organizer modal.
     * @param {string} organizerSeat - The seat organizing (pone or dealer)
     * @param {Object} [context={}]
     */
    static open(organizerSeat, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const showModal2 = context.showModal || (typeof window !== "undefined" ? window.modalManager ? window.modalManager.showModal.bind(window.modalManager) : window.showModal || ModalManager2.showModal : ModalManager2.showModal);
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.modalManager ? window.modalManager.hideModal.bind(window.modalManager) : window.hideModal || ModalManager2.hideModal : ModalManager2.hideModal);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const onComplete = context.onComplete || (() => {
      });
      const partnerSeat = organizerSeat === "p1" ? "p3" : organizerSeat === "p2" ? "p4" : organizerSeat === "p3" ? "p1" : "p2";
      const isDealer = organizerSeat === state3.dealer || partnerSeat === state3.dealer;
      const rawCards = (getSeatHand2(organizerSeat) || []).slice();
      const tenCards = rawCards.length >= 10 ? rawCards.slice(0, 10) : rawCards;
      const optimal = CribbageAI.organizeCanadianDoubles(tenCards, isDealer, { settings: settings3, starter: state3.starter });
      let keepHand = optimal && optimal.keepHand ? [...optimal.keepHand] : tenCards.slice(0, 4);
      let partnerHand = optimal && optimal.partnerHand ? [...optimal.partnerHand] : tenCards.slice(4, 8);
      let cribDiscards = optimal && optimal.cribDiscards ? [...optimal.cribDiscards] : tenCards.slice(8, 10);
      let selected = null;
      let toastMsg = "\u{1F4A1} Cards auto-arranged for highest score. Click cards in different sections to swap.";
      const rankNames = { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" };
      const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      function renderSingleCard(c, zone, idx, isSelected) {
        const suit = c.suit || c.s || "S";
        const isRed = suit === "H" || suit === "D";
        const color = isRed ? "#dc2626 !important" : "#111827 !important";
        const r = c.rankName || c.r || rankNames[c.rank] || c.rank || "\u2605";
        const sym = suitSyms[suit] || suit || "";
        const cardBorder = isSelected ? "border: 2px solid #f59e0b;" : "border: 2px solid #cbd5e1;";
        const cardShadow = isSelected ? "box-shadow: 0 0 16px rgba(245, 158, 11, 0.95), 0 4px 14px rgba(0,0,0,0.5); transform: translateY(-6px);" : "box-shadow: 0 4px 10px rgba(0,0,0,0.35);";
        const zoneLabel = zone === "keep" ? "You" : zone === "partner" ? "Partner" : "Crib";
        return `
        <div class="playing-card canadian-card ${isRed ? "red card-red" : "black card-black"}${isSelected ? " selected" : ""}"
             id="canCard_${zone}_${idx}"
             data-action="canadian-card"
             data-zone="${zone}"
             data-index="${idx}"
             style="position: relative; width: 62px; height: 90px; box-sizing: border-box; background: #ffffff !important; border-radius: 8px; display: flex; flex-direction: column; justify-content: space-between; padding: 5px 6px; text-align: left; cursor: pointer; transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease; ${cardBorder} ${cardShadow}">
          <div class="canadian-card-corner" style="font-size: 1rem; font-weight: 900; color: ${color}; -webkit-text-fill-color: ${color}; line-height: 1;">${r}<span style="font-size: 0.85rem; margin-left: 2px; color: ${color}; -webkit-text-fill-color: ${color};">${sym}</span></div>
          <div class="canadian-card-center" style="font-size: 1.7rem; color: ${color}; -webkit-text-fill-color: ${color}; line-height: 1; text-align: center;">${sym}</div>
          <div class="canadian-card-label" style="font-size: 0.62rem; font-weight: 700; color: #64748b !important; -webkit-text-fill-color: #64748b !important; text-align: center; text-transform: uppercase;">${zoneLabel}</div>
        </div>
      `;
      }
      function renderModalContent() {
        const scoreOpts = { verbose: true, ...settings3 };
        const s1 = keepHand.length === 4 ? CribbageScorer2.scoreHand(keepHand, state3.starter, false, scoreOpts) || { total: 0, notes: [] } : { total: 0, notes: [] };
        const s2 = partnerHand.length === 4 ? CribbageScorer2.scoreHand(partnerHand, state3.starter, false, scoreOpts) || { total: 0, notes: [] } : { total: 0, notes: [] };
        const sCrib = cribDiscards.length === 2 ? CribbageScorer2.scoreHand(cribDiscards, state3.starter, true, scoreOpts) || { total: 0, notes: [] } : { total: 0, notes: [] };
        const teamTotal = s1.total + s2.total;
        const formatNotesList = (notes) => {
          if (!notes || !notes.length) return '<span style="color:#64748b;">No combinations</span>';
          return notes.map((n) => `<span style="display:inline-block; margin-right:8px; color:#cbd5e1;">${n}</span>`).join("\xB7 ");
        };
        const keepCardsHtml = keepHand.map((c, i) => renderSingleCard(c, "keep", i, selected && selected.zone === "keep" && selected.idx === i)).join("");
        const partnerCardsHtml = partnerHand.map((c, i) => renderSingleCard(c, "partner", i, selected && selected.zone === "partner" && selected.idx === i)).join("");
        const cribCardsHtml = cribDiscards.map((c, i) => renderSingleCard(c, "crib", i, selected && selected.zone === "crib" && selected.idx === i)).join("");
        const myName = seatName(organizerSeat);
        const partnerName = seatName(partnerSeat);
        const cribTitle = isDealer ? `YOUR TEAM'S CRIB (${seatName(state3.dealer)})` : `OPPONENT'S CRIB (${seatName(state3.dealer)})`;
        return `
        <div class="canadian-modal-box">
          <div class="canadian-badge">\u{1F341} CANADIAN DOUBLES \u2014 HAND DISTRIBUTION</div>
          <h2 class="canadian-modal-title">Organize Your 10 Cards</h2>
          <div class="canadian-modal-subtitle">
            ${myName}, keep 4 cards for your hand, pass 4 to your partner (${partnerName}), and discard 2 to the crib.
          </div>

          <div class="canadian-scoreboard">
            <div style="text-align:right;">
              <div style="font-size:0.75rem; text-transform:uppercase; color:#94a3b8; font-weight:700;">Your Hand (${myName})</div>
              <div style="font-size:1.35rem; font-weight:800; color:#60a5fa;">+${s1.total} pts</div>
            </div>
            <div style="font-size:1.6rem; font-weight:900; color:#64748b;">+</div>
            <div style="text-align:left;">
              <div style="font-size:0.75rem; text-transform:uppercase; color:#94a3b8; font-weight:700;">Partner (${partnerName})</div>
              <div style="font-size:1.35rem; font-weight:800; color:#c084fc;">+${s2.total} pts</div>
            </div>
            <div style="font-size:1.6rem; font-weight:900; color:#64748b;">=</div>
            <div style="border-left:2px solid rgba(255,255,255,0.15); padding-left:14px; text-align:left;">
              <div style="font-size:0.75rem; text-transform:uppercase; color:#fde047; font-weight:800; letter-spacing:0.05em;">TEAM HAND TOTAL</div>
              <div class="canadian-score-total">${teamTotal} PTS</div>
            </div>
          </div>

          ${toastMsg ? `<div style="margin: 4px auto 10px; color:#38bdf8; font-weight:700; font-size:0.84rem;">${toastMsg}</div>` : ""}

          <div class="canadian-hands-grid">
            <div class="canadian-hand-panel hand-you">
              <div class="canadian-hand-header">
                <span class="canadian-hand-name">YOUR HAND (${myName}) \xB7 4 CARDS</span>
                <span class="canadian-hand-pts">${s1.total} pts</span>
              </div>
              <div class="canadian-cards-row">
                ${keepCardsHtml}
              </div>
              <div class="canadian-notes">
                ${formatNotesList(s1.notes)}
              </div>
            </div>

            <div class="canadian-hand-panel hand-partner">
              <div class="canadian-hand-header">
                <span class="canadian-hand-name">PASS TO PARTNER (${partnerName}) \xB7 4 CARDS</span>
                <span class="canadian-hand-pts">${s2.total} pts</span>
              </div>
              <div class="canadian-cards-row">
                ${partnerCardsHtml}
              </div>
              <div class="canadian-notes">
                ${formatNotesList(s2.notes)}
              </div>
            </div>
          </div>

          <div class="canadian-hand-panel hand-crib" style="max-width: 480px; margin: 0 auto 16px;">
            <div class="canadian-hand-header">
              <span class="canadian-hand-name">${cribTitle} \xB7 2 CARDS</span>
              <span class="canadian-hand-pts" style="${isDealer ? "color:#4ade80; border-color:rgba(74,222,128,0.4);" : "color:#f87171; border-color:rgba(248,113,113,0.4);"}">${sCrib.total} pts</span>
            </div>
            <div class="canadian-cards-row">
              ${cribCardsHtml}
            </div>
            <div style="font-size: 0.72rem; color: #94a3b8; text-align: center;">
              ${isDealer ? "\u2B50 Your team scores the crib!" : "\u26A0\uFE0F Opponents score this crib. Discard safe cards!"}
            </div>
          </div>

          <div class="canadian-actions">
            <button type="button" class="btn-canadian-opt" data-action="canadian-opt">
              \u26A1 Auto-Optimize (Best Scores)
            </button>
            <button type="button" class="btn-canadian-confirm" data-action="canadian-confirm">
              \u{1F341} Confirm Hand Distribution
            </button>
          </div>
        </div>
      `;
      }
      function refreshUI() {
        const modal = document.getElementById("modal");
        if (modal) {
          modal.innerHTML = renderModalContent();
        }
      }
      window.onCanadianCardClick = (zone, idx) => {
        if (!selected) {
          selected = { zone, idx };
          toastMsg = `Selected card from ${zone === "keep" ? "Your Hand" : zone === "partner" ? "Partner's Hand" : "Crib"}. Click another card to swap.`;
          refreshUI();
          return;
        }
        if (selected.zone === zone && selected.idx === idx) {
          selected = null;
          toastMsg = "Selection cleared.";
          refreshUI();
          return;
        }
        const getArray = (z) => z === "keep" ? keepHand : z === "partner" ? partnerHand : cribDiscards;
        const arr1 = getArray(selected.zone);
        const arr2 = getArray(zone);
        const temp = arr1[selected.idx];
        arr1[selected.idx] = arr2[idx];
        arr2[idx] = temp;
        selected = null;
        toastMsg = "Cards swapped!";
        refreshUI();
      };
      window.onCanadianAutoOptimize = () => {
        const all10 = [...keepHand, ...partnerHand, ...cribDiscards];
        const opt = CribbageAI.organizeCanadianDoubles(all10, isDealer, { settings: settings3, starter: state3.starter });
        if (opt) {
          keepHand = [...opt.keepHand];
          partnerHand = [...opt.partnerHand];
          cribDiscards = [...opt.cribDiscards];
          selected = null;
          toastMsg = "\u26A1 Optimal partition restored!";
          refreshUI();
        }
      };
      window.onCanadianConfirm = () => {
        if (keepHand.length !== 4 || partnerHand.length !== 4 || cribDiscards.length !== 2) {
          toastMsg = "\u26A0\uFE0F Invalid card counts! Must have 4 in Hand, 4 to Partner, and 2 to Crib.";
          refreshUI();
          return;
        }
        const modalEl = document.getElementById("modal");
        if (modalEl) modalEl.removeEventListener("click", handleCanadianClick);
        delete window.onCanadianCardClick;
        delete window.onCanadianAutoOptimize;
        delete window.onCanadianConfirm;
        setSeatHand2(organizerSeat, keepHand);
        setSeatKept2(organizerSeat, keepHand.slice());
        setSeatHand2(partnerSeat, partnerHand);
        setSeatKept2(partnerSeat, partnerHand.slice());
        state3.crib = state3.crib || [];
        state3.crib.push(...cribDiscards);
        state3.seatDiscards = state3.seatDiscards || {};
        state3.seatDiscards[organizerSeat] = cribDiscards;
        const myName = seatName(organizerSeat);
        const partnerName = seatName(partnerSeat);
        log2(`Canadian Doubles: ${myName} kept 4 cards, passed 4 cards to ${partnerName}, and discarded 2 cards to the crib.`);
        fancyCall2(`${myName} distributed 10 cards!`, "combo", 1500);
        if (typeof hideModal3 === "function") {
          hideModal3();
        } else {
          const overlay = document.getElementById("overlay");
          if (overlay) overlay.style.display = "none";
        }
        render2();
        onComplete(organizerSeat);
      };
      const handleCanadianClick = (e) => {
        const card = e.target.closest('[data-action="canadian-card"], .canadian-card');
        if (card && card.dataset.zone !== void 0 && card.dataset.index !== void 0) {
          const zone = card.dataset.zone;
          const idx = parseInt(card.dataset.index, 10);
          if (typeof window.onCanadianCardClick === "function") {
            window.onCanadianCardClick(zone, idx);
          }
          return;
        }
        const optBtn = e.target.closest('[data-action="canadian-opt"], .btn-canadian-opt');
        if (optBtn) {
          if (typeof window.onCanadianAutoOptimize === "function") {
            window.onCanadianAutoOptimize();
          }
          return;
        }
        const confirmBtn = e.target.closest('[data-action="canadian-confirm"], .btn-canadian-confirm');
        if (confirmBtn) {
          if (typeof window.onCanadianConfirm === "function") {
            window.onCanadianConfirm();
          }
          return;
        }
      };
      if (typeof showModal2 === "function") {
        showModal2(renderModalContent(), false);
      } else {
        const modal = document.getElementById("modal");
        const overlay = document.getElementById("overlay");
        if (modal && overlay) {
          modal.innerHTML = renderModalContent();
          overlay.style.display = "flex";
        }
      }
      const modalContainer = document.getElementById("modal");
      if (modalContainer) {
        modalContainer.addEventListener("click", handleCanadianClick);
      }
    }
  };

  // src/game/GameEngine.js
  var GameEngine2 = class _GameEngine {
    /**
     * Computes the deal and discard configuration based on player count and deal style.
     * @param {number} [playerCount=2]
     * @param {string} [dealStyle='standard'] 'standard' | 'super'
     * @returns {{ dealCount: number, discardCount: number, keepCount: number, extraCribDealt: number }}
     */
    static getDealStructure(playerCount = 2, dealStyle = "standard", options = {}) {
      const settings3 = typeof dealStyle === "object" ? dealStyle : typeof options === "object" ? options : {};
      const style = typeof dealStyle === "string" ? dealStyle : settings3.deal || "standard";
      const count = Math.max(2, Math.min(8, parseInt(playerCount, 10) || 2));
      if (count === 4 && settings3.optCanadianDoubles) {
        return { dealCount: 10, discardCount: 2, keepCount: 4, extraCribDealt: 0 };
      }
      if (count === 2 && settings3.opt7CardCribbage) {
        return { dealCount: 7, discardCount: 2, keepCount: 5, extraCribDealt: 1 };
      }
      if (style === "super" && count === 2) {
        return { dealCount: 9, discardCount: 3, keepCount: 6, extraCribDealt: 0 };
      }
      if (count === 2) {
        return { dealCount: 6, discardCount: 2, keepCount: 4, extraCribDealt: 0 };
      }
      if (count === 3) {
        return { dealCount: 5, discardCount: 1, keepCount: 4, extraCribDealt: 1 };
      }
      return { dealCount: 5, discardCount: 1, keepCount: 4, extraCribDealt: 0 };
    }
    /**
     * Evaluates cut cards between players to determine initial dealer.
     * Lowest rank card cuts dealer (Ace is 1, lowest).
     * @param {Array<{ seatId: string, card: Object|Card }>} cuts
     * @returns {{ winnerSeatId: string|null, isTie: boolean }}
     */
    static resolveCutWinner(cuts) {
      if (!Array.isArray(cuts) || cuts.length === 0) {
        return { winnerSeatId: null, isTie: false };
      }
      let lowestRank = 999;
      let winner = null;
      let tie = false;
      for (const cut of cuts) {
        const card = Card2.from(cut.card);
        const r = card ? card.rank : 13;
        if (r < lowestRank) {
          lowestRank = r;
          winner = cut.seatId;
          tie = false;
        } else if (r === lowestRank) {
          tie = true;
        }
      }
      return {
        winnerSeatId: tie ? null : winner,
        isTie: tie
      };
    }
    /**
     * Checks if turning the starter card awards dealer "His Heels" (Two for his heels).
     * A cut Jack awards 2 points to the dealer.
     * @param {Object|Card} starterCard
     * @returns {number} 2 if Jack, 0 otherwise
     */
    static checkHisHeels(starterCard) {
      if (!starterCard) return 0;
      const card = Card2.from(starterCard);
      return card && card.rank === 11 ? 2 : 0;
    }
    /**
     * Finds the next active player who has a card that fits under currentCount.
     * Traverses seats circularly starting immediately after fromSeat.
     * @param {string} fromSeat Current playing seat ID
     * @param {number} count Current pegging count (0 to 31)
     * @param {Array<string>} activeSeats Ordered circular array of active seat IDs
     * @param {Object<string, Array>} seatHands Map of seatId -> cards
     * @returns {string|null} The next seat ID with a legal play, or null if nobody can play
     */
    static findNextPlayerWithPlay(fromSeat, count, activeSeats, seatHands) {
      let seats = activeSeats;
      if (!Array.isArray(seats) || seats.length === 0) {
        if (typeof window !== "undefined" && typeof window.getActiveSeatIds === "function") {
          seats = window.getActiveSeatIds();
        } else {
          seats = ["p1", "p2"];
        }
      }
      let hands = seatHands;
      if (!hands) {
        hands = {};
        for (const s of seats) {
          if (typeof window !== "undefined" && typeof window.getSeatHand === "function") {
            hands[s] = window.getSeatHand(s);
          } else if (typeof window !== "undefined" && window.state && window.state.hands) {
            hands[s] = window.state.hands[s] || [];
          }
        }
      }
      const cleanFrom = fromSeat === "you" ? "p1" : fromSeat === "cpu" ? "p2" : fromSeat;
      const fromIdx = seats.indexOf(cleanFrom);
      const startIdx = fromIdx !== -1 ? (fromIdx + 1) % seats.length : 0;
      for (let i = 0; i < seats.length; i++) {
        const idx = (startIdx + i) % seats.length;
        const sId = seats[idx];
        const cards = hands ? hands[sId] || [] : [];
        const hand = new Hand(cards);
        if (hand.hasPlayableCard(count)) {
          return sId;
        }
      }
      return null;
    }
    /**
     * Evaluates who leads the next pegging series after a 31 or Go reset.
     * The lead passes to the next player with cards remaining in hand.
     * @param {string} whoJustPlayed Seat ID of player who claimed the Go/31
     * @param {Array<string>} activeSeats Ordered active seats
     * @param {Object<string, Array>} seatHands Map of seatId -> remaining cards
     * @returns {string|null} Next lead seat ID or null if all hands empty
     */
    static getNextLeadPlayer(whoJustPlayed, activeSeats, seatHands) {
      let seats = activeSeats;
      if (!Array.isArray(seats) || seats.length === 0) {
        if (typeof window !== "undefined" && typeof window.getActiveSeatIds === "function") {
          seats = window.getActiveSeatIds();
        } else {
          seats = ["p1", "p2"];
        }
      }
      let hands = seatHands;
      if (!hands) {
        hands = {};
        for (const s of seats) {
          if (typeof window !== "undefined" && typeof window.getSeatHand === "function") {
            hands[s] = window.getSeatHand(s);
          } else if (typeof window !== "undefined" && window.state && window.state.hands) {
            hands[s] = window.state.hands[s] || [];
          }
        }
      }
      const cleanFrom = whoJustPlayed === "you" ? "p1" : whoJustPlayed === "cpu" ? "p2" : whoJustPlayed;
      const fromIdx = seats.indexOf(cleanFrom);
      const startIdx = fromIdx !== -1 ? (fromIdx + 1) % seats.length : 0;
      for (let i = 0; i < seats.length; i++) {
        const idx = (startIdx + i) % seats.length;
        const sId = seats[idx];
        const cards = hands ? hands[sId] || [] : [];
        if (cards.length > 0) {
          return sId;
        }
      }
      return null;
    }
    /**
     * Computes the point value for a Go or 31 pegging hit.
     * @param {number} currentCount
     * @param {boolean} [opt31For5=false] Whether 31's for 5 variant is active
     * @returns {{ points: number, text: string }}
     */
    static calculateGoPoints(currentCount, opt31For5 = false) {
      if (currentCount === 31) {
        const pts = opt31For5 ? 5 : 2;
        return { points: pts, text: "Thirty-one!" };
      }
      return { points: 1, text: "GO" };
    }
    /**
     * Checks whether match target score has been reached and resolves the winner.
     * Handles both standard Highball and reverse Lowball rules.
     * @param {Object<string, number>} scores Map of track/seat -> score
     * @param {number} [target=121]
     * @param {string} [goal='high'] 'high' | 'low'
     * @param {Array<string>} [tracks=['p1', 'p2']]
     * @returns {{ over: boolean, winner: string|null }}
     */
    static checkMatchOver(scores = {}, target = 121, goal = "high", tracks = ["p1", "p2"]) {
      const t = parseInt(target, 10) || 121;
      let over = false;
      let winner = null;
      if (goal === "high") {
        for (const key of tracks) {
          const sc = scores[key] || 0;
          if (sc >= t) {
            over = true;
            if (!winner || sc > (scores[winner] || 0)) {
              winner = key;
            }
          }
        }
      } else {
        for (const key of tracks) {
          const sc = scores[key] || 0;
          if (sc >= t) {
            over = true;
            const others = tracks.filter((k) => k !== key);
            others.sort((a, b) => (scores[a] || 0) - (scores[b] || 0));
            winner = others[0] || tracks[0];
            break;
          }
        }
      }
      return { over, winner };
    }
    /**
     * Applies a score delta to a player/team, resolving Stink Hole rules,
     * obstacle hazards (Jail, Bar, Timeout, Detour, Roundabout), No Passing Lane
     * restrictions, Stop Signs, Jump zones, and match winning checks.
     *
     * @param {string} who Player or team identifier
     * @param {number} n Points to add (or subtract)
     * @param {string} why Description of points
     * @param {Object} [context={}] Match context options
     * @returns {Object} Result summary describing points scored, hazard progression, and game status
     */
    static applyScoreDelta(who, n, why = "", context = {}) {
      if (!n || n === 0) {
        return { scored: 0, rawPoints: 0, key: null, noop: true };
      }
      const state3 = context.state || {};
      const settings3 = context.settings || {};
      const target = parseInt(settings3.target, 10) || 121;
      const activeTracks = context.activeTracks || ["p1", "p2"];
      const key = typeof context.scoreKey === "function" ? context.scoreKey(who) : who === "you" ? "p1" : who === "cpu" ? "p2" : who;
      if (!state3.scores) state3.scores = {};
      if (!state3.prev) state3.prev = {};
      if (state3.scores[key] === void 0) state3.scores[key] = 0;
      if (state3.prev[key] === void 0) state3.prev[key] = 0;
      if (!context.isSignAction) {
        if (!state3.lastScoreDelta) state3.lastScoreDelta = {};
        state3.lastScoreDelta[key] = n;
      }
      if (settings3.optStinkHole && state3.scores[key] === target - 1) {
        if (n !== 1 && n > 0) {
          return {
            scored: 0,
            rawPoints: n,
            key,
            stinkHoleBlocked: true,
            hazard: null
          };
        }
      }
      if (settings3.optJail && state3.jailed && state3.jailed[key] && state3.jailed[key].turnsRemaining > 0) {
        if (n > 0) {
          state3.jailed[key].turnsRemaining--;
          state3.jailed[key].step = (state3.jailed[key].step || 0) + 1;
          const left = state3.jailed[key].turnsRemaining;
          const used = 3 - left;
          const trapHole = state3.jailed[key].jailHole;
          const freed = left === 0;
          if (freed) {
            delete state3.jailed[key];
          }
          return {
            scored: 0,
            rawPoints: n,
            key,
            hazard: "jail",
            penaltyUsed: { left, used, freed, trapHole }
          };
        }
      }
      if (settings3.optBar && state3.atBar && state3.atBar[key] && state3.atBar[key].turnsRemaining > 0) {
        if (n > 0) {
          state3.atBar[key].turnsRemaining--;
          state3.atBar[key].step = (state3.atBar[key].step || 0) + 1;
          const left = state3.atBar[key].turnsRemaining;
          const used = 3 - left;
          const trapHole = state3.atBar[key].barHole;
          const freed = left === 0;
          if (freed) {
            delete state3.atBar[key];
          }
          return {
            scored: 0,
            rawPoints: n,
            key,
            hazard: "bar",
            penaltyUsed: { left, used, freed, trapHole }
          };
        }
      }
      if (settings3.optTimeout && state3.inTimeout && state3.inTimeout[key] && state3.inTimeout[key].turnsRemaining > 0) {
        if (n > 0) {
          state3.inTimeout[key].turnsRemaining--;
          state3.inTimeout[key].step = (state3.inTimeout[key].step || 0) + 1;
          const left = state3.inTimeout[key].turnsRemaining;
          const used = 3 - left;
          const trapHole = state3.inTimeout[key].timeoutHole;
          const freed = left === 0;
          if (freed) {
            delete state3.inTimeout[key];
          }
          return {
            scored: 0,
            rawPoints: n,
            key,
            hazard: "timeout",
            penaltyUsed: { left, used, freed, trapHole }
          };
        }
      }
      if (settings3.optDetour && state3.inDetour && state3.inDetour[key] && n > 0) {
        const dInfo = state3.inDetour[key];
        const newProgress = (dInfo.progress || 0) + n;
        if (newProgress <= 7) {
          dInfo.progress = newProgress;
          return {
            scored: 0,
            rawPoints: n,
            key,
            hazard: "detour",
            detourProgress: { progress: newProgress, cleared: false, detourHole: dInfo.detourHole }
          };
        } else {
          const overflow = newProgress - 7;
          const targetHole = Math.min(target, dInfo.detourHole + overflow);
          delete state3.inDetour[key];
          state3.prev[key] = state3.scores[key];
          state3.scores[key] = targetHole;
          _GameEngine._syncLegacyScoreAliases(state3, key);
          return {
            scored: targetHole - state3.prev[key],
            rawPoints: n,
            key,
            hazard: "detour",
            detourProgress: { progress: newProgress, cleared: true, targetHole, detourHole: dInfo.detourHole }
          };
        }
      }
      if (settings3.optRoundAbout && state3.inRoundAbout && state3.inRoundAbout[key] && n > 0) {
        const rInfo = state3.inRoundAbout[key];
        const newProgress = (rInfo.progress || 0) + n;
        if (newProgress <= 7) {
          rInfo.progress = newProgress;
          return {
            scored: 0,
            rawPoints: n,
            key,
            hazard: "roundabout",
            roundAboutProgress: { progress: newProgress, cleared: false, roundAboutHole: rInfo.roundAboutHole }
          };
        } else {
          const overflow = newProgress - 7;
          const targetHole = Math.min(target, rInfo.roundAboutHole + overflow);
          delete state3.inRoundAbout[key];
          state3.prev[key] = state3.scores[key];
          state3.scores[key] = targetHole;
          _GameEngine._syncLegacyScoreAliases(state3, key);
          return {
            scored: targetHole - state3.prev[key],
            rawPoints: n,
            key,
            hazard: "roundabout",
            roundAboutProgress: { progress: newProgress, cleared: true, targetHole, roundAboutHole: rInfo.roundAboutHole }
          };
        }
      }
      let ptsToAdd = n;
      let laneBlocked = false;
      let laneBlocker = null;
      if (n > 0) {
        const currentScore = state3.scores[key];
        const targetScore = currentScore + n;
        const passCheckFn = context.getNoPassing || ObstacleGeometry && ObstacleGeometry.getNoPassingLaneMaxScore;
        if (typeof passCheckFn === "function") {
          const passCheck = passCheckFn(who, currentScore, targetScore, state3, settings3, activeTracks);
          if (passCheck && passCheck.blocked) {
            laneBlocked = true;
            laneBlocker = passCheck.blockingPlayer;
            ptsToAdd = Math.max(0, passCheck.allowedScore - currentScore);
          }
        }
      }
      let stopSignHit = null;
      if (n > 0 && settings3.optStopSign) {
        const getStopsFn = context.getStopSigns || ObstacleGeometry && ObstacleGeometry.getStopSignConfigs;
        if (typeof getStopsFn === "function") {
          const stopSigns = getStopsFn(settings3);
          if (Array.isArray(stopSigns)) {
            const currentScore = state3.scores[key];
            const targetHole = currentScore + ptsToAdd;
            const hitStops = stopSigns.filter((s) => s && s.hole > currentScore && s.hole <= targetHole);
            if (hitStops.length > 0) {
              hitStops.sort((a, b) => a.hole - b.hole);
              const firstStop = hitStops[0];
              const maxAllowed = firstStop.hole - currentScore;
              if (maxAllowed < ptsToAdd) {
                const lost = ptsToAdd - Math.max(0, maxAllowed);
                ptsToAdd = Math.max(0, maxAllowed);
                stopSignHit = { hole: firstStop.hole, ptsLost: lost };
              }
            }
          }
        }
      }
      state3.prev[key] = state3.scores[key];
      state3.scores[key] = Math.max(0, state3.scores[key] + ptsToAdd);
      let jumpTriggered = null;
      if (settings3.optJump) {
        const getJumpFn = context.getJump || ObstacleGeometry && ObstacleGeometry.getJumpForHole;
        if (typeof getJumpFn === "function") {
          const jump = getJumpFn(state3.scores[key], settings3);
          if (jump && jump.dest !== state3.scores[key]) {
            const landedHole = state3.scores[key];
            let targetDest = jump.dest;
            let finalDest = targetDest;
            if (jump.isForward) {
              const passCheckFn = context.getNoPassing || ObstacleGeometry && ObstacleGeometry.getNoPassingLaneMaxScore;
              if (typeof passCheckFn === "function") {
                const jumpCheck = passCheckFn(who, landedHole, targetDest, state3, settings3, activeTracks);
                if (jumpCheck && jumpCheck.allowedScore !== void 0) {
                  finalDest = jumpCheck.allowedScore;
                }
              }
            }
            if (finalDest !== landedHole) {
              state3.scores[key] = Math.max(0, Math.min(target, finalDest));
              const diff = finalDest - landedHole;
              jumpTriggered = {
                from: landedHole,
                to: finalDest,
                diff,
                isForward: Boolean(jump.isForward)
              };
            }
          }
        }
      }
      let newTrapLanded = null;
      if (settings3.optJail) {
        const getJailFn = context.getJail || ObstacleGeometry && ObstacleGeometry.getJailForHole;
        if (typeof getJailFn === "function") {
          const jail = getJailFn(state3.scores[key], settings3);
          if (jail && (!state3.jailed || !state3.jailed[key])) {
            if (!state3.jailed) state3.jailed = {};
            state3.jailed[key] = { jailHole: state3.scores[key], turnsRemaining: 3, step: 0 };
            newTrapLanded = "jail";
          }
        }
      }
      if (!newTrapLanded && settings3.optBar) {
        const getBarFn = context.getBar || ObstacleGeometry && ObstacleGeometry.getBarForHole;
        if (typeof getBarFn === "function") {
          const bar = getBarFn(state3.scores[key], settings3);
          if (bar && (!state3.atBar || !state3.atBar[key])) {
            if (!state3.atBar) state3.atBar = {};
            state3.atBar[key] = { barHole: state3.scores[key], turnsRemaining: 3, step: 0 };
            newTrapLanded = "bar";
          }
        }
      }
      if (!newTrapLanded && settings3.optTimeout) {
        const getTimeoutFn = context.getTimeout || ObstacleGeometry && ObstacleGeometry.getTimeoutForHole;
        if (typeof getTimeoutFn === "function") {
          const timeout = getTimeoutFn(state3.scores[key], settings3);
          if (timeout && (!state3.inTimeout || !state3.inTimeout[key])) {
            if (!state3.inTimeout) state3.inTimeout = {};
            state3.inTimeout[key] = { timeoutHole: state3.scores[key], turnsRemaining: 3, step: 0 };
            newTrapLanded = "timeout";
          }
        }
      }
      if (!newTrapLanded && settings3.optDetour) {
        const getDetourFn = context.getDetour || ObstacleGeometry && ObstacleGeometry.getDetourForHole;
        if (typeof getDetourFn === "function") {
          const detour = getDetourFn(state3.scores[key], settings3);
          if (detour && (!state3.inDetour || !state3.inDetour[key])) {
            if (!state3.inDetour) state3.inDetour = {};
            state3.inDetour[key] = { detourHole: state3.scores[key], progress: 0 };
            newTrapLanded = "detour";
          }
        }
      }
      if (!newTrapLanded && settings3.optRoundAbout) {
        const getRoundAboutFn = context.getRoundAbout || ObstacleGeometry && ObstacleGeometry.getRoundAboutForHole;
        if (typeof getRoundAboutFn === "function") {
          const roundAbout = getRoundAboutFn(state3.scores[key], settings3);
          if (roundAbout && (!state3.inRoundAbout || !state3.inRoundAbout[key])) {
            if (!state3.inRoundAbout) state3.inRoundAbout = {};
            state3.inRoundAbout[key] = { roundAboutHole: state3.scores[key], progress: 0 };
            newTrapLanded = "roundabout";
          }
        }
      }
      let signBlockLanded = null;
      if (settings3.optSigns && !context.isSignAction && !state3._inSignAction) {
        const getSignsFn = context.getSignBlock || ObstacleGeometry && ObstacleGeometry.getSignBlockForHole;
        if (typeof getSignsFn === "function") {
          const signBlock = getSignsFn(state3.scores[key], settings3);
          if (signBlock) {
            signBlockLanded = signBlock;
          }
        }
      }
      let diceLanded = null;
      if (settings3.optDice && !context.isSignAction && !state3._inDiceAction && !state3._inSignAction) {
        const getDiceFn = context.getDice || ObstacleGeometry && ObstacleGeometry.getDiceForHole;
        if (typeof getDiceFn === "function") {
          const diceHit = getDiceFn(state3.scores[key], settings3);
          if (diceHit) {
            diceLanded = diceHit;
          }
        }
      }
      let wheelLanded = null;
      if ((settings3.optWheel || settings3.optSpinningWheel) && !context.isSignAction && !state3._inWheelAction && !state3._inSignAction) {
        const getWheelFn = context.getWheel || ObstacleGeometry && ObstacleGeometry.getWheelForHole;
        if (typeof getWheelFn === "function") {
          const wheelHit = getWheelFn(state3.scores[key], settings3);
          if (wheelHit) {
            wheelLanded = wheelHit;
          }
        }
      }
      _GameEngine._syncLegacyScoreAliases(state3, key);
      const oldS = state3.prev[key];
      const newS = state3.scores[key];
      const marks = [241, 361, 481].includes(target) ? [30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360, 390, 420, 450, 481].filter((m) => m < target).concat([target]) : [30, 60, 90, target];
      const passedMarks = marks.filter((m) => oldS < m && newS >= m);
      const gameHoleReached = newS >= target && oldS < target;
      let chutesTriggered = false;
      if (settings3.optChutesAndLadders) {
        chutesTriggered = _GameEngine.checkChutesAndLadders(state3, settings3, {
          ...context,
          getActiveTracks: () => activeTracks
        });
        if (!chutesTriggered) {
          state3.chutesAndLaddersTriggered = false;
          state3.chutesAndLaddersTiedScore = null;
        }
      }
      const gameOver = chutesTriggered ? { over: false, winner: null } : _GameEngine.checkMatchOver(state3.scores, target, settings3.goal || "high", activeTracks);
      return {
        scored: ptsToAdd,
        rawPoints: n,
        key,
        hazard: null,
        laneBlocked,
        laneBlocker,
        stopSignHit,
        jumpTriggered,
        newTrapLanded,
        signBlockLanded,
        diceLanded,
        wheelLanded,
        passedMarks,
        gameHoleReached,
        chutesTriggered,
        gameOver
      };
    }
    /**
     * Advances the dealer button to the next active player circularly.
     * @param {string} currentDealer Current dealer seat ID (e.g. 'p1', 'p2')
     * @param {Array<string>} [activeSeats=['p1', 'p2']] Ordered active seats
     * @returns {string} Next dealer seat ID
     */
    static advanceDealer(currentDealer, activeSeats = ["p1", "p2"]) {
      if (!Array.isArray(activeSeats) || activeSeats.length === 0) return "p1";
      const cur = currentDealer === "you" ? "p1" : currentDealer === "cpu" ? "p2" : currentDealer;
      const idx = activeSeats.indexOf(cur);
      if (idx === -1) return activeSeats[0];
      return activeSeats[(idx + 1) % activeSeats.length];
    }
    /**
     * Builds the sequence of show acts for the show / counting phase.
     * @param {string} dealer Current dealer seat ID
     * @param {Array<string>} [activeSeats=['p1', 'p2']]
     * @param {boolean} [hasCrib=true]
     * @returns {Array<string>} List of act keys (e.g. ['pone', 'dealer', 'crib'])
     */
    static getShowQueue(dealer, activeSeats = ["p1", "p2"], hasCrib = true) {
      if (!Array.isArray(activeSeats) || activeSeats.length <= 2) {
        const q2 = ["pone", "dealer"];
        if (hasCrib) q2.push("crib");
        return q2;
      }
      const d = dealer === "you" ? "p1" : dealer === "cpu" ? "p2" : dealer;
      const dIdx = activeSeats.indexOf(d);
      const startIdx = dIdx !== -1 ? (dIdx + 1) % activeSeats.length : 0;
      const q = [];
      for (let i = 0; i < activeSeats.length; i++) {
        const sId = activeSeats[(startIdx + i) % activeSeats.length];
        q.push(sId);
      }
      if (hasCrib) q.push("crib");
      return q;
    }
    /**
     * Advances the show act index and determines the next act descriptor.
     * @param {number} currentIdx
     * @param {Array<string>} queue
     * @returns {{ nextIdx: number, nextAct: string, isDone: boolean }}
     */
    static advanceShowAct(currentIdx, queue = []) {
      const nextIdx = currentIdx + 1;
      const isDone = nextIdx >= queue.length;
      const nextAct = isDone ? "done" : queue[nextIdx];
      return { nextIdx, nextAct, isDone };
    }
    /**
     * Creates a clean initial game state object for a new match.
     * @param {Object} [settings={}]
     * @param {Array<string>} [activeSeats=['p1', 'p2']]
     * @returns {Object}
     */
    static getInitialGameState(settings3 = {}, activeSeats = ["p1", "p2"]) {
      const scores = {};
      const prev = {};
      const handPeg = {};
      for (const sId of activeSeats) {
        scores[sId] = 0;
        prev[sId] = 0;
        handPeg[sId] = 0;
      }
      scores.you = 0;
      scores.cpu = 0;
      prev.you = 0;
      prev.cpu = 0;
      handPeg.you = 0;
      handPeg.cpu = 0;
      return {
        scores,
        prev,
        phase: "cut",
        over: false,
        winner: null,
        dealer: null,
        turn: null,
        count: 0,
        pile: [],
        played: [],
        handPeg,
        pegLog: [],
        jailed: {},
        atBar: {},
        inTimeout: {},
        inDetour: {},
        inRoundAbout: {},
        deck: [],
        crib: [],
        starter: null,
        starters: [],
        handsCompleted: 0,
        showAct: null,
        recorded: false
      };
    }
    /**
     * Helper to sync legacy 2P aliases (you/cpu) from p1/p2.
     * @private
     */
    static _syncLegacyScoreAliases(state3, key) {
      if (!state3 || !state3.scores) return;
      if (key === "p1" || key === "team1") {
        state3.scores.you = state3.scores[key];
        if (state3.prev) state3.prev.you = state3.prev[key];
      } else if (key === "p2" || key === "team2") {
        state3.scores.cpu = state3.scores[key];
        if (state3.prev) state3.prev.cpu = state3.prev[key];
      }
    }
    /**
     * Constructs and returns a complete, fully initialized match state object.
     * Initializes all seat/team scores, obstacle states, pause flags, card containers,
     * and sign configurations if optSigns is enabled.
     * @param {Object} [settings={}]
     * @param {Object} [options={}]
     * @returns {GameState|Object}
     */
    static createInitialMatchState(settings3 = {}, options = {}) {
      const sc = { p1: 0, p2: 0, p3: 0, p4: 0, p5: 0, p6: 0, p7: 0, p8: 0, team1: 0, team2: 0, team3: 0, team4: 0, you: 0, cpu: 0 };
      const pr = { p1: 0, p2: 0, p3: 0, p4: 0, p5: 0, p6: 0, p7: 0, p8: 0, team1: 0, team2: 0, team3: 0, team4: 0, you: 0, cpu: 0 };
      const stateData = {
        scores: sc,
        prev: pr,
        jailed: {},
        atBar: {},
        inTimeout: {},
        inDetour: {},
        inRoundAbout: {},
        signsState: {},
        lastScoreDelta: {},
        pausedForSign: false,
        pausedForAdultTimer: false,
        pausedForAdultStrip: false,
        pausedForPintsBonus: false,
        _resumeAfterSign: null,
        _resumeAfterAdultTimer: null,
        _resumeAfterPintsBonus: null,
        dealer: null,
        over: false,
        recorded: false,
        hands: { p1: [], p2: [], p3: [], p4: [], p5: [], p6: [], p7: [], p8: [] },
        kept: { p1: [], p2: [], p3: [], p4: [], p5: [], p6: [], p7: [], p8: [] },
        youHand: [],
        cpuHand: [],
        crib: [],
        deckDiscards: [],
        pile: [],
        selected: [],
        starter: null,
        count: 0,
        phase: "cut",
        discardsComplete: false,
        revealCrib: false,
        stolenCrib: null,
        stolenCribResolved: false,
        twistedCribbageResolved: false,
        twisted8Cards: null,
        starterGuess: null
      };
      if (settings3 && settings3.optSigns) {
        const getSignConfigs2 = options.getSignConfigs || (typeof window !== "undefined" && window.getSignConfigs ? window.getSignConfigs : null);
        if (typeof getSignConfigs2 === "function") {
          const blocks = getSignConfigs2() || [];
          blocks.forEach((b) => {
            if (b && b.id && Array.isArray(b.initialSigns)) {
              stateData.signsState[b.id] = [...b.initialSigns];
            }
          });
        }
      }
      const GameStateClass = options.GameState || GameState || typeof window !== "undefined" && window.CC && window.CC.GameState;
      return GameStateClass ? new GameStateClass(stateData) : stateData;
    }
    /**
     * Begins the initial match cut ritual to determine the first dealer.
     * @param {Object} [context]
     */
    static beginCut(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const resetAnims2 = context.resetAnims || (typeof window !== "undefined" ? window.resetAnims : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const shuffle2 = context.shuffle || (typeof window !== "undefined" ? window.shuffle : (arr) => arr);
      const makeDeck2 = context.makeDeck || (typeof window !== "undefined" ? window.makeDeck : () => []);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const stepNextCut2 = context.stepNextCut || (typeof window !== "undefined" ? window.stepNextCut : _GameEngine.stepNextCut);
      resetAnims2();
      state3.phase = "cut";
      if (sfx3 && typeof sfx3.shuffle === "function") sfx3.shuffle();
      state3.hands = { p1: [], p2: [], p3: [], p4: [] };
      state3.youHand = [];
      state3.cpuHand = [];
      state3.crib = [];
      state3.starter = null;
      state3.starters = [];
      state3.spadesCut = false;
      state3.starterGuess = null;
      state3.pile = [];
      state3.played = [];
      state3.selected = [];
      state3.count = 0;
      state3.cutDeck = shuffle2(makeDeck2());
      state3.cutPicks = {};
      state3.highlightIds = [];
      state3.cutTurn = "p1";
      setStatus2("Fan the deck and cut \u2014 tap how deep. Lowest card deals (Ace is low).");
      render2();
      netPush2();
      stepNextCut2(context);
    }
    /**
     * Renders the interactive cut fan in the match DOM.
     * @param {Object} [context]
     */
    static renderCutFan(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const fan = doc.getElementById("cutFan");
      const hint = doc.getElementById("cutHint");
      if (!fan) return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => true);
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const cardLabel2 = context.cardLabel || (typeof window !== "undefined" ? window.cardLabel : (c) => String(c.rank));
      const cardEl2 = context.cardEl || (typeof window !== "undefined" ? window.cardEl : null);
      const pickCut2 = context.pickCut || (typeof window !== "undefined" ? window.pickCut : _GameEngine.pickCut);
      const activeSeats = getActiveSeatIds2();
      const humanNeedsToCut = activeSeats.some((sId) => isSeatHuman2(sId) && (!state3 || !state3.cutPicks || !state3.cutPicks[sId]));
      const showing = Boolean(state3 && state3.phase === "cut" && state3.cutDeck && state3.cutDeck.length && !(state3.hands && state3.hands.p1 && state3.hands.p1.length) && humanNeedsToCut);
      fan.classList.toggle("hidden", !showing);
      if (hint) hint.classList.toggle("hidden", !showing);
      fan.innerHTML = "";
      if (!showing || !state3) return;
      const curTurn = state3.cutTurn || "p1";
      const curPick = state3.cutPicks && state3.cutPicks[curTurn];
      const isPassingDevice = !isOnline2() && Boolean(state3 && state3.passingTo);
      const isMyCut = !isPassingDevice && (isOnline2() ? (!state3.cutPicks || !state3.cutPicks[mySeat3()]) && state3.cutTurn === mySeat3() : isSeatHuman2(curTurn) && !curPick);
      if (hint) {
        if (isOnline2()) {
          const myPick = state3.cutPicks && state3.cutPicks[mySeat3()];
          if (myPick) {
            hint.textContent = "You cut the " + cardLabel2(myPick) + ". Waiting for other players to cut\u2026";
          } else if (isMyCut) {
            hint.textContent = "Your cut \u2014 click a card in the fan (left = top of deck, right = deeper).";
          } else {
            hint.textContent = seatName3(curTurn) + " is cutting the deck\u2026";
          }
        } else {
          if (isMyCut) {
            hint.textContent = (curTurn === "p1" ? "Your cut" : seatName3(curTurn) + "\u2019s cut") + " \u2014 click a card in the fan (lowest card deals).";
          } else {
            hint.textContent = seatName3(curTurn) + " is cutting the deck\u2026";
          }
        }
      }
      const deck = state3.cutDeck;
      if (Array.isArray(deck) && typeof cardEl2 === "function") {
        deck.forEach((c, i) => {
          const taken = Object.values(state3.cutPicks || {}).some((p) => p && p.id === c.id);
          if (taken) return;
          const el = cardEl2(c, {
            back: true,
            playable: isMyCut,
            onClick: isMyCut ? () => pickCut2(i, isOnline2() ? mySeat3() : curTurn, context) : void 0,
            anim: "fan",
            animKey: "cutfan-" + c.id,
            delay: Math.min(i * 28, 700)
          });
          el.style.zIndex = String(i + 1);
          el.title = isMyCut ? "Cut " + (i + 1) + " cards down" : "Waiting for cut\u2026";
          fan.appendChild(el);
        });
      }
    }
    /**
     * Resolves cut cards, declarations of initial dealer, and ties.
     * @param {Object} [context]
     */
    static resolveCuts(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (c) => c ? c.rank : 0);
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (c) => Boolean(c && c.wild));
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const shuffle2 = context.shuffle || (typeof window !== "undefined" ? window.shuffle : (arr) => arr);
      const makeDeck2 = context.makeDeck || (typeof window !== "undefined" ? window.makeDeck : () => []);
      const stepNextCut2 = context.stepNextCut || (typeof window !== "undefined" ? window.stepNextCut : _GameEngine.stepNextCut);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const cardLabel2 = context.cardLabel || (typeof window !== "undefined" ? window.cardLabel : (c) => String(c.rank));
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const newHand2 = context.newHand || (typeof window !== "undefined" ? window.newHand : _GameEngine.newHand);
      const activeSeats = getActiveSeatIds2();
      const allCut = activeSeats.every((sId) => state3.cutPicks && state3.cutPicks[sId]);
      if (!allCut) return;
      const entries2 = activeSeats.map((sId) => ({
        seatId: sId,
        card: state3.cutPicks[sId],
        rank: rankOf2(state3.cutPicks[sId])
      }));
      let minRank = 999;
      for (const e of entries2) {
        if (e.rank < minRank) minRank = e.rank;
      }
      const minEntries = entries2.filter((e) => e.rank === minRank);
      if (minEntries.length > 1 || entries2.some((e) => isWild2(e.card))) {
        const tieMsg = "Cut: Tie for lowest rank or joker \u2014 cut again.";
        log2(tieMsg);
        setStatus2(tieMsg);
        fancyCall2("Tie! Cut again", "go", 1500);
        render2();
        netPush2({ log: tieMsg, fancy: { text: "Tie! Cut again", kind: "go", ms: 1500 } });
        setTimeout(() => {
          if (!state3 || state3.over || state3.phase !== "cut" && state3.phase !== "cut-reveal") return;
          state3.cutPicks = {};
          state3.highlightIds = [];
          state3.cutTurn = "p1";
          state3.cutDeck = shuffle2(makeDeck2());
          state3.phase = "cut";
          render2();
          netPush2();
          stepNextCut2(context);
        }, 2e3);
        return;
      }
      const winnerSeat = minEntries[0].seatId;
      state3.dealer = winnerSeat;
      state3.phase = "cut-reveal";
      state3.highlightIds = [minEntries[0].card.id];
      state3.cutDeck = [];
      const cutSummary = entries2.map((e) => `${seatName3(e.seatId)}: ${cardLabel2(e.card)}`).join(" vs ");
      const cutMsg = `Cut: ${cutSummary}. ${seatName3(winnerSeat)} deals first.`;
      log2(cutMsg);
      const myWinnerCall = winnerSeat === mySeat3() ? "You deal first!" : `${seatName3(winnerSeat)} deals first!`;
      fancyCall2(myWinnerCall, "famous", 1800);
      render2();
      netPush2({
        log: cutMsg,
        fancy: { text: myWinnerCall, kind: "famous", ms: 1800 }
      });
      setTimeout(() => {
        if (state3 && !state3.over) newHand2(context);
      }, 3200);
    }
    /**
     * Processes card selection from the cut fan for a player.
     * @param {number} index
     * @param {string} [seat]
     * @param {Object} [context]
     */
    static pickCut(index, seat, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.phase !== "cut" || !state3.cutDeck) return;
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (c) => Boolean(c && c.wild));
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const stepNextCut2 = context.stepNextCut || (typeof window !== "undefined" ? window.stepNextCut : _GameEngine.stepNextCut);
      const who = seat || (isOnline2() ? mySeat3() : state3.cutTurn || "p1");
      if (isOnline2() && settings3.netRole === "guest") {
        netSend2({ type: "intent", op: "cut", index, seatId: mySeat3() });
        return;
      }
      if (state3.cutPicks && state3.cutPicks[who]) return;
      if (!isOnline2() && state3.cutTurn !== who) return;
      let i = index;
      if (i == null || i < 0 || i >= state3.cutDeck.length) return;
      let card = state3.cutDeck[i];
      while (card && isWild2(card) && i < state3.cutDeck.length - 1) {
        i += 1;
        card = state3.cutDeck[i];
      }
      if (!card || isWild2(card)) {
        setStatus2("That cut is a joker \u2014 pick another depth.");
        return;
      }
      const used = Object.values(state3.cutPicks || {}).filter(Boolean).map((c) => c.id);
      if (used.includes(card.id)) return;
      if (!state3.cutPicks) state3.cutPicks = {};
      state3.cutPicks[who] = card;
      if (sfx3 && typeof sfx3.deal === "function") sfx3.deal();
      render2();
      netPush2();
      stepNextCut2(context);
    }
    /**
     * Advances turn progression through cutting the deck for the initial deal.
     * @param {Object} [context]
     */
    static stepNextCut(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.phase !== "cut") return;
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => true);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const updateTurnPrompt2 = context.updateTurnPrompt || (typeof window !== "undefined" ? window.updateTurnPrompt : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (seat, cb) => cb && cb());
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (c) => Boolean(c && c.wild));
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const resolveCuts2 = context.resolveCuts || (typeof window !== "undefined" ? window.resolveCuts : _GameEngine.resolveCuts);
      const activeSeats = getActiveSeatIds2();
      const allCut = activeSeats.every((sId) => state3.cutPicks && state3.cutPicks[sId]);
      if (allCut) {
        resolveCuts2(context);
        return;
      }
      const nextSeat2 = activeSeats.find((sId) => !state3.cutPicks[sId]);
      if (!nextSeat2) {
        resolveCuts2(context);
        return;
      }
      state3.cutTurn = nextSeat2;
      if (isSeatCpu2(nextSeat2)) {
        const cutMsg = seatName3(nextSeat2) + " is cutting the deck\u2026";
        setStatus2(cutMsg);
        updateTurnPrompt2(cutMsg);
        render2();
        netPush2();
        setTimeout(() => {
          if (!state3 || state3.phase !== "cut") return;
          const usedIds = Object.values(state3.cutPicks || {}).filter(Boolean).map((c) => c.id);
          const rest = (state3.cutDeck || []).filter((c) => !usedIds.includes(c.id) && !isWild2(c));
          if (!rest.length) {
            resolveCuts2(context);
            return;
          }
          const chosen = rest[Math.floor(Math.random() * rest.length)] || rest[0];
          state3.cutPicks[nextSeat2] = chosen;
          if (sfx3 && typeof sfx3.deal === "function") sfx3.deal();
          render2();
          netPush2();
          setTimeout(() => {
            if (!state3 || state3.phase !== "cut") return;
            _GameEngine.stepNextCut(context);
          }, 500);
        }, 750);
      } else if (isSeatHuman2(nextSeat2)) {
        const cutMsg = (nextSeat2 === "p1" ? "Your cut" : `${seatName3(nextSeat2)}'s cut`) + " \u2014 tap any card in the fan to cut the deck.";
        setStatus2(cutMsg);
        updateTurnPrompt2(cutMsg);
        if (!isOnline2() && nextSeat2 !== "p1") {
          passTo2(nextSeat2, () => {
            render2();
            netPush2();
          });
        } else {
          render2();
          netPush2();
        }
      }
    }
    /**
     * Helper to perform a quick midpoint cut.
     * @param {Object} [context]
     */
    static doCut(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const pickCut2 = context.pickCut || (typeof window !== "undefined" ? window.pickCut : _GameEngine.pickCut);
      const len = state3 && state3.cutDeck ? state3.cutDeck.length : 0;
      pickCut2(Math.floor(len / 2), null, context);
    }
    /**
     * Initiates a new hand, deals cards, resets hand pegging state, and prepares discards.
     * @param {Object} [context]
     */
    static newHand(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.over) return;
      const resetAnims2 = context.resetAnims || (typeof window !== "undefined" ? window.resetAnims : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const DeckClass = context.Deck || (typeof Deck !== "undefined" ? Deck : typeof window !== "undefined" ? window.Deck : null);
      const shuffle2 = context.shuffle || (typeof window !== "undefined" ? window.shuffle : (arr) => arr);
      const makeDeck2 = context.makeDeck || (typeof window !== "undefined" ? window.makeDeck : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" ? window.nextSeat : (s) => s === "p1" ? "p2" : "p1");
      const isSoloVsPairs2 = context.isSoloVsPairs || (typeof window !== "undefined" ? window.isSoloVsPairs : () => false);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const finishDeal2 = context.finishDeal || (typeof window !== "undefined" ? window.finishDeal : _GameEngine.finishDeal);
      resetAnims2();
      if (sfx3 && typeof sfx3.shuffle === "function") sfx3.shuffle();
      const activeSeats = getActiveSeatIds2();
      const count = settings3.playerCount || 2;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      const isCanadianDoubles = Boolean(settings3 && settings3.optCanadianDoubles && count === 4);
      const dealN = isCanadianDoubles ? 10 : count >= 3 ? 5 : is7Card ? 7 : settings3.deal === "super" ? 9 : 6;
      const deckObj = DeckClass ? new DeckClass({ decks: settings3.decks || 1, jokers: Boolean(settings3 && settings3.jokers) }).shuffle() : null;
      const deck = deckObj ? deckObj.cards : shuffle2(makeDeck2());
      state3.deckObj = deckObj;
      state3.deck = deck;
      state3.hands = {};
      state3.seatHands = {};
      state3.kept = {};
      state3.seatKept = {};
      state3.youKept = null;
      state3.cpuKept = null;
      state3.crib = [];
      state3.deckDiscards = [];
      state3.seatDiscards = {};
      state3.stolenCrib = null;
      state3.stolenCribResolved = false;
      state3.twistedCribbageResolved = false;
      state3.twisted8Cards = null;
      if (count === 3 || is7Card) {
        state3.crib = [deck.pop()];
      }
      if (isCanadianDoubles) {
        const pone = nextSeat2(state3.dealer);
        const dealer = state3.dealer;
        for (const sId of activeSeats) {
          if (sId === pone || sId === dealer) {
            const cards = deck.splice(0, 10);
            setSeatHand2(sId, cards);
          } else {
            setSeatHand2(sId, []);
          }
        }
        log2(`Canadian Doubles: 10 cards dealt to Pone (${seatName3(pone)}) and Dealer (${seatName3(dealer)}). Partners await passed hands.`);
      } else {
        for (const sId of activeSeats) {
          const cards = deck.splice(0, dealN);
          setSeatHand2(sId, cards);
        }
      }
      if (is7Card) {
        log2("7 Card Cribbage: 7 cards dealt to each player, 1 card dealt to the crib.");
      }
      if (sfx3) {
        const slideFn = typeof sfx3.cardSlide === "function" ? () => sfx3.cardSlide() : typeof sfx3.deal === "function" ? () => sfx3.deal() : null;
        if (slideFn) {
          const slideCount = Math.min(dealN, 6);
          for (let i = 0; i < slideCount; i++) {
            setTimeout(slideFn, 70 + i * 85);
          }
        }
      }
      state3.starter = null;
      state3.starters = [];
      state3.spadesCut = false;
      state3.starterGuess = null;
      state3.discardsComplete = false;
      state3.selected = [];
      state3.pile = [];
      state3.played = [];
      state3.count = 0;
      state3.turn = nextSeat2(state3.dealer);
      state3.assignTarget = null;
      state3.goPending = null;
      state3.lastPlayed = null;
      state3.handPeg = { p1: 0, p2: 0, p3: 0, p4: 0, p5: 0, p6: 0, p7: 0, p8: 0, team1: 0, team2: 0, team3: 0, team4: 0, you: 0, cpu: 0 };
      state3.handRecorded = false;
      state3.pegLog = [];
      state3.showAct = null;
      state3.lastShow = null;
      state3.showQueue = null;
      state3.showMeter = null;
      state3.cutDeck = null;
      state3.cutPicks = {};
      state3.cutTurn = null;
      state3.highlightIds = [];
      state3.currentHumanDiscard = null;
      state3.phase = "dealing";
      if (isSoloVsPairs2()) {
        const p1Name = seatName3("p1");
        if (settings3.playerCount === 3) {
          log2(`3 Players (1 vs 2) \u2014 Solo: ${p1Name} (always scores crib) \xB7 Pair: ${seatName3("p2")} & ${seatName3("p3")}`);
        } else if (settings3.playerCount === 5) {
          log2(`5 Players (1 vs 2 Pairs) \u2014 Solo: ${p1Name} (always scores crib) \xB7 Pair 1: ${seatName3("p2")} & ${seatName3("p4")} \xB7 Pair 2: ${seatName3("p3")} & ${seatName3("p5")}`);
        } else if (settings3.playerCount === 7) {
          log2(`7 Players (1 vs 3 Pairs) \u2014 Solo: ${p1Name} (always scores crib) \xB7 Pairs: (P2 & P5), (P3 & P6), (P4 & P7)`);
        }
      }
      if (count === 5) {
        log2(`5 Players \u2014 4 players discard to crib \xB7 Dealer (${seatName3(state3.dealer)}) discards to the deck.`);
      } else if (count === 6) {
        log2(`6 Players \u2014 4 players discard to crib \xB7 5th player & Dealer (${seatName3(state3.dealer)}) discard to the deck.`);
      } else if (count === 7) {
        log2(`7 Players \u2014 4 players discard to crib \xB7 5th, 6th players & Dealer (${seatName3(state3.dealer)}) discard to the deck.`);
      } else if (count === 8) {
        log2(`8 Players \u2014 4 players discard to crib \xB7 5th, 6th, 7th players & Dealer (${seatName3(state3.dealer)}) discard to the deck.`);
      }
      setStatus2(seatName3(state3.dealer) + " deals\u2026");
      fancyCall2("Dealing", "", 700);
      render2();
      setTimeout(() => {
        finishDeal2(context);
      }, 650);
    }
    /**
     * Concludes deal animation and transitions to discard or joker assignment.
     * @param {Object} [context]
     */
    static finishDeal(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const cpuAssignWilds2 = context.cpuAssignWilds || (typeof window !== "undefined" ? window.cpuAssignWilds : () => {
      });
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const beginCutStarter2 = context.beginCutStarter || (typeof window !== "undefined" ? window.beginCutStarter : _GameEngine.beginCutStarter);
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (c) => Boolean(c && c.wild));
      const openWildPick2 = context.openWildPick || (typeof window !== "undefined" ? window.openWildPick : null);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const startDiscardOrPickFlow3 = context.startDiscardOrPickFlow || (typeof window !== "undefined" ? window.startDiscardOrPickFlow : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      for (const sId of getActiveSeatIds2()) {
        if (isSeatCpu2(sId)) {
          const h = getSeatHand2(sId);
          if (h && h.length) cpuAssignWilds2(h);
        }
      }
      if (settings3.optCutBeforeDiscard) {
        beginCutStarter2(context);
        return;
      }
      state3.phase = "discard";
      const p1Wilds = (getSeatHand2("p1") || []).filter((c) => isWild2(c));
      if (settings3.jokers && p1Wilds.length >= 3) {
        AchievementManager.unlock("triple_joker", { sfx });
        AchievementManager.unlock("super_joker", { sfx });
      } else if (settings3.jokers && p1Wilds.length >= 2) {
        AchievementManager.unlock("super_joker", { sfx });
      }
      if (settings3.jokers && p1Wilds.some((c) => !c.playAs)) {
        state3.phase = "assign";
        state3.assignTarget = "hand";
        setStatus2("You were dealt a joker. Click it and choose any card.");
        render2();
        const firstWild = p1Wilds.find((c) => !c.playAs);
        if (typeof openWildPick2 === "function" && firstWild) {
          openWildPick2(firstWild, "hand", context);
        }
      } else {
        startDiscardOrPickFlow3(context);
      }
      netPush2();
    }
    /**
     * Prompts or executes the pone starter card cut.
     * @param {Object} [context]
     */
    static beginCutStarter(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" ? window.nextSeat : (s) => s === "p1" ? "p2" : "p1");
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => true);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const poneDoCutStarter2 = context.poneDoCutStarter || (typeof window !== "undefined" ? window.poneDoCutStarter : _GameEngine.poneDoCutStarter);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const pone = nextSeat2(state3.dealer);
      state3.phase = "cut-starter";
      state3.cutTurn = pone;
      state3.selected = [];
      const me = typeof mySeat3 === "function" ? mySeat3() : mySeat3 || "p1";
      const isMyCut = pone === me || !isOnline2() && isSeatHuman2(pone);
      const isGuessOpt = Boolean(settings3 && settings3.optGuessStarter);
      setStatus2(isMyCut ? isGuessOpt ? pone === me ? "You are the pone \u2014 guess the starter card rank, then cut the deck!" : `${seatName3(pone)} (pone): guess the starter rank and cut!` : pone === me ? "You are the pone \u2014 cut the deck for the starter card." : `${seatName3(pone)} (pone): cut the deck for the starter card.` : isGuessOpt ? `${seatName3(pone)} (pone) is guessing and cutting the starter\u2026` : `${seatName3(pone)} (pone) is cutting the starter\u2026`);
      render2();
      netPush2();
      if (isSeatCpu2(pone)) {
        setTimeout(() => {
          if (!state3 || state3.phase !== "cut-starter" || state3.cutTurn !== pone) return;
          poneDoCutStarter2(context);
        }, 850);
      } else if (isMyCut) {
        if (isGuessOpt && !state3.starterGuess) {
          setTimeout(() => {
            if (!state3 || state3.phase !== "cut-starter" || state3.starterGuess) return;
            const promptFn = context.openGuessStarterPrompt || (typeof window !== "undefined" ? window.modalManager?.openGuessStarterPrompt || window.openGuessStarterPrompt || window.CrazyCribbage?.ModalManager?.openGuessStarterPrompt : null) || ModalManager2.openGuessStarterPrompt;
            if (typeof promptFn === "function") {
              promptFn(pone, (rank) => {
                state3.starterGuess = { who: pone, rank };
                _GameEngine.poneDoCutStarter(context);
              }, context);
            }
          }, 300);
        }
      } else if (!isOnline2() && pone !== "p1" && isSeatHuman2(pone)) {
        passTo2(pone, () => {
          render2();
          if (isGuessOpt && !state3.starterGuess) {
            setTimeout(() => {
              if (!state3 || state3.phase !== "cut-starter" || state3.starterGuess) return;
              const promptFn = context.openGuessStarterPrompt || (typeof window !== "undefined" ? window.modalManager?.openGuessStarterPrompt || window.openGuessStarterPrompt || window.CrazyCribbage?.ModalManager?.openGuessStarterPrompt : null) || ModalManager2.openGuessStarterPrompt;
              if (typeof promptFn === "function") {
                promptFn(pone, (rank) => {
                  state3.starterGuess = { who: pone, rank };
                  _GameEngine.poneDoCutStarter(context);
                }, context);
              }
            }, 300);
          }
        });
      }
    }
    /**
     * Generates a starter rank guess (1..13) for CPU pone.
     * CPU counts remaining unseen ranks from its perspective to pick a rank with maximum probability.
     * @param {string} poneSeat
     * @param {Object} state
     * @param {Object} [settings]
     * @param {Object} [context]
     * @returns {number} Rank 1..13 (Ace=1 .. King=13)
     */
    static cpuGuessStarterRank(poneSeat, state3, settings3 = {}, context = {}) {
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : null);
      const decks = settings3 && Number(settings3.decks) || 1;
      const rankCounts = {};
      for (let r = 1; r <= 13; r++) {
        rankCounts[r] = 4 * decks;
      }
      const seenCards = [];
      if (state3) {
        if (getSeatHand2) {
          seenCards.push(...getSeatHand2(poneSeat) || []);
        } else if (state3.hands && state3.hands[poneSeat]) {
          seenCards.push(...state3.hands[poneSeat]);
        } else if (poneSeat === "p2" && state3.cpuHand) {
          seenCards.push(...state3.cpuHand);
        }
        if (state3.seatDiscards && state3.seatDiscards[poneSeat]) {
          seenCards.push(...state3.seatDiscards[poneSeat]);
        }
      }
      for (const c of seenCards) {
        const r = c && (c.r || c.rank) || 0;
        if (r >= 1 && r <= 13 && rankCounts[r]) {
          rankCounts[r]--;
        }
      }
      let maxRemaining = -1;
      let bestRanks = [];
      for (let r = 1; r <= 13; r++) {
        const count = rankCounts[r];
        if (count > maxRemaining) {
          maxRemaining = count;
          bestRanks = [r];
        } else if (count === maxRemaining) {
          bestRanks.push(r);
        }
      }
      const preferred = [5, 7, 8, 6, 4];
      for (const pref of preferred) {
        if (bestRanks.includes(pref)) return pref;
      }
      const idx = Math.floor(Math.random() * bestRanks.length);
      return bestRanks[idx] || 5;
    }
    /**
     * Cuts starter card when triggered by pone.
     * @param {Object} [context]
     */
    static poneDoCutStarter(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.phase !== "cut-starter") return;
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : _GameEngine.startStarter);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => true);
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" ? window.nextSeat : (s) => s === "p1" ? "p2" : "p1");
      const openGuessStarterPrompt2 = context.openGuessStarterPrompt || (typeof window !== "undefined" ? window.modalManager?.openGuessStarterPrompt || window.openGuessStarterPrompt || window.CrazyCribbage?.ModalManager?.openGuessStarterPrompt : null) || ModalManager2.openGuessStarterPrompt;
      const pone = state3.cutTurn && state3.phase === "cut-starter" ? state3.cutTurn : nextSeat2(state3.dealer);
      if (settings3 && settings3.optGuessStarter && !state3.starterGuess) {
        if (isSeatCpu2(pone)) {
          const guess = _GameEngine.cpuGuessStarterRank(pone, state3, settings3, context);
          state3.starterGuess = { who: pone, rank: guess };
        } else if (isSeatHuman2(pone)) {
          if (isOnline2() && settings3.netRole === "guest") {
            if (typeof openGuessStarterPrompt2 === "function") {
              openGuessStarterPrompt2(pone, (rank) => {
                state3.starterGuess = { who: pone, rank };
                netSend2({ type: "intent", op: "cutStarter", seatId: mySeat3(), guessRank: rank });
              }, context);
              return;
            } else {
              state3.starterGuess = { who: pone, rank: 5 };
              netSend2({ type: "intent", op: "cutStarter", seatId: mySeat3(), guessRank: 5 });
              return;
            }
          }
          if (typeof openGuessStarterPrompt2 === "function") {
            openGuessStarterPrompt2(pone, (rank) => {
              state3.starterGuess = { who: pone, rank };
              _GameEngine.poneDoCutStarter(context);
            }, context);
            return;
          } else {
            state3.starterGuess = { who: pone, rank: 5 };
          }
        }
      }
      if (isOnline2() && settings3.netRole === "guest") {
        const gRank = state3.starterGuess ? state3.starterGuess.rank : null;
        netSend2({ type: "intent", op: "cutStarter", seatId: mySeat3(), guessRank: gRank });
        return;
      }
      if (sfx3 && typeof sfx3.snap === "function") sfx3.snap();
      startStarter2(context);
    }
    /**
     * Cuts the starter card from the deck and initiates the starter ritual animation.
     * @param {Object} [context]
     */
    static startStarter(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      if (settings3 && settings3.optGuessStarter && !state3.starterGuess) {
        const beginCutStarter2 = context.beginCutStarter || (typeof window !== "undefined" ? window.beginCutStarter : _GameEngine.beginCutStarter);
        if (typeof beginCutStarter2 === "function") {
          beginCutStarter2(context);
          return;
        }
      }
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const finishStarterRitual2 = context.finishStarterRitual || (typeof window !== "undefined" ? window.finishStarterRitual : _GameEngine.finishStarterRitual);
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      hideWait2();
      state3.selected = [];
      const isProgCut = Boolean(settings3 && settings3.optProgressiveCut && (settings3.playerCount || 2) === 2);
      const cutCount = isProgCut ? Math.max(1, Math.floor((state3.handsCompleted || 0) / 2) + 1) : 1;
      state3.starters = [];
      for (let i = 0; i < cutCount; i++) {
        if (state3.deck && state3.deck.length > 2) {
          const cutIdx = Math.floor(Math.random() * (state3.deck.length - 1));
          state3.starters.push(state3.deck.splice(cutIdx, 1)[0]);
        } else if (state3.deck && state3.deck.length > 0) {
          state3.starters.push(state3.deck.pop());
        }
      }
      state3.starter = state3.starters[0] || null;
      state3.phase = "starter-ritual";
      state3.starterFace = false;
      const starterWord = cutCount > 1 ? `Cutting ${cutCount} starters\u2026` : "Cutting the starter\u2026";
      const fancyWord = cutCount > 1 ? `${cutCount} Starters` : "Starter";
      setStatus2(starterWord);
      fancyCall2(fancyWord, "", 800);
      render2();
      netPush2({ fancy: { text: fancyWord, kind: "", ms: 800 } });
      setTimeout(() => {
        if (!state3 || state3.phase !== "starter-ritual") return;
        state3.starterFace = true;
        render2();
        netPush2();
        setTimeout(() => {
          const cards = doc ? doc.querySelectorAll("#starterZone .playing-card") : [];
          if (cards && cards.length) {
            cards.forEach((c) => c.classList.add("starter-tap"));
          }
          setTimeout(() => {
            finishStarterRitual2(context);
          }, 430);
        }, 560);
      }, 520);
    }
    /**
     * Concludes the starter card ritual, handling jokers or proceeding to match play.
     * @param {Object} [context]
     */
    static finishStarterRitual(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || !state3.starter) return;
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (c) => Boolean(c && c.wild));
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => true);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const openWildPick2 = context.openWildPick || (typeof window !== "undefined" ? window.openWildPick : () => {
      });
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const isHvH2 = context.isHvH || (typeof window !== "undefined" ? window.isHvH : () => false);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const cpuAssignWilds2 = context.cpuAssignWilds || (typeof window !== "undefined" ? window.cpuAssignWilds : () => {
      });
      const afterStarterAssigned2 = context.afterStarterAssigned || (typeof window !== "undefined" ? window.afterStarterAssigned : () => {
      });
      const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
      const unassignedWild = starters.find((c) => isWild2(c) && !c.playAs);
      if (unassignedWild) {
        const dealerHuman = isSeatHuman2(state3.dealer);
        if (dealerHuman) {
          const go = () => {
            state3.phase = "assign";
            state3.assignTarget = "starter";
            render2();
            openWildPick2(unassignedWild, "starter");
            hideWait2();
            setStatus2(seatName3(state3.dealer) + ": starter is a joker. Choose the card it becomes.");
          };
          if (state3.dealer !== "p1" && isHvH2()) passTo2(state3.dealer, go);
          else go();
          return;
        }
        cpuAssignWilds2([unassignedWild]);
      }
      afterStarterAssigned2(context);
    }
    /**
     * Initializes state and prompts for the pegging play phase.
     * @param {Object} [context]
     */
    static startPlayAfterDiscards(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const activeSeats = typeof context.getActiveSeatIds === "function" ? context.getActiveSeatIds() : typeof window !== "undefined" && typeof window.getActiveSeatIds === "function" ? window.getActiveSeatIds() : ["p1", "p2"];
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" && typeof window.nextSeat === "function" ? window.nextSeat : (s) => _GameEngine.advanceDealer(s, activeSeats));
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => true);
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : () => {
      });
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      state3.phase = "play";
      const cribEl = typeof document !== "undefined" ? document.getElementById("cribCards") : null;
      if (cribEl) {
        cribEl.classList.remove("counting");
        cribEl.classList.add("playing");
      }
      state3.count = 0;
      state3.pile = [];
      const leadSeat = nextSeat2(state3.dealer);
      state3.turn = leadSeat;
      hideWait2();
      render2();
      netPush2();
      if (leadSeat && isSeatCpu2(leadSeat)) {
        scheduleOppPlay2(leadSeat, context);
      } else if (leadSeat && isSeatHuman2(leadSeat)) {
        _GameEngine.announcePlayTurn(leadSeat, context);
        if (!isOnline2()) {
          if (leadSeat !== "p1") {
            passTo2(leadSeat, () => {
              render2();
            }, context);
          } else {
            render2();
          }
        }
      }
    }
    /**
     * Confirms P2 discard in 2-player pass and play or guest online mode.
     * @param {Object} [context]
     */
    static confirmP2Discard(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const startPlayAfterDiscards2 = context.startPlayAfterDiscards || (typeof window !== "undefined" ? window.startPlayAfterDiscards : _GameEngine.startPlayAfterDiscards);
      const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : _GameEngine.startStarter);
      if (isOnline2() && settings3.netRole === "guest") {
        netSend2({ type: "intent", op: "discardP2", ids: (state3.selected || []).slice() });
        state3.selected = [];
        render2();
        return;
      }
      const count = parseInt(settings3 && settings3.playerCount, 10) || 2;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      const discardN = is7Card ? 2 : settings3.deal === "super" ? 3 : 2;
      if (!state3.selected || state3.selected.length !== discardN) return;
      const ids = new Set(state3.selected);
      const cpuHand = state3.cpuHand || [];
      const thrown = cpuHand.filter((c) => ids.has(c.id));
      state3.cpuHand = cpuHand.filter((c) => !ids.has(c.id));
      state3.cpuKept = state3.cpuHand.slice();
      state3.seatDiscards = state3.seatDiscards || {};
      state3.seatDiscards.p2 = thrown;
      state3.crib = state3.crib || [];
      state3.crib.push(...thrown);
      state3.selected = [];
      if (settings3.optCutBeforeDiscard) {
        state3.discardsComplete = true;
        startPlayAfterDiscards2(context);
      } else if (settings3.optGuessStarter) {
        state3.discardsComplete = true;
        const beginCutStarter2 = context.beginCutStarter || (typeof window !== "undefined" ? window.beginCutStarter : _GameEngine.beginCutStarter);
        beginCutStarter2(context);
      } else {
        startStarter2(context);
      }
    }
    /**
     * Handles dealer card selection from pone hands during Pick Your Crib.
     * @param {string} seatId
     * @param {Object} c
     * @param {Object} [context]
     */
    static onPickCribCard(seatId, c, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.phase !== "pick-crib" || state3.currentPickPone !== seatId) return;
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const pickN = state3.pickN || 2;
      state3.selected = state3.selected || [];
      const idx = state3.selected.indexOf(c.id);
      if (idx >= 0) {
        state3.selected.splice(idx, 1);
      } else if (state3.selected.length < pickN) {
        state3.selected.push(c.id);
      }
      render2();
    }
    /**
     * Prompts human dealer to select cards from active pone hands.
     * @param {Object} [context]
     */
    static startHumanPickCrib(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const finishPickYourCrib2 = context.finishPickYourCrib || (typeof window !== "undefined" ? window.finishPickYourCrib : _GameEngine.finishPickYourCrib);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      if (!state3.pickPones || !state3.pickPones.length) {
        finishPickYourCrib2(context);
        return;
      }
      state3.phase = "pick-crib";
      state3.currentPickPone = state3.pickPones[0];
      state3.selected = [];
      const count = parseInt(settings3.playerCount, 10) || 2;
      const pickN = count >= 3 ? 1 : settings3.deal === "super" ? 3 : 2;
      state3.pickN = pickN;
      setStatus2(`Pick your Crib: Select ${pickN} card${pickN > 1 ? "s" : ""} from ${seatName3(state3.currentPickPone)}'s hand to take for your crib.`);
      render2();
    }
    /**
     * Confirms human dealer theft of selected pone cards into crib.
     * @param {Object} [context]
     */
    static confirmPickCrib(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.phase !== "pick-crib") return;
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const startHumanPickCrib2 = context.startHumanPickCrib || (typeof window !== "undefined" ? window.startHumanPickCrib : _GameEngine.startHumanPickCrib);
      const finishPickYourCrib2 = context.finishPickYourCrib || (typeof window !== "undefined" ? window.finishPickYourCrib : _GameEngine.finishPickYourCrib);
      const pId = state3.currentPickPone;
      const pickN = state3.pickN || 2;
      if (!state3.selected || state3.selected.length !== pickN) return;
      const pHand = getSeatHand2(pId);
      const ids = new Set(state3.selected);
      const picked = pHand.filter((c) => ids.has(c.id));
      const remaining = pHand.filter((c) => !ids.has(c.id));
      setSeatHand2(pId, remaining);
      setSeatKept2(pId, remaining.slice());
      state3.crib = state3.crib || [];
      state3.crib.push(...picked);
      state3.seatDiscards = state3.seatDiscards || {};
      state3.seatDiscards[pId] = picked;
      log2(`You took ${pickN} card${pickN > 1 ? "s" : ""} from ${seatName3(pId)}'s hand for your crib.`);
      fancyCall2(`Took ${pickN} card${pickN > 1 ? "s" : ""}`, "combo", 1200);
      state3.selected = [];
      state3.pickPones.shift();
      if (state3.pickPones.length) {
        startHumanPickCrib2(context);
      } else {
        finishPickYourCrib2(context);
      }
    }
    /**
     * Concludes the Pick Your Crib sequence and transitions to starter cut or play.
     * @param {Object} [context]
     */
    static finishPickYourCrib(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const startPlayAfterDiscards2 = context.startPlayAfterDiscards || (typeof window !== "undefined" ? window.startPlayAfterDiscards : _GameEngine.startPlayAfterDiscards);
      const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : _GameEngine.startStarter);
      state3.phase = "discard";
      state3.currentHumanDiscard = null;
      state3.discardsComplete = true;
      if (settings3.optCutBeforeDiscard) {
        startPlayAfterDiscards2(context);
      } else {
        startStarter2(context);
      }
    }
    /**
     * Initiates Draw Cribbage Phase 1 (0-5 cards from 6) or Phase 2 (0-3 cards from 4).
     * @param {number} phaseNum 1 or 2
     * @param {Object} [context]
     */
    static startDrawCribbagePhase(phaseNum, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const isDealer = state3.dealer === "p1" || state3.dealer === "you";
      const pone = isDealer ? "p2" : "p1";
      const dealer = isDealer ? "p1" : "p2";
      state3.drawPhase = phaseNum;
      state3.drawSeats = [pone, dealer];
      state3.selected = [];
      _GameEngine.processNextDrawSeat(context);
    }
    /**
     * Advances Draw Cribbage to the next seat or next phase.
     * @param {Object} [context]
     */
    static processNextDrawSeat(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isTwoHuman2 = context.isTwoHuman || (typeof window !== "undefined" ? window.isTwoHuman : () => false);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const beginDiscard2 = context.beginDiscard || (typeof window !== "undefined" ? window.beginDiscard : _GameEngine.beginDiscard);
      const startPlayAfterDiscards2 = context.startPlayAfterDiscards || (typeof window !== "undefined" ? window.startPlayAfterDiscards : _GameEngine.startPlayAfterDiscards);
      const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : _GameEngine.startStarter);
      if (!state3.drawSeats || state3.drawSeats.length === 0) {
        state3.currentDrawSeat = null;
        if (state3.drawPhase === 1) {
          state3.phase = "discard";
          state3.selected = [];
          if (isTwoHuman2()) {
            const pone = state3.dealer === "p1" || state3.dealer === "you" ? "p2" : "p1";
            if (pone === "p2") {
              passTo2("p2", () => {
                state3.currentHumanDiscard = "p2";
                beginDiscard2(context);
              });
              return;
            }
            state3.currentHumanDiscard = "p1";
            beginDiscard2(context);
          } else {
            state3.currentHumanDiscard = "p1";
            beginDiscard2(context);
          }
        } else {
          state3.currentHumanDiscard = null;
          state3.discardsComplete = true;
          if (settings3.optCutBeforeDiscard) {
            startPlayAfterDiscards2(context);
          } else {
            startStarter2(context);
          }
        }
        return;
      }
      const curSeat = state3.drawSeats.shift();
      state3.currentDrawSeat = curSeat;
      state3.currentHumanDiscard = curSeat;
      state3.selected = [];
      if (isSeatCpu2(curSeat)) {
        const hand = (getSeatHand2(curSeat) || []).slice();
        let cpuThrow = [];
        const lowball = settings3.goal === "low";
        const isDealer = curSeat === state3.dealer;
        const aiCls = context.CribbageAI || (typeof CribbageAI !== "undefined" ? CribbageAI : typeof window !== "undefined" ? window.CrazyCribbage?.CribbageAI || window.CC?.CribbageAI : null);
        if (state3.drawPhase === 1) {
          cpuThrow = aiCls && aiCls.chooseDrawPhase1 ? aiCls.chooseDrawPhase1(hand, isDealer, lowball) : [];
        } else {
          cpuThrow = aiCls && aiCls.chooseDrawPhase2 ? aiCls.chooseDrawPhase2(hand, isDealer, lowball, state3.starter) : [];
        }
        const throwIds = new Set(cpuThrow.map((c) => c.id));
        const kept = hand.filter((c) => !throwIds.has(c.id));
        const drawn = [];
        for (let i = 0; i < cpuThrow.length; i++) {
          if (state3.deck && state3.deck.length > 0) {
            drawn.push(state3.deck.pop());
          }
        }
        if (cpuThrow.length > 0 && state3.deck) {
          state3.deck.unshift(...cpuThrow);
        }
        const newHand2 = kept.concat(drawn);
        setSeatHand2(curSeat, newHand2);
        setSeatKept2(curSeat, newHand2.slice());
        if (cpuThrow.length > 0) {
          log2(`${seatName3(curSeat)} discarded ${cpuThrow.length} card${cpuThrow.length === 1 ? "" : "s"} and drew ${drawn.length} new card${drawn.length === 1 ? "" : "s"}.`);
        } else {
          log2(`${seatName3(curSeat)} stood pat (kept all cards).`);
        }
        _GameEngine.processNextDrawSeat(context);
        return;
      }
      if (curSeat === "p2" && isTwoHuman2()) {
        passTo2("p2", () => {
          state3.phase = state3.drawPhase === 1 ? "draw-1-p2" : "draw-2-p2";
          state3.selected = [];
          const maxDraw2 = state3.drawPhase === 1 ? 5 : 3;
          setStatus2(`Draw Cribbage (${state3.drawPhase === 1 ? "1st Draw" : "2nd Draw"}): Select 0\u2013${maxDraw2} cards to replace, then click 'Discard & Draw' (or 'Keep Hand').`);
          render2();
        });
        return;
      }
      state3.phase = state3.drawPhase === 1 ? "draw-1" : "draw-2";
      state3.selected = [];
      const maxDraw = state3.drawPhase === 1 ? 5 : 3;
      setStatus2(`Draw Cribbage (${state3.drawPhase === 1 ? "1st Draw" : "2nd Draw"}): Select 0\u2013${maxDraw} cards to replace, then click 'Discard & Draw' (or 'Keep Hand').`);
      render2();
    }
    /**
     * Confirms human draw action in Draw Cribbage.
     * Discards selected cards (returning to deck bottom) and draws replacement cards from top of deck.
     * @param {Object} [context]
     */
    static confirmDraw(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.phase !== "draw-1" && state3.phase !== "draw-2" && state3.phase !== "draw-1-p2" && state3.phase !== "draw-2-p2") return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const me = mySeat3();
      if (isOnline2()) {
        if (settings3.netRole === "guest") {
          netSend2({ type: "intent", op: "draw", ids: state3.selected || [], seatId: me });
          state3.selected = [];
          const render3 = context.render || (typeof window !== "undefined" ? window.render : () => {
          });
          render3();
          return;
        }
      }
      const curSeat = state3.currentDrawSeat || state3.currentHumanDiscard || "p1";
      const isFirstDraw = state3.phase === "draw-1" || state3.phase === "draw-1-p2";
      const maxDraw = isFirstDraw ? 5 : 3;
      state3.selected = state3.selected || [];
      if (state3.selected.length > maxDraw) return;
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const selIds = new Set(state3.selected);
      const currHand = (getSeatHand2(curSeat) || []).slice();
      const discarded = currHand.filter((c) => selIds.has(c.id));
      const kept = currHand.filter((c) => !selIds.has(c.id));
      const drawn = [];
      for (let i = 0; i < discarded.length; i++) {
        if (state3.deck && state3.deck.length > 0) {
          drawn.push(state3.deck.pop());
        }
      }
      if (discarded.length > 0 && state3.deck) {
        state3.deck.unshift(...discarded);
      }
      const newHand2 = kept.concat(drawn);
      setSeatHand2(curSeat, newHand2);
      setSeatKept2(curSeat, newHand2.slice());
      state3.selected = [];
      if (discarded.length > 0) {
        log2(`${seatName3(curSeat)} discarded ${discarded.length} card${discarded.length === 1 ? "" : "s"} and drew ${drawn.length} new card${drawn.length === 1 ? "" : "s"}.`);
        fancyCall2(`Drew ${drawn.length} card${drawn.length === 1 ? "" : "s"}!`, "deal", 1200);
      } else {
        log2(`${seatName3(curSeat)} stood pat (kept all cards).`);
        fancyCall2("Stood Pat!", "deal", 1e3);
      }
      if (isOnline2()) {
        netPush2();
      }
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      render2();
      _GameEngine.processNextDrawSeat(context);
    }
    /**
     * Performs blind/random pick from pone hand for CPU dealer during Pick Your Crib.
     * @param {string} dealerSeat
     * @param {string} poneSeat
     * @param {number} pickN
     * @param {Object} [context]
     * @returns {Array}
     */
    static cpuPickFromPone(dealerSeat, poneSeat, pickN, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const poneHand = getSeatHand2(poneSeat) || [];
      if (poneHand.length <= pickN) return poneHand.slice();
      const shuffled = poneHand.slice().sort(() => Math.random() - 0.5);
      const picked = shuffled.slice(0, pickN);
      const pickIds = new Set(picked.map((c) => c.id));
      const remaining = poneHand.filter((c) => !pickIds.has(c.id));
      setSeatHand2(poneSeat, remaining);
      setSeatKept2(poneSeat, remaining.slice());
      if (state3) {
        state3.seatDiscards = state3.seatDiscards || {};
        state3.seatDiscards[poneSeat] = picked;
        state3.crib = state3.crib || [];
        state3.crib.push(...picked);
      }
      log2(`${seatName3(dealerSeat)} picked ${pickN} card${pickN > 1 ? "s" : ""} from ${seatName3(poneSeat)}'s hand for the crib.`);
      return picked;
    }
    /**
     * Coordinates complete CPU dealer Pick Your Crib process.
     * @param {Object} [context]
     */
    static cpuDoPickYourCrib(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const chooseDiscard2 = context.chooseDiscard || (typeof window !== "undefined" ? window.chooseDiscard : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const cpuPickFromPone2 = context.cpuPickFromPone || (typeof window !== "undefined" ? window.cpuPickFromPone : _GameEngine.cpuPickFromPone);
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const cardLabel2 = context.cardLabel || (typeof window !== "undefined" ? window.cardLabel : (c) => String(c.rank));
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const startPlayAfterDiscards2 = context.startPlayAfterDiscards || (typeof window !== "undefined" ? window.startPlayAfterDiscards : _GameEngine.startPlayAfterDiscards);
      const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : _GameEngine.startStarter);
      state3.phase = "discard";
      const count = parseInt(settings3.playerCount, 10) || 2;
      const discardN = count >= 3 ? 1 : settings3.deal === "super" ? 3 : 2;
      const dealerHand = getSeatHand2(state3.dealer);
      const cpuThrow = chooseDiscard2(dealerHand, true, settings3.goal === "low", discardN, false);
      const cids = new Set(cpuThrow.map((c) => c.id));
      const dealerKept = dealerHand.filter((c) => !cids.has(c.id));
      setSeatHand2(state3.dealer, dealerKept);
      setSeatKept2(state3.dealer, dealerKept.slice());
      state3.crib = state3.crib || [];
      state3.crib.push(...cpuThrow);
      state3.seatDiscards = state3.seatDiscards || {};
      state3.seatDiscards[state3.dealer] = cpuThrow;
      const pones = getActiveSeatIds2().filter((sId) => sId !== state3.dealer);
      let stolenFromHuman = [];
      for (const pId of pones) {
        const picked = cpuPickFromPone2(state3.dealer, pId, discardN, context);
        if (pId === "p1") stolenFromHuman = picked;
      }
      if (stolenFromHuman && stolenFromHuman.length) {
        fancyCall2(seatName3(state3.dealer) + " took " + stolenFromHuman.map(cardLabel2).join(", "), "combo", 1800);
        setStatus2(seatName3(state3.dealer) + " picked " + stolenFromHuman.map(cardLabel2).join(", ") + " from your hand for their crib.");
      } else {
        setStatus2(seatName3(state3.dealer) + " picked cards from the pone hand(s) for the crib.");
      }
      render2();
      setTimeout(() => {
        if (!state3 || state3.over) return;
        state3.discardsComplete = true;
        if (settings3.optCutBeforeDiscard) {
          startPlayAfterDiscards2(context);
        } else if (settings3.optGuessStarter) {
          const beginCutStarter2 = context.beginCutStarter || (typeof window !== "undefined" ? window.beginCutStarter : _GameEngine.beginCutStarter);
          beginCutStarter2(context);
        } else {
          startStarter2(context);
        }
      }, 1400);
    }
    /**
     * Routes match start to either Pick Your Crib flow or regular discard.
     * @param {Object} [context]
     */
    static startDiscardOrPickFlow(context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isTwoHuman2 = context.isTwoHuman || (typeof window !== "undefined" ? window.isTwoHuman : () => false);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const beginDiscard2 = context.beginDiscard || (typeof window !== "undefined" ? window.beginDiscard : () => {
      });
      const cpuDoPickYourCrib2 = context.cpuDoPickYourCrib || (typeof window !== "undefined" ? window.cpuDoPickYourCrib : _GameEngine.cpuDoPickYourCrib);
      if (settings3.optCanadianDoubles && (parseInt(settings3.playerCount, 10) || 2) === 4) {
        _GameEngine.startCanadianDoublesFlow(context);
        return;
      }
      if (settings3.optDrawCribbage && (parseInt(settings3.playerCount, 10) || 2) === 2) {
        _GameEngine.startDrawCribbagePhase(1, context);
        return;
      }
      if (settings3.optPickYourCrib) {
        if (state3 && isSeatCpu2(state3.dealer)) {
          cpuDoPickYourCrib2(context);
          return;
        }
        if (state3 && isTwoHuman2() && state3.dealer === "p2") {
          passTo2("p2", () => {
            state3.currentHumanDiscard = "p2";
            beginDiscard2();
          });
          return;
        }
      }
      if ((settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && (parseInt(settings3.playerCount, 10) || 2) === 2) {
        const pone = state3 && state3.dealer === "p1" ? "p2" : "p1";
        const dealer = state3 ? state3.dealer : "p2";
        const poneDiscardN = settings3.deal === "super" ? 3 : 2;
        const dealerDiscardN = settings3.deal === "super" ? 6 : 4;
        const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
        });
        const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
        });
        const chooseDiscard2 = context.chooseDiscard || (typeof window !== "undefined" ? window.chooseDiscard : () => []);
        const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
        const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
        });
        const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
        });
        const startPlayAfterDiscards2 = context.startPlayAfterDiscards || (typeof window !== "undefined" ? window.startPlayAfterDiscards : _GameEngine.startPlayAfterDiscards);
        const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : _GameEngine.startStarter);
        if (isSeatCpu2(pone)) {
          const pHand = (getSeatHand2(pone) || []).slice();
          const pThrow = chooseDiscard2(pHand, false, settings3.goal === "low", poneDiscardN);
          const pThrowIds = new Set(pThrow.map((c) => c.id));
          const pKept = pHand.filter((c) => !pThrowIds.has(c.id));
          setSeatHand2(pone, pKept);
          setSeatKept2(pone, pKept.slice());
          state3.seatDiscards = state3.seatDiscards || {};
          state3.seatDiscards[pone] = pThrow;
          const dHand = (getSeatHand2(dealer) || []).slice();
          dHand.push(...pThrow);
          setSeatHand2(dealer, dHand);
          log2(`${seatName3(pone)} discarded ${poneDiscardN} card${poneDiscardN === 1 ? "" : "s"} to ${seatName3(dealer)}'s hand.`);
          if (isSeatCpu2(dealer)) {
            const dThrow = chooseDiscard2(dHand, true, settings3.goal === "low", dealerDiscardN);
            const dThrowIds = new Set(dThrow.map((c) => c.id));
            const dKept = dHand.filter((c) => !dThrowIds.has(c.id));
            setSeatHand2(dealer, dKept);
            setSeatKept2(dealer, dKept.slice());
            state3.seatDiscards[dealer] = dThrow;
            state3.crib = state3.crib || [];
            state3.crib.push(...dThrow);
            log2(`${seatName3(dealer)} discarded ${dealerDiscardN} cards to the crib.`);
            state3.currentHumanDiscard = null;
            state3.discardsComplete = true;
            if (settings3.optCutBeforeDiscard) {
              startPlayAfterDiscards2(context);
            } else {
              startStarter2(context);
            }
            return;
          }
          fancyCall2(`${seatName3(pone)} passed ${poneDiscardN} cards to your hand!`, "combo", 1600);
          state3.currentHumanDiscard = dealer;
          beginDiscard2(context);
          return;
        }
        if (pone === "p2" && isTwoHuman2()) {
          passTo2("p2", () => {
            state3.currentHumanDiscard = "p2";
            beginDiscard2(context);
          });
          return;
        }
        state3.currentHumanDiscard = pone;
        beginDiscard2(context);
        return;
      }
      beginDiscard2();
    }
    /**
     * Orchestrates the 10-card organization phase for Canadian Doubles.
     * Pone organizes first, then Dealer organizes.
     * When both have organized (4 keep, 4 pass, 2 crib), discards are marked complete.
     * @param {Object} [context]
     */
    static startCanadianDoublesFlow(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isDealerTeam2 = context.isDealerTeam || (typeof window !== "undefined" ? window.isDealerTeam : () => false);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" ? window.nextSeat : (s) => s === "p1" ? "p2" : "p1");
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const startPlayAfterDiscards2 = context.startPlayAfterDiscards || (typeof window !== "undefined" ? window.startPlayAfterDiscards : _GameEngine.startPlayAfterDiscards);
      const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : _GameEngine.startStarter);
      const beginCutStarter2 = context.beginCutStarter || (typeof window !== "undefined" ? window.beginCutStarter : _GameEngine.beginCutStarter);
      const pone = nextSeat2(state3.dealer);
      const dealer = state3.dealer;
      const getPartnerSeat = (s) => s === "p1" ? "p3" : s === "p2" ? "p4" : s === "p3" ? "p1" : "p2";
      state3.seatDiscards = state3.seatDiscards || {};
      state3.crib = state3.crib || [];
      const poneDone = Boolean(state3.seatDiscards[pone]);
      const dealerDone = Boolean(state3.seatDiscards[dealer]);
      if (poneDone && dealerDone) {
        state3.currentHumanDiscard = null;
        state3.discardsComplete = true;
        if (settings3.optCutBeforeDiscard) {
          startPlayAfterDiscards2(context);
        } else if (settings3.optGuessStarter) {
          beginCutStarter2(context);
        } else {
          startStarter2(context);
        }
        return;
      }
      const ModalCls = CanadianDoublesModal || (typeof CC !== "undefined" ? CC.CanadianDoublesModal : typeof window !== "undefined" ? window.CanadianDoublesModal || window.CrazyCribbage?.CanadianDoublesModal : null);
      if (!poneDone) {
        const ponePartner = getPartnerSeat(pone);
        if (isSeatCpu2(pone)) {
          const pHand = (getSeatHand2(pone) || []).slice();
          const isD = isDealerTeam2(pone);
          const opt = CribbageAI.organizeCanadianDoubles(pHand, isD, { settings: settings3, starter: state3.starter });
          setSeatHand2(pone, opt.keepHand);
          setSeatKept2(pone, opt.keepHand.slice());
          setSeatHand2(ponePartner, opt.partnerHand);
          setSeatKept2(ponePartner, opt.partnerHand.slice());
          state3.crib.push(...opt.cribDiscards);
          state3.seatDiscards[pone] = opt.cribDiscards;
          log2(`${seatName3(pone)} organized hand: kept 4, passed 4 to ${seatName3(ponePartner)}, discarded 2 to the crib.`);
          _GameEngine.startCanadianDoublesFlow(context);
          return;
        } else {
          state3.currentHumanDiscard = pone;
          state3.phase = "discard";
          setStatus2(`${seatName3(pone)}: Organize your 10 cards (Keep 4, Pass 4 to ${seatName3(ponePartner)}, Discard 2).`);
          render2();
          if (ModalCls && typeof ModalCls.open === "function") {
            ModalCls.open(pone, { ...context, onComplete: () => _GameEngine.startCanadianDoublesFlow(context) });
          }
          return;
        }
      }
      if (!dealerDone) {
        const dealerPartner = getPartnerSeat(dealer);
        if (isSeatCpu2(dealer)) {
          const dHand = (getSeatHand2(dealer) || []).slice();
          const isD = isDealerTeam2(dealer);
          const opt = CribbageAI.organizeCanadianDoubles(dHand, isD, { settings: settings3, starter: state3.starter });
          setSeatHand2(dealer, opt.keepHand);
          setSeatKept2(dealer, opt.keepHand.slice());
          setSeatHand2(dealerPartner, opt.partnerHand);
          setSeatKept2(dealerPartner, opt.partnerHand.slice());
          state3.crib.push(...opt.cribDiscards);
          state3.seatDiscards[dealer] = opt.cribDiscards;
          log2(`${seatName3(dealer)} organized hand: kept 4, passed 4 to ${seatName3(dealerPartner)}, discarded 2 to the crib.`);
          _GameEngine.startCanadianDoublesFlow(context);
          return;
        } else {
          hideWait2();
          passTo2(dealer, () => {
            state3.currentHumanDiscard = dealer;
            state3.phase = "discard";
            setStatus2(`${seatName3(dealer)}: Organize your 10 cards (Keep 4, Pass 4 to ${seatName3(dealerPartner)}, Discard 2).`);
            render2();
            if (ModalCls && typeof ModalCls.open === "function") {
              ModalCls.open(dealer, { ...context, onComplete: () => _GameEngine.startCanadianDoublesFlow(context) });
            }
          });
          return;
        }
      }
    }
    /**
     * Authoritatively confirms and processes human discards across all match formats.
     * @param {Object} [context]
     */
    static confirmDiscard(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const confirmPickCrib2 = context.confirmPickCrib || (typeof window !== "undefined" ? window.confirmPickCrib : _GameEngine.confirmPickCrib);
      if (state3.phase === "pick-crib") {
        confirmPickCrib2(context);
        return;
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const count = parseInt(settings3.playerCount, 10) || 2;
      const currentSeat = state3.currentHumanDiscard || "p1";
      if (settings3.optCanadianDoubles && count === 4) {
        const getSeatHand3 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const curHand = getSeatHand3(currentSeat);
        if (curHand && curHand.length === 10) {
          const ModalCls = CanadianDoublesModal || (typeof CC !== "undefined" ? CC.CanadianDoublesModal : typeof window !== "undefined" ? window.CanadianDoublesModal || window.CrazyCribbage?.CanadianDoublesModal : null);
          if (ModalCls && typeof ModalCls.open === "function") {
            ModalCls.open(currentSeat, { ...context, onComplete: () => _GameEngine.startCanadianDoublesFlow(context) });
            return;
          }
        }
      }
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      let discardN = count >= 3 ? 1 : is7Card ? 2 : settings3.deal === "super" ? 3 : 2;
      if ((settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        discardN = currentSeat === state3.dealer ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
      }
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const me = mySeat3();
      if (!state3.selected || state3.selected.length !== discardN) return;
      const seatDiscardsToDeck2 = context.seatDiscardsToDeck || (typeof window !== "undefined" ? window.seatDiscardsToDeck : () => false);
      if (settings3 && settings3.optFivesCribbage && !seatDiscardsToDeck2(currentSeat)) {
        const getSeatHand3 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (c) => c && (c.rank !== void 0 ? c.rank : c.r) || 0);
        const currHand2 = getSeatHand3(currentSeat) || [];
        const fivesInHand = currHand2.filter((c) => rankOf2(c) === 5);
        const reqFives = Math.min(fivesInHand.length, discardN);
        if (reqFives > 0) {
          const selIds = new Set(state3.selected);
          const selectedFives = currHand2.filter((c) => selIds.has(c.id) && rankOf2(c) === 5);
          if (selectedFives.length < reqFives) {
            const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
            });
            const setStatus3 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
            });
            fancyCall2("Five's Cribbage: Discard your 5s!", "go", 1600);
            setStatus3(`Five's Cribbage: You must discard any 5s in your hand to the crib (${reqFives} required).`);
            return;
          }
        }
      }
      if (settings3 && settings3.optSevensAndEightsCribbage && !seatDiscardsToDeck2(currentSeat)) {
        const getSeatHand3 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (c) => c && (c.rank !== void 0 ? c.rank : c.r) || 0);
        const currHand2 = getSeatHand3(currentSeat) || [];
        const sevensAndEights = currHand2.filter((c) => {
          const r = rankOf2(c);
          return r === 7 || r === 8;
        });
        const reqCount = Math.min(sevensAndEights.length, discardN);
        if (reqCount > 0) {
          const selIds = new Set(state3.selected);
          const selectedTarget = currHand2.filter((c) => selIds.has(c.id) && (rankOf2(c) === 7 || rankOf2(c) === 8));
          if (selectedTarget.length < reqCount) {
            const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
            });
            const setStatus3 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
            });
            fancyCall2("Sevens and Eights Cribbage: Discard your 7s and 8s!", "go", 1600);
            setStatus3(`Sevens and Eights Cribbage: You must discard any 7s and 8s in your hand to the crib (${reqCount} required).`);
            return;
          }
        }
      }
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const handleSeatDiscardIntent2 = context.handleSeatDiscardIntent || (typeof window !== "undefined" ? window.handleSeatDiscardIntent : () => {
      });
      if (isOnline2()) {
        if (settings3.netRole === "guest") {
          netSend2({ type: "intent", op: "discard", ids: state3.selected, seatId: me });
          state3.selected = [];
          setStatus2("Discards submitted. Waiting for other players\u2026");
          render2();
          return;
        } else {
          handleSeatDiscardIntent2(me, state3.selected);
          return;
        }
      }
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const startHumanPickCrib2 = context.startHumanPickCrib || (typeof window !== "undefined" ? window.startHumanPickCrib : _GameEngine.startHumanPickCrib);
      const isTwoHuman2 = context.isTwoHuman || (typeof window !== "undefined" ? window.isTwoHuman : () => false);
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (c) => Boolean(c && c.wild));
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => false);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isDealerTeam2 = context.isDealerTeam || (typeof window !== "undefined" ? window.isDealerTeam : () => false);
      const chooseDiscard2 = context.chooseDiscard || (typeof window !== "undefined" ? window.chooseDiscard : () => []);
      const startPlayAfterDiscards2 = context.startPlayAfterDiscards || (typeof window !== "undefined" ? window.startPlayAfterDiscards : _GameEngine.startPlayAfterDiscards);
      const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : _GameEngine.startStarter);
      const ids = new Set(state3.selected);
      const currHand = getSeatHand2(currentSeat);
      const thrown = currHand.filter((c) => ids.has(c.id));
      const remaining = currHand.filter((c) => !ids.has(c.id));
      setSeatHand2(currentSeat, remaining);
      setSeatKept2(currentSeat, remaining.slice());
      state3.seatDiscards = state3.seatDiscards || {};
      state3.seatDiscards[currentSeat] = thrown;
      state3.selected = [];
      if (!state3.coachHistory) {
        state3.coachHistory = { discards: [], peggingTurns: [], cuts: [] };
      }
      if (currentSeat === "p1" || currentSeat === "you") {
        state3.coachHistory.discards.push({
          round: state3.round || 1,
          isDealer: Boolean(currentSeat === state3.dealer || typeof isDealerTeam2 === "function" && isDealerTeam2(currentSeat)),
          hand: currHand.slice(),
          discards: thrown.slice(),
          kept: remaining.slice()
        });
      }
      if ((settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        if (currentSeat !== state3.dealer) {
          const dealerSeat = state3.dealer;
          const dHand = (getSeatHand2(dealerSeat) || []).slice();
          dHand.push(...thrown);
          setSeatHand2(dealerSeat, dHand);
          log2(`${seatName3(currentSeat)} discarded ${thrown.length} card${thrown.length > 1 ? "s" : ""} to ${seatName3(dealerSeat)}'s hand.`);
          const dealerDiscardN = settings3.deal === "super" ? 6 : 4;
          if (isSeatCpu2(dealerSeat)) {
            const dCurrHand = getSeatHand2(dealerSeat);
            const cpuThrow = chooseDiscard2(dCurrHand, true, settings3.goal === "low", dealerDiscardN);
            const cids = new Set(cpuThrow.map((c) => c.id));
            const dealerKept = dCurrHand.filter((c) => !cids.has(c.id));
            setSeatHand2(dealerSeat, dealerKept);
            setSeatKept2(dealerSeat, dealerKept.slice());
            state3.crib = state3.crib || [];
            state3.crib.push(...cpuThrow);
            state3.seatDiscards = state3.seatDiscards || {};
            state3.seatDiscards[dealerSeat] = cpuThrow;
            log2(`${seatName3(dealerSeat)} discarded ${cpuThrow.length} cards to the crib.`);
            state3.currentHumanDiscard = null;
            state3.discardsComplete = true;
            if (settings3.optCutBeforeDiscard) {
              startPlayAfterDiscards2(context);
            } else {
              startStarter2(context);
            }
            return;
          } else {
            hideWait2();
            passTo2(dealerSeat, () => {
              state3.currentHumanDiscard = dealerSeat;
              state3.phase = "discard";
              const beginDiscard2 = context.beginDiscard || (typeof window !== "undefined" ? window.beginDiscard : _GameEngine.beginDiscard);
              beginDiscard2(context);
            });
            return;
          }
        } else {
          state3.crib = state3.crib || [];
          state3.crib.push(...thrown);
          log2(`${seatName3(currentSeat)} discarded ${thrown.length} cards to the crib.`);
          state3.currentHumanDiscard = null;
          state3.discardsComplete = true;
          if (settings3.optCutBeforeDiscard) {
            startPlayAfterDiscards2(context);
          } else {
            startStarter2(context);
          }
          return;
        }
      }
      if (seatDiscardsToDeck2(currentSeat)) {
        state3.deckDiscards = state3.deckDiscards || [];
        state3.deckDiscards.push(...thrown);
        log2(`${seatName3(currentSeat)} discards 1 card to the deck.`);
      } else {
        state3.crib = state3.crib || [];
        state3.crib.push(...thrown);
      }
      if (settings3.optPickYourCrib) {
        const pones = getActiveSeatIds2().filter((sId) => sId !== state3.dealer);
        state3.pickPones = pones.slice();
        startHumanPickCrib2(context);
        return;
      }
      if (count === 2 && isTwoHuman2() && currentSeat === "p1") {
        hideWait2();
        passTo2("p2", () => {
          state3.currentHumanDiscard = "p2";
          if (settings3.jokers && (getSeatHand2("p2") || []).some((c) => isWild2(c) && !c.playAs)) {
            state3.phase = "assign-p2";
            state3.assignTarget = "hand-p2";
            render2();
            netPush2();
            return;
          }
          state3.phase = "discard-p2";
          render2();
          netPush2({ fancy: { text: "Your turn to discard!", kind: "combo", ms: 1200 } });
        });
        return;
      }
      const pendingHuman = getActiveSeatIds2().find((sId) => isSeatHuman2(sId) && (!state3.seatDiscards || !state3.seatDiscards[sId]));
      if (pendingHuman) {
        hideWait2();
        passTo2(pendingHuman, () => {
          state3.currentHumanDiscard = pendingHuman;
          state3.phase = "discard";
          render2();
        });
        return;
      }
      const activeSeats = getActiveSeatIds2();
      for (const sId of activeSeats) {
        if (isSeatCpu2(sId) && (!state3.seatDiscards || !state3.seatDiscards[sId])) {
          const sHand = getSeatHand2(sId);
          const isDealer = isDealerTeam2(sId);
          const toDeck = seatDiscardsToDeck2(sId);
          const cpuThrow = chooseDiscard2(sHand, isDealer, settings3.goal === "low", discardN, toDeck, sId);
          const cids = new Set(cpuThrow.map((c) => c.id));
          const sKept = sHand.filter((c) => !cids.has(c.id));
          setSeatHand2(sId, sKept);
          setSeatKept2(sId, sKept.slice());
          state3.seatDiscards = state3.seatDiscards || {};
          state3.seatDiscards[sId] = cpuThrow;
          if (toDeck) {
            state3.deckDiscards = state3.deckDiscards || [];
            state3.deckDiscards.push(...cpuThrow);
            log2(`${seatName3(sId)} discards 1 card to the deck.`);
          } else {
            state3.crib = state3.crib || [];
            state3.crib.push(...cpuThrow);
          }
          try {
            GameReplayManager.recordEvent("discard", { who: sId, discards: cpuThrow });
          } catch (_) {
          }
        }
      }
      state3.currentHumanDiscard = null;
      if (settings3 && settings3.optDrawCribbage && count === 2) {
        _GameEngine.startDrawCribbagePhase(2, context);
        return;
      }
      if (settings3.optCutBeforeDiscard) {
        state3.discardsComplete = true;
        startPlayAfterDiscards2(context);
      } else if (settings3.optGuessStarter) {
        state3.discardsComplete = true;
        const beginCutStarter2 = context.beginCutStarter || (typeof window !== "undefined" ? window.beginCutStarter : _GameEngine.beginCutStarter);
        beginCutStarter2(context);
      } else {
        startStarter2(context);
      }
    }
    /**
     * Determines which active players with remaining cards were unable to play
     * and were skipped between fromSeat and nextPlayer.
     * @param {string} fromSeat - The seat that just played
     * @param {string|null} nextPlayer - The next seat with a legal play, or null if no one can play
     * @param {Array<string>} activeSeats - Active seat IDs in rotation order
     * @param {Function} getSeatHand - Function returning remaining cards for a seat
     * @returns {Array<string>} Seat IDs that had to call 'Go'
     */
    static getSkippedGoSeats(fromSeat, nextPlayer, activeSeats, getSeatHand2) {
      if (!Array.isArray(activeSeats) || activeSeats.length === 0) return [];
      const startIndex = activeSeats.indexOf(fromSeat);
      if (startIndex === -1) return [];
      const n = activeSeats.length;
      const skipped = [];
      const limit = nextPlayer === null ? n : nextPlayer === fromSeat ? n : (activeSeats.indexOf(nextPlayer) - startIndex + n) % n;
      for (let i = 1; i < limit; i++) {
        const idx = (startIndex + i) % n;
        const sId = activeSeats[idx];
        const hand = typeof getSeatHand2 === "function" ? getSeatHand2(sId) : [];
        if (hand && hand.length > 0) {
          skipped.push(sId);
        }
      }
      return skipped;
    }
    /**
     * Displays an on-screen message and triggers notifications when a player says Go.
     * @param {string|Array<string>} whoSaidGo - Seat ID or array of Seat IDs who called Go
     * @param {Object} [context]
     */
    static announceGo(whoSaidGo, context = {}) {
      const rawSeats = Array.isArray(whoSaidGo) ? whoSaidGo : [whoSaidGo];
      const seats = rawSeats.map((s) => s && typeof s === "object" ? s.id || "" : s).filter((s) => typeof s === "string" && s.length > 0 && !s.includes("[object"));
      if (seats.length === 0) return;
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const me = mySeat3();
      const names = seats.map((s) => {
        if (s === me) return "You";
        const n = seatName3(s);
        if (!n || typeof n !== "string" || n.includes("[object")) {
          return s === "p1" ? "You" : "Opponent";
        }
        return n === "You" || typeof n === "string" && n.endsWith("(You)") ? "You" : n;
      });
      let displayMsg = "";
      if (names.length === 1) {
        displayMsg = names[0] === "You" ? 'You say "Go!"' : `${names[0]} says "Go!"`;
      } else if (names.length === 2) {
        displayMsg = `${names[0]} & ${names[1]} say "Go!"`;
      } else {
        displayMsg = `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]} say "Go!"`;
      }
      fancyCall2(displayMsg, "go", 1800);
      setStatus2(displayMsg);
      seats.forEach((s) => {
        const sN = seatName3(s);
        log2(`${sN} says go.`);
      });
      try {
        const renderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
        if (renderer3D && typeof renderer3D.showSeatReaction === "function") {
          seats.forEach((s) => renderer3D.showSeatReaction(s, "\u{1F4AC} GO!"));
        }
      } catch (_) {
      }
      netPush2({
        fancy: {
          text: displayMsg,
          kind: "go",
          ms: 1800,
          goSeat: seats[0],
          goSeats: seats
        }
      });
    }
    /**
     * Displays an on-screen message and updates prompts when it is a human player's turn to play a card.
     * @param {string} seatId
     * @param {Object} [context]
     */
    static announcePlayTurn(seatId, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.over || state3.phase !== "play") return;
      const seat = seatId || state3.turn;
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => true);
      if (!isSeatHuman2(seat)) return;
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const me = mySeat3();
      const isMe = seat === me || !isOnline2() && (seat === "p1" || seat === "you");
      const msg = isMe ? "Your turn: Play a card" : `${seatName3(seat)}\u2019s turn: Play a card`;
      fancyCall2(msg, "play-turn", 1500);
      setStatus2(msg);
      try {
        const renderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
        if (renderer3D && typeof renderer3D.showSeatReaction === "function") {
          renderer3D.showSeatReaction(seat, "\u{1F3B4}");
        }
      } catch (_) {
      }
      if (isOnline2()) {
        netPush2({
          fancy: {
            text: msg,
            kind: "play-turn",
            ms: 1500,
            turnSeat: seat
          }
        });
      }
    }
    /**
     * Settles a 'Go' or '31' event, resets running count/pile, and advances lead.
     * @param {string} whoJustPlayed
     * @param {Object} [context]
     * @param {Array<string>|string} [goSeats=null]
     */
    static settleGo(whoJustPlayed, arg2 = {}, arg3 = null) {
      let context = {};
      let goSeats = null;
      if (Array.isArray(arg2) || typeof arg2 === "string") {
        goSeats = arg2;
        context = arg3 && typeof arg3 === "object" && !Array.isArray(arg3) ? arg3 : {};
      } else if (arg2 && typeof arg2 === "object" && !Array.isArray(arg2)) {
        context = arg2;
        goSeats = Array.isArray(arg3) || typeof arg3 === "string" ? arg3 : null;
      } else {
        goSeats = Array.isArray(arg3) || typeof arg3 === "string" ? arg3 : null;
      }
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const finishPlay2 = context.finishPlay || (typeof window !== "undefined" ? window.finishPlay : _GameEngine.finishPlay);
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" && typeof window.nextSeat === "function" ? window.nextSeat : (s) => _GameEngine.advanceDealer(s, getActiveSeatIds2()));
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => false);
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : () => {
      });
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const is31 = state3.count === 31;
      state3.turn = null;
      state3.frozen = true;
      state3.pileFaceDown = true;
      if (state3.pile && state3.pile.length) {
        state3.pile.forEach((c) => {
          if (c) c.faceDown = true;
        });
      }
      if (state3.played && state3.played.length) {
        state3.played.forEach((item) => {
          if (item && item.card) item.card.faceDown = true;
          if (item) item.faceDown = true;
        });
      }
      let seatsWhoSaidGo = null;
      if (Array.isArray(goSeats)) {
        const filtered = goSeats.map((s) => s && typeof s === "object" ? s.id || "" : s).filter((s) => typeof s === "string" && s.length > 0 && !s.includes("[object"));
        if (filtered.length > 0) seatsWhoSaidGo = filtered;
      } else if (typeof goSeats === "string" && goSeats.length > 0 && !goSeats.includes("[object")) {
        seatsWhoSaidGo = [goSeats];
      }
      const cleanWhoJustPlayed = typeof whoJustPlayed === "string" ? whoJustPlayed : whoJustPlayed && typeof whoJustPlayed === "object" && whoJustPlayed.id ? whoJustPlayed.id : "p1";
      if (!seatsWhoSaidGo || seatsWhoSaidGo.length === 0) {
        const activeSeats = getActiveSeatIds2().filter((sId) => typeof sId === "string" && sId !== cleanWhoJustPlayed && !sId.includes("[object"));
        seatsWhoSaidGo = activeSeats.filter((sId) => getSeatHand2(sId).length > 0);
      }
      const me = mySeat3();
      let goText = "GO";
      if (is31) {
        goText = "Thirty-one!";
      } else if (seatsWhoSaidGo && seatsWhoSaidGo.length > 0) {
        const names = seatsWhoSaidGo.map((s) => {
          if (s === me) return "You";
          const n = seatName3(s);
          if (!n || typeof n !== "string" || n.includes("[object")) {
            return s === "p1" ? "You" : "Opponent";
          }
          return n === "You" || typeof n === "string" && n.endsWith("(You)") ? "You" : n;
        });
        let whoSays = "";
        if (names.length === 1) {
          whoSays = names[0] === "You" ? 'You say "Go!"' : `${names[0]} says "Go!"`;
        } else if (names.length === 2) {
          whoSays = `${names[0]} & ${names[1]} say "Go!"`;
        } else {
          whoSays = `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]} say "Go!"`;
        }
        const rawScorer = cleanWhoJustPlayed === me ? "You" : seatName3(cleanWhoJustPlayed);
        const scorer = typeof rawScorer === "string" && !rawScorer.includes("[object") ? rawScorer : cleanWhoJustPlayed === "p1" ? "You" : "Opponent";
        goText = `${whoSays} \u2014 1 pt to ${scorer}`;
        seatsWhoSaidGo.forEach((s) => {
          const sN = seatName3(s);
          log2(`${sN} says go.`);
        });
        try {
          const renderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
          if (renderer3D && typeof renderer3D.showSeatReaction === "function") {
            seatsWhoSaidGo.forEach((s) => renderer3D.showSeatReaction(s, "\u{1F4AC} GO!"));
          }
        } catch (_) {
        }
      } else {
        const scorer = whoJustPlayed === me ? "You" : seatName3(whoJustPlayed);
        goText = `Go / Last Card \u2014 1 pt to ${scorer}`;
      }
      try {
        GameReplayManager.recordEvent("peg_go", {
          who: whoJustPlayed,
          points: is31 ? 2 : 1,
          reason: is31 ? "31" : "Go",
          scores: state3.scores
        });
      } catch (_) {
      }
      fancyCall2(goText, "go", 1800);
      setStatus2(goText);
      if (doc) {
        const pl = doc.getElementById("playedCards");
        if (pl) {
          pl.classList.add("face-down");
          const cards = pl.querySelectorAll(".playing-card");
          cards.forEach((cEl) => {
            cEl.classList.add("back", "face-down", "flipping-down");
            cEl.removeAttribute("data-badge");
            cEl.innerHTML = '<span></span><span class="suit">\u2726</span>';
          });
        }
      }
      try {
        const renderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
        if (renderer3D && renderer3D.cardEngine && typeof renderer3D.cardEngine.turnPlayPileFaceDown === "function") {
          renderer3D.cardEngine.turnPlayPileFaceDown();
        }
      } catch (_) {
      }
      render2();
      netPush2({
        fancy: {
          text: goText,
          kind: "go",
          ms: 1800,
          goSeat: seatsWhoSaidGo && seatsWhoSaidGo[0] || null,
          goSeats: seatsWhoSaidGo,
          scorerSeat: whoJustPlayed
        },
        sfx: is31 ? "bell31" : "peg"
      });
      setTimeout(() => {
        if (doc) {
          const pl = doc.getElementById("playedCards");
          if (pl) pl.classList.add("sweeping");
        }
        try {
          const renderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
          if (renderer3D && renderer3D.cardEngine && typeof renderer3D.cardEngine.sweepPlayPile === "function") {
            renderer3D.cardEngine.sweepPlayPile();
          }
        } catch (_) {
        }
      }, 1400);
      setTimeout(() => {
        state3.frozen = false;
        state3.pileFaceDown = false;
        if (doc) {
          const pl = doc.getElementById("playedCards");
          if (pl) pl.classList.remove("face-down", "sweeping");
        }
        if (state3.over || state3.phase !== "play") return;
        const activeSeats = getActiveSeatIds2();
        const anyCardsLeft = activeSeats.some((sId) => getSeatHand2(sId).length > 0);
        if (!anyCardsLeft) {
          finishPlay2(context);
          return;
        }
        const cleanWhoJustPlayed2 = typeof whoJustPlayed === "string" ? whoJustPlayed : whoJustPlayed && typeof whoJustPlayed === "object" && whoJustPlayed.id ? whoJustPlayed.id : "p1";
        let nextLead = nextSeat2(cleanWhoJustPlayed2);
        const startLead = nextLead;
        while (getSeatHand2(nextLead).length === 0) {
          nextLead = nextSeat2(nextLead);
          if (nextLead === startLead) break;
        }
        state3.count = 0;
        state3.pile = [];
        state3.turn = nextLead;
        render2();
        netPush2();
        if (isSeatCpu2(nextLead)) {
          scheduleOppPlay2(nextLead);
        } else if (isSeatHuman2(nextLead)) {
          _GameEngine.announcePlayTurn(nextLead, context);
          if (!isOnline2() && nextLead !== whoJustPlayed) {
            passTo2(nextLead, () => {
              render2();
            });
          }
        }
      }, 2e3);
    }
    /**
     * Plays a card to the pegging pile, validates counts, scores pegging, and routes turn.
     * @param {string} who
     * @param {Object} card
     * @param {Object} [context]
     */
    static playCard(who, card, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || !card || state3.over || state3.frozen || state3.paused || state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus) return;
      if (state3.phase && state3.phase !== "play" && state3.phase !== "pegging") return;
      if (!who) return;
      let sId = who;
      if (sId === "you") sId = "p1";
      if (sId === "cpu") sId = "p2";
      if (state3.turn === null) return;
      if (state3.turn !== void 0) {
        let turnSeat = state3.turn;
        if (turnSeat === "you") turnSeat = "p1";
        if (turnSeat === "cpu") turnSeat = "p2";
        if (turnSeat !== sId) return;
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const VAL4 = context.VAL || (typeof window !== "undefined" ? window.VAL : (r) => Math.min(r, 10));
      const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (c) => c.rank);
      const pegPoints2 = context.pegPoints || (typeof window !== "undefined" ? window.pegPoints : () => []);
      const isBonusMessage2 = context.isBonusMessage || (typeof window !== "undefined" ? window.isBonusMessage : () => false);
      const announceCombos2 = context.announceCombos || (typeof window !== "undefined" ? window.announceCombos : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const cardLabel2 = context.cardLabel || (typeof window !== "undefined" ? window.cardLabel : (c) => String(c.rank));
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : () => false);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : { snap: () => {
      }, chime15: () => {
      }, bell31: () => {
      } });
      const addScore2 = context.addScore || (typeof window !== "undefined" ? window.addScore : () => {
      });
      const fancyPegPhrase2 = context.fancyPegPhrase || (typeof window !== "undefined" ? window.fancyPegPhrase : (w, n) => `${w} +${n}`);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const settleGo2 = context.settleGo || (typeof window !== "undefined" ? window.settleGo : _GameEngine.settleGo);
      const findNextPlayerWithPlay2 = context.findNextPlayerWithPlay || (typeof window !== "undefined" ? window.findNextPlayerWithPlay : _GameEngine.findNextPlayerWithPlay);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : () => {
      });
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => false);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const getSeatKept2 = context.getSeatKept || (typeof window !== "undefined" ? window.getSeatKept : null);
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : null);
      if ((state3.count || 0) + VAL4(rankOf2(card)) > 31) return;
      const hand = getSeatHand2(sId);
      const idx = hand.findIndex((c) => c.id === card.id);
      if (idx < 0) return;
      let maxPegPts = 0;
      try {
        const currentCountBefore = state3.count || 0;
        const legalCandidateCards = hand.filter((c) => currentCountBefore + VAL4(rankOf2(c)) <= 31);
        for (const candidate of legalCandidateCards) {
          const testPile = (state3.pile || []).concat(candidate);
          const testRaw = pegPoints2(testPile, candidate);
          const testTotal = testRaw.reduce((s, p) => s + p.n, 0);
          if (testTotal > maxPegPts) maxPegPts = testTotal;
        }
      } catch (_) {
      }
      hand.splice(idx, 1);
      if (sId === "p1") state3.youHand = hand;
      if (sId === "p2") state3.cpuHand = hand;
      card.who = sId;
      card.owner = sId;
      state3.pile = state3.pile || [];
      state3.played = state3.played || [];
      state3.pile.push(card);
      state3.played.push({ who: sId, card });
      state3.count = (state3.count || 0) + VAL4(rankOf2(card));
      state3.lastPlayed = sId;
      const isSpadesCut = Boolean(settings3 && settings3.optSpades && (state3.spadesCut || state3.starters && state3.starters.some(isSpadeCard)));
      const rawPts = pegPoints2(state3.pile, card);
      const pts = isSpadesCut ? rawPts.map((p) => ({ ...p, n: p.n * 2, why: `${p.why} (spades x2)` })) : rawPts;
      const total = pts.reduce((s, p) => s + p.n, 0);
      const why = pts.map((p) => p.why).join(", ") || "play";
      const isBonusPeg = pts.some((p) => isBonusMessage2(p.why)) || state3.count === 31 && settings3 && settings3.opt31sFor5;
      if (total) {
        card.pegBadge = "+" + total;
        if (isBonusPeg) card.pegBadgeBonus = true;
      }
      if (state3.count === 31 && !card.pegBadge) {
        card.pegBadge = "31";
        if (settings3 && settings3.opt31sFor5) card.pegBadgeBonus = true;
      }
      if (pts.length) announceCombos2(pts);
      let progStealPhrase = null;
      if (settings3 && settings3.optProgressiveSteals && state3.pile.length >= 2) {
        const lastR = rankOf2(card);
        let same = 0;
        for (let i = state3.pile.length - 1; i >= 0; i--) {
          if (rankOf2(state3.pile[i]) === lastR) same++;
          else break;
        }
        if (same >= 2 && state3.played.length >= same) {
          const pairedPlays = state3.played.slice(state3.played.length - same);
          const prevPlay = pairedPlays[pairedPlays.length - 2];
          if (prevPlay && prevPlay.who !== sId) {
            const cardsToControl = pairedPlays.map((p) => p.card);
            const activeSeats = typeof context.getActiveSeatIds === "function" ? context.getActiveSeatIds() : context.activeSeats || (state3.seats ? state3.seats.map((s) => s.id) : ["p1", "p2"]);
            const cardMatches = (a, b) => {
              if (!a || !b) return false;
              if (a.id && b.id) return a.id === b.id;
              return a.rank === b.rank && a.suit === b.suit;
            };
            const getKeptCards = (seat) => {
              if (typeof getSeatKept2 === "function") {
                const res = getSeatKept2(seat, state3) || getSeatKept2(seat);
                if (Array.isArray(res)) return res;
              }
              return GameState.getSeatKept(seat, state3) || [];
            };
            const setKeptCards = (seat, cards) => {
              if (typeof setSeatKept2 === "function") {
                setSeatKept2(seat, cards);
              }
              GameState.setSeatKept(seat, cards, state3);
            };
            for (const otherSeat of activeSeats) {
              if (otherSeat === sId) continue;
              const otherKept = getKeptCards(otherSeat).slice();
              const filtered = otherKept.filter((c) => !cardsToControl.some((sc) => cardMatches(sc, c)));
              if (filtered.length !== otherKept.length) {
                setKeptCards(otherSeat, filtered);
              }
            }
            const myKept = getKeptCards(sId).slice();
            for (const c of cardsToControl) {
              if (!myKept.some((existing) => cardMatches(existing, c))) {
                myKept.push(c);
              }
            }
            setKeptCards(sId, myKept);
            progStealPhrase = same === 2 ? `${seatName3(sId)} stole ${cardLabel2(prevPlay.card)}!` : same === 3 ? `${seatName3(sId)} controls all 3 cards!` : `${seatName3(sId)} controls all 4 cards!`;
            card.pegBadgeBonus = true;
            fancyCall2(progStealPhrase, "combo", 1800);
            log2(`\u26A1 PROGRESSIVE STEAL: ${progStealPhrase}`);
          }
        }
      }
      const logMsg = `${seatName3(sId)} play ${cardLabel2(card)}${isWild2(card) ? " (wild)" : ""}  (${state3.count})` + (total ? ` +${total}` : "");
      log2(logMsg);
      if (sfx3.snap) sfx3.snap();
      try {
        GameReplayManager.recordEvent("peg_play", {
          who: sId,
          card,
          countAfter: state3.count,
          points: total,
          reason: why,
          scores: state3.scores
        });
        if (!state3.coachHistory) {
          state3.coachHistory = { discards: [], peggingTurns: [], cuts: [] };
        }
        if (sId === "p1" || sId === "you") {
          state3.coachHistory.peggingTurns.push({
            who: sId,
            round: state3.round || 1,
            cardPlayed: card,
            pointsScored: total,
            maxPointsPossible: Math.max(total, maxPegPts),
            reason: why
          });
        }
      } catch (_) {
      }
      let soundName = "snap";
      if (state3.count === 15) {
        if (sfx3.chime15) sfx3.chime15();
        soundName = "chime15";
      }
      if (state3.count === 19 && settings3 && settings3.opt19sFor2) {
        if (sfx3.chime15) sfx3.chime15();
        soundName = "chime15";
      }
      if (state3.count === 31) {
        if (sfx3.bell31) sfx3.bell31();
        soundName = "bell31";
      }
      if (total) addScore2(sId, total, why);
      const isFourOfAKind = pts.some((p) => /double pair royal|4 of a kind|four of a kind/i.test(p.why || ""));
      if (isFourOfAKind && typeof window !== "undefined" && window._currentRenderer3D) {
        window._currentRenderer3D.triggerActionCam({ type: "four_of_a_kind", who: sId });
      }
      const isTopBonus = pts.length ? isBonusMessage2(pts[0].why) : false;
      const fancyItem = progStealPhrase ? { text: progStealPhrase, kind: "combo", ms: 2e3 } : pts.length ? { text: fancyPegPhrase2(pts[0].why, pts[0].n), kind: "combo", ms: isTopBonus ? 2200 : 1400 } : state3.count === 31 ? { text: settings3 && settings3.opt31sFor5 ? "Thirty-one for five!" : "Thirty-one!", kind: "go", ms: settings3 && settings3.opt31sFor5 ? 2400 : 1400 } : null;
      const continuePlay = () => {
        if (state3.over) {
          render2();
          netPush2({ log: logMsg, fancy: fancyItem, sfx: soundName });
          return;
        }
        if (state3.count === 31) {
          netPush2({ log: logMsg, fancy: fancyItem, sfx: soundName });
          settleGo2(sId, context);
          return;
        }
        const activeSeats = typeof context.getActiveSeatIds === "function" ? context.getActiveSeatIds() : typeof window !== "undefined" && typeof window.getActiveSeatIds === "function" ? window.getActiveSeatIds() : ["p1", "p2"];
        const nextPlayer = findNextPlayerWithPlay2(sId, state3.count);
        const skippedGoSeats = _GameEngine.getSkippedGoSeats(sId, nextPlayer, activeSeats, getSeatHand2);
        if (!nextPlayer) {
          const goPts = isSpadesCut ? 2 : 1;
          const goWhy = isSpadesCut ? "go / last card (spades x2)" : "go / last card";
          addScore2(sId, goPts, goWhy);
          const last = state3.pile[state3.pile.length - 1];
          if (last) last.pegBadge = last.pegBadge ? last.pegBadge + (isSpadesCut ? " GO (+2)" : " GO") : isSpadesCut ? "GO (+2)" : "GO";
          if (state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || state3.paused) {
            const resumeCb = () => {
              if (state3.over) {
                render2();
                netPush2({ log: logMsg, fancy: fancyItem, sfx: soundName });
                return;
              }
              netPush2({ log: logMsg, fancy: fancyItem, sfx: soundName });
              settleGo2(sId, context, skippedGoSeats);
            };
            state3._resumeAfterSign = resumeCb;
            state3._resumeAfterAdultTimer = resumeCb;
            state3._resumeAfterPintsBonus = resumeCb;
            return;
          }
          if (state3.over) {
            render2();
            netPush2({ log: logMsg, fancy: fancyItem, sfx: soundName });
            return;
          }
          netPush2({ log: logMsg, fancy: fancyItem, sfx: soundName });
          settleGo2(sId, context, skippedGoSeats);
          return;
        }
        if (skippedGoSeats.length > 0) {
          _GameEngine.announceGo(skippedGoSeats, context);
        }
        state3.turn = nextPlayer;
        render2();
        netPush2({ log: logMsg, fancy: fancyItem, sfx: soundName });
        if (isSeatCpu2(nextPlayer)) {
          scheduleOppPlay2(nextPlayer);
        } else if (isSeatHuman2(nextPlayer)) {
          const announceDelay = skippedGoSeats.length > 0 ? 1400 : fancyItem ? fancyItem.ms || 1200 : 100;
          setTimeout(() => {
            if (!state3 || state3.over || state3.phase !== "play" || state3.turn !== nextPlayer && state3.passingTo !== nextPlayer) return;
            _GameEngine.announcePlayTurn(nextPlayer, context);
            if (!isOnline2() && nextPlayer !== sId) {
              passTo2(nextPlayer, () => {
                render2();
              });
            }
          }, announceDelay);
        }
      };
      if (state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || state3.paused) {
        state3._resumeAfterSign = continuePlay;
        state3._resumeAfterAdultTimer = continuePlay;
        state3._resumeAfterPintsBonus = continuePlay;
        return;
      }
      continuePlay();
    }
    /**
     * Executes CPU player turn during pegging play.
     * @param {string} seatId
     * @param {Object} [context]
     */
    static cpuSeatPlay(seatId, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.over || state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || state3.paused || state3.phase !== "play" || state3.turn !== seatId) return;
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const choosePlay2 = context.choosePlay || (typeof window !== "undefined" ? window.choosePlay : () => null);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const findNextPlayerWithPlay2 = context.findNextPlayerWithPlay || (typeof window !== "undefined" ? window.findNextPlayerWithPlay : _GameEngine.findNextPlayerWithPlay);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : () => {
      });
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => false);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      const addScore2 = context.addScore || (typeof window !== "undefined" ? window.addScore : () => {
      });
      const settleGo2 = context.settleGo || (typeof window !== "undefined" ? window.settleGo : _GameEngine.settleGo);
      const playCard2 = context.playCard || (typeof window !== "undefined" ? window.playCard : _GameEngine.playCard);
      const hand = getSeatHand2(seatId);
      const card = choosePlay2(hand, state3.pile, state3.count, true, settings3.goal === "low", seatId);
      if (!card) {
        _GameEngine.announceGo(seatId, context);
        const nextPlayer = findNextPlayerWithPlay2(seatId, state3.count);
        if (nextPlayer) {
          state3.turn = nextPlayer;
          render2();
          netPush2();
          if (isSeatCpu2(nextPlayer)) {
            scheduleOppPlay2(nextPlayer);
          } else if (isSeatHuman2(nextPlayer)) {
            setTimeout(() => {
              if (!state3 || state3.over || state3.phase !== "play" || state3.turn !== nextPlayer && state3.passingTo !== nextPlayer) return;
              _GameEngine.announcePlayTurn(nextPlayer, context);
              if (!isOnline2()) {
                passTo2(nextPlayer, () => {
                  render2();
                });
              }
            }, 1400);
          }
        } else {
          if (state3.count !== 31 && state3.lastPlayed) {
            const isSpadesCut = Boolean(settings3 && settings3.optSpades && (state3.spadesCut || state3.starters && state3.starters.some(isSpadeCard)));
            const goPts = isSpadesCut ? 2 : 1;
            const goWhy = isSpadesCut ? "go / last card (spades x2)" : "go / last card";
            addScore2(state3.lastPlayed, goPts, goWhy);
            const last = state3.pile[state3.pile.length - 1];
            if (last) last.pegBadge = last.pegBadge ? last.pegBadge + (isSpadesCut ? " GO (+2)" : " GO") : isSpadesCut ? "GO (+2)" : "GO";
          }
          if (state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || state3.paused) {
            const resumeCb = () => {
              if (state3.over) {
                render2();
                return;
              }
              settleGo2(state3.lastPlayed || seatId, context, [seatId]);
            };
            state3._resumeAfterSign = resumeCb;
            state3._resumeAfterAdultTimer = resumeCb;
            state3._resumeAfterPintsBonus = resumeCb;
            return;
          }
          if (state3.over) {
            render2();
            return;
          }
          settleGo2(state3.lastPlayed || seatId, context, [seatId]);
        }
        return;
      }
      playCard2(seatId, card, context);
    }
    /**
     * Legacy CPU turn handler delegating to seat 'p2'.
     * @param {Object} [context]
     */
    static cpuTurn(context = {}) {
      _GameEngine.cpuSeatPlay("p2", context);
    }
    /**
     * Finalizes the pegging play phase, prepares hands for show, and starts hand scoring.
     * @param {Object} [context]
     */
    static finishPlay(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const getPlayerCount2 = context.getPlayerCount || (typeof window !== "undefined" ? window.getPlayerCount : () => 2);
      const getSeatKept2 = context.getSeatKept || (typeof window !== "undefined" ? window.getSeatKept : () => []);
      const scoreShow2 = context.scoreShow || (typeof window !== "undefined" ? window.scoreShow : () => ({ total: 0 }));
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : (s) => s);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const openShowModal2 = context.openShowModal || (typeof window !== "undefined" ? window.openShowModal : () => {
      });
      const beginShowAct2 = context.beginShowAct || (typeof window !== "undefined" ? window.beginShowAct : () => {
      });
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" ? window.nextSeat : (s) => s);
      const isSoloVsPairs2 = context.isSoloVsPairs || (typeof window !== "undefined" ? window.isSoloVsPairs : () => false);
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : null) || GameState.setSeatKept;
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      if (state3.over) return;
      state3.phase = "show";
      const cribEl = typeof document !== "undefined" ? document.getElementById("cribCards") : null;
      if (cribEl) {
        cribEl.classList.remove("playing");
        cribEl.classList.add("counting");
      }
      state3.revealCrib = false;
      state3.highlightIds = [];
      const pegOnly = settings3.target === 31;
      const count = getPlayerCount2();
      if (count === 2) {
        const isP1Deal = state3.dealer === "p1" || state3.dealer === "you";
        const pone = isP1Deal ? "p2" : "p1";
        const deal = isP1Deal ? "p1" : "p2";
        const poneKept = getSeatKept2(pone);
        let dealKept = getSeatKept2(deal);
        const isShotgun = Boolean(settings3 && settings3.optShotgunCribbage);
        const isTwisted = Boolean(settings3 && settings3.optTwistedCribbage);
        const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
        const starterArg = starters.length > 1 ? starters : state3.starter;
        const poneScore = scoreShow2(poneKept, starterArg, false);
        let dealScore;
        let cribScore;
        let cribCards = state3.crib;
        state3.twistedCribbageResolved = false;
        if (isTwisted) {
          const combined = [...dealKept, ...state3.crib || []];
          state3.twisted8Cards = [...combined];
          state3.originalDealerKept = [...dealKept];
          state3.originalCrib = [...state3.crib || []];
          const Scorer = typeof CC !== "undefined" && CC?.CribbageScorer || (typeof window !== "undefined" ? window.CribbageScorer : null) || CribbageScorer2;
          const bestSplit = Scorer && typeof Scorer.findOptimalTwistedSplit === "function" ? Scorer.findOptimalTwistedSplit(combined, starterArg, settings3) : null;
          if (bestSplit) {
            dealKept = bestSplit.hand1;
            cribCards = bestSplit.hand2;
            dealScore = bestSplit.score1;
            cribScore = bestSplit.score2;
            state3.crib = cribCards;
            if (typeof setSeatKept2 === "function") {
              setSeatKept2(deal, dealKept, state3);
            } else if (state3.seatKept) {
              state3.seatKept[deal] = dealKept;
            }
            log2(`\u{1F300} Twisted Cribbage: ${pName2(deal)} combined 8 cards into two optimal hands (+${dealScore.total} & +${cribScore.total} = ${bestSplit.total} pts)!`);
          } else {
            dealScore = scoreShow2(dealKept, starterArg, false);
            cribScore = scoreShow2(state3.crib, starterArg, true, false, { dealerHand: dealKept });
          }
        } else {
          dealScore = scoreShow2(dealKept, starterArg, false);
          cribScore = scoreShow2(state3.crib, starterArg, true, false, { dealerHand: dealKept });
        }
        const cribSigned = pegOnly || isShotgun ? 0 : settings3.optRockCrib ? -cribScore.total : cribScore.total;
        state3.lastShow = {
          pone: { title: pName2(pone) + " hand (pone)", cards: poneKept, starter: state3.starter, starters, score: poneScore, signed: poneScore.total, who: pone },
          dealer: {
            title: isTwisted ? `${pName2(deal)} hand (Twisted 1/2)` : `${pName2(deal)} hand (dealer)`,
            cards: dealKept,
            starter: state3.starter,
            starters,
            score: dealScore,
            signed: dealScore.total,
            who: deal
          },
          crib: {
            title: isShotgun ? "Crib (Shotgun Cribbage)" : isTwisted ? `Crib (Twisted 2/2)` : "Crib",
            cards: cribCards,
            starter: state3.starter,
            starters,
            score: cribScore,
            signed: cribSigned,
            who: deal
          }
        };
        if (pegOnly) {
          openShowModal2(true);
          return;
        }
        state3.showQueue = ["pone", "dealer", "crib"];
        beginShowAct2(0);
      } else {
        const rawDealer = state3.dealer || "p1";
        const dealerSeat = rawDealer === "you" ? "p1" : rawDealer === "cpu" ? "p2" : rawDealer;
        const activeSeats = typeof context.getActiveSeatIds === "function" ? context.getActiveSeatIds() : typeof window !== "undefined" && typeof window.getActiveSeatIds === "function" ? window.getActiveSeatIds() : ["p1", "p2", "p3", "p4"];
        const showOrder = [];
        const dIdx = activeSeats.indexOf(dealerSeat);
        if (dIdx !== -1) {
          for (let i = 1; i < activeSeats.length; i++) {
            showOrder.push(activeSeats[(dIdx + i) % activeSeats.length]);
          }
          showOrder.push(dealerSeat);
        } else {
          const nextSeatFn = context.nextSeat || (typeof window !== "undefined" ? window.nextSeat : (s) => _GameEngine.advanceDealer(s, activeSeats));
          let curr = nextSeatFn(dealerSeat);
          let safety = 0;
          while (curr !== dealerSeat && safety < activeSeats.length + 2) {
            showOrder.push(curr);
            curr = nextSeatFn(curr);
            safety++;
          }
          showOrder.push(dealerSeat);
        }
        state3.lastShow = {};
        state3.showQueue = [];
        const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
        const starterArg = starters.length > 1 ? starters : state3.starter;
        for (const sId of showOrder) {
          const kept = getSeatKept2(sId);
          const sScore = scoreShow2(kept, starterArg, false);
          const isDealer = sId === dealerSeat;
          const title = seatName3(sId) + " hand" + (isDealer ? " (dealer)" : " (pone)");
          state3.lastShow[sId] = {
            title,
            cards: kept,
            starter: state3.starter,
            starters,
            score: sScore,
            signed: sScore.total,
            who: sId
          };
          state3.showQueue.push(sId);
        }
        const isShotgun = Boolean(settings3 && settings3.optShotgunCribbage);
        const cribScore = scoreShow2(state3.crib, starterArg, true, false, { dealerHand: getSeatKept2(dealerSeat) });
        const cribSigned = pegOnly || isShotgun ? 0 : settings3.optRockCrib ? -cribScore.total : cribScore.total;
        const isSolo = isSoloVsPairs2();
        const cribOwner = isSolo ? "p1" : dealerSeat;
        const baseCribTitle = isSolo ? "Crib (" + seatName3("p1") + ")" : "Crib (" + seatName3(dealerSeat) + ")";
        const cribTitle = isShotgun ? `${baseCribTitle} [Shotgun Cribbage]` : baseCribTitle;
        state3.lastShow.crib = {
          title: cribTitle,
          cards: state3.crib,
          starter: state3.starter,
          starters,
          score: cribScore,
          signed: cribSigned,
          who: cribOwner
        };
        state3.showQueue.push("crib");
        if (pegOnly) {
          openShowModal2(true);
          return;
        }
        beginShowAct2(0);
      }
    }
    /**
     * Evaluates the Chutes and Ladders option at the end of hand counting.
     * If all active players/tracks are tied (and score > 0), all players go back to the start (hole 0).
     * @param {Object} state
     * @param {Object} settings
     * @param {Object} [context]
     * @returns {boolean} True if Chutes and Ladders triggered
     */
    static checkChutesAndLadders(state3, settings3 = {}, context = {}) {
      if (!settings3 || !settings3.optChutesAndLadders) return false;
      if (!state3 || !state3.scores) return false;
      const getActiveTracks3 = context.getActiveTracks || (typeof window !== "undefined" ? window.getActiveTracks : () => ["p1", "p2"]);
      const tracks = typeof getActiveTracks3 === "function" ? getActiveTracks3() : ["p1", "p2"];
      if (!tracks || tracks.length < 2) return false;
      const getTrackScore = (track) => {
        if (track === "p1" && state3.scores.p1 === void 0 && state3.scores.you !== void 0) return state3.scores.you;
        if (track === "p2" && state3.scores.p2 === void 0 && state3.scores.cpu !== void 0) return state3.scores.cpu;
        return state3.scores[track] ?? 0;
      };
      const scores = tracks.map(getTrackScore);
      const firstScore = scores[0];
      const allTied = scores.every((s) => s === firstScore);
      if (allTied && firstScore > 0) {
        state3.chutesAndLaddersTriggered = true;
        state3.chutesAndLaddersTiedScore = firstScore;
        for (const t of tracks) {
          state3.scores[t] = 0;
          if (state3.prev) state3.prev[t] = 0;
        }
        if (state3.scores.you !== void 0) state3.scores.you = 0;
        if (state3.scores.cpu !== void 0) state3.scores.cpu = 0;
        if (state3.prev) {
          state3.prev.you = 0;
          state3.prev.cpu = 0;
        }
        if (context.pegTracker && typeof context.pegTracker.reset === "function") {
          context.pegTracker.reset();
        } else if (typeof window !== "undefined" && window.pegTracker && typeof window.pegTracker.reset === "function") {
          window.pegTracker.reset();
        }
        if (typeof window !== "undefined" && window.pegState) {
          for (const t of tracks) {
            if (window.pegState[t]) {
              window.pegState[t].front = 0;
              window.pegState[t].rear = 0;
            }
          }
          if (window.pegState.you) {
            window.pegState.you.front = 0;
            window.pegState.you.rear = 0;
          }
          if (window.pegState.cpu) {
            window.pegState.cpu.front = 0;
            window.pegState.cpu.rear = 0;
          }
        }
        if (context.pegState) {
          for (const t of tracks) {
            if (context.pegState[t]) {
              context.pegState[t].front = 0;
              context.pegState[t].rear = 0;
            }
          }
          if (context.pegState.you) {
            context.pegState.you.front = 0;
            context.pegState.you.rear = 0;
          }
          if (context.pegState.cpu) {
            context.pegState.cpu.front = 0;
            context.pegState.cpu.rear = 0;
          }
        }
        state3.over = false;
        state3.winner = null;
        const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : ((k) => k));
        const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
        });
        const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
        });
        const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : () => {
        });
        const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
        });
        const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
        const playerNames = tracks.map((t) => pName2(t)).join(" & ");
        log2(`\u{1F3A2} CHUTES AND LADDERS! All players (${playerNames}) are tied at ${firstScore} pts! Everyone slides back to the start (hole 0)!`);
        if (typeof fancyCall2 === "function") {
          fancyCall2(`Chutes & Ladders! Back to 0!`, "famous", 3e3);
        }
        if (sfx3 && typeof sfx3.chutesAndLadders === "function") {
          sfx3.chutesAndLadders();
        } else if (sfx3 && typeof sfx3.slide === "function") {
          sfx3.slide();
        } else if (sfx3 && typeof sfx3.jail === "function") {
          sfx3.jail();
        }
        if (typeof renderScores2 === "function") {
          renderScores2(true);
        }
        if (typeof netPush2 === "function") {
          netPush2({
            fancy: { text: `Chutes & Ladders! Back to 0!`, kind: "famous", ms: 3e3 },
            sfx: "chutesAndLadders"
          });
        }
        return true;
      }
      return false;
    }
    /**
     * Evaluates if match victory or defeat conditions are reached and displays results modal.
     * @param {Object} [context]
     * @returns {boolean}
     */
    static checkGameOver(context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const state3 = context.state || (typeof window !== "undefined" ? window.state : {});
      const getActiveTracks3 = context.getActiveTracks || (typeof window !== "undefined" ? window.getActiveTracks : () => ["p1", "p2"]);
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : ((k) => k));
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const recordGameResult2 = context.recordGameResult || (typeof window !== "undefined" ? window.recordGameResult : () => ({ wins: 0, losses: 0 }));
      const renderRecordBox2 = context.renderRecordBox || (typeof window !== "undefined" ? window.renderRecordBox : () => {
      });
      const skunkResult3 = context.skunkResult || (typeof window !== "undefined" ? window.skunkResult : () => null);
      const showModal2 = context.showModal || (typeof window !== "undefined" ? window.showModal : () => {
      });
      const t = settings3.target || 121;
      const tracks = getActiveTracks3();
      let over = false, winner = null;
      const isProgCut = Boolean(settings3 && settings3.optProgressiveCut && tracks.length === 2);
      if (isProgCut) {
        if (state3.phase === "show" && state3.showAct === "done") {
          const handsDone = state3.handsCompleted || 0;
          if (handsDone > 0 && handsDone % 2 === 0) {
            const s1 = state3.scores ? state3.scores[tracks[0]] || 0 : 0;
            const s2 = state3.scores ? state3.scores[tracks[1]] || 0 : 0;
            const maxScore = Math.max(s1, s2);
            if (maxScore > 121 || maxScore >= t) {
              if (s1 !== s2) {
                over = true;
                winner = settings3.goal === "low" ? s1 < s2 ? tracks[0] : tracks[1] : s1 > s2 ? tracks[0] : tracks[1];
              }
            }
          }
        }
      } else {
        if (settings3.optChutesAndLadders) {
          _GameEngine.checkChutesAndLadders(state3, settings3, context);
        }
        const res = _GameEngine.checkMatchOver(state3.scores, t, settings3.goal || "high", tracks);
        over = res.over;
        winner = res.winner;
      }
      if (over) {
        state3.over = true;
        state3.showModal = null;
        state3.showMeter = null;
        if (typeof document !== "undefined") {
          const sm = document.getElementById("showMeter");
          if (sm) sm.classList.add("hidden");
          const muggins = document.getElementById("mugginsPromptWrap");
          if (muggins) muggins.classList.add("hidden");
        }
        if (sfx3 && typeof sfx3.gameHole === "function") sfx3.gameHole();
        const scoreSummary = tracks.map((k) => `${pName2(k)}: ${state3.scores[k] || 0}`).join(" \xB7 ");
        const skunkLine = skunkResult3(winner, state3.scores ? state3.scores["you"] : 0, state3.scores ? state3.scores["cpu"] : 0);
        let skunkHtml = "";
        if (skunkLine) {
          skunkHtml = `<p class="skunk-banner ${skunkLine.kind}">${skunkLine.line}</p>`;
        }
        if (!state3.replayRecorded) {
          state3.replayRecorded = true;
          try {
            const repScores = {
              p1: state3.scores ? state3.scores["you"] ?? state3.scores["p1"] ?? 0 : 0,
              p2: state3.scores ? state3.scores["cpu"] ?? state3.scores["p2"] ?? 0 : 0
            };
            GameReplayManager.finishRecording(winner, repScores, skunkLine ? skunkLine.kind : null);
          } catch (err) {
            console.warn("[GameEngine] Error in finishRecording:", err);
          }
        }
        let recLine = "";
        if (!state3.recorded) {
          state3.recorded = true;
          const rec = recordGameResult2(winner === "p1" || winner === "team1" ? "you" : "cpu");
          if (rec && typeof rec.wins === "number" && typeof rec.losses === "number") {
            recLine = `<p>Record for this setup \u2014 ${rec.wins}\u2013${rec.losses}</p>`;
          }
          renderRecordBox2();
        }
        const winnerName = pName2(winner);
        const mySeatId = typeof mySeat === "function" ? mySeat() : "p1";
        const isWinnerMe = winner === mySeatId || winner === "p1" && mySeatId === "p1" || winner === "p2" && mySeatId === "p2";
        const title = isWinnerMe ? `Victory! ${winnerName} wins!` : `${winnerName} wins!`;
        if (isWinnerMe) {
          AchievementManager.incrementStat("totalWins", 1, { sfx: sfx3 });
          AchievementManager.unlock("first_blood", { sfx: sfx3 });
          if (skunkLine) {
            AchievementManager.incrementStat("totalSkunks", 1, { sfx: sfx3 });
            AchievementManager.unlock("skunk_master", { sfx: sfx3 });
            if (skunkLine.kind === "double") {
              AchievementManager.incrementStat("totalDoubleSkunks", 1, { sfx: sfx3 });
              AchievementManager.unlock("double_skunk", { sfx: sfx3 });
            }
          }
          const curBrand = settings3.brand || context.brand || (typeof window !== "undefined" ? window.getAppBrand ? window.getAppBrand() : window.currentBrand || "crazy" : "crazy");
          if (t === 481 || curBrand === "clash") {
            AchievementManager.incrementStat("clashWins", 1, { sfx: sfx3 });
            AchievementManager.unlock("clash_conqueror", { sfx: sfx3 });
          }
          const isPints = curBrand === "pints" || settings3.optYouDrink;
          if (isPints) {
            AchievementManager.incrementStat("pintsWins", 1, { sfx: sfx3 });
            if (!state3.drinks || !state3.drinks[mySeatId]) {
              AchievementManager.unlock("pub_legend", { sfx: sfx3 });
            }
          }
          const isAdult = curBrand === "adult" || settings3.optAdult;
          if (isAdult) {
            AchievementManager.incrementStat("adultWins", 1, { sfx: sfx3 });
            AchievementManager.unlock("adult_first_strip", { sfx: sfx3 });
          }
          CelebrationFX.launchConfetti({ count: 110, duration: 3800, sfx: sfx3 });
          CelebrationFX.pulseScreen(skunkLine ? "skunk" : "gold", 1800);
        }
        HandScoreTracker.recordFinalPartialHand(state3, settings3, winner, { pName: pName2 });
        const seriesResult = SeriesTracker.recordGame({
          winner,
          winnerName,
          p1Score: state3.scores ? state3.scores["you"] || state3.scores["p1"] || 0 : 0,
          p2Score: state3.scores ? state3.scores["cpu"] || state3.scores["p2"] || 0 : 0,
          skunkKind: skunkLine ? skunkLine.kind : null,
          openingDealer: state3.dealer
        });
        const seriesCardHtml = SeriesTracker.buildModalSummary({
          p1Name: pName2("you"),
          p2Name: pName2("cpu")
        });
        const isTournament = Boolean(
          settings3 && settings3.isTournamentMatch || context && (context.isTournament || context.isTournamentMatch) || typeof window !== "undefined" && window.settings && window.settings.isTournamentMatch
        );
        let tourneyCardHtml = "";
        if (isTournament) {
          const tourneyMatch = TournamentManager.getActiveMatch();
          if (tourneyMatch && tourneyMatch.status !== "completed") {
            const tourneyResult = TournamentManager.recordGame({
              winner,
              winnerName,
              p1Score: state3.scores ? state3.scores["you"] || state3.scores["p1"] || 0 : 0,
              p2Score: state3.scores ? state3.scores["cpu"] || state3.scores["p2"] || 0 : 0,
              skunkKind: skunkLine ? skunkLine.kind : null
            });
            if (tourneyResult) {
              const match = tourneyResult.match;
              const p1 = TournamentManager.getPlayer(tourneyResult.state, match.player1Id);
              const p2 = TournamentManager.getPlayer(tourneyResult.state, match.player2Id);
              const p1Wins = match.wins && match.player1Id && match.wins[match.player1Id] || 0;
              const p2Wins = match.wins && match.player2Id && match.wins[match.player2Id] || 0;
              const isChamp = tourneyResult.isTournamentComplete;
              if (isChamp) {
                const champPlayer = tourneyResult.champion;
                const isHumanChamp = champPlayer && (champPlayer.type === "human" || champPlayer.id === "p1");
                if (isHumanChamp) {
                  AchievementManager.recordTournamentWin(tourneyResult.state, { sfx: sfx3 });
                }
                CelebrationFX.launchConfetti({ count: 180, duration: 5e3, sfx: sfx3 });
                CelebrationFX.pulseScreen("gold", 2500);
              }
              tourneyCardHtml = `
              <div class="tournament-match-result-card" style="margin: 14px 0; padding: 12px 16px; background: rgba(240,198,74,0.12); border: 2px solid #f0c64a; border-radius: 10px; text-align: center;">
                <div style="font-size: 0.8rem; font-weight: 800; color: #f0c64a; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 6px;">
                  \u{1F3C6} ${tourneyResult.state.title} \xB7 ${match.roundLabel}
                </div>
                <div style="display: flex; justify-content: center; align-items: center; gap: 16px; margin: 6px 0;">
                  <div style="text-align: right; flex: 1;">
                    <div style="font-size: 0.95rem; font-weight: 700; color: ${p1Wins > p2Wins ? "#f0c64a" : "#f4ead4"};">${p1 ? p1.avatar : ""} ${p1 ? p1.name : "P1"}</div>
                    <div style="font-size: 1.5rem; font-weight: 900; color: #f0c64a;">${p1Wins}</div>
                  </div>
                  <div style="font-size: 1.2rem; font-weight: 800; color: rgba(244,234,212,0.4);">-</div>
                  <div style="text-align: left; flex: 1;">
                    <div style="font-size: 0.95rem; font-weight: 700; color: ${p2Wins > p1Wins ? "#f0c64a" : "#f4ead4"};">${p2 ? p2.avatar : ""} ${p2 ? p2.name : "P2"}</div>
                    <div style="font-size: 1.5rem; font-weight: 900; color: #f0c64a;">${p2Wins}</div>
                  </div>
                </div>
                ${isChamp ? `
                  <div style="margin-top: 8px; font-size: 1rem; font-weight: 900; color: #34d399; background: rgba(52,211,153,0.2); padding: 8px 12px; border-radius: 6px; border: 1px solid rgba(52,211,153,0.4);">
                    \u{1F451} ${tourneyResult.champion ? tourneyResult.champion.name : "Champion"} IS CROWNED THE TABLE CHAMPION!
                  </div>
                ` : tourneyResult.matchFinished ? `
                  <div style="margin-top: 6px; font-size: 0.92rem; font-weight: 800; color: #34d399;">
                    \u2714 ${tourneyResult.winner ? tourneyResult.winner.name : "Winner"} wins the match and advances!
                  </div>
                ` : `
                  <div style="margin-top: 6px; font-size: 0.82rem; color: #d6d3d1;">
                    First to ${match.targetWins} wins advances in bracket
                  </div>
                `}
              </div>
            `;
            }
          }
        }
        const nextGameNum = (seriesResult.state.gamesPlayed || 0) + 1;
        const rematchBtnText = seriesResult.isComplete ? "\u{1F3C6} New Series" : `\u{1F501} Rematch (Game ${nextGameNum})`;
        const avMgr = typeof window !== "undefined" && window.AvatarManager || AvatarManager;
        const winnerAvatarBadge = isWinnerMe && avMgr && typeof avMgr.renderAvatarBadge === "function" ? `<div style="display:flex;justify-content:center;margin-bottom:12px;">${avMgr.renderAvatarBadge(avMgr.getSelectedAvatarId(), { size: 68, showRing: true, ringColor: "#facc15" })}</div>` : "";
        const gameOverHtml = `${winnerAvatarBadge}<h2>${title}</h2>
         <p>Final score \u2014 ${scoreSummary}</p>
         <p>${settings3.goal === "low" ? "Low ball: first to the target loses." : "First to the target wins."}</p>
         ${skunkHtml}
         ${tourneyCardHtml || seriesCardHtml}
         ${recLine}
         <div class="game-over-hub">
            <div class="game-over-tools-card">
              <div class="game-over-tools-header">
                <span class="game-over-tools-title">MATCH ANALYSIS & REPLAY</span>
              </div>
              <div class="game-over-tools-grid">
                <button type="button" class="go-btn go-btn-summary" id="btnGameSummary">\u{1F4CA} Game Summary</button>
                <button type="button" class="go-btn go-btn-coach" id="btnCoachPostMortem">\u{1F393} Coach's Post-Mortem</button>
                <button type="button" class="go-btn go-btn-replay" id="btnWatchReplay">\u{1F3AC} Watch Replay</button>
              </div>
            </div>

            <div class="game-over-next-bar">
              ${isTournament ? `
                <button type="button" class="btn-gold go-btn go-btn-hero go-btn-tournament" id="btnTourneyBracket">\u{1F3C6} Tournament Bracket</button>
              ` : `
                <button type="button" class="btn-gold go-btn go-btn-hero go-btn-rematch" id="btnRematchGame">${rematchBtnText}</button>
                <button type="button" class="btn-ghost go-btn go-btn-menu" id="btnGameOverNewGame">New game</button>
              `}
            </div>
          </div>`;
        _GameEngine.lastGameOverHtml = gameOverHtml;
        if (typeof window !== "undefined") {
          window._lastGameOverHtml = gameOverHtml;
          window.showGameWonModal = () => _GameEngine.showGameWonModal();
        }
        showModal2(gameOverHtml);
        if (typeof document !== "undefined") {
          const modalEl = document.getElementById("modal");
          _GameEngine.bindGameOverEvents(modalEl || document);
        }
      }
      return over;
    }
    /**
     * Re-opens the Game Won / Game Over modal if a finished match exists.
     * @returns {boolean} Whether the modal was displayed
     */
    static showGameWonModal() {
      const html2 = _GameEngine.lastGameOverHtml || (typeof window !== "undefined" ? window._lastGameOverHtml : null);
      if (!html2) return false;
      const showModalFn = typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showModal === "function" ? window.modalManager.showModal.bind(window.modalManager) : typeof window !== "undefined" && typeof window.showModal === "function" ? window.showModal : null;
      if (showModalFn) {
        showModalFn(html2, false);
        if (typeof document !== "undefined") {
          const modalEl = document.getElementById("modal");
          _GameEngine.bindGameOverEvents(modalEl || document);
        }
        return true;
      }
      return false;
    }
    /**
     * Binds click events for game over modal action buttons.
     * @param {Element|Document} [root=document]
     */
    static bindGameOverEvents(root = typeof document !== "undefined" ? document : null) {
      if (!root || typeof root.querySelector !== "function") return;
      const summaryBtn = root.querySelector("#btnGameSummary");
      if (summaryBtn && !summaryBtn._boundGameOver) {
        summaryBtn._boundGameOver = true;
        summaryBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.showGameSummaryModal === "function") {
            window.showGameSummaryModal();
          }
        });
      }
      const coachBtn = root.querySelector("#btnCoachPostMortem");
      if (coachBtn && !coachBtn._boundGameOver) {
        coachBtn._boundGameOver = true;
        coachBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.showCoachPostMortemModal === "function") {
            window.showCoachPostMortemModal();
          } else if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showCoachPostMortemModal === "function") {
            window.modalManager.showCoachPostMortemModal();
          }
        });
      }
      const replayBtn = root.querySelector("#btnWatchReplay");
      if (replayBtn && !replayBtn._boundGameOver) {
        replayBtn._boundGameOver = true;
        replayBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.playCurrentGameReplay === "function") {
            window.playCurrentGameReplay();
          } else if (typeof window !== "undefined" && window.CrazyCribbage?.GameReplayManager?.playCurrentGameReplay) {
            window.CrazyCribbage.GameReplayManager.playCurrentGameReplay();
          } else if (typeof window !== "undefined" && window.ReplayModal && typeof window.ReplayModal.open === "function") {
            window.ReplayModal.open();
          }
        });
      }
      const tourneyBtn = root.querySelector("#btnTourneyBracket");
      if (tourneyBtn && !tourneyBtn._boundGameOver) {
        tourneyBtn._boundGameOver = true;
        tourneyBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && window.TournamentModal && typeof window.TournamentModal.open === "function") {
            window.TournamentModal.open();
          }
        });
      }
      const rematchBtn = root.querySelector("#btnRematchGame");
      if (rematchBtn && !rematchBtn._boundGameOver) {
        rematchBtn._boundGameOver = true;
        rematchBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.playAgain === "function") {
            window.playAgain();
          }
        });
      }
      const newGameBtn = root.querySelector("#btnGameOverNewGame");
      if (newGameBtn && !newGameBtn._boundGameOver) {
        newGameBtn._boundGameOver = true;
        newGameBtn.addEventListener("click", () => {
          if (typeof window !== "undefined" && typeof window.backToMenu === "function") {
            window.backToMenu();
          }
        });
      }
    }
    /**
     * Adds score delta, processes hazard triggers, toasts, notifications, and advances pegs.
     * @param {string} who
     * @param {number} n
     * @param {string} why
     * @param {boolean} [isPartnerBonus]
     * @param {boolean} [isSignAction]
     * @param {Object} [context]
     */
    static addScore(who, n, why, isPartnerBonus = false, isSignAction = false, context = {}) {
      if (!n) return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : {});
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const scoreKey2 = context.scoreKey || (typeof window !== "undefined" ? window.scoreKey : ((w) => w));
      const getActiveTracks3 = context.getActiveTracks || (typeof window !== "undefined" ? window.getActiveTracks : () => ["p1", "p2"]);
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : ((w) => w));
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const showScoreToast2 = context.showScoreToast || (typeof window !== "undefined" ? window.showScoreToast : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : () => {
      });
      const setShowMeter2 = context.setShowMeter || (typeof window !== "undefined" ? window.setShowMeter : () => {
      });
      const fancyPegPhrase2 = context.fancyPegPhrase || (typeof window !== "undefined" ? window.fancyPegPhrase : ((w, p) => `${w} +${p}`));
      const isBonusMessage2 = context.isBonusMessage || (typeof window !== "undefined" ? window.isBonusMessage : () => false);
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const showStreetBanner2 = context.showStreetBanner || (typeof window !== "undefined" ? window.showStreetBanner : () => {
      });
      const checkGameOver2 = context.checkGameOver || (typeof window !== "undefined" ? window.checkGameOver : _GameEngine.checkGameOver);
      const handleSignsLanding2 = context.handleSignsLanding || (typeof window !== "undefined" ? window.handleSignsLanding : null);
      const getActivePintsOptionAtHole = context.getActivePintsOptionAtHole || (typeof window !== "undefined" ? window.getActivePintsOptionAtHole : null);
      const showPintsBonusModal2 = context.showPintsBonusModal || (typeof window !== "undefined" ? window.showPintsBonusModal : null);
      const getActiveAdultOptionAtHole = context.getActiveAdultOptionAtHole || (typeof window !== "undefined" ? window.getActiveAdultOptionAtHole : null);
      const showAdultStripModal2 = context.showAdultStripModal || (typeof window !== "undefined" ? window.showAdultStripModal : null);
      const showAdultTimerModal2 = context.showAdultTimerModal || (typeof window !== "undefined" ? window.showAdultTimerModal : null);
      const pegTracker = context.pegTracker || (typeof window !== "undefined" ? window.pegTracker : null);
      const isShiftingPartnership2 = context.isShiftingPartnership || (typeof window !== "undefined" ? window.isShiftingPartnership : () => false);
      const getShiftingPartner2 = context.getShiftingPartner || (typeof window !== "undefined" ? window.getShiftingPartner : () => null);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : ((w) => w));
      const res = _GameEngine.applyScoreDelta(who, n, why, {
        state: state3,
        settings: settings3,
        scoreKey: scoreKey2,
        activeTracks: getActiveTracks3(),
        isSignAction,
        isPartnerBonus
      });
      if (res.noop) return;
      const key = res.key;
      const playerName = pName2(who);
      if (res.stinkHoleBlocked) {
        log2(`${playerName} stink hole \u2014 need exactly 1, ${n} not scored`);
        return;
      }
      if (res.hazard === "jail") {
        const { used, left, freed, trapHole } = res.penaltyUsed;
        log2(`\u{1F512} JAILED: ${playerName} missed a pegging turn (${why || "points"} for ${n} pts forfeited)! Turn ${used} of 3 used (${left} remaining).`);
        if (state3.phase === "play") {
          showScoreToast2(who, 0, `Jailed! Forfeited +${n} (${used} of 3 turns used)`);
          fancyCall2(`MISSED TURN (${used} OF 3 USED)`, "jail", 2200);
        } else {
          fancyCall2(`HAND FORFEITED (${used} OF 3 USED)`, "jail", 2200);
        }
        if (freed) {
          log2(`\u{1F513} FREEDOM: ${playerName} served 3 of 3 missed turns and returns to the pegging track at hole ${trapHole}!`);
          fancyCall2("RELEASED FROM JAIL!", "jail-free", 2200);
        }
        renderScores2(true);
        return;
      }
      if (res.hazard === "bar") {
        const { used, left, freed, trapHole } = res.penaltyUsed;
        log2(`\u{1F37B} AT THE BAR: ${playerName} missed a pegging turn (${why || "points"} for ${n} pts forfeited)! You lost a turn, take a drink \u2014 Turn ${used} of 3 used (${left} remaining).`);
        showScoreToast2(who, 0, `Lost a turn, take a drink (${used} of 3 turns used)`);
        fancyCall2(`TAKE A DRINK (${used} OF 3 USED)`, "bar", 2400);
        if (freed) {
          log2(`\u{1F37A} TAB CLOSED: ${playerName} served 3 of 3 missed turns and leaves The Bar, returning to the pegging track at hole ${trapHole}!`);
          fancyCall2("LEAVING THE BAR!", "bar-free", 2200);
        }
        renderScores2(true);
        return;
      }
      if (res.hazard === "timeout") {
        const { used, left, freed, trapHole } = res.penaltyUsed;
        log2(`\u23F3 TIMEOUT: ${playerName} missed a pegging turn (${why || "points"} for ${n} pts forfeited)! You've been bad, you lose a turn \u2014 Turn ${used} of 3 used (${left} remaining).`);
        showScoreToast2(who, 0, `Lost a turn in timeout (${used} of 3 turns used)`);
        fancyCall2(`IN TIMEOUT (${used} OF 3 USED)`, "timeout", 2400);
        if (freed) {
          log2(`\u2728 TIMEOUT OVER: ${playerName} served 3 of 3 missed turns and leaves timeout, returning to the pegging track at hole ${trapHole}!`);
          fancyCall2("OUT OF TIMEOUT!", "timeout-free", 2200);
        }
        renderScores2(true);
        return;
      }
      if (res.hazard === "detour") {
        const { progress, cleared, targetHole } = res.detourProgress;
        if (!cleared) {
          log2(`\u{1F6A7} DETOUR: ${playerName} advanced to Detour Hole ${progress}/7 (+${n} ${why || "pts"}).`);
          showScoreToast2(who, n, `Detour Hole ${progress}/7`);
          renderScores2(true);
          return;
        } else {
          log2(`\u2728 DETOUR CLEARED: ${playerName} completed the 7-hole detour loop and returned to the track at Hole ${targetHole} (+${n} ${why || "pts"})!`);
          fancyCall2("DETOUR CLEARED!", "detour-free", 2200);
          showScoreToast2(who, n, `Cleared Detour \u2794 Hole ${targetHole}`);
          renderScores2(true);
          return;
        }
      }
      if (res.hazard === "roundabout") {
        const { progress, cleared, targetHole } = res.roundAboutProgress;
        if (!cleared) {
          log2(`\u{1F504} ROUND ABOUT: ${playerName} advanced to Round About Hole ${progress}/7 (+${n} ${why || "pts"}).`);
          showScoreToast2(who, n, `Round About Hole ${progress}/7`);
          renderScores2(true);
          return;
        } else {
          log2(`\u2728 ROUND ABOUT CLEARED: ${playerName} completed the 7-hole rotary loop and returned to the track at Hole ${targetHole} (+${n} ${why || "pts"})!`);
          fancyCall2("ROUND ABOUT CLEARED!", "roundabout-free", 2200);
          showScoreToast2(who, n, `Cleared Round About \u2794 Hole ${targetHole}`);
          renderScores2(true);
          return;
        }
      }
      const ptsToAdd = res.scored;
      if (res.laneBlocked && res.laneBlocker) {
        const blockerName = pName2(res.laneBlocker);
        log2(`${playerName} cannot pass ${blockerName} in No Passing Lane (scored ${ptsToAdd} of ${n}, stopped at hole ${state3.scores[key]})`);
        if (state3.phase === "play") {
          showScoreToast2(who, ptsToAdd, `No Passing Lane (held behind ${blockerName})`);
        }
        const trapOpt = typeof settings3 !== "undefined" && settings3 && (settings3.stopSignAnimation !== void 0 ? settings3.stopSignAnimation : settings3.stopAnimation !== void 0 ? settings3.stopAnimation : settings3.speedTrapAnimation) || typeof window !== "undefined" && window.settings && (window.settings.stopSignAnimation !== void 0 ? window.settings.stopSignAnimation : window.settings.stopAnimation !== void 0 ? window.settings.stopAnimation : window.settings.speedTrapAnimation) || "yes";
        const isTrapAnimEnabled = trapOpt !== "no" && trapOpt !== "off" && trapOpt !== false;
        const showTrap = isTrapAnimEnabled ? context.showSpeedTrapAnimation || typeof window !== "undefined" && window.showSpeedTrapAnimation || typeof window !== "undefined" && window.SpeedTrapAnimationOverlay && window.SpeedTrapAnimationOverlay.show : null;
        if (typeof showTrap === "function") {
          let playerCard = null;
          if (state3.lastPlayedCard) playerCard = state3.lastPlayedCard;
          else if (state3.hands && state3.hands[who] && state3.hands[who].length) playerCard = state3.hands[who][0];
          try {
            showTrap({
              playerName,
              who,
              reason: "no_passing_lane",
              hole: state3.scores[key],
              ptsScored: ptsToAdd,
              ptsLost: Math.max(0, n - ptsToAdd),
              blockerName,
              card: playerCard,
              settings: settings3
            });
          } catch (err) {
            console.error("Failed to display Speed Trap animation:", err);
          }
        }
      }
      if (res.stopSignHit) {
        log2(`\u{1F6D1} STOP SIGN: ${playerName} reached Stop Sign at hole ${res.stopSignHit.hole}! Counting stopped immediately (${ptsToAdd} of ${n} pts scored${res.stopSignHit.ptsLost > 0 ? `, ${res.stopSignHit.ptsLost} pts lost` : ""}).`);
        fancyCall2(`STOP SIGN (HOLE ${res.stopSignHit.hole})!`, "stop", 2400);
        showScoreToast2(who, ptsToAdd, `Stop Sign at Hole ${res.stopSignHit.hole}! Counting stopped`);
        if (state3.showMeter) {
          state3.showMeter.total = ptsToAdd;
          state3.showMeter.line = `Stopped at Hole ${res.stopSignHit.hole} (${ptsToAdd} pts)`;
          setShowMeter2(state3.showMeter.act, ptsToAdd, state3.showMeter.line);
        }
        const trapOpt = typeof settings3 !== "undefined" && settings3 && (settings3.stopSignAnimation !== void 0 ? settings3.stopSignAnimation : settings3.stopAnimation !== void 0 ? settings3.stopAnimation : settings3.speedTrapAnimation) || typeof window !== "undefined" && window.settings && (window.settings.stopSignAnimation !== void 0 ? window.settings.stopSignAnimation : window.settings.stopAnimation !== void 0 ? window.settings.stopAnimation : window.settings.speedTrapAnimation) || "yes";
        const isTrapAnimEnabled = trapOpt !== "no" && trapOpt !== "off" && trapOpt !== false;
        const showTrap = isTrapAnimEnabled ? context.showSpeedTrapAnimation || typeof window !== "undefined" && window.showSpeedTrapAnimation || typeof window !== "undefined" && window.SpeedTrapAnimationOverlay && window.SpeedTrapAnimationOverlay.show : null;
        if (typeof showTrap === "function") {
          let playerCard = null;
          if (state3.lastPlayedCard) playerCard = state3.lastPlayedCard;
          else if (state3.hands && state3.hands[who] && state3.hands[who].length) playerCard = state3.hands[who][0];
          try {
            showTrap({
              playerName,
              who,
              reason: "stop_sign",
              hole: res.stopSignHit.hole,
              ptsScored: ptsToAdd,
              ptsLost: res.stopSignHit.ptsLost || 0,
              card: playerCard,
              settings: settings3
            });
          } catch (err) {
            console.error("Failed to display Speed Trap animation:", err);
          }
        }
      }
      if (res.jumpTriggered) {
        const { from, to, diff, isForward } = res.jumpTriggered;
        const diffStr = diff > 0 ? `+${diff}` : `${diff}`;
        const jumpMessage = isForward ? `Jumping forward from ${from} to ${to}` : `Jumping backward from ${from} to ${to}`;
        log2(`\u26A1 ${playerName}: ${jumpMessage} (${diffStr})!`);
        showScoreToast2(who, diffStr, jumpMessage);
        fancyCall2(jumpMessage, "combo jump", 2400);
        const cannonOpt = typeof settings3 !== "undefined" && settings3 && (settings3.jumpAnimation !== void 0 ? settings3.jumpAnimation : settings3.cannonAnimation) || typeof window !== "undefined" && window.settings && (window.settings.jumpAnimation !== void 0 ? window.settings.jumpAnimation : window.settings.cannonAnimation) || "yes";
        const isCannonAnimEnabled = cannonOpt !== "no" && cannonOpt !== "off" && cannonOpt !== false;
        const showCannon = isCannonAnimEnabled ? context.showCannonAnimation || typeof window !== "undefined" && window.showCannonAnimation || typeof window !== "undefined" && window.CannonAnimationOverlay && window.CannonAnimationOverlay.show : null;
        if (typeof showCannon === "function") {
          let playerCard = null;
          if (state3.lastPlayedCard) playerCard = state3.lastPlayedCard;
          else if (state3.hands && state3.hands[who] && state3.hands[who].length) playerCard = state3.hands[who][0];
          try {
            showCannon({
              playerName,
              who,
              fromHole: from,
              toHole: to,
              diff,
              isForward,
              card: playerCard,
              settings: settings3
            });
          } catch (err) {
            console.error("Failed to display ACME Human Cannonball animation:", err);
          }
        }
      }
      if (res.newTrapLanded === "jail") {
        log2(`\u{1F6A8} JAIL TRAP! ${playerName} landed on hole ${state3.scores[key]} and was thrown into the Jail Cell! Must serve 3 missed pegging turns.`);
        if (state3.phase === "play") fancyCall2("GO TO JAIL! (3 TURNS)", "jail", 2400);
        const jailOpt = typeof settings3 !== "undefined" && settings3 && settings3.jailAnimation || typeof window !== "undefined" && window.settings && window.settings.jailAnimation || "yes";
        const isJailAnimEnabled = jailOpt !== "no" && jailOpt !== "off" && jailOpt !== false;
        const showJail = isJailAnimEnabled ? context.showJailAnimation || typeof window !== "undefined" && window.showJailAnimation || typeof window !== "undefined" && window.JailAnimationOverlay && window.JailAnimationOverlay.show : null;
        if (typeof showJail === "function") {
          let playerCard = null;
          if (state3.lastPlayedCard) playerCard = state3.lastPlayedCard;
          else if (state3.hands && state3.hands[who] && state3.hands[who].length) playerCard = state3.hands[who][0];
          try {
            showJail({
              playerName,
              who,
              jailHole: state3.scores[key],
              score: state3.scores[key],
              card: playerCard,
              settings: settings3
            });
          } catch (err) {
            console.error("Failed to display Jailhouse Mugshot animation:", err);
          }
        }
      } else if (res.newTrapLanded === "bar") {
        log2(`\u{1F37B} THE BAR TRAP! ${playerName} landed on hole ${state3.scores[key]} and stopped in at The Bar! Must serve 3 missed pegging turns.`);
        if (state3.phase === "play") fancyCall2("HEADED TO THE BAR! (3 TURNS)", "bar", 2400);
        const barOpt = typeof settings3 !== "undefined" && settings3 && settings3.barAnimation || typeof window !== "undefined" && window.settings && window.settings.barAnimation || "yes";
        const isBarAnimEnabled = barOpt !== "no" && barOpt !== "off" && barOpt !== false;
        const showBar = isBarAnimEnabled ? context.showBarAnimation || typeof window !== "undefined" && window.showBarAnimation || typeof window !== "undefined" && window.BarAnimationOverlay && window.BarAnimationOverlay.show : null;
        if (typeof showBar === "function") {
          let playerCard = null;
          if (state3.lastPlayedCard) playerCard = state3.lastPlayedCard;
          else if (state3.hands && state3.hands[who] && state3.hands[who].length) playerCard = state3.hands[who][0];
          try {
            showBar({
              playerName,
              who,
              barHole: state3.scores[key],
              score: state3.scores[key],
              card: playerCard,
              settings: settings3
            });
          } catch (err) {
            console.error("Failed to display Saloon Bar Slide animation:", err);
          }
        }
      } else if (res.newTrapLanded === "timeout") {
        log2(`\u23F3 TIMEOUT TRAP! ${playerName} landed on hole ${state3.scores[key]} and was sent to the Timeout Corner! Must serve 3 missed pegging turns.`);
        if (state3.phase === "play") fancyCall2("SENT TO TIMEOUT! (3 TURNS)", "timeout", 2400);
      } else if (res.newTrapLanded === "detour") {
        log2(`\u{1F6A7} DETOUR: ${playerName} landed on hole ${state3.scores[key]} \u2014 Take the scenic route on this Detour!`);
        showScoreToast2(who, 0, "Take the scenic route on this Detour");
        fancyCall2("Take the scenic route on this Detour", "detour", 2600);
        const detourOpt = typeof settings3 !== "undefined" && settings3 && (settings3.detourAnimation !== void 0 ? settings3.detourAnimation : settings3.scenicRouteAnimation) || typeof window !== "undefined" && window.settings && (window.settings.detourAnimation !== void 0 ? window.settings.detourAnimation : window.settings.scenicRouteAnimation) || "yes";
        const isScenicEnabled = detourOpt !== "no" && detourOpt !== "off" && detourOpt !== false;
        const showScenic = isScenicEnabled ? context.showScenicRouteAnimation || typeof window !== "undefined" && window.showScenicRouteAnimation || typeof window !== "undefined" && window.ScenicRouteAnimationOverlay && window.ScenicRouteAnimationOverlay.show : null;
        if (typeof showScenic === "function") {
          let playerCard = null;
          if (state3.lastPlayedCard) playerCard = state3.lastPlayedCard;
          else if (state3.hands && state3.hands[who] && state3.hands[who].length) playerCard = state3.hands[who][0];
          try {
            showScenic({
              type: "detour",
              playerName,
              who,
              hole: state3.scores[key],
              card: playerCard,
              settings: settings3
            });
          } catch (err) {
            console.error("Failed to display Detour animation:", err);
          }
        }
      } else if (res.newTrapLanded === "roundabout") {
        log2(`\u{1F504} ROUND ABOUT: ${playerName} landed on hole ${state3.scores[key]} \u2014 Have some fun on the Round About!`);
        showScoreToast2(who, 0, "Have some fun on the Round About!");
        fancyCall2("Have some fun on the Round About!", "roundabout", 2600);
        const rotaryOpt = typeof settings3 !== "undefined" && settings3 && (settings3.roundAboutAnimation !== void 0 ? settings3.roundAboutAnimation : settings3.scenicRouteAnimation) || typeof window !== "undefined" && window.settings && (window.settings.roundAboutAnimation !== void 0 ? window.settings.roundAboutAnimation : window.settings.scenicRouteAnimation) || "yes";
        const isScenicEnabled = rotaryOpt !== "no" && rotaryOpt !== "off" && rotaryOpt !== false;
        const showScenic = isScenicEnabled ? context.showScenicRouteAnimation || typeof window !== "undefined" && window.showScenicRouteAnimation || typeof window !== "undefined" && window.ScenicRouteAnimationOverlay && window.ScenicRouteAnimationOverlay.show : null;
        if (typeof showScenic === "function") {
          let playerCard = null;
          if (state3.lastPlayedCard) playerCard = state3.lastPlayedCard;
          else if (state3.hands && state3.hands[who] && state3.hands[who].length) playerCard = state3.hands[who][0];
          try {
            showScenic({
              type: "roundabout",
              playerName,
              who,
              hole: state3.scores[key],
              card: playerCard,
              settings: settings3
            });
          } catch (err) {
            console.error("Failed to display Round About animation:", err);
          }
        }
      }
      if (res.signBlockLanded && typeof handleSignsLanding2 === "function") {
        handleSignsLanding2(res.signBlockLanded, who);
      }
      if (res.diceLanded) {
        log2(`\u{1F3B2} DICE: ${playerName} landed on hole ${state3.scores[key]} \u2014 Roll The Dice!`);
        showScoreToast2(who, 0, "Roll The Dice!");
        fancyCall2("ROLL THE DICE! \u{1F3B2}", "dice-roll", 2400);
        const openDice = context.openDiceRollModal || (typeof window !== "undefined" ? window.openDiceRollModal : typeof CC !== "undefined" && CC?.ClashMiniGames?.openDiceRollModal ? CC.ClashMiniGames.openDiceRollModal : null);
        if (typeof openDice === "function") {
          openDice(who, context);
        }
      }
      if (res.wheelLanded) {
        log2(`\u{1F3A1} SPINNING WHEEL: ${playerName} landed on hole ${state3.scores[key]} \u2014 Spin The Wheel!`);
        showScoreToast2(who, 0, "Spin The Wheel!");
        fancyCall2("SPIN THE WHEEL! \u{1F3A1}", "wheel-spin", 2600);
        const openWheel = context.openWheelSpinModal || (typeof window !== "undefined" ? window.openWheelSpinModal : typeof CC !== "undefined" && CC?.ClashMiniGames?.openWheelSpinModal ? CC.ClashMiniGames.openWheelSpinModal : null);
        if (typeof openWheel === "function") {
          openWheel(who, context);
        }
      }
      if (typeof getActivePintsOptionAtHole === "function") {
        const pintsHit = getActivePintsOptionAtHole(state3.scores[key]);
        if (pintsHit) {
          const opt = pintsHit.item;
          const holeNum = state3.scores[key];
          const desc = opt.description || opt.actionText || opt.name;
          log2(`${opt.icon || "\u{1F37A}"} ${opt.name.toUpperCase()}! ${playerName} landed on hole ${holeNum} \u2014 ${desc}!`);
          showScoreToast2(who, 0, `${opt.name}! ${desc}`);
          fancyCall2(`${opt.name.toUpperCase()}! ${opt.icon || "\u{1F37A}"}`, "pints-drink", 2400);
          if (typeof showPintsBonusModal2 === "function") showPintsBonusModal2(opt, playerName, holeNum);
          const barOpt = typeof settings3 !== "undefined" && settings3 && settings3.barAnimation || typeof window !== "undefined" && window.settings && window.settings.barAnimation || "yes";
          const isBarAnimEnabled = barOpt !== "no" && barOpt !== "off" && barOpt !== false;
          const showBar = isBarAnimEnabled ? context.showBarAnimation || typeof window !== "undefined" && window.showBarAnimation || typeof window !== "undefined" && window.BarAnimationOverlay && window.BarAnimationOverlay.show : null;
          if (typeof showBar === "function") {
            let playerCard = null;
            if (state3.lastPlayedCard) playerCard = state3.lastPlayedCard;
            else if (state3.hands && state3.hands[who] && state3.hands[who].length) playerCard = state3.hands[who][0];
            try {
              showBar({
                playerName,
                who,
                drinkName: opt.name,
                score: state3.scores[key],
                card: playerCard,
                isDrinkSpace: true,
                settings: settings3
              });
            } catch (err) {
              console.error("Failed to display Saloon Bar Slide animation for Drink space:", err);
            }
          }
        }
      }
      if (typeof getActiveAdultOptionAtHole === "function") {
        const adultHit = getActiveAdultOptionAtHole(state3.scores[key]);
        if (adultHit) {
          const opt = adultHit.item;
          if (opt.group === "strip") {
            log2(`${opt.icon} ${opt.name.toUpperCase()}! ${playerName} landed on hole ${state3.scores[key]} \u2014 ${opt.actionText}!`);
            showScoreToast2(who, 0, `${opt.name}! ${opt.actionText}`);
            fancyCall2(`${opt.name.toUpperCase()}! ${opt.icon}`, "strip-action", 2400);
            if (typeof showAdultStripModal2 === "function") showAdultStripModal2(opt, playerName, state3.scores[key]);
          } else if (opt.group === "adult" || opt.timed) {
            log2(`\u{1F525} ${opt.name.toUpperCase()}! ${playerName} landed on hole ${state3.scores[key]} \u2014 Timed Challenge: ${opt.actionText}!`);
            showScoreToast2(who, 0, `Challenge: ${opt.name}!`);
            fancyCall2(`${opt.name.toUpperCase()}! \u{1F525}`, "adult-action", 2400);
            if (typeof showAdultTimerModal2 === "function") showAdultTimerModal2(opt, playerName, state3.scores[key]);
          }
        }
      }
      if (pegTracker && typeof pegTracker.advance === "function") {
        pegTracker.advance(key, state3.scores[key]);
      }
      if (state3.phase !== "show") {
        if (!state3.handPeg) state3.handPeg = {};
        state3.handPeg[key] = (state3.handPeg[key] || 0) + ptsToAdd;
        if (key === "p1" || key === "team1") state3.handPeg.you = state3.handPeg[key];
        if (key === "p2" || key === "team2") state3.handPeg.cpu = state3.handPeg[key];
        if (!state3.pegLog) state3.pegLog = [];
        state3.pegLog.push({
          who,
          n: ptsToAdd,
          why,
          count: state3.count || 0,
          card: state3.pile && state3.pile.length ? state3.pile[state3.pile.length - 1] : state3.starter
        });
      }
      if (sfx3 && typeof sfx3.peg === "function") sfx3.peg();
      if (res.gameHoleReached && sfx3 && typeof sfx3.gameHole === "function") sfx3.gameHole();
      log2(`${playerName} peg ${ptsToAdd} \u2014 ${why}  (${state3.scores[key]})`);
      if (typeof window !== "undefined" && window._currentRenderer3D) {
        if (res.gameHoleReached) {
          window._currentRenderer3D.triggerActionCam({ type: "winning_peg", who: key, hole: state3.scores[key] });
        } else if (ptsToAdd >= 24) {
          window._currentRenderer3D.triggerActionCam({ type: "big_hand", who: key, score: ptsToAdd });
        }
      }
      if (state3.phase === "play" && (!res.laneBlocked || ptsToAdd === n)) {
        showScoreToast2(who, ptsToAdd, why);
        if (/go|heels|nobs/i.test(why) && !/fifteen|pair|run|thirty/i.test(why)) {
          fancyCall2(fancyPegPhrase2(why, ptsToAdd), "combo", isBonusMessage2(why) ? 2200 : 1400);
        }
        const whyLower = (why || "").toLowerCase();
        if (who === "cpu") {
          if (whyLower.includes("fifteen") && Math.random() < 0.28) {
            ReactionManager.triggerAiReaction("nice15", { sfx: sfx3, aiName: playerName });
          } else if ((whyLower.includes("thirty") || whyLower.includes("31") || ptsToAdd >= 6) && Math.random() < 0.35) {
            ReactionManager.triggerAiReaction("boom", { sfx: sfx3, aiName: playerName });
          }
        } else if (who === "p1" || who === "you") {
          if ((whyLower.includes("thirty") || whyLower.includes("31") || ptsToAdd >= 6) && Math.random() < 0.22) {
            ReactionManager.triggerAiReaction("noway", { sfx: sfx3 });
          }
        }
      }
      if (Array.isArray(res.passedMarks)) {
        for (const m of res.passedMarks) {
          setTimeout(() => showStreetBanner2(who, m), 400);
        }
      }
      if (!isPartnerBonus && typeof isShiftingPartnership2 === "function" && isShiftingPartnership2()) {
        const partner = typeof getShiftingPartner2 === "function" ? getShiftingPartner2(who) : null;
        if (partner && partner !== who) {
          _GameEngine.addScore(partner, n, `${why} (partner: ${seatName3(who)})`, true, false, context);
        }
      }
      renderScores2(true);
      checkGameOver2(context);
      return res;
    }
    /**
     * Resets the active match to its initial state and triggers cut phase.
     * @param {Object} [context]
     * @returns {{ state: Object, gameHands: Array }}
     */
    static resetMatch(context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const makeDeck2 = context.makeDeck || (typeof window !== "undefined" ? window.makeDeck : () => []);
      if (typeof window !== "undefined") {
        window.FULL_DECK = makeDeck2(settings3.decks);
      }
      if (typeof document !== "undefined") {
        const menu = document.getElementById("menu");
        const game = document.getElementById("game");
        const logEl = document.getElementById("log");
        if (menu) menu.classList.add("hidden");
        if (game) game.classList.remove("hidden");
        if (logEl) logEl.innerHTML = "";
      }
      const pegTracker = context.pegTracker || (typeof window !== "undefined" ? window.pegTracker : null);
      if (pegTracker && typeof pegTracker.reset === "function") {
        pegTracker.reset();
      }
      HandScoreTracker.reset();
      const getSignConfigs2 = context.getSignConfigs || (typeof window !== "undefined" ? window.getSignConfigs : null);
      const newState = _GameEngine.createInitialMatchState(settings3, { getSignConfigs: getSignConfigs2 });
      if (typeof context.setState === "function") {
        context.setState(newState);
      }
      if (typeof window !== "undefined") {
        window.state = newState;
      }
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : () => {
      });
      const buildBoard2 = context.buildBoard || (typeof window !== "undefined" ? window.buildBoard : () => {
      });
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : () => {
      });
      const beginCut2 = context.beginCut || (typeof window !== "undefined" ? window.beginCut : () => {
      });
      hideModal3();
      buildBoard2();
      renderScores2(false);
      beginCut2();
      return { state: typeof window !== "undefined" && window.state ? window.state : newState, gameHands: [] };
    }
    /**
     * Triggers a rematch or informs guest/host via network.
     * @param {Object} [context]
     */
    static playAgain(context = {}) {
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const resetMatch2 = context.resetMatch || (typeof window !== "undefined" ? window.resetMatch : _GameEngine.resetMatch);
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const seriesState = SeriesTracker.getSeriesState();
      if (seriesState.champion) {
        SeriesTracker.resetSeries();
      }
      if (isOnline2() && settings3.netRole === "guest") {
        netSend2({ type: "intent", op: "playAgain" });
        return;
      }
      resetMatch2(context);
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (state3) {
        const nextDealer = SeriesTracker.getNextOpeningDealer(state3.dealer);
        state3.dealer = nextDealer;
      }
      SeriesTracker.updateSeriesUi();
      ReactionManager.injectReactionUi();
      if (isOnline2()) {
        netSend2({ type: "rematch" });
      }
      netPush2();
    }
    /**
     * Confirms assignment of suit and rank for a wild card/joker.
     * @param {number} r - Rank
     * @param {string} su - Suit
     * @param {string} [seatId]
     * @param {Object} [context]
     */
    static confirmWildAs(r, su, seatId, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const c = state3.pendingWild;
      if (!c) return;
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const hideWildPick2 = context.hideWildPick || (typeof window !== "undefined" ? window.hideWildPick : () => {
      });
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const RANK_NAME3 = context.RANK_NAME || (typeof window !== "undefined" ? window.RANK_NAME : { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" });
      const SUIT_SYM3 = context.SUIT_SYM || (typeof window !== "undefined" ? window.SUIT_SYM : { S: "\u2660", H: "\u2665", C: "\u2663", D: "\u2666" });
      const afterStarterAssigned2 = context.afterStarterAssigned || (typeof window !== "undefined" ? window.afterStarterAssigned : _GameEngine.afterStarterAssigned);
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (card) => Boolean(card && card.wild));
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : (s) => s);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const cpuDoPickYourCrib2 = context.cpuDoPickYourCrib || (typeof window !== "undefined" ? window.cpuDoPickYourCrib : () => {
      });
      const beginDiscard2 = context.beginDiscard || (typeof window !== "undefined" ? window.beginDiscard : _GameEngine.beginDiscard);
      const openWildPick2 = context.openWildPick || (typeof window !== "undefined" ? window.openWildPick : null);
      if (isOnline2() && settings3.netRole === "guest") {
        netSend2({ type: "intent", op: "wild", cardId: c.id, r, s: su, phase: state3.phase, seatId: seatId || mySeat3() });
        hideWildPick2(context);
        return;
      }
      c.r = r;
      c.s = su;
      c.playAs = { r, s: su };
      log2("Joker is now " + (RANK_NAME3[r] || r) + (SUIT_SYM3[su] || su));
      hideWildPick2(context);
      if (state3.phase === "assign" && state3.assignTarget === "starter") {
        afterStarterAssigned2(context);
        return;
      }
      if (state3.phase === "assign-p2") {
        const nextWild = (state3.cpuHand || []).find((x) => isWild2(x) && !x.playAs);
        if (nextWild) {
          setStatus2(pName2("cpu") + ": choose the next joker.");
          render2();
          if (typeof openWildPick2 === "function") {
            openWildPick2(nextWild, "hand", context);
          }
          return;
        }
        state3.phase = "discard-p2";
        setStatus2(pName2("cpu") + ": select cards to throw to the crib.");
        render2();
        return;
      }
      if (state3.phase === "assign") {
        const nextWild = (state3.youHand || []).find((x) => isWild2(x) && !x.playAs);
        if (nextWild) {
          setStatus2("Choose the next joker.");
          render2();
          if (typeof openWildPick2 === "function") {
            openWildPick2(nextWild, "hand", context);
          }
          return;
        }
        if (settings3.optPickYourCrib && isSeatCpu2(state3.dealer)) {
          cpuDoPickYourCrib2(context);
          return;
        }
        beginDiscard2(context);
        return;
      }
      render2();
    }
    /**
     * Enters the discard phase, computes target descriptions, and prompts the current player.
     * @param {Object} [context]
     */
    static beginDiscard(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const seatDiscardsToDeck2 = context.seatDiscardsToDeck || (typeof window !== "undefined" ? window.seatDiscardsToDeck : () => false);
      const isSoloVsPairs2 = context.isSoloVsPairs || (typeof window !== "undefined" ? window.isSoloVsPairs : () => false);
      const isDealerTeam2 = context.isDealerTeam || (typeof window !== "undefined" ? window.isDealerTeam : () => false);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const updateCoachDisplay2 = context.updateCoachDisplay || (typeof window !== "undefined" ? window.updateCoachDisplay : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      state3.phase = "discard";
      const count = settings3 && settings3.playerCount || 2;
      const isCanadianDoubles = Boolean(settings3 && settings3.optCanadianDoubles && count === 4);
      if (isCanadianDoubles) {
        _GameEngine.startCanadianDoublesFlow(context);
        return;
      }
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      let discardN = count >= 3 ? 1 : is7Card ? 2 : settings3.deal === "super" ? 3 : 2;
      const curSeat = state3.currentHumanDiscard || "p1";
      const toDeck = seatDiscardsToDeck2(curSeat);
      let targetDesc = "the crib";
      if (settings3 && (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        const isDealer = curSeat === state3.dealer;
        discardN = isDealer ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
        targetDesc = isDealer ? "your crib" : "the dealer's hand";
        const variantTitle = settings3.optTwistedCribbage ? "Twisted Cribbage" : "Speedo Cribbage";
        setStatus2(variantTitle + ": Select " + discardN + " card" + (discardN === 1 ? "" : "s") + " to " + (isDealer ? "throw to " + targetDesc : "pass to " + targetDesc) + ".");
      } else {
        if (toDeck) {
          targetDesc = "the deck";
        } else if (isSoloVsPairs2()) {
          targetDesc = curSeat === "p1" ? "your crib" : "the crib";
        } else {
          targetDesc = isDealerTeam2(curSeat) ? "your crib" : "opponent's crib";
        }
        setStatus2("Select " + discardN + " card" + (discardN === 1 ? "" : "s") + " to throw to " + targetDesc + ".");
      }
      if (settings3 && settings3.optFivesCribbage && !toDeck) {
        const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (c) => c && (c.rank !== void 0 ? c.rank : c.r) || 0);
        const currHand = getSeatHand2(curSeat) || [];
        const fivesInHand = currHand.filter((c) => rankOf2(c) === 5);
        if (fivesInHand.length > 0) {
          const reqFives = Math.min(fivesInHand.length, discardN);
          state3.selected = fivesInHand.slice(0, reqFives).map((c) => c.id);
          setStatus2("Five's Cribbage: Discard any 5s in your hand to " + targetDesc + " (" + reqFives + " required).");
        }
      }
      if (settings3 && settings3.optSevensAndEightsCribbage && !toDeck) {
        const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (c) => c && (c.rank !== void 0 ? c.rank : c.r) || 0);
        const currHand = getSeatHand2(curSeat) || [];
        const sevensAndEights = currHand.filter((c) => {
          const r = rankOf2(c);
          return r === 7 || r === 8;
        });
        if (sevensAndEights.length > 0) {
          const reqCount = Math.min(sevensAndEights.length, discardN);
          state3.selected = sevensAndEights.slice(0, reqCount).map((c) => c.id);
          setStatus2("Sevens and Eights Cribbage: Discard any 7s and 8s in your hand to " + targetDesc + " (" + reqCount + " required).");
        }
      }
      updateCoachDisplay2();
      render2();
    }
    /**
     * Finalizes starter card selection, scores heels (Jack starter +2), and transitions to play or discard.
     * @param {Object} [context]
     */
    static afterStarterAssigned(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const cardLabel2 = context.cardLabel || (typeof window !== "undefined" ? window.cardLabel : (c) => c ? `${c.r}${c.s}` : "");
      const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (c) => c ? c.r || 0 : 0);
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const addScore2 = context.addScore || (typeof window !== "undefined" ? window.addScore : _GameEngine.addScore);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (c) => Boolean(c && c.wild));
      const openWildPick2 = context.openWildPick || (typeof window !== "undefined" ? window.openWildPick : null);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const activeSeats = typeof context.getActiveSeatIds === "function" ? context.getActiveSeatIds() : typeof window !== "undefined" && typeof window.getActiveSeatIds === "function" ? window.getActiveSeatIds() : ["p1", "p2"];
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" && typeof window.nextSeat === "function" ? window.nextSeat : (s) => _GameEngine.advanceDealer(s, activeSeats));
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : _GameEngine.scheduleOppPlay);
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => false);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (seat, cb) => cb && cb());
      const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
      const starterLabels = starters.map((c) => cardLabel2(c)).join(", ");
      log2("Starter" + (starters.length > 1 ? "s are " : " is ") + starterLabels);
      const isSpadesCut = Boolean(settings3 && settings3.optSpades && starters.some(isSpadeCard));
      state3.spadesCut = isSpadesCut;
      let heelsPts = 0;
      let jackCount = 0;
      for (const st of starters) {
        if (rankOf2(st) === 11) {
          heelsPts += 2;
          jackCount++;
        }
      }
      if (isSpadesCut && heelsPts > 0) {
        heelsPts *= 2;
      }
      const isHeels = heelsPts > 0;
      const heelsPhrase = jackCount > 1 ? `${heelsPts} for his heels${isSpadesCut ? " (spades x2)" : ""}` : `${heelsPts === 4 ? "Four" : "Two"} for his heels${isSpadesCut ? " (spades x2)" : ""}`;
      if (isHeels) {
        fancyCall2(heelsPhrase, "", 1200);
        addScore2(state3.dealer, heelsPts, `his heels (${jackCount > 1 ? `${jackCount} Jack starters` : "Jack starter"})`, false, false, context);
        if (state3.over) {
          render2();
          netPush2({ fancy: { text: `${heelsPhrase} (+${heelsPts})`, kind: "", ms: 1200 }, sfx: "bell31" });
          return;
        }
      }
      if (isSpadesCut) {
        log2("\u2660\uFE0F SPADES CUT! Pegging and heels points are doubled this hand!");
        fancyCall2("\u2660\uFE0F Spades Cut! Double Pegging! \u2660\uFE0F", "famous", 2200);
        const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
        if (sfx3 && typeof sfx3.spades === "function") {
          sfx3.spades();
        }
      }
      if (settings3 && settings3.optGuessStarter && state3.starterGuess) {
        const { who: guessWho, rank: guessRank } = state3.starterGuess;
        const RANK_NAME3 = context.RANK_NAME || (typeof window !== "undefined" ? window.RANK_NAME : { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" });
        const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : (s) => s);
        const whoName = pName2(guessWho);
        const guessedRankName = RANK_NAME3[guessRank] || String(guessRank);
        const isHit = starters.some((st) => {
          const r = st.playAs && st.playAs.r || st.rank || st.r || rankOf2(st) || 0;
          return Number(r) === Number(guessRank);
        });
        if (isHit) {
          log2(`\u{1F3AF} ${whoName} correctly guessed the starter card rank (${guessedRankName})! +3 points!`);
          fancyCall2(`\u{1F3AF} Starter Guessed! +3 pts`, "famous", 2e3);
          const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
          if (sfx3 && typeof sfx3.bell === "function") sfx3.bell();
          else if (sfx3 && typeof sfx3.snap === "function") sfx3.snap();
          addScore2(guessWho, 3, `guess starter: ${guessedRankName}`, false, false, context);
          if (state3.over) {
            state3.starterGuess = null;
            render2();
            netPush2({ fancy: { text: `\u{1F3AF} Starter Guessed! (+3)`, kind: "famous", ms: 2e3 } });
            return;
          }
        } else {
          log2(`${whoName} guessed starter rank ${guessedRankName}, cut was ${starterLabels}.`);
        }
        state3.starterGuess = null;
      }
      const proceed = () => {
        if (settings3.optCutBeforeDiscard && !state3.discardsComplete) {
          if (settings3.jokers && (getSeatHand2("p1") || []).some((c) => isWild2(c) && !c.playAs)) {
            state3.phase = "assign";
            state3.assignTarget = "hand";
            setStatus2("You were dealt a joker. Click it and choose any card.");
            render2();
            const firstWild = (getSeatHand2("p1") || []).find((c) => isWild2(c) && !c.playAs);
            if (typeof openWildPick2 === "function" && firstWild) {
              openWildPick2(firstWild, "hand", context);
            }
          } else {
            startDiscardOrPickFlow(context);
          }
          netPush2({
            fancy: isHeels ? { text: `${heelsPhrase} (+${heelsPts})`, kind: "", ms: 1200 } : null,
            sfx: isHeels ? "bell31" : null
          });
          return;
        }
        state3.phase = "play";
        const cribEl = typeof document !== "undefined" ? document.getElementById("cribCards") : null;
        if (cribEl) {
          cribEl.classList.remove("counting");
          cribEl.classList.add("playing");
        }
        state3.count = 0;
        state3.pile = [];
        const leadSeat = nextSeat2(state3.dealer);
        state3.turn = leadSeat;
        hideWait2();
        render2();
        netPush2({
          fancy: isHeels ? { text: `${heelsPhrase} (+${heelsPts})`, kind: "", ms: 1200 } : null,
          sfx: isHeels ? "bell31" : null
        });
        if (leadSeat && isSeatCpu2(leadSeat)) {
          scheduleOppPlay2(leadSeat, context);
        } else if (leadSeat && isSeatHuman2(leadSeat)) {
          const announceDelay = isHeels ? 1200 : 0;
          setTimeout(() => {
            if (!state3 || state3.over || state3.phase !== "play" || state3.turn !== leadSeat && state3.passingTo !== leadSeat) return;
            _GameEngine.announcePlayTurn(leadSeat, context);
            if (!isOnline2()) {
              passTo2(leadSeat, () => {
                render2();
              }, context);
            }
          }, announceDelay);
        }
      };
      if (state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || state3.paused) {
        state3._resumeAfterSign = proceed;
        state3._resumeAfterAdultTimer = proceed;
        state3._resumeAfterPintsBonus = proceed;
        return;
      }
      proceed();
    }
    /**
     * Schedules or triggers the next turn during the pegging play phase.
     * @param {string} [seatId]
     * @param {Object} [context]
     */
    static scheduleOppPlay(seatId, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (state3 && (state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || state3.paused)) return;
      const seat = seatId || (state3 ? state3.turn : null) || "p2";
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const cpuSeatPlay2 = context.cpuSeatPlay || (typeof window !== "undefined" ? window.cpuSeatPlay : () => {
      });
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => false);
      const passTo2 = context.passTo || (typeof window !== "undefined" ? window.passTo : (s, cb) => cb && cb());
      if (isOnline2()) {
        if (isSeatCpu2(seat)) {
          if (settings3.netRole === "host") {
            setTimeout(() => cpuSeatPlay2(seat), 550);
          }
          return;
        }
        if (seat === mySeat3()) {
          _GameEngine.announcePlayTurn(seat, context);
          render2();
          return;
        }
        setStatus2(seatName3(seat) + " to play\u2026");
        render2();
        netPush2();
        return;
      }
      if (isSeatHuman2(seat)) {
        passTo2(seat, () => {
          _GameEngine.announcePlayTurn(seat, context);
          render2();
        }, context);
        return;
      }
      setTimeout(() => cpuSeatPlay2(seat), 550);
    }
    checkGameOver(context) {
      return _GameEngine.checkGameOver(context);
    }
    addScore(who, n, why, isPartnerBonus, isSignAction, context) {
      return _GameEngine.addScore(who, n, why, isPartnerBonus, isSignAction, context);
    }
    resetMatch(context) {
      return _GameEngine.resetMatch(context);
    }
    playAgain(context) {
      return _GameEngine.playAgain(context);
    }
    confirmWildAs(r, su, seatId, context) {
      return _GameEngine.confirmWildAs(r, su, seatId, context);
    }
    beginDiscard(context) {
      return _GameEngine.beginDiscard(context);
    }
    afterStarterAssigned(context) {
      return _GameEngine.afterStarterAssigned(context);
    }
    /**
     * Determines if a player seat discards to the deck in 5+ player setups.
     * @param {string} seatId
     * @param {Object} [context]
     * @returns {boolean}
     */
    static seatDiscardsToDeck(seatId, context = {}) {
      const sId = seatId === "you" ? "p1" : seatId === "cpu" ? "p2" : seatId;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const count = settings3 && settings3.playerCount || 2;
      if (count < 5) return false;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || !state3.dealer) return false;
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => []);
      const active2 = getActiveSeatIds2();
      const dIdx = active2.indexOf(state3.dealer);
      if (dIdx < 0) return false;
      const sIdx = active2.indexOf(sId);
      if (sIdx < 0) return false;
      const posFromDealer = (sIdx - dIdx + count - 1) % count + 1;
      return posFromDealer > 4;
    }
    /**
     * Checks if a seat is on the dealer's team.
     * @param {string} seatId
     * @param {Object} [context]
     * @returns {boolean}
     */
    static isDealerTeam(seatId, context = {}) {
      let s = seatId;
      if (s === "you") s = "p1";
      if (s === "cpu") s = "p2";
      const isSoloVsPairs2 = context.isSoloVsPairs || (typeof window !== "undefined" ? window.isSoloVsPairs : () => false);
      if (isSoloVsPairs2()) return s === "p1";
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || !state3.dealer) return false;
      let d = state3.dealer;
      if (d === "you") d = "p1";
      if (d === "cpu") d = "p2";
      const isFixedTeams2 = context.isFixedTeams || (typeof window !== "undefined" ? window.isFixedTeams : () => false);
      const getSeatTeam2 = context.getSeatTeam || (typeof window !== "undefined" ? window.getSeatTeam : (seat) => seat);
      if (isFixedTeams2()) {
        return getSeatTeam2(d) === getSeatTeam2(s);
      }
      return s === d;
    }
    /**
     * Handles discard selection click for opponent seats in pass-and-play.
     * @param {string} sId
     * @param {Object} c
     * @param {Object} [context]
     */
    static onOppSeatDiscardCard(sId, c, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.over || state3.phase !== "discard" && state3.phase !== "draw-1" && state3.phase !== "draw-2" && state3.phase !== "draw-1-p2" && state3.phase !== "draw-2-p2") return;
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      if (isOnline2() || state3.currentHumanDiscard !== sId) return;
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const isDraw1 = state3.phase === "draw-1" || state3.phase === "draw-1-p2";
      const isDraw2 = state3.phase === "draw-2" || state3.phase === "draw-2-p2";
      if (isDraw1 || isDraw2) {
        const maxDraw = isDraw1 ? 5 : 3;
        state3.selected = state3.selected || [];
        const i2 = state3.selected.indexOf(c.id);
        if (i2 >= 0) state3.selected.splice(i2, 1);
        else if (state3.selected.length < maxDraw) state3.selected.push(c.id);
        render2();
        return;
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const count = parseInt(settings3 && settings3.playerCount, 10) || 2;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      const isCanadianDoubles = Boolean(settings3 && settings3.optCanadianDoubles && count === 4);
      let discardN = isCanadianDoubles ? 2 : count >= 3 ? 1 : is7Card ? 2 : settings3 && settings3.deal === "super" ? 3 : 2;
      if (settings3 && (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        discardN = sId === state3.dealer ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
      }
      state3.selected = state3.selected || [];
      const i = state3.selected.indexOf(c.id);
      if (i >= 0) state3.selected.splice(i, 1);
      else if (state3.selected.length < discardN) state3.selected.push(c.id);
      render2();
    }
    /**
     * Handles card interaction click for Player 2 (CPU / second human in HvH).
     * @param {Object} c
     * @param {Object} [context]
     */
    static onCpuCard(c, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const isHvH2 = context.isHvH || (typeof window !== "undefined" ? window.isHvH : () => false);
      if (!isHvH2() || state3.over || state3.frozen || state3.phase === "cut-starter" || state3.phase === "starter-ritual") return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const count = parseInt(settings3 && settings3.playerCount, 10) || 2;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      let discardN = count >= 3 ? 1 : is7Card ? 2 : settings3 && settings3.deal === "super" ? 3 : 2;
      if (settings3 && (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        discardN = "p2" === state3.dealer ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
      }
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (card) => Boolean(card && card.wild));
      const openWildPick2 = context.openWildPick || (typeof window !== "undefined" ? window.openWildPick : () => {
      });
      const hideWildPick2 = context.hideWildPick || (typeof window !== "undefined" ? window.hideWildPick : () => {
      });
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const VAL4 = context.VAL || (typeof window !== "undefined" ? window.VAL : (r) => Math.min(10, r));
      const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (card) => card ? card.r || 0 : 0);
      const playCard2 = context.playCard || (typeof window !== "undefined" ? window.playCard : () => {
      });
      if (state3.phase === "assign-p2") {
        if (isWild2(c) && !c.playAs) openWildPick2(c, "hand", context);
        return;
      }
      const isP2Draw1 = state3.phase === "draw-1-p2" || !isOnline2() && state3.currentHumanDiscard === "p2" && state3.phase === "draw-1";
      const isP2Draw2 = state3.phase === "draw-2-p2" || !isOnline2() && state3.currentHumanDiscard === "p2" && state3.phase === "draw-2";
      if (isP2Draw1 || isP2Draw2) {
        const maxDraw = isP2Draw1 ? 5 : 3;
        state3.selected = state3.selected || [];
        const i = state3.selected.indexOf(c.id);
        if (i >= 0) state3.selected.splice(i, 1);
        else if (state3.selected.length < maxDraw) state3.selected.push(c.id);
        const selLen = state3.selected.length;
        const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
        });
        if (selLen === 0) {
          setStatus2(`Draw Cribbage (${isP2Draw1 ? "1st Draw" : "2nd Draw"}): Select 0\u2013${maxDraw} cards to replace, then click 'Discard & Draw' (or 'Keep Hand').`);
        } else {
          setStatus2(`Draw Cribbage: ${selLen} card${selLen === 1 ? "" : "s"} selected to replace. Click 'Discard & Draw (${selLen})' to draw replacements.`);
        }
        render2();
        return;
      }
      if (state3.phase === "discard-p2" || !isOnline2() && state3.currentHumanDiscard === "p2" && state3.phase === "discard") {
        state3.selected = state3.selected || [];
        const i = state3.selected.indexOf(c.id);
        if (i >= 0) state3.selected.splice(i, 1);
        else if (state3.selected.length < discardN) state3.selected.push(c.id);
        render2();
        return;
      }
      if (state3.phase === "play" && (state3.turn === "cpu" || state3.turn === "p2") && !state3.frozen && !state3.pausedForSign && !state3.paused && !state3.pausedForAdultTimer && !state3.pausedForAdultStrip && !state3.pausedForPintsBonus) {
        if (isWild2(c) && !c.playAs) {
          openWildPick2(c, "hand", context);
          return;
        }
        if (state3.count + VAL4(rankOf2(c)) > 31) return;
        hideWildPick2(context);
        playCard2("p2", c);
      }
    }
    /**
     * Handles card interaction click for Player 1 / primary user.
     * @param {Object} c
     * @param {Object} [context]
     */
    static onYouCard(c, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.over || state3.phase === "dealing") return;
      if (state3.phase === "cut" || state3.phase === "cut-starter" || state3.phase === "starter-ritual") return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const count = parseInt(settings3 && settings3.playerCount, 10) || 2;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      const isCanadianDoubles = Boolean(settings3 && settings3.optCanadianDoubles && count === 4);
      if (isCanadianDoubles && state3.phase === "discard") {
        const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const curHand = getSeatHand2(mySeat3());
        if (curHand && curHand.length === 10) {
          const ModalCls = CanadianDoublesModal || (typeof CC !== "undefined" ? CC.CanadianDoublesModal : typeof window !== "undefined" ? window.CanadianDoublesModal || window.CrazyCribbage?.CanadianDoublesModal : null);
          if (ModalCls && typeof ModalCls.open === "function") {
            ModalCls.open(mySeat3(), { ...context, onComplete: () => _GameEngine.startCanadianDoublesFlow(context) });
            return;
          }
        }
      }
      let discardN = isCanadianDoubles ? 2 : count >= 3 ? 1 : is7Card ? 2 : settings3 && settings3.deal === "super" ? 3 : 2;
      if (settings3 && (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        discardN = state3.dealer === "p1" ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
      }
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : (card) => Boolean(card && card.wild));
      const openWildPick2 = context.openWildPick || (typeof window !== "undefined" ? window.openWildPick : () => {
      });
      const hideWildPick2 = context.hideWildPick || (typeof window !== "undefined" ? window.hideWildPick : () => {
      });
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => false);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const VAL4 = context.VAL || (typeof window !== "undefined" ? window.VAL : (r) => Math.min(10, r));
      const rankOf2 = context.rankOf || (typeof window !== "undefined" ? window.rankOf : (card) => card ? card.r || 0 : 0);
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const playCard2 = context.playCard || (typeof window !== "undefined" ? window.playCard : () => {
      });
      if (state3.phase === "assign") {
        if (state3.assignTarget === "starter") return;
        if (isWild2(c) && !c.playAs) openWildPick2(c, "hand", context);
        return;
      }
      const me = mySeat3();
      const activeHumanDiscard = !isOnline2() ? state3.currentHumanDiscard || "p1" : me;
      const canDiscard = state3.phase === "discard" && (!isOnline2() ? activeHumanDiscard === "p1" : settings3 && settings3.netRole === "host" || isSeatHuman2(me)) || state3.phase === "discard-p2" && isOnline2() && me === "p2";
      const isDraw1 = state3.phase === "draw-1" || state3.phase === "draw-1-p2" && isOnline2() && me === "p2";
      const isDraw2 = state3.phase === "draw-2" || state3.phase === "draw-2-p2" && isOnline2() && me === "p2";
      if (isDraw1 || isDraw2) {
        const maxDraw = isDraw1 ? 5 : 3;
        state3.selected = state3.selected || [];
        const i = state3.selected.indexOf(c.id);
        if (i >= 0) state3.selected.splice(i, 1);
        else if (state3.selected.length < maxDraw) state3.selected.push(c.id);
        const selLen = state3.selected.length;
        const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
        });
        if (selLen === 0) {
          setStatus2(`Draw Cribbage (${isDraw1 ? "1st Draw" : "2nd Draw"}): Select 0\u2013${maxDraw} cards to replace, then click 'Discard & Draw' (or 'Keep Hand').`);
        } else {
          setStatus2(`Draw Cribbage: ${selLen} card${selLen === 1 ? "" : "s"} selected to replace. Click 'Discard & Draw (${selLen})' to draw replacements.`);
        }
        render2();
        return;
      }
      if (canDiscard && !state3.paused && !state3.pausedForAdultTimer && !state3.pausedForAdultStrip && !state3.pausedForPintsBonus) {
        state3.selected = state3.selected || [];
        const i = state3.selected.indexOf(c.id);
        if (i >= 0) state3.selected.splice(i, 1);
        else if (state3.selected.length < discardN) state3.selected.push(c.id);
        render2();
      } else if (state3.phase === "play" && state3.turn === me && !state3.frozen && !state3.pausedForSign && !state3.paused && !state3.pausedForAdultTimer && !state3.pausedForAdultStrip && !state3.pausedForPintsBonus) {
        if (isWild2(c) && !c.playAs) {
          openWildPick2(c, "hand", context);
          return;
        }
        if (state3.count + VAL4(rankOf2(c)) > 31) return;
        hideWildPick2(context);
        if (isOnline2() && settings3 && settings3.netRole === "guest") {
          netSend2({ type: "intent", op: "play", cardId: c.id, seatId: me });
          return;
        }
        playCard2(me, c);
      }
    }
    seatDiscardsToDeck(seatId, context) {
      return _GameEngine.seatDiscardsToDeck(seatId, context);
    }
    isDealerTeam(seatId, context) {
      return _GameEngine.isDealerTeam(seatId, context);
    }
    onOppSeatDiscardCard(sId, c, context) {
      return _GameEngine.onOppSeatDiscardCard(sId, c, context);
    }
    onCpuCard(c, context) {
      return _GameEngine.onCpuCard(c, context);
    }
    onYouCard(c, context) {
      return _GameEngine.onYouCard(c, context);
    }
    confirmDraw(context) {
      return _GameEngine.confirmDraw(context);
    }
    startDrawCribbagePhase(phaseNum, context) {
      return _GameEngine.startDrawCribbagePhase(phaseNum, context);
    }
    processNextDrawSeat(context) {
      return _GameEngine.processNextDrawSeat(context);
    }
    cpuGuessStarterRank(poneSeat, state3, settings3, context) {
      return _GameEngine.cpuGuessStarterRank(poneSeat, state3, settings3, context);
    }
    announcePlayTurn(seatId, context) {
      return _GameEngine.announcePlayTurn(seatId, context);
    }
  };

  // src/variants/PintsManager.js
  var PINTS_OPTIONS_DEFS = Object.freeze([
    {
      key: "youDrink",
      chkId: "optYouDrink",
      name: "You Drink",
      icon: "\u{1F37A}",
      description: "Take a drink when you land on this space",
      actionText: "Landing here requires the player to take a drink",
      color: "#f59e0b",
      defaultHoles: [15, 45, 75, 105]
    },
    {
      key: "guysDrink",
      chkId: "optGuysDrink",
      name: "Guys Drink",
      icon: "\u{1F37B}",
      description: "All male players take a drink",
      actionText: "Landing here requires all guys to take a drink",
      color: "#6366f1",
      defaultHoles: [12, 42, 72, 102]
    },
    {
      key: "galsDrink",
      chkId: "optGalsDrink",
      name: "Gals Drink",
      icon: "\u{1F377}",
      description: "All female players take a drink",
      actionText: "Landing here requires all gals to take a drink",
      color: "#f43f5e",
      defaultHoles: [18, 48, 78, 108]
    },
    {
      key: "leftDrink",
      chkId: "optLeftDrink",
      name: "Player to the left Drinks",
      icon: "\u{1F448}",
      description: "Person to your left takes a drink",
      actionText: "Landing here requires the player to your left to take a drink",
      color: "#3b82f6",
      defaultHoles: [35, 65, 95, 115]
    },
    {
      key: "rightDrink",
      chkId: "optRightDrink",
      name: "Player to the right Drinks",
      icon: "\u{1F449}",
      description: "Person to your right takes a drink",
      actionText: "Landing here requires the player to your right to take a drink",
      color: "#06b6d4",
      defaultHoles: [5, 35, 65, 95]
    },
    {
      key: "everyoneDrink",
      chkId: "optEveryoneDrink",
      name: "Everyone Drinks",
      icon: "\u{1F942}",
      description: "Social! Every player at the table takes a drink",
      actionText: "Landing here requires everyone playing to take a drink",
      color: "#10b981",
      defaultHoles: [30, 60, 90, 120]
    },
    {
      key: "everyoneButYouDrink",
      chkId: "optEveryoneButYouDrink",
      name: "Everyone but you Drinks",
      icon: "\u{1F389}",
      description: "Everyone except the pegging player takes a drink",
      actionText: "Landing here requires everyone except you to take a drink",
      color: "#8b5cf6",
      defaultHoles: [20, 50, 80, 110]
    },
    {
      key: "pickWhoDrinks",
      chkId: "optPickWhoDrinks",
      name: "You pick who drinks",
      icon: "\u{1F3AF}",
      description: "Choose any single opponent or player to take a drink",
      actionText: "Landing here allows you to choose who takes a drink",
      color: "#ec4899",
      defaultHoles: [10, 40, 70, 100]
    }
  ]);
  var PintsManager = class _PintsManager {
    constructor(options = {}) {
      this.enabled = Boolean(options.enabled);
      this.options = { ...options };
      this.activeHoles = /* @__PURE__ */ new Map();
      this.rebuildHoleMap();
    }
    rebuildHoleMap(settings3 = this.options) {
      this.activeHoles.clear();
      for (const def of PINTS_OPTIONS_DEFS) {
        if (settings3 && (settings3[def.key] || settings3[def.chkId] || settings3[`opt${def.name.replace(/\s+/g, "")}`])) {
          const holes = settings3[`${def.key}Holes`] || def.defaultHoles;
          for (const h of holes) {
            if (h > 0) this.activeHoles.set(h, def);
          }
        }
      }
    }
    checkHole(holeNum) {
      return this.activeHoles.get(holeNum) || null;
    }
    /**
     * Retrieves all active pints space configurations based on settings and options definitions.
     * @param {Object} settings Current game settings object
     * @param {Array} [optionsList] List of pints option definitions (defaults to PINTS_OPTIONS_DEFS)
     * @returns {Array} List of active configs { id, hole, start, end, pegs, type, item }
     */
    getAllActiveConfigs(settings3, optionsList = PINTS_OPTIONS_DEFS) {
      if (!settings3) return [];
      const all = [];
      for (const opt of optionsList) {
        const isChecked = Boolean(settings3[opt.chkId] || settings3[opt.key]);
        if (!isChecked) continue;
        if (typeof opt.getConfig === "function") {
          const list = opt.getConfig();
          if (Array.isArray(list) && list.length > 0) {
            list.forEach((c) => all.push({ ...c, item: opt }));
            continue;
          }
        }
        const count = Math.min(4, Math.max(1, parseInt(settings3[opt.key + "Count"], 10) || (opt.defaultHoles ? opt.defaultHoles.length : 1)));
        const pegs = Math.min(5, Math.max(1, parseInt(settings3[opt.key + "Pegs"], 10) || 1));
        const holes = settings3[opt.key + "Holes"] || opt.defaultHoles || [15];
        for (let i = 0; i < count; i++) {
          const h = holes[i] != null ? holes[i] : opt.defaultHoles ? opt.defaultHoles[i] : 15;
          all.push({
            id: i + 1,
            hole: h,
            start: h,
            end: h + pegs - 1,
            pegs,
            type: opt.key,
            label: `${opt.name} ${i + 1}`,
            item: opt
          });
        }
      }
      return all;
    }
    /**
     * Resolves whether a specific board hole triggers an active Pints drinking space.
     * @param {number} hole Hole number (1-121 or 1-481)
     * @param {Object} settings Current game settings
     * @param {Array} [optionsList]
     * @param {string} [brand='pints'] Current application brand
     * @returns {Object|null}
     */
    getActiveOptionAtHole(hole, settings3, optionsList = PINTS_OPTIONS_DEFS, brand = "pints") {
      if (!settings3) return null;
      const list = optionsList || PINTS_OPTIONS_DEFS;
      const hasAnyOption = list.some((o) => settings3[o.chkId] || settings3[o.key]);
      if (brand !== "pints" && !hasAnyOption) return null;
      const all = this.getAllActiveConfigs(settings3, list);
      return all.find((c) => hole >= c.start && hole <= c.end) || null;
    }
    /**
     * Randomizes Pints spaces across the board without overlapping.
     * @param {Object} settings Current game settings
     * @param {boolean} [isFull=false] Whether to enable all options (full) or a subset
     * @param {Array} [optionsList]
     * @returns {Object} New settings fragment with randomized spaces
     */
    randomize(settings3 = {}, isFull = false, optionsList = PINTS_OPTIONS_DEFS) {
      const updated = { ...settings3 };
      const usedHoles = /* @__PURE__ */ new Set();
      optionsList.forEach((opt) => {
        const enable = isFull ? true : Math.random() < 0.65;
        updated[opt.chkId] = enable;
        if (!enable) return;
        const count = Math.floor(Math.random() * 2) + 1;
        const pegs = 1;
        updated[opt.key + "Count"] = count;
        updated[opt.key + "Pegs"] = pegs;
        const holes = [];
        for (let i = 0; i < count; i++) {
          let attempts = 0;
          let h = 15;
          while (attempts < 50) {
            h = Math.floor(Math.random() * 110) + 5;
            if (!usedHoles.has(h) && !usedHoles.has(h - 1) && !usedHoles.has(h + 1)) break;
            attempts++;
          }
          usedHoles.add(h);
          holes.push(h);
        }
        updated[opt.key + "Holes"] = holes;
      });
      return updated;
    }
    /**
     * Resets all Pints spaces to unselected state.
     * @param {Array} [optionsList]
     * @returns {Object} Settings fragment with all options disabled
     */
    clearAll(optionsList = PINTS_OPTIONS_DEFS) {
      const cleared = {};
      optionsList.forEach((opt) => {
        cleared[opt.chkId] = false;
        cleared[opt.key] = false;
      });
      return cleared;
    }
    triggerBonusModal(player, holeNum, bonusDef, continuationCb) {
      const overlay = typeof document !== "undefined" ? document.getElementById("pintsBonusOverlay") : null;
      const titleEl = typeof document !== "undefined" ? document.getElementById("pintsBonusTitle") : null;
      const playerEl = typeof document !== "undefined" ? document.getElementById("pintsBonusPlayer") : null;
      const iconEl = typeof document !== "undefined" ? document.getElementById("pintsBonusIcon") : null;
      const msgEl = typeof document !== "undefined" ? document.getElementById("pintsBonusMessage") : null;
      if (iconEl) iconEl.textContent = bonusDef.icon || "\u{1F37A}";
      if (titleEl) titleEl.textContent = `${bonusDef.icon ? bonusDef.icon + " " : ""}${bonusDef.name}`;
      if (playerEl) playerEl.textContent = `${player.name || player.label || "Player"} landed on Hole ${holeNum}!`;
      if (msgEl) msgEl.textContent = bonusDef.description || bonusDef.actionText || bonusDef.name;
      if (overlay) {
        overlay.style.display = "flex";
      }
      return continuationCb;
    }
    /**
     * Displays the Pints & Pegs drinking bonus modal dialog and pauses match flow.
     * @param {Object} optionDef
     * @param {string} playerLabel
     * @param {number} holeNum
     * @param {Object} [context]
     */
    static showPintsBonusModal(optionDef, playerLabel, holeNum, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
      const pintsManager = context.pintsManager || (typeof window !== "undefined" ? window.pintsManager : null);
      if (state3) {
        state3.pausedForPintsBonus = true;
        state3.paused = true;
        const desc = optionDef.description || optionDef.actionText || optionDef.name;
        log2(`\u{1F37A} PINTS BONUS: ${playerLabel || "Player"} landed on Hole ${holeNum} (${optionDef.name}) \u2014 ${desc}! Game is paused.`);
        setStatus2(`Landed on Hole ${holeNum} (${optionDef.name})! Game is paused.`);
      }
      if (pintsManager && typeof pintsManager.triggerBonusModal === "function") {
        pintsManager.triggerBonusModal({ name: playerLabel }, holeNum, optionDef);
      }
      if (sfx3 && typeof sfx3.snap === "function") sfx3.snap();
    }
    /**
     * Closes the Pints drinking modal and resumes gameplay.
     * @param {Object} [context]
     */
    static closePintsBonusModal(context = {}) {
      const pintsManager = context.pintsManager || (typeof window !== "undefined" ? window.pintsManager : null);
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : () => {
      });
      const resumeGameAfterPintsBonus2 = context.resumeGameAfterPintsBonus || (typeof window !== "undefined" ? window.resumeGameAfterPintsBonus : _PintsManager.resumeGameAfterPintsBonus);
      if (pintsManager && typeof pintsManager.closeModal === "function") {
        pintsManager.closeModal();
      }
      if (typeof document !== "undefined") {
        const overlay = document.getElementById("pintsBonusOverlay");
        if (overlay) overlay.style.display = "none";
        else hideModal3();
      } else {
        hideModal3();
      }
      resumeGameAfterPintsBonus2(context);
    }
    /**
     * Unpauses match and resumes play or turn scheduling after Pints bonus dismissal.
     * @param {Object} [context]
     */
    static resumeGameAfterPintsBonus(context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      state3.pausedForPintsBonus = false;
      if (!state3.pausedForSign && !state3.pausedForAdultTimer && !state3.pausedForAdultStrip) {
        state3.paused = false;
      }
      if (typeof state3._resumeAfterPintsBonus === "function") {
        const resumeFn = state3._resumeAfterPintsBonus;
        state3._resumeAfterPintsBonus = null;
        state3._resumeAfterAdultTimer = null;
        state3._resumeAfterSign = null;
        resumeFn();
      } else if (typeof state3._resumeAfterSign === "function" && !state3.pausedForSign && !state3.pausedForAdultTimer && !state3.pausedForAdultStrip) {
        const resumeFn = state3._resumeAfterSign;
        state3._resumeAfterPintsBonus = null;
        state3._resumeAfterAdultTimer = null;
        state3._resumeAfterSign = null;
        resumeFn();
      } else if (typeof state3._resumeAfterAdultTimer === "function" && !state3.pausedForAdultTimer && !state3.pausedForAdultStrip && !state3.pausedForSign) {
        const resumeFn = state3._resumeAfterAdultTimer;
        state3._resumeAfterPintsBonus = null;
        state3._resumeAfterAdultTimer = null;
        state3._resumeAfterSign = null;
        resumeFn();
      } else if (state3.phase === "play" && isSeatCpu2(state3.turn) && !state3.paused) {
        scheduleOppPlay2(state3.turn, context);
      } else if (state3.phase === "play" && !state3.paused) {
        render2();
      }
    }
    showPintsBonusModal(optionDef, playerLabel, holeNum, context) {
      return _PintsManager.showPintsBonusModal(optionDef, playerLabel, holeNum, context);
    }
    closePintsBonusModal(context) {
      return _PintsManager.closePintsBonusModal(context);
    }
    resumeGameAfterPintsBonus(context) {
      return _PintsManager.resumeGameAfterPintsBonus(context);
    }
  };

  // src/variants/AdultManager.js
  var ADULT_OPTIONS_DEFS = Object.freeze([
    // Group 1: Strip Themed
    { key: "loseClothing", chkId: "optLoseClothing", name: "You Lose Clothing", actionText: "Player loses an article of clothing", group: "strip", icon: "\u{1F459}", color: "#f43f5e", defaultHoles: [10, 70, 10, 70], timed: false },
    { key: "gainClothing", chkId: "optGainClothing", name: "You Gain Clothing", actionText: "Player gains an article of clothing back", group: "strip", icon: "\u{1F9E5}", color: "#10b981", defaultHoles: [20, 80, 20, 80], timed: false },
    { key: "pickWhoLosesClothing", chkId: "optPickWhoLosesClothing", name: "Pick Who Strips", actionText: "Player picks who loses an article of clothing", group: "strip", icon: "\u{1F3AF}", color: "#ec4899", defaultHoles: [30, 90, 30, 90], timed: false },
    { key: "rightLosesClothing", chkId: "optRightLosesClothing", name: "Right Neighbor Strips", actionText: "Person to right loses an article of clothing", group: "strip", icon: "\u{1F449}", color: "#3b82f6", defaultHoles: [40, 100, 40, 100], timed: false },
    { key: "leftLosesClothing", chkId: "optLeftLosesClothing", name: "Left Neighbor Strips", actionText: "Person to left loses an article of clothing", group: "strip", icon: "\u{1F448}", color: "#8b5cf6", defaultHoles: [50, 110, 50, 110], timed: false },
    { key: "removeClothingChoice", chkId: "optRemoveClothingChoice", name: "Remove Clothing Choice", actionText: "Remove an article of clothing off person of your choice", group: "strip", icon: "\u2702\uFE0F", color: "#e11d48", defaultHoles: [60, 120, 60, 120], timed: false },
    // Group 2: Adult Themed (Timed Challenges)
    { key: "touchBreast", chkId: "optTouchBreast", name: "Touch Breast", actionText: "Touch breast", group: "adult", icon: "\u{1F48B}", color: "#f43f5e", defaultHoles: [5, 45, 75, 105], timed: true },
    { key: "lickBreast", chkId: "optLickBreast", name: "Lick Breast", actionText: "Lick breast", group: "adult", icon: "\u{1F445}", color: "#ec4899", defaultHoles: [15, 50, 80, 110], timed: true },
    { key: "suckBreast", chkId: "optSuckBreast", name: "Suck Breast", actionText: "Suck breast", group: "adult", icon: "\u{1F444}", color: "#d946ef", defaultHoles: [25, 55, 85, 115], timed: true },
    { key: "touchGenitals", chkId: "optTouchGenitals", name: "Touch Genitals", actionText: "Touch genitals", group: "adult", icon: "\u2728", color: "#a855f7", defaultHoles: [35, 40, 70, 100], timed: true },
    { key: "lickGenitals", chkId: "optLickGenitals", name: "Lick Genitals", actionText: "Lick genitals", group: "adult", icon: "\u{1F445}", color: "#f43f5e", defaultHoles: [45, 60, 90, 120], timed: true },
    { key: "suckGenitals", chkId: "optSuckGenitals", name: "Suck Genitals", actionText: "Suck genitals", group: "adult", icon: "\u{1F444}", color: "#ec4899", defaultHoles: [55, 65, 95, 115], timed: true },
    { key: "fingerGenitals", chkId: "optFingerGenitals", name: "Finger Genitals", actionText: "Finger genitals", group: "adult", icon: "\u{1F449}", color: "#f59e0b", defaultHoles: [65, 45, 75, 105], timed: true }
  ]);
  var AdultManager = class {
    constructor(options = {}) {
      this.enabled = Boolean(options.enabled);
      this.options = { ...options };
      this.activeHoles = /* @__PURE__ */ new Map();
      this.timerInterval = null;
      this.rebuildHoleMap();
    }
    rebuildHoleMap(settings3 = this.options) {
      this.activeHoles.clear();
      for (const def of ADULT_OPTIONS_DEFS) {
        if (settings3 && (settings3[def.key] || settings3[def.chkId])) {
          const holes = settings3[`${def.key}Holes`] || def.defaultHoles;
          for (const h of holes) {
            if (h > 0) this.activeHoles.set(h, def);
          }
        }
      }
    }
    checkHole(holeNum) {
      return this.activeHoles.get(holeNum) || null;
    }
    /**
     * Retrieves definition for an adult option by its key.
     * @param {string} key
     * @param {Array} [optionsList]
     * @returns {Object|null}
     */
    getOptionDef(key, optionsList = ADULT_OPTIONS_DEFS) {
      return optionsList.find((o) => o.key === key) || null;
    }
    /**
     * Generates default configuration for the Adult / Skunked and Stripped brand.
     * @param {Array} [optionsList]
     * @returns {Object}
     */
    getDefaultSettings(optionsList = ADULT_OPTIONS_DEFS) {
      const cfg = {
        target: 121,
        goal: "high",
        theme: "passion"
      };
      optionsList.forEach((opt) => {
        const isStrip = opt.group === "strip";
        const defaultCount = isStrip ? 2 : 1;
        cfg[opt.chkId] = true;
        cfg[opt.key + "Count"] = defaultCount;
        cfg[opt.key + "Pegs"] = 1;
        cfg[opt.key + "Holes"] = [...opt.defaultHoles];
      });
      return cfg;
    }
    /**
     * Retrieves all active adult option configs across strip and timed challenges.
     * @param {Object} settings
     * @param {Array} [optionsList]
     * @returns {Array}
     */
    getAllActiveConfigs(settings3, optionsList = ADULT_OPTIONS_DEFS) {
      if (!settings3) return [];
      const all = [];
      optionsList.forEach((opt) => {
        if (settings3[opt.chkId] || settings3[opt.key]) {
          const count = Math.min(4, Math.max(1, settings3[opt.key + "Count"] != null ? parseInt(settings3[opt.key + "Count"], 10) : opt.group === "strip" ? 2 : 1));
          const pegs = Math.min(5, Math.max(1, parseInt(settings3[opt.key + "Pegs"], 10) || 1));
          const holes = settings3[opt.key + "Holes"] || opt.defaultHoles;
          for (let i = 0; i < count; i++) {
            const h = holes[i] != null ? holes[i] : opt.defaultHoles[i];
            all.push({
              id: i + 1,
              hole: h,
              start: h,
              end: h + pegs - 1,
              pegs,
              type: opt.key,
              label: `${opt.name} ${i + 1}`,
              item: opt
            });
          }
        }
      });
      return all;
    }
    /**
     * Resolves whether a specific board hole triggers an active Adult space.
     * @param {number} hole
     * @param {Object} settings
     * @param {Array} [optionsList]
     * @param {string} [brand='adult']
     * @returns {Object|null}
     */
    getActiveOptionAtHole(hole, settings3, optionsList = ADULT_OPTIONS_DEFS, brand = "adult") {
      if (!settings3) return null;
      if (brand !== "adult") return null;
      const list = optionsList || ADULT_OPTIONS_DEFS;
      const all = this.getAllActiveConfigs(settings3, list);
      return all.find((c) => hole >= c.start && hole <= c.end) || null;
    }
    /**
     * Clears all adult option checkboxes.
     * @param {Array} [optionsList]
     * @returns {Object}
     */
    clearAll(optionsList = ADULT_OPTIONS_DEFS) {
      const cleared = {};
      optionsList.forEach((opt) => {
        cleared[opt.chkId] = false;
        cleared[opt.key] = false;
      });
      return cleared;
    }
    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    }
  };

  // src/variants/ClashManager.js
  var CLASH_OBSTACLE_TYPES = Object.freeze([
    "noPassingLanes",
    "jump",
    "jail",
    "bar",
    "detour",
    "roundAbout",
    "timeout",
    "stopSigns",
    "diceRoll",
    "spinningWheel"
  ]);
  var WHEEL_SLOTS = Object.freeze([
    "Score Plus x2",
    "Score Plus x3",
    "Plus 10",
    "Minus 10",
    "Go To Jail",
    "Go To The Bar",
    "Go To Timeout",
    "Roll The Dice"
  ]);
  var SIGN_PRIORITY = Object.freeze([
    "Score Plus x3",
    "Score Plus x2",
    "Plus 10",
    "Plus 5",
    "Spin The Wheel",
    "Roll The Dice",
    "Undo",
    "Minus 5",
    "Score Minus x2",
    "Minus 10",
    "Score Minus x3",
    "Go To The Bar",
    "Go To Timeout",
    "Go To Jail"
  ]);
  var SIGN_DEFS = Object.freeze({
    "Plus 5": { icon: "\u2795", desc: "Advance your peg 5 holes forward" },
    "Plus 10": { icon: "\u23E9", desc: "Advance your peg 10 holes forward" },
    "Minus 5": { icon: "\u2796", desc: "Move your peg back 5 holes" },
    "Minus 10": { icon: "\u23EA", desc: "Move your peg back 10 holes" },
    "Score Plus x2": { icon: "\u2716\uFE0F2\uFE0F\u20E3", desc: "Double your entire current score!" },
    "Score Plus x3": { icon: "\u2716\uFE0F3\uFE0F\u20E3", desc: "Triple your entire current score!" },
    "Score Minus x2": { icon: "\u27972\uFE0F\u20E3", desc: "Cut your entire current score in half" },
    "Score Minus x3": { icon: "\u27973\uFE0F\u20E3", desc: "Reduce your score to one-third" },
    "Undo": { icon: "\u21A9\uFE0F", desc: "Undo the points that got you here" },
    "Go To Jail": { icon: "\u26D3\uFE0F", desc: "Trapped in Jail until you roll a pair" },
    "Go To The Bar": { icon: "\u{1F37A}", desc: "Enjoy drinks at The Bar until 15/31" },
    "Go To Timeout": { icon: "\u23F3", desc: "Forced to wait in Timeout for 3 turns" },
    "Roll The Dice": { icon: "\u{1F3B2}", desc: "Roll 3 dice for Direction, Pts & Target" },
    "Spin The Wheel": { icon: "\u{1F3A1}", desc: "Spin the wheel with 8 prize/penalty slots" }
  });
  var CLASH_DEFAULTS_4812 = Object.freeze({
    noPassingLaneStarts: [40, 175, 275, 415],
    jumpStarts: [25, 195, 295, 435, 75, 145, 245, 365],
    jumpDests: [60, 160, 335, 395, 110, 125, 280, 400],
    jailHoles: [110, 315],
    barHoles: [125, 375],
    timeoutHoles: [75, 255],
    detourHoles: [15, 235],
    roundAboutHoles: [145, 355],
    signsStarts: [90, 215, 450, 465],
    stopSignHoles: [35, 70, 105, 155, 205, 265, 345, 425],
    diceHoles: [50, 185, 285, 410],
    wheelHoles: [65, 160, 260, 385],
    optDetour1Hole: 15,
    optJump1Start: 25,
    optNoPassingLane1Start: 40,
    optJump1Dest: 60,
    optTimeout1Hole: 75,
    optSigns1Hole: 90,
    optJail1Hole: 110,
    optBar1Hole: 125,
    optRoundAbout1Hole: 145,
    optJump2Dest: 160,
    optNoPassingLane2Start: 175,
    optJump2Start: 195,
    optSigns2Hole: 215,
    optDetour2Hole: 235,
    optTimeout2Hole: 255,
    optNoPassingLane3Start: 275,
    optJump3Start: 295,
    optJail2Hole: 315,
    optJump3Dest: 335,
    optRoundAbout2Hole: 355,
    optBar2Hole: 375,
    optJump4Dest: 395,
    optNoPassingLane4Start: 415,
    optJump4Start: 435,
    optJump5Start: 75,
    optJump5Dest: 110,
    optJump6Start: 145,
    optJump6Dest: 125,
    optJump7Start: 245,
    optJump7Dest: 280,
    optJump8Start: 365,
    optJump8Dest: 400,
    optSigns3Hole: 450,
    optSigns4Hole: 465,
    optStopSign1Hole: 35,
    optStopSign2Hole: 70,
    optStopSign3Hole: 105,
    optStopSign4Hole: 155,
    optStopSign5Hole: 205,
    optStopSign6Hole: 265,
    optStopSign7Hole: 345,
    optStopSign8Hole: 425,
    optDice1Hole: 50,
    optDice2Hole: 185,
    optDice3Hole: 285,
    optDice4Hole: 410,
    optWheel1Hole: 65,
    optWheel2Hole: 160,
    optWheel3Hole: 260,
    optWheel4Hole: 385,
    optSkunkMarkerHole: 360,
    optDoubleSkunkMarkerHole: 240
  });
  var CLASH_DEFAULTS_2412 = Object.freeze({
    noPassingLaneStarts: [40, 95, 150, 195],
    jumpStarts: [25, 115, 145, 205, 55, 85, 135, 185],
    jumpDests: [60, 80, 185, 170, 75, 65, 160, 210],
    jailHoles: [70, 175],
    barHoles: [85, 190],
    timeoutHoles: [45, 140],
    detourHoles: [15, 125],
    roundAboutHoles: [65, 165],
    signsStarts: [50, 105, 155, 215],
    stopSignHoles: [25, 50, 75, 100, 125, 150, 175, 200],
    diceHoles: [30, 60, 130, 180],
    wheelHoles: [40, 80, 150, 200],
    optDetour1Hole: 15,
    optJump1Start: 25,
    optNoPassingLane1Start: 40,
    optJump1Dest: 60,
    optTimeout1Hole: 45,
    optSigns1Hole: 50,
    optJail1Hole: 70,
    optBar1Hole: 85,
    optRoundAbout1Hole: 65,
    optJump2Dest: 80,
    optNoPassingLane2Start: 95,
    optJump2Start: 115,
    optSigns2Hole: 105,
    optDetour2Hole: 125,
    optTimeout2Hole: 140,
    optNoPassingLane3Start: 150,
    optJump3Start: 145,
    optJail2Hole: 175,
    optJump3Dest: 185,
    optRoundAbout2Hole: 165,
    optBar2Hole: 190,
    optJump4Dest: 170,
    optNoPassingLane4Start: 195,
    optJump4Start: 205,
    optJump5Start: 55,
    optJump5Dest: 75,
    optJump6Start: 85,
    optJump6Dest: 65,
    optJump7Start: 135,
    optJump7Dest: 160,
    optJump8Start: 185,
    optJump8Dest: 210,
    optSigns3Hole: 155,
    optSigns4Hole: 215,
    optStopSign1Hole: 25,
    optStopSign2Hole: 50,
    optStopSign3Hole: 75,
    optStopSign4Hole: 100,
    optStopSign5Hole: 125,
    optStopSign6Hole: 150,
    optStopSign7Hole: 175,
    optStopSign8Hole: 200,
    optDice1Hole: 30,
    optDice2Hole: 60,
    optDice3Hole: 130,
    optDice4Hole: 180,
    optWheel1Hole: 40,
    optWheel2Hole: 80,
    optWheel3Hole: 150,
    optWheel4Hole: 200,
    optSkunkMarkerHole: 180,
    optDoubleSkunkMarkerHole: 120
  });
  var CLASH_DEFAULTS_3612 = Object.freeze({
    noPassingLaneStarts: [40, 135, 215, 315],
    jumpStarts: [25, 145, 225, 325, 65, 105, 185, 275],
    jumpDests: [60, 115, 260, 295, 85, 95, 210, 310],
    jailHoles: [90, 245],
    barHoles: [105, 285],
    timeoutHoles: [65, 195],
    detourHoles: [15, 175],
    roundAboutHoles: [115, 265],
    signsStarts: [70, 165, 255, 335],
    stopSignHoles: [30, 65, 105, 150, 195, 240, 285, 330],
    diceHoles: [50, 140, 230, 320],
    wheelHoles: [70, 160, 250, 330],
    optDetour1Hole: 15,
    optJump1Start: 25,
    optNoPassingLane1Start: 40,
    optJump1Dest: 60,
    optTimeout1Hole: 65,
    optSigns1Hole: 70,
    optJail1Hole: 90,
    optBar1Hole: 105,
    optRoundAbout1Hole: 115,
    optJump2Dest: 115,
    optNoPassingLane2Start: 135,
    optJump2Start: 145,
    optSigns2Hole: 165,
    optDetour2Hole: 175,
    optTimeout2Hole: 195,
    optNoPassingLane3Start: 215,
    optJump3Start: 225,
    optJail2Hole: 245,
    optJump3Dest: 260,
    optRoundAbout2Hole: 265,
    optBar2Hole: 285,
    optJump4Dest: 295,
    optNoPassingLane4Start: 315,
    optJump4Start: 325,
    optJump5Start: 65,
    optJump5Dest: 85,
    optJump6Start: 105,
    optJump6Dest: 95,
    optJump7Start: 185,
    optJump7Dest: 210,
    optJump8Start: 275,
    optJump8Dest: 310,
    optSigns3Hole: 255,
    optSigns4Hole: 335,
    optStopSign1Hole: 30,
    optStopSign2Hole: 65,
    optStopSign3Hole: 105,
    optStopSign4Hole: 150,
    optStopSign5Hole: 195,
    optStopSign6Hole: 240,
    optStopSign7Hole: 285,
    optStopSign8Hole: 330,
    optDice1Hole: 50,
    optDice2Hole: 140,
    optDice3Hole: 230,
    optDice4Hole: 320,
    optWheel1Hole: 70,
    optWheel2Hole: 160,
    optWheel3Hole: 250,
    optWheel4Hole: 330,
    optSkunkMarkerHole: 270,
    optDoubleSkunkMarkerHole: 180
  });
  function getClashDefaults2(target) {
    const t = Number(target) || 481;
    if (t === 241) return CLASH_DEFAULTS_2412;
    if (t === 361) return CLASH_DEFAULTS_3612;
    return CLASH_DEFAULTS_4812;
  }
  function getSkunkDefaults2(target) {
    const t = Number(target) || 481;
    const track = t - 1;
    return {
      skunkHole: Math.round(track * 0.75),
      doubleSkunkHole: Math.round(track * 0.5)
    };
  }
  var ClashManager = class _ClashManager {
    constructor(options = {}) {
      this.target = Number(options.target || 481);
      this.options = { ...options };
    }
    isClashMode(target = this.target) {
      return [241, 361, 481].includes(Number(target));
    }
    static getClashDefaults(target) {
      return getClashDefaults2(target);
    }
    getClashDefaults(target = this.target) {
      return getClashDefaults2(target);
    }
    static getSkunkDefaults(target) {
      return getSkunkDefaults2(target);
    }
    getSkunkDefaults(target = this.target) {
      return getSkunkDefaults2(target);
    }
    /**
     * Evaluates collision/overlap between candidate start/length and existing active obstacles.
     * @param {number} candidateStart
     * @param {number} length
     * @param {string|null} excludeSelectId
     * @param {Array} blockList
     * @returns {Object|null} The conflicting obstacle, or null if free
     */
    static checkCollision(candidateStart, length, excludeSelectId, blockList) {
      if (!Array.isArray(blockList)) return null;
      const cEnd = candidateStart + length - 1;
      for (const b of blockList) {
        if (b.selectId && excludeSelectId && b.selectId === excludeSelectId) continue;
        if (Math.max(candidateStart, b.start) <= Math.min(cEnd, b.end)) {
          return b;
        }
      }
      return null;
    }
    checkCollision(candidateStart, length, excludeSelectId, blockList) {
      return _ClashManager.checkCollision(candidateStart, length, excludeSelectId, blockList);
    }
    /**
     * Finds the nearest available non-colliding hole from a list of valid choices.
     * @param {Array<number>} options Available hole options
     * @param {number} currentVal Currently desired or selected value
     * @param {number} length Length of the obstacle
     * @param {string|null} excludeSelectId
     * @param {Array} activeBlocks
     * @returns {number}
     */
    static findAvailableHole(options, currentVal, length, excludeSelectId, activeBlocks) {
      if (!_ClashManager.checkCollision(currentVal, length, excludeSelectId, activeBlocks)) {
        return currentVal;
      }
      const validOptions = options.filter((h) => !_ClashManager.checkCollision(h, length, excludeSelectId, activeBlocks));
      if (validOptions.length > 0) {
        validOptions.sort((a, b) => Math.abs(a - currentVal) - Math.abs(b - currentVal));
        return validOptions[0];
      }
      return currentVal;
    }
    findAvailableHole(options, currentVal, length, excludeSelectId, activeBlocks) {
      return _ClashManager.findAvailableHole(options, currentVal, length, excludeSelectId, activeBlocks);
    }
    /**
     * Decides which sign an AI player picks from the remaining available signs.
     * @param {Array<string>} remainingSigns
     * @returns {string}
     */
    static pickCpuSign(remainingSigns) {
      if (!Array.isArray(remainingSigns) || remainingSigns.length === 0) return "Plus 5";
      for (const p of SIGN_PRIORITY) {
        if (remainingSigns.includes(p)) {
          return p;
        }
      }
      return remainingSigns[0];
    }
    pickCpuSign(remainingSigns) {
      return _ClashManager.pickCpuSign(remainingSigns);
    }
    /**
     * Evaluates the mathematical score delta or special action for a selected sign.
     * @param {string} signName
     * @param {number} currentScore
     * @param {number} lastDelta
     * @returns {{ type: 'score'|'action', delta?: number, action?: string }}
     */
    static evaluateSignEffect(signName, currentScore = 0, lastDelta = 2) {
      const cur = Math.max(0, parseInt(currentScore, 10) || 0);
      const delta = Math.abs(parseInt(lastDelta, 10) || 2);
      switch (signName) {
        case "Plus 5":
          return { type: "score", delta: 5 };
        case "Plus 10":
          return { type: "score", delta: 10 };
        case "Minus 5":
          return { type: "score", delta: -5 };
        case "Minus 10":
          return { type: "score", delta: -10 };
        case "Score Plus x2":
          return { type: "score", delta: cur };
        case "Score Plus x3":
          return { type: "score", delta: cur * 2 };
        case "Score Minus x2":
          return { type: "score", delta: -Math.floor(cur / 2) };
        case "Score Minus x3":
          return { type: "score", delta: -Math.floor(cur * 2 / 3) };
        case "Undo":
          return { type: "score", delta: -delta };
        case "Go To Jail":
          return { type: "action", action: "jail" };
        case "Go To The Bar":
          return { type: "action", action: "bar" };
        case "Go To Timeout":
          return { type: "action", action: "timeout" };
        case "Roll The Dice":
          return { type: "action", action: "dice" };
        case "Spin The Wheel":
          return { type: "action", action: "wheel" };
        default:
          return { type: "score", delta: 0 };
      }
    }
    evaluateSignEffect(signName, currentScore, lastDelta) {
      return _ClashManager.evaluateSignEffect(signName, currentScore, lastDelta);
    }
    /**
     * Resolves the result of a 3-die roll.
     * @param {string} dir '+' or '−'
     * @param {number} val Points (5, 10, 15, 20, 25, 30)
     * @param {string} target 'You' | 'Opponent' | 'You Pick'
     * @returns {{ points: number, target: string }}
     */
    static evaluateDiceRoll(dir, val, target) {
      const multiplier = dir === "\u2212" ? -1 : 1;
      const pts = Math.abs(parseInt(val, 10) || 5) * multiplier;
      return {
        points: pts,
        target: target || "You"
      };
    }
    /**
     * Resolves the outcome of spinning the wheel.
     * @param {number} slotIndex 0 to 7
     * @returns {string} One of WHEEL_SLOTS
     */
    static evaluateWheelSpin(slotIndex) {
      const idx = Math.max(0, Math.min(WHEEL_SLOTS.length - 1, parseInt(slotIndex, 10) || 0));
      return WHEEL_SLOTS[idx];
    }
  };

  // src/audio/AudioManager.js
  var AudioManager = class {
    constructor(options = {}) {
      this.on = true;
      this.ctx = null;
      this.storage = options.storage || null;
      if (typeof options.on === "boolean") {
        this.on = options.on;
      } else {
        const s = this.storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
        if (s) {
          try {
            this.on = s.getItem("crazyCribbage.sfx") !== "off";
          } catch (e) {
          }
        }
      }
    }
    /**
     * Lazily initializes or resumes the AudioContext upon user gesture.
     * @returns {AudioContext|null}
     */
    ensure() {
      if (!this.ctx && typeof window !== "undefined") {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        this.ctx = new AC();
      }
      if (this.ctx && this.ctx.state === "suspended") {
        this.ctx.resume().catch(() => {
        });
      }
      return this.ctx;
    }
    /**
     * Synthesizes an oscillator tone with envelope shaping and optional frequency slide.
     * @param {number} freq Frequency in Hz
     * @param {number} dur Duration in seconds
     * @param {OscillatorType} [type='triangle'] Waveform
     * @param {number} [gain=0.08] Peak gain
     * @param {number} [slide=null] Target slide frequency
     */
    tone(freq, dur, type = "triangle", gain = 0.08, slide = null) {
      if (!this.on) return;
      const ctx = this.ensure();
      if (!ctx) return;
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = type;
      o.frequency.setValueAtTime(freq, ctx.currentTime);
      if (slide) {
        o.frequency.exponentialRampToValueAtTime(Math.max(20, slide), ctx.currentTime + dur);
      }
      g.gain.setValueAtTime(gain, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(1e-3, ctx.currentTime + dur);
      o.connect(g);
      g.connect(ctx.destination);
      o.start();
      o.stop(ctx.currentTime + dur);
    }
    /**
     * Synthesizes shaped white noise with biquad filtering.
     * @param {number} dur Duration in seconds
     * @param {number} [gain=0.05] Peak gain
     * @param {number} [filterFreq=null] Cutoff frequency
     * @param {BiquadFilterType} [filterType='lowpass'] Filter mode
     */
    noise(dur, gain = 0.05, filterFreq = null, filterType = "lowpass") {
      if (!this.on) return;
      const ctx = this.ensure();
      if (!ctx) return;
      const bufferSize = Math.max(1, Math.floor(ctx.sampleRate * dur));
      const buf = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
      const data = buf.getChannelData(0);
      for (let i = 0; i < bufferSize; i++) {
        data[i] = (Math.random() * 2 - 1) * (1 - i / bufferSize);
      }
      const n = ctx.createBufferSource();
      n.buffer = buf;
      const g = ctx.createGain();
      g.gain.setValueAtTime(gain, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(1e-3, ctx.currentTime + dur);
      if (filterFreq) {
        const f = ctx.createBiquadFilter();
        f.type = filterType;
        f.frequency.value = filterFreq;
        n.connect(f);
        f.connect(g);
      } else {
        n.connect(g);
      }
      g.connect(ctx.destination);
      n.start();
    }
    /**
     * Crisp card snap / table drop sound.
     */
    snap() {
      this.noise(0.04, 0.06, 3200, "bandpass");
      this.tone(210, 0.05, "triangle", 0.04, 90);
    }
    /**
     * Real wooden peg "thunk" sound when pegs advance on the hardwood board.
     * Synthesizes an initial sharp wooden impact transient, followed by a resonant
     * body chamber decay and subtle hole air/friction pop.
     * @param {number} [pitchMod=1.0] Optional pitch multiplier
     */
    thunk(pitchMod = 1) {
      if (!this.on) return;
      const variance = Math.random() * 0.14 - 0.07;
      const mod = Math.max(0.65, Math.min(1.5, pitchMod + variance));
      const tapFreq = 1750 * mod;
      this.tone(tapFreq, 0.016, "triangle", 0.1, tapFreq * 0.48);
      const bodyFreq = 220 * mod;
      this.tone(bodyFreq, 0.065, "sine", 0.12, bodyFreq * 0.65);
      this.tone(bodyFreq * 1.5, 0.04, "triangle", 0.05, bodyFreq * 0.8);
      this.noise(0.018, 0.04, 750 * mod, "lowpass");
    }
    /**
     * Wooden peg insertion strike with micro-pitch randomization and resonant cavity.
     */
    peg() {
      this.thunk(1);
    }
    /**
     * Authentic micro-pitch wooden peg tactile clack sound for hole-by-hole movement.
     * @param {number} [pitchMod=1.0] Optional pitch multiplier
     */
    clack(pitchMod = 1) {
      this.thunk(pitchMod);
    }
    /**
     * Party popper pneumatic burst sound for confetti cannons.
     */
    confettiPop() {
      if (!this.on) return;
      this.tone(180, 0.06, "triangle", 0.12, 45);
      this.noise(0.08, 0.08, 1400, "lowpass");
      setTimeout(() => {
        this.noise(0.12, 0.04, 3400, "highpass");
      }, 25);
    }
    /**
     * Crisp whispering card stock friction slide on the deal.
     * Synthesizes card stock sliding across felt/wood with a frequency sweep
     * followed by light card contact.
     */
    cardSlide() {
      if (!this.on) return;
      const variance = Math.random() * 0.12 - 0.06;
      const slideFreq = 2700 * (1 + variance);
      this.noise(0.065, 0.045, slideFreq, "bandpass");
      setTimeout(() => {
        this.tone(190 * (1 + variance), 0.035, "triangle", 0.04, 95);
        this.noise(0.02, 0.03, 3400, "highpass");
      }, 38);
    }
    /**
     * Textured multi-card shuffle with realistic card interleaving flutter and bridge snap.
     */
    shuffle() {
      if (!this.on) return;
      this.noise(0.08, 0.04, 1400 + Math.random() * 900, "bandpass");
      const swishes = [60, 120, 185, 250, 315, 380];
      swishes.forEach((delay, i) => {
        setTimeout(() => {
          const freq = 1400 + Math.random() * 900;
          this.noise(0.08, 0.04 - (i + 1) * 3e-3, freq, "bandpass");
        }, delay);
      });
      for (let c = 0; c < 12; c++) {
        setTimeout(() => {
          this.noise(0.015, 0.025, 2600 + Math.random() * 1200, "highpass");
        }, 70 + c * 24);
      }
      setTimeout(() => {
        this.snap();
        this.tone(260, 0.06, "triangle", 0.05, 120);
      }, 440);
    }
    /**
     * Rapid riffle deal texture.
     */
    riffle() {
      if (!this.on) return;
      const taps = 8;
      for (let i = 0; i < taps; i++) {
        setTimeout(() => {
          this.noise(0.025, 0.03, 2400 + i * 150, "highpass");
        }, i * 28);
      }
    }
    /**
     * Grand fanfare for high-scoring hands (C major / G major arpeggio flourish).
     */
    fanfare20() {
      if (!this.on) return;
      const arpeggio = [
        { f: 523.25, d: 0.14, g: 0.09 },
        { f: 659.25, d: 0.14, g: 0.09 },
        { f: 783.99, d: 0.14, g: 0.1 },
        { f: 1046.5, d: 0.2, g: 0.12 },
        { f: 1318.51, d: 0.22, g: 0.12 },
        { f: 1567.98, d: 0.45, g: 0.14 }
      ];
      arpeggio.forEach((note, idx) => {
        setTimeout(() => {
          this.tone(note.f, note.d, "triangle", note.g);
          this.tone(note.f * 0.5, note.d * 0.8, "sine", note.g * 0.5);
        }, idx * 110);
      });
    }
    /**
     * Legendary fanfare for the Holy Grail 29-hand and championship victories.
     * Multi-octave royal brass & bell arpeggio with celebratory final chord.
     */
    fanfare29() {
      if (!this.on) return;
      const royalNotes = [
        { f: 523.25, d: 0.12, g: 0.1 },
        // C5
        { f: 659.25, d: 0.12, g: 0.1 },
        // E5
        { f: 783.99, d: 0.12, g: 0.11 },
        // G5
        { f: 1046.5, d: 0.16, g: 0.13 },
        // C6
        { f: 1318.51, d: 0.18, g: 0.13 },
        // E6
        { f: 1567.98, d: 0.22, g: 0.14 },
        // G6
        { f: 2093, d: 0.55, g: 0.15 }
        // C7
      ];
      royalNotes.forEach((note, idx) => {
        setTimeout(() => {
          this.tone(note.f, note.d, "triangle", note.g);
          this.tone(note.f * 0.5, note.d * 0.85, "sine", note.g * 0.6);
          this.tone(note.f * 1.5, note.d * 0.35, "sine", note.g * 0.3);
        }, idx * 95);
      });
      setTimeout(() => {
        this.tone(523.25, 0.9, "triangle", 0.1);
        this.tone(659.25, 0.9, "sine", 0.1);
        this.tone(783.99, 0.9, "triangle", 0.11);
        this.tone(1046.5, 0.95, "sine", 0.12);
        this.noise(0.4, 0.05, 3800, "bandpass");
      }, 720);
    }
    /**
     * Rewarding chime for trophy / achievement badge unlocks.
     */
    achievement() {
      if (!this.on) return;
      const notes = [
        { f: 587.33, d: 0.15, g: 0.11 },
        // D5
        { f: 739.99, d: 0.15, g: 0.12 },
        // F#5
        { f: 880, d: 0.18, g: 0.13 },
        // A5
        { f: 1174.66, d: 0.45, g: 0.15 }
        // D6
      ];
      notes.forEach((n, idx) => {
        setTimeout(() => {
          this.tone(n.f, n.d, "sine", n.g);
          this.tone(n.f * 2, n.d * 0.5, "triangle", n.g * 0.35);
        }, idx * 80);
      });
    }
    chime15() {
      this.tone(523, 0.18, "sine", 0.09);
      setTimeout(() => this.tone(659, 0.22, "sine", 0.08), 90);
    }
    bell31() {
      this.tone(784, 0.35, "sine", 0.1, 392);
      this.tone(1175, 0.12, "triangle", 0.05);
    }
    skunk() {
      this.tone(140, 0.55, "sawtooth", 0.07, 55);
      this.tone(90, 0.7, "sine", 0.05, 40);
    }
    /**
     * Playful glissando / slide whistle descent for Chutes and Ladders.
     */
    chutesAndLadders() {
      if (!this.on) return;
      this.ensure();
      const slides = [
        { f: 880, d: 0.22, end: 440 },
        { f: 620, d: 0.22, end: 260 },
        { f: 380, d: 0.35, end: 110 }
      ];
      slides.forEach((s, idx) => {
        setTimeout(() => {
          this.tone(s.f, s.d, "triangle", 0.09, s.end);
          this.tone(s.f * 1.5, s.d * 0.7, "sine", 0.05, s.end * 1.5);
        }, idx * 160);
      });
      setTimeout(() => {
        this.tone(110, 0.25, "sine", 0.12, 60);
      }, 520);
    }
    gameHole() {
      this.tone(160, 0.18, "sine", 0.1);
      this.tone(880, 0.08, "triangle", 0.06);
    }
    /**
     * Playful comic descending slide for 🦨 Skunked reaction.
     */
    reactionSkunk() {
      if (!this.on) return;
      this.tone(320, 0.45, "sawtooth", 0.09, 85);
      setTimeout(() => this.tone(210, 0.4, "sine", 0.08, 65), 100);
    }
    /**
     * Crisp celebratory glasses clink for 🍻 Cheers reaction.
     */
    reactionCheers() {
      if (!this.on) return;
      this.tone(2400, 0.35, "sine", 0.12);
      this.tone(3180, 0.28, "triangle", 0.08);
      setTimeout(() => {
        this.tone(2550, 0.32, "sine", 0.1);
        this.tone(3400, 0.22, "triangle", 0.07);
      }, 65);
    }
    /**
     * Dramatic gasp/surprise chord for 😱 No Way! reaction.
     */
    reactionNoWay() {
      if (!this.on) return;
      this.tone(440, 0.38, "sine", 0.11, 880);
      this.tone(660, 0.35, "triangle", 0.09, 1320);
      setTimeout(() => {
        this.tone(880, 0.3, "sine", 0.08, 1100);
      }, 70);
    }
    /**
     * Snappy crisp cribbage chime for 🃏 Nice 15 reaction.
     */
    reactionNice15() {
      if (!this.on) return;
      this.tone(1046.5, 0.18, "sine", 0.12);
      this.tone(2093, 0.12, "triangle", 0.06);
      setTimeout(() => {
        this.tone(1567.98, 0.25, "sine", 0.13);
        this.tone(3135.96, 0.15, "triangle", 0.07);
      }, 85);
    }
    /**
     * Punchy bass boom burst with high crackle for 💥 Boom! reaction.
     */
    reactionBoom() {
      if (!this.on) return;
      this.tone(120, 0.42, "sine", 0.22, 38);
      this.noise(0.25, 0.14, 2200, "lowpass");
      setTimeout(() => {
        this.tone(65, 0.35, "triangle", 0.15, 28);
      }, 45);
    }
    card() {
      this.cardSlide();
    }
    deal() {
      this.cardSlide();
    }
    /**
     * Sound bite: "Fifteen two, fifteen four, and the rest don't score!"
     * Playful rhythmic 4-note ascending cadence.
     */
    banterFifteenTwo() {
      if (!this.on) return;
      const notes = [
        { f: 523.25, d: 0.12, g: 0.11 },
        // 15
        { f: 659.25, d: 0.12, g: 0.11 },
        // 2
        { f: 783.99, d: 0.14, g: 0.12 },
        // 15
        { f: 1046.5, d: 0.28, g: 0.14 }
        // 4!
      ];
      notes.forEach((n, idx) => {
        setTimeout(() => {
          this.tone(n.f, n.d, "triangle", n.g);
          this.tone(n.f * 0.5, n.d * 0.8, "sine", n.g * 0.5);
        }, idx * 115);
      });
    }
    /**
     * Sound bite: "One for his nob!"
     * Snappy Jack chime with celebratory wood thunk.
     */
    banterNob() {
      if (!this.on) return;
      this.thunk(1.2);
      setTimeout(() => {
        this.tone(880, 0.14, "sine", 0.12);
        this.tone(1320, 0.22, "triangle", 0.1);
      }, 45);
    }
    /**
     * Sound bite: "Go!"
     * Urgent double-knock wood tap alert.
     */
    banterGo() {
      if (!this.on) return;
      this.thunk(1.1);
      setTimeout(() => this.thunk(1.25), 90);
    }
    /**
     * Sound bite: "Pair for two!"
     * Harmonic pair chime chord.
     */
    banterPair() {
      if (!this.on) return;
      this.tone(659.25, 0.22, "triangle", 0.1);
      this.tone(987.77, 0.24, "sine", 0.11);
      setTimeout(() => {
        this.tone(783.99, 0.28, "sine", 0.12);
        this.tone(1174.66, 0.32, "triangle", 0.08);
      }, 75);
    }
    /**
     * Sound bite: "Thirty-one for two!"
     * Regal milestone chime.
     */
    banterThirtyOne() {
      if (!this.on) return;
      this.bell31();
    }
    /**
     * Sound bite: "Two for his heels!"
     * Double wood tap and starter bell.
     */
    banterHeels() {
      if (!this.on) return;
      this.thunk(0.95);
      setTimeout(() => this.thunk(1.15), 85);
      setTimeout(() => this.chime15(), 170);
    }
    /**
     * Plays acoustic sound bite and optional synthesized speech if enabled.
     * @param {string} method Audio method name
     * @param {string} [spokenText] Speech text for browser speech synthesis
     */
    playBanterSound(method, spokenText = "") {
      if (!this.on) return;
      if (typeof this[method] === "function") {
        this[method]();
      }
      if (spokenText && typeof window !== "undefined" && "speechSynthesis" in window) {
        try {
          const utter = new SpeechSynthesisUtterance(spokenText);
          utter.rate = 1.05;
          utter.pitch = 1.05;
          utter.volume = 0.75;
          window.speechSynthesis.speak(utter);
        } catch (e) {
        }
      }
    }
    pop() {
      this.peg();
    }
    alarm(force = false) {
      if (!this.on && !force) return;
      const ctx = this.ensure();
      if (!ctx) return;
      const now = ctx.currentTime;
      for (let i = 0; i < 6; i++) {
        const t = now + i * 0.32;
        const o1 = ctx.createOscillator();
        const g1 = ctx.createGain();
        o1.type = "sawtooth";
        o1.frequency.setValueAtTime(880, t);
        g1.gain.setValueAtTime(0.22, t);
        g1.gain.exponentialRampToValueAtTime(1e-3, t + 0.13);
        o1.connect(g1);
        g1.connect(ctx.destination);
        o1.start(t);
        o1.stop(t + 0.13);
        const o2 = ctx.createOscillator();
        const g2 = ctx.createGain();
        o2.type = "square";
        o2.frequency.setValueAtTime(1175, t + 0.14);
        g2.gain.setValueAtTime(0.22, t + 0.14);
        g2.gain.exponentialRampToValueAtTime(1e-3, t + 0.28);
        o2.connect(g2);
        g2.connect(ctx.destination);
        o2.start(t + 0.14);
        o2.stop(t + 0.28);
      }
    }
    /**
     * Heavy metallic iron prison cell slam down sound with ringing dissonance.
     */
    jailClang() {
      if (!this.on) return;
      this.tone(90, 0.45, "sawtooth", 0.25, 30);
      this.noise(0.2, 0.18, 900, "lowpass");
      setTimeout(() => {
        this.tone(480, 0.6, "triangle", 0.14, 460);
        this.tone(720, 0.5, "sine", 0.12, 700);
        this.tone(1150, 0.35, "triangle", 0.08);
        this.noise(0.12, 0.06, 2400, "bandpass");
      }, 25);
    }
    /**
     * Snappy mechanical camera shutter click and flash capacitor pop.
     */
    cameraShutter() {
      if (!this.on) return;
      this.noise(0.025, 0.18, 3800, "highpass");
      this.tone(1200, 0.02, "triangle", 0.1);
      setTimeout(() => {
        this.noise(0.035, 0.22, 2800, "bandpass");
        this.tone(850, 0.03, "sine", 0.12);
      }, 45);
      setTimeout(() => {
        this.noise(0.015, 0.08, 4200, "highpass");
      }, 90);
    }
    /**
     * Wooden saloon swinging doors kick open with creaking hinges.
     */
    saloonDoorKick() {
      if (!this.on) return;
      this.tone(85, 0.28, "triangle", 0.24, 45);
      this.noise(0.12, 0.2, 1100, "bandpass");
      setTimeout(() => {
        this.tone(260, 0.35, "sawtooth", 0.12, 170);
        this.noise(0.08, 0.14, 1800, "bandpass");
      }, 40);
      setTimeout(() => {
        this.tone(120, 0.2, "triangle", 0.12, 70);
      }, 380);
    }
    /**
     * Heavy glass beer stein sliding across wooden bar counter.
     */
    barMugSlide() {
      if (!this.on) return;
      this.noise(0.55, 0.2, 1350, "bandpass");
      this.tone(145, 0.45, "sine", 0.12, 115);
    }
    /**
     * Resonant clink/bump of thick glass beer mug on counter or card.
     */
    glassClink() {
      if (!this.on) return;
      this.tone(1880, 0.4, "sine", 0.22);
      this.tone(2450, 0.35, "sine", 0.15);
      this.tone(950, 0.2, "triangle", 0.14, 400);
      this.noise(0.04, 0.12, 4500, "highpass");
    }
    /**
     * Rapid rhythmic beer gulping / drinking glug sounds.
     */
    beerGulp() {
      if (!this.on) return;
      const gulps = [
        { t: 0, f1: 190, f2: 270 },
        { t: 180, f1: 220, f2: 310 },
        { t: 360, f1: 250, f2: 350 },
        { t: 540, f1: 280, f2: 390 }
      ];
      gulps.forEach((g) => {
        setTimeout(() => {
          this.tone(g.f1, 0.12, "sine", 0.18, g.f2);
          this.tone(g.f1 * 0.5, 0.08, "triangle", 0.1);
        }, g.t);
      });
    }
    /**
     * Comical drunken upward pitch-swept hiccup.
     */
    drunkenHiccup() {
      if (!this.on) return;
      this.tone(340, 0.09, "sine", 0.25, 740);
      setTimeout(() => {
        this.tone(680, 0.06, "triangle", 0.15, 880);
      }, 20);
    }
    /**
     * Stumble and collapse face-first onto wooden bar stool thud.
     */
    stoolCollapseThud() {
      if (!this.on) return;
      this.noise(0.15, 0.22, 1400, "bandpass");
      this.tone(180, 0.2, "sawtooth", 0.15, 90);
      setTimeout(() => {
        this.tone(70, 0.45, "triangle", 0.32, 35);
        this.noise(0.22, 0.25, 800, "lowpass");
      }, 45);
    }
    /**
     * Crisp, playful popping sound for floating beer bubbles.
     */
    bubblePop() {
      if (!this.on) return;
      this.tone(1100, 0.035, "sine", 0.16, 1750);
    }
    /**
     * Heavy spoked iron/wooden wheels squeaking and rolling into position.
     */
    cannonRollWheel() {
      if (!this.on) return;
      this.noise(0.65, 0.16, 500, "lowpass");
      this.tone(90, 0.55, "triangle", 0.14, 75);
      setTimeout(() => this.tone(980, 0.08, "sine", 0.08, 1250), 120);
      setTimeout(() => this.tone(1120, 0.09, "sine", 0.07, 850), 340);
    }
    /**
     * Burning gunpowder fuse sizzling with bright sparks.
     */
    cannonFuseHiss() {
      if (!this.on) return;
      this.noise(1.1, 0.22, 3800, "highpass");
      [80, 220, 390, 580, 780, 960].forEach((d) => {
        setTimeout(() => {
          if (!this.on) return;
          this.tone(2200 + Math.random() * 800, 0.03, "sine", 0.14);
        }, d);
      });
    }
    /**
     * Massive concussive cartoon ACME cannon explosion blast.
     */
    cannonKaboom() {
      if (!this.on) return;
      this.noise(0.85, 0.45, 1200, "bandpass");
      this.tone(320, 0.15, "sawtooth", 0.45, 60);
      this.tone(95, 0.9, "triangle", 0.55, 28);
      setTimeout(() => {
        if (!this.on) return;
        this.noise(0.9, 0.32, 280, "lowpass");
        this.tone(55, 0.7, "sine", 0.4, 20);
      }, 60);
    }
    /**
     * Cartoon Doppler whistle of object streaking through the sky.
     */
    cannonFlightWhistle() {
      if (!this.on) return;
      this.tone(1450, 0.75, "sine", 0.22, 450);
      this.tone(725, 0.7, "triangle", 0.12, 225);
    }
    /**
     * Springy, punchy lawn-dart lawn/ground impact thud with vibrating boing.
     */
    lawnDartThud() {
      if (!this.on) return;
      this.noise(0.12, 0.38, 2200, "bandpass");
      this.tone(260, 0.18, "sawtooth", 0.35, 65);
      this.tone(68, 0.42, "triangle", 0.4, 30);
      setTimeout(() => {
        if (!this.on) return;
        this.tone(420, 0.35, "sine", 0.25, 210);
        this.tone(840, 0.25, "triangle", 0.15, 420);
      }, 40);
    }
    /**
     * Twinkling cartoon stars circling around the head of a stunned card.
     */
    dizzyStarsChime() {
      if (!this.on) return;
      const starNotes = [1318.51, 1567.98, 1760, 2093, 2349.32, 2637.02];
      starNotes.forEach((f, idx) => {
        setTimeout(() => {
          if (!this.on) return;
          this.tone(f, 0.22, "sine", 0.15);
          this.tone(f * 2, 0.14, "triangle", 0.08);
        }, idx * 110);
      });
    }
    /**
     * Oscillating two-tone police cruiser emergency siren wail.
     */
    policeSirenWail() {
      if (!this.on) return;
      const sirenFrequencies = [640, 920, 640, 920, 640, 920];
      sirenFrequencies.forEach((f, idx) => {
        setTimeout(() => {
          if (!this.on) return;
          const target = sirenFrequencies[Math.min(idx + 1, sirenFrequencies.length - 1)];
          this.tone(f, 0.28, "sawtooth", 0.22, target);
          this.tone(f * 0.5, 0.25, "triangle", 0.15, target * 0.5);
        }, idx * 220);
      });
    }
    /**
     * Revving motorcycle engine followed by high-pitched tire skid screech.
     */
    motorcycleRev() {
      if (!this.on) return;
      this.tone(90, 0.35, "sawtooth", 0.28, 220);
      this.noise(0.3, 0.15, 800, "lowpass");
      setTimeout(() => {
        if (!this.on) return;
        this.tone(180, 0.3, "sawtooth", 0.32, 280);
        setTimeout(() => {
          if (!this.on) return;
          this.noise(0.45, 0.3, 3600, "bandpass");
          this.tone(1450, 0.35, "sine", 0.18, 980);
        }, 150);
      }, 200);
    }
    /**
     * Piercing police referee whistle with rapid flutter vibrato.
     */
    policeWhistle() {
      if (!this.on) return;
      const chirps = [
        { t: 0, dur: 0.18 },
        { t: 220, dur: 0.35 }
      ];
      chirps.forEach((c) => {
        setTimeout(() => {
          if (!this.on) return;
          this.tone(2620, c.dur, "sine", 0.28, 2750);
          this.tone(2950, c.dur, "triangle", 0.22, 3080);
          this.noise(c.dur, 0.14, 5200, "bandpass");
        }, c.t);
      });
    }
    /**
     * Crisp, loud paper citation slap onto card face with cartoon impact thud.
     */
    ticketSlap() {
      if (!this.on) return;
      this.noise(0.08, 0.42, 4200, "highpass");
      this.tone(580, 0.08, "sawtooth", 0.38, 140);
      setTimeout(() => {
        if (!this.on) return;
        this.tone(120, 0.22, "triangle", 0.35, 45);
        this.noise(0.12, 0.25, 950, "lowpass");
      }, 20);
    }
    /**
     * Futuristic GPS prompt chime followed by static recalculating glitch.
     */
    gpsChimeRecalculate() {
      if (!this.on) return;
      const notes = [659.25, 830.61, 987.77];
      notes.forEach((f, idx) => {
        setTimeout(() => {
          if (!this.on) return;
          this.tone(f, 0.12, "sine", 0.25);
        }, idx * 110);
      });
      setTimeout(() => {
        if (!this.on) return;
        this.tone(740, 0.18, "sawtooth", 0.18, 480);
        this.noise(0.15, 0.12, 2800, "bandpass");
      }, 380);
    }
    /**
     * Whirling rotary whoosh, tire squeal, and comical dizzy carnival slide whistle.
     */
    rotarySpin() {
      if (!this.on) return;
      this.tone(140, 0.45, "sawtooth", 0.22, 280);
      setTimeout(() => {
        if (!this.on) return;
        this.tone(280, 0.45, "sawtooth", 0.24, 160);
        this.noise(0.35, 0.26, 3400, "bandpass");
        this.tone(1350, 0.3, "sine", 0.16, 920);
      }, 400);
      setTimeout(() => {
        if (!this.on) return;
        this.tone(880, 0.4, "sine", 0.2, 1760);
      }, 800);
    }
    /**
     * Bumpy dirt road suspension rattle, wooden plank clatter, and vintage ahooga horn.
     */
    bumpyDetourRattle() {
      if (!this.on) return;
      const bumps = [0, 80, 160, 240, 320, 420];
      bumps.forEach((t) => {
        setTimeout(() => {
          if (!this.on) return;
          this.tone(90 + Math.random() * 40, 0.08, "triangle", 0.28, 45);
          this.noise(0.06, 0.18, 1200, "lowpass");
        }, t);
      });
      setTimeout(() => {
        if (!this.on) return;
        this.tone(220, 0.14, "sawtooth", 0.32, 440);
        setTimeout(() => {
          if (!this.on) return;
          this.tone(440, 0.22, "sawtooth", 0.35, 415);
          setTimeout(() => {
            if (!this.on) return;
            this.tone(370, 0.18, "sawtooth", 0.3, 196);
          }, 200);
        }, 130);
      }, 550);
    }
    /**
     * Dramatic brassy fanfare when a Spade is cut in Spades mode.
     */
    spades() {
      if (!this.on) return;
      this.tone(293.66, 0.18, "sawtooth", 0.22);
      setTimeout(() => {
        if (!this.on) return;
        this.tone(369.99, 0.18, "sawtooth", 0.24);
      }, 120);
      setTimeout(() => {
        if (!this.on) return;
        this.tone(440, 0.22, "sawtooth", 0.26);
      }, 240);
      setTimeout(() => {
        if (!this.on) return;
        this.tone(587.33, 0.45, "sawtooth", 0.32);
        this.tone(880, 0.4, "triangle", 0.18);
      }, 380);
    }
    setOn(enabled) {
      const s = this.storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
      if (s) {
        try {
          s.setItem("crazyCribbage.sfx", this.on ? "on" : "off");
        } catch (e) {
        }
      }
    }
    toggle() {
      this.setOn(!this.on);
      return this.on;
    }
  };

  // src/net/CameraManager.js
  function getStorage5() {
    return typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
  }
  var CameraManager2 = class _CameraManager {
    constructor() {
      this.localStream = null;
      this.isBroadcasting = false;
      this.isPaused = false;
      this.isLocalMinimized = false;
      this.activeCalls = /* @__PURE__ */ new Map();
      this.remoteStreams = /* @__PURE__ */ new Map();
      this.hiddenSeats = /* @__PURE__ */ new Set();
      this.minimizedSeats = this.hiddenSeats;
    }
    /**
     * Returns singleton instance on window if available.
     */
    static getInstance() {
      if (typeof window !== "undefined") {
        if (!window._ccCameraManager) {
          window._ccCameraManager = new _CameraManager();
        }
        return window._ccCameraManager;
      }
      if (!_CameraManager._instance) {
        _CameraManager._instance = new _CameraManager();
      }
      return _CameraManager._instance;
    }
    /**
     * Checks if camera media devices are supported in current environment.
     * @returns {boolean}
     */
    static isSupported() {
      return typeof navigator !== "undefined" && !!navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === "function";
    }
    /**
     * Starts broadcasting local webcam to all connected online peers.
     * @param {Object} [context]
     * @returns {Promise<MediaStream|null>}
     */
    async startBroadcast(context = {}) {
      if (!_CameraManager.isSupported()) {
        const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
        });
        setStatus2("Camera access is not supported by this browser.");
        return null;
      }
      if (this.isBroadcasting && this.localStream) {
        if (this.isPaused) {
          return this.resumeBroadcast(context);
        }
        return this.localStream;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 480, max: 640 },
            height: { ideal: 360, max: 480 },
            facingMode: "user"
          },
          audio: false
        });
        this.localStream = stream;
        this.isBroadcasting = true;
        this.isPaused = false;
        stream.getVideoTracks().forEach((track) => {
          track.onended = () => {
            this.stopBroadcast(context);
          };
        });
        this.renderLocalPreview(context);
        this.callAllConnectedPeers(context);
        this.broadcastCamState(true, false, context);
        this.updateCamButtonUi(context);
        return stream;
      } catch (err) {
        console.warn("CameraManager.startBroadcast error:", err);
        const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
        });
        if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
          setStatus2("Camera permission was denied. Please allow camera access in your browser.");
        } else if (err.name === "NotFoundError" || err.name === "DevicesNotFoundError") {
          setStatus2("No camera device was detected on your system.");
        } else {
          setStatus2("Unable to start camera: " + (err.message || err.name || "unknown error"));
        }
        return null;
      }
    }
    /**
     * Pauses or unpauses the local video broadcast without dropping the peer connection.
     * @param {Object} [context]
     * @returns {boolean} New paused state
     */
    pauseBroadcast(context = {}) {
      if (!this.localStream || !this.isBroadcasting) return false;
      this.isPaused = !this.isPaused;
      const tracks = this.localStream.getVideoTracks();
      tracks.forEach((track) => {
        track.enabled = !this.isPaused;
      });
      this.broadcastCamState(true, this.isPaused, context);
      this.renderLocalPreview(context);
      this.updateCamButtonUi(context);
      return this.isPaused;
    }
    /**
     * Resumes broadcasting if currently paused.
     * @param {Object} [context]
     * @returns {MediaStream|null}
     */
    resumeBroadcast(context = {}) {
      if (this.isPaused) {
        this.pauseBroadcast(context);
      }
      return this.localStream;
    }
    /**
     * Completely stops local camera broadcast and closes all media calls.
     * @param {Object} [context]
     */
    stopBroadcast(context = {}) {
      if (this.localStream) {
        try {
          this.localStream.getTracks().forEach((track) => {
            try {
              track.stop();
            } catch (e) {
            }
          });
        } catch (e) {
        }
        this.localStream = null;
      }
      this.isBroadcasting = false;
      this.isPaused = false;
      for (const [peerId, call] of this.activeCalls.entries()) {
        try {
          call.close();
        } catch (e) {
        }
      }
      this.activeCalls.clear();
      this.broadcastCamState(false, false, context);
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (doc) {
        const localBox = doc.getElementById("localCamPreviewWrap");
        if (localBox) localBox.remove();
      }
      this.updateCamButtonUi(context);
    }
    /**
     * Makes outgoing PeerJS media calls to all known connected remote peers.
     * @param {Object} [context]
     */
    callAllConnectedPeers(context = {}) {
      if (!this.localStream || !this.isBroadcasting) return;
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2 || !net2.peer) return;
      if (net2.isHost && net2.clients) {
        for (const [peerId, client] of net2.clients.entries()) {
          this.callPeer(peerId, client.seatId, context);
        }
      } else if (!net2.isHost && net2.room) {
        const hostPeerId = "ccb-" + net2.room.trim().toUpperCase();
        this.callPeer(hostPeerId, "p1", context);
      }
    }
    /**
     * Calls an individual remote peer with our local camera stream.
     * @param {string} remotePeerId
     * @param {string} [remoteSeatId]
     * @param {Object} [context]
     */
    callPeer(remotePeerId, remoteSeatId = null, context = {}) {
      if (!remotePeerId || !this.localStream || !this.isBroadcasting) return;
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2 || !net2.peer || net2.peer.destroyed) return;
      const existingCall = this.activeCalls.get(remotePeerId);
      if (existingCall) {
        if (existingCall.open) return;
        try {
          existingCall.close();
        } catch (e) {
        }
        this.activeCalls.delete(remotePeerId);
      }
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const s = getStorage5();
      const myName = doc && doc.getElementById("optPlayerName") && doc.getElementById("optPlayerName").value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : "") || (net2.isHost ? "Host" : "Guest");
      const mySeatId = net2 && net2.mySeatId || (net2.isHost ? "p1" : "p2");
      try {
        const call = net2.peer.call(remotePeerId, this.localStream, {
          metadata: {
            seatId: mySeatId,
            name: myName
          }
        });
        if (!call) return;
        this.activeCalls.set(remotePeerId, call);
        this.bindCallEvents(call, remoteSeatId, context, myName);
      } catch (e) {
        console.warn("[CameraManager] callPeer error to", remotePeerId, e);
      }
    }
    /**
     * Handles an incoming PeerJS media call from a remote peer.
     * @param {Object} call
     * @param {Object} [context]
     */
    handleIncomingCall(call, context = {}) {
      if (!call) return;
      const remotePeerId = call.peer;
      this.activeCalls.set(remotePeerId, call);
      const meta = call.metadata || {};
      let remoteSeatId = meta.seatId || null;
      let remoteName = meta.name || null;
      try {
        if (this.localStream && this.isBroadcasting) {
          call.answer(this.localStream);
        } else {
          call.answer();
        }
      } catch (e) {
        console.warn("[CameraManager] call.answer error:", e);
      }
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!remoteSeatId && net2) {
        if (net2.isHost && net2.clients && net2.clients.get(remotePeerId)) {
          remoteSeatId = net2.clients.get(remotePeerId).seatId;
          if (!remoteName) remoteName = net2.clients.get(remotePeerId).name;
        } else if (!net2.isHost) {
          remoteSeatId = "p1";
        }
      }
      this.bindCallEvents(call, remoteSeatId, context, remoteName);
    }
    /**
     * Binds stream, close, and error events to a PeerJS MediaConnection.
     * @param {Object} call
     * @param {string} [targetSeatId]
     * @param {Object} [context]
     * @param {string} [initialName]
     */
    bindCallEvents(call, targetSeatId = null, context = {}, initialName = null) {
      const remotePeerId = call.peer;
      call.on("stream", (remoteStream) => {
        console.log("[CameraManager] Remote stream arrived from", remotePeerId, remoteStream);
        const meta = call.metadata || {};
        const resolvedSeatId = targetSeatId || meta.seatId || this.resolveSeatIdForPeer(remotePeerId, context) || "p2";
        const resolvedName = initialName || meta.name || this.resolveNameForSeat(resolvedSeatId, context);
        this.remoteStreams.set(resolvedSeatId, {
          stream: remoteStream,
          peerId: remotePeerId,
          name: resolvedName,
          paused: false
        });
        this.renderRemoteTile(resolvedSeatId, remoteStream, resolvedName, false, context);
      });
      call.on("close", () => {
        this.activeCalls.delete(remotePeerId);
        const sId = targetSeatId || this.resolveSeatIdForPeer(remotePeerId, context);
        if (sId) {
          this.remoteStreams.delete(sId);
          this.removeRemoteTile(sId, context);
        }
      });
      call.on("error", (err) => {
        console.warn("Call error from", remotePeerId, err);
        this.activeCalls.delete(remotePeerId);
      });
    }
    /**
     * Handles peer network data message for camera state updates ({ type: 'cam_state' }).
     * @param {Object} msg
     * @param {Object} [context]
     */
    handleCamStateMessage(msg, context = {}) {
      if (!msg || msg.type !== "cam_state") return;
      const seatId = msg.seatId || this.resolveSeatIdForPeer(msg.peerId, context) || "p2";
      const active2 = msg.active !== false;
      const paused = Boolean(msg.paused);
      const existing = this.remoteStreams.get(seatId);
      if (existing) {
        existing.paused = paused;
      }
      if (!active2) {
        this.remoteStreams.delete(seatId);
        this.removeRemoteTile(seatId, context);
      } else {
        const name = msg.name || this.resolveNameForSeat(seatId, context);
        const stream = existing ? existing.stream : null;
        if (stream) {
          this.renderRemoteTile(seatId, stream, name, paused, context);
        }
      }
    }
    /**
     * Broadcasts our current camera state (active/paused) to all connected peers.
     * @param {boolean} active
     * @param {boolean} paused
     * @param {Object} [context]
     */
    broadcastCamState(active2, paused, context = {}) {
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2) return;
      const mySeat3 = context.mySeat || (typeof window !== "undefined" && window.mySeat ? window.mySeat : () => "p1");
      const mySeatId = net2 && net2.mySeatId || mySeat3();
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const s = getStorage5();
      const myName = doc && doc.getElementById("optPlayerName") && doc.getElementById("optPlayerName").value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : "") || "Player";
      const payload = {
        type: "cam_state",
        active: active2,
        paused,
        seatId: mySeatId,
        peerId: net2.peer ? net2.peer.id : "",
        name: myName
      };
      if (net2.isHost && net2.clients) {
        for (const client of net2.clients.values()) {
          if (client.conn && client.conn.open !== false) {
            try {
              client.conn.send(payload);
            } catch (e) {
            }
          }
        }
      } else if (!net2.isHost && net2.conn && net2.conn.open !== false) {
        try {
          net2.conn.send(payload);
        } catch (e) {
        }
      }
    }
    /**
     * Toggles hiding/showing a specific opponent's camera on our local screen.
     * @param {string} seatId
     * @param {Object} [context]
     * @returns {boolean} New minimized/hidden state
     */
    toggleHideRemoteCam(seatId, context = {}) {
      if (this.hiddenSeats.has(seatId)) {
        this.hiddenSeats.delete(seatId);
      } else {
        this.hiddenSeats.add(seatId);
      }
      const isMinimized = this.hiddenSeats.has(seatId);
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (doc) {
        const tile = doc.getElementById(`remoteCamTile_${seatId}`);
        if (tile) {
          tile.classList.toggle("is-hidden", isMinimized);
          tile.classList.toggle("is-minimized", isMinimized);
          const toggleBtn = tile.querySelector(".btn-cam-hide-toggle");
          const videoEl = tile.querySelector("video");
          if (toggleBtn) {
            toggleBtn.textContent = isMinimized ? "\u25B2 Expand" : "\u25BC Minimize";
            toggleBtn.title = isMinimized ? "Expand camera" : "Minimize camera";
          }
          if (videoEl) {
            videoEl.style.display = isMinimized ? "none" : "block";
          }
          const videoWrap = tile.querySelector(".cam-video-wrap");
          if (videoWrap) {
            videoWrap.style.display = isMinimized ? "none" : "block";
          }
          const resizeHandle = tile.querySelector(".cam-resize-handle");
          if (resizeHandle) {
            resizeHandle.style.display = isMinimized ? "none" : "flex";
          }
        }
      }
      return isMinimized;
    }
    /**
     * Toggles minimizing or expanding an individual remote opponent's camera tile.
     * @param {string} seatId
     * @param {Object} [context]
     * @returns {boolean} New minimized state
     */
    toggleMinimizeRemoteCam(seatId, context = {}) {
      return this.toggleHideRemoteCam(seatId, context);
    }
    /**
     * Toggles minimizing or expanding any camera on screen (local preview or remote opponent).
     * @param {string} [seatId] 'local' (default) or opponent seatId ('p1', 'p2', etc.)
     * @param {Object} [context]
     * @returns {boolean} New minimized state
     */
    toggleMinimizeCam(seatId = "local", context = {}) {
      if (!seatId || seatId === "local") {
        return this.toggleMinimizeLocalCam(context);
      }
      return this.toggleMinimizeRemoteCam(seatId, context);
    }
    /**
     * Minimizes or expands all active cameras (local and remote).
     * @param {boolean} [minimize] Force state; if omitted toggles based on whether all are minimized.
     * @param {Object} [context]
     * @returns {boolean} Whether all cameras are now minimized
     */
    toggleMinimizeAll(minimize = void 0, context = {}) {
      const shouldMinimize = minimize !== void 0 ? minimize : !this.areAllMinimized();
      if (this.localStream && this.isLocalMinimized !== shouldMinimize) {
        this.toggleMinimizeLocalCam(context);
      }
      for (const seatId of this.remoteStreams.keys()) {
        const isMin = this.hiddenSeats.has(seatId);
        if (isMin !== shouldMinimize) {
          this.toggleHideRemoteCam(seatId, context);
        }
      }
      return shouldMinimize;
    }
    /**
     * Checks whether all active cameras (local and remote) are currently minimized.
     * @returns {boolean}
     */
    areAllMinimized() {
      if (this.localStream && !this.isLocalMinimized) return false;
      for (const seatId of this.remoteStreams.keys()) {
        if (!this.hiddenSeats.has(seatId)) return false;
      }
      return true;
    }
    /**
     * Toggles minimizing or expanding the local player's camera preview window.
     * When minimized, hides the video feed and resize handle while keeping
     * the pause and turn off controls visible.
     * @param {Object} [context]
     * @returns {boolean} New minimized state
     */
    toggleMinimizeLocalCam(context = {}) {
      this.isLocalMinimized = !this.isLocalMinimized;
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (doc) {
        const localWrap = doc.getElementById("localCamPreviewWrap");
        if (localWrap) {
          localWrap.classList.toggle("is-minimized", this.isLocalMinimized);
          const toggleBtn = localWrap.querySelector(".btn-cam-minimize-local");
          if (toggleBtn) {
            toggleBtn.textContent = this.isLocalMinimized ? "\u25B2 Expand" : "\u25BC Minimize";
            toggleBtn.title = this.isLocalMinimized ? "Expand camera preview" : "Minimize camera preview";
          }
          const videoWrap = localWrap.querySelector(".cam-video-wrap");
          if (videoWrap) {
            videoWrap.style.display = this.isLocalMinimized ? "none" : "block";
          }
          const resizeHandle = localWrap.querySelector(".cam-resize-handle");
          if (resizeHandle) {
            resizeHandle.style.display = this.isLocalMinimized ? "none" : "flex";
          }
        }
      }
      return this.isLocalMinimized;
    }
    /**
     * Safely attaches and autoplays a MediaStream on a video element with full
     * browser autoplay policy compliance (muted, playsinline, loadedmetadata hooks).
     * @param {HTMLVideoElement} videoEl
     * @param {MediaStream} stream
     * @param {Object} [doc]
     */
    _attachStreamToVideo(videoEl, stream, doc = null) {
      if (!videoEl || !stream) return;
      videoEl.muted = true;
      videoEl.defaultMuted = true;
      videoEl.playsInline = true;
      if (typeof videoEl.setAttribute === "function") {
        videoEl.setAttribute("muted", "");
        videoEl.setAttribute("playsinline", "");
        videoEl.setAttribute("autoplay", "");
      }
      if (videoEl.classList && typeof videoEl.classList.add === "function") {
        videoEl.classList.add("cam-video");
      }
      if (videoEl.srcObject !== stream) {
        videoEl.srcObject = stream;
      }
      const removePlayOverlay = () => {
        if (videoEl.parentElement) {
          const overlay = videoEl.parentElement.querySelector(".cam-click-to-play");
          if (overlay) overlay.remove();
        }
      };
      const showPlayOverlay = () => {
        if (!doc || !videoEl.parentElement) return;
        if (videoEl.parentElement.querySelector(".cam-click-to-play")) return;
        const btn = doc.createElement("button");
        btn.type = "button";
        btn.className = "cam-click-to-play";
        btn.innerHTML = "\u25B6 Click to Play";
        btn.title = "Click to start video stream";
        btn.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          videoEl.muted = true;
          videoEl.play().then(removePlayOverlay).catch((err) => console.warn("User play failed:", err));
        };
        videoEl.parentElement.appendChild(btn);
      };
      const attemptPlay = () => {
        try {
          const p = videoEl.play();
          if (p && typeof p.then === "function") {
            p.then(removePlayOverlay).catch((err) => {
              console.warn("[CameraManager] Autoplay prevented, showing play button:", err);
              showPlayOverlay();
            });
          }
        } catch (e) {
          console.warn("[CameraManager] Play call error:", e);
          showPlayOverlay();
        }
      };
      videoEl.onloadedmetadata = () => attemptPlay();
      videoEl.oncanplay = () => attemptPlay();
      attemptPlay();
      if (stream && typeof stream.getVideoTracks === "function") {
        stream.getVideoTracks().forEach((track) => {
          track.onunmute = () => {
            attemptPlay();
          };
        });
      }
    }
    /**
     * Renders the local player's selfie PiP camera preview card in #youZone.
     * @param {Object} [context]
     */
    renderLocalPreview(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc || !this.localStream) return;
      let localWrap = doc.getElementById("localCamPreviewWrap");
      const s = getStorage5();
      const myName = doc.getElementById("optPlayerName") && doc.getElementById("optPlayerName").value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : "") || "You";
      if (!localWrap) {
        const targetParent = doc.getElementById("localCamContainer") || doc.getElementById("youZone");
        if (!targetParent) return;
        localWrap = doc.createElement("div");
        localWrap.id = "localCamPreviewWrap";
        localWrap.className = `cam-tile cam-tile-local ${this.isLocalMinimized ? "is-minimized" : ""}`;
        localWrap.innerHTML = `
        <div class="cam-header">
          <span class="cam-name">\u{1F4F9} ${myName} (You)</span>
          <div class="cam-header-right">
            <span class="cam-badge ${this.isPaused ? "cam-badge-paused" : "cam-badge-live"}">
              ${this.isPaused ? "\u23F8\uFE0F Paused" : "\u25CF Live"}
            </span>
            <button type="button" class="btn-cam-hide-toggle btn-cam-minimize-local" title="${this.isLocalMinimized ? "Expand camera preview" : "Minimize camera preview"}">
              ${this.isLocalMinimized ? "\u25B2 Expand" : "\u25BC Minimize"}
            </button>
          </div>
        </div>
        <div class="cam-video-wrap" style="display: ${this.isLocalMinimized ? "none" : "block"};">
          <video id="localCamVideo" class="cam-video cam-video-mirrored" autoplay playsinline muted></video>
          <div class="cam-paused-overlay" style="display: ${this.isPaused ? "flex" : "none"};"><span>\u23F8\uFE0F Camera Paused</span></div>
        </div>
        <div class="cam-actions">
          <button type="button" class="btn-cam-action ${this.isPaused ? "btn-cam-resume" : "btn-cam-pause"}" id="btnLocalCamPause">
            ${this.isPaused ? "\u25B6 Resume" : "\u23F8 Pause"}
          </button>
          <button type="button" class="btn-cam-action btn-cam-off" id="btnLocalCamOff">
            \u2715 Turn Off
          </button>
        </div>
      `;
        targetParent.prepend(localWrap);
        const btnMinimize = localWrap.querySelector(".btn-cam-minimize-local");
        if (btnMinimize) {
          btnMinimize.onclick = (e) => {
            e.preventDefault();
            this.toggleMinimizeLocalCam(context);
          };
        }
        const btnPause = localWrap.querySelector("#btnLocalCamPause");
        const btnOff = localWrap.querySelector("#btnLocalCamOff");
        if (btnPause) {
          btnPause.onclick = (e) => {
            e.preventDefault();
            if (this.isPaused) {
              this.resumeBroadcast(context);
            } else {
              this.pauseBroadcast(context);
            }
          };
        }
        if (btnOff) {
          btnOff.onclick = (e) => {
            e.preventDefault();
            this.stopBroadcast(context);
          };
        }
      } else {
        localWrap.classList.toggle("is-minimized", this.isLocalMinimized);
        const nameEl = localWrap.querySelector(".cam-name");
        if (nameEl) nameEl.textContent = `\u{1F4F9} ${myName} (You)`;
        const badgeEl = localWrap.querySelector(".cam-badge");
        if (badgeEl) {
          badgeEl.className = `cam-badge ${this.isPaused ? "cam-badge-paused" : "cam-badge-live"}`;
          badgeEl.textContent = this.isPaused ? "\u23F8\uFE0F Paused" : "\u25CF Live";
        }
        const toggleBtn = localWrap.querySelector(".btn-cam-minimize-local");
        if (toggleBtn) {
          toggleBtn.textContent = this.isLocalMinimized ? "\u25B2 Expand" : "\u25BC Minimize";
          toggleBtn.title = this.isLocalMinimized ? "Expand camera preview" : "Minimize camera preview";
        }
        const overlay = localWrap.querySelector(".cam-paused-overlay");
        if (overlay) overlay.style.display = this.isPaused ? "flex" : "none";
        const videoWrap = localWrap.querySelector(".cam-video-wrap");
        if (videoWrap) {
          videoWrap.style.display = this.isLocalMinimized ? "none" : "block";
        }
        const btnPause = localWrap.querySelector("#btnLocalCamPause");
        if (btnPause) {
          btnPause.className = `btn-cam-action ${this.isPaused ? "btn-cam-resume" : "btn-cam-pause"}`;
          btnPause.textContent = this.isPaused ? "\u25B6 Resume" : "\u23F8 Pause";
        }
        const resizeHandle = localWrap.querySelector(".cam-resize-handle");
        if (resizeHandle) {
          resizeHandle.style.display = this.isLocalMinimized ? "none" : "flex";
        }
      }
      const videoEl = localWrap.querySelector("#localCamVideo");
      if (videoEl && this.localStream) {
        this._attachStreamToVideo(videoEl, this.localStream, doc);
      }
      this.makeTileResizable(localWrap, 180, context);
      if (this.isLocalMinimized) {
        const resizeHandle = localWrap.querySelector(".cam-resize-handle");
        if (resizeHandle) resizeHandle.style.display = "none";
      }
    }
    /**
     * Renders or updates a remote opponent's video tile on the game table.
     * @param {string} seatId
     * @param {MediaStream} stream
     * @param {string} name
     * @param {boolean} paused
     * @param {Object} [context]
     */
    renderRemoteTile(seatId, stream, name, paused = false, context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      let container = doc.getElementById("remoteCamsContainer");
      if (!container) {
        const oppWrapper = doc.getElementById("opponentsWrapper");
        const tableRight = doc.getElementById("tableRight");
        const targetParent = oppWrapper || tableRight;
        if (!targetParent) return;
        container = doc.createElement("div");
        container.id = "remoteCamsContainer";
        container.className = "remote-cams-container";
        targetParent.prepend(container);
      }
      let tile = doc.getElementById(`remoteCamTile_${seatId}`);
      const isMinimized = this.hiddenSeats.has(seatId);
      if (!tile) {
        tile = doc.createElement("div");
        tile.id = `remoteCamTile_${seatId}`;
        tile.dataset.seat = seatId;
        tile.className = `cam-tile cam-tile-remote ${isMinimized ? "is-minimized is-hidden" : ""}`;
        tile.innerHTML = `
        <div class="cam-header">
          <span class="cam-name">\u{1F4F9} ${name || "Opponent"}</span>
          <div class="cam-header-right">
            <span class="cam-badge ${paused ? "cam-badge-paused" : "cam-badge-live"}">
              ${paused ? "\u23F8\uFE0F Paused" : "\u25CF Live"}
            </span>
            <button type="button" class="btn-cam-hide-toggle btn-cam-minimize btn-cam-minimize-remote" title="${isMinimized ? "Expand camera" : "Minimize camera"}">
              ${isMinimized ? "\u25B2 Expand" : "\u25BC Minimize"}
            </button>
          </div>
        </div>
        <div class="cam-video-wrap" style="display: ${isMinimized ? "none" : "block"};">
          <video id="remoteVideo_${seatId}" class="cam-video" autoplay playsinline muted></video>
          <div class="cam-paused-overlay" style="display: ${paused ? "flex" : "none"};"><span>\u23F8\uFE0F Camera Paused</span></div>
        </div>
      `;
        container.appendChild(tile);
        const btnMinimize = tile.querySelector(".btn-cam-hide-toggle");
        if (btnMinimize) {
          btnMinimize.onclick = (e) => {
            e.preventDefault();
            this.toggleHideRemoteCam(seatId, context);
          };
        }
      } else {
        tile.className = `cam-tile cam-tile-remote ${isMinimized ? "is-minimized is-hidden" : ""}`;
        const nameEl = tile.querySelector(".cam-name");
        if (nameEl && name) nameEl.textContent = `\u{1F4F9} ${name}`;
        const badgeEl = tile.querySelector(".cam-badge");
        if (badgeEl) {
          badgeEl.className = `cam-badge ${paused ? "cam-badge-paused" : "cam-badge-live"}`;
          badgeEl.textContent = paused ? "\u23F8\uFE0F Paused" : "\u25CF Live";
        }
        const wrapEl = tile.querySelector(".cam-video-wrap");
        if (wrapEl) wrapEl.style.display = isMinimized ? "none" : "block";
        let pausedOverlay = tile.querySelector(".cam-paused-overlay");
        if (pausedOverlay) {
          pausedOverlay.style.display = paused ? "flex" : "none";
        } else if (paused && wrapEl) {
          pausedOverlay = doc.createElement("div");
          pausedOverlay.className = "cam-paused-overlay";
          pausedOverlay.innerHTML = "<span>\u23F8\uFE0F Camera Paused</span>";
          wrapEl.appendChild(pausedOverlay);
        }
        const btnMinimize = tile.querySelector(".btn-cam-hide-toggle");
        if (btnMinimize) {
          btnMinimize.textContent = isMinimized ? "\u25B2 Expand" : "\u25BC Minimize";
          btnMinimize.title = isMinimized ? "Expand camera" : "Minimize camera";
        }
        const resizeHandle = tile.querySelector(".cam-resize-handle");
        if (resizeHandle) {
          resizeHandle.style.display = isMinimized ? "none" : "flex";
        }
      }
      const videoEl = tile.querySelector(`#remoteVideo_${seatId}`);
      if (videoEl && stream) {
        this._attachStreamToVideo(videoEl, stream, doc);
      }
      this.makeTileResizable(tile, 210, context);
      if (isMinimized) {
        const resizeHandle = tile.querySelector(".cam-resize-handle");
        if (resizeHandle) resizeHandle.style.display = "none";
      }
    }
    /**
     * Enables mouse & touch drag-to-resize on a camera tile and persists size preferences.
     * @param {HTMLElement} tile
     * @param {number} defaultWidthPx
     * @param {Object} [context]
     */
    makeTileResizable(tile, defaultWidthPx = 200, context = {}) {
      if (!tile || tile._hasResizeHandler) return;
      tile._hasResizeHandler = true;
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const storageKey = `cc_cam_width_${tile.id || "tile"}`;
      try {
        const s = getStorage5();
        if (s) {
          const saved = s.getItem(storageKey);
          if (saved) {
            const w = parseInt(saved, 10);
            if (w >= 130 && w <= 600) {
              tile.style.width = `${w}px`;
            }
          }
        }
      } catch (e) {
      }
      let handle = tile.querySelector ? tile.querySelector(".cam-resize-handle") : null;
      if (!handle && doc && typeof doc.createElement === "function") {
        handle = doc.createElement("div");
        handle.className = "cam-resize-handle";
        handle.title = "Drag to resize camera box (Double-click to reset size)";
        if (typeof handle.setAttribute === "function") {
          handle.setAttribute("aria-label", "Resize camera box");
        }
        handle.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M10 2L2 10M10 6L6 10M10 10L10 10.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>`;
        tile.appendChild(handle);
      }
      if (!handle || typeof handle.addEventListener !== "function") return;
      let isResizing = false;
      let startX = 0;
      let startWidth = 0;
      const onPointerDown = (e) => {
        if (e.type === "mousedown" && e.button !== 0) return;
        isResizing = true;
        if (tile.classList && typeof tile.classList.add === "function") {
          tile.classList.add("is-resizing");
        }
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        startX = clientX;
        startWidth = tile.getBoundingClientRect ? tile.getBoundingClientRect().width : parseInt(tile.style.width, 10) || defaultWidthPx;
        const onPointerMove = (ev) => {
          if (!isResizing) return;
          const currentX = ev.touches ? ev.touches[0].clientX : ev.clientX;
          const deltaX = currentX - startX;
          const minW = 140;
          const maxW = typeof window !== "undefined" ? Math.min(540, window.innerWidth - 30) : 540;
          const newW = Math.max(minW, Math.min(maxW, Math.round(startWidth + deltaX)));
          tile.style.width = `${newW}px`;
          if (typeof ev.preventDefault === "function") ev.preventDefault();
        };
        const onPointerUp = () => {
          if (!isResizing) return;
          isResizing = false;
          if (tile.classList && typeof tile.classList.remove === "function") {
            tile.classList.remove("is-resizing");
          }
          if (typeof window !== "undefined") {
            window.removeEventListener("mousemove", onPointerMove);
            window.removeEventListener("touchmove", onPointerMove);
            window.removeEventListener("mouseup", onPointerUp);
            window.removeEventListener("touchend", onPointerUp);
            window.removeEventListener("touchcancel", onPointerUp);
          }
          try {
            const s = getStorage5();
            if (s) {
              const currentW = tile.getBoundingClientRect ? Math.round(tile.getBoundingClientRect().width) : parseInt(tile.style.width, 10);
              if (currentW) s.setItem(storageKey, currentW.toString());
            }
          } catch (err) {
          }
        };
        if (typeof window !== "undefined") {
          window.addEventListener("mousemove", onPointerMove, { passive: false });
          window.addEventListener("touchmove", onPointerMove, { passive: false });
          window.addEventListener("mouseup", onPointerUp);
          window.addEventListener("touchend", onPointerUp);
          window.addEventListener("touchcancel", onPointerUp);
        }
        if (typeof e.preventDefault === "function") e.preventDefault();
        if (typeof e.stopPropagation === "function") e.stopPropagation();
      };
      handle.addEventListener("mousedown", onPointerDown);
      handle.addEventListener("touchstart", onPointerDown, { passive: false });
      handle.addEventListener("dblclick", (e) => {
        if (typeof e.preventDefault === "function") e.preventDefault();
        if (typeof e.stopPropagation === "function") e.stopPropagation();
        tile.style.width = `${defaultWidthPx}px`;
        try {
          const s = getStorage5();
          if (s) {
            s.removeItem(storageKey);
          }
        } catch (err) {
        }
      });
    }
    /**
     * Removes a remote opponent's video tile from the game table.
     * @param {string} seatId
     * @param {Object} [context]
     */
    removeRemoteTile(seatId, context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const tile = doc.getElementById(`remoteCamTile_${seatId}`);
      if (tile) tile.remove();
    }
    /**
     * Updates the match header camera toggle button state (Off / Live / Paused).
     * @param {Object} [context]
     */
    updateCamButtonUi(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const btn = doc.getElementById("btnCamToggle");
      if (!btn) return;
      if (!this.isBroadcasting) {
        btn.textContent = "\u{1F4F7} Broadcast Cam";
        btn.className = "btn-ghost";
        btn.title = "Start broadcasting your camera to online players";
      } else if (this.isPaused) {
        btn.textContent = "\u23F8\uFE0F Cam Paused";
        btn.className = "btn-ghost cam-btn-active is-paused";
        btn.title = "Camera is paused \u2014 click to resume";
      } else {
        btn.textContent = "\u{1F534} Cam Live";
        btn.className = "btn-ghost cam-btn-active is-live";
        btn.title = "Camera is broadcasting live \u2014 click to pause/stop";
      }
    }
    resolveSeatIdForPeer(peerId, context = {}) {
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2 || !peerId) return null;
      if (net2.isHost && net2.clients) {
        const client = net2.clients.get(peerId);
        return client ? client.seatId : null;
      }
      if (!net2.isHost && net2.room && peerId.includes(net2.room.trim().toUpperCase())) {
        return "p1";
      }
      return null;
    }
    resolveNameForSeat(seatId, context = {}) {
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : null);
      if (typeof pName2 === "function") {
        return pName2(seatId);
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3 && Array.isArray(settings3.seats)) {
        const s = settings3.seats.find((x) => x && x.id === seatId);
        if (s && s.name) return s.name;
      }
      return seatId ? `Player ${seatId.replace(/\D/g, "") || ""}` : "Player";
    }
  };

  // src/net/ChatManager.js
  function getStorage6() {
    return typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
  }
  var ChatManager = class _ChatManager {
    constructor() {
      this.messages = [];
      this.maxMessages = 100;
      this.isExpanded = false;
      this.unreadCount = 0;
      this.hasCustomToggleState = false;
      const s = getStorage6();
      if (s) {
        try {
          const saved = s.getItem("cc_chat_expanded");
          if (saved !== null) {
            this.isExpanded = saved === "true";
            this.hasCustomToggleState = true;
          }
        } catch (e) {
        }
      }
    }
    /**
     * Returns singleton instance on window if available.
     */
    static getInstance() {
      if (typeof window !== "undefined") {
        if (!window._ccChatManager) {
          window._ccChatManager = new _ChatManager();
        }
        return window._ccChatManager;
      }
      if (!_ChatManager._instance) {
        _ChatManager._instance = new _ChatManager();
      }
      return _ChatManager._instance;
    }
    /**
     * Cleans and sanitizes raw user message text against HTML injection via DOMPurify.
     * @param {string} str
     * @returns {string}
     */
    static sanitizeText(str) {
      if (typeof str !== "string") return "";
      return sanitizeUserInput(str);
    }
    /**
     * Formats a unix timestamp into a local 12-hour or 24-hour time string (e.g. "10:45 AM").
     * @param {number} ts
     * @returns {string}
     */
    static formatTime(ts) {
      if (!ts) return "";
      try {
        const d = new Date(ts);
        return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
      } catch (e) {
        return "";
      }
    }
    /**
     * Sends a chat message from the local player to all connected multiplayer peers.
     * @param {string} rawText
     * @param {Object} [context]
     * @returns {Object|null} The created message object, or null if empty
     */
    sendMessage(rawText, context = {}) {
      const text2 = sanitizeUserInput(rawText);
      if (!text2) return null;
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" && window.mySeat ? window.mySeat : () => "p1");
      const mySeatId = net2 && net2.mySeatId || mySeat3();
      const s = getStorage6();
      const rawMyName = doc && doc.getElementById("optPlayerName") && doc.getElementById("optPlayerName").value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : "") || (net2 && net2.isHost ? "Host" : "You");
      const myName = sanitizeUserInput(rawMyName) || "Player";
      const msg = {
        id: "msg_" + Date.now() + "_" + Math.random().toString(36).slice(2, 7),
        type: "chat",
        sender: myName,
        seatId: mySeatId,
        text: text2,
        time: Date.now(),
        isLocal: true
      };
      this.messages.push(msg);
      if (this.messages.length > this.maxMessages) {
        this.messages.shift();
      }
      if (net2) {
        const payload = {
          id: msg.id,
          type: "chat",
          sender: msg.sender,
          seatId: msg.seatId,
          text: msg.text,
          time: msg.time
        };
        if (net2.isHost && net2.clients) {
          for (const client of net2.clients.values()) {
            if (client.conn && client.conn.open !== false) {
              try {
                client.conn.send(payload);
              } catch (e) {
              }
            }
          }
        } else if (!net2.isHost && net2.conn && net2.conn.open !== false) {
          try {
            net2.conn.send(payload);
          } catch (e) {
          }
        }
      }
      this.renderMessages(context);
      this.scrollToBottom(context);
      if (doc) {
        const inp = doc.getElementById("chatInput");
        if (inp) inp.value = "";
      }
      return msg;
    }
    /**
     * Handles an incoming chat message from a remote peer.
     * @param {Object} msg
     * @param {Object} [context]
     */
    handleIncomingMessage(msg, context = {}) {
      if (!msg || msg.type !== "chat") return;
      const cleanText = sanitizeUserInput(msg.text);
      if (!cleanText) return;
      if (msg.id && this.messages.some((m) => m.id === msg.id)) {
        return;
      }
      const cleanMsg = {
        id: msg.id || "msg_" + Date.now() + "_" + Math.random().toString(36).slice(2, 7),
        type: "chat",
        sender: sanitizeUserInput(msg.sender || "Player"),
        seatId: msg.seatId || "p2",
        text: cleanText,
        time: msg.time || Date.now(),
        isLocal: false
      };
      this.messages.push(cleanMsg);
      if (this.messages.length > this.maxMessages) {
        this.messages.shift();
      }
      if (!this.isExpanded) {
        this.unreadCount++;
        this.updateUnreadBadge(context);
      }
      this.playNotificationSound(context);
      this.renderMessages(context);
      this.scrollToBottom(context);
    }
    /**
     * Adds an informative system message (e.g. player connected, camera paused).
     * @param {string} text
     * @param {Object} [context]
     */
    addSystemMessage(text2, context = {}) {
      if (!text2) return;
      const sysMsg = {
        id: "sys_" + Date.now() + "_" + Math.random().toString(36).slice(2, 7),
        type: "chat",
        sender: "System",
        seatId: "system",
        text: text2,
        time: Date.now(),
        isSystem: true
      };
      this.messages.push(sysMsg);
      if (this.messages.length > this.maxMessages) {
        this.messages.shift();
      }
      this.renderMessages(context);
      this.scrollToBottom(context);
    }
    /**
     * Plays a gentle, pleasant notification chime when an incoming message arrives.
     * @param {Object} [context]
     */
    playNotificationSound(context = {}) {
      try {
        const audioMgr = context.AudioManager || (typeof window !== "undefined" ? window.audioManager : null);
        if (audioMgr && typeof audioMgr.tone === "function") {
          audioMgr.tone(587.33, 0.08, "sine", 0.04);
          setTimeout(() => {
            try {
              audioMgr.tone(880, 0.12, "sine", 0.04);
            } catch (e) {
            }
          }, 60);
        }
      } catch (e) {
      }
    }
    /**
     * Toggles the chat panel between expanded and collapsed states.
     * @param {boolean} [forceState]
     * @param {Object} [context]
     * @returns {boolean} New expansion state
     */
    toggleChat(forceState = void 0, context = {}) {
      this.isExpanded = forceState !== void 0 ? Boolean(forceState) : !this.isExpanded;
      this.hasCustomToggleState = true;
      if (this.isExpanded) {
        this.unreadCount = 0;
      }
      try {
        const s = getStorage6();
        if (s) {
          s.setItem("cc_chat_expanded", this.isExpanded.toString());
        }
      } catch (e) {
      }
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (doc) {
        const container = doc.getElementById("chatWidgetContainer");
        if (container) {
          container.classList.toggle("is-expanded", this.isExpanded);
          container.classList.toggle("is-collapsed", !this.isExpanded);
        }
        this.updateUnreadBadge(context);
        if (this.isExpanded) {
          this.scrollToBottom(context);
          const inp = doc.getElementById("chatInput");
          if (inp && typeof inp.focus === "function") {
            setTimeout(() => {
              try {
                inp.focus();
              } catch (e) {
              }
            }, 50);
          }
        }
      }
      return this.isExpanded;
    }
    /**
     * Updates the unread message counter badge on the collapsed chat pill.
     * @param {Object} [context]
     */
    updateUnreadBadge(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const badge = doc.getElementById("chatUnreadBadge");
      if (badge) {
        if (this.unreadCount > 0 && !this.isExpanded) {
          badge.textContent = this.unreadCount > 99 ? "99+" : this.unreadCount.toString();
          badge.style.display = "inline-flex";
        } else {
          badge.textContent = "0";
          badge.style.display = "none";
        }
      }
    }
    /**
     * Renders the chat widget DOM structure into #chatWidgetContainer.
     * @param {Object} [context]
     */
    renderChatWidget(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      let container = doc.getElementById("chatWidgetContainer");
      if (!container) {
        container = doc.createElement("div");
        container.id = "chatWidgetContainer";
        container.className = `chat-widget ${this.isExpanded ? "is-expanded" : "is-collapsed"}`;
        doc.body.appendChild(container);
      } else {
        container.className = `chat-widget ${this.isExpanded ? "is-expanded" : "is-collapsed"}`;
      }
      container.innerHTML = `
      <!-- Collapsed Floating Pill -->
      <button type="button" class="chat-toggle-pill" id="btnChatTogglePill" title="Expand Match Chat">
        <span class="chat-pill-icon">\u{1F4AC}</span>
        <span class="chat-pill-label">Chat</span>
        <span class="chat-unread-badge" id="chatUnreadBadge" style="display: ${this.unreadCount > 0 && !this.isExpanded ? "inline-flex" : "none"};">
          ${this.unreadCount > 99 ? "99+" : this.unreadCount}
        </span>
      </button>

      <!-- Expanded Floating Card Panel -->
      <div class="chat-panel" id="chatPanel">
        <div class="chat-header">
          <div class="chat-header-title">
            <span class="chat-header-icon">\u{1F4AC}</span>
            <span class="chat-header-text">Match Chat</span>
          </div>
          <div class="chat-header-actions">
            <button type="button" class="btn-chat-collapse" id="btnChatCollapse" title="Collapse Chat">
              \u25BC Minimize
            </button>
          </div>
        </div>

        <div class="chat-messages" id="chatMessagesList" role="log" aria-live="polite"></div>

        <form class="chat-input-bar" id="chatForm">
          <input type="text" class="chat-input" id="chatInput" placeholder="Message match\u2026" maxlength="250" autocomplete="off" />
          <button type="submit" class="btn-chat-send" id="btnChatSend" title="Send Message">
            \u27A4
          </button>
        </form>
      </div>
    `;
      const pillBtn = container.querySelector("#btnChatTogglePill");
      if (pillBtn) {
        if (typeof pillBtn.addEventListener === "function") {
          pillBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.toggleChat(true, context);
          });
        } else {
          pillBtn.onclick = (e) => {
            e.preventDefault();
            this.toggleChat(true, context);
          };
        }
      }
      const collapseBtn = container.querySelector("#btnChatCollapse");
      if (collapseBtn) {
        if (typeof collapseBtn.addEventListener === "function") {
          collapseBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.toggleChat(false, context);
          });
        } else {
          collapseBtn.onclick = (e) => {
            e.preventDefault();
            this.toggleChat(false, context);
          };
        }
      }
      const form = container.querySelector("#chatForm");
      const input = container.querySelector("#chatInput");
      if (form && input) {
        if (typeof form.addEventListener === "function") {
          form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.sendMessage(input.value, context);
          });
        } else {
          form.onsubmit = (e) => {
            e.preventDefault();
            this.sendMessage(input.value, context);
          };
        }
        if (typeof input.addEventListener === "function") {
          input.addEventListener("keydown", (e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              this.sendMessage(input.value, context);
            }
          });
        } else {
          input.onkeydown = (e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              this.sendMessage(input.value, context);
            }
          };
        }
      }
      this.renderMessages(context);
      this.updateUnreadBadge(context);
    }
    /**
     * Renders the current list of messages inside #chatMessagesList.
     * @param {Object} [context]
     */
    renderMessages(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const list = doc.getElementById("chatMessagesList");
      if (!list) return;
      if (this.messages.length === 0) {
        list.innerHTML = `<div class="chat-empty-state">No messages yet. Say hello! \u{1F44B}</div>`;
        return;
      }
      list.innerHTML = this.messages.map((m) => {
        if (m.isSystem) {
          return `
          <div class="chat-msg chat-msg-system">
            <span class="chat-sys-text">${_ChatManager.sanitizeText(m.text)}</span>
          </div>
        `;
        }
        const isLocal = Boolean(m.isLocal);
        const seatClass = m.seatId ? `chat-seat-${m.seatId}` : "";
        const timeStr = _ChatManager.formatTime(m.time);
        return `
        <div class="chat-msg ${isLocal ? "chat-msg-local" : "chat-msg-remote"} ${seatClass}">
          <div class="chat-msg-header">
            <span class="chat-msg-sender">${_ChatManager.sanitizeText(m.sender)}</span>
            <span class="chat-msg-time">${timeStr}</span>
          </div>
          <div class="chat-msg-bubble">
            <div class="chat-msg-text">${_ChatManager.sanitizeText(m.text)}</div>
          </div>
        </div>
      `;
      }).join("");
    }
    /**
     * Smoothly scrolls message list to bottom.
     * @param {Object} [context]
     */
    scrollToBottom(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const list = doc.getElementById("chatMessagesList");
      if (list) {
        setTimeout(() => {
          try {
            list.scrollTop = list.scrollHeight;
          } catch (e) {
          }
        }, 20);
      }
    }
    /**
     * Shows or hides the entire chat widget depending on whether multiple human players are active.
     * @param {boolean} visible
     * @param {Object} [context]
     */
    setChatVisibility(visible, context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      let container = doc.getElementById("chatWidgetContainer");
      if (!container && visible) {
        this.renderChatWidget(context);
        container = doc.getElementById("chatWidgetContainer");
      }
      if (container) {
        container.style.display = visible ? "flex" : "none";
      }
    }
    /**
     * Clears all chat messages and resets state (e.g. when leaving match to menu).
     * @param {Object} [context]
     */
    clearChat(context = {}) {
      this.messages = [];
      this.unreadCount = 0;
      this.renderMessages(context);
      this.updateUnreadBadge(context);
    }
  };

  // src/net/NetworkManager.js
  function getStorage7(context = {}) {
    return context.storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
  }
  var ROOM_CODE_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  var DEFAULT_PEER_CONFIG = {
    debug: 1,
    config: {
      iceServers: [
        { urls: "stun:stun.l.google.com:19302" },
        { urls: "stun:stun1.l.google.com:19302" },
        { urls: "stun:stun2.l.google.com:19302" },
        { urls: "stun:stun3.l.google.com:19302" },
        { urls: "stun:stun4.l.google.com:19302" },
        { urls: "stun:global.stun.twilio.com:3478" }
      ]
    }
  };
  var NetworkManager2 = class _NetworkManager {
    constructor(options = {}) {
      this.role = options.role || "solo";
      this.room = options.room || null;
      this.mySeatId = options.mySeatId || "p1";
      this.peer = null;
      this.conn = null;
      this.clients = /* @__PURE__ */ new Map();
      this.ready = false;
    }
    /**
     * Sanitizes and normalizes player names against HTML injection, control characters, and excessive length.
     * Strips HTML tags, metacharacters, and non-printable control characters.
     * @param {*} rawName
     * @param {string} [defaultFallback='Player']
     * @returns {string}
     */
    static sanitizePlayerName(rawName, defaultFallback = "Player") {
      if (typeof rawName !== "string") return defaultFallback;
      let cleaned = rawName.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "").replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "").replace(/<[^>]*>/g, "").replace(/[<>"'&`/\\;]/g, "").replace(/[\u0000-\u001F\u007F-\u009F]/g, "").replace(/\s+/g, " ").trim();
      if (!cleaned) return defaultFallback;
      return cleaned.slice(0, 24);
    }
    /**
     * Generates a 6-character clean uppercase room code (excluding ambiguous 0/O, 1/I).
     * @param {number} [length=6]
     * @returns {string}
     */
    static generateRoomCode(length = 6) {
      let s = "";
      for (let i = 0; i < length; i++) {
        s += ROOM_CODE_CHARS[Math.floor(Math.random() * ROOM_CODE_CHARS.length)];
      }
      return s;
    }
    /**
     * Generates a canonical join URL for sharing with guests.
     * @param {string} code
     * @param {string} [origin]
     * @returns {string}
     */
    static getJoinUrl(code, origin = "") {
      const roomCode = (code || "").trim().toUpperCase();
      if (!origin && typeof window !== "undefined" && window.location) {
        origin = window.location.href;
      }
      if (!origin) return roomCode ? `?room=${encodeURIComponent(roomCode)}` : "";
      try {
        const url = new URL(origin);
        let brand = url.searchParams.get("brand");
        if (!brand && typeof window !== "undefined" && typeof window.getAppBrand === "function") {
          brand = window.getAppBrand();
        }
        url.search = "";
        url.hash = "";
        if (roomCode) url.searchParams.set("room", roomCode);
        if (brand && brand !== "crazy") url.searchParams.set("brand", brand);
        return url.toString();
      } catch (e) {
        const base = origin.split("?")[0].split("#")[0];
        return roomCode ? `${base}?room=${encodeURIComponent(roomCode)}` : base;
      }
    }
    /**
     * Strips internal non-serializable fields (e.g. DOM nodes, closures) from game state.
     * @param {Object} state
     * @returns {Object} Clean JSON-serializable state
     */
    static serializeState(state3) {
      if (!state3 || typeof state3 !== "object") return {};
      const skip = {
        pendingWild: true,
        _resumeAfterSign: true,
        _resumeAfterAdultTimer: true,
        _resumeAfterPintsBonus: true
      };
      const out = {};
      for (const k of Object.keys(state3)) {
        if (!skip[k]) {
          out[k] = state3[k];
        }
      }
      return out;
    }
    serializeState(state3) {
      return _NetworkManager.serializeState(state3);
    }
    /**
     * Sanitizes game state before transmission to a client: masks opponent cards,
     * hides hidden crib cards during play, and strips undealt deck card identities.
     * @param {Object} rawState Full authoritative game state
     * @param {string} targetSeatId Seat identifier of the recipient (e.g. 'p2')
     * @returns {Object} Sanitized state safe for transmission
     */
    static sanitizeForClient(rawState, targetSeatId) {
      if (!rawState || typeof rawState !== "object") return rawState;
      const out = { ...rawState };
      const isShowOrOver = out.phase === "show" || out.phase === "show-p2" || out.phase === "show-multi" || Boolean(out.over);
      if (out.seatHands && typeof out.seatHands === "object") {
        const safeHands = {};
        for (const [sId, hand] of Object.entries(out.seatHands)) {
          if (!Array.isArray(hand)) {
            safeHands[sId] = hand;
            continue;
          }
          if (sId === targetSeatId || isShowOrOver) {
            safeHands[sId] = hand.map((c) => ({ ...c }));
          } else {
            safeHands[sId] = hand.map((c) => ({
              id: c.id,
              rank: "?",
              suit: "?",
              val: 0,
              masked: true
            }));
          }
        }
        out.seatHands = safeHands;
      }
      if (targetSeatId === "p2") {
        if (out.youHand && Array.isArray(out.youHand) && !isShowOrOver) {
          out.youHand = out.youHand.map((c) => ({ id: c.id, rank: "?", suit: "?", val: 0, masked: true }));
        }
      } else if (targetSeatId === "p1") {
        if (out.cpuHand && Array.isArray(out.cpuHand) && !isShowOrOver) {
          out.cpuHand = out.cpuHand.map((c) => ({ id: c.id, rank: "?", suit: "?", val: 0, masked: true }));
        }
      }
      if (out.crib && Array.isArray(out.crib)) {
        const isCountingCrib = (out.phase === "show" || out.phase === "show-multi") && out.showQueue && out.showQueue[out.showStep] === "crib";
        if (!isCountingCrib && !out.over) {
          out.crib = out.crib.map((c) => ({ id: c.id, rank: "?", suit: "?", val: 0, masked: true }));
        }
      }
      if (out.deck && Array.isArray(out.deck)) {
        out.deckCount = out.deck.length;
        out.deck = [];
      }
      return out;
    }
    sanitizeForClient(rawState, targetSeatId) {
      return _NetworkManager.sanitizeForClient(rawState, targetSeatId);
    }
    /**
     * Computes seat assignment for a new connecting client.
     * @param {Iterable<Object>} existingClients Map values or array of existing clients
     * @param {number} [playerCount=2] Max table player count
     * @param {string} [connectingPeerId=null]
     * @returns {string|null} Available seat ID (e.g. 'p2'..'p8') or null if table is full
     */
    static allocateSeat(existingClients, playerCount = 2, connectingPeerId = null) {
      const taken = /* @__PURE__ */ new Set();
      if (existingClients) {
        for (const client of existingClients) {
          if (client.seatId && (!connectingPeerId || client.peerId !== connectingPeerId)) {
            taken.add(client.seatId);
          }
        }
      }
      const maxCount = Math.max(2, Math.min(8, parseInt(playerCount, 10) || 2));
      for (let i = 2; i <= maxCount; i++) {
        const sId = "p" + i;
        if (!taken.has(sId)) return sId;
      }
      return null;
    }
    allocateSeat(playerCount = 2, connectingPeerId = null) {
      return _NetworkManager.allocateSeat(this.clients.values(), playerCount, connectingPeerId);
    }
    /**
     * Processes authoritative client intents received by the host.
     * @param {Object} msg Intent message { op, seatId, ... }
     * @param {Object} handlers Object with callback handlers for various operations
     * @returns {boolean} Whether the intent was successfully dispatched
     */
    static processClientIntent(msg, handlers = {}) {
      if (!msg || typeof msg !== "object" || !msg.op) return false;
      const sId = msg.seatId || "p2";
      switch (msg.op) {
        case "play":
          if (typeof handlers.onPlay === "function") {
            handlers.onPlay(sId, msg.cardId);
            return true;
          }
          break;
        case "discard":
        case "discardP2":
          if (typeof handlers.onDiscard === "function") {
            handlers.onDiscard(sId, msg.ids || []);
            return true;
          }
          break;
        case "cut":
          if (typeof handlers.onCut === "function") {
            handlers.onCut(sId, msg.index);
            return true;
          }
          break;
        case "cutStarter":
          if (msg.guessRank != null && handlers.state) {
            handlers.state.starterGuess = { who: sId, rank: Number(msg.guessRank) };
          }
          if (typeof handlers.onCutStarter === "function") {
            handlers.onCutStarter(sId, msg.guessRank);
            return true;
          }
          break;
        case "stolenCribGuess":
          if (typeof handlers.onStolenCribGuess === "function") {
            handlers.onStolenCribGuess(sId, msg.guess);
            return true;
          }
          break;
        case "twistedCribbageSplit":
          if (typeof handlers.onTwistedCribbageSplit === "function") {
            handlers.onTwistedCribbageSplit(sId, msg.hand1, msg.hand2);
            return true;
          }
          break;
        case "wild":
          if (typeof handlers.onWild === "function") {
            handlers.onWild(sId, msg.cardId, msg.r, msg.s);
            return true;
          }
          break;
        case "playAgain":
          if (typeof handlers.onPlayAgain === "function") {
            handlers.onPlayAgain(sId);
            return true;
          }
          break;
      }
      return false;
    }
    processClientIntent(msg, handlers = {}) {
      return _NetworkManager.processClientIntent(msg, handlers);
    }
    /**
     * Updates lobby roster DOM element and player counts.
     * @param {Array} [remoteRoster]
     * @param {Object} [context]
     */
    static updateNetRoster(remoteRoster, context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const rosterWrap = doc.getElementById("netRoster");
      const listEl = doc.getElementById("netRosterList");
      const countEl = doc.getElementById("netRosterCount");
      const btnStartGame = doc.getElementById("btnStartOnlineGame");
      if (!rosterWrap || !listEl) return;
      const optOpp = doc.getElementById("optOpp");
      const isOnline2 = typeof context.isOnline === "function" ? context.isOnline() : typeof window !== "undefined" && typeof window.isOnline === "function" ? window.isOnline() : false;
      const isOnlineMode = isOnline2 || optOpp && optOpp.value === "online";
      if (!isOnlineMode) {
        rosterWrap.style.display = "none";
        return;
      }
      rosterWrap.style.display = "block";
      const getLobbyRosterData2 = context.getLobbyRosterData || (typeof window !== "undefined" ? window.getLobbyRosterData : null);
      const roster = remoteRoster || (typeof getLobbyRosterData2 === "function" ? getLobbyRosterData2() : []);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (net2) {
        net2.roster = roster;
      }
      const totalSeats = roster.length;
      const humanCount = roster.filter((r) => r.type === "human" || r.status === "host" || r.status === "online").length;
      if (countEl) {
        countEl.textContent = `Players: ${humanCount} / ${totalSeats}`;
      }
      listEl.innerHTML = roster.map((r) => {
        let dotClass = "waiting";
        let dotLabel = r.statusText || "Waiting";
        if (r.status === "host" || r.status === "online") {
          dotClass = "online";
        } else if (r.status === "cpu") {
          dotClass = "cpu";
        }
        let avatarBadgeHtml = "";
        const avMgr = context.AvatarManager || typeof window !== "undefined" && window.AvatarManager || AvatarManager || null;
        if (avMgr && typeof avMgr.renderAvatarBadge === "function") {
          let targetAvId = null;
          if (r.isYou) {
            targetAvId = typeof avMgr.getSelectedAvatarId === "function" ? avMgr.getSelectedAvatarId() : "jack";
          } else {
            const settingsObj = context.settings || (typeof window !== "undefined" ? window.settings : null);
            const seatObj = settingsObj && Array.isArray(settingsObj.seats) ? settingsObj.seats.find((s) => s && s.id === r.id) : null;
            const av = seatObj?.avatar || r.avatar || r.avatarId;
            if (av === "custom") {
              targetAvId = "custom_" + r.id;
            } else {
              targetAvId = av || (r.type === "cpu" ? "robot" : "jack");
            }
          }
          if (targetAvId && avMgr.getAvatarById(targetAvId)) {
            avatarBadgeHtml = `<span class="net-roster-avatar" style="margin-right:6px;vertical-align:middle;display:inline-flex;">${avMgr.renderAvatarBadge(targetAvId, { size: 22, showRing: false })}</span>`;
          }
        }
        return `
        <div class="net-roster-row ${r.isYou ? "you" : ""}">
          <div class="net-roster-seat">P${r.num}</div>
          <div class="net-roster-name" style="flex: 1; font-weight: ${r.isYou ? "bold" : "normal"}; display:flex; align-items:center;">
            ${avatarBadgeHtml}<span>${_NetworkManager.sanitizePlayerName(r.name, `Player ${r.num}`)}</span> ${r.isYou ? '<span style="font-size:0.8em;opacity:0.75;margin-left:4px;">(You)</span>' : ""}
          </div>
          <div class="net-roster-tag">
            <span class="net-status-dot ${dotClass}"></span>
            <span>${dotLabel}</span>
          </div>
        </div>
      `;
      }).join("");
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (btnStartGame) {
        if (settings3 && settings3.netRole === "host") {
          btnStartGame.style.display = "inline-flex";
        } else {
          btnStartGame.style.display = "none";
        }
      }
    }
    /**
     * Broadcasts active lobby state & roster to all connected guests.
     * @param {Object} [context]
     */
    static broadcastLobbyUpdate(context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (!settings3 || settings3.netRole !== "host") return;
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2 || !net2.clients) return;
      const getLobbyRosterData2 = context.getLobbyRosterData || (typeof window !== "undefined" ? window.getLobbyRosterData : null);
      const roster = typeof getLobbyRosterData2 === "function" ? getLobbyRosterData2() : net2.roster || [];
      const onlineSeats = ["p1"];
      if (net2.clients) {
        for (const client of net2.clients.values()) {
          if (client && client.seatId && client.conn && client.conn.open) {
            onlineSeats.push(client.seatId);
          }
        }
      }
      const payload = {
        type: "lobby",
        roster,
        playerCount: settings3.playerCount,
        seats: settings3.seats,
        onlineSeats: Array.from(new Set(onlineSeats))
      };
      for (const client of net2.clients.values()) {
        if (client.conn && client.conn.open) {
          try {
            client.conn.send(payload);
          } catch (e) {
            console.warn("Lobby broadcast err:", e);
          }
        }
      }
    }
    /**
     * Authoritative / guest network send helper.
     * @param {Object} msg
     * @param {Object} [targetConn]
     * @param {Object} [context]
     */
    static netSend(msg, targetConn, context = {}) {
      if (targetConn && targetConn.open) {
        try {
          targetConn.send(msg);
        } catch (e) {
          console.warn("netSend error:", e);
        }
        return;
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2) return;
      if (settings3 && settings3.netRole === "host") {
        if (net2.clients) {
          for (const client of net2.clients.values()) {
            if (client.conn && client.conn.open) {
              try {
                client.conn.send(msg);
              } catch (e) {
                console.warn("netSend broadcast error:", e);
              }
            }
          }
        }
      } else if (net2.conn && net2.conn.open) {
        try {
          net2.conn.send(msg);
        } catch (e) {
          console.warn("netSend guest error:", e);
        }
      }
    }
    /**
     * Pushes sanitized state snapshots from host to all connected clients.
     * @param {Object} [extra]
     * @param {Object} [context]
     */
    static netPush(extra = {}, context = {}) {
      const isOnline2 = typeof context.isOnline === "function" ? context.isOnline() : typeof window !== "undefined" && typeof window.isOnline === "function" ? window.isOnline() : false;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (!isOnline2 || !settings3 || settings3.netRole !== "host") return;
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2 || !net2.clients) return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const serializeState2 = context.serializeState || (typeof window !== "undefined" && typeof window.serializeState === "function" ? window.serializeState : _NetworkManager.serializeState);
      const getSanitizedStateForSeat2 = context.getSanitizedStateForSeat || (typeof window !== "undefined" && typeof window.getSanitizedStateForSeat === "function" ? window.getSanitizedStateForSeat : (sId, raw) => _NetworkManager.sanitizeForClient(raw, sId));
      const onlineSeats = ["p1"];
      if (net2.clients) {
        for (const client of net2.clients.values()) {
          if (client && client.seatId && client.conn && client.conn.open) {
            onlineSeats.push(client.seatId);
          }
        }
      }
      const uniqueOnlineSeats = Array.from(new Set(onlineSeats));
      const rawState = serializeState2(state3);
      for (const [peerId, client] of net2.clients.entries()) {
        if (client.conn && client.conn.open) {
          const sanitized = getSanitizedStateForSeat2(client.seatId, rawState);
          try {
            client.conn.send({
              type: "state",
              state: sanitized,
              settings: { ...settings3 },
              mySeatId: client.seatId,
              onlineSeats: uniqueOnlineSeats,
              ...extra
            });
          } catch (e) {
            console.warn("netPush error to", peerId, e);
          }
        }
      }
    }
    /**
     * Applies remote game state snapshot received from host to client view.
     * @param {Object} payload
     * @param {Object} [context]
     */
    static applyRemoteState(payload, context = {}) {
      if (!payload || !payload.state) return;
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      hideWait2();
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (net2 && payload.mySeatId) {
        net2.mySeatId = payload.mySeatId;
      }
      if (context.setState && typeof context.setState === "function") {
        context.setState(payload.state);
      } else if (typeof window !== "undefined") {
        window.state = payload.state;
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3) {
        if (payload.settings) Object.assign(settings3, payload.settings);
        settings3.opp = "online";
        settings3.netRole = "guest";
      }
      if (Array.isArray(payload.onlineSeats)) {
        if (net2) net2.onlineSeats = payload.onlineSeats;
        if (settings3 && settings3.seats) {
          settings3.seats.forEach((s) => {
            if (s && s.id) {
              s.online = payload.onlineSeats.includes(s.id);
            }
          });
        }
      }
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (doc) {
        const menuEl = doc.getElementById("menu");
        const gameEl = doc.getElementById("game");
        if (menuEl) menuEl.classList.add("hidden");
        if (gameEl) gameEl.classList.remove("hidden");
        const getBoardSignature2 = context.getBoardSignature || (typeof window !== "undefined" ? window.getBoardSignature : null);
        const buildBoard2 = context.buildBoard || (typeof window !== "undefined" ? window.buildBoard : null);
        if (typeof getBoardSignature2 === "function" && typeof buildBoard2 === "function") {
          const targetSig = getBoardSignature2();
          const currentSig = typeof window !== "undefined" ? window._currentBoardSignature : null;
          if (currentSig !== targetSig || !doc.getElementById("serpentineBoard")) {
            buildBoard2();
          }
        }
        const applySeatLabels2 = context.applySeatLabels || (typeof window !== "undefined" ? window.applySeatLabels : null);
        if (typeof applySeatLabels2 === "function") applySeatLabels2();
        const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : null);
        if (typeof renderScores2 === "function") renderScores2(true);
        const render2 = context.render || (typeof window !== "undefined" ? window.render : null);
        if (typeof render2 === "function") render2();
        const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : null);
        if (payload.fancy && typeof fancyCall2 === "function") {
          let fText = payload.fancy.text;
          if (payload.fancy.kind === "go" && (payload.fancy.goSeat || payload.fancy.goSeats)) {
            const mySeat3 = context.mySeat || (typeof window !== "undefined" && typeof window.mySeat === "function" ? window.mySeat : () => net2 ? net2.mySeatId : "p2");
            const seatName3 = context.seatName || (typeof window !== "undefined" && typeof window.seatName === "function" ? window.seatName : (s) => s);
            const me = mySeat3();
            const seats = payload.fancy.goSeats || [payload.fancy.goSeat];
            const names = seats.map((s) => {
              if (s === me) return "You";
              const n = seatName3(s);
              return n === "You" || typeof n === "string" && n.endsWith("(You)") ? "You" : n;
            });
            let whoSays = "";
            if (names.length === 1) {
              whoSays = names[0] === "You" ? 'You say "Go!"' : `${names[0]} says "Go!"`;
            } else if (names.length === 2) {
              whoSays = `${names[0]} & ${names[1]} say "Go!"`;
            } else {
              whoSays = `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]} say "Go!"`;
            }
            if (payload.fancy.scorerSeat) {
              const sc = payload.fancy.scorerSeat === me ? "You" : seatName3(payload.fancy.scorerSeat);
              fText = `${whoSays} \u2014 1 pt to ${sc}`;
            } else {
              fText = whoSays;
            }
            try {
              const b3d = typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null;
              if (b3d && typeof b3d.showSeatReaction === "function") {
                seats.forEach((s) => b3d.showSeatReaction(s, "\u{1F4AC} GO!"));
              }
            } catch (_) {
            }
          } else if (payload.fancy.kind === "play-turn" && payload.fancy.turnSeat) {
            const mySeat3 = context.mySeat || (typeof window !== "undefined" && typeof window.mySeat === "function" ? window.mySeat : () => net2 ? net2.mySeatId : "p2");
            const seatName3 = context.seatName || (typeof window !== "undefined" && typeof window.seatName === "function" ? window.seatName : (s) => s);
            const me = mySeat3();
            const turnSeat = payload.fancy.turnSeat;
            fText = turnSeat === me ? "Your turn: Play a card" : `${seatName3(turnSeat)}\u2019s turn: Play a card`;
            try {
              const b3d = typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null;
              if (b3d && typeof b3d.showSeatReaction === "function") {
                b3d.showSeatReaction(turnSeat, "\u{1F3B4}");
              }
            } catch (_) {
            }
          }
          fancyCall2(fText, payload.fancy.kind, payload.fancy.ms);
        }
        const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
        if (payload.sfx && sfx3 && typeof sfx3[payload.sfx] === "function") {
          sfx3[payload.sfx]();
        }
        const log2 = context.log || (typeof window !== "undefined" ? window.log : null);
        if (payload.log && typeof log2 === "function") {
          log2(payload.log);
        }
        const setShowMeter2 = context.setShowMeter || (typeof window !== "undefined" ? window.setShowMeter : null);
        if (payload.showMeter && typeof setShowMeter2 === "function") {
          setShowMeter2(payload.showMeter.act, payload.showMeter.total, payload.showMeter.line);
        }
        const openShowModal2 = context.openShowModal || (typeof window !== "undefined" ? window.openShowModal : null);
        const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : null);
        const currentState = payload.state;
        if (payload.modal === "show" || currentState && currentState.showModal && currentState.showModal.open) {
          if (typeof openShowModal2 === "function") {
            openShowModal2(payload.pegOnly != null ? payload.pegOnly : currentState.showModal && currentState.showModal.pegOnly);
          }
        } else if (payload.modal === "hide" || currentState && !currentState.showModal && doc.getElementById("modal") && doc.getElementById("modal").querySelector("#btnNextHand, #btnGuestWait")) {
          if (typeof hideModal3 === "function") hideModal3();
        }
      }
    }
    /**
     * Processes discard intention from a human seat on the host.
     * @param {string} sId
     * @param {Array<number|string>} ids
     * @param {Object} [context]
     */
    static handleSeatDiscardIntent(sId, ids, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (!state3 || !settings3 || state3.phase !== "discard" && state3.phase !== "discard-p2") return;
      const count = settings3.playerCount || 2;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      let discardN = count >= 3 ? 1 : is7Card ? 2 : settings3.deal === "super" ? 3 : 2;
      if ((settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        discardN = sId === state3.dealer ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
      }
      if (!Array.isArray(ids) || ids.length !== discardN) return;
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const setSeatHand2 = context.setSeatHand || (typeof window !== "undefined" ? window.setSeatHand : () => {
      });
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" ? window.setSeatKept : () => {
      });
      const seatDiscardsToDeck2 = context.seatDiscardsToDeck || (typeof window !== "undefined" ? window.seatDiscardsToDeck : () => false);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => []);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => false);
      const isSeatCpu2 = context.isSeatCpu || (typeof window !== "undefined" ? window.isSeatCpu : () => false);
      const isDealerTeam2 = context.isDealerTeam || (typeof window !== "undefined" ? window.isDealerTeam : () => false);
      const chooseDiscard2 = context.chooseDiscard || (typeof window !== "undefined" ? window.chooseDiscard : () => []);
      const setStatus2 = context.setStatus || (typeof window !== "undefined" ? window.setStatus : () => {
      });
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : _NetworkManager.netPush);
      const startPlayAfterDiscards2 = context.startPlayAfterDiscards || (typeof window !== "undefined" ? window.startPlayAfterDiscards : () => {
      });
      const startStarter2 = context.startStarter || (typeof window !== "undefined" ? window.startStarter : () => {
      });
      const beginCutStarter2 = context.beginCutStarter || (typeof window !== "undefined" ? window.beginCutStarter : null);
      const idSet = new Set(ids);
      const currHand = getSeatHand2(sId);
      const thrown = currHand.filter((c) => idSet.has(c.id));
      if (thrown.length !== discardN) return;
      if (settings3 && settings3.optFivesCribbage && !seatDiscardsToDeck2(sId)) {
        const fivesInHand = currHand.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5);
        const reqFives = Math.min(fivesInHand.length, discardN);
        const thrownFives = thrown.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5);
        if (thrownFives.length < reqFives) return;
      }
      if (settings3 && settings3.optSevensAndEightsCribbage && !seatDiscardsToDeck2(sId)) {
        const sevensAndEightsInHand = currHand.filter((c) => {
          const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
          return r === 7 || r === 8;
        });
        const reqCount = Math.min(sevensAndEightsInHand.length, discardN);
        const thrownTarget = thrown.filter((c) => {
          const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
          return r === 7 || r === 8;
        });
        if (thrownTarget.length < reqCount) return;
      }
      const remaining = currHand.filter((c) => !idSet.has(c.id));
      setSeatHand2(sId, remaining);
      setSeatKept2(sId, remaining.slice());
      state3.seatDiscards = state3.seatDiscards || {};
      state3.seatDiscards[sId] = thrown;
      if ((settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        if (sId !== state3.dealer) {
          const dHand = (getSeatHand2(state3.dealer) || []).slice();
          dHand.push(...thrown);
          setSeatHand2(state3.dealer, dHand);
          log2(`${seatName3(sId)} discarded ${thrown.length} card${thrown.length > 1 ? "s" : ""} to ${seatName3(state3.dealer)}'s hand.`);
        } else {
          state3.crib = state3.crib || [];
          state3.crib.push(...thrown);
          log2(`${seatName3(sId)} discarded ${thrown.length} cards to the crib.`);
        }
      } else if (seatDiscardsToDeck2(sId)) {
        state3.deckDiscards = state3.deckDiscards || [];
        state3.deckDiscards.push(...thrown);
        log2(`${seatName3(sId)} discards 1 card to the deck.`);
      } else {
        state3.crib = state3.crib || [];
        state3.crib.push(...thrown);
      }
      if (sId === mySeat3()) {
        state3.selected = [];
      }
      const activeSeats = getActiveSeatIds2();
      const pendingHumans = activeSeats.filter((id) => isSeatHuman2(id) && (!state3.seatDiscards || !state3.seatDiscards[id]));
      if (pendingHumans.length > 0) {
        const pendingNames = pendingHumans.map((id) => seatName3(id)).join(", ");
        setStatus2(`Waiting for ${pendingNames} to discard\u2026`);
        render2();
        netPush2();
        return;
      }
      for (const seat of activeSeats) {
        if (isSeatCpu2(seat) && (!state3.seatDiscards || !state3.seatDiscards[seat])) {
          const sHand = getSeatHand2(seat);
          const isDealer = isDealerTeam2(seat);
          const toDeck = seatDiscardsToDeck2(seat);
          const cpuDiscardN = (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2 && seat === state3.dealer ? settings3.deal === "super" ? 6 : 4 : discardN;
          const cpuThrow = chooseDiscard2(sHand, isDealer, settings3.goal === "low", cpuDiscardN, toDeck);
          const cids = new Set(cpuThrow.map((c) => c.id));
          const sKept = sHand.filter((c) => !cids.has(c.id));
          setSeatHand2(seat, sKept);
          setSeatKept2(seat, sKept.slice());
          state3.seatDiscards[seat] = cpuThrow;
          if (toDeck) {
            state3.deckDiscards = state3.deckDiscards || [];
            state3.deckDiscards.push(...cpuThrow);
            log2(`${seatName3(seat)} discards 1 card to the deck.`);
          } else {
            state3.crib = state3.crib || [];
            state3.crib.push(...cpuThrow);
          }
        }
      }
      state3.currentHumanDiscard = null;
      if (settings3.optCutBeforeDiscard) {
        state3.discardsComplete = true;
        startPlayAfterDiscards2();
      } else if (settings3.optGuessStarter) {
        state3.discardsComplete = true;
        const beginCutStarter3 = context.beginCutStarter || (typeof window !== "undefined" ? window.beginCutStarter : null);
        if (typeof beginCutStarter3 === "function") beginCutStarter3();
        else startStarter2();
      } else {
        startStarter2();
      }
      render2();
      netPush2();
    }
    /**
     * Applies client game intents on the host machine.
     * @param {Object} msg
     * @param {Object} [fromConn]
     * @param {Object} [context]
     */
    static hostApplyIntent(msg, fromConn, context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (!msg || !settings3 || settings3.netRole !== "host") return;
      const sId = msg.seatId || fromConn && fromConn._seatId || "p2";
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : _NetworkManager.netPush);
      if (msg.op === "stolenCribGuess") {
        const resolveStolenCribGuess2 = context.resolveStolenCribGuess || (typeof window !== "undefined" ? window.resolveStolenCribGuess : null);
        if (typeof resolveStolenCribGuess2 === "function") {
          resolveStolenCribGuess2(msg.guess, state3 && state3.showQueue ? state3.showQueue.indexOf("crib") : -1);
        }
        netPush2();
        return;
      }
      if (msg.op === "twistedCribbageSplit") {
        const resolveTwistedCribbageSplit2 = context.resolveTwistedCribbageSplit || (typeof window !== "undefined" ? window.resolveTwistedCribbageSplit : null);
        if (typeof resolveTwistedCribbageSplit2 === "function") {
          const dealerIdx = state3 && state3.showQueue ? state3.showQueue.indexOf("dealer") : 1;
          resolveTwistedCribbageSplit2(msg.hand1, msg.hand2, dealerIdx);
        }
        netPush2();
        return;
      }
      if (msg.op === "cut") {
        const pickCut2 = context.pickCut || (typeof window !== "undefined" ? window.pickCut : null);
        if (typeof pickCut2 === "function") pickCut2(msg.index, sId);
        return;
      }
      if (msg.op === "cutStarter") {
        if (msg.guessRank != null && state3) {
          state3.starterGuess = { who: sId, rank: Number(msg.guessRank) };
        }
        const poneDoCutStarter2 = context.poneDoCutStarter || (typeof window !== "undefined" ? window.poneDoCutStarter : null);
        if (typeof poneDoCutStarter2 === "function") poneDoCutStarter2();
        return;
      }
      if (msg.op === "play") {
        const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const playCard2 = context.playCard || (typeof window !== "undefined" ? window.playCard : null);
        const card = (getSeatHand2(sId) || []).find((c) => c.id === msg.cardId);
        if (card && typeof playCard2 === "function") {
          playCard2(sId, card);
        }
        netPush2();
        return;
      }
      if (msg.op === "discard" || msg.op === "discardP2") {
        const handleSeatDiscardIntent2 = context.handleSeatDiscardIntent || (typeof window !== "undefined" ? window.handleSeatDiscardIntent : _NetworkManager.handleSeatDiscardIntent);
        if (typeof handleSeatDiscardIntent2 === "function") {
          handleSeatDiscardIntent2(sId, msg.ids || []);
        }
        return;
      }
      if (msg.op === "draw") {
        const confirmDraw2 = context.confirmDraw || (typeof window !== "undefined" ? window.confirmDraw : null);
        if (typeof confirmDraw2 === "function") {
          state3.selected = msg.ids || [];
          confirmDraw2(context);
        }
        return;
      }
      if (msg.op === "playAgain") {
        const playAgain2 = context.playAgain || (typeof window !== "undefined" ? window.playAgain : null);
        if (typeof playAgain2 === "function") playAgain2();
        return;
      }
      if (msg.op === "wild") {
        const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
        const confirmWildAs2 = context.confirmWildAs || (typeof window !== "undefined" ? window.confirmWildAs : null);
        const hands = [].concat(getSeatHand2(sId) || [], state3 && state3.starters && state3.starters.length ? state3.starters : state3 && state3.starter ? [state3.starter] : []);
        const c = hands.find((x) => x && x.id === msg.cardId);
        if (c && state3) {
          state3.pendingWild = c;
          if (typeof confirmWildAs2 === "function") {
            confirmWildAs2(msg.r, msg.s, sId);
          }
        }
        netPush2();
      }
    }
    /**
     * Welcomes and allocates seat to a connecting client.
     * @param {Object} conn
     * @param {Object} msg
     * @param {Object} [context]
     */
    static handleClientHello(conn, msg, context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!settings3 || !net2) return;
      const count = settings3.playerCount || 2;
      const takenSeats = /* @__PURE__ */ new Set();
      if (net2.clients) {
        for (const client of net2.clients.values()) {
          if (client.seatId && client.conn && client.conn.peer !== conn.peer) {
            takenSeats.add(client.seatId);
          }
        }
      }
      let assignedSeatId = null;
      for (let i = 2; i <= count; i++) {
        const sId = "p" + i;
        if (!takenSeats.has(sId)) {
          assignedSeatId = sId;
          break;
        }
      }
      if (!assignedSeatId) {
        try {
          conn.send({ type: "error", message: "Room is full" });
          conn.close();
        } catch (e) {
        }
        return;
      }
      conn._seatId = assignedSeatId;
      const fallbackClientName = `Player ${assignedSeatId.slice(1)}`;
      const clientName = _NetworkManager.sanitizePlayerName(msg && msg.name, fallbackClientName);
      if (!net2.clients) net2.clients = /* @__PURE__ */ new Map();
      net2.clients.set(conn.peer, {
        conn,
        seatId: assignedSeatId,
        name: clientName
      });
      net2.conn = conn;
      net2.ready = true;
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const hostInput = doc ? doc.getElementById("optPlayerName") : null;
      const s = getStorage7(context);
      const hostName = _NetworkManager.sanitizePlayerName(
        hostInput && hostInput.value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : ""),
        "Host"
      );
      const avMgr = context.AvatarManager || typeof window !== "undefined" && window.AvatarManager || AvatarManager || null;
      const hostAvId = avMgr && typeof avMgr.getSelectedAvatarId === "function" ? avMgr.getSelectedAvatarId(s) : "jack";
      const hostCustomData = hostAvId === "custom" && avMgr && typeof avMgr.getCustomAvatarData === "function" ? avMgr.getCustomAvatarData(s) : null;
      const clientAvId = msg && msg.avatarId || "jack";
      const clientCustomData = clientAvId === "custom" && msg && msg.customAvatarData ? msg.customAvatarData : null;
      if (clientAvId === "custom" && clientCustomData && avMgr && typeof avMgr.registerRemoteCustomAvatar === "function") {
        avMgr.registerRemoteCustomAvatar(assignedSeatId, clientCustomData, clientName);
      }
      if (settings3) {
        if (!settings3.seats || !settings3.seats.length) {
          settings3.seats = [
            { id: "p1", name: hostName, type: "human", personality: "shark", team: 1, color: "#d4a017", online: true, avatar: hostAvId, customAvatarData: hostCustomData },
            { id: "p2", name: clientName, type: "human", personality: "shark", team: 2, color: "#ef4444", online: true, avatar: clientAvId, customAvatarData: clientCustomData }
          ];
        } else {
          if (settings3.seats[0]) {
            settings3.seats[0].name = hostName;
            settings3.seats[0].type = "human";
            settings3.seats[0].online = true;
            settings3.seats[0].avatar = hostAvId;
            if (hostCustomData) settings3.seats[0].customAvatarData = hostCustomData;
          }
          const seatObj = settings3.seats.find((s2) => s2 && s2.id === assignedSeatId);
          if (seatObj) {
            seatObj.name = clientName;
            seatObj.type = "human";
            seatObj.online = true;
            seatObj.avatar = clientAvId;
            if (clientCustomData) seatObj.customAvatarData = clientCustomData;
          }
        }
      }
      const BoardRenderer2 = context.BoardRenderer || (typeof window !== "undefined" ? window.BoardRenderer : null);
      if (BoardRenderer2 && typeof BoardRenderer2.updatePegAvatarPattern === "function") {
        const targetPattern = clientAvId === "custom" ? "custom_" + assignedSeatId : clientAvId;
        BoardRenderer2.updatePegAvatarPattern(assignedSeatId, targetPattern);
      }
      const bRenderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
      if (bRenderer3D && typeof bRenderer3D.updatePegAvatars === "function") {
        bRenderer3D.updatePegAvatars();
      }
      if (typeof window !== "undefined") {
        window._currentRoster = null;
      }
      const onlineSeats = ["p1"];
      if (net2.clients) {
        for (const c of net2.clients.values()) {
          if (c && c.seatId && c.conn && c.conn.open) {
            onlineSeats.push(c.seatId);
          }
        }
      }
      const getLobbyRosterData2 = context.getLobbyRosterData || (typeof window !== "undefined" ? window.getLobbyRosterData : () => []);
      try {
        conn.send({
          type: "welcome",
          seatId: assignedSeatId,
          room: net2.room,
          playerCount: count,
          roster: typeof getLobbyRosterData2 === "function" ? getLobbyRosterData2() : [],
          seats: settings3.seats,
          onlineSeats: Array.from(new Set(onlineSeats))
        });
      } catch (e) {
        console.warn("Welcome send error:", e);
      }
      const broadcastLobbyUpdate2 = context.broadcastLobbyUpdate || (typeof window !== "undefined" ? window.broadcastLobbyUpdate : _NetworkManager.broadcastLobbyUpdate);
      if (typeof broadcastLobbyUpdate2 === "function") broadcastLobbyUpdate2();
      const updateNetRoster2 = context.updateNetRoster || (typeof window !== "undefined" ? window.updateNetRoster : _NetworkManager.updateNetRoster);
      if (typeof updateNetRoster2 === "function") updateNetRoster2();
      const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
      });
      const humanCount = net2.clients.size + 1;
      setNetStatus2(`${humanCount} player(s) in room. Ready to start!`, "on");
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : _NetworkManager.netPush);
      if (state3 && !state3.over && typeof netPush2 === "function") {
        netPush2();
      }
      try {
        const camMgr = context.CameraManager && context.CameraManager.getInstance ? context.CameraManager.getInstance() : CameraManager2.getInstance();
        if (camMgr && camMgr.isBroadcasting && conn.peer) {
          camMgr.callPeer(conn.peer, assignedSeatId, context);
        }
      } catch (e) {
        console.warn("[CameraManager] callPeer on hello error:", e);
      }
    }
    /**
     * Handles peer disconnection on the host, converting mid-game seats to CPU.
     * @param {Object} conn
     * @param {Object} [context]
     */
    /**
     * Checks whether the current game has more than 1 human player.
     * @param {Object} [settings]
     * @returns {boolean}
     */
    static isMultiHuman(settings3) {
      if (!settings3) return false;
      if (Array.isArray(settings3.seats)) {
        const humans = settings3.seats.filter((s) => s && s.type === "human");
        if (humans.length >= 2) return true;
      }
      return Boolean(settings3.opp === "online" || settings3.opp === "hvh" || settings3.isHvH);
    }
    /**
     * Checks whether a seat is currently connected online.
     * @param {string} seatId
     * @param {Object} [context]
     * @returns {boolean}
     */
    static isSeatOnline(seatId, context = {}) {
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const sId = String(seatId || "p1").toLowerCase();
      if (settings3 && settings3.seats) {
        const s = settings3.seats.find((x) => x && x.id === sId);
        if (s && s.type !== "human") return false;
        if (s && s.online === false) return false;
      }
      const isHvH2 = Boolean(settings3 && (settings3.isHvH || settings3.opp === "hvh"));
      if (isHvH2) return true;
      if (!settings3 || settings3.opp !== "online") {
        return false;
      }
      const isHost = Boolean(
        settings3 && settings3.netRole === "host" || net2 && (net2.isHost === true || net2.role === "host")
      );
      const isGuest = Boolean(
        settings3 && settings3.netRole === "guest" || net2 && (net2.isHost === false || net2.role === "guest") || !isHost && net2 && (net2.conn || net2.mySeatId)
      );
      if (isHost) {
        if (sId === "p1") return true;
        if (net2 && net2.clients) {
          for (const [, c] of net2.clients.entries()) {
            if (c && c.seatId === sId) {
              return Boolean(c.conn && c.conn.open);
            }
          }
        }
        return false;
      }
      if (isGuest) {
        const isConnectedToHost = Boolean(net2 && (net2.conn ? net2.conn.open : net2.ready) && !net2._handledHostDisconnect);
        if (!isConnectedToHost) {
          return false;
        }
        if (sId === "p1") {
          if (settings3 && settings3.seats) {
            const s = settings3.seats.find((x) => x && x.id === "p1");
            if (s && s.online === false) return false;
          }
          return true;
        }
        const mySeat3 = net2 && net2.mySeatId ? net2.mySeatId : "p2";
        if (sId === mySeat3) {
          return true;
        }
        if (net2 && Array.isArray(net2.onlineSeats)) {
          return net2.onlineSeats.includes(sId);
        }
        if (settings3 && settings3.seats) {
          const s = settings3.seats.find((x) => x && x.id === sId);
          if (s && s.online !== void 0) return Boolean(s.online);
        }
        return false;
      }
      if (settings3 && settings3.seats) {
        const s = settings3.seats.find((x) => x && x.id === sId);
        if (s && s.online !== void 0) return Boolean(s.online);
      }
      if (sId === "p1") return true;
      if (net2 && net2.conn) return Boolean(net2.conn.open);
      return false;
    }
    /**
     * Handles peer disconnection on the host, notifying player and offering AI replacement.
     * @param {Object} conn
     * @param {Object} [context]
     */
    static handleClientDisconnect(conn, context = {}) {
      if (!conn) return;
      if (conn._handledDisconnect) return;
      conn._handledDisconnect = true;
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2) return;
      let client = net2.clients ? net2.clients.get(conn.peer) : null;
      if (!client && net2.clients) {
        for (const c of net2.clients.values()) {
          if (c && (c.conn === conn || c.seatId && c.seatId === conn._seatId)) {
            client = c;
            break;
          }
        }
      }
      const sId = client ? client.seatId : conn._seatId;
      const sName = client ? client.name : sId ? `Player ${sId.slice(1)}` : "A player";
      if (sId) {
        try {
          const camMgr = context.CameraManager && context.CameraManager.getInstance ? context.CameraManager.getInstance() : CameraManager2.getInstance();
          if (camMgr) camMgr.removeRemoteTile(sId, context);
        } catch (e) {
          console.warn("[CameraManager] removeRemoteTile on disconnect error:", e);
        }
      }
      if (net2.clients) {
        if (conn.peer) net2.clients.delete(conn.peer);
        for (const [pId, c] of net2.clients.entries()) {
          if (c && (c.conn === conn || c.seatId === sId)) {
            net2.clients.delete(pId);
          }
        }
        if (net2.conn === conn) {
          net2.conn = net2.clients.values().next().value ? net2.clients.values().next().value.conn : null;
        }
        if (net2.clients.size === 0) {
          net2.ready = false;
        }
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (sId && settings3 && settings3.seats) {
        const s = settings3.seats.find((x) => x && x.id === sId);
        if (s) {
          s.online = false;
        }
      }
      const remainingOnline = ["p1"];
      if (net2 && net2.clients) {
        for (const c of net2.clients.values()) {
          if (c && c.seatId && c.seatId !== sId && c.conn && c.conn.open) {
            remainingOnline.push(c.seatId);
          }
        }
      }
      if (net2) {
        net2.onlineSeats = Array.from(new Set(remainingOnline));
      }
      if (net2 && net2.clients) {
        for (const c of net2.clients.values()) {
          if (c && c.conn && c.conn.open) {
            try {
              c.conn.send({
                type: "player_offline",
                seatId: sId,
                name: sName,
                onlineSeats: net2.onlineSeats
              });
            } catch (e) {
            }
          }
        }
      }
      const broadcastLobbyUpdate2 = context.broadcastLobbyUpdate || (typeof window !== "undefined" ? window.broadcastLobbyUpdate : _NetworkManager.broadcastLobbyUpdate);
      if (typeof broadcastLobbyUpdate2 === "function") broadcastLobbyUpdate2();
      const updateNetRoster2 = context.updateNetRoster || (typeof window !== "undefined" ? window.updateNetRoster : _NetworkManager.updateNetRoster);
      if (typeof updateNetRoster2 === "function") updateNetRoster2();
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
      });
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : _NetworkManager.netPush);
      setNetStatus2(`${sName} went offline.`, "wait");
      log2(`${sName} went offline.`);
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : null);
      if (typeof renderScores2 === "function") renderScores2(false);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : null);
      if (typeof render2 === "function") render2();
      if (typeof netPush2 === "function") {
        netPush2({}, context);
      }
      if (state3 && !state3.over) {
        const onPlayerOffline = context.onPlayerOffline || (typeof window !== "undefined" ? window.handlePlayerOfflinePrompt : null);
        if (typeof onPlayerOffline === "function") {
          onPlayerOffline(sId, sName);
        } else {
          _NetworkManager.replaceSeatWithCpu(sId, "shark", "The Shark", context);
        }
      }
    }
    /**
     * Handles host disconnection on the guest client.
     * @param {Object} [context]
     */
    static handleHostDisconnect(context = {}) {
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2) return;
      if (net2._handledHostDisconnect) return;
      net2._handledHostDisconnect = true;
      net2.ready = false;
      if (net2.conn) {
        try {
          net2.conn.open = false;
        } catch (e) {
        }
      }
      net2.onlineSeats = [];
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3 && settings3.seats) {
        settings3.seats.forEach((s) => {
          if (s && s.id === "p1") {
            s.online = false;
          }
        });
      }
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      hideWait2();
      const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
      });
      setNetStatus2("Host disconnected from room.", "wait");
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      log2("Host disconnected from room.");
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : null);
      if (typeof renderScores2 === "function") renderScores2(false);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : null);
      if (typeof render2 === "function") render2();
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const onPlayerOffline = context.onPlayerOffline || (typeof window !== "undefined" ? window.handlePlayerOfflinePrompt : null);
      if (state3 && !state3.over && typeof onPlayerOffline === "function") {
        onPlayerOffline("p1", "Host");
      }
    }
    /**
     * Replaces a disconnected human seat with a designated computer player personality.
     * @param {string} seatId
     * @param {string} [aiProfile='shark']
     * @param {string} [personalityName='The Shark']
     * @param {Object} [context]
     */
    static replaceSeatWithCpu(seatId, aiProfile = "shark", personalityName = "The Shark", context = {}) {
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
      });
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : _NetworkManager.netPush);
      let updatedSeatName = `${personalityName} (${(seatId || "").toUpperCase()})`;
      if (seatId && settings3 && settings3.seats) {
        const s = settings3.seats.find((x) => x.id === seatId);
        if (s) {
          s.type = "cpu";
          s.personality = aiProfile;
          s.name = `${personalityName} (${seatId.toUpperCase()})`;
          s.online = false;
          updatedSeatName = s.name;
        }
      }
      if (typeof window !== "undefined") {
        window._currentRoster = null;
      }
      setNetStatus2(`${personalityName} took over ${seatId.toUpperCase()}.`, "on");
      log2(`Computer player ${personalityName} (${aiProfile.toUpperCase()}) took over seat ${seatId.toUpperCase()}.`);
      if (typeof netPush2 === "function") {
        netPush2({
          log: `${personalityName} took over ${seatId.toUpperCase()}.`,
          seats: settings3 ? settings3.seats : void 0
        });
      }
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : null);
      if (typeof renderScores2 === "function") renderScores2(false);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : null);
      if (typeof render2 === "function") render2();
      if (state3 && !state3.over) {
        if (state3.turn === seatId && state3.phase === "play") {
          const scheduleOppPlay2 = context.scheduleOppPlay || (typeof window !== "undefined" ? window.scheduleOppPlay : null);
          if (typeof scheduleOppPlay2 === "function") {
            scheduleOppPlay2(seatId);
          }
        } else if (state3.phase === "discard") {
          const kept = state3.keptCards ? state3.keptCards[seatId] : null;
          if (!kept || !kept.length) {
            const chooseDiscard2 = context.chooseDiscard || (typeof window !== "undefined" ? window.chooseDiscard : null);
            const handleSeatDiscardIntent2 = context.handleSeatDiscardIntent || (typeof window !== "undefined" ? window.handleSeatDiscardIntent : null);
            const sHand = state3.hands ? state3.hands[seatId] : [];
            if (typeof chooseDiscard2 === "function" && typeof handleSeatDiscardIntent2 === "function" && sHand && sHand.length > 4) {
              const isDealer = state3.dealer === seatId;
              const discardN = parseInt(settings3?.playerCount, 10) === 2 ? 2 : 1;
              const toDeck = Boolean(settings3?.optNoPassingLanes);
              const cpuThrow = chooseDiscard2(sHand, isDealer, settings3?.goal === "low", discardN, toDeck);
              if (cpuThrow && cpuThrow.length) {
                handleSeatDiscardIntent2(seatId, cpuThrow.map((c) => c.id || c));
              }
            }
          }
        } else if (state3.phase === "cut" || state3.phase === "cut-pick") {
          const pickCut2 = context.pickCut || (typeof window !== "undefined" ? window.pickCut : null);
          if (typeof pickCut2 === "function") {
            pickCut2(seatId, 0);
          }
        }
      }
    }
    /**
     * Binds data, close, and error listeners on incoming client connection.
     * @param {Object} conn
     * @param {Object} [context]
     */
    static bindHostClientConn(conn, context = {}) {
      conn.on("open", () => {
      });
      conn.on("data", (msg) => {
        if (!msg || typeof msg !== "object") return;
        const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
        if (net2 && net2.clients) {
          const client = net2.clients.get(conn.peer);
          if (client) client.lastSeen = Date.now();
        }
        if (msg.type === "client_leave" || msg.type === "leave" || msg.type === "disconnect") {
          const handleClientDisconnect2 = context.handleClientDisconnect || (typeof window !== "undefined" ? window.handleClientDisconnect : _NetworkManager.handleClientDisconnect);
          if (typeof handleClientDisconnect2 === "function") handleClientDisconnect2(conn, context);
          return;
        } else if (msg.type === "pong") {
          return;
        } else if (msg.type === "ping") {
          try {
            conn.send({ type: "pong", seatId: "p1" });
          } catch (e) {
          }
          return;
        } else if (msg.type === "hello") {
          const handleClientHello2 = context.handleClientHello || (typeof window !== "undefined" ? window.handleClientHello : _NetworkManager.handleClientHello);
          if (typeof handleClientHello2 === "function") handleClientHello2(conn, msg);
        } else if (msg.type === "intent") {
          const hostApplyIntent2 = context.hostApplyIntent || (typeof window !== "undefined" ? window.hostApplyIntent : _NetworkManager.hostApplyIntent);
          if (typeof hostApplyIntent2 === "function") hostApplyIntent2(msg, conn);
        } else if (msg.type === "cam_state") {
          try {
            const camMgr = context.CameraManager && context.CameraManager.getInstance ? context.CameraManager.getInstance() : CameraManager2.getInstance();
            if (camMgr) camMgr.handleCamStateMessage(msg, context);
            if (net2 && net2.clients) {
              for (const [pId, c] of net2.clients.entries()) {
                if (c && c.conn && pId !== conn.peer) {
                  try {
                    c.conn.send(msg);
                  } catch (e) {
                  }
                }
              }
            }
          } catch (e) {
            console.warn("[CameraManager] Host cam_state relay error:", e);
          }
        } else if (msg.type === "chat") {
          try {
            const chatMgr = context.ChatManager && context.ChatManager.getInstance ? context.ChatManager.getInstance() : ChatManager.getInstance();
            if (chatMgr) chatMgr.handleIncomingMessage(msg, context);
            if (net2 && net2.clients) {
              for (const [pId, c] of net2.clients.entries()) {
                if (c && c.conn && pId !== conn.peer) {
                  try {
                    c.conn.send(msg);
                  } catch (e) {
                  }
                }
              }
            }
          } catch (e) {
            console.warn("[ChatManager] Host chat relay error:", e);
          }
        } else if (msg.type === "reaction") {
          try {
            const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
            ReactionManager.handleRemoteReaction(msg, { sfx: sfx3 });
            if (net2 && net2.clients) {
              for (const [pId, c] of net2.clients.entries()) {
                if (c && c.conn && pId !== conn.peer) {
                  try {
                    c.conn.send(msg);
                  } catch (e) {
                  }
                }
              }
            }
          } catch (e) {
            console.warn("[ReactionManager] Host reaction relay error:", e);
          }
        } else if (msg.type === "tournament_update") {
          try {
            if (net2 && net2.clients) {
              for (const [pId, c] of net2.clients.entries()) {
                if (c && c.conn && pId !== conn.peer) {
                  try {
                    c.conn.send(msg);
                  } catch (e) {
                  }
                }
              }
            }
          } catch (e) {
            console.warn("[Tournament] Host tournament relay error:", e);
          }
        } else if (msg.type === "avatar_update") {
          try {
            _NetworkManager.handleAvatarUpdate(msg, context);
            if (net2 && net2.clients) {
              for (const [pId, c] of net2.clients.entries()) {
                if (c && c.conn && pId !== conn.peer) {
                  try {
                    c.conn.send(msg);
                  } catch (e) {
                  }
                }
              }
            }
          } catch (e) {
            console.warn("[AvatarManager] Host avatar relay error:", e);
          }
        }
      });
      const triggerDisconnect = () => {
        const handleClientDisconnect2 = context.handleClientDisconnect || (typeof window !== "undefined" ? window.handleClientDisconnect : _NetworkManager.handleClientDisconnect);
        if (typeof handleClientDisconnect2 === "function") handleClientDisconnect2(conn, context);
      };
      conn.on("close", triggerDisconnect);
      conn.on("error", (err) => {
        console.warn("Client conn error:", err);
        triggerDisconnect();
      });
      if (conn.peerConnection) {
        try {
          conn.peerConnection.addEventListener("connectionstatechange", () => {
            const st = conn.peerConnection.connectionState;
            if (st === "disconnected" || st === "failed" || st === "closed") {
              triggerDisconnect();
            }
          });
          conn.peerConnection.addEventListener("iceconnectionstatechange", () => {
            const st = conn.peerConnection.iceConnectionState;
            if (st === "disconnected" || st === "failed" || st === "closed") {
              triggerDisconnect();
            }
          });
        } catch (e) {
        }
      }
    }
    /**
     * Displays the host invite link box in lobby.
     * @param {string} code
     * @param {Object} [context]
     */
    static showHostInviteLink(code, context = {}) {
      const getJoinUrl2 = context.getJoinUrl || (typeof window !== "undefined" && typeof window.getJoinUrl === "function" ? window.getJoinUrl : _NetworkManager.getJoinUrl);
      const joinUrl = getJoinUrl2(code);
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const btnCopy = doc.getElementById("btnCopyRoomLink");
      const bar = doc.getElementById("netInviteBox");
      const inp = doc.getElementById("netInviteUrl");
      const shareBox = doc.getElementById("netShareBox");
      if (btnCopy) btnCopy.style.display = "inline-flex";
      if (bar && inp) {
        inp.value = joinUrl;
        bar.style.display = "flex";
      }
      if (shareBox) {
        shareBox.style.display = "flex";
      }
    }
    /**
     * Hides the host invite link box and share box.
     * @param {Object} [context]
     */
    static hideHostInviteLink(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (!doc) return;
      const btnCopy = doc.getElementById("btnCopyRoomLink");
      const bar = doc.getElementById("netInviteBox");
      const shareBox = doc.getElementById("netShareBox");
      if (btnCopy) btnCopy.style.display = "none";
      if (bar) bar.style.display = "none";
      if (shareBox) shareBox.style.display = "none";
    }
    /**
     * Builds structured room share data.
     * @param {Object} [context]
     * @returns {{code: string, joinUrl: string, title: string, text: string}}
     */
    static getRoomShareData(context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      const optRoom = doc ? doc.getElementById("optRoom") : null;
      const code = net2 && net2.room || optRoom && optRoom.value || "";
      const cleanCode = code.trim().toUpperCase();
      const getJoinUrl2 = context.getJoinUrl || (typeof window !== "undefined" && typeof window.getJoinUrl === "function" ? window.getJoinUrl : _NetworkManager.getJoinUrl);
      const joinUrl = cleanCode ? getJoinUrl2(cleanCode) : typeof window !== "undefined" && window.location ? window.location.href : "";
      const title = "Crazy Cribbage Online";
      const text2 = cleanCode ? `Join my Crazy Cribbage online room! Room code: ${cleanCode}` : "Play Crazy Cribbage online!";
      return { code: cleanCode, joinUrl, title, text: text2 };
    }
    /**
     * Triggers native Web Share API or falls back to the full share modal.
     * @param {Object} [context]
     */
    static shareRoomInvite(context = {}) {
      const { code, joinUrl, title, text: text2 } = _NetworkManager.getRoomShareData(context);
      const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
      });
      if (!code) {
        setNetStatus2("Please host or enter a room code first.", "");
        return;
      }
      if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
        navigator.share({
          title,
          text: text2,
          url: joinUrl
        }).catch((err) => {
          if (err && err.name !== "AbortError") {
            if (typeof window !== "undefined" && typeof window.showShareModal === "function") {
              window.showShareModal();
            }
          }
        });
      } else if (typeof window !== "undefined" && typeof window.showShareModal === "function") {
        window.showShareModal();
      } else {
        _NetworkManager.copyRoomInviteLink(null, context);
      }
    }
    /**
     * Quick share via WhatsApp.
     * @param {Object} [context]
     */
    static shareRoomWhatsApp(context = {}) {
      const { code, joinUrl, text: text2 } = _NetworkManager.getRoomShareData(context);
      if (!code) return;
      const shareMsg = `${text2}
${joinUrl}`;
      const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareMsg)}`;
      if (typeof window !== "undefined") window.open(url, "_blank", "noopener,noreferrer");
    }
    /**
     * Quick share via Email.
     * @param {Object} [context]
     */
    static shareRoomEmail(context = {}) {
      const { code, joinUrl, text: text2 } = _NetworkManager.getRoomShareData(context);
      if (!code) return;
      const subject = `Join my Crazy Cribbage Game (Room: ${code})`;
      const body = `Hey,

Join my Crazy Cribbage online game!

Room Code: ${code}
Invite Link: ${joinUrl}

Click the link above to join directly from your browser!`;
      const mailto = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      if (typeof window !== "undefined") window.location.href = mailto;
    }
    /**
     * Copies host invite link to user clipboard with visual feedback.
     * @param {HTMLElement} [btnEl]
     * @param {Object} [context]
     */
    static copyRoomInviteLink(btnEl, context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      const optRoom = doc ? doc.getElementById("optRoom") : null;
      const code = net2 && net2.room || optRoom && optRoom.value || "";
      const cleanCode = code.trim().toUpperCase();
      const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
      });
      if (!cleanCode) {
        setNetStatus2("Please host or enter a room code first.", "");
        return;
      }
      const getJoinUrl2 = context.getJoinUrl || (typeof window !== "undefined" && typeof window.getJoinUrl === "function" ? window.getJoinUrl : _NetworkManager.getJoinUrl);
      const joinUrl = getJoinUrl2(cleanCode);
      const targetBtn = btnEl || (doc ? doc.getElementById("btnCopyRoomLink") : null);
      const txtSpan = doc ? doc.getElementById("btnCopyRoomLinkText") : null;
      const barBtn = doc ? doc.getElementById("btnCopyRoomLinkBar") : null;
      const onCopied = () => {
        if (txtSpan) txtSpan.textContent = "Copied!";
        else if (targetBtn) targetBtn.textContent = "Copied!";
        if (barBtn) barBtn.textContent = "Copied!";
        if (targetBtn) targetBtn.style.filter = "brightness(1.25)";
        setNetStatus2("Invite link copied! Share it with friends to join\u2026", "wait");
        setTimeout(() => {
          if (txtSpan) txtSpan.textContent = "Copy Link";
          else if (targetBtn) targetBtn.textContent = "Copy Link";
          if (barBtn) barBtn.textContent = "Copy";
          if (targetBtn) targetBtn.style.filter = "";
        }, 2500);
      };
      const nav = typeof navigator !== "undefined" ? navigator : null;
      if (nav && nav.clipboard && nav.clipboard.writeText) {
        nav.clipboard.writeText(joinUrl).then(onCopied).catch(() => {
          _NetworkManager.fallbackCopyText(joinUrl, onCopied, doc);
        });
      } else {
        _NetworkManager.fallbackCopyText(joinUrl, onCopied, doc);
      }
    }
    /**
     * Fallback copy mechanism using temporary textarea element.
     * @param {string} text
     * @param {Function} [cb]
     * @param {Document} [doc]
     */
    static fallbackCopyText(text2, cb, doc = null) {
      const documentObj = doc || (typeof document !== "undefined" ? document : null);
      if (!documentObj) {
        if (cb) cb();
        return;
      }
      const inp = documentObj.getElementById("netInviteUrl");
      if (inp) {
        inp.value = text2;
        inp.select();
        try {
          documentObj.execCommand("copy");
          if (cb) cb();
          return;
        } catch (e) {
        }
      }
      const temp = documentObj.createElement("textarea");
      temp.value = text2;
      temp.style.position = "fixed";
      temp.style.opacity = "0";
      documentObj.body.appendChild(temp);
      temp.select();
      try {
        documentObj.execCommand("copy");
        if (cb) cb();
      } catch (e) {
        if (typeof prompt === "function") prompt("Copy this invite link:", text2);
      }
      if (temp.parentNode) temp.parentNode.removeChild(temp);
    }
    /**
     * Prompts the player to enter their name before joining a multiplayer room.
     * @param {string} code
     * @param {Function} onConfirm
     * @param {Object} [context]
     */
    static promptPlayerName(code, onConfirm, context = {}) {
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const showModal2 = context.showModal || (typeof window !== "undefined" ? window.showModal : null);
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : null);
      let initialName = "";
      const s = getStorage7(context);
      try {
        initialName = doc && doc.getElementById("optPlayerName") && doc.getElementById("optPlayerName").value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : "");
      } catch (e) {
      }
      const html2 = `
      <div style="text-align:center;padding:16px 12px;max-width:380px;margin:0 auto;">
        <div style="font-size:2.2rem;margin-bottom:8px;">\u{1F44B}</div>
        <h2 style="margin:0 0 8px;color:#f0c64a;font-size:1.35rem;letter-spacing:0.03em;">Join Room ${code || "Game"}</h2>
        <p style="margin:0 0 16px;color:#f4ead4;font-size:0.95rem;line-height:1.4;">Please enter your name so scoring, bonus options, and match results can be displayed for you and your opponent:</p>
        <form id="joinNameForm" style="display:flex;flex-direction:column;align-items:center;gap:12px;width:100%;">
          <input id="joinPlayerNameInput" maxlength="16" placeholder="Your Name" value="${initialName.replace(/"/g, "&quot;")}" pattern="[a-zA-Z0-9]+" autofocus
            style="width:90%;max-width:260px;padding:10px 14px;border-radius:8px;border:2px solid #f0c64a;font-size:1.05rem;font-weight:700;background:#f4ead4 !important;background-color:#f4ead4 !important;color:#111 !important;-webkit-text-fill-color:#111 !important;caret-color:#111 !important;color-scheme:light !important;text-align:center;outline:none;" />
          <p id="joinNameError" style="display:none;margin:-4px 0 0;font-size:0.85rem;color:#ef4444;font-weight:600;">Please enter a name to join the game.</p>
          <div style="display:flex;gap:10px;margin-top:6px;width:100%;justify-content:center;">
            <button type="submit" class="btn-gold" id="btnConfirmJoinName" style="padding:8px 24px;font-size:1rem;font-weight:700;">Join Room</button>
            <button type="button" class="btn-ghost" id="btnCancelJoinName" style="padding:8px 16px;font-size:0.95rem;">Cancel</button>
          </div>
        </form>
      </div>
    `;
      if (typeof showModal2 === "function") {
        showModal2(html2, false);
        if (doc) {
          const inp = doc.getElementById("joinPlayerNameInput");
          const err = doc.getElementById("joinNameError");
          const form = doc.getElementById("joinNameForm");
          const btnOk = doc.getElementById("btnConfirmJoinName");
          const btnCancel = doc.getElementById("btnCancelJoinName");
          const doJoin = () => {
            const val = inp ? sanitizeUserInput(inp.value).replace(/[^a-zA-Z0-9]/g, "").trim() : "";
            if (!val) {
              if (err) err.style.display = "block";
              if (inp) {
                inp.style.borderColor = "#ef4444";
                inp.focus();
              }
              return;
            }
            try {
              if (s) s.setItem("cc_player_name", val);
            } catch (e) {
            }
            const opt = doc.getElementById("optPlayerName");
            if (opt) opt.value = val;
            if (typeof hideModal3 === "function") hideModal3();
            if (typeof onConfirm === "function") onConfirm(val);
          };
          if (form && typeof form.addEventListener === "function") {
            form.addEventListener("submit", (e) => {
              e.preventDefault();
              doJoin();
            });
          } else if (form) {
            form.onsubmit = (e) => {
              e.preventDefault();
              doJoin();
            };
          }
          if (inp) {
            setTimeout(() => {
              try {
                inp.focus();
                inp.select();
              } catch (e) {
              }
            }, 50);
            inp.addEventListener("input", () => {
              inp.value = sanitizeUserInput(inp.value).replace(/[^a-zA-Z0-9]/g, "");
              if (err) err.style.display = "none";
              inp.style.borderColor = "#f0c64a";
            });
          }
          if (btnOk) btnOk.onclick = (e) => {
            e.preventDefault();
            doJoin();
          };
          if (btnCancel) btnCancel.onclick = (e) => {
            e.preventDefault();
            if (typeof hideModal3 === "function") hideModal3();
            const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
            });
            setNetStatus2("Join cancelled. Enter your name and click Join to enter room.", "");
          };
        }
      } else {
        const val = typeof window !== "undefined" && typeof window.prompt === "function" ? window.prompt(`Enter your name to join Room ${code}:`, initialName) : initialName;
        if (val) {
          const clean = sanitizeUserInput(val).replace(/[^a-zA-Z0-9]/g, "").trim();
          if (clean) {
            try {
              if (s) s.setItem("cc_player_name", clean);
            } catch (e) {
            }
            const opt = doc ? doc.getElementById("optPlayerName") : null;
            if (opt) opt.value = clean;
            if (typeof onConfirm === "function") onConfirm(clean);
          }
        }
      }
    }
    /**
     * Hosts a new multiplayer room via PeerJS.
     * @param {Object} [context]
     */
    static hostRoom(context = {}) {
      const PeerClass = context.PeerClass || (typeof Peer !== "undefined" ? Peer : typeof window !== "undefined" ? window.Peer : null);
      const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
      });
      if (!PeerClass) {
        setNetStatus2("PeerJS failed to load. Use http/https, not file://", "");
        return;
      }
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const hostInput = doc ? doc.getElementById("optPlayerName") : null;
      const s = getStorage7(context);
      const hostName = hostInput && hostInput.value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : "") || "Host";
      if (hostInput && !hostInput.value) hostInput.value = hostName;
      try {
        if (hostName && hostName !== "Host" && s) s.setItem("cc_player_name", hostName);
      } catch (e) {
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (settings3) {
        settings3.opp = "online";
        settings3.netRole = "host";
        if (settings3.seats && settings3.seats[0]) {
          settings3.seats[0].name = hostName;
          settings3.seats[0].type = "human";
          settings3.seats[0].online = true;
        }
      }
      if (typeof window !== "undefined") {
        window._currentRoster = null;
      }
      if (net2) {
        net2.isHost = true;
        net2.role = "host";
        net2.mySeatId = "p1";
        net2.clients = /* @__PURE__ */ new Map();
        net2.onlineSeats = ["p1"];
      }
      const optRoom = doc ? doc.getElementById("optRoom") : null;
      const makeRoomCode2 = context.makeRoomCode || (typeof window !== "undefined" && typeof window.makeRoomCode === "function" ? window.makeRoomCode : _NetworkManager.generateRoomCode);
      const code = (optRoom && optRoom.value || "").trim().toUpperCase() || makeRoomCode2();
      if (optRoom) optRoom.value = code;
      if (net2) net2.room = code;
      const showHostInviteLink2 = context.showHostInviteLink || (typeof window !== "undefined" ? window.showHostInviteLink : _NetworkManager.showHostInviteLink);
      const updateNetRoster2 = context.updateNetRoster || (typeof window !== "undefined" ? window.updateNetRoster : _NetworkManager.updateNetRoster);
      const bindHostClientConn2 = context.bindHostClientConn || (typeof window !== "undefined" ? window.bindHostClientConn : _NetworkManager.bindHostClientConn);
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      if (typeof showHostInviteLink2 === "function") showHostInviteLink2(code);
      if (typeof updateNetRoster2 === "function") updateNetRoster2();
      setNetStatus2("Opening room " + code + "\u2026", "wait");
      if (net2) {
        try {
          if (net2.peer) net2.peer.destroy();
        } catch (e) {
        }
        net2.peer = new PeerClass("ccb-" + code, DEFAULT_PEER_CONFIG);
        net2.peer.on("open", () => {
          net2.ready = true;
          setNetStatus2("Room " + code + " ready. Waiting for players\u2026", "wait");
          if (typeof showHostInviteLink2 === "function") showHostInviteLink2(code);
          if (typeof updateNetRoster2 === "function") updateNetRoster2();
          _NetworkManager.startHeartbeat(context);
          _NetworkManager.initUnloadHandler(context);
        });
        net2.peer.on("connection", (conn) => {
          if (typeof bindHostClientConn2 === "function") bindHostClientConn2(conn);
        });
        net2.peer.on("call", (call) => {
          try {
            const camMgr = context.CameraManager && context.CameraManager.getInstance ? context.CameraManager.getInstance() : CameraManager2.getInstance();
            if (camMgr) camMgr.handleIncomingCall(call, context);
          } catch (e) {
            console.warn("[CameraManager] Host incoming call error:", e);
          }
        });
        net2.peer.on("error", (err) => {
          hideWait2();
          setNetStatus2("Host error: " + (err ? err.type || err : "unknown"), "");
        });
      }
    }
    /**
     * Joins an existing host room via PeerJS.
     * @param {string} [codeParam]
     * @param {Object} [context]
     */
    static joinRoom(codeParam = null, context = {}) {
      const PeerClass = context.PeerClass || (typeof Peer !== "undefined" ? Peer : typeof window !== "undefined" ? window.Peer : null);
      const setNetStatus2 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
      });
      const hideWait2 = context.hideWait || (typeof window !== "undefined" ? window.hideWait : () => {
      });
      if (!PeerClass) {
        setNetStatus2("PeerJS failed to load. Use http/https, not file://", "");
        hideWait2();
        return;
      }
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      const optRoom = doc ? doc.getElementById("optRoom") : null;
      const code = (codeParam || optRoom && optRoom.value || "").trim().toUpperCase();
      if (!code) {
        setNetStatus2("Enter the host room code first.", "");
        hideWait2();
        return;
      }
      const optPlayerName = doc ? doc.getElementById("optPlayerName") : null;
      const s = getStorage7(context);
      let myName = (context.playerName || optPlayerName && optPlayerName.value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : "")).trim();
      if (!myName) {
        hideWait2();
        _NetworkManager.promptPlayerName(code, (enteredName) => {
          _NetworkManager.joinRoom(code, { ...context, playerName: enteredName });
        }, context);
        return;
      }
      if (optPlayerName && !optPlayerName.value) optPlayerName.value = myName;
      try {
        if (s) s.setItem("cc_player_name", myName);
      } catch (e) {
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (settings3) {
        settings3.opp = "online";
        settings3.netRole = "guest";
      }
      if (net2) {
        net2.isHost = false;
        net2.role = "guest";
        net2.room = code;
      }
      setNetStatus2("Joining " + code + "\u2026", "wait");
      if (net2) {
        try {
          if (net2.peer) net2.peer.destroy();
        } catch (e) {
        }
        net2.peer = new PeerClass(DEFAULT_PEER_CONFIG);
        net2.peer.on("call", (call) => {
          try {
            const camMgr = context.CameraManager && context.CameraManager.getInstance ? context.CameraManager.getInstance() : CameraManager2.getInstance();
            if (camMgr) camMgr.handleIncomingCall(call, context);
          } catch (e) {
            console.warn("[CameraManager] Guest incoming call error:", e);
          }
        });
        net2.peer.on("open", () => {
          const conn = net2.peer.connect("ccb-" + code, { reliable: true });
          net2.conn = conn;
          conn.on("open", () => {
            hideWait2();
            const avMgr = context.AvatarManager || typeof window !== "undefined" && window.AvatarManager || AvatarManager || null;
            const myAvatarId = avMgr && typeof avMgr.getSelectedAvatarId === "function" ? avMgr.getSelectedAvatarId(s) : "jack";
            const helloPayload = { type: "hello", name: myName, avatarId: myAvatarId };
            if (myAvatarId === "custom" && avMgr && typeof avMgr.getCustomAvatarData === "function") {
              const dataUrl = avMgr.getCustomAvatarData(s);
              if (dataUrl) helloPayload.customAvatarData = dataUrl;
            }
            conn.send(helloPayload);
            setNetStatus2("Connected to room " + code + ". Waiting for seat\u2026", "wait");
          });
          conn.on("data", (msg) => {
            if (!msg || typeof msg !== "object") return;
            if (net2) net2.lastHostSeen = Date.now();
            if (msg.type === "host_offline" || msg.type === "leave" && msg.seatId === "p1") {
              _NetworkManager.handleHostDisconnect(context);
              return;
            } else if (msg.type === "player_offline") {
              if (msg.seatId && settings3 && settings3.seats) {
                const s2 = settings3.seats.find((x) => x && x.id === msg.seatId);
                if (s2) s2.online = false;
              }
              if (Array.isArray(msg.onlineSeats)) {
                net2.onlineSeats = msg.onlineSeats;
              } else if (net2 && net2.onlineSeats && msg.seatId) {
                net2.onlineSeats = net2.onlineSeats.filter((id) => id !== msg.seatId);
              }
              const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : null);
              if (typeof renderScores2 === "function") renderScores2(false);
              const render2 = context.render || (typeof window !== "undefined" ? window.render : null);
              if (typeof render2 === "function") render2();
              const setNetStatus3 = context.setNetStatus || (typeof window !== "undefined" ? window.setNetStatus : () => {
              });
              const offlineName = _NetworkManager.sanitizePlayerName(msg.name, msg.seatId ? msg.seatId.toUpperCase() : "Player");
              setNetStatus3(`${offlineName} went offline.`, "wait");
              return;
            } else if (msg.type === "ping") {
              try {
                conn.send({ type: "pong", seatId: net2.mySeatId });
              } catch (e) {
              }
              return;
            } else if (msg.type === "pong") {
              return;
            }
            const updateNetRoster2 = context.updateNetRoster || (typeof window !== "undefined" ? window.updateNetRoster : _NetworkManager.updateNetRoster);
            const applyRemoteState2 = context.applyRemoteState || (typeof window !== "undefined" ? window.applyRemoteState : _NetworkManager.applyRemoteState);
            if (msg.type === "welcome") {
              net2.mySeatId = msg.seatId;
              net2.ready = true;
              _NetworkManager.startHeartbeat(context);
              _NetworkManager.initUnloadHandler(context);
              if (Array.isArray(msg.onlineSeats)) {
                net2.onlineSeats = msg.onlineSeats;
              }
              if (settings3) {
                if (Array.isArray(msg.seats)) {
                  for (const s2 of msg.seats) {
                    if (s2 && s2.name) {
                      s2.name = _NetworkManager.sanitizePlayerName(s2.name, `Player ${(s2.id || "").slice(1)}`);
                    }
                  }
                  settings3.seats = msg.seats;
                }
                if (msg.playerCount) settings3.playerCount = msg.playerCount;
                if (settings3.seats) {
                  const mySeatObj = settings3.seats.find((s2) => s2 && s2.id === msg.seatId);
                  if (mySeatObj) {
                    mySeatObj.name = _NetworkManager.sanitizePlayerName(myName, `Player ${(msg.seatId || "").slice(1)}`);
                    mySeatObj.type = "human";
                    mySeatObj.online = true;
                  }
                  const hostSeatObj = settings3.seats.find((s2) => s2 && s2.id === "p1");
                  if (hostSeatObj) {
                    hostSeatObj.online = true;
                  }
                }
              }
              if (typeof window !== "undefined") window._currentRoster = null;
              if (Array.isArray(msg.seats)) {
                const avMgr = context.AvatarManager || typeof window !== "undefined" && window.AvatarManager || AvatarManager || null;
                const BoardRenderer2 = context.BoardRenderer || (typeof window !== "undefined" ? window.BoardRenderer : null);
                for (const sObj of msg.seats) {
                  if (sObj && sObj.id && sObj.id !== net2.mySeatId) {
                    if (sObj.avatar === "custom" && sObj.customAvatarData && avMgr && typeof avMgr.registerRemoteCustomAvatar === "function") {
                      avMgr.registerRemoteCustomAvatar(sObj.id, sObj.customAvatarData, sObj.name || `Player ${sObj.id.slice(1)}`);
                    }
                    if (BoardRenderer2 && typeof BoardRenderer2.updatePegAvatarPattern === "function") {
                      const patId = sObj.avatar === "custom" ? "custom_" + sObj.id : sObj.avatar || "jack";
                      BoardRenderer2.updatePegAvatarPattern(sObj.id, patId);
                    }
                  }
                }
                const bRenderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
                if (bRenderer3D && typeof bRenderer3D.updatePegAvatars === "function") {
                  bRenderer3D.updatePegAvatars();
                }
              }
              setNetStatus2(`Connected as ${myName} (${msg.seatId.toUpperCase()})! Waiting for host to start\u2026`, "on");
              if (typeof updateNetRoster2 === "function") updateNetRoster2(msg.roster);
            } else if (msg.type === "lobby") {
              if (Array.isArray(msg.onlineSeats)) {
                net2.onlineSeats = msg.onlineSeats;
              }
              if (settings3) {
                if (Array.isArray(msg.seats)) {
                  for (const s2 of msg.seats) {
                    if (s2 && s2.name) {
                      s2.name = _NetworkManager.sanitizePlayerName(s2.name, `Player ${(s2.id || "").slice(1)}`);
                    }
                  }
                  settings3.seats = msg.seats;
                }
                if (msg.playerCount) settings3.playerCount = msg.playerCount;
                if (settings3.seats && net2.mySeatId) {
                  const mySeatObj = settings3.seats.find((s2) => s2 && s2.id === net2.mySeatId);
                  if (mySeatObj) {
                    mySeatObj.name = _NetworkManager.sanitizePlayerName(myName, `Player ${(net2.mySeatId || "").slice(1)}`);
                    mySeatObj.type = "human";
                    mySeatObj.online = true;
                  }
                  const hostSeatObj = settings3.seats.find((s2) => s2 && s2.id === "p1");
                  if (hostSeatObj) {
                    hostSeatObj.online = true;
                  }
                }
              }
              if (typeof window !== "undefined") window._currentRoster = null;
              if (Array.isArray(msg.seats)) {
                const avMgr = context.AvatarManager || typeof window !== "undefined" && window.AvatarManager || AvatarManager || null;
                const BoardRenderer2 = context.BoardRenderer || (typeof window !== "undefined" ? window.BoardRenderer : null);
                for (const sObj of msg.seats) {
                  if (sObj && sObj.id && sObj.id !== net2.mySeatId) {
                    if (sObj.avatar === "custom" && sObj.customAvatarData && avMgr && typeof avMgr.registerRemoteCustomAvatar === "function") {
                      avMgr.registerRemoteCustomAvatar(sObj.id, sObj.customAvatarData, sObj.name || `Player ${sObj.id.slice(1)}`);
                    }
                    if (BoardRenderer2 && typeof BoardRenderer2.updatePegAvatarPattern === "function") {
                      const patId = sObj.avatar === "custom" ? "custom_" + sObj.id : sObj.avatar || "jack";
                      BoardRenderer2.updatePegAvatarPattern(sObj.id, patId);
                    }
                  }
                }
                const bRenderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
                if (bRenderer3D && typeof bRenderer3D.updatePegAvatars === "function") {
                  bRenderer3D.updatePegAvatars();
                }
              }
              if (typeof updateNetRoster2 === "function") updateNetRoster2(msg.roster);
            } else if (msg.type === "state") {
              if (typeof applyRemoteState2 === "function") applyRemoteState2(msg);
            } else if (msg.type === "cam_state") {
              try {
                const camMgr = context.CameraManager && context.CameraManager.getInstance ? context.CameraManager.getInstance() : CameraManager2.getInstance();
                if (camMgr) camMgr.handleCamStateMessage(msg, context);
              } catch (e) {
                console.warn("[CameraManager] Guest cam_state error:", e);
              }
            } else if (msg.type === "chat") {
              try {
                const chatMgr = context.ChatManager && context.ChatManager.getInstance ? context.ChatManager.getInstance() : ChatManager.getInstance();
                if (chatMgr) chatMgr.handleIncomingMessage(msg, context);
              } catch (e) {
                console.warn("[ChatManager] Guest chat message error:", e);
              }
            } else if (msg.type === "reaction") {
              try {
                const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : null);
                ReactionManager.handleRemoteReaction(msg, { sfx: sfx3 });
              } catch (e) {
                console.warn("[ReactionManager] Guest reaction error:", e);
              }
            } else if (msg.type === "rematch") {
              try {
                const playAgain2 = context.playAgain || (typeof window !== "undefined" ? window.playAgain : null);
                if (typeof playAgain2 === "function") playAgain2();
              } catch (e) {
              }
            } else if (msg.type === "tournament_update") {
              try {
                if (msg.tournament) {
                  const TournamentManager2 = context.TournamentManager || (typeof window !== "undefined" ? window.TournamentManager : null);
                  if (TournamentManager2) {
                    TournamentManager2.saveTournamentState(msg.tournament);
                  }
                  const TournamentModal2 = context.TournamentModal || (typeof window !== "undefined" ? window.TournamentModal : null);
                  if (TournamentModal2) {
                    const overlay = document.getElementById(TournamentModal2.OVERLAY_ID);
                    if (overlay && overlay.style.display !== "none") {
                      TournamentModal2.render(context);
                    }
                  }
                }
              } catch (e) {
                console.warn("[Tournament] Guest tournament update error:", e);
              }
            } else if (msg.type === "avatar_update") {
              try {
                _NetworkManager.handleAvatarUpdate(msg, context);
              } catch (e) {
                console.warn("[AvatarManager] Guest avatar_update error:", e);
              }
            }
          });
          const triggerHostDisconnect = () => {
            _NetworkManager.handleHostDisconnect(context);
          };
          conn.on("close", triggerHostDisconnect);
          conn.on("error", (err) => {
            triggerHostDisconnect();
          });
          if (conn.peerConnection) {
            try {
              conn.peerConnection.addEventListener("connectionstatechange", () => {
                const st = conn.peerConnection.connectionState;
                if (st === "disconnected" || st === "failed" || st === "closed") {
                  triggerHostDisconnect();
                }
              });
              conn.peerConnection.addEventListener("iceconnectionstatechange", () => {
                const st = conn.peerConnection.iceConnectionState;
                if (st === "disconnected" || st === "failed" || st === "closed") {
                  triggerHostDisconnect();
                }
              });
            } catch (e) {
            }
          }
        });
        net2.peer.on("error", (err) => {
          hideWait2();
          if (err && err.type === "peer-unavailable") {
            setNetStatus2('Room "' + code + '" not found. Ensure host is waiting.', "");
          } else {
            setNetStatus2("Join error: " + (err ? err.type || err : "unknown"), "");
          }
        });
      }
    }
    /**
    
       * Parses URL room parameters/hash and initiates auto-joining flow.
       * @param {Object} [context]
       */
    static initAutoJoin(context = {}) {
      let joinCode = "";
      const win = context.window || (typeof window !== "undefined" ? window : null);
      if (!win) return;
      try {
        const params = new URLSearchParams(win.location.search);
        joinCode = params.get("join") || params.get("room") || "";
        if (!joinCode && win.location.hash) {
          const hash = win.location.hash.replace(/^#/, "");
          const hashParams = new URLSearchParams(hash.includes("?") ? hash.split("?")[1] : hash);
          joinCode = hashParams.get("join") || hashParams.get("room") || "";
          if (!joinCode && /^[A-Z0-9]{4,8}$/i.test(hash)) {
            joinCode = hash;
          }
        }
      } catch (e) {
      }
      if (!joinCode) return;
      joinCode = joinCode.trim().toUpperCase();
      const doc = context.document || win.document;
      const settings3 = context.settings || win.settings;
      if (doc) {
        const pCount = doc.getElementById("optPlayerCount");
        if (pCount) {
          pCount.value = "2";
          pCount.dispatchEvent(new Event("change"));
        }
      }
      if (settings3) {
        settings3.playerCount = 2;
        settings3.gameMode = "indiv";
      }
      if (doc) {
        const oppSelect = doc.getElementById("optOpp");
        if (oppSelect) {
          oppSelect.value = "online";
          oppSelect.dispatchEvent(new Event("change"));
        }
        const roomInput = doc.getElementById("optRoom");
        if (roomInput) {
          roomInput.value = joinCode;
        }
        const netPanel = doc.getElementById("netPanel");
        if (netPanel) {
          netPanel.classList.remove("hidden");
        }
        const menuOptions = doc.getElementById("menuOptions");
        if (menuOptions && menuOptions.classList.contains("hidden")) {
          menuOptions.classList.remove("hidden");
          const btnSettingsMenu = doc.getElementById("btnSettingsMenu");
          if (btnSettingsMenu) btnSettingsMenu.classList.add("is-active");
        }
      }
      if (settings3) {
        settings3.opp = "online";
      }
      const setNetStatus2 = context.setNetStatus || win.setNetStatus || (() => {
      });
      const showWait2 = context.showWait || win.showWait || (() => {
      });
      const hideWait2 = context.hideWait || win.hideWait || (() => {
      });
      const joinRoom2 = context.joinRoom || win.joinRoom || _NetworkManager.joinRoom;
      const s = getStorage7(context);
      const savedName = doc && doc.getElementById("optPlayerName") && doc.getElementById("optPlayerName").value.trim() || (s ? (s.getItem("cc_player_name") || "").trim() : "");
      if (!savedName) {
        setNetStatus2("Room invite detected. Please enter your name to join\u2026", "wait");
        _NetworkManager.promptPlayerName(joinCode, (enteredName) => {
          if (doc && doc.getElementById("optPlayerName")) doc.getElementById("optPlayerName").value = enteredName;
          try {
            if (s) s.setItem("cc_player_name", enteredName);
          } catch (e) {
          }
          joinRoom2(joinCode, { ...context, playerName: enteredName });
        }, context);
        return;
      }
      if (doc && doc.getElementById("optPlayerName") && !doc.getElementById("optPlayerName").value) {
        doc.getElementById("optPlayerName").value = savedName;
      }
      setNetStatus2("Auto-joining room " + joinCode + "\u2026", "wait");
      showWait2("Connecting to host room " + joinCode + "\u2026");
      function attemptJoin(retries = 25) {
        const PeerClass = context.PeerClass || win.Peer;
        if (typeof PeerClass === "undefined") {
          if (retries > 0) {
            setTimeout(() => attemptJoin(retries - 1), 150);
          } else {
            setNetStatus2("PeerJS failed to load. Please refresh and serve over http/https.", "");
            hideWait2();
          }
          return;
        }
        joinRoom2(joinCode);
      }
      setTimeout(attemptJoin, 150);
    }
    updateNetRoster(remoteRoster, context) {
      return _NetworkManager.updateNetRoster(remoteRoster, { net: this, ...context });
    }
    broadcastLobbyUpdate(context) {
      return _NetworkManager.broadcastLobbyUpdate({ net: this, ...context });
    }
    netSend(msg, targetConn, context) {
      return _NetworkManager.netSend(msg, targetConn, { net: this, ...context });
    }
    netPush(extra, context) {
      return _NetworkManager.netPush(extra, { net: this, ...context });
    }
    applyRemoteState(payload, context) {
      return _NetworkManager.applyRemoteState(payload, { net: this, ...context });
    }
    hostRoom(context) {
      return _NetworkManager.hostRoom({ net: this, ...context });
    }
    joinRoom(code, context) {
      return _NetworkManager.joinRoom(code, { net: this, ...context });
    }
    /**
     * Sets up net panel visibility, host/join buttons, copy room link, and quick mode pills.
     * @param {Object} [context]
     */
    static setupNetUi(context = {}) {
      if (typeof document === "undefined") return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const net2 = context.net || (typeof window !== "undefined" ? window.net : {});
      const showHostInviteLink2 = context.showHostInviteLink || (typeof window !== "undefined" ? window.showHostInviteLink : () => {
      });
      const hostRoom2 = context.hostRoom || (typeof window !== "undefined" ? window.hostRoom : () => {
      });
      const joinRoom2 = context.joinRoom || (typeof window !== "undefined" ? window.joinRoom : () => {
      });
      const copyRoomInviteLink2 = context.copyRoomInviteLink || (typeof window !== "undefined" ? window.copyRoomInviteLink : () => {
      });
      const startGameOnline2 = context.startGameOnline || (typeof window !== "undefined" ? window.startGameOnline : () => {
      });
      const syncPlayerCountUi2 = context.syncPlayerCountUi || (typeof window !== "undefined" ? window.syncPlayerCountUi : () => {
      });
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "crazy");
      const GameOptionsEngine2 = context.GameOptionsEngine || (typeof window !== "undefined" ? window.GameOptionsEngine : null);
      const opp = document.getElementById("optOpp");
      const panel = document.getElementById("netPanel");
      const sync = () => {
        if (!panel || !opp) return;
        panel.classList.toggle("hidden", opp.value !== "online");
        if (opp.value === "online" && settings3.netRole === "host" && net2.room) {
          showHostInviteLink2(net2.room);
        }
      };
      if (opp) opp.addEventListener("change", sync);
      sync();
      const optPlayerName = document.getElementById("optPlayerName");
      const s = getStorage7(context);
      if (optPlayerName) {
        try {
          const saved = s ? s.getItem("cc_player_name") : null;
          if (saved && !optPlayerName.value) optPlayerName.value = saved;
        } catch (e) {
        }
        optPlayerName.addEventListener("input", () => {
          try {
            const val = optPlayerName.value.trim();
            if (val && s) s.setItem("cc_player_name", val);
          } catch (e) {
          }
        });
      }
      const bh = document.getElementById("btnHost");
      const bj = document.getElementById("btnJoin");
      const bc = document.getElementById("btnCopyRoomLink");
      const bcb = document.getElementById("btnCopyRoomLinkBar");
      const bStart = document.getElementById("btnStartOnlineGame");
      const bShareInvite = document.getElementById("btnShareInvite");
      const bShareWhatsApp = document.getElementById("btnShareWhatsApp");
      const bShareEmail = document.getElementById("btnShareEmail");
      const bShareMore = document.getElementById("btnShareMore");
      if (bh) bh.onclick = (e) => {
        e.preventDefault();
        hostRoom2();
      };
      if (bj) bj.onclick = (e) => {
        e.preventDefault();
        joinRoom2();
      };
      if (bc) bc.onclick = (e) => {
        e.preventDefault();
        copyRoomInviteLink2(bc);
      };
      if (bcb) bcb.onclick = (e) => {
        e.preventDefault();
        copyRoomInviteLink2(bcb);
      };
      if (bShareInvite) bShareInvite.onclick = (e) => {
        e.preventDefault();
        _NetworkManager.shareRoomInvite(context);
      };
      if (bShareWhatsApp) bShareWhatsApp.onclick = (e) => {
        e.preventDefault();
        _NetworkManager.shareRoomWhatsApp(context);
      };
      if (bShareEmail) bShareEmail.onclick = (e) => {
        e.preventDefault();
        _NetworkManager.shareRoomEmail(context);
      };
      if (bShareMore) bShareMore.onclick = (e) => {
        e.preventDefault();
        typeof window !== "undefined" && window.showShareModal ? window.showShareModal() : _NetworkManager.shareRoomInvite(context);
      };
      if (bStart) bStart.onclick = (e) => {
        e.preventDefault();
        startGameOnline2();
      };
      if (typeof window !== "undefined") {
        window.shareRoomInvite = (ctx) => _NetworkManager.shareRoomInvite(ctx || context);
        window.shareRoomWhatsApp = (ctx) => _NetworkManager.shareRoomWhatsApp(ctx || context);
        window.shareRoomEmail = (ctx) => _NetworkManager.shareRoomEmail(ctx || context);
      }
      const modePills = document.querySelectorAll(".game-mode-pill");
      modePills.forEach((btn) => {
        btn.onclick = (e) => {
          e.preventDefault();
          const mode = btn.dataset.mode;
          const b = getAppBrand2();
          const allowCpu = GameOptionsEngine2 && typeof GameOptionsEngine2.isCpuAllowed === "function" ? GameOptionsEngine2.isCpuAllowed(b) : !["pints", "adult"].includes(b);
          if (!allowCpu && mode === "cpu") return;
          if (opp) {
            opp.value = mode;
            const aiRow = document.getElementById("optAiProfileRow");
            if (aiRow) {
              aiRow.classList.toggle("hidden", mode !== "cpu");
              aiRow.style.display = mode === "cpu" && allowCpu ? "" : "none";
            }
            syncPlayerCountUi2();
          }
        };
      });
      const sizeBtns = document.querySelectorAll(".net-size-btn");
      const pCountSel = document.getElementById("optPlayerCount");
      sizeBtns.forEach((btn) => {
        btn.onclick = (e) => {
          e.preventDefault();
          const countVal = btn.dataset.count;
          if (pCountSel) {
            pCountSel.value = countVal;
            syncPlayerCountUi2();
          }
        };
      });
      ["optSeat2Type", "optSeat3Type", "optSeat4Type", "optSeat5Type", "optSeat6Type", "optSeat7Type", "optSeat8Type"].forEach((id) => {
        const sel = document.getElementById(id);
        if (sel) {
          sel.addEventListener("change", () => {
            if (sel.value === "online") {
              if (opp) {
                opp.value = "online";
                syncPlayerCountUi2();
              }
            }
          });
        }
      });
    }
    /**
     * Starts periodic heartbeat ping/pong to detect dropped peer connections within 5-7s.
     * @param {Object} [context]
     */
    static startHeartbeat(context = {}) {
      if (typeof window === "undefined") return;
      if (window._ccHeartbeatTimer) clearInterval(window._ccHeartbeatTimer);
      window._ccHeartbeatTimer = setInterval(() => {
        const net2 = context.net || window.net;
        const settings3 = context.settings || window.settings;
        if (!net2 || settings3 && settings3.opp !== "online") return;
        const now = Date.now();
        const isHost = Boolean(settings3 && settings3.netRole === "host" || net2.isHost || net2.role === "host");
        if (isHost) {
          if (!net2.clients) return;
          for (const [, client] of net2.clients.entries()) {
            if (!client || !client.conn) continue;
            if (client.lastSeen && now - client.lastSeen > 7e3) {
              console.warn(`[NetworkManager] Client ${client.seatId} heartbeat timeout (>7s), marking offline.`);
              const handleClientDisconnect2 = context.handleClientDisconnect || window.handleClientDisconnect || _NetworkManager.handleClientDisconnect;
              if (typeof handleClientDisconnect2 === "function") {
                handleClientDisconnect2(client.conn, context);
              }
              continue;
            }
            if (client.conn.open) {
              try {
                client.conn.send({ type: "ping" });
              } catch (e) {
              }
            }
          }
        } else {
          if (!net2.conn) return;
          if (net2.ready && net2.lastHostSeen && now - net2.lastHostSeen > 7e3) {
            console.warn("[NetworkManager] Host heartbeat timeout (>7s), marking host offline.");
            _NetworkManager.handleHostDisconnect(context);
            return;
          }
          if (net2.conn.open) {
            try {
              net2.conn.send({ type: "pong", seatId: net2.mySeatId });
            } catch (e) {
            }
          }
        }
      }, 2500);
    }
    /**
     * Attaches page unload listeners to instantly notify peers on window close or tab navigation.
     * @param {Object} [context]
     */
    static initUnloadHandler(context = {}) {
      if (typeof window === "undefined" || window._ccUnloadInitialized) return;
      window._ccUnloadInitialized = true;
      const onLeave = () => {
        const net2 = context.net || window.net;
        const settings3 = context.settings || window.settings;
        if (!net2) return;
        const isHost = Boolean(settings3 && settings3.netRole === "host" || net2.isHost || net2.role === "host");
        if (isHost && net2.clients) {
          for (const c of net2.clients.values()) {
            if (c && c.conn && c.conn.open) {
              try {
                c.conn.send({ type: "host_offline", seatId: "p1" });
                c.conn.close();
              } catch (e) {
              }
            }
          }
        } else if (net2.conn && net2.conn.open) {
          try {
            net2.conn.send({ type: "client_leave", seatId: net2.mySeatId || "p2" });
            net2.conn.close();
          } catch (e) {
          }
        }
        if (net2.peer && typeof net2.peer.destroy === "function") {
          try {
            net2.peer.destroy();
          } catch (e) {
          }
        }
      };
      window.addEventListener("beforeunload", onLeave);
      window.addEventListener("pagehide", onLeave);
    }
    /**
     * Handles incoming avatar_update message (both host and guest).
     * @param {Object} msg - { type: 'avatar_update', seatId, avatarId, customAvatarData, name }
     * @param {Object} [context]
     */
    static handleAvatarUpdate(msg, context = {}) {
      if (!msg || !msg.seatId) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const avMgr = context.AvatarManager || typeof window !== "undefined" && window.AvatarManager || AvatarManager || null;
      if (msg.avatarId === "custom" && msg.customAvatarData && avMgr && typeof avMgr.registerRemoteCustomAvatar === "function") {
        const seatObj = settings3 && Array.isArray(settings3.seats) ? settings3.seats.find((s) => s && s.id === msg.seatId) : null;
        const fallbackPeerName = `Player ${msg.seatId.slice(1)}`;
        const peerName = _NetworkManager.sanitizePlayerName(seatObj && seatObj.name || msg.name, fallbackPeerName);
        avMgr.registerRemoteCustomAvatar(msg.seatId, msg.customAvatarData, peerName);
      }
      if (settings3 && Array.isArray(settings3.seats)) {
        const seatObj = settings3.seats.find((s) => s && s.id === msg.seatId);
        if (seatObj) {
          seatObj.avatar = msg.avatarId;
          if (msg.customAvatarData) seatObj.customAvatarData = msg.customAvatarData;
        }
      }
      const BoardRenderer2 = context.BoardRenderer || (typeof window !== "undefined" ? window.BoardRenderer : null);
      if (BoardRenderer2 && typeof BoardRenderer2.updatePegAvatarPattern === "function") {
        const targetPatternAvatarId = msg.avatarId === "custom" ? "custom_" + msg.seatId : msg.avatarId;
        BoardRenderer2.updatePegAvatarPattern(msg.seatId, targetPatternAvatarId);
      }
      const bRenderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
      if (bRenderer3D && typeof bRenderer3D.updatePegAvatars === "function") {
        bRenderer3D.updatePegAvatars();
      }
      const updateNetRoster2 = context.updateNetRoster || (typeof window !== "undefined" ? window.updateNetRoster : _NetworkManager.updateNetRoster);
      if (typeof updateNetRoster2 === "function") {
        if (typeof window !== "undefined") window._currentRoster = null;
        updateNetRoster2();
      }
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : null);
      if (typeof renderScores2 === "function") renderScores2(false);
    }
    setupNetUi(context) {
      return _NetworkManager.setupNetUi(context);
    }
  };

  // src/variants/LayoutSanitizer.js
  var MAX_LAYOUT_JSON_LENGTH = 65536;
  var MAX_CUSTOM_LAYOUTS = 50;
  var MAX_ITEMS_PER_LAYOUT = 100;
  var MAX_NAME_LENGTH = 50;
  var ALLOWED_BOARD_TARGETS = Object.freeze([121, 241, 361, 481]);
  var BRAND_GAME_TITLES = Object.freeze({
    clash: "Cribbage Clash",
    pints: "Pints & Pegs",
    adult: "Skunked & Stripped"
  });
  var BRAND_ALLOWED_TYPES = Object.freeze({
    clash: [
      "jail",
      "bar",
      "timeout",
      "jump",
      "noPassingLanes",
      "stopSign",
      "stopSigns",
      "signs",
      "signBlock",
      "detour",
      "roundAbout",
      "roundabout",
      "dice",
      "diceRoll",
      "wheel",
      "spinningWheel",
      "spinWheel"
    ],
    pints: [
      "youDrink",
      "guysDrink",
      "galsDrink",
      "leftDrink",
      "rightDrink",
      "everyoneDrink",
      "everyoneButYouDrink",
      "pickWhoDrinks"
    ],
    adult: [
      "loseClothing",
      "gainClothing",
      "pickWhoLosesClothing",
      "rightLosesClothing",
      "leftLosesClothing",
      "removeClothingChoice",
      "touchBreast",
      "lickBreast",
      "suckBreast",
      "touchGenitals",
      "lickGenitals",
      "suckGenitals",
      "fingerGenitals"
    ]
  });
  var TYPE_ALIASES = Object.freeze({
    stopSigns: "stopSign",
    roundabout: "roundAbout",
    signBlock: "signs",
    diceRoll: "dice",
    spinningWheel: "wheel",
    spinWheel: "wheel"
  });
  var SYSTEM_TYPE_METADATA = Object.freeze({
    // Clash
    jail: { icon: "\u{1F512}", color: "#94a3b8", name: "Jail" },
    bar: { icon: "\u{1F378}", color: "#f59e0b", name: "The Bar" },
    timeout: { icon: "\u23F3", color: "#8b5cf6", name: "Timeout" },
    jump: { icon: "\u26A1", color: "#3b82f6", name: "Jump" },
    noPassingLanes: { icon: "\u{1F6AB}", color: "#ef4444", name: "No Passing" },
    stopSign: { icon: "\u{1F6D1}", color: "#ef4444", name: "Stop Sign" },
    signs: { icon: "\u{1FAA7}", color: "#ec4899", name: "Sign Block" },
    detour: { icon: "\u{1F500}", color: "#06b6d4", name: "Detour" },
    roundAbout: { icon: "\u{1F504}", color: "#10b981", name: "Roundabout" },
    dice: { icon: "\u{1F3B2}", color: "#a855f7", name: "Dice" },
    diceRoll: { icon: "\u{1F3B2}", color: "#a855f7", name: "Dice" },
    wheel: { icon: "\u{1F3A1}", color: "#ec4899", name: "Spinning Wheel" },
    spinningWheel: { icon: "\u{1F3A1}", color: "#ec4899", name: "Spinning Wheel" },
    spinWheel: { icon: "\u{1F3A1}", color: "#ec4899", name: "Spinning Wheel" },
    // Pints
    youDrink: { icon: "\u{1F37A}", color: "#f59e0b", name: "You Drink" },
    guysDrink: { icon: "\u{1F37B}", color: "#6366f1", name: "Guys Drink" },
    galsDrink: { icon: "\u{1F377}", color: "#f43f5e", name: "Gals Drink" },
    leftDrink: { icon: "\u{1F448}", color: "#3b82f6", name: "Left Drinks" },
    rightDrink: { icon: "\u{1F449}", color: "#06b6d4", name: "Right Drinks" },
    everyoneDrink: { icon: "\u{1F942}", color: "#10b981", name: "Everyone Drinks" },
    everyoneButYouDrink: { icon: "\u{1F389}", color: "#8b5cf6", name: "Everyone But You" },
    pickWhoDrinks: { icon: "\u{1F3AF}", color: "#ec4899", name: "Pick Who Drinks" },
    // Adult
    loseClothing: { icon: "\u{1F459}", color: "#f43f5e", name: "You Strip" },
    gainClothing: { icon: "\u{1F9E5}", color: "#10b981", name: "Gain Clothing" },
    pickWhoLosesClothing: { icon: "\u{1F3AF}", color: "#ec4899", name: "Pick Who Strips" },
    rightLosesClothing: { icon: "\u{1F449}", color: "#3b82f6", name: "Right Strips" },
    leftLosesClothing: { icon: "\u{1F448}", color: "#8b5cf6", name: "Left Strips" },
    removeClothingChoice: { icon: "\u2702\uFE0F", color: "#e11d48", name: "Remove Choice" },
    touchBreast: { icon: "\u{1F48B}", color: "#f43f5e", name: "Touch Breast" },
    lickBreast: { icon: "\u{1F445}", color: "#ec4899", name: "Lick Breast" },
    suckBreast: { icon: "\u{1F444}", color: "#d946ef", name: "Suck Breast" },
    touchGenitals: { icon: "\u2728", color: "#a855f7", name: "Touch Genitals" },
    lickGenitals: { icon: "\u{1F445}", color: "#f43f5e", name: "Lick Genitals" },
    suckGenitals: { icon: "\u{1F444}", color: "#ec4899", name: "Suck Genitals" },
    fingerGenitals: { icon: "\u{1F449}", color: "#f59e0b", name: "Finger Genitals" }
  });
  var LayoutSanitizer = class _LayoutSanitizer {
    /**
     * Retrieves system-defined official icon, color, and name for an obstacle type.
     * @param {string} type
     * @param {string} [brand='clash']
     * @returns {{ icon: string, color: string, name: string }}
     */
    static getSystemMetaForType(type, brand = "clash") {
      const canonicalType = TYPE_ALIASES[type] || type;
      const meta = SYSTEM_TYPE_METADATA[canonicalType];
      if (meta) {
        return { ...meta };
      }
      return {
        icon: "\u2605",
        color: "#f59e0b",
        name: canonicalType || "Obstacle"
      };
    }
    /**
     * Generates a cryptographically or pseudo-random safe ID.
     * Format: [prefix]_[timestamp]_[alphanumeric]
     * @param {string} [prefix='layout']
     * @returns {string}
     */
    static generateSafeId(prefix = "layout") {
      const cleanPrefix = String(prefix || "layout").replace(/[^a-zA-Z0-9_]/g, "").slice(0, 20);
      const rnd = Math.random().toString(36).substring(2, 9);
      return `${cleanPrefix}_${Date.now()}_${rnd}`;
    }
    /**
     * Ensures an ID consists strictly of safe alphanumeric characters, dashes, and underscores.
     * If invalid, a fresh safe ID is returned.
     * @param {*} id
     * @param {string} [prefix='layout']
     * @returns {string}
     */
    static sanitizeId(id, prefix = "layout") {
      if (typeof id === "string" && /^[a-zA-Z0-9_-]{1,64}$/.test(id)) {
        return id;
      }
      return _LayoutSanitizer.generateSafeId(prefix);
    }
    /**
     * Validates whether a value represents a valid integer.
     * Accepts integer numbers (e.g. 5) or integer strings (e.g. "5").
     * Rejects floats (5.5, "5.5"), booleans, null, undefined, NaN, Infinity, and non-numeric strings.
     * @param {*} val
     * @returns {boolean}
     */
    static isInteger(val) {
      if (val === null || val === void 0 || val === "") return false;
      if (typeof val === "boolean") return false;
      if (typeof val === "number") {
        return Number.isInteger(val);
      }
      if (typeof val === "string") {
        const trimmed = val.trim();
        if (!trimmed) return false;
        if (!/^-?\d+$/.test(trimmed)) return false;
        const num = Number(trimmed);
        return Number.isSafeInteger(num);
      }
      return false;
    }
    /**
     * Validates that a field is plain text:
     * - Must be a string
     * - Must not contain extended characters (code point > 127) or control characters (< 32 or === 127)
     * - Must not contain XML or SVG tags, markup, namespaces, or keywords (<, >, xml, svg, xmlns)
     * @param {*} val
     * @param {string} fieldName
     * @param {string} [context='']
     * @throws {Error} if validation fails
     */
    static validatePlainTextField(val, fieldName, context = "") {
      if (val === null || val === void 0) return;
      const ctx = context ? ` ${context}` : "";
      if (typeof val !== "string") {
        throw new Error(`Invalid ${fieldName}${ctx}: must be a plain text string.`);
      }
      for (let i = 0; i < val.length; i++) {
        const code = val.charCodeAt(i);
        if (code > 127) {
          throw new Error(`Invalid ${fieldName}${ctx}: contains extended character "${val[i]}" (code ${code}). Only plain ASCII text is allowed.`);
        }
        if (code < 32 || code === 127) {
          throw new Error(`Invalid ${fieldName}${ctx}: contains control character (code ${code}). Only printable plain text is allowed.`);
        }
      }
      if (/[<>]|&lt;|&gt;|xmlns|svg|xml/i.test(val)) {
        throw new Error(`Invalid ${fieldName}${ctx}: XML and SVG are not allowed.`);
      }
    }
    /**
     * Validates and parses raw JSON string with size checks and prototype pollution guards.
     * @param {string} jsonStr
     * @returns {Object|Array}
     */
    static parseJsonSafely(jsonStr) {
      if (typeof jsonStr !== "string") {
        throw new Error("Expected JSON layout string.");
      }
      const trimmed = jsonStr.trim();
      if (!trimmed) {
        throw new Error("JSON layout is empty.");
      }
      if (trimmed.length > MAX_LAYOUT_JSON_LENGTH) {
        throw new Error(`Layout payload exceeds maximum size limit of ${MAX_LAYOUT_JSON_LENGTH / 1024}KB.`);
      }
      let parsed;
      try {
        parsed = JSON.parse(trimmed);
      } catch (e) {
        throw new Error(`JSON syntax error: ${e.message}`);
      }
      if (!parsed || typeof parsed !== "object") {
        throw new Error("Invalid layout format: must be a JSON object or array of objects.");
      }
      if (Object.prototype.hasOwnProperty.call(parsed, "__proto__") || Object.prototype.hasOwnProperty.call(parsed, "constructor") || Object.prototype.hasOwnProperty.call(parsed, "prototype")) {
        throw new Error("Layout contains disallowed prototype property.");
      }
      return parsed;
    }
    /**
     * Validates and sanitizes a layout's obstacle or action items.
     * Enforces brand whitelists, integer bounds [1, target], self-jump prevention,
     * and jump loop detection.
     * ALWAYS sets icon and color to the system-defined official values for the type.
     * @param {Array} rawItems
     * @param {number} target
     * @param {string} [brand='clash']
     * @param {Object} [options={}]
     * @returns {Array}
     */
    static sanitizeItems(rawItems, target = 481, brand = "clash", options = {}) {
      const opts = { validateTypes: true, ...options };
      if (!Array.isArray(rawItems)) {
        if (opts.validateTypes && rawItems != null) {
          throw new Error("Layout items property must be an array.");
        }
        return [];
      }
      const allowedTypes = new Set(BRAND_ALLOWED_TYPES[brand] || BRAND_ALLOWED_TYPES.clash);
      const sanitized = [];
      const jumpMap = /* @__PURE__ */ new Map();
      const maxItems = Math.min(rawItems.length, MAX_ITEMS_PER_LAYOUT);
      for (let i = 0; i < maxItems; i++) {
        const it = rawItems[i];
        if (!it || typeof it !== "object" || Array.isArray(it)) {
          if (opts.validateTypes) {
            throw new Error(`Invalid item at position ${i + 1}: expected an obstacle object.`);
          }
          continue;
        }
        if (Object.prototype.hasOwnProperty.call(it, "__proto__") || Object.prototype.hasOwnProperty.call(it, "constructor") || Object.prototype.hasOwnProperty.call(it, "prototype")) {
          continue;
        }
        if (opts.validateTypes) {
          if (it.id !== void 0 && it.id !== null) {
            _LayoutSanitizer.validatePlainTextField(it.id, "id", `at item #${i + 1}`);
            if (typeof it.id !== "string" || !/^[a-zA-Z0-9_-]{1,64}$/.test(it.id)) {
              throw new Error(`Invalid id at item #${i + 1}: must be 1-64 alphanumeric characters, underscores, or hyphens.`);
            }
          }
        }
        if (it.type == null) {
          if (opts.validateTypes) {
            const gameTitle = BRAND_GAME_TITLES[brand] || brand;
            throw new Error(`Missing required "type" field at item #${i + 1} for ${gameTitle}.`);
          }
          continue;
        }
        if (opts.validateTypes) {
          _LayoutSanitizer.validatePlainTextField(it.type, "type", `at item #${i + 1}`);
        }
        const rawType = String(it.type).trim();
        if (!rawType) {
          if (opts.validateTypes) {
            const gameTitle = BRAND_GAME_TITLES[brand] || brand;
            throw new Error(`Missing required "type" field at item #${i + 1} for ${gameTitle}.`);
          }
          continue;
        }
        if (!allowedTypes.has(rawType)) {
          if (opts.validateTypes) {
            const gameTitle = BRAND_GAME_TITLES[brand] || brand;
            const displayTypes = Array.from(allowedTypes).filter((t) => !["stopSigns", "roundabout", "signBlock"].includes(t)).join(", ");
            throw new Error(`Invalid obstacle type "${rawType}" at item #${i + 1} for ${gameTitle}. Valid types are: ${displayTypes}`);
          }
          continue;
        }
        const type = TYPE_ALIASES[rawType] || rawType;
        if (!_LayoutSanitizer.isInteger(it.hole)) {
          if (opts.validateTypes) {
            throw new Error(`Invalid hole coordinate "${it.hole}" at item #${i + 1} (${type}): hole must be an integer.`);
          }
          continue;
        }
        const hole = Number(it.hole);
        if (hole < 1 || hole >= target) {
          if (opts.validateTypes) {
            throw new Error(`Invalid hole coordinate "${it.hole}" at item #${i + 1} (${type}): hole must be an integer less than target (${target}) and at least 1 (1 to ${target - 1}).`);
          }
          continue;
        }
        if (opts.validateTypes) {
          if (it.name !== void 0 && it.name !== null) {
            _LayoutSanitizer.validatePlainTextField(it.name, "name", `at item #${i + 1} (${type})`);
          }
        }
        const meta = _LayoutSanitizer.getSystemMetaForType(type, brand);
        const cleanItem = {
          type,
          hole,
          name: it.name && typeof it.name === "string" ? it.name.trim().substring(0, 50) : meta.name,
          icon: meta.icon,
          color: meta.color
        };
        if (it.id && typeof it.id === "string" && /^[a-zA-Z0-9_-]{1,64}$/.test(it.id)) {
          cleanItem.id = it.id;
        }
        if (it.length !== void 0 && it.length !== null) {
          if (!_LayoutSanitizer.isInteger(it.length)) {
            if (opts.validateTypes) {
              throw new Error(`Invalid length "${it.length}" at item #${i + 1} (${type}): length must be an integer.`);
            }
            continue;
          }
          const len = Number(it.length);
          if (len < 1 || len > 5) {
            if (opts.validateTypes) {
              throw new Error(`Invalid length "${it.length}" at item #${i + 1} (${type}): length must be an integer of 5 or less (1 to 5).`);
            }
            continue;
          }
          cleanItem.length = len;
        } else if (type === "noPassingLanes") {
          cleanItem.length = 5;
        }
        if (it.dest != null || type === "jump") {
          if (it.dest != null && !_LayoutSanitizer.isInteger(it.dest)) {
            if (opts.validateTypes) {
              throw new Error(`Invalid jump destination "${it.dest}" at Hole ${hole} (item #${i + 1}): destination must be an integer.`);
            }
            continue;
          }
          const dest = Number(it.dest);
          if (Number.isInteger(dest) && dest >= 1 && dest <= target && dest !== hole) {
            if (jumpMap.get(dest) === hole) {
              continue;
            }
            cleanItem.dest = dest;
            jumpMap.set(hole, dest);
          } else if (type === "jump") {
            if (opts.validateTypes) {
              throw new Error(`Invalid jump destination "${it.dest}" at Hole ${hole} (item #${i + 1}). Destination must be between 1 and ${target} and different from start hole.`);
            }
            continue;
          }
        }
        sanitized.push(cleanItem);
      }
      return sanitized;
    }
    /**
     * Sanitizes a complete layout object.
     * @param {Object} rawLayout
     * @param {string} [brand='clash']
     * @param {Object} [options={}]
     * @returns {Object}
     */
    static sanitizeLayout(rawLayout, brand = "clash", options = {}) {
      if (!rawLayout || typeof rawLayout !== "object") {
        throw new Error("Invalid layout object.");
      }
      const opts = {
        regenerateId: true,
        validateTypes: true,
        ...options
      };
      const defaultTarget = brand === "clash" ? 481 : 121;
      let target = parseInt(rawLayout.target, 10);
      if (!ALLOWED_BOARD_TARGETS.includes(target)) {
        target = defaultTarget;
      }
      const items = _LayoutSanitizer.sanitizeItems(rawLayout.items, target, brand, opts);
      if (opts.validateTypes) {
        if (rawLayout.id !== void 0 && rawLayout.id !== null) {
          _LayoutSanitizer.validatePlainTextField(rawLayout.id, "id", "for layout");
        }
        if (rawLayout.name !== void 0 && rawLayout.name !== null) {
          _LayoutSanitizer.validatePlainTextField(rawLayout.name, "name", "for layout");
        }
      }
      let rawName = typeof rawLayout.name === "string" ? rawLayout.name : "Custom Layout";
      let name = rawName.replace(/[\x00-\x1F\x7F]/g, "").trim().substring(0, MAX_NAME_LENGTH);
      if (!name) name = "Custom Layout";
      const id = opts.regenerateId ? _LayoutSanitizer.generateSafeId(`${brand}_layout`) : _LayoutSanitizer.sanitizeId(rawLayout.id, `${brand}_layout`);
      const now = Date.now();
      const createdAt = typeof rawLayout.createdAt === "number" || typeof rawLayout.createdAt === "string" ? rawLayout.createdAt : now;
      const sanitized = {
        id,
        name,
        target,
        items,
        createdAt,
        updatedAt: now
      };
      return sanitized;
    }
    /**
     * Prepares a layout (or list of layouts) for export.
     * Strips icon and color from all items, and strips root metadata (id, createdAt, updatedAt, metrics, config).
     * @param {Object|Array} layoutOrLayouts
     * @returns {Object|Array}
     */
    static prepareForExport(layoutOrLayouts) {
      if (!layoutOrLayouts) return null;
      if (Array.isArray(layoutOrLayouts)) {
        return layoutOrLayouts.map((l) => _LayoutSanitizer.prepareForExport(l));
      }
      if (typeof layoutOrLayouts !== "object") return layoutOrLayouts;
      const copy = { ...layoutOrLayouts };
      delete copy.id;
      delete copy.createdAt;
      delete copy.updatedAt;
      delete copy.metrics;
      delete copy.config;
      if (Array.isArray(copy.items)) {
        copy.items = copy.items.map((it) => {
          const itemCopy = { ...it };
          delete itemCopy.icon;
          delete itemCopy.color;
          return itemCopy;
        });
      }
      return copy;
    }
    /**
     * Enforces custom layout storage limit to prevent localStorage quota exhaustion.
     * If existing layout array exceeds MAX_CUSTOM_LAYOUTS, oldest layouts are removed.
     * @param {Array} layouts
     * @param {number} [maxCount=MAX_CUSTOM_LAYOUTS]
     * @returns {Array}
     */
    static enforceStorageQuota(layouts, maxCount = MAX_CUSTOM_LAYOUTS) {
      if (!Array.isArray(layouts)) return [];
      if (layouts.length <= maxCount) return layouts;
      return layouts.slice(0, maxCount);
    }
  };
  if (typeof window !== "undefined") {
    window.LayoutSanitizer = LayoutSanitizer;
    window.MAX_LAYOUT_JSON_LENGTH = MAX_LAYOUT_JSON_LENGTH;
    window.MAX_CUSTOM_LAYOUTS = MAX_CUSTOM_LAYOUTS;
    window.BRAND_GAME_TITLES = BRAND_GAME_TITLES;
    window.BRAND_ALLOWED_TYPES = BRAND_ALLOWED_TYPES;
    window.SYSTEM_TYPE_METADATA = SYSTEM_TYPE_METADATA;
  }

  // src/variants/PintsPresets.js
  var PINTS_CUSTOM_LAYOUTS_KEY = "cc_pints_custom_layouts";
  var PINTS_PRESET_KEYS = Object.freeze({
    STANDARD: "standard",
    POWER_HOUR: "powerHour",
    SOCIAL_HOUR: "socialHour",
    BATTLE_OF_SEXES: "battleOfSexes"
  });
  var PINTS_PRESETS_121 = Object.freeze({
    standard: {
      key: "standard",
      name: "Pub Crawl",
      badge: "\u{1F37B} Balanced",
      icon: "\u{1F37B}",
      description: "The classic pub crawl around the board. A smooth, fun balance of personal drinks, neighbor penalties, and social toasts.",
      tags: ["Balanced", "Party", "Classic"],
      drinkSpaces: 16,
      config: {
        optYouDrink: true,
        optYouDrinkCount: 2,
        optYouDrinkPegs: 1,
        optYouDrink1Hole: 15,
        optYouDrink2Hole: 75,
        optGuysDrink: true,
        optGuysDrinkCount: 2,
        optGuysDrinkPegs: 1,
        optGuysDrink1Hole: 25,
        optGuysDrink2Hole: 85,
        optGalsDrink: true,
        optGalsDrinkCount: 2,
        optGalsDrinkPegs: 1,
        optGalsDrink1Hole: 35,
        optGalsDrink2Hole: 95,
        optLeftDrink: true,
        optLeftDrinkCount: 2,
        optLeftDrinkPegs: 1,
        optLeftDrink1Hole: 10,
        optLeftDrink2Hole: 70,
        optRightDrink: true,
        optRightDrinkCount: 2,
        optRightDrinkPegs: 1,
        optRightDrink1Hole: 20,
        optRightDrink2Hole: 80,
        optEveryoneDrink: true,
        optEveryoneDrinkCount: 2,
        optEveryoneDrinkPegs: 1,
        optEveryoneDrink1Hole: 30,
        optEveryoneDrink2Hole: 90,
        optEveryoneButYouDrink: true,
        optEveryoneButYouDrinkCount: 2,
        optEveryoneButYouDrinkPegs: 1,
        optEveryoneButYouDrink1Hole: 45,
        optEveryoneButYouDrink2Hole: 105,
        optPickWhoDrinks: true,
        optPickWhoDrinksCount: 2,
        optPickWhoDrinksPegs: 1,
        optPickWhoDrinks1Hole: 55,
        optPickWhoDrinks2Hole: 115
      }
    },
    powerHour: {
      key: "powerHour",
      name: "Power Hour",
      badge: "\u26A1 High Stakes",
      icon: "\u26A1",
      description: "Intense and relentless drinking action! Packed with rapid personal shots, neighbor penalties, and cutthroat player targeting.",
      tags: ["Intense", "Fast", "Heavy Drinking"],
      drinkSpaces: 24,
      config: {
        optYouDrink: true,
        optYouDrinkCount: 4,
        optYouDrinkPegs: 2,
        optYouDrink1Hole: 10,
        optYouDrink2Hole: 40,
        optYouDrink3Hole: 70,
        optYouDrink4Hole: 100,
        optGuysDrink: true,
        optGuysDrinkCount: 2,
        optGuysDrinkPegs: 1,
        optGuysDrink1Hole: 20,
        optGuysDrink2Hole: 80,
        optGalsDrink: true,
        optGalsDrinkCount: 2,
        optGalsDrinkPegs: 1,
        optGalsDrink1Hole: 25,
        optGalsDrink2Hole: 85,
        optLeftDrink: true,
        optLeftDrinkCount: 3,
        optLeftDrinkPegs: 1,
        optLeftDrink1Hole: 15,
        optLeftDrink2Hole: 50,
        optLeftDrink3Hole: 95,
        optRightDrink: true,
        optRightDrinkCount: 3,
        optRightDrinkPegs: 1,
        optRightDrink1Hole: 30,
        optRightDrink2Hole: 65,
        optRightDrink3Hole: 105,
        optEveryoneDrink: true,
        optEveryoneDrinkCount: 3,
        optEveryoneDrinkPegs: 1,
        optEveryoneDrink1Hole: 35,
        optEveryoneDrink2Hole: 75,
        optEveryoneDrink3Hole: 115,
        optEveryoneButYouDrink: true,
        optEveryoneButYouDrinkCount: 3,
        optEveryoneButYouDrinkPegs: 1,
        optEveryoneButYouDrink1Hole: 45,
        optEveryoneButYouDrink2Hole: 85,
        optEveryoneButYouDrink3Hole: 110,
        optPickWhoDrinks: true,
        optPickWhoDrinksCount: 4,
        optPickWhoDrinksPegs: 2,
        optPickWhoDrinks1Hole: 5,
        optPickWhoDrinks2Hole: 55,
        optPickWhoDrinks3Hole: 90,
        optPickWhoDrinks4Hole: 118
      }
    },
    socialHour: {
      key: "socialHour",
      name: "Social Hour",
      badge: "\u{1F942} Group Socials",
      icon: "\u{1F942}",
      description: 'High-energy party atmosphere! Maximizes table-wide toasts ("Everyone Drinks") and "Everyone But You" cheers.',
      tags: ["Social", "Celebration", "Group Fun"],
      drinkSpaces: 18,
      config: {
        optYouDrink: true,
        optYouDrinkCount: 2,
        optYouDrinkPegs: 1,
        optYouDrink1Hole: 12,
        optYouDrink2Hole: 72,
        optGuysDrink: true,
        optGuysDrinkCount: 1,
        optGuysDrinkPegs: 1,
        optGuysDrink1Hole: 32,
        optGalsDrink: true,
        optGalsDrinkCount: 1,
        optGalsDrinkPegs: 1,
        optGalsDrink1Hole: 42,
        optLeftDrink: true,
        optLeftDrinkCount: 2,
        optLeftDrinkPegs: 1,
        optLeftDrink1Hole: 22,
        optLeftDrink2Hole: 82,
        optRightDrink: true,
        optRightDrinkCount: 2,
        optRightDrinkPegs: 1,
        optRightDrink1Hole: 52,
        optRightDrink2Hole: 92,
        optEveryoneDrink: true,
        optEveryoneDrinkCount: 4,
        optEveryoneDrinkPegs: 1,
        optEveryoneDrink1Hole: 15,
        optEveryoneDrink2Hole: 45,
        optEveryoneDrink3Hole: 75,
        optEveryoneDrink4Hole: 105,
        optEveryoneButYouDrink: true,
        optEveryoneButYouDrinkCount: 4,
        optEveryoneButYouDrinkPegs: 1,
        optEveryoneButYouDrink1Hole: 25,
        optEveryoneButYouDrink2Hole: 55,
        optEveryoneButYouDrink3Hole: 85,
        optEveryoneButYouDrink4Hole: 115,
        optPickWhoDrinks: true,
        optPickWhoDrinksCount: 2,
        optPickWhoDrinksPegs: 1,
        optPickWhoDrinks1Hole: 35,
        optPickWhoDrinks2Hole: 95
      }
    },
    battleOfSexes: {
      key: "battleOfSexes",
      name: "Battle of the Sexes",
      badge: "\u{1F94A} Guys vs Gals",
      icon: "\u{1F94A}",
      description: "Alternating Guys Drink vs Gals Drink battlefields! Keep score and drink when your gender space is hit.",
      tags: ["Battle", "Competitive", "Guys vs Gals"],
      drinkSpaces: 20,
      config: {
        optYouDrink: true,
        optYouDrinkCount: 2,
        optYouDrinkPegs: 1,
        optYouDrink1Hole: 20,
        optYouDrink2Hole: 80,
        optGuysDrink: true,
        optGuysDrinkCount: 4,
        optGuysDrinkPegs: 1,
        optGuysDrink1Hole: 10,
        optGuysDrink2Hole: 40,
        optGuysDrink3Hole: 70,
        optGuysDrink4Hole: 100,
        optGalsDrink: true,
        optGalsDrinkCount: 4,
        optGalsDrinkPegs: 1,
        optGalsDrink1Hole: 15,
        optGalsDrink2Hole: 45,
        optGalsDrink3Hole: 75,
        optGalsDrink4Hole: 105,
        optLeftDrink: true,
        optLeftDrinkCount: 2,
        optLeftDrinkPegs: 1,
        optLeftDrink1Hole: 30,
        optLeftDrink2Hole: 90,
        optRightDrink: true,
        optRightDrinkCount: 2,
        optRightDrinkPegs: 1,
        optRightDrink1Hole: 35,
        optRightDrink2Hole: 95,
        optEveryoneDrink: true,
        optEveryoneDrinkCount: 2,
        optEveryoneDrinkPegs: 1,
        optEveryoneDrink1Hole: 60,
        optEveryoneDrink2Hole: 120,
        optEveryoneButYouDrink: true,
        optEveryoneButYouDrinkCount: 1,
        optEveryoneButYouDrinkPegs: 1,
        optEveryoneButYouDrink1Hole: 50,
        optPickWhoDrinks: true,
        optPickWhoDrinksCount: 3,
        optPickWhoDrinksPegs: 1,
        optPickWhoDrinks1Hole: 25,
        optPickWhoDrinks2Hole: 65,
        optPickWhoDrinks3Hole: 115
      }
    }
  });
  var PintsPresets = class _PintsPresets {
    static getStorage(storage = null) {
      if (storage) return storage;
      if (typeof window !== "undefined" && window.appStorage) return window.appStorage;
      return appStorage;
    }
    static getPresets(target = 121) {
      const t = Number(target) || 121;
      if (t === 121) return PINTS_PRESETS_121;
      return _PintsPresets.scalePresetsForTarget(PINTS_PRESETS_121, t);
    }
    static scalePresetsForTarget(presets, target) {
      const scale = (target - 1) / 120;
      const scaled = {};
      for (const [key, preset] of Object.entries(presets)) {
        const cfg = { ...preset.config };
        for (const [prop, val] of Object.entries(cfg)) {
          if (typeof val === "number" && prop.endsWith("Hole")) {
            cfg[prop] = Math.min(target - 2, Math.max(2, Math.round(val * scale)));
          }
        }
        scaled[key] = {
          ...preset,
          config: cfg
        };
      }
      return scaled;
    }
    static computeTrackMetrics(items = [], target = 121) {
      const total = items.length;
      let socials = 0;
      let targeted = 0;
      let gender = 0;
      const holes = [];
      for (const item of items) {
        if (item.hole != null) holes.push(item.hole);
        if (["everyoneDrink", "everyoneButYouDrink"].includes(item.type)) socials++;
        else if (["guysDrink", "galsDrink"].includes(item.type)) gender++;
        else targeted++;
      }
      holes.sort((a, b) => a - b);
      let avgSpacing = 0;
      if (holes.length > 1) {
        let sumDist = 0;
        for (let i = 1; i < holes.length; i++) {
          sumDist += holes[i] - holes[i - 1];
        }
        avgSpacing = Math.round(sumDist / (holes.length - 1));
      } else if (holes.length === 1) {
        avgSpacing = target;
      }
      return {
        totalDrinkSpaces: total,
        socialDrinks: socials,
        targetedDrinks: targeted,
        genderDrinks: gender,
        avgSpacing
      };
    }
    static applyPreset(presetKey, context = {}) {
      const target = context.settings && context.settings.target || typeof window !== "undefined" && window.settings && window.settings.target || 121;
      const presets = _PintsPresets.getPresets(target);
      const preset = presets[presetKey] || presets.standard;
      if (!preset) return false;
      const cfg = preset.config;
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (doc) {
        for (const [prop, val] of Object.entries(cfg)) {
          const el = doc.getElementById(prop);
          if (!el) continue;
          if (el.type === "checkbox") {
            el.checked = Boolean(val);
            const toggleFn = typeof window !== "undefined" ? window[`toggle${prop.replace("opt", "")}Config`] : null;
            if (typeof toggleFn === "function") toggleFn(el.checked);
          } else {
            el.value = String(val);
            el.dataset.customized = "true";
          }
        }
        if (typeof window !== "undefined" && typeof window.updateTrackItemRows === "function") {
          const keys = ["youDrink", "guysDrink", "galsDrink", "leftDrink", "rightDrink", "everyoneDrink", "everyoneButYouDrink", "pickWhoDrinks"];
          keys.forEach((k) => window.updateTrackItemRows(k));
        }
      }
      if (context.settings || typeof window !== "undefined" && window.settings) {
        const s = context.settings || window.settings;
        Object.assign(s, cfg);
        s.pintsPreset = presetKey;
      }
      if (typeof window !== "undefined" && typeof window.saveBrandSettings === "function" && typeof window.readBrandSettings === "function") {
        window.saveBrandSettings("pints", window.readBrandSettings("pints"));
      }
      return true;
    }
    static getCustomLayouts(storage = null) {
      const s = _PintsPresets.getStorage(storage);
      try {
        const raw = s.getItem(PINTS_CUSTOM_LAYOUTS_KEY);
        if (!raw) return [];
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.warn("[PintsPresets] Error loading custom layouts:", e);
        return [];
      }
    }
    static saveCustomLayout(layout, storage = null, isImport = false) {
      if (!layout || typeof layout !== "object") throw new Error("Invalid layout object");
      const s = _PintsPresets.getStorage(storage);
      const layouts = _PintsPresets.getCustomLayouts(s);
      const now = (/* @__PURE__ */ new Date()).toISOString();
      const sanitized = LayoutSanitizer.sanitizeLayout(layout, "pints", {
        regenerateId: isImport || !layout.id
      });
      sanitized.metrics = _PintsPresets.computeTrackMetrics(sanitized.items, sanitized.target);
      let targetLayout = null;
      if (!isImport && layout.id) {
        const idx = layouts.findIndex((l) => l.id === sanitized.id);
        if (idx !== -1) {
          targetLayout = {
            ...layouts[idx],
            ...sanitized,
            updatedAt: now
          };
          layouts[idx] = targetLayout;
        }
      }
      if (!targetLayout) {
        targetLayout = sanitized;
        layouts.unshift(targetLayout);
      }
      const capped = LayoutSanitizer.enforceStorageQuota(layouts, MAX_CUSTOM_LAYOUTS);
      if (s) {
        try {
          s.setItem(PINTS_CUSTOM_LAYOUTS_KEY, JSON.stringify(capped));
        } catch (e) {
          console.error("[PintsPresets] Failed to save custom layouts:", e);
          throw new Error("Failed to save layout to storage: Quota exceeded or storage unavailable.");
        }
      }
      return targetLayout;
    }
    static renameCustomLayout(layoutId, newName, storage = null) {
      if (!layoutId || !newName || !newName.trim()) return false;
      const s = _PintsPresets.getStorage(storage);
      const layouts = _PintsPresets.getCustomLayouts(s);
      const layout = layouts.find((l) => l.id === layoutId);
      if (!layout) return false;
      layout.name = newName.trim();
      layout.updatedAt = (/* @__PURE__ */ new Date()).toISOString();
      s.setItem(PINTS_CUSTOM_LAYOUTS_KEY, JSON.stringify(layouts));
      return true;
    }
    static deleteCustomLayout(layoutId, storage = null) {
      if (!layoutId) return false;
      const s = _PintsPresets.getStorage(storage);
      const layouts = _PintsPresets.getCustomLayouts(s);
      const filtered = layouts.filter((l) => l.id !== layoutId);
      if (filtered.length === layouts.length) return false;
      s.setItem(PINTS_CUSTOM_LAYOUTS_KEY, JSON.stringify(filtered));
      return true;
    }
    static duplicateCustomLayout(layoutId, storage = null) {
      if (!layoutId) return null;
      const s = _PintsPresets.getStorage(storage);
      const layouts = _PintsPresets.getCustomLayouts(s);
      const original = layouts.find((l) => l.id === layoutId);
      if (!original) return null;
      const copy = {
        ...original,
        id: void 0,
        name: `${original.name} (Copy)`
      };
      return _PintsPresets.saveCustomLayout(copy, s);
    }
    static exportLayout(layoutId = null, storage = null) {
      const s = _PintsPresets.getStorage(storage);
      const layouts = _PintsPresets.getCustomLayouts(s);
      if (layoutId) {
        const single = layouts.find((l) => l.id === layoutId);
        const prepared2 = LayoutSanitizer.prepareForExport(single || null);
        return JSON.stringify(prepared2, null, 2);
      }
      const prepared = LayoutSanitizer.prepareForExport(layouts);
      return JSON.stringify(prepared, null, 2);
    }
    static importLayout(jsonStr, storage = null) {
      const parsed = LayoutSanitizer.parseJsonSafely(jsonStr);
      const s = _PintsPresets.getStorage(storage);
      if (Array.isArray(parsed)) {
        if (parsed.length > 20) {
          throw new Error("Cannot import more than 20 layouts at once.");
        }
        let lastSaved = null;
        for (const item of parsed) {
          lastSaved = _PintsPresets.saveCustomLayout(item, s, true);
        }
        return lastSaved;
      }
      return _PintsPresets.saveCustomLayout(parsed, s, true);
    }
  };
  if (typeof window !== "undefined") {
    window.PintsPresets = PintsPresets;
    window.PINTS_PRESETS_121 = PINTS_PRESETS_121;
  }

  // src/ui/SettingsManager.js
  function getStorage8(s) {
    return s || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
  }
  var THEMES = [
    {
      id: "passion",
      name: "Sultry Passion",
      cloth: "Sultry passion velvet cloth",
      icon: '<svg class="menu-orbit-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>'
    },
    {
      id: "tournament",
      name: "Tournament Green",
      cloth: "Tournament green cloth",
      icon: '<svg class="menu-orbit-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="4.5"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M4.93 19.07l2.12-2.12M16.95 7.05l2.12-2.12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>'
    },
    {
      id: "night",
      name: "Night Obsidian",
      cloth: "Night obsidian cloth",
      icon: '<svg class="menu-orbit-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>'
    },
    {
      id: "burgundy",
      name: "Royal Burgundy",
      cloth: "Royal burgundy velvet",
      icon: '<svg class="menu-orbit-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5zm14 3c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-1h14v1z"/></svg>'
    },
    {
      id: "sapphire",
      name: "Ocean Sapphire",
      cloth: "Ocean sapphire cloth",
      icon: '<svg class="menu-orbit-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>'
    },
    {
      id: "rustic",
      name: "Rustic Walnut",
      cloth: "Rustic walnut cloth",
      icon: '<svg class="menu-orbit-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/></svg>'
    },
    {
      id: "amethyst",
      name: "Regal Amethyst",
      cloth: "Regal amethyst velvet",
      icon: '<svg class="menu-orbit-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 1L9 9l-8 3 8 3 3 8 3-8 8-3-8-3z"/></svg>'
    },
    {
      id: "charcoal",
      name: "Stealth Charcoal",
      cloth: "Stealth charcoal cloth",
      icon: '<svg class="menu-orbit-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/></svg>'
    }
  ];
  var SettingsManager = class _SettingsManager {
    constructor(options = {}) {
      this.brand = options.brand || "crazy";
      this.storage = getStorage8(options.storage);
      this.recordCache = null;
    }
    static getThemeKey(brand = "crazy") {
      if (brand === "clash") return "cribbageClash.theme";
      if (brand === "adult") return "skunkedAndStripped.theme";
      return "crazyCribbage.theme";
    }
    static getDefaultTheme(brand = "crazy") {
      if (brand === "clash") return "rustic";
      if (brand === "adult") return "passion";
      return "tournament";
    }
    static getSettingsKey(brand = "crazy") {
      if (brand === "clash") return "cribbageClash.settings.v1";
      if (brand === "pints") return "pintsAndPegs.settings.v1";
      if (brand === "adult") return "skunkedAndStripped.settings.v1";
      return "crazyCribbage.settings.v1";
    }
    static getRecordKey(brand = "crazy") {
      if (brand === "clash") return "cribbageClash.records.v1";
      if (brand === "pints") return "pintsAndPegs.records.v1";
      if (brand === "adult") return "skunkedAndStripped.records.v1";
      return "crazyCribbage.records.v1";
    }
    static isAgeVerified(brand = "crazy", storage = null) {
      if (brand !== "pints" && brand !== "adult") return true;
      const s = getStorage8(storage);
      if (!s) return false;
      try {
        return s.getItem("cc_age_verified_" + brand) === "true";
      } catch (e) {
        return false;
      }
    }
    static setAgeVerified(brand = "crazy", val = true, storage = null) {
      const s = getStorage8(storage);
      if (!s) return;
      try {
        s.setItem("cc_age_verified_" + brand, val ? "true" : "false");
      } catch (e) {
      }
    }
    static saveSettingsStore(data, storage = null, brand = null, suppress = false) {
      if (suppress) return;
      brand = brand || _SettingsManager.getAppBrand();
      const s = getStorage8(storage);
      if (!s) return;
      try {
        s.setItem(_SettingsManager.getSettingsKey(brand), JSON.stringify(data));
      } catch (e) {
      }
    }
    static loadSettingsStore(storage = null, brand = null, defaultAdultSettings = null, adultOptionsList = null) {
      if (storage && typeof storage === "object" && !("getItem" in storage) && (storage.brand !== void 0 || storage.storage !== void 0)) {
        brand = storage.brand;
        defaultAdultSettings = storage.defaultAdultSettings;
        adultOptionsList = storage.adultOptionsList;
        storage = storage.storage;
      }
      brand = brand || _SettingsManager.getAppBrand();
      const s = getStorage8(storage);
      let parsed = null;
      if (s) {
        try {
          const raw = s.getItem(_SettingsManager.getSettingsKey(brand));
          if (raw) parsed = JSON.parse(raw);
        } catch (e) {
        }
      }
      if (parsed) {
        if (brand !== "clash") {
          const clashKeys = [
            "optNoPassingLanes",
            "noPassingLanes",
            "optJump",
            "jump",
            "optJail",
            "jail",
            "optBar",
            "bar",
            "optTimeout",
            "timeout",
            "optDetour",
            "detour",
            "optRoundAbout",
            "roundAbout",
            "optSigns",
            "signs",
            "optStopSign",
            "stopSign",
            "optDice",
            "dice",
            "optWheel",
            "wheel",
            "optSpinningWheel",
            "spinningWheel",
            "optSkunkMarkers",
            "skunkMarkers",
            "noPassingLaneStarts",
            "jumpStarts",
            "jumpDests",
            "jailHoles",
            "barHoles",
            "timeoutHoles",
            "detourHoles",
            "roundAboutHoles",
            "signsBlocks",
            "stopSignHoles",
            "diceHoles",
            "wheelHoles",
            "spinningWheelHoles",
            "clashPreset",
            "clashCustomLayoutId"
          ];
          clashKeys.forEach((k) => {
            delete parsed[k];
          });
        }
        if (brand !== "crazy") {
          const crazyKeys = ["jokers", "optCutBeforeDiscard", "opt31sFor5", "opt19sFor2", "optRoundAroundTheWorld", "optMultipleRunsInPegging", "optPickYourCrib", "optSpeedoCribbage", "optShotgunCribbage", "optTwistedCribbage", "optChutesAndLadders", "optFivesCribbage", "optSevensAndEightsCribbage", "optDrawCribbage", "opt7CardCribbage", "optProgressiveCut", "optCanadianDoubles", "optProgressiveSteals", "optAllRed", "optAllBlack", "optAllOdd", "optAllEven", "optAllDifferentSuits", "optKH", "optQS", "optAS", "optSpades", "optGuessStarter", "optStraight", "optFullHouse", "optStraightFlush", "optRoyalFlush", "optRockCrib", "optStinkHole", "optFlushInPlay", "optPegThroughZones", "optLast5PegOut", "optBunkers", "optStolenCrib", "optZeroHand", "optZeroCrib"];
          crazyKeys.forEach((k) => {
            delete parsed[k];
          });
        }
        if (brand !== "pints") {
          const pintsKeys = ["optYouDrink", "optGuysDrink", "optGalsDrink", "optLeftDrink", "optRightDrink", "optEveryoneDrink", "optEveryoneButYouDrink", "optPickWhoDrinks"];
          pintsKeys.forEach((k) => {
            delete parsed[k];
            delete parsed[k + "Count"];
            delete parsed[k + "Holes"];
            delete parsed[k + "Pegs"];
          });
        }
        if (brand !== "adult") {
          const adultKeys = ["optLoseClothing", "optGainClothing", "optPickWhoLosesClothing", "optRightLosesClothing", "optLeftLosesClothing", "optRemoveClothingChoice", "optTouchBreast", "optLickBreast", "optSuckBreast", "optTouchGenitals", "optLickGenitals", "optSuckGenitals", "optFingerGenitals", "optGenitalIntercourse", "optTouchAnus", "optLickAnus", "optFingerAnus", "optAnalIntercourse"];
          adultKeys.forEach((k) => {
            delete parsed[k];
            delete parsed[k + "Count"];
            delete parsed[k + "Holes"];
            delete parsed[k + "Pegs"];
          });
        }
      }
      if (brand === "adult") {
        const getDef = defaultAdultSettings || (typeof window !== "undefined" && typeof window.getDefaultAdultSettings === "function" ? window.getDefaultAdultSettings : null);
        const defaults = (typeof getDef === "function" ? getDef() : getDef) || {};
        if (!parsed) return defaults;
        const opts = adultOptionsList || (typeof window !== "undefined" && Array.isArray(window.ADULT_OPTIONS_LIST) ? window.ADULT_OPTIONS_LIST : []);
        const hasAnyAdultOption = opts.some((opt) => parsed[opt.chkId] === true);
        if (!hasAnyAdultOption) {
          const merged = Object.assign({}, defaults, parsed);
          opts.forEach((opt) => {
            merged[opt.chkId] = true;
            if (merged[opt.key + "Count"] == null) merged[opt.key + "Count"] = opt.group === "strip" ? 2 : 1;
            if (merged[opt.key + "Pegs"] == null) merged[opt.key + "Pegs"] = 1;
            if (!merged[opt.key + "Holes"]) merged[opt.key + "Holes"] = [...opt.defaultHoles || []];
          });
          return merged;
        }
        return parsed;
      }
      if (brand === "clash") {
        const validClashTargets = [241, 361, 481];
        if (!parsed) {
          return { target: 481 };
        }
        if (!validClashTargets.includes(Number(parsed.target))) {
          parsed.target = 481;
        }
        return parsed;
      }
      if (brand === "pints") {
        const pintsDefaults = typeof window !== "undefined" && window.PINTS_PRESETS_121?.standard?.config || PINTS_PRESETS_121?.standard?.config || {};
        if (!parsed) {
          return Object.assign({ target: 121, brand: "pints", selected3DBoardId: "board-14" }, pintsDefaults);
        }
        if ([241, 361, 481].includes(Number(parsed.target))) {
          parsed.target = 121;
        }
        if (parsed.selected3DBoardId === "board-cribbage-clash" || parsed.selected3DBoardId === "board-cribbage-clash-square") {
          parsed.selected3DBoardId = "board-14";
        }
        parsed.brand = "pints";
        const pintsKeys = ["optYouDrink", "optGuysDrink", "optGalsDrink", "optLeftDrink", "optRightDrink", "optEveryoneDrink", "optEveryoneButYouDrink", "optPickWhoDrinks"];
        const hasAnyPintsOption = pintsKeys.some((k) => parsed[k] === true);
        if (!hasAnyPintsOption) {
          Object.assign(parsed, pintsDefaults);
        }
        return parsed;
      }
      if (parsed) return parsed;
      return null;
    }
    static loadRecords(storage = null, brand = "crazy") {
      const s = getStorage8(storage);
      if (!s) return {};
      const currentKey = _SettingsManager.getRecordKey(brand);
      try {
        const raw = s.getItem(currentKey);
        const data = raw ? JSON.parse(raw) : {};
        return data && typeof data === "object" ? data : {};
      } catch (e) {
        return {};
      }
    }
    static saveRecords(map, storage = null, brand = "crazy") {
      const s = getStorage8(storage);
      if (!s) return;
      const currentKey = _SettingsManager.getRecordKey(brand);
      try {
        s.setItem(currentKey, JSON.stringify(map));
      } catch (e) {
      }
    }
    static getVariantRecord(key, storage = null, brand = "crazy") {
      const map = _SettingsManager.loadRecords(storage, brand);
      return map[key] || { wins: 0, losses: 0 };
    }
    static recordGameResult(winner, variantKey, variantLabel, storage = null, brand = "crazy") {
      const map = _SettingsManager.loadRecords(storage, brand);
      if (!map[variantKey]) {
        map[variantKey] = { wins: 0, losses: 0, label: variantLabel || variantKey };
      }
      if (winner === "you") {
        map[variantKey].wins += 1;
      } else {
        map[variantKey].losses += 1;
      }
      if (variantLabel) {
        map[variantKey].label = variantLabel;
      }
      _SettingsManager.saveRecords(map, storage, brand);
      return map[variantKey];
    }
    /**
     * Applies a theme to document elements.
     */
    static applyTheme(themeName, options = {}) {
      const brand = options.brand || _SettingsManager.getAppBrand();
      const isClash = brand === "clash";
      let theme2 = isClash ? "rustic" : themeName || _SettingsManager.getDefaultTheme(brand);
      let cur = THEMES.find((t) => t.id === theme2);
      if (!cur) {
        cur = THEMES[0];
        theme2 = cur.id;
      }
      const currentIndex = THEMES.indexOf(cur);
      const nextTheme = THEMES[(currentIndex + 1) % THEMES.length];
      if (typeof document !== "undefined") {
        if (document.documentElement) document.documentElement.setAttribute("data-theme", theme2);
        if (document.body) document.body.setAttribute("data-theme", theme2);
        const app = document.getElementById("app");
        if (app) app.setAttribute("data-theme", theme2);
        const overlay = document.getElementById("overlay");
        if (overlay) overlay.setAttribute("data-theme", theme2);
        const modal = document.getElementById("modal");
        if (modal) modal.setAttribute("data-theme", theme2);
        const waitOverlay = document.getElementById("waitOverlay");
        if (waitOverlay) waitOverlay.setAttribute("data-theme", theme2);
        const b = document.getElementById("btnTheme");
        if (b) {
          b.textContent = cur.name;
          b.title = `Theme: ${cur.name} (Click to switch to ${nextTheme.name})`;
          b.style.display = isClash ? "none" : "";
        }
        const iconSvg = cur.icon;
        const tooltip = `Theme: ${cur.name} (Click for ${nextTheme.name})`;
        const btnMenu = document.getElementById("btnThemeMenu");
        if (btnMenu) {
          btnMenu.innerHTML = iconSvg + `
          <svg class="menu-orbit-label-svg" viewBox="-50 -50 100 100" aria-hidden="true">
            <path id="arc-label-theme" d="M -35,15 A 38,38 0 0,0 35,15" fill="none"/>
            <text class="menu-orbit-label-text"><textPath href="#arc-label-theme" startOffset="50%" text-anchor="middle">THEME</textPath></text>
          </svg>
        `;
          btnMenu.title = tooltip;
          btnMenu.setAttribute("aria-label", tooltip);
          btnMenu.style.display = isClash ? "none" : "";
        }
        const btnHeader = document.getElementById("btnThemeHeader");
        if (btnHeader) {
          btnHeader.innerHTML = iconSvg;
          btnHeader.title = tooltip;
          btnHeader.setAttribute("aria-label", tooltip);
          btnHeader.style.display = isClash ? "none" : "";
        }
      }
      if (options.showFeedback && typeof window !== "undefined" && typeof window.fancyCall === "function") {
        window.fancyCall(cur.name, "famous", 1200);
      }
      return theme2;
    }
    /**
     * Toggles to the next available theme.
     */
    static toggleTheme(currentTheme, brand = "crazy", storage = null) {
      if (brand === "clash") return "rustic";
      const currentIndex = THEMES.findIndex((t) => t.id === currentTheme);
      const nextIndex = (currentIndex + 1) % THEMES.length;
      const nextTheme = THEMES[nextIndex].id;
      const s = getStorage8(storage);
      if (s) {
        try {
          s.setItem(_SettingsManager.getThemeKey(brand), nextTheme);
        } catch (e) {
        }
      }
      return nextTheme;
    }
    /**
     * Sets the active card back pattern on the DOM and settings store.
     */
    static setCardBack(id, options = {}) {
      const pattern = CARD_BACKS.find((p) => p.id === id) || CARD_BACKS[0];
      if (typeof document !== "undefined") {
        const app = document.getElementById("app");
        if (app) app.setAttribute("data-card-back", pattern.id);
        const prev = document.getElementById("activePatternPreview");
        if (prev) prev.className = "pattern-preview pattern-" + pattern.id;
        const lbl = document.getElementById("activePatternLabel");
        if (lbl) lbl.textContent = pattern.name;
        const sel = document.getElementById("optCardBack");
        if (sel && sel.value !== pattern.id) {
          sel.value = pattern.id;
        }
        const dropdown = document.getElementById("cardBackDropdown");
        if (dropdown) {
          dropdown.querySelectorAll(".card-picker-option").forEach((opt) => {
            const match = opt.getAttribute("data-value") === pattern.id;
            opt.classList.toggle("selected", match);
            opt.setAttribute("aria-selected", match ? "true" : "false");
          });
        }
      }
      if (options.settings) {
        options.settings.cardBack = pattern.id;
      }
      if (!options.skipSave && typeof options.onSave === "function") {
        options.onSave(pattern.id);
      }
      return pattern.id;
    }
    /**
     * Initializes the card back picker custom dropdown with keyboard and click support.
     */
    static initCardBackPicker(options = {}) {
      if (typeof document === "undefined") return;
      const trigger = document.getElementById("cardBackTrigger");
      const dropdown = document.getElementById("cardBackDropdown");
      const sel = document.getElementById("optCardBack");
      if (!trigger || !dropdown) return;
      dropdown.innerHTML = CARD_BACKS.map((p) => `
      <div class="card-picker-option ${(options.currentCardBack || "classic-blue") === p.id ? "selected" : ""}" role="option" data-value="${p.id}" aria-selected="${(options.currentCardBack || "classic-blue") === p.id}" tabindex="0">
        <span class="pattern-preview pattern-${p.id}"></span>
        <div class="option-info">
          <div class="option-title">${p.name}</div>
          <div class="option-desc">${p.desc}</div>
        </div>
        <svg class="option-check" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>
      </div>
    `).join("");
      if (sel && sel.options.length === 0) {
        sel.innerHTML = CARD_BACKS.map((p) => `<option value="${p.id}">${p.name}</option>`).join("");
      }
      function openDropdown() {
        dropdown.classList.remove("hidden");
        trigger.setAttribute("aria-expanded", "true");
        const selectedOpt = dropdown.querySelector(".card-picker-option.selected") || dropdown.querySelector(".card-picker-option");
        if (selectedOpt) selectedOpt.focus();
      }
      function closeDropdown(focusTrigger = false) {
        dropdown.classList.add("hidden");
        trigger.setAttribute("aria-expanded", "false");
        if (focusTrigger) trigger.focus();
      }
      trigger.onclick = (e) => {
        e.stopPropagation();
        if (dropdown.classList.contains("hidden")) {
          openDropdown();
        } else {
          closeDropdown();
        }
      };
      dropdown.onclick = (e) => {
        const opt = e.target.closest(".card-picker-option");
        if (opt) {
          const val = opt.getAttribute("data-value");
          _SettingsManager.setCardBack(val, options);
          closeDropdown(true);
        }
      };
      dropdown.onkeydown = (e) => {
        const optList = Array.from(dropdown.querySelectorAll(".card-picker-option"));
        const currIndex = optList.indexOf(document.activeElement);
        if (e.key === "ArrowDown") {
          e.preventDefault();
          const next = (currIndex + 1) % optList.length;
          optList[next].focus();
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          const prev = (currIndex - 1 + optList.length) % optList.length;
          optList[prev].focus();
        } else if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (currIndex >= 0) {
            const val = optList[currIndex].getAttribute("data-value");
            _SettingsManager.setCardBack(val, options);
            closeDropdown(true);
          }
        } else if (e.key === "Escape") {
          e.preventDefault();
          closeDropdown(true);
        }
      };
      document.addEventListener("click", (e) => {
        if (!e.target.closest("#cardBackPicker")) {
          closeDropdown();
        }
      });
      _SettingsManager.setCardBack(options.currentCardBack || "classic-blue", { ...options, skipSave: true });
    }
    /**
     * Deconstructs match settings into variant parts.
     */
    static variantParts(obj = {}) {
      const goal = obj.goal === "low" ? "low" : "high";
      const target = obj.target ? String(obj.target) : "121";
      const deal = obj.deal === "super" ? "super" : "std";
      const decks = parseInt(obj.decks, 10) === 2 ? "2" : "1";
      return { goal, target, deal, decks };
    }
    /**
     * Generates a unique key string for a variant setup.
     */
    static variantKeyFrom(obj) {
      const p = _SettingsManager.variantParts(obj);
      return [p.goal, p.target, p.deal, p.decks].join("|");
    }
    /**
     * Generates a readable label for a variant setup.
     */
    static variantLabelFrom(obj) {
      const p = _SettingsManager.variantParts(obj);
      return (p.goal === "low" ? "Low ball" : "High ball") + " \xB7 " + p.target + " \xB7 " + (p.deal === "super" ? "Super" : "Standard") + " \xB7 " + p.decks + " deck" + (p.decks === "2" ? "s" : "");
    }
    /**
     * Reads the current variant configuration from the lobby form.
     */
    static currentFormVariant(context = {}) {
      const brand = context.brand || (typeof window !== "undefined" && window.getAppBrand ? window.getAppBrand() : "crazy");
      const isClash = brand === "clash";
      if (typeof document === "undefined") {
        return { goal: "high", target: isClash ? 481 : 121, deal: "std", decks: 1 };
      }
      const deal = document.getElementById("optDeal");
      const goal = document.getElementById("optGoal");
      const target = document.getElementById("optTarget");
      const decks = document.getElementById("optDecks");
      if (!deal) return { goal: "high", target: isClash ? 481 : 121, deal: "std", decks: 1 };
      return {
        deal: deal.value,
        goal: isClash ? "high" : goal ? goal.value : "high",
        target: parseInt(target.value, 10),
        decks: parseInt(decks.value, 10) || 1
      };
    }
    /**
     * Renders the current setup win/loss stats and game record badge in the lobby.
     */
    static renderRecordBox(context = {}) {
      if (typeof document === "undefined") return;
      const curEl = document.getElementById("recordCurrent");
      const listEl = document.getElementById("recordList");
      if (!curEl || !listEl) return;
      const brand = context.brand || (typeof window !== "undefined" && window.getAppBrand ? window.getAppBrand() : "crazy");
      const storage = getStorage8(context.storage);
      const v = _SettingsManager.currentFormVariant({ brand });
      const rec = _SettingsManager.getVariantRecord(_SettingsManager.variantKeyFrom(v), storage, brand);
      curEl.style.display = "block";
      curEl.textContent = "This setup \u2014 " + rec.wins + " win" + (rec.wins === 1 ? "" : "s") + " \xB7 " + rec.losses + " loss" + (rec.losses === 1 ? "" : "es");
      const map = _SettingsManager.loadRecords(storage, brand);
      const rows = Object.keys(map).map((k) => {
        const r = map[k];
        return { key: k, label: r.label || k, wins: r.wins || 0, losses: r.losses || 0 };
      }).filter((r) => r.wins + r.losses > 0).sort((a, b) => b.wins + b.losses - (a.wins + a.losses));
      listEl.innerHTML = rows.length ? rows.map((r) => "<div>" + r.label + " \u2014 " + r.wins + "\u2013" + r.losses + "</div>").join("") : "<div>No games recorded yet.</div>";
      const gameRec = document.getElementById("gameRecord");
      if (gameRec) {
        const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
        const activeObj = settings3 && settings3.deal ? settings3 : v;
        const r = _SettingsManager.getVariantRecord(_SettingsManager.variantKeyFrom(activeObj), storage, brand);
        gameRec.textContent = r.wins + "\u2013" + r.losses;
      }
    }
    /**
     * Displays the modal with full historical match records across variants.
     */
    static showRecordsModal(context = {}) {
      _SettingsManager.renderRecordBox(context);
      const brand = context.brand || (typeof window !== "undefined" && window.getAppBrand ? window.getAppBrand() : "crazy");
      const storage = getStorage8(context.storage);
      const v = _SettingsManager.currentFormVariant({ brand });
      const rec = _SettingsManager.getVariantRecord(_SettingsManager.variantKeyFrom(v), storage, brand);
      const currentLine = "This setup \u2014 " + rec.wins + " win" + (rec.wins === 1 ? "" : "s") + " \xB7 " + rec.losses + " loss" + (rec.losses === 1 ? "" : "es");
      const map = _SettingsManager.loadRecords(storage, brand);
      const rows = Object.keys(map).map((k) => {
        const r = map[k];
        return { key: k, label: r.label || k, wins: r.wins || 0, losses: r.losses || 0 };
      }).filter((r) => r.wins + r.losses > 0).sort((a, b) => b.wins + b.losses - (a.wins + a.losses));
      const listItemsHtml = rows.length ? rows.map((r) => `<div style="margin:6px 0;padding:5px 0;border-bottom:1px solid rgba(244,234,212,0.1);display:flex;justify-content:space-between;align-items:center;gap:12px;"><span>${r.label}</span><strong style="color:var(--gold,#f0c64a);white-space:nowrap;">${r.wins}\u2013${r.losses}</strong></div>`).join("") : '<div style="color:#d7e8dc;font-style:italic;padding:12px 0;">No games recorded yet.</div>';
      const modalHtml = `
      <h2>Game Records</h2>
      <div style="background:rgba(0,0,0,0.35);padding:10px 14px;border-radius:8px;border:1px solid rgba(240,198,74,0.35);margin:12px 0 14px;color:var(--gold,#f0c64a);font-weight:600;font-size:0.95rem;">
        ${currentLine}
      </div>
      <div class="record-list record-list-modal" style="display:block;max-height:55vh;overflow-y:auto;text-align:left;padding:10px 14px;background:rgba(0,0,0,0.28);border-radius:8px;border:1px solid rgba(244,234,212,0.18);line-height:1.6;">
        ${listItemsHtml}
      </div>
      <div style="margin-top:16px;display:flex;justify-content:center;gap:12px;flex-wrap:wrap;">
        <button type="button" class="btn-danger" id="btnResetStats">Reset Statistics</button>
        <button type="button" class="btn-gold modal-btn-close" id="btnCloseRecords">Close</button>
      </div>
    `;
      const showModalFn = context.showModal || (typeof window !== "undefined" && window.showModal ? window.showModal : null);
      if (typeof showModalFn === "function") {
        showModalFn(modalHtml, true);
        if (typeof document !== "undefined") {
          const btnReset = document.getElementById("btnResetStats");
          if (btnReset) {
            btnReset.addEventListener("click", () => {
              if (typeof resetGameStatistics === "function") resetGameStatistics();
              else _SettingsManager.resetGameStatistics(context);
            });
          }
        }
      }
    }
    /**
     * Resets all stored match statistics after confirmation.
     */
    static resetGameStatistics(context = {}) {
      const showConfirmModalFn = context.showConfirmModal || (typeof window !== "undefined" && window.showConfirmModal ? window.showConfirmModal : null);
      const onConfirm = () => {
        const brand = context.brand || (typeof window !== "undefined" && window.getAppBrand ? window.getAppBrand() : "crazy");
        const storage = getStorage8(context.storage);
        _SettingsManager.saveRecords({}, storage, brand);
        if (storage) {
          try {
            storage.removeItem(_SettingsManager.getRecordKey(brand));
          } catch (e) {
          }
        }
        _SettingsManager.renderRecordBox(context);
        _SettingsManager.showRecordsModal(context);
      };
      if (typeof showConfirmModalFn === "function") {
        showConfirmModalFn({
          title: "Reset All Statistics?",
          message: "Are you sure you want to reset all game statistics, win rates, and records? This action cannot be undone.",
          confirmText: "Reset Statistics",
          cancelText: "Cancel",
          danger: true,
          onConfirm
        });
      } else {
        onConfirm();
      }
    }
    /**
     * Detects the current application brand based on globals, window.location search, or path.
     */
    static getAppBrand(win = typeof window !== "undefined" ? window : null) {
      if (win) {
        if (win.currentBrand) return win.currentBrand;
        if (win.currentLogoBrand) return win.currentLogoBrand;
        if (typeof win.detectBrand === "function") {
          try {
            return win.detectBrand();
          } catch (e) {
          }
        }
        try {
          if (win.location && win.location.search) {
            const params = new URLSearchParams(win.location.search);
            const b = (params.get("brand") || params.get("game") || params.get("logo") || "").toLowerCase();
            if (b === "clash" || b === "cribbage-clash") return "clash";
            if (b === "pints" || b === "pints-and-pegs" || b === "cribbage-pints") return "pints";
            if (b === "adult" || b === "stripped" || b === "skunked-and-stripped") return "adult";
            if (b === "crazy" || b === "crazy-cribbage") return "crazy";
          }
          const href = (win.location && win.location.href ? win.location.href : "").toLowerCase();
          if (href.includes("game-skunked-and-stripped") || href.includes("skunked-and-stripped") || href.includes("adult") || href.includes("stripped")) return "adult";
          if (href.includes("game-pints-and-pegs") || href.includes("pints-and-pegs") || href.includes("pints")) return "pints";
          if (href.includes("game-cribbage-clash") || href.includes("cribbage-clash") || href.includes("clash")) return "clash";
        } catch (e) {
        }
      }
      if (typeof document !== "undefined" && document.documentElement) {
        const b = document.documentElement.getAttribute("data-brand");
        if (b) return b;
      }
      return "crazy";
    }
    /**
     * Parses game mode string into playerCount and gameMode.
     */
    static parseGameMode(val) {
      if (val === "3_shifting") return { playerCount: 3, gameMode: "shifting" };
      if (val === "3" || val === "3_indiv") return { playerCount: 3, gameMode: "individual" };
      if (val === "4_part") return { playerCount: 4, gameMode: "partnership" };
      if (val === "4" || val === "4_indiv") return { playerCount: 4, gameMode: "individual" };
      if (val === "5" || val === "5_shifting") return { playerCount: 5, gameMode: "shifting" };
      if (val === "6" || val === "6_teams") return { playerCount: 6, gameMode: "teams" };
      if (val === "7" || val === "7_shifting") return { playerCount: 7, gameMode: "shifting" };
      if (val === "8" || val === "8_teams") return { playerCount: 8, gameMode: "teams" };
      return { playerCount: 2, gameMode: "individual" };
    }
    /**
     * Serializes playerCount and gameMode into a compact mode identifier string.
     */
    static serializeGameMode(playerCount, gameMode) {
      if (playerCount === 3) return gameMode === "shifting" ? "3_shifting" : "3_indiv";
      if (playerCount === 4) return gameMode === "partnership" ? "4_part" : "4_indiv";
      if (playerCount === 5) return "5_shifting";
      if (playerCount === 6) return "6_teams";
      if (playerCount === 7) return "7_shifting";
      if (playerCount === 8) return "8_teams";
      return "2";
    }
    /**
     * Determines whether the current game settings represent human-vs-human mode.
     */
    static isHvH(settingsObj, context = {}) {
      const s = settingsObj || (typeof window !== "undefined" ? window.settings : null);
      if (!s) return false;
      const pCount = parseInt(s.playerCount, 10) || 2;
      const getAppBrandFn = context.getAppBrand || (typeof window !== "undefined" && window.getAppBrand ? window.getAppBrand : _SettingsManager.getAppBrand);
      const b = typeof getAppBrandFn === "function" ? getAppBrandFn() : "crazy";
      const gameOptionsEngine = context.GameOptionsEngine || (typeof window !== "undefined" && window.GameOptionsEngine ? window.GameOptionsEngine : typeof globalThis !== "undefined" && globalThis.GameOptionsEngine ? globalThis.GameOptionsEngine : null);
      const allowCpu = gameOptionsEngine && typeof gameOptionsEngine.isCpuAllowed === "function" ? gameOptionsEngine.isCpuAllowed(b) : !["pints", "adult"].includes(b);
      if (!allowCpu) return pCount === 2 && s.opp !== "online";
      return s.opp === "human" && pCount === 2;
    }
    /**
     * Returns a fresh deep clone of the default settings object.
     * @param {string} [brand='crazy']
     * @returns {Object}
     */
    static getDefaultSettings(brand = "crazy") {
      const s = JSON.parse(JSON.stringify(DEFAULT_SETTINGS));
      if (brand === "clash") {
        s.target = 481;
      }
      return s;
    }
  };
  var CARD_BACKS = Object.freeze([
    { id: "classic-blue", name: "Classic Blue", desc: "Traditional casino crosshatch" },
    { id: "classic-red", name: "Classic Red", desc: "Bicycle crimson diamond weave" },
    { id: "emerald-diamond", name: "Emerald Diamond", desc: "Lush green argyle with gold flecks" },
    { id: "royal-gold", name: "Royal Gold", desc: "Luxurious onyx & gold filigree" },
    { id: "vintage-tartan", name: "Vintage Tartan", desc: "Scottish highland green & red plaid" },
    { id: "honeycomb", name: "Amber Honeycomb", desc: "Warm geometric hexagon grid" },
    { id: "midnight-stars", name: "Midnight Astral", desc: "Cosmic navy with celestial starbursts" },
    { id: "amethyst", name: "Amethyst Lattice", desc: "Royal imperial purple & lavender" },
    { id: "vegas-crimson", name: "Vegas Crimson", desc: "Vibrant casino scarlet repeating mesh" },
    { id: "obsidian-carbon", name: "Stealth Carbon", desc: "Modern charcoal & black carbon weave" }
  ]);
  var BOARD_FINISHES = Object.freeze([
    { id: "maple", name: "Natural Maple", desc: "Classic golden honey grain" },
    { id: "walnut", name: "Dark Walnut", desc: "Deep espresso timber with rich grain" },
    { id: "cherry", name: "Rich Cherry", desc: "Warm reddish mahogany lacquer" },
    { id: "obsidian", name: "Midnight Obsidian", desc: "Stealth charcoal ebony with gold border" },
    { id: "driftwood", name: "Coastal Driftwood", desc: "Weathered salt-air ash & gray" }
  ]);
  SettingsManager.BOARD_FINISHES = BOARD_FINISHES;
  var PEG_SKINS = Object.freeze([
    { id: "avatar", name: "Custom Avatar Peg", desc: "Display your chosen persona wrapped on your peg" },
    { id: "brass", name: "Polished Brass", desc: "Authentic radiant gold luster" },
    { id: "silver", name: "Sterling Silver", desc: "Sleek brushed chrome metallic" },
    { id: "cherry", name: "Turned Cherry", desc: "Rich reddish-brown artisanal wood" },
    { id: "walnut", name: "Dark Walnut", desc: "Deep dark roasted timber finish" },
    { id: "glow", name: "Radiant Glow", desc: "Luminescent neon cyan/emerald shine" }
  ]);
  SettingsManager.PEG_SKINS = PEG_SKINS;
  SettingsManager.CARD_BACKS = CARD_BACKS;
  SettingsManager.THEMES = THEMES;
  var CHECK_IDS = Object.freeze({
    jokers: "optJokers",
    optCutBeforeDiscard: "optCutBeforeDiscard",
    opt31sFor5: "opt31sFor5",
    opt19sFor2: "opt19sFor2",
    optRoundAroundTheWorld: "optRoundAroundTheWorld",
    optPickYourCrib: "optPickYourCrib",
    optSpeedoCribbage: "optSpeedoCribbage",
    optShotgunCribbage: "optShotgunCribbage",
    optFivesCribbage: "optFivesCribbage",
    optSevensAndEightsCribbage: "optSevensAndEightsCribbage",
    optDrawCribbage: "optDrawCribbage",
    opt7CardCribbage: "opt7CardCribbage",
    optProgressiveCut: "optProgressiveCut",
    optProgressiveSteals: "optProgressiveSteals",
    optAllRed: "optAllRed",
    optAllBlack: "optAllBlack",
    optAllOdd: "optAllOdd",
    optAllEven: "optAllEven",
    optAllDifferentSuits: "optAllDifferentSuits",
    optKH: "optKH",
    optQS: "optQS",
    optAS: "optAS",
    optStraight: "optStraight",
    optFullHouse: "optFullHouse",
    optStraightFlush: "optStraightFlush",
    optRoyalFlush: "optRoyalFlush",
    optRockCrib: "optRockCrib",
    optStinkHole: "optStinkHole",
    optPegThroughZones: "optPegThroughZones",
    optLast5PegOut: "optLast5PegOut",
    optBunkers: "optBunkers",
    optNoPassingLanes: "optNoPassingLanes",
    optJump: "optJump",
    optJail: "optJail",
    optBar: "optBar",
    optTimeout: "optTimeout",
    optDetour: "optDetour",
    optRoundAbout: "optRoundAbout",
    optSigns: "optSigns",
    optFlushInPlay: "optFlushInPlay",
    optStolenCrib: "optStolenCrib",
    optTwistedCribbage: "optTwistedCribbage",
    optChutesAndLadders: "optChutesAndLadders",
    optSpades: "optSpades",
    optGuessStarter: "optGuessStarter",
    optZeroHand: "optZeroHand",
    optZeroCrib: "optZeroCrib",
    optCanadianDoubles: "optCanadianDoubles",
    optMultipleRunsInPegging: "optMultipleRunsInPegging"
  });
  SettingsManager.CHECK_IDS = CHECK_IDS;
  var DEFAULT_SETTINGS = Object.freeze({
    opp: "cpu",
    playerCount: 2,
    gameMode: "individual",
    seats: [
      { id: "p1", name: "You", type: "human", personality: "shark", team: 1, color: "#d4a017" },
      { id: "p2", name: "The Shark", type: "cpu", personality: "shark", team: 2, color: "#ef4444" },
      { id: "p3", name: "The Gambler", type: "cpu", personality: "gambler", team: 1, color: "#10b981" },
      { id: "p4", name: "The Turtler", type: "cpu", personality: "turtler", team: 2, color: "#3b82f6" },
      { id: "p5", name: "The Maverick", type: "cpu", personality: "gambler", team: 1, color: "#a855f7" },
      { id: "p6", name: "The Grinder", type: "cpu", personality: "turtler", team: 3, color: "#f97316" },
      { id: "p7", name: "The Barracuda", type: "cpu", personality: "shark", team: 3, color: "#06b6d4" },
      { id: "p8", name: "The High Roller", type: "cpu", personality: "gambler", team: 4, color: "#ec4899" }
    ],
    aiProfile: "shark",
    coach: "off",
    deal: "std",
    dealStyle: "alternate",
    showDetail: "highlight",
    cardAssassin: "no",
    optActionCam: "no",
    jailAnimation: "yes",
    barAnimation: "yes",
    cannonAnimation: "yes",
    jumpAnimation: "yes",
    speedTrapAnimation: "yes",
    stopSignAnimation: "yes",
    stopAnimation: "yes",
    detourAnimation: "yes",
    roundAboutAnimation: "yes",
    scenicRouteAnimation: "yes",
    goal: "high",
    target: 121,
    decks: 1,
    cardBack: "classic-blue",
    boardFinish: "maple",
    seriesMode: "bo3",
    boardViewMode: "room3d-fullscreen",
    selected3DBoardId: "board-14",
    jokers: false,
    optCutBeforeDiscard: false,
    opt31sFor5: false,
    opt19sFor2: false,
    optRoundAroundTheWorld: false,
    optPickYourCrib: false,
    optSpeedoCribbage: false,
    optShotgunCribbage: false,
    optTwistedCribbage: false,
    optChutesAndLadders: false,
    optSpades: false,
    optGuessStarter: false,
    optFivesCribbage: false,
    optSevensAndEightsCribbage: false,
    optDrawCribbage: false,
    opt7CardCribbage: false,
    optProgressiveCut: false,
    optProgressiveSteals: false,
    optPegThroughZones: false,
    optLast5PegOut: false,
    optBunkers: false,
    optNoPassingLanes: false,
    noPassingLaneCount: 2,
    noPassingLaneStarts: [20, 50, 80, 100],
    optJump: false,
    jumpCount: 2,
    jumpStarts: [15, 65, 5, 115, 25, 75, 45, 95],
    jumpDests: [35, 50, 45, 70, 55, 60, 80, 85],
    optJail: false,
    jailCount: 2,
    jailHoles: [25, 75],
    optBar: false,
    barCount: 2,
    barHoles: [40, 85],
    optTimeout: false,
    timeoutCount: 2,
    timeoutHoles: [30, 90],
    optDetour: false,
    detourCount: 2,
    detourHoles: [10, 60],
    optRoundAbout: false,
    roundAboutCount: 2,
    roundAboutHoles: [35, 70],
    optSigns: false,
    signsCount: 2,
    signsBlocks: [{ id: 1, start: 45, size: 2, signs: ["Plus 5", "Roll The Dice"] }, { id: 2, start: 55, size: 4, signs: ["Spin The Wheel", "Plus 10", "Minus 5", "Score Plus x2"] }, { id: 3, start: 95, size: 2, signs: ["Undo", "Score Plus x3"] }, { id: 4, start: 105, size: 4, signs: ["Plus 5", "Minus 10", "Go To Jail", "Roll The Dice"] }],
    optStopSign: false,
    stopSignCount: 2,
    stopSignHoles: [35, 70, 105, 155, 205, 265, 345, 425],
    optSkunkMarkers: false,
    skunkMarkerHole: 360,
    doubleSkunkMarkerHole: 240,
    optYouDrink: false,
    youDrinkCount: 2,
    youDrinkPegs: 1,
    youDrinkHoles: [15, 45, 75, 105],
    optGuysDrink: false,
    guysDrinkCount: 2,
    guysDrinkPegs: 1,
    guysDrinkHoles: [25, 55, 85, 115],
    optGalsDrink: false,
    galsDrinkCount: 2,
    galsDrinkPegs: 1,
    galsDrinkHoles: [35, 65, 95, 110],
    optLeftDrink: false,
    leftDrinkCount: 2,
    leftDrinkPegs: 1,
    leftDrinkHoles: [10, 40, 70, 100],
    optRightDrink: false,
    rightDrinkCount: 2,
    rightDrinkPegs: 1,
    rightDrinkHoles: [20, 50, 80, 120],
    optEveryoneDrink: false,
    everyoneDrinkCount: 2,
    everyoneDrinkPegs: 1,
    everyoneDrinkHoles: [30, 60, 90, 5],
    optEveryoneButYouDrink: false,
    everyoneButYouDrinkCount: 2,
    everyoneButYouDrinkPegs: 1,
    everyoneButYouDrinkHoles: [20, 50, 80, 110],
    optPickWhoDrinks: false,
    pickWhoDrinksCount: 2,
    pickWhoDrinksPegs: 1,
    pickWhoDrinksHoles: [25, 55, 85, 115],
    optLoseClothing: false,
    loseClothingCount: 2,
    loseClothingPegs: 1,
    loseClothingHoles: [10, 70, 10, 70],
    optGainClothing: false,
    gainClothingCount: 2,
    gainClothingPegs: 1,
    gainClothingHoles: [20, 80, 20, 80],
    optPickWhoLosesClothing: false,
    pickWhoLosesClothingCount: 2,
    pickWhoLosesClothingPegs: 1,
    pickWhoLosesClothingHoles: [30, 90, 30, 90],
    optRightLosesClothing: false,
    rightLosesClothingCount: 2,
    rightLosesClothingPegs: 1,
    rightLosesClothingHoles: [40, 100, 40, 100],
    optLeftLosesClothing: false,
    leftLosesClothingCount: 2,
    leftLosesClothingPegs: 1,
    leftLosesClothingHoles: [50, 110, 50, 110],
    optRemoveClothingChoice: false,
    removeClothingChoiceCount: 2,
    removeClothingChoicePegs: 1,
    removeClothingChoiceHoles: [60, 120, 60, 120],
    optTouchBreast: false,
    touchBreastCount: 1,
    touchBreastPegs: 1,
    touchBreastHoles: [5, 45, 75, 105],
    optLickBreast: false,
    lickBreastCount: 1,
    lickBreastPegs: 1,
    lickBreastHoles: [15, 50, 80, 110],
    optSuckBreast: false,
    suckBreastCount: 1,
    suckBreastPegs: 1,
    suckBreastHoles: [25, 55, 85, 115],
    optTouchGenitals: false,
    touchGenitalsCount: 1,
    touchGenitalsPegs: 1,
    touchGenitalsHoles: [35, 40, 70, 100],
    optLickGenitals: false,
    lickGenitalsCount: 1,
    lickGenitalsPegs: 1,
    lickGenitalsHoles: [45, 60, 90, 120],
    optSuckGenitals: false,
    suckGenitalsCount: 1,
    suckGenitalsPegs: 1,
    suckGenitalsHoles: [55, 65, 95, 115],
    optFingerGenitals: false,
    fingerGenitalsCount: 1,
    fingerGenitalsPegs: 1,
    fingerGenitalsHoles: [65, 45, 75, 105],
    optGenitalIntercourse: false,
    genitalIntercourseCount: 1,
    genitalIntercoursePegs: 1,
    genitalIntercourseHoles: [75, 55, 85, 115],
    optTouchAnus: false,
    touchAnusCount: 1,
    touchAnusPegs: 1,
    touchAnusHoles: [85, 50, 80, 110],
    optLickAnus: false,
    lickAnusCount: 1,
    lickAnusPegs: 1,
    lickAnusHoles: [95, 55, 85, 115],
    optFingerAnus: false,
    fingerAnusCount: 1,
    fingerAnusPegs: 1,
    fingerAnusHoles: [105, 60, 90, 120],
    optAnalIntercourse: false,
    analIntercourseCount: 1,
    analIntercoursePegs: 1,
    analIntercourseHoles: [115, 65, 95, 115],
    optStolenCrib: false,
    optFlushInPlay: false,
    optMultipleRunsInPegging: false,
    optAllRed: false,
    optAllBlack: false,
    optAllOdd: false,
    optAllEven: false,
    optAllDifferentSuits: false,
    optKH: false,
    optQS: false,
    optAS: false,
    optStraight: false,
    optFullHouse: false,
    optStraightFlush: false,
    optRoyalFlush: false,
    optRockCrib: false,
    optStinkHole: false,
    optZeroHand: false,
    optZeroCrib: false,
    optCanadianDoubles: false
  });
  SettingsManager.DEFAULT_SETTINGS = DEFAULT_SETTINGS;

  // src/variants/PintsSettings.js
  var PINTS_DRINKING_DEFS = Object.freeze([
    {
      key: "youDrink",
      name: "You Drink",
      chkId: "optYouDrink",
      countId: "optYouDrinkCount",
      pegsId: "optYouDrinkPegs",
      subId: "youDrinkSub",
      configId: "youDrinkConfig",
      rowPrefix: "youDrinkRow",
      badgePrefix: "youDrinkBadge",
      holeIdPrefix: "optYouDrink",
      type: "you-drink",
      desc: "Landing here requires the player to take a drink",
      defaultHoles: [15, 45, 75, 105]
    },
    {
      key: "guysDrink",
      name: "Guys Drink",
      chkId: "optGuysDrink",
      countId: "optGuysDrinkCount",
      pegsId: "optGuysDrinkPegs",
      subId: "guysDrinkSub",
      configId: "guysDrinkConfig",
      rowPrefix: "guysDrinkRow",
      badgePrefix: "guysDrinkBadge",
      holeIdPrefix: "optGuysDrink",
      type: "guys-drink",
      desc: "Landing here requires all male players to take a drink",
      defaultHoles: [25, 55, 85, 115]
    },
    {
      key: "galsDrink",
      name: "Gals Drink",
      chkId: "optGalsDrink",
      countId: "optGalsDrinkCount",
      pegsId: "optGalsDrinkPegs",
      subId: "galsDrinkSub",
      configId: "galsDrinkConfig",
      rowPrefix: "galsDrinkRow",
      badgePrefix: "galsDrinkBadge",
      holeIdPrefix: "optGalsDrink",
      type: "gals-drink",
      desc: "Landing here requires all female players to take a drink",
      defaultHoles: [35, 65, 95, 105]
    },
    {
      key: "leftDrink",
      name: "Left Drinks",
      chkId: "optLeftDrink",
      countId: "optLeftDrinkCount",
      pegsId: "optLeftDrinkPegs",
      subId: "leftDrinkSub",
      configId: "leftDrinkConfig",
      rowPrefix: "leftDrinkRow",
      badgePrefix: "leftDrinkBadge",
      holeIdPrefix: "optLeftDrink",
      type: "left-drink",
      desc: "Landing here requires the player to your left to take a drink",
      defaultHoles: [20, 50, 80, 110]
    },
    {
      key: "rightDrink",
      name: "Right Drinks",
      chkId: "optRightDrink",
      countId: "optRightDrinkCount",
      pegsId: "optRightDrinkPegs",
      subId: "rightDrinkSub",
      configId: "rightDrinkConfig",
      rowPrefix: "rightDrinkRow",
      badgePrefix: "rightDrinkBadge",
      holeIdPrefix: "optRightDrink",
      type: "right-drink",
      desc: "Landing here requires the player to your right to take a drink",
      defaultHoles: [40, 70, 100, 120]
    },
    {
      key: "everyoneDrink",
      name: "Everyone Drinks",
      chkId: "optEveryoneDrink",
      countId: "optEveryoneDrinkCount",
      pegsId: "optEveryoneDrinkPegs",
      subId: "everyoneDrinkSub",
      configId: "everyoneDrinkConfig",
      rowPrefix: "everyoneDrinkRow",
      badgePrefix: "everyoneDrinkBadge",
      holeIdPrefix: "optEveryoneDrink",
      type: "everyone-drink",
      desc: "Landing here requires all players to take a drink",
      defaultHoles: [30, 60, 90, 120]
    },
    {
      key: "everyoneButYouDrink",
      name: "Everyone But You",
      chkId: "optEveryoneButYouDrink",
      countId: "optEveryoneButYouDrinkCount",
      pegsId: "optEveryoneButYouDrinkPegs",
      subId: "everyoneButYouDrinkSub",
      configId: "everyoneButYouDrinkConfig",
      rowPrefix: "everyoneButYouDrinkRow",
      badgePrefix: "everyoneButYouDrinkBadge",
      holeIdPrefix: "optEveryoneButYouDrink",
      type: "everyone-but-you-drink",
      desc: "Landing here requires all players except you to take a drink",
      defaultHoles: [10, 50, 90, 110]
    },
    {
      key: "pickWhoDrinks",
      name: "Pick Who Drinks",
      chkId: "optPickWhoDrinks",
      countId: "optPickWhoDrinksCount",
      pegsId: "optPickWhoDrinksPegs",
      subId: "pickWhoDrinksSub",
      configId: "pickWhoDrinksConfig",
      rowPrefix: "pickWhoDrinksRow",
      badgePrefix: "pickWhoDrinksBadge",
      holeIdPrefix: "optPickWhoDrinks",
      type: "pick-who-drinks",
      desc: "Landing here allows you to choose who takes a drink",
      defaultHoles: [25, 55, 85, 115]
    }
  ]);
  var PintsSettings = class _PintsSettings {
    static getDrinkingDefs() {
      return PINTS_DRINKING_DEFS;
    }
    static getDrinkingDef(key) {
      return PINTS_DRINKING_DEFS.find((d) => d.key === key) || null;
    }
    static toggleDrinkingConfig(key, checked, options = {}) {
      const def = _PintsSettings.getDrinkingDef(key);
      if (!def) return;
      if (typeof document !== "undefined") {
        const panel = document.getElementById(def.configId);
        if (panel) panel.style.display = checked ? "flex" : "none";
      }
      _PintsSettings.updateDrinkingRows(key, options);
      for (let i = 1; i <= 4; i++) {
        _PintsSettings.onDrinkingFieldChange(key, i, true, options);
      }
      if (checked) {
        if (typeof options.enforceClashNoOverlap === "function") options.enforceClashNoOverlap();
      } else {
        if (typeof options.updateAllClashDropdowns === "function") options.updateAllClashDropdowns();
      }
      if (typeof options.saveSettings === "function") {
        options.saveSettings();
      }
    }
    static updateDrinkingRows(key, options = {}) {
      const def = _PintsSettings.getDrinkingDef(key);
      if (!def) return;
      if (typeof document !== "undefined") {
        const countEl = document.getElementById(def.countId);
        const count = countEl ? parseInt(countEl.value, 10) : 2;
        for (let i = 1; i <= 4; i++) {
          const row = document.getElementById(def.rowPrefix + i);
          if (row) row.style.display = i <= count ? "flex" : "none";
        }
      }
      if (typeof options.enforceClashNoOverlap === "function") {
        options.enforceClashNoOverlap();
      }
      if (typeof options.saveSettings === "function") {
        options.saveSettings();
      }
    }
    static onDrinkingPegsChange(key, options = {}) {
      const def = _PintsSettings.getDrinkingDef(key);
      if (!def) return;
      let pegs = 1;
      if (typeof document !== "undefined") {
        const pegsEl = document.getElementById(def.pegsId);
        pegs = pegsEl ? parseInt(pegsEl.value, 10) : 1;
        const sub = document.getElementById(def.subId);
        if (sub) {
          sub.textContent = `${pegs === 1 ? "1 peg" : pegs + " pegs"} \xB7 ${def.desc}`;
        }
      }
      if (options.settings) {
        options.settings[def.key + "Pegs"] = pegs;
      }
      for (let i = 1; i <= 4; i++) {
        _PintsSettings.onDrinkingFieldChange(key, i, true, options);
      }
      if (typeof options.enforceClashNoOverlap === "function") {
        options.enforceClashNoOverlap();
      }
      if (typeof options.syncAllClashPlacementButtons === "function") {
        options.syncAllClashPlacementButtons();
      }
      if (typeof options.saveSettings === "function") {
        options.saveSettings();
      }
    }
    static onDrinkingFieldChange(key, idx, skipSave = false, options = {}) {
      const def = _PintsSettings.getDrinkingDef(key);
      if (!def) return;
      const fieldId = `${def.holeIdPrefix}${idx}Hole`;
      if (typeof options.enforceClashNoOverlap === "function") {
        options.enforceClashNoOverlap(fieldId);
      }
      if (typeof document !== "undefined") {
        const hEl = document.getElementById(fieldId);
        const bEl = document.getElementById(`${def.badgePrefix}${idx}`);
        const pegsEl = document.getElementById(def.pegsId);
        const pegs = parseInt(pegsEl?.value || options.settings && options.settings[def.key + "Pegs"] || 1, 10);
        if (hEl && bEl) {
          const h = parseInt(hEl.value, 10) || def.defaultHoles[idx - 1] || 15;
          const streetName3 = typeof options.getStreetOrTurnName === "function" ? options.getStreetOrTurnName(h) : "";
          if (pegs > 1) {
            const endH = Math.min(121, h + pegs - 1);
            bEl.textContent = `${streetName3 ? streetName3 + " \xB7 " : ""}Holes ${h}\u2013${endH} (${pegs} Pegs)`;
          } else {
            bEl.textContent = `${streetName3 ? streetName3 + " \xB7 " : ""}Hole ${h}`;
          }
        }
      }
      if (!skipSave && typeof options.saveSettings === "function") {
        options.saveSettings();
      }
    }
    static getDrinkingConfigs(key, settings3 = {}) {
      const def = _PintsSettings.getDrinkingDef(key);
      if (!def || !settings3[def.chkId]) return [];
      const count = Math.min(4, Math.max(1, settings3[def.key + "Count"] || 2));
      const pegs = Math.min(5, Math.max(1, parseInt(settings3[def.key + "Pegs"], 10) || 1));
      const holes = settings3[def.key + "Holes"] || def.defaultHoles;
      const list = [];
      for (let i = 0; i < count; i++) {
        const h = holes[i] != null ? holes[i] : def.defaultHoles[i] || 15 + i * 30;
        list.push({
          id: i + 1,
          hole: h,
          start: h,
          end: h + pegs - 1,
          pegs,
          type: def.type,
          label: `${def.name} ${i + 1}`
        });
      }
      return list;
    }
  };

  // src/variants/ClashPresets.js
  var CLASH_CUSTOM_LAYOUTS_KEY = "cc_clash_custom_layouts";
  var CLASH_PRESET_KEYS = Object.freeze({
    STANDARD: "standard",
    GAUNTLET: "gauntlet",
    SPEEDWAY: "speedway",
    BOTTLENECK: "bottleneck"
  });
  var CLASH_PRESETS_481 = Object.freeze({
    standard: {
      key: "standard",
      name: "Classic Clash",
      badge: "\u{1F3DB}\uFE0F Balanced",
      icon: "\u{1F3DB}\uFE0F",
      description: "The standard tournament layout. A balanced mix of forward jumps, tactical lanes, and classic hazard zones.",
      tags: ["Balanced", "Tournament", "Standard"],
      hazardCount: 30,
      config: {
        optNoPassingLanes: true,
        optNoPassingLaneCount: 4,
        optNoPassingLane1Start: 40,
        optNoPassingLane2Start: 175,
        optNoPassingLane3Start: 275,
        optNoPassingLane4Start: 415,
        optJump: true,
        optJumpCount: 8,
        optJump1Start: 25,
        optJump1Dest: 60,
        optJump2Start: 195,
        optJump2Dest: 160,
        optJump3Start: 295,
        optJump3Dest: 335,
        optJump4Start: 435,
        optJump4Dest: 395,
        optJump5Start: 75,
        optJump5Dest: 110,
        optJump6Start: 145,
        optJump6Dest: 125,
        optJump7Start: 245,
        optJump7Dest: 280,
        optJump8Start: 365,
        optJump8Dest: 400,
        optJail: true,
        optJailCount: 2,
        optJail1Hole: 110,
        optJail2Hole: 315,
        optBar: true,
        optBarCount: 2,
        optBar1Hole: 125,
        optBar2Hole: 375,
        optTimeout: true,
        optTimeoutCount: 2,
        optTimeout1Hole: 75,
        optTimeout2Hole: 255,
        optDetour: true,
        optDetourCount: 2,
        optDetour1Hole: 15,
        optDetour2Hole: 235,
        optRoundAbout: true,
        optRoundAboutCount: 2,
        optRoundAbout1Hole: 145,
        optRoundAbout2Hole: 355,
        optSigns: true,
        optSignsCount: 4,
        optSigns1Hole: 90,
        optSigns2Hole: 215,
        optSigns3Hole: 450,
        optSigns4Hole: 465,
        optStopSign: true,
        optStopSignCount: 8,
        optStopSign1Hole: 35,
        optStopSign2Hole: 70,
        optStopSign3Hole: 105,
        optStopSign4Hole: 155,
        optStopSign5Hole: 205,
        optStopSign6Hole: 265,
        optStopSign7Hole: 345,
        optStopSign8Hole: 425,
        optDice: true,
        optDiceCount: 4,
        optDice1Hole: 50,
        optDice2Hole: 185,
        optDice3Hole: 285,
        optDice4Hole: 410,
        optWheel: true,
        optWheelCount: 4,
        optWheel1Hole: 65,
        optWheel2Hole: 160,
        optWheel3Hole: 260,
        optWheel4Hole: 385,
        optSkunkMarkers: true,
        optSkunkMarkerHole: 360,
        optDoubleSkunkMarkerHole: 240
      }
    },
    gauntlet: {
      key: "gauntlet",
      name: "The Gauntlet",
      badge: "\u2694\uFE0F High Hazard",
      icon: "\u2694\uFE0F",
      description: "Punishing trap run. Maximum Jail, Bar, and Timeout penalty zones with Stop Signs positioned right before hazards to trap players.",
      tags: ["High Penalty", "Challenging", "Survival"],
      hazardCount: 32,
      config: {
        optNoPassingLanes: true,
        optNoPassingLaneCount: 3,
        optNoPassingLane1Start: 70,
        optNoPassingLane2Start: 210,
        optNoPassingLane3Start: 380,
        optNoPassingLane4Start: 440,
        optJump: true,
        optJumpCount: 4,
        optJump1Start: 45,
        optJump1Dest: 30,
        // backward penalty
        optJump2Start: 185,
        optJump2Dest: 165,
        // backward penalty
        optJump3Start: 330,
        optJump3Dest: 305,
        // backward penalty
        optJump4Start: 440,
        optJump4Dest: 405,
        // backward penalty
        optJump5Start: 85,
        optJump5Dest: 120,
        optJump6Start: 150,
        optJump6Dest: 130,
        optJump7Start: 250,
        optJump7Dest: 285,
        optJump8Start: 370,
        optJump8Dest: 405,
        optJail: true,
        optJailCount: 2,
        optJail1Hole: 100,
        optJail2Hole: 310,
        optBar: true,
        optBarCount: 2,
        optBar1Hole: 140,
        optBar2Hole: 360,
        optTimeout: true,
        optTimeoutCount: 2,
        optTimeout1Hole: 60,
        optTimeout2Hole: 230,
        optDetour: true,
        optDetourCount: 2,
        optDetour1Hole: 20,
        optDetour2Hole: 270,
        optRoundAbout: true,
        optRoundAboutCount: 2,
        optRoundAbout1Hole: 170,
        optRoundAbout2Hole: 390,
        optSigns: true,
        optSignsCount: 4,
        optSigns1Hole: 80,
        optSigns2Hole: 200,
        optSigns3Hole: 340,
        optSigns4Hole: 450,
        optStopSign: true,
        optStopSignCount: 8,
        optStopSign1Hole: 15,
        optStopSign2Hole: 55,
        optStopSign3Hole: 95,
        optStopSign4Hole: 135,
        optStopSign5Hole: 225,
        optStopSign6Hole: 265,
        optStopSign7Hole: 305,
        optStopSign8Hole: 355,
        optDice: true,
        optDiceCount: 4,
        optDice1Hole: 65,
        optDice2Hole: 175,
        optDice3Hole: 285,
        optDice4Hole: 400,
        optWheel: true,
        optWheelCount: 4,
        optWheel1Hole: 50,
        optWheel2Hole: 150,
        optWheel3Hole: 275,
        optWheel4Hole: 390,
        optSkunkMarkers: true,
        optSkunkMarkerHole: 360,
        optDoubleSkunkMarkerHole: 240
      }
    },
    speedway: {
      key: "speedway",
      name: "Speedway",
      badge: "\u{1F680} Turbo Boost",
      icon: "\u{1F680}",
      description: "Blistering acceleration. All 8 Jump Zones configured as massive forward boosts (+40 to +55 holes) and wide open lanes for lightning-fast matches.",
      tags: ["Ultra Fast", "High Velocity", "Forward Boosts"],
      hazardCount: 16,
      config: {
        optNoPassingLanes: false,
        // Open highway: no passing restrictions
        optNoPassingLaneCount: 0,
        optNoPassingLane1Start: 40,
        optNoPassingLane2Start: 175,
        optNoPassingLane3Start: 275,
        optNoPassingLane4Start: 415,
        optJump: true,
        optJumpCount: 8,
        optJump1Start: 25,
        optJump1Dest: 75,
        // +50
        optJump2Start: 90,
        optJump2Dest: 145,
        // +55
        optJump3Start: 160,
        optJump3Dest: 215,
        // +55
        optJump4Start: 235,
        optJump4Dest: 290,
        // +55
        optJump5Start: 310,
        optJump5Dest: 365,
        // +55
        optJump6Start: 380,
        optJump6Dest: 430,
        // +50
        optJump7Start: 440,
        optJump7Dest: 475,
        // +35
        optJump8Start: 50,
        optJump8Dest: 90,
        // +40
        optJail: false,
        optJailCount: 0,
        optJail1Hole: 110,
        optJail2Hole: 315,
        optBar: true,
        optBarCount: 1,
        optBar1Hole: 190,
        optBar2Hole: 375,
        optTimeout: false,
        optTimeoutCount: 0,
        optTimeout1Hole: 75,
        optTimeout2Hole: 255,
        optDetour: false,
        optDetourCount: 0,
        optDetour1Hole: 15,
        optDetour2Hole: 235,
        optRoundAbout: false,
        optRoundAboutCount: 0,
        optRoundAbout1Hole: 145,
        optRoundAbout2Hole: 355,
        optSigns: true,
        optSignsCount: 2,
        optSigns1Hole: 120,
        optSigns2Hole: 300,
        optSigns3Hole: 450,
        optSigns4Hole: 465,
        optStopSign: true,
        optStopSignCount: 2,
        optStopSign1Hole: 210,
        optStopSign2Hole: 420,
        optStopSign3Hole: 105,
        optStopSign4Hole: 155,
        optStopSign5Hole: 205,
        optStopSign6Hole: 265,
        optStopSign7Hole: 345,
        optStopSign8Hole: 425,
        optDice: true,
        optDiceCount: 2,
        optDice1Hole: 60,
        optDice2Hole: 270,
        optDice3Hole: 380,
        optDice4Hole: 440,
        optWheel: true,
        optWheelCount: 2,
        optWheel1Hole: 120,
        optWheel2Hole: 340,
        optWheel3Hole: 220,
        optWheel4Hole: 410,
        optSkunkMarkers: true,
        optSkunkMarkerHole: 360,
        optDoubleSkunkMarkerHole: 240
      }
    },
    bottleneck: {
      key: "bottleneck",
      name: "Cutthroat Bottleneck",
      badge: "\u{1F6D1} Choke Points",
      icon: "\u{1F6D1}",
      description: "Choke-point heavy tactical battle. All 4 No Passing Lanes and 8 Stop Signs positioned at high-traffic zones to trap leaders behind opponents.",
      tags: ["Choke Points", "High Tactical", "Blocking"],
      hazardCount: 28,
      config: {
        optNoPassingLanes: true,
        optNoPassingLaneCount: 4,
        optNoPassingLane1Start: 45,
        optNoPassingLane2Start: 160,
        optNoPassingLane3Start: 270,
        optNoPassingLane4Start: 390,
        optJump: true,
        optJumpCount: 4,
        optJump1Start: 20,
        optJump1Dest: 40,
        optJump2Start: 120,
        optJump2Dest: 150,
        optJump3Start: 230,
        optJump3Dest: 260,
        optJump4Start: 350,
        optJump4Dest: 380,
        optJump5Start: 75,
        optJump5Dest: 110,
        optJump6Start: 145,
        optJump6Dest: 125,
        optJump7Start: 245,
        optJump7Dest: 280,
        optJump8Start: 365,
        optJump8Dest: 400,
        optJail: true,
        optJailCount: 2,
        optJail1Hole: 110,
        optJail2Hole: 330,
        optBar: true,
        optBarCount: 2,
        optBar1Hole: 190,
        optBar2Hole: 420,
        optTimeout: true,
        optTimeoutCount: 2,
        optTimeout1Hole: 80,
        optTimeout2Hole: 300,
        optDetour: true,
        optDetourCount: 1,
        optDetour1Hole: 15,
        optDetour2Hole: 235,
        optRoundAbout: true,
        optRoundAboutCount: 1,
        optRoundAbout1Hole: 215,
        optRoundAbout2Hole: 355,
        optSigns: true,
        optSignsCount: 4,
        optSigns1Hole: 100,
        optSigns2Hole: 215,
        optSigns3Hole: 350,
        optSigns4Hole: 455,
        optStopSign: true,
        optStopSignCount: 8,
        optStopSign1Hole: 40,
        optStopSign2Hole: 50,
        optStopSign3Hole: 155,
        optStopSign4Hole: 165,
        optStopSign5Hole: 265,
        optStopSign6Hole: 275,
        optStopSign7Hole: 385,
        optStopSign8Hole: 470,
        optDice: true,
        optDiceCount: 4,
        optDice1Hole: 50,
        optDice2Hole: 180,
        optDice3Hole: 290,
        optDice4Hole: 410,
        optWheel: true,
        optWheelCount: 4,
        optWheel1Hole: 65,
        optWheel2Hole: 190,
        optWheel3Hole: 300,
        optWheel4Hole: 420,
        optSkunkMarkers: true,
        optSkunkMarkerHole: 360,
        optDoubleSkunkMarkerHole: 240
      }
    }
  });
  var ClashPresets = class _ClashPresets {
    /**
     * Retrieves all available presets for a given track target (241, 361, or 481).
     * @param {number} [target=481]
     * @returns {Object}
     */
    static getPresets(target = 481) {
      const t = Number(target) || 481;
      if (t === 481) return CLASH_PRESETS_481;
      return _ClashPresets.scalePresetsForTarget(CLASH_PRESETS_481, t);
    }
    /**
     * Scales a preset layout configuration proportionately for 241 or 361 targets.
     * @param {Object} presets
     * @param {number} target
     * @returns {Object}
     */
    static scalePresetsForTarget(presets, target) {
      const scale = target / 481;
      const scaled = {};
      for (const [key, preset] of Object.entries(presets)) {
        const cfg = { ...preset.config };
        for (const [prop, val] of Object.entries(cfg)) {
          if (typeof val === "number" && (prop.endsWith("Hole") || prop.endsWith("Start") || prop.endsWith("Dest"))) {
            cfg[prop] = Math.max(5, Math.min(target - 5, Math.round(val * scale / 5) * 5));
          }
        }
        scaled[key] = {
          ...preset,
          config: cfg
        };
      }
      return scaled;
    }
    /**
     * Applies a preset directly into DOM fields and/or active settings object.
     * @param {string} presetKey
     * @param {Object} [context={}]
     * @returns {boolean}
     */
    static applyPreset(presetKey, context = {}) {
      const target = context.settings && context.settings.target || 481;
      const presets = _ClashPresets.getPresets(target);
      const preset = presets[presetKey] || presets.standard;
      if (!preset) return false;
      const cfg = preset.config;
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (doc) {
        for (const [prop, val] of Object.entries(cfg)) {
          const el = doc.getElementById(prop);
          if (!el) continue;
          if (el.type === "checkbox") {
            el.checked = Boolean(val);
            const toggleFn = typeof window !== "undefined" ? window[`toggle${prop.replace("opt", "")}Config`] : null;
            if (typeof toggleFn === "function") {
              toggleFn(el.checked);
            }
          } else {
            el.value = String(val);
            el.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
        if (typeof window !== "undefined") {
          if (typeof window.enforceClashNoOverlap === "function") {
            window.enforceClashNoOverlap();
          }
          if (typeof window.syncAllPlacementButtons === "function") {
            window.syncAllPlacementButtons();
          }
          if (typeof window.readFormSettings === "function" && typeof window.saveSettingsStore === "function") {
            const updated = window.readFormSettings();
            updated.clashPreset = presetKey;
            window.saveSettingsStore(updated);
          }
        }
      }
      if (context.settings) {
        Object.assign(context.settings, cfg);
        context.settings.clashPreset = presetKey;
      }
      if (typeof window !== "undefined" && typeof window.buildBoard === "function") {
        window.buildBoard();
      }
      return true;
    }
    /**
     * Computes live track metrics from a set of placed obstacle items.
     * @param {Array<Object>} items
     * @param {number} [target=481]
     * @returns {Object}
     */
    static computeTrackMetrics(items = [], target = 481) {
      let penaltyTraps = 0;
      let forwardBoosts = 0;
      let backwardJumps = 0;
      let chokePoints = 0;
      let mysterySigns = 0;
      let stopSigns = 0;
      for (const item of items) {
        const type = item.type;
        if (["jail", "bar", "timeout"].includes(type)) penaltyTraps++;
        else if (type === "noPassingLanes") chokePoints++;
        else if (type === "stopSign") stopSigns++;
        else if (type === "signs") mysterySigns++;
        else if (type === "jump") {
          if (item.dest && item.hole) {
            if (item.dest > item.hole) forwardBoosts++;
            else backwardJumps++;
          } else {
            forwardBoosts++;
          }
        }
      }
      const totalHazards = items.length;
      const avgSpacing = totalHazards > 0 ? Math.round(target / totalHazards) : target;
      return {
        totalHazards,
        penaltyTraps,
        forwardBoosts,
        backwardJumps,
        chokePoints,
        stopSigns,
        mysterySigns,
        avgSpacing
      };
    }
    static getStorage(storage = null) {
      return storage || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
    }
    /**
     * Retrieves all saved custom layouts from persistent storage.
     * @param {Object} [storage=null]
     * @returns {Array<Object>}
     */
    static getCustomLayouts(storage = null) {
      const s = _ClashPresets.getStorage(storage);
      if (!s) return [];
      try {
        const raw = s.getItem(CLASH_CUSTOM_LAYOUTS_KEY);
        if (!raw) return [];
        const data = JSON.parse(raw);
        return Array.isArray(data) ? data : [];
      } catch (e) {
        console.warn("[ClashPresets] Failed to parse custom layouts:", e);
        return [];
      }
    }
    /**
     * Saves a custom layout (either creates new or updates existing).
     * @param {Object} layout
     * @param {Object} [storage=null]
     * @returns {Object} The saved layout object
     */
    static saveCustomLayout(layout, storage = null, isImport = false) {
      if (!layout || typeof layout !== "object") throw new Error("Invalid layout object");
      const s = _ClashPresets.getStorage(storage);
      const layouts = _ClashPresets.getCustomLayouts(s);
      const now = Date.now();
      const sanitized = LayoutSanitizer.sanitizeLayout(layout, "clash", {
        regenerateId: isImport || !layout.id
      });
      sanitized.metrics = _ClashPresets.computeTrackMetrics(sanitized.items, sanitized.target);
      let targetLayout = null;
      if (!isImport && layout.id) {
        const existingIdx = layouts.findIndex((l) => l.id === sanitized.id);
        if (existingIdx !== -1) {
          targetLayout = {
            ...layouts[existingIdx],
            ...sanitized,
            updatedAt: now
          };
          layouts[existingIdx] = targetLayout;
        }
      }
      if (!targetLayout) {
        targetLayout = sanitized;
        layouts.unshift(targetLayout);
      }
      const capped = LayoutSanitizer.enforceStorageQuota(layouts, MAX_CUSTOM_LAYOUTS);
      if (s) {
        try {
          s.setItem(CLASH_CUSTOM_LAYOUTS_KEY, JSON.stringify(capped));
        } catch (e) {
          console.error("[ClashPresets] Failed to save custom layouts:", e);
          throw new Error("Failed to save layout to storage: Quota exceeded or storage unavailable.");
        }
      }
      return targetLayout;
    }
    /**
     * Renames a custom layout by ID.
     * @param {string} layoutId
     * @param {string} newName
     * @param {Object} [storage=null]
     * @returns {boolean}
     */
    static renameCustomLayout(layoutId, newName, storage = null) {
      if (!layoutId || !newName || !newName.trim()) return false;
      const s = _ClashPresets.getStorage(storage);
      const layouts = _ClashPresets.getCustomLayouts(s);
      const idx = layouts.findIndex((l) => l.id === layoutId);
      if (idx === -1) return false;
      layouts[idx].name = newName.trim();
      layouts[idx].updatedAt = Date.now();
      if (s) {
        try {
          s.setItem(CLASH_CUSTOM_LAYOUTS_KEY, JSON.stringify(layouts));
          return true;
        } catch (e) {
          return false;
        }
      }
      return false;
    }
    /**
     * Deletes a custom layout by ID.
     * @param {string} layoutId
     * @param {Object} [storage=null]
     * @returns {boolean}
     */
    static deleteCustomLayout(layoutId, storage = null) {
      if (!layoutId) return false;
      const s = _ClashPresets.getStorage(storage);
      const layouts = _ClashPresets.getCustomLayouts(s);
      const filtered = layouts.filter((l) => l.id !== layoutId);
      if (filtered.length === layouts.length) return false;
      if (s) {
        try {
          s.setItem(CLASH_CUSTOM_LAYOUTS_KEY, JSON.stringify(filtered));
          return true;
        } catch (e) {
          return false;
        }
      }
      return false;
    }
    /**
     * Clones / duplicates an existing custom layout.
     * @param {string} layoutId
     * @param {Object} [storage=null]
     * @returns {Object|null}
     */
    static duplicateCustomLayout(layoutId, storage = null) {
      const s = _ClashPresets.getStorage(storage);
      const layouts = _ClashPresets.getCustomLayouts(s);
      const source = layouts.find((l) => l.id === layoutId);
      if (!source) return null;
      const clone2 = {
        ...source,
        id: null,
        name: `${source.name} (Copy)`
      };
      return _ClashPresets.saveCustomLayout(clone2, s);
    }
    /**
     * Serializes a layout or all layouts into a shareable JSON string.
     * @param {string} [layoutId=null] If null, exports all custom layouts
     * @param {Object} [storage=null]
     * @returns {string}
     */
    static exportLayout(layoutId = null, storage = null) {
      const s = _ClashPresets.getStorage(storage);
      const layouts = _ClashPresets.getCustomLayouts(s);
      if (layoutId) {
        const single = layouts.find((l) => l.id === layoutId);
        const prepared2 = LayoutSanitizer.prepareForExport(single || null);
        return JSON.stringify(prepared2, null, 2);
      }
      const prepared = LayoutSanitizer.prepareForExport(layouts);
      return JSON.stringify(prepared, null, 2);
    }
    /**
     * Imports a layout from a JSON string.
     * @param {string} jsonStr
     * @param {Object} [storage=null]
     * @returns {Object}
     */
    static importLayout(jsonStr, storage = null) {
      const parsed = LayoutSanitizer.parseJsonSafely(jsonStr);
      const s = _ClashPresets.getStorage(storage);
      if (Array.isArray(parsed)) {
        if (parsed.length > 20) {
          throw new Error("Cannot import more than 20 layouts at once.");
        }
        let lastSaved = null;
        for (const item of parsed) {
          lastSaved = _ClashPresets.saveCustomLayout(item, s, true);
        }
        return lastSaved;
      }
      return _ClashPresets.saveCustomLayout(parsed, s, true);
    }
  };
  if (typeof window !== "undefined") {
    window.ClashPresets = ClashPresets;
    window.CLASH_PRESETS_481 = CLASH_PRESETS_481;
    window.CLASH_CUSTOM_LAYOUTS_KEY = CLASH_CUSTOM_LAYOUTS_KEY;
    window.applyClashPreset = (key, ctx) => ClashPresets.applyPreset(key, ctx);
  }

  // src/variants/ClashSettings.js
  var ClashSettings = class _ClashSettings {
    static applyPreset(presetKey, context = {}) {
      return ClashPresets.applyPreset(presetKey, context);
    }
    static openSandbox(context = {}) {
      return ClashSandboxModal.open(context);
    }
    static getBlockDefs() {
      const baseDefs = [
        {
          type: "noPassingLanes",
          chkId: "optNoPassingLanes",
          countId: "optNoPassingLaneCount",
          maxCount: 4,
          baseName: "No Passing Lane",
          selectIdPrefix: "optNoPassingLane",
          selectIdSuffix: "Start",
          getLength: () => 5,
          minHole: 10,
          maxHole: 100,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onNoPassingLaneFieldChange === "function") {
              window.onNoPassingLaneFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "jump",
          chkId: "optJump",
          countId: "optJumpCount",
          maxCount: 8,
          baseName: "Jump Zone",
          selectIdPrefix: "optJump",
          selectIdSuffix: "Start",
          getLength: (idx) => {
            if (typeof document === "undefined") return 1;
            const sEl = document.getElementById(`optJump${idx}Start`);
            const dEl = document.getElementById(`optJump${idx}Dest`);
            const sVal = sEl ? parseInt(sEl.value, 10) : 0;
            const dVal = dEl ? parseInt(dEl.value, 10) : 0;
            return !isNaN(sVal) && !isNaN(dVal) && sVal > 0 && dVal > 0 && dVal <= sVal ? 3 : 1;
          },
          minHole: 5,
          maxHole: 115,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onJumpFieldChange === "function") {
              window.onJumpFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "jail",
          chkId: "optJail",
          countId: "optJailCount",
          maxCount: 4,
          baseName: "Jail",
          selectIdPrefix: "optJail",
          selectIdSuffix: "Hole",
          getLength: () => 1,
          minHole: 10,
          maxHole: 110,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onJailFieldChange === "function") {
              window.onJailFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "bar",
          chkId: "optBar",
          countId: "optBarCount",
          maxCount: 4,
          baseName: "The Bar",
          selectIdPrefix: "optBar",
          selectIdSuffix: "Hole",
          getLength: () => 1,
          minHole: 10,
          maxHole: 110,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onBarFieldChange === "function") {
              window.onBarFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "timeout",
          chkId: "optTimeout",
          countId: "optTimeoutCount",
          maxCount: 4,
          baseName: "Timeout",
          selectIdPrefix: "optTimeout",
          selectIdSuffix: "Hole",
          getLength: () => 1,
          minHole: 10,
          maxHole: 110,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onTimeoutFieldChange === "function") {
              window.onTimeoutFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "detour",
          chkId: "optDetour",
          countId: "optDetourCount",
          maxCount: 4,
          baseName: "Detour",
          selectIdPrefix: "optDetour",
          selectIdSuffix: "Hole",
          getLength: () => 1,
          minHole: 10,
          maxHole: 110,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onDetourFieldChange === "function") {
              window.onDetourFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "roundAbout",
          chkId: "optRoundAbout",
          countId: "optRoundAboutCount",
          maxCount: 4,
          baseName: "Round About",
          selectIdPrefix: "optRoundAbout",
          selectIdSuffix: "Hole",
          getLength: () => 1,
          minHole: 10,
          maxHole: 110,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onRoundAboutFieldChange === "function") {
              window.onRoundAboutFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "signs",
          chkId: "optSigns",
          countId: "optSignsCount",
          maxCount: 8,
          baseName: "Sign Block",
          selectIdPrefix: "optSigns",
          selectIdSuffix: "Hole",
          getLength: (idx) => {
            if (typeof document === "undefined") return 3;
            const sizeEl = document.getElementById(`optSigns${idx}Size`);
            const sz = sizeEl ? parseInt(sizeEl.value, 10) : 2;
            return sz === 4 ? 5 : 3;
          },
          minHole: 10,
          maxHole: 110,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onSignsFieldChange === "function") {
              window.onSignsFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "stopSign",
          chkId: "optStopSign",
          countId: "optStopSignCount",
          maxCount: 8,
          baseName: "Stop Sign",
          selectIdPrefix: "optStopSign",
          selectIdSuffix: "Hole",
          getLength: () => 1,
          minHole: 5,
          maxHole: 475,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onStopSignFieldChange === "function") {
              window.onStopSignFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "dice",
          chkId: "optDice",
          countId: "optDiceCount",
          maxCount: 4,
          baseName: "Dice",
          selectIdPrefix: "optDice",
          selectIdSuffix: "Hole",
          getLength: () => 1,
          minHole: 5,
          maxHole: 475,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onDiceFieldChange === "function") {
              window.onDiceFieldChange(idx, skipSave);
            }
          }
        },
        {
          type: "wheel",
          chkId: "optWheel",
          countId: "optWheelCount",
          maxCount: 4,
          baseName: "Spinning Wheel",
          selectIdPrefix: "optWheel",
          selectIdSuffix: "Hole",
          getLength: () => 1,
          minHole: 5,
          maxHole: 475,
          onFieldChange: (idx, skipSave) => {
            if (typeof window !== "undefined" && typeof window.onWheelFieldChange === "function") {
              window.onWheelFieldChange(idx, skipSave);
            }
          }
        }
      ];
      const drinkingDefs = (PINTS_DRINKING_DEFS || []).map((dt) => ({
        type: dt.key,
        chkId: dt.chkId,
        countId: dt.countId,
        pegsId: dt.pegsId,
        maxCount: 4,
        baseName: dt.name,
        selectIdPrefix: dt.holeIdPrefix,
        selectIdSuffix: "Hole",
        getLength: () => {
          if (typeof document === "undefined") return 1;
          return parseInt(document.getElementById(dt.pegsId)?.value || typeof window !== "undefined" && window.settings && window.settings[dt.key + "Pegs"] || 1, 10);
        },
        minHole: 5,
        maxHole: 120,
        onFieldChange: (idx, skipSave) => {
          const fnName = "on" + dt.key.charAt(0).toUpperCase() + dt.key.slice(1) + "FieldChange";
          if (typeof window !== "undefined" && typeof window[fnName] === "function") {
            window[fnName](idx, skipSave);
          }
        }
      }));
      return [...baseDefs, ...drinkingDefs];
    }
    static getActiveBlocks(blockDefs = null) {
      if (typeof document === "undefined") return [];
      const defs = blockDefs || _ClashSettings.getBlockDefs();
      const active2 = [];
      for (const def of defs) {
        const chk = document.getElementById(def.chkId);
        if (!chk || !chk.checked) continue;
        const countEl = document.getElementById(def.countId);
        const count = countEl ? Math.min(def.maxCount, Math.max(1, parseInt(countEl.value, 10) || 1)) : 1;
        for (let i = 1; i <= count; i++) {
          const selId = `${def.selectIdPrefix}${i}${def.selectIdSuffix}`;
          const sel = document.getElementById(selId);
          if (!sel) continue;
          const start = parseInt(sel.value, 10);
          if (isNaN(start)) continue;
          const length = typeof def.getLength === "function" ? def.getLength(i) : 1;
          const end = start + length - 1;
          active2.push({
            type: def.type,
            index: i,
            name: `${def.baseName} ${i}`,
            selectId: selId,
            start,
            length,
            end,
            def
          });
        }
      }
      return active2;
    }
    static updateAllDropdowns(blockDefs = null, clashManager = null) {
      if (typeof document === "undefined") return;
      if (typeof window !== "undefined" && window._isRandomizingClash) return;
      const defs = blockDefs || _ClashSettings.getBlockDefs();
      const active2 = _ClashSettings.getActiveBlocks(defs);
      for (const def of defs) {
        for (let i = 1; i <= def.maxCount; i++) {
          const selId = `${def.selectIdPrefix}${i}${def.selectIdSuffix}`;
          const sel = document.getElementById(selId);
          if (!sel) continue;
          const length = typeof def.getLength === "function" ? def.getLength(i) : 1;
          for (let optIdx = 0; optIdx < sel.options.length; optIdx++) {
            const opt = sel.options[optIdx];
            const val = parseInt(opt.value, 10);
            if (isNaN(val)) continue;
            if (!opt.dataset.originalText) {
              opt.dataset.originalText = opt.textContent;
            }
            let collision = null;
            if (clashManager && typeof clashManager.checkCollision === "function") {
              collision = clashManager.checkCollision(val, length, selId, active2);
            } else {
              collision = active2.find((b) => b.selectId !== selId && !(val + length - 1 < b.start || val > b.end));
            }
            if (collision) {
              opt.disabled = true;
              opt.textContent = `${opt.dataset.originalText} (Occupied: ${collision.name})`;
            } else {
              opt.disabled = false;
              opt.textContent = opt.dataset.originalText;
            }
          }
        }
      }
    }
    static sanitizeBlockPlacements(s, clashDefaultsFn = null) {
      if (!s) return s;
      const occupied = /* @__PURE__ */ new Set();
      const targetVal = Number(s?.target || typeof document !== "undefined" && document.getElementById("optTarget") && document.getElementById("optTarget").value || 121);
      const isClashTarget2 = [241, 361, 481].includes(targetVal);
      const defFn = clashDefaultsFn || (typeof getClashDefaults === "function" ? getClashDefaults : null);
      const defs = isClashTarget2 && defFn ? defFn(targetVal) : null;
      const maxClashHole = isClashTarget2 ? targetVal - 11 : 110;
      const maxNplHole = isClashTarget2 ? targetVal - 11 : 100;
      const maxJumpHole = isClashTarget2 ? targetVal - 11 : 115;
      const maxJumpDestHole = isClashTarget2 ? targetVal - 1 : 120;
      const maxStopSignHole = isClashTarget2 ? targetVal - 6 : 115;
      function isRangeOccupied(start, len) {
        for (let h = start; h < start + len; h++) {
          if (occupied.has(h)) return true;
        }
        return false;
      }
      function occupyRange(start, len) {
        for (let h = start; h < start + len; h++) {
          occupied.add(h);
        }
      }
      function findFreeStart(desired, len, minHole = 10, maxHole = maxClashHole, step = 5) {
        if (!isRangeOccupied(desired, len)) return desired;
        const maxDelta = isClashTarget2 ? targetVal : 120;
        for (let delta = step; delta <= maxDelta; delta += step) {
          if (desired + delta <= maxHole && !isRangeOccupied(desired + delta, len)) {
            return desired + delta;
          }
          if (desired - delta >= minHole && !isRangeOccupied(desired - delta, len)) {
            return desired - delta;
          }
        }
        for (let h = minHole; h <= maxHole; h += step) {
          if (!isRangeOccupied(h, len)) return h;
        }
        return desired;
      }
      function setDomValue(id, val) {
        if (typeof document !== "undefined") {
          const el = document.getElementById(id);
          if (el && el.value !== String(val)) el.value = String(val);
        }
      }
      if (s.optNoPassingLanes && Array.isArray(s.noPassingLaneStarts)) {
        const count = Math.min(4, Math.max(1, parseInt(s.noPassingLaneCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defs ? defs.noPassingLaneStarts[i] : [20, 50, 80, 100][i];
          const cur = parseInt(s.noPassingLaneStarts[i], 10) || fallback;
          const valid = findFreeStart(cur, 5, 10, maxNplHole);
          s.noPassingLaneStarts[i] = valid;
          occupyRange(valid, 5);
          setDomValue(`optNoPassingLane${i + 1}Start`, valid);
        }
      }
      if (s.optJump && Array.isArray(s.jumpStarts)) {
        const count = Math.min(8, Math.max(1, parseInt(s.jumpCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defs ? defs.jumpStarts[i] : [15, 65, 5, 115, 25, 75, 45, 95][i];
          const cur = parseInt(s.jumpStarts[i], 10) || fallback;
          const dFallback = defs ? defs.jumpDests[i] : [35, 50, 45, 70, 55, 60, 80, 85][i];
          const dVal = Array.isArray(s.jumpDests) && parseInt(s.jumpDests[i], 10) || dFallback;
          const isFwd = !isNaN(dVal) && dVal > cur;
          const jumpLen = isFwd ? 1 : 3;
          const valid = findFreeStart(cur, jumpLen, 5, maxJumpHole);
          s.jumpStarts[i] = valid;
          occupyRange(valid, jumpLen);
          setDomValue(`optJump${i + 1}Start`, valid);
        }
      }
      if (s.optJump && Array.isArray(s.jumpDests)) {
        const count = Math.min(8, Math.max(1, parseInt(s.jumpCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defs ? defs.jumpDests[i] : [35, 50, 45, 70, 55, 60, 80, 85][i];
          const cur = parseInt(s.jumpDests[i], 10) || fallback;
          const sVal = Array.isArray(s.jumpStarts) && parseInt(s.jumpStarts[i], 10);
          const isFwd = !isNaN(sVal) && cur > sVal;
          const maxDestLimit = isFwd ? Math.min(maxJumpDestHole, targetVal - 11) : maxJumpDestHole;
          const valid = findFreeStart(cur, 1, 5, maxDestLimit);
          s.jumpDests[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optJump${i + 1}Dest`, valid);
        }
      }
      if (s.optJail && Array.isArray(s.jailHoles)) {
        const count = Math.min(2, Math.max(1, parseInt(s.jailCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defs ? defs.jailHoles[i] : i === 0 ? 25 : 75;
          const cur = parseInt(s.jailHoles[i], 10) || fallback;
          const valid = findFreeStart(cur, 1, 10, maxClashHole);
          s.jailHoles[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optJail${i + 1}Hole`, valid);
        }
      }
      if (s.optBar && Array.isArray(s.barHoles)) {
        const count = Math.min(2, Math.max(1, parseInt(s.barCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defs ? defs.barHoles[i] : i === 0 ? 40 : 85;
          const cur = parseInt(s.barHoles[i], 10) || fallback;
          const valid = findFreeStart(cur, 1, 10, maxClashHole);
          s.barHoles[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optBar${i + 1}Hole`, valid);
        }
      }
      if (s.optTimeout && Array.isArray(s.timeoutHoles)) {
        const count = Math.min(2, Math.max(1, parseInt(s.timeoutCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defs ? defs.timeoutHoles[i] : i === 0 ? 30 : 90;
          const cur = parseInt(s.timeoutHoles[i], 10) || fallback;
          const valid = findFreeStart(cur, 1, 10, maxClashHole);
          s.timeoutHoles[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optTimeout${i + 1}Hole`, valid);
        }
      }
      if (s.optDetour && Array.isArray(s.detourHoles)) {
        const count = Math.min(2, Math.max(1, parseInt(s.detourCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defs ? defs.detourHoles[i] : i === 0 ? 10 : 60;
          const cur = parseInt(s.detourHoles[i], 10) || fallback;
          const valid = findFreeStart(cur, 1, 10, maxClashHole);
          s.detourHoles[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optDetour${i + 1}Hole`, valid);
        }
      }
      if (s.optRoundAbout && Array.isArray(s.roundAboutHoles)) {
        const count = Math.min(2, Math.max(1, parseInt(s.roundAboutCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defs ? defs.roundAboutHoles[i] : i === 0 ? 35 : 70;
          const cur = parseInt(s.roundAboutHoles[i], 10) || fallback;
          const valid = findFreeStart(cur, 1, 10, maxClashHole);
          s.roundAboutHoles[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optRoundAbout${i + 1}Hole`, valid);
        }
      }
      if (s.optSigns && Array.isArray(s.signsBlocks)) {
        const count = Math.min(4, Math.max(1, parseInt(s.signsCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const b = s.signsBlocks[i];
          if (!b) continue;
          const len = parseInt(b.size, 10) === 4 ? 5 : 3;
          const fallback = defs ? defs.signsStarts[i] : [45, 55, 95, 105][i];
          const cur = parseInt(b.start, 10) || fallback;
          const valid = findFreeStart(cur, len, 10, maxClashHole);
          b.start = valid;
          occupyRange(valid, len);
          setDomValue(`optSigns${i + 1}Hole`, valid);
        }
      }
      if (s.optStopSign && Array.isArray(s.stopSignHoles)) {
        const defaultStops121 = [20, 35, 50, 65, 80, 95, 105, 115];
        const defaultStopsClash = defs ? defs.stopSignHoles : null;
        const count = Math.min(8, Math.max(1, parseInt(s.stopSignCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defaultStopsClash ? defaultStopsClash[i] || 35 + i * 50 : defaultStops121[i] || 15 + i * 12;
          const cur = parseInt(s.stopSignHoles[i], 10) || fallback;
          const valid = findFreeStart(cur, 1, 5, maxStopSignHole);
          s.stopSignHoles[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optStopSign${i + 1}Hole`, valid);
        }
      }
      if (s.optDice && Array.isArray(s.diceHoles)) {
        const defaultDice121 = [20, 50, 80, 100];
        const defaultDiceClash = defs ? defs.diceHoles : null;
        const count = Math.min(4, Math.max(1, parseInt(s.diceCount || s.optDiceCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defaultDiceClash ? defaultDiceClash[i] || 50 + i * 100 : defaultDice121[i] || 20 + i * 25;
          const cur = parseInt(s.diceHoles[i], 10) || fallback;
          const valid = findFreeStart(cur, 1, 5, maxClashHole);
          s.diceHoles[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optDice${i + 1}Hole`, valid);
        }
      }
      if ((s.optWheel || s.optSpinningWheel) && Array.isArray(s.wheelHoles)) {
        const defaultWheel121 = [15, 45, 75, 105];
        const defaultWheelClash = defs ? defs.wheelHoles : null;
        const count = Math.min(4, Math.max(1, parseInt(s.wheelCount || s.optWheelCount || s.optSpinningWheelCount, 10) || 1));
        for (let i = 0; i < count; i++) {
          const fallback = defaultWheelClash ? defaultWheelClash[i] || 65 + i * 90 : defaultWheel121[i] || 15 + i * 30;
          const cur = parseInt(s.wheelHoles[i], 10) || fallback;
          const valid = findFreeStart(cur, 1, 5, maxClashHole);
          s.wheelHoles[i] = valid;
          occupyRange(valid, 1);
          setDomValue(`optWheel${i + 1}Hole`, valid);
        }
      }
      return s;
    }
    /**
     * Computes street or turn display name for a given hole number on 121 or Clash circular board.
     * @param {number} h
     * @param {number} [targetVal=121]
     * @returns {string}
     */
    static getStreetOrTurnName(h, targetVal = 121) {
      const isClashTarget2 = [241, 361, 481].includes(targetVal);
      if (isClashTarget2) {
        if (h <= 0) return "Start";
        if (h >= targetVal) return "Finish";
        const row = Math.floor((h - 1) / 60);
        const pos = (h - 1) % 60;
        if (pos < 55) return `Street ${row + 1}`;
        return `Turn ${row + 1}`;
      }
      if (h > 70) return "Street 3";
      if (h > 65) return "Turn 2";
      if (h > 35) return "Street 2";
      if (h > 30) return "Turn 1";
      return "Street 1";
    }
    /**
     * Updates jump option labels to show forward (1 hole) vs backward (3 holes).
     * @param {number} idx
     */
    static updateJumpOptionLabels(idx) {
      if (typeof document === "undefined") return;
      const sEl = document.getElementById(`optJump${idx}Start`);
      const dEl = document.getElementById(`optJump${idx}Dest`);
      if (!sEl || !dEl) return;
      const dVal = parseInt(dEl.value, 10);
      Array.from(sEl.options).forEach((opt) => {
        const sVal = parseInt(opt.value, 10);
        if (isNaN(sVal)) return;
        const isFwd = !isNaN(dVal) && dVal > sVal;
        opt.textContent = isFwd ? `Hole ${sVal}` : `Holes ${sVal}\u2013${sVal + 2}`;
      });
    }
    /**
     * Toggles an obstacle panel on/off, updating its rows and overlap enforcement.
     * @param {string} type
     * @param {boolean} checked
     * @param {Object} [helpers]
     */
    static toggleObstacleConfig(type, checked, helpers = {}) {
      if (typeof document === "undefined") return;
      const configMap = {
        noPassingLanes: { panelId: "noPassingLanesConfig", count: 4, updateFn: "updateNoPassingLaneRows", onField: "onNoPassingLaneFieldChange" },
        jump: { panelId: "jumpConfig", count: 8, updateFn: "updateJumpRows", onField: "onJumpFieldChange" },
        jail: { panelId: "jailConfig", count: 2, updateFn: "updateJailRows", onField: "onJailFieldChange" },
        bar: { panelId: "barConfig", count: 2, updateFn: "updateBarRows", onField: "onBarFieldChange" },
        timeout: { panelId: "timeoutConfig", count: 2, updateFn: "updateTimeoutRows", onField: "onTimeoutFieldChange" },
        detour: { panelId: "detourConfig", count: 2, updateFn: "updateDetourRows", onField: "onDetourFieldChange" },
        roundAbout: { panelId: "roundAboutConfig", count: 2, updateFn: "updateRoundAboutRows", onField: "onRoundAboutFieldChange" },
        signs: { panelId: "signsConfig", count: 4, updateFn: "updateSignsRows", onField: "onSignsFieldChange" },
        stopSign: { panelId: "stopSignConfig", count: 8, updateFn: "updateStopSignRows", onField: "onStopSignFieldChange" },
        dice: { panelId: "diceConfig", count: 4, updateFn: "updateDiceRows", onField: "onDiceFieldChange" },
        wheel: { panelId: "wheelConfig", count: 4, updateFn: "updateWheelRows", onField: "onWheelFieldChange" }
      };
      const cfg = configMap[type];
      if (!cfg) return;
      const panel = document.getElementById(cfg.panelId);
      if (panel) panel.style.display = checked ? "flex" : "none";
      if (typeof window !== "undefined" && typeof window[cfg.updateFn] === "function") {
        window[cfg.updateFn]();
      }
      if (cfg.onField && typeof window !== "undefined" && typeof window[cfg.onField] === "function") {
        for (let i = 1; i <= cfg.count; i++) {
          window[cfg.onField](i, true);
        }
      }
      if (checked) {
        if (typeof window !== "undefined" && typeof window.enforceClashNoOverlap === "function") {
          window.enforceClashNoOverlap();
        }
      } else {
        if (typeof window !== "undefined" && typeof window.updateAllClashDropdowns === "function") {
          window.updateAllClashDropdowns();
        }
      }
      if (typeof window !== "undefined" && typeof window.readFormSettings === "function" && typeof window.saveSettingsStore === "function") {
        window.saveSettingsStore(window.readFormSettings());
      }
    }
    /**
     * Updates obstacle row visibility based on count dropdown.
     * @param {string} type
     */
    static updateObstacleRows(type) {
      if (typeof document === "undefined") return;
      const def = _ClashSettings.getBlockDefs().find((d) => d.type === type);
      const rowMap = {
        noPassingLanes: { countId: "optNoPassingLaneCount", prefix: "nplLaneRow", max: 4 },
        jump: { countId: "optJumpCount", prefix: "jumpRow", max: 8 },
        jail: { countId: "optJailCount", prefix: "jailRow", max: 4 },
        bar: { countId: "optBarCount", prefix: "barRow", max: 4 },
        timeout: { countId: "optTimeoutCount", prefix: "timeoutRow", max: 4 },
        detour: { countId: "optDetourCount", prefix: "detourRow", max: 4 },
        roundAbout: { countId: "optRoundAboutCount", prefix: "roundAboutRow", max: 4 },
        signs: { countId: "optSignsCount", prefix: "signsRow", max: 8 },
        stopSign: { countId: "optStopSignCount", prefix: "stopSignRow", max: 8 },
        dice: { countId: "optDiceCount", prefix: "diceRow", max: 4 },
        wheel: { countId: "optWheelCount", prefix: "wheelRow", max: 4 }
      };
      const rm = rowMap[type];
      if (!rm) return;
      const max = def && typeof def.maxCount === "number" ? def.maxCount : rm.max;
      const countEl = document.getElementById(rm.countId);
      const count = countEl ? parseInt(countEl.value, 10) : 2;
      for (let i = 1; i <= max; i++) {
        const row = document.getElementById(rm.prefix + i);
        if (row) row.style.display = i <= count ? "flex" : "none";
      }
      if (typeof window !== "undefined" && typeof window.enforceClashNoOverlap === "function") {
        window.enforceClashNoOverlap();
      }
      if (typeof window !== "undefined" && typeof window.readFormSettings === "function" && typeof window.saveSettingsStore === "function") {
        window.saveSettingsStore(window.readFormSettings());
      }
    }
    /**
     * Handles field change on obstacle dropdowns, formatting badge and enforcing non-overlap.
     * @param {string} type
     * @param {number} idx
     * @param {boolean} [skipSave=false]
     */
    static onObstacleFieldChange(type, idx, skipSave = false) {
      if (typeof document === "undefined") return;
      const targetVal = Number(
        typeof window !== "undefined" && window.settings && window.settings.target || document.getElementById("optTarget") && document.getElementById("optTarget").value || 121
      );
      const isClashTarget2 = [241, 361, 481].includes(targetVal);
      const defs = isClashTarget2 ? getClashDefaults(targetVal) : null;
      if (type === "noPassingLanes") {
        if (typeof window !== "undefined" && typeof window.enforceClashNoOverlap === "function") {
          window.enforceClashNoOverlap(`optNoPassingLane${idx}Start`);
        }
      } else if (type === "jump") {
        _ClashSettings.updateJumpOptionLabels(idx);
        if (typeof window !== "undefined" && typeof window.enforceClashNoOverlap === "function") {
          window.enforceClashNoOverlap(`optJump${idx}Start`);
        }
        const sEl = document.getElementById(`optJump${idx}Start`);
        const dEl = document.getElementById(`optJump${idx}Dest`);
        const bEl = document.getElementById(`jumpBadge${idx}`);
        const rowEl = document.getElementById(`jumpRow${idx}`);
        if (sEl && dEl && bEl) {
          const sFallback = defs ? defs.jumpStarts[idx - 1] : [15, 65, 5, 115, 25, 75, 45, 95][idx - 1];
          const dFallback = defs ? defs.jumpDests[idx - 1] : [35, 50, 45, 70, 55, 60, 80, 85][idx - 1];
          const s = parseInt(sEl.value, 10) || sFallback;
          const d = parseInt(dEl.value, 10) || dFallback;
          const isForward = d > s;
          bEl.className = "jump-badge " + (isForward ? "jump-badge-forward" : "jump-badge-backward");
          bEl.textContent = isForward ? "Forward (1 hole) \u2794" : "Backward (3 holes) \u2B05";
          if (rowEl) rowEl.classList.toggle("backward", !isForward);
        }
        if (typeof window !== "undefined" && typeof window.syncClashPlacementButton === "function") {
          window.syncClashPlacementButton(`optJump${idx}Start`);
          window.syncClashPlacementButton(`optJump${idx}Dest`);
        }
      } else if (["jail", "bar", "timeout", "detour", "roundAbout", "stopSign", "dice", "wheel"].includes(type)) {
        const idPrefix = {
          jail: "optJail",
          bar: "optBar",
          timeout: "optTimeout",
          detour: "optDetour",
          roundAbout: "optRoundAbout",
          stopSign: "optStopSign",
          dice: "optDice",
          wheel: "optWheel"
        }[type];
        const badgePrefix = {
          jail: "jailBadge",
          bar: "barBadge",
          timeout: "timeoutBadge",
          detour: "detourBadge",
          roundAbout: "roundAboutBadge",
          stopSign: "stopSignBadge",
          dice: "diceBadge",
          wheel: "wheelBadge"
        }[type];
        if (typeof window !== "undefined" && typeof window.enforceClashNoOverlap === "function") {
          window.enforceClashNoOverlap(`${idPrefix}${idx}Hole`);
        }
        const hEl = document.getElementById(`${idPrefix}${idx}Hole`);
        const bEl = document.getElementById(`${badgePrefix}${idx}`);
        if (hEl && bEl) {
          let fallback = 25;
          if (type === "jail") fallback = defs ? defs.jailHoles[idx - 1] : idx === 1 ? 25 : 75;
          if (type === "bar") fallback = defs ? defs.barHoles[idx - 1] : idx === 1 ? 40 : 85;
          if (type === "timeout") fallback = defs ? defs.timeoutHoles[idx - 1] : idx === 1 ? 30 : 90;
          if (type === "detour") fallback = defs ? defs.detourHoles[idx - 1] : idx === 1 ? 10 : 60;
          if (type === "roundAbout") fallback = defs ? defs.roundAboutHoles[idx - 1] : idx === 1 ? 35 : 70;
          if (type === "stopSign") {
            const defaultStops121 = [20, 35, 50, 65, 80, 95, 105, 115];
            const defaultStopsClash = defs ? defs.stopSignHoles : null;
            fallback = defaultStopsClash ? defaultStopsClash[idx - 1] || 35 + idx * 50 : defaultStops121[idx - 1] || 15 + idx * 12;
          }
          if (type === "dice") {
            const defaultDice121 = [20, 50, 80, 100];
            const defaultDiceClash = defs ? defs.diceHoles : null;
            fallback = defaultDiceClash ? defaultDiceClash[idx - 1] || 50 + idx * 100 : defaultDice121[idx - 1] || 20 + idx * 25;
          }
          if (type === "wheel") {
            const defaultWheel121 = [15, 45, 75, 105];
            const defaultWheelClash = defs ? defs.wheelHoles : null;
            fallback = defaultWheelClash ? defaultWheelClash[idx - 1] || 65 + idx * 90 : defaultWheel121[idx - 1] || 15 + idx * 30;
          }
          const h = parseInt(hEl.value, 10) || fallback;
          const streetName3 = _ClashSettings.getStreetOrTurnName(h, targetVal);
          bEl.textContent = `${streetName3} (Hole ${h})`;
        }
      } else if (type === "signs") {
        if (typeof window !== "undefined" && typeof window.enforceClashNoOverlap === "function") {
          window.enforceClashNoOverlap(`optSigns${idx}Hole`);
        }
        const hEl = document.getElementById(`optSigns${idx}Hole`);
        const sEl = document.getElementById(`optSigns${idx}Size`);
        const bEl = document.getElementById(`signsBadge${idx}`);
        const slot3Wrap = document.getElementById(`signs${idx}Slot3Wrap`);
        const slot4Wrap = document.getElementById(`signs${idx}Slot4Wrap`);
        const size = sEl ? parseInt(sEl.value, 10) : 2;
        if (slot3Wrap) slot3Wrap.style.display = size === 4 ? "flex" : "none";
        if (slot4Wrap) slot4Wrap.style.display = size === 4 ? "flex" : "none";
        if (hEl && bEl) {
          const fallback = defs ? defs.signsStarts[idx - 1] : idx === 1 ? 45 : idx === 2 ? 55 : idx === 3 ? 95 : 105;
          const start = parseInt(hEl.value, 10) || fallback;
          const pegLength = size === 2 ? 3 : 5;
          const end = start + pegLength - 1;
          const streetName3 = _ClashSettings.getStreetOrTurnName(start, targetVal);
          bEl.textContent = `${streetName3} (Holes ${start}\u2013${end} \xB7 ${size} Signs)`;
        }
      }
      if (!skipSave && typeof window !== "undefined" && typeof window.readFormSettings === "function" && typeof window.saveSettingsStore === "function") {
        window.saveSettingsStore(window.readFormSettings());
      }
    }
    /**
     * Reads configured sign blocks from form DOM elements.
     * @param {Object} [options]
     * @returns {Array<Object>}
     */
    static readSignsBlocksFromForm(options = {}) {
      if (typeof document === "undefined") return [];
      const targetVal = Number(
        options.target || typeof window !== "undefined" && window.settings && window.settings.target || document.getElementById("optTarget") && document.getElementById("optTarget").value || 121
      );
      const isClashTarget2 = [241, 361, 481].includes(targetVal);
      const defs = isClashTarget2 ? getClashDefaults(targetVal) : null;
      const blocks = [];
      for (let i = 1; i <= 4; i++) {
        const hEl = document.getElementById(`optSigns${i}Hole`);
        const sEl = document.getElementById(`optSigns${i}Size`);
        const fallback = defs ? defs.signsStarts[i - 1] : i === 1 ? 45 : i === 2 ? 55 : i === 3 ? 95 : 105;
        const start = hEl ? parseInt(hEl.value, 10) : fallback;
        const size = sEl ? parseInt(sEl.value, 10) : i % 2 === 1 ? 2 : 4;
        const signs = [];
        for (let slot = 1; slot <= size; slot++) {
          const slotEl = document.getElementById(`optSigns${i}Slot${slot}`);
          if (slotEl && slotEl.value) {
            signs.push(slotEl.value);
          }
        }
        if (!signs.length) {
          if (size === 2) signs.push("Plus 5", "Roll The Dice");
          else signs.push("Spin The Wheel", "Plus 10", "Minus 5", "Score Plus x2");
        }
        blocks.push({ id: i, start, size, signs });
      }
      return blocks;
    }
    /**
     * Toggles skunk markers configuration panel and updates settings.
     * @param {boolean} checked
     * @param {Object} [helpers]
     */
    static toggleSkunkMarkersConfig(checked, helpers = {}) {
      if (typeof document === "undefined") return;
      const panel = document.getElementById("skunkMarkersConfig");
      if (panel) panel.style.display = checked ? "flex" : "none";
      const settings3 = helpers.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3) {
        settings3.optSkunkMarkers = Boolean(checked);
      }
      const onSkunk = helpers.onSkunkMarkerFieldChange || (typeof window !== "undefined" ? window.onSkunkMarkerFieldChange : _ClashSettings.onSkunkMarkerFieldChange);
      const onDoubleSkunk = helpers.onDoubleSkunkMarkerFieldChange || (typeof window !== "undefined" ? window.onDoubleSkunkMarkerFieldChange : _ClashSettings.onDoubleSkunkMarkerFieldChange);
      if (typeof onSkunk === "function") onSkunk(true, helpers);
      if (typeof onDoubleSkunk === "function") onDoubleSkunk(true, helpers);
      const syncPlacement = helpers.syncAllClashPlacementButtons || (typeof window !== "undefined" ? window.syncAllClashPlacementButtons : null);
      if (typeof syncPlacement === "function") syncPlacement();
      const readSettings = helpers.readFormSettings || (typeof window !== "undefined" ? window.readFormSettings : null);
      const saveSettings = helpers.saveSettingsStore || (typeof window !== "undefined" ? window.saveSettingsStore : null);
      if (typeof readSettings === "function" && typeof saveSettings === "function") {
        saveSettings(readSettings());
      }
      const gameBoard = document.getElementById("board");
      const buildBoard2 = helpers.buildBoard || (typeof window !== "undefined" ? window.buildBoard : null);
      if (gameBoard && gameBoard.querySelector("svg") && typeof buildBoard2 === "function") {
        buildBoard2();
      }
    }
    /**
     * Updates skunk marker hole value and badge text.
     * @param {boolean} [skipSave]
     * @param {Object} [helpers]
     */
    static onSkunkMarkerFieldChange(skipSave = false, helpers = {}) {
      if (typeof document === "undefined") return;
      const hEl = document.getElementById("optSkunkMarkerHole");
      const bEl = document.getElementById("skunkMarkerBadge");
      const settings3 = helpers.settings || (typeof window !== "undefined" ? window.settings : null);
      const targetVal = Number(settings3 && settings3.target || document.getElementById("optTarget") && document.getElementById("optTarget").value || 481);
      const getSkunkDefs = helpers.getSkunkDefaults || (typeof window !== "undefined" ? window.getSkunkDefaults : null);
      const defs = typeof getSkunkDefs === "function" ? getSkunkDefs(targetVal) : { skunkHole: 360, doubleSkunkHole: 240 };
      const h = hEl && parseInt(hEl.value, 10) || defs.skunkHole;
      if (settings3) {
        settings3.skunkMarkerHole = h;
      }
      if (bEl) {
        const getStreet = helpers.getStreetOrTurnName || (typeof window !== "undefined" ? window.getStreetOrTurnName : null);
        const sName = typeof getStreet === "function" ? getStreet(h) : "";
        bEl.textContent = `${sName ? sName + " \xB7 " : ""}Hole ${h}`;
      }
      const readSettings = helpers.readFormSettings || (typeof window !== "undefined" ? window.readFormSettings : null);
      const saveSettings = helpers.saveSettingsStore || (typeof window !== "undefined" ? window.saveSettingsStore : null);
      if (!skipSave && typeof readSettings === "function" && typeof saveSettings === "function") {
        saveSettings(readSettings());
      }
      const gameBoard = document.getElementById("board");
      const buildBoard2 = helpers.buildBoard || (typeof window !== "undefined" ? window.buildBoard : null);
      if (gameBoard && gameBoard.querySelector("svg") && typeof buildBoard2 === "function" && settings3 && settings3.optSkunkMarkers) {
        buildBoard2();
      }
    }
    /**
     * Updates double skunk marker hole value and badge text.
     * @param {boolean} [skipSave]
     * @param {Object} [helpers]
     */
    static onDoubleSkunkMarkerFieldChange(skipSave = false, helpers = {}) {
      if (typeof document === "undefined") return;
      const hEl = document.getElementById("optDoubleSkunkMarkerHole");
      const bEl = document.getElementById("doubleSkunkMarkerBadge");
      const settings3 = helpers.settings || (typeof window !== "undefined" ? window.settings : null);
      const targetVal = Number(settings3 && settings3.target || document.getElementById("optTarget") && document.getElementById("optTarget").value || 481);
      const getSkunkDefs = helpers.getSkunkDefaults || (typeof window !== "undefined" ? window.getSkunkDefaults : null);
      const defs = typeof getSkunkDefs === "function" ? getSkunkDefs(targetVal) : { skunkHole: 360, doubleSkunkHole: 240 };
      const h = hEl && parseInt(hEl.value, 10) || defs.doubleSkunkHole;
      if (settings3) {
        settings3.doubleSkunkMarkerHole = h;
      }
      if (bEl) {
        const getStreet = helpers.getStreetOrTurnName || (typeof window !== "undefined" ? window.getStreetOrTurnName : null);
        const sName = typeof getStreet === "function" ? getStreet(h) : "";
        bEl.textContent = `${sName ? sName + " \xB7 " : ""}Hole ${h}`;
      }
      const readSettings = helpers.readFormSettings || (typeof window !== "undefined" ? window.readFormSettings : null);
      const saveSettings = helpers.saveSettingsStore || (typeof window !== "undefined" ? window.saveSettingsStore : null);
      if (!skipSave && typeof readSettings === "function" && typeof saveSettings === "function") {
        saveSettings(readSettings());
      }
      const gameBoard = document.getElementById("board");
      const buildBoard2 = helpers.buildBoard || (typeof window !== "undefined" ? window.buildBoard : null);
      if (gameBoard && gameBoard.querySelector("svg") && typeof buildBoard2 === "function" && settings3 && settings3.optSkunkMarkers) {
        buildBoard2();
      }
    }
    /**
     * Checks for obstacle range collision against active obstacles.
     */
    static checkCollision(candidateStart, length, excludeSelectId, blockList, clashManager = null) {
      const cm = clashManager || (typeof window !== "undefined" ? window.ClashManager : null);
      if (cm && typeof cm.checkCollision === "function") {
        return cm.checkCollision(candidateStart, length, excludeSelectId, blockList);
      }
      const end = candidateStart + length - 1;
      for (const b of blockList || []) {
        if (b.selectId === excludeSelectId) continue;
        if (candidateStart <= b.end && end >= b.start) return b;
      }
      return null;
    }
    /**
     * Discovers an available non-overlapping hole for a select dropdown.
     */
    static findAvailableHole(sel, length, excludeSelectId, activeBlocks, clashManager = null) {
      if (!sel) return null;
      const currentVal = parseInt(sel.value, 10);
      const options = Array.from(sel.options || []).map((o) => parseInt(o.value, 10)).filter((v) => !isNaN(v));
      const cm = clashManager || (typeof window !== "undefined" ? window.ClashManager : null);
      if (cm && typeof cm.findAvailableHole === "function") {
        return cm.findAvailableHole(options, currentVal, length, excludeSelectId, activeBlocks);
      }
      return currentVal;
    }
    /**
     * Enforces non-overlapping placement across all active obstacle dropdown selectors.
     */
    static enforceNoOverlap(initiatorSelectId = null, context = {}) {
      if (typeof window !== "undefined" && (window._isEnforcingClashNoOverlap || window._isRandomizingClash)) return;
      if (typeof window !== "undefined") window._isEnforcingClashNoOverlap = true;
      const getActiveClashBlocks2 = context.getActiveClashBlocks || (typeof window !== "undefined" ? window.getActiveClashBlocks : () => []);
      const updateAllClashDropdowns2 = context.updateAllClashDropdowns || (typeof window !== "undefined" ? window.updateAllClashDropdowns : () => {
      });
      const checkCollision = context.checkCollision || _ClashSettings.checkCollision;
      const findAvailableHole = context.findAvailableHole || _ClashSettings.findAvailableHole;
      try {
        const active2 = getActiveClashBlocks2();
        const blocksToProcess = [...active2];
        if (initiatorSelectId) {
          const initIdx = blocksToProcess.findIndex((b) => b.selectId === initiatorSelectId);
          if (initIdx > 0) {
            const [initBlock] = blocksToProcess.splice(initIdx, 1);
            blocksToProcess.unshift(initBlock);
          }
        }
        const resolved = [];
        for (const b of blocksToProcess) {
          const sel = typeof document !== "undefined" ? document.getElementById(b.selectId) : null;
          if (!sel) continue;
          let start = parseInt(sel.value, 10);
          const collision = checkCollision(start, b.length, b.selectId, resolved);
          if (collision) {
            const freeHole = findAvailableHole(sel, b.length, b.selectId, resolved);
            if (freeHole != null && freeHole !== start) {
              sel.value = String(freeHole);
              start = freeHole;
              if (b.def && typeof b.def.onFieldChange === "function") {
                b.def.onFieldChange(b.index, true);
              }
            }
          }
          resolved.push({
            ...b,
            start,
            end: start + b.length - 1
          });
        }
        updateAllClashDropdowns2();
      } finally {
        if (typeof window !== "undefined") window._isEnforcingClashNoOverlap = false;
      }
    }
    toggleSkunkMarkersConfig(checked, helpers) {
      return _ClashSettings.toggleSkunkMarkersConfig(checked, helpers);
    }
    onSkunkMarkerFieldChange(skipSave, helpers) {
      return _ClashSettings.onSkunkMarkerFieldChange(skipSave, helpers);
    }
    onDoubleSkunkMarkerFieldChange(skipSave, helpers) {
      return _ClashSettings.onDoubleSkunkMarkerFieldChange(skipSave, helpers);
    }
    checkCollision(candidateStart, length, excludeSelectId, blockList, clashManager) {
      return _ClashSettings.checkCollision(candidateStart, length, excludeSelectId, blockList, clashManager);
    }
    findAvailableHole(sel, length, excludeSelectId, activeBlocks, clashManager) {
      return _ClashSettings.findAvailableHole(sel, length, excludeSelectId, activeBlocks, clashManager);
    }
    enforceNoOverlap(initiatorSelectId, context) {
      return _ClashSettings.enforceNoOverlap(initiatorSelectId, context);
    }
  };
  function getClashBlockDefs() {
    return ClashSettings.getBlockDefs();
  }

  // src/variants/AdultPresets.js
  var ADULT_CUSTOM_LAYOUTS_KEY = "cc_adult_custom_layouts";
  var ADULT_PRESET_KEYS = Object.freeze({
    STANDARD: "standard",
    HIGH_HEAT: "highHeat",
    SENSUAL_GAUNTLET: "sensualGauntlet"
  });
  var ADULT_PRESETS_121 = Object.freeze({
    standard: {
      key: "standard",
      name: "Warm-Up Strip",
      badge: "\u{1F457} Gentle Strip",
      icon: "\u{1F457}",
      description: "A playful and flirtatious intro. Balanced strip spaces with chances to gain clothing back and occasional sensual touch dares.",
      tags: ["Strip", "Flirty", "Playful"],
      dareSpaces: 14,
      config: {
        optLoseClothing: true,
        optLoseClothingCount: 2,
        optLoseClothingPegs: 1,
        optLoseClothing1Hole: 15,
        optLoseClothing2Hole: 75,
        optGainClothing: true,
        optGainClothingCount: 2,
        optGainClothingPegs: 1,
        optGainClothing1Hole: 25,
        optGainClothing2Hole: 85,
        optPickWhoLosesClothing: true,
        optPickWhoLosesClothingCount: 2,
        optPickWhoLosesClothingPegs: 1,
        optPickWhoLosesClothing1Hole: 35,
        optPickWhoLosesClothing2Hole: 95,
        optRightLosesClothing: true,
        optRightLosesClothingCount: 2,
        optRightLosesClothingPegs: 1,
        optRightLosesClothing1Hole: 45,
        optRightLosesClothing2Hole: 105,
        optLeftLosesClothing: true,
        optLeftLosesClothingCount: 2,
        optLeftLosesClothingPegs: 1,
        optLeftLosesClothing1Hole: 55,
        optLeftLosesClothing2Hole: 115,
        optTouchBreast: true,
        optTouchBreastCount: 2,
        optTouchBreastPegs: 1,
        optTouchBreast1Hole: 30,
        optTouchBreast2Hole: 90,
        optTouchGenitals: true,
        optTouchGenitalsCount: 2,
        optTouchGenitalsPegs: 1,
        optTouchGenitals1Hole: 60,
        optTouchGenitals2Hole: 118
      }
    },
    highHeat: {
      key: "highHeat",
      name: "High Heat",
      badge: "\u{1F525} Intense Strip",
      icon: "\u{1F525}",
      description: "Rapid strip penalties and zero mercy! Multiple strip tiles placed right before corners and skunk zones.",
      tags: ["Intense", "Naked", "Competitive"],
      dareSpaces: 20,
      config: {
        optLoseClothing: true,
        optLoseClothingCount: 4,
        optLoseClothingPegs: 1,
        optLoseClothing1Hole: 10,
        optLoseClothing2Hole: 40,
        optLoseClothing3Hole: 70,
        optLoseClothing4Hole: 100,
        optGainClothing: true,
        optGainClothingCount: 1,
        optGainClothingPegs: 1,
        optGainClothing1Hole: 60,
        optPickWhoLosesClothing: true,
        optPickWhoLosesClothingCount: 3,
        optPickWhoLosesClothingPegs: 1,
        optPickWhoLosesClothing1Hole: 20,
        optPickWhoLosesClothing2Hole: 50,
        optPickWhoLosesClothing3Hole: 80,
        optRightLosesClothing: true,
        optRightLosesClothingCount: 3,
        optRightLosesClothingPegs: 1,
        optRightLosesClothing1Hole: 25,
        optRightLosesClothing2Hole: 75,
        optRightLosesClothing3Hole: 105,
        optLeftLosesClothing: true,
        optLeftLosesClothingCount: 3,
        optLeftLosesClothingPegs: 1,
        optLeftLosesClothing1Hole: 30,
        optLeftLosesClothing2Hole: 85,
        optLeftLosesClothing3Hole: 115,
        optRemoveClothingChoice: true,
        optRemoveClothingChoiceCount: 3,
        optRemoveClothingChoicePegs: 1,
        optRemoveClothingChoice1Hole: 15,
        optRemoveClothingChoice2Hole: 65,
        optRemoveClothingChoice3Hole: 118,
        optTouchBreast: true,
        optTouchBreastCount: 2,
        optTouchBreastPegs: 1,
        optTouchBreast1Hole: 35,
        optTouchBreast2Hole: 95,
        optTouchGenitals: true,
        optTouchGenitalsCount: 1,
        optTouchGenitalsPegs: 1,
        optTouchGenitals1Hole: 110
      }
    },
    sensualGauntlet: {
      key: "sensualGauntlet",
      name: "Sensual Gauntlet",
      badge: "\u23F3 Timed Dares",
      icon: "\u23F3",
      description: "An erotic challenge board heavily loaded with timed touch, kiss, lick, and genital dares at nearly every milestone.",
      tags: ["Erotic", "Timed Dares", "Intimate"],
      dareSpaces: 22,
      config: {
        optLoseClothing: true,
        optLoseClothingCount: 2,
        optLoseClothingPegs: 1,
        optLoseClothing1Hole: 10,
        optLoseClothing2Hole: 70,
        optPickWhoLosesClothing: true,
        optPickWhoLosesClothingCount: 2,
        optPickWhoLosesClothingPegs: 1,
        optPickWhoLosesClothing1Hole: 40,
        optPickWhoLosesClothing2Hole: 100,
        optTouchBreast: true,
        optTouchBreastCount: 3,
        optTouchBreastPegs: 1,
        optTouchBreast1Hole: 15,
        optTouchBreast2Hole: 45,
        optTouchBreast3Hole: 75,
        optLickBreast: true,
        optLickBreastCount: 3,
        optLickBreastPegs: 1,
        optLickBreast1Hole: 20,
        optLickBreast2Hole: 50,
        optLickBreast3Hole: 80,
        optSuckBreast: true,
        optSuckBreastCount: 2,
        optSuckBreastPegs: 1,
        optSuckBreast1Hole: 25,
        optSuckBreast2Hole: 85,
        optTouchGenitals: true,
        optTouchGenitalsCount: 3,
        optTouchGenitalsPegs: 1,
        optTouchGenitals1Hole: 30,
        optTouchGenitals2Hole: 60,
        optTouchGenitals3Hole: 90,
        optLickGenitals: true,
        optLickGenitalsCount: 2,
        optLickGenitalsPegs: 1,
        optLickGenitals1Hole: 35,
        optLickGenitals2Hole: 95,
        optSuckGenitals: true,
        optSuckGenitalsCount: 2,
        optSuckGenitalsPegs: 1,
        optSuckGenitals1Hole: 55,
        optSuckGenitals2Hole: 110,
        optFingerGenitals: true,
        optFingerGenitalsCount: 3,
        optFingerGenitalsPegs: 1,
        optFingerGenitals1Hole: 65,
        optFingerGenitals2Hole: 105,
        optFingerGenitals3Hole: 118
      }
    }
  });
  var AdultPresets = class _AdultPresets {
    static getStorage(storage = null) {
      if (storage) return storage;
      if (typeof window !== "undefined" && window.appStorage) return window.appStorage;
      return appStorage;
    }
    static getPresets(target = 121) {
      const t = Number(target) || 121;
      if (t === 121) return ADULT_PRESETS_121;
      return _AdultPresets.scalePresetsForTarget(ADULT_PRESETS_121, t);
    }
    static scalePresetsForTarget(presets, target) {
      const scale = (target - 1) / 120;
      const scaled = {};
      for (const [key, preset] of Object.entries(presets)) {
        const cfg = { ...preset.config };
        for (const [prop, val] of Object.entries(cfg)) {
          if (typeof val === "number" && prop.endsWith("Hole")) {
            cfg[prop] = Math.min(target - 2, Math.max(2, Math.round(val * scale)));
          }
        }
        scaled[key] = {
          ...preset,
          config: cfg
        };
      }
      return scaled;
    }
    static computeTrackMetrics(items = [], target = 121) {
      const total = items.length;
      let stripSpaces = 0;
      let timedDares = 0;
      const timedKeys = /* @__PURE__ */ new Set([
        "touchBreast",
        "lickBreast",
        "suckBreast",
        "touchGenitals",
        "lickGenitals",
        "suckGenitals",
        "fingerGenitals"
      ]);
      const holes = [];
      for (const item of items) {
        if (item.hole != null) holes.push(item.hole);
        if (timedKeys.has(item.type)) timedDares++;
        else stripSpaces++;
      }
      holes.sort((a, b) => a - b);
      let avgSpacing = 0;
      if (holes.length > 1) {
        let sumDist = 0;
        for (let i = 1; i < holes.length; i++) {
          sumDist += holes[i] - holes[i - 1];
        }
        avgSpacing = Math.round(sumDist / (holes.length - 1));
      } else if (holes.length === 1) {
        avgSpacing = target;
      }
      return {
        totalDareSpaces: total,
        stripSpaces,
        timedDares,
        avgSpacing
      };
    }
    static applyPreset(presetKey, context = {}) {
      const target = context.settings && context.settings.target || typeof window !== "undefined" && window.settings && window.settings.target || 121;
      const presets = _AdultPresets.getPresets(target);
      const preset = presets[presetKey] || presets.standard;
      if (!preset) return false;
      const cfg = preset.config;
      const doc = context.document || (typeof document !== "undefined" ? document : null);
      if (doc) {
        for (const [prop, val] of Object.entries(cfg)) {
          const el = doc.getElementById(prop);
          if (!el) continue;
          if (el.type === "checkbox") {
            el.checked = Boolean(val);
            const toggleFn = typeof window !== "undefined" ? window[`toggle${prop.replace("opt", "")}Config`] : null;
            if (typeof toggleFn === "function") toggleFn(el.checked);
          } else {
            el.value = String(val);
            el.dataset.customized = "true";
          }
        }
        if (typeof window !== "undefined" && typeof window.updateTrackItemRows === "function") {
          const keys = [
            "loseClothing",
            "gainClothing",
            "pickWhoLosesClothing",
            "rightLosesClothing",
            "leftLosesClothing",
            "removeClothingChoice",
            "touchBreast",
            "lickBreast",
            "suckBreast",
            "touchGenitals",
            "lickGenitals",
            "suckGenitals",
            "fingerGenitals"
          ];
          keys.forEach((k) => window.updateTrackItemRows(k));
        }
      }
      if (context.settings || typeof window !== "undefined" && window.settings) {
        const s = context.settings || window.settings;
        Object.assign(s, cfg);
        s.adultPreset = presetKey;
      }
      if (typeof window !== "undefined" && typeof window.saveBrandSettings === "function" && typeof window.readBrandSettings === "function") {
        window.saveBrandSettings("adult", window.readBrandSettings("adult"));
      }
      return true;
    }
    static getCustomLayouts(storage = null) {
      const s = _AdultPresets.getStorage(storage);
      try {
        const raw = s.getItem(ADULT_CUSTOM_LAYOUTS_KEY);
        if (!raw) return [];
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.warn("[AdultPresets] Error loading custom layouts:", e);
        return [];
      }
    }
    static saveCustomLayout(layout, storage = null, isImport = false) {
      if (!layout || typeof layout !== "object") throw new Error("Invalid layout object");
      const s = _AdultPresets.getStorage(storage);
      const layouts = _AdultPresets.getCustomLayouts(s);
      const now = (/* @__PURE__ */ new Date()).toISOString();
      const sanitized = LayoutSanitizer.sanitizeLayout(layout, "adult", {
        regenerateId: isImport || !layout.id
      });
      sanitized.metrics = _AdultPresets.computeTrackMetrics(sanitized.items, sanitized.target);
      let targetLayout = null;
      if (!isImport && layout.id) {
        const idx = layouts.findIndex((l) => l.id === sanitized.id);
        if (idx !== -1) {
          targetLayout = {
            ...layouts[idx],
            ...sanitized,
            updatedAt: now
          };
          layouts[idx] = targetLayout;
        }
      }
      if (!targetLayout) {
        targetLayout = sanitized;
        layouts.unshift(targetLayout);
      }
      const capped = LayoutSanitizer.enforceStorageQuota(layouts, MAX_CUSTOM_LAYOUTS);
      if (s) {
        try {
          s.setItem(ADULT_CUSTOM_LAYOUTS_KEY, JSON.stringify(capped));
        } catch (e) {
          console.error("[AdultPresets] Failed to save custom layouts:", e);
          throw new Error("Failed to save layout to storage: Quota exceeded or storage unavailable.");
        }
      }
      return targetLayout;
    }
    static renameCustomLayout(layoutId, newName, storage = null) {
      if (!layoutId || !newName || !newName.trim()) return false;
      const s = _AdultPresets.getStorage(storage);
      const layouts = _AdultPresets.getCustomLayouts(s);
      const layout = layouts.find((l) => l.id === layoutId);
      if (!layout) return false;
      layout.name = newName.trim();
      layout.updatedAt = (/* @__PURE__ */ new Date()).toISOString();
      s.setItem(ADULT_CUSTOM_LAYOUTS_KEY, JSON.stringify(layouts));
      return true;
    }
    static deleteCustomLayout(layoutId, storage = null) {
      if (!layoutId) return false;
      const s = _AdultPresets.getStorage(storage);
      const layouts = _AdultPresets.getCustomLayouts(s);
      const filtered = layouts.filter((l) => l.id !== layoutId);
      if (filtered.length === layouts.length) return false;
      s.setItem(ADULT_CUSTOM_LAYOUTS_KEY, JSON.stringify(filtered));
      return true;
    }
    static duplicateCustomLayout(layoutId, storage = null) {
      if (!layoutId) return null;
      const s = _AdultPresets.getStorage(storage);
      const layouts = _AdultPresets.getCustomLayouts(s);
      const original = layouts.find((l) => l.id === layoutId);
      if (!original) return null;
      const copy = {
        ...original,
        id: void 0,
        name: `${original.name} (Copy)`
      };
      return _AdultPresets.saveCustomLayout(copy, s);
    }
    static exportLayout(layoutId = null, storage = null) {
      const s = _AdultPresets.getStorage(storage);
      const layouts = _AdultPresets.getCustomLayouts(s);
      if (layoutId) {
        const single = layouts.find((l) => l.id === layoutId);
        const prepared2 = LayoutSanitizer.prepareForExport(single || null);
        return JSON.stringify(prepared2, null, 2);
      }
      const prepared = LayoutSanitizer.prepareForExport(layouts);
      return JSON.stringify(prepared, null, 2);
    }
    static importLayout(jsonStr, storage = null) {
      const parsed = LayoutSanitizer.parseJsonSafely(jsonStr);
      const s = _AdultPresets.getStorage(storage);
      if (Array.isArray(parsed)) {
        if (parsed.length > 20) {
          throw new Error("Cannot import more than 20 layouts at once.");
        }
        let lastSaved = null;
        for (const item of parsed) {
          lastSaved = _AdultPresets.saveCustomLayout(item, s, true);
        }
        return lastSaved;
      }
      return _AdultPresets.saveCustomLayout(parsed, s, true);
    }
  };
  if (typeof window !== "undefined") {
    window.AdultPresets = AdultPresets;
    window.ADULT_PRESETS_121 = ADULT_PRESETS_121;
  }

  // src/variants/AdultSettings.js
  var ADULT_OPTIONS_LIST = Object.freeze([
    // Group 1: Strip Themed (2 spaces each by default = 12 spaces)
    { key: "loseClothing", chkId: "optLoseClothing", countId: "optLoseClothingCount", pegsId: "optLoseClothingPegs", prefix: "optLoseClothing", name: "You Lose Clothing", actionText: "Player loses an article of clothing", group: "strip", icon: "\u{1F459}", color: "#f43f5e", defaultHoles: [10, 70, 10, 70], timed: false },
    { key: "gainClothing", chkId: "optGainClothing", countId: "optGainClothingCount", pegsId: "optGainClothingPegs", prefix: "optGainClothing", name: "You Gain Clothing", actionText: "Player gains an article of clothing back", group: "strip", icon: "\u{1F9E5}", color: "#10b981", defaultHoles: [20, 80, 20, 80], timed: false },
    { key: "pickWhoLosesClothing", chkId: "optPickWhoLosesClothing", countId: "optPickWhoLosesClothingCount", pegsId: "optPickWhoLosesClothingPegs", prefix: "optPickWhoLosesClothing", name: "Pick Who Strips", actionText: "Player picks who loses an article of clothing", group: "strip", icon: "\u{1F3AF}", color: "#ec4899", defaultHoles: [30, 90, 30, 90], timed: false },
    { key: "rightLosesClothing", chkId: "optRightLosesClothing", countId: "optRightLosesClothingCount", pegsId: "optRightLosesClothingPegs", prefix: "optRightLosesClothing", name: "Right Neighbor Strips", actionText: "Person to right loses an article of clothing", group: "strip", icon: "\u{1F449}", color: "#3b82f6", defaultHoles: [40, 100, 40, 100], timed: false },
    { key: "leftLosesClothing", chkId: "optLeftLosesClothing", countId: "optLeftLosesClothingCount", pegsId: "optLeftLosesClothingPegs", prefix: "optLeftLosesClothing", name: "Left Neighbor Strips", actionText: "Person to left loses an article of clothing", group: "strip", icon: "\u{1F448}", color: "#8b5cf6", defaultHoles: [50, 110, 50, 110], timed: false },
    { key: "removeClothingChoice", chkId: "optRemoveClothingChoice", countId: "optRemoveClothingChoiceCount", pegsId: "optRemoveClothingChoicePegs", prefix: "optRemoveClothingChoice", name: "Remove Clothing Choice", actionText: "Remove an article of clothing off person of your choice", group: "strip", icon: "\u2702\uFE0F", color: "#e11d48", defaultHoles: [60, 120, 60, 120], timed: false },
    // Group 2: Adult Themed (Timed Challenges - 1 space each by default = 12 spaces)
    { key: "touchBreast", chkId: "optTouchBreast", countId: "optTouchBreastCount", pegsId: "optTouchBreastPegs", prefix: "optTouchBreast", name: "Touch Breast", actionText: "Touch breast", group: "adult", icon: "\u{1F48B}", color: "#f43f5e", defaultHoles: [5, 45, 75, 105], timed: true },
    { key: "lickBreast", chkId: "optLickBreast", countId: "optLickBreastCount", pegsId: "optLickBreastPegs", prefix: "optLickBreast", name: "Lick Breast", actionText: "Lick breast", group: "adult", icon: "\u{1F445}", color: "#ec4899", defaultHoles: [15, 50, 80, 110], timed: true },
    { key: "suckBreast", chkId: "optSuckBreast", countId: "optSuckBreastCount", pegsId: "optSuckBreastPegs", prefix: "optSuckBreast", name: "Suck Breast", actionText: "Suck breast", group: "adult", icon: "\u{1F444}", color: "#d946ef", defaultHoles: [25, 55, 85, 115], timed: true },
    { key: "touchGenitals", chkId: "optTouchGenitals", countId: "optTouchGenitalsCount", pegsId: "optTouchGenitalsPegs", prefix: "optTouchGenitals", name: "Touch Genitals", actionText: "Touch genitals", group: "adult", icon: "\u2728", color: "#a855f7", defaultHoles: [35, 40, 70, 100], timed: true },
    { key: "lickGenitals", chkId: "optLickGenitals", countId: "optLickGenitalsCount", pegsId: "optLickGenitalsPegs", prefix: "optLickGenitals", name: "Lick Genitals", actionText: "Lick genitals", group: "adult", icon: "\u{1F445}", color: "#f43f5e", defaultHoles: [45, 60, 90, 120], timed: true },
    { key: "suckGenitals", chkId: "optSuckGenitals", countId: "optSuckGenitalsCount", pegsId: "optSuckGenitalsPegs", prefix: "optSuckGenitals", name: "Suck Genitals", actionText: "Suck genitals", group: "adult", icon: "\u{1F444}", color: "#ec4899", defaultHoles: [55, 65, 95, 115], timed: true },
    { key: "fingerGenitals", chkId: "optFingerGenitals", countId: "optFingerGenitalsCount", pegsId: "optFingerGenitalsPegs", prefix: "optFingerGenitals", name: "Finger Genitals", actionText: "Finger genitals", group: "adult", icon: "\u{1F449}", color: "#f59e0b", defaultHoles: [65, 45, 75, 105], timed: true },
    { key: "genitalIntercourse", chkId: "optGenitalIntercourse", countId: "optGenitalIntercourseCount", pegsId: "optGenitalIntercoursePegs", prefix: "optGenitalIntercourse", name: "Genital Intercourse", actionText: "Genital intercourse", group: "adult", icon: "\u{1F525}", color: "#ef4444", defaultHoles: [75, 55, 85, 115], timed: true },
    { key: "touchAnus", chkId: "optTouchAnus", countId: "optTouchAnusCount", pegsId: "optTouchAnusPegs", prefix: "optTouchAnus", name: "Touch Anus", actionText: "Touch anus", group: "adult", icon: "\u{1F351}", color: "#8b5cf6", defaultHoles: [85, 50, 80, 110], timed: true },
    { key: "lickAnus", chkId: "optLickAnus", countId: "optLickAnusCount", pegsId: "optLickAnusPegs", prefix: "optLickAnus", name: "Lick Anus", actionText: "Lick anus", group: "adult", icon: "\u{1F445}", color: "#ec4899", defaultHoles: [95, 55, 85, 115], timed: true },
    { key: "fingerAnus", chkId: "optFingerAnus", countId: "optFingerAnusCount", pegsId: "optFingerAnusPegs", prefix: "optFingerAnus", name: "Finger Anus", actionText: "Finger anus", group: "adult", icon: "\u{1F449}", color: "#f59e0b", defaultHoles: [105, 60, 90, 120], timed: true },
    { key: "analIntercourse", chkId: "optAnalIntercourse", countId: "optAnalIntercourseCount", pegsId: "optAnalIntercoursePegs", prefix: "optAnalIntercourse", name: "Anal Intercourse", actionText: "Anal intercourse", group: "adult", icon: "\u{1F525}", color: "#ef4444", defaultHoles: [115, 65, 95, 115], timed: true }
  ]);
  var AdultSettings = class _AdultSettings {
    static getOptionsList() {
      return ADULT_OPTIONS_LIST;
    }
    static getDefaultSettings() {
      const cfg = {
        target: 121,
        goal: "high",
        theme: "passion"
      };
      ADULT_OPTIONS_LIST.forEach((opt) => {
        const isStrip = opt.group === "strip";
        const defaultCount = isStrip ? 2 : 1;
        cfg[opt.chkId] = true;
        cfg[opt.key + "Count"] = defaultCount;
        cfg[opt.key + "Pegs"] = 1;
        cfg[opt.key + "Holes"] = [...opt.defaultHoles];
      });
      return cfg;
    }
    static getOptionDef(key) {
      return ADULT_OPTIONS_LIST.find((o) => o.key === key) || null;
    }
    static toggleOptionConfig(optKey, checked, skipSave = false, options = {}) {
      if (typeof document !== "undefined") {
        const panel = document.getElementById(optKey + "Config");
        if (panel) panel.style.display = checked ? "flex" : "none";
      }
      _AdultSettings.updateOptionRows(optKey, skipSave, options);
      for (let i = 1; i <= 4; i++) {
        _AdultSettings.onOptionFieldChange(optKey, i, true, options);
      }
      if (checked) {
        if (typeof options.enforceClashNoOverlap === "function") options.enforceClashNoOverlap();
      } else {
        if (typeof options.updateAllClashDropdowns === "function") options.updateAllClashDropdowns();
      }
      if (!skipSave && typeof options.saveSettings === "function") {
        options.saveSettings();
      }
    }
    static updateOptionRows(optKey, skipSave = false, options = {}) {
      const def = _AdultSettings.getOptionDef(optKey);
      if (!def) return;
      if (typeof document !== "undefined") {
        const countEl = document.getElementById(def.countId);
        const count = countEl ? parseInt(countEl.value, 10) : def.group === "strip" ? 2 : 1;
        for (let i = 1; i <= 4; i++) {
          const row = document.getElementById(optKey + "Row" + i);
          if (row) row.style.display = i <= count ? "flex" : "none";
        }
      }
      if (typeof options.enforceClashNoOverlap === "function") options.enforceClashNoOverlap();
      if (!skipSave && typeof options.saveSettings === "function") {
        options.saveSettings();
      }
    }
    static onOptionPegsChange(optKey, options = {}) {
      const def = _AdultSettings.getOptionDef(optKey);
      if (!def) return;
      let pegs = 1;
      if (typeof document !== "undefined") {
        const pegsEl = document.getElementById(def.pegsId);
        pegs = pegsEl ? parseInt(pegsEl.value, 10) : 1;
        const sub = document.getElementById(optKey + "Sub");
        if (sub) {
          const pegStr = pegs === 1 ? "1 peg" : `${pegs} pegs`;
          sub.textContent = `${pegStr} \xB7 ${def.actionText}`;
        }
      }
      if (options.settings) {
        options.settings[optKey + "Pegs"] = pegs;
      }
      for (let i = 1; i <= 4; i++) {
        _AdultSettings.onOptionFieldChange(optKey, i, true, options);
      }
      if (typeof options.enforceClashNoOverlap === "function") options.enforceClashNoOverlap();
      if (typeof options.syncAllClashPlacementButtons === "function") options.syncAllClashPlacementButtons();
      if (typeof options.saveSettings === "function") {
        options.saveSettings();
      }
    }
    static onOptionFieldChange(optKey, idx, skipSave = false, options = {}) {
      const def = _AdultSettings.getOptionDef(optKey);
      if (!def) return;
      const selectId = `${def.prefix}${idx}Hole`;
      if (typeof options.enforceClashNoOverlap === "function") options.enforceClashNoOverlap(selectId);
      if (typeof document !== "undefined") {
        const hEl = document.getElementById(selectId);
        const bEl = document.getElementById(`${optKey}Badge${idx}`);
        const pegsEl = document.getElementById(def.pegsId);
        const pegs = parseInt(pegsEl?.value || options.settings && options.settings[optKey + "Pegs"] || 1, 10);
        if (hEl && bEl) {
          const h = parseInt(hEl.value, 10) || def.defaultHoles[idx - 1] || 15;
          const streetName3 = typeof options.getStreetOrTurnName === "function" ? options.getStreetOrTurnName(h) : "";
          if (pegs > 1) {
            const endH = Math.min(121, h + pegs - 1);
            bEl.textContent = `${streetName3 ? streetName3 + " \xB7 " : ""}Holes ${h}\u2013${endH} (${pegs} Pegs)`;
          } else {
            bEl.textContent = `${streetName3 ? streetName3 + " \xB7 " : ""}Hole ${h}`;
          }
        }
      }
      if (!skipSave && typeof options.saveSettings === "function") {
        options.saveSettings();
      }
    }
    static getOptionConfigs(optKey, settings3 = {}) {
      const def = _AdultSettings.getOptionDef(optKey);
      if (!def || !settings3[def.chkId]) return [];
      const count = Math.min(4, Math.max(1, settings3[optKey + "Count"] != null ? parseInt(settings3[optKey + "Count"], 10) : def.group === "strip" ? 2 : 1));
      const pegs = Math.min(5, Math.max(1, parseInt(settings3[optKey + "Pegs"], 10) || 1));
      const holes = settings3[optKey + "Holes"] || def.defaultHoles;
      const list = [];
      for (let i = 0; i < count; i++) {
        const h = holes[i] != null ? holes[i] : def.defaultHoles[i];
        list.push({
          id: i + 1,
          hole: h,
          start: h,
          end: h + pegs - 1,
          pegs,
          type: optKey,
          label: `${def.name} ${i + 1}`,
          item: def
        });
      }
      return list;
    }
    static uncheckAll() {
      if (typeof document === "undefined") return;
      ADULT_OPTIONS_LIST.forEach((opt) => {
        const chk = document.getElementById(opt.chkId);
        if (chk) chk.checked = false;
        const panel = document.getElementById(opt.key + "Config");
        if (panel) panel.style.display = "none";
      });
    }
  };

  // src/variants/ClashPlacementModal.js
  function getJumpTriggerLength(jumpIdx, overrideStart = null) {
    if (typeof document === "undefined") return 1;
    const dEl = document.getElementById(`optJump${jumpIdx}Dest`);
    const dVal = dEl ? parseInt(dEl.value, 10) : 0;
    let sVal = overrideStart;
    if (sVal == null) {
      const sEl = document.getElementById(`optJump${jumpIdx}Start`);
      sVal = sEl ? parseInt(sEl.value, 10) : 0;
    }
    if (!isNaN(sVal) && !isNaN(dVal) && dVal > 0 && sVal > 0) {
      return dVal > sVal ? 1 : 3;
    }
    return 1;
  }
  function buildClashItemMetadata(settings3 = null) {
    const meta = {
      optNoPassingLane1Start: { name: "No Passing Lane 1", type: "noPassingLanes", icon: "\u{1F6AB}", color: "#ef4444", getLength: () => 5 },
      optNoPassingLane2Start: { name: "No Passing Lane 2", type: "noPassingLanes", icon: "\u{1F6AB}", color: "#ef4444", getLength: () => 5 },
      optNoPassingLane3Start: { name: "No Passing Lane 3", type: "noPassingLanes", icon: "\u{1F6AB}", color: "#ef4444", getLength: () => 5 },
      optNoPassingLane4Start: { name: "No Passing Lane 4", type: "noPassingLanes", icon: "\u{1F6AB}", color: "#ef4444", getLength: () => 5 },
      optJump1Start: { name: "Jump 1 Trigger", type: "jump", icon: "\u26A1", color: "#3b82f6", getLength: (h) => getJumpTriggerLength(1, h) },
      optJump1Dest: { name: "Jump 1 Destination", type: "jumpDest", icon: "\u{1F3AF}", color: "#0ea5e9", getLength: () => 1 },
      optJump2Start: { name: "Jump 2 Trigger", type: "jump", icon: "\u26A1", color: "#3b82f6", getLength: (h) => getJumpTriggerLength(2, h) },
      optJump2Dest: { name: "Jump 2 Destination", type: "jumpDest", icon: "\u{1F3AF}", color: "#0ea5e9", getLength: () => 1 },
      optJump3Start: { name: "Jump 3 Trigger", type: "jump", icon: "\u26A1", color: "#3b82f6", getLength: (h) => getJumpTriggerLength(3, h) },
      optJump3Dest: { name: "Jump 3 Destination", type: "jumpDest", icon: "\u{1F3AF}", color: "#0ea5e9", getLength: () => 1 },
      optJump4Start: { name: "Jump 4 Trigger", type: "jump", icon: "\u26A1", color: "#3b82f6", getLength: (h) => getJumpTriggerLength(4, h) },
      optJump4Dest: { name: "Jump 4 Destination", type: "jumpDest", icon: "\u{1F3AF}", color: "#0ea5e9", getLength: () => 1 },
      optJump5Start: { name: "Jump 5 Trigger", type: "jump", icon: "\u26A1", color: "#3b82f6", getLength: (h) => getJumpTriggerLength(5, h) },
      optJump5Dest: { name: "Jump 5 Destination", type: "jumpDest", icon: "\u{1F3AF}", color: "#0ea5e9", getLength: () => 1 },
      optJump6Start: { name: "Jump 6 Trigger", type: "jump", icon: "\u26A1", color: "#3b82f6", getLength: (h) => getJumpTriggerLength(6, h) },
      optJump6Dest: { name: "Jump 6 Destination", type: "jumpDest", icon: "\u{1F3AF}", color: "#0ea5e9", getLength: () => 1 },
      optJump7Start: { name: "Jump 7 Trigger", type: "jump", icon: "\u26A1", color: "#3b82f6", getLength: (h) => getJumpTriggerLength(7, h) },
      optJump7Dest: { name: "Jump 7 Destination", type: "jumpDest", icon: "\u{1F3AF}", color: "#0ea5e9", getLength: () => 1 },
      optJump8Start: { name: "Jump 8 Trigger", type: "jump", icon: "\u26A1", color: "#3b82f6", getLength: (h) => getJumpTriggerLength(8, h) },
      optJump8Dest: { name: "Jump 8 Destination", type: "jumpDest", icon: "\u{1F3AF}", color: "#0ea5e9", getLength: () => 1 },
      optJail1Hole: { name: "Jail 1", type: "jail", icon: "\u{1F512}", color: "#94a3b8", getLength: () => 1 },
      optJail2Hole: { name: "Jail 2", type: "jail", icon: "\u{1F512}", color: "#94a3b8", getLength: () => 1 },
      optBar1Hole: { name: "The Bar 1", type: "bar", icon: "\u{1F378}", color: "#f59e0b", getLength: () => 1 },
      optBar2Hole: { name: "The Bar 2", type: "bar", icon: "\u{1F378}", color: "#f59e0b", getLength: () => 1 },
      optTimeout1Hole: { name: "Timeout 1", type: "timeout", icon: "\u23F3", color: "#8b5cf6", getLength: () => 1 },
      optTimeout2Hole: { name: "Timeout 2", type: "timeout", icon: "\u23F3", color: "#8b5cf6", getLength: () => 1 },
      optDetour1Hole: { name: "Detour 1", type: "detour", icon: "\u{1F500}", color: "#06b6d4", getLength: () => 1 },
      optDetour2Hole: { name: "Detour 2", type: "detour", icon: "\u{1F500}", color: "#06b6d4", getLength: () => 1 },
      optRoundAbout1Hole: { name: "Round About 1", type: "roundAbout", icon: "\u{1F504}", color: "#10b981", getLength: () => 1 },
      optRoundAbout2Hole: { name: "Round About 2", type: "roundAbout", icon: "\u{1F504}", color: "#10b981", getLength: () => 1 },
      optSigns1Hole: { name: "Sign Block 1", type: "signs", icon: "\u{1FAA7}", color: "#ec4899", getLength: () => {
        const sz = typeof document !== "undefined" ? document.getElementById("optSigns1Size") : null;
        return sz && parseInt(sz.value, 10) === 4 ? 5 : 3;
      } },
      optSigns2Hole: { name: "Sign Block 2", type: "signs", icon: "\u{1FAA7}", color: "#ec4899", getLength: () => {
        const sz = typeof document !== "undefined" ? document.getElementById("optSigns2Size") : null;
        return sz && parseInt(sz.value, 10) === 4 ? 5 : 3;
      } },
      optSigns3Hole: { name: "Sign Block 3", type: "signs", icon: "\u{1FAA7}", color: "#ec4899", getLength: () => {
        const sz = typeof document !== "undefined" ? document.getElementById("optSigns3Size") : null;
        return sz && parseInt(sz.value, 10) === 4 ? 5 : 3;
      } },
      optSigns4Hole: { name: "Sign Block 4", type: "signs", icon: "\u{1FAA7}", color: "#ec4899", getLength: () => {
        const sz = typeof document !== "undefined" ? document.getElementById("optSigns4Size") : null;
        return sz && parseInt(sz.value, 10) === 4 ? 5 : 3;
      } },
      optStopSign1Hole: { name: "Stop Sign 1", type: "stopSign", icon: "\u{1F6D1}", color: "#ef4444", getLength: () => 1 },
      optStopSign2Hole: { name: "Stop Sign 2", type: "stopSign", icon: "\u{1F6D1}", color: "#ef4444", getLength: () => 1 },
      optStopSign3Hole: { name: "Stop Sign 3", type: "stopSign", icon: "\u{1F6D1}", color: "#ef4444", getLength: () => 1 },
      optStopSign4Hole: { name: "Stop Sign 4", type: "stopSign", icon: "\u{1F6D1}", color: "#ef4444", getLength: () => 1 },
      optStopSign5Hole: { name: "Stop Sign 5", type: "stopSign", icon: "\u{1F6D1}", color: "#ef4444", getLength: () => 1 },
      optStopSign6Hole: { name: "Stop Sign 6", type: "stopSign", icon: "\u{1F6D1}", color: "#ef4444", getLength: () => 1 },
      optStopSign7Hole: { name: "Stop Sign 7", type: "stopSign", icon: "\u{1F6D1}", color: "#ef4444", getLength: () => 1 },
      optStopSign8Hole: { name: "Stop Sign 8", type: "stopSign", icon: "\u{1F6D1}", color: "#ef4444", getLength: () => 1 },
      optDice1Hole: { name: "Dice 1", type: "dice", icon: "\u{1F3B2}", color: "#a855f7", getLength: () => 1 },
      optDice2Hole: { name: "Dice 2", type: "dice", icon: "\u{1F3B2}", color: "#a855f7", getLength: () => 1 },
      optDice3Hole: { name: "Dice 3", type: "dice", icon: "\u{1F3B2}", color: "#a855f7", getLength: () => 1 },
      optDice4Hole: { name: "Dice 4", type: "dice", icon: "\u{1F3B2}", color: "#a855f7", getLength: () => 1 },
      optWheel1Hole: { name: "Spinning Wheel 1", type: "spinningWheel", icon: "\u{1F3A1}", color: "#ec4899", getLength: () => 1 },
      optWheel2Hole: { name: "Spinning Wheel 2", type: "spinningWheel", icon: "\u{1F3A1}", color: "#ec4899", getLength: () => 1 },
      optWheel3Hole: { name: "Spinning Wheel 3", type: "spinningWheel", icon: "\u{1F3A1}", color: "#ec4899", getLength: () => 1 },
      optWheel4Hole: { name: "Spinning Wheel 4", type: "spinningWheel", icon: "\u{1F3A1}", color: "#ec4899", getLength: () => 1 },
      optSkunkMarkerHole: { name: "Skunk Marker", type: "skunkMarker", icon: "\u{1F9A8}", color: "#64748b", getLength: () => 1, allowsOverlap: true },
      optDoubleSkunkMarkerHole: { name: "Double Skunk Marker", type: "doubleSkunkMarker", icon: "\u{1F9A8}", color: "#475569", getLength: () => 1, allowsOverlap: true },
      optYouDrink1Hole: { name: "You Drink 1", type: "youDrink", icon: "\u{1F37A}", color: "#f59e0b", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optYouDrinkPegs")?.value || settings3 && settings3.youDrinkPegs || 1, 10) },
      optYouDrink2Hole: { name: "You Drink 2", type: "youDrink", icon: "\u{1F37A}", color: "#f59e0b", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optYouDrinkPegs")?.value || settings3 && settings3.youDrinkPegs || 1, 10) },
      optYouDrink3Hole: { name: "You Drink 3", type: "youDrink", icon: "\u{1F37A}", color: "#f59e0b", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optYouDrinkPegs")?.value || settings3 && settings3.youDrinkPegs || 1, 10) },
      optYouDrink4Hole: { name: "You Drink 4", type: "youDrink", icon: "\u{1F37A}", color: "#f59e0b", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optYouDrinkPegs")?.value || settings3 && settings3.youDrinkPegs || 1, 10) },
      optGuysDrink1Hole: { name: "Guys Drink 1", type: "guysDrink", icon: "\u{1F37B}", color: "#06b6d4", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optGuysDrinkPegs")?.value || settings3 && settings3.guysDrinkPegs || 1, 10) },
      optGuysDrink2Hole: { name: "Guys Drink 2", type: "guysDrink", icon: "\u{1F37B}", color: "#06b6d4", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optGuysDrinkPegs")?.value || settings3 && settings3.guysDrinkPegs || 1, 10) },
      optGuysDrink3Hole: { name: "Guys Drink 3", type: "guysDrink", icon: "\u{1F37B}", color: "#06b6d4", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optGuysDrinkPegs")?.value || settings3 && settings3.guysDrinkPegs || 1, 10) },
      optGuysDrink4Hole: { name: "Guys Drink 4", type: "guysDrink", icon: "\u{1F37B}", color: "#06b6d4", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optGuysDrinkPegs")?.value || settings3 && settings3.guysDrinkPegs || 1, 10) },
      optGalsDrink1Hole: { name: "Gals Drink 1", type: "galsDrink", icon: "\u{1F377}", color: "#ec4899", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optGalsDrinkPegs")?.value || settings3 && settings3.galsDrinkPegs || 1, 10) },
      optGalsDrink2Hole: { name: "Gals Drink 2", type: "galsDrink", icon: "\u{1F377}", color: "#ec4899", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optGalsDrinkPegs")?.value || settings3 && settings3.galsDrinkPegs || 1, 10) },
      optGalsDrink3Hole: { name: "Gals Drink 3", type: "galsDrink", icon: "\u{1F377}", color: "#ec4899", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optGalsDrinkPegs")?.value || settings3 && settings3.galsDrinkPegs || 1, 10) },
      optGalsDrink4Hole: { name: "Gals Drink 4", type: "galsDrink", icon: "\u{1F377}", color: "#ec4899", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optGalsDrinkPegs")?.value || settings3 && settings3.galsDrinkPegs || 1, 10) },
      optLeftDrink1Hole: { name: "Left Drinks 1", type: "leftDrink", icon: "\u{1F448}", color: "#8b5cf6", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optLeftDrinkPegs")?.value || settings3 && settings3.leftDrinkPegs || 1, 10) },
      optLeftDrink2Hole: { name: "Left Drinks 2", type: "leftDrink", icon: "\u{1F448}", color: "#8b5cf6", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optLeftDrinkPegs")?.value || settings3 && settings3.leftDrinkPegs || 1, 10) },
      optLeftDrink3Hole: { name: "Left Drinks 3", type: "leftDrink", icon: "\u{1F448}", color: "#8b5cf6", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optLeftDrinkPegs")?.value || settings3 && settings3.leftDrinkPegs || 1, 10) },
      optLeftDrink4Hole: { name: "Left Drinks 4", type: "leftDrink", icon: "\u{1F448}", color: "#8b5cf6", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optLeftDrinkPegs")?.value || settings3 && settings3.leftDrinkPegs || 1, 10) },
      optRightDrink1Hole: { name: "Right Drinks 1", type: "rightDrink", icon: "\u{1F449}", color: "#3b82f6", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optRightDrinkPegs")?.value || settings3 && settings3.rightDrinkPegs || 1, 10) },
      optRightDrink2Hole: { name: "Right Drinks 2", type: "rightDrink", icon: "\u{1F449}", color: "#3b82f6", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optRightDrinkPegs")?.value || settings3 && settings3.rightDrinkPegs || 1, 10) },
      optRightDrink3Hole: { name: "Right Drinks 3", type: "rightDrink", icon: "\u{1F449}", color: "#3b82f6", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optRightDrinkPegs")?.value || settings3 && settings3.rightDrinkPegs || 1, 10) },
      optRightDrink4Hole: { name: "Right Drinks 4", type: "rightDrink", icon: "\u{1F449}", color: "#3b82f6", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optRightDrinkPegs")?.value || settings3 && settings3.rightDrinkPegs || 1, 10) },
      optEveryoneDrink1Hole: { name: "Everyone Drinks 1", type: "everyoneDrink", icon: "\u{1F942}", color: "#10b981", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optEveryoneDrinkPegs")?.value || settings3 && settings3.everyoneDrinkPegs || 1, 10) },
      optEveryoneDrink2Hole: { name: "Everyone Drinks 2", type: "everyoneDrink", icon: "\u{1F942}", color: "#10b981", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optEveryoneDrinkPegs")?.value || settings3 && settings3.everyoneDrinkPegs || 1, 10) },
      optEveryoneDrink3Hole: { name: "Everyone Drinks 3", type: "everyoneDrink", icon: "\u{1F942}", color: "#10b981", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optEveryoneDrinkPegs")?.value || settings3 && settings3.everyoneDrinkPegs || 1, 10) },
      optEveryoneDrink4Hole: { name: "Everyone Drinks 4", type: "everyoneDrink", icon: "\u{1F942}", color: "#10b981", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optEveryoneDrinkPegs")?.value || settings3 && settings3.everyoneDrinkPegs || 1, 10) },
      optEveryoneButYouDrink1Hole: { name: "Everyone But You 1", type: "everyoneButYouDrink", icon: "\u{1F389}", color: "#f97316", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optEveryoneButYouDrinkPegs")?.value || settings3 && settings3.everyoneButYouDrinkPegs || 1, 10) },
      optEveryoneButYouDrink2Hole: { name: "Everyone But You 2", type: "everyoneButYouDrink", icon: "\u{1F389}", color: "#f97316", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optEveryoneButYouDrinkPegs")?.value || settings3 && settings3.everyoneButYouDrinkPegs || 1, 10) },
      optEveryoneButYouDrink3Hole: { name: "Everyone But You 3", type: "everyoneButYouDrink", icon: "\u{1F389}", color: "#f97316", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optEveryoneButYouDrinkPegs")?.value || settings3 && settings3.everyoneButYouDrinkPegs || 1, 10) },
      optEveryoneButYouDrink4Hole: { name: "Everyone But You 4", type: "everyoneButYouDrink", icon: "\u{1F389}", color: "#f97316", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optEveryoneButYouDrinkPegs")?.value || settings3 && settings3.everyoneButYouDrinkPegs || 1, 10) },
      optPickWhoDrinks1Hole: { name: "Pick Who Drinks 1", type: "pickWhoDrinks", icon: "\u{1F3AF}", color: "#e11d48", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optPickWhoDrinksPegs")?.value || settings3 && settings3.pickWhoDrinksPegs || 1, 10) },
      optPickWhoDrinks2Hole: { name: "Pick Who Drinks 2", type: "pickWhoDrinks", icon: "\u{1F3AF}", color: "#e11d48", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optPickWhoDrinksPegs")?.value || settings3 && settings3.pickWhoDrinksPegs || 1, 10) },
      optPickWhoDrinks3Hole: { name: "Pick Who Drinks 3", type: "pickWhoDrinks", icon: "\u{1F3AF}", color: "#e11d48", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optPickWhoDrinksPegs")?.value || settings3 && settings3.pickWhoDrinksPegs || 1, 10) },
      optPickWhoDrinks4Hole: { name: "Pick Who Drinks 4", type: "pickWhoDrinks", icon: "\u{1F3AF}", color: "#e11d48", getLength: () => parseInt(typeof document !== "undefined" && document.getElementById("optPickWhoDrinksPegs")?.value || settings3 && settings3.pickWhoDrinksPegs || 1, 10) }
    };
    if (typeof ADULT_OPTIONS_LIST !== "undefined" && Array.isArray(ADULT_OPTIONS_LIST)) {
      ADULT_OPTIONS_LIST.forEach((opt) => {
        for (let i = 1; i <= 4; i++) {
          const id = `${opt.prefix}${i}Hole`;
          meta[id] = {
            name: `${opt.name} ${i}`,
            type: opt.key,
            icon: opt.icon,
            color: opt.color,
            getLength: () => parseInt(typeof document !== "undefined" && document.getElementById(opt.pegsId)?.value || settings3 && settings3[opt.key + "Pegs"] || 1, 10)
          };
        }
      });
    }
    return meta;
  }
  var ClashPlacementModal = class _ClashPlacementModal {
    static currentSelectId = null;
    static currentSelectedHole = null;
    static metadata = null;
    static getMetadata(settings3 = null) {
      if (!_ClashPlacementModal.metadata) {
        _ClashPlacementModal.metadata = buildClashItemMetadata(settings3);
      }
      return _ClashPlacementModal.metadata;
    }
    static initPlacementButtons(meta = null) {
      if (typeof document === "undefined") return;
      const itemMeta = meta || _ClashPlacementModal.getMetadata();
      for (const selectId of Object.keys(itemMeta)) {
        const sel = document.getElementById(selectId);
        if (!sel) continue;
        sel.classList.add("clash-select-hidden");
        let btn = document.getElementById(`btnPlace_${selectId}`);
        if (!btn) {
          btn = document.createElement("button");
          btn.type = "button";
          btn.id = `btnPlace_${selectId}`;
          btn.className = "clash-place-btn";
          btn.onclick = () => _ClashPlacementModal.open(selectId);
          sel.parentNode.insertBefore(btn, sel.nextSibling);
        }
        sel.addEventListener("change", () => {
          sel.dataset.customized = "true";
          _ClashPlacementModal.syncPlacementButton(selectId, itemMeta);
        });
      }
      _ClashPlacementModal.syncAllPlacementButtons(itemMeta);
    }
    static syncPlacementButton(selectId, meta = null) {
      if (typeof document === "undefined") return;
      const itemMeta = meta || _ClashPlacementModal.getMetadata();
      const sel = document.getElementById(selectId);
      const btn = document.getElementById(`btnPlace_${selectId}`);
      const item = itemMeta[selectId];
      if (!sel || !btn || !item) return;
      let val = parseInt(sel.value, 10);
      if (isNaN(val) && sel.options && sel.options.length > 0) {
        val = parseInt(sel.options[0].value, 10);
        sel.value = String(val);
      }
      if (isNaN(val)) return;
      const len = typeof item.getLength === "function" ? item.getLength(val) : 1;
      let label = `Hole ${val}`;
      if (len > 1) {
        label = `Holes ${val}\u2013${val + len - 1}`;
      }
      btn.innerHTML = `
      <span>${item.icon}</span>
      <span class="clash-place-val">${label}</span>
      <span class="clash-place-action">Choose \u2794</span>
    `;
    }
    static syncAllPlacementButtons(meta = null) {
      if (typeof document === "undefined") return;
      const itemMeta = meta || _ClashPlacementModal.getMetadata();
      for (const selectId of Object.keys(itemMeta)) {
        _ClashPlacementModal.syncPlacementButton(selectId, itemMeta);
      }
    }
    static getAllPlacedItems(excludeSelectId = null, meta = null) {
      if (typeof document === "undefined") return [];
      const itemMeta = meta || _ClashPlacementModal.getMetadata();
      const items = [];
      for (const [id, m] of Object.entries(itemMeta)) {
        if (id === excludeSelectId) continue;
        const sel = document.getElementById(id);
        if (!sel) continue;
        let isActive = true;
        if (id.startsWith("optNoPassingLane")) {
          const chk = document.getElementById("optNoPassingLanes");
          const cnt = parseInt(document.getElementById("optNoPassingLaneCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optNoPassingLane", "").replace("Start", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optJump")) {
          const chk = document.getElementById("optJump");
          const cnt = parseInt(document.getElementById("optJumpCount")?.value, 10) || 1;
          const match = id.match(/\d+/);
          const idx = match ? parseInt(match[0], 10) : 1;
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optJail")) {
          const chk = document.getElementById("optJail");
          const cnt = parseInt(document.getElementById("optJailCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optJail", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optBar")) {
          const chk = document.getElementById("optBar");
          const cnt = parseInt(document.getElementById("optBarCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optBar", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optTimeout")) {
          const chk = document.getElementById("optTimeout");
          const cnt = parseInt(document.getElementById("optTimeoutCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optTimeout", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optDetour")) {
          const chk = document.getElementById("optDetour");
          const cnt = parseInt(document.getElementById("optDetourCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optDetour", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optRoundAbout")) {
          const chk = document.getElementById("optRoundAbout");
          const cnt = parseInt(document.getElementById("optRoundAboutCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optRoundAbout", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optSigns")) {
          const chk = document.getElementById("optSigns");
          const cnt = parseInt(document.getElementById("optSignsCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optSigns", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optStopSign")) {
          const chk = document.getElementById("optStopSign");
          const cnt = parseInt(document.getElementById("optStopSignCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optStopSign", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optDice")) {
          const chk = document.getElementById("optDice");
          const cnt = parseInt(document.getElementById("optDiceCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optDice", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optWheel")) {
          const chk = document.getElementById("optWheel");
          const cnt = parseInt(document.getElementById("optWheelCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optWheel", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id === "optSkunkMarkerHole" || id === "optDoubleSkunkMarkerHole") {
          const chk = document.getElementById("optSkunkMarkers");
          isActive = chk && chk.checked;
        } else if (id.startsWith("optYouDrink")) {
          const chk = document.getElementById("optYouDrink");
          const cnt = parseInt(document.getElementById("optYouDrinkCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optYouDrink", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optGuysDrink")) {
          const chk = document.getElementById("optGuysDrink");
          const cnt = parseInt(document.getElementById("optGuysDrinkCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optGuysDrink", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optGalsDrink")) {
          const chk = document.getElementById("optGalsDrink");
          const cnt = parseInt(document.getElementById("optGalsDrinkCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optGalsDrink", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optLeftDrink")) {
          const chk = document.getElementById("optLeftDrink");
          const cnt = parseInt(document.getElementById("optLeftDrinkCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optLeftDrink", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optRightDrink")) {
          const chk = document.getElementById("optRightDrink");
          const cnt = parseInt(document.getElementById("optRightDrinkCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optRightDrink", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optEveryoneDrink")) {
          const chk = document.getElementById("optEveryoneDrink");
          const cnt = parseInt(document.getElementById("optEveryoneDrinkCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optEveryoneDrink", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optEveryoneButYouDrink")) {
          const chk = document.getElementById("optEveryoneButYouDrink");
          const cnt = parseInt(document.getElementById("optEveryoneButYouDrinkCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optEveryoneButYouDrink", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        } else if (id.startsWith("optPickWhoDrinks")) {
          const chk = document.getElementById("optPickWhoDrinks");
          const cnt = parseInt(document.getElementById("optPickWhoDrinksCount")?.value, 10) || 1;
          const idx = parseInt(id.replace("optPickWhoDrinks", "").replace("Hole", ""), 10);
          isActive = chk && chk.checked && idx <= cnt;
        }
        if (!isActive && typeof ADULT_OPTIONS_LIST !== "undefined" && Array.isArray(ADULT_OPTIONS_LIST)) {
          const adultOpt = ADULT_OPTIONS_LIST.find((o) => id.startsWith(o.prefix));
          if (adultOpt) {
            const chk = document.getElementById(adultOpt.chkId);
            const cnt = parseInt(document.getElementById(adultOpt.countId)?.value, 10) || 1;
            const idx = parseInt(id.replace(adultOpt.prefix, "").replace("Hole", ""), 10);
            isActive = chk && chk.checked && idx <= cnt;
          }
        }
        if (!isActive) continue;
        const val = parseInt(sel.value, 10);
        if (isNaN(val)) continue;
        const len = typeof m.getLength === "function" ? m.getLength(val) : 1;
        items.push({
          selectId: id,
          name: m.name,
          icon: m.icon,
          color: m.color,
          type: m.type,
          start: val,
          end: val + len - 1,
          length: len,
          allowsOverlap: Boolean(m.allowsOverlap)
        });
      }
      return items;
    }
    static open(selectId, options = {}) {
      if (typeof document === "undefined") return;
      const itemMeta = options.meta || _ClashPlacementModal.getMetadata();
      const meta = itemMeta[selectId];
      const sel = document.getElementById(selectId);
      if (!meta || !sel) return;
      _ClashPlacementModal.currentSelectId = selectId;
      _ClashPlacementModal.currentSelectedHole = parseInt(sel.value, 10) || 10;
      const overlay = document.getElementById("clashPlacementOverlay");
      if (!overlay) return;
      const iconEl = document.getElementById("clashModalIcon");
      const titleEl = document.getElementById("clashModalTitle");
      const subEl = document.getElementById("clashModalSub");
      const len = typeof meta.getLength === "function" ? meta.getLength(_ClashPlacementModal.currentSelectedHole) : 1;
      if (iconEl) iconEl.textContent = meta.icon;
      if (titleEl) titleEl.textContent = `Choose Placement: ${meta.name}`;
      if (subEl) {
        if (meta.allowsOverlap) {
          subEl.textContent = "Milestone marker. Can be placed anywhere on the track, including over other options.";
        } else if (selectId.startsWith("optJump") && selectId.endsWith("Start")) {
          subEl.textContent = "Forward jumps occupy 1 hole; backward jumps span 3 holes. Click any available group on the track. Occupied locations are locked.";
        } else {
          subEl.textContent = `Occupies ${len} hole${len > 1 ? "s" : ""}. Click any available group of holes on the track. Occupied locations are locked.`;
        }
      }
      overlay.style.display = "flex";
      _ClashPlacementModal.renderPlacementBoard(selectId, options);
    }
    static close() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("clashPlacementOverlay");
      if (overlay) overlay.style.display = "none";
      _ClashPlacementModal.currentSelectId = null;
      _ClashPlacementModal.currentSelectedHole = null;
    }
    static onConfirm(options = {}) {
      if (!_ClashPlacementModal.currentSelectId || _ClashPlacementModal.currentSelectedHole == null) return;
      const sel = document.getElementById(_ClashPlacementModal.currentSelectId);
      const selectId = _ClashPlacementModal.currentSelectId;
      const selectedHole = _ClashPlacementModal.currentSelectedHole;
      if (sel) {
        sel.dataset.customized = "true";
        sel.value = String(selectedHole);
        if (typeof sel.dispatchEvent === "function" && typeof Event !== "undefined") {
          sel.dispatchEvent(new Event("change"));
        }
        if (typeof window !== "undefined") {
          if (selectId.startsWith("optJail")) {
            const idx = parseInt(selectId.replace("optJail", "").replace("Hole", ""), 10);
            if (typeof window.onJailFieldChange === "function") window.onJailFieldChange(idx);
          } else if (selectId.startsWith("optBar")) {
            const idx = parseInt(selectId.replace("optBar", "").replace("Hole", ""), 10);
            if (typeof window.onBarFieldChange === "function") window.onBarFieldChange(idx);
          } else if (selectId.startsWith("optTimeout")) {
            const idx = parseInt(selectId.replace("optTimeout", "").replace("Hole", ""), 10);
            if (typeof window.onTimeoutFieldChange === "function") window.onTimeoutFieldChange(idx);
          } else if (selectId.startsWith("optDetour")) {
            const idx = parseInt(selectId.replace("optDetour", "").replace("Hole", ""), 10);
            if (typeof window.onDetourFieldChange === "function") window.onDetourFieldChange(idx);
          } else if (selectId.startsWith("optRoundAbout")) {
            const idx = parseInt(selectId.replace("optRoundAbout", "").replace("Hole", ""), 10);
            if (typeof window.onRoundAboutFieldChange === "function") window.onRoundAboutFieldChange(idx);
          } else if (selectId.startsWith("optSigns")) {
            const idx = parseInt(selectId.replace("optSigns", "").replace("Hole", ""), 10);
            if (typeof window.onSignsFieldChange === "function") window.onSignsFieldChange(idx);
          } else if (selectId.startsWith("optNoPassingLane")) {
            const idx = parseInt(selectId.replace("optNoPassingLane", "").replace("Start", ""), 10);
            if (typeof window.onNoPassingLaneFieldChange === "function") window.onNoPassingLaneFieldChange(idx);
          } else if (selectId.startsWith("optJump")) {
            const m = selectId.match(/\d+/);
            const idx = m ? parseInt(m[0], 10) : 1;
            if (typeof window.onJumpFieldChange === "function") window.onJumpFieldChange(idx);
          } else if (selectId.startsWith("optStopSign")) {
            const idx = parseInt(selectId.replace("optStopSign", "").replace("Hole", ""), 10);
            if (typeof window.onStopSignFieldChange === "function") window.onStopSignFieldChange(idx);
          } else if (selectId.startsWith("optDice")) {
            const idx = parseInt(selectId.replace("optDice", "").replace("Hole", ""), 10);
            if (typeof window.onDiceFieldChange === "function") window.onDiceFieldChange(idx);
          } else if (selectId.startsWith("optWheel")) {
            const idx = parseInt(selectId.replace("optWheel", "").replace("Hole", ""), 10);
            if (typeof window.onWheelFieldChange === "function") window.onWheelFieldChange(idx);
          } else if (selectId === "optSkunkMarkerHole") {
            if (typeof window.onSkunkMarkerFieldChange === "function") window.onSkunkMarkerFieldChange();
          } else if (selectId === "optDoubleSkunkMarkerHole") {
            if (typeof window.onDoubleSkunkMarkerFieldChange === "function") window.onDoubleSkunkMarkerFieldChange();
          } else if (selectId.startsWith("optYouDrink")) {
            const idx = parseInt(selectId.replace("optYouDrink", "").replace("Hole", ""), 10);
            if (typeof window.onYouDrinkFieldChange === "function") window.onYouDrinkFieldChange(idx);
          } else if (selectId.startsWith("optGuysDrink")) {
            const idx = parseInt(selectId.replace("optGuysDrink", "").replace("Hole", ""), 10);
            if (typeof window.onGuysDrinkFieldChange === "function") window.onGuysDrinkFieldChange(idx);
          } else if (selectId.startsWith("optGalsDrink")) {
            const idx = parseInt(selectId.replace("optGalsDrink", "").replace("Hole", ""), 10);
            if (typeof window.onGalsDrinkFieldChange === "function") window.onGalsDrinkFieldChange(idx);
          } else if (selectId.startsWith("optLeftDrink")) {
            const idx = parseInt(selectId.replace("optLeftDrink", "").replace("Hole", ""), 10);
            if (typeof window.onLeftDrinkFieldChange === "function") window.onLeftDrinkFieldChange(idx);
          } else if (selectId.startsWith("optRightDrink")) {
            const idx = parseInt(selectId.replace("optRightDrink", "").replace("Hole", ""), 10);
            if (typeof window.onRightDrinkFieldChange === "function") window.onRightDrinkFieldChange(idx);
          } else if (selectId.startsWith("optEveryoneDrink")) {
            const idx = parseInt(selectId.replace("optEveryoneDrink", "").replace("Hole", ""), 10);
            if (typeof window.onEveryoneDrinkFieldChange === "function") window.onEveryoneDrinkFieldChange(idx);
          } else if (selectId.startsWith("optEveryoneButYouDrink")) {
            const idx = parseInt(selectId.replace("optEveryoneButYouDrink", "").replace("Hole", ""), 10);
            if (typeof window.onEveryoneButYouDrinkFieldChange === "function") window.onEveryoneButYouDrinkFieldChange(idx);
          } else if (selectId.startsWith("optPickWhoDrinks")) {
            const idx = parseInt(selectId.replace("optPickWhoDrinks", "").replace("Hole", ""), 10);
            if (typeof window.onPickWhoDrinksFieldChange === "function") window.onPickWhoDrinksFieldChange(idx);
          } else if (typeof ADULT_OPTIONS_LIST !== "undefined" && ADULT_OPTIONS_LIST.some((o) => selectId.startsWith(o.prefix))) {
            const adultOpt = ADULT_OPTIONS_LIST.find((o) => selectId.startsWith(o.prefix));
            const idx = parseInt(selectId.replace(adultOpt.prefix, "").replace("Hole", ""), 10);
            if (typeof window.onAdultOptionFieldChange === "function") window.onAdultOptionFieldChange(adultOpt.key, idx);
          }
          if (typeof window.enforceClashNoOverlap === "function") {
            window.enforceClashNoOverlap(selectId);
          }
        }
      }
      _ClashPlacementModal.syncAllPlacementButtons();
      const meta = _ClashPlacementModal.getMetadata()[selectId];
      _ClashPlacementModal.close();
      if (typeof window !== "undefined" && typeof window.showToast === "function") {
        window.showToast(`\u2713 Placed ${meta ? meta.name : "Option"} at Hole ${selectedHole}`);
      }
    }
    static renderPlacementBoard(selectId, options = {}) {
      if (typeof document === "undefined") return;
      const container = document.getElementById("clashBoardSvgWrap");
      if (!container) return;
      container.innerHTML = "";
      const itemMeta = options.meta || _ClashPlacementModal.getMetadata();
      const meta = itemMeta[selectId] || { name: "Option", icon: "\u{1F4CD}", color: "#f0c64a", getLength: () => 1 };
      function getItemLength(startCandidate = null) {
        if (typeof meta.getLength === "function") {
          return meta.getLength(startCandidate);
        }
        return 1;
      }
      const isPintsItem = selectId.includes("Drink");
      const isAdultItem = typeof ADULT_OPTIONS_LIST !== "undefined" && ADULT_OPTIONS_LIST.some((o) => selectId.startsWith(o.prefix));
      const targetVal = (document.getElementById("optTarget") ? parseInt(document.getElementById("optTarget").value, 10) : options.settings && options.settings.target) || 481;
      const isClashTarget2 = [241, 361, 481].includes(targetVal);
      const boardTarget = isPintsItem || isAdultItem ? 121 : isClashTarget2 ? targetVal : 121;
      const isClashBoard = [241, 361, 481].includes(boardTarget);
      if (typeof window !== "undefined") window._clashBoardTarget = boardTarget;
      let viewW, viewH, targetHoles;
      let clashCfg = null;
      if (isClashBoard) {
        clashCfg = getClashBoardCfg(boardTarget);
        viewW = clashCfg.viewW;
        viewH = clashCfg.viewH;
        targetHoles = boardTarget - 1;
      } else {
        viewW = BOARD_CFG.viewW;
        viewH = BOARD_CFG.viewH;
        targetHoles = 120;
      }
      const placedItems = _ClashPlacementModal.getAllPlacedItems(selectId, itemMeta);
      const badgesWrap = document.getElementById("clashPlacedBadges");
      if (badgesWrap) {
        badgesWrap.innerHTML = placedItems.length ? placedItems.map((b) => `
        <span class="cpl-placed-tag" style="border-color: ${b.color}; color: ${b.color};">
          ${b.icon} ${b.name}: ${b.start}${b.length > 1 ? "\u2013" + b.end : ""}
        </span>
      `).join("") : '<span style="color: #64748b;">No other options active</span>';
      }
      const svg2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg2.setAttribute("viewBox", `0 0 ${viewW} ${viewH}`);
      const bgX = 15;
      const bgY = 12;
      const bgW = viewW - 30;
      const bgH = viewH - 24;
      const bgRx = 16;
      const svgContent = `
      <defs>
        <radialGradient id="plHoleGrad" cx="38%" cy="38%" r="65%">
          <stop offset="0%" stop-color="#020101" />
          <stop offset="65%" stop-color="#120803" />
          <stop offset="100%" stop-color="#241005" />
        </radialGradient>
        <linearGradient id="plBoardWoodGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#eed5ad" />
          <stop offset="45%" stop-color="#e2c191" />
          <stop offset="80%" stop-color="#d4af7a" />
          <stop offset="100%" stop-color="#c69e67" />
        </linearGradient>
        <filter id="plGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0" stdDeviation="2.5" flood-color="#f0c64a" flood-opacity="0.9" />
        </filter>
        <marker id="plJumpArrowGreen" viewBox="0 0 10 10" refX="7" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill="#22c55e" />
        </marker>
        <marker id="plJumpArrowRed" viewBox="0 0 10 10" refX="7" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill="#ef4444" />
        </marker>
      </defs>
      <rect x="${bgX}" y="${bgY}" width="${bgW}" height="${bgH}" rx="${bgRx}"
            fill="url(#plBoardWoodGrad)" stroke="#6b3a12" stroke-width="3" />
      <rect x="${bgX + 2}" y="${bgY + 2}" width="${bgW - 4}" height="${bgH - 4}" rx="${Math.max(2, bgRx - 2)}"
            fill="none" stroke="rgba(255, 240, 215, 0.45)" stroke-width="1.2" />
      <g id="plMilestonesGroup"></g>
      <g id="plJumpsLayer"></g>
      <g id="plHolesGroup"></g>
      <g id="plPlacedOverlaysGroup"></g>
      <g id="plHitAreasGroup"></g>
      <g id="plLabelsGroup"></g>
    `;
      svg2.innerHTML = svgContent;
      container.appendChild(svg2);
      const milestonesGroup = svg2.querySelector("#plMilestonesGroup");
      const jumpsGroup = svg2.querySelector("#plJumpsLayer");
      const holesGroup = svg2.querySelector("#plHolesGroup");
      const overlaysGroup = svg2.querySelector("#plPlacedOverlaysGroup");
      const hitAreasGroup = svg2.querySelector("#plHitAreasGroup");
      const labelsGroup = svg2.querySelector("#plLabelsGroup");
      if (isClashBoard && clashCfg) {
        for (let r = 0; r < clashCfg.numRows; r++) {
          const y = clashCfg.stY[r];
          const startH = r * 60 + 1;
          for (let g = 1; g <= 11; g++) {
            const h = startH + g * 5 - 1;
            const pt = getTrackXY(h, "p1", boardTarget);
            const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
            line.setAttribute("x1", pt.x);
            line.setAttribute("y1", y - 9);
            line.setAttribute("x2", pt.x);
            line.setAttribute("y2", y + 9);
            line.setAttribute("stroke", "#6d421a");
            line.setAttribute("stroke-opacity", "0.65");
            line.setAttribute("stroke-width", "1.2");
            milestonesGroup.appendChild(line);
          }
          const stTxt = document.createElementNS("http://www.w3.org/2000/svg", "text");
          stTxt.setAttribute("x", r % 2 === 0 ? 32 : 788);
          stTxt.setAttribute("y", y + 3.5);
          stTxt.setAttribute("fill", "#5c3814");
          stTxt.setAttribute("font-size", "8.5px");
          stTxt.setAttribute("font-weight", "700");
          stTxt.setAttribute("text-anchor", "middle");
          stTxt.textContent = `ST ${r + 1}`;
          labelsGroup.appendChild(stTxt);
        }
      } else {
        const streets = [
          { num: 1, y: BOARD_CFG.st1Y, start: 5, end: 30, xLabel: 32 },
          { num: 2, y: BOARD_CFG.st2Y, start: 40, end: 65, xLabel: 788 },
          { num: 3, y: BOARD_CFG.st3Y, start: 75, end: 120, xLabel: 32 }
        ];
        streets.forEach((st) => {
          for (let h = st.start; h <= st.end; h += 5) {
            const pt = getTrackXY(h, "p1", boardTarget);
            const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
            line.setAttribute("x1", pt.x);
            line.setAttribute("y1", st.y - 9);
            line.setAttribute("x2", pt.x);
            line.setAttribute("y2", st.y + 9);
            line.setAttribute("stroke", "#6d421a");
            line.setAttribute("stroke-opacity", "0.65");
            line.setAttribute("stroke-width", "1.2");
            milestonesGroup.appendChild(line);
          }
          const stTxt = document.createElementNS("http://www.w3.org/2000/svg", "text");
          stTxt.setAttribute("x", st.xLabel);
          stTxt.setAttribute("y", st.y + 3.5);
          stTxt.setAttribute("fill", "#5c3814");
          stTxt.setAttribute("font-size", "8.5px");
          stTxt.setAttribute("font-weight", "700");
          stTxt.setAttribute("text-anchor", "middle");
          stTxt.textContent = `ST ${st.num}`;
          labelsGroup.appendChild(stTxt);
        });
      }
      const holeCircleMap = /* @__PURE__ */ new Map();
      for (let h = 1; h <= targetHoles; h++) {
        const pt = getTrackXY(h, "p1", boardTarget);
        const isMilestone = h > 0 && h % 5 === 0;
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", pt.x);
        circle.setAttribute("cy", pt.y);
        circle.setAttribute("r", isMilestone ? "2.8" : "2");
        circle.setAttribute("fill", "url(#plHoleGrad)");
        circle.setAttribute("stroke", isMilestone ? "#3a1b07" : "#1a0b03");
        circle.setAttribute("stroke-width", isMilestone ? "1.2" : "0.8");
        circle.setAttribute("id", `plHoleCircle_${h}`);
        holesGroup.appendChild(circle);
        holeCircleMap.set(h, circle);
      }
      placedItems.forEach((item) => {
        for (let h = item.start; h <= item.end; h++) {
          const c = holeCircleMap.get(h);
          if (c) {
            c.setAttribute("fill", item.color);
            c.setAttribute("stroke", "#ffffff");
            c.setAttribute("stroke-width", "1.2");
          }
        }
        const midHole = Math.round((item.start + item.end) / 2);
        const midPt = getTrackXY(midHole, "p1", boardTarget);
        const pin = document.createElementNS("http://www.w3.org/2000/svg", "text");
        pin.setAttribute("x", midPt.x);
        pin.setAttribute("y", midPt.y - 10);
        pin.setAttribute("class", "placement-pin");
        pin.textContent = item.icon;
        const pinTitle = document.createElementNS("http://www.w3.org/2000/svg", "title");
        pinTitle.textContent = `${item.name} (Holes ${item.start}\u2013${item.end})`;
        pin.appendChild(pinTitle);
        overlaysGroup.appendChild(pin);
      });
      const step = 5;
      const startHole = selectId.includes("Jump") || selectId.includes("StopSign") || selectId.includes("Skunk") || isPintsItem || isAdultItem ? 5 : 10;
      const maxClashHole = isClashBoard ? boardTarget - 11 : 110;
      const maxStopSignHole = isClashBoard ? boardTarget - 6 : 115;
      const maxJumpDestHole = isClashBoard ? boardTarget - 1 : 120;
      const maxMarkerHole = isClashBoard ? boardTarget - 1 : 120;
      const endHole = isPintsItem || isAdultItem ? Math.max(5, 120 - getItemLength(120) + 1) : isClashBoard ? selectId.includes("Skunk") ? maxMarkerHole : selectId.includes("JumpDest") ? maxJumpDestHole : selectId.includes("StopSign") ? maxStopSignHole : maxClashHole : selectId.includes("Skunk") ? 120 : selectId.includes("JumpDest") ? 120 : selectId.includes("StopSign") ? 115 : selectId.includes("NoPassing") ? 100 : 110;
      function drawJumpArrows(previewHole = null) {
        if (!jumpsGroup) return;
        jumpsGroup.innerHTML = "";
        const chk = document.getElementById("optJump");
        const isEditingJump = selectId.startsWith("optJump");
        const isJumpActive = chk && chk.checked || isEditingJump;
        if (!isJumpActive) return;
        const count = parseInt(document.getElementById("optJumpCount")?.value, 10) || 2;
        const currentEditedIdx = selectId.startsWith("optJump") ? parseInt(selectId.match(/\d+/)?.[0] || "1", 10) : null;
        const maxJump = Math.max(count, currentEditedIdx || 1);
        for (let i = 1; i <= maxJump; i++) {
          let sVal = parseInt(document.getElementById(`optJump${i}Start`)?.value, 10);
          let dVal = parseInt(document.getElementById(`optJump${i}Dest`)?.value, 10);
          const targetHole = previewHole != null ? previewHole : _ClashPlacementModal.currentSelectedHole;
          if (selectId === `optJump${i}Start` && targetHole != null) {
            sVal = targetHole;
          } else if (selectId === `optJump${i}Dest` && targetHole != null) {
            dVal = targetHole;
          }
          if (isNaN(sVal) || isNaN(dVal) || sVal <= 0 || dVal <= 0 || sVal === dVal) continue;
          if (sVal > targetHoles || dVal > targetHoles) continue;
          const isForward = dVal > sVal;
          const sHole = Math.min(targetHoles, isForward ? sVal : sVal + 1);
          const dHole = dVal;
          const pStart = getTrackXY(sHole, "p1", boardTarget);
          const pEnd = getTrackXY(dHole, "p1", boardTarget);
          const dx2 = pEnd.x - pStart.x;
          const dy2 = pEnd.y - pStart.y;
          const dist2 = Math.hypot(dx2, dy2);
          if (dist2 < 4) continue;
          const mx = (pStart.x + pEnd.x) / 2;
          const my = (pStart.y + pEnd.y) / 2;
          const nx = -dy2 / dist2;
          const ny = dx2 / dist2;
          let arcSign = -1;
          if (Math.abs(dy2) < 15) {
            arcSign = my > viewH / 2 ? 1 : -1;
          } else {
            arcSign = isForward ? -1 : 1;
          }
          const curveHeight = Math.max(16, Math.min(50, dist2 * 0.25)) * arcSign;
          const cx = mx + nx * curveHeight;
          const cy = my + ny * curveHeight;
          const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
          path.setAttribute("d", `M ${pStart.x} ${pStart.y} Q ${cx} ${cy} ${pEnd.x} ${pEnd.y}`);
          path.setAttribute("class", isForward ? "jump-arrow-forward" : "jump-arrow-backward");
          path.setAttribute("marker-end", isForward ? "url(#plJumpArrowGreen)" : "url(#plJumpArrowRed)");
          const diff = Math.abs(dVal - sVal);
          const jumpSpanText = isForward ? `Hole ${sVal}` : `Holes ${sVal}\u2013${sVal + 2}`;
          const title = document.createElementNS("http://www.w3.org/2000/svg", "title");
          title.textContent = `Jump ${i}: ${jumpSpanText} \u2794 Hole ${dVal} (${isForward ? `Forward +${diff}` : `Backward -${diff}`})`;
          path.appendChild(title);
          jumpsGroup.appendChild(path);
        }
      }
      function updateHoverHighlight(start, isHover) {
        const len = getItemLength(start);
        for (let h = start; h < start + len; h++) {
          const c = holeCircleMap.get(h);
          if (c) {
            if (isHover) {
              c.classList.add("placement-hole-hover-span");
            } else {
              c.classList.remove("placement-hole-hover-span");
            }
          }
        }
        if (selectId.startsWith("optJump")) {
          drawJumpArrows(isHover ? start : null);
        }
      }
      function setSelectedHole(h) {
        _ClashPlacementModal.currentSelectedHole = h;
        const confirmBtn = document.getElementById("btnConfirmClashPlacement");
        if (confirmBtn) confirmBtn.disabled = false;
        const len = getItemLength(h);
        const rangeText = len > 1 ? `Holes ${h}\u2013${h + len - 1}` : `Hole ${h}`;
        const street = typeof window !== "undefined" && typeof window.getStreetOrTurnName === "function" ? window.getStreetOrTurnName(h) : "";
        let jumpDetails = "";
        if (selectId.startsWith("optJump")) {
          const jIdx = selectId.match(/\d+/)?.[0] || "1";
          if (selectId.endsWith("Start")) {
            const dVal = parseInt(document.getElementById(`optJump${jIdx}Dest`)?.value, 10);
            if (!isNaN(dVal)) {
              const isFwd = dVal > h;
              const diff = Math.abs(dVal - h);
              jumpDetails = ` \xB7 <span style="color: ${isFwd ? "#22c55e" : "#ef4444"}; font-weight: 800;">${isFwd ? "\u2794 Forward Jump (+" + diff + ")" : "\u2794 Backward Jump (-" + diff + ")"}</span> to Hole ${dVal}`;
            }
          } else if (selectId.endsWith("Dest")) {
            const sVal = parseInt(document.getElementById(`optJump${jIdx}Start`)?.value, 10);
            if (!isNaN(sVal)) {
              const isFwd = h > sVal;
              const diff = Math.abs(h - sVal);
              const fromText = isFwd ? `Hole ${sVal}` : `Holes ${sVal}\u2013${sVal + 2}`;
              jumpDetails = ` \xB7 <span style="color: ${isFwd ? "#22c55e" : "#ef4444"}; font-weight: 800;">${isFwd ? "\u2794 Forward Jump (+" + diff + ")" : "\u2794 Backward Jump (-" + diff + ")"}</span> from ${fromText}`;
            }
          }
        }
        const statusVal = document.getElementById("clashStatusSelected");
        if (statusVal) {
          statusVal.innerHTML = `<span style="color: ${meta.color}; font-weight: 700;">${meta.icon} ${meta.name}:</span> ${street ? street + " \xB7 " : ""}${rangeText}${jumpDetails}`;
        }
        svg2.querySelectorAll(".candidate-hole-selected").forEach((el) => el.remove());
        for (let cur = h; cur < h + len; cur++) {
          const pt = getTrackXY(cur, "p1", boardTarget);
          const ring = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          ring.setAttribute("cx", pt.x);
          ring.setAttribute("cy", pt.y);
          ring.setAttribute("r", "6");
          ring.setAttribute("fill", "none");
          ring.setAttribute("stroke", "#f0c64a");
          ring.setAttribute("stroke-width", "2");
          ring.setAttribute("class", "candidate-hole-selected");
          ring.setAttribute("filter", "url(#plGlow)");
          holesGroup.appendChild(ring);
        }
        drawJumpArrows(h);
      }
      for (let s = startHole; s <= endHole; s += step) {
        const len = getItemLength(s);
        if (s + len - 1 > targetHoles) continue;
        let overlaps = false;
        if (!meta.allowsOverlap) {
          for (const it of placedItems) {
            if (it.allowsOverlap) continue;
            if (s <= it.end && s + len - 1 >= it.start) {
              overlaps = true;
              break;
            }
          }
        }
        const pStart = getTrackXY(s, "p1", boardTarget);
        const pEnd = getTrackXY(s + len - 1, "p1", boardTarget);
        const midX = (pStart.x + pEnd.x) / 2;
        const midY = (pStart.y + pEnd.y) / 2;
        const hit = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        hit.setAttribute("cx", midX);
        hit.setAttribute("cy", midY);
        hit.setAttribute("r", 5);
        hit.setAttribute("class", `placement-candidate-hit ${overlaps ? "is-occupied" : "is-available"}`);
        hit.setAttribute("data-hole", s);
        const rangeText = len > 1 ? `Holes ${s}\u2013${s + len - 1}` : `Hole ${s}`;
        const tip = document.createElementNS("http://www.w3.org/2000/svg", "title");
        tip.textContent = overlaps ? `${rangeText} (Overlaps other placed option)` : `${rangeText} (Click to place)`;
        hit.appendChild(tip);
        if (!overlaps) {
          hit.addEventListener("mouseenter", () => {
            updateHoverHighlight(s, true);
            const statusVal = document.getElementById("clashStatusSelected");
            if (statusVal && _ClashPlacementModal.currentSelectedHole !== s) {
              const street = typeof window !== "undefined" && typeof window.getStreetOrTurnName === "function" ? window.getStreetOrTurnName(s) : "";
              let hoverJumpExtra = "";
              if (selectId.startsWith("optJump")) {
                const jIdx = selectId.match(/\d+/)?.[0] || "1";
                if (selectId.endsWith("Start")) {
                  const dVal = parseInt(document.getElementById(`optJump${jIdx}Dest`)?.value, 10);
                  if (!isNaN(dVal)) {
                    const isFwd = dVal > s;
                    const diff = Math.abs(dVal - s);
                    hoverJumpExtra = ` \xB7 <span style="color: ${isFwd ? "#22c55e" : "#ef4444"}; font-weight: 800;">${isFwd ? "\u2794 Forward Jump (+" + diff + ")" : "\u2794 Backward Jump (-" + diff + ")"}</span> to Hole ${dVal}`;
                  }
                } else if (selectId.endsWith("Dest")) {
                  const sVal = parseInt(document.getElementById(`optJump${jIdx}Start`)?.value, 10);
                  if (!isNaN(sVal)) {
                    const isFwd = s > sVal;
                    const diff = Math.abs(s - sVal);
                    const fromText = isFwd ? `Hole ${sVal}` : `Holes ${sVal}\u2013${sVal + 2}`;
                    hoverJumpExtra = ` \xB7 <span style="color: ${isFwd ? "#22c55e" : "#ef4444"}; font-weight: 800;">${isFwd ? "\u2794 Forward Jump (+" + diff + ")" : "\u2794 Backward Jump (-" + diff + ")"}</span> from ${fromText}`;
                  }
                }
              }
              statusVal.innerHTML = `<span style="color: #34d399;">Hovering:</span> ${street ? street + " \xB7 " : ""}${rangeText}${hoverJumpExtra} (Click to place)`;
            }
          });
          hit.addEventListener("mouseleave", () => {
            updateHoverHighlight(s, false);
            if (_ClashPlacementModal.currentSelectedHole != null) {
              setSelectedHole(_ClashPlacementModal.currentSelectedHole);
            }
          });
          hit.addEventListener("click", () => {
            setSelectedHole(s);
          });
        }
        hitAreasGroup.appendChild(hit);
      }
      drawJumpArrows();
      if (_ClashPlacementModal.currentSelectedHole != null && _ClashPlacementModal.currentSelectedHole >= startHole && _ClashPlacementModal.currentSelectedHole <= endHole) {
        setSelectedHole(_ClashPlacementModal.currentSelectedHole);
      } else {
        const confirmBtn = document.getElementById("btnConfirmClashPlacement");
        if (confirmBtn) confirmBtn.disabled = true;
        const statusVal = document.getElementById("clashStatusSelected");
        if (statusVal) statusVal.textContent = "None selected \u2014 Click any green group on the track";
      }
    }
    static updateOptionRanges(targetOrIsClash, options = {}) {
      if (typeof document === "undefined") return;
      function rebuildOptions(selectId, items, defaultValue) {
        const sel = document.getElementById(selectId);
        if (!sel) return;
        const currentVal = parseInt(sel.value, 10);
        const lastOpt = sel.options[sel.options.length - 1];
        const isMatchingOptions = lastOpt && parseInt(lastOpt.value, 10) === items[items.length - 1].value && sel.options.length === items.length;
        if (!isMatchingOptions) {
          sel.innerHTML = "";
          items.forEach((item) => {
            const opt = document.createElement("option");
            opt.value = String(item.value);
            opt.textContent = item.label;
            sel.appendChild(opt);
          });
        }
        const isCustom = sel.dataset.customized === "true";
        let targetVal = isCustom && !isNaN(currentVal) && items.some((it) => it.value === currentVal) ? currentVal : defaultValue;
        if (isNaN(targetVal)) targetVal = items[0] && items[0].value != null ? items[0].value : 5;
        if (!items.some((it) => it.value === targetVal) && !isNaN(targetVal)) {
          const opt = document.createElement("option");
          opt.value = String(targetVal);
          opt.textContent = `Hole ${targetVal}`;
          sel.appendChild(opt);
        }
        sel.value = String(targetVal);
        delete sel.dataset.originalText;
      }
      let clashTarget = 481;
      if (typeof targetOrIsClash === "number") {
        clashTarget = targetOrIsClash;
      } else if (targetOrIsClash === false) {
        clashTarget = 121;
      } else {
        const optTarget = document.getElementById("optTarget");
        if (optTarget && [241, 361, 481].includes(parseInt(optTarget.value, 10))) {
          clashTarget = parseInt(optTarget.value, 10);
        } else if (options.settings && [241, 361, 481].includes(options.settings.target)) {
          clashTarget = options.settings.target;
        }
      }
      const isClashTarget2 = [241, 361, 481].includes(clashTarget);
      const defs = isClashTarget2 ? getClashDefaults(clashTarget) : null;
      const maxSingleHole = isClashTarget2 ? clashTarget - 11 : 110;
      const singleHoleItems = [];
      for (let v = 10; v <= maxSingleHole; v += 5) {
        singleHoleItems.push({ value: v, label: `Hole ${v}` });
      }
      rebuildOptions("optJail1Hole", singleHoleItems, defs ? defs.jailHoles[0] : 25);
      rebuildOptions("optJail2Hole", singleHoleItems, defs ? defs.jailHoles[1] : 75);
      rebuildOptions("optBar1Hole", singleHoleItems, defs ? defs.barHoles[0] : 40);
      rebuildOptions("optBar2Hole", singleHoleItems, defs ? defs.barHoles[1] : 85);
      rebuildOptions("optTimeout1Hole", singleHoleItems, defs ? defs.timeoutHoles[0] : 30);
      rebuildOptions("optTimeout2Hole", singleHoleItems, defs ? defs.timeoutHoles[1] : 90);
      rebuildOptions("optDetour1Hole", singleHoleItems, defs ? defs.detourHoles[0] : 10);
      rebuildOptions("optDetour2Hole", singleHoleItems, defs ? defs.detourHoles[1] : 60);
      rebuildOptions("optRoundAbout1Hole", singleHoleItems, defs ? defs.roundAboutHoles[0] : 35);
      rebuildOptions("optRoundAbout2Hole", singleHoleItems, defs ? defs.roundAboutHoles[1] : 70);
      rebuildOptions("optSigns1Hole", singleHoleItems, defs ? defs.signsStarts[0] : 45);
      rebuildOptions("optSigns2Hole", singleHoleItems, defs ? defs.signsStarts[1] : 55);
      rebuildOptions("optSigns3Hole", singleHoleItems, defs ? defs.signsStarts[2] : 95);
      rebuildOptions("optSigns4Hole", singleHoleItems, defs ? defs.signsStarts[3] : 105);
      const defaultDice121 = [20, 50, 80, 100];
      const defaultDiceClash = defs ? defs.diceHoles : null;
      for (let i = 1; i <= 4; i++) {
        const defVal = defaultDiceClash ? defaultDiceClash[i - 1] : defaultDice121[i - 1];
        rebuildOptions(`optDice${i}Hole`, singleHoleItems, defVal);
      }
      const defaultWheel121 = [30, 60, 90, 110];
      const defaultWheelClash = defs ? defs.wheelHoles : null;
      for (let i = 1; i <= 4; i++) {
        const defVal = defaultWheelClash ? defaultWheelClash[i - 1] : defaultWheel121[i - 1];
        rebuildOptions(`optWheel${i}Hole`, singleHoleItems, defVal);
      }
      const maxStopSignHole = isClashTarget2 ? clashTarget - 6 : 115;
      const stopSignItems = [];
      for (let v = 5; v <= maxStopSignHole; v += 5) {
        stopSignItems.push({ value: v, label: `Hole ${v}` });
      }
      const defaultStops121 = [20, 35, 50, 65, 80, 95, 105, 115];
      const defaultStopsClash = defs ? defs.stopSignHoles : null;
      for (let i = 1; i <= 8; i++) {
        const defVal = defaultStopsClash ? defaultStopsClash[i - 1] : defaultStops121[i - 1];
        rebuildOptions(`optStopSign${i}Hole`, stopSignItems, defVal);
      }
      const maxNplHole = isClashTarget2 ? clashTarget - 11 : 100;
      const nplItems = [];
      for (let v = 10; v <= maxNplHole; v += 10) {
        nplItems.push({ value: v, label: `Holes ${v}\u2013${v + 4}` });
      }
      const defaultNpl121 = [20, 50, 80, 100];
      const defaultNplClash = defs ? defs.noPassingLaneStarts : null;
      for (let i = 1; i <= 4; i++) {
        const defVal = defaultNplClash ? defaultNplClash[i - 1] : defaultNpl121[i - 1];
        rebuildOptions(`optNoPassingLane${i}Start`, nplItems, defVal);
      }
      const maxJumpStartHole = isClashTarget2 ? clashTarget - 11 : 115;
      const maxJumpDestHole = isClashTarget2 ? clashTarget - 1 : 120;
      const jumpStartItems = [];
      for (let v = 5; v <= maxJumpStartHole; v += 5) {
        jumpStartItems.push({ value: v, label: `Hole ${v}` });
      }
      const jumpDestItems = [];
      for (let v = 5; v <= maxJumpDestHole; v += 5) {
        jumpDestItems.push({ value: v, label: `Hole ${v}` });
      }
      const defaultJumpStarts121 = [15, 65, 5, 115, 25, 75, 45, 95];
      const defaultJumpDests121 = [35, 50, 45, 70, 55, 60, 80, 85];
      const defaultJumpStartsClash = defs ? defs.jumpStarts : null;
      const defaultJumpDestsClash = defs ? defs.jumpDests : null;
      for (let i = 1; i <= 8; i++) {
        const defStart = defaultJumpStartsClash ? defaultJumpStartsClash[i - 1] : defaultJumpStarts121[i - 1];
        const defDest = defaultJumpDestsClash ? defaultJumpDestsClash[i - 1] : defaultJumpDests121[i - 1];
        rebuildOptions(`optJump${i}Start`, jumpStartItems, defStart);
        rebuildOptions(`optJump${i}Dest`, jumpDestItems, defDest);
      }
      _ClashPlacementModal.syncAllPlacementButtons();
    }
    static randomizeOptions(isFull = false, options = {}) {
      if (typeof window !== "undefined") window._isRandomizingClash = true;
      try {
        let isFree = function(start, length) {
          for (let h = start; h < start + length; h++) {
            if (occupiedHoles.has(h)) return false;
          }
          return true;
        }, occupy = function(start, length) {
          for (let h = start; h < start + length; h++) {
            occupiedHoles.add(h);
          }
        }, shuffle2 = function(arr) {
          const a = [...arr];
          for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
          }
          return a;
        }, getMultiples = function(step, max, min = 10) {
          const out = [];
          for (let v = min; v <= max; v += step) out.push(v);
          return out;
        }, setChecked = function(id, val) {
          const el = document.getElementById(id);
          if (el) el.checked = val;
        }, setCount = function(id, val) {
          const el = document.getElementById(id);
          if (el) el.value = String(val);
        }, placeJump = function(jumpIndex) {
          const preferForward = Math.random() < 0.5;
          const allStarts = shuffle2(getMultiples(5, maxJumpHole));
          const directions = preferForward ? [true, false] : [false, true];
          for (const isFwd of directions) {
            const triggerLen = isFwd ? 1 : 3;
            for (const start of allStarts) {
              if (!isFree(start, triggerLen)) continue;
              let destCandidates = [];
              if (isFwd) {
                const minDest = start + 5;
                const maxDest = Math.min(maxFwdJumpDestHole, start + 50);
                for (let d = minDest; d <= maxDest; d += 5) {
                  if (isFree(d, 1) && finishPegHole - d > 10) destCandidates.push(d);
                }
              } else {
                const minDest = Math.max(5, start - 50);
                const maxDest = start - 5;
                for (let d = minDest; d <= maxDest; d += 5) {
                  if (isFree(d, 1) && (d < start || d > start + 2)) destCandidates.push(d);
                }
              }
              if (destCandidates.length > 0) {
                destCandidates = shuffle2(destCandidates);
                const dest = destCandidates[0];
                occupy(start, triggerLen);
                occupy(dest, 1);
                const sEl = document.getElementById(`optJump${jumpIndex}Start`);
                if (sEl) {
                  sEl.value = String(start);
                  sEl.dataset.customized = "true";
                }
                const dEl = document.getElementById(`optJump${jumpIndex}Dest`);
                if (dEl) {
                  dEl.value = String(dest);
                  dEl.dataset.customized = "true";
                }
                return true;
              }
            }
          }
          return false;
        };
        const targetVal = (document.getElementById("optTarget") ? parseInt(document.getElementById("optTarget").value, 10) : options.settings && options.settings.target) || 481;
        const isClashTarget2 = [241, 361, 481].includes(targetVal);
        const clashTarget = isClashTarget2 ? targetVal : 481;
        const maxClashHole = isClashTarget2 ? clashTarget - 11 : 110;
        const jailSel = document.getElementById("optJail1Hole");
        const needsRanges = !jailSel || !jailSel.options || jailSel.options.length === 0 || jailSel.options[jailSel.options.length - 1].value !== String(maxClashHole);
        if (needsRanges) {
          _ClashPlacementModal.updateOptionRanges(clashTarget, options);
        }
        const occupiedHoles = /* @__PURE__ */ new Set();
        let signsCount, nplCount, jumpCount, jailCount, barCount, timeoutCount, detourCount, roundAboutCount, stopSignCount;
        if (isFull) {
          signsCount = 4;
          nplCount = 4;
          jumpCount = 8;
          jailCount = 2;
          barCount = 2;
          timeoutCount = 2;
          detourCount = 2;
          roundAboutCount = 2;
          stopSignCount = 8;
        } else {
          signsCount = Math.floor(Math.random() * 4) + 1;
          nplCount = Math.floor(Math.random() * 4) + 1;
          jumpCount = Math.floor(Math.random() * 8) + 1;
          jailCount = Math.floor(Math.random() * 2) + 1;
          barCount = Math.floor(Math.random() * 2) + 1;
          timeoutCount = Math.floor(Math.random() * 2) + 1;
          detourCount = Math.floor(Math.random() * 2) + 1;
          roundAboutCount = Math.floor(Math.random() * 2) + 1;
          stopSignCount = Math.floor(Math.random() * 8) + 1;
        }
        setChecked("optSigns", true);
        setCount("optSignsCount", signsCount);
        setChecked("optNoPassingLanes", true);
        setCount("optNoPassingLaneCount", nplCount);
        setChecked("optJump", true);
        setCount("optJumpCount", jumpCount);
        setChecked("optJail", true);
        setCount("optJailCount", jailCount);
        setChecked("optBar", true);
        setCount("optBarCount", barCount);
        setChecked("optTimeout", true);
        setCount("optTimeoutCount", timeoutCount);
        setChecked("optDetour", true);
        setCount("optDetourCount", detourCount);
        setChecked("optRoundAbout", true);
        setCount("optRoundAboutCount", roundAboutCount);
        setChecked("optStopSign", true);
        setCount("optStopSignCount", stopSignCount);
        const diceCount = isFull ? 4 : Math.floor(Math.random() * 3) + 2;
        setChecked("optDice", true);
        setCount("optDiceCount", diceCount);
        const wheelCount = isFull ? 4 : Math.floor(Math.random() * 3) + 2;
        setChecked("optWheel", true);
        setCount("optWheelCount", wheelCount);
        if (typeof window !== "undefined") {
          if (typeof window.toggleSignsConfig === "function") window.toggleSignsConfig(true);
          if (typeof window.toggleNoPassingLanesConfig === "function") window.toggleNoPassingLanesConfig(true);
          if (typeof window.toggleJumpConfig === "function") window.toggleJumpConfig(true);
          if (typeof window.toggleJailConfig === "function") window.toggleJailConfig(true);
          if (typeof window.toggleBarConfig === "function") window.toggleBarConfig(true);
          if (typeof window.toggleTimeoutConfig === "function") window.toggleTimeoutConfig(true);
          if (typeof window.toggleDetourConfig === "function") window.toggleDetourConfig(true);
          if (typeof window.toggleRoundAboutConfig === "function") window.toggleRoundAboutConfig(true);
          if (typeof window.toggleStopSignConfig === "function") window.toggleStopSignConfig(true);
          if (typeof window.toggleDiceConfig === "function") window.toggleDiceConfig(true);
          if (typeof window.toggleWheelConfig === "function") window.toggleWheelConfig(true);
        }
        const signLengths = {};
        for (let i = 1; i <= 4; i++) {
          const sz = Math.random() < 0.5 ? 4 : 2;
          const szEl = document.getElementById(`optSigns${i}Size`);
          if (szEl) szEl.value = String(sz);
          signLengths[i] = sz === 4 ? 5 : 3;
        }
        const finishPegHole = clashTarget;
        const maxFwdJumpDestHole = clashTarget - 11;
        const maxJumpDestHole = clashTarget - 1;
        const maxNplHole = clashTarget - 11;
        const maxJumpHole = clashTarget - 11;
        for (let i = 1; i <= signsCount; i++) {
          const len = signLengths[i];
          const candidates = shuffle2(getMultiples(10, maxClashHole)).filter((h) => isFree(h, len));
          if (candidates.length > 0) {
            const start = candidates[0];
            occupy(start, len);
            const sel = document.getElementById(`optSigns${i}Hole`);
            if (sel) {
              sel.value = String(start);
              sel.dataset.customized = "true";
            }
          }
        }
        for (let i = 1; i <= nplCount; i++) {
          const candidates = shuffle2(getMultiples(10, maxNplHole)).filter((h) => isFree(h, 5));
          if (candidates.length > 0) {
            const start = candidates[0];
            occupy(start, 5);
            const sel = document.getElementById(`optNoPassingLane${i}Start`);
            if (sel) {
              sel.value = String(start);
              sel.dataset.customized = "true";
            }
          }
        }
        for (let i = 1; i <= jumpCount; i++) {
          placeJump(i);
        }
        const singleObstacles = [
          { prefix: "optJail", suffix: "Hole", count: jailCount },
          { prefix: "optBar", suffix: "Hole", count: barCount },
          { prefix: "optTimeout", suffix: "Hole", count: timeoutCount },
          { prefix: "optDetour", suffix: "Hole", count: detourCount },
          { prefix: "optRoundAbout", suffix: "Hole", count: roundAboutCount },
          { prefix: "optStopSign", suffix: "Hole", count: stopSignCount },
          { prefix: "optDice", suffix: "Hole", count: diceCount },
          { prefix: "optWheel", suffix: "Hole", count: wheelCount }
        ];
        for (const obs of singleObstacles) {
          for (let i = 1; i <= obs.count; i++) {
            const candidates = shuffle2(getMultiples(10, maxClashHole)).filter((h) => isFree(h, 1));
            if (candidates.length > 0) {
              const h = candidates[0];
              occupy(h, 1);
              const sel = document.getElementById(`${obs.prefix}${i}${obs.suffix}`);
              if (sel) {
                sel.value = String(h);
                sel.dataset.customized = "true";
              }
            }
          }
        }
        if (typeof window !== "undefined") {
          for (let i = 1; i <= 4; i++) {
            if (typeof window.onNoPassingLaneFieldChange === "function") window.onNoPassingLaneFieldChange(i, true);
            if (typeof window.onSignsFieldChange === "function") window.onSignsFieldChange(i, true);
            if (typeof window.onDiceFieldChange === "function") window.onDiceFieldChange(i, true);
          }
          for (let i = 1; i <= 8; i++) {
            if (typeof window.onJumpFieldChange === "function") window.onJumpFieldChange(i, true);
            if (typeof window.onStopSignFieldChange === "function") window.onStopSignFieldChange(i, true);
          }
          for (let i = 1; i <= 2; i++) {
            if (typeof window.onJailFieldChange === "function") window.onJailFieldChange(i, true);
            if (typeof window.onBarFieldChange === "function") window.onBarFieldChange(i, true);
            if (typeof window.onTimeoutFieldChange === "function") window.onTimeoutFieldChange(i, true);
            if (typeof window.onDetourFieldChange === "function") window.onDetourFieldChange(i, true);
            if (typeof window.onRoundAboutFieldChange === "function") window.onRoundAboutFieldChange(i, true);
          }
        }
      } finally {
        if (typeof window !== "undefined") window._isRandomizingClash = false;
      }
      if (typeof window !== "undefined") {
        if (typeof window.enforceClashNoOverlap === "function") window.enforceClashNoOverlap();
        _ClashPlacementModal.syncAllPlacementButtons();
        if (typeof window.readFormSettings === "function" && typeof window.saveSettingsStore === "function") {
          window.saveSettingsStore(window.readFormSettings());
        }
        if (typeof window.showToast === "function") {
          if (isFull) {
            window.showToast("\u26A1 Full Random: Enabled all options with non-overlapping placements!");
          } else {
            window.showToast("\u{1F3B2} Randomized Cribbage Clash options with zero overlaps!");
          }
        }
      }
    }
    static uncheckClashOptions() {
      const prevSuppress = typeof window !== "undefined" ? window._suppressSettingsSave : false;
      if (typeof window !== "undefined") window._suppressSettingsSave = true;
      try {
        const clashIds = [
          "optNoPassingLanes",
          "optJump",
          "optJail",
          "optBar",
          "optTimeout",
          "optDetour",
          "optRoundAbout",
          "optSigns",
          "optStopSign",
          "optDice",
          "optWheel",
          "optSkunkMarkers"
        ];
        if (typeof document !== "undefined") {
          const bClash = document.querySelectorAll("#cribbage-clash-options input[type=checkbox]");
          bClash.forEach((element) => {
            element.checked = false;
          });
          clashIds.forEach((id) => {
            const el = document.getElementById(id);
            if (el) el.checked = false;
          });
        }
        if (typeof window !== "undefined" && window.settings) {
          clashIds.forEach((id) => {
            window.settings[id] = false;
            const shortKey = id.replace(/^opt/, "").charAt(0).toLowerCase() + id.replace(/^opt/, "").slice(1);
            window.settings[shortKey] = false;
          });
          window.settings.noPassingLaneStarts = [];
          window.settings.noPassingLaneHoles = [];
          window.settings.jumpStarts = [];
          window.settings.jumpDests = [];
          window.settings.jailHoles = [];
          window.settings.barHoles = [];
          window.settings.timeoutHoles = [];
          window.settings.detourHoles = [];
          window.settings.roundAboutHoles = [];
          window.settings.signsBlocks = [];
          window.settings.stopSignHoles = [];
          window.settings.diceHoles = [];
          window.settings.wheelHoles = [];
        }
        if (typeof window !== "undefined") {
          if (typeof window.toggleNoPassingLanesConfig === "function") window.toggleNoPassingLanesConfig(false);
          if (typeof window.toggleJumpConfig === "function") window.toggleJumpConfig(false);
          if (typeof window.toggleJailConfig === "function") window.toggleJailConfig(false);
          if (typeof window.toggleBarConfig === "function") window.toggleBarConfig(false);
          if (typeof window.toggleTimeoutConfig === "function") window.toggleTimeoutConfig(false);
          if (typeof window.toggleDetourConfig === "function") window.toggleDetourConfig(false);
          if (typeof window.toggleRoundAboutConfig === "function") window.toggleRoundAboutConfig(false);
          if (typeof window.toggleSignsConfig === "function") window.toggleSignsConfig(false);
          if (typeof window.toggleStopSignConfig === "function") window.toggleStopSignConfig(false);
          if (typeof window.toggleDiceConfig === "function") window.toggleDiceConfig(false);
          if (typeof window.toggleWheelConfig === "function") window.toggleWheelConfig(false);
          if (typeof window.toggleSkunkMarkersConfig === "function") window.toggleSkunkMarkersConfig(false);
        }
        _ClashPlacementModal.syncAllPlacementButtons();
      } finally {
        if (typeof window !== "undefined") window._suppressSettingsSave = prevSuppress;
      }
    }
    static uncheckPintsOptions() {
      const prevSuppress = typeof window !== "undefined" ? window._suppressSettingsSave : false;
      if (typeof window !== "undefined") window._suppressSettingsSave = true;
      try {
        const pintsIds = [
          "optYouDrink",
          "optGuysDrink",
          "optGalsDrink",
          "optLeftDrink",
          "optRightDrink",
          "optEveryoneDrink",
          "optEveryoneButYouDrink",
          "optPickWhoDrinks"
        ];
        if (typeof document !== "undefined") {
          const bPints = document.querySelectorAll("#pints-options input[type=checkbox]");
          bPints.forEach((element) => {
            element.checked = false;
          });
          pintsIds.forEach((id) => {
            const el = document.getElementById(id);
            if (el) el.checked = false;
          });
        }
        if (typeof window !== "undefined" && window.settings) {
          pintsIds.forEach((id) => {
            window.settings[id] = false;
            const shortKey = id.replace(/^opt/, "").charAt(0).toLowerCase() + id.replace(/^opt/, "").slice(1);
            window.settings[shortKey] = false;
            window.settings[shortKey + "Count"] = 0;
            window.settings[shortKey + "Holes"] = [];
            window.settings[shortKey + "Pegs"] = 0;
          });
        }
        if (typeof window !== "undefined") {
          if (typeof window.toggleYouDrinkConfig === "function") window.toggleYouDrinkConfig(false);
          if (typeof window.toggleGuysDrinkConfig === "function") window.toggleGuysDrinkConfig(false);
          if (typeof window.toggleGalsDrinkConfig === "function") window.toggleGalsDrinkConfig(false);
          if (typeof window.toggleLeftDrinkConfig === "function") window.toggleLeftDrinkConfig(false);
          if (typeof window.toggleRightDrinkConfig === "function") window.toggleRightDrinkConfig(false);
          if (typeof window.toggleEveryoneDrinkConfig === "function") window.toggleEveryoneDrinkConfig(false);
          if (typeof window.toggleEveryoneButYouDrinkConfig === "function") window.toggleEveryoneButYouDrinkConfig(false);
          if (typeof window.togglePickWhoDrinksConfig === "function") window.togglePickWhoDrinksConfig(false);
        }
        _ClashPlacementModal.syncAllPlacementButtons();
      } finally {
        if (typeof window !== "undefined") window._suppressSettingsSave = prevSuppress;
      }
    }
    static uncheckAdultOptions() {
      const prevSuppress = typeof window !== "undefined" ? window._suppressSettingsSave : false;
      if (typeof window !== "undefined") window._suppressSettingsSave = true;
      try {
        const adultIds = [
          "optLoseClothing",
          "optGainClothing",
          "optPickWhoLosesClothing",
          "optRightLosesClothing",
          "optLeftLosesClothing",
          "optRemoveClothingChoice",
          "optTouchBreast",
          "optLickBreast",
          "optSuckBreast",
          "optTouchGenitals",
          "optLickGenitals",
          "optSuckGenitals",
          "optFingerGenitals",
          "optGenitalIntercourse",
          "optTouchAnus",
          "optLickAnus",
          "optFingerAnus",
          "optAnalIntercourse"
        ];
        if (typeof document !== "undefined") {
          const bAdult = document.querySelectorAll("#adult-options input[type=checkbox]");
          bAdult.forEach((element) => {
            element.checked = false;
          });
          adultIds.forEach((id) => {
            const el = document.getElementById(id);
            if (el) el.checked = false;
          });
        }
        if (typeof window !== "undefined" && window.settings) {
          adultIds.forEach((id) => {
            window.settings[id] = false;
            const shortKey = id.replace(/^opt/, "").charAt(0).toLowerCase() + id.replace(/^opt/, "").slice(1);
            window.settings[shortKey] = false;
            window.settings[shortKey + "Count"] = 0;
            window.settings[shortKey + "Holes"] = [];
            window.settings[shortKey + "Pegs"] = 0;
          });
        }
        _ClashPlacementModal.syncAllPlacementButtons();
      } finally {
        if (typeof window !== "undefined") window._suppressSettingsSave = prevSuppress;
      }
    }
    static uncheckCrazyOptions() {
      const crazyIds = [
        "optJokers",
        "optCutBeforeDiscard",
        "opt31sFor5",
        "opt19sFor2",
        "optRoundAroundTheWorld",
        "optMultipleRunsInPegging",
        "optAllRed",
        "optAllBlack",
        "optAllOdd",
        "optAllEven",
        "optAllDifferentSuits",
        "optKH",
        "optQS",
        "optAS",
        "optStraight",
        "optFullHouse",
        "optStraightFlush",
        "optRoyalFlush",
        "optFlushInPlay",
        "optPegThroughZones",
        "optLast5PegOut",
        "optBunkers",
        "optStinkHole",
        "optStolenCrib",
        "optZeroHand",
        "optZeroCrib",
        "optRockCrib",
        "optPickYourCrib",
        "optSpeedoCribbage",
        "optShotgunCribbage",
        "optTwistedCribbage",
        "optChutesAndLadders",
        "optSpades",
        "optGuessStarter",
        "optFivesCribbage",
        "optSevensAndEightsCribbage",
        "optDrawCribbage",
        "opt7CardCribbage",
        "optProgressiveCut",
        "optProgressiveSteals"
      ];
      if (typeof document !== "undefined") {
        crazyIds.forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.checked = false;
        });
        const checkAll = document.getElementById("checkAllBonuses");
        if (checkAll) checkAll.checked = false;
      }
      if (typeof window !== "undefined" && window.settings) {
        crazyIds.forEach((id) => {
          window.settings[id] = false;
          const shortKey = id.replace(/^opt/, "").charAt(0).toLowerCase() + id.replace(/^opt/, "").slice(1);
          window.settings[shortKey] = false;
        });
        window.settings.jokers = false;
      }
    }
  };

  // src/variants/ClashSandboxModal.js
  function escapeHtml2(str) {
    if (!str) return "";
    return sanitizeUserInput(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }
  var BRAND_ITEM_PALETTES = Object.freeze({
    clash: [
      { type: "jail", name: "Jail", icon: "\u{1F512}", color: "#94a3b8", length: 1, desc: "Locks peg until rolling a double or serving sentence" },
      { type: "bar", name: "The Bar", icon: "\u{1F378}", color: "#f59e0b", length: 1, desc: "Diverts peg for refreshments" },
      { type: "timeout", name: "Timeout", icon: "\u23F3", color: "#8b5cf6", length: 1, desc: "Lose a turn or pay a penalty point" },
      { type: "jump", name: "Jump", icon: "\u26A1", color: "#3b82f6", length: 1, desc: "Forward or backward shortcut vector" },
      { type: "noPassingLanes", name: "No Passing", icon: "\u{1F6AB}", color: "#ef4444", length: 5, desc: "5-hole bottleneck where passing is blocked" },
      { type: "stopSign", name: "Stop Sign", icon: "\u{1F6D1}", color: "#ef4444", length: 1, desc: "Forces peg movement to halt on this space" },
      { type: "signs", name: "Sign Block", icon: "\u{1FAA7}", color: "#ec4899", length: 3, desc: "Mystery interactive event block" },
      { type: "detour", name: "Detour", icon: "\u{1F500}", color: "#06b6d4", length: 1, desc: "Scenic bypass around a stretch of track" },
      { type: "roundAbout", name: "Roundabout", icon: "\u{1F504}", color: "#10b981", length: 1, desc: "Circular traffic loop" },
      { type: "dice", name: "Dice", icon: "\u{1F3B2}", color: "#a855f7", length: 1, desc: "Roll the dice minigame space" },
      { type: "wheel", name: "Spinning Wheel", icon: "\u{1F3A1}", color: "#ec4899", length: 1, desc: "Spin the wheel minigame space" }
    ],
    pints: [
      { type: "youDrink", name: "You Drink", icon: "\u{1F37A}", color: "#f59e0b", length: 1, desc: "Player landing here takes a drink / shot" },
      { type: "guysDrink", name: "Guys Drink", icon: "\u{1F37B}", color: "#6366f1", length: 1, desc: "All male players at the table take a drink" },
      { type: "galsDrink", name: "Gals Drink", icon: "\u{1F377}", color: "#f43f5e", length: 1, desc: "All female players at the table take a drink" },
      { type: "leftDrink", name: "Left Drinks", icon: "\u{1F448}", color: "#3b82f6", length: 1, desc: "Player to your left takes a drink" },
      { type: "rightDrink", name: "Right Drinks", icon: "\u{1F449}", color: "#06b6d4", length: 1, desc: "Player to your right takes a drink" },
      { type: "everyoneDrink", name: "Everyone Drinks", icon: "\u{1F942}", color: "#10b981", length: 1, desc: "Social! Everyone playing takes a drink" },
      { type: "everyoneButYouDrink", name: "Everyone But You", icon: "\u{1F389}", color: "#8b5cf6", length: 1, desc: "Everyone except the pegging player takes a drink" },
      { type: "pickWhoDrinks", name: "Pick Who Drinks", icon: "\u{1F3AF}", color: "#ec4899", length: 1, desc: "Choose any opponent to take a drink" }
    ],
    adult: [
      { type: "loseClothing", name: "You Strip", icon: "\u{1F459}", color: "#f43f5e", length: 1, desc: "Player loses an article of clothing" },
      { type: "gainClothing", name: "Gain Clothing", icon: "\u{1F9E5}", color: "#10b981", length: 1, desc: "Player regains an article of clothing" },
      { type: "pickWhoLosesClothing", name: "Pick Who Strips", icon: "\u{1F3AF}", color: "#ec4899", length: 1, desc: "Choose who loses an article of clothing" },
      { type: "rightLosesClothing", name: "Right Strips", icon: "\u{1F449}", color: "#3b82f6", length: 1, desc: "Person to your right loses clothing" },
      { type: "leftLosesClothing", name: "Left Strips", icon: "\u{1F448}", color: "#8b5cf6", length: 1, desc: "Person to your left loses clothing" },
      { type: "removeClothingChoice", name: "Remove Choice", icon: "\u2702\uFE0F", color: "#e11d48", length: 1, desc: "Remove clothing off player of choice" },
      { type: "touchBreast", name: "Touch Breast", icon: "\u{1F48B}", color: "#f43f5e", length: 1, desc: "Timed intimate challenge: Touch breast" },
      { type: "lickBreast", name: "Lick Breast", icon: "\u{1F445}", color: "#ec4899", length: 1, desc: "Timed intimate challenge: Lick breast" },
      { type: "suckBreast", name: "Suck Breast", icon: "\u{1F444}", color: "#d946ef", length: 1, desc: "Timed intimate challenge: Suck breast" },
      { type: "touchGenitals", name: "Touch Genitals", icon: "\u2728", color: "#a855f7", length: 1, desc: "Timed intimate challenge: Touch genitals" },
      { type: "lickGenitals", name: "Lick Genitals", icon: "\u{1F445}", color: "#f43f5e", length: 1, desc: "Timed intimate challenge: Lick genitals" },
      { type: "suckGenitals", name: "Suck Genitals", icon: "\u{1F444}", color: "#ec4899", length: 1, desc: "Timed intimate challenge: Suck genitals" },
      { type: "fingerGenitals", name: "Finger Genitals", icon: "\u{1F449}", color: "#f59e0b", length: 1, desc: "Timed intimate challenge: Finger genitals" }
    ]
  });
  var ClashSandboxModal = class _ClashSandboxModal {
    static pickingDestForJumpId = null;
    static draggedDestOfJump = null;
    static draggedTrayType = null;
    static activeSnappedHole = null;
    static isOpen = false;
    static _dragGuardsAttached = false;
    static _cachedHolesTarget = null;
    static _cachedHolesCoords = null;
    static init(brand = "clash") {
      this.brand = brand;
      this.activeLayout = null;
      this.selectedTrayType = null;
      this.draggedItem = null;
      this.targetVal = brand === "clash" ? 481 : 121;
      this.activeCustomLayoutId = null;
      this.activeCustomLayoutName = null;
      this.currentExportedLayout = null;
      this.pickingDestForJumpId = null;
      this.draggedDestOfJump = null;
      this.draggedTrayType = null;
      this.activeSnappedHole = null;
      _ClashSandboxModal.cleanupFloatingGhosts();
    }
    /**
     * Attaches window-level drag guards while the sandbox modal is open
     * to completely prevent the browser from navigating to dropped text or freezing.
     */
    static attachGlobalDragGuards() {
      if (_ClashSandboxModal._dragGuardsAttached || typeof window === "undefined") return;
      _ClashSandboxModal._dragGuardsAttached = true;
      _ClashSandboxModal._onGlobalDragOver = (e) => {
        if (_ClashSandboxModal.isOpen) {
          e.preventDefault();
        }
      };
      _ClashSandboxModal._onGlobalDrop = (e) => {
        if (_ClashSandboxModal.isOpen) {
          e.preventDefault();
        }
      };
      window.addEventListener("dragover", _ClashSandboxModal._onGlobalDragOver, { passive: false });
      window.addEventListener("drop", _ClashSandboxModal._onGlobalDrop, { passive: false });
    }
    static removeGlobalDragGuards() {
      if (!_ClashSandboxModal._dragGuardsAttached || typeof window === "undefined") return;
      _ClashSandboxModal._dragGuardsAttached = false;
      if (_ClashSandboxModal._onGlobalDragOver) {
        window.removeEventListener("dragover", _ClashSandboxModal._onGlobalDragOver);
      }
      if (_ClashSandboxModal._onGlobalDrop) {
        window.removeEventListener("drop", _ClashSandboxModal._onGlobalDrop);
      }
    }
    static cleanupFloatingGhosts() {
      if (typeof document === "undefined" || typeof document.querySelectorAll !== "function") return;
      document.querySelectorAll(".sb-floating-drag-ghost").forEach((el) => el.remove());
    }
    /**
     * Returns precomputed { x, y } coordinates for every hole up to targetVal - 1.
     */
    static getHoleCoordinatesMap(targetVal) {
      if (_ClashSandboxModal._cachedHolesTarget === targetVal && _ClashSandboxModal._cachedHolesCoords) {
        return _ClashSandboxModal._cachedHolesCoords;
      }
      const totalHoles = targetVal - 1;
      const coords = new Array(totalHoles + 1);
      for (let h = 1; h <= totalHoles; h++) {
        coords[h] = getTrackXY(h, "p1", targetVal);
      }
      _ClashSandboxModal._cachedHolesTarget = targetVal;
      _ClashSandboxModal._cachedHolesCoords = coords;
      return coords;
    }
    /**
     * Translates client pointer coordinates into the board SVG viewBox coordinate space.
     */
    static getSvgCoords(e, svg2) {
      if (!svg2) return { x: 0, y: 0 };
      const clientX = e.clientX !== void 0 ? e.clientX : e.touches && e.touches[0] ? e.touches[0].clientX : 0;
      const clientY = e.clientY !== void 0 ? e.clientY : e.touches && e.touches[0] ? e.touches[0].clientY : 0;
      const pt = svg2.createSVGPoint ? svg2.createSVGPoint() : null;
      const ctm = svg2.getScreenCTM ? svg2.getScreenCTM() : null;
      if (pt && ctm) {
        pt.x = clientX;
        pt.y = clientY;
        return pt.matrixTransform(ctm.inverse());
      }
      const rect = svg2.getBoundingClientRect();
      const vb = svg2.viewBox && svg2.viewBox.baseVal ? svg2.viewBox.baseVal : { width: 820, height: 438 };
      const scaleX = vb.width / (rect.width || 1);
      const scaleY = vb.height / (rect.height || 1);
      return {
        x: (clientX - rect.left) * scaleX,
        y: (clientY - rect.top) * scaleY
      };
    }
    /**
     * Snaps any coordinate on the board to the closest hole number (1 to targetVal - 1).
     */
    static findClosestHole(svgX, svgY, targetVal) {
      const coords = _ClashSandboxModal.getHoleCoordinatesMap(targetVal);
      let closestHole = 1;
      let minDistSq = Infinity;
      for (let h = 1; h < coords.length; h++) {
        const pt = coords[h];
        if (!pt) continue;
        const dx2 = pt.x - svgX;
        const dy2 = pt.y - svgY;
        const dSq = dx2 * dx2 + dy2 * dy2;
        if (dSq < minDistSq) {
          minDistSq = dSq;
          closestHole = h;
        }
      }
      return closestHole;
    }
    /**
     * Highlights the nearest snapped hole with visual pulse and moves the indicator ring.
     */
    static updateSnapHighlight(hole, svg2) {
      if (!hole || !svg2) return;
      if (_ClashSandboxModal.activeSnappedHole === hole) return;
      if (_ClashSandboxModal.activeSnappedHole) {
        const prevEl = svg2.querySelector(`.sb-hole[data-hole="${_ClashSandboxModal.activeSnappedHole}"]`);
        if (prevEl) prevEl.classList.remove("sb-hole-snap");
      }
      _ClashSandboxModal.activeSnappedHole = hole;
      const curEl = svg2.querySelector(`.sb-hole[data-hole="${hole}"]`);
      if (curEl) curEl.classList.add("sb-hole-snap");
      const snapIndicator = svg2.querySelector("#sbSnapIndicator");
      if (snapIndicator) {
        const pt = getTrackXY(hole, "p1", _ClashSandboxModal.targetVal);
        snapIndicator.setAttribute("cx", pt.x);
        snapIndicator.setAttribute("cy", pt.y);
        snapIndicator.setAttribute("opacity", "1");
      }
    }
    /**
     * Clears any active snapped hole highlight.
     */
    static clearSnapHighlight(svg2) {
      if (!svg2 && typeof document !== "undefined") svg2 = document.querySelector(".sandbox-svg-board");
      if (_ClashSandboxModal.activeSnappedHole && svg2) {
        const prevEl = svg2.querySelector(`.sb-hole[data-hole="${_ClashSandboxModal.activeSnappedHole}"]`);
        if (prevEl) prevEl.classList.remove("sb-hole-snap");
      }
      _ClashSandboxModal.activeSnappedHole = null;
      if (svg2) {
        const snapIndicator = svg2.querySelector("#sbSnapIndicator");
        if (snapIndicator) snapIndicator.setAttribute("opacity", "0");
      }
    }
    /**
     * Retrieves the block definitions for Clash from ClashSettings.getBlockDefs().
     * @returns {Array<Object>}
     */
    static getClashBlockDefs() {
      try {
        if (typeof getClashBlockDefs === "function") {
          const defs = getClashBlockDefs();
          if (Array.isArray(defs) && defs.length) return defs;
        }
        if (typeof ClashSettings !== "undefined" && typeof ClashSettings.getBlockDefs === "function") {
          return ClashSettings.getBlockDefs();
        }
        if (typeof window !== "undefined" && window.ClashSettings && typeof window.ClashSettings.getBlockDefs === "function") {
          return window.ClashSettings.getBlockDefs();
        }
        if (typeof window !== "undefined" && window.CC?.ClashSettings?.getBlockDefs) {
          return window.CC.ClashSettings.getBlockDefs();
        }
        if (typeof window !== "undefined" && window.crazyCribbageApp?.ClashSettings?.getBlockDefs) {
          return window.crazyCribbageApp.ClashSettings.getBlockDefs();
        }
      } catch (_) {
      }
      return [];
    }
    /**
     * Finds the block definition for a specific hazard/item type in ClashSettings.
     * @param {string} type
     * @returns {Object|null}
     */
    static getClashBlockDef(type) {
      const defs = _ClashSandboxModal.getClashBlockDefs();
      return defs.find((d) => d.type === type || d.key === type) || null;
    }
    /**
     * Retrieves the maximum number allowed for an item type.
     * For Cribbage Clash, this comes directly from ClashSettings.getBlockDefs().
     * @param {string} type
     * @param {string} [brand=ClashSandboxModal.brand]
     * @returns {number}
     */
    static getItemMaxCount(type, brand = _ClashSandboxModal.brand) {
      const resolvedBrand = brand || _ClashSandboxModal.brand || "clash";
      if (resolvedBrand === "clash") {
        const def = _ClashSandboxModal.getClashBlockDef(type);
        if (def && typeof def.maxCount === "number") {
          return def.maxCount;
        }
        const clashFallbackMaxes = {
          noPassingLanes: 4,
          jump: 8,
          jail: 4,
          bar: 4,
          timeout: 4,
          detour: 4,
          roundAbout: 4,
          signs: 8,
          stopSign: 8,
          dice: 4,
          wheel: 4
        };
        if (clashFallbackMaxes[type] !== void 0) return clashFallbackMaxes[type];
      }
      if (resolvedBrand === "pints") return 4;
      if (resolvedBrand === "adult") return 4;
      return 4;
    }
    /**
     * Retrieves the element ID of the count dropdown for a given hazard/item type.
     * Uses countId from ClashSettings.getBlockDefs() for clash items.
     * @param {string} type
     * @returns {string}
     */
    static getCountElementId(type) {
      const clashDef = _ClashSandboxModal.getClashBlockDef(type);
      if (clashDef && clashDef.countId) return clashDef.countId;
      if (type === "noPassingLanes") return "optNoPassingLaneCount";
      if (type === "wheel") {
        return typeof document !== "undefined" && document.getElementById("optSpinningWheelCount") ? "optSpinningWheelCount" : "optWheelCount";
      }
      return `opt${type.charAt(0).toUpperCase() + type.slice(1)}Count`;
    }
    /**
     * Retrieves the maximum allowed count for an item type in the sandbox.
     * For Cribbage Clash, this comes directly from ClashSettings.getBlockDefs().
     * @param {string} type
     * @param {string} [brand=ClashSandboxModal.brand]
     * @param {Object} [settings=null]
     * @returns {number}
     */
    static getItemLimit(type, brand = _ClashSandboxModal.brand, settings3 = null) {
      const resolvedBrand = brand || _ClashSandboxModal.brand || "clash";
      return _ClashSandboxModal.getItemMaxCount(type, resolvedBrand);
    }
    static _onExternalCountChange = () => {
      if (!_ClashSandboxModal.isOpen) return;
      _ClashSandboxModal.refreshView();
    };
    static bindExternalCountListeners() {
      if (typeof document === "undefined") return;
      const countEls = document.querySelectorAll('select[id$="Count"]');
      countEls.forEach((el) => {
        el.removeEventListener("change", _ClashSandboxModal._onExternalCountChange);
        el.addEventListener("change", _ClashSandboxModal._onExternalCountChange);
      });
    }
    static unbindExternalCountListeners() {
      if (typeof document === "undefined") return;
      const countEls = document.querySelectorAll('select[id$="Count"]');
      countEls.forEach((el) => {
        el.removeEventListener("change", _ClashSandboxModal._onExternalCountChange);
      });
    }
    /**
     * Retrieves the preset & storage engine corresponding to the current brand.
     * @param {string} [brand=ClashSandboxModal.brand]
     * @returns {Object}
     */
    static getPresetEngine(brand = _ClashSandboxModal.brand) {
      if (brand === "pints") return PintsPresets;
      if (brand === "adult") return AdultPresets;
      return ClashPresets;
    }
    /**
     * Opens the interactive Hazard Creator Sandbox for Clash, Pints & Pegs, or Skunked & Stripped.
     * @param {Object} [context={}]
     */
    static open(context = {}) {
      if (typeof document === "undefined") return;
      try {
        const detectedBrand = context.brand || (typeof window !== "undefined" && window.getAppBrand ? window.getAppBrand() : window.currentBrand || "clash");
        const brand = ["pints", "adult", "clash"].includes(detectedBrand) ? detectedBrand : "clash";
        _ClashSandboxModal.init(brand);
        _ClashSandboxModal.isOpen = true;
        _ClashSandboxModal.attachGlobalDragGuards();
        const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
        const fallbackTarget = brand === "clash" ? 481 : 121;
        const targetVal = Number(settings3.target || fallbackTarget);
        _ClashSandboxModal.targetVal = [121, 241, 361, 481].includes(targetVal) ? targetVal : fallbackTarget;
        const customPresetProp = brand === "pints" ? "pintsPreset" : brand === "adult" ? "adultPreset" : "clashPreset";
        const customLayoutIdProp = brand === "pints" ? "pintsCustomLayoutId" : brand === "adult" ? "adultCustomLayoutId" : "clashCustomLayoutId";
        const customLayoutNameProp = brand === "pints" ? "pintsCustomLayoutName" : brand === "adult" ? "adultCustomLayoutName" : "clashCustomLayoutName";
        if (settings3[customPresetProp] === "custom" && settings3[customLayoutIdProp]) {
          _ClashSandboxModal.activeCustomLayoutId = settings3[customLayoutIdProp];
          _ClashSandboxModal.activeCustomLayoutName = settings3[customLayoutNameProp] || "Custom Layout";
        }
        _ClashSandboxModal.activeLayout = _ClashSandboxModal.loadLayoutFromSettings(settings3, brand);
        const counts = {};
        _ClashSandboxModal.activeLayout = (_ClashSandboxModal.activeLayout || []).filter((item) => {
          const limit = _ClashSandboxModal.getItemLimit(item.type, brand, settings3);
          const curr = counts[item.type] || 0;
          if (curr < limit) {
            counts[item.type] = curr + 1;
            return true;
          }
          return false;
        });
        _ClashSandboxModal.bindExternalCountListeners();
        let overlay = document.getElementById("clashSandboxOverlay");
        if (!overlay) {
          overlay = document.createElement("div");
          overlay.id = "clashSandboxOverlay";
          overlay.className = "clash-sandbox-overlay";
          overlay.setAttribute("role", "dialog");
          overlay.setAttribute("aria-modal", "true");
          overlay.setAttribute("aria-label", "Track Hazard Sandbox");
          document.body.appendChild(overlay);
        }
        overlay.style.display = "flex";
        _ClashSandboxModal.renderModal(overlay);
        const btnVariantsMenu = document.getElementById("btnVariantsMenu");
        if (btnVariantsMenu) {
          btnVariantsMenu.classList.add("is-active");
          const b = brand || "clash";
          const label = b === "crazy" ? "Crazy Variants" : "Board Layout";
          btnVariantsMenu.title = `Hide ${label}`;
          btnVariantsMenu.setAttribute("aria-label", `Hide ${label}`);
        }
        if (context.openDrawer) {
          setTimeout(() => _ClashSandboxModal.openLayoutsDrawer(), 60);
        }
      } catch (err) {
        console.error("[ClashSandboxModal] Error opening sandbox:", err);
      }
    }
    /**
     * Closes the Hazard Creator Sandbox without saving changes.
     */
    static close() {
      if (typeof document === "undefined") return;
      _ClashSandboxModal.isOpen = false;
      _ClashSandboxModal.removeGlobalDragGuards();
      _ClashSandboxModal.cleanupFloatingGhosts();
      _ClashSandboxModal.unbindExternalCountListeners();
      const overlay = document.getElementById("clashSandboxOverlay");
      if (overlay) {
        overlay.style.display = "none";
      }
      const btnVariantsMenu = document.getElementById("btnVariantsMenu");
      if (btnVariantsMenu) {
        btnVariantsMenu.classList.remove("is-active");
        const b = _ClashSandboxModal.brand || "clash";
        const label = b === "crazy" ? "Crazy Variants" : "Board Layout";
        btnVariantsMenu.title = label;
        btnVariantsMenu.setAttribute("aria-label", label);
      }
      _ClashSandboxModal.draggedItem = null;
      _ClashSandboxModal.draggedDestOfJump = null;
      _ClashSandboxModal.draggedTrayType = null;
      _ClashSandboxModal.activeSnappedHole = null;
      _ClashSandboxModal.pickingDestForJumpId = null;
      _ClashSandboxModal.selectedTrayType = null;
      const svgWrap = document.getElementById("sandboxSvgWrap");
      if (svgWrap) svgWrap.classList.remove("sandbox-picking-active");
    }
    /**
     * Extracts placed spaces/hazards from active settings into an array of editable items.
     * @param {Object} settings
     * @param {string} [brand=ClashSandboxModal.brand]
     * @returns {Array<Object>}
     */
    static loadLayoutFromSettings(settings3, brand = _ClashSandboxModal.brand) {
      const items = [];
      const getVal = (id, arrKey = null, idx = 0) => {
        const el = typeof document !== "undefined" ? document.getElementById(id) : null;
        if (el && el.value !== "" && !isNaN(parseInt(el.value, 10))) return parseInt(el.value, 10);
        if (typeof settings3?.[id] === "number") return settings3[id];
        if (typeof settings3?.[id] === "string" && settings3[id].trim() !== "" && !isNaN(parseInt(settings3[id], 10))) {
          return parseInt(settings3[id], 10);
        }
        if (arrKey && Array.isArray(settings3?.[arrKey]) && typeof settings3[arrKey][idx] === "number") {
          return settings3[arrKey][idx];
        }
        return 0;
      };
      const isChecked = (chkId, cntId, idx, arrKey = null, type = null) => {
        const limit = type ? _ClashSandboxModal.getItemLimit(type, brand, settings3) : null;
        let cnt = limit !== null ? limit : null;
        if (cnt === null) {
          const el = typeof document !== "undefined" ? document.getElementById(cntId) : null;
          if (el && el.value !== "" && !isNaN(parseInt(el.value, 10))) {
            cnt = parseInt(el.value, 10);
          } else if (typeof settings3?.[cntId] === "number") {
            cnt = settings3[cntId];
          } else if (typeof settings3?.[cntId] === "string" && !isNaN(parseInt(settings3[cntId], 10))) {
            cnt = parseInt(settings3[cntId], 10);
          } else if (arrKey && Array.isArray(settings3?.[arrKey])) {
            cnt = settings3[arrKey].length;
          } else {
            cnt = 1;
          }
        }
        if (idx > cnt) return false;
        const chk = typeof document !== "undefined" ? document.getElementById(chkId) : null;
        const chkVal = chk ? chk.checked : settings3?.[chkId] !== void 0 ? Boolean(settings3[chkId]) : true;
        return Boolean(chkVal);
      };
      if (brand === "pints") {
        const palette = BRAND_ITEM_PALETTES.pints;
        palette.forEach((opt) => {
          const chkId = `opt${opt.type.charAt(0).toUpperCase() + opt.type.slice(1)}`;
          const cntId = _ClashSandboxModal.getCountElementId(opt.type);
          const arrKey = `${opt.type}Holes`;
          for (let i = 1; i <= 4; i++) {
            if (isChecked(chkId, cntId, i, arrKey, opt.type)) {
              const h = getVal(`opt${opt.type.charAt(0).toUpperCase() + opt.type.slice(1)}${i}Hole`, arrKey, i - 1);
              if (h > 0) {
                items.push({
                  id: `${opt.type}_${i}`,
                  type: opt.type,
                  name: `${opt.name} ${i}`,
                  icon: opt.icon,
                  color: opt.color,
                  hole: h,
                  length: 1
                });
              }
            }
          }
        });
        if (!items.length) {
          return _ClashSandboxModal.convertPresetToItems(PintsPresets.getPresets(_ClashSandboxModal.targetVal).standard.config, "pints");
        }
        return items;
      }
      if (brand === "adult") {
        const palette = BRAND_ITEM_PALETTES.adult;
        palette.forEach((opt) => {
          const chkId = `opt${opt.type.charAt(0).toUpperCase() + opt.type.slice(1)}`;
          const cntId = _ClashSandboxModal.getCountElementId(opt.type);
          const arrKey = `${opt.type}Holes`;
          for (let i = 1; i <= 4; i++) {
            if (isChecked(chkId, cntId, i, arrKey, opt.type)) {
              const h = getVal(`opt${opt.type.charAt(0).toUpperCase() + opt.type.slice(1)}${i}Hole`, arrKey, i - 1);
              if (h > 0) {
                items.push({
                  id: `${opt.type}_${i}`,
                  type: opt.type,
                  name: `${opt.name} ${i}`,
                  icon: opt.icon,
                  color: opt.color,
                  hole: h,
                  length: 1
                });
              }
            }
          }
        });
        if (!items.length) {
          return _ClashSandboxModal.convertPresetToItems(AdultPresets.getPresets(_ClashSandboxModal.targetVal).standard.config, "adult");
        }
        return items;
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("noPassingLanes", "clash"); i++) {
        if (isChecked("optNoPassingLanes", "optNoPassingLaneCount", i, "noPassingLaneStarts", "noPassingLanes")) {
          const h = getVal(`optNoPassingLane${i}Start`, "noPassingLaneStarts", i - 1);
          if (h > 0) items.push({ id: `lane_${i}`, type: "noPassingLanes", name: `No Passing ${i}`, icon: "\u{1F6AB}", color: "#ef4444", hole: h, length: 5 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("jump", "clash"); i++) {
        if (isChecked("optJump", "optJumpCount", i, "jumpStarts", "jump")) {
          const s = getVal(`optJump${i}Start`, "jumpStarts", i - 1);
          const d = getVal(`optJump${i}Dest`, "jumpDests", i - 1);
          if (s > 0) {
            items.push({
              id: `jump_${i}`,
              type: "jump",
              name: `Jump ${i}`,
              icon: "\u26A1",
              color: "#3b82f6",
              hole: s,
              dest: d > 0 ? d : Math.min(_ClashSandboxModal.targetVal - 5, s + 30),
              length: 1
            });
          }
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("jail", "clash"); i++) {
        if (isChecked("optJail", "optJailCount", i, "jailHoles", "jail")) {
          const h = getVal(`optJail${i}Hole`, "jailHoles", i - 1);
          if (h > 0) items.push({ id: `jail_${i}`, type: "jail", name: `Jail ${i}`, icon: "\u{1F512}", color: "#94a3b8", hole: h, length: 1 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("bar", "clash"); i++) {
        if (isChecked("optBar", "optBarCount", i, "barHoles", "bar")) {
          const h = getVal(`optBar${i}Hole`, "barHoles", i - 1);
          if (h > 0) items.push({ id: `bar_${i}`, type: "bar", name: `The Bar ${i}`, icon: "\u{1F378}", color: "#f59e0b", hole: h, length: 1 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("timeout", "clash"); i++) {
        if (isChecked("optTimeout", "optTimeoutCount", i, "timeoutHoles", "timeout")) {
          const h = getVal(`optTimeout${i}Hole`, "timeoutHoles", i - 1);
          if (h > 0) items.push({ id: `timeout_${i}`, type: "timeout", name: `Timeout ${i}`, icon: "\u23F3", color: "#8b5cf6", hole: h, length: 1 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("detour", "clash"); i++) {
        if (isChecked("optDetour", "optDetourCount", i, "detourHoles", "detour")) {
          const h = getVal(`optDetour${i}Hole`, "detourHoles", i - 1);
          if (h > 0) items.push({ id: `detour_${i}`, type: "detour", name: `Detour ${i}`, icon: "\u{1F500}", color: "#06b6d4", hole: h, length: 1 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("roundAbout", "clash"); i++) {
        if (isChecked("optRoundAbout", "optRoundAboutCount", i, "roundAboutHoles", "roundAbout")) {
          const h = getVal(`optRoundAbout${i}Hole`, "roundAboutHoles", i - 1);
          if (h > 0) items.push({ id: `roundAbout_${i}`, type: "roundAbout", name: `Round About ${i}`, icon: "\u{1F504}", color: "#10b981", hole: h, length: 1 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("signs", "clash"); i++) {
        if (isChecked("optSigns", "optSignsCount", i, "signsStarts", "signs")) {
          const h = getVal(`optSigns${i}Hole`, "signsStarts", i - 1);
          if (h > 0) items.push({ id: `signs_${i}`, type: "signs", name: `Signs ${i}`, icon: "\u{1FAA7}", color: "#ec4899", hole: h, length: 3 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("stopSign", "clash"); i++) {
        if (isChecked("optStopSign", "optStopSignCount", i, "stopSignHoles", "stopSign")) {
          const h = getVal(`optStopSign${i}Hole`, "stopSignHoles", i - 1);
          if (h > 0) items.push({ id: `stopSign_${i}`, type: "stopSign", name: `Stop Sign ${i}`, icon: "\u{1F6D1}", color: "#ef4444", hole: h, length: 1 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("dice", "clash"); i++) {
        if (isChecked("optDice", "optDiceCount", i, "diceHoles", "dice")) {
          const h = getVal(`optDice${i}Hole`, "diceHoles", i - 1);
          if (h > 0) items.push({ id: `dice_${i}`, type: "dice", name: `Dice ${i}`, icon: "\u{1F3B2}", color: "#a855f7", hole: h, length: 1 });
        }
      }
      for (let i = 1; i <= _ClashSandboxModal.getItemMaxCount("wheel", "clash"); i++) {
        if (isChecked("optWheel", "optWheelCount", i, "wheelHoles", "wheel") || isChecked("optSpinningWheel", "optWheelCount", i, "wheelHoles", "wheel") || isChecked("optSpinningWheel", "optSpinningWheelCount", i, "wheelHoles", "wheel")) {
          const h = getVal(`optWheel${i}Hole`, "wheelHoles", i - 1) || getVal(`optSpinningWheel${i}Hole`, "spinningWheelHoles", i - 1);
          if (h > 0) items.push({ id: `wheel_${i}`, type: "wheel", name: `Spinning Wheel ${i}`, icon: "\u{1F3A1}", color: "#ec4899", hole: h, length: 1 });
        }
      }
      if (!items.length) {
        return _ClashSandboxModal.convertPresetToItems(CLASH_PRESETS_481.standard.config, "clash");
      }
      return items;
    }
    /**
     * Converts a preset config object to an items array.
     * @param {Object} cfg
     * @param {string} [brand=ClashSandboxModal.brand]
     * @returns {Array<Object>}
     */
    static convertPresetToItems(cfg, brand = _ClashSandboxModal.brand) {
      const items = [];
      if (!cfg) return items;
      if (brand === "pints") {
        const palette = BRAND_ITEM_PALETTES.pints;
        palette.forEach((opt) => {
          const chkKey = `opt${opt.type.charAt(0).toUpperCase() + opt.type.slice(1)}`;
          const arr = cfg[`${opt.type}Holes`] || [];
          if (cfg[chkKey] || arr.length > 0) {
            const limit = _ClashSandboxModal.getItemLimit(opt.type, brand, cfg);
            const rawCnt = cfg[`${chkKey}Count`] || cfg[`${opt.type}Count`] || arr.length || 2;
            const cnt = Math.min(limit, rawCnt);
            for (let i = 1; i <= cnt; i++) {
              const h = cfg[`${chkKey}${i}Hole`] || arr[i - 1];
              if (h) items.push({ id: `${opt.type}_${i}`, type: opt.type, name: `${opt.name} ${i}`, icon: opt.icon, color: opt.color, hole: h, length: 1 });
            }
          }
        });
        return items;
      }
      if (brand === "adult") {
        const palette = BRAND_ITEM_PALETTES.adult;
        palette.forEach((opt) => {
          const chkKey = `opt${opt.type.charAt(0).toUpperCase() + opt.type.slice(1)}`;
          const arr = cfg[`${opt.type}Holes`] || [];
          if (cfg[chkKey] || arr.length > 0) {
            const limit = _ClashSandboxModal.getItemLimit(opt.type, brand, cfg);
            const rawCnt = cfg[`${chkKey}Count`] || cfg[`${opt.type}Count`] || arr.length || 2;
            const cnt = Math.min(limit, rawCnt);
            for (let i = 1; i <= cnt; i++) {
              const h = cfg[`${chkKey}${i}Hole`] || arr[i - 1];
              if (h) items.push({ id: `${opt.type}_${i}`, type: opt.type, name: `${opt.name} ${i}`, icon: opt.icon, color: opt.color, hole: h, length: 1 });
            }
          }
        });
        return items;
      }
      if (cfg.optNoPassingLanes || Array.isArray(cfg.noPassingLaneStarts) && cfg.noPassingLaneStarts.length) {
        const arr = cfg.noPassingLaneStarts || [];
        const limit = _ClashSandboxModal.getItemLimit("noPassingLanes", "clash", cfg);
        const rawCnt = cfg.optNoPassingLaneCount || cfg.noPassingLaneCount || arr.length || 4;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optNoPassingLane${i}Start`] || arr[i - 1];
          if (h) items.push({ id: `lane_${i}`, type: "noPassingLanes", name: `No Passing ${i}`, icon: "\u{1F6AB}", color: "#ef4444", hole: h, length: 5 });
        }
      }
      if (cfg.optJump || Array.isArray(cfg.jumpStarts) && cfg.jumpStarts.length) {
        const sArr = cfg.jumpStarts || [];
        const dArr = cfg.jumpDests || [];
        const limit = _ClashSandboxModal.getItemLimit("jump", "clash", cfg);
        const rawCnt = cfg.optJumpCount || cfg.jumpCount || sArr.length || 8;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const s = cfg[`optJump${i}Start`] || sArr[i - 1];
          const d = cfg[`optJump${i}Dest`] || dArr[i - 1];
          if (s) items.push({ id: `jump_${i}`, type: "jump", name: `Jump ${i}`, icon: "\u26A1", color: "#3b82f6", hole: s, dest: d, length: 1 });
        }
      }
      if (cfg.optJail || Array.isArray(cfg.jailHoles) && cfg.jailHoles.length) {
        const arr = cfg.jailHoles || [];
        const limit = _ClashSandboxModal.getItemLimit("jail", "clash", cfg);
        const rawCnt = cfg.optJailCount || cfg.jailCount || arr.length || 2;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optJail${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `jail_${i}`, type: "jail", name: `Jail ${i}`, icon: "\u{1F512}", color: "#94a3b8", hole: h, length: 1 });
        }
      }
      if (cfg.optBar || Array.isArray(cfg.barHoles) && cfg.barHoles.length) {
        const arr = cfg.barHoles || [];
        const limit = _ClashSandboxModal.getItemLimit("bar", "clash", cfg);
        const rawCnt = cfg.optBarCount || cfg.barCount || arr.length || 2;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optBar${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `bar_${i}`, type: "bar", name: `The Bar ${i}`, icon: "\u{1F378}", color: "#f59e0b", hole: h, length: 1 });
        }
      }
      if (cfg.optTimeout || Array.isArray(cfg.timeoutHoles) && cfg.timeoutHoles.length) {
        const arr = cfg.timeoutHoles || [];
        const limit = _ClashSandboxModal.getItemLimit("timeout", "clash", cfg);
        const rawCnt = cfg.optTimeoutCount || cfg.timeoutCount || arr.length || 2;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optTimeout${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `timeout_${i}`, type: "timeout", name: `Timeout ${i}`, icon: "\u23F3", color: "#8b5cf6", hole: h, length: 1 });
        }
      }
      if (cfg.optDetour || Array.isArray(cfg.detourHoles) && cfg.detourHoles.length) {
        const arr = cfg.detourHoles || [];
        const limit = _ClashSandboxModal.getItemLimit("detour", "clash", cfg);
        const rawCnt = cfg.optDetourCount || cfg.detourCount || arr.length || 2;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optDetour${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `detour_${i}`, type: "detour", name: `Detour ${i}`, icon: "\u{1F500}", color: "#06b6d4", hole: h, length: 1 });
        }
      }
      if (cfg.optRoundAbout || Array.isArray(cfg.roundAboutHoles) && cfg.roundAboutHoles.length) {
        const arr = cfg.roundAboutHoles || [];
        const limit = _ClashSandboxModal.getItemLimit("roundAbout", "clash", cfg);
        const rawCnt = cfg.optRoundAboutCount || cfg.roundAboutCount || arr.length || 2;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optRoundAbout${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `roundAbout_${i}`, type: "roundAbout", name: `Round About ${i}`, icon: "\u{1F504}", color: "#10b981", hole: h, length: 1 });
        }
      }
      if (cfg.optSigns || Array.isArray(cfg.signsStarts) && cfg.signsStarts.length) {
        const arr = cfg.signsStarts || [];
        const limit = _ClashSandboxModal.getItemLimit("signs", "clash", cfg);
        const rawCnt = cfg.optSignsCount || cfg.signsCount || arr.length || 4;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optSigns${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `signs_${i}`, type: "signs", name: `Signs ${i}`, icon: "\u{1FAA7}", color: "#ec4899", hole: h, length: 3 });
        }
      }
      if (cfg.optStopSign || Array.isArray(cfg.stopSignHoles) && cfg.stopSignHoles.length) {
        const arr = cfg.stopSignHoles || [];
        const limit = _ClashSandboxModal.getItemLimit("stopSign", "clash", cfg);
        const rawCnt = cfg.optStopSignCount || cfg.stopSignCount || arr.length || 8;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optStopSign${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `stopSign_${i}`, type: "stopSign", name: `Stop Sign ${i}`, icon: "\u{1F6D1}", color: "#ef4444", hole: h, length: 1 });
        }
      }
      if (cfg.optDice || Array.isArray(cfg.diceHoles) && cfg.diceHoles.length) {
        const arr = cfg.diceHoles || [];
        const limit = _ClashSandboxModal.getItemLimit("dice", "clash", cfg);
        const rawCnt = cfg.optDiceCount || cfg.diceCount || arr.length || 4;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optDice${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `dice_${i}`, type: "dice", name: `Dice ${i}`, icon: "\u{1F3B2}", color: "#a855f7", hole: h, length: 1 });
        }
      }
      if (cfg.optWheel || cfg.optSpinningWheel || Array.isArray(cfg.wheelHoles) && cfg.wheelHoles.length) {
        const arr = cfg.wheelHoles || cfg.spinningWheelHoles || [];
        const limit = _ClashSandboxModal.getItemLimit("wheel", "clash", cfg);
        const rawCnt = cfg.optWheelCount || cfg.optSpinningWheelCount || cfg.wheelCount || arr.length || 4;
        const cnt = Math.min(limit, rawCnt);
        for (let i = 1; i <= cnt; i++) {
          const h = cfg[`optWheel${i}Hole`] || cfg[`optSpinningWheel${i}Hole`] || cfg[`wheel${i}Hole`] || arr[i - 1];
          if (h) items.push({ id: `wheel_${i}`, type: "wheel", name: `Spinning Wheel ${i}`, icon: "\u{1F3A1}", color: "#ec4899", hole: h, length: 1 });
        }
      }
      return items;
    }
    /**
     * Renders the complete Sandbox modal HTML and wires interactive events.
     * @param {HTMLElement} overlay
     */
    static renderModal(overlay) {
      const brand = _ClashSandboxModal.brand || "clash";
      const targetVal = _ClashSandboxModal.targetVal;
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const customLayouts = engine.getCustomLayouts ? engine.getCustomLayouts() : [];
      const customCount = customLayouts.length;
      const activeName = _ClashSandboxModal.activeCustomLayoutName;
      let modalTitle = "CRIBBAGE CLASH HAZARD CREATOR";
      let modalIcon = "\u{1F6E0}\uFE0F";
      let modalSub = `Drag hazards from the tray to any hole, or move placed items around the ${targetVal}-hole circular track.`;
      let presetsHtml = "";
      if (brand === "pints") {
        modalTitle = "PINTS & PEGS DRINKING BOARD SANDBOX";
        modalIcon = "\u{1F37B}";
        modalSub = `Drag drinking tiles to any hole on the ${targetVal === 121 ? "121-hole board" : `${targetVal}-hole track`} to create your custom drinking party layout.`;
        presetsHtml = `
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="standard">\u{1F37B} Pub Crawl</button>
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="powerHour">\u26A1 Power Hour</button>
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="socialHour">\u{1F942} Social Hour</button>
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="battleOfSexes">\u{1F94A} Battle of Sexes</button>
      `;
      } else if (brand === "adult") {
        modalTitle = "SKUNKED & STRIPPED DARE SANDBOX";
        modalIcon = "\u{1F48B}";
        modalSub = `Place strip and timed challenge spaces along the ${targetVal === 121 ? "121-hole board" : `${targetVal}-hole track`} to craft your intimate game.`;
        presetsHtml = `
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="standard">\u{1F457} Warm-Up Strip</button>
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="highHeat">\u{1F525} High Heat</button>
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="sensualGauntlet">\u23F3 Sensual Gauntlet</button>
      `;
      } else {
        presetsHtml = `
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="standard">\u{1F3DB}\uFE0F Classic</button>
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="gauntlet">\u2694\uFE0F The Gauntlet</button>
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="speedway">\u{1F680} Speedway</button>
        <button type="button" class="sandbox-preset-pill" data-action="apply-preset" data-preset="bottleneck">\u{1F6D1} Bottleneck</button>
      `;
      }
      overlay.innerHTML = `
      <div class="clash-sandbox-box sandbox-theme-${brand}" id="clashSandboxBox">
        <!-- Top Header -->
        <div class="sandbox-header">
          <div class="sandbox-title-wrap">
            <span class="sandbox-title-icon">${modalIcon}</span>
            <div>
              <div class="sandbox-title-row">
                <h2 class="sandbox-title">${modalTitle}</h2>
                <span class="sandbox-active-badge ${activeName ? "is-visible" : ""}" id="sandboxActiveBadge">
                  ${activeName ? `\u{1F4C1} Custom: <strong>${escapeHtml2(activeName)}</strong>` : ""}
                </span>
              </div>
              <div class="sandbox-sub">${modalSub}</div>
            </div>
          </div>
          <button type="button" class="btn-ghost sandbox-btn-close" data-action="close" title="Cancel and Close">\u2715 Close</button>
        </div>

        <!-- Presets Quick Bar -->
        <div class="sandbox-presets-bar">
          <div class="sandbox-presets-left">
            <span class="sandbox-presets-label">Layout Presets:</span>
            <div class="sandbox-preset-pills">
              ${presetsHtml}
              <button type="button" class="sandbox-preset-pill sandbox-rand-pill" data-action="randomize">\u{1F3B2} Full Random</button>
              <button type="button" class="sandbox-preset-pill sandbox-clear-pill" data-action="clear-all">\u{1F9F9} Clear All</button>
            </div>
          </div>
          <div class="sandbox-presets-right">
            <button type="button" class="sandbox-preset-pill sandbox-custom-pill" id="btnOpenCustomLayouts" data-action="open-drawer" title="View and load saved custom track layouts">
              \u{1F4C1} My Layouts <span class="sandbox-badge-count" id="sandboxCustomLayoutCount">${customCount}</span>
            </button>
            <button type="button" class="sandbox-preset-pill sandbox-save-pill" data-action="open-save" title="Save current hazard placements to your custom layouts library">
              \u{1F4BE} ${activeName ? "Save / Update" : "Save Layout"}
            </button>
          </div>
        </div>

        <!-- Live Track Analysis Stats -->
        <div class="sandbox-metrics-bar" id="sandboxMetricsBar">
          ${_ClashSandboxModal.renderMetricsBarHtml()}
        </div>

        <!-- Pick Destination Mode Banner -->
        <div class="sandbox-pick-banner" id="sandboxPickBanner" style="display: none;">
          <span class="spb-icon">\u{1F3AF}</span>
          <span class="spb-text" id="sandboxPickBannerText">Click any hole on the board to set destination for Jump</span>
          <button type="button" class="btn-xs btn-ghost" data-action="cancel-pick-dest">\u2715 Cancel</button>
        </div>

        <!-- Interactive Board Viewport -->
        <div class="sandbox-board-viewport" id="sandboxBoardViewport">
          <div class="sandbox-board-svg-wrap" id="sandboxSvgWrap"></div>
        </div>

        <!-- Space Palette Tray -->
        <div class="sandbox-tray-wrap">
          <div class="sandbox-tray-title">Space Palette (Drag onto board or click to select & place):</div>
          <div class="sandbox-tray-items" id="sandboxTrayItems">
            ${_ClashSandboxModal.renderTrayButtons()}
          </div>
        </div>

        <!-- Action Footer -->
        <div class="sandbox-footer">
          <div class="sandbox-footer-hint" id="sandboxFooterHint">
            \u{1F4A1} <em>Click any placed space to remove/reposition. Click \u26A1 Jump or \u{1F3AF} to set destination.</em>
          </div>
          <div class="sandbox-footer-actions">
            <button type="button" class="btn-secondary" data-action="close">Cancel</button>
            <button type="button" class="btn-secondary sandbox-btn-quick-save" data-action="open-save" title="Save layout to library">
              \u{1F4BE} Save to Library
            </button>
            <button type="button" class="btn-primary btn-gold sandbox-btn-apply" data-action="apply-and-save">
              \u2714 Apply Board Layout
            </button>
          </div>
        </div>
      </div>

      <!-- Custom Layouts Library Drawer Overlay -->
      <div class="sandbox-drawer-overlay" id="sandboxDrawerOverlay" style="display: none;">
        <div class="sandbox-drawer" id="sandboxDrawer">
          <div class="sandbox-drawer-header">
            <div class="sandbox-drawer-title-wrap">
              <span class="sandbox-drawer-icon">\u{1F4C1}</span>
              <div>
                <h3 class="sandbox-drawer-title">${brand === "pints" ? "My Custom Drinking Boards" : brand === "adult" ? "My Custom Adult Boards" : "My Custom Track Layouts"}</h3>
                <div class="sandbox-drawer-sub">Saved on this device</div>
              </div>
            </div>
            <div class="sandbox-drawer-header-actions">
              <button type="button" class="btn-sm btn-gold" data-action="open-save" data-is-current="true">\u2795 Save Current</button>
              <button type="button" class="sandbox-drawer-close" data-action="close-drawer" title="Close Drawer">\u2715</button>
            </div>
          </div>
          <div class="sandbox-drawer-body" id="sandboxDrawerList">
            ${_ClashSandboxModal.renderCustomLayoutCards()}
          </div>
        </div>
      </div>

      <!-- Save / Rename Dialog Overlay -->
      <div class="sandbox-dialog-overlay" id="sandboxSaveDialogOverlay" style="display: none;">
        <div class="sandbox-dialog-box" id="sandboxSaveDialogBox">
          <div class="sandbox-dialog-header">
            <span class="sandbox-dialog-icon">\u{1F4BE}</span>
            <div>
              <h3 class="sandbox-dialog-title" id="sandboxSaveDialogTitle">Save Custom Track Layout</h3>
              <div class="sandbox-dialog-sub">Enter a unique name for this layout.</div>
            </div>
            <button type="button" class="sandbox-dialog-close" data-action="close-save-dialog">\u2715</button>
          </div>
          <div class="sandbox-dialog-body">
            <div class="sandbox-form-group">
              <label class="sandbox-form-label" for="txtCustomLayoutName">Layout Name</label>
              <input type="text" class="sandbox-input" id="txtCustomLayoutName" placeholder="e.g. PubCrawl120" maxlength="40" pattern="[a-zA-Z0-9]+">
              <div class="sandbox-form-error" id="saveLayoutError" style="display: none;"></div>
            </div>
          </div>
          <div class="sandbox-dialog-footer" id="sandboxSaveDialogFooter">
            <button type="button" class="btn-secondary" data-action="close-save-dialog">Cancel</button>
            <button type="button" class="btn-primary btn-gold" id="btnConfirmSaveLayout" data-action="submit-save-layout" data-as-new="false">
              \u{1F4BE} Save Layout
            </button>
          </div>
        </div>
      </div>

      <!-- Import JSON Dialog Overlay -->
      <div class="sandbox-dialog-overlay" id="sandboxImportDialogOverlay" style="display: none;">
        <div class="sandbox-dialog-box" id="sandboxImportDialogBox">
          <div class="sandbox-dialog-header">
            <span class="sandbox-dialog-icon">\u{1F4E5}</span>
            <div>
              <h3 class="sandbox-dialog-title">Import Track Layout</h3>
              <div class="sandbox-dialog-sub">Paste track layout JSON shared by friends or exported previously.</div>
            </div>
            <button type="button" class="sandbox-dialog-close" data-action="close-import-dialog">\u2715</button>
          </div>
          <div class="sandbox-dialog-body">
            <div class="sandbox-form-group">
              <label class="sandbox-form-label" for="txtImportLayoutJson">Layout JSON</label>
              <textarea class="sandbox-textarea" id="txtImportLayoutJson" rows="6" placeholder="Paste { ... } or [ ... ] JSON here..."></textarea>
              <div class="sandbox-form-error" id="importLayoutError" style="display: none;"></div>
            </div>
          </div>
          <div class="sandbox-dialog-footer">
            <button type="button" class="btn-secondary" data-action="close-import-dialog">Cancel</button>
            <button type="button" class="btn-primary btn-gold" data-action="submit-import-layout">
              \u{1F4E5} Import Track
            </button>
          </div>
        </div>
      </div>

      <!-- Export / Share JSON Dialog Overlay -->
      <div class="sandbox-dialog-overlay" id="sandboxExportDialogOverlay" style="display: none;">
        <div class="sandbox-dialog-box" id="sandboxExportDialogBox">
          <div class="sandbox-dialog-header">
            <span class="sandbox-dialog-icon">\u{1F4E4}</span>
            <div>
              <h3 class="sandbox-dialog-title" id="sandboxExportDialogTitle">Share Track Layout</h3>
              <div class="sandbox-dialog-sub" id="sandboxExportDialogSub">Copy track JSON or download as a file to share with friends.</div>
            </div>
            <button type="button" class="sandbox-dialog-close" data-action="close-export-dialog">\u2715</button>
          </div>
          <div class="sandbox-dialog-body">
            <div class="sandbox-form-group">
              <label class="sandbox-form-label" for="txtExportLayoutJson">Track Layout JSON</label>
              <textarea class="sandbox-textarea" id="txtExportLayoutJson" rows="7" readonly style="cursor: text; user-select: all;"></textarea>
              <div class="sandbox-form-help" id="sandboxExportHelp" style="margin-top: 6px; font-size: 0.8rem; color: #94a3b8;">
                Click inside to select all, or use the buttons below.
              </div>
            </div>
          </div>
          <div class="sandbox-dialog-footer" style="display: flex; gap: 8px; justify-content: space-between; flex-wrap: wrap;">
            <div style="display: flex; gap: 8px;">
              <button type="button" class="btn-secondary btn-sm" id="btnDownloadLayoutJson" data-action="download-export-layout" title="Download layout as a .json file">
                \u{1F4BE} Download .json
              </button>
              <button type="button" class="btn-secondary btn-sm" id="btnSystemShareLayout" style="display: none;" data-action="system-share-layout" title="Share via device share menu">
                \u{1F517} Share...
              </button>
            </div>
            <div style="display: flex; gap: 8px;">
              <button type="button" class="btn-secondary btn-sm" data-action="close-export-dialog">Close</button>
              <button type="button" class="btn-primary btn-gold btn-sm" id="btnCopyExportJson" data-action="copy-export-json">
                \u{1F4CB} Copy Layout
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Jump Vector / Destination Dialog Overlay -->
      <div class="sandbox-dialog-overlay" id="sandboxJumpDialogOverlay" style="display: none;">
        <div class="sandbox-dialog-box" id="sandboxJumpDialogBox" style="max-width: 440px;">
          <div class="sandbox-dialog-header">
            <span class="sandbox-dialog-icon">\u26A1</span>
            <div>
              <h3 class="sandbox-dialog-title" id="sandboxJumpDialogTitle">Configure Jump Vector</h3>
              <div class="sandbox-dialog-sub">Set trigger and destination holes for this shortcut or trap.</div>
            </div>
            <button type="button" class="sandbox-dialog-close" data-action="close-jump-dialog">\u2715</button>
          </div>
          <div class="sandbox-dialog-body">
            <input type="hidden" id="txtJumpItemId" />
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px;">
              <div class="sandbox-form-group">
                <label class="sandbox-form-label" for="numJumpStart">\u26A1 Trigger Hole</label>
                <input type="number" class="sandbox-input" id="numJumpStart" min="1" max="${targetVal - 1}" />
              </div>
              <div class="sandbox-form-group">
                <label class="sandbox-form-label" for="numJumpDest">\u{1F3AF} Destination Hole</label>
                <input type="number" class="sandbox-input" id="numJumpDest" min="1" max="${targetVal - 1}" />
              </div>
            </div>

            <div style="margin-bottom: 12px;">
              <label class="sandbox-form-label" style="display: block; margin-bottom: 6px;">\u26A1 Quick Offsets</label>
              <div style="display: flex; gap: 6px; flex-wrap: wrap;">
                <button type="button" class="btn-xs btn-ghost jump-offset-btn" data-action="apply-jump-offset" data-offset="15">+15</button>
                <button type="button" class="btn-xs btn-ghost jump-offset-btn" data-action="apply-jump-offset" data-offset="30">+30</button>
                <button type="button" class="btn-xs btn-ghost jump-offset-btn" data-action="apply-jump-offset" data-offset="50">+50</button>
                <button type="button" class="btn-xs btn-ghost jump-offset-btn" data-action="apply-jump-offset" data-offset="-15">-15</button>
                <button type="button" class="btn-xs btn-ghost jump-offset-btn" data-action="apply-jump-offset" data-offset="-30">-30</button>
              </div>
            </div>

            <div id="jumpVectorSummary" style="padding: 10px 14px; border-radius: 8px; font-size: 0.88rem; margin-bottom: 14px; font-weight: 600; text-align: center; border: 1px solid rgba(255,255,255,0.1); background: rgba(0,0,0,0.3);">
            </div>

            <div style="display: flex; gap: 8px;">
              <button type="button" class="btn-secondary btn-sm" style="flex: 1; padding: 8px;" data-action="start-pick-dest">
                \u{1F3AF} Pick Destination on Board
              </button>
            </div>

            <div class="sandbox-form-error" id="jumpConfigError" style="display: none; margin-top: 8px;"></div>
          </div>
          <div class="sandbox-dialog-footer" style="display: flex; justify-content: space-between;">
            <button type="button" class="btn-danger btn-sm" data-action="delete-jump" title="Delete this jump from the board">
              \u{1F5D1}\uFE0F Remove Jump
            </button>
            <div style="display: flex; gap: 8px;">
              <button type="button" class="btn-secondary btn-sm" data-action="close-jump-dialog">Cancel</button>
              <button type="button" class="btn-primary btn-gold btn-sm" data-action="save-jump-dialog">
                \u2713 Apply Destination
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
      _ClashSandboxModal.renderBoardSvg();
      _ClashSandboxModal.bindTrayEvents();
      _ClashSandboxModal.bindModalEvents(overlay);
    }
    /**
     * Centralized event delegation and listener binder for the Sandbox modal.
     * Eliminates inline onclick/oninput/onkeydown attributes.
     * @param {HTMLElement} overlay
     */
    static bindModalEvents(overlay) {
      if (!overlay) return;
      overlay.addEventListener("click", (e) => {
        if (e.target.id === "sandboxDrawerOverlay") {
          _ClashSandboxModal.closeLayoutsDrawer();
          return;
        }
        if (e.target.id === "sandboxSaveDialogOverlay") {
          _ClashSandboxModal.closeSaveDialog();
          return;
        }
        if (e.target.id === "sandboxImportDialogOverlay") {
          _ClashSandboxModal.closeImportDialog();
          return;
        }
        if (e.target.id === "sandboxExportDialogOverlay") {
          _ClashSandboxModal.closeExportDialog();
          return;
        }
        if (e.target.id === "sandboxJumpDialogOverlay") {
          _ClashSandboxModal.closeJumpConfigDialog();
          return;
        }
        if (e.target.closest("#sandboxDrawerList")) {
          _ClashSandboxModal.handleDrawerAction(e);
          return;
        }
        const actionBtn = e.target.closest("[data-action]");
        if (!actionBtn) return;
        const action = actionBtn.dataset.action;
        switch (action) {
          case "apply-preset": {
            const key = actionBtn.dataset.preset;
            if (key) _ClashSandboxModal.applyPresetKey(key);
            break;
          }
          case "close":
            _ClashSandboxModal.close();
            break;
          case "randomize":
            _ClashSandboxModal.randomizeLayout();
            break;
          case "clear-all":
            _ClashSandboxModal.clearAllHazards();
            break;
          case "open-drawer":
            _ClashSandboxModal.openLayoutsDrawer();
            break;
          case "close-drawer":
            _ClashSandboxModal.closeLayoutsDrawer();
            break;
          case "open-save": {
            const isCurrent = actionBtn.dataset.isCurrent === "true";
            _ClashSandboxModal.openSaveDialog(isCurrent);
            break;
          }
          case "close-save-dialog":
            _ClashSandboxModal.closeSaveDialog();
            break;
          case "submit-save-layout": {
            const asNew = actionBtn.dataset.asNew === "true";
            _ClashSandboxModal.submitSaveLayout(asNew);
            break;
          }
          case "cancel-pick-dest":
            _ClashSandboxModal.cancelPickDestinationMode();
            break;
          case "apply-and-save":
            _ClashSandboxModal.applyAndSave();
            break;
          case "close-import-dialog":
            _ClashSandboxModal.closeImportDialog();
            break;
          case "submit-import-layout":
            _ClashSandboxModal.submitImportLayout();
            break;
          case "close-export-dialog":
            _ClashSandboxModal.closeExportDialog();
            break;
          case "download-export-layout":
            _ClashSandboxModal.downloadExportedLayout();
            break;
          case "system-share-layout":
            _ClashSandboxModal.systemShareExportedLayout();
            break;
          case "copy-export-json":
            _ClashSandboxModal.copyExportedJsonToClipboard();
            break;
          case "close-jump-dialog":
            _ClashSandboxModal.closeJumpConfigDialog();
            break;
          case "apply-jump-offset": {
            const offset = parseInt(actionBtn.dataset.offset, 10);
            if (!isNaN(offset)) _ClashSandboxModal.applyJumpOffset(offset);
            break;
          }
          case "start-pick-dest":
            _ClashSandboxModal.startPickDestinationMode();
            break;
          case "delete-jump":
            _ClashSandboxModal.deleteCurrentJump();
            break;
          case "save-jump-dialog":
            _ClashSandboxModal.saveJumpConfigDialog();
            break;
        }
      });
      const txtName = overlay.querySelector("#txtCustomLayoutName");
      if (txtName) {
        txtName.addEventListener("input", () => {
          txtName.value = txtName.value.replace(/[^a-zA-Z0-9]/g, "");
        });
        txtName.addEventListener("keydown", (e) => {
          if (e.key === "Enter") _ClashSandboxModal.submitSaveLayout();
        });
      }
      const txtExport = overlay.querySelector("#txtExportLayoutJson");
      if (txtExport) {
        txtExport.addEventListener("click", () => txtExport.select());
      }
      const numStart = overlay.querySelector("#numJumpStart");
      if (numStart) {
        numStart.addEventListener("input", () => _ClashSandboxModal.onJumpInputChanged());
      }
      const numDest = overlay.querySelector("#numJumpDest");
      if (numDest) {
        numDest.addEventListener("input", () => _ClashSandboxModal.onJumpInputChanged());
      }
    }
    /**
     * Renders the draggable/selectable buttons for each space type in the palette.
     * @returns {string}
     */
    static renderTrayButtons() {
      const brand = _ClashSandboxModal.brand || "clash";
      const palette = BRAND_ITEM_PALETTES[brand] || BRAND_ITEM_PALETTES.clash;
      const layout = _ClashSandboxModal.activeLayout || [];
      const counts = {};
      layout.forEach((item) => {
        counts[item.type] = (counts[item.type] || 0) + 1;
      });
      return palette.map((p) => {
        const placed = counts[p.type] || 0;
        const limit = _ClashSandboxModal.getItemLimit(p.type, brand);
        const isMaxed = placed >= limit;
        const isSelected = _ClashSandboxModal.selectedTrayType === p.type && !isMaxed;
        const title = isMaxed ? `${p.name} \u2014 Maximum capacity reached (${placed}/${limit}) as defined in ClashSettings.` : `${p.name} (${p.desc}) \u2014 ${placed}/${limit} placed. Click to select, then click any hole; or drag onto hole.`;
        const badgeStyle = isMaxed ? "background: rgba(239, 68, 68, 0.2); color: #f87171; border: 1px solid rgba(239, 68, 68, 0.5); font-weight: 700;" : `background: ${p.color}33; color: ${p.color}; border: 1px solid ${p.color}66;`;
        return `
        <div class="sandbox-tray-btn ${isSelected ? "is-selected" : ""} ${isMaxed ? "disabled is-maxed" : ""}"
             data-hazard-type="${p.type}"
             data-placed="${placed}"
             data-limit="${limit}"
             draggable="${isMaxed ? "false" : "true"}"
             title="${escapeHtml2(title)}">
          <span class="tray-icon">${p.icon}</span>
          <span class="tray-name">${escapeHtml2(p.name)}</span>
          <span class="tray-count ${isMaxed ? "is-maxed" : ""}" style="${badgeStyle}">
            ${placed} / ${limit}
          </span>
        </div>
      `;
      }).join("");
    }
    /**
     * Renders the SVG board with interactive holes and placed space tokens.
     */
    static renderBoardSvg() {
      if (typeof document === "undefined") return;
      const container = document.getElementById("sandboxSvgWrap");
      if (!container) return;
      container.innerHTML = "";
      const targetVal = _ClashSandboxModal.targetVal;
      const is121 = targetVal === 121;
      const clashCfg = is121 ? null : getClashBoardCfg(targetVal);
      const viewW = is121 ? 820 : clashCfg.viewW;
      const viewH = is121 ? 216 : clashCfg.viewH;
      const totalHoles = targetVal - 1;
      const svg2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg2.setAttribute("viewBox", `0 0 ${viewW} ${viewH}`);
      svg2.setAttribute("class", "sandbox-svg-board");
      const bgX = 15;
      const bgY = 12;
      const bgW = viewW - 30;
      const bgH = viewH - 24;
      const bgRx = 16;
      svg2.innerHTML = `
      <defs>
        <linearGradient id="sbBoardWoodGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#eed5ad" />
          <stop offset="45%" stop-color="#e2c191" />
          <stop offset="80%" stop-color="#d4af7a" />
          <stop offset="100%" stop-color="#c69e67" />
        </linearGradient>
        <marker id="sbArrowGreen" viewBox="0 0 10 10" refX="7" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill="#22c55e" />
        </marker>
        <marker id="sbArrowRed" viewBox="0 0 10 10" refX="7" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill="#ef4444" />
        </marker>
      </defs>
      <rect x="${bgX}" y="${bgY}" width="${bgW}" height="${bgH}" rx="${bgRx}"
            fill="url(#sbBoardWoodGrad)" stroke="#6b3a12" stroke-width="3" />
    `;
      const milestonesGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
      milestonesGroup.id = "sbMilestones";
      svg2.appendChild(milestonesGroup);
      const jumpsGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
      jumpsGroup.id = "sbJumps";
      svg2.appendChild(jumpsGroup);
      const holesGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
      holesGroup.id = "sbHoles";
      svg2.appendChild(holesGroup);
      const tokensGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
      tokensGroup.id = "sbHazardTokens";
      svg2.appendChild(tokensGroup);
      container.appendChild(svg2);
      if (is121) {
        for (let h = 5; h <= 120; h += 5) {
          const pt = getTrackXY(h, "p1", 121);
          const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
          line.setAttribute("x1", pt.x);
          line.setAttribute("y1", pt.y - 7);
          line.setAttribute("x2", pt.x);
          line.setAttribute("y2", pt.y + 7);
          line.setAttribute("stroke", "#6d421a");
          line.setAttribute("stroke-opacity", "0.55");
          line.setAttribute("stroke-width", "1.5");
          milestonesGroup.appendChild(line);
        }
      } else {
        for (let r = 0; r < clashCfg.numRows; r++) {
          const y = clashCfg.stY[r];
          const startH = r * 60 + 1;
          for (let g = 1; g <= 11; g++) {
            const h = startH + g * 5 - 1;
            const pt = getTrackXY(h, "p1", targetVal);
            const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
            line.setAttribute("x1", pt.x);
            line.setAttribute("y1", y - 8);
            line.setAttribute("x2", pt.x);
            line.setAttribute("y2", y + 8);
            line.setAttribute("stroke", "#6d421a");
            line.setAttribute("stroke-opacity", "0.5");
            line.setAttribute("stroke-width", "1");
            milestonesGroup.appendChild(line);
          }
        }
      }
      const snapIndicator = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      snapIndicator.id = "sbSnapIndicator";
      snapIndicator.setAttribute("cx", "-100");
      snapIndicator.setAttribute("cy", "-100");
      snapIndicator.setAttribute("r", is121 ? "8.5" : "7.5");
      snapIndicator.setAttribute("fill", "none");
      snapIndicator.setAttribute("stroke", "#38bdf8");
      snapIndicator.setAttribute("stroke-width", "2.5");
      snapIndicator.setAttribute("stroke-dasharray", "4,3");
      snapIndicator.setAttribute("opacity", "0");
      snapIndicator.style.pointerEvents = "none";
      snapIndicator.style.transition = "opacity 0.15s ease";
      svg2.appendChild(snapIndicator);
      const coordsMap = _ClashSandboxModal.getHoleCoordinatesMap(targetVal);
      for (let h = 1; h <= totalHoles; h++) {
        const pt = coordsMap[h];
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", pt.x);
        circle.setAttribute("cy", pt.y);
        circle.setAttribute("r", is121 ? "3.8" : "3.2");
        circle.setAttribute("class", "sb-hole");
        circle.setAttribute("data-hole", h);
        circle.addEventListener("click", (e) => {
          e.stopPropagation();
          if (_ClashSandboxModal.pickingDestForJumpId) {
            _ClashSandboxModal.setJumpDestination(_ClashSandboxModal.pickingDestForJumpId, h);
            return;
          }
          if (_ClashSandboxModal.selectedTrayType) {
            _ClashSandboxModal.addHazardToHole(_ClashSandboxModal.selectedTrayType, h);
          }
        });
        holesGroup.appendChild(circle);
      }
      svg2.addEventListener("dragover", (e) => {
        e.preventDefault();
        try {
          e.dataTransfer.dropEffect = "copy";
        } catch (_) {
        }
        const svgPt = _ClashSandboxModal.getSvgCoords(e, svg2);
        const nearest = _ClashSandboxModal.findClosestHole(svgPt.x, svgPt.y, targetVal);
        _ClashSandboxModal.updateSnapHighlight(nearest, svg2);
      });
      svg2.addEventListener("dragleave", (e) => {
        if (!svg2.contains(e.relatedTarget)) {
          _ClashSandboxModal.clearSnapHighlight(svg2);
        }
      });
      svg2.addEventListener("drop", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const svgPt = _ClashSandboxModal.getSvgCoords(e, svg2);
        const nearest = _ClashSandboxModal.findClosestHole(svgPt.x, svgPt.y, targetVal);
        _ClashSandboxModal.clearSnapHighlight(svg2);
        let hazardType = null;
        try {
          hazardType = e.dataTransfer.getData("text/plain");
        } catch (_) {
        }
        if (!hazardType && _ClashSandboxModal.draggedTrayType) {
          hazardType = _ClashSandboxModal.draggedTrayType;
        }
        if (_ClashSandboxModal.draggedDestOfJump) {
          _ClashSandboxModal.draggedDestOfJump.dest = nearest;
          _ClashSandboxModal.draggedDestOfJump = null;
          _ClashSandboxModal.refreshView();
          if (typeof window !== "undefined" && typeof window.showToast === "function") {
            window.showToast(`\u{1F3AF} Jump destination set to Hole ${nearest}`);
          }
        } else if (_ClashSandboxModal.draggedItem) {
          _ClashSandboxModal.draggedItem.hole = nearest;
          _ClashSandboxModal.draggedItem = null;
          _ClashSandboxModal.refreshView();
        } else if (hazardType && hazardType !== "jump_dest") {
          _ClashSandboxModal.addHazardToHole(hazardType, nearest);
        }
      });
      const viewport = document.getElementById("sandboxBoardViewport");
      if (viewport && !viewport._hasDragGuard) {
        viewport._hasDragGuard = true;
        viewport.addEventListener("dragover", (e) => {
          e.preventDefault();
        });
        viewport.addEventListener("drop", (e) => {
          e.preventDefault();
          _ClashSandboxModal.clearSnapHighlight(svg2);
        });
      }
      const jumps = (_ClashSandboxModal.activeLayout || []).filter((i) => i.type === "jump" && i.dest);
      for (const j of jumps) {
        const p1 = getTrackXY(j.hole, "p1", targetVal);
        const p2 = getTrackXY(j.dest, "p1", targetVal);
        const isForward = j.dest > j.hole;
        const marker = isForward ? "url(#sbArrowGreen)" : "url(#sbArrowRed)";
        const strokeColor = isForward ? "#22c55e" : "#ef4444";
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        const dx2 = p2.x - p1.x;
        const dy2 = p2.y - p1.y;
        const cx = (p1.x + p2.x) / 2 - dy2 * 0.15;
        const cy = (p1.y + p2.y) / 2 + dx2 * 0.15;
        path.setAttribute("d", `M ${p1.x} ${p1.y} Q ${cx} ${cy} ${p2.x} ${p2.y}`);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke", strokeColor);
        path.setAttribute("stroke-width", "2.5");
        path.setAttribute("stroke-dasharray", "5,3");
        path.setAttribute("marker-end", marker);
        path.setAttribute("opacity", "0.85");
        path.setAttribute("class", "sb-jump-path");
        path.setAttribute("data-jump-id", j.id);
        path.style.cursor = "pointer";
        const pathTitle = document.createElementNS("http://www.w3.org/2000/svg", "title");
        pathTitle.textContent = `Jump: Hole ${j.hole} \u2794 Hole ${j.dest} (${isForward ? `+${j.dest - j.hole} Forward Boost` : `${j.dest - j.hole} Backward Trap`}). Click to configure.`;
        path.appendChild(pathTitle);
        path.addEventListener("click", (e) => {
          e.stopPropagation();
          _ClashSandboxModal.openJumpConfigDialog(j.id);
        });
        jumpsGroup.appendChild(path);
      }
      const layout = _ClashSandboxModal.activeLayout || [];
      for (const item of layout) {
        const pt = getTrackXY(item.hole, "p1", targetVal);
        const token = document.createElementNS("http://www.w3.org/2000/svg", "g");
        token.setAttribute("class", `sb-token-group ${item.type === "jump" ? "is-jump" : ""}`);
        token.setAttribute("data-item-id", item.id);
        token.setAttribute("transform", `translate(${pt.x}, ${pt.y})`);
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("r", is121 ? "9.5" : "8.5");
        circle.setAttribute("fill", item.color || "#f0c64a");
        circle.setAttribute("stroke", "#111827");
        circle.setAttribute("stroke-width", "1.5");
        circle.setAttribute("class", "sb-token-circle");
        const text2 = document.createElementNS("http://www.w3.org/2000/svg", "text");
        text2.setAttribute("text-anchor", "middle");
        text2.setAttribute("dominant-baseline", "central");
        text2.setAttribute("font-size", is121 ? "10" : "9");
        text2.textContent = item.icon || "\u2605";
        const title = document.createElementNS("http://www.w3.org/2000/svg", "title");
        if (item.type === "jump") {
          title.textContent = `\u26A1 Jump Trigger: Hole ${item.hole} \u2794 Destination: Hole ${item.dest || "?"}. Click to configure destination or drag to move.`;
        } else {
          title.textContent = `${item.name} (Hole ${item.hole}). Click to remove or drag to move.`;
        }
        token.appendChild(title);
        token.appendChild(circle);
        token.appendChild(text2);
        token.addEventListener("click", (e) => {
          e.stopPropagation();
          if (e.shiftKey) {
            _ClashSandboxModal.removeHazard(item.id);
            return;
          }
          if (item.type === "jump") {
            _ClashSandboxModal.openJumpConfigDialog(item.id);
          } else {
            _ClashSandboxModal.removeHazard(item.id);
          }
        });
        token.setAttribute("draggable", "true");
        token.addEventListener("dragstart", (e) => {
          _ClashSandboxModal.draggedItem = item;
          _ClashSandboxModal.draggedDestOfJump = null;
          try {
            e.dataTransfer.setData("application/json", JSON.stringify(item));
            e.dataTransfer.setData("text/plain", item.type);
            e.dataTransfer.effectAllowed = "move";
          } catch (_) {
          }
        });
        token.addEventListener("dragend", () => {
          _ClashSandboxModal.draggedItem = null;
          _ClashSandboxModal.clearSnapHighlight();
        });
        _ClashSandboxModal.bindTokenPointerDrag(token, item);
        tokensGroup.appendChild(token);
      }
      for (const j of jumps) {
        const pt = getTrackXY(j.dest, "p1", targetVal);
        const destToken = document.createElementNS("http://www.w3.org/2000/svg", "g");
        destToken.setAttribute("class", "sb-token-group sb-jump-dest-token");
        destToken.setAttribute("data-jump-id", j.id);
        destToken.setAttribute("transform", `translate(${pt.x}, ${pt.y})`);
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("r", is121 ? "8.5" : "7.5");
        circle.setAttribute("fill", "#0284c7");
        circle.setAttribute("stroke", "#ffffff");
        circle.setAttribute("stroke-width", "1.5");
        circle.setAttribute("class", "sb-token-circle sb-dest-circle");
        const text2 = document.createElementNS("http://www.w3.org/2000/svg", "text");
        text2.setAttribute("text-anchor", "middle");
        text2.setAttribute("dominant-baseline", "central");
        text2.setAttribute("font-size", is121 ? "8.5" : "7.5");
        text2.textContent = "\u{1F3AF}";
        const title = document.createElementNS("http://www.w3.org/2000/svg", "title");
        title.textContent = `\u{1F3AF} Jump Destination: Hole ${j.dest} (from Hole ${j.hole}). Click to configure, or drag to another hole.`;
        destToken.appendChild(title);
        destToken.appendChild(circle);
        destToken.appendChild(text2);
        destToken.addEventListener("click", (e) => {
          e.stopPropagation();
          if (e.shiftKey) {
            _ClashSandboxModal.removeHazard(j.id);
            return;
          }
          _ClashSandboxModal.openJumpConfigDialog(j.id);
        });
        destToken.setAttribute("draggable", "true");
        destToken.addEventListener("dragstart", (e) => {
          _ClashSandboxModal.draggedDestOfJump = j;
          _ClashSandboxModal.draggedItem = null;
          try {
            e.dataTransfer.setData("application/json", JSON.stringify({ isDest: true, jumpId: j.id }));
            e.dataTransfer.setData("text/plain", "jump_dest");
            e.dataTransfer.effectAllowed = "move";
          } catch (_) {
          }
        });
        destToken.addEventListener("dragend", () => {
          _ClashSandboxModal.draggedDestOfJump = null;
          _ClashSandboxModal.clearSnapHighlight();
        });
        _ClashSandboxModal.bindDestPinPointerDrag(destToken, j);
        tokensGroup.appendChild(destToken);
      }
    }
    /**
     * Binds pointer-based dragging (mouse/touch/pen) for placed board hazard tokens.
     */
    static bindTokenPointerDrag(tokenEl, item) {
      let startPos = null;
      let isDragging = false;
      let ghostEl = null;
      const onMove = (e) => {
        if (!startPos) return;
        const clientX = e.clientX !== void 0 ? e.clientX : e.touches && e.touches[0] ? e.touches[0].clientX : 0;
        const clientY = e.clientY !== void 0 ? e.clientY : e.touches && e.touches[0] ? e.touches[0].clientY : 0;
        const dx2 = clientX - startPos.x;
        const dy2 = clientY - startPos.y;
        if (!isDragging && dx2 * dx2 + dy2 * dy2 > 36) {
          isDragging = true;
          ghostEl = document.createElement("div");
          ghostEl.className = "sb-floating-drag-ghost";
          ghostEl.innerHTML = `<span style="font-size: 1.1rem;">${item.icon || "\u2605"}</span><span>${escapeHtml2(item.name || item.type)}</span>`;
          ghostEl.style.left = `${clientX}px`;
          ghostEl.style.top = `${clientY}px`;
          ghostEl.style.borderColor = item.color || "#f0c64a";
          document.body.appendChild(ghostEl);
        }
        if (isDragging && ghostEl) {
          ghostEl.style.left = `${clientX}px`;
          ghostEl.style.top = `${clientY}px`;
          const svg2 = document.querySelector(".sandbox-svg-board");
          if (svg2) {
            const rect = svg2.getBoundingClientRect();
            if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
              const svgPt = _ClashSandboxModal.getSvgCoords({ clientX, clientY }, svg2);
              const nearest = _ClashSandboxModal.findClosestHole(svgPt.x, svgPt.y, _ClashSandboxModal.targetVal);
              _ClashSandboxModal.updateSnapHighlight(nearest, svg2);
            } else {
              _ClashSandboxModal.clearSnapHighlight(svg2);
            }
          }
        }
      };
      const onUp = (e) => {
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
        window.removeEventListener("pointercancel", onUp);
        if (isDragging) {
          const clientX = e.clientX !== void 0 ? e.clientX : e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : startPos ? startPos.x : 0;
          const clientY = e.clientY !== void 0 ? e.clientY : e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : startPos ? startPos.y : 0;
          const svg2 = document.querySelector(".sandbox-svg-board");
          let droppedHole = null;
          if (svg2) {
            const rect = svg2.getBoundingClientRect();
            if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
              const svgPt = _ClashSandboxModal.getSvgCoords({ clientX, clientY }, svg2);
              droppedHole = _ClashSandboxModal.findClosestHole(svgPt.x, svgPt.y, _ClashSandboxModal.targetVal);
            }
          }
          if (ghostEl && ghostEl.parentNode) ghostEl.parentNode.removeChild(ghostEl);
          ghostEl = null;
          isDragging = false;
          startPos = null;
          _ClashSandboxModal.clearSnapHighlight();
          if (droppedHole && droppedHole !== item.hole) {
            item.hole = droppedHole;
            _ClashSandboxModal.refreshView();
            if (typeof window !== "undefined" && typeof window.showToast === "function") {
              window.showToast(`Moved ${item.name} to Hole ${droppedHole}`);
            }
          }
        } else {
          startPos = null;
        }
      };
      tokenEl.addEventListener("pointerdown", (e) => {
        if (e.button !== 0 && e.pointerType === "mouse") return;
        startPos = { x: e.clientX, y: e.clientY };
        isDragging = false;
        window.addEventListener("pointermove", onMove, { passive: true });
        window.addEventListener("pointerup", onUp);
        window.addEventListener("pointercancel", onUp);
      });
    }
    /**
     * Binds pointer-based dragging (mouse/touch/pen) for jump destination pins.
     */
    static bindDestPinPointerDrag(destTokenEl, jump) {
      let startPos = null;
      let isDragging = false;
      let ghostEl = null;
      const onMove = (e) => {
        if (!startPos) return;
        const clientX = e.clientX !== void 0 ? e.clientX : e.touches && e.touches[0] ? e.touches[0].clientX : 0;
        const clientY = e.clientY !== void 0 ? e.clientY : e.touches && e.touches[0] ? e.touches[0].clientY : 0;
        const dx2 = clientX - startPos.x;
        const dy2 = clientY - startPos.y;
        if (!isDragging && dx2 * dx2 + dy2 * dy2 > 36) {
          isDragging = true;
          ghostEl = document.createElement("div");
          ghostEl.className = "sb-floating-drag-ghost";
          ghostEl.innerHTML = `<span style="font-size: 1.1rem;">\u{1F3AF}</span><span>Jump Destination</span>`;
          ghostEl.style.left = `${clientX}px`;
          ghostEl.style.top = `${clientY}px`;
          ghostEl.style.borderColor = "#0284c7";
          document.body.appendChild(ghostEl);
        }
        if (isDragging && ghostEl) {
          ghostEl.style.left = `${clientX}px`;
          ghostEl.style.top = `${clientY}px`;
          const svg2 = document.querySelector(".sandbox-svg-board");
          if (svg2) {
            const rect = svg2.getBoundingClientRect();
            if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
              const svgPt = _ClashSandboxModal.getSvgCoords({ clientX, clientY }, svg2);
              const nearest = _ClashSandboxModal.findClosestHole(svgPt.x, svgPt.y, _ClashSandboxModal.targetVal);
              _ClashSandboxModal.updateSnapHighlight(nearest, svg2);
            } else {
              _ClashSandboxModal.clearSnapHighlight(svg2);
            }
          }
        }
      };
      const onUp = (e) => {
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
        window.removeEventListener("pointercancel", onUp);
        if (isDragging) {
          const clientX = e.clientX !== void 0 ? e.clientX : e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : startPos ? startPos.x : 0;
          const clientY = e.clientY !== void 0 ? e.clientY : e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : startPos ? startPos.y : 0;
          const svg2 = document.querySelector(".sandbox-svg-board");
          let droppedHole = null;
          if (svg2) {
            const rect = svg2.getBoundingClientRect();
            if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
              const svgPt = _ClashSandboxModal.getSvgCoords({ clientX, clientY }, svg2);
              droppedHole = _ClashSandboxModal.findClosestHole(svgPt.x, svgPt.y, _ClashSandboxModal.targetVal);
            }
          }
          if (ghostEl && ghostEl.parentNode) ghostEl.parentNode.removeChild(ghostEl);
          ghostEl = null;
          isDragging = false;
          startPos = null;
          _ClashSandboxModal.clearSnapHighlight();
          if (droppedHole && droppedHole !== jump.dest) {
            jump.dest = droppedHole;
            _ClashSandboxModal.refreshView();
            if (typeof window !== "undefined" && typeof window.showToast === "function") {
              window.showToast(`\u{1F3AF} Jump destination set to Hole ${droppedHole}`);
            }
          }
        } else {
          startPos = null;
        }
      };
      destTokenEl.addEventListener("pointerdown", (e) => {
        if (e.button !== 0 && e.pointerType === "mouse") return;
        startPos = { x: e.clientX, y: e.clientY };
        isDragging = false;
        window.addEventListener("pointermove", onMove, { passive: true });
        window.addEventListener("pointerup", onUp);
        window.addEventListener("pointercancel", onUp);
      });
    }
    /**
     * Binds click & drag events to tray buttons.
     * Supports both HTML5 drag and smooth Pointer Events dragging for desktop and mobile.
     */
    static bindTrayEvents() {
      const btns = document.querySelectorAll(".sandbox-tray-btn");
      const brand = _ClashSandboxModal.brand || "clash";
      const palette = BRAND_ITEM_PALETTES[brand] || BRAND_ITEM_PALETTES.clash;
      btns.forEach((btn) => {
        const type = btn.getAttribute("data-hazard-type");
        const def = palette.find((p) => p.type === type) || { name: type, icon: "\u2605", color: "#f0c64a" };
        btn.addEventListener("dragstart", (e) => {
          const limit = _ClashSandboxModal.getItemLimit(type, brand);
          const placed = (_ClashSandboxModal.activeLayout || []).filter((i) => i.type === type).length;
          if (placed >= limit) {
            e.preventDefault();
            if (typeof window !== "undefined" && typeof window.showToast === "function") {
              window.showToast(`\u26A0\uFE0F Maximum ${limit} ${def.name} allowed (${limit} max defined in ClashSettings).`);
            }
            return;
          }
          try {
            e.dataTransfer.setData("text/plain", type);
            e.dataTransfer.effectAllowed = "copy";
          } catch (_) {
          }
          _ClashSandboxModal.selectedTrayType = type;
          _ClashSandboxModal.draggedTrayType = type;
        });
        btn.addEventListener("dragend", () => {
          _ClashSandboxModal.draggedTrayType = null;
          _ClashSandboxModal.clearSnapHighlight();
        });
        let pointerDownPos = null;
        let isPointerDragging = false;
        let ghostEl = null;
        const onPointerMove = (e) => {
          if (!pointerDownPos) return;
          const clientX = e.clientX !== void 0 ? e.clientX : e.touches && e.touches[0] ? e.touches[0].clientX : 0;
          const clientY = e.clientY !== void 0 ? e.clientY : e.touches && e.touches[0] ? e.touches[0].clientY : 0;
          const dx2 = clientX - pointerDownPos.x;
          const dy2 = clientY - pointerDownPos.y;
          if (!isPointerDragging && dx2 * dx2 + dy2 * dy2 > 36) {
            isPointerDragging = true;
            _ClashSandboxModal.selectedTrayType = type;
            _ClashSandboxModal.draggedTrayType = type;
            ghostEl = document.createElement("div");
            ghostEl.className = "sb-floating-drag-ghost";
            ghostEl.innerHTML = `<span style="font-size: 1.1rem;">${def.icon}</span><span>${escapeHtml2(def.name)}</span>`;
            ghostEl.style.left = `${clientX}px`;
            ghostEl.style.top = `${clientY}px`;
            ghostEl.style.borderColor = def.color || "#f0c64a";
            document.body.appendChild(ghostEl);
          }
          if (isPointerDragging && ghostEl) {
            ghostEl.style.left = `${clientX}px`;
            ghostEl.style.top = `${clientY}px`;
            const svg2 = document.querySelector(".sandbox-svg-board");
            if (svg2) {
              const rect = svg2.getBoundingClientRect();
              if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
                const svgPt = _ClashSandboxModal.getSvgCoords({ clientX, clientY }, svg2);
                const nearest = _ClashSandboxModal.findClosestHole(svgPt.x, svgPt.y, _ClashSandboxModal.targetVal);
                _ClashSandboxModal.updateSnapHighlight(nearest, svg2);
              } else {
                _ClashSandboxModal.clearSnapHighlight(svg2);
              }
            }
          }
        };
        const onPointerUp = (e) => {
          window.removeEventListener("pointermove", onPointerMove);
          window.removeEventListener("pointerup", onPointerUp);
          window.removeEventListener("pointercancel", onPointerUp);
          if (isPointerDragging) {
            const clientX = e.clientX !== void 0 ? e.clientX : e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : pointerDownPos ? pointerDownPos.x : 0;
            const clientY = e.clientY !== void 0 ? e.clientY : e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : pointerDownPos ? pointerDownPos.y : 0;
            const svg2 = document.querySelector(".sandbox-svg-board");
            let droppedHole = null;
            if (svg2) {
              const rect = svg2.getBoundingClientRect();
              if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
                const svgPt = _ClashSandboxModal.getSvgCoords({ clientX, clientY }, svg2);
                droppedHole = _ClashSandboxModal.findClosestHole(svgPt.x, svgPt.y, _ClashSandboxModal.targetVal);
              }
            }
            if (ghostEl && ghostEl.parentNode) ghostEl.parentNode.removeChild(ghostEl);
            ghostEl = null;
            isPointerDragging = false;
            pointerDownPos = null;
            _ClashSandboxModal.draggedTrayType = null;
            _ClashSandboxModal.clearSnapHighlight();
            if (droppedHole) {
              _ClashSandboxModal.addHazardToHole(type, droppedHole);
            }
          } else {
            pointerDownPos = null;
            const limit = _ClashSandboxModal.getItemLimit(type, brand);
            const placed = (_ClashSandboxModal.activeLayout || []).filter((i) => i.type === type).length;
            if (placed >= limit) {
              if (typeof window !== "undefined" && typeof window.showToast === "function") {
                window.showToast(`\u26A0\uFE0F Maximum ${limit} ${def.name} reached (${placed}/${limit}) as defined in ClashSettings.`);
              }
              return;
            }
            if (_ClashSandboxModal.selectedTrayType === type) {
              _ClashSandboxModal.selectedTrayType = null;
              btn.classList.remove("is-selected");
            } else {
              btns.forEach((b) => b.classList.remove("is-selected"));
              _ClashSandboxModal.selectedTrayType = type;
              btn.classList.add("is-selected");
            }
          }
        };
        btn.addEventListener("pointerdown", (e) => {
          if (e.button !== 0 && e.pointerType === "mouse") return;
          const limit = _ClashSandboxModal.getItemLimit(type, brand);
          const placed = (_ClashSandboxModal.activeLayout || []).filter((i) => i.type === type).length;
          if (placed >= limit) {
            if (typeof window !== "undefined" && typeof window.showToast === "function") {
              window.showToast(`\u26A0\uFE0F Maximum ${limit} ${def.name} reached (${placed}/${limit}) as defined in ClashSettings.`);
            }
            return;
          }
          pointerDownPos = { x: e.clientX, y: e.clientY };
          isPointerDragging = false;
          window.addEventListener("pointermove", onPointerMove, { passive: true });
          window.addEventListener("pointerup", onPointerUp);
          window.addEventListener("pointercancel", onPointerUp);
        });
      });
    }
    /**
     * Places a space/hazard onto a specific hole.
     * @param {string} type
     * @param {number} hole
     */
    static addHazardToHole(type, hole) {
      if (!_ClashSandboxModal.activeLayout) _ClashSandboxModal.activeLayout = [];
      const brand = _ClashSandboxModal.brand || "clash";
      const limit = _ClashSandboxModal.getItemLimit(type, brand);
      const currentPlaced = _ClashSandboxModal.activeLayout.filter((i) => i.type === type).length;
      const palette = BRAND_ITEM_PALETTES[brand] || BRAND_ITEM_PALETTES.clash;
      const def = palette.find((p) => p.type === type) || { name: type.toUpperCase(), icon: "\u2605", color: "#f0c64a", length: 1 };
      if (currentPlaced >= limit) {
        if (typeof window !== "undefined" && typeof window.showToast === "function") {
          window.showToast(`\u26A0\uFE0F Maximum ${limit} ${def.name} allowed (${limit} max defined in ClashSettings).`);
        }
        return;
      }
      const newItem = {
        id: `${type}_${Date.now()}_${Math.random().toString(36).substr(2, 4)}`,
        type,
        name: `${def.name}`,
        icon: def.icon,
        color: def.color,
        hole,
        length: def.length || 1
      };
      if (type === "jump") {
        const defaultDelta = _ClashSandboxModal.targetVal === 121 ? 15 : 30;
        newItem.dest = Math.min(_ClashSandboxModal.targetVal - 5, hole + defaultDelta);
      }
      _ClashSandboxModal.activeLayout.push(newItem);
      if (currentPlaced + 1 >= limit && _ClashSandboxModal.selectedTrayType === type) {
        _ClashSandboxModal.selectedTrayType = null;
      }
      _ClashSandboxModal.refreshView();
      if (type === "jump") {
        _ClashSandboxModal.openJumpConfigDialog(newItem.id);
      }
    }
    /**
     * Removes a placed space by ID.
     * @param {string} itemId
     */
    static removeHazard(itemId) {
      _ClashSandboxModal.activeLayout = _ClashSandboxModal.activeLayout.filter((i) => i.id !== itemId);
      _ClashSandboxModal.refreshView();
    }
    /**
     * Clears all placed spaces from the sandbox board.
     */
    static clearAllHazards() {
      _ClashSandboxModal.activeLayout = [];
      _ClashSandboxModal.cancelPickDestinationMode();
      _ClashSandboxModal.refreshView();
    }
    /**
     * Opens the Jump Vector Configuration Dialog.
     * @param {string} jumpId
     */
    static openJumpConfigDialog(jumpId) {
      if (typeof document === "undefined") return;
      const layout = _ClashSandboxModal.activeLayout || [];
      const jump = layout.find((i) => i.id === jumpId && i.type === "jump");
      if (!jump) return;
      const overlay = document.getElementById("sandboxJumpDialogOverlay");
      const txtId = document.getElementById("txtJumpItemId");
      const numStart = document.getElementById("numJumpStart");
      const numDest = document.getElementById("numJumpDest");
      const title = document.getElementById("sandboxJumpDialogTitle");
      const err = document.getElementById("jumpConfigError");
      if (!overlay || !txtId || !numStart || !numDest) return;
      txtId.value = jump.id;
      numStart.value = jump.hole;
      numDest.value = jump.dest || jump.hole + (_ClashSandboxModal.targetVal === 121 ? 15 : 30);
      const maxHole = _ClashSandboxModal.targetVal - 1;
      numStart.max = maxHole;
      numDest.max = maxHole;
      if (title) title.textContent = `Configure Jump (${jump.name || "Jump"})`;
      if (err) err.style.display = "none";
      _ClashSandboxModal.onJumpInputChanged();
      overlay.style.display = "flex";
      setTimeout(() => {
        numDest.focus();
        numDest.select();
      }, 50);
    }
    /**
     * Closes the Jump Vector Configuration Dialog.
     */
    static closeJumpConfigDialog() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("sandboxJumpDialogOverlay");
      if (overlay) overlay.style.display = "none";
    }
    /**
     * Real-time update for Jump summary box when start or destination hole changes.
     */
    static onJumpInputChanged() {
      if (typeof document === "undefined") return;
      const numStart = document.getElementById("numJumpStart");
      const numDest = document.getElementById("numJumpDest");
      const summary = document.getElementById("jumpVectorSummary");
      if (!numStart || !numDest || !summary) return;
      const s = parseInt(numStart.value, 10);
      const d = parseInt(numDest.value, 10);
      if (isNaN(s) || isNaN(d)) {
        summary.innerHTML = '<span style="color: #94a3b8;">Enter valid hole numbers.</span>';
        summary.style.background = "rgba(0,0,0,0.3)";
        summary.style.borderColor = "rgba(255,255,255,0.1)";
        return;
      }
      const delta = d - s;
      if (delta > 0) {
        summary.style.background = "rgba(34, 197, 94, 0.15)";
        summary.style.borderColor = "#22c55e";
        summary.style.color = "#4ade80";
        summary.innerHTML = `\u{1F7E2} <strong>Forward Shortcut: +${delta} Holes</strong><br><span style="font-size: 0.8rem; font-weight: normal; color: #bbf7d0;">Peg landing on Hole ${s} leaps forward to Hole ${d}.</span>`;
      } else if (delta < 0) {
        summary.style.background = "rgba(239, 68, 68, 0.15)";
        summary.style.borderColor = "#ef4444";
        summary.style.color = "#f87171";
        summary.innerHTML = `\u{1F534} <strong>Backward Trap: ${delta} Holes</strong><br><span style="font-size: 0.8rem; font-weight: normal; color: #fecaca;">Peg landing on Hole ${s} is thrown backward to Hole ${d}.</span>`;
      } else {
        summary.style.background = "rgba(245, 158, 11, 0.15)";
        summary.style.borderColor = "#f59e0b";
        summary.style.color = "#fbbf24";
        summary.innerHTML = `\u26A0\uFE0F <strong>Zero Jump</strong><br><span style="font-size: 0.8rem; font-weight: normal; color: #fef08a;">Trigger and destination cannot be the same hole.</span>`;
      }
    }
    /**
     * Applies a relative offset to destination hole.
     * @param {number} offset
     */
    static applyJumpOffset(offset) {
      if (typeof document === "undefined") return;
      const numStart = document.getElementById("numJumpStart");
      const numDest = document.getElementById("numJumpDest");
      if (!numStart || !numDest) return;
      const s = parseInt(numStart.value, 10) || 1;
      const maxHole = _ClashSandboxModal.targetVal - 1;
      const newDest = Math.max(1, Math.min(maxHole, s + offset));
      numDest.value = newDest;
      _ClashSandboxModal.onJumpInputChanged();
    }
    /**
     * Saves updated jump trigger and destination from the dialog.
     */
    static saveJumpConfigDialog() {
      if (typeof document === "undefined") return;
      const txtId = document.getElementById("txtJumpItemId");
      const numStart = document.getElementById("numJumpStart");
      const numDest = document.getElementById("numJumpDest");
      const err = document.getElementById("jumpConfigError");
      if (!txtId || !numStart || !numDest) return;
      const jumpId = txtId.value;
      const layout = _ClashSandboxModal.activeLayout || [];
      const jump = layout.find((i) => i.id === jumpId && i.type === "jump");
      if (!jump) return;
      const s = parseInt(numStart.value, 10);
      const d = parseInt(numDest.value, 10);
      const maxHole = _ClashSandboxModal.targetVal - 1;
      if (isNaN(s) || s < 1 || s > maxHole) {
        if (err) {
          err.textContent = `Trigger hole must be between 1 and ${maxHole}.`;
          err.style.display = "block";
        }
        return;
      }
      if (isNaN(d) || d < 1 || d > maxHole) {
        if (err) {
          err.textContent = `Destination hole must be between 1 and ${maxHole}.`;
          err.style.display = "block";
        }
        return;
      }
      if (s === d) {
        if (err) {
          err.textContent = "Destination hole must be different from trigger hole.";
          err.style.display = "block";
        }
        return;
      }
      jump.hole = s;
      jump.dest = d;
      _ClashSandboxModal.closeJumpConfigDialog();
      _ClashSandboxModal.refreshView();
      if (typeof window !== "undefined" && typeof window.showToast === "function") {
        const delta = d - s;
        const typeStr = delta > 0 ? `+${delta} Forward Shortcut` : `${delta} Backward Trap`;
        window.showToast(`\u26A1 Jump set: Hole ${s} \u2794 Hole ${d} (${typeStr})`);
      }
    }
    /**
     * Deletes the currently inspected jump from the board.
     */
    static deleteCurrentJump() {
      if (typeof document === "undefined") return;
      const txtId = document.getElementById("txtJumpItemId");
      const jumpId = txtId ? txtId.value : null;
      if (jumpId) {
        _ClashSandboxModal.removeHazard(jumpId);
      }
      _ClashSandboxModal.closeJumpConfigDialog();
    }
    /**
     * Enters "Pick Destination on Board" interactive mode.
     */
    static startPickDestinationMode() {
      if (typeof document === "undefined") return;
      const txtId = document.getElementById("txtJumpItemId");
      const jumpId = txtId ? txtId.value : null;
      if (!jumpId) return;
      const layout = _ClashSandboxModal.activeLayout || [];
      const jump = layout.find((i) => i.id === jumpId && i.type === "jump");
      if (!jump) return;
      _ClashSandboxModal.pickingDestForJumpId = jumpId;
      _ClashSandboxModal.closeJumpConfigDialog();
      const banner = document.getElementById("sandboxPickBanner");
      const bannerText = document.getElementById("sandboxPickBannerText");
      const svgWrap = document.getElementById("sandboxSvgWrap");
      if (bannerText) {
        bannerText.innerHTML = `\u{1F3AF} Click any hole on the board to set destination for Jump (Trigger: <strong>Hole ${jump.hole}</strong>)`;
      }
      if (banner) banner.style.display = "flex";
      if (svgWrap) svgWrap.classList.add("sandbox-picking-active");
      if (typeof window !== "undefined" && typeof window.showToast === "function") {
        window.showToast(`\u{1F3AF} Click any hole on the track to set Jump destination`);
      }
    }
    /**
     * Cancels "Pick Destination on Board" mode.
     */
    static cancelPickDestinationMode() {
      _ClashSandboxModal.pickingDestForJumpId = null;
      if (typeof document === "undefined") return;
      const banner = document.getElementById("sandboxPickBanner");
      const svgWrap = document.getElementById("sandboxSvgWrap");
      if (banner) banner.style.display = "none";
      if (svgWrap) svgWrap.classList.remove("sandbox-picking-active");
    }
    /**
     * Sets jump destination from a board click.
     * @param {string} jumpId
     * @param {number} destHole
     */
    static setJumpDestination(jumpId, destHole) {
      const layout = _ClashSandboxModal.activeLayout || [];
      const jump = layout.find((i) => i.id === jumpId && i.type === "jump");
      if (!jump) {
        _ClashSandboxModal.cancelPickDestinationMode();
        return;
      }
      if (destHole === jump.hole) {
        if (typeof window !== "undefined" && typeof window.showToast === "function") {
          window.showToast("\u26A0\uFE0F Destination hole must be different from trigger hole.");
        }
        return;
      }
      jump.dest = destHole;
      _ClashSandboxModal.cancelPickDestinationMode();
      _ClashSandboxModal.refreshView();
      if (typeof window !== "undefined" && typeof window.showToast === "function") {
        const delta = destHole - jump.hole;
        const typeStr = delta > 0 ? `+${delta} Forward Shortcut` : `${delta} Backward Trap`;
        window.showToast(`\u{1F3AF} Jump destination set to Hole ${destHole} (${typeStr})`);
      }
    }
    /**
     * Applies one of the curated presets to the sandbox layout.
     * @param {string} presetKey
     */
    static applyPresetKey(presetKey) {
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const presets = engine.getPresets(_ClashSandboxModal.targetVal);
      const preset = presets[presetKey] || presets.standard;
      if (preset) {
        _ClashSandboxModal.activeLayout = _ClashSandboxModal.convertPresetToItems(preset.config, brand);
        _ClashSandboxModal.refreshView();
        if (typeof window !== "undefined" && typeof window.showToast === "function") {
          window.showToast(`Applied preset: ${preset.name} (${preset.badge})`);
        }
      }
    }
    /**
     * Generates a full random non-overlapping distribution.
     */
    static randomizeLayout() {
      const brand = _ClashSandboxModal.brand || "clash";
      const target = _ClashSandboxModal.targetVal;
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const presets = engine.getPresets(target);
      const standard = presets.standard.config;
      const items = _ClashSandboxModal.convertPresetToItems(standard, brand);
      const counts = {};
      const filteredItems = [];
      for (const item of items) {
        const limit = _ClashSandboxModal.getItemLimit(item.type, brand);
        const curr = counts[item.type] || 0;
        if (curr < limit) {
          counts[item.type] = curr + 1;
          filteredItems.push(item);
        }
      }
      const usedHoles = /* @__PURE__ */ new Set();
      const randomized = [];
      const minHole = target === 121 ? 5 : 10;
      const maxHole = target === 121 ? 118 : target - 30;
      for (const item of filteredItems) {
        let tries = 0;
        let placedHole = null;
        while (tries < 100) {
          tries++;
          const candidate = Math.floor(Math.random() * (maxHole - minHole)) + minHole;
          let conflict = false;
          const radius = target === 121 ? 2 : 4;
          for (let h = candidate - radius; h <= candidate + radius; h++) {
            if (usedHoles.has(h)) {
              conflict = true;
              break;
            }
          }
          if (!conflict) {
            placedHole = candidate;
            for (let h = candidate - radius; h <= candidate + radius; h++) usedHoles.add(h);
            break;
          }
        }
        if (placedHole) {
          item.hole = placedHole;
          if (item.dest != null) {
            item.dest = Math.min(target - 5, placedHole + (Math.random() > 0.25 ? 30 : -15));
          }
          randomized.push(item);
        }
      }
      _ClashSandboxModal.activeLayout = randomized;
      _ClashSandboxModal.refreshView();
    }
    /**
     * Generates HTML for the live metrics bar.
     * @returns {string}
     */
    static renderMetricsBarHtml() {
      const brand = _ClashSandboxModal.brand || "clash";
      const targetVal = _ClashSandboxModal.targetVal;
      const items = _ClashSandboxModal.activeLayout || [];
      if (brand === "pints") {
        const m2 = PintsPresets.computeTrackMetrics(items, targetVal);
        return `
        <div class="sandbox-metric-chip">
          <span class="sm-val">${m2.totalDrinkSpaces}</span>
          <span class="sm-label">Total Drink Spaces</span>
        </div>
        <div class="sandbox-metric-chip">
          <span class="sm-val" style="color: #10b981;">${m2.socialDrinks}</span>
          <span class="sm-label">Social / Group Drinks</span>
        </div>
        <div class="sandbox-metric-chip">
          <span class="sm-val" style="color: #3b82f6;">${m2.targetedDrinks}</span>
          <span class="sm-label">Targeted Shots</span>
        </div>
        <div class="sandbox-metric-chip">
          <span class="sm-val" style="color: #ec4899;">${m2.genderDrinks}</span>
          <span class="sm-label">Guys vs Gals</span>
        </div>
        <div class="sandbox-metric-chip">
          <span class="sm-val" style="color: #f59e0b;">~${m2.avgSpacing}h</span>
          <span class="sm-label">Avg Spacing</span>
        </div>
      `;
      }
      if (brand === "adult") {
        const m2 = AdultPresets.computeTrackMetrics(items, targetVal);
        return `
        <div class="sandbox-metric-chip">
          <span class="sm-val">${m2.totalDareSpaces}</span>
          <span class="sm-label">Total Dare Spaces</span>
        </div>
        <div class="sandbox-metric-chip">
          <span class="sm-val" style="color: #f43f5e;">${m2.stripSpaces}</span>
          <span class="sm-label">Strip Spaces</span>
        </div>
        <div class="sandbox-metric-chip">
          <span class="sm-val" style="color: #ec4899;">${m2.timedDares}</span>
          <span class="sm-label">Timed Challenges</span>
        </div>
        <div class="sandbox-metric-chip">
          <span class="sm-val" style="color: #10b981;">~${m2.avgSpacing}h</span>
          <span class="sm-label">Avg Spacing</span>
        </div>
      `;
      }
      const m = ClashPresets.computeTrackMetrics(items, targetVal);
      return `
      <div class="sandbox-metric-chip">
        <span class="sm-val">${m.totalHazards}</span>
        <span class="sm-label">Total Hazards</span>
      </div>
      <div class="sandbox-metric-chip">
        <span class="sm-val" style="color: #ef4444;">${m.penaltyTraps}</span>
        <span class="sm-label">Traps (Jail/Bar/Time)</span>
      </div>
      <div class="sandbox-metric-chip">
        <span class="sm-val" style="color: #3b82f6;">${m.forwardBoosts}</span>
        <span class="sm-label">Forward Boosts</span>
      </div>
      <div class="sandbox-metric-chip">
        <span class="sm-val" style="color: #f59e0b;">${m.chokePoints + m.stopSigns}</span>
        <span class="sm-label">Choke Points & Stops</span>
      </div>
      <div class="sandbox-metric-chip">
        <span class="sm-val" style="color: #10b981;">~${m.avgSpacing}h</span>
        <span class="sm-label">Avg Spacing</span>
      </div>
    `;
    }
    /**
     * Re-renders the SVG board, updates the palette counts, and refreshes the live analysis chips.
     */
    static refreshView() {
      if (typeof document === "undefined") return;
      _ClashSandboxModal.renderBoardSvg();
      const tray = document.getElementById("sandboxTrayItems");
      if (tray) {
        tray.innerHTML = _ClashSandboxModal.renderTrayButtons();
        _ClashSandboxModal.bindTrayEvents();
      }
      const metricsBar = document.getElementById("sandboxMetricsBar");
      if (metricsBar) {
        metricsBar.innerHTML = _ClashSandboxModal.renderMetricsBarHtml();
      }
    }
    /**
     * Backward-compatibility alias for updating analysis and view.
     */
    static updateTrackAnalysis() {
      _ClashSandboxModal.refreshView();
    }
    /**
     * Builds form configuration object from obstacle items list.
     * @param {Array<Object>} [layout]
     * @param {number} [targetVal]
     * @param {string} [brand=ClashSandboxModal.brand]
     * @returns {Object}
     */
    static buildFormConfig(layout = _ClashSandboxModal.activeLayout, targetVal = _ClashSandboxModal.targetVal, brand = _ClashSandboxModal.brand) {
      const items = layout || [];
      const cfg = {};
      const grouped = {};
      for (const item of items) {
        if (!grouped[item.type]) grouped[item.type] = [];
        grouped[item.type].push(item);
      }
      if (brand === "pints") {
        const palette = BRAND_ITEM_PALETTES.pints;
        palette.forEach((opt) => {
          const typeList = grouped[opt.type] || [];
          const chkKey = `opt${opt.type.charAt(0).toUpperCase() + opt.type.slice(1)}`;
          cfg[chkKey] = Boolean(typeList.length);
          cfg[`${chkKey}Count`] = typeList.length;
          cfg[`${opt.type}Count`] = typeList.length;
          cfg[`${opt.type}Holes`] = typeList.map((it) => it.hole);
          cfg[`${opt.type}Starts`] = cfg[`${opt.type}Holes`];
          for (let idx = 0; idx < 4; idx++) {
            cfg[`${chkKey}${idx + 1}Hole`] = typeList[idx] ? typeList[idx].hole : 0;
          }
        });
        return cfg;
      }
      if (brand === "adult") {
        const palette = BRAND_ITEM_PALETTES.adult;
        palette.forEach((opt) => {
          const typeList = grouped[opt.type] || [];
          const chkKey = `opt${opt.type.charAt(0).toUpperCase() + opt.type.slice(1)}`;
          cfg[chkKey] = Boolean(typeList.length);
          cfg[`${chkKey}Count`] = typeList.length;
          cfg[`${opt.type}Count`] = typeList.length;
          cfg[`${opt.type}Holes`] = typeList.map((it) => it.hole);
          cfg[`${opt.type}Starts`] = cfg[`${opt.type}Holes`];
          for (let idx = 0; idx < 4; idx++) {
            cfg[`${chkKey}${idx + 1}Hole`] = typeList[idx] ? typeList[idx].hole : 0;
          }
        });
        return cfg;
      }
      const clashDefs = _ClashSandboxModal.getClashBlockDefs();
      const processedTypes = /* @__PURE__ */ new Set();
      for (const def of clashDefs) {
        const type = def.type;
        processedTypes.add(type);
        const typeItems = grouped[type] || [];
        const maxCount = typeof def.maxCount === "number" ? def.maxCount : def.type === "jump" || def.type === "stopSign" || def.type === "signs" ? 8 : 4;
        const count = Math.min(maxCount, typeItems.length);
        const isEnabled = count > 0;
        cfg[def.chkId] = isEnabled;
        if (type === "jump") cfg.optJumps = isEnabled;
        if (type === "noPassingLanes") cfg.optNoPassing = isEnabled;
        if (type === "jail") cfg.optJails = isEnabled;
        if (type === "bar") cfg.optBars = isEnabled;
        if (type === "timeout") cfg.optTimeouts = isEnabled;
        if (type === "detour") cfg.optDetours = isEnabled;
        if (type === "roundAbout") cfg.optRoundAbouts = isEnabled;
        if (type === "signs") cfg.optSign = isEnabled;
        if (type === "stopSign") cfg.optStopSigns = isEnabled;
        if (type === "wheel") cfg.optSpinningWheel = isEnabled;
        cfg[def.countId] = count;
        cfg[`${type}Count`] = count;
        if (type === "noPassingLanes") {
          cfg.noPassingLaneCount = count;
          cfg.noPassingLanesCount = count;
        }
        if (type === "wheel") {
          cfg.optSpinningWheelCount = count;
          cfg.spinningWheelCount = count;
        }
        const validItems = typeItems.slice(0, count);
        const holes = validItems.map((it) => it.hole);
        cfg[`${type}Holes`] = holes;
        cfg[`${type}Starts`] = holes;
        if (type === "noPassingLanes") {
          cfg.noPassingLaneStarts = holes;
          cfg.noPassingLaneHoles = holes;
        }
        if (type === "wheel") {
          cfg.spinningWheelHoles = holes;
          cfg.spinningWheelStarts = holes;
        }
        const suffix = def.selectIdSuffix || "Hole";
        const prefix = def.selectIdPrefix || `opt${type.charAt(0).toUpperCase() + type.slice(1)}`;
        for (let i = 1; i <= maxCount; i++) {
          const item = validItems[i - 1];
          const h = item && i <= count ? item.hole : 0;
          cfg[`${prefix}${i}${suffix}`] = h;
          cfg[`${type}${i}${suffix}`] = h;
        }
        if (type === "jump") {
          cfg.jumpDests = validItems.map((it) => it.dest || Math.min(targetVal - 5, it.hole + 30));
          for (let i = 1; i <= maxCount; i++) {
            const item = validItems[i - 1];
            const d = item && i <= count ? item.dest || Math.min(targetVal - 5, item.hole + 30) : 0;
            cfg[`optJump${i}Dest`] = d;
            cfg[`jump${i}Dest`] = d;
          }
        }
        if (type === "signs") {
          cfg.signsBlocks = validItems.map((item, i) => ({
            id: i + 1,
            start: item.hole,
            size: (i + 1) % 2 === 0 ? 4 : 2,
            signs: (i + 1) % 2 === 0 ? ["Spin The Wheel", "Plus 10", "Minus 5", "Score Plus x2"] : ["Plus 5", "Roll The Dice"]
          }));
        }
      }
      return cfg;
    }
    /**
     * Opens the Custom Layouts slide-over drawer.
     */
    static openLayoutsDrawer() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("sandboxDrawerOverlay");
      if (!overlay) return;
      _ClashSandboxModal.refreshDrawerList();
      overlay.style.display = "flex";
    }
    /**
     * Closes the Custom Layouts slide-over drawer.
     */
    static closeLayoutsDrawer() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("sandboxDrawerOverlay");
      if (overlay) overlay.style.display = "none";
    }
    /**
     * Refreshes the custom layouts list inside the drawer.
     */
    static refreshDrawerList() {
      if (typeof document === "undefined") return;
      const list = document.getElementById("sandboxDrawerList");
      if (list) {
        list.innerHTML = _ClashSandboxModal.renderCustomLayoutCards();
      }
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const count = (engine.getCustomLayouts ? engine.getCustomLayouts() : []).length;
      const badge = document.getElementById("sandboxCustomLayoutCount");
      if (badge) badge.textContent = String(count);
    }
    /**
     * Renders the HTML cards for all saved custom layouts.
     * @returns {string}
     */
    static renderCustomLayoutCards() {
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const layouts = engine.getCustomLayouts ? engine.getCustomLayouts() : [];
      if (!layouts.length) {
        return `
        <div class="sandbox-drawer-empty">
          <span class="empty-icon">\u{1F4C2}</span>
          <div class="empty-title">No Custom Layouts Yet</div>
          <div class="empty-desc">Create your favorite configuration and click <strong>"Save Layout"</strong> to save it here!</div>
        </div>
      `;
      }
      return layouts.map((l) => {
        const isCurrent = _ClashSandboxModal.activeCustomLayoutId === l.id;
        const dateStr = l.updatedAt ? new Date(l.updatedAt).toLocaleDateString() : "";
        let metricsChipsHtml = "";
        if (brand === "pints") {
          const m = l.metrics || PintsPresets.computeTrackMetrics(l.items || [], l.target || 121);
          metricsChipsHtml = `
          <span class="cl-metric-chip" title="Total Drink Spaces">\u{1F4CD} ${m.totalDrinkSpaces || 0}</span>
          <span class="cl-metric-chip" title="Social Drinks" style="color: #10b981;">\u{1F942} ${m.socialDrinks || 0}</span>
          <span class="cl-metric-chip" title="Targeted Shots" style="color: #3b82f6;">\u{1F3AF} ${m.targetedDrinks || 0}</span>
          <span class="cl-metric-chip" title="Guys vs Gals" style="color: #ec4899;">\u{1F94A} ${m.genderDrinks || 0}</span>
          <span class="cl-metric-chip" title="Average Spacing" style="color: #f59e0b;">~${m.avgSpacing || 0}h</span>
        `;
        } else if (brand === "adult") {
          const m = l.metrics || AdultPresets.computeTrackMetrics(l.items || [], l.target || 121);
          metricsChipsHtml = `
          <span class="cl-metric-chip" title="Total Dare Spaces">\u{1F4CD} ${m.totalDareSpaces || 0}</span>
          <span class="cl-metric-chip" title="Strip Spaces" style="color: #f43f5e;">\u{1F459} ${m.stripSpaces || 0}</span>
          <span class="cl-metric-chip" title="Timed Challenges" style="color: #ec4899;">\u23F3 ${m.timedDares || 0}</span>
          <span class="cl-metric-chip" title="Average Spacing" style="color: #10b981;">~${m.avgSpacing || 0}h</span>
        `;
        } else {
          const m = l.metrics || ClashPresets.computeTrackMetrics(l.items || [], l.target || 481);
          metricsChipsHtml = `
          <span class="cl-metric-chip" title="Total Hazards">\u{1F4CD} ${m.totalHazards || 0}</span>
          <span class="cl-metric-chip" title="Penalty Traps" style="color: #ef4444;">\u{1F512} ${m.penaltyTraps || 0}</span>
          <span class="cl-metric-chip" title="Forward Boosts" style="color: #3b82f6;">\u26A1 ${m.forwardBoosts || 0}</span>
          <span class="cl-metric-chip" title="Choke Points & Stops" style="color: #f59e0b;">\u{1F6AB} ${(m.chokePoints || 0) + (m.stopSigns || 0)}</span>
          <span class="cl-metric-chip" title="Average Spacing" style="color: #10b981;">~${m.avgSpacing || 0}h</span>
        `;
        }
        const safeId = escapeHtml2(l.id);
        return `
        <div class="custom-layout-card ${isCurrent ? "is-active-card" : ""}" data-layout-id="${safeId}">
          <div class="cl-card-header">
            <div class="cl-card-info">
              <span class="cl-card-name" id="clName_${safeId}">${escapeHtml2(l.name)}</span>
              ${isCurrent ? '<span class="cl-active-tag">Active</span>' : ""}
              <span class="cl-card-date">${escapeHtml2(dateStr)}</span>
            </div>
            <span class="cl-target-tag">${Number(l.target) || (brand === "clash" ? 481 : 121)} Holes</span>
          </div>
          <div class="cl-card-metrics">
            ${metricsChipsHtml}
          </div>
          <div class="cl-card-actions">
            <button type="button" class="btn-xs btn-gold cl-btn-load" data-layout-action="load" data-layout-id="${safeId}">
              \u{1F4E5} Load
            </button>
            <button type="button" class="btn-xs btn-ghost cl-btn-rename" data-layout-action="rename" data-layout-id="${safeId}" title="Rename layout">
              \u270F\uFE0F Rename
            </button>
            <button type="button" class="btn-xs btn-ghost cl-btn-duplicate" data-layout-action="duplicate" data-layout-id="${safeId}" title="Duplicate layout">
              \u{1F4CB} Copy
            </button>
            <button type="button" class="btn-xs btn-danger cl-btn-delete" data-layout-action="delete" data-layout-id="${safeId}" title="Delete layout">
              \u{1F5D1}\uFE0F
            </button>
          </div>
        </div>
      `;
      }).join("");
    }
    /**
     * Safe event delegation handler for custom layout card actions.
     * Prevents injection of executable code into inline HTML handlers.
     * @param {Event} event
     */
    static handleDrawerAction(event) {
      if (!event || !event.target) return;
      const btn = event.target.closest("[data-layout-action]");
      if (!btn) return;
      const action = btn.dataset.layoutAction;
      const layoutId = btn.dataset.layoutId;
      if (!layoutId) return;
      if (action === "load") _ClashSandboxModal.loadCustomLayout(layoutId);
      else if (action === "rename") _ClashSandboxModal.promptRenameLayout(layoutId);
      else if (action === "duplicate") _ClashSandboxModal.duplicateLayout(layoutId);
      else if (action === "export") _ClashSandboxModal.exportSingleLayout(layoutId);
      else if (action === "delete") _ClashSandboxModal.confirmDeleteLayout(layoutId);
    }
    /**
     * Loads a custom layout by ID into the active sandbox session.
     * @param {string} layoutId
     */
    static loadCustomLayout(layoutId) {
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const layouts = engine.getCustomLayouts ? engine.getCustomLayouts() : [];
      const layout = layouts.find((l) => l.id === layoutId);
      const counts = {};
      const clampedItems = [];
      for (const item of layout.items || []) {
        const limit = _ClashSandboxModal.getItemLimit(item.type, brand);
        const curr = counts[item.type] || 0;
        if (curr < limit) {
          counts[item.type] = curr + 1;
          clampedItems.push(item);
        }
      }
      _ClashSandboxModal.activeLayout = JSON.parse(JSON.stringify(clampedItems));
      _ClashSandboxModal.activeCustomLayoutId = layout.id;
      _ClashSandboxModal.activeCustomLayoutName = layout.name;
      if (layout.target && [121, 241, 361, 481].includes(Number(layout.target))) {
        _ClashSandboxModal.targetVal = Number(layout.target);
      }
      _ClashSandboxModal.closeLayoutsDrawer();
      _ClashSandboxModal.refreshView();
      _ClashSandboxModal.updateHeaderActiveBadge();
      if (typeof window !== "undefined" && typeof window.showToast === "function") {
        window.showToast(`\u{1F4E5} Loaded custom layout: "${layout.name}"`);
      }
    }
    /**
     * Opens the Save / Update Layout dialog.
     * @param {boolean} [isSaveAs=false]
     */
    static openSaveDialog(isSaveAs = false) {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("sandboxSaveDialogOverlay");
      const input = document.getElementById("txtCustomLayoutName");
      const title = document.getElementById("sandboxSaveDialogTitle");
      const footer = document.getElementById("sandboxSaveDialogFooter");
      const errorEl = document.getElementById("saveLayoutError");
      if (!overlay || !input) return;
      const isExisting = Boolean(_ClashSandboxModal.activeCustomLayoutId && !isSaveAs);
      if (title) {
        title.textContent = isExisting ? `Update "${_ClashSandboxModal.activeCustomLayoutName}"` : "Save Custom Track Layout";
      }
      input.value = isExisting ? (_ClashSandboxModal.activeCustomLayoutName || "").replace(/[^a-zA-Z0-9]/g, "") : "";
      input.addEventListener("input", () => {
        input.value = input.value.replace(/[^a-zA-Z0-9]/g, "");
        if (errorEl) errorEl.style.display = "none";
      });
      if (errorEl) errorEl.style.display = "none";
      if (footer) {
        if (isExisting) {
          footer.innerHTML = `
          <button type="button" class="btn-secondary" data-action="close-save-dialog">Cancel</button>
          <button type="button" class="btn-secondary" data-action="submit-save-layout" data-as-new="true">Save as New</button>
          <button type="button" class="btn-primary btn-gold" data-action="submit-save-layout" data-as-new="false">\u{1F4BE} Update Layout</button>
        `;
        } else {
          footer.innerHTML = `
          <button type="button" class="btn-secondary" data-action="close-save-dialog">Cancel</button>
          <button type="button" class="btn-primary btn-gold" data-action="submit-save-layout" data-as-new="false">\u{1F4BE} Save Layout</button>
        `;
        }
      }
      overlay.style.display = "flex";
      setTimeout(() => input.focus(), 50);
    }
    /**
     * Closes the Save / Update Layout dialog.
     */
    static closeSaveDialog() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("sandboxSaveDialogOverlay");
      if (overlay) overlay.style.display = "none";
    }
    /**
     * Submits custom layout saving.
     * @param {boolean} [saveAsNew=false]
     */
    static submitSaveLayout(saveAsNew = false) {
      if (typeof document === "undefined") return;
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const input = document.getElementById("txtCustomLayoutName");
      const errorEl = document.getElementById("saveLayoutError");
      const name = input ? sanitizeUserInput(input.value).replace(/[^a-zA-Z0-9]/g, "").trim() : "";
      if (!name) {
        if (errorEl) {
          errorEl.textContent = "Please enter a name for your track layout (letters and numbers only).";
          errorEl.style.display = "block";
        }
        return;
      }
      const items = _ClashSandboxModal.activeLayout || [];
      const metrics = engine.computeTrackMetrics(items, _ClashSandboxModal.targetVal);
      const config = _ClashSandboxModal.buildFormConfig(items, _ClashSandboxModal.targetVal, brand);
      const saved = engine.saveCustomLayout({
        id: !saveAsNew && _ClashSandboxModal.activeCustomLayoutId ? _ClashSandboxModal.activeCustomLayoutId : void 0,
        name,
        target: _ClashSandboxModal.targetVal,
        items,
        metrics,
        config
      });
      _ClashSandboxModal.activeCustomLayoutId = saved.id;
      _ClashSandboxModal.activeCustomLayoutName = saved.name;
      _ClashSandboxModal.closeSaveDialog();
      _ClashSandboxModal.refreshDrawerList();
      _ClashSandboxModal.updateHeaderActiveBadge();
      if (typeof window !== "undefined" && typeof window.showToast === "function") {
        window.showToast(`\u{1F4BE} Saved custom layout: "${saved.name}"`);
      }
    }
    /**
     * Prompts user to rename a custom layout.
     * @param {string} layoutId
     */
    static promptRenameLayout(layoutId) {
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const layouts = engine.getCustomLayouts ? engine.getCustomLayouts() : [];
      const layout = layouts.find((l) => l.id === layoutId);
      if (!layout) return;
      const rawName = window.prompt(`Rename layout "${layout.name}":`, layout.name);
      if (!rawName) return;
      const newName = sanitizeUserInput(rawName).replace(/[^a-zA-Z0-9]/g, "").trim();
      if (!newName || newName === layout.name) return;
      engine.renameCustomLayout(layoutId, newName);
      if (_ClashSandboxModal.activeCustomLayoutId === layoutId) {
        _ClashSandboxModal.activeCustomLayoutName = newName;
        _ClashSandboxModal.updateHeaderActiveBadge();
      }
      _ClashSandboxModal.refreshDrawerList();
      if (typeof window !== "undefined" && typeof window.showToast === "function") {
        window.showToast(`\u270F\uFE0F Renamed layout to "${newName}"`);
      }
    }
    /**
     * Prompts user to confirm deletion of a custom layout.
     * @param {string} layoutId
     */
    static confirmDeleteLayout(layoutId) {
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const layouts = engine.getCustomLayouts ? engine.getCustomLayouts() : [];
      const layout = layouts.find((l) => l.id === layoutId);
      if (!layout) return;
      const confirmed = window.confirm(`Are you sure you want to delete custom layout "${layout.name}"?`);
      if (!confirmed) return;
      engine.deleteCustomLayout(layoutId);
      if (_ClashSandboxModal.activeCustomLayoutId === layoutId) {
        _ClashSandboxModal.activeCustomLayoutId = null;
        _ClashSandboxModal.activeCustomLayoutName = null;
        _ClashSandboxModal.updateHeaderActiveBadge();
      }
      _ClashSandboxModal.refreshDrawerList();
      if (typeof window !== "undefined" && typeof window.showToast === "function") {
        window.showToast(`\u{1F5D1}\uFE0F Deleted layout "${layout.name}"`);
      }
    }
    /**
     * Duplicates an existing custom layout.
     * @param {string} layoutId
     */
    static duplicateLayout(layoutId) {
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const cloned = engine.duplicateCustomLayout ? engine.duplicateCustomLayout(layoutId) : null;
      if (cloned) {
        _ClashSandboxModal.refreshDrawerList();
        if (typeof window !== "undefined" && typeof window.showToast === "function") {
          window.showToast(`\u{1F4CB} Duplicated layout as "${cloned.name}"`);
        }
      }
    }
    /**
     * Opens the Share / Export JSON Dialog for a specific layout.
     * @param {string} layoutId
     */
    static exportSingleLayout(layoutId) {
      _ClashSandboxModal.openExportDialog(layoutId);
    }
    /**
     * Opens the Share / Export Dialog and auto-selects the track JSON.
     * @param {string} [layoutId=null]
     */
    static openExportDialog(layoutId = null) {
      if (typeof document === "undefined") return;
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const layouts = engine.getCustomLayouts ? engine.getCustomLayouts() : [];
      let layout = null;
      let titleHtml = "Share: <strong>All Custom Tracks</strong>";
      if (layoutId) {
        layout = layouts.find((l) => l.id === layoutId);
        if (!layout) return;
        titleHtml = `Share Track: <strong>${escapeHtml2(layout.name)}</strong>`;
      }
      const json = engine.exportLayout ? engine.exportLayout(layoutId) : JSON.stringify(LayoutSanitizer.prepareForExport(layout || layouts), null, 2);
      _ClashSandboxModal.currentExportedLayout = { layout: layout || { name: `${brand}-tracks` }, json };
      const overlay = document.getElementById("sandboxExportDialogOverlay");
      const txt = document.getElementById("txtExportLayoutJson");
      const title = document.getElementById("sandboxExportDialogTitle");
      const btnShare = document.getElementById("btnSystemShareLayout");
      const btnCopy = document.getElementById("btnCopyExportJson");
      if (!overlay || !txt) return;
      if (title) {
        title.innerHTML = titleHtml;
      }
      txt.value = json;
      if (btnCopy) {
        btnCopy.textContent = "\u{1F4CB} Copy Layout";
        btnCopy.classList.remove("btn-success");
        btnCopy.classList.add("btn-gold");
      }
      if (btnShare) {
        btnShare.style.display = typeof navigator !== "undefined" && typeof navigator.share === "function" ? "inline-flex" : "none";
      }
      overlay.style.display = "flex";
      setTimeout(() => {
        txt.focus();
        txt.select();
      }, 50);
      _ClashSandboxModal.copyExportedJsonToClipboard(false);
    }
    /**
     * Closes the Share / Export Dialog.
     */
    static closeExportDialog() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("sandboxExportDialogOverlay");
      if (overlay) overlay.style.display = "none";
    }
    /**
     * Copies exported JSON to clipboard with multi-tier fallback.
     * @param {boolean} [showToast=true]
     */
    static copyExportedJsonToClipboard(showToast = true) {
      if (typeof document === "undefined") return;
      const txt = document.getElementById("txtExportLayoutJson");
      const val = txt ? txt.value : _ClashSandboxModal.currentExportedLayout?.json || "";
      if (!val) return;
      const markSuccess = () => {
        const btnCopy = document.getElementById("btnCopyExportJson");
        if (btnCopy) {
          btnCopy.textContent = "\u2705 Copied!";
          btnCopy.classList.remove("btn-gold");
          btnCopy.classList.add("btn-success");
          setTimeout(() => {
            if (btnCopy) {
              btnCopy.textContent = "\u{1F4CB} Copy Layout";
              btnCopy.classList.remove("btn-success");
              btnCopy.classList.add("btn-gold");
            }
          }, 2500);
        }
        if (showToast && typeof window !== "undefined" && typeof window.showToast === "function") {
          window.showToast("\u{1F4CB} Track layout JSON copied to clipboard!");
        }
      };
      if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        navigator.clipboard.writeText(val).then(() => {
          markSuccess();
        }).catch(() => {
          try {
            if (txt) {
              txt.focus();
              txt.select();
              if (document.execCommand("copy")) markSuccess();
            }
          } catch (_) {
          }
        });
      } else {
        try {
          if (txt) {
            txt.focus();
            txt.select();
            if (document.execCommand("copy")) markSuccess();
          }
        } catch (_) {
        }
      }
    }
    /**
     * Downloads the exported layout as a .json file.
     */
    static downloadExportedLayout() {
      const exported = _ClashSandboxModal.currentExportedLayout;
      if (!exported || !exported.json) return;
      try {
        const safeName = (exported.layout?.name || "custom-track").toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "") || "track-layout";
        const fileName = `${safeName}.json`;
        const blob = new Blob([exported.json], { type: "application/json;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        if (typeof window !== "undefined" && typeof window.showToast === "function") {
          window.showToast(`\u{1F4BE} Downloaded "${fileName}"`);
        }
      } catch (err) {
        console.warn("[ClashSandboxModal] Download failed:", err);
      }
    }
    /**
     * Invokes native Web Share API if available.
     */
    static systemShareExportedLayout() {
      const exported = _ClashSandboxModal.currentExportedLayout;
      if (!exported || !exported.json) return;
      if (navigator && typeof navigator.share === "function") {
        navigator.share({
          title: `Track Layout: ${exported.layout?.name || "Custom Track"}`,
          text: exported.json
        }).catch((err) => {
          if (err.name !== "AbortError") {
            console.warn("[ClashSandboxModal] System share failed:", err);
          }
        });
      }
    }
    /**
     * Opens the Import JSON Dialog.
     */
    static openImportDialog() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("sandboxImportDialogOverlay");
      const txt = document.getElementById("txtImportLayoutJson");
      const err = document.getElementById("importLayoutError");
      if (!overlay || !txt) return;
      txt.value = "";
      if (err) err.style.display = "none";
      overlay.style.display = "flex";
      setTimeout(() => txt.focus(), 50);
    }
    /**
     * Closes the Import JSON Dialog.
     */
    static closeImportDialog() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById("sandboxImportDialogOverlay");
      if (overlay) overlay.style.display = "none";
    }
    /**
     * Submits JSON import.
     */
    static submitImportLayout() {
      if (typeof document === "undefined") return;
      const brand = _ClashSandboxModal.brand || "clash";
      const engine = _ClashSandboxModal.getPresetEngine(brand);
      const txt = document.getElementById("txtImportLayoutJson");
      const err = document.getElementById("importLayoutError");
      const raw = txt ? txt.value.trim() : "";
      if (!raw) {
        if (err) {
          err.textContent = "Please paste a valid JSON track layout.";
          err.style.display = "block";
        }
        return;
      }
      if (raw.length > MAX_LAYOUT_JSON_LENGTH) {
        if (err) {
          err.textContent = `Layout JSON exceeds maximum allowed size (${MAX_LAYOUT_JSON_LENGTH / 1024}KB).`;
          err.style.display = "block";
        }
        return;
      }
      try {
        const imported = engine.importLayout(raw);
        _ClashSandboxModal.closeImportDialog();
        _ClashSandboxModal.refreshDrawerList();
        if (typeof window !== "undefined" && typeof window.showToast === "function") {
          window.showToast(`\u{1F4E5} Imported layout "${imported.name}" successfully!`);
        }
      } catch (e) {
        if (err) {
          err.textContent = `Invalid layout JSON: ${e.message}`;
          err.style.display = "block";
        }
      }
    }
    /**
     * Updates the header badge showing the active custom layout name.
     */
    static updateHeaderActiveBadge() {
      if (typeof document === "undefined") return;
      const badge = document.getElementById("sandboxActiveBadge");
      if (badge) {
        if (_ClashSandboxModal.activeCustomLayoutName) {
          badge.innerHTML = `\u{1F4C1} Custom: <strong>${escapeHtml2(_ClashSandboxModal.activeCustomLayoutName)}</strong>`;
          badge.classList.add("is-visible");
        } else {
          badge.innerHTML = "";
          badge.classList.remove("is-visible");
        }
      }
    }
    /**
     * Applies the current sandbox layout to the settings store, form fields, and broadcasts across network.
     */
    static applyAndSave() {
      const brand = _ClashSandboxModal.brand || "clash";
      const layout = _ClashSandboxModal.activeLayout || [];
      const cfg = _ClashSandboxModal.buildFormConfig(layout, _ClashSandboxModal.targetVal, brand);
      if (typeof document !== "undefined") {
        for (const [prop, val] of Object.entries(cfg)) {
          if (typeof val === "object" && val !== null) continue;
          const el = document.getElementById(prop);
          if (el) {
            if (el.type === "checkbox") {
              el.checked = Boolean(val);
              const toggleFn = window[`toggle${prop.replace("opt", "")}Config`];
              if (typeof toggleFn === "function") toggleFn(el.checked);
            } else {
              if (el.tagName === "SELECT" && val !== void 0 && val !== null) {
                const strVal = String(val);
                let opt = el.querySelector(`option[value="${strVal}"]`);
                if (!opt) {
                  opt = document.createElement("option");
                  opt.value = strVal;
                  opt.textContent = el.id.endsWith("Count") ? `${strVal} Spaces` : `Hole ${strVal}`;
                  el.appendChild(opt);
                }
              }
              el.value = String(val);
              el.dataset.customized = "true";
              try {
                el.dispatchEvent(new Event("change", { bubbles: true }));
              } catch (_) {
              }
            }
          }
        }
        if (typeof window !== "undefined" && typeof window.updateTrackItemRows === "function") {
          if (brand === "pints") {
            ["youDrink", "guysDrink", "galsDrink", "leftDrink", "rightDrink", "everyoneDrink", "everyoneButYouDrink", "pickWhoDrinks"].forEach((k) => window.updateTrackItemRows(k));
          } else if (brand === "adult") {
            ["loseClothing", "gainClothing", "pickWhoLosesClothing", "rightLosesClothing", "leftLosesClothing", "removeClothingChoice", "touchBreast", "lickBreast", "suckBreast", "touchGenitals", "lickGenitals", "suckGenitals", "fingerGenitals"].forEach((k) => window.updateTrackItemRows(k));
          } else if (brand === "clash") {
            ["noPassingLanes", "jump", "jail", "bar", "timeout", "detour", "roundAbout", "signs", "stopSign", "dice", "wheel"].forEach((k) => window.updateTrackItemRows(k));
          }
        }
      }
      if (typeof window !== "undefined") {
        const customPresetProp = brand === "pints" ? "pintsPreset" : brand === "adult" ? "adultPreset" : "clashPreset";
        const customLayoutNameProp = brand === "pints" ? "pintsCustomLayoutName" : brand === "adult" ? "adultCustomLayoutName" : "clashCustomLayoutName";
        const customLayoutIdProp = brand === "pints" ? "pintsCustomLayoutId" : brand === "adult" ? "adultCustomLayoutId" : "clashCustomLayoutId";
        if (window.settings) {
          Object.assign(window.settings, cfg);
          window.settings[customPresetProp] = "custom";
          if (_ClashSandboxModal.activeCustomLayoutName) {
            window.settings[customLayoutNameProp] = _ClashSandboxModal.activeCustomLayoutName;
            window.settings[customLayoutIdProp] = _ClashSandboxModal.activeCustomLayoutId;
          }
        }
        if (window.crazyCribbageApp && window.crazyCribbageApp.settings) {
          Object.assign(window.crazyCribbageApp.settings, cfg);
          window.crazyCribbageApp.settings[customPresetProp] = "custom";
          if (_ClashSandboxModal.activeCustomLayoutName) {
            window.crazyCribbageApp.settings[customLayoutNameProp] = _ClashSandboxModal.activeCustomLayoutName;
            window.crazyCribbageApp.settings[customLayoutIdProp] = _ClashSandboxModal.activeCustomLayoutId;
          }
        }
        if (typeof window.saveBrandSettings === "function") {
          const curBrand = typeof window.readBrandSettings === "function" ? window.readBrandSettings(brand) : {};
          const mergedBrand = Object.assign({}, curBrand, cfg);
          mergedBrand[customPresetProp] = "custom";
          if (_ClashSandboxModal.activeCustomLayoutName) {
            mergedBrand[customLayoutNameProp] = _ClashSandboxModal.activeCustomLayoutName;
            mergedBrand[customLayoutIdProp] = _ClashSandboxModal.activeCustomLayoutId;
          }
          window.saveBrandSettings(brand, mergedBrand);
        }
        if (typeof window.saveSettingsStore === "function") {
          const curStore = typeof window.readFormSettings === "function" ? window.readFormSettings() : {};
          const mergedStore = Object.assign({}, curStore, window.settings, cfg);
          mergedStore[customPresetProp] = "custom";
          if (_ClashSandboxModal.activeCustomLayoutName) {
            mergedStore[customLayoutNameProp] = _ClashSandboxModal.activeCustomLayoutName;
            mergedStore[customLayoutIdProp] = _ClashSandboxModal.activeCustomLayoutId;
          }
          window.saveSettingsStore(mergedStore);
        }
        if (typeof window.netPush === "function") {
          window.netPush({
            type: "trackLayout",
            brand,
            settings: window.settings,
            customLayoutName: _ClashSandboxModal.activeCustomLayoutName || null
          });
        }
        if (window._currentRenderer3D) {
          if (window._currentRenderer3D.options) {
            window._currentRenderer3D.options.obstacleConfigs = null;
            window._currentRenderer3D.options.pintsConfigs = null;
            window._currentRenderer3D.options.adultConfigs = null;
          }
          if (typeof window._currentRenderer3D.updateClashObstacles === "function") {
            window._currentRenderer3D.updateClashObstacles(window.settings);
          }
          if (typeof window._currentRenderer3D.updatePintsObjects === "function") {
            window._currentRenderer3D.updatePintsObjects(window.settings);
          }
          if (typeof window._currentRenderer3D.updateAdultObjects === "function") {
            window._currentRenderer3D.updateAdultObjects(window.settings);
          }
        }
        if (typeof window.buildBoard === "function") {
          window.buildBoard();
        } else if (window.crazyCribbageApp && typeof window.crazyCribbageApp.buildBoard === "function") {
          window.crazyCribbageApp.buildBoard();
        }
        if (typeof window.renderScores === "function") {
          window.renderScores(false);
        } else if (window.crazyCribbageApp && typeof window.crazyCribbageApp.renderScores === "function") {
          window.crazyCribbageApp.renderScores(false);
        }
        if (typeof window.showToast === "function") {
          const nameMsg = _ClashSandboxModal.activeCustomLayoutName ? `\u{1F3C1} Applied "${_ClashSandboxModal.activeCustomLayoutName}" to match!` : "\u{1F3C1} Custom Board Layout applied to match!";
          window.showToast(nameMsg);
        }
      }
      _ClashSandboxModal.close();
    }
  };
  if (typeof window !== "undefined") {
    window.ClashSandboxModal = ClashSandboxModal;
    window.openClashSandbox = (opts) => ClashSandboxModal.open({ brand: "clash", ...opts });
    window.openPintsSandbox = (opts) => ClashSandboxModal.open({ brand: "pints", ...opts });
    window.openAdultSandbox = (opts) => ClashSandboxModal.open({ brand: "adult", ...opts });
  }

  // src/ui/UIController.js
  function getStorage9(s) {
    return s || typeof window !== "undefined" && window.appStorage || appStorage || (typeof localStorage !== "undefined" ? localStorage : null);
  }
  var UIController = class _UIController {
    constructor(options = {}) {
      this.options = options;
    }
    /**
     * Tests if a message text corresponds to a Crazy Cribbage bonus or obstacle event.
     */
    static isBonusMessage(text2) {
      if (!text2) return false;
      const s = String(text2);
      return /sign|plus 5|plus 10|minus 5|minus 10|wheel|dice|undo|selected|chose sign|all red|all black|all odd|all even|all diff|suicide king|king of hearts|queen of spades|ace of spades|spades cut|no spade|spades|guess starter|starter guess|starter guessed|full house|straight flush|royal flush|straight|stolen crib|crib stolen|thirty-one for five|31.*for 5|nineteen for two|19.*for 2|thirty-one|nineteen|detour|round about|jail|bar|timeout|passing lane|stop sign|partner|flush in play|flush of|double run|triple run|quadruple run|bonus/i.test(s);
    }
    /**
     * Converts score reason into classic cribbage callout phrase.
     */
    static fancyPegPhrase(why, n) {
      const w = String(why || "").toLowerCase();
      const xRunM = w.match(/(\d+)x run of (\d+)/);
      const qRunM = w.match(/quadruple run of (\d+)/);
      const tRunM = w.match(/triple run of (\d+)/);
      const dRunM = w.match(/double run of (\d+)/);
      const runM = w.match(/run of (\d+)/);
      const flushM = w.match(/flush of (\d+)/);
      if (w.includes("thirty-one") || w.includes("31")) return n === 5 ? "Thirty-one for five" : "Thirty-one for two";
      if (w.includes("nineteen") || w === "19") return "Nineteen for two";
      if (w.includes("fifteen")) return "Fifteen for two";
      if (w.includes("double pair royal")) return "Double pair royal";
      if (w.includes("pair royal")) return "Pair royal";
      if (w.includes("pair")) return "Pair for two";
      if (xRunM) return xRunM[1] + "x run of " + xRunM[2] + (n ? " for " + n : "");
      if (qRunM) return "Quadruple run of " + qRunM[1] + (n ? " for " + n : "");
      if (tRunM) return "Triple run of " + tRunM[1] + (n ? " for " + n : "");
      if (dRunM) return "Double run of " + dRunM[1] + (n ? " for " + n : "");
      if (runM) return "Run of " + runM[1];
      if (w.includes("run")) return "Run of " + n;
      if (flushM) return "Flush of " + flushM[1];
      if (w.includes("flush")) return "Flush of " + n;
      if (w.includes("go")) return "One for last";
      if (w.includes("heels")) return "Two for his heels";
      if (w.includes("nobs")) return "One for his nobs";
      return n ? "+" + n + "  " + why : why;
    }
    /**
     * Updates count glow classes and radial clock indicator.
     */
    static updateCountGlow(count = 0, phase = "play", elements = null) {
      if (typeof document === "undefined") return;
      const chip = elements && elements.chip || document.querySelector(".count-chip");
      const clock = elements && elements.clock || document.getElementById("countClock");
      const pile = elements && elements.pile || document.querySelector(".play-pile");
      if (chip) chip.classList.remove("hit-15", "hit-31");
      if (clock) clock.classList.remove("hit-15", "hit-31");
      if (pile) pile.classList.remove("hit-15", "hit-31");
      const n = count || 0;
      if (clock) {
        clock.style.setProperty("--p", String(Math.max(0, Math.min(100, n / 31 * 100))));
      }
      if (phase !== "play") return;
      const hit = n === 31 ? "hit-31" : n === 15 ? "hit-15" : "";
      if (hit) {
        if (chip) chip.classList.add(hit);
        if (clock) clock.classList.add(hit);
        if (pile) pile.classList.add(hit);
      }
    }
    /**
     * Displays milestone street announcement banner.
     */
    static showStreetBanner(who, mark, options = {}) {
      if (typeof document === "undefined") return;
      const pName2 = options.pName || typeof window !== "undefined" && window.pName || ((w) => w);
      const streetName3 = options.streetName || typeof window !== "undefined" && window.streetName || ((m) => "Street " + m);
      const fancyCall2 = options.fancyCall || typeof window !== "undefined" && window.fancyCall;
      const el = document.getElementById("streetBanner");
      if (!el) {
        if (typeof fancyCall2 === "function") {
          fancyCall2(pName2(who) + " \u2014 " + streetName3(mark), "street", 1600);
        }
        return;
      }
      el.innerHTML = `<span class="who">${pName2(who)}</span>${streetName3(mark)}`;
      el.className = "on";
      clearTimeout(_UIController._streetBannerTimer);
      _UIController._streetBannerTimer = setTimeout(() => {
        el.className = "";
        el.textContent = "";
      }, 1800);
    }
    /**
     * Displays animated score toast notification.
     */
    static showScoreToast(who, n, why, customDuration = null, options = {}) {
      if (typeof document === "undefined") return;
      const box = options && options.container || document.getElementById("toasts");
      if (!box) return;
      const pName2 = options && options.pName || typeof window !== "undefined" && window.pName || ((w) => w);
      const isBonus = _UIController.isBonusMessage(why);
      const toastDuration = customDuration || (isBonus ? 5500 : 3800);
      const el = document.createElement("div");
      el.className = "toast " + who + (isBonus ? " bonus-toast" : "");
      el.style.setProperty("--toast-duration", `${Math.max(1, (toastDuration - 400) / 1e3)}s`);
      const ptsText = typeof n === "string" ? n : n > 0 ? `+${n}` : n < 0 ? `${n}` : "0";
      el.innerHTML = `<div class="who">${pName2(who)}${isBonus ? ' <span class="toast-bonus-badge">BONUS</span>' : ""}</div>
      <div class="pts">${ptsText}</div>
      <div class="why">${why}</div>`;
      box.prepend(el);
      setTimeout(() => {
        if (el && el.parentNode) el.remove();
      }, toastDuration);
    }
    /**
     * Displays center screen callout text.
     */
    static fancyCall(text2, kind, ms = null, options = {}) {
      if (typeof document === "undefined") return;
      const el = options && options.element || document.getElementById("callout");
      if (!el || !text2) return;
      const fsElem = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
      const b3dElem = typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
      const targetParent = fsElem || b3dElem;
      if (targetParent && el.parentElement !== targetParent) {
        targetParent.appendChild(el);
      } else if (!targetParent && el.parentElement !== document.body && document.body) {
        document.body.appendChild(el);
      }
      const isBonus = _UIController.isBonusMessage(text2) || kind === "signs" || kind === "famous";
      const displayMs = ms || (isBonus ? 2600 : 1300);
      el.className = "on" + (kind ? " " + kind : "") + (isBonus ? " bonus-call" : "");
      el.textContent = text2;
      clearTimeout(_UIController._fancyCallTimer);
      _UIController._fancyCallTimer = setTimeout(() => {
        el.className = "";
        el.textContent = "";
      }, displayMs);
    }
    /**
     * Updates game status prompt and state customStatus.
     */
    static setStatus(t, state3 = null, promptFn = null) {
      if (state3) state3.customStatus = t;
      if (typeof promptFn === "function") {
        promptFn(t);
      } else if (typeof window !== "undefined" && typeof window.updateTurnPrompt === "function") {
        window.updateTurnPrompt(t);
      }
    }
    /**
     * Updates game status line based on turn and match phase.
     * @param {string} [overrideText]
     * @param {Object} [options]
     */
    static updateTurnPrompt(overrideText, options = {}) {
      const state3 = options.state || (typeof window !== "undefined" ? window.state : null) || {};
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : null) || {};
      return _UIController.formatTurnPrompt(overrideText, state3, settings3, options);
    }
    /**
     * Formats prompt HTML for turn status line.
     */
    static formatTurnPrompt(overrideText, state3, settings3, options = {}) {
      const el = options && options.element || (typeof document !== "undefined" ? document.getElementById("status") : null);
      if (!state3) return;
      const pName2 = options.pName || typeof window !== "undefined" && window.pName || ((s) => s);
      const seatName3 = options.seatName || typeof window !== "undefined" && window.seatName || ((s) => s);
      const mySeat3 = options.mySeat || typeof window !== "undefined" && window.mySeat || (() => "you");
      const isOnline2 = options.isOnline || typeof window !== "undefined" && window.isOnline || (() => false);
      const isHvH2 = options.isHvH || typeof window !== "undefined" && window.isHvH || (() => false);
      const isSeatHuman2 = options.isSeatHuman || typeof window !== "undefined" && window.isSeatHuman || (() => true);
      const nextSeat2 = options.nextSeat || typeof window !== "undefined" && window.nextSeat || ((s) => s === "p1" ? "p2" : "p1");
      const cardLabel2 = options.cardLabel || typeof window !== "undefined" && window.cardLabel || ((c) => c);
      const me = mySeat3();
      const count = settings3 && settings3.playerCount || 2;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      const discardN = count >= 3 ? 1 : is7Card ? 2 : settings3 && settings3.deal === "super" ? 3 : 2;
      let text2 = overrideText || "";
      let isMyTurn = false;
      let isWait = false;
      if (!text2) {
        if (state3.over) {
          text2 = state3.winner === me ? "Victory! You won the match!" : "Match over. " + pName2(state3.winner) + " won!";
        } else if (state3.phase === "cut") {
          const curTurn = state3.cutTurn || "p1";
          if (isOnline2()) {
            const myPick = state3.cutPicks && state3.cutPicks[me];
            if (myPick) {
              isWait = true;
              text2 = "You cut the " + cardLabel2(myPick) + ". Waiting for " + pName2(state3.cutTurn) + " to cut the deck\u2026";
            } else if (state3.cutTurn === me) {
              isMyTurn = true;
              text2 = "Your cut \u2014 tap any card in the fan to cut the deck (lowest card deals).";
            } else {
              isWait = true;
              text2 = "Waiting for " + pName2(state3.cutTurn) + " to cut the deck\u2026";
            }
          } else {
            const curPick = state3.cutPicks && state3.cutPicks[curTurn];
            if (!curPick && isSeatHuman2(curTurn)) {
              isMyTurn = true;
              text2 = (curTurn === "p1" ? "Your cut" : seatName3(curTurn) + "\u2019s cut") + " \u2014 tap any card in the fan to cut the deck (lowest card deals).";
            } else {
              isWait = true;
              text2 = seatName3(curTurn) + " is cutting the deck\u2026";
            }
          }
        } else if (state3.phase === "cut-starter") {
          const pone = nextSeat2(state3.dealer);
          const isProg = Boolean(settings3 && settings3.optProgressiveCut && (settings3.playerCount || 2) === 2);
          const cutCount = isProg ? Math.max(1, Math.floor((state3.handsCompleted || 0) / 2) + 1) : 1;
          const cardPhrase = cutCount > 1 ? `${cutCount} starter cards` : "the starter card";
          if (pone === me || !isOnline2() && isSeatHuman2(pone)) {
            isMyTurn = true;
            text2 = (pone === "p1" ? "You are the pone" : seatName3(pone) + " (pone)") + ` \u2014 cut the deck for ${cardPhrase}.`;
          } else {
            isWait = true;
            text2 = seatName3(pone) + ` (pone) is cutting ${cardPhrase} from the deck\u2026`;
          }
        } else if (state3.phase === "cut-reveal") {
          const winnerText = state3.dealer === me ? "You cut lower and deal first!" : pName2(state3.dealer) + " cut lower and deals first!";
          text2 = "Cut revealed: " + winnerText;
        } else if (state3.phase === "dealing") {
          text2 = (state3.dealer === me ? "You are dealing" : pName2(state3.dealer) + " is dealing") + " the cards\u2026";
        } else if (state3.phase === "play") {
          const cribEl = typeof document !== "undefined" ? document.getElementById("cribCards") : null;
          if (cribEl) {
            cribEl.classList.remove("counting");
            cribEl.classList.add("playing");
          }
          const activeTurn = state3.passingTo || state3.turn;
          const isHumanActive = activeTurn === me || !isOnline2() && isSeatHuman2(activeTurn);
          if (state3.frozen) {
            text2 = state3.count === 31 ? "Thirty-one! Sweeping count\u2026" : "Go! Sweeping count\u2026";
          } else if (isHumanActive) {
            isMyTurn = true;
            const whoPrefix = activeTurn === me || activeTurn === "p1" || activeTurn === "you" ? "Your" : seatName3(activeTurn) + "\u2019s";
            text2 = whoPrefix + " turn! Play a card (count is " + state3.count + " / 31).";
          } else {
            isWait = true;
            text2 = "Waiting for " + pName2(activeTurn) + " to play a card\u2026 (count is " + state3.count + " / 31)";
          }
        } else if (state3.phase === "show") {
          const cribEl = typeof document !== "undefined" ? document.getElementById("cribCards") : null;
          if (cribEl) {
            cribEl.classList.remove("playing");
            cribEl.classList.add("counting");
          }
          if (state3.showAct === "pone") {
            const pone = state3.dealer === "you" ? "cpu" : "you";
            text2 = "Counting " + pName2(pone) + " hand (pone)\u2026";
          } else if (state3.showAct === "dealer") {
            text2 = "Counting " + pName2(state3.dealer) + " hand (dealer)\u2026";
          } else if (state3.showAct === "crib") {
            text2 = "Counting Crib (" + pName2(state3.dealer) + ")\u2026";
          } else if (state3.showAct && state3.showAct !== "done") {
            text2 = "Counting " + pName2(state3.showAct) + " hand\u2026";
          } else {
            text2 = "Hand scoring complete.";
          }
        }
      }
      if (text2 && el) {
        let badge = "";
        if (isMyTurn) {
          const activeTurn = state3 && (state3.passingTo || state3.turn);
          const badgeLabel = activeTurn && activeTurn !== me && activeTurn !== "p1" && activeTurn !== "you" && !isOnline2() && isSeatHuman2(activeTurn) ? `${String(seatName3(activeTurn)).toUpperCase()} TURN` : "YOUR TURN";
          badge = `<span class="turn-badge your-turn">${badgeLabel}</span> `;
        } else if (isWait) {
          badge = '<span class="turn-badge wait-turn">WAITING</span> ';
        }
        el.innerHTML = badge + "<span>" + text2 + "</span>";
      }
      return { text: text2, isMyTurn, isWait };
    }
    /**
     * Initializes the draggable table splitter dividing the board and card play area.
     */
    static initTableSplitter(options = {}) {
      if (typeof document === "undefined") return;
      const splitter = document.getElementById("tableSplitter");
      const splitContainer = document.querySelector(".table.split");
      const leftPanel = document.querySelector(".table-left");
      if (!splitter || !splitContainer || !leftPanel) return;
      const STORAGE_KEY = options.storageKey || "cc_table_split_width";
      const DEFAULT_WIDTH = options.defaultWidth || "38%";
      const storage = getStorage9(options.storage);
      if (storage) {
        try {
          const savedWidth = storage.getItem(STORAGE_KEY);
          if (savedWidth) {
            splitContainer.style.setProperty("--table-left-width", savedWidth);
          }
        } catch (e) {
        }
      }
      let isDragging = false;
      let startX = 0;
      let startWidthPx = 0;
      const onPointerDown = (e) => {
        if (e.type === "mousedown" && e.button !== 0) return;
        isDragging = true;
        splitter.classList.add("dragging");
        document.body.classList.add("is-table-resizing");
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        startX = clientX;
        startWidthPx = leftPanel.getBoundingClientRect().width;
        window.addEventListener("mousemove", onPointerMove, { passive: false });
        window.addEventListener("touchmove", onPointerMove, { passive: false });
        window.addEventListener("mouseup", onPointerUp);
        window.addEventListener("touchend", onPointerUp);
        window.addEventListener("touchcancel", onPointerUp);
        e.preventDefault();
      };
      const onPointerMove = (e) => {
        if (!isDragging) return;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const deltaX = clientX - startX;
        const containerRect = splitContainer.getBoundingClientRect();
        const containerWidth = containerRect.width;
        if (containerWidth <= 0) return;
        const minLeftPx = 240;
        const maxLeftPx = Math.max(minLeftPx, containerWidth - 280);
        const newLeftPx = Math.max(minLeftPx, Math.min(maxLeftPx, startWidthPx + deltaX));
        const widthPct = Math.round(newLeftPx / containerWidth * 1e3) / 10;
        const clampedPct = Math.max(20, Math.min(75, widthPct));
        const widthVal = `${clampedPct}%`;
        splitContainer.style.setProperty("--table-left-width", widthVal);
        e.preventDefault();
      };
      const onPointerUp = () => {
        if (!isDragging) return;
        isDragging = false;
        splitter.classList.remove("dragging");
        document.body.classList.remove("is-table-resizing");
        window.removeEventListener("mousemove", onPointerMove);
        window.removeEventListener("touchmove", onPointerMove);
        window.removeEventListener("mouseup", onPointerUp);
        window.removeEventListener("touchend", onPointerUp);
        window.removeEventListener("touchcancel", onPointerUp);
        const currentWidth = splitContainer.style.getPropertyValue("--table-left-width");
        if (currentWidth && storage) {
          try {
            storage.setItem(STORAGE_KEY, currentWidth);
          } catch (e) {
          }
        }
      };
      splitter.addEventListener("mousedown", onPointerDown);
      splitter.addEventListener("touchstart", onPointerDown, { passive: false });
      splitter.addEventListener("dblclick", () => {
        splitContainer.style.setProperty("--table-left-width", DEFAULT_WIDTH);
        if (storage) {
          try {
            storage.removeItem(STORAGE_KEY);
          } catch (e) {
          }
        }
        const box = document.getElementById("toasts");
        if (box) {
          const el = document.createElement("div");
          el.className = "toast";
          el.style.borderLeft = "3px solid #f0c64a";
          el.innerHTML = '<div class="why" style="font-size:0.85rem;color:#f8fafc;">Reset cribbage board & playing area layout to default</div>';
          box.prepend(el);
          setTimeout(() => el.remove(), 2500);
        }
      });
      splitter.addEventListener("keydown", (e) => {
        const containerRect = splitContainer.getBoundingClientRect();
        const containerWidth = containerRect.width;
        if (containerWidth <= 0) return;
        let currentPct = parseFloat(splitContainer.style.getPropertyValue("--table-left-width")) || 38;
        if (e.key === "ArrowLeft") {
          currentPct = Math.max(20, currentPct - 2);
          splitContainer.style.setProperty("--table-left-width", `${currentPct}%`);
          if (storage) {
            try {
              storage.setItem(STORAGE_KEY, `${currentPct}%`);
            } catch (err) {
            }
          }
          e.preventDefault();
        } else if (e.key === "ArrowRight") {
          currentPct = Math.min(75, currentPct + 2);
          splitContainer.style.setProperty("--table-left-width", `${currentPct}%`);
          if (storage) {
            try {
              storage.setItem(STORAGE_KEY, `${currentPct}%`);
            } catch (err) {
            }
          }
          e.preventDefault();
        } else if (e.key === "Enter" || e.key === " ") {
          splitContainer.style.setProperty("--table-left-width", DEFAULT_WIDTH);
          if (storage) {
            try {
              storage.removeItem(STORAGE_KEY);
            } catch (err) {
            }
          }
          e.preventDefault();
        }
      });
    }
    /**
     * Toggles the lobby settings menu or confirms leaving an active game.
     */
    static toggleMenuSettings(fromGame = false, context = {}) {
      if (typeof document === "undefined") return;
      const menuOptions = document.getElementById("menuOptions");
      const btnSettingsMenu = document.getElementById("btnSettingsMenu");
      const menuVariants = document.getElementById("menuVariants");
      const btnVariantsMenu = document.getElementById("btnVariantsMenu");
      const gameEl = document.getElementById("game");
      const menuEl = document.getElementById("menu");
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const hideModalFn = context.hideModal || (typeof window !== "undefined" && window.hideModal ? window.hideModal : null);
      const showConfirmModalFn = context.showConfirmModal || (typeof window !== "undefined" && window.showConfirmModal ? window.showConfirmModal : null);
      const renderRecordBoxFn = context.renderRecordBox || (typeof window !== "undefined" && window.renderRecordBox ? window.renderRecordBox : null);
      const openSettings = () => {
        if (typeof hideModalFn === "function") hideModalFn();
        if (gameEl) gameEl.classList.add("hidden");
        if (menuEl) menuEl.classList.remove("hidden");
        if (menuVariants) menuVariants.classList.add("hidden");
        if (btnVariantsMenu) btnVariantsMenu.classList.remove("is-active");
        if (menuOptions) {
          menuOptions.classList.remove("hidden");
          menuOptions.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        if (btnSettingsMenu) btnSettingsMenu.classList.add("is-active");
        if (typeof renderRecordBoxFn === "function") renderRecordBoxFn();
      };
      if (fromGame || gameEl && !gameEl.classList.contains("hidden")) {
        if (state3 && state3.over) {
          openSettings();
          return;
        }
        if (typeof showConfirmModalFn === "function") {
          showConfirmModalFn({
            title: "Go to Game Settings?",
            message: "Your current match will end and progress will be lost. Are you sure you want to open settings?",
            confirmText: "Go to Settings",
            cancelText: "Keep Playing",
            onConfirm: openSettings
          });
        } else {
          openSettings();
        }
        return;
      }
      if (!menuOptions) return;
      if (menuVariants) menuVariants.classList.add("hidden");
      if (btnVariantsMenu) btnVariantsMenu.classList.remove("is-active");
      const isHidden = menuOptions.classList.toggle("hidden");
      const isOpen = !isHidden;
      if (btnSettingsMenu) {
        btnSettingsMenu.classList.toggle("is-active", isOpen);
        const tooltip = isOpen ? "Hide game settings" : "Game settings";
        btnSettingsMenu.title = tooltip;
        btnSettingsMenu.setAttribute("aria-label", tooltip);
      }
      if (isOpen) {
        menuOptions.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
    /**
     * Toggles the variants / board layout menu or confirms leaving an active game.
     * For Cribbage Clash, Pints & Pegs, and Skunked & Stripped, Board Layout directly opens the Track Sandbox.
     */
    static toggleMenuVariants(fromGame = false, context = {}) {
      if (typeof document === "undefined") return;
      const menuVariants = document.getElementById("menuVariants");
      const btnVariantsMenu = document.getElementById("btnVariantsMenu");
      const menuOptions = document.getElementById("menuOptions");
      const btnSettingsMenu = document.getElementById("btnSettingsMenu");
      const gameEl = document.getElementById("game");
      const menuEl = document.getElementById("menu");
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const hideModalFn = context.hideModal || (typeof window !== "undefined" && window.hideModal ? window.hideModal : null);
      const showConfirmModalFn = context.showConfirmModal || (typeof window !== "undefined" && window.showConfirmModal ? window.showConfirmModal : null);
      const renderRecordBoxFn = context.renderRecordBox || (typeof window !== "undefined" && window.renderRecordBox ? window.renderRecordBox : null);
      const brand = typeof window !== "undefined" && typeof window.detectBrand === "function" ? window.detectBrand() : context.brand || typeof window !== "undefined" && (window.currentBrand || window.currentLogoBrand) || "crazy";
      const isCrazy = brand === "crazy";
      if (!isCrazy) {
        const isSandboxOpen = typeof window !== "undefined" && window.ClashSandboxModal && window.ClashSandboxModal.isOpen || typeof ClashSandboxModal !== "undefined" && ClashSandboxModal.isOpen;
        if (isSandboxOpen) {
          if (typeof window !== "undefined" && window.ClashSandboxModal && typeof window.ClashSandboxModal.close === "function") {
            window.ClashSandboxModal.close();
          } else if (typeof ClashSandboxModal !== "undefined" && typeof ClashSandboxModal.close === "function") {
            ClashSandboxModal.close();
          }
          return;
        }
        _UIController.hideMenuVariants();
        _UIController.hideMenuOptions();
        const sandboxContext = { brand, state: state3, settings: settings3 };
        if (typeof window !== "undefined") {
          if (brand === "pints" && typeof window.openPintsSandbox === "function") {
            return window.openPintsSandbox(sandboxContext);
          }
          if (brand === "adult" && typeof window.openAdultSandbox === "function") {
            return window.openAdultSandbox(sandboxContext);
          }
          if (typeof window.openClashSandbox === "function") {
            return window.openClashSandbox(sandboxContext);
          }
          if (window.ClashSandboxModal && typeof window.ClashSandboxModal.open === "function") {
            return window.ClashSandboxModal.open(sandboxContext);
          }
        }
        if (typeof ClashSandboxModal !== "undefined" && typeof ClashSandboxModal.open === "function") {
          return ClashSandboxModal.open(sandboxContext);
        }
        return;
      }
      const openVariants = () => {
        if (typeof hideModalFn === "function") hideModalFn();
        if (gameEl) gameEl.classList.add("hidden");
        if (menuEl) menuEl.classList.remove("hidden");
        if (menuOptions) menuOptions.classList.add("hidden");
        if (typeof document !== "undefined") {
          if (document.fullscreenElement && typeof document.exitFullscreen === "function") {
            document.exitFullscreen().catch(() => {
            });
          }
          if (document.body) {
            document.body.classList.remove("is-3d-fullscreen");
          }
        }
        const r3d = typeof window !== "undefined" ? window._currentRenderer3D || window.boardRenderer3D : null;
        if (r3d && typeof r3d.exitFullScreen === "function") {
          r3d.exitFullScreen();
        }
        if (menuVariants) {
          menuVariants.classList.remove("hidden");
          menuVariants.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        if (btnVariantsMenu) btnVariantsMenu.classList.add("is-active");
        if (typeof renderRecordBoxFn === "function") renderRecordBoxFn();
      };
      if (fromGame || gameEl && !gameEl.classList.contains("hidden")) {
        if (state3 && state3.over) {
          openVariants();
          return;
        }
        const label = "Crazy Variants";
        if (typeof showConfirmModalFn === "function") {
          showConfirmModalFn({
            title: `Go to ${label}?`,
            message: `Your current match will end and progress will be lost. Are you sure you want to open ${label}?`,
            confirmText: `Go to ${label}`,
            cancelText: "Keep Playing",
            onConfirm: openVariants
          });
        } else {
          openVariants();
        }
        return;
      }
      if (!menuVariants) return;
      if (menuOptions) menuOptions.classList.add("hidden");
      if (btnSettingsMenu) btnSettingsMenu.classList.remove("is-active");
      const isHidden = menuVariants.classList.toggle("hidden");
      const isOpen = !isHidden;
      if (isOpen) {
        if (typeof document !== "undefined") {
          if (document.fullscreenElement && typeof document.exitFullscreen === "function") {
            document.exitFullscreen().catch(() => {
            });
          }
          if (document.body) {
            document.body.classList.remove("is-3d-fullscreen");
          }
        }
        const r3d = typeof window !== "undefined" ? window._currentRenderer3D || window.boardRenderer3D : null;
        if (r3d && typeof r3d.exitFullScreen === "function") {
          r3d.exitFullScreen();
        }
        menuVariants.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      if (btnVariantsMenu) {
        btnVariantsMenu.classList.toggle("is-active", isOpen);
        const name = "Crazy Variants";
        const tooltip = isOpen ? `Hide ${name}` : name;
        btnVariantsMenu.title = tooltip;
        btnVariantsMenu.setAttribute("aria-label", tooltip);
      }
    }
    /**
     * Hides the lobby settings menu and variants menu.
     */
    static hideMenuOptions() {
      if (typeof document === "undefined") return;
      const menuOptions = document.getElementById("menuOptions");
      if (menuOptions) menuOptions.classList.add("hidden");
      const btnSettingsMenu = document.getElementById("btnSettingsMenu");
      if (btnSettingsMenu) btnSettingsMenu.classList.remove("is-active");
      _UIController.hideMenuVariants();
    }
    /**
     * Hides the lobby variants / board layout menu.
     */
    static hideMenuVariants() {
      if (typeof document === "undefined") return;
      const menuVariants = document.getElementById("menuVariants");
      if (menuVariants) menuVariants.classList.add("hidden");
      const btnVariantsMenu = document.getElementById("btnVariantsMenu");
      if (btnVariantsMenu) btnVariantsMenu.classList.remove("is-active");
    }
    toggleMenuSettings(fromGame, context) {
      return _UIController.toggleMenuSettings(fromGame, context);
    }
    toggleMenuVariants(fromGame, context) {
      return _UIController.toggleMenuVariants(fromGame, context);
    }
    hideMenuOptions() {
      return _UIController.hideMenuOptions();
    }
    hideMenuVariants() {
      return _UIController.hideMenuVariants();
    }
    static showStartGameModal(context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showStartGameModal === "function") {
        return window.modalManager.showStartGameModal(context);
      }
      const overlay = document.getElementById("startGameOverlay");
      if (overlay) overlay.style.display = "flex";
    }
    static hideStartGameModal() {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.hideStartGameModal === "function") {
        return window.modalManager.hideStartGameModal();
      }
      const overlay = document.getElementById("startGameOverlay");
      if (overlay) overlay.style.display = "none";
    }
    showStartGameModal(context) {
      return _UIController.showStartGameModal(context);
    }
    hideStartGameModal() {
      return _UIController.hideStartGameModal();
    }
    static showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context = {}) {
      if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showPlayerOfflineModal === "function") {
        return window.modalManager.showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context);
      }
      const mgr = CC?.ModalManager || (typeof ModalManager !== "undefined" ? ModalManager : null);
      if (mgr && typeof mgr.showPlayerOfflineModal === "function") {
        return mgr.showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context);
      }
    }
    showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context) {
      return _UIController.showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel, context);
    }
    static cancelGameAndReturnToMenu() {
      if (typeof window !== "undefined" && typeof window.cancelGameAndReturnToMenu === "function") {
        return window.cancelGameAndReturnToMenu();
      }
    }
    cancelGameAndReturnToMenu() {
      return _UIController.cancelGameAndReturnToMenu();
    }
    /**
     * Initializes theme toggle buttons across navbar and menu headers.
     * @param {Object} [context]
     */
    static initThemeButtons(context = {}) {
      if (typeof document === "undefined") return;
      const applyTheme2 = context.applyTheme || (typeof window !== "undefined" ? window.applyTheme : () => {
      });
      const toggleTheme2 = context.toggleTheme || (typeof window !== "undefined" ? window.toggleTheme : () => {
      });
      if (typeof window !== "undefined") window.isThemeReady = true;
      applyTheme2();
      const b = document.getElementById("btnTheme");
      if (b) b.onclick = toggleTheme2;
      const btnMenu = document.getElementById("btnThemeMenu");
      if (btnMenu) btnMenu.onclick = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        toggleTheme2();
      };
      const btnHeader = document.getElementById("btnThemeHeader");
      if (btnHeader) btnHeader.onclick = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        toggleTheme2();
      };
    }
    /**
     * Initializes sound toggle button with local storage persistence.
     * @param {Object} [context]
     */
    static initSoundButton(context = {}) {
      if (typeof document === "undefined") return;
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : { on: true, ensure: () => {
      }, peg: () => {
      } });
      const b = document.getElementById("btnSound");
      if (!b) return;
      const sync = () => {
        b.textContent = sfx3.on ? "Sound on" : "Sound off";
      };
      sync();
      b.onclick = () => {
        sfx3.on = !sfx3.on;
        try {
          const s = getStorage9();
          if (s) {
            s.setItem("crazyCribbage.sfx", sfx3.on ? "on" : "off");
          }
        } catch (e) {
        }
        if (sfx3.on) {
          if (sfx3.ensure) sfx3.ensure();
          if (sfx3.peg) sfx3.peg();
        }
        sync();
      };
    }
    /**
     * Updates is-mobile-device CSS classes based on viewport dimensions and touch capabilities.
     */
    static updateMobileDeviceClass() {
      if (typeof window === "undefined" || typeof document === "undefined") return;
      try {
        const isNarrow = window.innerWidth <= 920;
        const isShort = window.innerHeight <= 520 && window.innerWidth <= 1024;
        const isMobileUA = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");
        const isTouchNarrow = ("ontouchstart" in window || navigator.maxTouchPoints > 0) && window.innerWidth <= 1024;
        const isMobile = isNarrow || isShort || isMobileUA || isTouchNarrow;
        if (isMobile) {
          document.documentElement.classList.add("is-mobile-device");
          if (document.body) document.body.classList.add("is-mobile-device");
        } else {
          document.documentElement.classList.remove("is-mobile-device");
          if (document.body) document.body.classList.remove("is-mobile-device");
        }
      } catch (e) {
      }
    }
    /**
     * Updates seat display labels and title headers based on player count, game mode, and brand rules.
     * @param {Object} [context]
     */
    static applySeatLabels(context = {}) {
      if (typeof document === "undefined") return;
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const getPlayerCount2 = context.getPlayerCount || (typeof window !== "undefined" ? window.getPlayerCount : () => 2);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "crazy");
      const isSoloVsPairs2 = context.isSoloVsPairs || (typeof window !== "undefined" ? window.isSoloVsPairs : () => false);
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : (s) => s);
      const isHvH2 = context.isHvH || (typeof window !== "undefined" ? window.isHvH : () => false);
      const y = document.getElementById("youLabel");
      const c = document.getElementById("cpuLabel");
      const yt = document.getElementById("youTitle");
      const ct = document.getElementById("cpuTitle");
      const btnCam = document.getElementById("btnCamToggle");
      if (btnCam) {
        btnCam.classList.toggle("hidden", !isOnline2());
      }
      try {
        const isMultiHuman3 = isOnline2() || (typeof isHvH2 === "function" ? isHvH2() : false);
        const chatMgr = context.ChatManager && context.ChatManager.getInstance ? context.ChatManager.getInstance() : ChatManager.getInstance();
        if (chatMgr) {
          if (isMultiHuman3) {
            chatMgr.renderChatWidget(context);
            chatMgr.setChatVisibility(true, context);
          } else {
            chatMgr.setChatVisibility(false, context);
          }
        }
      } catch (e) {
      }
      if (isOnline2()) {
        const me = mySeat3();
        const count = getPlayerCount2();
        if (count === 2) {
          const other = me === "p1" ? "p2" : "p1";
          if (y) y.textContent = `${seatName3(me)} (${me.toUpperCase()})`;
          if (c) c.textContent = `${seatName3(other)} (${other.toUpperCase()})`;
          if (yt) yt.textContent = "Your hand";
          if (ct) ct.textContent = `${seatName3(other)}\u2019s hand`;
        } else {
          if (y) y.textContent = `${seatName3(me)} (${me.toUpperCase()})`;
          if (yt) yt.textContent = `Your hand (${me.toUpperCase()})`;
        }
        return;
      }
      const pCount = settings3 ? parseInt(settings3.playerCount, 10) || 2 : 2;
      const brand = typeof getAppBrand2 === "function" ? getAppBrand2() : "crazy";
      const GameOptionsEngine2 = typeof window !== "undefined" && window.GameOptionsEngine ? window.GameOptionsEngine : null;
      const allowCpu = GameOptionsEngine2 && typeof GameOptionsEngine2.isCpuAllowed === "function" ? GameOptionsEngine2.isCpuAllowed(brand) : !["pints", "adult"].includes(brand);
      if (isSoloVsPairs2()) {
        if (y) y.textContent = pName2("team1");
        if (c) c.textContent = pName2("team2");
      } else {
        if (y) y.textContent = pName2("p1");
        if (c) c.textContent = !allowCpu && (pName2("p2") === "Computer" || pName2("p2") === "cpu") ? "Player 2" : pName2("p2");
      }
      const is2p = !settings3 || pCount === 2;
      if (yt) yt.textContent = is2p ? isHvH2() || !allowCpu ? "Player 1" : "Your hand" : "Your hand (P1)";
      if (ct) ct.textContent = is2p ? isHvH2() || !allowCpu ? "Player 2" : "Computer" : seatName3("p2");
    }
    /**
     * Shows the discard/play wait overlay with a custom message and disables discard button.
     * @param {string} [msg]
     */
    static showWait(msg) {
      if (typeof document === "undefined") return;
      const el = document.getElementById("waitOverlay");
      const t = document.getElementById("waitMsg");
      if (t && msg) t.textContent = msg;
      if (el) el.classList.add("on");
      const btn = document.getElementById("btnDiscard");
      if (btn) btn.disabled = true;
    }
    /**
     * Hides the discard/play wait overlay and enables discard button.
     */
    static hideWait() {
      if (typeof document === "undefined") return;
      const el = document.getElementById("waitOverlay");
      if (el) el.classList.remove("on");
      const btn = document.getElementById("btnDiscard");
      if (btn) btn.disabled = false;
    }
    initThemeButtons(context) {
      return _UIController.initThemeButtons(context);
    }
    initSoundButton(context) {
      return _UIController.initSoundButton(context);
    }
    updateMobileDeviceClass() {
      return _UIController.updateMobileDeviceClass();
    }
    applySeatLabels(context) {
      return _UIController.applySeatLabels(context);
    }
    showWait(msg) {
      return _UIController.showWait(msg);
    }
    /**
     * Appends an event log message to the on-screen game log.
     * @param {string} msg
     */
    static log(msg) {
      if (typeof document === "undefined" || !msg) return;
      const el = document.getElementById("log");
      if (!el) return;
      const p = document.createElement("p");
      if (_UIController.isBonusMessage(msg)) {
        p.classList.add("log-bonus");
      }
      p.textContent = msg;
      el.prepend(p);
    }
    /**
     * Sequentially announces score combinations with staggered callout banners.
     * @param {Array} pts - List of scored point combinations ({ why, n })
     * @param {Object} [context]
     */
    static announceCombos(pts, context = {}) {
      if (!pts || !pts.length) return;
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : _UIController.fancyCall);
      const fancyPegPhrase2 = context.fancyPegPhrase || (typeof window !== "undefined" ? window.fancyPegPhrase : _UIController.fancyPegPhrase);
      const isBonusMessage2 = context.isBonusMessage || (typeof window !== "undefined" ? window.isBonusMessage : _UIController.isBonusMessage);
      let cumDelay = 0;
      pts.forEach((p) => {
        const isBonus = isBonusMessage2(p.why);
        const ms = isBonus ? 2200 : 1300;
        setTimeout(() => fancyCall2(fancyPegPhrase2(p.why, p.n), "combo", ms), cumDelay);
        cumDelay += isBonus ? 2250 : 1350;
      });
    }
    log(msg) {
      return _UIController.log(msg);
    }
    fancyCall(text2, kind, ms) {
      return _UIController.fancyCall(text2, kind, ms);
    }
    announceCombos(pts, context) {
      return _UIController.announceCombos(pts, context);
    }
  };

  // src/ui/CardAssassinOverlay.js
  var WEAPONS = {
    sword: { carry: 18, coil: -58, strike: 34, recover: 10, reach: 0 },
    mace: { carry: 26, coil: -72, strike: 50, recover: 18, reach: 0 },
    spear: { carry: 8, coil: -42, strike: -8, recover: 6, reach: 0 },
    club: { carry: 28, coil: -78, strike: 54, recover: 20, reach: 0 },
    bat: { carry: 24, coil: -80, strike: 48, recover: 14, reach: 6 },
    axe: { carry: 22, coil: -82, strike: 56, recover: 16, reach: 4 },
    dagger: { carry: 12, coil: -28, strike: 18, recover: 8, reach: 10 },
    bow: { carry: -8, coil: -12, strike: -4, recover: -6, reach: 0 }
  };
  var RANGED = { spear: true, bow: true };
  var WEAPON_KEYS = Object.keys(WEAPONS);
  var START_LEFT = 0.11;
  var WALK_SPEED = 0.16;
  var STAND_LIFT = 34;
  var STRIKE_GAP = 96;
  var THIGH = 26;
  var SHIN = 22;
  var LEG_SPAN = THIGH + SHIN;
  var STEP_LIFT = 14;
  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }
  function lerp(a, b, t) {
    return a + (b - a) * t;
  }
  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }
  function hashNoise(t) {
    const n = Math.sin(t * 12.9898) * 43758.5453;
    return n - Math.floor(n);
  }
  function valueNoise(t) {
    const i = Math.floor(t);
    const f = t - i;
    const u = f * f * (3 - 2 * f);
    return lerp(hashNoise(i), hashNoise(i + 1), u) * 2 - 1;
  }
  function Spring(freq, zeta, pos) {
    this.omega = Math.PI * 2 * freq;
    this.zeta = zeta;
    this.pos = pos || 0;
    this.vel = 0;
  }
  Spring.prototype.tick = function(target, dt) {
    const maxStep = 4e-3;
    let remaining = Math.min(Math.max(dt, 1e-3), 0.05);
    while (remaining > 0) {
      const step = Math.min(remaining, maxStep);
      const w = this.omega;
      const acc = (target - this.pos) * w * w - 2 * this.zeta * w * this.vel;
      this.vel += acc * step;
      this.pos += this.vel * step;
      remaining -= step;
    }
    if (!Number.isFinite(this.pos)) {
      this.pos = target;
      this.vel = 0;
    }
    return this.pos;
  };
  var _pid = 0;
  function VPoint(x, y, mass, group) {
    return { id: ++_pid, x, y, px: x, py: y, mass: mass || 1, pin: false, group: group || "free", radius: 7 };
  }
  function aabbOf(p) {
    const r = p.radius;
    return { x0: p.x - r, y0: p.y - r, x1: p.x + r, y1: p.y + r };
  }
  function aabbUnion(a, b) {
    return {
      x0: Math.min(a.x0, b.x0),
      y0: Math.min(a.y0, b.y0),
      x1: Math.max(a.x1, b.x1),
      y1: Math.max(a.y1, b.y1)
    };
  }
  function aabbHits(a, b) {
    return a.x0 <= b.x1 && a.x1 >= b.x0 && a.y0 <= b.y1 && a.y1 >= b.y0;
  }
  function aabbArea(a) {
    return Math.max(0, a.x1 - a.x0) * Math.max(0, a.y1 - a.y0);
  }
  function aabbSurface(a) {
    return 2 * (Math.max(0, a.x1 - a.x0) + Math.max(0, a.y1 - a.y0));
  }
  function BVH() {
    this.root = null;
    this.leaves = [];
  }
  BVH.prototype.build = function(points) {
    const leaves = points.map((p) => ({ leaf: true, aabb: aabbOf(p), ref: p, left: null, right: null }));
    this.leaves = leaves;
    this.root = leaves.length ? this._split(leaves) : null;
    return this.root;
  };
  BVH.prototype._split = function(nodes) {
    if (nodes.length === 1) return nodes[0];
    if (nodes.length === 2) {
      return {
        leaf: false,
        aabb: aabbUnion(nodes[0].aabb, nodes[1].aabb),
        left: nodes[0],
        right: nodes[1]
      };
    }
    let best = null;
    for (const axis of ["x", "y"]) {
      const sorted = nodes.slice().sort((a, b) => {
        const ca = axis === "x" ? a.aabb.x0 + a.aabb.x1 : a.aabb.y0 + a.aabb.y1;
        const cb = axis === "x" ? b.aabb.x0 + b.aabb.x1 : b.aabb.y0 + b.aabb.y1;
        return ca - cb;
      });
      let leftBox = sorted[0].aabb;
      const prefix = [leftBox];
      for (let i = 1; i < sorted.length - 1; i++) {
        leftBox = aabbUnion(leftBox, sorted[i].aabb);
        prefix[i] = leftBox;
      }
      let rightBox = sorted[sorted.length - 1].aabb;
      for (let i = sorted.length - 1; i >= 1; i--) {
        if (i < sorted.length - 1) rightBox = aabbUnion(rightBox, sorted[i].aabb);
        const leftCount = i;
        const rightCount = sorted.length - i;
        const cost = aabbSurface(prefix[i - 1]) * leftCount + aabbSurface(rightBox) * rightCount;
        if (!best || cost < best.cost) {
          best = { cost, axis, index: i, sorted };
        }
      }
    }
    const mid = best ? best.index : nodes.length >> 1;
    const ordered = best ? best.sorted : nodes;
    const left = this._split(ordered.slice(0, mid));
    const right = this._split(ordered.slice(mid));
    return { leaf: false, aabb: aabbUnion(left.aabb, right.aabb), left, right };
  };
  BVH.prototype.refit = function() {
    if (!this.root) return;
    (function walk(node) {
      if (node.leaf) {
        node.aabb = aabbOf(node.ref);
        return node.aabb;
      }
      const l = walk(node.left);
      const r = walk(node.right);
      node.aabb = aabbUnion(l, r);
      return node.aabb;
    })(this.root);
  };
  BVH.collide = function(a, b, fn) {
    function walk(n0, n1) {
      if (!n0 || !n1 || !aabbHits(n0.aabb, n1.aabb)) return;
      if (n0.leaf && n1.leaf) {
        fn(n0.ref, n1.ref);
        return;
      }
      if (n0.leaf) {
        walk(n0, n1.left);
        walk(n0, n1.right);
        return;
      }
      if (n1.leaf) {
        walk(n0.left, n1);
        walk(n0, n1.right);
        return;
      }
      if (aabbArea(n0.aabb) > aabbArea(n1.aabb)) {
        walk(n0.left, n1);
        walk(n0.right, n1);
      } else {
        walk(n0, n1.left);
        walk(n0, n1.right);
      }
    }
    if (a && b) walk(a.root, b.root);
  };
  BVH.prototype.boxes = function() {
    const list = [];
    (function walk(node, depth) {
      if (!node) return;
      list.push({ aabb: node.aabb, leaf: node.leaf, depth });
      if (!node.leaf) {
        walk(node.left, depth + 1);
        walk(node.right, depth + 1);
      }
    })(this.root, 0);
    return list;
  };
  function collideParticles(a, b) {
    if (a.group === b.group) return;
    const minDist = a.radius + b.radius;
    const dx2 = b.x - a.x;
    const dy2 = b.y - a.y;
    const d2 = dx2 * dx2 + dy2 * dy2;
    if (d2 >= minDist * minDist || d2 === 0) return;
    const d = Math.sqrt(d2);
    const nx = dx2 / d;
    const ny = dy2 / d;
    const overlap = minDist - d;
    const invA = a.pin ? 0 : 1 / a.mass;
    const invB = b.pin ? 0 : 1 / b.mass;
    const inv = invA + invB;
    if (inv <= 0) return;
    const corr = overlap / inv;
    a.x -= nx * corr * invA;
    a.y -= ny * corr * invA;
    b.x += nx * corr * invB;
    b.y += ny * corr * invB;
  }
  function VRod(a, b, rest, stiff) {
    return { a, b, rest: rest == null ? Math.hypot(b.x - a.x, b.y - a.y) : rest, stiff: stiff == null ? 1 : stiff };
  }
  function verletStep(p, dt, gx, gy, damp) {
    if (p.pin) {
      p.px = p.x;
      p.py = p.y;
      return;
    }
    const vx = (p.x - p.px) * damp;
    const vy = (p.y - p.py) * damp;
    p.px = p.x;
    p.py = p.y;
    p.x += vx + gx * dt * dt;
    p.y += vy + gy * dt * dt;
  }
  function verletImpulse(p, ix, iy) {
    p.px -= ix;
    p.py -= iy;
  }
  function solveRod(c) {
    const dx2 = c.b.x - c.a.x;
    const dy2 = c.b.y - c.a.y;
    const dist2 = Math.hypot(dx2, dy2) || 1e-4;
    const frac = (c.rest - dist2) / dist2;
    const invA = c.a.pin ? 0 : 1 / c.a.mass;
    const invB = c.b.pin ? 0 : 1 / c.b.mass;
    const inv = invA + invB;
    if (inv <= 0) return;
    const k = frac * c.stiff / inv;
    const ox = dx2 * k;
    const oy = dy2 * k;
    c.a.x -= ox * invA;
    c.a.y -= oy * invA;
    c.b.x += ox * invB;
    c.b.y += oy * invB;
  }
  function collideFloor(p, floorY, bounce) {
    if (p.y > floorY) {
      const vy = p.y - p.py;
      p.y = floorY;
      p.py = p.y + vy * bounce;
      p.x += (p.px - p.x) * 0.18;
    }
  }
  function collideWalls(p, x0, x1) {
    if (p.x < x0) {
      p.px = p.x + (p.x - p.px) * 0.4;
      p.x = x0;
    }
    if (p.x > x1) {
      p.px = p.x + (p.x - p.px) * 0.4;
      p.x = x1;
    }
  }
  function solveLeg(targetX, targetY, kneeDir, legThigh = THIGH, legShin = SHIN) {
    let dx2 = targetX;
    let dy2 = targetY;
    let dist2 = Math.hypot(dx2, dy2) || 1e-4;
    const legSpan = legThigh + legShin;
    const minD = Math.abs(legThigh - legShin) + 0.5;
    const maxD = legSpan - 0.4;
    const reach = clamp(dist2, minD, maxD);
    dx2 *= reach / dist2;
    dy2 *= reach / dist2;
    dist2 = reach;
    const base = Math.atan2(dx2, dy2);
    const cosHip = clamp((legThigh * legThigh + dist2 * dist2 - legShin * legShin) / (2 * legThigh * dist2), -1, 1);
    const hipBend = Math.acos(cosHip);
    const thighRad = base - kneeDir * hipBend;
    const kneeX = Math.sin(thighRad) * legThigh;
    const kneeY = Math.cos(thighRad) * legThigh;
    const shinWorld = Math.atan2(targetX - kneeX, targetY - kneeY);
    const shinLocal = shinWorld - thighRad;
    const footLocal = -shinWorld + 0.16;
    return {
      thigh: thighRad * 180 / Math.PI,
      shin: shinLocal * 180 / Math.PI,
      foot: footLocal * 180 / Math.PI
    };
  }
  var activeOverlayInstance = null;
  var CardAssassinOverlay = class _CardAssassinOverlay {
    /**
     * Displays the Card Assassin animation in a transparent overlay.
     * Randomly selects one of the weapons in the arsenal.
     *
     * @param {Object} [options]
     * @param {string} [options.passerName] - Name of player who passed
     * @param {string} [options.passedName] - Name of player passed
     * @param {Object} [options.passerCard] - { r: 'A', s: 'S' }
     * @param {Object} [options.passedCard] - { r: 'K', s: 'H' }
     * @param {string} [options.weapon] - Optional specific weapon key
     * @param {Function} [options.onComplete] - Callback on dismiss or completion
     * @returns {CardAssassinOverlay|null}
     */
    static show(options = {}) {
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3 && (settings3.cardAssassin === "no" || settings3.cardAssassin === "off" || settings3.cardAssassin === false)) {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (typeof document === "undefined") {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (activeOverlayInstance) {
        activeOverlayInstance.close(false);
      }
      const instance = new _CardAssassinOverlay(options);
      activeOverlayInstance = instance;
      instance.mount();
      return instance;
    }
    static hide() {
      if (activeOverlayInstance) {
        activeOverlayInstance.close(true);
      }
    }
    constructor(options = {}) {
      this.options = options;
      this.onComplete = options.onComplete || (() => {
      });
      this.raf = 0;
      this.running = false;
      this.currentWeapon = options.weapon && WEAPONS[options.weapon] ? options.weapon : this.pickRandomWeapon();
      this.overlayEl = null;
      this.autoCloseTimer = null;
      this.safetyTimer = null;
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    pickRandomWeapon() {
      return WEAPON_KEYS[Math.floor(Math.random() * WEAPON_KEYS.length)];
    }
    formatCard(card, fallbackRank, fallbackSuit) {
      if (!card) {
        return { r: fallbackRank, s: fallbackSuit, isRed: fallbackSuit === "\u2665" || fallbackSuit === "\u2666" };
      }
      if (Array.isArray(card) && card.length > 0) {
        card = card[card.length - 1];
      }
      if (typeof card === "string") {
        const match = card.match(/^([0-9AJQK]+)([HDSC♥♦♠♣]?)$/i);
        if (match) {
          card = { r: match[1], s: match[2] };
        }
      }
      let r = card.r !== void 0 ? card.r : card.rank !== void 0 ? card.rank : fallbackRank;
      if (r === 1 || r === "1") r = "A";
      else if (r === 11 || r === "11") r = "J";
      else if (r === 12 || r === "12") r = "Q";
      else if (r === 13 || r === "13") r = "K";
      r = String(r).toUpperCase();
      let s = card.s || card.suit || fallbackSuit;
      if (s === "H" || s === "h") s = "\u2665";
      else if (s === "D" || s === "d") s = "\u2666";
      else if (s === "S" || s === "s") s = "\u2660";
      else if (s === "C" || s === "c") s = "\u2663";
      const isRed = s === "\u2665" || s === "\u2666";
      return { r, s, isRed };
    }
    buildHtml() {
      const passer = this.options.passerName || "Player";
      const passed = this.options.passedName || "Opponent";
      const killerCard = this.formatCard(this.options.passerCard, "A", "\u2660");
      const victimCard = this.formatCard(this.options.passedCard, "K", "\u2665");
      return `
      <div class="assassin-banner">
        <span class="assassin-badge">\u2694\uFE0F OVERTAKE!</span>
        <h2 class="assassin-title">${passer} passes ${passed}!</h2>
      </div>

      <div class="stage" id="assassinStage">
        <div class="card" id="killer" style="color: ${killerCard.isRed ? "var(--red)" : "var(--ink)"};">
          <div class="face">
            <div class="corner"><span class="r">${killerCard.r}</span><span class="s">${killerCard.s}</span></div>
            <div class="pip">${killerCard.s}</div>
            <div class="corner br"><span class="r">${killerCard.r}</span><span class="s">${killerCard.s}</span></div>
          </div>
          <div class="weapon" id="w-sword" data-kind="sword">
            <div class="sword-pommel"></div>
            <div class="sword-grip"></div>
            <div class="sword-guard"></div>
            <div class="sword-blade"></div>
          </div>
          <div class="weapon" id="w-mace" data-kind="mace">
            <div class="sword-grip"></div>
            <div class="mace-haft"></div>
            <div class="mace-head"></div>
          </div>
          <div class="weapon" id="w-spear" data-kind="spear">
            <div class="spear-haft"></div>
            <div class="spear-head"></div>
          </div>
          <div class="weapon" id="w-club" data-kind="club">
            <div class="sword-grip"></div>
            <div class="club-body"></div>
          </div>
          <div class="weapon" id="w-bat" data-kind="bat">
            <div class="bat-knob"></div>
            <div class="bat-handle"></div>
            <div class="bat-barrel"></div>
          </div>
          <div class="weapon" id="w-axe" data-kind="axe">
            <div class="sword-grip"></div>
            <div class="axe-haft"></div>
            <div class="axe-bit"></div>
          </div>
          <div class="weapon" id="w-dagger" data-kind="dagger">
            <div class="sword-pommel"></div>
            <div class="sword-grip"></div>
            <div class="dagger-guard"></div>
            <div class="dagger-blade"></div>
          </div>
          <div class="weapon" id="w-bow" data-kind="bow">
            <div class="bow-limb"></div>
            <div class="bow-string"></div>
          </div>
          <div class="legs">
            <div class="leg l" id="legL">
              <div class="thigh" id="thighL">
                <div class="shin" id="shinL">
                  <div class="foot" id="footL"></div>
                </div>
              </div>
            </div>
            <div class="leg r" id="legR">
              <div class="thigh" id="thighR">
                <div class="shin" id="shinR">
                  <div class="foot" id="footR"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" id="victim" style="color: ${victimCard.isRed ? "var(--red)" : "var(--ink)"};">
          <div class="face">
            <div class="corner"><span class="r">${victimCard.r}</span><span class="s">${victimCard.s}</span></div>
            <div class="pip">${victimCard.s}</div>
            <div class="corner br"><span class="r">${victimCard.r}</span><span class="s">${victimCard.s}</span></div>
            <div class="wound"></div>
            <div class="x-eyes">\u2715 \u2715</div>
          </div>
        </div>

        <svg id="bvhLayer" class="hidden" aria-hidden="true"></svg>
        <div class="splash a"></div>
        <div class="splash b"></div>
        <div class="splash c"></div>
        <div id="spear-flight">
          <div class="spear-haft"></div>
          <div class="spear-head"></div>
        </div>
        <div id="arrow-flight">
          <div class="arrow-shaft"></div>
          <div class="arrow-head"></div>
        </div>
      </div>
    `;
    }
    mount() {
      let el = document.getElementById("cardAssassinOverlay");
      if (!el) {
        el = document.createElement("div");
        el.id = "cardAssassinOverlay";
        el.className = "card-assassin-overlay";
        document.body.appendChild(el);
      }
      el.innerHTML = this.buildHtml();
      this.overlayEl = el;
      this.stage = el.querySelector("#assassinStage");
      this.killer = el.querySelector("#killer");
      this.victim = el.querySelector("#victim");
      this.spearFlight = el.querySelector("#spear-flight");
      this.arrowFlight = el.querySelector("#arrow-flight");
      this.bvhLayer = el.querySelector("#bvhLayer");
      this.bones = {
        L: {
          thigh: el.querySelector("#thighL"),
          shin: el.querySelector("#shinL"),
          foot: el.querySelector("#footL")
        },
        R: {
          thigh: el.querySelector("#thighR"),
          shin: el.querySelector("#shinR"),
          foot: el.querySelector("#footR")
        }
      };
      el.addEventListener("click", () => {
        this.close(true);
      });
      window.addEventListener("keydown", this.handleKeyDown);
      this.setWeapon(this.currentWeapon);
      requestAnimationFrame(() => {
        el.classList.add("active");
        this.play();
      });
    }
    handleKeyDown(e) {
      if (e.key === "Escape") {
        this.close(true);
      }
    }
    setWeapon(kind) {
      this.currentWeapon = WEAPONS[kind] ? kind : "sword";
      if (!this.overlayEl) return;
      this.overlayEl.querySelectorAll(".weapon").forEach((el) => {
        el.classList.toggle("active", el.dataset.kind === this.currentWeapon);
        el.classList.remove("firing");
      });
      this.overlayEl.querySelectorAll("#assassinArsenal [data-weapon]").forEach((btn) => {
        btn.classList.toggle("on", btn.dataset.weapon === this.currentWeapon);
      });
    }
    setSword(angle, scale, reach) {
      const s = scale == null ? 1 : scale;
      const x = reach || 0;
      if (!this.overlayEl) return;
      this.overlayEl.querySelectorAll(".weapon.active").forEach((el) => {
        el.style.transform = `translateX(${x}px) rotate(${angle}deg) scale(${s})`;
      });
    }
    applyLeg(side, pose) {
      const b = this.bones[side];
      if (!b || !b.thigh) return;
      b.thigh.style.transform = `rotate(${pose.thigh}deg)`;
      b.shin.style.transform = `rotate(${pose.shin}deg)`;
      b.foot.style.transform = `rotate(${pose.foot}deg)`;
    }
    poseLegsFromTargets(left, right, legThigh = THIGH, legShin = SHIN) {
      this.applyLeg("L", solveLeg(left.x, left.y, -1, legThigh, legShin));
      this.applyLeg("R", solveLeg(right.x, right.y, -1, legThigh, legShin));
    }
    poseKiller({ x, lift, rotX, rotZ, scaleX, scaleY, bright }) {
      if (!this.killer) return;
      this.killer.style.left = "0px";
      this.killer.style.filter = `brightness(${bright ?? 1})`;
      this.killer.style.transform = `translateX(${x}px) translateY(${-(lift ?? 0)}px) rotateX(${rotX ?? 0}deg) rotateZ(${rotZ ?? 0}deg) scaleX(${scaleX ?? 1}) scaleY(${scaleY ?? 1})`;
    }
    poseVictim({ rotX, rotZ, x, y, scaleY, bright }) {
      if (!this.victim) return;
      this.victim.style.filter = `brightness(${bright ?? 0.92})`;
      this.victim.style.transform = `translateX(${x ?? 0}px) translateY(${y ?? 0}px) rotateX(${rotX ?? 76}deg) rotateZ(${rotZ ?? 0}deg) scaleY(${scaleY ?? 0.42})`;
    }
    resetScene() {
      cancelAnimationFrame(this.raf);
      this.running = false;
      if (!this.killer || !this.victim || !this.stage) return;
      const isMobile = (this.stage.clientWidth || 800) < 600;
      const scale = isMobile ? 0.5 : 1;
      this.killer.className = "card";
      this.victim.className = "card";
      this.stage.classList.remove("bloodied");
      this.poseLegsFromTargets({ x: -4 * scale, y: 8 * scale }, { x: 4 * scale, y: 8 * scale }, THIGH * scale, SHIN * scale);
      this.setSword(-12, 0.85, 0);
      this.overlayEl.querySelectorAll(".weapon").forEach((el) => el.classList.remove("firing"));
      const heldSpear = this.overlayEl.querySelector("#w-spear");
      if (heldSpear) heldSpear.style.opacity = "";
      if (this.spearFlight) {
        this.spearFlight.classList.remove("airborne");
        this.spearFlight.style.transform = "";
      }
      if (this.arrowFlight) {
        this.arrowFlight.classList.remove("airborne");
        this.arrowFlight.style.transform = "";
      }
      const w = this.stage.clientWidth || 800;
      this.poseKiller({
        x: w * START_LEFT,
        lift: 0,
        rotX: 76,
        rotZ: 0,
        scaleX: 1,
        scaleY: 0.42,
        bright: 0.92
      });
      this.poseVictim({ rotX: 76, rotZ: 0, x: 0, y: 0, scaleY: 0.42, bright: 0.92 });
    }
    play() {
      this.resetScene();
      this.running = true;
      if (this.safetyTimer) {
        clearTimeout(this.safetyTimer);
      }
      this.safetyTimer = setTimeout(() => {
        this.close(true);
      }, 1e4);
      const self2 = this;
      const stage = this.stage;
      const killer = this.killer;
      const victim = this.victim;
      const spearFlight = this.spearFlight;
      const arrowFlight = this.arrowFlight;
      const currentWeapon = this.currentWeapon;
      const width = stage.clientWidth || 800;
      const isMobile = width < 600;
      const scale = isMobile ? 0.5 : 1;
      const homeX = width * START_LEFT;
      const victimX = width * 0.69;
      const CARD_W = 86 * scale;
      const CARD_H = 122 * scale;
      const THIGH_LEN = THIGH * scale;
      const SHIN_LEN = SHIN * scale;
      const STAND_LIFT_VAL = STAND_LIFT * scale;
      const STRIKE_GAP_VAL = (currentWeapon === "dagger" ? 58 : STRIKE_GAP) * scale;
      const CARD_BOTTOM = 92 * scale;
      const FLOOR_PAD = 26 * scale;
      const arriveX = RANGED[currentWeapon] ? homeX + (victimX - homeX) * 0.5 : victimX - STRIKE_GAP_VAL;
      let thrown = null;
      const cruise = WALK_SPEED * width;
      const body = {
        x: homeX,
        vx: 0,
        lift: 0,
        rotX: 76,
        rotZ: 0,
        scaleX: 1,
        scaleY: 0.42
      };
      const springLift = new Spring(3.2, 0.78, 0);
      const springRotZ = new Spring(4.4, 0.62, 0);
      const springRotX = new Spring(3.6, 0.7, 76);
      const springSquash = new Spring(8.5, 0.55, 0);
      const springBladeW = new Spring(7.5, 0.72, 0);
      const springBladeA = new Spring(6.5, 0.7, 0);
      const feet = {
        L: { worldX: homeX - 8 * scale, locked: true, lastLocalX: -6 * scale },
        R: { worldX: homeX + 8 * scale, locked: true, lastLocalX: 6 * scale }
      };
      const king = {
        live: true,
        ragdoll: null,
        lethal: false
      };
      let limp = null;
      const FLOOR_Y = () => stage.clientHeight - FLOOR_PAD;
      const kingBVH = new BVH();
      const legBVH = new BVH();
      const bvhLayer = this.bvhLayer;
      function drawBVH() {
        if (!bvhLayer || bvhLayer.classList.contains("hidden")) return;
        const w = stage.clientWidth;
        const h = stage.clientHeight;
        bvhLayer.setAttribute("viewBox", `0 0 ${w} ${h}`);
        const boxes = kingBVH.boxes().map((b) => ({ ...b, tint: "#d9d2c0" })).concat(legBVH.boxes().map((b) => ({ ...b, tint: "#b4232a" })));
        bvhLayer.innerHTML = boxes.map((b) => {
          const { x0, y0, x1, y1 } = b.aabb;
          const op = b.leaf ? 0.55 : Math.max(0.12, 0.4 - b.depth * 0.08);
          const sw = b.leaf ? 1.2 : 0.8;
          return `<rect x="${x0.toFixed(1)}" y="${y0.toFixed(1)}" width="${Math.max(0, x1 - x0).toFixed(1)}" height="${Math.max(0, y1 - y0).toFixed(1)}" fill="none" stroke="${b.tint}" stroke-opacity="${op}" stroke-width="${sw}"/>`;
        }).join("");
      }
      function resolveBroadphase(kingPts, legPts) {
        if (!kingBVH.root || kingBVH.leaves.length !== kingPts.length) kingBVH.build(kingPts);
        else kingBVH.refit();
        if (!legBVH.root || legBVH.leaves.length !== legPts.length) legBVH.build(legPts);
        else legBVH.refit();
        BVH.collide(kingBVH, legBVH, collideParticles);
        drawBVH();
      }
      function spawnKingRagdoll() {
        const left = stage.clientWidth * 0.69;
        const floor = FLOOR_Y();
        const bl = VPoint(left, floor, 1, "king");
        const br = VPoint(left + CARD_W, floor, 1, "king");
        const tl = VPoint(left, floor - CARD_H, 1, "king");
        const tr = VPoint(left + CARD_W, floor - CARD_H, 1, "king");
        const mid = VPoint(left + CARD_W / 2, floor - CARD_H / 2, 1.4, "king");
        [bl, br, tl, tr, mid].forEach((p) => {
          p.radius = 10 * scale;
        });
        verletImpulse(tl, 18 * scale, -14 * scale);
        verletImpulse(bl, 28 * scale, -4 * scale);
        verletImpulse(mid, 16 * scale, -16 * scale);
        verletImpulse(tr, 8 * scale, -10 * scale);
        victim.classList.add("ragdolled");
        return {
          pts: [tl, tr, br, bl, mid],
          rods: [
            VRod(tl, tr, null, 1),
            VRod(tr, br, null, 1),
            VRod(br, bl, null, 1),
            VRod(bl, tl, null, 1),
            VRod(tl, br, null, 0.45),
            VRod(tr, bl, null, 0.45),
            VRod(mid, tl, null, 0.75),
            VRod(mid, tr, null, 0.75),
            VRod(mid, br, null, 0.75),
            VRod(mid, bl, null, 0.75)
          ]
        };
      }
      function stepKingRagdoll(dt) {
        const g = 2200;
        king.ragdoll.pts.forEach((p) => verletStep(p, dt, 0, g, 0.988));
        for (let i = 0; i < 8; i++) king.ragdoll.rods.forEach(solveRod);
        const floor = FLOOR_Y();
        const x0 = 18;
        const x1 = stage.clientWidth - 18;
        king.ragdoll.pts.forEach((p) => {
          collideFloor(p, floor, -0.28);
          collideWalls(p, x0, x1);
        });
        const [tl, tr, br, bl] = king.ragdoll.pts;
        const cx = (tl.x + tr.x + br.x + bl.x) / 4;
        const cy = (tl.y + tr.y + br.y + bl.y) / 4;
        const ang = Math.atan2(
          (tr.y + br.y) * 0.5 - (tl.y + bl.y) * 0.5,
          (tr.x + br.x) * 0.5 - (tl.x + bl.x) * 0.5
        );
        victim.style.filter = "brightness(0.74)";
        victim.style.transform = `translate(${cx - CARD_W / 2}px, ${cy - CARD_H / 2}px) rotate(${ang * 180 / Math.PI}deg)`;
      }
      function seedLimpLegs(hipLift) {
        const hipY = stage.clientHeight - CARD_BOTTOM - hipLift;
        const cx = body.x + CARD_W / 2;
        function chain(sx, kickX) {
          const hip = VPoint(cx + sx * scale, hipY, 1, "leg");
          hip.pin = true;
          const knee = VPoint(cx + (sx + 3) * scale, hipY + THIGH_LEN, 1, "leg");
          const foot = VPoint(cx + (sx + 5) * scale, hipY + THIGH_LEN + SHIN_LEN, 1, "leg");
          verletImpulse(foot, kickX * scale, 4 * scale);
          verletImpulse(knee, kickX * 0.4 * scale, 2 * scale);
          return {
            hip,
            knee,
            foot,
            rods: [VRod(hip, knee, THIGH_LEN, 1), VRod(knee, foot, SHIN_LEN, 1)]
          };
        }
        return { L: chain(-16, -6), R: chain(16, 9) };
      }
      function stepLimpLegs(hipLift, dt) {
        const hipY = stage.clientHeight - CARD_BOTTOM - hipLift;
        const cx = body.x + CARD_W / 2;
        limp.L.hip.x = cx - 16 * scale;
        limp.L.hip.y = hipY;
        limp.R.hip.x = cx + 16 * scale;
        limp.R.hip.y = hipY;
        const pts = [limp.L.hip, limp.L.knee, limp.L.foot, limp.R.hip, limp.R.knee, limp.R.foot];
        const rods = limp.L.rods.concat(limp.R.rods);
        pts.forEach((p) => verletStep(p, dt, 0, 1900, 0.984));
        for (let i = 0; i < 5; i++) rods.forEach(solveRod);
        const floor = FLOOR_Y();
        [limp.L.knee, limp.L.foot, limp.R.knee, limp.R.foot].forEach((p) => collideFloor(p, floor, -0.2));
        function angles(leg) {
          const thigh = Math.atan2(leg.knee.x - leg.hip.x, leg.knee.y - leg.hip.y);
          const shin = Math.atan2(leg.foot.x - leg.knee.x, leg.foot.y - leg.knee.y);
          return {
            thigh: thigh * 180 / Math.PI,
            shin: (shin - thigh) * 180 / Math.PI,
            foot: -shin * 180 / Math.PI
          };
        }
        self2.applyLeg("L", angles(limp.L));
        self2.applyLeg("R", angles(limp.R));
      }
      function resolveHit() {
        king.live = false;
        king.lethal = true;
        king.ragdoll = spawnKingRagdoll();
        limp = seedLimpLegs(body.lift || STAND_LIFT);
        victim.classList.add("hit");
        stage.classList.add("bloodied");
      }
      let phase = 0;
      let state3 = "idle";
      let stateT = 0;
      let lastLift = 0;
      let doneHold = 0;
      let last = performance.now();
      function gaitFeet(hipX, hipLift, speed, dt) {
        const stepHz = clamp(0.7 + Math.abs(speed) / 90, 1.15, 2.6);
        phase += dt * stepHz;
        const travel = Math.abs(speed) * (0.5 / stepHz);
        const half = clamp(travel * 0.5, 10 * scale, 26 * scale);
        function one(side, offset) {
          const foot = feet[side];
          const cycle = ((phase + (side === "R" ? 0.5 : 0)) % 1 + 1) % 1;
          const stance = cycle < 0.55;
          if (stance) {
            if (!foot.locked) {
              foot.locked = true;
              foot.worldX = hipX + half * Math.sign(speed || 1) + offset;
            }
            return {
              x: foot.worldX - hipX,
              y: hipLift
            };
          }
          foot.locked = false;
          const u = (cycle - 0.55) / 0.45;
          const swing = u * u * (3 - 2 * u);
          const takeoff = foot.worldX - hipX;
          const landing = half * Math.sign(speed || 1) + offset;
          return {
            x: lerp(takeoff, landing, swing),
            y: hipLift - Math.sin(u * Math.PI) * (STEP_LIFT * scale + Math.abs(speed) * 0.04)
          };
        }
        return {
          L: one("L", -5 * scale),
          R: one("R", 5 * scale),
          stepHz
        };
      }
      function frame(now) {
        if (!self2.running) return;
        const dt = Math.min(0.04, (now - last) / 1e3) || 0.016;
        last = now;
        stateT += dt;
        let wantLift = 0;
        let wantRotZ = 0;
        let wantRotX = 76;
        const kit = WEAPONS[currentWeapon];
        let wantBladeA = kit.carry;
        let wantBladeS = 0.9;
        let wantReach = 0;
        let wantSquash = 0;
        let wantVx = 0;
        let bright = 0.92;
        let mode = "lie";
        if (state3 === "idle") {
          const n = valueNoise(stateT * 3.1) * 1.8 + valueNoise(stateT * 7.4) * 0.7;
          body.x = homeX + n * 0.6;
          wantRotX = 76 + valueNoise(stateT * 2.2 + 8) * 2;
          wantSquash = 0.02 + valueNoise(stateT * 4.5) * 0.015;
          if (stateT > 0.85) {
            state3 = "rise";
            stateT = 0;
          }
        } else if (state3 === "rise") {
          const p = clamp(stateT / 1.15, 0, 1);
          wantLift = easeOut(p) * STAND_LIFT_VAL;
          wantRotX = lerp(76, 0, easeOut(p));
          wantRotZ = valueNoise(stateT * 5) * 1.2;
          wantSquash = Math.sin(p * Math.PI) * -0.08;
          bright = lerp(0.92, 1, p);
          mode = p > 0.45 ? "stand" : "lie";
          wantBladeA = lerp(-12, kit.carry, p);
          wantBladeS = lerp(0.7, 1, p);
          if (p > 0.45) killer.classList.add("standing");
          if (p >= 1) {
            state3 = "walk";
            stateT = 0;
            body.lift = STAND_LIFT_VAL;
            feet.L.worldX = body.x - 10 * scale;
            feet.R.worldX = body.x + 12 * scale;
            feet.L.locked = true;
            feet.R.locked = true;
          }
        } else if (state3 === "walk") {
          killer.classList.add("walking");
          const dist2 = arriveX - body.x;
          const slow = clamp(dist2 / 140, 0.22, 1);
          wantVx = cruise * slow;
          wantLift = STAND_LIFT_VAL;
          wantRotX = 0;
          wantRotZ = 0;
          bright = 1;
          mode = "walk";
          wantBladeA = kit.carry + Math.sin(phase * Math.PI * 2) * 6;
          wantBladeS = 1;
          if (dist2 < 8) {
            state3 = "coil";
            stateT = 0;
            body.vx *= 0.2;
          }
        } else if (state3 === "coil") {
          killer.classList.remove("walking");
          killer.classList.add("attacking");
          const isThrow = !!RANGED[currentWeapon];
          wantVx = isThrow ? -18 * scale : -42 * scale;
          wantLift = STAND_LIFT_VAL + (isThrow ? 8 * scale : 14 * scale);
          wantRotX = isThrow ? -6 : -10;
          wantRotZ = isThrow ? -8 : -11;
          wantBladeA = kit.coil;
          wantBladeS = 1.05;
          wantReach = kit.reach * 0.15;
          wantSquash = 0.1;
          bright = 1;
          mode = "coil";
          if (stateT > (isThrow ? 0.28 : 0.34)) {
            state3 = "strike";
            stateT = 0;
            body.vx = isThrow ? 20 : 340;
            if (isThrow && !thrown) {
              const missile = currentWeapon === "bow" ? arrowFlight : spearFlight;
              const held = self2.overlayEl.querySelector(currentWeapon === "bow" ? "#w-bow" : "#w-spear");
              if (held && currentWeapon === "spear") held.style.opacity = "0";
              thrown = {
                el: missile,
                x0: body.x + (currentWeapon === "bow" ? 62 : 70),
                y0: stage.clientHeight - 92 - STAND_LIFT - 52,
                x1: victimX + 20,
                y1: stage.clientHeight - 92 - 36,
                t: 0,
                dur: currentWeapon === "bow" ? 0.32 : 0.42
              };
              if (missile) missile.classList.add("airborne");
            }
          }
        } else if (state3 === "strike") {
          const isThrow = !!RANGED[currentWeapon];
          wantVx = isThrow ? 0 : 40;
          wantLift = STAND_LIFT - (isThrow ? 2 : 10);
          wantRotX = isThrow ? 4 : 8;
          wantRotZ = isThrow ? 6 : 13;
          wantBladeA = kit.strike;
          wantBladeS = isThrow ? 0 : 1.08;
          wantReach = kit.reach;
          wantSquash = isThrow ? 0.04 : -0.12;
          bright = 1;
          mode = "strike";
          if (thrown) {
            thrown.t += dt;
            const u = clamp(thrown.t / thrown.dur, 0, 1);
            const ease = 1 - Math.pow(1 - u, 2);
            const x = lerp(thrown.x0, thrown.x1, ease);
            const arc = Math.sin(u * Math.PI) * 36;
            const y = lerp(thrown.y0, thrown.y1, ease) - arc;
            const ang = Math.atan2(thrown.y1 - thrown.y0, thrown.x1 - thrown.x0) * 180 / Math.PI;
            if (thrown.el) {
              thrown.el.style.left = `${x}px`;
              thrown.el.style.top = `${y}px`;
              thrown.el.style.transform = `rotate(${ang}deg)`;
            }
            if (u >= 0.78 && king.live) {
              resolveHit();
            }
            if (u >= 1) {
              state3 = "recover";
              stateT = 0;
            }
          } else {
            if (king.live && stateT > 0.08) {
              resolveHit();
            }
            if (stateT > 0.28) {
              state3 = "recover";
              stateT = 0;
            }
          }
        } else if (state3 === "recover") {
          wantVx = 0;
          wantLift = STAND_LIFT;
          wantRotX = 0;
          wantRotZ = -6;
          wantBladeA = kit.recover;
          wantBladeS = 1;
          wantReach = 0;
          bright = 1;
          mode = "stand";
          killer.classList.add("victory");
          if (stateT > 0.2 && king.lethal) victim.classList.add("dead");
          doneHold += dt;
          if (doneHold > 1.6) {
            self2.running = false;
            self2.autoCloseTimer = setTimeout(() => {
              self2.close(true);
            }, 2e3);
            return;
          }
        }
        if (state3 === "walk" || state3 === "coil" || state3 === "strike" || state3 === "recover") {
          body.vx = lerp(body.vx, wantVx, 1 - Math.exp(-dt * 8));
          body.x += body.vx * dt;
        }
        springLift.tick(wantLift, dt);
        springRotZ.tick(wantRotZ, dt);
        springRotX.tick(wantRotX, dt);
        springSquash.tick(wantSquash, dt);
        springBladeW.tick(wantBladeS, dt);
        springBladeA.tick(wantBladeA, dt);
        let hip = springLift.pos;
        let rotZ = springRotZ.pos;
        let targets = { L: { x: -4 * scale, y: Math.max(8 * scale, hip) }, R: { x: 4 * scale, y: Math.max(8 * scale, hip) } };
        if (mode === "walk") {
          const bob = Math.abs(Math.sin(phase * Math.PI * 2)) * 4.2 * scale + Math.sin(phase * Math.PI * 4) * 0.8 * scale;
          hip = springLift.pos - 3 * scale + bob;
          rotZ += Math.sin(phase * Math.PI * 2) * 4.6;
          rotZ += Math.sin(phase * Math.PI * 4) * 1.1;
          targets = gaitFeet(body.x, hip, body.vx, dt);
        } else if (mode === "coil") {
          targets = { L: { x: -6 * scale, y: hip - 9 * scale }, R: { x: 8 * scale, y: hip - 8 * scale } };
        } else if (mode === "strike") {
          targets = { L: { x: 8 * scale, y: hip - 3 * scale }, R: { x: 16 * scale, y: hip - 2 * scale } };
        } else if (mode === "stand") {
          targets = { L: { x: -5 * scale, y: hip }, R: { x: 5 * scale, y: hip } };
        }
        const dLift = (hip - lastLift) / Math.max(dt, 8e-3);
        lastLift = hip;
        const squash = clamp(springSquash.pos + clamp(-dLift * 18e-4, -0.1, 0.12), -0.25, 0.25);
        if (limp) {
          stepLimpLegs(mode === "lie" ? 0 : hip, dt);
        } else if (mode !== "lie") {
          self2.poseLegsFromTargets(targets.L, targets.R, THIGH_LEN, SHIN_LEN);
        }
        self2.poseKiller({
          x: body.x,
          lift: mode === "lie" ? 0 : hip,
          rotX: springRotX.pos,
          rotZ,
          scaleX: clamp(1 - squash * 0.55, 0.5, 1.5),
          scaleY: clamp((mode === "lie" ? 0.42 : 1) + squash, 0.2, 1.8),
          bright
        });
        self2.setSword(springBladeA.pos, Math.max(0.6, springBladeW.pos), wantReach);
        if (king.ragdoll) {
          stepKingRagdoll(dt);
        } else if (king.live) {
          const riseAmt = clamp((76 - springRotX.pos) / 76, 0, 1);
          self2.poseVictim({
            rotX: springRotX.pos,
            rotZ: riseAmt * Math.sin(performance.now() / 1e3 * 2.2) * 1.4,
            x: 0,
            y: -springLift.pos,
            scaleY: clamp(lerp(0.42, 1, riseAmt) + squash * 0.2, 0.2, 1.8),
            bright: lerp(0.92, 1, riseAmt)
          });
        }
        if (king.ragdoll && limp) {
          resolveBroadphase(
            king.ragdoll.pts,
            [limp.L.knee, limp.L.foot, limp.R.knee, limp.R.foot]
          );
        }
        self2.raf = requestAnimationFrame(frame);
      }
      self2.raf = requestAnimationFrame(frame);
    }
    close(triggerCallback = true) {
      if (this.safetyTimer) {
        clearTimeout(this.safetyTimer);
        this.safetyTimer = null;
      }
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      cancelAnimationFrame(this.raf);
      this.running = false;
      window.removeEventListener("keydown", this.handleKeyDown);
      if (this.overlayEl) {
        this.overlayEl.classList.remove("active");
        setTimeout(() => {
          if (this.overlayEl && this.overlayEl.parentNode) {
            this.overlayEl.parentNode.removeChild(this.overlayEl);
          }
          this.overlayEl = null;
        }, 300);
      }
      if (activeOverlayInstance === this) {
        activeOverlayInstance = null;
      }
      if (triggerCallback && typeof this.onComplete === "function") {
        const cb = this.onComplete;
        this.onComplete = null;
        cb();
      }
    }
  };

  // src/ui/ShowModal.js
  var ShowModal = class _ShowModal {
    static isBonusMessage(text2) {
      if (!text2) return false;
      const s = String(text2);
      return /sign|plus 5|plus 10|minus 5|minus 10|wheel|dice|undo|selected|chose sign|all red|all black|all odd|all even|all diff|suicide king|king of hearts|queen of spades|ace of spades|spades cut|no spade|spades|guess starter|starter guess|starter guessed|full house|straight flush|royal flush|straight|stolen crib|crib stolen|thirty-one for five|31.*for 5|nineteen for two|19.*for 2|thirty-one|nineteen|detour|round about|jail|bar|timeout|passing lane|stop sign|partner|flush in play|flush of|bonus/i.test(s);
    }
    static getCardLabel(c) {
      if (typeof window !== "undefined" && typeof window.cardLabel === "function") {
        return window.cardLabel(c);
      }
      if (!c) return "";
      const r = c.playAs && c.playAs.r || c.r || c.rank || "";
      const s = c.playAs && c.playAs.s || c.s || c.suit || "";
      const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      return `${r}${suitSyms[s] || s}`;
    }
    static miniCardHtml(c, extra = "") {
      if (!c) return "";
      const s = c.s || c.suit || "";
      const red = s === "H" || s === "D";
      const label = _ShowModal.getCardLabel(c);
    }
    static bindModalEvents(root = typeof document !== "undefined" ? document.getElementById("modalContent") || document.getElementById("modal") : null) {
      if (!root || root.__showModalEventsBound) return;
      root.__showModalEventsBound = true;
      root.addEventListener("click", (e) => {
        const gloryBtn = e.target.closest('[data-action="hand-of-glory"]');
        if (gloryBtn) {
          const seat = gloryBtn.dataset.seat || gloryBtn.getAttribute("data-seat");
          if (typeof window !== "undefined" && typeof window.showHandOfGloryModal === "function") {
            window.showHandOfGloryModal(seat);
          }
          return;
        }
        const pegBtn = e.target.closest('[data-action="show-peg-points"]');
        if (pegBtn) {
          if (typeof window !== "undefined" && typeof window.showPegPoints === "function") {
            window.showPegPoints();
          } else {
            _ShowModal.showPegPoints();
          }
          return;
        }
        const handBtn = e.target.closest('[data-action="show-hand-points"]');
        if (handBtn) {
          const key = handBtn.dataset.key || handBtn.getAttribute("data-key");
          if (typeof window !== "undefined" && typeof window.showHandPoints === "function") {
            window.showHandPoints(key);
          } else {
            _ShowModal.showHandPoints(key);
          }
          return;
        }
        const chipBtn = e.target.closest('[data-action="select-stolen-chip"]');
        if (chipBtn) {
          const amt = parseInt(chipBtn.dataset.amount, 10);
          if (!isNaN(amt)) {
            _ShowModal.selectStolenChip(amt);
          }
          return;
        }
      });
    }
    /**
     * Retrieves the kept hand cards for a specific seat/player across all phase structures.
     * Handles 2-player ('pone', 'dealer') and multi-player ('p1'..'p8') state formats.
     * @param {string} trackOrSeat
     * @param {Object} state
     * @param {Object} [context]
     * @returns {Array} Array of Card objects
     */
    static getPlayerHandCards(trackOrSeat, state3, context = {}) {
      if (!trackOrSeat || !state3) return [];
      let sId = String(trackOrSeat);
      if (sId === "you") sId = "p1";
      if (sId === "cpu") sId = "p2";
      if (state3.lastShow && typeof state3.lastShow === "object") {
        if (Array.isArray(state3.lastShow[sId]?.cards) && state3.lastShow[sId].cards.length) {
          return state3.lastShow[sId].cards;
        }
        for (const k of Object.keys(state3.lastShow)) {
          const item = state3.lastShow[k];
          if (item && item.who) {
            let itemWho = String(item.who);
            if (itemWho === "you") itemWho = "p1";
            if (itemWho === "cpu") itemWho = "p2";
            if (itemWho === sId && Array.isArray(item.cards) && item.cards.length) {
              return item.cards;
            }
          }
        }
      }
      const getSeatKeptFn = context.getSeatKept || (typeof window !== "undefined" ? window.getSeatKept || window.GameState?.getSeatKept : null);
      if (typeof getSeatKeptFn === "function") {
        try {
          const kept = getSeatKeptFn(sId, state3) || getSeatKeptFn(sId);
          if (Array.isArray(kept) && kept.length) return kept;
        } catch (_) {
        }
      }
      if (Array.isArray(state3.seatKept?.[sId]) && state3.seatKept[sId].length) return state3.seatKept[sId];
      if (Array.isArray(state3.kept?.[sId]) && state3.kept[sId].length) return state3.kept[sId];
      if (sId === "p1") {
        if (Array.isArray(state3.youKept) && state3.youKept.length) return state3.youKept;
        if (Array.isArray(state3.kept?.p1) && state3.kept.p1.length) return state3.kept.p1;
      }
      if (sId === "p2") {
        if (Array.isArray(state3.cpuKept) && state3.cpuKept.length) return state3.cpuKept;
        if (Array.isArray(state3.kept?.p2) && state3.kept.p2.length) return state3.kept.p2;
      }
      if (Array.isArray(state3.seatHands?.[sId]) && state3.seatHands[sId].length) return state3.seatHands[sId];
      if (Array.isArray(state3.hands?.[sId]) && state3.hands[sId].length) return state3.hands[sId];
      if (sId === "p1" && Array.isArray(state3.youHand) && state3.youHand.length) return state3.youHand;
      if (sId === "p2" && Array.isArray(state3.cpuHand) && state3.cpuHand.length) return state3.cpuHand;
      return [];
    }
    static showPegPoints(options = {}) {
      if (typeof document === "undefined") return;
      const box = document.getElementById("handDetail");
      if (!box) return;
      if (box.dataset.open === "peg") {
        box.innerHTML = "";
        box.dataset.open = "";
        return;
      }
      const state3 = options.state || (typeof window !== "undefined" ? window.state : {}) || {};
      const log2 = state3.pegLog || [];
      const count = typeof window !== "undefined" && typeof window.getPlayerCount === "function" ? window.getPlayerCount() : 2;
      const isPart = typeof window !== "undefined" && typeof window.isPartnership === "function" ? window.isPartnership() : false;
      const pName2 = typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : ((w) => w);
      let pegTotalsStr = "";
      if (isPart) {
        pegTotalsStr = `Team 1 ${state3.handPeg && state3.handPeg.team1 || 0} \xB7 Team 2 ${state3.handPeg && state3.handPeg.team2 || 0}`;
      } else if (count > 2 && typeof window !== "undefined" && typeof window.getActiveSeats === "function") {
        pegTotalsStr = window.getActiveSeats().map((s) => `${s.name} ${state3.handPeg && state3.handPeg[s.id] || 0}`).join(" \xB7 ");
      } else {
        pegTotalsStr = `${pName2("you")} ${state3.handPeg && state3.handPeg.you || 0} \xB7 ${pName2("cpu")} ${state3.handPeg && state3.handPeg.cpu || 0}`;
      }
      const rows = log2.length ? '<ul class="pt-lines">' + log2.map((e) => {
        const isB = _ShowModal.isBonusMessage(e.why);
        return `<li class="${isB ? "pt-line-bonus" : ""}">${isB ? '<span class="pt-bonus-pill">BONUS</span> ' : ""}<strong>${pName2(e.who)} +${e.n}</strong> ${e.why}` + (e.card ? " \u2014 " + _ShowModal.getCardLabel(e.card) : "") + (e.count ? ' <span style="opacity:.7">(count ' + e.count + ")</span>" : "") + "</li>";
      }).join("") + "</ul>" : "<p>No pegging points this hand.</p>";
      box.dataset.open = "peg";
      box.innerHTML = `<div class="hand-detail">
      <strong>Pegging</strong> \u2014 ${pegTotalsStr}
      ${rows}
    </div>`;
    }
    static showHandPoints(key, options = {}) {
      if (typeof document === "undefined") return;
      const box = document.getElementById("handDetail");
      const state3 = options.state || (typeof window !== "undefined" ? window.state : {}) || {};
      if (!box || !state3.lastShow || !state3.lastShow[key]) return;
      if (box.dataset.open === key) {
        box.innerHTML = "";
        box.dataset.open = "";
        return;
      }
      const h = state3.lastShow[key];
      const cards = h.cards || [];
      const lines = h.score && h.score.lines || [];
      const lineHtml = lines.length ? '<ul class="pt-lines">' + lines.map((l) => {
        const isB = l.isBonus || _ShowModal.isBonusMessage(l.why);
        return `<li class="${isB ? "pt-line-bonus" : ""}">${isB ? '<span class="pt-bonus-pill">BONUS</span> ' : ""}<strong>+${l.n}</strong> ${l.why}${l.cards && l.cards.length ? " \u2014 " + l.cards.map(_ShowModal.getCardLabel).join(" ") : ""}</li>`;
      }).join("") + "</ul>" : "<p>No scoring combinations.</p>";
      box.dataset.open = key;
      const starters = h.starters && h.starters.length ? h.starters : h.starter ? [h.starter] : [];
      const startersHtml = starters.map((s) => _ShowModal.miniCardHtml(s, "cut")).join("");
      box.innerHTML = `<div class="hand-detail">
      <strong>${h.title}</strong> \u2014 ${h.signed} point${Math.abs(h.signed) === 1 ? "" : "s"}
      <div class="mini-row">${cards.map((c) => _ShowModal.miniCardHtml(c)).join("")}${startersHtml}</div>
      <div style="font-size:.8rem;opacity:.8">Starter${starters.length > 1 ? "s" : ""} outlined in gold</div>
      ${lineHtml}
      <div style="margin-top: 10px; text-align: center;">
        <button type="button" class="btn-glory-pill" data-action="hand-of-glory" data-seat="${key}" title="Generate shareable Hand of Glory graphic card">
          <span>\u{1F3C6}</span> <span>Hand of Glory Card</span>
        </button>
      </div>
    </div>`;
      _ShowModal.bindModalEvents();
    }
    static cardKey(c) {
      if (!c) return "";
      if (c.id) return c.id;
      const r = c.r || c.rank || "";
      const s = c.s || c.suit || "";
      return r && s ? `${r}-${s}` : "";
    }
    /**
     * Renders the active hand or crib counter modal dialog with cards and live show meter.
     * @param {Object} pack
     * @param {number} actIdx
     * @param {Object} [context]
     */
    static renderShowCountModal(pack, actIdx = 0, context = {}) {
      if (!pack) return;
      const showModal2 = context.showModal || (typeof window !== "undefined" ? window.showModal : null);
      if (typeof showModal2 !== "function") return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const key = state3 && state3.showQueue && state3.showQueue[actIdx] || state3?.showAct || "";
      const isCrib = key === "crib" || pack.who === "crib";
      const cards = pack.cards && pack.cards.length ? pack.cards : [];
      const starters = pack.starters && pack.starters.length ? pack.starters : pack.starter ? [pack.starter] : [];
      const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const rankNames = { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" };
      const getCid = (c) => {
        const fn = context.cardKey || (typeof window !== "undefined" ? window.cardKey : null) || _ShowModal.cardKey;
        return fn(c) || _ShowModal.cardKey(c);
      };
      const renderCard = (c, isCut = false) => {
        if (!c) return "";
        const suit = c.suit || c.s || "S";
        const isRed = suit === "H" || suit === "D";
        const color = isRed ? "#dc2626 !important" : "#111827 !important";
        const r = c.rankName || c.r || rankNames[c.rank] || c.rank || "\u2605";
        const s = suitSyms[suit] || suit || "";
        const cid = getCid(c);
        return `
        <div class="playing-card show-count-card${isCut ? " cut-card" : ""}" data-cid="${cid}"
             style="position: relative; width: 58px; height: 84px; box-sizing: border-box; background: #ffffff !important; border: 2px solid ${isCut ? "#eab308" : "#cbd5e1"}; border-radius: 7px; overflow: hidden; box-shadow: 0 4px 10px rgba(0,0,0,0.35); text-align: left; transition: transform 0.22s ease, box-shadow 0.22s ease, outline 0.22s ease;">
          ${TraditionalCard.renderHtml(c, { isCut })}
        </div>
      `;
      };
      const cardsHtml = cards.map((c) => renderCard(c, false)).join("");
      const startersHtml = starters.map((s) => renderCard(s, true)).join("");
      const html2 = `
      <div class="show-counter-modal" id="showCountModal">
        <div class="show-count-badge">
          <span class="show-count-icon">${isCrib ? "\u{1F9FA}" : "\u{1F3B4}"}</span>
          <span>${isCrib ? "CRIB COUNT" : "HAND COUNT"}</span>
        </div>
        <h2 class="show-count-title">${pack.title || (isCrib ? "The Crib" : "Hand Count")}</h2>

        <div class="show-count-cards-wrap">
          <div class="show-count-cards-group">
            ${cardsHtml}
          </div>
          ${startersHtml ? `
            <div class="show-count-divider">+</div>
            <div class="show-count-cards-group cut-group">
              ${startersHtml}
            </div>
          ` : ""}
        </div>
        <div class="show-count-cut-note">Starter${starters.length > 1 ? "s" : ""} outlined in gold</div>

        <div class="show-meter" id="showMeter">
          <div class="show-act" id="showActLabel">${pack.title || "Show"}</div>
          <div class="show-run"><span id="showRunVal">${state3?.showRun || 0}</span></div>
          <div class="show-line" id="showLine">${state3?.showMeter?.line || "Flipping\u2026"}</div>
        </div>

        <div class="show-combo-feed" id="showComboFeed"></div>
      </div>
    `;
      showModal2(html2, false);
    }
    static setShowMeter(act, total, line, isBonus = false, context = {}) {
      if (typeof document === "undefined") return;
      let box = document.getElementById("showMeter");
      if (!box) {
        const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
        if (state3 && state3.phase === "show" && state3.lastShow && state3.showAct && state3.lastShow[state3.showAct]) {
          const pack = state3.lastShow[state3.showAct];
          _ShowModal.renderShowCountModal(pack, 0, context);
          box = document.getElementById("showMeter");
        }
      }
      if (!box) return;
      box.classList.toggle("hidden", !act);
      box.classList.toggle("bonus-active", !!isBonus);
      const lab = document.getElementById("showActLabel");
      const val = document.getElementById("showRunVal");
      const ln = document.getElementById("showLine");
      if (lab) lab.textContent = act || "";
      if (val) val.textContent = String(total || 0);
      if (ln) {
        ln.innerHTML = isBonus ? `<span class="show-line-bonus">${line}</span>` : line || "";
      }
    }
    static famousFanfare(n, options = {}) {
      if (typeof window === "undefined") return;
      const sfx3 = options.sfx || window.sfx;
      const fancyCall2 = options.fancyCall || window.fancyCall;
      if (n >= 20) {
        CelebrationFX.triggerCelebration(n, { sfx: sfx3 });
      }
      if (n >= 24 && typeof window !== "undefined" && window._currentRenderer3D) {
        window._currentRenderer3D.triggerActionCam({ type: "big_hand", score: n });
      }
      if (n === 29) {
        AchievementManager.unlock("holy_grail", { sfx: sfx3 });
        AchievementManager.unlock("twenty_pointer", { sfx: sfx3 });
      } else {
        if (n >= 100) AchievementManager.unlock("crazy_mythic", { sfx: sfx3 });
        if (n >= 75) AchievementManager.unlock("crazy_godlike", { sfx: sfx3 });
        if (n >= 60) AchievementManager.unlock("crazy_legendary", { sfx: sfx3 });
        if (n >= 50) AchievementManager.unlock("crazy_awesome", { sfx: sfx3 });
        if (n >= 40) AchievementManager.unlock("crazy_amazing", { sfx: sfx3 });
        if (n >= 35) AchievementManager.unlock("century_club", { sfx: sfx3 });
        if (n >= 30) AchievementManager.unlock("crazy_good", { sfx: sfx3 });
        if (n >= 20) AchievementManager.unlock("twenty_pointer", { sfx: sfx3 });
      }
      if (typeof fancyCall2 === "function") {
        if (n === 29) fancyCall2("Twenty-nine!", "famous", 2200);
        else if (n === 28) fancyCall2("Twenty-eight!", "famous", 2e3);
        else if (n === 24) fancyCall2("Twenty-four!", "famous", 1800);
        else if (n >= 20) fancyCall2(n + " Points!", "famous", 1600);
      }
    }
    static open(pegOnly = false, options = {}) {
      const state3 = options.state || (typeof window !== "undefined" ? window.state : {}) || {};
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : {}) || {};
      const pName2 = typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : ((w) => w);
      if (state3 && state3.over) {
        state3.showModal = null;
        state3.showMeter = null;
        const checkGameOverFn = options.checkGameOver || (typeof window !== "undefined" ? window.checkGameOver : null);
        if (typeof checkGameOverFn === "function") checkGameOverFn(options);
        return;
      }
      if (typeof document === "undefined") return;
      if (state3 && !state3.handRecorded) {
        state3.handRecorded = true;
        state3.handsCompleted = (state3.handsCompleted || 0) + 1;
      }
      if (typeof window !== "undefined" && window.gameHands && typeof window.saveHand === "function") {
        window.saveHand(state3);
      }
      HandScoreTracker.recordHand(state3, settings3, { pName: pName2 });
      state3.showModal = { open: true, pegOnly: !!pegOnly };
      const ls = state3.lastShow || {};
      const count = typeof window !== "undefined" && typeof window.getPlayerCount === "function" ? window.getPlayerCount() : 2;
      const isPart = typeof window !== "undefined" && typeof window.isPartnership === "function" ? window.isPartnership() : false;
      const isGuest = typeof window !== "undefined" && typeof window.isOnline === "function" && window.isOnline() && settings3.netRole === "guest";
      const actionBtn = isGuest ? `<div class="btn-gold" id="btnGuestWait" style="opacity:.85;cursor:default;text-align:center;padding:12px 20px;letter-spacing:.05em;">Waiting for Host to start next hand\u2026</div>` : `<button class="btn-gold" id="btnNextHand">Next hand</button>`;
      const formatNotes = (notes) => {
        if (!notes || !notes.length) return "0";
        return notes.map((n) => _ShowModal.isBonusMessage(n) ? `<span class="note-bonus">${n}</span>` : n).join(" \xB7 ");
      };
      let breakdownHtml = "";
      let scoresHtml = "";
      const animIds = ["tickPeg"];
      if (count === 2) {
        const youPeg = state3.handPeg && state3.handPeg.you || 0;
        const cpuPeg = state3.handPeg && state3.handPeg.cpu || 0;
        const poneScore = ls.pone && ls.pone.score || { total: 0, notes: [] };
        const dealScore = ls.dealer && ls.dealer.score || { total: 0, notes: [] };
        const cribSigned = ls.crib ? ls.crib.signed : 0;
        const cribNotes = ls.crib && ls.crib.score && ls.crib.score.notes || [];
        const pone = state3.dealer === "you" ? "cpu" : "you";
        const poneBlocked = ls.pone && ls.pone.blockedByZone;
        const dealBlocked = ls.dealer && ls.dealer.blockedByZone;
        const cribBlocked = ls.crib && ls.crib.blockedByZone;
        const poneReason = ls.pone && ls.pone.blockedReason || "Peg Zone";
        const dealReason = ls.dealer && ls.dealer.blockedReason || "Peg Zone";
        const cribReason = ls.crib && ls.crib.blockedReason || "Peg Zone";
        const zoneColor = (r) => r === "Bunker" ? "#eab308" : r === "Last 5 Peg Out" ? "#f43f5e" : "#f97316";
        const poneCounted = poneBlocked ? 0 : poneScore.total;
        const dealCounted = dealBlocked ? 0 : dealScore.total;
        const cribCounted = cribBlocked ? 0 : cribSigned;
        const cribRecipient = ls.crib && ls.crib.who || state3.dealer;
        const isYouCrib = cribRecipient === "you" || cribRecipient === "p1";
        const youShow = pegOnly ? 0 : (pone === "you" ? poneCounted : dealCounted) + (isYouCrib ? cribCounted : 0);
        const cpuShow = pegOnly ? 0 : (pone === "cpu" ? poneCounted : dealCounted) + (!isYouCrib ? cribCounted : 0);
        const stolenInfo = state3.stolenCrib;
        let stolenTag = "";
        if (stolenInfo) {
          if (stolenInfo.success) {
            stolenTag = ` <span class="note-bonus" style="font-weight:700;">[STOLEN by ${pName2(stolenInfo.pone)}: guessed ${stolenInfo.guess} pts!]</span>`;
          } else {
            stolenTag = ` <span style="color:#94a3b8;font-size:0.85em;">[${pName2(stolenInfo.pone)} guessed ${stolenInfo.guess} pts]</span>`;
          }
        }
        breakdownHtml = `
        <div class="breakdown show-tick" id="tickPeg"><strong>Pegged this hand</strong> \u2014 ${pName2("you")} ${youPeg} \xB7 ${pName2("cpu")} ${cpuPeg}
          <div><button type="button" class="btn-ghost" data-action="show-peg-points">Show pegging points</button></div></div>
        ${pegOnly ? "<p>Hand and crib points do not count in speed game.</p>" : `
        <div class="breakdown show-tick" id="tickPone"><strong>${pName2(pone)} hand (pone)</strong> \u2014 ${poneBlocked ? `0 (in ${poneReason})` : poneScore.total}<br>${formatNotes(poneScore.notes)}${poneBlocked ? ` <span style="color:${zoneColor(poneReason)};font-weight:600;">[${poneReason}: hole ${ls.pone.leadPegWhenScored}]</span>` : ""}
          <div><button type="button" class="btn-ghost" data-action="show-hand-points" data-key="pone">Show cards &amp; points</button></div></div>
        <div class="breakdown show-tick" id="tickDeal"><strong>${ls.dealer && ls.dealer.title || `${pName2(state3.dealer)} hand (dealer)`}</strong> \u2014 ${dealBlocked ? `0 (in ${dealReason})` : dealScore.total}<br>${formatNotes(dealScore.notes)}${dealBlocked ? ` <span style="color:${zoneColor(dealReason)};font-weight:600;">[${dealReason}: hole ${ls.dealer.leadPegWhenScored}]</span>` : ""}
          <div><button type="button" class="btn-ghost" data-action="show-hand-points" data-key="dealer">Show cards &amp; points</button></div></div>
        <div class="breakdown show-tick" id="tickCrib"><strong>${ls.crib && ls.crib.title || (ls.crib && ls.crib.stolen ? `Crib (Stolen by ${pName2(ls.crib.stolenBy)})` : "Crib")}</strong> \u2014 ${cribBlocked ? `0 (in ${cribReason})` : cribSigned}<br>${formatNotes(cribNotes)}${settings3.optRockCrib ? " (rocked)" : ""}${settings3.optShotgunCribbage ? " (Shotgun Cribbage: not counted)" : ""}${stolenTag}${cribBlocked ? ` <span style="color:${zoneColor(cribReason)};font-weight:600;">[${cribReason}: hole ${ls.crib.leadPegWhenScored}]</span>` : ""}
          <div><button type="button" class="btn-ghost" data-action="show-hand-points" data-key="crib">Show cards &amp; points</button></div></div>
        `}
        <div id="handDetail"></div>
        <div class="breakdown show-tick" id="tickTot"><strong>This hand total</strong> \u2014 ${pName2("you")} ${youPeg + youShow} \xB7 ${pName2("cpu")} ${cpuPeg + cpuShow}</div>
      `;
        scoresHtml = `<p>${pName2("you")} ${state3.scores ? state3.scores.you : 0} \xB7 ${pName2("cpu")} ${state3.scores ? state3.scores.cpu : 0}</p>`;
        animIds.push("tickPone", "tickDeal", "tickCrib", "tickTot");
      } else {
        let pegTotalsStr = "";
        if (isPart) {
          pegTotalsStr = `Team 1 ${state3.handPeg && state3.handPeg.team1 || 0} \xB7 Team 2 ${state3.handPeg && state3.handPeg.team2 || 0}`;
        } else if (typeof window !== "undefined" && typeof window.getActiveSeats === "function") {
          pegTotalsStr = window.getActiveSeats().map((s) => `${s.name} ${state3.handPeg && state3.handPeg[s.id] || 0}`).join(" \xB7 ");
        }
        let showRows = "";
        const q = state3.showQueue || [];
        const zoneColor = (r) => r === "Bunker" ? "#eab308" : r === "Last 5 Peg Out" ? "#f43f5e" : "#f97316";
        q.forEach((key) => {
          const pack = ls[key];
          if (!pack) return;
          const tid = "tick_" + key;
          animIds.push(tid);
          const isCrib = key === "crib";
          const notes = pack.score && pack.score.notes || [];
          const isBlocked = pack.blockedByZone;
          const bReason = pack.blockedReason || "Peg Zone";
          const ptsDisplay = isBlocked ? `0 (in ${bReason})` : isCrib ? pack.signed : pack.score.total;
          showRows += `
          <div class="breakdown show-tick" id="${tid}">
            <strong>${pack.title}</strong> \u2014 ${ptsDisplay}<br>
            ${formatNotes(notes)}${isCrib && settings3.optRockCrib ? " (rocked)" : ""}${isCrib && settings3.optShotgunCribbage ? " (Shotgun Cribbage: not counted)" : ""}${isBlocked ? ` <span style="color:${zoneColor(bReason)};font-weight:600;">[${bReason}: hole ${pack.leadPegWhenScored}]</span>` : ""}
            <div><button type="button" class="btn-ghost" data-action="show-hand-points" data-key="${key}">Show cards &amp; points</button></div>
          </div>
        `;
        });
        breakdownHtml = `
        <div class="breakdown show-tick" id="tickPeg"><strong>Pegged this hand</strong> \u2014 ${pegTotalsStr}
          <div><button type="button" class="btn-ghost" data-action="show-peg-points">Show pegging points</button></div></div>
        ${pegOnly ? "<p>Hand and crib points do not count in speed game.</p>" : showRows}
        <div id="handDetail"></div>
      `;
        if (isPart) {
          if (typeof window !== "undefined" && typeof window.is3Player1vs2 === "function" && window.is3Player1vs2()) {
            scoresHtml = `<p><strong>Match Score:</strong> ${pName2("team1")}: ${state3.scores.team1 || 0} \xB7 ${pName2("team2")}: ${state3.scores.team2 || 0}</p>`;
          } else if (count === 5 && settings3.gameMode === "shifting") {
            scoresHtml = `<p><strong>Match Score:</strong> ${pName2("team1")}: ${state3.scores.team1 || 0} \xB7 ${pName2("team2")}: ${state3.scores.team2 || 0} \xB7 ${pName2("team3")}: ${state3.scores.team3 || 0}</p>`;
          } else if (count === 6) {
            scoresHtml = `<p><strong>Match Score:</strong> ${pName2("team1")}: ${state3.scores.team1 || 0} \xB7 ${pName2("team2")}: ${state3.scores.team2 || 0} \xB7 ${pName2("team3")}: ${state3.scores.team3 || 0}</p>`;
          } else if (count === 7 && settings3.gameMode === "shifting") {
            scoresHtml = `<p><strong>Match Score:</strong> ${pName2("team1")}: ${state3.scores.team1 || 0} \xB7 ${pName2("team2")}: ${state3.scores.team2 || 0} \xB7 ${pName2("team3")}: ${state3.scores.team3 || 0} \xB7 ${pName2("team4")}: ${state3.scores.team4 || 0}</p>`;
          } else if (count === 8) {
            scoresHtml = `<p><strong>Match Score:</strong> ${pName2("team1")}: ${state3.scores.team1 || 0} \xB7 ${pName2("team2")}: ${state3.scores.team2 || 0} \xB7 ${pName2("team3")}: ${state3.scores.team3 || 0} \xB7 ${pName2("team4")}: ${state3.scores.team4 || 0}</p>`;
          } else {
            scoresHtml = `<p><strong>Match Score:</strong> Team 1 (Seats 1 &amp; 3): ${state3.scores.team1 || 0} \xB7 Team 2 (Seats 2 &amp; 4): ${state3.scores.team2 || 0}</p>`;
          }
        } else if (typeof window !== "undefined" && typeof window.getActiveSeats === "function") {
          scoresHtml = `<p><strong>Match Scores:</strong> ` + window.getActiveSeats().map((s) => `${s.name}: ${state3.scores[s.id] || 0}`).join(" \xB7 ") + `</p>`;
        }
      }
      let gloryBannerHtml = "";
      const gloryThreshold = settings3.brand === "crazy" && settings3.optJokers ? 30 : 20;
      let maxGloryPts = 0;
      let maxGloryKey = null;
      let maxGloryOwner = "";
      const checkGloryEntry = (k, entry) => {
        if (!entry) return;
        const pts = typeof entry.signed === "number" ? entry.signed : entry.score && entry.score.total || 0;
        if (pts >= gloryThreshold && pts > maxGloryPts) {
          maxGloryPts = pts;
          maxGloryKey = k;
          maxGloryOwner = entry.title || pName2(entry.who || k);
        }
      };
      if (count === 2) {
        checkGloryEntry("pone", ls.pone);
        checkGloryEntry("dealer", ls.dealer);
        checkGloryEntry("crib", ls.crib);
      } else {
        Object.keys(ls).forEach((k) => checkGloryEntry(k, ls[k]));
      }
      const trackBest = (entry) => {
        if (!entry) return;
        const pts = typeof entry.signed === "number" ? entry.signed : entry.score && entry.score.total || 0;
        const curBest = state3.bestMatchHand ? typeof state3.bestMatchHand.signed === "number" ? state3.bestMatchHand.signed : state3.bestMatchHand.score && state3.bestMatchHand.score.total || 0 : -1;
        if (pts > curBest) {
          try {
            state3.bestMatchHand = JSON.parse(JSON.stringify(entry));
          } catch (e) {
            state3.bestMatchHand = entry;
          }
        }
      };
      if (count === 2) {
        trackBest(ls.pone);
        trackBest(ls.dealer);
        trackBest(ls.crib);
      } else {
        Object.keys(ls).forEach((k) => trackBest(ls[k]));
      }
      if (maxGloryKey && !pegOnly) {
        gloryBannerHtml = `
        <div class="glory-show-banner">
          <div class="glory-show-banner-text">
            <span class="glory-show-icon">\u{1F31F}</span>
            <span><strong>HAND OF GLORY!</strong> ${maxGloryOwner} scored <strong>${maxGloryPts} pts</strong></span>
          </div>
          <button type="button" class="btn-glory-banner" data-action="hand-of-glory" data-seat="${maxGloryKey}" title="Generate and share Hand of Glory card">
            \u{1F3C6} Share Card
          </button>
        </div>
      `;
      }
      let progressiveCutHtml = "";
      if (settings3.optProgressiveCut && count === 2) {
        const handsDone = state3.handsCompleted || 0;
        const currentCutLevel = Math.max(1, Math.floor((handsDone - 1) / 2) + 1);
        const nextCutLevel = Math.floor(handsDone / 2) + 1;
        const isUneven = handsDone % 2 !== 0;
        const target = settings3.target || 121;
        const s1 = state3.scores ? state3.scores.p1 || state3.scores.you || 0 : 0;
        const s2 = state3.scores ? state3.scores.p2 || state3.scores.cpu || 0 : 0;
        const hasPassedTarget = s1 > 121 || s2 > 121 || s1 >= target || s2 >= target;
        const isTied = s1 === s2;
        if (isUneven && hasPassedTarget) {
          progressiveCutHtml = `
          <div style="margin: 8px 0 12px; padding: 10px 14px; background: rgba(245,158,11,0.18); border: 1.5px solid #f59e0b; border-radius: 8px; font-size: 0.88rem; color: #fde68a; line-height: 1.4;">
            \u26A1 <strong>Progressive Cut: Level ${currentCutLevel} (${currentCutLevel} cut card${currentCutLevel > 1 ? "s" : ""})</strong><br>
            Target reached! Uneven cribs (${handsDone} hand played) \u2014 playing 1 more hand for equal cribs!
          </div>
        `;
        } else if (!isUneven && isTied && hasPassedTarget) {
          progressiveCutHtml = `
          <div style="margin: 8px 0 12px; padding: 10px 14px; background: rgba(239,68,68,0.18); border: 1.5px solid #ef4444; border-radius: 8px; font-size: 0.88rem; color: #fca5a5; line-height: 1.4;">
            \u2694\uFE0F <strong>Progressive Cut: Tied at ${s1} pts after even cribs!</strong><br>
            Carrying on to Level ${nextCutLevel} (${nextCutLevel} cut cards)!
          </div>
        `;
        } else {
          progressiveCutHtml = `
          <div style="margin: 8px 0 12px; padding: 8px 12px; background: rgba(240,198,74,0.1); border: 1px solid rgba(240,198,74,0.3); border-radius: 8px; font-size: 0.84rem; color: #f4ead4;">
            \u{1F0CF} <strong>Progressive Cut: Level ${currentCutLevel} (${currentCutLevel} cut card${currentCutLevel > 1 ? "s" : ""})</strong> \xB7 Hand ${handsDone} completed${nextCutLevel > currentCutLevel ? ` \u2794 Advancing to Level ${nextCutLevel} (${nextCutLevel} cut cards)` : ""}
          </div>
        `;
        }
      }
      let chutesAndLaddersHtml = "";
      if (state3.chutesAndLaddersTriggered) {
        const tiedScore = state3.chutesAndLaddersTiedScore || 0;
        chutesAndLaddersHtml = `
        <div style="margin: 8px 0 12px; padding: 12px 16px; background: linear-gradient(135deg, rgba(239,68,68,0.22), rgba(245,158,11,0.22)); border: 2px solid #f59e0b; border-radius: 10px; font-size: 0.95rem; color: #fef3c7; line-height: 1.45; text-align: center; box-shadow: 0 4px 12px rgba(0,0,0,0.35);">
          <div style="font-size: 1.3rem; margin-bottom: 4px;">\u{1F3A2} <strong>CHUTES AND LADDERS!</strong> \u{1FA9C}</div>
          <div>All players were tied at <strong>${tiedScore} pts</strong>!</div>
          <div style="font-weight: bold; color: #fde68a; margin-top: 4px;">Everyone slides all the way back to Start (Hole 0)!</div>
        </div>
      `;
      }
      if (typeof window !== "undefined" && typeof window.showModal === "function") {
        window.showModal(
          `<h2>${pegOnly ? "Pegging only" : "Hand scored"}</h2>
         ${gloryBannerHtml}
         ${chutesAndLaddersHtml}
         ${progressiveCutHtml}
         ${breakdownHtml}
         ${scoresHtml}
         ${actionBtn}`
        );
        _ShowModal.bindModalEvents();
      }
      animIds.forEach((id, i) => {
        setTimeout(() => {
          const n = document.getElementById(id);
          if (n) n.classList.add("on");
        }, 180 + i * 280);
      });
      if (typeof window !== "undefined") {
        const checkGameOverFn = options.checkGameOver || (typeof window.checkGameOver === "function" ? window.checkGameOver : null);
        const isOver = typeof checkGameOverFn === "function" ? checkGameOverFn(options) : false;
        if (isOver || state3 && state3.over) {
          state3.showModal = null;
          state3.showMeter = null;
          return;
        }
        const nextBtn = document.getElementById("btnNextHand");
        if (nextBtn) {
          nextBtn.addEventListener("click", () => {
            state3.showModal = null;
            state3.chutesAndLaddersTriggered = false;
            state3.chutesAndLaddersTiedScore = null;
            if (typeof window.hideModal === "function") window.hideModal();
            if (typeof window.nextSeat === "function") state3.dealer = window.nextSeat(state3.dealer);
            state3.revealCrib = false;
            if (typeof window.newHand === "function") window.newHand();
            if (typeof window.netPush === "function") window.netPush({ modal: "hide" });
          });
        }
        if (typeof window.render === "function") window.render();
        if (typeof window.netPush === "function") window.netPush({ modal: "show", pegOnly: !!pegOnly });
      }
    }
    /**
     * Sets the active guess value in the Stolen Crib modal.
     * @param {number} n
     */
    static selectStolenChip(n) {
      if (typeof document === "undefined") return;
      const inp = document.getElementById("stolenCribGuess");
      if (inp) inp.value = n;
      document.querySelectorAll(".stolen-crib-chip").forEach((c) => {
        c.classList.toggle("active", c.textContent.trim() === String(n));
      });
    }
    /**
     * Displays the Stolen Crib guessing modal for human players.
     * @param {string} poneSeat
     * @param {string} dealerSeat
     * @param {number} actIdx
     * @param {Object} [context]
     */
    static openStolenCribPrompt(poneSeat, dealerSeat, actIdx, context = {}) {
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const showModal2 = context.showModal || (typeof window !== "undefined" ? window.showModal : () => {
      });
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : () => {
      });
      const sendStolenCribGuess2 = context.sendStolenCribGuess || (typeof window !== "undefined" ? window.sendStolenCribGuess : _ShowModal.sendStolenCribGuess);
      const pTitle = seatName3(poneSeat);
      const dTitle = seatName3(dealerSeat);
      const html2 = `
      <div class="stolen-crib-box">
        <div class="stolen-crib-badge">Bonus: Stolen Crib</div>
        <h2>Steal the Crib?</h2>
        <p><strong>${pTitle}</strong>, guess how many points <strong>${dTitle}</strong>'s crib is worth!</p>
        <p style="font-size:0.9rem;color:#cbd5e1;margin-top:-4px;">If your guess is exactly correct, you steal and score all the points instead of the dealer.</p>
        <div class="stolen-crib-input-wrap">
          <input type="number" id="stolenCribGuess" class="stolen-crib-input" min="0" max="60" value="4" autofocus>
          <button type="button" class="btn-gold" id="btnSubmitStolenGuess">Lock in guess</button>
        </div>
        <div class="stolen-crib-quick-row">
          <button type="button" class="stolen-crib-chip" data-action="select-stolen-chip" data-amount="0">0</button>
          <button type="button" class="stolen-crib-chip" data-action="select-stolen-chip" data-amount="2">2</button>
          <button type="button" class="stolen-crib-chip active" data-action="select-stolen-chip" data-amount="4">4</button>
          <button type="button" class="stolen-crib-chip" data-action="select-stolen-chip" data-amount="6">6</button>
          <button type="button" class="stolen-crib-chip" data-action="select-stolen-chip" data-amount="8">8</button>
          <button type="button" class="stolen-crib-chip" data-action="select-stolen-chip" data-amount="10">10</button>
          <button type="button" class="stolen-crib-chip" data-action="select-stolen-chip" data-amount="12">12</button>
          <button type="button" class="stolen-crib-chip" data-action="select-stolen-chip" data-amount="16">16</button>
        </div>
      </div>
    `;
      showModal2(html2, false);
      _ShowModal.bindModalEvents();
      if (typeof document === "undefined") return;
      const btn = document.getElementById("btnSubmitStolenGuess");
      const inp = document.getElementById("stolenCribGuess");
      if (btn && inp) {
        btn.addEventListener("click", () => {
          const val = parseInt(inp.value, 10) || 0;
          hideModal3();
          sendStolenCribGuess2(val, actIdx, context);
        });
        inp.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            const val = parseInt(inp.value, 10) || 0;
            hideModal3();
            sendStolenCribGuess2(val, actIdx, context);
          }
        });
      }
    }
    /**
     * Displays the interactive Twisted Cribbage modal allowing the player to arrange
     * all 8 cards into two 4-card hands maximizing total points.
     * @param {string} dealerSeat
     * @param {number} actIdx
     * @param {Object} [context]
     */
    static openTwistedCribbageModal(dealerSeat, actIdx, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const getSeatKept2 = context.getSeatKept || (typeof window !== "undefined" && typeof window.getSeatKept === "function" ? window.getSeatKept : () => []);
      const pName2 = context.pName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : (s) => s);
      const showModal2 = context.showModal || (typeof window !== "undefined" && typeof window.showModal === "function" ? window.showModal : () => {
      });
      const hideModal3 = context.hideModal || (typeof window !== "undefined" && typeof window.hideModal === "function" ? window.hideModal : () => {
      });
      const resolveTwistedCribbageSplit2 = context.resolveTwistedCribbageSplit || (typeof window !== "undefined" && typeof window.resolveTwistedCribbageSplit === "function" ? window.resolveTwistedCribbageSplit : _ShowModal.resolveTwistedCribbageSplit);
      const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
      const starterArg = starters.length > 1 ? starters : state3.starter;
      const Scorer = typeof CC !== "undefined" && CC?.CribbageScorer || (typeof window !== "undefined" ? window.CribbageScorer : null) || CribbageScorer2;
      const originalKept = state3.originalDealerKept && state3.originalDealerKept.length ? [...state3.originalDealerKept] : getSeatKept2(dealerSeat) || [];
      const originalCrib = state3.originalCrib && state3.originalCrib.length ? [...state3.originalCrib] : state3.crib || [];
      let all8 = state3.twisted8Cards && state3.twisted8Cards.length === 8 ? [...state3.twisted8Cards] : [...originalKept, ...originalCrib];
      if (all8.length !== 8) {
        all8 = all8.length >= 8 ? all8.slice(0, 8) : all8;
      }
      const is3D = Boolean(
        settings3 && (settings3.boardViewMode === "3d" || settings3.boardViewMode === "room3d" || settings3.boardViewMode === "room3d-fullscreen") || typeof window !== "undefined" && window.settings && (window.settings.boardViewMode === "3d" || window.settings.boardViewMode === "room3d" || window.settings.boardViewMode === "room3d-fullscreen") || typeof document !== "undefined" && (document.getElementById("board3DCanvas") || document.getElementById("room3dCanvas") || document.querySelector(".board-3d-wrap") || document.querySelector(".room3d-wrap"))
      );
      if (is3D) {
        const optimal = Scorer && typeof Scorer.findOptimalTwistedSplit === "function" ? Scorer.findOptimalTwistedSplit(all8, starterArg, settings3) : { hand1: all8.slice(0, 4), hand2: all8.slice(4, 8) };
        resolveTwistedCribbageSplit2(optimal.hand1, optimal.hand2, actIdx, context);
        return;
      }
      let hand1 = all8.slice(0, 4);
      let hand2 = all8.slice(4, 8);
      let selected = null;
      let toastMsg = "";
      const scoreOpts = { ...settings3, optFiveCardFlushOnly: true };
      const rankNames = { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" };
      const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      function renderSingleCard(c, handNum, idx, isSelected) {
        const suit = c.suit || c.s || "S";
        const isRed = suit === "H" || suit === "D";
        const color = isRed ? "#dc2626 !important" : "#111827 !important";
        const r = c.rankName || c.r || rankNames[c.rank] || c.rank || "\u2605";
        const sym = suitSyms[suit] || suit || "";
        const cardBorder = isSelected ? "border: 2px solid #f59e0b;" : "border: 2px solid #cbd5e1;";
        const cardShadow = isSelected ? "box-shadow: 0 0 16px rgba(245, 158, 11, 0.95), 0 4px 14px rgba(0,0,0,0.5); transform: translateY(-6px);" : "box-shadow: 0 4px 10px rgba(0,0,0,0.35);";
        return `
        <div class="playing-card twisted-card ${isRed ? "red card-red" : "black card-black"}${isSelected ? " selected" : ""}"
             id="twCard_${handNum}_${idx}"
             data-action="twisted-card"
             data-hand="${handNum}"
             data-index="${idx}"
             style="position: relative; width: 62px; height: 90px; box-sizing: border-box; background: #ffffff !important; border-radius: 8px; overflow: hidden; text-align: left; cursor: pointer; transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease; ${cardBorder} ${cardShadow}">
          ${TraditionalCard.renderHtml(c)}
          <div class="twisted-card-label" style="font-size: 0.62rem; font-weight: 700; color: #64748b !important; -webkit-text-fill-color: #64748b !important; text-align: center; text-transform: uppercase; position: absolute; bottom: 2px; left: 0; right: 0; z-index: 3;">${handNum === 1 ? "Hand 1" : "Hand 2"}</div>
        </div>
      `;
      }
      function renderCutCardBadge() {
        if (!starterArg) return "";
        const st = Array.isArray(starterArg) ? starterArg[0] : starterArg;
        if (!st) return "";
        const suit = st.suit || st.s || "S";
        const isRed = suit === "H" || suit === "D";
        const color = isRed ? "#dc2626 !important" : "#111827 !important";
        const r = st.rankName || st.r || rankNames[st.rank] || st.rank || "\u2605";
        const sym = suitSyms[suit] || suit || "";
        return `
        <div style="display: flex; align-items: center; justify-content: center; gap: 10px; background: rgba(234, 179, 8, 0.12); border: 1px solid rgba(234, 179, 8, 0.45); border-radius: 8px; padding: 6px 14px; margin: 10px auto; max-width: 540px;">
          <div class="twisted-cut-card ${isRed ? "red card-red" : "black card-black"}" style="width: 32px; height: 46px; background: #ffffff !important; border: 2px solid #eab308; border-radius: 5px; display: flex; flex-direction: column; justify-content: center; align-items: center; font-weight: 900; line-height: 1; box-shadow: 0 2px 6px rgba(0,0,0,0.3);">
            <span class="twisted-cut-rank" style="font-size: 0.78rem; color: ${color}; -webkit-text-fill-color: ${color};">${r}</span>
            <span class="twisted-cut-suit" style="font-size: 0.92rem; color: ${color}; -webkit-text-fill-color: ${color};">${sym}</span>
          </div>
          <div style="text-align: left;">
            <div style="font-size: 0.85rem; color: #fde047; font-weight: 800;">Starter Cut Card: <span style="font-weight: 900; color: ${color}; -webkit-text-fill-color: ${color};">${r}${sym}</span></div>
            <div style="font-size: 0.74rem; color: #cbd5e1;">\u26A0\uFE0F 5-Card Flush Rule: Flushes in either hand require all 5 cards (4 in hand + cut) matching suit.</div>
          </div>
        </div>
      `;
      }
      function renderModalContent() {
        const s1 = hand1.length === 4 ? Scorer.scoreHand(hand1, starterArg, true, scoreOpts) : { total: 0, notes: [] };
        const s2 = hand2.length === 4 ? Scorer.scoreHand(hand2, starterArg, true, { ...scoreOpts, dealerHand: hand1 }) : { total: 0, notes: [] };
        const totalPts = s1.total + s2.total;
        const formatNotesList = (notes) => {
          if (!notes || !notes.length) return '<span style="color:#64748b;">No combinations</span>';
          return notes.map((n) => `<span style="display:inline-block; margin-right:8px; color:#cbd5e1;">${n}</span>`).join("\xB7 ");
        };
        const h1CardsHtml = hand1.map((c, i) => renderSingleCard(c, 1, i, selected && selected.handNum === 1 && selected.idx === i)).join("");
        const h2CardsHtml = hand2.map((c, i) => renderSingleCard(c, 2, i, selected && selected.handNum === 2 && selected.idx === i)).join("");
        return `
        <div class="twisted-modal-box">
          <div class="twisted-badge">\u{1F300} TWISTED CRIBBAGE \u2014 DEALER COUNT</div>
          <h2 class="twisted-modal-title">Arrange Your 8 Cards into Two 4-Card Hands</h2>
          <div class="twisted-modal-subtitle">
            ${pName2(dealerSeat)}, combine all 8 cards from your hand and crib to maximize your combined score!
          </div>

          ${renderCutCardBadge()}

          <div class="twisted-scoreboard">
            <div style="text-align:right;">
              <div style="font-size:0.78rem; text-transform:uppercase; color:#94a3b8; font-weight:700;">Hand 1 (Dealer)</div>
              <div style="font-size:1.4rem; font-weight:800; color:#60a5fa;">+${s1.total} pts</div>
            </div>
            <div style="font-size:1.8rem; font-weight:900; color:#64748b;">+</div>
            <div style="text-align:left;">
              <div style="font-size:0.78rem; text-transform:uppercase; color:#94a3b8; font-weight:700;">Hand 2 (Crib)</div>
              <div style="font-size:1.4rem; font-weight:800; color:#c084fc;">+${s2.total} pts</div>
            </div>
            <div style="font-size:1.8rem; font-weight:900; color:#64748b;">=</div>
            <div style="border-left:2px solid rgba(255,255,255,0.15); padding-left:16px; text-align:left;">
              <div style="font-size:0.78rem; text-transform:uppercase; color:#fde047; font-weight:800; letter-spacing:0.05em;">COMBINED TOTAL</div>
              <div class="twisted-score-total">${totalPts} PTS</div>
            </div>
          </div>

          ${toastMsg ? `<div style="margin: 6px auto 10px; color:#38bdf8; font-weight:700; font-size:0.85rem;">${toastMsg}</div>` : ""}

          <div style="font-size: 0.78rem; color: #94a3b8; margin-bottom: 8px;">
            \u{1F4A1} <em>Click a card in each hand to swap them.</em>
          </div>

          <div class="twisted-hands-grid">
            <div class="twisted-hand-panel hand-1">
              <div class="twisted-hand-header">
                <span class="twisted-hand-name">HAND 1 (DEALER)</span>
                <span class="twisted-hand-pts">${s1.total} pts</span>
              </div>
              <div class="twisted-cards-row">
                ${h1CardsHtml}
              </div>
              <div class="twisted-notes">
                ${formatNotesList(s1.notes)}
              </div>
            </div>

            <div class="twisted-hand-panel hand-2">
              <div class="twisted-hand-header">
                <span class="twisted-hand-name">HAND 2 (CRIB)</span>
                <span class="twisted-hand-pts">${s2.total} pts</span>
              </div>
              <div class="twisted-cards-row">
                ${h2CardsHtml}
              </div>
              <div class="twisted-notes">
                ${formatNotesList(s2.notes)}
              </div>
            </div>
          </div>

          <div class="twisted-actions">
            <button type="button" class="btn-twisted-best" id="btnTwistedAutoBest" data-action="twisted-best">
              \u26A1 Auto Best Split
            </button>
            <button type="button" class="btn-ghost" id="btnTwistedReset" data-action="twisted-reset" style="padding:10px 18px; border-radius:8px; color:#cbd5e1;">
              \u21BA Original Hands
            </button>
            <button type="button" class="btn-twisted-confirm" id="btnTwistedConfirm" data-action="twisted-confirm">
              \u2714 Confirm Hands (+${totalPts} pts)
            </button>
          </div>
        </div>
      `;
      }
      const handleTwistedClick = (e) => {
        const cardEl2 = e.target.closest('[data-action="twisted-card"], .twisted-card');
        if (cardEl2 && cardEl2.dataset.hand !== void 0 && cardEl2.dataset.index !== void 0) {
          const handNum = parseInt(cardEl2.dataset.hand, 10);
          const idx = parseInt(cardEl2.dataset.index, 10);
          if (typeof window.onTwistedCardClick === "function") {
            window.onTwistedCardClick(handNum, idx);
          }
          return;
        }
        const bestBtn = e.target.closest('#btnTwistedAutoBest, [data-action="twisted-best"]');
        if (bestBtn) {
          if (typeof window.onTwistedAutoBest === "function") {
            window.onTwistedAutoBest();
          }
          return;
        }
        const resetBtn = e.target.closest('#btnTwistedReset, [data-action="twisted-reset"]');
        if (resetBtn) {
          if (typeof window.onTwistedReset === "function") {
            window.onTwistedReset();
          }
          return;
        }
        const confirmBtn = e.target.closest('#btnTwistedConfirm, [data-action="twisted-confirm"]');
        if (confirmBtn) {
          if (typeof window.onTwistedConfirm === "function") {
            window.onTwistedConfirm();
          }
          return;
        }
      };
      function refreshModal() {
        const container = typeof document !== "undefined" ? document.getElementById("modalContent") || document.getElementById("modal") : null;
        if (container) {
          container.innerHTML = renderModalContent();
        } else {
          showModal2(renderModalContent(), false);
        }
      }
      window.onTwistedCardClick = (handNum, idx) => {
        toastMsg = "";
        if (!selected) {
          selected = { handNum, idx };
        } else if (selected.handNum === handNum && selected.idx === idx) {
          selected = null;
        } else if (selected.handNum === handNum) {
          selected = { handNum, idx };
        } else {
          const idx1 = selected.handNum === 1 ? selected.idx : idx;
          const idx2 = selected.handNum === 2 ? selected.idx : idx;
          const temp = hand1[idx1];
          hand1[idx1] = hand2[idx2];
          hand2[idx2] = temp;
          selected = null;
        }
        refreshModal();
      };
      window.onTwistedAutoBest = () => {
        const optimal = Scorer.findOptimalTwistedSplit(all8, starterArg, settings3);
        if (optimal && optimal.hand1 && optimal.hand2) {
          hand1 = [...optimal.hand1];
          hand2 = [...optimal.hand2];
          selected = null;
          toastMsg = `\u2728 Optimal split loaded (+${optimal.total} pts)!`;
          refreshModal();
        }
      };
      window.onTwistedReset = () => {
        hand1 = all8.slice(0, 4);
        hand2 = all8.slice(4, 8);
        selected = null;
        toastMsg = "\u21BA Reset to original hand & crib.";
        refreshModal();
      };
      window.onTwistedConfirm = () => {
        const container = typeof document !== "undefined" ? document.getElementById("modalContent") || document.getElementById("modal") : null;
        if (container) {
          container.removeEventListener("click", handleTwistedClick);
        }
        delete window.onTwistedCardClick;
        delete window.onTwistedAutoBest;
        delete window.onTwistedReset;
        delete window.onTwistedConfirm;
        hideModal3();
        resolveTwistedCribbageSplit2(hand1, hand2, actIdx, context);
      };
      showModal2(renderModalContent(), false);
      const modalContainer = typeof document !== "undefined" ? document.getElementById("modalContent") || document.getElementById("modal") : null;
      if (modalContainer) {
        modalContainer.addEventListener("click", handleTwistedClick);
      }
    }
    /**
     * Resolves the dealer's Twisted Cribbage split, updates hands, scores, and advances the show act.
     * @param {Array} hand1
     * @param {Array} hand2
     * @param {number} actIdx
     * @param {Object} [context]
     */
    static resolveTwistedCribbageSplit(hand1, hand2, actIdx, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const setSeatKept2 = context.setSeatKept || (typeof window !== "undefined" && typeof window.setSeatKept === "function" ? window.setSeatKept : null);
      const pName2 = context.pName || (typeof window !== "undefined" && typeof window.pName === "function" ? window.pName : (s) => s);
      const seatName3 = context.seatName || (typeof window !== "undefined" && typeof window.seatName === "function" ? window.seatName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" && typeof window.log === "function" ? window.log : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" && typeof window.fancyCall === "function" ? window.fancyCall : () => {
      });
      const render2 = context.render || (typeof window !== "undefined" && typeof window.render === "function" ? window.render : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" && typeof window.netPush === "function" ? window.netPush : () => {
      });
      const beginShowAct2 = context.beginShowAct || (typeof window !== "undefined" && typeof window.beginShowAct === "function" ? window.beginShowAct : _ShowModal.beginShowAct);
      const dealerSeat = state3.dealer === "you" ? "p1" : state3.dealer === "cpu" ? "p2" : state3.dealer;
      const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
      const starterArg = starters.length > 1 ? starters : state3.starter;
      const Scorer = typeof CC !== "undefined" && CC?.CribbageScorer || (typeof window !== "undefined" ? window.CribbageScorer : null) || CribbageScorer2;
      const scoreOpts = { ...settings3, optFiveCardFlushOnly: true };
      const score1 = Scorer.scoreHand(hand1, starterArg, true, scoreOpts);
      const score2 = Scorer.scoreHand(hand2, starterArg, true, { ...scoreOpts, dealerHand: hand1 });
      state3.twistedCribbageResolved = true;
      if (typeof setSeatKept2 === "function") {
        setSeatKept2(dealerSeat, hand1, state3);
      } else if (state3.seatKept) {
        state3.seatKept[dealerSeat] = hand1;
      }
      state3.crib = hand2;
      const pegOnly = settings3.target === 31;
      const isShotgun = Boolean(settings3 && settings3.optShotgunCribbage);
      const cribSigned = pegOnly || isShotgun ? 0 : settings3.optRockCrib ? -score2.total : score2.total;
      if (!state3.lastShow) state3.lastShow = {};
      state3.lastShow.dealer = {
        title: `${pName2(dealerSeat)} hand (Twisted 1/2)`,
        cards: hand1,
        starter: state3.starter,
        starters,
        score: score1,
        signed: score1.total,
        who: dealerSeat
      };
      state3.lastShow.crib = {
        title: isShotgun ? "Crib (Shotgun Cribbage)" : "Crib (Twisted 2/2)",
        cards: hand2,
        starter: state3.starter,
        starters,
        score: score2,
        signed: cribSigned,
        who: dealerSeat
      };
      const totalPts = score1.total + score2.total;
      log2(`\u{1F300} Twisted Cribbage: ${seatName3(dealerSeat)} arranged 8 cards into two hands (+${score1.total} & +${score2.total} = ${totalPts} pts)!`);
      fancyCall2(`Twisted: +${totalPts} pts!`, "fifteen", 1200);
      netPush2({
        op: "twistedCribbageSplit",
        hand1,
        hand2,
        totalPts
      });
      render2();
      beginShowAct2(actIdx, context);
    }
    /**
     * Displays the interactive Muggins manual hand/crib counting modal for human players.
     * @param {string} key 'pone', 'dealer', or 'crib'
     * @param {Object} pack
     * @param {number} actIdx
     * @param {Object} [context]
     */
    static openMugginsCountPrompt(key, pack, actIdx, context = {}) {
      const showModal2 = context.showModal || (typeof window !== "undefined" ? window.showModal : () => {
      });
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : () => {
      });
      const beginShowAct2 = context.beginShowAct || (typeof window !== "undefined" ? window.beginShowAct : _ShowModal.beginShowAct);
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : (s) => s);
      const isCrib = key === "crib";
      const cards = pack.cards || [];
      const starters = pack.starters && pack.starters.length ? pack.starters : pack.starter ? [pack.starter] : [];
      const suitSyms = { H: "\u2665", D: "\u2666", S: "\u2660", C: "\u2663" };
      const rankNames = { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" };
      const renderCard = (c, isCut = false) => {
        if (!c) return "";
        const suit = c.suit || c.s || "S";
        const isRed = suit === "H" || suit === "D";
        const color = isRed ? "#dc2626 !important" : "#111827 !important";
        const r = c.rankName || c.r || rankNames[c.rank] || c.rank || "\u2605";
        const s = suitSyms[suit] || suit || "";
        return `
        <div style="position: relative; width: 56px; height: 80px; box-sizing: border-box; background: #ffffff !important; border: 2px solid ${isCut ? "#eab308" : "#cbd5e1"}; border-radius: 6px; display: flex; flex-direction: column; justify-content: space-between; padding: 4px 5px; box-shadow: 0 3px 8px rgba(0,0,0,0.35); text-align: left;">
          <div style="font-size: 0.95rem; font-weight: 900; color: ${color}; -webkit-text-fill-color: ${color}; line-height: 1;">${r}<span style="font-size: 0.78rem; margin-left: 2px;">${s}</span></div>
          <div style="font-size: 1.5rem; color: ${color}; -webkit-text-fill-color: ${color}; line-height: 1; text-align: center;">${s}</div>
          <div style="font-size: 0.58rem; font-weight: 800; color: ${isCut ? "#ca8a04" : "transparent"}; -webkit-text-fill-color: ${isCut ? "#ca8a04" : "transparent"}; text-align: center; text-transform: uppercase;">${isCut ? "CUT" : ""}</div>
        </div>
      `;
      };
      const cardsHtml = cards.map((c) => renderCard(c, false)).join("");
      const starterHtml = starters.map((s) => renderCard(s, true)).join("");
      const html2 = `
      <div class="muggins-count-box" style="max-width: 480px; width: 100%; margin: 0 auto; text-align: center; color: #f4ead4; font-family: inherit;">
        <div style="display: inline-flex; align-items: center; justify-content: center; width: 44px; height: 44px; border-radius: 50%; background: linear-gradient(135deg, #f0c64a, #d4a017); color: #1a1208; font-size: 1.5rem; margin-bottom: 8px;">\u26A1</div>
        <h2 style="margin: 0 0 4px; font-size: 1.3rem; font-weight: 800; color: #f0c64a; letter-spacing: 0.03em;">
          MUGGINS: COUNT YOUR ${isCrib ? "CRIB" : "HAND"}
        </h2>
        <p style="margin: 0 0 12px; font-size: 0.84rem; color: #cbd5e1; line-height: 1.4;">
          ${pName2(pack.who)}, examine your cards and the starter card${starters.length > 1 ? "s" : ""} below.
          <br><span style="color: #f87171; font-weight: 600;">\u26A0\uFE0F If you undercount, your opponent can call Muggins and steal the missed points!</span>
        </p>

        <!-- Cards Display (Hand + Cut Starter) -->
        <div style="display: flex; justify-content: center; align-items: center; gap: 6px; margin-bottom: 14px; flex-wrap: wrap;">
          <div style="display: flex; gap: 5px; justify-content: center; flex-wrap: wrap;">
            ${cardsHtml}
          </div>
          ${starterHtml ? `
            <div style="display: flex; align-items: center; margin: 0 4px; color: #ca8a04; font-size: 1.2rem; font-weight: 800;">+</div>
            <div style="display: flex; gap: 5px; justify-content: center; flex-wrap: wrap;">${starterHtml}</div>
          ` : ""}
        </div>

        <!-- Point Input & Stepper -->
        <div style="display: flex; align-items: center; justify-content: center; gap: 10px; margin-bottom: 12px;">
          <button type="button" id="btnMugginsDec" style="width: 42px; height: 42px; font-size: 1.4rem; font-weight: 800; border-radius: 8px; border: 1.5px solid rgba(255,255,255,0.25); background: rgba(255,255,255,0.08); color: #f4ead4; cursor: pointer;">\u2212</button>
          <input type="number" id="mugginsCountInp" min="0" max="60" value="0"
                 style="width: 80px; height: 42px; font-size: 1.7rem; font-weight: 900; text-align: center; border-radius: 8px; border: 2px solid #f0c64a; background: rgba(0,0,0,0.6); color: #f0c64a !important; -webkit-text-fill-color: #f0c64a !important; outline: none;">
          <button type="button" id="btnMugginsInc" style="width: 42px; height: 42px; font-size: 1.4rem; font-weight: 800; border-radius: 8px; border: 1.5px solid rgba(255,255,255,0.25); background: rgba(255,255,255,0.08); color: #f4ead4; cursor: pointer;">+</button>
        </div>

        <!-- Quick Select Chips -->
        <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 6px; margin-bottom: 16px;">
          ${[0, 2, 4, 6, 7, 8, 9, 10, 12, 14, 15, 16, 20].map((n) => `
            <button type="button" class="muggins-count-chip" data-val="${n}"
                    style="padding: 4px 10px; font-size: 0.84rem; font-weight: 700; border-radius: 14px; border: 1px solid rgba(255,255,255,0.2); background: rgba(255,255,255,0.06); color: #f4ead4; cursor: pointer;">
              ${n}
            </button>
          `).join("")}
        </div>

        <!-- Action Buttons -->
        <div style="display: flex; gap: 10px; justify-content: center;">
          <button type="button" id="btnMugginsClaimCount" class="btn-gold"
                  style="padding: 10px 22px; font-size: 0.96rem; font-weight: 800; border-radius: 8px; cursor: pointer; box-shadow: 0 4px 12px rgba(240,198,74,0.35);">
            Claim <span id="mugginsClaimVal">0</span> Points
          </button>
          <button type="button" id="btnMugginsAutoCount" class="btn-ghost"
                  style="padding: 10px 14px; font-size: 0.84rem; font-weight: 600; border-radius: 8px; border: 1.5px solid rgba(255,255,255,0.2); background: rgba(255,255,255,0.08); color: #a8a29e; cursor: pointer;"
                  title="Auto-count without claiming">
            Auto-Count
          </button>
        </div>
      </div>
    `;
      showModal2(html2, false);
      if (typeof document === "undefined") return;
      const inp = document.getElementById("mugginsCountInp");
      const claimValSpan = document.getElementById("mugginsClaimVal");
      const btnDec = document.getElementById("btnMugginsDec");
      const btnInc = document.getElementById("btnMugginsInc");
      const chips = document.querySelectorAll(".muggins-count-chip");
      const btnClaim = document.getElementById("btnMugginsClaimCount");
      const btnAuto = document.getElementById("btnMugginsAutoCount");
      const updateVal = (newVal) => {
        let v = Math.max(0, Math.min(60, parseInt(newVal, 10) || 0));
        if (inp) inp.value = v;
        if (claimValSpan) claimValSpan.textContent = v;
        chips.forEach((c) => {
          const cv = parseInt(c.dataset.val, 10);
          if (cv === v) {
            c.style.background = "#f0c64a";
            c.style.color = "#000";
            c.style.borderColor = "#f0c64a";
          } else {
            c.style.background = "rgba(255,255,255,0.06)";
            c.style.color = "#f4ead4";
            c.style.borderColor = "rgba(255,255,255,0.2)";
          }
        });
      };
      if (btnDec) btnDec.addEventListener("click", () => updateVal(parseInt(inp.value, 10) - 1));
      if (btnInc) btnInc.addEventListener("click", () => updateVal(parseInt(inp.value, 10) + 1));
      if (inp) {
        inp.addEventListener("input", () => updateVal(inp.value));
        inp.addEventListener("keydown", (e) => {
          if (e.key === "Enter" && btnClaim) btnClaim.click();
        });
      }
      chips.forEach((c) => {
        c.addEventListener("click", () => updateVal(c.dataset.val));
      });
      if (btnClaim) {
        btnClaim.addEventListener("click", () => {
          const val = parseInt(inp ? inp.value : 0, 10) || 0;
          hideModal3();
          pack.mugginsCountResolved = true;
          pack.claimedPoints = val;
          beginShowAct2(actIdx, context);
        });
      }
      if (btnAuto) {
        btnAuto.addEventListener("click", () => {
          hideModal3();
          pack.mugginsCountResolved = true;
          pack.claimedPoints = pack.score.total;
          beginShowAct2(actIdx, context);
        });
      }
    }
    /**
     * Dispatches online intent or resolves guess locally.
     * @param {number} val
     * @param {number} actIdx
     * @param {Object} [context]
     */
    static sendStolenCribGuess(val, actIdx, context = {}) {
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const netSend2 = context.netSend || (typeof window !== "undefined" ? window.netSend : () => {
      });
      const showWait2 = context.showWait || (typeof window !== "undefined" ? window.showWait : () => {
      });
      const resolveStolenCribGuess2 = context.resolveStolenCribGuess || (typeof window !== "undefined" ? window.resolveStolenCribGuess : _ShowModal.resolveStolenCribGuess);
      if (isOnline2() && settings3.netRole === "guest") {
        netSend2({ type: "intent", op: "stolenCribGuess", guess: val });
        showWait2("Guess submitted! Waiting for result\u2026");
        return;
      }
      resolveStolenCribGuess2(val, actIdx, context);
    }
    /**
     * Evaluates Stolen Crib guess and applies bonus score reassignment.
     * @param {number} guess
     * @param {number} actIdx
     * @param {Object} [context]
     */
    static resolveStolenCribGuess(guess, actIdx, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const famousFanfare2 = context.famousFanfare || (typeof window !== "undefined" ? window.famousFanfare : _ShowModal.famousFanfare);
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const beginShowAct2 = context.beginShowAct || (typeof window !== "undefined" ? window.beginShowAct : _ShowModal.beginShowAct);
      const cribPack = state3.lastShow && state3.lastShow.crib;
      if (!cribPack) {
        state3.stolenCribResolved = true;
        beginShowAct2(actIdx, context);
        return;
      }
      const dealerSeat = cribPack.who;
      const poneSeat = dealerSeat === "p1" ? "p2" : "p1";
      const actual = cribPack.score.total;
      const success = guess === actual;
      state3.stolenCrib = {
        guess,
        actual,
        pone: poneSeat,
        dealer: dealerSeat,
        success
      };
      state3.stolenCribResolved = true;
      if (success) {
        cribPack.who = poneSeat;
        cribPack.stolen = true;
        cribPack.stolenBy = poneSeat;
        cribPack.title = "Stolen Crib (" + seatName3(poneSeat) + ")";
        log2(`STOLEN CRIB! ${seatName3(poneSeat)} correctly guessed ${guess} pts and STOLE the crib!`);
        fancyCall2(`Crib Stolen! (${guess} pts)`, "famous", 2800);
        famousFanfare2(actual);
        netPush2({
          fancy: { text: `Crib Stolen! (${guess} pts)`, kind: "famous", ms: 2800 },
          sfx: "fanfare20"
        });
      } else {
        cribPack.stolen = false;
        log2(`${seatName3(poneSeat)} guessed ${guess} pts for the crib (actual: ${actual}). Dealer keeps the crib.`);
        fancyCall2(`Crib Safe (${actual} pts)`, "", 2e3);
        netPush2({
          fancy: { text: `Crib Safe (Guessed ${guess})`, kind: "", ms: 2e3 }
        });
      }
      setTimeout(() => {
        beginShowAct2(actIdx, context);
      }, 900);
    }
    /**
     * Begins presentation of a specific hand/crib show act.
     * @param {number} i
     * @param {Object} [context]
     */
    static beginShowAct(i, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3) return;
      const setShowMeter2 = context.setShowMeter || (typeof window !== "undefined" ? window.setShowMeter : _ShowModal.setShowMeter);
      const openShowModal2 = context.openShowModal || (typeof window !== "undefined" ? window.openShowModal : _ShowModal.open);
      if (state3.over) {
        state3.showModal = null;
        state3.showMeter = null;
        if (typeof setShowMeter2 === "function") setShowMeter2("", 0, "");
        if (typeof document !== "undefined") {
          const m = document.getElementById("showMeter");
          if (m) m.classList.add("hidden");
        }
        const checkGameOverFn = context.checkGameOver || (typeof window !== "undefined" ? window.checkGameOver : null);
        if (typeof checkGameOverFn === "function") checkGameOverFn(context);
        return;
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const getPlayerCount2 = context.getPlayerCount || (typeof window !== "undefined" ? window.getPlayerCount : () => 2);
      const render2 = context.render || (typeof window !== "undefined" ? window.render : () => {
      });
      const getSeat2 = context.getSeat || (typeof window !== "undefined" ? window.getSeat : () => ({}));
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" && typeof window.isSeatHuman === "function" ? window.isSeatHuman : ((s) => s === "p1"));
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const openStolenCribPrompt2 = context.openStolenCribPrompt || (typeof window !== "undefined" ? window.openStolenCribPrompt : _ShowModal.openStolenCribPrompt);
      const showWait2 = context.showWait || (typeof window !== "undefined" ? window.showWait : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const cpuGuessCrib2 = context.cpuGuessCrib || (typeof window !== "undefined" ? window.cpuGuessCrib : () => 4);
      const resolveStolenCribGuess2 = context.resolveStolenCribGuess || (typeof window !== "undefined" ? window.resolveStolenCribGuess : _ShowModal.resolveStolenCribGuess);
      const resetAnims2 = context.resetAnims || (typeof window !== "undefined" ? window.resetAnims : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const finishShowAct2 = context.finishShowAct || (typeof window !== "undefined" ? window.finishShowAct : _ShowModal.finishShowAct);
      const tickShowLine2 = context.tickShowLine || (typeof window !== "undefined" ? window.tickShowLine : _ShowModal.tickShowLine);
      const keys = state3.showQueue || [];
      if (i >= keys.length) {
        state3.showAct = "done";
        state3.highlightIds = [];
        state3.showMeter = null;
        setShowMeter2("", 0, "");
        if (typeof document !== "undefined") {
          const m = document.getElementById("showMeter");
          if (m) m.classList.add("hidden");
        }
        if (settings3.optChutesAndLadders) {
          const checkChutesAndLadders2 = context.checkChutesAndLadders || (typeof window !== "undefined" ? window.checkChutesAndLadders : GameEngine2.checkChutesAndLadders);
          if (typeof checkChutesAndLadders2 === "function") {
            checkChutesAndLadders2(state3, settings3, context);
          }
        }
        if (state3.over) {
          state3.showModal = null;
          const checkGameOverFn = context.checkGameOver || (typeof window !== "undefined" ? window.checkGameOver : null);
          if (typeof checkGameOverFn === "function") checkGameOverFn(context);
          return;
        }
        openShowModal2(false, context);
        return;
      }
      const key = keys[i];
      if (key === "crib" && settings3.optStolenCrib && getPlayerCount2() === 2 && !state3.stolenCribResolved) {
        state3.revealCrib = false;
        render2();
        const dealerSeat = state3.dealer === "you" ? "p1" : state3.dealer === "cpu" ? "p2" : state3.dealer;
        const poneSeat = dealerSeat === "p1" ? "p2" : "p1";
        const poneSeatObj = getSeat2(poneSeat);
        const isPoneHuman = poneSeatObj && poneSeatObj.type === "human";
        if (isOnline2()) {
          const isGuestPone = settings3.netRole === "guest" && poneSeat === "p2";
          const isHostPone = settings3.netRole === "host" && poneSeat === "p1";
          if (isGuestPone || isHostPone) {
            openStolenCribPrompt2(poneSeat, dealerSeat, i, context);
          } else {
            showWait2(`Waiting for ${seatName3(poneSeat)}'s Stolen Crib guess\u2026`);
          }
          return;
        }
        if (isPoneHuman) {
          openStolenCribPrompt2(poneSeat, dealerSeat, i, context);
          return;
        } else {
          const cpuName = seatName3(poneSeat);
          fancyCall2(`${cpuName} guessing crib\u2026`, "", 1e3);
          setTimeout(() => {
            const guess = cpuGuessCrib2(poneSeat, dealerSeat);
            resolveStolenCribGuess2(guess, i, context);
          }, 1100);
          return;
        }
      }
      if (key === "dealer" && settings3.optTwistedCribbage && getPlayerCount2() === 2 && !state3.twistedCribbageResolved) {
        render2();
        const dealerSeat = state3.dealer === "you" ? "p1" : state3.dealer === "cpu" ? "p2" : state3.dealer;
        const dealerSeatObj = getSeat2(dealerSeat);
        const isDealerHuman = isSeatHuman2 ? isSeatHuman2(dealerSeat) : dealerSeatObj && dealerSeatObj.type === "human";
        const is3D = Boolean(
          settings3 && (settings3.boardViewMode === "3d" || settings3.boardViewMode === "room3d" || settings3.boardViewMode === "room3d-fullscreen") || typeof window !== "undefined" && window.settings && (window.settings.boardViewMode === "3d" || window.settings.boardViewMode === "room3d" || window.settings.boardViewMode === "room3d-fullscreen") || typeof document !== "undefined" && (document.getElementById("board3DCanvas") || document.getElementById("room3dCanvas") || document.querySelector(".board-3d-wrap") || document.querySelector(".room3d-wrap"))
        );
        const openTwistedCribbageModalFn = context.openTwistedCribbageModal || (typeof window !== "undefined" ? window.openTwistedCribbageModal : _ShowModal.openTwistedCribbageModal);
        const resolveTwistedCribbageSplitFn = context.resolveTwistedCribbageSplit || (typeof window !== "undefined" ? window.resolveTwistedCribbageSplit : _ShowModal.resolveTwistedCribbageSplit);
        if (is3D) {
          const dealerName = seatName3(dealerSeat);
          fancyCall2(`${dealerName} arranging best split\u2026`, "", 1e3);
          setTimeout(() => {
            const getSeatKeptFn = context.getSeatKept || (typeof window !== "undefined" ? window.getSeatKept : () => []);
            const combined = state3.twisted8Cards && state3.twisted8Cards.length === 8 ? state3.twisted8Cards : [...getSeatKeptFn(dealerSeat) || [], ...state3.crib || []];
            const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
            const starterArg = starters.length > 1 ? starters : state3.starter;
            const Scorer = typeof CC !== "undefined" && CC?.CribbageScorer || (typeof window !== "undefined" ? window.CribbageScorer : null) || CribbageScorer2;
            const optimal = Scorer && typeof Scorer.findOptimalTwistedSplit === "function" ? Scorer.findOptimalTwistedSplit(combined, starterArg, settings3) : { hand1: combined.slice(0, 4), hand2: combined.slice(4, 8) };
            resolveTwistedCribbageSplitFn(optimal.hand1, optimal.hand2, i, context);
          }, 600);
          return;
        }
        if (isOnline2()) {
          const isGuestDealer = settings3.netRole === "guest" && dealerSeat === "p2";
          const isHostDealer = settings3.netRole === "host" && dealerSeat === "p1";
          if (isGuestDealer || isHostDealer) {
            openTwistedCribbageModalFn(dealerSeat, i, context);
          } else {
            showWait2(`Waiting for ${seatName3(dealerSeat)} to arrange Twisted Cribbage hands\u2026`);
          }
          return;
        }
        if (isDealerHuman) {
          openTwistedCribbageModalFn(dealerSeat, i, context);
          return;
        } else {
          const cpuName = seatName3(dealerSeat);
          fancyCall2(`${cpuName} calculating best split\u2026`, "", 1e3);
          setTimeout(() => {
            const getSeatKeptFn = context.getSeatKept || (typeof window !== "undefined" ? window.getSeatKept : () => []);
            const combined = state3.twisted8Cards && state3.twisted8Cards.length === 8 ? state3.twisted8Cards : [...getSeatKeptFn(dealerSeat) || [], ...state3.crib || []];
            const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
            const starterArg = starters.length > 1 ? starters : state3.starter;
            const Scorer = typeof CC !== "undefined" && CC?.CribbageScorer || (typeof window !== "undefined" ? window.CribbageScorer : null) || CribbageScorer2;
            const optimal = Scorer && typeof Scorer.findOptimalTwistedSplit === "function" ? Scorer.findOptimalTwistedSplit(combined, starterArg, settings3) : { hand1: combined.slice(0, 4), hand2: combined.slice(4, 8) };
            resolveTwistedCribbageSplitFn(optimal.hand1, optimal.hand2, i, context);
          }, 1100);
          return;
        }
      }
      state3.showAct = key;
      state3.showRun = 0;
      if (key === "crib") {
        state3.revealCrib = true;
        resetAnims2();
      }
      const pack = state3.lastShow[key];
      const isShowingHuman = isSeatHuman2(pack.who);
      if (key === "crib" && settings3.optShotgunCribbage) {
        state3.showMeter = { act: pack.title, total: 0, line: "Shotgun Cribbage: Dealer does not count crib points" };
        _ShowModal.renderShowCountModal(pack, i, context);
        setShowMeter2(pack.title, 0, "Shotgun Cribbage: Dealer does not count crib points");
        fancyCall2("Shotgun: Crib Not Counted", "go", 1200);
        render2();
        netPush2({ fancy: { text: "Shotgun: Crib Not Counted", kind: "go", ms: 1200 } });
        setTimeout(() => {
          if (state3 && state3.over) return;
          finishShowAct2(i, context);
        }, 1200);
        return;
      }
      const isMuggins = Boolean(settings3.optMuggins || settings3.showDetail === "muggins");
      if (isMuggins && isShowingHuman && !pack.mugginsCountResolved) {
        render2();
        _ShowModal.openMugginsCountPrompt(key, pack, i, context);
        return;
      }
      state3.showMeter = { act: pack.title, total: 0, line: "Flipping\u2026" };
      _ShowModal.renderShowCountModal(pack, i, context);
      setShowMeter2(pack.title, 0, "Flipping\u2026");
      const actCallout = key === "crib" ? "The Crib" : pack.title || (key === "pone" ? "Pone\u2019s Hand" : "Dealer\u2019s Hand");
      fancyCall2(actCallout, "", 700);
      render2();
      netPush2({ fancy: { text: actCallout, kind: "", ms: 700 } });
      const introDelay = i === 0 ? 1200 : 700;
      if ((settings3.showDetail || "highlight") === "totals") {
        setTimeout(() => {
          if (state3 && state3.over) return;
          finishShowAct2(i, context);
        }, i === 0 ? 900 : 500);
      } else {
        setTimeout(() => {
          if (state3 && state3.over) return;
          tickShowLine2(i, 0, context);
        }, introDelay);
      }
    }
    /**
     * Completes a show act, evaluates zone blocks, serves penalties, and advances to next act.
     * @param {number} actIdx
     * @param {Object} [context]
     */
    static finishShowAct(actIdx, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.phase !== "show") return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const scoreKey2 = context.scoreKey || (typeof window !== "undefined" ? window.scoreKey : (s) => s);
      const isInPegThroughZone3 = context.isInPegThroughZone || (typeof window !== "undefined" ? window.isInPegThroughZone : () => false);
      const isInLast5PegOut3 = context.isInLast5PegOut || (typeof window !== "undefined" ? window.isInLast5PegOut : () => false);
      const isInBunker3 = context.isInBunker || (typeof window !== "undefined" ? window.isInBunker : () => false);
      const applyHighlights2 = context.applyHighlights || (typeof window !== "undefined" ? window.applyHighlights : () => {
      });
      const setShowMeter2 = context.setShowMeter || (typeof window !== "undefined" ? window.setShowMeter : _ShowModal.setShowMeter);
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : (s) => s);
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : () => {
      });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const famousFanfare2 = context.famousFanfare || (typeof window !== "undefined" ? window.famousFanfare : _ShowModal.famousFanfare);
      const addScore2 = context.addScore || (typeof window !== "undefined" ? window.addScore : () => {
      });
      const openShowModal2 = context.openShowModal || (typeof window !== "undefined" ? window.openShowModal : _ShowModal.open);
      const beginShowAct2 = context.beginShowAct || (typeof window !== "undefined" ? window.beginShowAct : _ShowModal.beginShowAct);
      const key = state3.showQueue[actIdx];
      const pack = state3.lastShow[key];
      const currentLeadPeg = state3.scores && state3.scores[scoreKey2(pack.who)] || 0;
      const inPegZone = settings3.optPegThroughZones && isInPegThroughZone3(currentLeadPeg);
      const inLast5 = settings3.optLast5PegOut && isInLast5PegOut3(currentLeadPeg);
      const inBunker = settings3.optBunkers && isInBunker3(currentLeadPeg);
      const isBlocked = inPegZone || inLast5 || inBunker;
      pack.blockedByZone = isBlocked;
      pack.blockedReason = inBunker ? "Bunker" : inLast5 ? "Last 5 Peg Out" : inPegZone ? "Peg Zone" : "";
      pack.leadPegWhenScored = currentLeadPeg;
      const total = isBlocked ? 0 : pack.signed;
      state3.highlightIds = [];
      applyHighlights2([]);
      if (isBlocked) {
        const t = Number(settings3.target) || 121;
        let zoneHoles = "";
        if (inBunker) {
          if (currentLeadPeg >= 1 && currentLeadPeg <= 5) zoneHoles = "1\u20135";
          else if (currentLeadPeg >= 50 && currentLeadPeg <= 60) zoneHoles = "50\u201360";
          else if (currentLeadPeg >= 80 && currentLeadPeg <= 90) zoneHoles = "80\u201390";
          else zoneHoles = `${t - 5}\u2013${t - 1}`;
        } else if (inLast5) {
          zoneHoles = `${t - 5}\u2013${t - 1}`;
        } else {
          zoneHoles = currentLeadPeg <= 40 ? "31\u201340" : currentLeadPeg <= 70 ? "61\u201370" : "91\u2013100";
        }
        const reasonLabel = pack.blockedReason;
        const note = `Hole ${currentLeadPeg} in ${reasonLabel} (${zoneHoles}) \u2014 0 pts`;
        state3.showMeter = { act: pack.title, total: 0, line: note };
        setShowMeter2(pack.title, 0, note);
        log2(`${pName2(pack.who)} lead peg at hole ${currentLeadPeg} in ${reasonLabel} (${zoneHoles}) \u2014 ${key === "crib" ? "crib" : "hand"} (${pack.signed} pts) not counted.`);
        fancyCall2(`${reasonLabel}: 0 pts`, "go", 1200);
        renderScores2(true);
        netPush2({
          fancy: { text: `${reasonLabel} (${currentLeadPeg}) \u2014 0 pts`, kind: "go", ms: 1200 },
          sfx: "bell31"
        });
      } else {
        const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : ((s) => s === "p1"));
        const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : "p1") || "p1";
        const isShowingHuman = isSeatHuman2(pack.who);
        const isMuggins = Boolean(settings3.optMuggins || settings3.showDetail === "muggins");
        if (isMuggins && !isShowingHuman && total >= 3) {
          const profile = settings3.aiProfile || "shark";
          const missProb = profile === "gambler" ? 0.22 : profile === "turtler" ? 0.12 : 0.05;
          if (Math.random() < missProb) {
            const missedPts = Math.min(total, Math.random() < 0.65 ? 2 : total >= 6 ? 4 : 2);
            const declaredTotal = total - missedPts;
            state3.showMeter = { act: pack.title, total: declaredTotal, line: `Declared ${declaredTotal} pts` };
            setShowMeter2(pack.title, declaredTotal, `Declared ${declaredTotal} pts`);
            addScore2(pack.who, declaredTotal, (key === "crib" ? "crib: " : "hand: ") + (pack.score.notes.join(", ") || "0") + ` (missed ${missedPts} pts)`);
            renderScores2(true);
            _ShowModal.triggerMugginsPrompt({
              who: pack.who,
              claimant: mySeat3,
              missed: missedPts,
              declared: declaredTotal,
              total,
              actIdx,
              context
            });
            return;
          }
        }
        if (isMuggins && isShowingHuman && pack.claimedPoints !== void 0) {
          const claimed = Number(pack.claimedPoints) || 0;
          const actual = total;
          if (claimed < actual) {
            const missedPts = actual - claimed;
            state3.showMeter = { act: pack.title, total: claimed, line: `Claimed ${claimed} pts (${missedPts} uncounted)` };
            setShowMeter2(pack.title, claimed, `Claimed ${claimed} pts (${missedPts} uncounted)`);
            addScore2(pack.who, claimed, (key === "crib" ? "crib: " : "hand: ") + (pack.score.notes.join(", ") || "0") + ` (claimed ${claimed}, missed ${missedPts} pts)`);
            log2(`\u26A0\uFE0F ${pName2(pack.who)} claimed ${claimed} pts but held ${actual} pts (${missedPts} uncounted points)!`);
            const opponentSeat = pack.who === "p1" ? "p2" : "p1";
            const isOpponentHuman = isSeatHuman2(opponentSeat);
            if (isOpponentHuman) {
              renderScores2(true);
              _ShowModal.triggerMugginsPrompt({
                who: pack.who,
                claimant: opponentSeat,
                missed: missedPts,
                declared: claimed,
                total: actual,
                actIdx,
                context
              });
              return;
            } else {
              const profile = settings3.aiProfile || "shark";
              let catchProb = 0.85;
              if (["expert", "shark", "master"].includes(profile)) {
                catchProb = 0.9;
              } else if (["advanced", "turtler", "maverick"].includes(profile)) {
                catchProb = 0.75;
              } else if (["intermediate", "gambler", "regular"].includes(profile)) {
                catchProb = 0.55;
              } else if (["beginner", "rookie", "casual"].includes(profile)) {
                catchProb = 0.35;
              }
              if (Math.random() < catchProb) {
                setTimeout(() => {
                  log2(`\u26A1 MUGGINS! ${pName2(opponentSeat)} noticed your undercount and stole ${missedPts} points!`);
                  fancyCall2(`MUGGINS! ${pName2(opponentSeat)} STOLE ${missedPts} PTS!`, "muggins-steal", 2600);
                  addScore2(opponentSeat, missedPts, `Muggins steal from ${pName2(pack.who)}`);
                  renderScores2(true);
                }, 1e3);
              } else {
                setTimeout(() => {
                  log2(`\u23F3 ${pName2(opponentSeat)} failed to notice the undercount! The ${missedPts} uncounted points are lost.`);
                  fancyCall2(`Undercount missed! (${missedPts} pts lost)`, "", 2e3);
                }, 1e3);
              }
            }
          } else if (claimed > actual) {
            log2(`\u26A0\uFE0F OVERCOUNT FOUL: ${pName2(pack.who)} claimed ${claimed} pts but only holds ${actual} pts. Score capped at ${actual} pts.`);
            fancyCall2(`Overcount! Capped at ${actual} pts`, "go", 1800);
            state3.showMeter = { act: pack.title, total: actual, line: `Overcount: ${actual} pts max` };
            setShowMeter2(pack.title, actual, `Overcount: ${actual} pts max`);
            famousFanfare2(Math.abs(actual));
            addScore2(pack.who, actual, (key === "crib" ? "crib: " : "hand: ") + (pack.score.notes.join(", ") || "0") + ` (overcount claimed ${claimed})`);
          } else {
            log2(`\u2B50 PERFECT COUNT: ${pName2(pack.who)} accurately counted all ${actual} pts!`);
            fancyCall2(`Perfect Count! ${actual} pts`, "combo", 1800);
            state3.showMeter = { act: pack.title, total: actual, line: actual ? "Perfect Total" : "Zero points" };
            setShowMeter2(pack.title, actual, actual ? "Perfect Total" : "Zero points");
            famousFanfare2(Math.abs(actual));
            addScore2(pack.who, actual, (key === "crib" ? "crib: " : "hand: ") + (pack.score.notes.join(", ") || "0"));
          }
        } else {
          state3.showMeter = { act: pack.title, total, line: total ? "Total" : "No points" };
          setShowMeter2(pack.title, total, total ? "Total" : "No points");
          famousFanfare2(Math.abs(pack.score.total));
          addScore2(pack.who, total, (key === "crib" ? "crib: " : "hand: ") + (pack.score.notes.join(", ") || "0"));
        }
        if (typeof document !== "undefined") {
          const feed = document.getElementById("showComboFeed");
          if (feed) {
            const tot = document.createElement("div");
            tot.className = "show-combo-item total";
            tot.innerHTML = `<span><strong>Total</strong></span><span class="combo-pts">${total} pts</span>`;
            feed.appendChild(tot);
            feed.scrollTop = feed.scrollHeight;
          }
        }
        if (settings3.optJail && state3.jailed && state3.jailed[scoreKey2(pack.who)] && total === 0) {
          const sk = scoreKey2(pack.who);
          state3.jailed[sk].turnsRemaining--;
          state3.jailed[sk].step++;
          const left = state3.jailed[sk].turnsRemaining;
          const used = 3 - left;
          log2(`\u{1F512} JAILED: ${pName2(pack.who)} counted hand (0 pts) \u2014 Turn ${used} of 3 used (${left} remaining).`);
          fancyCall2(`MISSED TURN (${used} OF 3 USED)`, "jail", 1400);
          if (left === 0) {
            log2(`\u{1F513} FREEDOM: ${pName2(pack.who)} served 3 of 3 missed turns and returns to the pegging track at hole ${state3.jailed[sk].jailHole}!`);
            delete state3.jailed[sk];
            fancyCall2("RELEASED FROM JAIL!", "jail-free", 1400);
          }
          renderScores2(true);
        }
        if (settings3.optBar && state3.atBar && state3.atBar[scoreKey2(pack.who)] && total === 0) {
          const sk = scoreKey2(pack.who);
          state3.atBar[sk].turnsRemaining--;
          state3.atBar[sk].step++;
          const left = state3.atBar[sk].turnsRemaining;
          const used = 3 - left;
          log2(`\u{1F37B} AT THE BAR: ${pName2(pack.who)} counted hand (0 pts) \u2014 You lost a turn, take a drink \u2014 Turn ${used} of 3 used (${left} remaining).`);
          fancyCall2(`TAKE A DRINK (${used} OF 3 USED)`, "bar", 1500);
          if (left === 0) {
            log2(`\u{1F37A} TAB CLOSED: ${pName2(pack.who)} served 3 of 3 missed turns and leaves The Bar, returning to the pegging track at hole ${state3.atBar[sk].barHole}!`);
            delete state3.atBar[sk];
            fancyCall2("LEAVING THE BAR!", "bar-free", 1400);
          }
          renderScores2(true);
        }
        if (settings3.optTimeout && state3.inTimeout && state3.inTimeout[scoreKey2(pack.who)] && total === 0) {
          const sk = scoreKey2(pack.who);
          state3.inTimeout[sk].turnsRemaining--;
          state3.inTimeout[sk].step++;
          const left = state3.inTimeout[sk].turnsRemaining;
          const used = 3 - left;
          log2(`\u23F3 TIMEOUT: ${pName2(pack.who)} counted hand (0 pts) \u2014 You've been bad, you lose a turn \u2014 Turn ${used} of 3 used (${left} remaining).`);
          fancyCall2(`IN TIMEOUT (${used} OF 3 USED)`, "timeout", 1500);
          if (left === 0) {
            log2(`\u2728 TIMEOUT OVER: ${pName2(pack.who)} served 3 of 3 missed turns and leaves timeout, returning to the pegging track at hole ${state3.inTimeout[sk].timeoutHole}!`);
            delete state3.inTimeout[sk];
            fancyCall2("OUT OF TIMEOUT!", "timeout-free", 1400);
          }
          renderScores2(true);
        }
        renderScores2(true);
        netPush2({
          sfx: Math.abs(pack.score.total) >= 20 ? "fanfare20" : total ? "peg" : null,
          fancy: total ? { text: total + " Points!", kind: "famous", ms: 1e3 } : null
        });
        try {
          const repMgr = typeof window !== "undefined" && window.CrazyCribbage?.GameReplayManager || GameReplayManager || (typeof window !== "undefined" ? window.GameReplayManager : null);
          if (repMgr && repMgr.currentReplay && !pack._replayRecorded) {
            pack._replayRecorded = true;
            const isCrib = key === "crib";
            const whoKey = pack.who === "you" || pack.who === "p1" ? "p1" : pack.who === "cpu" || pack.who === "p2" ? "p2" : pack.who;
            const p1Score = state3.scores ? state3.scores.you ?? state3.scores.p1 ?? 0 : 0;
            const p2Score = state3.scores ? state3.scores.cpu ?? state3.scores.p2 ?? 0 : 0;
            const comboList = pack.score?.lines || pack.score?.items || pack.score?.notes || [];
            repMgr.recordEvent(isCrib ? "show_crib" : "show_hand", {
              round: (state3.handsCompleted || 0) + 1,
              who: whoKey,
              starter: state3.starter,
              cards: pack.cards ? [...pack.cards] : isCrib && state3.crib ? [...state3.crib] : [],
              points: total,
              combos: Array.isArray(comboList) ? [...comboList] : [],
              scores: { p1: p1Score, p2: p2Score },
              narration: `\u2B50 ${pName2(pack.who)} scored ${total} pts in ${isCrib ? "crib" : "hand"}`
            });
          }
        } catch (_) {
        }
      }
      const myKey = scoreKey2(pack.who);
      const newScore = state3.scores && state3.scores[myKey] || 0;
      const getActiveTracks3 = context.getActiveTracks || (typeof window !== "undefined" ? window.getActiveTracks : () => ["p1", "p2"]);
      const activeTracks = getActiveTracks3();
      const passedPlayers = [];
      for (const track of activeTracks) {
        if (track === myKey) continue;
        const otherScore = state3.scores && state3.scores[track] || 0;
        if (currentLeadPeg <= otherScore && newScore > otherScore && (currentLeadPeg < otherScore || otherScore > 0)) {
          passedPlayers.push({
            track,
            name: pName2(track),
            score: otherScore
          });
        }
      }
      const handleGameOverCleanup = () => {
        state3.showModal = null;
        state3.showMeter = null;
        if (typeof setShowMeter2 === "function") setShowMeter2("", 0, "");
        if (typeof document !== "undefined") {
          const m = document.getElementById("showMeter");
          if (m) m.classList.add("hidden");
        }
        const checkGameOverFn = context.checkGameOver || (typeof window !== "undefined" ? window.checkGameOver : null);
        if (typeof checkGameOverFn === "function") checkGameOverFn(context);
      };
      if (state3.over) {
        handleGameOverCleanup();
        return;
      }
      const continueShow = () => {
        if (state3.over) {
          handleGameOverCleanup();
          return;
        }
        if (state3.pausedForSign || state3.pausedForAdultTimer || state3.pausedForAdultStrip || state3.pausedForPintsBonus || state3.paused) {
          const resumeCb = () => {
            if (state3.over) {
              handleGameOverCleanup();
              return;
            }
            setTimeout(() => beginShowAct2(actIdx + 1, context), 700);
          };
          state3._resumeAfterSign = resumeCb;
          state3._resumeAfterAdultTimer = resumeCb;
          state3._resumeAfterPintsBonus = resumeCb;
          return;
        }
        setTimeout(() => beginShowAct2(actIdx + 1, context), 700);
      };
      if (passedPlayers.length > 0) {
        passedPlayers.sort((a, b) => (b.score || 0) - (a.score || 0));
        const firstPassed = passedPlayers[0];
        const passerCards = pack.cards && pack.cards.length ? pack.cards : _ShowModal.getPlayerHandCards(pack.who, state3, context);
        const passerCard = passerCards && passerCards.length ? passerCards[passerCards.length - 1] : null;
        const passedCards = _ShowModal.getPlayerHandCards(firstPassed.track, state3, context);
        const passedCard = passedCards && passedCards.length ? passedCards[passedCards.length - 1] : null;
        const passerName = pName2(pack.who);
        const passedName = passedPlayers.map((p) => p.name).join(" & ");
        const assassinOpt = typeof settings3 !== "undefined" && settings3 && settings3.cardAssassin || typeof window !== "undefined" && window.settings && window.settings.cardAssassin || "no";
        const isAssassinEnabled = assassinOpt === "yes";
        const showAssassin = isAssassinEnabled ? context.showCardAssassin || typeof window !== "undefined" && window.showCardAssassin || CardAssassinOverlay && CardAssassinOverlay.show : null;
        if (typeof showAssassin === "function") {
          let finished = false;
          const safeComplete = () => {
            if (finished) return;
            finished = true;
            continueShow();
          };
          try {
            showAssassin({
              passerName,
              passedName,
              passerCard,
              passedCard,
              settings: typeof settings3 !== "undefined" ? settings3 : typeof window !== "undefined" ? window.settings : null,
              onComplete: safeComplete
            });
            setTimeout(() => {
              if (!finished) safeComplete();
            }, 10500);
            return;
          } catch (err) {
            console.error("Failed to display Card Assassin animation:", err);
            continueShow();
            return;
          }
        }
      }
      continueShow();
    }
    /**
     * Ticks and displays an individual scoring line item with highlighting.
     * @param {number} actIdx
     * @param {number} lineIdx
     * @param {Object} [context]
     */
    static tickShowLine(actIdx, lineIdx, context = {}) {
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (!state3 || state3.phase !== "show" || state3.over) return;
      const isBonusMessage2 = context.isBonusMessage || (typeof window !== "undefined" ? window.isBonusMessage : _ShowModal.isBonusMessage);
      const cardKey2 = context.cardKey || (typeof window !== "undefined" ? window.cardKey : (c) => c && c.id);
      const applyHighlights2 = context.applyHighlights || (typeof window !== "undefined" ? window.applyHighlights : () => {
      });
      const setShowMeter2 = context.setShowMeter || (typeof window !== "undefined" ? window.setShowMeter : _ShowModal.setShowMeter);
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const sfx3 = context.sfx || (typeof window !== "undefined" ? window.sfx : { peg: () => {
      } });
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const finishShowAct2 = context.finishShowAct || (typeof window !== "undefined" ? window.finishShowAct : _ShowModal.finishShowAct);
      const key = state3.showQueue[actIdx];
      const pack = state3.lastShow[key];
      const lines = pack.score && pack.score.lines || [];
      if (lineIdx >= lines.length) {
        finishShowAct2(actIdx, context);
        return;
      }
      const line = lines[lineIdx];
      const isBonus = Boolean(line.isBonus || isBonusMessage2(line.why));
      const lineDuration = isBonus ? 2400 : 850;
      const fancyMs = isBonus ? 2200 : 750;
      state3.showRun = (state3.showRun || 0) + line.n;
      state3.highlightIds = (line.cards || []).map(cardKey2).filter(Boolean);
      applyHighlights2(line.cards || [], isBonus);
      const signPrefix = line.n >= 0 ? "+" : "";
      const lineText = signPrefix + line.n + "  " + line.why;
      state3.showMeter = { act: pack.title, total: state3.showRun, line: lineText, isBonus };
      setShowMeter2(pack.title, state3.showRun, lineText, isBonus);
      if (isBonus) {
        fancyCall2(lineText, "combo bonus-call", fancyMs);
      }
      if (sfx3.peg) sfx3.peg();
      netPush2({
        fancy: { text: lineText, kind: isBonus ? "combo bonus-call" : "combo", ms: fancyMs },
        sfx: "peg"
      });
      if (typeof document !== "undefined") {
        const feed = document.getElementById("showComboFeed");
        if (feed) {
          const item = document.createElement("div");
          item.className = "show-combo-item" + (isBonus ? " bonus" : "");
          item.innerHTML = `<span>${line.why}</span><span class="combo-pts">${line.n >= 0 ? "+" : ""}${line.n}</span>`;
          feed.appendChild(item);
          feed.scrollTop = feed.scrollHeight;
        }
      }
      setTimeout(() => {
        if (state3 && state3.over) return;
        _ShowModal.tickShowLine(actIdx, lineIdx + 1, context);
      }, lineDuration);
    }
    /**
     * Triggers the Muggins action banner and countdown timer when a player undercounts.
     * @param {Object} info
     */
    static triggerMugginsPrompt(info) {
      const { who, claimant, missed, declared, total, actIdx, context } = info;
      const pName2 = context.pName || (typeof window !== "undefined" ? window.pName : (s) => s);
      const fancyCall2 = context.fancyCall || (typeof window !== "undefined" ? window.fancyCall : () => {
      });
      const addScore2 = context.addScore || (typeof window !== "undefined" ? window.addScore : () => {
      });
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : () => {
      });
      const log2 = context.log || (typeof window !== "undefined" ? window.log : () => {
      });
      const famousFanfare2 = context.famousFanfare || (typeof window !== "undefined" ? window.famousFanfare : _ShowModal.famousFanfare);
      const beginShowAct2 = context.beginShowAct || (typeof window !== "undefined" ? window.beginShowAct : _ShowModal.beginShowAct);
      fancyCall2(`${pName2(who)} declared ${declared} pts!`, "go", 1200);
      log2(`\u26A0\uFE0F MUGGINS ALERT: ${pName2(who)} counted ${declared} pts but held ${total} pts (${missed} pts uncounted)!`);
      const wrap = typeof document !== "undefined" ? document.getElementById("mugginsPromptWrap") : null;
      const btn = typeof document !== "undefined" ? document.getElementById("btnMugginsClaim") : null;
      const text2 = typeof document !== "undefined" ? document.getElementById("mugginsText") : null;
      const timerEl = typeof document !== "undefined" ? document.getElementById("mugginsTimer") : null;
      let timeLeft = 5;
      let timerId = null;
      let resolved = false;
      const cleanup = () => {
        if (timerId) clearInterval(timerId);
        if (wrap) wrap.classList.add("hidden");
        if (typeof window !== "undefined") window.claimMuggins = null;
      };
      const onClaim = () => {
        if (resolved) return;
        resolved = true;
        cleanup();
        log2(`\u26A1 MUGGINS! ${pName2(claimant)} caught ${pName2(who)}'s undercount and stole ${missed} points!`);
        fancyCall2(`MUGGINS! +${missed} PTS STOLEN!`, "muggins-steal", 2e3);
        if (claimant === "p1" || claimant === "you") {
          const sfx3 = typeof window !== "undefined" ? window.sfx : null;
          AchievementManager.incrementStat("mugginsCalls", 1, { sfx: sfx3 });
          AchievementManager.unlock("cutthroat_king", { sfx: sfx3 });
        }
        famousFanfare2(missed);
        addScore2(claimant, missed, `Muggins steal from ${pName2(who)}`);
        renderScores2(true);
        setTimeout(() => beginShowAct2(actIdx + 1, context), 900);
      };
      if (typeof window !== "undefined") {
        window.claimMuggins = onClaim;
      }
      if (wrap && btn) {
        if (text2) text2.textContent = `${pName2(who)} counted ${declared} pts (missed ${missed} pts). Tap MUGGINS to steal!`;
        if (timerEl) timerEl.textContent = `${timeLeft}s`;
        wrap.classList.remove("hidden");
        btn.addEventListener("click", onClaim);
        timerId = setInterval(() => {
          timeLeft--;
          if (timerEl) timerEl.textContent = `${timeLeft}s`;
          if (timeLeft <= 0) {
            if (resolved) return;
            resolved = true;
            cleanup();
            log2(`\u23F3 Muggins timer expired \u2014 ${missed} uncounted points lost.`);
            setTimeout(() => beginShowAct2(actIdx + 1, context), 500);
          }
        }, 1e3);
      } else {
        setTimeout(() => beginShowAct2(actIdx + 1, context), 700);
      }
    }
    /**
     * Saves stripped match round summary snapshot into gameHands array.
     * @param {Object} state
     * @param {Array} gameHands
     */
    static saveHand(state3, gameHands2 = []) {
      if (!state3 || !Array.isArray(gameHands2)) return;
      const clonedState = { ...state3 };
      const keysToDelete = [
        "assignTarget",
        "atBar",
        "count",
        "cpuHand",
        "currentHumanDiscard",
        "customStatus",
        "cutDeck",
        "cutPicks",
        "deck",
        "deckDiscards",
        "discardsComplete",
        "frozen",
        "goPending",
        "highlightIds",
        "inDetour",
        "inRoundAbout",
        "inTimeout",
        "jailed",
        "over",
        "pausedForSign",
        "pausedForAdultTimer",
        "pausedForAdultStrip",
        "pausedForPintsBonus",
        "paused",
        "pendingSuit",
        "pendingWild",
        "phase",
        "recorded",
        "revealCrib",
        "selected",
        "showAct",
        "showMeter",
        "showModal",
        "showRun",
        "signsState",
        "starterFace",
        "stolenCrib",
        "stolenCribResolved",
        "twistedCribbageResolved",
        "twisted8Cards",
        "originalDealerKept",
        "originalCrib",
        "turn",
        "youHand",
        "_resumeAfterSign",
        "_resumeAfterAdultTimer",
        "_resumeAfterPintsBonus"
      ];
      keysToDelete.forEach((key) => delete clonedState[key]);
      gameHands2.push(clonedState);
    }
  };

  // src/variants/CrazyManager.js
  var CRAZY_OPTIONS_DEFS = Object.freeze([
    // Subgroup: General Options
    { key: "jokers", chkId: "optJokers", subgroup: "general", type: "boolean", name: "Jokers", description: "2 wild cards per deck; represent any card in play, hands & crib", default: false },
    { key: "optCutBeforeDiscard", chkId: "optCutBeforeDiscard", subgroup: "general", type: "boolean", name: "Cut before Discard", description: "Pone cuts the starter card before players discard to the crib", default: false },
    { key: "opt31sFor5", chkId: "opt31sFor5", subgroup: "general", type: "boolean", name: "31's for 5", description: "Combinations summing to 31 count for 5 bonus points in play, hand & crib", default: false },
    { key: "opt19sFor2", chkId: "opt19sFor2", subgroup: "general", type: "boolean", name: "19's for 2", description: "Combinations summing to 19 count for 2 bonus points in play, hand & crib", default: false },
    { key: "optRoundAroundTheWorld", chkId: "optRoundAroundTheWorld", subgroup: "general", type: "boolean", name: "Round around the World", description: "Runs can wrap around Ace to King (e.g. K-A-2 or Q-K-A)", default: false },
    { key: "optAllRed", chkId: "optAllRed", subgroup: "general", type: "boolean", name: "All Red", description: "All-red cards in hand, crib, or pegging score 1 bonus point per card", default: false },
    { key: "optAllBlack", chkId: "optAllBlack", subgroup: "general", type: "boolean", name: "All Black", description: "All-black cards in hand, crib, or pegging score 1 bonus point per card", default: false },
    { key: "optAllOdd", chkId: "optAllOdd", subgroup: "general", type: "boolean", name: "All Odd", description: "All odd ranks (A, 3, 5, 7, 9, J, K) score 1 bonus point per card", default: false },
    { key: "optAllEven", chkId: "optAllEven", subgroup: "general", type: "boolean", name: "All Even", description: "All even ranks (2, 4, 6, 8, 10, Q) score 1 bonus point per card", default: false },
    { key: "optAllDifferentSuits", chkId: "optAllDifferentSuits", subgroup: "general", type: "boolean", name: "All Different Suits", description: "All cards having distinct suits score 1 bonus point per card", default: false },
    { key: "optFlushInPlay", chkId: "optFlushInPlay", subgroup: "general", type: "boolean", name: "Flush in Play", description: "3 or more consecutive cards of the same suit in pegging score 1 pt per card", default: false },
    { key: "optChutesAndLadders", chkId: "optChutesAndLadders", subgroup: "general", type: "boolean", name: "Chutes and Ladders", description: "If at any time all players are tied, everyone goes back to the start (hole 0)", default: false },
    // Subgroup: Individual Cards
    { key: "optKH", chkId: "optKH", subgroup: "cards", type: "boolean", name: "King of Hearts (Suicide King)", description: "Scores 5 bonus points when in hand or crib (does not count as starter)", default: false },
    { key: "optQS", chkId: "optQS", subgroup: "cards", type: "boolean", name: "Queen of Spades", description: "Scores 5 bonus points when in hand or crib (does not count as starter)", default: false },
    { key: "optAS", chkId: "optAS", subgroup: "cards", type: "boolean", name: "Ace of Spades", description: "Scores 5 bonus points when in hand or crib (does not count as starter)", default: false },
    { key: "optSpades", chkId: "optSpades", subgroup: "cards", type: "boolean", name: "Spades", description: "Hands & cribs with a Spade double; no Spade loses 29 pts (crib immune if dealer holds a Spade; min 0). Cutting a Spade doubles pegging & heels", default: false },
    { key: "optGuessStarter", chkId: "optGuessStarter", subgroup: "cards", type: "boolean", name: "Guess Starter", description: "Pone guesses the rank of the cut starter card before it is turned over. A correct guess scores 3 points", default: false },
    // Subgroup: Poker Hands
    { key: "optStraight", chkId: "optStraight", subgroup: "poker", type: "boolean", name: "Straight", description: "A run of 5 or more cards scores 10 bonus points", default: false },
    { key: "optFullHouse", chkId: "optFullHouse", subgroup: "poker", type: "boolean", name: "Full House", description: "Three of a kind plus a pair in hand or crib scores 10 bonus points", default: false },
    { key: "optStraightFlush", chkId: "optStraightFlush", subgroup: "poker", type: "boolean", name: "Straight Flush", description: "Five consecutive cards of the same suit score 20 bonus points", default: false },
    { key: "optRoyalFlush", chkId: "optRoyalFlush", subgroup: "poker", type: "boolean", name: "Royal Flush", description: "10-J-Q-K-A of the same suit scores 30 bonus points", default: false },
    // Subgroup: Pegging Options
    { key: "optMultipleRunsInPegging", chkId: "optMultipleRunsInPegging", subgroup: "pegging", type: "boolean", name: "Multiple Runs in Pegging", description: "Double runs, triple runs and quadruple runs can be scored during pegging", default: false },
    { key: "optPegThroughZones", chkId: "optPegThroughZones", subgroup: "pegging", type: "boolean", name: "Peg Through Zones", description: "Holes 31\u201340, 61\u201370, 91\u2013100 are peg-only zones; hand & crib points don't count", default: false, mutualGroup: "zones" },
    { key: "optLast5PegOut", chkId: "optLast5PegOut", subgroup: "pegging", type: "boolean", name: "Last 5 Peg Out", description: "Last 5 holes require pegging out; hand & crib points cannot cross finish", default: false, mutualGroup: "zones" },
    { key: "optBunkers", chkId: "optBunkers", subgroup: "pegging", type: "boolean", name: "Bunkers", description: "First & last 5 holes, plus 50\u201360 & 80\u201390; pegging points only", default: false, mutualGroup: "zones" },
    { key: "optStinkHole", chkId: "optStinkHole", subgroup: "pegging", type: "boolean", name: "Stink Hole", description: "At hole 120 (or 60 in quick game), you must score exactly 1 point to win", default: false, mutualGroup: "zones" },
    { key: "optProgressiveSteals", chkId: "optProgressiveSteals", subgroup: "pegging", type: "boolean", name: "Progressive Steals", description: "Pair opponent's card while pegging to steal it into your hand for counting", default: false },
    // Subgroup: Hands & Cribs
    { key: "optStolenCrib", chkId: "optStolenCrib", subgroup: "hands", type: "boolean", name: "Stolen Crib", description: "Pone guesses dealer's exact crib points to steal all of them (2 players only)", default: false, requiredPlayers: 2 },
    { key: "optZeroHand", chkId: "optZeroHand", subgroup: "hands", type: "boolean", name: "Zero Hand", description: "A 0-point hand inflicts \u221219 penalty points", default: false },
    { key: "optZeroCrib", chkId: "optZeroCrib", subgroup: "hands", type: "boolean", name: "Zero Crib", description: "A 0-point crib inflicts \u221219 penalty points to dealer", default: false },
    { key: "optRockCrib", chkId: "optRockCrib", subgroup: "hands", type: "boolean", name: "Rock the Crib", description: "All crib points subtract from dealer score instead of adding", default: false },
    { key: "optPickYourCrib", chkId: "optPickYourCrib", subgroup: "hands", type: "boolean", name: "Pick Your Crib", description: "Dealer discards normally, but steals card(s) from pone's hand for the crib", default: false },
    { key: "optSpeedoCribbage", chkId: "optSpeedoCribbage", subgroup: "hands", type: "boolean", name: "Speedo Cribbage", description: "Pone discards to dealer's hand; dealer discards 4 (or 6 in super) to crib (2 players only)", default: false, requiredPlayers: 2 },
    { key: "optShotgunCribbage", chkId: "optShotgunCribbage", subgroup: "hands", type: "boolean", name: "Shotgun Cribbage", description: "Dealer forfeits all points scored in the crib", default: false },
    { key: "optTwistedCribbage", chkId: "optTwistedCribbage", subgroup: "hands", type: "boolean", name: "Twisted Cribbage", description: "Dealer combines 8 cards to make best two 4-card hands. Flushes require all 5 cards matching (2 players only)", default: false, requiredPlayers: 2 },
    { key: "optFivesCribbage", chkId: "optFivesCribbage", subgroup: "hands", type: "boolean", name: "Five's Cribbage", description: "Players must discard any 5s in hand directly to the crib", default: false },
    { key: "optSevensAndEightsCribbage", chkId: "optSevensAndEightsCribbage", subgroup: "hands", type: "boolean", name: "Sevens and Eights Cribbage", description: "Players must discard any 7s and 8s in hand directly to the crib", default: false },
    { key: "optDrawCribbage", chkId: "optDrawCribbage", subgroup: "hands", type: "boolean", name: "Draw Cribbage", description: "Draw 0\u20135 cards after deal, discard 2 to crib, then discard & draw 0\u20133 cards (2 players only)", default: false, requiredPlayers: 2 },
    { key: "opt7CardCribbage", chkId: "opt7CardCribbage", subgroup: "hands", type: "boolean", name: "7 Card Cribbage", description: "7 cards dealt, 1 dealt to crib, both players discard 2 to crib (2 players only)", default: false, requiredPlayers: 2 },
    { key: "optProgressiveCut", chkId: "optProgressiveCut", subgroup: "hands", type: "boolean", name: "Progressive cut", description: "Cut 1 card for first 2 hands, 2 for next 2, etc. Game ends when >121 with equal cribs (2 players only)", default: false, requiredPlayers: 2 },
    { key: "optCanadianDoubles", chkId: "optCanadianDoubles", subgroup: "hands", type: "boolean", name: "Canadian Doubles", description: "4-player partnership: dealer and pone get 10 cards, keep 4, pass 4 to partner, discard 2 to crib (forces 4 players partnership)", default: false, requiredPlayers: 4, requiredGameMode: "partnership", requiredPlayerMode: "4_part" }
  ]);
  var CrazyManager = class _CrazyManager {
    /**
     * @param {Object} [options]
     */
    constructor(options = {}) {
      this.options = { ...options };
      this.settings = options.settings || {};
    }
    /**
     * Updates internal settings reference.
     * @param {Object} settings
     */
    setSettings(settings3 = {}) {
      this.settings = settings3;
    }
    /**
     * Retrieves definition for a Crazy option by its key.
     * @param {string} key
     * @returns {Object|null}
     */
    static getOptionDef(key) {
      return CRAZY_OPTIONS_DEFS.find((o) => o.key === key || o.chkId === key) || null;
    }
    /**
     * Retrieves all options for a specific subgroup.
     * @param {string} subgroup
     * @returns {Array}
     */
    static getOptionsBySubgroup(subgroup) {
      return CRAZY_OPTIONS_DEFS.filter((o) => o.subgroup === subgroup);
    }
    /**
     * Checks whether a hole is within a Peg Through Zone.
     * Hand and crib points cannot be pegged while inside this zone.
     * @param {number} hole
     * @returns {boolean}
     */
    isInPegThroughZone(hole) {
      return hole >= 31 && hole <= 40 || hole >= 61 && hole <= 70 || hole >= 91 && hole <= 100;
    }
    /**
     * Checks whether a hole is in the Last 5 Peg Out zone.
     * Only pegging points can advance the peg out to victory.
     * @param {number} hole
     * @param {number} [target]
     * @returns {boolean}
     */
    isInLast5PegOut(hole, target = this.settings.target || 121) {
      const t = Number(target) || 121;
      return hole >= t - 5 && hole < t;
    }
    /**
     * Checks whether a hole is in a Bunker zone.
     * In bunkers, only pegging points are scored.
     * @param {number} hole
     * @param {number} [target]
     * @returns {boolean}
     */
    isInBunker(hole, target = this.settings.target || 121) {
      const t = Number(target) || 121;
      if (hole >= 1 && hole <= 5) return true;
      if (hole >= t - 5 && hole < t) return true;
      if (t === 121 || [241, 361, 481].includes(t)) {
        if (hole >= 50 && hole <= 60) return true;
        if (hole >= 80 && hole <= 90) return true;
      }
      return false;
    }
    /**
     * Checks whether a hole is the Stink Hole.
     * Must score exactly 1 point to win.
     * @param {number} hole
     * @param {number} [target]
     * @returns {boolean}
     */
    isInStinkHole(hole, target = this.settings.target || 121) {
      const t = Number(target) || 121;
      return hole === t - 1;
    }
    /**
     * Evaluates hand score adjustments under Zero Hand rule.
     * If a player scores 0 points in their hand, they receive -19 points.
     * @param {number} rawPoints
     * @param {boolean} [isEnabled]
     * @returns {number}
     */
    evaluateZeroHand(rawPoints, isEnabled = this.settings.optZeroHand) {
      return isEnabled && rawPoints === 0 ? -19 : rawPoints;
    }
    /**
     * Evaluates crib score adjustments under Zero Crib rule.
     * If the crib scores 0 points, the dealer receives -19 points.
     * @param {number} rawPoints
     * @param {boolean} [isEnabled]
     * @returns {number}
     */
    evaluateZeroCrib(rawPoints, isEnabled = this.settings.optZeroCrib) {
      return isEnabled && rawPoints === 0 ? -19 : rawPoints;
    }
    /**
     * Evaluates Rock the Crib rule: crib points count as negative points.
     * @param {number} rawPoints
     * @param {boolean} [isEnabled]
     * @returns {number}
     */
    evaluateRockTheCrib(rawPoints, isEnabled = this.settings.optRockCrib) {
      return isEnabled ? -Math.abs(rawPoints) : rawPoints;
    }
    /**
     * Evaluates Guess Starter result.
     * A correct rank guess scores 3 points.
     * @param {number} guessedRank
     * @param {Array|Object} starter
     * @param {boolean} [isEnabled]
     * @returns {{ isHit: boolean, points: number }}
     */
    evaluateGuessStarter(guessedRank, starter, isEnabled = this.settings.optGuessStarter) {
      if (!isEnabled || !guessedRank || !starter) return { isHit: false, points: 0 };
      const starters = Array.isArray(starter) ? starter.filter(Boolean) : [starter];
      const isHit = starters.some((st) => (st.playAs && st.playAs.r || st.rank || st.r || 0) === Number(guessedRank));
      return { isHit, points: isHit ? 3 : 0 };
    }
    /**
     * Resolves a Stolen Crib attempt.
     * If the pone correctly guesses the dealer's crib score, the pone steals those points.
     * Otherwise, the dealer keeps them.
     * @param {number} actualCribPoints
     * @param {number|null} poneGuess
     * @param {string} [dealerSeat]
     * @param {string} [poneSeat]
     * @returns {{ stolen: boolean, awardedTo: string, points: number }}
     */
    resolveStolenCrib(actualCribPoints, poneGuess, dealerSeat = "p2", poneSeat = "p1") {
      const stolen = poneGuess != null && Number(poneGuess) === actualCribPoints;
      return {
        stolen,
        awardedTo: stolen ? poneSeat : dealerSeat,
        points: actualCribPoints
      };
    }
    /**
     * Evaluates individual card bonus points (King of Hearts, Queen of Spades, Ace of Spades).
     * @param {string} rank 'K', 'Q', 'A', etc.
     * @param {string} suit 'H', 'S', 'D', 'C'
     * @returns {number}
     */
    evaluateCardBonus(rank, suit) {
      if (this.settings.optKH && rank === "K" && suit === "H") return 5;
      if (this.settings.optQS && rank === "Q" && suit === "S") return 5;
      if (this.settings.optAS && rank === "A" && suit === "S") return 5;
      return 0;
    }
    /**
     * Evaluates a Muggins claim: if a player claimed fewer points than their actual score,
     * the uncounted difference can be stolen by their opponent.
     * @param {number} claimedPoints Points declared by showing player
     * @param {number} actualPoints Actual points earned by hand/crib
     * @param {string} claimantSeat The player claiming Muggins
     * @param {string} targetSeat The player who undercounted
     * @returns {{ valid: boolean, stolenPoints: number, claimant: string, target: string }}
     */
    evaluateMuggins(claimedPoints, actualPoints, claimantSeat, targetSeat) {
      const claimed = Number(claimedPoints) || 0;
      const actual = Number(actualPoints) || 0;
      const diff = actual - claimed;
      const valid = diff > 0;
      return {
        valid,
        stolenPoints: valid ? diff : 0,
        claimant: claimantSeat,
        target: targetSeat
      };
    }
    /**
     * Returns discard counts for Speedo Cribbage given dealer status and deal type.
     * Pone discards 2 cards (or 3 in super deal) to dealer's hand.
     * Dealer discards 4 cards (or 6 in super deal) to the crib.
     * @param {boolean} isDealer
     * @param {string} [dealType='std'] 'std' or 'super'
     * @returns {number}
     */
    getSpeedoDiscardCount(isDealer, dealType = "std") {
      const isSuper = dealType === "super";
      return isDealer ? isSuper ? 6 : 4 : isSuper ? 3 : 2;
    }
    /**
     * Evaluates Shotgun Cribbage: in Shotgun Cribbage, the dealer does not get to count
     * the points in the crib (crib scores 0 points).
     * @param {number} rawPoints
     * @param {boolean} [isEnabled=this.settings.optShotgunCribbage]
     * @returns {number}
     */
    evaluateShotgunCribbage(rawPoints, isEnabled = this.settings.optShotgunCribbage) {
      if (!isEnabled) return rawPoints;
      return 0;
    }
    /**
     * Validates whether discards satisfy Five's Cribbage rule: any 5s held in hand
     * must be discarded to the crib (up to discardN).
     * @param {Array} hand
     * @param {Array} discarded
     * @param {number} [discardN=2]
     * @param {boolean} [isEnabled=this.settings.optFivesCribbage]
     * @returns {{ valid: boolean, requiredFives: number, discardedFives: number }}
     */
    validateFivesCribbage(hand = [], discarded = [], discardN = 2, isEnabled = this.settings.optFivesCribbage) {
      if (!isEnabled) return { valid: true, requiredFives: 0, discardedFives: 0 };
      const rankOf2 = (c) => c && (c.rank !== void 0 ? c.rank : c.r) || 0;
      const fivesInHand = hand.filter((c) => rankOf2(c) === 5);
      const requiredFives = Math.min(fivesInHand.length, discardN);
      const discardedFives = discarded.filter((c) => rankOf2(c) === 5).length;
      return {
        valid: discardedFives >= requiredFives,
        requiredFives,
        discardedFives
      };
    }
    /**
     * Validates whether discards satisfy Sevens and Eights Cribbage rule: any 7s and 8s held in hand
     * must be discarded to the crib (up to discardN).
     * @param {Array} hand
     * @param {Array} discarded
     * @param {number} [discardN=2]
     * @param {boolean} [isEnabled=this.settings.optSevensAndEightsCribbage]
     * @returns {{ valid: boolean, requiredCount: number, discardedCount: number }}
     */
    validateSevensAndEightsCribbage(hand = [], discarded = [], discardN = 2, isEnabled = this.settings.optSevensAndEightsCribbage) {
      if (!isEnabled) return { valid: true, requiredCount: 0, discardedCount: 0 };
      const rankOf2 = (c) => c && (c.rank !== void 0 ? c.rank : c.r) || 0;
      const sevensAndEightsInHand = hand.filter((c) => {
        const r = rankOf2(c);
        return r === 7 || r === 8;
      });
      const requiredCount = Math.min(sevensAndEightsInHand.length, discardN);
      const discardedCount = discarded.filter((c) => {
        const r = rankOf2(c);
        return r === 7 || r === 8;
      }).length;
      return {
        valid: discardedCount >= requiredCount,
        requiredCount,
        discardedCount
      };
    }
    /**
     * Returns whether 7 Card Cribbage is active for the current settings.
     * Only enabled for 2 players.
     * @param {Object} [settings=this.settings]
     * @returns {boolean}
     */
    is7CardCribbage(settings3 = this.settings) {
      const pCount = Number(settings3 && settings3.playerCount) || 2;
      return Boolean(settings3 && settings3.opt7CardCribbage && pCount === 2);
    }
    /**
     * Returns whether Progressive Cut is active for the current settings.
     * Only enabled for 2 players.
     * @param {Object} [settings=this.settings]
     * @returns {boolean}
     */
    isProgressiveCut(settings3 = this.settings) {
      const pCount = Number(settings3 && settings3.playerCount) || 2;
      return Boolean(settings3 && settings3.optProgressiveCut && pCount === 2);
    }
    /**
     * Returns whether Progressive Steals is active for the current settings.
     * @param {Object} [settings=this.settings]
     * @returns {boolean}
     */
    isProgressiveSteals(settings3 = this.settings) {
      return Boolean(settings3 && settings3.optProgressiveSteals);
    }
    /**
     * Returns whether Canadian Doubles is active for the current settings.
     * Only enabled for 4-player partnership games.
     * @param {Object} [settings=this.settings]
     * @returns {boolean}
     */
    isCanadianDoubles(settings3 = this.settings) {
      const pCount = Number(settings3 && settings3.playerCount) || 2;
      return Boolean(settings3 && settings3.optCanadianDoubles && pCount === 4);
    }
    /**
     * Returns an array of allowed player counts for a variant definition, or null if no restriction.
     * @param {Object} opt
     * @returns {number[]|null}
     */
    static getVariantRequiredPlayers(opt) {
      if (!opt || opt.requiredPlayers == null) return null;
      if (Array.isArray(opt.requiredPlayers)) return opt.requiredPlayers.map(Number);
      return [Number(opt.requiredPlayers)];
    }
    /**
     * Checks whether two variant definitions have compatible player count requirements.
     * Returns true if both can be played together or if either has no restriction.
     * @param {Object} optA
     * @param {Object} optB
     * @returns {boolean}
     */
    static areVariantPlayerRequirementsCompatible(optA, optB) {
      const reqA = _CrazyManager.getVariantRequiredPlayers(optA);
      const reqB = _CrazyManager.getVariantRequiredPlayers(optB);
      if (!reqA || !reqB) return true;
      const hasOverlap = reqA.some((count) => reqB.includes(count));
      if (!hasOverlap) return false;
      if (optA.requiredGameMode && optB.requiredGameMode && optA.requiredGameMode !== optB.requiredGameMode) {
        return false;
      }
      if (optA.requiredPlayerMode && optB.requiredPlayerMode && optA.requiredPlayerMode !== optB.requiredPlayerMode) {
        return false;
      }
      return true;
    }
    /**
     * Returns whether a given player count and mode are allowed for a variant definition.
     * @param {Object} opt
     * @param {number} count
     * @param {string} [mode]
     * @param {string} [playerMode]
     * @returns {boolean}
     */
    static isPlayerCountAllowedForVariant(opt, count, mode, playerMode) {
      const req = _CrazyManager.getVariantRequiredPlayers(opt);
      if (!req) return true;
      if (!req.includes(Number(count))) return false;
      if (opt.requiredGameMode && mode && opt.requiredGameMode !== mode) return false;
      if (opt.requiredPlayerMode && playerMode && opt.requiredPlayerMode !== playerMode) return false;
      return true;
    }
  };
  function getVariantRequiredPlayers(opt) {
    return CrazyManager.getVariantRequiredPlayers(opt);
  }
  function areVariantPlayerRequirementsCompatible(optA, optB) {
    return CrazyManager.areVariantPlayerRequirementsCompatible(optA, optB);
  }
  function isPlayerCountAllowedForVariant(opt, count, mode, playerMode) {
    return CrazyManager.isPlayerCountAllowedForVariant(opt, count, mode, playerMode);
  }

  // src/variants/CrazySettings.js
  var CrazySettings = class _CrazySettings {
    /**
     * Returns a clean map of default settings for Crazy Cribbage options.
     * @returns {Object}
     */
    static getCrazyDefaults() {
      const defaults = {};
      for (const opt of CRAZY_OPTIONS_DEFS) {
        defaults[opt.key] = opt.default;
      }
      return defaults;
    }
    /**
     * Sanitizes Crazy Cribbage settings:
     * - Enforces mutual exclusivity among zone pegging options (Bunkers vs Peg Through vs Last 5 vs Stink Hole).
     * - Enforces mutual exclusivity between Speedo Cribbage and Pick Your Crib.
     * - Disables 2-player-only options (Stolen Crib, Speedo Cribbage) if player count exceeds 2.
     * @param {Object} settings
     * @returns {Object} mutated settings
     */
    static sanitizeCrazyOptions(settings3 = {}) {
      if (!settings3) return settings3;
      if (settings3.optBunkers) {
        settings3.optPegThroughZones = false;
        settings3.optLast5PegOut = false;
        settings3.optStinkHole = false;
      } else if (settings3.optLast5PegOut) {
        settings3.optPegThroughZones = false;
        settings3.optStinkHole = false;
      } else if (settings3.optPegThroughZones) {
        settings3.optStinkHole = false;
      }
      if (settings3.opt7CardCribbage) {
        if (settings3.optSpeedoCribbage) settings3.optSpeedoCribbage = false;
        if (settings3.optPickYourCrib) settings3.optPickYourCrib = false;
        if (settings3.optDrawCribbage) settings3.optDrawCribbage = false;
      }
      if (settings3.optSpeedoCribbage && settings3.optPickYourCrib) {
        settings3.optPickYourCrib = false;
      }
      if (settings3.optDrawCribbage) {
        if (settings3.optSpeedoCribbage) settings3.optSpeedoCribbage = false;
        if (settings3.optPickYourCrib) settings3.optPickYourCrib = false;
        if (settings3.optFivesCribbage) settings3.optFivesCribbage = false;
        if (settings3.optSevensAndEightsCribbage) settings3.optSevensAndEightsCribbage = false;
        if (settings3.opt7CardCribbage) settings3.opt7CardCribbage = false;
      } else if (settings3.optSevensAndEightsCribbage) {
        if (settings3.optDrawCribbage) settings3.optDrawCribbage = false;
        if (settings3.optFivesCribbage) settings3.optFivesCribbage = false;
        if (settings3.optSpeedoCribbage) settings3.optSpeedoCribbage = false;
        if (settings3.optPickYourCrib) settings3.optPickYourCrib = false;
      } else if (settings3.optFivesCribbage) {
        if (settings3.optDrawCribbage) settings3.optDrawCribbage = false;
        if (settings3.optSpeedoCribbage) settings3.optSpeedoCribbage = false;
        if (settings3.optPickYourCrib) settings3.optPickYourCrib = false;
      } else if (settings3.optSpeedoCribbage || settings3.optPickYourCrib) {
        if (settings3.opt7CardCribbage) settings3.opt7CardCribbage = false;
        settings3.optDrawCribbage = false;
        settings3.optFivesCribbage = false;
        settings3.optSevensAndEightsCribbage = false;
      }
      if (settings3.optShotgunCribbage) {
        if (settings3.optRockCrib) settings3.optRockCrib = false;
        if (settings3.optZeroCrib) settings3.optZeroCrib = false;
        if (settings3.optStolenCrib) settings3.optStolenCrib = false;
        if (settings3.optTwistedCribbage) settings3.optTwistedCribbage = false;
      }
      if (settings3.optTwistedCribbage) {
        if (settings3.optShotgunCribbage) settings3.optShotgunCribbage = false;
        if (settings3.opt7CardCribbage) settings3.opt7CardCribbage = false;
      }
      const modeForcingOpt = CRAZY_OPTIONS_DEFS.find((opt) => opt.requiredPlayerMode && settings3[opt.key]);
      if (modeForcingOpt) {
        const req = Array.isArray(modeForcingOpt.requiredPlayers) ? modeForcingOpt.requiredPlayers : [Number(modeForcingOpt.requiredPlayers)];
        settings3.playerCount = req[0];
        if (modeForcingOpt.requiredGameMode) {
          settings3.gameMode = modeForcingOpt.requiredGameMode;
        }
      }
      const pCount = Number(settings3.playerCount) || 2;
      const gMode = settings3.gameMode || "individual";
      CRAZY_OPTIONS_DEFS.forEach((opt) => {
        if (opt.requiredPlayers != null) {
          const req = Array.isArray(opt.requiredPlayers) ? opt.requiredPlayers : [Number(opt.requiredPlayers)];
          const countAllowed = req.includes(pCount);
          const modeAllowed = !opt.requiredGameMode || opt.requiredGameMode === gMode;
          if (!countAllowed || !modeAllowed) {
            settings3[opt.key] = false;
          }
        }
      });
      const remainingActive = CRAZY_OPTIONS_DEFS.filter((opt) => opt.requiredPlayers != null && settings3[opt.key]);
      if (remainingActive.length > 1) {
        const primary = remainingActive[0];
        const primaryReq = Array.isArray(primary.requiredPlayers) ? primary.requiredPlayers : [Number(primary.requiredPlayers)];
        remainingActive.slice(1).forEach((other) => {
          const otherReq = Array.isArray(other.requiredPlayers) ? other.requiredPlayers : [Number(other.requiredPlayers)];
          const hasOverlap = otherReq.some((c) => primaryReq.includes(c));
          const modeCompatible = !primary.requiredGameMode || !other.requiredGameMode || primary.requiredGameMode === other.requiredGameMode;
          if (!hasOverlap || !modeCompatible) {
            settings3[other.key] = false;
          }
        });
      }
      return settings3;
    }
    /**
     * Randomizes Crazy Cribbage options.
     * @param {Object} [currentSettings]
     * @param {boolean} [isFull=false] If true, higher chance of activating multiple options
     * @returns {Object} Updated options dictionary
     */
    static randomizeCrazyOptions(currentSettings = {}, isFull = false) {
      const next = { ...currentSettings };
      const pCount = Number(next.playerCount) || 2;
      for (const opt of CRAZY_OPTIONS_DEFS) {
        if (opt.requiredPlayers != null) {
          const req = Array.isArray(opt.requiredPlayers) ? opt.requiredPlayers : [Number(opt.requiredPlayers)];
          if (!req.includes(pCount)) {
            next[opt.key] = false;
            continue;
          }
        }
        const prob = isFull ? 0.65 : 0.3;
        next[opt.key] = Math.random() < prob;
      }
      _CrazySettings.sanitizeCrazyOptions(next);
      return next;
    }
  };

  // src/ui/LobbyController.js
  var LobbyController = class _LobbyController {
    /**
     * Applies visibility states, headers, and option rules for the specified brand.
     * @param {string} brand
     * @param {Object} [context]
     */
    static applyBrandVisibility(brand, context = {}) {
      if (typeof document === "undefined") return;
      brand = brand || (typeof context.getAppBrand === "function" ? context.getAppBrand() : "crazy");
      const isClash = brand === "clash";
      const isPints = brand === "pints";
      const isAdult = brand === "adult";
      const gameTitleEl = document.getElementById("gameHeaderTitle") || document.querySelector(".header-title-wrap h1");
      if (gameTitleEl) {
        gameTitleEl.textContent = isClash ? "CRIBBAGE CLASH" : isPints ? "PINTS AND PEGS" : isAdult ? "SKUNKED AND STRIPPED" : "CRAZY CRIBBAGE";
      }
      const clashOptions = document.getElementById("cribbage-clash-options");
      const pintsOptions = document.getElementById("pints-options");
      const adultOptions = document.getElementById("adult-options");
      const crazyOptions = document.querySelectorAll(".crazy-only-options");
      const clashOnlyEls = document.querySelectorAll(".clash-only-options");
      const pintsOnlyEls = document.querySelectorAll(".pints-only-options");
      const adultOnlyEls = document.querySelectorAll(".adult-only-options");
      const checkAllWrap = document.querySelector(".checkAll");
      _LobbyController.updateTargetOptions(brand, context);
      if (isClash) {
        if (context.settings && (!context.settings.target || ![241, 361, 481].includes(context.settings.target))) {
          context.settings.target = 481;
        }
        if (typeof window !== "undefined" && window.settings && (!window.settings.target || ![241, 361, 481].includes(window.settings.target))) {
          window.settings.target = 481;
        }
      }
      const el3dOpt = document.getElementById("opt3DBoard");
      if (el3dOpt) {
        const cur3dId = context.settings?.selected3DBoardId || typeof window !== "undefined" && window.settings?.selected3DBoardId || el3dOpt.value;
        Board3DCatalog.syncDropdownOptions(el3dOpt, cur3dId, brand);
        if (context.settings) context.settings.selected3DBoardId = el3dOpt.value;
        if (typeof window !== "undefined" && window.settings) window.settings.selected3DBoardId = el3dOpt.value;
      }
      const brandContainer = document.getElementById("brand-game-options");
      const GameOptionsEngine2 = context.GameOptionsEngine || (typeof window !== "undefined" ? window.GameOptionsEngine : null);
      if (brandContainer && GameOptionsEngine2) {
        if (brandContainer.getAttribute("data-rendered-brand") !== brand) {
          GameOptionsEngine2.buildBrandSettingsUI(brand, brandContainer);
          brandContainer.setAttribute("data-rendered-brand", brand);
          const saved = GameOptionsEngine2.loadBrandSettings(brand);
          if (saved) {
            GameOptionsEngine2.applyBrandSettings(brand, saved);
          }
        }
      }
      _LobbyController.disableOtherGameBonusOptions(brand, context.settings || (typeof window !== "undefined" ? window.settings : {}), context);
      if (isClash) {
        if (clashOptions) clashOptions.style.display = "block";
        clashOnlyEls.forEach((el) => {
          el.style.display = el.classList.contains("opt") ? "flex" : "block";
        });
        if (pintsOptions) {
          pintsOptions.style.display = "none";
          if (typeof context.uncheckPintsOptions === "function") context.uncheckPintsOptions();
        }
        pintsOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        if (adultOptions) {
          adultOptions.style.display = "none";
          if (typeof context.uncheckAdultOptions === "function") context.uncheckAdultOptions();
        }
        adultOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        if (typeof context.updateCribbageClashOptionRanges === "function") {
          context.updateCribbageClashOptionRanges(true);
        }
        crazyOptions.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        if (checkAllWrap) {
          checkAllWrap.style.display = "none";
          const checkAllChk = checkAllWrap.querySelector('input[type="checkbox"]');
          if (checkAllChk) checkAllChk.checked = false;
        }
      } else if (isPints) {
        if (clashOptions) {
          clashOptions.style.display = "none";
          if (typeof context.uncheckCribbageClashOptions === "function") context.uncheckCribbageClashOptions();
        }
        clashOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        if (pintsOptions) pintsOptions.style.display = "block";
        pintsOnlyEls.forEach((el) => {
          el.style.display = "block";
        });
        if (adultOptions) {
          adultOptions.style.display = "none";
          if (typeof context.uncheckAdultOptions === "function") context.uncheckAdultOptions();
        }
        adultOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        crazyOptions.forEach((el) => {
          el.style.display = "block";
        });
        if (checkAllWrap) checkAllWrap.style.display = "flex";
      } else if (isAdult) {
        if (clashOptions) {
          clashOptions.style.display = "none";
          if (typeof context.uncheckCribbageClashOptions === "function") context.uncheckCribbageClashOptions();
        }
        clashOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        if (pintsOptions) {
          pintsOptions.style.display = "none";
          if (typeof context.uncheckPintsOptions === "function") context.uncheckPintsOptions();
        }
        pintsOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        if (adultOptions) adultOptions.style.display = "block";
        adultOnlyEls.forEach((el) => {
          el.style.display = "block";
        });
        crazyOptions.forEach((el) => {
          el.style.display = "block";
        });
        if (checkAllWrap) checkAllWrap.style.display = "flex";
      } else {
        if (clashOptions) {
          clashOptions.style.display = "none";
          if (typeof context.uncheckCribbageClashOptions === "function") context.uncheckCribbageClashOptions();
        }
        clashOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        if (pintsOptions) {
          pintsOptions.style.display = "none";
          if (typeof context.uncheckPintsOptions === "function") context.uncheckPintsOptions();
        }
        pintsOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        if (adultOptions) {
          adultOptions.style.display = "none";
          if (typeof context.uncheckAdultOptions === "function") context.uncheckAdultOptions();
        }
        adultOnlyEls.forEach((el) => {
          el.style.display = "none";
          el.querySelectorAll('input[type="checkbox"]').forEach((chk) => {
            chk.checked = false;
          });
        });
        crazyOptions.forEach((el) => {
          el.style.display = "block";
        });
        if (checkAllWrap) checkAllWrap.style.display = "flex";
      }
      const isCrazy = brand === "crazy";
      const btnTourneyLaunch = document.getElementById("btnLaunchTourney");
      if (btnTourneyLaunch) btnTourneyLaunch.style.display = isCrazy ? "inline-flex" : "none";
      const btnModeTourney = document.getElementById("btnModeTourney");
      if (btnModeTourney) btnModeTourney.style.display = isCrazy ? "inline-flex" : "none";
      if (typeof context.updateCheckAllBonusesState === "function") {
        context.updateCheckAllBonusesState();
      }
      const buildBoardFn = context.buildBoard || (typeof window !== "undefined" ? window.buildBoard || window.crazyCribbageApp && window.crazyCribbageApp.buildBoard : null);
      if (typeof buildBoardFn === "function") {
        try {
          buildBoardFn();
        } catch (e) {
        }
      }
    }
    /**
     * Updates available target score options for the specified brand.
     * @param {string} brand
     * @param {Object} [context]
     */
    static updateTargetOptions(brand, context = {}) {
      if (typeof document === "undefined") return;
      const optTarget = document.getElementById("optTarget");
      if (!optTarget) return;
      const isClash = brand === "clash";
      const isCrazy = !brand || brand === "crazy";
      const targetOptions = isClash ? [
        { val: "481", text: "481 points (Standard Match)" },
        { val: "361", text: "361 points (Short Match)" },
        { val: "241", text: "241 points (Mini Match)" }
      ] : isCrazy ? [
        { val: "121", text: "121 points (Full game)" },
        { val: "61", text: "61 points (Short game)" },
        { val: "31", text: "31 points (Pegging Only)" },
        { val: "241", text: "241 points (There and Back)" }
      ] : [
        { val: "121", text: "121 points (Full game)" },
        { val: "61", text: "61 points (Short game)" },
        { val: "31", text: "31 points (Pegging Only)" }
      ];
      const currentVal = optTarget.value;
      optTarget.innerHTML = "";
      targetOptions.forEach((opt) => {
        const el = document.createElement("option");
        el.value = opt.val;
        el.textContent = opt.text;
        optTarget.appendChild(el);
      });
      const hasMatch = targetOptions.some((o) => o.val === currentVal);
      const resolvedVal = hasMatch ? currentVal : isClash ? "481" : "121";
      optTarget.value = resolvedVal;
      const targetInt = parseInt(resolvedVal, 10);
      if (context && context.settings) {
        context.settings.target = targetInt;
      }
      if (typeof window !== "undefined" && window.settings) {
        window.settings.target = targetInt;
      }
    }
    /**
     * Synchronizes variant checkboxes and the Player Count dropdown according to variant player constraints.
     * If any variant requiring a specific player count is selected (checked):
     * 1. Variants requiring a different player count or conflicting mode are disabled.
     * 2. Dropdown options in #optPlayerCount are restricted to the required player count, and its value updated.
     * If no player-restricted variant is selected:
     * 1. All variant checkboxes are re-enabled.
     * 2. All player count options in #optPlayerCount are unlocked and visible.
     *
     * @param {Object} [context]
     * @returns {Object} { activeRestrictedVariant, allowedCountVal }
     */
    static syncVariantPlayerCountConstraints(context = {}) {
      if (typeof document === "undefined") return { activeRestrictedVariant: null, allowedCountVal: null };
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const parseGameMode2 = context.parseGameMode || (typeof window !== "undefined" ? window.parseGameMode : ((v) => ({ playerCount: parseInt(v, 10) || 2, gameMode: "individual" })));
      const pCountEl = document.getElementById("optPlayerCount");
      const restrictedDefs = CRAZY_OPTIONS_DEFS.filter((opt) => opt.requiredPlayers != null);
      const activeRestrictedDefs = restrictedDefs.filter((opt) => {
        const chk = document.getElementById(opt.chkId || opt.key);
        if (chk) return chk.checked;
        return Boolean(settings3 && (settings3[opt.key] || settings3[opt.chkId]));
      });
      let activeVariant = null;
      if (activeRestrictedDefs.length > 0) {
        if (context.changedEl) {
          const changedId = context.changedEl.id;
          const matched = activeRestrictedDefs.find((o) => o.chkId === changedId || o.key === changedId);
          if (matched) activeVariant = matched;
        }
        if (!activeVariant) {
          activeVariant = activeRestrictedDefs[0];
        }
        activeRestrictedDefs.forEach((otherOpt) => {
          if (otherOpt === activeVariant) return;
          if (!CrazyManager.areVariantPlayerRequirementsCompatible(activeVariant, otherOpt)) {
            const otherChk = document.getElementById(otherOpt.chkId || otherOpt.key);
            if (otherChk) otherChk.checked = false;
            if (settings3) {
              settings3[otherOpt.key] = false;
              if (otherOpt.chkId) settings3[otherOpt.chkId] = false;
            }
          }
        });
      }
      if (pCountEl) {
        if (activeVariant) {
          if (settings3) {
            settings3[activeVariant.key] = true;
            if (activeVariant.chkId) settings3[activeVariant.chkId] = true;
          }
          let firstAllowedVal = null;
          let isCurrentValAllowed = false;
          if (pCountEl.options && pCountEl.options.length > 0) {
            Array.from(pCountEl.options).forEach((opt) => {
              const { playerCount, gameMode } = parseGameMode2(opt.value);
              const allowed = CrazyManager.isPlayerCountAllowedForVariant(activeVariant, playerCount, gameMode, opt.value);
              opt.disabled = !allowed;
              opt.hidden = !allowed;
              opt.style.display = allowed ? "" : "none";
              if (allowed) {
                if (!firstAllowedVal) firstAllowedVal = opt.value;
                if (activeVariant.requiredPlayerMode && opt.value === activeVariant.requiredPlayerMode) {
                  firstAllowedVal = opt.value;
                }
                if (opt.value === pCountEl.value) {
                  isCurrentValAllowed = true;
                }
              }
            });
          } else {
            firstAllowedVal = activeVariant.requiredPlayerMode || (activeVariant.requiredPlayers ? String(activeVariant.requiredPlayers) : "2");
            const { playerCount, gameMode } = parseGameMode2(pCountEl.value);
            isCurrentValAllowed = CrazyManager.isPlayerCountAllowedForVariant(activeVariant, playerCount, gameMode, pCountEl.value);
          }
          if (!isCurrentValAllowed && firstAllowedVal) {
            pCountEl.value = firstAllowedVal;
          }
          const resolvedVal = pCountEl.value || firstAllowedVal;
          const parsed = parseGameMode2(resolvedVal);
          if (settings3) {
            settings3.playerCount = parsed.playerCount;
            settings3.gameMode = parsed.gameMode;
          }
        } else {
          if (pCountEl.options) {
            Array.from(pCountEl.options).forEach((opt) => {
              opt.disabled = false;
              opt.hidden = false;
              opt.style.display = "";
            });
          }
        }
      }
      restrictedDefs.forEach((opt) => {
        const chk = document.getElementById(opt.chkId || opt.key);
        if (!chk) return;
        const label = chk.closest(".chk");
        if (activeVariant) {
          const isCompatible = CrazyManager.areVariantPlayerRequirementsCompatible(activeVariant, opt);
          if (isCompatible) {
            chk.disabled = false;
            if (label) {
              label.style.opacity = "";
              label.style.cursor = "";
              label.title = "";
            }
          } else {
            chk.checked = false;
            chk.disabled = true;
            if (label) {
              label.style.opacity = "0.45";
              label.style.cursor = "not-allowed";
              const reqList = CrazyManager.getVariantRequiredPlayers(opt) || [];
              label.title = `${opt.name} requires ${reqList.join("/")} players (conflicts with ${activeVariant.name})`;
            }
            if (settings3) {
              settings3[opt.key] = false;
              if (opt.chkId) settings3[opt.chkId] = false;
            }
          }
        } else {
          chk.disabled = false;
          if (label) {
            label.style.opacity = "";
            label.style.cursor = "";
            const reqList = CrazyManager.getVariantRequiredPlayers(opt) || [];
            label.title = `${opt.name} (${reqList.join("/")} players${opt.requiredGameMode ? " " + opt.requiredGameMode : ""})`;
          }
        }
      });
      return { activeRestrictedVariant: activeVariant, allowedCountVal: pCountEl ? pCountEl.value : null };
    }
    /**
     * Synchronizes Player Count, Seat types, CPU availability, and Stolen Crib constraints.
     * @param {Object} [context]
     */
    static syncPlayerCountUi(context = {}) {
      if (typeof document === "undefined") return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const parseGameMode2 = context.parseGameMode || (typeof window !== "undefined" ? window.parseGameMode : ((v) => ({ playerCount: parseInt(v, 10) || 2, gameMode: "individual" })));
      const pCountEl = document.getElementById("optPlayerCount");
      if (pCountEl) {
        const { playerCount: curCount, gameMode: curMode } = parseGameMode2(pCountEl.value);
        CRAZY_OPTIONS_DEFS.forEach((opt) => {
          if (opt.requiredPlayers != null) {
            if (!CrazyManager.isPlayerCountAllowedForVariant(opt, curCount, curMode, pCountEl.value)) {
              const chk = document.getElementById(opt.chkId || opt.key);
              if (chk && chk.checked) {
                chk.checked = false;
                if (settings3) {
                  settings3[opt.key] = false;
                  if (opt.chkId) settings3[opt.chkId] = false;
                }
              }
            }
          }
        });
      }
      _LobbyController.syncVariantPlayerCountConstraints(context);
      let countVal = pCountEl ? pCountEl.value : "2";
      const { playerCount, gameMode } = parseGameMode2(countVal);
      settings3.playerCount = playerCount;
      settings3.gameMode = gameMode;
      const brand = typeof context.getAppBrand === "function" ? context.getAppBrand() : typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : "crazy";
      const GameOptionsEngine2 = context.GameOptionsEngine || (typeof window !== "undefined" ? window.GameOptionsEngine : null);
      const allowCpu = GameOptionsEngine2 && typeof GameOptionsEngine2.isCpuAllowed === "function" ? GameOptionsEngine2.isCpuAllowed(brand) : !["pints", "adult"].includes(brand);
      const oppRow = document.getElementById("optOppRow");
      const oppSel = document.getElementById("optOpp");
      const seatPanel = document.getElementById("seatConfigPanel");
      const pBadge = document.getElementById("partnershipBadge");
      const dealSel = document.getElementById("optDeal");
      const dealRow = dealSel ? dealSel.closest(".opt") : null;
      const netPanel = document.getElementById("netPanel");
      const rawOppVal = oppSel && oppSel.value || "cpu";
      let oppVal = !allowCpu && rawOppVal === "cpu" ? "online" : rawOppVal;
      if (oppVal === "human") {
        oppVal = allowCpu ? "cpu" : "online";
        if (oppSel) oppSel.value = oppVal;
      }
      if (oppRow) oppRow.classList.remove("hidden");
      if (netPanel) netPanel.classList.toggle("hidden", oppVal !== "online");
      const modePills = document.querySelectorAll(".game-mode-pill");
      modePills.forEach((p) => {
        p.classList.toggle("active", p.dataset.mode === oppVal);
      });
      for (let i = 2; i <= 8; i++) {
        const r = document.getElementById(`seatRow${i}`);
        if (r) r.style.display = i <= playerCount ? "flex" : "none";
      }
      if (seatPanel) {
        seatPanel.classList.toggle("hidden", playerCount <= 2);
        seatPanel.style.display = playerCount > 2 ? "flex" : "none";
      }
      const aiRow = document.getElementById("optAiProfileRow");
      if (aiRow) {
        const isCpu = oppVal === "cpu";
        const showSingleCpuRow = allowCpu && isCpu && playerCount === 2;
        aiRow.classList.toggle("hidden", !showSingleCpuRow);
        aiRow.style.display = showSingleCpuRow ? "" : "none";
      }
      if (dealRow) {
        dealRow.style.display = playerCount === 2 ? "" : "none";
      }
      if (pBadge) {
        if (gameMode === "partnership") {
          pBadge.textContent = "Partnership Play (P1 & P3 vs P2 & P4)";
          pBadge.style.display = "block";
        } else if (gameMode === "shifting") {
          pBadge.textContent = playerCount === 3 ? "Shifting Partnership (P1 & P2 vs Dealer)" : "Shifting Partnership (Pone & Partner vs Others)";
          pBadge.style.display = "block";
        } else if (gameMode === "teams") {
          pBadge.textContent = playerCount === 6 ? "3-Team Battle (P1/P4 vs P2/P5 vs P3/P6)" : "4-Team Battle (P1/P5 vs P2/P6 vs P3/P7 vs P4/P8)";
          pBadge.style.display = "block";
        } else {
          pBadge.style.display = "none";
        }
      }
      const isPartnership2 = gameMode === "partnership";
      const isTeams = gameMode === "teams";
      const showTeamTags = isPartnership2 || isTeams;
      for (let i = 1; i <= 8; i++) {
        const tag = document.getElementById(`seat${i}TeamTag`);
        if (tag) {
          if (!showTeamTags || i > playerCount) {
            tag.style.display = "none";
          } else {
            tag.style.display = "inline-block";
            if (isPartnership2) {
              if (i === 1) tag.textContent = "Team 1";
              else if (i === 2) tag.textContent = "Team 2";
              else if (i === 3) tag.textContent = "Team 1 (Partner)";
              else if (i === 4) tag.textContent = "Team 2";
            } else if (isTeams) {
              if (playerCount === 6) {
                const teamNum = (i - 1) % 3 + 1;
                tag.textContent = `Team ${teamNum}${i === 4 ? " (Partner)" : ""}`;
                tag.className = `seat-team-tag team${teamNum}`;
              } else if (playerCount === 8) {
                const teamNum = (i - 1) % 4 + 1;
                tag.textContent = `Team ${teamNum}${i === 5 ? " (Partner)" : ""}`;
                tag.className = `seat-team-tag team${teamNum}`;
              }
            }
          }
        }
      }
    }
    /**
     * Applies loaded or default settings store into form elements.
     * @param {Object} saved
     * @param {Object} [context]
     */
    static applyFormSettings(saved, context = {}) {
      if (!saved || typeof document === "undefined") return;
      const brand = typeof context.getAppBrand === "function" ? context.getAppBrand() : "crazy";
      if (brand === "clash") {
        if (!saved.target || ![241, 361, 481].includes(Number(saved.target))) {
          saved.target = 481;
        }
      } else if (brand === "pints") {
        if (!saved.target || [241, 361, 481].includes(Number(saved.target))) {
          saved.target = 121;
        }
        if (saved.selected3DBoardId === "board-cribbage-clash" || saved.selected3DBoardId === "board-cribbage-clash-square") {
          saved.selected3DBoardId = "board-14";
        }
      }
      _LobbyController.disableOtherGameBonusOptions(brand, saved, context);
      _LobbyController.applyBrandVisibility(brand, context);
      const GameOptionsEngine2 = context.GameOptionsEngine || (typeof window !== "undefined" ? window.GameOptionsEngine : null);
      const allowCpu = GameOptionsEngine2 && typeof GameOptionsEngine2.isCpuAllowed === "function" ? GameOptionsEngine2.isCpuAllowed(brand) : !["pints", "adult"].includes(brand);
      if (!allowCpu) {
        if (saved.opp === "cpu") saved.opp = "online";
        ["seat2Type", "seat3Type", "seat4Type", "seat5Type", "seat6Type", "seat7Type", "seat8Type"].forEach((key) => {
          if (saved[key] && typeof saved[key] === "string" && saved[key].startsWith("cpu:")) saved[key] = "online";
        });
      }
      if (saved.opp === "human") saved.opp = allowCpu ? "cpu" : "online";
      ["seat2Type", "seat3Type", "seat4Type", "seat5Type", "seat6Type", "seat7Type", "seat8Type"].forEach((key) => {
        if (saved[key] === "human") saved[key] = "online";
      });
      if (typeof context.settings !== "undefined" && context.settings) {
        _LobbyController.disableOtherGameBonusOptions(brand, context.settings, context);
        Object.assign(context.settings, saved);
        _LobbyController.disableOtherGameBonusOptions(brand, context.settings, context);
      }
      if (saved.optCanadianDoubles) {
        saved.playerCount = "4_part";
        saved.gameMode = "partnership";
      }
      if (saved.playerCount) {
        const el = document.getElementById("optPlayerCount");
        if (el && [...el.options].some((o) => o.value === saved.playerCount)) el.value = saved.playerCount;
      }
      ["seat2Type", "seat3Type", "seat4Type", "seat5Type", "seat6Type", "seat7Type", "seat8Type"].forEach((key) => {
        if (saved[key]) {
          const el = document.getElementById("opt" + key.charAt(0).toUpperCase() + key.slice(1));
          if (el && [...el.options].some((o) => o.value === saved[key])) el.value = saved[key];
        }
      });
      if (saved.opp) {
        const el = document.getElementById("optOpp");
        if (el && [...el.options].some((o) => o.value === saved.opp)) el.value = saved.opp;
      }
      if (saved.aiProfile) {
        const el = document.getElementById("optAiProfile");
        if (el && [...el.options].some((o) => o.value === saved.aiProfile)) el.value = saved.aiProfile;
      }
      if (saved.coach) {
        const el = document.getElementById("optCoach");
        if (el && [...el.options].some((o) => o.value === saved.coach)) el.value = saved.coach;
      }
      if (saved.cardAssassin) {
        const el = document.getElementById("optCardAssassin");
        if (el && [...el.options].some((o) => o.value === saved.cardAssassin)) el.value = saved.cardAssassin;
      }
      if (saved.jailAnimation) {
        const el = document.getElementById("optJailAnimation");
        if (el && [...el.options].some((o) => o.value === saved.jailAnimation)) el.value = saved.jailAnimation;
      }
      if (saved.barAnimation) {
        const el = document.getElementById("optBarAnimation");
        if (el && [...el.options].some((o) => o.value === saved.barAnimation)) el.value = saved.barAnimation;
      }
      if (saved.cannonAnimation) {
        const el = document.getElementById("optCannonAnimation");
        if (el && [...el.options].some((o) => o.value === saved.cannonAnimation)) el.value = saved.cannonAnimation;
      }
      if (saved.speedTrapAnimation) {
        const el = document.getElementById("optSpeedTrapAnimation");
        if (el && [...el.options].some((o) => o.value === saved.speedTrapAnimation)) el.value = saved.speedTrapAnimation;
      }
      if (saved.scenicRouteAnimation) {
        const el = document.getElementById("optScenicRouteAnimation");
        if (el && [...el.options].some((o) => o.value === saved.scenicRouteAnimation)) el.value = saved.scenicRouteAnimation;
      }
      if (saved.detourAnimation || saved.scenicRouteAnimation) {
        const el = document.getElementById("optDetourAnimation");
        const val = saved.detourAnimation || saved.scenicRouteAnimation;
        if (el && [...el.options].some((o) => o.value === val)) el.value = val;
      }
      if (saved.roundAboutAnimation || saved.scenicRouteAnimation) {
        const el = document.getElementById("optRoundAboutAnimation");
        const val = saved.roundAboutAnimation || saved.scenicRouteAnimation;
        if (el && [...el.options].some((o) => o.value === val)) el.value = val;
      }
      if (saved.deal) {
        const el = document.getElementById("optDeal");
        if (el && [...el.options].some((o) => o.value === saved.deal)) el.value = saved.deal;
      }
      if (saved.dealStyle) {
        const el = document.getElementById("optDealStyle");
        if (el) el.value = "alternate";
      }
      if (saved.showDetail) {
        const el = document.getElementById("optShowDetail");
        if (el && [...el.options].some((o) => o.value === saved.showDetail)) el.value = saved.showDetail;
      } else if (saved.optMuggins) {
        const el = document.getElementById("optShowDetail");
        if (el) el.value = "muggins";
      }
      if (brand === "clash") {
        const el = document.getElementById("optGoal");
        if (el) el.value = "high";
      } else if (saved.goal) {
        const el = document.getElementById("optGoal");
        if (el && [...el.options].some((o) => o.value === saved.goal)) el.value = saved.goal;
      }
      if (saved.target != null) {
        const el = document.getElementById("optTarget");
        let v = String(saved.target);
        if (brand === "clash" && !["241", "361", "481"].includes(v)) {
          v = "481";
        }
        if (brand !== "clash" && (v === "361" || v === "481")) {
          v = "121";
        }
        if ((brand === "pints" || brand === "adult") && v === "241") {
          v = "121";
        }
        if (el) {
          if (![...el.options].some((o) => o.value === v)) {
            _LobbyController.updateTargetOptions(brand, context);
          }
          el.value = v;
        }
        const targetVal = el ? parseInt(el.value, 10) : parseInt(v, 10);
        if (context.settings) {
          context.settings.target = targetVal;
        }
        const isClashTarget2 = brand === "clash" && ["241", "361", "481"].includes(v);
        const bClash = document.getElementById("cribbage-clash-options");
        if (bClash) bClash.style.display = isClashTarget2 ? "block" : "none";
        if (typeof context.updateCribbageClashOptionRanges === "function") {
          context.updateCribbageClashOptionRanges(targetVal);
        }
      }
      if (saved.decks != null) {
        const el = document.getElementById("optDecks");
        const v = String(saved.decks);
        if (el && [...el.options].some((o) => o.value === v)) el.value = v;
      }
      if (saved.cardBack && typeof context.setCardBack === "function") {
        context.setCardBack(saved.cardBack, true);
      }
      if (saved.boardFinish) {
        const el = document.getElementById("optBoardFinish");
        if (el) el.value = saved.boardFinish;
        if (context.settings) context.settings.boardFinish = saved.boardFinish;
      }
      if (saved.pegSkin) {
        const el = document.getElementById("optPegSkin");
        if (el) el.value = saved.pegSkin;
        if (context.settings) context.settings.pegSkin = saved.pegSkin;
      }
      if (saved.pegStyle) {
        const el = document.getElementById("optPegStyle");
        if (el) el.value = saved.pegStyle;
        if (context.settings) context.settings.pegStyle = saved.pegStyle;
      }
      if (saved.tableEnvironment) {
        const el = document.getElementById("optTableEnvironment");
        if (el) el.value = saved.tableEnvironment;
        if (context.settings) context.settings.tableEnvironment = saved.tableEnvironment;
      }
      if (saved.optActionCam) {
        const el = document.getElementById("optActionCam");
        if (el) el.value = saved.optActionCam;
        if (context.settings) context.settings.optActionCam = saved.optActionCam;
      }
      if (saved.seriesMode) {
        const el = document.getElementById("optSeriesMode");
        if (el) el.value = saved.seriesMode;
        if (context.settings) context.settings.seriesMode = saved.seriesMode;
        SeriesTracker.setMode(saved.seriesMode);
      }
      if (saved.boardViewMode) {
        const el = document.getElementById("optBoardView");
        if (el) el.value = saved.boardViewMode;
        const elModal = document.getElementById("optBoardViewModal");
        if (elModal) elModal.value = saved.boardViewMode;
        if (context.settings) context.settings.boardViewMode = saved.boardViewMode;
      }
      const el3d = document.getElementById("opt3DBoard");
      if (el3d) {
        const bId = saved?.selected3DBoardId || context.settings?.selected3DBoardId || (brand === "clash" ? "board-cribbage-clash" : "board-14");
        Board3DCatalog.syncDropdownOptions(el3d, bId, brand);
        if (context.settings) context.settings.selected3DBoardId = el3d.value;
        if (typeof window !== "undefined" && window.settings) window.settings.selected3DBoardId = el3d.value;
      }
      const container = document.getElementById("brand-game-options");
      if (container && GameOptionsEngine2) {
        if (container.getAttribute("data-rendered-brand") !== brand) {
          GameOptionsEngine2.buildBrandSettingsUI(brand, container);
          container.setAttribute("data-rendered-brand", brand);
        }
        GameOptionsEngine2.applyBrandSettings(brand, saved);
      }
      if (typeof context.updateCheckAllBonusesState === "function") {
        context.updateCheckAllBonusesState();
      }
      _LobbyController.syncPlayerCountUi(context);
      if (typeof context.enforceClashNoOverlap === "function") {
        context.enforceClashNoOverlap();
      }
      _LobbyController.applyBrandVisibility(brand, context);
      if (typeof context.syncAllClashPlacementButtons === "function") {
        context.syncAllClashPlacementButtons();
      }
    }
    /**
     * Builds the roster data structure for lobby display and online room synchronization.
     * @param {Object} [context]
     * @returns {Array<Object>}
     */
    static getLobbyRosterData(context = {}) {
      if (typeof document === "undefined") return [];
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const net2 = context.net || (typeof window !== "undefined" ? window.net : {});
      const mySeat3 = context.mySeat || (typeof window !== "undefined" ? window.mySeat : (() => "p1"));
      const parseGameMode2 = context.parseGameMode || (typeof window !== "undefined" ? window.parseGameMode : ((v) => ({ playerCount: parseInt(v, 10) || 2 })));
      const pCountEl = document.getElementById("optPlayerCount");
      const countVal = pCountEl ? pCountEl.value : "2";
      const { playerCount } = parseGameMode2(countVal);
      const count = playerCount || settings3.playerCount || 2;
      const list = [];
      const hostName = document.getElementById("optPlayerName") && document.getElementById("optPlayerName").value.trim() || "Host";
      const myCurrentSeat = mySeat3();
      const seatToClient = /* @__PURE__ */ new Map();
      if (net2.clients) {
        for (const client of net2.clients.values()) {
          if (client.seatId) seatToClient.set(client.seatId, client);
        }
      }
      for (let i = 1; i <= count; i++) {
        const sId = "p" + i;
        const isMe = sId === myCurrentSeat;
        if (sId === "p1") {
          list.push({
            id: "p1",
            num: 1,
            name: hostName,
            type: "human",
            status: "host",
            statusText: isMe ? "Host (You)" : "Host (Online)",
            isYou: isMe
          });
        } else {
          const client = seatToClient.get(sId);
          if (client) {
            list.push({
              id: sId,
              num: i,
              name: client.name || `Player ${i}`,
              type: "human",
              status: "online",
              statusText: isMe ? "Online (You)" : "Online",
              isYou: isMe
            });
          } else if (settings3.netRole === "guest") {
            list.push({
              id: sId,
              num: i,
              name: isMe ? document.getElementById("optPlayerName") && document.getElementById("optPlayerName").value.trim() || `Player ${i}` : `Player ${i}`,
              type: isMe ? "human" : "cpu",
              status: isMe ? "online" : "waiting",
              statusText: isMe ? "Online (You)" : "Waiting\u2026",
              isYou: isMe
            });
          } else {
            const defaultBotName = { p2: "The Shark", p3: "The Gambler", p4: "The Turtler", p5: "The Gambler", p6: "The Turtler", p7: "The Shark", p8: "The Gambler" }[sId] || `Bot ${i}`;
            list.push({
              id: sId,
              num: i,
              name: defaultBotName,
              type: "cpu",
              status: "waiting",
              statusText: "Open (or Bot)",
              isYou: false
            });
          }
        }
      }
      return list;
    }
    /**
     * Resolves seat configurations for a match given player count, CPU allowance, and UI option values.
     * @param {number|string} playerCount
     * @param {boolean} allowCpu
     * @param {Object} [options]
     * @returns {Array<Object>}
     */
    static resolveSeatConfigs(playerCount, allowCpu = true, options = {}) {
      const pCountNum = parseInt(playerCount, 10) || 2;
      const opp = options.opp || "cpu";
      const aiProfile = options.aiProfile || "shark";
      const seatValues = options.seatValues || {};
      const parseSeatVal = (val, defaultPers, defaultName, team, seatNum) => {
        if (!allowCpu || val === "human") return { type: "human", personality: defaultPers, name: defaultName, team };
        const parts = (val || "").split(":");
        const pers = parts[1] || defaultPers;
        let botName = "";
        if (typeof document !== "undefined" && seatNum) {
          const el = document.getElementById(`optSeat${seatNum}Type`);
          if (el && el.selectedIndex >= 0) {
            const text2 = el.options[el.selectedIndex]?.textContent || "";
            const m = text2.match(/(?:[—–-]\s*)([^(]+)/);
            if (m && m[1].trim()) {
              botName = m[1].trim();
            }
          }
        }
        const avatarMap = {
          expert: "shark",
          shark: "shark",
          master: "king",
          advanced: "turtler",
          turtler: "turtler",
          maverick: "steampunk",
          intermediate: "gambler",
          gambler: "gambler",
          regular: "velvet_fox",
          beginner: "jack",
          rookie: "jack",
          casual: "pint_master"
        };
        if (!botName || botName.startsWith("Player")) {
          const defaultBotNames = { 2: "The Shark", 3: "The Regular", 4: "The Turtler", 5: "The Maverick", 6: "The Grandmaster", 7: "The Rookie", 8: "The Casual" };
          const nameMap = {
            expert: "The Shark",
            shark: "The Shark",
            master: "The Grandmaster",
            advanced: "The Turtler",
            turtler: "The Turtler",
            maverick: "The Maverick",
            intermediate: "The Gambler",
            gambler: "The Gambler",
            regular: "The Regular",
            beginner: "The Rookie",
            rookie: "The Rookie",
            casual: "The Casual"
          };
          botName = nameMap[pers] || defaultBotNames && defaultBotNames[seatNum] || "Computer";
        }
        const botAvatar = avatarMap[pers] || "jack";
        return { type: "cpu", personality: pers, name: botName, avatar: botAvatar, team };
      };
      if (pCountNum === 2) {
        const oppType = allowCpu ? opp : "human";
        const nameMap = {
          expert: "The Shark",
          shark: "The Shark",
          master: "The Grandmaster",
          advanced: "The Turtler",
          turtler: "The Turtler",
          maverick: "The Maverick",
          intermediate: "The Gambler",
          gambler: "The Gambler",
          regular: "The Regular",
          beginner: "The Rookie",
          rookie: "The Rookie",
          casual: "The Casual"
        };
        const avatarMap = {
          expert: "shark",
          shark: "shark",
          master: "king",
          advanced: "turtler",
          turtler: "turtler",
          maverick: "steampunk",
          intermediate: "gambler",
          gambler: "gambler",
          regular: "velvet_fox",
          beginner: "jack",
          rookie: "jack",
          casual: "pint_master"
        };
        const botName = nameMap[aiProfile] || "Computer";
        const botAvatar = avatarMap[aiProfile] || "shark";
        return [
          { id: "p1", name: "You", type: "human", personality: "shark", team: 1, color: "#d4a017" },
          { id: "p2", name: oppType === "cpu" ? botName : "Player 2", type: oppType === "cpu" ? "cpu" : "human", personality: aiProfile || "shark", avatar: oppType === "cpu" ? botAvatar : "queen", team: 2, color: "#ef4444" },
          { id: "p3", name: "Seat 3", type: allowCpu ? "cpu" : "human", personality: "regular", avatar: "velvet_fox", team: 1, color: "#10b981" },
          { id: "p4", name: "Seat 4", type: allowCpu ? "cpu" : "human", personality: "turtler", avatar: "turtler", team: 2, color: "#3b82f6" },
          { id: "p5", name: "Seat 5", type: allowCpu ? "cpu" : "human", personality: "maverick", avatar: "steampunk", team: 1, color: "#a855f7" },
          { id: "p6", name: "Seat 6", type: allowCpu ? "cpu" : "human", personality: "master", avatar: "king", team: 2, color: "#f97316" },
          { id: "p7", name: "Seat 7", type: allowCpu ? "cpu" : "human", personality: "rookie", avatar: "jack", team: 3, color: "#06b6d4" },
          { id: "p8", name: "Seat 8", type: allowCpu ? "cpu" : "human", personality: "casual", avatar: "pint_master", team: 4, color: "#ec4899" }
        ];
      }
      const s2Val = seatValues.s2 || typeof document !== "undefined" && document.getElementById("optSeat2Type") && document.getElementById("optSeat2Type").value || "cpu:shark";
      const s3Val = seatValues.s3 || typeof document !== "undefined" && document.getElementById("optSeat3Type") && document.getElementById("optSeat3Type").value || "cpu:regular";
      const s4Val = seatValues.s4 || typeof document !== "undefined" && document.getElementById("optSeat4Type") && document.getElementById("optSeat4Type").value || "cpu:turtler";
      const s5Val = seatValues.s5 || typeof document !== "undefined" && document.getElementById("optSeat5Type") && document.getElementById("optSeat5Type").value || "cpu:maverick";
      const s6Val = seatValues.s6 || typeof document !== "undefined" && document.getElementById("optSeat6Type") && document.getElementById("optSeat6Type").value || "cpu:master";
      const s7Val = seatValues.s7 || typeof document !== "undefined" && document.getElementById("optSeat7Type") && document.getElementById("optSeat7Type").value || "cpu:rookie";
      const s8Val = seatValues.s8 || typeof document !== "undefined" && document.getElementById("optSeat8Type") && document.getElementById("optSeat8Type").value || "cpu:casual";
      const s2 = parseSeatVal(s2Val, "shark", "Player 2", 2, 2);
      const s3 = parseSeatVal(s3Val, "regular", "Player 3", 1, 3);
      const s4 = parseSeatVal(s4Val, "turtler", "Player 4", 2, 4);
      const s5 = parseSeatVal(s5Val, "maverick", "Player 5", 1, 5);
      const s6 = parseSeatVal(s6Val, "master", "Player 6", 3, 6);
      const s7 = parseSeatVal(s7Val, "rookie", "Player 7", 3, 7);
      const s8 = parseSeatVal(s8Val, "casual", "Player 8", 4, 8);
      return [
        { id: "p1", name: "You", type: "human", personality: "shark", team: 1, color: "#d4a017" },
        { id: "p2", name: s2.name, type: s2.type, personality: s2.personality, avatar: s2.avatar, team: 2, color: "#ef4444" },
        { id: "p3", name: s3.name, type: s3.type, personality: s3.personality, avatar: s3.avatar, team: 1, color: "#10b981" },
        { id: "p4", name: s4.name, type: s4.type, personality: s4.personality, avatar: s4.avatar, team: 2, color: "#3b82f6" },
        { id: "p5", name: s5.name, type: s5.type, personality: s5.personality, avatar: s5.avatar, team: 1, color: "#a855f7" },
        { id: "p6", name: s6.name, type: s6.type, personality: s6.personality, avatar: s6.avatar, team: 3, color: "#f97316" },
        { id: "p7", name: s7.name, type: s7.type, personality: s7.personality, avatar: s7.avatar, team: 3, color: "#06b6d4" },
        { id: "p8", name: s8.name, type: s8.type, personality: s8.personality, avatar: s8.avatar, team: 4, color: "#ec4899" }
      ];
    }
    /**
     * Generates the list of mode pills badges for the match header.
     * @param {Object} settings
     * @param {Object} [options]
     * @returns {Array<string>}
     */
    static generateModePills(settings3 = {}, options = {}) {
      const pCountNum = parseInt(settings3.playerCount, 10) || 2;
      const allowCpu = options.allowCpu != null ? options.allowCpu : true;
      const isOnline2 = options.isOnline || (typeof window !== "undefined" && window.isOnline ? window.isOnline : () => false);
      const isHvH2 = options.isHvH || (typeof window !== "undefined" && window.isHvH ? window.isHvH : () => false);
      const is3Player1vs22 = options.is3Player1vs2 || (typeof window !== "undefined" && window.is3Player1vs2 ? window.is3Player1vs2 : () => false);
      const getNoPassingLanes2 = options.getNoPassingLanes || (typeof window !== "undefined" && window.getNoPassingLanes ? window.getNoPassingLanes : () => []);
      const getJumpConfigs2 = options.getJumpConfigs || (typeof window !== "undefined" && window.getJumpConfigs ? window.getJumpConfigs : () => []);
      const getJailConfigs2 = options.getJailConfigs || (typeof window !== "undefined" && window.getJailConfigs ? window.getJailConfigs : () => []);
      const getBarConfigs2 = options.getBarConfigs || (typeof window !== "undefined" && window.getBarConfigs ? window.getBarConfigs : () => []);
      const getTimeoutConfigs2 = options.getTimeoutConfigs || (typeof window !== "undefined" && window.getTimeoutConfigs ? window.getTimeoutConfigs : () => []);
      const getDetourConfigs2 = options.getDetourConfigs || (typeof window !== "undefined" && window.getDetourConfigs ? window.getDetourConfigs : () => []);
      const getRoundAboutConfigs2 = options.getRoundAboutConfigs || (typeof window !== "undefined" && window.getRoundAboutConfigs ? window.getRoundAboutConfigs : () => []);
      const getSignConfigs2 = options.getSignConfigs || (typeof window !== "undefined" && window.getSignConfigs ? window.getSignConfigs : () => []);
      const pills = [];
      if (pCountNum === 2) {
        if (!allowCpu) {
          pills.push(isOnline2() ? "Online" : "Human vs human");
        } else {
          pills.push(isOnline2() ? "Online" : isHvH2() ? "Human vs human" : "vs computer");
          if (settings3.opp === "cpu") {
            const pLabel = {
              shark: "Shark AI",
              gambler: "Gambler AI",
              turtler: "Turtler AI"
            }[settings3.aiProfile] || "Shark AI";
            pills.push(pLabel);
          }
        }
      } else if (pCountNum === 3) {
        pills.push(is3Player1vs22() ? "3 Players (1 vs 2)" : "3 Players (Individual)");
      } else if (pCountNum === 4 && settings3.gameMode === "indiv") {
        pills.push("4 Players (Cutthroat)");
      } else if (pCountNum === 4 && settings3.gameMode === "partnership") {
        pills.push("4 Players (Partnership 2v2)");
      } else if (pCountNum === 5) {
        pills.push("5 Players (1 vs 2 Pairs)");
      } else if (pCountNum === 6) {
        pills.push("6 Players (3 Teams of 2)");
      } else if (pCountNum === 7) {
        pills.push("7 Players (1 vs 3 Pairs)");
      } else if (pCountNum === 8) {
        pills.push("8 Players (4 Teams of 2)");
      }
      if (settings3.coach === "on") pills.push("Coach on");
      if (settings3.optCanadianDoubles && pCountNum === 4) {
        pills.push("Deal (10 / keep 4 / pass 4 / crib 2)");
      } else if (settings3.playerCount >= 3) {
        pills.push("Deal (5 / discard 1)");
      } else {
        pills.push(settings3.deal === "super" ? "Super (9 / discard 3)" : "Standard (6 / discard 2)");
      }
      pills.push(settings3.decks === 2 ? "2 decks" : "1 deck");
      const currentBrand = options.brand || (typeof options.getAppBrand === "function" ? options.getAppBrand() : settings3.brand || (typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : "crazy"));
      if (currentBrand === "crazy") {
        if (settings3.jokers) pills.push("jokers wild");
        if (settings3.optCutBeforeDiscard) pills.push("cut before discard");
        if (settings3.opt31sFor5) pills.push("31's for 5");
        if (settings3.opt19sFor2) pills.push("19's for 2");
        if (settings3.optRoundAroundTheWorld) pills.push("round around the world");
        if (settings3.optMultipleRunsInPegging) pills.push("multiple runs in pegging");
        if (settings3.optPickYourCrib) pills.push("pick your crib");
        if (settings3.optSpeedoCribbage && settings3.playerCount === 2) pills.push("speedo cribbage");
        if (settings3.optShotgunCribbage) pills.push("shotgun cribbage");
        if (settings3.optTwistedCribbage && settings3.playerCount === 2) pills.push("twisted cribbage");
        if (settings3.optChutesAndLadders) pills.push("chutes and ladders");
        if (settings3.optFivesCribbage) pills.push("five's cribbage");
        if (settings3.optSevensAndEightsCribbage) pills.push("sevens and eights cribbage");
        if (settings3.optDrawCribbage && settings3.playerCount === 2) pills.push("draw cribbage");
        if (settings3.opt7CardCribbage && settings3.playerCount === 2) pills.push("7 card cribbage");
        if (settings3.optProgressiveCut && settings3.playerCount === 2) pills.push("progressive cut");
        if (settings3.optCanadianDoubles && settings3.playerCount === 4) pills.push("canadian doubles");
        if (settings3.optProgressiveSteals) pills.push("progressive steals");
        if (settings3.optAllRed) pills.push("all red");
        if (settings3.optAllBlack) pills.push("all black");
        if (settings3.optAllOdd) pills.push("all odd");
        if (settings3.optAllEven) pills.push("all even");
        if (settings3.optAllDifferentSuits) pills.push("diff suits");
        if (settings3.optKH) pills.push("KH +5");
        if (settings3.optQS) pills.push("QS +5");
        if (settings3.optAS) pills.push("AS +5");
        if (settings3.optSpades) pills.push("spades");
        if (settings3.optGuessStarter) pills.push("guess starter");
        if (settings3.optStraight) pills.push("straight +10");
        if (settings3.optFullHouse) pills.push("full house +10");
        if (settings3.optStraightFlush) pills.push("straight flush +20");
        if (settings3.optRoyalFlush) pills.push("royal flush +30");
        if (settings3.optFlushInPlay) pills.push("flush in play");
        if (settings3.optRockCrib) pills.push("rock the crib");
        if (settings3.optStinkHole) pills.push("stink hole");
        if (settings3.optPegThroughZones) pills.push("peg through zones");
        if (settings3.optLast5PegOut) pills.push("last 5 peg out");
        if (settings3.optBunkers) pills.push("bunkers");
        if (settings3.optStolenCrib && settings3.playerCount === 2) pills.push("stolen crib");
        if (settings3.optZeroHand) pills.push("zero hand \u221219");
        if (settings3.optZeroCrib) pills.push("zero crib \u221219");
      } else if (currentBrand === "clash") {
        if (settings3.optNoPassingLanes) {
          const laneCount = getNoPassingLanes2().length;
          pills.push(`no passing lanes (${laneCount})`);
        }
        if (settings3.optJump) {
          const jCount = getJumpConfigs2().length;
          pills.push(`jump (${jCount})`);
        }
        if (settings3.optJail) {
          const jailCount = getJailConfigs2().length;
          pills.push(`jail (${jailCount})`);
        }
        if (settings3.optBar) {
          const barCount = getBarConfigs2().length;
          pills.push(`the bar (${barCount})`);
        }
        if (settings3.optTimeout) {
          const timeoutCount = getTimeoutConfigs2().length;
          pills.push(`timeout (${timeoutCount})`);
        }
        if (settings3.optDetour) {
          const detourCount = getDetourConfigs2().length;
          pills.push(`detour (${detourCount})`);
        }
        if (settings3.optRoundAbout) {
          const roundAboutCount = getRoundAboutConfigs2().length;
          pills.push(`round about (${roundAboutCount})`);
        }
        if (settings3.optSigns) {
          const signsCount = getSignConfigs2().length;
          pills.push(`signs (${signsCount})`);
        }
        if (settings3.optDice) {
          const getDice = options.getDiceConfigs || (typeof window !== "undefined" && window.getDiceConfigs ? window.getDiceConfigs : () => []);
          const diceCount = getDice().length;
          pills.push(`dice (${diceCount || settings3.diceCount || 4})`);
        }
        if (settings3.optWheel || settings3.optSpinningWheel) {
          const getWheels = options.getWheelConfigs || (typeof window !== "undefined" && window.getWheelConfigs ? window.getWheelConfigs : () => []);
          const wheelCount = getWheels().length;
          pills.push(`spinning wheel (${wheelCount || settings3.wheelCount || 4})`);
        }
        if (settings3.optSkunkMarkers) pills.push("skunk markers");
      }
      pills.push(settings3.goal === "low" ? "Low ball" : "High ball");
      if ((settings3.brand === "clash" || currentBrand === "clash") && [241, 361, 481].includes(settings3.target)) {
        pills.push("Cribbage Clash (to " + settings3.target + ")");
      } else if (settings3.target === 241) {
        pills.push("to 241 (There and Back)");
      } else {
        pills.push("to " + (settings3.target || 121));
      }
      return pills;
    }
    /**
     * Enforces mutual exclusivity among zone options (optPegThroughZones, optLast5PegOut, optBunkers, optStinkHole).
     * @param {HTMLElement} changedEl
     * @param {Object} [context]
     */
    static handleZoneOptionChange(changedEl, context = {}) {
      if (!changedEl || !changedEl.checked) return;
      const updateCheckAllBonusesState2 = context.updateCheckAllBonusesState || (typeof window !== "undefined" ? window.updateCheckAllBonusesState : () => {
      });
      const zoneIds = ["optPegThroughZones", "optLast5PegOut", "optBunkers", "optStinkHole"];
      if (typeof document !== "undefined") {
        zoneIds.forEach((id) => {
          if (id !== changedEl.id) {
            const other = document.getElementById(id);
            if (other) other.checked = false;
          }
        });
      }
      updateCheckAllBonusesState2();
      if (typeof window !== "undefined" && typeof window.saveSettingsStore === "function" && typeof window.readFormSettings === "function") {
        window.saveSettingsStore(window.readFormSettings());
      }
    }
    static handleCribOptionChange(changedEl, context = {}) {
      if (!changedEl || typeof document === "undefined") return;
      const curSettings = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (!changedEl.checked) {
        if (curSettings) {
          const optDef = CRAZY_OPTIONS_DEFS.find((o) => o.chkId === changedEl.id || o.key === changedEl.id);
          if (optDef) {
            curSettings[optDef.key] = false;
            if (optDef.chkId) curSettings[optDef.chkId] = false;
          }
        }
        _LobbyController.syncVariantPlayerCountConstraints({ ...context, changedEl });
        const updateCheckAllBonusesState3 = context.updateCheckAllBonusesState || (typeof window !== "undefined" ? window.updateCheckAllBonusesState : () => {
        });
        updateCheckAllBonusesState3();
        return;
      }
      const updateCheckAllBonusesState2 = context.updateCheckAllBonusesState || (typeof window !== "undefined" ? window.updateCheckAllBonusesState : () => {
      });
      if (changedEl.id === "optShotgunCribbage") {
        ["optRockCrib", "optZeroCrib", "optStolenCrib", "optTwistedCribbage"].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.checked = false;
        });
      } else if (["optRockCrib", "optZeroCrib", "optStolenCrib"].includes(changedEl.id)) {
        const el = document.getElementById("optShotgunCribbage");
        if (el) el.checked = false;
      } else if (changedEl.id === "optTwistedCribbage") {
        ["optShotgunCribbage", "opt7CardCribbage"].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.checked = false;
        });
      }
      if (changedEl.id === "opt7CardCribbage") {
        ["optSpeedoCribbage", "optPickYourCrib", "optDrawCribbage", "optTwistedCribbage"].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.checked = false;
        });
      } else if (changedEl.id === "optDrawCribbage") {
        ["optSpeedoCribbage", "optPickYourCrib", "optFivesCribbage", "optSevensAndEightsCribbage", "opt7CardCribbage"].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.checked = false;
        });
      } else if (changedEl.id === "optFivesCribbage") {
        ["optSpeedoCribbage", "optPickYourCrib", "optSevensAndEightsCribbage", "optDrawCribbage"].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.checked = false;
        });
      } else if (changedEl.id === "optSevensAndEightsCribbage") {
        ["optSpeedoCribbage", "optPickYourCrib", "optFivesCribbage", "optDrawCribbage"].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.checked = false;
        });
      } else if (["optSpeedoCribbage", "optPickYourCrib"].includes(changedEl.id)) {
        const el5 = document.getElementById("optFivesCribbage");
        if (el5) el5.checked = false;
        const el78 = document.getElementById("optSevensAndEightsCribbage");
        if (el78) el78.checked = false;
        const elDraw = document.getElementById("optDrawCribbage");
        if (elDraw) elDraw.checked = false;
        const el7Card = document.getElementById("opt7CardCribbage");
        if (el7Card) el7Card.checked = false;
      }
      const res = _LobbyController.syncVariantPlayerCountConstraints({ ...context, changedEl });
      if (res.activeRestrictedVariant) {
        const pCountEl = document.getElementById("optPlayerCount");
        if (pCountEl) {
          pCountEl.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (context.syncPlayerCountUi) {
          context.syncPlayerCountUi();
        } else if (typeof window !== "undefined" && typeof window.syncPlayerCountUi === "function") {
          window.syncPlayerCountUi();
        } else {
          _LobbyController.syncPlayerCountUi(context);
        }
      }
      updateCheckAllBonusesState2();
      if (typeof window !== "undefined" && typeof window.saveSettingsStore === "function" && typeof window.readFormSettings === "function") {
        window.saveSettingsStore(window.readFormSettings());
      }
    }
    handleZoneOptionChange(changedEl, context) {
      return _LobbyController.handleZoneOptionChange(changedEl, context);
    }
    /**
     * Randomizes the bonus options for Crazy Cribbage.
     * @param {Object} [context]
     */
    static randomizeCrazyCribbageBonuses(context = {}) {
      const GameOptionsEngine2 = context.GameOptionsEngine || (typeof window !== "undefined" ? window.GameOptionsEngine : null);
      if (GameOptionsEngine2 && typeof GameOptionsEngine2.randomizeBrandOptions === "function") {
        return GameOptionsEngine2.randomizeBrandOptions("crazy", false);
      }
      if (typeof document === "undefined") return;
      const items = document.querySelectorAll(".crazy-only-options input");
      items.forEach((opt) => opt.checked = false);
      const getRandomSubset2 = context.getRandomSubset || (typeof window !== "undefined" ? window.getRandomSubset : (arr) => arr.filter(() => Math.random() > 0.5));
      const rand = getRandomSubset2(items);
      rand.forEach((item) => item.checked = true);
    }
    /**
     * Checks age verification on startup for brands requiring age gating.
     * @param {Object} [context]
     */
    static checkInitialAgeGate(context = {}) {
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "crazy");
      const isAgeVerified2 = context.isAgeVerified || (typeof window !== "undefined" ? window.isAgeVerified : () => false);
      const showAgeGateModal2 = context.showAgeGateModal || (typeof window !== "undefined" ? window.showAgeGateModal : () => {
      });
      const brand = getAppBrand2();
      if ((brand === "pints" || brand === "adult") && !isAgeVerified2(brand)) {
        showAgeGateModal2(brand);
      }
    }
    /**
     * Wires master 'Check All Bonuses' checkbox and handles individual option change events.
     * @param {Object} [context]
     */
    static setupCheckAllBonuses(context = {}) {
      if (typeof document === "undefined") return;
      const updateCheckAllBonusesState2 = context.updateCheckAllBonusesState || (typeof window !== "undefined" ? window.updateCheckAllBonusesState : () => {
      });
      const parseGameMode2 = context.parseGameMode || (typeof window !== "undefined" ? window.parseGameMode : ((v) => ({ playerCount: parseInt(v, 10) || 2 })));
      const toggleSignsConfig2 = context.toggleSignsConfig || (typeof window !== "undefined" ? window.toggleSignsConfig : () => {
      });
      const toggleDetourConfig2 = context.toggleDetourConfig || (typeof window !== "undefined" ? window.toggleDetourConfig : () => {
      });
      const toggleRoundAboutConfig2 = context.toggleRoundAboutConfig || (typeof window !== "undefined" ? window.toggleRoundAboutConfig : () => {
      });
      const handleZoneOptionChange2 = context.handleZoneOptionChange || (typeof window !== "undefined" ? window.handleZoneOptionChange : _LobbyController.handleZoneOptionChange);
      const checkAllBonusesEl = document.getElementById("checkAllBonuses");
      if (checkAllBonusesEl) {
        const handleCheckAllToggle = () => {
          const checkedState = checkAllBonusesEl.checked;
          const opts = document.querySelectorAll(".bonuses .chk input");
          const countVal = document.getElementById("optPlayerCount") && document.getElementById("optPlayerCount").value || "2";
          const { playerCount, gameMode } = parseGameMode2(countVal);
          opts.forEach((opt) => {
            const def = CRAZY_OPTIONS_DEFS.find((d) => d.chkId === opt.id || d.key === opt.id);
            if (checkedState && (opt.id === "optLast5PegOut" || opt.id === "optBunkers" || opt.id === "optStinkHole" || opt.id === "optShotgunCribbage")) {
              opt.checked = false;
            } else if (checkedState && def && def.requiredPlayers != null && !CrazyManager.isPlayerCountAllowedForVariant(def, playerCount, gameMode, countVal)) {
              opt.checked = false;
            } else {
              opt.checked = checkedState;
            }
            if (opt.id === "optSigns") toggleSignsConfig2(opt.checked);
            if (opt.id === "optDetour") toggleDetourConfig2(opt.checked);
            if (opt.id === "optRoundAbout") toggleRoundAboutConfig2(opt.checked);
          });
          _LobbyController.syncVariantPlayerCountConstraints(context);
          const GameOptionsEngine2 = context.GameOptionsEngine || (typeof window !== "undefined" ? window.GameOptionsEngine : null) || (typeof globalThis !== "undefined" ? globalThis.GameOptionsEngine : null);
          if (GameOptionsEngine2 && typeof GameOptionsEngine2.updateSubgroupActiveBadges === "function") {
            GameOptionsEngine2.updateSubgroupActiveBadges("crazy", document.getElementById("brand-game-options"));
          }
          if (typeof window !== "undefined" && typeof window.saveSettingsStore === "function" && typeof window.readFormSettings === "function") {
            window.saveSettingsStore(window.readFormSettings());
          }
        };
        checkAllBonusesEl.onclick = handleCheckAllToggle;
        checkAllBonusesEl.addEventListener("change", handleCheckAllToggle);
      }
      document.querySelectorAll(".bonuses .chk input").forEach((opt) => {
        opt.addEventListener("change", updateCheckAllBonusesState2);
      });
      ["optPegThroughZones", "optLast5PegOut", "optBunkers", "optStinkHole"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          el.addEventListener("change", () => handleZoneOptionChange2(el, context));
        }
      });
      ["optShotgunCribbage", "optRockCrib", "optZeroCrib", "optStolenCrib", "optTwistedCribbage", "optFivesCribbage", "optSevensAndEightsCribbage", "optDrawCribbage", "optSpeedoCribbage", "optPickYourCrib", "opt7CardCribbage", "optProgressiveCut", "optCanadianDoubles"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          el.addEventListener("change", () => _LobbyController.handleCribOptionChange(el, context));
        }
      });
      if (!_LobbyController._variantConstraintsDelegatedAttached) {
        _LobbyController._variantConstraintsDelegatedAttached = true;
        document.addEventListener("change", (e) => {
          if (e.target && (e.target.id === "optCanadianDoubles" || CRAZY_OPTIONS_DEFS.some((o) => o.chkId === e.target.id || o.key === e.target.id))) {
            _LobbyController.handleCribOptionChange(e.target, context);
          }
        });
      }
      const pCountSelectEl = document.getElementById("optPlayerCount");
      if (pCountSelectEl && !pCountSelectEl._variantConstraintsSyncBound) {
        pCountSelectEl._variantConstraintsSyncBound = true;
        pCountSelectEl.addEventListener("change", () => {
          const { playerCount: newCount, gameMode: newMode } = parseGameMode2(pCountSelectEl.value);
          CRAZY_OPTIONS_DEFS.forEach((opt) => {
            if (opt.requiredPlayers != null) {
              if (!CrazyManager.isPlayerCountAllowedForVariant(opt, newCount, newMode, pCountSelectEl.value)) {
                const chk = document.getElementById(opt.chkId || opt.key);
                if (chk && chk.checked) {
                  chk.checked = false;
                  const currentSettings = context.settings || (typeof window !== "undefined" ? window.settings : null);
                  if (currentSettings) {
                    currentSettings[opt.key] = false;
                    if (opt.chkId) currentSettings[opt.chkId] = false;
                  }
                }
              }
            }
          });
          _LobbyController.syncVariantPlayerCountConstraints(context);
        });
      }
      updateCheckAllBonusesState2();
    }
    /**
     * Turns off bonus options from all games/brands other than the active brand.
     * Cleanses the target settings object and unchecks corresponding DOM elements.
     * @param {string} activeBrand
     * @param {Object} targetSettings
     * @param {Object} [context]
     * @returns {Object} Cleaned targetSettings
     */
    static disableOtherGameBonusOptions(activeBrand = "crazy", targetSettings = {}, context = {}) {
      if (!targetSettings) return targetSettings;
      const allBrands = ["crazy", "clash", "pints", "adult"];
      const configs = context.GAME_CONFIGS || (typeof window !== "undefined" ? window.GAME_CONFIGS : null);
      allBrands.forEach((b) => {
        if (b === activeBrand) return;
        if (configs && typeof configs.getGame === "function") {
          try {
            const gameConf = configs.getGame(b);
            if (gameConf && Array.isArray(gameConf.options)) {
              gameConf.options.forEach((opt) => {
                if (opt.key) targetSettings[opt.key] = false;
                if (opt.chkId) targetSettings[opt.chkId] = false;
                if (opt.prefix) targetSettings[opt.prefix] = false;
                if (opt.type === "trackItem") {
                  targetSettings[`${opt.key}Count`] = 0;
                  targetSettings[`${opt.key}Starts`] = [];
                  targetSettings[`${opt.key}Holes`] = [];
                  targetSettings[`${opt.key}Dests`] = [];
                  targetSettings[`${opt.key}Pegs`] = 0;
                }
                if (opt.type === "skunkSpecial") {
                  targetSettings.optSkunkMarkers = false;
                  targetSettings.skunkMarkers = false;
                }
              });
            }
          } catch (e) {
          }
        }
        if (b === "clash") {
          const clashKeys = [
            "optNoPassingLanes",
            "noPassingLanes",
            "optJump",
            "jump",
            "optJail",
            "jail",
            "optBar",
            "bar",
            "optTimeout",
            "timeout",
            "optDetour",
            "detour",
            "optRoundAbout",
            "roundAbout",
            "optSigns",
            "signs",
            "optStopSign",
            "stopSign",
            "optDice",
            "dice",
            "optWheel",
            "wheel",
            "optSpinningWheel",
            "spinningWheel",
            "optSkunkMarkers",
            "skunkMarkers"
          ];
          clashKeys.forEach((k) => {
            targetSettings[k] = false;
          });
          targetSettings.noPassingLaneStarts = [];
          targetSettings.noPassingLaneHoles = [];
          targetSettings.noPassingLaneCount = 0;
          targetSettings.noPassingLanesCount = 0;
          targetSettings.jumpStarts = [];
          targetSettings.jumpDests = [];
          targetSettings.jumpCount = 0;
          targetSettings.optJumpCount = 0;
          targetSettings.jailHoles = [];
          targetSettings.jailStarts = [];
          targetSettings.jailCount = 0;
          targetSettings.barHoles = [];
          targetSettings.barStarts = [];
          targetSettings.barCount = 0;
          targetSettings.timeoutHoles = [];
          targetSettings.timeoutStarts = [];
          targetSettings.timeoutCount = 0;
          targetSettings.detourHoles = [];
          targetSettings.detourStarts = [];
          targetSettings.detourCount = 0;
          targetSettings.roundAboutHoles = [];
          targetSettings.roundAboutStarts = [];
          targetSettings.roundAboutCount = 0;
          targetSettings.signsBlocks = [];
          targetSettings.signsCount = 0;
          targetSettings.stopSignHoles = [];
          targetSettings.stopSignStarts = [];
          targetSettings.stopSignCount = 0;
          targetSettings.diceHoles = [];
          targetSettings.diceCount = 0;
          targetSettings.optDiceCount = 0;
          targetSettings.wheelHoles = [];
          targetSettings.wheelCount = 0;
          targetSettings.optWheelCount = 0;
          targetSettings.spinningWheelHoles = [];
          targetSettings.spinningWheelCount = 0;
          targetSettings.clashPreset = null;
          targetSettings.clashCustomLayoutId = null;
        } else if (b === "crazy") {
          const crazyKeys = [
            "jokers",
            "optJokers",
            "optCutBeforeDiscard",
            "opt31sFor5",
            "opt19sFor2",
            "optRoundAroundTheWorld",
            "optMultipleRunsInPegging",
            "optAllRed",
            "optAllBlack",
            "optAllOdd",
            "optAllEven",
            "optAllDifferentSuits",
            "optKH",
            "optQS",
            "optAS",
            "optStraight",
            "optFullHouse",
            "optStraightFlush",
            "optRoyalFlush",
            "optFlushInPlay",
            "optPegThroughZones",
            "optLast5PegOut",
            "optBunkers",
            "optStinkHole",
            "optStolenCrib",
            "optZeroHand",
            "optZeroCrib",
            "optRockCrib",
            "optPickYourCrib",
            "optSpeedoCribbage",
            "optShotgunCribbage",
            "optTwistedCribbage",
            "optChutesAndLadders",
            "optSpades",
            "optGuessStarter",
            "optFivesCribbage",
            "optSevensAndEightsCribbage",
            "optDrawCribbage",
            "opt7CardCribbage",
            "optProgressiveCut",
            "optCanadianDoubles",
            "optProgressiveSteals"
          ];
          crazyKeys.forEach((k) => {
            targetSettings[k] = false;
          });
        } else if (b === "pints") {
          const pintsKeys = [
            "youDrink",
            "optYouDrink",
            "guysDrink",
            "optGuysDrink",
            "galsDrink",
            "optGalsDrink",
            "leftDrink",
            "optLeftDrink",
            "rightDrink",
            "optRightDrink",
            "everyoneDrink",
            "optEveryoneDrink",
            "everyoneButYouDrink",
            "optEveryoneButYouDrink",
            "pickWhoDrinks",
            "optPickWhoDrinks"
          ];
          pintsKeys.forEach((k) => {
            targetSettings[k] = false;
            targetSettings[`${k}Count`] = 0;
            targetSettings[`${k}Holes`] = [];
            targetSettings[`${k}Pegs`] = 0;
          });
        } else if (b === "adult") {
          const adultKeys = [
            "loseClothing",
            "optLoseClothing",
            "gainClothing",
            "optGainClothing",
            "pickWhoLosesClothing",
            "optPickWhoLosesClothing",
            "rightLosesClothing",
            "optRightLosesClothing",
            "leftLosesClothing",
            "optLeftLosesClothing",
            "removeClothingChoice",
            "optRemoveClothingChoice",
            "touchBreast",
            "optTouchBreast",
            "lickBreast",
            "optLickBreast",
            "suckBreast",
            "optSuckBreast",
            "touchGenitals",
            "optTouchGenitals",
            "lickGenitals",
            "optLickGenitals",
            "suckGenitals",
            "optSuckGenitals",
            "fingerGenitals",
            "optFingerGenitals",
            "genitalIntercourse",
            "optGenitalIntercourse",
            "touchAnus",
            "optTouchAnus",
            "lickAnus",
            "optLickAnus",
            "fingerAnus",
            "optFingerAnus",
            "analIntercourse",
            "optAnalIntercourse"
          ];
          adultKeys.forEach((k) => {
            targetSettings[k] = false;
            targetSettings[`${k}Count`] = 0;
            targetSettings[`${k}Holes`] = [];
            targetSettings[`${k}Pegs`] = 0;
          });
        }
        if (typeof document !== "undefined") {
          try {
            if (b === "clash") {
              const clashChkIds = [
                "optNoPassingLanes",
                "optJump",
                "optJail",
                "optBar",
                "optTimeout",
                "optDetour",
                "optRoundAbout",
                "optSigns",
                "optStopSign",
                "optDice",
                "optWheel",
                "optSpinningWheel",
                "optSkunkMarkers"
              ];
              clashChkIds.forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.checked = false;
              });
              const clashOnly = document.querySelectorAll('.clash-only-options input[type="checkbox"], #cribbage-clash-options input[type="checkbox"]');
              clashOnly.forEach((el) => {
                el.checked = false;
              });
            } else if (b === "crazy") {
              const crazyChkIds = [
                "optJokers",
                "optCutBeforeDiscard",
                "opt31sFor5",
                "opt19sFor2",
                "optRoundAroundTheWorld",
                "optMultipleRunsInPegging",
                "optAllRed",
                "optAllBlack",
                "optAllOdd",
                "optAllEven",
                "optAllDifferentSuits",
                "optKH",
                "optQS",
                "optAS",
                "optStraight",
                "optFullHouse",
                "optStraightFlush",
                "optRoyalFlush",
                "optFlushInPlay",
                "optPegThroughZones",
                "optLast5PegOut",
                "optBunkers",
                "optStinkHole",
                "optStolenCrib",
                "optZeroHand",
                "optZeroCrib",
                "optRockCrib",
                "optPickYourCrib",
                "optSpeedoCribbage",
                "optShotgunCribbage",
                "optTwistedCribbage",
                "optChutesAndLadders",
                "optSpades",
                "optGuessStarter",
                "optFivesCribbage",
                "optSevensAndEightsCribbage",
                "optDrawCribbage",
                "opt7CardCribbage",
                "optProgressiveCut",
                "optCanadianDoubles",
                "optProgressiveSteals"
              ];
              crazyChkIds.forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.checked = false;
              });
              const checkAll = document.getElementById("checkAllBonuses");
              if (checkAll) checkAll.checked = false;
            } else if (b === "pints") {
              const pintsChkIds = [
                "optYouDrink",
                "optGuysDrink",
                "optGalsDrink",
                "optLeftDrink",
                "optRightDrink",
                "optEveryoneDrink",
                "optEveryoneButYouDrink",
                "optPickWhoDrinks"
              ];
              pintsChkIds.forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.checked = false;
              });
              const pintsOnly = document.querySelectorAll('#pints-options input[type="checkbox"], .pints-only-options input[type="checkbox"]');
              pintsOnly.forEach((el) => {
                el.checked = false;
              });
            } else if (b === "adult") {
              const adultChkIds = [
                "optLoseClothing",
                "optGainClothing",
                "optPickWhoLosesClothing",
                "optRightLosesClothing",
                "optLeftLosesClothing",
                "optRemoveClothingChoice",
                "optTouchBreast",
                "optLickBreast",
                "optSuckBreast",
                "optTouchGenitals",
                "optLickGenitals",
                "optSuckGenitals",
                "optFingerGenitals",
                "optGenitalIntercourse",
                "optTouchAnus",
                "optLickAnus",
                "optFingerAnus",
                "optAnalIntercourse"
              ];
              adultChkIds.forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.checked = false;
              });
              const adultOnly = document.querySelectorAll('#adult-options input[type="checkbox"], .adult-only-options input[type="checkbox"]');
              adultOnly.forEach((el) => {
                el.checked = false;
              });
            }
          } catch (e) {
          }
        }
      });
      if (activeBrand === "pints") {
        targetSettings.brand = "pints";
        if (targetSettings.target && [241, 361, 481].includes(Number(targetSettings.target))) {
          targetSettings.target = 121;
        }
        if (targetSettings.selected3DBoardId === "board-cribbage-clash" || targetSettings.selected3DBoardId === "board-cribbage-clash-square") {
          targetSettings.selected3DBoardId = "board-14";
        }
      }
      return targetSettings;
    }
    /**
     * Reads lobby form controls and returns a normalized settings object.
     * @param {Object} [context]
     * @returns {Object}
     */
    static readFormSettings(context = {}) {
      if (typeof document === "undefined") return {};
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "crazy");
      const brand = getAppBrand2();
      const GameOptionsEngine2 = context.GameOptionsEngine || (typeof window !== "undefined" ? window.GameOptionsEngine : null);
      const allowCpu = GameOptionsEngine2 && typeof GameOptionsEngine2.isCpuAllowed === "function" ? GameOptionsEngine2.isCpuAllowed(brand) : !["pints", "adult"].includes(brand);
      const parseGameMode2 = context.parseGameMode || (typeof window !== "undefined" ? window.parseGameMode : ((v) => ({ playerCount: parseInt(v, 10) || 2, gameMode: "individual" })));
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const pCountVal = document.getElementById("optPlayerCount") ? document.getElementById("optPlayerCount").value : "2";
      const { playerCount: pNum, gameMode: gMode } = parseGameMode2(pCountVal);
      const getSeatVal = (id, fallback) => {
        const el = document.getElementById(id);
        const val = el ? el.value : fallback;
        if (val === "human") return "online";
        return !allowCpu && val.startsWith("cpu:") ? "online" : val;
      };
      const rawOpp = document.getElementById("optOpp") ? document.getElementById("optOpp").value : "cpu";
      let opp = !allowCpu && rawOpp === "cpu" ? "online" : rawOpp;
      if (opp === "human") opp = allowCpu ? "cpu" : "online";
      const res = {
        playerCount: pNum,
        gameMode: gMode || "individual",
        seat2Type: getSeatVal("optSeat2Type", "cpu:shark"),
        seat3Type: getSeatVal("optSeat3Type", "cpu:regular"),
        seat4Type: getSeatVal("optSeat4Type", "cpu:turtler"),
        seat5Type: getSeatVal("optSeat5Type", "cpu:maverick"),
        seat6Type: getSeatVal("optSeat6Type", "cpu:master"),
        seat7Type: getSeatVal("optSeat7Type", "cpu:rookie"),
        seat8Type: getSeatVal("optSeat8Type", "cpu:casual"),
        opp,
        aiProfile: document.getElementById("optAiProfile") ? document.getElementById("optAiProfile").value : "shark",
        coach: document.getElementById("optCoach") ? document.getElementById("optCoach").value : "off",
        deal: document.getElementById("optDeal") ? document.getElementById("optDeal").value : "std",
        dealStyle: document.getElementById("optDealStyle") ? document.getElementById("optDealStyle").value : "alternate",
        showDetail: document.getElementById("optShowDetail") ? document.getElementById("optShowDetail").value : "highlight",
        cardAssassin: document.getElementById("optCardAssassin") && document.getElementById("optCardAssassin").value || (settings3.cardAssassin || "no"),
        jailAnimation: document.getElementById("optJailAnimation") && document.getElementById("optJailAnimation").value || (settings3.jailAnimation || "yes"),
        barAnimation: document.getElementById("optBarAnimation") && document.getElementById("optBarAnimation").value || (settings3.barAnimation || "yes"),
        cannonAnimation: document.getElementById("optCannonAnimation") && document.getElementById("optCannonAnimation").value || (settings3.cannonAnimation || "yes"),
        jumpAnimation: document.getElementById("optCannonAnimation") && document.getElementById("optCannonAnimation").value || (settings3.jumpAnimation || settings3.cannonAnimation || "yes"),
        speedTrapAnimation: document.getElementById("optSpeedTrapAnimation") && document.getElementById("optSpeedTrapAnimation").value || (settings3.speedTrapAnimation || "yes"),
        stopSignAnimation: document.getElementById("optSpeedTrapAnimation") && document.getElementById("optSpeedTrapAnimation").value || (settings3.stopSignAnimation || settings3.speedTrapAnimation || "yes"),
        stopAnimation: document.getElementById("optSpeedTrapAnimation") && document.getElementById("optSpeedTrapAnimation").value || (settings3.stopAnimation || settings3.speedTrapAnimation || "yes"),
        detourAnimation: document.getElementById("optDetourAnimation") && document.getElementById("optDetourAnimation").value || (settings3.detourAnimation || settings3.scenicRouteAnimation || "yes"),
        roundAboutAnimation: document.getElementById("optRoundAboutAnimation") && document.getElementById("optRoundAboutAnimation").value || (settings3.roundAboutAnimation || settings3.scenicRouteAnimation || "yes"),
        scenicRouteAnimation: document.getElementById("optScenicRouteAnimation") && document.getElementById("optScenicRouteAnimation").value || document.getElementById("optDetourAnimation") && document.getElementById("optDetourAnimation").value || (settings3.scenicRouteAnimation || "yes"),
        goal: brand === "clash" ? "high" : document.getElementById("optGoal") ? document.getElementById("optGoal").value : "high",
        target: (() => {
          const rawTarget = document.getElementById("optTarget") ? parseInt(document.getElementById("optTarget").value, 10) : settings3.target || 121;
          return brand === "clash" && ![241, 361, 481].includes(rawTarget) ? 481 : rawTarget;
        })(),
        decks: document.getElementById("optDecks") ? parseInt(document.getElementById("optDecks").value, 10) || 1 : 1,
        cardBack: document.getElementById("optCardBack") && document.getElementById("optCardBack").value || (settings3.cardBack || "classic-blue"),
        boardFinish: document.getElementById("optBoardFinish") && document.getElementById("optBoardFinish").value || (settings3.boardFinish || "maple"),
        pegSkin: document.getElementById("optPegSkin") && document.getElementById("optPegSkin").value || (settings3.pegSkin || "brass"),
        pegStyle: document.getElementById("optPegStyle") && document.getElementById("optPegStyle").value || (settings3.pegStyle || "classic"),
        tableEnvironment: document.getElementById("optTableEnvironment") && document.getElementById("optTableEnvironment").value || (settings3.tableEnvironment || "auto"),
        optActionCam: document.getElementById("optActionCam") && document.getElementById("optActionCam").value || (settings3.optActionCam || "no"),
        seriesMode: document.getElementById("optSeriesMode") && document.getElementById("optSeriesMode").value || (settings3.seriesMode || "bo3"),
        boardViewMode: document.getElementById("optBoardViewModal") && document.getElementById("optBoardViewModal").value || document.getElementById("optBoardView") && document.getElementById("optBoardView").value || (settings3.boardViewMode || "room3d-fullscreen"),
        selected3DBoardId: document.getElementById("opt3DBoard") && document.getElementById("opt3DBoard").value || (settings3.selected3DBoardId || "board-14")
      };
      if (GameOptionsEngine2 && typeof GameOptionsEngine2.readBrandSettings === "function") {
        Object.assign(res, GameOptionsEngine2.readBrandSettings(brand));
      }
      const activeRestricted = CRAZY_OPTIONS_DEFS.find((opt) => {
        if (opt.requiredPlayers == null) return false;
        const chk = document.getElementById(opt.chkId || opt.key);
        return chk ? chk.checked : Boolean(res[opt.key] || res[opt.chkId]);
      });
      if (activeRestricted) {
        res[activeRestricted.key] = true;
        const req = CrazyManager.getVariantRequiredPlayers(activeRestricted);
        if (req && !req.includes(Number(res.playerCount))) {
          res.playerCount = req[0];
        }
        if (activeRestricted.requiredGameMode) {
          res.gameMode = activeRestricted.requiredGameMode;
        }
      }
      CrazySettings.sanitizeCrazyOptions(res);
      const sanitizeClash = context.sanitizeClashBlockPlacements || (typeof window !== "undefined" ? window.sanitizeClashBlockPlacements : null);
      if (typeof sanitizeClash === "function") {
        sanitizeClash(res);
      }
      _LobbyController.disableOtherGameBonusOptions(brand, res, context);
      return res;
    }
    /**
     * Updates state of master 'Check All Bonuses' checkbox based on children checkboxes.
     */
    static updateCheckAllBonusesState() {
      if (typeof document === "undefined") return;
      const checkAll = document.getElementById("checkAllBonuses");
      if (!checkAll) return;
      const opts = document.querySelectorAll(".bonuses .chk input");
      if (!opts.length) return;
      checkAll.checked = Array.from(opts).every((opt) => opt.checked);
      const GameOptionsEngine2 = (typeof window !== "undefined" ? window.GameOptionsEngine : null) || (typeof globalThis !== "undefined" ? globalThis.GameOptionsEngine : null);
      if (GameOptionsEngine2 && typeof GameOptionsEngine2.updateSubgroupActiveBadges === "function") {
        GameOptionsEngine2.updateSubgroupActiveBadges("crazy", document.getElementById("brand-game-options"));
      }
    }
    /**
     * Starts an online multiplayer match as the host.
     * @param {Object} [context]
     */
    static startGameOnline(context = {}) {
      if (typeof document === "undefined") return;
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "crazy");
      const isAgeVerified2 = context.isAgeVerified || (typeof window !== "undefined" && window.isAgeVerified ? window.isAgeVerified : ((b) => b !== "pints" && b !== "adult"));
      const showAgeGateModal2 = context.showAgeGateModal || (typeof window !== "undefined" ? window.showAgeGateModal : () => {
      });
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const net2 = context.net || (typeof window !== "undefined" ? window.net : {});
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : () => {
      });
      const startGame2 = context.startGame || (typeof window !== "undefined" ? window.startGame : _LobbyController.startGame);
      const netPush2 = context.netPush || (typeof window !== "undefined" ? window.netPush : () => {
      });
      const currentBrand = getAppBrand2();
      if ((currentBrand === "pints" || currentBrand === "adult") && !isAgeVerified2(currentBrand)) {
        showAgeGateModal2(currentBrand);
        return;
      }
      const optOppEl = document.getElementById("optOpp");
      if (optOppEl) optOppEl.value = "online";
      settings3.opp = "online";
      settings3.netRole = "host";
      net2.isHost = true;
      net2.mySeatId = "p1";
      net2.ready = true;
      hideModal3();
      startGame2(context);
      netPush2({ fancy: { text: "Game Started!", kind: "famous", ms: 1600 } });
    }
    /**
     * Initiates gameplay from the lobby form settings.
     * @param {Object} [context]
     */
    static startGame(context = {}) {
      if (typeof document === "undefined") return;
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "crazy");
      const isAgeVerified2 = context.isAgeVerified || (typeof window !== "undefined" && window.isAgeVerified ? window.isAgeVerified : ((b) => b !== "pints" && b !== "adult"));
      const showAgeGateModal2 = context.showAgeGateModal || (typeof window !== "undefined" ? window.showAgeGateModal : () => {
      });
      const hideMenuOptions = context.hideMenuOptions || (typeof window !== "undefined" ? window.hideMenuOptions || window.hideMenuOtions : () => {
      });
      const parseGameMode2 = context.parseGameMode || (typeof window !== "undefined" ? window.parseGameMode : ((v) => ({ playerCount: parseInt(v, 10) || 2, gameMode: "individual" })));
      const GameOptionsEngine2 = context.GameOptionsEngine || (typeof window !== "undefined" ? window.GameOptionsEngine : null);
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : {});
      const net2 = context.net || (typeof window !== "undefined" ? window.net : {});
      const hostRoom2 = context.hostRoom || (typeof window !== "undefined" ? window.hostRoom : () => {
      });
      const setCardBack2 = context.setCardBack || (typeof window !== "undefined" ? window.setCardBack : () => {
      });
      const readFormSettings2 = context.readFormSettings || (typeof window !== "undefined" ? window.readFormSettings : _LobbyController.readFormSettings);
      const sanitizeClashBlockPlacements2 = context.sanitizeClashBlockPlacements || (typeof window !== "undefined" ? window.sanitizeClashBlockPlacements : null);
      const saveSettingsStore2 = context.saveSettingsStore || (typeof window !== "undefined" ? window.saveSettingsStore : () => {
      });
      const makeDeck2 = context.makeDeck || (typeof window !== "undefined" ? window.makeDeck : null);
      const applySeatLabels2 = context.applySeatLabels || (typeof window !== "undefined" ? window.applySeatLabels : () => {
      });
      const resetMatch2 = context.resetMatch || (typeof window !== "undefined" ? window.resetMatch : () => {
      });
      const currentBrand = getAppBrand2();
      if ((currentBrand === "pints" || currentBrand === "adult") && !isAgeVerified2(currentBrand)) {
        showAgeGateModal2(currentBrand);
        return;
      }
      hideMenuOptions();
      if (typeof window !== "undefined" && typeof window.hideStartGameModal === "function") {
        window.hideStartGameModal();
      }
      const startOverlay = document.getElementById("startGameOverlay");
      if (startOverlay) startOverlay.style.display = "none";
      if (typeof window !== "undefined" && window.scrollTo) {
        window.scrollTo(0, 0);
      }
      const isTourney = Boolean(context.isTournamentMatch || context.settings && context.settings.isTournamentMatch);
      settings3.isTournamentMatch = isTourney;
      if (typeof window !== "undefined" && window.settings) {
        window.settings.isTournamentMatch = isTourney;
      }
      if (!settings3.isTournamentMatch) {
        const activeRestricted = CRAZY_OPTIONS_DEFS.find((opt) => {
          if (opt.requiredPlayers == null) return false;
          const chk = document.getElementById(opt.chkId || opt.key);
          return chk ? chk.checked : Boolean(settings3[opt.key] || settings3[opt.chkId]);
        });
        if (activeRestricted) {
          settings3[activeRestricted.key] = true;
          const req = CrazyManager.getVariantRequiredPlayers(activeRestricted);
          if (req && !req.includes(Number(settings3.playerCount))) {
            settings3.playerCount = req[0];
          }
          if (activeRestricted.requiredGameMode) {
            settings3.gameMode = activeRestricted.requiredGameMode;
          }
        } else {
          const pCountVal = document.getElementById("optPlayerCount") && document.getElementById("optPlayerCount").value || "2";
          const parsedMode = parseGameMode2(pCountVal);
          settings3.playerCount = parsedMode.playerCount;
          settings3.gameMode = parsedMode.gameMode;
        }
        const brand2 = getAppBrand2();
        const allowCpu2 = GameOptionsEngine2 && typeof GameOptionsEngine2.isCpuAllowed === "function" ? GameOptionsEngine2.isCpuAllowed(brand2) : !["pints", "adult"].includes(brand2);
        const rawOpp = document.getElementById("optOpp") && document.getElementById("optOpp").value || (allowCpu2 ? "cpu" : "online");
        let opp = !allowCpu2 && rawOpp === "cpu" ? "online" : rawOpp;
        if (opp === "human") opp = allowCpu2 ? "cpu" : "online";
        settings3.opp = opp;
        if (settings3.opp === "online" && !net2.peer) {
          hostRoom2();
          return;
        }
        settings3.aiProfile = document.getElementById("optAiProfile") && document.getElementById("optAiProfile").value || "shark";
      } else {
        settings3.playerCount = 2;
        settings3.gameMode = "individual";
      }
      const brand = getAppBrand2();
      const allowCpu = GameOptionsEngine2 && typeof GameOptionsEngine2.isCpuAllowed === "function" ? GameOptionsEngine2.isCpuAllowed(brand) : !["pints", "adult"].includes(brand);
      settings3.coach = document.getElementById("optCoach") && document.getElementById("optCoach").value || "off";
      settings3.deal = settings3.playerCount >= 3 ? "std" : document.getElementById("optDeal") && document.getElementById("optDeal").value || "std";
      settings3.dealStyle = document.getElementById("optDealStyle") && document.getElementById("optDealStyle").value || "alternate";
      settings3.showDetail = document.getElementById("optShowDetail") && document.getElementById("optShowDetail").value || "highlight";
      settings3.cardAssassin = document.getElementById("optCardAssassin") && document.getElementById("optCardAssassin").value || (settings3.cardAssassin || "no");
      settings3.jailAnimation = document.getElementById("optJailAnimation") && document.getElementById("optJailAnimation").value || (settings3.jailAnimation || "yes");
      settings3.barAnimation = document.getElementById("optBarAnimation") && document.getElementById("optBarAnimation").value || (settings3.barAnimation || "yes");
      settings3.cannonAnimation = document.getElementById("optCannonAnimation") && document.getElementById("optCannonAnimation").value || (settings3.cannonAnimation || "yes");
      settings3.jumpAnimation = settings3.cannonAnimation;
      settings3.speedTrapAnimation = document.getElementById("optSpeedTrapAnimation") && document.getElementById("optSpeedTrapAnimation").value || (settings3.speedTrapAnimation || "yes");
      settings3.stopSignAnimation = settings3.speedTrapAnimation;
      settings3.stopAnimation = settings3.speedTrapAnimation;
      settings3.detourAnimation = document.getElementById("optDetourAnimation") && document.getElementById("optDetourAnimation").value || (settings3.detourAnimation || settings3.scenicRouteAnimation || "yes");
      settings3.roundAboutAnimation = document.getElementById("optRoundAboutAnimation") && document.getElementById("optRoundAboutAnimation").value || (settings3.roundAboutAnimation || settings3.scenicRouteAnimation || "yes");
      settings3.scenicRouteAnimation = document.getElementById("optScenicRouteAnimation") && document.getElementById("optScenicRouteAnimation").value || settings3.detourAnimation || (settings3.scenicRouteAnimation || "yes");
      if (settings3.showDetail === "muggins") {
        settings3.optMuggins = true;
      }
      settings3.goal = brand === "clash" ? "high" : document.getElementById("optGoal") && document.getElementById("optGoal").value || "high";
      let targetVal = document.getElementById("optTarget") ? parseInt(document.getElementById("optTarget").value, 10) : settings3.target || 121;
      if (brand === "clash" && ![241, 361, 481].includes(targetVal)) {
        targetVal = 481;
        const optTargetEl = document.getElementById("optTarget");
        if (optTargetEl) optTargetEl.value = "481";
      }
      settings3.target = targetVal;
      settings3.decks = document.getElementById("optDecks") ? parseInt(document.getElementById("optDecks").value, 10) || 1 : 1;
      settings3.cardBack = document.getElementById("optCardBack") && document.getElementById("optCardBack").value || (settings3.cardBack || "classic-blue");
      setCardBack2(settings3.cardBack, true);
      settings3.boardFinish = document.getElementById("optBoardFinish") && document.getElementById("optBoardFinish").value || (settings3.boardFinish || "maple");
      settings3.pegSkin = document.getElementById("optPegSkin") && document.getElementById("optPegSkin").value || (settings3.pegSkin || "brass");
      settings3.optActionCam = document.getElementById("optActionCam") && document.getElementById("optActionCam").value || (settings3.optActionCam || "no");
      settings3.seriesMode = document.getElementById("optSeriesMode") && document.getElementById("optSeriesMode").value || (settings3.seriesMode || "bo3");
      SeriesTracker.setMode(settings3.seriesMode);
      settings3.boardViewMode = document.getElementById("optBoardViewModal") && document.getElementById("optBoardViewModal").value || document.getElementById("optBoardView") && document.getElementById("optBoardView").value || (settings3.boardViewMode || "room3d-fullscreen");
      settings3.selected3DBoardId = document.getElementById("opt3DBoard") && document.getElementById("opt3DBoard").value || (settings3.selected3DBoardId || "board-14");
      if (!settings3.isTournamentMatch && typeof _LobbyController.resolveSeatConfigs === "function") {
        settings3.seats = _LobbyController.resolveSeatConfigs(settings3.playerCount, allowCpu, {
          opp: settings3.opp,
          aiProfile: settings3.aiProfile
        });
      }
      if (settings3.opp === "online") {
        const hostName = document.getElementById("optPlayerName") && document.getElementById("optPlayerName").value.trim() || "Host";
        if (settings3.seats && settings3.seats[0]) {
          settings3.seats[0].name = hostName;
          settings3.seats[0].type = "human";
          settings3.seats[0].online = true;
        }
        if (net2.clients) {
          for (const client of net2.clients.values()) {
            if (client.seatId) {
              const s = settings3.seats.find((x) => x.id === client.seatId);
              if (s) {
                s.name = client.name || `Player ${client.seatId.slice(1)}`;
                s.type = "human";
                s.online = Boolean(client.conn && client.conn.open);
              }
            }
          }
        }
      }
      settings3.brand = currentBrand;
      _LobbyController.disableOtherGameBonusOptions(currentBrand, settings3, context);
      if (typeof window !== "undefined" && window.settings) {
        window.settings.brand = currentBrand;
        _LobbyController.disableOtherGameBonusOptions(currentBrand, window.settings, context);
      }
      const formSettings = readFormSettings2(context);
      _LobbyController.disableOtherGameBonusOptions(currentBrand, formSettings, context);
      Object.assign(settings3, formSettings);
      const chosenBoardViewMode = document.getElementById("optBoardViewModal") && document.getElementById("optBoardViewModal").value || document.getElementById("optBoardView") && document.getElementById("optBoardView").value || (settings3.boardViewMode || "room3d-fullscreen");
      settings3.boardViewMode = chosenBoardViewMode;
      if (typeof window !== "undefined" && window.settings) {
        window.settings.boardViewMode = chosenBoardViewMode;
      }
      _LobbyController.disableOtherGameBonusOptions(currentBrand, settings3, context);
      if (typeof window !== "undefined" && window.settings) {
        _LobbyController.disableOtherGameBonusOptions(currentBrand, window.settings, context);
      }
      let optPegThroughZones = settings3.optPegThroughZones || false;
      let optLast5PegOut = settings3.optLast5PegOut || false;
      let optBunkers = settings3.optBunkers || false;
      let optStinkHole = settings3.optStinkHole || false;
      if (optBunkers) {
        optPegThroughZones = false;
        optLast5PegOut = false;
        optStinkHole = false;
      } else if (optLast5PegOut) {
        optPegThroughZones = false;
        optStinkHole = false;
      } else if (optPegThroughZones) {
        optStinkHole = false;
      }
      settings3.optPegThroughZones = optPegThroughZones;
      settings3.optLast5PegOut = optLast5PegOut;
      settings3.optBunkers = optBunkers;
      settings3.optStinkHole = optStinkHole;
      if (typeof sanitizeClashBlockPlacements2 === "function") {
        sanitizeClashBlockPlacements2(settings3);
      }
      saveSettingsStore2(formSettings);
      if (typeof makeDeck2 === "function") {
        if (typeof window !== "undefined") {
          window.FULL_DECK = makeDeck2(settings3.decks);
        }
      }
      const menuEl = document.getElementById("menu");
      const gameEl = document.getElementById("game");
      if (menuEl) menuEl.classList.add("hidden");
      if (gameEl) gameEl.classList.remove("hidden");
      if (settings3.boardViewMode === "room3d" || settings3.boardViewMode === "3d" || settings3.boardViewMode === "room3d-fullscreen") {
        try {
          const loaderCls = typeof Room3DLoadingOverlay !== "undefined" ? Room3DLoadingOverlay : typeof window !== "undefined" ? window.Room3DLoadingOverlay : null;
          if (loaderCls && typeof loaderCls.show === "function") {
            loaderCls.show(document.body, {
              settings: settings3,
              is3DOnly: settings3.boardViewMode === "3d",
              isGlobal: true,
              cardBack: settings3?.cardBack,
              theme: settings3?.roomTheme || settings3?.tableEnvironment,
              deck: typeof window !== "undefined" ? window.FULL_DECK : null,
              minDuration: 1600
            });
          }
        } catch (err) {
          console.warn("[LobbyController] Could not display Room3DLoadingOverlay:", err);
        }
      }
      ReactionManager.injectReactionUi();
      SeriesTracker.updateSeriesUi();
      const appBrand = brand;
      const gameTitleEl = document.getElementById("gameHeaderTitle") || document.querySelector(".header-title-wrap h1");
      if (gameTitleEl) {
        gameTitleEl.textContent = appBrand === "clash" ? "CRIBBAGE CLASH" : appBrand === "pints" ? "PINTS AND PEGS" : appBrand === "adult" ? "SKUNKED AND STRIPPED" : "CRAZY CRIBBAGE";
      }
      applySeatLabels2();
      let pills = [];
      if (typeof _LobbyController.generateModePills === "function") {
        pills = _LobbyController.generateModePills(settings3, {
          brand: currentBrand,
          getAppBrand: () => currentBrand,
          allowCpu,
          isOnline: context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false),
          isHvH: context.isHvH || (typeof window !== "undefined" ? window.isHvH : () => false),
          is3Player1vs2: context.is3Player1vs2 || (typeof window !== "undefined" ? window.is3Player1vs2 : () => false),
          getNoPassingLanes: context.getNoPassingLanes || (typeof window !== "undefined" ? window.getNoPassingLanes : () => []),
          getJumpConfigs: context.getJumpConfigs || (typeof window !== "undefined" ? window.getJumpConfigs : () => []),
          getJailConfigs: context.getJailConfigs || (typeof window !== "undefined" ? window.getJailConfigs : () => []),
          getBarConfigs: context.getBarConfigs || (typeof window !== "undefined" ? window.getBarConfigs : () => []),
          getTimeoutConfigs: context.getTimeoutConfigs || (typeof window !== "undefined" ? window.getTimeoutConfigs : () => []),
          getDetourConfigs: context.getDetourConfigs || (typeof window !== "undefined" ? window.getDetourConfigs : () => []),
          getRoundAboutConfigs: context.getRoundAboutConfigs || (typeof window !== "undefined" ? window.getRoundAboutConfigs : () => []),
          getSignConfigs: context.getSignConfigs || (typeof window !== "undefined" ? window.getSignConfigs : () => []),
          getDiceConfigs: context.getDiceConfigs || (typeof window !== "undefined" ? window.getDiceConfigs : () => []),
          getWheelConfigs: context.getWheelConfigs || (typeof window !== "undefined" ? window.getWheelConfigs : () => [])
        });
      }
      const modePillsEl = document.getElementById("modePills");
      if (modePillsEl) {
        modePillsEl.innerHTML = pills.map((p) => `<span class="pill">${p}</span>`).join("");
      }
      ["introCopy", "introCopyClash", "introCopyAdult", "introCopyPints"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.hidden = true;
      });
      resetMatch2();
      if (settings3.boardViewMode === "room3d-fullscreen") {
        try {
          const b3dWrap = document.getElementById("board3DContainer");
          if (b3dWrap) {
            if (b3dWrap.requestFullscreen) {
              b3dWrap.requestFullscreen().catch(() => {
              });
            } else if (b3dWrap.webkitRequestFullscreen) {
              b3dWrap.webkitRequestFullscreen();
            }
          }
        } catch (_) {
        }
      }
    }
    startGameOnline(context) {
      return _LobbyController.startGameOnline(context);
    }
    startGame(context) {
      return _LobbyController.startGame(context);
    }
    readFormSettings(context) {
      return _LobbyController.readFormSettings(context);
    }
    updateCheckAllBonusesState() {
      return _LobbyController.updateCheckAllBonusesState();
    }
    randomizeCrazyCribbageBonuses(context) {
      return _LobbyController.randomizeCrazyCribbageBonuses(context);
    }
    checkInitialAgeGate(context) {
      return _LobbyController.checkInitialAgeGate(context);
    }
    setupCheckAllBonuses(context) {
      return _LobbyController.setupCheckAllBonuses(context);
    }
    disableOtherGameBonusOptions(activeBrand, targetSettings, context) {
      return _LobbyController.disableOtherGameBonusOptions(activeBrand, targetSettings, context);
    }
  };

  // src/variants/ClashMiniGames.js
  var CLASH_SIGN_DEFS = Object.freeze({
    "Plus 5": { icon: "\u27955\uFE0F\u20E3", desc: "Move ahead 5 points" },
    "Plus 10": { icon: "\u23E9\u{1F51F}", desc: "Move ahead 10 points" },
    "Minus 5": { icon: "\u27965\uFE0F\u20E3", desc: "Move back 5 points" },
    "Minus 10": { icon: "\u23EA\u{1F51F}", desc: "Move back 10 points" },
    "Undo": { icon: "\u21A9\uFE0F", desc: "Undo your last points scored" },
    "Go To Jail": { icon: "\u{1F512}", desc: "Sent to the nearest Jail block" },
    "Go To The Bar": { icon: "\u{1F37A}", desc: "Sent to the nearest Bar block" },
    "Go To Timeout": { icon: "\u23F3", desc: "Sent to the nearest Timeout block" },
    "Score Plus x2": { icon: "\u2716\uFE0F2\uFE0F\u20E3", desc: "Move ahead 2x last points" },
    "Score Plus x3": { icon: "\u{1F680}3\uFE0F\u20E3", desc: "Move ahead 3x last points" },
    "Score Minus x2": { icon: "\u{1F4C9}2\uFE0F\u20E3", desc: "Move back 2x last points" },
    "Score Minus x3": { icon: "\u{1F4A5}3\uFE0F\u20E3", desc: "Move back 3x last points" },
    "Roll The Dice": { icon: "\u{1F3B2}", desc: "Roll 3 dice for Direction, Pts & Target" },
    "Spin The Wheel": { icon: "\u{1F3A1}", desc: "Spin the wheel with 8 prize/penalty slots" }
  });
  var CLASH_WHEEL_SLOTS = Object.freeze([
    "Plus 5",
    "Minus 5",
    "Plus 10",
    "Minus 10",
    "Go To Jail",
    "Go To The Bar",
    "Go To Timeout",
    "Roll The Dice"
  ]);
  var ClashMiniGames = class _ClashMiniGames {
    static get SIGN_DEFS() {
      return CLASH_SIGN_DEFS;
    }
    static get WHEEL_SLOTS() {
      return CLASH_WHEEL_SLOTS;
    }
    /**
     * Helper to resolve runtime environment context.
     * @private
     */
    static _resolveCtx(ctx = {}) {
      const doc = ctx.document || (typeof document !== "undefined" ? document : null);
      const win = ctx.window || (typeof window !== "undefined" ? window : null);
      const st = ctx.state || win && win.state || {};
      const set = ctx.settings || win && win.settings || {};
      const logFn = ctx.log || (win && typeof win.log === "function" ? win.log : () => {
      });
      const fancyFn = ctx.fancyCall || (win && typeof win.fancyCall === "function" ? win.fancyCall : () => {
      });
      const toastFn = ctx.showScoreToast || (win && typeof win.showScoreToast === "function" ? win.showScoreToast : () => {
      });
      const statusFn = ctx.setStatus || (win && typeof win.setStatus === "function" ? win.setStatus : () => {
      });
      const modalFn = ctx.showModal || (win && typeof win.showModal === "function" ? win.showModal : () => {
      });
      const closeFn = ctx.closeModal || (win && typeof win.closeModal === "function" ? win.closeModal : () => {
      });
      const pNameFn = ctx.pName || (win && typeof win.pName === "function" ? win.pName : ((w) => w));
      const isHumanFn = ctx.isSeatHuman || (win && typeof win.isSeatHuman === "function" ? win.isSeatHuman : (() => true));
      const isCpuFn = ctx.isSeatCpu || (win && typeof win.isSeatCpu === "function" ? win.isSeatCpu : (() => false));
      const scoreKeyFn = ctx.scoreKey || (win && typeof win.scoreKey === "function" ? win.scoreKey : ((w) => w));
      const addScoreFn = ctx.addScore || (win && typeof win.addScore === "function" ? win.addScore : () => {
      });
      const renderScoresFn = ctx.renderScores || (win && typeof win.renderScores === "function" ? win.renderScores : () => {
      });
      const sfxObj = ctx.sfx || win && win.sfx || { card: () => {
      }, pop: () => {
      }, peg: () => {
      } };
      return {
        doc,
        win,
        state: st,
        settings: set,
        log: logFn,
        fancyCall: fancyFn,
        showScoreToast: toastFn,
        setStatus: statusFn,
        showModal: modalFn,
        closeModal: closeFn,
        pName: pNameFn,
        isSeatHuman: isHumanFn,
        isSeatCpu: isCpuFn,
        scoreKey: scoreKeyFn,
        addScore: addScoreFn,
        renderScores: renderScoresFn,
        sfx: sfxObj
      };
    }
    /**
     * Handles player landing on an interactive Signs block.
     * @param {Object} block
     * @param {string} who
     * @param {Object} [context={}]
     */
    static handleSignsLanding(block, who, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      if (!ctx.state || !ctx.settings.optSigns || !block) return;
      if (!ctx.state.signsState) ctx.state.signsState = {};
      if (!ctx.state.signsState[block.id] || !ctx.state.signsState[block.id].length) {
        ctx.state.signsState[block.id] = [...block.initialSigns || []];
      }
      const remaining = ctx.state.signsState[block.id];
      const isHuman = ctx.isSeatHuman(who);
      if (isHuman) {
        ctx.state.pausedForSign = true;
        ctx.state.paused = true;
        const playerName = ctx.pName(who);
        ctx.log(`\u{1FAA7} SIGNS: ${playerName} landed on Sign Block ${block.id} (Holes ${block.start}\u2013${block.end})! Game is paused until you pick a sign.`);
        ctx.setStatus(`Landed on Sign Block ${block.id}! Game is paused \u2014 pick a sign.`);
        _ClashMiniGames.openSignPickerModal(block, who, context);
      } else {
        const chosen = ClashManager.pickCpuSign(remaining);
        const cpuName = ctx.pName(who);
        ctx.log(`\u{1FAA7} SIGNS: ${cpuName} landed on Sign Block ${block.id} and selected "${chosen}"!`);
        ctx.fancyCall(`${cpuName} SELECTED: ${chosen.toUpperCase()}!`, "signs", 3400);
        ctx.showScoreToast(who, 0, `${cpuName} selected: ${chosen}`);
        ctx.setStatus(`${cpuName} landed on Sign Block ${block.id} and selected: ${chosen}`);
        setTimeout(() => {
          _ClashMiniGames.chooseSign(chosen, who, block, context);
        }, 2200);
      }
    }
    /**
     * Opens the interactive sign card picker modal.
     * @param {Object} block
     * @param {string} who
     * @param {Object} [context={}]
     */
    static openSignPickerModal(block, who, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      if (!ctx.state || !block) return;
      ctx.state._inSignAction = true;
      ctx.state.pausedForSign = true;
      ctx.state.paused = true;
      const remaining = ctx.state.signsState && ctx.state.signsState[block.id] || [...block.initialSigns || []];
      const cardsHtml = remaining.map((sign) => {
        const def = CLASH_SIGN_DEFS[sign] || { icon: "\u{1FAA7}", desc: sign };
        const escapedSign = sign.replace(/'/g, "\\'");
        return `
        <div class="sign-pick-card" data-action="pick-sign" data-sign="${sign}" data-block="${block.id}" data-who="${who}">
          <div class="sign-card-icon">${def.icon}</div>
          <div class="sign-card-name">${sign}</div>
          <div class="sign-card-desc">${def.desc}</div>
        </div>
      `;
      }).join("");
      const modalHtml = `
      <div class="signs-modal-wrap">
        <h2 class="signs-modal-title">\u{1FAA7} SIGN BLOCK ${block.id}</h2>
        <p class="signs-modal-subtitle">Landed on Holes ${block.start}\u2013${block.end}! Game is paused \u2014 choose an available sign (${remaining.length} left):</p>
        <div class="signs-cards-grid">
          ${cardsHtml}
        </div>
      </div>
    `;
      ctx.showModal(modalHtml, false);
      if (typeof document !== "undefined") {
        const wrap = document.querySelector(".signs-modal-wrap");
        if (wrap) {
          wrap.addEventListener("click", (e) => {
            const card = e.target.closest('[data-action="pick-sign"]');
            if (card) {
              const sName = card.dataset.sign;
              const bId = parseInt(card.dataset.block, 10);
              const w = card.dataset.who;
              if (typeof onSignCardClick === "function") {
                onSignCardClick(sName, bId, w);
              } else {
                _ClashMiniGames.onSignCardClick(sName, bId, w, context);
              }
            }
          });
        }
      }
    }
    /**
     * Handles user click on a sign card in the picker modal.
     * @param {string} signName
     * @param {number} blockId
     * @param {string} who
     * @param {Object} [context={}]
     */
    static onSignCardClick(signName, blockId, who, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      ctx.closeModal();
      const getSignsFn = context.getSignConfigs || ctx.win && ctx.win.getSignConfigs;
      const blocks = typeof getSignsFn === "function" ? getSignsFn() : [];
      const block = blocks.find((b) => b.id === blockId);
      if (block) {
        _ClashMiniGames.chooseSign(signName, who, block, context);
      }
    }
    /**
     * Selects and consumes a sign card from a block.
     * @param {string} signName
     * @param {string} who
     * @param {Object} block
     * @param {Object} [context={}]
     */
    static chooseSign(signName, who, block, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      if (!ctx.state || !block) return;
      ctx.state._inSignAction = true;
      if (!ctx.state.signsState) ctx.state.signsState = {};
      if (!ctx.state.signsState[block.id]) ctx.state.signsState[block.id] = [...block.initialSigns || []];
      const idx = ctx.state.signsState[block.id].indexOf(signName);
      if (idx !== -1) {
        ctx.state.signsState[block.id].splice(idx, 1);
      }
      const isHuman = ctx.isSeatHuman(who);
      const playerName = ctx.pName(who);
      if (!isHuman) {
        ctx.log(`\u{1FAA7} SIGN CHOSEN: ${playerName} selected "${signName}" on Block ${block.id}!`);
        ctx.fancyCall(`${playerName} SELECTED: ${signName.toUpperCase()}!`, "signs", 3400);
        ctx.showScoreToast(who, 0, `${playerName} chose ${signName}`);
        ctx.setStatus(`${playerName} selected Sign: ${signName}`);
      } else {
        ctx.log(`\u{1FAA7} SIGN CHOSEN: ${playerName} selected "${signName}" on Block ${block.id}!`);
        ctx.fancyCall(signName.toUpperCase(), "signs", 2600);
        ctx.showScoreToast(who, 0, `Chose Sign: ${signName}`);
      }
      const wasLast = ctx.state.signsState[block.id].length === 0;
      if (wasLast) {
        ctx.state.signsState[block.id] = [...block.initialSigns || []];
        ctx.log(`\u2728 SIGNS REPLENISHED: The last sign was chosen on Block ${block.id}! All ${block.initialSigns.length} signs have been restored.`);
        setTimeout(() => {
          ctx.fancyCall("SIGNS REPLENISHED!", "signs", 2600);
        }, 1500);
      }
      _ClashMiniGames.updateSignsBillboard(block.id, context);
      setTimeout(() => {
        _ClashMiniGames.executeSign(signName, who, block, context);
        ctx.state._inSignAction = false;
        if (signName !== "Roll The Dice" && signName !== "Spin The Wheel") {
          _ClashMiniGames.resumeGameAfterSign(context);
        }
      }, isHuman ? 1400 : 1800);
    }
    /**
     * Resumes the match progression after a sign effect completes.
     * @param {Object} [context={}]
     */
    static resumeGameAfterSign(context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      if (!ctx.state) return;
      ctx.state.pausedForSign = false;
      if (!ctx.state.pausedForAdultTimer && !ctx.state.pausedForAdultStrip && !ctx.state.pausedForPintsBonus) {
        ctx.state.paused = false;
      }
      if (typeof ctx.state._resumeAfterSign === "function" && !ctx.state.pausedForAdultTimer && !ctx.state.pausedForAdultStrip && !ctx.state.pausedForPintsBonus) {
        const resumeFn = ctx.state._resumeAfterSign;
        ctx.state._resumeAfterSign = null;
        ctx.state._resumeAfterAdultTimer = null;
        ctx.state._resumeAfterPintsBonus = null;
        resumeFn();
      } else if (ctx.state.phase === "play" && ctx.isSeatCpu(ctx.state.turn) && !ctx.state.paused) {
        const schedFn = context.scheduleOppPlay || ctx.win && ctx.win.scheduleOppPlay;
        if (typeof schedFn === "function") {
          schedFn(ctx.state.turn);
        }
      }
    }
    /**
     * Executes the mechanical effect of a chosen sign.
     * @param {string} signName
     * @param {string} who
     * @param {Object|null} block
     * @param {Object} [context={}]
     */
    static executeSign(signName, who, block = null, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      const key = ctx.scoreKey(who);
      const curScore = ctx.state.scores && ctx.state.scores[key] || 0;
      const lastDelta = Math.abs(ctx.state.lastScoreDelta && ctx.state.lastScoreDelta[key] || 2);
      const playerName = ctx.pName(who);
      switch (signName) {
        case "Plus 5":
          ctx.addScore(who, 5, "Sign: Plus 5", false, true);
          break;
        case "Plus 10":
          ctx.addScore(who, 10, "Sign: Plus 10", false, true);
          break;
        case "Minus 5":
          ctx.addScore(who, -5, "Sign: Minus 5", false, true);
          break;
        case "Minus 10":
          ctx.addScore(who, -10, "Sign: Minus 10", false, true);
          break;
        case "Undo":
          ctx.log(`\u21A9\uFE0F UNDO SIGN: Reversing last points (${lastDelta} pts) for ${playerName}.`);
          ctx.addScore(who, -lastDelta, "Sign: Undo", false, true);
          break;
        case "Score Plus x2":
          ctx.addScore(who, lastDelta * 2, "Sign: Score Plus x2", false, true);
          break;
        case "Score Plus x3":
          ctx.addScore(who, lastDelta * 3, "Sign: Score Plus x3", false, true);
          break;
        case "Score Minus x2":
          ctx.addScore(who, -(lastDelta * 2), "Sign: Score Minus x2", false, true);
          break;
        case "Score Minus x3":
          ctx.addScore(who, -(lastDelta * 3), "Sign: Score Minus x3", false, true);
          break;
        case "Go To Jail": {
          const getJailsFn = context.getJailConfigs || ctx.win && ctx.win.getJailConfigs;
          const jails = typeof getJailsFn === "function" && ctx.settings.optJail ? getJailsFn() : [];
          if (jails.length) {
            const nearest = jails.slice().sort((a, b) => Math.abs(a.hole - curScore) - Math.abs(b.hole - curScore))[0];
            ctx.state.scores[key] = nearest.hole;
            ctx.state.jailed = ctx.state.jailed || {};
            ctx.state.jailed[key] = { jailHole: nearest.hole, turnsRemaining: 3, step: 0 };
            ctx.log(`\u{1F512} GO TO JAIL: ${playerName} sent to nearest Jail at Hole ${nearest.hole}!`);
            ctx.fancyCall("SENT TO JAIL!", "jail", 2400);
            ctx.renderScores(true);
            const jailOpt = ctx.settings && ctx.settings.jailAnimation || typeof window !== "undefined" && window.settings && window.settings.jailAnimation || "yes";
            if (jailOpt !== "no" && jailOpt !== "off" && jailOpt !== false) {
              const showJail = context.showJailAnimation || typeof window !== "undefined" && window.showJailAnimation || typeof window !== "undefined" && window.JailAnimationOverlay && window.JailAnimationOverlay.show;
              if (typeof showJail === "function") {
                try {
                  showJail({
                    playerName,
                    who,
                    jailHole: nearest.hole,
                    score: nearest.hole,
                    settings: ctx.settings
                  });
                } catch (e) {
                }
              }
            }
          } else {
            ctx.log(`\u2139\uFE0F GO TO JAIL: No Jail block is currently active on the board.`);
            ctx.fancyCall("NO JAIL ACTIVE", "signs", 1600);
          }
          break;
        }
        case "Go To The Bar": {
          const getBarsFn = context.getBarConfigs || ctx.win && ctx.win.getBarConfigs;
          const bars = typeof getBarsFn === "function" && ctx.settings.optBar ? getBarsFn() : [];
          if (bars.length) {
            const nearest = bars.slice().sort((a, b) => Math.abs(a.hole - curScore) - Math.abs(b.hole - curScore))[0];
            ctx.state.scores[key] = nearest.hole;
            ctx.state.atBar = ctx.state.atBar || {};
            ctx.state.atBar[key] = { barHole: nearest.hole, turnsRemaining: 3, step: 0 };
            ctx.log(`\u{1F37B} GO TO THE BAR: ${playerName} sent to nearest Bar at Hole ${nearest.hole}!`);
            ctx.fancyCall("SENT TO THE BAR!", "bar", 2400);
            ctx.renderScores(true);
            const barOpt = ctx.settings && ctx.settings.barAnimation || typeof window !== "undefined" && window.settings && window.settings.barAnimation || "yes";
            if (barOpt !== "no" && barOpt !== "off" && barOpt !== false) {
              const showBar = context.showBarAnimation || typeof window !== "undefined" && window.showBarAnimation || typeof window !== "undefined" && window.BarAnimationOverlay && window.BarAnimationOverlay.show;
              if (typeof showBar === "function") {
                let playerCard = null;
                if (ctx.state && ctx.state.lastPlayedCard) playerCard = ctx.state.lastPlayedCard;
                else if (ctx.state && ctx.state.hands && ctx.state.hands[who] && ctx.state.hands[who].length) playerCard = ctx.state.hands[who][0];
                try {
                  showBar({
                    playerName,
                    who,
                    barHole: nearest.hole,
                    score: nearest.hole,
                    card: playerCard,
                    settings: ctx.settings
                  });
                } catch (e) {
                }
              }
            }
          } else {
            ctx.log(`\u2139\uFE0F GO TO THE BAR: No Bar block is currently active on the board.`);
            ctx.fancyCall("NO BAR ACTIVE", "signs", 1600);
          }
          break;
        }
        case "Go To Timeout": {
          const getTimeoutsFn = context.getTimeoutConfigs || ctx.win && ctx.win.getTimeoutConfigs;
          const timeouts = typeof getTimeoutsFn === "function" && ctx.settings.optTimeout ? getTimeoutsFn() : [];
          if (timeouts.length) {
            const nearest = timeouts.slice().sort((a, b) => Math.abs(a.hole - curScore) - Math.abs(b.hole - curScore))[0];
            ctx.state.scores[key] = nearest.hole;
            ctx.state.inTimeout = ctx.state.inTimeout || {};
            ctx.state.inTimeout[key] = { timeoutHole: nearest.hole, turnsRemaining: 3, step: 0 };
            ctx.log(`\u23F3 GO TO TIMEOUT: ${playerName} sent to nearest Timeout at Hole ${nearest.hole}!`);
            ctx.fancyCall("SENT TO TIMEOUT!", "timeout", 2400);
            ctx.renderScores(true);
          } else {
            ctx.log(`\u2139\uFE0F GO TO TIMEOUT: No Timeout block is currently active on the board.`);
            ctx.fancyCall("NO TIMEOUT ACTIVE", "signs", 1600);
          }
          break;
        }
        case "Roll The Dice":
          _ClashMiniGames.openDiceRollModal(who, context);
          break;
        case "Spin The Wheel":
          _ClashMiniGames.openWheelSpinModal(who, context);
          break;
        default:
          ctx.log(`\u{1FAA7} SIGN: Unknown sign "${signName}"`);
          break;
      }
    }
    /**
     * Opens the 3-die roll arena modal.
     * @param {string} who
     * @param {Object} [context={}]
     */
    static openDiceRollModal(who, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      const modalHtml = `
      <div class="signs-modal-wrap">
        <h2 class="signs-modal-title">\u{1F3B2} ROLL THE DICE</h2>
        <p class="signs-modal-subtitle">Rolling 3 dice for Direction (\xB1), Points (5..30), and Target Player:</p>
        <div class="dice-arena">
          <div class="die-block die-dir" id="die1">
            <span class="die-label">Direction</span>
            <span class="die-value" id="die1Val">?</span>
          </div>
          <div class="die-block die-val" id="die2">
            <span class="die-label">Points</span>
            <span class="die-value" id="die2Val">?</span>
          </div>
          <div class="die-block die-target" id="die3">
            <span class="die-label">Target</span>
            <span class="die-value" id="die3Val" style="font-size: 1rem;">?</span>
          </div>
        </div>
        <div id="diceActions">
          <button type="button" class="dice-roll-btn" id="btnRollDice">ROLLING DICE...</button>
        </div>
        <div id="diceTargetPick" class="target-pick-wrap" style="display: none;"></div>
      </div>
    `;
      ctx.showModal(modalHtml, false);
      const rollBtn = ctx.doc ? ctx.doc.getElementById("btnRollDice") : null;
      if (rollBtn) {
        rollBtn.addEventListener("click", () => {
          if (typeof performDiceRoll === "function") performDiceRoll(who);
          else _ClashMiniGames.performDiceRoll(who, context);
        });
      }
      setTimeout(() => {
        _ClashMiniGames.performDiceRoll(who, context);
      }, 300);
    }
    /**
     * Animates and resolves the 3-die scramble roll.
     * @param {string} who
     * @param {Object} [context={}]
     */
    static performDiceRoll(who, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      if (ctx.state && ctx.state._diceRolling) return;
      if (ctx.state) ctx.state._diceRolling = true;
      const doc = ctx.doc;
      const btn = doc ? doc.getElementById("btnRollDice") : null;
      if (btn) {
        btn.disabled = true;
        btn.textContent = "ROLLING... (2s)";
      }
      const d1 = doc ? doc.getElementById("die1") : null;
      const d2 = doc ? doc.getElementById("die2") : null;
      const d3 = doc ? doc.getElementById("die3") : null;
      const d1V = doc ? doc.getElementById("die1Val") : null;
      const d2V = doc ? doc.getElementById("die2Val") : null;
      const d3V = doc ? doc.getElementById("die3Val") : null;
      if (d1) {
        d1.classList.add("rolling");
        d1.classList.remove("settled");
      }
      if (d2) {
        d2.classList.add("rolling");
        d2.classList.remove("settled");
      }
      if (d3) {
        d3.classList.add("rolling");
        d3.classList.remove("settled");
      }
      ctx.sfx.card();
      const dirOptions = ["+", "\u2212"];
      const valOptions = [5, 10, 15, 20, 25, 30];
      const targetOptions = ["You", "Opponent", "You Pick"];
      const scrambleTimer = setInterval(() => {
        if (d1V) d1V.textContent = dirOptions[Math.floor(Math.random() * dirOptions.length)];
        if (d2V) d2V.textContent = valOptions[Math.floor(Math.random() * valOptions.length)];
        if (d3V) d3V.textContent = targetOptions[Math.floor(Math.random() * targetOptions.length)];
      }, 65);
      setTimeout(() => {
        clearInterval(scrambleTimer);
        if (ctx.state) ctx.state._diceRolling = false;
        if (d1) {
          d1.classList.remove("rolling");
          d1.classList.add("settled");
        }
        if (d2) {
          d2.classList.remove("rolling");
          d2.classList.add("settled");
        }
        if (d3) {
          d3.classList.remove("rolling");
          d3.classList.add("settled");
        }
        const dir = Math.random() < 0.5 ? "+" : "\u2212";
        const val = valOptions[Math.floor(Math.random() * valOptions.length)];
        const die3Pool = ["You", "You", "Opponent", "Opponent", "You Pick", "You Pick"];
        const targetType = die3Pool[Math.floor(Math.random() * die3Pool.length)];
        if (d1V) d1V.textContent = dir;
        if (d2V) d2V.textContent = val;
        if (d3V) d3V.textContent = targetType;
        ctx.sfx.pop();
        const isPositive = dir === "+";
        const signedPts = isPositive ? val : -val;
        ctx.log(`\u{1F3B2} DICE STOPPED: [${dir}] [${val} pts] [${targetType}]!`);
        const isCpu = ctx.isSeatCpu(who);
        const getTracksFn = context.getActiveTracks || ctx.win && ctx.win.getActiveTracks;
        const tracks = typeof getTracksFn === "function" ? getTracksFn() : ["p1", "p2"];
        const opponents = tracks.filter((t) => t !== who);
        const actContainer = doc ? doc.getElementById("diceActions") : null;
        const pickContainer = doc ? doc.getElementById("diceTargetPick") : null;
        if (targetType === "You") {
          const targetName = ctx.pName(who);
          if (actContainer) {
            actContainer.innerHTML = `<div class="dice-result-banner">\u{1F3B2} Outcome: ${dir}${val} pts for ${targetName}!</div>`;
          }
          ctx.setStatus(`Dice: ${dir}${val} points for ${targetName}`);
          setTimeout(() => {
            _ClashMiniGames.applyDiceResult(who, signedPts, context);
          }, 2e3);
        } else if (targetType === "Opponent") {
          const targetOpp = opponents.slice().sort((a, b) => {
            const scA = ctx.state.scores && ctx.state.scores[a] || 0;
            const scB = ctx.state.scores && ctx.state.scores[b] || 0;
            return isPositive ? scA - scB : scB - scA;
          })[0] || opponents[0] || "cpu";
          const targetName = ctx.pName(targetOpp);
          if (actContainer) {
            actContainer.innerHTML = `<div class="dice-result-banner">\u{1F3B2} Outcome: ${dir}${val} pts for Opponent (${targetName})!</div>`;
          }
          ctx.setStatus(`Dice: ${dir}${val} points for Opponent (${targetName})`);
          setTimeout(() => {
            _ClashMiniGames.applyDiceResult(targetOpp, signedPts, context);
          }, 2e3);
        } else {
          const bestTarget = isPositive ? who : opponents[0] || who;
          if (isCpu) {
            const bestTargetName = ctx.pName(bestTarget);
            if (actContainer) {
              actContainer.innerHTML = `<div class="dice-result-banner">\u{1F3B2} ${ctx.pName(who)} picked: ${bestTargetName} to move ${dir}${val} pts!</div>`;
            }
            ctx.setStatus(`${ctx.pName(who)} picked ${bestTargetName} to move ${dir}${val} points`);
            ctx.log(`\u{1F3B2} YOU PICK: ${ctx.pName(who)} picked ${bestTargetName} to move ${dir}${val} points!`);
            setTimeout(() => {
              _ClashMiniGames.applyDiceResult(bestTarget, signedPts, context);
            }, 2e3);
          } else {
            if (actContainer) {
              actContainer.innerHTML = `<div class="dice-result-banner">\u{1F3B2} You Pick! Pick what player has to move (${dir}${val} pts):</div>`;
            }
            ctx.setStatus(`You Pick! Pick what player has to move (${dir}${val} points)`);
            if (pickContainer) {
              pickContainer.style.display = "flex";
              pickContainer.innerHTML = tracks.map((p) => {
                const curScore = ctx.state.scores && ctx.state.scores[p] || 0;
                const newScore = Math.max(0, curScore + signedPts);
                const color = ctx.win && typeof ctx.win.seatColor === "function" ? ctx.win.seatColor(p) : "#f0c64a";
                return `
                <button type="button" class="target-player-btn" data-action="dice-pick-player" data-player="${p}" data-signed="${signedPts}" data-dir="${dir}" data-val="${val}">
                  <span style="color: ${color}; font-size: 1.05rem;">${ctx.pName(p)}</span>
                  <span class="target-score-shift">${curScore} pts \u2192 <strong>${newScore} pts</strong> (${dir}${val})</span>
                </button>
              `;
              }).join("");
              pickContainer.addEventListener("click", (e) => {
                const btn2 = e.target.closest('[data-action="dice-pick-player"]');
                if (btn2) {
                  const pSeat = btn2.dataset.player;
                  const sPts = parseInt(btn2.dataset.signed, 10);
                  const d = btn2.dataset.dir;
                  const v = parseInt(btn2.dataset.val, 10);
                  if (typeof onDicePickPlayer === "function") {
                    onDicePickPlayer(pSeat, sPts, d, v);
                  } else {
                    _ClashMiniGames.onDicePickPlayer(pSeat, sPts, d, v, context);
                  }
                }
              });
            }
          }
        }
      }, 2e3);
    }
    /**
     * Handles interactive human player selection after a 'You Pick' die outcome.
     * @param {string} targetWho
     * @param {number} signedPts
     * @param {string} dir
     * @param {number} val
     * @param {Object} [context={}]
     */
    static onDicePickPlayer(targetWho, signedPts, dir, val, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      const doc = ctx.doc;
      const actContainer = doc ? doc.getElementById("diceActions") : null;
      const pickContainer = doc ? doc.getElementById("diceTargetPick") : null;
      if (pickContainer) pickContainer.style.display = "none";
      const targetName = ctx.pName(targetWho);
      const dirStr = dir || (signedPts >= 0 ? "+" : "\u2212");
      const ptsVal = val || Math.abs(signedPts);
      if (actContainer) {
        actContainer.innerHTML = `<div class="dice-result-banner">\u{1F3B2} You picked: ${targetName} to move ${dirStr}${ptsVal} pts!</div>`;
      }
      ctx.log(`\u{1F3B2} YOU PICK: Player chose ${targetName} to move ${dirStr}${ptsVal} points!`);
      ctx.setStatus(`You picked ${targetName} to move ${dirStr}${ptsVal} points`);
      setTimeout(() => {
        _ClashMiniGames.applyDiceResult(targetWho, signedPts, context);
      }, 2e3);
    }
    /**
     * Closes the dice modal, adds the score delta, and resumes the match.
     * @param {string} targetWho
     * @param {number} signedPts
     * @param {Object} [context={}]
     */
    static applyDiceResult(targetWho, signedPts, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      ctx.closeModal();
      const playerName = ctx.pName(targetWho);
      const signPrefix = signedPts >= 0 ? "+" : "";
      ctx.log(`\u{1F3B2} DICE OUTCOME: ${playerName} ${signPrefix}${signedPts} pts!`);
      ctx.fancyCall(`DICE: ${signPrefix}${signedPts} PTS!`, "signs", 2600);
      ctx.addScore(targetWho, signedPts, `Dice Roll: ${signPrefix}${signedPts}`, false, true);
      _ClashMiniGames.resumeGameAfterSign(context);
    }
    /**
     * Opens the Spin-The-Wheel modal and draws the canvas.
     * @param {string} who
     * @param {Object} [context={}]
     */
    static openWheelSpinModal(who, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      const isCpu = ctx.isSeatCpu(who);
      const modalHtml = `
      <div class="signs-modal-wrap">
        <h2 class="signs-modal-title">\u{1F3A1} SPIN THE WHEEL</h2>
        <p class="signs-modal-subtitle">Spin for 1 of 8 exciting rewards or penalties:</p>
        <div class="wheel-arena">
          <div class="wheel-pointer"></div>
          <canvas id="wheelCanvas" class="wheel-canvas" width="240" height="240"></canvas>
          <div class="wheel-hub"></div>
        </div>
        <div id="wheelActions">
          <button type="button" class="dice-roll-btn" id="btnSpinWheel">SPIN WHEEL</button>
        </div>
      </div>
    `;
      ctx.showModal(modalHtml, false);
      const spinBtn = ctx.doc ? ctx.doc.getElementById("btnSpinWheel") : null;
      if (spinBtn) {
        spinBtn.addEventListener("click", () => {
          if (typeof performWheelSpin === "function") performWheelSpin(who);
          else _ClashMiniGames.performWheelSpin(who, context);
        });
      }
      const canvas = ctx.doc ? ctx.doc.getElementById("wheelCanvas") : null;
      if (canvas) {
        _ClashMiniGames.drawWheelCanvas(canvas);
      }
      if (isCpu) {
        setTimeout(() => {
          _ClashMiniGames.performWheelSpin(who, context);
        }, 700);
      }
    }
    /**
     * Draws 8 color-coded wheel segments with text labels on an HTML5 canvas.
     * @param {HTMLCanvasElement} canvas
     */
    static drawWheelCanvas(canvas) {
      if (!canvas || typeof canvas.getContext !== "function") return;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      const cx = 120, cy = 120, r = 118;
      const colors = ["#10b981", "#ef4444", "#06b6d4", "#f97316", "#6366f1", "#a855f7", "#eab308", "#ec4899"];
      const n = CLASH_WHEEL_SLOTS.length;
      const step = Math.PI * 2 / n;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < n; i++) {
        const angle = i * step;
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.arc(cx, cy, r, angle, angle + step);
        ctx.closePath();
        ctx.fillStyle = colors[i % colors.length];
        ctx.fill();
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#ffffff";
        ctx.stroke();
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(angle + step / 2);
        ctx.textAlign = "right";
        ctx.fillStyle = "#ffffff";
        ctx.font = "bold 11px Outfit, sans-serif";
        ctx.shadowColor = "rgba(0,0,0,0.8)";
        ctx.shadowBlur = 4;
        ctx.fillText(CLASH_WHEEL_SLOTS[i], r - 12, 4);
        ctx.restore();
      }
    }
    /**
     * Animates the wheel spin rotation and executes the outcome.
     * @param {string} who
     * @param {Object} [context={}]
     */
    static performWheelSpin(who, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      const doc = ctx.doc;
      const btn = doc ? doc.getElementById("btnSpinWheel") : null;
      if (btn) btn.disabled = true;
      const canvas = doc ? doc.getElementById("wheelCanvas") : null;
      if (!canvas) return;
      const slotIdx = Math.floor(Math.random() * CLASH_WHEEL_SLOTS.length);
      const n = CLASH_WHEEL_SLOTS.length;
      const slotAngleDeg = 360 / n;
      const targetAngle = 360 - (slotIdx * slotAngleDeg + slotAngleDeg / 2) - 90;
      const totalRot = 360 * 5 + targetAngle;
      canvas.style.transform = `rotate(${totalRot}deg)`;
      ctx.sfx.card();
      setTimeout(() => {
        const landedSlot = CLASH_WHEEL_SLOTS[slotIdx];
        const isHuman = ctx.isSeatHuman(who);
        const playerName = ctx.pName(who);
        const actEl = doc ? doc.getElementById("wheelActions") : null;
        if (actEl) {
          actEl.innerHTML = `<div class="dice-result-banner">\u{1F3A1} Result: ${landedSlot.toUpperCase()}!</div>`;
        }
        if (!isHuman) {
          ctx.log(`\u{1F3A1} WHEEL RESULT: ${playerName} spun and landed on "${landedSlot}"!`);
          ctx.fancyCall(`${playerName} WHEEL: ${landedSlot.toUpperCase()}!`, "signs", 3200);
          ctx.setStatus(`${playerName} spun wheel and landed on ${landedSlot}`);
        } else {
          ctx.log(`\u{1F3A1} WHEEL RESULT: Landed on "${landedSlot}"!`);
          ctx.fancyCall(`WHEEL: ${landedSlot.toUpperCase()}`, "signs", 2800);
          ctx.setStatus(`Wheel landed on ${landedSlot}`);
        }
        setTimeout(() => {
          ctx.closeModal();
          setTimeout(() => {
            _ClashMiniGames.executeSign(landedSlot, who, null, context);
            if (landedSlot !== "Roll The Dice") {
              _ClashMiniGames.resumeGameAfterSign(context);
            }
          }, 1e3);
        }, 2400);
      }, 4e3);
    }
    /**
     * Updates the SVG track signs billboard text for a block.
     * @param {number} blockId
     * @param {Object} [context={}]
     */
    static updateSignsBillboard(blockId, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      const doc = ctx.doc;
      if (!doc) return;
      const tEl = doc.getElementById(`signsText${blockId}`);
      if (!tEl) return;
      const getSignsFn = context.getSignConfigs || ctx.win && ctx.win.getSignConfigs;
      const blocks = typeof getSignsFn === "function" ? getSignsFn() : [];
      const block = blocks.find((b) => b.id === blockId);
      if (!block) return;
      const remaining = ctx.state && ctx.state.signsState && ctx.state.signsState[blockId] ? ctx.state.signsState[blockId] : block.initialSigns;
      tEl.textContent = `\u{1FAA7} Signs: ${remaining.length}/${block.initialSigns.length}`;
    }
    /**
     * Displays info callout for remaining signs when user clicks a sign billboard.
     * @param {number} blockId
     * @param {Object} [context={}]
     */
    static onSignBillboardClick(blockId, context = {}) {
      const ctx = _ClashMiniGames._resolveCtx(context);
      const getSignsFn = context.getSignConfigs || ctx.win && ctx.win.getSignConfigs;
      const blocks = typeof getSignsFn === "function" ? getSignsFn() : [];
      const block = blocks.find((b) => b.id === blockId);
      if (!block) return;
      const remaining = ctx.state && ctx.state.signsState && ctx.state.signsState[blockId] ? ctx.state.signsState[blockId] : block.initialSigns;
      const defs = CLASH_SIGN_DEFS;
      const signsList = remaining.map((s) => `\u2022 ${s} (${defs[s] && defs[s].desc || ""})`).join("\n");
      ctx.log(`\u{1FAA7} SIGN BLOCK ${blockId} (Holes ${block.start}\u2013${block.end}):
Remaining Signs:
${signsList}`);
      ctx.fancyCall(`BLOCK ${blockId}: ${remaining.length} SIGNS LEFT`, "signs", 1600);
    }
  };

  // src/ui/TableRenderer.js
  var TableRenderer = class _TableRenderer {
    static _animSeen = /* @__PURE__ */ new Set();
    static takeAnim(key) {
      if (!key || _TableRenderer._animSeen.has(key)) return false;
      _TableRenderer._animSeen.add(key);
      return true;
    }
    static resetAnims() {
      _TableRenderer._animSeen.clear();
    }
    static isWild(c) {
      if (c && typeof c.isWild === "boolean") return c.isWild;
      return !!(c && c.wild);
    }
    static rankOf(c) {
      if (c && typeof c.rank === "number") return c.rank;
      return c && c.playAs && c.playAs.r || (c ? c.r : 0);
    }
    static suitOf(c) {
      if (c && typeof c.suit === "string") return c.suit;
      return c && c.playAs && c.playAs.s || (c ? c.s : "S");
    }
    static faceMarkup(c) {
      const card = c instanceof Card2 ? c : Card2.from(c);
      return TraditionalCard.renderHtml(card);
    }
    static cardEl(c, opts = {}, context = {}) {
      if (typeof document === "undefined") return null;
      const card = c instanceof Card2 ? c : Card2.from(c);
      const d = document.createElement("div");
      const shownS = _TableRenderer.suitOf(card);
      const red = card && typeof card.isRed === "boolean" ? card.isRed : !_TableRenderer.isWild(card) && (shownS === "H" || shownS === "D");
      const wildCard = _TableRenderer.isWild(card);
      d.className = "playing-card" + (red ? " red" : "") + (wildCard ? " wild" : "") + (wildCard && !card.playAs ? " joker" : "");
      if (opts.playable) d.className += " playable";
      if (opts.selected) d.className += " selected";
      if (opts.disabled) d.className += " disabled";
      if (opts.highlight) d.className += " highlight-line";
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      const animKey = opts.animKey || (card && card.id) + ":" + opts.anim + ":" + (state3 && state3.phase);
      const doFlip = opts.anim === "flip" && _TableRenderer.takeAnim(animKey);
      const isFaceDown = opts.back || Boolean(card && card.faceDown);
      if (opts.anim && opts.anim !== "flip" && _TableRenderer.takeAnim(animKey)) {
        d.classList.add("anim-" + opts.anim);
        if (opts.delay) d.style.animationDelay = opts.delay + "ms";
      }
      if (doFlip && !isFaceDown) {
        d.classList.add("flipping");
        const inner = document.createElement("div");
        inner.className = "card-3d";
        if (opts.delay) inner.style.animationDelay = opts.delay + "ms";
        inner.innerHTML = `<div class="face back-face"></div><div class="face front">${_TableRenderer.faceMarkup(card)}</div>`;
        d.appendChild(inner);
      } else if (!isFaceDown) {
        d.innerHTML = _TableRenderer.faceMarkup(card);
      } else {
        d.className += " back face-down";
        d.innerHTML = `<span></span><span class="suit">\u2726</span>`;
      }
      if (opts.badge && !isFaceDown) d.setAttribute("data-badge", opts.badge);
      if (opts.badgeBonus && !isFaceDown) d.classList.add("badge-bonus");
      if (card && card.id) d.setAttribute("data-cid", card.id);
      if (opts.onClick) d.addEventListener("click", opts.onClick);
      return d;
    }
    static cardKey(c) {
      if (!c) return "";
      if (c.id) return c.id;
      return _TableRenderer.rankOf(c) + "-" + _TableRenderer.suitOf(c);
    }
    static applyHighlights(cards, isBonus = false, context = {}) {
      if (typeof document === "undefined") return;
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null);
      if (state3) {
        state3.highlightIds = (cards || []).map(_TableRenderer.cardKey).filter(Boolean);
      }
      document.querySelectorAll(".playing-card.highlight-line, .playing-card.highlight-bonus").forEach((el) => {
        el.classList.remove("highlight-line", "highlight-bonus");
      });
      const ids = state3 && state3.highlightIds || (cards || []).map(_TableRenderer.cardKey).filter(Boolean);
      for (const id of ids) {
        const safe = String(id).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        document.querySelectorAll('.playing-card[data-cid="' + safe + '"]').forEach((el) => {
          el.classList.add(isBonus ? "highlight-bonus" : "highlight-line");
        });
      }
    }
    static cardLabel(c) {
      if (_TableRenderer.isWild(c) && !c.playAs) return "Joker";
      return (RANK_NAME[_TableRenderer.rankOf(c)] || "\u2605") + (SUIT_SYM[_TableRenderer.suitOf(c)] || "");
    }
    static miniCardHtml(c, extra = "") {
      if (!c) return "";
      const s = _TableRenderer.suitOf(c);
      const red = s === "H" || s === "D";
      return `<span class="mini-card${red ? " red" : ""}${extra ? " " + extra : ""}">${_TableRenderer.cardLabel(c)}</span>`;
    }
    /**
     * Main table layout render loop.
     * Updates role badges, player hand, opponent hands, crib, starter, played pile, and action controls.
     * @param {Object} context
     */
    static render(context = {}) {
      if (typeof document === "undefined") {
        const r3d = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
        if (r3d && typeof r3d.syncFromGameState === "function") {
          r3d.syncFromGameState({
            ...context,
            state: context.state || (typeof window !== "undefined" ? window.state : null) || {},
            me: context.mySeat ? context.mySeat() : typeof window !== "undefined" && typeof window.mySeat === "function" ? window.mySeat() : "p1"
          });
        }
        return;
      }
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null) || {};
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
      const mySeatFn = context.mySeat || (typeof window !== "undefined" ? window.mySeat : () => "p1");
      const getActiveSeatIds2 = context.getActiveSeatIds || (typeof window !== "undefined" ? window.getActiveSeatIds : () => ["p1", "p2"]);
      const getPlayerCount2 = context.getPlayerCount || (typeof window !== "undefined" ? window.getPlayerCount : () => 2);
      const isSoloVsPairs2 = context.isSoloVsPairs || (typeof window !== "undefined" ? window.isSoloVsPairs : () => false);
      const isOnline2 = context.isOnline || (typeof window !== "undefined" ? window.isOnline : () => false);
      const isHvH2 = context.isHvH || (typeof window !== "undefined" ? window.isHvH : () => false);
      const isSeatHuman2 = context.isSeatHuman || (typeof window !== "undefined" ? window.isSeatHuman : () => true);
      const getSeatKept2 = context.getSeatKept || (typeof window !== "undefined" ? window.getSeatKept : () => []);
      const getSeatHand2 = context.getSeatHand || (typeof window !== "undefined" ? window.getSeatHand : () => []);
      const sortCards2 = context.sortCards || (typeof window !== "undefined" ? window.sortCards : (cards) => cards);
      const cardLabel2 = context.cardLabel || (typeof window !== "undefined" ? window.cardLabel : (c) => c ? `${c.r}${c.s}` : "");
      const cardFits2 = context.cardFits || (typeof window !== "undefined" ? window.cardFits : () => true);
      const cardEl2 = context.cardEl || (typeof window !== "undefined" ? window.cardEl : null);
      const isWild2 = context.isWild || (typeof window !== "undefined" ? window.isWild : () => false);
      const onPickCribCard2 = context.onPickCribCard || (typeof window !== "undefined" ? window.onPickCribCard : () => {
      });
      const onYouCard2 = context.onYouCard || (typeof window !== "undefined" ? window.onYouCard : () => {
      });
      const onCpuCard2 = context.onCpuCard || (typeof window !== "undefined" ? window.onCpuCard : () => {
      });
      const onOppSeatDiscardCard2 = context.onOppSeatDiscardCard || (typeof window !== "undefined" ? window.onOppSeatDiscardCard : () => {
      });
      const updateCoachDisplay2 = context.updateCoachDisplay || (typeof window !== "undefined" ? window.updateCoachDisplay : () => {
      });
      const seatName3 = context.seatName || (typeof window !== "undefined" ? window.seatName : (s) => s);
      const nextSeat2 = context.nextSeat || (typeof window !== "undefined" ? window.nextSeat : (s) => s === "p1" ? "p2" : "p1");
      const poneDoCutStarter2 = context.poneDoCutStarter || (typeof window !== "undefined" ? window.poneDoCutStarter : () => {
      });
      const seatDiscardsToDeck2 = context.seatDiscardsToDeck || (typeof window !== "undefined" ? window.seatDiscardsToDeck : () => false);
      const isDealerTeam2 = context.isDealerTeam || (typeof window !== "undefined" ? window.isDealerTeam : () => false);
      const setShowMeter2 = context.setShowMeter || (typeof window !== "undefined" ? window.setShowMeter : () => {
      });
      const updateTurnPrompt2 = context.updateTurnPrompt || (typeof window !== "undefined" ? window.updateTurnPrompt : () => {
      });
      const renderScores2 = context.renderScores || (typeof window !== "undefined" ? window.renderScores : () => {
      });
      const updateCountGlow2 = context.updateCountGlow || (typeof window !== "undefined" ? window.updateCountGlow : () => {
      });
      const renderCutFan2 = context.renderCutFan || (typeof window !== "undefined" ? window.renderCutFan : () => {
      });
      const count = Number(context.count || settings3 && settings3.playerCount || (typeof getPlayerCount2 === "function" ? getPlayerCount2(settings3) : 2)) || 2;
      const isMulti = count >= 3;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      const isCanadianDoubles = Boolean(settings3 && settings3.optCanadianDoubles && count === 4);
      const discardN = isCanadianDoubles ? 2 : isMulti ? 1 : is7Card ? 2 : settings3 && settings3.deal === "super" ? 3 : 2;
      const me = mySeatFn();
      const oppSeats = getActiveSeatIds2().filter((id) => id !== me);
      const primaryOpp = oppSeats[0] || (me === "p1" ? "p2" : "p1");
      const isCutPhase = state3.phase === "cut" || state3.phase === "cut-reveal";
      const youRoleEl = document.getElementById("youRole");
      const cpuRoleEl = document.getElementById("cpuRole");
      if (isCutPhase) {
        const myCut = state3.cutPicks && state3.cutPicks[me];
        const oppCut = state3.cutPicks && state3.cutPicks[primaryOpp];
        if (state3.phase === "cut-reveal") {
          const isMeDeal = state3.dealer === me || state3.dealer === "you";
          if (youRoleEl) youRoleEl.textContent = myCut ? `(cut ${cardLabel2(myCut)}${isMeDeal ? " \u2014 deals!" : ""})` : "(cut)";
          if (cpuRoleEl) cpuRoleEl.textContent = oppCut ? `(cut ${cardLabel2(oppCut)}${!isMeDeal ? " \u2014 deals!" : ""})` : "(cut)";
        } else {
          if (youRoleEl) youRoleEl.textContent = myCut ? `(cut ${cardLabel2(myCut)})` : "(cut)";
          if (cpuRoleEl) cpuRoleEl.textContent = oppCut ? `(cut ${cardLabel2(oppCut)})` : "(cut)";
        }
      } else {
        const isMeDeal = state3.dealer === me || state3.dealer === "you";
        if (youRoleEl) {
          if (isSoloVsPairs2()) {
            youRoleEl.textContent = isMeDeal ? "(dealer & crib)" : "(crib)";
          } else {
            youRoleEl.textContent = isMeDeal ? "(dealer)" : "(pone)";
          }
        }
        if (cpuRoleEl) {
          cpuRoleEl.textContent = state3.dealer === primaryOpp ? "(dealer)" : "(pone)";
        }
      }
      const youTitleEl = document.getElementById("youTitle");
      if (youTitleEl) {
        const isMultiH = typeof context.isMultiHuman === "function" ? context.isMultiHuman() : typeof window !== "undefined" && typeof window.isMultiHuman === "function" ? window.isMultiHuman() : settings3 && (settings3.opp === "online" || settings3.isHvH);
        const isOnlineFn = context.isSeatOnline || (typeof window !== "undefined" ? window.isSeatOnline : null);
        const isOnline3 = typeof isOnlineFn === "function" ? isOnlineFn(me) : true;
        const ind = isMultiH ? `<span class="online-indicator ${isOnline3 ? "online" : "offline"}" title="${isOnline3 ? "Online" : "Offline"}"></span>` : "";
        youTitleEl.innerHTML = `${ind}Your hand`;
      }
      const countValEl = document.getElementById("countVal");
      if (countValEl) countValEl.textContent = state3.count != null ? state3.count : 0;
      if (typeof renderCutFan2 === "function") {
        renderCutFan2();
      }
      _TableRenderer.renderPlayerHand({
        state: state3,
        settings: settings3,
        me,
        isCutPhase,
        discardN,
        isOnline: isOnline2,
        isHvH: isHvH2,
        isSeatHuman: isSeatHuman2,
        getSeatKept: getSeatKept2,
        getSeatHand: getSeatHand2,
        sortCards: sortCards2,
        cardEl: cardEl2,
        cardFits: cardFits2,
        isWild: isWild2,
        onPickCribCard: onPickCribCard2,
        onYouCard: onYouCard2,
        updateCoachDisplay: updateCoachDisplay2
      });
      _TableRenderer.renderOpponents({
        state: state3,
        settings: settings3,
        me,
        isMulti,
        oppSeats,
        primaryOpp,
        isCutPhase,
        isOnline: isOnline2,
        isHvH: isHvH2,
        isSeatHuman: isSeatHuman2,
        isSeatOnline,
        isMultiHuman,
        getSeatKept: getSeatKept2,
        getSeatHand: getSeatHand2,
        sortCards: sortCards2,
        cardEl: cardEl2,
        cardLabel: cardLabel2,
        cardFits: cardFits2,
        isWild: isWild2,
        seatName: seatName3,
        onPickCribCard: onPickCribCard2,
        onCpuCard: onCpuCard2,
        onOppSeatDiscardCard: onOppSeatDiscardCard2
      });
      _TableRenderer.renderCrib({
        state: state3,
        settings: settings3,
        getPlayerCount: getPlayerCount2,
        sortCards: sortCards2,
        cardEl: cardEl2
      });
      _TableRenderer.renderStarter({
        state: state3,
        cardEl: cardEl2
      });
      _TableRenderer.renderPlayedPile({
        state: state3,
        cardEl: cardEl2,
        updateCountGlow: updateCountGlow2
      });
      _TableRenderer.renderActionControls({
        state: state3,
        settings: settings3,
        me,
        discardN,
        isCutPhase,
        count,
        isOnline: isOnline2,
        isSeatHuman: isSeatHuman2,
        seatName: seatName3,
        nextSeat: nextSeat2,
        poneDoCutStarter: poneDoCutStarter2,
        seatDiscardsToDeck: seatDiscardsToDeck2,
        isSoloVsPairs: isSoloVsPairs2,
        isDealerTeam: isDealerTeam2,
        setShowMeter: setShowMeter2,
        getSeatHand: getSeatHand2
      });
      if (typeof updateTurnPrompt2 === "function") updateTurnPrompt2();
      if (typeof renderScores2 === "function") renderScores2(false);
      const renderer3D = context.boardRenderer3D || (typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null);
      if (renderer3D && typeof renderer3D.syncFromGameState === "function") {
        renderer3D.syncFromGameState({
          state: state3,
          settings: settings3,
          me,
          oppSeats,
          primaryOpp,
          getSeatHand: getSeatHand2,
          getSeatKept: getSeatKept2,
          sortCards: sortCards2,
          count,
          onYouCard: onYouCard2,
          onPickCribCard: onPickCribCard2,
          poneDoCutStarter: poneDoCutStarter2,
          updateCoachDisplay: updateCoachDisplay2
        });
      }
    }
    /**
     * Renders the local player's hand (#youCards).
     */
    static renderPlayerHand(ctx) {
      const youEl = document.getElementById("youCards");
      if (!youEl || typeof ctx.cardEl !== "function") return;
      youEl.innerHTML = "";
      const {
        state: state3,
        settings: settings3,
        me,
        isCutPhase,
        discardN,
        isOnline: isOnline2,
        isHvH: isHvH2,
        isSeatHuman: isSeatHuman2,
        getSeatKept: getSeatKept2,
        getSeatHand: getSeatHand2,
        sortCards: sortCards2,
        cardEl: cardEl2,
        cardFits: cardFits2,
        isWild: isWild2,
        onPickCribCard: onPickCribCard2,
        onYouCard: onYouCard2,
        updateCoachDisplay: updateCoachDisplay2
      } = ctx;
      const isPassingDevice = !isOnline2() && Boolean(state3 && state3.passingTo);
      const isPickingMe = !isPassingDevice && state3.phase === "pick-crib" && state3.currentPickPone === me;
      const activeHumanDiscard = !isOnline2() ? state3.currentHumanDiscard || "p1" : me;
      const isP1Turn = !isPassingDevice && activeHumanDiscard === "p1" && (state3.phase === "discard" || state3.phase === "draw-1" || state3.phase === "draw-2");
      const hideYou = isPassingDevice || !isOnline2() && (!isP1Turn && (state3.phase === "discard" || state3.phase === "discard-p2" || state3.phase === "draw-1" || state3.phase === "draw-2" || state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2") || isHvH2() && (state3.phase === "assign-p2" || state3.phase === "play" && state3.turn === "p2") || isPickingMe);
      const canDiscard = !isPassingDevice && (state3.phase === "discard" && (!isOnline2() ? activeHumanDiscard === "p1" : settings3.netRole === "host" || isSeatHuman2(me)) || state3.phase === "discard-p2" && isOnline2() && me === "p2");
      const isDrawMe = !isPassingDevice && ((state3.phase === "draw-1" || state3.phase === "draw-2") && (!isOnline2() ? activeHumanDiscard === "p1" : settings3.netRole === "host" || isSeatHuman2(me)) || (state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2") && isOnline2() && me === "p2");
      const selecting = canDiscard || isDrawMe;
      const assigning = !isPassingDevice && (state3.phase === "assign" && state3.assignTarget === "hand");
      const showHands = !isPassingDevice && (state3.phase === "show" || state3.over);
      const myKept = getSeatKept2(me);
      const myCutCard = isCutPhase && state3.cutPicks ? state3.cutPicks[me] : null;
      const myHand = myCutCard ? [myCutCard] : showHands && myKept && myKept.length ? myKept : getSeatHand2(me);
      const myTurn = !isPassingDevice && (state3.turn === me || me === "p1" && state3.turn === "you");
      const displayMe = isPickingMe ? myHand : sortCards2(myHand);
      displayMe.forEach((c, i) => {
        const isCutCard = Boolean(isCutPhase && myCutCard && c.id === myCutCard.id);
        const selected = !isPassingDevice && (isPickingMe ? state3.selected.includes(c.id) : !hideYou && state3.selected.includes(c.id));
        const legalPlay2 = !isPassingDevice && state3.phase === "play" && myTurn && cardFits2(c, state3.count);
        const dealPhase = state3.phase === "discard" || state3.phase === "assign" || state3.phase === "play" || state3.phase === "cut-starter" || state3.phase === "starter-ritual" || state3.phase === "draw-1" || state3.phase === "draw-2" || state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2";
        const cardNode = cardEl2(c, {
          back: isPassingDevice || !isCutCard && hideYou && state3.phase !== "show" && !state3.over || isPickingMe,
          selected,
          highlight: !isPassingDevice && state3.highlightIds && state3.highlightIds.includes(c.id),
          playable: !isPassingDevice && (isPickingMe || !isCutCard && !hideYou && (selecting || legalPlay2 || assigning && isWild2(c) && !c.playAs)),
          disabled: isPassingDevice || hideYou && !isPickingMe || state3.phase === "play" && myTurn && !legalPlay2,
          onClick: isPassingDevice ? void 0 : isPickingMe ? () => onPickCribCard2(me, c) : hideYou ? void 0 : () => onYouCard2(c),
          anim: isPassingDevice ? null : isCutCard ? "flip" : state3.phase === "dealing" ? "deal-you" : dealPhase && state3.phase !== "show" ? "deal" : null,
          animKey: isCutCard ? "cut-" + c.id : "hand-" + c.id + (state3.phase === "dealing" ? "-deal" : ""),
          delay: isCutCard ? 0 : state3.phase === "dealing" ? i * 55 : state3.phase === "cut-reveal" || state3.phase === "show" ? i * 90 : i * 70
        });
        if (settings3.coach === "on" && state3.phase === "discard") {
          cardNode.addEventListener("mouseenter", () => {
            let sim = getSeatHand2(me).filter((x) => state3.selected.includes(x.id));
            if (!state3.selected.includes(c.id)) {
              sim = sim.concat([c]).slice(0, discardN);
            }
            if (sim.length === discardN) {
              updateCoachDisplay2(sim);
            }
          });
          cardNode.addEventListener("mouseleave", () => {
            updateCoachDisplay2();
          });
        }
        if (cardNode) {
          cardNode.style.zIndex = selected ? "12" : String(i + 1);
        }
        youEl.appendChild(cardNode);
      });
    }
    /**
     * Renders the opponents container (#opponentsWrapper) for 2P or multiplayer.
     */
    static renderOpponents(ctx) {
      const oppWrap = document.getElementById("opponentsWrapper");
      if (!oppWrap || typeof ctx.cardEl !== "function") return;
      const {
        state: state3,
        settings: settings3,
        me,
        isMulti,
        oppSeats,
        primaryOpp,
        isCutPhase,
        isOnline: isOnline2,
        isHvH: isHvH2,
        isSeatHuman: isSeatHuman2,
        isSeatOnline: isSeatOnline3,
        isMultiHuman: isMultiHuman3,
        getSeatKept: getSeatKept2,
        getSeatHand: getSeatHand2,
        sortCards: sortCards2,
        cardEl: cardEl2,
        cardLabel: cardLabel2,
        cardFits: cardFits2,
        isWild: isWild2,
        seatName: seatName3,
        onPickCribCard: onPickCribCard2,
        onCpuCard: onCpuCard2,
        onOppSeatDiscardCard: onOppSeatDiscardCard2
      } = ctx;
      oppWrap.classList.toggle("multi", isMulti);
      const isPassingDevice = !isOnline2() && Boolean(state3 && state3.passingTo);
      const showHands = !isPassingDevice && (state3.phase === "show" || state3.over);
      if (!isMulti) {
        if (!document.getElementById("cpuZone")) {
          oppWrap.innerHTML = `
          <div class="zone" id="cpuZone">
            <h3><span id="cpuTitle">${seatName3(primaryOpp)}</span> <span id="cpuRole"></span></h3>
            <div class="cards" id="cpuCards"></div>
          </div>`;
        }
        const ct = document.getElementById("cpuTitle");
        if (ct) {
          const isMultiH = typeof isMultiHuman3 === "function" ? isMultiHuman3() : typeof window !== "undefined" && typeof window.isMultiHuman === "function" ? window.isMultiHuman() : settings3 && (settings3.opp === "online" || settings3.opp === "hvh" || settings3.isHvH);
          const oppIsHuman = typeof isSeatHuman2 === "function" ? isSeatHuman2(primaryOpp) : typeof window !== "undefined" && typeof window.isSeatHuman === "function" ? window.isSeatHuman(primaryOpp) : true;
          const isOnlineFn = isSeatOnline3 || (typeof window !== "undefined" ? window.isSeatOnline : null);
          const isOnline3 = typeof isOnlineFn === "function" ? isOnlineFn(primaryOpp) : true;
          const ind = isMultiH && oppIsHuman ? `<span class="online-indicator ${isOnline3 ? "online" : "offline"}" title="${isOnline3 ? "Online" : "Offline"}"></span>` : "";
          const nameStr = isHvH2() ? "Player 2" : seatName3(primaryOpp);
          ct.innerHTML = `${ind}${nameStr}`;
        }
        const cr = document.getElementById("cpuRole");
        const oppCut = state3.cutPicks && state3.cutPicks[primaryOpp];
        if (isCutPhase) {
          const isOppDeal = state3.dealer === primaryOpp;
          if (cr) {
            cr.textContent = state3.phase === "cut-reveal" && oppCut ? `(cut ${cardLabel2(oppCut)}${isOppDeal ? " \u2014 deals!" : ""})` : oppCut ? `(cut ${cardLabel2(oppCut)})` : "(cut)";
          }
        } else {
          if (cr) cr.textContent = state3.dealer === primaryOpp ? "(dealer)" : "(pone)";
        }
        const cpuEl = document.getElementById("cpuCards");
        if (cpuEl) {
          cpuEl.innerHTML = "";
          const oppKept = getSeatKept2(primaryOpp);
          const oppCutCard = isCutPhase && state3.cutPicks ? state3.cutPicks[primaryOpp] : null;
          const theirHand = oppCutCard ? [oppCutCard] : showHands && oppKept && oppKept.length ? oppKept : getSeatHand2(primaryOpp);
          const showAct = state3.showAct;
          const showingOppHand = !isPassingDevice && state3.phase === "show" && (showAct === "pone" && state3.dealer === me || showAct === "dealer" && state3.dealer === primaryOpp || showAct === primaryOpp || showAct === "done");
          const isDrawP2 = state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2" || (state3.phase === "draw-1" || state3.phase === "draw-2") && state3.currentHumanDiscard === "p2";
          const p2Active = !isPassingDevice && isHvH2() && (state3.phase === "discard-p2" || state3.phase === "discard" && state3.currentHumanDiscard === "p2" || isDrawP2 || state3.phase === "assign-p2" || state3.phase === "play" && state3.turn === "p2");
          const isPickingOpp = !isPassingDevice && state3.phase === "pick-crib" && state3.currentPickPone === primaryOpp;
          const face = !isPassingDevice && (Boolean(oppCutCard) || p2Active || state3.over || state3.phase === "cut-reveal" || showingOppHand);
          const selectingP2 = !isPassingDevice && !isOnline2() && (state3.phase === "discard-p2" || state3.phase === "discard" && state3.currentHumanDiscard === "p2" || isDrawP2);
          const displayHand = isPickingOpp ? theirHand : sortCards2(theirHand);
          displayHand.forEach((c, i) => {
            const isCutCard = Boolean(oppCutCard && c.id === oppCutCard.id);
            const el = cardEl2(c, {
              back: !face,
              selected: !isPassingDevice && (selectingP2 && state3.selected.includes(c.id) || isPickingOpp && state3.selected.includes(c.id)),
              highlight: !isPassingDevice && state3.highlightIds && state3.highlightIds.includes(c.id),
              playable: !isPassingDevice && (p2Active && (selectingP2 || legalPlay || state3.phase === "assign-p2" && isWild2(c) && !c.playAs) || isPickingOpp),
              disabled: isPassingDevice || isHvH2() && state3.phase === "play" && state3.turn === "p2" && !legalPlay,
              onClick: isPassingDevice ? void 0 : isPickingOpp ? () => onPickCribCard2(primaryOpp, c) : p2Active ? () => onCpuCard2(c) : void 0,
              anim: isPassingDevice ? null : isCutCard ? "flip" : state3.phase === "dealing" ? "deal-cpu" : state3.phase === "show" ? null : "deal",
              animKey: isCutCard ? "cut-" + c.id : "opp-" + c.id + (state3.phase === "dealing" ? "-deal" : ""),
              delay: isCutCard ? 0 : state3.phase === "dealing" ? i * 55 : state3.phase === "cut-reveal" || state3.phase === "show" ? 80 + i * 90 : 60 + i * 70
            });
            if (el) {
              el.style.zIndex = String(i + 1);
              cpuEl.appendChild(el);
            }
          });
        }
      } else {
        oppWrap.innerHTML = oppSeats.map((sId) => {
          const isDealer = state3.dealer === sId;
          const oppCut = isCutPhase && state3.cutPicks ? state3.cutPicks[sId] : null;
          let roleText = isDealer ? "(dealer)" : "(pone)";
          if (state3.phase === "cut-reveal") {
            roleText = oppCut ? `(cut ${cardLabel2(oppCut)}${isDealer ? " \u2014 deals!" : ""})` : "(cut)";
          } else if (isCutPhase) {
            roleText = oppCut ? `(cut ${cardLabel2(oppCut)})` : "(cut)";
          }
          const isMultiH = typeof isMultiHuman3 === "function" ? isMultiHuman3() : typeof window !== "undefined" && typeof window.isMultiHuman === "function" ? window.isMultiHuman() : settings3 && (settings3.opp === "online" || settings3.opp === "hvh" || settings3.isHvH);
          const oppIsHuman = typeof isSeatHuman2 === "function" ? isSeatHuman2(sId) : typeof window !== "undefined" && typeof window.isSeatHuman === "function" ? window.isSeatHuman(sId) : true;
          const isOnlineFn = isSeatOnline3 || (typeof window !== "undefined" ? window.isSeatOnline : null);
          const isOnline3 = typeof isOnlineFn === "function" ? isOnlineFn(sId) : true;
          const ind = isMultiH && oppIsHuman ? `<span class="online-indicator ${isOnline3 ? "online" : "offline"}" title="${isOnline3 ? "Online" : "Offline"}"></span>` : "";
          const isActiveTurn = state3.phase === "play" && state3.turn === sId;
          return `
          <div class="opponent-seat-card ${isActiveTurn ? "active-turn" : ""}" id="oppCard-${sId}">
            <div class="opp-seat-header">
              <span class="seat-tag ${sId}">${sId.toUpperCase()}</span>
              <span class="opp-name">${ind}${seatName3(sId)}</span>
              <span class="opp-role-badge" id="${sId}Role">${roleText}</span>
            </div>
            <div class="cards opp-cards" id="${sId}Cards"></div>
          </div>`;
        }).join("");
        oppSeats.forEach((sId) => {
          const oppCardsEl = document.getElementById(sId + "Cards");
          if (!oppCardsEl) return;
          oppCardsEl.innerHTML = "";
          const kept = getSeatKept2(sId);
          const oppCutCard = isCutPhase && state3.cutPicks ? state3.cutPicks[sId] : null;
          const hand = oppCutCard ? [oppCutCard] : showHands && kept && kept.length ? kept : getSeatHand2(sId);
          const isPickingThisPone = !isPassingDevice && state3.phase === "pick-crib" && state3.currentPickPone === sId;
          const isShowingThisHand = !isPassingDevice && state3.phase === "show" && (state3.showAct === sId || state3.showAct === "done");
          const isSeatDrawPhase = (state3.phase === "draw-1" || state3.phase === "draw-2" || state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2") && state3.currentHumanDiscard === sId;
          const isSeatDiscarding = !isPassingDevice && !isOnline2() && (state3.phase === "discard" || isSeatDrawPhase) && state3.currentHumanDiscard === sId;
          const face = !isPassingDevice && (Boolean(oppCutCard) || state3.over || isShowingThisHand || state3.phase === "cut-reveal" || isSeatDiscarding);
          const displayOppHand = isPickingThisPone || isSeatDiscarding ? hand : sortCards2(hand);
          displayOppHand.forEach((c, i) => {
            const isCutCard = Boolean(oppCutCard && c.id === oppCutCard.id);
            const el = cardEl2(c, {
              back: !face,
              selected: !isPassingDevice && ((isPickingThisPone || isSeatDiscarding) && state3.selected.includes(c.id)),
              highlight: !isPassingDevice && state3.highlightIds && state3.highlightIds.includes(c.id),
              playable: !isPassingDevice && (isPickingThisPone || isSeatDiscarding),
              onClick: isPassingDevice ? void 0 : isPickingThisPone ? () => onPickCribCard2(sId, c) : isSeatDiscarding ? () => onOppSeatDiscardCard2(sId, c) : void 0,
              anim: isPassingDevice ? null : isCutCard ? "flip" : state3.phase === "dealing" ? "deal" : face ? "flip" : null,
              animKey: isCutCard ? "opp-cut-" + sId + "-" + c.id : "opp-" + sId + "-" + c.id,
              delay: isCutCard ? 0 : i * 40
            });
            if (el) {
              el.style.zIndex = String(i + 1);
              oppCardsEl.appendChild(el);
            }
          });
        });
      }
    }
    /**
     * Renders the crib zone (#cribCards).
     */
    static renderCrib(ctx) {
      const cribEl = document.getElementById("cribCards");
      if (!cribEl || typeof ctx.cardEl !== "function") return;
      const { state: state3, settings: settings3, getPlayerCount: getPlayerCount2, sortCards: sortCards2, cardEl: cardEl2 } = ctx;
      if (state3 && state3.phase === "play") {
        cribEl.classList.remove("counting");
        cribEl.classList.add("playing");
      } else if (state3 && (state3.phase === "show" || state3.over)) {
        cribEl.classList.remove("playing");
        cribEl.classList.add("counting");
      } else if (cribEl) {
        cribEl.classList.remove("playing", "counting");
      }
      cribEl.innerHTML = "";
      const cribCards = state3.crib || [];
      sortCards2(cribCards).forEach((c, i) => {
        const face = settings3.optStolenCrib && getPlayerCount2() === 2 ? Boolean(state3.stolenCribResolved && state3.revealCrib) : state3.phase === "show" || state3.revealCrib;
        const el = cardEl2(c, {
          back: !face,
          highlight: state3.highlightIds && state3.highlightIds.includes(c.id),
          anim: face ? "flip" : "pop",
          animKey: "crib-" + c.id + (face ? "-up" : ""),
          delay: face ? i * 90 : i * 55
        });
        if (el) {
          el.style.zIndex = String(i + 1);
          cribEl.appendChild(el);
        }
      });
    }
    /**
     * Renders the starter zone (#starterZone).
     */
    static renderStarter(ctx) {
      const st = document.getElementById("starterZone");
      if (!st || typeof ctx.cardEl !== "function") return;
      st.innerHTML = "";
      const { state: state3, cardEl: cardEl2 } = ctx;
      const starters = state3.starters && state3.starters.length ? state3.starters : state3.starter ? [state3.starter] : [];
      if (starters.length) {
        const ritualBack = state3.phase === "starter-ritual" && !state3.starterFace;
        starters.forEach((stCard, idx) => {
          st.appendChild(cardEl2(stCard, {
            back: ritualBack,
            highlight: !!(state3.highlightIds && stCard.id && state3.highlightIds.includes(stCard.id)),
            anim: ritualBack ? "starter-slide" : "flip",
            animKey: "starter-" + stCard.id + (ritualBack ? "-slide" : "-flip"),
            delay: idx * 60
          }));
        });
      } else {
        st.innerHTML = '<div class="playing-card back"></div>';
      }
    }
    /**
     * Renders the played cards pile (#playedCards).
     */
    static renderPlayedPile(ctx) {
      const pl = document.getElementById("playedCards");
      if (!pl || typeof ctx.cardEl !== "function") return;
      pl.innerHTML = "";
      const { state: state3, cardEl: cardEl2, updateCountGlow: updateCountGlow2 } = ctx;
      if (state3.phase === "play" && !state3.frozen) pl.classList.remove("sweeping", "face-down");
      const pile = state3.pile || [];
      const isFaceDown = Boolean(state3 && state3.pileFaceDown);
      if (isFaceDown) pl.classList.add("face-down");
      pile.forEach((c, i) => {
        const el = cardEl2(c, {
          back: isFaceDown,
          anim: isFaceDown ? "flip" : "play",
          animKey: "pile-" + c.id + "-" + i + (isFaceDown ? "-down" : ""),
          delay: isFaceDown ? Math.min(i * 30, 150) : Math.min(i * 50, 250),
          badge: isFaceDown ? "" : c.pegBadge || "",
          badgeBonus: isFaceDown ? false : !!c.pegBadgeBonus
        });
        if (el) {
          if (isFaceDown) el.classList.add("back", "face-down", "flipping-down");
          el.style.zIndex = String(i + 1);
          pl.appendChild(el);
        }
      });
      if (typeof updateCountGlow2 === "function") updateCountGlow2();
    }
    /**
     * Renders action controls: deal deck, cut starter button, discard button, next button, and show meter.
     */
    static renderActionControls(ctx) {
      const {
        state: state3,
        settings: settings3,
        me,
        discardN,
        isCutPhase,
        isOnline: isOnline2,
        isSeatHuman: isSeatHuman2,
        seatName: seatName3,
        nextSeat: nextSeat2,
        poneDoCutStarter: poneDoCutStarter2,
        seatDiscardsToDeck: seatDiscardsToDeck2,
        isSoloVsPairs: isSoloVsPairs2,
        isDealerTeam: isDealerTeam2,
        setShowMeter: setShowMeter2,
        getSeatHand: getSeatHand2
      } = ctx;
      const count = Number(ctx.count || settings3 && settings3.playerCount || (typeof window !== "undefined" && typeof window.getPlayerCount === "function" ? window.getPlayerCount(settings3) : 2)) || 2;
      const isPassingDevice = !isOnline2() && Boolean(state3 && state3.passingTo);
      const isCutStarter = state3.phase === "cut-starter";
      const deckEl = document.getElementById("dealDeck");
      if (deckEl) {
        deckEl.classList.toggle("hidden", state3.phase !== "dealing" && state3.phase !== "starter-ritual" && !isCutStarter);
        const pone = state3 ? nextSeat2(state3.dealer) : null;
        const isMyCut = isCutStarter && (pone === me || !isOnline2() && isSeatHuman2(pone));
        const isGuess = Boolean(settings3 && settings3.optGuessStarter);
        deckEl.classList.toggle("cuttable", isMyCut);
        if (isMyCut) {
          deckEl.title = isGuess ? "Click to guess and cut the starter card" : "Click to cut the starter card";
          deckEl.onclick = () => typeof poneDoCutStarter2 === "function" ? poneDoCutStarter2() : null;
        } else {
          deckEl.title = "Stock";
          deckEl.onclick = null;
        }
      }
      const btnCutStarter = document.getElementById("btnCutStarter");
      if (btnCutStarter) {
        const pone = state3 ? nextSeat2(state3.dealer) : null;
        const isMyCut = isCutStarter && (pone === me || !isOnline2() && isSeatHuman2(pone));
        btnCutStarter.classList.toggle("hidden", !isMyCut);
        if (isMyCut) {
          const isGuess = Boolean(settings3 && settings3.optGuessStarter);
          btnCutStarter.textContent = pone === "p1" || pone === me ? isGuess ? "\u{1F3AF} Guess & Cut Starter" : "Cut Starter Card" : isGuess ? `\u{1F3AF} ${seatName3(pone)}: Guess & Cut Starter` : `${seatName3(pone)}: Cut Starter`;
          btnCutStarter.onclick = () => typeof poneDoCutStarter2 === "function" ? poneDoCutStarter2() : null;
        }
      }
      const mySId = me;
      const hasDiscarded = Boolean(state3.seatDiscards && state3.seatDiscards[mySId]);
      const canConfirmDiscard = !isPassingDevice && (isOnline2() ? !hasDiscarded && (state3.phase === "discard" || state3.phase === "discard-p2" && mySId === "p2") : state3.phase === "discard" || state3.phase === "discard-p2");
      const isPickCribPhase = state3.phase === "pick-crib";
      const isDrawPhase = state3.phase === "draw-1" || state3.phase === "draw-2" || state3.phase === "draw-1-p2" || state3.phase === "draw-2-p2";
      const btnDiscard = document.getElementById("btnDiscard");
      if (btnDiscard) {
        if (isPickCribPhase) {
          const pickN = state3.pickN || 2;
          const canConfirmPick = state3.selected && state3.selected.length === pickN;
          btnDiscard.classList.toggle("hidden", !canConfirmPick);
          btnDiscard.textContent = "Take (" + pickN + ") to your crib";
        } else if (isDrawPhase) {
          const isFirstDraw = state3.phase === "draw-1" || state3.phase === "draw-1-p2";
          const selLen = state3.selected && state3.selected.length || 0;
          btnDiscard.classList.remove("hidden");
          if (selLen === 0) {
            btnDiscard.textContent = "Keep Hand (Draw 0)";
          } else {
            btnDiscard.textContent = "Discard & Draw (" + selLen + ")";
          }
        } else {
          const curSeat = state3.currentHumanDiscard || "p1";
          if (settings3 && settings3.optCanadianDoubles && count === 4) {
            const handFn = getSeatHand2 || (typeof window !== "undefined" ? window.getSeatHand : null);
            const curHand = typeof handFn === "function" ? handFn(curSeat) : [];
            if (curHand && curHand.length === 10) {
              btnDiscard.classList.remove("hidden");
              btnDiscard.textContent = "\u{1F341} Organize 10 Cards";
              btnDiscard.onclick = () => {
                const ModalCls = typeof CC !== "undefined" && CC.CanadianDoublesModal || (typeof window !== "undefined" ? window.CanadianDoublesModal || window.CrazyCribbage?.CanadianDoublesModal : null);
                if (ModalCls && typeof ModalCls.open === "function") {
                  const openCtx = Object.assign({}, ctx, {
                    showModal: ctx.showModal || (typeof window !== "undefined" && window.crazyCribbageApp?.showModal ? window.crazyCribbageApp.showModal.bind(window.crazyCribbageApp) : window.modalManager ? window.modalManager.showModal.bind(window.modalManager) : null),
                    hideModal: ctx.hideModal || (typeof window !== "undefined" && window.crazyCribbageApp?.hideModal ? window.crazyCribbageApp.hideModal.bind(window.crazyCribbageApp) : window.modalManager ? window.modalManager.hideModal.bind(window.modalManager) : null),
                    render: ctx.render || (typeof window !== "undefined" && window.crazyCribbageApp?.render ? window.crazyCribbageApp.render.bind(window.crazyCribbageApp) : null)
                  });
                  ModalCls.open(curSeat, openCtx);
                }
              };
              return;
            }
          }
          const toDeck = seatDiscardsToDeck2(curSeat);
          let targetDesc = "the crib";
          const isCanadianDoubles = Boolean(settings3 && settings3.optCanadianDoubles && count === 4);
          const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
          const isMulti = count >= 3;
          const resolvedDiscardN = ctx.discardN != null ? ctx.discardN : isCanadianDoubles ? 2 : isMulti ? 1 : is7Card ? 2 : settings3 && settings3.deal === "super" ? 3 : 2;
          let currentDiscardN = resolvedDiscardN;
          if (settings3 && (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
            const isDealer = curSeat === state3.dealer;
            currentDiscardN = isDealer ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
            targetDesc = isDealer ? "your crib" : "the dealer's hand";
          } else if (toDeck) {
            targetDesc = "the deck";
          } else if (isSoloVsPairs2()) {
            targetDesc = curSeat === "p1" ? "your crib" : "the crib";
          } else {
            targetDesc = isDealerTeam2(curSeat) ? "your crib" : "opponent's crib";
          }
          let hasRequiredFives = true;
          if (settings3 && settings3.optFivesCribbage && !toDeck) {
            const handFn = getSeatHand2 || (typeof window !== "undefined" ? window.getSeatHand : null);
            if (typeof handFn === "function") {
              const hand = handFn(curSeat) || [];
              const fivesInHand = hand.filter((c) => ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5);
              const reqFives = Math.min(fivesInHand.length, currentDiscardN);
              if (reqFives > 0) {
                const selIds = new Set(state3.selected || []);
                const selectedFives = hand.filter((c) => selIds.has(c.id) && ((c.rank !== void 0 ? c.rank : c.r) || 0) === 5);
                if (selectedFives.length < reqFives) {
                  hasRequiredFives = false;
                }
              }
            }
          }
          let hasRequiredSevensAndEights = true;
          if (settings3 && settings3.optSevensAndEightsCribbage && !toDeck) {
            const handFn = getSeatHand2 || (typeof window !== "undefined" ? window.getSeatHand : null);
            if (typeof handFn === "function") {
              const hand = handFn(curSeat) || [];
              const targetInHand = hand.filter((c) => {
                const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
                return r === 7 || r === 8;
              });
              const reqTarget = Math.min(targetInHand.length, currentDiscardN);
              if (reqTarget > 0) {
                const selIds = new Set(state3.selected || []);
                const selectedTarget = hand.filter((c) => {
                  const r = (c.rank !== void 0 ? c.rank : c.r) || 0;
                  return selIds.has(c.id) && (r === 7 || r === 8);
                });
                if (selectedTarget.length < reqTarget) {
                  hasRequiredSevensAndEights = false;
                }
              }
            }
          }
          const selLen = state3.selected && state3.selected.length || 0;
          btnDiscard.classList.toggle("hidden", !(canConfirmDiscard && selLen === currentDiscardN));
          if (selLen === currentDiscardN) {
            if (!hasRequiredFives) {
              btnDiscard.textContent = "Must discard 5s to " + targetDesc;
            } else if (!hasRequiredSevensAndEights) {
              btnDiscard.textContent = "Must discard 7s & 8s to " + targetDesc;
            } else {
              btnDiscard.textContent = "Discard (" + currentDiscardN + ") to " + targetDesc;
            }
          } else {
            btnDiscard.textContent = "Discard selected";
          }
        }
      }
      const btnNext = document.getElementById("btnNext");
      if (btnNext) {
        btnNext.classList.toggle("hidden", state3.phase !== "await");
      }
      if (typeof setShowMeter2 === "function") {
        if (state3.showMeter) {
          setShowMeter2(state3.showMeter.act, state3.showMeter.total, state3.showMeter.line);
        } else if (state3.phase !== "show") {
          setShowMeter2("", 0, "");
        }
      }
    }
  };

  // src/ui/DropdownHelpManager.js
  var DROPDOWN_DESCRIPTIONS = {
    optPlayerCount: {
      title: "Players & Seating",
      subtitle: "Choose from 2 to 8 players with individual cutthroat, shifting partnerships, or fixed teams:",
      options: [
        {
          val: "2",
          name: "2 Players (Head-to-head)",
          desc: "Traditional cribbage. 6 cards dealt (or 9 in Super Deal), discard 2 to the crib. Head-to-head pegging and scoring on 2 concentric tracks."
        },
        {
          val: "3_indiv",
          name: "3 Players (Individual / Cutthroat)",
          desc: "Official 3-player cribbage: 5 cards dealt to each player plus 1 card dealt directly to the crib. Each player discards 1 card to complete the 4-card crib. 3 concentric serpentine board tracks."
        },
        {
          val: "3_shifting",
          name: "3 Players (Shifting Partnerships \u2014 1 vs 2)",
          desc: "Dealer plays alone and always scores the crib! The other 2 players team up into a pair for the hand and both score when either pegs or counts."
        },
        {
          val: "4_indiv",
          name: "4 Players (Individual / Cutthroat)",
          desc: "Every player for themselves! 5 cards dealt each; each player discards 1 card to form the 4-card crib. 4 separate concentric tracks race to the finish."
        },
        {
          val: "4_part",
          name: "4 Players (Partnership \u2014 2 vs 2)",
          desc: "Partners sit opposite each other (Seats 1 & 3 vs Seats 2 & 4). 5 cards dealt each, 1 discard each to crib. Scores pool into shared team tracks!"
        },
        {
          val: "5_shifting",
          name: "5 Players (Shifting Partnerships \u2014 1 vs 2 Pairs)",
          desc: "Dealer plays alone and always scores the crib! The other 4 players form 2 shifting pairs across the table and peg forward together."
        },
        {
          val: "6_teams",
          name: "6 Players (3 Teams of 2)",
          desc: "3 teams of 2 players (Seats 1 & 4 vs Seats 2 & 5 vs Seats 3 & 6). 5 cards dealt each, 1 discard to the crib. 3 team tracks on board."
        },
        {
          val: "7_shifting",
          name: "7 Players (Shifting Partnerships \u2014 1 vs 3 Pairs)",
          desc: "Dealer plays alone and always scores the crib! The other 6 players form 3 shifting pairs across the table."
        },
        {
          val: "8_teams",
          name: "8 Players (4 Teams of 2)",
          desc: "4 teams of 2 players (Seats 1 & 5 vs Seats 2 & 6 vs Seats 3 & 7 vs Seats 4 & 8). 5 cards dealt each, 1 discard to the crib. 4 team tracks on board."
        }
      ]
    },
    optOpp: {
      title: "Players",
      subtitle: "Choose how many players and devices to play with:",
      options: [
        {
          val: "cpu",
          name: "You vs computer",
          desc: "Play single-player against the Crazy Cribbage AI engine. Choose from multiple distinct computer personalities below."
        },
        {
          val: "online",
          name: "Online \u2014 two devices",
          desc: "Play head-to-head across two devices (phones, tablets, or computers) via peer-to-peer connection with an 8-character room code. No login required."
        }
      ]
    },
    optAiProfile: {
      title: "Computer Opponent Skill Levels & Personalities",
      subtitle: "Select the skill level and playing style for your computer opponent:",
      options: [
        {
          val: "shark",
          name: "Expert \u2014 The Shark (EV / GTO Optimal)",
          desc: "Expert level. Plays mathematically optimal Game Theory Optimal (GTO) cribbage. Analyzes discard permutations and pegging rollouts for maximum expected point value."
        },
        {
          val: "master",
          name: "Expert \u2014 The Grandmaster (Tournament Precision)",
          desc: "Expert level. High-level tournament champion with deep board-position awareness, disciplined crib defense, and precision endgame play."
        },
        {
          val: "turtler",
          name: "Advanced \u2014 The Turtler (Defensive Strategy)",
          desc: "Advanced level. Risk-averse, highly defensive play style. Sacrifices hand potential to starve opponent cribs of synergy and carefully controls pegging counts."
        },
        {
          val: "maverick",
          name: "Advanced \u2014 The Maverick (Tactical Pressure)",
          desc: "Advanced level. Aggressive pegging pressure, setting up run sequences, pair traps, and forcing opponents into tough Go decisions."
        },
        {
          val: "gambler",
          name: "Intermediate \u2014 The Gambler (Aggressive / Big Hands)",
          desc: "Intermediate level. High-variance play style. Chases massive hands and explosive combos, taking risks on discards and aggressively pairing cards."
        },
        {
          val: "regular",
          name: "Intermediate \u2014 The Regular (Steady Fundamentals)",
          desc: "Intermediate level. Consistent, dependable cribbage following time-tested counting principles, balanced crib discards, and safe leads."
        },
        {
          val: "rookie",
          name: "Beginner \u2014 The Rookie (Friendly & Relaxed)",
          desc: "Beginner level. Friendly, casual opponent focused on straightforward counting. Great for newcomers and relaxed games without aggressive traps."
        },
        {
          val: "casual",
          name: "Beginner \u2014 The Casual (Easygoing / Learning)",
          desc: "Beginner level. Easygoing play style that avoids complex traps, making simple and accessible card choices to keep games fun and welcoming."
        }
      ]
    },
    optPegStyle: {
      title: "Custom Peg Styles & Trail FX",
      subtitle: "Choose custom 3D sculpted peg heads and hopping particle effects:",
      options: [
        {
          val: "classic",
          name: "Classic \u2014 Turned Finial & Avatar (Default)",
          desc: "Traditional turned hardwood/metallic pin with custom circular avatar medallions."
        },
        {
          val: "crown",
          name: "Gold Crown \u2014 Royal Coronet & Gemstones",
          desc: "Royal golden 5-peak crown topper with embedded ruby and sapphire jewels that glisten under 3D table lights."
        },
        {
          val: "skull",
          name: "Pirate Skull \u2014 Silver Buccaneer & Carved Sockets",
          desc: "Burnished pirate skull topper with carved eye sockets, skull brow, and silver sheen."
        },
        {
          val: "beermug",
          name: "Pint Beer Mug \u2014 Frosted Tankard & Foam Cap",
          desc: "Frosted pub tankard filled with amber ale, frothy white foam head, and curved glass handle."
        },
        {
          val: "rivet",
          name: "Brass Rivet \u2014 Machined Industrial Hex Bolt",
          desc: "Machined hex-head industrial machine bolt with heavy beveled facets and metallic sheen."
        },
        {
          val: "crystal",
          name: "Neon Crystal \u2014 Prismatic Radiant Gem",
          desc: "Prismatic faceted gemstone topper with radiant emissive glow and colorful edge highlights."
        }
      ]
    },
    optTableEnvironment: {
      title: "3D Table Environments & Backdrops",
      subtitle: "Select 3D themed table surroundings matching your game mood:",
      options: [
        {
          val: "auto",
          name: "Auto \u2014 Brand Themed (Default)",
          desc: "Automatically matches the active game brand: The Pub for Pints & Pegs, Vegas High Roller Suite for Crazy Cribbage, The Thunderdome for Cribbage Clash, and Velvet Lounge for Skunked & Stripped."
        },
        {
          val: "pub",
          name: "The Pub \u2014 Oak Planks, Pint Coasters & Candle Warmth",
          desc: "Dimmed tavern ambiance with aged tavern oak planks, beer coasters, and cozy amber lighting."
        },
        {
          val: "vegas",
          name: "Vegas High Roller Suite \u2014 Green Baize & Mahogany",
          desc: "Luxury casino VIP suite with emerald casino baize, gold card-suit watermarks, rich polished mahogany trim, and neon skyline glow."
        },
        {
          val: "cabin",
          name: "Mountain Lodge \u2014 Pine Logs & Stone Hearth",
          desc: "Rustic log cabin interior with knotty pine floors, fieldstone fireplace wall, and cozy amber mountain glow."
        },
        {
          val: "thunderdome",
          name: "The Thunderdome / Raceway \u2014 Tarmac & Hazard Lines",
          desc: "High-octane raceway setting with textured asphalt tarmac, burnout tire tracks, hazard warning chevrons, and stadium floodlights."
        },
        {
          val: "velvet",
          name: "Velvet Lounge \u2014 Royal Emerald Baize",
          desc: "Moody speakeasy lounge with deep emerald baize and satin gold finishes."
        },
        {
          val: "studio",
          name: "Studio Wood \u2014 Nordic Ash Minimalist",
          desc: "Clean Scandinavian studio setting with pale ash timber grain and soft diffuse lighting."
        },
        {
          val: "none",
          name: "None \u2014 Minimalist Backdrop",
          desc: "Minimalist shadow surface without textured table borders."
        }
      ]
    },
    optBoardView: {
      title: "Board & Room View Modes",
      subtitle: "Choose your visual presentation and immersion style:",
      options: [
        {
          val: "room3d-fullscreen",
          name: "3D Room (Full Screen) \u2014 Edge-to-Edge Cinematic Room",
          desc: "Launches into edge-to-edge full screen mode featuring realistic themed 3D rooms (Pub, Vegas Suite, Mountain Lodge, Velvet Speakeasy, Industrial, or Nordic Studio), table, chairs, and cribbage board for maximum visual immersion."
        },
        {
          val: "room3d",
          name: "3D Room (Full Width) \u2014 Complete Themed Tabletop & Surroundings",
          desc: "Full-width cinematic view featuring realistic themed 3D rooms (Pub, Vegas Suite, Mountain Lodge, Velvet Speakeasy, Industrial, or Nordic Studio), table, chairs, and cribbage board."
        },
        {
          val: "3d",
          name: "3D Board \u2014 Interactive Babylon.js Cribbage Board",
          desc: "Standard split-table view with the interactive 3D board, smooth track zoom, and cinematic action cameras."
        },
        {
          val: "2d",
          name: "Flat Board \u2014 Classic Vector SVG Board",
          desc: "Traditional top-down 2D flat track view with crisp vector graphics."
        },
        {
          val: "none",
          name: "None \u2014 Scorecard & Cards Only",
          desc: "Maximizes card area by hiding the track board entirely while scores track via header chips."
        }
      ]
    },
    optActionCam: {
      title: "Cinematic Action Cam Replays",
      subtitle: "Automated dynamic slow-motion camera zoom and orbit during major match moments:",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 Cinematic orbit on 24+ pts, 4-of-a-kind & game win (Default)",
          desc: "Automatically launches a broadcast-style slow-motion 3D camera orbit with a recording HUD badge whenever a player scores 24+ points, hits a 4-of-a-kind (double pair royal) during pegging, or pegs into the winning game hole (121 / 481)."
        },
        {
          val: "no",
          name: "No \u2014 Static camera view",
          desc: "Maintains player camera position during high-scoring events without automated cinematic replays."
        }
      ]
    },
    optCardAssassin: {
      title: "Card Assassin Animations",
      subtitle: "Cinematic duel animation when a player overtakes an opponent on the board:",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 show overtake animations (Default)",
          desc: "Displays an action-packed cinematic showdown featuring animated cards battling with legendary weapons whenever one player overtakes another on the board."
        },
        {
          val: "no",
          name: "No \u2014 skip overtake animations",
          desc: "Disables the Card Assassin overtake animation for faster match pacing."
        }
      ]
    },
    optJailAnimation: {
      title: "Jailhouse Mugshot Animations",
      subtitle: "Cinematic cartoon animation when a player lands in Jail:",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 show jail mugshot animations (Default)",
          desc: "Displays a cinematic cartoon sequence where iron prison bars slam down, a burly police guard card marches in, slaps a striped convict uniform on the player card with frantic kicking legs, and snaps a mugshot with camera flash."
        },
        {
          val: "no",
          name: "No \u2014 skip jail animations",
          desc: "Disables the Jailhouse Mugshot animation for faster game pacing."
        }
      ]
    },
    optBarAnimation: {
      title: "Saloon Bar Slide Animations",
      subtitle: "Cinematic cartoon animation when a player lands on Bar or Drink spaces:",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 show saloon bar slide animations (Default)",
          desc: "Displays a cinematic cartoon sequence where wooden saloon swinging doors kick open, an overflowing frothy beer mug slides across the counter and bumps the card, the card chugs it with spinning spiral eyes and wobbly noodle IK legs, and collapses face-first onto a bar stool while bubbles pop."
        },
        {
          val: "no",
          name: "No \u2014 skip saloon bar animations",
          desc: "Disables the Saloon Bar Slide animation for faster match pacing."
        }
      ]
    },
    optCannonAnimation: {
      title: "Jump (ACME Cannonball) Animations",
      subtitle: "Cinematic cartoon animation when a player lands on a Jump Spring or Start tile:",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 show ACME cannonball animations (Default)",
          desc: "Displays a cinematic cartoon sequence where an ACME-style striped cannon rolls out, the card climbs inside rear-first with feet kicking out the muzzle, a sparkling fuse counts down to KABOOM, and blasts the card in a high parabolic flight across the tracks before lawn-darting head-first into the destination hole with spinning dizzy stars."
        },
        {
          val: "no",
          name: "No \u2014 skip cannonball animations",
          desc: "Disables the ACME Human Cannonball animation for faster match pacing."
        }
      ]
    },
    optSpeedTrapAnimation: {
      title: "Stop Sign (Speed Trap Radar) Animations",
      subtitle: "Cinematic cartoon interception when a player is stopped by a Stop Sign or blocked in a No Passing Lane:",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 show speed trap radar animations (Default)",
          desc: "Displays a cinematic sequence where emergency red and blue flashers strobe the screen, an animated radar sweep tracks offender velocity, a motorcycle cop card in aviator sunglasses zips in across asphalt, signals HALT with a police whistle, and slaps an official speeding citation onto the player's card face."
        },
        {
          val: "no",
          name: "No \u2014 skip speed trap animations",
          desc: "Disables the Speed Trap Radar animation for faster match pacing."
        }
      ]
    },
    optDetourAnimation: {
      title: "Detour Animations",
      subtitle: "Cinematic cartoon sequence when a player lands on a Detour (\u{1F6A7}) tile:",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 show GPS detour animations (Default)",
          desc: "Displays an interactive in-car dashboard navigation display with digital speedometer and GPS route alerts. As the GPS warns of road work ahead, the convertible swerves down a bumpy dirt road past construction barricades with bouncing suspension, dust clouds, and an old-school ahooga horn."
        },
        {
          val: "no",
          name: "No \u2014 skip detour animations",
          desc: "Disables the Detour scenic route animation for faster match pacing."
        }
      ]
    },
    optRoundAboutAnimation: {
      title: "Round About Rotary Animations",
      subtitle: "Cinematic cartoon sequence when a player lands on a Round About (\u{1F504}) tile:",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 show GPS rotary animations (Default)",
          desc: "Displays an interactive in-car dashboard navigation display with digital speedometer and GPS route alerts. The GPS announces the missed rotary exit while the player card orbits the rotary with tire squeals, slide whistles, and dizzy spiral eyes."
        },
        {
          val: "no",
          name: "No \u2014 skip round about animations",
          desc: "Disables the Round About rotary animation for faster match pacing."
        }
      ]
    },
    optScenicRouteAnimation: {
      title: "Scenic Route & Rotary Animations",
      subtitle: "Cinematic cartoon sequence when a player lands on a Round About (\u{1F504}) or Detour (\u{1F6A7}):",
      options: [
        {
          val: "yes",
          name: "Yes \u2014 show GPS scenic route & rotary animations (Default)",
          desc: "Displays an interactive in-car dashboard navigation display with digital speedometer and GPS route alerts. For Round Abouts, the GPS announces the rotary while the player card orbits the rotary with tire squeals and dizzy spiral eyes. For Detours, the GPS warns of road work ahead as the convertible swerves down a bumpy dirt road with bouncing suspension, dust clouds, and an old-school ahooga horn."
        },
        {
          val: "no",
          name: "No \u2014 skip scenic route animations",
          desc: "Disables the Round About and Detour scenic route animations for faster match pacing."
        }
      ]
    },
    optCoach: {
      title: "Coach Mode",
      subtitle: "Real-time discard analysis and expected value projections:",
      options: [
        {
          val: "off",
          name: "Off \u2014 standard play",
          desc: "Normal cribbage gameplay without hints or statistical projections."
        },
        {
          val: "on",
          name: "On \u2014 show keep EV on discard",
          desc: "Displays an interactive strategy projection banner during discard. Simulates every remaining possible cut card to calculate minimum, maximum, and expected average points for your hand."
        }
      ]
    },
    optGoal: {
      title: "Objective",
      subtitle: "Choose whether you are racing to win or trying to avoid points:",
      options: [
        {
          val: "high",
          name: "High ball \u2014 first to target wins",
          desc: "Classic cribbage objective. Race around the track\u2014the first player to reach or exceed the target score wins immediately."
        },
        {
          val: "low",
          name: "Low ball \u2014 first to target loses",
          desc: "Reverse cribbage (mis\xE8re)! The first player to reach the target score loses. Strategy is inverted: aim for 0-point hands, discard safe zeroes, and force your opponent to take points during pegging."
        }
      ]
    },
    optTarget: {
      title: "Target Score",
      subtitle: "Select the winning score and game duration:",
      options: [
        {
          val: "121",
          name: "Full Game (121)",
          desc: "Standard regulation cribbage match to 121 points around the full serpentine board track."
        },
        {
          val: "61",
          name: "Quick game (61)",
          desc: "Fast half-board match to 61 points, reaching the first half of the board for quick games."
        },
        {
          val: "31",
          name: "Pegging Only (31)",
          desc: "Lightning-fast match to 31 points. Hands and cribs are not scored\u2014every single point must be won during pegging play at the table!"
        },
        {
          val: "241",
          name: "241 - Short",
          desc: "Exciting match to 241 peg holes across 4 streets (240 track holes plus the final game hole)."
        },
        {
          val: "361",
          name: "361 - Medium",
          desc: "Strategic 6-street battle to 361 peg holes (360 track holes plus the final game hole)."
        },
        {
          val: "481",
          name: "481 - Long",
          desc: "Epic marathon match to 481 peg holes on the massive 8-street serpentine board (480 track holes plus the game hole)."
        }
      ]
    },
    optDeal: {
      title: "Deal",
      subtitle: "Standard 4-card cribbage vs. Crazy Cribbage 6-card Super Deal:",
      options: [
        {
          val: "std",
          name: "Standard \u2014 6 cards, discard 2, keep 4",
          desc: "Traditional cribbage deal. Each player receives 6 cards, discards 2 into the crib, and keeps 4 cards in hand."
        },
        {
          val: "super",
          name: "Super \u2014 9 cards, discard 3, keep 6",
          desc: "Crazy Cribbage signature mode! Each player receives 9 cards, discards 3 into a giant 6-card crib, and plays with a 6-card hand. Hands frequently score 30 to 50+ points!"
        }
      ]
    },
    optDealStyle: {
      title: "Deal Animation",
      subtitle: "Card dealing presentation and choreography:",
      options: [
        { val: "alternate", name: "Alternate \u2014 one to pone, one to dealer", desc: "Classic card-by-card deal alternating between players." },
        { val: "packets", name: "Packets \u2014 two at a time", desc: "Deals cards in packets of two." },
        { val: "you-first", name: "Your hand first, then theirs", desc: "Deals your complete hand first, then the opponent's." },
        { val: "together", name: "Together \u2014 both seats at once", desc: "Deals to both seats simultaneously." },
        { val: "riffle", name: "Riffle \u2014 same as alternate, fast", desc: "Fast alternate deal." },
        { val: "waterfall", name: "Waterfall \u2014 all cards, CSS stagger only", desc: "Fast staggered card fan." }
      ]
    },
    optShowDetail: {
      title: "Show Points",
      subtitle: "Control how scoring combinations are revealed at the end of each hand:",
      options: [
        {
          val: "highlight",
          name: "Highlight each scoring combo",
          desc: "Paces through hand and crib scoring step-by-step, highlighting cards involved in 15s, pairs, runs, and flushes with visual combo callouts."
        },
        {
          val: "totals",
          name: "Just show total points",
          desc: "Skips combo-by-combo animations and immediately tallies total hand and crib points for faster, uninterrupted play."
        },
        {
          val: "muggins",
          name: "Muggins (Cutthroat \u2014 manual count)",
          desc: "Traditional cutthroat cribbage! You must manually count and claim your hand and crib points. If you undercount, your opponent can call Muggins and steal the forgotten points!"
        }
      ]
    },
    optDecks: {
      title: "Decks",
      subtitle: "Standard single deck vs. double deck madness:",
      options: [
        {
          val: "1",
          name: "1 deck \u2014 52 cards",
          desc: "Standard single 52-card deck (plus optional wild jokers)."
        },
        {
          val: "2",
          name: "2 decks \u2014 104 cards",
          desc: "Double deck with two of every card rank and suit! Enables 5-to-8 card runs, quadruple pairs, duplicate flushes, and monster hands."
        }
      ]
    },
    optCardBack: {
      title: "Card Back Patterns",
      subtitle: "Available card back styles with custom textures and weaves:",
      options: [
        { val: "classic-blue", name: "Classic Blue", pattern: "classic-blue", desc: "Traditional casino crosshatch in deep navy." },
        { val: "classic-red", name: "Classic Red", pattern: "classic-red", desc: "Bicycle crimson diamond weave in deep ruby." },
        { val: "emerald-diamond", name: "Emerald Diamond", pattern: "emerald-diamond", desc: "Harlequin argyle green with gold flecks." },
        { val: "royal-gold", name: "Royal Gold", pattern: "royal-gold", desc: "Luxurious onyx with gold filigree rosette mesh." },
        { val: "vintage-tartan", name: "Vintage Tartan", pattern: "vintage-tartan", desc: "Scottish highland green, crimson and gold plaid." },
        { val: "honeycomb", name: "Amber Honeycomb", pattern: "honeycomb", desc: "Warm geometric amber and espresso hexagon grid." },
        { val: "midnight-stars", name: "Midnight Astral", pattern: "midnight-stars", desc: "Deep cosmic navy with starburst constellation dots." },
        { val: "amethyst", name: "Amethyst Lattice", pattern: "amethyst", desc: "Royal imperial purple and lavender diamond weave." },
        { val: "vegas-crimson", name: "Vegas Crimson", pattern: "vegas-crimson", desc: "Vibrant casino scarlet repeating mesh." },
        { val: "obsidian-carbon", name: "Stealth Carbon", pattern: "obsidian-carbon", desc: "Modern charcoal and matte black carbon weave." }
      ]
    }
  };
  var DropdownHelpManager = class _DropdownHelpManager {
    /**
     * Opens the interactive info modal for the given dropdown option key.
     * @param {string} key
     * @param {Object} [context]
     */
    static showDropdownInfoModal(key, context = {}) {
      const config = DROPDOWN_DESCRIPTIONS[key];
      if (!config || typeof document === "undefined") return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
      const showModal2 = context.showModal || (typeof window !== "undefined" ? window.showModal : null);
      const getAppBrand2 = context.getAppBrand || (typeof window !== "undefined" ? window.getAppBrand : () => "crazy");
      let currVal = "";
      if (key === "optCardBack") {
        currVal = settings3.cardBack || "classic-blue";
      } else {
        const el = key === "optBoardView" && document.getElementById("optBoardViewModal") ? document.getElementById("optBoardViewModal") : document.getElementById(key);
        if (el) currVal = String(el.value);
      }
      let optionsList = config.options;
      if (key === "optTarget") {
        const brand = typeof getAppBrand2 === "function" ? getAppBrand2() : window.currentBrand || "crazy";
        const isClash = brand === "clash";
        const isCrazy = !brand || brand === "crazy";
        if (isClash) {
          optionsList = optionsList.filter((opt) => ["241", "361", "481"].includes(String(opt.val)));
        } else if (isCrazy) {
          optionsList = optionsList.filter((opt) => ["121", "61", "31", "241"].includes(String(opt.val))).map((opt) => {
            if (String(opt.val) === "241") {
              return {
                ...opt,
                name: "241 points (There and Back)",
                desc: "Epic extended match to 241 points (There and Back)\u2014pegging twice the standard distance to the finish line!"
              };
            }
            return opt;
          });
        } else {
          optionsList = optionsList.filter((opt) => ["121", "61", "31"].includes(String(opt.val)));
        }
      }
      const optionsHtml = optionsList.map((opt) => {
        const isCurrent = String(opt.val) === currVal;
        return `
        <div class="opt-desc-card ${isCurrent ? "is-active" : ""}" data-action="select-option" data-key="${key}" data-val="${opt.val}" role="button" tabindex="0" title="Click to select ${opt.name}">
          <div class="opt-card-header">
            <div class="opt-card-title">
              ${opt.pattern ? `<span class="pattern-preview pattern-${opt.pattern}" style="width:20px;height:28px;border-radius:3px;"></span>` : ""}
              <span>${opt.name}</span>
            </div>
            ${isCurrent ? `<span class="opt-active-badge">Active</span>` : `<span class="opt-select-pill">Select</span>`}
          </div>
          <div class="opt-card-body">${opt.desc}</div>
        </div>
      `;
      }).join("");
      const html2 = `
      <div class="dropdown-info-modal">
        <h2>${config.title}</h2>
        <div class="modal-sub">${config.subtitle}</div>
        <div class="dropdown-options-list">
          ${optionsHtml}
        </div>
        <div style="margin-top: 18px; text-align: center;">
          <button type="button" class="btn-gold modal-btn-close" id="btnCloseDropdownHelp">Close</button>
        </div>
      </div>
    `;
      if (typeof showModal2 === "function") {
        showModal2(html2, true);
        if (typeof document !== "undefined") {
          const modalRoot = (typeof document.querySelector === "function" ? document.querySelector(".dropdown-info-modal") : null) || (typeof document.getElementById === "function" ? document.getElementById("modal") : null);
          if (modalRoot && typeof modalRoot.addEventListener === "function") {
            modalRoot.addEventListener("click", (e) => {
              const card = e.target.closest('[data-action="select-option"]');
              if (card) {
                const optKey = card.dataset.key;
                const optVal = card.dataset.val;
                if (typeof selectOptionFromModal === "function") {
                  selectOptionFromModal(optKey, optVal);
                } else if (_DropdownHelpManager.selectOptionFromModal) {
                  _DropdownHelpManager.selectOptionFromModal(optKey, optVal);
                }
              }
            });
            modalRoot.addEventListener("keydown", (e) => {
              if (e.key === "Enter" || e.key === " ") {
                const card = e.target.closest('[data-action="select-option"]');
                if (card) {
                  e.preventDefault();
                  const optKey = card.dataset.key;
                  const optVal = card.dataset.val;
                  if (typeof selectOptionFromModal === "function") {
                    selectOptionFromModal(optKey, optVal);
                  } else if (_DropdownHelpManager.selectOptionFromModal) {
                    _DropdownHelpManager.selectOptionFromModal(optKey, optVal);
                  }
                }
              }
            });
          }
        }
      }
    }
    /**
     * Selects an option value from the modal and triggers change event.
     * @param {string} key
     * @param {string} val
     * @param {Object} [context]
     */
    static selectOptionFromModal(key, val, context = {}) {
      const hideModal3 = context.hideModal || (typeof window !== "undefined" ? window.hideModal : () => {
      });
      const setCardBack2 = context.setCardBack || (typeof window !== "undefined" ? window.setCardBack : () => {
      });
      if (key === "optCardBack") {
        if (typeof setCardBack2 === "function") {
          setCardBack2(val);
        }
      } else if (typeof document !== "undefined") {
        const el = document.getElementById(key);
        if (el) {
          el.value = val;
          el.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (key === "optBoardView") {
          const modalEl = document.getElementById("optBoardViewModal");
          if (modalEl) {
            modalEl.value = val;
            modalEl.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      }
      if (typeof hideModal3 === "function") {
        hideModal3();
      }
    }
    /**
     * Injects info icon SVGs into option labels and attaches click/keyboard event listeners.
     * @param {Object} [context]
     */
    static initDropdownLabels(context = {}) {
      if (typeof document === "undefined") return;
      const showModalFn = context.showDropdownInfoModal || (typeof window !== "undefined" ? window.showDropdownInfoModal : null);
      document.querySelectorAll(".opt label").forEach((lbl) => {
        let key = lbl.getAttribute("data-opt-key");
        if (!key) {
          const parent = lbl.closest(".opt");
          if (parent) {
            const sel = parent.querySelector("select");
            if (sel && sel.id) key = sel.id;
            else if (parent.querySelector("#cardBackPicker")) key = "optCardBack";
          }
        }
        if (!key || !DROPDOWN_DESCRIPTIONS[key]) return;
        lbl.classList.add("clickable-opt-label");
        lbl.setAttribute("data-opt-key", key);
        lbl.setAttribute("role", "button");
        lbl.setAttribute("tabindex", "0");
        lbl.setAttribute("aria-haspopup", "dialog");
        lbl.title = "Click to view details about " + DROPDOWN_DESCRIPTIONS[key].title;
        const INFO_ICON_SVG = '<svg class="label-info-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle class="info-bg" cx="8" cy="8" r="7.2"/><circle class="info-mark" cx="8" cy="4.8" r="1.1" stroke="none"/><line class="info-mark" x1="8" y1="7.4" x2="8" y2="12" stroke-width="1.8" stroke-linecap="round"/></svg>';
        const existingIcon = lbl.querySelector(".label-info-icon");
        if (!existingIcon) {
          lbl.insertAdjacentHTML("beforeend", INFO_ICON_SVG);
        } else if (existingIcon.tagName.toLowerCase() !== "svg") {
          existingIcon.outerHTML = INFO_ICON_SVG;
        }
        lbl.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof showModalFn === "function") showModalFn(key);
        };
        lbl.onkeydown = (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            if (typeof showModalFn === "function") showModalFn(key);
          }
        };
      });
    }
  };

  // src/ui/CoachController.js
  var CoachController = class _CoachController {
    /**
     * Computes min, max, and exact average show points for a candidate keep against all unseen starters.
     * @param {Array} keep The cards kept in hand
     * @param {Set<string>} deadIds Cards already seen
     * @param {Object} [options]
     * @returns {{min: number, max: number, avg: number}}
     */
    static analyzeKeepEV(keep, deadIds, options = {}) {
      const starter = options.starter || (typeof window !== "undefined" && window.state ? window.state.starter : null);
      const fullDeck = options.fullDeck || (typeof window !== "undefined" ? window.FULL_DECK : null);
      if (CribbageAI && typeof CribbageAI.analyzeKeepEV === "function") {
        return CribbageAI.analyzeKeepEV(keep, deadIds, starter, fullDeck);
      }
      return { min: 0, max: 0, avg: 0 };
    }
    /**
     * Updates or hides the Coach Mode projection banner based on hover or selected discards.
     * @param {Array} [hoverDiscards] Optional cards currently being hovered
     * @param {Object} [context]
     */
    static updateCoachDisplay(hoverDiscards, context = {}) {
      if (typeof document === "undefined" && !context.box) return;
      const box = context.box || (typeof document !== "undefined" ? document.getElementById("coachBox") : null);
      if (!box) return;
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null) || {};
      const state3 = context.state || (typeof window !== "undefined" ? window.state : null) || {};
      const cardLabel2 = context.cardLabel || (typeof window !== "undefined" && window.cardLabel ? window.cardLabel : ((c) => c ? `${c.rank}${c.suit}` : ""));
      if (settings3.coach !== "on" || state3.phase !== "discard" || !state3.youHand || state3.youHand.length === 0) {
        box.classList.add("hidden");
        box.innerHTML = "";
        return;
      }
      const count = settings3 && settings3.playerCount || 2;
      const is7Card = Boolean(settings3 && settings3.opt7CardCribbage && count === 2);
      let discardN = count >= 3 ? 1 : is7Card ? 2 : settings3.deal === "super" ? 3 : 2;
      if (settings3 && (settings3.optSpeedoCribbage || settings3.optTwistedCribbage) && count === 2) {
        const curSeat = state3.currentHumanDiscard || "p1";
        discardN = curSeat === state3.dealer ? settings3.deal === "super" ? 6 : 4 : settings3.deal === "super" ? 3 : 2;
      }
      const targetKeepN = is7Card ? 5 : settings3.deal === "super" ? 6 : 4;
      const selectedIds = state3.selected || [];
      let discards = hoverDiscards || state3.youHand.filter((c) => selectedIds.includes(c.id));
      if (discards.length !== discardN) {
        box.classList.remove("hidden");
        box.innerHTML = `
        <div class="coach-banner">
          <div class="coach-title">Coach Mode</div>
          <div class="coach-hint">Select ${discardN} cards to discard (or hover) to preview keep potential.</div>
        </div>`;
        return;
      }
      const discIds = new Set(discards.map((c) => c.id));
      const candidateKeep = state3.youHand.filter((c) => !discIds.has(c.id));
      if (candidateKeep.length !== targetKeepN) {
        box.classList.add("hidden");
        return;
      }
      const dead = new Set(state3.youHand.map((c) => c.id));
      const stats = _CoachController.analyzeKeepEV(candidateKeep, dead, {
        starter: state3.starter,
        fullDeck: context.fullDeck || (typeof window !== "undefined" ? window.FULL_DECK : null)
      });
      const isHypothetical = !!hoverDiscards;
      box.classList.remove("hidden");
      box.innerHTML = `
      <div class="coach-banner">
        <div class="coach-title">Coach Mode ${isHypothetical ? "(Preview)" : "(Current Selection)"}</div>
        <div class="coach-stats">
          <div class="stat-item">
            <span class="stat-lbl">Min Hand</span>
            <span class="stat-val">${stats.min}</span>
          </div>
          <div class="stat-item">
            <span class="stat-lbl">Expected Avg</span>
            <span class="stat-val avg">${stats.avg}</span>
          </div>
          <div class="stat-item">
            <span class="stat-lbl">Max Hand</span>
            <span class="stat-val">${stats.max}</span>
          </div>
        </div>
        <div class="coach-hint">Keeping: ${candidateKeep.map((c) => cardLabel2(c)).join(" ")}</div>
      </div>`;
    }
    updateCoachDisplay(hoverDiscards, context) {
      return _CoachController.updateCoachDisplay(hoverDiscards, context);
    }
    analyzeKeepEV(keep, deadIds, options) {
      return _CoachController.analyzeKeepEV(keep, deadIds, options);
    }
  };

  // src/ui/TournamentModal.js
  var TournamentModal = class _TournamentModal {
    static MODAL_ID = "crazyTournamentModal";
    static OVERLAY_ID = "crazyTournamentOverlay";
    /**
     * Opens the Tournament modal. If an active tournament exists, shows the bracket;
     * otherwise opens the setup wizard.
     * @param {Object} [context]
     */
    static open(context = {}) {
      if (typeof document === "undefined") return;
      const brand = context.brand || (typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : "crazy");
      if (brand !== "crazy") {
        if (typeof window !== "undefined" && typeof window.showScoreToast === "function") {
          window.showScoreToast("Mini-Tournament is only available on Crazy Cribbage.", 3e3);
        }
        return;
      }
      let overlay = document.getElementById(_TournamentModal.OVERLAY_ID);
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = _TournamentModal.OVERLAY_ID;
        overlay.className = "tournament-overlay";
        overlay.setAttribute("role", "dialog");
        overlay.setAttribute("aria-modal", "true");
        overlay.setAttribute("aria-label", "Mini-Tournament Bracket Manager");
        document.body.appendChild(overlay);
      }
      overlay.style.display = "flex";
      _TournamentModal.render(context);
    }
    /**
     * Closes the tournament modal.
     */
    static close() {
      if (typeof document === "undefined") return;
      const overlay = document.getElementById(_TournamentModal.OVERLAY_ID);
      if (overlay) overlay.style.display = "none";
    }
    /**
     * Main render dispatcher for tournament modal.
     * @param {Object} [context]
     */
    static render(context = {}) {
      if (typeof document === "undefined") return;
      const brand = context.brand || (typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : "crazy");
      if (brand !== "crazy") {
        _TournamentModal.close();
        return;
      }
      const overlay = document.getElementById(_TournamentModal.OVERLAY_ID);
      if (!overlay) return;
      const state3 = TournamentManager.getTournamentState();
      if (!state3 || context.forceSetup) {
        _TournamentModal.renderSetup(overlay, context);
      } else {
        _TournamentModal.renderBracket(overlay, state3, context);
      }
    }
    /**
     * Helper to serialize current tournament setup form data.
     * @param {HTMLElement} overlay
     * @returns {Object|null}
     */
    static getSetupFormData(overlay) {
      if (!overlay) return null;
      const rawTitle = overlay.querySelector("#tourneyTitleInput")?.value || "Table Championship";
      const titleVal = sanitizeUserInput(rawTitle) || "Table Championship";
      const formatVal = overlay.querySelector("#tourneyFormatSel")?.value || "single";
      const seriesVal = overlay.querySelector("#tourneySeriesSel")?.value || "bo3";
      const activeCountBtn = overlay.querySelector(".tourney-count-btn.active");
      const countVal = activeCountBtn ? Number(activeCountBtn.getAttribute("data-count")) : 4;
      const rosterRows = overlay.querySelectorAll(".tourney-roster-row");
      const players = [];
      rosterRows.forEach((row, idx) => {
        const seed = idx + 1;
        const rawName = row.querySelector(".tourney-player-name")?.value || `Player ${seed}`;
        const nameVal = sanitizeUserInput(rawName) || `Player ${seed}`;
        const typeVal = row.querySelector(".tourney-player-type")?.value || "cpu:shark";
        players.push({
          seed,
          name: nameVal,
          typeVal
        });
      });
      return {
        title: titleVal,
        format: formatVal,
        seriesMode: seriesVal,
        playerCount: countVal,
        players
      };
    }
    /**
     * Persists current setup selections to storage so user settings are remembered.
     * @param {HTMLElement} overlay
     */
    static autoSaveSetup(overlay) {
      const data = _TournamentModal.getSetupFormData(overlay);
      if (!data) return;
      const existing = TournamentManager.getSavedSetupSettings() || {};
      const mergedPlayers = Array.isArray(existing.players) ? [...existing.players] : [];
      data.players.forEach((p) => {
        const idx = mergedPlayers.findIndex((ep) => ep.seed === p.seed);
        if (idx >= 0) {
          mergedPlayers[idx] = { ...mergedPlayers[idx], ...p };
        } else {
          mergedPlayers.push(p);
        }
      });
      mergedPlayers.sort((a, b) => a.seed - b.seed);
      data.players = mergedPlayers;
      TournamentManager.saveSetupSettings(data);
    }
    /**
     * Renders the tournament setup view.
     * @param {HTMLElement} overlay
     * @param {Object} context
     */
    static renderSetup(overlay, context = {}) {
      const brand = context.brand || (typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : "crazy");
      if (brand !== "crazy") {
        _TournamentModal.close();
        return;
      }
      const saved = TournamentManager.getSavedSetupSettings() || {};
      const activeTourney = TournamentManager.getTournamentState();
      const canResumeBracket = Boolean(activeTourney && !activeTourney.isComplete);
      let playerCount = context.playerCount || saved.playerCount || 4;
      let format = context.format || saved.format || TOURNAMENT_FORMATS.SINGLE_ELIM;
      let seriesMode = context.seriesMode || saved.seriesMode || TOURNAMENT_SERIES_MODES.BO3;
      let tourneyTitle = context.title || saved.title || "Table Championship";
      let savedPlayers = context.players || saved.players || [];
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      const onlineClients = [];
      if (net2 && net2.clients) {
        for (const [peerId, client] of net2.clients.entries()) {
          if (client.conn && client.conn.open) {
            onlineClients.push({
              peerId,
              name: client.name || `Guest (${client.seatId || "p2"})`,
              seatId: client.seatId
            });
          }
        }
      }
      const defaultNames = ["Player 1 (You)", "The Shark", "The Gambler", "The Turtler", "Pub Master Dave", "Lucky Sarah", "Peggin Pete", "Cribbage Chris"];
      const defaultTypes = ["human", "cpu", "cpu", "cpu", "human", "human", "cpu", "cpu"];
      const defaultCpuProfiles = ["shark", "shark", "gambler", "turtler", "gambler", "shark", "gambler", "turtler"];
      const renderRosterRows = (count) => {
        let rows = "";
        for (let i = 0; i < count; i++) {
          const seed = i + 1;
          const avatar = DEFAULT_AVATARS[i % DEFAULT_AVATARS.length];
          const savedP = savedPlayers.find((p) => p.seed === seed) || savedPlayers[i] || null;
          const name = savedP && savedP.name ? savedP.name : defaultNames[i] || `Player ${seed}`;
          let typeVal = savedP?.typeVal;
          if (!typeVal && savedP) {
            if (savedP.type === "human") typeVal = "human";
            else if (savedP.type === "online") typeVal = `online:${savedP.peerId}`;
            else if (savedP.type === "cpu") typeVal = `cpu:${savedP.cpuProfile || "shark"}`;
          }
          if (!typeVal) {
            const defType = defaultTypes[i] || "cpu";
            const defProfile = defaultCpuProfiles[i] || "shark";
            typeVal = defType === "human" ? "human" : `cpu:${defProfile}`;
          }
          let onlineOption = "";
          if (typeVal.startsWith("online:")) {
            const pId = typeVal.split(":")[1];
            const hasClient = onlineClients.some((c) => c.peerId === pId);
            if (!hasClient) {
              onlineOption = `<option value="${typeVal}" selected>\u{1F310} Online Guest (${pId.substring(0, 6)}...)</option>`;
            }
          }
          rows += `
          <div class="tourney-roster-row" data-seed="${seed}" style="display:flex;align-items:center;gap:10px;margin-bottom:8px;padding:8px 12px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.1);border-radius:8px;">
            <div style="font-weight:900;color:#f0c64a;width:24px;text-align:center;">#${seed}</div>
            <div class="tourney-avatar-wrap" style="font-size:1.25rem;">
              <span id="tourneyAvatar_${seed}">${avatar}</span>
            </div>
            <input type="text" id="tourneyName_${seed}" class="tourney-player-name" value="${name.replace(/"/g, "&quot;")}" maxlength="24" pattern="[a-zA-Z0-9]+"
                   style="flex:1;background:rgba(0,0,0,0.4);border:1px solid rgba(240,198,74,0.3);border-radius:6px;padding:6px 10px;color:#f4ead4;font-size:0.92rem;font-weight:700;" placeholder="Player name">
            <select id="tourneyType_${seed}" class="tourney-player-type"
                    style="background:rgba(20,15,10,0.9);border:1px solid rgba(240,198,74,0.3);border-radius:6px;padding:6px 10px;color:#f0c64a;font-size:0.85rem;font-weight:700;cursor:pointer;">
              <option value="human" ${typeVal === "human" ? "selected" : ""}>\u{1F464} Human (Local)</option>
              <option value="cpu:shark" ${typeVal === "cpu:shark" ? "selected" : ""}>\u{1F988} Expert \u2014 The Shark</option>
              <option value="cpu:master" ${typeVal === "cpu:master" ? "selected" : ""}>\u{1F451} Expert \u2014 The Grandmaster</option>
              <option value="cpu:turtler" ${typeVal === "cpu:turtler" ? "selected" : ""}>\u{1F422} Advanced \u2014 The Turtler</option>
              <option value="cpu:maverick" ${typeVal === "cpu:maverick" ? "selected" : ""}>\u26A1 Advanced \u2014 The Maverick</option>
              <option value="cpu:gambler" ${typeVal === "cpu:gambler" ? "selected" : ""}>\u{1F3B2} Intermediate \u2014 The Gambler</option>
              <option value="cpu:regular" ${typeVal === "cpu:regular" ? "selected" : ""}>\u{1F98A} Intermediate \u2014 The Regular</option>
              <option value="cpu:rookie" ${typeVal === "cpu:rookie" ? "selected" : ""}>\u{1F331} Beginner \u2014 The Rookie</option>
              <option value="cpu:casual" ${typeVal === "cpu:casual" ? "selected" : ""}>\u2615 Beginner \u2014 The Casual</option>
              ${onlineOption}
              ${onlineClients.map((c) => `<option value="online:${c.peerId}" ${typeVal === `online:${c.peerId}` ? "selected" : ""}>\u{1F310} Online: ${c.name}</option>`).join("")}
            </select>
          </div>
        `;
        }
        return rows;
      };
      overlay.innerHTML = `
      <div class="tournament-modal-card tourney-setup-card" style="max-width:680px;width:95%;max-height:92vh;background:linear-gradient(135deg,rgba(26,18,8,0.98),rgba(15,10,5,0.99));border:2px solid #f0c64a;border-radius:14px;box-shadow:0 15px 45px rgba(0,0,0,0.85),0 0 25px rgba(240,198,74,0.25);overflow:hidden;display:flex;flex-direction:column;color:#f4ead4;">
        <div class="tourney-modal-header" style="display:flex;justify-content:space-between;align-items:center;padding:16px 20px;border-bottom:1px solid rgba(240,198,74,0.3);background:rgba(0,0,0,0.35);">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="font-size:1.6rem;">\u{1F3C6}</span>
            <div>
              <div style="font-size:1.15rem;font-weight:900;color:#f0c64a;letter-spacing:0.04em;">MINI-TOURNAMENT SETUP</div>
              <div style="font-size:0.78rem;color:#d6d3d1;">4 to 8 Player Bracket Manager for Game Nights & Online Tables</div>
            </div>
          </div>
          <button type="button" class="btn-ghost tourney-close-btn" style="background:transparent;border:none;color:#a8a29e;font-size:1.5rem;cursor:pointer;padding:4px 8px;line-height:1;">\u2715</button>
        </div>

        <div class="tourney-modal-body" style="padding:18px 20px;overflow-y:auto;flex:1;">
          <div style="margin-bottom:14px;">
            <label style="display:block;font-size:0.8rem;font-weight:800;text-transform:uppercase;color:#f0c64a;margin-bottom:5px;letter-spacing:0.05em;">Tournament Title</label>
            <input type="text" id="tourneyTitleInput" value="${tourneyTitle}" style="width:100%;box-sizing:border-box;background:rgba(0,0,0,0.45);border:1.5px solid rgba(240,198,74,0.4);border-radius:8px;padding:9px 12px;color:#fff;font-size:1rem;font-weight:800;">
          </div>

          <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:14px;">
            <div>
              <label style="display:block;font-size:0.8rem;font-weight:800;text-transform:uppercase;color:#f0c64a;margin-bottom:5px;letter-spacing:0.05em;">Bracket Format</label>
              <select id="tourneyFormatSel" style="width:100%;background:rgba(20,15,10,0.95);border:1.5px solid rgba(240,198,74,0.4);border-radius:8px;padding:9px 12px;color:#f0c64a;font-size:0.95rem;font-weight:800;cursor:pointer;">
                <option value="single" ${format === "single" ? "selected" : ""}>Single Elimination</option>
                <option value="double" ${format === "double" ? "selected" : ""}>Double Elimination</option>
              </select>
            </div>
            <div>
              <label style="display:block;font-size:0.8rem;font-weight:800;text-transform:uppercase;color:#f0c64a;margin-bottom:5px;letter-spacing:0.05em;">Match Series Length</label>
              <select id="tourneySeriesSel" style="width:100%;background:rgba(20,15,10,0.95);border:1.5px solid rgba(240,198,74,0.4);border-radius:8px;padding:9px 12px;color:#f0c64a;font-size:0.95rem;font-weight:800;cursor:pointer;">
                <option value="bo1" ${seriesMode === "bo1" ? "selected" : ""}>Best of 1 (Single Game)</option>
                <option value="bo3" ${seriesMode === "bo3" ? "selected" : ""}>Best of 3 (First to 2 Wins)</option>
                <option value="bo5" ${seriesMode === "bo5" ? "selected" : ""}>Best of 5 (First to 3 Wins)</option>
              </select>
            </div>
          </div>

          <div style="margin-bottom:16px;">
            <label style="display:block;font-size:0.8rem;font-weight:800;text-transform:uppercase;color:#f0c64a;margin-bottom:8px;letter-spacing:0.05em;">Number of Players (4 to 8)</label>
            <div style="display:flex;gap:8px;">
              ${[4, 5, 6, 7, 8].map((n) => `
                <button type="button" class="tourney-count-btn ${n === playerCount ? "active" : ""}" data-count="${n}"
                        style="flex:1;padding:8px 0;font-weight:900;font-size:1rem;border-radius:8px;cursor:pointer;transition:all 0.15s ease;border:1.5px solid ${n === playerCount ? "#f0c64a" : "rgba(255,255,255,0.15)"};background:${n === playerCount ? "rgba(240,198,74,0.25)" : "rgba(0,0,0,0.3)"};color:${n === playerCount ? "#f0c64a" : "#d6d3d1"};">
                  ${n}
                </button>
              `).join("")}
            </div>
          </div>

          <div style="margin-bottom:14px;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
              <label style="font-size:0.8rem;font-weight:800;text-transform:uppercase;color:#f0c64a;letter-spacing:0.05em;">Bracket Seeds & Participants</label>
              <div style="display:flex;gap:6px;">
                <button type="button" id="btnShuffleSeeds" class="btn-ghost" style="padding:4px 8px;font-size:0.75rem;border:1px solid rgba(240,198,74,0.4);border-radius:6px;color:#f0c64a;cursor:pointer;">\u{1F3B2} Shuffle Seeds</button>
                <button type="button" id="btnPresetBots" class="btn-ghost" style="padding:4px 8px;font-size:0.75rem;border:1px solid rgba(240,198,74,0.4);border-radius:6px;color:#f0c64a;cursor:pointer;">\u{1F916} Fill Bots</button>
              </div>
            </div>
            <div id="tourneyRosterWrap">
              ${renderRosterRows(playerCount)}
            </div>
          </div>
        </div>

        <div class="tourney-modal-footer" style="padding:14px 20px;border-top:1px solid rgba(240,198,74,0.3);background:rgba(0,0,0,0.4);display:flex;justify-content:flex-end;gap:12px;">
          ${canResumeBracket ? `
            <button type="button" class="btn-ghost" id="btnCancelSetup" style="padding:10px 18px;border:1px solid rgba(255,255,255,0.2);border-radius:8px;color:#d6d3d1;font-weight:700;cursor:pointer;">Resume Active Bracket</button>
          ` : ""}
          <button type="button" class="btn-gold" id="btnGenerateTournament" style="padding:11px 24px;border-radius:8px;font-weight:900;font-size:1rem;cursor:pointer;background:linear-gradient(135deg,#f0c64a,#ca8a04);color:#1a1208;border:none;box-shadow:0 4px 15px rgba(240,198,74,0.4);">
            \u{1F3C6} Launch Tournament
          </button>
        </div>
      </div>
    `;
      overlay.querySelectorAll(".tourney-close-btn").forEach((btn) => {
        btn.addEventListener("click", () => _TournamentModal.close());
      });
      const countBtns = overlay.querySelectorAll(".tourney-count-btn");
      countBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const count = Number(btn.getAttribute("data-count")) || 4;
          const currentData = _TournamentModal.getSetupFormData(overlay);
          if (currentData) {
            currentData.playerCount = count;
            TournamentManager.saveSetupSettings(currentData);
          }
          _TournamentModal.renderSetup(overlay, {
            ...context,
            playerCount: count,
            title: currentData?.title || tourneyTitle,
            format: currentData?.format || format,
            seriesMode: currentData?.seriesMode || seriesMode,
            players: currentData?.players || savedPlayers
          });
        });
      });
      const titleInput = overlay.querySelector("#tourneyTitleInput");
      if (titleInput) {
        titleInput.addEventListener("input", () => _TournamentModal.autoSaveSetup(overlay));
        titleInput.addEventListener("change", () => _TournamentModal.autoSaveSetup(overlay));
      }
      const formatSel = overlay.querySelector("#tourneyFormatSel");
      if (formatSel) {
        formatSel.addEventListener("change", () => _TournamentModal.autoSaveSetup(overlay));
      }
      const seriesSel = overlay.querySelector("#tourneySeriesSel");
      if (seriesSel) {
        seriesSel.addEventListener("change", () => _TournamentModal.autoSaveSetup(overlay));
      }
      const nameInputs = overlay.querySelectorAll(".tourney-player-name");
      nameInputs.forEach((inp) => {
        inp.addEventListener("input", () => {
          inp.value = inp.value.replace(/[^a-zA-Z0-9]/g, "");
          _TournamentModal.autoSaveSetup(overlay);
        });
        inp.addEventListener("change", () => _TournamentModal.autoSaveSetup(overlay));
      });
      const typeSelects = overlay.querySelectorAll(".tourney-player-type");
      typeSelects.forEach((sel) => {
        sel.addEventListener("change", () => _TournamentModal.autoSaveSetup(overlay));
      });
      const shuffleBtn = overlay.querySelector("#btnShuffleSeeds");
      if (shuffleBtn) {
        shuffleBtn.addEventListener("click", () => {
          const curNameInputs = overlay.querySelectorAll(".tourney-player-name");
          const names = Array.from(curNameInputs).map((inp) => inp.value);
          for (let i = names.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [names[i], names[j]] = [names[j], names[i]];
          }
          curNameInputs.forEach((inp, idx) => {
            inp.value = names[idx] || `Player ${idx + 1}`;
          });
          _TournamentModal.autoSaveSetup(overlay);
        });
      }
      const presetBotsBtn = overlay.querySelector("#btnPresetBots");
      if (presetBotsBtn) {
        presetBotsBtn.addEventListener("click", () => {
          const curTypeSelects = overlay.querySelectorAll(".tourney-player-type");
          const profiles = ["shark", "master", "turtler", "maverick", "gambler", "regular", "rookie", "casual"];
          curTypeSelects.forEach((sel, idx) => {
            if (idx === 0) sel.value = "human";
            else sel.value = `cpu:${profiles[(idx - 1) % profiles.length]}`;
          });
          _TournamentModal.autoSaveSetup(overlay);
        });
      }
      const cancelBtn = overlay.querySelector("#btnCancelSetup");
      if (cancelBtn) {
        cancelBtn.addEventListener("click", () => {
          _TournamentModal.render({ forceSetup: false });
        });
      }
      const launchBtn = overlay.querySelector("#btnGenerateTournament");
      if (launchBtn) {
        launchBtn.addEventListener("click", () => {
          _TournamentModal.autoSaveSetup(overlay);
          const titleVal = (overlay.querySelector("#tourneyTitleInput")?.value || "Table Championship").trim();
          const formatVal = overlay.querySelector("#tourneyFormatSel")?.value || "single";
          const seriesVal = overlay.querySelector("#tourneySeriesSel")?.value || "bo3";
          const rosterRows = overlay.querySelectorAll(".tourney-roster-row");
          const players = [];
          rosterRows.forEach((row, idx) => {
            const seed = idx + 1;
            const raw = row.querySelector(".tourney-player-name")?.value || "";
            const nameVal = raw.replace(/[^a-zA-Z0-9]/g, "").trim() || `Player${seed}`;
            const typeVal = row.querySelector(".tourney-player-type")?.value || "cpu:shark";
            const avatar = DEFAULT_AVATARS[idx % DEFAULT_AVATARS.length];
            let type = "cpu";
            let cpuProfile = "shark";
            let peerId = null;
            if (typeVal === "human") {
              type = "human";
            } else if (typeVal.startsWith("cpu:")) {
              type = "cpu";
              cpuProfile = typeVal.split(":")[1] || "shark";
            } else if (typeVal.startsWith("online:")) {
              type = "online";
              peerId = typeVal.split(":")[1];
            }
            players.push({
              id: `p${seed}`,
              name: nameVal,
              type,
              cpuProfile,
              avatar,
              seed,
              peerId
            });
          });
          const brand2 = typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : "crazy";
          const targetPoints = typeof window !== "undefined" && window.settings && window.settings.target ? Number(window.settings.target) : 121;
          const newTourney = TournamentManager.createTournament({
            title: titleVal,
            format: formatVal,
            seriesMode: seriesVal,
            playerCount: players.length,
            players,
            brand: brand2,
            targetPoints
          });
          _TournamentModal._broadcastTournament(newTourney, context);
          _TournamentModal.render({ forceSetup: false });
        });
      }
    }
    /**
     * Renders the active bracket tree, match progression, and champion podium.
     * @param {HTMLElement} overlay
     * @param {Object} state
     * @param {Object} context
     */
    static renderBracket(overlay, state3, context = {}) {
      const isCompleted = state3.isComplete;
      const champ = state3.champion ? TournamentManager.getPlayer(state3, state3.champion) : null;
      const formatLabel = state3.format === "double" ? "Double Elimination" : "Single Elimination";
      const seriesLabel = state3.seriesMode.toUpperCase();
      const winnersRounds = {};
      const losersRounds = {};
      const finalsMatches = [];
      for (const match of Object.values(state3.matches)) {
        if (match.bracket === "finals" || match.id === "m_finals" || match.id === "m_grand_finals") {
          finalsMatches.push(match);
        } else if (match.bracket === "losers") {
          losersRounds[match.round] = losersRounds[match.round] || [];
          losersRounds[match.round].push(match);
        } else {
          winnersRounds[match.round] = winnersRounds[match.round] || [];
          winnersRounds[match.round].push(match);
        }
      }
      const renderMatchCard = (match) => {
        const p1 = TournamentManager.getPlayer(state3, match.player1Id);
        const p2 = TournamentManager.getPlayer(state3, match.player2Id);
        const isBye = match.status === "bye";
        const isReady = match.status === "ready";
        const isInProg = match.status === "in_progress";
        const isDone = match.status === "completed";
        const isActive = state3.activeMatchId === match.id;
        const p1Wins = match.wins && match.player1Id && match.wins[match.player1Id] || 0;
        const p2Wins = match.wins && match.player2Id && match.wins[match.player2Id] || 0;
        const p1Won = isDone && match.winnerId === match.player1Id;
        const p2Won = isDone && match.winnerId === match.player2Id;
        const p1Name = p1 ? p1.name : isBye ? "BYE" : "TBD";
        const p2Name = p2 ? p2.name : isBye ? "BYE" : "TBD";
        const p1Avatar = p1 ? p1.avatar : "\u2753";
        const p2Avatar = p2 ? p2.avatar : "\u2753";
        let borderStyle = "1px solid rgba(255,255,255,0.12)";
        if (isActive && !isDone) borderStyle = "2px solid #f0c64a; box-shadow: 0 0 16px rgba(240,198,74,0.45);";
        else if (isDone) borderStyle = "1px solid rgba(52,211,153,0.35);";
        let statusBadge = "";
        if (isDone) statusBadge = `<span style="font-size:0.68rem;font-weight:800;background:rgba(52,211,153,0.2);color:#34d399;padding:2px 6px;border-radius:4px;border:1px solid rgba(52,211,153,0.4);">COMPLETED</span>`;
        else if (isInProg) statusBadge = `<span style="font-size:0.68rem;font-weight:800;background:rgba(240,198,74,0.2);color:#f0c64a;padding:2px 6px;border-radius:4px;border:1px solid rgba(240,198,74,0.4);">LIVE</span>`;
        else if (isReady) statusBadge = `<span style="font-size:0.68rem;font-weight:800;background:rgba(59,130,246,0.2);color:#60a5fa;padding:2px 6px;border-radius:4px;border:1px solid rgba(59,130,246,0.4);">READY</span>`;
        else if (isBye) statusBadge = `<span style="font-size:0.68rem;font-weight:800;background:rgba(168,85,247,0.2);color:#c084fc;padding:2px 6px;border-radius:4px;border:1px solid rgba(168,85,247,0.4);">BYE</span>`;
        else statusBadge = `<span style="font-size:0.68rem;color:#78716c;">WAITING</span>`;
        let actionsHtml = "";
        if ((isReady || isInProg) && p1 && p2) {
          const canSimulate = p1.type === "cpu" && p2.type === "cpu";
          actionsHtml = `
          <div class="tourney-match-actions" style="display:flex;gap:6px;margin-top:8px;padding-top:6px;border-top:1px solid rgba(255,255,255,0.08);">
            <button type="button" class="btn-play-match btn-gold" data-match-id="${match.id}"
                    style="flex:2;padding:5px 8px;font-size:0.78rem;font-weight:800;border-radius:6px;cursor:pointer;background:linear-gradient(135deg,#f0c64a,#ca8a04);color:#1a1208;border:none;">
              \u25B6 Play Match
            </button>
            <button type="button" class="btn-manual-score btn-ghost" data-match-id="${match.id}" title="Enter match score manually (for pub game nights)"
                    style="flex:1;padding:5px 6px;font-size:0.75rem;border:1px solid rgba(240,198,74,0.4);border-radius:6px;color:#f0c64a;background:rgba(0,0,0,0.3);cursor:pointer;">
              \u270F Record
            </button>
            ${canSimulate ? `
              <button type="button" class="btn-sim-match btn-ghost" data-match-id="${match.id}" title="Simulate CPU vs CPU match"
                      style="flex:1;padding:5px 6px;font-size:0.75rem;border:1px solid rgba(168,85,247,0.4);border-radius:6px;color:#c084fc;background:rgba(0,0,0,0.3);cursor:pointer;">
                \u26A1 Sim
              </button>
            ` : ""}
          </div>
        `;
        }
        return `
        <div class="tourney-match-node ${isActive ? "active-match" : ""}" data-match-id="${match.id}"
             style="background:rgba(20,15,10,0.92);border-radius:10px;padding:10px 12px;margin-bottom:12px;width:230px;box-sizing:border-box;border:${borderStyle};transition:all 0.2s ease;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">
            <span style="font-size:0.72rem;font-weight:800;color:#d6d3d1;text-transform:uppercase;letter-spacing:0.04em;">${match.roundLabel || "Match"}</span>
            ${statusBadge}
          </div>

          <div class="tourney-slot ${p1Won ? "winner-slot" : ""}"
               style="display:flex;align-items:center;justify-content:space-between;padding:5px 8px;border-radius:6px;background:${p1Won ? "rgba(52,211,153,0.18)" : "rgba(255,255,255,0.03)"};margin-bottom:4px;border:${p1Won ? "1px solid rgba(52,211,153,0.35)" : "1px solid transparent"};">
            <div style="display:flex;align-items:center;gap:6px;overflow:hidden;flex:1;">
              <span style="font-size:0.95rem;">${p1Avatar}</span>
              <span style="font-size:0.86rem;font-weight:700;color:${p1Won ? "#34d399" : p1 ? "#f4ead4" : "#78716c"};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                ${p1 ? p1.name : isBye ? "BYE" : "TBD"}
              </span>
            </div>
            <div style="font-size:0.95rem;font-weight:900;color:${p1Won ? "#34d399" : "#f0c64a"};margin-left:8px;">
              ${p1 ? p1Wins : "-"}
            </div>
          </div>

          <div class="tourney-slot ${p2Won ? "winner-slot" : ""}"
               style="display:flex;align-items:center;justify-content:space-between;padding:5px 8px;border-radius:6px;background:${p2Won ? "rgba(52,211,153,0.18)" : "rgba(255,255,255,0.03)"};border:${p2Won ? "1px solid rgba(52,211,153,0.35)" : "1px solid transparent"};">
            <div style="display:flex;align-items:center;gap:6px;overflow:hidden;flex:1;">
              <span style="font-size:0.95rem;">${p2Avatar}</span>
              <span style="font-size:0.86rem;font-weight:700;color:${p2Won ? "#34d399" : p2 ? "#f4ead4" : "#78716c"};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                ${p2 ? p2.name : isBye ? "BYE" : "TBD"}
              </span>
            </div>
            <div style="font-size:0.95rem;font-weight:900;color:${p2Won ? "#34d399" : "#f0c64a"};margin-left:8px;">
              ${p2 ? p2Wins : "-"}
            </div>
          </div>

          ${actionsHtml}
        </div>
      `;
      };
      const renderRoundColumn = (roundMatches, roundLabel) => `
      <div class="tourney-bracket-col" style="display:flex;flex-direction:column;justify-content:space-around;min-width:240px;margin-right:16px;">
        <div style="text-align:center;font-size:0.82rem;font-weight:800;color:#f0c64a;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:12px;padding:4px 0;background:rgba(0,0,0,0.3);border-radius:6px;">
          ${roundLabel}
        </div>
        <div style="display:flex;flex-direction:column;justify-content:space-around;flex:1;">
          ${roundMatches.map((m) => renderMatchCard(m)).join("")}
        </div>
      </div>
    `;
      let podiumHtml = "";
      if (isCompleted && champ) {
        const p1st = champ;
        const p2nd = state3.podium?.second ? TournamentManager.getPlayer(state3, state3.podium.second) : null;
        const p3rd = state3.podium?.third ? TournamentManager.getPlayer(state3, state3.podium.third) : null;
        podiumHtml = `
        <div class="tourney-podium-card" style="margin-bottom:16px;padding:16px 20px;background:linear-gradient(135deg,rgba(240,198,74,0.18),rgba(0,0,0,0.6));border:2px solid #f0c64a;border-radius:12px;text-align:center;box-shadow:0 8px 30px rgba(240,198,74,0.35);">
          <div style="font-size:1.8rem;line-height:1;margin-bottom:4px;">\u{1F451} \u{1F3C6} \u{1F451}</div>
          <div style="font-size:1.35rem;font-weight:900;color:#f0c64a;text-transform:uppercase;letter-spacing:0.06em;">
            TABLE CHAMPION CROWNED!
          </div>
          <div style="font-size:1.25rem;font-weight:900;color:#ffffff;margin:8px 0;">
            ${p1st.avatar} ${p1st.name}
          </div>
          <div style="display:flex;justify-content:center;gap:20px;margin-top:10px;flex-wrap:wrap;">
            ${p2nd ? `<div style="font-size:0.88rem;color:#e2e8f0;">\u{1F948} <strong>Runner-Up:</strong> ${p2nd.name}</div>` : ""}
            ${p3rd ? `<div style="font-size:0.88rem;color:#fbd38d;">\u{1F949} <strong>3rd Place:</strong> ${p3rd.name}</div>` : ""}
          </div>
        </div>
      `;
      }
      overlay.innerHTML = `
      <div class="tournament-modal-card" style="max-width:1100px;width:96%;max-height:94vh;background:linear-gradient(135deg,rgba(26,18,8,0.98),rgba(15,10,5,0.99));border:2px solid #f0c64a;border-radius:14px;box-shadow:0 15px 45px rgba(0,0,0,0.85),0 0 25px rgba(240,198,74,0.25);overflow:hidden;display:flex;flex-direction:column;color:#f4ead4;">
        <div class="tourney-modal-header" style="display:flex;justify-content:space-between;align-items:center;padding:14px 20px;border-bottom:1px solid rgba(240,198,74,0.3);background:rgba(0,0,0,0.35);flex-wrap:wrap;gap:8px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="font-size:1.6rem;">\u{1F3C6}</span>
            <div>
              <div style="font-size:1.15rem;font-weight:900;color:#f0c64a;letter-spacing:0.04em;">${state3.title}</div>
              <div style="font-size:0.78rem;color:#d6d3d1;">
                ${state3.playerCount} Players \xB7 ${formatLabel} \xB7 ${seriesLabel}
                ${state3.isComplete ? '\xB7 <strong style="color:#34d399;">CHAMPION CROWNED</strong>' : ""}
              </div>
            </div>
          </div>
          <div style="display:flex;gap:8px;align-items:center;">
            <button type="button" class="btn-ghost" id="btnCopyTourneySummary" style="padding:6px 10px;font-size:0.8rem;border:1px solid rgba(240,198,74,0.4);border-radius:6px;color:#f0c64a;cursor:pointer;">
              \u{1F4CB} Share Recap
            </button>
            <button type="button" class="btn-ghost" id="btnNewTourney" style="padding:6px 10px;font-size:0.8rem;border:1px solid rgba(255,255,255,0.2);border-radius:6px;color:#d6d3d1;cursor:pointer;">
              \u2699 New Bracket
            </button>
            <button type="button" class="btn-ghost tourney-close-btn" id="btnTourneyCloseTop" style="background:transparent;border:none;color:#a8a29e;font-size:1.5rem;cursor:pointer;padding:4px 8px;line-height:1;">\u2715</button>
          </div>
        </div>

        <div class="tourney-modal-body" style="padding:18px 20px;overflow-x:auto;overflow-y:auto;flex:1;">
          ${podiumHtml}

          <div class="tourney-bracket-container" style="display:flex;align-items:stretch;min-width:max-content;padding-bottom:10px;">
            ${Object.keys(winnersRounds).map((rnd) => {
        const rMatches = winnersRounds[rnd];
        const label = rnd === "1" && state3.playerCount > 4 ? "Quarterfinals" : rnd === "1" ? "Semifinals" : "Semifinals";
        return renderRoundColumn(rMatches, label);
      }).join("")}

            ${finalsMatches.length > 0 ? renderRoundColumn(finalsMatches, finalsMatches[0].roundLabel || "Finals") : ""}
          </div>

          ${state3.format === "double" && Object.keys(losersRounds).length > 0 ? `
            <div style="margin-top:20px;border-top:1px dashed rgba(240,198,74,0.3);padding-top:16px;">
              <div style="font-size:0.95rem;font-weight:900;color:#c084fc;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:12px;">
                \u26A1 Losers / Consolation Bracket
              </div>
              <div class="tourney-bracket-container" style="display:flex;align-items:stretch;min-width:max-content;padding-bottom:10px;">
                ${Object.keys(losersRounds).map((rnd) => {
        const rMatches = losersRounds[rnd];
        return renderRoundColumn(rMatches, `Losers Round ${rnd}`);
      }).join("")}
              </div>
            </div>
          ` : ""}
        </div>

        <div class="tourney-modal-footer" style="padding:12px 20px;border-top:1px solid rgba(240,198,74,0.3);background:rgba(0,0,0,0.4);display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px;">
          <div style="font-size:0.82rem;color:#a8a29e;">
            \u{1F4A1} Play directly on the digital table or record physical cribbage board match results manually.
          </div>
          <button type="button" class="btn-ghost" id="btnTourneyCloseBottom" style="padding:8px 18px;border:1px solid rgba(255,255,255,0.2);border-radius:6px;color:#f4ead4;cursor:pointer;">
            Close to Table
          </button>
        </div>
      </div>
    `;
      overlay.querySelectorAll(".tourney-close-btn, #btnTourneyCloseBottom, #btnTourneyCloseTop").forEach((btn) => {
        btn.addEventListener("click", () => _TournamentModal.close());
      });
      const copyBtn = overlay.querySelector("#btnCopyTourneySummary");
      if (copyBtn) {
        copyBtn.addEventListener("click", () => {
          const text2 = TournamentManager.generateShareSummary(state3);
          if (typeof navigator !== "undefined" && navigator.clipboard) {
            navigator.clipboard.writeText(text2).then(() => {
              copyBtn.textContent = "\u2714 Copied!";
              setTimeout(() => {
                copyBtn.textContent = "\u{1F4CB} Share Recap";
              }, 2e3);
            }).catch(() => {
            });
          }
        });
      }
      const newBtn = overlay.querySelector("#btnNewTourney");
      if (newBtn) {
        newBtn.addEventListener("click", () => {
          _TournamentModal.renderSetup(overlay, { ...context, forceSetup: true });
        });
      }
      const playBtns = overlay.querySelectorAll(".btn-play-match");
      playBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const matchId = btn.getAttribute("data-match-id");
          _TournamentModal.launchMatch(matchId, context);
        });
      });
      const manualBtns = overlay.querySelectorAll(".btn-manual-score");
      manualBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const matchId = btn.getAttribute("data-match-id");
          _TournamentModal.promptManualScore(matchId, context);
        });
      });
      const simBtns = overlay.querySelectorAll(".btn-sim-match");
      simBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const matchId = btn.getAttribute("data-match-id");
          const res = TournamentManager.simulateCpuMatch(matchId);
          if (res) {
            _TournamentModal._broadcastTournament(res.state, context);
            _TournamentModal.render(context);
          }
        });
      });
    }
    /**
     * Prompts a modal to enter manual match result (for pub game nights on physical boards).
     * @param {string} matchId
     * @param {Object} context
     */
    static promptManualScore(matchId, context = {}) {
      const state3 = TournamentManager.getTournamentState();
      if (!state3 || !state3.matches || !state3.matches[matchId]) return;
      const match = state3.matches[matchId];
      const p1 = TournamentManager.getPlayer(state3, match.player1Id);
      const p2 = TournamentManager.getPlayer(state3, match.player2Id);
      if (!p1 || !p2) return;
      const modalManager = context.modalManager || (typeof window !== "undefined" ? window.modalManager : null);
      const showModal2 = typeof window !== "undefined" && typeof window.showModal === "function" ? window.showModal : null;
      const modalHtml = `
      <div class="manual-score-modal" style="padding:10px;text-align:center;">
        <h3 style="color:#f0c64a;font-size:1.2rem;margin-bottom:6px;">Record Match Result</h3>
        <p style="font-size:0.86rem;color:#d6d3d1;margin-bottom:16px;">
          Select the winner of <strong>${p1.name}</strong> vs <strong>${p2.name}</strong>:
        </p>

        <div style="display:flex;gap:12px;justify-content:center;margin-bottom:18px;">
          <button type="button" class="btn-gold" id="btnPickWinner1" style="flex:1;padding:12px;border-radius:8px;font-weight:900;font-size:1rem;cursor:pointer;">
            ${p1.avatar} ${p1.name} Won
          </button>
          <button type="button" class="btn-gold" id="btnPickWinner2" style="flex:1;padding:12px;border-radius:8px;font-weight:900;font-size:1rem;cursor:pointer;">
            ${p2.avatar} ${p2.name} Won
          </button>
        </div>

        <button type="button" class="btn-ghost modal-btn-close" id="btnCancelManualResult" style="padding:8px 16px;border:1px solid rgba(255,255,255,0.2);border-radius:6px;color:#d6d3d1;cursor:pointer;">
          Cancel
        </button>
      </div>
    `;
      if (modalManager && typeof modalManager.showModal === "function") {
        modalManager.showModal(modalHtml, true);
      } else if (showModal2) {
        showModal2(modalHtml, true);
      }
      setTimeout(() => {
        const btn1 = document.getElementById("btnPickWinner1");
        const btn2 = document.getElementById("btnPickWinner2");
        const hide = typeof window !== "undefined" && typeof window.hideModal === "function" ? window.hideModal : () => {
        };
        const btnCancel = document.getElementById("btnCancelManualResult");
        if (btnCancel) btnCancel.addEventListener("click", () => hide());
        if (btn1) {
          btn1.addEventListener("click", () => {
            const res = TournamentManager.manualSetMatchWinner(matchId, p1.id);
            hide();
            if (res) {
              _TournamentModal._broadcastTournament(res.state, context);
              _TournamentModal.render(context);
            }
          });
        }
        if (btn2) {
          btn2.addEventListener("click", () => {
            const res = TournamentManager.manualSetMatchWinner(matchId, p2.id);
            hide();
            if (res) {
              _TournamentModal._broadcastTournament(res.state, context);
              _TournamentModal.render(context);
            }
          });
        }
      }, 100);
    }
    /**
     * Launches active tournament match onto the digital cribbage table.
     * @param {string} matchId
     * @param {Object} context
     */
    static launchMatch(matchId, context = {}) {
      const match = TournamentManager.setActiveMatch(matchId);
      if (!match) return;
      const state3 = TournamentManager.getTournamentState();
      const p1 = TournamentManager.getPlayer(state3, match.player1Id);
      const p2 = TournamentManager.getPlayer(state3, match.player2Id);
      if (!p1 || !p2) return;
      _TournamentModal.close();
      let seat1Player = p1;
      let seat2Player = p2;
      if (p1.type === "cpu" && p2.type === "human") {
        seat1Player = p2;
        seat2Player = p1;
      }
      match.seatMap = {
        p1: seat1Player.id,
        p2: seat2Player.id
      };
      TournamentManager.saveTournamentState(state3);
      const isHumanVsHuman = seat1Player.type === "human" && seat2Player.type === "human";
      const isOnline2 = seat1Player.type === "online" || seat2Player.type === "online";
      const oppMode = isHumanVsHuman ? "human" : isOnline2 ? "online" : "cpu";
      const aiProf = seat2Player.type === "cpu" ? seat2Player.cpuProfile || "shark" : "shark";
      if (typeof document !== "undefined") {
        const optPlayerCount = document.getElementById("optPlayerCount");
        if (optPlayerCount) optPlayerCount.value = "2";
        const optOpp = document.getElementById("optOpp");
        if (optOpp) optOpp.value = oppMode;
        const optAiProfile = document.getElementById("optAiProfile");
        if (optAiProfile) optAiProfile.value = aiProf;
        const optSeat2Type = document.getElementById("optSeat2Type");
        if (optSeat2Type) optSeat2Type.value = oppMode === "human" ? "human" : `cpu:${aiProf}`;
        const modePills = document.querySelectorAll(".game-mode-pill");
        modePills.forEach((p) => p.classList.toggle("active", p.dataset.mode === oppMode));
      }
      const settings3 = context.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3) {
        settings3.playerCount = 2;
        settings3.gameMode = "individual";
        settings3.opp = oppMode;
        settings3.aiProfile = aiProf;
        settings3.isTournamentMatch = true;
        settings3.seats = [
          {
            id: "p1",
            name: seat1Player.name,
            type: seat1Player.type === "online" ? "online" : seat1Player.type === "human" ? "human" : "cpu",
            personality: seat1Player.cpuProfile || "shark",
            team: 1,
            color: "#d4a017"
          },
          {
            id: "p2",
            name: seat2Player.name,
            type: seat2Player.type === "online" ? "online" : seat2Player.type === "human" ? "human" : "cpu",
            personality: aiProf,
            team: 2,
            color: "#ef4444"
          }
        ];
      }
      const startGame2 = context.startGame || (typeof window !== "undefined" ? window.startGame : null);
      if (typeof startGame2 === "function") {
        startGame2();
      }
    }
    /**
     * Broadcasts tournament update over WebRTC to multiplayer room.
     */
    static _broadcastTournament(tourneyState, context = {}) {
      const net2 = context.net || (typeof window !== "undefined" ? window.net : null);
      if (!net2 || !net2.clients || typeof net2.broadcast !== "function" && !net2.clients.size) return;
      const payload = {
        type: "tournament_update",
        tournament: tourneyState
      };
      if (typeof net2.broadcast === "function") {
        net2.broadcast(payload);
      } else {
        for (const client of net2.clients.values()) {
          if (client.conn && client.conn.open) {
            try {
              client.conn.send(payload);
            } catch (e) {
            }
          }
        }
      }
    }
  };

  // src/ui/BoardSelectorModal.js
  function escapeHtml3(str) {
    if (!str) return "";
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }
  function sanitizeUrl(url) {
    if (!url || typeof url !== "string") return "";
    const trimmed = url.trim();
    if (/^(?:https?:\/\/|\/|\.\/|\.\.\/|data:image\/)/i.test(trimmed)) {
      return trimmed.replace(/[<>"'`]/g, "");
    }
    return "";
  }
  var BoardSelectorModal2 = class {
    /**
     * Opens the 3D Board Gallery modal.
     * @param {Object} options
     */
    static show(options = {}) {
      const initialBrand = options.brand || SettingsManager.getAppBrand() || "crazy";
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : {}) || {};
      const onSelect = options.onSelect || (() => {
      });
      let currentBrandTab = initialBrand;
      let modalEl = document.getElementById("board3DModal");
      if (!modalEl) {
        modalEl = document.createElement("div");
        modalEl.id = "board3DModal";
        modalEl.className = "board-3d-overlay";
        modalEl.setAttribute("role", "dialog");
        modalEl.setAttribute("aria-modal", "true");
        modalEl.setAttribute("aria-labelledby", "board3DModalTitle");
        document.body.appendChild(modalEl);
      }
      const fsElem = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
      const b3dElem = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
      const activeModalOverlay = document.getElementById("overlay");
      const modalParent = activeModalOverlay && activeModalOverlay.parentElement && activeModalOverlay.parentElement !== document.body ? activeModalOverlay.parentElement : null;
      const b3dContainer = document.getElementById("board3DContainer");
      const is3DFullscreen = Boolean(
        fsElem || b3dElem || b3dContainer && (b3dContainer.classList?.contains?.("is-fullscreen") || typeof document !== "undefined" && document.body?.classList?.contains?.("is-3d-fullscreen"))
      );
      const targetParent = fsElem || b3dElem || modalParent || (is3DFullscreen ? b3dContainer : null);
      if (targetParent && modalEl.parentElement !== targetParent) {
        targetParent.appendChild(modalEl);
      } else if (!targetParent && modalEl.parentElement !== document.body && document.body) {
        document.body.appendChild(modalEl);
      }
      modalEl.style.cssText = "position: fixed; inset: 0; top: 0; left: 0; right: 0; bottom: 0; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.84); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; z-index: 20000000; padding: 14px; box-sizing: border-box;";
      modalEl.style.zIndex = "20000000";
      const getBrandBadge = (brandVal) => {
        if (!brandVal || brandVal === "all") {
          return '<span style="font-size: 0.68rem; padding: 2px 6px; border-radius: 4px; background: rgba(56, 189, 248, 0.2); color: #38bdf8; border: 1px solid rgba(56, 189, 248, 0.4); font-weight: 700;">\u{1F310} All Brands</span>';
        }
        const b = GAME_BRANDS.find((g) => g.id === brandVal);
        if (b) {
          return `<span style="font-size: 0.68rem; padding: 2px 6px; border-radius: 4px; background: ${b.badgeBg}; color: ${b.color}; border: 1px solid ${b.border}; font-weight: 700;">${b.icon} ${b.shortName}</span>`;
        }
        return `<span style="font-size: 0.68rem; padding: 2px 6px; border-radius: 4px; background: rgba(255,255,255,0.1); color: #cbd5e1; border: 1px solid rgba(255,255,255,0.2); font-weight: 700;">${escapeHtml3(brandVal)}</span>`;
      };
      const renderModal = () => {
        const allBrandBoards = Board3DCatalog.getBoards(currentBrandTab);
        const officialBoards = allBrandBoards.filter((b) => !b.isCustom);
        const selectedId = officialBoards.some((b) => b.id === settings3.selected3DBoardId) ? settings3.selected3DBoardId : officialBoards[0]?.id || (currentBrandTab === "clash" ? "board-cribbage-clash" : "board-14");
        const is3DActive = settings3.boardViewMode === "3d";
        modalEl.innerHTML = `
        <div class="modal-card board-3d-modal-card" style="box-sizing: border-box; background: linear-gradient(135deg, rgba(22, 16, 8, 0.98), rgba(38, 26, 12, 0.98)); border: 1.5px solid rgba(240, 198, 74, 0.5); border-radius: 18px; box-shadow: 0 16px 45px rgba(0, 0, 0, 0.8), 0 0 25px rgba(240, 198, 74, 0.2); max-width: 860px; width: 95vw; max-height: 92vh; display: flex; flex-direction: column; overflow: hidden;">
          <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; padding: 16px 22px; border-bottom: 1px solid rgba(240, 198, 74, 0.25); background: rgba(0,0,0,0.35);">
            <div style="display: flex; align-items: center; gap: 12px;">
              <span style="font-size: 1.7rem;">\u{1F3B2}</span>
              <div>
                <h2 id="board3DModalTitle" style="margin: 0; font-size: 1.35rem; color: var(--gold, #f0c64a); font-weight: 800; letter-spacing: 0.03em;">3D Cribbage Boards</h2>
                <div style="font-size: 0.82rem; color: #cbd5e1;">Browse official 3D cribbage boards across all game brands</div>
              </div>
            </div>
            <button type="button" class="btn-ghost" id="btnBoard3DClose" aria-label="Close modal" style="font-size: 1.4rem; color: #f0c64a; cursor: pointer; padding: 4px 10px; border-radius: 8px; border: none; background: transparent; line-height: 1;">\u2715</button>
          </div>

          <div class="modal-body" style="padding: 16px 22px; max-height: calc(92vh - 140px); overflow-y: auto;">
            <!-- View Mode Toggle -->
            <div style="display: flex; align-items: center; justify-content: space-between; background: rgba(0,0,0,0.35); padding: 12px 16px; border-radius: 12px; margin-bottom: 14px; border: 1px solid rgba(240,198,74,0.25); flex-wrap: wrap; gap: 10px;">
              <div>
                <div style="font-weight: 700; color: #fff;">Render Mode</div>
                <div style="font-size: 0.8rem; color: #94a3b8;">Choose between classic 2D SVG or interactive 3D WebGL</div>
              </div>
              <div style="display: inline-flex; gap: 8px;">
                <button type="button" class="btn-toggle-view ${!is3DActive ? "active" : ""}" id="btnMode2D" style="padding: 7px 16px; border-radius: 8px; font-weight: 700; font-size: 0.85rem; cursor: pointer; border: 1px solid ${!is3DActive ? "var(--gold, #f0c64a)" : "rgba(255,255,255,0.2)"}; background: ${!is3DActive ? "var(--gold, #f0c64a)" : "transparent"}; color: ${!is3DActive ? "#000" : "#cbd5e1"};">2D Classic</button>
                <button type="button" class="btn-toggle-view ${is3DActive ? "active" : ""}" id="btnMode3D" style="padding: 7px 16px; border-radius: 8px; font-weight: 700; font-size: 0.85rem; cursor: pointer; border: 1px solid ${is3DActive ? "var(--gold, #f0c64a)" : "rgba(255,255,255,0.2)"}; background: ${is3DActive ? "var(--gold, #f0c64a)" : "transparent"}; color: ${is3DActive ? "#000" : "#cbd5e1"};">3D Interactive</button>
              </div>
            </div>

            <!-- Brand Selection Navigation Tabs -->
            <div style="display: flex; gap: 6px; margin-bottom: 16px; overflow-x: auto; padding-bottom: 4px; border-bottom: 1px solid rgba(240,198,74,0.18);">
              <button type="button" class="board-brand-tab-btn ${currentBrandTab === "all" ? "active" : ""}" data-brand-tab="all" style="padding: 6px 12px; border-radius: 8px; font-size: 0.82rem; font-weight: 700; cursor: pointer; white-space: nowrap; border: 1px solid ${currentBrandTab === "all" ? "#f59e0b" : "rgba(244,234,212,0.18)"}; background: ${currentBrandTab === "all" ? "rgba(245,158,11,0.25)" : "rgba(0,0,0,0.3)"}; color: ${currentBrandTab === "all" ? "#facc15" : "#d1d5db"};">
                \u{1F310} All Brands
              </button>
              ${GAME_BRANDS.map((b) => {
          const isAct = currentBrandTab === b.id;
          return `
                  <button type="button" class="board-brand-tab-btn ${isAct ? "active" : ""}" data-brand-tab="${b.id}" style="padding: 6px 12px; border-radius: 8px; font-size: 0.82rem; font-weight: 700; cursor: pointer; white-space: nowrap; border: 1px solid ${isAct ? b.color : "rgba(244,234,212,0.18)"}; background: ${isAct ? b.badgeBg : "rgba(0,0,0,0.3)"}; color: ${isAct ? "#fff" : "#d1d5db"}; display: inline-flex; align-items: center; gap: 5px;">
                    <span>${b.icon} ${b.shortName}</span>
                  </button>
                `;
        }).join("")}
            </div>

            <!-- Official 3D Boards for the Brand -->
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; flex-wrap: wrap; gap: 8px;">
              <span style="font-weight: 800; font-size: 1.05rem; color: #f4ead4;">\u{1F3DB}\uFE0F Official 3D Boards (${officialBoards.length})</span>
            </div>

            <div class="board-3d-grid" id="official3DGrid">
              ${officialBoards.map((b) => {
          const isSelected = b.id === selectedId;
          const safeId = escapeHtml3(b.id);
          const safeName = escapeHtml3(b.name);
          const safeDesc = escapeHtml3(b.desc || "Standard 3D Cribbage Board");
          const safeThumb = sanitizeUrl(b.thumbnailUrl);
          return `
                  <div class="board-3d-card ${isSelected ? "is-selected" : ""}" data-board-id="${safeId}" tabindex="0" role="button" aria-label="Select ${safeName}">
                    <div>
                      ${safeThumb ? `
                        <div class="board-3d-thumb-wrap">
                          <img src="${safeThumb}" alt="${safeName}" class="board-3d-thumb-img" loading="lazy">
                        </div>
                      ` : ""}
                      <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px; gap: 8px;">
                        <span style="font-weight: 800; font-size: 0.95rem; color: #fff; line-height: 1.25;">${safeName}</span>
                        <div style="display: flex; gap: 4px; flex-shrink: 0;">
                          <span class="board-3d-badge-builtin">OFFICIAL</span>
                          ${isSelected ? '<span class="board-3d-badge-active">ACTIVE</span>' : ""}
                        </div>
                      </div>
                      <p style="font-size: 0.78rem; color: #94a3b8; margin: 0 0 10px 0; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">${safeDesc}</p>
                    </div>

                    <div>
                      <div style="display: flex; justify-content: space-between; align-items: center; font-size: 0.75rem; color: #cbd5e1; margin-bottom: 4px;">
                        <span>Tracks: <strong>${Number(b.trackCount) || 3}</strong></span>
                        <span>Target: <strong>${Number(b.target) || 121}</strong></span>
                      </div>
                      <div style="margin-top: 6px;">
                        <button type="button" class="btn-board-action btn-board-select" data-action="select" data-id="${safeId}" style="width: 100%; padding: 4px 8px; border-radius: 6px; font-size: 0.78rem; font-weight: 700; background: ${isSelected ? "var(--gold, #f0c64a)" : "rgba(240,198,74,0.18)"}; color: ${isSelected ? "#000" : "var(--gold, #f0c64a)"}; border: 1px solid var(--gold, #f0c64a); cursor: pointer;">${isSelected ? "\u2713 In Use" : "\u25B6\uFE0F Select Board"}</button>
                      </div>
                    </div>
                  </div>
                `;
        }).join("")}
            </div>
          </div>

          <div class="modal-footer" style="padding: 12px 22px; display: flex; justify-content: flex-end; gap: 10px; border-top: 1px solid rgba(240, 198, 74, 0.2); background: rgba(0,0,0,0.35);">
            <button type="button" class="btn-ghost" id="btnBoard3DCancel" style="padding: 8px 20px; border-radius: 8px; cursor: pointer; font-weight: 700; color: #f4ead4; border: 1px solid rgba(255,255,255,0.2);">Close</button>
          </div>
        </div>
      `;
        bindEvents();
      };
      const closeModal2 = () => {
        modalEl.style.display = "none";
        const fsElem2 = typeof document !== "undefined" ? document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement : null;
        const b3dElem2 = typeof document !== "undefined" && typeof document.querySelector === "function" ? document.querySelector(".board-3d-container.is-fullscreen, .board-3d-container:fullscreen") : null;
        if (modalEl.parentElement !== document.body && !fsElem2 && !b3dElem2 && document.body) {
          document.body.appendChild(modalEl);
        }
      };
      const bindEvents = () => {
        modalEl.onclick = (e) => {
          if (e.target === modalEl) closeModal2();
        };
        if (!window._board3DEscapeBound && typeof window !== "undefined" && typeof window.addEventListener === "function") {
          window._board3DEscapeBound = true;
          window.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
              const el = document.getElementById("board3DModal");
              if (el && el.style.display !== "none") {
                el.style.display = "none";
              }
            }
          });
        }
        const btnClose = modalEl.querySelector("#btnBoard3DClose");
        if (btnClose) btnClose.onclick = closeModal2;
        const btnCancel = modalEl.querySelector("#btnBoard3DCancel");
        if (btnCancel) btnCancel.onclick = closeModal2;
        modalEl.querySelectorAll("img.board-3d-thumb-img").forEach((img) => {
          img.addEventListener("error", () => {
            const wrap = img.closest(".board-3d-thumb-wrap");
            if (wrap) wrap.style.display = "none";
          }, { once: true });
        });
        modalEl.querySelectorAll(".board-brand-tab-btn").forEach((btn) => {
          btn.onclick = () => {
            currentBrandTab = btn.getAttribute("data-brand-tab") || "all";
            renderModal();
          };
        });
        const btnMode2D = modalEl.querySelector("#btnMode2D");
        if (btnMode2D) {
          btnMode2D.onclick = () => {
            settings3.boardViewMode = "2d";
            const elBv = document.getElementById("optBoardView");
            if (elBv) elBv.value = "2d";
            SettingsManager.saveSettingsStore(settings3);
            onSelect({ viewMode: "2d", boardId: settings3.selected3DBoardId });
            closeModal2();
          };
        }
        const btnMode3D = modalEl.querySelector("#btnMode3D");
        if (btnMode3D) {
          btnMode3D.onclick = () => {
            settings3.boardViewMode = "3d";
            const elBv = document.getElementById("optBoardView");
            if (elBv) elBv.value = "3d";
            SettingsManager.saveSettingsStore(settings3);
            onSelect({ viewMode: "3d", boardId: settings3.selected3DBoardId });
            closeModal2();
          };
        }
        const selectBoard = (boardId) => {
          settings3.selected3DBoardId = boardId;
          const activeViewMode = settings3.boardViewMode || "3d";
          const el3d = document.getElementById("opt3DBoard");
          if (el3d) el3d.value = boardId;
          const elInGame = document.getElementById("inGameOpt3DBoard");
          if (elInGame) elInGame.value = boardId;
          SettingsManager.saveSettingsStore(settings3);
          onSelect({ viewMode: activeViewMode, boardId });
          closeModal2();
        };
        modalEl.querySelectorAll(".board-3d-card").forEach((card) => {
          card.onclick = (e) => {
            if (e.target.closest(".btn-board-action")) return;
            const boardId = card.getAttribute("data-board-id");
            if (boardId) selectBoard(boardId);
          };
        });
        modalEl.querySelectorAll(".btn-board-action").forEach((btn) => {
          btn.onclick = (e) => {
            e.stopPropagation();
            const action = btn.getAttribute("data-action");
            const boardId = btn.getAttribute("data-id");
            if (action === "select" && boardId) {
              selectBoard(boardId);
            }
          };
        });
      };
      renderModal();
      modalEl.style.display = "flex";
    }
  };

  // src/ui/JailAnimationOverlay.js
  var activeJailOverlayInstance = null;
  var JailAnimationOverlay = class _JailAnimationOverlay {
    /**
     * Displays the Jailhouse Mugshot animation in an interactive overlay.
     *
     * @param {Object} [options]
     * @param {string} [options.playerName] - Name of player jailed (e.g. "You", "Computer")
     * @param {string} [options.who] - Seat ID ('p1', 'p2', etc.)
     * @param {number} [options.jailHole] - The board hole number of the jail trap
     * @param {number} [options.score] - Current score of the jailed player
     * @param {Object} [options.card] - Card object { r, s } representing the player's card
     * @param {Object} [options.settings] - Game settings object
     * @param {Function} [options.onComplete] - Callback on dismiss or completion
     * @returns {JailAnimationOverlay|null}
     */
    static show(options = {}) {
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3 && (settings3.jailAnimation === "no" || settings3.jailAnimation === "off" || settings3.jailAnimation === false)) {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (typeof document === "undefined") {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (activeJailOverlayInstance) {
        activeJailOverlayInstance.close(false);
      }
      const instance = new _JailAnimationOverlay(options);
      activeJailOverlayInstance = instance;
      instance.mount();
      return instance;
    }
    static hide() {
      if (activeJailOverlayInstance) {
        activeJailOverlayInstance.close(true);
      }
    }
    constructor(options = {}) {
      this.options = options;
      this.onComplete = options.onComplete || (() => {
      });
      this.raf = 0;
      this.running = false;
      this.overlayEl = null;
      this.autoCloseTimer = null;
      this.safetyTimer = null;
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    formatCard(card, fallbackRank = "J", fallbackSuit = "\u2660") {
      if (!card) {
        return { r: fallbackRank, s: fallbackSuit, isRed: fallbackSuit === "\u2665" || fallbackSuit === "\u2666" };
      }
      if (Array.isArray(card) && card.length > 0) {
        card = card[card.length - 1];
      }
      if (typeof card === "string") {
        const match = card.match(/^([0-9AJQK]+)([HDSC♥♦♠♣]?)$/i);
        if (match) {
          card = { r: match[1], s: match[2] };
        }
      }
      let r = card.r !== void 0 ? card.r : card.rank !== void 0 ? card.rank : fallbackRank;
      if (r === 1 || r === "1") r = "A";
      else if (r === 11 || r === "11") r = "J";
      else if (r === 12 || r === "12") r = "Q";
      else if (r === 13 || r === "13") r = "K";
      r = String(r).toUpperCase();
      let s = card.s || card.suit || fallbackSuit;
      if (s === "H" || s === "h") s = "\u2665";
      else if (s === "D" || s === "d") s = "\u2666";
      else if (s === "S" || s === "s") s = "\u2660";
      else if (s === "C" || s === "c") s = "\u2663";
      const isRed = s === "\u2665" || s === "\u2666";
      return { r, s, isRed };
    }
    buildHtml() {
      const prisonerName = this.options.playerName || "Player";
      const jailHole = this.options.jailHole !== void 0 ? this.options.jailHole : 25;
      const score = this.options.score !== void 0 ? this.options.score : jailHole;
      const prisonerCard = this.formatCard(this.options.card, "J", "\u2660");
      return `
      <div class="siren-glow"></div>
      <button class="jail-skip-btn" id="jailSkipBtn" type="button" title="Skip animation (Esc)">Skip \u2715</button>

      <div class="jail-banner">
        <span class="jail-badge">\u{1F6A8} BUSTED! GO TO JAIL</span>
        <h2 class="jail-title">${prisonerName} Thrown in the Clink!</h2>
        <p class="jail-subtitle">Landed on Jail Hole ${jailHole} \u2014 Must serve 3 missed turns!</p>
      </div>

      <div class="jail-stage" id="jailStage">
        <!-- Height Measurement Lines on Wall -->
        <div class="height-chart">
          <div class="height-line"><span class="height-label">6' 0"</span><span class="height-label right">6' 0"</span></div>
          <div class="height-line"><span class="height-label">5' 6"</span><span class="height-label right">5' 6"</span></div>
          <div class="height-line"><span class="height-label">5' 0"</span><span class="height-label right">5' 0"</span></div>
          <div class="height-line"><span class="height-label">4' 6"</span><span class="height-label right">4' 6"</span></div>
          <div class="height-line"><span class="height-label">4' 0"</span><span class="height-label right">4' 0"</span></div>
        </div>

        <!-- Guard Card (Burly King Police Officer) -->
        <div class="card" id="jailGuardCard">
          <div class="police-cap">
            <div class="cap-crown"></div>
            <div class="cap-visor"></div>
            <div class="cap-badge"></div>
          </div>
          <div class="face">
            <div class="corner"><span class="r">K</span><span class="s">\u2660</span></div>
            <div class="guard-mustache"></div>
            <div class="pip">\u2660</div>
            <div class="corner br"><span class="r">K</span><span class="s">\u2660</span></div>
          </div>
          <div class="guard-uniform">
            <div class="guard-badge">\u2B50</div>
          </div>
          <div class="guard-arm" id="guardArm">
            <span class="guard-hand">\u270A</span>
          </div>
          <div class="legs">
            <div class="leg l" id="guardLegL">
              <div class="thigh" id="guardThighL">
                <div class="shin" id="guardShinL">
                  <div class="foot"></div>
                </div>
              </div>
            </div>
            <div class="leg r" id="guardLegR">
              <div class="thigh" id="guardThighR">
                <div class="shin" id="guardShinR">
                  <div class="foot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Prisoner Card -->
        <div class="card" id="jailPrisonerCard" style="color: ${prisonerCard.isRed ? "var(--red)" : "var(--ink)"};">
          <div class="prisoner-sweat">\u{1F4A7}</div>
          <div class="face">
            <div class="corner"><span class="r">${prisonerCard.r}</span><span class="s">${prisonerCard.s}</span></div>
            <div class="pip">${prisonerCard.s}</div>
            <div class="corner br"><span class="r">${prisonerCard.r}</span><span class="s">${prisonerCard.s}</span></div>
          </div>
          <div class="convict-suit" id="convictSuit">
            <div class="convict-stencil">JAIL #CC-${jailHole}</div>
          </div>
          <div class="mugshot-plaque" id="mugshotPlaque">
            <div class="plaque-header">\u2605 COUNTY JAIL \u2605</div>
            <div class="plaque-name">${prisonerName}</div>
            <div class="plaque-booking">BOOKING #CC-${jailHole} \u2022 ${score} PTS</div>
            <div class="plaque-turns">SENTENCE: 3 MISSED TURNS</div>
          </div>
          <div class="legs" id="prisonerLegs">
            <div class="leg l" id="prisLegL">
              <div class="thigh" id="prisThighL">
                <div class="shin" id="prisShinL">
                  <div class="foot"></div>
                </div>
              </div>
            </div>
            <div class="leg r" id="prisLegR">
              <div class="thigh" id="prisThighR">
                <div class="shin" id="prisShinR">
                  <div class="foot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Camera Focus Reticle -->
        <div class="camera-reticle" id="cameraReticle">
          <div class="reticle-corner tl"></div>
          <div class="reticle-corner tr"></div>
          <div class="reticle-corner bl"></div>
          <div class="reticle-corner br"></div>
        </div>

        <!-- Floor -->
        <div class="jail-floor"></div>

        <!-- Iron Prison Cell Bars (Foreground) -->
        <div class="prison-bars-layer" id="prisonBarsLayer">
          <div class="bars-container">
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
            <div class="iron-bar"></div>
          </div>
          <div class="prison-beam top">
            <div class="prison-rivet"></div><div class="prison-rivet"></div><div class="prison-rivet"></div>
            <div class="prison-rivet"></div><div class="prison-rivet"></div><div class="prison-rivet"></div>
          </div>
          <div class="prison-beam bottom">
            <div class="prison-rivet"></div><div class="prison-rivet"></div><div class="prison-rivet"></div>
            <div class="prison-rivet"></div><div class="prison-rivet"></div><div class="prison-rivet"></div>
          </div>
        </div>

        <!-- Camera Flashbulb -->
        <div class="jail-flash" id="jailFlash"></div>
      </div>
    `;
    }
    mount() {
      let el = document.getElementById("jailAnimationOverlay");
      if (!el) {
        el = document.createElement("div");
        el.id = "jailAnimationOverlay";
        el.className = "jail-animation-overlay";
        document.body.appendChild(el);
      }
      this.overlayEl = el;
      this.overlayEl.innerHTML = this.buildHtml();
      const skipBtn = el.querySelector("#jailSkipBtn");
      if (skipBtn) {
        skipBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          this.close(true);
        });
      }
      el.addEventListener("click", () => {
        this.close(true);
      });
      window.addEventListener("keydown", this.handleKeyDown);
      requestAnimationFrame(() => {
        el.classList.add("active");
        this.startSequence();
      });
      this.safetyTimer = setTimeout(() => {
        this.close(true);
      }, 4800);
    }
    handleKeyDown(e) {
      if (e.key === "Escape" || e.key === " " || e.key === "Enter") {
        this.close(true);
      }
    }
    getAudio() {
      return typeof window !== "undefined" && window.audioManager ? window.audioManager : this.options.audioManager || null;
    }
    startSequence() {
      const stage = this.overlayEl.querySelector("#jailStage");
      const barsLayer = this.overlayEl.querySelector("#prisonBarsLayer");
      const guard = this.overlayEl.querySelector("#jailGuardCard");
      const prisoner = this.overlayEl.querySelector("#jailPrisonerCard");
      const reticle = this.overlayEl.querySelector("#cameraReticle");
      const flash = this.overlayEl.querySelector("#jailFlash");
      const guardThighL = this.overlayEl.querySelector("#guardThighL");
      const guardShinL = this.overlayEl.querySelector("#guardShinL");
      const guardThighR = this.overlayEl.querySelector("#guardThighR");
      const guardShinR = this.overlayEl.querySelector("#guardShinR");
      const prisThighL = this.overlayEl.querySelector("#prisThighL");
      const prisShinL = this.overlayEl.querySelector("#prisShinL");
      const prisThighR = this.overlayEl.querySelector("#prisThighR");
      const prisShinR = this.overlayEl.querySelector("#prisShinR");
      const sfx3 = this.getAudio();
      setTimeout(() => {
        if (barsLayer) barsLayer.classList.add("slammed");
        if (sfx3 && typeof sfx3.jailClang === "function") {
          sfx3.jailClang();
        } else if (sfx3 && typeof sfx3.reactionBoom === "function") {
          sfx3.reactionBoom();
        }
      }, 120);
      let startTime = performance.now();
      this.running = true;
      let grabbed = false;
      let flashed = false;
      let dragging = false;
      const loop = (now) => {
        if (!this.running) return;
        const elapsed = (now - startTime) / 1e3;
        const stageW = stage && stage.clientWidth || 800;
        const prisBaseX = stageW * 0.54;
        if (elapsed < 1.1) {
          const t = Math.max(0, (elapsed - 0.2) / 0.9);
          const guardX = -90 + t * (prisBaseX - 68 - -90);
          if (guard) {
            guard.style.left = `${guardX}px`;
          }
          const walkCycle = elapsed * 10;
          const thL = Math.sin(walkCycle) * 28;
          const thR = Math.sin(walkCycle + Math.PI) * 28;
          const shL = Math.max(0, -Math.sin(walkCycle) * 35);
          const shR = Math.max(0, -Math.sin(walkCycle + Math.PI) * 35);
          if (guardThighL) guardThighL.style.transform = `rotate(${thL}deg)`;
          if (guardShinL) guardShinL.style.transform = `rotate(${shL}deg)`;
          if (guardThighR) guardThighR.style.transform = `rotate(${thR}deg)`;
          if (guardShinR) guardShinR.style.transform = `rotate(${shR}deg)`;
          if (prisThighL) prisThighL.style.transform = "rotate(0deg)";
          if (prisShinL) prisShinL.style.transform = "rotate(0deg)";
          if (prisThighR) prisThighR.style.transform = "rotate(0deg)";
          if (prisShinR) prisShinR.style.transform = "rotate(0deg)";
        } else if (elapsed < 2.1) {
          if (guard) {
            guard.style.left = `${prisBaseX - 68}px`;
          }
          if (!grabbed) {
            grabbed = true;
            if (prisoner) {
              prisoner.classList.add("has-suit");
              prisoner.classList.add("has-plaque");
            }
            if (reticle) reticle.classList.add("active");
            if (sfx3 && typeof sfx3.snap === "function") sfx3.snap();
          }
          const kickTime = elapsed - 1.1;
          const liftY = -26 + Math.sin(kickTime * 14) * 4;
          const bodyRot = Math.sin(kickTime * 16) * 7;
          if (prisoner) {
            prisoner.style.transform = `translateX(-50%) translateY(${liftY}px) rotate(${bodyRot}deg)`;
          }
          const kickRate = 22;
          const kickL = Math.sin(kickTime * kickRate);
          const kickR = Math.sin(kickTime * kickRate + Math.PI);
          const pThL = -25 + kickL * 42;
          const pShL = 30 + Math.max(0, -kickL * 65);
          const pThR = -25 + kickR * 42;
          const pShR = 30 + Math.max(0, -kickR * 65);
          if (prisThighL) prisThighL.style.transform = `rotate(${pThL}deg)`;
          if (prisShinL) prisShinL.style.transform = `rotate(${pShL}deg)`;
          if (prisThighR) prisThighR.style.transform = `rotate(${pThR}deg)`;
          if (prisShinR) prisShinR.style.transform = `rotate(${pShR}deg)`;
          if (guardThighL) guardThighL.style.transform = "rotate(-4deg)";
          if (guardShinL) guardShinL.style.transform = "rotate(4deg)";
          if (guardThighR) guardThighR.style.transform = "rotate(8deg)";
          if (guardShinR) guardShinR.style.transform = "rotate(2deg)";
        } else if (elapsed < 2.5) {
          if (!flashed) {
            flashed = true;
            if (flash) flash.classList.add("active");
            if (reticle) reticle.classList.remove("active");
            if (sfx3 && typeof sfx3.cameraShutter === "function") {
              sfx3.cameraShutter();
            } else if (sfx3 && typeof sfx3.confettiPop === "function") {
              sfx3.confettiPop();
            }
            setTimeout(() => {
              if (flash) flash.classList.remove("active");
            }, 140);
          }
          if (prisoner) {
            prisoner.style.transform = `translateX(-50%) translateY(-22px) rotate(-3deg)`;
          }
          if (prisThighL) prisThighL.style.transform = "rotate(-18deg)";
          if (prisShinL) prisShinL.style.transform = "rotate(45deg)";
          if (prisThighR) prisThighR.style.transform = "rotate(22deg)";
          if (prisShinR) prisShinR.style.transform = "rotate(15deg)";
        } else if (elapsed < 3.3) {
          if (!dragging) dragging = true;
          const dragProgress = (elapsed - 2.5) / 0.8;
          const exitOffset = dragProgress * (stageW * 0.45);
          const guardCurX = prisBaseX - 80 + exitOffset;
          if (guard) guard.style.left = `${guardCurX}px`;
          const prisCurX = prisBaseX + exitOffset;
          const dragLift = -20 + Math.sin(elapsed * 12) * 5;
          const dragRot = 12 + Math.sin(elapsed * 14) * 6;
          if (prisoner) {
            prisoner.style.left = `${prisCurX}px`;
            prisoner.style.transform = `translateX(-50%) translateY(${dragLift}px) rotate(${dragRot}deg)`;
          }
          const dragKickRate = 18;
          const dkL = Math.sin(elapsed * dragKickRate);
          const dkR = Math.sin(elapsed * dragKickRate + Math.PI);
          if (prisThighL) prisThighL.style.transform = `rotate(${-15 + dkL * 35}deg)`;
          if (prisShinL) prisShinL.style.transform = `rotate(${25 + Math.max(0, -dkL * 55)}deg)`;
          if (prisThighR) prisThighR.style.transform = `rotate(${-15 + dkR * 35}deg)`;
          if (prisShinR) prisShinR.style.transform = `rotate(${25 + Math.max(0, -dkR * 55)}deg)`;
          const gWalk = elapsed * 8;
          if (guardThighL) guardThighL.style.transform = `rotate(${Math.sin(gWalk) * 22}deg)`;
          if (guardShinL) guardShinL.style.transform = `rotate(${Math.max(0, -Math.sin(gWalk) * 28)}deg)`;
          if (guardThighR) guardThighR.style.transform = `rotate(${Math.sin(gWalk + Math.PI) * 22}deg)`;
          if (guardShinR) guardShinR.style.transform = `rotate(${Math.max(0, -Math.sin(gWalk + Math.PI) * 28)}deg)`;
        } else {
          this.close(true);
          return;
        }
        this.raf = requestAnimationFrame(loop);
      };
      this.raf = requestAnimationFrame(loop);
    }
    close(triggerCallback = true) {
      if (this.safetyTimer) {
        clearTimeout(this.safetyTimer);
        this.safetyTimer = null;
      }
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      if (this.raf) {
        cancelAnimationFrame(this.raf);
        this.raf = 0;
      }
      this.running = false;
      window.removeEventListener("keydown", this.handleKeyDown);
      if (this.overlayEl) {
        this.overlayEl.classList.remove("active");
        setTimeout(() => {
          if (this.overlayEl && this.overlayEl.parentNode) {
            this.overlayEl.parentNode.removeChild(this.overlayEl);
          }
          this.overlayEl = null;
        }, 300);
      }
      if (activeJailOverlayInstance === this) {
        activeJailOverlayInstance = null;
      }
      if (triggerCallback && typeof this.onComplete === "function") {
        const cb = this.onComplete;
        this.onComplete = null;
        cb();
      }
    }
  };

  // src/ui/BarAnimationOverlay.js
  var activeBarOverlayInstance = null;
  var BarAnimationOverlay = class _BarAnimationOverlay {
    /**
     * Displays the Saloon Bar Slide animation in an interactive overlay.
     *
     * @param {Object} [options]
     * @param {string} [options.playerName] - Name of player at the bar (e.g. "You", "Computer")
     * @param {string} [options.who] - Seat ID ('p1', 'p2', etc.)
     * @param {number} [options.barHole] - The board hole number of the bar/drink space
     * @param {Object} [options.card] - Card object { r, s } representing the player's card
     * @param {Object} [options.settings] - Game settings object
     * @param {boolean} [options.isDrinkSpace] - True if triggered by a Pints & Pegs drinking tile
     * @param {Function} [options.onComplete] - Callback on dismiss or completion
     * @returns {BarAnimationOverlay|null}
     */
    static show(options = {}) {
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3 && (settings3.barAnimation === "no" || settings3.barAnimation === "off" || settings3.barAnimation === false)) {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (typeof document === "undefined") {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (activeBarOverlayInstance) {
        activeBarOverlayInstance.close(false);
      }
      const instance = new _BarAnimationOverlay(options);
      activeBarOverlayInstance = instance;
      instance.mount();
      return instance;
    }
    static hide() {
      if (activeBarOverlayInstance) {
        activeBarOverlayInstance.close(true);
      }
    }
    constructor(options = {}) {
      this.options = options;
      this.onComplete = options.onComplete || (() => {
      });
      this.overlayEl = null;
      this.autoCloseTimer = null;
      this.bubbleTimer = null;
      this.stepTimers = [];
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    formatCard(card, fallbackRank = "J", fallbackSuit = "\u2660") {
      if (!card) {
        return { r: fallbackRank, s: fallbackSuit, isRed: fallbackSuit === "\u2665" || fallbackSuit === "\u2666" };
      }
      if (Array.isArray(card) && card.length > 0) {
        card = card[card.length - 1];
      }
      if (typeof card === "string") {
        const match = card.match(/^([0-9AJQK]+)([HDSC♥♦♠♣]?)$/i);
        if (match) {
          card = { r: match[1], s: match[2] };
        }
      }
      let r = card.r !== void 0 ? card.r : card.rank !== void 0 ? card.rank : fallbackRank;
      if (r === 1 || r === "1") r = "A";
      else if (r === 11 || r === "11") r = "J";
      else if (r === 12 || r === "12") r = "Q";
      else if (r === 13 || r === "13") r = "K";
      r = String(r).toUpperCase();
      let s = card.s || card.suit || fallbackSuit;
      if (s === "H" || s === "h") s = "\u2665";
      else if (s === "D" || s === "d") s = "\u2666";
      else if (s === "S" || s === "s") s = "\u2660";
      else if (s === "C" || s === "c") s = "\u2663";
      const isRed = s === "\u2665" || s === "\u2666";
      return { r, s, isRed };
    }
    buildHtml() {
      const playerName = this.options.playerName || "Player";
      const barHole = this.options.barHole !== void 0 ? this.options.barHole : 40;
      const isDrink = Boolean(this.options.isDrinkSpace);
      const card = this.formatCard(this.options.card, "J", "\u2660");
      const badgeText = isDrink ? "\u{1F37B} DRINK SPACE! SOCIAL CALL" : "\u{1F37A} THE BAR TRAP! TIME TO CHUG";
      const titleText = isDrink ? `${playerName} Takes a Drink!` : `${playerName} Pulled Up to The Bar!`;
      const subText = isDrink ? `Landed on Drinking Space at Hole ${barHole} \u2014 Bottoms up!` : `Landed on Bar Hole ${barHole} \u2014 Serving a 3-turn sentence!`;
      return `
      <div class="tavern-ambient-glow"></div>
      <button class="bar-skip-btn" id="barSkipBtn" type="button" title="Skip animation (Esc)">Skip \u2715</button>

      <div class="bar-banner">
        <span class="bar-badge">${badgeText}</span>
        <h2 class="bar-title">${titleText}</h2>
        <p class="bar-subtitle">${subText}</p>
      </div>

      <div class="bar-stage" id="barStage">
        <!-- Saloon Back Wall with Shelves & Bottles -->
        <div class="saloon-backwall">
          <div class="bottle-shelf">
            <div class="bottles-row">
              <div class="bottle amber"></div>
              <div class="bottle green"></div>
              <div class="bottle brown"></div>
              <div class="bottle amber"></div>
              <div class="bottle green"></div>
              <div class="bottle brown"></div>
              <div class="bottle amber"></div>
            </div>
          </div>
        </div>

        <!-- 3D Saloon Swinging Doors (Batwing Doors) -->
        <div class="saloon-door-wrap left">
          <div class="saloon-door" id="saloonDoorL">
            <div class="door-hinge top"></div>
            <div class="door-hinge bottom"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
          </div>
        </div>
        <div class="saloon-door-wrap right">
          <div class="saloon-door" id="saloonDoorR">
            <div class="door-hinge top"></div>
            <div class="door-hinge bottom"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
            <div class="door-slat"></div>
          </div>
        </div>

        <!-- Wooden Bar Counter Surface -->
        <div class="bar-counter-surface" id="barCounter">
          <div class="counter-top-rim"></div>
          <div class="brass-rail"></div>
        </div>

        <!-- Frothy Overflowing Beer Mug Stein -->
        <div class="beer-mug" id="beerMug">
          <div class="mug-handle"></div>
          <div class="mug-glass">
            <div class="beer-liquid" id="beerLiquid">
              <div class="fizz-bubble"></div>
              <div class="fizz-bubble"></div>
              <div class="fizz-bubble"></div>
            </div>
          </div>
          <div class="beer-foam">
            <div class="foam-bubble b1"></div>
            <div class="foam-bubble b2"></div>
            <div class="foam-bubble b3"></div>
            <div class="foam-drip d1"></div>
            <div class="foam-drip d2"></div>
          </div>
        </div>

        <!-- The Player's Card with Wobbly Noodle IK Legs -->
        <div class="player-card ${card.isRed ? "red" : "black"}" id="barPlayerCard">
          <div class="corner tl">
            <span class="r">${card.r}</span>
            <span class="s">${card.s}</span>
          </div>

          <div class="card-face-center">
            <span class="main-pip" id="barCardPip">${card.s}</span>
            <!-- Hypnotic Spinning Spiral Eyes -->
            <div class="drunken-eyes" id="drunkenEyes">
              <svg class="spiral-eye" viewBox="0 0 100 100">
                <path d="M 50,50 A 5,5 0 0,1 55,50 A 10,10 0 0,1 45,50 A 15,15 0 0,1 60,50 A 20,20 0 0,1 40,50 A 25,25 0 0,1 65,50 A 30,30 0 0,1 35,50 A 35,35 0 0,1 70,50"
                      fill="none" stroke="#dc2626" stroke-width="8" stroke-linecap="round" />
              </svg>
              <svg class="spiral-eye" viewBox="0 0 100 100">
                <path d="M 50,50 A 5,5 0 0,1 55,50 A 10,10 0 0,1 45,50 A 15,15 0 0,1 60,50 A 20,20 0 0,1 40,50 A 25,25 0 0,1 65,50 A 30,30 0 0,1 35,50 A 35,35 0 0,1 70,50"
                      fill="none" stroke="#dc2626" stroke-width="8" stroke-linecap="round" />
              </svg>
            </div>
            <!-- Rosy Drunken Cheeks -->
            <div class="drunk-cheeks">
              <div class="cheek"></div>
              <div class="cheek"></div>
            </div>
            <!-- Foamy Mustache -->
            <div class="foam-mustache" id="foamMustache"></div>
          </div>

          <div class="corner br">
            <span class="r">${card.r}</span>
            <span class="s">${card.s}</span>
          </div>

          <!-- Rubber Noodle IK Legs -->
          <div class="noodle-legs" id="noodleLegs">
            <div class="noodle-leg left" id="legLeft">
              <div class="segment thigh">
                <div class="segment shin">
                  <div class="foot"></div>
                </div>
              </div>
            </div>
            <div class="noodle-leg right" id="legRight">
              <div class="segment thigh">
                <div class="segment shin">
                  <div class="foot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Classic Round Bar Stool -->
        <div class="bar-stool" id="barStool">
          <div class="stool-seat"></div>
          <div class="stool-legs">
            <div class="leg l"></div>
            <div class="leg r"></div>
            <div class="rung top"></div>
            <div class="rung bottom"></div>
          </div>
        </div>
      </div>
    `;
    }
    mount() {
      let el = document.getElementById("barAnimationOverlay");
      if (!el) {
        el = document.createElement("div");
        el.id = "barAnimationOverlay";
        el.className = "bar-animation-overlay";
        el.setAttribute("role", "dialog");
        el.setAttribute("aria-modal", "true");
        el.setAttribute("aria-label", "The Saloon Bar Slide Animation");
        document.body.appendChild(el);
      }
      this.overlayEl = el;
      el.innerHTML = this.buildHtml();
      const skipBtn = el.querySelector("#barSkipBtn");
      if (skipBtn) {
        skipBtn.addEventListener("click", () => this.close(true));
      }
      window.addEventListener("keydown", this.handleKeyDown);
      void el.offsetWidth;
      el.classList.add("active");
      this.startChoreography();
    }
    getAudio() {
      return typeof window !== "undefined" && (window.audio || window.CC && window.CC.audio) || null;
    }
    startChoreography() {
      const audio = this.getAudio();
      if (audio && typeof audio.saloonDoorKick === "function") {
        audio.saloonDoorKick();
      }
      this.scheduleStep(450, () => {
        if (audio && typeof audio.barMugSlide === "function") {
          audio.barMugSlide();
        }
      });
      this.scheduleStep(1150, () => {
        if (audio && typeof audio.glassClink === "function") {
          audio.glassClink();
        }
        const card = this.overlayEl?.querySelector("#barPlayerCard");
        if (card) card.classList.add("is-bumped");
        this.spawnBeerSplash();
      });
      this.scheduleStep(1450, () => {
        const mug = this.overlayEl?.querySelector("#beerMug");
        const card = this.overlayEl?.querySelector("#barPlayerCard");
        if (mug) mug.classList.add("is-chugging");
        if (card) card.classList.add("has-foam");
        if (audio && typeof audio.beerGulp === "function") {
          audio.beerGulp();
        }
      });
      this.scheduleStep(2450, () => {
        const card = this.overlayEl?.querySelector("#barPlayerCard");
        if (card) {
          card.classList.remove("is-bumped");
          card.classList.add("is-dizzy");
        }
        if (audio && typeof audio.drunkenHiccup === "function") {
          audio.drunkenHiccup();
        }
      });
      this.scheduleStep(2650, () => {
        const card = this.overlayEl?.querySelector("#barPlayerCard");
        if (card) card.classList.add("is-staggering");
      });
      this.scheduleStep(3400, () => {
        const card = this.overlayEl?.querySelector("#barPlayerCard");
        if (card) {
          card.classList.remove("is-staggering");
          card.classList.add("is-collapsed");
        }
        if (audio && typeof audio.stoolCollapseThud === "function") {
          audio.stoolCollapseThud();
        }
        this.spawnFloatingBubbles();
      });
      this.autoCloseTimer = setTimeout(() => {
        this.close(true);
      }, 4850);
    }
    scheduleStep(delay, fn) {
      const t = setTimeout(fn, delay);
      this.stepTimers.push(t);
    }
    spawnBeerSplash() {
      const stage = this.overlayEl?.querySelector("#barStage");
      if (!stage) return;
      for (let i = 0; i < 7; i++) {
        const drop = document.createElement("div");
        drop.className = "beer-splash animate";
        drop.style.left = "48%";
        drop.style.bottom = "195px";
        const angle = Math.PI / 6 + Math.random() * Math.PI * 0.7;
        const dist2 = 30 + Math.random() * 55;
        const tx = Math.cos(angle) * dist2;
        const ty = -Math.sin(angle) * dist2;
        drop.style.setProperty("--tx", `${tx}px`);
        drop.style.setProperty("--ty", `${ty}px`);
        stage.appendChild(drop);
        setTimeout(() => drop.remove(), 700);
      }
    }
    spawnFloatingBubbles() {
      const stage = this.overlayEl?.querySelector("#barStage");
      const audio = this.getAudio();
      if (!stage) return;
      const stool = stage.querySelector("#barStool");
      const stoolRect = stool ? stool.getBoundingClientRect() : null;
      const stageRect = stage.getBoundingClientRect();
      const baseX = stoolRect ? stoolRect.left - stageRect.left + stoolRect.width * 0.5 : stage.offsetWidth * 0.75;
      const baseY = 160;
      for (let i = 0; i < 8; i++) {
        setTimeout(() => {
          if (!this.overlayEl) return;
          const b = document.createElement("div");
          b.className = "saloon-bubble";
          const sz = 16 + Math.random() * 22;
          b.style.width = `${sz}px`;
          b.style.height = `${sz}px`;
          b.style.left = `${baseX + (Math.random() * 60 - 30)}px`;
          b.style.bottom = `${baseY + Math.random() * 30}px`;
          b.style.setProperty("--bx", `${Math.random() * 40 - 20}px`);
          stage.appendChild(b);
          const popDelay = 1200 + Math.random() * 1200;
          setTimeout(() => {
            if (b.parentNode) {
              b.classList.add("popped");
              if (audio && typeof audio.bubblePop === "function") {
                audio.bubblePop();
              }
              setTimeout(() => b.remove(), 200);
            }
          }, popDelay);
          setTimeout(() => {
            if (b.parentNode) b.remove();
          }, 3e3);
        }, i * 160);
      }
    }
    handleKeyDown(e) {
      if (e.key === "Escape" || e.key === "Esc" || e.key === "Enter" || e.key === " ") {
        this.close(true);
      }
    }
    close(triggerCallback = true) {
      window.removeEventListener("keydown", this.handleKeyDown);
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      this.stepTimers.forEach((t) => clearTimeout(t));
      this.stepTimers = [];
      if (this.overlayEl) {
        this.overlayEl.classList.remove("active");
        setTimeout(() => {
          if (this.overlayEl && this.overlayEl.parentNode) {
            this.overlayEl.parentNode.removeChild(this.overlayEl);
          }
          this.overlayEl = null;
        }, 320);
      }
      if (activeBarOverlayInstance === this) {
        activeBarOverlayInstance = null;
      }
      if (triggerCallback && typeof this.onComplete === "function") {
        const cb = this.onComplete;
        this.onComplete = null;
        try {
          cb();
        } catch (err) {
          console.error("[BarAnimationOverlay] onComplete error:", err);
        }
      }
    }
  };

  // src/ui/CannonAnimationOverlay.js
  var activeCannonOverlayInstance = null;
  var CannonAnimationOverlay = class _CannonAnimationOverlay {
    /**
     * Displays the ACME Human Cannonball animation overlay.
     *
     * @param {Object} [options]
     * @param {string} [options.playerName] - Name of player jumping (e.g. "You", "Computer")
     * @param {string} [options.who] - Seat ID ('p1', 'p2', etc.)
     * @param {number} [options.fromHole] - Jump launch/spring hole
     * @param {number} [options.toHole] - Destination landing hole
     * @param {number} [options.diff] - Net score difference
     * @param {boolean} [options.isForward] - True if jumping forward
     * @param {Object} [options.card] - Card object { r, s } representing the player's card
     * @param {Object} [options.settings] - Game settings object
     * @param {Function} [options.onComplete] - Callback on dismiss or completion
     * @returns {CannonAnimationOverlay|null}
     */
    static show(options = {}) {
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3) {
        const cannonVal = settings3.jumpAnimation !== void 0 ? settings3.jumpAnimation : settings3.cannonAnimation;
        if (cannonVal === "no" || cannonVal === "off" || cannonVal === false) {
          if (typeof options.onComplete === "function") options.onComplete();
          return null;
        }
      }
      if (typeof document === "undefined") {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (activeCannonOverlayInstance) {
        activeCannonOverlayInstance.close(false);
      }
      const instance = new _CannonAnimationOverlay(options);
      activeCannonOverlayInstance = instance;
      instance.mount();
      return instance;
    }
    static hide() {
      if (activeCannonOverlayInstance) {
        activeCannonOverlayInstance.close(true);
      }
    }
    constructor(options = {}) {
      this.options = options;
      this.onComplete = options.onComplete || (() => {
      });
      this.overlayEl = null;
      this.autoCloseTimer = null;
      this.stepTimers = [];
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    formatCard(card, fallbackRank = "J", fallbackSuit = "\u2660") {
      if (!card) {
        return { r: fallbackRank, s: fallbackSuit, isRed: fallbackSuit === "\u2665" || fallbackSuit === "\u2666" };
      }
      if (Array.isArray(card) && card.length > 0) {
        card = card[card.length - 1];
      }
      if (typeof card === "string") {
        const match = card.match(/^([0-9AJQK]+)([HDSC♥♦♠♣]?)$/i);
        if (match) {
          card = { r: match[1], s: match[2] };
        }
      }
      let r = card.r !== void 0 ? card.r : card.rank !== void 0 ? card.rank : fallbackRank;
      if (r === 1 || r === "1") r = "A";
      else if (r === 11 || r === "11") r = "J";
      else if (r === 12 || r === "12") r = "Q";
      else if (r === 13 || r === "13") r = "K";
      r = String(r).toUpperCase();
      let s = card.s || card.suit || fallbackSuit;
      if (s === "H" || s === "h") s = "\u2665";
      else if (s === "D" || s === "d") s = "\u2666";
      else if (s === "S" || s === "s") s = "\u2660";
      else if (s === "C" || s === "c") s = "\u2663";
      const isRed = s === "\u2665" || s === "\u2666";
      return { r, s, isRed };
    }
    buildHtml() {
      const pName2 = this.options.playerName || "Player";
      const fromHole = this.options.fromHole !== void 0 ? this.options.fromHole : 15;
      const toHole = this.options.toHole !== void 0 ? this.options.toHole : 35;
      const diff = this.options.diff !== void 0 ? this.options.diff : toHole - fromHole;
      const diffStr = diff > 0 ? `+${diff}` : `${diff}`;
      const card = this.formatCard(this.options.card, "K", "\u2660");
      return `
      <div class="sky-ambient-glow" aria-hidden="true"></div>

      <!-- Skip Button -->
      <button type="button" class="cannon-skip-btn" id="cannonSkipBtn" aria-label="Skip Jump Animation">
        Skip \u2715
      </button>

      <!-- Banner Header -->
      <div class="cannon-banner">
        <div class="cannon-badge">
          <span>\u{1F680} ACME HUMAN CANNONBALL!</span>
        </div>
        <h2 class="cannon-title">${pName2} Launched Into The Stratosphere!</h2>
        <div class="cannon-subtitle">
          Jump Spring Hole ${fromHole} \u2794 Destination Hole ${toHole} (${diffStr} Holes!)
        </div>
      </div>

      <!-- The Main Cannon Arena Stage -->
      <div class="cannon-stage" id="cannonStage">
        <div class="stage-sky-stars" aria-hidden="true"></div>

        <!-- Parabolic Trajectory Flight Arc SVG -->
        <svg class="parabolic-flight-svg" id="trajectorySvg" viewBox="0 0 860 440" preserveAspectRatio="none">
          <path class="trajectory-line" d="M 180 320 Q 480 80 770 380" />
        </svg>

        <!-- Destination Target Hole Crater (Right Side) -->
        <div class="destination-crater" id="destCrater">
          <div class="crater-rim"></div>
          <div class="hole-badge">Hole ${toHole}</div>
        </div>

        <!-- Arena Ground Track with Peg Hole Markers -->
        <div class="stage-ground">
          <div class="ground-track-holes">
            <span class="track-dot"></span>
            <span class="track-dot"></span>
            <span class="track-dot"></span>
            <span class="track-dot"></span>
            <span class="track-dot"></span>
            <span class="track-dot"></span>
            <span class="track-dot"></span>
            <span class="track-dot"></span>
            <span class="track-dot"></span>
            <span class="track-dot"></span>
          </div>
        </div>

        <!-- Digital / Comic Countdown: 3... 2... 1... KABOOM! -->
        <div class="cannon-countdown" id="cannonCountdown">3</div>

        <!-- Explosive Muzzle Blast Flash -->
        <div class="muzzle-blast-flash" id="muzzleFlash"></div>

        <!-- The ACME Striped Cannon Container -->
        <div class="acme-cannon-wrap" id="acmeCannon">
          <!-- Rear Spoked Wheel -->
          <div class="cannon-wheel back">
            <div class="wheel-hub"></div>
          </div>

          <!-- Heavy Iron Carriage -->
          <div class="cannon-carriage">
            <span class="acme-stencil">ACME</span>
          </div>

          <!-- Red & Yellow Striped Barrel -->
          <div class="cannon-barrel">
            <div class="muzzle-ring"></div>
            <div class="muzzle-cavity"></div>

            <!-- Gunpowder Fuse on Breech -->
            <div class="cannon-fuse burning" id="cannonFuse">
              <div class="fuse-spark"></div>
            </div>

            <!-- Card Stuffed Inside Cannon (Feet Kicking Out Muzzle) -->
            <div class="card-in-cannon visible kicking" id="cardInCannon">
              <div class="cannon-legs">
                <div class="c-leg l"><div class="c-foot"></div></div>
                <div class="c-leg r"><div class="c-foot"></div></div>
              </div>
            </div>
          </div>

          <!-- Front Spoked Wheel -->
          <div class="cannon-wheel front">
            <div class="wheel-hub"></div>
          </div>
        </div>

        <!-- The Flying Card in Stratospheric Flight -->
        <div class="flying-card ${card.isRed ? "red" : "black"}" id="flyingCard">
          <div class="aviator-cap">
            <div class="goggle-lens"></div>
            <div class="goggle-lens"></div>
          </div>
          <div class="corner tl">
            <span class="r">${card.r}</span>
            <span class="s">${card.s}</span>
          </div>
          <div class="card-rank-center">
            <span class="p-pip">${card.s}</span>
          </div>
          <div class="corner br">
            <span class="r">${card.r}</span>
            <span class="s">${card.s}</span>
          </div>
        </div>

        <!-- Lawn-Dart Card Stuck Head-First in Destination Crater -->
        <div class="lawn-dart-card ${card.isRed ? "red" : "black"}" id="lawnDartCard">
          <div class="lawn-dart-legs">
            <div class="d-leg"><div class="d-foot"></div></div>
            <div class="d-leg"><div class="d-foot"></div></div>
          </div>
          <div class="card-rank-center">
            <span class="p-pip">${card.s}</span>
          </div>
          <div class="corner br">
            <span class="r">${card.r}</span>
            <span class="s">${card.s}</span>
          </div>
        </div>

        <!-- Impact Shockwave Rings -->
        <div class="impact-shockwave" id="impactShockwave"></div>

        <!-- Dizzy Golden Cartoon Stars Halo -->
        <div class="dizzy-stars-halo" id="dizzyStarsHalo">
          <span class="cartoon-star">\u2B50</span>
          <span class="cartoon-star">\u2728</span>
          <span class="cartoon-star">\u2B50</span>
          <span class="cartoon-star">\u2728</span>
        </div>
      </div>
    `;
    }
    mount() {
      let el = document.getElementById("cannonAnimationOverlay");
      if (!el) {
        el = document.createElement("div");
        el.id = "cannonAnimationOverlay";
        el.className = "cannon-animation-overlay";
        el.setAttribute("role", "dialog");
        el.setAttribute("aria-modal", "true");
        el.setAttribute("aria-label", "ACME Human Cannonball Jump Animation");
        document.body.appendChild(el);
      }
      this.overlayEl = el;
      el.innerHTML = this.buildHtml();
      const skipBtn = el.querySelector("#cannonSkipBtn");
      if (skipBtn) {
        skipBtn.addEventListener("click", () => this.close(true));
      }
      window.addEventListener("keydown", this.handleKeyDown);
      void el.offsetWidth;
      el.classList.add("active");
      this.startChoreography();
    }
    getAudio() {
      return typeof window !== "undefined" && (window.audio || window.audioManager || window.sfx || window.CC && (window.CC.audio || window.CC.audioManager || window.CC.sfx)) || null;
    }
    startChoreography() {
      const audio = this.getAudio();
      if (audio && typeof audio.cannonRollWheel === "function") {
        audio.cannonRollWheel();
      }
      if (audio && typeof audio.cannonFuseHiss === "function") {
        audio.cannonFuseHiss();
      }
      this.scheduleStep(450, () => {
        const cd = this.overlayEl?.querySelector("#cannonCountdown");
        if (cd) {
          cd.textContent = "3...";
          cd.classList.add("active");
        }
      });
      this.scheduleStep(850, () => {
        const cd = this.overlayEl?.querySelector("#cannonCountdown");
        if (cd) {
          cd.textContent = "2...";
          cd.classList.remove("active");
          void cd.offsetWidth;
          cd.classList.add("active");
        }
      });
      this.scheduleStep(1250, () => {
        const cd = this.overlayEl?.querySelector("#cannonCountdown");
        if (cd) {
          cd.textContent = "1...";
          cd.classList.remove("active");
          void cd.offsetWidth;
          cd.classList.add("active");
        }
      });
      this.scheduleStep(1600, () => {
        const cannon = this.overlayEl?.querySelector("#acmeCannon");
        const cd = this.overlayEl?.querySelector("#cannonCountdown");
        const flash = this.overlayEl?.querySelector("#muzzleFlash");
        const cardInCannon = this.overlayEl?.querySelector("#cardInCannon");
        const flyingCard = this.overlayEl?.querySelector("#flyingCard");
        const trajectory = this.overlayEl?.querySelector("#trajectorySvg");
        if (cd) {
          cd.textContent = "\u{1F4A5} KABOOM!";
          cd.style.color = "#ef4444";
        }
        if (cannon) cannon.classList.add("recoil");
        if (flash) flash.classList.add("boom");
        if (cardInCannon) cardInCannon.classList.remove("visible");
        this.spawnBlastSmoke();
        if (audio && typeof audio.cannonKaboom === "function") {
          audio.cannonKaboom();
        }
        setTimeout(() => {
          if (flyingCard) flyingCard.classList.add("in-flight");
          if (trajectory) trajectory.classList.add("active");
          if (audio && typeof audio.cannonFlightWhistle === "function") {
            audio.cannonFlightWhistle();
          }
        }, 50);
      });
      this.scheduleStep(2850, () => {
        const flyingCard = this.overlayEl?.querySelector("#flyingCard");
        const lawnDart = this.overlayEl?.querySelector("#lawnDartCard");
        const shockwave = this.overlayEl?.querySelector("#impactShockwave");
        const trajectory = this.overlayEl?.querySelector("#trajectorySvg");
        if (flyingCard) flyingCard.style.opacity = "0";
        if (trajectory) trajectory.classList.remove("active");
        if (lawnDart) lawnDart.classList.add("impact");
        if (shockwave) shockwave.classList.add("active");
        this.spawnImpactDust();
        if (audio && typeof audio.lawnDartThud === "function") {
          audio.lawnDartThud();
        }
      });
      this.scheduleStep(3150, () => {
        const starsHalo = this.overlayEl?.querySelector("#dizzyStarsHalo");
        if (starsHalo) starsHalo.classList.add("active");
        if (audio && typeof audio.dizzyStarsChime === "function") {
          audio.dizzyStarsChime();
        }
      });
      this.autoCloseTimer = setTimeout(() => {
        this.close(true);
      }, 4650);
    }
    scheduleStep(delay, fn) {
      const t = setTimeout(fn, delay);
      this.stepTimers.push(t);
    }
    spawnBlastSmoke() {
      const stage = this.overlayEl?.querySelector("#cannonStage");
      if (!stage) return;
      for (let i = 0; i < 9; i++) {
        const puff = document.createElement("div");
        puff.className = "cannon-smoke-puff";
        const sz = 24 + Math.random() * 38;
        puff.style.width = `${sz}px`;
        puff.style.height = `${sz}px`;
        puff.style.left = "160px";
        puff.style.bottom = "115px";
        const angle = Math.PI * -0.3 + Math.random() * Math.PI * 0.6;
        const dist2 = 40 + Math.random() * 80;
        const sx = Math.cos(angle) * dist2;
        const sy = Math.sin(angle) * dist2;
        puff.style.setProperty("--sx", `${sx}px`);
        puff.style.setProperty("--sy", `${sy}px`);
        stage.appendChild(puff);
        setTimeout(() => puff.remove(), 900);
      }
    }
    spawnImpactDust() {
      const stage = this.overlayEl?.querySelector("#cannonStage");
      if (!stage) return;
      for (let i = 0; i < 7; i++) {
        const puff = document.createElement("div");
        puff.className = "cannon-smoke-puff";
        const sz = 18 + Math.random() * 26;
        puff.style.width = `${sz}px`;
        puff.style.height = `${sz}px`;
        puff.style.right = "80px";
        puff.style.bottom = "55px";
        const angle = Math.PI * 0.1 + Math.random() * Math.PI * 0.8;
        const dist2 = 25 + Math.random() * 50;
        const sx = (Math.random() - 0.5) * 60;
        const sy = -Math.sin(angle) * dist2;
        puff.style.setProperty("--sx", `${sx}px`);
        puff.style.setProperty("--sy", `${sy}px`);
        stage.appendChild(puff);
        setTimeout(() => puff.remove(), 800);
      }
    }
    handleKeyDown(e) {
      if (e.key === "Escape" || e.key === "Esc" || e.key === "Enter" || e.key === " ") {
        this.close(true);
      }
    }
    close(triggerCallback = true) {
      window.removeEventListener("keydown", this.handleKeyDown);
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      this.stepTimers.forEach((t) => clearTimeout(t));
      this.stepTimers = [];
      if (this.overlayEl) {
        this.overlayEl.classList.remove("active");
        setTimeout(() => {
          if (this.overlayEl && this.overlayEl.parentNode) {
            this.overlayEl.parentNode.removeChild(this.overlayEl);
          }
          this.overlayEl = null;
        }, 320);
      }
      if (activeCannonOverlayInstance === this) {
        activeCannonOverlayInstance = null;
      }
      if (triggerCallback && typeof this.onComplete === "function") {
        const cb = this.onComplete;
        this.onComplete = null;
        try {
          cb();
        } catch (err) {
          console.error("[CannonAnimationOverlay] onComplete error:", err);
        }
      }
    }
  };

  // src/ui/SpeedTrapAnimationOverlay.js
  var activeSpeedTrapInstance = null;
  var SpeedTrapAnimationOverlay = class _SpeedTrapAnimationOverlay {
    /**
     * Displays the Speed Trap Radar animation overlay.
     *
     * @param {Object} [options]
     * @param {string} [options.playerName] - Name of player stopped (e.g. "You", "The Shark")
     * @param {string} [options.who] - Seat ID ('p1', 'p2', etc.)
     * @param {string} [options.reason] - 'stop_sign' | 'no_passing_lane'
     * @param {number} [options.hole] - Hole number where vehicle was halted
     * @param {number} [options.ptsScored] - Points allowed through
     * @param {number} [options.ptsLost] - Points confiscated / lost
     * @param {string} [options.blockerName] - Name of vehicle blocking (if no passing lane)
     * @param {Object} [options.card] - Card object { r, s } representing the player's card
     * @param {Object} [options.settings] - Game settings object
     * @param {Function} [options.onComplete] - Callback on dismiss or completion
     * @returns {SpeedTrapAnimationOverlay|null}
     */
    static show(options = {}) {
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3) {
        const trapVal = settings3.stopSignAnimation !== void 0 ? settings3.stopSignAnimation : settings3.stopAnimation !== void 0 ? settings3.stopAnimation : settings3.speedTrapAnimation;
        if (trapVal === "no" || trapVal === "off" || trapVal === false) {
          if (typeof options.onComplete === "function") options.onComplete();
          return null;
        }
      }
      if (typeof document === "undefined") {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (activeSpeedTrapInstance) {
        activeSpeedTrapInstance.close(false);
      }
      const instance = new _SpeedTrapAnimationOverlay(options);
      activeSpeedTrapInstance = instance;
      instance.mount();
      return instance;
    }
    static hide() {
      if (activeSpeedTrapInstance) {
        activeSpeedTrapInstance.close(true);
      }
    }
    constructor(options = {}) {
      this.options = options;
      this.onComplete = options.onComplete || (() => {
      });
      this.overlayEl = null;
      this.autoCloseTimer = null;
      this.stepTimers = [];
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    formatCard(card, fallbackRank = "J", fallbackSuit = "\u2660") {
      if (!card) {
        return { r: fallbackRank, s: fallbackSuit, isRed: fallbackSuit === "\u2665" || fallbackSuit === "\u2666" };
      }
      if (Array.isArray(card) && card.length > 0) {
        card = card[card.length - 1];
      }
      if (typeof card === "string") {
        const match = card.match(/^([0-9AJQK]+)([HDSC♥♦♠♣]?)$/i);
        if (match) {
          card = { r: match[1], s: match[2] };
        }
      }
      let r = card.r !== void 0 ? card.r : card.rank !== void 0 ? card.rank : fallbackRank;
      if (r === 1 || r === "1") r = "A";
      else if (r === 11 || r === "11") r = "J";
      else if (r === 12 || r === "12") r = "Q";
      else if (r === 13 || r === "13") r = "K";
      r = String(r).toUpperCase();
      let s = card.s || card.suit || fallbackSuit;
      if (s === "H" || s === "h") s = "\u2665";
      else if (s === "D" || s === "d") s = "\u2666";
      else if (s === "S" || s === "s") s = "\u2660";
      else if (s === "C" || s === "c") s = "\u2663";
      const isRed = s === "\u2665" || s === "\u2666";
      return { r, s, isRed };
    }
    buildHtml() {
      const pName2 = this.options.playerName || "Driver";
      const reason = this.options.reason || "stop_sign";
      const hole = this.options.hole !== void 0 ? this.options.hole : 35;
      const ptsScored = this.options.ptsScored !== void 0 ? this.options.ptsScored : 2;
      const ptsLost = this.options.ptsLost !== void 0 ? this.options.ptsLost : 4;
      const blockerName = this.options.blockerName || "Lead Vehicle";
      const card = this.formatCard(this.options.card, "K", "\u2660");
      const isLane = reason === "no_passing_lane";
      const bannerTitle = isLane ? `${pName2} Blocked in No Passing Lane!` : `\u{1F6D1} Speed Trap: ${pName2} Clocked at Stop Sign!`;
      const subTitle = isLane ? `Held Behind ${blockerName} at Hole ${hole} \xB7 Strict 15 MPH Zone` : `Stop Sign at Hole ${hole} \xB7 ${ptsLost > 0 ? `${ptsLost} Points Confiscated!` : "Full Stop Enforced"}`;
      return `
      <!-- Red & Blue Emergency Strobe Flashers -->
      <div class="emergency-flasher-strobe" aria-hidden="true"></div>

      <!-- Skip Button -->
      <button type="button" class="speed-trap-skip-btn" id="speedTrapSkipBtn" aria-label="Skip Speed Trap Animation">
        Skip \u2715
      </button>

      <!-- Header Banner & Police Radar Badge -->
      <div class="speed-trap-banner">
        <div class="police-badge-wrap">
          <span class="police-siren-pill"></span>
          <span>HIGHWAY PATROL \xB7 SPEED TRAP RADAR</span>
          <span class="police-siren-pill"></span>
        </div>
        <h2 class="speed-trap-title">${bannerTitle}</h2>
        <div class="speed-trap-subtitle">${subTitle}</div>
      </div>

      <!-- The Main Speed Trap Arena Stage -->
      <div class="speed-trap-stage" id="speedTrapStage">
        <!-- Radar Scope HUD -->
        <div class="radar-hud">
          <div class="radar-sweep-screen"></div>
          <div class="radar-data">
            <span class="radar-tag">RADAR LOCK \u2794 HOLE ${hole}</span>
            <span class="radar-speed-val">STOPPED: ${ptsScored} PTS</span>
          </div>
        </div>

        <!-- Highway Asphalt Ground Floor -->
        <div class="highway-asphalt">
          <div class="dashed-highway-line"></div>
        </div>

        <!-- Offending Card (Left/Center Stage) -->
        <div class="violator-card-wrap sweating" id="violatorCardWrap">
          <span class="sweat-drop" aria-hidden="true">\u{1F4A7}</span>
          <div class="violator-card ${card.isRed ? "red" : "black"}" id="violatorCard">
            <div class="corner tl">
              <span class="r">${card.r}</span>
              <span class="s">${card.s}</span>
            </div>
            <div class="card-rank-center">
              <span class="p-pip">${card.s}</span>
            </div>
            <div class="corner br">
              <span class="r">${card.r}</span>
              <span class="s">${card.s}</span>
            </div>
          </div>

          <!-- Impact Spikes from Ticket Slap -->
          <div class="slap-impact-lines" id="slapImpact"></div>

          <!-- Bright Yellow Speeding Citation Ticket Slapped On Card -->
          <div class="speeding-ticket" id="speedingTicket">
            <div class="ticket-header">TRAFFIC CITATION #CC-911</div>
            <div class="ticket-body">
              <div class="ticket-field"><span>VIOLATOR:</span><strong>${pName2}</strong></div>
              <div class="ticket-field"><span>LOCATION:</span><strong>HOLE ${hole}</strong></div>
              <div class="ticket-field"><span>CHARGE:</span><strong>${isLane ? "ILLEGAL PASSING" : "FAILED TO STOP"}</strong></div>
              <div class="ticket-field"><span>PENALTY:</span><strong>${ptsLost > 0 ? `-${ptsLost} PTS LOST` : "WARNING"}</strong></div>
            </div>
            <div class="red-rubber-stamp">\u{1F6D1} CITATION ISSUED</div>
          </div>
        </div>

        <!-- Motorcycle Cop Card Container (Zips in from Right) -->
        <div class="motorcycle-cop-wrap" id="motorcycleCop">
          <!-- The Cruiser Motorcycle -->
          <div class="police-bike">
            <div class="bike-wheel front"><div class="hubcap"></div></div>
            <div class="bike-chassis">
              <div class="police-decal">PATROL</div>
            </div>
            <div class="exhaust-pipe"></div>
            <div class="bike-wheel rear"><div class="hubcap"></div></div>
            <div class="bike-siren-beacon"></div>
          </div>

          <!-- The Motorcycle Cop Playing Card -->
          <div class="cop-card">
            <!-- Police Cap with Gold Shield Badge -->
            <div class="police-cap">
              <div class="gold-badge"></div>
              <div class="cap-visor"></div>
            </div>

            <div class="cop-corner">\u{1F46E}</div>

            <!-- Aviator Sunglasses -->
            <div class="aviator-shades">
              <div class="lens"></div>
              <div class="bridge"></div>
              <div class="lens"></div>
            </div>
          </div>

          <!-- White-Gloved Arm Extended in "HALT!" Gesture -->
          <div class="halt-arm" id="copHaltArm">
            <div class="arm-sleeve"></div>
            <div class="white-glove">\u270B</div>
          </div>

          <!-- Comic "HALT!" Callout Bubble -->
          <div class="halt-bubble" id="copHaltBubble">HALT!</div>
        </div>

        <!-- Skid Tire Smoke Puffs -->
        <div class="bike-skid-smoke" id="bikeSmoke"></div>
      </div>
    `;
    }
    mount() {
      let el = document.getElementById("speedTrapAnimationOverlay");
      if (!el) {
        el = document.createElement("div");
        el.id = "speedTrapAnimationOverlay";
        el.className = "speed-trap-overlay";
        el.setAttribute("role", "dialog");
        el.setAttribute("aria-modal", "true");
        el.setAttribute("aria-label", "Speed Trap Radar Animation");
        document.body.appendChild(el);
      }
      this.overlayEl = el;
      el.innerHTML = this.buildHtml();
      const skipBtn = el.querySelector("#speedTrapSkipBtn");
      if (skipBtn) {
        skipBtn.addEventListener("click", () => this.close(true));
      }
      window.addEventListener("keydown", this.handleKeyDown);
      void el.offsetWidth;
      el.classList.add("active");
      this.startChoreography();
    }
    getAudio() {
      return typeof window !== "undefined" && (window.audio || window.audioManager || window.sfx || window.CC && (window.CC.audio || window.CC.audioManager || window.CC.sfx)) || null;
    }
    startChoreography() {
      const audio = this.getAudio();
      if (audio && typeof audio.policeSirenWail === "function") {
        audio.policeSirenWail();
      }
      this.scheduleStep(400, () => {
        const cop = this.overlayEl?.querySelector("#motorcycleCop");
        const smoke = this.overlayEl?.querySelector("#bikeSmoke");
        if (cop) cop.classList.add("zipping-in");
        if (smoke) smoke.classList.add("active");
        if (audio && typeof audio.motorcycleRev === "function") {
          audio.motorcycleRev();
        }
      });
      this.scheduleStep(1150, () => {
        const cop = this.overlayEl?.querySelector("#motorcycleCop");
        if (cop) cop.classList.add("halt-active");
        if (audio && typeof audio.policeWhistle === "function") {
          audio.policeWhistle();
        }
      });
      this.scheduleStep(1850, () => {
        const ticket = this.overlayEl?.querySelector("#speedingTicket");
        const impact = this.overlayEl?.querySelector("#slapImpact");
        const card = this.overlayEl?.querySelector("#violatorCard");
        if (ticket) ticket.classList.add("slapped");
        if (impact) impact.classList.add("boom");
        if (card) {
          card.style.transform = "scale(0.96) rotate(-2deg)";
          setTimeout(() => {
            if (card) card.style.transform = "scale(1) rotate(0deg)";
          }, 140);
        }
        if (audio && typeof audio.ticketSlap === "function") {
          audio.ticketSlap();
        }
      });
      this.autoCloseTimer = setTimeout(() => {
        this.close(true);
      }, 4250);
    }
    scheduleStep(delay, fn) {
      const t = setTimeout(fn, delay);
      this.stepTimers.push(t);
    }
    handleKeyDown(e) {
      if (e.key === "Escape" || e.key === "Esc" || e.key === "Enter" || e.key === " ") {
        this.close(true);
      }
    }
    close(triggerCallback = true) {
      window.removeEventListener("keydown", this.handleKeyDown);
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      if (this.removeTimer) {
        clearTimeout(this.removeTimer);
        this.removeTimer = null;
      }
      this.stepTimers.forEach((t) => clearTimeout(t));
      this.stepTimers = [];
      const el = this.overlayEl;
      this.overlayEl = null;
      if (activeSpeedTrapInstance === this) {
        activeSpeedTrapInstance = null;
      }
      if (el) {
        el.classList.remove("active");
        if (triggerCallback) {
          this.removeTimer = setTimeout(() => {
            if (el && el.parentNode) {
              el.parentNode.removeChild(el);
            }
          }, 300);
        } else {
          if (el && el.parentNode) {
            el.parentNode.removeChild(el);
          }
        }
      }
      if (triggerCallback && typeof this.onComplete === "function") {
        const cb = this.onComplete;
        this.onComplete = null;
        try {
          cb();
        } catch (err) {
          console.error("[SpeedTrapAnimationOverlay] onComplete error:", err);
        }
      }
    }
  };

  // src/ui/ScenicRouteAnimationOverlay.js
  var activeScenicRouteInstance = null;
  var ScenicRouteAnimationOverlay = class _ScenicRouteAnimationOverlay {
    /**
     * Displays the Scenic Route / Rotary GPS animation overlay.
     *
     * @param {Object} [options]
     * @param {'roundabout'|'detour'} [options.type='roundabout'] - Animation variant type
     * @param {string} [options.playerName='Driver'] - Name of player navigating
     * @param {string} [options.who='p1'] - Seat ID
     * @param {number} [options.hole=35] - Hole number where hazard triggered
     * @param {number} [options.progress=0] - Hazard loop progress (e.g. 0 to 7)
     * @param {Object} [options.card] - Card object { r, s } representing player's card
     * @param {Object} [options.settings] - Game settings object
     * @param {Function} [options.onComplete] - Callback on dismiss or completion
     * @returns {ScenicRouteAnimationOverlay|null}
     */
    static show(options = {}) {
      const settings3 = options.settings || (typeof window !== "undefined" ? window.settings : null);
      if (settings3) {
        const specificOpt = options.type === "detour" ? settings3.detourAnimation : settings3.roundAboutAnimation;
        const optVal = specificOpt !== void 0 ? specificOpt : settings3.scenicRouteAnimation;
        if (optVal === "no" || optVal === "off" || optVal === false) {
          if (typeof options.onComplete === "function") options.onComplete();
          return null;
        }
      }
      if (typeof document === "undefined") {
        if (typeof options.onComplete === "function") options.onComplete();
        return null;
      }
      if (activeScenicRouteInstance) {
        activeScenicRouteInstance.close(false);
      }
      const instance = new _ScenicRouteAnimationOverlay(options);
      activeScenicRouteInstance = instance;
      instance.mount();
      return instance;
    }
    static hide() {
      if (activeScenicRouteInstance) {
        activeScenicRouteInstance.close(true);
      }
    }
    constructor(options = {}) {
      this.options = options;
      this.type = options.type === "detour" ? "detour" : "roundabout";
      this.onComplete = options.onComplete || (() => {
      });
      this.overlayEl = null;
      this.autoCloseTimer = null;
      this.removeTimer = null;
      this.stepTimers = [];
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    formatCard(card, fallbackRank = "J", fallbackSuit = "\u2660") {
      if (!card) {
        return { r: fallbackRank, s: fallbackSuit, isRed: fallbackSuit === "\u2665" || fallbackSuit === "\u2666" };
      }
      if (Array.isArray(card) && card.length > 0) {
        card = card[card.length - 1];
      }
      if (typeof card === "string") {
        const match = card.match(/^([0-9AJQK]+)([HDSC♥♦♠♣]?)$/i);
        if (match) {
          card = { r: match[1], s: match[2] };
        }
      }
      let r = card.r !== void 0 ? card.r : card.rank !== void 0 ? card.rank : fallbackRank;
      if (r === 1 || r === "1") r = "A";
      else if (r === 11 || r === "11") r = "J";
      else if (r === 12 || r === "12") r = "Q";
      else if (r === 13 || r === "13") r = "K";
      r = String(r).toUpperCase();
      let s = card.s || card.suit || fallbackSuit;
      if (s === "H" || s === "h") s = "\u2665";
      else if (s === "D" || s === "d") s = "\u2666";
      else if (s === "S" || s === "s") s = "\u2660";
      else if (s === "C" || s === "c") s = "\u2663";
      const isRed = s === "\u2665" || s === "\u2666";
      return { r, s, isRed };
    }
    buildHtml() {
      const pName2 = this.options.playerName || "Driver";
      const hole = this.options.hole !== void 0 ? this.options.hole : 35;
      const card = this.formatCard(this.options.card, "Q", "\u2665");
      const isDetour = this.type === "detour";
      const bannerPill = isDetour ? "ROAD WORK AHEAD \xB7 GPS DETOUR" : "TRAFFIC ROTARY \xB7 ROUND ABOUT";
      const titleText = isDetour ? `\u{1F6A7} Detour: ${pName2} Taking the Scenic Route!` : `\u{1F504} Round About: ${pName2} Having Fun on the Rotary!`;
      const subtitleText = isDetour ? `Main Road Closed at Hole ${hole} \xB7 7-Hole Scenic Byway Activated` : `Approaching Hole ${hole} Rotary \xB7 7-Hole Rotary Loop In Progress`;
      const gpsTurnText = isDetour ? "In 50 ft, take bumpy scenic dirt road" : "At roundabout, take the 7th exit";
      return `
      <!-- Ambient GPS Strobe Effect -->
      <div class="ambient-gps-strobe" aria-hidden="true"></div>

      <!-- Skip Button -->
      <button type="button" class="scenic-skip-btn" id="scenicRouteSkipBtn" aria-label="Skip Animation">
        Skip \u2715
      </button>

      <!-- Top Header & Banner -->
      <div class="scenic-route-banner">
        <div class="badge-pill-wrap">
          <span class="pulsing-dot"></span>
          <span>${bannerPill}</span>
          <span class="pulsing-dot"></span>
        </div>
        <h2 class="scenic-title">${titleText}</h2>
        <div class="scenic-subtitle">${subtitleText}</div>
      </div>

      <!-- In-Car Dashboard GPS HUD Bar -->
      <div class="gps-dash-hud">
        <div class="speedometer-cluster">
          <span class="speed-val" id="dashSpeedometer">45</span>
          <span class="speed-unit">MPH</span>
        </div>
        <div class="gps-route-instruction">
          <span class="turn-icon">${isDetour ? "\u{1F6A7}" : "\u{1F504}"}</span>
          <span id="gpsTurnLabel">${gpsTurnText}</span>
        </div>
        <div class="gps-recalculating-pill" id="gpsRecalcBadge">
          <span>\u26A0\uFE0F RECALCULATING...</span>
        </div>
      </div>

      <!-- Main Animation Stage -->
      <div class="scenic-route-stage" id="scenicStage">
        <!-- Paved Highway Base Floor -->
        <div class="stage-highway">
          <div class="dashed-line"></div>
        </div>

        ${isDetour ? `
          <!-- Detour Construction Zone Arena -->
          <div class="detour-arena">
            <div class="bumpy-dirt-road">
              <div class="road-rock r1"></div>
              <div class="road-rock r2"></div>
              <div class="road-rock r3"></div>
            </div>
            <div class="construction-sawhorse">
              <span class="amber-beacon left"></span>
              <span class="sawhorse-sign">ROAD CLOSED</span>
              <span class="amber-beacon right"></span>
            </div>
            <div class="orange-detour-sign">
              <div class="sign-main">DETOUR</div>
              <div class="sign-arrow">\u2794</div>
            </div>
            <div class="roadside-cow" title="Roadside onlooker">\u{1F42E}</div>
          </div>
        ` : `
          <!-- Round About Rotary Loop Arena -->
          <div class="roundabout-arena">
            <div class="rotary-circle-ring"></div>
            <div class="rotary-center-island">
              <span>\u26F2</span>
              <span class="rotary-label">ROTARY</span>
            </div>
            <div class="rotary-orbit-track" id="rotaryOrbitTrack"></div>
          </div>
        `}

        <!-- The Player's Vehicle & Driver Card -->
        <div class="player-car-wrap" id="playerCar">
          <div class="driver-card ${card.isRed ? "red" : "black"}">
            <div class="corner tl">
              <span class="r">${card.r}</span>
              <span class="s">${card.s}</span>
            </div>
            <div class="card-face-center">
              <span class="normal-pip">${card.s}</span>
              <span class="dizzy-face">\u{1F635}\u200D\u{1F4AB}</span>
            </div>
            <div class="corner br">
              <span class="r">${card.r}</span>
              <span class="s">${card.s}</span>
            </div>
            <div class="steering-wheel"></div>
          </div>

          <div class="car-chassis">
            <div class="headlight"></div>
          </div>
          <div class="car-wheel front"></div>
          <div class="car-wheel rear"></div>
          <div class="road-dust-cloud"></div>
        </div>
      </div>
    `;
    }
    mount() {
      let el = document.getElementById("scenicRouteAnimationOverlay");
      if (!el) {
        el = document.createElement("div");
        el.id = "scenicRouteAnimationOverlay";
        el.setAttribute("role", "dialog");
        el.setAttribute("aria-modal", "true");
        el.setAttribute("aria-label", this.type === "detour" ? "Detour Animation" : "Round About Animation");
        document.body.appendChild(el);
      }
      el.className = `scenic-route-overlay theme-${this.type}`;
      this.overlayEl = el;
      el.innerHTML = this.buildHtml();
      const skipBtn = el.querySelector("#scenicRouteSkipBtn");
      if (skipBtn) {
        skipBtn.addEventListener("click", () => this.close(true));
      }
      window.addEventListener("keydown", this.handleKeyDown);
      void el.offsetWidth;
      el.classList.add("active");
      this.startChoreography();
    }
    getAudio() {
      return typeof window !== "undefined" && (window.audio || window.audioManager || window.sfx || window.CC && (window.CC.audio || window.CC.audioManager || window.CC.sfx)) || null;
    }
    startChoreography() {
      const audio = this.getAudio();
      if (audio && typeof audio.gpsChimeRecalculate === "function") {
        audio.gpsChimeRecalculate();
      }
      this.scheduleStep(650, () => {
        const car = this.overlayEl?.querySelector("#playerCar");
        const speedEl = this.overlayEl?.querySelector("#dashSpeedometer");
        const labelEl = this.overlayEl?.querySelector("#gpsTurnLabel");
        if (this.type === "detour") {
          if (car) car.classList.add("detour-swerved");
          if (speedEl) speedEl.textContent = "22";
          if (labelEl) labelEl.textContent = "BUMPY SCENIC ROUTE AHEAD!";
          if (audio && typeof audio.bumpyDetourRattle === "function") {
            audio.bumpyDetourRattle();
          }
        } else {
          const orbitTrack = this.overlayEl?.querySelector("#rotaryOrbitTrack");
          if (orbitTrack && car) {
            orbitTrack.appendChild(car);
            orbitTrack.classList.add("spinning");
            car.style.left = "50%";
            car.style.top = "-15px";
            car.style.transform = "translate(-50%, 0) scale(0.9)";
          }
          if (speedEl) speedEl.textContent = "15";
          if (labelEl) labelEl.textContent = "ROUNDABOUT EXIT MISSED! WHEEEE!";
          if (audio && typeof audio.rotarySpin === "function") {
            audio.rotarySpin();
          }
        }
      });
      this.scheduleStep(1800, () => {
        const speedEl = this.overlayEl?.querySelector("#dashSpeedometer");
        if (this.type === "detour") {
          if (speedEl) speedEl.textContent = "28";
        } else {
          if (speedEl) speedEl.textContent = "35";
        }
      });
      this.autoCloseTimer = setTimeout(() => {
        this.close(true);
      }, 4250);
    }
    scheduleStep(delay, fn) {
      const t = setTimeout(fn, delay);
      this.stepTimers.push(t);
    }
    handleKeyDown(e) {
      if (e.key === "Escape" || e.key === "Esc" || e.key === "Enter" || e.key === " ") {
        this.close(true);
      }
    }
    close(triggerCallback = true) {
      window.removeEventListener("keydown", this.handleKeyDown);
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      if (this.removeTimer) {
        clearTimeout(this.removeTimer);
        this.removeTimer = null;
      }
      this.stepTimers.forEach((t) => clearTimeout(t));
      this.stepTimers = [];
      const el = this.overlayEl;
      this.overlayEl = null;
      if (activeScenicRouteInstance === this) {
        activeScenicRouteInstance = null;
      }
      if (el) {
        el.classList.remove("active");
        if (triggerCallback) {
          this.removeTimer = setTimeout(() => {
            if (el && el.parentNode) {
              el.parentNode.removeChild(el);
            }
          }, 300);
        } else {
          if (el && el.parentNode) {
            el.parentNode.removeChild(el);
          }
        }
      }
      if (triggerCallback && typeof this.onComplete === "function") {
        const cb = this.onComplete;
        this.onComplete = null;
        try {
          cb();
        } catch (err) {
          console.error("[ScenicRouteAnimationOverlay] onComplete error:", err);
        }
      }
    }
  };

  // src/ui/ReplayModal.js
  var ReplayModal = class _ReplayModal {
    static OVERLAY_ID = "crazyReplayOverlay";
    static MODAL_ID = "crazyReplayModal";
    static activeReplay = null;
    static currentStep = 0;
    static isPlaying = false;
    static playbackSpeed = 1;
    // 0.5 | 1 | 2 | 4
    static autoPauseOnShow = true;
    // Auto-pause after counting each hand and crib
    static playbackTimer = null;
    static keydownHandler = null;
    static _currentView = null;
    // 'player' | 'library'
    static _renderedReplayId = null;
    static _selectedBrand = "all";
    /**
     * Opens the Replay Modal.
     * If a replay or replay ID is passed, launches the interactive viewer;
     * otherwise opens the saved replays library.
     * @param {Object|string} [replayOrId]
     * @param {string} [brand='all']
     */
    static open(replayOrId = null, brand = null) {
      if (typeof document === "undefined") return;
      if (brand) {
        _ReplayModal._selectedBrand = brand;
      }
      let overlay = document.getElementById(_ReplayModal.OVERLAY_ID);
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = _ReplayModal.OVERLAY_ID;
        overlay.className = "replay-overlay";
        overlay.setAttribute("role", "dialog");
        overlay.setAttribute("aria-modal", "true");
        overlay.setAttribute("aria-label", "Crazy Cribbage Game Replays");
        document.body.appendChild(overlay);
      }
      _ReplayModal.stopPlayback();
      overlay.classList.add("is-opening");
      setTimeout(() => {
        if (overlay) overlay.classList.remove("is-opening");
      }, 250);
      if (replayOrId) {
        const rep = typeof replayOrId === "string" ? GameReplayManager.getReplayById(replayOrId) : replayOrId;
        if (rep) {
          _ReplayModal.activeReplay = rep;
          _ReplayModal.currentStep = 0;
          _ReplayModal.renderPlayer();
        } else {
          _ReplayModal.renderLibrary(_ReplayModal._selectedBrand);
        }
      } else {
        _ReplayModal.renderLibrary(_ReplayModal._selectedBrand);
      }
      overlay.style.display = "flex";
      overlay.onclick = (e) => {
        if (e.target === overlay) {
          _ReplayModal.close();
        }
      };
      _ReplayModal.attachKeyboardControls();
    }
    /**
     * Opens the library view explicitly, optionally focused on a brand.
     * @param {string} [brand='all']
     */
    static openLibrary(brand = "all") {
      _ReplayModal.stopPlayback();
      _ReplayModal.activeReplay = null;
      _ReplayModal._currentView = null;
      _ReplayModal._renderedReplayId = null;
      _ReplayModal._selectedBrand = brand || "all";
      _ReplayModal.open(null, brand || "all");
    }
    /**
     * Closes the Replay Modal.
     */
    static close() {
      _ReplayModal.stopPlayback();
      _ReplayModal.detachKeyboardControls();
      _ReplayModal._currentView = null;
      _ReplayModal._renderedReplayId = null;
      if (typeof document !== "undefined") {
        const overlay = document.getElementById(_ReplayModal.OVERLAY_ID);
        if (overlay) overlay.style.display = "none";
      }
      const isGameOver = typeof window !== "undefined" && (window.state && window.state.over || window._lastGameOverHtml);
      if (isGameOver) {
        if (typeof window !== "undefined" && typeof window.showGameWonModal === "function") {
          window.showGameWonModal();
        } else if (typeof GameEngine !== "undefined" && typeof GameEngine.showGameWonModal === "function") {
          GameEngine.showGameWonModal();
        }
      }
    }
    /**
     * Attaches keyboard shortcut listener.
     */
    static attachKeyboardControls() {
      _ReplayModal.detachKeyboardControls();
      _ReplayModal.keydownHandler = (e) => {
        const overlay = document.getElementById(_ReplayModal.OVERLAY_ID);
        if (!overlay || overlay.style.display === "none") return;
        if (e.key === "Escape") {
          e.preventDefault();
          _ReplayModal.close();
        } else if (_ReplayModal.activeReplay) {
          if (e.key === " " || e.code === "Space") {
            e.preventDefault();
            _ReplayModal.togglePlayPause();
          } else if (e.key === "ArrowRight") {
            e.preventDefault();
            _ReplayModal.stepForward();
          } else if (e.key === "ArrowLeft") {
            e.preventDefault();
            _ReplayModal.stepBackward();
          } else if (e.key === "Home") {
            e.preventDefault();
            _ReplayModal.goToStep(0);
          } else if (e.key === "End") {
            e.preventDefault();
            const max = (_ReplayModal.activeReplay.events?.length || 1) - 1;
            _ReplayModal.goToStep(max);
          }
        }
      };
      window.addEventListener("keydown", _ReplayModal.keydownHandler);
    }
    /**
     * Detaches keyboard shortcut listener.
     */
    static detachKeyboardControls() {
      if (_ReplayModal.keydownHandler && typeof window !== "undefined") {
        window.removeEventListener("keydown", _ReplayModal.keydownHandler);
        _ReplayModal.keydownHandler = null;
      }
    }
    /**
     * Formats a card into a styled HTML element badge.
     * @param {Object} card
     * @param {boolean} [highlight=false]
     * @param {boolean} [played=false]
     * @returns {string}
     */
    static formatCardHtml(card, highlight = false, played = false) {
      if (!card) return '<div class="replay-card replay-card-empty">\u2014</div>';
      const c = TraditionalCard.normalize(card);
      const color = c.isJoker ? "#9333ea" : c.isRed ? "#ef4444" : "#1e293b";
      return `
      <div class="replay-card ${c.isRed ? "replay-red" : "replay-black"}${highlight ? " is-highlighted" : ""}${played ? " is-played" : ""}" style="color:${color}; position:relative; overflow:hidden;">
        ${TraditionalCard.renderHtml(card)}
      </div>
    `;
    }
    /**
     * Compares two cards for equality by id or rank+suit.
     * @param {Object} a
     * @param {Object} b
     * @returns {boolean}
     */
    static sameCard(a, b) {
      if (!a || !b) return false;
      if (a.id && b.id && a.id === b.id) return true;
      const ra = a.r !== void 0 ? a.r : a.rank;
      const rb = b.r !== void 0 ? b.r : b.rank;
      const sa = (a.s !== void 0 ? a.s : a.suit || "").toUpperCase();
      const sb = (b.s !== void 0 ? b.s : b.suit || "").toUpperCase();
      return ra === rb && sa === sb;
    }
    /**
     * Returns a copy of hand with played cards removed.
     * @param {Array} hand
     * @param {Array} played
     * @returns {Array}
     */
    static removeCards(hand, played) {
      if (!Array.isArray(hand)) return [];
      const remaining = [...hand];
      if (!Array.isArray(played)) return remaining;
      for (const p of played) {
        const idx = remaining.findIndex((c) => _ReplayModal.sameCard(c, p));
        if (idx !== -1) {
          remaining.splice(idx, 1);
        }
      }
      return remaining;
    }
    /**
     * Formats combo notes and points into stylish badge pills.
     * @param {Array} combos
     * @param {number} points
     * @returns {string}
     */
    static formatComboPills(combos, points = 0) {
      const pills = [];
      if (points !== void 0 && points !== null) {
        pills.push(`<span class="replay-combo-pill is-total">+${points} pts</span>`);
      }
      if (Array.isArray(combos) && combos.length) {
        for (const c of combos) {
          let text2 = "";
          if (typeof c === "string") {
            text2 = c;
          } else if (c && typeof c === "object") {
            if (c.why && c.n !== void 0) {
              text2 = `${c.why} (${c.n})`;
            } else if (c.label && c.points !== void 0) {
              text2 = `${c.label} (${c.points})`;
            } else if (c.desc) {
              text2 = c.desc;
            } else if (c.description) {
              text2 = c.description;
            } else if (c.name) {
              text2 = c.name;
            } else {
              text2 = JSON.stringify(c);
            }
          }
          if (text2) {
            const formatted = text2.charAt(0).toUpperCase() + text2.slice(1);
            pills.push(`<span class="replay-combo-pill">${formatted}</span>`);
          }
        }
      } else if (points === 0) {
        pills.push('<span class="replay-combo-pill is-zero">0 points (No combinations)</span>');
      }
      return pills.join("");
    }
    /**
     * Renders the interactive replay player view.
     * Builds the shell once if needed, then performs smooth in-place DOM updates without re-building or flashing.
     */
    static renderPlayer() {
      const overlay = document.getElementById(_ReplayModal.OVERLAY_ID);
      if (!overlay || !_ReplayModal.activeReplay) return;
      const rep = _ReplayModal.activeReplay;
      const events = rep.events || [];
      const event = events[_ReplayModal.currentStep] || events[0] || {};
      const totalSteps = Math.max(1, events.length);
      const targetScore = rep.target || 121;
      const p1 = rep.players?.p1 || { name: "Player 1", avatar: "\u{1F920}" };
      const p2 = rep.players?.p2 || { name: "Player 2", avatar: "\u{1F916}" };
      const modal = document.getElementById(_ReplayModal.MODAL_ID);
      const isPlayerShellPresent = modal && _ReplayModal._currentView === "player" && _ReplayModal._renderedReplayId === rep.id;
      if (!isPlayerShellPresent) {
        _ReplayModal._currentView = "player";
        _ReplayModal._renderedReplayId = rep.id;
        overlay.innerHTML = `
        <div class="replay-modal-wrap" id="${_ReplayModal.MODAL_ID}">
          <!-- Header -->
          <div class="replay-header">
            <div class="replay-header-left">
              <button type="button" class="btn-ghost replay-btn-sm" id="btnReplayBackToLib" title="Back to Replays List">
                \u25C0 Replay Library
              </button>
              <div class="replay-title-wrap">
                <h2 class="replay-title">\u{1F3AC} Match Replay: ${p1.name} vs ${p2.name}</h2>
                <div class="replay-meta-pills">
                  <span class="replay-badge badge-brand">${rep.brandLabel || "Crazy Cribbage"}</span>
                  <span class="replay-badge badge-target">${targetScore} Points</span>
                  <span class="replay-badge badge-date">${rep.dateLabel || "Match"}</span>
                  ${rep.winnerName ? `<span class="replay-badge badge-winner">\u{1F3C6} Winner: ${rep.winnerName} (${rep.finalScores?.p1}\u2013${rep.finalScores?.p2})</span>` : ""}
                </div>
              </div>
            </div>
            <div class="replay-header-right">
              <button type="button" class="btn-ghost replay-btn-close" id="btnReplayClose" title="Close Replay">
                \u2715
              </button>
            </div>
          </div>

          <!-- Scoreboard Progress Track -->
          <div class="replay-scoreboard">
            <div class="replay-score-card" id="repP1ScoreCard">
              <div class="replay-player-row">
                <span class="replay-avatar">${p1.avatar || "\u{1F920}"}</span>
                <span class="replay-player-name">${p1.name}</span>
                <span class="replay-player-score" id="repP1Score">0 <span class="score-denom">/ ${targetScore}</span></span>
              </div>
              <div class="replay-score-track">
                <div class="replay-score-fill fill-p1" id="repP1ScoreFill" style="width: 0%;"></div>
              </div>
            </div>

            <div class="replay-round-pill">
              <span class="round-label">ROUND</span>
              <span class="round-num" id="repRoundNum">1</span>
            </div>

            <div class="replay-score-card" id="repP2ScoreCard">
              <div class="replay-player-row">
                <span class="replay-avatar">${p2.avatar || "\u{1F916}"}</span>
                <span class="replay-player-name">${p2.name}</span>
                <span class="replay-player-score" id="repP2Score">0 <span class="score-denom">/ ${targetScore}</span></span>
              </div>
              <div class="replay-score-track">
                <div class="replay-score-fill fill-p2" id="repP2ScoreFill" style="width: 0%;"></div>
              </div>
            </div>
          </div>

          <!-- Action Narration Banner -->
          <div class="replay-narration-box" id="replayNarration">
            <div class="narration-icon" id="repNarrationIcon">\u{1F4AC}</div>
            <div class="narration-text" id="repNarrationText">Play progress...</div>
            <div class="replay-pause-alert" id="repPauseNotice" style="display: none;"></div>
          </div>

          <!-- Replay Table Layout -->
          <div class="replay-table-grid">
            <!-- Left: Starter & Crib -->
            <div class="replay-col-side">
              <div class="replay-box" id="repStarterBox">
                <div class="replay-box-title">\u2702\uFE0F Starter Card</div>
                <div class="replay-cards-row" id="repStarterArea">
                  <div class="replay-card replay-card-back">\u{1F0A0}</div>
                </div>
              </div>
              <div class="replay-box" id="repCribBox">
                <div class="replay-box-title" id="repCribTitle">\u{1F381} Dealer Crib</div>
                <div class="replay-cards-row" id="repCribArea">
                  <span class="replay-dim-text">Hidden in crib</span>
                </div>
                <div class="replay-combos-breakdown" id="repCribCombos" style="display: none;"></div>
              </div>
            </div>

            <!-- Center: Pegging Play Area & Count Dial -->
            <div class="replay-col-center">
              <div class="replay-box replay-box-play">
                <div class="replay-box-title replay-box-title-center">
                  <span>\u{1F0CF} Pegging Sequence</span>
                  <span class="replay-count-badge" id="repCountBadge">Count: <strong>0</strong> / 31</span>
                </div>
                <div class="replay-pile-area" id="repPileArea">
                  <span class="replay-dim-text">No cards played yet this turn</span>
                </div>
              </div>

              <!-- Player Hands Area -->
              <div class="replay-hands-area">
                <div class="replay-hand-box" id="repP1HandBox">
                  <div class="replay-hand-main">
                    <div class="replay-hand-label" id="repP1HandLabel">${p1.name}'s Hand:</div>
                    <div class="replay-cards-row" id="repP1HandArea">
                      <span class="replay-dim-text">No cards</span>
                    </div>
                  </div>
                  <div class="replay-combos-breakdown" id="repP1Combos" style="display: none;"></div>
                </div>
                <div class="replay-hand-box" id="repP2HandBox">
                  <div class="replay-hand-main">
                    <div class="replay-hand-label" id="repP2HandLabel">${p2.name}'s Hand:</div>
                    <div class="replay-cards-row" id="repP2HandArea">
                      <span class="replay-dim-text">No cards</span>
                    </div>
                  </div>
                  <div class="replay-combos-breakdown" id="repP2Combos" style="display: none;"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Timeline & Playback Controller Bar -->
          <div class="replay-controller-bar">
            <!-- Scrubber Range -->
            <div class="replay-scrubber-row">
              <span class="replay-step-info" id="repStepInfo">Step <strong>1</strong> of ${totalSteps} (Round 1)</span>
              <input type="range" class="replay-scrubber-slider" id="replayScrubber" min="0" max="${totalSteps - 1}" value="${_ReplayModal.currentStep}" aria-label="Replay Timeline Scrubber" />
            </div>

            <!-- Controls Buttons -->
            <div class="replay-buttons-row">
              <div class="replay-controls-group">
                <button type="button" class="btn-ghost replay-ctrl-btn" id="btnRepPrevRound" title="Previous Round (Home)">\u23EE Round</button>
                <button type="button" class="btn-ghost replay-ctrl-btn" id="btnRepStepBack" title="Step Back (Left Arrow)">\u25C0 Step</button>
                <button type="button" class="btn-gold replay-play-btn" id="btnRepPlayPause" title="Play / Pause (Spacebar)">
                  ${_ReplayModal.isPlaying ? "\u23F8 Pause" : "\u25B6 Play"}
                </button>
                <button type="button" class="btn-ghost replay-ctrl-btn" id="btnRepStepForward" title="Step Forward (Right Arrow)">Step \u25B6</button>
                <button type="button" class="btn-ghost replay-ctrl-btn" id="btnRepNextRound" title="Next Round (End)">Round \u23ED</button>
              </div>

              <!-- Speed selector & Auto-pause toggle -->
              <div class="replay-options-group">
                <div class="replay-speed-group" role="group" aria-label="Playback Speed">
                  <span class="speed-label">Speed:</span>
                  ${[0.5, 1, 2, 4].map((spd) => `
                    <button type="button" class="replay-speed-btn${_ReplayModal.playbackSpeed === spd ? " is-active" : ""}" data-speed="${spd}">
                      ${spd}x
                    </button>
                  `).join("")}
                </div>

                <label class="replay-check-label" title="Automatically pause replay after counting each hand and crib">
                  <input type="checkbox" id="chkAutoPauseShow" ${_ReplayModal.autoPauseOnShow ? "checked" : ""} />
                  <span>Pause on Hand/Crib</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      `;
        _ReplayModal.bindPlayerEvents();
      }
      const isShowHand = event.type === "show_hand";
      const isShowCrib = event.type === "show_crib";
      const isP1Scoring = isShowHand && (event.who === "p1" || event.who === "you");
      const isP2Scoring = isShowHand && (event.who === "p2" || event.who === "cpu");
      const isCribScoring = isShowCrib;
      const curIdx = _ReplayModal.currentStep;
      let roundStartIdx = 0;
      for (let i = curIdx; i >= 0; i--) {
        if (events[i].type === "round_start") {
          roundStartIdx = i;
          break;
        }
      }
      let nextRoundStartIdx = events.length;
      for (let i = roundStartIdx + 1; i < events.length; i++) {
        if (events[i].type === "round_start") {
          nextRoundStartIdx = i;
          break;
        }
      }
      const roundEndIdx = nextRoundStartIdx - 1;
      const roundNum = events[roundStartIdx]?.round || event.round || 1;
      let p1ShowCards = null;
      let p2ShowCards = null;
      let p1Dealt = null;
      let p2Dealt = null;
      const p1Discards = [];
      const p2Discards = [];
      const p1PeggedAll = [];
      const p2PeggedAll = [];
      let hasCutOccurred = false;
      for (let i = roundStartIdx; i <= roundEndIdx; i++) {
        const e = events[i];
        if (e.type === "show_hand" && Array.isArray(e.cards) && e.cards.length) {
          if ((e.who === "p1" || e.who === "you") && !p1ShowCards) p1ShowCards = [...e.cards];
          else if ((e.who === "p2" || e.who === "cpu") && !p2ShowCards) p2ShowCards = [...e.cards];
        } else if (e.type === "deal" && e.hands) {
          if (!p1Dealt && (e.hands.p1 || e.hands.you)) p1Dealt = [...e.hands.p1 || e.hands.you];
          if (!p2Dealt && (e.hands.p2 || e.hands.cpu)) p2Dealt = [...e.hands.p2 || e.hands.cpu];
        } else if (e.type === "discard") {
          if (e.who === "p1" || e.who === "you") p1Discards.push(...e.discards || e.cards || []);
          else if (e.who === "p2" || e.who === "cpu") p2Discards.push(...e.discards || e.cards || []);
        } else if (e.type === "peg_play" && e.card) {
          if (e.who === "p1" || e.who === "you") p1PeggedAll.push(e.card);
          else if (e.who === "p2" || e.who === "cpu") p2PeggedAll.push(e.card);
        }
      }
      for (let i = roundStartIdx; i <= curIdx; i++) {
        if (events[i].type === "starter_cut" || events[i].type === "peg_play" || events[i].type === "show_hand" || events[i].type === "show_crib") {
          hasCutOccurred = true;
          break;
        }
      }
      let p1Kept = p1ShowCards;
      if (!p1Kept && p1PeggedAll.length >= 4) p1Kept = p1PeggedAll;
      if (!p1Kept && p1Dealt) {
        p1Kept = p1Discards.length ? _ReplayModal.removeCards(p1Dealt, p1Discards) : p1Dealt.length === 4 ? p1Dealt : p1PeggedAll.length ? p1PeggedAll : p1Dealt;
      }
      if (!p1Kept && event.hands?.p1) p1Kept = [...event.hands.p1];
      if (!p1Kept) p1Kept = p1PeggedAll;
      let p2Kept = p2ShowCards;
      if (!p2Kept && p2PeggedAll.length >= 4) p2Kept = p2PeggedAll;
      if (!p2Kept && p2Dealt) {
        p2Kept = p2Discards.length ? _ReplayModal.removeCards(p2Dealt, p2Discards) : p2Dealt.length === 4 ? p2Dealt : p2PeggedAll.length ? p2PeggedAll : p2Dealt;
      }
      if (!p2Kept && event.hands?.p2) p2Kept = [...event.hands.p2];
      if (!p2Kept) p2Kept = p2PeggedAll;
      const p1PlayedSoFar = [];
      const p2PlayedSoFar = [];
      for (let i = roundStartIdx; i <= curIdx; i++) {
        const e = events[i];
        if (e.type === "peg_play" && e.card) {
          if (e.who === "p1" || e.who === "you") p1PlayedSoFar.push(e.card);
          else if (e.who === "p2" || e.who === "cpu") p2PlayedSoFar.push(e.card);
        }
      }
      let p1Hand = [];
      let p2Hand = [];
      if (curIdx === roundStartIdx && event.type === "round_start") {
        p1Hand = [];
        p2Hand = [];
      } else if (event.type === "deal" && p1Dealt && p2Dealt) {
        p1Hand = p1Dealt;
        p2Hand = p2Dealt;
      } else if (isP1Scoring) {
        p1Hand = event.cards && event.cards.length ? [...event.cards] : p1Kept || [];
        p2Hand = _ReplayModal.removeCards(p2Kept || [], p2PlayedSoFar);
      } else if (isP2Scoring) {
        p1Hand = _ReplayModal.removeCards(p1Kept || [], p1PlayedSoFar);
        p2Hand = event.cards && event.cards.length ? [...event.cards] : p2Kept || [];
      } else if (isShowCrib) {
        p1Hand = p1Kept || [];
        p2Hand = p2Kept || [];
      } else {
        p1Hand = _ReplayModal.removeCards(p1Kept || [], p1PlayedSoFar);
        p2Hand = _ReplayModal.removeCards(p2Kept || [], p2PlayedSoFar);
      }
      let cribCards = [];
      if (isCribScoring && event.cards && event.cards.length) {
        cribCards = [...event.cards];
      } else if (isCribScoring && event.crib && event.crib.length) {
        cribCards = [...event.crib];
      } else if (isCribScoring && p1Discards.length && p2Discards.length) {
        cribCards = [...p1Discards, ...p2Discards];
      }
      let pileCards = [];
      let currentCount = 0;
      if (event.type === "peg_go" || event.type === "peg_reset" || isShowHand || isShowCrib || event.type === "round_start" || event.type === "deal" || event.type === "discard" || event.type === "starter_cut") {
        pileCards = [];
        currentCount = 0;
      } else {
        for (let i = roundStartIdx; i <= curIdx; i++) {
          const e = events[i];
          if (e.type === "peg_go" || e.type === "peg_reset" || e.type === "round_start") {
            pileCards = [];
            currentCount = 0;
          } else if (e.type === "peg_play") {
            if (currentCount >= 31) {
              pileCards = [];
              currentCount = 0;
            }
            if (e.card) {
              pileCards.push(e.card);
            }
            currentCount = e.countAfter !== void 0 ? e.countAfter : e.count !== void 0 ? e.count : currentCount;
          }
        }
      }
      let starterCard = null;
      if (hasCutOccurred) {
        starterCard = event.starter || null;
        if (!starterCard) {
          for (let i = roundStartIdx; i <= roundEndIdx; i++) {
            if (events[i].starter) {
              starterCard = events[i].starter;
              break;
            }
          }
        }
      }
      const isCurrentCard = (c) => Boolean(event.card && c && _ReplayModal.sameCard(c, event.card));
      let p1Pts = 0;
      let p1CombosList = [];
      if (isP1Scoring) {
        p1Pts = event.points !== void 0 && event.points !== null ? event.points : 0;
        p1CombosList = Array.isArray(event.combos) ? [...event.combos] : [];
        const scoringCards = p1Hand && p1Hand.length >= 4 ? p1Hand : event.cards && event.cards.length ? event.cards : p1Kept;
        if ((!p1Pts || !p1CombosList.length) && scoringCards && scoringCards.length >= 4) {
          try {
            const sc = CribbageScorer2.scoreHand(scoringCards, starterCard, false, rep.options || {});
            if (!p1Pts) p1Pts = sc.total;
            if (!p1CombosList.length) p1CombosList = sc.notes && sc.notes.length ? sc.notes : sc.lines;
          } catch (err) {
            console.warn("ReplayModal: error scoring P1 hand", err);
          }
        }
      }
      let p2Pts = 0;
      let p2CombosList = [];
      if (isP2Scoring) {
        p2Pts = event.points !== void 0 && event.points !== null ? event.points : 0;
        p2CombosList = Array.isArray(event.combos) ? [...event.combos] : [];
        const scoringCards = p2Hand && p2Hand.length >= 4 ? p2Hand : event.cards && event.cards.length ? event.cards : p2Kept;
        if ((!p2Pts || !p2CombosList.length) && scoringCards && scoringCards.length >= 4) {
          try {
            const sc = CribbageScorer2.scoreHand(scoringCards, starterCard, false, rep.options || {});
            if (!p2Pts) p2Pts = sc.total;
            if (!p2CombosList.length) p2CombosList = sc.notes && sc.notes.length ? sc.notes : sc.lines;
          } catch (err) {
            console.warn("ReplayModal: error scoring P2 hand", err);
          }
        }
      }
      let cribPts = 0;
      let cribCombosList = [];
      if (isCribScoring) {
        cribPts = event.points !== void 0 && event.points !== null ? event.points : 0;
        cribCombosList = Array.isArray(event.combos) ? [...event.combos] : [];
        const scoringCards = cribCards && cribCards.length >= 4 ? cribCards : event.cards || event.crib || [];
        if ((!cribPts || !cribCombosList.length) && scoringCards && scoringCards.length >= 4) {
          try {
            const sc = CribbageScorer2.scoreHand(scoringCards, starterCard, true, rep.options || {});
            if (!cribPts) cribPts = sc.total;
            if (!cribCombosList.length) cribCombosList = sc.notes && sc.notes.length ? sc.notes : sc.lines;
          } catch (err) {
            console.warn("ReplayModal: error scoring crib", err);
          }
        }
      }
      const activeShowPts = isCribScoring ? cribPts : isP1Scoring ? p1Pts : isP2Scoring ? p2Pts : 0;
      const activeShowCombos = isCribScoring ? cribCombosList : isP1Scoring ? p1CombosList : isP2Scoring ? p2CombosList : [];
      let runningP1 = 0;
      let runningP2 = 0;
      for (let i = roundStartIdx; i >= 0; i--) {
        const sc = events[i]?.scores;
        if (sc && (sc.p1 !== void 0 || sc.you !== void 0)) {
          runningP1 = sc.p1 !== void 0 ? sc.p1 : sc.you;
          runningP2 = sc.p2 !== void 0 ? sc.p2 : sc.cpu;
          break;
        }
      }
      const roundDealer = events[roundStartIdx]?.dealer;
      for (let i = roundStartIdx; i <= curIdx; i++) {
        const e = events[i];
        if (e.type === "peg_play" || e.type === "peg_go") {
          if (e.scores) {
            const ep1 = e.scores.p1 !== void 0 ? e.scores.p1 : e.scores.you;
            const ep2 = e.scores.p2 !== void 0 ? e.scores.p2 : e.scores.cpu;
            if (ep1 !== void 0 && ep1 !== null) runningP1 = ep1;
            if (ep2 !== void 0 && ep2 !== null) runningP2 = ep2;
          }
        } else if (e.type === "show_hand") {
          const isP1 = e.who === "p1" || e.who === "you";
          const isP2 = e.who === "p2" || e.who === "cpu";
          const pts = i === curIdx ? isP1 ? p1Pts : p2Pts : e.points || 0;
          if (isP1) {
            const scP1 = e.scores ? e.scores.p1 !== void 0 ? e.scores.p1 : e.scores.you : null;
            if (scP1 !== null && scP1 > runningP1) {
              runningP1 = scP1;
            } else {
              runningP1 += pts;
            }
          } else if (isP2) {
            const scP2 = e.scores ? e.scores.p2 !== void 0 ? e.scores.p2 : e.scores.cpu : null;
            if (scP2 !== null && scP2 > runningP2) {
              runningP2 = scP2;
            } else {
              runningP2 += pts;
            }
          }
        } else if (e.type === "show_crib") {
          const isP1 = e.who === "p1" || e.who === "you" || roundDealer === "p1" || roundDealer === "you";
          const pts = i === curIdx ? cribPts : e.points || 0;
          if (isP1) {
            const scP1 = e.scores ? e.scores.p1 !== void 0 ? e.scores.p1 : e.scores.you : null;
            if (scP1 !== null && scP1 > runningP1) {
              runningP1 = scP1;
            } else {
              runningP1 += pts;
            }
          } else {
            const scP2 = e.scores ? e.scores.p2 !== void 0 ? e.scores.p2 : e.scores.cpu : null;
            if (scP2 !== null && scP2 > runningP2) {
              runningP2 = scP2;
            } else {
              runningP2 += pts;
            }
          }
        } else if (i === curIdx && e.scores) {
          const ep1 = e.scores.p1 !== void 0 ? e.scores.p1 : e.scores.you;
          const ep2 = e.scores.p2 !== void 0 ? e.scores.p2 : e.scores.cpu;
          if (ep1 !== void 0 && ep1 !== null) runningP1 = ep1;
          if (ep2 !== void 0 && ep2 !== null) runningP2 = ep2;
        }
      }
      const s1 = runningP1;
      const s2 = runningP2;
      const pct1 = Math.min(100, Math.max(0, s1 / targetScore * 100));
      const pct2 = Math.min(100, Math.max(0, s2 / targetScore * 100));
      const p1ScoreEl = document.getElementById("repP1Score");
      if (p1ScoreEl) p1ScoreEl.innerHTML = `${s1} <span class="score-denom">/ ${targetScore}</span>`;
      const p2ScoreEl = document.getElementById("repP2Score");
      if (p2ScoreEl) p2ScoreEl.innerHTML = `${s2} <span class="score-denom">/ ${targetScore}</span>`;
      const p1FillEl = document.getElementById("repP1ScoreFill");
      if (p1FillEl) p1FillEl.style.width = `${pct1}%`;
      const p2FillEl = document.getElementById("repP2ScoreFill");
      if (p2FillEl) p2FillEl.style.width = `${pct2}%`;
      const roundNumEl = document.getElementById("repRoundNum");
      if (roundNumEl) roundNumEl.textContent = String(roundNum);
      const cardP1 = document.getElementById("repP1ScoreCard");
      if (cardP1) cardP1.classList.toggle("is-winner", (rep.winner === "p1" || rep.winner === "you") && _ReplayModal.currentStep === totalSteps - 1);
      const cardP2 = document.getElementById("repP2ScoreCard");
      if (cardP2) cardP2.classList.toggle("is-winner", (rep.winner === "p2" || rep.winner === "cpu") && _ReplayModal.currentStep === totalSteps - 1);
      const narrEl = document.getElementById("repNarrationText");
      if (narrEl) {
        let narrationText = event.narration || "Play progress...";
        if (isShowHand || isShowCrib) {
          const whoLabel = isCribScoring ? "Dealer Crib" : isP1Scoring ? p1.name : p2.name;
          const comboText = activeShowCombos.length ? ` (${activeShowCombos.map((c) => typeof c === "string" ? c : c.why || c.label || "").filter(Boolean).join(", ")})` : "";
          narrationText = `\u2B50 ${whoLabel} scores ${activeShowPts} points in ${isCribScoring ? "crib" : "hand"}${comboText}`;
        }
        narrEl.textContent = narrationText;
      }
      const narrIcon = document.getElementById("repNarrationIcon");
      if (narrIcon) {
        narrIcon.textContent = isShowCrib ? "\u{1F381}" : isShowHand ? "\u2B50" : event.type === "peg_play" ? "\u{1F0CF}" : "\u{1F4AC}";
      }
      const pauseNotice = document.getElementById("repPauseNotice");
      if (pauseNotice) {
        if (!_ReplayModal.isPlaying && (isShowHand || isShowCrib)) {
          const kind = isShowCrib ? "Crib" : isP1Scoring ? `${p1.name}'s Hand` : `${p2.name}'s Hand`;
          pauseNotice.textContent = `\u23F8 Paused on ${kind} Show (+${activeShowPts} pts) \u2014 Press \u25B6 Play or Spacebar to continue`;
          pauseNotice.style.display = "inline-flex";
        } else {
          pauseNotice.style.display = "none";
        }
      }
      const starterArea = document.getElementById("repStarterArea");
      if (starterArea) {
        starterArea.innerHTML = starterCard ? _ReplayModal.formatCardHtml(starterCard) : '<div class="replay-card replay-card-back">\u{1F0A0}</div>';
      }
      const cribBox = document.getElementById("repCribBox");
      if (cribBox) cribBox.classList.toggle("is-scoring", isCribScoring);
      const cribTitle = document.getElementById("repCribTitle");
      if (cribTitle) {
        cribTitle.innerHTML = `\u{1F381} Dealer Crib${isCribScoring ? ` <span class="replay-scoring-badge">+${cribPts} pts</span>` : ""}`;
      }
      const cribArea = document.getElementById("repCribArea");
      if (cribArea) {
        cribArea.innerHTML = cribCards && cribCards.length ? cribCards.map((c) => _ReplayModal.formatCardHtml(c)).join("") : '<span class="replay-dim-text">Hidden in crib</span>';
      }
      const cribCombosEl = document.getElementById("repCribCombos");
      if (cribCombosEl) {
        if (isCribScoring) {
          cribCombosEl.innerHTML = _ReplayModal.formatComboPills(cribCombosList, cribPts);
          cribCombosEl.style.display = "flex";
        } else {
          cribCombosEl.style.display = "none";
          cribCombosEl.innerHTML = "";
        }
      }
      const countBadge = document.getElementById("repCountBadge");
      if (countBadge) {
        countBadge.innerHTML = `Count: <strong>${currentCount}</strong> / 31`;
      }
      const pileArea = document.getElementById("repPileArea");
      if (pileArea) {
        pileArea.innerHTML = pileCards && pileCards.length ? pileCards.map((c, idx) => _ReplayModal.formatCardHtml(c, idx === pileCards.length - 1)).join("") : '<span class="replay-dim-text">No cards played yet this turn</span>';
      }
      const p1HandBox = document.getElementById("repP1HandBox");
      if (p1HandBox) p1HandBox.classList.toggle("is-scoring", isP1Scoring);
      const p1Label = document.getElementById("repP1HandLabel");
      if (p1Label) {
        p1Label.innerHTML = `${p1.name}'s Hand:${isP1Scoring ? ` <span class="replay-scoring-badge">+${p1Pts} pts</span>` : ""}`;
      }
      const p1HandArea = document.getElementById("repP1HandArea");
      if (p1HandArea) {
        p1HandArea.innerHTML = p1Hand && p1Hand.length ? p1Hand.map((c) => _ReplayModal.formatCardHtml(c, isCurrentCard(c))).join("") : '<span class="replay-dim-text">No cards</span>';
      }
      const p1CombosEl = document.getElementById("repP1Combos");
      if (p1CombosEl) {
        if (isP1Scoring) {
          p1CombosEl.innerHTML = _ReplayModal.formatComboPills(p1CombosList, p1Pts);
          p1CombosEl.style.display = "flex";
        } else {
          p1CombosEl.style.display = "none";
          p1CombosEl.innerHTML = "";
        }
      }
      const p2HandBox = document.getElementById("repP2HandBox");
      if (p2HandBox) p2HandBox.classList.toggle("is-scoring", isP2Scoring);
      const p2Label = document.getElementById("repP2HandLabel");
      if (p2Label) {
        p2Label.innerHTML = `${p2.name}'s Hand:${isP2Scoring ? ` <span class="replay-scoring-badge">+${p2Pts} pts</span>` : ""}`;
      }
      const p2HandArea = document.getElementById("repP2HandArea");
      if (p2HandArea) {
        p2HandArea.innerHTML = p2Hand && p2Hand.length ? p2Hand.map((c) => _ReplayModal.formatCardHtml(c, isCurrentCard(c))).join("") : '<span class="replay-dim-text">No cards</span>';
      }
      const p2CombosEl = document.getElementById("repP2Combos");
      if (p2CombosEl) {
        if (isP2Scoring) {
          p2CombosEl.innerHTML = _ReplayModal.formatComboPills(p2CombosList, p2Pts);
          p2CombosEl.style.display = "flex";
        } else {
          p2CombosEl.style.display = "none";
          p2CombosEl.innerHTML = "";
        }
      }
      const stepInfo = document.getElementById("repStepInfo");
      if (stepInfo) {
        stepInfo.innerHTML = `Step <strong>${_ReplayModal.currentStep + 1}</strong> of ${totalSteps} (Round ${roundNum})`;
      }
      const scrubber = document.getElementById("replayScrubber");
      if (scrubber) {
        scrubber.max = String(totalSteps - 1);
        if (Number(scrubber.value) !== _ReplayModal.currentStep) {
          scrubber.value = String(_ReplayModal.currentStep);
        }
      }
      const playBtn = document.getElementById("btnRepPlayPause");
      if (playBtn) {
        playBtn.textContent = _ReplayModal.isPlaying ? "\u23F8 Pause" : "\u25B6 Play";
      }
      document.querySelectorAll(".replay-speed-btn").forEach((btn) => {
        const spd = Number(btn.getAttribute("data-speed"));
        btn.classList.toggle("is-active", _ReplayModal.playbackSpeed === spd);
      });
      const chkPause = document.getElementById("chkAutoPauseShow");
      if (chkPause && chkPause.checked !== _ReplayModal.autoPauseOnShow) {
        chkPause.checked = _ReplayModal.autoPauseOnShow;
      }
    }
    /**
     * Binds interaction events for the interactive player view.
     */
    static bindPlayerEvents() {
      const el = document.getElementById(_ReplayModal.MODAL_ID);
      if (!el) return;
      el.querySelector("#btnReplayClose")?.addEventListener("click", () => _ReplayModal.close());
      el.querySelector("#btnReplayBackToLib")?.addEventListener("click", () => _ReplayModal.openLibrary());
      el.querySelector("#btnRepPlayPause")?.addEventListener("click", () => _ReplayModal.togglePlayPause());
      el.querySelector("#btnRepStepForward")?.addEventListener("click", () => _ReplayModal.stepForward());
      el.querySelector("#btnRepStepBack")?.addEventListener("click", () => _ReplayModal.stepBackward());
      el.querySelector("#btnRepPrevRound")?.addEventListener("click", () => _ReplayModal.jumpRound(-1));
      el.querySelector("#btnRepNextRound")?.addEventListener("click", () => _ReplayModal.jumpRound(1));
      const chkPause = el.querySelector("#chkAutoPauseShow");
      if (chkPause) {
        chkPause.addEventListener("change", (e) => {
          _ReplayModal.autoPauseOnShow = Boolean(e.target.checked);
        });
      }
      const scrubber = el.querySelector("#replayScrubber");
      if (scrubber) {
        scrubber.addEventListener("input", (e) => {
          _ReplayModal.goToStep(Number(e.target.value));
        });
      }
      el.querySelectorAll(".replay-speed-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
          const spd = Number(btn.getAttribute("data-speed")) || 1;
          _ReplayModal.setPlaybackSpeed(spd);
        });
      });
    }
    /**
     * Jumps timeline to specific step.
     * @param {number} step
     */
    static goToStep(step) {
      if (!_ReplayModal.activeReplay) return;
      const events = _ReplayModal.activeReplay.events || [];
      const target = Math.max(0, Math.min(events.length - 1, step));
      _ReplayModal.currentStep = target;
      _ReplayModal.renderPlayer();
    }
    /**
     * Steps forward 1 event in the timeline.
     * @param {boolean} [isAutoPlay=false] - Whether triggered by the auto-playback timer
     */
    static stepForward(isAutoPlay = false) {
      if (!_ReplayModal.activeReplay) return;
      const events = _ReplayModal.activeReplay.events || [];
      if (_ReplayModal.currentStep < events.length - 1) {
        const nextStep = _ReplayModal.currentStep + 1;
        _ReplayModal.goToStep(nextStep);
        if (isAutoPlay && _ReplayModal.autoPauseOnShow) {
          const nextEv = events[nextStep];
          if (nextEv && (nextEv.type === "show_hand" || nextEv.type === "show_crib")) {
            _ReplayModal.stopPlayback();
            _ReplayModal.renderPlayer();
          }
        }
      } else {
        _ReplayModal.stopPlayback();
      }
    }
    /**
     * Steps backward 1 event in the timeline.
     */
    static stepBackward() {
      if (!_ReplayModal.activeReplay) return;
      if (_ReplayModal.currentStep > 0) {
        _ReplayModal.goToStep(_ReplayModal.currentStep - 1);
      }
    }
    /**
     * Jumps to the beginning of the next or previous round.
     * @param {number} delta - -1 for prev round, 1 for next round
     */
    static jumpRound(delta) {
      if (!_ReplayModal.activeReplay) return;
      const events = _ReplayModal.activeReplay.events || [];
      const curEvent = events[_ReplayModal.currentStep] || {};
      const curRound = curEvent.round || 1;
      if (delta > 0) {
        const idx = events.findIndex((e) => e.round > curRound);
        if (idx !== -1) _ReplayModal.goToStep(idx);
        else _ReplayModal.goToStep(events.length - 1);
      } else {
        let idx = -1;
        for (let i = _ReplayModal.currentStep - 1; i >= 0; i--) {
          if (events[i].round < curRound) {
            const targetRound = events[i].round;
            idx = events.findIndex((e) => e.round === targetRound);
            break;
          }
        }
        _ReplayModal.goToStep(idx !== -1 ? idx : 0);
      }
    }
    /**
     * Toggles playback play / pause state.
     */
    static togglePlayPause() {
      if (_ReplayModal.isPlaying) {
        _ReplayModal.stopPlayback();
      } else {
        _ReplayModal.startPlayback();
      }
    }
    /**
     * Starts automatic playback.
     */
    static startPlayback() {
      if (!_ReplayModal.activeReplay) return;
      _ReplayModal.stopPlayback();
      _ReplayModal.isPlaying = true;
      const events = _ReplayModal.activeReplay.events || [];
      if (_ReplayModal.currentStep >= events.length - 1) {
        _ReplayModal.currentStep = 0;
        _ReplayModal.goToStep(0);
      }
      const notice = document.getElementById("repPauseNotice");
      if (notice) notice.style.display = "none";
      const interval = Math.max(250, Math.round(1200 / _ReplayModal.playbackSpeed));
      _ReplayModal.playbackTimer = setInterval(() => {
        if (_ReplayModal.currentStep < events.length - 1) {
          _ReplayModal.stepForward(true);
        } else {
          _ReplayModal.stopPlayback();
        }
      }, interval);
      const btn = document.getElementById("btnRepPlayPause");
      if (btn) btn.textContent = "\u23F8 Pause";
    }
    /**
     * Stops automatic playback.
     */
    static stopPlayback() {
      _ReplayModal.isPlaying = false;
      if (_ReplayModal.playbackTimer) {
        clearInterval(_ReplayModal.playbackTimer);
        _ReplayModal.playbackTimer = null;
      }
      const btn = typeof document !== "undefined" ? document.getElementById("btnRepPlayPause") : null;
      if (btn) btn.textContent = "\u25B6 Play";
    }
    /**
     * Adjusts playback speed.
     * @param {number} speed - 0.5, 1, 2, or 4
     */
    static setPlaybackSpeed(speed) {
      _ReplayModal.playbackSpeed = speed;
      if (_ReplayModal.isPlaying) {
        _ReplayModal.startPlayback();
      }
      document.querySelectorAll(".replay-speed-btn").forEach((btn) => {
        const spd = Number(btn.getAttribute("data-speed"));
        btn.classList.toggle("is-active", _ReplayModal.playbackSpeed === spd);
      });
    }
    /**
     * Renders the saved replays library view separated by brand.
     * @param {string} [brandFilter=null]
     */
    static renderLibrary(brandFilter = null) {
      const overlay = document.getElementById(_ReplayModal.OVERLAY_ID);
      if (!overlay) return;
      _ReplayModal._currentView = "library";
      _ReplayModal._renderedReplayId = null;
      if (brandFilter !== null && brandFilter !== void 0) {
        _ReplayModal._selectedBrand = brandFilter;
      }
      const currentBrand = _ReplayModal._selectedBrand || "all";
      const replays = GameReplayManager.loadReplays();
      const autoRecord = GameReplayManager.isAutoRecordEnabled();
      const brands = typeof GAME_BRANDS !== "undefined" && Array.isArray(GAME_BRANDS) ? GAME_BRANDS : [
        { id: "crazy", name: "Crazy Cribbage", shortName: "Crazy", icon: "\u{1F0CF}", color: "#facc15", badgeBg: "rgba(245, 158, 11, 0.2)", border: "rgba(245, 158, 11, 0.4)" },
        { id: "clash", name: "Cribbage Clash", shortName: "Clash", icon: "\u2694\uFE0F", color: "#38bdf8", badgeBg: "rgba(56, 189, 248, 0.2)", border: "rgba(56, 189, 248, 0.4)" },
        { id: "pints", name: "Pints & Pegs", shortName: "Pints", icon: "\u{1F37A}", color: "#10b981", badgeBg: "rgba(16, 185, 129, 0.2)", border: "rgba(16, 185, 129, 0.4)" },
        { id: "adult", name: "Skunked & Stripped", shortName: "Adult", icon: "\u{1F9A8}", color: "#ec4899", badgeBg: "rgba(244, 63, 94, 0.2)", border: "rgba(244, 63, 94, 0.4)" }
      ];
      const counts = {
        all: replays.length,
        crazy: replays.filter((r) => (r.brand || "crazy") === "crazy").length,
        clash: replays.filter((r) => (r.brand || "crazy") === "clash").length,
        pints: replays.filter((r) => (r.brand || "crazy") === "pints").length,
        adult: replays.filter((r) => (r.brand || "crazy") === "adult").length
      };
      const renderCard = (r) => {
        const bId = r.brand || "crazy";
        const bObj = brands.find((b) => b.id === bId) || brands[0];
        const p1 = r.players?.p1 || { name: "You", avatar: "\u{1F920}" };
        const p2 = r.players?.p2 || { name: "Computer", avatar: "\u{1F916}" };
        const s1 = r.finalScores?.p1 || 0;
        const s2 = r.finalScores?.p2 || 0;
        const isWinnerP1 = r.winner === "p1" || r.winner === "you";
        return `
        <div class="replay-card-item rep-card-${bId}" data-id="${r.id}" style="border: 1.5px solid ${bObj.border}; background: rgba(18, 14, 28, 0.65); box-shadow: 0 4px 15px rgba(0,0,0,0.35);">
          <div class="rep-card-top" style="display:flex; justify-content:space-between; align-items:center;">
            <span class="rep-badge-brand" style="color:${bObj.color}; background:${bObj.badgeBg}; border:1px solid ${bObj.border}; padding:2px 8px; border-radius:12px; font-weight:800; font-size:0.73rem;">
              ${bObj.icon} ${r.brandLabel || bObj.name}
            </span>
            <span class="rep-badge-date" style="font-size:0.72rem; color:#94a3b8;">${r.dateLabel || "Match"}</span>
          </div>

          <div class="rep-card-matchup">
            <div class="rep-player-col ${isWinnerP1 ? "is-winner" : ""}">
              <span class="rep-player-avatar">${p1.avatar || "\u{1F920}"}</span>
              <span class="rep-player-name">${p1.name}</span>
              <span class="rep-player-score">${s1}</span>
            </div>
            <div class="rep-vs-divider">VS</div>
            <div class="rep-player-col ${!isWinnerP1 ? "is-winner" : ""}">
              <span class="rep-player-avatar">${p2.avatar || "\u{1F916}"}</span>
              <span class="rep-player-name">${p2.name}</span>
              <span class="rep-player-score">${s2}</span>
            </div>
          </div>

          <div class="rep-card-bottom">
            <div class="rep-winner-tag">
              \u{1F3C6} Winner: <strong>${r.winnerName || "Winner"}</strong> ${r.skunkKind ? `<span class="skunk-tag">${r.skunkKind.toUpperCase()} SKUNK</span>` : ""}
            </div>
            <div class="rep-actions-row">
              <button type="button" class="btn-gold btn-play-rep" data-id="${r.id}">\u25B6 Watch Replay</button>
              <button type="button" class="btn-ghost btn-del-rep" data-id="${r.id}" title="Delete Replay">\u{1F5D1}</button>
            </div>
          </div>
        </div>
      `;
      };
      overlay.innerHTML = `
      <div class="replay-modal-wrap replay-library-wrap" id="${_ReplayModal.MODAL_ID}">
        <!-- Header -->
        <div class="replay-header">
          <div class="replay-header-left">
            <h2 class="replay-title">\u{1F3AC} Game Replays Library</h2>
            <p class="replay-subtitle">Watch and review your past matches move-by-move across all 4 games.</p>
          </div>
          <div class="replay-header-right">
            <button type="button" class="btn-ghost replay-btn-close" id="btnLibClose" title="Close">\u2715</button>
          </div>
        </div>

        <!-- Brand & Game Filter Dropdown (replaces overflowing horizontal scrollbar) -->
        <div class="replay-brand-nav-tabs replay-brand-nav-dropdown-row" id="replayBrandFilterRow" style="display:flex; align-items:center; justify-content:space-between; gap:10px; padding:10px 20px; background:rgba(0,0,0,0.38); border-bottom:1px solid rgba(240,198,74,0.2); flex-wrap:wrap; overflow:visible;">
          <div style="display:flex; align-items:center; gap:8px;">
            <span style="font-size:1.15rem;">\u{1F3AF}</span>
            <label for="selectReplayBrandFilter" style="font-size:0.84rem; font-weight:800; color:#f0c64a; text-transform:uppercase; letter-spacing:0.04em;">
              Filter Replays By Game:
            </label>
          </div>
          <div style="flex:1; min-width:240px; position:relative;">
            <select id="selectReplayBrandFilter" class="replay-brand-select" aria-label="Filter replays by game or brand" style="width:100%; padding:8px 32px 8px 12px; border-radius:8px; border:1.5px solid #f0c64a; background:#0f172a; color:#f0c64a; font-weight:700; font-size:0.9rem; cursor:pointer; outline:none; appearance:none; -webkit-appearance:none; box-shadow:0 2px 8px rgba(0,0,0,0.4);">
              <option value="all" ${currentBrand === "all" ? "selected" : ""}>\u{1F310} All Brands (${counts.all} ${counts.all === 1 ? "Replay" : "Replays"})</option>
              ${brands.map((b) => `
                <option value="${b.id}" ${currentBrand === b.id ? "selected" : ""}>${b.icon} ${b.name} (${counts[b.id]} ${counts[b.id] === 1 ? "Replay" : "Replays"})</option>
              `).join("")}
            </select>
            <span style="position:absolute; right:12px; top:50%; transform:translateY(-50%); pointer-events:none; color:#f0c64a; font-size:0.75rem;">\u25BC</span>
          </div>
        </div>

        <!-- Toolbar & Quick Actions -->
        <div class="replay-lib-toolbar">
          <div class="replay-lib-toolbar-left">
            <label class="replay-toggle-label" title="Automatically record every completed game">
              <input type="checkbox" id="chkAutoRecord" ${autoRecord ? "checked" : ""} />
              <span>Auto-Record Matches</span>
            </label>
          </div>
        </div>

        <!-- Replay Match Cards List -->
        <div class="replay-list-container">
          ${replays.length === 0 ? `
            <div class="replay-empty-state">
              <div class="empty-icon">\u{1F3AC}</div>
              <h3>No Recorded Games Yet</h3>
              <p>Play a match against the computer or online with friends across any of the 4 games, and your full game replay will appear here!</p>
            </div>
          ` : currentBrand === "all" ? `
            <!-- All Brands View Separated by Brand -->
            ${brands.map((b) => {
        const brandReplays = replays.filter((r) => (r.brand || "crazy") === b.id);
        return `
                <div class="rep-brand-section" data-brand="${b.id}" style="margin-bottom: 24px;">
                  <div class="rep-brand-header" style="display:flex; justify-content:space-between; align-items:center; padding:9px 14px; border-radius:8px; border:1px solid ${b.border}; border-left:4px solid ${b.color}; background: linear-gradient(90deg, ${b.badgeBg}, rgba(0,0,0,0.3)); margin-bottom:12px;">
                    <div style="display:flex; align-items:center; gap:8px;">
                      <span style="font-size:1.3rem;">${b.icon}</span>
                      <span style="color:${b.color}; font-weight:800; font-size:1.02rem;">${b.name}</span>
                    </div>
                    <span style="background:${b.badgeBg}; border:1px solid ${b.border}; color:${b.color}; padding:2px 8px; border-radius:12px; font-size:0.75rem; font-weight:800;">
                      ${brandReplays.length} ${brandReplays.length === 1 ? "Replay" : "Replays"}
                    </span>
                  </div>
                  ${brandReplays.length === 0 ? `
                    <div class="rep-brand-empty-hint" style="font-size:0.82rem; color:#94a3b8; font-style:italic; padding:12px 14px; background:rgba(0,0,0,0.2); border-radius:8px; border:1px dashed rgba(244,234,212,0.1); text-align:center;">
                      No ${b.name} replays saved yet. Play a match in ${b.name} to save your gameplay!
                    </div>
                  ` : `
                    <div class="replay-grid">
                      ${brandReplays.map(renderCard).join("")}
                    </div>
                  `}
                </div>
              `;
      }).join("")}
          ` : (() => {
        const b = brands.find((item) => item.id === currentBrand) || brands[0];
        const brandReplays = replays.filter((r) => (r.brand || "crazy") === b.id);
        return `
              <!-- Single Brand View -->
              <div class="rep-brand-section rep-brand-section-focused" data-brand="${b.id}">
                <div class="rep-brand-header" style="display:flex; justify-content:space-between; align-items:center; padding:9px 14px; border-radius:8px; border:1px solid ${b.border}; border-left:4px solid ${b.color}; background: linear-gradient(90deg, ${b.badgeBg}, rgba(0,0,0,0.3)); margin-bottom:12px;">
                  <div style="display:flex; align-items:center; gap:8px;">
                    <span style="font-size:1.3rem;">${b.icon}</span>
                    <span style="color:${b.color}; font-weight:800; font-size:1.02rem;">${b.name} Replays</span>
                  </div>
                  <span style="background:${b.badgeBg}; border:1px solid ${b.border}; color:${b.color}; padding:2px 8px; border-radius:12px; font-size:0.75rem; font-weight:800;">
                    ${brandReplays.length} ${brandReplays.length === 1 ? "Replay" : "Replays"}
                  </span>
                </div>
                ${brandReplays.length === 0 ? `
                  <div class="replay-empty-state">
                    <div class="empty-icon">${b.icon}</div>
                    <h3>No Recorded ${b.name} Games Yet</h3>
                    <p>Play a match in ${b.name}, and your full game replay will appear here!</p>
                  </div>
                ` : `
                  <div class="replay-grid">
                    ${brandReplays.map(renderCard).join("")}
                  </div>
                `}
              </div>
            `;
      })()}
        </div>
      </div>
    `;
      _ReplayModal.bindLibraryEvents();
    }
    /**
     * Binds interaction events for the library view.
     */
    static bindLibraryEvents() {
      const el = document.getElementById(_ReplayModal.MODAL_ID);
      if (!el) return;
      el.querySelector("#btnLibClose")?.addEventListener("click", () => _ReplayModal.close());
      const brandSelect = el.querySelector("#selectReplayBrandFilter");
      if (brandSelect) {
        brandSelect.addEventListener("change", (e) => {
          _ReplayModal.renderLibrary(e.target.value);
        });
      }
      el.querySelectorAll(".replay-brand-tab").forEach((btn) => {
        btn.addEventListener("click", () => {
          const bId = btn.getAttribute("data-brand") || "all";
          _ReplayModal.renderLibrary(bId);
        });
      });
      const chk = el.querySelector("#chkAutoRecord");
      if (chk) {
        chk.addEventListener("change", (e) => {
          GameReplayManager.setAutoRecordEnabled(e.target.checked);
        });
      }
      el.querySelectorAll(".btn-play-rep").forEach((btn) => {
        btn.addEventListener("click", () => {
          const id = btn.getAttribute("data-id");
          _ReplayModal.open(id);
        });
      });
      el.querySelectorAll(".btn-del-rep").forEach((btn) => {
        btn.addEventListener("click", () => {
          const id = btn.getAttribute("data-id");
          if (confirm("Delete this recorded replay?")) {
            GameReplayManager.deleteReplay(id);
            _ReplayModal.renderLibrary(_ReplayModal._selectedBrand);
          }
        });
      });
    }
    /**
     * Displays the share / export dialog for a specific replay.
     * @param {Object} replay
     */
    static async openShareDialog(replay) {
      if (!replay) return;
      let shareUrl = "";
      try {
        shareUrl = await GameReplayManager.generateShareUrl(replay);
      } catch (_) {
      }
      const dialogId = "crazyReplayShareDialog";
      let dialog = document.getElementById(dialogId);
      if (!dialog) {
        dialog = document.createElement("div");
        dialog.id = dialogId;
        dialog.className = "replay-share-dialog";
        document.body.appendChild(dialog);
      }
      dialog.innerHTML = `
      <div class="replay-share-box">
        <div class="share-box-header">
          <h3>\u{1F4E4} Share Match Replay</h3>
          <button type="button" class="btn-ghost share-box-close" id="btnCloseShareDialog">\u2715</button>
        </div>
        <p class="share-box-desc">Share this game with friends so they can watch the match play out move-by-move!</p>

        <div class="share-options-list">
          <!-- 1. Download File -->
          <div class="share-option-card">
            <div class="share-card-info">
              <strong>\u{1F4E5} Download Replay File (.cribbage.json)</strong>
              <span>Save the match file locally to share or store.</span>
            </div>
            <button type="button" class="btn-gold replay-btn-sm" id="btnDlReplayFile">Download File</button>
          </div>

          <!-- 2. Copy Share Link -->
          ${shareUrl ? `
            <div class="share-option-card">
              <div class="share-card-info">
                <strong>\u{1F517} Shareable Web Link</strong>
                <span>Open directly in any browser with zero setup.</span>
              </div>
              <button type="button" class="btn-gold replay-btn-sm" id="btnCopyShareUrl">Copy Link</button>
            </div>
          ` : ""}

          <!-- 3. Copy JSON to Clipboard -->
          <div class="share-option-card">
            <div class="share-card-info">
              <strong>\u{1F4CB} Copy Replay JSON</strong>
              <span>Copy full match events string to clipboard.</span>
            </div>
            <button type="button" class="btn-ghost replay-btn-sm" id="btnCopyReplayJson">Copy JSON</button>
          </div>
        </div>
      </div>
    `;
      dialog.style.display = "flex";
      const replayOverlay = document.getElementById(_ReplayModal.OVERLAY_ID);
      const isReplayOverlayOpen = Boolean(replayOverlay && replayOverlay.style.display !== "none");
      const closeDialog = () => {
        dialog.style.display = "none";
        if (typeof window !== "undefined") {
          window.removeEventListener("keydown", onShareDialogKeydown);
        }
        if (!isReplayOverlayOpen) {
          const isGameOver = typeof window !== "undefined" && (window.state && window.state.over || window._lastGameOverHtml);
          if (isGameOver) {
            if (typeof window !== "undefined" && typeof window.showGameWonModal === "function") {
              window.showGameWonModal();
            } else if (typeof GameEngine !== "undefined" && typeof GameEngine.showGameWonModal === "function") {
              GameEngine.showGameWonModal();
            }
          }
        }
      };
      const onShareDialogKeydown = (e) => {
        if (e.key === "Escape" && dialog.style.display !== "none") {
          e.preventDefault();
          e.stopPropagation();
          closeDialog();
        }
      };
      if (typeof window !== "undefined") {
        window.addEventListener("keydown", onShareDialogKeydown);
      }
      dialog.onclick = (e) => {
        if (e.target === dialog) {
          closeDialog();
        }
      };
      dialog.querySelector("#btnCloseShareDialog")?.addEventListener("click", closeDialog);
      dialog.querySelector("#btnDlReplayFile")?.addEventListener("click", () => {
        GameReplayManager.exportReplayFile(replay);
        if (typeof GameReplayManager !== "undefined" && GameReplayManager.showToast) {
          GameReplayManager.showToast("Replay file downloaded!", 2500);
        } else if (typeof window !== "undefined" && window.showScoreToast) {
          window.showScoreToast("Replay file downloaded!", 2500);
        }
      });
      dialog.querySelector("#btnCopyShareUrl")?.addEventListener("click", async () => {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(shareUrl);
          if (typeof GameReplayManager !== "undefined" && GameReplayManager.showToast) {
            GameReplayManager.showToast("Share link copied to clipboard!", 2500);
          } else if (typeof window !== "undefined" && window.showScoreToast) {
            window.showScoreToast("Share link copied to clipboard!", 2500);
          }
        } else {
          prompt("Copy your replay share link:", shareUrl);
        }
      });
      dialog.querySelector("#btnCopyReplayJson")?.addEventListener("click", async () => {
        const json = JSON.stringify(replay, null, 2);
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(json);
          if (typeof GameReplayManager !== "undefined" && GameReplayManager.showToast) {
            GameReplayManager.showToast("Replay JSON copied to clipboard!", 2500);
          } else if (typeof window !== "undefined" && window.showScoreToast) {
            window.showScoreToast("Replay JSON copied to clipboard!", 2500);
          }
        } else {
          prompt("Copy your replay JSON:", json);
        }
      });
    }
  };
  if (typeof window !== "undefined") {
    window.ReplayModal = ReplayModal;
  }

  // src/app/CrazyCribbageApp.js
  var import_game_options_engine = __toESM(require_game_options_engine(), 1);
  var GameOptionsEngine = import_game_options_engine.default;
  if (typeof window !== "undefined" && window.GameOptionsEngine) {
    GameOptionsEngine = window.GameOptionsEngine;
  }
  var active = {};
  var CCProxy = new Proxy({}, {
    get(target, prop) {
      if (typeof window !== "undefined" && window.CrazyCribbage && window.CrazyCribbage[prop] !== void 0) {
        const val2 = window.CrazyCribbage[prop];
        return typeof val2 === "function" ? val2.bind(window.CrazyCribbage) : val2;
      }
      const val = active[prop];
      return typeof val === "function" ? val.bind(active) : val;
    }
  });
  var MODULES = {
    ...BoardGeometry_exports,
    getTrackXY,
    Card: Card2,
    Deck: Deck2,
    Hand,
    Player,
    SEAT_COLORS,
    Roster,
    CribbageScorer: CribbageScorer2,
    combinations: combinations2,
    isConsecutiveRun: isConsecutiveRun2,
    BoardRenderer,
    PegTracker,
    GameState,
    GameEngine: GameEngine2,
    PintsManager,
    PINTS_OPTIONS_DEFS,
    AdultManager,
    ADULT_OPTIONS_DEFS,
    ClashManager,
    CribbageAI,
    ObstacleGeometry,
    AudioManager,
    NetworkManager: NetworkManager2,
    ROOM_CODE_CHARS,
    ModalManager: ModalManager2,
    SettingsManager,
    UIController,
    PintsSettings,
    AdultSettings,
    ClashSettings,
    ClashPlacementModal,
    ShowModal,
    CelebrationFX,
    AchievementManager,
    LobbyController,
    ClashMiniGames,
    TableRenderer,
    DropdownHelpManager,
    CoachController,
    CrazyManager,
    CRAZY_OPTIONS_DEFS,
    CrazySettings,
    DiscardTrainer,
    HandScoreTracker,
    HandOfGloryCard,
    ClashPresets,
    CLASH_PRESETS_481,
    PintsPresets,
    PINTS_PRESETS_121,
    AdultPresets,
    ADULT_PRESETS_121,
    ClashSandboxModal,
    IndexedDBStorage,
    appStorage,
    CardAssassinOverlay,
    JailAnimationOverlay,
    BarAnimationOverlay,
    CannonAnimationOverlay,
    SpeedTrapAnimationOverlay,
    ScenicRouteAnimationOverlay,
    GameReplayManager,
    ReplayModal
  };
  var CC2 = typeof window !== "undefined" && window.CrazyCribbage || MODULES;
  var _suppressSettingsSave = true;
  var RANKS2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
  var RANK_NAME2 = { 1: "A", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", 10: "10", 11: "J", 12: "Q", 13: "K" };
  var SUITS2 = ["S", "H", "D", "C"];
  var SUIT_SYM2 = { S: "\u2660", H: "\u2665", D: "\u2666", C: "\u2663" };
  var VAL3 = (r) => r >= 10 ? 10 : r;
  var BOARD_CFG2 = CC2 && CC2.BOARD_CFG || { viewW: 820, viewH: 216, st1Y: 54, st2Y: 108, st3Y: 162, trackOffset: { p1: -15, p2: -10, p3: -5, p4: 0, p5: 5, p6: 10, p7: 15, p8: 20, you: -6, cpu: 6, team1: -6, team2: 6, team3: 0, team4: 6 }, xStart: 85, xEnd: 715 };
  var BOARD_CFG_4812 = CC2 && CC2.BOARD_CFG_481 || { viewW: 820, viewH: 438, stY: [42, 86, 130, 174, 218, 262, 306, 350], finishY: 394, xStart: 75, xEnd: 745 };
  function getClashBoardCfg2(target) {
    return CC2 && CC2.getClashBoardCfg ? CC2.getClashBoardCfg(target) : { numRows: 8, viewW: 820, viewH: 438, stY: [42, 86, 130, 174, 218, 262, 306, 350], finishY: 394, xStart: 75, xEnd: 745 };
  }
  var pegState = CC2 && CC2.PegTracker ? new CC2.PegTracker().toPlain() : {
    p1: { front: 0, rear: 0 },
    p2: { front: 0, rear: 0 },
    p3: { front: 0, rear: 0 },
    p4: { front: 0, rear: 0 },
    p5: { front: 0, rear: 0 },
    p6: { front: 0, rear: 0 },
    p7: { front: 0, rear: 0 },
    p8: { front: 0, rear: 0 },
    team1: { front: 0, rear: 0 },
    team2: { front: 0, rear: 0 },
    team3: { front: 0, rear: 0 },
    team4: { front: 0, rear: 0 },
    you: { front: 0, rear: 0 },
    cpu: { front: 0, rear: 0 }
  };
  function getTrackXY2(holeNum, who, forcedTarget = null) {
    if (CC2?.getTrackXY) {
      let resolvedTarget = null;
      let extraOpts = null;
      if (typeof forcedTarget === "object" && forcedTarget !== null) {
        resolvedTarget = forcedTarget.target;
        extraOpts = forcedTarget;
      } else if (typeof forcedTarget === "number") {
        resolvedTarget = forcedTarget;
      }
      resolvedTarget = resolvedTarget || typeof window !== "undefined" && window._clashBoardTarget || settings2?.target || typeof document !== "undefined" && document.getElementById("optTarget") && parseInt(document.getElementById("optTarget").value, 10) || 121;
      const brand = typeof getAppBrand === "function" ? getAppBrand() : "crazy";
      if (brand === "clash" && ![241, 361, 481].includes(resolvedTarget)) {
        resolvedTarget = 481;
      }
      const isFixed = typeof isFixedTeams === "function" ? isFixedTeams() : false;
      const opts = Object.assign({
        playerCount: settings2?.playerCount || (isFixed ? 4 : 2),
        isFixedTeams: isFixed,
        getSeatTeam: typeof getSeatTeam === "function" ? getSeatTeam : null,
        optNoPassingLanes: Boolean(settings2?.optNoPassingLanes)
      }, extraOpts || {});
      return CC2.getTrackXY(holeNum, who, resolvedTarget, opts);
    }
  }
  function parseGameMode(val) {
    return CC2?.SettingsManager?.parseGameMode?.(val);
  }
  function serializeGameMode(playerCount, gameMode) {
    return CC2?.SettingsManager?.serializeGameMode?.(playerCount, gameMode);
  }
  function isOnline() {
    return Boolean(settings2 && settings2.opp === "online");
  }
  function isHvH() {
    return CC2?.SettingsManager?.isHvH?.(settings2, { getAppBrand, GameOptionsEngine });
  }
  function isTwoHuman() {
    return CC2 && CC2.Roster && CC2.Roster.isTwoHuman({ isHvH, isOnline });
  }
  function isSoloVsPairs() {
    return CC2 && CC2.Roster && CC2.Roster.isSoloVsPairs(settings2);
  }
  function is3Player1vs2() {
    return CC2 && CC2.Roster && CC2.Roster.is3Player1vs2(settings2);
  }
  function is5Player1vs4() {
    return CC2 && CC2.Roster && CC2.Roster.is5Player1vs4(settings2);
  }
  function is7Player1vs6() {
    return CC2 && CC2.Roster && CC2.Roster.is7Player1vs6(settings2);
  }
  function isFixedTeams() {
    return CC2 && CC2.Roster && CC2.Roster.isFixedTeams(settings2);
  }
  function isPartnership() {
    return CC2 && CC2.Roster && CC2.Roster.isPartnership(settings2);
  }
  function isShiftingPartnership() {
    return false;
  }
  function mySeat2() {
    return CC2 && CC2.Roster ? CC2.Roster.mySeat({ isOnline, net, settings: settings2 }) : "p1";
  }
  function getPlayerCount() {
    return CC2 && CC2.Roster ? CC2.Roster.getPlayerCount(settings2) : 2;
  }
  function getRoster() {
    return CC2 && CC2.Roster && CC2.Roster.getRoster({ settings: settings2, isHvH, isOnline });
  }
  function getActiveSeats() {
    return CC2 && CC2.Roster ? CC2.Roster.getActiveSeats(settings2) : [];
  }
  function getActiveSeatIds() {
    return CC2 && CC2.Roster ? CC2.Roster.getActiveSeatIds({ getRoster, settings: settings2 }) : [];
  }
  function getSeatTeam(sId) {
    return CC2?.Roster?.getSeatTeam?.(sId, { is3Player1vs2, settings: settings2 });
  }
  function getShiftingRoles() {
    return CC2?.Roster?.getShiftingRoles?.({ isShiftingPartnership, getActiveSeatIds, state: state2 });
  }
  function getShiftingPartner(seatId) {
    return CC2?.Roster?.getShiftingPartner?.(seatId, { getShiftingRoles });
  }
  function nextSeat(seatId) {
    return CC2?.GameEngine?.advanceDealer?.(seatId, getActiveSeatIds()) || "p1";
  }
  function prevSeat(seatId) {
    return CC2?.Roster?.prevSeat?.(seatId, getActiveSeatIds());
  }
  function getSeat(seatId) {
    return CC2?.Roster?.getSeat?.(seatId, { getRoster, settings: settings2 });
  }
  function getSeatHand(seatId) {
    return CC2?.GameState?.getSeatHand?.(state2, seatId);
  }
  function setSeatHand(seatId, cards) {
    return CC2?.GameState?.setSeatHand?.(state2, seatId, cards);
  }
  function getSeatKept(seatId) {
    return CC2?.GameState?.getSeatKept?.(state2, seatId);
  }
  function setSeatKept(seatId, cards) {
    return CC2?.GameState?.setSeatKept?.(state2, seatId, cards);
  }
  function getSeatHandModel(sId) {
    const c = getSeatHand(sId);
    return CC2 && CC2.Hand ? new CC2.Hand(c) : c;
  }
  function getSeatKeptModel(sId) {
    const c = getSeatKept(sId);
    return CC2 && CC2.Hand ? new CC2.Hand(c) : c;
  }
  function getCribModel() {
    const c = state2 && state2.crib || [];
    return CC2 && CC2.Hand ? new CC2.Hand(c) : c;
  }
  function getPileModel() {
    const c = state2 && state2.pile || [];
    return CC2 && CC2.Hand ? new CC2.Hand(c) : c;
  }
  function seatName2(seatId) {
    return CC2?.Roster?.seatName?.(seatId, { isOnline, mySeat: mySeat2, getSeat, settings: settings2, isHvH });
  }
  function pName(who) {
    return CC2?.Roster?.pName?.(who, { seatName: seatName2, isSoloVsPairs, is3Player1vs2, is5Player1vs4, is7Player1vs6, getPlayerCount });
  }
  function seatColor(seatId) {
    return CC2?.Roster?.seatColor?.(seatId);
  }
  function isSeatCpu(seatId) {
    if (!seatId || typeof seatId !== "string") return false;
    return CC2?.Roster?.isSeatCpu?.(seatId, { settings: settings2, isTwoHuman, getSeat }) ?? false;
  }
  function isSeatHuman(seatId) {
    if (!seatId || typeof seatId !== "string") return false;
    return CC2?.Roster?.isSeatHuman?.(seatId, { settings: settings2, isTwoHuman, getSeat }) ?? !isSeatCpu(seatId);
  }
  function isSeatOnline2(seatId) {
    return CC2?.NetworkManager?.isSeatOnline?.(seatId, { net, settings: settings2 }) ?? true;
  }
  function isMultiHuman2() {
    return CC2?.NetworkManager?.isMultiHuman?.(settings2) ?? false;
  }
  function replacePlayerWithAi(seatId, aiProfile = "shark", botName = "The Shark") {
    if (CC2?.NetworkManager?.replaceSeatWithCpu) {
      CC2.NetworkManager.replaceSeatWithCpu(seatId, aiProfile, botName, {
        settings: settings2,
        state: state2,
        setNetStatus,
        log,
        netPush,
        renderScores,
        render,
        scheduleOppPlay,
        chooseDiscard,
        handleSeatDiscardIntent,
        pickCut
      });
    }
  }
  function handlePlayerOfflinePrompt(seatId, seatName3) {
    const showOfflineModal = CC2?.ModalManager?.showPlayerOfflineModal || (window.modalManager && window.modalManager.showPlayerOfflineModal ? window.modalManager.showPlayerOfflineModal.bind(window.modalManager) : null);
    const showPickAiModal = CC2?.ModalManager?.showPickAiReplacementModal || (window.modalManager && window.modalManager.showPickAiReplacementModal ? window.modalManager.showPickAiReplacementModal.bind(window.modalManager) : null);
    if (typeof showOfflineModal === "function") {
      showOfflineModal(seatId, seatName3, (sId, name) => {
        if (typeof showPickAiModal === "function") {
          showPickAiModal(sId, name, (aiProfile, botName) => {
            replacePlayerWithAi(sId, aiProfile, botName);
          });
        } else {
          replacePlayerWithAi(sId, "shark", "The Shark");
        }
      }, (sId, name) => {
        const statusEl = document.getElementById("status");
        if (statusEl) {
          let waitBar = document.getElementById("reconnectWaitBar");
          if (!waitBar) {
            waitBar = document.createElement("div");
            waitBar.className = "reconnect-wait-bar";
            waitBar.id = "reconnectWaitBar";
            statusEl.appendChild(waitBar);
          }
          waitBar.innerHTML = `<span>\u26A0\uFE0F ${name} is offline.</span> <button type="button" class="btn-quick-replace" id="btnTriggerAiReplace">\u{1F916} Replace with AI</button>`;
          const btn = document.getElementById("btnTriggerAiReplace");
          if (btn) {
            btn.onclick = () => {
              waitBar.remove();
              if (typeof showPickAiModal === "function") {
                showPickAiModal(sId, name, (aiProfile, botName) => {
                  replacePlayerWithAi(sId, aiProfile, botName);
                });
              } else {
                replacePlayerWithAi(sId, "shark", "The Shark");
              }
            };
          }
        }
      }, (sId, name) => {
        cancelGameAndReturnToMenu();
      });
    } else {
      replacePlayerWithAi(seatId, "shark", "The Shark");
    }
  }
  function scoreKey(who) {
    return CC2?.Roster?.scoreKey?.(who, { isFixedTeams, settings: settings2, getSeatTeam });
  }
  function isInPegThroughZone2(score) {
    return CC2?.isInPegThroughZone ? CC2.isInPegThroughZone(score) : false;
  }
  function isInLast5PegOut2(score) {
    return CC2?.isInLast5PegOut ? CC2.isInLast5PegOut(score, settings2 && settings2.target || 121) : false;
  }
  function isInBunker2(score) {
    return CC2?.isInBunker ? CC2.isInBunker(score, settings2 && settings2.target || 121) : false;
  }
  function getNoPassingLanes() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getNoPassingLanes(settings2) : [];
  }
  function isInNoPassingLane2(score) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.isInNoPassingLane(score, settings2) : false;
  }
  function getNoPassingLaneForHole(score) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getNoPassingLaneForHole(score, settings2) : null;
  }
  function getNoPassingLaneMaxScore(who, currentScore, targetScore) {
    if (CC2 && CC2.ObstacleGeometry && CC2.ObstacleGeometry.getNoPassingLaneMaxScore) {
      return CC2.ObstacleGeometry.getNoPassingLaneMaxScore(scoreKey(who), currentScore, targetScore, state2, settings2, typeof getActiveTracks2 === "function" ? getActiveTracks2() : []);
    }
    return { allowedScore: targetScore, blocked: false, blockingPlayer: null };
  }
  function getJumpConfigs() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getJumpConfigs(settings2) : [];
  }
  function getJumpForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getJumpForHole(holeNum, settings2) : null;
  }
  function getJailConfigs() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getJailConfigs(settings2) : [];
  }
  function getJailForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getJailForHole(holeNum, settings2) : null;
  }
  function getJailStepXY(jailHole, step, who) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getJailStepXY(jailHole, step, who, settings2, getTrackXY2) : typeof getTrackXY2 === "function" ? getTrackXY2(jailHole, who || "p1") : { x: 0, y: 0 };
  }
  function getBarConfigs() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getBarConfigs(settings2) : [];
  }
  function getBarForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getBarForHole(holeNum, settings2) : null;
  }
  function getBarStepXY(barHole, step, who) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getBarStepXY(barHole, step, who, settings2, getTrackXY2) : typeof getTrackXY2 === "function" ? getTrackXY2(barHole, who || "p1") : { x: 0, y: 0 };
  }
  function getTimeoutConfigs() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getTimeoutConfigs(settings2) : [];
  }
  function getTimeoutForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getTimeoutForHole(holeNum, settings2) : null;
  }
  function getTimeoutStepXY(timeoutHole, step, who) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getTimeoutStepXY(timeoutHole, step, who, settings2, getTrackXY2) : typeof getTrackXY2 === "function" ? getTrackXY2(timeoutHole, who || "p1") : { x: 0, y: 0 };
  }
  function getStopSignConfigs() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getStopSignConfigs(settings2) : [];
  }
  function getStopSignForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getStopSignForHole(holeNum, settings2) : null;
  }
  function getDetourConfigs() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getDetourConfigs(settings2) : [];
  }
  function getDetourForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getDetourForHole(holeNum, settings2) : null;
  }
  function catmullRomPath(pts) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.catmullRomPath(pts) : "";
  }
  function computeLoopGeometry(holeNum, who, isRoundAbout) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.computeLoopGeometry(holeNum, who, isRoundAbout, settings2, getTrackXY2) : { pEntry: { x: 0, y: 0 }, pExit: { x: 0, y: 0 } };
  }
  function getDetourStepXY(detourHole, step, who) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getDetourStepXY(detourHole, step, who, settings2, getTrackXY2) : typeof getTrackXY2 === "function" ? getTrackXY2(detourHole, who || "p1") : { x: 0, y: 0 };
  }
  function getRoundAboutConfigs() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getRoundAboutConfigs(settings2) : [];
  }
  function getRoundAboutForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getRoundAboutForHole(holeNum, settings2) : null;
  }
  function getRoundAboutStepXY(roundAboutHole, step, who) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getRoundAboutStepXY(roundAboutHole, step, who, settings2, getTrackXY2) : typeof getTrackXY2 === "function" ? getTrackXY2(roundAboutHole, who || "p1") : { x: 0, y: 0 };
  }
  function getSignConfigs() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getSignConfigs(settings2) : [];
  }
  function getSignBlockForHole(h) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getSignBlockForHole(h, settings2) : null;
  }
  function getDiceConfigs2() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getDiceConfigs(settings2) : [];
  }
  function getDiceForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getDiceForHole(holeNum, settings2) : null;
  }
  function getWheelConfigs2() {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getWheelConfigs(settings2) : [];
  }
  function getWheelForHole(holeNum) {
    return CC2 && CC2.ObstacleGeometry ? CC2.ObstacleGeometry.getWheelForHole(holeNum, settings2) : null;
  }
  function isDealerTeam(seatId) {
    return CC2?.GameEngine?.isDealerTeam?.(seatId, { state: state2, isSoloVsPairs, isFixedTeams, getSeatTeam });
  }
  function seatDiscardsToDeck(seatId) {
    return CC2?.GameEngine?.seatDiscardsToDeck?.(seatId, { settings: settings2, state: state2, getActiveSeatIds });
  }
  function applySeatLabels() {
    return CC2?.UIController?.applySeatLabels?.({ isOnline, mySeat: mySeat2, getPlayerCount, seatName: seatName2, settings: settings2, getAppBrand, isSoloVsPairs, pName, isHvH });
  }
  function passTo(who, thenFn) {
    return CC2?.ModalManager?.passTo?.(who, thenFn, { isOnline, isSeatCpu, isSeatHuman, getActiveSeatIds, settings: settings2, getAppBrand, isHvH, state: state2, render, showModal, hideModal: hideModal2, seatColor, seatName: seatName2 });
  }
  function scheduleOppPlay(seatId) {
    return CC2?.GameEngine?.scheduleOppPlay?.(seatId, { state: state2, isOnline, isSeatCpu, settings: settings2, cpuSeatPlay, mySeat: mySeat2, setStatus, render, netPush, seatName: seatName2, isSeatHuman, passTo });
  }
  var CLASH_DEFAULTS_4813 = CC2 && CC2.CLASH_DEFAULTS_481 || {};
  var CLASH_DEFAULTS_2413 = CC2 && CC2.CLASH_DEFAULTS_241 || {};
  var CLASH_DEFAULTS_3613 = CC2 && CC2.CLASH_DEFAULTS_361 || {};
  function getClashDefaults3(t) {
    return CC2 && CC2.ClashManager ? CC2.ClashManager.getClashDefaults(t) : Number(t) === 241 ? CLASH_DEFAULTS_2413 : Number(t) === 361 ? CLASH_DEFAULTS_3613 : CLASH_DEFAULTS_4813;
  }
  function getSkunkDefaults3(t) {
    return CC2 && CC2.ClashManager ? CC2.ClashManager.getSkunkDefaults(t) : { skunkHole: Math.round((Number(t || 481) - 1) * 0.75), doubleSkunkHole: Math.round((Number(t || 481) - 1) * 0.5) };
  }
  var settings2 = CC2 && CC2.SettingsManager && CC2.SettingsManager.DEFAULT_SETTINGS ? JSON.parse(JSON.stringify(CC2.SettingsManager.DEFAULT_SETTINGS)) : { opp: "cpu", playerCount: 2, gameMode: "individual", target: 121, decks: 1, cardBack: "classic-blue" };
  var gameHands = [];
  var CARD_BACKS2 = CC2 && CC2.CARD_BACKS || CC2 && CC2.SettingsManager && CC2.SettingsManager.CARD_BACKS || [
    { id: "classic-blue", name: "Classic Blue", desc: "Traditional casino crosshatch" },
    { id: "classic-red", name: "Classic Red", desc: "Bicycle crimson diamond weave" }
  ];
  function setCardBack(id, skipSave = false) {
    return CC2?.SettingsManager?.setCardBack?.(id, { settings: settings2, skipSave, onSave: () => {
      if (typeof saveSettingsStore === "function" && typeof readFormSettings === "function") saveSettingsStore(readFormSettings());
    } });
  }
  function initCardBackPicker() {
    return CC2?.SettingsManager?.initCardBackPicker?.({ currentCardBack: settings2.cardBack || "classic-blue", settings: settings2, onSave: () => {
      if (typeof saveSettingsStore === "function" && typeof readFormSettings === "function") saveSettingsStore(readFormSettings());
    } });
  }
  var state2;
  function makeDeck(n) {
    return CC2 && CC2.Deck ? CC2.Deck.makeDeck(n != null ? n : settings2.decks || 1, settings2 && settings2.jokers) : [];
  }
  function isWild(c) {
    return c && typeof c.isWild === "boolean" ? c.isWild : !!(c && c.wild);
  }
  function rankOf(c) {
    return c && typeof c.rank === "number" ? c.rank : c && c.playAs && c.playAs.r || (c ? c.r : 0);
  }
  function suitOf(c) {
    return c && typeof c.suit === "string" ? c.suit : c && c.playAs && c.playAs.s || (c ? c.s : "S");
  }
  function cardFits(c, count) {
    if (!c) return false;
    return CC2 && CC2.Card ? CC2.Card.from(c).fits(count) : isWild(c) && !c.playAs ? count <= 30 : count + VAL3(rankOf(c)) <= 31;
  }
  function assignCard(c, r, su) {
    return CC2 && CC2.Card ? CC2.Card.from(c).assignWild(r, su) : Object.assign({}, c, { r, s: su || suitOf(c) || "S", playAs: { r, s: su || "S" } });
  }
  function shuffle(a) {
    return CC2 && CC2.Deck && typeof CC2.Deck.shuffleArray === "function" ? CC2.Deck.shuffleArray(a) : a;
  }
  function takeAnim(key) {
    return CC2?.TableRenderer?.takeAnim?.(key);
  }
  function resetAnims() {
    CC2?.TableRenderer?.resetAnims?.();
  }
  function faceMarkup(c) {
    return CC2?.TableRenderer?.faceMarkup?.(c);
  }
  function cardEl(c, opts = {}) {
    return CC2?.TableRenderer?.cardEl?.(c, opts, { state: state2 });
  }
  function cardKey(c) {
    return CC2?.TableRenderer ? CC2.TableRenderer.cardKey(c) : c && c.id || "";
  }
  function applyHighlights(cards, isBonus = false) {
    CC2?.TableRenderer?.applyHighlights?.(cards, isBonus, { state: state2 });
  }
  function combinations2(arr, k) {
    return CC2?.combinations ? CC2.combinations(arr, k) : [];
  }
  function isConsecutiveRun2(rs, allowWrap) {
    if (CC2 && CC2.isConsecutiveRun) return CC2.isConsecutiveRun(rs, allowWrap);
    return false;
  }
  function scoreShowCore(cards, starter, isCrib, extraOptions = {}) {
    return CC2?.CribbageScorer?.scoreHandCore ? CC2.CribbageScorer.scoreHandCore(cards, starter, isCrib, { ...settings2, state: state2, ...extraOptions }) : { fifteens: 0, nineteens: 0, thirtyOnes: 0, pairs: 0, runs: 0, flush: 0, nobs: 0, total: 0, notes: [], lines: [] };
  }
  function scoreShow(cards, starter, isCrib, precise, extraOptions = {}) {
    return CC2?.CribbageScorer?.scoreHand ? CC2.CribbageScorer.scoreHand(cards, starter, isCrib, { ...settings2, state: state2, ...extraOptions }, precise) : scoreShowCore(cards, starter, isCrib, extraOptions);
  }
  function pegPoints(pile, justPlayed) {
    return CC2?.CribbageScorer?.scorePegging ? CC2.CribbageScorer.scorePegging(pile, settings2) : [];
  }
  var FULL_DECK = makeDeck(1);
  function pegTotal(pile) {
    return CC2?.CribbageScorer?.pegTotal ? CC2.CribbageScorer.pegTotal(pile, settings2) : pegPoints(pile).reduce((s, p) => s + p.n, 0);
  }
  function pegPotential(keep) {
    return CC2?.CribbageScorer?.pegPotential ? CC2.CribbageScorer.pegPotential(keep) : 0;
  }
  function expectedShowExact(keep, deadIds, isCrib) {
    return CC2?.CribbageAI?.expectedShowExact ? CC2.CribbageAI.expectedShowExact(keep, deadIds, isCrib, FULL_DECK) : 0;
  }
  function getSeatPersonality(seatId) {
    const sId = seatId || state2?.turn || "p2";
    const seat = settings2?.seats?.find((s) => s.id === sId);
    return seat?.personality || settings2?.aiProfile || "shark";
  }
  function chooseDiscardFast(hand, isDealer, lowball, discardN = 2, toDeck = false, seatId = null) {
    const profile = getSeatPersonality(seatId);
    return CC2?.CribbageAI?.chooseDiscardFast?.(hand, isDealer, lowball, discardN, toDeck, { profile, starter: state2?.starter, optFivesCribbage: settings2?.optFivesCribbage, optSevensAndEightsCribbage: settings2?.optSevensAndEightsCribbage, settings: settings2 }) || (hand || []).slice(0, discardN);
  }
  function chooseDiscard(hand, isDealer, lowball, discardN = 2, toDeck = false, seatId = null) {
    if (!hand || hand.length <= discardN) return (hand || []).slice(0, discardN);
    const profile = getSeatPersonality(seatId);
    if (CC2?.CribbageAI?.chooseDiscard) {
      const myLead = state2?.scores?.[scoreKey(isDealer ? state2.dealer : nextSeat(state2.dealer))] || 0;
      const inBlockedZone = settings2?.optPegThroughZones && isInPegThroughZone2(myLead) || settings2?.optLast5PegOut && isInLast5PegOut2(myLead) || settings2?.optBunkers && isInBunker2(myLead);
      return CC2.CribbageAI.chooseDiscard(hand, isDealer, lowball, discardN, toDeck, { profile, deck: FULL_DECK, starter: state2?.starter, inBlockedZone, target: settings2?.target, optRockCrib: settings2?.optRockCrib, optShotgunCribbage: settings2?.optShotgunCribbage, optFivesCribbage: settings2?.optFivesCribbage, optSevensAndEightsCribbage: settings2?.optSevensAndEightsCribbage, settings: settings2 });
    }
    return chooseDiscardFast(hand, isDealer, lowball, discardN, toDeck, seatId);
  }
  function cpuKnownIds() {
    return CC2 && CC2.CribbageAI ? CC2.CribbageAI.cpuKnownIds(state2) : /* @__PURE__ */ new Set();
  }
  function unseenCards() {
    return CC2 && CC2.CribbageAI ? CC2.CribbageAI.unseenCards(state2, FULL_DECK) : [];
  }
  function sampleOppHand(unseen, n) {
    return CC2 && CC2.CribbageAI ? CC2.CribbageAI.sampleOppHand(unseen, n, shuffle) : [];
  }
  function removeCard(hand, card) {
    if (CC2 && CC2.CribbageAI) CC2.CribbageAI.removeCard(hand, card);
  }
  function fastPlayCard(hand, pile, count) {
    return CC2?.CribbageAI?.fastPlayCard ? CC2.CribbageAI.fastPlayCard(hand, pile, count, settings2) : (hand || []).filter((c) => Card2.from(c).fits(count))[0] || null;
  }
  function rolloutPeg(myHand, oppHand, pile, count, myTurn, lastWasMe) {
    return CC2?.CribbageAI?.rolloutPeg ? CC2.CribbageAI.rolloutPeg(myHand, oppHand, pile, count, myTurn, lastWasMe, settings2) : { myPts: 0, oppPts: 0 };
  }
  function raceBonus(whoPts, add, lowball) {
    if (CC2?.CribbageAI?.raceBonus) {
      const opp = state2?.scores ? whoPts === state2.scores.cpu ? state2.scores.you : state2.scores.cpu : 0;
      return CC2.CribbageAI.raceBonus(whoPts, add, lowball, settings2?.target || 121, opp);
    }
    return 0;
  }
  function cardLabel(c) {
    return CC2 && CC2.TableRenderer ? CC2.TableRenderer.cardLabel(c) : "";
  }
  function choosePlay(hand, pile, count, oppCanPlay, lowball, seatId = null) {
    const profile = getSeatPersonality(seatId);
    if (CC2?.CribbageAI?.choosePlay) {
      const oppN = state2?.youHand ? state2.youHand.length : 4;
      return CC2.CribbageAI.choosePlay(hand, pile, count, oppCanPlay, lowball, { profile, settings: settings2, knownIds: typeof cpuKnownIds === "function" ? cpuKnownIds() : [], deck: FULL_DECK, oppHandCount: oppN, myScore: state2?.scores?.cpu || 0, oppScore: state2?.scores?.you || 0, target: settings2?.target });
    }
    return (hand || []).filter((c) => Card2.from(c).fits(count))[0] || null;
  }
  var sfx2 = typeof window !== "undefined" && window.audioManager ? window.audioManager : CC2 && CC2.AudioManager ? new CC2.AudioManager() : {
    on: true,
    ctx: null,
    ensure() {
      return null;
    },
    tone() {
    },
    noise() {
    },
    snap() {
    },
    peg() {
    },
    shuffle() {
    },
    riffle() {
    },
    fanfare20() {
    },
    chime15() {
    },
    bell31() {
    },
    skunk() {
    },
    chutesAndLadders() {
    },
    spades() {
    },
    gameHole() {
    },
    card() {
    },
    deal() {
    },
    pop() {
    },
    alarm() {
    },
    setOn(enabled) {
      this.on = Boolean(enabled);
    },
    toggle() {
      this.on = !this.on;
      return this.on;
    }
  };
  if (typeof window !== "undefined") {
    window.sfx = sfx2;
    if (!window.audioManager) window.audioManager = sfx2;
  }
  try {
    sfx2.on = (appStorage.getItem("crazyCribbage.sfx") ?? (typeof localStorage !== "undefined" ? localStorage.getItem("crazyCribbage.sfx") : null)) !== "off";
  } catch (e) {
  }
  function log(msg) {
    return CC2?.UIController?.log?.(msg);
  }
  function showSolver() {
  }
  function setStatus(t) {
    return CC2?.UIController?.setStatus ? CC2.UIController.setStatus(t, state2, updateTurnPrompt) : state2 ? (state2.customStatus = t, updateTurnPrompt(t)) : null;
  }
  function updateTurnPrompt(overrideText) {
    return CC2?.UIController?.updateTurnPrompt?.(overrideText, { state: state2, settings: settings2, mySeat: mySeat2, isOnline, isSeatHuman, seatName: seatName2, pName, nextSeat, cardLabel });
  }
  function isBonusMessage(text2) {
    return CC2?.UIController?.isBonusMessage?.(text2) ?? false;
  }
  function fancyCall(text2, kind, ms) {
    return CC2?.UIController?.fancyCall?.(text2, kind, ms);
  }
  function fancyPegPhrase(why, n) {
    return CC2?.UIController?.fancyPegPhrase?.(why, n);
  }
  function announceCombos(pts) {
    return CC2?.UIController?.announceCombos?.(pts, { fancyCall, fancyPegPhrase, isBonusMessage });
  }
  function updateCountGlow() {
    return CC2?.UIController?.updateCountGlow?.(state2 ? state2.count : 0, state2 ? state2.phase : null);
  }
  function streetName2(score) {
    return CC2?.streetName ? CC2.streetName(score, settings2?.target || 121) : "Home";
  }
  function showStreetBanner(who, mark) {
    return CC2?.UIController?.showStreetBanner?.(who, mark, { pName, streetName: streetName2, fancyCall });
  }
  function showScoreToast(who, n, why, customDuration) {
    return CC2?.UIController?.showScoreToast?.(who, n, why, customDuration, { pName });
  }
  function addScore(who, n, why, isPartnerBonus = false, isSignAction = false) {
    return CC2?.GameEngine?.addScore?.(who, n, why, isPartnerBonus, isSignAction, {
      state: state2,
      settings: settings2,
      scoreKey,
      getActiveTracks: getActiveTracks2,
      pName,
      log,
      showScoreToast,
      fancyCall,
      renderScores,
      setShowMeter,
      fancyPegPhrase,
      isBonusMessage,
      sfx: sfx2,
      showStreetBanner,
      checkGameOver,
      handleSignsLanding: window.handleSignsLanding,
      openDiceRollModal: window.openDiceRollModal || openDiceRollModal,
      openWheelSpinModal: window.openWheelSpinModal || openWheelSpinModal,
      getActivePintsOptionAtHole: window.getActivePintsOptionAtHole,
      showPintsBonusModal: window.showPintsBonusModal,
      getActiveAdultOptionAtHole: window.getActiveAdultOptionAtHole,
      showAdultStripModal: window.showAdultStripModal,
      showAdultTimerModal: window.showAdultTimerModal,
      pegTracker: typeof window !== "undefined" ? window.pegTracker : null,
      isShiftingPartnership: window.isShiftingPartnership,
      getShiftingPartner: window.getShiftingPartner,
      seatName: window.seatName,
      showJailAnimation: (opts) => {
        const fn = typeof window !== "undefined" && window.showJailAnimation || CC2 && CC2.JailAnimationOverlay && CC2.JailAnimationOverlay.show || JailAnimationOverlay.show;
        return typeof fn === "function" ? fn(opts) : null;
      },
      showBarAnimation: (opts) => {
        const fn = typeof window !== "undefined" && window.showBarAnimation || CC2 && CC2.BarAnimationOverlay && CC2.BarAnimationOverlay.show || BarAnimationOverlay.show;
        return typeof fn === "function" ? fn(opts) : null;
      },
      showCannonAnimation: (opts) => {
        const fn = typeof window !== "undefined" && window.showCannonAnimation || CC2 && CC2.CannonAnimationOverlay && CC2.CannonAnimationOverlay.show || CannonAnimationOverlay.show;
        return typeof fn === "function" ? fn(opts) : null;
      },
      showSpeedTrapAnimation: (opts) => {
        const fn = typeof window !== "undefined" && window.showSpeedTrapAnimation || CC2 && CC2.SpeedTrapAnimationOverlay && CC2.SpeedTrapAnimationOverlay.show || SpeedTrapAnimationOverlay.show;
        return typeof fn === "function" ? fn(opts) : null;
      },
      showScenicRouteAnimation: (opts) => {
        const fn = typeof window !== "undefined" && window.showScenicRouteAnimation || CC2 && CC2.ScenicRouteAnimationOverlay && CC2.ScenicRouteAnimationOverlay.show || ScenicRouteAnimationOverlay.show;
        return typeof fn === "function" ? fn(opts) : null;
      }
    });
  }
  function skunkResult2(winner, youScore, cpuScore) {
    return CC2?.skunkResult?.(winner, youScore, cpuScore, { target: settings2?.target || 121, goal: settings2?.goal || "high", optSkunkMarkers: Boolean(settings2?.optSkunkMarkers), skunkMarkerHole: settings2?.skunkMarkerHole, doubleSkunkMarkerHole: settings2?.doubleSkunkMarkerHole });
  }
  function checkChutesAndLadders() {
    return CC2?.GameEngine?.checkChutesAndLadders?.(state2, settings2, { getActiveTracks: getActiveTracks2, pName, log, fancyCall, renderScores, netPush, sfx: sfx2 });
  }
  function checkGameOver() {
    return CC2?.GameEngine?.checkGameOver?.({ settings: settings2, state: state2, getActiveTracks: getActiveTracks2, pName, sfx: sfx2, recordGameResult, renderRecordBox: window.renderRecordBox, skunkResult: skunkResult2, showModal, log, fancyCall, renderScores, netPush });
  }
  var SIGN_DEFS2 = CC2?.ClashMiniGames?.SIGN_DEFS || {};
  var WHEEL_SLOTS2 = CC2?.ClashMiniGames?.WHEEL_SLOTS || [];
  function handleSignsLanding(block, who) {
    return CC2?.ClashMiniGames?.handleSignsLanding?.(block, who, { state: state2, settings: settings2, pName, log, fancyCall, showScoreToast, setStatus, isSeatHuman, isSeatCpu, showModal, closeModal, chooseSign });
  }
  function openSignPickerModal(block, who) {
    return CC2?.ClashMiniGames?.openSignPickerModal?.(block, who, { state: state2, showModal });
  }
  function onSignCardClick2(signName, blockId, who) {
    return CC2?.ClashMiniGames?.onSignCardClick?.(signName, blockId, who, { closeModal, getSignConfigs, chooseSign });
  }
  function chooseSign(signName, who, block) {
    return CC2?.ClashMiniGames?.chooseSign?.(signName, who, block, { state: state2, pName, isSeatHuman, log, fancyCall, showScoreToast, setStatus, updateSignsBillboard, executeSign, resumeGameAfterSign });
  }
  function resumeGameAfterSign() {
    return CC2?.ClashMiniGames?.resumeGameAfterSign?.({ state: state2, isSeatCpu, scheduleOppPlay });
  }
  function executeSign(signName, who, block) {
    return CC2?.ClashMiniGames?.executeSign?.(signName, who, block, { state: state2, settings: settings2, scoreKey, pName, log, fancyCall, renderScores, addScore, getJailConfigs, getBarConfigs, getTimeoutConfigs, openDiceRollModal, openWheelSpinModal });
  }
  function openDiceRollModal(who) {
    return CC2?.ClashMiniGames?.openDiceRollModal?.(who, { showModal, performDiceRoll: performDiceRoll2 });
  }
  function performDiceRoll2(who) {
    return CC2?.ClashMiniGames?.performDiceRoll?.(who, { document, state: state2, sfx: sfx2, log, pName, isSeatCpu, getActiveTracks: getActiveTracks2, setStatus, applyDiceResult, seatColor });
  }
  function onDicePickPlayer2(targetWho, signedPts, dir, val) {
    return CC2?.ClashMiniGames?.onDicePickPlayer?.(targetWho, signedPts, dir, val, { document, pName, log, setStatus, applyDiceResult });
  }
  function applyDiceResult(targetWho, signedPts) {
    return CC2?.ClashMiniGames?.applyDiceResult?.(targetWho, signedPts, { closeModal, log, pName, fancyCall, addScore, resumeGameAfterSign });
  }
  function openWheelSpinModal(who) {
    return CC2?.ClashMiniGames?.openWheelSpinModal?.(who, { document, showModal, isSeatCpu, performWheelSpin: performWheelSpin2 });
  }
  function drawWheelCanvas() {
    return CC2?.ClashMiniGames?.drawWheelCanvas?.(document.getElementById("wheelCanvas"));
  }
  function performWheelSpin2(who) {
    return CC2?.ClashMiniGames?.performWheelSpin?.(who, { document, sfx: sfx2, isSeatHuman, pName, log, fancyCall, setStatus, closeModal, executeSign, resumeGameAfterSign });
  }
  function updateSignsBillboard(blockId) {
    return CC2?.ClashMiniGames?.updateSignsBillboard?.(blockId, { document, state: state2, getSignConfigs });
  }
  function getActiveTracks2() {
    return CC2?.getActiveTracks ? CC2.getActiveTracks(settings2, typeof isFixedTeams === "function" ? isFixedTeams() : false) : ["p1", "p2"];
  }
  function getPegGradId(who) {
    return CC2?.BoardRenderer?.getPegGradId ? CC2.BoardRenderer.getPegGradId(who) : "pegP1Grad";
  }
  function updateScoreChips() {
    return CC2?.BoardRenderer?.updateScoreChips?.(document, getActiveTracks2(), pName, settings2);
  }
  function getBoardSignature() {
    return CC2?.BoardRenderer?.getBoardSignature ? CC2.BoardRenderer.getBoardSignature(settings2, getActiveTracks2(), typeof getAppBrand === "function" ? getAppBrand() : "") : "";
  }
  function buildBoard(opts = {}) {
    const activeSettings = opts.settings || settings2;
    const brand = opts.brand || (typeof getAppBrand === "function" ? getAppBrand() : activeSettings?.brand || "crazy");
    const isClash = brand === "clash";
    const emptyObstacles = { noPassingLanes: [], jumps: [], jails: [], bars: [], timeouts: [], detours: [], roundabouts: [], signs: [], stopSigns: [], dice: [], wheels: [] };
    const defaultObstacles = isClash ? {
      noPassingLanes: typeof getNoPassingLanes === "function" ? getNoPassingLanes(activeSettings) : [],
      jumps: typeof getJumpConfigs === "function" ? getJumpConfigs(activeSettings) : [],
      jails: typeof getJailConfigs === "function" ? getJailConfigs(activeSettings) : [],
      bars: typeof getBarConfigs === "function" ? getBarConfigs(activeSettings) : [],
      timeouts: typeof getTimeoutConfigs === "function" ? getTimeoutConfigs(activeSettings) : [],
      detours: typeof getDetourConfigs === "function" ? getDetourConfigs(activeSettings) : [],
      roundabouts: typeof getRoundAboutConfigs === "function" ? getRoundAboutConfigs(activeSettings) : [],
      signs: typeof getSignConfigs === "function" ? getSignConfigs(activeSettings) : [],
      stopSigns: typeof getStopSignConfigs === "function" ? getStopSignConfigs(activeSettings) : [],
      dice: typeof getDiceConfigs2 === "function" ? getDiceConfigs2(activeSettings) : [],
      wheels: typeof getWheelConfigs2 === "function" ? getWheelConfigs2(activeSettings) : []
    } : emptyObstacles;
    return CC2?.BoardRenderer?.buildBoard?.({
      document: typeof document !== "undefined" ? document : null,
      settings: activeSettings,
      state: state2,
      pegState,
      brand,
      activeTracks: typeof getActiveTracks2 === "function" ? getActiveTracks2() : ["p1", "p2"],
      BOARD_CFG: BOARD_CFG2,
      getTrackXY: getTrackXY2,
      getTrackXYFn: getTrackXY2,
      getClashBoardCfg: getClashBoardCfg2,
      getSkunkDefaults: getSkunkDefaults3,
      CARD_BACKS: CARD_BACKS2,
      obstacleConfigs: isClash ? opts.obstacleConfigs || defaultObstacles : emptyObstacles,
      obstacleStepHelpers: {
        getJailStepXY: typeof getJailStepXY === "function" ? getJailStepXY : null,
        getBarStepXY: typeof getBarStepXY === "function" ? getBarStepXY : null,
        getTimeoutStepXY: typeof getTimeoutStepXY === "function" ? getTimeoutStepXY : null,
        getDetourStepXY: typeof getDetourStepXY === "function" ? getDetourStepXY : null,
        getRoundAboutStepXY: typeof getRoundAboutStepXY === "function" ? getRoundAboutStepXY : null
      },
      createLegendFn: typeof createCrazyCribbageLegend === "function" ? createCrazyCribbageLegend : null,
      onAfterRender: () => {
        initBoardFancyTooltips();
        if (typeof opts.onAfterRender === "function") opts.onAfterRender();
      },
      ...opts
    });
  }
  function createCrazyCribbageLegend() {
    return CC2?.BoardRenderer?.createLegend?.({ brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy", settings: settings2, adultOptions: ADULT_OPTIONS_LIST2 || [], obstacleConfigs: { noPassingLanes: getNoPassingLanes(), jumps: getJumpConfigs(), jails: getJailConfigs(), bars: getBarConfigs(), timeouts: getTimeoutConfigs(), detours: getDetourConfigs(), roundabouts: getRoundAboutConfigs(), signs: getSignConfigs(), stopSigns: typeof getStopSignConfigs === "function" ? getStopSignConfigs() : [], dice: typeof getDiceConfigs2 === "function" ? getDiceConfigs2() : [], wheels: typeof getWheelConfigs2 === "function" ? getWheelConfigs2() : [] } }) || document.createElement("div");
  }
  function getBoardTooltipContext() {
    return CC2?.BoardRenderer?.getBoardTooltipContext?.({
      state: state2,
      settings: settings2,
      pegState,
      getAppBrand,
      getStreetOrTurnName,
      getSignConfigs,
      getStopSignConfigs,
      getJailConfigs,
      getBarConfigs,
      getTimeoutConfigs,
      getJumpConfigs,
      getDetourConfigs,
      getRoundAboutConfigs,
      getNoPassingLanes,
      getDiceConfigs: getDiceConfigs2,
      getWheelConfigs: getWheelConfigs2
    }) || { state: state2, settings: settings2, pegState, brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy" };
  }
  function getBoardTooltipData(target) {
    return CC2?.BoardRenderer?.getBoardTooltipData?.(target, getBoardTooltipContext()) ?? null;
  }
  function hideFancyTooltip() {
    return CC2?.BoardRenderer?.hideFancyTooltip?.();
  }
  function initBoardFancyTooltips() {
    return CC2?.BoardRenderer?.initBoardFancyTooltips?.(null, getBoardTooltipContext());
  }
  function renderScores(animate = true) {
    return CC2?.BoardRenderer?.renderScores?.(animate, { state: state2, settings: settings2, pegState, getActiveTracks: getActiveTracks2, getTrackXY: getTrackXY2, updateScoreChips, updateCoachDisplay });
  }
  function sortCards(arr) {
    return CC2?.Hand?.sort ? CC2.Hand.sort(arr) : (arr || []).slice().sort((a, b) => a.r - b.r || SUITS2.indexOf(a.s) - SUITS2.indexOf(b.s));
  }
  function render() {
    return CC2?.TableRenderer?.render?.({ state: state2, settings: settings2, mySeat: mySeat2, getActiveSeatIds, getPlayerCount, isSoloVsPairs, isOnline, isHvH, isSeatHuman, isSeatOnline: isSeatOnline2, isMultiHuman: isMultiHuman2, getSeatKept, getSeatHand, sortCards, cardLabel, cardFits, cardEl, isWild, onPickCribCard, onYouCard, onCpuCard, onOppSeatDiscardCard, updateCoachDisplay, seatName: seatName2, nextSeat, poneDoCutStarter, seatDiscardsToDeck, isDealerTeam, setShowMeter, updateTurnPrompt, renderScores, updateCountGlow, renderCutFan });
  }
  function onOppSeatDiscardCard(sId, c) {
    return CC2?.GameEngine?.onOppSeatDiscardCard?.(sId, c, { state: state2, settings: settings2, isOnline, render, setStatus });
  }
  function onCpuCard(c) {
    return CC2?.GameEngine?.onCpuCard?.(c, { state: state2, settings: settings2, isHvH, isOnline, isWild, openWildPick, render, hideWildPick, playCard, rankOf, VAL: VAL3, setStatus });
  }
  function onYouCard(c) {
    return CC2?.GameEngine?.onYouCard?.(c, { state: state2, settings: settings2, mySeat: mySeat2, isOnline, isSeatHuman, openWildPick, isWild, render, hideWildPick, netSend, playCard, rankOf, VAL: VAL3, setStatus });
  }
  function hideWildPick() {
    return CC2?.ModalManager?.hideWildPick?.({ state: state2 });
  }
  function openWildPick(c, kind) {
    return CC2?.ModalManager?.openWildPick?.(c, kind, { state: state2, setStatus, SUIT_SYM: SUIT_SYM2, SUITS: SUITS2, RANKS: RANKS2, RANK_NAME: RANK_NAME2, confirmWildAs });
  }
  function stylePickBtn(b, ink) {
    return CC2?.ModalManager?.stylePickBtn?.(b, ink);
  }
  function drawWildPick() {
    return CC2?.ModalManager?.drawWildPick?.({ state: state2, SUIT_SYM: SUIT_SYM2, SUITS: SUITS2, RANKS: RANKS2, RANK_NAME: RANK_NAME2, confirmWildAs });
  }
  function confirmWildAs(r, su) {
    return CC2?.GameEngine?.confirmWildAs?.(r, su, null, { state: state2, isOnline, settings: settings2, netSend, mySeat: mySeat2, hideWildPick, log, RANK_NAME: RANK_NAME2, SUIT_SYM: SUIT_SYM2, afterStarterAssigned, isWild, setStatus, pName, render, isSeatCpu, cpuDoPickYourCrib, beginDiscard, openWildPick });
  }
  function cpuAssignWilds(hand) {
    return CC2?.CribbageAI?.cpuAssignWilds?.(hand, { isWild, settings: settings2, scoreShow, assignCard, log, RANK_NAME: RANK_NAME2, SUIT_SYM: SUIT_SYM2, RANKS: RANKS2 });
  }
  function beginDiscard() {
    return CC2?.GameEngine?.beginDiscard?.({ state: state2, settings: settings2, seatDiscardsToDeck, isSoloVsPairs, isDealerTeam, setStatus, updateCoachDisplay, render });
  }
  function showWait(msg) {
    return CC2?.UIController?.showWait?.(msg);
  }
  function hideWait() {
    return CC2?.UIController?.hideWait?.();
  }
  function afterStarterAssigned() {
    try {
      const repMgr = CC2?.GameReplayManager || (typeof window !== "undefined" ? window.GameReplayManager : null);
      if (repMgr?.currentReplay && state2?.starter) {
        repMgr.recordEvent("starter_cut", { starter: state2.starter });
      }
    } catch (_) {
    }
    return CC2?.GameEngine?.afterStarterAssigned?.({ state: state2, settings: settings2, log, cardLabel, rankOf, fancyCall, addScore, render, netPush, getSeatHand, isWild, setStatus, startDiscardOrPickFlow: startDiscardOrPickFlow2, nextSeat, hideWait, isSeatCpu, scheduleOppPlay, isOnline, isSeatHuman, passTo, sfx: sfx2, RANK_NAME: RANK_NAME2, pName, openWildPick });
  }
  function getAppBrand() {
    if (CC2?.SettingsManager?.getAppBrand) {
      return CC2.SettingsManager.getAppBrand(typeof window !== "undefined" ? window : null);
    }
    if (typeof window !== "undefined") {
      if (window.currentBrand) return window.currentBrand;
      if (window.currentLogoBrand) return window.currentLogoBrand;
      if (typeof window.detectBrand === "function") {
        try {
          const b = window.detectBrand();
          if (b) return b;
        } catch (e) {
        }
      }
      if (typeof document !== "undefined" && document.documentElement) {
        const b = document.documentElement.getAttribute("data-brand");
        if (b) return b;
      }
      if (window.location) {
        try {
          const params = new URLSearchParams(window.location.search);
          const p = (params.get("brand") || params.get("game") || params.get("logo") || "").toLowerCase();
          if (p === "clash" || p === "cribbage-clash") return "clash";
          if (p === "pints" || p === "pints-and-pegs" || p === "cribbage-pints") return "pints";
          if (p === "adult" || p === "stripped" || p === "skunked-and-stripped") return "adult";
          if (p === "crazy" || p === "crazy-cribbage") return "crazy";
          const href = (window.location.href || "").toLowerCase();
          if (href.indexOf("game-cribbage-clash") !== -1 || href.indexOf("cribbage-clash") !== -1 || href.indexOf("clash") !== -1) return "clash";
          if (href.indexOf("game-pints-and-pegs") !== -1 || href.indexOf("pints-and-pegs") !== -1 || href.indexOf("pints") !== -1) return "pints";
          if (href.indexOf("game-skunked-and-stripped") !== -1 || href.indexOf("skunked-and-stripped") !== -1 || href.indexOf("adult") !== -1 || href.indexOf("stripped") !== -1) return "adult";
        } catch (e) {
        }
      }
    }
    return "crazy";
  }
  function getSettingsKey() {
    return CC2?.SettingsManager?.getSettingsKey ? CC2.SettingsManager.getSettingsKey(getAppBrand()) : "crazyCribbage.settings.v1";
  }
  function getRecordKey() {
    return CC2?.SettingsManager?.getRecordKey ? CC2.SettingsManager.getRecordKey(getAppBrand()) : "crazyCribbage.records.v1";
  }
  function isAgeVerified(brand) {
    const b = brand || getAppBrand();
    if (b !== "pints" && b !== "adult") return true;
    const mgr = (typeof SettingsManager !== "undefined" ? SettingsManager : null) || CC2?.SettingsManager || typeof window !== "undefined" && window.SettingsManager;
    if (mgr && typeof mgr.isAgeVerified === "function") {
      return mgr.isAgeVerified(b, appStorage);
    }
    if (appStorage && typeof appStorage.getItem === "function") {
      return appStorage.getItem("cc_age_verified_" + b) === "true";
    }
    return false;
  }
  function setAgeVerified(brand, val = true) {
    const b = brand || getAppBrand();
    const mgr = (typeof SettingsManager !== "undefined" ? SettingsManager : null) || CC2?.SettingsManager || typeof window !== "undefined" && window.SettingsManager;
    if (mgr && typeof mgr.setAgeVerified === "function") {
      mgr.setAgeVerified(b, val, appStorage);
    } else if (appStorage && typeof appStorage.setItem === "function") {
      appStorage.setItem("cc_age_verified_" + b, val ? "true" : "false");
    }
  }
  function showAgeGateModal(brand) {
    return CC2?.ModalManager?.showAgeGateModal?.(brand, { getAppBrand });
  }
  function hideAgeGateModal() {
    return CC2?.ModalManager?.hideAgeGateModal?.();
  }
  function confirmAgeGate() {
    return CC2?.ModalManager?.confirmAgeGate?.({ getAppBrand, setAgeVerified, sfx: sfx2 });
  }
  function exitAgeGateToSafeBrand() {
    return CC2?.ModalManager?.exitAgeGateToSafeBrand?.();
  }
  var THEMES2 = CC2?.THEMES || CC2?.SettingsManager?.THEMES || [];
  function getThemeKey() {
    return CC2?.SettingsManager?.getThemeKey ? CC2.SettingsManager.getThemeKey(getAppBrand()) : "crazyCribbage.theme";
  }
  function getDefaultTheme() {
    return CC2?.SettingsManager?.getDefaultTheme ? CC2.SettingsManager.getDefaultTheme(getAppBrand()) : "tournament";
  }
  var theme = getDefaultTheme();
  try {
    theme = appStorage.getItem(getThemeKey()) || (typeof localStorage !== "undefined" ? localStorage.getItem(getThemeKey()) : null) || getDefaultTheme();
  } catch (e) {
    theme = getDefaultTheme();
  }
  if (!THEMES2.some((t) => t.id === theme)) theme = getDefaultTheme();
  function applyTheme(showFeedback = false) {
    if (CC2?.SettingsManager) {
      theme = CC2.SettingsManager.applyTheme(theme, { showFeedback, brand: getAppBrand() });
      (typeof window !== "undefined" ? window.modalManager : null)?.setTheme?.(theme);
    }
  }
  function toggleTheme() {
    if (getAppBrand() !== "clash" && CC2?.SettingsManager) {
      theme = CC2.SettingsManager.toggleTheme(theme, getAppBrand(), appStorage);
      applyTheme(true);
    }
  }
  var SETTINGS_KEY = getSettingsKey();
  var RECORD_KEY = getRecordKey();
  var CHECK_IDS2 = CC2 && CC2.CHECK_IDS || CC2 && CC2.SettingsManager && CC2.SettingsManager.CHECK_IDS || {};
  var recordCache = null;
  function variantParts(obj) {
    return CC2 && CC2.SettingsManager ? CC2.SettingsManager.variantParts(obj) : { goal: "high", target: "121", deal: "std", decks: "1" };
  }
  function variantKeyFrom(obj) {
    return CC2 && CC2.SettingsManager ? CC2.SettingsManager.variantKeyFrom(obj) : "";
  }
  function variantLabelFrom(obj) {
    return CC2 && CC2.SettingsManager ? CC2.SettingsManager.variantLabelFrom(obj) : "";
  }
  function loadRecords() {
    return CC2?.SettingsManager?.loadRecords(appStorage, getAppBrand()) ?? {};
  }
  function saveRecords(map) {
    CC2?.SettingsManager?.saveRecords(map, appStorage, getAppBrand());
  }
  function getVariantRecord(key) {
    return CC2?.SettingsManager?.getVariantRecord(key, appStorage, getAppBrand()) ?? { wins: 0, losses: 0 };
  }
  function recordGameResult(winner) {
    const src = settings2 && settings2.deal ? settings2 : currentFormVariant();
    const vKey = variantKeyFrom(src);
    const vLabel = variantLabelFrom(src);
    const b = typeof getAppBrand === "function" ? getAppBrand() : "crazy";
    const res = CC2?.SettingsManager?.recordGameResult(winner, vKey, vLabel, appStorage, b) ?? { wins: 0, losses: 0, label: vLabel };
    try {
      const profClass = typeof window !== "undefined" && window.Profile || CC2?.Profile || Profile;
      if (profClass) {
        const prof = typeof profClass.getInstance === "function" ? profClass.getInstance(appStorage) : profClass;
        if (prof && typeof prof.recordGame === "function") {
          const uScore = state2?.scores?.you ?? state2?.scores?.p1 ?? 0;
          const oScore = state2?.scores?.opp ?? state2?.scores?.p2 ?? 0;
          const oName = settings2?.seats && settings2.seats[1]?.name || "Opponent";
          const isSkunk = Boolean(typeof skunkResult2 === "function" && skunkResult2(state2, settings2));
          prof.recordGame({
            winner,
            userScore: uScore,
            oppScore: oScore,
            opponentName: oName,
            variantKey: vKey,
            variantLabel: vLabel,
            brand: b,
            skunk: isSkunk
          }, appStorage);
        }
      }
    } catch (err) {
      console.warn("[Profile] Failed to record match in profile:", err);
    }
    return res;
  }
  function currentFormVariant() {
    return CC2?.SettingsManager?.currentFormVariant?.({ brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy" }) ?? { goal: "high", target: 121, deal: "std", decks: 1 };
  }
  function renderRecordBox() {
    return CC2?.SettingsManager?.renderRecordBox?.({ brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy", settings: settings2 });
  }
  var CLASH_BLOCK_DEFS = CC2?.ClashSettings?.getBlockDefs ? CC2.ClashSettings.getBlockDefs() : [];
  function getActiveClashBlocks() {
    return CC2?.ClashSettings?.getActiveBlocks ? CC2.ClashSettings.getActiveBlocks(CLASH_BLOCK_DEFS) : [];
  }
  function checkClashCollision(candidateStart, length, excludeSelectId, blockList) {
    return CC2?.ClashSettings?.checkCollision?.(candidateStart, length, excludeSelectId, blockList, CC2.ClashManager);
  }
  function findAvailableClashHole(sel, length, excludeSelectId, activeBlocks) {
    return CC2?.ClashSettings?.findAvailableHole?.(sel, length, excludeSelectId, activeBlocks, CC2.ClashManager);
  }
  function updateAllClashDropdowns() {
    return CC2?.ClashSettings?.updateAllDropdowns?.(CLASH_BLOCK_DEFS, CC2.ClashManager);
  }
  var _isEnforcingClashNoOverlap = false;
  var _isRandomizingClash = false;
  function enforceClashNoOverlap(initiatorSelectId = null) {
    return CC2?.ClashSettings?.enforceNoOverlap?.(initiatorSelectId, { getActiveClashBlocks, updateAllClashDropdowns, checkCollision: checkClashCollision, findAvailableHole: findAvailableClashHole });
  }
  function sanitizeClashBlockPlacements(s) {
    return CC2?.ClashSettings?.sanitizeBlockPlacements ? CC2.ClashSettings.sanitizeBlockPlacements(s, typeof getClashDefaults3 === "function" ? getClashDefaults3 : null) : s;
  }
  function getStreetOrTurnName(h) {
    const targetVal = Number(settings2 && settings2.target || document.getElementById("optTarget") && document.getElementById("optTarget").value || 121);
    return CC2?.ClashSettings?.getStreetOrTurnName ? CC2.ClashSettings.getStreetOrTurnName(h, targetVal) : "Street 1";
  }
  function toggleSignsConfig(c) {
    return CC2?.ClashSettings?.toggleObstacleConfig?.("signs", c);
  }
  function toggleDetourConfig(c) {
    return CC2?.ClashSettings?.toggleObstacleConfig?.("detour", c);
  }
  function toggleRoundAboutConfig(c) {
    return CC2?.ClashSettings?.toggleObstacleConfig?.("roundAbout", c);
  }
  function toggleDiceConfig(c) {
    return CC2?.ClashSettings?.toggleObstacleConfig?.("dice", c);
  }
  function toggleWheelConfig(c) {
    return CC2?.ClashSettings?.toggleObstacleConfig?.("wheel", c);
  }
  function updateJumpOptionLabels(idx) {
    CC2?.ClashSettings?.updateJumpOptionLabels?.(idx);
  }
  function readSignsBlocksFromForm() {
    return CC2?.ClashSettings?.readSignsBlocksFromForm ? CC2.ClashSettings.readSignsBlocksFromForm({ target: settings2?.target }) : [];
  }
  function onSignBillboardClick(blockId) {
    return CC2?.ClashMiniGames?.onSignBillboardClick?.(blockId, { state: state2, log, fancyCall, getSignConfigs });
  }
  function toggleSkunkMarkersConfig(checked) {
    return CC2?.ClashSettings?.toggleSkunkMarkersConfig?.(checked, { settings: settings2, onSkunkMarkerFieldChange, onDoubleSkunkMarkerFieldChange, syncAllClashPlacementButtons, readFormSettings, saveSettingsStore, buildBoard });
  }
  function onSkunkMarkerFieldChange(skipSave = false) {
    return CC2?.ClashSettings?.onSkunkMarkerFieldChange?.(skipSave, { settings: settings2, getSkunkDefaults: getSkunkDefaults3, getStreetOrTurnName, readFormSettings, saveSettingsStore, buildBoard });
  }
  function onDoubleSkunkMarkerFieldChange(skipSave = false) {
    return CC2?.ClashSettings?.onDoubleSkunkMarkerFieldChange?.(skipSave, { settings: settings2, getSkunkDefaults: getSkunkDefaults3, getStreetOrTurnName, readFormSettings, saveSettingsStore, buildBoard });
  }
  var PINTS_DRINKING_DEFS2 = CC2 && CC2.PINTS_DRINKING_DEFS ? CC2.PINTS_DRINKING_DEFS : [];
  function randomizePintsOptions(isFull = false) {
    return typeof GameOptionsEngine !== "undefined" && typeof GameOptionsEngine.randomizeBrandOptions === "function" ? GameOptionsEngine.randomizeBrandOptions("pints", isFull) : void 0;
  }
  var ADULT_OPTIONS_LIST2 = CC2 && CC2.ADULT_OPTIONS_LIST ? CC2.ADULT_OPTIONS_LIST : [];
  function getDefaultAdultSettings() {
    return CC2?.AdultSettings?.getDefaultSettings?.() || { target: 121, goal: "high", theme: "passion" };
  }
  function getAdultOptionDef(key) {
    return CC2?.AdultSettings?.getOptionDef ? CC2.AdultSettings.getOptionDef(key) : ADULT_OPTIONS_LIST2 && Array.isArray(ADULT_OPTIONS_LIST2) ? ADULT_OPTIONS_LIST2.find((o) => o.key === key) || null : null;
  }
  function toggleAdultOptionConfig(optKey, checked, skipSave = false) {
    return CC2?.AdultSettings?.toggleOptionConfig?.(optKey, checked, skipSave);
  }
  function updateAdultOptionRows(optKey, skipSave = false) {
    return CC2?.AdultSettings?.updateOptionRows?.(optKey, skipSave);
  }
  function onAdultOptionPegsChange(optKey) {
    return CC2?.AdultSettings?.onOptionPegsChange?.(optKey, settings2);
  }
  function onAdultOptionFieldChange(optKey, idx, skipSave = false) {
    return CC2?.AdultSettings?.onOptionFieldChange?.(optKey, idx, skipSave);
  }
  function getAdultOptionConfigs(optKey) {
    return CC2?.AdultSettings?.getOptionConfigs?.(optKey, settings2) || [];
  }
  function randomizeAdultOptions(isFull = false) {
    return typeof GameOptionsEngine !== "undefined" && typeof GameOptionsEngine.randomizeBrandOptions === "function" ? GameOptionsEngine.randomizeBrandOptions("adult", isFull) : void 0;
  }
  function showAdultTimerModal(optionDef, playerLabel, holeNum) {
    return CC2?.ModalManager?.showAdultTimerModal?.(optionDef, playerLabel, holeNum, { state: state2, log, setStatus, sfx: sfx2 });
  }
  function startAdultTimer() {
    return CC2?.ModalManager?.startAdultTimer?.({ sfx: sfx2 });
  }
  function closeAdultTimerModal() {
    return CC2?.ModalManager?.closeAdultTimerModal?.({ state: state2, isSeatCpu, scheduleOppPlay, render });
  }
  function showAdultStripModal(optionDef, playerLabel, holeNum) {
    return CC2?.ModalManager?.showAdultStripModal?.(optionDef, playerLabel, holeNum, { state: state2, log, setStatus, sfx: sfx2 });
  }
  function closeAdultStripModal() {
    return CC2?.ModalManager?.closeAdultStripModal?.({ state: state2, isSeatCpu, scheduleOppPlay, render });
  }
  function resumeGameAfterAdultStrip() {
    return CC2?.ModalManager?.resumeGameAfterAdultStrip?.({ state: state2, isSeatCpu, scheduleOppPlay, render });
  }
  function resumeGameAfterAdultTimer() {
    return CC2?.ModalManager?.resumeGameAfterAdultTimer?.({ state: state2, isSeatCpu, scheduleOppPlay, render });
  }
  function showPintsBonusModal(optionDef, playerLabel, holeNum) {
    return CC2?.PintsManager?.showPintsBonusModal?.(optionDef, playerLabel, holeNum, { state: state2, log, setStatus, sfx: sfx2, pintsManager: typeof window !== "undefined" ? window.pintsManager : null });
  }
  function closePintsBonusModal() {
    return CC2?.PintsManager?.closePintsBonusModal?.({ pintsManager: typeof window !== "undefined" ? window.pintsManager : null, hideModal: hideModal2, resumeGameAfterPintsBonus });
  }
  function resumeGameAfterPintsBonus() {
    return CC2?.PintsManager?.resumeGameAfterPintsBonus?.({ state: state2, isSeatCpu, scheduleOppPlay, render });
  }
  function readFormSettings() {
    return CC2?.LobbyController?.readFormSettings?.({ getAppBrand, GameOptionsEngine, parseGameMode, settings: settings2, sanitizeClashBlockPlacements }) || {};
  }
  function updateTargetOptions(brand) {
    return CC2?.LobbyController?.updateTargetOptions?.(brand);
  }
  function applyFormSettings(saved) {
    if (CC2?.LobbyController?.applyFormSettings) {
      const prev = _suppressSettingsSave;
      _suppressSettingsSave = true;
      try {
        return CC2.LobbyController.applyFormSettings(saved, { settings: settings2, getAppBrand, GameOptionsEngine, setCardBack, updateCheckAllBonusesState, syncPlayerCountUi, enforceClashNoOverlap, applyBrandVisibility, syncAllClashPlacementButtons, updateCribbageClashOptionRanges });
      } finally {
        _suppressSettingsSave = prev;
      }
    }
  }
  function applyBrandVisibility(brand) {
    if (CC2?.LobbyController?.applyBrandVisibility) {
      const prev = _suppressSettingsSave;
      _suppressSettingsSave = true;
      try {
        return CC2.LobbyController.applyBrandVisibility(brand, {
          settings: settings2,
          buildBoard,
          getAppBrand,
          GameOptionsEngine,
          uncheckPintsOptions,
          uncheckAdultOptions: window.uncheckAdultOptions,
          uncheckCribbageClashOptions,
          updateCribbageClashOptionRanges,
          updateCheckAllBonusesState
        });
      } finally {
        _suppressSettingsSave = prev;
      }
    }
  }
  function updateCheckAllBonusesState() {
    return CC2?.LobbyController?.updateCheckAllBonusesState?.();
  }
  function saveSettingsStore(data) {
    if (_suppressSettingsSave) return;
    return CC2?.SettingsManager?.saveSettingsStore ? CC2.SettingsManager.saveSettingsStore(data, appStorage, getAppBrand(), _suppressSettingsSave) : null;
  }
  function loadSettingsStore() {
    return CC2?.SettingsManager?.loadSettingsStore?.({ storage: appStorage, brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy", defaultAdultSettings: typeof getDefaultAdultSettings === "function" ? getDefaultAdultSettings : null, adultOptionsList: typeof ADULT_OPTIONS_LIST2 !== "undefined" ? ADULT_OPTIONS_LIST2 : [] }) || null;
  }
  var net = { peer: null, conn: null, clients: /* @__PURE__ */ new Map(), room: null, ready: false, mySeatId: "p1", isHost: false, roster: [] };
  function setNetStatus(text2, mode) {
    const el = document.getElementById("netStatus");
    if (el) el.innerHTML = '<span id="netDot" class="' + (mode || "") + '"></span>' + text2;
  }
  function getLobbyRosterData() {
    return CC2?.LobbyController?.getLobbyRosterData ? CC2.LobbyController.getLobbyRosterData({ settings: settings2, net, mySeat: mySeat2, parseGameMode }) : [];
  }
  function updateNetRoster(remoteRoster) {
    return CC2?.NetworkManager?.updateNetRoster?.(remoteRoster, { net, settings: settings2, isOnline, getLobbyRosterData });
  }
  function broadcastLobbyUpdate() {
    return CC2?.NetworkManager?.broadcastLobbyUpdate?.({ net, settings: settings2, getLobbyRosterData });
  }
  function serializeState() {
    return CC2?.NetworkManager?.serializeState ? CC2.NetworkManager.serializeState(state2) : state2 || {};
  }
  function getSanitizedStateForSeat(targetSeatId, rawState) {
    return CC2?.NetworkManager?.sanitizeForClient ? CC2.NetworkManager.sanitizeForClient(rawState, targetSeatId) : rawState;
  }
  function netSend(msg, targetConn) {
    return CC2?.NetworkManager?.netSend?.(msg, targetConn, { net, settings: settings2 });
  }
  function netPush(extra = {}) {
    return CC2?.NetworkManager?.netPush?.(extra, { net, settings: settings2, isOnline, state: state2, serializeState, getSanitizedStateForSeat });
  }
  function applyRemoteState(payload) {
    return CC2?.NetworkManager?.applyRemoteState?.(payload, { net, settings: settings2, state: state2, setState: (s) => {
      state2 = s;
    }, hideWait, getBoardSignature, buildBoard, applySeatLabels, renderScores, render, fancyCall, sfx: sfx2, log, setShowMeter, openShowModal, hideModal: hideModal2 });
  }
  function handleSeatDiscardIntent(sId, ids) {
    return CC2?.NetworkManager?.handleSeatDiscardIntent?.(sId, ids, { state: state2, settings: settings2, getSeatHand, setSeatHand, setSeatKept, seatDiscardsToDeck, seatName: seatName2, mySeat: mySeat2, getActiveSeatIds, isSeatHuman, isSeatCpu, isDealerTeam, chooseDiscard, setStatus, log, render, netPush, startPlayAfterDiscards, startStarter, beginCutStarter });
  }
  function hostApplyIntent(msg, fromConn) {
    return CC2?.NetworkManager?.hostApplyIntent?.(msg, fromConn, { settings: settings2, state: state2, netPush, resolveStolenCribGuess, pickCut, poneDoCutStarter, getSeatHand, playCard, handleSeatDiscardIntent, confirmDraw, playAgain, confirmWildAs });
  }
  function handleClientHello(conn, msg) {
    return CC2?.NetworkManager?.handleClientHello?.(conn, msg, { settings: settings2, net, state: state2, getLobbyRosterData, broadcastLobbyUpdate, updateNetRoster, setNetStatus, netPush });
  }
  function handleClientDisconnect(conn) {
    return CC2?.NetworkManager?.handleClientDisconnect?.(conn, { net, broadcastLobbyUpdate, updateNetRoster, state: state2, settings: settings2, setNetStatus, log, netPush, scheduleOppPlay, onPlayerOffline: handlePlayerOfflinePrompt, renderScores, render });
  }
  function handleHostDisconnect() {
    return CC2?.NetworkManager?.handleHostDisconnect?.({ net, settings: settings2, state: state2, setNetStatus, log, hideWait, onPlayerOffline: handlePlayerOfflinePrompt, renderScores, render });
  }
  function bindHostClientConn(conn) {
    return CC2?.NetworkManager?.bindHostClientConn?.(conn, { handleClientHello, hostApplyIntent, handleClientDisconnect });
  }
  function makeRoomCode() {
    return CC2?.NetworkManager?.generateRoomCode ? CC2.NetworkManager.generateRoomCode() : "ROOM99";
  }
  function getJoinUrl(code) {
    const roomCode = (code || net.room || document.getElementById("optRoom") && document.getElementById("optRoom").value || "").trim().toUpperCase();
    return CC2?.NetworkManager?.getJoinUrl ? CC2.NetworkManager.getJoinUrl(roomCode) : roomCode ? `?join=${encodeURIComponent(roomCode)}` : "";
  }
  function showHostInviteLink(code) {
    return CC2?.NetworkManager?.showHostInviteLink?.(code, { getJoinUrl });
  }
  function copyRoomInviteLink(btnEl) {
    return CC2?.NetworkManager?.copyRoomInviteLink?.(btnEl, { net, setNetStatus, getJoinUrl });
  }
  function shareRoomInvite() {
    return CC2?.NetworkManager?.shareRoomInvite?.({ net, setNetStatus, getJoinUrl });
  }
  function shareRoomWhatsApp() {
    return CC2?.NetworkManager?.shareRoomWhatsApp?.({ net, getJoinUrl });
  }
  function shareRoomEmail() {
    return CC2?.NetworkManager?.shareRoomEmail?.({ net, getJoinUrl });
  }
  function fallbackCopyText(text2, cb) {
    return CC2?.NetworkManager?.fallbackCopyText?.(text2, cb);
  }
  function hostRoom() {
    return CC2?.NetworkManager?.hostRoom?.({ setNetStatus, settings: settings2, net, makeRoomCode, showHostInviteLink, updateNetRoster, bindHostClientConn, hideWait });
  }
  function joinRoom(code) {
    return CC2?.NetworkManager?.joinRoom?.(code, { setNetStatus, hideWait, settings: settings2, net, updateNetRoster, applyRemoteState, showModal, hideModal: hideModal2, onPlayerOffline: handlePlayerOfflinePrompt, renderScores, render, log });
  }
  function startGameOnline() {
    return CC2?.LobbyController?.startGameOnline?.({ settings: settings2, net, getAppBrand, isAgeVerified, showAgeGateModal, hideModal: hideModal2, startGame, netPush });
  }
  function startGame() {
    return CC2?.LobbyController?.startGame?.({ settings: settings2, net, getAppBrand, isAgeVerified, showAgeGateModal, hideMenuOptions: hideMenuOtions, parseGameMode, GameOptionsEngine, hostRoom, setCardBack, readFormSettings, sanitizeClashBlockPlacements, saveSettingsStore, makeDeck, applySeatLabels, resetMatch, isOnline, isHvH, is3Player1vs2, getNoPassingLanes, getJumpConfigs, getJailConfigs, getBarConfigs, getTimeoutConfigs, getDetourConfigs, getRoundAboutConfigs, getSignConfigs, getDiceConfigs: getDiceConfigs2, getWheelConfigs: getWheelConfigs2 });
  }
  function resetMatch() {
    if (CC2?.GameEngine?.resetMatch) {
      const res = CC2.GameEngine.resetMatch({ settings: settings2, makeDeck, pegTracker: typeof window !== "undefined" ? window.pegTracker : null, getSignConfigs, setState: (s) => {
        state2 = s;
        if (typeof window !== "undefined") window.state = s;
      }, hideModal: hideModal2, buildBoard, renderScores, beginCut });
      if (res?.state) {
        state2 = res.state;
        if (typeof window !== "undefined") window.state = state2;
        gameHands = res.gameHands || [];
      }
    }
    try {
      const repMgr = CC2?.GameReplayManager || (typeof window !== "undefined" ? window.GameReplayManager : null);
      if (repMgr) {
        repMgr.startRecording({ settings: settings2, state: state2, brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy", pName });
      }
    } catch (_) {
    }
  }
  function playAgain() {
    return CC2?.GameEngine?.playAgain?.({ isOnline, settings: settings2, netSend, resetMatch, netPush });
  }
  function beginCut() {
    return CC2?.GameEngine?.beginCut?.({ state: state2, resetAnims, sfx: sfx2, shuffle, makeDeck, setStatus, render, netPush, stepNextCut, resolveCuts, getActiveSeatIds, isSeatCpu, isSeatHuman, seatName: seatName2, updateTurnPrompt, passTo, isWild, rankOf, log, fancyCall, cardLabel, mySeat: mySeat2, newHand });
  }
  function renderCutFan() {
    return CC2?.GameEngine?.renderCutFan?.({ document, state: state2, getActiveSeatIds, isSeatHuman, isOnline, mySeat: mySeat2, seatName: seatName2, cardLabel, cardEl, pickCut });
  }
  function resolveCuts() {
    return CC2?.GameEngine?.resolveCuts?.({ state: state2, getActiveSeatIds, rankOf, isWild, log, setStatus, fancyCall, render, netPush, shuffle, makeDeck, stepNextCut, seatName: seatName2, cardLabel, mySeat: mySeat2, newHand });
  }
  function pickCut(index, seat) {
    return CC2?.GameEngine?.pickCut?.(index, seat, { state: state2, isOnline, mySeat: mySeat2, settings: settings2, netSend, isWild, setStatus, sfx: sfx2, render, netPush, stepNextCut, resolveCuts, getActiveSeatIds, isSeatCpu, isSeatHuman, seatName: seatName2, updateTurnPrompt, passTo, rankOf, log, fancyCall, shuffle, makeDeck, cardLabel, newHand });
  }
  function stepNextCut() {
    return CC2?.GameEngine?.stepNextCut?.({ state: state2, getActiveSeatIds, isSeatCpu, isSeatHuman, seatName: seatName2, setStatus, updateTurnPrompt, render, netPush, isOnline, passTo, isWild, sfx: sfx2, resolveCuts, rankOf, log, fancyCall, shuffle, makeDeck, cardLabel, mySeat: mySeat2, newHand });
  }
  function doCut() {
    return CC2?.GameEngine?.doCut?.({ state: state2, pickCut });
  }
  function newHand() {
    try {
      const repMgr = CC2?.GameReplayManager || (typeof window !== "undefined" ? window.GameReplayManager : null);
      if (repMgr) {
        if (!repMgr.currentReplay) {
          repMgr.startRecording({ settings: settings2, state: state2, brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy", pName });
        }
        repMgr.recordEvent("round_start", { round: (state2?.handsCompleted || 0) + 1, dealer: state2?.dealer });
      }
    } catch (_) {
    }
    return CC2?.GameEngine?.newHand?.({ state: state2, resetAnims, sfx: sfx2, getActiveSeatIds, settings: settings2, Deck: CC2?.Deck || Deck2, shuffle, makeDeck, setSeatHand, nextSeat, isSoloVsPairs, seatName: seatName2, log, setStatus, fancyCall, render, finishDeal });
  }
  function openGuessStarterPrompt(poneSeat, onGuess) {
    const mm = (typeof window !== "undefined" ? window.modalManager : null) || (CC2?.ModalManager ? new CC2.ModalManager() : null);
    return CC2?.ModalManager?.openGuessStarterPrompt?.(poneSeat, onGuess, { seatName: seatName2, showModal, hideModal: hideModal2 }) || mm?.openGuessStarterPrompt?.(poneSeat, onGuess, { seatName: seatName2, showModal, hideModal: hideModal2 });
  }
  function beginCutStarter(ctx = {}) {
    return CC2?.GameEngine?.beginCutStarter?.({ state: state2, settings: settings2, nextSeat, mySeat: mySeat2, isOnline, isSeatHuman, isSeatCpu, seatName: seatName2, setStatus, render, netPush, poneDoCutStarter, passTo, openGuessStarterPrompt, ...ctx });
  }
  function poneDoCutStarter(ctx = {}) {
    return CC2?.GameEngine?.poneDoCutStarter?.({ state: state2, isOnline, settings: settings2, netSend, mySeat: mySeat2, sfx: sfx2, startStarter, openGuessStarterPrompt, nextSeat, isSeatCpu, isSeatHuman, ...ctx });
  }
  function announcePlayTurn(seatId) {
    return CC2?.GameEngine?.announcePlayTurn?.(seatId, { state: state2, isOnline, isSeatHuman, mySeat: mySeat2, seatName: seatName2, fancyCall, setStatus, netPush, boardRenderer3D: typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null });
  }
  function startPlayAfterDiscards() {
    return CC2?.GameEngine?.startPlayAfterDiscards?.({ state: state2, nextSeat, hideWait, render, netPush, isSeatCpu, isSeatHuman, isOnline, scheduleOppPlay, passTo, fancyCall, seatName: seatName2, mySeat: mySeat2, setStatus, boardRenderer3D: typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null });
  }
  function finishDeal() {
    try {
      const repMgr = CC2?.GameReplayManager || (typeof window !== "undefined" ? window.GameReplayManager : null);
      if (repMgr?.currentReplay) {
        repMgr.recordEvent("deal", { hands: state2?.hands || state2?.seatHands });
      }
    } catch (_) {
    }
    return CC2?.GameEngine?.finishDeal?.({ state: state2, getActiveSeatIds, isSeatCpu, isSeatHuman, isDealerTeam, getSeatHand, setSeatHand, setSeatKept, cpuAssignWilds, settings: settings2, beginCutStarter, isWild, setStatus, render, startDiscardOrPickFlow: startDiscardOrPickFlow2, startCanadianDoublesFlow, showModal, hideModal: hideModal2, seatName: seatName2, log, fancyCall, nextSeat, passTo, hideWait, startPlayAfterDiscards, startStarter, openGuessStarterPrompt, poneDoCutStarter, netPush, openWildPick });
  }
  function startStarter(ctx = {}) {
    return CC2?.GameEngine?.startStarter?.({ state: state2, settings: settings2, hideWait, setStatus, fancyCall, render, netPush, finishStarterRitual, document, beginCutStarter, openGuessStarterPrompt, nextSeat, isSeatCpu, isSeatHuman, seatName: seatName2, poneDoCutStarter, passTo, isOnline, mySeat: mySeat2, netSend, sfx: sfx2, ...ctx });
  }
  function finishStarterRitual() {
    return CC2?.GameEngine?.finishStarterRitual?.({ state: state2, isWild, isSeatHuman, render, openWildPick, hideWait, setStatus, seatName: seatName2, isHvH, passTo, cpuAssignWilds, afterStarterAssigned });
  }
  function confirmP2Discard() {
    return CC2?.GameEngine?.confirmP2Discard?.({ state: state2, isOnline, settings: settings2, netSend, render, startPlayAfterDiscards, startStarter, beginCutStarter, openGuessStarterPrompt, poneDoCutStarter, nextSeat });
  }
  function onPickCribCard(seatId, c) {
    return CC2?.GameEngine?.onPickCribCard?.(seatId, c, { state: state2, render });
  }
  function startHumanPickCrib() {
    return CC2?.GameEngine?.startHumanPickCrib?.({ state: state2, finishPickYourCrib, settings: settings2, seatName: seatName2, setStatus, render });
  }
  function confirmPickCrib() {
    return CC2?.GameEngine?.confirmPickCrib?.({ state: state2, getSeatHand, setSeatHand, setSeatKept, seatName: seatName2, log, fancyCall, startHumanPickCrib, finishPickYourCrib });
  }
  function finishPickYourCrib() {
    return CC2?.GameEngine?.finishPickYourCrib?.({ state: state2, settings: settings2, startPlayAfterDiscards, startStarter, beginCutStarter, openGuessStarterPrompt, poneDoCutStarter, nextSeat });
  }
  function cpuPickFromPone(dealerSeat, poneSeat, pickN) {
    return CC2?.GameEngine?.cpuPickFromPone?.(dealerSeat, poneSeat, pickN, { state: state2, getSeatHand, setSeatHand, setSeatKept, seatName: seatName2, log });
  }
  function cpuDoPickYourCrib() {
    return CC2?.GameEngine?.cpuDoPickYourCrib?.({ state: state2, settings: settings2, getSeatHand, chooseDiscard, setSeatHand, setSeatKept, getActiveSeatIds, cpuPickFromPone, fancyCall, setStatus, seatName: seatName2, cardLabel, render, startPlayAfterDiscards, startStarter, beginCutStarter, openGuessStarterPrompt, poneDoCutStarter, nextSeat });
  }
  function startCanadianDoublesFlow() {
    return CC2?.GameEngine?.startCanadianDoublesFlow?.({ state: state2, settings: settings2, getSeatHand, setSeatHand, setSeatKept, isSeatCpu, isSeatHuman, isDealerTeam, seatName: seatName2, log, fancyCall, nextSeat, passTo, hideWait, setStatus, render, startPlayAfterDiscards, startStarter, beginCutStarter, openGuessStarterPrompt, poneDoCutStarter, showModal, hideModal: hideModal2 });
  }
  function startDiscardOrPickFlow2() {
    return CC2?.GameEngine?.startDiscardOrPickFlow?.({ settings: settings2, state: state2, isSeatCpu, isSeatHuman, isDealerTeam, isTwoHuman, passTo, beginDiscard, cpuDoPickYourCrib, getSeatHand, chooseDiscard, setSeatHand, setSeatKept, seatName: seatName2, log, fancyCall, render, startPlayAfterDiscards, startStarter, beginCutStarter, openGuessStarterPrompt, poneDoCutStarter, nextSeat, hideWait, setStatus, showModal, hideModal: hideModal2 });
  }
  function confirmDiscard() {
    try {
      const repMgr = CC2?.GameReplayManager || (typeof window !== "undefined" ? window.GameReplayManager : null);
      if (repMgr?.currentReplay) {
        repMgr.recordEvent("discard", { who: mySeat2, discards: state2?.selected || [] });
      }
    } catch (_) {
    }
    return CC2?.GameEngine?.confirmDiscard?.({ state: state2, confirmPickCrib, settings: settings2, mySeat: mySeat2, isOnline, netSend, setStatus, render, handleSeatDiscardIntent, getSeatHand, setSeatHand, setSeatKept, seatDiscardsToDeck, seatName: seatName2, log, getActiveSeatIds, startHumanPickCrib, isTwoHuman, hideWait, passTo, isWild, netPush, isSeatHuman, isSeatCpu, isDealerTeam, chooseDiscard, startPlayAfterDiscards, startStarter, beginDiscard, beginCutStarter, openGuessStarterPrompt, poneDoCutStarter, nextSeat });
  }
  function confirmDraw() {
    return CC2?.GameEngine?.confirmDraw?.({ state: state2, settings: settings2, isOnline, netSend, mySeat: mySeat2, getSeatHand, setSeatHand, setSeatKept, seatName: seatName2, log, fancyCall, netPush, render, passTo, isTwoHuman, isSeatCpu, beginDiscard, startPlayAfterDiscards, startStarter, setStatus, updateCoachDisplay, seatDiscardsToDeck, isSoloVsPairs, isDealerTeam, rankOf, VAL: VAL3, hideWait, isWild, isSeatHuman, finishStarterRitual, document, CribbageAI: CC2?.CribbageAI || CribbageAI });
  }
  function findNextPlayerWithPlay(fromSeat, count) {
    const seats = getActiveSeatIds(), hands = {};
    for (const s of seats) hands[s] = getSeatHand(s);
    return CC2?.CribbageAI?.findNextPlayerWithPlay ? CC2.CribbageAI.findNextPlayerWithPlay(fromSeat, count, seats, hands) : null;
  }
  function settleGo(whoJustPlayed, arg2, arg3) {
    const goSeats = Array.isArray(arg2) || typeof arg2 === "string" ? arg2 : Array.isArray(arg3) || typeof arg3 === "string" ? arg3 : null;
    const extraCtx = arg2 && typeof arg2 === "object" && !Array.isArray(arg2) ? arg2 : {};
    return CC2?.GameEngine?.settleGo?.(whoJustPlayed, { state: state2, fancyCall, render, netPush, finishPlay, getActiveSeatIds, getSeatHand, nextSeat, isSeatCpu, isSeatHuman, isOnline, scheduleOppPlay, passTo, document, seatName: seatName2, mySeat: mySeat2, log, setStatus, boardRenderer3D: typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null, ...extraCtx }, goSeats);
  }
  function playCard(who, card) {
    return CC2?.GameEngine?.playCard?.(who, card, { state: state2, settings: settings2, getSeatHand, VAL: VAL3, rankOf, pegPoints, isBonusMessage, announceCombos, seatName: seatName2, cardLabel, isWild, log, sfx: sfx2, addScore, fancyPegPhrase, render, netPush, settleGo, findNextPlayerWithPlay, isSeatCpu, scheduleOppPlay, isOnline, isSeatHuman, passTo, fancyCall, getActiveSeatIds, getSeatKept, setSeatKept, mySeat: mySeat2, setStatus, boardRenderer3D: typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null });
  }
  function cpuSeatPlay(seatId) {
    return CC2?.GameEngine?.cpuSeatPlay?.(seatId, { state: state2, getSeatHand, choosePlay, settings: settings2, log, seatName: seatName2, findNextPlayerWithPlay, render, netPush, isSeatCpu, scheduleOppPlay, isOnline, isSeatHuman, passTo, addScore, settleGo, playCard, mySeat: mySeat2, setStatus, fancyCall, getActiveSeatIds, boardRenderer3D: typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null });
  }
  function cpuTurn() {
    return CC2?.GameEngine?.cpuTurn?.({ state: state2, getSeatHand, choosePlay, settings: settings2, log, seatName: seatName2, findNextPlayerWithPlay, render, netPush, isSeatCpu, scheduleOppPlay, isOnline, isSeatHuman, passTo, addScore, settleGo, playCard, mySeat: mySeat2, setStatus, fancyCall, getActiveSeatIds, boardRenderer3D: typeof window !== "undefined" ? window.boardRenderer3D || window._currentRenderer3D : null });
  }
  function miniCardHtml(c, extra) {
    return CC2 && CC2.TableRenderer ? CC2.TableRenderer.miniCardHtml(c, extra) : "";
  }
  function showPegPoints() {
    return CC2?.ShowModal?.showPegPoints?.({ state: state2, settings: settings2 });
  }
  function showHandPoints(key) {
    return CC2?.ShowModal?.showHandPoints?.(key, { state: state2, settings: settings2 });
  }
  function setShowMeter(act, total, line, isBonus = false) {
    return CC2?.ShowModal?.setShowMeter?.(act, total, line, isBonus);
  }
  function famousFanfare(n) {
    return CC2?.ShowModal?.famousFanfare?.(n, { sfx: sfx2, fancyCall });
  }
  function finishPlay() {
    return CC2?.GameEngine?.finishPlay?.({ state: state2, settings: settings2, getPlayerCount, getSeatKept, setSeatKept, scoreShow, pName, seatName: seatName2, openShowModal, beginShowAct, nextSeat, isSoloVsPairs, getActiveSeatIds, log });
  }
  function cpuGuessCrib(poneSeat, dealerSeat) {
    const myDiscards = state2?.seatDiscards?.[poneSeat] || [];
    if (!state2?.starter || myDiscards.length < 2) return 4;
    return CC2?.CribbageAI?.guessStolenCrib ? CC2.CribbageAI.guessStolenCrib(myDiscards, state2.starter, getSeatKept(poneSeat) || [], FULL_DECK, { scoreShow, shuffle }) : 4;
  }
  function selectStolenChip(n) {
    return CC2?.ShowModal?.selectStolenChip?.(n);
  }
  function openStolenCribPrompt(poneSeat, dealerSeat, actIdx) {
    return CC2?.ShowModal?.openStolenCribPrompt?.(poneSeat, dealerSeat, actIdx, { seatName: seatName2, showModal, hideModal: hideModal2, sendStolenCribGuess });
  }
  function sendStolenCribGuess(val, actIdx) {
    return CC2?.ShowModal?.sendStolenCribGuess?.(val, actIdx, { isOnline, settings: settings2, netSend, showWait, resolveStolenCribGuess });
  }
  function resolveStolenCribGuess(guess, actIdx) {
    return CC2?.ShowModal?.resolveStolenCribGuess?.(guess, actIdx, { state: state2, seatName: seatName2, log, fancyCall, famousFanfare, netPush, beginShowAct });
  }
  function openTwistedCribbageModal(dealerSeat, actIdx) {
    return CC2?.ShowModal?.openTwistedCribbageModal?.(dealerSeat, actIdx, {
      state: state2,
      settings: settings2,
      getSeatKept,
      setSeatKept,
      seatName: seatName2,
      pName,
      log,
      fancyCall,
      showModal,
      hideModal: hideModal2,
      render,
      netPush,
      beginShowAct,
      isOnline,
      resolveTwistedCribbageSplit
    });
  }
  function resolveTwistedCribbageSplit(hand1, hand2, actIdx) {
    return CC2?.ShowModal?.resolveTwistedCribbageSplit?.(hand1, hand2, actIdx, {
      state: state2,
      settings: settings2,
      getSeatKept,
      setSeatKept,
      seatName: seatName2,
      pName,
      log,
      fancyCall,
      render,
      netPush,
      beginShowAct
    });
  }
  function beginShowAct(i) {
    return CC2?.ShowModal?.beginShowAct?.(i, { state: state2, setShowMeter, openShowModal, settings: settings2, getPlayerCount, render, getSeat, isOnline, seatName: seatName2, openStolenCribPrompt, openTwistedCribbageModal, resolveTwistedCribbageSplit, getSeatKept, setSeatKept, log, showWait, fancyCall, cpuGuessCrib, resolveStolenCribGuess, resetAnims, netPush, finishShowAct, tickShowLine, isSeatHuman, showModal, hideModal: hideModal2, pName, checkGameOver, checkChutesAndLadders, sfx: sfx2, renderScores, getActiveTracks: getActiveTracks2 });
  }
  function finishShowAct(actIdx) {
    return CC2?.ShowModal?.finishShowAct?.(actIdx, {
      state: state2,
      settings: settings2,
      scoreKey,
      isInPegThroughZone: isInPegThroughZone2,
      isInLast5PegOut: isInLast5PegOut2,
      isInBunker: isInBunker2,
      applyHighlights,
      setShowMeter,
      pName,
      log,
      fancyCall,
      renderScores,
      netPush,
      famousFanfare,
      addScore,
      openShowModal,
      beginShowAct,
      isSeatHuman,
      mySeat: mySeat2,
      getActiveTracks: getActiveTracks2,
      checkGameOver,
      showCardAssassin: (opts) => {
        const assassinOpt = settings2?.cardAssassin ?? "no";
        if (assassinOpt !== "yes") {
          if (opts && typeof opts.onComplete === "function") {
            opts.onComplete();
          }
          return;
        }
        const fn = CC2?.CardAssassinOverlay?.show || typeof window !== "undefined" && window.CardAssassinOverlay?.show || CardAssassinOverlay?.show;
        if (typeof fn === "function") {
          return fn(opts);
        } else if (opts && typeof opts.onComplete === "function") {
          opts.onComplete();
        }
      }
    });
  }
  function tickShowLine(actIdx, lineIdx) {
    return CC2?.ShowModal?.tickShowLine?.(actIdx, lineIdx, { state: state2, isBonusMessage, cardKey, applyHighlights, setShowMeter, fancyCall, sfx: sfx2, netPush, finishShowAct });
  }
  function saveHand(state3) {
    return CC2?.ShowModal?.saveHand?.(state3, gameHands);
  }
  function openShowModal(pegOnly) {
    return CC2?.ShowModal?.open?.(pegOnly, { state: state2, settings: settings2, checkGameOver });
  }
  function showModal(html2, closable = false) {
    if (typeof window !== "undefined" ? window.modalManager : null) {
      (typeof window !== "undefined" ? window.modalManager : null).setTheme(theme);
      return (typeof window !== "undefined" ? window.modalManager : null).showModal(html2, closable);
    }
  }
  function hideModal2() {
    if (typeof window !== "undefined" ? window.modalManager : null) return (typeof window !== "undefined" ? window.modalManager : null).hideModal(state2);
    if (state2?.passingTo) state2.passingTo = null;
  }
  function showOverlay(html2, closable = false) {
    return showModal(html2, closable);
  }
  function hideOverlay() {
    return hideModal2();
  }
  function closeModal() {
    return hideModal2();
  }
  function closeOverlay() {
    return hideModal2();
  }
  function setupCloseButtonCompat() {
    if (typeof document === "undefined") return;
    const origGetById = document.getElementById.bind(document);
    document.getElementById = function(id) {
      if (id === "overlayClose") return origGetById("modalClose") || origGetById("modalBar");
      return origGetById(id);
    };
    const origQuerySelector = document.querySelector.bind(document);
    document.querySelector = function(sel) {
      if (sel === "#overlayClose") return origGetById("modalClose") || origGetById("modalBar") || origQuerySelector(sel);
      return origQuerySelector(sel);
    };
  }
  function showConfirmModal(opts) {
    if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showConfirmModal === "function") {
      return window.modalManager.showConfirmModal(opts);
    }
    if (CC2?.ModalManager?.showConfirmModal) {
      return CC2.ModalManager.showConfirmModal(opts);
    }
    if (typeof ModalManager2 !== "undefined") {
      return new ModalManager2().showConfirmModal(opts);
    }
  }
  function backToMenu() {
    return CC2?.ModalManager?.backToMenu?.({ state: state2, hideModal: hideModal2, showConfirmModal, renderRecordBox });
  }
  function returnToMenu() {
    return CC2?.ModalManager?.returnToMenu?.({ state: state2, hideModal: hideModal2, showConfirmModal, renderRecordBox });
  }
  function cancelGameAndReturnToMenu() {
    if (state2) state2.over = true;
    if (typeof hideModal2 === "function") hideModal2();
    if (typeof hideWait === "function") hideWait();
    const waitBar = typeof document !== "undefined" ? document.getElementById("reconnectWaitBar") : null;
    if (waitBar) waitBar.remove();
    try {
      const camMgr = typeof window !== "undefined" && (window._ccCameraManager || window.CrazyCribbage && window.CrazyCribbage.CameraManager && window.CrazyCribbage.CameraManager.getInstance());
      if (camMgr && camMgr.isBroadcasting) {
        camMgr.stopBroadcast();
      }
      const chatMgr = typeof window !== "undefined" && (window._ccChatManager || window.CrazyCribbage && window.CrazyCribbage.ChatManager && window.CrazyCribbage.ChatManager.getInstance());
      if (chatMgr) {
        chatMgr.setChatVisibility(false);
        chatMgr.clearChat();
      }
    } catch (e) {
    }
    if (net && net.conn) {
      try {
        if (typeof netPush === "function") {
          netPush({ type: "game_cancelled", text: "The game was cancelled." });
        }
      } catch (e) {
      }
    }
    if (net) {
      net.ready = false;
    }
    if (typeof document !== "undefined") {
      const game = document.getElementById("game");
      const menu = document.getElementById("menu");
      if (game) game.classList.add("hidden");
      if (menu) menu.classList.remove("hidden");
    }
    if (typeof renderRecordBox === "function") renderRecordBox();
    if (typeof setNetStatus === "function") {
      setNetStatus("Game cancelled.", "idle");
    }
  }
  var DROPDOWN_DESCRIPTIONS2 = CC2?.DROPDOWN_DESCRIPTIONS || {};
  function showDropdownInfoModal(key) {
    return CC2?.DropdownHelpManager?.showDropdownInfoModal?.(key, { settings: settings2, theme, getAppBrand, showModal, hideModal: hideModal2, setCardBack });
  }
  function selectOptionFromModal2(key, val) {
    return CC2?.DropdownHelpManager?.selectOptionFromModal?.(key, val, { setCardBack, hideModal: hideModal2 });
  }
  function initDropdownLabels() {
    return CC2?.DropdownHelpManager?.initDropdownLabels?.({ showDropdownInfoModal });
  }
  function syncPlayerCountUi() {
    return CC2?.LobbyController?.syncPlayerCountUi?.({ settings: settings2, parseGameMode, getAppBrand, GameOptionsEngine });
  }
  function updateCribbageClashOptionRanges(targetOrIsClash) {
    return CC2?.ClashPlacementModal?.updateOptionRanges?.(targetOrIsClash, { settings: settings2 });
  }
  function randomizeCrazyCribbageBonuses() {
    return CC2?.LobbyController?.randomizeCrazyCribbageBonuses?.({ GameOptionsEngine, getRandomSubset });
  }
  function randomizeCribbageClashOptions(isFull = false) {
    return CC2 && CC2.ClashPlacementModal ? CC2.ClashPlacementModal.randomizeOptions(isFull, { settings: settings2 }) : void 0;
  }
  function getJumpTriggerLength2(jumpIdx, overrideStart = null) {
    return CC2 && typeof CC2.getJumpTriggerLength === "function" ? CC2.getJumpTriggerLength(jumpIdx, overrideStart) : 1;
  }
  var CLASH_ITEM_METADATA = CC2 && CC2.ClashPlacementModal && CC2.ClashPlacementModal.getMetadata ? CC2.ClashPlacementModal.getMetadata(settings2) : {};
  function initClashPlacementButtons() {
    return CC2 && CC2.ClashPlacementModal ? CC2.ClashPlacementModal.initPlacementButtons(CLASH_ITEM_METADATA) : void 0;
  }
  function syncClashPlacementButton(selectId) {
    return CC2 && CC2.ClashPlacementModal ? CC2.ClashPlacementModal.syncPlacementButton(selectId, CLASH_ITEM_METADATA) : void 0;
  }
  function syncAllClashPlacementButtons() {
    return CC2 && CC2.ClashPlacementModal ? CC2.ClashPlacementModal.syncAllPlacementButtons(CLASH_ITEM_METADATA) : void 0;
  }
  function getAllPlacedClashItems(excludeSelectId) {
    return CC2 && CC2.ClashPlacementModal ? CC2.ClashPlacementModal.getAllPlacedItems(excludeSelectId, CLASH_ITEM_METADATA) : [];
  }
  function openClashPlacementModal(selectId) {
    return CC2 && CC2.ClashPlacementModal ? CC2.ClashPlacementModal.open(selectId, { settings: settings2, meta: CLASH_ITEM_METADATA }) : void 0;
  }
  function closeClashPlacementModal() {
    return CC2?.ClashPlacementModal?.close?.();
  }
  function onConfirmClashPlacement() {
    return CC2?.ClashPlacementModal?.onConfirm?.({ settings: settings2, meta: CLASH_ITEM_METADATA });
  }
  function renderClashPlacementBoard(selectId) {
    return CC2?.ClashPlacementModal?.renderPlacementBoard?.(selectId, { settings: settings2, meta: CLASH_ITEM_METADATA });
  }
  function uncheckCribbageClashOptions() {
    return CC2?.ClashPlacementModal?.uncheckClashOptions?.();
  }
  function uncheckPintsOptions() {
    return CC2?.ClashPlacementModal?.uncheckPintsOptions?.();
  }
  function initTableSplitter() {
    return CC2?.UIController?.initTableSplitter?.();
  }
  function initThemeButtons() {
    return CC2?.UIController?.initThemeButtons?.({ applyTheme, toggleTheme });
  }
  function initSoundButton() {
    return CC2?.UIController?.initSoundButton?.({ sfx: sfx2 });
  }
  function checkInitialAgeGate() {
    return CC2?.LobbyController?.checkInitialAgeGate?.({ getAppBrand, isAgeVerified, showAgeGateModal });
  }
  function setupNetUi() {
    return CC2?.NetworkManager?.setupNetUi?.({ settings: settings2, net, showHostInviteLink, hostRoom, joinRoom, copyRoomInviteLink, startGameOnline, syncPlayerCountUi, getAppBrand, showModal, hideModal: hideModal2, GameOptionsEngine: typeof GameOptionsEngine !== "undefined" ? GameOptionsEngine : null });
  }
  function handleZoneOptionChange(changedEl) {
    return CC2?.LobbyController?.handleZoneOptionChange?.(changedEl, { updateCheckAllBonusesState });
  }
  function setupCheckAllBonuses() {
    return CC2?.LobbyController?.setupCheckAllBonuses?.({ updateCheckAllBonusesState, parseGameMode, toggleSignsConfig, toggleDetourConfig, toggleRoundAboutConfig, handleZoneOptionChange });
  }
  function toggleMenuSettings(fromGame = false) {
    return CC2?.UIController?.toggleMenuSettings?.(fromGame, { state: state2, hideModal: hideModal2, showConfirmModal, renderRecordBox });
  }
  function toggleMenuVariants(fromGame = false) {
    return CC2?.UIController?.toggleMenuVariants?.(fromGame, { state: state2, hideModal: hideModal2, showConfirmModal, renderRecordBox });
  }
  function hideMenuOtions() {
    return CC2?.UIController?.hideMenuOptions?.();
  }
  function hideMenuVariants() {
    return CC2?.UIController?.hideMenuVariants?.();
  }
  function setupCloseButtonEvents() {
    return CC2?.ModalManager?.setupCloseButtonEvents?.({ hideModal: hideModal2, showIntro, showRecordsModal, toggleMenuSettings, showShareModal });
  }
  function analyzeKeepEV(keep, deadIds) {
    return CC2?.CoachController?.analyzeKeepEV?.(keep, deadIds, { starter: state2?.starter, fullDeck: FULL_DECK }) || CC2?.CribbageAI?.analyzeKeepEV?.(keep, deadIds, state2?.starter, FULL_DECK) || { min: 0, max: 0, avg: 0 };
  }
  function updateCoachDisplay(hoverDiscards) {
    return CC2?.CoachController?.updateCoachDisplay?.(hoverDiscards, { settings: settings2, state: state2, cardLabel, fullDeck: FULL_DECK });
  }
  function showIntro() {
    return CC2?.ModalManager?.showIntro?.(typeof getAppBrand === "function" ? getAppBrand() : "crazy", { showModal });
  }
  function showRecordsModal() {
    const prof = typeof window !== "undefined" && window.Profile || CC2?.Profile || Profile;
    if (prof && typeof prof.showRecordsModal === "function") {
      return prof.showRecordsModal({ brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy", showModal, storage: appStorage });
    }
    return CC2?.SettingsManager?.showRecordsModal?.({ brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy", showModal });
  }
  function resetGameStatistics2() {
    const prof = typeof window !== "undefined" && window.Profile || CC2?.Profile || Profile;
    if (prof && typeof prof.resetStatsConfirm === "function") {
      return prof.resetStatsConfirm();
    }
    return CC2?.SettingsManager?.resetGameStatistics?.({ brand: typeof getAppBrand === "function" ? getAppBrand() : "crazy", showConfirmModal });
  }
  function showShareModal() {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showShareModal?.({ settings: settings2, net, getJoinUrl });
  }
  function showJoinModal() {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showJoinModal?.({ settings: settings2, net, joinRoom, hostRoom, sfx: sfx2, getJoinUrl });
  }
  function showDiscardTrainerModal2(context = {}) {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showDiscardTrainerModal?.(context) || CC2?.ModalManager?.showDiscardTrainerModal?.(context);
  }
  function showPeggingTrainerModal(context = {}) {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showPeggingTrainerModal?.(context) || CC2?.ModalManager?.showPeggingTrainerModal?.(context);
  }
  function showCountingTrainerModal(context = {}) {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showCountingTrainerModal?.(context) || CC2?.ModalManager?.showCountingTrainerModal?.(context);
  }
  function showCoachPostMortemModal(context = {}) {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showCoachPostMortemModal?.(context) || CC2?.ModalManager?.showCoachPostMortemModal?.(context);
  }
  function shareCoachPostMortem(report) {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showCoachPostMortemShareModal?.(report) || (CC2?.CoachPostMortem || CoachPostMortem).openShareDialog(report);
  }
  function showDailyPuzzleModal(context = {}) {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showDailyPuzzleModal?.(context) || CC2?.ModalManager?.showDailyPuzzleModal?.(context) || ModalManager2.showDailyPuzzleModal(context);
  }
  function showTrophyRoomModal(brand = "all") {
    return CC2?.AchievementManager?.showTrophyRoomModal ? CC2.AchievementManager.showTrophyRoomModal(brand) : null;
  }
  function showReplaysModal(brand = "all") {
    const modal = CC2?.ReplayModal || window.ReplayModal || ReplayModal;
    return modal?.openLibrary ? modal.openLibrary(brand) : modal?.open?.(null, brand);
  }
  function showGameSummaryModal(context = {}) {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showGameSummaryModal?.({ state: state2, settings: settings2, ...context }) || CC2?.ModalManager?.showGameSummaryModal?.({ state: state2, settings: settings2, ...context });
  }
  function showGameWonModal() {
    return typeof window !== "undefined" && window.GameEngine?.showGameWonModal?.() || CC2?.GameEngine?.showGameWonModal?.() || (typeof GameEngine2 !== "undefined" && GameEngine2.showGameWonModal ? GameEngine2.showGameWonModal() : false);
  }
  function showHandOfGloryModal(keyOrData, context = {}) {
    return (typeof window !== "undefined" ? window.modalManager : null)?.showHandOfGloryModal?.(keyOrData, { state: state2, settings: settings2, ...context }) || CC2?.ModalManager?.showHandOfGloryModal?.(keyOrData, { state: state2, settings: settings2, ...context }) || CC2?.HandOfGloryCard?.showModal?.(keyOrData, { state: state2, settings: settings2, ...context }) || HandOfGloryCard?.showModal?.(keyOrData, { state: state2, settings: settings2, ...context });
  }
  function closeHandOfGloryModal() {
    return (typeof window !== "undefined" ? window.modalManager : null)?.closeHandOfGloryModal?.() || CC2?.ModalManager?.closeHandOfGloryModal?.() || CC2?.HandOfGloryCard?.closeModal?.() || HandOfGloryCard?.closeModal?.();
  }
  function openClashSandbox(context = {}) {
    return (typeof window !== "undefined" ? window.ClashSandboxModal : null)?.open?.({ state: state2, settings: settings2, ...context }) || CC2?.ClashSandboxModal?.open?.({ state: state2, settings: settings2, ...context }) || ClashSandboxModal?.open?.({ state: state2, settings: settings2, ...context });
  }
  function applyClashPreset(key, context = {}) {
    return (typeof window !== "undefined" ? window.ClashPresets : null)?.applyPreset?.(key, { state: state2, settings: settings2, ...context }) || CC2?.ClashPresets?.applyPreset?.(key, { state: state2, settings: settings2, ...context }) || ClashPresets?.applyPreset?.(key, { state: state2, settings: settings2, ...context });
  }
  function copyShareLink2() {
    return CC2?.ModalManager?.copyShareLink?.();
  }
  function triggerNativeShare2() {
    return (typeof window !== "undefined" ? window.modalManager : null)?.triggerNativeShare?.() || CC2?.ModalManager?.triggerNativeShare?.();
  }
  function showStartGameModal() {
    if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.showStartGameModal === "function") {
      return window.modalManager.showStartGameModal({ getAppBrand, isAgeVerified, showAgeGateModal, syncPlayerCountUi });
    }
    const overlay = document.getElementById("startGameOverlay");
    if (overlay) overlay.style.display = "flex";
  }
  function hideStartGameModal() {
    if (typeof window !== "undefined" && window.modalManager && typeof window.modalManager.hideStartGameModal === "function") {
      return window.modalManager.hideStartGameModal();
    }
    const overlay = document.getElementById("startGameOverlay");
    if (overlay) overlay.style.display = "none";
  }
  function confirmAndStartGame() {
    const modalVal = document.getElementById("optBoardViewModal")?.value;
    hideStartGameModal();
    startGame();
    if (modalVal === "room3d-fullscreen") {
      try {
        const b3d = document.getElementById("board3DContainer");
        if (b3d && b3d.requestFullscreen) {
          b3d.requestFullscreen().catch(() => {
          });
        }
      } catch (_) {
      }
    }
  }
  function initAutoJoin() {
    return CC2?.NetworkManager?.initAutoJoin?.({ settings: settings2, setNetStatus, showWait, hideWait, joinRoom, showModal, hideModal: hideModal2 });
  }
  function updateMobileDeviceClass() {
    return CC2?.UIController?.updateMobileDeviceClass?.();
  }
  var CrazyCribbageApp = class _CrazyCribbageApp {
    constructor(options = {}) {
      this.options = options;
      this.CC = CC2;
      this.BOARD_CFG = BOARD_CFG2;
      this.BOARD_CFG_481 = BOARD_CFG_4812;
      this.CLASH_DEFAULTS_481 = CLASH_DEFAULTS_4813;
      this.CLASH_DEFAULTS_241 = CLASH_DEFAULTS_2413;
      this.CLASH_DEFAULTS_361 = CLASH_DEFAULTS_3613;
      this.CARD_BACKS = CARD_BACKS2;
      this.THEMES = THEMES2;
      this.CLASH_BLOCK_DEFS = CLASH_BLOCK_DEFS;
      this.PINTS_DRINKING_DEFS = PINTS_DRINKING_DEFS2;
      this.ADULT_OPTIONS_LIST = ADULT_OPTIONS_LIST2;
      this.DROPDOWN_DESCRIPTIONS = DROPDOWN_DESCRIPTIONS2;
      this.CLASH_ITEM_METADATA = CLASH_ITEM_METADATA;
      this.CRAZY_OPTIONS_DEFS = CRAZY_OPTIONS_DEFS;
      this._state = { scores: { you: 0, cpu: 0 }, prev: { you: 0, cpu: 0 }, over: false, dealer: "you" };
      state2 = this._state;
      const resolvedBrand = typeof window !== "undefined" && typeof window.getAppBrand === "function" ? window.getAppBrand() : typeof getAppBrand === "function" ? getAppBrand() : "crazy";
      this._settings = CC2 && CC2.SettingsManager && CC2.SettingsManager.DEFAULT_SETTINGS ? JSON.parse(JSON.stringify(CC2.SettingsManager.DEFAULT_SETTINGS)) : { opp: "cpu", playerCount: 2, gameMode: "individual", target: 121, decks: 1, cardBack: "classic-blue" };
      if (resolvedBrand === "clash") {
        this._settings.target = 481;
      }
      settings2 = this._settings;
      this._pegState = pegState || { p1: { front: 0, rear: 0 }, p2: { front: 0, rear: 0 }, you: { front: 0, rear: 0 }, cpu: { front: 0, rear: 0 } };
      pegState = this._pegState;
      this._net = net || { peer: null, conn: null, clients: /* @__PURE__ */ new Map(), room: null, ready: false, mySeatId: "p1", isHost: false, roster: [] };
      net = this._net;
      this._gameHands = [];
      gameHands = this._gameHands;
      this._theme = theme || "tournament";
      this._recordCache = null;
      Object.defineProperty(this, "state", { get: () => this._state, set: (v) => {
        this._state = state2 = v;
      }, configurable: true });
      Object.defineProperty(this, "settings", { get: () => this._settings, set: (v) => {
        this._settings = settings2 = v;
      }, configurable: true });
      Object.defineProperty(this, "pegState", { get: () => this._pegState, set: (v) => {
        this._pegState = pegState = v;
      }, configurable: true });
      Object.defineProperty(this, "net", { get: () => this._net, set: (v) => {
        this._net = net = v;
      }, configurable: true });
      Object.defineProperty(this, "gameHands", { get: () => this._gameHands, set: (v) => {
        this._gameHands = gameHands = v;
      }, configurable: true });
      Object.defineProperty(this, "theme", { get: () => this._theme, set: (v) => {
        this._theme = theme = v;
      }, configurable: true });
      Object.defineProperty(this, "recordCache", { get: () => this._recordCache, set: (v) => {
        this._recordCache = recordCache = v;
      }, configurable: true });
      Object.defineProperty(this, "_suppressSettingsSave", { get: () => _suppressSettingsSave, set: (v) => {
        _suppressSettingsSave = v;
      }, configurable: true });
      Object.defineProperty(this, "_isEnforcingClashNoOverlap", { get: () => _isEnforcingClashNoOverlap, set: (v) => {
        _isEnforcingClashNoOverlap = v;
      }, configurable: true });
      Object.defineProperty(this, "_isRandomizingClash", { get: () => _isRandomizingClash, set: (v) => {
        _isRandomizingClash = v;
      }, configurable: true });
      Object.defineProperty(this, "sfx", { get: () => sfx2, set: (v) => {
      }, configurable: true });
      Object.defineProperty(this, "FULL_DECK", { get: () => FULL_DECK, set: (v) => {
        FULL_DECK = v;
      }, configurable: true });
    }
    init() {
      if (typeof document === "undefined") return this;
      const brand = typeof getAppBrand === "function" ? getAppBrand() : window.currentBrand || "crazy";
      if (brand === "clash") {
        if (!this._settings.target || ![241, 361, 481].includes(this._settings.target)) {
          this._settings.target = 481;
          settings2.target = 481;
        }
        const isClashBoard = this._settings.selected3DBoardId === "board-cribbage-clash" || this._settings.selected3DBoardId === "board-cribbage-clash-square" || Board3DCatalog.getBoards("clash").some((b) => b.id === this._settings.selected3DBoardId);
        if (!this._settings.selected3DBoardId || !isClashBoard) {
          this._settings.selected3DBoardId = "board-cribbage-clash";
          settings2.selected3DBoardId = "board-cribbage-clash";
        }
      } else if (brand === "pints") {
        if (!this._settings.target || [241, 361, 481].includes(this._settings.target)) {
          this._settings.target = 121;
          settings2.target = 121;
        }
        if (this._settings.selected3DBoardId === "board-cribbage-clash" || this._settings.selected3DBoardId === "board-cribbage-clash-square") {
          this._settings.selected3DBoardId = "board-14";
          settings2.selected3DBoardId = "board-14";
        }
      }
      setupCloseButtonEvents();
      setupCheckAllBonuses();
      if (typeof Board3DCatalog !== "undefined" && typeof Board3DCatalog.autoLoad === "function") {
        Board3DCatalog.autoLoad().then((res) => {
          if (res && res.success) {
            const el3d = document.getElementById("opt3DBoard");
            if (el3d && CC2?.LobbyController) {
              Board3DCatalog.syncDropdownOptions(el3d, settings2?.selected3DBoardId, brand);
            }
            this.syncInGameBoardSelector();
          }
        }).catch(() => {
        });
      }
      if (typeof applyBrandVisibility === "function") applyBrandVisibility(brand);
      if (CC2?.LobbyController && typeof CC2.LobbyController.disableOtherGameBonusOptions === "function") {
        CC2.LobbyController.disableOtherGameBonusOptions(brand, this._settings);
        CC2.LobbyController.disableOtherGameBonusOptions(brand, settings2);
      }
      applyFormSettings(loadSettingsStore());
      if (CC2?.LobbyController && typeof CC2.LobbyController.disableOtherGameBonusOptions === "function") {
        CC2.LobbyController.disableOtherGameBonusOptions(brand, this._settings);
        CC2.LobbyController.disableOtherGameBonusOptions(brand, settings2);
      }
      initTableSplitter();
      initCardBackPicker();
      initDropdownLabels();
      renderRecordBox();
      syncPlayerCountUi();
      initThemeButtons();
      initSoundButton();
      checkInitialAgeGate();
      setupNetUi();
      this._state = state2 = { scores: { you: 0, cpu: 0 }, prev: { you: 0, cpu: 0 }, over: false, dealer: "you" };
      buildBoard({ skipLoader: true });
      initBoardFancyTooltips();
      renderScores(false);
      this.bindDomEvents();
      initAutoJoin();
      updateMobileDeviceClass();
      this.updateBoardViewToggleBtn();
      this.syncInGameBoardSelector();
      try {
        const savedBoardState = typeof localStorage !== "undefined" ? localStorage.getItem("cc_board_display_state") : null;
        if (savedBoardState && savedBoardState !== "normal") {
          this.setBoardDisplayState(savedBoardState);
        } else {
          this.updateBoardSizeButtons();
        }
      } catch (_) {
      }
      const applyStoredSettingsAndSync = () => {
        checkInitialAgeGate();
        try {
          const stored = loadSettingsStore();
          if (stored) {
            applyFormSettings(stored);
            buildBoard({ skipLoader: true });
            renderScores(false);
            this.syncInGameBoardSelector();
          }
        } catch (err) {
          console.warn("[CrazyCribbageApp] Failed to apply settings from storage:", err);
        }
      };
      if (appStorage && appStorage.ready && typeof appStorage.ready.then === "function") {
        appStorage.ready.then(() => {
          applyStoredSettingsAndSync();
          _suppressSettingsSave = false;
        }).catch(() => {
          _suppressSettingsSave = false;
        });
      } else {
        _suppressSettingsSave = false;
      }
      try {
        if (typeof window !== "undefined" && window.location?.search?.includes("replay=")) {
          const urlParams = new URLSearchParams(window.location.search);
          const repCode = urlParams.get("replay");
          if (repCode) {
            const repMgr = CC2?.GameReplayManager || window.CrazyCribbage?.GameReplayManager || GameReplayManager;
            const repModal = CC2?.ReplayModal || window.CrazyCribbage?.ReplayModal || ReplayModal;
            if (repMgr && repModal) {
              repMgr.decompressReplay(repCode).then((replay) => {
                if (replay && Array.isArray(replay.events)) {
                  setTimeout(() => {
                    repModal.open(replay);
                  }, 400);
                }
              }).catch(() => {
              });
            }
          }
        }
      } catch (_) {
      }
      return this;
    }
    bindDomEvents() {
      if (typeof document === "undefined") return;
      const byId = (id) => document.getElementById(id);
      const on = (id, event, handler, options) => {
        const el = byId(id);
        if (el) el.addEventListener(event, handler, options);
      };
      const onAll = (selector, event, handler) => {
        document.querySelectorAll(selector).forEach((el) => el.addEventListener(event, handler));
      };
      on("btnStart", "click", showStartGameModal);
      on("btnNew", "click", backToMenu);
      on("btnJoinMenu", "click", showJoinModal);
      on("btnSettingsMenu", "click", () => toggleMenuSettings());
      on("btnVariantsMenu", "click", () => toggleMenuVariants());
      on("btnThemeMenu", "click", toggleTheme);
      on("btnRecords", "click", showRecordsModal);
      on("btnShareMenu", "click", showShareModal);
      on("btnHelp", "click", showIntro);
      on("btnBrandMenu", "click", (e) => toggleBrandDropdown(e));
      on("brandItemCrazy", "click", (e) => handleBrandLinkClick(e, "crazy"));
      on("brandItemClash", "click", (e) => handleBrandLinkClick(e, "clash"));
      on("brandItemPints", "click", (e) => handleBrandLinkClick(e, "pints"));
      on("brandItemAdult", "click", (e) => handleBrandLinkClick(e, "adult"));
      on("btnLaunchTrainer", "click", () => showDiscardTrainerModal2());
      on("btnLaunchPeggingTrainer", "click", () => showPeggingTrainerModal());
      on("btnLaunchCountingTrainer", "click", () => showCountingTrainerModal());
      on("btnLaunchDailyPuzzle", "click", () => showDailyPuzzleModal());
      on("btnLaunchTrophyRoom", "click", () => showTrophyRoomModal());
      on("btnLaunchTourney", "click", () => {
        if (window.TournamentModal) window.TournamentModal.open();
        else if (window.showTournamentModal) window.showTournamentModal();
      });
      on("btnLaunch3DBoard", "click", () => this.showBoard3DModal());
      on("btnLaunchReplays", "click", () => {
        const b = typeof getAppBrand === "function" ? getAppBrand() : "all";
        (CC2?.ReplayModal || window.ReplayModal || ReplayModal)?.openLibrary?.(b);
      });
      onAll("#menuOptions .menu-options-close", "click", () => toggleMenuSettings());
      on("btnStartSettings", "click", () => {
        showStartGameModal();
        toggleMenuSettings();
      });
      onAll("#menuOptions .settings-play-label", "click", () => {
        showStartGameModal();
        toggleMenuSettings();
      });
      onAll(".menu-variants-close", "click", () => {
        if (window.hideMenuVariants) window.hideMenuVariants();
        else toggleMenuVariants();
      });
      onAll(".menu-variants-play-btn", "click", () => {
        showStartGameModal();
        if (window.hideMenuVariants) window.hideMenuVariants();
        else toggleMenuVariants();
      });
      on("btnThemeHeader", "click", toggleTheme);
      on("btnRecordsHeader", "click", showRecordsModal);
      on("btnScorecardHeader", "click", showGameSummaryModal);
      on("btnSettingsHeader", "click", () => toggleMenuSettings(true));
      on("btnBoardHeader", "click", () => this.showBoard3DModal());
      on("btnShareHeader", "click", showShareModal);
      on("btnReplaysHeader", "click", () => {
        const b = typeof getAppBrand === "function" ? getAppBrand() : "all";
        (CC2?.ReplayModal || window.ReplayModal || ReplayModal)?.openLibrary?.(b);
      });
      on("btnHelpHeader", "click", showIntro);
      const handleAvatarClick = () => {
        const av = this.CC && this.CC.AvatarManager || AvatarManager || window.AvatarManager;
        if (av && typeof av.openAvatarModal === "function") {
          av.openAvatarModal();
        } else if (typeof window.openAvatarModal === "function") {
          window.openAvatarModal();
        }
      };
      on("scoreChipAvatarYou", "click", handleAvatarClick);
      on("youZoneAvatar", "click", handleAvatarClick);
      on("inGameBoardTriggerThumb", "error", function() {
        if (this.parentElement) this.parentElement.style.display = "none";
      });
      on("btnChange3DBoard", "click", () => this.showBoard3DModal());
      on("btnOpenBoardGallery", "click", () => this.showBoard3DModal());
      on("btnToggleBoardView", "click", (e) => {
        e.stopPropagation();
        this.toggleInGameBoardViewDropdown();
      });
      on("inGameBoardViewDropdownTrigger", "click", (e) => {
        e.stopPropagation();
        this.toggleInGameBoardViewDropdown();
      });
      const inGameOptBoardView = byId("inGameOptBoardView");
      if (inGameOptBoardView) {
        inGameOptBoardView.addEventListener("change", () => this.selectBoardViewMode(inGameOptBoardView.value));
      }
      const boardViewMenu = byId("inGameBoardViewDropdownMenu");
      if (boardViewMenu) {
        boardViewMenu.querySelectorAll(".board-view-dropdown-item[data-view-mode]").forEach((item) => {
          item.addEventListener("click", (e) => {
            e.stopPropagation();
            const mode = item.getAttribute("data-view-mode");
            if (mode) this.selectBoardViewMode(mode);
          });
          item.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              const mode = item.getAttribute("data-view-mode");
              if (mode) this.selectBoardViewMode(mode);
            }
          });
        });
        const fsItem = boardViewMenu.querySelector(".board-view-fullscreen-item");
        if (fsItem) {
          const handleFsClick = (e) => {
            e.stopPropagation();
            this.closeInGameBoardViewDropdown();
            this.toggle3DRoomFullScreen();
          };
          fsItem.addEventListener("click", handleFsClick);
          fsItem.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleFsClick(e);
            }
          });
        }
      }
      const dropdownTrigger = byId("inGameBoardDropdownTrigger");
      if (dropdownTrigger) {
        dropdownTrigger.addEventListener("click", (e) => {
          e.stopPropagation();
          this.toggleInGameBoardDropdown();
        });
      }
      const inGameOpt3DBoard = byId("inGameOpt3DBoard");
      if (inGameOpt3DBoard) {
        inGameOpt3DBoard.addEventListener("change", () => this.select3DBoard(inGameOpt3DBoard.value));
      }
      if (typeof document !== "undefined") {
        document.addEventListener("click", (e) => {
          const wrap = document.getElementById("inGameBoardDropdownWrap");
          if (wrap && !wrap.contains(e.target)) {
            this.closeInGameBoardDropdown();
          }
          const wrapBv = document.getElementById("inGameBoardViewDropdownWrap");
          if (wrapBv && !wrapBv.contains(e.target)) {
            this.closeInGameBoardViewDropdown();
          }
        });
        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape") {
            this.closeInGameBoardDropdown();
            this.closeInGameBoardViewDropdown();
          }
        });
      }
      on("btnFullscreen3D", "click", () => this.toggle3DRoomFullScreen());
      on("btnMinimizeBoard", "click", () => this.toggleBoardMinimize());
      on("btnMaximizeBoard", "click", () => this.toggleBoardMaximize());
      on("btnFloatingRestoreBoard", "click", () => this.restoreBoard());
      onAll(".modal-btn-close", "click", hideModal2);
      on("startGameOverlay", "click", (e) => {
        if (e.target.id === "startGameOverlay") hideStartGameModal();
      });
      on("btnCloseStartGame", "click", hideStartGameModal);
      on("btnModeTourney", "click", () => {
        if (typeof hideStartGameModal === "function") hideStartGameModal();
        if (window.TournamentModal) window.TournamentModal.open();
        else if (window.showTournamentModal) window.showTournamentModal();
      });
      on("optPlayerName", "input", function() {
        this.value = this.value.replace(/[^a-zA-Z0-9]/g, "");
      });
      on("optBoardViewModal", "change", function() {
        const el = document.getElementById("optBoardView");
        if (el) el.value = this.value;
        if (window.settings) window.settings.boardViewMode = this.value;
      });
      on("optBoardView", "change", function() {
        const el = document.getElementById("optBoardViewModal");
        if (el) el.value = this.value;
      });
      on("btnShareInvite", "click", () => {
        if (window.shareRoomInvite) window.shareRoomInvite();
      });
      on("btnShareWhatsApp", "click", () => {
        if (window.shareRoomWhatsApp) window.shareRoomWhatsApp();
      });
      on("btnShareEmail", "click", () => {
        if (window.shareRoomEmail) window.shareRoomEmail();
      });
      on("btnShareMore", "click", () => {
        if (window.showShareModal) window.showShareModal();
      });
      on("btnNetTrackSandbox", "click", () => {
        if (window.openClashSandbox) window.openClashSandbox();
        else if (window.ClashSandboxModal) window.ClashSandboxModal.open();
      });
      on("btnConfirmStartGame", "click", confirmAndStartGame);
      on("btnStartGameMoreSettings", "click", () => {
        hideStartGameModal();
        toggleMenuSettings();
      });
      onAll(".start-game-btn-cancel", "click", hideStartGameModal);
      on("gloryOverlay", "click", (e) => {
        if (e.target.id === "gloryOverlay") closeHandOfGloryModal();
      });
      on("adultTimerOverlay", "click", (e) => {
        if (e.target.id === "adultTimerOverlay") closeAdultTimerModal();
      });
      on("btnAdultTimerStart", "click", startAdultTimer);
      on("btnAdultTimerClose", "click", closeAdultTimerModal);
      on("adultBonusOverlay", "click", (e) => {
        if (e.target.id === "adultBonusOverlay") closeAdultStripModal();
      });
      on("btnAdultBonusDone", "click", closeAdultStripModal);
      on("pintsBonusOverlay", "click", (e) => {
        if (e.target.id === "pintsBonusOverlay") closePintsBonusModal();
      });
      on("btnPintsBonusDone", "click", closePintsBonusModal);
      on("btnAgeGateConfirm", "click", confirmAgeGate);
      on("btnAgeGateExit", "click", exitAgeGateToSafeBrand);
      const topChips = byId("boardTopChips");
      if (topChips) {
        topChips.addEventListener("dblclick", (e) => {
          if (e.target.closest("button, select, input, a")) return;
          this.toggleBoardMinimize();
        });
        topChips.addEventListener("click", (e) => {
          if (this.getBoardDisplayState() === "minimized" && !e.target.closest("button, select, input, a")) {
            this.restoreBoard();
          }
        });
      }
      window.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.getBoardDisplayState() !== "normal") {
          this.restoreBoard();
        }
      });
      on("btnCamToggle", "click", async () => {
        const camMgr = CC2?.CameraManager && CC2.CameraManager.getInstance ? CC2.CameraManager.getInstance() : typeof CameraManager !== "undefined" ? CameraManager.getInstance() : window._ccCameraManager || null;
        if (!camMgr) return;
        const camCtx = { net, settings: settings2, byId, document, setStatus };
        if (!camMgr.isBroadcasting) {
          await camMgr.startBroadcast(camCtx);
        } else if (camMgr.isPaused) {
          camMgr.resumeBroadcast(camCtx);
        } else {
          camMgr.pauseBroadcast(camCtx);
        }
      });
      on("gamePlayLogo", "click", returnToMenu);
      on("btnDiscard", "click", () => {
        if (state2.phase === "pick-crib") {
          confirmPickCrib();
          return;
        }
        if (state2.phase === "draw-1" || state2.phase === "draw-2" || state2.phase === "draw-1-p2" || state2.phase === "draw-2-p2") {
          confirmDraw();
          return;
        }
        showWait(state2.phase === "discard-p2" ? "Turning the starter\u2026" : "Discarding and setting the starter\u2026");
        setTimeout(() => {
          try {
            confirmDiscard();
          } catch (e) {
            hideWait();
            throw e;
          }
          if (state2.phase !== "play") hideWait();
        }, 40);
      });
      const clashOverlayEl = byId("clashPlacementOverlay");
      if (clashOverlayEl) clashOverlayEl.addEventListener("click", (e) => {
        if (e.target === clashOverlayEl) closeClashPlacementModal();
      });
      if (typeof window !== "undefined") {
        window.addEventListener("keydown", (e) => {
          if (e.key === "Escape") {
            const ov = byId("clashPlacementOverlay");
            if (ov && ov.style.display === "flex") closeClashPlacementModal();
            const adultOv = byId("adultTimerOverlay");
            if (adultOv && adultOv.style.display === "flex" && typeof closeAdultTimerModal === "function") closeAdultTimerModal();
          }
        });
      }
      on("btnCloseClashPlacement", "click", closeClashPlacementModal);
      on("btnCancelClashPlacement", "click", closeClashPlacementModal);
      on("btnConfirmClashPlacement", "click", onConfirmClashPlacement);
      const bTarget = byId("optTarget");
      if (bTarget) {
        const bClash = byId("cribbage-clash-options");
        const handleTargetChange = (isInitial = false) => {
          const brand = typeof getAppBrand === "function" ? getAppBrand() : window.currentBrand || "crazy";
          let targetVal = bTarget ? parseInt(bTarget.value, 10) : 121;
          if (brand === "clash" && ![241, 361, 481].includes(targetVal)) {
            targetVal = 481;
            if (bTarget) bTarget.value = "481";
          }
          const prevTarget = settings2.target;
          settings2.target = targetVal;
          if (typeof window !== "undefined" && window.settings) {
            window.settings.target = targetVal;
          }
          const isClashMode = brand === "clash" || [241, 361, 481].includes(targetVal);
          if (typeof applyBrandVisibility === "function") applyBrandVisibility(brand);
          else if (bClash) {
            bClash.style.display = isClashMode ? "block" : "none";
            if (!isClashMode) uncheckCribbageClashOptions();
          }
          updateCribbageClashOptionRanges(isClashMode ? targetVal : false);
          initClashPlacementButtons();
          if (!isInitial || prevTarget !== targetVal) {
            buildBoard();
          }
          if (!_suppressSettingsSave && !isInitial && typeof saveSettingsStore === "function" && typeof readFormSettings === "function") {
            saveSettingsStore(readFormSettings());
          }
        };
        bTarget.addEventListener("change", () => handleTargetChange(false));
        handleTargetChange(true);
      }
      const optPlayerCountEl = byId("optPlayerCount");
      if (optPlayerCountEl) {
        optPlayerCountEl.addEventListener("change", () => {
          const cdChk = byId("optCanadianDoubles");
          if (optPlayerCountEl.value !== "4_part" && cdChk && cdChk.checked) {
            cdChk.checked = false;
            if (settings2) settings2.optCanadianDoubles = false;
          }
          syncPlayerCountUi();
          if (typeof saveSettingsStore === "function" && typeof readFormSettings === "function") {
            saveSettingsStore(readFormSettings());
          }
          renderRecordBox();
        });
      }
      ["optPlayerCount", "optDeal", "optDealStyle", "optShowDetail", "optCardAssassin", "optJailAnimation", "optBarAnimation", "optCannonAnimation", "optSpeedTrapAnimation", "optDetourAnimation", "optRoundAboutAnimation", "optScenicRouteAnimation", "optGoal", "optTarget", "optDecks", "optCardBack", "optBoardFinish", "optPegSkin", "optPegStyle", "optTableEnvironment", "optActionCam", "optSeriesMode", "optOpp", "optCoach", "optAiProfile", "optBoardView", "opt3DBoard", "optSeat2Type", "optSeat3Type", "optSeat4Type", "optSeat5Type", "optSeat6Type", "optSeat7Type", "optSeat8Type"].forEach((id) => {
        const sel = byId(id);
        if (sel && id !== "optPlayerCount") {
          sel.addEventListener("change", () => {
            if (id === "optShowDetail") {
              settings2.showDetail = sel.value;
              if (sel.value === "muggins") settings2.optMuggins = true;
            }
            if (id === "optCardAssassin") {
              settings2.cardAssassin = sel.value;
            }
            if (id === "optJailAnimation") {
              settings2.jailAnimation = sel.value;
            }
            if (id === "optBarAnimation") {
              settings2.barAnimation = sel.value;
            }
            if (id === "optCannonAnimation") {
              settings2.cannonAnimation = sel.value;
              settings2.jumpAnimation = sel.value;
            }
            if (id === "optSpeedTrapAnimation") {
              settings2.speedTrapAnimation = sel.value;
              settings2.stopSignAnimation = sel.value;
              settings2.stopAnimation = sel.value;
            }
            if (id === "optDetourAnimation") {
              settings2.detourAnimation = sel.value;
            }
            if (id === "optRoundAboutAnimation") {
              settings2.roundAboutAnimation = sel.value;
            }
            if (id === "optScenicRouteAnimation") {
              settings2.scenicRouteAnimation = sel.value;
            }
            if (id === "optActionCam") {
              settings2.optActionCam = sel.value;
            }
            if (id === "optBoardView") {
              settings2.boardViewMode = sel.value;
              if (typeof buildBoard === "function") {
                buildBoard();
                renderScores(false);
              }
              if (typeof this.updateBoardViewToggleBtn === "function") {
                this.updateBoardViewToggleBtn();
              }
            }
            if (id === "opt3DBoard") {
              settings2.selected3DBoardId = sel.value;
              const inGameEl = byId("inGameOpt3DBoard");
              if (inGameEl) inGameEl.value = sel.value;
              if (typeof buildBoard === "function") {
                buildBoard();
                renderScores(false);
              }
            }
            if (id === "optBoardFinish") {
              settings2.boardFinish = sel.value;
              const boardTracks = byId("boardTracks");
              if (boardTracks && boardTracks.querySelector("svg") && typeof buildBoard === "function") {
                buildBoard();
                renderScores(false);
              }
            }
            if (id === "optPegSkin") {
              settings2.pegSkin = sel.value;
              const boardTracks = byId("boardTracks");
              if (boardTracks && boardTracks.querySelector("svg") && typeof buildBoard === "function") {
                buildBoard();
                renderScores(false);
              }
            }
            if (id === "optPegStyle") {
              settings2.pegStyle = sel.value;
              if (typeof window !== "undefined" && window._currentRenderer3D) {
                window._currentRenderer3D.setPegStyle(sel.value);
              }
            }
            if (id === "optTableEnvironment") {
              settings2.tableEnvironment = sel.value;
              if (typeof window !== "undefined" && window._currentRenderer3D) {
                window._currentRenderer3D.setTableEnvironment(sel.value);
              }
            }
            if (id === "optSeriesMode") {
              settings2.seriesMode = sel.value;
              SeriesTracker.setMode(sel.value);
            }
            if (typeof saveSettingsStore === "function" && typeof readFormSettings === "function") {
              saveSettingsStore(readFormSettings());
            }
            renderRecordBox();
          });
        }
      });
      const optOppEl = byId("optOpp");
      if (optOppEl) {
        optOppEl.addEventListener("change", (e) => {
          const brand = typeof getAppBrand === "function" ? getAppBrand() : "crazy";
          const allowCpu = typeof GameOptionsEngine !== "undefined" && typeof GameOptionsEngine.isCpuAllowed === "function" ? GameOptionsEngine.isCpuAllowed(brand) : !["pints", "adult"].includes(brand);
          if (!allowCpu && e.target.value === "cpu") e.target.value = "online";
          syncPlayerCountUi();
        });
      }
      const gameModeBar = byId("gameModeBar");
      if (gameModeBar) {
        gameModeBar.querySelectorAll(".game-mode-pill").forEach((pill) => {
          const mode = pill.dataset.mode;
          if (!mode || mode === "tournament") return;
          pill.addEventListener("click", () => {
            const brand = typeof getAppBrand === "function" ? getAppBrand() : "crazy";
            const allowCpu = typeof GameOptionsEngine !== "undefined" && typeof GameOptionsEngine.isCpuAllowed === "function" ? GameOptionsEngine.isCpuAllowed(brand) : !["pints", "adult"].includes(brand);
            if (mode === "cpu" && !allowCpu) return;
            const optOpp = byId("optOpp");
            if (optOpp) {
              optOpp.value = mode;
            }
            if (mode === "cpu") {
              const defaultCpu = { 2: "cpu:shark", 3: "cpu:regular", 4: "cpu:turtler", 5: "cpu:maverick", 6: "cpu:master", 7: "cpu:rookie", 8: "cpu:casual" };
              for (let i = 2; i <= 8; i++) {
                const seatEl = byId(`optSeat${i}Type`);
                if (seatEl && (seatEl.value === "human" || seatEl.value === "online")) {
                  seatEl.value = defaultCpu[i] || "cpu:shark";
                }
              }
            }
            syncPlayerCountUi();
            if (typeof saveSettingsStore === "function" && typeof readFormSettings === "function") {
              saveSettingsStore(readFormSettings());
            }
          });
        });
      }
      const overlayEl = byId("overlay");
      if (overlayEl) {
        overlayEl.addEventListener("click", (e) => {
          if (e.target.id === "overlay") {
            if (overlayEl.classList.contains("closable")) {
              hideModal2();
              return;
            }
          }
        });
      }
      const avMgr = this.CC && this.CC.AvatarManager || AvatarManager;
      if (avMgr && typeof avMgr.syncAvatarUI === "function") {
        avMgr.syncAvatarUI();
      }
      const btnSelectAvatar = byId("btnSelectAvatar");
      if (btnSelectAvatar) {
        btnSelectAvatar.addEventListener("click", () => {
          if (avMgr && typeof avMgr.openAvatarModal === "function") {
            avMgr.openAvatarModal();
          }
        });
      }
      if (typeof window !== "undefined") {
        window.addEventListener("resize", updateMobileDeviceClass);
        window.addEventListener("orientationchange", updateMobileDeviceClass);
        if (window.location) {
          try {
            const params = new URLSearchParams(window.location.search);
            if (params.get("tool") === "trainer" || params.get("mode") === "trainer") {
              setTimeout(() => showDiscardTrainerModal2(), 300);
            }
            if (params.get("tool") === "pegging" || params.get("mode") === "pegging") {
              setTimeout(() => showPeggingTrainerModal(), 300);
            }
            if (params.get("tool") === "counting" || params.get("mode") === "counting" || params.get("trainer") === "counting") {
              const decoded = (CC2?.CountingTrainer || window.CountingTrainer || CountingTrainer)?.decodeShareUrl?.(window.location.search);
              setTimeout(() => showCountingTrainerModal(decoded || {}), 300);
            }
            if (params.get("tool") === "coach" || params.get("tool") === "postmortem") {
              setTimeout(() => showCoachPostMortemModal(), 300);
            }
            if (params.get("testAnim") === "bar" || params.get("anim") === "bar") {
              setTimeout(() => {
                const showBar = window.showBarAnimation || this.CC && this.CC.BarAnimationOverlay && this.CC.BarAnimationOverlay.show || BarAnimationOverlay.show;
                if (typeof showBar === "function") {
                  showBar({
                    playerName: "You",
                    who: "p1",
                    barHole: 40,
                    score: 40,
                    card: { r: "K", s: "\u2660" },
                    settings: { barAnimation: "yes" }
                  });
                }
              }, 600);
            } else if (params.get("testAnim") === "jail" || params.get("anim") === "jail") {
              setTimeout(() => {
                const showJail = window.showJailAnimation || this.CC && this.CC.JailAnimationOverlay && this.CC.JailAnimationOverlay.show || JailAnimationOverlay.show;
                if (typeof showJail === "function") {
                  showJail({
                    playerName: "You",
                    who: "p1",
                    jailHole: 25,
                    score: 25,
                    card: { r: "J", s: "\u2660" },
                    settings: { jailAnimation: "yes" }
                  });
                }
              }, 600);
            } else if (params.get("testAnim") === "cannon" || params.get("anim") === "cannon") {
              setTimeout(() => {
                const showCannon = window.showCannonAnimation || this.CC && this.CC.CannonAnimationOverlay && this.CC.CannonAnimationOverlay.show || CannonAnimationOverlay.show;
                if (typeof showCannon === "function") {
                  showCannon({
                    playerName: "You",
                    who: "p1",
                    fromHole: 30,
                    toHole: 55,
                    diff: 25,
                    isForward: true,
                    card: { r: "A", s: "\u2660" },
                    settings: { cannonAnimation: "yes" }
                  });
                }
              }, 600);
            } else if (params.get("testAnim") === "speedtrap" || params.get("anim") === "speedtrap" || params.get("anim") === "radar") {
              setTimeout(() => {
                const showTrap = window.showSpeedTrapAnimation || this.CC && this.CC.SpeedTrapAnimationOverlay && this.CC.SpeedTrapAnimationOverlay.show || SpeedTrapAnimationOverlay.show;
                if (typeof showTrap === "function") {
                  showTrap({
                    playerName: "You",
                    who: "p1",
                    reason: "stop_sign",
                    hole: 35,
                    ptsScored: 2,
                    ptsLost: 3,
                    card: { r: "K", s: "\u2660" },
                    settings: { speedTrapAnimation: "yes" }
                  });
                }
              }, 600);
            } else if (params.get("testAnim") === "roundabout" || params.get("anim") === "roundabout") {
              setTimeout(() => {
                const showScenic = window.showScenicRouteAnimation || this.CC && this.CC.ScenicRouteAnimationOverlay && this.CC.ScenicRouteAnimationOverlay.show || ScenicRouteAnimationOverlay.show;
                if (typeof showScenic === "function") {
                  showScenic({
                    type: "roundabout",
                    playerName: "You",
                    who: "p1",
                    hole: 35,
                    card: { r: "Q", s: "\u2665" },
                    settings: { scenicRouteAnimation: "yes" }
                  });
                }
              }, 600);
            } else if (params.get("testAnim") === "detour" || params.get("anim") === "detour") {
              setTimeout(() => {
                const showScenic = window.showScenicRouteAnimation || this.CC && this.CC.ScenicRouteAnimationOverlay && this.CC.ScenicRouteAnimationOverlay.show || ScenicRouteAnimationOverlay.show;
                if (typeof showScenic === "function") {
                  showScenic({
                    type: "detour",
                    playerName: "You",
                    who: "p1",
                    hole: 10,
                    card: { r: "J", s: "\u2666" },
                    settings: { scenicRouteAnimation: "yes" }
                  });
                }
              }, 600);
            }
          } catch (e) {
          }
        }
      }
    }
    updateBoardViewToggleBtn() {
      if (typeof document === "undefined") return;
      const btn = document.getElementById("btnToggleBoardView");
      const labelEl = document.getElementById("inGameBoardViewTriggerLabel");
      const iconEl = document.getElementById("inGameBoardViewTriggerIcon");
      const menuEl = document.getElementById("inGameBoardViewDropdownMenu");
      const nativeSel = document.getElementById("inGameOptBoardView");
      const mode = this.settings && this.settings.boardViewMode || "room3d-fullscreen";
      let icon = "\u{1F3B2}";
      let text2 = "3D Board";
      let title = "Current: 3D Board (Click to select board view)";
      if (mode === "room3d-fullscreen") {
        icon = "\u26F6";
        text2 = "3D Room (FS)";
        title = "Current: 3D Room (Full Screen) (Click to select board view)";
      } else if (mode === "room3d") {
        icon = "\u{1F3DB}\uFE0F";
        text2 = "3D Room";
        title = "Current: 3D Room (Click to select board view)";
      } else if (mode === "none") {
        icon = "\u{1F6AB}";
        text2 = "No Board";
        title = "Current: No Board (Click to select board view)";
      } else if (mode === "3d") {
        icon = "\u{1F3B2}";
        text2 = "3D Board";
        title = "Current: 3D Board (Click to select board view)";
      } else {
        icon = "\u{1F4CB}";
        text2 = "Flat Board";
        title = "Current: 2D Flat Board (Click to select board view)";
      }
      if (labelEl) labelEl.textContent = text2;
      if (iconEl) iconEl.textContent = icon;
      if (btn) {
        if (!labelEl) {
          btn.innerHTML = `${icon} ${text2}`;
        }
        btn.title = title;
        btn.setAttribute("aria-pressed", mode === "3d" || mode === "room3d" || mode === "room3d-fullscreen" ? "true" : "false");
      }
      if (nativeSel) {
        nativeSel.value = mode;
      }
      if (menuEl) {
        menuEl.querySelectorAll(".board-view-dropdown-item").forEach((item) => {
          const itemMode = item.getAttribute("data-view-mode");
          const isSelected = itemMode === mode;
          item.classList.toggle("is-selected", isSelected);
          item.setAttribute("aria-selected", isSelected ? "true" : "false");
        });
      }
      const b3dControls = document.getElementById("board3DIngameControls");
      const btnFullscreen = document.getElementById("btnFullscreen3D");
      if (b3dControls) {
        if (mode === "2d" || mode === "none") {
          b3dControls.classList.add("hidden");
        } else {
          b3dControls.classList.remove("hidden");
        }
      }
      if (btnFullscreen) {
        if (mode === "2d" || mode === "none") {
          btnFullscreen.classList.add("hidden");
        } else {
          btnFullscreen.classList.remove("hidden");
        }
      }
    }
    selectBoardViewMode(mode) {
      if (!mode) return;
      this.settings.boardViewMode = mode;
      if (typeof settings2 !== "undefined" && settings2) {
        settings2.boardViewMode = mode;
      }
      if (typeof window !== "undefined" && window.settings) {
        window.settings.boardViewMode = mode;
      }
      const elBv = document.getElementById("optBoardView");
      if (elBv) elBv.value = mode;
      const elBvm = document.getElementById("optBoardViewModal");
      if (elBvm) elBvm.value = mode;
      const elInGame = document.getElementById("inGameOptBoardView");
      if (elInGame) elInGame.value = mode;
      if (typeof saveSettingsStore === "function") saveSettingsStore(this.settings);
      if (typeof buildBoard === "function") buildBoard();
      if (typeof renderScores === "function") renderScores(false);
      this.updateBoardViewToggleBtn();
      this.closeInGameBoardViewDropdown();
      const r3d = typeof window !== "undefined" ? window._currentRenderer3D || window.boardRenderer3D : null;
      if (mode === "room3d-fullscreen") {
        if (r3d && typeof r3d.enterFullScreen === "function") {
          r3d.enterFullScreen();
        }
      } else if (r3d && typeof r3d.isFullScreen === "function" && r3d.isFullScreen()) {
        r3d.exitFullScreen();
      }
    }
    toggleInGameBoardViewDropdown() {
      const menu = document.getElementById("inGameBoardViewDropdownMenu");
      if (!menu) return;
      if (menu.classList.contains("hidden")) {
        this.openInGameBoardViewDropdown();
      } else {
        this.closeInGameBoardViewDropdown();
      }
    }
    openInGameBoardViewDropdown() {
      const menu = document.getElementById("inGameBoardViewDropdownMenu");
      const trigger = document.getElementById("btnToggleBoardView");
      if (!menu) return;
      if (typeof this.closeInGameBoardDropdown === "function") {
        this.closeInGameBoardDropdown();
      }
      menu.classList.remove("hidden");
      if (trigger) {
        trigger.classList.add("is-active");
        trigger.setAttribute("aria-expanded", "true");
      }
      this.updateBoardViewToggleBtn();
    }
    closeInGameBoardViewDropdown() {
      const menu = document.getElementById("inGameBoardViewDropdownMenu");
      const trigger = document.getElementById("btnToggleBoardView");
      if (!menu) return;
      menu.classList.add("hidden");
      if (trigger) {
        trigger.classList.remove("is-active");
        trigger.setAttribute("aria-expanded", "false");
      }
    }
    select3DBoard(boardId) {
      if (!boardId) return;
      this.settings.selected3DBoardId = boardId;
      if (typeof settings2 !== "undefined" && settings2) {
        settings2.selected3DBoardId = boardId;
      }
      const el3d = document.getElementById("opt3DBoard");
      if (el3d) el3d.value = boardId;
      const elInGame = document.getElementById("inGameOpt3DBoard");
      if (elInGame) elInGame.value = boardId;
      if (typeof saveSettingsStore === "function") saveSettingsStore(this.settings);
      if (typeof buildBoard === "function") buildBoard();
      if (typeof renderScores === "function") renderScores(false);
      this.updateBoardViewToggleBtn();
      this.syncInGameBoardSelector();
      this.closeInGameBoardDropdown();
    }
    toggleInGameBoardDropdown() {
      if (typeof document === "undefined") return;
      const menuEl = document.getElementById("inGameBoardDropdownMenu");
      if (!menuEl) return;
      const isOpen = !menuEl.classList.contains("hidden");
      if (isOpen) {
        this.closeInGameBoardDropdown();
      } else {
        this.openInGameBoardDropdown();
      }
    }
    openInGameBoardDropdown() {
      if (typeof document === "undefined") return;
      const menuEl = document.getElementById("inGameBoardDropdownMenu");
      const triggerEl = document.getElementById("inGameBoardDropdownTrigger");
      if (!menuEl) return;
      this.syncInGameBoardSelector();
      menuEl.classList.remove("hidden");
      if (triggerEl) {
        triggerEl.classList.add("is-active");
        triggerEl.setAttribute("aria-expanded", "true");
      }
    }
    closeInGameBoardDropdown() {
      if (typeof document === "undefined") return;
      const menuEl = document.getElementById("inGameBoardDropdownMenu");
      const triggerEl = document.getElementById("inGameBoardDropdownTrigger");
      if (menuEl) menuEl.classList.add("hidden");
      if (triggerEl) {
        triggerEl.classList.remove("is-active");
        triggerEl.setAttribute("aria-expanded", "false");
      }
    }
    syncInGameBoardSelector() {
      if (typeof document === "undefined") return;
      const curBoardId = this.settings && this.settings.selected3DBoardId || typeof settings2 !== "undefined" && settings2?.selected3DBoardId || "board-14";
      const brand = typeof getAppBrand === "function" ? getAppBrand() : this.settings?.brand || "crazy";
      const catalog = this.CC?.Board3DCatalog || (typeof Board3DCatalog !== "undefined" ? Board3DCatalog : null);
      const inGameEl = document.getElementById("inGameOpt3DBoard");
      if (inGameEl) {
        if (catalog && typeof catalog.syncDropdownOptions === "function") {
          catalog.syncDropdownOptions(inGameEl, curBoardId, brand);
        }
        inGameEl.value = curBoardId;
      }
      const curBoard = catalog && typeof catalog.getBoardById === "function" ? catalog.getBoardById(curBoardId) : null;
      const triggerThumb = document.getElementById("inGameBoardTriggerThumb");
      const triggerThumbWrap = document.getElementById("inGameBoardTriggerThumbWrap");
      const triggerName = document.getElementById("inGameBoardTriggerName");
      if (triggerName) {
        triggerName.textContent = curBoard ? curBoard.name : curBoardId;
      }
      if (triggerThumb && triggerThumbWrap) {
        const thumbUrl = curBoard?.thumbnailUrl && curBoard.thumbnailUrl.trim() ? curBoard.thumbnailUrl.trim() : "";
        if (thumbUrl) {
          triggerThumb.src = thumbUrl;
          triggerThumb.alt = curBoard?.name || "";
          triggerThumb.style.display = "block";
          triggerThumbWrap.style.display = "flex";
        } else {
          triggerThumb.style.display = "none";
          triggerThumbWrap.style.display = "none";
        }
      }
      const menuEl = document.getElementById("inGameBoardDropdownMenu");
      if (menuEl && catalog && typeof catalog.getBoards === "function") {
        const boards = catalog.getBoards(brand) || [];
        this.renderInGameBoardDropdown(menuEl, boards, curBoardId);
      }
    }
    renderInGameBoardDropdown(menuEl, boards, curBoardId) {
      if (!menuEl) return;
      let html2 = `
      <div class="board-3d-dropdown-header">
        <span class="board-3d-dropdown-header-title">\u{1F3B2} 3D Cribbage Boards</span>
        <span class="board-3d-dropdown-count">${boards.length} Boards</span>
      </div>
      <div class="board-3d-dropdown-grid">
    `;
      boards.forEach((b) => {
        const isSelected = b.id === curBoardId;
        const thumbUrl = b.thumbnailUrl && b.thumbnailUrl.trim() ? b.thumbnailUrl.trim() : "";
        html2 += `
        <div class="board-3d-dropdown-item ${isSelected ? "is-selected" : ""}"
             role="option"
             aria-selected="${isSelected ? "true" : "false"}"
             data-board-id="${b.id}"
             tabindex="0"
             title="${b.name}${b.desc ? " - " + b.desc : ""}">
          <div class="board-3d-dropdown-item-thumb-box">
            ${thumbUrl ? `
              <img src="${thumbUrl}" alt="${b.name}" class="board-3d-dropdown-item-thumb" loading="lazy">
            ` : `
              <span class="board-3d-thumb-fallback">\u{1F3B2}</span>
            `}
            ${isSelected ? '<span class="board-3d-item-badge-active">\u2713 Active</span>' : ""}
            ${b.isCustom ? '<span class="board-3d-item-badge-custom">Custom</span>' : ""}
          </div>
          <div class="board-3d-dropdown-item-name">${b.name}</div>
        </div>
      `;
      });
      html2 += `
      </div>
      <div class="board-3d-dropdown-footer">
        <button type="button" class="btn-ghost board-3d-dropdown-gallery-btn" id="btnDropdownOpenGallery">
          <span>\u{1F3A8} Open Gallery &amp; Custom Loader</span>
        </button>
      </div>
    `;
      menuEl.innerHTML = html2;
      menuEl.querySelectorAll("img.board-3d-dropdown-item-thumb").forEach((img) => {
        img.addEventListener("error", () => {
          if (img.parentElement) {
            img.parentElement.innerHTML = '<span class="board-3d-thumb-fallback">\u{1F3B2}</span>';
          }
        }, { once: true });
      });
      menuEl.querySelectorAll(".board-3d-dropdown-item").forEach((item) => {
        item.onclick = (e) => {
          e.stopPropagation();
          const boardId = item.getAttribute("data-board-id");
          if (boardId) {
            this.select3DBoard(boardId);
          }
        };
        item.onkeydown = (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            const boardId = item.getAttribute("data-board-id");
            if (boardId) {
              this.select3DBoard(boardId);
            }
          }
        };
      });
      const btnGallery = menuEl.querySelector("#btnDropdownOpenGallery");
      if (btnGallery) {
        btnGallery.onclick = (e) => {
          e.stopPropagation();
          this.closeInGameBoardDropdown();
          this.showBoard3DModal();
        };
      }
    }
    showBoard3DModal(options = {}) {
      const modal = (typeof BoardSelectorModal2 !== "undefined" ? BoardSelectorModal2 : null) || this.CC?.BoardSelectorModal || (typeof window !== "undefined" ? window.BoardSelectorModal : null);
      if (modal) {
        const brand = (typeof options === "string" ? options : options?.brand) || (typeof getAppBrand === "function" ? getAppBrand() : this.settings?.brand || "crazy");
        modal.show({
          brand,
          settings: this.settings,
          onSelect: ({ viewMode, boardId }) => {
            const currentMode = this.settings?.boardViewMode || (typeof settings2 !== "undefined" ? settings2?.boardViewMode : null) || "3d";
            const resolvedMode = viewMode || currentMode;
            this.settings.boardViewMode = resolvedMode;
            this.settings.selected3DBoardId = boardId;
            if (typeof settings2 !== "undefined" && settings2) {
              settings2.boardViewMode = resolvedMode;
              settings2.selected3DBoardId = boardId;
            }
            const elBv = document.getElementById("optBoardView");
            if (elBv) elBv.value = resolvedMode;
            const el3d = document.getElementById("opt3DBoard");
            if (el3d) el3d.value = boardId;
            const elInGame = document.getElementById("inGameOpt3DBoard");
            if (elInGame) elInGame.value = boardId;
            if (typeof saveSettingsStore === "function") saveSettingsStore(this.settings);
            if (typeof buildBoard === "function") buildBoard();
            if (typeof renderScores === "function") renderScores(false);
            this.updateBoardViewToggleBtn();
            this.syncInGameBoardSelector();
          }
        });
      }
    }
    exposeGlobals(target = typeof window !== "undefined" ? window : globalThis) {
      target.crazyCribbageApp = this;
      target.CrazyCribbage = target.CrazyCribbage || this.CC;
      target.CrazyCribbageApp = _CrazyCribbageApp;
      target.CC = target.CrazyCribbage;
      target.RANKS = RANKS2;
      target.RANK_NAME = RANK_NAME2;
      target.SUITS = SUITS2;
      target.SUIT_SYM = SUIT_SYM2;
      target.VAL = VAL3;
      target.BOARD_CFG = BOARD_CFG2;
      target.BOARD_CFG_481 = BOARD_CFG_4812;
      target.CLASH_DEFAULTS_481 = CLASH_DEFAULTS_4813;
      target.CLASH_DEFAULTS_241 = CLASH_DEFAULTS_2413;
      target.CLASH_DEFAULTS_361 = CLASH_DEFAULTS_3613;
      target.CARD_BACKS = CARD_BACKS2;
      target.THEMES = THEMES2;
      target.CLASH_BLOCK_DEFS = CLASH_BLOCK_DEFS;
      target.PINTS_DRINKING_DEFS = PINTS_DRINKING_DEFS2;
      target.ADULT_OPTIONS_LIST = ADULT_OPTIONS_LIST2;
      target.DROPDOWN_DESCRIPTIONS = DROPDOWN_DESCRIPTIONS2;
      target.CLASH_ITEM_METADATA = CLASH_ITEM_METADATA;
      target.CRAZY_OPTIONS_DEFS = CRAZY_OPTIONS_DEFS;
      const stateProps = ["state", "settings", "pegState", "net", "gameHands", "theme", "recordCache", "_suppressSettingsSave", "_isEnforcingClashNoOverlap", "_isRandomizingClash", "sfx", "FULL_DECK"];
      for (const prop of stateProps) {
        Object.defineProperty(target, prop, {
          get: () => this[prop],
          set: (v) => {
            this[prop] = v;
          },
          configurable: true
        });
      }
      if (this.CC) {
        const classes = ["Card", "Deck", "Hand", "Player", "Roster", "CribbageScorer", "PegTracker", "GameState", "PintsManager", "AdultManager", "ClashManager", "CrazyManager", "CrazySettings", "CribbageAI", "ObstacleGeometry", "AudioManager", "NetworkManager", "GameEngine", "ModalManager", "SettingsManager", "UIController", "BoardRenderer", "PintsSettings", "AdultSettings", "ClashSettings", "CoachController", "ClashPlacementModal", "ShowModal", "LobbyController", "DropdownHelpManager", "TableRenderer", "ClashMiniGames", "DiscardTrainer", "HandScoreTracker", "HandOfGloryCard", "ClashPresets", "PintsPresets", "AdultPresets", "ClashSandboxModal", "IndexedDBStorage", "appStorage", "TournamentManager", "TournamentModal", "Board3DCatalog", "DEFAULT_3D_BOARDS", "BoardRenderer3D", "BoardSelectorModal", "CardAssassinOverlay", "JailAnimationOverlay", "BarAnimationOverlay", "CannonAnimationOverlay", "SpeedTrapAnimationOverlay", "ScenicRouteAnimationOverlay", "GameReplayManager", "ReplayModal", "AvatarManager", "PRESET_AVATARS", "Profile", "RoomCatalog3D", "CardMesh3D", "CardEngine3D", "SeatManager3D", "PlayerAvatar3D", "Room3DLoadingOverlay"];
        classes.forEach((c) => {
          if (this.CC[c]) target[c] = this.CC[c];
        });
        target.Profile = target.Profile || this.CC?.Profile || Profile;
        target.PlayerProfile = target.PlayerProfile || target.Profile;
        target.AvatarManager = target.AvatarManager || this.CC?.AvatarManager || AvatarManager;
        target.openAvatarModal = (opts) => (target.AvatarManager || AvatarManager).openAvatarModal(opts);
        target.CardAssassinOverlay = target.CardAssassinOverlay || CardAssassinOverlay;
        target.showCardAssassin = target.showCardAssassin || ((opts) => (target.CardAssassinOverlay || CardAssassinOverlay).show(opts));
        target.JailAnimationOverlay = target.JailAnimationOverlay || JailAnimationOverlay;
        target.showJailAnimation = target.showJailAnimation || ((opts) => (target.JailAnimationOverlay || JailAnimationOverlay).show(opts));
        target.BarAnimationOverlay = target.BarAnimationOverlay || BarAnimationOverlay;
        target.showBarAnimation = target.showBarAnimation || ((opts) => (target.BarAnimationOverlay || BarAnimationOverlay).show(opts));
        target.CannonAnimationOverlay = target.CannonAnimationOverlay || CannonAnimationOverlay;
        target.showCannonAnimation = target.showCannonAnimation || ((opts) => (target.CannonAnimationOverlay || CannonAnimationOverlay).show(opts));
        target.SpeedTrapAnimationOverlay = target.SpeedTrapAnimationOverlay || SpeedTrapAnimationOverlay;
        target.showSpeedTrapAnimation = target.showSpeedTrapAnimation || ((opts) => (target.SpeedTrapAnimationOverlay || SpeedTrapAnimationOverlay).show(opts));
        target.ScenicRouteAnimationOverlay = target.ScenicRouteAnimationOverlay || ScenicRouteAnimationOverlay;
        target.showScenicRouteAnimation = target.showScenicRouteAnimation || ((opts) => (target.ScenicRouteAnimationOverlay || ScenicRouteAnimationOverlay).show(opts));
        target.Room3DLoadingOverlay = target.Room3DLoadingOverlay || this.CC?.Room3DLoadingOverlay || Room3DLoadingOverlay2;
        target.showRoom3DLoader = target.showRoom3DLoader || ((container, opts) => (target.Room3DLoadingOverlay || Room3DLoadingOverlay2).show(container, opts));
        target.GameReplayManager = target.GameReplayManager || this.CC?.GameReplayManager || GameReplayManager;
        target.ReplayModal = target.ReplayModal || this.CC?.ReplayModal || ReplayModal;
        target.showReplaysModal = (brand = null) => {
          const b = brand || (typeof getAppBrand === "function" ? getAppBrand() : "all");
          return (this.CC?.ReplayModal || target.ReplayModal || ReplayModal)?.openLibrary?.(b);
        };
        target.showReplayPlayer = (replay) => (this.CC?.ReplayModal || target.ReplayModal || ReplayModal)?.open?.(replay);
        target.playCurrentGameReplay = () => (this.CC?.GameReplayManager || target.GameReplayManager || GameReplayManager)?.playCurrentGameReplay?.();
        target.shareCurrentGameReplay = () => (this.CC?.GameReplayManager || target.GameReplayManager || GameReplayManager)?.shareCurrentGameReplay?.();
        target.shareCurrentReplay = target.shareCurrentGameReplay;
        target.appStorage = appStorage;
        target.IndexedDBStorage = IndexedDBStorage;
        target.crazyManager = target.crazyManager || (this.CC.CrazyManager ? new this.CC.CrazyManager({ settings: this.settings }) : null);
        target.pintsManager = target.pintsManager || (this.CC.PintsManager ? new this.CC.PintsManager() : null);
        target.adultManager = target.adultManager || (this.CC.AdultManager ? new this.CC.AdultManager() : null);
        target.clashManager = target.clashManager || (this.CC.ClashManager ? new this.CC.ClashManager() : null);
        target.pegTracker = target.pegTracker || (this.CC.PegTracker ? new this.CC.PegTracker() : null);
        target.audioManager = target.audioManager || (this.CC.AudioManager ? new this.CC.AudioManager() : null);
        target.modalManager = target.modalManager || (this.CC.ModalManager ? new this.CC.ModalManager() : null);
        if (target.modalManager && !target.modalManager.openGuessStarterPrompt) {
          target.modalManager.openGuessStarterPrompt = openGuessStarterPrompt;
        }
        target.settingsManager = target.settingsManager || (this.CC.SettingsManager ? new this.CC.SettingsManager() : null);
        target.uiController = target.uiController || (this.CC.UIController ? new this.CC.UIController() : null);
        target.load3DBoardsJson = (source, opts) => Board3DCatalog.loadDefaultBoards(source, opts);
        target.reload3DBoardsJson = (opts) => Board3DCatalog.loadDefaultBoards(null, opts);
        if (typeof window !== "undefined") {
          window.modalManager = target.modalManager;
          window.showModal = showModal;
          window.hideModal = hideModal2;
          window.load3DBoardsJson = target.load3DBoardsJson;
          window.reload3DBoardsJson = target.reload3DBoardsJson;
        }
      }
      const proto = Object.getPrototypeOf(this);
      for (const key of Object.getOwnPropertyNames(proto)) {
        if (key !== "constructor" && typeof this[key] === "function" && !key.startsWith("_")) {
          target[key] = this[key];
        }
      }
      target.openGuessStarterPrompt = openGuessStarterPrompt;
      target.beginCutStarter = beginCutStarter;
      target.poneDoCutStarter = poneDoCutStarter;
      target.beginCut = beginCut;
      target.pickCut = pickCut;
      target.stepNextCut = stepNextCut;
      target.resolveCuts = resolveCuts;
      if (typeof window !== "undefined") {
        window.openGuessStarterPrompt = openGuessStarterPrompt;
        window.beginCutStarter = beginCutStarter;
        window.poneDoCutStarter = poneDoCutStarter;
        window.beginCut = beginCut;
        window.pickCut = pickCut;
        window.stepNextCut = stepNextCut;
        window.resolveCuts = resolveCuts;
      }
      target.pegScore = this.addScore;
      target.showOptionDescriptionModal = this.showDropdownInfoModal;
      target.showDiscardTrainerModal = showDiscardTrainerModal2;
      target.showPeggingTrainerModal = showPeggingTrainerModal;
      target.showCountingTrainerModal = showCountingTrainerModal;
      target.showCoachPostMortemModal = showCoachPostMortemModal;
      target.shareCoachPostMortem = shareCoachPostMortem;
      target.showGameWonModal = showGameWonModal;
      target.PeggingTrainer = CC2?.PeggingTrainer || PeggingTrainer;
      target.CountingTrainer = CC2?.CountingTrainer || CountingTrainer;
      target.CoachPostMortem = CC2?.CoachPostMortem || CoachPostMortem;
      target.showDailyPuzzleModal = showDailyPuzzleModal;
      target.DailyPuzzleManager = CC2?.DailyPuzzleManager || DailyPuzzleManager;
      target.TournamentManager = CC2?.TournamentManager || TournamentManager;
      target.TournamentModal = CC2?.TournamentModal || TournamentModal;
      target.showTournamentModal = (context) => (CC2?.TournamentModal || TournamentModal).open(context);
      target.showBoard3DModal = (options = {}) => this.showBoard3DModal(options);
      target.select3DBoard = (boardId) => this.select3DBoard(boardId);
      target.syncInGameBoardSelector = () => this.syncInGameBoardSelector();
      target.toggleBoardViewMode = () => this.toggleBoardViewMode();
      target.selectBoardViewMode = (mode) => this.selectBoardViewMode(mode);
      target.toggleInGameBoardViewDropdown = () => this.toggleInGameBoardViewDropdown();
      target.openInGameBoardViewDropdown = () => this.openInGameBoardViewDropdown();
      target.closeInGameBoardViewDropdown = () => this.closeInGameBoardViewDropdown();
      target.updateBoardViewToggleBtn = () => this.updateBoardViewToggleBtn();
      target.minimizeBoard = () => this.minimizeBoard();
      target.maximizeBoard = () => this.maximizeBoard();
      target.restoreBoard = () => this.restoreBoard();
      target.toggleBoardMinimize = () => this.toggleBoardMinimize();
      target.toggleBoardMaximize = () => this.toggleBoardMaximize();
      target.toggle3DRoomFullScreen = () => this.toggle3DRoomFullScreen();
      target.is3DRoomFullScreen = () => this.is3DRoomFullScreen();
      target.updateBoardSizeButtons = () => this.updateBoardSizeButtons();
      target.getAppBrand = getAppBrand;
      target.isAgeVerified = isAgeVerified;
      target.setAgeVerified = setAgeVerified;
      target.checkInitialAgeGate = checkInitialAgeGate;
      target.showAgeGateModal = showAgeGateModal;
      target.hideAgeGateModal = hideAgeGateModal;
    }
  };
  CrazyCribbageApp.prototype.getAppBrand = getAppBrand;
  CrazyCribbageApp.prototype.getClashBoardCfg = getClashBoardCfg2;
  CrazyCribbageApp.prototype.getTrackXY = getTrackXY2;
  CrazyCribbageApp.prototype.parseGameMode = parseGameMode;
  CrazyCribbageApp.prototype.serializeGameMode = serializeGameMode;
  CrazyCribbageApp.prototype.isOnline = isOnline;
  CrazyCribbageApp.prototype.isHvH = isHvH;
  CrazyCribbageApp.prototype.isTwoHuman = isTwoHuman;
  CrazyCribbageApp.prototype.isSoloVsPairs = isSoloVsPairs;
  CrazyCribbageApp.prototype.is3Player1vs2 = is3Player1vs2;
  CrazyCribbageApp.prototype.is5Player1vs4 = is5Player1vs4;
  CrazyCribbageApp.prototype.is7Player1vs6 = is7Player1vs6;
  CrazyCribbageApp.prototype.isFixedTeams = isFixedTeams;
  CrazyCribbageApp.prototype.isPartnership = isPartnership;
  CrazyCribbageApp.prototype.isShiftingPartnership = isShiftingPartnership;
  CrazyCribbageApp.prototype.mySeat = mySeat2;
  CrazyCribbageApp.prototype.getPlayerCount = getPlayerCount;
  CrazyCribbageApp.prototype.getRoster = getRoster;
  CrazyCribbageApp.prototype.getActiveSeats = getActiveSeats;
  CrazyCribbageApp.prototype.getActiveSeatIds = getActiveSeatIds;
  CrazyCribbageApp.prototype.getSeatTeam = getSeatTeam;
  CrazyCribbageApp.prototype.getShiftingRoles = getShiftingRoles;
  CrazyCribbageApp.prototype.getShiftingPartner = getShiftingPartner;
  CrazyCribbageApp.prototype.nextSeat = nextSeat;
  CrazyCribbageApp.prototype.prevSeat = prevSeat;
  CrazyCribbageApp.prototype.getSeat = getSeat;
  CrazyCribbageApp.prototype.getSeatHand = getSeatHand;
  CrazyCribbageApp.prototype.setSeatHand = setSeatHand;
  CrazyCribbageApp.prototype.getSeatKept = getSeatKept;
  CrazyCribbageApp.prototype.setSeatKept = setSeatKept;
  CrazyCribbageApp.prototype.getSeatHandModel = getSeatHandModel;
  CrazyCribbageApp.prototype.getSeatKeptModel = getSeatKeptModel;
  CrazyCribbageApp.prototype.getCribModel = getCribModel;
  CrazyCribbageApp.prototype.getPileModel = getPileModel;
  CrazyCribbageApp.prototype.seatName = seatName2;
  CrazyCribbageApp.prototype.pName = pName;
  CrazyCribbageApp.prototype.seatColor = seatColor;
  CrazyCribbageApp.prototype.isSeatCpu = isSeatCpu;
  CrazyCribbageApp.prototype.isSeatHuman = isSeatHuman;
  CrazyCribbageApp.prototype.scoreKey = scoreKey;
  CrazyCribbageApp.prototype.isInPegThroughZone = isInPegThroughZone2;
  CrazyCribbageApp.prototype.isInLast5PegOut = isInLast5PegOut2;
  CrazyCribbageApp.prototype.isInBunker = isInBunker2;
  CrazyCribbageApp.prototype.getNoPassingLanes = getNoPassingLanes;
  CrazyCribbageApp.prototype.isInNoPassingLane = isInNoPassingLane2;
  CrazyCribbageApp.prototype.getNoPassingLaneForHole = getNoPassingLaneForHole;
  CrazyCribbageApp.prototype.getNoPassingLaneMaxScore = getNoPassingLaneMaxScore;
  CrazyCribbageApp.prototype.getJumpConfigs = getJumpConfigs;
  CrazyCribbageApp.prototype.getJumpForHole = getJumpForHole;
  CrazyCribbageApp.prototype.getJailConfigs = getJailConfigs;
  CrazyCribbageApp.prototype.getJailForHole = getJailForHole;
  CrazyCribbageApp.prototype.getJailStepXY = getJailStepXY;
  CrazyCribbageApp.prototype.getBarConfigs = getBarConfigs;
  CrazyCribbageApp.prototype.getBarForHole = getBarForHole;
  CrazyCribbageApp.prototype.getBarStepXY = getBarStepXY;
  CrazyCribbageApp.prototype.getTimeoutConfigs = getTimeoutConfigs;
  CrazyCribbageApp.prototype.getTimeoutForHole = getTimeoutForHole;
  CrazyCribbageApp.prototype.getTimeoutStepXY = getTimeoutStepXY;
  CrazyCribbageApp.prototype.getStopSignConfigs = getStopSignConfigs;
  CrazyCribbageApp.prototype.getStopSignForHole = getStopSignForHole;
  CrazyCribbageApp.prototype.getDetourConfigs = getDetourConfigs;
  CrazyCribbageApp.prototype.getDetourForHole = getDetourForHole;
  CrazyCribbageApp.prototype.catmullRomPath = catmullRomPath;
  CrazyCribbageApp.prototype.computeLoopGeometry = computeLoopGeometry;
  CrazyCribbageApp.prototype.getDetourStepXY = getDetourStepXY;
  CrazyCribbageApp.prototype.getRoundAboutConfigs = getRoundAboutConfigs;
  CrazyCribbageApp.prototype.getRoundAboutForHole = getRoundAboutForHole;
  CrazyCribbageApp.prototype.getRoundAboutStepXY = getRoundAboutStepXY;
  CrazyCribbageApp.prototype.getSignConfigs = getSignConfigs;
  CrazyCribbageApp.prototype.getSignBlockForHole = getSignBlockForHole;
  CrazyCribbageApp.prototype.getDiceConfigs = getDiceConfigs2;
  CrazyCribbageApp.prototype.getDiceForHole = getDiceForHole;
  CrazyCribbageApp.prototype.getWheelConfigs = getWheelConfigs2;
  CrazyCribbageApp.prototype.getWheelForHole = getWheelForHole;
  CrazyCribbageApp.prototype.isDealerTeam = isDealerTeam;
  CrazyCribbageApp.prototype.seatDiscardsToDeck = seatDiscardsToDeck;
  CrazyCribbageApp.prototype.applySeatLabels = applySeatLabels;
  CrazyCribbageApp.prototype.passTo = passTo;
  CrazyCribbageApp.prototype.scheduleOppPlay = scheduleOppPlay;
  CrazyCribbageApp.prototype.announcePlayTurn = announcePlayTurn;
  CrazyCribbageApp.prototype.getClashDefaults = getClashDefaults3;
  CrazyCribbageApp.prototype.getSkunkDefaults = getSkunkDefaults3;
  CrazyCribbageApp.prototype.setCardBack = setCardBack;
  CrazyCribbageApp.prototype.initCardBackPicker = initCardBackPicker;
  CrazyCribbageApp.prototype.makeDeck = makeDeck;
  CrazyCribbageApp.prototype.isWild = isWild;
  CrazyCribbageApp.prototype.rankOf = rankOf;
  CrazyCribbageApp.prototype.suitOf = suitOf;
  CrazyCribbageApp.prototype.cardFits = cardFits;
  CrazyCribbageApp.prototype.assignCard = assignCard;
  CrazyCribbageApp.prototype.shuffle = shuffle;
  CrazyCribbageApp.prototype.takeAnim = takeAnim;
  CrazyCribbageApp.prototype.resetAnims = resetAnims;
  CrazyCribbageApp.prototype.faceMarkup = faceMarkup;
  CrazyCribbageApp.prototype.cardEl = cardEl;
  CrazyCribbageApp.prototype.cardKey = cardKey;
  CrazyCribbageApp.prototype.applyHighlights = applyHighlights;
  CrazyCribbageApp.prototype.combinations = combinations2;
  CrazyCribbageApp.prototype.isConsecutiveRun = isConsecutiveRun2;
  CrazyCribbageApp.prototype.scoreShowCore = scoreShowCore;
  CrazyCribbageApp.prototype.scoreShow = scoreShow;
  CrazyCribbageApp.prototype.pegPoints = pegPoints;
  CrazyCribbageApp.prototype.pegTotal = pegTotal;
  CrazyCribbageApp.prototype.pegPotential = pegPotential;
  CrazyCribbageApp.prototype.expectedShowExact = expectedShowExact;
  CrazyCribbageApp.prototype.chooseDiscardFast = chooseDiscardFast;
  CrazyCribbageApp.prototype.chooseDiscard = chooseDiscard;
  CrazyCribbageApp.prototype.cpuKnownIds = cpuKnownIds;
  CrazyCribbageApp.prototype.unseenCards = unseenCards;
  CrazyCribbageApp.prototype.sampleOppHand = sampleOppHand;
  CrazyCribbageApp.prototype.removeCard = removeCard;
  CrazyCribbageApp.prototype.fastPlayCard = fastPlayCard;
  CrazyCribbageApp.prototype.rolloutPeg = rolloutPeg;
  CrazyCribbageApp.prototype.raceBonus = raceBonus;
  CrazyCribbageApp.prototype.cardLabel = cardLabel;
  CrazyCribbageApp.prototype.choosePlay = choosePlay;
  CrazyCribbageApp.prototype.log = log;
  CrazyCribbageApp.prototype.showSolver = showSolver;
  CrazyCribbageApp.prototype.setStatus = setStatus;
  CrazyCribbageApp.prototype.updateTurnPrompt = updateTurnPrompt;
  CrazyCribbageApp.prototype.isBonusMessage = isBonusMessage;
  CrazyCribbageApp.prototype.fancyCall = fancyCall;
  CrazyCribbageApp.prototype.fancyPegPhrase = fancyPegPhrase;
  CrazyCribbageApp.prototype.announceCombos = announceCombos;
  CrazyCribbageApp.prototype.updateCountGlow = updateCountGlow;
  CrazyCribbageApp.prototype.streetName = streetName2;
  CrazyCribbageApp.prototype.showStreetBanner = showStreetBanner;
  CrazyCribbageApp.prototype.showScoreToast = showScoreToast;
  CrazyCribbageApp.prototype.addScore = addScore;
  CrazyCribbageApp.prototype.skunkResult = skunkResult2;
  CrazyCribbageApp.prototype.checkGameOver = checkGameOver;
  CrazyCribbageApp.prototype.checkChutesAndLadders = checkChutesAndLadders;
  CrazyCribbageApp.prototype.handleSignsLanding = handleSignsLanding;
  CrazyCribbageApp.prototype.openSignPickerModal = openSignPickerModal;
  CrazyCribbageApp.prototype.onSignCardClick = onSignCardClick2;
  CrazyCribbageApp.prototype.chooseSign = chooseSign;
  CrazyCribbageApp.prototype.resumeGameAfterSign = resumeGameAfterSign;
  CrazyCribbageApp.prototype.executeSign = executeSign;
  CrazyCribbageApp.prototype.openDiceRollModal = openDiceRollModal;
  CrazyCribbageApp.prototype.performDiceRoll = performDiceRoll2;
  CrazyCribbageApp.prototype.onDicePickPlayer = onDicePickPlayer2;
  CrazyCribbageApp.prototype.applyDiceResult = applyDiceResult;
  CrazyCribbageApp.prototype.openWheelSpinModal = openWheelSpinModal;
  CrazyCribbageApp.prototype.drawWheelCanvas = drawWheelCanvas;
  CrazyCribbageApp.prototype.performWheelSpin = performWheelSpin2;
  CrazyCribbageApp.prototype.updateSignsBillboard = updateSignsBillboard;
  CrazyCribbageApp.prototype.getActiveTracks = getActiveTracks2;
  CrazyCribbageApp.prototype.getPegGradId = getPegGradId;
  CrazyCribbageApp.prototype.updateScoreChips = updateScoreChips;
  CrazyCribbageApp.prototype.getBoardSignature = getBoardSignature;
  CrazyCribbageApp.prototype.buildBoard = buildBoard;
  CrazyCribbageApp.prototype.createCrazyCribbageLegend = createCrazyCribbageLegend;
  CrazyCribbageApp.prototype.getBoardTooltipContext = getBoardTooltipContext;
  CrazyCribbageApp.prototype.getBoardTooltipData = getBoardTooltipData;
  CrazyCribbageApp.prototype.hideFancyTooltip = hideFancyTooltip;
  CrazyCribbageApp.prototype.initBoardFancyTooltips = initBoardFancyTooltips;
  CrazyCribbageApp.prototype.renderScores = renderScores;
  CrazyCribbageApp.prototype.sortCards = sortCards;
  CrazyCribbageApp.prototype.render = render;
  CrazyCribbageApp.prototype.onOppSeatDiscardCard = onOppSeatDiscardCard;
  CrazyCribbageApp.prototype.onCpuCard = onCpuCard;
  CrazyCribbageApp.prototype.onYouCard = onYouCard;
  CrazyCribbageApp.prototype.hideWildPick = hideWildPick;
  CrazyCribbageApp.prototype.openWildPick = openWildPick;
  CrazyCribbageApp.prototype.stylePickBtn = stylePickBtn;
  CrazyCribbageApp.prototype.drawWildPick = drawWildPick;
  CrazyCribbageApp.prototype.confirmWildAs = confirmWildAs;
  CrazyCribbageApp.prototype.cpuAssignWilds = cpuAssignWilds;
  CrazyCribbageApp.prototype.beginDiscard = beginDiscard;
  CrazyCribbageApp.prototype.showWait = showWait;
  CrazyCribbageApp.prototype.hideWait = hideWait;
  CrazyCribbageApp.prototype.afterStarterAssigned = afterStarterAssigned;
  CrazyCribbageApp.prototype.getAppBrand = getAppBrand;
  CrazyCribbageApp.prototype.getSettingsKey = getSettingsKey;
  CrazyCribbageApp.prototype.getRecordKey = getRecordKey;
  CrazyCribbageApp.prototype.isAgeVerified = isAgeVerified;
  CrazyCribbageApp.prototype.setAgeVerified = setAgeVerified;
  CrazyCribbageApp.prototype.showAgeGateModal = showAgeGateModal;
  CrazyCribbageApp.prototype.hideAgeGateModal = hideAgeGateModal;
  CrazyCribbageApp.prototype.confirmAgeGate = confirmAgeGate;
  CrazyCribbageApp.prototype.exitAgeGateToSafeBrand = exitAgeGateToSafeBrand;
  CrazyCribbageApp.prototype.getThemeKey = getThemeKey;
  CrazyCribbageApp.prototype.getDefaultTheme = getDefaultTheme;
  CrazyCribbageApp.prototype.applyTheme = applyTheme;
  CrazyCribbageApp.prototype.toggleTheme = toggleTheme;
  CrazyCribbageApp.prototype.variantParts = variantParts;
  CrazyCribbageApp.prototype.variantKeyFrom = variantKeyFrom;
  CrazyCribbageApp.prototype.variantLabelFrom = variantLabelFrom;
  CrazyCribbageApp.prototype.loadRecords = loadRecords;
  CrazyCribbageApp.prototype.saveRecords = saveRecords;
  CrazyCribbageApp.prototype.getVariantRecord = getVariantRecord;
  CrazyCribbageApp.prototype.recordGameResult = recordGameResult;
  CrazyCribbageApp.prototype.currentFormVariant = currentFormVariant;
  CrazyCribbageApp.prototype.renderRecordBox = renderRecordBox;
  CrazyCribbageApp.prototype.getActiveClashBlocks = getActiveClashBlocks;
  CrazyCribbageApp.prototype.checkClashCollision = checkClashCollision;
  CrazyCribbageApp.prototype.findAvailableClashHole = findAvailableClashHole;
  CrazyCribbageApp.prototype.updateAllClashDropdowns = updateAllClashDropdowns;
  CrazyCribbageApp.prototype.enforceClashNoOverlap = enforceClashNoOverlap;
  CrazyCribbageApp.prototype.sanitizeClashBlockPlacements = sanitizeClashBlockPlacements;
  CrazyCribbageApp.prototype.getStreetOrTurnName = getStreetOrTurnName;
  CrazyCribbageApp.prototype.toggleSignsConfig = toggleSignsConfig;
  CrazyCribbageApp.prototype.toggleDetourConfig = toggleDetourConfig;
  CrazyCribbageApp.prototype.toggleRoundAboutConfig = toggleRoundAboutConfig;
  CrazyCribbageApp.prototype.toggleDiceConfig = toggleDiceConfig;
  CrazyCribbageApp.prototype.toggleWheelConfig = toggleWheelConfig;
  CrazyCribbageApp.prototype.updateJumpOptionLabels = updateJumpOptionLabels;
  CrazyCribbageApp.prototype.readSignsBlocksFromForm = readSignsBlocksFromForm;
  CrazyCribbageApp.prototype.onSignBillboardClick = onSignBillboardClick;
  CrazyCribbageApp.prototype.toggleSkunkMarkersConfig = toggleSkunkMarkersConfig;
  CrazyCribbageApp.prototype.onSkunkMarkerFieldChange = onSkunkMarkerFieldChange;
  CrazyCribbageApp.prototype.onDoubleSkunkMarkerFieldChange = onDoubleSkunkMarkerFieldChange;
  CrazyCribbageApp.prototype.randomizePintsOptions = randomizePintsOptions;
  CrazyCribbageApp.prototype.getDefaultAdultSettings = getDefaultAdultSettings;
  CrazyCribbageApp.prototype.getAdultOptionDef = getAdultOptionDef;
  CrazyCribbageApp.prototype.toggleAdultOptionConfig = toggleAdultOptionConfig;
  CrazyCribbageApp.prototype.updateAdultOptionRows = updateAdultOptionRows;
  CrazyCribbageApp.prototype.onAdultOptionPegsChange = onAdultOptionPegsChange;
  CrazyCribbageApp.prototype.onAdultOptionFieldChange = onAdultOptionFieldChange;
  CrazyCribbageApp.prototype.getAdultOptionConfigs = getAdultOptionConfigs;
  CrazyCribbageApp.prototype.randomizeAdultOptions = randomizeAdultOptions;
  CrazyCribbageApp.prototype.showAdultTimerModal = showAdultTimerModal;
  CrazyCribbageApp.prototype.startAdultTimer = startAdultTimer;
  CrazyCribbageApp.prototype.closeAdultTimerModal = closeAdultTimerModal;
  CrazyCribbageApp.prototype.showAdultStripModal = showAdultStripModal;
  CrazyCribbageApp.prototype.closeAdultStripModal = closeAdultStripModal;
  CrazyCribbageApp.prototype.resumeGameAfterAdultStrip = resumeGameAfterAdultStrip;
  CrazyCribbageApp.prototype.resumeGameAfterAdultTimer = resumeGameAfterAdultTimer;
  CrazyCribbageApp.prototype.showPintsBonusModal = showPintsBonusModal;
  CrazyCribbageApp.prototype.closePintsBonusModal = closePintsBonusModal;
  CrazyCribbageApp.prototype.resumeGameAfterPintsBonus = resumeGameAfterPintsBonus;
  CrazyCribbageApp.prototype.readFormSettings = readFormSettings;
  CrazyCribbageApp.prototype.updateTargetOptions = updateTargetOptions;
  CrazyCribbageApp.prototype.applyFormSettings = applyFormSettings;
  CrazyCribbageApp.prototype.applyBrandVisibility = applyBrandVisibility;
  CrazyCribbageApp.prototype.updateCheckAllBonusesState = updateCheckAllBonusesState;
  CrazyCribbageApp.prototype.saveSettingsStore = saveSettingsStore;
  CrazyCribbageApp.prototype.loadSettingsStore = loadSettingsStore;
  CrazyCribbageApp.prototype.setNetStatus = setNetStatus;
  CrazyCribbageApp.prototype.getLobbyRosterData = getLobbyRosterData;
  CrazyCribbageApp.prototype.updateNetRoster = updateNetRoster;
  CrazyCribbageApp.prototype.broadcastLobbyUpdate = broadcastLobbyUpdate;
  CrazyCribbageApp.prototype.serializeState = serializeState;
  CrazyCribbageApp.prototype.getSanitizedStateForSeat = getSanitizedStateForSeat;
  CrazyCribbageApp.prototype.netSend = netSend;
  CrazyCribbageApp.prototype.netPush = netPush;
  CrazyCribbageApp.prototype.applyRemoteState = applyRemoteState;
  CrazyCribbageApp.prototype.handleSeatDiscardIntent = handleSeatDiscardIntent;
  CrazyCribbageApp.prototype.confirmDraw = confirmDraw;
  CrazyCribbageApp.prototype.hostApplyIntent = hostApplyIntent;
  CrazyCribbageApp.prototype.handleClientHello = handleClientHello;
  CrazyCribbageApp.prototype.handleClientDisconnect = handleClientDisconnect;
  CrazyCribbageApp.prototype.handleHostDisconnect = handleHostDisconnect;
  CrazyCribbageApp.prototype.isSeatOnline = isSeatOnline2;
  CrazyCribbageApp.prototype.isMultiHuman = isMultiHuman2;
  CrazyCribbageApp.prototype.replacePlayerWithAi = replacePlayerWithAi;
  CrazyCribbageApp.prototype.handlePlayerOfflinePrompt = handlePlayerOfflinePrompt;
  CrazyCribbageApp.prototype.bindHostClientConn = bindHostClientConn;
  CrazyCribbageApp.prototype.makeRoomCode = makeRoomCode;
  CrazyCribbageApp.prototype.getJoinUrl = getJoinUrl;
  CrazyCribbageApp.prototype.showHostInviteLink = showHostInviteLink;
  CrazyCribbageApp.prototype.copyRoomInviteLink = copyRoomInviteLink;
  CrazyCribbageApp.prototype.shareRoomInvite = shareRoomInvite;
  CrazyCribbageApp.prototype.shareRoomWhatsApp = shareRoomWhatsApp;
  CrazyCribbageApp.prototype.shareRoomEmail = shareRoomEmail;
  CrazyCribbageApp.prototype.fallbackCopyText = fallbackCopyText;
  CrazyCribbageApp.prototype.hostRoom = hostRoom;
  CrazyCribbageApp.prototype.joinRoom = joinRoom;
  CrazyCribbageApp.prototype.startGameOnline = startGameOnline;
  CrazyCribbageApp.prototype.startGame = startGame;
  CrazyCribbageApp.prototype.resetMatch = resetMatch;
  CrazyCribbageApp.prototype.playAgain = playAgain;
  CrazyCribbageApp.prototype.beginCut = beginCut;
  CrazyCribbageApp.prototype.renderCutFan = renderCutFan;
  CrazyCribbageApp.prototype.resolveCuts = resolveCuts;
  CrazyCribbageApp.prototype.pickCut = pickCut;
  CrazyCribbageApp.prototype.stepNextCut = stepNextCut;
  CrazyCribbageApp.prototype.doCut = doCut;
  CrazyCribbageApp.prototype.newHand = newHand;
  CrazyCribbageApp.prototype.beginCutStarter = beginCutStarter;
  CrazyCribbageApp.prototype.poneDoCutStarter = poneDoCutStarter;
  CrazyCribbageApp.prototype.openGuessStarterPrompt = openGuessStarterPrompt;
  CrazyCribbageApp.prototype.startPlayAfterDiscards = startPlayAfterDiscards;
  CrazyCribbageApp.prototype.finishDeal = finishDeal;
  CrazyCribbageApp.prototype.startStarter = startStarter;
  CrazyCribbageApp.prototype.finishStarterRitual = finishStarterRitual;
  CrazyCribbageApp.prototype.confirmP2Discard = confirmP2Discard;
  CrazyCribbageApp.prototype.onPickCribCard = onPickCribCard;
  CrazyCribbageApp.prototype.startHumanPickCrib = startHumanPickCrib;
  CrazyCribbageApp.prototype.confirmPickCrib = confirmPickCrib;
  CrazyCribbageApp.prototype.finishPickYourCrib = finishPickYourCrib;
  CrazyCribbageApp.prototype.cpuPickFromPone = cpuPickFromPone;
  CrazyCribbageApp.prototype.cpuDoPickYourCrib = cpuDoPickYourCrib;
  CrazyCribbageApp.prototype.startCanadianDoublesFlow = startCanadianDoublesFlow;
  CrazyCribbageApp.prototype.startDiscardOrPickFlow = startDiscardOrPickFlow2;
  CrazyCribbageApp.prototype.confirmDiscard = confirmDiscard;
  CrazyCribbageApp.prototype.findNextPlayerWithPlay = findNextPlayerWithPlay;
  CrazyCribbageApp.prototype.settleGo = settleGo;
  CrazyCribbageApp.prototype.playCard = playCard;
  CrazyCribbageApp.prototype.cpuSeatPlay = cpuSeatPlay;
  CrazyCribbageApp.prototype.cpuTurn = cpuTurn;
  CrazyCribbageApp.prototype.miniCardHtml = miniCardHtml;
  CrazyCribbageApp.prototype.showPegPoints = showPegPoints;
  CrazyCribbageApp.prototype.showHandPoints = showHandPoints;
  CrazyCribbageApp.prototype.setShowMeter = setShowMeter;
  CrazyCribbageApp.prototype.famousFanfare = famousFanfare;
  CrazyCribbageApp.prototype.finishPlay = finishPlay;
  CrazyCribbageApp.prototype.cpuGuessCrib = cpuGuessCrib;
  CrazyCribbageApp.prototype.selectStolenChip = selectStolenChip;
  CrazyCribbageApp.prototype.openStolenCribPrompt = openStolenCribPrompt;
  CrazyCribbageApp.prototype.sendStolenCribGuess = sendStolenCribGuess;
  CrazyCribbageApp.prototype.resolveStolenCribGuess = resolveStolenCribGuess;
  CrazyCribbageApp.prototype.openTwistedCribbageModal = openTwistedCribbageModal;
  CrazyCribbageApp.prototype.resolveTwistedCribbageSplit = resolveTwistedCribbageSplit;
  CrazyCribbageApp.prototype.beginShowAct = beginShowAct;
  CrazyCribbageApp.prototype.finishShowAct = finishShowAct;
  CrazyCribbageApp.prototype.tickShowLine = tickShowLine;
  CrazyCribbageApp.prototype.saveHand = saveHand;
  CrazyCribbageApp.prototype.openShowModal = openShowModal;
  CrazyCribbageApp.prototype.showModal = showModal;
  CrazyCribbageApp.prototype.hideModal = hideModal2;
  CrazyCribbageApp.prototype.showOverlay = showOverlay;
  CrazyCribbageApp.prototype.hideOverlay = hideOverlay;
  CrazyCribbageApp.prototype.closeModal = closeModal;
  CrazyCribbageApp.prototype.closeOverlay = closeOverlay;
  CrazyCribbageApp.prototype.setupCloseButtonCompat = setupCloseButtonCompat;
  CrazyCribbageApp.prototype.showConfirmModal = showConfirmModal;
  CrazyCribbageApp.prototype.backToMenu = backToMenu;
  CrazyCribbageApp.prototype.returnToMenu = returnToMenu;
  CrazyCribbageApp.prototype.showDropdownInfoModal = showDropdownInfoModal;
  CrazyCribbageApp.prototype.selectOptionFromModal = selectOptionFromModal2;
  CrazyCribbageApp.prototype.initDropdownLabels = initDropdownLabels;
  CrazyCribbageApp.prototype.syncPlayerCountUi = syncPlayerCountUi;
  CrazyCribbageApp.prototype.updateCribbageClashOptionRanges = updateCribbageClashOptionRanges;
  CrazyCribbageApp.prototype.randomizeCrazyCribbageBonuses = randomizeCrazyCribbageBonuses;
  CrazyCribbageApp.prototype.randomizeCribbageClashOptions = randomizeCribbageClashOptions;
  CrazyCribbageApp.prototype.getJumpTriggerLength = getJumpTriggerLength2;
  CrazyCribbageApp.prototype.initClashPlacementButtons = initClashPlacementButtons;
  CrazyCribbageApp.prototype.syncClashPlacementButton = syncClashPlacementButton;
  CrazyCribbageApp.prototype.syncAllClashPlacementButtons = syncAllClashPlacementButtons;
  CrazyCribbageApp.prototype.getAllPlacedClashItems = getAllPlacedClashItems;
  CrazyCribbageApp.prototype.openClashPlacementModal = openClashPlacementModal;
  CrazyCribbageApp.prototype.closeClashPlacementModal = closeClashPlacementModal;
  CrazyCribbageApp.prototype.onConfirmClashPlacement = onConfirmClashPlacement;
  CrazyCribbageApp.prototype.renderClashPlacementBoard = renderClashPlacementBoard;
  CrazyCribbageApp.prototype.uncheckCribbageClashOptions = uncheckCribbageClashOptions;
  CrazyCribbageApp.prototype.uncheckPintsOptions = uncheckPintsOptions;
  CrazyCribbageApp.prototype.initTableSplitter = initTableSplitter;
  CrazyCribbageApp.prototype.initThemeButtons = initThemeButtons;
  CrazyCribbageApp.prototype.initSoundButton = initSoundButton;
  CrazyCribbageApp.prototype.checkInitialAgeGate = checkInitialAgeGate;
  CrazyCribbageApp.prototype.setupNetUi = setupNetUi;
  CrazyCribbageApp.prototype.handleZoneOptionChange = handleZoneOptionChange;
  CrazyCribbageApp.prototype.setupCheckAllBonuses = setupCheckAllBonuses;
  CrazyCribbageApp.prototype.toggleMenuSettings = toggleMenuSettings;
  CrazyCribbageApp.prototype.toggleMenuVariants = toggleMenuVariants;
  CrazyCribbageApp.prototype.hideMenuOtions = hideMenuOtions;
  CrazyCribbageApp.prototype.hideMenuOptions = hideMenuOtions;
  CrazyCribbageApp.prototype.hideMenuVariants = hideMenuVariants;
  CrazyCribbageApp.prototype.setupCloseButtonEvents = setupCloseButtonEvents;
  CrazyCribbageApp.prototype.analyzeKeepEV = analyzeKeepEV;
  CrazyCribbageApp.prototype.updateCoachDisplay = updateCoachDisplay;
  CrazyCribbageApp.prototype.showIntro = showIntro;
  CrazyCribbageApp.prototype.showRecordsModal = showRecordsModal;
  CrazyCribbageApp.prototype.resetGameStatistics = resetGameStatistics2;
  CrazyCribbageApp.prototype.showShareModal = showShareModal;
  CrazyCribbageApp.prototype.showStartGameModal = showStartGameModal;
  CrazyCribbageApp.prototype.hideStartGameModal = hideStartGameModal;
  CrazyCribbageApp.prototype.confirmAndStartGame = confirmAndStartGame;
  CrazyCribbageApp.prototype.showJoinModal = showJoinModal;
  CrazyCribbageApp.prototype.copyShareLink = copyShareLink2;
  CrazyCribbageApp.prototype.triggerNativeShare = triggerNativeShare2;
  CrazyCribbageApp.prototype.initAutoJoin = initAutoJoin;
  CrazyCribbageApp.prototype.updateMobileDeviceClass = updateMobileDeviceClass;
  CrazyCribbageApp.prototype.showDiscardTrainerModal = showDiscardTrainerModal2;
  CrazyCribbageApp.prototype.showPeggingTrainerModal = showPeggingTrainerModal;
  CrazyCribbageApp.prototype.showCountingTrainerModal = showCountingTrainerModal;
  CrazyCribbageApp.prototype.showCoachPostMortemModal = showCoachPostMortemModal;
  CrazyCribbageApp.prototype.shareCoachPostMortem = shareCoachPostMortem;
  CrazyCribbageApp.prototype.PeggingTrainer = CC2?.PeggingTrainer || PeggingTrainer;
  CrazyCribbageApp.prototype.CountingTrainer = CC2?.CountingTrainer || CountingTrainer;
  CrazyCribbageApp.prototype.CoachPostMortem = CC2?.CoachPostMortem || CoachPostMortem;
  CrazyCribbageApp.prototype.showDailyPuzzleModal = showDailyPuzzleModal;
  CrazyCribbageApp.prototype.DailyPuzzleManager = CC2?.DailyPuzzleManager || DailyPuzzleManager;
  CrazyCribbageApp.prototype.showTrophyRoomModal = showTrophyRoomModal;
  CrazyCribbageApp.prototype.showReplaysModal = showReplaysModal;
  CrazyCribbageApp.prototype.showGameSummaryModal = showGameSummaryModal;
  CrazyCribbageApp.prototype.showGameWonModal = showGameWonModal;
  CrazyCribbageApp.prototype.showHandOfGloryModal = showHandOfGloryModal;
  CrazyCribbageApp.prototype.closeHandOfGloryModal = closeHandOfGloryModal;
  CrazyCribbageApp.prototype.openClashSandbox = openClashSandbox;
  CrazyCribbageApp.prototype.applyClashPreset = applyClashPreset;
  CrazyCribbageApp.prototype.triggerReaction = (id) => ReactionManager.triggerReaction(id, { sfx: sfx2, net, netSend });
  CrazyCribbageApp.prototype.triggerBanter = (id) => ReactionManager.triggerBanter(id, { sfx: sfx2, net, netSend });
  CrazyCribbageApp.prototype.toggleReactionWheel = () => ReactionManager.toggleReactionWheel();
  CrazyCribbageApp.prototype.SeriesTracker = SeriesTracker;
  CrazyCribbageApp.prototype.ReactionManager = ReactionManager;
  CrazyCribbageApp.prototype.BANTER_ITEMS = BANTER_ITEMS;
  CrazyCribbageApp.prototype.HandScoreTracker = CC2?.HandScoreTracker || HandScoreTracker;
  CrazyCribbageApp.prototype.HandOfGloryCard = CC2?.HandOfGloryCard || HandOfGloryCard;
  CrazyCribbageApp.prototype.ClashPresets = CC2?.ClashPresets || ClashPresets;
  CrazyCribbageApp.prototype.PintsPresets = CC2?.PintsPresets || PintsPresets;
  CrazyCribbageApp.prototype.AdultPresets = CC2?.AdultPresets || AdultPresets;
  CrazyCribbageApp.prototype.ClashSandboxModal = CC2?.ClashSandboxModal || ClashSandboxModal;
  CrazyCribbageApp.prototype.showPlayerOfflineModal = (seatId, seatName3, onConfirm, onWait, onCancel) => ModalManager2.showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel);
  CrazyCribbageApp.prototype.showPickAiReplacementModal = (seatId, seatName3, onSelectAi) => ModalManager2.showPickAiReplacementModal(seatId, seatName3, onSelectAi);
  CrazyCribbageApp.prototype.cancelGame = cancelGameAndReturnToMenu;
  CrazyCribbageApp.prototype.cancelGameAndReturnToMenu = cancelGameAndReturnToMenu;
  CrazyCribbageApp.prototype.IndexedDBStorage = IndexedDBStorage;
  CrazyCribbageApp.prototype.appStorage = appStorage;
  CrazyCribbageApp.prototype.toggleBoardViewMode = function() {
    const currentMode = this.settings && this.settings.boardViewMode || "room3d-fullscreen";
    let newMode = "3d";
    if (currentMode === "room3d-fullscreen") newMode = "room3d";
    else if (currentMode === "room3d") newMode = "3d";
    else if (currentMode === "3d") newMode = "2d";
    else if (currentMode === "2d") newMode = "none";
    else if (currentMode === "none") newMode = "room3d";
    this.selectBoardViewMode(newMode);
  };
  CrazyCribbageApp.prototype.selectBoardViewMode = function(mode) {
    if (!mode) return;
    this.settings.boardViewMode = mode;
    if (typeof settings2 !== "undefined" && settings2) {
      settings2.boardViewMode = mode;
    }
    if (typeof window !== "undefined" && window.settings) {
      window.settings.boardViewMode = mode;
    }
    const elBv = document.getElementById("optBoardView");
    if (elBv) elBv.value = mode;
    const elBvm = document.getElementById("optBoardViewModal");
    if (elBvm) elBvm.value = mode;
    const elInGame = document.getElementById("inGameOptBoardView");
    if (elInGame) elInGame.value = mode;
    if (typeof saveSettingsStore === "function") saveSettingsStore(this.settings);
    if (typeof buildBoard === "function") buildBoard();
    if (typeof renderScores === "function") renderScores(false);
    this.updateBoardViewToggleBtn();
    this.closeInGameBoardViewDropdown();
    const r3d = typeof window !== "undefined" ? window._currentRenderer3D || window.boardRenderer3D : null;
    if (mode === "room3d-fullscreen") {
      if (r3d && typeof r3d.enterFullScreen === "function") {
        r3d.enterFullScreen();
      }
    } else if (r3d && typeof r3d.isFullScreen === "function" && r3d.isFullScreen()) {
      r3d.exitFullScreen();
    }
  };
  CrazyCribbageApp.prototype.toggleInGameBoardViewDropdown = function() {
    const menu = document.getElementById("inGameBoardViewDropdownMenu");
    if (!menu) return;
    if (menu.classList.contains("hidden")) {
      this.openInGameBoardViewDropdown();
    } else {
      this.closeInGameBoardViewDropdown();
    }
  };
  CrazyCribbageApp.prototype.openInGameBoardViewDropdown = function() {
    const menu = document.getElementById("inGameBoardViewDropdownMenu");
    const trigger = document.getElementById("btnToggleBoardView");
    if (!menu) return;
    if (typeof this.closeInGameBoardDropdown === "function") {
      this.closeInGameBoardDropdown();
    }
    menu.classList.remove("hidden");
    if (trigger) {
      trigger.classList.add("is-active");
      trigger.setAttribute("aria-expanded", "true");
    }
    this.updateBoardViewToggleBtn();
  };
  CrazyCribbageApp.prototype.closeInGameBoardViewDropdown = function() {
    const menu = document.getElementById("inGameBoardViewDropdownMenu");
    const trigger = document.getElementById("btnToggleBoardView");
    if (!menu) return;
    menu.classList.add("hidden");
    if (trigger) {
      trigger.classList.remove("is-active");
      trigger.setAttribute("aria-expanded", "false");
    }
  };
  CrazyCribbageApp.prototype.zoomIn3DBoard = function(step) {
    if (typeof window !== "undefined" && window._currentRenderer3D?.zoomIn) {
      return window._currentRenderer3D.zoomIn(step);
    }
  };
  CrazyCribbageApp.prototype.zoomOut3DBoard = function(step) {
    if (typeof window !== "undefined" && window._currentRenderer3D?.zoomOut) {
      return window._currentRenderer3D.zoomOut(step);
    }
  };
  CrazyCribbageApp.prototype.togglePanMode3DBoard = function(enable) {
    if (typeof window !== "undefined" && window._currentRenderer3D?.setPanMode) {
      return window._currentRenderer3D.setPanMode(enable);
    }
  };
  CrazyCribbageApp.prototype.pan3DBoard = function(deltaX, deltaY) {
    if (typeof window !== "undefined" && window._currentRenderer3D?.pan) {
      return window._currentRenderer3D.pan(deltaX, deltaY);
    }
  };
  CrazyCribbageApp.prototype.getBoardAngles = function() {
    if (typeof window !== "undefined" && window._currentRenderer3D?.getCameraAngles) {
      return window._currentRenderer3D.getCameraAngles();
    }
    if (CC2?.BoardRenderer3D?.getCameraAngles) {
      return CC2.BoardRenderer3D.getCameraAngles();
    }
    console.warn("[CrazyCribbage] No active 3D board found. Ensure 3D board view is selected.");
    return null;
  };
  CrazyCribbageApp.prototype.getCameraAngles = function() {
    return this.getBoardAngles();
  };
  CrazyCribbageApp.prototype.minimizeBoard = function() {
    return CC2?.BoardRenderer?.minimizeBoard ? CC2.BoardRenderer.minimizeBoard() : BoardRenderer.minimizeBoard();
  };
  CrazyCribbageApp.prototype.maximizeBoard = function() {
    return CC2?.BoardRenderer?.maximizeBoard ? CC2.BoardRenderer.maximizeBoard() : BoardRenderer.maximizeBoard();
  };
  CrazyCribbageApp.prototype.restoreBoard = function() {
    return CC2?.BoardRenderer?.restoreBoard ? CC2.BoardRenderer.restoreBoard() : BoardRenderer.restoreBoard();
  };
  CrazyCribbageApp.prototype.toggleBoardMinimize = function() {
    return CC2?.BoardRenderer?.toggleBoardMinimize ? CC2.BoardRenderer.toggleBoardMinimize() : BoardRenderer.toggleBoardMinimize();
  };
  CrazyCribbageApp.prototype.toggleBoardMaximize = function() {
    return CC2?.BoardRenderer?.toggleBoardMaximize ? CC2.BoardRenderer.toggleBoardMaximize() : BoardRenderer.toggleBoardMaximize();
  };
  CrazyCribbageApp.prototype.getBoardDisplayState = function() {
    return (CC2?.BoardRenderer?.getBoardDisplayState ? CC2.BoardRenderer.getBoardDisplayState() : BoardRenderer.getBoardDisplayState()) || "normal";
  };
  CrazyCribbageApp.prototype.setBoardDisplayState = function(state3) {
    return CC2?.BoardRenderer?.setBoardDisplayState ? CC2.BoardRenderer.setBoardDisplayState(state3) : BoardRenderer.setBoardDisplayState(state3);
  };
  CrazyCribbageApp.prototype.updateBoardSizeButtons = function() {
    return CC2?.BoardRenderer?.updateBoardSizeButtons ? CC2.BoardRenderer.updateBoardSizeButtons() : BoardRenderer.updateBoardSizeButtons();
  };
  CrazyCribbageApp.prototype.toggle3DRoomFullScreen = function() {
    const r3d = typeof window !== "undefined" ? window._currentRenderer3D || window.boardRenderer3D : null;
    if (r3d && typeof r3d.toggleFullScreen === "function") {
      return r3d.toggleFullScreen();
    } else if (typeof CC2 !== "undefined" && CC2.BoardRenderer?.toggle3DRoomFullScreen) {
      return CC2.BoardRenderer.toggle3DRoomFullScreen();
    } else if (typeof BoardRenderer !== "undefined" && BoardRenderer.toggle3DRoomFullScreen) {
      return BoardRenderer.toggle3DRoomFullScreen();
    }
  };
  CrazyCribbageApp.prototype.is3DRoomFullScreen = function() {
    const r3d = typeof window !== "undefined" ? window._currentRenderer3D || window.boardRenderer3D : null;
    if (r3d && typeof r3d.isFullScreen === "function") {
      return r3d.isFullScreen();
    } else if (typeof CC2 !== "undefined" && CC2.BoardRenderer?.is3DRoomFullScreen) {
      return CC2.BoardRenderer.is3DRoomFullScreen();
    } else if (typeof BoardRenderer !== "undefined" && BoardRenderer.is3DRoomFullScreen) {
      return BoardRenderer.is3DRoomFullScreen();
    }
    return false;
  };
  if (typeof window !== "undefined") {
    window.zoomIn3DBoard = (step) => window.crazyCribbageApp ? window.crazyCribbageApp.zoomIn3DBoard(step) : null;
    window.zoomOut3DBoard = (step) => window.crazyCribbageApp ? window.crazyCribbageApp.zoomOut3DBoard(step) : null;
    window.togglePanMode3DBoard = (enable) => window.crazyCribbageApp ? window.crazyCribbageApp.togglePanMode3DBoard(enable) : null;
    window.pan3DBoard = (dx2, dy2) => window.crazyCribbageApp ? window.crazyCribbageApp.pan3DBoard(dx2, dy2) : null;
    window.toggleBoardViewMode = () => window.crazyCribbageApp ? window.crazyCribbageApp.toggleBoardViewMode() : null;
    window.selectBoardViewMode = (mode) => window.crazyCribbageApp ? window.crazyCribbageApp.selectBoardViewMode(mode) : null;
    window.toggleInGameBoardViewDropdown = () => window.crazyCribbageApp ? window.crazyCribbageApp.toggleInGameBoardViewDropdown() : null;
    window.closeInGameBoardViewDropdown = () => window.crazyCribbageApp ? window.crazyCribbageApp.closeInGameBoardViewDropdown() : null;
    window.select3DBoard = (boardId) => window.crazyCribbageApp ? window.crazyCribbageApp.select3DBoard(boardId) : null;
    window.syncInGameBoardSelector = () => window.crazyCribbageApp ? window.crazyCribbageApp.syncInGameBoardSelector() : null;
    window.toggleInGameBoardDropdown = () => window.crazyCribbageApp ? window.crazyCribbageApp.toggleInGameBoardDropdown() : null;
    window.closeInGameBoardDropdown = () => window.crazyCribbageApp ? window.crazyCribbageApp.closeInGameBoardDropdown() : null;
    window.minimizeBoard = () => window.crazyCribbageApp ? window.crazyCribbageApp.minimizeBoard() : CC2?.BoardRenderer?.minimizeBoard ? CC2.BoardRenderer.minimizeBoard() : BoardRenderer.minimizeBoard();
    window.maximizeBoard = () => window.crazyCribbageApp ? window.crazyCribbageApp.maximizeBoard() : CC2?.BoardRenderer?.maximizeBoard ? CC2.BoardRenderer.maximizeBoard() : BoardRenderer.maximizeBoard();
    window.restoreBoard = () => window.crazyCribbageApp ? window.crazyCribbageApp.restoreBoard() : CC2?.BoardRenderer?.restoreBoard ? CC2.BoardRenderer.restoreBoard() : BoardRenderer.restoreBoard();
    window.toggleBoardMinimize = () => window.crazyCribbageApp ? window.crazyCribbageApp.toggleBoardMinimize() : CC2?.BoardRenderer?.toggleBoardMinimize ? CC2.BoardRenderer.toggleBoardMinimize() : BoardRenderer.toggleBoardMinimize();
    window.toggleBoardMaximize = () => window.crazyCribbageApp ? window.crazyCribbageApp.toggleBoardMaximize() : CC2?.BoardRenderer?.toggleBoardMaximize ? CC2.BoardRenderer.toggleBoardMaximize() : BoardRenderer.toggleBoardMaximize();
    window.toggle3DRoomFullScreen = () => window.crazyCribbageApp ? window.crazyCribbageApp.toggle3DRoomFullScreen() : CC2?.BoardRenderer?.toggle3DRoomFullScreen ? CC2.BoardRenderer.toggle3DRoomFullScreen() : BoardRenderer?.toggle3DRoomFullScreen ? BoardRenderer.toggle3DRoomFullScreen() : window._currentRenderer3D?.toggleFullScreen ? window._currentRenderer3D.toggleFullScreen() : null;
    window.is3DRoomFullScreen = () => window.crazyCribbageApp ? window.crazyCribbageApp.is3DRoomFullScreen() : CC2?.BoardRenderer?.is3DRoomFullScreen ? CC2.BoardRenderer.is3DRoomFullScreen() : BoardRenderer?.is3DRoomFullScreen ? BoardRenderer.is3DRoomFullScreen() : window._currentRenderer3D?.isFullScreen ? window._currentRenderer3D.isFullScreen() : false;
    window.showBoard3DModal = (options = {}) => window.crazyCribbageApp ? window.crazyCribbageApp.showBoard3DModal(options) : BoardSelectorModal2.show(options);
    window.toggleMenuSettings = toggleMenuSettings;
    window.toggleMenuVariants = toggleMenuVariants;
    window.hideMenuOptions = hideMenuOtions;
    window.hideMenuOtions = hideMenuOtions;
    window.hideMenuVariants = hideMenuVariants;
    window.cancelGame = cancelGameAndReturnToMenu;
    window.cancelGameAndReturnToMenu = cancelGameAndReturnToMenu;
    window.returnToMenu = returnToMenu;
    window.backToMenu = backToMenu;
    window.showConfirmModal = showConfirmModal;
    window.showStartGameModal = showStartGameModal;
    window.hideStartGameModal = hideStartGameModal;
    window.confirmAndStartGame = confirmAndStartGame;
    window.showTrophyRoomModal = showTrophyRoomModal;
    window.showTrophyRoom = showTrophyRoomModal;
    window.showGameSummaryModal = showGameSummaryModal;
    window.showGameWonModal = showGameWonModal;
    window.showHandOfGloryModal = showHandOfGloryModal;
    window.closeHandOfGloryModal = closeHandOfGloryModal;
    window.showPlayerOfflineModal = (seatId, seatName3, onConfirm, onWait, onCancel) => ModalManager2.showPlayerOfflineModal(seatId, seatName3, onConfirm, onWait, onCancel);
    window.showPickAiReplacementModal = (seatId, seatName3, onSelectAi) => ModalManager2.showPickAiReplacementModal(seatId, seatName3, onSelectAi);
    window.openClashSandbox = openClashSandbox;
    window.openPintsSandbox = (opts) => ClashSandboxModal.open({ brand: "pints", ...opts });
    window.openAdultSandbox = (opts) => ClashSandboxModal.open({ brand: "adult", ...opts });
    window.applyClashPreset = applyClashPreset;
    window.applyPintsPreset = (key, ctx) => (window.PintsPresets || PintsPresets).applyPreset(key, ctx);
    window.applyAdultPreset = (key, ctx) => (window.AdultPresets || AdultPresets).applyPreset(key, ctx);
    window.triggerReaction = (id) => ReactionManager.triggerReaction(id, { sfx: sfx2, net, netSend });
    window.triggerBanter = (id) => ReactionManager.triggerBanter(id, { sfx: sfx2, net, netSend });
    window.toggleReactionWheel = () => ReactionManager.toggleReactionWheel();
    window.ReactionManager = ReactionManager;
    window.BANTER_ITEMS = BANTER_ITEMS;
    window.SeriesTracker = SeriesTracker;
    window.TournamentManager = TournamentManager;
    window.TournamentModal = TournamentModal;
    window.showTournamentModal = (context) => TournamentModal.open(context);
    window.HandScoreTracker = CC2?.HandScoreTracker || HandScoreTracker || window.HandScoreTracker;
    window.HandOfGloryCard = CC2?.HandOfGloryCard || HandOfGloryCard || window.HandOfGloryCard;
    window.ClashPresets = CC2?.ClashPresets || ClashPresets || window.ClashPresets;
    window.PintsPresets = CC2?.PintsPresets || PintsPresets || window.PintsPresets;
    window.AdultPresets = CC2?.AdultPresets || AdultPresets || window.AdultPresets;
    window.ClashSandboxModal = CC2?.ClashSandboxModal || ClashSandboxModal || window.ClashSandboxModal;
    window.IndexedDBStorage = IndexedDBStorage;
    window.appStorage = appStorage;
    window.isSeatCpu = isSeatCpu;
    window.isSeatHuman = isSeatHuman;
    window.isSeatOnline = isSeatOnline2;
    window.isMultiHuman = isMultiHuman2;
    window.replacePlayerWithAi = replacePlayerWithAi;
    window.handlePlayerOfflinePrompt = handlePlayerOfflinePrompt;
    window.handleHostDisconnect = handleHostDisconnect;
    window.checkGameOver = checkGameOver;
    window.checkChutesAndLadders = checkChutesAndLadders;
    window.GameReplayManager = CC2?.GameReplayManager || GameReplayManager || window.GameReplayManager;
    window.ReplayModal = CC2?.ReplayModal || ReplayModal || window.ReplayModal;
    window.showReplaysModal = (brand = null) => {
      const b = brand || (typeof getAppBrand === "function" ? getAppBrand() : "all");
      return (window.ReplayModal || CC2?.ReplayModal || ReplayModal)?.openLibrary?.(b);
    };
    window.showReplayPlayer = (replay) => (window.ReplayModal || CC2?.ReplayModal || ReplayModal)?.open?.(replay);
    window.playCurrentGameReplay = () => (window.GameReplayManager || CC2?.GameReplayManager || GameReplayManager)?.playCurrentGameReplay?.();
    window.shareCurrentGameReplay = () => (window.GameReplayManager || CC2?.GameReplayManager || GameReplayManager)?.shareCurrentGameReplay?.();
    window.shareCurrentReplay = window.shareCurrentGameReplay;
    window.load3DBoardsJson = (source, opts) => Board3DCatalog.loadDefaultBoards(source, opts);
    window.reload3DBoardsJson = (opts) => Board3DCatalog.loadDefaultBoards(null, opts);
  }
  CrazyCribbageApp.prototype.load3DBoardsJson = function(source, opts) {
    return Board3DCatalog.loadDefaultBoards(source, opts);
  };
  CrazyCribbageApp.prototype.reload3DBoardsJson = function(opts) {
    return Board3DCatalog.loadDefaultBoards(null, opts);
  };
  return __toCommonJS(index_exports);
})();
/*! Bundled license information:

dompurify/dist/purify.es.mjs:
  (*! @license DOMPurify 3.4.17 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.17/LICENSE *)
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE *)
*/
